// AUTO-GENERATED via the Emergent LLM key. Fills missing i18n keys for
// selector languages. Hand-written dictionaries still take priority.
export const GENERATED = {
"es": {
"a.category": "Categoría",
"a.categoryPlaceholder": "Elige una categoría",
"a.city": "Ciudad",
"a.legalHint": "Requerido para la facturación electrónica francesa (Factur-X) de los establecimientos franceses.",
"a.legalRequiredFR": "El SIRET y el número de IVA intracomunitario son obligatorios para Francia.",
"a.rememberMe": "Recuérdame",
"a.siret": "SIRET",
"a.vat": "N.º de IVA intracomunitario",
"ac.africa": "África",
"ac.boostActive": "Destacar activo —",
"ac.boostSub": "Aparecer en la parte superior del directorio de socios con una insignia de “Destacado”.",
"ac.boostTitle": "Mejora tu listado en el directorio",
"ac.categoryHint": "Para clasificar tu establecimiento en el directorio de findloop.",
"ac.choose": "Elige",
"ac.cityHint": "Para una ubicación precisa en el mapa público.",
"ac.cityLabel": "Ciudad del establecimiento",
"ac.cityPh": "París",
"ac.contact": "Datos de contacto",
"ac.converted": "Convertido",
"ac.copyDeclLink": "Copiar el enlace de la declaración",
"ac.copyLink": "Copiar el enlace",
"ac.currentPlan": "Plan actual",
"ac.emailDesc": "Elige los correos que deseas recibir. Las notificaciones en tu espacio de trabajo siempre permanecen activas.",
"ac.emailMatch": "Coincidencias",
"ac.emailMatchDesc": "Un correo cuando un artículo coincide con una declaración",
"ac.emailNewDecl": "Nuevas declaraciones de pérdida",
"ac.emailNewDeclDesc": "Un correo tan pronto como un cliente informe de una pérdida en tu lugar",
"ac.emailShip": "Solicitudes de envío",
"ac.emailShipDesc": "Un correo cuando un cliente solicita el envío de un artículo",
"ac.emailTitle": "Preferencias de correo electrónico",
"ac.expireSoon": "Tu destacado expirará pronto —",
"ac.exportCsv": "Exportar (CSV)",
"ac.exportHint": "Exporta tus pagos externos validados para tu contabilidad.",
"ac.free": "Gratis",
"ac.freeMonths": "Meses gratis",
"ac.hours": "horas",
"ac.howItWorks": "¿Cómo funciona?",
"ac.invited": "Invitado",
"ac.legalFR": "Requerido para la facturación electrónica (Factur-X) aplicable desde septiembre de 2026.",
"ac.legalMissing": "⚠️ SIRET y IVA intracomunitario faltantes — complétalos para cumplir con la facturación electrónica.",
"ac.legalOther": "Recomendado para tus facturas.",
"ac.legalPartnerQr": "Código QR",
"ac.legalTitle": "Identificadores legales (facturación)",
"ac.logoTitle": "Logo del establecimiento",
"ac.modeCurrent": "Modo actual:",
"ac.modeExternal": "Externo (validación manual)",
"ac.modeInternal": "Interno Findloop (auto)",
"ac.noSubReceipt": "Aún no hay pago de suscripción pagada.",
"ac.none": "Ninguno",
"ac.onYourListing": "en tu listado",
"ac.pay1": "Introduce tus enlaces de pago a continuación para redirigir a tus clientes a tu propio sistema de cobro.",
"ac.pay2": "La validación se vuelve manual: confirmas la recepción del pago desde la pestaña “Declaraciones”.",
"ac.pay3": "El enlace de “Costo de envío” es un pago consolidado (recuperación + envío).",
"ac.pay4": "Deja los campos vacíos para usar el pago interno de Findloop (Stripe) con validación automática.",
"ac.paySub": "Cobra tarifas a través de tu propio sistema de pago.",
"ac.payTitle": "Pagos externos",
"ac.permissive": "Permisivo",
"ac.phone": "Teléfono",
"ac.posterA4": "Póster A4 (PDF)",
"ac.qMessage": "Mensaje (opcional)",
"ac.qName": "Nombre",
"ac.qOrg": "Organización",
"ac.qSites": "Número de establecimientos (estimado)",
"ac.qrHint": "Sus clientes escanean este código para reportar un artículo perdido.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Su código QR de socio",
"ac.quoteDesc": "Aeropuertos, redes de trenes, cadenas internacionales · ",
"ac.quoteEurope": "Europa / Mundo",
"ac.quoteSent": "Solicitud de cotización enviada. Nuestro equipo se pondrá en contacto contigo pronto.",
"ac.quoteTitle": "Solicitar una cotización — Empresa",
"ac.recoveryLink": "enlace de “tarifa de recuperación”",
"ac.refSub": "Cada socio referido que se suscribe te da 1 mes gratis.",
"ac.refTitle": "Refiere, gana un mes gratis",
"ac.reminderDelay": "Retraso de recordatorio de validación",
"ac.reminderHint": "Recibirás un recordatorio por correo electrónico si un pago externo permanece sin validar más allá de este retraso (predeterminado: 48h).",
"ac.renewDesc1": "Ya te ha generado",
"ac.renewDesc2": "Renueva para mantenerte en la parte superior del directorio y no perder esta visibilidad.",
"ac.renewNow": "Renovar ahora",
"ac.requestQuote": "Solicitar una cotización",
"ac.saveLegal": "Guardar los identificadores",
"ac.saveLinks": "Guardar los enlaces",
"ac.sendRequest": "Enviar mi solicitud",
"ac.sending": "Enviando…",
"ac.shippingLink": "enlace de “tarifa de envío” (consolidado)",
"ac.shippingLinkHint": "Este enlace cubre tanto la recuperación como el envío.",
"ac.strict": "Estricto",
"ac.subReceipt": "Recibo de suscripción (PDF)",
"ac.subReceiptsSub": "Descarga el recibo PDF de cada pago de suscripción.",
"ac.subReceiptsTitle": "Recibos de suscripción",
"ac.tCategory": "Categoría guardada",
"ac.tCity": "Ciudad guardada — mapa actualizado",
"ac.tCityNeeded": "Ingresa una ciudad",
"ac.tCopied": "¡Copiado!",
"ac.tCover": "Foto de portada actualizada",
"ac.tEmailPrefs": "Preferencias de correo electrónico actualizadas",
"ac.tErr": "Error",
"ac.tExportImpossible": "Exportación fallida",
"ac.tLegal": "Identificadores legales guardados",
"ac.tLegalNeeded": "SIRET y IVA requeridos para Francia",
"ac.tLogo": "Logo actualizado",
"ac.tLogoRemoved": "Logo eliminado",
"ac.tPayLinks": "Enlaces de pago guardados",
"ac.tPhone": "Teléfono guardado",
"ac.tSensitivity": "Sensibilidad guardada",
"ac.tVatInvalid": "Número de IVA inválido",
"ac.tVatValid": "IVA válido",
"ac.tabBoost": "Visibilidad",
"ac.tabPayments": "Pagos",
"ac.tabProfile": "Perfil",
"ac.tabQr": "QR & Póster",
"ac.tabReferral": "Referencia",
"ac.tabSub": "Suscripción",
"ac.thisWeek": "Esta semana",
"ac.thisWeekOf": " ({n} esta semana)",
"ac.thresholdDesc": "Umbral de confianza a partir del cual la IA valida automáticamente una coincidencia de foto y notifica al cliente. Más alto = menos coincidencias automáticas pero más confiables.",
"ac.thresholdTitle": "Sensibilidad de coincidencia visual de IA",
"ac.trend": "Tendencia",
"ac.upload": "Subir",
"ac.vatValidFmt": "IVA válido{name} ({via})",
"ac.vatVerified": "IVA intracomunitario verificado",
"ac.verifyVat": "Verificar IVA (VIES)",
"ac.verifying": "Verificando…",
"ac.views": "vistas",
"ac.viewsTotal": "Vistas ganadas (total)",
"ac.winbackBtn": "Reanudar con -20%",
"ac.winbackDesc1": "Te ganó",
"ac.winbackDesc2": "Oferta especial: -20% aplicados automáticamente si renuevas dentro de 24h.",
"ac.winbackTitle": "Tu destacado acaba de expirar — ¡reanuda con -20%!",
"an.allCountries": "Todos los países",
"an.country": "País",
"an.geoBanner": "Estás viendo anuncios en",
"an.geoBannerWorld": "Estás viendo anuncios a nivel mundial",
"an.geoChange": "cambiar país",
"an.loginRequired": "Inicia sesión para reportar este artículo y seguir la devolución.",
"an.requestInProgress": "Solicitud en progreso",
"an.resolved": "Artículo ya recuperado",
"an.sortRecent": "Más recientes",
"an.sortRelevance": "Relevancia",
"bo.africaPrice": "Se aplicó precio preferencial de zona África",
"c.all": "Todo",
"c.close": "Cerrar",
"c.confirm": "Confirmar",
"c.confirmed": "Confirmado",
"c.download": "Descargar",
"c.reset": "Restablecer",
"c.transfer": "Transferir",
"cat.Animal": "Mascota / Accesorio para mascota",
"cat.AppareilPhoto": "Cámara",
"cat.Argent": "Dinero / Efectivo",
"cat.Autres": "Otros",
"cat.Bijoux": "Joyería",
"cat.CarteBancaire": "Tarjeta bancaria",
"cat.CarteIdentite": "Documento de identidad / Pasaporte",
"cat.Casquette": "Gorra / Sombrero",
"cat.Ceinture": "Cinturón",
"cat.Chargeur": "Cargador / Cable",
"cat.Chaussures": "Zapatos",
"cat.CleVoiture": "Llave de coche",
"cat.Cles": "Llaves",
"cat.Console": "Consola de juegos",
"cat.Documents": "Documentos / Papeles",
"cat.Echarpe": "Bufanda",
"cat.Ecouteurs": "Auriculares",
"cat.Electronique": "Electrónica (otros)",
"cat.Enceinte": "Altavoz",
"cat.Gants": "Guantes",
"cat.Gourde": "Botella de agua / Termo",
"cat.Instrument": "Instrumento musical",
"cat.Jouet": "Juguete / Peluche",
"cat.Jumelles": "Prismáticos",
"cat.Lampe": "Lámpara / Linterna",
"cat.Liseuse": " lector de libros electrónicos",
"cat.Livre": "Libro / Cuaderno",
"cat.Lunettes": "Gafas",
"cat.Manteau": "Abrigo / Chaqueta",
"cat.Maquillage": "Neceser de maquillaje",
"cat.Medical": "Equipo médico",
"cat.Medicaments": "Medicamentos",
"cat.Montre": "Reloj / Reloj inteligente",
"cat.Ordinateur": "Portátil",
"cat.Parapluie": "Paraguas",
"cat.Portefeuille": "Cartera / Monedero",
"cat.Poussette": "Cochecito / Accesorio de bebé",
"cat.Sac": "Bolsa / Tasche",
"cat.SacADos": "Mochila",
"cat.Souris": "Ratón / Teclado",
"cat.Sport": "Equipo deportivo",
"cat.Tablette": "Tableta",
"cat.Telephone": "Teléfono / Smartphone",
"cat.Trottinette": "Patinete",
"cat.Trousse": "Estuche / Funda",
"cat.USB": "Memoria USB / Disco duro",
"cat.Valise": "Maleta / Equipaje",
"cat.Velo": "Bicicleta",
"cat.Vetements": "Ropa",
"cm.found": "ENCONTRADO",
"cm.lost": "PERDIDO",
"consent.required": "Debes aceptar compartir tus datos de contacto para continuar.",
"consent.share": "Acepto que el encontrador de mi artículo pueda ver mis datos de contacto (nombre, correo electrónico, teléfono) para contactarme para su devolución.",
"dc.partnerDesc": "¿Perdiste tu artículo en un lugar asociado (hotel, estación, sala…)? Selecciónalo para una devolución directa.",
"dc.partnerList": "Elige de la lista",
"dc.partnerMap": "Elige en el mapa",
"dc.partnerTitle": "Declaración en un socio",
"dc.publicCta": "Publicar un anuncio público",
"dc.publicDesc": "Tu anuncio será visible para toda la comunidad de findloop. Ideal si no sabes dónde perdiste el artículo.",
"dc.publicTitle": "Declaración pública",
"dc.subtitle": "Elige cómo reportar tu artículo perdido.",
"dc.title": "¿Qué te gustaría hacer?",
"dec.addrPending": "Dirección pendiente del cliente",
"dec.analyzing": "Analizando…",
"dec.clientDescription": "Descripción del cliente",
"dec.clientPhoto": "Foto proporcionada por el cliente",
"dec.clientPhotoShort": "Foto del cliente",
"dec.comparePhotos": "Comparar fotos",
"dec.declaredItemPhoto": "Foto del artículo declarado",
"dec.emptyDesc": "Comparte tu código QR para recibir declaraciones.",
"dec.emptyTitle": "Sin declaraciones",
"dec.enlarge": "Ampliar",
"dec.extBanner": "{n} pago(s) externo(s) por validar — confirma la recepción a continuación para desbloquear la entrega o el envío.",
"dec.foundItemAlt": "Artículo encontrado",
"dec.foundItemRegistry": "Artículo encontrado (registro)",
"dec.labelClient": "Cliente",
"dec.labelRegistry": "Registro",
"dec.noMatchYet": "Sin coincidencia aún.",
"dec.noPhoto": "Sin foto",
"dec.pRecup": "recuperación",
"dec.pRecupP": "(recuperación)",
"dec.pRecupShip": "(recuperación + envío)",
"dec.payConfirmed": "Pago {x} confirmado",
"dec.payPending": "Pago externo {x} pendiente",
"dec.pickup": "Recogida en persona",
"dec.reject": "Rechazar",
"dec.rerun": "Repetir el análisis",
"dec.similarity": "Similitud {n}%",
"dec.suggestedMatches": "Coincidencias sugeridas",
"dec.toColon": " a:",
"dec.toShip": "Para enviar",
"dec.toastExtPay": "Pago confirmado — se notificará al cliente.",
"dec.toastMatch": "Coincidencia confirmada",
"dec.toastReject": "Sugerencia rechazada",
"dec.toastRerun": "Análisis reiniciado",
"dec.toastVisualN": "{n} coincidencia(s) visual(es)",
"dec.toastVisualNone": "Sin coincidencia visual",
"dec.viewBeforeAfter": "Vista previa / después (superposición)",
"dec.viewSideBySide": "Vista lado a lado",
"dec.visualCompare": "Comparación visual AI",
"dec.visualIdle": "Ejecuta la comparación para que la IA coincida visualmente la foto del cliente con los artículos encontrados.",
"dec.visualRunning": "La IA está comparando la foto del cliente con los artículos de tu registro…",
"dec.zoomPhoto": "Ampliar la foto",
"dep.addAnyway": "Agregar de todos modos",
"dep.addError": "Error al agregar",
"dep.addItem": "Agregar artículo",
"dep.added": "¡Artículo agregado al registro!",
"dep.adding": "Agregando…",
"dep.aiError": "Análisis de IA no disponible en este momento.",
"dep.aiFilled": "Formulario pre-rellenado por IA ✨",
"dep.aiUnavailable": "IA no disponible — completa el formulario manualmente.",
"dep.analyzing": "Analizando…",
"dep.analyzingPhoto": "Analizando foto…",
"dep.brand": "Marca",
"dep.brandPlaceholder": "p. ej. Apple",
"dep.category": "Categoría",
"dep.checkingDup": "Verificando duplicados…",
"dep.color": "Color",
"dep.colorPlaceholder": "p. ej. negro",
"dep.condition": "Condición",
"dep.conditionPlaceholder": "p. ej. buena condición",
"dep.depositorNote": "Nota del depositante",
"dep.depositorNoteHint": "Detalles operativos escritos a mano. La IA nunca sobrescribe esta nota.",
"dep.depositorNotePlaceholder": "p. ej. contenido de una bolsa, marca según lo reportado, detalles dados por la persona…",
"dep.descPlaceholder": "p. ej. iPhone 15 negro con una funda transparente, encontrado en el bar…",
"dep.description": "Descripción",
"dep.dupHint": "Asegúrate de que no estás agregando un duplicado. Puedes continuar si el artículo es genuinamente diferente.",
"dep.dupTitle": "Artículo(s) similar(es) ya registrado(s)",
"dep.dupWarn": "Se detectó un artículo similar — revisa, luego haz clic nuevamente para confirmar.",
"dep.estHint": "El artículo se añadirá al registro de este establecimiento.",
"dep.establishment": "Establecimiento",
"dep.fee": "Tarifa de recuperación (€) — opcional",
"dep.feePlaceholder": "Deja vacío para el precio predeterminado de la categoría",
"dep.fillAI": "Rellenar con IA",
"dep.optional": "(opcional)",
"dep.photo": "Foto del artículo",
"dep.principal": "principal",
"dep.reqError": "Categoría y descripción son requeridas.",
"dep.savedItem": "Artículo registrado",
"dep.similarity": "Similitud",
"dep.storage": "Ubicación física",
"dep.storageHint": "Dónde se almacena físicamente el artículo. Se generará un código QR para encontrarlo.",
"dep.storagePlaceholder": "p. ej. Estante A3, Casillero 12, Caja de recepción",
"dl.aClient": "un cliente",
"dl.alertsBlocked": "Alertas del navegador bloqueadas",
"dl.alertsBlockedHint": "Para volver a habilitarlas: haz clic en el icono 🔒 (o ⓘ) a la izquierda de la dirección del sitio, luego permite notificaciones y recarga la página.",
"dl.amountDue": "Monto adeudado: {amount} {currency}.",
"dl.enableAlerts": "Habilitar alertas",
"dl.extPending": "Pagos a validar",
"dl.freemiumNear": "Te estás acercando al límite Freemium ({used}/{max} artículos este mes). Actualiza a Starter para obtener artículos ilimitados.",
"dl.freemiumReached": "Límite Freemium alcanzado ({used}/{max} artículos este mes). Actualiza a Starter para registrar artículos ilimitados.",
"dl.invoiceOverdue": "Factura {num} impaga — acceso restringido.",
"dl.matchNotifTitle": "Findloop — Nueva coincidencia de IA 🔔",
"dl.matchToast": "Nueva coincidencia de IA — {name}",
"dl.matchToastDesc": "Un artículo coincide con una declaración.",
"dl.notifEmpty": "No hay notificaciones aún.",
"dl.notifEnabled": "Alertas del navegador habilitadas",
"dl.notifTitle": "Notificaciones",
"dl.payInvoice": "Pagar mi factura →",
"dl.rewardsPending": "Vales por presentar",
"dl.upgradeStarter": "Actualizar a Starter →",
"est.all": "Todos los establecimientos ({n})",
"est.label": "Establecimiento",
"est.primary": "primario",
"est.secondary": "secundario",
"est2.add": "Agregar un establecimiento",
"est2.addressLabel": "Dirección",
"est2.addressPh": "Calle República 12",
"est2.autoInvoice": "Una factura detallada se genera automáticamente el 1 de cada mes.",
"est2.baseSub": "Suscripción base",
"est2.billing": "Facturación",
"est2.boostActivated": "Impulso activado para {name}",
"est2.boostBillingNote": "Facturado a la tarifa actual y agrupado en tu factura mensual consolidada.",
"est2.boostCta": "Impulsar",
"est2.boostDesc": "Mejora la visibilidad de este establecimiento en el directorio y en el mapa.",
"est2.boostDuration": "{h}h de visibilidad impulsada",
"est2.boostExtend": "Extender",
"est2.boostTitle": "Impulsar {name}",
"est2.boosted": "Impulsado",
"est2.chartDesc": "Parte de artículos devueltos respecto al total registrado, sitio por sitio.",
"est2.chartTitle": "Tasa de retorno por establecimiento",
"est2.chartTooltip": "Devolución",
"est2.cityLabel": "Ciudad",
"est2.cityPh": "Lyon",
"est2.contactHint": "Estos detalles se muestran al cliente para este establecimiento (se reemplaza por la cuenta si está vacío).",
"est2.countryLabel": "País",
"est2.coverLabel": "Foto de portada",
"est2.create": "Crear",
"est2.created": "Establecimiento creado",
"est2.delete": "Eliminar",
"est2.deleteDesc": "Esta acción es permanente. Solo puedes eliminar un establecimiento si no contiene artículos.",
"est2.deleteTitle": "¿Eliminar “{name}”?",
"est2.deleted": "Establecimiento eliminado",
"est2.dialogDesc": "Ingresa el nombre y la dirección de este sitio.",
"est2.edit": "Editar",
"est2.editEst": "Editar establecimiento",
"est2.emailLabel": "Correo electrónico de contacto",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " establecimiento(s)",
"est2.extraNoteBase": "{n} establecimiento(s) adicional(es) facturados",
"est2.extraPrice": " a {price} €/mes.",
"est2.extraQuote": " en presupuesto.",
"est2.imgChange": "Elegir una imagen",
"est2.imgDone": "Hecho",
"est2.imgRemove": "Eliminar",
"est2.imgRemoved": "Imagen eliminada",
"est2.imgSaved": "Imagen guardada",
"est2.imgUploading": "Subiendo…",
"est2.includedPlan": "Incluido en tu plan: {n}.",
"est2.kDeclarations": "Declaraciones",
"est2.kInStorage": "En almacenamiento",
"est2.kItemsTotal": "Artículos (total)",
"est2.kRestituted": "Devueltos",
"est2.limitReached": "Límite alcanzado",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Decl.",
"est2.mItems": "Artículos",
"est2.mRestituted": "Devoluciones",
"est2.mStorage": "En almacenamiento",
"est2.monthlyTotal": "Total mensual",
"est2.nameLabel": "Nombre *",
"est2.namePh": "p. ej. Belmont Hotel — Anexo de Lyon",
"est2.newEst": "Nuevo establecimiento",
"est2.onQuote": "En cotización",
"est2.phoneLabel": "Teléfono",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plan",
"est2.planLimited": "Tu plan “{tier}” está limitado a {max} establecimiento(s).",
"est2.primary": "Primario",
"est2.qr": "Código QR",
"est2.qrDesc": "Muestra este código QR en este establecimiento. Los clientes que reporten una pérdida serán redirigidos a este sitio.",
"est2.qrTitle": "Código QR — {name}",
"est2.saving": "Guardando…",
"est2.seeInvoices": "Ver mis facturas mensuales",
"est2.seePlans": "Ver los planes",
"est2.subtitle": "Gestiona todos tus sitios bajo una cuenta — vista consolidada, artículos, código QR y facturación.",
"est2.suspended": "Suspendido",
"est2.tierFree": "1 establecimiento",
"est2.tierLarge": "establecimientos ilimitados",
"est2.tierMedium": "5 establecimientos incluidos",
"est2.tierSmall": "3 establecimientos incluidos",
"est2.title": "Establecimientos",
"est2.unlimitedPlan": "Tu plan permite un número ilimitado de establecimientos.",
"est2.unlimitedSuffix": " · ilimitado",
"est2.updated": "Establecimiento actualizado",
"est2.upgradeHint": "Actualiza a un plan superior para agregar más sitios y centralizar toda tu actividad.",
"est2.visuals": "Logo y foto",
"est2.visualsDesc": "Personaliza el logo y la foto de portada de este establecimiento. Aparecen en su página pública y formulario de declaración.",
"est2.visualsTitle": "Visuales — {name}",
"est2.workOn": "Trabajar en este establecimiento",
"est2.working": "Estás trabajando en “{name}”",
"fp.backToRanking": "Volver a la clasificación",
"fp.badge": "Insignia",
"fp.notFound": "Perfil no encontrado o privado.",
"fp.scoreTotal": "Puntos totales",
"fp.scoreYear": "Puntos en",
"fp.share": "Comparte este perfil",
"fp.shareText": "¡Mira el perfil de {name} en Findloop!",
"fp.tagline": "Un buscador honesto haciendo del mundo un lugar mejor.",
"ft.backAccount": "Volver a Mi cuenta",
"ft.closeBtn": "Cerrar el caso",
"ft.closeConfirm": "¿Confirmar que el artículo fue devuelto? El anuncio se cerrará.",
"ft.closeLockedHint": "Valida el código del dueño primero para desbloquear el cierre.",
"ft.closed": "Caso cerrado — ¡artículo devuelto!",
"ft.codeLabel": "Ingresa el código de validación recibido del propietario",
"ft.codeNeeded": "Por favor, ingresa el código de validación.",
"ft.codeOk": "Código validado — puedes cerrar el caso.",
"ft.codePlaceholder": "p. ej. 4821",
"ft.codeVerified": "Validado",
"ft.doneMsg": "Artículo devuelto. ¡Gracias por ayudar a regresar a su dueño!",
"ft.stepInProgress": "Devolución en progreso",
"ft.stepPublished": "Anuncio publicado",
"ft.stepReturned": "Artículo devuelto",
"ft.subtitle": "Sigue los pasos hasta que el artículo encontrado sea devuelto.",
"ft.title": "Seguimiento de devoluciones",
"ft.verifyBtn": "Validar código",
"home.champBecome": "Conviértete en un buscador",
"home.champCta": "Ver clasificación",
"home.champSubtitle": "Cada artículo devuelto gana puntos. Únete a la clasificación y gana recompensas.",
"home.champTitle": "Nuestros mejores buscadores",
"inv2.contractTitle": "Mi contrato Findloop",
"inv2.detailByEst": "Detalles por establecimiento",
"inv2.dueLabel": "Vencido:",
"inv2.dueSuffix": " · vencido {date}",
"inv2.error": "Error {status}",
"inv2.estCountIssued": "{n} establecimiento(s) · emitido el {date}",
"inv2.estimate": "Estimación (no cobrado) · {n} establecimiento(s)",
"inv2.expired": " · expirado",
"inv2.exportCsv": "Exportar CSV",
"inv2.exportDone": "CSV exportado descargado",
"inv2.included": "Incluido",
"inv2.monthlyTitle": "Facturación mensual (suscripción)",
"inv2.months": "+{n} meses",
"inv2.paid": "Pagado",
"inv2.pay": "Pagar",
"inv2.previewTitle": "Vista previa de tu próxima factura —",
"inv2.renew": "Renovar mi contrato",
"inv2.renewalsTitle": "Historial de renovaciones ({n})",
"inv2.renewedUntil": "Contrato renovado hasta {date}",
"inv2.serviceTitle": "Facturas de servicio (recuperaciones y presupuestos)",
"inv2.soon": "Expirando pronto",
"inv2.toPay": "A pagar",
"inv2.totalHtTva": "Total excl. impuesto · IVA",
"inv2.totalTtc": "Total incl. impuesto",
"iu.addPhoto": "Agregar una foto",
"iu.change": "Cambiar",
"lb.allCountries": "Todos los países",
"lb.badge": "Clasificación anual",
"lb.champion": "🏆 Campeón del año",
"lb.cityPh": "Filtrar por ciudad…",
"lb.empty": "No hay clasificación para estos filtros aún.",
"lb.pts": "puntos",
"lb.resetNote": "Clasificación del año en curso — se restablece cada 1 de enero.",
"lb.returned": "devuelto",
"lb.share": "Compartir clasificación",
"lb.shareText": "¡Mira la clasificación de los mejores buscadores en Findloop!",
"lb.subtitle": "Cada devolución gana puntos. La clasificación se restablece cada 1 de enero.",
"lb.tabFinders": "Buscadores",
"lb.tabPartners": "Establecimientos",
"lb.title": "Mejores buscadores",
"lost.b2bDesc": "¿Lo perdiste en un hotel, centro de transporte o lugar asociado? Encuentra el establecimiento y reporta tu pérdida.",
"lost.b2bTitle": "Reportar a un socio",
"lost.b2cDesc": "Publica un anuncio visible para todos, ofrece una recompensa y promociónalo para maximizar tus oportunidades.",
"lost.b2cTitle": "Publicar un anuncio público",
"lost.desc": "Elige cómo te gustaría proceder.",
"lost.title": "¿Perdiste un objeto?",
"map.allCategories": "Todas las categorías",
"map.clear": "Restablecer",
"map.exitFullscreen": "Salir",
"map.filterCity": "Ciudad o país…",
"map.fullscreen": "Pantalla completa",
"map.heatmap": "Mapa de calor",
"map.high": "Alto",
"map.impactMonth": "artículos devueltos este mes",
"map.impactTotal": "devueltos en total",
"map.legend": "Puntos de colores desde rojo (bajo) hasta verde (alto) según la tasa de retorno; tamaño basado en el número de artículos.",
"map.locating": "Localizando… añade una dirección a tus establecimientos para verlos en el mapa.",
"map.low": "Bajo",
"map.medium": "Medio",
"map.noItemRegistered": "Ningún artículo registrado",
"map.noItems": "Ningún artículo",
"map.period30": "Últimos 30 días",
"map.period7": "Últimos 7 días",
"map.period90": "Últimos 90 días",
"map.periodAll": "Todo el tiempo",
"map.returnedSuffix": "devueltos · {a}/{t} artículos",
"map.stats": "Estadísticas de la ciudad",
"map.statsTop": "Top 5 lugares (artículos perdidos)",
"map.statsTrend": "Tendencia de 6 meses",
"map.title": "Mapa de tus establecimientos",
"map.topPlaces": "Lugares populares",
"mc.addPhoto": "Añadir una foto",
"mc.archiveHide": "Ocultar historial",
"mc.archiveNone": "No hay casos resueltos aún.",
"mc.archiveShow": "Mostrar historial",
"mc.archiveSub": "Casos resueltos y devueltos.",
"mc.archiveTitle": "Historial",
"mc.backToLogin": "Volver al inicio de sesión",
"mc.cancel": "Cancelar",
"mc.certificate": "Certificado",
"mc.city": "Ciudad",
"mc.confirmPassword": "Confirmar contraseña",
"mc.confirmRestitution": "Confirmar devolución",
"mc.deleteAccount": "Eliminar mi cuenta",
"mc.deleteConfirm": "Sí, elimina mi cuenta",
"mc.deleteConfirmBody": "Tu cuenta será eliminada permanentemente y tus datos personales serán anonimados. Esta acción no se puede deshacer.",
"mc.deleteConfirmTitle": "¿Eliminar tu cuenta?",
"mc.deleteDesc": "Elimina permanentemente tu cuenta y anonimiza tus datos personales. Esta acción no se puede deshacer.",
"mc.deleted": "Tu cuenta ha sido eliminada.",
"mc.deleting": "Eliminando…",
"mc.expiresOn": "Expira el",
"mc.exportData": "Descargar mis datos (GDPR)",
"mc.exportDone": "Tus datos han sido descargados.",
"mc.exporting": "Preparando…",
"mc.finderAccepted": "Aceptado",
"mc.finderProfile": "Perfil del buscador (opcional)",
"mc.finderProfileDesc": "Gana puntos al devolver artículos y aparecer en la tabla de clasificación pública.",
"mc.forgotLink": "¿Olvidaste la contraseña?",
"mc.forgotSend": "Enviar el enlace",
"mc.forgotSent": "Si existe una cuenta para este correo, se ha enviado un enlace de restablecimiento.",
"mc.forgotTitle": "Olvidé la contraseña",
"mc.hAd": "Anuncio perdido",
"mc.hDeclaration": "Declaración",
"mc.hFinderContact": "Artículo reportado",
"mc.hFound": "Artículo devuelto",
"mc.hFoundAd": "Anuncio encontrado",
"mc.histEarned": "Artículo devuelto",
"mc.historyTitle": "Mi historial de puntos",
"mc.myFinds": "Artículos que encontré",
"mc.myFindsNone": "No has reportado haber encontrado ningún artículo aún.",
"mc.myFindsSub": "Artículos que reportaste haber encontrado en anuncios de artículos perdidos.",
"mc.myRewards": "Mis vales",
"mc.newPassword": "Nueva contraseña",
"mc.notEnough": "No hay suficientes puntos",
"mc.notifEmpty": "No hay notificaciones aún.",
"mc.notifOpen": "Ver",
"mc.notifTitle": "Notificaciones",
"mc.notifTrack": "Rastrear",
"mc.notifViewAd": "Ver anuncio",
"mc.optInDesc": "Participación opcional. Consentís en mostrar públicamente los elementos seleccionados a continuación. Cambiable en cualquier momento.",
"mc.optInTitle": "Aparecer en la tabla de clasificación pública",
"mc.passwordMismatch": "Las contraseñas no coinciden.",
"mc.pointsBalance": "Puntos para gastar",
"mc.presentHint": "Muestra este QR al socio: ellos lo escanean para validar tu recompensa.",
"mc.presentInStore": "Mostrar en tienda",
"mc.presentTitle": "Mostrar este voucher",
"mc.privacy": "Privacidad y datos",
"mc.privacyDesc": "Descarga una copia de todos los datos personales que Findloop tiene sobre ti (GDPR, art. 15 y 20).",
"mc.profileSaved": "Perfil actualizado.",
"mc.profileSettings": "Perfil público y tabla de clasificación",
"mc.pseudo": "Nombre o apodo",
"mc.redExpired": "Expirado",
"mc.redReady": "Mostrar al socio",
"mc.redUsed": "Usado",
"mc.redeem": "Canjear",
"mc.rememberMe": "Recuérdame",
"mc.remove": "Eliminar",
"mc.resetDone": "Contraseña actualizada. Ahora puedes iniciar sesión.",
"mc.resetExpired": "Este enlace de restablecimiento es inválido o ha expirado. Solicita uno nuevo a continuación.",
"mc.resetSave": "Restablecer mi contraseña",
"mc.resetTitle": "Nueva contraseña",
"mc.restitutionConfirmed": "Devolución confirmada.",
"mc.rewardRedeemed": "¡Recompensa desbloqueada! Código:",
"mc.rewardsDesc": "Utiliza tus puntos para beneficios ofrecidos por nuestros socios. Saldo:",
"mc.rewardsNone": "No hay recompensa disponible aún.",
"mc.rewardsTitle": "Gastar mis puntos",
"mc.scoreAwarded": "¡Bien hecho! +1 a tu Finder Score 🎉",
"mc.scoreEarned": "Punto ganado",
"mc.scorePts": "pts",
"mc.scoreThisYear": "Este año",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Ver tabla de clasificación",
"mc.visCity": "Ciudad",
"mc.visCountry": "País",
"mc.visLabel": "Elementos visibles en la tabla de clasificación:",
"mc.visName": "Nombre / apodo",
"mc.visPhoto": "Foto de perfil",
"mc2.acceptFinder": "Aceptar este finder",
"mc2.accountActivity": "Actividad de la cuenta",
"mc2.adsActive": "{n}/5 anuncios activos",
"mc2.autoDelete": "Eliminación automática programada para",
"mc2.badgeBronze": "Bronce",
"mc2.badgeGold": "Oro",
"mc2.badgeSilver": "Plata",
"mc2.boostEarnedAlready": "Ya te ha ganado",
"mc2.boostEarnedWin": "Te ganó",
"mc2.boostExpiredWin": "Tu boost acaba de expirar — ¡reanuda con -20%!",
"mc2.boostExpiresIn": "Tu boost expira en",
"mc2.boostWinDetail2": ". -20% aplicado automáticamente si renuevas dentro de 24h.",
"mc2.claimCode": "Código de reclamación:",
"mc2.codeSentFinder": "Código enviado al finder por correo electrónico",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Descargar mi recibo",
"mc2.error": "Error {status}",
"mc2.finderAccepted": "Finder aceptado — código enviado por correo electrónico",
"mc2.finderContacts": "Detalles de contacto del/dos Finder(s)",
"mc2.followFindo": "Sigue a Findloop",
"mc2.imgInvalid": "Imagen inválida",
"mc2.inactivityNote": " — en caso de {n} meses de inactividad (GDPR).",
"mc2.lastActivity": "Última actividad:",
"mc2.lostEmailTitle": "Ya no tengo acceso a mi correo electrónico",
"mc2.noPhotoPreset": "¿Sin foto aún? Elige un avatar predeterminado:",
"mc2.paidViaPartner": "Pagado (a través de un socio)",
"mc2.payRecovery": "Pagar la tarifa de recuperación",
"mc2.paySettle": "Liquidar mi pago",
"mc2.payShipping": "Pagar la tarifa de envío",
"mc2.payUnavailable": "Pago no disponible",
"mc2.peopleFound": "{n} persona(s) cree que encontraron tu artículo",
"mc2.phoneNumber": "Número de teléfono",
"mc2.reactivateAccount": "Reactivar mi cuenta",
"mc2.reactivated": "Cuenta reactivada",
"mc2.reactivatedThanks": "Cuenta reactivada — ¡gracias por tu lealtad!",
"mc2.recoverSmsBtn": "Obtén mi código por SMS",
"mc2.recoverSmsDesc": "Recibe tu código de reclamación por SMS al número registrado en tu cuenta.",
"mc2.recoverSmsFallback": "Si existe una cuenta con este número, se ha enviado un SMS.",
"mc2.renewStayTop": ". Renueva para mantenerte en la cima y recuperar tu artículo.",
"mc2.resume20": "Reanudar -20%",
"mc2.unlockContacts": "Desbloquear detalles de contacto",
"mc2.unlockDesc": "Paga la tarifa de manejo de Findloop para revelar sus detalles de contacto y organizar la entrega.",
"mc2.viewsWord": "vistas",
"mc2.live": "En directo",
"mh.allCategories": "Todas las categorías",
"mh.allPeriod": "Todo el tiempo",
"mh.autoMatch": "Coincidencia automática de IA",
"mh.blocked": "Bloqueado (contradicción)",
"mh.blockedReason": "Coincidencia bloqueada: las palabras clave principales del artículo y la declaración se contradicen entre sí.",
"mh.days30": "Últimos 30 días",
"mh.days7": "Últimos 7 días",
"mh.days90": "Últimos 90 días",
"mh.emptyDesc": "Las coincidencias de IA aparecerán aquí a medida que lleguen las declaraciones.",
"mh.emptyTitle": "No hay eventos",
"mh.exportCsv": "Exportar CSV",
"mh.exportDone": "CSV exportado descargado",
"mh.exportImpossible": "Exportación fallida",
"mh.fBlocked": "Bloqueado",
"mh.fConfirmed": "Confirmado",
"mh.fRejected": "Rechazado",
"mh.objectLabel": "Artículo:",
"mh.refresh": "Actualizar",
"mh.rejected": "Rechazado",
"mh.srcManual": "Manual",
"mh.srcText": "Texto",
"mh.srcVisual": "Visual (foto)",
"mh.subtitle": "Registro de coincidencias propuestas por IA — coincidencias automáticas, confirmadas y rechazadas.",
"mh.title": "Historia de IA",
"nav.ranking": "Tabla de clasificación",
"nf.desc": "La página que buscas no existe o ha sido movida.",
"nf.home": "Volver a inicio",
"nf.title": "Página no encontrada",
"par.allCities": "Todas las ciudades",
"par.cityPh": "Ciudad",
"pay.addr1": "Dirección",
"pay.addr2": "Línea de dirección 2 (opcional)",
"pay.addrIncomplete": "Por favor, completa tu dirección de entrega.",
"pay.city": "Ciudad",
"pay.country": "País",
"pay.eurNote": "Montos mostrados en euros (€).",
"pay.free": "gratis",
"pay.howRecover": "¿Cómo te gustaría recuperar tu artículo?",
"pay.pickup": "Recoger en persona",
"pay.pickupDesc": "En",
"pay.postal": "Código postal",
"pay.ship": "Envíamelo",
"pay.shipDesc": "Entrega a mi dirección",
"pay.shipping": "Costo de envío",
"pcat.city_hall": "Ayuntamientos",
"pcat.hotel": "Hoteles",
"pcat.other": "Otros",
"pcat.park": "Parques",
"pcat.prefecture": "Prefecturas",
"pcat.restaurant": "Restaurantes",
"pcat.uncategorized": "Sin categorizar",
"pd.about": "Acerca de",
"pd.back": "Todos los socios",
"pd.certified": "Socio certificado",
"pd.declare": "Reporta una pérdida aquí",
"pd.itemsReturned": "artículos devueltos",
"pd.itemsTotal": "artículos registrados",
"pd.map": "Ubicación",
"pd.noItems": "No se encontraron artículos recientemente.",
"pd.noReviews": "No hay reseñas aún.",
"pd.notFound": "Socio no encontrado.",
"pd.recentItems": "Artículos encontrados recientemente",
"pd.reply": "Respuesta del establecimiento",
"pd.reviews": "Reseñas de clientes",
"pd.verified": " reseña verificada",
"pd.verifiedEstablishment": "establecimiento verificado por Findloop",
"pg.next": "Siguiente",
"pg.prev": "Anterior",
"pg.showing": "{from}–{to} de {total}",
"pk.bodyCopy": "Cuerpo del texto",
"pk.bodyText": "Texto del cuerpo",
"pk.brandColors": "Colores de la marca",
"pk.colorRed": "Rojo",
"pk.colorWhite": "Blanco",
"pk.darkBg": "Fondo oscuro",
"pk.download": "Descargar",
"pk.downloadZip": "Descargar todo el kit (ZIP)",
"pk.headings": "Encabezados",
"pk.heroDesc": "Logos oficiales, banners de medios sociales, colores y tipografía. Elige el idioma y variante del eslogan, luego descarga el visual o el kit completo.",
"pk.lightBg": "Fondo claro (impresión)",
"pk.logoWordmark": "Logo / palabra",
"pk.logosVisuals": "Logos y visuales",
"pk.mapCollect": "Mapa / puntos de recolección",
"pk.plain": "Simple",
"pk.pressKit": "Kit de prensa",
"pk.taglineLang": "Idioma del eslogan",
"pk.typography": "Tipografía",
"pk.variant": "Variante",
"pr2.adBoostMsg": "¡Gran elección! Multiplicas tus posibilidades de recuperar rápidamente tu artículo.",
"pr2.boostActivated": "¡Impulso activado!",
"pr2.canRecoverNow": "Ahora puedes recuperar tu artículo.",
"pr2.continue": "Continuar",
"pr2.downloadReceiptPdf": "Descargar el recibo (PDF)",
"pr2.goToSpaceNow": "Ir a mi cuenta ahora",
"pr2.partnerBoostMsg": "¡Gran elección! Ser más visible significa atraer nuevos clientes a tu establecimiento.",
"pr2.paymentSuccess": "¡Pago exitoso!",
"pr2.redirectingSpace": "Redirigiendo a tu cuenta…",
"pr2.subActivated": "¡Pago exitoso! Tu suscripción está activa, ahora puedes gestionar tus establecimientos.",
"prev.allSites": "Todos los establecimientos",
"pricing.annual": "Anual",
"pricing.annualBadge": "Oferta del -20%",
"pricing.monthly": "Mensual",
"pricing.perYear": "/año",
"pricing.quoteMsg": "Tus necesidades (opcional)",
"pricing.quoteOrg": "Organización",
"pricing.quoteSend": "Enviar solicitud",
"pricing.quoteSent": "¡Solicitud enviada! Nos pondremos en contacto contigo pronto.",
"pricing.quoteSites": "Número de sitios / terminales",
"pricing.quoteTitle": "Solicitar una cotización",
"pricing.requestQuote": "Solicitar una cotización",
"pub.accessGranted": "Acceso concedido",
"pub.accessLimited2h": "Acceso limitado a 2 horas",
"pub.accountEmailConcerned": "Correo electrónico de la cuenta relacionada",
"pub.adAppearPublic": "Así es como aparecerá tu anuncio públicamente.",
"pub.adPreviewBtn": "Vista previa del anuncio",
"pub.alertMeOnArrival": "Alérteme a la llegada",
"pub.allActionsLogged": "Todas las acciones están registradas",
"pub.allCategories": "Todas las categorías",
"pub.authorizeAccess": "Autorizar acceso",
"pub.authorizeSupportQ": "¿Autorizar acceso al soporte?",
"pub.available": "Disponible",
"pub.backHome": "Volver a inicio",
"pub.boostAdCta": "Impulsa mi anuncio",
"pub.boostAdTitle": "Impulsa tu anuncio",
"pub.boostCarouselSub": "Mueve al principio de la página en el carrusel de “Impulsados” y multiplica vistas para recuperar tu artículo más rápido.",
"pub.boostEstablishment": "Impulsa tu establecimiento",
"pub.boostEstablishmentDesc": "Aparece en la parte superior del directorio con una etiqueta de “Impulsado” y atrae más reportes.",
"pub.boostFicheCta": "Impulsa mi listado",
"pub.brandReady": "La marca Findloop, lista para usar",
"pub.cantFindItem": "¿No puedes encontrar tu artículo?",
"pub.cantProcessImage": "No se puede procesar esta imagen",
"pub.claimQr": "Reclamar código QR",
"pub.clickToZoom": "Haz clic para ampliar",
"pub.codeAlreadyValidated": "Código validado — contactos desbloqueados.",
"pub.codeExample": "p. ej. ABCD2345",
"pub.confirmRenewal": "Confirmar renovación",
"pub.contactIntro": "¿Una pregunta, una solicitud? Escríbenos, nos pondremos en contacto contigo pronto.",
"pub.contactTypeDeceased": "Eliminación de cuenta (persona fallecida)",
"pub.contactTypeGeneral": "Pregunta general",
"pub.contactTypeSupport": "Soporte / problema técnico",
"pub.contactUs": "Contáctanos",
"pub.continueWithoutEmail": "Continuar sin dejar mi correo electrónico",
"pub.contractLabel": "Contrato",
"pub.contractNotFound": "Contrato no encontrado o ya expirado.",
"pub.contractRenewed": "¡Contrato renovado!",
"pub.contractRenewedFor": "Tu contrato se renueva por {n} meses.",
"pub.copyFailed": "Error al copiar",
"pub.createPartnerAccount": "Crear mi cuenta de socio",
"pub.currentDeadline": "Fecha límite actual",
"pub.deceasedInfo": "Como familiar o heredero, puedes solicitar la eliminación de la cuenta de Findloop de una persona fallecida. Procesaremos tu solicitud en cumplimiento con el GDPR (se pueden solicitar documentos de apoyo).",
"pub.declareMyLoss": "Reportar mi pérdida",
"pub.describeItemPlaceholder": "Describe tu artículo (p. ej. paraguas negro, llaves…)",
"pub.downloadImage": "Descargar la imagen",
"pub.drawSignature": "Por favor, dibuja tu firma.",
"pub.drawSignatureHint": "Dibuja tu firma con el mouse o el dedo.",
"pub.duration": "Duración",
"pub.eSignature": "Firma electrónica",
"pub.eSignatureDesc": "Ingresa tu nombre para firmar. La fecha se registra automáticamente.",
"pub.edit": "Editar",
"pub.editorialTitles": "Títulos editoriales",
"pub.emailPlaceholder": "tu@ejemplo.com",
"pub.enterCodeUnlockOwner": "Ingresa el código recibido por correo electrónico para desbloquear los datos de contacto del propietario.",
"pub.errorWord": "Error",
"pub.foundSelfService": "Artículos encontrados · Autoservicio",
"pub.haveOwnerCode": "Recibí un código del propietario",
"pub.home": "Inicio",
"pub.immediateRenewal": "Renovación inmediata, sin nueva cotización.",
"pub.impAdminReq1": "Administrador",
"pub.impAdminReq2": "solicita permiso para acceder temporalmente a tu cuenta",
"pub.impAdminReq3": "para ayudarte.",
"pub.impGrantedDesc": "El equipo de soporte podrá acceder a tu cuenta por un máximo de 2 horas. Cada acción será registrada. Puedes cerrar esta página.",
"pub.invitedOnFindo": "Estás invitado a Findloop",
"pub.isThisYourItem": "¿Es este tu artículo?",
"pub.itemsAvailableCount": "{n} artículo(s) actualmente disponible(s)",
"pub.itemsFoundOwner": "de artículos confiados encontró su dueño",
"pub.itemsReturnedOwners": "artículos devueltos a sus dueños",
"pub.itsMine": "Es mío",
"pub.joinFindoDesc": "Únete a Findloop y gestiona tus artículos encontrados con facilidad.",
"pub.joinInvitesYou": "te invita a unirte a findloop. Crea tu cuenta de socio para gestionar tus artículos encontrados.",
"pub.linkCopied": "¡Enlace copiado!",
"pub.loadingContract": "Cargando el contrato…",
"pub.lsClaimDesc": "Reporta tu pérdida para recuperarla. Deja tu correo electrónico y te enviaremos un recordatorio si tu informe no se completa.",
"pub.lsHeroDesc": "Verifica por tu cuenta si tu artículo perdido ha sido encontrado y dejado aquí. ¿Lo encontraste? Repórtalo para recuperarlo.",
"pub.lsSearchTitle": "Busca artículos encontrados",
"pub.makeOffer": "Hacer una oferta",
"pub.makeOfferDesc": "Propón tu monto. El superadministrador lo revisará.",
"pub.mapNearYou": "Artículos y socios cerca de ti",
"pub.mapWord": "Mapa",
"pub.messageSentToast": "Mensaje enviado — nuestro equipo responderá pronto.",
"pub.messageWord": "Mensaje",
"pub.momoInitiated": "Pago de Mobile Money iniciado",
"pub.monthsWord": "meses",
"pub.nameConsentRequired": "Nombre y consentimiento requeridos.",
"pub.newDeadline": "Nueva fecha límite",
"pub.noActionRequired": "No se requiere acción.",
"pub.noAmountCharged": "No se cobró ninguna cantidad.",
"pub.noItemMatch": "No hay artículo disponible que coincida con tu búsqueda en este momento.",
"pub.noMatchingItem": "No hay artículo coincidente",
"pub.noPaymentSession": "No hay sesión de pago.",
"pub.noPhoto": "Sin foto",
"pub.noPointsYet": "No hay puntos para mostrar aún.",
"pub.noSecondPayment": "No se requiere un segundo pago para este artículo.",
"pub.notHereYet": "¿Aún no está aquí? Recibe una notificación tan pronto como llegue.",
"pub.notifyDone": "¡Anotado! Te notificaremos por correo electrónico tan pronto como llegue un artículo coincidente.",
"pub.offerSubmitted": "Tu oferta ha sido enviada.",
"pub.oops": "Ups",
"pub.orAlertEmail": "O recibe una alerta por correo electrónico tan pronto como llegue un artículo coincidente:",
"pub.ownerContacts": "Datos de contacto del propietario",
"pub.ownerContactsUnlocked": "Datos de contacto del propietario desbloqueados",
"pub.partnerContact": "Contacto del socio",
"pub.payLinkUnavailable": "Enlace de pago no disponible — contacta al socio.",
"pub.paymentCancelled": "Pago cancelado",
"pub.paymentConfirmed": "Pago confirmado 🎉",
"pub.paymentConfirmedDesc": "Recibirás un correo electrónico con los detalles para recuperar tu artículo.",
"pub.paymentNotConfirmed": "Pago no confirmado",
"pub.paymentNotConfirmedDesc": "El pago no pudo ser verificado. Intenta de nuevo o contacta al socio.",
"pub.paymentProcessing": "El pago está siendo procesado. Actualiza en un momento.",
"pub.photoAdded": "✓ Foto añadida",
"pub.photoRequired": "Se requiere una foto del artículo.",
"pub.previewAlt": "vista previa",
"pub.publish": "Publicar",
"pub.publishingWord": "Publicando…",
"pub.qty": "Cant.",
"pub.quoteDeclined": "Cotización rechazada.",
"pub.quoteNotFound": "Cotización no encontrada o expirada.",
"pub.reasonLabel": "Razón",
"pub.recoveryAlreadyPaid": "Tarifa de recuperación ya pagada",
"pub.referralCode": "Código de referido:",
"pub.relationshipPlaceholder": "Hijo, cónyuge, notario…",
"pub.renewYourContract": "Renueva tu contrato",
"pub.renewalFailed": "La renovación falló. Intenta de nuevo más tarde.",
"pub.renewing": "Renovando…",
"pub.replySoon": "Nuestro equipo responderá lo antes posible.",
"pub.requestGone": "Esta solicitud ya no existe.",
"pub.requestHandled": "Solicitud ya gestionada",
"pub.requestNotFound": "Solicitud no encontrada o expirada.",
"pub.requestUnavailable": "Solicitud no disponible",
"pub.required": "(requerido)",
"pub.retroClosing": "Juntos, hacemos el mundo un poco menos perdido.",
"pub.retroClosing2": "Juntos, hacemos el mundo un poco menos perdido.",
"pub.retroScroll": "Un año recuperando lo que importa. Desplaza hacia abajo ↓",
"pub.revokeAnytime": "Puedes revocar en cualquier momento contactándonos",
"pub.scene": "Escena",
"pub.sendImpossible": "No se pudo enviar",
"pub.sendMessage": "Enviar el mensaje",
"pub.sending": "Enviando…",
"pub.sharePreview": "Compartir vista previa",
"pub.shareYourAd": "Comparte tu anuncio",
"pub.signedSuccess": "¡Firmado con éxito!",
"pub.signerFullName": "Nombre completo del firmante",
"pub.spreadNetwork": "Compártelo con quienes te rodean para aumentar tus posibilidades.",
"pub.spreadOwner": "Compártelo para ayudar al propietario a recuperar sus pertenencias.",
"pub.statusLabel": "Estado:",
"pub.subject": "Asunto",
"pub.thanksSent": "Gracias, tu mensaje ha sido enviado.",
"pub.thisYear": "Este año",
"pub.validate": "Validar",
"pub.verifyingPayment": "Verificando el pago…",
"pub.verifyingYourPayment": "Verificando tu pago…",
"pub.viewAd": "Ver el anuncio →",
"pub.viewPartner": "Ver al socio →",
"pub.yourAdPreview": "Vista previa de tu anuncio",
"pub.yourEmail": "Tu correo electrónico",
"pub.yourEmailRecommended": "Tu correo electrónico (recomendado)",
"pub.yourEmailShort": "Tu correo electrónico",
"pub.yourName": "Tu nombre",
"pub.yourRelationship": "Tu relación con la persona",
"qv.acceptAndSign": "Aceptar y firmar mi cotización",
"qv.certifyAuthorized": "Certifico que estoy autorizado para firmar y acepto los términos de este {what} (valor vinculante).",
"qv.clear": "Limpiar",
"qv.client": "Cliente",
"qv.conditions": "Términos",
"qv.confirmDecline": "¿Confirmar el rechazo de esta cotización?",
"qv.countersignedFindo": "Contrafirmado por Findloop · {name} el {date}",
"qv.decline": "Rechazar",
"qv.description": "Descripción",
"qv.downloadPdf": "Descargar el PDF",
"qv.handwrittenSignature": "Firma manuscrita",
"qv.inclTax": "Incl. IVA",
"qv.invalidAmount": "Cantidad no válida.",
"qv.invoice": "Factura",
"qv.invoicePaid": "Factura pagada",
"qv.issuer": "Emisor",
"qv.messageOptional": "Mensaje (opcional)",
"qv.negotiatedAmount": "Cantidad negociada",
"qv.payInvoiceOnline": "Pagar la factura en línea",
"qv.quote": "Cotización",
"qv.quoteValidDays": "Cotización válida por {n} días.",
"qv.sendMyOffer": "Enviar mi oferta",
"qv.signContract": "Firmar mi contrato",
"qv.signNow": "Firmar ahora",
"qv.signatureAlt": "Firma",
"qv.signedByOn": "✔ Firmado por {name} el {date}",
"qv.stContractSigned": "Contrato firmado. ¡Gracias!",
"qv.stCounterAccepted": "¡Tu oferta ha sido aceptada! Firma tu contrato a continuación.",
"qv.stCounterRefused": "Tu oferta no pudo ser aceptada.",
"qv.stCountered": "Tu oferta ha sido enviada. Esperando la respuesta de findloop.",
"qv.stDeclined": "Has rechazado esta cotización.",
"qv.stSigned": "Cotización aceptada y firmada. ¡Gracias!",
"qv.totalHt": "Total excl. IVA",
"qv.totalTtc": "Total incl. IVA",
"qv.unitHt": "Unidad excl. IVA",
"qv.vat": "IVA",
"qv.yourProposedAmount": "Tu cantidad propuesta ({cur})",
"reg.add": "Registrar un artículo",
"reg.allBrands": "Todas las marcas",
"reg.allColors": "Todos los colores",
"reg.allLocations": "Todas las ubicaciones",
"reg.detailDesc": "Detalles y acciones para este artículo encontrado.",
"reg.dispAuction": "Subasta",
"reg.dispAuthorities": "Entregado a las autoridades",
"reg.dispDestroyed": "Destrozado",
"reg.dispDonate": "Donación benéfica",
"reg.dispositionHint": "Registra el artículo saliendo del almacenamiento. Contado en estadísticas por categoría.",
"reg.emptyCta": "Registrar un artículo",
"reg.emptyDesc": "Comienza registrando tu primer artículo encontrado.",
"reg.emptyTitle": "No se encontraron artículos",
"reg.establishmentFallback": "el establecimiento",
"reg.lblAuctioned": "listado en subasta",
"reg.lblAuctionedShort": "subastado",
"reg.lblAuthorities": "entregado a las autoridades",
"reg.lblDestroyed": "destrozado",
"reg.lblDonated": "donado a una organización benéfica",
"reg.legalCount": "{n} artículo(s): periodo de retención legal alcanzado",
"reg.legalHint": "Puedes listarlos en subasta, donarlos a una organización benéfica o informar de su entrega a las autoridades.",
"reg.legalLimitCountry": "Fecha límite: {date} · país aplicado: {country}",
"reg.legalOver": "Fecha límite pasada: {date} · {country}",
"reg.legalReached": "Periodo legal alcanzado",
"reg.legalReachedFull": "Periodo de retención legal alcanzado",
"reg.limitShort": "fecha límite",
"reg.location": "Ubicación",
"reg.markRestituted": "Marcar como devuelto",
"reg.markedAs": "Artículo marcado como {label}",
"reg.moveHistory": "Historial de movimientos",
"reg.overBy": "superado por {n}d",
"reg.physicalLocation": "Ubicación física",
"reg.popupBlocked": "Permitir ventanas emergentes para imprimir las etiquetas.",
"reg.popupBlockedOne": "Permitir ventanas emergentes para imprimir la etiqueta.",
"reg.printLabel": "Imprimir la etiqueta",
"reg.printN": "Imprimir {n} etiqueta(s)",
"reg.qrCodeItem": "Código QR del artículo",
"reg.qrLabelTitle": "Etiqueta QR",
"reg.qrLabelsTitle": "Etiquetas QR",
"reg.qrNotFound": "No se encontró ningún artículo para este código QR.",
"reg.qrScanHint": "Escanéalo para abrir este registro directamente y encontrar la ubicación.",
"reg.recoveryFee": "Cargo de recuperación (€)",
"reg.searchPh": "Buscar por descripción…",
"reg.selectQr": "Seleccionar para imprimir etiquetas QR",
"reg.selectedN": "{n} seleccionado(s)",
"reg.shipPricePh": "Precio de envío (€)",
"reg.shippingPossible": "Envío disponible",
"reg.storagePh": "p.ej. Estante A3, Taquilla 12",
"reg.tAuction": "Subasta en Findloop",
"reg.tAuthorities": "Informe de entrega a las autoridades",
"reg.tDonate": "Donar a una organización benéfica",
"reg.toastFee": "Tarifa actualizada",
"reg.toastLocation": "Ubicación guardada",
"reg.toastRestituted": "Artículo marcado como devuelto",
"reg.toastShipping": "Opción de envío actualizada",
"reg.toastTransferred": "Artículo transferido a “{name}”",
"reg.unclaimedDisposition": "Artículo no reclamado — disposición final",
"res.codeValidated": "Código validado",
"res.empty": "No se ha registrado ninguna restitución aún.",
"res.error": "Error {status}",
"res.proofPdf": "Prueba en PDF",
"res.signed": "Firmado",
"res.stRestituted": "Entregado en persona",
"res.stShipped": "Devuelto por envío",
"res.subtitle": "Todas las entregas completadas, con su prueba firmada descargable.",
"res.title": "Historial de restituciones",
"rev.restitutedBy": "Devuelto por {org}",
"rev.storiesEyebrow": "Finales felices",
"rev.storiesSubtitle": "Historias reales de clientes que recuperaron sus pertenencias con findloop.",
"rev.storiesTitle": "¡Encontraron sus pertenencias!",
"rp.duplicate": "Duplicado",
"rp.inappropriate": "Contenido inapropiado",
"rp.wrongCategory": "Categoría incorrecta",
"rt.annualGoal": "Meta anual",
"rt.championCity": "Ciudad campeona",
"rt.cityRate": "Tasa de retorno del {rate}%",
"rt.goalProgress": "{rate}% alcanzado de una meta del {target}%",
"rt.reached": "Alcanzado 🎉",
"rt.restitutionRate": "Tasa de retorno",
"rt.shareRecap": "Compartir mi resumen",
"rt.thanks": "Gracias Findloop {year} 💛",
"rt.yourRecap": "Tu resumen de {year}",
"rw.active": "Activo",
"rw.add": "Agregar",
"rw.camUnavailable": "Cámara no disponible. Ingresa el código manualmente a continuación.",
"rw.codeValidated": "Código validado",
"rw.codesTitle": "Códigos canjeados por los buscadores",
"rw.confirmDelete": "Eliminar “{title}”?",
"rw.deleted": "Eliminado",
"rw.edit": "Editar",
"rw.editReward": "Editar la recompensa",
"rw.empty": "Aún no hay recompensa.",
"rw.expired": "Expirado",
"rw.expiresOn": "Expira el {date}",
"rw.fActive": "Activa (visible para los buscadores)",
"rw.fCost": "Costo (puntos)",
"rw.fDesc": "Descripción",
"rw.fStock": "Stock (vacío = ilimitado)",
"rw.fTitle": "Título",
"rw.fValidity": "Validez del vale (días después de la redención)",
"rw.inactive": "Inactiva",
"rw.newReward": "Nueva recompensa",
"rw.noExchange": "Aún no se ha canjeado.",
"rw.pageSubtitle": "Escanea los vales presentados por los buscadores para validar sus recompensas.",
"rw.redeemedN": "Canjeado: {n}×",
"rw.saved": "Recompensa guardada",
"rw.scanVoucher": "Escanear un vale",
"rw.staffScanOnly": "Escanear solo",
"rw.statActive": "Por presentar",
"rw.statExpired": "Expirado",
"rw.statRedeemed": "Vales canjeados",
"rw.statUsed": "Validado",
"rw.stock": "Stock",
"rw.subtitle": "Ofrece beneficios no monetarios (vales, mejoras…) que los buscadores canjean por sus puntos de Finder Score.",
"rw.title": "Recompensas para buscadores",
"rw.used": "Usado",
"rw.validate": "Validar",
"rw.validateCode": "Validar el código",
"rw.validity": "Validez: {n} d",
"side.establishments": "Establecimientos",
"side.restitutions": "Devoluciones",
"side.storage": "Almacenamiento & QR",
"status.auctioned": "Subastado",
"status.destroyed": "Destruido",
"status.donated": "Donado (caridad)",
"status.handed_to_authorities": "Entregado a las autoridades",
"status.in_storage": "En almacenamiento",
"status.matched": "Coincide",
"status.open": "Abierto",
"status.paid": "Pagado",
"status.pending": "Pendiente",
"status.restituted": "Devuelto",
"status.shipped": "Enviado",
"status.shipping_requested": "Envío solicitado",
"status.submitted": "Enviado",
"stg.allLabels": "Todas las etiquetas QR",
"stg.camHint": "Usa la entrada manual a continuación.",
"stg.camStarting": "Iniciando la cámara…",
"stg.camUnavailable": "Cámara no disponible.",
"stg.clear": "Borrar",
"stg.clearAll": "Borrar todo",
"stg.codeUnreadable": "Código ilegible.",
"stg.emptyDesc": "Los artículos almacenados aparecerán aquí, agrupados por ubicación.",
"stg.emptyTitle": "No hay artículo en almacenamiento",
"stg.exportAudit": "Exportar auditoría CSV",
"stg.exportDone": "Exportación CSV descargada",
"stg.exportImpossible": "Exportación no disponible en este momento.",
"stg.itemFound": "Artículo encontrado ✅",
"stg.kLocations": "Ubicaciones utilizadas",
"stg.kObjects": "Artículos almacenados",
"stg.kToClear": "Ubicaciones para limpiar",
"stg.locFreed": "Ubicación liberada",
"stg.locsFreed": "{n} ubicación(es) liberada(s)",
"stg.manualLabel": "O ingrese el código / ID del artículo",
"stg.manualPh": "Pegue el ID o URL del QR",
"stg.noItemMatch": "Ningún artículo coincide con este QR / código.",
"stg.noLocation": "Sin ubicación",
"stg.objectsAxis": "Artículos",
"stg.objectsN": "{n} artículo(s)",
"stg.occAvg": "prom. {n} artículo(s)/ubicación",
"stg.occHint": "Las ubicaciones en ámbar superan el promedio (potencialmente sobrecargadas).",
"stg.occupancy": "Ocupación de la ubicación",
"stg.openPage": "Abrir la página",
"stg.posterPdf": "PDF del cartel (A4)",
"stg.printAll": "Imprimir todo",
"stg.printGroupTitle": "Imprimir etiquetas para esta estantería",
"stg.qrAlt": "QR de autoservicio",
"stg.qrDownload": "Descargar el QR",
"stg.qrHint": "Muestra este QR en el mostrador: tus clientes lo escanean para verificar si su artículo está disponible.",
"stg.qrTitle": "QR de autoservicio para el cliente",
"stg.scanDesc": "Escanea la etiqueta de un artículo para abrir su registro al instante.",
"stg.scanQr": "Escanear un QR",
"stg.scanTitle": "Escanear un código QR",
"stg.search": "Buscar",
"stg.shelf": "Estante {loc}",
"stg.shelfPlan": "Plan del estante",
"stg.staleHint": "Limpia estas ubicaciones para mantener tu inventario físico actualizado.",
"stg.staleTitle": "{n} artículo(s) han salido del almacenamiento pero aún mantienen una ubicación",
"stg.subtitle": "Plan del estante, escáner de QR y seguimiento de inventario físico.",
"stg.title": "Almacenamiento & QR",
"stt.acceptRate": "Tasa de aceptación",
"stt.accepted": "Aceptado",
"stt.activity30": "Actividad (últimos 30 días)",
"stt.ai6mo": "Últimos 6 meses · aceptado = auto-mapeado + confirmado.",
"stt.aiEmpty": "Aún no hay coincidencias de IA en este período.",
"stt.aiTitle": "Coincidencias de IA — aceptadas vs rechazadas",
"stt.auctionShort": "Subasta",
"stt.auctionedSold": "Subastado (vendido)",
"stt.authShort": "Autoridades",
"stt.authorities": "Entregado a las autoridades",
"stt.avgRating": "Calificación promedio",
"stt.awaitingRestitution": "artículos esperando devolución",
"stt.boostClicks": "Clics en tu directorio esta semana gracias al impulso",
"stt.boostInactive": "Impulso inactivo — habilítalo para ganar visibilidad",
"stt.certifiedPremium": "Certificado premium",
"stt.declarations": "Declaraciones",
"stt.destroyed": "Destruido",
"stt.dispoEmpty": "No ha salido ningún artículo no reclamado del almacenamiento aún.",
"stt.donatedAssoc": "Donado (caridad)",
"stt.donatedShort": "Donado",
"stt.gateCta": "Descubre los planes",
"stt.gateDesc": "Actualiza a Starter para desbloquear tus estadísticas básicas, o a Business para estadísticas avanzadas y análisis por establecimiento.",
"stt.gateTitle": "Estadísticas reservadas para planes de pago",
"stt.inStorage": "En almacenamiento",
"stt.kItems": "Artículos registrados",
"stt.kRate": "Tasa de retorno",
"stt.kRestituted": "Artículos devueltos",
"stt.kRevenue": "Ingresos (mes)",
"stt.noDeclYet": "Aún no hay declaraciones.",
"stt.recapDownloaded": "Resumen descargado — ¡listo para compartir!",
"stt.recapError": "No se pudo generar el resumen",
"stt.recapText": "Nuestro resumen de Findloop {year}: artículos devueltos y satisfacción del cliente 🎉",
"stt.recapTitle": "Resumen de Findloop {year}",
"stt.rejected": "Rechazado",
"stt.restitutions": "Devoluciones",
"stt.shareRecap": "Compartir mi resumen de {year}",
"stt.topCategories": "Categorías más declaradas",
"stt.unclaimedDesc": "Volumen de artículos destruidos, donados a organizaciones benéficas y subastados, por categoría.",
"stt.unclaimedTitle": "Artículos no reclamados — saliendo del almacenamiento",
"stt.vsLastWeek": "vs la semana pasada",
"sub.cancel": "Cancelar mi suscripción",
"sub.cancelAbort": "Cancelar",
"sub.cancelConfirm1": "¿Estás seguro de que deseas cancelar? Tu acceso permanecerá activo hasta",
"sub.cancelConfirm2": "No se emitirá reembolso.",
"sub.cancelConfirmBtn": "Confirmar cancelación",
"sub.cancelTitle": "Cancelar tu suscripción",
"sub.cancelledToast": "Cancelación registrada.",
"sub.cguAnd": "y el",
"sub.cguDesc": "Por favor, confirma tu acuerdo antes del pago.",
"sub.cguLink": "Términos de Uso",
"sub.cguPay": "Continuar al pago",
"sub.cguPre": "He leído y acepto los",
"sub.cguRequired": "Debes aceptar los Términos de Uso y la Política de Privacidad para continuar.",
"sub.cguSuffix": "de findloop.",
"sub.cguTitle": "Finalizar tu suscripción",
"sub.expiresOn": "Tu suscripción vence el",
"sub.noProrata": "Sin reembolso pro-rata.",
"sub.privacyLink": "Política de Privacidad",
"sub.renewsOn": "Tu suscripción se renueva el",
"sub.resume": "Reinscribirse",
"sub.resumedToast": "Reinscripción confirmada.",
"tier.free": "Freemium",
"tier.large": "Empresarial",
"tier.medium": "Negocio",
"tier.small": "Iniciador",
"tm.add": "Agregar",
"tm.adminOpt": "Admin (vista completa)",
"tm.chooseEst": "Elegir un establecimiento",
"tm.chooseEstPh": "Elige un establecimiento",
"tm.copyFail": "Error al copiar",
"tm.copyLink": "Copiar el enlace",
"tm.copyOk": "Enlace de invitación copiado",
"tm.emailHint": "Se enviará un correo electrónico de invitación para crear la contraseña.",
"tm.expiresOn": "vence el {date}",
"tm.forEmail": " para {email}",
"tm.forbidden": "La gestión de equipo está reservada para el propietario de la cuenta.",
"tm.inviteCreated": "Invitación creada",
"tm.inviteDesc": "Un correo electrónico de invitación permite al compañero crear su contraseña.",
"tm.invitePending": "Invitación pendiente",
"tm.inviteResent": "Invitación reenviada",
"tm.inviteSent": "Invitación enviada por correo electrónico",
"tm.inviteTitle": "Invitar a un miembro",
"tm.invitedOn": "Invitado el {date}",
"tm.linkExpired": "Enlace expirado",
"tm.memberRemoved": "Miembro eliminado",
"tm.name": "Nombre",
"tm.noMembers": "Aún no hay compañeros.",
"tm.resendTitle": "Reenviar la invitación",
"tm.role": "Rol",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Propietario",
"tm.roleStaff": "Personal",
"tm.roleUpdated": "Rol actualizado",
"tm.sendInvite": "Enviar la invitación",
"tm.sending": "Enviando…",
"tm.staffOpt": "Personal (solo ve su establecimiento)",
"trk.carrier": "Transportista",
"trk.codeValidated": "Código validado por el socio",
"trk.dlProof": "Descargar mi comprobante de entrega (PDF)",
"trk.enterEmailCode": "Ingresa tu correo electrónico arriba para mostrar tu código de reclamación.",
"trk.lostEmail": "Ya no tengo acceso a mi correo electrónico",
"trk.phonePh": "Tu número de teléfono",
"trk.photoBefore": "Foto del artículo antes del envío",
"trk.recoverHint": "Obtén tu código de reclamación por SMS al número registrado.",
"trk.secureRest": "Entrega segura",
"trk.send": "Enviar",
"trk.shipPending": "Envío en preparación — el número de seguimiento aparecerá aquí una vez enviado.",
"trk.shipTitle": "Seguimiento de envío",
"trk.showQr": "Muestra este QR al socio para validar la entrega",
"trk.sigSaved": "Firma guardada",
"trk.signFirst": "Por favor, firma antes de confirmar.",
"trk.signProof": "Firma tu comprobante de entrega",
"trk.signSubmit": "Confirma mi firma y genera el PDF",
"trk.trackShipment": "Rastrear paquete",
"trk.trackingNo": "Número de seguimiento",
"trk.yourCode": "Tu código de reclamación (para dar al socio)",
"a.firstName": "Nombre",
"ac.emailCrossMatch": "Coincidencias B2C",
"ac.emailCrossMatchDesc": "Un correo cuando un anuncio público de objeto perdido coincide con un objeto depositado en sus instalaciones",
"ac.emailCrossReject": "Rechazos de coincidencias públicas",
"ac.emailCrossRejectDesc": "Reciba un correo cuando un cliente indique que una coincidencia pública sugerida no es su objeto.",
"ac.emailLoginNotif": "Notificación de inicio de sesión",
"ac.emailLoginNotifDesc": "Reciba un correo cada vez que alguien inicie sesión en su cuenta.",
"ad.closeNoCancel": "No, eliminar el anuncio",
"ad.closeQuestion": "¿Se te devolvió el objeto?",
"ad.closeQuestionDesc": "Háganos saber si recuperó su objeto o si simplemente desea eliminar este anuncio.",
"ad.closeYesRestituted": "Sí, el objeto fue devuelto",
"ad.closedRestituted": "Objeto devuelto — anuncio cerrado 🎉",
"an.lostLoginDesc": "Se requiere una cuenta para informar un objeto perdido y seguir su devolución.",
"an.lostLoginRequired": "Inicie sesión para informar un objeto perdido",
"an.qfAll": "Todos",
"an.qfBoosted": "Acelerados",
"an.qfPhoto": "Con foto",
"an.qfRecent": "Esta semana",
"an.qfResolved": "Resuelto",
"an.restitutionInProgress": "Objeto en proceso de devolución",
"dec.descPhLong": "Describa el objeto: marca, color, marcas distintivas… (Cuantos más detalles dé, mayores serán sus posibilidades de recuperar su objeto)",
"dec.loadError": "No se puede cargar el socio en este momento. Verifique su conexión e inténtelo de nuevo.",
"dec.retry": "Reintentar",
"dec.shippingMode": "Envío",
"dep.photo2": "2ª foto del objeto",
"dep.photo2Hint": "Opcional — otro ángulo mejora la precisión del emparejamiento visual.",
"dl.accountSuspended": "Cuenta suspendida por una factura impaga. Págala para restaurar tu acceso.",
"dl.regularize": "Paga ahora →",
"dl.suspensionCountdown": "Factura {num} impaga — su cuenta será suspendida en {days} día(s). Págala para evitar esto.",
"ft.cancelConfirm": "¿Cancelar su informe? El propietario del objeto será informado.",
"ft.cancelDone": "Informe cancelado.",
"ft.cancelLocked": "La cancelación no es posible después de que el propietario haya pagado.",
"ft.cancelReport": "Cancelar mi informe",
"ft.claimCodeHelp": "Entregue este código al encontrador al hacer la entrega para confirmar que ha recibido su objeto.",
"ft.claimCodeTitle": "Su código de restitución",
"ft.claimDone": "Objeto devuelto. ¡Gracias por usar Findloop!",
"ft.claimUnlockHint": "Desbloquee los detalles de contacto del encontrador",
"ft.claimUnlockHintSub": "Vaya a \"Objetos que estoy reclamando\" en su cuenta para pagar la tarifa y obtener los detalles de contacto.",
"ft.finderCodeShownHelp": "El propietario ha pagado y lo ha seleccionado. Copie este código a continuación para confirmar la devolución — no es necesario revisar su correo electrónico.",
"ft.finderCodeShownTitle": "Código de validación del propietario",
"ft.finderContactsTitle": "Detalles de contacto del Finder",
"ft.foundCodeHelp": "Muestra este código al propietario durante la entrega para confirmar que el artículo fue devuelto.",
"ft.inProgressOther": "Artículo en devolución",
"ft.inProgressOtherHelp": "El propietario seleccionó otro finder para este artículo. No se necesita ninguna acción de tu parte.",
"ft.restitutionCodeHelp": "Este código confirma la entrega del artículo. Ya está prellenado abajo; valídalo y luego cierra el caso.",
"ft.restitutionCodeTitle": "Tu código de restitución",
"hc.14Digits": "14 dígitos",
"hc.15DaysBeforeAnItem": "15 días antes de la fecha límite legal de un artículo.",
"hc.7DaysBeforeAnItem": "7 días antes de la fecha límite legal de un artículo.",
"hc.8CharactersMinimum": "Mínimo de 8 caracteres.",
"hc.aClaimToValidate": "Una reclamación para validar",
"hc.aFindoAssistanceSessionIs": "Una sesión de asistencia Findloop está actualmente activa en tu cuenta.",
"hc.aNewMatchHasBeen": "Se ha encontrado una nueva coincidencia",
"hc.aUser": "Un usuario",
"hc.aUserClaimsToBe": "Un usuario afirma ser el propietario. Verifica sus respuestas antes de autorizar la devolución.",
"hc.aboutFindo": "Acerca de Findloop",
"hc.accountActivatedPleaseLogIn": "Cuenta activada, por favor inicie sesión.",
"hc.accountActivation": "Activación de la cuenta",
"hc.accountCreated": "¡Cuenta creada!",
"hc.accountDeactivatedAReactivationEmail": "Cuenta desactivada. Se te ha enviado un correo electrónico de reactivación (válido por 30 días).",
"hc.accountReactivation": "Reactivación de la cuenta",
"hc.activateMyAccount": "Activar mi cuenta",
"hc.activateMyAdminAccount": "Activar mi cuenta de administrador",
"hc.activating": "Activando…",
"hc.activeMatchCancelReason": "Coincidencia activa. Razón de cancelación del cliente: \"{reason}\". El artículo aún está a la espera de una reclamación.",
"hc.activeMatchWithAPublic": "Coincidencia activa con un listado público (cliente). Esperando la reclamación del propietario.",
"hc.addAPhoto": "Agregar una foto",
"hc.addAndConfigureYourEstablishments": "Agrega y configura tus establecimientos en \"Establecimientos\": detalles de contacto, categoría y almacenamiento físico de artículos.",
"hc.addOnGoogle": "Agregar en Google",
"hc.address": "Dirección",
"hc.addressSaved": "Dirección guardada",
"hc.addressStreet": "Dirección — Calle",
"hc.adjustThePhoto": "Ajustar la foto",
"hc.adminFullView": "Administrador (vista completa)",
"hc.administratorOnly": "Solo para administradores",
"hc.africa": "África",
"hc.aiVisualComparison": "Comparación visual de IA",
"hc.all": "Todo",
"hc.amount": "Cantidad",
"hc.anOrganization": "Una organización",
"hc.analyzing": "Analizando…",
"hc.andRecoveryIs": "y la recuperación es",
"hc.andTheDeclarationWillBe": "y la declaración se cerrará (se moverá a historial). Esta acción es definitiva.",
"hc.annual20": "Anual -20%",
"hc.annualBilling20": "Facturación anual (−20%)",
"hc.annualTarget": "Objetivo anual",
"hc.anyCommentsOptional": "¿Alg comentarios? (opcional)",
"hc.approveTheClaim": "Aprobar la reclamación",
"hc.archiveCancelledConfirm": "¿Archivar {n} listado(s) \"Cancelado por el cliente\"? Serán eliminados del registro.",
"hc.asSoonAs": "Tan pronto como",
"hc.askTheOwnerToDisplay": "Pedir al propietario que muestre el QR de su código (página de seguimiento).",
"hc.askThemAtTheCounter": "Pregúntales en el mostrador para confirmar la identidad — nunca visible públicamente.",
"hc.assistance": "Soporte",
"hc.assistanceSessionRevoked": "Sesión de asistencia revocada.",
"hc.atLeast6Characters": "Al menos 6 caracteres",
"hc.automaticallyPreSelected": "preseleccionado automáticamente",
"hc.automaticallyWhenShipping": "automáticamente al enviar.",
"hc.awaitingClaim": "Esperando reclamación",
"hc.awaitingPayment": "Esperando pago",
"hc.b2cCustomer": "Cliente B2C",
"hc.back": "Atrás",
"hc.backToHome": "Regresar a inicio",
"hc.backToMyAccount": "Regresar a mi cuenta",
"hc.backToPayment": "Regresar al pago",
"hc.beforeAfterComparisonSlider": "Deslizador de comparación antes/después",
"hc.billingInformation": "Información de facturación",
"hc.billingInformationSaved": "Información de facturación guardada ✓",
"hc.brand": "Marca",
"hc.bronze": "Bronce",
"hc.calculatingTheShippingRate": "Calculando la tarifa de envío…",
"hc.cameraUnavailableEnterTheCode": "Cámara no disponible. Ingresa el código manualmente.",
"hc.cancel": "Cancelar",
"hc.cancelMyDeclaration": "Cancelar mi declaración",
"hc.cancelSavedFmt": "Cancelación guardada: \"{reason}\". Aún puedes reclamar.",
"hc.cancelTheDeposit": "Cancelar el depósito",
"hc.cancelThisMatch": "Cancelar este partido",
"hc.cancellationReason": "Razón de cancelación",
"hc.cancelled": "Cancelado",
"hc.cancelledByTheCustomer": "Cancelado por el cliente",
"hc.cannotOpenPayment": "No se puede abrir el pago. Por favor, inténtalo de nuevo.",
"hc.careers": "Carreras",
"hc.carrier": "Transportista",
"hc.carrierAvailabilityCannotBeChecked": "La disponibilidad del transportista no se puede verificar hasta que tu remitente de Sendcloud esté configurado.",
"hc.carrierConfirmedCharged": "Transportista confirmado: se cargaron {price} € al cliente",
"hc.carrierOther": "Transportista (otro)",
"hc.carrierSelection": "Selección de transportista",
"hc.caseClosedThankYou": "Caso cerrado. ¡Gracias!",
"hc.category": "Categoría",
"hc.changeMethod": "Cambiar método",
"hc.characteristic": "Característica",
"hc.chargedToCustomer": "cargado al cliente.",
"hc.checkOrEditYourDetails": "Revisa o edita tus detalles antes del pago seguro.",
"hc.checkStatisticsToTrackDeposited": "Revisa \"Estadísticas\" para rastrear artículos depositados, tasa de devolución y rendimiento de cada establecimiento.",
"hc.checkTheDetailsBeforeContacting": "Revisa los detalles antes de contactar al buscador.",
"hc.checkTheDetailsBelowBefore": "Revisa los detalles a continuación antes de iniciar tu solicitud de devolución.",
"hc.checkTheNewItem": "Revisa el nuevo artículo",
"hc.checkThePhotosAndCharacteristics": "Revisa las fotos y características a continuación antes de proceder con la recuperación.",
"hc.chooseACountry": "Elige un país",
"hc.chooseANewPassword": "Elige una nueva contraseña",
"hc.chooseAReason": "Elige una razón",
"hc.chooseTheLegalRetentionAlerts": "Elige las alertas de retención legal recibidas por correo electrónico para",
"hc.chooseYourPasswordToAccess": "Elige tu contraseña para acceder a la consola de administración.",
"hc.city": "Ciudad",
"hc.claimApproved": "Reclamo aprobado",
"hc.claimApproved2": "Reclamo aprobado.",
"hc.claimCodeExpired": "Código de reclamo expirado",
"hc.claimCodeVerified": "Código de reclamo verificado",
"hc.claimNotFound": "Reclamo no encontrado",
"hc.claimNotValidated": "Reclamo no validado",
"hc.claimRejected": "Reclamo rechazado",
"hc.claimRejected2": "Reclamo rechazado.",
"hc.claimValidated": "Reclamo validado",
"hc.claimValidatedByThePartner": "Reclamo validado por el socio",
"hc.claimant": "Reclamante",
"hc.claimsToBeTheOwner": "afirma ser el propietario de este artículo y respondió las preguntas de verificación. Solo aprueba si las respuestas coinciden.",
"hc.claimsToValidate": "Reclamos a validar",
"hc.clear": "Borrar",
"hc.clickToZoom": "Haz clic para hacer zoom",
"hc.close": "Cerrar",
"hc.close2": "Cerrar",
"hc.closeTheDeclaration": "Cerrar la declaración",
"hc.closeTheDeclaration2": "¿Cerrar la declaración?",
"hc.codeAlreadyVerified": "Código ya verificado",
"hc.codeCopied": "Código copiado",
"hc.collapse": "Colapsar",
"hc.color": "Color",
"hc.company": "Empresa",
"hc.companyName": "Nombre de la empresa",
"hc.comparePhotos": "Comparar fotos",
"hc.compareThemWithTheOwner": "Compáralos con las respuestas del propietario — nunca visibles públicamente.",
"hc.condition": "Condición",
"hc.confirmAndPay": "Confirmar y pagar",
"hc.confirmCancellation": "Confirmar cancelación",
"hc.confirmCrop": "Confirmar recorte",
"hc.confirmDeletion": "Confirmar eliminación",
"hc.confirmPassword": "Confirmar contraseña",
"hc.confirmThatThisIsYour": "Confirma que este es tu artículo. Se solicitará una verificación de identidad al encontrador antes de cualquier contacto.",
"hc.confirmTheCarrier": "Confirmar el transportista",
"hc.confirmThePassword": "Confirmar la contraseña",
"hc.confirmYourShippingAddressTo": "Confirma tu dirección de envío para continuar con el pago.",
"hc.confirmYourSubscription": "Confirmar tu suscripción",
"hc.confirmed": "Confirmado ✓",
"hc.contactFindoToGetYour": "Contacta a Findloop para obtener tu ID de remitente.",
"hc.contactUs": "Contáctanos",
"hc.continueTheReturn": "Continuar con la devolución",
"hc.continueToPayment": "Continuar al pago",
"hc.copy": "Copiar",
"hc.correctMyDetails": "corregir mis datos",
"hc.correctThisEntry": "¿Corregir esta entrada?",
"hc.country": "País",
"hc.countryAddress": "País (dirección)",
"hc.countryIsoCodeEG": "País (código ISO, p. ej. FR)",
"hc.cover": "cubrir",
"hc.createTheShipment": "Crear el envío",
"hc.cropThePhoto": "Recortar la foto",
"hc.customer": "Cliente",
"hc.customerClaimCodeToCheck": "Código de reclamación del cliente — para verificar en la recogida:",
"hc.customerReasonFmt": "Razón del cliente: \"{reason}\".",
"hc.customerReminderDelay": "Retraso de recordatorio del cliente",
"hc.customerWhosePublicListingMatches": "Cliente cuya lista pública coincide con este artículo — visible solo para ti.",
"hc.d15": "D-15",
"hc.dangerZone": "Zona de peligro",
"hc.date": "Fecha",
"hc.dateNewest": "Fecha (más reciente)",
"hc.dateOldest": "Fecha (más antigua)",
"hc.daysToYearEnd": "{n} días hasta el fin del año",
"hc.deadlineAlert": "Alerta de plazo",
"hc.declarationClosed": "Declaración cerrada ✓",
"hc.declarationNotFound": "Declaración no encontrada.",
"hc.declarationNotFound2": "Declaración no encontrada",
"hc.declarationTracking": "Seguimiento de declaración",
"hc.defaultCarrier": "Transportista predeterminado",
"hc.defaultCarrierPreselected": "Transportista predeterminado preseleccionado — se puede cambiar para este envío. Tarifa actual (Sendcloud + {m}% de margen).",
"hc.defaultCarrierRemoved": "Transportista predeterminado eliminado",
"hc.delayHours": "Retraso (horas)",
"hc.deleteMyAccount": "Eliminar mi cuenta",
"hc.deleting": "Eliminando…",
"hc.deletingDeactivatesYourAccountLogin": "Eliminar desactiva tu cuenta: el acceso está bloqueado y los datos se mantienen por 30 días. Recibirás un correo electrónico con un enlace de reactivación válido por 30 días.",
"hc.delivered": "Entregado",
"hc.depositAnItem": "Depositar un artículo",
"hc.depositCancelledItemPutBack": "Depósito cancelado — artículo devuelto a stock.",
"hc.depositCancelledItemRemovedFrom": "Depósito cancelado — artículo eliminado del registro.",
"hc.depositedOn": "Depositado el",
"hc.describeTheItemBrandColor": "Describe el artículo: marca, color, marcas distintivas… (Cuantos más detalles des, mejores serán tus posibilidades de encontrar tu artículo)",
"hc.dimensionsCm": "Dimensiones (cm)",
"hc.disablingAnEmail": "Deshabilitando un correo electrónico",
"hc.doesNotHide": "no oculta",
"hc.download": "Descargar",
"hc.downloadThePdf": "Descargar el PDF",
"hc.draftRestoredPickUpYour": "Borrador restaurado — recoge tu declaración donde la dejaste.",
"hc.dragToReposition": "Arrastra para reposicionar",
"hc.eGColisPriv": "Ej. Colis Privé",
"hc.eachItemGetsAQr": "Cada artículo recibe una etiqueta QR. Escanéalo desde \"Almacenamiento y QR\" para localizar un artículo al instante.",
"hc.eachSiteManagesItsOwn": "Cada sitio gestiona su propia banca. Ve a",
"hc.edit": "Editar",
"hc.emailNotificationPreferences": "Preferencias de notificación por correo electrónico",
"hc.emailPreferencesUpdated": "Preferencias de correo electrónico actualizadas",
"hc.enableOrDisableRecoveryFees": "Habilitar o deshabilitar tarifas de recuperación para",
"hc.enlargePhoto": "Ampliar foto",
"hc.enterTheCustomerSCode": "Ingresa el código del cliente",
"hc.estShipRate": "Tarifa de envío estimada (Sendcloud + {m}% de margen):",
"hc.establishment": "Establecimiento",
"hc.establishment2": "Establecimiento:",
"hc.establishmentInItsSendcloudAccount": "establecimiento en su cuenta de Sendcloud y le proporciona el ID del remitente",
"hc.establishmentSettings": "Configuraciones del establecimiento",
"hc.exCode": "p. ej. ABCD2345",
"hc.exId": "p. ej. 3f2a…",
"hc.exit": "Salir",
"hc.explainWhyThisItemIs": "Explica por qué este artículo no es tuyo…",
"hc.externalPaymentLinks": "Enlaces de pago externos",
"hc.failed": "Fallido",
"hc.feesEnabled": "Comisiones habilitadas",
"hc.field": ") campo.",
"hc.finderAcceptedCloseTheCase": "Finder aceptado — cierra el caso una vez que el artículo ha sido entregado en persona.",
"hc.findoCityRanking": "Findloop — Clasificación de ciudades",
"hc.findoForEstablishments": "Findloop para establecimientos",
"hc.findoPresentationVideo": "vídeo de presentación de Findloop",
"hc.findoRegistersTheAddressOf": "Findloop registra la dirección de tu",
"hc.findoReviewShare": "revisión de Findloop {year}: {n} artículos devueltos, {rate}% tasa de retorno 🎉",
"hc.firstVerifyTheClaimCode": "Primero verifica el código de reclamación arriba",
"hc.forEveryNewShipmentFrom": "por cada nuevo envío desde",
"hc.free": "gratis",
"hc.freeRecovery0": "Recuperación gratuita (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Recuperación gratuita en toda África – Oferta de lanzamiento",
"hc.freeRecoveryFeesDisabled0": "Recuperación gratuita: tasas deshabilitadas (0 €)",
"hc.fromTeamInviteYourColleagues": "Desde \"Equipo\", invita a tus colegas por correo electrónico y asígnales un establecimiento. Cada miembro solo ve su propio alcance.",
"hc.fullName": "Nombre completo",
"hc.fullPhoto": "Foto completa",
"hc.gallery": "Galería",
"hc.giveTheReasonForCancelling": "Da la razón para cancelar. El socio será informado.",
"hc.goToLogin": "Ir a inicio de sesión",
"hc.goToMyAccount": "Ir a mi cuenta",
"hc.gold": "Oro",
"hc.googleLoginFailed": "El inicio de sesión con Google falló",
"hc.hasConfirmedYourPaymentYou": "ha confirmado tu pago, serás redirigido automáticamente",
"hc.helpCenter": "Centro de ayuda",
"hc.helpUsImproveWhyAre": "Ayúdanos a mejorar: ¿por qué te vas? Tu cuenta será desactivada y puede ser reactivada durante 30 días.",
"hc.hidePassword": "Ocultar contraseña",
"hc.high": "Alto",
"hc.historyOfYourMonthlySubscriptions": "Historial de tus suscripciones mensuales y su estado de pago.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "¿Cómo configuro mi ID de remitente numérico?",
"hc.iDonTUseIt": "No lo utilizo lo suficiente",
"hc.iFoundItElsewhere": "Lo encontré en otro lugar",
"hc.iNoLongerNeedMy": "Ya no necesito mi artículo",
"hc.identityVerification": "Verificación de identidad",
"hc.idleLogoutIn": "Se cerrará la sesión en {n} s debido a inactividad.",
"hc.ifProvidedTheVolumetricWeight": "Si se proporciona, se utiliza el peso volumétrico.",
"hc.ifThePartnerHasNot": "Si el socio no ha confirmado la recepción del pago externo después de este plazo, Findloop recuerda automáticamente al socio que lo valide.",
"hc.impersonationEnded": "Suplantación finalizada.",
"hc.impersonationMode": "Modo de suplantación",
"hc.impersonationSessionExpired": "La sesión de suplantación ha expirado.",
"hc.inTheField": ", en el campo",
"hc.inTransit": "En tránsito",
"hc.inclVat": "incl. IVA",
"hc.intraEuVatNumberOptional": "Número de IVA intracomunitario opcional, no se requiere SIRET (fuera de Francia).",
"hc.invalidInvitationLink": "Enlace de invitación inválido.",
"hc.invalidInvitationLink2": "Enlace de invitación inválido",
"hc.invalidInviteLink": "Enlace de invitación inválido o expirado.",
"hc.invalidNumberEnterAnInternational": "Número inválido. Introduzca un número internacional, p. ej. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Enlace inválido o expirado.",
"hc.invalidOrExpiredReactivationLink": "Enlace de reactivación inválido o expirado",
"hc.invalidSendcloudId": "ID de Sendcloud inválido",
"hc.inviteSubtitle": "{org} te invita a unirte a su equipo de findloop. Elige tu contraseña para activar tu cuenta.",
"hc.isAvailableOnSendcloudFor": "está disponible en Sendcloud para todas tus rutas (nacionales + internacionales).",
"hc.isNotEnabledOnYour": "no está habilitado en tu cuenta de Sendcloud para algunos destinos. Las etiquetas para esos serán generadas con otro transportista disponible.",
"hc.isThisReallyYourItem": "¿Es realmente tu artículo?",
"hc.isThisYourItem": "¿Es este tu artículo?",
"hc.item": "Artículo",
"hc.itemAlreadyConfirmed": "Artículo ya confirmado",
"hc.itemDetails": "Detalles del artículo",
"hc.itemFoundAt": "Artículo encontrado en",
"hc.itemFoundAtAPartner": "Artículo encontrado en un socio",
"hc.itemMarkedAsReturned": "Artículo marcado como devuelto ✓",
"hc.itemPhotoRequiredBeforeShipping": "Foto del artículo (requerida antes del envío)",
"hc.itemPhotoSaved": "Foto del artículo guardada",
"hc.itemPreview": "Vista previa del artículo",
"hc.itemPutBackInStorage": "Artículo devuelto al almacenamiento.",
"hc.itemWeight": "Peso del artículo:",
"hc.itemsReturned": "artículo(s) devuelto(s)",
"hc.itemsReturnedThisYear": "artículos devueltos este año",
"hc.itemsWhoseLegalDeadlineIs": "Artículos cuyo plazo legal es de 15 días o menos (incluye los atrasados). Las coincidencias permanecen visibles.",
"hc.kbisNumber": "Número Kbis",
"hc.keysForgottenOnABench": "Llaves olvidadas en un banco",
"hc.labelBeingGenerated": "Etiqueta en generación",
"hc.leaveTheFieldsEmptyTo": "Deja los campos vacíos para ofrecer la recuperación de forma gratuita.",
"hc.legalNotice": "Aviso legal",
"hc.limitReachedUpgradeToA": "Límite alcanzado — actualiza a un plan superior",
"hc.linkCopiedShareOn": "Enlace copiado — compártelo en {label}",
"hc.linkUnavailable": "Enlace no disponible",
"hc.linkedTo": "Vinculado a",
"hc.listingHiddenByModeration": "Listado oculto por moderación.",
"hc.loading": "Cargando…",
"hc.locateMe": "Localízame",
"hc.logIn": "Iniciar sesión",
"hc.logInToGetBack": "Inicia sesión para volver a tu espacio y gestionar tu suscripción.",
"hc.loginFailed": "Error en el inicio de sesión",
"hc.lostFoundPlatform": "Plataforma de objetos perdidos y encontrados.",
"hc.lostIn": "perdido en",
"hc.lowRate": "Baja tasa",
"hc.mainReason": "Razón principal",
"hc.mainStreet": "Calle Principal",
"hc.makeSureThisIsThe": "Asegúrate de que este es el artículo que perdiste antes de desbloquear los datos de contacto del hallador.",
"hc.manageCookies": "Gestionar cookies",
"hc.manageMyTeam": "Gestionar mi equipo",
"hc.manageYourTeam": "Gestionar tu equipo",
"hc.markAsReturned": "Marcar como devuelto",
"hc.matchNoClaimInTime": "La coincidencia no recibió reclamaciones dentro del plazo.",
"hc.matchNotFound": "Coincidencia no encontrada",
"hc.medium": "Medio",
"hc.milestoneFmt": "{m} hitos de artículos devueltos alcanzados! En camino a {next}.",
"hc.missingFeatures": "Funciones faltantes",
"hc.monthly": "Mensual",
"hc.monthlyBilling": "Facturación mensual",
"hc.moveThePhotoToFit": "Mueve la foto para ajustarla en el círculo.",
"hc.myAccount": "Mi cuenta",
"hc.myInvoices": "Mis facturas",
"hc.myMonthlyInvoices": "Mis facturas mensuales",
"hc.nArchived": "{n} anuncio(s) archivado(s).",
"hc.newCodeGeneratedAndSent": "Nuevo código generado y enviado al cliente por correo electrónico y SMS",
"hc.newCodeGeneratedAndSent2": "Nuevo código generado y enviado al propietario",
"hc.newPassword": "Nueva contraseña",
"hc.next": "Siguiente",
"hc.nextPhoto": "Foto siguiente",
"hc.no": "No",
"hc.noAnswerProvided": "No se proporcionó respuesta.",
"hc.noArchivedDeclarations": "No hay declaraciones archivadas",
"hc.noCountryFound": "No se encontró ningún país",
"hc.noDeclarations": "No hay declaraciones",
"hc.noFeesAreChargedTo": "No se cobran tarifas al cliente.",
"hc.noInvoiceYet": "No hay factura aún.",
"hc.noInvoiceYetYourInvoices": "No hay factura aún. Tus facturas aparecerán aquí automáticamente después de cada pago.",
"hc.noMatchIsAvailableFor": "No hay coincidencia disponible por ahora. Te informaremos tan pronto como un artículo coincida con tu declaración.",
"hc.noShipmentMatchesYourSearch": "Ningún envío coincide con tu búsqueda.",
"hc.noShipmentsYet": "No hay envíos aún.",
"hc.noShipmentsYet2": "No hay envíos aún",
"hc.none": "ninguno",
"hc.noneChooseForEachShipment": "Ninguno (elegir para cada envío)",
"hc.notMine": "No es mío",
"hc.of": "de",
"hc.only": "Solo",
"hc.onlyEachSiteManagesIts": "solo. Cada sitio gestiona su propio banco: estos enlaces no afectan a ningún otro establecimiento.",
"hc.onlyTheOwnerOrAn": "Solo el propietario o un administrador pueden configurar los enlaces de pago del establecimiento.",
"hc.openDepositInTheMenu": "Abre \"Depósito\" en el menú, describe el artículo y toma una foto. Se almacena inmediatamente y está listo para ser devuelto.",
"hc.openSettings": "Abrir Configuración →",
"hc.openTheDeclarationToManage": "Abre la declaración para gestionar el envío",
"hc.optional": "— opcional",
"hc.optional2": "(opcional)",
"hc.optional3": "opcional",
"hc.originalListingPhotoUsed": "Foto de anuncio original utilizada",
"hc.other": "Otro",
"hc.other2": "Otro…",
"hc.ourProducts": "Nuestros productos",
"hc.overallRateTrendLast6": "Tendencia general de tarifas (últimos 6 meses)",
"hc.ownerSClaimCode": "Código de reclamación del propietario",
"hc.ownershipConfirmed": "Propiedad confirmada",
"hc.paid": "Pagado",
"hc.paidOn": "Pagado el",
"hc.paidViaPartner": "Pagado (a través de un socio)",
"hc.parcelBeingPrepared": "Paquete en preparación",
"hc.parcelDelivered": "Paquete entregado",
"hc.parcelShipped": "Paquete enviado",
"hc.parisGareDeLyon": "París, Gare de Lyon…",
"hc.partner": "Socio",
"hc.partner2": "socio",
"hc.partnerDirectory": "Directorio de socios",
"hc.passedOnToTheCustomer": "— pasado al cliente el enlace de pago.",
"hc.password": "Contraseña",
"hc.passwordResetPleaseLogIn": "Restablecimiento de contraseña, por favor inicie sesión.",
"hc.passwordUpdated": "Contraseña actualizada.",
"hc.passwordsDoNotMatch": "Las contraseñas no coinciden.",
"hc.pasteThisSenderIdIn": "Pegue este ID de remitente en Findloop → Configuraciones",
"hc.payForTheShipmentOf": "Pague por el envío de su artículo a través de Findloop con un pago seguro.",
"hc.payTheRecoveryFees": "Pague las tarifas de recuperación",
"hc.payTheShippingFees": "Pague las tarifas de envío",
"hc.payment": "Pago",
"hc.paymentAlreadyConfirmedByThe": "Pago ya confirmado por el socio",
"hc.paymentLinksAreNowConfigured": "Los enlaces de pago ahora están configurados por establecimiento",
"hc.paymentNotCompletedYourAccount": "Pago no completado, su cuenta no ha sido creada — por favor intente de nuevo.",
"hc.paymentReceived": "Pago recibido",
"hc.paymentSuccessful": "¡Pago exitoso!",
"hc.pdfInvoice": "Factura PDF",
"hc.pending": "Pendiente",
"hc.period": "Período",
"hc.phoneNumber": "Número de teléfono",
"hc.phoneOptional": "Teléfono (opcional)",
"hc.planAt": "plan en",
"hc.planLimitFmt": "Su plan \"{plan}\" está limitado a {max} establecimientos. Para gestionar {n} sitios, recomendamos el",
"hc.platformReturnTarget": "Objetivo de retorno de la plataforma",
"hc.pleaseCompleteYourShippingAddress": "Por favor complete su dirección de envío.",
"hc.pleaseProvideAPhoneNumber": "Por favor proporcione un número de teléfono: es requerido por el transportista para el envío.",
"hc.pleaseProvideAReason": "Por favor proporcione una razón.",
"hc.pleaseSetYourOwnPassword": "por favor establezca su propia contraseña antes de continuar.",
"hc.pointsToGoal": "{n} puntos más para alcanzar nuestro objetivo compartido.",
"hc.posterPreview": "Vista previa del cartel",
"hc.potentialMatchBeingVerified": "Coincidencia potencial siendo verificada",
"hc.potentialOwner": "Propietario potencial",
"hc.preFilledAutomaticallyYouCan": "Pre-llenado automáticamente — puede reemplazarlo con una foto del paquete.",
"hc.pressKit": "Kit de prensa",
"hc.previewMode": "Modo de vista previa:",
"hc.previewOfThePrintReady": "Vista previa del cartel A4 listo para imprimir para este establecimiento.",
"hc.previous": "Anterior",
"hc.previousPhoto": "Foto anterior",
"hc.primary": "primario",
"hc.printThePoster": "Imprimir el cartel",
"hc.privacy": "Privacidad",
"hc.privacyPolicy": "Política de privacidad",
"hc.processedCasesWillAppearHere": "Los casos procesados aparecerán aquí.",
"hc.proofOfReturnPdf": "Prueba de devolución (PDF)",
"hc.protectedByRecaptcha": "Protegido por reCAPTCHA",
"hc.publicMatch": "Coincidencia pública",
"hc.putBackInStorage": "Devolver al almacenamiento",
"hc.pwdResetByTeam": "Tu contraseña fue restablecida por nuestro equipo. Para tu seguridad,",
"hc.questionsToAskTheOwner": "Preguntas para hacerle al propietario",
"hc.rateChargedToTheCustomer": "Tarifa cobrada al cliente:",
"hc.rateOfTarget": "{rate}% alcanzado de un objetivo del {target}%",
"hc.reached": "alcanzado",
"hc.reactivating": "Reactivando…",
"hc.reasonSavedYouCanStill": "Razón guardada. Aún puedes reclamar tu artículo.",
"hc.recentMatchesFirst": "Primeras coincidencias recientes",
"hc.recognizedThePhotoYouSent": "reconoció la foto que enviaste y describió estas características. Solo confirma si coinciden con el artículo en tu posesión.",
"hc.recommended": "Recomendado",
"hc.recoveryFees": "Tarifas de recuperación",
"hc.recoveryFeesArePaidDirectly": "Las tarifas de recuperación se pagan directamente al establecimiento asociado. Findloop no recibe ningún pago de los clientes.",
"hc.recoveryFeesEnabled": "Tarifas de recuperación habilitadas",
"hc.recoveryOfferedByTheEstablishment": "Recuperación ofrecida por el establecimiento — Findloop no cobra tarifas.",
"hc.recoveryPaymentLink": "Enlace de pago de recuperación",
"hc.recoveryPaymentLinkSavedFor": "Enlace de pago de recuperación guardado para este establecimiento",
"hc.redirecting": "Redirigiendo…",
"hc.redirectingToPayment": "Redirigiendo al pago…",
"hc.redirectingToTheRecoveryOf": "Redirigiendo a la recuperación de tu artículo…",
"hc.regenerateAndResendToThe": "Regenerar y reenviar al propietario",
"hc.regenerateTheCode": "Regenerar el código",
"hc.registerAFoundItem": "Registrar un artículo encontrado",
"hc.rejectTheClaim": "Rechazar la reclamación",
"hc.reminderDelaySaved": "Retraso de recordatorio guardado",
"hc.reopenThePaymentLink": "Reabrir el enlace de pago",
"hc.repeatThePassword": "Repite la contraseña",
"hc.reportAProblem": "Reportar un problema",
"hc.reportDismissedYourListingRemains": "Reporte desestimado. Su anuncio sigue siendo público.",
"hc.requiredUsedToCalculateThe": "Requerido: usado para calcular la tarifa de envío de Sendcloud. Envío no disponible por encima de 30 kg.",
"hc.reset": "Reiniciar",
"hc.resume": "Reanudar",
"hc.resumeRegistration": "Reanudar registro",
"hc.retro": "Año en revisión",
"hc.returnSecurity": "Seguridad de devolución",
"hc.returnToTheOwner": "Devolver al dueño",
"hc.returned": "devuelto",
"hc.reviewTheItemDetails": "Revisar los detalles del artículo",
"hc.revokeAccess": "Revocar acceso",
"hc.role": "Rol:",
"hc.save": "Guardar",
"hc.save2": "guardar",
"hc.saveAndContinue": "Guardar y continuar",
"hc.saving": "Guardando…",
"hc.scanTheClaimCode": "Escanear el código de reclamo",
"hc.scanTheOwnerSQr": "Escanear el QR del dueño",
"hc.scrollThroughLanguages": "Desplazarse por los idiomas",
"hc.searchByCustomerItemOr": "Buscar por cliente, artículo o número de seguimiento…",
"hc.searchForACountry": "Buscar un país…",
"hc.secureFindoVerification": "Verificación segura de Findloop",
"hc.seeRetro": "Ver el año en revisión",
"hc.selectedCarrier": "Transportista seleccionado:",
"hc.selectedPlan": "Plan seleccionado",
"hc.send": "Enviar",
"hc.sendcloudSenderIdSaved": "ID de remitente de Sendcloud guardado",
"hc.sendcloudSenderIdSenderId": "ID de remitente de Sendcloud (sender_id)",
"hc.sending": "Enviando…",
"hc.sessionExpired": "Sesión expirada",
"hc.setUpYourEstablishments": "Configurar sus establecimientos",
"hc.settings": "Configuraciones",
"hc.settingsSubtitle": "Pagos y recordatorios externos, configurados por establecimiento.",
"hc.shareFoundText": "Encontré un artículo — ayúdame a encontrar su dueño en Findloop",
"hc.shareLostText": "Perdí un artículo — ayúdame a encontrarlo en Findloop",
"hc.sharePreview": "Compartir vista previa",
"hc.shareTheRanking": "Compartir la clasificación",
"hc.shareYourQrCodeTo": "Comparte tu código QR para recibir declaraciones.",
"hc.shipRateAutoWeight": "La tarifa de envío se calcula automáticamente a través de Sendcloud (peso {w}) en el momento del envío.",
"hc.shipRateForWeight": "Tarifa de envío (Sendcloud + {m}% de margen) para {w}:",
"hc.shipments": "Envíos",
"hc.shipmentsSubtitle": "Vista consolidada de todos los envíos del establecimiento, en todos los casos. Haz clic en una fila para gestionar el envío en su declaración.",
"hc.shipping": "Envío",
"hc.shippingAddress": "Dirección de envío",
"hc.shippingFeesAreHandledAutomatically": "Las tarifas de envío son gestionadas automáticamente por Findloop (Sendcloud) — no hay enlace que ingresar.",
"hc.shippingFeesHaveAlreadyBeen": "Las tarifas de envío ya han sido pagadas: el transportista ya no puede ser cambiado.",
"hc.shippingNotAvailableForItems": "Envío no disponible para artículos de más de 30 kg. El cliente tendrá que recoger el artículo en persona.",
"hc.shippingPaid": "Envío pagado ✓",
"hc.showOnlyItemsMatchingA": "Mostrar solo artículos que coincidan con un anuncio público (cliente)",
"hc.showPassword": "Mostrar contraseña",
"hc.signInTheBoxAbove": "Inicia sesión en el cuadro de arriba",
"hc.signatureSaved": "Firma guardada",
"hc.signedInWithGoogle": "Iniciado sesión con Google",
"hc.signupFailed": "El registro falló",
"hc.silver": "Plata",
"hc.simulatedRatesInPreProduction": "(tarifas simuladas en pre-producción)",
"hc.siretAndVatNumberRequired": "Número SIRET y de IVA requerido (Francia).",
"hc.skip": "Saltar",
"hc.smsSentIfAccount": "Si existe una cuenta con este número, se te ha enviado un SMS.",
"hc.sortItemsWithAPublic": "Ordenar: artículos con una coincidencia pública (más reciente) primero",
"hc.specifyWhetherYouRecoveredYour": "Especifica si recuperaste tu artículo o simplemente deseas eliminar este anuncio.",
"hc.specifyYourReason": "Especifica tu razón",
"hc.specifyYourReason2": "Especifica tu razón…",
"hc.staff": "Personal",
"hc.status": "Estado",
"hc.staySignedIn": "Mantenerse conectado",
"hc.step": "Paso",
"hc.stillThere": "¿Todavía allí?",
"hc.stopScrolling": "Dejar de desplazarse",
"hc.storeFindWithQr": "Almacenar y encontrar con QR",
"hc.streetName": "Nombre de la calle",
"hc.streetNo": "Número de la calle",
"hc.switchTo": "Cambiar a",
"hc.switchToDarkMode": "Cambiar a modo oscuro",
"hc.switchToLightMode": "Cambiar a modo claro",
"hc.takeAPhoto": "Tomar una foto",
"hc.takeChangeThePhoto": "Tomar / cambiar la foto",
"hc.takenFromYourDeclaration": "tomado de tu declaración",
"hc.target": "Objetivo",
"hc.targetReached": "Objetivo alcanzado",
"hc.targetReachedThankYouTo": "Objetivo alcanzado — gracias a toda la comunidad de Findloop!",
"hc.tellUsMore": "Cuéntanos más…",
"hc.tellUsWhyYouCancel": "Cuéntanos por qué estás cancelando. Esto ayuda al socio a procesar tu solicitud.",
"hc.tellUsWhyYourListing": "Cuéntanos por qué. Tu anuncio permanece activo y puedes seguir reclamando tu artículo.",
"hc.termsAndConditions": "Términos y condiciones",
"hc.termsAndPolicies": "Términos y políticas",
"hc.thankYouForYourFeedback": "Gracias por tu feedback",
"hc.theBannerDisplayedInThe": "el banner mostrado en el registro.",
"hc.theClaimantHasBeenInformed": "El reclamante ha sido informado. El artículo permanece disponible en el listado público.",
"hc.theClaimantHasBeenNotified": "El reclamante ha sido notificado y ahora puede proceder con la devolución.",
"hc.theCustomerPaysTheFees": "El cliente paga las tarifas al establecimiento.",
"hc.theDayTheLegalRetention": "El día que se alcanza el período legal de retención.",
"hc.theEstablishmentConsideredThatThis": "El establecimiento consideró que este artículo no es tuyo.",
"hc.theEstablishmentIsReviewingYour": "El establecimiento está revisando tus respuestas. Se te notificará tan pronto como se valide tu reclamación, luego podrás pagar las tarifas de recuperación.",
"hc.theFeesAreTooHigh": "Las tarifas son demasiado altas",
"hc.theFinderConsideredThatThis": "El buscador consideró que este artículo no es tuyo.",
"hc.theFinderIsReviewingYour": "El buscador está revisando tu reclamación. Se te notificará tan pronto como se valide.",
"hc.theItem": "El artículo",
"hc.theItemWillBeRemoved": "El artículo será eliminado del registro (sin reclamación en curso).",
"hc.theItemWillBeSet": "El artículo será devuelto a \"en stock\" y la reclamación relacionada cancelada.",
"hc.theKbisNumberAndVat": "El número Kbis y el número de IVA son requeridos para Francia.",
"hc.theLabelIsGeneratedAutomatically": "La etiqueta se genera automáticamente tan pronto como el cliente ha pagado las tarifas de envío. Se podrá descargar aquí.",
"hc.theLinkMayHaveExpired": "El enlace puede haber expirado (válido por 30 días). Contacta con el soporte de Findloop si es necesario.",
"hc.theOwnerDescribesTheirItem": "El propietario describe su artículo",
"hc.theOwnerReceivedItBy": "El propietario lo recibió por correo electrónico (o SMS). Ingresa o escanea antes de la entrega.",
"hc.thePartnerConsideredThatThis": "El socio consideró que este artículo no es tuyo. El artículo permanece disponible.",
"hc.thePartnerIsReviewingYour": "El socio está revisando tus respuestas. Se te notificará tan pronto como se valide tu reclamación.",
"hc.theShipmentIsCreatedAutomatically": "El envío se crea automáticamente una vez que el cliente ha confirmado su dirección y pagado las tarifas de recuperación. La etiqueta se generará automáticamente después del pago del envío y se podrá descargar aquí.",
"hc.theShippingRateWillBe": "La tarifa de envío se calculará automáticamente a través de Sendcloud en el momento del envío (peso registrado).",
"hc.thisCarrierWillBe": "Este transportista será",
"hc.thisEstablishment": "este establecimiento",
"hc.thisFieldIsRequiredFor": "Este campo es obligatorio para la generación automática de etiquetas.",
"hc.thisIsMyItem": "Este es mi artículo",
"hc.thisIsMyItemContinue": "Este es mi artículo — continuar",
"hc.thisIsMyItemStart": "Este es mi artículo — iniciar la devolución",
"hc.thisIsNotMyItem": "Este no es mi artículo",
"hc.thisMatchIsNoLonger": "Esta coincidencia ya no está disponible o ya ha sido procesada.",
"hc.thisRateWillBeCharged": "Esta tarifa será cobrada al cliente. Una tarifa alta puede desalentar la recuperación.",
"hc.thisStepIsRequiredFor": "Este paso es necesario para que se generen las etiquetas de envío.",
"hc.thisValidationLinkIsInvalid": "Este enlace de validación es inválido o ha expirado.",
"hc.toCheckBeforeMarkingThe": "Para verificar antes de marcar el artículo como devuelto.",
"hc.toConfigureTheLinksAnd": "para configurar los enlaces y el retraso de recordatorio para cada establecimiento.",
"hc.toReachOurFirstMilestone": "para alcanzar nuestro primer hito de 100 devoluciones.",
"hc.toTheCustomer": "al cliente.",
"hc.toTheShippingFeePayment": "al pago de la tarifa de envío.",
"hc.toYourRecoveryTracking": "a tu seguimiento de recuperación.",
"hc.tooExpensiveBudget": "Demasiado caro / presupuesto",
"hc.topCitiesForReturns": "Principales ciudades para devoluciones",
"hc.trackMyRecovery": "Rastrear mi recuperación",
"hc.trackTheShipmentAndDownload": "Rastrear el envío y descargar la etiqueta (generada automáticamente) sin salir de la pestaña de Declaraciones.",
"hc.trackYourStatistics": "Rastrear tus estadísticas",
"hc.tracking": "Rastreo",
"hc.unableToOpenTheShipping": "No se puede abrir el pago de la tarifa de envío. Por favor, inténtalo de nuevo.",
"hc.unableToRetrieveTheInvoice": "No se puede recuperar la factura.",
"hc.unclaimed": "No reclamado",
"hc.unclaimedCustomerReason": "Artículo no reclamado. Motivo del cliente: \"{reason}\".",
"hc.unclaimedItem": "Artículo no reclamado",
"hc.unclaimedItemNoClaimWithin": "Artículo no reclamado — sin reclamación dentro del plazo.",
"hc.unclaimedItems": "Artículos no reclamados",
"hc.unclaimedItemsMatchLeftWithout": "Artículos no reclamados: coincidencias dejadas sin una reclamación dentro del plazo. Puedes volver a guardarlos.",
"hc.unlockTheFinderSContact": "Desbloquear los detalles de contacto del encontrador para organizar la entrega.",
"hc.upcoming": "Próximamente",
"hc.updateFailed": "Actualización fallida.",
"hc.usedForInvoices": "Utilizado para emitir tus facturas de findloop.",
"hc.vatNumber": "Número de IVA",
"hc.verificationPending": "Verificación pendiente",
"hc.verificationSentToTheFinder": "Verificación enviada al encontrador. Serás notificado de su decisión.",
"hc.verificationSentToThePartner": "Verificación enviada al socio. Serás notificado de su decisión.",
"hc.verify": "Verificar",
"hc.verifyingInvite": "Verificando el enlace de invitación…",
"hc.verifyingTheLink": "Verificando el enlace…",
"hc.viewInRegistry": "Ver en el registro",
"hc.viewItem": "Ver artículo",
"hc.viewItemRecover": "Ver artículo y recuperar",
"hc.visibleToTheOwnerAutomatically": "Visible para el propietario · eliminado automáticamente después de 60 días.",
"hc.waitingForPartnerConfirmation": "Esperando la confirmación del socio",
"hc.waitingForThePartnerS": "Esperando la confirmación del socio",
"hc.weHaveInformedTheEstablishment": "Hemos informado al establecimiento que este artículo no es tuyo y reiniciado el análisis. Serás notificado tan pronto como se encuentre una nueva coincidencia.",
"hc.weHaveInformedThePartner": "Hemos informado al socio que este artículo no es tuyo. Tu listado permanece activo para coincidencias futuras.",
"hc.weRanTheAnalysisAgain": "Hemos realizado el análisis nuevamente y hemos identificado otro artículo que podría ser tuyo. Por favor, revísalo de nuevo.",
"hc.weight": "Peso",
"hc.weightNotProvidedTheShipping": "Peso no proporcionado: la tarifa de envío se calculará en el momento del envío.",
"hc.weightUnit": "Unidad de peso",
"hc.welcome": "¡Bienvenido!",
"hc.welcomeToFindo": "Bienvenido a Findloop",
"hc.whenACustomerComesTo": "Cuando un cliente viene a recoger sus pertenencias, abre su declaración y valida la devolución. ¡Eso es todo!",
"hc.whenDisabledFeesDropTo": ". Cuando está desactivado, las tarifas caen a",
"hc.whyIsThisNotYour": "¿Por qué no es tu artículo?",
"hc.willBeMarkedAs": "será marcado como",
"hc.wrongColor": "Color incorrecto",
"hc.wrongModel": "Modelo incorrecto",
"hc.yesCancel": "Sí, cancelar",
"hc.yesContactTheFinder": "Sí, contactar al hallador",
"hc.youAreHere": "Estás aquí",
"hc.youBusinessCom": "tú@negocio.com",
"hc.youCanNowStartThe": "Ahora puedes comenzar la devolución.",
"hc.youCanStillChangeIt": ". Aún puedes cambiarlo caso por caso.",
"hc.youHaveAlreadyConfirmedThat": "Ya has confirmado que este es tu artículo.",
"hc.youWillBeRedirectedTo": "Serás redirigido al pago seguro de Stripe.",
"hc.yourAccountHasBeenReactivated": "Tu cuenta ha sido reactivada.",
"hc.yourAccountIsActiveYou": "Tu cuenta está activa, ahora puedes gestionar tus establecimientos.",
"hc.yourEstablishment": "Tu establecimiento",
"hc.yourFeedbackHelpsUsImprove": "Tu opinión nos ayuda a mejorar nuestras coincidencias.",
"hc.yourFeedbackHelpsUsRestart": "Tu opinión nos ayuda a reiniciar el análisis y mejorar nuestras coincidencias.",
"hc.yourFirstSteps": "Tus primeros pasos",
"hc.yourFirstStepsAdmin": "Tus primeros pasos (admin)",
"hc.yourItemHasBeenHanded": "Tu artículo ha sido entregado en persona por el socio; cierra el caso una vez que se confirme la entrega.",
"hc.yourItemHasBeenShipped": "Tu artículo ha sido enviado por el socio; cierra el caso una vez que se confirme la entrega.",
"hc.yourPaymentHasBeenRecorded": "Tu pago ha sido registrado.",
"hc.yourShipmentIsBeingPrepared": "Tu envío está siendo preparado. Recibirás tu paquete en un plazo de 3 a 5 días hábiles.",
"hc.yourShippingFeesHaveAlready": "Tus tarifas de envío ya han sido pagadas. Envío pagado ✓",
"hc.yourShippingFeesHaveBeen": "Tus tarifas de envío han sido pagadas. Tu paquete está siendo preparado.",
"hc.yourVerificationQuestionsDeposit": "Tus preguntas de verificación (depósito)",
"home.recentAdsAll": "Ver todas las listas",
"home.recentAdsEyebrow": "En este momento",
"home.recentAdsSubtitle": "Artículos perdidos y encontrados reportados por la comunidad.",
"home.recentAdsTitle": "Últimas listas",
"home.reunions": "Reuniones recientes",
"home.videoEyebrow": "Ver",
"home.videoSubtitle": "Cómo reunimos artículos perdidos con sus dueños, sin esfuerzo.",
"home.videoTitle": "Descubre Findloop en 2 minutos",
"home.watchYoutube": "Ver en YouTube",
"impact.already": "Ya",
"impact.citiesWord": "ciudad/ciudades",
"impact.eachPoint": "Cada punto es una ciudad donde Findloop ayuda a recuperar artículos perdidos.",
"impact.emptyMap": "El mapa se llena a medida que ocurren las restituciones.",
"impact.eyebrow": "Nuestro impacto",
"impact.inCities": "a través de",
"impact.restitutedTo": "artículos devueltos a sus dueños",
"impact.title": "Artículos devueltos, en todas partes cerca de ti",
"inv2.download": "Descargar",
"inv2.view": "Ver",
"map.objectsOnMapPlural": "artículos en el mapa",
"map.objectsOnMapSingular": "artículo en el mapa",
"mc.claimConfirmDesc": "Revisa el artículo encontrado por el buscador antes de pagar para desbloquear sus datos de contacto.",
"mc.claimConfirmNo": "Este no es mi artículo",
"mc.claimConfirmTitle": "¿Es este realmente tu artículo?",
"mc.claimConfirmYes": "Sí, es mío — pagar",
"mc.claimFinderContacts": "Datos de contacto del buscador",
"mc.claimNotMineDone": "Gracias — el buscador ha sido notificado y tu solicitud fue eliminada del anuncio.",
"mc.claimUnlockDesc": "Paga la tarifa de gestión de Findloop para obtener los datos de contacto de la persona que encontró tu artículo.",
"mc.claimUnlockTitle": "Desbloquear los datos de contacto del buscador",
"mc.hideCountryOffers": "Ocultar ofertas en mi país",
"mc.myClaims": "Artículos que estoy reclamando",
"mc.myClaimsSub": "Artículos encontrados por otros que estás reclamando. Desbloquea los datos de contacto del buscador para coordinar la entrega.",
"mc.notifAdCancelled": "Anuncio cancelado",
"mc.notifCancelAd": "Cancelar mi anuncio",
"mc.offersInCountry": "Ofertas en mi país",
"mc.offersInCountryDesc": "Todas las recompensas activas de socios en tu país, por ciudad.",
"mc.redArchived": "Archivado",
"mc.rewardsCountryNone": "Aún no hay oferta en tu país.",
"mc.rewardsForYou": "Recompensas para ti",
"mc.rewardsForYouDesc": "Ofrecidas por el(los) socio(s) donde dejaste un artículo.",
"mc.rewardsMineNone": "Aún no hay recompensa de tus socios de entrega.",
"mc.showCountryOffers": "Ver ofertas en mi país",
"mc2.cancelDecl": "Cancelar mi declaración",
"mc2.cancelDeclDone": "Declaración cancelada.",
"pricing.physInvDesc": "Cuando un artículo es devuelto, su ubicación se libera automáticamente y está disponible para un nuevo artículo.",
"pricing.physInvTitle": "Seguimiento del inventario físico",
"pricing.physModalTitle": "Gestión de artículos físicos",
"pricing.physQrDesc": "Se genera un código QR único por artículo que enlaza a toda su información.",
"pricing.physQrTitle": "Etiqueta QR dedicada",
"pricing.physShelfDesc": "Cada artículo registrado puede ser asignado a una ubicación física dentro del establecimiento.",
"pricing.physShelfTitle": "Plan de estantes",
"pricing.physicalMgmt": "Gestión de artículos físicos (estantes, QR, inventario)",
"pub.addSecondPhoto": "Agregar una 2ª foto (opcional)",
"pub.photo2Added": "✓ 2ª foto agregada",
"reg.dispositionJournal": "Diario de disposiciones",
"reg.dispositionNoteAuthHint": "ℹ️ Se requiere una nota para “Entregado a las autoridades” (número de reporte, departamento…).",
"reg.dispositionNotePh": "Nota (opcional): organización benéfica receptora, referencia de autoridades, nombre del comprador…",
"reg.dispositionNoteRequired": "Se requiere una referencia oficial para entregar a las autoridades.",
"reg.legalPrealert": "Plazo legal en {days} día(s)",
"reg.legalPrealertOptions": "Opciones al vencimiento: venta en subasta, donación a una organización benéfica, entrega a las autoridades.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Revisión completa",
"rev.readMore": "Leer más",
"rw.activeCodes": "Vouchers activos",
"rw.archived": "Archivado",
"rw.archivedTitle": "Vouchers canjeados (archivados)",
"rw.hideArchived": "Ocultar vouchers canjeados",
"rw.noArchived": "No hay vouchers archivados.",
"rw.showArchived": "Mostrar vouchers canjeados",
"shp.labelAuto": "La etiqueta se genera automáticamente tan pronto como el cliente ha pagado las tarifas de envío. Se podrá descargar aquí.",
"stt.dispoPdfBtn": "Exportar PDF",
"stt.dispoPdfError": "Error en la exportación del PDF.",
"stt.dispoPdfExporting": "Exportando…",
"trk.matchVerifying": "Posible coincidencia siendo verificada",
"hc.and": "y",
"hc.demoObj0": "una billetera",
"hc.demoObj1": "una mochila deportiva",
"hc.demoObj2": "un teléfono",
"hc.demoObj3": "un par de gafas",
"hc.demoObj4": "un juego de llaves",
"hc.demoObj5": "una bufanda",
"hc.demoObj6": "una computadora portátil",
"hc.demoObj7": "una botella de agua",
"hc.demoWhen0": "hace 2 horas",
"hc.demoWhen1": "hace 5 horas",
"hc.demoWhen2": "ayer",
"hc.demoWhen3": "hace 3 horas",
"hc.demoWhen4": "esta mañana",
"hc.demoWhen5": "hace 1 día",
"hc.feedDemo": "{obj} fue devuelto en {city} {when}.",
"hc.feedReal": "Un artículo ({cat}) fue devuelto en {city}.",
"hc.saveBtn": "Guardar",
"hc.saveLink": "Guardar enlace",
"hc.terms": "Términos",
"hc.view": "Ver",
"pcat.airline": "Aerolínea",
"pcat.airport": "Aeropuerto",
"pcat.amusement_park": "Parque de atracciones",
"pcat.bank": "Banco",
"pcat.bar_cafe": "Bar / Café",
"pcat.beauty_salon": "Salón de pelo / Belleza",
"pcat.cinema": "Cine",
"pcat.concert_theater": "Sala de conciertos / Teatro",
"pcat.coworking": "Espacio de coworking",
"pcat.gym_fitness": "Gimnasio / Fitness",
"pcat.hospital_clinic": "Hospital / Clínica",
"pcat.library": "Biblioteca",
"pcat.mall": "Centro comercial",
"pcat.museum": "Museo",
"pcat.pharmacy": "Farmacia",
"pcat.private_company": "Empresa privada",
"pcat.public_transport": "Transporte público",
"pcat.school_university": "Escuela / Universidad",
"pcat.sports_center": "Centro deportivo",
"pcat.stadium_arena": "Estadio / Arena",
"pcat.supermarket": "Supermercado",
"pcat.taxi_vtc": "Taxi / Transporte a pedido",
"pcat.tourism_office": "Oficina de turismo",
"pcat.train_bus_station": "Estación de tren / autobús",
"pcat.travel_agency": "Agencia de viajes",
"an.found": "Encontrado",
"an.lost": "Perdido",
"hc.shareReview": "Comparte la reseña",
"hc.citiesAboveTarget": "{n} ciudades por encima de su objetivo",
"hc.cityAboveTarget": "{n} ciudad por encima de su objetivo",
"hc.j15EarlyReminder": "Recordatorio anticipado D-15",
"hc.j7EarlyReminder": "Recordatorio anticipado D-7",
"hc.annualTotal": "Total anual",
"hc.billedOnceYear": "Cargado una vez por 12 meses, renovado cada año.",
"hc.monthlyPrice": "Precio mensual",
"hc.perMonth": "/ mes",
"hc.perYear": "/ año",
"hc.billedEachMonth": "Cargado automáticamente cada mes.",
"nav.business": "Negocios",
"nav.individual": "Individual",
"hc.circumstancesFound": "Circunstancias del hallazgo",
"hc.circumstancesFoundPh": "Ej. encontrado en el suelo cerca de la entrada del metro",
"hc.circumstancesLost": "Circunstancias de la pérdida",
"hc.circumstancesLostPh": "Ej. dejado en un banco mientras esperaba el autobús",
"hc.conditionPh": "Ej. bueno, rallado…",
"hc.firstName": "Nombre",
"hc.lastName": "Apellido",
"hc.quantity": "Número de artículos",
"fa.approve": "Aprobar",
"fa.approveConfirm": "¿Aprobar esta declaración? Se intercambiarán tus datos de contacto (nombre, correo, teléfono) con el buscador.",
"fa.approved": "Declaración aprobada — datos de contacto intercambiados",
"fa.approvedFinder": "El propietario aprobó tu declaración",
"fa.approvedFinderText": "Contáctalos para organizar la devolución.",
"fa.boostSub": "Tu anuncio permanece en la parte superior durante la duración elegida.",
"fa.boostTitle": "Impulsar mi anuncio (opcional)",
"fa.colFinder": "Declaración del buscador",
"fa.colYours": "Tu declaración",
"fa.compareHint": "Compara la declaración del buscador con la tuya antes de decidir.",
"fa.contribNone": "Sin contribución",
"fa.contribPaid": "Contribución recibida — ¡gracias!",
"fa.contribPending": "Contribución pendiente de pago",
"fa.contribSub": "Apoya a Findloop para ayudar a más personas a recuperar sus pertenencias. Puedes elegir €0.",
"fa.contribSuccessMsg": "Tu declaración ha sido enviada al propietario.",
"fa.contribSuccessTitle": "Gracias por tu contribución",
"fa.contribTitle": "Contribución voluntaria",
"fa.days3": "3 días",
"fa.days30": "30 días",
"fa.days7": "7 días",
"fa.declSub": "Describe el artículo que encontraste. El propietario comparará tu declaración con la suya.",
"fa.declTitle": "Encontré este artículo",
"fa.expiresOn": "Expira el",
"fa.fBrand": "Marca",
"fa.fCircumstances": "Circunstancias",
"fa.fCity": "Ciudad",
"fa.fColor": "Color",
"fa.fCondition": "Condición",
"fa.fDate": "Fecha",
"fa.fMessage": "Mensaje del buscador",
"fa.fPlace": "Lugar",
"fa.fQuantity": "Cantidad",
"fa.finderContact": "Datos de contacto del buscador",
"fa.finishPay": "Completar pago",
"fa.foundDate": "Fecha encontrada",
"fa.foundPlace": "Lugar encontrado",
"fa.hours24": "24 horas",
"fa.ht": "excl. IVA",
"fa.months3": "3 meses",
"fa.noBoost": "Sin impulso",
"fa.ownerContact": "Detalles de contacto del propietario",
"fa.payPublish": "Pagar y publicar",
"fa.pendingPayText": "Tu anuncio estará en vivo tan pronto como se confirme el pago.",
"fa.pendingPayTitle": "Pago pendiente",
"fa.planSub": "Tu anuncio estará en vivo tan pronto como se confirme el pago.",
"fa.planTitle": "Duración del anuncio",
"fa.pubSuccessMsg": "Tu anuncio está en vivo. Te notificaremos tan pronto como un buscador se presente.",
"fa.pubSuccessTitle": "Anuncio publicado",
"fa.publicNote": "Solo se muestran públicamente la descripción, ciudad, país y fotos.",
"fa.redirectStripe": "Redirigiendo a pago seguro…",
"fa.reject": "Rechazar",
"fa.rejectConfirm": "¿Rechazar esta declaración? Tu anuncio permanecerá en línea.",
"fa.rejected": "Declaración rechazada",
"fa.rejectedFinder": "No era el artículo que estaban buscando",
"fa.rejectedFinderText": "El propietario dice que este artículo no es suyo. ¡Gracias por tu ayuda!",
"fa.responsesTitle": "Declaraciones de buscadores",
"fa.sent": "Declaración enviada al propietario.",
"fa.submitDecl": "Enviar mi declaración",
"fa.submitDeclPay": "Enviar y contribuir {amount}",
"fa.total": "Total a pagar",
"fa.ttc": "incl. IVA",
"fa.waitClaimText": "El buscador está revisando tu solicitud. Te notificaremos de su decisión.",
"fa.waitFinderText": "Te informaremos tan pronto como un buscador envíe una declaración.",
"fa.waitFinderTitle": "Tu anuncio está en vivo",
"fa.waitOwnerText": "El propietario está comparando tu declaración con la suya. Te notificaremos de su decisión.",
"fa.waitOwnerTitle": "Esperando la decisión del propietario",
"st.pending_payment": "Pago pendiente",
"fa.africaFree": "Listado gratuito en África — oferta de lanzamiento de Findloop, ¡disfrútalo!",
"fa.africaPublished": "Listado publicado gratis — oferta de lanzamiento en África!",
"fa.approveClaimConfirm": "¿Aprobar esta reclamación? El propietario podrá desbloquear tus datos de contacto.",
"fa.checkInfo": "Verifica tus detalles antes de enviar: se compararán con los del buscador.",
"fa.claimApprovedShort": "El buscador aprobó tu reclamación",
"fa.claimRejectedShort": "Reclamación declinada por el buscador",
"fa.claimRejectedText": "El buscador cree que este artículo no es tuyo.",
"fa.claimSub": "Describe tu artículo y añade 2 fotos. El buscador las comparará con su listado.",
"fa.claimTitle": "Este es mi artículo",
"fa.claimUnlockText": "Desbloquea los datos de contacto del buscador para organizar la devolución.",
"fa.claimUnlockedShort": "Datos de contacto desbloqueados — ver seguimiento",
"fa.claimsTitle": "Reclamaciones del propietario",
"fa.colOwner": "Declaración del propietario",
"fa.colYourAd": "Tu listado",
"fa.expired": "Listado expirado",
"fa.free": "Gratis",
"fa.lostDate": "Fecha de pérdida",
"fa.lostPlace": "Lugar de pérdida",
"fa.noReceipt": "No hay recibo disponible para este listado.",
"fa.planSubFree": "Elige la duración: tu listado se activa de inmediato, sin pago requerido.",
"fa.prefillPrevious": "Reutilizar los detalles de mi listado anterior en esta categoría",
"fa.receipt": "Recibo en PDF",
"fa.renewBtn": "Renovar",
"fa.renewDiscountBanner": "50% de descuento: renueva antes de que tu listado expire!",
"fa.renewDiscountHint": "Descuento del 50% aplicado porque renuevas antes de la fecha de expiración.",
"fa.renewEarly": "Renovar (−50%)",
"fa.renewTitle": "Renovar mi listado",
"fa.renewed": "Listado renovado",
"fa.sendClaim": "Enviar mi reclamación",
"fa.twoPhotos": "2 fotos de tu artículo",
"fa.twoPhotosError": "Añade 2 fotos de tu artículo.",
"fa.twoPhotosHint": "Fotos personales que demuestran que el artículo es tuyo (con el artículo, factura, caja…).",
"fa.unlockBtn": "Desbloquear datos de contacto",
"fa.unlockFree": "Desbloquear gratis — oferta de lanzamiento",
"fa.waitClaimantText": "Te informaremos tan pronto como un propietario reclame este artículo.",
"fa.waitFinderDecision": "Esperando la decisión del buscador",
"fa.waitUnlockText": "Serás notificado tan pronto como se intercambien los datos de contacto.",
"fa.waitUnlockTitle": "Esperando a que el propietario desbloquee",
"fa.cancel": "Cancelar",
"fa.categoryRequired": "Elige una categoría para el artículo encontrado.",
"fa.confirmTitle": "Confirma tu decisión",
"fa.goBack": "Regresar",
"dr.continue": "Continuar mi declaración",
"dr.delete": "Eliminar permanentemente",
"dr.deleteConfirm": "¿Eliminar permanentemente este borrador? Esto no se puede deshacer.",
"dr.deleted": "Borrador eliminado",
"dr.expiresIn": "Borrador guardado por {h} horas más",
"dr.title": "Tienes una declaración sin terminar",
"form.step": "Paso",
"form.next": "Continuar",
"form.back": "Atrás",
"form.stepDetails": "Tu informe",
"form.stepPublish": "Duración, impulso y pago",
"form.stepThanks": "Gracias y contribución",
"fthx.badge": "Informe casi listo",
"fthx.title": "¡Gracias, estás haciendo la diferencia!",
"fthx.text": "Gracias a ti, alguien pronto podrá recuperar algo que le importa. Actos de bondad como el tuyo son precisamente lo que mantiene a Findloop vivo.",
"fthx.impact1": "1 artículo informado",
"fthx.impact2": "1 oportunidad más de un reencuentro",
"fthx.tipTitle": "¿Un pequeño impulso para Findloop?",
"fthx.tipText": "Tu contribución nos ayuda a mantener el servicio accesible y a reunir cada vez más objetos con sus propietarios.",
"fthx.optional": "100% opcional — puedes publicar sin contribuir.",
"fthx.thanksTip": "¡Muchas gracias por tu generosidad!",
"fthx.suggest": "Montos sugeridos",
"fthx.none": "Sin propina",
"pay.pendingTitle": "Pago no completado",
"pay.pendingText": "Tus detalles están guardados. Retoma el pago justo donde lo dejaste.",
"pay.resume": "Reanudar pago",
"pay.expiredTitle": "Sesión de pago expirada",
"pay.expiredText": "Por tu seguridad, la sesión de pago ha expirado. Tus detalles están guardados: reinicia el pago con un clic.",
"pay.relaunch": "Reiniciar pago",
"sub.received": "¡Enviado!",
"sub.publishing": "Estamos terminando…",
"sub.toPayment": "Redirigiendo a pago seguro…",
"fa.claimSubV2": "Describe tu objeto perdido. La persona que lo encontró comparará tu declaración con su listado.",
"fa.photosOptional": "Fotos de tu objeto (opcional)",
"fa.compareOwnerHint": "Compara esta información con el objeto que encontraste, luego indica si es el mismo objeto.",
"fa.itsThisItem": "Sí, este es el objeto",
"fa.notThisItem": "No, este no es el objeto",
"fa.confirmIsItem": "¿Confirma que este es el objeto? Tus datos de contacto y los del propietario se mostrarán en sus respectivas cuentas.",
"fa.confirmNotItem": "¿Confirma que este no es el objeto? Su informe se cerrará.",
"fa.youConfirmed": "Confirmaste que este es el objeto del propietario",
"fa.youDeclined": "Indicaste que este no era el objeto",
"fa.youDeclinedText": "¡Gracias por tu ayuda! Se ha informado al propietario.",
"fa.waitFinderDecisionOwner": "Esperando la decisión del encontrador",
"fa.finderConfirmed": "Confirmado",
"fa.notYourItem": "Este no era tu objeto",
"fa.reportedOn": "Reportado el",
"fa.ownerWaitHint": "Un encontrador está revisando la información, por favor espera.",
"fa.claimSentFinder": "Reclamación enviada a la persona que encontró el artículo.",
"fa.compareClaimHint": "Compara la declaración del propietario con tu listado antes de decidir.",
"fa.closeFollowup": "Cerrar este seguimiento",
"fa.closeFollowupConfirm": "¿Cerrar este seguimiento? Los correos electrónicos y números de teléfono de ambas partes se eliminarán permanentemente una vez que el propietario cierre también su anuncio.",
"fa.safetyTitle": "Consejos de seguridad antes de la entrega",
"fa.safety1": "Pide al propietario una descripción detallada de las características ocultas del artículo: un rasguño específico, el contenido exacto de una bolsa, el papel tapiz, el número de serie…",
"fa.safety2": "Si es posible, solicita prueba visual (una foto del artículo) o prueba de compra.",
"fa.safety3": "Entrega el artículo en un lugar público o en un socio de Findloop, y verifica la identificación del propietario.",
"fa.safetyOk": "Entendido, continuar",
"fa.ownerClosedNote": "El propietario ha cerrado su anuncio.",
"fa.finderClosedNote": "El buscador ha cerrado su seguimiento.",
"fa.followupClosed": "Seguimiento cerrado",
"fa.followupClosedText": "Has cerrado este seguimiento. ¡Gracias por tu ayuda!",
"fa.photoReviewTitle": "Un buscador envió una foto. ¿Se parece a tu artículo?",
"fa.photoLooksLike": "Sí, se parece a mi artículo",
"fa.photoNotMine": "No, este no es mi artículo",
"fa.photoNotMineConfirm": "El seguimiento se cerrará por ambas partes y tu anuncio permanecerá abierto para un nuevo buscador.",
"fa.photoLooksLikeDone": "¡Gracias! El buscador ahora comparará tu declaración.",
"fa.photoNotMineDone": "Informe desestimado. Tu anuncio permanece abierto.",
"fa.ownerPhotoHint": "Solo se te muestra la foto del buscador. Dinos si se parece a tu artículo.",
"fa.ownerReviewingPhoto": "El propietario está revisando tu foto",
"fa.ownerReviewingPhotoText": "Se te notificará tan pronto como respondan. Entonces podrás comparar su declaración.",
"fa.ownerRejectedPhoto": "Este no es el artículo del propietario",
"fa.ownerRejectedPhotoText": "El propietario dice que tu foto no coincide con su artículo. El seguimiento se cierra. ¡Gracias por tu ayuda!",
"fa.contribute": "Contribuir",
"fa.phoneMissing": "No proporcionado",
"fa.ownerSafety1": "Preferiblemente realizar la entrega en un lugar público o en un socio de Findloop. Si la distancia es larga, sugiere enviarlo por correo en su lugar.",
"fa.ownerSafety2": "En la entrega, verifica la identificación del encontrador.",
"pub.changePhoto": "Cambiar foto",
"ph.secured": "Foto asegurada",
"ph.securing": "Asegurando la foto…",
"fa.ownerSafety3": "Si la foto del descubridor tiene la marca de agua de Findloop, no aceptes la reunión. La foto debe ser una imagen original tomada por el descubridor, sin marca de agua."
},
"de": {
"a.category": "Kategorie",
"a.categoryPlaceholder": "Wähle eine Kategorie",
"a.city": "Stadt",
"a.legalHint": "Erforderlich für die französische E-Rechnung (Factur-X) für französische Einrichtungen.",
"a.legalRequiredFR": "SIRET und innergemeinschaftliche Umsatzsteuer-Identifikationsnummer sind verpflichtend für Frankreich.",
"a.rememberMe": "Erinnere dich an mich",
"a.siret": "SIRET",
"a.vat": "Umsatzsteuer-ID (innergemeinschaftlich)",
"ac.africa": "Afrika",
"ac.boostActive": "Aktiv hervorheben —",
"ac.boostSub": "Oben im Partnerverzeichnis mit einem „Hervorgehoben“-Abzeichen erscheinen.",
"ac.boostTitle": "Steigere dein Eintrag im Verzeichnis",
"ac.categoryHint": "Um deine Einrichtung im findloop-Verzeichnis zu klassifizieren.",
"ac.choose": "Wählen",
"ac.cityHint": "Für präzise Positionierung auf der öffentlichen Karte.",
"ac.cityLabel": "Stadt der Einrichtung",
"ac.cityPh": "Paris",
"ac.contact": "Kontaktdaten",
"ac.converted": "Konvertiert",
"ac.copyDeclLink": "Link zur Erklärung kopieren",
"ac.copyLink": "Link kopieren",
"ac.currentPlan": "Aktueller Plan",
"ac.emailDesc": "Wähle die E-Mails, die du empfangen möchtest. Benachrichtigungen in deinem Arbeitsbereich bleiben immer aktiv.",
"ac.emailMatch": "Übereinstimmungen",
"ac.emailMatchDesc": "Eine E-Mail, wenn ein Artikel mit einer Erklärung übereinstimmt",
"ac.emailNewDecl": "Neue Verlustmeldungen",
"ac.emailNewDeclDesc": "Eine E-Mail, sobald ein Kunde einen Verlust an deinem Standort meldet",
"ac.emailShip": "Versandanfragen",
"ac.emailShipDesc": "Eine E-Mail, wenn ein Kunde den Versand eines Artikels anfragt",
"ac.emailTitle": "E-Mail-Einstellungen",
"ac.expireSoon": "Deine Hervorhebung läuft bald ab —",
"ac.exportCsv": "Exportieren (CSV)",
"ac.exportHint": "Exportiere deine validierten externen Zahlungen für deine Buchhaltung.",
"ac.free": "Kostenlos",
"ac.freeMonths": "Kostenlose Monate",
"ac.hours": "Stunden",
"ac.howItWorks": "Wie funktioniert es?",
"ac.invited": "Eingeladen",
"ac.legalFR": "Erforderlich für die elektronische Rechnungsstellung (Factur-X), gültig ab September 2026.",
"ac.legalMissing": "⚠️ SIRET und innergemeinschaftliche Umsatzsteuer fehlen — vervollständige sie, um den Anforderungen der elektronischen Rechnungsstellung gerecht zu werden.",
"ac.legalOther": "Empfohlen für deine Rechnungen.",
"ac.legalPartnerQr": "QR-Code",
"ac.legalTitle": "Rechtliche Identifier (Abrechnung)",
"ac.logoTitle": "Logo der Einrichtung",
"ac.modeCurrent": "Aktueller Modus:",
"ac.modeExternal": "Extern (manuelle Validierung)",
"ac.modeInternal": "Intern Findloop (automatisch)",
"ac.noSubReceipt": "Bisher keine Zahlung für ein bezahltes Abonnement.",
"ac.none": "Keine",
"ac.onYourListing": "auf deinem Eintrag",
"ac.pay1": "Gib deine Zahlungslinks unten ein, um deine Kunden zu deinem eigenen Abrechnungssystem weiterzuleiten.",
"ac.pay2": "Die Validierung wird manuell: Du bestätigst den Zahlungseingang im Tab „Erklärungen“.",
"ac.pay3": "Der Link „Versandkosten“ ist eine konsolidierte Zahlung (Rückholung + Versand).",
"ac.pay4": "Lass die Felder leer, um Findos interne Zahlung (Stripe) mit automatischer Validierung zu verwenden.",
"ac.paySub": "Erhebe Gebühren über dein eigenes Zahlungssystem.",
"ac.payTitle": "Externe Zahlungen",
"ac.permissive": "Nachsichtig",
"ac.phone": "Telefon",
"ac.posterA4": "A4-Poster (PDF)",
"ac.qMessage": "Nachricht (optional)",
"ac.qName": "Name",
"ac.qOrg": "Organisation",
"ac.qSites": "Anzahl der Einrichtungen (geschätzt)",
"ac.qrHint": "Ihre Kunden scannen diesen Code, um einen verlorenen Gegenstand zu melden.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Ihr Partner-QR-Code",
"ac.quoteDesc": "Flughäfen, Bahnnetze, internationale Ketten · ",
"ac.quoteEurope": "Europa / Welt",
"ac.quoteSent": "Anfrage gesendet. Unser Team wird sich bald bei Ihnen melden.",
"ac.quoteTitle": "Ein Angebot anfordern — Unternehmen",
"ac.recoveryLink": "Link „Wiederherstellungsgebühr“",
"ac.refSub": "Jeder empfohlene Partner, der sich anmeldet, gibt Ihnen 1 kostenlosen Monat.",
"ac.refTitle": "Empfehlen, einen kostenlosen Monat verdienen",
"ac.reminderDelay": "Erinnerungszeitraum für die Validierung",
"ac.reminderHint": "Sie erhalten eine Erinnerungs-E-Mail, wenn eine externe Zahlung über diesen Zeitraum (Standard: 48h) hinaus unvalidiert bleibt.",
"ac.renewDesc1": "Es hat Ihnen bereits",
"ac.renewDesc2": "Erneuern Sie, um an oberster Stelle im Verzeichnis zu bleiben und diese Sichtbarkeit nicht zu verlieren.",
"ac.renewNow": "Jetzt erneuern",
"ac.requestQuote": "Ein Angebot anfordern",
"ac.saveLegal": "Die Identifikatoren speichern",
"ac.saveLinks": "Die Links speichern",
"ac.sendRequest": "Meine Anfrage senden",
"ac.sending": "Wird gesendet…",
"ac.shippingLink": "Link „Versandgebühr“ (konsolidiert)",
"ac.shippingLinkHint": "Dieser Link deckt sowohl die Wiederherstellung als auch den Versand ab.",
"ac.strict": "Streng",
"ac.subReceipt": "Abonnementbeleg (PDF)",
"ac.subReceiptsSub": "Laden Sie den PDF-Beleg für jede Abonnementzahlung herunter.",
"ac.subReceiptsTitle": "Abonnementbelege",
"ac.tCategory": "Kategorie gespeichert",
"ac.tCity": "Stadt gespeichert — Karte aktualisiert",
"ac.tCityNeeded": "Geben Sie eine Stadt ein",
"ac.tCopied": "Kopiert!",
"ac.tCover": "Titelfoto aktualisiert",
"ac.tEmailPrefs": "E-Mail-Einstellungen aktualisiert",
"ac.tErr": "Fehler",
"ac.tExportImpossible": "Export fehlgeschlagen",
"ac.tLegal": "Rechtliche Identifikatoren gespeichert",
"ac.tLegalNeeded": "SIRET und USt-IdNr. für Frankreich erforderlich",
"ac.tLogo": "Logo aktualisiert",
"ac.tLogoRemoved": "Logo entfernt",
"ac.tPayLinks": "Zahlungslinks gespeichert",
"ac.tPhone": "Telefon gespeichert",
"ac.tSensitivity": "Sensibilität gespeichert",
"ac.tVatInvalid": "Ungültige USt-IdNr.",
"ac.tVatValid": "Gültige USt.",
"ac.tabBoost": "Sichtbarkeit",
"ac.tabPayments": "Zahlungen",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Poster",
"ac.tabReferral": "Empfehlung",
"ac.tabSub": "Abonnement",
"ac.thisWeek": "Diese Woche",
"ac.thisWeekOf": " ({n} diese Woche)",
"ac.thresholdDesc": "Vertrauenschwelle, ab der die KI automatisch ein Foto-Match validiert und den Kunden benachrichtigt. Höher = weniger automatische Übereinstimmungen, aber zuverlässiger.",
"ac.thresholdTitle": "Empfindlichkeit des visuellen KI-Matches",
"ac.trend": "Trend",
"ac.upload": "Hochladen",
"ac.vatValidFmt": "Gültige USt.{name} ({via})",
"ac.vatVerified": "Intra-EU-USt. verifiziert",
"ac.verifyVat": "Umsatzsteuer (VIES) überprüfen",
"ac.verifying": "Wird überprüft…",
"ac.views": "Aufrufe",
"ac.viewsTotal": "Gesammelte Aufrufe (insgesamt)",
"ac.winbackBtn": "Fortfahren mit -20%",
"ac.winbackDesc1": "Es hat Ihnen eingebracht",
"ac.winbackDesc2": "Sonderangebot: -20% werden automatisch angewendet, wenn Sie innerhalb von 24h verlängern.",
"ac.winbackTitle": "Ihr Highlight ist gerade abgelaufen – fahren Sie mit -20% fort!",
"an.allCountries": "Alle Länder",
"an.country": "Land",
"an.geoBanner": "Sie sehen Angebote in",
"an.geoBannerWorld": "Sie sehen Angebote weltweit",
"an.geoChange": "Land wechseln",
"an.loginRequired": "Melden Sie sich an, um diesen Artikel zu melden und den Rückversand zu verfolgen.",
"an.requestInProgress": "Anfrage wird bearbeitet",
"an.resolved": "Artikel bereits zurückgeholt",
"an.sortRecent": "Neueste",
"an.sortRelevance": "Relevanz",
"bo.africaPrice": "Bevorzugte Preise für die Afrika-Zone angewendet",
"c.all": "Alle",
"c.close": "Schließen",
"c.confirm": "Bestätigen",
"c.confirmed": "Bestätigt",
"c.download": "Herunterladen",
"c.reset": "Zurücksetzen",
"c.transfer": "Übertragen",
"cat.Animal": "Haustier / Haustierzubehör",
"cat.AppareilPhoto": "Kamera",
"cat.Argent": "Geld / Bargeld",
"cat.Autres": "Sonstiges",
"cat.Bijoux": "Schmuck",
"cat.CarteBancaire": "Bankkarte",
"cat.CarteIdentite": "Ausweis / Reisepass",
"cat.Casquette": "Mütze / Hut",
"cat.Ceinture": "Gürtel",
"cat.Chargeur": "Ladegerät / Kabel",
"cat.Chaussures": "Schuhe",
"cat.CleVoiture": "Autoschlüssel",
"cat.Cles": "Schlüssel",
"cat.Console": "Spielekonsole",
"cat.Documents": "Dokumente / Papiere",
"cat.Echarpe": "Schal",
"cat.Ecouteurs": "Kopfhörer",
"cat.Electronique": "Elektronik (Sonstiges)",
"cat.Enceinte": "Lautsprecher",
"cat.Gants": "Handschuhe",
"cat.Gourde": "Wasserflasche / Thermoskanne",
"cat.Instrument": "Musikinstrument",
"cat.Jouet": "Spielzeug / Plüsch",
"cat.Jumelles": "Fernglas",
"cat.Lampe": "Lampe / Taschenlampe",
"cat.Liseuse": "E-Reader",
"cat.Livre": "Buch / Notizbuch",
"cat.Lunettes": "Brille",
"cat.Manteau": "Mantel / Jacke",
"cat.Maquillage": "Make-up Tasche",
"cat.Medical": "Medizinische Ausrüstung",
"cat.Medicaments": "Medikamente",
"cat.Montre": "Uhr / Smartwatch",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Regenschirm",
"cat.Portefeuille": "Geldbörse / Portemonnaie",
"cat.Poussette": "Kinderwagen / Babyaccessoire",
"cat.Sac": "Tasche / Handtasche",
"cat.SacADos": "Rucksack",
"cat.Souris": "Maus / Tastatur",
"cat.Sport": "Sportgeräte",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefon / Smartphone",
"cat.Trottinette": "Roller",
"cat.Trousse": "Täschen / Etui",
"cat.USB": "USB-Stick / Festplatte",
"cat.Valise": "Koffer / Gepäck",
"cat.Velo": "Fahrrad",
"cat.Vetements": "Kleidung",
"cm.found": "GEMELDET",
"cm.lost": "VERLOREN",
"consent.required": "Sie müssen zustimmen, Ihre Kontaktdaten zu teilen, um fortzufahren.",
"consent.share": "Ich stimme zu, dass der Finder meines Gegenstands meine Kontaktdaten (Name, E-Mail, Telefon) sehen darf, um mich für die Rückgabe zu erreichen.",
"dc.partnerDesc": "Haben Sie Ihren Gegenstand an einem Partnerort (Hotel, Bahnhof, Halle…) verloren? Wählen Sie ihn für eine direkte Rückgabe aus.",
"dc.partnerList": "Wählen Sie aus der Liste",
"dc.partnerMap": "Wählen Sie auf der Karte",
"dc.partnerTitle": "Erklärung bei einem Partner",
"dc.publicCta": "Eine öffentliche Anzeige aufgeben",
"dc.publicDesc": "Ihre Anzeige wird der gesamten findloop-Community sichtbar sein. Ideal, wenn Sie nicht wissen, wo Sie den Gegenstand verloren haben.",
"dc.publicTitle": "Öffentliche Erklärung",
"dc.subtitle": "Wählen Sie, wie Sie Ihren verlorenen Gegenstand melden möchten.",
"dc.title": "Was möchten Sie tun?",
"dec.addrPending": "Adresse vom Kunden ausstehend",
"dec.analyzing": "Wird analysiert…",
"dec.clientDescription": "Kundenbeschreibung",
"dec.clientPhoto": "Foto vom Kunden bereitgestellt",
"dec.clientPhotoShort": "Foto des Kunden",
"dec.comparePhotos": "Fotos vergleichen",
"dec.declaredItemPhoto": "Foto des deklarierten Gegenstands",
"dec.emptyDesc": "Teilen Sie Ihren QR-Code, um Meldungen zu erhalten.",
"dec.emptyTitle": "Keine Meldungen",
"dec.enlarge": "Vergrößern",
"dec.extBanner": "{n} externe Zahlung(en) zur Validierung — bestätigen Sie den Empfang unten, um die Übergabe oder den Versand freizugeben.",
"dec.foundItemAlt": "Gefundener Gegenstand",
"dec.foundItemRegistry": "Gefundener Gegenstand (Registrierung)",
"dec.labelClient": "Kunde",
"dec.labelRegistry": "Registrierung",
"dec.noMatchYet": "Noch keine Übereinstimmung.",
"dec.noPhoto": "Kein Foto",
"dec.pRecup": "Wiederbeschaffung",
"dec.pRecupP": "(Wiederbeschaffung)",
"dec.pRecupShip": "(Wiederbeschaffung + Versand)",
"dec.payConfirmed": "Zahlung {x} bestätigt",
"dec.payPending": "Externe Zahlung {x} ausstehend",
"dec.pickup": "Persönliche Abholung",
"dec.reject": "Ablehnen",
"dec.rerun": "Analyse erneut ausführen",
"dec.similarity": "Ähnlichkeit {n}%",
"dec.suggestedMatches": "Vorgeschlagene Übereinstimmungen",
"dec.toColon": " zu:",
"dec.toShip": "Zu versenden",
"dec.toastExtPay": "Zahlung bestätigt — der Kunde wird benachrichtigt.",
"dec.toastMatch": "Übereinstimmung bestätigt",
"dec.toastReject": "Vorschlag abgelehnt",
"dec.toastRerun": "Analyse neu gestartet",
"dec.toastVisualN": "{n} visuelle Übereinstimmung(en)",
"dec.toastVisualNone": "Keine visuelle Übereinstimmung",
"dec.viewBeforeAfter": "Vorher/Nachher-Ansicht (Überlagerung)",
"dec.viewSideBySide": "Nebeneinander-Ansicht",
"dec.visualCompare": "KI-Visueller Vergleich",
"dec.visualIdle": "Führen Sie den Vergleich durch, damit die KI das Foto des Kunden mit den gefundenen Artikeln visuell abgleicht.",
"dec.visualRunning": "Die KI vergleicht das Foto des Kunden mit Artikeln in Ihrem Register…",
"dec.zoomPhoto": "Foto vergrößern",
"dep.addAnyway": "Trotzdem hinzufügen",
"dep.addError": "Fehler beim Hinzufügen",
"dep.addItem": "Artikel hinzufügen",
"dep.added": "Artikel zum Register hinzugefügt!",
"dep.adding": "Wird hinzugefügt…",
"dep.aiError": "KI-Analyse gerade nicht verfügbar.",
"dep.aiFilled": "Formular automatisch ausgefüllt von der KI ✨",
"dep.aiUnavailable": "KI nicht verfügbar — füllen Sie das Formular manuell aus.",
"dep.analyzing": "Wird analysiert…",
"dep.analyzingPhoto": "Foto wird analysiert…",
"dep.brand": "Marke",
"dep.brandPlaceholder": "z.B. Apple",
"dep.category": "Kategorie",
"dep.checkingDup": "Überprüfe auf Duplikate…",
"dep.color": "Farbe",
"dep.colorPlaceholder": "z.B. schwarz",
"dep.condition": "Zustand",
"dep.conditionPlaceholder": "z.B. guter Zustand",
"dep.depositorNote": "Hinweis des Einlegers",
"dep.depositorNoteHint": "Betriebsdetails handschriftlich eingegeben. Die KI überschreibt diesen Hinweis nie.",
"dep.depositorNotePlaceholder": "z.B. Inhalt eines Beutels, Marke wie angegeben, Details der Person…",
"dep.descPlaceholder": "z.B. schwarzes iPhone 15 mit einem klaren Case, an der Bar gefunden…",
"dep.description": "Beschreibung",
"dep.dupHint": "Stellen Sie sicher, dass Sie kein Duplikat hinzufügen. Sie können fortfahren, wenn der Artikel wirklich anders ist.",
"dep.dupTitle": "Ähnliche Artikel bereits registriert",
"dep.dupWarn": "Ähnlicher Artikel erkannt — überprüfen Sie, und klicken Sie dann erneut, um zu bestätigen.",
"dep.estHint": "Der Artikel wird im Register dieser Einrichtung hinzugefügt.",
"dep.establishment": "Einrichtung",
"dep.fee": "Rückgewinnungsgebühr (€) — optional",
"dep.feePlaceholder": "Leer lassen für den Standardpreis der Kategorie",
"dep.fillAI": "Mit KI ausfüllen",
"dep.optional": "(optional)",
"dep.photo": "Artikelphoto",
"dep.principal": "hauptsächlich",
"dep.reqError": "Kategorie und Beschreibung sind erforderlich.",
"dep.savedItem": "Registrierter Artikel",
"dep.similarity": "Ähnlichkeit",
"dep.storage": "Physischer Standort",
"dep.storageHint": "Wo der Artikel physisch aufbewahrt wird. Ein QR-Code wird generiert, um ihn zu finden.",
"dep.storagePlaceholder": "z.B. Regal A3, Fach 12, Empfangstresor",
"dl.aClient": "ein Kunde",
"dl.alertsBlocked": "Browserbenachrichtigungen blockiert",
"dl.alertsBlockedHint": "Um sie wieder zu aktivieren: Klicken Sie auf das 🔒 (oder ⓘ) Symbol links von der Seitenadresse, dann Benachrichtigungen zulassen und die Seite neu laden.",
"dl.amountDue": "Fälliger Betrag: {amount} {currency}.",
"dl.enableAlerts": "Benachrichtigungen aktivieren",
"dl.extPending": "Zahlungen zur Validierung",
"dl.freemiumNear": "Sie nähern sich der Freemium-Grenze ({used}/{max} Artikel in diesem Monat). Upgrade auf Starter für unbegrenzte Artikel.",
"dl.freemiumReached": "Freemium-Grenze erreicht ({used}/{max} Artikel in diesem Monat). Upgrade auf Starter, um unbegrenzt Artikel zu registrieren.",
"dl.invoiceOverdue": "Rechnung {num} unbezahlte — Zugriff eingeschränkt.",
"dl.matchNotifTitle": "Findloop — Neue KI-Übereinstimmung 🔔",
"dl.matchToast": "Neue KI-Übereinstimmung — {name}",
"dl.matchToastDesc": "Ein Artikel passt zu einer Erklärung.",
"dl.notifEmpty": "Noch keine Benachrichtigungen.",
"dl.notifEnabled": "Browserbenachrichtigungen aktiviert",
"dl.notifTitle": "Benachrichtigungen",
"dl.payInvoice": "Rechnung bezahlen →",
"dl.rewardsPending": "Einzulösende Gutscheine",
"dl.upgradeStarter": "Upgrade auf Starter →",
"est.all": "Alle Einrichtungen ({n})",
"est.label": "Einrichtung",
"est.primary": "primär",
"est.secondary": "sekundär",
"est2.add": "Eine Einrichtung hinzufügen",
"est2.addressLabel": "Adresse",
"est2.addressPh": "12 République Straße",
"est2.autoInvoice": "Eine detaillierte Rechnung wird am 1. jedes Monats automatisch erstellt.",
"est2.baseSub": "Basis-Abonnement",
"est2.billing": "Abrechnung",
"est2.boostActivated": "Boost aktiviert für {name}",
"est2.boostBillingNote": "Zum aktuellen Tarif abgerechnet und in Ihrer konsolidierten monatlichen Rechnung gruppiert.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Verbessern Sie die Sichtbarkeit dieser Einrichtung im Verzeichnis und auf der Karte.",
"est2.boostDuration": "{h}h erhöhte Sichtbarkeit",
"est2.boostExtend": "Erweitern",
"est2.boostTitle": "Boost {name}",
"est2.boosted": "Erhöht",
"est2.chartDesc": "Anteil der zurückgegebenen Artikel aus der insgesamt registrierten Anzahl, standortspezifisch.",
"est2.chartTitle": "Rückgaberate nach Einrichtung",
"est2.chartTooltip": "Rückgabe",
"est2.cityLabel": "Stadt",
"est2.cityPh": "Lyon",
"est2.contactHint": "Diese Angaben werden dem Kunden für diese Einrichtung angezeigt (fällt auf das Konto zurück, wenn leer).",
"est2.countryLabel": "Land",
"est2.coverLabel": "Titelbild",
"est2.create": "Erstellen",
"est2.created": "Einrichtung erstellt",
"est2.delete": "Löschen",
"est2.deleteDesc": "Diese Aktion ist dauerhaft. Sie können eine Einrichtung nur löschen, wenn sie keine Artikel enthält.",
"est2.deleteTitle": "„{name}“ löschen?",
"est2.deleted": "Einrichtung gelöscht",
"est2.dialogDesc": "Geben Sie den Namen und die Adresse dieses Standorts ein.",
"est2.edit": "Bearbeiten",
"est2.editEst": "Einrichtung bearbeiten",
"est2.emailLabel": "Kontakt-E-Mail",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " Einrichtung(en)",
"est2.extraNoteBase": "{n} zusätzliche Einrichtung(en) abgerechnet",
"est2.extraPrice": " zu {price} €/Monat.",
"est2.extraQuote": " auf Anfrage.",
"est2.imgChange": "Ein Bild auswählen",
"est2.imgDone": "Fertig",
"est2.imgRemove": "Entfernen",
"est2.imgRemoved": "Bild entfernt",
"est2.imgSaved": "Bild gespeichert",
"est2.imgUploading": "Hochladen…",
"est2.includedPlan": "In Ihrem Plan enthalten: {n}.",
"est2.kDeclarations": "Erklärungen",
"est2.kInStorage": "Im Lager",
"est2.kItemsTotal": "Artikel (gesamt)",
"est2.kRestituted": "Zurückgegeben",
"est2.limitReached": "Limit erreicht",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Dekl.",
"est2.mItems": "Artikel",
"est2.mRestituted": "Zurückgegeben",
"est2.mStorage": "In Lagerung",
"est2.monthlyTotal": "Monatliche Gesamtsumme",
"est2.nameLabel": "Name *",
"est2.namePh": "z.B. Belmont Hotel — Lyon Annex",
"est2.newEst": "Neues Unternehmen",
"est2.onQuote": "Auf Anfrage",
"est2.phoneLabel": "Telefon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plan",
"est2.planLimited": "Ihr „{tier}“ Plan ist auf {max} Unternehmen beschränkt.",
"est2.primary": "Primär",
"est2.qr": "QR-Code",
"est2.qrDesc": "Zeigen Sie diesen QR-Code in diesem Unternehmen an. Kunden, die einen Verlust melden, werden mit dieser Webseite verbunden.",
"est2.qrTitle": "QR-Code — {name}",
"est2.saving": "Speichern…",
"est2.seeInvoices": "Meine monatlichen Rechnungen ansehen",
"est2.seePlans": "Die Pläne ansehen",
"est2.subtitle": "Verwalten Sie alle Ihre Standorte unter einem Konto — konsolidierte Ansicht, Artikel, QR-Code und Abrechnung.",
"est2.suspended": "Ausgesetzt",
"est2.tierFree": "1 Unternehmen",
"est2.tierLarge": "unbegrenzte Unternehmen",
"est2.tierMedium": "5 Unternehmen inklusive",
"est2.tierSmall": "3 Unternehmen inklusive",
"est2.title": "Unternehmen",
"est2.unlimitedPlan": "Ihr Plan erlaubt eine unbegrenzte Anzahl von Unternehmen.",
"est2.unlimitedSuffix": " · unbegrenzt",
"est2.updated": "Unternehmen aktualisiert",
"est2.upgradeHint": "Upgrade auf einen höheren Plan, um mehr Standorte hinzuzufügen und alle Ihre Aktivitäten zu zentralisieren.",
"est2.visuals": "Logo & Foto",
"est2.visualsDesc": "Passen Sie das Logo und das Titelbild dieses Unternehmens an. Sie erscheinen auf der öffentlichen Seite und im Deklarationsformular.",
"est2.visualsTitle": "Visuals — {name}",
"est2.workOn": "An diesem Unternehmen arbeiten",
"est2.working": "Sie arbeiten an „{name}“",
"fp.backToRanking": "Zurück zur Rangliste",
"fp.badge": "Abzeichen",
"fp.notFound": "Profil nicht gefunden oder privat.",
"fp.scoreTotal": "Gesamtpunkte",
"fp.scoreYear": "Punkte in",
"fp.share": "Teilen Sie dieses Profil",
"fp.shareText": "Schauen Sie sich {name}‘s Finder-Profil auf Findloop an!",
"fp.tagline": "Ein ehrlicher Finder, der die Welt zu einem besseren Ort macht.",
"ft.backAccount": "Zurück zu Mein Konto",
"ft.closeBtn": "Fall schließen",
"ft.closeConfirm": "Bestätigen, dass der Artikel zurückgegeben wurde? Die Anzeige wird geschlossen.",
"ft.closeLockedHint": "Validieren Sie zuerst den Code des Eigentümers, um das Schließen freizugeben.",
"ft.closed": "Fall geschlossen — Artikel zurückgegeben!",
"ft.codeLabel": "Geben Sie den Validierungscode ein, den Sie vom Eigentümer erhalten haben",
"ft.codeNeeded": "Bitte geben Sie den Validierungscode ein.",
"ft.codeOk": "Code validiert — Sie können den Fall schließen.",
"ft.codePlaceholder": "z.B. 4821",
"ft.codeVerified": "Validiert",
"ft.doneMsg": "Artikel zurückgegeben. Danke, dass Sie ihn seinem Eigentümer zurückgebracht haben!",
"ft.stepInProgress": "Rückgabe in Bearbeitung",
"ft.stepPublished": "Anzeige veröffentlicht",
"ft.stepReturned": "Artikel zurückgegeben",
"ft.subtitle": "Befolgen Sie die Schritte, bis der gefundene Artikel zurückgegeben ist.",
"ft.title": "Sendungsverfolgung",
"ft.verifyBtn": "Code überprüfen",
"home.champBecome": "Ein Finder werden",
"home.champCta": "Leaderboard ansehen",
"home.champSubtitle": "Jeder zurückgegebene Artikel bringt Punkte. Nimm am Leaderboard teil und gewinne Belohnungen.",
"home.champTitle": "Unsere besten Finder",
"inv2.contractTitle": "Mein Findloop Vertrag",
"inv2.detailByEst": "Details nach Einrichtung",
"inv2.dueLabel": "Fällig:",
"inv2.dueSuffix": " · fällig am {date}",
"inv2.error": "Fehler {status}",
"inv2.estCountIssued": "{n} Einrichtung(en) · ausgestellt am {date}",
"inv2.estimate": "Schätzung (nicht berechnet) · {n} Einrichtung(en)",
"inv2.expired": " · abgelaufen",
"inv2.exportCsv": "CSV exportieren",
"inv2.exportDone": "CSV-Export heruntergeladen",
"inv2.included": "Inklusive",
"inv2.monthlyTitle": "Monatliche Abrechnung (Abonnement)",
"inv2.months": "+{n} Monate",
"inv2.paid": "Bezahlt",
"inv2.pay": "Zahlen",
"inv2.previewTitle": "Vorschau auf deine nächste Rechnung —",
"inv2.renew": "Meinen Vertrag verlängern",
"inv2.renewalsTitle": "Verlängerungshistorie ({n})",
"inv2.renewedUntil": "Vertrag verlängert bis {date}",
"inv2.serviceTitle": "Dienstleistungsrechnungen (Rückforderungen & Angebote)",
"inv2.soon": "Bald ablaufend",
"inv2.toPay": "Zu bezahlen",
"inv2.totalHtTva": "Gesamt excl. MwSt. · USt.",
"inv2.totalTtc": "Gesamt incl. MwSt.",
"iu.addPhoto": "Foto hinzufügen",
"iu.change": "Ändern",
"lb.allCountries": "Alle Länder",
"lb.badge": "Jährliches Leaderboard",
"lb.champion": "🏆 Champion des Jahres",
"lb.cityPh": "Nach Stadt filtern…",
"lb.empty": "Noch kein Ranking für diese Filter.",
"lb.pts": "Punkte",
"lb.resetNote": "Leaderboards des aktuellen Jahres — jeden 1. Januar zurückgesetzt.",
"lb.returned": "zurückgegeben",
"lb.share": "Leaderboard teilen",
"lb.shareText": "Schau dir das Leaderboard der besten Finder auf Findloop an!",
"lb.subtitle": "Jede Rückgabe bringt Punkte. Das Leaderboard wird jeden 1. Januar zurückgesetzt.",
"lb.tabFinders": "Finder",
"lb.tabPartners": "Einrichtungen",
"lb.title": "Beste Finder",
"lost.b2bDesc": "Hast du es in einem Hotel, Verkehrsknotenpunkt oder Partnerort verloren? Finde die Einrichtung und melde deinen Verlust.",
"lost.b2bTitle": "An einen Partner melden",
"lost.b2cDesc": "Veröffentliche eine Anzeige, die für alle sichtbar ist, biete eine Belohnung an und bewerbe sie, um deine Chancen zu maximieren.",
"lost.b2cTitle": "Öffentliche Anzeige posten",
"lost.desc": "Wähle, wie du fortfahren möchtest.",
"lost.title": "Hast du einen Gegenstand verloren?",
"map.allCategories": "Alle Kategorien",
"map.clear": "Zurücksetzen",
"map.exitFullscreen": "Beenden",
"map.filterCity": "Stadt oder Land…",
"map.fullscreen": "Vollbild",
"map.heatmap": "Heatmap",
"map.high": "Hoch",
"map.impactMonth": "Artikel diesen Monat zurückgegeben",
"map.impactTotal": "insgesamt zurückgegeben",
"map.legend": "Farbige Punkte von rot (niedrig) bis grün (hoch) basierend auf der Rückgabewahrscheinlichkeit; Größe basierend auf der Anzahl der Artikel.",
"map.locating": "Standortbestimmung… Fügen Sie eine Adresse zu Ihren Einrichtungen hinzu, um sie auf der Karte zu sehen.",
"map.low": "Niedrig",
"map.medium": "Mittel",
"map.noItemRegistered": "Kein Artikel registriert",
"map.noItems": "Kein Artikel",
"map.period30": "Letzte 30 Tage",
"map.period7": "Letzte 7 Tage",
"map.period90": "Letzte 90 Tage",
"map.periodAll": "Immer",
"map.returnedSuffix": "zurückgegeben · {a}/{t} Artikel",
"map.stats": "Stadtstatistiken",
"map.statsTop": "Top 5 Orte (verlorene Artikel)",
"map.statsTrend": "6-Monats-Trend",
"map.title": "Karte Ihrer Einrichtungen",
"map.topPlaces": "Beliebte Orte",
"mc.addPhoto": "Ein Foto hinzufügen",
"mc.archiveHide": "Verlauf verstecken",
"mc.archiveNone": "Noch kein gelöstes Anliegen.",
"mc.archiveShow": "Verlauf anzeigen",
"mc.archiveSub": "Gelöste und zurückgegebene Fälle.",
"mc.archiveTitle": "Verlauf",
"mc.backToLogin": "Zurück zur Anmeldung",
"mc.cancel": "Abbrechen",
"mc.certificate": "Zertifikat",
"mc.city": "Stadt",
"mc.confirmPassword": "Passwort bestätigen",
"mc.confirmRestitution": "Rückgabe bestätigen",
"mc.deleteAccount": "Mein Konto löschen",
"mc.deleteConfirm": "Ja, mein Konto löschen",
"mc.deleteConfirmBody": "Ihr Konto wird dauerhaft gelöscht und Ihre persönlichen Daten anonymisiert. Diese Aktion kann nicht rückgängig gemacht werden.",
"mc.deleteConfirmTitle": "Ihr Konto löschen?",
"mc.deleteDesc": "Löscht Ihr Konto dauerhaft und anonymisiert Ihre persönlichen Daten. Diese Aktion kann nicht rückgängig gemacht werden.",
"mc.deleted": "Ihr Konto wurde gelöscht.",
"mc.deleting": "Löschen…",
"mc.expiresOn": "Läuft ab am",
"mc.exportData": "Lade meine Daten herunter (DSGVO)",
"mc.exportDone": "Ihre Daten wurden heruntergeladen.",
"mc.exporting": "Vorbereiten…",
"mc.finderAccepted": "Akzeptiert",
"mc.finderProfile": "Finder-Profil (optional)",
"mc.finderProfileDesc": "Verdienen Sie Punkte, indem Sie Artikel zurückgeben und auf der öffentlichen Bestenliste erscheinen.",
"mc.forgotLink": "Passwort vergessen?",
"mc.forgotSend": "Link senden",
"mc.forgotSent": "Wenn ein Konto für diese E-Mail existiert, wurde gerade ein Rücksetzlink gesendet.",
"mc.forgotTitle": "Passwort vergessen",
"mc.hAd": "Verlorene Anzeige",
"mc.hDeclaration": "Erklärung",
"mc.hFinderContact": "Gemeldeter Artikel",
"mc.hFound": "Zurückgegebener Artikel",
"mc.hFoundAd": "Gefundene Anzeige",
"mc.histEarned": "Artikel zurückgegeben",
"mc.historyTitle": "Meine Punktehistorie",
"mc.myFinds": "Artikel, die ich gefunden habe",
"mc.myFindsNone": "Sie haben noch keinen Artikel gefunden und gemeldet.",
"mc.myFindsSub": "Artikel, die Sie in Verlustanzeigen gemeldet haben.",
"mc.myRewards": "Meine Gutscheine",
"mc.newPassword": "Neues Passwort",
"mc.notEnough": "Nicht genügend Punkte",
"mc.notifEmpty": "Noch keine Benachrichtigungen.",
"mc.notifOpen": "Ansehen",
"mc.notifTitle": "Benachrichtigungen",
"mc.notifTrack": "Verfolgen",
"mc.notifViewAd": "Anzeige ansehen",
"mc.optInDesc": "Freiwillige Teilnahme. Sie stimmen zu, die unten ausgewählten Elemente öffentlich anzuzeigen. Jederzeit änderbar.",
"mc.optInTitle": "Öffentlich auf der Bestenliste erscheinen",
"mc.passwordMismatch": "Passwörter stimmen nicht überein.",
"mc.pointsBalance": "Punkte zum Ausgeben",
"mc.presentHint": "Zeigen Sie diesen QR-Code dem Partner: Er scannt ihn, um Ihre Belohnung zu validieren.",
"mc.presentInStore": "Im Laden zeigen",
"mc.presentTitle": "Diesen Gutschein zeigen",
"mc.privacy": "Privatsphäre & Daten",
"mc.privacyDesc": "Laden Sie eine Kopie aller persönlichen Daten herunter, die Findloop über Sie speichert (DSGVO, Art. 15 & 20).",
"mc.profileSaved": "Profil aktualisiert.",
"mc.profileSettings": "Öffentliches Profil & Bestenliste",
"mc.pseudo": "Vorname oder Spitzname",
"mc.redExpired": "Abgelaufen",
"mc.redReady": "Bei Partner zeigen",
"mc.redUsed": "Verwendet",
"mc.redeem": "Einlösen",
"mc.rememberMe": "Eingeloggt bleiben",
"mc.remove": "Entfernen",
"mc.resetDone": "Passwort aktualisiert. Sie können sich jetzt anmelden.",
"mc.resetExpired": "Dieser Link zum Zurücksetzen ist ungültig oder abgelaufen. Fordern Sie unten einen neuen an.",
"mc.resetSave": "Mein Passwort zurücksetzen",
"mc.resetTitle": "Neues Passwort",
"mc.restitutionConfirmed": "Rückgabe bestätigt.",
"mc.rewardRedeemed": "Belohnung freigeschaltet! Code:",
"mc.rewardsDesc": "Nutzen Sie Ihre Punkte für Vorteile, die von unseren Partnern angeboten werden. Guthaben:",
"mc.rewardsNone": "Noch keine Belohnung verfügbar.",
"mc.rewardsTitle": "Meine Punkte ausgeben",
"mc.scoreAwarded": "Gut gemacht! +1 zu Ihrem Finder Score 🎉",
"mc.scoreEarned": "Punkt verdient",
"mc.scorePts": "Pkt",
"mc.scoreThisYear": "Dieses Jahr",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Bestenliste ansehen",
"mc.visCity": "Stadt",
"mc.visCountry": "Land",
"mc.visLabel": "Auf der Bestenliste sichtbare Elemente:",
"mc.visName": "Vorname / Spitzname",
"mc.visPhoto": "Profilfoto",
"mc2.acceptFinder": "Diesen Finder akzeptieren",
"mc2.accountActivity": "Kontobewegungen",
"mc2.adsActive": "{n}/5 aktive Anzeigen",
"mc2.autoDelete": "Automatische Löschung geplant für",
"mc2.badgeBronze": "Bronze",
"mc2.badgeGold": "Gold",
"mc2.badgeSilver": "Silber",
"mc2.boostEarnedAlready": "Es hat Ihnen bereits eingebracht",
"mc2.boostEarnedWin": "Es hat Ihnen eingebracht",
"mc2.boostExpiredWin": "Ihr Boost ist gerade abgelaufen — erneuern Sie sich mit -20%!",
"mc2.boostExpiresIn": "Ihr Boost läuft in",
"mc2.boostWinDetail2": ". -20% werden automatisch angewendet, wenn Sie innerhalb von 24 Stunden erneuern.",
"mc2.claimCode": "Code einlösen:",
"mc2.codeSentFinder": "Code wurde per E-Mail an den Finder gesendet",
"mc2.daysShort": "{n} Tg",
"mc2.downloadReceipt": "Quittung herunterladen",
"mc2.error": "Fehler {status}",
"mc2.finderAccepted": "Finder akzeptiert — Code per E-Mail gesendet",
"mc2.finderContacts": "Kontaktdaten des Finders/der Finder",
"mc2.followFindo": "Folge Findloop",
"mc2.imgInvalid": "Ungültiges Bild",
"mc2.inactivityNote": " — im Falle von {n} Monaten Inaktivität (DSGVO).",
"mc2.lastActivity": "Letzte Aktivität:",
"mc2.lostEmailTitle": "Ich habe keinen Zugriff mehr auf meine E-Mail",
"mc2.noPhotoPreset": "Noch kein Foto? Wähle ein Standard-Avatar:",
"mc2.paidViaPartner": "Bezahlt (über Partner)",
"mc2.payRecovery": "Zahle die Wiederherstellungsgebühr",
"mc2.paySettle": "Zahlung begleichen",
"mc2.payShipping": "Zahle die Versandgebühr",
"mc2.payUnavailable": "Zahlung nicht verfügbar",
"mc2.peopleFound": "{n} Person(en) glauben, dass sie deinen Artikel gefunden haben",
"mc2.phoneNumber": "Telefonnummer",
"mc2.reactivateAccount": "Mein Konto reaktivieren",
"mc2.reactivated": "Konto reaktiviert",
"mc2.reactivatedThanks": "Konto reaktiviert — Danke für deine Treue!",
"mc2.recoverSmsBtn": "Erhalte meinen Code per SMS",
"mc2.recoverSmsDesc": "Erhalte deinen Anspruchscode per SMS an die Nummer, die in deinem Konto registriert ist.",
"mc2.recoverSmsFallback": "Falls ein Konto mit dieser Nummer existiert, wurde eine SMS gesendet.",
"mc2.renewStayTop": ". Erneuere, um oben zu bleiben und deinen Artikel wiederzuerlangen.",
"mc2.resume20": "Fortsetzen -20%",
"mc2.unlockContacts": "Kontaktdaten freischalten",
"mc2.unlockDesc": "Zahle die Bearbeitungsgebühr von Findloop, um ihre Kontaktdaten preiszugeben und die Übergabe zu vereinbaren.",
"mc2.viewsWord": "Ansichten",
"mc2.live": "Live",
"mh.allCategories": "Alle Kategorien",
"mh.allPeriod": "Alle Zeiten",
"mh.autoMatch": "Auto KI-Zuordnung",
"mh.blocked": "Blockiert (Widerspruch)",
"mh.blockedReason": "Zuordnung blockiert: Die Hauptkeywords des Artikels und die Erklärung widersprechen sich.",
"mh.days30": "Letzte 30 Tage",
"mh.days7": "Letzte 7 Tage",
"mh.days90": "Letzte 90 Tage",
"mh.emptyDesc": "KI-Zuordnungen erscheinen hier, sobald Erklärungen eingehen.",
"mh.emptyTitle": "Keine Ereignisse",
"mh.exportCsv": "Exportiere CSV",
"mh.exportDone": "CSV-Export heruntergeladen",
"mh.exportImpossible": "Export fehlgeschlagen",
"mh.fBlocked": "Blockiert",
"mh.fConfirmed": "Bestätigt",
"mh.fRejected": "Abgelehnt",
"mh.objectLabel": "Artikel:",
"mh.refresh": "Aktualisieren",
"mh.rejected": "Abgelehnt",
"mh.srcManual": "Manuell",
"mh.srcText": "Text",
"mh.srcVisual": "Visuell (Foto)",
"mh.subtitle": "Protokoll der von der KI vorgeschlagenen Zuordnungen — automatisch zugeordnet, bestätigt und abgelehnt.",
"mh.title": "KI-Historie",
"nav.ranking": "Rangliste",
"nf.desc": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
"nf.home": "Zurück zur Startseite",
"nf.title": "Seite nicht gefunden",
"par.allCities": "Alle Städte",
"par.cityPh": "Stadt",
"pay.addr1": "Adresse",
"pay.addr2": "Adresszeile 2 (optional)",
"pay.addrIncomplete": "Bitte fülle deine Lieferadresse aus.",
"pay.city": "Stadt",
"pay.country": "Land",
"pay.eurNote": "Beträge in Euro (€) angegeben.",
"pay.free": "frei",
"pay.howRecover": "Wie möchten Sie Ihren Artikel zurückbekommen?",
"pay.pickup": "Persönlich abholen",
"pay.pickupDesc": "In",
"pay.postal": "Postleitzahl",
"pay.ship": "Zu mir schicken",
"pay.shipDesc": "Lieferung an meine Adresse",
"pay.shipping": "Versandgebühr",
"pcat.city_hall": "Rathäuser",
"pcat.hotel": "Hotels",
"pcat.other": "Sonstige",
"pcat.park": "Parks",
"pcat.prefecture": "Präfekturen",
"pcat.restaurant": "Restaurants",
"pcat.uncategorized": "Nicht kategorisiert",
"pd.about": "Über",
"pd.back": "Alle Partner",
"pd.certified": "Zertifizierter Partner",
"pd.declare": "Hier einen Verlust melden",
"pd.itemsReturned": "Artikel zurückgegeben",
"pd.itemsTotal": "Artikel registriert",
"pd.map": "Standort",
"pd.noItems": "Kürzlich keine Artikel gefunden.",
"pd.noReviews": "Noch keine Bewertungen.",
"pd.notFound": "Partner nicht gefunden.",
"pd.recentItems": "Kürzlich gefundene Artikel",
"pd.reply": "Antwort vom Etablissement",
"pd.reviews": "Kundenbewertungen",
"pd.verified": "Verifizierte Bewertung",
"pd.verifiedEstablishment": "Findloop verifiziertes Etablissement",
"pg.next": "Weiter",
"pg.prev": "Zurück",
"pg.showing": "{from}–{to} von {total}",
"pk.bodyCopy": "Haupttext",
"pk.bodyText": "Textkörper",
"pk.brandColors": "Markenfarben",
"pk.colorRed": "Rot",
"pk.colorWhite": "Weiß",
"pk.darkBg": "Dunkler Hintergrund",
"pk.download": "Herunterladen",
"pk.downloadZip": "Das gesamte Kit herunterladen (ZIP)",
"pk.headings": "Überschriften",
"pk.heroDesc": "Offizielle Logos, Social-Media-Banner, Farben und Typografie. Wählen Sie die Sprache und Variante des Slogans aus und laden Sie dann das visuelle Material oder das vollständige Kit herunter.",
"pk.lightBg": "Heller Hintergrund (Druck)",
"pk.logoWordmark": "Logo / Wortmarke",
"pk.logosVisuals": "Logos & visuelle Materialien",
"pk.mapCollect": "Karte / Abholpunkte",
"pk.plain": "Einfach",
"pk.pressKit": "Pressekit",
"pk.taglineLang": "Sprache des Slogans",
"pk.typography": "Typografie",
"pk.variant": "Variante",
"pr2.adBoostMsg": "Tolle Wahl! Sie vervielfachen Ihre Chancen, Ihren Artikel schnell zurückzubekommen.",
"pr2.boostActivated": "Boost aktiviert!",
"pr2.canRecoverNow": "Sie können jetzt Ihren Artikel zurückbekommen.",
"pr2.continue": "Fortfahren",
"pr2.downloadReceiptPdf": "Quittung herunterladen (PDF)",
"pr2.goToSpaceNow": "Gehe jetzt zu meinem Konto",
"pr2.partnerBoostMsg": "Großartige Wahl! Sichtbarer zu sein bedeutet, neue Kunden zu Ihrem Geschäft zu ziehen.",
"pr2.paymentSuccess": "Zahlung erfolgreich!",
"pr2.redirectingSpace": "Weiterleitung zu Ihrem Konto…",
"pr2.subActivated": "Zahlung erfolgreich! Ihr Abonnement ist aktiv, Sie können jetzt Ihre Betriebe verwalten.",
"prev.allSites": "Alle Betriebe",
"pricing.annual": "Jährlich",
"pricing.annualBadge": "-20% Angebot",
"pricing.monthly": "Monatlich",
"pricing.perYear": "/Jahr",
"pricing.quoteMsg": "Ihre Bedürfnisse (optional)",
"pricing.quoteOrg": "Organisation",
"pricing.quoteSend": "Anfrage senden",
"pricing.quoteSent": "Anfrage gesendet! Wir werden uns bald bei Ihnen melden.",
"pricing.quoteSites": "Anzahl der Standorte / Terminals",
"pricing.quoteTitle": "Angebot anfordern",
"pricing.requestQuote": "Angebot anfordern",
"pub.accessGranted": "Zugriff gewährt",
"pub.accessLimited2h": "Zugriff auf 2 Stunden beschränkt",
"pub.accountEmailConcerned": "E-Mail des betroffenen Kontos",
"pub.adAppearPublic": "So wird Ihre Anzeige öffentlich angezeigt.",
"pub.adPreviewBtn": "Anzeigevorschau",
"pub.alertMeOnArrival": "Benachrichtigen Sie mich bei Ankunft",
"pub.allActionsLogged": "Alle Aktionen werden protokolliert",
"pub.allCategories": "Alle Kategorien",
"pub.authorizeAccess": "Zugriff autorisieren",
"pub.authorizeSupportQ": "Zugriff für den Support autorisieren?",
"pub.available": "Verfügbar",
"pub.backHome": "Zurück zur Startseite",
"pub.boostAdCta": "Meine Anzeige hervorheben",
"pub.boostAdTitle": "Heben Sie Ihre Anzeige hervor",
"pub.boostCarouselSub": "Bewegen Sie sich an die Spitze der Seite im „Hervorgehobenen“ Karussell und multiplizieren Sie die Sichtungen, um Ihr Objekt schneller zurückzuerhalten.",
"pub.boostEstablishment": "Heben Sie Ihren Betrieb hervor",
"pub.boostEstablishmentDesc": "Erscheinen Sie oben im Verzeichnis mit einem „Hervorgehoben“-Badge und ziehen Sie mehr Meldungen an.",
"pub.boostFicheCta": "Mein Inserat hervorheben",
"pub.brandReady": "Die Marke Findloop, bereit zur Nutzung",
"pub.cantFindItem": "Artikel nicht gefunden?",
"pub.cantProcessImage": "Bild kann nicht verarbeitet werden",
"pub.claimQr": "QR-Code beanspruchen",
"pub.clickToZoom": "Klicken Sie zum Vergrößern",
"pub.codeAlreadyValidated": "Code validiert — Kontakte freigeschaltet.",
"pub.codeExample": "z.B. ABCD2345",
"pub.confirmRenewal": "Erneuerung bestätigen",
"pub.contactIntro": "Eine Frage, eine Anfrage? Schreiben Sie uns, wir melden uns bald bei Ihnen.",
"pub.contactTypeDeceased": "Kontolöschung (verstorbenes Person)",
"pub.contactTypeGeneral": "Allgemeine Frage",
"pub.contactTypeSupport": "Support / technisches Problem",
"pub.contactUs": "Kontaktieren Sie uns",
"pub.continueWithoutEmail": "Weiter ohne meine E-Mail zu hinterlassen",
"pub.contractLabel": "Vertrag",
"pub.contractNotFound": "Vertrag nicht gefunden oder bereits abgelaufen.",
"pub.contractRenewed": "Vertrag erneuert!",
"pub.contractRenewedFor": "Ihr Vertrag wurde für {n} Monate erneuert.",
"pub.copyFailed": "Kopieren fehlgeschlagen",
"pub.createPartnerAccount": "Mein Partnerkonto erstellen",
"pub.currentDeadline": "Aktuelle Frist",
"pub.deceasedInfo": "Als Verwandter oder Erbe können Sie die Löschung des findloop-Kontos einer verstorbenen Person beantragen. Wir werden Ihre Anfrage gemäß der DSGVO bearbeiten (unterstützende Dokumente können angefordert werden).",
"pub.declareMyLoss": "Ich möchte meinen Verlust melden",
"pub.describeItemPlaceholder": "Beschreiben Sie Ihren Artikel (z.B. schwarzer Regenschirm, Schlüssel…)",
"pub.downloadImage": "Bild herunterladen",
"pub.drawSignature": "Bitte zeichnen Sie Ihre Unterschrift.",
"pub.drawSignatureHint": "Zeichnen Sie Ihre Unterschrift mit der Maus oder dem Finger.",
"pub.duration": "Dauer",
"pub.eSignature": "Elektronische Unterschrift",
"pub.eSignatureDesc": "Geben Sie Ihren Namen zur Unterschrift ein. Das Datum wird automatisch aufgezeichnet.",
"pub.edit": "Bearbeiten",
"pub.editorialTitles": "Redaktionelle Titel",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "Geben Sie den per E-Mail erhaltenen Code ein, um die Kontaktdaten des Eigentümers freizuschalten.",
"pub.errorWord": "Fehler",
"pub.foundSelfService": "Gefundene Gegenstände · Selbstbedienung",
"pub.haveOwnerCode": "Ich habe einen Code vom Eigentümer erhalten",
"pub.home": "Startseite",
"pub.immediateRenewal": "Sofortige Verlängerung, ohne neues Angebot.",
"pub.impAdminReq1": "Administrator",
"pub.impAdminReq2": "beantragt die Berechtigung, vorübergehend auf Ihr Konto zuzugreifen",
"pub.impAdminReq3": "um Ihnen zu helfen.",
"pub.impGrantedDesc": "Das Support-Team kann bis zu 2 Stunden auf Ihr Konto zugreifen. Jede Aktion wird protokolliert. Sie können diese Seite schließen.",
"pub.invitedOnFindo": "Sie sind zu Findloop eingeladen",
"pub.isThisYourItem": "Ist das Ihr Gegenstand?",
"pub.itemsAvailableCount": "{n} Gegenstand(e) zurzeit verfügbar",
"pub.itemsFoundOwner": "von vertrauten Gegenständen hat ihren Eigentümer gefunden",
"pub.itemsReturnedOwners": "Gegenstände wurden an ihre Eigentümer zurückgegeben",
"pub.itsMine": "Das gehört mir",
"pub.joinFindoDesc": "Treten Sie Findloop bei und verwalten Sie Ihre gefundenen Gegenstände einfach.",
"pub.joinInvitesYou": "lädt Sie ein, Findloop beizutreten. Erstellen Sie Ihr Partnerkonto, um Ihre gefundenen Gegenstände zu verwalten.",
"pub.linkCopied": "Link kopiert!",
"pub.loadingContract": "Lade den Vertrag…",
"pub.lsClaimDesc": "Melden Sie Ihren Verlust zur Wiedererlangung. Hinterlassen Sie Ihre E-Mail, und wir senden Ihnen eine Erinnerung, falls Ihr Bericht nicht abgeschlossen ist.",
"pub.lsHeroDesc": "Überprüfen Sie selbst, ob Ihr verlorener Gegenstand gefunden und hier abgegeben wurde. Gefunden? Melden Sie es zur Wiedererlangung.",
"pub.lsSearchTitle": "Nach gefundenen Gegenständen suchen",
"pub.makeOffer": "Ein Angebot machen",
"pub.makeOfferDesc": "Schlagen Sie Ihren Betrag vor. Der Superadmin wird es prüfen.",
"pub.mapNearYou": "Gegenstände & Partner in Ihrer Nähe",
"pub.mapWord": "Karte",
"pub.messageSentToast": "Nachricht gesendet — unser Team wird in Kürze antworten.",
"pub.messageWord": "Nachricht",
"pub.momoInitiated": "Mobile Money-Zahlung initiiert",
"pub.monthsWord": "Monate",
"pub.nameConsentRequired": "Name und Zustimmung erforderlich.",
"pub.newDeadline": "Neue Frist",
"pub.noActionRequired": "Keine Aktion erforderlich.",
"pub.noAmountCharged": "Es wurde kein Betrag berechnet.",
"pub.noItemMatch": "Momentan passt kein verfügbarer Gegenstand zu Ihrer Suche.",
"pub.noMatchingItem": "Kein passender Gegenstand",
"pub.noPaymentSession": "Keine Zahlungssitzung.",
"pub.noPhoto": "Kein Foto",
"pub.noPointsYet": "Noch keine Punkte zur Anzeige.",
"pub.noSecondPayment": "Für diesen Gegenstand ist keine zweite Zahlung erforderlich.",
"pub.notHereYet": "Noch nicht hier? Lassen Sie sich benachrichtigen, sobald es ankommt.",
"pub.notifyDone": "Notiert! Wir benachrichtigen Sie per E-Mail, sobald ein passender Gegenstand ankommt.",
"pub.offerSubmitted": "Ihr Angebot wurde eingereicht.",
"pub.oops": "Ups",
"pub.orAlertEmail": "Oder lassen Sie sich per E-Mail benachrichtigen, sobald ein passender Gegenstand ankommt:",
"pub.ownerContacts": "Kontaktdaten des Eigentümers",
"pub.ownerContactsUnlocked": "Kontaktdaten des Eigentümers freigeschaltet",
"pub.partnerContact": "Partnerkontakt",
"pub.payLinkUnavailable": "Zahlungslink nicht verfügbar — kontaktieren Sie den Partner.",
"pub.paymentCancelled": "Zahlung abgebrochen",
"pub.paymentConfirmed": "Zahlung bestätigt 🎉",
"pub.paymentConfirmedDesc": "Sie erhalten eine E-Mail mit den Details zur Wiedererlangung Ihres Gegenstands.",
"pub.paymentNotConfirmed": "Zahlung nicht bestätigt",
"pub.paymentNotConfirmedDesc": "Die Zahlung konnte nicht verifiziert werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Partner.",
"pub.paymentProcessing": "Zahlung wird bearbeitet. Bitte in Kürze aktualisieren.",
"pub.photoAdded": "✓ Foto hinzugefügt",
"pub.photoRequired": "Ein Foto des Gegenstands ist erforderlich.",
"pub.previewAlt": "Vorschau",
"pub.publish": "Veröffentlichen",
"pub.publishingWord": "Veröffentliche…",
"pub.qty": "Menge",
"pub.quoteDeclined": "Angebot abgelehnt.",
"pub.quoteNotFound": "Angebot nicht gefunden oder abgelaufen.",
"pub.reasonLabel": "Grund",
"pub.recoveryAlreadyPaid": "Rückgewinnungsgebühr bereits bezahlt",
"pub.referralCode": "Empfehlungscode:",
"pub.relationshipPlaceholder": "Sohn, Ehepartner, Notar…",
"pub.renewYourContract": "Verlängern Sie Ihren Vertrag",
"pub.renewalFailed": "Verlängerung fehlgeschlagen. Bitte später erneut versuchen.",
"pub.renewing": "Wird verlängert…",
"pub.replySoon": "Unser Team wird so schnell wie möglich antworten.",
"pub.requestGone": "Diese Anfrage existiert nicht mehr.",
"pub.requestHandled": "Anfrage bereits bearbeitet",
"pub.requestNotFound": "Anfrage nicht gefunden oder abgelaufen.",
"pub.requestUnavailable": "Anfrage nicht verfügbar",
"pub.required": "(erforderlich)",
"pub.retroClosing": "Gemeinsam machen wir die Welt ein wenig weniger verloren.",
"pub.retroClosing2": "Gemeinsam machen wir die Welt ein wenig weniger verloren.",
"pub.retroScroll": "Ein Jahr, in dem wir das Wichtigste zurückgewinnen. Nach unten scrollen ↓",
"pub.revokeAnytime": "Sie können jederzeit widerrufen, indem Sie uns kontaktieren",
"pub.scene": "Szene",
"pub.sendImpossible": "Versand nicht möglich",
"pub.sendMessage": "Nachricht senden",
"pub.sending": "Senden…",
"pub.sharePreview": "Vorschau teilen",
"pub.shareYourAd": "Teilen Sie Ihre Anzeige",
"pub.signedSuccess": "Erfolgreich unterschrieben!",
"pub.signerFullName": "Vollständiger Name des Unterzeichners",
"pub.spreadNetwork": "Teilen Sie es mit den Menschen um Sie herum, um Ihre Chancen zu erhöhen.",
"pub.spreadOwner": "Teilen Sie es, um dem Eigentümer zu helfen, seine Besitztümer zurückzubekommen.",
"pub.statusLabel": "Status:",
"pub.subject": "Betreff",
"pub.thanksSent": "Danke, Ihre Nachricht wurde gesendet.",
"pub.thisYear": "Dieses Jahr",
"pub.validate": "Validieren",
"pub.verifyingPayment": "Zahlung wird überprüft…",
"pub.verifyingYourPayment": "Ihre Zahlung wird überprüft…",
"pub.viewAd": "Anzeige anzeigen →",
"pub.viewPartner": "Partner anzeigen →",
"pub.yourAdPreview": "Vorschau Ihrer Anzeige",
"pub.yourEmail": "Ihre E-Mail",
"pub.yourEmailRecommended": "Ihre E-Mail (empfohlen)",
"pub.yourEmailShort": "Ihre E-Mail",
"pub.yourName": "Ihr Name",
"pub.yourRelationship": "Ihr Verhältnis zur Person",
"qv.acceptAndSign": "Angebot akzeptieren und unterschreiben",
"qv.certifyAuthorized": "Ich bescheinige, dass ich berechtigt bin zu unterschreiben und die Bedingungen dieses {what} (bindender Wert) akzeptiere.",
"qv.clear": "Löschen",
"qv.client": "Kunde",
"qv.conditions": "Bedingungen",
"qv.confirmDecline": "Die Ablehnung dieses Angebots bestätigen?",
"qv.countersignedFindo": "Gegengezeichnet von Findloop · {name} am {date}",
"qv.decline": "Ablehnen",
"qv.description": "Beschreibung",
"qv.downloadPdf": "PDF herunterladen",
"qv.handwrittenSignature": "Handschriftliche Unterschrift",
"qv.inclTax": "inkl. MwSt.",
"qv.invalidAmount": "Ungültiger Betrag.",
"qv.invoice": "Rechnung",
"qv.invoicePaid": "Rechnung bezahlt",
"qv.issuer": "Aussteller",
"qv.messageOptional": "Nachricht (optional)",
"qv.negotiatedAmount": "Verhandelter Betrag",
"qv.payInvoiceOnline": "Rechnung online bezahlen",
"qv.quote": "Angebot",
"qv.quoteValidDays": "Angebot gültig für {n} Tage.",
"qv.sendMyOffer": "Mein Angebot senden",
"qv.signContract": "Meinen Vertrag unterschreiben",
"qv.signNow": "Jetzt unterschreiben",
"qv.signatureAlt": "Unterschrift",
"qv.signedByOn": "✔ Unterzeichnet von {name} am {date}",
"qv.stContractSigned": "Vertrag unterschrieben. Danke!",
"qv.stCounterAccepted": "Ihr Angebot wurde angenommen! Unterschreiben Sie Ihren Vertrag unten.",
"qv.stCounterRefused": "Ihr Angebot konnte nicht angenommen werden.",
"qv.stCountered": "Ihr Angebot wurde eingereicht. Warten auf die Antwort von findloop.",
"qv.stDeclined": "Sie haben dieses Angebot abgelehnt.",
"qv.stSigned": "Angebot angenommen und unterschrieben. Danke!",
"qv.totalHt": "Gesamtbetrag excl. MwSt.",
"qv.totalTtc": "Gesamtbetrag incl. MwSt.",
"qv.unitHt": "Einzelpreis excl. MwSt.",
"qv.vat": "MwSt.",
"qv.yourProposedAmount": "Ihr vorgeschlagener Betrag ({cur})",
"reg.add": "Einen Artikel erfassen",
"reg.allBrands": "Alle Marken",
"reg.allColors": "Alle Farben",
"reg.allLocations": "Alle Standorte",
"reg.detailDesc": "Details und Aktionen für diesen gefundenen Artikel.",
"reg.dispAuction": "Auktion",
"reg.dispAuthorities": "Behörden übergeben",
"reg.dispDestroyed": "Zerstört",
"reg.dispDonate": "Wohltätige Spende",
"reg.dispositionHint": "Erfassen Sie den Artikel, der das Lager verlässt. In der Statistik nach Kategorie gezählt.",
"reg.emptyCta": "Einen Artikel erfassen",
"reg.emptyDesc": "Beginnen Sie mit der Erfassung Ihres ersten gefundenen Artikels.",
"reg.emptyTitle": "Keine Artikel gefunden",
"reg.establishmentFallback": "das Etablissement",
"reg.lblAuctioned": "bei Auktion gelistet",
"reg.lblAuctionedShort": "versteigert",
"reg.lblAuthorities": "den Behörden übergeben",
"reg.lblDestroyed": "zerstört",
"reg.lblDonated": "an eine Wohltätigkeit gespendet",
"reg.legalCount": "{n} Artikel: gesetzliche Aufbewahrungsfrist erreicht",
"reg.legalHint": "Sie können sie versteigern, an eine Wohltätigkeit spenden oder die Übergabe an die Behörden melden.",
"reg.legalLimitCountry": "Frist: {date} · angewendetes Land: {country}",
"reg.legalOver": "Frist abgelaufen: {date} · {country}",
"reg.legalReached": "Gesetzliche Frist erreicht",
"reg.legalReachedFull": "Gesetzliche Aufbewahrungsfrist erreicht",
"reg.limitShort": "Frist",
"reg.location": "Standort",
"reg.markRestituted": "Als retourniert markieren",
"reg.markedAs": "Artikel als {label} markiert",
"reg.moveHistory": "Bewegungshistorie",
"reg.overBy": "über {n}d",
"reg.physicalLocation": "Physischer Standort",
"reg.popupBlocked": "Erlaube Pop-ups, um die Etiketten zu drucken.",
"reg.popupBlockedOne": "Erlaube Pop-ups, um das Etikett zu drucken.",
"reg.printLabel": "Etikett drucken",
"reg.printN": "{n} Etikett(e) drucken",
"reg.qrCodeItem": "Artikel QR-Code",
"reg.qrLabelTitle": "QR-Etikett",
"reg.qrLabelsTitle": "QR-Etiketten",
"reg.qrNotFound": "Kein Artikel für diesen QR-Code gefunden.",
"reg.qrScanHint": "Scanne es, um diesen Datensatz direkt zu öffnen und den Standort zu finden.",
"reg.recoveryFee": "Rückholgebühr (€)",
"reg.searchPh": "Nach Beschreibung suchen…",
"reg.selectQr": "Wählen um QR-Etiketten zu drucken",
"reg.selectedN": "{n} ausgewählt",
"reg.shipPricePh": "Versandpreis (€)",
"reg.shippingPossible": "Versand verfügbar",
"reg.storagePh": "z.B. Regal A3, Fach 12",
"reg.tAuction": "Auktion auf Findloop",
"reg.tAuthorities": "Übergabe an die Behörden melden",
"reg.tDonate": "An eine Wohltätigkeitsorganisation spenden",
"reg.toastFee": "Gebühr aktualisiert",
"reg.toastLocation": "Standort gespeichert",
"reg.toastRestituted": "Artikel als zurückgegeben markiert",
"reg.toastShipping": "Versandoption aktualisiert",
"reg.toastTransferred": "Artikel an „{name}“ übertragen",
"reg.unclaimedDisposition": "Unclaimed item — endgültige Verfügung",
"res.codeValidated": "Code validiert",
"res.empty": "Keine Rückgabe aufgezeichnet.",
"res.error": "Fehler {status}",
"res.proofPdf": "PDF-Nachweis",
"res.signed": "Unterzeichnet",
"res.stRestituted": "Persönlich übergeben",
"res.stShipped": "Per Versand zurückgegeben",
"res.subtitle": "Alle abgeschlossenen Übergaben mit ihrem herunterladbaren unterschriebenen Nachweis.",
"res.title": "Rückgabeverlauf",
"rev.restitutedBy": "Zurückgegeben von {org}",
"rev.storiesEyebrow": "Glückliche Enden",
"rev.storiesSubtitle": "Echte Geschichten von Kunden, die ihre Sachen mit Findloop zurückbekamen.",
"rev.storiesTitle": "Sie haben ihre Sachen gefunden!",
"rp.duplicate": "Duplikat",
"rp.inappropriate": "Unangemessener Inhalt",
"rp.wrongCategory": "Falsche Kategorie",
"rt.annualGoal": "Jahresziel",
"rt.championCity": "Champions-Stadt",
"rt.cityRate": "{rate}% Rückquote",
"rt.goalProgress": "{rate}% erreicht von einem {target}% Ziel",
"rt.reached": "Erreicht 🎉",
"rt.restitutionRate": "Rückgabequote",
"rt.shareRecap": "Teile meine Zusammenfassung",
"rt.thanks": "Danke Findloop {year} 💛",
"rt.yourRecap": "Deine Zusammenfassung {year}",
"rw.active": "Aktiv",
"rw.add": "Hinzufügen",
"rw.camUnavailable": "Kamera nicht verfügbar. Geben Sie den Code manuell unten ein.",
"rw.codeValidated": "Code validiert",
"rw.codesTitle": "Von Findern eingelöste Codes",
"rw.confirmDelete": "„{title}“ löschen?",
"rw.deleted": "Gelöscht",
"rw.edit": "Bearbeiten",
"rw.editReward": "Belohnung bearbeiten",
"rw.empty": "Noch keine Belohnung.",
"rw.expired": "Abgelaufen",
"rw.expiresOn": "Läuft ab am {date}",
"rw.fActive": "Aktiv (sichtbar für Finder)",
"rw.fCost": "Kosten (Punkte)",
"rw.fDesc": "Beschreibung",
"rw.fStock": "Bestand (leer = unbegrenzt)",
"rw.fTitle": "Titel",
"rw.fValidity": "Gültigkeit des Gutscheins (Tage nach Einlösung)",
"rw.inactive": "Inaktiv",
"rw.newReward": "Neue Belohnung",
"rw.noExchange": "Noch keine Einlösung.",
"rw.pageSubtitle": "Scanne die von den Findern präsentierten Gutscheine, um ihre Belohnungen zu validieren.",
"rw.redeemedN": "Eingelöst: {n}×",
"rw.saved": "Belohnung gespeichert",
"rw.scanVoucher": "Gutschein scannen",
"rw.staffScanOnly": "Nur scannen",
"rw.statActive": "Zu präsentieren",
"rw.statExpired": "Abgelaufen",
"rw.statRedeemed": "Gutscheine eingelöst",
"rw.statUsed": "Validiert",
"rw.stock": "Bestand",
"rw.subtitle": "Biete nicht-monetäre Vergünstigungen (Gutscheine, Upgrades…) an, die Finder für ihre Finder Score Punkte einlösen.",
"rw.title": "Belohnungen für Finder",
"rw.used": "Verwendet",
"rw.validate": "Validieren",
"rw.validateCode": "Den Code validieren",
"rw.validity": "Gültigkeit: {n} T",
"side.establishments": "Einrichtungen",
"side.restitutions": "Rückgaben",
"side.storage": "Lager & QR",
"status.auctioned": "Versteigert",
"status.destroyed": "Zerstört",
"status.donated": "Gespendet (Wohltätigkeit)",
"status.handed_to_authorities": "Den Behörden übergeben",
"status.in_storage": "Im Lager",
"status.matched": "Zugeordnet",
"status.open": "Offen",
"status.paid": "Bezahlt",
"status.pending": "Ausstehend",
"status.restituted": "Zurückgegeben",
"status.shipped": "Versandt",
"status.shipping_requested": "Versand angefordert",
"status.submitted": "Eingereicht",
"stg.allLabels": "Alle QR-Labels",
"stg.camHint": "Nutze die manuelle Eingabe unten.",
"stg.camStarting": "Kamera wird gestartet…",
"stg.camUnavailable": "Kamera nicht verfügbar.",
"stg.clear": "Löschen",
"stg.clearAll": "Alles löschen",
"stg.codeUnreadable": "Code nicht lesbar.",
"stg.emptyDesc": "Gespeicherte Artikel erscheinen hier, gruppiert nach Standort.",
"stg.emptyTitle": "Kein Artikel im Lager",
"stg.exportAudit": "Audit-CSV exportieren",
"stg.exportDone": "CSV-Export heruntergeladen",
"stg.exportImpossible": "Export momentan nicht verfügbar.",
"stg.itemFound": "Artikel gefunden ✅",
"stg.kLocations": "Verwendete Standorte",
"stg.kObjects": "Gespeicherte Artikel",
"stg.kToClear": "Standorte zum Löschen",
"stg.locFreed": "Standort gelöscht",
"stg.locsFreed": "{n} Standort(e) gelöscht",
"stg.manualLabel": "Oder geben Sie den Code / die ID des Artikels ein",
"stg.manualPh": "Fügen Sie die ID oder URL des QR-Codes ein",
"stg.noItemMatch": "Kein Artikel entspricht diesem QR-Code / Code.",
"stg.noLocation": "Kein Standort",
"stg.objectsAxis": "Artikel",
"stg.objectsN": "{n} Artikel",
"stg.occAvg": "durchschnittlich {n} Artikel/Standort",
"stg.occHint": "Standorte in Amber überschreiten den Durchschnitt (potenziell überlastet).",
"stg.occupancy": "Standortbelegung",
"stg.openPage": "Seite öffnen",
"stg.posterPdf": "PDF-Plakat (A4)",
"stg.printAll": "Alle drucken",
"stg.printGroupTitle": "Etiketten für dieses Regal drucken",
"stg.qrAlt": "Self-Service QR",
"stg.qrDownload": "QR herunterladen",
"stg.qrHint": "Zeigen Sie diesen QR an der Theke an: Ihre Kunden scannen ihn, um zu überprüfen, ob ihr Artikel verfügbar ist.",
"stg.qrTitle": "QR für den Kunden-Self-Service",
"stg.scanDesc": "Scannen Sie das Etikett eines Artikels, um sofort auf seinen Datensatz zuzugreifen.",
"stg.scanQr": "QR scannen",
"stg.scanTitle": "QR-Code scannen",
"stg.search": "Suche",
"stg.shelf": "Regal {loc}",
"stg.shelfPlan": "Regalplan",
"stg.staleHint": "Löschen Sie diese Standorte, um Ihr physisches Inventar aktuell zu halten.",
"stg.staleTitle": "{n} Artikel wurden aus dem Lager entfernt, behalten jedoch einen Standort",
"stg.subtitle": "Regalplan, QR-Scanner und physische Inventarverfolgung.",
"stg.title": "Lager & QR",
"stt.acceptRate": "Akzeptanzrate",
"stt.accepted": "Akzeptiert",
"stt.activity30": "Aktivität (letzte 30 Tage)",
"stt.ai6mo": "Letzte 6 Monate · akzeptiert = automatisch zugeordnet + bestätigt.",
"stt.aiEmpty": "Keine KI-Zuordnungen in diesem Zeitraum bisher.",
"stt.aiTitle": "KI-Zuordnungen — akzeptiert vs. abgelehnt",
"stt.auctionShort": "Auktion",
"stt.auctionedSold": "Versteigert (verkauft)",
"stt.authShort": "Behörden",
"stt.authorities": "An Behörden übergeben",
"stt.avgRating": "Durchschnittliche Bewertung",
"stt.awaitingRestitution": "Artikel warten auf Rückgabe",
"stt.boostClicks": "Klicks auf Ihr Verzeichnis diese Woche dank Boost",
"stt.boostInactive": "Boost inaktiv — aktivieren Sie es, um Sichtbarkeit zu erhalten",
"stt.certifiedPremium": "Premium zertifiziert",
"stt.declarations": "Erklärungen",
"stt.destroyed": "Zerstört",
"stt.dispoEmpty": "Kein nicht beanspruchter Artikel hat das Lager bisher verlassen.",
"stt.donatedAssoc": "Gespendet (Wohltätigkeit)",
"stt.donatedShort": "Gespendet",
"stt.gateCta": "Entdecken Sie die Pläne",
"stt.gateDesc": "Upgrade auf Starter, um Ihre Basisstatistiken freizuschalten, oder auf Business für erweiterte Statistiken und Analyse pro Einrichtung.",
"stt.gateTitle": "Statistiken, die für kostenpflichtige Pläne reserviert sind",
"stt.inStorage": "Im Lager",
"stt.kItems": "Registrierte Artikel",
"stt.kRate": "Rückgaberate",
"stt.kRestituted": "Rückgegebene Artikel",
"stt.kRevenue": "Umsatz (Monat)",
"stt.noDeclYet": "Keine Erklärungen bisher.",
"stt.recapDownloaded": "Zusammenfassung heruntergeladen — bereit zum Teilen!",
"stt.recapError": "Konnte die Zusammenfassung nicht erstellen",
"stt.recapText": "Unser Findloop {year} Rückblick: retournierte Artikel und Kundenzufriedenheit 🎉",
"stt.recapTitle": "Findloop {year} Rückblick",
"stt.rejected": "Abgelehnt",
"stt.restitutions": "Rücksendungen",
"stt.shareRecap": "Teile meinen {year} Rückblick",
"stt.topCategories": "Am häufigsten angegebene Kategorien",
"stt.unclaimedDesc": "Volumen der Artikel, die nach Kategorie zerstört, gespendet oder versteigert wurden.",
"stt.unclaimedTitle": "Unbeordnete Artikel – verlassen das Lager",
"stt.vsLastWeek": "im Vergleich zur letzten Woche",
"sub.cancel": "Mein Abonnement kündigen",
"sub.cancelAbort": "Abbrechen",
"sub.cancelConfirm1": "Sind Sie sicher, dass Sie kündigen möchten? Ihr Zugang bleibt bis",
"sub.cancelConfirm2": "ohne Rückerstattung.",
"sub.cancelConfirmBtn": "Kündigung bestätigen",
"sub.cancelTitle": "Kündigen Sie Ihr Abonnement",
"sub.cancelledToast": "Kündigung aufgezeichnet.",
"sub.cguAnd": "und die",
"sub.cguDesc": "Bitte bestätigen Sie Ihre Zustimmung vor der Zahlung.",
"sub.cguLink": "Nutzungsbedingungen",
"sub.cguPay": "Weiter zur Zahlung",
"sub.cguPre": "Ich habe die",
"sub.cguRequired": "Sie müssen die Nutzungsbedingungen und die Datenschutzrichtlinie akzeptieren, um fortzufahren.",
"sub.cguSuffix": "von findloop.",
"sub.cguTitle": "Schließen Sie Ihr Abonnement ab",
"sub.expiresOn": "Ihr Abonnement läuft ab am",
"sub.noProrata": "Keine anteilige Rückerstattung.",
"sub.privacyLink": "Datenschutzrichtlinie",
"sub.renewsOn": "Ihr Abonnement wird erneuert am",
"sub.resume": "Wieder abonnieren",
"sub.resumedToast": "Wiederanmeldung bestätigt.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Business",
"tier.small": "Starter",
"tm.add": "Hinzufügen",
"tm.adminOpt": "Admin (vollständige Ansicht)",
"tm.chooseEst": "Wählen Sie eine Einrichtung",
"tm.chooseEstPh": "Wählen Sie eine Einrichtung",
"tm.copyFail": "Kopieren fehlgeschlagen",
"tm.copyLink": "Link kopieren",
"tm.copyOk": "Einladungslink kopiert",
"tm.emailHint": "Eine Einladung per E-Mail wird gesendet, um das Passwort zu erstellen.",
"tm.expiresOn": "läuft ab am {date}",
"tm.forEmail": " für {email}",
"tm.forbidden": "Das Teammanagement ist dem Kontoinhaber vorbehalten.",
"tm.inviteCreated": "Einladung erstellt",
"tm.inviteDesc": "Eine Einladung per E-Mail ermöglicht es dem Teammitglied, ihr Passwort zu erstellen.",
"tm.invitePending": "Ausstehende Einladung",
"tm.inviteResent": "Einladung erneut gesendet",
"tm.inviteSent": "Einladung per E-Mail gesendet",
"tm.inviteTitle": "Mitglied einladen",
"tm.invitedOn": "Eingeladen am {date}",
"tm.linkExpired": "Link abgelaufen",
"tm.memberRemoved": "Mitglied entfernt",
"tm.name": "Name",
"tm.noMembers": "Noch kein Teammitglied.",
"tm.resendTitle": "Einladung erneut senden",
"tm.role": "Rolle",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Besitzer",
"tm.roleStaff": "Mitarbeiter",
"tm.roleUpdated": "Rolle aktualisiert",
"tm.sendInvite": "Einladung senden",
"tm.sending": "Wird gesendet…",
"tm.staffOpt": "Mitarbeiter (sieht nur ihre Einrichtung)",
"trk.carrier": "Transporteur",
"trk.codeValidated": "Code vom Partner validiert",
"trk.dlProof": "Lade meinen Übergabe-Proof (PDF) herunter",
"trk.enterEmailCode": "Geben Sie Ihre E-Mail oben ein, um Ihren Anspruchscode anzuzeigen.",
"trk.lostEmail": "Ich habe keinen Zugang mehr zu meiner E-Mail",
"trk.phonePh": "Ihre Telefonnummer",
"trk.photoBefore": "Foto des Artikels vor dem Versand",
"trk.recoverHint": "Erhalten Sie Ihren Anspruchscode per SMS auf Ihre registrierte Nummer.",
"trk.secureRest": "Sichere Übergabe",
"trk.send": "Senden",
"trk.shipPending": "Sendung wird vorbereitet — die Sendungsnummer wird hier angezeigt, sobald sie versendet wurde.",
"trk.shipTitle": "Sendungsverfolgung",
"trk.showQr": "Zeigen Sie diesen QR-Code dem Partner, um die Übergabe zu validieren",
"trk.sigSaved": "Unterschrift gespeichert",
"trk.signFirst": "Bitte unterschreiben Sie, bevor Sie bestätigen.",
"trk.signProof": "Unterschreiben Sie Ihren Übergabe-Proof",
"trk.signSubmit": "Bestätigen Sie meine Unterschrift und generieren Sie das PDF",
"trk.trackShipment": "Paket verfolgen",
"trk.trackingNo": "Sendungsnummer",
"trk.yourCode": "Ihr Anspruchscode (um ihn dem Partner zu geben)",
"pricing.physModalTitle": "Verwaltung physischer Artikel",
"pricing.physQrDesc": "Ein einzigartiger QR-Code wird pro Artikel generiert und verlinkt alle Informationen dazu.",
"pricing.physQrTitle": "Dediziertes QR-Etikett",
"pricing.physShelfDesc": "Jeder registrierte Artikel kann einen physischen Standort im Geschäft zugewiesen bekommen.",
"pricing.physShelfTitle": "Regalplan",
"pricing.physicalMgmt": "Verwaltung physischer Artikel (Regale, QR, Inventar)",
"pub.addSecondPhoto": "Fügen Sie ein 2. Foto hinzu (optional)",
"pub.photo2Added": "✓ 2. Foto hinzugefügt",
"reg.dispositionJournal": "Dispositionsjournal",
"reg.dispositionNoteAuthHint": "ℹ️ Eine Notiz ist erforderlich für „An Behörden übergeben“ (Berichtnummer, Abteilung…).",
"reg.dispositionNotePh": "Hinweis (optional): empfangende Wohltätigkeitsorganisation, Behördenreferenz, Käufername…",
"reg.dispositionNoteRequired": "Eine offizielle Referenz ist erforderlich, um an die Behörden zu übergeben.",
"reg.legalPrealert": "Rechtliche Frist in {days} Tag(en)",
"reg.legalPrealertOptions": "Optionen bei Fristablauf: Auktion, Spende an eine Wohltätigkeitsorganisation, Übergabe an Behörden.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Vollständige Bewertung",
"rev.readMore": "Mehr lesen",
"rw.activeCodes": "Aktive Gutscheine",
"rw.archived": "Archiviert",
"rw.archivedTitle": "Eingelöste Gutscheine (archiviert)",
"rw.hideArchived": "Eingelöste Gutscheine ausblenden",
"rw.noArchived": "Kein archivierter Gutschein.",
"rw.showArchived": "Eingelöste Gutscheine anzeigen",
"shp.labelAuto": "Das Etikett wird automatisch generiert, sobald der Kunde die Versandkosten bezahlt hat. Es wird hier herunterladbar sein.",
"stt.dispoPdfBtn": "PDF exportieren",
"stt.dispoPdfError": "PDF-Export fehlgeschlagen.",
"stt.dispoPdfExporting": "Wird exportiert…",
"trk.matchVerifying": "Potenzielle Übereinstimmung wird überprüft",
"home.videoSubtitle": "Wie wir verlorene Gegenstände mühelos mit ihren Besitzern wieder vereinen.",
"home.videoTitle": "Entdecke Findloop in 2 Minuten",
"home.watchYoutube": "Auf YouTube ansehen",
"impact.already": "Bereits",
"impact.citiesWord": "Stadt/Städte",
"impact.eachPoint": "Jeder Punkt ist eine Stadt, in der Findloop hilft, verlorene Gegenstände wiederzufinden.",
"impact.emptyMap": "Die Karte füllt sich, während Rückgaben stattfinden.",
"impact.eyebrow": "Unsere Auswirkungen",
"impact.inCities": "in",
"impact.restitutedTo": "Gegenstände, die ihren Eigentümern zurückgegeben wurden",
"impact.title": "Gegenstände überall um dich herum zurückgegeben",
"inv2.download": "Herunterladen",
"inv2.view": "Ansehen",
"map.objectsOnMapPlural": "Gegenstände auf der Karte",
"map.objectsOnMapSingular": "Gegenstand auf der Karte",
"mc.claimConfirmDesc": "Überprüfe den gefundenen Gegenstand, bevor du bezahlst, um die Kontaktdaten des Finders freizuschalten.",
"mc.claimConfirmNo": "Das ist nicht mein Gegenstand",
"mc.claimConfirmTitle": "Ist das wirklich dein Gegenstand?",
"mc.claimConfirmYes": "Ja, er gehört mir — bezahlen",
"mc.claimFinderContacts": "Kontaktdaten des Finders",
"mc.claimNotMineDone": "Danke — der Finder wurde benachrichtigt und deine Anfrage wurde aus der Anzeige entfernt.",
"mc.claimUnlockDesc": "Bezahlen Sie die Findloop Verwaltungsgebühr, um die Kontaktdaten der Person zu erhalten, die Ihren Gegenstand gefunden hat.",
"mc.claimUnlockTitle": "Kontaktdaten des Finders freischalten",
"mc.hideCountryOffers": "Angebote in meinem Land ausblenden",
"mc.myClaims": "Gegenstände, die ich beanspruche",
"mc.myClaimsSub": "Von anderen gefundenen Gegenständen, die du beanspruchst. Entsperre die Kontaktdaten des Finders, um die Übergabe zu organisieren.",
"mc.notifAdCancelled": "Anzeige storniert",
"mc.notifCancelAd": "Meine Anzeige stornieren",
"mc.offersInCountry": "Angebote in meinem Land",
"mc.offersInCountryDesc": "Alle aktiven Belohnungen von Partnern in deinem Land, nach Stadt.",
"mc.redArchived": "Archiviert",
"mc.rewardsCountryNone": "Noch kein Angebot in deinem Land.",
"mc.rewardsForYou": "Belohnungen für dich",
"mc.rewardsForYouDesc": "Angeboten von den Partnern, bei denen du einen Gegenstand abgegeben hast.",
"mc.rewardsMineNone": "Noch keine Belohnung von deinen Abgabe-Partnern.",
"mc.showCountryOffers": "Angebote in meinem Land ansehen",
"mc2.cancelDecl": "Meine Erklärung stornieren",
"mc2.cancelDeclDone": "Erklärung storniert.",
"pricing.physInvDesc": "Wenn ein Gegenstand zurückgegeben wird, wird sein Standort automatisch freigegeben und für einen neuen Gegenstand verfügbar.",
"pricing.physInvTitle": "Physische Bestandsverfolgung",
"a.firstName": "Vorname",
"ac.emailCrossMatch": "B2C-Abgleich",
"ac.emailCrossMatchDesc": "Eine E-Mail, wenn eine öffentliche Anzeige für verlorene Gegenstände mit einem bei Ihnen hinterlegten Gegenstand übereinstimmt",
"ac.emailCrossReject": "Ablehnungen öffentlicher Übereinstimmungen",
"ac.emailCrossRejectDesc": "Erhalten Sie eine E-Mail, wenn ein Kunde angibt, dass ein vorgeschlagener öffentlicher Abgleich nicht ihr Gegenstand ist.",
"ac.emailLoginNotif": "Anmeldebenachrichtigung",
"ac.emailLoginNotifDesc": "Erhalten Sie eine E-Mail, jedes Mal, wenn sich jemand in Ihr Konto einloggt.",
"ad.closeNoCancel": "Nein, die Anzeige entfernen",
"ad.closeQuestion": "Wurde der Gegenstand an Sie zurückgegeben?",
"ad.closeQuestionDesc": "Lassen Sie uns wissen, ob Sie Ihren Gegenstand zurückerhalten haben oder ob Sie einfach diese Anzeige entfernen möchten.",
"ad.closeYesRestituted": "Ja, der Gegenstand wurde zurückgegeben",
"ad.closedRestituted": "Gegenstand zurückgegeben — Anzeige geschlossen 🎉",
"an.lostLoginDesc": "Ein Konto ist erforderlich, um einen verlorenen Gegenstand zu melden und dessen Rückgabe zu verfolgen.",
"an.lostLoginRequired": "Loggen Sie sich ein, um einen verlorenen Gegenstand zu melden",
"an.qfAll": "Alle",
"an.qfBoosted": "Gepusht",
"an.qfPhoto": "Mit Foto",
"an.qfRecent": "Diese Woche",
"an.qfResolved": "Gelöst",
"an.restitutionInProgress": "Gegenstand wird zurückgegeben",
"dec.descPhLong": "Beschreiben Sie den Gegenstand: Marke, Farbe, besondere Merkmale… (Je mehr Details Sie geben, desto höher sind Ihre Chancen, Ihren Gegenstand zurückzubekommen)",
"dec.loadError": "Kann den Partner derzeit nicht laden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
"dec.retry": "Erneut versuchen",
"dec.shippingMode": "Versand",
"dep.photo2": "2. Gegenstandfoto",
"dep.photo2Hint": "Optional — ein weiterer Winkel verbessert die visuelle Übereinstimmung.",
"dl.accountSuspended": "Konto wegen einer unbezahlten Rechnung gesperrt. Begleichen Sie diese, um Ihren Zugang wiederherzustellen.",
"dl.regularize": "Jetzt begleichen →",
"dl.suspensionCountdown": "Rechnung {num} unbezahlte — Ihr Konto wird in {days} Tag(en) gesperrt. Begleichen Sie diese, um dies zu vermeiden.",
"ft.cancelConfirm": "Möchten Sie Ihren Bericht stornieren? Der Besitzer des Gegenstands wird informiert.",
"ft.cancelDone": "Bericht storniert.",
"ft.cancelLocked": "Eine Stornierung ist nicht mehr möglich, nachdem der Besitzer bezahlt hat.",
"ft.cancelReport": "Meinen Bericht stornieren",
"ft.claimCodeHelp": "Geben Sie diesen Code beim Übergeben dem Finder, um zu bestätigen, dass Sie Ihren Gegenstand erhalten haben.",
"ft.claimCodeTitle": "Ihr Rückgabecode",
"ft.claimDone": "Gegenstand zurückgegeben. Danke, dass Sie Findloop verwenden!",
"ft.claimUnlockHint": "Entsperren Sie die Kontaktdaten des Finders",
"ft.claimUnlockHintSub": "Gehen Sie zu \"Gegenstände, die ich einfordere\" in Ihrem Konto, um die Gebühr zu zahlen und die Kontaktdaten zu erhalten.",
"ft.finderCodeShownHelp": "Der Besitzer hat bezahlt und Sie ausgewählt. Kopieren Sie diesen Code unten, um die Rückgabe zu bestätigen — keine Notwendigkeit, Ihre E-Mails zu überprüfen.",
"ft.finderCodeShownTitle": "Validierungscode des Besitzers",
"ft.finderContactsTitle": "Kontaktdaten des Finders",
"ft.foundCodeHelp": "Zeigen Sie diesen Code dem Eigentümer bei der Übergabe vor, um zu bestätigen, dass der Artikel zurückgegeben wurde.",
"ft.inProgressOther": "Artikel wird zurückgegeben",
"ft.inProgressOtherHelp": "Der Eigentümer hat einen anderen Finder für diesen Artikel ausgewählt. Ihrerseits sind keine weiteren Aktionen erforderlich.",
"ft.restitutionCodeHelp": "Dieser Code bestätigt die Artikelübergabe. Er ist bereits unten vorausgefüllt; validieren Sie ihn und schließen Sie den Fall ab.",
"ft.restitutionCodeTitle": "Ihr Rückerstattungscode",
"hc.14Digits": "14 Ziffern",
"hc.15DaysBeforeAnItem": "15 Tage vor der gesetzlichen Frist des Artikels.",
"hc.7DaysBeforeAnItem": "7 Tage vor der gesetzlichen Frist des Artikels.",
"hc.8CharactersMinimum": "Mindestens 8 Zeichen.",
"hc.aClaimToValidate": "Ein Anspruch zur Validierung",
"hc.aFindoAssistanceSessionIs": "Eine findloop-Hilfesitzung ist derzeit auf Ihrem Konto aktiv.",
"hc.aNewMatchHasBeen": "Ein neues Matching wurde gefunden",
"hc.aUser": "Ein Benutzer",
"hc.aUserClaimsToBe": "Ein Benutzer behauptet, der Eigentümer zu sein. Überprüfen Sie deren Antworten, bevor Sie die Rückgabe autorisieren.",
"hc.aboutFindo": "Über Findloop",
"hc.accountActivatedPleaseLogIn": "Konto aktiviert, bitte einloggen.",
"hc.accountActivation": "Konto aktivieren",
"hc.accountCreated": "Konto erstellt!",
"hc.accountDeactivatedAReactivationEmail": "Konto deaktiviert. Eine E-Mail zur Reaktivierung (gültig für 30 Tage) wurde Ihnen gesendet.",
"hc.accountReactivation": "Konto reaktivieren",
"hc.activateMyAccount": "Mein Konto aktivieren",
"hc.activateMyAdminAccount": "Mein Administratorkonto aktivieren",
"hc.activating": "Aktivierung…",
"hc.activeMatchCancelReason": "Aktives Matching. Stornierungsgrund des Kunden: \"{reason}\". Der Artikel wartet noch auf einen Anspruch.",
"hc.activeMatchWithAPublic": "Aktives Matching mit einer öffentlichen (Kunden-)Auflistung. Warte auf den Anspruch des Eigentümers.",
"hc.addAPhoto": "Foto hinzufügen",
"hc.addAndConfigureYourEstablishments": "Fügen Sie Ihre Einrichtungen in \"Einrichtungen\" hinzu und konfigurieren Sie sie: Kontaktdaten, Kategorie und physische Lagerung der Artikel.",
"hc.addOnGoogle": "Bei Google hinzufügen",
"hc.address": "Adresse",
"hc.addressSaved": "Adresse gespeichert",
"hc.addressStreet": "Adresse — Straße",
"hc.adjustThePhoto": "Das Foto anpassen",
"hc.adminFullView": "Administrator (komplette Ansicht)",
"hc.administratorOnly": "Nur für Administratoren",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "KI visuelle Vergleich",
"hc.all": "Alle",
"hc.amount": "Betrag",
"hc.anOrganization": "Eine Organisation",
"hc.analyzing": "Analyse läuft…",
"hc.andRecoveryIs": "und die Wiederherstellung ist",
"hc.andTheDeclarationWillBe": "und die Erklärung wird geschlossen (in die Historie verschoben). Diese Aktion ist endgültig.",
"hc.annual20": "Jährlich -20%",
"hc.annualBilling20": "Jährliche Abrechnung (−20%)",
"hc.annualTarget": "Jährliches Ziel",
"hc.anyCommentsOptional": "Keine Kommentare? (optional)",
"hc.approveTheClaim": "Die Forderung genehmigen",
"hc.archiveCancelledConfirm": "{n} Einträge \"Von Kunde storniert\" archivieren? Sie werden aus dem Register entfernt.",
"hc.asSoonAs": "Sobald",
"hc.askTheOwnerToDisplay": "Den Eigentümer bitten, den QR-Code seines Codes anzuzeigen (Tracking-Seite).",
"hc.askThemAtTheCounter": "Frag sie am Schalter zur Bestätigung der Identität – niemals öffentlich sichtbar.",
"hc.assistance": "Support",
"hc.assistanceSessionRevoked": "Support-Sitzung widerrufen.",
"hc.atLeast6Characters": "Mindestens 6 Zeichen",
"hc.automaticallyPreSelected": "automatisch vorausgewählt",
"hc.automaticallyWhenShipping": "automatisch beim Versand.",
"hc.awaitingClaim": "Warte auf Forderung",
"hc.awaitingPayment": "Warte auf Zahlung",
"hc.b2cCustomer": "B2C-Kunde",
"hc.back": "Zurück",
"hc.backToHome": "Zurück zur Startseite",
"hc.backToMyAccount": "Zurück zu meinem Konto",
"hc.backToPayment": "Zurück zur Zahlung",
"hc.beforeAfterComparisonSlider": "Vorher/Nachher Vergleichsschieberegler",
"hc.billingInformation": "Rechnungsinformationen",
"hc.billingInformationSaved": "Rechnungsinformationen gespeichert ✓",
"hc.brand": "Marke",
"hc.bronze": "Bronze",
"hc.calculatingTheShippingRate": "Versandkosten werden berechnet…",
"hc.cameraUnavailableEnterTheCode": "Kamera nicht verfügbar. Geben Sie den Code manuell ein.",
"hc.cancel": "Abbrechen",
"hc.cancelMyDeclaration": "Meine Erklärung stornieren",
"hc.cancelSavedFmt": "Stornierung gespeichert: \"{reason}\". Sie können weiterhin beanspruchen.",
"hc.cancelTheDeposit": "Die Einzahlung stornieren",
"hc.cancelThisMatch": "Dieses Match stornieren",
"hc.cancellationReason": "Stornierungsgrund",
"hc.cancelled": "Storniert",
"hc.cancelledByTheCustomer": "Vom Kunden storniert",
"hc.cannotOpenPayment": "Zahlung konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.",
"hc.careers": "Karriere",
"hc.carrier": "Transporteur",
"hc.carrierAvailabilityCannotBeChecked": "Die Verfügbarkeit des Transporteurs kann erst überprüft werden, wenn Ihr Sendcloud-Absender konfiguriert ist.",
"hc.carrierConfirmedCharged": "Transporteur bestätigt — {price} € dem Kunden in Rechnung gestellt",
"hc.carrierOther": "Transporteur (sonstiger)",
"hc.carrierSelection": "Auswahl des Transporteurs",
"hc.caseClosedThankYou": "Fall geschlossen. Vielen Dank!",
"hc.category": "Kategorie",
"hc.changeMethod": "Methode ändern",
"hc.characteristic": "Merkmal",
"hc.chargedToCustomer": "dem Kunden in Rechnung gestellt.",
"hc.checkOrEditYourDetails": "Überprüfen oder bearbeiten Sie Ihre Angaben vor der sicheren Zahlung.",
"hc.checkStatisticsToTrackDeposited": "Überprüfen Sie \"Statistiken\", um eingezahlte Artikel, Rücklaufquote und Leistung jedes Unternehmens zu verfolgen.",
"hc.checkTheDetailsBeforeContacting": "Überprüfen Sie die Details, bevor Sie den Finder kontaktieren.",
"hc.checkTheDetailsBelowBefore": "Überprüfen Sie die Details unten, bevor Sie Ihre Rücksendung anfordern.",
"hc.checkTheNewItem": "Überprüfen Sie den neuen Artikel",
"hc.checkThePhotosAndCharacteristics": "Überprüfen Sie die Fotos und Merkmale unten, bevor Sie mit der Wiederbeschaffung fortfahren.",
"hc.chooseACountry": "Wählen Sie ein Land",
"hc.chooseANewPassword": "Wählen Sie ein neues Passwort",
"hc.chooseAReason": "Wählen Sie einen Grund",
"hc.chooseTheLegalRetentionAlerts": "Wählen Sie die rechtlichen Aufbewahrungsbenachrichtigungen, die per E-Mail erhalten werden für",
"hc.chooseYourPasswordToAccess": "Wählen Sie Ihr Passwort, um auf das Administrationskonsole zuzugreifen.",
"hc.city": "Stadt",
"hc.claimApproved": "Anspruch genehmigt",
"hc.claimApproved2": "Anspruch genehmigt.",
"hc.claimCodeExpired": "Anspruchscode abgelaufen",
"hc.claimCodeVerified": "Anspruchscode überprüft",
"hc.claimNotFound": "Anspruch nicht gefunden",
"hc.claimNotValidated": "Anspruch nicht validiert",
"hc.claimRejected": "Anspruch abgelehnt",
"hc.claimRejected2": "Anspruch abgelehnt.",
"hc.claimValidated": "Anspruch validiert",
"hc.claimValidatedByThePartner": "Anspruch vom Partner validiert",
"hc.claimant": "Antragsteller",
"hc.claimsToBeTheOwner": "gibt an, der Eigentümer dieses Artikels zu sein und hat die Überprüfungsfragen beantwortet. Nur genehmigen, wenn die Antworten übereinstimmen.",
"hc.claimsToValidate": "Zu validierende Ansprüche",
"hc.clear": "Löschen",
"hc.clickToZoom": "Klicken zum Vergrößern",
"hc.close": "Schließen",
"hc.close2": "Schließen",
"hc.closeTheDeclaration": "Deklaration schließen",
"hc.closeTheDeclaration2": "Deklaration schließen?",
"hc.codeAlreadyVerified": "Code bereits verifiziert",
"hc.codeCopied": "Code kopiert",
"hc.collapse": "Einklappen",
"hc.color": "Farbe",
"hc.company": "Unternehmen",
"hc.companyName": "Unternehmensname",
"hc.comparePhotos": "Fotos vergleichen",
"hc.compareThemWithTheOwner": "Vergleichen Sie sie mit den Antworten des Eigentümers – nie öffentlich sichtbar.",
"hc.condition": "Zustand",
"hc.confirmAndPay": "Bestätigen und bezahlen",
"hc.confirmCancellation": "Stornierung bestätigen",
"hc.confirmCrop": "Zuschneiden bestätigen",
"hc.confirmDeletion": "Löschen bestätigen",
"hc.confirmPassword": "Passwort bestätigen",
"hc.confirmThatThisIsYour": "Bestätigen Sie, dass dies Ihr Artikel ist. Eine Identitätsprüfung wird vom Finder vor jeglichem Kontakt angefordert.",
"hc.confirmTheCarrier": "Den Carrier bestätigen",
"hc.confirmThePassword": "Das Passwort bestätigen",
"hc.confirmYourShippingAddressTo": "Bestätigen Sie Ihre Versandadresse, um mit der Zahlung fortzufahren.",
"hc.confirmYourSubscription": "Abonnement bestätigen",
"hc.confirmed": "Bestätigt ✓",
"hc.contactFindoToGetYour": "Kontaktieren Sie Findloop, um Ihre Absender-ID zu erhalten.",
"hc.contactUs": "Kontaktieren Sie uns",
"hc.continueTheReturn": "Rücksendung fortsetzen",
"hc.continueToPayment": "Zur Zahlung fortfahren",
"hc.copy": "Kopieren",
"hc.correctMyDetails": "meine Daten korrigieren",
"hc.correctThisEntry": "Diesen Eintrag korrigieren?",
"hc.country": "Land",
"hc.countryAddress": "Land (Adresse)",
"hc.countryIsoCodeEG": "Land (ISO-Code, z. B. FR)",
"hc.cover": "Bedecken",
"hc.createTheShipment": "Die Sendung erstellen",
"hc.cropThePhoto": "Foto zuschneiden",
"hc.customer": "Kunde",
"hc.customerClaimCodeToCheck": "Kundenforderungscode – zur Überprüfung bei der Abholung:",
"hc.customerReasonFmt": "Kundenanfrage: \"{reason}\".",
"hc.customerReminderDelay": "Erinnerungsverzögerung des Kunden",
"hc.customerWhosePublicListingMatches": "Kunde, dessen öffentliche Anzeige mit diesem Artikel übereinstimmt – nur für Sie sichtbar.",
"hc.d15": "D-15",
"hc.dangerZone": "Warnzone",
"hc.date": "Datum",
"hc.dateNewest": "Datum (neueste)",
"hc.dateOldest": "Datum (älteste)",
"hc.daysToYearEnd": "{n} Tage bis zum Jahresende",
"hc.deadlineAlert": "Fristwarnung",
"hc.declarationClosed": "Erklärung abgeschlossen ✓",
"hc.declarationNotFound": "Erklärung nicht gefunden.",
"hc.declarationNotFound2": "Erklärung nicht gefunden",
"hc.declarationTracking": "Verfolgung der Erklärung",
"hc.defaultCarrier": "Standarddienstleister",
"hc.defaultCarrierPreselected": "Standarddienstleister vorab ausgewählt – kann für diesen Versand geändert werden. Tatsächlicher Preis (Sendcloud + {m}% Marge).",
"hc.defaultCarrierRemoved": "Standarddienstleister entfernt",
"hc.delayHours": "Verzögerung (Stunden)",
"hc.deleteMyAccount": "Mein Konto löschen",
"hc.deleting": "Löschen…",
"hc.deletingDeactivatesYourAccountLogin": "Das Löschen deaktiviert Ihren Account: Der Login ist blockiert und die Daten werden 30 Tage aufbewahrt. Sie erhalten eine E-Mail mit einem Reaktivierungslink, der 30 Tage gültig ist.",
"hc.delivered": "Zugestellt",
"hc.depositAnItem": "Einen Artikel hinterlegen",
"hc.depositCancelledItemPutBack": "Einzahlung storniert – Artikel wieder ins Lager gelegt.",
"hc.depositCancelledItemRemovedFrom": "Einzahlung storniert – Artikel aus dem Register entfernt.",
"hc.depositedOn": "Hinterlegt am",
"hc.describeTheItemBrandColor": "Artikel beschreiben: Marke, Farbe, besondere Merkmale… (Je mehr Details Sie angeben, desto besser sind Ihre Chancen, Ihren Artikel zu finden)",
"hc.dimensionsCm": "Abmessungen (cm)",
"hc.disablingAnEmail": "Eine E-Mail deaktivieren",
"hc.doesNotHide": "verbirgt nicht",
"hc.download": "Herunterladen",
"hc.downloadThePdf": "Das PDF herunterladen",
"hc.draftRestoredPickUpYour": "Entwurf wiederhergestellt – holen Sie Ihre Erklärung dort ab, wo Sie aufgehört haben.",
"hc.dragToReposition": "Ziehen zum Neupositionieren",
"hc.eGColisPriv": "Z.B. Colis Privé",
"hc.eachItemGetsAQr": "Jeder Artikel erhält ein QR-Etikett. Scannen Sie es unter \"Lager & QR\", um einen Artikel sofort zu lokalisieren.",
"hc.eachSiteManagesItsOwn": "Jede Website verwaltet ihr eigenes Banking. Gehe zu",
"hc.edit": "Bearbeiten",
"hc.emailNotificationPreferences": "E-Mail-Benachrichtigungseinstellungen",
"hc.emailPreferencesUpdated": "E-Mail-Einstellungen aktualisiert",
"hc.enableOrDisableRecoveryFees": "Wiederherstellungsgebühren aktivieren oder deaktivieren für",
"hc.enlargePhoto": "Foto vergrößern",
"hc.enterTheCustomerSCode": "Geben Sie den Kunden-Code ein",
"hc.estShipRate": "Geschätzte Versandkosten (Sendcloud + {m}% Marge):",
"hc.establishment": "Etablissement",
"hc.establishment2": "Etablissement:",
"hc.establishmentInItsSendcloudAccount": "Etablissement in Ihrem Sendcloud-Konto und gibt Ihnen die Absender-ID",
"hc.establishmentSettings": "Einstellung des Etablissements",
"hc.exCode": "z.B. ABCD2345",
"hc.exId": "z.B. 3f2a…",
"hc.exit": "Beenden",
"hc.explainWhyThisItemIs": "Erklären Sie, warum dieser Artikel nicht Ihrer ist…",
"hc.externalPaymentLinks": "Externe Zahlungslinks",
"hc.failed": "Fehlgeschlagen",
"hc.feesEnabled": "Gebühren aktiviert",
"hc.field": ") Feld.",
"hc.finderAcceptedCloseTheCase": "Finder akzeptiert — schließen Sie den Fall, sobald der Artikel persönlich übergeben wurde.",
"hc.findoCityRanking": "Findloop — Städte-Ranking",
"hc.findoForEstablishments": "Findloop für Etablissements",
"hc.findoPresentationVideo": "Findloop Präsentationsvideo",
"hc.findoRegistersTheAddressOf": "Findloop registriert die Adresse Ihres",
"hc.findoReviewShare": "Findloop {year} Rückblick: {n} zurückgegebene Artikel, {rate}% Rücksendequote 🎉",
"hc.firstVerifyTheClaimCode": "Überprüfen Sie zuerst den oben genannten Anspruchscode",
"hc.forEveryNewShipmentFrom": "für jede neue Sendung von",
"hc.free": "kostenlos",
"hc.freeRecovery0": "Kostenlose Rückholung (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Kostenlose Rückholung in ganz Afrika – Angebot zur Einführung",
"hc.freeRecoveryFeesDisabled0": "Kostenlose Rückholung: Gebühren deaktiviert (0 €)",
"hc.fromTeamInviteYourColleagues": "Von \"Team\", laden Sie Ihre Kollegen per E-Mail ein und weisen Sie ihnen ein Etablissement zu. Jedes Mitglied sieht nur seinen eigenen Bereich.",
"hc.fullName": "Vollständiger Name",
"hc.fullPhoto": "Vollfoto",
"hc.gallery": "Galerie",
"hc.giveTheReasonForCancelling": "Geben Sie den Grund für die Stornierung an. Der Partner wird informiert.",
"hc.goToLogin": "Zum Login gehen",
"hc.goToMyAccount": "Gehe zu meinem Konto",
"hc.gold": "Gold",
"hc.googleLoginFailed": "Google-Anmeldung fehlgeschlagen",
"hc.hasConfirmedYourPaymentYou": "hat Ihre Zahlung bestätigt, Sie werden automatisch weitergeleitet",
"hc.helpCenter": "Hilfecenter",
"hc.helpUsImproveWhyAre": "Helfen Sie uns, besser zu werden: Warum verlassen Sie uns? Ihr Konto wird deaktiviert und kann innerhalb von 30 Tagen reaktiviert werden.",
"hc.hidePassword": "Passwort verbergen",
"hc.high": "Hoch",
"hc.historyOfYourMonthlySubscriptions": "Verlauf Ihrer monatlichen Abonnements und deren Zahlungsstatus.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Wie richte ich meine numerische Absender-ID ein?",
"hc.iDonTUseIt": "Ich nutze es nicht genug",
"hc.iFoundItElsewhere": "Ich habe es woanders gefunden",
"hc.iNoLongerNeedMy": "Ich benötige meinen Artikel nicht mehr",
"hc.identityVerification": "Identitätsüberprüfung",
"hc.idleLogoutIn": "Sie werden in {n} s aufgrund von Inaktivität abgemeldet.",
"hc.ifProvidedTheVolumetricWeight": "Wenn angegeben, wird das Volumengewicht verwendet.",
"hc.ifThePartnerHasNot": "Wenn der Partner den Eingang der externen Zahlung nach diesem Zeitraum nicht bestätigt hat, erinnert Findloop den Partner automatisch daran, dies zu validieren.",
"hc.impersonationEnded": "Imitation beendet.",
"hc.impersonationMode": "Imitationsmodus",
"hc.impersonationSessionExpired": "Imitationssitzung abgelaufen.",
"hc.inTheField": ", im Feld",
"hc.inTransit": "Unterwegs",
"hc.inclVat": "inkl. MwSt.",
"hc.intraEuVatNumberOptional": "Intra-EU-USt-IdNr. optional, keine SIRET erforderlich (außerhalb Frankreichs).",
"hc.invalidInvitationLink": "Ungültiger Einladungslink.",
"hc.invalidInvitationLink2": "Ungültiger Einladungslink",
"hc.invalidInviteLink": "Ungültiger oder abgelaufener Einladungslink.",
"hc.invalidNumberEnterAnInternational": "Ungültige Nummer. Geben Sie eine internationale Nummer ein, z. B. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Ungültiger oder abgelaufener Link.",
"hc.invalidOrExpiredReactivationLink": "Ungültiger oder abgelaufener Reaktivierungslink",
"hc.invalidSendcloudId": "Ungültige Sendcloud-ID",
"hc.inviteSubtitle": "{org} lädt Sie ein, ihrem findloop-Team beizutreten. Wählen Sie Ihr Passwort, um Ihr Konto zu aktivieren.",
"hc.isAvailableOnSendcloudFor": "ist auf Sendcloud für alle Ihre Routen (Inland + international) verfügbar.",
"hc.isNotEnabledOnYour": "ist auf Ihrem Sendcloud-Konto für einige Ziele nicht aktiviert. Etiketten dafür werden mit einem anderen verfügbaren Anbieter erstellt.",
"hc.isThisReallyYourItem": "Ist das wirklich Ihr Artikel?",
"hc.isThisYourItem": "Ist das Ihr Artikel?",
"hc.item": "Artikel",
"hc.itemAlreadyConfirmed": "Artikel bereits bestätigt",
"hc.itemDetails": "Artikel Details",
"hc.itemFoundAt": "Artikel gefunden bei",
"hc.itemFoundAtAPartner": "Artikel gefunden bei einem Partner",
"hc.itemMarkedAsReturned": "Artikel als zurückgegeben markiert ✓",
"hc.itemPhotoRequiredBeforeShipping": "Artikel Foto (erforderlich vor dem Versand)",
"hc.itemPhotoSaved": "Artikel Foto gespeichert",
"hc.itemPreview": "Artikel Vorschau",
"hc.itemPutBackInStorage": "Artikel wieder im Lager.",
"hc.itemWeight": "Artikelgewicht:",
"hc.itemsReturned": "Artikel(e) zurückgegeben",
"hc.itemsReturnedThisYear": "Artikel, die in diesem Jahr zurückgegeben wurden",
"hc.itemsWhoseLegalDeadlineIs": "Artikel, deren gesetzliche Frist in 15 Tagen oder weniger abläuft (überfällig inbegriffen). Übereinstimmungen bleiben sichtbar.",
"hc.kbisNumber": "Kbis-Nummer",
"hc.keysForgottenOnABench": "Schlüssel auf einer Bank vergessen",
"hc.labelBeingGenerated": "Etikett wird erstellt",
"hc.leaveTheFieldsEmptyTo": "Lassen Sie die Felder leer, um die Wiederherstellung kostenlos anzubieten.",
"hc.legalNotice": "Rechtshinweis",
"hc.limitReachedUpgradeToA": "Limit erreicht — auf einen höheren Plan upgraden",
"hc.linkCopiedShareOn": "Link kopiert — teilen Sie es auf {label}",
"hc.linkUnavailable": "Link nicht verfügbar",
"hc.linkedTo": "Verknüpft mit",
"hc.listingHiddenByModeration": "Eintrag durch Moderation verborgen.",
"hc.loading": "Lädt…",
"hc.locateMe": "Finde mich",
"hc.logIn": "Anmelden",
"hc.logInToGetBack": "Melden Sie sich an, um zu Ihrem Bereich zurückzukehren und Ihr Abonnement zu verwalten.",
"hc.loginFailed": "Anmeldung fehlgeschlagen",
"hc.lostFoundPlatform": "Fundplattform.",
"hc.lostIn": "verloren in",
"hc.lowRate": "Niedriger Tarif",
"hc.mainReason": "Hauptgrund",
"hc.mainStreet": "Hauptstraße",
"hc.makeSureThisIsThe": "Stellen Sie sicher, dass dies der Artikel ist, den Sie verloren haben, bevor Sie die Kontaktdaten des Finders freigeben.",
"hc.manageCookies": "Cookies verwalten",
"hc.manageMyTeam": "Mein Team verwalten",
"hc.manageYourTeam": "Ihr Team verwalten",
"hc.markAsReturned": "Als zurückgegeben markieren",
"hc.matchNoClaimInTime": "Die Übereinstimmung erhielt innerhalb der Frist keinen Anspruch.",
"hc.matchNotFound": "Übereinstimmung nicht gefunden",
"hc.medium": "Mittel",
"hc.milestoneFmt": "{m} zurückgegebene Artikel – Meilenstein erreicht! Auf dem Weg zu {next}.",
"hc.missingFeatures": "Fehlende Funktionen",
"hc.monthly": "Monatlich",
"hc.monthlyBilling": "Monatliche Abrechnung",
"hc.moveThePhotoToFit": "Verschieben Sie das Foto, um es im Kreis anzupassen.",
"hc.myAccount": "Mein Konto",
"hc.myInvoices": "Meine Rechnungen",
"hc.myMonthlyInvoices": "Meine monatlichen Rechnungen",
"hc.nArchived": "{n} Angebot(e) archiviert.",
"hc.newCodeGeneratedAndSent": "Neuer Code generiert und dem Kunden per E-Mail und SMS gesendet",
"hc.newCodeGeneratedAndSent2": "Neuer Code generiert und dem Eigentümer gesendet",
"hc.newPassword": "Neues Passwort",
"hc.next": "Weiter",
"hc.nextPhoto": "Nächstes Foto",
"hc.no": "Nein",
"hc.noAnswerProvided": "Keine Antwort gegeben.",
"hc.noArchivedDeclarations": "Keine archivierten Erklärungen",
"hc.noCountryFound": "Kein Land gefunden",
"hc.noDeclarations": "Keine Erklärungen",
"hc.noFeesAreChargedTo": "Es fallen keine Gebühren für den Kunden an.",
"hc.noInvoiceYet": "Noch keine Rechnung.",
"hc.noInvoiceYetYourInvoices": "Noch keine Rechnung. Ihre Rechnungen erscheinen hier automatisch nach jeder Zahlung.",
"hc.noMatchIsAvailableFor": "Derzeit ist kein Treffer verfügbar. Wir informieren Sie, sobald ein Artikel mit Ihrer Erklärung übereinstimmt.",
"hc.noShipmentMatchesYourSearch": "Keine Sendung entspricht Ihrer Suche.",
"hc.noShipmentsYet": "Noch keine Sendungen.",
"hc.noShipmentsYet2": "Noch keine Sendungen",
"hc.none": "keine",
"hc.noneChooseForEachShipment": "Keine (für jede Sendung auswählen)",
"hc.notMine": "Das ist nicht meins",
"hc.of": "von",
"hc.only": "Nur",
"hc.onlyEachSiteManagesIts": "nur. Jede Seite verwaltet ihr eigenes Banking: diese Links betreffen keine andere Einrichtung.",
"hc.onlyTheOwnerOrAn": "Nur der Eigentümer oder ein Administrator kann die Zahlungslinks der Einrichtung konfigurieren.",
"hc.openDepositInTheMenu": "Öffnen Sie \"Einzahlung\" im Menü, beschreiben Sie den Artikel und machen Sie ein Foto. Es wird sofort gespeichert und ist bereit zur Rückgabe.",
"hc.openSettings": "Einstellungen öffnen →",
"hc.openTheDeclarationToManage": "Öffnen Sie die Erklärung, um die Sendung zu verwalten",
"hc.optional": "— freiwillig",
"hc.optional2": "(freiwillig)",
"hc.optional3": "freiwillig",
"hc.originalListingPhotoUsed": "Originalfoto des Angebots verwendet",
"hc.other": "Andere",
"hc.other2": "Andere…",
"hc.ourProducts": "Unsere Produkte",
"hc.overallRateTrendLast6": "Gesamtzinsentwicklung (letzte 6 Monate)",
"hc.ownerSClaimCode": "Anspruchscode des Eigentümers",
"hc.ownershipConfirmed": "Eigentum bestätigt",
"hc.paid": "Bezahlt",
"hc.paidOn": "Bezahlt am",
"hc.paidViaPartner": "Bezahlt (über Partner)",
"hc.parcelBeingPrepared": "Paket wird vorbereitet",
"hc.parcelDelivered": "Paket geliefert",
"hc.parcelShipped": "Paket versandt",
"hc.parisGareDeLyon": "Paris, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Partnerverzeichnis",
"hc.passedOnToTheCustomer": "— an den Kunden Zahlungslink weitergeleitet.",
"hc.password": "Passwort",
"hc.passwordResetPleaseLogIn": "Passwort zurücksetzen, bitte anmelden.",
"hc.passwordUpdated": "Passwort aktualisiert.",
"hc.passwordsDoNotMatch": "Passwörter stimmen nicht überein.",
"hc.pasteThisSenderIdIn": "Fügen Sie diese Sender-ID in Findloop → Einstellungen ein",
"hc.payForTheShipmentOf": "Zahlen Sie für den Versand Ihres Artikels über Findloop mit einer sicheren Zahlung.",
"hc.payTheRecoveryFees": "Zahlen Sie die Wiederherstellungsgebühren",
"hc.payTheShippingFees": "Zahlen Sie die Versandkosten",
"hc.payment": "Zahlung",
"hc.paymentAlreadyConfirmedByThe": "Zahlung wurde bereits vom Partner bestätigt",
"hc.paymentLinksAreNowConfigured": "Zahlungslinks sind jetzt pro Einrichtung konfiguriert",
"hc.paymentNotCompletedYourAccount": "Zahlung nicht abgeschlossen, Ihr Konto wurde nicht erstellt — bitte versuchen Sie es erneut.",
"hc.paymentReceived": "Zahlung erhalten",
"hc.paymentSuccessful": "Zahlung erfolgreich!",
"hc.pdfInvoice": "PDF-Rechnung",
"hc.pending": "Ausstehend",
"hc.period": "Zeitraum",
"hc.phoneNumber": "Telefonnummer",
"hc.phoneOptional": "Telefon (optional)",
"hc.planAt": "Plan bei",
"hc.planLimitFmt": "Ihr \"{plan}\"-Plan ist auf {max} Einrichtungen beschränkt. Um {n} Standorte zu verwalten, empfehlen wir den",
"hc.platformReturnTarget": "Plattform-Rückgabenziel",
"hc.pleaseCompleteYourShippingAddress": "Bitte vervollständigen Sie Ihre Lieferadresse.",
"hc.pleaseProvideAPhoneNumber": "Bitte geben Sie eine Telefonnummer an: sie wird vom Versanddienstleister für den Versand benötigt.",
"hc.pleaseProvideAReason": "Bitte geben Sie einen Grund an.",
"hc.pleaseSetYourOwnPassword": "Bitte setzen Sie Ihr eigenes Passwort, bevor Sie fortfahren.",
"hc.pointsToGoal": "{n} weitere Punkte, um unser gemeinsames Ziel zu erreichen.",
"hc.posterPreview": "Poster-Vorschau",
"hc.potentialMatchBeingVerified": "Potentielles Übereinstimmung wird überprüft",
"hc.potentialOwner": "Potentieller Eigentümer",
"hc.preFilledAutomaticallyYouCan": "Automatisch vorausgefüllt — Sie können dies durch ein Foto des Pakets ersetzen.",
"hc.pressKit": "Pressekit",
"hc.previewMode": "Vorschau-Modus:",
"hc.previewOfThePrintReady": "Vorschau des druckfertigen A4-Plakats für dieses Etablissement.",
"hc.previous": "Vorherige",
"hc.previousPhoto": "Vorheriges Foto",
"hc.primary": "primär",
"hc.printThePoster": "Plakat drucken",
"hc.privacy": "Datenschutz",
"hc.privacyPolicy": "Datenschutzrichtlinie",
"hc.processedCasesWillAppearHere": "Bearbeitete Fälle werden hier angezeigt.",
"hc.proofOfReturnPdf": "Rücksendebestätigung (PDF)",
"hc.protectedByRecaptcha": "Durch reCAPTCHA geschützt",
"hc.publicMatch": "Öffentliche Übereinstimmung",
"hc.putBackInStorage": "Wieder ins Lager zurücklegen",
"hc.pwdResetByTeam": "Ihr Passwort wurde von unserem Team zurückgesetzt. Zu Ihrer Sicherheit,",
"hc.questionsToAskTheOwner": "Fragen an den Eigentümer",
"hc.rateChargedToTheCustomer": "Vom Kunden erhobener Tarif:",
"hc.rateOfTarget": "{rate}% erreicht von einem {target}% Ziel",
"hc.reached": "erreicht",
"hc.reactivating": "Reaktivieren…",
"hc.reasonSavedYouCanStill": "Grund gespeichert. Sie können Ihren Artikel weiterhin beanspruchen.",
"hc.recentMatchesFirst": "Neueste Übereinstimmungen zuerst",
"hc.recognizedThePhotoYouSent": "hat das Foto erkannt, das Sie gesendet haben, und diese Merkmale beschrieben. Bestätigen Sie nur, wenn sie zu dem Artikel in Ihrem Besitz passen.",
"hc.recommended": "Empfohlen",
"hc.recoveryFees": "Rückführungsgebühren",
"hc.recoveryFeesArePaidDirectly": "Rückführungsgebühren werden direkt an das Partner-Etablissement gezahlt. Findloop erhält keine Zahlungen von Kunden.",
"hc.recoveryFeesEnabled": "Rückführungsgebühren aktiviert",
"hc.recoveryOfferedByTheEstablishment": "Rückführung vom Etablissement angeboten — Findloop erhebt keine Gebühren.",
"hc.recoveryPaymentLink": "Zahlungslink für die Rückführung",
"hc.recoveryPaymentLinkSavedFor": "Zahlungslink für die Rückführung für dieses Etablissement gespeichert",
"hc.redirecting": "Umleiten…",
"hc.redirectingToPayment": "Umleitung zur Zahlung…",
"hc.redirectingToTheRecoveryOf": "Umleitung zur Rückführung Ihres Artikels…",
"hc.regenerateAndResendToThe": "Regenerieren und an den Eigentümer senden",
"hc.regenerateTheCode": "Den Code regenerieren",
"hc.registerAFoundItem": "Einen gefundenen Artikel registrieren",
"hc.rejectTheClaim": "Den Anspruch ablehnen",
"hc.reminderDelaySaved": "Erinnerungsverzögerung gespeichert",
"hc.reopenThePaymentLink": "Zahlungslink erneut öffnen",
"hc.repeatThePassword": "Passwort wiederholen",
"hc.reportAProblem": "Ein Problem melden",
"hc.reportDismissedYourListingRemains": "Meldung abgelehnt. Ihr Eintrag bleibt öffentlich.",
"hc.requiredUsedToCalculateThe": "Erforderlich: wird zur Berechnung des Sendcloud-Shipping-Preises verwendet. Versand über 30 kg nicht verfügbar.",
"hc.reset": "Zurücksetzen",
"hc.resume": "Fortsetzen",
"hc.resumeRegistration": "Registrierung fortsetzen",
"hc.retro": "Jahr im Rückblick",
"hc.returnSecurity": "Rückgabesicherheit",
"hc.returnToTheOwner": "An den Eigentümer zurückgeben",
"hc.returned": "zurückgegeben",
"hc.reviewTheItemDetails": "Überprüfen Sie die Artikeldetails",
"hc.revokeAccess": "Zugriff widerrufen",
"hc.role": "Rolle:",
"hc.save": "Speichern",
"hc.save2": "speichern",
"hc.saveAndContinue": "Speichern und fortfahren",
"hc.saving": "Speichern…",
"hc.scanTheClaimCode": "Den Anspruchscode scannen",
"hc.scanTheOwnerSQr": "QR-Code des Eigentümers scannen",
"hc.scrollThroughLanguages": "Durch Sprachen blättern",
"hc.searchByCustomerItemOr": "Nach Kunde, Artikel oder Sendungsnummer suchen…",
"hc.searchForACountry": "Nach einem Land suchen…",
"hc.secureFindoVerification": "Sichere findloop-Verifizierung",
"hc.seeRetro": "Jahr im Rückblick ansehen",
"hc.selectedCarrier": "Ausgewählter Anbieter:",
"hc.selectedPlan": "Ausgewählter Plan",
"hc.send": "Senden",
"hc.sendcloudSenderIdSaved": "Sendcloud Absender-ID gespeichert",
"hc.sendcloudSenderIdSenderId": "Sendcloud Absender-ID (sender_id)",
"hc.sending": "Senden…",
"hc.sessionExpired": "Sitzung abgelaufen",
"hc.setUpYourEstablishments": "Richten Sie Ihre Einrichtungen ein",
"hc.settings": "Einstellungen",
"hc.settingsSubtitle": "Externe Zahlungen und Erinnerungen, pro Einrichtung konfiguriert.",
"hc.shareFoundText": "Ich habe einen Artikel gefunden – helfen Sie mir, seinen Eigentümer auf Findloop zu finden",
"hc.shareLostText": "Ich habe einen Artikel verloren – helfen Sie mir, ihn auf Findloop zu finden",
"hc.sharePreview": "Vorschau teilen",
"hc.shareTheRanking": "Das Ranking teilen",
"hc.shareYourQrCodeTo": "Teilen Sie Ihren QR-Code, um Erklärungen zu erhalten.",
"hc.shipRateAutoWeight": "Der Versandpreis wird automatisch über Sendcloud (Gewicht {w}) zum Zeitpunkt des Versands berechnet.",
"hc.shipRateForWeight": "Versandkosten (Sendcloud + {m}% Marge) für {w}:",
"hc.shipments": "Sendungen",
"hc.shipmentsSubtitle": "Konsolidierte Ansicht aller Sendungen des Unternehmens, über alle Fälle hinweg. Klicken Sie auf eine Zeile, um die Sendung in der Erklärung zu verwalten.",
"hc.shipping": "Versand",
"hc.shippingAddress": "Versandadresse",
"hc.shippingFeesAreHandledAutomatically": "Versandkosten werden automatisch von Findloop (Sendcloud) bearbeitet — kein Link zum Eingeben.",
"hc.shippingFeesHaveAlreadyBeen": "Versandkosten wurden bereits bezahlt: der Dienstleister kann nicht mehr geändert werden.",
"hc.shippingNotAvailableForItems": "Versand nicht für Artikel über 30 kg verfügbar. Der Kunde muss den Artikel persönlich abholen.",
"hc.shippingPaid": "Versand bezahlt ✓",
"hc.showOnlyItemsMatchingA": "Nur Artikel anzeigen, die einem öffentlichen (Kunden-) Angebot entsprechen",
"hc.showPassword": "Passwort anzeigen",
"hc.signInTheBoxAbove": "Melden Sie sich im Feld oben an",
"hc.signatureSaved": "Unterschrift gespeichert",
"hc.signedInWithGoogle": "Mit Google angemeldet",
"hc.signupFailed": "Anmeldung fehlgeschlagen",
"hc.silver": "Silber",
"hc.simulatedRatesInPreProduction": "(simulierte Preise in der Vorproduktion)",
"hc.siretAndVatNumberRequired": "SIRET- und USt-Nummer erforderlich (Frankreich).",
"hc.skip": "Überspringen",
"hc.smsSentIfAccount": "Wenn ein Konto mit dieser Nummer existiert, wurde Ihnen eine SMS gesendet.",
"hc.sortItemsWithAPublic": "Sortieren: Artikel mit öffentlicher Übereinstimmung (neueste zuerst)",
"hc.specifyWhetherYouRecoveredYour": "Geben Sie an, ob Sie Ihren Artikel zurückgeholt haben oder dieses Angebot einfach entfernen möchten.",
"hc.specifyYourReason": "Geben Sie Ihren Grund an",
"hc.specifyYourReason2": "Geben Sie Ihren Grund an…",
"hc.staff": "Mitarbeiter",
"hc.status": "Status",
"hc.staySignedIn": "Eingeloggt bleiben",
"hc.step": "Schritt",
"hc.stillThere": "Immer noch da?",
"hc.stopScrolling": "Scrollen stoppen",
"hc.storeFindWithQr": "Speichern & finden mit QR",
"hc.streetName": "Straßenname",
"hc.streetNo": "Hausnummer",
"hc.switchTo": "Wechseln zu",
"hc.switchToDarkMode": "Wechseln zu Dunkelmodus",
"hc.switchToLightMode": "Wechseln zu Hellmodus",
"hc.takeAPhoto": "Ein Foto machen",
"hc.takeChangeThePhoto": "Foto machen / ändern",
"hc.takenFromYourDeclaration": "aus Ihrer Erklärung entnommen",
"hc.target": "Ziel",
"hc.targetReached": "Ziel erreicht",
"hc.targetReachedThankYouTo": "Ziel erreicht — danke an die gesamte findloop-Community!",
"hc.tellUsMore": "Erzähl uns mehr…",
"hc.tellUsWhyYouCancel": "Sag uns, warum du stornierst. Das hilft dem Partner, deine Anfrage zu bearbeiten.",
"hc.tellUsWhyYourListing": "Sag uns warum. Dein Eintrag bleibt aktiv und du kannst deinen Artikel weiterhin beanspruchen.",
"hc.termsAndConditions": "Allgemeine Geschäftsbedingungen",
"hc.termsAndPolicies": "Bedingungen und Richtlinien",
"hc.thankYouForYourFeedback": "Danke für dein Feedback",
"hc.theBannerDisplayedInThe": "das Banner, das im Register angezeigt wird.",
"hc.theClaimantHasBeenInformed": "Der Antragsteller wurde informiert. Der Artikel bleibt im öffentlichen Eintrag verfügbar.",
"hc.theClaimantHasBeenNotified": "Der Antragsteller wurde benachrichtigt und kann jetzt mit der Rücksendung fortfahren.",
"hc.theCustomerPaysTheFees": "Der Kunde bezahlt die Gebühren an das Unternehmen.",
"hc.theDayTheLegalRetention": "Der Tag, an dem die gesetzliche Aufbewahrungsfrist erreicht ist.",
"hc.theEstablishmentConsideredThatThis": "Das Unternehmen hat festgestellt, dass dieser Artikel nicht dir gehört.",
"hc.theEstablishmentIsReviewingYour": "Das Unternehmen prüft deine Antworten. Du wirst benachrichtigt, sobald dein Anspruch validiert ist, dann kannst du die Wiederherstellungsgebühren bezahlen.",
"hc.theFeesAreTooHigh": "Die Gebühren sind zu hoch",
"hc.theFinderConsideredThatThis": "Der Finder hat festgestellt, dass dieser Artikel nicht dir gehört.",
"hc.theFinderIsReviewingYour": "Der Finder prüft deinen Anspruch. Du wirst benachrichtigt, sobald er validiert ist.",
"hc.theItem": "Der Artikel",
"hc.theItemWillBeRemoved": "Der Artikel wird aus dem Register entfernt (kein laufender Anspruch).",
"hc.theItemWillBeSet": "Der Artikel wird auf \"auf Lager\" zurückgesetzt und der entsprechende Anspruch wird storniert.",
"hc.theKbisNumberAndVat": "Die Kbis-Nummer und die USt-Nummer sind für Frankreich erforderlich.",
"hc.theLabelIsGeneratedAutomatically": "Das Etikett wird automatisch generiert, sobald der Kunde die Versandgebühren bezahlt hat. Es kann hier heruntergeladen werden.",
"hc.theLinkMayHaveExpired": "Der Link ist möglicherweise abgelaufen (gültig für 30 Tage). Kontaktiere den findloop-Support, falls nötig.",
"hc.theOwnerDescribesTheirItem": "Der Eigentümer beschreibt seinen Artikel",
"hc.theOwnerReceivedItBy": "Der Eigentümer hat es per E-Mail (oder SMS) erhalten. Gib es ein oder scanne es vor der Übergabe.",
"hc.thePartnerConsideredThatThis": "Der Partner hat festgestellt, dass dieser Artikel nicht dir gehört. Der Artikel bleibt verfügbar.",
"hc.thePartnerIsReviewingYour": "Der Partner prüft deine Antworten. Du wirst benachrichtigt, sobald dein Anspruch validiert ist.",
"hc.theShipmentIsCreatedAutomatically": "Der Versand wird automatisch erstellt, sobald der Kunde seine Adresse bestätigt und die Wiederherstellungsgebühren bezahlt hat. Das Etikett wird dann automatisch nach der Versandzahlung generiert und kann hier heruntergeladen werden.",
"hc.theShippingRateWillBe": "Der Versandpreis wird automatisch über Sendcloud zum Zeitpunkt des Versands berechnet (erfasste Gewicht).",
"hc.thisCarrierWillBe": "Dieser Spediteur wird sein",
"hc.thisEstablishment": "dieses Unternehmen",
"hc.thisFieldIsRequiredFor": "Dieses Feld ist erforderlich, um ein automatisches Etikett zu generieren.",
"hc.thisIsMyItem": "Das ist mein Artikel",
"hc.thisIsMyItemContinue": "Das ist mein Artikel — fortfahren",
"hc.thisIsMyItemStart": "Das ist mein Artikel — Rückgabe starten",
"hc.thisIsNotMyItem": "Das ist nicht mein Artikel",
"hc.thisMatchIsNoLonger": "Dieses Match ist nicht mehr verfügbar oder wurde bereits bearbeitet.",
"hc.thisRateWillBeCharged": "Diese Gebühr wird dem Kunden in Rechnung gestellt. Ein hoher Satz kann die Rückholung entmutigen.",
"hc.thisStepIsRequiredFor": "Dieser Schritt ist erforderlich, damit Versandetiketten generiert werden.",
"hc.thisValidationLinkIsInvalid": "Dieser Bestätigungslink ist ungültig oder abgelaufen.",
"hc.toCheckBeforeMarkingThe": "Vor dem Markieren des Artikels als zurückgegeben prüfen.",
"hc.toConfigureTheLinksAnd": "um die Links und die Erinnerungsverzögerung für jede Einrichtung zu konfigurieren.",
"hc.toReachOurFirstMilestone": "um unseren ersten Meilenstein von 100 Rückgaben zu erreichen.",
"hc.toTheCustomer": "an den Kunden.",
"hc.toTheShippingFeePayment": "zur Zahlung der Versandkosten.",
"hc.toYourRecoveryTracking": "zu Ihrer Rückverfolgung der Wiederherstellung.",
"hc.tooExpensiveBudget": "Zu teuer / Budget",
"hc.topCitiesForReturns": "Top Städte für Rückgaben",
"hc.trackMyRecovery": "Meine Wiederherstellung verfolgen",
"hc.trackTheShipmentAndDownload": "Sendung verfolgen und das Etikett (automatisch generiert) ohne Verlassen des Deklarations-Tabs herunterladen.",
"hc.trackYourStatistics": "Verfolgen Sie Ihre Statistiken",
"hc.tracking": "Verfolgung",
"hc.unableToOpenTheShipping": "Konnte die Zahlung der Versandkosten nicht öffnen. Bitte versuchen Sie es erneut.",
"hc.unableToRetrieveTheInvoice": "Rechnung konnte nicht abgerufen werden.",
"hc.unclaimed": "Unbeansprucht",
"hc.unclaimedCustomerReason": "Unbeanspruchter Artikel. Grund des Kunden: \"{reason}\".",
"hc.unclaimedItem": "Unbeanspruchter Artikel",
"hc.unclaimedItemNoClaimWithin": "Unbeanspruchter Artikel — keine Beantragung innerhalb der Frist.",
"hc.unclaimedItems": "Unbeanspruchte Artikel",
"hc.unclaimedItemsMatchLeftWithout": "Unbeanspruchte Artikel: übereinstimmend geblieben ohne Beantragung innerhalb der Frist. Sie können sie wieder in den Speicher legen.",
"hc.unlockTheFinderSContact": "Kontaktdaten des Finders freischalten, um die Übergabe zu vereinbaren.",
"hc.upcoming": "Kommend",
"hc.updateFailed": "Aktualisierung fehlgeschlagen.",
"hc.usedForInvoices": "Verwendet zur Ausstellung Ihrer findloop-Rechnungen.",
"hc.vatNumber": "USt-IdNr.",
"hc.verificationPending": "Überprüfung ausstehend",
"hc.verificationSentToTheFinder": "Überprüfung an den Finder gesendet. Sie werden über deren Entscheidung informiert.",
"hc.verificationSentToThePartner": "Überprüfung an den Partner gesendet. Sie werden über deren Entscheidung informiert.",
"hc.verify": "Überprüfen",
"hc.verifyingInvite": "Einladungslink wird überprüft…",
"hc.verifyingTheLink": "Link wird überprüft…",
"hc.viewInRegistry": "Im Register anzeigen",
"hc.viewItem": "Artikel anzeigen",
"hc.viewItemRecover": "Artikel anzeigen & wiederherstellen",
"hc.visibleToTheOwnerAutomatically": "Sichtbar für den Eigentümer · nach 60 Tagen automatisch gelöscht.",
"hc.waitingForPartnerConfirmation": "Warten auf die Bestätigung des Partners",
"hc.waitingForThePartnerS": "Warten auf die Bestätigung des Partners",
"hc.weHaveInformedTheEstablishment": "Wir haben die Einrichtung informiert, dass dieser Artikel nicht Ihnen gehört und die Analyse neu gestartet. Sie werden benachrichtigt, sobald ein neuer Treffer gefunden wird.",
"hc.weHaveInformedThePartner": "Wir haben den Partner informiert, dass dieser Artikel nicht Ihnen gehört. Ihre Anzeige bleibt aktiv für zukünftige Übereinstimmungen.",
"hc.weRanTheAnalysisAgain": "Wir haben die Analyse erneut durchgeführt und ein weiteres Objekt identifiziert, das Ihnen gehören könnte. Bitte überprüfen Sie es erneut.",
"hc.weight": "Gewicht",
"hc.weightNotProvidedTheShipping": "Gewicht nicht angegeben: Die Versandkosten werden zum Zeitpunkt des Versands berechnet.",
"hc.weightUnit": "Gewichtseinheit",
"hc.welcome": "Willkommen!",
"hc.welcomeToFindo": "Willkommen bei Findloop",
"hc.whenACustomerComesTo": "Wenn ein Kunde kommt, um seine Sachen abzuholen, öffnen Sie seine Erklärung und validieren Sie die Rücksendung. Das war's!",
"hc.whenDisabledFeesDropTo": ". Wenn deaktiviert, sinken die Gebühren auf",
"hc.whyIsThisNotYour": "Warum ist dies nicht Ihr Objekt?",
"hc.willBeMarkedAs": "wird markiert als",
"hc.wrongColor": "Falsche Farbe",
"hc.wrongModel": "Falsches Modell",
"hc.yesCancel": "Ja, abbrechen",
"hc.yesContactTheFinder": "Ja, den Finder kontaktieren",
"hc.youAreHere": "Sie sind hier",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Sie können jetzt die Rücksendung starten.",
"hc.youCanStillChangeIt": ". Sie können es weiterhin fallweise ändern.",
"hc.youHaveAlreadyConfirmedThat": "Sie haben bereits bestätigt, dass dies Ihr Objekt ist.",
"hc.youWillBeRedirectedTo": "Sie werden zur sicheren Stripe-Zahlung weitergeleitet.",
"hc.yourAccountHasBeenReactivated": "Ihr Konto wurde reaktiviert.",
"hc.yourAccountIsActiveYou": "Ihr Konto ist aktiv, Sie können jetzt Ihre Einrichtungen verwalten.",
"hc.yourEstablishment": "Ihr Standort",
"hc.yourFeedbackHelpsUsImprove": "Ihr Feedback hilft uns, unsere Übereinstimmungen zu verbessern.",
"hc.yourFeedbackHelpsUsRestart": "Ihr Feedback hilft uns, die Analyse neu zu starten und unsere Übereinstimmungen zu verbessern.",
"hc.yourFirstSteps": "Ihre ersten Schritte",
"hc.yourFirstStepsAdmin": "Ihre ersten Schritte (Admin)",
"hc.yourItemHasBeenHanded": "Ihr Objekt wurde persönlich vom Partner übergeben – schließen Sie den Fall, sobald die Übergabe bestätigt ist.",
"hc.yourItemHasBeenShipped": "Ihr Objekt wurde vom Partner versandt – schließen Sie den Fall, sobald die Lieferung bestätigt ist.",
"hc.yourPaymentHasBeenRecorded": "Ihre Zahlung wurde aufgezeichnet.",
"hc.yourShipmentIsBeingPrepared": "Ihre Sendung wird vorbereitet. Sie erhalten Ihr Paket innerhalb von 3 bis 5 Werktagen.",
"hc.yourShippingFeesHaveAlready": "Ihre Versandkosten wurden bereits bezahlt. Versand bezahlt ✓",
"hc.yourShippingFeesHaveBeen": "Ihre Versandkosten wurden bezahlt. Ihr Paket wird vorbereitet.",
"hc.yourVerificationQuestionsDeposit": "Ihre Überprüfungsfragen (Einzahlung)",
"home.recentAdsAll": "Alle Angebote ansehen",
"home.recentAdsEyebrow": "Gerade jetzt",
"home.recentAdsSubtitle": "Verlorene und gefundene Gegenstände, die von der Community gemeldet wurden.",
"home.recentAdsTitle": "Neueste Angebote",
"home.reunions": "Neueste Wiedervereinigungen",
"home.videoEyebrow": "Ansehen",
"pcat.stadium_arena": "Stadion / Arena",
"pcat.supermarket": "Supermarkt",
"pcat.taxi_vtc": "Taxi / Fahrdienst",
"pcat.tourism_office": "Touristeninformation",
"pcat.train_bus_station": "Bahnhof / Busbahnhof",
"pcat.travel_agency": "Reisebüro",
"hc.and": "und",
"hc.demoObj0": "eine Geldbörse",
"hc.demoObj1": "eine Sporttasche",
"hc.demoObj2": "ein Telefon",
"hc.demoObj3": "eine Brille",
"hc.demoObj4": "ein Satz Schlüssel",
"hc.demoObj5": "ein Schal",
"hc.demoObj6": "ein Laptop",
"hc.demoObj7": "eine Wasserflasche",
"hc.demoWhen0": "vor 2 Stunden",
"hc.demoWhen1": "vor 5 Stunden",
"hc.demoWhen2": "gestern",
"hc.demoWhen3": "vor 3 Stunden",
"hc.demoWhen4": "heute Morgen",
"hc.demoWhen5": "vor 1 Tag",
"hc.feedDemo": "{obj} wurde in {city} {when} zurückgegeben.",
"hc.feedReal": "Ein Artikel ({cat}) wurde in {city} zurückgegeben.",
"hc.saveBtn": "Speichern",
"hc.saveLink": "Link speichern",
"hc.terms": "Bedingungen",
"hc.view": "Anzeigen",
"pcat.airline": "Fluggesellschaft",
"pcat.airport": "Flughafen",
"pcat.amusement_park": "Vergnügungspark",
"pcat.bank": "Bank",
"pcat.bar_cafe": "Bar / Café",
"pcat.beauty_salon": "Friseur / Schönheitssalon",
"pcat.cinema": "Kino",
"pcat.concert_theater": "Konzertsaal / Theater",
"pcat.coworking": "Coworking Space",
"pcat.gym_fitness": "Fitnessstudio",
"pcat.hospital_clinic": "Krankenhaus / Klinik",
"pcat.library": "Bibliothek",
"pcat.mall": "Einkaufszentrum",
"pcat.museum": "Museum",
"pcat.pharmacy": "Apotheke",
"pcat.private_company": "Privatunternehmen",
"pcat.public_transport": "Öffentliche Verkehrsmittel",
"pcat.school_university": "Schule / Universität",
"pcat.sports_center": "Sportzentrum",
"an.found": "Gefunden",
"an.lost": "Verloren",
"hc.shareReview": "Bewertung teilen",
"hc.citiesAboveTarget": "{n} Städte über ihrem Ziel",
"hc.cityAboveTarget": "{n} Stadt über ihrem Ziel",
"hc.j15EarlyReminder": "D-15 Frühwarnung",
"hc.j7EarlyReminder": "D-7 Frühwarnung",
"hc.annualTotal": "Jährliche Gesamtsumme",
"hc.billedOnceYear": "Einmal jährlich für 12 Monate berechnet, jedes Jahr erneuert.",
"hc.monthlyPrice": "Monatlicher Preis",
"hc.perMonth": "/ Monat",
"hc.perYear": "/ Jahr",
"hc.billedEachMonth": "Automatisch jeden Monat abgerechnet.",
"nav.business": "Geschäft",
"nav.individual": "Einzelperson",
"hc.circumstancesFound": "Umstände des Fundes",
"hc.circumstancesFoundPh": "Z.B. auf dem Boden in der Nähe des U-Bahn-Eingangs gefunden",
"hc.circumstancesLost": "Umstände des Verlusts",
"hc.circumstancesLostPh": "Z.B. auf einer Bank liegen lassen, während ich auf den Bus gewartet habe",
"hc.conditionPh": "Z.B. gut, verkratzt…",
"hc.firstName": "Vorname",
"hc.lastName": "Nachname",
"hc.quantity": "Anzahl der Artikel",
"fa.approve": "Genehmigen",
"fa.approveConfirm": "Diese Erklärung genehmigen? Ihre vollständigen Kontaktdaten (Name, E-Mail, Telefon) werden mit dem Finder ausgetauscht.",
"fa.approved": "Erklärung genehmigt — Kontaktdaten ausgetauscht",
"fa.approvedFinder": "Der Eigentümer hat Ihre Erklärung genehmigt",
"fa.approvedFinderText": "Kontaktieren Sie sie, um die Rückgabe zu arrangieren.",
"fa.boostSub": "Ihre Anzeige bleibt für die gewählte Dauer oben.",
"fa.boostTitle": "Meine Anzeige boosten (optional)",
"fa.colFinder": "Erklärung des Finders",
"fa.colYours": "Ihre Erklärung",
"fa.compareHint": "Vergleichen Sie die Erklärung des Finders mit Ihrer, bevor Sie entscheiden.",
"fa.contribNone": "Keine Spende",
"fa.contribPaid": "Spende erhalten — danke!",
"fa.contribPending": "Spende wartet auf Zahlung",
"fa.contribSub": "Unterstützen Sie Findloop, um mehr Menschen zu helfen, ihre Gegenstände zurückzubekommen. Sie können €0 wählen.",
"fa.contribSuccessMsg": "Ihre Erklärung wurde an den Eigentümer gesendet.",
"fa.contribSuccessTitle": "Danke für Ihre Spende",
"fa.contribTitle": "Freiwillige Spende",
"fa.days3": "3 Tage",
"fa.days30": "30 Tage",
"fa.days7": "7 Tage",
"fa.declSub": "Beschreiben Sie den gefundenen Gegenstand. Der Eigentümer wird Ihre Erklärung mit seiner vergleichen.",
"fa.declTitle": "Ich habe diesen Gegenstand gefunden",
"fa.expiresOn": "Läuft aus am",
"fa.fBrand": "Marke",
"fa.fCircumstances": "Umstände",
"fa.fCity": "Stadt",
"fa.fColor": "Farbe",
"fa.fCondition": "Zustand",
"fa.fDate": "Datum",
"fa.fMessage": "Nachricht des Finders",
"fa.fPlace": "Ort",
"fa.fQuantity": "Menge",
"fa.finderContact": "Kontaktdaten des Finders",
"fa.finishPay": "Zahlung abschließen",
"fa.foundDate": "Gefunden am",
"fa.foundPlace": "Gefunden an",
"fa.hours24": "24 Stunden",
"fa.ht": "zzgl. MwSt.",
"fa.months3": "3 Monate",
"fa.noBoost": "Kein Boost",
"fa.ownerContact": "Kontaktdaten des Eigentümers",
"fa.payPublish": "Bezahlen und veröffentlichen",
"fa.pendingPayText": "Ihr Angebot wird live geschaltet, sobald die Zahlung bestätigt ist.",
"fa.pendingPayTitle": "Zahlung ausstehend",
"fa.planSub": "Ihr Angebot wird live geschaltet, sobald die Zahlung bestätigt ist.",
"fa.planTitle": "Dauer des Angebots",
"fa.pubSuccessMsg": "Ihr Angebot ist live. Sie werden benachrichtigt, sobald ein Finder sich meldet.",
"fa.pubSuccessTitle": "Angebot veröffentlicht",
"fa.publicNote": "Nur die Beschreibung, Stadt, Land und Fotos werden öffentlich angezeigt.",
"fa.redirectStripe": "Weiterleitung zur sicheren Zahlung…",
"fa.reject": "Ablehnen",
"fa.rejectConfirm": "Diese Erklärung ablehnen? Ihr Angebot bleibt online.",
"fa.rejected": "Erklärung abgelehnt",
"fa.rejectedFinder": "Es war nicht der gesuchte Gegenstand",
"fa.rejectedFinderText": "Der Eigentümer sagt, dieser Gegenstand gehört ihm nicht. Danke für Ihre Hilfe!",
"fa.responsesTitle": "Findererklärungen",
"fa.sent": "Erklärung an den Eigentümer gesendet.",
"fa.submitDecl": "Meine Erklärung senden",
"fa.submitDeclPay": "Senden und {amount} beitragen",
"fa.total": "Gesamtbetrag",
"fa.ttc": "inkl. MwSt.",
"fa.waitClaimText": "Der Finder prüft Ihre Anfrage. Sie werden über deren Entscheidung benachrichtigt.",
"fa.waitFinderText": "Wir informieren Sie, sobald ein Finder eine Erklärung einreicht.",
"fa.waitFinderTitle": "Ihr Angebot ist live",
"fa.waitOwnerText": "Der Eigentümer vergleicht Ihre Erklärung mit seiner. Sie werden über deren Entscheidung benachrichtigt.",
"fa.waitOwnerTitle": "Warten auf die Entscheidung des Eigentümers",
"st.pending_payment": "Zahlung ausstehend",
"fa.africaFree": "Kostenloses Angebot in Afrika — Findloop Launch-Angebot, genießen Sie es!",
"fa.africaPublished": "Angebot kostenlos veröffentlicht — Afrika Launch-Angebot!",
"fa.approveClaimConfirm": "Diesen Anspruch genehmigen? Der Eigentümer kann dann Ihre Kontaktdaten freischalten.",
"fa.checkInfo": "Überprüfen Sie Ihre Daten vor dem Senden: Sie werden mit den Daten des Finders verglichen.",
"fa.claimApprovedShort": "Der Finder hat Ihren Anspruch genehmigt",
"fa.claimRejectedShort": "Anspruch vom Finder abgelehnt",
"fa.claimRejectedText": "Der Finder glaubt, dass dieser Artikel nicht Ihnen gehört.",
"fa.claimSub": "Beschreiben Sie Ihren Artikel und fügen Sie 2 Fotos hinzu. Der Finder wird sie mit seinem Angebot vergleichen.",
"fa.claimTitle": "Das ist mein Artikel",
"fa.claimUnlockText": "Schalten Sie die Kontaktdaten des Finders frei, um die Rückgabe zu arrangieren.",
"fa.claimUnlockedShort": "Kontaktdaten freigeschaltet — Sendungsverfolgung anzeigen",
"fa.claimsTitle": "Eigentümeransprüche",
"fa.colOwner": "Erklärung des Eigentümers",
"fa.colYourAd": "Ihr Angebot",
"fa.expired": "Angebot abgelaufen",
"fa.free": "Kostenlos",
"fa.lostDate": "Verlustdatum",
"fa.lostPlace": "Verlustort",
"fa.noReceipt": "Für dieses Angebot liegt kein Beleg vor.",
"fa.planSubFree": "Wählen Sie die Dauer: Ihr Angebot wird sofort live, keine Zahlung erforderlich.",
"fa.prefillPrevious": "Die Details meines vorherigen Angebots in dieser Kategorie wiederverwenden",
"fa.receipt": "PDF-Beleg",
"fa.renewBtn": "Erneuern",
"fa.renewDiscountBanner": "50 % Rabatt: erneuern Sie, bevor Ihr Angebot abläuft!",
"fa.renewDiscountHint": "50 % Rabatt, weil Sie vor dem Ablauf erneuern.",
"fa.renewEarly": "Erneuern (−50%)",
"fa.renewTitle": "Mein Angebot erneuern",
"fa.renewed": "Angebot erneuert",
"fa.sendClaim": "Meinen Anspruch senden",
"fa.twoPhotos": "2 Fotos Ihres Artikels",
"fa.twoPhotosError": "Fügen Sie 2 Fotos Ihres Artikels hinzu.",
"fa.twoPhotosHint": "Persönliche Fotos, die beweisen, dass der Artikel Ihnen gehört (mit dem Artikel, der Rechnung, der Box…).",
"fa.unlockBtn": "Kontaktdaten freischalten",
"fa.unlockFree": "Kostenlos freischalten — Launch-Angebot",
"fa.waitClaimantText": "Wir informieren Sie, sobald ein Eigentümer diesen Artikel beansprucht.",
"fa.waitFinderDecision": "Warten auf die Entscheidung des Finders",
"fa.waitUnlockText": "Sie werden benachrichtigt, sobald die Kontaktdaten ausgetauscht werden.",
"fa.waitUnlockTitle": "Warten auf die Freischaltung durch den Eigentümer",
"fa.cancel": "Abbrechen",
"fa.categoryRequired": "Wählen Sie eine Kategorie für den gefundenen Artikel.",
"fa.confirmTitle": "Bestätigen Sie Ihre Entscheidung",
"fa.goBack": "Zurückgehen",
"dr.continue": "Fahre mit meiner Erklärung fort",
"dr.delete": "Dauerhaft löschen",
"dr.deleteConfirm": "Diesen Entwurf dauerhaft löschen? Dies kann nicht rückgängig gemacht werden.",
"dr.deleted": "Entwurf gelöscht",
"dr.expiresIn": "Entwurf noch {h} Stunden gespeichert",
"dr.title": "Sie haben eine nicht abgeschlossene Erklärung",
"form.step": "Schritt",
"form.next": "Weiter",
"form.back": "Zurück",
"form.stepDetails": "Ihr Bericht",
"form.stepPublish": "Dauer, Boost & Zahlung",
"form.stepThanks": "Danke & Beitrag",
"fthx.badge": "Bericht fast abgeschlossen",
"fthx.title": "Danke, Sie machen einen Unterschied!",
"fthx.text": "Dank Ihnen könnte jemand bald etwas zurückbekommen, das ihm wichtig ist. Handlungen wie Ihre sind es, die Findloop am Leben erhalten.",
"fthx.impact1": "1 Gegenstand gemeldet",
"fthx.impact2": "1 weitere Chance auf eine Wiedervereinigung",
"fthx.tipTitle": "Ein kleiner Schubs für Findloop?",
"fthx.tipText": "Dein Beitrag hilft uns, den Service zugänglich zu halten und immer mehr Gegenstände mit ihren Besitzern zu vereinen.",
"fthx.optional": "100% optional — du kannst alles veröffentlichen, ohne einen Beitrag zu leisten.",
"fthx.thanksTip": "Vielen Dank für Ihre Großzügigkeit!",
"fthx.suggest": "Vorgeschlagene Beträge",
"fthx.none": "Kein Trinkgeld",
"pay.pendingTitle": "Zahlung nicht abgeschlossen",
"pay.pendingText": "Ihre Daten sind gespeichert. Setzen Sie die Zahlung dort fort, wo Sie aufgehört haben.",
"pay.resume": "Zahlung fortsetzen",
"pay.expiredTitle": "Zahlungssitzung abgelaufen",
"pay.expiredText": "Aus Sicherheitsgründen ist die Zahlungssitzung abgelaufen. Ihre Daten sind gespeichert: Beginnen Sie die Zahlung mit einem Klick neu.",
"pay.relaunch": "Zahlung neu starten",
"sub.received": "Gesendet!",
"sub.publishing": "Wir sind gerade dabei…",
"sub.toPayment": "Weiterleitung zur sicheren Zahlung…",
"fa.claimSubV2": "Beschreiben Sie Ihren verlorenen Gegenstand. Die Person, die ihn gefunden hat, wird Ihre Beschreibung mit ihrem Angebot vergleichen.",
"fa.photosOptional": "Fotos Ihres Gegenstands (optional)",
"fa.compareOwnerHint": "Vergleichen Sie diese Informationen mit dem gefundenen Gegenstand und sagen Sie, ob es sich um denselben Gegenstand handelt.",
"fa.itsThisItem": "Ja, das ist der Gegenstand",
"fa.notThisItem": "Nein, das ist nicht der Gegenstand",
"fa.confirmIsItem": "Bestätigen Sie, dass dies der Gegenstand ist? Ihre Kontaktdaten und die des Eigentümers werden in Ihren jeweiligen Konten angezeigt.",
"fa.confirmNotItem": "Bestätigen Sie, dass dies nicht der Gegenstand ist? Ihr Bericht wird geschlossen.",
"fa.youConfirmed": "Sie haben bestätigt, dass dies der Gegenstand des Eigentümers ist",
"fa.youDeclined": "Sie haben angegeben, dass dies nicht der Gegenstand ist",
"fa.youDeclinedText": "Vielen Dank für Ihre Hilfe! Der Eigentümer wurde informiert.",
"fa.waitFinderDecisionOwner": "Warten auf die Entscheidung des Finders",
"fa.finderConfirmed": "Bestätigt",
"fa.notYourItem": "Das war nicht Ihr Gegenstand",
"fa.reportedOn": "Gemeldet am",
"fa.ownerWaitHint": "Ein Finder prüft derzeit die Informationen, bitte warten Sie.",
"fa.claimSentFinder": "Anspruch an die Person gesendet, die den Gegenstand gefunden hat.",
"fa.compareClaimHint": "Vergleichen Sie die Erklärung des Eigentümers mit Ihrem Angebot, bevor Sie eine Entscheidung treffen.",
"fa.closeFollowup": "Schließe dieses Follow-up",
"fa.closeFollowupConfirm": "Dieses Follow-up schließen? Die E-Mail-Adressen und Telefonnummern beider Parteien werden dauerhaft gelöscht, sobald der Eigentümer auch sein Angebot geschlossen hat.",
"fa.safetyTitle": "Sicherheitstipps vor der Übergabe",
"fa.safety1": "Bitte den Eigentümer um eine detaillierte Beschreibung versteckter Merkmale des Gegenstands: einen bestimmten Kratzer, den genauen Inhalt einer Tasche, die Tapete, die Seriennummer…",
"fa.safety2": "Falls möglich, bitte um einen visuellen Nachweis (ein Foto des Gegenstands) oder einen Kaufbeleg.",
"fa.safety3": "Übergib den Gegenstand an einem öffentlichen Ort oder bei einem Findloop-Partner und überprüfe den Ausweis des Eigentümers.",
"fa.safetyOk": "Verstanden, fortfahren",
"fa.ownerClosedNote": "Der Eigentümer hat sein Angebot geschlossen.",
"fa.finderClosedNote": "Der Finder hat sein Follow-up geschlossen.",
"fa.followupClosed": "Nachverfolgung abgeschlossen",
"fa.followupClosedText": "Sie haben diese Nachverfolgung abgeschlossen. Vielen Dank für Ihre Hilfe!",
"fa.photoReviewTitle": "Ein Finder hat ein Foto gesendet. Sieht es aus wie Ihr Artikel?",
"fa.photoLooksLike": "Ja, es sieht aus wie mein Artikel",
"fa.photoNotMine": "Nein, das ist nicht mein Artikel",
"fa.photoNotMineConfirm": "Die Nachverfolgung wird beidseitig geschlossen und Ihr Angebot bleibt offen für einen neuen Finder.",
"fa.photoLooksLikeDone": "Danke! Der Finder wird nun Ihre Erklärung vergleichen.",
"fa.photoNotMineDone": "Meldung abgelehnt. Ihr Angebot bleibt offen.",
"fa.ownerPhotoHint": "Nur das Foto des Finders wird Ihnen angezeigt. Lassen Sie uns wissen, ob es wie Ihr Artikel aussieht.",
"fa.ownerReviewingPhoto": "Der Besitzer überprüft Ihr Foto",
"fa.ownerReviewingPhotoText": "Sie werden benachrichtigt, sobald sie antworten. Dann können Sie ihre Erklärung vergleichen.",
"fa.ownerRejectedPhoto": "Das ist nicht der Artikel des Besitzers",
"fa.ownerRejectedPhotoText": "Der Besitzer sagt, Ihr Foto stimmt nicht mit ihrem Artikel überein. Die Nachverfolgung ist geschlossen. Danke für Ihre Hilfe!",
"fa.contribute": "Beitragen",
"fa.phoneMissing": "Nicht angegeben",
"fa.ownerSafety1": "Bevorzuge eine Übergabe an einem öffentlichen Ort oder bei einem Findloop-Partner. Wenn die Entfernung groß ist, schlage vor, es stattdessen per Post zu senden.",
"fa.ownerSafety2": "Überprüfe bei der Übergabe den Ausweis des Finders.",
"pub.changePhoto": "Foto ändern",
"ph.secured": "Foto gesichert",
"ph.securing": "Foto wird gesichert…",
"fa.ownerSafety3": "Wenn das Foto des Finders das Findloop-Wasserzeichen trägt, akzeptieren Sie das Treffen nicht. Das Foto muss ein Originalbild sein, das vom Finder ohne Wasserzeichen aufgenommen wurde."
},
"it": {
"a.category": "Categoria",
"a.categoryPlaceholder": "Scegli una categoria",
"a.city": "Città",
"a.legalHint": "Richiesto per la fatturazione elettronica francese (Factur-X) degli stabilimenti francesi.",
"a.legalRequiredFR": "SIRET e numero di partita IVA intracomunitaria sono obbligatori per la Francia.",
"a.rememberMe": "Ricordami",
"a.siret": "SIRET",
"a.vat": "N. partita IVA intracomunitaria",
"ac.africa": "Africa",
"ac.boostActive": "Evidenziare attivo —",
"ac.boostSub": "Apparire in cima alla directory dei partner con un badge “Evidenziato”.",
"ac.boostTitle": "Evidenzia la tua inserzione nella directory",
"ac.categoryHint": "Per classificare il tuo stabilimento nella directory di findloop.",
"ac.choose": "Scegli",
"ac.cityHint": "Per una posizione precisa sulla mappa pubblica.",
"ac.cityLabel": "Città dello stabilimento",
"ac.cityPh": "Parigi",
"ac.contact": "Dettagli di contatto",
"ac.converted": "Convertito",
"ac.copyDeclLink": "Copia il link della dichiarazione",
"ac.copyLink": "Copia il link",
"ac.currentPlan": "Piano attuale",
"ac.emailDesc": "Scegli le email che vuoi ricevere. Le notifiche nel tuo spazio di lavoro rimangono sempre attive.",
"ac.emailMatch": "Corrispondenze",
"ac.emailMatchDesc": "Un'email quando un elemento corrisponde a una dichiarazione",
"ac.emailNewDecl": "Nuove dichiarazioni di perdita",
"ac.emailNewDeclDesc": "Un'email non appena un cliente segnala una perdita presso la tua sede",
"ac.emailShip": "Richieste di spedizione",
"ac.emailShipDesc": "Un'email quando un cliente richiede la spedizione di un elemento",
"ac.emailTitle": "Preferenze email",
"ac.expireSoon": "La tua evidenziazione scade presto —",
"ac.exportCsv": "Esporta (CSV)",
"ac.exportHint": "Esporta i tuoi pagamenti esterni convalidati per la tua contabilità.",
"ac.free": "Gratuito",
"ac.freeMonths": "Mesi gratuiti",
"ac.hours": "ore",
"ac.howItWorks": "Come funziona?",
"ac.invited": "Invitato",
"ac.legalFR": "Richiesto per la fatturazione elettronica (Factur-X) applicabile da settembre 2026.",
"ac.legalMissing": "⚠️ SIRET e partita IVA intracomunitaria mancanti — completali per rimanere conforme alla fatturazione elettronica.",
"ac.legalOther": "Consigliato per le tue fatture.",
"ac.legalPartnerQr": "Codice QR",
"ac.legalTitle": "Identificatori legali (fatturazione)",
"ac.logoTitle": "Logo dello stabilimento",
"ac.modeCurrent": "Modalità attuale:",
"ac.modeExternal": "Esterno (convalida manuale)",
"ac.modeInternal": "Interno Findloop (automatica)",
"ac.noSubReceipt": "Nessun pagamento di abbonamento pagato ancora.",
"ac.none": "Nessuno",
"ac.onYourListing": "nella tua inserzione",
"ac.pay1": "Inserisci i tuoi link di pagamento qui sotto per reindirizzare i tuoi clienti al tuo sistema di incasso.",
"ac.pay2": "La convalida diventa manuale: confermi il ricevimento del pagamento dalla scheda “Dichiarazioni”.",
"ac.pay3": "Il link “Spese di spedizione” è un pagamento consolidato (recupero + spedizione).",
"ac.pay4": "Lascia i campi vuoti per utilizzare il pagamento interno di Findloop (Stripe) con convalida automatica.",
"ac.paySub": "Raccogli le commissioni tramite il tuo sistema di pagamento.",
"ac.payTitle": "Pagamenti esterni",
"ac.permissive": "Permissivo",
"ac.phone": "Telefono",
"ac.posterA4": "Poster A4 (PDF)",
"ac.qMessage": "Messaggio (opzionale)",
"ac.qName": "Nome",
"ac.qOrg": "Organizzazione",
"ac.qSites": "Numero di stabilimenti (stimato)",
"ac.qrHint": "I tuoi clienti scannerizzano questo codice per segnalare un oggetto smarrito.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Il tuo codice QR partner",
"ac.quoteDesc": "Aeroporti, reti ferroviarie, catene internazionali · ",
"ac.quoteEurope": "Europa / Mondo",
"ac.quoteSent": "Richiesta di preventivo inviata. Il nostro team ti contatterà a breve.",
"ac.quoteTitle": "Richiedi un preventivo — Impresa",
"ac.recoveryLink": "Collegamento “spese di recupero”",
"ac.refSub": "Ogni partner referito che si iscrive ti dà 1 mese gratuito.",
"ac.refTitle": "Riferisci, guadagna un mese gratuito",
"ac.reminderDelay": "Ritardo promemoria di validazione",
"ac.reminderHint": "Riceverai un'email di promemoria se un pagamento esterno rimane non validato oltre questo ritardo (predefinito: 48h).",
"ac.renewDesc1": "Ha già guadagnato",
"ac.renewDesc2": "Rinnova per rimanere in cima al directory e non perdere questa visibilità.",
"ac.renewNow": "Rinnova ora",
"ac.requestQuote": "Richiedi un preventivo",
"ac.saveLegal": "Salva gli identificatori",
"ac.saveLinks": "Salva i collegamenti",
"ac.sendRequest": "Invia la mia richiesta",
"ac.sending": "Invio…",
"ac.shippingLink": "Collegamento “spese di spedizione” (consolidato)",
"ac.shippingLinkHint": "Questo collegamento copre sia il recupero che la spedizione.",
"ac.strict": "Rigido",
"ac.subReceipt": "Ricevuta di abbonamento (PDF)",
"ac.subReceiptsSub": "Scarica la ricevuta PDF per ogni pagamento di abbonamento.",
"ac.subReceiptsTitle": "Ricevute di abbonamento",
"ac.tCategory": "Categoria salvata",
"ac.tCity": "Città salvata — mappa aggiornata",
"ac.tCityNeeded": "Inserisci una città",
"ac.tCopied": "Copiato!",
"ac.tCover": "Foto di copertura aggiornata",
"ac.tEmailPrefs": "Preferenze email aggiornate",
"ac.tErr": "Errore",
"ac.tExportImpossible": "Esportazione fallita",
"ac.tLegal": "Identificatori legali salvati",
"ac.tLegalNeeded": "SIRET e IVA richiesti per la Francia",
"ac.tLogo": "Logo aggiornato",
"ac.tLogoRemoved": "Logo rimosso",
"ac.tPayLinks": "Collegamenti di pagamento salvati",
"ac.tPhone": "Telefono salvato",
"ac.tSensitivity": "Sensibilità salvata",
"ac.tVatInvalid": "Numero IVA non valido",
"ac.tVatValid": "IVA valida",
"ac.tabBoost": "Visibilità",
"ac.tabPayments": "Pagamenti",
"ac.tabProfile": "Profilo",
"ac.tabQr": "QR & Poster",
"ac.tabReferral": "Referral",
"ac.tabSub": "Abbonamento",
"ac.thisWeek": "Questa settimana",
"ac.thisWeekOf": " ({n} questa settimana)",
"ac.thresholdDesc": "Soglia di fiducia da cui l'IA convalida automaticamente una corrispondenza fotografica e notifica il cliente. Maggiore = meno corrispondenze automatiche ma più affidabili.",
"ac.thresholdTitle": "Sensibilità di corrispondenza visiva AI",
"ac.trend": "Tendenza",
"ac.upload": "Carica",
"ac.vatValidFmt": "IVA valida{name} ({via})",
"ac.vatVerified": "IVA intra-UE verificata",
"ac.verifyVat": "Verifica VAT (VIES)",
"ac.verifying": "Verificando…",
"ac.views": "visualizzazioni",
"ac.viewsTotal": "Visualizzazioni totali",
"ac.winbackBtn": "Riprendi con -20%",
"ac.winbackDesc1": "Ti ha fruttato",
"ac.winbackDesc2": "Offerta speciale: -20% applicato automaticamente se rinnovi entro 24h.",
"ac.winbackTitle": "Il tuo highlight è appena scaduto — riprendi a -20%!",
"an.allCountries": "Tutti i paesi",
"an.country": "Paese",
"an.geoBanner": "Stai visualizzando annunci in",
"an.geoBannerWorld": "Stai visualizzando annunci in tutto il mondo",
"an.geoChange": "cambia paese",
"an.loginRequired": "Accedi per segnalare questo articolo e seguire il reso.",
"an.requestInProgress": "Richiesta in corso",
"an.resolved": "Articolo già recuperato",
"an.sortRecent": "Più recente",
"an.sortRelevance": "Rilevanza",
"bo.africaPrice": "Prezzi preferenziali zona Africa applicati",
"c.all": "Tutti",
"c.close": "Chiudi",
"c.confirm": "Conferma",
"c.confirmed": "Confermato",
"c.download": "Scarica",
"c.reset": "Reimposta",
"c.transfer": "Trasferisci",
"cat.Animal": "Animale / Accessorio per animali",
"cat.AppareilPhoto": "Macchina fotografica",
"cat.Argent": "Denaro / Contante",
"cat.Autres": "Altro",
"cat.Bijoux": "Gioielli",
"cat.CarteBancaire": "Carta bancaria",
"cat.CarteIdentite": "Carta d'identità / Passaporto",
"cat.Casquette": "Cappellino",
"cat.Ceinture": "Cintura",
"cat.Chargeur": "Caricabatterie / Cavo",
"cat.Chaussures": "Scarpe",
"cat.CleVoiture": "Chiave dell'auto",
"cat.Cles": "Chiavi",
"cat.Console": "Console di gioco",
"cat.Documents": "Documenti / Carta",
"cat.Echarpe": "Sciarpa",
"cat.Ecouteurs": "Cuffie / Auricolari",
"cat.Electronique": "Elettronica (altro)",
"cat.Enceinte": "Altoparlante",
"cat.Gants": "Guanti",
"cat.Gourde": "Bottiglia d'acqua / Thermos",
"cat.Instrument": "Strumento musicale",
"cat.Jouet": "Giocattolo / Peluche",
"cat.Jumelles": "Binocolo",
"cat.Lampe": "Lampada / Torcia",
"cat.Liseuse": "E-reader",
"cat.Livre": "Libro / Quaderno",
"cat.Lunettes": "Occhiali",
"cat.Manteau": "Cappotto / Giacca",
"cat.Maquillage": "Beauty case",
"cat.Medical": "Attrezzature mediche",
"cat.Medicaments": "Medicinali",
"cat.Montre": "Orologio / Smartwatch",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Ombrello",
"cat.Portefeuille": "Portafoglio / Borsa",
"cat.Poussette": "Passeggino / Accessorio per bambini",
"cat.Sac": "Borsa / Borsetta",
"cat.SacADos": "Zaino",
"cat.Souris": "Mouse / Tastiera",
"cat.Sport": "Attrezzatura sportiva",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefono / Smartphone",
"cat.Trottinette": "Monopattino",
"cat.Trousse": "Astuccio / Custodia",
"cat.USB": "Chiavetta USB / Disco rigido",
"cat.Valise": "Valigia / Bagagli",
"cat.Velo": "Bicicletta",
"cat.Vetements": "Abbigliamento",
"cm.found": "TROVATO",
"cm.lost": "PERDUTO",
"consent.required": "Devi accettare di condividere i tuoi dati per continuare.",
"consent.share": "Accetto che il trovatore del mio oggetto possa vedere i miei dati di contatto (nome, email, telefono) per contattarmi per la restituzione.",
"dc.partnerDesc": "Hai perso il tuo oggetto in un luogo partner (hotel, stazione, sala…)? Selezionalo per una restituzione diretta.",
"dc.partnerList": "Scegli dalla lista",
"dc.partnerMap": "Scegli sulla mappa",
"dc.partnerTitle": "Dichiarazione presso un partner",
"dc.publicCta": "Pubblica un annuncio pubblico",
"dc.publicDesc": "Il tuo annuncio sarà visibile a tutta la comunità findloop. Ideale se non sai dove hai perso l'oggetto.",
"dc.publicTitle": "Dichiarazione pubblica",
"dc.subtitle": "Scegli come segnalare il tuo oggetto smarrito.",
"dc.title": "Cosa vorresti fare?",
"dec.addrPending": "Indirizzo in attesa dal cliente",
"dec.analyzing": "Analizzando…",
"dec.clientDescription": "Descrizione del cliente",
"dec.clientPhoto": "Foto fornita dal cliente",
"dec.clientPhotoShort": "Foto del cliente",
"dec.comparePhotos": "Confronta foto",
"dec.declaredItemPhoto": "Foto dell'oggetto dichiarato",
"dec.emptyDesc": "Condividi il tuo codice QR per ricevere dichiarazioni.",
"dec.emptyTitle": "Nessuna dichiarazione",
"dec.enlarge": "Ingrandire",
"dec.extBanner": "{n} pagamento/i esterni da convalidare — conferma la ricezione qui sotto per sbloccare la consegna o la spedizione.",
"dec.foundItemAlt": "Oggetto trovato",
"dec.foundItemRegistry": "Oggetto trovato (registro)",
"dec.labelClient": "Cliente",
"dec.labelRegistry": "Registro",
"dec.noMatchYet": "Nessuna corrispondenza ancora.",
"dec.noPhoto": "Nessuna foto",
"dec.pRecup": "recupero",
"dec.pRecupP": "(recupero)",
"dec.pRecupShip": "(recupero + spedizione)",
"dec.payConfirmed": "Pagamento {x} confermato",
"dec.payPending": "Pagamento esterno {x} in attesa",
"dec.pickup": "Ritiro di persona",
"dec.reject": "Rifiuta",
"dec.rerun": "Rifare l'analisi",
"dec.similarity": "Somiglianza {n}%",
"dec.suggestedMatches": "Corrispondenze suggerite",
"dec.toColon": " a:",
"dec.toShip": "Da spedire",
"dec.toastExtPay": "Pagamento confermato — il cliente sarà avvisato.",
"dec.toastMatch": "Corrispondenza confermata",
"dec.toastReject": "Suggerimento rifiutato",
"dec.toastRerun": "Analisi riavviata",
"dec.toastVisualN": "{n} corrispondenza/e visiva/e",
"dec.toastVisualNone": "Nessuna corrispondenza visiva",
"dec.viewBeforeAfter": "Vista prima/dopo (sovrapposizione)",
"dec.viewSideBySide": "Vista affiancata",
"dec.visualCompare": "Confronto visivo AI",
"dec.visualIdle": "Esegui il confronto così l'AI abbina visivamente la foto del cliente con gli oggetti trovati.",
"dec.visualRunning": "L'AI sta confrontando la foto del cliente con gli oggetti nel tuo registro...",
"dec.zoomPhoto": "Ingrandisci la foto",
"dep.addAnyway": "Aggiungi comunque",
"dep.addError": "Errore durante l'aggiunta",
"dep.addItem": "Aggiungi oggetto",
"dep.added": "Oggetto aggiunto al registro!",
"dep.adding": "Aggiungendo...",
"dep.aiError": "Analisi AI non disponibile al momento.",
"dep.aiFilled": "Modulo precompilato dall'AI ✨",
"dep.aiUnavailable": "AI non disponibile — compila il modulo manualmente.",
"dep.analyzing": "Analizzando...",
"dep.analyzingPhoto": "Analizzando foto...",
"dep.brand": "Marca",
"dep.brandPlaceholder": "es. Apple",
"dep.category": "Categoria",
"dep.checkingDup": "Verifica duplicati...",
"dep.color": "Colore",
"dep.colorPlaceholder": "es. nero",
"dep.condition": "Condizione",
"dep.conditionPlaceholder": "es. buone condizioni",
"dep.depositorNote": "Nota del depositante",
"dep.depositorNoteHint": "Dettagli operativi scritti a mano. L'AI non sovrascrive mai questa nota.",
"dep.depositorNotePlaceholder": "es. contenuti di una borsa, marca riportata, dettagli forniti dalla persona...",
"dep.descPlaceholder": "es. iPhone 15 nero con una custodia trasparente, trovato al bar...",
"dep.description": "Descrizione",
"dep.dupHint": "Assicurati di non aggiungere un duplicato. Puoi continuare se l'oggetto è realmente diverso.",
"dep.dupTitle": "Oggetto/i simili già registrato/i",
"dep.dupWarn": "Oggetto simile rilevato — rivedi, poi fai clic di nuovo per confermare.",
"dep.estHint": "L'oggetto sarà aggiunto al registro di questo stabilimento.",
"dep.establishment": "Stabilimento",
"dep.fee": "Commissione di recupero (€) — opzionale",
"dep.feePlaceholder": "Lascia vuoto per il prezzo predefinito della categoria",
"dep.fillAI": "Compila con l'AI",
"dep.optional": "(opzionale)",
"dep.photo": "Foto dell'oggetto",
"dep.principal": "principale",
"dep.reqError": "Categoria e descrizione sono richieste.",
"dep.savedItem": "Oggetto registrato",
"dep.similarity": "Somiglianza",
"dep.storage": "Posizione fisica",
"dep.storageHint": "Dove l'oggetto è fisicamente conservato. Sarà generato un codice QR per trovarlo.",
"dep.storagePlaceholder": "es. Scaffale A3, Armadietto 12, Cassaforte reception",
"dl.aClient": "un cliente",
"dl.alertsBlocked": "Avvisi del browser bloccati",
"dl.alertsBlockedHint": "Per riabilitarli: fai clic sull'icona 🔒 (o ⓘ) a sinistra dell'indirizzo del sito, quindi consenti Notifiche e ricarica la pagina.",
"dl.amountDue": "Importo dovuto: {amount} {currency}.",
"dl.enableAlerts": "Abilita avvisi",
"dl.extPending": "Pagamenti da convalidare",
"dl.freemiumNear": "Stai raggiungendo il limite Freemium ({used}/{max} oggetti questo mese). Aggiorna a Starter per oggetti illimitati.",
"dl.freemiumReached": "Limite Freemium raggiunto ({used}/{max} oggetti questo mese). Aggiorna a Starter per registrare oggetti illimitati.",
"dl.invoiceOverdue": "Fattura {num} non pagata — accesso ristretto.",
"dl.matchNotifTitle": "Findloop — Nuovo abbinamento AI 🔔",
"dl.matchToast": "Nuovo abbinamento AI — {name}",
"dl.matchToastDesc": "Un articolo corrisponde a una dichiarazione.",
"dl.notifEmpty": "Nessuna notifica ancora.",
"dl.notifEnabled": "Avvisi del browser attivati",
"dl.notifTitle": "Notifiche",
"dl.payInvoice": "Paga la mia fattura →",
"dl.rewardsPending": "Buoni da presentare",
"dl.upgradeStarter": "Aggiorna a Starter →",
"est.all": "Tutti gli stabilimenti ({n})",
"est.label": "Stabilimento",
"est.primary": "primario",
"est.secondary": "secondario",
"est2.add": "Aggiungi uno stabilimento",
"est2.addressLabel": "Indirizzo",
"est2.addressPh": "12 Rue de la République",
"est2.autoInvoice": "Una fattura dettagliata viene generata automaticamente il 1° di ogni mese.",
"est2.baseSub": "Abbonamento base",
"est2.billing": "Fatturazione",
"est2.boostActivated": "Boost attivato per {name}",
"est2.boostBillingNote": "Fatturato al tasso attuale e raggruppato sulla tua fattura mensile consolidata.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Migliora la visibilità di questo stabilimento nel catalogo e sulla mappa.",
"est2.boostDuration": "{h}h di visibilità potenziata",
"est2.boostExtend": "Estendi",
"est2.boostTitle": "Boost {name}",
"est2.boosted": "Potenziato",
"est2.chartDesc": "Quota di articoli restituiti su totale registrato, sito per sito.",
"est2.chartTitle": "Tasso di restituzione per stabilimento",
"est2.chartTooltip": "Restituzione",
"est2.cityLabel": "Città",
"est2.cityPh": "Lione",
"est2.contactHint": "Questi dettagli sono mostrati al cliente per questo stabilimento (in caso di vuoto, si fa riferimento all'account).",
"est2.countryLabel": "Paese",
"est2.coverLabel": "Foto di copertura",
"est2.create": "Crea",
"est2.created": "Stabilimento creato",
"est2.delete": "Elimina",
"est2.deleteDesc": "Questa azione è permanente. Puoi eliminare uno stabilimento solo se non contiene articoli.",
"est2.deleteTitle": "Eliminare “{name}”?",
"est2.deleted": "Stabilimento eliminato",
"est2.dialogDesc": "Inserisci il nome e l'indirizzo di questo sito.",
"est2.edit": "Modifica",
"est2.editEst": "Modifica stabilimento",
"est2.emailLabel": "Email di contatto",
"est2.emailPh": "contatto@sito.com",
"est2.estSuffix": " stabilimento/i",
"est2.extraNoteBase": "{n} stabilimento/i aggiuntivi fatturati",
"est2.extraPrice": " a {price} €/mese.",
"est2.extraQuote": " su preventivo.",
"est2.imgChange": "Scegli un'immagine",
"est2.imgDone": "Fatto",
"est2.imgRemove": "Rimuovi",
"est2.imgRemoved": "Immagine rimossa",
"est2.imgSaved": "Immagine salvata",
"est2.imgUploading": "Caricamento…",
"est2.includedPlan": "Incluso nel tuo piano: {n}.",
"est2.kDeclarations": "Dichiarazioni",
"est2.kInStorage": "In magazzino",
"est2.kItemsTotal": "Articoli (totale)",
"est2.kRestituted": "Restituiti",
"est2.limitReached": "Limite raggiunto",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Dich.",
"est2.mItems": "Articoli",
"est2.mRestituted": "Restituito",
"est2.mStorage": "In magazzino",
"est2.monthlyTotal": "Totale mensile",
"est2.nameLabel": "Nome *",
"est2.namePh": "es. Belmont Hotel — Lyon Annex",
"est2.newEst": "Nuovo stabilimento",
"est2.onQuote": "Su preventivo",
"est2.phoneLabel": "Telefono",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Piano",
"est2.planLimited": "Il tuo piano “{tier}” è limitato a {max} stabilimento/i.",
"est2.primary": "Primario",
"est2.qr": "Codice QR",
"est2.qrDesc": "Visualizza questo codice QR in questo stabilimento. I clienti che segnalano una perdita saranno collegati a questo sito.",
"est2.qrTitle": "Codice QR — {name}",
"est2.saving": "Salvataggio…",
"est2.seeInvoices": "Vedi le mie fatture mensili",
"est2.seePlans": "Vedi i piani",
"est2.subtitle": "Gestisci tutti i tuoi siti con un solo account — visualizzazione consolidata, articoli, codice QR e fatturazione.",
"est2.suspended": "Sospeso",
"est2.tierFree": "1 stabilimento",
"est2.tierLarge": "stabilimenti illimitati",
"est2.tierMedium": "5 stabilimenti inclusi",
"est2.tierSmall": "3 stabilimenti inclusi",
"est2.title": "Stabilimenti",
"est2.unlimitedPlan": "Il tuo piano consente un numero illimitato di stabilimenti.",
"est2.unlimitedSuffix": " · illimitato",
"est2.updated": "Stabilimento aggiornato",
"est2.upgradeHint": "Aggiorna a un piano superiore per aggiungere più siti e centralizzare tutta la tua attività.",
"est2.visuals": "Logo & foto",
"est2.visualsDesc": "Personalizza il logo e la foto di copertura di questo stabilimento. Appaiono sulla sua pagina pubblica e nel modulo di dichiarazione.",
"est2.visualsTitle": "Visuals — {name}",
"est2.workOn": "Lavora su questo stabilimento",
"est2.working": "Stai lavorando su “{name}”",
"fp.backToRanking": "Torna alla classifica",
"fp.badge": "Badge",
"fp.notFound": "Profilo non trovato o privato.",
"fp.scoreTotal": "Punti totali",
"fp.scoreYear": "Punti in",
"fp.share": "Condividi questo profilo",
"fp.shareText": "Guarda il profilo di {name} su Findloop!",
"fp.tagline": "Un finder onesto che rende il mondo un posto migliore.",
"ft.backAccount": "Torna al mio account",
"ft.closeBtn": "Chiudi il caso",
"ft.closeConfirm": "Confermi che l'articolo è stato restituito? L'annuncio sarà chiuso.",
"ft.closeLockedHint": "Valida prima il codice del proprietario per sbloccare la chiusura.",
"ft.closed": "Caso chiuso — articolo restituito!",
"ft.codeLabel": "Inserisci il codice di validazione ricevuto dal proprietario",
"ft.codeNeeded": "Si prega di inserire il codice di validazione.",
"ft.codeOk": "Codice convalidato — puoi chiudere il caso.",
"ft.codePlaceholder": "es. 4821",
"ft.codeVerified": "Convalidato",
"ft.doneMsg": "Articolo restituito. Grazie per aver aiutato a restituirlo al proprietario!",
"ft.stepInProgress": "Restituzione in corso",
"ft.stepPublished": "Annuncio pubblicato",
"ft.stepReturned": "Articolo restituito",
"ft.subtitle": "Segui i passaggi fino alla restituzione dell'oggetto trovato.",
"ft.title": "Tracciamento restituzioni",
"ft.verifyBtn": "Valida codice",
"home.champBecome": "Diventa un finder",
"home.champCta": "Vedi la classifica",
"home.champSubtitle": "Ogni articolo restituito guadagna punti. Unisciti alla classifica e vinci premi.",
"home.champTitle": "I nostri migliori finder",
"inv2.contractTitle": "Il mio contratto Findloop",
"inv2.detailByEst": "Dettagli per stabilimento",
"inv2.dueLabel": "Scadenza:",
"inv2.dueSuffix": " · scadenza {date}",
"inv2.error": "Errore {status}",
"inv2.estCountIssued": "{n} stabilimento/i · emesso il {date}",
"inv2.estimate": "Stima (non addebitata) · {n} stabilimento/i",
"inv2.expired": " · scaduto",
"inv2.exportCsv": "Esporta CSV",
"inv2.exportDone": "CSV esportato",
"inv2.included": "Incluso",
"inv2.monthlyTitle": "Fatturazione mensile (abbonamento)",
"inv2.months": "+{n} mesi",
"inv2.paid": "Pagato",
"inv2.pay": "Paga",
"inv2.previewTitle": "Anteprima della tua prossima fattura —",
"inv2.renew": "Rinnova il mio contratto",
"inv2.renewalsTitle": "Storico rinnovi ({n})",
"inv2.renewedUntil": "Contratto rinnovato fino al {date}",
"inv2.serviceTitle": "Fatture di servizio (recuperi e preventivi)",
"inv2.soon": "In scadenza a breve",
"inv2.toPay": "Da pagare",
"inv2.totalHtTva": "Totale escl. tasse · IVA",
"inv2.totalTtc": "Totale incl. tasse",
"iu.addPhoto": "Aggiungi una foto",
"iu.change": "Cambia",
"lb.allCountries": "Tutti i paesi",
"lb.badge": "Classifica annuale",
"lb.champion": "🏆 Campione dell'anno",
"lb.cityPh": "Filtra per città…",
"lb.empty": "Nessuna classifica per questi filtri ancora.",
"lb.pts": "punti",
"lb.resetNote": "Classifica dell'anno corrente — ripristinata ogni 1 gennaio.",
"lb.returned": "restituito",
"lb.share": "Condividi la classifica",
"lb.shareText": "Guarda la classifica dei migliori finder su Findloop!",
"lb.subtitle": "Ogni restituzione guadagna punti. La classifica si ripristina ogni 1 gennaio.",
"lb.tabFinders": "Finders",
"lb.tabPartners": "Stabilimenti",
"lb.title": "Migliori finder",
"lost.b2bDesc": "Perso in un hotel, hub di trasporto o locale partner? Trova lo stabilimento e segnala la tua perdita.",
"lost.b2bTitle": "Segnala a un partner",
"lost.b2cDesc": "Pubblica un annuncio visibile a tutti, offri una ricompensa e promuovilo per massimizzare le tue possibilità.",
"lost.b2cTitle": "Pubblica un annuncio pubblico",
"lost.desc": "Scegli come procedere.",
"lost.title": "Hai perso un oggetto?",
"map.allCategories": "Tutte le categorie",
"map.clear": "Reimposta",
"map.exitFullscreen": "Esci",
"map.filterCity": "Città o paese…",
"map.fullscreen": "Schermo intero",
"map.heatmap": "Mappa di calore",
"map.high": "Alto",
"map.impactMonth": "oggetti restituiti questo mese",
"map.impactTotal": "totale restituito",
"map.legend": "Punti colorati dal rosso (basso) al verde (alto) in base al tasso di restituzione; dimensione basata sul numero di oggetti.",
"map.locating": "Localizzazione… aggiungi un indirizzo ai tuoi stabilimenti per vederli sulla mappa.",
"map.low": "Basso",
"map.medium": "Medio",
"map.noItemRegistered": "Nessun oggetto registrato",
"map.noItems": "Nessun oggetto",
"map.period30": "Ultimi 30 giorni",
"map.period7": "Ultimi 7 giorni",
"map.period90": "Ultimi 90 giorni",
"map.periodAll": "Tutto il tempo",
"map.returnedSuffix": "restituito · {a}/{t} oggetti",
"map.stats": "Statistiche della città",
"map.statsTop": "Top 5 luoghi (oggetti smarriti)",
"map.statsTrend": "Tendenza di 6 mesi",
"map.title": "Mappa dei tuoi stabilimenti",
"map.topPlaces": "Luoghi popolari",
"mc.addPhoto": "Aggiungi una foto",
"mc.archiveHide": "Nascondi cronologia",
"mc.archiveNone": "Nessun caso risolto ancora.",
"mc.archiveShow": "Mostra cronologia",
"mc.archiveSub": "Casi risolti e restituiti.",
"mc.archiveTitle": "Cronologia",
"mc.backToLogin": "Torna al login",
"mc.cancel": "Annulla",
"mc.certificate": "Certificato",
"mc.city": "Città",
"mc.confirmPassword": "Conferma password",
"mc.confirmRestitution": "Conferma restituzione",
"mc.deleteAccount": "Elimina il mio account",
"mc.deleteConfirm": "Sì, elimina il mio account",
"mc.deleteConfirmBody": "Il tuo account sarà eliminato definitivamente e i tuoi dati personali anonimizzati. Questa azione non può essere annullata.",
"mc.deleteConfirmTitle": "Eliminare il tuo account?",
"mc.deleteDesc": "Elimina definitivamente il tuo account e anonimizza i tuoi dati personali. Questa azione non può essere annullata.",
"mc.deleted": "Il tuo account è stato eliminato.",
"mc.deleting": "Eliminazione…",
"mc.expiresOn": "Scade il",
"mc.exportData": "Scarica i miei dati (GDPR)",
"mc.exportDone": "I tuoi dati sono stati scaricati.",
"mc.exporting": "Preparazione…",
"mc.finderAccepted": "Accettato",
"mc.finderProfile": "Profilo del trovatori (opzionale)",
"mc.finderProfileDesc": "Guadagna punti restituendo oggetti e apparire nella classifica pubblica.",
"mc.forgotLink": "Password dimenticata?",
"mc.forgotSend": "Invia il link",
"mc.forgotSent": "Se esiste un account per questa email, è stato appena inviato un link di ripristino.",
"mc.forgotTitle": "Password dimenticata",
"mc.hAd": "Annuncio perso",
"mc.hDeclaration": "Dichiarazione",
"mc.hFinderContact": "Oggetto segnalato",
"mc.hFound": "Oggetto restituito",
"mc.hFoundAd": "Annuncio trovato",
"mc.histEarned": "Oggetto restituito",
"mc.historyTitle": "La mia cronologia punti",
"mc.myFinds": "Oggetti trovati",
"mc.myFindsNone": "Non hai ancora segnalato di aver trovato oggetti.",
"mc.myFindsSub": "Oggetti che hai segnalato trovati negli annunci di oggetti smarriti.",
"mc.myRewards": "I miei voucher",
"mc.newPassword": "Nuova password",
"mc.notEnough": "Punti insufficienti",
"mc.notifEmpty": "Nessuna notifica ancora.",
"mc.notifOpen": "Visualizza",
"mc.notifTitle": "Notifiche",
"mc.notifTrack": "Traccia",
"mc.notifViewAd": "Visualizza annuncio",
"mc.optInDesc": "Partecipazione opzionale. Acconsenti a visualizzare pubblicamente gli elementi selezionati qui sotto. Modificabile in qualsiasi momento.",
"mc.optInTitle": "Apparire nella classifica pubblica",
"mc.passwordMismatch": "Le password non corrispondono.",
"mc.pointsBalance": "Punti da spendere",
"mc.presentHint": "Mostra questo QR al partner: lo scannerizzano per convalidare il tuo premio.",
"mc.presentInStore": "Mostra in negozio",
"mc.presentTitle": "Mostra questo voucher",
"mc.privacy": "Privacy & dati",
"mc.privacyDesc": "Scarica una copia di tutti i dati personali che Findloop detiene su di te (GDPR, art. 15 & 20).",
"mc.profileSaved": "Profilo aggiornato.",
"mc.profileSettings": "Profilo pubblico e classifica",
"mc.pseudo": "Nome o soprannome",
"mc.redExpired": "Scaduto",
"mc.redReady": "Mostra al partner",
"mc.redUsed": "Usato",
"mc.redeem": "Riscatta",
"mc.rememberMe": "Ricordami",
"mc.remove": "Rimuovi",
"mc.resetDone": "Password aggiornata. Ora puoi accedere.",
"mc.resetExpired": "Questo link di reset è non valido o scaduto. Richiedi un nuovo qui sotto.",
"mc.resetSave": "Reim posta la mia password",
"mc.resetTitle": "Nuova password",
"mc.restitutionConfirmed": "Restituzione confermata.",
"mc.rewardRedeemed": "Premio sbloccato! Codice:",
"mc.rewardsDesc": "Usa i tuoi punti per i vantaggi offerti dai nostri partner. Saldo:",
"mc.rewardsNone": "Nessun premio disponibile ancora.",
"mc.rewardsTitle": "Spendi i miei punti",
"mc.scoreAwarded": "Ben fatto! +1 al tuo Finder Score 🎉",
"mc.scoreEarned": "Punto guadagnato",
"mc.scorePts": "pts",
"mc.scoreThisYear": "Quest'anno",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Visualizza classifica",
"mc.visCity": "Città",
"mc.visCountry": "Paese",
"mc.visLabel": "Elementi visibili nella classifica:",
"mc.visName": "Nome / soprannome",
"mc.visPhoto": "Foto profilo",
"mc2.acceptFinder": "Accetta questo finder",
"mc2.accountActivity": "Attività account",
"mc2.adsActive": "{n}/5 annunci attivi",
"mc2.autoDelete": "Cancellazione automatica programmata per",
"mc2.badgeBronze": "Bronzo",
"mc2.badgeGold": "Oro",
"mc2.badgeSilver": "Argento",
"mc2.boostEarnedAlready": "Ti ha già guadagnato",
"mc2.boostEarnedWin": "Ti ha guadagnato",
"mc2.boostExpiredWin": "Il tuo boost è appena scaduto — riprendi con -20%!",
"mc2.boostExpiresIn": "Il tuo boost scade in",
"mc2.boostWinDetail2": ". -20% applicato automaticamente se rinnovi entro 24h.",
"mc2.claimCode": "Codice da reclamare:",
"mc2.codeSentFinder": "Codice inviato al finder via email",
"mc2.daysShort": "{n} g",
"mc2.downloadReceipt": "Scarica la mia ricevuta",
"mc2.error": "Errore {status}",
"mc2.finderAccepted": "Finder accettato — codice inviato via email",
"mc2.finderContacts": "Dettagli di contatto del Finder",
"mc2.followFindo": "Segui Findloop",
"mc2.imgInvalid": "Immagine non valida",
"mc2.inactivityNote": " — in caso di {n} mesi di inattività (GDPR).",
"mc2.lastActivity": "Ultima attività:",
"mc2.lostEmailTitle": "Non ho più accesso alla mia email",
"mc2.noPhotoPreset": "Nessuna foto ancora? Scegli un avatar predefinito:",
"mc2.paidViaPartner": "Pagato (tramite partner)",
"mc2.payRecovery": "Paga la tassa di recupero",
"mc2.paySettle": "Regola il mio pagamento",
"mc2.payShipping": "Paga la tassa di spedizione",
"mc2.payUnavailable": "Pagamento non disponibile",
"mc2.peopleFound": "{n} persona(e) pensa di aver trovato il tuo articolo",
"mc2.phoneNumber": "Numero di telefono",
"mc2.reactivateAccount": "Riattiva il mio account",
"mc2.reactivated": "Account riattivato",
"mc2.reactivatedThanks": "Account riattivato — grazie per la tua fedeltà!",
"mc2.recoverSmsBtn": "Ricevi il mio codice via SMS",
"mc2.recoverSmsDesc": "Ricevi il tuo codice di reclamo via SMS al numero registrato sul tuo account.",
"mc2.recoverSmsFallback": "Se esiste un account con questo numero, è stato inviato un SMS.",
"mc2.renewStayTop": ". Rinnova per rimanere in cima e recuperare il tuo articolo.",
"mc2.resume20": "Rinnova -20%",
"mc2.unlockContacts": "Sblocca i dettagli di contatto",
"mc2.unlockDesc": "Paga la tassa di gestione di Findloop per rivelare i loro dettagli di contatto e organizzare la consegna.",
"mc2.viewsWord": "visualizzazioni",
"mc2.live": "In diretta",
"mh.allCategories": "Tutte le categorie",
"mh.allPeriod": "Tutto il tempo",
"mh.autoMatch": "Abbinamento automatico AI",
"mh.blocked": "Bloccato (contraddizione)",
"mh.blockedReason": "Match bloccato: le parole chiave principali dell'articolo e la dichiarazione si contraddicono.",
"mh.days30": "Ultimi 30 giorni",
"mh.days7": "Ultimi 7 giorni",
"mh.days90": "Ultimi 90 giorni",
"mh.emptyDesc": "Gli abbinamenti AI appariranno qui man mano che arrivano le dichiarazioni.",
"mh.emptyTitle": "Nessun evento",
"mh.exportCsv": "Esporta CSV",
"mh.exportDone": "Esportazione CSV completata",
"mh.exportImpossible": "Esportazione fallita",
"mh.fBlocked": "Bloccato",
"mh.fConfirmed": "Confermato",
"mh.fRejected": "Rifiutato",
"mh.objectLabel": "Articolo:",
"mh.refresh": "Aggiorna",
"mh.rejected": "Rifiutato",
"mh.srcManual": "Manuale",
"mh.srcText": "Testo",
"mh.srcVisual": "Visivo (foto)",
"mh.subtitle": "Registro degli abbinamenti proposti dall'AI — abbinati automaticamente, confermati e rifiutati.",
"mh.title": "Storia AI",
"nav.ranking": "Classifica",
"nf.desc": "La pagina che stai cercando non esiste o è stata spostata.",
"nf.home": "Torna alla home",
"nf.title": "Pagina non trovata",
"par.allCities": "Tutte le città",
"par.cityPh": "Città",
"pay.addr1": "Indirizzo",
"pay.addr2": "Linea indirizzo 2 (opzionale)",
"pay.addrIncomplete": "Per favore, compila il tuo indirizzo di consegna.",
"pay.city": "Città",
"pay.country": "Paese",
"pay.eurNote": "Importi mostrati in euro (€).",
"pay.free": "gratuito",
"pay.howRecover": "Come desideri riavere il tuo articolo?",
"pay.pickup": "Ritira di persona",
"pay.pickupDesc": "Presso",
"pay.postal": "Codice postale",
"pay.ship": "Spediscilo a me",
"pay.shipDesc": "Consegna al mio indirizzo",
"pay.shipping": "Spese di spedizione",
"pcat.city_hall": "Municipi",
"pcat.hotel": "Hotel",
"pcat.other": "Altro",
"pcat.park": "Parchi",
"pcat.prefecture": "Prefetture",
"pcat.restaurant": "Ristoranti",
"pcat.uncategorized": "Non categorizzato",
"pd.about": "Informazioni",
"pd.back": "Tutti i partner",
"pd.certified": "Partner certificato",
"pd.declare": "Segnala una perdita qui",
"pd.itemsReturned": "articoli restituiti",
"pd.itemsTotal": "articoli registrati",
"pd.map": "Posizione",
"pd.noItems": "Nessun articolo trovato di recente.",
"pd.noReviews": "Nessuna recensione ancora.",
"pd.notFound": "Partner non trovato.",
"pd.recentItems": "Articoli trovati di recente",
"pd.reply": "Risposta dell'attività",
"pd.reviews": "Recensioni dei clienti",
"pd.verified": "Recensione verificata",
"pd.verifiedEstablishment": "stabilimento verificato da Findloop",
"pg.next": "Avanti",
"pg.prev": "Precedente",
"pg.showing": "{from}–{to} di {total}",
"pk.bodyCopy": "Testo del corpo",
"pk.bodyText": "Testo del corpo",
"pk.brandColors": "Colori del marchio",
"pk.colorRed": "Rosso",
"pk.colorWhite": "Bianco",
"pk.darkBg": "Sfondo scuro",
"pk.download": "Scarica",
"pk.downloadZip": "Scarica l'intero kit (ZIP)",
"pk.headings": "Titoli",
"pk.heroDesc": "Loghi ufficiali, banner sui social media, colori e tipografia. Scegli la lingua e la variante del claim, quindi scarica il visual o l'intero kit.",
"pk.lightBg": "Sfondo chiaro (stampa)",
"pk.logoWordmark": "Logo / marchio",
"pk.logosVisuals": "Loghi e visual",
"pk.mapCollect": "Mappa / punti di raccolta",
"pk.plain": "Semplice",
"pk.pressKit": "Kit stampa",
"pk.taglineLang": "Lingua del claim",
"pk.typography": "Tipografia",
"pk.variant": "Variante",
"pr2.adBoostMsg": "Ottima scelta! Moltiplichi le tue possibilità di recuperare rapidamente il tuo articolo.",
"pr2.boostActivated": "Boost attivato!",
"pr2.canRecoverNow": "Ora puoi recuperare il tuo articolo.",
"pr2.continue": "Continua",
"pr2.downloadReceiptPdf": "Scarica la ricevuta (PDF)",
"pr2.goToSpaceNow": "Vai al mio account ora",
"pr2.partnerBoostMsg": "Ottima scelta! Essere più visibili significa attirare nuovi clienti nel tuo stabilimento.",
"pr2.paymentSuccess": "Pagamento riuscito!",
"pr2.redirectingSpace": "Reindirizzando al tuo account…",
"pr2.subActivated": "Pagamento riuscito! Il tuo abbonamento è attivo, puoi ora gestire i tuoi stabilimenti.",
"prev.allSites": "Tutti gli stabilimenti",
"pricing.annual": "Annuale",
"pricing.annualBadge": "-20% di offerta",
"pricing.monthly": "Mensile",
"pricing.perYear": "/anno",
"pricing.quoteMsg": "Le tue esigenze (opzionale)",
"pricing.quoteOrg": "Organizzazione",
"pricing.quoteSend": "Invia richiesta",
"pricing.quoteSent": "Richiesta inviata! Ti risponderemo a breve.",
"pricing.quoteSites": "Numero di siti / terminali",
"pricing.quoteTitle": "Richiedi un preventivo",
"pricing.requestQuote": "Richiedi un preventivo",
"pricing.saveLabel": "Risparmi",
"pricing.savePerYear": "/anno per ogni stabilimento extra",
"pub.accessGranted": "Accesso autorizzato",
"pub.accessLimited2h": "Accesso limitato a 2 ore",
"pub.accountEmailConcerned": "Email dell'account interessato",
"pub.adAppearPublic": "Ecco come apparirà il tuo annuncio pubblicamente.",
"pub.adPreviewBtn": "Anteprima annuncio",
"pub.alertMeOnArrival": "Avvisami all'arrivo",
"pub.allActionsLogged": "Tutte le azioni sono registrate",
"pub.allCategories": "Tutte le categorie",
"pub.authorizeAccess": "Autorizza accesso",
"pub.authorizeSupportQ": "Autorizzare l'accesso al supporto?",
"pub.available": "Disponibile",
"pub.backHome": "Torna alla home",
"pub.boostAdCta": "Potenzia il mio annuncio",
"pub.boostAdTitle": "Potenzia il tuo annuncio",
"pub.boostCarouselSub": "Sposta in cima alla pagina nel carosello “Potenziato” e moltiplica le visualizzazioni per recuperare il tuo articolo più velocemente.",
"pub.boostEstablishment": "Potenzia il tuo stabilimento",
"pub.boostEstablishmentDesc": "Appari in cima al direttorio con un badge “Potenziato” e attira più segnalazioni.",
"pub.boostFicheCta": "Potenzia la mia scheda",
"pub.brandReady": "Il marchio Findloop, pronto all'uso",
"pub.cantFindItem": "Non riesci a trovare il tuo articolo?",
"pub.cantProcessImage": "Impossibile elaborare questa immagine",
"pub.claimQr": "Richiedi codice QR",
"pub.clickToZoom": "Clicca per ingrandire",
"pub.codeAlreadyValidated": "Codice convalidato — contatti sbloccati.",
"pub.codeExample": "es. ABCD2345",
"pub.confirmRenewal": "Conferma rinnovo",
"pub.contactIntro": "Hai una domanda, una richiesta? Scrivici, ti risponderemo a breve.",
"pub.contactTypeDeceased": "Cancellazione account (persona deceduta)",
"pub.contactTypeGeneral": "Domanda generale",
"pub.contactTypeSupport": "Supporto / problema tecnico",
"pub.contactUs": "Contattaci",
"pub.continueWithoutEmail": "Continua senza lasciare la mia email",
"pub.contractLabel": "Contratto",
"pub.contractNotFound": "Contratto non trovato o già scaduto.",
"pub.contractRenewed": "Contratto rinnovato!",
"pub.contractRenewedFor": "Il tuo contratto è rinnovato per {n} mesi.",
"pub.copyFailed": "Copia fallita",
"pub.createPartnerAccount": "Crea il mio account partner",
"pub.currentDeadline": "Scadenza attuale",
"pub.deceasedInfo": "In quanto familiare o erede, puoi richiedere la cancellazione dell'account Findloop di una persona deceduta. Elaboreremo la tua richiesta in conformità al GDPR (potranno essere richiesti documenti di supporto).",
"pub.declareMyLoss": "Dichiara la mia perdita",
"pub.describeItemPlaceholder": "Descrivi il tuo articolo (es. ombrello nero, chiavi…)",
"pub.downloadImage": "Scarica l'immagine",
"pub.drawSignature": "Si prega di disegnare la propria firma.",
"pub.drawSignatureHint": "Disegna la tua firma con il mouse o con il dito.",
"pub.duration": "Durata",
"pub.eSignature": "Firma elettronica",
"pub.eSignatureDesc": "Inserisci il tuo nome per firmare. La data viene registrata automaticamente.",
"pub.edit": "Modifica",
"pub.editorialTitles": "Titoli editoriali",
"pub.emailPlaceholder": "tu@example.com",
"pub.enterCodeUnlockOwner": "Inserisci il codice ricevuto via email per sbloccare i dettagli di contatto del proprietario.",
"pub.errorWord": "Errore",
"pub.foundSelfService": "Oggetti trovati · Self-service",
"pub.haveOwnerCode": "Ho ricevuto un codice dal proprietario",
"pub.home": "Home",
"pub.immediateRenewal": "Rinnovo immediato, senza un nuovo preventivo.",
"pub.impAdminReq1": "Amministratore",
"pub.impAdminReq2": "richiede il permesso di accedere temporaneamente al tuo account",
"pub.impAdminReq3": "per assisterti.",
"pub.impGrantedDesc": "Il team di supporto potrà accedere al tuo account per un massimo di 2 ore. Ogni azione sarà registrata. Puoi chiudere questa pagina.",
"pub.invitedOnFindo": "Sei invitato a Findloop",
"pub.isThisYourItem": "È questo il tuo oggetto?",
"pub.itemsAvailableCount": "{n} oggetto(i) attualmente disponibile(i)",
"pub.itemsFoundOwner": "degli oggetti affidati hanno trovato il loro proprietario",
"pub.itemsReturnedOwners": "oggetti restituiti ai loro proprietari",
"pub.itsMine": "È mio",
"pub.joinFindoDesc": "Unisciti a Findloop e gestisci i tuoi oggetti trovati con facilità.",
"pub.joinInvitesYou": "ti invita a unirti a findloop. Crea il tuo account partner per gestire i tuoi oggetti trovati.",
"pub.linkCopied": "Link copiato!",
"pub.loadingContract": "Caricamento del contratto…",
"pub.lsClaimDesc": "Segnala la tua perdita per recuperarla. Lascia la tua email e ti invieremo un promemoria se la tua segnalazione non è completata.",
"pub.lsHeroDesc": "Controlla da solo se il tuo oggetto smarrito è stato trovato e lasciato qui. Lo hai trovato? Segnalo per recuperarlo.",
"pub.lsSearchTitle": "Cerca oggetti trovati",
"pub.makeOffer": "Fai un'offerta",
"pub.makeOfferDesc": "Proponi il tuo importo. Il superadmin lo esaminerà.",
"pub.mapNearYou": "Oggetti e partner vicino a te",
"pub.mapWord": "Mappa",
"pub.messageSentToast": "Messaggio inviato — il nostro team risponderà a breve.",
"pub.messageWord": "Messaggio",
"pub.momoInitiated": "Pagamento tramite Mobile Money avviato",
"pub.monthsWord": "mesi",
"pub.nameConsentRequired": "Nome e consenso richiesti.",
"pub.newDeadline": "Nuova scadenza",
"pub.noActionRequired": "Nessuna azione richiesta.",
"pub.noAmountCharged": "Nessun importo è stato addebitato.",
"pub.noItemMatch": "Nessun oggetto disponibile corrisponde alla tua ricerca al momento.",
"pub.noMatchingItem": "Nessun oggetto corrispondente",
"pub.noPaymentSession": "Nessuna sessione di pagamento.",
"pub.noPhoto": "Nessuna foto",
"pub.noPointsYet": "Nessun punto da visualizzare ancora.",
"pub.noSecondPayment": "Non è richiesto alcun secondo pagamento per questo oggetto.",
"pub.notHereYet": "Non è ancora qui? Ricevi una notifica non appena arriva.",
"pub.notifyDone": "Annotato! Ti notifieremo via email non appena un oggetto corrispondente arriverà.",
"pub.offerSubmitted": "La tua offerta è stata inviata.",
"pub.oops": "Ops",
"pub.orAlertEmail": "Oppure ricevi un avviso via email non appena un oggetto corrispondente arriva:",
"pub.ownerContacts": "Dettagli di contatto del proprietario",
"pub.ownerContactsUnlocked": "Dettagli di contatto del proprietario sbloccati",
"pub.partnerContact": "Contatto partner",
"pub.payLinkUnavailable": "Link di pagamento non disponibile — contatta il partner.",
"pub.paymentCancelled": "Pagamento annullato",
"pub.paymentConfirmed": "Pagamento confermato 🎉",
"pub.paymentConfirmedDesc": "Riceverai un'email con i dettagli per recuperare il tuo oggetto.",
"pub.paymentNotConfirmed": "Pagamento non confermato",
"pub.paymentNotConfirmedDesc": "Il pagamento non può essere verificato. Riprova o contatta il partner.",
"pub.paymentProcessing": "Pagamento in fase di elaborazione. Ricarica tra un momento.",
"pub.photoAdded": "✓ Foto aggiunta",
"pub.photoRequired": "È richiesta una foto dell'oggetto.",
"pub.previewAlt": "anteprima",
"pub.publish": "Pubblica",
"pub.publishingWord": "Pubblicazione in corso…",
"pub.qty": "Qtà",
"pub.quoteDeclined": "Preventivo rifiutato.",
"pub.quoteNotFound": "Preventivo non trovato o scaduto.",
"pub.reasonLabel": "Motivo",
"pub.recoveryAlreadyPaid": "Costo di recupero già pagato",
"pub.referralCode": "Codice di riferimento:",
"pub.relationshipPlaceholder": "Figlio, coniuge, notaio…",
"pub.renewYourContract": "Rinnova il tuo contratto",
"pub.renewalFailed": "Rinnovo fallito. Riprova più tardi.",
"pub.renewing": "Rinnovo in corso…",
"pub.replySoon": "Il nostro team risponderà il prima possibile.",
"pub.requestGone": "Questa richiesta non esiste più.",
"pub.requestHandled": "Richiesta già gestita",
"pub.requestNotFound": "Richiesta non trovata o scaduta.",
"pub.requestUnavailable": "Richiesta non disponibile",
"pub.required": "(obbligatorio)",
"pub.retroClosing": "Insieme, rendiamo il mondo un po' meno smarrito.",
"pub.retroClosing2": "Insieme, rendiamo il mondo un po' meno smarrito.",
"pub.retroScroll": "Un anno di recupero di ciò che conta. Scorri in basso ↓",
"pub.revokeAnytime": "Puoi revocare in qualsiasi momento contattandoci",
"pub.scene": "Scena",
"pub.sendImpossible": "Impossibile inviare",
"pub.sendMessage": "Invia il messaggio",
"pub.sending": "Invio in corso…",
"pub.sharePreview": "Condividi anteprima",
"pub.shareYourAd": "Condividi il tuo annuncio",
"pub.signedSuccess": "Firmato con successo!",
"pub.signerFullName": "Nome completo del firmatario",
"pub.spreadNetwork": "Condividilo con chi ti circonda per aumentare le tue possibilità.",
"pub.spreadOwner": "Condividilo per aiutare il proprietario a recuperare i propri beni.",
"pub.statusLabel": "Stato:",
"pub.subject": "Oggetto",
"pub.thanksSent": "Grazie, il tuo messaggio è stato inviato.",
"pub.thisYear": "Quest'anno",
"pub.validate": "Valida",
"pub.verifyingPayment": "Verifica pagamento…",
"pub.verifyingYourPayment": "Verifica il tuo pagamento…",
"pub.viewAd": "Visualizza l'annuncio →",
"pub.viewPartner": "Visualizza il partner →",
"pub.yourAdPreview": "Anteprima del tuo annuncio",
"pub.yourEmail": "La tua email",
"pub.yourEmailRecommended": "La tua email (raccomandata)",
"pub.yourEmailShort": "La tua email",
"pub.yourName": "Il tuo nome",
"pub.yourRelationship": "La tua relazione con la persona",
"qv.acceptAndSign": "Accetta e firma il mio preventivo",
"qv.certifyAuthorized": "Certifico di essere autorizzato a firmare e accetto i termini di questo {what} (valore vincolante).",
"qv.clear": "Pulisci",
"qv.client": "Cliente",
"qv.conditions": "Termini",
"qv.confirmDecline": "Conferma il rifiuto di questo preventivo?",
"qv.countersignedFindo": "Controfirmato da Findloop · {name} il {date}",
"qv.decline": "Rifiuta",
"qv.description": "Descrizione",
"qv.downloadPdf": "Scarica il PDF",
"qv.handwrittenSignature": "Firma autografa",
"qv.inclTax": "Incluso. tassa",
"qv.invalidAmount": "Importo non valido.",
"qv.invoice": "Fattura",
"qv.invoicePaid": "Fattura pagata",
"qv.issuer": "Emittente",
"qv.messageOptional": "Messaggio (opzionale)",
"qv.negotiatedAmount": "Importo negoziato",
"qv.payInvoiceOnline": "Paga la fattura online",
"qv.quote": "Preventivo",
"qv.quoteValidDays": "Preventivo valido per {n} giorni.",
"qv.sendMyOffer": "Invia la mia offerta",
"qv.signContract": "Firma il mio contratto",
"qv.signNow": "Firma ora",
"qv.signatureAlt": "Firma",
"qv.signedByOn": "✔ Firmato da {name} il {date}",
"qv.stContractSigned": "Contratto firmato. Grazie!",
"qv.stCounterAccepted": "La tua offerta è stata accettata! Firma il tuo contratto qui sotto.",
"qv.stCounterRefused": "La tua offerta non può essere accettata.",
"qv.stCountered": "La tua offerta è stata inviata. In attesa della risposta di findloop.",
"qv.stDeclined": "Hai rifiutato questo preventivo.",
"qv.stSigned": "Preventivo accettato e firmato. Grazie!",
"qv.totalHt": "Totale escl. tassa",
"qv.totalTtc": "Totale incl. tassa",
"qv.unitHt": "Unità escl. tassa",
"qv.vat": "IVA",
"qv.yourProposedAmount": "Il tuo importo proposto ({cur})",
"reg.add": "Registra un oggetto",
"reg.allBrands": "Tutte le marche",
"reg.allColors": "Tutti i colori",
"reg.allLocations": "Tutte le posizioni",
"reg.detailDesc": "Dettagli e azioni per questo oggetto trovato.",
"reg.dispAuction": "Asta",
"reg.dispAuthorities": "Consegnato alle autorità",
"reg.dispDestroyed": "Distrutto",
"reg.dispDonate": "Donazione a beneficenza",
"reg.dispositionHint": "Registra l'uscita dell'oggetto dal magazzino. Conteggiato nelle statistiche per categoria.",
"reg.emptyCta": "Registra un oggetto",
"reg.emptyDesc": "Inizia registrando il tuo primo oggetto trovato.",
"reg.emptyTitle": "Nessun oggetto trovato",
"reg.establishmentFallback": "l'istituzione",
"reg.lblAuctioned": "elencato all'asta",
"reg.lblAuctionedShort": "messo all'asta",
"reg.lblAuthorities": "consegnato alle autorità",
"reg.lblDestroyed": "distrutto",
"reg.lblDonated": "donato a una beneficenza",
"reg.legalCount": "{n} oggetto(i): periodo di conservazione legale raggiunto",
"reg.legalHint": "Puoi metterli all'asta, donarli a una beneficenza o segnalare la loro consegna alle autorità.",
"reg.legalLimitCountry": "Scadenza: {date} · paese applicato: {country}",
"reg.legalOver": "Scadenza superata: {date} · {country}",
"reg.legalReached": "Periodo legale raggiunto",
"reg.legalReachedFull": "Periodo di conservazione legale raggiunto",
"reg.limitShort": "scadenza",
"reg.location": "Posizione",
"reg.markRestituted": "Segna come restituito",
"reg.markedAs": "Elemento contrassegnato come {label}",
"reg.moveHistory": "Storico dei movimenti",
"reg.overBy": "superato di {n}d",
"reg.physicalLocation": "Posizione fisica",
"reg.popupBlocked": "Consenti pop-up per stampare le etichette.",
"reg.popupBlockedOne": "Consenti pop-up per stampare l'etichetta.",
"reg.printLabel": "Stampa l'etichetta",
"reg.printN": "Stampa {n} etichetta(e)",
"reg.qrCodeItem": "Codice QR dell’elemento",
"reg.qrLabelTitle": "Etichetta QR",
"reg.qrLabelsTitle": "Etichette QR",
"reg.qrNotFound": "Nessun elemento trovato per questo codice QR.",
"reg.qrScanHint": "Scansiona per aprire direttamente questo record e trovare la posizione.",
"reg.recoveryFee": "Tassa di recupero (€)",
"reg.searchPh": "Cerca per descrizione…",
"reg.selectQr": "Seleziona per stampare le etichette QR",
"reg.selectedN": "{n} selezionati",
"reg.shipPricePh": "Prezzo di spedizione (€)",
"reg.shippingPossible": "Spedizione disponibile",
"reg.storagePh": "es. Scaffale A3, Armadietto 12",
"reg.tAuction": "Asta su Findloop",
"reg.tAuthorities": "Segnala consegna alle autorità",
"reg.tDonate": "Dona a un’organizzazione di beneficenza",
"reg.toastFee": "Tassa aggiornata",
"reg.toastLocation": "Posizione salvata",
"reg.toastRestituted": "Elemento contrassegnato come restituito",
"reg.toastShipping": "Opzione di spedizione aggiornata",
"reg.toastTransferred": "Elemento trasferito a “{name}”",
"reg.unclaimedDisposition": "Elemento non reclamato — disposizione finale",
"res.codeValidated": "Codice convalidato",
"res.empty": "Nessuna restituzione registrata finora.",
"res.error": "Errore {status}",
"res.proofPdf": "Prova PDF",
"res.signed": "Firmato",
"res.stRestituted": "Consegnato di persona",
"res.stShipped": "Restituito per spedizione",
"res.subtitle": "Tutte le consegne completate, con la loro prova firmata scaricabile.",
"res.title": "Storia delle restituzioni",
"rev.restitutedBy": "Restituito da {org}",
"rev.storiesEyebrow": "Fini felici",
"rev.storiesSubtitle": "Storie reali di clienti che hanno recuperato i loro beni con findloop.",
"rev.storiesTitle": "Hanno ritrovato i loro beni!",
"rp.duplicate": "Duplicato",
"rp.inappropriate": "Contenuto inappropriato",
"rp.wrongCategory": "Categoria sbagliata",
"rt.annualGoal": "Obiettivo annuale",
"rt.championCity": "Città campione",
"rt.cityRate": "{rate}% tasso di restituzione",
"rt.goalProgress": "{rate}% raggiunto di un obiettivo del {target}%",
"rt.reached": "Raggiunto 🎉",
"rt.restitutionRate": "Tasso di restituzione",
"rt.shareRecap": "Condividi il mio riepilogo",
"rt.thanks": "Grazie Findloop {year} 💛",
"rt.yourRecap": "Il tuo riepilogo {year}",
"rw.active": "Attivo",
"rw.add": "Aggiungi",
"rw.camUnavailable": "Camera non disponibile. Inserisci il codice manualmente qui sotto.",
"rw.codeValidated": "Codice convalidato",
"rw.codesTitle": "Codici riscattati dai trovatori",
"rw.confirmDelete": "Eliminare “{title}”?",
"rw.deleted": "Eliminato",
"rw.edit": "Modifica",
"rw.editReward": "Modifica la ricompensa",
"rw.empty": "Nessuna ricompensa ancora.",
"rw.expired": "Scaduto",
"rw.expiresOn": "Scade il {date}",
"rw.fActive": "Attivo (visibile ai trovatori)",
"rw.fCost": "Costo (punti)",
"rw.fDesc": "Descrizione",
"rw.fStock": "Stock (vuoto = illimitato)",
"rw.fTitle": "Titolo",
"rw.fValidity": "Validità del buono (giorni dopo il riscatto)",
"rw.inactive": "Inattivo",
"rw.newReward": "Nuova ricompensa",
"rw.noExchange": "Nessun riscatto ancora.",
"rw.pageSubtitle": "Scansiona i buoni presentati dai trovatori per convalidare le loro ricompense.",
"rw.redeemedN": "Riscattato: {n}×",
"rw.saved": "Ricompensa salvata",
"rw.scanVoucher": "Scansiona un buono",
"rw.staffScanOnly": "Scansiona solo",
"rw.statActive": "Da presentare",
"rw.statExpired": "Scaduto",
"rw.statRedeemed": "Buoni riscattati",
"rw.statUsed": "Convalidato",
"rw.stock": "Stock",
"rw.subtitle": "Offri vantaggi non monetari (buoni, upgrade…) che i trovatori riscattano per i loro punti Finder Score.",
"rw.title": "Ricompense per trovatori",
"rw.used": "Usato",
"rw.validate": "Convalida",
"rw.validateCode": "Convalida il codice",
"rw.validity": "Validità: {n} g",
"side.establishments": "Stabilimenti",
"side.restitutions": "Resi",
"side.storage": "Magazzino & QR",
"status.auctioned": "Asta",
"status.destroyed": "Distrutto",
"status.donated": "Donato (charità)",
"status.handed_to_authorities": "Consegnato alle autorità",
"status.in_storage": "In magazzino",
"status.matched": "Corrispondenza",
"status.open": "Aperto",
"status.paid": "Pagato",
"status.pending": "In attesa",
"status.restituted": "Restituito",
"status.shipped": "Spedito",
"status.shipping_requested": "Spedizione richiesta",
"status.submitted": "Inviato",
"stg.allLabels": "Tutti i codici QR",
"stg.camHint": "Usa l'inserimento manuale qui sotto.",
"stg.camStarting": "Avviando la fotocamera…",
"stg.camUnavailable": "Fotocamera non disponibile.",
"stg.clear": "Pulisci",
"stg.clearAll": "Pulisci tutto",
"stg.codeUnreadable": "Codice illeggibile.",
"stg.emptyDesc": "Gli oggetti memorizzati appariranno qui, raggruppati per posizione.",
"stg.emptyTitle": "Nessun oggetto in magazzino",
"stg.exportAudit": "Esporta audit CSV",
"stg.exportDone": "Esportazione CSV completata",
"stg.exportImpossible": "Esportazione non disponibile al momento.",
"stg.itemFound": "Oggetto trovato ✅",
"stg.kLocations": "Posizioni utilizzate",
"stg.kObjects": "Oggetti memorizzati",
"stg.kToClear": "Posizioni da liberare",
"stg.locFreed": "Posizione liberata",
"stg.locsFreed": "{n} posizione(i) liberata(e)",
"stg.manualLabel": "Oppure inserisci il codice / ID dell'oggetto",
"stg.manualPh": "Incolla l'ID o URL del QR",
"stg.noItemMatch": "Nessun oggetto corrisponde a questo QR / codice.",
"stg.noLocation": "Nessuna posizione",
"stg.objectsAxis": "Oggetti",
"stg.objectsN": "{n} oggetto(i)",
"stg.occAvg": "media {n} oggetti/posizione",
"stg.occHint": "Le posizioni in ambra superano la media (potenzialmente sovraccariche).",
"stg.occupancy": "Occupazione della posizione",
"stg.openPage": "Apri la pagina",
"stg.posterPdf": "Poster PDF (A4)",
"stg.printAll": "Stampa tutto",
"stg.printGroupTitle": "Stampa etichette per questo scaffale",
"stg.qrAlt": "QR self-service",
"stg.qrDownload": "Scarica il QR",
"stg.qrHint": "Mostra questo QR al banco: i tuoi clienti lo scansionano per verificare se l'oggetto è disponibile.",
"stg.qrTitle": "QR self-service per i clienti",
"stg.scanDesc": "Scansiona l'etichetta di un oggetto per aprire il suo record istantaneamente.",
"stg.scanQr": "Scansiona un QR",
"stg.scanTitle": "Scansiona un codice QR",
"stg.search": "Cerca",
"stg.shelf": "Scaffale {loc}",
"stg.shelfPlan": "Piano dello scaffale",
"stg.staleHint": "Libera queste posizioni per mantenere il tuo inventario fisico aggiornato.",
"stg.staleTitle": "{n} oggetto(i) hanno lasciato il magazzino ma mantengono ancora una posizione",
"stg.subtitle": "Piano dello scaffale, scanner QR e tracciamento dell'inventario fisico.",
"stg.title": "Magazzino & QR",
"stt.acceptRate": "Tasso di accettazione",
"stt.accepted": "Accettato",
"stt.activity30": "Attività (ultimi 30 giorni)",
"stt.ai6mo": "Ultimi 6 mesi · accettato = abbinato automaticamente + confermato.",
"stt.aiEmpty": "Nessun abbinamento AI in questo periodo.",
"stt.aiTitle": "Abbinamenti AI — accettati vs rifiutati",
"stt.auctionShort": "Asta",
"stt.auctionedSold": "Asta (venduto)",
"stt.authShort": "Autorità",
"stt.authorities": "Consegnato alle autorità",
"stt.avgRating": "Valutazione media",
"stt.awaitingRestitution": "oggetti in attesa di restituzione",
"stt.boostClicks": "Clic sul tuo elenco questa settimana grazie a boost",
"stt.boostInactive": "Boost inattivo — attivalo per ottenere visibilità",
"stt.certifiedPremium": "Premium certificato",
"stt.declarations": "Dichiarazioni",
"stt.destroyed": "Distrutto",
"stt.dispoEmpty": "Nessun oggetto non reclamato ha lasciato il magazzino.",
"stt.donatedAssoc": "Donato (beneficenza)",
"stt.donatedShort": "Donato",
"stt.gateCta": "Scopri i piani",
"stt.gateDesc": "Aggiorna a Starter per sbloccare le tue statistiche di base, o a Business per statistiche avanzate e analisi per stabilimento.",
"stt.gateTitle": "Statistiche riservate ai piani a pagamento",
"stt.inStorage": "In magazzino",
"stt.kItems": "Oggetti registrati",
"stt.kRate": "Tasso di restituzione",
"stt.kRestituted": "Oggetti restituiti",
"stt.kRevenue": "Entrate (mese)",
"stt.noDeclYet": "Nessuna dichiarazione ancora.",
"stt.recapDownloaded": "Riepilogo scaricato — pronto per essere condiviso!",
"stt.recapError": "Impossibile generare il riepilogo",
"stt.recapText": "Il nostro riepilogo Findloop {year}: articoli restituiti e soddisfazione del cliente 🎉",
"stt.recapTitle": "riepilogo Findloop {year}",
"stt.rejected": "Rifiutato",
"stt.restitutions": "Resi",
"stt.shareRecap": "Condividi il mio riepilogo {year}",
"stt.topCategories": "Categorie più dichiarate",
"stt.unclaimedDesc": "Volume di articoli distrutti, donati a enti di beneficenza e messi all'asta, per categoria.",
"stt.unclaimedTitle": "Articoli non richiesti — in uscita dal magazzino",
"stt.vsLastWeek": "rispetto alla scorsa settimana",
"sub.cancel": "Annulla il mio abbonamento",
"sub.cancelAbort": "Annulla",
"sub.cancelConfirm1": "Sei sicuro di voler annullare? Il tuo accesso rimane attivo fino al",
"sub.cancelConfirm2": "Non sarà emesso alcun rimborso.",
"sub.cancelConfirmBtn": "Conferma cancellazione",
"sub.cancelTitle": "Annulla il tuo abbonamento",
"sub.cancelledToast": "Cancellazione registrata.",
"sub.cguAnd": "e il",
"sub.cguDesc": "Si prega di confermare il proprio accordo prima del pagamento.",
"sub.cguLink": "Termini di utilizzo",
"sub.cguPay": "Continua al pagamento",
"sub.cguPre": "Ho letto e accetto il",
"sub.cguRequired": "Devi accettare i Termini di Utilizzo e la Politica sulla Privacy per continuare.",
"sub.cguSuffix": "di findloop.",
"sub.cguTitle": "Finalizza il tuo abbonamento",
"sub.expiresOn": "Il tuo abbonamento scade il",
"sub.noProrata": "Nessun rimborso pro-rata.",
"sub.privacyLink": "Politica sulla Privacy",
"sub.renewsOn": "Il tuo abbonamento si rinnova il",
"sub.resume": "Riabbonati",
"sub.resumedToast": "Riabbonamento confermato.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Business",
"tier.small": "Starter",
"tm.add": "Aggiungi",
"tm.adminOpt": "Admin (visualizzazione completa)",
"tm.chooseEst": "Scegli un'istituzione",
"tm.chooseEstPh": "Scegli un'istituzione",
"tm.copyFail": "Copia non riuscita",
"tm.copyLink": "Copia il link",
"tm.copyOk": "Link di invito copiato",
"tm.emailHint": "Una email di invito sarà inviata per creare la password.",
"tm.expiresOn": "scade il {date}",
"tm.forEmail": " per {email}",
"tm.forbidden": "La gestione del team è riservata al proprietario dell'account.",
"tm.inviteCreated": "Invito creato",
"tm.inviteDesc": "Un'email di invito consente al membro del team di creare la propria password.",
"tm.invitePending": "Invito in attesa",
"tm.inviteResent": "Invito reinviato",
"tm.inviteSent": "Invito inviato via email",
"tm.inviteTitle": "Invita un membro",
"tm.invitedOn": "Invitato il {date}",
"tm.linkExpired": "Link scaduto",
"tm.memberRemoved": "Membro rimosso",
"tm.name": "Nome",
"tm.noMembers": "Nessun membro del team ancora.",
"tm.resendTitle": "Reinvia l'invito",
"tm.role": "Ruolo",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Proprietario",
"tm.roleStaff": "Staff",
"tm.roleUpdated": "Ruolo aggiornato",
"tm.sendInvite": "Invia l'invito",
"tm.sending": "Invio in corso…",
"tm.staffOpt": "Staff (vede solo il proprio stabilimento)",
"trk.carrier": "Corriere",
"trk.codeValidated": "Codice convalidato dal partner",
"trk.dlProof": "Scarica la mia prova di consegna (PDF)",
"trk.enterEmailCode": "Inserisci la tua email sopra per visualizzare il tuo codice di richiesta.",
"trk.lostEmail": "Non ho più accesso alla mia email",
"trk.phonePh": "Il tuo numero di telefono",
"trk.photoBefore": "Foto dell'oggetto prima della spedizione",
"trk.recoverHint": "Ricevi il tuo codice di richiesta via SMS sul tuo numero registrato.",
"trk.secureRest": "Consegna sicura",
"trk.send": "Invia",
"trk.shipPending": "Spedizione in preparazione — il numero di tracciamento apparirà qui una volta spedito.",
"trk.shipTitle": "Tracciamento della spedizione",
"trk.showQr": "Mostra questo QR al partner per convalidare la consegna",
"trk.sigSaved": "Firma salvata",
"trk.signFirst": "Per favore firma prima di confermare.",
"trk.signProof": "Firma la tua prova di consegna",
"trk.signSubmit": "Conferma la mia firma e genera il PDF",
"trk.trackShipment": "Traccia pacco",
"trk.trackingNo": "Numero di tracciamento",
"trk.yourCode": "Il tuo codice di richiesta (da dare al partner)",
"a.firstName": "Nome",
"ac.emailCrossMatch": "Incroci B2C",
"ac.emailCrossMatchDesc": "Un'email quando un annuncio pubblico di oggetti smarriti corrisponde a un oggetto depositato presso di te",
"ac.emailCrossReject": "Rifiuti di incrocio pubblici",
"ac.emailCrossRejectDesc": "Ricevi un'email quando un cliente indica che un incrocio pubblico suggerito non è il suo oggetto.",
"ac.emailLoginNotif": "Notifica di accesso",
"ac.emailLoginNotifDesc": "Ricevi un'email ogni volta che qualcuno accede al tuo account.",
"ad.closeNoCancel": "No, rimuovi l'annuncio",
"ad.closeQuestion": "L'oggetto ti è stato restituito?",
"ad.closeQuestionDesc": "Facci sapere se hai recuperato il tuo oggetto o se desideri semplicemente rimuovere questo annuncio.",
"ad.closeYesRestituted": "Sì, l'oggetto è stato restituito",
"ad.closedRestituted": "Oggetto restituito — annuncio chiuso 🎉",
"an.lostLoginDesc": "È necessario un account per segnalare un oggetto smarrito e seguirne il ritorno.",
"an.lostLoginRequired": "Accedi per segnalare un oggetto smarrito",
"an.qfAll": "Tutti",
"an.qfBoosted": "Potenziati",
"an.qfPhoto": "Con foto",
"an.qfRecent": "Questa settimana",
"an.qfResolved": "Risolti",
"an.restitutionInProgress": "Oggetto in fase di restituzione",
"dec.descPhLong": "Descrivi l'oggetto: marca, colore, segni distintivi… (Più dettagli fornisci, maggiori sono le possibilità di recuperare il tuo oggetto)",
"dec.loadError": "Impossibile caricare il partner in questo momento. Controlla la tua connessione e riprova.",
"dec.retry": "Riprova",
"dec.shippingMode": "Spedizione",
"dep.photo2": "2° foto dell'oggetto",
"dep.photo2Hint": "Facoltativo — un altro angolo migliora l'accuratezza del riconoscimento visivo.",
"dl.accountSuspended": "Account sospeso per una fattura non pagata. Salda per ripristinare il tuo accesso.",
"dl.regularize": "Salda ora →",
"dl.suspensionCountdown": "Fattura {num} non pagata — il tuo account sarà sospeso tra {days} giorno(i). Salda per evitare questo.",
"ft.cancelConfirm": "Annullare la tua segnalazione? Il proprietario dell'oggetto verrà informato.",
"ft.cancelDone": "Segnalazione annullata.",
"ft.cancelLocked": "L'annullamento non è più possibile dopo che il proprietario ha pagato.",
"ft.cancelReport": "Annulla la mia segnalazione",
"ft.claimCodeHelp": "Dai questo codice al trovante durante la consegna per confermare che hai ricevuto il tuo oggetto.",
"ft.claimCodeTitle": "Il tuo codice di restituzione",
"ft.claimDone": "Oggetto restituito. Grazie per aver usato Findloop!",
"ft.claimUnlockHint": "Sblocca i dettagli di contatto del trovante",
"ft.claimUnlockHintSub": "Vai a \"Oggetti che sto richiedendo\" nel tuo account per pagare la tariffa e ottenere i dettagli di contatto.",
"ft.finderCodeShownHelp": "Il proprietario ha pagato e ti ha selezionato. Copia questo codice qui sotto per confermare la restituzione — non è necessario controllare la tua email.",
"ft.finderCodeShownTitle": "Codice di validazione del proprietario",
"ft.finderContactsTitle": "Dettagli di contatto del Finder",
"ft.foundCodeHelp": "Mostra questo codice al proprietario al momento della consegna per confermare che l'oggetto è stato restituito.",
"ft.inProgressOther": "Oggetto in fase di restituzione",
"ft.inProgressOtherHelp": "Il proprietario ha selezionato un altro finder per questo oggetto. Non è necessaria alcuna ulteriore azione da parte tua.",
"ft.restitutionCodeHelp": "Questo codice conferma la consegna dell'oggetto. È già precompilato qui sotto; convalidalo e poi chiudi il caso.",
"ft.restitutionCodeTitle": "Il tuo codice di restituzione",
"hc.14Digits": "14 cifre",
"hc.15DaysBeforeAnItem": "15 giorni prima della scadenza legale dell'oggetto.",
"hc.7DaysBeforeAnItem": "7 giorni prima della scadenza legale dell'oggetto.",
"hc.8CharactersMinimum": "Minimo 8 caratteri.",
"hc.aClaimToValidate": "Una richiesta da convalidare",
"hc.aFindoAssistanceSessionIs": "Una sessione di assistenza Findloop è attualmente attiva sul tuo account.",
"hc.aNewMatchHasBeen": "È stata trovata una nuova corrispondenza",
"hc.aUser": "Un utente",
"hc.aUserClaimsToBe": "Un utente afferma di essere il proprietario. Controlla le loro risposte prima di autorizzare la restituzione.",
"hc.aboutFindo": "Informazioni su Findloop",
"hc.accountActivatedPleaseLogIn": "Account attivato, per favore accedi.",
"hc.accountActivation": "Attivazione dell'account",
"hc.accountCreated": "Account creato!",
"hc.accountDeactivatedAReactivationEmail": "Account disattivato. È stata inviata un'email di riattivazione (valida per 30 giorni).",
"hc.accountReactivation": "Riattivazione dell'account",
"hc.activateMyAccount": "Attiva il mio account",
"hc.activateMyAdminAccount": "Attiva il mio account admin",
"hc.activating": "Attivazione in corso…",
"hc.activeMatchCancelReason": "Corrispondenza attiva. Motivo di cancellazione del cliente: \"{reason}\". L'oggetto è ancora in attesa di una richiesta.",
"hc.activeMatchWithAPublic": "Corrispondenza attiva con una lista pubblica (cliente). In attesa della richiesta del proprietario.",
"hc.addAPhoto": "Aggiungi una foto",
"hc.addAndConfigureYourEstablishments": "Aggiungi e configura i tuoi stabilimenti in \"Stabilimenti\": dettagli di contatto, categoria e stoccaggio fisico degli oggetti.",
"hc.addOnGoogle": "Aggiungi su Google",
"hc.address": "Indirizzo",
"hc.addressSaved": "Indirizzo salvato",
"hc.addressStreet": "Indirizzo — Via",
"hc.adjustThePhoto": "Regola la foto",
"hc.adminFullView": "Amministratore (vista completa)",
"hc.administratorOnly": "Solo amministratore",
"hc.africa": "Africa",
"hc.aiVisualComparison": "Confronto visivo AI",
"hc.all": "Tutti",
"hc.amount": "Importo",
"hc.anOrganization": "Un'organizzazione",
"hc.analyzing": "Analizzando…",
"hc.andRecoveryIs": "e il recupero è",
"hc.andTheDeclarationWillBe": "e la dichiarazione sarà chiusa (trasferita nella storia). Questa azione è definitiva.",
"hc.annual20": "Annuale -20%",
"hc.annualBilling20": "Fatturazione annuale (−20%)",
"hc.annualTarget": "Obiettivo annuale",
"hc.anyCommentsOptional": "Commenti? (opzionale)",
"hc.approveTheClaim": "Approva la richiesta",
"hc.archiveCancelledConfirm": "Archivia {n} inserzione(i) \"Annullata dal cliente\"? Verranno rimossi dal registro.",
"hc.asSoonAs": "Non appena",
"hc.askTheOwnerToDisplay": "Chiedi al proprietario di visualizzare il QR del loro codice (pagina di tracciamento).",
"hc.askThemAtTheCounter": "Chiedi loro al bancone di confermare l'identità — mai visibile pubblicamente.",
"hc.assistance": "Supporto",
"hc.assistanceSessionRevoked": "Sessione di assistenza revocata.",
"hc.atLeast6Characters": "Almeno 6 caratteri",
"hc.automaticallyPreSelected": "selezionato automaticamente",
"hc.automaticallyWhenShipping": "automaticamente durante la spedizione.",
"hc.awaitingClaim": "In attesa della richiesta",
"hc.awaitingPayment": "In attesa del pagamento",
"hc.b2cCustomer": "Cliente B2C",
"hc.back": "Indietro",
"hc.backToHome": "Torna alla home",
"hc.backToMyAccount": "Torna al mio account",
"hc.backToPayment": "Torna al pagamento",
"hc.beforeAfterComparisonSlider": "Fetta di confronto prima/dopo",
"hc.billingInformation": "Informazioni di fatturazione",
"hc.billingInformationSaved": "Informazioni di fatturazione salvate ✓",
"hc.brand": "Marchio",
"hc.bronze": "Bronzo",
"hc.calculatingTheShippingRate": "Calculando la tariffa di spedizione…",
"hc.cameraUnavailableEnterTheCode": "Fotocamera non disponibile. Inserisci il codice manualmente.",
"hc.cancel": "Annulla",
"hc.cancelMyDeclaration": "Annulla la mia dichiarazione",
"hc.cancelSavedFmt": "Cancellazione salvata: \"{reason}\". Puoi comunque richiedere.",
"hc.cancelTheDeposit": "Annulla il deposito",
"hc.cancelThisMatch": "Annulla questa corrispondenza",
"hc.cancellationReason": "Motivo dell'annullamento",
"hc.cancelled": "Annullato",
"hc.cancelledByTheCustomer": "Annullato dal cliente",
"hc.cannotOpenPayment": "Impossibile aprire il pagamento. Riprova.",
"hc.closeTheDeclaration": "Chiudi la dichiarazione",
"hc.closeTheDeclaration2": "Chiudere la dichiarazione?",
"hc.codeAlreadyVerified": "Codice già verificato",
"hc.codeCopied": "Codice copiato",
"hc.collapse": "Riduci",
"hc.color": "Colore",
"hc.company": "Azienda",
"hc.companyName": "Nome azienda",
"hc.comparePhotos": "Confronta foto",
"hc.compareThemWithTheOwner": "Confrontali con le risposte del proprietario — mai visibili pubblicamente.",
"hc.condition": "Condizione",
"hc.confirmAndPay": "Conferma e paga",
"hc.confirmCancellation": "Conferma cancellazione",
"hc.confirmCrop": "Conferma ritaglio",
"hc.confirmDeletion": "Conferma eliminazione",
"hc.confirmPassword": "Conferma password",
"hc.confirmThatThisIsYour": "Conferma che questo è il tuo oggetto. Verrà richiesta una verifica dell'identità al trovatore prima di qualsiasi contatto.",
"hc.confirmTheCarrier": "Conferma il corriere",
"hc.confirmThePassword": "Conferma la password",
"hc.confirmYourShippingAddressTo": "Conferma il tuo indirizzo di spedizione per continuare con il pagamento.",
"hc.confirmYourSubscription": "Conferma il tuo abbonamento",
"hc.confirmed": "Confermato ✓",
"hc.contactFindoToGetYour": "Contatta Findloop per ottenere il tuo ID mittente.",
"hc.contactUs": "Contattaci",
"hc.continueTheReturn": "Continua il reso",
"hc.continueToPayment": "Continua al pagamento",
"hc.copy": "Copia",
"hc.correctMyDetails": "correggi i miei dettagli",
"hc.correctThisEntry": "Correggere questa voce?",
"hc.country": "Paese",
"hc.countryAddress": "Paese (indirizzo)",
"hc.countryIsoCodeEG": "Paese (codice ISO, ad es. FR)",
"hc.cover": "copertura",
"hc.createTheShipment": "Crea la spedizione",
"hc.cropThePhoto": "Ritaglia la foto",
"hc.customer": "Cliente",
"hc.customerClaimCodeToCheck": "Codice di reclamo del cliente — da controllare al ritiro:",
"hc.customerReasonFmt": "Motivo del cliente: \"{reason}\".",
"hc.customerReminderDelay": "Ritardo promemoria cliente",
"hc.customerWhosePublicListingMatches": "Cliente la cui inserzione pubblica corrisponde a questo oggetto — visibile solo a te.",
"hc.d15": "D-15",
"hc.dangerZone": "Zona pericolosa",
"hc.date": "Data",
"hc.dateNewest": "Data (più recente)",
"hc.dateOldest": "Data (più vecchia)",
"hc.daysToYearEnd": "{n} giorni fino alla fine dell'anno",
"hc.deadlineAlert": "Avviso scadenza",
"hc.declarationClosed": "Dichiarazione chiusa ✓",
"hc.declarationNotFound": "Dichiarazione non trovata.",
"hc.declarationNotFound2": "Dichiarazione non trovata",
"hc.declarationTracking": "Tracciamento dichiarazione",
"hc.defaultCarrier": "Corriere predefinito",
"hc.defaultCarrierPreselected": "Corriere predefinito pre-selezionato — può essere modificato per questa spedizione. Tariffa attuale (Sendcloud + {m}% margine).",
"hc.defaultCarrierRemoved": "Corriere predefinito rimosso",
"hc.delayHours": "Ritardo (ore)",
"hc.deleteMyAccount": "Elimina il mio account",
"hc.deleting": "Eliminando…",
"hc.deletingDeactivatesYourAccountLogin": "L'eliminazione disattiva il tuo account: il login è bloccato e i dati vengono conservati per 30 giorni. Riceverai un'email con un link di riattivazione valido per 30 giorni.",
"hc.delivered": "Consegnato",
"hc.depositAnItem": "Deposita un articolo",
"hc.depositCancelledItemPutBack": "Deposito annullato — articolo rimesso a magazzino.",
"hc.depositCancelledItemRemovedFrom": "Deposito annullato — articolo rimosso dal registro.",
"hc.depositedOn": "Deposito effettuato il",
"hc.describeTheItemBrandColor": "Descrivi l'articolo: marca, colore, segni distintivi… (Più dettagli fornisci, maggiori saranno le possibilità di trovare il tuo articolo)",
"hc.dimensionsCm": "Dimensioni (cm)",
"hc.disablingAnEmail": "Disabilitando un'email",
"hc.doesNotHide": "non nasconde",
"hc.download": "Scarica",
"hc.downloadThePdf": "Scarica il PDF",
"hc.draftRestoredPickUpYour": "Bozza ripristinata — riprendi la tua dichiarazione da dove l'hai lasciata.",
"hc.dragToReposition": "Trascina per riposizionare",
"hc.eGColisPriv": "E.g. Colis Privé",
"hc.eachItemGetsAQr": "Ogni articolo riceve un'etichetta QR. Scansionalo da \"Magazzino & QR\" per localizzare un articolo in un istante.",
"hc.eachSiteManagesItsOwn": "Ogni sito gestisce le proprie finanze. Vai a",
"hc.edit": "Modifica",
"hc.emailNotificationPreferences": "Preferenze di notifica via email",
"hc.emailPreferencesUpdated": "Preferenze email aggiornate",
"hc.enableOrDisableRecoveryFees": "Abilita o disabilita le spese di recupero per",
"hc.enlargePhoto": "Ingrandisci foto",
"hc.enterTheCustomerSCode": "Inserisci il codice del cliente",
"hc.estShipRate": "Tariffa di spedizione stimata (Sendcloud + {m}% margine):",
"hc.establishment": "Stabilimento",
"hc.establishment2": "Stabilimento:",
"hc.establishmentInItsSendcloudAccount": "stabilimento nel suo account Sendcloud e ti fornisce l'ID mittente",
"hc.establishmentSettings": "Impostazioni dello stabilimento",
"hc.exCode": "es. ABCD2345",
"hc.exId": "es. 3f2a…",
"hc.exit": "Esci",
"hc.explainWhyThisItemIs": "Spiega perché questo articolo non è tuo…",
"hc.externalPaymentLinks": "Link di pagamento esterni",
"hc.failed": "Fallito",
"hc.feesEnabled": "Commissioni attivate",
"hc.field": ") campo.",
"hc.finderAcceptedCloseTheCase": "Finder accettato — chiudi il caso una volta che l'oggetto è stato consegnato di persona.",
"hc.findoCityRanking": "Findloop — Classifica delle città",
"hc.findoForEstablishments": "Findloop per stabilimenti",
"hc.findoPresentationVideo": "video di presentazione di Findloop",
"hc.findoRegistersTheAddressOf": "Findloop registra l'indirizzo del tuo",
"hc.findoReviewShare": "recensione di Findloop {year}: {n} articoli restituiti, tasso di restituzione {rate}% 🎉",
"hc.firstVerifyTheClaimCode": "Verifica prima il codice di reclamo sopra",
"hc.forEveryNewShipmentFrom": "per ogni nuova spedizione da",
"hc.free": "gratuito",
"hc.freeRecovery0": "Recupero gratuito (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Recupero gratuito in tutta l'Africa – Offerta di lancio",
"hc.freeRecoveryFeesDisabled0": "Recupero gratuito: commissioni disattivate (0 €)",
"hc.fromTeamInviteYourColleagues": "Da \"Team\", invita i tuoi colleghi via email e assegna loro un stabilimento. Ogni membro vede solo il proprio ambito.",
"hc.fullName": "Nome completo",
"hc.fullPhoto": "Foto completa",
"hc.gallery": "Galleria",
"hc.giveTheReasonForCancelling": "Fornisci il motivo della cancellazione. Il partner sarà informato.",
"hc.goToLogin": "Vai al login",
"hc.goToMyAccount": "Vai al mio account",
"hc.gold": "Oro",
"hc.googleLoginFailed": "Accesso a Google fallito",
"hc.hasConfirmedYourPaymentYou": "ha confermato il tuo pagamento, verrai reindirizzato automaticamente",
"hc.helpCenter": "Centro assistenza",
"hc.helpUsImproveWhyAre": "Aiutaci a migliorare: perché ce ne vai? Il tuo account sarà disattivato e potrà essere riattivato per 30 giorni.",
"hc.hidePassword": "Nascondi password",
"hc.high": "Alto",
"hc.historyOfYourMonthlySubscriptions": "Storia dei tuoi abbonamenti mensili e il loro stato di pagamento.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Come posso impostare il mio ID mittente numerico?",
"hc.iDonTUseIt": "Non lo utilizzo abbastanza",
"hc.iFoundItElsewhere": "L'ho trovato altrove",
"hc.iNoLongerNeedMy": "Non ho più bisogno del mio articolo",
"hc.identityVerification": "Verifica dell'identità",
"hc.idleLogoutIn": "Verrai disconnesso tra {n} s per inattività.",
"hc.ifProvidedTheVolumetricWeight": "Se fornito, il peso volumetrico sarà utilizzato.",
"hc.ifThePartnerHasNot": "Se il partner non ha confermato la ricezione del pagamento esterno dopo questo ritardo, Findloop ricorderà automaticamente al partner di convalidarlo.",
"hc.impersonationEnded": "Impersonificazione terminata.",
"hc.impersonationMode": "Modalità impersonificazione",
"hc.impersonationSessionExpired": "Sessione di impersonificazione scaduta.",
"hc.inTheField": ", sul campo",
"hc.inTransit": "In transito",
"hc.inclVat": "incl. IVA",
"hc.intraEuVatNumberOptional": "Numero IVA intra-UE opzionale, nessun SIRET richiesto (fuori dalla Francia).",
"hc.invalidInvitationLink": "Link di invito non valido.",
"hc.invalidInvitationLink2": "Link di invito non valido",
"hc.invalidInviteLink": "Link di invito non valido o scaduto.",
"hc.invalidNumberEnterAnInternational": "Numero non valido. Inserisci un numero internazionale, ad es. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Link non valido o scaduto.",
"hc.invalidOrExpiredReactivationLink": "Link di riattivazione non valido o scaduto",
"hc.invalidSendcloudId": "ID Sendcloud non valido",
"hc.inviteSubtitle": "{org} ti invita a unirti al proprio team findloop. Scegli la tua password per attivare il tuo account.",
"hc.isAvailableOnSendcloudFor": "è disponibile su Sendcloud per tutte le tue rotte (nazionali + internazionali).",
"hc.isNotEnabledOnYour": "non è abilitato sul tuo account Sendcloud per alcune destinazioni. Le etichette per queste saranno generate con un altro corriere disponibile.",
"hc.isThisReallyYourItem": "È davvero il tuo articolo?",
"hc.isThisYourItem": "È questo il tuo articolo?",
"hc.item": "Articolo",
"hc.itemAlreadyConfirmed": "Articolo già confermato",
"hc.itemDetails": "Dettagli articolo",
"hc.itemFoundAt": "Articolo trovato presso",
"hc.itemFoundAtAPartner": "Articolo trovato presso un partner",
"hc.itemMarkedAsReturned": "Articolo contrassegnato come restituito ✓",
"hc.itemPhotoRequiredBeforeShipping": "Foto dell'articolo (richiesta prima della spedizione)",
"hc.itemPhotoSaved": "Foto dell'articolo salvata",
"hc.itemPreview": "Anteprima articolo",
"hc.itemPutBackInStorage": "Articolo rimesso in magazzino.",
"hc.itemWeight": "Peso articolo:",
"hc.itemsReturned": "articolo(i) restituito(i)",
"hc.itemsReturnedThisYear": "oggetti restituiti quest'anno",
"hc.itemsWhoseLegalDeadlineIs": "Oggetti il cui termine legale è a 15 giorni o meno (inclusi i scaduti). Le corrispondenze rimangono visibili.",
"hc.kbisNumber": "Numero Kbis",
"hc.keysForgottenOnABench": "Chiavi dimenticate su una panchina",
"hc.labelBeingGenerated": "Etichetta in fase di generazione",
"hc.leaveTheFieldsEmptyTo": "Lascia i campi vuoti per offrire il recupero gratuitamente.",
"hc.legalNotice": "Avviso legale",
"hc.limitReachedUpgradeToA": "Limite raggiunto — aggiorna a un piano superiore",
"hc.linkCopiedShareOn": "Link copiato — condividilo su {label}",
"hc.linkUnavailable": "Link non disponibile",
"hc.linkedTo": "Collegato a",
"hc.listingHiddenByModeration": "Annuncio nascosto dalla moderazione.",
"hc.loading": "Caricamento…",
"hc.locateMe": "Trova me",
"hc.logIn": "Accedi",
"hc.logInToGetBack": "Accedi per tornare nel tuo spazio e gestire il tuo abbonamento.",
"hc.loginFailed": "Accesso non riuscito",
"hc.lostFoundPlatform": "Piattaforma di oggetti smarriti e trovati.",
"hc.lostIn": "smarrito in",
"hc.lowRate": "Basso tasso",
"hc.mainReason": "Motivo principale",
"hc.mainStreet": "Via principale",
"hc.makeSureThisIsThe": "Assicurati che questo sia l'oggetto che hai perso prima di sbloccare i dettagli di contatto del ritrovatori.",
"hc.manageCookies": "Gestisci i cookie",
"hc.manageMyTeam": "Gestisci il mio team",
"hc.manageYourTeam": "Gestisci il tuo team",
"hc.markAsReturned": "Segna come restituito",
"hc.matchNoClaimInTime": "La corrispondenza non ha ricevuto alcuna rivendicazione entro la scadenza.",
"hc.matchNotFound": "Corrispondenza non trovata",
"hc.medium": "Medio",
"hc.milestoneFmt": "{m} traguardo di oggetti restituiti raggiunto! Insieme a {next}.",
"hc.missingFeatures": "Funzionalità mancanti",
"hc.monthly": "Mensile",
"hc.monthlyBilling": "Fatturazione mensile",
"hc.moveThePhotoToFit": "Sposta la foto per adattarla al cerchio.",
"hc.myAccount": "Il mio account",
"hc.myInvoices": "Le mie fatture",
"hc.myMonthlyInvoices": "Le mie fatture mensili",
"hc.nArchived": "{n} annuncio(i) archiviato(i).",
"hc.newCodeGeneratedAndSent": "Nuovo codice generato e inviato al cliente via email e SMS",
"hc.newCodeGeneratedAndSent2": "Nuovo codice generato e inviato al proprietario",
"hc.newPassword": "Nuova password",
"hc.next": "Avanti",
"hc.nextPhoto": "Foto successiva",
"hc.no": "No",
"hc.noAnswerProvided": "Nessuna risposta fornita.",
"hc.noArchivedDeclarations": "Nessuna dichiarazione archiviata",
"hc.noCountryFound": "Nessun paese trovato",
"hc.noDeclarations": "Nessuna dichiarazione",
"hc.noFeesAreChargedTo": "Nessuna tariffa addebitata al cliente.",
"hc.noInvoiceYet": "Nessuna fattura ancora.",
"hc.noInvoiceYetYourInvoices": "Nessuna fattura ancora. Le tue fatture appariranno qui automaticamente dopo ogni pagamento.",
"hc.noMatchIsAvailableFor": "Nessuna corrispondenza disponibile per ora. Ti informeremo non appena un articolo corrisponderà alla tua dichiarazione.",
"hc.noShipmentMatchesYourSearch": "Nessuna spedizione corrisponde alla tua ricerca.",
"hc.noShipmentsYet": "Nessuna spedizione ancora.",
"hc.noShipmentsYet2": "Nessuna spedizione ancora",
"hc.none": "nessuno",
"hc.noneChooseForEachShipment": "Nessuno (scegli per ogni spedizione)",
"hc.notMine": "Non è mio",
"hc.of": "di",
"hc.only": "Solo",
"hc.onlyEachSiteManagesIts": "solo. Ogni sito gestisce il proprio sistema bancario: questi collegamenti non influenzano alcun altro stabilimento.",
"hc.onlyTheOwnerOrAn": "Solo il proprietario o un amministratore possono configurare i collegamenti di pagamento dell'establismento.",
"hc.openDepositInTheMenu": "Apri \"Deposito\" nel menu, descrivi l'elemento e scatta una foto. Viene immediatamente memorizzato e pronto per essere restituito.",
"hc.openSettings": "Apri Impostazioni →",
"hc.openTheDeclarationToManage": "Apri la dichiarazione per gestire la spedizione",
"hc.optional": "— facoltativo",
"hc.optional2": "(facoltativo)",
"hc.optional3": "facoltativo",
"hc.originalListingPhotoUsed": "Foto originale dell'annuncio utilizzata",
"hc.other": "Altro",
"hc.other2": "Altro…",
"hc.ourProducts": "I nostri prodotti",
"hc.overallRateTrendLast6": "Andamento generale delle tariffe (ultimi 6 mesi)",
"hc.ownerSClaimCode": "Codice di reclamo del proprietario",
"hc.ownershipConfirmed": "Proprietà confermata",
"hc.paid": "Pagato",
"hc.paidOn": "Pagato il",
"hc.paidViaPartner": "Pagato (tramite partner)",
"hc.parcelBeingPrepared": "Pacco in preparazione",
"hc.parcelDelivered": "Pacco consegnato",
"hc.parcelShipped": "Pacco spedito",
"hc.parisGareDeLyon": "Parigi, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Elenco partner",
"hc.passedOnToTheCustomer": "— passato al cliente il link di pagamento.",
"hc.password": "Password",
"hc.passwordResetPleaseLogIn": "Ripristino password, per favore accedi.",
"hc.passwordUpdated": "Password aggiornata.",
"hc.passwordsDoNotMatch": "Le password non corrispondono.",
"hc.pasteThisSenderIdIn": "Incolla questo ID mittente in Findloop → Impostazioni",
"hc.payForTheShipmentOf": "Paga per la spedizione del tuo articolo tramite Findloop con un pagamento sicuro.",
"hc.payTheRecoveryFees": "Paga le spese di recupero",
"hc.payTheShippingFees": "Paga le spese di spedizione",
"hc.payment": "Pagamento",
"hc.paymentAlreadyConfirmedByThe": "Pagamento già confermato dal partner",
"hc.paymentLinksAreNowConfigured": "I link di pagamento sono ora configurati per ogni stabilimento",
"hc.paymentNotCompletedYourAccount": "Pagamento non completato, il tuo account non è stato creato — riprova.",
"hc.paymentReceived": "Pagamento ricevuto",
"hc.paymentSuccessful": "Pagamento riuscito!",
"hc.pdfInvoice": "Fattura PDF",
"hc.pending": "In attesa",
"hc.period": "Periodo",
"hc.phoneNumber": "Numero di telefono",
"hc.phoneOptional": "Telefono (opzionale)",
"hc.planAt": "piano a",
"hc.planLimitFmt": "Il tuo piano \"{plan}\" è limitato a {max} stabilimenti. Per gestire {n} siti, ti consigliamo il",
"hc.platformReturnTarget": "Obiettivo di ritorno della piattaforma",
"hc.pleaseCompleteYourShippingAddress": "Per favore completa il tuo indirizzo di spedizione.",
"hc.pleaseProvideAPhoneNumber": "Per favore fornisci un numero di telefono: è richiesto dal corriere per la spedizione.",
"hc.pleaseProvideAReason": "Per favore fornisci un motivo.",
"hc.pleaseSetYourOwnPassword": "per favore imposta la tua password prima di continuare.",
"hc.pointsToGoal": "{n} punti in più per raggiungere il nostro obiettivo condiviso.",
"hc.posterPreview": "Anteprima poster",
"hc.potentialMatchBeingVerified": "Possibile corrispondenza in fase di verifica",
"hc.potentialOwner": "Possibile proprietario",
"hc.preFilledAutomaticallyYouCan": "Compilato automaticamente — puoi sostituirlo con una foto del pacco.",
"hc.pressKit": "Kit stampa",
"hc.previewMode": "Modalità anteprima:",
"hc.previewOfThePrintReady": "Anteprima del poster A4 pronto per la stampa per questo stabilimento.",
"hc.previous": "Precedente",
"hc.previousPhoto": "Foto precedente",
"hc.primary": "primario",
"hc.printThePoster": "Stampa il poster",
"hc.privacy": "Privacy",
"hc.privacyPolicy": "Politica sulla privacy",
"hc.processedCasesWillAppearHere": "I casi elaborati appariranno qui.",
"hc.proofOfReturnPdf": "Prova di ritorno (PDF)",
"hc.protectedByRecaptcha": "Protetto da reCAPTCHA",
"hc.publicMatch": "Corrispondenza pubblica",
"hc.putBackInStorage": "Riponi di nuovo in magazzino",
"hc.pwdResetByTeam": "La tua password è stata reimpostata dal nostro team. Per la tua sicurezza,",
"hc.questionsToAskTheOwner": "Domande da fare al proprietario",
"hc.rateChargedToTheCustomer": "Tariffa addebitata al cliente:",
"hc.rateOfTarget": "{rate}% raggiunto su un obiettivo del {target}%",
"hc.reached": "raggiunto",
"hc.reactivating": "Reattivazione…",
"hc.reasonSavedYouCanStill": "Motivo salvato. Puoi ancora richiedere il tuo articolo.",
"hc.recentMatchesFirst": "Recenti corrispondenze prima",
"hc.recognizedThePhotoYouSent": "ha riconosciuto la foto che hai inviato e descritto queste caratteristiche. Conferma solo se corrispondono all'articolo in tuo possesso.",
"hc.recommended": "Consigliato",
"hc.recoveryFees": "Spese di recupero",
"hc.recoveryFeesArePaidDirectly": "Le spese di recupero sono pagate direttamente allo stabilimento partner. Findloop non riceve alcun pagamento dai clienti.",
"hc.recoveryFeesEnabled": "Spese di recupero attivate",
"hc.recoveryOfferedByTheEstablishment": "Recupero offerto dallo stabilimento — Findloop non addebita spese.",
"hc.recoveryPaymentLink": "Link per il pagamento del recupero",
"hc.recoveryPaymentLinkSavedFor": "Link per il pagamento del recupero salvato per questo stabilimento",
"hc.redirecting": "Reindirizzamento…",
"hc.redirectingToPayment": "Reindirizzamento al pagamento…",
"hc.redirectingToTheRecoveryOf": "Reindirizzamento al recupero del tuo articolo…",
"hc.regenerateAndResendToThe": "Rigenera e rinvia al proprietario",
"hc.regenerateTheCode": "Rigenera il codice",
"hc.registerAFoundItem": "Registra un articolo trovato",
"hc.rejectTheClaim": "Rifiuta la richiesta",
"hc.reminderDelaySaved": "Ritardo promemoria salvato",
"hc.reopenThePaymentLink": "Riapri il link di pagamento",
"hc.repeatThePassword": "Ripeti la password",
"hc.reportAProblem": "Segnala un problema",
"hc.reportDismissedYourListingRemains": "Segnalazione ignorata. Il tuo annuncio rimane pubblico.",
"hc.requiredUsedToCalculateThe": "Richiesto: utilizzato per calcolare il tasso di spedizione Sendcloud. Spedizione non disponibile sopra i 30 kg.",
"hc.reset": "Reimposta",
"hc.resume": "Riprendi",
"hc.resumeRegistration": "Riprendi registrazione",
"hc.retro": "Anno in revisione",
"hc.returnSecurity": "Sicurezza di ritorno",
"hc.returnToTheOwner": "Restituisci al proprietario",
"hc.returned": "restituito",
"hc.reviewTheItemDetails": "Esamina i dettagli dell'articolo",
"hc.revokeAccess": "Revoca accesso",
"hc.role": "Ruolo:",
"hc.save": "Salva",
"hc.save2": "salva",
"hc.saveAndContinue": "Salva e continua",
"hc.saving": "Salvataggio…",
"hc.scanTheClaimCode": "Scansiona il codice di reclamo",
"hc.scanTheOwnerSQr": "Scansiona il QR del proprietario",
"hc.scrollThroughLanguages": "Scorri tra le lingue",
"hc.searchByCustomerItemOr": "Cerca per cliente, articolo o numero di tracciamento…",
"hc.searchForACountry": "Cerca un paese…",
"hc.secureFindoVerification": "Verifica Findloop sicura",
"hc.seeRetro": "Guarda l'anno in revisione",
"hc.selectedCarrier": "Corriere selezionato:",
"hc.selectedPlan": "Piano selezionato",
"hc.send": "Invia",
"hc.sendcloudSenderIdSaved": "ID mittente Sendcloud salvato",
"hc.sendcloudSenderIdSenderId": "ID mittente Sendcloud (sender_id)",
"hc.sending": "Invio…",
"hc.sessionExpired": "Sessione scaduta",
"hc.setUpYourEstablishments": "Configura i tuoi stabilimenti",
"hc.settings": "Impostazioni",
"hc.settingsSubtitle": "Pagamenti esterni e promemoria, configurati per stabilimento.",
"hc.shareFoundText": "Ho trovato un oggetto — aiutami a trovare il suo proprietario su Findloop",
"hc.shareLostText": "Ho perso un oggetto — aiutami a trovarlo su Findloop",
"hc.sharePreview": "Condividi anteprima",
"hc.shareTheRanking": "Condividi la classifica",
"hc.shareYourQrCodeTo": "Condividi il tuo codice QR per ricevere dichiarazioni.",
"hc.shipRateAutoWeight": "Il tasso di spedizione è calcolato automaticamente tramite Sendcloud (peso {w}) al momento della spedizione.",
"hc.shipRateForWeight": "Tariffa di spedizione (Sendcloud + {m}% margine) per {w}:",
"hc.shipments": "Spedizioni",
"hc.shipmentsSubtitle": "Vista consolidata di tutte le spedizioni dell'istituzione, in tutti i casi. Clicca su una riga per gestire la spedizione nella sua dichiarazione.",
"hc.shipping": "Spedizione",
"hc.shippingAddress": "Indirizzo di spedizione",
"hc.shippingFeesAreHandledAutomatically": "Le spese di spedizione sono gestite automaticamente da Findloop (Sendcloud) — nessun link da inserire.",
"hc.shippingFeesHaveAlreadyBeen": "Le spese di spedizione sono già state pagate: il corriere non può più essere cambiato.",
"hc.shippingNotAvailableForItems": "Spedizione non disponibile per articoli oltre 30 kg. Il cliente dovrà ritirare l'articolo di persona.",
"hc.shippingPaid": "Spedizione pagata ✓",
"hc.showOnlyItemsMatchingA": "Mostra solo articoli che corrispondono a un elenco pubblico (cliente)",
"hc.showPassword": "Mostra password",
"hc.signInTheBoxAbove": "Accedi nel campo sopra",
"hc.signatureSaved": "Firma salvata",
"hc.signedInWithGoogle": "Accesso effettuato con Google",
"hc.signupFailed": "Registrazione non riuscita",
"hc.silver": "Argento",
"hc.simulatedRatesInPreProduction": "(tariffe simulate in pre-produzione)",
"hc.siretAndVatNumberRequired": "SIRET e numero di partita IVA richiesti (Francia).",
"hc.skip": "Salta",
"hc.smsSentIfAccount": "Se esiste un account con questo numero, ti è stato inviato un SMS.",
"hc.sortItemsWithAPublic": "Ordina: articoli con una corrispondenza pubblica (più recenti) per primi",
"hc.specifyWhetherYouRecoveredYour": "Specifica se hai recuperato il tuo articolo o semplicemente vuoi rimuovere questo annuncio.",
"hc.specifyYourReason": "Specifica il tuo motivo",
"hc.specifyYourReason2": "Specifica il tuo motivo…",
"hc.staff": "Personale",
"hc.status": "Stato",
"hc.staySignedIn": "Rimani connesso",
"hc.step": "Passo",
"hc.stillThere": "Sei ancora lì?",
"hc.stopScrolling": "Ferma lo scorrimento",
"hc.storeFindWithQr": "Memorizza e trova con QR",
"hc.streetName": "Nome della strada",
"hc.streetNo": "Numero civico",
"hc.switchTo": "Passa a",
"hc.switchToDarkMode": "Passa alla modalità scura",
"hc.switchToLightMode": "Passa alla modalità chiara",
"hc.takeAPhoto": "Scatta una foto",
"hc.takeChangeThePhoto": "Scatta / cambia la foto",
"hc.takenFromYourDeclaration": "presa dalla tua dichiarazione",
"hc.target": "Obiettivo",
"hc.targetReached": "Obiettivo raggiunto",
"hc.targetReachedThankYouTo": "Obiettivo raggiunto — grazie a tutta la comunità Findloop!",
"hc.tellUsMore": "Dìci di più…",
"hc.tellUsWhyYouCancel": "Dìci perché stai cancellando. Questo aiuta il partner a elaborare la tua richiesta.",
"hc.tellUsWhyYourListing": "Dìci perché. La tua inserzione rimane attiva e puoi ancora reclamare il tuo articolo.",
"hc.termsAndConditions": "Termini e condizioni",
"hc.termsAndPolicies": "Termini e politiche",
"hc.thankYouForYourFeedback": "Grazie per il tuo feedback",
"hc.theBannerDisplayedInThe": "il banner visualizzato nel registro.",
"hc.theClaimantHasBeenInformed": "Il richiedente è stato informato. L'oggetto rimane disponibile nell'elenco pubblico.",
"hc.theClaimantHasBeenNotified": "Il richiedente è stato notificato e può ora procedere con il reso.",
"hc.theCustomerPaysTheFees": "Il cliente paga le spese all'istituzione.",
"hc.theDayTheLegalRetention": "Il giorno in cui viene raggiunto il periodo di ritenzione legale.",
"hc.theEstablishmentConsideredThatThis": "L'istituzione ha ritenuto che questo articolo non sia tuo.",
"hc.theEstablishmentIsReviewingYour": "L'istituzione sta rivedendo le tue risposte. Sarai notificato non appena la tua richiesta sarà convalidata, quindi potrai pagare le spese di recupero.",
"hc.theFeesAreTooHigh": "Le spese sono troppo alte",
"hc.theFinderConsideredThatThis": "Il cercatore ha considerato che questo articolo non sia tuo.",
"hc.theFinderIsReviewingYour": "Il cercatore sta esaminando la tua richiesta. Sarai notificato non appena sarà convalidata.",
"hc.theItem": "L'oggetto",
"hc.theItemWillBeRemoved": "L'oggetto sarà rimosso dal registro (nessuna richiesta in corso).",
"hc.theItemWillBeSet": "L'oggetto sarà ripristinato a \"disponibile\" e la richiesta correlata annullata.",
"hc.theKbisNumberAndVat": "Il numero Kbis e il numero IVA sono richiesti per la Francia.",
"hc.theLabelIsGeneratedAutomatically": "L'etichetta viene generata automaticamente non appena il cliente ha pagato le spese di spedizione. Sarà scaricabile qui.",
"hc.theLinkMayHaveExpired": "Il link potrebbe essere scaduto (valido per 30 giorni). Contatta il supporto Findloop se necessario.",
"hc.theOwnerDescribesTheirItem": "Il proprietario descrive il proprio oggetto",
"hc.theOwnerReceivedItBy": "Il proprietario lo ha ricevuto via email (o SMS). Inseriscilo o scansiona prima della consegna.",
"hc.thePartnerConsideredThatThis": "Il partner ha ritenuto che questo articolo non sia tuo. L'oggetto rimane disponibile.",
"hc.thePartnerIsReviewingYour": "Il partner sta rivedendo le tue risposte. Sarai notificato non appena la tua richiesta sarà convalidata.",
"hc.theShipmentIsCreatedAutomatically": "La spedizione viene creata automaticamente non appena il cliente ha confermato il proprio indirizzo e ha pagato le spese di recupero. L'etichetta sarà quindi generata automaticamente dopo il pagamento della spedizione e potrà essere scaricata qui.",
"hc.theShippingRateWillBe": "La tariffa di spedizione sarà calcolata automaticamente tramite Sendcloud al momento della spedizione (peso registrato).",
"hc.thisCarrierWillBe": "Questo corriere sarà",
"hc.thisEstablishment": "questa istituzione",
"hc.thisFieldIsRequiredFor": "Questo campo è obbligatorio per la generazione automatica dell'etichetta.",
"hc.thisIsMyItem": "Questo è il mio oggetto",
"hc.thisIsMyItemContinue": "Questo è il mio oggetto — continua",
"hc.thisIsMyItemStart": "Questo è il mio oggetto — inizia il reso",
"hc.thisIsNotMyItem": "Questo non è il mio oggetto",
"hc.thisMatchIsNoLonger": "Questa corrispondenza non è più disponibile o è già stata elaborata.",
"hc.thisRateWillBeCharged": "Questa tariffa sarà addebitata al cliente. Una tariffa alta può scoraggiare il recupero.",
"hc.thisStepIsRequiredFor": "Questo passaggio è necessario per generare le etichette di spedizione",
"hc.thisValidationLinkIsInvalid": "Questo link di convalida non è valido o è scaduto.",
"hc.toCheckBeforeMarkingThe": "Da controllare prima di contrassegnare l'oggetto come restituito.",
"hc.toConfigureTheLinksAnd": "per configurare i link e il ritardo di promemoria per ciascun stabilimento.",
"hc.toReachOurFirstMilestone": "per raggiungere il nostro primo traguardo di 100 restituzioni.",
"hc.toTheCustomer": "al cliente.",
"hc.toTheShippingFeePayment": "al pagamento della spesa di spedizione.",
"hc.toYourRecoveryTracking": "al tuo tracciamento del recupero.",
"hc.tooExpensiveBudget": "Troppo costoso / budget",
"hc.topCitiesForReturns": "Top città per le restituzioni",
"hc.trackMyRecovery": "Traccia il mio recupero",
"hc.trackTheShipmentAndDownload": "Traccia la spedizione e scarica l'etichetta (generata automaticamente) senza uscire dalla scheda Dichiarazioni.",
"hc.trackYourStatistics": "Traccia le tue statistiche",
"hc.tracking": "Tracciamento",
"hc.unableToOpenTheShipping": "Impossibile aprire il pagamento della spesa di spedizione. Riprova.",
"hc.unableToRetrieveTheInvoice": "Impossibile recuperare la fattura.",
"hc.unclaimed": "Non reclamo",
"hc.unclaimedCustomerReason": "Oggetto non reclamato. Motivo del cliente: \"{reason}\".",
"hc.unclaimedItem": "Oggetto non reclamato",
"hc.unclaimedItemNoClaimWithin": "Oggetto non reclamato — nessun reclamo entro la scadenza.",
"hc.unclaimedItems": "Oggetti non reclamati",
"hc.unclaimedItemsMatchLeftWithout": "Oggetti non reclamati: partita lasciata senza un reclamo entro la scadenza. Puoi rimetterli in deposito.",
"hc.unlockTheFinderSContact": "Sblocca i dettagli di contatto del trovator per organizzare la consegna.",
"hc.upcoming": "Prossimi",
"hc.updateFailed": "Aggiornamento fallito.",
"hc.usedForInvoices": "Utilizzato per emettere le tue fatture findloop.",
"hc.vatNumber": "Numero di partita IVA",
"hc.verificationPending": "Verifica in attesa",
"hc.verificationSentToTheFinder": "Verifica inviata al trovator. Sarai informato della loro decisione.",
"hc.verificationSentToThePartner": "Verifica inviata al partner. Sarai informato della loro decisione.",
"hc.verify": "Verifica",
"hc.verifyingInvite": "Verifica il link di invito…",
"hc.verifyingTheLink": "Verifica il link…",
"hc.viewInRegistry": "Visualizza nel registro",
"hc.viewItem": "Visualizza oggetto",
"hc.viewItemRecover": "Visualizza oggetto & recupera",
"hc.visibleToTheOwnerAutomatically": "Visibile al proprietario · eliminato automaticamente dopo 60 giorni.",
"hc.waitingForPartnerConfirmation": "In attesa della conferma del partner",
"hc.waitingForThePartnerS": "In attesa della conferma del partner",
"hc.weHaveInformedTheEstablishment": "Abbiamo informato lo stabilimento che questo oggetto non è tuo e riavviato l'analisi. Sarai informato non appena verrà trovata una nuova corrispondenza.",
"hc.weHaveInformedThePartner": "Abbiamo informato il partner che questo oggetto non è tuo. Il tuo annuncio rimane attivo per future corrispondenze.",
"home.videoSubtitle": "Come ricolleghiamo oggetti smarriti ai loro proprietari, senza sforzo.",
"home.videoTitle": "Scopri Findloop in 2 minuti",
"home.watchYoutube": "Guarda su YouTube",
"impact.already": "Già",
"impact.citiesWord": "città",
"impact.eachPoint": "Ogni punto è una città in cui Findloop aiuta a recuperare oggetti smarriti.",
"impact.emptyMap": "La mappa si riempie man mano che avvengono le restituzioni.",
"impact.eyebrow": "Il nostro impatto",
"impact.inCities": "in",
"impact.restitutedTo": "oggetti restituiti ai loro proprietari",
"impact.title": "Oggetti restituiti, ovunque vicino a te",
"inv2.download": "Scarica",
"inv2.view": "Visualizza",
"map.objectsOnMapPlural": "oggetti sulla mappa",
"map.objectsOnMapSingular": "oggetto sulla mappa",
"mc.claimConfirmDesc": "Controlla l'oggetto trovato dal cercatore prima di pagare per sbloccare i dettagli di contatto.",
"mc.claimConfirmNo": "Questo non è il mio oggetto",
"mc.claimConfirmTitle": "È davvero il tuo oggetto?",
"mc.claimConfirmYes": "Sì, è mio — paga",
"mc.claimFinderContacts": "Dettagli di contatto del cercatore",
"mc.claimNotMineDone": "Grazie — il cercatore è stato avvisato e la tua richiesta è stata rimossa dall'annuncio.",
"mc.claimUnlockDesc": "Paga la tassa di gestione Findloop per ottenere i dettagli di contatto della persona che ha trovato il tuo oggetto.",
"mc.claimUnlockTitle": "Sblocca i dettagli di contatto del cercatore",
"mc.hideCountryOffers": "Nascondi offerte nel mio paese",
"mc.myClaims": "Oggetti che sto reclamando",
"mc.myClaimsSub": "Oggetti trovati da altri che stai reclamando. Sblocca i dettagli di contatto del cercatore per organizzare il passaggio.",
"mc.notifAdCancelled": "Annuncio annullato",
"mc.notifCancelAd": "Annulla il mio annuncio",
"mc.offersInCountry": "Offerte nel mio paese",
"mc.offersInCountryDesc": "Tutte le ricompense attive dai partner nel tuo paese, per città.",
"mc.redArchived": "Archiviate",
"mc.rewardsCountryNone": "Nessuna offerta nel tuo paese ancora.",
"mc.rewardsForYou": "Ricompense per te",
"mc.rewardsForYouDesc": "Offerte dai partner in cui hai lasciato un oggetto.",
"mc.rewardsMineNone": "Nessuna ricompensa dai tuoi partner di drop-off ancora.",
"mc.showCountryOffers": "Vedi offerte nel mio paese",
"mc2.cancelDecl": "Annulla la mia dichiarazione",
"mc2.cancelDeclDone": "Dichiarazione annullata.",
"pricing.physInvDesc": "Quando un oggetto viene restituito, la sua posizione è automaticamente liberata e disponibile per un nuovo oggetto.",
"pricing.physInvTitle": "Tracciamento dell'inventario fisico",
"hc.weRanTheAnalysisAgain": "Abbiamo ripetuto l'analisi e identificato un altro articolo che potrebbe essere tuo. Controllalo di nuovo.",
"hc.weight": "Peso",
"hc.weightNotProvidedTheShipping": "Peso non fornito: la tariffa di spedizione sarà calcolata al momento della spedizione.",
"hc.weightUnit": "Unità di peso",
"hc.welcome": "Benvenuto!",
"hc.welcomeToFindo": "Benvenuto in Findloop",
"hc.whenACustomerComesTo": "Quando un cliente arriva per ritirare i propri beni, apri la loro dichiarazione e convalida il reso. Tutto qui!",
"hc.whenDisabledFeesDropTo": ". Quando disabilitato, le spese scendono a",
"hc.whyIsThisNotYour": "Perché questo non è il tuo articolo?",
"hc.willBeMarkedAs": "verrà contrassegnato come",
"hc.wrongColor": "Colore errato",
"hc.wrongModel": "Modello errato",
"hc.yesCancel": "Sì, annulla",
"hc.yesContactTheFinder": "Sì, contatta il recuperatore",
"hc.youAreHere": "Sei qui",
"hc.youBusinessCom": "tu@business.com",
"hc.youCanNowStartThe": "Puoi ora avviare il reso.",
"hc.youCanStillChangeIt": ". Puoi comunque modificarlo caso per caso.",
"hc.youHaveAlreadyConfirmedThat": "Hai già confermato che questo è il tuo articolo.",
"hc.youWillBeRedirectedTo": "Verrai reindirizzato al pagamento sicuro con Stripe.",
"hc.yourAccountHasBeenReactivated": "Il tuo account è stato riattivato.",
"hc.yourAccountIsActiveYou": "Il tuo account è attivo, puoi ora gestire i tuoi stabilimenti.",
"hc.yourEstablishment": "Il tuo stabilimento",
"hc.yourFeedbackHelpsUsImprove": "Il tuo feedback ci aiuta a migliorare i nostri abbinamenti.",
"hc.yourFeedbackHelpsUsRestart": "Il tuo feedback ci aiuta a riprendere l'analisi e migliorare i nostri abbinamenti.",
"hc.yourFirstSteps": "I tuoi primi passi",
"hc.yourFirstStepsAdmin": "I tuoi primi passi (admin)",
"hc.yourItemHasBeenHanded": "Il tuo articolo è stato consegnato di persona dal partner — chiudi il caso una volta confermata la consegna.",
"hc.yourItemHasBeenShipped": "Il tuo articolo è stato spedito dal partner — chiudi il caso una volta confermata la consegna.",
"hc.yourPaymentHasBeenRecorded": "Il tuo pagamento è stato registrato.",
"hc.yourShipmentIsBeingPrepared": "La tua spedizione è in fase di preparazione. Riceverai il tuo pacco entro 3-5 giorni lavorativi.",
"hc.yourShippingFeesHaveAlready": "Le tue spese di spedizione sono già state pagate. Spedizione pagata ✓",
"hc.yourShippingFeesHaveBeen": "Le tue spese di spedizione sono state pagate. Il tuo pacco è in fase di preparazione.",
"hc.yourVerificationQuestionsDeposit": "Le tue domande di verifica (deposito)",
"home.recentAdsAll": "Vedi tutte le inserzioni",
"home.recentAdsEyebrow": "In questo momento",
"home.recentAdsSubtitle": "Articoli smarriti e trovati segnalati dalla comunità.",
"home.recentAdsTitle": "Ultime inserzioni",
"home.reunions": "Riunioni recenti",
"home.videoEyebrow": "Guarda",
"pricing.physModalTitle": "Gestione degli articoli fisici",
"pricing.physQrDesc": "Un codice QR unico viene generato per ogni articolo e collega a tutte le sue informazioni.",
"pricing.physQrTitle": "Etichetta QR dedicata",
"pricing.physShelfDesc": "Ogni articolo registrato può essere assegnato a una posizione fisica all'interno dell'istituzione.",
"pricing.physShelfTitle": "Piano degli scaffali",
"pricing.physicalMgmt": "Gestione degli articoli fisici (scaffali, QR, inventario)",
"pub.addSecondPhoto": "Aggiungi una 2ª foto (opzionale)",
"pub.photo2Added": "✓ 2ª foto aggiunta",
"reg.dispositionJournal": "Diario delle disposizioni",
"reg.dispositionNoteAuthHint": "ℹ️ È necessaria una nota per “Consegnato alle autorità” (numero di rapporto, dipartimento…).",
"reg.dispositionNotePh": "Nota (opzionale): ente beneficiario, riferimento autorità, nome dell'acquirente…",
"reg.dispositionNoteRequired": "È necessario un riferimento ufficiale per consegnare alle autorità.",
"reg.legalPrealert": "Scadenza legale in {days} giorno/i",
"reg.legalPrealertOptions": "Opzioni alla scadenza: vendita all'asta, donazione a un ente benefico, consegna alle autorità.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Recensione completa",
"rev.readMore": "Leggi di più",
"rw.activeCodes": "Buoni attivi",
"rw.archived": "Archiviato",
"rw.archivedTitle": "Buoni riscattati (archiviati)",
"rw.hideArchived": "Nascondi buoni riscattati",
"rw.noArchived": "Nessun buono archiviato.",
"rw.showArchived": "Mostra buoni riscattati",
"shp.labelAuto": "L'etichetta viene generata automaticamente non appena il cliente ha pagato le spese di spedizione. Sarà scaricabile qui.",
"stt.dispoPdfBtn": "Esporta PDF",
"stt.dispoPdfError": "Esportazione PDF fallita.",
"stt.dispoPdfExporting": "Esportando…",
"trk.matchVerifying": "Possibile corrispondenza in fase di verifica",
"hc.careers": "Carriere",
"hc.carrier": "Corriere",
"hc.carrierAvailabilityCannotBeChecked": "La disponibilità del corriere non può essere controllata fino a quando il tuo mittente Sendcloud non è configurato.",
"hc.carrierConfirmedCharged": "Corriere confermato — {price} € addebitati al cliente",
"hc.carrierOther": "Corriere (altro)",
"hc.carrierSelection": "Selezione corriere",
"hc.caseClosedThankYou": "Caso chiuso. Grazie!",
"hc.category": "Categoria",
"hc.changeMethod": "Cambia metodo",
"hc.characteristic": "Caratteristica",
"hc.chargedToCustomer": "addebitato al cliente.",
"hc.checkOrEditYourDetails": "Controlla o modifica i tuoi dettagli prima del pagamento sicuro.",
"hc.checkStatisticsToTrackDeposited": "Controlla \"Statistiche\" per monitorare gli articoli depositati, il tasso di restituzione e le prestazioni di ogni stabilimento.",
"hc.checkTheDetailsBeforeContacting": "Controlla i dettagli prima di contattare il finder.",
"hc.checkTheDetailsBelowBefore": "Controlla i dettagli qui sotto prima di avviare la tua richiesta di restituzione.",
"hc.checkTheNewItem": "Controlla il nuovo articolo",
"hc.checkThePhotosAndCharacteristics": "Controlla le foto e le caratteristiche qui sotto prima di procedere con il recupero.",
"hc.chooseACountry": "Scegli un paese",
"hc.chooseANewPassword": "Scegli una nuova password",
"hc.chooseAReason": "Scegli un motivo",
"hc.chooseTheLegalRetentionAlerts": "Scegli le avvertenze legali di retention ricevute via email per",
"hc.chooseYourPasswordToAccess": "Scegli la tua password per accedere alla console di amministrazione.",
"hc.city": "Città",
"hc.claimApproved": "Richiesta approvata",
"hc.claimApproved2": "Richiesta approvata.",
"hc.claimCodeExpired": "Codice di richiesta scaduto",
"hc.claimCodeVerified": "Codice di richiesta verificato",
"hc.claimNotFound": "Richiesta non trovata",
"hc.claimNotValidated": "Richiesta non convalidata",
"hc.claimRejected": "Richiesta rifiutata",
"hc.claimRejected2": "Richiesta rifiutata.",
"hc.claimValidated": "Richiesta convalidata",
"hc.claimValidatedByThePartner": "Richiesta convalidata dal partner",
"hc.claimant": "Richiedente",
"hc.claimsToBeTheOwner": "affermano di essere il proprietario di questo articolo e hanno risposto alle domande di verifica. Approva solo se le risposte corrispondono.",
"hc.claimsToValidate": "Richieste da convalidare",
"hc.clear": "Pulisci",
"hc.clickToZoom": "Clicca per ingrandire",
"hc.close": "Chiudi",
"hc.close2": "Chiudi",
"pcat.stadium_arena": "Stadio / Arena",
"pcat.supermarket": "Supermercato",
"pcat.taxi_vtc": "Taxi / Ride-hailing",
"pcat.tourism_office": "Ufficio turistico",
"pcat.train_bus_station": "Stazione ferroviaria / degli autobus",
"pcat.travel_agency": "Agenzia di viaggi",
"hc.and": "e",
"hc.demoObj0": "un portafoglio",
"hc.demoObj1": "una borsa sportiva",
"hc.demoObj2": "un telefono",
"hc.demoObj3": "un paio di occhiali",
"hc.demoObj4": "un mazzo di chiavi",
"hc.demoObj5": "una sciarpa",
"hc.demoObj6": "un laptop",
"hc.demoObj7": "una bottiglia d'acqua",
"hc.demoWhen0": "2 ore fa",
"hc.demoWhen1": "5 ore fa",
"hc.demoWhen2": "ieri",
"hc.demoWhen3": "3 ore fa",
"hc.demoWhen4": "questa mattina",
"hc.demoWhen5": "1 giorno fa",
"hc.feedDemo": "{obj} è stato restituito a {city} {when}.",
"hc.feedReal": "Un articolo ({cat}) è stato restituito a {city}.",
"hc.saveBtn": "Salva",
"hc.saveLink": "Salva link",
"hc.terms": "Termini",
"hc.view": "Visualizza",
"pcat.airline": "Compagnia aerea",
"pcat.airport": "Aeroporto",
"pcat.amusement_park": "Parco divertimenti",
"pcat.bank": "Banca",
"pcat.bar_cafe": "Bar / Caffè",
"pcat.beauty_salon": "Salone di bellezza",
"pcat.cinema": "Cinema",
"pcat.concert_theater": "Teatro / Sala concerti",
"pcat.coworking": "Spazio coworking",
"pcat.gym_fitness": "Palestra / Fitness",
"pcat.hospital_clinic": "Ospedale / Clinica",
"pcat.library": "Biblioteca",
"pcat.mall": "Centro commerciale",
"pcat.museum": "Museo",
"pcat.pharmacy": "Farmacia",
"pcat.private_company": "Azienda privata",
"pcat.public_transport": "Trasporto pubblico",
"pcat.school_university": "Scuola / Università",
"pcat.sports_center": "Centro sportivo",
"an.found": "Trovato",
"an.lost": "Perso",
"hc.shareReview": "Condividi la recensione",
"hc.citiesAboveTarget": "{n} città sopra il loro obiettivo",
"hc.cityAboveTarget": "{n} città sopra il suo obiettivo",
"hc.j15EarlyReminder": "Promemoria anticipato D-15",
"hc.j7EarlyReminder": "Promemoria anticipato D-7",
"hc.annualTotal": "Totale annuale",
"hc.billedOnceYear": "Addebitato una volta per 12 mesi, rinnovato ogni anno.",
"hc.monthlyPrice": "Prezzo mensile",
"hc.perMonth": "/ mese",
"hc.perYear": "/ anno",
"hc.billedEachMonth": "Addebitato automaticamente ogni mese.",
"nav.business": "Attività",
"nav.individual": "Individuale",
"hc.circumstancesFound": "Circostanze del ritrovamento",
"hc.circumstancesFoundPh": "Ad es. trovato a terra vicino all'entrata della metro",
"hc.circumstancesLost": "Circostanze della perdita",
"hc.circumstancesLostPh": "Ad es. lasciato su una panchina mentre si aspettava l'autobus",
"hc.conditionPh": "Ad es. buono, graffiato...",
"hc.firstName": "Nome",
"hc.lastName": "Cognome",
"hc.quantity": "Numero di oggetti",
"fa.ownerContact": "Dettagli di contatto del proprietario",
"fa.payPublish": "Paga e pubblica",
"fa.pendingPayText": "Il tuo annuncio sarà attivo non appena il pagamento sarà confermato.",
"fa.pendingPayTitle": "Pagamento in sospeso",
"fa.planSub": "Il tuo annuncio sarà attivo non appena il pagamento sarà confermato.",
"fa.planTitle": "Durata dell'annuncio",
"fa.pubSuccessMsg": "Il tuo annuncio è attivo. Sarai avvisato non appena un cercatore si farà avanti.",
"fa.pubSuccessTitle": "Annuncio pubblicato",
"fa.publicNote": "Solo la descrizione, la città, il paese e le foto sono visibili pubblicamente.",
"fa.redirectStripe": "Reindirizzamento al pagamento sicuro…",
"fa.reject": "Rifiuta",
"fa.rejectConfirm": "Rifiutare questa dichiarazione? Il tuo annuncio rimane online.",
"fa.rejected": "Dichiarazione rifiutata",
"fa.rejectedFinder": "Non era l'oggetto che cercavano",
"fa.rejectedFinderText": "Il proprietario dice che questo oggetto non è il suo. Grazie per il tuo aiuto!",
"fa.responsesTitle": "Dichiarazioni dei cercatori",
"fa.sent": "Dichiarazione inviata al proprietario.",
"fa.submitDecl": "Invia la mia dichiarazione",
"fa.submitDeclPay": "Invia e contribuisci {amount}",
"fa.total": "Totale da pagare",
"fa.ttc": "incl. IVA",
"fa.waitClaimText": "Il cercatore sta esaminando la tua richiesta. Sarai avvisato della loro decisione.",
"fa.waitFinderText": "Ti faremo sapere non appena un cercatore invierà una dichiarazione.",
"fa.waitFinderTitle": "Il tuo annuncio è attivo",
"fa.waitOwnerText": "Il proprietario sta confrontando la tua dichiarazione con la sua. Sarai avvisato della loro decisione.",
"fa.waitOwnerTitle": "In attesa della decisione del proprietario",
"st.pending_payment": "Pagamento in sospeso",
"fa.approve": "Approva",
"fa.approveConfirm": "Approvi questa dichiarazione? I tuoi dettagli di contatto completi (nome, email, telefono) verranno scambiati con il finder.",
"fa.approved": "Dichiarazione approvata — dettagli di contatto scambiati",
"fa.approvedFinder": "Il proprietario ha approvato la tua dichiarazione",
"fa.approvedFinderText": "Contattali per organizzare il rientro.",
"fa.boostSub": "Il tuo annuncio rimane in cima per la durata scelta.",
"fa.boostTitle": "Migliora il mio annuncio (opzionale)",
"fa.colFinder": "Dichiarazione del finder",
"fa.colYours": "La tua dichiarazione",
"fa.compareHint": "Confronta la dichiarazione del finder con la tua prima di decidere.",
"fa.contribNone": "Nessun contributo",
"fa.contribPaid": "Contributo ricevuto — grazie!",
"fa.contribPending": "Contributo in attesa di pagamento",
"fa.contribSub": "Supporta Findloop per aiutare più persone a riprendere i propri oggetti. Puoi scegliere €0.",
"fa.contribSuccessMsg": "La tua dichiarazione è stata inviata al proprietario.",
"fa.contribSuccessTitle": "Grazie per il tuo contributo",
"fa.contribTitle": "Contributo volontario",
"fa.days3": "3 giorni",
"fa.days30": "30 giorni",
"fa.days7": "7 giorni",
"fa.declSub": "Descrivi l'oggetto che hai trovato. Il proprietario confronterà la tua dichiarazione con la sua.",
"fa.declTitle": "Ho trovato questo oggetto",
"fa.expiresOn": "Scade il",
"fa.fBrand": "Marca",
"fa.fCircumstances": "Circostanze",
"fa.fCity": "Città",
"fa.fColor": "Colore",
"fa.fCondition": "Condizione",
"fa.fDate": "Data",
"fa.fMessage": "Messaggio del finder",
"fa.fPlace": "Luogo",
"fa.fQuantity": "Quantità",
"fa.finderContact": "Dettagli di contatto del finder",
"fa.finishPay": "Completa il pagamento",
"fa.foundDate": "Data trovata",
"fa.foundPlace": "Luogo trovato",
"fa.hours24": "24 ore",
"fa.ht": "escl. IVA",
"fa.months3": "3 mesi",
"fa.noBoost": "Nessun potenziamento",
"fa.africaFree": "Annuncio gratuito in Africa — Offerta di lancio di Findloop, goditelo!",
"fa.africaPublished": "Annuncio pubblicato gratuitamente — Offerta di lancio in Africa!",
"fa.approveClaimConfirm": "Approvi questo reclamo? Il proprietario potrà poi sbloccare i tuoi dettagli di contatto.",
"fa.checkInfo": "Controlla i tuoi dettagli prima di inviare: verranno confrontati con quelli del rintracciatore.",
"fa.claimApprovedShort": "Il rintracciatore ha approvato il tuo reclamo",
"fa.claimRejectedShort": "Reclamo rifiutato dal rintracciatore",
"fa.claimRejectedText": "Il rintracciatore crede che questo oggetto non sia tuo.",
"fa.claimSub": "Descrivi il tuo oggetto e aggiungi 2 foto. Il rintracciatore li confronterà con il suo annuncio.",
"fa.claimTitle": "Questo è il mio oggetto",
"fa.claimUnlockText": "Sblocca i dettagli di contatto del rintracciatore per organizzare il ritorno.",
"fa.claimUnlockedShort": "Dettagli di contatto sbloccati — vedi tracciamento",
"fa.claimsTitle": "Reclami del proprietario",
"fa.colOwner": "Dichiarazione del proprietario",
"fa.colYourAd": "Il tuo annuncio",
"fa.expired": "Annuncio scaduto",
"fa.free": "Gratuito",
"fa.lostDate": "Data di smarrimento",
"fa.lostPlace": "Luogo di smarrimento",
"fa.noReceipt": "Nessuna ricevuta disponibile per questo annuncio.",
"fa.planSubFree": "Scegli la durata: il tuo annuncio va live immediatamente, nessun pagamento necessario.",
"fa.prefillPrevious": "Riusa i dettagli del mio annuncio precedente in questa categoria",
"fa.receipt": "Ricevuta PDF",
"fa.renewBtn": "Rinnova",
"fa.renewDiscountBanner": "50% di sconto: rinnova prima che il tuo annuncio scada!",
"fa.renewDiscountHint": "50% di sconto applicato perché rinnovi prima della scadenza.",
"fa.renewEarly": "Rinnova (−50%)",
"fa.renewTitle": "Rinnova il mio annuncio",
"fa.renewed": "Annuncio rinnovato",
"fa.sendClaim": "Invia il mio reclamo",
"fa.twoPhotos": "2 foto del tuo oggetto",
"fa.twoPhotosError": "Aggiungi 2 foto del tuo oggetto.",
"fa.twoPhotosHint": "Foto personali che dimostrano che l'oggetto è tuo (con l'oggetto, fattura, scatola…).",
"fa.unlockBtn": "Sblocca i dettagli di contatto",
"fa.unlockFree": "Sblocca gratis — offerta di lancio",
"fa.waitClaimantText": "Ti informeremo non appena un proprietario reclami questo oggetto.",
"fa.waitFinderDecision": "In attesa della decisione del rintracciatore",
"fa.waitUnlockText": "Verrai avvisato non appena i dettagli di contatto verranno scambiati.",
"fa.waitUnlockTitle": "In attesa che il proprietario sblocchi",
"fa.cancel": "Annulla",
"fa.categoryRequired": "Scegli una categoria per l'oggetto trovato.",
"fa.confirmTitle": "Conferma la tua decisione",
"fa.goBack": "Torna indietro",
"dr.continue": "Continua la mia dichiarazione",
"dr.delete": "Elimina definitivamente",
"dr.deleteConfirm": "Eliminare definitivamente questo abbozzo? Questa azione non può essere annullata.",
"dr.deleted": "Abbozzo eliminato",
"dr.expiresIn": "Abbozzo conservato per altre {h} ore",
"dr.title": "Hai una dichiarazione non completata",
"form.step": "Passo",
"form.next": "Continua",
"form.back": "Indietro",
"form.stepDetails": "Il tuo rapporto",
"form.stepPublish": "Durata, aumento e pagamento",
"form.stepThanks": "Grazie e contributo",
"fthx.badge": "Rapporto quasi pronto",
"fthx.title": "Grazie, stai facendo la differenza!",
"fthx.text": "Grazie a te, qualcuno potrebbe presto riavere qualcosa che per lui conta. Atti di gentilezza come il tuo sono esattamente ciò che mantiene viva Findloop.",
"fthx.impact1": "1 articolo segnalato",
"fthx.impact2": "1 ulteriore possibilità di un incontro",
"fthx.tipTitle": "Un piccolo aiuto per Findloop?",
"fthx.tipText": "Il tuo contributo ci aiuta a mantenere il servizio accessibile e a riunire sempre più oggetti con i loro proprietari.",
"fthx.optional": "100% facoltativo — puoi pubblicare senza contribuire.",
"fthx.thanksTip": "Grazie mille per la tua generosità!",
"fthx.suggest": "Importi suggeriti",
"fthx.none": "Nessun contributo",
"pay.pendingTitle": "Pagamento non completato",
"pay.pendingText": "I tuoi dettagli sono stati salvati. Riprendi il pagamento esattamente da dove lo avevi lasciato.",
"pay.resume": "Riprendi il pagamento",
"pay.expiredTitle": "Sessione di pagamento scaduta",
"pay.expiredText": "Per la tua sicurezza, la sessione di pagamento è scaduta. I tuoi dettagli sono stati salvati: riavvia il pagamento con un clic.",
"pay.relaunch": "Riavvia il pagamento",
"sub.received": "Inviato!",
"sub.publishing": "Stiamo concludendo…",
"sub.toPayment": "Reindirizzamento al pagamento sicuro…",
"fa.claimSubV2": "Descrivi il tuo oggetto smarrito. La persona che l'ha trovato confronterà la tua dichiarazione con il suo annuncio.",
"fa.photosOptional": "Foto del tuo oggetto (opzionale)",
"fa.compareOwnerHint": "Confronta queste informazioni con l'oggetto che hai trovato, poi dì se è lo stesso oggetto.",
"fa.itsThisItem": "Sì, questo è l'oggetto",
"fa.notThisItem": "No, questo non è l'oggetto",
"fa.confirmIsItem": "Confermi che questo è l'oggetto? I tuoi contatti e quelli del proprietario verranno mostrati nei rispettivi profili.",
"fa.confirmNotItem": "Confermi che questo non è l'oggetto? La tua segnalazione sarà chiusa.",
"fa.youConfirmed": "Hai confermato che questo è l'oggetto del proprietario",
"fa.youDeclined": "Hai indicato che questo non era l'oggetto",
"fa.youDeclinedText": "Grazie per il tuo aiuto! Il proprietario è stato informato.",
"fa.waitFinderDecisionOwner": "In attesa della decisione del cercatore",
"fa.finderConfirmed": "Confermato",
"fa.notYourItem": "Questo non era il tuo oggetto",
"fa.reportedOn": "Segnalato il",
"fa.ownerWaitHint": "Un trovator sta attualmente controllando le informazioni, ti preghiamo di attendere.",
"fa.claimSentFinder": "Richiesta inviata alla persona che ha trovato l'oggetto.",
"fa.compareClaimHint": "Confronta la dichiarazione del proprietario con il tuo annuncio prima di decidere.",
"fa.closeFollowup": "Chiudi questo follow-up",
"fa.closeFollowupConfirm": "Chiudere questo follow-up? Le email e i numeri di telefono di entrambe le parti verranno eliminati permanentemente una volta che anche il proprietario avrà chiuso il suo annuncio.",
"fa.safetyTitle": "Suggerimenti di sicurezza prima del passaggio",
"fa.safety1": "Chiedi al proprietario una descrizione dettagliata delle caratteristiche nascoste dell'oggetto: un graffio specifico, il contenuto esatto di una borsa, la carta da parati, il numero di serie…",
"fa.safety2": "Se possibile, chiedi una prova visiva (una foto dell'oggetto) o una prova d'acquisto.",
"fa.safety3": "Consegnare l'oggetto in un luogo pubblico o presso un partner di Findloop e controllare l'ID del proprietario.",
"fa.safetyOk": "Capito, continua",
"fa.ownerClosedNote": "Il proprietario ha chiuso il suo annuncio.",
"fa.finderClosedNote": "Il cercatore ha chiuso il suo follow-up.",
"fa.followupClosed": "Follow-up chiuso",
"fa.followupClosedText": "Hai chiuso questo follow-up. Grazie per il tuo aiuto!",
"fa.photoReviewTitle": "Un cercatore ha inviato una foto. Sembra il tuo oggetto?",
"fa.photoLooksLike": "Sì, sembra il mio oggetto",
"fa.photoNotMine": "No, questo non è il mio oggetto",
"fa.photoNotMineConfirm": "Il follow-up sarà chiuso da entrambi i lati e il tuo annuncio rimarrà aperto per un nuovo cercatore.",
"fa.photoLooksLikeDone": "Grazie! Il cercatore confronterà ora la tua dichiarazione.",
"fa.photoNotMineDone": "Segnalazione annullata. Il tuo annuncio rimane aperto.",
"fa.ownerPhotoHint": "Solo la foto del cercatore ti viene mostrata. Dicci se sembra il tuo oggetto.",
"fa.ownerReviewingPhoto": "Il proprietario sta esaminando la tua foto",
"fa.ownerReviewingPhotoText": "Saranno avvisati non appena risponderanno. Potrai poi confrontare la loro dichiarazione.",
"fa.ownerRejectedPhoto": "Questo non è l'oggetto del proprietario",
"fa.ownerRejectedPhotoText": "Il proprietario dice che la tua foto non corrisponde al loro oggetto. Il follow-up è chiuso. Grazie per il tuo aiuto!",
"fa.contribute": "Contribuisci",
"fa.phoneMissing": "Non fornito",
"fa.ownerSafety1": "Preferisci un passaggio in un luogo pubblico o presso un partner di Findloop. Se la distanza è lunga, suggerisci di inviarlo per posta.",
"fa.ownerSafety2": "Durante il passaggio, controlla l'ID del trovatore.",
"pub.changePhoto": "Cambia foto",
"ph.secured": "Foto protetta",
"ph.securing": "Proteggendo la foto…",
"fa.ownerSafety3": "Se la foto del trovador ha il watermark di Findloop, non accettare l'incontro. La foto deve essere un'immagine originale scattata dal trovador, senza watermark."
},
"pt": {
"ac.africa": "África",
"ac.boostActive": "Destaque ativo —",
"ac.boostSub": "Apareça no topo do diretório de parceiros com um distintivo “Impulsionado”.",
"ac.boostTitle": "Impulsione sua listagem no diretório",
"ac.categoryHint": "Para classificar seu estabelecimento no diretório findloop.",
"ac.choose": "Escolher",
"ac.cityHint": "Para posicionamento preciso no mapa público.",
"ac.cityLabel": "Cidade do estabelecimento",
"ac.cityPh": "Paris",
"ac.contact": "Detalhes de contato",
"ac.converted": "Convertido",
"ac.copyDeclLink": "Copiar o link da declaração",
"ac.copyLink": "Copiar o link",
"ac.currentPlan": "Plano atual",
"ac.emailDesc": "Escolha os e-mails que deseja receber. Notificações em seu espaço de trabalho permanecem sempre ativas.",
"ac.emailMatch": "Correspondências",
"ac.emailMatchDesc": "Um e-mail quando um item corresponde a uma declaração",
"ac.emailNewDecl": "Novas declarações de perda",
"ac.emailNewDeclDesc": "Um e-mail assim que um cliente relata uma perda em seu local",
"ac.emailShip": "Pedidos de envio",
"ac.emailShipDesc": "Um e-mail quando um cliente solicita o envio de um item",
"ac.emailTitle": "Preferências de e-mail",
"ac.expireSoon": "Seu destaque expirará em breve —",
"ac.exportCsv": "Exportar (CSV)",
"ac.exportHint": "Exporte seus pagamentos externos validados para sua contabilidade.",
"ac.free": "Grátis",
"ac.freeMonths": "Meses grátis",
"ac.hours": "horas",
"ac.howItWorks": "Como funciona?",
"ac.invited": "Convidado",
"ac.legalFR": "Obrigatório para faturamento eletrônico (Factur-X) aplicável a partir de setembro de 2026.",
"ac.legalMissing": "⚠️ SIRET e IVA intra-UE ausentes — complete-os para permanecer em conformidade com a fatura eletrônica.",
"ac.legalOther": "Recomendado para suas faturas.",
"ac.legalPartnerQr": "Código QR",
"ac.legalTitle": "Identificadores legais (faturamento)",
"ac.logoTitle": "Logo do estabelecimento",
"ac.modeCurrent": "Modo atual:",
"ac.modeExternal": "Externo (validação manual)",
"ac.modeInternal": "Interno Findloop (automático)",
"ac.noSubReceipt": "Nenhum pagamento de assinatura pago ainda.",
"ac.none": "Nenhum",
"ac.onYourListing": "na sua listagem",
"ac.pay1": "Insira seus links de pagamento abaixo para redirecionar seus clientes ao seu próprio sistema de cobrança.",
"ac.pay2": "A validação se torna manual: você confirma o recebimento do pagamento na aba “Declarações”.",
"ac.pay3": "O link “Taxa de envio” é um pagamento consolidado (recuperação + envio).",
"ac.pay4": "Deixe os campos vazios para usar o pagamento interno do Findloop (Stripe) com validação automática.",
"ac.paySub": "Coletar taxas através do seu próprio sistema de pagamento.",
"ac.payTitle": "Pagamentos externos",
"ac.permissive": "Permissivo",
"ac.phone": "Telefone",
"ac.posterA4": "Pôster A4 (PDF)",
"ac.qMessage": "Mensagem (opcional)",
"ac.qName": "Nome",
"ac.qOrg": "Organização",
"ac.qSites": "Número de estabelecimentos (estimado)",
"ac.qrHint": "Seus clientes escaneiam este código para relatar um item perdido.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Seu código QR de parceiro",
"ac.quoteDesc": "Aeroportos, redes ferroviárias, cadeias internacionais · ",
"ac.quoteEurope": "Europa / Mundo",
"ac.quoteSent": "Solicitação de orçamento enviada. Nossa equipe retornará em breve.",
"ac.quoteTitle": "Solicitar um orçamento — Enterprise",
"ac.recoveryLink": "link de “taxa de recuperação”",
"ac.refSub": "Cada parceiro indicado que se inscreve lhe dá 1 mês grátis.",
"ac.refTitle": "Indique, ganhe um mês grátis",
"ac.reminderDelay": "Atraso do lembrete de validação",
"ac.reminderHint": "Você receberá um lembrete por e-mail se um pagamento externo permanecer não validado além deste atraso (padrão: 48h).",
"ac.renewDesc1": "Isso já lhe rendeu",
"ac.renewDesc2": "Renove para continuar no topo do diretório e não perder essa visibilidade.",
"ac.renewNow": "Renovar agora",
"ac.requestQuote": "Solicitar um orçamento",
"ac.saveLegal": "Salvar os identificadores",
"ac.saveLinks": "Salvar os links",
"ac.sendRequest": "Enviar minha solicitação",
"ac.sending": "Enviando…",
"ac.shippingLink": "link de “taxa de envio” (consolidado)",
"ac.shippingLinkHint": "Este link cobre tanto recuperação quanto envio.",
"ac.strict": "Rigoroso",
"ac.subReceipt": "Recibo de assinatura (PDF)",
"ac.subReceiptsSub": "Baixe o recibo em PDF para cada pagamento de assinatura.",
"ac.subReceiptsTitle": "Recibos de assinatura",
"ac.tCategory": "Categoria salva",
"ac.tCity": "Cidade salva — mapa atualizado",
"ac.tCityNeeded": "Digite uma cidade",
"ac.tCopied": "Copiado!",
"ac.tCover": "Foto de capa atualizada",
"ac.tEmailPrefs": "Preferências de e-mail atualizadas",
"ac.tErr": "Erro",
"ac.tExportImpossible": "Exportação falhou",
"ac.tLegal": "Identificadores legais salvos",
"ac.tLegalNeeded": "SIRET e IVA necessários para a França",
"ac.tLogo": "Logo atualizado",
"ac.tLogoRemoved": "Logo removido",
"ac.tPayLinks": "Links de pagamento salvos",
"ac.tPhone": "Telefone salvo",
"ac.tSensitivity": "Sensibilidade salva",
"ac.tVatInvalid": "Número de IVA inválido",
"ac.tVatValid": "IVA válido",
"ac.tabBoost": "Visibilidade",
"ac.tabPayments": "Pagamentos",
"ac.tabProfile": "Perfil",
"ac.tabQr": "QR & Pôster",
"ac.tabReferral": "Indicação",
"ac.tabSub": "Assinatura",
"ac.thisWeek": "Esta semana",
"ac.thisWeekOf": " ({n} esta semana)",
"ac.thresholdDesc": "Limiar de confiança a partir do qual a IA valida automaticamente uma correspondência de foto e notifica o cliente. Maior = menos correspondências automáticas, mas mais confiáveis.",
"ac.thresholdTitle": "Sensibilidade de correspondência visual da IA",
"ac.trend": "Tendência",
"ac.upload": "Fazer upload",
"ac.vatValidFmt": "IVA válido{name} ({via})",
"ac.vatVerified": "IVA intra-UE verificado",
"ac.verifyVat": "Verificar IVA (VIES)",
"ac.verifying": "Verificando…",
"ac.views": "visualizações",
"ac.viewsTotal": "Visualizações gainhas (total)",
"ac.winbackBtn": "Retomar com -20%",
"ac.winbackDesc1": "Isso rendeu a você",
"ac.winbackDesc2": "Oferta especial: -20% aplicado automaticamente se você renovar dentro de 24h.",
"ac.winbackTitle": "Seu destaque acabou de expirar — retome com -20%!",
"an.allCountries": "Todos os países",
"an.country": "País",
"an.geoBanner": "Você está vendo listagens em",
"an.geoBannerWorld": "Você está vendo listagens mundialmente",
"an.geoChange": "mudar país",
"an.loginRequired": "Faça login para relatar este item e seguir o retorno.",
"an.requestInProgress": "Solicitação em andamento",
"an.resolved": "Item já recuperado",
"an.sortRecent": "Mais recente",
"an.sortRelevance": "Relevância",
"bo.africaPrice": "Preço preferencial da zona da África aplicado",
"c.all": "Todos",
"c.close": "Fechar",
"c.confirm": "Confirmar",
"c.confirmed": "Confirmado",
"c.download": "Baixar",
"c.reset": "Redefinir",
"c.transfer": "Transferir",
"cat.Animal": "Animal de estimação / Acessório para pet",
"cat.AppareilPhoto": "Câmera",
"cat.Argent": "Dinheiro / Caixa",
"cat.Autres": "Outros",
"cat.Bijoux": "Joias",
"cat.CarteBancaire": "Cartão bancário",
"cat.CarteIdentite": "Documento de identidade / Passaporte",
"cat.Casquette": "Boné / Chapéu",
"cat.Ceinture": "Cinto",
"cat.Chargeur": "Carregador / Cabo",
"cat.Chaussures": "Sapatos",
"cat.CleVoiture": "Chave do carro",
"cat.Cles": "Chaves",
"cat.Console": "Console de jogos",
"cat.Documents": "Documentos / Papéis",
"cat.Echarpe": "Cachecol",
"cat.Ecouteurs": "Fones de ouvido",
"cat.Electronique": "Eletrônicos (outros)",
"cat.Enceinte": "Caixa de som",
"cat.Gants": "Luvas",
"cat.Gourde": "Garrafa de água / Termo",
"cat.Instrument": "Instrumento musical",
"cat.Jouet": "Brinquedo / Pelúcia",
"cat.Jumelles": "Binóculos",
"cat.Lampe": "Luminária / Lanterna",
"cat.Liseuse": "Leitor de e-books",
"cat.Livre": "Livro / Caderno",
"cat.Lunettes": "Óculos",
"cat.Manteau": "Casaco / Jaqueta",
"cat.Maquillage": "Necessaire de maquiagem",
"cat.Medical": "Equipamento médico",
"cat.Medicaments": "Medicação",
"cat.Montre": "Relógio / Smartwatch",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Guarda-chuva",
"cat.Portefeuille": "Carteira / Bolsa",
"cat.Poussette": "Carrinho de bebê / Acessório para bebê",
"cat.Sac": "Bolsa / Carteira de mão",
"cat.SacADos": "Mochila",
"cat.Souris": "Mouse / Teclado",
"cat.Sport": "Equipamento esportivo",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefone / Smartphone",
"cat.Trottinette": "Patinete",
"cat.Trousse": "Bolsa / Estojo",
"cat.USB": "Pen drive / HD",
"cat.Valise": "Mala / Bagagem",
"cat.Velo": "Bicicleta",
"cat.Vetements": "Roupas",
"cm.found": "ENCONTRADO",
"cm.lost": "PERDIDO",
"consent.required": "Você deve concordar em compartilhar seus dados de contato para continuar.",
"consent.share": "Concordo que o localizador do meu item pode ver meus dados de contato (nome, e-mail, telefone) para entrar em contato para a devolução.",
"dc.partnerDesc": "Perdeu seu item em um local parceiro (hotel, estação, salão…)? Selecione-o para uma devolução direta.",
"dc.partnerList": "Escolha na lista",
"dc.partnerMap": "Escolha no mapa",
"dc.partnerTitle": "Declaração em um parceiro",
"dc.publicCta": "Publicar um anúncio público",
"dc.publicDesc": "Seu anúncio será visível para toda a comunidade findloop. Ideal se você não sabe onde perdeu o item.",
"dc.publicTitle": "Declaração pública",
"dc.subtitle": "Escolha como relatar seu item perdido.",
"dc.title": "O que você gostaria de fazer?",
"dec.addrPending": "Endereço pendente do cliente",
"dec.analyzing": "Analisando…",
"dec.clientDescription": "Descrição do cliente",
"dec.clientPhoto": "Foto fornecida pelo cliente",
"dec.clientPhotoShort": "Foto do cliente",
"dec.comparePhotos": "Comparar fotos",
"dec.declaredItemPhoto": "Foto do item declarado",
"dec.emptyDesc": "Compartilhe seu código QR para receber declarações.",
"dec.emptyTitle": "Sem declarações",
"dec.enlarge": "Ampliar",
"dec.extBanner": "{n} pagamento(s) externo(s) a validar — confirme o recebimento abaixo para desbloquear a entrega ou envio.",
"dec.foundItemAlt": "Item encontrado",
"dec.foundItemRegistry": "Item encontrado (registro)",
"dec.labelClient": "Cliente",
"dec.labelRegistry": "Registro",
"dec.noMatchYet": "Nenhuma correspondência ainda.",
"dec.noPhoto": "Sem foto",
"dec.pRecup": "recuperação",
"dec.pRecupP": "(recuperação)",
"dec.pRecupShip": "(recuperação + envio)",
"dec.payConfirmed": "Pagamento {x} confirmado",
"dec.payPending": "Pagamento externo {x} pendente",
"dec.pickup": "Retirada pessoal",
"dec.reject": "Rejeitar",
"dec.rerun": "Repetir a análise",
"dec.similarity": "Similaridade {n}%",
"dec.suggestedMatches": "Correspondências sugeridas",
"dec.toColon": " para:",
"dec.toShip": "Para envio",
"dec.toastExtPay": "Pagamento confirmado — o cliente será notificado.",
"dec.toastMatch": "Correspondência confirmada",
"dec.toastReject": "Sugestão rejeitada",
"dec.toastRerun": "Análise reiniciada",
"dec.toastVisualN": "{n} correspondência(s) visual(is)",
"dec.toastVisualNone": "Sem correspondência visual",
"dec.viewBeforeAfter": "Visão antes/depois (sobreposição)",
"dec.viewSideBySide": "Visão lado a lado",
"dec.visualCompare": "Comparação visual por IA",
"dec.visualIdle": "Execute a comparação para que a IA compare visualmente a foto do cliente com os itens encontrados.",
"dec.visualRunning": "A IA está comparando a foto do cliente com os itens no seu registro…",
"dec.zoomPhoto": "Ampliar a foto",
"dep.addAnyway": "Adicionar mesmo assim",
"dep.addError": "Erro ao adicionar",
"dep.addItem": "Adicionar item",
"dep.added": "Item adicionado ao registro!",
"dep.adding": "Adicionando...",
"dep.aiError": "Análise de IA indisponível no momento.",
"dep.aiFilled": "Formulário pré-preenchido pela IA ✨",
"dep.aiUnavailable": "IA indisponível — preencha o formulário manualmente.",
"dep.analyzing": "Analisando...",
"dep.analyzingPhoto": "Analisando foto...",
"dep.brand": "Marca",
"dep.brandPlaceholder": "ex. Apple",
"dep.category": "Categoria",
"dep.checkingDup": "Verificando duplicatas...",
"dep.color": "Cor",
"dep.colorPlaceholder": "ex. preto",
"dep.condition": "Condição",
"dep.conditionPlaceholder": "ex. boa condição",
"dep.depositorNote": "Nota do depositante",
"dep.depositorNoteHint": "Detalhes operacionais digitados à mão. A IA nunca sobrescreve essa nota.",
"dep.depositorNotePlaceholder": "ex. conteúdos de uma bolsa, marca conforme reportada, detalhes dados pela pessoa...",
"dep.descPlaceholder": "ex. iPhone 15 preto com capa transparente, encontrado no bar...",
"dep.description": "Descrição",
"dep.dupHint": "Certifique-se de que não está adicionando uma duplicata. Você pode continuar se o item for realmente diferente.",
"dep.dupTitle": "Item(s) semelhante(s) já registrados",
"dep.dupWarn": "Item semelhante detectado — revise e clique novamente para confirmar.",
"dep.estHint": "O item será adicionado ao registro deste estabelecimento.",
"dep.establishment": "Estabelecimento",
"dep.fee": "Taxa de recuperação (€) — opcional",
"dep.feePlaceholder": "Deixe em branco para o preço padrão da categoria",
"dep.fillAI": "Preencher com IA",
"dep.optional": "(opcional)",
"dep.photo": "Foto do item",
"dep.principal": "principal",
"dep.reqError": "Categoria e descrição são obrigatórios.",
"dep.savedItem": "Item registrado",
"dep.similarity": "Similaridade",
"dep.storage": "Localização física",
"dep.storageHint": "Onde o item está fisicamente armazenado. Um código QR será gerado para encontrá-lo.",
"dep.storagePlaceholder": "ex. Prateleira A3, Armário 12, Cofre da recepção",
"dl.aClient": "um cliente",
"dl.alertsBlocked": "Alertas do navegador bloqueados",
"dl.alertsBlockedHint": "Para reativá-los: clique no ícone 🔒 (ou ⓘ) à esquerda do endereço do site, em seguida, permita Notificações e recarregue a página.",
"dl.amountDue": "Valor devido: {amount} {currency}.",
"dl.enableAlerts": "Habilitar alertas",
"dl.extPending": "Pagamentos a validar",
"dl.freemiumNear": "Você está se aproximando do limite Freemium ({used}/{max} itens neste mês). Atualize para Starter para itens ilimitados.",
"dl.freemiumReached": "Limite Freemium alcançado ({used}/{max} itens neste mês). Atualize para Starter para registrar itens ilimitados.",
"dl.invoiceOverdue": "Fatura {num} não paga — acesso restrito.",
"dl.matchNotifTitle": "Findloop — Nova correspondência de IA 🔔",
"dl.matchToast": "Nova correspondência de IA — {name}",
"dl.matchToastDesc": "Um item corresponde a uma declaração.",
"dl.notifEmpty": "Ainda sem notificações.",
"dl.notifEnabled": "Alertas do navegador habilitados",
"dl.notifTitle": "Notificações",
"dl.payInvoice": "Pagar minha fatura →",
"dl.rewardsPending": "Vouchers a apresentar",
"dl.upgradeStarter": "Atualizar para Starter →",
"est.all": "Todos os estabelecimentos ({n})",
"est.label": "Estabelecimento",
"est.primary": "primário",
"est.secondary": "secundário",
"est2.add": "Adicionar um estabelecimento",
"est2.addressLabel": "Endereço",
"est2.addressPh": "Rua República 12",
"est2.autoInvoice": "Uma fatura detalhada é gerada automaticamente no dia 1 de cada mês.",
"est2.baseSub": "Assinatura base",
"est2.billing": "Faturamento",
"est2.boostActivated": "Impulso ativado para {name}",
"est2.boostBillingNote": "Cobrado pela tarifa atual e agrupado na sua fatura mensal consolidada.",
"est2.boostCta": "Impulso",
"est2.boostDesc": "Melhore a visibilidade deste estabelecimento no diretório e no mapa.",
"est2.boostDuration": "{h}h de visibilidade impulsionada",
"est2.boostExtend": "Prorrogar",
"est2.boostTitle": "Impulso {name}",
"est2.boosted": "Impulsionado",
"est2.chartDesc": "Parte de itens devolvidos do total registrado, site por site.",
"est2.chartTitle": "Taxa de retorno por estabelecimento",
"est2.chartTooltip": "Retorno",
"est2.cityLabel": "Cidade",
"est2.cityPh": "Lyon",
"est2.contactHint": "Esses detalhes são mostrados ao cliente para este estabelecimento (retorna à conta se vazio).",
"est2.countryLabel": "País",
"est2.coverLabel": "Foto de capa",
"est2.create": "Criar",
"est2.created": "Estabelecimento criado",
"est2.delete": "Excluir",
"est2.deleteDesc": "Essa ação é permanente. Você só pode excluir um estabelecimento se não contiver itens.",
"est2.deleteTitle": "Excluir “{name}”?",
"est2.deleted": "Estabelecimento excluído",
"est2.dialogDesc": "Insira o nome e o endereço deste local.",
"est2.edit": "Editar",
"est2.editEst": "Editar estabelecimento",
"est2.emailLabel": "Email de contato",
"est2.emailPh": "contato@site.com",
"est2.estSuffix": " estabelecimento(s)",
"est2.extraNoteBase": "{n} estabelecimento(s) adicional(is) cobrados",
"est2.extraPrice": " a {price} €/mês.",
"est2.extraQuote": " na cotação.",
"est2.imgChange": "Escolher uma imagem",
"est2.imgDone": "Concluído",
"est2.imgRemove": "Remover",
"est2.imgRemoved": "Imagem removida",
"est2.imgSaved": "Imagem salva",
"est2.imgUploading": "Carregando…",
"est2.includedPlan": "Incluído no seu plano: {n}.",
"est2.kDeclarations": "Declarações",
"est2.kInStorage": "Em estoque",
"est2.kItemsTotal": "Itens (total)",
"est2.kRestituted": "Devolvidos",
"est2.limitReached": "Limite atingido",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Decl.",
"est2.mItems": "Itens",
"est2.mRestituted": "Devolvidos",
"est2.mStorage": "Em estoque",
"est2.monthlyTotal": "Total mensal",
"est2.nameLabel": "Nome *",
"est2.namePh": "ex. Hotel Belmont — Anexo Lyon",
"est2.newEst": "Novo estabelecimento",
"est2.onQuote": "Na cotação",
"est2.phoneLabel": "Telefone",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plano",
"est2.planLimited": "Seu plano “{tier}” é limitado a {max} estabelecimento(s).",
"est2.primary": "Primário",
"est2.qr": "Código QR",
"est2.qrDesc": "Exiba este código QR neste estabelecimento. Clientes relatando perda serão vinculados a este site.",
"est2.qrTitle": "Código QR — {name}",
"est2.saving": "Economizando…",
"est2.seeInvoices": "Veja minhas faturas mensais",
"est2.seePlans": "Veja os planos",
"est2.subtitle": "Gerencie todos os seus sites sob uma conta — visão consolidada, itens, código QR e faturamento.",
"est2.suspended": "Suspenso",
"est2.tierFree": "1 estabelecimento",
"est2.tierLarge": "estabelecimentos ilimitados",
"est2.tierMedium": "5 estabelecimentos incluídos",
"est2.tierSmall": "3 estabelecimentos incluídos",
"est2.title": "Estabelecimentos",
"est2.unlimitedPlan": "Seu plano permite um número ilimitado de estabelecimentos.",
"est2.unlimitedSuffix": " · ilimitado",
"est2.updated": "Estabelecimento atualizado",
"est2.upgradeHint": "Atualize para um plano superior para adicionar mais sites e centralizar toda a sua atividade.",
"est2.visuals": "Logotipo e foto",
"est2.visualsDesc": "Personalize o logotipo e a foto de capa deste estabelecimento. Eles aparecem em sua página pública e formulário de declaração.",
"est2.visualsTitle": "Visuais — {name}",
"est2.workOn": "Trabalhe neste estabelecimento",
"est2.working": "Você está trabalhando em “{name}”",
"ft.backAccount": "Voltar à Minha conta",
"ft.closeBtn": "Fechar o caso",
"ft.closeConfirm": "Confirmar que o item foi devolvido? O anúncio será fechado.",
"ft.closeLockedHint": "Valide o código do proprietário primeiro para desbloquear o fechamento.",
"ft.closed": "Caso fechado — item devolvido!",
"ft.codeLabel": "Digite o código de validação recebido do proprietário",
"ft.codeNeeded": "Por favor, insira o código de validação.",
"ft.codeOk": "Código validado — você pode fechar o caso.",
"ft.codePlaceholder": "ex. 4821",
"ft.codeVerified": "Validado",
"ft.doneMsg": "Item devolvido. Obrigado por ajudar a devolvê-lo ao seu proprietário!",
"ft.stepInProgress": "Devolução em andamento",
"ft.stepPublished": "Anúncio publicado",
"ft.stepReturned": "Item devolvido",
"ft.subtitle": "Siga os passos até que o item encontrado seja devolvido.",
"ft.title": "Rastreamento de devolução",
"ft.verifyBtn": "Validar código",
"inv2.contractTitle": "Meu contrato Findloop",
"inv2.detailByEst": "Detalhes por estabelecimento",
"inv2.dueLabel": "Vencimento:",
"inv2.dueSuffix": " · vencido {date}",
"inv2.error": "Erro {status}",
"inv2.estCountIssued": "{n} estabelecimento(s) · emitido em {date}",
"inv2.estimate": "Estimativa (não cobrada) · {n} estabelecimento(s)",
"inv2.expired": " · expirado",
"inv2.exportCsv": "Exportar CSV",
"inv2.exportDone": "Exportação CSV baixada",
"inv2.included": "Incluído",
"inv2.monthlyTitle": "Faturamento mensal (assinatura)",
"inv2.months": "+{n} meses",
"inv2.paid": "Pago",
"inv2.pay": "Pagar",
"inv2.previewTitle": "Prévia da sua próxima fatura —",
"inv2.renew": "Renovar meu contrato",
"inv2.renewalsTitle": "Histórico de renovações ({n})",
"inv2.renewedUntil": "Contrato renovado até {date}",
"inv2.serviceTitle": "Faturas de serviço (recuperações e orçamentos)",
"inv2.soon": "Expirando em breve",
"inv2.toPay": "A pagar",
"inv2.totalHtTva": "Total excl. imposto · IVA",
"inv2.totalTtc": "Total incl. imposto",
"iu.addPhoto": "Adicionar uma foto",
"iu.change": "Mudar",
"map.high": "Alto",
"map.legend": "Pontinhos coloridos de vermelho (baixo) a verde (alto) com base na taxa de retorno; tamanho baseado no número de itens.",
"map.locating": "Localizando… adicione um endereço aos seus estabelecimentos para vê-los no mapa.",
"map.low": "Baixo",
"map.medium": "Médio",
"map.noItemRegistered": "Nenhum item registrado",
"map.noItems": "Nenhum item",
"map.returnedSuffix": "retornado · {a}/{t} itens",
"map.title": "Mapa dos seus estabelecimentos",
"mc.archiveHide": "Ocultar histórico",
"mc.archiveNone": "Nenhum caso resolvido ainda.",
"mc.archiveShow": "Mostrar histórico",
"mc.archiveSub": "Casos resolvidos e retornados.",
"mc.archiveTitle": "Histórico",
"mc.certificate": "Certificado",
"mc.finderAccepted": "Aceito",
"mc.hAd": "Anúncio perdido",
"mc.hDeclaration": "Declaração",
"mc.hFinderContact": "Item relatado",
"mc.hFound": "Item retornado",
"mc.hFoundAd": "Anúncio encontrado",
"mc.myFinds": "Itens que encontrei",
"mc.myFindsNone": "Você ainda não relatou ter encontrado nenhum item.",
"mc.myFindsSub": "Itens que você relatou ter encontrado em anúncios de itens perdidos.",
"mc.notifOpen": "Ver",
"mc.notifTrack": "Rastrear",
"mc.notifViewAd": "Ver anúncio",
"mc.presentHint": "Mostre este QR para o parceiro: ele o escaneia para validar sua recompensa.",
"mc.presentInStore": "Mostrar na loja",
"mc.presentTitle": "Mostrar este voucher",
"mc2.acceptFinder": "Aceitar este encontrador",
"mc2.accountActivity": "Atividade da conta",
"mc2.adsActive": "{n}/5 anúncios ativos",
"mc2.autoDelete": "Exclusão automática agendada para",
"mc2.badgeBronze": "Bronze",
"mc2.badgeGold": "Ouro",
"mc2.badgeSilver": "Prata",
"mc2.boostEarnedAlready": "Já te rendeu",
"mc2.boostEarnedWin": "Te rendeu",
"mc2.boostExpiredWin": "Seu boost acabou de expirar — renove com -20%!",
"mc2.boostExpiresIn": "Seu boost expira em",
"mc2.boostWinDetail2": ". -20% aplicado automaticamente se você renovar em até 24h.",
"mc2.claimCode": "Código de reivindicação:",
"mc2.codeSentFinder": "Código enviado para o encontrador por e-mail",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Baixar meu recibo",
"mc2.error": "Erro {status}",
"mc2.finderAccepted": "Encontrador aceito — código enviado por e-mail",
"mc2.finderContacts": "Detalhes de contato do(s) Finder(s)",
"mc2.followFindo": "Siga Findloop",
"mc2.imgInvalid": "Imagem inválida",
"mc2.inactivityNote": " — em caso de {n} meses de inatividade (GDPR).",
"mc2.lastActivity": "Última atividade:",
"mc2.lostEmailTitle": "Não tenho mais acesso ao meu e-mail",
"mc2.noPhotoPreset": "Sem foto ainda? Escolha um avatar padrão:",
"mc2.paidViaPartner": "Pago (via parceiro)",
"mc2.payRecovery": "Pagar a taxa de recuperação",
"mc2.paySettle": "Regularizar meu pagamento",
"mc2.payShipping": "Pagar a taxa de envio",
"mc2.payUnavailable": "Pagamento indisponível",
"mc2.peopleFound": "{n} pessoa(s) acham que encontrou seu item",
"mc2.phoneNumber": "Número de telefone",
"mc2.reactivateAccount": "Reativar minha conta",
"mc2.reactivated": "Conta reativada",
"mc2.reactivatedThanks": "Conta reativada — obrigado pela sua lealdade!",
"mc2.recoverSmsBtn": "Receber meu código por SMS",
"mc2.recoverSmsDesc": "Receba seu código de reivindicação por SMS para o número registrado na sua conta.",
"mc2.recoverSmsFallback": "Se uma conta existir com este número, um SMS foi enviado.",
"mc2.renewStayTop": ". Renove para se manter no topo e recuperar seu item.",
"mc2.resume20": "Retomar -20%",
"mc2.unlockContacts": "Desbloquear detalhes de contato",
"mc2.unlockDesc": "Pague a taxa de manuseio do Findloop para revelar os detalhes de contato e agendar a entrega.",
"mc2.viewsWord": "visualizações",
"mc2.live": "Ao vivo",
"mh.allCategories": "Todas as categorias",
"mh.allPeriod": "Todo tempo",
"mh.autoMatch": "Correspondência automática de IA",
"mh.blocked": "Bloqueado (contradição)",
"mh.blockedReason": "Correspondência bloqueada: as palavras-chave principais do item e a declaração se contradizem.",
"mh.days30": "Últimos 30 dias",
"mh.days7": "Últimos 7 dias",
"mh.days90": "Últimos 90 dias",
"mh.emptyDesc": "As correspondências de IA aparecerão aqui à medida que as declarações chegarem.",
"mh.emptyTitle": "Sem eventos",
"mh.exportCsv": "Exportar CSV",
"mh.exportDone": "Exportação CSV baixada",
"mh.exportImpossible": "Exportação falhou",
"mh.fBlocked": "Bloqueado",
"mh.fConfirmed": "Confirmado",
"mh.fRejected": "Rejeitado",
"mh.objectLabel": "Item:",
"mh.refresh": "Atualizar",
"mh.rejected": "Rejeitado",
"mh.srcManual": "Manual",
"mh.srcText": "Texto",
"mh.srcVisual": "Visual (foto)",
"mh.subtitle": "Registro de correspondências propostas pela IA — correspondido automaticamente, confirmado e rejeitado.",
"mh.title": "Histórico de IA",
"nf.desc": "A página que você está procurando não existe ou foi movida.",
"nf.home": "Voltar para a página inicial",
"nf.title": "Página não encontrada",
"par.allCities": "Todas as cidades",
"par.cityPh": "Cidade",
"pay.eurNote": "Valores exibidos em euros (€).",
"pg.next": "Próximo",
"pg.prev": "Anterior",
"pg.showing": "{from}–{to} de {total}",
"pk.bodyCopy": "Texto do corpo",
"pk.bodyText": "Texto do corpo",
"pk.brandColors": "Cores da marca",
"pk.colorRed": "Vermelho",
"pk.colorWhite": "Branco",
"pk.darkBg": "Fundo escuro",
"pk.download": "Baixar",
"pk.downloadZip": "Baixar o kit completo (ZIP)",
"pk.headings": "Títulos",
"pk.heroDesc": "Logos oficiais, banners de redes sociais, cores e tipografia. Escolha o idioma e a variante da tagline, e depois baixe o visual ou o kit completo.",
"pk.lightBg": "Fundo claro (impressão)",
"pk.logoWordmark": "Logo / palavra",
"pk.logosVisuals": "Logos & visuais",
"pk.mapCollect": "Pontos de coleta / mapa",
"pk.plain": "Simples",
"pk.pressKit": "Kit de imprensa",
"pk.taglineLang": "Idioma da tagline",
"pk.typography": "Tipografia",
"pk.variant": "Variantes",
"pr2.adBoostMsg": "Ótima escolha! Você multiplica suas chances de recuperar seu item rapidamente.",
"pr2.boostActivated": "Aumento ativado!",
"pr2.canRecoverNow": "Você pode agora recuperar seu item.",
"pr2.continue": "Continuar",
"pr2.downloadReceiptPdf": "Baixar o recibo (PDF)",
"pr2.goToSpaceNow": "Ir para minha conta agora",
"pr2.partnerBoostMsg": "Ótima escolha! Ser mais visível significa atrair novos clientes para o seu estabelecimento.",
"pr2.paymentSuccess": "Pagamento realizado com sucesso!",
"pr2.redirectingSpace": "Redirecionando para sua conta…",
"pr2.subActivated": "Pagamento realizado com sucesso! Sua assinatura está ativa, você pode agora gerenciar seus estabelecimentos.",
"prev.allSites": "Todos os estabelecimentos",
"pricing.annual": "Anual",
"pricing.annualBadge": "-20% oferta",
"pricing.monthly": "Mensal",
"pricing.perYear": "/ano",
"pub.accessGranted": "Acesso concedido",
"pub.accessLimited2h": "Acesso limitado a 2 horas",
"pub.accountEmailConcerned": "Email da conta envolvida",
"pub.adAppearPublic": "É assim que seu anúncio aparecerá publicamente.",
"pub.adPreviewBtn": "Prévia do anúncio",
"pub.alertMeOnArrival": "Avise-me na chegada",
"pub.allActionsLogged": "Todas as ações estão registradas",
"pub.allCategories": "Todas as categorias",
"pub.authorizeAccess": "Autorizar acesso",
"pub.authorizeSupportQ": "Autorizar acesso ao suporte?",
"pub.available": "Disponível",
"pub.backHome": "Voltar para a página inicial",
"pub.boostAdCta": "Aumentar meu anúncio",
"pub.boostAdTitle": "Aumente seu anúncio",
"pub.boostCarouselSub": "Mova para o topo da página no carrossel “Aumentados” e multiplique visualizações para recuperar seu item mais rápido.",
"pub.boostEstablishment": "Aumentar seu estabelecimento",
"pub.boostEstablishmentDesc": "Apareça no topo do diretório com um selo “Aumentado” e atraia mais relatos.",
"pub.boostFicheCta": "Aumentar minha listagem",
"pub.brandReady": "A marca Findloop, pronta para uso",
"pub.cantFindItem": "Não consegue encontrar seu item?",
"pub.cantProcessImage": "Não foi possível processar esta imagem",
"pub.claimQr": "Reivindicar código QR",
"pub.clickToZoom": "Clique para ampliar",
"pub.codeAlreadyValidated": "Código validado — contatos desbloqueados.",
"pub.codeExample": "ex. ABCD2345",
"pub.confirmRenewal": "Confirme a renovação",
"pub.contactIntro": "Uma pergunta, um pedido? Escreva para nós, entraremos em contato em breve.",
"pub.contactTypeDeceased": "Exclusão de conta (pessoa falecida)",
"pub.contactTypeGeneral": "Pergunta geral",
"pub.contactTypeSupport": "Suporte / problema técnico",
"pub.contactUs": "Entre em contato",
"pub.continueWithoutEmail": "Continuar sem deixar meu e-mail",
"pub.contractLabel": "Contrato",
"pub.contractNotFound": "Contrato não encontrado ou já expirado.",
"pub.contractRenewed": "Contrato renovado!",
"pub.contractRenewedFor": "Seu contrato foi renovado por {n} meses.",
"pub.copyFailed": "Falha na cópia",
"pub.createPartnerAccount": "Criar minha conta de parceiro",
"pub.currentDeadline": "Prazo atual",
"pub.deceasedInfo": "Como parente ou herdeiro, você pode solicitar a exclusão da conta Findloop de uma pessoa falecida. Vamos processar sua solicitação em conformidade com o GDPR (documentos de apoio podem ser solicitados).",
"pub.declareMyLoss": "Reportar minha perda",
"pub.describeItemPlaceholder": "Descreva seu item (ex.: guarda-chuva preto, chaves…)",
"pub.downloadImage": "Baixar a imagem",
"pub.drawSignature": "Por favor, desenhe sua assinatura.",
"pub.drawSignatureHint": "Desenhe sua assinatura com o mouse ou o dedo.",
"pub.duration": "Duração",
"pub.eSignature": "Assinatura eletrônica",
"pub.eSignatureDesc": "Insira seu nome para assinar. A data é registrada automaticamente.",
"pub.edit": "Editar",
"pub.editorialTitles": "Títulos editoriais",
"pub.emailPlaceholder": "você@exemplo.com",
"pub.enterCodeUnlockOwner": "Insira o código recebido por e-mail para desbloquear os detalhes de contato do proprietário.",
"pub.errorWord": "Erro",
"pub.foundSelfService": "Itens encontrados · Autoatendimento",
"pub.haveOwnerCode": "Eu recebi um código do proprietário",
"pub.home": "Início",
"pub.immediateRenewal": "Renovação imediata, sem um novo orçamento.",
"pub.impAdminReq1": "Administrador",
"pub.impAdminReq2": "solicita permissão para acessar temporariamente sua conta",
"pub.impAdminReq3": "para ajudá-lo.",
"pub.impGrantedDesc": "A equipe de suporte poderá acessar sua conta por no máximo 2 horas. Cada ação será registrada. Você pode fechar esta página.",
"pub.invitedOnFindo": "Você está convidado a encontrar o Findloop",
"pub.isThisYourItem": "Este item é seu?",
"pub.itemsAvailableCount": "{n} item(ns) disponível(eis) atualmente",
"pub.itemsFoundOwner": "dos itens confiados encontrou seu proprietário",
"pub.itemsReturnedOwners": "itens devolvidos a seus proprietários",
"pub.itsMine": "É meu",
"pub.joinFindoDesc": "Junte-se ao Findloop e gerencie seus itens encontrados com facilidade.",
"pub.joinInvitesYou": "o convida a se juntar ao findloop. Crie sua conta de parceiro para gerenciar seus itens encontrados.",
"pub.linkCopied": "Link copiado!",
"pub.loadingContract": "Carregando o contrato…",
"pub.lsClaimDesc": "Reporte sua perda para recuperá-la. Deixe seu e-mail e enviaremos um lembrete se seu relatório não for concluído.",
"pub.lsHeroDesc": "Verifique por conta própria se seu item perdido foi encontrado e deixado aqui. Encontrou? Informe para recuperá-lo.",
"pub.lsSearchTitle": "Pesquisar itens encontrados",
"pub.makeOffer": "Fazer uma oferta",
"pub.makeOfferDesc": "Proponha seu valor. O superadministrador irá avaliar.",
"pub.mapNearYou": "Itens e parceiros perto de você",
"pub.mapWord": "Mapa",
"pub.messageSentToast": "Mensagem enviada — nossa equipe responderá em breve.",
"pub.messageWord": "Mensagem",
"pub.momoInitiated": "Pagamento de Mobile Money iniciado",
"pub.monthsWord": "meses",
"pub.nameConsentRequired": "Nome e consentimento necessários.",
"pub.newDeadline": "Novo prazo",
"pub.noActionRequired": "Nenhuma ação necessária.",
"pub.noAmountCharged": "Nenhum valor foi cobrado.",
"pub.noItemMatch": "Nenhum item disponível corresponde à sua pesquisa no momento.",
"pub.noMatchingItem": "Nenhum item correspondente",
"pub.noPaymentSession": "Sem sessão de pagamento.",
"pub.noPhoto": "Sem foto",
"pub.noPointsYet": "Ainda não há pontos para exibir.",
"pub.noSecondPayment": "Nenhum segundo pagamento é necessário para este item.",
"pub.notHereYet": "Ainda não chegou? Receba uma notificação assim que chegar.",
"pub.notifyDone": "Anotado! Nós o notificaremos por e-mail assim que um item correspondente chegar.",
"pub.offerSubmitted": "Sua oferta foi enviada.",
"pub.oops": "Oops",
"pub.orAlertEmail": "Ou receba um alerta por e-mail assim que um item correspondente chegar:",
"pub.ownerContacts": "Detalhes de contato do proprietário",
"pub.ownerContactsUnlocked": "Detalhes de contato do proprietário desbloqueados",
"pub.partnerContact": "Contato do parceiro",
"pub.payLinkUnavailable": "Link de pagamento indisponível — entre em contato com o parceiro.",
"pub.paymentCancelled": "Pagamento cancelado",
"pub.paymentConfirmed": "Pagamento confirmado 🎉",
"pub.paymentConfirmedDesc": "Você receberá um e-mail com os detalhes para recuperar seu item.",
"pub.paymentNotConfirmed": "Pagamento não confirmado",
"pub.paymentNotConfirmedDesc": "O pagamento não pôde ser verificado. Tente novamente ou entre em contato com o parceiro.",
"pub.paymentProcessing": "Pagamento está sendo processado. Atualize em um momento.",
"pub.photoAdded": "✓ Foto adicionada",
"pub.photoRequired": "Uma foto do item é necessária.",
"pub.previewAlt": "pré-visualização",
"pub.publish": "Publicar",
"pub.publishingWord": "Publicando…",
"pub.qty": "Qtd",
"pub.quoteDeclined": "Citação recusada.",
"pub.quoteNotFound": "Citação não encontrada ou expirada.",
"pub.reasonLabel": "Razão",
"pub.recoveryAlreadyPaid": "Taxa de recuperação já paga",
"pub.referralCode": "Código de referência:",
"pub.relationshipPlaceholder": "Filho, cônjuge, notário…",
"pub.renewYourContract": "Renove seu contrato",
"pub.renewalFailed": "Falha na renovação. Tente novamente mais tarde.",
"pub.renewing": "Renovando…",
"pub.replySoon": "Nossa equipe responderá o mais rápido possível.",
"pub.requestGone": "Este pedido não existe mais.",
"pub.requestHandled": "Pedido já tratado",
"pub.requestNotFound": "Pedido não encontrado ou expirada.",
"pub.requestUnavailable": "Pedido indisponível",
"pub.required": "(obrigatório)",
"pub.retroClosing": "Juntos, tornamos o mundo um pouco menos perdido.",
"pub.retroClosing2": "Juntos, tornamos o mundo um pouco menos perdido.",
"pub.retroScroll": "Um ano de recuperação do que importa. Role para baixo ↓",
"pub.revokeAnytime": "Você pode revogar a qualquer momento entrando em contato conosco",
"pub.scene": "Cena",
"pub.sendImpossible": "Incapaz de enviar",
"pub.sendMessage": "Enviar a mensagem",
"pub.sending": "Enviando…",
"pub.sharePreview": "Compartilhar pré-visualização",
"pub.shareYourAd": "Compartilhe seu anúncio",
"pub.signedSuccess": "Assinado com sucesso!",
"pub.signerFullName": "Nome completo do signatário",
"pub.spreadNetwork": "Compartilhe com aqueles ao seu redor para aumentar suas chances.",
"pub.spreadOwner": "Compartilhe para ajudar o proprietário a recuperar seus pertences.",
"pub.statusLabel": "Status:",
"pub.subject": "Assunto",
"pub.thanksSent": "Obrigado, sua mensagem foi enviada.",
"pub.thisYear": "Este ano",
"pub.validate": "Validar",
"pub.verifyingPayment": "Verificando pagamento…",
"pub.verifyingYourPayment": "Verificando seu pagamento…",
"pub.viewAd": "Ver o anúncio →",
"pub.viewPartner": "Ver o parceiro →",
"pub.yourAdPreview": "Prévia do seu anúncio",
"pub.yourEmail": "Seu e-mail",
"pub.yourEmailRecommended": "Seu e-mail (recomendado)",
"pub.yourEmailShort": "Seu e-mail",
"pub.yourName": "Seu nome",
"pub.yourRelationship": "Sua relação com a pessoa",
"qv.acceptAndSign": "Aceitar e assinar minha proposta",
"qv.certifyAuthorized": "Certifico que estou autorizado a assinar e aceito os termos deste {what} (valor vinculativo).",
"qv.clear": "Limpar",
"qv.client": "Cliente",
"qv.conditions": "Condições",
"qv.confirmDecline": "Confirmar a recusa desta proposta?",
"qv.countersignedFindo": "Countersignado por Findloop · {name} em {date}",
"qv.decline": "Recusar",
"qv.description": "Descrição",
"qv.downloadPdf": "Baixar o PDF",
"qv.handwrittenSignature": "Assinatura manuscrita",
"qv.inclTax": "Incl. imposto",
"qv.invalidAmount": "Valor inválido.",
"qv.invoice": "Fatura",
"qv.invoicePaid": "Fatura paga",
"qv.issuer": "Emissor",
"qv.messageOptional": "Mensagem (opcional)",
"qv.negotiatedAmount": "Valor negociado",
"qv.payInvoiceOnline": "Pagar a fatura online",
"qv.quote": "Proposta",
"qv.quoteValidDays": "Proposta válida por {n} dias.",
"qv.sendMyOffer": "Enviar minha oferta",
"qv.signContract": "Assinar meu contrato",
"qv.signNow": "Assinar agora",
"qv.signatureAlt": "Assinatura",
"qv.signedByOn": "✔ Assinado por {name} em {date}",
"qv.stContractSigned": "Contrato assinado. Obrigado!",
"qv.stCounterAccepted": "Sua oferta foi aceita! Assine seu contrato abaixo.",
"qv.stCounterRefused": "Sua oferta não pôde ser aceita.",
"qv.stCountered": "Sua oferta foi enviada. Aguardando resposta do findloop.",
"qv.stDeclined": "Você recusou esta proposta.",
"qv.stSigned": "Proposta aceita e assinada. Obrigado!",
"qv.totalHt": "Total sem imposto",
"qv.totalTtc": "Total com imposto",
"qv.unitHt": "Unidade sem imposto",
"qv.vat": "IVA",
"qv.yourProposedAmount": "Seu valor proposto ({cur})",
"reg.add": "Registrar um item",
"reg.allBrands": "Todas as marcas",
"reg.allColors": "Todas as cores",
"reg.allLocations": "Todos os locais",
"reg.detailDesc": "Detalhes e ações para este item encontrado.",
"reg.dispAuction": "Leilão",
"reg.dispAuthorities": "Entregue às autoridades",
"reg.dispDestroyed": "Destruído",
"reg.dispDonate": "Doação para caridade",
"reg.dispositionHint": "Registre o item saindo do armazenamento. Contado nas estatísticas por categoria.",
"reg.emptyCta": "Registrar um item",
"reg.emptyDesc": "Comece registrando seu primeiro item encontrado.",
"reg.emptyTitle": "Nenhum item encontrado",
"reg.establishmentFallback": "o estabelecimento",
"reg.lblAuctioned": "listado em leilão",
"reg.lblAuctionedShort": "leiloado",
"reg.lblAuthorities": "entregue às autoridades",
"reg.lblDestroyed": "destruído",
"reg.lblDonated": "doado a uma instituição de caridade",
"reg.legalCount": "{n} item(s): período legal de retenção alcançado",
"reg.legalHint": "Você pode listá-los em leilão, doá-los a uma instituição de caridade ou relatar a entrega às autoridades.",
"reg.legalLimitCountry": "Prazo: {date} · país aplicado: {country}",
"reg.legalOver": "Prazo ultrapassado: {date} · {country}",
"reg.legalReached": "Período legal alcançado",
"reg.legalReachedFull": "Período legal de retenção alcançado",
"reg.limitShort": "prazo",
"reg.location": "Localização",
"reg.markRestituted": "Marcar como retornado",
"reg.markedAs": "Item marcado como {label}",
"reg.moveHistory": "Histórico de movimentação",
"reg.overBy": "ultrapassado por {n}d",
"reg.physicalLocation": "Localização física",
"reg.popupBlocked": "Permita pop-ups para imprimir os rótulos.",
"reg.popupBlockedOne": "Permita pop-ups para imprimir o rótulo.",
"reg.printLabel": "Imprimir o rótulo",
"reg.printN": "Imprimir {n} rótulo(s)",
"reg.qrCodeItem": "QR code do item",
"reg.qrLabelTitle": "Rótulo QR",
"reg.qrLabelsTitle": "Rótulos QR",
"reg.qrNotFound": "Nenhum item encontrado para este QR code.",
"reg.qrScanHint": "Escaneie para abrir este registro diretamente e encontrar a localização.",
"reg.recoveryFee": "Taxa de recuperação (€)",
"reg.searchPh": "Buscar por descrição…",
"reg.selectQr": "Selecionar para imprimir rótulos QR",
"reg.selectedN": "{n} selecionado(s)",
"reg.shipPricePh": "Preço de envio (€)",
"reg.shippingPossible": "Envio disponível",
"reg.storagePh": "ex. Prateleira A3, Armário 12",
"reg.tAuction": "Leilão no Findloop",
"reg.tAuthorities": "Relatar entrega às autoridades",
"reg.tDonate": "Doar a uma instituição de caridade",
"reg.toastFee": "Taxa atualizada",
"reg.toastLocation": "Localização salva",
"reg.toastRestituted": "Item marcado como retornado",
"reg.toastShipping": "Opção de envio atualizada",
"reg.toastTransferred": "Item transferido para “{name}”",
"reg.unclaimedDisposition": "Item não reclamado — disposição final",
"res.codeValidated": "Código validado",
"res.empty": "Nenhuma restituição registrada ainda.",
"res.error": "Erro {status}",
"res.proofPdf": "PDF de prova",
"res.signed": "Assinado",
"res.stRestituted": "Entregue pessoalmente",
"res.stShipped": "Devolvido por envio",
"res.subtitle": "Todas as entregas concluídas, com sua prova assinada para download.",
"res.title": "Histórico de restituição",
"rev.restitutedBy": "Retornado por {org}",
"rev.storiesEyebrow": "Final feliz",
"rev.storiesSubtitle": "Histórias reais de clientes que recuperaram seus pertences com findloop.",
"rev.storiesTitle": "Eles encontraram seus pertences!",
"rp.duplicate": "Duplicado",
"rp.inappropriate": "Conteúdo inadequado",
"rp.wrongCategory": "Categoria errada",
"rt.annualGoal": "Meta anual",
"rt.championCity": "Cidade campeã",
"rt.cityRate": "{rate}% taxa de retorno",
"rt.goalProgress": "{rate}% alcançado de uma meta de {target}%",
"rt.reached": "Alcançado 🎉",
"rt.restitutionRate": "Taxa de retorno",
"rt.shareRecap": "Compartilhar meu resumo",
"rt.thanks": "Obrigado Findloop {year} 💛",
"rt.yourRecap": "Seu resumo de {year}",
"rw.active": "Ativo",
"rw.add": "Adicionar",
"rw.camUnavailable": "Câmera indisponível. Digite o código manualmente abaixo.",
"rw.codeValidated": "Código validado",
"rw.codesTitle": "Códigos resgatados por finders",
"rw.confirmDelete": "Excluir “{title}”? ",
"rw.deleted": "Excluído",
"rw.edit": "Editar",
"rw.editReward": "Editar a recompensa",
"rw.empty": "Nenhuma recompensa ainda.",
"rw.expired": "Expirado",
"rw.expiresOn": "Expira em {date}",
"rw.fActive": "Ativo (visível para finders)",
"rw.fCost": "Custo (pontos)",
"rw.fDesc": "Descrição",
"rw.fStock": "Estoque (vazio = ilimitado)",
"rw.fTitle": "Título",
"rw.fValidity": "Validade do voucher (dias após o resgate)",
"rw.inactive": "Inativo",
"rw.newReward": "Nova recompensa",
"rw.noExchange": "Nenhum resgate ainda.",
"rw.pageSubtitle": "Escaneie os vouchers apresentados pelos finders para validar suas recompensas.",
"rw.redeemedN": "Resgatado: {n}×",
"rw.saved": "Recompensa salva",
"rw.scanVoucher": "Escanear um voucher",
"rw.staffScanOnly": "Escanear apenas",
"rw.statActive": "A apresentar",
"rw.statExpired": "Expirado",
"rw.statRedeemed": "Vouchers resgatados",
"rw.statUsed": "Validado",
"rw.stock": "Estoque",
"rw.subtitle": "Ofereça benefícios não monetários (vouchers, melhorias…) que os finders resgatem por seus pontos de Finder Score.",
"rw.title": "Recompensas para finders",
"rw.used": "Usado",
"rw.validate": "Validar",
"rw.validateCode": "Validar o código",
"rw.validity": "Validade: {n} d",
"side.establishments": "Estabelecimentos",
"side.restitutions": "Devoluções",
"side.storage": "Armazenamento & QR",
"status.auctioned": "Leiloado",
"status.destroyed": "Destruído",
"status.donated": "Doado (caridade)",
"status.handed_to_authorities": "Entregue às autoridades",
"status.in_storage": "Em armazenamento",
"status.matched": "Correspondência",
"status.open": "Aberto",
"status.paid": "Pago",
"status.pending": "Pendente",
"status.restituted": "Devolvido",
"status.shipped": "Enviado",
"status.shipping_requested": "Envio solicitado",
"status.submitted": "Enviado",
"stg.allLabels": "Todos os rótulos QR",
"stg.camHint": "Use a entrada manual abaixo.",
"stg.camStarting": "Iniciando a câmera…",
"stg.camUnavailable": "Câmera indisponível.",
"stg.clear": "Limpar",
"stg.clearAll": "Limpar tudo",
"stg.codeUnreadable": "Código ilegível.",
"stg.emptyDesc": "Os itens armazenados aparecerão aqui, agrupados por localização.",
"stg.emptyTitle": "Nenhum item no armazenamento",
"stg.exportAudit": "Exportar auditoria CSV",
"stg.exportDone": "Exportação CSV concluída",
"stg.exportImpossible": "Exportação indisponível no momento.",
"stg.itemFound": "Item encontrado ✅",
"stg.kLocations": "Locais utilizados",
"stg.kObjects": "Itens armazenados",
"stg.kToClear": "Locais para limpar",
"stg.locFreed": "Local limpo",
"stg.locsFreed": "{n} local(is) limpo(s)",
"stg.manualLabel": "Ou insira o código / ID do item",
"stg.manualPh": "Cole o ID ou URL do QR",
"stg.noItemMatch": "Nenhum item corresponde a este QR / código.",
"stg.noLocation": "Nenhuma localização",
"stg.objectsAxis": "Itens",
"stg.objectsN": "{n} item(s)",
"stg.occAvg": "média {n} itens/local",
"stg.occHint": "Locais em âmbar excedem a média (potencialmente sobrecarregados).",
"stg.occupancy": "Ocupação do local",
"stg.openPage": "Abrir a página",
"stg.posterPdf": "Pôster em PDF (A4)",
"stg.printAll": "Imprimir tudo",
"stg.printGroupTitle": "Imprimir rótulos para esta prateleira",
"stg.qrAlt": "QR de autoatendimento",
"stg.qrDownload": "Baixar o QR",
"stg.qrHint": "Exiba este QR no balcão: seus clientes escaneiam para verificar se seu item está disponível.",
"stg.qrTitle": "QR de autoatendimento para o cliente",
"stg.scanDesc": "Escaneie o rótulo de um item para abrir seu registro instantaneamente.",
"stg.scanQr": "Escanear um QR",
"stg.scanTitle": "Escanear um código QR",
"stg.search": "Pesquisar",
"stg.shelf": "Prateleira {loc}",
"stg.shelfPlan": "Plano da prateleira",
"stg.staleHint": "Limpe esses locais para manter seu inventário físico atualizado.",
"stg.staleTitle": "{n} item(ns) saíram do armazenamento, mas ainda mantêm uma localização",
"stg.subtitle": "Plano da prateleira, scanner QR e rastreamento de inventário físico.",
"stg.title": "Armazenamento & QR",
"stt.acceptRate": "Taxa de aceitação",
"stt.accepted": "Aceito",
"stt.activity30": "Atividade (últimos 30 dias)",
"stt.ai6mo": "Últimos 6 meses · aceito = emparelhado automaticamente + confirmado.",
"stt.aiEmpty": "Sem correspondências de IA neste período ainda.",
"stt.aiTitle": "Correspondências de IA — aceito vs rejeitado",
"stt.auctionShort": "Leilão",
"stt.auctionedSold": "Leiloado (vendido)",
"stt.authShort": "Autoridades",
"stt.authorities": "Entregue às autoridades",
"stt.avgRating": "Avaliação média",
"stt.awaitingRestitution": "itens aguardando devolução",
"stt.boostClicks": "Cliques no seu diretório esta semana graças ao boost",
"stt.boostInactive": "Boost inativo — ative-o para ganhar visibilidade",
"stt.certifiedPremium": "Premium certificado",
"stt.declarations": "Declarações",
"stt.destroyed": "Destruído",
"stt.dispoEmpty": "Nenhum item não reclamado saiu do armazenamento ainda.",
"stt.donatedAssoc": "Doado (caridade)",
"stt.donatedShort": "Doado",
"stt.gateCta": "Descubra os planos",
"stt.gateDesc": "Faça upgrade para Starter para desbloquear suas estatísticas básicas, ou para Business para estatísticas avançadas e análise por estabelecimento.",
"stt.gateTitle": "Estatísticas reservadas para planos pagos",
"stt.inStorage": "No armazenamento",
"stt.kItems": "Itens registrados",
"stt.kRate": "Taxa de devolução",
"stt.kRestituted": "Itens retornados",
"stt.kRevenue": "Receita (mês)",
"stt.noDeclYet": "Nenhuma declaração ainda.",
"stt.recapDownloaded": "Recapitulação baixada — pronta para compartilhar!",
"stt.recapError": "Não foi possível gerar a recapitulação",
"stt.recapText": "Nossa recapitulação Findloop {year}: itens retornados e satisfação do cliente 🎉",
"stt.recapTitle": "recap Findloop {year}",
"stt.rejected": "Rejeitado",
"stt.restitutions": "Devoluções",
"stt.shareRecap": "Compartilhar minha recapitulação {year}",
"stt.topCategories": "Categorias mais declaradas",
"stt.unclaimedDesc": "Volume de itens destruídos, doados a instituições de caridade e leiloados, por categoria.",
"stt.unclaimedTitle": "Itens não reclamados — saindo do armazenamento",
"stt.vsLastWeek": "vs semana passada",
"sub.cancel": "Cancelar minha assinatura",
"sub.cancelAbort": "Cancelar",
"sub.cancelConfirm1": "Tem certeza de que deseja cancelar? Seu acesso permanecerá ativo até",
"sub.cancelConfirm2": "Nenhum reembolso será emitido.",
"sub.cancelConfirmBtn": "Confirmar cancelamento",
"sub.cancelTitle": "Cancelar sua assinatura",
"sub.cancelledToast": "Cancelamento registrado.",
"sub.cguAnd": "e o",
"sub.cguDesc": "Por favor, confirme sua aceitação antes do pagamento.",
"sub.cguLink": "Termos de Uso",
"sub.cguPay": "Continuar para pagamento",
"sub.cguPre": "Li e aceito o",
"sub.cguRequired": "Você deve aceitar os Termos de Uso e a Política de Privacidade para continuar.",
"sub.cguSuffix": "do findloop.",
"sub.cguTitle": "Finalize sua assinatura",
"sub.expiresOn": "Sua assinatura expira em",
"sub.noProrata": "Sem reembolso proporcional.",
"sub.privacyLink": "Política de Privacidade",
"sub.renewsOn": "Sua assinatura renova em",
"sub.resume": "Reassinar",
"sub.resumedToast": "Reassociação confirmada.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Business",
"tier.small": "Starter",
"tm.add": "Adicionar",
"tm.adminOpt": "Admin (vista completa)",
"tm.chooseEst": "Escolha um estabelecimento",
"tm.chooseEstPh": "Escolha um estabelecimento",
"tm.copyFail": "Falha ao copiar",
"tm.copyLink": "Copiar o link",
"tm.copyOk": "Link de convite copiado",
"tm.emailHint": "Um e-mail de convite será enviado para criar a senha.",
"tm.expiresOn": "expira em {date}",
"tm.forEmail": " para {email}",
"tm.forbidden": "A gestão de equipe é reservada para o proprietário da conta.",
"tm.inviteCreated": "Convite criado",
"tm.inviteDesc": "Um e-mail de convite permite que o membro da equipe crie sua senha.",
"tm.invitePending": "Convite pendente",
"tm.inviteResent": "Convite reenviado",
"tm.inviteSent": "Convite enviado por e-mail",
"tm.inviteTitle": "Convide um membro",
"tm.invitedOn": "Convidado em {date}",
"tm.linkExpired": "Link expirado",
"tm.memberRemoved": "Membro removido",
"tm.name": "Nome",
"tm.noMembers": "Nenhum membro da equipe ainda.",
"tm.resendTitle": "Reenviar o convite",
"tm.role": "Função",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Proprietário",
"tm.roleStaff": "Funcionário",
"tm.roleUpdated": "Função atualizada",
"tm.sendInvite": "Enviar o convite",
"tm.sending": "Enviando…",
"tm.staffOpt": "Funcionário (vê apenas seu estabelecimento)",
"trk.carrier": "Transportadora",
"trk.shipPending": "Envio sendo preparado — o número de rastreamento aparecerá aqui assim que enviado.",
"trk.shipTitle": "Rastreamento de envio",
"trk.trackShipment": "Rastrear pacote",
"trk.trackingNo": "Número de rastreamento",
"a.firstName": "Nome",
"ac.emailCrossMatch": "Correspondências B2C",
"ac.emailCrossMatchDesc": "Um email quando um anúncio público de item perdido corresponde a um item depositado em suas dependências",
"ac.emailCrossReject": "Rejeições de correspondências públicas",
"ac.emailCrossRejectDesc": "Receba um email quando um cliente indicar que uma correspondência pública sugerida não é o seu item.",
"ac.emailLoginNotif": "Notificação de login",
"ac.emailLoginNotifDesc": "Receba um email cada vez que alguém acessar sua conta.",
"ad.closeNoCancel": "Não, remover a listagem",
"ad.closeQuestion": "O item foi devolvido a você?",
"ad.closeQuestionDesc": "Nos avise se você recuperou seu item ou se simplesmente deseja remover esta listagem.",
"ad.closeYesRestituted": "Sim, o item foi devolvido",
"ad.closedRestituted": "Item devolvido — listagem fechada 🎉",
"an.lostLoginDesc": "Uma conta é necessária para relatar um item perdido e acompanhar seu retorno.",
"an.lostLoginRequired": "Faça login para relatar um item perdido",
"an.qfAll": "Todos",
"an.qfBoosted": "Impulsionados",
"an.qfPhoto": "Com foto",
"an.qfRecent": "Esta semana",
"an.qfResolved": "Resolvido",
"an.restitutionInProgress": "Item sendo devolvido",
"dec.descPhLong": "Descreva o item: marca, cor, marcas distintivas… (Quanto mais detalhes você der, maiores são suas chances de recuperar seu item)",
"dec.loadError": "Não foi possível carregar o parceiro no momento. Verifique sua conexão e tente novamente.",
"dec.retry": "Tentar novamente",
"dec.shippingMode": "Envio",
"dep.photo2": "2ª foto do item",
"dep.photo2Hint": "Opcional — outro ângulo melhora a precisão da correspondência visual.",
"dl.accountSuspended": "Conta suspensa por fatura não paga. Regularize para restaurar seu acesso.",
"dl.regularize": "Regularizar agora →",
"dl.suspensionCountdown": "Fatura {num} não paga — sua conta será suspensa em {days} dia(s). Regularize para evitar isso.",
"ft.cancelConfirm": "Cancelar seu relatório? O proprietário do item será informado.",
"ft.cancelDone": "Relatório cancelado.",
"ft.cancelLocked": "O cancelamento não é mais possível após o proprietário ter pago.",
"ft.cancelReport": "Cancelar meu relatório",
"ft.claimCodeHelp": "Dê este código ao encontrador na entrega para confirmar que você recebeu seu item.",
"ft.claimCodeTitle": "Seu código de restituição",
"ft.claimDone": "Item devolvido. Obrigado por usar Findloop!",
"ft.claimUnlockHint": "Desbloquear os detalhes de contato do encontrador",
"ft.claimUnlockHintSub": "Vá para \"Itens que estou reivindicando\" em sua conta para pagar a taxa e obter os detalhes de contato.",
"ft.finderCodeShownHelp": "O proprietário pagou e selecionou você. Copie este código abaixo para confirmar a devolução — não é necessário verificar seu email.",
"ft.finderCodeShownTitle": "Código de validação do proprietário",
"ft.finderContactsTitle": "Detalhes de contato do Finder",
"ft.foundCodeHelp": "Mostre este código ao proprietário na entrega para confirmar que o item foi devolvido.",
"ft.inProgressOther": "Item sendo devolvido",
"ft.inProgressOtherHelp": "O proprietário selecionou outro finder para este item. Nenhuma ação adicional é necessária da sua parte.",
"ft.restitutionCodeHelp": "Este código confirma a entrega do item. Está pré-preenchido abaixo; valide-o e feche o caso.",
"ft.restitutionCodeTitle": "Seu código de restituição",
"hc.14Digits": "14 dígitos",
"hc.15DaysBeforeAnItem": "15 dias antes do prazo legal de um item.",
"hc.7DaysBeforeAnItem": "7 dias antes do prazo legal de um item.",
"hc.8CharactersMinimum": "Mínimo de 8 caracteres.",
"hc.aClaimToValidate": "Uma reclamação para validar",
"hc.aFindoAssistanceSessionIs": "Uma sessão de assistência Findloop está atualmente ativa na sua conta.",
"hc.aNewMatchHasBeen": "Uma nova correspondência foi encontrada",
"hc.aUser": "Um usuário",
"hc.aUserClaimsToBe": "Um usuário afirma ser o proprietário. Verifique suas respostas antes de autorizar a devolução.",
"hc.aboutFindo": "Sobre Findloop",
"hc.accountActivatedPleaseLogIn": "Conta ativada, por favor faça login.",
"hc.accountActivation": "Ativação da conta",
"hc.accountCreated": "Conta criada!",
"hc.accountDeactivatedAReactivationEmail": "Conta desativada. Um e-mail de reativação (válido por 30 dias) foi enviado a você.",
"hc.accountReactivation": "Reativação da conta",
"hc.activateMyAccount": "Ativar minha conta",
"hc.activateMyAdminAccount": "Ativar minha conta de administrador",
"hc.activating": "Ativando…",
"hc.activeMatchCancelReason": "Correspondência ativa. Motivo de cancelamento do cliente: \"{reason}\". O item ainda está aguardando uma reclamação.",
"hc.activeMatchWithAPublic": "Correspondência ativa com uma lista pública (cliente). Aguardando a reclamação do proprietário.",
"hc.addAPhoto": "Adicionar uma foto",
"hc.addAndConfigureYourEstablishments": "Adicione e configure seus estabelecimentos em \"Estabelecimentos\": detalhes de contato, categoria e armazenamento físico dos itens.",
"hc.addOnGoogle": "Adicionar no Google",
"hc.address": "Endereço",
"hc.addressSaved": "Endereço salvo",
"hc.addressStreet": "Endereço — Rua",
"hc.adjustThePhoto": "Ajustar a foto",
"hc.adminFullView": "Admin (visão completa)",
"hc.administratorOnly": "Somente administrador",
"hc.africa": "África",
"hc.aiVisualComparison": "Comparação visual por IA",
"hc.all": "Todos",
"hc.amount": "Valor",
"hc.anOrganization": "Uma organização",
"hc.analyzing": "Analisando…",
"hc.andRecoveryIs": "e a recuperação é",
"hc.andTheDeclarationWillBe": "e a declaração será fechada (movida para o histórico). Esta ação é final.",
"hc.annual20": "Anual -20%",
"hc.annualBilling20": "Faturamento anual (−20%)",
"hc.annualTarget": "Meta anual",
"hc.anyCommentsOptional": "Algum comentário? (opcional)",
"hc.approveTheClaim": "Aprovar a reclamação",
"hc.archiveCancelledConfirm": "Arquivar {n} listagem(s) \"Cancelado pelo cliente\"? Elas serão removidas do registro.",
"hc.asSoonAs": "Assim que",
"hc.askTheOwnerToDisplay": "Peça ao proprietário para exibir o QR do seu código (página de rastreamento).",
"hc.askThemAtTheCounter": "Pergunte a eles no balcão para confirmar a identidade — nunca visível publicamente.",
"hc.assistance": "Suporte",
"hc.assistanceSessionRevoked": "Sessão de assistência revogada.",
"hc.atLeast6Characters": "Pelo menos 6 caracteres",
"hc.automaticallyPreSelected": "pré-selecionado automaticamente",
"hc.automaticallyWhenShipping": "automaticamente ao enviar.",
"hc.awaitingClaim": "Aguardando reclamação",
"hc.awaitingPayment": "Aguardando pagamento",
"hc.b2cCustomer": "Cliente B2C",
"hc.back": "Voltar",
"hc.backToHome": "Voltar para a página inicial",
"hc.backToMyAccount": "Voltar para minha conta",
"hc.backToPayment": "Voltar para o pagamento",
"hc.beforeAfterComparisonSlider": "Deslizante de comparação antes/depois",
"hc.billingInformation": "Informações de faturamento",
"hc.billingInformationSaved": "Informações de faturamento salvas ✓",
"hc.brand": "Marca",
"hc.bronze": "Bronze",
"hc.calculatingTheShippingRate": "Calculando a taxa de envio…",
"hc.cameraUnavailableEnterTheCode": "Câmera indisponível. Insira o código manualmente.",
"hc.cancel": "Cancelar",
"hc.cancelMyDeclaration": "Cancelar minha declaração",
"hc.cancelSavedFmt": "Cancelamento salvo: \"{reason}\". Você ainda pode reclamar.",
"hc.cancelTheDeposit": "Cancelar o depósito",
"hc.cancelThisMatch": "Cancelar esta partida",
"hc.cancellationReason": "Razão do cancelamento",
"hc.cancelled": "Cancelado",
"hc.cancelledByTheCustomer": "Cancelado pelo cliente",
"hc.cannotOpenPayment": "Não foi possível abrir o pagamento. Por favor, tente novamente.",
"hc.careers": "Carreiras",
"hc.carrier": "Transportadora",
"hc.carrierAvailabilityCannotBeChecked": "A disponibilidade da transportadora não pode ser verificada até que seu remetente do Sendcloud esteja configurado.",
"hc.carrierConfirmedCharged": "Transportadora confirmada — {price} € cobrado do cliente",
"hc.carrierOther": "Transportadora (outra)",
"hc.carrierSelection": "Seleção da transportadora",
"hc.caseClosedThankYou": "Caso encerrado. Obrigado!",
"hc.category": "Categoria",
"hc.changeMethod": "Alterar método",
"hc.characteristic": "Características",
"hc.chargedToCustomer": "cobrado do cliente.",
"hc.checkOrEditYourDetails": "Verifique ou edite seus detalhes antes do pagamento seguro.",
"hc.checkStatisticsToTrackDeposited": "Verifique \"Estatísticas\" para acompanhar os itens depositados, taxa de retorno e desempenho de cada estabelecimento.",
"hc.checkTheDetailsBeforeContacting": "Verifique os detalhes antes de contatar o localizador.",
"hc.checkTheDetailsBelowBefore": "Verifique os detalhes abaixo antes de iniciar seu pedido de devolução.",
"hc.checkTheNewItem": "Verifique o novo item",
"hc.checkThePhotosAndCharacteristics": "Verifique as fotos e características abaixo antes de prosseguir com a recuperação.",
"hc.chooseACountry": "Escolha um país",
"hc.chooseANewPassword": "Escolha uma nova senha",
"hc.chooseAReason": "Escolha uma razão",
"hc.chooseTheLegalRetentionAlerts": "Escolha os alertas de retenção legal recebidos por e-mail para",
"hc.chooseYourPasswordToAccess": "Escolha sua senha para acessar o console de administração.",
"hc.city": "Cidade",
"hc.claimApproved": "Reclamação aprovada",
"hc.claimApproved2": "Reclamação aprovada.",
"hc.claimCodeExpired": "Código da reclamação expirado",
"hc.claimCodeVerified": "Código da reclamação verificado",
"hc.claimNotFound": "Reclamação não encontrada",
"hc.claimNotValidated": "Reclamação não validada",
"hc.claimRejected": "Reclamação rejeitada",
"hc.claimRejected2": "Reclamação rejeitada.",
"hc.claimValidated": "Reclamação validada",
"hc.claimValidatedByThePartner": "Reclamação validada pelo parceiro",
"hc.claimant": "Reclamante",
"hc.claimsToBeTheOwner": "declara ser o proprietário deste item e respondeu às perguntas de verificação. Apenas aprove se as respostas coincidirem.",
"hc.claimsToValidate": "Reclamações a validar",
"hc.clear": "Limpar",
"hc.clickToZoom": "Clique para ampliar",
"hc.close": "Fechar",
"hc.close2": "Fechar",
"hc.closeTheDeclaration": "Fechar a declaração",
"hc.closeTheDeclaration2": "Fechar a declaração?",
"hc.codeAlreadyVerified": "Código já verificado",
"hc.codeCopied": "Código copiado",
"hc.collapse": "Colapsar",
"hc.color": "Cor",
"hc.company": "Empresa",
"hc.companyName": "Nome da empresa",
"hc.comparePhotos": "Comparar fotos",
"hc.compareThemWithTheOwner": "Compare com as respostas do proprietário — nunca visíveis publicamente.",
"hc.condition": "Condição",
"hc.confirmAndPay": "Confirmar e pagar",
"hc.confirmCancellation": "Confirmar cancelamento",
"hc.confirmCrop": "Confirmar corte",
"hc.confirmDeletion": "Confirmar exclusão",
"hc.confirmPassword": "Confirmar senha",
"hc.confirmThatThisIsYour": "Confirme que este é o seu item. Uma verificação de identidade será solicitada ao encontrador antes de qualquer contato.",
"hc.confirmTheCarrier": "Confirmar o transportador",
"hc.confirmThePassword": "Confirmar a senha",
"hc.confirmYourShippingAddressTo": "Confirme seu endereço de entrega para continuar com o pagamento.",
"hc.confirmYourSubscription": "Confirme sua assinatura",
"hc.confirmed": "Confirmado ✓",
"hc.contactFindoToGetYour": "Entre em contato com a Findloop para obter seu ID de Remetente.",
"hc.contactUs": "Contate-nos",
"hc.continueTheReturn": "Continuar com a devolução",
"hc.continueToPayment": "Continuar para pagamento",
"hc.copy": "Copiar",
"hc.correctMyDetails": "corrigir meus dados",
"hc.correctThisEntry": "Corrigir esta entrada?",
"hc.country": "País",
"hc.countryAddress": "País (endereço)",
"hc.countryIsoCodeEG": "País (código ISO, ex. FR)",
"hc.cover": "capa",
"hc.createTheShipment": "Criar o envio",
"hc.cropThePhoto": "Recortar a foto",
"hc.customer": "Cliente",
"hc.customerClaimCodeToCheck": "Código de reclamação do cliente — para verificar na coleta:",
"hc.customerReasonFmt": "Motivo do cliente: \"{reason}\".",
"hc.customerReminderDelay": "Atraso do lembrete do cliente",
"hc.customerWhosePublicListingMatches": "Cliente cuja lista pública corresponde a este item — visível apenas para você.",
"hc.d15": "D-15",
"hc.dangerZone": "Zona de perigo",
"hc.date": "Data",
"hc.dateNewest": "Data (mais recente)",
"hc.dateOldest": "Data (mais antiga)",
"hc.daysToYearEnd": "{n} dias até o fim do ano",
"hc.deadlineAlert": "Alerta de prazo",
"hc.declarationClosed": "Declaração fechada ✓",
"hc.declarationNotFound": "Declaração não encontrada.",
"hc.declarationNotFound2": "Declaração não encontrada",
"hc.declarationTracking": "Rastreamento da declaração",
"hc.defaultCarrier": "Transportadora padrão",
"hc.defaultCarrierPreselected": "Transportadora padrão pré-selecionada — pode ser alterada para este envio. Tarifa atual (Sendcloud + {m}% de margem).",
"hc.defaultCarrierRemoved": "Transportadora padrão removida",
"hc.delayHours": "Atraso (horas)",
"hc.deleteMyAccount": "Excluir minha conta",
"hc.deleting": "Excluindo…",
"hc.deletingDeactivatesYourAccountLogin": "Excluir desativa seu acesso: o login é bloqueado e os dados são mantidos por 30 dias. Você receberá um e-mail com um link de reativação válido por 30 dias.",
"hc.delivered": "Entregue",
"hc.depositAnItem": "Depositar um item",
"hc.depositCancelledItemPutBack": "Depósito cancelado — item colocado de volta no estoque.",
"hc.depositCancelledItemRemovedFrom": "Depósito cancelado — item removido do registro.",
"hc.depositedOn": "Depositado em",
"hc.describeTheItemBrandColor": "Descreva o item: marca, cor, marcas distintivas… (Quanto mais detalhes você fornecer, melhores serão suas chances de encontrar seu item)",
"hc.dimensionsCm": "Dimensões (cm)",
"hc.disablingAnEmail": "Desativando um e-mail",
"hc.doesNotHide": "não oculta",
"hc.download": "Baixar",
"hc.downloadThePdf": "Baixar o PDF",
"hc.draftRestoredPickUpYour": "Rascunho restaurado — pegue sua declaração de onde parou.",
"hc.dragToReposition": "Arraste para reposicionar",
"hc.eGColisPriv": "Ex.: Colis Privé",
"hc.eachItemGetsAQr": "Cada item recebe um rótulo QR. Escaneie-o de \"Armazenamento & QR\" para localizar um item instantaneamente.",
"hc.eachSiteManagesItsOwn": "Cada site gerencia seu próprio banco. Vá para",
"hc.edit": "Editar",
"hc.emailNotificationPreferences": "Preferências de notificação por e-mail",
"hc.emailPreferencesUpdated": "Preferências de e-mail atualizadas",
"hc.enableOrDisableRecoveryFees": "Ativar ou desativar taxas de recuperação para",
"hc.enlargePhoto": "Ampliar foto",
"hc.enterTheCustomerSCode": "Insira o código do cliente",
"hc.estShipRate": "Taxa de envio estimada (Sendcloud + {m}% de margem):",
"hc.establishment": "Estabelecimento",
"hc.establishment2": "Estabelecimento:",
"hc.establishmentInItsSendcloudAccount": "estabelecimento na sua conta Sendcloud e fornece o ID do remetente",
"hc.establishmentSettings": "Configurações do estabelecimento",
"hc.exCode": "ex: ABCD2345",
"hc.exId": "ex: 3f2a…",
"hc.exit": "Sair",
"hc.explainWhyThisItemIs": "Explique por que este item não é seu…",
"hc.externalPaymentLinks": "Links de pagamento externos",
"hc.failed": "Falhou",
"hc.feesEnabled": "Taxas habilitadas",
"hc.field": ") campo.",
"hc.finderAcceptedCloseTheCase": "Finder aceitou — feche o caso uma vez que o item foi entregue pessoalmente.",
"hc.findoCityRanking": "Findloop — Ranking de cidades",
"hc.findoForEstablishments": "Findloop para estabelecimentos",
"hc.findoPresentationVideo": "vídeo de apresentação da Findloop",
"hc.findoRegistersTheAddressOf": "Findloop registra o endereço do seu",
"hc.findoReviewShare": "avaliação Findloop {year}: {n} itens retornados, {rate}% taxa de retorno 🎉",
"hc.firstVerifyTheClaimCode": "Primeiro, verifique o código de reivindicação acima",
"hc.forEveryNewShipmentFrom": "para cada novo envio de",
"hc.free": "grátis",
"hc.freeRecovery0": "Recuperação gratuita (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Recuperação gratuita em toda a África – Oferta de lançamento",
"hc.freeRecoveryFeesDisabled0": "Recuperação gratuita: taxas desativadas (0 €)",
"hc.fromTeamInviteYourColleagues": "De \"Equipe\", convide seus colegas por e-mail e atribua a eles um estabelecimento. Cada membro vê apenas seu próprio escopo.",
"hc.fullName": "Nome completo",
"hc.fullPhoto": "Foto completa",
"hc.gallery": "Galeria",
"hc.giveTheReasonForCancelling": "Dê o motivo para o cancelamento. O parceiro será informado.",
"hc.goToLogin": "Ir para o login",
"hc.goToMyAccount": "Ir para minha conta",
"hc.gold": "Ouro",
"hc.googleLoginFailed": "Falha no login do Google",
"hc.hasConfirmedYourPaymentYou": "confirmou seu pagamento, você será redirecionado automaticamente",
"hc.helpCenter": "Central de ajuda",
"hc.helpUsImproveWhyAre": "Ajude-nos a melhorar: por que você está saindo? Sua conta será desativada e poderá ser reativada por 30 dias.",
"hc.hidePassword": "Ocultar senha",
"hc.high": "Alto",
"hc.historyOfYourMonthlySubscriptions": "Histórico de suas assinaturas mensais e seu status de pagamento.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Como configuro meu ID de remetente numérico?",
"hc.iDonTUseIt": "Eu não uso o suficiente",
"hc.iFoundItElsewhere": "Eu encontrei em outro lugar",
"hc.iNoLongerNeedMy": "Eu não preciso mais do meu item",
"hc.identityVerification": "Verificação de identidade",
"hc.idleLogoutIn": "Você será desconectado em {n} s devido à inatividade.",
"hc.ifProvidedTheVolumetricWeight": "Se fornecido, o peso volumétrico é usado.",
"hc.ifThePartnerHasNot": "Se o parceiro não confirmou o recebimento do pagamento externo após esse prazo, a Findloop automaticamente lembra o parceiro de validá-lo.",
"hc.impersonationEnded": "Imitação encerrada.",
"hc.impersonationMode": "Modo de imitação",
"hc.impersonationSessionExpired": "Sessão de imitação expirada.",
"hc.inTheField": ", no campo",
"hc.inTransit": "Em trânsito",
"hc.inclVat": "incl. IVA",
"hc.intraEuVatNumberOptional": "Número de IVA intra-UE opcional, sem SIRET necessário (fora da França).",
"hc.invalidInvitationLink": "Link de convite inválido.",
"hc.invalidInvitationLink2": "Link de convite inválido",
"hc.invalidInviteLink": "Link de convite inválido ou expirado.",
"hc.invalidNumberEnterAnInternational": "Número inválido. Insira um número internacional, ex. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Link inválido ou expirado.",
"hc.invalidOrExpiredReactivationLink": "Link de reativação inválido ou expirado",
"hc.invalidSendcloudId": "ID do Sendcloud inválido",
"hc.inviteSubtitle": "{org} convida você a se juntar à sua equipe findloop. Escolha sua senha para ativar sua conta.",
"hc.isAvailableOnSendcloudFor": "está disponível no Sendcloud para todas as suas rotas (nacional + internacional).",
"hc.isNotEnabledOnYour": "não está habilitado na sua conta do Sendcloud para alguns destinos. As etiquetas para esses serão geradas com outro transportadora disponível.",
"hc.isThisReallyYourItem": "Este é realmente seu item?",
"hc.isThisYourItem": "Este é seu item?",
"hc.item": "Item",
"hc.itemAlreadyConfirmed": "Item já confirmado",
"hc.itemDetails": "Detalhes do item",
"hc.itemFoundAt": "Item encontrado em",
"hc.itemFoundAtAPartner": "Item encontrado em um parceiro",
"hc.itemMarkedAsReturned": "Item marcado como devolvido ✓",
"hc.itemPhotoRequiredBeforeShipping": "Foto do item (obrigatória antes do envio)",
"hc.itemPhotoSaved": "Foto do item salva",
"hc.itemPreview": "Prévia do item",
"hc.itemPutBackInStorage": "Item devolvido ao armazenamento.",
"hc.itemWeight": "Peso do item:",
"hc.itemsReturned": "item(s) devolvido(s)",
"hc.itemsReturnedThisYear": "itens retornados este ano",
"hc.itemsWhoseLegalDeadlineIs": "Itens cujo prazo legal é de 15 dias ou menos (incluindo vencidos). Os matches permanecem visíveis.",
"hc.kbisNumber": "Número Kbis",
"hc.keysForgottenOnABench": "Chaves esquecidas em um banco",
"hc.labelBeingGenerated": "Etiqueta sendo gerada",
"hc.leaveTheFieldsEmptyTo": "Deixe os campos vazios para oferecer recuperação gratuita.",
"hc.legalNotice": "Aviso legal",
"hc.limitReachedUpgradeToA": "Limite alcançado — faça upgrade para um plano superior",
"hc.linkCopiedShareOn": "Link copiado — compartilhe em {label}",
"hc.linkUnavailable": "Link indisponível",
"hc.linkedTo": "Vinculado a",
"hc.listingHiddenByModeration": "Anúncio oculto pela moderação.",
"hc.loading": "Carregando…",
"hc.locateMe": "Localizar-me",
"hc.logIn": "Fazer login",
"hc.logInToGetBack": "Faça login para retornar ao seu espaço e gerenciar sua assinatura.",
"hc.loginFailed": "Falha no login",
"hc.lostFoundPlatform": "Plataforma de achados e perdidos.",
"hc.lostIn": "perdido em",
"hc.lowRate": "Baixa taxa",
"hc.mainReason": "Principal razão",
"hc.mainStreet": "Rua Principal",
"hc.makeSureThisIsThe": "Certifique-se de que este é o item que você perdeu antes de desbloquear os detalhes de contato do encontrador.",
"hc.manageCookies": "Gerenciar cookies",
"hc.manageMyTeam": "Gerenciar minha equipe",
"hc.manageYourTeam": "Gerenciar sua equipe",
"hc.markAsReturned": "Marcar como retornado",
"hc.matchNoClaimInTime": "O match não recebeu nenhuma reclamação dentro do prazo.",
"hc.matchNotFound": "Match não encontrado",
"hc.medium": "Médio",
"hc.milestoneFmt": "{m} itens retornados atingidos! Rumo a {next}.",
"hc.missingFeatures": "Recursos ausentes",
"hc.monthly": "Mensal",
"hc.monthlyBilling": "Cobrança mensal",
"hc.moveThePhotoToFit": "Mova a foto para ajustá-la no círculo.",
"hc.myAccount": "Minha conta",
"hc.myInvoices": "Minhas faturas",
"hc.myMonthlyInvoices": "Minhas faturas mensais",
"hc.nArchived": "{n} listagem(ns) arquivada(s).",
"hc.newCodeGeneratedAndSent": "Novo código gerado e enviado ao cliente por e-mail e SMS",
"hc.newCodeGeneratedAndSent2": "Novo código gerado e enviado ao proprietário",
"hc.newPassword": "Nova senha",
"hc.next": "Próximo",
"hc.nextPhoto": "Próxima foto",
"hc.no": "Não",
"hc.noAnswerProvided": "Nenhuma resposta fornecida.",
"hc.noArchivedDeclarations": "Nenhuma declaração arquivada",
"hc.noCountryFound": "Nenhum país encontrado",
"hc.noDeclarations": "Nenhuma declaração",
"hc.noFeesAreChargedTo": "Nenhuma taxa é cobrada do cliente.",
"hc.noInvoiceYet": "Nenhuma fatura ainda.",
"hc.noInvoiceYetYourInvoices": "Nenhuma fatura ainda. Suas faturas aparecerão aqui automaticamente após cada pagamento.",
"hc.noMatchIsAvailableFor": "Nenhuma correspondência disponível por enquanto. Avisaremos assim que um item corresponder à sua declaração.",
"hc.noShipmentMatchesYourSearch": "Nenhum envio corresponde à sua pesquisa.",
"hc.noShipmentsYet": "Nenhum envio ainda.",
"hc.noShipmentsYet2": "Nenhum envio ainda",
"hc.none": "nenhum",
"hc.noneChooseForEachShipment": "Nenhum (escolha para cada envio)",
"hc.notMine": "Não é meu",
"hc.of": "de",
"hc.only": "Apenas",
"hc.onlyEachSiteManagesIts": "apenas. Cada site gerencia seu próprio banco: esses links não afetam nenhum outro estabelecimento.",
"hc.onlyTheOwnerOrAn": "Somente o proprietário ou um administrador pode configurar os links de pagamento do estabelecimento.",
"hc.openDepositInTheMenu": "Abra \"Depósito\" no menu, descreva o item e tire uma foto. Ele é armazenado imediatamente e pronto para ser devolvido.",
"hc.openSettings": "Abrir Configurações →",
"hc.openTheDeclarationToManage": "Abra a declaração para gerenciar o envio",
"hc.optional": "— opcional",
"hc.optional2": "(opcional)",
"hc.optional3": "opcional",
"hc.originalListingPhotoUsed": "Foto original da listagem usada",
"hc.other": "Outro",
"hc.other2": "Outro…",
"hc.ourProducts": "Nossos produtos",
"hc.overallRateTrendLast6": "Tendência geral de taxas (últimos 6 meses)",
"hc.ownerSClaimCode": "Código de reivindicação do proprietário",
"hc.ownershipConfirmed": "Propriedade confirmada",
"hc.paid": "Pago",
"hc.paidOn": "Pago em",
"hc.paidViaPartner": "Pago (via parceiro)",
"hc.parcelBeingPrepared": "Pacote sendo preparado",
"hc.parcelDelivered": "Pacote entregue",
"hc.parcelShipped": "Pacote enviado",
"hc.parisGareDeLyon": "Paris, Gare de Lyon…",
"hc.partner": "Parceiro",
"hc.partner2": "parceiro",
"hc.partnerDirectory": "Diretório de parceiros",
"hc.passedOnToTheCustomer": "— encaminhado para o cliente o link de pagamento.",
"hc.password": "Senha",
"hc.passwordResetPleaseLogIn": "Redefinição de senha, por favor faça login.",
"hc.passwordUpdated": "Senha atualizada.",
"hc.passwordsDoNotMatch": "As senhas não coincidem.",
"hc.pasteThisSenderIdIn": "Cole este ID do remetente em Findloop → Configurações",
"hc.payForTheShipmentOf": "Pague pelo envio do seu item através do Findloop com um pagamento seguro.",
"hc.payTheRecoveryFees": "Pague as taxas de recuperação",
"hc.payTheShippingFees": "Pague as taxas de envio",
"hc.payment": "Pagamento",
"hc.paymentAlreadyConfirmedByThe": "Pagamento já confirmado pelo parceiro",
"hc.paymentLinksAreNowConfigured": "Links de pagamento agora estão configurados por estabelecimento",
"hc.paymentNotCompletedYourAccount": "Pagamento não concluído, sua conta não foi criada — por favor, tente novamente.",
"hc.paymentReceived": "Pagamento recebido",
"hc.paymentSuccessful": "Pagamento bem-sucedido!",
"hc.pdfInvoice": "Fatura PDF",
"hc.pending": "Pendente",
"hc.period": "Período",
"hc.phoneNumber": "Número de telefone",
"hc.phoneOptional": "Telefone (opcional)",
"hc.planAt": "plano em",
"hc.planLimitFmt": "Seu plano \"{plan}\" é limitado a {max} estabelecimento. Para gerenciar {n} sites, recomendamos o",
"hc.platformReturnTarget": "Meta de retorno da plataforma",
"hc.pleaseCompleteYourShippingAddress": "Por favor, complete seu endereço de entrega.",
"hc.pleaseProvideAPhoneNumber": "Por favor, forneça um número de telefone: é necessário pela transportadora para envio.",
"hc.pleaseProvideAReason": "Por favor, forneça um motivo.",
"hc.pleaseSetYourOwnPassword": "por favor, defina sua própria senha antes de continuar.",
"hc.pointsToGoal": "{n} pontos a mais para alcançarmos nossa meta compartilhada.",
"hc.posterPreview": "Pré-visualização do cartaz",
"hc.potentialMatchBeingVerified": "Correspondência potencial sendo verificada",
"hc.potentialOwner": "Proprietário potencial",
"hc.preFilledAutomaticallyYouCan": "Pré-preenchido automaticamente — você pode substituí-lo por uma foto do pacote.",
"hc.pressKit": "Kit de imprensa",
"hc.previewMode": "Modo de visualização:",
"hc.previewOfThePrintReady": "Visualização do cartaz A4 pronto para impressão deste estabelecimento.",
"hc.previous": "Anterior",
"hc.previousPhoto": "Foto anterior",
"hc.primary": "principal",
"hc.printThePoster": "Imprimir o cartaz",
"hc.privacy": "Privacidade",
"hc.privacyPolicy": "Política de privacidade",
"hc.processedCasesWillAppearHere": "Casos processados aparecerão aqui.",
"hc.proofOfReturnPdf": "Comprovante de devolução (PDF)",
"hc.protectedByRecaptcha": "Protegido por reCAPTCHA",
"hc.publicMatch": "Partida pública",
"hc.putBackInStorage": "Devolver ao armazenamento",
"hc.pwdResetByTeam": "Sua senha foi redefinida por nossa equipe. Para sua segurança,",
"hc.questionsToAskTheOwner": "Perguntas para fazer ao proprietário",
"hc.rateChargedToTheCustomer": "Taxa cobrada ao cliente:",
"hc.rateOfTarget": "{rate}% alcançado de uma meta de {target}%",
"hc.reached": "alcansado",
"hc.reactivating": "Reativando…",
"hc.reasonSavedYouCanStill": "Razão salva. Você ainda pode reivindicar seu item.",
"hc.recentMatchesFirst": "Últimas partidas primeiro",
"hc.recognizedThePhotoYouSent": "reconheceu a foto que você enviou e descreveu estas características. Confirme apenas se coincidem com o item que você possui.",
"hc.recommended": "Recomendado",
"hc.recoveryFees": "Taxas de recuperação",
"hc.recoveryFeesArePaidDirectly": "As taxas de recuperação são pagas diretamente ao estabelecimento parceiro. Findloop não recebe pagamento dos clientes.",
"hc.recoveryFeesEnabled": "Taxas de recuperação habilitadas",
"hc.recoveryOfferedByTheEstablishment": "Recuperação oferecida pelo estabelecimento — Findloop não cobra taxas.",
"hc.recoveryPaymentLink": "Link de pagamento de recuperação",
"hc.recoveryPaymentLinkSavedFor": "Link de pagamento de recuperação salvo para este estabelecimento",
"hc.redirecting": "Redirecionando…",
"hc.redirectingToPayment": "Redirecionando para o pagamento…",
"hc.redirectingToTheRecoveryOf": "Redirecionando para a recuperação do seu item…",
"hc.regenerateAndResendToThe": "Regenerar e reenviar ao proprietário",
"hc.regenerateTheCode": "Regenerar o código",
"hc.registerAFoundItem": "Registrar um item encontrado",
"hc.rejectTheClaim": "Rejeitar a reivindicação",
"hc.reminderDelaySaved": "Atraso no lembrete salvo",
"hc.reopenThePaymentLink": "Reabrir o link de pagamento",
"hc.repeatThePassword": "Repita a senha",
"hc.reportAProblem": "Relatar um problema",
"hc.reportDismissedYourListingRemains": "Relatório descartado. Seu anúncio permanece público.",
"hc.requiredUsedToCalculateThe": "Necessário: usado para calcular a taxa de envio do Sendcloud. Envio indisponível acima de 30 kg.",
"hc.reset": "Redefinir",
"hc.resume": "Retomar",
"hc.resumeRegistration": "Retomar registro",
"hc.retro": "Ano em revisão",
"hc.returnSecurity": "Segurança de retorno",
"hc.returnToTheOwner": "Retornar ao proprietário",
"hc.returned": "devolvido",
"hc.reviewTheItemDetails": "Revise os detalhes do item",
"hc.revokeAccess": "Revogar acesso",
"hc.role": "Função:",
"hc.save": "Salvar",
"hc.save2": "salvar",
"hc.saveAndContinue": "Salvar e continuar",
"hc.saving": "Salvando…",
"hc.scanTheClaimCode": "Escanear o código de reclamação",
"hc.scanTheOwnerSQr": "Escanear o QR do proprietário",
"hc.scrollThroughLanguages": "Role pelos idiomas",
"hc.searchByCustomerItemOr": "Pesquisar por cliente, item ou número de rastreamento…",
"hc.searchForACountry": "Pesquisar por um país…",
"hc.secureFindoVerification": "Verificação segura Findloop",
"hc.seeRetro": "Ver o ano em revisão",
"hc.selectedCarrier": "Transportadora selecionada:",
"hc.selectedPlan": "Plano selecionado",
"hc.send": "Enviar",
"hc.sendcloudSenderIdSaved": "ID do remetente Sendcloud salvo",
"hc.sendcloudSenderIdSenderId": "ID do remetente Sendcloud (sender_id)",
"hc.sending": "Enviando…",
"hc.sessionExpired": "Sessão expirada",
"hc.setUpYourEstablishments": "Configure seus estabelecimentos",
"hc.settings": "Configurações",
"hc.settingsSubtitle": "Pagamentos externos e lembretes, configurados por estabelecimento.",
"hc.shareFoundText": "Encontrei um item — me ajude a encontrar seu proprietário no Findloop",
"hc.shareLostText": "Perdi um item — me ajude a encontrá-lo no Findloop",
"hc.sharePreview": "Compartilhar prévia",
"hc.shareTheRanking": "Compartilhar o ranking",
"hc.shareYourQrCodeTo": "Compartilhe seu QR code para receber declarações.",
"hc.shipRateAutoWeight": "A taxa de envio é calculada automaticamente via Sendcloud (peso {w}) no momento do envio.",
"hc.shipRateForWeight": "Tarifa de envio (Sendcloud + {m}% de margem) para {w}:",
"hc.shipments": "Envios",
"hc.shipmentsSubtitle": "Visão consolidada de todos os envios do estabelecimento, em todos os casos. Clique em uma linha para gerenciar o envio em sua declaração.",
"hc.shipping": "Envio",
"hc.shippingAddress": "Endereço de envio",
"hc.shippingFeesAreHandledAutomatically": "As taxas de envio são gerenciadas automaticamente pelo Findloop (Sendcloud) — sem link a ser inserido.",
"hc.shippingFeesHaveAlreadyBeen": "As taxas de envio já foram pagas: o transportador não pode mais ser alterado.",
"hc.shippingNotAvailableForItems": "Envio não disponível para itens acima de 30 kg. O cliente terá que retirar o item pessoalmente.",
"hc.shippingPaid": "Envio pago ✓",
"hc.showOnlyItemsMatchingA": "Mostrar apenas itens correspondentes a uma lista pública (cliente)",
"hc.showPassword": "Mostrar senha",
"hc.signInTheBoxAbove": "Entre na caixa acima",
"hc.signatureSaved": "Assinatura salva",
"hc.signedInWithGoogle": "Conectado com o Google",
"hc.signupFailed": "Falha no registro",
"hc.silver": "Prata",
"hc.simulatedRatesInPreProduction": "(taxas simuladas em pré-produção)",
"hc.siretAndVatNumberRequired": "Número SIRET e IVA necessários (França).",
"hc.skip": "Pular",
"hc.smsSentIfAccount": "Se uma conta existir com este número, um SMS foi enviado para você.",
"hc.sortItemsWithAPublic": "Classificar: itens com uma correspondência pública (mais recente) primeiro",
"hc.specifyWhetherYouRecoveredYour": "Especifique se você recuperou seu item ou simplesmente deseja remover esta lista.",
"hc.specifyYourReason": "Especifique seu motivo",
"hc.specifyYourReason2": "Especifique seu motivo…",
"hc.staff": "Equipe",
"hc.status": "Status",
"hc.staySignedIn": "Permanecer conectado",
"hc.step": "Passo",
"hc.stillThere": "Ainda está aí?",
"hc.stopScrolling": "Parar de rolar",
"hc.storeFindWithQr": "Salvar e encontrar com QR",
"hc.streetName": "Nome da rua",
"hc.streetNo": "Número da rua",
"hc.switchTo": "Alternar para",
"hc.switchToDarkMode": "Alternar para o modo escuro",
"hc.switchToLightMode": "Alternar para o modo claro",
"hc.takeAPhoto": "Tirar uma foto",
"hc.takeChangeThePhoto": "Tirar / trocar a foto",
"hc.takenFromYourDeclaration": "retirado da sua declaração",
"hc.target": "Alvo",
"hc.targetReached": "Meta alcançada",
"hc.targetReachedThankYouTo": "Meta alcançada — obrigado a toda a comunidade Findloop!",
"hc.tellUsMore": "Conte-nos mais…",
"hc.tellUsWhyYouCancel": "Diga-nos por que você está cancelando. Isso ajuda o parceiro a processar seu pedido.",
"hc.tellUsWhyYourListing": "Diga-nos o porquê. Seu anúncio permanece ativo e você ainda pode reivindicar seu item.",
"hc.termsAndConditions": "Termos e condições",
"hc.termsAndPolicies": "Termos e políticas",
"hc.thankYouForYourFeedback": "Obrigado pelo seu feedback",
"hc.theBannerDisplayedInThe": "o banner exibido no registro.",
"hc.theClaimantHasBeenInformed": "O requerente foi informado. O item continua disponível na lista pública.",
"hc.theClaimantHasBeenNotified": "O requerente foi notificado e agora pode prosseguir com a devolução.",
"hc.theCustomerPaysTheFees": "O cliente paga as taxas ao estabelecimento.",
"hc.theDayTheLegalRetention": "O dia em que o período de retenção legal é atingido.",
"hc.theEstablishmentConsideredThatThis": "O estabelecimento considerou que este item não é seu.",
"hc.theEstablishmentIsReviewingYour": "O estabelecimento está analisando suas respostas. Você será notificado assim que sua reclamação for validada, então poderá pagar as taxas de recuperação.",
"hc.theFeesAreTooHigh": "As taxas são muito altas",
"hc.theFinderConsideredThatThis": "O localizador considerou que este item não é seu.",
"hc.theFinderIsReviewingYour": "O localizador está revisando sua reclamação. Você será notificado assim que for validada.",
"hc.theItem": "O item",
"hc.theItemWillBeRemoved": "O item será removido do registro (sem reclamação em andamento).",
"hc.theItemWillBeSet": "O item será definido como \"em estoque\" e a reclamação relacionada cancelada.",
"hc.theKbisNumberAndVat": "O número Kbis e o número de IVA são necessários para a França.",
"hc.theLabelIsGeneratedAutomatically": "O rótulo é gerado automaticamente assim que o cliente paga as taxas de envio. Ele será baixável aqui.",
"hc.theLinkMayHaveExpired": "O link pode ter expirado (válido por 30 dias). Entre em contato com o suporte da Findloop se necessário.",
"hc.theOwnerDescribesTheirItem": "O proprietário descreve seu item",
"hc.theOwnerReceivedItBy": "O proprietário recebeu por e-mail (ou SMS). Insira ou escaneie antes da entrega.",
"hc.thePartnerConsideredThatThis": "O parceiro considerou que este item não é seu. O item permanece disponível.",
"hc.thePartnerIsReviewingYour": "O parceiro está revisando suas respostas. Você será notificado assim que sua reclamação for validada.",
"hc.theShipmentIsCreatedAutomatically": "A remessa é criada automaticamente assim que o cliente confirma seu endereço e paga as taxas de recuperação. O rótulo será então gerado automaticamente após o pagamento do envio e poderá ser baixado aqui.",
"hc.theShippingRateWillBe": "A taxa de envio será calculada automaticamente via Sendcloud no momento do envio (peso registrado).",
"hc.thisCarrierWillBe": "Este transportador será",
"hc.thisEstablishment": "este estabelecimento",
"hc.thisFieldIsRequiredFor": "Este campo é obrigatório para a geração automática de rótulos.",
"hc.thisIsMyItem": "Este é meu item",
"hc.thisIsMyItemContinue": "Este é meu item — continue",
"hc.thisIsMyItemStart": "Este é meu item — inicie a devolução",
"hc.thisIsNotMyItem": "Este não é meu item",
"hc.thisMatchIsNoLonger": "Esta correspondência não está mais disponível ou já foi processada.",
"hc.thisRateWillBeCharged": "Esta taxa será cobrada ao cliente. Uma taxa alta pode desencorajar a recuperação.",
"hc.thisStepIsRequiredFor": "Esta etapa é necessária para que os rótulos de envio sejam gerados",
"hc.thisValidationLinkIsInvalid": "Este link de validação é inválido ou expirou.",
"hc.toCheckBeforeMarkingThe": "Para verificar antes de marcar o item como devolvido.",
"hc.toConfigureTheLinksAnd": "para configurar os links e o atraso de lembrete para cada estabelecimento.",
"hc.toReachOurFirstMilestone": "para atingir nosso primeiro marco de 100 devoluções.",
"hc.toTheCustomer": "para o cliente.",
"hc.toTheShippingFeePayment": "para o pagamento da taxa de envio.",
"hc.toYourRecoveryTracking": "para seu rastreamento de recuperação.",
"hc.tooExpensiveBudget": "Muito caro / orçamento",
"hc.topCitiesForReturns": "Principais cidades para devoluções",
"hc.trackMyRecovery": "Rastrear minha recuperação",
"hc.trackTheShipmentAndDownload": "Rastreie a remessa e baixe o rótulo (gerado automaticamente) sem sair da aba Declarações.",
"hc.trackYourStatistics": "Rastrear suas estatísticas",
"hc.tracking": "Rastreamento",
"hc.unableToOpenTheShipping": "Não foi possível abrir o pagamento da taxa de envio. Por favor, tente novamente.",
"hc.unableToRetrieveTheInvoice": "Não foi possível recuperar a fatura.",
"hc.unclaimed": "Não reclamado",
"hc.unclaimedCustomerReason": "Item não reclamado. Motivo do cliente: \"{reason}\".",
"hc.unclaimedItem": "Item não reclamado",
"hc.unclaimedItemNoClaimWithin": "Item não reclamado — sem reclamação dentro do prazo.",
"hc.unclaimedItems": "Itens não reclamados",
"hc.unclaimedItemsMatchLeftWithout": "Itens não reclamados: correspondência deixada sem reclamação dentro do prazo. Você pode colocá-los de volta no armazenamento.",
"hc.unlockTheFinderSContact": "Desbloquear os detalhes de contato do coletor para organizar a entrega.",
"hc.upcoming": "Próximos",
"hc.updateFailed": "Atualização falhou.",
"hc.usedForInvoices": "Usado para emitir suas faturas findloop.",
"hc.vatNumber": "Número do IVA",
"hc.verificationPending": "Verificação pendente",
"hc.verificationSentToTheFinder": "Verificação enviada ao coletor. Você será notificado sobre a decisão deles.",
"hc.verificationSentToThePartner": "Verificação enviada ao parceiro. Você será notificado sobre a decisão deles.",
"hc.verify": "Verificar",
"hc.verifyingInvite": "Verificando o link de convite…",
"hc.verifyingTheLink": "Verificando o link…",
"hc.viewInRegistry": "Ver no registro",
"hc.viewItem": "Ver item",
"hc.viewItemRecover": "Ver item e recuperar",
"hc.visibleToTheOwnerAutomatically": "Visível para o proprietário · excluído automaticamente após 60 dias.",
"hc.waitingForPartnerConfirmation": "Aguardando confirmação do parceiro",
"hc.waitingForThePartnerS": "Aguardando a confirmação do parceiro",
"hc.weHaveInformedTheEstablishment": "Informamos ao estabelecimento que este item não é seu e reiniciamos a análise. Você será notificado assim que uma nova correspondência for encontrada.",
"hc.weHaveInformedThePartner": "Informamos ao parceiro que este item não é seu. Seu anúncio permanece ativo para futuras correspondências.",
"hc.weRanTheAnalysisAgain": "Fizemos a análise novamente e identificamos outro item que pode ser seu. Por favor, verifique novamente.",
"hc.weight": "Peso",
"hc.weightNotProvidedTheShipping": "Peso não fornecido: a taxa de envio será calculada no momento do envio.",
"hc.weightUnit": "Unidade de peso",
"hc.welcome": "Bem-vindo!",
"hc.welcomeToFindo": "Bem-vindo ao Findloop",
"hc.whenACustomerComesTo": "Quando um cliente vem buscar seus pertences, abra a declaração e valide a devolução. É isso!",
"hc.whenDisabledFeesDropTo": ". Quando desabilitado, as taxas caem para",
"hc.whyIsThisNotYour": "Por que isso não é seu item?",
"hc.willBeMarkedAs": "será marcado como",
"hc.wrongColor": "Cor errada",
"hc.wrongModel": "Modelo errado",
"hc.yesCancel": "Sim, cancelar",
"hc.yesContactTheFinder": "Sim, contatar o encontrador",
"hc.youAreHere": "Você está aqui",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Você agora pode iniciar a devolução.",
"hc.youCanStillChangeIt": ". Você ainda pode mudar isso caso a caso.",
"hc.youHaveAlreadyConfirmedThat": "Você já confirmou que este é seu item.",
"hc.youWillBeRedirectedTo": "Você será redirecionado para o pagamento seguro da Stripe.",
"hc.yourAccountHasBeenReactivated": "Sua conta foi reativada.",
"hc.yourAccountIsActiveYou": "Sua conta está ativa, você agora pode gerenciar seus estabelecimentos.",
"hc.yourEstablishment": "Seu estabelecimento",
"hc.yourFeedbackHelpsUsImprove": "Seu feedback nos ajuda a melhorar nossas correspondências.",
"hc.yourFeedbackHelpsUsRestart": "Seu feedback nos ajuda a reiniciar a análise e melhorar nossas correspondências.",
"hc.yourFirstSteps": "Seus primeiros passos",
"hc.yourFirstStepsAdmin": "Seus primeiros passos (admin)",
"hc.yourItemHasBeenHanded": "Seu item foi entregue pessoalmente pelo parceiro — feche o caso uma vez que a entrega seja confirmada.",
"hc.yourItemHasBeenShipped": "Seu item foi enviado pelo parceiro — feche o caso uma vez que a entrega seja confirmada.",
"hc.yourPaymentHasBeenRecorded": "Seu pagamento foi registrado.",
"hc.yourShipmentIsBeingPrepared": "Seu envio está sendo preparado. Você receberá seu pacote dentro de 3 a 5 dias úteis.",
"hc.yourShippingFeesHaveAlready": "Suas taxas de envio já foram pagas. Envio pago ✓",
"hc.yourShippingFeesHaveBeen": "Suas taxas de envio foram pagas. Seu pacote está sendo preparado.",
"hc.yourVerificationQuestionsDeposit": "Suas perguntas de verificação (depósito)",
"home.recentAdsAll": "Ver todos os anúncios",
"home.recentAdsEyebrow": "Neste momento",
"home.recentAdsSubtitle": "Itens perdidos e encontrados reportados pela comunidade.",
"home.recentAdsTitle": "Últimos anúncios",
"home.reunions": "Reuniões recentes",
"home.videoEyebrow": "Assista",
"home.videoSubtitle": "Como reunimos itens perdidos com seus donos, sem esforço.",
"home.videoTitle": "Descubra o Findloop em 2 minutos",
"home.watchYoutube": "Assista no YouTube",
"impact.already": "Já",
"impact.citiesWord": "cidade/cidades",
"impact.eachPoint": "Cada ponto representa uma cidade onde o Findloop ajuda a recuperar itens perdidos.",
"impact.emptyMap": "O mapa se preenche conforme as restituições acontecem.",
"impact.eyebrow": "Nosso impacto",
"impact.inCities": "em",
"impact.restitutedTo": "itens devolvidos aos seus donos",
"impact.title": "Itens devolvidos, em toda parte perto de você",
"inv2.download": "Baixar",
"inv2.view": "Ver",
"map.objectsOnMapPlural": "itens no mapa",
"map.objectsOnMapSingular": "item no mapa",
"mc.claimConfirmDesc": "Verifique o item encontrado pelo localizador antes de pagar para desbloquear os detalhes de contato dele.",
"mc.claimConfirmNo": "Este não é o meu item",
"mc.claimConfirmTitle": "Este é realmente seu item?",
"mc.claimConfirmYes": "Sim, é meu — pagar",
"mc.claimFinderContacts": "Detalhes de contato do localizador",
"mc.claimNotMineDone": "Obrigado — o localizador foi notificado e sua solicitação foi removida do anúncio.",
"mc.claimUnlockDesc": "Pague a taxa de administração do Findloop para obter os detalhes de contato da pessoa que encontrou seu item.",
"mc.claimUnlockTitle": "Desbloqueie os detalhes de contato do localizador",
"mc.hideCountryOffers": "Ocultar ofertas no meu país",
"mc.myClaims": "Itens que estou reivindicando",
"mc.myClaimsSub": "Itens encontrados por outros que você está reivindicando. Desbloqueie os detalhes de contato do localizador para organizar a entrega.",
"mc.notifAdCancelled": "Anúncio cancelado",
"mc.notifCancelAd": "Cancelar meu anúncio",
"mc.offersInCountry": "Ofertas no meu país",
"mc.offersInCountryDesc": "Todas as recompensas ativas dos parceiros no seu país, por cidade.",
"mc.redArchived": "Arquivo",
"mc.rewardsCountryNone": "Ainda não há oferta no seu país.",
"mc.rewardsForYou": "Recompensas para você",
"mc.rewardsForYouDesc": "Oferecido pelo(s) parceiro(s) onde você deixou um item.",
"mc.rewardsMineNone": "Ainda não há recompensa dos seus parceiros de entrega.",
"mc.showCountryOffers": "Ver ofertas no meu país",
"mc2.cancelDecl": "Cancelar minha declaração",
"mc2.cancelDeclDone": "Declaração cancelada.",
"pricing.physInvDesc": "Quando um item é devolvido, sua localização é automaticamente liberada e disponível para um novo item.",
"pricing.physInvTitle": "Rastreamento de inventário físico",
"pricing.physModalTitle": "Gerenciamento de itens físicos",
"pricing.physQrDesc": "Um código QR único é gerado por item e vincula-se a todas as suas informações.",
"pricing.physQrTitle": "Etiqueta QR dedicada",
"pricing.physShelfDesc": "Todo item registrado pode ser atribuído a uma localização física dentro do estabelecimento.",
"pricing.physShelfTitle": "Planta de prateleira",
"pricing.physicalMgmt": "Gerenciamento de itens físicos (prateleiras, QR, inventário)",
"pub.addSecondPhoto": "Adicione uma 2ª foto (opcional)",
"pub.photo2Added": "✓ 2ª foto adicionada",
"reg.dispositionJournal": "Diário de disposição",
"reg.dispositionNoteAuthHint": "ℹ️ Uma nota é necessária para “Entregue às autoridades” (número do relatório, departamento…).",
"reg.dispositionNotePh": "Nota (opcional): instituição de caridade recebedora, ref. das autoridades, nome do comprador…",
"reg.dispositionNoteRequired": "Uma referência oficial é necessária para entrega às autoridades.",
"reg.legalPrealert": "Prazo legal em {days} dia(s)",
"reg.legalPrealertOptions": "Opções no prazo: venda em leilão, doação a uma instituição de caridade, entrega às autoridades.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Revisão completa",
"rev.readMore": "Leia mais",
"rw.activeCodes": "Vouchers ativos",
"rw.archived": "Arquivado",
"rw.archivedTitle": "Vouchers resgatados (arquivados)",
"rw.hideArchived": "Ocultar vouchers resgatados",
"rw.noArchived": "Nenhum voucher arquivado.",
"rw.showArchived": "Mostrar vouchers resgatados",
"shp.labelAuto": "A etiqueta é gerada automaticamente assim que o cliente paga as taxas de envio. Ela será baixável aqui.",
"stt.dispoPdfBtn": "Exportar PDF",
"stt.dispoPdfError": "Falha na exportação do PDF.",
"stt.dispoPdfExporting": "Exportando…",
"trk.matchVerifying": "Correspondência potencial sendo verificada",
"pcat.stadium_arena": "Estádio / Arena",
"pcat.supermarket": "Supermercado",
"pcat.taxi_vtc": "Táxi / Transporte por aplicativo",
"pcat.tourism_office": "Escritório de turismo",
"pcat.train_bus_station": "Estação de trem / ônibus",
"pcat.travel_agency": "Agência de viagens",
"hc.and": "e",
"hc.demoObj0": "uma carteira",
"hc.demoObj1": "uma bolsa de esporte",
"hc.demoObj2": "um telefone",
"hc.demoObj3": "um par de óculos",
"hc.demoObj4": "um conjunto de chaves",
"hc.demoObj5": "uma scarf",
"hc.demoObj6": "um laptop",
"hc.demoObj7": "uma garrafa de água",
"hc.demoWhen0": "há 2 horas",
"hc.demoWhen1": "há 5 horas",
"hc.demoWhen2": "ontem",
"hc.demoWhen3": "há 3 horas",
"hc.demoWhen4": "esta manhã",
"hc.demoWhen5": "há 1 dia",
"hc.feedDemo": "{obj} foi retornado em {city} {when}.",
"hc.feedReal": "Um item ({cat}) foi retornado em {city}.",
"hc.saveBtn": "Salvar",
"hc.saveLink": "Salvar link",
"hc.terms": "Termos",
"hc.view": "Ver",
"pcat.airline": "Companhia aérea",
"pcat.airport": "Aeroporto",
"pcat.amusement_park": "Parque de diversões",
"pcat.bank": "Banco",
"pcat.bar_cafe": "Bar / Café",
"pcat.beauty_salon": "Salão de Cabelo / Beleza",
"pcat.cinema": "Cinema",
"pcat.concert_theater": "Casa de shows / Teatro",
"pcat.coworking": "Espaço de coworking",
"pcat.gym_fitness": "Academia / Fitness",
"pcat.hospital_clinic": "Hospital / Clínica",
"pcat.library": "Biblioteca",
"pcat.mall": "Shopping",
"pcat.museum": "Museu",
"pcat.pharmacy": "Farmácia",
"pcat.private_company": "Empresa privada",
"pcat.public_transport": "Transporte público",
"pcat.school_university": "Escola / Universidade",
"pcat.sports_center": "Centro esportivo",
"an.found": "Encontrado",
"an.lost": "Perdido",
"hc.shareReview": "Compartilhar a avaliação",
"hc.citiesAboveTarget": "{n} cidades acima da meta",
"hc.cityAboveTarget": "{n} cidade acima da meta",
"hc.j15EarlyReminder": "Lembrete antecipado D-15",
"hc.j7EarlyReminder": "Lembrete antecipado D-7",
"hc.annualTotal": "Total anual",
"hc.billedOnceYear": "Cobrado uma vez por 12 meses, renovado todo ano.",
"hc.monthlyPrice": "Preço mensal",
"hc.perMonth": "/ mês",
"hc.perYear": "/ ano",
"hc.billedEachMonth": "Cobrado automaticamente todo mês.",
"nav.business": "Negócios",
"nav.individual": "Individual",
"hc.circumstancesFound": "Circunstâncias do achado",
"hc.circumstancesFoundPh": "Ex.: encontrado no chão perto da entrada do metrô",
"hc.circumstancesLost": "Circunstâncias da perda",
"hc.circumstancesLostPh": "Ex.: deixado em um banco enquanto esperava pelo ônibus",
"hc.conditionPh": "Ex.: bom, arranhado…",
"hc.firstName": "Primeiro nome",
"hc.lastName": "Sobrenome",
"hc.quantity": "Número de itens",
"fa.approve": "Aprovar",
"fa.approveConfirm": "Aprovar esta declaração? Seus dados de contato completos (nome, e-mail, telefone) serão trocados com o encontrador.",
"fa.approved": "Declaração aprovada — dados de contato trocados",
"fa.approvedFinder": "O proprietário aprovou sua declaração",
"fa.approvedFinderText": "Entre em contato para organizar a devolução.",
"fa.boostSub": "Seu anúncio fica no topo pelo tempo escolhido.",
"fa.boostTitle": "Aumentar meu anúncio (opcional)",
"fa.colFinder": "Declaração do encontrador",
"fa.colYours": "Sua declaração",
"fa.compareHint": "Compare a declaração do encontrador com a sua antes de decidir.",
"fa.contribNone": "Sem contribuição",
"fa.contribPaid": "Contribuição recebida — obrigado!",
"fa.contribPending": "Contribuição aguardando pagamento",
"fa.contribSub": "Apoie o Findloop para ajudar mais pessoas a recuperar seus pertences. Você pode escolher €0.",
"fa.contribSuccessMsg": "Sua declaração foi enviada ao proprietário.",
"fa.contribSuccessTitle": "Obrigado pela sua contribuição",
"fa.contribTitle": "Contribuição voluntária",
"fa.days3": "3 dias",
"fa.days30": "30 dias",
"fa.days7": "7 dias",
"fa.declSub": "Descreva o item que você encontrou. O proprietário comparará sua declaração com a dele.",
"fa.declTitle": "Eu encontrei este item",
"fa.expiresOn": "Expira em",
"fa.fBrand": "Marca",
"fa.fCircumstances": "Circunstâncias",
"fa.fCity": "Cidade",
"fa.fColor": "Cor",
"fa.fCondition": "Condição",
"fa.fDate": "Data",
"fa.fMessage": "Mensagem do encontrador",
"fa.fPlace": "Lugar",
"fa.fQuantity": "Quantidade",
"fa.finderContact": "Detalhes de contato do encontrador",
"fa.finishPay": "Concluir pagamento",
"fa.foundDate": "Data encontrada",
"fa.foundPlace": "Lugar encontrado",
"fa.hours24": "24 horas",
"fa.ht": "excl. IVA",
"fa.months3": "3 meses",
"fa.noBoost": "Sem aumento",
"fa.ownerContact": "Detalhes de contato do proprietário",
"fa.payPublish": "Pagar e publicar",
"fa.pendingPayText": "Seu anúncio será ativado assim que o pagamento for confirmado.",
"fa.pendingPayTitle": "Pagamento pendente",
"fa.planSub": "Seu anúncio será ativado assim que o pagamento for confirmado.",
"fa.planTitle": "Duração do anúncio",
"fa.pubSuccessMsg": "Seu anúncio está ativo. Você será notificado assim que um localizador se manifestar.",
"fa.pubSuccessTitle": "Anúncio publicado",
"fa.publicNote": "Apenas a descrição, cidade, país e fotos são exibidos publicamente.",
"fa.redirectStripe": "Redirecionando para pagamento seguro…",
"fa.reject": "Rejeitar",
"fa.rejectConfirm": "Rejeitar esta declaração? Seu anúncio permanecerá online.",
"fa.rejected": "Declaração rejeitada",
"fa.rejectedFinder": "Não era o item que eles estavam procurando",
"fa.rejectedFinderText": "O proprietário diz que este item não é dele. Obrigado pela sua ajuda!",
"fa.responsesTitle": "Declarações de localizadores",
"fa.sent": "Declaração enviada ao proprietário.",
"fa.submitDecl": "Enviar minha declaração",
"fa.submitDeclPay": "Enviar e contribuir {amount}",
"fa.total": "Total a pagar",
"fa.ttc": "incl. IVA",
"fa.waitClaimText": "O localizador está revisando sua solicitação. Você será notificado sobre a decisão deles.",
"fa.waitFinderText": "Nós o informaremos assim que um localizador enviar uma declaração.",
"fa.waitFinderTitle": "Seu anúncio está ativo",
"fa.waitOwnerText": "O proprietário está comparando sua declaração com a dele. Você será notificado sobre a decisão deles.",
"fa.waitOwnerTitle": "Aguardando a decisão do proprietário",
"st.pending_payment": "Pagamento pendente",
"fa.africaFree": "Listagem gratuita na África — oferta de lançamento da Findloop, aproveite!",
"fa.africaPublished": "Listagem publicada gratuitamente — oferta de lançamento na África!",
"fa.approveClaimConfirm": "Aprovar esta reclamação? O proprietário poderá desbloquear seus dados de contato.",
"fa.checkInfo": "Verifique seus detalhes antes de enviar: eles serão comparados com os do finder.",
"fa.claimApprovedShort": "O finder aprovou sua reclamação",
"fa.claimRejectedShort": "Reclamação recusada pelo finder",
"fa.claimRejectedText": "O finder acredita que este item não é seu.",
"fa.claimSub": "Descreva seu item e adicione 2 fotos. O finder as comparará com sua listagem.",
"fa.claimTitle": "Este é meu item",
"fa.claimUnlockText": "Desbloqueie os detalhes de contato do finder para organizar a devolução.",
"fa.claimUnlockedShort": "Detalhes de contato desbloqueados — veja o rastreamento",
"fa.claimsTitle": "Reclamações de proprietário",
"fa.colOwner": "Declaração do proprietário",
"fa.colYourAd": "Sua listagem",
"fa.expired": "Listagem expirada",
"fa.free": "Gratuito",
"fa.lostDate": "Data perdida",
"fa.lostPlace": "Local perdido",
"fa.noReceipt": "Nenhum recibo disponível para esta listagem.",
"fa.planSubFree": "Escolha a duração: sua listagem entra no ar imediatamente, sem pagamento necessário.",
"fa.prefillPrevious": "Reutilizar os detalhes da minha listagem anterior nesta categoria",
"fa.receipt": "Recibo em PDF",
"fa.renewBtn": "Renovar",
"fa.renewDiscountBanner": "50% de desconto: renove antes que sua listagem expire!",
"fa.renewDiscountHint": "50% de desconto aplicado porque você renovou antes do vencimento.",
"fa.renewEarly": "Renovar (−50%)",
"fa.renewTitle": "Renovar minha listagem",
"fa.renewed": "Listagem renovada",
"fa.sendClaim": "Enviar minha reclamação",
"fa.twoPhotos": "2 fotos do seu item",
"fa.twoPhotosError": "Adicione 2 fotos do seu item.",
"fa.twoPhotosHint": "Fotos pessoais comprovando que o item é seu (com o item, nota fiscal, caixa…).",
"fa.unlockBtn": "Desbloquear detalhes de contato",
"fa.unlockFree": "Desbloquear gratuitamente — oferta de lançamento",
"fa.waitClaimantText": "Nós o avisaremos assim que um proprietário reclamar este item.",
"fa.waitFinderDecision": "Aguardando a decisão do finder",
"fa.waitUnlockText": "Você será notificado assim que os dados de contato forem trocados.",
"fa.waitUnlockTitle": "Aguardando o proprietário desbloquear",
"fa.cancel": "Cancelar",
"fa.categoryRequired": "Escolha uma categoria para o item encontrado.",
"fa.confirmTitle": "Confirme sua decisão",
"fa.goBack": "Voltar",
"dr.continue": "Continuar minha declaração",
"dr.delete": "Excluir permanentemente",
"dr.deleteConfirm": "Excluir este rascunho permanentemente? Isso não pode ser desfeito.",
"dr.deleted": "Rascunho excluído",
"dr.expiresIn": "Rascunho mantido por mais {h} horas",
"dr.title": "Você tem uma declaração inacabada",
"form.step": "Etapa",
"form.next": "Continuar",
"form.back": "Voltar",
"form.stepDetails": "Seu relatório",
"form.stepPublish": "Duração, impulsionamento e pagamento",
"form.stepThanks": "Obrigado e contribuição",
"fthx.badge": "Relatório quase finalizado",
"fthx.title": "Obrigado, você está fazendo a diferença!",
"fthx.text": "Graças a você, alguém pode em breve recuperar algo que é importante para ele. Ações de bondade como a sua são exatamente o que mantém a Findloop viva.",
"fthx.impact1": "1 item reportado",
"fthx.impact2": "1 chance a mais de uma reunião",
"fthx.tipTitle": "Um pequeno impulso para o Findloop?",
"fthx.tipText": "Sua contribuição nos ajuda a manter o serviço acessível e reunir cada vez mais itens com seus proprietários.",
"fthx.optional": "100% opcional — você pode publicar sem contribuir.",
"fthx.thanksTip": "Muito obrigado pela sua generosidade!",
"fthx.suggest": "Valores sugeridos",
"fthx.none": "Sem contribuição",
"pay.pendingTitle": "Pagamento não concluído",
"pay.pendingText": "Seus dados estão salvos. Continue o pagamento de onde parou.",
"pay.resume": "Retomar pagamento",
"pay.expiredTitle": "Sessão de pagamento expirada",
"pay.expiredText": "Para sua segurança, a sessão de pagamento expirou. Seus dados estão salvos: reinicie o pagamento com um clique.",
"pay.relaunch": "Reiniciar pagamento",
"sub.received": "Enviado!",
"sub.publishing": "Estamos finalizando…",
"sub.toPayment": "Redirecionando para pagamento seguro…",
"fa.claimSubV2": "Descreva o item perdido. A pessoa que o encontrou irá comparar sua declaração com a listagem dela.",
"fa.photosOptional": "Fotos do seu item (opcional)",
"fa.compareOwnerHint": "Compare essas informações com o item que você encontrou e diga se é o mesmo item.",
"fa.itsThisItem": "Sim, este é o item",
"fa.notThisItem": "Não, este não é o item",
"fa.confirmIsItem": "Confirma que este é o item? Seus dados de contato e os do proprietário serão mostrados em suas respectivas contas.",
"fa.confirmNotItem": "Confirma que este não é o item? Seu relatório será encerrado.",
"fa.youConfirmed": "Você confirmou que este é o item do proprietário",
"fa.youDeclined": "Você indicou que este não era o item",
"fa.youDeclinedText": "Obrigado pela sua ajuda! O proprietário foi informado.",
"fa.waitFinderDecisionOwner": "Aguardando a decisão do encontrador",
"fa.finderConfirmed": "Confirmado",
"fa.notYourItem": "Este não era o seu item",
"fa.reportedOn": "Reportado em",
"fa.ownerWaitHint": "Um encontrador está verificando as informações, por favor aguarde.",
"fa.claimSentFinder": "Reclamação enviada para a pessoa que encontrou o item.",
"fa.compareClaimHint": "Compare a declaração do proprietário com sua listagem antes de decidir.",
"fa.closeFollowup": "Fechar este acompanhamento",
"fa.closeFollowupConfirm": "Fechar este acompanhamento? Os e-mails e números de telefone de ambas as partes serão permanentemente excluídos assim que o proprietário também fechar seu anúncio.",
"fa.safetyTitle": "Dicas de segurança antes da entrega",
"fa.safety1": "Peça ao proprietário uma descrição detalhada das características ocultas do item: um arranhão específico, o conteúdo exato de uma bolsa, o papel de parede, o número de série...",
"fa.safety2": "Se possível, peça uma prova visual (uma foto do item) ou comprovante de compra.",
"fa.safety3": "Entregue o item em um local público ou em um parceiro da Findloop, e verifique a identidade do proprietário.",
"fa.safetyOk": "Entendi, continuar",
"fa.ownerClosedNote": "O proprietário fechou seu anúncio.",
"fa.finderClosedNote": "O encontrador fechou seu acompanhamento.",
"fa.followupClosed": "Acompanhamento fechado",
"fa.followupClosedText": "Você fechou este acompanhamento. Obrigado pela sua ajuda!",
"fa.photoReviewTitle": "Um localizador enviou uma foto. Parece com o seu item?",
"fa.photoLooksLike": "Sim, parece com o meu item",
"fa.photoNotMine": "Não, este não é meu item",
"fa.photoNotMineConfirm": "O acompanhamento será fechado de ambos os lados e seu anúncio ficará ativo para um novo localizador.",
"fa.photoLooksLikeDone": "Obrigado! O localizador agora irá comparar sua declaração.",
"fa.photoNotMineDone": "Relatório descartado. Seu anúncio permanece aberto.",
"fa.ownerPhotoHint": "Apenas a foto do localizador é exibida para você. Diga-nos se parece com o seu item.",
"fa.ownerReviewingPhoto": "O proprietário está analisando sua foto",
"fa.ownerReviewingPhotoText": "Você será notificado assim que eles responderem. Você poderá então comparar a declaração deles.",
"fa.ownerRejectedPhoto": "Este não é o item do proprietário",
"fa.ownerRejectedPhotoText": "O proprietário diz que sua foto não corresponde ao item dele. O acompanhamento está encerrado. Obrigado pela sua ajuda!",
"fa.contribute": "Contribuir",
"fa.phoneMissing": "Não fornecido",
"fa.ownerSafety1": "Prefira a entrega em um local público ou em um parceiro da Findloop. Se a distância for longa, sugira enviá-lo pelo correio.",
"fa.ownerSafety2": "Na entrega, verifique a identificação do encontrador.",
"pub.changePhoto": "Mudar foto",
"ph.secured": "Foto protegida",
"ph.securing": "Protegendo a foto…",
"fa.ownerSafety3": "Se a foto do encontrador tiver a marca d'água da Findloop, não aceite a reunião. A foto deve ser uma imagem original tirada pelo encontrador, sem marca d'água."
},
"nl": {
"ac.africa": "Afrika",
"ac.boostActive": "Actieve nadruk —",
"ac.boostSub": "Verschijnen bovenaan de partnerdirectory met een “Verhoogd” badge.",
"ac.boostTitle": "Verhoog uw vermelding in de directory",
"ac.categoryHint": "Om uw establishment in de findloop-directory te classificeren.",
"ac.choose": "Kies",
"ac.cityHint": "Voor nauwkeurige positionering op de openbare kaart.",
"ac.cityLabel": "Stad van het establishment",
"ac.cityPh": "Parijs",
"ac.contact": "Contactgegevens",
"ac.converted": "Omgezet",
"ac.copyDeclLink": "Kopieer de declaratiekoppeling",
"ac.copyLink": "Kopieer de link",
"ac.currentPlan": "Huidig plan",
"ac.emailDesc": "Kies de e-mails die u wilt ontvangen. Meldingen in uw werkruimte blijven altijd actief.",
"ac.emailMatch": "Overeenkomsten",
"ac.emailMatchDesc": "Een e-mail wanneer een item overeenkomt met een verklaring",
"ac.emailNewDecl": "Nieuwe verliesverklaringen",
"ac.emailNewDeclDesc": "Een e-mail zodra een klant een verlies op uw locatie meldt",
"ac.emailShip": "Verzendverzoeken",
"ac.emailShipDesc": "Een e-mail wanneer een klant om verzending van een item vraagt",
"ac.emailTitle": "E-mailvoorkeuren",
"ac.expireSoon": "Uw nadruk verloopt binnenkort —",
"ac.exportCsv": "Exporteren (CSV)",
"ac.exportHint": "Exporteer uw gevalideerde externe betalingen voor uw boekhouding.",
"ac.free": "Gratis",
"ac.freeMonths": "Gratis maanden",
"ac.hours": "uren",
"ac.howItWorks": "Hoe werkt het?",
"ac.invited": "Uitgenodigd",
"ac.legalFR": "Vereist voor elektronische facturering (Factur-X) van toepassing vanaf september 2026.",
"ac.legalMissing": "⚠️ SIRET en intra-EU BTW ontbreekt — vul deze in om compliant te blijven met elektronische facturering.",
"ac.legalOther": "Aanbevolen voor uw facturen.",
"ac.legalPartnerQr": "QR-code",
"ac.legalTitle": "Juridische identificatoren (facturering)",
"ac.logoTitle": "Logo van het establishment",
"ac.modeCurrent": "Huidige modus:",
"ac.modeExternal": "Extern (handmatige validatie)",
"ac.modeInternal": "Interne Findloop (automatisch)",
"ac.noSubReceipt": "Nog geen betaling voor een betaald abonnement.",
"ac.none": "Geen",
"ac.onYourListing": "op uw vermelding",
"ac.pay1": "Voer hieronder uw betalingslinks in om uw klanten naar uw eigen incassosysteem te leiden.",
"ac.pay2": "Validatie wordt handmatig: u bevestigt de betaling ontvangst vanuit het tabblad “Verklaringen.”",
"ac.pay3": "De link “Verzendkosten” is een geconsolideerde betaling (terugvordering + verzending).",
"ac.pay4": "Laat de velden leeg om de interne betaling van Findloop (Stripe) met automatische validatie te gebruiken.",
"ac.paySub": "Verzamel kosten via uw eigen betalingssysteem.",
"ac.payTitle": "Externe betalingen",
"ac.permissive": "Toegestaan",
"ac.phone": "Telefoon",
"ac.posterA4": "A4 poster (PDF)",
"ac.qMessage": "Bericht (optioneel)",
"ac.qName": "Naam",
"ac.qOrg": "Organisatie",
"ac.qSites": "Aantal establishments (geschat)",
"ac.qrHint": "Uw klanten scannen deze code om een verloren item te melden.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Uw partner QR-code",
"ac.quoteDesc": "Luchthavens, spoorwegnnetwerken, internationale ketens · ",
"ac.quoteEurope": "Europa / Wereld",
"ac.quoteSent": "Offerteaanvraag verzonden. Ons team neemt binnenkort contact met je op.",
"ac.quoteTitle": "Vraag een offerte aan — Onderneming",
"ac.recoveryLink": "Link voor “herstelkosten”",
"ac.refSub": "Elke doorverwezen partner die zich abonneert, geeft je 1 gratis maand.",
"ac.refTitle": "Verwijs, verdien een gratis maand",
"ac.reminderDelay": "Herinnering voor validatie",
"ac.reminderHint": "Je ontvangt een e-mailherinnering als een externe betaling langer dan deze vertraging niet geverifieerd is (standaard: 48u).",
"ac.renewDesc1": "Het heeft je al",
"ac.renewDesc2": "Verleng om bovenaan de directory te blijven en deze zichtbaarheid niet te verliezen.",
"ac.renewNow": "Nu verlengen",
"ac.requestQuote": "Vraag een offerte aan",
"ac.saveLegal": "Bewaar de identificatoren",
"ac.saveLinks": "Bewaar de links",
"ac.sendRequest": "Verzend mijn aanvraag",
"ac.sending": "Verzenden…",
"ac.shippingLink": "Link voor “verzendkosten” (geconsolideerd)",
"ac.shippingLinkHint": "Deze link dekt zowel herstel als verzending.",
"ac.strict": "Strikt",
"ac.subReceipt": "Abonnementsbewijs (PDF)",
"ac.subReceiptsSub": "Download het PDF-bewijs voor elke abonnementsbetaling.",
"ac.subReceiptsTitle": "Abonnementsbewijzen",
"ac.tCategory": "Categorie opgeslagen",
"ac.tCity": "Stad opgeslagen — kaart bijgewerkt",
"ac.tCityNeeded": "Voer een stad in",
"ac.tCopied": "Gekopieerd!",
"ac.tCover": "Omslagfoto bijgewerkt",
"ac.tEmailPrefs": "E-mailvoorkeuren bijgewerkt",
"ac.tErr": "Fout",
"ac.tExportImpossible": "Export mislukt",
"ac.tLegal": "Juridische identificatoren opgeslagen",
"ac.tLegalNeeded": "SIRET en BTW vereist voor Frankrijk",
"ac.tLogo": "Logo bijgewerkt",
"ac.tLogoRemoved": "Logo verwijderd",
"ac.tPayLinks": "Betalingslinks opgeslagen",
"ac.tPhone": "Telefoon opgeslagen",
"ac.tSensitivity": "Gevoeligheid opgeslagen",
"ac.tVatInvalid": "Ongeldig btw-nummer",
"ac.tVatValid": "Geldige btw",
"ac.tabBoost": "Zichtbaarheid",
"ac.tabPayments": "Betalingen",
"ac.tabProfile": "Profiel",
"ac.tabQr": "QR & Poster",
"ac.tabReferral": "Doorverwijzing",
"ac.tabSub": "Abonnement",
"ac.thisWeek": "Deze week",
"ac.thisWeekOf": " ({n} deze week)",
"ac.thresholdDesc": "Vertrouwensdrempel vanaf wanneer de AI automatisch een fotocorrespondentie valideert en de klant notificaties stuurt. Hoger = minder automatische overeenkomsten maar betrouwbaarder.",
"ac.thresholdTitle": "AI visuele matchgevoeligheid",
"ac.trend": "Trend",
"ac.upload": "Uploaden",
"ac.vatValidFmt": "Geldige btw{name} ({via})",
"ac.vatVerified": "Intra-EU btw geverifieerd",
"ac.verifyVat": "Verifieer btw (VIES)",
"ac.verifying": "Verifiëren…",
"ac.views": "weergaven",
"ac.viewsTotal": "Verkregen weergaven (totaal)",
"ac.winbackBtn": "Hervat met -20%",
"ac.winbackDesc1": "Het heeft je opgebracht",
"ac.winbackDesc2": "Speciale aanbieding: -20% wordt automatisch toegepast als je binnen 24u verlengt.",
"ac.winbackTitle": "Je hoogtepunten zijn net verlopen — hervat met -20%!",
"an.allCountries": "Alle landen",
"an.country": "Land",
"an.geoBanner": "Je bekijkt aanbiedingen in",
"an.geoBannerWorld": "Je bekijkt aanbiedingen wereldwijd",
"an.geoChange": "verander land",
"an.loginRequired": "Log in om dit item te rapporteren en de retour te volgen.",
"an.requestInProgress": "Verzoek in behandeling",
"an.resolved": "Item al hersteld",
"an.sortRecent": "Meest recent",
"an.sortRelevance": "Relevantie",
"bo.africaPrice": "Afrika-zone voorkeurstarieven toegepast",
"c.all": "Alles",
"c.close": "Sluiten",
"c.confirm": "Bevestigen",
"c.confirmed": "Bevestigd",
"c.download": "Downloaden",
"c.reset": "Resetten",
"c.transfer": "Overdragen",
"cat.Animal": "Huisdier / Huisdieraccessoire",
"cat.AppareilPhoto": "Camera",
"cat.Argent": "Geld / Contant",
"cat.Autres": "Overig",
"cat.Bijoux": "Sieraden",
"cat.CarteBancaire": "Bankkaart",
"cat.CarteIdentite": "Identiteitskaart / Paspoort",
"cat.Casquette": "Pet / Hoed",
"cat.Ceinture": "Riem",
"cat.Chargeur": "Lader / Kabel",
"cat.Chaussures": "Schoenen",
"cat.CleVoiture": "Autosleutel",
"cat.Cles": "Sleutels",
"cat.Console": "Gamingconsole",
"cat.Documents": "Documenten / Papieren",
"cat.Echarpe": "Sjaal",
"cat.Ecouteurs": "Oordopjes / Hoofdtelefoon",
"cat.Electronique": "Elektronica (overige)",
"cat.Enceinte": "Luidspreker",
"cat.Gants": "Handschoenen",
"cat.Gourde": "Waterfles / Thermos",
"cat.Instrument": "Musikaal instrument",
"cat.Jouet": "Speelgoed / Pluche",
"cat.Jumelles": "Verrekijker",
"cat.Lampe": "Lamp / Zaklamp",
"cat.Liseuse": "E-booklezer",
"cat.Livre": "Boek / Notitieboek",
"cat.Lunettes": "Bril",
"cat.Manteau": "Jas / Jacket",
"cat.Maquillage": "Make-up tas",
"cat.Medical": "Medische apparatuur",
"cat.Medicaments": "Medicijnen",
"cat.Montre": "Horloge / Smartwatch",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Paraplu",
"cat.Portefeuille": "Portemonnee / Tas",
"cat.Poussette": "Kinderwagen / Babyaccessoire",
"cat.Sac": "Tas / Handtas",
"cat.SacADos": "Rugzak",
"cat.Souris": "Muis / Toetsenbord",
"cat.Sport": "Sportuitrusting",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefoon / Smartphone",
"cat.Trottinette": "Scooter",
"cat.Trousse": "Etui / Case",
"cat.USB": "USB-stick / Harde schijf",
"cat.Valise": "Koffer / Bagage",
"cat.Velo": "Fiets",
"cat.Vetements": "Kleding",
"cm.found": "GEVONDEN",
"cm.lost": "VERLOREN",
"cmp.starterEst": "1 inbegrepen + onbeperkt extra",
"consent.required": "U moet instemmen met het delen van uw contactgegevens om door te gaan.",
"consent.share": "Ik stem ermee in dat de vinder van mijn item mijn contactgegevens (naam, e-mail, telefoon) kan zien om contact met mij op te nemen voor de teruggave.",
"dc.partnerDesc": "Verlies je item op een partnerlocatie (hotel, station, hal..)? Selecteer deze voor een directe terugkeer.",
"dc.partnerList": "Kies uit de lijst",
"dc.partnerMap": "Kies op de kaart",
"dc.partnerTitle": "Aangifte bij een partner",
"dc.publicCta": "Plaats een openbare advertentie",
"dc.publicDesc": "Uw advertentie is zichtbaar voor de hele findloop-gemeenschap. Ideaal als u niet weet waar u het item kwijt bent.",
"dc.publicTitle": "Openbare aangifte",
"dc.subtitle": "Kies hoe u uw verloren item wilt rapporteren.",
"dc.title": "Wat wilt u doen?",
"dec.addrPending": "Adres in afwachting van de klant",
"dec.analyzing": "Analyseren…",
"dec.clientDescription": "Klantbeschrijving",
"dec.clientPhoto": "Foto geleverd door de klant",
"dec.clientPhotoShort": "Foto van de klant",
"dec.comparePhotos": "Foto's vergelijken",
"dec.declaredItemPhoto": "Foto van het verklaarde item",
"dec.emptyDesc": "Deel uw QR-code om verklaringen te ontvangen.",
"dec.emptyTitle": "Geen verklaringen",
"dec.enlarge": "Vergroten",
"dec.extBanner": "{n} externe betaling(en) te valideren — bevestig ontvangst hieronder om de overdracht of verzending te ontgrendelen.",
"dec.foundItemAlt": "Gevonden item",
"dec.foundItemRegistry": "Gevonden item (register)",
"dec.labelClient": "Klant",
"dec.labelRegistry": "Register",
"dec.noMatchYet": "Nog geen overeenkomsten.",
"dec.noPhoto": "Geen foto",
"dec.pRecup": "herstel",
"dec.pRecupP": "(herstel)",
"dec.pRecupShip": "(herstel + verzending)",
"dec.payConfirmed": "Betaling {x} bevestigd",
"dec.payPending": "Externe betaling {x} in behandeling",
"dec.pickup": "Persoonlijke afhaling",
"dec.reject": "Weigeren",
"dec.rerun": "Analyse opnieuw uitvoeren",
"dec.similarity": "Gelijkheid {n}%",
"dec.suggestedMatches": "Voorstellen van overeenkomsten",
"dec.toColon": " naar:",
"dec.toShip": "Te verzenden",
"dec.toastExtPay": "Betaling bevestigd — de klant wordt op de hoogte gebracht.",
"dec.toastMatch": "Overeenkomst bevestigd",
"dec.toastReject": "Suggestie afgewezen",
"dec.toastRerun": "Analyse opnieuw gestart",
"dec.toastVisualN": "{n} visuele overeenkomsten",
"dec.toastVisualNone": "Geen visuele overeenkomst",
"dec.viewBeforeAfter": "Voor/na weergave (overlay)",
"dec.viewSideBySide": "Zij-aan-zij weergave",
"dec.visualCompare": "AI visuele vergelijking",
"dec.visualIdle": "Voer de vergelijking uit zodat de AI de foto van de klant visueel matcht met gevonden items.",
"dec.visualRunning": "AI vergelijkt de foto van de klant met artikelen in uw register…",
"dec.zoomPhoto": "Vergroot de foto",
"dep.addAnyway": "Toch toevoegen",
"dep.addError": "Fout bij het toevoegen",
"dep.addItem": "Artikel toevoegen",
"dep.added": "Artikel toegevoegd aan het register!",
"dep.adding": "Aan het toevoegen…",
"dep.aiError": "AI-analyse momenteel niet beschikbaar.",
"dep.aiFilled": "Formulier automatisch ingevuld door AI ✨",
"dep.aiUnavailable": "AI niet beschikbaar — vul het formulier handmatig in.",
"dep.analyzing": "Analyseren…",
"dep.analyzingPhoto": "Foto analyseren…",
"dep.brand": "Merk",
"dep.brandPlaceholder": "bijv. Apple",
"dep.category": "Categorie",
"dep.checkingDup": "Controleren op duplicaten…",
"dep.color": "Kleur",
"dep.colorPlaceholder": "bijv. zwart",
"dep.condition": "Toestand",
"dep.conditionPlaceholder": "bijv. goede staat",
"dep.depositorNote": "Notitie van de storter",
"dep.depositorNoteHint": "Operationele details met de hand getypt. De AI overschrijft deze notitie nooit.",
"dep.depositorNotePlaceholder": "bijv. inhoud van een zak, merk zoals vermeld, details gegeven door de persoon…",
"dep.descPlaceholder": "bijv. zwarte iPhone 15 met een doorzichtige hoes, gevonden bij de bar…",
"dep.description": "Beschrijving",
"dep.dupHint": "Zorg ervoor dat u geen duplicaat toevoegt. U kunt doorgaan als het artikel echt anders is.",
"dep.dupTitle": "Vergelijkbaar artikel(s) al geregistreerd",
"dep.dupWarn": "Vergelijkbaar artikel gedetecteerd — controleer, klik dan opnieuw om te bevestigen.",
"dep.estHint": "Het artikel zal aan het register van deze zaak worden toegevoegd.",
"dep.establishment": "Zaken",
"dep.fee": "Herstellingskosten (€) — optioneel",
"dep.feePlaceholder": "Laat leeg voor de standaardprijs van de categorie",
"dep.fillAI": "Vul met AI",
"dep.optional": "(optioneel)",
"dep.photo": "Artikel foto",
"dep.principal": "primair",
"dep.reqError": "Categorie en beschrijving zijn vereist.",
"dep.savedItem": "Geregistreerd artikel",
"dep.similarity": "Overeenkomst",
"dep.storage": "Fysieke locatie",
"dep.storageHint": "Waar het artikel fysiek is opgeslagen. Er wordt een QR-code gegenereerd om het te vinden.",
"dep.storagePlaceholder": "bijv. Plank A3, Kluis 12, Ontvangstkluis",
"dl.aClient": "een klant",
"dl.alertsBlocked": "Browsermeldingen geblokkeerd",
"dl.alertsBlockedHint": "Om ze opnieuw in te schakelen: klik op het 🔒 (of ⓘ) pictogram links van het webadres, sta vervolgens Meldingen toe en vernieuw de pagina.",
"dl.amountDue": "Te betalen bedrag: {amount} {currency}.",
"dl.enableAlerts": "Meldingen inschakelen",
"dl.extPending": "Betalingen te valideren",
"dl.freemiumNear": "U nadert de Freemium limiet ({used}/{max} artikelen deze maand). Upgrade naar Starter voor onbeperkte artikelen.",
"dl.freemiumReached": "Freemium limiet bereikt ({used}/{max} artikelen deze maand). Upgrade naar Starter om onbeperkte artikelen te registreren.",
"dl.invoiceOverdue": "Factuur {num} onbetaald — toegang beperkt.",
"dl.matchNotifTitle": "Findloop — Nieuwe AI-match 🔔",
"dl.matchToast": "Nieuwe AI-match — {name}",
"dl.matchToastDesc": "Een artikel komt overeen met een verklaring.",
"dl.notifEmpty": "Nog geen meldingen.",
"dl.notifEnabled": "Browsermeldingen ingeschakeld",
"dl.notifTitle": "Meldingen",
"dl.payInvoice": "Betaal mijn factuur →",
"dl.rewardsPending": "Vouchers te presenteren",
"dl.upgradeStarter": "Upgrade naar Starter →",
"est.all": "Alle instellingen ({n})",
"est.label": "Instelling",
"est.primary": "primaire",
"est.secondary": "secundaire",
"est2.add": "Voeg een instelling toe",
"est2.addressLabel": "Adres",
"est2.addressPh": "12 République Straat",
"est2.autoInvoice": "Een gedetailleerde factuur wordt automatisch op de 1e van elke maand gegenereerd.",
"est2.baseSub": "Basisabonnement",
"est2.billing": "Facturatie",
"est2.boostActivated": "Boost geactiveerd voor {name}",
"est2.boostBillingNote": "Gefactureerd tegen het huidige tarief en gegroepeerd op uw geconsolideerde maandfactuur.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Verbeter de zichtbaarheid van deze instelling in de directory en op de kaart.",
"est2.boostDuration": "{h}u van verhoogde zichtbaarheid",
"est2.boostExtend": "Verlengen",
"est2.boostTitle": "Boost {name}",
"est2.boosted": "Verhoogd",
"est2.chartDesc": "Aandeel geretourneerde items van het totaal geregistreerd, site per site.",
"est2.chartTitle": "Retourpercentage per instelling",
"est2.chartTooltip": "Retour",
"est2.cityLabel": "Stad",
"est2.cityPh": "Lyon",
"est2.contactHint": "Deze gegevens worden aan de klant getoond voor deze instelling (valt terug op het account als het leeg is).",
"est2.countryLabel": "Land",
"est2.coverLabel": "Coverfoto",
"est2.create": "Aanmaken",
"est2.created": "Instelling aangemaakt",
"est2.delete": "Verwijderen",
"est2.deleteDesc": "Deze actie is permanent. U kunt een instelling alleen verwijderen als deze geen items bevat.",
"est2.deleteTitle": "Verwijder “{name}”?",
"est2.deleted": "Instelling verwijderd",
"est2.dialogDesc": "Voer de naam en het adres van deze locatie in.",
"est2.edit": "Bewerken",
"est2.editEst": "Instelling bewerken",
"est2.emailLabel": "Contact e-mail",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " instelling(en)",
"est2.extraNoteBase": "{n} aanvullende instelling(en) gefactureerd",
"est2.extraPrice": " tegen {price} €/maand.",
"est2.extraQuote": " op offerte.",
"est2.imgChange": "Kies een afbeelding",
"est2.imgDone": "Klaar",
"est2.imgRemove": "Verwijderen",
"est2.imgRemoved": "Afbeelding verwijderd",
"est2.imgSaved": "Afbeelding opgeslagen",
"est2.imgUploading": "Uploaden…",
"est2.includedPlan": "Inbegrepen in uw plan: {n}.",
"est2.kDeclarations": "Declaraties",
"est2.kInStorage": "In opslag",
"est2.kItemsTotal": "Items (totaal)",
"est2.kRestituted": "Geretourneerd",
"est2.limitReached": "Limiet bereikt",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Decl.",
"est2.mItems": "Items",
"est2.mRestituted": "Geretourneerd",
"est2.mStorage": "In opslag",
"est2.monthlyTotal": "Maandtotaal",
"est2.nameLabel": "Naam *",
"est2.namePh": "bijv. Belmont Hotel — Lyon Annex",
"est2.newEst": "Nieuwe vestiging",
"est2.onQuote": "Op offerte",
"est2.phoneLabel": "Telefoon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plan",
"est2.planLimited": "Uw “{tier}” plan is beperkt tot {max} vestiging(en).",
"est2.primary": "Primair",
"est2.qr": "QR-code",
"est2.qrDesc": "Toon deze QR-code in deze vestiging. Klanten die verlies melden worden naar deze site geleid.",
"est2.qrTitle": "QR-code — {name}",
"est2.saving": "Opslaan…",
"est2.seeInvoices": "Bekijk mijn maandfacturen",
"est2.seePlans": "Bekijk de plannen",
"est2.subtitle": "Beheer al uw locaties onder één account — geconsolideerd overzicht, items, QR-code en facturering.",
"est2.suspended": "Geannuleerd",
"est2.tierFree": "1 vestiging",
"est2.tierLarge": "ongelimiteerde vestigingen",
"est2.tierMedium": "5 vestigingen inbegrepen",
"est2.tierSmall": "3 vestigingen inbegrepen",
"est2.title": "Vestigingen",
"est2.unlimitedPlan": "Uw plan staat een onbeperkt aantal vestigingen toe.",
"est2.unlimitedSuffix": " · onbeperkt",
"est2.updated": "Vestiging bijgewerkt",
"est2.upgradeHint": "Upgrade naar een hoger plan om meer locaties toe te voegen en alle uw activiteiten te centraliseren.",
"est2.visuals": "Logo & foto",
"est2.visualsDesc": "Pas het logo en de omslagfoto van deze vestiging aan. Ze verschijnen op de openbare pagina en het aangifteformulier.",
"est2.visualsTitle": "Visuals — {name}",
"est2.workOn": "Werk aan deze vestiging",
"est2.working": "U werkt aan “{name}”",
"ft.backAccount": "Terug naar Mijn account",
"ft.closeBtn": "Sluit de zaak",
"ft.closeConfirm": "Bevestig dat het item is teruggebracht? De advertentie zal worden gesloten.",
"ft.closeLockedHint": "Valideer eerst de code van de eigenaar om te ontgrendelen.",
"ft.closed": "Zaak gesloten — item teruggebracht!",
"ft.codeLabel": "Voer de validatiecode in die u van de eigenaar heeft ontvangen",
"ft.codeNeeded": "Voer alstublieft de validatiecode in.",
"ft.codeOk": "Code gevalideerd — u kunt de zaak sluiten.",
"ft.codePlaceholder": "bijv. 4821",
"ft.codeVerified": "Gevalideerd",
"ft.doneMsg": "Item teruggebracht. Bedankt voor het helpen retourneren naar de eigenaar!",
"ft.stepInProgress": "Retourneren in uitvoering",
"ft.stepPublished": "Advertentie gepubliceerd",
"ft.stepReturned": "Item teruggebracht",
"ft.subtitle": "Volg de stappen totdat het gevonden item is teruggebracht.",
"ft.title": "Retourregistratie",
"ft.verifyBtn": "Valideer code",
"inv2.contractTitle": "Mijn findloop-contract",
"inv2.detailByEst": "Detail per vestiging",
"inv2.dueLabel": "Vervaldatum:",
"inv2.dueSuffix": " · vervaldatum {date}",
"inv2.error": "Fout {status}",
"inv2.estCountIssued": "{n} vestiging(en) · uitgegeven op {date}",
"inv2.estimate": "Schatting (niet gefactureerd) · {n} vestiging(en)",
"inv2.expired": " · verlopen",
"inv2.exportCsv": "Exporteer CSV",
"inv2.exportDone": "CSV-export gedownload",
"inv2.included": "Inbegrepen",
"inv2.monthlyTitle": "Maandelijkse facturering (abonnement)",
"inv2.months": "+{n} maanden",
"inv2.paid": "Betaald",
"inv2.pay": "Betalen",
"inv2.previewTitle": "Voorbeeld van je volgende factuur —",
"inv2.renew": "Verleng mijn contract",
"inv2.renewalsTitle": "Verlenggeschiedenis ({n})",
"inv2.renewedUntil": "Contract verlengd tot {date}",
"inv2.serviceTitle": "Dienstenfacturen (terugvorderingen & offertes)",
"inv2.soon": "Vervalt binnenkort",
"inv2.toPay": "Te betalen",
"inv2.totalHtTva": "Totaal excl. btw · BTW",
"inv2.totalTtc": "Totaal incl. btw",
"iu.addPhoto": "Voeg een foto toe",
"iu.change": "Wijzigen",
"map.high": "Hoog",
"map.legend": "Gekleurde stippen van rood (laag) naar groen (hoog) op basis van het retourpercentage; grootte gebaseerd op het aantal items.",
"map.locating": "Locatie bepalen… voeg een adres toe aan je vestigingen om ze op de kaart te zien.",
"map.low": "Laag",
"map.medium": "Medium",
"map.noItemRegistered": "Geen item geregistreerd",
"map.noItems": "Geen item",
"map.returnedSuffix": "teruggegeven · {a}/{t} items",
"map.title": "Kaart van je vestigingen",
"mc.archiveHide": "Verberg geschiedenis",
"mc.archiveNone": "Nog geen opgelost geval.",
"mc.archiveShow": "Toon geschiedenis",
"mc.archiveSub": "Opgeloste en teruggegeven gevallen.",
"mc.archiveTitle": "Geschiedenis",
"mc.certificate": "Certificaat",
"mc.finderAccepted": "Geaccepteerd",
"mc.hAd": "Verloren advertentie",
"mc.hDeclaration": "Aangifte",
"mc.hFinderContact": "Geleverd item",
"mc.hFound": "Teruggegeven item",
"mc.hFoundAd": "Gevonden advertentie",
"mc.myFinds": "Items die ik heb gevonden",
"mc.myFindsNone": "Je hebt nog geen item gevonden gerapporteerd.",
"mc.myFindsSub": "Items die je hebt gerapporteerd op verloren-item advertenties.",
"mc.notifOpen": "Bekijk",
"mc.notifTrack": "Volgen",
"mc.notifViewAd": "Bekijk advertentie",
"mc.presentHint": "Toon deze QR-code aan de partner: zij scannen om je beloning te valideren.",
"mc.presentInStore": "Toon in de winkel",
"mc.presentTitle": "Toon deze voucher",
"mc2.acceptFinder": "Accepteer deze vindende",
"mc2.accountActivity": "Accountactiviteit",
"mc2.adsActive": "{n}/5 actieve advertenties",
"mc2.autoDelete": "Automatische verwijdering gepland voor",
"mc2.badgeBronze": "Brons",
"mc2.badgeGold": "Goud",
"mc2.badgeSilver": "Zilver",
"mc2.boostEarnedAlready": "Het heeft je al opgeleverd",
"mc2.boostEarnedWin": "Het heeft je opgeleverd",
"mc2.boostExpiredWin": "Je boost is net verlopen — hervat met -20%!",
"mc2.boostExpiresIn": "Je boost verloopt in",
"mc2.boostWinDetail2": ". -20% wordt automatisch toegepast als je binnen 24u verlengt.",
"mc2.claimCode": "Claimcode:",
"mc2.codeSentFinder": "Code naar de vindende verzonden via e-mail",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Download mijn recept",
"mc2.error": "Fout {status}",
"mc2.finderAccepted": "Finder geaccepteerd — code per e-mail verzonden",
"mc2.finderContacts": "Contactgegevens van de Finder(s)",
"mc2.followFindo": "Volg Findloop",
"mc2.imgInvalid": "Ongeldig beeld",
"mc2.inactivityNote": " — bij {n} maanden inactiviteit (GDPR).",
"mc2.lastActivity": "Laatste activiteit:",
"mc2.lostEmailTitle": "Ik heb geen toegang meer tot mijn e-mail",
"mc2.noPhotoPreset": "Nog geen foto? Kies een standaard avatar:",
"mc2.paidViaPartner": "Betaald (via partner)",
"mc2.payRecovery": "Betaal de herstelkosten",
"mc2.paySettle": "Regel mijn betaling",
"mc2.payShipping": "Betaal de verzendkosten",
"mc2.payUnavailable": "Betaling niet beschikbaar",
"mc2.peopleFound": "{n} persoon(s) denkt dat ze jouw item hebben gevonden",
"mc2.phoneNumber": "Telefoonnummer",
"mc2.reactivateAccount": "Reactiveer mijn account",
"mc2.reactivated": "Account geheractiveerd",
"mc2.reactivatedThanks": "Account geheractiveerd — bedankt voor je loyaliteit!",
"mc2.recoverSmsBtn": "Ontvang mijn code per SMS",
"mc2.recoverSmsDesc": "Ontvang je claimcode per SMS op het nummer dat aan je account is gekoppeld.",
"mc2.recoverSmsFallback": "Als er een account bestaat met dit nummer, is er een SMS verzonden.",
"mc2.renewStayTop": ". Vernieuw om bovenaan te blijven en je item terug te krijgen.",
"mc2.resume20": "Hervatten -20%",
"mc2.unlockContacts": "Ontgrendel contactgegevens",
"mc2.unlockDesc": "Betaal de Findloop behandelingskosten om hun contactgegevens te onthullen en de overdracht te regelen.",
"mc2.viewsWord": "weergaven",
"mc2.live": "Live",
"mh.allCategories": "Alle categorieën",
"mh.allPeriod": "Alle tijd",
"mh.autoMatch": "Automatische AI-match",
"mh.blocked": "Geblokkeerd (tegenstrijdigheid)",
"mh.blockedReason": "Match geblokkeerd: de belangrijkste zoekwoorden van het item en de verklaring contradictoriseren elkaar.",
"mh.days30": "Laatste 30 dagen",
"mh.days7": "Laatste 7 dagen",
"mh.days90": "Laatste 90 dagen",
"mh.emptyDesc": "AI-matches verschijnen hier zodra de verklaringen binnenkomen.",
"mh.emptyTitle": "Geen evenementen",
"mh.exportCsv": "Exporteer CSV",
"mh.exportDone": "CSV-export gedownload",
"mh.exportImpossible": "Export mislukt",
"mh.fBlocked": "Geblokkeerd",
"mh.fConfirmed": "Bevestigd",
"mh.fRejected": "Afgewezen",
"mh.objectLabel": "Item:",
"mh.refresh": "Vernieuwen",
"mh.rejected": "Afgewezen",
"mh.srcManual": "Handmatig",
"mh.srcText": "Tekst",
"mh.srcVisual": "Visueel (foto)",
"mh.subtitle": "Log van door AI voorgestelde matches — automatisch gematcht, bevestigd en afgewezen.",
"mh.title": "AI Geschiedenis",
"nf.desc": "De pagina die je zoekt bestaat niet of is verplaatst.",
"nf.home": "Terug naar de startpagina",
"nf.title": "Pagina niet gevonden",
"par.allCities": "Alle steden",
"par.cityPh": "Stad",
"pay.eurNote": "Bedragen weergegeven in euro's (€).",
"pg.next": "Volgende",
"pg.prev": "Vorige",
"pg.showing": "{from}–{to} van {total}",
"pk.bodyCopy": "Body copy",
"pk.bodyText": "Lichaamstekst",
"pk.brandColors": "Merk kleuren",
"pk.colorRed": "Rood",
"pk.colorWhite": "Wit",
"pk.darkBg": "Donkere achtergrond",
"pk.download": "Downloaden",
"pk.downloadZip": "Download het hele pakket (ZIP)",
"pk.headings": "Koppen",
"pk.heroDesc": "Officiële logo's, banners voor sociale media, kleuren en typografie. Kies de tagline taal en variant, en download daarna de visual of het volledige pakket.",
"pk.lightBg": "Lichte achtergrond (print)",
"pk.logoWordmark": "Logo / woordmerk",
"pk.logosVisuals": "Logo's & visuals",
"pk.mapCollect": "Kaart / verzamelpunten",
"pk.plain": "Eenvoudig",
"pk.pressKit": "Perskit",
"pk.taglineLang": "Tagline taal",
"pk.typography": "Typografie",
"pk.variant": "Variant",
"pr2.adBoostMsg": "Geweldige keuze! Je vergroot je kansen om je item snel terug te krijgen.",
"pr2.boostActivated": "Boost geactiveerd!",
"pr2.canRecoverNow": "Je kunt nu je item terugkrijgen.",
"pr2.continue": "Doorgaan",
"pr2.downloadReceiptPdf": "Download de ontvangstbewijs (PDF)",
"pr2.goToSpaceNow": "Ga nu naar mijn account",
"pr2.partnerBoostMsg": "Geweldige keuze! Meer zichtbaarheid betekent nieuwe klanten naar je onderneming trekken.",
"pr2.paymentSuccess": "Betaling succesvol!",
"pr2.redirectingSpace": "Onover te voor je account…",
"pr2.subActivated": "Betaling succesvol! Je abonnement is actief, je kunt nu je ondernemingen beheren.",
"prev.allSites": "Alle ondernemingen",
"pricing.annual": "Jaarlijks",
"pricing.annualBadge": "-20% aanbieding",
"pricing.monthly": "Maandelijks",
"pricing.perYear": "/jr",
"pricing.saveLabel": "Je bespaart",
"pricing.savePerYear": "/jr per extra onderneming",
"pub.accessGranted": "Toegang verleend",
"pub.accessLimited2h": "Toegang beperkt tot 2 uur",
"pub.accountEmailConcerned": "E-mail van het betreffende account",
"pub.adAppearPublic": "Zo verschijnt je advertentie openbaar.",
"pub.adPreviewBtn": "Advertentie voorbeeld",
"pub.alertMeOnArrival": "Waarschuw me bij aankomst",
"pub.allActionsLogged": "Alle acties zijn gelogd",
"pub.allCategories": "Alle categorieën",
"pub.authorizeAccess": "Toegang verlenen",
"pub.authorizeSupportQ": "Toegang voor ondersteuning verlenen?",
"pub.available": "Beschikbaar",
"pub.backHome": "Terug naar huis",
"pub.boostAdCta": "Boost mijn advertentie",
"pub.boostAdTitle": "Boost je advertentie",
"pub.boostCarouselSub": "Verplaats naar de top van de pagina in de “Geboeide” carrousel en vermenigvuldig weergaven om je item sneller terug te krijgen.",
"pub.boostEstablishment": "Boost je onderneming",
"pub.boostEstablishmentDesc": "Verschijn bovenaan de directory met een “Geboeide” badge en trek meer meldingen aan.",
"pub.boostFicheCta": "Boost mijn vermelding",
"pub.brandReady": "Het Findloop merk, klaar voor gebruik",
"pub.cantFindItem": "Kan je item niet vinden?",
"pub.cantProcessImage": "Kan deze afbeelding niet verwerken",
"pub.claimQr": "Claim QR-code",
"pub.clickToZoom": "Klik om in te zoomen",
"pub.codeAlreadyValidated": "Code gevalideerd — contacten ontgrendeld.",
"pub.codeExample": "bijv. ABCD2345",
"pub.confirmRenewal": "Bevestig verlenging",
"pub.contactIntro": "Een vraag, een verzoek? Schrijf naar ons, we komen snel bij je terug.",
"pub.contactTypeDeceased": "Accountverwijdering (overleden persoon)",
"pub.contactTypeGeneral": "Algemene vraag",
"pub.contactTypeSupport": "Ondersteuning / technische kwestie",
"pub.contactUs": "Neem contact met ons op",
"pub.continueWithoutEmail": "Doorgaan zonder mijn e-mailadres achter te laten",
"pub.contractLabel": "Contract",
"pub.contractNotFound": "Contract niet gevonden of al verlopen.",
"pub.contractRenewed": "Contract verlengd!",
"pub.contractRenewedFor": "Je contract is verlengd voor {n} maanden.",
"pub.copyFailed": "Kopiëren mislukt",
"pub.createPartnerAccount": "Maak mijn partneraccount aan",
"pub.currentDeadline": "Huidige deadline",
"pub.deceasedInfo": "Als familielid of erfgenaam kun je de verwijdering van een overleden persoon's findloop-account aanvragen. We zullen je verzoek verwerken in overeenstemming met de AVG (ondersteunende documenten kunnen worden gevraagd).",
"pub.declareMyLoss": "Meld mijn verlies",
"pub.describeItemPlaceholder": "Beschrijf je item (bijv. zwarte paraplu, sleutels…)",
"pub.downloadImage": "Download de afbeelding",
"pub.drawSignature": "Trek alsjeblieft je handtekening.",
"pub.drawSignatureHint": "Trek je handtekening met de muis of je vinger.",
"pub.duration": "Duur",
"pub.eSignature": "Digitale handtekening",
"pub.eSignatureDesc": "Voer je naam in om te ondertekenen. De datum wordt automatisch geregistreerd.",
"pub.edit": "Bewerken",
"pub.editorialTitles": "Redactionele titels",
"pub.emailPlaceholder": "je@example.com",
"pub.enterCodeUnlockOwner": "Voer de code in die je per e-mail hebt ontvangen om de contactgegevens van de eigenaar te ontsluiten.",
"pub.errorWord": "Fout",
"pub.foundSelfService": "Gevonden items · Zelfservice",
"pub.haveOwnerCode": "Ik heb een code ontvangen van de eigenaar",
"pub.home": "Home",
"pub.immediateRenewal": "Onmiddellijke verlenging, zonder nieuwe offerte.",
"pub.impAdminReq1": "Administrator",
"pub.impAdminReq2": "verzoekt toestemming om tijdelijk toegang te krijgen tot je account",
"pub.impAdminReq3": "om je te helpen.",
"pub.impGrantedDesc": "Het ondersteuningsteam kan maximaal 2 uur toegang krijgen tot je account. Elke actie wordt geregistreerd. Je kunt deze pagina sluiten.",
"pub.invitedOnFindo": "Je bent uitgenodigd voor Findloop",
"pub.isThisYourItem": "Is dit jouw item?",
"pub.itemsAvailableCount": "{n} item(s) momenteel beschikbaar",
"pub.itemsFoundOwner": "van vertrouwde items heeft hun eigenaar gevonden",
"pub.itemsReturnedOwners": "items teruggegeven aan hun eigenaren",
"pub.itsMine": "Het is van mij",
"pub.joinFindoDesc": "Word lid van Findloop en beheer je gevonden items eenvoudig.",
"pub.joinInvitesYou": "nodigt je uit om lid te worden van findloop. Maak je partneraccount aan om je gevonden items te beheren.",
"pub.linkCopied": "Link gekopieerd!",
"pub.loadingContract": "Contract aan het laden…",
"pub.lsClaimDesc": "Meld je verlies om het terug te krijgen. Laat je e-mailadres achter en we sturen je een herinnering als je melding niet is voltooid.",
"pub.lsHeroDesc": "Controleer zelf of je verloren item hier is gevonden en achtergelaten. Gevonden? Meld het om het terug te krijgen.",
"pub.lsSearchTitle": "Zoek naar gevonden items",
"pub.makeOffer": "Doe een bod",
"pub.makeOfferDesc": "Stel je bedrag voor. De superadmin zal het beoordelen.",
"pub.mapNearYou": "Items & partners bij jou in de buurt",
"pub.mapWord": "Kaart",
"pub.messageSentToast": "Bericht verzonden — ons team zal snel antwoorden.",
"pub.messageWord": "Bericht",
"pub.momoInitiated": "Mobiele geldbetaling geïnitieerd",
"pub.monthsWord": "maanden",
"pub.nameConsentRequired": "Naam en toestemming vereist.",
"pub.newDeadline": "Nieuwe deadline",
"pub.noActionRequired": "Geen actie vereist.",
"pub.noAmountCharged": "Er is geen bedrag in rekening gebracht.",
"pub.noItemMatch": "Op dit moment komt er geen beschikbaar item overeen met je zoekopdracht.",
"pub.noMatchingItem": "Geen overeenkomend item",
"pub.noPaymentSession": "Geen betalingssessie.",
"pub.noPhoto": "Geen foto",
"pub.noPointsYet": "Nog geen punten om weer te geven.",
"pub.noSecondPayment": "Er is geen tweede betaling vereist voor dit item.",
"pub.notHereYet": "Nog niet hier? Ontvang een melding zodra het arriveert.",
"pub.notifyDone": "Genoteerd! We brengen je per e-mail op de hoogte zodra er een overeenkomend item arriveert.",
"pub.offerSubmitted": "Je bieding is ingediend.",
"pub.oops": "Oeps",
"pub.orAlertEmail": "Of krijg een melding per e-mail zodra er een overeenkomend item arriveert:",
"pub.ownerContacts": "Contactgegevens van de eigenaar",
"pub.ownerContactsUnlocked": "Contactgegevens van de eigenaar ontgrendeld",
"pub.partnerContact": "Partnercontact",
"pub.payLinkUnavailable": "Betalingslink niet beschikbaar — neem contact op met de partner.",
"pub.paymentCancelled": "Betaling geannuleerd",
"pub.paymentConfirmed": "Betaling bevestigd 🎉",
"pub.paymentConfirmedDesc": "Je ontvangt een e-mail met de details om je item te recupereren.",
"pub.paymentNotConfirmed": "Betaling niet bevestigd",
"pub.paymentNotConfirmedDesc": "De betaling kon niet worden geverifieerd. Probeer het opnieuw of neem contact op met de partner.",
"pub.paymentProcessing": "Betaling wordt verwerkt. Vernieuw over een moment.",
"pub.photoAdded": "✓ Foto toegevoegd",
"pub.photoRequired": "Een foto van het item is vereist.",
"pub.previewAlt": "voorvertoning",
"pub.publish": "Publiceren",
"pub.publishingWord": "Publiceren…",
"pub.qty": "Aantal",
"pub.quoteDeclined": "Offerte afgewezen.",
"pub.quoteNotFound": "Offerte niet gevonden of verlopen.",
"pub.reasonLabel": "Reden",
"pub.recoveryAlreadyPaid": "Herstelvergoeding al betaald",
"pub.referralCode": "Verwijzingscode:",
"pub.relationshipPlaceholder": "Zoon, echtgenoot, notaris…",
"pub.renewYourContract": "Verleng je contract",
"pub.renewalFailed": "Verlenging mislukt. Probeer het later opnieuw.",
"pub.renewing": "Verlengen…",
"pub.replySoon": "Ons team zal zo snel mogelijk antwoorden.",
"pub.requestGone": "Dit verzoek bestaat niet meer.",
"pub.requestHandled": "Verzoek al afgehandeld",
"pub.requestNotFound": "Verzoek niet gevonden of verlopen.",
"pub.requestUnavailable": "Verzoek niet beschikbaar",
"pub.required": "(vereist)",
"pub.retroClosing": "Samen maken we de wereld een beetje minder verloren.",
"pub.retroClosing2": "Samen maken we de wereld een beetje minder verloren.",
"pub.retroScroll": "Een jaar van het recupereren van wat belangrijk is. Scroll naar beneden ↓",
"pub.revokeAnytime": "Je kunt op elk moment intrekken door contact met ons op te nemen",
"pub.scene": "Scène",
"pub.sendImpossible": "Kan niet verzenden",
"pub.sendMessage": "Stuur het bericht",
"pub.sending": "Verzenden…",
"pub.sharePreview": "Deel voorvertoning",
"pub.shareYourAd": "Deel je advertentie",
"pub.signedSuccess": "Succesvol getekend!",
"pub.signerFullName": "Volledige naam van de ondertekenaar",
"pub.spreadNetwork": "Deel het met de mensen om je heen om je kansen te vergroten.",
"pub.spreadOwner": "Deel het om de eigenaar te helpen zijn bezittingen terug te krijgen.",
"pub.statusLabel": "Status:",
"pub.subject": "Onderwerp",
"pub.thanksSent": "Bedankt, je bericht is verzonden.",
"pub.thisYear": "Dit jaar",
"pub.validate": "Valideren",
"pub.verifyingPayment": "Betaling verificeren…",
"pub.verifyingYourPayment": "Je betaling verifiëren…",
"pub.viewAd": "Bekijk de advertentie →",
"pub.viewPartner": "Bekijk de partner →",
"pub.yourAdPreview": "Voorbeeld van je advertentie",
"pub.yourEmail": "Je e-mail",
"pub.yourEmailRecommended": "Je e-mail (aanbevolen)",
"pub.yourEmailShort": "Je e-mail",
"pub.yourName": "Je naam",
"pub.yourRelationship": "Je relatie tot de persoon",
"qv.acceptAndSign": "Accepteer en teken mijn offerte",
"qv.certifyAuthorized": "Ik bevestig dat ik bevoegd ben om te tekenen en ik accepteer de voorwaarden van deze {what} (bindende waarde).",
"qv.clear": "Wissen",
"qv.client": "Klant",
"qv.conditions": "Voorwaarden",
"qv.confirmDecline": "Bevestig de weigering van deze offerte?",
"qv.countersignedFindo": "Tegengetekend door Findloop · {name} op {date}",
"qv.decline": "Weigeren",
"qv.description": "Beschrijving",
"qv.downloadPdf": "Download de PDF",
"qv.handwrittenSignature": "Handtekening",
"qv.inclTax": "Incl. belasting",
"qv.invalidAmount": "Ongeldig bedrag.",
"qv.invoice": "Factuur",
"qv.invoicePaid": "Factuur betaald",
"qv.issuer": "Uitgever",
"qv.messageOptional": "Bericht (optioneel)",
"qv.negotiatedAmount": "Onderhandeld bedrag",
"qv.payInvoiceOnline": "Betaal de factuur online",
"qv.quote": "Offerte",
"qv.quoteValidDays": "Offerte geldig voor {n} dagen.",
"qv.sendMyOffer": "Stuur mijn aanbod",
"qv.signContract": "Teken mijn contract",
"qv.signNow": "Teken nu",
"qv.signatureAlt": "Handtekening",
"qv.signedByOn": "✔ Ondertekend door {name} op {date}",
"qv.stContractSigned": "Contract ondertekend. Bedankt!",
"qv.stCounterAccepted": "Je aanbod is geaccepteerd! Teken je contract hieronder.",
"qv.stCounterRefused": "Je aanbod kon niet worden geaccepteerd.",
"qv.stCountered": "Je aanbod is ingediend. Wachten op de reactie van findloop.",
"qv.stDeclined": "Je hebt deze offerte geweigerd.",
"qv.stSigned": "Offerte geaccepteerd en ondertekend. Bedankt!",
"qv.totalHt": "Totaal excl. belasting",
"qv.totalTtc": "Totaal incl. belasting",
"qv.unitHt": "Eenheid excl. belasting",
"qv.vat": "BTW",
"qv.yourProposedAmount": "Je voorgestelde bedrag ({cur})",
"reg.add": "Een item registreren",
"reg.allBrands": "Alle merken",
"reg.allColors": "Alle kleuren",
"reg.allLocations": "Alle locaties",
"reg.detailDesc": "Details en acties voor dit gevonden item.",
"reg.dispAuction": "Veiling",
"reg.dispAuthorities": "Overgedragen aan autoriteiten",
"reg.dispDestroyed": "Vernietigd",
"reg.dispDonate": "Donatie aan het goede doel",
"reg.dispositionHint": "Registreer het item dat de opslag verlaat. Geteld in statistieken per categorie.",
"reg.emptyCta": "Een item registreren",
"reg.emptyDesc": "Begin met het registreren van je eerste gevonden item.",
"reg.emptyTitle": "Geen items gevonden",
"reg.establishmentFallback": "de instelling",
"reg.lblAuctioned": "geëxposeerd op veiling",
"reg.lblAuctionedShort": "geveild",
"reg.lblAuthorities": "overgedragen aan de autoriteiten",
"reg.lblDestroyed": "vernietigd",
"reg.lblDonated": "gedoneerd aan een goed doel",
"reg.legalCount": "{n} item(s): wettelijke bewaartermijn bereikt",
"reg.legalHint": "Je kunt ze op veiling zetten, aan een goed doel doneren of melden dat je ze aan de autoriteiten hebt overgedragen.",
"reg.legalLimitCountry": "Deadline: {date} · toegepast land: {country}",
"reg.legalOver": "Deadline voorbij: {date} · {country}",
"reg.legalReached": "Wettelijke periode bereikt",
"reg.legalReachedFull": "Wettelijke bewaartermijn bereikt",
"reg.limitShort": "deadline",
"reg.location": "Locatie",
"reg.markRestituted": "Markeer als teruggegeven",
"reg.markedAs": "Item gemarkeerd als {label}",
"reg.moveHistory": "Verhuishistorie",
"reg.overBy": "over {n}d",
"reg.physicalLocation": "Fysieke locatie",
"reg.popupBlocked": "Sta pop-ups toe om de labels af te drukken.",
"reg.popupBlockedOne": "Sta pop-ups toe om het label af te drukken.",
"reg.printLabel": "Print het label",
"reg.printN": "Print {n} label(s)",
"reg.qrCodeItem": "Item QR-code",
"reg.qrLabelTitle": "QR-label",
"reg.qrLabelsTitle": "QR-labels",
"reg.qrNotFound": "Geen item gevonden voor deze QR-code.",
"reg.qrScanHint": "Scan het om deze registratie direct te openen en de locatie te vinden.",
"reg.recoveryFee": "Herstelkosten (€)",
"reg.searchPh": "Zoek op beschrijving…",
"reg.selectQr": "Selecteer om QR-labels af te drukken",
"reg.selectedN": "{n} geselecteerd",
"reg.shipPricePh": "Verzendprijs (€)",
"reg.shippingPossible": "Verzending mogelijk",
"reg.storagePh": "bijv. Plank A3, Kluis 12",
"reg.tAuction": "Veiling op Findloop",
"reg.tAuthorities": "Melden aan autoriteiten",
"reg.tDonate": "Doneren aan een goed doel",
"reg.toastFee": "Kosten bijgewerkt",
"reg.toastLocation": "Locatie opgeslagen",
"reg.toastRestituted": "Item gemarkeerd als teruggegeven",
"reg.toastShipping": "Verzendoptie bijgewerkt",
"reg.toastTransferred": "Item overgedragen aan “{name}”",
"reg.unclaimedDisposition": "Ongemeld item — definitieve bestemming",
"res.codeValidated": "Code gevalideerd",
"res.empty": "Nog geen restitutie geregistreerd.",
"res.error": "Fout {status}",
"res.proofPdf": "PDF bewijs",
"res.signed": "Getekend",
"res.stRestituted": "Persoonlijk overhandigd",
"res.stShipped": "Retour verzonden",
"res.subtitle": "Alle voltooide overdrachten, met hun downloadbare getekende bewijs.",
"res.title": "Restitutiegeschiedenis",
"rev.restitutedBy": "Teruggegeven door {org}",
"rev.storiesEyebrow": "Gelukkige eindes",
"rev.storiesSubtitle": "Echte verhalen van klanten die hun bezittingen met Findloop hebben teruggevonden.",
"rev.storiesTitle": "Ze vonden hun bezittingen!",
"rp.already": "Je hebt deze vermelding al gemeld.",
"rp.duplicate": "Dupliceer",
"rp.inappropriate": "Ongepaste inhoud",
"rp.wrongCategory": "Verkeerde categorie",
"rt.annualGoal": "Jaarlijks doel",
"rt.championCity": "Kampioensstad",
"rt.cityRate": "{rate}% retourpercentage",
"rt.goalProgress": "{rate}% behaald van een {target}% doel",
"rt.reached": "Bereikt 🎉",
"rt.restitutionRate": "Retourpercentage",
"rt.shareRecap": "Deel mijn samenvatting",
"rt.thanks": "Dank je wel Findloop {year} 💛",
"rt.yourRecap": "Jouw samenvatting van {year}",
"rw.active": "Actief",
"rw.add": "Toevoegen",
"rw.camUnavailable": "Camera niet beschikbaar. Voer de code handmatig hieronder in.",
"rw.codeValidated": "Code gevalideerd",
"rw.codesTitle": "Codes ingewisseld door finders",
"rw.confirmDelete": "Verwijder “{title}”?",
"rw.deleted": "Verwijderd",
"rw.edit": "Bewerken",
"rw.editReward": "Bewerk de beloning",
"rw.empty": "Nog geen beloning.",
"rw.expired": "Verlopen",
"rw.expiresOn": "Verloopt op {date}",
"rw.fActive": "Actief (zichtbaar voor finders)",
"rw.fCost": "Kosten (punten)",
"rw.fDesc": "Omschrijving",
"rw.fStock": "Voorraad (lege = ongelimiteerd)",
"rw.fTitle": "Titel",
"rw.fValidity": "Geldigheid van de voucher (dagen na inwisseling)",
"rw.inactive": "Inactief",
"rw.newReward": "Nieuwe beloning",
"rw.noExchange": "Nog geen inwisseling.",
"rw.pageSubtitle": "Scan de vouchers die door finders worden gepresenteerd om hun beloningen te valideren.",
"rw.redeemedN": "Ingewisseld: {n}×",
"rw.saved": "Beloning opgeslagen",
"rw.scanVoucher": "Scan een voucher",
"rw.staffScanOnly": "Alleen scannen",
"rw.statActive": "Te presenteren",
"rw.statExpired": "Verlopen",
"rw.statRedeemed": "Vouchers ingewisseld",
"rw.statUsed": "Gevalideerd",
"rw.stock": "Voorraad",
"rw.subtitle": "Bied niet-monetaire voordelen (vouchers, upgrades…) die finders inwisselen voor hun Finder Score punten.",
"rw.title": "Beloningen voor finders",
"rw.used": "Gebruikt",
"rw.validate": "Valideer",
"rw.validateCode": "Valideer de code",
"rw.validity": "Geldigheid: {n} d",
"side.establishments": "Vestigingen",
"side.restitutions": "Retours",
"side.rewards": "Beloningen & Vouchers",
"side.settings": "Instellingen",
"side.storage": "Opslag & QR",
"status.auctioned": "Geveild",
"status.destroyed": "Verwoest",
"status.donated": "Gedoneerd (liefdadigheid)",
"status.handed_to_authorities": "Overhandigd aan autoriteiten",
"status.in_storage": "In opslag",
"status.matched": "Gepaard",
"status.open": "Open",
"status.paid": "Betaald",
"status.pending": "In afwachting",
"status.restituted": "Geretourneerd",
"status.shipped": "Verzonden",
"status.shipping_requested": "Verzending aangevraagd",
"status.submitted": "Ingediend",
"stg.allLabels": "Alle QR-labels",
"stg.camHint": "Gebruik de handmatige invoer hieronder.",
"stg.camStarting": "Camera wordt opgestart…",
"stg.camUnavailable": "Camera niet beschikbaar.",
"stg.clear": "Wissen",
"stg.clearAll": "Alles wissen",
"stg.codeUnreadable": "Onleesbare code.",
"stg.emptyDesc": "Opgeslagen items verschijnen hier, gegroepeerd per locatie.",
"stg.emptyTitle": "Geen item in opslag",
"stg.exportAudit": "Exporteer audit CSV",
"stg.exportDone": "CSV-export gedownload",
"stg.exportImpossible": "Export op dit moment niet beschikbaar.",
"stg.itemFound": "Item gevonden ✅",
"stg.kLocations": "Gebruikte locaties",
"stg.kObjects": "Opgeslagen items",
"stg.kToClear": "Te wissen locaties",
"stg.locFreed": "Locatie gewist",
"stg.locsFreed": "{n} locatie(s) gewist",
"stg.manualLabel": "Of voer de code / ID van het item in",
"stg.manualPh": "Plak de ID of URL van de QR",
"stg.noItemMatch": "Geen item dat overeenkomt met deze QR / code.",
"stg.noLocation": "Geen locatie",
"stg.objectsAxis": "Items",
"stg.objectsN": "{n} item(s)",
"stg.occAvg": "gem. {n} items/lokatie",
"stg.occHint": "Locaties in amber overschrijden het gemiddelde (mogelijk overbelast).",
"stg.occupancy": "Locatiebezetting",
"stg.openPage": "Open de pagina",
"stg.posterPdf": "PDF-poster (A4)",
"stg.printAll": "Alles afdrukken",
"stg.printGroupTitle": "Labels voor deze plank afdrukken",
"stg.qrAlt": "Zelfbedienings QR",
"stg.qrDownload": "Download de QR",
"stg.qrHint": "Toon deze QR aan de balie: uw klanten scannen deze om te controleren of hun item beschikbaar is.",
"stg.qrTitle": "Klanten zelfbediening QR",
"stg.scanDesc": "Scan het label van een item om het record direct te openen.",
"stg.scanQr": "Scan een QR",
"stg.scanTitle": "Scan een QR-code",
"stg.search": "Zoeken",
"stg.shelf": "Plank {loc}",
"stg.shelfPlan": "Plankeuze",
"stg.staleHint": "Wis deze locaties om uw fysieke inventaris up-to-date te houden.",
"stg.staleTitle": "{n} item(s) hebben opslag verlaten maar houden nog steeds een locatie",
"stg.subtitle": "Plankeuze, QR-scanner en fysieke inventaris tracking.",
"stg.title": "Opslag & QR",
"stt.acceptRate": "Acceptatiegraad",
"stt.accepted": "Geaccepteerd",
"stt.activity30": "Activiteit (laatste 30 dagen)",
"stt.ai6mo": "Laatste 6 maanden · geaccepteerd = automatisch gematcht + bevestigd.",
"stt.aiEmpty": "Geen AI-matches over deze periode nog.",
"stt.aiTitle": "AI-matches — geaccepteerd vs afgewezen",
"stt.auctionShort": "Veiling",
"stt.auctionedSold": "Geveild (verkocht)",
"stt.authShort": "Autoriteiten",
"stt.authorities": "Overgedragen aan autoriteiten",
"stt.avgRating": "Gemiddelde beoordeling",
"stt.awaitingRestitution": "items in afwachting van terugkeer",
"stt.boostClicks": "Kliks op uw directory deze week dankzij boost",
"stt.boostInactive": "Boost niet geactiveerd — schakel het in voor meer zichtbaarheid",
"stt.certifiedPremium": "Premium gecertificeerd",
"stt.declarations": "Declaraties",
"stt.destroyed": "Vernietigd",
"stt.dispoEmpty": "Geen ongeclaimd item heeft de opslag verlaten.",
"stt.donatedAssoc": "Gedoneerd (goed doel)",
"stt.donatedShort": "Gedoneerd",
"stt.gateCta": "Ontdek de plannen",
"stt.gateDesc": "Upgrade naar Starter om uw basisstatistieken te ontgrendelen, of naar Business voor geavanceerde statistieken en per-etablissementanalyse.",
"stt.gateTitle": "Statistieken gereserveerd voor betaalde plannen",
"stt.inStorage": "In opslag",
"stt.kItems": "Geregistreerde items",
"stt.kRate": "Retourpercentage",
"stt.kRestituted": "Teruggegeven items",
"stt.kRevenue": "Omzet (maand)",
"stt.noDeclYet": "Geen declaraties nog.",
"stt.recapDownloaded": "Overzicht gedownload — klaar om te delen!",
"stt.recapError": "Kan het overzicht niet genereren",
"stt.recapText": "Onze Findloop {year} samenvatting: teruggegeven items en klanttevredenheid 🎉",
"stt.recapTitle": "Findloop {year} samenvatting",
"stt.rejected": "Afgewezen",
"stt.restitutions": "Teruggaven",
"stt.shareRecap": "Deel mijn {year} samenvatting",
"stt.topCategories": "Meest gedeclareerde categorieën",
"stt.unclaimedDesc": "Volume van items dat vernietigd, gedoneerd aan goede doelen en geveild is, per categorie.",
"stt.unclaimedTitle": "Ongeclaimde items — verlaten opslag",
"stt.vsLastWeek": "t.o.v. vorige week",
"sub.cancel": "Annuleer mijn abonnement",
"sub.cancelAbort": "Annuleer",
"sub.cancelConfirm1": "Weet u zeker dat u wilt annuleren? Uw toegang blijft actief tot",
"sub.cancelConfirm2": "Er wordt geen terugbetaling gedaan.",
"sub.cancelConfirmBtn": "Bevestig annulering",
"sub.cancelTitle": "Annuleer uw abonnement",
"sub.cancelledToast": "Annulering geregistreerd.",
"sub.cguAnd": "en de",
"sub.cguDesc": "Bevestig uw akkoord voor de betaling.",
"sub.cguLink": "Gebruiksvoorwaarden",
"sub.cguPay": "Ga door naar betaling",
"sub.cguPre": "Ik heb de",
"sub.cguRequired": "U moet akkoord gaan met de Gebruiksvoorwaarden en Privacybeleid om door te gaan.",
"sub.cguSuffix": "van findloop.",
"sub.cguTitle": "Finaliseer uw abonnement",
"sub.expiresOn": "Uw abonnement verloopt op",
"sub.noProrata": "Geen pro-rata terugbetaling.",
"sub.privacyLink": "Privacybeleid",
"sub.renewsOn": "Uw abonnement wordt vernieuwd op",
"sub.resume": "Heractiveer abonnement",
"sub.resumedToast": "Heractivatie bevestigd.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Business",
"tier.small": "Starter",
"tm.add": "Toevoegen",
"tm.adminOpt": "Beheerder (volledige weergave)",
"tm.chooseEst": "Kies een etablissement",
"tm.chooseEstPh": "Kies een vestiging",
"tm.copyFail": "Kopie failed",
"tm.copyLink": "Kopieer de link",
"tm.copyOk": "Uitnodigingslink gekopieerd",
"tm.emailHint": "Een uitnodigings-e-mail wordt verzonden om het wachtwoord aan te maken.",
"tm.expiresOn": "verloopt op {date}",
"tm.forEmail": " voor {email}",
"tm.forbidden": "Teambeheer is gereserveerd voor de accounteigenaar.",
"tm.inviteCreated": "Uitnodiging aangemaakt",
"tm.inviteDesc": "Een uitnodigings-e-mail stelt de teamgenoot in staat om hun wachtwoord aan te maken.",
"tm.invitePending": "Uitnodiging in behandeling",
"tm.inviteResent": "Uitnodiging opnieuw verzonden",
"tm.inviteSent": "Uitnodiging verzonden via e-mail",
"tm.inviteTitle": "Nodig een lid uit",
"tm.invitedOn": "Uitgenodigd op {date}",
"tm.linkExpired": "Link verlopen",
"tm.memberRemoved": "Lid verwijderd",
"tm.name": "Naam",
"tm.noMembers": "Nog geen teamgenoot.",
"tm.resendTitle": "Verzend de uitnodiging opnieuw",
"tm.role": "Rol",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Eigenaar",
"tm.roleStaff": "Personeel",
"tm.roleUpdated": "Rol bijgewerkt",
"tm.sendInvite": "Stuur de uitnodiging",
"tm.sending": "Verzenden…",
"tm.staffOpt": "Personeel (ziet alleen hun vestiging)",
"trk.carrier": "Vervoerder",
"trk.shipPending": "Zending wordt voorbereid — het trackingnummer verschijnt hier zodra het is verzonden.",
"trk.shipTitle": "Zending volgen",
"trk.trackShipment": "Volg pakket",
"trk.trackingNo": "Trackingnummer",
"a.firstName": "Voornaam",
"ac.emailCrossMatch": "B2C kruisvergelijkingen",
"ac.emailCrossMatchDesc": "Een e-mail wanneer een openbaar verloren voorwerp overeenkomt met een item dat bij uw locatie is gedeponeerd",
"ac.emailCrossReject": "Afwijzingen van openbare overeenkomsten",
"ac.emailCrossRejectDesc": "Ontvang een e-mail wanneer een klant aangeeft dat een voorgestelde openbare overeenkomst niet hun item is.",
"ac.emailLoginNotif": "Inlogmelding",
"ac.emailLoginNotifDesc": "Ontvang een e-mail elke keer dat iemand inlogt op uw account.",
"ad.closeNoCancel": "Nee, verwijder de vermelding",
"ad.closeQuestion": "Is het item aan u teruggegeven?",
"ad.closeQuestionDesc": "Laat ons weten of u uw item heeft teruggevonden, of dat u deze vermelding gewoon wilt verwijderen.",
"ad.closeYesRestituted": "Ja, het item is teruggegeven",
"ad.closedRestituted": "Item teruggegeven — vermelding gesloten 🎉",
"an.lostLoginDesc": "Een account is vereist om een verloren item te melden en de terugkeer op te volgen.",
"an.lostLoginRequired": "Log in om een verloren item te melden",
"an.qfAll": "Alle",
"an.qfBoosted": "Verhoogd",
"an.qfPhoto": "Met foto",
"an.qfRecent": "Deze week",
"an.qfResolved": "Opgelost",
"an.restitutionInProgress": "Item wordt teruggegeven",
"dec.descPhLong": "Beschrijf het item: merk, kleur, onderscheidende kenmerken… (Hoe meer details u geeft, hoe groter de kans dat u uw item terugkrijgt)",
"dec.loadError": "Kan de partner momenteel niet laden. Controleer uw verbinding en probeer het opnieuw.",
"dec.retry": "Opnieuw proberen",
"dec.shippingMode": "Verzending",
"dep.photo2": "2e itemfoto",
"dep.photo2Hint": "Optioneel — een andere hoek verbetert de visuele overeenstemming.",
"dl.accountSuspended": "Account opgeschort wegens een openstaande factuur. Betaal deze om uw toegang te herstellen.",
"dl.regularize": "Betaal nu →",
"dl.suspensionCountdown": "Factuur {num} onbetaald — uw account wordt opgeschorst in {days} dag(en). Betaal dit om dit te voorkomen.",
"ft.cancelConfirm": "Uw melding annuleren? De eigenaar van het item wordt geïnformeerd.",
"ft.cancelDone": "Melding geannuleerd.",
"ft.cancelLocked": "Annuleren is niet meer mogelijk nadat de eigenaar heeft betaald.",
"ft.cancelReport": "Annuleer mijn melding",
"ft.claimCodeHelp": "Geef deze code aan de vindster bij de overdracht om te bevestigen dat u uw item heeft ontvangen.",
"ft.claimCodeTitle": "Uw restitutiecode",
"ft.claimDone": "Item teruggegeven. Bedankt voor het gebruik van Findloop!",
"ft.claimUnlockHint": "Ontgrendel de contactgegevens van de vindster",
"ft.claimUnlockHintSub": "Ga naar \"Items die ik claim\" in uw account om de vergoeding te betalen en de contactgegevens te krijgen.",
"ft.finderCodeShownHelp": "De eigenaar heeft betaald en jou geselecteerd. Kopieer deze code hieronder om de terugkeer te bevestigen — het is niet nodig om uw e-mail te controleren.",
"ft.finderCodeShownTitle": "Validatiecode van de eigenaar",
"ft.finderContactsTitle": "Contactgegevens van Finder",
"ft.foundCodeHelp": "Toon deze code aan de eigenaar bij de overdracht om te bevestigen dat het item is teruggegeven.",
"ft.inProgressOther": "Item wordt geretourneerd",
"ft.inProgressOtherHelp": "De eigenaar heeft een andere finder voor dit item geselecteerd. Er is geen verdere actie van jouw kant nodig.",
"ft.restitutionCodeHelp": "Deze code bevestigt de itemoverdracht. Het is al vooraf ingevuld hieronder; valideer het en sluit de zaak.",
"ft.restitutionCodeTitle": "Jouw restitutiecode",
"hc.14Digits": "14 cijfers",
"hc.15DaysBeforeAnItem": "15 dagen voor de wettelijke deadline van een item.",
"hc.7DaysBeforeAnItem": "7 dagen voor de wettelijke deadline van een item.",
"hc.8CharactersMinimum": "Minimaal 8 tekens.",
"hc.aClaimToValidate": "Een claim om te valideren",
"hc.aFindoAssistanceSessionIs": "Een findloop-assistentiesessie is momenteel actief op jouw account.",
"hc.aNewMatchHasBeen": "Er is een nieuwe match gevonden",
"hc.aUser": "Een gebruiker",
"hc.aUserClaimsToBe": "Een gebruiker beweert de eigenaar te zijn. Controleer hun antwoorden voordat je de retour autoriseert.",
"hc.aboutFindo": "Over Findloop",
"hc.accountActivatedPleaseLogIn": "Account geactiveerd, log alsjeblieft in.",
"hc.accountActivation": "Accountactivatie",
"hc.accountCreated": "Account aangemaakt!",
"hc.accountDeactivatedAReactivationEmail": "Account gedeactiveerd. Een heractivatie-e-mail (geldig voor 30 dagen) is naar jou gestuurd.",
"hc.accountReactivation": "Heractivatie van account",
"hc.activateMyAccount": "Activeer mijn account",
"hc.activateMyAdminAccount": "Activeer mijn adminaccount",
"hc.activating": "Bezig met activeren…",
"hc.activeMatchCancelReason": "Actieve match. Reden voor annulering door de klant: \"{reason}\". Het item wacht nog op een claim.",
"hc.activeMatchWithAPublic": "Actieve match met een openbare (klant)vermelding. Wacht op de claim van de eigenaar.",
"hc.addAPhoto": "Voeg een foto toe",
"hc.addAndConfigureYourEstablishments": "Voeg je vestigingen toe en configureer ze in \"Vestigingen\": contactgegevens, categorie en fysieke opslag van items.",
"hc.addOnGoogle": "Toevoegen op Google",
"hc.address": "Adres",
"hc.addressSaved": "Adres opgeslagen",
"hc.addressStreet": "Adres — Straat",
"hc.adjustThePhoto": "Pas de foto aan",
"hc.adminFullView": "Admin (volledig overzicht)",
"hc.administratorOnly": "Alleen voor administrator",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "AI visuele vergelijkingen",
"hc.all": "Alles",
"hc.amount": "Bedrag",
"hc.anOrganization": "Een organisatie",
"hc.analyzing": "Analyseren…",
"hc.andRecoveryIs": "en herstel is",
"hc.andTheDeclarationWillBe": "en de verklaring zal worden gesloten (verplaatst naar geschiedenis). Deze actie is definitief.",
"hc.annual20": "Jaarlijks -20%",
"hc.annualBilling20": "Jaarlijkse facturering (−20%)",
"hc.annualTarget": "Jaarlijks doel",
"hc.anyCommentsOptional": "Enige opmerkingen? (optioneel)",
"hc.approveTheClaim": "Keurt de claim goed",
"hc.archiveCancelledConfirm": "Archiveren van {n} lijst(en) \"Geannuleerd door de klant\"? Ze worden verwijderd uit het register.",
"hc.asSoonAs": "Zodra",
"hc.askTheOwnerToDisplay": "Vraag de eigenaar om de QR-code van hun code weer te geven (trackingpagina).",
"hc.askThemAtTheCounter": "Vraag ze bij de balie om identiteit te bevestigen — nooit openbaar zichtbaar.",
"hc.assistance": "Ondersteuning",
"hc.assistanceSessionRevoked": "Ondersteuningssessie ingetrokken.",
"hc.atLeast6Characters": "Minimaal 6 tekens",
"hc.automaticallyPreSelected": "automatisch voor geselecteerd",
"hc.automaticallyWhenShipping": "automatisch bij verzending.",
"hc.awaitingClaim": "Claim in afwachting",
"hc.awaitingPayment": "Betaling in afwachting",
"hc.b2cCustomer": "B2C-klant",
"hc.back": "Terug",
"hc.backToHome": "Terug naar start",
"hc.backToMyAccount": "Terug naar mijn account",
"hc.backToPayment": "Terug naar betaling",
"hc.beforeAfterComparisonSlider": "Voor/na vergelijkingsslider",
"hc.billingInformation": "Factuurinformatie",
"hc.billingInformationSaved": "Factuurinformatie opgeslagen ✓",
"hc.brand": "Merk",
"hc.bronze": "Brons",
"hc.calculatingTheShippingRate": "Verzendtarief berekenen…",
"hc.cameraUnavailableEnterTheCode": "Camera niet beschikbaar. Voer de code handmatig in.",
"hc.cancel": "Annuleren",
"hc.cancelMyDeclaration": "Annuleer mijn verklaring",
"hc.cancelSavedFmt": "Annulering opgeslagen: \"{reason}\". U kunt nog steeds claimen.",
"hc.cancelTheDeposit": "Annuleer het bedrag",
"hc.cancelThisMatch": "Annuleer deze match",
"hc.cancellationReason": "Annuleringsreden",
"hc.cancelled": "Geannuleerd",
"hc.cancelledByTheCustomer": "Geannuleerd door de klant",
"hc.cannotOpenPayment": "Kan de betaling niet openen. Probeer het opnieuw.",
"hc.careers": "Carrières",
"hc.carrier": "Vervoerder",
"hc.carrierAvailabilityCannotBeChecked": "Beschikbaarheid van de vervoerder kan niet worden gecontroleerd totdat uw Sendcloud-afzender is geconfigureerd.",
"hc.carrierConfirmedCharged": "Vervoerder bevestigd — {price} € in rekening gebracht bij de klant",
"hc.carrierOther": "Vervoerder (anders)",
"hc.carrierSelection": "Selectie van vervoerder",
"hc.caseClosedThankYou": "Zaak gesloten. Dank u!",
"hc.category": "Categorie",
"hc.changeMethod": "Wijzig methode",
"hc.characteristic": "Kenmerk",
"hc.chargedToCustomer": "in rekening gebracht bij de klant.",
"hc.checkOrEditYourDetails": "Controleer of bewerk uw gegevens vóór de veilige betaling.",
"hc.checkStatisticsToTrackDeposited": "Controleer \"Statistieken\" om gestorte items, retourpercentage en prestatie van elke vestiging te volgen.",
"hc.checkTheDetailsBeforeContacting": "Controleer de details voordat u de vinderscontacteert.",
"hc.checkTheDetailsBelowBefore": "Controleer de onderstaande details voordat u uw retourverzoek start.",
"hc.checkTheNewItem": "Controleer het nieuwe item",
"hc.checkThePhotosAndCharacteristics": "Controleer de foto's en kenmerken hieronder voordat u verder gaat met het herstel.",
"hc.chooseACountry": "Kies een land",
"hc.chooseANewPassword": "Kies een nieuw wachtwoord",
"hc.chooseAReason": "Kies een reden",
"hc.chooseTheLegalRetentionAlerts": "Kies de wettelijke bewaalerts die per e-mail worden ontvangen voor",
"hc.chooseYourPasswordToAccess": "Kies uw wachtwoord om toegang te krijgen tot de administratieconsole.",
"hc.city": "Stad",
"hc.claimApproved": "Claim goedgekeurd",
"hc.claimApproved2": "Claim goedgekeurd.",
"hc.claimCodeExpired": "Claimcode is verlopen",
"hc.claimCodeVerified": "Claimcode geverifieerd",
"hc.claimNotFound": "Claim niet gevonden",
"hc.claimNotValidated": "Claim niet gevalideerd",
"hc.claimRejected": "Claim afgewezen",
"hc.claimRejected2": "Claim afgewezen.",
"hc.claimValidated": "Claim gevalideerd",
"hc.claimValidatedByThePartner": "Claim gevalideerd door de partner",
"hc.claimant": "Aanvrager",
"hc.claimsToBeTheOwner": "claimt de eigenaar van dit item te zijn en heeft de verificatievragen beantwoord. Goedkeuren alleen als de antwoorden overeenkomen.",
"hc.claimsToValidate": "Claims om te valideren",
"hc.clear": "Wissen",
"hc.clickToZoom": "Klik om in te zoomen",
"hc.close": "Sluiten",
"hc.close2": "Sluiten",
"hc.closeTheDeclaration": "Sluit de verklaring",
"hc.closeTheDeclaration2": "Sluit de verklaring?",
"hc.codeAlreadyVerified": "Code al geverifieerd",
"hc.codeCopied": "Code gekopieerd",
"hc.collapse": "Samenvouwen",
"hc.color": "Kleur",
"hc.company": "Bedrijf",
"hc.companyName": "Bedrijfsnaam",
"hc.comparePhotos": "Vergelijk foto's",
"hc.compareThemWithTheOwner": "Vergelijk ze met de antwoorden van de eigenaar - nooit publiekelijk zichtbaar.",
"hc.condition": "Voorwaarde",
"hc.confirmAndPay": "Bevestigen en betalen",
"hc.confirmCancellation": "Bevestigen annulering",
"hc.confirmCrop": "Bevestigen bijsnijden",
"hc.confirmDeletion": "Bevestigen verwijdering",
"hc.confirmPassword": "Bevestig wachtwoord",
"hc.confirmThatThisIsYour": "Bevestig dat dit jouw item is. Er zal een identiteitscontrole worden aangevraagd bij de vindende partij voordat er contact is.",
"hc.confirmTheCarrier": "Bevestig de vervoerder",
"hc.confirmThePassword": "Bevestig het wachtwoord",
"hc.confirmYourShippingAddressTo": "Bevestig je verzendadres om door te gaan met de betaling.",
"hc.confirmYourSubscription": "Bevestig je abonnement",
"hc.confirmed": "Bevestigd ✓",
"hc.contactFindoToGetYour": "Neem contact op met Findloop om je Verzender-ID te verkrijgen.",
"hc.contactUs": "Neem contact met ons op",
"hc.continueTheReturn": "Ga door met de retour",
"hc.continueToPayment": "Ga door naar betaling",
"hc.copy": "Kopieer",
"hc.correctMyDetails": "mijn gegevens corrigeren",
"hc.correctThisEntry": "Deze invoer corrigeren?",
"hc.country": "Land",
"hc.countryAddress": "Land (adres)",
"hc.countryIsoCodeEG": "Land (ISO-code, bijv. FR)",
"hc.cover": "cover",
"hc.createTheShipment": "Creëer de zending",
"hc.cropThePhoto": "Bijsnijden van de foto",
"hc.customer": "Klant",
"hc.customerClaimCodeToCheck": "Klantclaimcode — om te controleren bij afhaling:",
"hc.customerReasonFmt": "Reden van de klant: \"{reason}\".",
"hc.customerReminderDelay": "Klant herinnering vertraging",
"hc.customerWhosePublicListingMatches": "Klant wiens openbare vermelding overeenkomt met dit item - alleen zichtbaar voor jou.",
"hc.d15": "D-15",
"hc.dangerZone": "Gevarenzone",
"hc.date": "Datum",
"hc.dateNewest": "Datum (nieuwste)",
"hc.dateOldest": "Datum (oudste)",
"hc.daysToYearEnd": "{n} dagen tot het einde van het jaar",
"hc.deadlineAlert": "Deadline waarschuwing",
"hc.declarationClosed": "Aangifte gesloten ✓",
"hc.declarationNotFound": "Aangifte niet gevonden.",
"hc.declarationNotFound2": "Aangifte niet gevonden",
"hc.declarationTracking": "Aangifte traceren",
"hc.defaultCarrier": "Standaard verzender",
"hc.defaultCarrierPreselected": "Standaard verzender vooraf geselecteerd — kan worden aangepast voor deze zending. Werkelijke tarief (Sendcloud + {m}% marge).",
"hc.defaultCarrierRemoved": "Standaard verzender verwijderd",
"hc.delayHours": "Vertraging (uren)",
"hc.deleteMyAccount": "Verwijder mijn account",
"hc.deleting": "Verwijderen…",
"hc.deletingDeactivatesYourAccountLogin": "Verwijderen deactiveert je account: inloggen is geblokkeerd en gegevens worden 30 dagen bewaard. Je ontvangt een e-mail met een heractiveringslink die 30 dagen geldig is.",
"hc.delivered": "Bezorgd",
"hc.depositAnItem": "Een item deponeren",
"hc.depositCancelledItemPutBack": "Depositie geannuleerd — item weer op voorraad geplaatst.",
"hc.depositCancelledItemRemovedFrom": "Depositie geannuleerd — item verwijderd uit het register.",
"hc.depositedOn": "Gedeporteerd op",
"hc.describeTheItemBrandColor": "Beschrijf het item: merk, kleur, onderscheidende kenmerken… (Hoe meer details je geeft, hoe beter je kansen om je item te vinden)",
"hc.dimensionsCm": "Afmetingen (cm)",
"hc.disablingAnEmail": "Een e-mail deactiveren",
"hc.doesNotHide": "verbergt niet",
"hc.download": "Downloaden",
"hc.downloadThePdf": "Download de PDF",
"hc.draftRestoredPickUpYour": "Concept hersteld — pak je aangifte waar je was gestopt.",
"hc.dragToReposition": "Slepen om te verplaatsen",
"hc.eGColisPriv": "Bijv. Colis Privé",
"hc.eachItemGetsAQr": "Elk item krijgt een QR-label. Scan het vanaf \"Opslag & QR\" om een item in een oogwenk te vinden.",
"hc.eachSiteManagesItsOwn": "Elke site beheert zijn eigen bankzaken. Ga naar",
"hc.edit": "Bewerken",
"hc.emailNotificationPreferences": "E-mail notificatievoorkeuren",
"hc.emailPreferencesUpdated": "E-mailvoorkeuren bijgewerkt",
"hc.enableOrDisableRecoveryFees": "Herstelkosten in- of uitschakelen voor",
"hc.enlargePhoto": "Vergroot foto",
"hc.enterTheCustomerSCode": "Voer de code van de klant in",
"hc.estShipRate": "Geschatte verzendkosten (Sendcloud + {m}% marge):",
"hc.establishment": "Vestiging",
"hc.establishment2": "Vestiging:",
"hc.establishmentInItsSendcloudAccount": "vestiging in zijn Sendcloud-account en geeft je de verzender ID",
"hc.establishmentSettings": "Vestigingsinstellingen",
"hc.exCode": "bijv. ABCD2345",
"hc.exId": "bijv. 3f2a…",
"hc.exit": "Afsluiten",
"hc.explainWhyThisItemIs": "Leg uit waarom dit item niet van jou is…",
"hc.externalPaymentLinks": "Externe betaallinks",
"hc.failed": "Mislukt",
"hc.feesEnabled": "Vergoedingen ingeschakeld",
"hc.field": ") veld.",
"hc.finderAcceptedCloseTheCase": "Finder geaccepteerd — sluit de zaak zodra het item persoonlijk is overhandigd.",
"hc.findoCityRanking": "Findloop — Stedenranking",
"hc.findoForEstablishments": "Findloop voor vestigingen",
"hc.findoPresentationVideo": "Findloop presentatievideo",
"hc.findoRegistersTheAddressOf": "Findloop registreert het adres van jouw",
"hc.findoReviewShare": "Findloop {year} beoordeling: {n} items geretourneerd, {rate}% retourpercentage 🎉",
"hc.firstVerifyTheClaimCode": "Controleer eerst de bovenstaande claimcode",
"hc.forEveryNewShipmentFrom": "voor elke nieuwe zending van",
"hc.free": "gratis",
"hc.freeRecovery0": "Gratis herstel (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Gratis herstel in heel Afrika – Lancering aanbod",
"hc.freeRecoveryFeesDisabled0": "Gratis herstel: portokosten uitgeschakeld (0 €)",
"hc.fromTeamInviteYourColleagues": "Van \"Team\", nodig je collega's per e-mail uit en wijs ze een vestiging toe. Elk lid ziet alleen zijn eigen scope.",
"hc.fullName": "Volledige naam",
"hc.fullPhoto": "Volledige foto",
"hc.gallery": "Galerij",
"hc.giveTheReasonForCancelling": "Geef de reden voor annulering. De partner zal worden geïnformeerd.",
"hc.goToLogin": "Ga naar inloggen",
"hc.goToMyAccount": "Ga naar mijn account",
"hc.gold": "Goud",
"hc.googleLoginFailed": "Google-aanmelding mislukt",
"hc.hasConfirmedYourPaymentYou": "heeft jouw betaling bevestigd, je wordt automatisch doorgestuurd",
"hc.helpCenter": "Helpcentrum",
"hc.helpUsImproveWhyAre": "Help ons verbeteren: waarom vertrek je? Je account wordt gedeactiveerd en kan binnen 30 dagen opnieuw worden geactiveerd.",
"hc.hidePassword": "Verberg wachtwoord",
"hc.high": "Hoog",
"hc.historyOfYourMonthlySubscriptions": "Geschiedenis van je maandelijkse abonnementen en hun betalingsstatus.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Hoe stel ik mijn numerieke Sender ID in?",
"hc.iDonTUseIt": "Ik gebruik het niet genoeg",
"hc.iFoundItElsewhere": "Ik heb het ergens anders gevonden",
"hc.iNoLongerNeedMy": "Ik heb mijn item niet meer nodig",
"hc.identityVerification": "Identiteitsverificatie",
"hc.idleLogoutIn": "Je wordt over {n} s uitgelogd wegens inactiviteit.",
"hc.ifProvidedTheVolumetricWeight": "Als opgegeven, wordt het volumetrische gewicht gebruikt.",
"hc.ifThePartnerHasNot": "Als de partner de ontvangst van de externe betaling na deze vertraging niet bevestigt, herinnert Findloop automatisch de partner om deze te valideren.",
"hc.impersonationEnded": "Vervalsing beëindigd.",
"hc.impersonationMode": "Vervalsingsmodus",
"hc.impersonationSessionExpired": "Vervalsingssessie verlopen.",
"hc.inTheField": ", in het veld",
"hc.inTransit": "In transit",
"hc.inclVat": "incl. BTW",
"hc.intraEuVatNumberOptional": "Intra-EU BTW-nummer optioneel, geen SIRET vereist (buiten Frankrijk).",
"hc.invalidInvitationLink": "Ongeldige uitnodigingslink.",
"hc.invalidInvitationLink2": "Ongeldige uitnodigingslink",
"hc.invalidInviteLink": "Ongeldige of verlopen uitnodigingslink.",
"hc.invalidNumberEnterAnInternational": "Ongeldig nummer. Voer een internationaal nummer in, bijv. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Ongeldige of verlopen link.",
"hc.invalidOrExpiredReactivationLink": "Ongeldige of verlopen heractivatielink",
"hc.invalidSendcloudId": "Ongeldig Sendcloud ID",
"hc.inviteSubtitle": "{org} nodigt je uit om lid te worden van hun findloop-team. Kies je wachtwoord om je account te activeren.",
"hc.isAvailableOnSendcloudFor": "is beschikbaar op Sendcloud voor al je routes (binnenlands + internationaal).",
"hc.isNotEnabledOnYour": "is niet ingeschakeld op je Sendcloud-account voor sommige bestemmingen. Etiketten daarvoor worden gegenereerd met een andere beschikbare vervoerder.",
"hc.isThisReallyYourItem": "Is dit echt jouw item?",
"hc.isThisYourItem": "Is dit jouw item?",
"hc.item": "Item",
"hc.itemAlreadyConfirmed": "Item al bevestigd",
"hc.itemDetails": "Itemdetails",
"hc.itemFoundAt": "Item gevonden bij",
"hc.itemFoundAtAPartner": "Item gevonden bij een partner",
"hc.itemMarkedAsReturned": "Item gemarkeerd als geretourneerd ✓",
"hc.itemPhotoRequiredBeforeShipping": "Itemfoto (vereist voor verzending)",
"hc.itemPhotoSaved": "Itemfoto opgeslagen",
"hc.itemPreview": "Itemvoorbeeld",
"hc.itemPutBackInStorage": "Item weer terug in opslag geplaatst.",
"hc.itemWeight": "Gewicht van het item:",
"hc.itemsReturned": "item(s) geretourneerd",
"hc.itemsReturnedThisYear": "dit jaar geretourneerde items",
"hc.itemsWhoseLegalDeadlineIs": "Items waarvan de wettelijke deadline 15 dagen of minder is (overdue inbegrepen). Overeenkomsten blijven zichtbaar.",
"hc.kbisNumber": "Kbis-nummer",
"hc.keysForgottenOnABench": "Sleutels vergeten op een bank",
"hc.labelBeingGenerated": "Label wordt aangemaakt",
"hc.leaveTheFieldsEmptyTo": "Laat de velden leeg om herstel gratis aan te bieden.",
"hc.legalNotice": "Juridische kennisgeving",
"hc.limitReachedUpgradeToA": "Limiet bereikt — upgrade naar een hoger plan",
"hc.linkCopiedShareOn": "Link gekopieerd — deel het op {label}",
"hc.linkUnavailable": "Link niet beschikbaar",
"hc.linkedTo": "Verknopt met",
"hc.listingHiddenByModeration": "Vermelding verborgen door moderatie.",
"hc.loading": "Laden…",
"hc.locateMe": "Vind mijn locatie",
"hc.logIn": "Inloggen",
"hc.logInToGetBack": "Log in om terug te keren naar je ruimte en je abonnement te beheren.",
"hc.loginFailed": "Inloggen mislukt",
"hc.lostFoundPlatform": "Verloren & gevonden platform.",
"hc.lostIn": "verloren in",
"hc.lowRate": "Laag tarief",
"hc.mainReason": "Hoof reden",
"hc.mainStreet": "Hoofdstraat",
"hc.makeSureThisIsThe": "Zorg ervoor dat dit het item is dat je verloren hebt voordat je de contactgegevens van de vindende partij ontgrendelt.",
"hc.manageCookies": "Cookies beheren",
"hc.manageMyTeam": "Mijn team beheren",
"hc.manageYourTeam": "Je team beheren",
"hc.markAsReturned": "Markeer als geretourneerd",
"hc.matchNoClaimInTime": "De overeenkomst heeft binnen de deadline geen claim ontvangen.",
"hc.matchNotFound": "Overeenkomst niet gevonden",
"hc.medium": "Gemiddeld",
"hc.milestoneFmt": "{m} geretourneerde items mijlpaal bereikt! Op weg naar {next}.",
"hc.missingFeatures": "Ontbrekende functies",
"hc.monthly": "Maandelijks",
"hc.monthlyBilling": "Maandelijkse facturatie",
"hc.moveThePhotoToFit": "Verplaats de foto om deze in de cirkel te passen.",
"hc.myAccount": "Mijn account",
"hc.myInvoices": "Mijn facturen",
"hc.myMonthlyInvoices": "Mijn maandelijkse facturen",
"hc.nArchived": "{n} aanbieding(en) gearchiveerd.",
"hc.newCodeGeneratedAndSent": "Nieuwe code gegenereerd en per e-mail en SMS naar de klant verzonden",
"hc.newCodeGeneratedAndSent2": "Nieuwe code gegenereerd en naar de eigenaar verzonden",
"hc.newPassword": "Nieuw wachtwoord",
"hc.next": "Volgende",
"hc.nextPhoto": "Volgende foto",
"hc.no": "Nee",
"hc.noAnswerProvided": "Geen antwoord opgegeven.",
"hc.noArchivedDeclarations": "Geen gearchiveerde verklaringen",
"hc.noCountryFound": "Geen land gevonden",
"hc.noDeclarations": "Geen verklaringen",
"hc.noFeesAreChargedTo": "Er worden geen kosten aan de klant in rekening gebracht.",
"hc.noInvoiceYet": "Nog geen factuur.",
"hc.noInvoiceYetYourInvoices": "Nog geen factuur. Je facturen verschijnen hier automatisch na elke betaling.",
"hc.noMatchIsAvailableFor": "Momenteel is er geen overeenkomst beschikbaar. We laten het je weten zodra er een item overeenkomt met jouw verklaring.",
"hc.noShipmentMatchesYourSearch": "Geen verzending komt overeen met je zoekopdracht.",
"hc.noShipmentsYet": "Nog geen verzendingen.",
"hc.noShipmentsYet2": "Nog geen verzendingen",
"hc.none": "geen",
"hc.noneChooseForEachShipment": "Geen (kies voor elke zending)",
"hc.notMine": "Het is niet van mij",
"hc.of": "van",
"hc.only": "Alleen",
"hc.onlyEachSiteManagesIts": "alleen. Elke site beheert zijn eigen bankverkeer: deze links beïnvloeden geen andere inrichting.",
"hc.onlyTheOwnerOrAn": "Alleen de eigenaar of een beheerder kan de betalingslinks van de inrichting configureren.",
"hc.openDepositInTheMenu": "Open \"Storting\" in het menu, beschrijf het item en maak een foto. Het wordt onmiddellijk opgeslagen en is klaar om teruggegeven te worden.",
"hc.openSettings": "Instellingen openen →",
"hc.openTheDeclarationToManage": "Open de verklaring om de verzending te beheren",
"hc.optional": "— optioneel",
"hc.optional2": "(optioneel)",
"hc.optional3": "optioneel",
"hc.originalListingPhotoUsed": "Oorspronkelijke aanbieding foto gebruikt",
"hc.other": "Overige",
"hc.other2": "Overige…",
"hc.ourProducts": "Onze producten",
"hc.overallRateTrendLast6": "Algemene tarieftrend (laatste 6 maanden)",
"hc.ownerSClaimCode": "Claimcode van de eigenaar",
"hc.ownershipConfirmed": "Eigenaarschap bevestigd",
"hc.paid": "Betaald",
"hc.paidOn": "Betaald op",
"hc.paidViaPartner": "Betaald (via partner)",
"hc.parcelBeingPrepared": "Pakket wordt voorbereid",
"hc.parcelDelivered": "Pakket geleverd",
"hc.parcelShipped": "Pakket verzonden",
"hc.parisGareDeLyon": "Parijs, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Partnerdirectory",
"hc.passedOnToTheCustomer": "— doorgegeven aan de klant betaallink.",
"hc.password": "Wachtwoord",
"hc.passwordResetPleaseLogIn": "Wachtwoord opnieuw instellen, log alstublieft in.",
"hc.passwordUpdated": "Wachtwoord bijgewerkt.",
"hc.passwordsDoNotMatch": "Wachtwoorden komen niet overeen.",
"hc.pasteThisSenderIdIn": "Plak deze afzender-ID in Findloop → Instellingen",
"hc.payForTheShipmentOf": "Betaal voor de verzending van uw artikel via Findloop met een veilige betaling.",
"hc.payTheRecoveryFees": "Betaal de terugvorderingskosten",
"hc.payTheShippingFees": "Betaal de verzendkosten",
"hc.payment": "Betaling",
"hc.paymentAlreadyConfirmedByThe": "Betaling al bevestigd door de partner",
"hc.paymentLinksAreNowConfigured": "Betaallinks zijn nu geconfigureerd per instelling",
"hc.paymentNotCompletedYourAccount": "Betaling niet voltooid, uw account is niet aangemaakt — probeer het opnieuw.",
"hc.paymentReceived": "Betaling ontvangen",
"hc.paymentSuccessful": "Betaling succesvol!",
"hc.pdfInvoice": "PDF-factuur",
"hc.pending": "In behandeling",
"hc.period": "Periode",
"hc.phoneNumber": "Telefoonnummer",
"hc.phoneOptional": "Telefoon (optioneel)",
"hc.planAt": "plan op",
"hc.planLimitFmt": "Uw \"{plan}\" plan is beperkt tot {max} instellingen. Voor het beheren van {n} locaties raden we de",
"hc.platformReturnTarget": "Platform retourdoel",
"hc.pleaseCompleteYourShippingAddress": "Vul alstublieft uw verzendadres in.",
"hc.pleaseProvideAPhoneNumber": "Geef alstublieft een telefoonnummer op: het is vereist door de koerier voor verzending.",
"hc.pleaseProvideAReason": "Geef alstublieft een reden op.",
"hc.pleaseSetYourOwnPassword": "stel uw eigen wachtwoord in voordat u verdergaat.",
"hc.pointsToGoal": "{n} punten meer om ons gezamenlijke doel te bereiken.",
"hc.posterPreview": "Postervoorbeeld",
"hc.potentialMatchBeingVerified": "Potentiële match wordt geverifieerd",
"hc.potentialOwner": "Potentiële eigenaar",
"hc.preFilledAutomaticallyYouCan": "Automatisch ingevuld — u kunt het vervangen door een foto van het pakket.",
"hc.pressKit": "Perskit",
"hc.previewMode": "Voorbeeldmodus:",
"hc.previewOfThePrintReady": "Voorbeeld van de printklare A4-poster voor deze instelling.",
"hc.previous": "Vorige",
"hc.previousPhoto": "Vorige foto",
"hc.primary": "primaire",
"hc.printThePoster": "Print de poster",
"hc.privacy": "Privacy",
"hc.privacyPolicy": "Privacybeleid",
"hc.processedCasesWillAppearHere": "Verwerkte gevallen verschijnen hier.",
"hc.proofOfReturnPdf": "Bewijs van retour (PDF)",
"hc.protectedByRecaptcha": "Beschermd door reCAPTCHA",
"hc.publicMatch": "Openbare match",
"hc.putBackInStorage": "Terug in opslag plaatsen",
"hc.pwdResetByTeam": "Je wachtwoord is gereset door ons team. Voor jouw veiligheid,",
"hc.questionsToAskTheOwner": "Vragen om aan de eigenaar te stellen",
"hc.rateChargedToTheCustomer": "Tarief in rekening gebracht aan de klant:",
"hc.rateOfTarget": "{rate}% gehaald van een {target}% doelstelling",
"hc.reached": "bereikt",
"hc.reactivating": "Heractivatie…",
"hc.reasonSavedYouCanStill": "Reden opgeslagen. Je kunt je item nog steeds claimen.",
"hc.recentMatchesFirst": "Recentste matches eerst",
"hc.recognizedThePhotoYouSent": "herkende de foto die je stuurde en beschreef deze kenmerken. Bevestig alleen als ze overeenkomen met het item in jouw bezit.",
"hc.recommended": "Aanbevolen",
"hc.recoveryFees": "Herstelkosten",
"hc.recoveryFeesArePaidDirectly": "Herstelkosten worden rechtstreeks aan de partnerinstelling betaald. Findloop ontvangt geen betaling van klanten.",
"hc.recoveryFeesEnabled": "Herstelkosten ingeschakeld",
"hc.recoveryOfferedByTheEstablishment": "Herstel aangeboden door de instelling — Findloop rekent geen kosten.",
"hc.recoveryPaymentLink": "Betaallink voor herstel",
"hc.recoveryPaymentLinkSavedFor": "Betaallink voor herstel opgeslagen voor deze instelling",
"hc.redirecting": "Omleiden…",
"hc.redirectingToPayment": "Omleiden naar betaling…",
"hc.redirectingToTheRecoveryOf": "Omleiden naar het herstel van je item…",
"hc.regenerateAndResendToThe": "Regenerate en stuur opnieuw naar de eigenaar",
"hc.regenerateTheCode": "Genereer de code opnieuw",
"hc.registerAFoundItem": "Registreer een gevonden item",
"hc.rejectTheClaim": "Weiger de claim",
"hc.reminderDelaySaved": "Herinneringsvertraging opgeslagen",
"hc.reopenThePaymentLink": "Heropen de betaallink",
"hc.repeatThePassword": "Herhaal het wachtwoord",
"hc.reportAProblem": "Rapporteer een probleem",
"hc.reportDismissedYourListingRemains": "Rapport afgewezen. Je vermelding blijft openbaar.",
"hc.requiredUsedToCalculateThe": "Vereist: wordt gebruikt om het verzendtarief van Sendcloud te berekenen. Verzendoption beschikbaar boven de 30 kg.",
"hc.reset": "Reset",
"hc.resume": "Hervatten",
"hc.resumeRegistration": "Registratie hervatten",
"hc.retro": "Jaaroverzicht",
"hc.returnSecurity": "Retourbeveiliging",
"hc.returnToTheOwner": "Terug naar de eigenaar",
"hc.returned": "teruggegeven",
"hc.reviewTheItemDetails": "Bekijk de itemdetails",
"hc.revokeAccess": "Toegang intrekken",
"hc.role": "Rol:",
"hc.save": "Opslaan",
"hc.save2": "opslaan",
"hc.saveAndContinue": "Opslaan en doorgaan",
"hc.saving": "Opslaan…",
"hc.scanTheClaimCode": "Scan de claimcode",
"hc.scanTheOwnerSQr": "Scan de QR van de eigenaar",
"hc.scrollThroughLanguages": "Scroll door talen",
"hc.searchByCustomerItemOr": "Zoek op klant, item of trackingnummer…",
"hc.searchForACountry": "Zoek een land…",
"hc.secureFindoVerification": "Veilige findloop-verificatie",
"hc.seeRetro": "Bekijk het jaaroverzicht",
"hc.selectedCarrier": "Geselecteerde vervoerder:",
"hc.selectedPlan": "Geselecteerd plan",
"hc.send": "Verzenden",
"hc.sendcloudSenderIdSaved": "Sendcloud afzender ID opgeslagen",
"hc.sendcloudSenderIdSenderId": "Sendcloud afzender ID (sender_id)",
"hc.sending": "Verzenden…",
"hc.sessionExpired": "Sessie verlopen",
"hc.setUpYourEstablishments": "Stel je instellingen in",
"hc.settings": "Instellingen",
"hc.settingsSubtitle": "Externe betalingen en herinneringen, geconfigureerd per bedrijf.",
"hc.shareFoundText": "Ik heb een item gevonden - help me de eigenaar te vinden op Findloop",
"hc.shareLostText": "Ik ben een item kwijt - help me het te vinden op Findloop",
"hc.sharePreview": "Delen voorvertoning",
"hc.shareTheRanking": "Deel de ranking",
"hc.shareYourQrCodeTo": "Deel je QR-code om verklaringen te ontvangen.",
"hc.shipRateAutoWeight": "Het verzendtarief wordt automatisch berekend via Sendcloud (gewicht {w}) op het moment van verzending.",
"hc.shipRateForWeight": "Verzendtarief (Sendcloud + {m}% marge) voor {w}:",
"hc.shipments": "Zendingen",
"hc.shipmentsSubtitle": "Geconsolideerd overzicht van alle zendingen van de vestiging, over alle gevallen. Klik op een rij om de zending in de aangifte te beheren.",
"hc.shipping": "Verzending",
"hc.shippingAddress": "Verzendadres",
"hc.shippingFeesAreHandledAutomatically": "Verzendkosten worden automatisch afgehandeld door Findloop (Sendcloud) — geen link om in te voeren.",
"hc.shippingFeesHaveAlreadyBeen": "Verzendkosten zijn al betaald: de vervoerder kan niet meer worden gewijzigd.",
"hc.shippingNotAvailableForItems": "Verzending niet beschikbaar voor artikelen boven de 30 kg. De klant moet het artikel persoonlijk ophalen.",
"hc.shippingPaid": "Verzending betaald ✓",
"hc.showOnlyItemsMatchingA": "Toon alleen artikelen die overeenkomen met een openbare (klant)vermelding",
"hc.showPassword": "Toon wachtwoord",
"hc.signInTheBoxAbove": "Log in in het bovenstaande vak",
"hc.signatureSaved": "Handtekening opgeslagen",
"hc.signedInWithGoogle": "Ingelogd met Google",
"hc.signupFailed": "Aanmelding mislukt",
"hc.silver": "Zilver",
"hc.simulatedRatesInPreProduction": "(gesimuleerde tarieven in pre-productie)",
"hc.siretAndVatNumberRequired": "SIRET- en btw-nummer vereist (Frankrijk).",
"hc.skip": "Overslaan",
"hc.smsSentIfAccount": "Als er een account bestaat met dit nummer, is er een sms naar u verzonden.",
"hc.sortItemsWithAPublic": "Sorteren: artikelen met een openbare overeenkomst (meest recent) eerst",
"hc.specifyWhetherYouRecoveredYour": "Geef aan of u uw artikel heeft teruggekregen of gewoon deze vermelding wilt verwijderen.",
"hc.specifyYourReason": "Geef uw reden op",
"hc.specifyYourReason2": "Geef uw reden op…",
"hc.staff": "Personeel",
"hc.status": "Status",
"hc.staySignedIn": "Ingelogd blijven",
"hc.step": "Stap",
"hc.stillThere": "Nog daar?",
"hc.stopScrolling": "Stop met scrollen",
"hc.storeFindWithQr": "Opslaan & vinden met QR",
"hc.streetName": "Straatnaam",
"hc.streetNo": "Huisnummer",
"hc.switchTo": "Overschakelen naar",
"hc.switchToDarkMode": "Overschakelen naar de donkere modus",
"hc.switchToLightMode": "Overschakelen naar de lichte modus",
"hc.takeAPhoto": "Neem een foto",
"hc.takeChangeThePhoto": "Neem / wijzig de foto",
"hc.takenFromYourDeclaration": "genomen van uw aangifte",
"hc.target": "Doel",
"hc.targetReached": "Doel bereikt",
"hc.targetReachedThankYouTo": "Doel bereikt — bedankt aan de hele Findloop community!",
"hc.tellUsMore": "Vertel ons meer…",
"hc.tellUsWhyYouCancel": "Vertel ons waarom je annuleert. Dit helpt de partner om je verzoek te verwerken.",
"hc.tellUsWhyYourListing": "Vertel ons waarom. Je vermelding blijft actief en je kunt je item nog steeds claimen.",
"hc.termsAndConditions": "Algemene voorwaarden",
"hc.termsAndPolicies": "Voorwaarden en beleid",
"hc.thankYouForYourFeedback": "Dank je voor je feedback",
"hc.theBannerDisplayedInThe": "de banner weergegeven in het register.",
"hc.theClaimantHasBeenInformed": "De aanvrager is geïnformeerd. Het item blijft beschikbaar in de openbare vermelding.",
"hc.theClaimantHasBeenNotified": "De aanvrager is op de hoogte gesteld en kan nu doorgaan met de retour.",
"hc.theCustomerPaysTheFees": "De klant betaalt de kosten aan de vestiging.",
"hc.theDayTheLegalRetention": "De dag dat de wettelijke bewaartermijn is bereikt.",
"hc.theEstablishmentConsideredThatThis": "De vestiging heeft bepaald dat dit item niet van jou is.",
"hc.theEstablishmentIsReviewingYour": "De vestiging beoordeelt je antwoorden. Je zult op de hoogte worden gesteld zodra je claim is gevalideerd, daarna kun je de terugwinningskosten betalen.",
"hc.theFeesAreTooHigh": "De kosten zijn te hoog",
"hc.theFinderConsideredThatThis": "De vinder heeft bepaald dat dit item niet van jou is.",
"hc.theFinderIsReviewingYour": "De vinder beoordeelt je claim. Je wordt op de hoogte gesteld zodra deze is gevalideerd.",
"hc.theItem": "Het item",
"hc.theItemWillBeRemoved": "Het item zal uit het register worden verwijderd (geen claim in behandeling).",
"hc.theItemWillBeSet": "Het item zal worden teruggezet naar \"in voorraad\" en de bijbehorende claim zal worden geannuleerd.",
"hc.theKbisNumberAndVat": "Het Kbis-nummer en het btw-nummer zijn vereist voor Frankrijk.",
"hc.theLabelIsGeneratedAutomatically": "Het label wordt automatisch gegenereerd zodra de klant de verzendkosten heeft betaald. Het kan hier worden gedownload.",
"hc.theLinkMayHaveExpired": "De link kan zijn verlopen (geldig voor 30 dagen). Neem contact op met Findloop support indien nodig.",
"hc.theOwnerDescribesTheirItem": "De eigenaar beschrijft zijn item",
"hc.theOwnerReceivedItBy": "De eigenaar ontving het per e-mail (of SMS). Voer het in of scan het voor de overdracht.",
"hc.thePartnerConsideredThatThis": "De partner heeft bepaald dat dit item niet van jou is. Het item blijft beschikbaar.",
"hc.thePartnerIsReviewingYour": "De partner beoordeelt je antwoorden. Je wordt op de hoogte gesteld zodra je claim is gevalideerd.",
"hc.theShipmentIsCreatedAutomatically": "De verzending wordt automatisch aangemaakt zodra de klant zijn adres heeft bevestigd en de terugwinningskosten heeft betaald. Het label wordt dan automatisch gegenereerd na de verzendbetaling en kan hier worden gedownload.",
"hc.theShippingRateWillBe": "De verzendkosten worden automatisch berekend via Sendcloud op het moment van verzending (opgegeven gewicht).",
"hc.thisCarrierWillBe": "Deze vervoerder zal zijn",
"hc.thisEstablishment": "deze vestiging",
"hc.thisFieldIsRequiredFor": "Dit veld is vereist voor automatische labelgeneratie.",
"hc.thisIsMyItem": "Dit is mijn item",
"hc.thisIsMyItemContinue": "Dit is mijn item — voortzetten",
"hc.thisIsMyItemStart": "Dit is mijn item — start de retour",
"hc.thisIsNotMyItem": "Dit is niet mijn item",
"hc.thisMatchIsNoLonger": "Deze match is niet langer beschikbaar of is al verwerkt.",
"hc.thisRateWillBeCharged": "Dit tarief zal aan de klant worden in rekening gebracht. Een hoog tarief kan terugwinningsafspraken ontmoedigen.",
"hc.thisStepIsRequiredFor": "Deze stap is vereist om verzendlabels te genereren",
"hc.thisValidationLinkIsInvalid": "Deze verificatielink is ongeldig of is verlopen.",
"hc.toCheckBeforeMarkingThe": "Te controleren voordat het item als geretourneerd wordt gemarkeerd.",
"hc.toConfigureTheLinksAnd": "om de links en herinneringsvertraging voor elk filiaal in te stellen.",
"hc.toReachOurFirstMilestone": "om onze eerste mijlpaal van 100 retouren te bereiken.",
"hc.toTheCustomer": "aan de klant.",
"hc.toTheShippingFeePayment": "aan de betaling van de verzendkosten.",
"hc.toYourRecoveryTracking": "aan je terugverdammingstracking.",
"hc.tooExpensiveBudget": "Te duur / budget",
"hc.topCitiesForReturns": "Topsteden voor retouren",
"hc.trackMyRecovery": "Volg mijn terugvordering",
"hc.trackTheShipmentAndDownload": "Volg de zending en download het label (automatisch gegenereerd) zonder het tabblad Declaraties te verlaten.",
"hc.trackYourStatistics": "Volg je statistieken",
"hc.tracking": "Tracking",
"hc.unableToOpenTheShipping": "Kan de betaling van de verzendkosten niet openen. Probeer het opnieuw.",
"hc.unableToRetrieveTheInvoice": "Kan de factuur niet ophalen.",
"hc.unclaimed": "Ongeëist",
"hc.unclaimedCustomerReason": "Ongeëist item. Reden van de klant: \"{reason}\".",
"hc.unclaimedItem": "Ongeëist item",
"hc.unclaimedItemNoClaimWithin": "Ongeëist item — geen claim binnen de deadline.",
"hc.unclaimedItems": "Ongeëiste items",
"hc.unclaimedItemsMatchLeftWithout": "Ongeëiste items: match overgelaten zonder een claim binnen de deadline. Je kunt ze weer in opslag plaatsen.",
"hc.unlockTheFinderSContact": "Ontgrendel de contactgegevens van de vindende om de overdracht te regelen.",
"hc.upcoming": "Aanstaande",
"hc.updateFailed": "Bijwerken mislukt.",
"hc.usedForInvoices": "Gebruikt om je findloop-facturen te verstrekken.",
"hc.vatNumber": "Btw-nummer",
"hc.verificationPending": "Verificatie in behandeling",
"hc.verificationSentToTheFinder": "Verificatie gestuurd naar de vindende. Je wordt op de hoogte gebracht van hun beslissing.",
"hc.verificationSentToThePartner": "Verificatie gestuurd naar de partner. Je wordt op de hoogte gebracht van hun beslissing.",
"hc.verify": "Verifiëren",
"hc.verifyingInvite": "Bevestigen van de uitnodigingslink…",
"hc.verifyingTheLink": "Bevestigen van de link…",
"hc.viewInRegistry": "Bekijken in register",
"hc.viewItem": "Item bekijken",
"hc.viewItemRecover": "Item bekijken & terugvorderen",
"hc.visibleToTheOwnerAutomatically": "Zichtbaar voor de eigenaar · automatisch verwijderd na 60 dagen.",
"hc.waitingForPartnerConfirmation": "Wachten op bevestiging van de partner",
"hc.waitingForThePartnerS": "Wachten op de bevestiging van de partner",
"hc.weHaveInformedTheEstablishment": "We hebben het filiaal geïnformeerd dat dit item niet van jou is en de analyse opnieuw gestart. Je wordt op de hoogte gesteld zodra er een nieuwe match is gevonden.",
"hc.weHaveInformedThePartner": "We hebben de partner geïnformeerd dat dit item niet van jou is. Je vermelding blijft actief voor toekomstige matches.",
"hc.weRanTheAnalysisAgain": "We hebben de analyse opnieuw uitgevoerd en een ander item geïdentificeerd dat van jou kan zijn. Controleer het nogmaals.",
"hc.weight": "Gewicht",
"hc.weightNotProvidedTheShipping": "Gewicht niet opgegeven: de verzendkosten worden berekend op het moment van verzending.",
"hc.weightUnit": "Gewichtseenheid",
"hc.welcome": "Welkom!",
"hc.welcomeToFindo": "Welkom bij Findloop",
"hc.whenACustomerComesTo": "Wanneer een klant komt om hun bezittingen op te halen, open je hun verklaring en valideer je de terugkeer. Dat is alles!",
"hc.whenDisabledFeesDropTo": ". Wanneer uitgeschakeld, dalen de kosten naar",
"hc.whyIsThisNotYour": "Waarom is dit niet jouw item?",
"hc.willBeMarkedAs": "zal worden gemarkeerd als",
"hc.wrongColor": "Verkeerde kleur",
"hc.wrongModel": "Verkeerd model",
"hc.yesCancel": "Ja, annuleren",
"hc.yesContactTheFinder": "Ja, neem contact op met de vindende partij",
"hc.youAreHere": "Je bent hier",
"hc.youBusinessCom": "jij@bedrijf.com",
"hc.youCanNowStartThe": "Je kunt nu de retourprocedure starten.",
"hc.youCanStillChangeIt": ". Je kunt het nog steeds per geval wijzigen.",
"hc.youHaveAlreadyConfirmedThat": "Je hebt al bevestigd dat dit jouw item is.",
"hc.youWillBeRedirectedTo": "Je wordt doorgestuurd naar de veilige Stripe-betaling.",
"hc.yourAccountHasBeenReactivated": "Je account is opnieuw geactiveerd.",
"hc.yourAccountIsActiveYou": "Je account is actief, je kunt nu je instellingen beheren.",
"hc.yourEstablishment": "Je instelling",
"hc.yourFeedbackHelpsUsImprove": "Je feedback helpt ons om onze matches te verbeteren.",
"hc.yourFeedbackHelpsUsRestart": "Je feedback helpt ons om de analyse opnieuw te starten en onze matches te verbeteren.",
"hc.yourFirstSteps": "Je eerste stappen",
"hc.yourFirstStepsAdmin": "Je eerste stappen (admin)",
"hc.yourItemHasBeenHanded": "Je item is persoonlijk overhandigd door de partner — sluit de zaak zodra de overdracht is bevestigd.",
"hc.yourItemHasBeenShipped": "Je item is verzonden door de partner — sluit de zaak zodra de levering is bevestigd.",
"hc.yourPaymentHasBeenRecorded": "Je betaling is geregistreerd.",
"hc.yourShipmentIsBeingPrepared": "Je zending wordt voorbereid. Je ontvangt je pakket binnen 3 tot 5 werkdagen.",
"hc.yourShippingFeesHaveAlready": "Je verzendkosten zijn al betaald. Verzendkosten betaald ✓",
"hc.yourShippingFeesHaveBeen": "Je verzendkosten zijn betaald. Je pakket wordt voorbereid.",
"hc.yourVerificationQuestionsDeposit": "Je verificatievragen (borg)",
"hero.einvoiceBadge": "2027-conforme e-facturering",
"home.recentAdsAll": "Bekijk alle advertenties",
"home.recentAdsEyebrow": "Op dit moment",
"home.recentAdsSubtitle": "Verloren en gevonden items gerapporteerd door de gemeenschap.",
"home.recentAdsTitle": "Laatste advertenties",
"home.reunions": "Recente bijeenkomsten",
"pricing.physInvTitle": "Fysieke voorraad tracking",
"pricing.physModalTitle": "Fysieke itembeheer",
"pricing.physQrDesc": "Een unieke QR-code wordt per item gegenereerd en linkt naar alle informatie.",
"pricing.physQrTitle": "Toegewijde QR-label",
"pricing.physShelfDesc": "Elk geregistreerd item kan een fysieke locatie binnen de instelling krijgen.",
"pricing.physShelfTitle": "Plankplan",
"pricing.physicalMgmt": "Fysiek itembeheer (planken, QR, voorraad)",
"pub.addSecondPhoto": "Voeg een 2e foto toe (optioneel)",
"pub.photo2Added": "✓ 2e foto toegevoegd",
"reg.dispositionJournal": "Afhandelingsjournal",
"reg.dispositionNoteAuthHint": "ℹ️ Een opmerking is vereist voor “Overhandigd aan autoriteiten” (rapportnummer, afdeling…).",
"reg.dispositionNotePh": "Opmerking (optioneel): ontvangende stichting, referentie autoriteiten, naam koper…",
"reg.dispositionNoteRequired": "Een officiële referentie is vereist om aan de autoriteiten over te dragen.",
"reg.legalPrealert": "Wettelijke deadline in {days} dag(en)",
"reg.legalPrealertOptions": "Opties bij deadline: veilingverkoop, donatie aan een stichting, overhandiging aan autoriteiten.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Volledige beoordeling",
"rev.readMore": "Lees meer",
"rw.activeCodes": "Actieve vouchers",
"rw.archived": "Gearchiveerd",
"rw.archivedTitle": "Ingeloste vouchers (gearchiveerd)",
"rw.hideArchived": "Verberg ingeloste vouchers",
"rw.noArchived": "Geen gearchiveerde voucher.",
"rw.showArchived": "Toon ingeloste vouchers",
"shp.labelAuto": "Het label wordt automatisch gegenereerd zodra de klant de verzendkosten heeft betaald. Het zal hier te downloaden zijn.",
"st.cancelled_by_customer": "Geannuleerd",
"stt.dispoPdfBtn": "Exporteer PDF",
"stt.dispoPdfError": "PDF-export mislukt.",
"stt.dispoPdfExporting": "Aan het exporteren…",
"trk.matchVerifying": "Potentiële match wordt geverifieerd",
"home.videoEyebrow": "Kijk",
"home.videoSubtitle": "Hoe we verloren voorwerpen moeiteloos terugbrengen bij hun eigenaars.",
"home.videoTitle": "Ontdek Findloop in 2 minuten",
"home.watchYoutube": "Bekijk op YouTube",
"impact.already": "Al",
"impact.citiesWord": "stad/steden",
"impact.eachPoint": "Elke stip is een stad waar Findloop helpt verloren voorwerpen terug te vinden.",
"impact.emptyMap": "De kaart vult zich naarmate restituties plaatsvinden.",
"impact.eyebrow": "Onze impact",
"impact.inCities": "over",
"impact.restitutedTo": "voorwerpen teruggebracht naar hun eigenaars",
"impact.title": "Voorwerpen teruggebracht, overal bij jou in de buurt",
"inv2.download": "Downloaden",
"inv2.view": "Bekijken",
"map.objectsOnMapPlural": "voorwerpen op de kaart",
"map.objectsOnMapSingular": "voorwerp op de kaart",
"mc.claimConfirmDesc": "Controleer het voorwerp dat door de vinder is gevonden voordat je betaalt om hun contactgegevens te ontgrendelen.",
"mc.claimConfirmNo": "Dit is niet mijn voorwerp",
"mc.claimConfirmTitle": "Is dit echt jouw voorwerp?",
"mc.claimConfirmYes": "Ja, het is van mij — betaal",
"mc.claimFinderContacts": "Contactgegevens van de vinder",
"mc.claimNotMineDone": "Bedankt — de vinder is gewaarschuwd en je verzoek is uit de advertentie verwijderd.",
"mc.claimUnlockDesc": "Betaal de Findloop beheervergoeding om de contactgegevens van de persoon die jouw voorwerp heeft gevonden te krijgen.",
"mc.claimUnlockTitle": "Ontgrendel de contactgegevens van de vinder",
"mc.hideCountryOffers": "Verberg aanbiedingen in mijn land",
"mc.myClaims": "Voorwerpen die ik claim",
"mc.myClaimsSub": "Voorwerpen die door anderen zijn gevonden en die jij claimt. Ontgrendel de contactgegevens van de vinder om de overdracht te regelen.",
"mc.notifAdCancelled": "Advertentie geannuleerd",
"mc.notifCancelAd": "Annuleer mijn advertentie",
"mc.offersInCountry": "Aanbiedingen in mijn land",
"mc.offersInCountryDesc": "Alle actieve beloningen van partners in jouw land, per stad.",
"mc.redArchived": "Gearchiveerd",
"mc.rewardsCountryNone": "Nog geen aanbieding in jouw land.",
"mc.rewardsForYou": "Beloningen voor jou",
"mc.rewardsForYouDesc": "Biedt de partner(s) waar je een voorwerp hebt afgegeven.",
"mc.rewardsMineNone": "Nog geen beloning van jouw afgiftepartners.",
"mc.showCountryOffers": "Bekijk aanbiedingen in mijn land",
"mc2.cancelDecl": "Annuleer mijn verklaring",
"mc2.cancelDeclDone": "Verklaring geannuleerd.",
"pricing.physInvDesc": "Wanneer een voorwerp wordt teruggebracht, wordt de locatie automatisch vrijgegeven en beschikbaar voor een nieuw voorwerp.",
"pcat.stadium_arena": "Stadion / Arena",
"pcat.supermarket": "Supermarkt",
"pcat.taxi_vtc": "Taxi / Rit delen",
"pcat.tourism_office": "Toeristenbureau",
"pcat.train_bus_station": "Trein- / busstation",
"pcat.travel_agency": "Reisbureau",
"hc.and": "en",
"hc.demoObj0": "een portemonnee",
"hc.demoObj1": "een sporttas",
"hc.demoObj2": "een telefoon",
"hc.demoObj3": "een paar brillen",
"hc.demoObj4": "een set sleutels",
"hc.demoObj5": "een sjaal",
"hc.demoObj6": "een laptop",
"hc.demoObj7": "een waterfles",
"hc.demoWhen0": "2 uur geleden",
"hc.demoWhen1": "5 uur geleden",
"hc.demoWhen2": "gisteren",
"hc.demoWhen3": "3 uur geleden",
"hc.demoWhen4": "vandaag vroeg",
"hc.demoWhen5": "1 dag geleden",
"hc.feedDemo": "{obj} werd teruggegeven in {city} {when}.",
"hc.feedReal": "Een item ({cat}) werd teruggegeven in {city}.",
"hc.saveBtn": "Opslaan",
"hc.saveLink": "Opslaan link",
"hc.terms": "Voorwaarden",
"hc.view": "Bekijk",
"pcat.airline": "Luchtvaartmaatschappij",
"pcat.airport": "Luchthaven",
"pcat.amusement_park": "Attractiepark",
"pcat.bank": "Bank",
"pcat.bar_cafe": "Bar / Café",
"pcat.beauty_salon": "Haar / Schoonheidssalon",
"pcat.cinema": "Bioscoop",
"pcat.concert_theater": "Concertzaal / Theater",
"pcat.coworking": "Coworkingruimte",
"pcat.gym_fitness": "Gym / Fitness",
"pcat.hospital_clinic": "Ziekenhuis / Kliniek",
"pcat.library": "Bibliotheek",
"pcat.mall": "Winkelcentrum",
"pcat.museum": "Museum",
"pcat.pharmacy": "Apotheek",
"pcat.private_company": "Privébedrijf",
"pcat.public_transport": "Openbaar vervoer",
"pcat.school_university": "School / Universiteit",
"pcat.sports_center": "Sportcentrum",
"an.found": "Gevonden",
"an.lost": "Verloren",
"hc.shareReview": "De beoordeling delen",
"hc.citiesAboveTarget": "{n} steden boven hun doel",
"hc.cityAboveTarget": "{n} stad boven zijn doel",
"hc.j15EarlyReminder": "D-15 vroege herinnering",
"hc.j7EarlyReminder": "D-7 vroege herinnering",
"hc.annualTotal": "Jaarlijkse totaal",
"hc.billedOnceYear": "Eenmalig aangerekend voor 12 maanden, elk jaar verlengd.",
"hc.monthlyPrice": "Maandprijs",
"hc.perMonth": "/ maand",
"hc.perYear": "/ jaar",
"hc.billedEachMonth": "Automatisch elke maand in rekening gebracht.",
"nav.business": "Zakelijk",
"nav.individual": "Individueel",
"hc.circumstancesFound": "Omstandigheden van de vondst",
"hc.circumstancesFoundPh": "Bijv. gevonden op de grond nabij de metro-ingang",
"hc.circumstancesLost": "Omstandigheden van het verlies",
"hc.circumstancesLostPh": "Bijv. achtergelaten op een bank terwijl ik op de bus wachtte",
"hc.conditionPh": "Bijv. goed, krassen…",
"hc.firstName": "Voornaam",
"hc.lastName": "Achternaam",
"hc.quantity": "Aantal artikelen",
"fa.approve": "Goedkeuren",
"fa.approveConfirm": "Deze verklaring goedkeuren? Je volledige contactdetails (naam, e-mail, telefoon) worden uitgewisseld met de vinders.",
"fa.approved": "Verklaring goedgekeurd — contactdetails uitgewisseld",
"fa.approvedFinder": "De eigenaar heeft je verklaring goedgekeurd",
"fa.approvedFinderText": "Neem contact met hen op om de teruggave te regelen.",
"fa.boostSub": "Je lijst blijft bovenaan voor de gekozen duur.",
"fa.boostTitle": "Verhoog mijn lijst (optioneel)",
"fa.colFinder": "Verklaring van de vinders",
"fa.colYours": "Jouw verklaring",
"fa.compareHint": "Vergelijk de verklaring van de vinder met die van jou voordat je beslist.",
"fa.contribNone": "Geen bijdrage",
"fa.contribPaid": "Bijdrage ontvangen — bedankt!",
"fa.contribPending": "Bijdrage wacht op betaling",
"fa.contribSub": "Steun Findloop om meer mensen te helpen hun bezittingen terug te krijgen. Je kunt €0 kiezen.",
"fa.contribSuccessMsg": "Je verklaring is naar de eigenaar gestuurd.",
"fa.contribSuccessTitle": "Bedankt voor je bijdrage",
"fa.contribTitle": "Vrijwillige bijdrage",
"fa.days3": "3 dagen",
"fa.days30": "30 dagen",
"fa.days7": "7 dagen",
"fa.declSub": "Beschrijf het item dat je hebt gevonden. De eigenaar zal jouw verklaring vergelijken met die van hen.",
"fa.declTitle": "Ik heb dit item gevonden",
"fa.expiresOn": "Vervalt op",
"fa.fBrand": "Merk",
"fa.fCircumstances": "Omstandigheden",
"fa.fCity": "Stad",
"fa.fColor": "Kleur",
"fa.fCondition": "Toestand",
"fa.fDate": "Datum",
"fa.fMessage": "Bericht van de vinder",
"fa.fPlace": "Plaats",
"fa.fQuantity": "Aantal",
"fa.finderContact": "Contactgegevens van de vinder",
"fa.finishPay": "Betaling voltooien",
"fa.foundDate": "Datum gevonden",
"fa.foundPlace": "Plaats gevonden",
"fa.hours24": "24 uur",
"fa.ht": "excl. BTW",
"fa.months3": "3 maanden",
"fa.noBoost": "Geen verhoging",
"fa.ownerContact": "Contactgegevens van de eigenaar",
"fa.payPublish": "Betaal en publiceer",
"fa.pendingPayText": "Je vermelding gaat live zodra de betaling is bevestigd.",
"fa.pendingPayTitle": "Betaling in behandeling",
"fa.planSub": "Je vermelding gaat live zodra de betaling is bevestigd.",
"fa.planTitle": "Duur van de vermelding",
"fa.pubSuccessMsg": "Je vermelding is live. Je ontvangt een melding zodra een vinder zich meldt.",
"fa.pubSuccessTitle": "Vermelding gepubliceerd",
"fa.publicNote": "Alleen de beschrijving, stad, land en foto's zijn openbaar zichtbaar.",
"fa.redirectStripe": "Wordt omgeleid naar veilige betaling…",
"fa.reject": "Afwijzen",
"fa.rejectConfirm": "Deze verklaring afwijzen? Je vermelding blijft online.",
"fa.rejected": "Verklaring afgewezen",
"fa.rejectedFinder": "Het was niet het item waar ze naar zochten",
"fa.rejectedFinderText": "De eigenaar zegt dat dit item niet van hen is. Bedankt voor je hulp!",
"fa.responsesTitle": "Verklaringen van vinders",
"fa.sent": "Verklaring verzonden naar de eigenaar.",
"fa.submitDecl": "Stuur mijn verklaring",
"fa.submitDeclPay": "Stuur en draag bij {amount}",
"fa.total": "Totaal te betalen",
"fa.ttc": "incl. BTW",
"fa.waitClaimText": "De vinder beoordeelt je aanvraag. Je ontvangt een melding van hun beslissing.",
"fa.waitFinderText": "We laten je weten zodra een vinder een verklaring indient.",
"fa.waitFinderTitle": "Je vermelding is live",
"fa.waitOwnerText": "De eigenaar vergelijkt je verklaring met de hunne. Je ontvangt een melding van hun beslissing.",
"fa.waitOwnerTitle": "Wachten op de beslissing van de eigenaar",
"st.pending_payment": "Betaling in behandeling",
"fa.africaFree": "Gratis vermelding in Afrika — Findloop lanceeraanbieding, geniet ervan!",
"fa.africaPublished": "Vermelding gratis gepubliceerd — Afrikaanse lanceeraanbieding!",
"fa.approveClaimConfirm": "Deze claim goedkeuren? De eigenaar kan dan uw contactgegevens ontgrendelen.",
"fa.checkInfo": "Controleer uw gegevens voordat u verzendt: ze worden vergeleken met die van de vindende.",
"fa.claimApprovedShort": "De vindende heeft uw claim goedgekeurd",
"fa.claimRejectedShort": "Claim afgewezen door de vindende",
"fa.claimRejectedText": "De vindende denkt dat dit item niet van u is.",
"fa.claimSub": "Beschrijf uw item en voeg 2 foto’s toe. De vindende zal ze vergelijken met hun vermelding.",
"fa.claimTitle": "Dit is mijn item",
"fa.claimUnlockText": "Ontgrendel de contactgegevens van de vindende om de teruggave te regelen.",
"fa.claimUnlockedShort": "Contactgegevens ontgrendeld — zie tracking",
"fa.claimsTitle": "Eigenaar claims",
"fa.colOwner": "Verklaring van de eigenaar",
"fa.colYourAd": "Uw vermelding",
"fa.expired": "Vermelding verlopen",
"fa.free": "Gratis",
"fa.lostDate": "Verlies datum",
"fa.lostPlace": "Verlies plaats",
"fa.noReceipt": "Geen bon beschikbaar voor deze vermelding.",
"fa.planSubFree": "Kies de duur: uw vermelding gaat direct live, geen betaling nodig.",
"fa.prefillPrevious": "Herbruik de gegevens van mijn vorige vermelding in deze categorie",
"fa.receipt": "PDF-bon",
"fa.renewBtn": "Vernieuwen",
"fa.renewDiscountBanner": "50% korting: vernieuw voordat uw vermelding verloopt!",
"fa.renewDiscountHint": "50% korting toegepast omdat u vóór vervaldatum vernieuwt.",
"fa.renewEarly": "Vernieuwen (−50%)",
"fa.renewTitle": "Vernieuw mijn vermelding",
"fa.renewed": "Vermelding vernieuwd",
"fa.sendClaim": "Stuur mijn claim",
"fa.twoPhotos": "2 foto’s van uw item",
"fa.twoPhotosError": "Voeg 2 foto’s van uw item toe.",
"fa.twoPhotosHint": "Persoonlijke foto's die bewijzen dat het item van u is (met het item, factuur, doos...).",
"fa.unlockBtn": "Ontgrendel contactgegevens",
"fa.unlockFree": "Ontgrendel gratis — lanceeraanbieding",
"fa.waitClaimantText": "We laten het u weten zodra een eigenaar dit item claimt.",
"fa.waitFinderDecision": "Wachten op de beslissing van de vindende",
"fa.waitUnlockText": "U wordt geïnformeerd zodra de contactgegevens zijn uitgewisseld.",
"fa.waitUnlockTitle": "Wachten tot de eigenaar ontgrendel",
"fa.cancel": "Annuleren",
"fa.categoryRequired": "Kies een categorie voor het gevonden item.",
"fa.confirmTitle": "Bevestig je beslissing",
"fa.goBack": "Ga terug",
"dr.continue": "Ga door met mijn verklaring",
"dr.delete": "Permanent verwijderen",
"dr.deleteConfirm": "Deze concept permanent verwijderen? Dit kan niet ongedaan worden gemaakt.",
"dr.deleted": "Concept verwijderd",
"dr.expiresIn": "Concept nog {h} uur bewaard",
"dr.title": "Je hebt een onvoltooid verklaring",
"form.step": "Stap",
"form.next": "Doorgaan",
"form.back": "Terug",
"form.stepDetails": "Uw rapport",
"form.stepPublish": "Duur, boost & betaling",
"form.stepThanks": "Bedankt & bijdrage",
"fthx.badge": "Rapport bijna klaar",
"fthx.title": "Bedankt, u maakt het verschil!",
"fthx.text": "Dankzij u kan iemand binnenkort iets terugkrijgen dat voor hen belangrijk is. Daden van vriendelijkheid zoals die van u zijn precies wat Findloop levend houdt.",
"fthx.impact1": "1 item gerapporteerd",
"fthx.impact2": "1 kans meer op een hereniging",
"fthx.tipTitle": "Een kleine boost voor Findloop?",
"fthx.tipText": "Jouw bijdrage helpt ons de service toegankelijk te houden en nog meer items te herenigen met hun eigenaren.",
"fthx.optional": "100% optioneel — je kunt publiceren zonder bij te dragen.",
"fthx.thanksTip": "Hartelijk dank voor uw genereuze gift!",
"fthx.suggest": "Voorgestelde bedragen",
"fthx.none": "Geen tip",
"pay.pendingTitle": "Betaling niet voltooid",
"pay.pendingText": "Je gegevens zijn opgeslagen. Ga verder met de betaling waar je was gebleven.",
"pay.resume": "Betaling hervatten",
"pay.expiredTitle": "Betalingssessie verlopen",
"pay.expiredText": "Voor je veiligheid is de betalingssessie verlopen. Je gegevens zijn opgeslagen: start de betaling met één klik opnieuw.",
"pay.relaunch": "Betaling opnieuw starten",
"sub.received": "Verzonden!",
"sub.publishing": "We zijn bezig met de laatste hand…",
"sub.toPayment": "Wordt doorgestuurd naar veilige betaling…",
"fa.claimSubV2": "Beschrijf uw verloren voorwerp. De persoon die het heeft gevonden, zal uw verklaring vergelijken met hun vermelding.",
"fa.photosOptional": "Foto's van uw voorwerp (optioneel)",
"fa.compareOwnerHint": "Vergelijk deze informatie met het voorwerp dat u hebt gevonden en geef aan of het hetzelfde voorwerp is.",
"fa.itsThisItem": "Ja, dit is het voorwerp",
"fa.notThisItem": "Nee, dit is het voorwerp niet",
"fa.confirmIsItem": "Bevestig dat dit het voorwerp is? Uw contactgegevens en die van de eigenaar worden in uw respectieve accounts weergegeven.",
"fa.confirmNotItem": "Bevestig dat dit het voorwerp niet is? Uw melding wordt gesloten.",
"fa.youConfirmed": "U heeft bevestigd dat dit het voorwerp van de eigenaar is",
"fa.youDeclined": "U heeft aangegeven dat dit niet het voorwerp is",
"fa.youDeclinedText": "Bedankt voor uw hulp! De eigenaar is geïnformeerd.",
"fa.waitFinderDecisionOwner": "Wachten op de beslissing van de vinder",
"fa.finderConfirmed": "Bevestigd",
"fa.notYourItem": "Dit was niet uw voorwerp",
"fa.reportedOn": "Gerapporteerd op",
"fa.ownerWaitHint": "Een vinder controleert momenteel de informatie, please wacht.",
"fa.claimSentFinder": "Claim verzonden naar de persoon die het item heeft gevonden.",
"fa.compareClaimHint": "Vergelijk de verklaring van de eigenaar met jouw vermelding voordat je een beslissing neemt.",
"fa.closeFollowup": "Sluit dit vervolg",
"fa.closeFollowupConfirm": "Dit vervolg sluiten? De e-mailadressen en telefoonnummers van beide partijen worden permanent verwijderd zodra de eigenaar ook hun aanbieding heeft gesloten.",
"fa.safetyTitle": "Veiligheidstips voor de overdracht",
"fa.safety1": "Vraag de eigenaar om een gedetailleerde beschrijving van verborgen kenmerken van het item: een specifieke kras, de exacte inhoud van een tas, het behang, het serienummer…",
"fa.safety2": "Vraag indien mogelijk om visueel bewijs (een foto van het item) of een aankoopbewijs.",
"fa.safety3": "Geef het item over op een openbare plaats of bij een Findloop-partner en controleer de ID van de eigenaar.",
"fa.safetyOk": "Begrepen, ga verder",
"fa.ownerClosedNote": "De eigenaar heeft hun aanbieding gesloten.",
"fa.finderClosedNote": "De vindende heeft hun vervolg gesloten.",
"fa.followupClosed": "Opvolging gesloten",
"fa.followupClosedText": "Je hebt deze opvolging gesloten. Bedankt voor je hulp!",
"fa.photoReviewTitle": "Een finder heeft een foto gestuurd. Lijkt het op jouw item?",
"fa.photoLooksLike": "Ja, het lijkt op mijn item",
"fa.photoNotMine": "Nee, dit is niet mijn item",
"fa.photoNotMineConfirm": "De opvolging wordt aan beide zijden gesloten en jouw aanbieding blijft open voor een nieuwe finder.",
"fa.photoLooksLikeDone": "Bedankt! De finder zal nu jouw verklaring vergelijken.",
"fa.photoNotMineDone": "Rapport afgewezen. Jouw aanbieding blijft open.",
"fa.ownerPhotoHint": "Alleen de foto van de finder is aan jou getoond. Laat ons weten of het op jouw item lijkt.",
"fa.ownerReviewingPhoto": "De eigenaar beoordeelt jouw foto",
"fa.ownerReviewingPhotoText": "Je ontvangt een melding zodra ze antwoorden. Je kunt dan hun verklaring vergelijken.",
"fa.ownerRejectedPhoto": "Dit is niet het item van de eigenaar",
"fa.ownerRejectedPhotoText": "De eigenaar zegt dat jouw foto niet overeenkomt met hun item. De opvolging is gesloten. Bedankt voor je hulp!",
"fa.contribute": "Bijdragen",
"fa.phoneMissing": "Niet opgegeven",
"fa.ownerSafety1": "Geef de voorkeur aan een overdracht op een openbare plaats of bij een Findloop-partner. Als de afstand groot is, stel dan voor om het per post te verzenden.",
"fa.ownerSafety2": "Controleer bij de overdracht de ID van de vinder.",
"pub.changePhoto": "Foto wijzigen",
"ph.secured": "Foto beveiligd",
"ph.securing": "De foto wordt beveiligd…",
"fa.ownerSafety3": "Als de foto van de vinder het Findloop-watermerk bevat, accepteer de afspraak dan niet. De foto moet een origineel beeld zijn dat door de vinder is genomen, zonder watermerk."
},
"pl": {
"ac.africa": "Afryka",
"ac.boostActive": "Wyróżnij aktywne —",
"ac.boostSub": "Pojaw się na górze katalogu partnerów z odznaką „Wyróżnione”.",
"ac.boostTitle": "Wyróżnij swoją ofertę w katalogu",
"ac.categoryHint": "Aby zaklasyfikować swoją placówkę w katalogu findloop.",
"ac.choose": "Wybierz",
"ac.cityHint": "Aby dokładnie umiejscowić na publicznej mapie.",
"ac.cityLabel": "Miasto placówki",
"ac.cityPh": "Paryż",
"ac.contact": "Dane kontaktowe",
"ac.converted": "Przekształcone",
"ac.copyDeclLink": "Skopiuj link zgłoszenia",
"ac.copyLink": "Skopiuj link",
"ac.currentPlan": "Aktualny plan",
"ac.emailDesc": "Wybierz e-maile, które chcesz otrzymywać. Powiadomienia w Twoim miejscu pracy są zawsze aktywne.",
"ac.emailMatch": "Dopasowania",
"ac.emailMatchDesc": "E-mail, gdy przedmiot pasuje do zgłoszenia",
"ac.emailNewDecl": "Nowe zgłoszenia strat",
"ac.emailNewDeclDesc": "E-mail, gdy klient zgłasza stratę w Twoim miejscu",
"ac.emailShip": "Zgłoszenia wysyłek",
"ac.emailShipDesc": "E-mail, gdy klient prosi o wysyłkę przedmiotu",
"ac.emailTitle": "Preferencje e-mailowe",
"ac.expireSoon": "Twoje wyróżnienie wkrótce wygasa —",
"ac.exportCsv": "Eksportuj (CSV)",
"ac.exportHint": "Eksportuj swoje zweryfikowane płatności zewnętrzne do księgowości.",
"ac.free": "Darmowe",
"ac.freeMonths": "Darmowe miesiące",
"ac.hours": "godzin",
"ac.howItWorks": "Jak to działa?",
"ac.invited": "Zaproszony",
"ac.legalFR": "Wymagane do fakturowania elektronicznego (Factur-X) obowiązującego od września 2026 r.",
"ac.legalMissing": "⚠️ Brak SIRET i VAT wewnątrz UE — uzupełnij je, aby pozostać w zgodzie z fakturowaniem elektronicznym.",
"ac.legalOther": "Zalecane dla Twoich faktur.",
"ac.legalPartnerQr": "Kod QR",
"ac.legalTitle": "Identyfikatory prawne (fakturowanie)",
"ac.logoTitle": "Logo placówki",
"ac.modeCurrent": "Aktualny tryb:",
"ac.modeExternal": "Zewnętrzny (walidacja ręczna)",
"ac.modeInternal": "Wewnętrzny Findloop (automatyczny)",
"ac.noSubReceipt": "Brak jeszcze opłaty za subskrypcję.",
"ac.none": "Brak",
"ac.onYourListing": "na Twojej ofercie",
"ac.pay1": "Wpisz poniżej swoje linki płatności, aby przekierować swoich klientów do własnego systemu zbierania płatności.",
"ac.pay2": "Walidacja staje się ręczna: potwierdzasz otrzymanie płatności z zakładki „Zgłoszenia”.",
"ac.pay3": "Link „Opłata za wysyłkę” to skonsolidowana płatność (odzyskiwanie + wysyłka).",
"ac.pay4": "Pozostaw puste pola, aby użyć wewnętrznej płatności Findloop (Stripe) z automatyczną walidacją.",
"ac.paySub": "Zbieraj opłaty za pośrednictwem własnego systemu płatności.",
"ac.payTitle": "Płatności zewnętrzne",
"ac.permissive": "Pobłażliwy",
"ac.phone": "Telefon",
"ac.posterA4": "Plakat A4 (PDF)",
"ac.qMessage": "Wiadomość (opcjonalnie)",
"ac.qName": "Imię",
"ac.qOrg": "Organizacja",
"ac.qSites": "Liczba placówek (szacunkowo)",
"ac.qrHint": "Twoi klienci skanują ten kod, aby zgłosić zagubiony przedmiot.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Twój kod QR partnera",
"ac.quoteDesc": "Lotniska, sieci kolejowe, międzynarodowe sieci · ",
"ac.quoteEurope": "Europa / Świat",
"ac.quoteSent": "Prośba o wycenę została wysłana. Nasz zespół skontaktuje się z Tobą wkrótce.",
"ac.quoteTitle": "Poproś o wycenę — Enterprise",
"ac.recoveryLink": "link „Opłata za odzyskanie”",
"ac.refSub": "Każdy polecony partner, który subskrybuje, daje Ci 1 darmowy miesiąc.",
"ac.refTitle": "Poleć, zarób darmowy miesiąc",
"ac.reminderDelay": "Opóźnienie przypomnienia o weryfikacji",
"ac.reminderHint": "Otrzymasz przypomnienie e-mail, jeśli zewnętrzna płatność pozostanie nieweryfikowana po tym opóźnieniu (domyślnie: 48h).",
"ac.renewDesc1": "Już zarobiłeś",
"ac.renewDesc2": "Odnów, aby pozostać na szczycie katalogu i nie stracić tej widoczności.",
"ac.renewNow": "Odnów teraz",
"ac.requestQuote": "Poproś o wycenę",
"ac.saveLegal": "Zapisz identyfikatory",
"ac.saveLinks": "Zapisz linki",
"ac.sendRequest": "Wyślij moją prośbę",
"ac.sending": "Wysyłanie…",
"ac.shippingLink": "link „Opłata za wysyłkę” (skonsolidowany)",
"ac.shippingLinkHint": "Ten link obejmuje zarówno odzyskanie, jak i wysyłkę.",
"ac.strict": "Ścisły",
"ac.subReceipt": "Potwierdzenie subskrypcji (PDF)",
"ac.subReceiptsSub": "Pobierz potwierdzenie PDF dla każdej płatności subskrypcyjnej.",
"ac.subReceiptsTitle": "Potwierdzenia subskrypcji",
"ac.tCategory": "Kategoria zapisana",
"ac.tCity": "Miasto zapisane — mapa zaktualizowana",
"ac.tCityNeeded": "Wprowadź miasto",
"ac.tCopied": "Skopiowano!",
"ac.tCover": "Zdjęcie okładki zaktualizowane",
"ac.tEmailPrefs": "Preferencje e-mail zaktualizowane",
"ac.tErr": "Błąd",
"ac.tExportImpossible": "Eksport nie powiódł się",
"ac.tLegal": "Identyfikatory prawne zapisane",
"ac.tLegalNeeded": "SIRET i VAT wymagane dla Francji",
"ac.tLogo": "Logo zaktualizowane",
"ac.tLogoRemoved": "Logo usunięte",
"ac.tPayLinks": "Linki płatności zapisane",
"ac.tPhone": "Telefon zapisany",
"ac.tSensitivity": "Czułość zapisana",
"ac.tVatInvalid": "Nieprawidłowy numer VAT",
"ac.tVatValid": "Prawidłowy VAT",
"ac.tabBoost": "Widoczność",
"ac.tabPayments": "Płatności",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR i Plakat",
"ac.tabReferral": "Referencje",
"ac.tabSub": "Subskrypcja",
"ac.thisWeek": "Ten tydzień",
"ac.thisWeekOf": " ({n} w tym tygodniu)",
"ac.thresholdDesc": "Prog czułości, od którego AI automatycznie weryfikuje zgodność zdjęcia i powiadamia klienta. Wyższy = mniej automatycznych zgodności, ale bardziej wiarygodny.",
"ac.thresholdTitle": "Czułość wizualnego dopasowania AI",
"ac.trend": "Trend",
"ac.upload": "Prześlij",
"ac.vatValidFmt": "Prawidłowy VAT{name} ({via})",
"ac.vatVerified": "Weryfikacja VAT wewnątrzwspólnotowego",
"ac.verifyVat": "Zweryfikuj VAT (VIES)",
"ac.verifying": "Weryfikowanie…",
"ac.views": "wyświetlenia",
"ac.viewsTotal": "Zyskane wyświetlenia (razem)",
"ac.winbackBtn": "Wznów z -20%",
"ac.winbackDesc1": "Zarobiłeś",
"ac.winbackDesc2": "Oferta specjalna: -20% zastosowane automatycznie, jeśli odnowisz w ciągu 24h.",
"ac.winbackTitle": "Twoje wyróżnienie właśnie wygasło — wznowić z -20%!",
"an.allCountries": "Wszystkie kraje",
"an.country": "Kraj",
"an.geoBanner": "Wyświetlasz oferty w",
"an.geoBannerWorld": "Wyświetlasz oferty na całym świecie",
"an.geoChange": "zmień kraj",
"an.loginRequired": "Zaloguj się, aby zgłosić ten przedmiot i śledzić zwrot.",
"an.requestInProgress": "Żądanie w toku",
"an.resolved": "Przedmiot już odzyskany",
"an.sortRecent": "Najnowsze",
"an.sortRelevance": "Relewancja",
"bo.africaPrice": "Zastosowano preferencyjne ceny dla strefy Afryki",
"c.all": "Wszystko",
"c.close": "Zamknij",
"c.confirm": "Potwierdź",
"c.confirmed": "Potwierdzone",
"c.download": "Pobierz",
"c.reset": "Resetuj",
"c.transfer": "Przenieś",
"cat.Animal": "Zwierzę / Akcesoria dla zwierząt",
"cat.AppareilPhoto": "Aparat",
"cat.Argent": "Pieniądze / Gotówka",
"cat.Autres": "Inne",
"cat.Bijoux": "Biżuteria",
"cat.CarteBancaire": "Karta bankowa",
"cat.CarteIdentite": "Dowód osobisty / Paszport",
"cat.Casquette": "Czapka",
"cat.Ceinture": "Pasek",
"cat.Chargeur": "Ładowarka / Kabel",
"cat.Chaussures": "Buty",
"cat.CleVoiture": "Klucz samochodowy",
"cat.Cles": "Klucze",
"cat.Console": "Konsola do gier",
"cat.Documents": "Dokumenty / papiery",
"cat.Echarpe": "Szalik",
"cat.Ecouteurs": "Słuchawki",
"cat.Electronique": "Elektronika (inne)",
"cat.Enceinte": "Głośnik",
"cat.Gants": "Rękawice",
"cat.Gourde": "Butelka na wodę / Termos",
"cat.Instrument": "Instrument muzyczny",
"cat.Jouet": "Zabawka / Pluszak",
"cat.Jumelles": "Lornetka",
"cat.Lampe": "Lampa / Latarka",
"cat.Liseuse": "E-czytnik",
"cat.Livre": "Książka / Notatnik",
"cat.Lunettes": "Okulary",
"cat.Manteau": "Płaszcz / Kurtka",
"cat.Maquillage": "Kosmetyczka",
"cat.Medical": "Sprzęt medyczny",
"cat.Medicaments": "Leki",
"cat.Montre": "Zegarek / Smartwatch",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Parasol",
"cat.Portefeuille": "Portfel",
"cat.Poussette": "Wózek / Akcesoria dla niemowląt",
"cat.Sac": "Torba / Torebka",
"cat.SacADos": "Plecak",
"cat.Souris": "Mysz / Klawiatura",
"cat.Sport": "Sprzęt sportowy",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefon / Smartfon",
"cat.Trottinette": "Hulajnoga",
"cat.Trousse": "Woreczek / Etui",
"cat.USB": "Pendrive / Dysk twardy",
"cat.Valise": "Walizka / Bagaż",
"cat.Velo": "Rower",
"cat.Vetements": "Odzież",
"cm.found": "ZNALEZIONO",
"cm.lost": "ZAGUBIONO",
"cmp.starterEst": "1 w zestawie + nielimitowana ilość dodatkowych",
"consent.required": "Musisz zgodzić się na udostępnienie swoich danych kontaktowych, aby kontynuować.",
"consent.share": "Zgadzam się, że znalazca mojego przedmiotu może zobaczyć moje dane kontaktowe (imię, e-mail, telefon), aby skontaktować się ze mną w celu zwrotu.",
"dc.partnerDesc": "Zgubiłeś przedmiot w miejscu partnerskim (hotel, dworzec, hala…)? Wybierz je, aby uzyskać bezpośredni zwrot.",
"dc.partnerList": "Wybierz z listy",
"dc.partnerMap": "Wybierz na mapie",
"dc.partnerTitle": "Zgłoszenie w miejscu partnerskim",
"dc.publicCta": "Opublikuj ogłoszenie publiczne",
"dc.publicDesc": "Twoje ogłoszenie będzie widoczne dla całej społeczności findloop. Idealne, jeśli nie wiesz, gdzie zgubiłeś przedmiot.",
"dc.publicTitle": "Publiczne zgłoszenie",
"dc.subtitle": "Wybierz sposób zgłoszenia zagubionego przedmiotu.",
"dc.title": "Co chciałbyś zrobić?",
"dec.addrPending": "Adres oczekujący od klienta",
"dec.analyzing": "Analizowanie…",
"dec.clientDescription": "Opis klienta",
"dec.clientPhoto": "Zdjęcie dostarczone przez klienta",
"dec.clientPhotoShort": "Zdjęcie klienta",
"dec.comparePhotos": "Porównaj zdjęcia",
"dec.declaredItemPhoto": "Zdjęcie zgłoszonego przedmiotu",
"dec.emptyDesc": "Podziel się swoim kodem QR, aby otrzymać zgłoszenia.",
"dec.emptyTitle": "Brak zgłoszeń",
"dec.enlarge": "Powiększ",
"dec.extBanner": "{n} płatność(i) zewnętrzna(e) do zatwierdzenia — potwierdź odbiór poniżej, aby odblokować przekazanie lub wysyłkę.",
"dec.foundItemAlt": "Znaleziony przedmiot",
"dec.foundItemRegistry": "Znaleziony przedmiot (rejestr)",
"dec.labelClient": "Klient",
"dec.labelRegistry": "Rejestr",
"dec.noMatchYet": "Brak dopasowania.",
"dec.noPhoto": "Brak zdjęcia",
"dec.pRecup": "odzyskanie",
"dec.pRecupP": "(odzyskanie)",
"dec.pRecupShip": "(odzyskanie + wysyłka)",
"dec.payConfirmed": "Płatność {x} potwierdzona",
"dec.payPending": "Płatność zewnętrzna {x} w toku",
"dec.pickup": "Odbiór osobisty",
"dec.reject": "Odrzuć",
"dec.rerun": "Uruchom ponownie analizę",
"dec.similarity": "Podobieństwo {n}%",
"dec.suggestedMatches": "Sugerowane dopasowania",
"dec.toColon": " do:",
"dec.toShip": "Do wysyłki",
"dec.toastExtPay": "Płatność potwierdzona — klient zostanie powiadomiony.",
"dec.toastMatch": "Dopasowanie potwierdzone",
"dec.toastReject": "Sugestia odrzucona",
"dec.toastRerun": "Analiza wznowiona",
"dec.toastVisualN": "{n} dopasowanie wizualne",
"dec.toastVisualNone": "Brak dopasowania wizualnego",
"dec.viewBeforeAfter": "Widok przed/po (nakładka)",
"dec.viewSideBySide": "Widok obok siebie",
"dec.visualCompare": "AI porównanie wizualne",
"dec.visualIdle": "Uruchom porównanie, aby AI wizualnie dopasowało zdjęcie klienta do znalezionych przedmiotów.",
"dec.visualRunning": "AI porównuje zdjęcie klienta z przedmiotami w Twoim rejestrze…",
"dec.zoomPhoto": "Powiększ zdjęcie",
"dep.addAnyway": "Dodaj mimo to",
"dep.addError": "Błąd podczas dodawania",
"dep.addItem": "Dodaj przedmiot",
"dep.added": "Przedmiot dodany do rejestru!",
"dep.adding": "Dodawanie…",
"dep.aiError": "Analiza AI niedostępna w tej chwili.",
"dep.aiFilled": "Formularz wypełniony przez AI ✨",
"dep.aiUnavailable": "AI niedostępne — wypełnij formularz ręcznie.",
"dep.analyzing": "Analizowanie…",
"dep.analyzingPhoto": "Analizowanie zdjęcia…",
"dep.brand": "Marka",
"dep.brandPlaceholder": "np. Apple",
"dep.category": "Kategoria",
"dep.checkingDup": "Sprawdzanie duplikatów…",
"dep.color": "Kolor",
"dep.colorPlaceholder": "np. czarny",
"dep.condition": "Stan",
"dep.conditionPlaceholder": "np. dobry stan",
"dep.depositorNote": "Notatka depozytora",
"dep.depositorNoteHint": "Szczegóły operacyjne wpisane ręcznie. AI nigdy nie nadpisuje tej notatki.",
"dep.depositorNotePlaceholder": "np. zawartość torby, marka podana przez osobę…",
"dep.descPlaceholder": "np. czarny iPhone 15 z przezroczystą obudową, znaleziony w barze…",
"dep.description": "Opis",
"dep.dupHint": "Upewnij się, że nie dodajesz duplikatu. Możesz kontynuować, jeśli przedmiot jest rzeczywiście inny.",
"dep.dupTitle": "Podobny przedmiot(y) już zarejestrowane",
"dep.dupWarn": "Wykryto podobny przedmiot — sprawdź, a następnie kliknij ponownie, aby potwierdzić.",
"dep.estHint": "Przedmiot zostanie dodany do rejestru tego obiektu.",
"dep.establishment": "Obiekt",
"dep.fee": "Opłata za odzyskanie (€) — opcjonalnie",
"dep.feePlaceholder": "Zostaw puste, aby użyć domyślnej ceny kategorii",
"dep.fillAI": "Wypełnij z AI",
"dep.optional": "(opcjonalnie)",
"dep.photo": "Zdjęcie przedmiotu",
"dep.principal": "główny",
"dep.reqError": "Kategoria i opis są wymagane.",
"dep.savedItem": "Zarejestrowany przedmiot",
"dep.similarity": "Podobieństwo",
"dep.storage": "Lokalizacja fizyczna",
"dep.storageHint": "Gdzie przedmiot jest fizycznie przechowywany. Zostanie wygenerowany kod QR, aby go znaleźć.",
"dep.storagePlaceholder": "np. Półka A3, Szafka 12, Sejf recepcyjny",
"dl.aClient": "klient",
"dl.alertsBlocked": "Powiadomienia przeglądarki zablokowane",
"dl.alertsBlockedHint": "Aby je ponownie włączyć: kliknij ikonę 🔒 (lub ⓘ) po lewej stronie adresu strony, a następnie zezwól na Powiadomienia i przeładuj stronę.",
"dl.amountDue": "Kwota do zapłaty: {amount} {currency}.",
"dl.enableAlerts": "Włącz powiadomienia",
"dl.extPending": "Płatności do zatwierdzenia",
"dl.freemiumNear": "Zbliżasz się do limitu Freemium ({used}/{max} przedmiotów w tym miesiącu). Ulepsz do Startera, aby mieć nieograniczoną liczbę przedmiotów.",
"dl.freemiumReached": "Osiągnięto limit Freemium ({used}/{max} przedmiotów w tym miesiącu). Ulepsz do Startera, aby zarejestrować nieograniczoną liczbę przedmiotów.",
"dl.invoiceOverdue": "Faktura {num} niezapłacona — dostęp ograniczony.",
"dl.matchNotifTitle": "Findloop — Nowe dopasowanie AI 🔔",
"dl.matchToast": "Nowe dopasowanie AI — {name}",
"dl.matchToastDesc": "Przedmiot odpowiada deklaracji.",
"dl.notifEmpty": "Brak powiadomień.",
"dl.notifEnabled": "Powiadomienia przeglądarki włączone",
"dl.notifTitle": "Powiadomienia",
"dl.payInvoice": "Zapłać swoją fakturę →",
"dl.rewardsPending": "Zniżki do przedstawienia",
"dl.upgradeStarter": "Ulepsz do Startera →",
"est.all": "Wszystkie placówki ({n})",
"est.label": "Placówka",
"est.primary": "pierwsza",
"est.secondary": "druga",
"est2.add": "Dodaj placówkę",
"est2.addressLabel": "Adres",
"est2.addressPh": "ul. République 12",
"est2.autoInvoice": "Szczegółowa faktura jest generowana automatycznie 1. dnia każdego miesiąca.",
"est2.baseSub": "Podstawowa subskrypcja",
"est2.billing": "Fakturowanie",
"est2.boostActivated": "Boost aktywowany dla {name}",
"est2.boostBillingNote": "Fakturowane według aktualnej stawki i grupowane na Twojej zbiorczej miesięcznej fakturze.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Popraw widoczność tej placówki w katalogu i na mapie.",
"est2.boostDuration": "{h}h wzmocnionej widoczności",
"est2.boostExtend": "Przedłuż",
"est2.boostTitle": "Boost {name}",
"est2.boosted": "Wzmocniony",
"est2.chartDesc": "Udział zwróconych przedmiotów z łącznej liczby zarejestrowanych, strona po stronie.",
"est2.chartTitle": "Wskaźnik zwrotu według placówki",
"est2.chartTooltip": "Zwróć",
"est2.cityLabel": "Miasto",
"est2.cityPh": "Lyon",
"est2.contactHint": "Te dane są wyświetlane klientowi dla tej placówki (przechodzi do konta, jeśli są puste).",
"est2.countryLabel": "Kraj",
"est2.coverLabel": "Zdjęcie w tle",
"est2.create": "Utwórz",
"est2.created": "Placówka utworzona",
"est2.delete": "Usuń",
"est2.deleteDesc": "Ta czynność jest trwała. Możesz usunąć placówkę tylko wtedy, gdy nie zawiera przedmiotów.",
"est2.deleteTitle": "Usunąć „{name}”?",
"est2.deleted": "Placówka usunięta",
"est2.dialogDesc": "Wprowadź nazwę i adres tej lokalizacji.",
"est2.edit": "Edytuj",
"est2.editEst": "Edytuj placówkę",
"est2.emailLabel": "Email kontaktowy",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " placówka(i)",
"est2.extraNoteBase": "{n} dodatkowa placówka(i) do fakturowania",
"est2.extraPrice": " po {price} €/miesiąc.",
"est2.extraQuote": " na podstawie wyceny.",
"est2.imgChange": "Wybierz obrazek",
"est2.imgDone": "Gotowe",
"est2.imgRemove": "Usuń",
"est2.imgRemoved": "Obrazek usunięty",
"est2.imgSaved": "Obrazek zapisany",
"est2.imgUploading": "Przesyłanie…",
"est2.includedPlan": "Zawarte w Twoim planie: {n}.",
"est2.kDeclarations": "Deklaracje",
"est2.kInStorage": "W magazynie",
"est2.kItemsTotal": "Przedmioty (łącznie)",
"est2.kRestituted": "Zwrócone",
"est2.limitReached": "Osiągnięty limit",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Dekl.",
"est2.mItems": "Przedmioty",
"est2.mRestituted": "Zwrócone",
"est2.mStorage": "W magazynie",
"est2.monthlyTotal": "Miesięczny całkowity",
"est2.nameLabel": "Nazwa *",
"est2.namePh": "np. Hotel Belmont — Annex Lyon",
"est2.newEst": "Nowa placówka",
"est2.onQuote": "Na ofertę",
"est2.phoneLabel": "Telefon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plan",
"est2.planLimited": "Twój plan „{tier}” jest ograniczony do {max} placówki(-ek).",
"est2.primary": "Podstawowy",
"est2.qr": "Kod QR",
"est2.qrDesc": "Wyświetl ten kod QR w tej placówce. Klienci zgłaszający zgubienie będą połączeni z tą stroną.",
"est2.qrTitle": "Kod QR — {name}",
"est2.saving": "Zapisywanie…",
"est2.seeInvoices": "Zobacz moje miesięczne faktury",
"est2.seePlans": "Zobacz plany",
"est2.subtitle": "Zarządzaj wszystkimi swoimi miejscami z jednego konta — skonsolidowany widok, przedmioty, kod QR i fakturowanie.",
"est2.suspended": "Zawieszone",
"est2.tierFree": "1 placówka",
"est2.tierLarge": "nieograniczone placówki",
"est2.tierMedium": "5 placówek wliczonych",
"est2.tierSmall": "3 placówki wliczone",
"est2.title": "Placówki",
"est2.unlimitedPlan": "Twój plan pozwala na nieograniczoną liczbę placówek.",
"est2.unlimitedSuffix": " · nieograniczone",
"est2.updated": "Placówka zaktualizowana",
"est2.upgradeHint": "Ulepsz plan, aby dodać więcej miejsc i scentralizować całą swoją aktywność.",
"est2.visuals": "Logo i zdjęcie",
"est2.visualsDesc": "Dostosuj logo i zdjęcie okładkowe tej placówki. Pojawią się na jej publicznej stronie i formularzu deklaracyjnym.",
"est2.visualsTitle": "Wizualizacje — {name}",
"est2.workOn": "Pracuj nad tą placówką",
"est2.working": "Pracujesz nad „{name}”",
"ft.backAccount": "Powrót do mojego konta",
"ft.closeBtn": "Zamknij sprawę",
"ft.closeConfirm": "Potwierdź, że przedmiot został zwrócony? Ogłoszenie zostanie zamknięte.",
"ft.closeLockedHint": "Najpierw zweryfikuj kod właściciela, aby odblokować zamknięcie.",
"ft.closed": "Sprawa zamknięta — przedmiot zwrócony!",
"ft.codeLabel": "Wprowadź kod weryfikacyjny otrzymany od właściciela",
"ft.codeNeeded": "Proszę wprowadzić kod weryfikacyjny.",
"ft.codeOk": "Kod zweryfikowany — możesz zamknąć sprawę.",
"ft.codePlaceholder": "np. 4821",
"ft.codeVerified": "Zweryfikowany",
"ft.doneMsg": "Przedmiot zwrócony. Dziękujemy za pomoc w jego zwrocie do właściciela!",
"ft.stepInProgress": "Zwrot w toku",
"ft.stepPublished": "Ogłoszenie opublikowane",
"ft.stepReturned": "Przedmiot zwrócony",
"ft.subtitle": "Sledź kroki, aż odnaleziony przedmiot zostanie zwrócony.",
"ft.title": "Śledzenie zwrotów",
"ft.verifyBtn": "Zweryfikuj kod",
"inv2.contractTitle": "Moja umowa Findloop",
"inv2.detailByEst": "Szczegóły według placówki",
"inv2.dueLabel": "Termin:",
"inv2.dueSuffix": " · termin {date}",
"inv2.error": "Błąd {status}",
"inv2.estCountIssued": "{n} placówki · wydane {date}",
"inv2.estimate": "Szacunkowa (nie obciążona) · {n} placówki",
"inv2.expired": " · wygasło",
"inv2.exportCsv": "Eksportuj CSV",
"inv2.exportDone": "Eksport CSV pobrany",
"inv2.included": "Wliczone",
"inv2.monthlyTitle": "Miesięczne fakturowanie (subskrypcja)",
"inv2.months": "+{n} miesięcy",
"inv2.paid": "Zapłacono",
"inv2.pay": "Zapłać",
"inv2.previewTitle": "Podgląd Twojej następnej faktury —",
"inv2.renew": "Odnowić mój kontrakt",
"inv2.renewalsTitle": "Historia odnawiania ({n})",
"inv2.renewedUntil": "Kontrakt odnowiony do {date}",
"inv2.serviceTitle": "Faktury za usługi (windykacja i wyceny)",
"inv2.soon": "Wygasa wkrótce",
"inv2.toPay": "Do zapłaty",
"inv2.totalHtTva": "Razem bez podatku · VAT",
"inv2.totalTtc": "Razem z podatkiem",
"iu.addPhoto": "Dodaj zdjęcie",
"iu.change": "Zmień",
"map.high": "Wysoki",
"map.legend": "Kolorowe punkty od czerwonego (niski) do zielonego (wysoki) w zależności od wskaźnika zwrotu; rozmiar na podstawie liczby przedmiotów.",
"map.locating": "Lokalizowanie… dodaj adres do swoich lokalizacji, aby zobaczyć je na mapie.",
"map.low": "Niski",
"map.medium": "Średni",
"map.noItemRegistered": "Brak zarejestrowanego przedmiotu",
"map.noItems": "Brak przedmiotu",
"map.returnedSuffix": "zwrócone · {a}/{t} przedmiotów",
"map.title": "Mapa Twoich lokalizacji",
"mc.archiveHide": "Ukryj historię",
"mc.archiveNone": "Brak rozwiązanych spraw.",
"mc.archiveShow": "Pokaż historię",
"mc.archiveSub": "Rozwiązane i zwrócone sprawy.",
"mc.archiveTitle": "Historia",
"mc.certificate": "Certyfikat",
"mc.finderAccepted": "Zaakceptowane",
"mc.hAd": "Zgubiona reklama",
"mc.hDeclaration": "Deklaracja",
"mc.hFinderContact": "Zgłoszony przedmiot",
"mc.hFound": "Zwrócony przedmiot",
"mc.hFoundAd": "Znalezione ogłoszenie",
"mc.myFinds": "Przedmioty, które znalazłem",
"mc.myFindsNone": "Nie zgłosiłeś jeszcze znalezienia żadnego przedmiotu.",
"mc.myFindsSub": "Przedmioty, które zgłosiłeś jako znalezione w ogłoszeniach o zgubionych przedmiotach.",
"mc.notifOpen": "Zobacz",
"mc.notifTrack": "Śledź",
"mc.notifViewAd": "Zobacz ogłoszenie",
"mc.presentHint": "Pokaż ten QR partnerowi: skanuje go, aby potwierdzić Twoją nagrodę.",
"mc.presentInStore": "Pokaż w sklepie",
"mc.presentTitle": "Pokaż ten bon",
"mc2.acceptFinder": "Zaakceptuj tego znalazcę",
"mc2.accountActivity": "Aktywność konta",
"mc2.adsActive": "{n}/5 aktywnych ogłoszeń",
"mc2.autoDelete": "Automatyczne usunięcie zaplanowane na",
"mc2.badgeBronze": "Brązowy",
"mc2.badgeGold": "Złoty",
"mc2.badgeSilver": "Srebrny",
"mc2.boostEarnedAlready": "Już zdobyłeś",
"mc2.boostEarnedWin": "Zdobyłeś",
"mc2.boostExpiredWin": "Twój boost właśnie wygasł — wznowienie z rabatem -20%!",
"mc2.boostExpiresIn": "Twój boost wygasa za",
"mc2.boostWinDetail2": ". -20% stosowane automatycznie, jeśli odnowisz w ciągu 24h.",
"mc2.claimCode": "Kod do odebrania:",
"mc2.codeSentFinder": "Kod wysłany do znalazcy e-mailem",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Pobierz mój paragon",
"mc2.error": "Błąd {status}",
"mc2.finderAccepted": "Finder zaakceptowany — kod wysłany emailem",
"mc2.finderContacts": "Szczegóły kontaktowe Findera(ów)",
"mc2.followFindo": "Śledź Findloop",
"mc2.imgInvalid": "Nieprawidłowy obraz",
"mc2.inactivityNote": " — w przypadku {n} miesięcy bezczynności (RODO).",
"mc2.lastActivity": "Ostatnia aktywność:",
"mc2.lostEmailTitle": "Nie mam już dostępu do mojego emaila",
"mc2.noPhotoPreset": "Brak zdjęcia? Wybierz domywny awatar:",
"mc2.paidViaPartner": "Opłacone (przez partnera)",
"mc2.payRecovery": "Zapłać opłatę za odzyskanie",
"mc2.paySettle": "Ureguluj moją płatność",
"mc2.payShipping": "Zapłać opłatę za wysyłkę",
"mc2.payUnavailable": "Płatność niedostępna",
"mc2.peopleFound": "{n} osoba(y) uważa, że znalazła twoją rzecz",
"mc2.phoneNumber": "Numer telefonu",
"mc2.reactivateAccount": "Reaktywuj moje konto",
"mc2.reactivated": "Konto reaktywowane",
"mc2.reactivatedThanks": "Konto reaktywowane — dziękujemy za lojalność!",
"mc2.recoverSmsBtn": "Odbierz mój kod przez SMS",
"mc2.recoverSmsDesc": "Otrzymaj swój kod roszczenia przez SMS na numer zarejestrowany na twoim koncie.",
"mc2.recoverSmsFallback": "Jeśli konto istnieje z tym numerem, SMS został wysłany.",
"mc2.renewStayTop": ". Odnów, aby pozostać na szczycie i odzyskać swoją rzecz.",
"mc2.resume20": "Wznów -20%",
"mc2.unlockContacts": "Odblokuj szczegóły kontaktowe",
"mc2.unlockDesc": "Zapłać opłatę manipulacyjną Findloop, aby ujawnić ich dane kontaktowe i zaaranżować przekazanie.",
"mc2.viewsWord": "wyświetlenia",
"mc2.live": "Na żywo",
"mh.allCategories": "Wszystkie kategorie",
"mh.allPeriod": "Cały czas",
"mh.autoMatch": "Automatyczne dopasowanie AI",
"mh.blocked": "Zablokowane (sprzeczność)",
"mh.blockedReason": "Dopasowanie zablokowane: główne słowa kluczowe przedmiotu i deklaracja są sprzeczne.",
"mh.days30": "Ostatnie 30 dni",
"mh.days7": "Ostatnie 7 dni",
"mh.days90": "Ostatnie 90 dni",
"mh.emptyDesc": "Dopasowania AI pojawią się tutaj, gdy przyjdą deklaracje.",
"mh.emptyTitle": "Brak wydarzeń",
"mh.exportCsv": "Eksportuj CSV",
"mh.exportDone": "Eksport CSV pobrany",
"mh.exportImpossible": "Eksport nie powiódł się",
"mh.fBlocked": "Zablokowane",
"mh.fConfirmed": "Potwierdzone",
"mh.fRejected": "Odrzucone",
"mh.objectLabel": "Przedmiot:",
"mh.refresh": "Odśwież",
"mh.rejected": "Odrzucone",
"mh.srcManual": "Ręcznie",
"mh.srcText": "Tekst",
"mh.srcVisual": "Wizualny (zdjęcie)",
"mh.subtitle": "Log dopasowań zaproponowanych przez AI — automatycznie dopasowane, potwierdzone i odrzucone.",
"mh.title": "Historia AI",
"nf.desc": "Strona, której szukasz, nie istnieje lub została przeniesiona.",
"nf.home": "Powrót do strony głównej",
"nf.title": "Strona nie znaleziona",
"par.allCities": "Wszystkie miasta",
"par.cityPh": "Miasto",
"pay.eurNote": "Kwoty wyświetlane w euro (€).",
"pg.next": "Dalej",
"pg.prev": "Poprzednia",
"pg.showing": "{from}–{to} z {total}",
"pk.bodyCopy": "Treść",
"pk.bodyText": "Tekst główny",
"pk.brandColors": "Kolory marki",
"pk.colorRed": "Czerwony",
"pk.colorWhite": "Biały",
"pk.darkBg": "Ciemne tło",
"pk.download": "Pobierz",
"pk.downloadZip": "Pobierz cały zestaw (ZIP)",
"pk.headings": "Nagłówki",
"pk.heroDesc": "Oficjalne logo, banery mediów społecznościowych, kolory i typografia. Wybierz język i wariant hasła, a następnie pobierz wizualizację lub cały zestaw.",
"pk.lightBg": "Jasne tło (druk)",
"pk.logoWordmark": "Logo / znak słowny",
"pk.logosVisuals": "Loga i wizualizacje",
"pk.mapCollect": "Mapa / punkty zbiórki",
"pk.plain": "Zwykły",
"pk.pressKit": "Zestaw dla mediów",
"pk.taglineLang": "Język hasła",
"pk.typography": "Typografia",
"pk.variant": "Wariant",
"pr2.adBoostMsg": "Świetny wybór! Mnożysz swoje szanse na szybsze odzyskanie przedmiotu.",
"pr2.boostActivated": "Wzmocnienie aktywowane!",
"pr2.canRecoverNow": "Możesz teraz odzyskać swój przedmiot.",
"pr2.continue": "Kontynuuj",
"pr2.downloadReceiptPdf": "Pobierz paragon (PDF)",
"pr2.goToSpaceNow": "Przejdź do mojego konta teraz",
"pr2.partnerBoostMsg": "Świetny wybór! Bycie bardziej widocznym oznacza przyciąganie nowych klientów do Twojego lokalu.",
"pr2.paymentSuccess": "Płatność zakończona sukcesem!",
"pr2.redirectingSpace": "Przekierowuję do Twojego konta…",
"pr2.subActivated": "Płatność zakończona sukcesem! Twoja subskrypcja jest aktywna, możesz teraz zarządzać swoimi lokalami.",
"prev.allSites": "Wszystkie lokale",
"pricing.annual": "Roczny",
"pricing.annualBadge": "-20% oferta",
"pricing.monthly": "Miesięczny",
"pricing.perYear": "/rok",
"pricing.saveLabel": "Oszczędzasz",
"pricing.savePerYear": "/rok za dodatkowy lokal",
"pub.accessGranted": "Dostęp przyznany",
"pub.accessLimited2h": "Dostęp ograniczony do 2 godzin",
"pub.accountEmailConcerned": "E-mail konta, którego dotyczy",
"pub.adAppearPublic": "Tak będzie wyglądać twoja reklama publicznie.",
"pub.adPreviewBtn": "Podgląd reklamy",
"pub.alertMeOnArrival": "Powiadom mnie o przyjeździe",
"pub.allActionsLogged": "Wszystkie działania są rejestrowane",
"pub.allCategories": "Wszystkie kategorie",
"pub.authorizeAccess": "Autoryzować dostęp",
"pub.authorizeSupportQ": "Autoryzować dostęp do wsparcia?",
"pub.available": "Dostępny",
"pub.backHome": "Powrót do strony głównej",
"pub.boostAdCta": "Wzmocnij moją reklamę",
"pub.boostAdTitle": "Wzmocnij swoją reklamę",
"pub.boostCarouselSub": "Przenieś na szczyt strony w „Wzmocnionym” karuzeli i zwiększ wyświetlenia, aby szybciej odzyskać swój przedmiot.",
"pub.boostEstablishment": "Wzmocnij swój lokal",
"pub.boostEstablishmentDesc": "Wyświetlaj się na szczycie katalogu z oznaczeniem „Wzmocniony” i przyciągaj więcej zgłoszeń.",
"pub.boostFicheCta": "Wzmocnij moją ofertę",
"pub.brandReady": "Marka Findloop, gotowa do użycia",
"pub.cantFindItem": "Nie możesz znaleźć swojego przedmiotu?",
"pub.cantProcessImage": "Nie można przetworzyć tego obrazu",
"pub.claimQr": "Zgłoś kod QR",
"pub.clickToZoom": "Kliknij, aby powiększyć",
"pub.codeAlreadyValidated": "Kod zweryfikowany — kontakty odblokowane.",
"pub.codeExample": "np. ABCD2345",
"pub.confirmRenewal": "Potwierdź odnowienie",
"pub.contactIntro": "Masz pytanie lub prośbę? Napisz do nas, szybko się z tobą skontaktujemy.",
"pub.contactTypeDeceased": "Usunięcie konta (osoba zmarła)",
"pub.contactTypeGeneral": "Ogólne pytanie",
"pub.contactTypeSupport": "Wsparcie / problem techniczny",
"pub.contactUs": "Skontaktuj się z nami",
"pub.continueWithoutEmail": "Kontynuuj bez podawania mojego emaila",
"pub.contractLabel": "Umowa",
"pub.contractNotFound": "Umowa nie znaleziona lub już wygasła.",
"pub.contractRenewed": "Umowa odnowiona!",
"pub.contractRenewedFor": "Twoja umowa została odnowiona na {n} miesiące.",
"pub.copyFailed": "Kopiowanie nie powiodło się",
"pub.createPartnerAccount": "Utwórz moje konto partnera",
"pub.currentDeadline": "Aktualny termin",
"pub.deceasedInfo": "Jako krewny lub spadkobierca możesz zgłosić usunięcie konta Findloop osoby zmarłej. Zrealizujemy twoją prośbę zgodnie z RODO (mogą być wymagane dokumenty potwierdzające).",
"pub.declareMyLoss": "Zgłoś swoją utratę",
"pub.describeItemPlaceholder": "Opisz swój przedmiot (np. czarny parasol, klucze…)",
"pub.downloadImage": "Pobierz obraz",
"pub.drawSignature": "Proszę narysować swój podpis.",
"pub.drawSignatureHint": "Narysuj swój podpis myszą lub palcem.",
"pub.duration": "Czas trwania",
"pub.eSignature": "Podpis elektroniczny",
"pub.eSignatureDesc": "Wpisz swoje imię, aby podpisać. Data jest rejestrowana automatycznie.",
"pub.edit": "Edytuj",
"pub.editorialTitles": "Tytuły redakcyjne",
"pub.emailPlaceholder": "ty@example.com",
"pub.enterCodeUnlockOwner": "Wprowadź kod otrzymany mailem, aby odblokować dane kontaktowe właściciela.",
"pub.errorWord": "Błąd",
"pub.foundSelfService": "Znalezione przedmioty · Samoobsługa",
"pub.haveOwnerCode": "Otrzymałem kod od właściciela",
"pub.home": "Strona główna",
"pub.immediateRenewal": "Natychmiastowe odnowienie, bez nowej wyceny.",
"pub.impAdminReq1": "Administrator",
"pub.impAdminReq2": "wnosi prośbę o tymczasowy dostęp do twojego konta",
"pub.impAdminReq3": "aby ci pomóc.",
"pub.impGrantedDesc": "Zespół wsparcia będzie miał dostęp do twojego konta maksymalnie przez 2 godziny. Każda akcja będzie rejestrowana. Możesz zamknąć tę stronę.",
"pub.invitedOnFindo": "Zostałeś zaproszony do Findloop",
"pub.isThisYourItem": "Czy to twój przedmiot?",
"pub.itemsAvailableCount": "Obecnie dostępnych {n} przedmiotów",
"pub.itemsFoundOwner": "powierzone przedmioty znalazły swojego właściciela",
"pub.itemsReturnedOwners": "przedmioty zwrócone właścicielom",
"pub.itsMine": "To moje",
"pub.joinFindoDesc": "Dołącz do Findloop i zarządzaj swoimi znalezionymi przedmiotami z łatwością.",
"pub.joinInvitesYou": "zaprasza cię do dołączenia do findloop. Stwórz swoje konto partnera, aby zarządzać swoimi znalezionymi przedmiotami.",
"pub.linkCopied": "Link skopiowany!",
"pub.loadingContract": "Ładowanie umowy…",
"pub.lsClaimDesc": "Zgłoś swoją utratę, aby ją odzyskać. Podaj swój e-mail, a my wyślemy ci przypomnienie, jeśli twoje zgłoszenie nie zostanie ukończone.",
"pub.lsHeroDesc": "Sprawdź sam, czy twój zgubiony przedmiot został znaleziony i pozostawiony tutaj. Znalazłeś? Zgłoś, aby go odzyskać.",
"pub.lsSearchTitle": "Szukaj znalezionych przedmiotów",
"pub.makeOffer": "Złóż ofertę",
"pub.makeOfferDesc": "Proponuj swoją kwotę. Superadmin ją rozpatrzy.",
"pub.mapNearYou": "Przedmioty i partnerzy w twojej okolicy",
"pub.mapWord": "Mapa",
"pub.messageSentToast": "Wiadomość wysłana — nasz zespół wkrótce odpowie.",
"pub.messageWord": "Wiadomość",
"pub.momoInitiated": "Inicjowanie płatności Mobile Money",
"pub.monthsWord": "miesiące",
"pub.nameConsentRequired": "Imię i zgoda wymagane.",
"pub.newDeadline": "Nowy termin",
"pub.noActionRequired": "Brak wymagań akcji.",
"pub.noAmountCharged": "Nie pobrano żadnej kwoty.",
"pub.noItemMatch": "Brak dostępnych przedmiotów pasujących do Twojego wyszukiwania w tej chwili.",
"pub.noMatchingItem": "Brak pasującego przedmiotu",
"pub.noPaymentSession": "Brak sesji płatności.",
"pub.noPhoto": "Brak zdjęcia",
"pub.noPointsYet": "Brak punktów do wyświetlenia.",
"pub.noSecondPayment": "Brak drugiej płatności wymaganej za ten przedmiot.",
"pub.notHereYet": "Jeszcze nie ma? Powiadomimy Cię, gdy tylko przyjedzie.",
"pub.notifyDone": "Zauważono! Powiadomimy Cię e-mailem, gdy tylko pojawi się pasujący przedmiot.",
"pub.offerSubmitted": "Twoja oferta została złożona.",
"pub.oops": "Ups",
"pub.orAlertEmail": "Lub otrzymaj powiadomienie e-mailem, gdy tylko pojawi się pasujący przedmiot:",
"pub.ownerContacts": "Dane kontaktowe właściciela",
"pub.ownerContactsUnlocked": "Dane kontaktowe właściciela odblokowane",
"pub.partnerContact": "Kontakt z partnerem",
"pub.payLinkUnavailable": "Link do płatności niedostępny — skontaktuj się z partnerem.",
"pub.paymentCancelled": "Płatność anulowana",
"pub.paymentConfirmed": "Płatność potwierdzona 🎉",
"pub.paymentConfirmedDesc": "Otrzymasz e-mail z danymi do odzyskania swojego przedmiotu.",
"pub.paymentNotConfirmed": "Płatność niepotwierdzona",
"pub.paymentNotConfirmedDesc": "Płatność nie mogła zostać zweryfikowana. Spróbuj ponownie lub skontaktuj się z partnerem.",
"pub.paymentProcessing": "Płatność jest przetwarzana. Odśwież za chwilę.",
"pub.photoAdded": "✓ Zdjęcie dodane",
"pub.photoRequired": "Zdjęcie przedmiotu jest wymagane.",
"pub.previewAlt": "podgląd",
"pub.publish": "Opublikuj",
"pub.publishingWord": "Publikowanie…",
"pub.qty": "Ilość",
"pub.quoteDeclined": "Oferta odrzucona.",
"pub.quoteNotFound": "Oferta nie znaleziona lub wygasła.",
"pub.reasonLabel": "Powód",
"pub.recoveryAlreadyPaid": "Opłata za odzyskanie już opłacona",
"pub.referralCode": "Kod polecający:",
"pub.relationshipPlaceholder": "Syn, małżonek, notariusz…",
"pub.renewYourContract": "Odnów swoją umowę",
"pub.renewalFailed": "Nie udało się odnowić. Spróbuj ponownie później.",
"pub.renewing": "Odnawianie…",
"pub.replySoon": "Nasz zespół odpowie jak najszybciej.",
"pub.requestGone": "Ta prośba już nie istnieje.",
"pub.requestHandled": "Prośba już obsłużona",
"pub.requestNotFound": "Prośba nie znaleziona lub wygasła.",
"pub.requestUnavailable": "Prośba niedostępna",
"pub.required": "(wymagane)",
"pub.retroClosing": "Razem sprawiamy, że świat jest trochę mniej zagubiony.",
"pub.retroClosing2": "Razem sprawiamy, że świat jest trochę mniej zagubiony.",
"pub.retroScroll": "Rok odzyskiwania tego, co ważne. Przewiń w dół ↓",
"pub.revokeAnytime": "Możesz cofnąć w każdej chwili, kontaktując się z nami",
"pub.scene": "Scena",
"pub.sendImpossible": "Nie można wysłać",
"pub.sendMessage": "Wyślij wiadomość",
"pub.sending": "Wysyłanie…",
"pub.sharePreview": "Udostępnij podgląd",
"pub.shareYourAd": "Udostępnij swoją reklamę",
"pub.signedSuccess": "Podpisano pomyślnie!",
"pub.signerFullName": "Pełne imię i nazwisko osoby podpisującej",
"pub.spreadNetwork": "Podziel się tym z osobami w Twoim otoczeniu, aby zwiększyć swoje szanse.",
"pub.spreadOwner": "Podziel się tym, aby pomóc właścicielowi odzyskać swoje rzeczy.",
"pub.statusLabel": "Status:",
"pub.subject": "Temat",
"pub.thanksSent": "Dziękujemy, Twoja wiadomość została wysłana.",
"pub.thisYear": "Ten rok",
"pub.validate": "Zatwierdź",
"pub.verifyingPayment": "Weryfikacja płatności...",
"pub.verifyingYourPayment": "Weryfikacja Twojej płatności...",
"pub.viewAd": "Zobacz ogłoszenie →",
"pub.viewPartner": "Zobacz partnera →",
"pub.yourAdPreview": "Podgląd Twojego ogłoszenia",
"pub.yourEmail": "Twój e-mail",
"pub.yourEmailRecommended": "Twój e-mail (zalecany)",
"pub.yourEmailShort": "Twój e-mail",
"pub.yourName": "Twoje imię",
"pub.yourRelationship": "Twoje powiązanie z osobą",
"qv.acceptAndSign": "Zaakceptuj i podpisz moją ofertę",
"qv.certifyAuthorized": "Potwierdzam, że mam prawo podpisać i akceptuję warunki tego {what} (wartość wiążąca).",
"qv.clear": "Wyczyść",
"qv.client": "Klient",
"qv.conditions": "Warunki",
"qv.confirmDecline": "Potwierdzić odmowę tej oferty?",
"qv.countersignedFindo": "Potwierdzone przez Findloop · {name} w dniu {date}",
"qv.decline": "Odmów",
"qv.description": "Opis",
"qv.downloadPdf": "Pobierz PDF",
"qv.handwrittenSignature": "Podpis własnoręczny",
"qv.inclTax": "W tym podatek",
"qv.invalidAmount": "Nieprawidłowa kwota.",
"qv.invoice": "Faktura",
"qv.invoicePaid": "Faktura zapłacona",
"qv.issuer": "Wystawca",
"qv.messageOptional": "Wiadomość (opcjonalnie)",
"qv.negotiatedAmount": "Uzgodniona kwota",
"qv.payInvoiceOnline": "Zapłać fakturę online",
"qv.quote": "Oferta",
"qv.quoteValidDays": "Oferta ważna przez {n} dni.",
"qv.sendMyOffer": "Wyślij moją ofertę",
"qv.signContract": "Podpisz moją umowę",
"qv.signNow": "Podpisz teraz",
"qv.signatureAlt": "Podpis",
"qv.signedByOn": "✔ Podpisane przez {name} w dniu {date}",
"qv.stContractSigned": "Umowa podpisana. Dziękujemy!",
"qv.stCounterAccepted": "Twoja oferta została zaakceptowana! Podpisz swoją umowę poniżej.",
"qv.stCounterRefused": "Twoja oferta nie mogła zostać zaakceptowana.",
"qv.stCountered": "Twoja oferta została złożona. Oczekiwanie na odpowiedź findloop.",
"qv.stDeclined": "Odmówiłeś tę ofertę.",
"qv.stSigned": "Oferta zaakceptowana i podpisana. Dziękujemy!",
"qv.totalHt": "Łącznie bez VAT",
"qv.totalTtc": "Łącznie z VAT",
"qv.unitHt": "Jednostka bez VAT",
"qv.vat": "VAT",
"qv.yourProposedAmount": "Twoja proponowana kwota ({cur})",
"reg.add": "Zaloguj przedmiot",
"reg.allBrands": "Wszystkie marki",
"reg.allColors": "Wszystkie kolory",
"reg.allLocations": "Wszystkie lokalizacje",
"reg.detailDesc": "Szczegóły i działania dla tego znalezionego przedmiotu.",
"reg.dispAuction": "Aukcja",
"reg.dispAuthorities": "Przekazane władzom",
"reg.dispDestroyed": "Zniszczone",
"reg.dispDonate": "Darowizna na cele charytatywne",
"reg.dispositionHint": "Zarejestruj przedmiot opuszczający magazyn. Liczone w statystykach według kategorii.",
"reg.emptyCta": "Zaloguj przedmiot",
"reg.emptyDesc": "Zacznij od zalogowania swojego pierwszego znalezionego przedmiotu.",
"reg.emptyTitle": "Brak znalezionych przedmiotów",
"reg.establishmentFallback": "instytucja",
"reg.lblAuctioned": "wystawiony na aukcję",
"reg.lblAuctionedShort": "aukcjonowany",
"reg.lblAuthorities": "przekazany władzom",
"reg.lblDestroyed": "zniszczony",
"reg.lblDonated": "przekazany na cele charytatywne",
"reg.legalCount": "{n} przedmiot(y): osiągnięto okres przechowywania prawnego",
"reg.legalHint": "Możesz wystawić je na aukcję, przekazać na cele charytatywne lub zgłosić przekazanie władzom.",
"reg.legalLimitCountry": "Termin: {date} · zastosowany kraj: {country}",
"reg.legalOver": "Termin minął: {date} · {country}",
"reg.legalReached": "Osiągnięto okres prawny",
"reg.legalReachedFull": "Osiągnięto okres przechowywania prawnego",
"reg.limitShort": "termin",
"reg.location": "Lokalizacja",
"reg.markRestituted": "Oznacz jako zwrócony",
"reg.markedAs": "Przedmiot oznaczony jako {label}",
"reg.moveHistory": "Historia ruchu",
"reg.overBy": "przekroczony o {n}d",
"reg.physicalLocation": "Fizyczna lokalizacja",
"reg.popupBlocked": "Zezwól na okna pop-up, aby wydrukować etykiety.",
"reg.popupBlockedOne": "Zezwól na okna pop-up, aby wydrukować etykietę.",
"reg.printLabel": "Drukuj etykietę",
"reg.printN": "Drukuj {n} etykiet(y)",
"reg.qrCodeItem": "Kod QR przedmiotu",
"reg.qrLabelTitle": "Etykieta QR",
"reg.qrLabelsTitle": "Etykiety QR",
"reg.qrNotFound": "Nie znaleziono przedmiotu dla tego kodu QR.",
"reg.qrScanHint": "Skanuj, aby otworzyć ten zapis bezpośrednio i znaleźć lokalizację.",
"reg.recoveryFee": "Opłata za odzyskanie (€)",
"reg.searchPh": "Szukaj według opisu…",
"reg.selectQr": "Wybierz, aby wydrukować etykiety QR",
"reg.selectedN": "{n} wybranych",
"reg.shipPricePh": "Cena wysyłki (€)",
"reg.shippingPossible": "Wysyłka dostępna",
"reg.storagePh": "np. Półka A3, Szafka 12",
"reg.tAuction": "Aukcja na Findloop",
"reg.tAuthorities": "Zgłoś przekazanie władzom",
"reg.tDonate": "Przekaż na cele charytatywne",
"reg.toastFee": "Opłata zaktualizowana",
"reg.toastLocation": "Lokalizacja zapisana",
"reg.toastRestituted": "Przedmiot oznaczony jako zwrócony",
"reg.toastShipping": "Opcja wysyłki zaktualizowana",
"reg.toastTransferred": "Przedmiot przeniesiony do “{name}”",
"reg.unclaimedDisposition": "Nieodebrany przedmiot — ostateczna dyspozycja",
"res.codeValidated": "Kod zweryfikowany",
"res.empty": "Brak zarejestrowanej restitucji.",
"res.error": "Błąd {status}",
"res.proofPdf": "PDF potwierdzający",
"res.signed": "Podpisane",
"res.stRestituted": "Przekazany osobiście",
"res.stShipped": "Zwrócony przez wysyłkę",
"res.subtitle": "Wszystkie zakończone przekazania, z pobieralnym podpisanym dowodem.",
"res.title": "Historia restitucji",
"rev.restitutedBy": "Zwrócony przez {org}",
"rev.storiesEyebrow": "Szczęśliwe zakończenia",
"rev.storiesSubtitle": "Prawdziwe historie klientów, którzy odzyskali swoje rzeczy dzięki findloop.",
"rev.storiesTitle": "Odnaleźli swoje rzeczy!",
"rp.already": "Już zgłosiłeś tę ofertę.",
"rp.duplicate": "Duplikat",
"rp.inappropriate": "Treść nieodpowiednia",
"rp.wrongCategory": "Zła kategoria",
"rt.annualGoal": "Cel roczny",
"rt.championCity": "Miasto mistrzów",
"rt.cityRate": "{rate}% wskaźnik zwrotu",
"rt.goalProgress": "{rate}% osiągnięto z celu {target}%",
"rt.reached": "Osiągnięto 🎉",
"rt.restitutionRate": "Wskaźnik zwrotu",
"rt.shareRecap": "Udostępnij moje podsumowanie",
"rt.thanks": "Dziękuję Findloop {year} 💛",
"rt.yourRecap": "Twoje podsumowanie {year}",
"rw.active": "Aktywny",
"rw.add": "Dodaj",
"rw.camUnavailable": "Kamera niedostępna. Wprowadź kod ręcznie poniżej.",
"rw.codeValidated": "Kod zatwierdzony",
"rw.codesTitle": "Kody zrealizowane przez finderów",
"rw.confirmDelete": "Usunąć „{title}”?",
"rw.deleted": "Usunięto",
"rw.edit": "Edytuj",
"rw.editReward": "Edytuj nagrodę",
"rw.empty": "Brak nagrody.",
"rw.expired": "Wygasło",
"rw.expiresOn": "Wygasa w {date}",
"rw.fActive": "Aktywny (widoczny dla finderów)",
"rw.fCost": "Koszt (punkty)",
"rw.fDesc": "Opis",
"rw.fStock": "Stan (pusty = nieograniczony)",
"rw.fTitle": "Tytuł",
"rw.fValidity": "Ważność bonu (dni po zrealizowaniu)",
"rw.inactive": "Nieaktywny",
"rw.newReward": "Nowa nagroda",
"rw.noExchange": "Brak realizacji.",
"rw.pageSubtitle": "Skanuj bony przedstawione przez finderów, aby zatwierdzić ich nagrody.",
"rw.redeemedN": "Zrealizowane: {n}×",
"rw.saved": "Nagroda zapisana",
"rw.scanVoucher": "Skanuj bon",
"rw.staffScanOnly": "Skanuj tylko",
"rw.statActive": "Do zaprezentowania",
"rw.statExpired": "Wygasło",
"rw.statRedeemed": "Bony zrealizowane",
"rw.statUsed": "Zatwierdzone",
"rw.stock": "Stan",
"rw.subtitle": "Oferuj niena pieniężne korzyści (bony, ulepszenia…), które findery wymieniają na punkty Finder Score.",
"rw.title": "Nagrody dla finderów",
"rw.used": "Użyte",
"rw.validate": "Zatwierdź",
"rw.validateCode": "Zatwierdź kod",
"rw.validity": "Ważność: {n} d",
"side.establishments": "Punkty",
"side.restitutions": "Zwroty",
"side.rewards": "Nagrody i Bony",
"side.settings": "Ustawienia",
"side.storage": "Przechowywanie i QR",
"status.auctioned": "Zaproponowane na aukcję",
"status.destroyed": "Zniszczone",
"status.donated": "Darowane (charytatywnie)",
"status.handed_to_authorities": "Przekazane władzom",
"status.in_storage": "W magazynie",
"status.matched": "Dopasowane",
"status.open": "Otwarte",
"status.paid": "Zapłacone",
"status.pending": "Oczekujące",
"status.restituted": "Zwrócone",
"status.shipped": "Wysłane",
"status.shipping_requested": "Zamówiono wysyłkę",
"status.submitted": "Przesłane",
"stg.allLabels": "Wszystkie etykiety QR",
"stg.camHint": "Użyj ręcznego wpisania poniżej.",
"stg.camStarting": "Uruchamianie kamery…",
"stg.camUnavailable": "Kamera niedostępna.",
"stg.clear": "Wyczyść",
"stg.clearAll": "Wyczyść wszystko",
"stg.codeUnreadable": "Nieczytelny kod.",
"stg.emptyDesc": "Przechowywane przedmioty pojawią się tutaj, pogrupowane według lokalizacji.",
"stg.emptyTitle": "Brak przedmiotu w magazynie",
"stg.exportAudit": "Eksportuj audyt CSV",
"stg.exportDone": "Eksport CSV pobrany",
"stg.exportImpossible": "Eksport niedostępny w tej chwili.",
"stg.itemFound": "Przedmiot znaleziony ✅",
"stg.kLocations": "Używane lokalizacje",
"stg.kObjects": "Przechowywane przedmioty",
"stg.kToClear": "Lokalizacje do usunięcia",
"stg.locFreed": "Lokalizacja usunięta",
"stg.locsFreed": "{n} lokalizacja(e) usunięta(e)",
"stg.manualLabel": "Lub wpisz kod / ID przedmiotu",
"stg.manualPh": "Wklej ID lub URL QR",
"stg.noItemMatch": "Brak przedmiotu odpowiadającego temu QR / kodowi.",
"stg.noLocation": "Brak lokalizacji",
"stg.objectsAxis": "Przedmioty",
"stg.objectsN": "{n} przedmiot(y)",
"stg.occAvg": "średnio {n} przedmiotów/lokalizacja",
"stg.occHint": "Lokalizacje w kolorze bursztynowym przekraczają średnią (potencjalnie przeciążone).",
"stg.occupancy": "Zajętość lokalizacji",
"stg.openPage": "Otwórz stronę",
"stg.posterPdf": "Plakat PDF (A4)",
"stg.printAll": "Drukuj wszystko",
"stg.printGroupTitle": "Drukuj etykiety dla tej półki",
"stg.qrAlt": "Samodzielne usługi QR",
"stg.qrDownload": "Pobierz QR",
"stg.qrHint": "Wyświetl ten QR w punkcie obsługi: twoi klienci skanują go, aby sprawdzić, czy ich przedmiot jest dostępny.",
"stg.qrTitle": "QR do samodzielnej obsługi klienta",
"stg.scanDesc": "Skanuj etykietę przedmiotu, aby natychmiast otworzyć jego dane.",
"stg.scanQr": "Skanuj QR",
"stg.scanTitle": "Skanuj kod QR",
"stg.search": "Szukaj",
"stg.shelf": "Półka {loc}",
"stg.shelfPlan": "Plan półki",
"stg.staleHint": "Usuwaj te lokalizacje, aby utrzymać fizyczny stan magazynu na bieżąco.",
"stg.staleTitle": "{n} przedmiot(y) opuściły magazyn, ale nadal zajmują lokalizację",
"stg.subtitle": "Plan półki, skaner QR i śledzenie fizycznego stanu magazynu.",
"stg.title": "Magazyn & QR",
"stt.acceptRate": "Wskaźnik akceptacji",
"stt.accepted": "Zaakceptowane",
"stt.activity30": "Aktywność (ostatnie 30 dni)",
"stt.ai6mo": "Ostatnie 6 miesięcy · zaakceptowane = automatycznie dopasowane + potwierdzone.",
"stt.aiEmpty": "Brak dopasowań AI w tym okresie.",
"stt.aiTitle": "Dopasowania AI — zaakceptowane vs odrzucone",
"stt.auctionShort": "Aukcja",
"stt.auctionedSold": "Aukcjonowane (sprzedane)",
"stt.authShort": "Władze",
"stt.authorities": "Przekazane władzom",
"stt.avgRating": "Średnia ocena",
"stt.awaitingRestitution": "przedmioty oczekujące na zwrot",
"stt.boostClicks": "Kliknięcia w twoją wizytówkę w tym tygodniu dzięki boost",
"stt.boostInactive": "Boost nieaktywny — włącz go, aby zyskać widoczność",
"stt.certifiedPremium": "Premium certyfikowany",
"stt.declarations": "Deklaracje",
"stt.destroyed": "Zniszczone",
"stt.dispoEmpty": "Nie ma nieodebranych przedmiotów, które opuściły magazyn.",
"stt.donatedAssoc": "Darowizna (charytatywna)",
"stt.donatedShort": "Darowane",
"stt.gateCta": "Odkryj plany",
"stt.gateDesc": "Zaktualizuj do Starter, aby odblokować swoje podstawowe statystyki, lub do Business, aby uzyskać zaawansowane statystyki i analizę dla każdego lokalu.",
"stt.gateTitle": "Statystyki zarezerwowane dla płatnych planów",
"stt.inStorage": "W magazynie",
"stt.kItems": "Zarejestrowane przedmioty",
"stt.kRate": "Wskaźnik zwrotów",
"stt.kRestituted": "Zwroty",
"stt.kRevenue": "Przychód (miesiąc)",
"stt.noDeclYet": "Brak deklaracji.",
"stt.recapDownloaded": "Podsumowanie pobrane — gotowe do udostępnienia!",
"stt.recapError": "Nie można wygenerować podsumowania",
"stt.recapText": "Nasze podsumowanie Findloop {year}: przedmioty zwrócone i satysfakcja klientów 🎉",
"stt.recapTitle": "Podsumowanie Findloop {year}",
"stt.rejected": "Odrzucone",
"stt.restitutions": "Zwroty",
"stt.shareRecap": "Udostępnij moje podsumowanie {year}",
"stt.topCategories": "Najczęściej deklarowane kategorie",
"stt.unclaimedDesc": "Ilość przedmiotów zniszczonych, darowanych organizacjom charytatywnym i wystawionych na aukcji, według kategorii.",
"stt.unclaimedTitle": "Nieodebrane przedmioty — opuszczenie magazynu",
"stt.vsLastWeek": "w porównaniu do zeszłego tygodnia",
"sub.cancel": "Anuluj moją subskrypcję",
"sub.cancelAbort": "Anuluj",
"sub.cancelConfirm1": "Czy na pewno chcesz anulować? Twój dostęp pozostaje aktywny do",
"sub.cancelConfirm2": "Nie zostanie wydany żaden zwrot.",
"sub.cancelConfirmBtn": "Potwierdź anulowanie",
"sub.cancelTitle": "Anuluj swoją subskrypcję",
"sub.cancelledToast": "Anulowanie zapisane.",
"sub.cguAnd": "i",
"sub.cguDesc": "Proszę potwierdź swoją zgodę przed płatnością.",
"sub.cguLink": "Warunki użytkowania",
"sub.cguPay": "Przejdź do płatności",
"sub.cguPre": "Przeczytałem i akceptuję",
"sub.cguRequired": "Musisz zaakceptować Warunki użytkowania i Politykę prywatności, aby kontynuować.",
"sub.cguSuffix": "Findloop.",
"sub.cguTitle": "Zakończ swoją subskrypcję",
"sub.expiresOn": "Twoja subskrypcja wygasa",
"sub.noProrata": "Brak zwrotu proporcjonalnego.",
"sub.privacyLink": "Polityka prywatności",
"sub.renewsOn": "Twoja subskrypcja odnawia się",
"sub.resume": "Wznów subskrypcję",
"sub.resumedToast": "Wznawianie subskrypcji potwierdzone.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Business",
"tier.small": "Starter",
"tm.add": "Dodaj",
"tm.adminOpt": "Administrator (pełny widok)",
"tm.chooseEst": "Wybierz lokal",
"tm.chooseEstPh": "Wybierz lokal",
"tm.copyFail": "Kopiowanie nie powiodło się",
"tm.copyLink": "Skopiuj link",
"tm.copyOk": "Link zaproszenia skopiowany",
"tm.emailHint": "E-mail z zaproszeniem zostanie wysłany w celu utworzenia hasła.",
"tm.expiresOn": "wygasa {date}",
"tm.forEmail": " dla {email}",
"tm.forbidden": "Zarządzanie zespołem jest zarezerwowane dla właściciela konta.",
"tm.inviteCreated": "Zaproszenie utworzone",
"tm.inviteDesc": "E-mail z zaproszeniem pozwala członkowi zespołu utworzyć swoje hasło.",
"tm.invitePending": "Zaproszenie w toku",
"tm.inviteResent": "Zaproszenie ponownie wysłane",
"tm.inviteSent": "Zaproszenie wysłane e-mailem",
"tm.inviteTitle": "Zaproś członka",
"tm.invitedOn": "Zaproszony {date}",
"tm.linkExpired": "Link wygasł",
"tm.memberRemoved": "Członek usunięty",
"tm.name": "Imię",
"tm.noMembers": "Brak członków zespołu.",
"tm.resendTitle": "Wyślij ponownie zaproszenie",
"tm.role": "Rola",
"tm.roleAdmin": "Administrator",
"tm.roleOwner": "Właściciel",
"tm.roleStaff": "Pracownik",
"tm.roleUpdated": "Rola zaktualizowana",
"tm.sendInvite": "Wyślij zaproszenie",
"tm.sending": "Wysyłanie…",
"tm.staffOpt": "Pracownik (widzi tylko swoją lokalizację)",
"trk.carrier": "Przewoźnik",
"trk.shipPending": "Zamówienie w trakcie przygotowania — numer śledzenia pojawi się tutaj po wysłaniu.",
"trk.shipTitle": "Śledzenie przesyłki",
"trk.trackShipment": "Śledź paczkę",
"trk.trackingNo": "Numer śledzenia",
"a.firstName": "Imię",
"ac.emailCrossMatch": "B2C dopasowania",
"ac.emailCrossMatchDesc": "Email, gdy publiczne ogłoszenie o zgubionym przedmiocie pasuje do przedmiotu złożonego w Twoich pomieszczeniach",
"ac.emailCrossReject": "Odrzucenia dopasowań publicznych",
"ac.emailCrossRejectDesc": "Otrzymaj email, gdy klient zaznaczy, że zaproponowane dopasowanie publiczne nie dotyczy jego przedmiotu.",
"ac.emailLoginNotif": "Powiadomienie o logowaniu",
"ac.emailLoginNotifDesc": "Otrzymuj email za każdym razem, gdy ktoś loguje się do Twojego konta.",
"ad.closeNoCancel": "Nie, usuń ogłoszenie",
"ad.closeQuestion": "Czy przedmiot został do Ciebie zwrócony?",
"ad.closeQuestionDesc": "Powiedz nam, czy odzyskałeś swój przedmiot, czy po prostu chcesz usunąć to ogłoszenie.",
"ad.closeYesRestituted": "Tak, przedmiot został zwrócony",
"ad.closedRestituted": "Przedmiot zwrócony — ogłoszenie zamknięte 🎉",
"an.lostLoginDesc": "Konto jest wymagane do zgłaszania zgubionego przedmiotu i śledzenia jego zwrotu.",
"an.lostLoginRequired": "Zaloguj się, aby zgłosić zgubiony przedmiot",
"an.qfAll": "Wszystkie",
"an.qfBoosted": "Wzmocnione",
"an.qfPhoto": "Zdjęcie",
"an.qfRecent": "W tym tygodniu",
"an.qfResolved": "Rozwiązane",
"an.restitutionInProgress": "Przedmiot w drodze zwrotu",
"dec.descPhLong": "Opisz przedmiot: marka, kolor, charakterystyczne cechy… (Im więcej szczegółów podasz, tym większe szanse na odzyskanie przedmiotu)",
"dec.loadError": "Nie można teraz załadować partnera. Sprawdź swoje połączenie i spróbuj ponownie.",
"dec.retry": "Spróbuj ponownie",
"dec.shippingMode": "Wysyłka",
"dep.photo2": "2. zdjęcie przedmiotu",
"dep.photo2Hint": "Opcjonalne — inny kąt poprawia dokładność wizualnego dopasowania.",
"dl.accountSuspended": "Konto zawieszone z powodu nieopłaconej faktury. Ureguluj to, aby przywrócić dostęp.",
"dl.regularize": "Ureguluj teraz →",
"dl.suspensionCountdown": "Faktura {num} nieopłacona — Twoje konto zostanie zawieszone za {days} dzień(dni). Ureguluj to, aby tego uniknąć.",
"ft.cancelConfirm": "Anulować zgłoszenie? Właściciel przedmiotu zostanie poinformowany.",
"ft.cancelDone": "Zgłoszenie anulowane.",
"ft.cancelLocked": "Anulowanie nie jest już możliwe po zapłacie przez właściciela.",
"ft.cancelReport": "Anuluj moje zgłoszenie",
"ft.claimCodeHelp": "Podaj ten kod osobie, która znalazła, przy przekazaniu, aby potwierdzić, że odebrałeś swój przedmiot.",
"ft.claimCodeTitle": "Twój kod zwrotu",
"ft.claimDone": "Przedmiot zwrócony. Dziękujemy za skorzystanie z Findloop!",
"ft.claimUnlockHint": "Odblokuj dane kontaktowe znalazcy",
"ft.claimUnlockHintSub": "Przejdź do \"Przedmioty, które zgłaszam\" w swoim koncie, aby uiścić opłatę i uzyskać dane kontaktowe.",
"ft.finderCodeShownHelp": "Właściciel zapłacił i wybrał Ciebie. Skopiuj ten kod poniżej, aby potwierdzić zwrot — nie musisz sprawdzać swojego emaila.",
"ft.finderCodeShownTitle": "Kod walidacji właściciela",
"ft.finderContactsTitle": "Szczegóły kontaktowe findera",
"ft.foundCodeHelp": "Pokaż ten kod właścicielowi przy przekazaniu, aby potwierdzić, że przedmiot został zwrócony.",
"ft.inProgressOther": "Przedmiot w trakcie zwrotu",
"ft.inProgressOtherHelp": "Właściciel wybrał innego findera dla tego przedmiotu. Nie są potrzebne dalsze działania z Twojej strony.",
"ft.restitutionCodeHelp": "Ten kod potwierdza przekazanie przedmiotu. Jest już wypełniony poniżej; zweryfikuj go, a następnie zamknij sprawę.",
"ft.restitutionCodeTitle": "Twój kod zwrotu",
"hc.14Digits": "14 cyfr",
"hc.15DaysBeforeAnItem": "15 dni przed ustawowym terminem przedmiotu.",
"hc.7DaysBeforeAnItem": "7 dni przed ustawowym terminem przedmiotu.",
"hc.8CharactersMinimum": "Minimum 8 znaków.",
"hc.aClaimToValidate": "Roszczenie do zweryfikowania",
"hc.aFindoAssistanceSessionIs": "Aktualnie aktywna sesja pomocy Findloop na Twoim koncie.",
"hc.aNewMatchHasBeen": "Znaleziono nowe dopasowanie",
"hc.aUser": "Użytkownik",
"hc.aUserClaimsToBe": "Użytkownik twierdzi, że jest właścicielem. Sprawdź jego odpowiedzi przed autoryzacją zwrotu.",
"hc.aboutFindo": "O Findloop",
"hc.accountActivatedPleaseLogIn": "Konto aktywowane, zaloguj się proszę.",
"hc.accountActivation": "Aktywacja konta",
"hc.accountCreated": "Konto utworzone!",
"hc.accountDeactivatedAReactivationEmail": "Konto deaktywowane. Wysłano do Ciebie e-mail z linkiem do reaktywacji (ważny przez 30 dni).",
"hc.accountReactivation": "Reaktywacja konta",
"hc.activateMyAccount": "Aktywuj moje konto",
"hc.activateMyAdminAccount": "Aktywuj moje konto administratora",
"hc.activating": "Aktywowanie…",
"hc.activeMatchCancelReason": "Aktywne dopasowanie. Powód anulowania klienta: \"{reason}\". Przedmiot nadal oczekuje na roszczenie.",
"hc.activeMatchWithAPublic": "Aktywne dopasowanie z publiczną (klient) ofertą. Oczekiwanie na roszczenie właściciela.",
"hc.addAPhoto": "Dodaj zdjęcie",
"hc.addAndConfigureYourEstablishments": "Dodaj i skonfiguruj swoje placówki w \"Placówki\": dane kontaktowe, kategoria i fizyczne przechowywanie przedmiotów.",
"hc.addOnGoogle": "Dodaj w Google",
"hc.address": "Adres",
"hc.addressSaved": "Adres zapisany",
"hc.addressStreet": "Adres — Ulica",
"hc.adjustThePhoto": "Dostosuj zdjęcie",
"hc.adminFullView": "Admin (pełny widok)",
"hc.administratorOnly": "Tylko administrator",
"hc.africa": "Afryka",
"hc.aiVisualComparison": "AI wizualne porównanie",
"hc.all": "Wszystko",
"hc.amount": "Kwota",
"hc.anOrganization": "Organizacja",
"hc.analyzing": "Analizowanie…",
"hc.andRecoveryIs": "i odzyskiwanie to",
"hc.andTheDeclarationWillBe": "a deklaracja zostanie zamknięta (przeniesiona do historii). Ta czynność jest ostateczna.",
"hc.annual20": "Roczne -20%",
"hc.annualBilling20": "Roczne fakturowanie (−20%)",
"hc.annualTarget": "Cel roczny",
"hc.anyCommentsOptional": "Jakieś komentarze? (opcjonalnie)",
"hc.approveTheClaim": "Zatwierdź roszczenie",
"hc.archiveCancelledConfirm": "Archiwizować {n} ogłoszeń „Anulowane przez klienta”? Zostaną one usunięte z rejestru.",
"hc.asSoonAs": "Tak szybko jak",
"hc.askTheOwnerToDisplay": "Poproś właściciela o wyświetlenie kodu QR jego kodu (strona śledzenia).",
"hc.askThemAtTheCounter": "Zapytaj ich przy ladzie o potwierdzenie tożsamości — nigdy nie widoczne publicznie.",
"hc.assistance": "Wsparcie",
"hc.assistanceSessionRevoked": "Sesja wsparcia anulowana.",
"hc.atLeast6Characters": "Min. 6 znaków",
"hc.automaticallyPreSelected": "automatycznie wstępnie zaznaczone",
"hc.automaticallyWhenShipping": "automatycznie przy wysyłce.",
"hc.awaitingClaim": "Oczekiwanie na roszczenie",
"hc.awaitingPayment": "Oczekiwanie na płatność",
"hc.b2cCustomer": "Klient B2C",
"hc.back": "Powrót",
"hc.backToHome": "Powrót do strony głównej",
"hc.backToMyAccount": "Powrót do mojego konta",
"hc.backToPayment": "Powrót do płatności",
"hc.beforeAfterComparisonSlider": "Suwnica porównawcza przed/po",
"hc.billingInformation": "Informacje o fakturowaniu",
"hc.billingInformationSaved": "Informacje o fakturowaniu zapisane ✓",
"hc.brand": "Marka",
"hc.bronze": "Brązowy",
"hc.calculatingTheShippingRate": "Obliczanie kosztu wysyłki…",
"hc.cameraUnavailableEnterTheCode": "Kamera niedostępna. Wprowadź kod ręcznie.",
"hc.cancel": "Anuluj",
"hc.cancelMyDeclaration": "Anuluj moją deklarację",
"hc.cancelSavedFmt": "Anulowanie zapisane: „{reason}”. Wciąż możesz roszczyć.",
"hc.cancelTheDeposit": "Anuluj depozyt",
"hc.cancelThisMatch": "Anuluj to dopasowanie",
"hc.cancellationReason": "Powód anulowania",
"hc.cancelled": "Anulowane",
"hc.cancelledByTheCustomer": "Anulowane przez klienta",
"hc.cannotOpenPayment": "Nie można otworzyć płatności. Spróbuj ponownie.",
"hc.careers": "Kariera",
"hc.carrier": "Przewoźnik",
"hc.carrierAvailabilityCannotBeChecked": "Dostępność przewoźnika nie może być sprawdzona, dopóki Twój nadawca Sendcloud nie jest skonfigurowany.",
"hc.carrierConfirmedCharged": "Przewoźnik potwierdzony — {price} € pobrane od klienta",
"hc.carrierOther": "Przewoźnik (inny)",
"hc.carrierSelection": "Wybór przewoźnika",
"hc.caseClosedThankYou": "Sprawa zamknięta. Dziękujemy!",
"hc.category": "Kategoria",
"hc.changeMethod": "Zmień metodę",
"hc.characteristic": "Cecha",
"hc.chargedToCustomer": "pobrane od klienta.",
"hc.checkOrEditYourDetails": "Sprawdź lub edytuj swoje dane przed bezpieczną płatnością.",
"hc.checkStatisticsToTrackDeposited": "Sprawdź \"Statystyki\", aby śledzić wpłacone przedmioty, wskaźnik zwrotów i wyniki każdego zakładu.",
"hc.checkTheDetailsBeforeContacting": "Sprawdź szczegóły przed skontaktowaniem się z finderem.",
"hc.checkTheDetailsBelowBefore": "Sprawdź szczegóły poniżej przed rozpoczęciem żądania zwrotu.",
"hc.checkTheNewItem": "Sprawdź nowy przedmiot",
"hc.checkThePhotosAndCharacteristics": "Sprawdź zdjęcia i cechy poniżej przed przystąpieniem do odbioru.",
"hc.chooseACountry": "Wybierz kraj",
"hc.chooseANewPassword": "Wybierz nowe hasło",
"hc.chooseAReason": "Wybierz powód",
"hc.chooseTheLegalRetentionAlerts": "Wybierz alerty dotyczące obowiązkowego przechowywania, które będą wysyłane mailem dla",
"hc.chooseYourPasswordToAccess": "Wybierz swoje hasło, aby uzyskać dostęp do konsoli administracyjnej.",
"hc.city": "Miasto",
"hc.claimApproved": "Reklamacja zatwierdzona",
"hc.claimApproved2": "Reklamacja zatwierdzona.",
"hc.claimCodeExpired": "Kod reklamacji wygasł",
"hc.claimCodeVerified": "Kod reklamacji zweryfikowany",
"hc.claimNotFound": "Reklamacja nie znaleziona",
"hc.claimNotValidated": "Reklamacja niezatwierdzona",
"hc.claimRejected": "Reklamacja odrzucona",
"hc.claimRejected2": "Reklamacja odrzucona.",
"hc.claimValidated": "Reklamacja zatwierdzona",
"hc.claimValidatedByThePartner": "Reklamacja zatwierdzona przez partnera",
"hc.claimant": "Reklamujący",
"hc.claimsToBeTheOwner": "twierdzi, że jest właścicielem tego przedmiotu i odpowiedział na pytania weryfikacyjne. Zatwierdzaj tylko, jeśli odpowiedzi pasują.",
"hc.claimsToValidate": "Reklamacje do zatwierdzenia",
"hc.clear": "Wyczyść",
"hc.clickToZoom": "Kliknij, aby powiększyć",
"hc.close": "Zamknij",
"hc.close2": "Zamknij",
"hc.closeTheDeclaration": "Zamknij deklarację",
"hc.closeTheDeclaration2": "Zamknąć deklarację?",
"hc.codeAlreadyVerified": "Kod już zweryfikowany",
"hc.codeCopied": "Kod skopiowany",
"hc.collapse": "Zwiń",
"hc.color": "Kolor",
"hc.company": "Firma",
"hc.companyName": "Nazwa firmy",
"hc.comparePhotos": "Porównaj zdjęcia",
"hc.compareThemWithTheOwner": "Porównaj je z odpowiedziami właściciela — nigdy niepublicznymi.",
"hc.condition": "Stan",
"hc.confirmAndPay": "Potwierdź i zapłać",
"hc.confirmCancellation": "Potwierdź anulowanie",
"hc.confirmCrop": "Potwierdź przycięcie",
"hc.confirmDeletion": "Potwierdź usunięcie",
"hc.confirmPassword": "Potwierdź hasło",
"hc.confirmThatThisIsYour": "Potwierdź, że to jest twój przedmiot. Weryfikacja tożsamości będzie wymagana od znalazcy przed jakimkolwiek kontaktem.",
"hc.confirmTheCarrier": "Potwierdź przewoźnika",
"hc.confirmThePassword": "Potwierdź hasło",
"hc.confirmYourShippingAddressTo": "Potwierdź swój adres wysyłkowy, aby kontynuować płatność.",
"hc.confirmYourSubscription": "Potwierdź swoją subskrypcję",
"hc.confirmed": "Potwierdzone ✓",
"hc.contactFindoToGetYour": "Skontaktuj się z Findloop, aby uzyskać swój identyfikator nadawcy.",
"hc.contactUs": "Skontaktuj się z nami",
"hc.continueTheReturn": "Kontynuuj zwrot",
"hc.continueToPayment": "Kontynuuj do płatności",
"hc.copy": "Kopiuj",
"hc.correctMyDetails": "popraw moje dane",
"hc.correctThisEntry": "Poprawić ten wpis?",
"hc.country": "Kraj",
"hc.countryAddress": "Kraj (adres)",
"hc.countryIsoCodeEG": "Kraj (kod ISO, np. FR)",
"hc.cover": "okładka",
"hc.createTheShipment": "Utwórz przesyłkę",
"hc.cropThePhoto": "Przytnij zdjęcie",
"hc.customer": "Klient",
"hc.customerClaimCodeToCheck": "Kod zgłoszenia klienta — do sprawdzenia przy odbiorze:",
"hc.customerReasonFmt": "Powód klienta: \"{reason}\".",
"hc.customerReminderDelay": "Opóźnienie przypomnienia klienta",
"hc.customerWhosePublicListingMatches": "Klient, którego publiczna oferta odpowiada temu przedmiotowi — widoczne tylko dla ciebie.",
"hc.d15": "D-15",
"hc.dangerZone": "Strefa zagrożenia",
"hc.date": "Data",
"hc.dateNewest": "Data (najnowsza)",
"hc.dateOldest": "Data (najstarsza)",
"hc.daysToYearEnd": "{n} dni do końca roku",
"hc.deadlineAlert": "Powiadomienie o terminie",
"hc.declarationClosed": "Deklaracja zamknięta ✓",
"hc.declarationNotFound": "Deklaracja nie znaleziona.",
"hc.declarationNotFound2": "Deklaracja nie znaleziona",
"hc.declarationTracking": "Śledzenie deklaracji",
"hc.defaultCarrier": "Domyślny przewoźnik",
"hc.defaultCarrierPreselected": "Domyślny przewoźnik wstępnie wybrany — może być zmieniony dla tej przesyłki. Rzeczywista stawka (Sendcloud + {m}% marży).",
"hc.defaultCarrierRemoved": "Domyślny przewoźnik usunięty",
"hc.delayHours": "Opóźnienie (godziny)",
"hc.deleteMyAccount": "Usuń moje konto",
"hc.deleting": "Usuwanie…",
"hc.deletingDeactivatesYourAccountLogin": "Usuwanie dezaktywuje twoje konto: logowanie jest zablokowane, a dane przechowywane przez 30 dni. Otrzymasz e-mail z linkiem do reaktywacji ważnym przez 30 dni.",
"hc.delivered": "Dostarczono",
"hc.depositAnItem": "Wpłać przedmiot",
"hc.depositCancelledItemPutBack": "Wpłata anulowana — przedmiot zwrócony do magazynu.",
"hc.depositCancelledItemRemovedFrom": "Wpłata anulowana — przedmiot usunięty z rejestru.",
"hc.depositedOn": "Wpłacono w dniu",
"hc.describeTheItemBrandColor": "Opisz przedmiot: marka, kolor, cechy szczególne… (Im więcej szczegółów podasz, tym większe szanse na znalezienie przedmiotu)",
"hc.dimensionsCm": "Wymiary (cm)",
"hc.disablingAnEmail": "Dezaktywacja e-maila",
"hc.doesNotHide": "nie ukrywa",
"hc.download": "Pobierz",
"hc.downloadThePdf": "Pobierz PDF",
"hc.draftRestoredPickUpYour": "Szkic przywrócony — kontynuuj deklarację tam, gdzie przerwałeś.",
"hc.dragToReposition": "Przeciągnij, aby zmienić pozycję",
"hc.eGColisPriv": "Np. Colis Privé",
"hc.eachItemGetsAQr": "Każdy przedmiot otrzymuje etykietę QR. Zeskanuj ją z \"Magazyn & QR\", aby natychmiast zlokalizować przedmiot.",
"hc.eachSiteManagesItsOwn": "Każda strona zarządza swoją własną bankowością. Przejdź do",
"hc.edit": "Edytuj",
"hc.emailNotificationPreferences": "Preferencje powiadomień e-mail",
"hc.emailPreferencesUpdated": "Preferencje e-mail zaktualizowane",
"hc.enableOrDisableRecoveryFees": "Włącz lub wyłącz opłaty za odzyskiwanie dla",
"hc.enlargePhoto": "Powiększ zdjęcie",
"hc.enterTheCustomerSCode": "Wprowadź kod klienta",
"hc.estShipRate": "Szacowana stawka za wysyłkę (Sendcloud + {m}% marży):",
"hc.establishment": "Instytucja",
"hc.establishment2": "Instytucja:",
"hc.establishmentInItsSendcloudAccount": "instytucja w swoim koncie Sendcloud i podaje ID nadawcy",
"hc.establishmentSettings": "Ustawienia instytucji",
"hc.exCode": "np. ABCD2345",
"hc.exId": "np. 3f2a…",
"hc.exit": "Wyjście",
"hc.explainWhyThisItemIs": "Wyjaśnij, dlaczego ten przedmiot nie jest twój…",
"hc.externalPaymentLinks": "Zewnętrzne linki płatności",
"hc.failed": "Niepowodzenie",
"hc.feesEnabled": "Opłaty włączone",
"hc.field": ") pole.",
"hc.finderAcceptedCloseTheCase": "Finder zaakceptował — zamknij sprawę, gdy przedmiot zostanie przekazany osobiście.",
"hc.findoCityRanking": "Findloop — Ranking miast",
"hc.findoForEstablishments": "Findloop dla instytucji",
"hc.findoPresentationVideo": "film prezentacyjny Findloop",
"hc.findoRegistersTheAddressOf": "Findloop rejestruje adres twojego",
"hc.findoReviewShare": "Findloop {year} przegląd: {n} przedmiotów zwróconych, {rate}% wskaźnik zwrotów 🎉",
"hc.firstVerifyTheClaimCode": "Najpierw zweryfikuj kod roszczenia powyżej",
"hc.forEveryNewShipmentFrom": "za każdą nową wysyłkę z",
"hc.free": "darmowy",
"hc.freeRecovery0": "Darmowa regeneracja (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Darmowa regeneracja w całej Afryce – Oferta startowa",
"hc.freeRecoveryFeesDisabled0": "Darmowa regeneracja: opłaty wyłączone (0 €)",
"hc.fromTeamInviteYourColleagues": "Z \"Zespół\", zaproś swoich kolegów e-mailem i przypisz im instytucję. Każdy członek widzi tylko swój własny zakres.",
"hc.fullName": "Pełne imię i nazwisko",
"hc.fullPhoto": "Pełne zdjęcie",
"hc.gallery": "Galeria",
"hc.giveTheReasonForCancelling": "Podaj powód anulowania. Partner zostanie poinformowany.",
"hc.goToLogin": "Przejdź do logowania",
"hc.goToMyAccount": "Przejdź do mojego konta",
"hc.gold": "Złoto",
"hc.googleLoginFailed": "Logowanie przez Google nie powiodło się",
"hc.hasConfirmedYourPaymentYou": "potwierdził twoją płatność, zostaniesz automatycznie przekierowany",
"hc.helpCenter": "Centrum pomocy",
"hc.helpUsImproveWhyAre": "Pomóż nam się poprawić: dlaczego odchodzisz? Twoje konto zostanie dezaktywowane i może być reaktywowane przez 30 dni.",
"hc.hidePassword": "Ukryj hasło",
"hc.high": "Wysoki",
"hc.historyOfYourMonthlySubscriptions": "Historia twoich miesięcznych subskrypcji i ich status płatności.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Jak skonfigurować mój numerowy identyfikator nadawcy?",
"hc.iDonTUseIt": "Nie używam go wystarczająco często",
"hc.iFoundItElsewhere": "Znalazłem to gdzie indziej",
"hc.iNoLongerNeedMy": "Nie potrzebuję już mojej pozycji",
"hc.identityVerification": "Weryfikacja tożsamości",
"hc.idleLogoutIn": "Zostaniesz wylogowany za {n} s z powodu braku aktywności.",
"hc.ifProvidedTheVolumetricWeight": "Jeśli podano, używana jest waga objętościowa.",
"hc.ifThePartnerHasNot": "Jeśli partner nie potwierdził odbioru płatności zewnętrznej po tym czasie, Findloop automatycznie przypomina partnerowi o jej zatwierdzeniu.",
"hc.impersonationEnded": "Zakończono podszywanie się.",
"hc.impersonationMode": "Tryb podszywania się",
"hc.impersonationSessionExpired": "Sesja podszywania się wygasła.",
"hc.inTheField": ", w terenie",
"hc.inTransit": "W tranzycie",
"hc.inclVat": "w tym VAT",
"hc.intraEuVatNumberOptional": "Numer VAT wewnątrz UE opcjonalny, brak wymogu SIRET (poza Francją).",
"hc.invalidInvitationLink": "Nieprawidłowy link zaproszenia.",
"hc.invalidInvitationLink2": "Nieprawidłowy link zaproszenia",
"hc.invalidInviteLink": "Nieprawidłowy lub wygasły link zaproszenia.",
"hc.invalidNumberEnterAnInternational": "Nieprawidłowy numer. Wprowadź numer międzynarodowy, np. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Nieprawidłowy lub wygasły link.",
"hc.invalidOrExpiredReactivationLink": "Nieprawidłowy lub wygasły link reaktywacyjny",
"hc.invalidSendcloudId": "Nieprawidłowy identyfikator Sendcloud",
"hc.inviteSubtitle": "{org} zaprasza Cię do dołączenia do ich zespołu findloop. Wybierz swoje hasło, aby aktywować swoje konto.",
"hc.isAvailableOnSendcloudFor": "jest dostępne na Sendcloud dla wszystkich Twoich tras (krajowych + międzynarodowych).",
"hc.isNotEnabledOnYour": "nie jest włączone na Twoim koncie Sendcloud dla niektórych lokalizacji. Etykiety dla tych będą generowane z innym dostępnym przewoźnikiem.",
"hc.isThisReallyYourItem": "Czy to naprawdę twoja pozycja?",
"hc.isThisYourItem": "Czy to twoja pozycja?",
"hc.item": "Pozycja",
"hc.itemAlreadyConfirmed": "Pozycja już potwierdzona",
"hc.itemDetails": "S szczegóły pozycji",
"hc.itemFoundAt": "Pozycja znaleziona w",
"hc.itemFoundAtAPartner": "Pozycja znaleziona u partnera",
"hc.itemMarkedAsReturned": "Pozycja oznaczona jako zwrócona ✓",
"hc.itemPhotoRequiredBeforeShipping": "Zdjęcie pozycji (wymagane przed wysyłką)",
"hc.itemPhotoSaved": "Zdjęcie pozycji zapisane",
"hc.itemPreview": "Podgląd pozycji",
"hc.itemPutBackInStorage": "Pozycja z powrotem w magazynie.",
"hc.itemWeight": "Waga pozycji:",
"hc.itemsReturned": "przedmiot(y) zwrócone",
"hc.itemsReturnedThisYear": "przedmioty zwrócone w tym roku",
"hc.itemsWhoseLegalDeadlineIs": "Przedmioty, których termin prawny upływa za 15 dni lub mniej (w tym przeterminowane). Oferty pozostają widoczne.",
"hc.kbisNumber": "Numer Kbis",
"hc.keysForgottenOnABench": "Klucze zapomniane na ławce",
"hc.labelBeingGenerated": "Etykieta w trakcie generowania",
"hc.leaveTheFieldsEmptyTo": "Pozostaw pola puste, aby zaoferować odzyskanie za darmo.",
"hc.legalNotice": "Zawiadomienie prawne",
"hc.limitReachedUpgradeToA": "Osiągnięto limit — zaktualizuj do wyższego planu",
"hc.linkCopiedShareOn": "Link skopiowany — udostępnij na {label}",
"hc.linkUnavailable": "Link niedostępny",
"hc.linkedTo": "Połączony z",
"hc.listingHiddenByModeration": "Ogłoszenie ukryte przez moderację.",
"hc.loading": "Ładowanie…",
"hc.locateMe": "Zlokalizuj mnie",
"hc.logIn": "Zaloguj się",
"hc.logInToGetBack": "Zaloguj się, aby wrócić do swojej przestrzeni i zarządzać subskrypcją.",
"hc.loginFailed": "Logowanie nie powiodło się",
"hc.lostFoundPlatform": "Platforma zgubionych i znalezionych.",
"hc.lostIn": "zgubione w",
"hc.lowRate": "Niska stawka",
"hc.mainReason": "Główny powód",
"hc.mainStreet": "Główna ulica",
"hc.makeSureThisIsThe": "Upewnij się, że to jest przedmiot, który zgubiłeś, zanim odblokujesz dane kontaktowe znalazcy.",
"hc.manageCookies": "Zarządzaj plikami cookie",
"hc.manageMyTeam": "Zarządzaj moim zespołem",
"hc.manageYourTeam": "Zarządzaj swoim zespołem",
"hc.markAsReturned": "Oznacz jako zwrócone",
"hc.matchNoClaimInTime": "Dopasowanie nie otrzymało roszczenia w wyznaczonym terminie.",
"hc.matchNotFound": "Dopasowanie nie znalezione",
"hc.medium": "Średni",
"hc.milestoneFmt": "Osiągnięto kamień milowy {m} zwróconych przedmiotów! W drodze do {next}.",
"hc.missingFeatures": "Brakujące funkcje",
"hc.monthly": "Miesięcznie",
"hc.monthlyBilling": "Faktura miesięczna",
"hc.moveThePhotoToFit": "Przesuń zdjęcie, aby dopasować je do okręgu.",
"hc.myAccount": "Moje konto",
"hc.myInvoices": "Moje faktury",
"hc.myMonthlyInvoices": "Moje miesięczne faktury",
"hc.nArchived": "{n} ogłoszenie(a) zarchiwizowane.",
"hc.newCodeGeneratedAndSent": "Nowy kod wygenerowany i wysłany do klienta mailem i SMS-em",
"hc.newCodeGeneratedAndSent2": "Nowy kod wygenerowany i wysłany do właściciela",
"hc.newPassword": "Nowe hasło",
"hc.next": "Dalej",
"hc.nextPhoto": "Następne zdjęcie",
"hc.no": "Nie",
"hc.noAnswerProvided": "Nie podano odpowiedzi.",
"hc.noArchivedDeclarations": "Brak zarchiwizowanych deklaracji",
"hc.noCountryFound": "Nie znaleziono kraju",
"hc.noDeclarations": "Brak deklaracji",
"hc.noFeesAreChargedTo": "Nie pobierane są żadne opłaty od klienta.",
"hc.noInvoiceYet": "Brak faktury.",
"hc.noInvoiceYetYourInvoices": "Brak faktury. Twoje faktury pojawią się tutaj automatycznie po każdej płatności.",
"hc.noMatchIsAvailableFor": "Brak dostępnych dopasowań. Poinformujemy Cię, gdy tylko pojawi się element pasujący do Twojej deklaracji.",
"hc.noShipmentMatchesYourSearch": "Brak przesyłek pasujących do Twojego wyszukiwania.",
"hc.noShipmentsYet": "Brak przesyłek.",
"hc.noShipmentsYet2": "Brak przesyłek",
"hc.none": "brak",
"hc.noneChooseForEachShipment": "Brak (wybierz dla każdej przesyłki)",
"hc.notMine": "To nie moje",
"hc.of": "z",
"hc.only": "Tylko",
"hc.onlyEachSiteManagesIts": "tylko. Każda strona zarządza swoją własną bankowością: te linki nie wpływają na inne placówki.",
"hc.onlyTheOwnerOrAn": "Tylko właściciel lub administrator może skonfigurować linki płatności placówki.",
"hc.openDepositInTheMenu": "Otwórz \"Zadatek\" w menu, opisz przedmiot i zrób zdjęcie. Jest on natychmiast zapisany i gotowy do zwrotu.",
"hc.openSettings": "Otwórz Ustawienia →",
"hc.openTheDeclarationToManage": "Otwórz deklarację, aby zarządzać przesyłką",
"hc.optional": "— opcjonalne",
"hc.optional2": "(opcjonalne)",
"hc.optional3": "opcjonalne",
"hc.originalListingPhotoUsed": "Zastosowane oryginalne zdjęcie oferty",
"hc.other": "Inne",
"hc.other2": "Inne…",
"hc.ourProducts": "Nasze produkty",
"hc.overallRateTrendLast6": "Ogólny trend stawki (ostatnie 6 miesięcy)",
"hc.ownerSClaimCode": "Kod roszczenia właściciela",
"hc.ownershipConfirmed": "Własność potwierdzona",
"hc.paid": "Opłacono",
"hc.paidOn": "Opłacono w",
"hc.paidViaPartner": "Zapłacono (przez partnera)",
"hc.parcelBeingPrepared": "Paczka w przygotowaniu",
"hc.parcelDelivered": "Paczka dostarczona",
"hc.parcelShipped": "Paczka wysłana",
"hc.parisGareDeLyon": "Paryż, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Katalog partnerów",
"hc.passedOnToTheCustomer": "— przekazano klientowi link do płatności.",
"hc.password": "Hasło",
"hc.passwordResetPleaseLogIn": "Resetowanie hasła, proszę się zalogować.",
"hc.passwordUpdated": "Hasło zaktualizowane.",
"hc.passwordsDoNotMatch": "Hasła nie pasują.",
"hc.pasteThisSenderIdIn": "Wklej ten identyfikator nadawcy w Findloop → Ustawienia",
"hc.payForTheShipmentOf": "Zapłać za wysyłkę swojej paczki przez Findloop z bezpieczną płatnością.",
"hc.payTheRecoveryFees": "Zapłać opłaty za odzyskanie",
"hc.payTheShippingFees": "Zapłać opłaty za wysyłkę",
"hc.payment": "Płatność",
"hc.paymentAlreadyConfirmedByThe": "Płatność już potwierdzona przez partnera",
"hc.paymentLinksAreNowConfigured": "Linki płatności są teraz skonfigurowane według zakładu",
"hc.paymentNotCompletedYourAccount": "Płatność nie została zrealizowana, twoje konto nie zostało utworzone — spróbuj ponownie.",
"hc.paymentReceived": "Płatność otrzymana",
"hc.paymentSuccessful": "Płatność udana!",
"hc.pdfInvoice": "Faktura PDF",
"hc.pending": "W trakcie",
"hc.period": "Okres",
"hc.phoneNumber": "Numer telefonu",
"hc.phoneOptional": "Telefon (opcjonalnie)",
"hc.planAt": "plan w",
"hc.planLimitFmt": "Twój plan „{plan}” jest ograniczony do {max} zakładów. Aby zarządzać {n} stronami, polecamy",
"hc.platformReturnTarget": "Cel zwrotu platformy",
"hc.pleaseCompleteYourShippingAddress": "Proszę uzupełnić adres dostawy.",
"hc.pleaseProvideAPhoneNumber": "Proszę podać numer telefonu: jest wymagany przez przewoźnika do wysyłki.",
"hc.pleaseProvideAReason": "Proszę podać powód.",
"hc.pleaseSetYourOwnPassword": "proszę ustawić własne hasło przed kontynuowaniem.",
"hc.pointsToGoal": "{n} punktów do osiągnięcia naszego wspólnego celu.",
"hc.posterPreview": "Podgląd plakatu",
"hc.potentialMatchBeingVerified": "Potencjalne dopasowanie weryfikowane",
"hc.potentialOwner": "Potencjalny właściciel",
"hc.preFilledAutomaticallyYouCan": "Automatycznie uzupełnione — możesz zastąpić to zdjęciem paczki.",
"hc.pressKit": "Zestaw prasowy",
"hc.previewMode": "Tryb podglądu:",
"hc.previewOfThePrintReady": "Podgląd gotowego do druku plakatu A4 dla tego miejsca.",
"hc.previous": "Poprzedni",
"hc.previousPhoto": "Poprzednie zdjęcie",
"hc.primary": "główny",
"hc.printThePoster": "Drukuj plakat",
"hc.privacy": "Prywatność",
"hc.privacyPolicy": "Polityka prywatności",
"hc.processedCasesWillAppearHere": "Przetworzone sprawy pojawią się tutaj.",
"hc.proofOfReturnPdf": "Dowód zwrotu (PDF)",
"hc.protectedByRecaptcha": "Chronione przez reCAPTCHA",
"hc.publicMatch": "Publiczne dopasowanie",
"hc.putBackInStorage": "Włóż z powrotem do magazynu",
"hc.pwdResetByTeam": "Twoje hasło zostało zresetowane przez nasz zespół. Dla twojego bezpieczeństwa,",
"hc.questionsToAskTheOwner": "Pytania do właściciela",
"hc.rateChargedToTheCustomer": "Stawka naliczana klientowi:",
"hc.rateOfTarget": "{rate}% osiągnięte z celu {target}%",
"hc.reached": "osiągnięte",
"hc.reactivating": "Reaktywacja…",
"hc.reasonSavedYouCanStill": "Powód zapisany. Możesz nadal odebrać swój przedmiot.",
"hc.recentMatchesFirst": "Najnowsze dopasowania najpierw",
"hc.recognizedThePhotoYouSent": "rozpoznał zdjęcie, które wysłałeś i opisał te cechy. Potwierdź tylko, jeśli pasują do przedmiotu w twoim posiadaniu.",
"hc.recommended": "Zalecane",
"hc.recoveryFees": "Opłaty za odzyskanie",
"hc.recoveryFeesArePaidDirectly": "Opłaty za odzyskanie są płacone bezpośrednio do partnera. Findloop nie otrzymuje żadnych płatności od klientów.",
"hc.recoveryFeesEnabled": "Opłaty za odzyskanie włączone",
"hc.recoveryOfferedByTheEstablishment": "Odzyskanie oferowane przez lokal — Findloop nie pobiera żadnych opłat.",
"hc.recoveryPaymentLink": "Link do płatności za odzyskanie",
"hc.recoveryPaymentLinkSavedFor": "Link do płatności za odzyskanie zapisany dla tego miejsca",
"hc.redirecting": "Przekierowywanie…",
"hc.redirectingToPayment": "Przekierowywanie do płatności…",
"hc.redirectingToTheRecoveryOf": "Przekierowywanie do odzyskania twojego przedmiotu…",
"hc.regenerateAndResendToThe": "Zregeneruj i wyślij ponownie do właściciela",
"hc.regenerateTheCode": "Zregeneruj kod",
"hc.registerAFoundItem": "Zarejestruj znaleziony przedmiot",
"hc.rejectTheClaim": "Odrzuć roszczenie",
"hc.reminderDelaySaved": "Opóźnienie przypomnienia zapisane",
"hc.reopenThePaymentLink": "Ponownie otwórz link do płatności",
"hc.repeatThePassword": "Powtórz hasło",
"hc.reportAProblem": "Zgłoś problem",
"hc.reportDismissedYourListingRemains": "Zgłoszenie odrzucone. Twój wpis pozostaje publiczny.",
"hc.requiredUsedToCalculateThe": "Wymagane: używane do obliczania stawki wysyłki Sendcloud. Przesyłka niedostępna powyżej 30 kg.",
"hc.reset": "Resetuj",
"hc.resume": "Wznów",
"hc.resumeRegistration": "Wznów rejestrację",
"hc.retro": "Rok w przeglądzie",
"hc.returnSecurity": "Bezpieczeństwo zwrotu",
"hc.returnToTheOwner": "Zwróć właścicielowi",
"hc.returned": "zwrócone",
"hc.reviewTheItemDetails": "Przegląd szczegółów przedmiotu",
"hc.revokeAccess": "Cofnij dostęp",
"hc.role": "Rola:",
"hc.save": "Zapisz",
"hc.save2": "zapisz",
"hc.saveAndContinue": "Zapisz i kontynuuj",
"hc.saving": "Zapisywanie…",
"hc.scanTheClaimCode": "Skanuj kod roszczenia",
"hc.scanTheOwnerSQr": "Skanuj QR właściciela",
"hc.scrollThroughLanguages": "Przewiń przez języki",
"hc.searchByCustomerItemOr": "Szukaj według klienta, przedmiotu lub numeru śledzenia…",
"hc.searchForACountry": "Szukaj kraju…",
"hc.secureFindoVerification": "Bezpieczna weryfikacja Findloop",
"hc.seeRetro": "Zobacz rok w przeglądzie",
"hc.selectedCarrier": "Wybrany przewoźnik:",
"hc.selectedPlan": "Wybrany plan",
"hc.send": "Wyślij",
"hc.sendcloudSenderIdSaved": "ID nadawcy Sendcloud zapisane",
"hc.sendcloudSenderIdSenderId": "ID nadawcy Sendcloud (sender_id)",
"hc.sending": "Wysyłanie…",
"hc.sessionExpired": "Sesja wygasła",
"hc.setUpYourEstablishments": "Skonfiguruj swoje placówki",
"hc.settings": "Ustawienia",
"hc.settingsSubtitle": "Płatności zewnętrzne i przypomnienia, skonfigurowane na podstawie placówki.",
"hc.shareFoundText": "Znalazłem przedmiot — pomóż mi znaleźć jego właściciela na Findloop",
"hc.shareLostText": "Zgubiłem przedmiot — pomóż mi go znaleźć na Findloop",
"hc.sharePreview": "Udostępnij podgląd",
"hc.shareTheRanking": "Udostępnij ranking",
"hc.shareYourQrCodeTo": "Udostępnij swój kod QR, aby otrzymać deklaracje.",
"hc.shipRateAutoWeight": "Stawka wysyłki jest obliczana automatycznie przez Sendcloud (waga {w}) w momencie wysyłki.",
"hc.shipRateForWeight": "Stawka za wysyłkę (Sendcloud + {m}% marży) dla {w}:",
"hc.shipments": "Wysyłki",
"hc.shipmentsSubtitle": "Skonsolidowany widok wszystkich wysyłek zakładu, we wszystkich przypadkach. Kliknij w wiersz, aby zarządzać wysyłką w jej deklaracji.",
"hc.shipping": "Wysyłka",
"hc.shippingAddress": "Adres wysyłki",
"hc.shippingFeesAreHandledAutomatically": "Opłaty za wysyłkę są obsługiwane automatycznie przez Findloop (Sendcloud) — nie ma potrzeby wprowadzania linku.",
"hc.shippingFeesHaveAlreadyBeen": "Opłaty za wysyłkę zostały już uregulowane: przewoźnik nie może być zmieniony.",
"hc.shippingNotAvailableForItems": "Wysyłka niedostępna dla przedmiotów powyżej 30 kg. Klient będzie musiał odebrać przedmiot osobiście.",
"hc.shippingPaid": "Wysyłka opłacona ✓",
"hc.showOnlyItemsMatchingA": "Pokaż tylko przedmioty odpowiadające publicznej (klientowskiej) liście",
"hc.showPassword": "Pokaż hasło",
"hc.signInTheBoxAbove": "Zaloguj się w polu powyżej",
"hc.signatureSaved": "Podpis zapisany",
"hc.signedInWithGoogle": "Zalogowano przez Google",
"hc.signupFailed": "Rejestracja nie powiodła się",
"hc.silver": "Srebro",
"hc.simulatedRatesInPreProduction": "(symulowane stawki w pre-produkcji)",
"hc.siretAndVatNumberRequired": "Wymagany numer SIRET i VAT (Francja).",
"hc.skip": "Pomiń",
"hc.smsSentIfAccount": "Jeśli konto istnieje z tym numerem, wysłano do Ciebie SMS.",
"hc.sortItemsWithAPublic": "Sortuj: przedmioty z publicznym dopasowaniem (najświeższe) na początku",
"hc.specifyWhetherYouRecoveredYour": "Określ, czy odzyskałeś swój przedmiot, czy po prostu chcesz usunąć tę listę.",
"hc.specifyYourReason": "Określ swój powód",
"hc.specifyYourReason2": "Określ swój powód…",
"hc.staff": "Personel",
"hc.status": "Status",
"hc.staySignedIn": "Pozostań zalogowany",
"hc.step": "Krok",
"hc.stillThere": "Jeszcze tam?",
"hc.stopScrolling": "Przestań przewijać",
"hc.storeFindWithQr": "Przechowuj i znajdź za pomocą QR",
"hc.streetName": "Nazwa ulicy",
"hc.streetNo": "Numer ulicy",
"hc.switchTo": "Przełącz na",
"hc.switchToDarkMode": "Przełącz na tryb ciemny",
"hc.switchToLightMode": "Przełącz na tryb jasny",
"hc.takeAPhoto": "Zrób zdjęcie",
"hc.takeChangeThePhoto": "Zrób / zmień zdjęcie",
"hc.takenFromYourDeclaration": "przyjęto z twojej deklaracji",
"hc.target": "Cel",
"hc.targetReached": "Cel osiągnięty",
"hc.targetReachedThankYouTo": "Cel osiągnięty — dziękujemy całej społeczności Findloop!",
"hc.tellUsMore": "Powiedz nam więcej…",
"hc.tellUsWhyYouCancel": "Powiedz nam, dlaczego rezygnujesz. To pomoże partnerowi w przetwarzaniu twojej prośby.",
"hc.tellUsWhyYourListing": "Powiedz nam dlaczego. Twoje ogłoszenie pozostaje aktywne, a ty możesz dalej ubiegać się o swój przedmiot.",
"hc.termsAndConditions": "Warunki",
"hc.termsAndPolicies": "Warunki i polityki",
"hc.thankYouForYourFeedback": "Dziękujemy za twoją opinię",
"hc.theBannerDisplayedInThe": "baner wyświetlany w rejestrze.",
"hc.theClaimantHasBeenInformed": "Wnioskodawca został poinformowany. Przedmiot pozostaje dostępny w publicznym ogłoszeniu.",
"hc.theClaimantHasBeenNotified": "Wnioskodawca został powiadomiony i może teraz przejść do zwrotu.",
"hc.theCustomerPaysTheFees": "Klient opłaca opłaty na rzecz zakładu.",
"hc.theDayTheLegalRetention": "Dzień osiągnięcia ustawowego okresu zatrzymania.",
"hc.theEstablishmentConsideredThatThis": "Zakład uznał, że ten przedmiot nie należy do ciebie.",
"hc.theEstablishmentIsReviewingYour": "Zakład przegląda twoje odpowiedzi. Zostaniesz powiadomiony, gdy twój wniosek zostanie zatwierdzony, a następnie możesz opłacić opłaty za odzyskanie.",
"hc.theFeesAreTooHigh": "Opłaty są zbyt wysokie",
"hc.theFinderConsideredThatThis": "Znalazca uznał, że ten przedmiot nie należy do ciebie.",
"hc.theFinderIsReviewingYour": "Znalazca przegląda twój wniosek. Zostaniesz powiadomiony, gdy zostanie on zatwierdzony.",
"hc.theItem": "Przedmiot",
"hc.theItemWillBeRemoved": "Przedmiot zostanie usunięty z rejestru (brak trwającego roszczenia).",
"hc.theItemWillBeSet": "Przedmiot zostanie przywrócony do \"dostępny\" i związane roszczenie zostanie anulowane.",
"hc.theKbisNumberAndVat": "Numer Kbis i numer VAT są wymagane dla Francji.",
"hc.theLabelIsGeneratedAutomatically": "Etykieta jest generowana automatycznie, gdy klient opłacił opłaty za wysyłkę. Będzie dostępna do pobrania tutaj.",
"hc.theLinkMayHaveExpired": "Link mógł wygasnąć (ważny przez 30 dni). Skontaktuj się z pomocą Findloop, jeśli potrzebujesz.",
"hc.theOwnerDescribesTheirItem": "Właściciel opisuje swój przedmiot",
"hc.theOwnerReceivedItBy": "Właściciel otrzymał go mailem (lub SMS). Wprowadź lub zeskanuj go przed oddaniem.",
"hc.thePartnerConsideredThatThis": "Partner uznał, że ten przedmiot nie należy do ciebie. Przedmiot pozostaje dostępny.",
"hc.thePartnerIsReviewingYour": "Partner przegląda twoje odpowiedzi. Zostaniesz powiadomiony, gdy twój wniosek zostanie zatwierdzony.",
"hc.theShipmentIsCreatedAutomatically": "Przesyłka jest tworzona automatycznie, gdy klient potwierdził swój adres i opłacił opłaty za odzyskanie. Etykieta zostanie następnie automatycznie wygenerowana po dokonaniu płatności za wysyłkę i będzie dostępna do pobrania tutaj.",
"hc.theShippingRateWillBe": "Stawka za wysyłkę będzie obliczana automatycznie przez Sendcloud w momencie wysyłki (zarejestrowana waga).",
"hc.thisCarrierWillBe": "Ten przewoźnik będzie",
"hc.thisEstablishment": "ten zakład",
"hc.thisFieldIsRequiredFor": "To pole jest wymagane do automatycznego generowania etykiet.",
"hc.thisIsMyItem": "To jest mój przedmiot",
"hc.thisIsMyItemContinue": "To jest mój przedmiot — kontynuuj",
"hc.thisIsMyItemStart": "To jest mój przedmiot — rozpocznij zwrot",
"hc.thisIsNotMyItem": "To nie jest mój przedmiot",
"hc.thisMatchIsNoLonger": "To dopasowanie nie jest już dostępne lub zostało już przetworzone.",
"hc.thisRateWillBeCharged": "Ta stawka zostanie obciążona klienta. Wysoka stawka może zniechęcić do odzyskania.",
"hc.thisStepIsRequiredFor": "Ten krok jest wymagany do wygenerowania etykiet wysyłkowych",
"hc.thisValidationLinkIsInvalid": "Ten link do weryfikacji jest nieprawidłowy lub wygasł.",
"hc.toCheckBeforeMarkingThe": "Do sprawdzenia przed oznaczeniem przedmiotu jako zwrócony.",
"hc.toConfigureTheLinksAnd": "aby skonfigurować linki i opóźnienie przypomnienia dla każdego obiektu.",
"hc.toReachOurFirstMilestone": "aby osiągnąć nasz pierwszy kamień milowy 100 zwrotów.",
"hc.toTheCustomer": "do klienta.",
"hc.toTheShippingFeePayment": "do płatności za koszty wysyłki.",
"hc.toYourRecoveryTracking": "do śledzenia Twojego odzysku.",
"hc.tooExpensiveBudget": "Zbyt drogie / budżet",
"hc.topCitiesForReturns": "Najlepsze miasta do zwrotów",
"hc.trackMyRecovery": "Śledź mój odzysk",
"hc.trackTheShipmentAndDownload": "Śledź przesyłkę i pobierz etykietę (generowaną automatycznie) bez wychodzenia z zakładki Deklaracje.",
"hc.trackYourStatistics": "Śledź swoje statystyki",
"hc.tracking": "Śledzenie",
"hc.unableToOpenTheShipping": "Nie można otworzyć płatności za koszty wysyłki. Spróbuj ponownie.",
"hc.unableToRetrieveTheInvoice": "Nie można pobrać faktury.",
"hc.unclaimed": "Nieodebrany",
"hc.unclaimedCustomerReason": "Nieodebrany przedmiot. Powód klienta: \"{reason}\".",
"hc.unclaimedItem": "Nieodebrany przedmiot",
"hc.unclaimedItemNoClaimWithin": "Nieodebrany przedmiot — brak roszczenia w wyznaczonym terminie.",
"hc.unclaimedItems": "Nieodebrane przedmioty",
"hc.unclaimedItemsMatchLeftWithout": "Nieodebrane przedmioty: dopasowanie pozostało bez roszczenia w wyznaczonym terminie. Możesz je z powrotem złożyć w magazynie.",
"hc.unlockTheFinderSContact": "Odblokuj dane kontaktowe znalazcy, aby zorganizować przekazanie.",
"hc.upcoming": "Nadchodzące",
"hc.updateFailed": "Aktualizacja nie powiodła się.",
"hc.usedForInvoices": "Używane do wystawiania faktur findloop.",
"hc.vatNumber": "Numer VAT",
"hc.verificationPending": "Weryfikacja w toku",
"hc.verificationSentToTheFinder": "Weryfikacja wysłana do znalazcy. Zostaniesz powiadomiony o ich decyzji.",
"hc.verificationSentToThePartner": "Weryfikacja wysłana do partnera. Zostaniesz powiadomiony o ich decyzji.",
"hc.verify": "Zweryfikuj",
"hc.verifyingInvite": "Weryfikacja linku zapraszającego…",
"hc.verifyingTheLink": "Weryfikacja linku…",
"hc.viewInRegistry": "Zobacz w rejestrze",
"hc.viewItem": "Zobacz przedmiot",
"hc.viewItemRecover": "Zobacz przedmiot i odzyskaj",
"hc.visibleToTheOwnerAutomatically": "Widoczny dla właściciela · automatycznie usunięty po 60 dniach.",
"hc.waitingForPartnerConfirmation": "Czekanie na potwierdzenie od partnera",
"hc.waitingForThePartnerS": "Czekanie na potwierdzenie od partnera",
"hc.weHaveInformedTheEstablishment": "Poinformowaliśmy obiekt, że ten przedmiot nie jest Twój i wznowiliśmy analizę. Zostaniesz powiadomiony, gdy tylko zostanie znalezione nowe dopasowanie.",
"hc.weHaveInformedThePartner": "Poinformowaliśmy partnera, że ten przedmiot nie jest Twój. Twoje ogłoszenie pozostaje aktywne na przyszłe dopasowania.",
"hc.weRanTheAnalysisAgain": "Ponownie przeprowadziliśmy analizę i zidentyfikowaliśmy kolejny przedmiot, który może być Twój. Sprawdź go ponownie.",
"hc.weight": "Waga",
"hc.weightNotProvidedTheShipping": "Waga nie została podana: koszt wysyłki zostanie obliczony w momencie wysyłki.",
"hc.weightUnit": "Jednostka wagi",
"hc.welcome": "Witamy!",
"hc.welcomeToFindo": "Witamy w Findloop",
"hc.whenACustomerComesTo": "Kiedy klient przychodzi odebrać swoje rzeczy, otwórz jego deklarację i zweryfikuj zwrot. To wszystko!",
"hc.whenDisabledFeesDropTo": ". Po wyłączeniu, opłaty spadają do",
"hc.whyIsThisNotYour": "Dlaczego to nie jest Twój przedmiot?",
"hc.willBeMarkedAs": "zostanie oznaczony jako",
"hc.wrongColor": "Zła kolorystyka",
"hc.wrongModel": "Zły model",
"hc.yesCancel": "Tak, anuluj",
"hc.yesContactTheFinder": "Tak, skontaktuj się z osobą, która znalazła przedmiot",
"hc.youAreHere": "Jesteś tutaj",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Możesz teraz rozpocząć zwrot.",
"hc.youCanStillChangeIt": ". Możesz nadal to zmienić w każdej sytuacji.",
"hc.youHaveAlreadyConfirmedThat": "Już potwierdziłeś, że to jest Twój przedmiot.",
"hc.youWillBeRedirectedTo": "Zostaniesz przekierowany do bezpiecznej płatności Stripe.",
"hc.yourAccountHasBeenReactivated": "Twoje konto zostało reaktywowane.",
"hc.yourAccountIsActiveYou": "Twoje konto jest aktywne, możesz teraz zarządzać swoimi miejscami.",
"hc.yourEstablishment": "Twoje miejsce",
"hc.yourFeedbackHelpsUsImprove": "Twoje opinie pomagają nam poprawić nasze dopasowania.",
"hc.yourFeedbackHelpsUsRestart": "Twoje opinie pomagają nam wznowić analizę i poprawić nasze dopasowania.",
"hc.yourFirstSteps": "Twoje pierwsze kroki",
"hc.yourFirstStepsAdmin": "Twoje pierwsze kroki (admin)",
"hc.yourItemHasBeenHanded": "Twój przedmiot został przekazany osobiście przez partnera — zamknij sprawę, gdy potwierdzone zostanie przekazanie.",
"hc.yourItemHasBeenShipped": "Twój przedmiot został wysłany przez partnera — zamknij sprawę, gdy potwierdzona zostanie dostawa.",
"hc.yourPaymentHasBeenRecorded": "Twoja płatność została zarejestrowana.",
"hc.yourShipmentIsBeingPrepared": "Twoja przesyłka jest przygotowywana. Otrzymasz paczkę w ciągu 3 do 5 dni roboczych.",
"hc.yourShippingFeesHaveAlready": "Twoje koszty wysyłki zostały już opłacone. Wysyłka opłacona ✓",
"hc.yourShippingFeesHaveBeen": "Twoje koszty wysyłki zostały opłacone. Twoja paczka jest w przygotowaniu.",
"hc.yourVerificationQuestionsDeposit": "Twoje pytania weryfikacyjne (depozyt)",
"hero.einvoiceBadge": "E-fakturowanie zgodne z ustawą z 2027 roku",
"home.recentAdsAll": "Zobacz wszystkie ogłoszenia",
"home.recentAdsEyebrow": "Teraz",
"home.recentAdsSubtitle": "Znalezione i zaginione przedmioty zgłoszone przez społeczność.",
"home.recentAdsTitle": "Najnowsze ogłoszenia",
"home.reunions": "Ostatnie spotkania",
"pricing.physInvTitle": "Śledzenie fizycznego stanu magazynowego",
"pricing.physModalTitle": "Zarządzanie przedmiotami fizycznymi",
"pricing.physQrDesc": "Dla każdego przedmiotu generowany jest unikalny kod QR, który łączy się z wszystkimi jego informacjami.",
"pricing.physQrTitle": "Dedykowana etykieta QR",
"pricing.physShelfDesc": "Każdemu zarejestrowanemu przedmiotowi można przypisać fizyczną lokalizację w obiekcie.",
"pricing.physShelfTitle": "Plan półek",
"pricing.physicalMgmt": "Zarządzanie przedmiotami fizycznymi (półki, QR, inwentaryzacja)",
"pub.addSecondPhoto": "Dodaj 2. zdjęcie (opcjonalne)",
"pub.photo2Added": "✓ 2. zdjęcie dodane",
"reg.dispositionJournal": "Dziennik zbycia",
"reg.dispositionNoteAuthHint": "ℹ️ Wymagana jest notatka dla „Przekazano władzom” (numer raportu, dział…).",
"reg.dispositionNotePh": "Notatka (opcjonalnie): organizacja charytatywna, referencja władz, imię kupującego…",
"reg.dispositionNoteRequired": "Oficjalna referencja jest wymagana do przekazania władzom.",
"reg.legalPrealert": "Termin prawny za {days} dzień(i)",
"reg.legalPrealertOptions": "Opcje na terminie: sprzedaż na aukcji, darowizna dla organizacji charytatywnej, przekazanie władzom.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Pełna recenzja",
"rev.readMore": "Czytaj więcej",
"rw.activeCodes": "Aktywne bony",
"rw.archived": "Archiwum",
"rw.archivedTitle": "Wykorzystane bony (archiwum)",
"rw.hideArchived": "Ukryj wykorzystane bony",
"rw.noArchived": "Brak archiwalnego bonu.",
"rw.showArchived": "Pokaż wykorzystane bony",
"shp.labelAuto": "Etykieta jest generowana automatycznie, gdy tylko klient opłaci koszty przesyłki. Będzie do pobrania tutaj.",
"st.cancelled_by_customer": "Anulowano",
"stt.dispoPdfBtn": "Eksportuj PDF",
"stt.dispoPdfError": "Eksport PDF nie powiódł się.",
"stt.dispoPdfExporting": "Eksportowanie…",
"trk.matchVerifying": "Potencjalne dopasowanie weryfikowane",
"home.videoEyebrow": "Obejrzyj",
"home.videoSubtitle": "Jak ponownie łączymy zagubione przedmioty z ich właścicielami, bez wysiłku.",
"home.videoTitle": "Odkryj Findloop w 2 minuty",
"home.watchYoutube": "Obejrzyj na YouTube",
"impact.already": "Już",
"impact.citiesWord": "miasto/miasta",
"impact.eachPoint": "Każda kropka to miasto, w którym Findloop pomaga odzyskać zagubione przedmioty.",
"impact.emptyMap": "Mapa zapełnia się w miarę jak następują restitucje.",
"impact.eyebrow": "Nasz wpływ",
"impact.inCities": "w",
"impact.restitutedTo": "przedmioty zwrócone ich właścicielom",
"impact.title": "Przedmioty zwrócone, wszędzie w Twojej okolicy",
"inv2.download": "Pobierz",
"inv2.view": "Zobacz",
"map.objectsOnMapPlural": "przedmioty na mapie",
"map.objectsOnMapSingular": "przedmiot na mapie",
"mc.claimConfirmDesc": "Sprawdź przedmiot znaleziony przez znalazcę przed opłatą za odblokowanie jego danych kontaktowych.",
"mc.claimConfirmNo": "To nie jest mój przedmiot",
"mc.claimConfirmTitle": "Czy to naprawdę Twój przedmiot?",
"mc.claimConfirmYes": "Tak, to mój — zapłać",
"mc.claimFinderContacts": "Dane kontaktowe znalazcy",
"mc.claimNotMineDone": "Dziękujemy — znalazca został powiadomiony, a Twoja prośba została usunięta z ogłoszenia.",
"mc.claimUnlockDesc": "Zapłać opłatę zarządzającą Findloop, aby uzyskać dane kontaktowe osoby, która znalazła Twój przedmiot.",
"mc.claimUnlockTitle": "Odblokuj dane kontaktowe znalazcy",
"mc.hideCountryOffers": "Ukryj oferty w moim kraju",
"mc.myClaims": "Przedmioty, które zgłaszam",
"mc.myClaimsSub": "Przedmioty znalezione przez innych, które zgłaszasz. Odblokuj dane kontaktowe znalazcy, aby zorganizować przekazanie.",
"mc.notifAdCancelled": "Ogłoszenie anulowane",
"mc.notifCancelAd": "Anuluj moje ogłoszenie",
"mc.offersInCountry": "Oferty w moim kraju",
"mc.offersInCountryDesc": "Wszystkie aktywne nagrody od partnerów w Twoim kraju, według miasta.",
"mc.redArchived": "Zarchiwizowane",
"mc.rewardsCountryNone": "Brak ofert w Twoim kraju.",
"mc.rewardsForYou": "Nagrody dla Ciebie",
"mc.rewardsForYouDesc": "Oferowane przez partnerów, u których zostawiłeś przedmiot.",
"mc.rewardsMineNone": "Brak nagród od Twoich partnerów za pozostawienie przedmiotu.",
"mc.showCountryOffers": "Zobacz oferty w moim kraju",
"mc2.cancelDecl": "Anuluj moją deklarację",
"mc2.cancelDeclDone": "Deklaracja została anulowana.",
"pricing.physInvDesc": "Gdy przedmiot jest zwracany, jego lokalizacja jest automatycznie zwalniana i dostępna dla nowego przedmiotu.",
"pcat.stadium_arena": "Stadion / Arena",
"pcat.supermarket": "Supermarket",
"pcat.taxi_vtc": "Taksówka / Usługa przejazdów",
"pcat.tourism_office": "Biuro turystyczne",
"pcat.train_bus_station": "Dworzec kolejowy / autobusowy",
"pcat.travel_agency": "Biuro podróży",
"hc.and": "i",
"hc.demoObj0": "portfel",
"hc.demoObj1": "torba sportowa",
"hc.demoObj2": "telefon",
"hc.demoObj3": "para okularów",
"hc.demoObj4": "zestaw kluczy",
"hc.demoObj5": "szalik",
"hc.demoObj6": "laptop",
"hc.demoObj7": "butelka na wodę",
"hc.demoWhen0": "2 godziny temu",
"hc.demoWhen1": "5 godzin temu",
"hc.demoWhen2": "wczoraj",
"hc.demoWhen3": "3 godziny temu",
"hc.demoWhen4": "dzisiaj rano",
"hc.demoWhen5": "1 dzień temu",
"hc.feedDemo": "{obj} został zwrócony w {city} {when}.",
"hc.feedReal": "Przedmiot ({cat}) został zwrócony w {city}.",
"hc.saveBtn": "Zapisz",
"hc.saveLink": "Zapisz link",
"hc.terms": "Warunki",
"hc.view": "Zobacz",
"pcat.airline": "Linia lotnicza",
"pcat.airport": "Lotnisko",
"pcat.amusement_park": "Park rozrywki",
"pcat.bank": "Bank",
"pcat.bar_cafe": "Bar / Kawiarnia",
"pcat.beauty_salon": "Salon fryzjerski / Urody",
"pcat.cinema": "Kino",
"pcat.concert_theater": "Sala koncertowa / Teatr",
"pcat.coworking": "Przestrzeń coworkingowa",
"pcat.gym_fitness": "Siłownia / Fitness",
"pcat.hospital_clinic": "Szpital / Klinika",
"pcat.library": "Biblioteka",
"pcat.mall": "Centrum handlowe",
"pcat.museum": "Muzeum",
"pcat.pharmacy": "Apteka",
"pcat.private_company": "Firma prywatna",
"pcat.public_transport": "Transport publiczny",
"pcat.school_university": "Szkoła / Uniwersytet",
"pcat.sports_center": "Centrum sportowe",
"an.found": "Znaleziono",
"an.lost": "Zgubiono",
"hc.shareReview": "Udostępnij recenzję",
"hc.citiesAboveTarget": "{n} miasta powyżej celu",
"hc.cityAboveTarget": "{n} miasto powyżej celu",
"hc.j15EarlyReminder": "Przypomnienie D-15",
"hc.j7EarlyReminder": "Przypomnienie D-7",
"hc.annualTotal": "Roczna kwota",
"hc.billedOnceYear": "Obciążane raz na 12 miesięcy, odnawiane co roku.",
"hc.monthlyPrice": "Cena miesięczna",
"hc.perMonth": "/ miesiąc",
"hc.perYear": "/ rok",
"hc.billedEachMonth": "Automatycznie pobierane co miesiąc.",
"nav.business": "Biznes",
"nav.individual": "Indywidualny",
"hc.circumstancesFound": "Okoliczności znalezienia",
"hc.circumstancesFoundPh": "Np. znalezione na ziemi obok wejścia do metra",
"hc.circumstancesLost": "Okoliczności zgubienia",
"hc.circumstancesLostPh": "Np. zostawione na ławce podczas czekania na autobus",
"hc.conditionPh": "Np. dobry, zarysowany…",
"hc.firstName": "Imię",
"hc.lastName": "Nazwisko",
"hc.quantity": "Liczba przedmiotów",
"fa.ownerContact": "Kontakt do właściciela",
"fa.payPublish": "Zaplac i opublikuj",
"fa.pendingPayText": "Twoje ogłoszenie zostanie opublikowane, gdy płatność zostanie potwierdzona.",
"fa.pendingPayTitle": "Płatność w toku",
"fa.planSub": "Twoje ogłoszenie zostanie opublikowane, gdy płatność zostanie potwierdzona.",
"fa.planTitle": "Czas trwania ogłoszenia",
"fa.pubSuccessMsg": "Twoje ogłoszenie jest opublikowane. Zostaniesz powiadomiony, gdy tylko znajdący się zgłosi się.",
"fa.pubSuccessTitle": "Ogłoszenie opublikowane",
"fa.publicNote": "Tylko opis, miasto, kraj i zdjęcia są wyświetlane publicznie.",
"fa.redirectStripe": "Przekierowanie do bezpiecznej płatności…",
"fa.reject": "Odrzuć",
"fa.rejectConfirm": "Odrzucić to zgłoszenie? Twoje ogłoszenie pozostaje online.",
"fa.rejected": "Zgłoszenie odrzucone",
"fa.rejectedFinder": "To nie był poszukiwany przedmiot",
"fa.rejectedFinderText": "Właściciel mówi, że ten przedmiot nie jest jego. Dziękujemy za pomoc!",
"fa.responsesTitle": "Zgłoszenia znalezionych",
"fa.sent": "Zgłoszenie wysłane do właściciela.",
"fa.submitDecl": "Wyślij moje zgłoszenie",
"fa.submitDeclPay": "Wyślij i wnieś {amount}",
"fa.total": "Łączna kwota do zapłaty",
"fa.ttc": "w tym VAT",
"fa.waitClaimText": "Poszukujący przegląda Twoją prośbę. Zostaniesz powiadomiony o ich decyzji.",
"fa.waitFinderText": "Poinformujemy Cię, gdy tylko poszukujący złoży zgłoszenie.",
"fa.waitFinderTitle": "Twoje ogłoszenie jest opublikowane",
"fa.waitOwnerText": "Właściciel porównuje Twoje zgłoszenie z jego. Zostaniesz powiadomiony o ich decyzji.",
"fa.waitOwnerTitle": "Czekam na decyzję właściciela",
"st.pending_payment": "Płatność w toku",
"fa.approve": "Zatwierdź",
"fa.approveConfirm": "Zatwierdzić tę deklarację? Twoje pełne dane kontaktowe (imię, e-mail, telefon) zostaną wymienione z finderem.",
"fa.approved": "Deklaracja zatwierdzona — dane kontaktowe wymienione",
"fa.approvedFinder": "Właściciel zatwierdził Twoją deklarację",
"fa.approvedFinderText": "Skontaktuj się z nimi, aby umówić się na zwrot.",
"fa.boostSub": "Twoje ogłoszenie pozostaje na górze przez wybrany czas.",
"fa.boostTitle": "Wzmocnij moje ogłoszenie (opcjonalnie)",
"fa.colFinder": "Deklaracja findera",
"fa.colYours": "Twoja deklaracja",
"fa.compareHint": "Porównaj deklarację findera z Twoją przed podjęciem decyzji.",
"fa.contribNone": "Brak wkładu",
"fa.contribPaid": "Wkład otrzymany — dziękujemy!",
"fa.contribPending": "Wkład oczekuje na płatność",
"fa.contribSub": "Wspieraj Findloop, aby pomóc więcej osobom odzyskać ich rzeczy. Możesz wybrać €0.",
"fa.contribSuccessMsg": "Twoja deklaracja została wysłana do właściciela.",
"fa.contribSuccessTitle": "Dziękujemy za Twój wkład",
"fa.contribTitle": "Dobrowolny wkład",
"fa.days3": "3 dni",
"fa.days30": "30 dni",
"fa.days7": "7 dni",
"fa.declSub": "Opisz przedmiot, który znalazłeś. Właściciel porówna Twoją deklarację ze swoją.",
"fa.declTitle": "Znalazłem ten przedmiot",
"fa.expiresOn": "Wygasa",
"fa.fBrand": "Marka",
"fa.fCircumstances": "Okoliczności",
"fa.fCity": "Miasto",
"fa.fColor": "Kolor",
"fa.fCondition": "Stan",
"fa.fDate": "Data",
"fa.fMessage": "Wiadomość findera",
"fa.fPlace": "Miejsce",
"fa.fQuantity": "Ilość",
"fa.finderContact": "Dane kontaktowe findera",
"fa.finishPay": "Zakończ płatność",
"fa.foundDate": "Data znalezienia",
"fa.foundPlace": "Miejsce znalezienia",
"fa.hours24": "24 godziny",
"fa.ht": "bez VAT",
"fa.months3": "3 miesiące",
"fa.noBoost": "Brak wzmocnienia",
"fa.africaFree": "Bezpłatne ogłoszenie w Afryce — oferta startowa Findloop, skorzystaj!",
"fa.africaPublished": "Ogłoszenie opublikowane za darmo — oferta startowa w Afryce!",
"fa.approveClaimConfirm": "Czy zatwierdzić ten roszczenie? Właściciel będzie mógł odblokować Twoje dane kontaktowe.",
"fa.checkInfo": "Sprawdź swoje dane przed wysłaniem: zostaną porównane z danymi findera.",
"fa.claimApprovedShort": "Finder zatwierdził Twoje roszczenie",
"fa.claimRejectedShort": "Roszczenie odrzucone przez findera",
"fa.claimRejectedText": "Finder uważa, że ten przedmiot nie należy do Ciebie.",
"fa.claimSub": "Opisz swój przedmiot i dodaj 2 zdjęcia. Finder porówna je ze swoim ogłoszeniem.",
"fa.claimTitle": "To jest mój przedmiot",
"fa.claimUnlockText": "Odblokuj dane kontaktowe findera, aby umówić się na zwrot.",
"fa.claimUnlockedShort": "Dane kontaktowe odblokowane — zobacz śledzenie",
"fa.claimsTitle": "Roszczenia właściciela",
"fa.colOwner": "Oświadczenie właściciela",
"fa.colYourAd": "Twoje ogłoszenie",
"fa.expired": "Ogłoszenie wygasło",
"fa.free": "Darmowe",
"fa.lostDate": "Data zagubienia",
"fa.lostPlace": "Miejsce zagubienia",
"fa.noReceipt": "Brak paragonu dostępnego dla tego ogłoszenia.",
"fa.planSubFree": "Wybierz czas trwania: Twoje ogłoszenie będzie publikowane od razu, bez płatności.",
"fa.prefillPrevious": "Ponownie wykorzystaj dane mojego poprzedniego ogłoszenia w tej kategorii",
"fa.receipt": "Paragon PDF",
"fa.renewBtn": "Odnowić",
"fa.renewDiscountBanner": "50% zniżki: odnów przed wygaśnięciem ogłoszenia!",
"fa.renewDiscountHint": "50% zniżki przyznane, ponieważ odnawiasz przed wygaśnięciem.",
"fa.renewEarly": "Odnowić (−50%)",
"fa.renewTitle": "Odnowić moje ogłoszenie",
"fa.renewed": "Ogłoszenie odnowione",
"fa.sendClaim": "Wyślij moje roszczenie",
"fa.twoPhotos": "2 zdjęcia Twojego przedmiotu",
"fa.twoPhotosError": "Dodaj 2 zdjęcia swojego przedmiotu.",
"fa.twoPhotosHint": "Osobiste zdjęcia potwierdzające, że przedmiot należy do Ciebie (z przedmiotem, fakturą, pudełkiem…).",
"fa.unlockBtn": "Odblokuj dane kontaktowe",
"fa.unlockFree": "Odblokuj za darmo — oferta startowa",
"fa.waitClaimantText": "Powiadomimy Cię, gdy właściciel zgłosi ten przedmiot.",
"fa.waitFinderDecision": "Czekamy na decyzję findera",
"fa.waitUnlockText": "Otrzymasz powiadomienie, gdy dane kontaktowe zostaną wymienione.",
"fa.waitUnlockTitle": "Czekamy na odblokowanie przez właściciela",
"fa.cancel": "Anuluj",
"fa.categoryRequired": "Wybierz kategorię dla znalezionego przedmiotu.",
"fa.confirmTitle": "Potwierdź swoją decyzję",
"fa.goBack": "Wróć",
"dr.continue": "Kontynuuj moje zgłoszenie",
"dr.delete": "Usuń na stałe",
"dr.deleteConfirm": "Na pewno usunąć ten szkic na stałe? Nie można tego cofnąć.",
"dr.deleted": "Szkic usunięty",
"dr.expiresIn": "Szkic przechowywany przez {h} godzin więcej",
"dr.title": "Masz nieskończone zgłoszenie",
"form.step": "Krok",
"form.next": "Kontynuuj",
"form.back": "Wstecz",
"form.stepDetails": "Twój raport",
"form.stepPublish": "Czas trwania, wsparcie i płatność",
"form.stepThanks": "Dziękujemy i za wkład",
"fthx.badge": "Raport prawie gotowy",
"fthx.title": "Dziękujemy, wprowadzasz zmianę!",
"fthx.text": "Dzięki Tobie, ktoś wkrótce może odzyskać coś, co ma dla niego znaczenie. Takie akty dobroci jak Twój to dokładnie to, co utrzymuje Findloop przy życiu.",
"fthx.impact1": "Zgłoszony 1 przedmiot",
"fthx.impact2": "1 dodatkowa szansa na spotkanie",
"fthx.tipTitle": "Mały zastrzyk dla Findloop?",
"fthx.tipText": "Twoja pomoc pozwala nam utrzymywać usługę dostępną i łączyć coraz więcej przedmiotów z ich właścicielami.",
"fthx.optional": "100% opcjonalne – możesz opublikować bez wpłaty.",
"fthx.thanksTip": "Bardzo dziękujemy za Twoją hojność!",
"fthx.suggest": "Sugerowane kwoty",
"fthx.none": "Brak napiwku",
"pay.pendingTitle": "Płatność nie została dokończona",
"pay.pendingText": "Twoje dane zostały zapisane. Kontynuuj płatność tam, gdzie ją przerwałeś.",
"pay.resume": "Wznów płatność",
"pay.expiredTitle": "Sesja płatności wygasła",
"pay.expiredText": "Dla Twojego bezpieczeństwa sesja płatności wygasła. Twoje dane są zapisane: wznowisz płatność jednym kliknięciem.",
"pay.relaunch": "Uruchom ponownie płatność",
"sub.received": "Wysłano!",
"sub.publishing": "Kończymy…",
"sub.toPayment": "Przekierowuję do bezpiecznej płatności…",
"fa.claimSubV2": "Opisz zgubioną rzecz. Osoba, która ją znalazła, porówna Twoje zgłoszenie z jej ogłoszeniem.",
"fa.photosOptional": "Zdjęcia Twojej rzeczy (opcjonalnie)",
"fa.compareOwnerHint": "Porównaj te informacje z rzeczą, którą znalazłeś, a następnie powiedz, czy to ta sama rzecz.",
"fa.itsThisItem": "Tak, to jest ta rzecz",
"fa.notThisItem": "Nie, to nie jest ta rzecz",
"fa.confirmIsItem": "Potwierdź, że to ta rzecz? Twoje dane kontaktowe i właściciela będą widoczne w odpowiednich kontach.",
"fa.confirmNotItem": "Potwierdź, że to nie jest ta rzecz? Twoje zgłoszenie zostanie zamknięte.",
"fa.youConfirmed": "Potwierdziłeś, że to rzecz właściciela",
"fa.youDeclined": "Wskazałeś, że to nie jest ta rzecz",
"fa.youDeclinedText": "Dziękujemy za pomoc! Właściciel został poinformowany.",
"fa.waitFinderDecisionOwner": "Czekamy na decyzję znalazcy",
"fa.finderConfirmed": "Potwierdzone",
"fa.notYourItem": "To nie była Twoja rzecz",
"fa.reportedOn": "Zgłoszone w dniu",
"fa.ownerWaitHint": "Znajdujący się aktualnie sprawdza informacje, proszę czekać.",
"fa.claimSentFinder": "Roszczenie wysłane do osoby, która znalazła przedmiot.",
"fa.compareClaimHint": "Porównaj oświadczenie właściciela z Twoją ofertą przed podjęciem decyzji.",
"fa.closeFollowup": "Zamknij to przypomnienie",
"fa.closeFollowupConfirm": "Zamknąć to przypomnienie? Adresy e-mail i numery telefonów obu stron zostaną trwale usunięte, gdy właściciel również zamknie swoją ofertę.",
"fa.safetyTitle": "Wskazówki dotyczące bezpieczeństwa przed przekazaniem",
"fa.safety1": "Poproś właściciela o szczegółowy opis ukrytych cech przedmiotu: konkretny zadrapanie, dokładna zawartość torby, tapeta, numer seryjny…",
"fa.safety2": "Jeśli to możliwe, poproś o dowód wizualny (zdjęcie przedmiotu) lub dowód zakupu.",
"fa.safety3": "Przekaż przedmiot w miejscu publicznym lub u partnera Findloop i sprawdź dowód tożsamości właściciela.",
"fa.safetyOk": "Rozumiem, kontynuuj",
"fa.ownerClosedNote": "Właściciel zamknął swoją ofertę.",
"fa.finderClosedNote": "Poszukiwacz zamknął swoje przypomnienie.",
"fa.followupClosed": "Zamknięte przypomnienie",
"fa.followupClosedText": "Zamknąłeś to przypomnienie. Dziękujemy za pomoc!",
"fa.photoReviewTitle": "Finder wysłał zdjęcie. Czy wygląda jak Twój przedmiot?",
"fa.photoLooksLike": "Tak, to wygląda jak mój przedmiot",
"fa.photoNotMine": "Nie, to nie jest mój przedmiot",
"fa.photoNotMineConfirm": "Kontynuacja zostanie zamknięta z obu stron, a Twoje ogłoszenie pozostanie otwarte dla nowego findera.",
"fa.photoLooksLikeDone": "Dzięki! Finder porówna teraz Twoje zgłoszenie.",
"fa.photoNotMineDone": "Zgłoszenie odrzucone. Twoje ogłoszenie pozostaje otwarte.",
"fa.ownerPhotoHint": "Pokazane jest tylko zdjęcie findera. Powiedz nam, czy wygląda jak Twój przedmiot.",
"fa.ownerReviewingPhoto": "Właściciel przegląda Twoje zdjęcie",
"fa.ownerReviewingPhotoText": "Będziesz powiadomiony, gdy tylko odpowiedzą. Będziesz mógł porównać ich zgłoszenie.",
"fa.ownerRejectedPhoto": "To nie jest przedmiot właściciela",
"fa.ownerRejectedPhotoText": "Właściciel mówi, że Twoje zdjęcie nie pasuje do jego przedmiotu. Kontynuacja została zamknięta. Dzięki za pomoc!",
"fa.contribute": "Wnieś wkład",
"fa.phoneMissing": "Nie podano",
"fa.ownerSafety1": "Najlepiej przekazać przedmiot w miejscu publicznym lub u partnera Findloop. Jeśli odległość jest duża, zaproponuj wysłanie go pocztą.",
"fa.ownerSafety2": "Przy odbiorze sprawdź dowód tożsamości znalazcy.",
"pub.changePhoto": "Zmień zdjęcie",
"ph.secured": "Zdjęcie zabezpieczone",
"ph.securing": "Zabezpieczanie zdjęcia…",
"fa.ownerSafety3": "Jeśli zdjęcie znalezione przez osobę ma znak wodny Findloop, nie akceptuj spotkania. Zdjęcie musi być oryginalnym obrazem wykonanym przez znalazcę, bez znaku wodnego."
},
"ru": {
"ac.africa": "Африка",
"ac.boostActive": "Выделение активно —",
"ac.boostSub": "Появитесь в верхней части каталога партнеров с бейджем «Увеличено».",
"ac.boostTitle": "Увеличьте свое размещение в каталоге",
"ac.categoryHint": "Чтобы классифицировать ваше заведение в каталоге findloop.",
"ac.choose": "Выбрать",
"ac.cityHint": "Для точного позиционирования на публичной карте.",
"ac.cityLabel": "Город заведения",
"ac.cityPh": "Париж",
"ac.contact": "Контактные данные",
"ac.converted": "Конвертировано",
"ac.copyDeclLink": "Скопируйте ссылку на декларацию",
"ac.copyLink": "Скопировать ссылку",
"ac.currentPlan": "Текущий тариф",
"ac.emailDesc": "Выберите электронные письма, которые хотите получать. Уведомления в вашем рабочем пространстве всегда активны.",
"ac.emailMatch": "Совпадения",
"ac.emailMatchDesc": "Сообщение на почту, когда элемент соответствует декларации",
"ac.emailNewDecl": "Новые декларации о потерях",
"ac.emailNewDeclDesc": "Сообщение на почту, как только клиент сообщает о потере у вас",
"ac.emailShip": "Запросы на отправку",
"ac.emailShipDesc": "Сообщение на почту, когда клиент запрашивает отправку элемента",
"ac.emailTitle": "Настройки электронной почты",
"ac.expireSoon": "Ваше выделение скоро истечет —",
"ac.exportCsv": "Экспорт (CSV)",
"ac.exportHint": "Экспортируйте ваши подтвержденные внешние платежи для учета.",
"ac.free": "Бесплатно",
"ac.freeMonths": "Бесплатные месяцы",
"ac.hours": "часов",
"ac.howItWorks": "Как это работает?",
"ac.invited": "Приглашено",
"ac.legalFR": "Необходимо для электронного выставления счетов (Factur-X), применяется с сентября 2026 года.",
"ac.legalMissing": "⚠️ Недостаёт SIRET и внутрисоюзного НДС — заполните их, чтобы соответствовать требованиям электронного выставления счетов.",
"ac.legalOther": "Рекомендуется для ваших счетов.",
"ac.legalPartnerQr": "QR-код",
"ac.legalTitle": "Юридические идентификаторы (выставление счетов)",
"ac.logoTitle": "Логотип заведения",
"ac.modeCurrent": "Текущий режим:",
"ac.modeExternal": "Внешний (ручная валидация)",
"ac.modeInternal": "Внутренний Findloop (авто)",
"ac.noSubReceipt": "Пока нет оплаты подписки.",
"ac.none": "Нет",
"ac.onYourListing": "в вашем размещении",
"ac.pay1": "Введите свои платежные ссылки ниже, чтобы перенаправить клиентов на вашу собственную систему сбора средств.",
"ac.pay2": "Валидация становится ручной: вы подтверждаете получение платежа во вкладке «Декларации».",
"ac.pay3": "Ссылка «Плата за отправку» является обобщенным платежом (восстановление + отправка).",
"ac.pay4": "Оставьте поля пустыми, чтобы использовать внутренний платеж Findloop (Stripe) с автоматической валидацией.",
"ac.paySub": "Собирайте сборы через свою собственную платёжную систему.",
"ac.payTitle": "Внешние платежи",
"ac.permissive": "Разрешающий",
"ac.phone": "Телефон",
"ac.posterA4": "Плакат A4 (PDF)",
"ac.qMessage": "Сообщение (по желанию)",
"ac.qName": "Имя",
"ac.qOrg": "Организация",
"ac.qSites": "Количество заведений (предположительно)",
"ac.qrHint": "Ваши клиенты сканируют этот код, чтобы сообщить о потерянном предмете.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Ваш партнерский QR-код",
"ac.quoteDesc": "Аэропорты, железнодорожные сети, международные цепочки · ",
"ac.quoteEurope": "Европа / Мир",
"ac.quoteSent": "Запрос на коммерческое предложение отправлен. Наша команда свяжется с вами в ближайшее время.",
"ac.quoteTitle": "Запрос коммерческого предложения — Корпорация",
"ac.recoveryLink": "Ссылка на «плату за восстановление»",
"ac.refSub": "Каждый рекомендованный партнер, подписавшийся на услуги, дает вам 1 бесплатный месяц.",
"ac.refTitle": "Рекомендуйте, зарабатывайте бесплатный месяц",
"ac.reminderDelay": "Срок напоминания о валидации",
"ac.reminderHint": "Вы получите напоминание по электронной почте, если внешний платеж не будет подтвержден по истечении этого срока (по умолчанию: 48 ч).",
"ac.renewDesc1": "Вы уже заработали",
"ac.renewDesc2": "Продлите действие, чтобы оставаться на вершине каталога и не потерять эту видимость.",
"ac.renewNow": "Продлить сейчас",
"ac.requestQuote": "Запросить коммерческое предложение",
"ac.saveLegal": "Сохранить идентификаторы",
"ac.saveLinks": "Сохранить ссылки",
"ac.sendRequest": "Отправить мой запрос",
"ac.sending": "Отправка…",
"ac.shippingLink": "Ссылка на «плату за доставку» (консолидированная)",
"ac.shippingLinkHint": "Эта ссылка охватывает как восстановление, так и доставку.",
"ac.strict": "Строго",
"ac.subReceipt": "Чек подписки (PDF)",
"ac.subReceiptsSub": "Загрузите PDF-накладную для каждого платежа подписки.",
"ac.subReceiptsTitle": "Чеки подписки",
"ac.tCategory": "Категория сохранена",
"ac.tCity": "Город сохранен — карта обновлена",
"ac.tCityNeeded": "Введите город",
"ac.tCopied": "Скопировано!",
"ac.tCover": "Обложка обновлена",
"ac.tEmailPrefs": "Настройки электронной почты обновлены",
"ac.tErr": "Ошибка",
"ac.tExportImpossible": "Экспорт не удался",
"ac.tLegal": "Правовые идентификаторы сохранены",
"ac.tLegalNeeded": "SIRET и НДС обязательны для Франции",
"ac.tLogo": "Логотип обновлен",
"ac.tLogoRemoved": "Логотип удален",
"ac.tPayLinks": "Ссылки для оплаты сохранены",
"ac.tPhone": "Телефон сохранен",
"ac.tSensitivity": "Чувствительность сохранена",
"ac.tVatInvalid": "Недействительный номер НДС",
"ac.tVatValid": "Действительный НДС",
"ac.tabBoost": "Видимость",
"ac.tabPayments": "Платежи",
"ac.tabProfile": "Профиль",
"ac.tabQr": "QR и плакат",
"ac.tabReferral": "Рефералы",
"ac.tabSub": "Подписка",
"ac.thisWeek": "Эта неделя",
"ac.thisWeekOf": " ({n} на этой неделе)",
"ac.thresholdDesc": "Порог доверия, при котором ИИ автоматически подтверждает соответствие фотографии и уведомляет клиента. Чем выше = меньше автоматических совпадений, но надежнее.",
"ac.thresholdTitle": "Чувствительность визуального соответствия ИИ",
"ac.trend": "Тренд",
"ac.upload": "Загрузить",
"ac.vatValidFmt": "Действительный НДС{name} ({via})",
"ac.vatVerified": "Внутренний НДС ЕС подтвержден",
"ac.verifyVat": "Проверить НДС (VIES)",
"ac.verifying": "Проверка…",
"ac.views": "просмотры",
"ac.viewsTotal": "Общее количество просмотров",
"ac.winbackBtn": "Возобновить с -20%",
"ac.winbackDesc1": "Вы заработали",
"ac.winbackDesc2": "Специальное предложение: -20% применяется автоматически, если вы продлите в течение 24 ч.",
"ac.winbackTitle": "Ваш момент только что истек — возобновите со скидкой -20%!",
"an.allCountries": "Все страны",
"an.country": "Страна",
"an.geoBanner": "Вы просматриваете объявления в",
"an.geoBannerWorld": "Вы просматриваете объявления по всему миру",
"an.geoChange": "сменить страну",
"an.loginRequired": "Войдите, чтобы сообщить об этом предмете и следовать возвращению.",
"an.requestInProgress": "Запрос в процессе",
"an.resolved": "Предмет уже восстановлен",
"an.sortRecent": "Самые новые",
"an.sortRelevance": "Релевантность",
"bo.africaPrice": "Применены преференциальные цены для зоны Африки",
"c.all": "Все",
"c.close": "Закрыть",
"c.confirm": "Подтвердить",
"c.confirmed": "Подтверждено",
"c.download": "Скачать",
"c.reset": "Сбросить",
"c.transfer": "Передать",
"cat.Animal": "Домашние животные / Аксессуары для домашних животных",
"cat.AppareilPhoto": "Камера",
"cat.Argent": "Деньги / Наличные",
"cat.Autres": "Другие",
"cat.Bijoux": "Ювелирные изделия",
"cat.CarteBancaire": "Банковская карта",
"cat.CarteIdentite": "Удостоверение личности / Паспорт",
"cat.Casquette": "Кепка / Шляпа",
"cat.Ceinture": "Ремень",
"cat.Chargeur": "Зарядное устройство / Кабель",
"cat.Chaussures": "Обувь",
"cat.CleVoiture": "Ключ от автомобиля",
"cat.Cles": "Ключи",
"cat.Console": "Игровая консоль",
"cat.Documents": "Документы / Бумаги",
"cat.Echarpe": "Шарф",
"cat.Ecouteurs": "Наушники",
"cat.Electronique": "Электроника (другое)",
"cat.Enceinte": "Динамик",
"cat.Gants": "Перчатки",
"cat.Gourde": "Бутылка для воды / Термо-бутылка",
"cat.Instrument": "Музыкальный инструмент",
"cat.Jouet": "Игрушка / Плюш",
"cat.Jumelles": "Бинокль",
"cat.Lampe": "Лампа / Фонарь",
"cat.Liseuse": "Электронная книга",
"cat.Livre": "Книга / Блокнот",
"cat.Lunettes": "Очки",
"cat.Manteau": "Пальто / Куртка",
"cat.Maquillage": "Косметичка",
"cat.Medical": "Медицинское оборудование",
"cat.Medicaments": "Лекарства",
"cat.Montre": "Часы / Умные часы",
"cat.Ordinateur": "Персональный компьютер",
"cat.Parapluie": "Зонтик",
"cat.Portefeuille": "Кошелек / Портмоне",
"cat.Poussette": "Коляска / Аксессуар для ребенка",
"cat.Sac": "Сумка / Сумочка",
"cat.SacADos": "Рюкзак",
"cat.Souris": "Мышь / Клавиатура",
"cat.Sport": "Спортивное оборудование",
"cat.Tablette": "Планшет",
"cat.Telephone": "Телефон / Смартфон",
"cat.Trottinette": "Самокат",
"cat.Trousse": "Кошелек / Чехол",
"cat.USB": "USB флешка / Жесткий диск",
"cat.Valise": "Чемодан / Багаж",
"cat.Velo": "Велосипед",
"cat.Vetements": "Одежда",
"cm.found": "НАЙДЕНО",
"cm.lost": "ПОТЕРЯНО",
"cmp.starterEst": "1 включен + неограниченно дополнительно",
"consent.required": "Вы должны согласиться на предоставление своих контактных данных для продолжения.",
"consent.share": "Я согласен, чтобы находивший мой предмет мог видеть мои контактные данные (имя, email, телефон) для связи со мной по поводу его возврата.",
"dc.partnerDesc": "Потеряли предмет в партнерском месте (гостиница, станция, зал...)? Выберите его для прямого возврата.",
"dc.partnerList": "Выберите из списка",
"dc.partnerMap": "Выберите на карте",
"dc.partnerTitle": "Декларация в партнере",
"dc.publicCta": "Разместить публичное объявление",
"dc.publicDesc": "Ваше объявление будет видно всей communauté findloop. Идеально, если вы не знаете, где потеряли предмет.",
"dc.publicTitle": "Публичная декларация",
"dc.subtitle": "Выберите, как сообщить о потерянном предмете.",
"dc.title": "Что вы хотите сделать?",
"dec.addrPending": "Адрес ожидает подтверждения от клиента",
"dec.analyzing": "Анализируется...",
"dec.clientDescription": "Описание клиента",
"dec.clientPhoto": "Фото, предоставленное клиентом",
"dec.clientPhotoShort": "Фото клиента",
"dec.comparePhotos": "Сравнить фото",
"dec.declaredItemPhoto": "Фото заявленного предмета",
"dec.emptyDesc": "Поделитесь своим QR-кодом, чтобы получить декларации.",
"dec.emptyTitle": "Нет деклараций",
"dec.enlarge": "Увеличить",
"dec.extBanner": "{n} внешних платеж(ей) для подтверждения — подтвердите получение ниже, чтобы разблокировать передачу или доставку.",
"dec.foundItemAlt": "Найденный предмет",
"dec.foundItemRegistry": "Найденный предмет (регистрация)",
"dec.labelClient": "Клиент",
"dec.labelRegistry": "Регистрация",
"dec.noMatchYet": "Совпадений еще нет.",
"dec.noPhoto": "Нет фото",
"dec.pRecup": "восстановление",
"dec.pRecupP": "(восстановление)",
"dec.pRecupShip": "(восстановление + доставка)",
"dec.payConfirmed": "Платеж {x} подтвержден",
"dec.payPending": "Внешний платеж {x} в ожидании",
"dec.pickup": "Личное получение",
"dec.reject": "Отклонить",
"dec.rerun": "Повторить анализ",
"dec.similarity": "Сходство {n}%",
"dec.suggestedMatches": "Предложенные совпадения",
"dec.toColon": " до:",
"dec.toShip": "К отправке",
"dec.toastExtPay": "Платеж подтвержден — клиент будет уведомлен.",
"dec.toastMatch": "Совпадение подтверждено",
"dec.toastReject": "Предложение отклонено",
"dec.toastRerun": "Анализ перезапущен",
"dec.toastVisualN": "{n} визуальное совпадение(я)",
"dec.toastVisualNone": "Нет визуальных совпадений",
"dec.viewBeforeAfter": "Просмотр до/после (наложение)",
"dec.viewSideBySide": "Сравнительный просмотр",
"dec.visualCompare": "AI визуальное сравнение",
"dec.visualIdle": "Запустите сравнение, чтобы AI визуально сопоставил фото клиента с найденными предметами.",
"dec.visualRunning": "ИИ сравнивает фото клиента с предметами в вашем реестре…",
"dec.zoomPhoto": "Увеличить фото",
"dep.addAnyway": "Добавить в любом случае",
"dep.addError": "Ошибка при добавлении",
"dep.addItem": "Добавить предмет",
"dep.added": "Предмет добавлен в реестр!",
"dep.adding": "Добавление…",
"dep.aiError": "Анализ ИИ сейчас недоступен.",
"dep.aiFilled": "Форма заполнена ИИ ✨",
"dep.aiUnavailable": "ИИ недоступен — заполните форму вручную.",
"dep.analyzing": "Анализирую…",
"dep.analyzingPhoto": "Анализирую фото…",
"dep.brand": "Бренд",
"dep.brandPlaceholder": "например, Apple",
"dep.category": "Категория",
"dep.checkingDup": "Проверка на дубликаты…",
"dep.color": "Цвет",
"dep.colorPlaceholder": "например, черный",
"dep.condition": "Состояние",
"dep.conditionPlaceholder": "например, хорошее состояние",
"dep.depositorNote": "Заметка от депозитора",
"dep.depositorNoteHint": "Операционные детали, написанные от руки. ИИ никогда не перезаписывает эту запись.",
"dep.depositorNotePlaceholder": "например, содержимое мешочка, указанный бренд, детали, сообщенные человеком…",
"dep.descPlaceholder": "например, черный iPhone 15 с прозрачным чехлом, найденный в баре…",
"dep.description": "Описание",
"dep.dupHint": "Убедитесь, что вы не добавляете дубликат. Вы можете продолжить, если предмет действительно отличается.",
"dep.dupTitle": "Похожие предметы уже зарегистрированы",
"dep.dupWarn": "Обнаружен похожий предмет — проверьте, затем нажмите снова, чтобы подтвердить.",
"dep.estHint": "Предмет будет добавлен в реестр этого заведения.",
"dep.establishment": "Заведение",
"dep.fee": "Плата за восстановление (€) — необязательно",
"dep.feePlaceholder": "Оставьте пустым для цены по умолчанию категории",
"dep.fillAI": "Заполнить с ИИ",
"dep.optional": "(необязательно)",
"dep.photo": "Фото предмета",
"dep.principal": "основной",
"dep.reqError": "Категория и описание обязательны.",
"dep.savedItem": "Зарегистрированный предмет",
"dep.similarity": "Схожесть",
"dep.storage": "Физическое местонахождение",
"dep.storageHint": "Где физически хранится предмет. Будет создан QR-код для его поиска.",
"dep.storagePlaceholder": "например, Полка A3, Шкафчик 12, Сейф на ресепшен",
"dl.aClient": "клиент",
"dl.alertsBlocked": "Уведомления браузера заблокированы",
"dl.alertsBlockedHint": "Чтобы снова включить их: нажмите на значок 🔒 (или ⓘ) слева от адреса сайта, затем разрешите уведомления и перезагрузите страницу.",
"dl.amountDue": "Сумма к оплате: {amount} {currency}.",
"dl.enableAlerts": "Включить уведомления",
"dl.extPending": "Платежи на подтверждение",
"dl.freemiumNear": "Вы приближаетесь к лимиту Freemium ({used}/{max} предметов в этом месяце). Обновите до Starter для неограниченного количества предметов.",
"dl.freemiumReached": "Лимит Freemium достигнут ({used}/{max} предметов в этом месяце). Обновите до Starter, чтобы регистрировать неограниченное количество предметов.",
"dl.invoiceOverdue": "Счет {num} не оплачен — доступ ограничен.",
"dl.matchNotifTitle": "Findloop — Новое совпадение ИИ 🔔",
"dl.matchToast": "Новое совпадение ИИ — {name}",
"dl.matchToastDesc": "Предмет соответствует декларации.",
"dl.notifEmpty": "Нет уведомлений.",
"dl.notifEnabled": "Уведомления браузера включены",
"dl.notifTitle": "Уведомления",
"dl.payInvoice": "Оплатить мой счет →",
"dl.rewardsPending": "Промо-коды для презентации",
"dl.upgradeStarter": "Обновить до Starter →",
"est.all": "Все заведения ({n})",
"est.label": "Заведение",
"est.primary": "основное",
"est.secondary": "вторичное",
"est2.add": "Добавить заведение",
"est2.addressLabel": "Адрес",
"est2.addressPh": "Улица République, 12",
"est2.autoInvoice": "Подробный счет фактуры автоматически создается 1-го числа каждого месяца.",
"est2.baseSub": "Базовая подписка",
"est2.billing": "Выставление счетов",
"est2.boostActivated": "Увеличение активности для {name} активировано",
"est2.boostBillingNote": "Выставляется по текущему тарифу и объединяется в вашем общем месячном счете.",
"est2.boostCta": "Увеличить",
"est2.boostDesc": "Улучшите видимость этого заведения в справочнике и на карте.",
"est2.boostDuration": "{h}ч повышенной видимости",
"est2.boostExtend": "Продлить",
"est2.boostTitle": "Увеличить {name}",
"est2.boosted": "Увеличено",
"est2.chartDesc": "Доля возвращенных товаров из общего числа зарегистрированных, по каждому сайту.",
"est2.chartTitle": "Уровень возврата по заведению",
"est2.chartTooltip": "Возврат",
"est2.cityLabel": "Город",
"est2.cityPh": "Лион",
"est2.contactHint": "Эти данные показываются клиенту для этого заведения (используются данные аккаунта, если пусто).",
"est2.countryLabel": "Страна",
"est2.coverLabel": "Обложка",
"est2.create": "Создать",
"est2.created": "Заведение создано",
"est2.delete": "Удалить",
"est2.deleteDesc": "Это действие является постоянным. Вы можете удалить заведение, только если в нем нет товаров.",
"est2.deleteTitle": "Удалить «{name}»?",
"est2.deleted": "Заведение удалено",
"est2.dialogDesc": "Введите название и адрес этого заведения.",
"est2.edit": "Редактировать",
"est2.editEst": "Редактировать заведение",
"est2.emailLabel": "Контактный email",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " заведение(я)",
"est2.extraNoteBase": "{n} дополнительных заведения(й) выставлено",
"est2.extraPrice": " по {price} €/месяц.",
"est2.extraQuote": " по запросу.",
"est2.imgChange": "Выбрать изображение",
"est2.imgDone": "Готово",
"est2.imgRemove": "Удалить",
"est2.imgRemoved": "Изображение удалено",
"est2.imgSaved": "Изображение сохранено",
"est2.imgUploading": "Загружается…",
"est2.includedPlan": "Включено в ваш тариф: {n}.",
"est2.kDeclarations": "Декларации",
"est2.kInStorage": "На складе",
"est2.kItemsTotal": "Товары (всего)",
"est2.kRestituted": "Возвращено",
"est2.limitReached": "Достигнут лимит",
"est2.logoLabel": "Логотип",
"est2.mDeclar": "Декл.",
"est2.mItems": "Товары",
"est2.mRestituted": "Возвращено",
"est2.mStorage": "На складе",
"est2.monthlyTotal": "Месячная сумма",
"est2.nameLabel": "Имя *",
"est2.namePh": "например, Belmont Hotel — Lyon Annex",
"est2.newEst": "Новое заведение",
"est2.onQuote": "По报价",
"est2.phoneLabel": "Телефон",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "План",
"est2.planLimited": "Ваш план “{tier}” ограничен {max} заведением(ями).",
"est2.primary": "Основной",
"est2.qr": "QR-код",
"est2.qrDesc": "Покажите этот QR-код в данном заведении. Клиенты, сообщающие о потере, будут связаны с этим сайтом.",
"est2.qrTitle": "QR-код — {name}",
"est2.saving": "Сохранение…",
"est2.seeInvoices": "Смотреть мои ежемесячные счета",
"est2.seePlans": "Смотреть планы",
"est2.subtitle": "Управляйте всеми вашими заведениями в одной учетной записи — консолидированный просмотр, предметы, QR-код и выставление счетов.",
"est2.suspended": "Приостановлено",
"est2.tierFree": "1 заведение",
"est2.tierLarge": "неограниченное количество заведений",
"est2.tierMedium": "включено 5 заведений",
"est2.tierSmall": "включено 3 заведения",
"est2.title": "Заведения",
"est2.unlimitedPlan": "Ваш план позволяет неограниченное количество заведений.",
"est2.unlimitedSuffix": " · неограниченно",
"est2.updated": "Заведение обновлено",
"est2.upgradeHint": "Повышайте план, чтобы добавить больше сайтов и централизовать всю вашу активность.",
"est2.visuals": "Логотип и фото",
"est2.visualsDesc": "Настройте логотип и обложку этого заведения. Они появляются на его публичной странице и в форме декларации.",
"est2.visualsTitle": "Визуалы — {name}",
"est2.workOn": "Работать над этим заведением",
"est2.working": "Вы работаете над “{name}”",
"ft.backAccount": "Назад к Моему аккаунту",
"ft.closeBtn": "Закрыть дело",
"ft.closeConfirm": "Подтвердить, что предмет был возвращен? Объявление будет закрыто.",
"ft.closeLockedHint": "Сначала подтвердите код владельца, чтобы разблокировать закрытие.",
"ft.closed": "Дело закрыто — предмет возвращен!",
"ft.codeLabel": "Введите код подтверждения, полученный от владельца",
"ft.codeNeeded": "Пожалуйста, введите код подтверждения.",
"ft.codeOk": "Код подтвержден — вы можете закрыть дело.",
"ft.codePlaceholder": "например, 4821",
"ft.codeVerified": "Подтверждено",
"ft.doneMsg": "Предмет возвращен. Спасибо, что помогли вернуть его владельцу!",
"ft.stepInProgress": "Возврат в процессе",
"ft.stepPublished": "Объявление опубликовано",
"ft.stepReturned": "Предмет возвращен",
"ft.subtitle": "Следуйте шагам до тех пор, пока найденный предмет не будет возвращен.",
"ft.title": "Отслеживание возврата",
"ft.verifyBtn": "Подтвердить код",
"inv2.contractTitle": "Мой контракт Findloop",
"inv2.detailByEst": "Детали по заведению",
"inv2.dueLabel": "Срок:",
"inv2.dueSuffix": " · до {date}",
"inv2.error": "Ошибка {status}",
"inv2.estCountIssued": "{n} заведение(я) · выдано {date}",
"inv2.estimate": "Оценка (не взимается) · {n} заведение(я)",
"inv2.expired": " · истек",
"inv2.exportCsv": "Экспорт CSV",
"inv2.exportDone": "CSV экспорт загружен",
"inv2.included": "Включено",
"inv2.monthlyTitle": "Ежемесячная оплата (подписка)",
"inv2.months": "+{n} месяцев",
"inv2.paid": "Оплачено",
"inv2.pay": "Оплатить",
"inv2.previewTitle": "Предварительный просмотр вашего следующего счета —",
"inv2.renew": "Продлить мой контракт",
"inv2.renewalsTitle": "История продлений ({n})",
"inv2.renewedUntil": "Контракт продлён до {date}",
"inv2.serviceTitle": "Счета за услуги (восстановления и предложения)",
"inv2.soon": "Скоро истечёт",
"inv2.toPay": "К оплате",
"inv2.totalHtTva": "Итого без НДС · НДС",
"inv2.totalTtc": "Итого с НДС",
"iu.addPhoto": "Добавить фото",
"iu.change": "Изменить",
"map.high": "Высокий",
"map.legend": "Цветные точки от красного (низкий) до зелёного (высокий) в зависимости от коэффициента возврата; размер зависит от количества предметов.",
"map.locating": "Определение местоположения… добавьте адрес к вашим заведениям, чтобы увидеть их на карте.",
"map.low": "Низкий",
"map.medium": "Средний",
"map.noItemRegistered": "Нет зарегистрированных предметов",
"map.noItems": "Нет предметов",
"map.returnedSuffix": "возвращено · {a}/{t} предметов",
"map.title": "Карта ваших заведений",
"mc.archiveHide": "Скрыть историю",
"mc.archiveNone": "Нет ещё решённых случаев.",
"mc.archiveShow": "Показать историю",
"mc.archiveSub": "Решённые и возвращённые случаи.",
"mc.archiveTitle": "История",
"mc.certificate": "Сертификат",
"mc.finderAccepted": "Принято",
"mc.hAd": "Потерянное объявление",
"mc.hDeclaration": "Декларация",
"mc.hFinderContact": "Сообщенный предмет",
"mc.hFound": "Возвращённый предмет",
"mc.hFoundAd": "Найденное объявление",
"mc.myFinds": "Предметы, которые я нашёл",
"mc.myFindsNone": "Вы пока не сообщили о находке ни одного предмета.",
"mc.myFindsSub": "Предметы, о которых вы сообщили в объявлениях о потерянных вещах.",
"mc.notifOpen": "Просмотреть",
"mc.notifTrack": "Отслеживать",
"mc.notifViewAd": "Просмотреть объявление",
"mc.presentHint": "Покажите этот QR партнёру: они сканируют его, чтобы подтвердить вашу награду.",
"mc.presentInStore": "Показать в магазине",
"mc.presentTitle": "Показать этот ваучер",
"mc2.acceptFinder": "Принять этого находчика",
"mc2.accountActivity": "Активность аккаунта",
"mc2.adsActive": "{n}/5 активных объявлений",
"mc2.autoDelete": "Автоматическое удаление запланировано на",
"mc2.badgeBronze": "Бронзовый",
"mc2.badgeGold": "Золотой",
"mc2.badgeSilver": "Серебряный",
"mc2.boostEarnedAlready": "Он уже принес вам",
"mc2.boostEarnedWin": "Он принес вам",
"mc2.boostExpiredWin": "Ваш бонус только что истек — возобновите с -20%!",
"mc2.boostExpiresIn": "Ваш бонус истечёт через",
"mc2.boostWinDetail2": ". -20% применяется автоматически, если вы продлите в течение 24 часов.",
"mc2.claimCode": "Код подтверждения:",
"mc2.codeSentFinder": "Код отправлен находчику по электронной почте",
"mc2.daysShort": "{n} д",
"mc2.downloadReceipt": "Скачать мой чек",
"mc2.error": "Ошибка {status}",
"mc2.finderAccepted": "Файдер принят — код отправлен по электронной почте",
"mc2.finderContacts": "Контактные данные Файдера(ов)",
"mc2.followFindo": "Подписаться на Findloop",
"mc2.imgInvalid": "Недействительное изображение",
"mc2.inactivityNote": " — в случае {n} месяцев бездействия (GDPR).",
"mc2.lastActivity": "Последняя активность:",
"mc2.lostEmailTitle": "У меня больше нет доступа к моему электронному адресу",
"mc2.noPhotoPreset": "Еще нет фотографии? Выберите аватар по умолчанию:",
"mc2.paidViaPartner": "Оплачено (через партнера)",
"mc2.payRecovery": "Оплатить сбор за восстановление",
"mc2.paySettle": "Уладить мой платеж",
"mc2.payShipping": "Оплатить сбор за доставку",
"mc2.payUnavailable": "Платеж недоступен",
"mc2.peopleFound": "{n} человек(а) думает(ют), что нашли ваш предмет",
"mc2.phoneNumber": "Номер телефона",
"mc2.reactivateAccount": "Восстановить мой аккаунт",
"mc2.reactivated": "Аккаунт восстановлен",
"mc2.reactivatedThanks": "Аккаунт восстановлен — спасибо за вашу лояльность!",
"mc2.recoverSmsBtn": "Получить мой код по SMS",
"mc2.recoverSmsDesc": "Получите код выполнения вашей заявки по SMS на номер, зарегистрированный в вашем аккаунте.",
"mc2.recoverSmsFallback": "Если с этим номером существует аккаунт, SMS было отправлено.",
"mc2.renewStayTop": ". Обновите, чтобы оставаться на вершине и восстановить ваш предмет.",
"mc2.resume20": "Возобновить -20%",
"mc2.unlockContacts": "Разблокировать контактные данные",
"mc2.unlockDesc": "Оплатите сбор за обработку Findloop, чтобы раскрыть их контактные данные и организовать передачу.",
"mc2.viewsWord": "просмотров",
"mc2.live": "Онлайн",
"mh.allCategories": "Все категории",
"mh.allPeriod": "За все время",
"mh.autoMatch": "Авто AI матч",
"mh.blocked": "Заблокировано (противоречие)",
"mh.blockedReason": "Матч заблокирован: основные ключевые слова предмета и декларации противоречат друг другу.",
"mh.days30": "Последние 30 дней",
"mh.days7": "Последние 7 дней",
"mh.days90": "Последние 90 дней",
"mh.emptyDesc": "AI матчи появятся здесь по мере поступления деклараций.",
"mh.emptyTitle": "Нет событий",
"mh.exportCsv": "Экспорт CSV",
"mh.exportDone": "CSV экспорт загружен",
"mh.exportImpossible": "Экспорт не удался",
"mh.fBlocked": "Заблокировано",
"mh.fConfirmed": "Подтверждено",
"mh.fRejected": "Отклонено",
"mh.objectLabel": "Предмет:",
"mh.refresh": "Обновить",
"mh.rejected": "Отклонено",
"mh.srcManual": "Ручной",
"mh.srcText": "Текст",
"mh.srcVisual": "Визуально (фото)",
"mh.subtitle": "Журнал матчей, предложенных AI — авто-сопоставленные, подтвержденные и отклоненные.",
"mh.title": "История AI",
"nf.desc": "Страница, которую вы ищете, не существует или была перемещена.",
"nf.home": "Вернуться на главную",
"nf.title": "Страница не найдена",
"par.allCities": "Все города",
"par.cityPh": "Город",
"pay.eurNote": "Суммы указаны в евро (€).",
"pg.next": "Далее",
"pg.prev": "Назад",
"pg.showing": "{from}–{to} из {total}",
"pk.bodyCopy": "Основной текст",
"pk.bodyText": "Текст тела",
"pk.brandColors": "Цвета бренда",
"pk.colorRed": "Красный",
"pk.colorWhite": "Белый",
"pk.darkBg": "Темный фон",
"pk.download": "Скачать",
"pk.downloadZip": "Скачать весь комплект (ZIP)",
"pk.headings": "Заголовки",
"pk.heroDesc": "Официальные логотипы, баннеры для социальных сетей, цвета и типографика. Выберите язык и вариант слогана, затем загрузите визуал или полный комплект.",
"pk.lightBg": "Светлый фон (печать)",
"pk.logoWordmark": "Логотип / фирменное название",
"pk.logosVisuals": "Логотипы и визуалы",
"pk.mapCollect": "Карта / точки сбора",
"pk.plain": "Простой",
"pk.pressKit": "Пресс-кит",
"pk.taglineLang": "Язык слогана",
"pk.typography": "Типографика",
"pk.variant": "Вариант",
"pr2.adBoostMsg": "Отличный выбор! Вы увеличиваете свои шансы на быстрое восстановление вашего предмета.",
"pr2.boostActivated": "Улучшение активировано!",
"pr2.canRecoverNow": "Теперь вы можете восстановить ваш предмет.",
"pr2.continue": "Продолжить",
"pr2.downloadReceiptPdf": "Скачать receipt (PDF)",
"pr2.goToSpaceNow": "Перейти в мой аккаунт сейчас",
"pr2.partnerBoostMsg": "Отличный выбор! Более высокая видимость помогает привлекать новых клиентов в ваше заведение.",
"pr2.paymentSuccess": "Оплата успешна!",
"pr2.redirectingSpace": "Перенаправление в ваш аккаунт…",
"pr2.subActivated": "Оплата успешна! Ваша подписка активна, теперь вы можете управлять своими заведениями.",
"prev.allSites": "Все заведения",
"pricing.annual": "Годовой",
"pricing.annualBadge": "-20% предложение",
"pricing.monthly": "Ежемесячный",
"pricing.perYear": "/год",
"pricing.saveLabel": "Вы экономите",
"pricing.savePerYear": "/год на каждое дополнительное заведение",
"pub.accessGranted": "Доступ предоставлен",
"pub.accessLimited2h": "Доступ ограничен 2 часами",
"pub.accountEmailConcerned": "Электронная почта затронутого аккаунта",
"pub.adAppearPublic": "Вот как ваше объявление будет отображаться публично.",
"pub.adPreviewBtn": "Предпросмотр объявления",
"pub.alertMeOnArrival": "Уведомите меня о прибытии",
"pub.allActionsLogged": "Все действия зафиксированы",
"pub.allCategories": "Все категории",
"pub.authorizeAccess": "Авторизовать доступ",
"pub.authorizeSupportQ": "Авторизовать доступ к поддержке?",
"pub.available": "Доступно",
"pub.backHome": "Вернуться на главную",
"pub.boostAdCta": "Улучшить мое объявление",
"pub.boostAdTitle": "Улучшить ваше объявление",
"pub.boostCarouselSub": "Переместитесь на верх страницы в карусели «Улучшенные» и увеличьте просмотры, чтобы быстрее восстановить свой предмет.",
"pub.boostEstablishment": "Улучшить ваше заведение",
"pub.boostEstablishmentDesc": "Появляйтесь в верхней части каталога с значком «Улучшенный» и привлекайте больше сообщений.",
"pub.boostFicheCta": "Улучшить мой список",
"pub.brandReady": "Бренд Findloop готов к использованию",
"pub.cantFindItem": "Не удается найти ваш предмет?",
"pub.cantProcessImage": "Не удалось обработать это изображение",
"pub.claimQr": "Забрать QR-код",
"pub.clickToZoom": "Нажмите для увеличения",
"pub.codeAlreadyValidated": "Код подтвержден — контакты разблокированы.",
"pub.codeExample": "например, ABCD2345",
"pub.confirmRenewal": "Подтвердите продление",
"pub.contactIntro": "Вопрос или просьба? Напишите нам, мы скоро ответим.",
"pub.contactTypeDeceased": "Удаление аккаунта (умерший человек)",
"pub.contactTypeGeneral": "Общий вопрос",
"pub.contactTypeSupport": "Поддержка / техническая проблема",
"pub.contactUs": "Связаться с нами",
"pub.continueWithoutEmail": "Продолжить без указания моего email",
"pub.contractLabel": "Контракт",
"pub.contractNotFound": "Контракт не найден или уже истек.",
"pub.contractRenewed": "Контракт продлен!",
"pub.contractRenewedFor": "Ваш контракт продлен на {n} месяцев.",
"pub.copyFailed": "Не удалось скопировать",
"pub.createPartnerAccount": "Создать мой партнерский аккаунт",
"pub.currentDeadline": "Текущий срок",
"pub.deceasedInfo": "Как родственник или наследник, вы можете запросить удаление аккаунта Findloop умершего человека. Мы обработаем ваш запрос в соответствии с GDPR (могут быть запрошены подтверждающие документы).",
"pub.declareMyLoss": "Сообщить о моей утере",
"pub.describeItemPlaceholder": "Опишите ваш предмет (например, черный зонт, ключи…)",
"pub.downloadImage": "Скачать изображение",
"pub.drawSignature": "Пожалуйста, нарисуйте свою подпись.",
"pub.drawSignatureHint": "Нарисуйте свою подпись мышью или пальцем.",
"pub.duration": "Продолжительность",
"pub.eSignature": "Электронная подпись",
"pub.eSignatureDesc": "Введите ваше имя для подписи. Дата фиксируется автоматически.",
"pub.edit": "Редактировать",
"pub.editorialTitles": "Редакционные заголовки",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "Введите код, полученный по электронной почте, для разблокировки контактных данных владельца.",
"pub.errorWord": "Ошибка",
"pub.foundSelfService": "Найденные предметы · Самообслуживание",
"pub.haveOwnerCode": "Я получил код от владельца",
"pub.home": "Главная",
"pub.immediateRenewal": "Немедленное продление, без нового предложения.",
"pub.impAdminReq1": "Администратор",
"pub.impAdminReq2": "запрашивает разрешение на временный доступ к вашему аккаунту",
"pub.impAdminReq3": "чтобы помочь вам.",
"pub.impGrantedDesc": "Команда поддержки сможет получить доступ к вашему аккаунту максимум на 2 часа. Каждое действие будет записано. Вы можете закрыть эту страницу.",
"pub.invitedOnFindo": "Вас пригласили в Findloop",
"pub.isThisYourItem": "Это ваш предмет?",
"pub.itemsAvailableCount": "{n} предмет(ов) в настоящее время доступно",
"pub.itemsFoundOwner": "из доверенных предметов нашли своего владельца",
"pub.itemsReturnedOwners": "предметы возвращены своим владельцам",
"pub.itsMine": "Это мое",
"pub.joinFindoDesc": "Присоединяйтесь к Findloop и управляйте найденными предметами с легкостью.",
"pub.joinInvitesYou": "приглашает вас присоединиться к findloop. Создайте свой партнерский аккаунт, чтобы управлять найденными предметами.",
"pub.linkCopied": "Ссылка скопирована!",
"pub.loadingContract": "Загрузка контракта…",
"pub.lsClaimDesc": "Сообщите о вашей утере, чтобы восстановить его. Оставьте свой email, и мы отправим вам напоминание, если ваш отчет не будет завершен.",
"pub.lsHeroDesc": "Проверьте сами, был ли найден ваш утерянный предмет и оставлен здесь. Нашли? Сообщите, чтобы восстановить его.",
"pub.lsSearchTitle": "Поиск найденных предметов",
"pub.makeOffer": "Сделать предложение",
"pub.makeOfferDesc": "Предложите свою сумму. Суперадминистратор рассмотрит ее.",
"pub.mapNearYou": "Предметы и партнеры рядом с вами",
"pub.mapWord": "Карта",
"pub.messageSentToast": "Сообщение отправлено — наша команда скоро ответит.",
"pub.messageWord": "Сообщение",
"pub.momoInitiated": "Инициирована оплата Mobile Money",
"pub.monthsWord": "месяцев",
"pub.nameConsentRequired": "Требуется имя и согласие.",
"pub.newDeadline": "Новый срок",
"pub.noActionRequired": "Действий не требуется.",
"pub.noAmountCharged": "Не было осуществлено взимание.",
"pub.noItemMatch": "В данный момент нет доступных предметов, соответствующих вашему запросу.",
"pub.noMatchingItem": "Нет подходящего предмета",
"pub.noPaymentSession": "Нет платежной сессии.",
"pub.noPhoto": "Нет фото",
"pub.noPointsYet": "Еще нет баллов для отображения.",
"pub.noSecondPayment": "Для этого предмета нет необходимости во втором платеже.",
"pub.notHereYet": "Еще не здесь? Получите уведомление, как только он прибудет.",
"pub.notifyDone": "Заметили! Мы уведомим вас по электронной почте, как только появится подходящий предмет.",
"pub.offerSubmitted": "Ваше предложение было отправлено.",
"pub.oops": "Упс",
"pub.orAlertEmail": "Или получите уведомление по электронной почте, как только появится подходящий предмет:",
"pub.ownerContacts": "Контактные данные владельца",
"pub.ownerContactsUnlocked": "Контактные данные владельца разблокированы",
"pub.partnerContact": "Контакт партнера",
"pub.payLinkUnavailable": "Ссылка для оплаты недоступна — свяжитесь с партнером.",
"pub.paymentCancelled": "Платеж отменён",
"pub.paymentConfirmed": "Платеж подтверждён 🎉",
"pub.paymentConfirmedDesc": "Вы получите письмо с деталями для получения вашего предмета.",
"pub.paymentNotConfirmed": "Платеж не подтверждён",
"pub.paymentNotConfirmedDesc": "Платеж не может быть подтвержден. Попробуйте снова или свяжитесь с партнером.",
"pub.paymentProcessing": "Платеж обрабатывается. Обновите через минуту.",
"pub.photoAdded": "✓ Фото добавлено",
"pub.photoRequired": "Требуется фото предмета.",
"pub.previewAlt": "предварительный просмотр",
"pub.publish": "Опубликовать",
"pub.publishingWord": "Публикация…",
"pub.qty": "Кол-во",
"pub.quoteDeclined": "Предложение отклонено.",
"pub.quoteNotFound": "Предложение не найдено или истекло.",
"pub.reasonLabel": "Причина",
"pub.recoveryAlreadyPaid": "Плата за восстановление уже оплачена",
"pub.referralCode": "Реферальный код:",
"pub.relationshipPlaceholder": "Сын, супруг, нотариус…",
"pub.renewYourContract": "Продлить контракт",
"pub.renewalFailed": "Продление не удалось. Попробуйте позже.",
"pub.renewing": "Продление…",
"pub.replySoon": "Наша команда ответит как можно скорее.",
"pub.requestGone": "Этот запрос больше не существует.",
"pub.requestHandled": "Запрос уже обработан",
"pub.requestNotFound": "Запрос не найден или истек.",
"pub.requestUnavailable": "Запрос недоступен",
"pub.required": "(обязательно)",
"pub.retroClosing": "Вместе мы делаем мир немного менее потерянным.",
"pub.retroClosing2": "Вместе мы делаем мир немного менее потерянным.",
"pub.retroScroll": "Год восстановления того, что имеет значение. Прокрутите вниз ↓",
"pub.revokeAnytime": "Вы можете отменить в любое время, связавшись с нами",
"pub.scene": "Сцена",
"pub.sendImpossible": "Не удается отправить",
"pub.sendMessage": "Отправить сообщение",
"pub.sending": "Отправка…",
"pub.sharePreview": "Поделиться предварительным просмотром",
"pub.shareYourAd": "Поделиться вашим объявлением",
"pub.signedSuccess": "Успешно подписано!",
"pub.signerFullName": "Полное имя подписавшего",
"pub.spreadNetwork": "Поделитесь этим с окружающими, чтобы увеличить ваши шансы.",
"pub.spreadOwner": "Поделитесь этим, чтобы помочь владельцу вернуть свои вещи.",
"pub.statusLabel": "Статус:",
"pub.subject": "Тема",
"pub.thanksSent": "Спасибо, ваше сообщение было отправлено.",
"pub.thisYear": "Этот год",
"pub.validate": "Подтвердить",
"pub.verifyingPayment": "Проверка платежа…",
"pub.verifyingYourPayment": "Проверка вашего платежа…",
"pub.viewAd": "Просмотреть объявление →",
"pub.viewPartner": "Просмотреть партнера →",
"pub.yourAdPreview": "Предварительный просмотр вашего объявления",
"pub.yourEmail": "Ваш email",
"pub.yourEmailRecommended": "Ваш email (рекомендуется)",
"pub.yourEmailShort": "Ваш email",
"pub.yourName": "Ваше имя",
"pub.yourRelationship": "Ваши отношения с человеком",
"qv.acceptAndSign": "Принять и подписать мое предложение",
"qv.certifyAuthorized": "Я подтверждаю, что я уполномочен подписывать и принимаю условия этого {what} (обязательная стоимость).",
"qv.clear": "Очистить",
"qv.client": "Клиент",
"qv.conditions": "Условия",
"qv.confirmDecline": "Подтвердить отказ от этого предложения?",
"qv.countersignedFindo": "Подписано Findloop · {name} {date}",
"qv.decline": "Отказаться",
"qv.description": "Описание",
"qv.downloadPdf": "Скачать PDF",
"qv.handwrittenSignature": "Ручная подпись",
"qv.inclTax": "С учетом налога",
"qv.invalidAmount": "Некорректная сумма.",
"qv.invoice": "Счет",
"qv.invoicePaid": "Счет оплачен",
"qv.issuer": "Эмитент",
"qv.messageOptional": "Сообщение (необязательно)",
"qv.negotiatedAmount": "Согласованная сумма",
"qv.payInvoiceOnline": "Оплатить счет онлайн",
"qv.quote": "Предложение",
"qv.quoteValidDays": "Предложение действительно {n} дней.",
"qv.sendMyOffer": "Отправить мое предложение",
"qv.signContract": "Подписать мой контракт",
"qv.signNow": "Подписать сейчас",
"qv.signatureAlt": "Подпись",
"qv.signedByOn": "✔ Подписано {name} {date}",
"qv.stContractSigned": "Контракт подписан. Спасибо!",
"qv.stCounterAccepted": "Ваше предложение было принято! Подпишите свой контракт ниже.",
"qv.stCounterRefused": "Ваше предложение не было принято.",
"qv.stCountered": "Ваше предложение отправлено. Ожидание ответа от findloop.",
"qv.stDeclined": "Вы отклонили это предложение.",
"qv.stSigned": "Предложение принято и подписано. Спасибо!",
"qv.totalHt": "Итого без НДС",
"qv.totalTtc": "Итого с НДС",
"qv.unitHt": "Единица без НДС",
"qv.vat": "НДС",
"qv.yourProposedAmount": "Ваша предложенная сумма ({cur})",
"reg.add": "Зарегистрировать предмет",
"reg.allBrands": "Все бренды",
"reg.allColors": "Все цвета",
"reg.allLocations": "Все локации",
"reg.detailDesc": "Детали и действия для этого найденного предмета.",
"reg.dispAuction": "Аукцион",
"reg.dispAuthorities": "Передано властям",
"reg.dispDestroyed": "Уничтожено",
"reg.dispDonate": "Благотворительная пожертвование",
"reg.dispositionHint": "Запишите предмет, покидающий хранение. Учитывается в статистике по категориям.",
"reg.emptyCta": "Зарегистрировать предмет",
"reg.emptyDesc": "Начните с записи первого найденного предмета.",
"reg.emptyTitle": "Нет найденных предметов",
"reg.establishmentFallback": "учреждение",
"reg.lblAuctioned": "выставлено на аукцион",
"reg.lblAuctionedShort": "аукцион",
"reg.lblAuthorities": "передано властям",
"reg.lblDestroyed": "уничтожено",
"reg.lblDonated": "подарено благотворительной организации",
"reg.legalCount": "{n} предмет(ов): достигнут законный срок хранения",
"reg.legalHint": "Вы можете выставить их на аукцион, подарить благотворительной организации или сообщить о передаче властям.",
"reg.legalLimitCountry": "Срок: {date} · применяемая страна: {country}",
"reg.legalOver": "Срок истек: {date} · {country}",
"reg.legalReached": "Достигнут законный срок",
"reg.legalReachedFull": "Достигнут законный срок хранения",
"reg.limitShort": "срок",
"reg.location": "Местоположение",
"reg.markRestituted": "Отметить как возвращенный",
"reg.markedAs": "Предмет отмечен как {label}",
"reg.moveHistory": "История перемещений",
"reg.overBy": "более чем на {n} дн.",
"reg.physicalLocation": "Физическое местоположение",
"reg.popupBlocked": "Разрешите всплывающие окна для печати этикеток.",
"reg.popupBlockedOne": "Разрешите всплывающее окно для печати этикетки.",
"reg.printLabel": "Напечатать этикетку",
"reg.printN": "Напечатать {n} этикеток",
"reg.qrCodeItem": "QR-код предмета",
"reg.qrLabelTitle": "QR-этикетка",
"reg.qrLabelsTitle": "QR-этикетки",
"reg.qrNotFound": "Нет найденного предмета для этого QR-кода.",
"reg.qrScanHint": "Сканируйте его для быстрого доступа к этой записи и нахождения местоположения.",
"reg.recoveryFee": "Плата за восстановление (€)",
"reg.searchPh": "Поиск по описанию…",
"reg.selectQr": "Выберите для печати QR-этикеток",
"reg.selectedN": "{n} выбрано",
"reg.shipPricePh": "Цена доставки (€)",
"reg.shippingPossible": "Доставка доступна",
"reg.storagePh": "например, Полка A3, Ячейка 12",
"reg.tAuction": "Аукцион на Findloop",
"reg.tAuthorities": "Сообщить о передаче властям",
"reg.tDonate": "Подарить благотворительной организации",
"reg.toastFee": "Плата обновлена",
"reg.toastLocation": "Местоположение сохранено",
"reg.toastRestituted": "Предмет отмечен как возвращенный",
"reg.toastShipping": "Опция доставки обновлена",
"reg.toastTransferred": "Предмет передан «{name}»",
"reg.unclaimedDisposition": "Не востребованный предмет — финальная судьба",
"res.codeValidated": "Код подтвержден",
"res.empty": "Еще нет записей о возвращении.",
"res.error": "Ошибка {status}",
"res.proofPdf": "PDF-доказательство",
"res.signed": "Подписано",
"res.stRestituted": "Передано лично",
"res.stShipped": "Возвращено по доставке",
"res.subtitle": "Все завершенные передачи с их подписанными доказательствами для загрузки.",
"res.title": "История возвращения",
"rev.restitutedBy": "Возвращено {org}",
"rev.storiesEyebrow": "Счастливые истории",
"rev.storiesSubtitle": "Настоящие истории клиентов, которые вернули свои вещи с помощью findloop.",
"rev.storiesTitle": "Они нашли свои вещи!",
"rp.already": "Вы уже сообщили об этом лоте.",
"rp.duplicate": "Дубликат",
"rp.inappropriate": "Неподобающий контент",
"rp.wrongCategory": "Неверная категория",
"rt.annualGoal": "Годовая цель",
"rt.championCity": "Город-чемпион",
"rt.cityRate": "{rate}% уровень возврата",
"rt.goalProgress": "{rate}% достигнуто из {target}% цели",
"rt.reached": "Достигнуто 🎉",
"rt.restitutionRate": "Уровень возврата",
"rt.shareRecap": "Поделиться моим итогом",
"rt.thanks": "Спасибо Findloop {year} 💛",
"rt.yourRecap": "Ваш итог за {year}",
"rw.active": "Активно",
"rw.add": "Добавить",
"rw.camUnavailable": "Камера недоступна. Введите код вручную ниже.",
"rw.codeValidated": "Код подтвержден",
"rw.codesTitle": "Коды, которые использовали искатели",
"rw.confirmDelete": "Удалить “{title}”?",
"rw.deleted": "Удалено",
"rw.edit": "Редактировать",
"rw.editReward": "Редактировать награду",
"rw.empty": "Награды пока нет.",
"rw.expired": "Истекший",
"rw.expiresOn": "Истекает {date}",
"rw.fActive": "Активно (видно искателям)",
"rw.fCost": "Стоимость (баллы)",
"rw.fDesc": "Описание",
"rw.fStock": "Запас (пусто = неограниченно)",
"rw.fTitle": "Название",
"rw.fValidity": "Срок действия ваучера (дни после получения)",
"rw.inactive": "Неактивно",
"rw.newReward": "Новая награда",
"rw.noExchange": "Обмена еще нет.",
"rw.pageSubtitle": "Сканируйте ваучеры, представленные искателями, чтобы подтвердить их награды.",
"rw.redeemedN": "Погашено: {n}×",
"rw.saved": "Награда сохранена",
"rw.scanVoucher": "Сканировать ваучер",
"rw.staffScanOnly": "Сканировать только",
"rw.statActive": "Для представления",
"rw.statExpired": "Истекший",
"rw.statRedeemed": "Ваучеры погашены",
"rw.statUsed": "Подтверждено",
"rw.stock": "Запас",
"rw.subtitle": "Предлагайте немонетарные привилегии (ваучеры, улучшения…) которые искатели обменивают на свои баллы Finder Score.",
"rw.title": "Награды для искателей",
"rw.used": "Использовано",
"rw.validate": "Подтвердить",
"rw.validateCode": "Подтвердить код",
"rw.validity": "Срок действия: {n} д",
"side.establishments": "Учреждения",
"side.restitutions": "Возвраты",
"side.rewards": "Награды и ваучеры",
"side.settings": "Настройки",
"side.storage": "Хранение и QR",
"status.auctioned": "На аукционе",
"status.destroyed": "Уничтожено",
"status.donated": "Пожертвовано (благотворительность)",
"status.handed_to_authorities": "Передано властям",
"status.in_storage": "На складе",
"status.matched": "Совпадение",
"status.open": "Открыто",
"status.paid": "Оплачено",
"status.pending": "В ожидании",
"status.restituted": "Возвращено",
"status.shipped": "Отправлено",
"status.shipping_requested": "Запрос на отправку",
"status.submitted": "Отправлено",
"stg.allLabels": "Все QR-метки",
"stg.camHint": "Используйте ручной ввод ниже.",
"stg.camStarting": "Запуск камеры…",
"stg.camUnavailable": "Камера недоступна.",
"stg.clear": "Очистить",
"stg.clearAll": "Очистить все",
"stg.codeUnreadable": "Код неразборчив.",
"stg.emptyDesc": "Здесь появятся сохраненные предметы, сгруппированные по местоположению.",
"stg.emptyTitle": "Нет предметов в хранилище",
"stg.exportAudit": "Экспортировать CSV аудит",
"stg.exportDone": "CSV экспорт загружен",
"stg.exportImpossible": "Экспорт в данный момент недоступен.",
"stg.itemFound": "Предмет найден ✅",
"stg.kLocations": "Используемые места",
"stg.kObjects": "Сохраненные предметы",
"stg.kToClear": "Места для очистки",
"stg.locFreed": "Место очищено",
"stg.locsFreed": "{n} место(а) очищено",
"stg.manualLabel": "Или введите код / ID предмета",
"stg.manualPh": "Вставьте ID или URL QR",
"stg.noItemMatch": "Нет соответствия этому QR / коду.",
"stg.noLocation": "Нет места",
"stg.objectsAxis": "Предметы",
"stg.objectsN": "{n} предмет(ов)",
"stg.occAvg": "в среднем {n} предметов/место",
"stg.occHint": "Места в желтом превышают среднее значение (возможно, перегружены).",
"stg.occupancy": "Занятость места",
"stg.openPage": "Открыть страницу",
"stg.posterPdf": "PDF постер (A4)",
"stg.printAll": "Напечатать все",
"stg.printGroupTitle": "Напечатать метки для этой полки",
"stg.qrAlt": "QR-самообслуживание",
"stg.qrDownload": "Скачать QR",
"stg.qrHint": "Отображайте этот QR на стойке: ваши клиенты сканируют его, чтобы проверить, доступен ли их предмет.",
"stg.qrTitle": "QR самообслуживания для клиентов",
"stg.scanDesc": "Сканируйте метку предмета, чтобы мгновенно открыть его запись.",
"stg.scanQr": "Сканировать QR",
"stg.scanTitle": "Сканировать QR-код",
"stg.search": "Поиск",
"stg.shelf": "Полка {loc}",
"stg.shelfPlan": "План полки",
"stg.staleHint": "Очистите эти места, чтобы поддерживать физический инвентаризационный учет в актуальном состоянии.",
"stg.staleTitle": "{n} предмет(ов) покинули хранилище, но все еще занимают место",
"stg.subtitle": "План полки, сканер QR и отслеживание физического инвентаря.",
"stg.title": "Хранение & QR",
"stt.acceptRate": "Уровень принятия",
"stt.accepted": "Принято",
"stt.activity30": "Активность (последние 30 дней)",
"stt.ai6mo": "Последние 6 месяцев · принято = автоматически сопоставлено + подтверждено.",
"stt.aiEmpty": "За этот период пока нет совпадений ИИ.",
"stt.aiTitle": "Совпадения ИИ — принято против отклонено",
"stt.auctionShort": "Аукцион",
"stt.auctionedSold": "Аукцион (продано)",
"stt.authShort": "Власти",
"stt.authorities": "Передано властям",
"stt.avgRating": "Средний рейтинг",
"stt.awaitingRestitution": "товары ожидают возврата",
"stt.boostClicks": "Клики по вашему каталогу на этой неделе благодаря продвижению",
"stt.boostInactive": "Продвижение не активно — включите его для повышения видимости",
"stt.certifiedPremium": "Премиум сертифицированный",
"stt.declarations": "Декларации",
"stt.destroyed": "Уничтожено",
"stt.dispoEmpty": "Не осталось незабранных товаров на складе.",
"stt.donatedAssoc": "Пожертвовано (благотворительность)",
"stt.donatedShort": "Пожертвовано",
"stt.gateCta": "Ознакомьтесь с планами",
"stt.gateDesc": "Обновите до Starter, чтобы разблокировать базовую статистику, или до Business для расширенной статистики и анализа по каждому объекту.",
"stt.gateTitle": "Статистика доступна только для платных планов",
"stt.inStorage": "На складе",
"stt.kItems": "Зарегистрированные товары",
"stt.kRate": "Уровень возврата",
"stt.kRestituted": "Возвращенные товары",
"stt.kRevenue": "Выручка (месяц)",
"stt.noDeclYet": "Пока нет деклараций.",
"stt.recapDownloaded": "Резюме загружено — готово к分享！",
"stt.recapError": "Не удалось сгенерировать резюме",
"stt.recapText": "Наше резюме Findloop за {year}: возвращенные товары и удовлетворенность клиентов 🎉",
"stt.recapTitle": "Резюме Findloop за {year}",
"stt.rejected": "Отклонено",
"stt.restitutions": "Возвраты",
"stt.shareRecap": "Поделиться моим резюме за {year}",
"stt.topCategories": "Наиболее заявленные категории",
"stt.unclaimedDesc": "Объем уничтоженных товаров, пожертвованных на благотворительность и выставленных на аукцион, по категориям.",
"stt.unclaimedTitle": "Незабранные товары — покидающие склад",
"stt.vsLastWeek": "по сравнению с прошлой неделей",
"sub.cancel": "Отменить мою подписку",
"sub.cancelAbort": "Отмена",
"sub.cancelConfirm1": "Вы уверены, что хотите отменить? Ваш доступ останется активным до",
"sub.cancelConfirm2": "Возврат средств не будет произведен.",
"sub.cancelConfirmBtn": "Подтвердить отмену",
"sub.cancelTitle": "Отменить подписку",
"sub.cancelledToast": "Отмена записана.",
"sub.cguAnd": "и",
"sub.cguDesc": "Пожалуйста, подтвердите свое согласие перед оплатой.",
"sub.cguLink": "Условия использования",
"sub.cguPay": "Продолжить к оплате",
"sub.cguPre": "Я прочитал и принимаю",
"sub.cguRequired": "Вы должны принять Условия использования и Политику конфиденциальности, чтобы продолжить.",
"sub.cguSuffix": "Findloop.",
"sub.cguTitle": "Завершите свою подписку",
"sub.expiresOn": "Ваша подписка истекает",
"sub.noProrata": "Без пропорционального возврата.",
"sub.privacyLink": "Политика конфиденциальности",
"sub.renewsOn": "Ваша подписка обновляется",
"sub.resume": "Подписаться заново",
"sub.resumedToast": "Подписка подтверждена.",
"tier.free": "Бесплатный",
"tier.large": "Корпоративный",
"tier.medium": "Бизнес",
"tier.small": "Стартовый",
"tm.add": "Добавить",
"tm.adminOpt": "Администратор (полный доступ)",
"tm.chooseEst": "Выберите заведение",
"tm.chooseEstPh": "Выберите заведение",
"tm.copyFail": "Копирование не удалось",
"tm.copyLink": "Скопировать ссылку",
"tm.copyOk": "Ссылка приглашения скопирована",
"tm.emailHint": "На указанный адрес электронной почты будет отправлено приглашение для создания пароля.",
"tm.expiresOn": "истекает {date}",
"tm.forEmail": " для {email}",
"tm.forbidden": "Управление командой доступно только владельцу аккаунта.",
"tm.inviteCreated": "Приглашение создано",
"tm.inviteDesc": "Приглашение по электронной почте позволяет участнику создать свой пароль.",
"tm.invitePending": "Приглашение в ожидании",
"tm.inviteResent": "Приглашение повторно отправлено",
"tm.inviteSent": "Приглашение отправлено по электронной почте",
"tm.inviteTitle": "Пригласить участника",
"tm.invitedOn": "Приглашен {date}",
"tm.linkExpired": "Ссылка просрочена",
"tm.memberRemoved": "Участник удалён",
"tm.name": "Имя",
"tm.noMembers": "Пока нет участников.",
"tm.resendTitle": "Повторно отправить приглашение",
"tm.role": "Роль",
"tm.roleAdmin": "Администратор",
"tm.roleOwner": "Владелец",
"tm.roleStaff": "Сотрудник",
"tm.roleUpdated": "Роль обновлена",
"tm.sendInvite": "Отправить приглашение",
"tm.sending": "Отправка…",
"tm.staffOpt": "Сотрудник (видит только своё заведение)",
"trk.carrier": "Перевозчик",
"trk.shipPending": "Отправка готовится — номер отслеживания появится здесь после отправки.",
"trk.shipTitle": "Отслеживание отправления",
"trk.trackShipment": "Отследить посылку",
"trk.trackingNo": "Номер отслеживания",
"a.firstName": "Имя",
"ac.emailCrossMatch": "B2C совпадения",
"ac.emailCrossMatchDesc": "Уведомление по электронной почте, когда публичное объявление о потерянном предмете совпадает с предметом, оставленным у вас",
"ac.emailCrossReject": "Отказ в публичных совпадениях",
"ac.emailCrossRejectDesc": "Получите уведомление по электронной почте, когда клиент укажет, что предложенное публичное совпадение не является его предметом.",
"ac.emailLoginNotif": "Уведомление о входе",
"ac.emailLoginNotifDesc": "Получайте письма каждый раз, когда кто-то входит в ваш аккаунт.",
"ad.closeNoCancel": "Нет, убрать объявление",
"ad.closeQuestion": "Предмет был возвращен вам?",
"ad.closeQuestionDesc": "Сообщите нам, восстановили ли вы свой предмет или просто хотите убрать это объявление.",
"ad.closeYesRestituted": "Да, предмет был возвращен",
"ad.closedRestituted": "Предмет возвращен — объявление закрыто 🎉",
"an.lostLoginDesc": "Для сообщения о потерянном предмете требуется аккаунт.",
"an.lostLoginRequired": "Войдите, чтобы сообщить о потерянном предмете",
"an.qfAll": "Все",
"an.qfBoosted": "Популярные",
"an.qfPhoto": "С фото",
"an.qfRecent": "На этой неделе",
"an.qfResolved": "Решено",
"an.restitutionInProgress": "Предмет возвращается",
"dec.descPhLong": "Опишите предмет: бренд, цвет, отличительные знаки... (Чем больше подробностей, тем выше шансы вернуть ваш предмет)",
"dec.loadError": "Не удалось загрузить партнера в данный момент. Проверьте соединение и попробуйте снова.",
"dec.retry": "Повторить",
"dec.shippingMode": "Доставка",
"dep.photo2": "Фото 2-го предмета",
"dep.photo2Hint": "Необязательно — другой угол улучшает точность визуального совпадения.",
"dl.accountSuspended": "Аккаунт приостановлен из-за неоплаченного счета. Оплатите его, чтобы восстановить доступ.",
"dl.regularize": "Оплатить сейчас →",
"dl.suspensionCountdown": "Счет {num} неоплачен — ваш аккаунт будет приостановлен через {days} день(ей). Оплатите, чтобы избежать этого.",
"ft.cancelConfirm": "Отменить ваш отчет? Владельцу предмета будет сообщено.",
"ft.cancelDone": "Отчет отменен.",
"ft.cancelLocked": "Отмена больше невозможна после того, как владелец оплатил.",
"ft.cancelReport": "Отменить мой отчет",
"ft.claimCodeHelp": "Передайте этот код находчику при передаче, чтобы подтвердить, что вы получили ваш предмет.",
"ft.claimCodeTitle": "Ваш код возврата",
"ft.claimDone": "Предмет возвращен. Спасибо, что воспользовались Findloop!",
"ft.claimUnlockHint": "Разблокируйте контактные данные находчика",
"ft.claimUnlockHintSub": "Перейдите в «Предметы, которые я требую» в вашем аккаунте, чтобы оплатить сбор и получить контактные данные.",
"ft.finderCodeShownHelp": "Владелец оплатил и выбрал вас. Скопируйте этот код ниже, чтобы подтвердить возврат — нет необходимости проверять почту.",
"ft.finderCodeShownTitle": "Код проверки владельца",
"ft.finderContactsTitle": "Контактные данные Finder",
"ft.foundCodeHelp": "Покажите этот код владельцу при передаче, чтобы подтвердить возврат предмета.",
"ft.inProgressOther": "Возвращаемый предмет",
"ft.inProgressOtherHelp": "Владелец выбрал другого находящего для этого предмета. Действий с вашей стороны не требуется.",
"ft.restitutionCodeHelp": "Этот код подтверждает передачу предмета. Он уже предзаполнен ниже; проверьте его, затем закройте дело.",
"ft.restitutionCodeTitle": "Ваш код возврата",
"hc.14Digits": "14 цифр",
"hc.15DaysBeforeAnItem": "15 дней до законного срока предмета.",
"hc.7DaysBeforeAnItem": "7 дней до законного срока предмета.",
"hc.8CharactersMinimum": "Минимум 8 символов.",
"hc.aClaimToValidate": "Запрос на проверку",
"hc.aFindoAssistanceSessionIs": "Сессия помощи Findloop в настоящее время активна на вашем аккаунте.",
"hc.aNewMatchHasBeen": "Найдено новое совпадение",
"hc.aUser": "Пользователь",
"hc.aUserClaimsToBe": "Пользователь утверждает, что он владелец. Проверьте его ответы перед авторизацией возврата.",
"hc.aboutFindo": "О Findloop",
"hc.accountActivatedPleaseLogIn": "Аккаунт активирован, пожалуйста, войдите в систему.",
"hc.accountActivation": "Активация аккаунта",
"hc.accountCreated": "Аккаунт создан!",
"hc.accountDeactivatedAReactivationEmail": "Аккаунт деактивирован. Вам на электронную почту отправлено письмо о реактивации (действительно 30 дней).",
"hc.accountReactivation": "Реактивация аккаунта",
"hc.activateMyAccount": "Активировать мой аккаунт",
"hc.activateMyAdminAccount": "Активировать мой административный аккаунт",
"hc.activating": "Активация…",
"hc.activeMatchCancelReason": "Активное совпадение. Причина отмены клиента: \"{reason}\". Предмет все еще ожидает запроса.",
"hc.activeMatchWithAPublic": "Активное совпадение с публичным (клиентским) списком. Ожидание запроса владельца.",
"hc.addAPhoto": "Добавить фото",
"hc.addAndConfigureYourEstablishments": "Добавьте и настройте свои заведения в разделе \"Заведения\": контактные данные, категория и физическое хранение предметов.",
"hc.addOnGoogle": "Добавить в Google",
"hc.address": "Адрес",
"hc.addressSaved": "Адрес сохранен",
"hc.addressStreet": "Адрес — Улица",
"hc.adjustThePhoto": "Отредактировать фото",
"hc.adminFullView": "Администратор (полный доступ)",
"hc.administratorOnly": "Только для администратора",
"hc.africa": "Африка",
"hc.aiVisualComparison": "AI визуальное сравнение",
"hc.all": "Все",
"hc.amount": "Сумма",
"hc.anOrganization": "Организация",
"hc.analyzing": "Анализ…",
"hc.andRecoveryIs": "и восстановление",
"hc.andTheDeclarationWillBe": "и декларация будет закрыта (перенесена в историю). Это действие окончательное.",
"hc.annual20": "Годовой -20%",
"hc.annualBilling20": "Годовая оплата (−20%)",
"hc.annualTarget": "Годовая цель",
"hc.anyCommentsOptional": "Любые комментарии? (по желанию)",
"hc.approveTheClaim": "Одобрить заявление",
"hc.archiveCancelledConfirm": "Архивировать {n} объявление(я) \"Отменено заказчиком\"? Они будут удалены из реестра.",
"hc.asSoonAs": "Как только",
"hc.askTheOwnerToDisplay": "Попросите владельца отобразить QR-код своего кода (страница отслеживания).",
"hc.askThemAtTheCounter": "Спросите их на стойке для подтверждения личности — никогда не будет публично доступно.",
"hc.assistance": "Поддержка",
"hc.assistanceSessionRevoked": "Сессия поддержки отменена.",
"hc.atLeast6Characters": "Не менее 6 символов",
"hc.automaticallyPreSelected": "автоматически предвыбрано",
"hc.automaticallyWhenShipping": "автоматически при отправке.",
"hc.awaitingClaim": "Ожидание претензии",
"hc.awaitingPayment": "Ожидание платежа",
"hc.b2cCustomer": "B2C клиент",
"hc.back": "Назад",
"hc.backToHome": "Вернуться на главную",
"hc.backToMyAccount": "Вернуться в мой аккаунт",
"hc.backToPayment": "Вернуться к платежу",
"hc.beforeAfterComparisonSlider": "Слайдер сравнения до/после",
"hc.billingInformation": "Платежная информация",
"hc.billingInformationSaved": "Платежная информация сохранена ✓",
"hc.brand": "Бренд",
"hc.bronze": "Бронза",
"hc.calculatingTheShippingRate": "Расчет тарифов на доставку…",
"hc.cameraUnavailableEnterTheCode": "Камера недоступна. Введите код вручную.",
"hc.cancel": "Отменить",
"hc.cancelMyDeclaration": "Отменить мою декларацию",
"hc.cancelSavedFmt": "Отмена сохранена: \"{reason}\". Вы все еще можете подать претензию.",
"hc.cancelTheDeposit": "Отменить депозит",
"hc.cancelThisMatch": "Отменить это совпадение",
"hc.cancellationReason": "Причина отмены",
"hc.cancelled": "Отменено",
"hc.cancelledByTheCustomer": "Отменено заказчиком",
"hc.cannotOpenPayment": "Не удалось открыть платеж. Пожалуйста, попробуйте еще раз.",
"hc.careers": "Карьеры",
"hc.carrier": "Перевозчик",
"hc.carrierAvailabilityCannotBeChecked": "Доступность перевозчика нельзя проверить, пока ваш отправитель Sendcloud не настроен.",
"hc.carrierConfirmedCharged": "Перевозчик подтвержден — {price} € списано с клиента",
"hc.carrierOther": "Перевозчик (другой)",
"hc.carrierSelection": "Выбор перевозчика",
"hc.caseClosedThankYou": "Дело закрыто. Спасибо!",
"hc.category": "Категория",
"hc.changeMethod": "Сменить метод",
"hc.characteristic": "Характеристика",
"hc.chargedToCustomer": "списано с клиента.",
"hc.checkOrEditYourDetails": "Проверьте или измените свои данные перед безопасной оплатой.",
"hc.checkStatisticsToTrackDeposited": "Проверьте «Статистику», чтобы отслеживать внесенные предметы, уровень возвратов и эффективность каждого заведения.",
"hc.checkTheDetailsBeforeContacting": "Проверьте детали перед обращением к находчику.",
"hc.checkTheDetailsBelowBefore": "Проверьте данные ниже перед началом запроса на возврат.",
"hc.checkTheNewItem": "Проверьте новый элемент",
"hc.checkThePhotosAndCharacteristics": "Проверьте фотографии и характеристики ниже перед продолжением восстановления.",
"hc.chooseACountry": "Выберите страну",
"hc.chooseANewPassword": "Выберите новый пароль",
"hc.chooseAReason": "Выберите причину",
"hc.chooseTheLegalRetentionAlerts": "Выберите юридические уведомления о хранении, получаемые по электронной почте для",
"hc.chooseYourPasswordToAccess": "Выберите пароль для доступа к административной консоли.",
"hc.city": "Город",
"hc.claimApproved": "Запрос одобрен",
"hc.claimApproved2": "Запрос одобрен.",
"hc.claimCodeExpired": "Срок действия кода запроса истек",
"hc.claimCodeVerified": "Код запроса подтвержден",
"hc.claimNotFound": "Запрос не найден",
"hc.claimNotValidated": "Запрос не подтвержден",
"hc.claimRejected": "Запрос отклонен",
"hc.claimRejected2": "Запрос отклонен.",
"hc.claimValidated": "Запрос подтвержден",
"hc.claimValidatedByThePartner": "Запрос подтвержден партнером",
"hc.claimant": "Истец",
"hc.claimsToBeTheOwner": "информирует, что является владельцем этого предмета и ответил на вопросы проверки. Одобрите только если ответы совпадают.",
"hc.claimsToValidate": "Запросы на подтверждение",
"hc.clear": "Очистить",
"hc.clickToZoom": "Нажмите для увеличения",
"hc.close": "Закрыть",
"hc.close2": "Закрыть",
"hc.closeTheDeclaration": "Закрыть декларацию",
"hc.closeTheDeclaration2": "Закрыть декларацию?",
"hc.codeAlreadyVerified": "Код уже подтвержден",
"hc.codeCopied": "Код скопирован",
"hc.collapse": "Свернуть",
"hc.color": "Цвет",
"hc.company": "Компания",
"hc.companyName": "Название компании",
"hc.comparePhotos": "Сравнить фотографии",
"hc.compareThemWithTheOwner": "Сравните их с ответами владельца — никогда не будет опубликовано.",
"hc.condition": "Состояние",
"hc.confirmAndPay": "Подтвердить и оплатить",
"hc.confirmCancellation": "Подтвердить отмену",
"hc.confirmCrop": "Подтвердить обрезку",
"hc.confirmDeletion": "Подтвердить удаление",
"hc.confirmPassword": "Подтвердить пароль",
"hc.confirmThatThisIsYour": "Подтвердите, что это ваш предмет. Перед любым контактом потребуется проверка личности у найденщика.",
"hc.confirmTheCarrier": "Подтвердите перевозчика",
"hc.confirmThePassword": "Подтвердите пароль",
"hc.confirmYourShippingAddressTo": "Подтвердите ваш адрес доставки, чтобы продолжить оплату.",
"hc.confirmYourSubscription": "Подтвердите вашу подписку",
"hc.confirmed": "Подтверждено ✓",
"hc.contactFindoToGetYour": "Свяжитесь с Findloop, чтобы получить ваш идентификатор отправителя.",
"hc.contactUs": "Связаться с нами",
"hc.continueTheReturn": "Продолжить возврат",
"hc.continueToPayment": "Продолжить к оплате",
"hc.copy": "Копировать",
"hc.correctMyDetails": "исправить мои данные",
"hc.correctThisEntry": "Исправить эту запись?",
"hc.country": "Страна",
"hc.countryAddress": "Страна (адрес)",
"hc.countryIsoCodeEG": "Страна (ISO код, напр., FR)",
"hc.cover": "обложка",
"hc.createTheShipment": "Создать отправление",
"hc.cropThePhoto": "Обрезать фотографию",
"hc.customer": "Клиент",
"hc.customerClaimCodeToCheck": "Код претензии клиента — для проверки при получении:",
"hc.customerReasonFmt": "Причина клиента: \"{reason}\".",
"hc.customerReminderDelay": "Задержка напоминания клиенту",
"hc.customerWhosePublicListingMatches": "Клиент, чье публичное объявление совпадает с этим предметом — видно только вам.",
"hc.d15": "Д-15",
"hc.dangerZone": "Опасная зона",
"hc.date": "Дата",
"hc.dateNewest": "Дата (новейшая)",
"hc.dateOldest": "Дата (старейшая)",
"hc.daysToYearEnd": "{n} дней до конца года",
"hc.deadlineAlert": "Сигнал о дедлайне",
"hc.declarationClosed": "Декларация закрыта ✓",
"hc.declarationNotFound": "Декларация не найдена.",
"hc.declarationNotFound2": "Декларация не найдена",
"hc.declarationTracking": "Отслеживание декларации",
"hc.defaultCarrier": "Поставщик по умолчанию",
"hc.defaultCarrierPreselected": "Поставщик по умолчанию предустановлен — его можно изменить для этой отправки. Актуальная ставка (Sendcloud + {m}% наценка).",
"hc.defaultCarrierRemoved": "Поставщик по умолчанию удалён",
"hc.delayHours": "Задержка (часы)",
"hc.deleteMyAccount": "Удалить мой аккаунт",
"hc.deleting": "Удаление…",
"hc.deletingDeactivatesYourAccountLogin": "Удаление деактивирует ваш аккаунт: вход заблокирован, а данные хранятся в течение 30 дней. Вы получите электронное письмо со ссылкой на реактивацию, действительной в течение 30 дней.",
"hc.delivered": "Доставлено",
"hc.depositAnItem": "Сдать вещь",
"hc.depositCancelledItemPutBack": "Сдача отменена — вещь возвращена на склад.",
"hc.depositCancelledItemRemovedFrom": "Сдача отменена — вещь удалена из реестра.",
"hc.depositedOn": "Сдано",
"hc.describeTheItemBrandColor": "Опишите вещь: бренд, цвет, отличительные знаки… (Чем больше деталей вы укажете, тем лучше ваши шансы найти свою вещь)",
"hc.dimensionsCm": "Размеры (см)",
"hc.disablingAnEmail": "Отключение электронной почты",
"hc.doesNotHide": "не скрывает",
"hc.download": "Скачать",
"hc.downloadThePdf": "Скачать PDF",
"hc.draftRestoredPickUpYour": "Черновик восстановлен — заберите свою декларацию с того места, где вы остановились.",
"hc.dragToReposition": "Перетащите для изменения положения",
"hc.eGColisPriv": "Например, Colis Privé",
"hc.eachItemGetsAQr": "Каждая вещь получает QR-метку. Отсканируйте её из \"Хранилище & QR\", чтобы быстро найти вещь.",
"hc.eachSiteManagesItsOwn": "Каждый сайт управляет своим банковским обслуживанием. Перейдите к",
"hc.edit": "Редактировать",
"hc.emailNotificationPreferences": "Предпочтения уведомлений по электронной почте",
"hc.emailPreferencesUpdated": "Предпочтения электронной почты обновлены",
"hc.enableOrDisableRecoveryFees": "Включить или отключить сборы за восстановление для",
"hc.enlargePhoto": "Увеличить фото",
"hc.enterTheCustomerSCode": "Введите код клиента",
"hc.estShipRate": "Оценочная стоимость доставки (Sendcloud + {m}% наценка):",
"hc.establishment": "Учреждение",
"hc.establishment2": "Учреждение:",
"hc.establishmentInItsSendcloudAccount": "учреждение в вашем аккаунте Sendcloud и дает вам идентификатор отправителя",
"hc.establishmentSettings": "Настройки учреждения",
"hc.exCode": "например, ABCD2345",
"hc.exId": "например, 3f2a…",
"hc.exit": "Выход",
"hc.explainWhyThisItemIs": "Объясните, почему этот товар не ваш…",
"hc.externalPaymentLinks": "Внешние ссылки на оплату",
"hc.failed": "Не удалось",
"hc.feesEnabled": "Сборы включены",
"hc.field": ") поле.",
"hc.finderAcceptedCloseTheCase": "Найдено — закройте дело, как только товар будет передан лично.",
"hc.findoCityRanking": "Findloop — Рейтинг городов",
"hc.findoForEstablishments": "Findloop для учреждений",
"hc.findoPresentationVideo": "видео презентации Findloop",
"hc.findoRegistersTheAddressOf": "Findloop регистрирует адрес вашего",
"hc.findoReviewShare": "Findloop {year} обзор: {n} товаров возвращено, {rate}% уровень возврата 🎉",
"hc.firstVerifyTheClaimCode": "Сначала подтвердите код запроса выше",
"hc.forEveryNewShipmentFrom": "за каждую новую отправку от",
"hc.free": "бесплатно",
"hc.freeRecovery0": "Бесплатное восстановление (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Бесплатное восстановление по всей Африке – Запуск предложения",
"hc.freeRecoveryFeesDisabled0": "Бесплатное восстановление: сборы отключены (0 €)",
"hc.fromTeamInviteYourColleagues": "Из \"Команды\" пригласите своих коллег по электронной почте и назначьте им учреждение. Каждый участник видит только свой собственный объем.",
"hc.fullName": "Полное имя",
"hc.fullPhoto": "Полное фото",
"hc.gallery": "Галерея",
"hc.giveTheReasonForCancelling": "Укажите причину отмены. Партнер будет уведомлен.",
"hc.goToLogin": "Перейти к входу",
"hc.goToMyAccount": "Перейти в мой аккаунт",
"hc.gold": "Золото",
"hc.googleLoginFailed": "Не удалось войти через Google",
"hc.hasConfirmedYourPaymentYou": "подтвердил ваш платеж, вы будете автоматически перенаправлены",
"hc.helpCenter": "Центр помощи",
"hc.helpUsImproveWhyAre": "Помогите нам улучшиться: почему вы уходите? Ваш аккаунт будет деактивирован и может быть повторно активирован в течение 30 дней.",
"hc.hidePassword": "Скрыть пароль",
"hc.high": "Высокий",
"hc.historyOfYourMonthlySubscriptions": "История ваших ежемесячных подписок и их статус оплаты.",
"hc.hotelBelmont": "Гостиница Белмонт",
"hc.howConfigureSenderId": "Как настроить мой числовой идентификатор отправителя?",
"hc.iDonTUseIt": "Я не использую это достаточно часто",
"hc.iFoundItElsewhere": "Я нашёл это в другом месте",
"hc.iNoLongerNeedMy": "Мне больше не нужен мой предмет",
"hc.identityVerification": "Проверка личности",
"hc.idleLogoutIn": "Вы будете выведены из системы через {n} с из-за неактивности.",
"hc.ifProvidedTheVolumetricWeight": "Если указано, используется объемный вес.",
"hc.ifThePartnerHasNot": "Если партнёр не подтвердил получение внешнего платежа после этого времени, Findloop автоматически напомнит партнёру подтвердить его.",
"hc.impersonationEnded": "Имитация завершена.",
"hc.impersonationMode": "Режим имитации",
"hc.impersonationSessionExpired": "Сессия имитации истекла.",
"hc.inTheField": ", в поле",
"hc.inTransit": "В пути",
"hc.inclVat": "включая НДС",
"hc.intraEuVatNumberOptional": "Номер НДС внутри ЕС необязателен, SIRET не требуется (за пределами Франции).",
"hc.invalidInvitationLink": "Неверная ссылка приглашения.",
"hc.invalidInvitationLink2": "Неверная ссылка приглашения",
"hc.invalidInviteLink": "Неверная или истекшая ссылка приглашения.",
"hc.invalidNumberEnterAnInternational": "Неверный номер. Введите международный номер, например +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Неверная или истекшая ссылка.",
"hc.invalidOrExpiredReactivationLink": "Неверная или истекшая ссылка для реактивации",
"hc.invalidSendcloudId": "Недействительный идентификатор Sendcloud",
"hc.inviteSubtitle": "{org} приглашает вас присоединиться к своей команде findloop. Выберите ваш пароль для активации аккаунта.",
"hc.isAvailableOnSendcloudFor": "доступен на Sendcloud для всех ваших маршрутов (внутренние + международные).",
"hc.isNotEnabledOnYour": "не включен в вашем аккаунте Sendcloud для некоторых направлений. Этикетки для них будут генерироваться с помощью другого доступного перевозчика.",
"hc.isThisReallyYourItem": "Это действительно ваш предмет?",
"hc.isThisYourItem": "Это ваш предмет?",
"hc.item": "Предмет",
"hc.itemAlreadyConfirmed": "Предмет уже подтверждён",
"hc.itemDetails": "Детали предмета",
"hc.itemFoundAt": "Предмет найден в",
"hc.itemFoundAtAPartner": "Предмет найден у партнёра",
"hc.itemMarkedAsReturned": "Предмет помечен как возвращённый ✓",
"hc.itemPhotoRequiredBeforeShipping": "Фото предмета (обязательно перед отправкой)",
"hc.itemPhotoSaved": "Фото предмета сохранено",
"hc.itemPreview": "Предпросмотр предмета",
"hc.itemPutBackInStorage": "Предмет возвращён на хранение.",
"hc.itemWeight": "Вес предмета:",
"hc.itemsReturned": "возврат предмет(ов)",
"hc.itemsReturnedThisYear": "товары, возвращенные в этом году",
"hc.itemsWhoseLegalDeadlineIs": "Товары, у которых юридический срок истекает через 15 дней или меньше (включая просроченные). Соответствия остаются видимыми.",
"hc.kbisNumber": "Номер Kbis",
"hc.keysForgottenOnABench": "Ключи, забытые на скамейке",
"hc.labelBeingGenerated": "Этикетка создается",
"hc.leaveTheFieldsEmptyTo": "Оставьте поля пустыми, чтобы предложить восстановление бесплатно.",
"hc.legalNotice": "Юридическое уведомление",
"hc.limitReachedUpgradeToA": "Достигнут лимит — перейдите на более высокий план",
"hc.linkCopiedShareOn": "Ссылка скопирована — поделитесь ей на {label}",
"hc.linkUnavailable": "Ссылка недоступна",
"hc.linkedTo": "Связано с",
"hc.listingHiddenByModeration": "Список скрыт модерацией.",
"hc.loading": "Загрузка…",
"hc.locateMe": "Определить местоположение",
"hc.logIn": "Войти",
"hc.logInToGetBack": "Войдите, чтобы вернуться в своё пространство и управлять своей подпиской.",
"hc.loginFailed": "Неудачный вход",
"hc.lostFoundPlatform": "Площадка для потерянных и найденных вещей.",
"hc.lostIn": "потеряно в",
"hc.lowRate": "Низкая ставка",
"hc.mainReason": "Основная причина",
"hc.mainStreet": "Главная улица",
"hc.makeSureThisIsThe": "Убедитесь, что это вещь, которую вы потеряли, прежде чем разблокировать контактные данные находившего.",
"hc.manageCookies": "Управление куками",
"hc.manageMyTeam": "Управление моей командой",
"hc.manageYourTeam": "Управление вашей командой",
"hc.markAsReturned": "Пометить как возвращенное",
"hc.matchNoClaimInTime": "На совпадение не было заявок в срок.",
"hc.matchNotFound": "Совпадение не найдено",
"hc.medium": "Средний",
"hc.milestoneFmt": "Достигнут этап {m} возвращенных товаров! На пути к {next}.",
"hc.missingFeatures": "Недостающие функции",
"hc.monthly": "Ежемесячно",
"hc.monthlyBilling": "Ежемесячная выставление счетов",
"hc.moveThePhotoToFit": "Переместите фото, чтобы поместить его в круг.",
"hc.myAccount": "Мой аккаунт",
"hc.myInvoices": "Мои счета",
"hc.myMonthlyInvoices": "Мои ежемесячные счета",
"hc.nArchived": "{n} объявление(я) архивированы.",
"hc.newCodeGeneratedAndSent": "Новый код сгенерирован и отправлен клиенту по электронной почте и SMS",
"hc.newCodeGeneratedAndSent2": "Новый код сгенерирован и отправлен владельцу",
"hc.newPassword": "Новый пароль",
"hc.next": "Далее",
"hc.nextPhoto": "Следующее фото",
"hc.no": "Нет",
"hc.noAnswerProvided": "Ответ не предоставлен.",
"hc.noArchivedDeclarations": "Нет архивированных деклараций",
"hc.noCountryFound": "Страна не найдена",
"hc.noDeclarations": "Нет деклараций",
"hc.noFeesAreChargedTo": "С клиента не взимаются сборы.",
"hc.noInvoiceYet": "Счет еще не выставлен.",
"hc.noInvoiceYetYourInvoices": "Счет еще не выставлен. Ваши счета появятся здесь автоматически после каждого платежа.",
"hc.noMatchIsAvailableFor": "На данный момент нет совпадений. Мы сообщим вам, как только появится товар, соответствующий вашей декларации.",
"hc.noShipmentMatchesYourSearch": "Нет отправлений, соответствующих вашему запросу.",
"hc.noShipmentsYet": "Нет отправлений.",
"hc.noShipmentsYet2": "Нет отправлений",
"hc.none": "нет",
"hc.noneChooseForEachShipment": "Нет (выберите для каждого отправления)",
"hc.notMine": "Это не мое",
"hc.of": "из",
"hc.only": "Только",
"hc.onlyEachSiteManagesIts": "только. Каждый сайт управляет своими финансами: эти ссылки не влияют на другие заведения.",
"hc.onlyTheOwnerOrAn": "Только владелец или администратор могут настроить платежные ссылки заведения.",
"hc.openDepositInTheMenu": "Откройте \"Депозит\" в меню, опишите товар и сделайте фото. Он сразу же будет сохранен и готов к возврату.",
"hc.openSettings": "Открыть Настройки →",
"hc.openTheDeclarationToManage": "Откройте декларацию, чтобы управлять отправлением",
"hc.optional": "— необязательно",
"hc.optional2": "(необязательно)",
"hc.optional3": "необязательно",
"hc.originalListingPhotoUsed": "Использовано оригинальное фото объявления",
"hc.other": "Другое",
"hc.other2": "Другое…",
"hc.ourProducts": "Наши продукты",
"hc.overallRateTrendLast6": "Общая тенденция тарифов (последние 6 месяцев)",
"hc.ownerSClaimCode": "Код иска владельца",
"hc.ownershipConfirmed": "Право собственности подтверждено",
"hc.paid": "Оплачено",
"hc.paidOn": "Оплачено",
"hc.paidViaPartner": "Оплачено (через партнёра)",
"hc.parcelBeingPrepared": "Посылка в процессе подготовки",
"hc.parcelDelivered": "Посылка доставлена",
"hc.parcelShipped": "Посылка отправлена",
"hc.parisGareDeLyon": "Париж, Гар дё Лион…",
"hc.partner": "Партнёр",
"hc.partner2": "партнёр",
"hc.partnerDirectory": "Каталог партнёров",
"hc.passedOnToTheCustomer": "— передано клиенту по ссылке для оплаты.",
"hc.password": "Пароль",
"hc.passwordResetPleaseLogIn": "Сброс пароля, пожалуйста, войдите.",
"hc.passwordUpdated": "Пароль обновлён.",
"hc.passwordsDoNotMatch": "Пароли не совпадают.",
"hc.pasteThisSenderIdIn": "Вставьте этот Sender ID в Findloop → Настройки",
"hc.payForTheShipmentOf": "Оплатите отправку вашего товара через Findloop с безопасным платежом.",
"hc.payTheRecoveryFees": "Оплатите сборы за восстановление",
"hc.payTheShippingFees": "Оплатите стоимость доставки",
"hc.payment": "Оплата",
"hc.paymentAlreadyConfirmedByThe": "Оплата уже подтверждена партнёром",
"hc.paymentLinksAreNowConfigured": "Ссылки для оплаты теперь настроены для каждого заведения",
"hc.paymentNotCompletedYourAccount": "Оплата не завершена, ваш аккаунт не был создан — попробуйте ещё раз.",
"hc.paymentReceived": "Оплата получена",
"hc.paymentSuccessful": "Оплата прошла успешно!",
"hc.pdfInvoice": "PDF-счет",
"hc.pending": "В ожидании",
"hc.period": "Период",
"hc.phoneNumber": "Номер телефона",
"hc.phoneOptional": "Телефон (по желанию)",
"hc.planAt": "план на",
"hc.planLimitFmt": "Ваш \"{plan}\" план ограничен {max} заведениями. Чтобы управлять {n} сайтами, мы рекомендуем",
"hc.platformReturnTarget": "Цель возврата платформы",
"hc.pleaseCompleteYourShippingAddress": "Пожалуйста, заполните адрес доставки.",
"hc.pleaseProvideAPhoneNumber": "Пожалуйста, укажите номер телефона: это требуется перевозчиком для доставки.",
"hc.pleaseProvideAReason": "Пожалуйста, укажите причину.",
"hc.pleaseSetYourOwnPassword": "пожалуйста, установите свой собственный пароль перед продолжением.",
"hc.pointsToGoal": "{n} баллов осталось до достижения нашей общей цели.",
"hc.posterPreview": "Предпросмотр плаката",
"hc.potentialMatchBeingVerified": "Потенциальное соответствие проверяется",
"hc.potentialOwner": "Потенциальный владелец",
"hc.preFilledAutomaticallyYouCan": "Автоматически заполнено — вы можете заменить это фотографией посылки.",
"hc.pressKit": "Пресс-кит",
"hc.previewMode": "Режим предпросмотра:",
"hc.previewOfThePrintReady": "Предпросмотр готового к печати постера A4 для этого заведения.",
"hc.previous": "Предыдущий",
"hc.previousPhoto": "Предыдущее фото",
"hc.primary": "основной",
"hc.printThePoster": "Распечатать постер",
"hc.privacy": "Конфиденциальность",
"hc.privacyPolicy": "Политика конфиденциальности",
"hc.processedCasesWillAppearHere": "Обработанные случаи появятся здесь.",
"hc.proofOfReturnPdf": "Подтверждение возврата (PDF)",
"hc.protectedByRecaptcha": "Защита reCAPTCHA",
"hc.publicMatch": "Публичное совпадение",
"hc.putBackInStorage": "Положить обратно на хранение",
"hc.pwdResetByTeam": "Ваш пароль был сброшен нашей командой. Для вашей безопасности,",
"hc.questionsToAskTheOwner": "Вопросы, которые можно задать владельцу",
"hc.rateChargedToTheCustomer": "Тариф, взимаемый с клиента:",
"hc.rateOfTarget": "{rate}% достигнуто из {target}% цели",
"hc.reached": "достигнуто",
"hc.reactivating": "Реактивация…",
"hc.reasonSavedYouCanStill": "Причина сохранена. Вы все еще можете потребовать свой предмет.",
"hc.recentMatchesFirst": "Недавние совпадения первыми",
"hc.recognizedThePhotoYouSent": "распознал отправленное вами фото и описал эти характеристики. Подтверждайте только в том случае, если они соответствуют предмету в вашем владении.",
"hc.recommended": "Рекомендуется",
"hc.recoveryFees": "Сборы за восстановление",
"hc.recoveryFeesArePaidDirectly": "Сборы за восстановление оплачиваются непосредственно партнерскому заведению. Findloop не получает оплату от клиентов.",
"hc.recoveryFeesEnabled": "Сборы за восстановление включены",
"hc.recoveryOfferedByTheEstablishment": "Восстановление, предлагаемое заведением — Findloop не взимает сборов.",
"hc.recoveryPaymentLink": "Ссылка на оплату восстановления",
"hc.recoveryPaymentLinkSavedFor": "Ссылка на оплату восстановления сохранена для данного заведения",
"hc.redirecting": "Перенаправление…",
"hc.redirectingToPayment": "Перенаправление на оплату…",
"hc.redirectingToTheRecoveryOf": "Перенаправление на восстановление вашего предмета…",
"hc.regenerateAndResendToThe": "Сгенерировать и отправить заново владельцу",
"hc.regenerateTheCode": "Сгенерировать код заново",
"hc.registerAFoundItem": "Зарегистрировать найденный предмет",
"hc.rejectTheClaim": "Отклонить требование",
"hc.reminderDelaySaved": "Задержка напоминания сохранена",
"hc.reopenThePaymentLink": "Повторно открыть ссылку на оплату",
"hc.repeatThePassword": "Повторите пароль",
"hc.reportAProblem": "Сообщить о проблеме",
"hc.reportDismissedYourListingRemains": "Сообщение отклонено. Ваше объявление остается публичным.",
"hc.requiredUsedToCalculateThe": "Обязательно: используется для расчета ставки доставки Sendcloud. Доставка недоступна свыше 30 кг.",
"hc.reset": "Сбросить",
"hc.resume": "Возобновить",
"hc.resumeRegistration": "Возобновить регистрацию",
"hc.retro": "Год в обзоре",
"hc.returnSecurity": "Безопасный возврат",
"hc.returnToTheOwner": "Вернуть владельцу",
"hc.returned": "возвращено",
"hc.reviewTheItemDetails": "Просмотреть детали товара",
"hc.revokeAccess": "Отозвать доступ",
"hc.role": "Роль:",
"hc.save": "Сохранить",
"hc.save2": "сохранить",
"hc.saveAndContinue": "Сохранить и продолжить",
"hc.saving": "Сохранение…",
"hc.scanTheClaimCode": "Сканируйте код требования",
"hc.scanTheOwnerSQr": "Сканируйте QR-код владельца",
"hc.scrollThroughLanguages": "Прокручивайте языки",
"hc.searchByCustomerItemOr": "Поиск по клиенту, товару или номеру отслеживания…",
"hc.searchForACountry": "Поиск по стране…",
"hc.secureFindoVerification": "Безопасная проверка Findloop",
"hc.seeRetro": "Смотреть год в обзоре",
"hc.selectedCarrier": "Выбранный перевозчик:",
"hc.selectedPlan": "Выбранный план",
"hc.send": "Отправить",
"hc.sendcloudSenderIdSaved": "ID отправителя Sendcloud сохранен",
"hc.sendcloudSenderIdSenderId": "ID отправителя Sendcloud (sender_id)",
"hc.sending": "Отправка…",
"hc.sessionExpired": "Сессия истекла",
"hc.setUpYourEstablishments": "Настроить ваши заведения",
"hc.settings": "Настройки",
"hc.settingsSubtitle": "Внешние платежи и напоминания, настроенные для каждого заведения.",
"hc.shareFoundText": "Я нашел предмет — помогите мне найти его владельца на Findloop",
"hc.shareLostText": "Я потерял предмет — помогите мне найти его на Findloop",
"hc.sharePreview": "Предварительный просмотр ссылки",
"hc.shareTheRanking": "Поделиться рейтингом",
"hc.shareYourQrCodeTo": "Поделитесь своим QR-кодом, чтобы получать заявления.",
"hc.shipRateAutoWeight": "Ставка доставки рассчитывается автоматически через Sendcloud (вес {w}) в момент отправки.",
"hc.shipRateForWeight": "Ставка доставки (Sendcloud + {m}% наценка) для {w}:",
"hc.shipments": "Отправления",
"hc.shipmentsSubtitle": "Консолидированный обзор всех отправлений заведения по всем случаям. Нажмите строку, чтобы управлять отправлением в его декларации.",
"hc.shipping": "Доставка",
"hc.shippingAddress": "Адрес доставки",
"hc.shippingFeesAreHandledAutomatically": "Плата за доставку автоматически обрабатывается Findloop (Sendcloud) — ссылка для ввода не требуется.",
"hc.shippingFeesHaveAlreadyBeen": "Плата за доставку уже оплачена: перевозчика больше нельзя изменить.",
"hc.shippingNotAvailableForItems": "Доставка недоступна для предметов свыше 30 кг. Клиенту придется забрать товар лично.",
"hc.shippingPaid": "Доставка оплачена ✓",
"hc.showOnlyItemsMatchingA": "Показать только товары, соответствующие публичному (клиентскому) списку",
"hc.showPassword": "Показать пароль",
"hc.signInTheBoxAbove": "Войдите в поле выше",
"hc.signatureSaved": "Подпись сохранена",
"hc.signedInWithGoogle": "Вошли с Google",
"hc.signupFailed": "Не удалось зарегистрироваться",
"hc.silver": "Серебро",
"hc.simulatedRatesInPreProduction": "(симулированные ставки в предпроизводстве)",
"hc.siretAndVatNumberRequired": "Требуется номер SIRET и НДС (Франция).",
"hc.skip": "Пропустить",
"hc.smsSentIfAccount": "Если с этим номером существует аккаунт, вам было отправлено SMS.",
"hc.sortItemsWithAPublic": "Сортировать: товары с публичным совпадением (самые свежие) первыми",
"hc.specifyWhetherYouRecoveredYour": "Уточните, получили ли вы ваш товар или просто хотите убрать этот список.",
"hc.specifyYourReason": "Укажите вашу причину",
"hc.specifyYourReason2": "Укажите вашу причину…",
"hc.staff": "Персонал",
"hc.status": "Статус",
"hc.staySignedIn": "Оставаться в системе",
"hc.step": "Шаг",
"hc.stillThere": "Все еще здесь?",
"hc.stopScrolling": "Остановить прокрутку",
"hc.storeFindWithQr": "Сохранить и найти с помощью QR",
"hc.streetName": "Название улицы",
"hc.streetNo": "Номер улицы",
"hc.switchTo": "Переключиться на",
"hc.switchToDarkMode": "Переключиться на темный режим",
"hc.switchToLightMode": "Переключиться на светлый режим",
"hc.takeAPhoto": "Сделать фото",
"hc.takeChangeThePhoto": "Сделать / изменить фото",
"hc.takenFromYourDeclaration": "взято из вашей декларации",
"hc.target": "Цель",
"hc.targetReached": "Цель достигнута",
"hc.targetReachedThankYouTo": "Цель достигнута — спасибо всей команде Findloop!",
"hc.tellUsMore": "Скажите нам больше…",
"hc.tellUsWhyYouCancel": "Скажите нам, почему вы отменяете. Это поможет партнеру обработать ваш запрос.",
"hc.tellUsWhyYourListing": "Скажите нам почему. Ваше объявление остается активным, и вы все еще можете забрать свою вещь.",
"hc.termsAndConditions": "Условия и положения",
"hc.termsAndPolicies": "Условия и политика",
"hc.thankYouForYourFeedback": "Спасибо за ваш отзыв",
"hc.theBannerDisplayedInThe": "баннер отображён в реестре.",
"hc.theClaimantHasBeenInformed": "Заявитель был проинформирован. Вещь остаётся доступной в публичном списке.",
"hc.theClaimantHasBeenNotified": "Заявитель был уведомлён и теперь может продолжить возврат.",
"hc.theCustomerPaysTheFees": "Клиент оплачивает сборы в учреждении.",
"hc.theDayTheLegalRetention": "День, когда истекает срок законного удержания.",
"hc.theEstablishmentConsideredThatThis": "Учреждение посчитало, что эта вещь не ваша.",
"hc.theEstablishmentIsReviewingYour": "Учреждение рассматривает ваши ответы. Вы будете уведомлены, как только ваш запрос будет подтверждён, тогда вы сможете оплатить сборы за возврат.",
"hc.theFeesAreTooHigh": "Сборы слишком высоки",
"hc.theFinderConsideredThatThis": "Находка посчитала, что эта вещь не ваша.",
"hc.theFinderIsReviewingYour": "Находка рассматривает ваш запрос. Вы будете уведомлены, как только он будет подтверждён.",
"hc.theItem": "Вещь",
"hc.theItemWillBeRemoved": "Вещь будет удалена из реестра (запрос не в процессе).",
"hc.theItemWillBeSet": "Вещь будет выставлена как \"в наличии\", и связанный запрос будет отменён.",
"hc.theKbisNumberAndVat": "Номер Kbis и номер НДС необходимы для Франции.",
"hc.theLabelIsGeneratedAutomatically": "Этикетка генерируется автоматически, как только клиент оплатил сборы за доставку. Ее можно будет скачать здесь.",
"hc.theLinkMayHaveExpired": "Ссылка могла устареть (действительна в течение 30 дней). Свяжитесь с поддержкой Findloop, если это необходимо.",
"hc.theOwnerDescribesTheirItem": "Владелец описывает свою вещь",
"hc.theOwnerReceivedItBy": "Владелец получил это по электронной почте (или SMS). Введите или отсканируйте это перед передачей.",
"hc.thePartnerConsideredThatThis": "Партнёр посчитал, что эта вещь не ваша. Вещь остаётся доступной.",
"hc.thePartnerIsReviewingYour": "Партнёр рассматривает ваши ответы. Вы будете уведомлены, как только ваш запрос будет подтверждён.",
"hc.theShipmentIsCreatedAutomatically": "Отправка создаётся автоматически, как только клиент подтвердит свой адрес и оплатит сборы за возврат. Этикетка затем будет сгенерирована автоматически после оплаты доставки и может быть скачана здесь.",
"hc.theShippingRateWillBe": "Стоимость доставки будет рассчитана автоматически через Sendcloud на момент отправки (зарегистрированный вес).",
"hc.thisCarrierWillBe": "Этот перевозчик будет",
"hc.thisEstablishment": "это учреждение",
"hc.thisFieldIsRequiredFor": "Это поле обязательно для автоматического формирования этикетки.",
"hc.thisIsMyItem": "Это моя вещь",
"hc.thisIsMyItemContinue": "Это моя вещь — продолжить",
"hc.thisIsMyItemStart": "Это моя вещь — начать возврат",
"hc.thisIsNotMyItem": "Это не моя вещь",
"hc.thisMatchIsNoLonger": "Это совпадение больше недоступно или уже обработано.",
"hc.thisRateWillBeCharged": "Эта ставка будет начислена клиенту. Высокая ставка может отпугнуть от возврата.",
"hc.thisStepIsRequiredFor": "Этот шаг необходим для генерации этикеток для отправки",
"hc.thisValidationLinkIsInvalid": "Эта ссылка для верификации недействительна или истекла.",
"hc.toCheckBeforeMarkingThe": "Проверьте перед тем, как пометить предмет как возвращённый.",
"hc.toConfigureTheLinksAnd": "для настройки ссылок и времени напоминания для каждого заведения.",
"hc.toReachOurFirstMilestone": "чтобы достичь нашей первой вехи в 100 возвратов.",
"hc.toTheCustomer": "к клиенту.",
"hc.toTheShippingFeePayment": "к оплате за доставку.",
"hc.toYourRecoveryTracking": "к вашему отслеживанию возврата.",
"hc.tooExpensiveBudget": "Слишком дорого / бюджет",
"hc.topCitiesForReturns": "Топ города для возвратов",
"hc.trackMyRecovery": "Отследить мой возврат",
"hc.trackTheShipmentAndDownload": "Отслеживайте отправку и загружайте ярлык (созданный автоматически), не покидая вкладку Деклараций.",
"hc.trackYourStatistics": "Отслеживайте свою статистику",
"hc.tracking": "Отслеживание",
"hc.unableToOpenTheShipping": "Не удалось открыть оплату за доставку. Пожалуйста, попробуйте снова.",
"hc.unableToRetrieveTheInvoice": "Не удалось получить счет-фактуру.",
"hc.unclaimed": "Не заявленный",
"hc.unclaimedCustomerReason": "Не заявленный предмет. Причина клиента: \"{reason}\".",
"hc.unclaimedItem": "Не заявленный предмет",
"hc.unclaimedItemNoClaimWithin": "Не заявленный предмет — нет заявки в срок.",
"hc.unclaimedItems": "Не заявленные предметы",
"hc.unclaimedItemsMatchLeftWithout": "Не заявленные предметы: совпадение оставлено без заявки в срок. Вы можете вернуть их на хранение.",
"hc.unlockTheFinderSContact": "Разблокируйте контактные данные находителя для организации передачи.",
"hc.upcoming": "Предстоящие",
"hc.updateFailed": "Обновление не удалось.",
"hc.usedForInvoices": "Используется для оформления ваших счетов findloop.",
"hc.vatNumber": "Номер НДС",
"hc.verificationPending": "Верификация в ожидании",
"hc.verificationSentToTheFinder": "Верификация отправлена находителю. Вы будете уведомлены о их решении.",
"hc.verificationSentToThePartner": "Верификация отправлена партнеру. Вы будете уведомлены о их решении.",
"hc.verify": "Подтвердить",
"hc.verifyingInvite": "Проверка ссылки приглашения…",
"hc.verifyingTheLink": "Проверка ссылки…",
"hc.viewInRegistry": "Просмотреть в реестре",
"hc.viewItem": "Просмотреть предмет",
"hc.viewItemRecover": "Просмотреть предмет и восстановить",
"hc.visibleToTheOwnerAutomatically": "Видимо владельцу · автоматически удаляется через 60 дней.",
"hc.waitingForPartnerConfirmation": "Ожидание подтверждения партнера",
"hc.waitingForThePartnerS": "Ожидание подтверждения партнера",
"hc.weHaveInformedTheEstablishment": "Мы проинформировали заведение, что этот предмет не ваш, и перезапустили анализ. Вы будете уведомлены, как только будет найдено новое совпадение.",
"hc.weHaveInformedThePartner": "Мы проинформировали партнера, что этот предмет не ваш. Ваше объявление остаётся активным для будущих совпадений.",
"hc.weRanTheAnalysisAgain": "Мы заново провели анализ и выявили еще один предмет, который может быть вашим. Пожалуйста, проверьте это снова.",
"hc.weight": "Вес",
"hc.weightNotProvidedTheShipping": "Вес не указан: стоимость доставки будет рассчитана в момент отправки.",
"hc.weightUnit": "Единица измерения веса",
"hc.welcome": "Добро пожаловать!",
"hc.welcomeToFindo": "Добро пожаловать в Findloop",
"hc.whenACustomerComesTo": "Когда клиент приходит забрать свои вещи, откройте его декларацию и подтвердите возврат. Вот и все!",
"hc.whenDisabledFeesDropTo": ". Когда отключено, сборы снижаются до",
"hc.whyIsThisNotYour": "Почему это не ваш предмет?",
"hc.willBeMarkedAs": "будет помечено как",
"hc.wrongColor": "Неправильный цвет",
"hc.wrongModel": "Неправильная модель",
"hc.yesCancel": "Да, отменить",
"hc.yesContactTheFinder": "Да, свяжитесь с находчиком",
"hc.youAreHere": "Вы здесь",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Теперь вы можете начать возврат.",
"hc.youCanStillChangeIt": ". Вы все еще можете изменить это в каждом конкретном случае.",
"hc.youHaveAlreadyConfirmedThat": "Вы уже подтвердили, что это ваш предмет.",
"hc.youWillBeRedirectedTo": "Вы будете перенаправлены на безопасный платеж Stripe.",
"hc.yourAccountHasBeenReactivated": "Ваш аккаунт был реактивирован.",
"hc.yourAccountIsActiveYou": "Ваш аккаунт активен, теперь вы можете управлять своими заведениями.",
"hc.yourEstablishment": "Ваше заведение",
"hc.yourFeedbackHelpsUsImprove": "Ваши отзывы помогают нам улучшить наши соответствия.",
"hc.yourFeedbackHelpsUsRestart": "Ваши отзывы помогают нам перезапустить анализ и улучшить наши соответствия.",
"hc.yourFirstSteps": "Ваши первые шаги",
"hc.yourFirstStepsAdmin": "Ваши первые шаги (администратор)",
"hc.yourItemHasBeenHanded": "Ваш предмет был передан лично партнером — закройте дело, как только передача будет подтверждена.",
"hc.yourItemHasBeenShipped": "Ваш предмет был отправлен партнером — закройте дело, как только доставка будет подтверждена.",
"hc.yourPaymentHasBeenRecorded": "Ваш платеж был зарегистрирован.",
"hc.yourShipmentIsBeingPrepared": "Ваша отправка готовится. Вы получите вашу посылку в течение 3-5 рабочих дней.",
"hc.yourShippingFeesHaveAlready": "Ваши сборы за доставку уже оплачены. Доставка оплачена ✓",
"hc.yourShippingFeesHaveBeen": "Ваши сборы за доставку были оплачены. Ваша посылка готовится.",
"hc.yourVerificationQuestionsDeposit": "Ваши вопросы проверки (депозит)",
"hero.einvoiceBadge": "Электронные счета-фактуры, соответствующие стандарту 2027",
"home.recentAdsAll": "Посмотреть все объявления",
"home.recentAdsEyebrow": "Прямо сейчас",
"home.recentAdsSubtitle": "Потерянные и найденные предметы, о которых сообщила сообщество.",
"home.recentAdsTitle": "Последние объявления",
"home.reunions": "Недавние встречи",
"home.videoEyebrow": "Смотреть",
"home.videoSubtitle": "Как мы без усилий соединяем потерянные вещи с их владельцами.",
"home.videoTitle": "Откройте для себя Findloop за 2 минуты",
"home.watchYoutube": "Смотреть на YouTube",
"impact.already": "Уже",
"impact.citiesWord": "город/города",
"impact.eachPoint": "Каждая точка — это город, где Findloop помогает вернуть потерянные вещи.",
"impact.emptyMap": "Карта заполняется по мере возврата вещей.",
"impact.eyebrow": "Наше влияние",
"impact.inCities": "по всему",
"impact.restitutedTo": "вещи, возвращенные их владельцам",
"impact.title": "Вещи возвращены, повсюду рядом с вами",
"inv2.download": "Скачать",
"inv2.view": "Посмотреть",
"map.objectsOnMapPlural": "вещи на карте",
"map.objectsOnMapSingular": "вещь на карте",
"mc.claimConfirmDesc": "Проверьте вещь, найденную находчиком, прежде чем оплатить, чтобы разблокировать его контактные данные.",
"mc.claimConfirmNo": "Это не моя вещь",
"mc.claimConfirmTitle": "Это действительно ваша вещь?",
"mc.claimConfirmYes": "Да, это моя — оплатить",
"mc.claimFinderContacts": "Контактные данные находчика",
"mc.claimNotMineDone": "Спасибо — находчик был уведомлен, и ваш запрос был удален из объявления.",
"mc.claimUnlockDesc": "Оплатите сбор Findloop, чтобы получить контактные данные человека, который нашел вашу вещь.",
"mc.claimUnlockTitle": "Разблокировать контактные данные находчика",
"mc.hideCountryOffers": "Скрыть предложения в моей стране",
"mc.myClaims": "Вещи, которые я претендую",
"mc.myClaimsSub": "Вещи, найденные другими, за которые вы претендуете. Разблокируйте контактные данные находчика, чтобы организовать передачу.",
"mc.notifAdCancelled": "Объявление отменено",
"mc.notifCancelAd": "Отменить мое объявление",
"mc.offersInCountry": "Предложения в моей стране",
"mc.offersInCountryDesc": "Все активные вознаграждения от партнеров в вашей стране, по городам.",
"mc.redArchived": "Архивировано",
"mc.rewardsCountryNone": "Пока нет предложений в вашей стране.",
"mc.rewardsForYou": "Вознаграждения для вас",
"mc.rewardsForYouDesc": "Предложенные партнером(ами), куда вы сдали вещь.",
"mc.rewardsMineNone": "Пока нет вознаграждений от ваших партнеров по сдаче.",
"mc.showCountryOffers": "Смотреть предложения в моей стране",
"mc2.cancelDecl": "Отменить мою декларацию",
"mc2.cancelDeclDone": "Декларация отменена.",
"pricing.physInvDesc": "Когда вещь возвращается, ее местоположение автоматически освобождается и доступно для новой вещи.",
"pricing.physInvTitle": "Отслеживание физического инвентаря",
"pricing.physModalTitle": "Управление физическими товарами",
"pricing.physQrDesc": "Для каждого товара генерируется уникальный QR-код, который ссылается на всю его информацию.",
"pricing.physQrTitle": "Посвященная QR-этикетка",
"pricing.physShelfDesc": "Каждому зарегистрированному товару может быть назначено физическое местоположение в учреждении.",
"pricing.physShelfTitle": "План полки",
"pricing.physicalMgmt": "Управление физическими товарами (полки, QR, инвентаризация)",
"pub.addSecondPhoto": "Добавить 2-ю фотографию (по желанию)",
"pub.photo2Added": "✓ 2-я фотография добавлена",
"reg.dispositionJournal": "Журнал распределения",
"reg.dispositionNoteAuthHint": "ℹ️ Для \"Передано в органы\" требуется запись (номер отчета, отдел…).",
"reg.dispositionNotePh": "Запись (по желанию): получающая благотворительная организация, ссылка на органы, имя покупателя…",
"reg.dispositionNoteRequired": "Официальная ссылка обязательна для передачи в органы.",
"reg.legalPrealert": "Юридический срок истекает через {days} день(дней)",
"reg.legalPrealertOptions": "Опции по истечении срока: аукционная продажа, пожертвование благотворительной организации, передача в органы.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Полный обзор",
"rev.readMore": "Читать далее",
"rw.activeCodes": "Активные ваучеры",
"rw.archived": "Архивировано",
"rw.archivedTitle": "Погашенные ваучеры (архивировано)",
"rw.hideArchived": "Скрыть погашенные ваучеры",
"rw.noArchived": "Нет архивированного ваучера.",
"rw.showArchived": "Показать погашенные ваучеры",
"shp.labelAuto": "Этикетка генерируется автоматически, как только клиент оплатил стоимость доставки. Ее можно будет скачать здесь.",
"st.cancelled_by_customer": "Отменено",
"stt.dispoPdfBtn": "Экспортировать PDF",
"stt.dispoPdfError": "Ошибка экспорта PDF.",
"stt.dispoPdfExporting": "Экспортируем…",
"trk.matchVerifying": "Потенциальное совпадение проверяется",
"pcat.stadium_arena": "Стадион / Арена",
"pcat.supermarket": "Супермаркет",
"pcat.taxi_vtc": "Такси / Вызов такси",
"pcat.tourism_office": "Туристический офис",
"pcat.train_bus_station": "Железнодорожный / автобусный вокзал",
"pcat.travel_agency": "Туристическое агентство",
"hc.and": "и",
"hc.demoObj0": "кошелек",
"hc.demoObj1": "спортивная сумка",
"hc.demoObj2": "телефон",
"hc.demoObj3": "пара очков",
"hc.demoObj4": "брелок с ключами",
"hc.demoObj5": "шарф",
"hc.demoObj6": "ноутбук",
"hc.demoObj7": "бутылка воды",
"hc.demoWhen0": "2 часа назад",
"hc.demoWhen1": "5 часов назад",
"hc.demoWhen2": "вчера",
"hc.demoWhen3": "3 часа назад",
"hc.demoWhen4": "этим утром",
"hc.demoWhen5": "1 день назад",
"hc.feedDemo": "{obj} был возвращен в {city} {when}.",
"hc.feedReal": "Предмет ({cat}) был возвращен в {city}.",
"hc.saveBtn": "Сохранить",
"hc.saveLink": "Сохранить ссылку",
"hc.terms": "Условия",
"hc.view": "Просмотреть",
"pcat.airline": "Авиакомпания",
"pcat.airport": "Аэропорт",
"pcat.amusement_park": "Парк аттракционов",
"pcat.bank": "Банк",
"pcat.bar_cafe": "Бар / Кафе",
"pcat.beauty_salon": "Парикмахерская / Салон красоты",
"pcat.cinema": "Кинотеатр",
"pcat.concert_theater": "Концертный зал / Театр",
"pcat.coworking": "Коворкинг",
"pcat.gym_fitness": "Спортзал / Фитнес",
"pcat.hospital_clinic": "Больница / Клиника",
"pcat.library": "Библиотека",
"pcat.mall": "Торговый центр",
"pcat.museum": "Музей",
"pcat.pharmacy": "Аптека",
"pcat.private_company": "Частная компания",
"pcat.public_transport": "Общественный транспорт",
"pcat.school_university": "Школа / Университет",
"pcat.sports_center": "Спортивный центр",
"an.found": "Найдено",
"an.lost": "Потеряно",
"hc.shareReview": "Поделиться отзывом",
"hc.citiesAboveTarget": "{n} города выше своей цели",
"hc.cityAboveTarget": "{n} город выше своей цели",
"hc.j15EarlyReminder": "Напоминание за 15 дней до",
"hc.j7EarlyReminder": "Напоминание за 7 дней до",
"hc.annualTotal": "Годовая сумма",
"hc.billedOnceYear": "Списание один раз за 12 месяцев, продляется каждый год.",
"hc.monthlyPrice": "Ежемесячная цена",
"hc.perMonth": "/ месяц",
"hc.perYear": "/ год",
"hc.billedEachMonth": "Систематически списывается каждый месяц.",
"nav.business": "Бизнес",
"nav.individual": "Индивидуальный",
"hc.circumstancesFound": "Обстоятельства находки",
"hc.circumstancesFoundPh": "Напр. найдено на земле у входа в метро",
"hc.circumstancesLost": "Обстоятельства потери",
"hc.circumstancesLostPh": "Напр. оставлено на скамейке во время ожидания автобуса",
"hc.conditionPh": "Напр. в хорошем состоянии, поцарапанное…",
"hc.firstName": "Имя",
"hc.lastName": "Фамилия",
"hc.quantity": "Количество предметов",
"fa.approve": "Одобрить",
"fa.approveConfirm": "Одобрить это заявление? Ваши полные контактные данные (имя, электронная почта, телефон) будут переданы находчику.",
"fa.approved": "Заявление одобрено — контактные данные обменены",
"fa.approvedFinder": "Владелец одобрил ваше заявление",
"fa.approvedFinderText": "Свяжитесь с ними, чтобы организовать возврат.",
"fa.boostSub": "Ваше объявление остается на вершине в течение выбранного времени.",
"fa.boostTitle": "Поднять мое объявление (по желанию)",
"fa.colFinder": "Заявление находчика",
"fa.colYours": "Ваше заявление",
"fa.compareHint": "Сравните заявление находчика с вашим перед принятием решения.",
"fa.contribNone": "Нет взноса",
"fa.contribPaid": "Взнос получен — спасибо!",
"fa.contribPending": "Взнос ожидает оплаты",
"fa.contribSub": "Поддержите Findloop, чтобы помочь большему количеству людей вернуть свои вещи. Вы можете выбрать €0.",
"fa.contribSuccessMsg": "Ваше заявление было отправлено владельцу.",
"fa.contribSuccessTitle": "Спасибо за ваш вклад",
"fa.contribTitle": "Добровольный взнос",
"fa.days3": "3 дня",
"fa.days30": "30 дней",
"fa.days7": "7 дней",
"fa.declSub": "Опишите вещь, которую вы нашли. Владелец сравнит ваше заявление с их заявлением.",
"fa.declTitle": "Я нашел этот предмет",
"fa.expiresOn": "Истекает",
"fa.fBrand": "Бренд",
"fa.fCircumstances": "Обстоятельства",
"fa.fCity": "Город",
"fa.fColor": "Цвет",
"fa.fCondition": "Состояние",
"fa.fDate": "Дата",
"fa.fMessage": "Сообщение находчика",
"fa.fPlace": "Место",
"fa.fQuantity": "Количество",
"fa.finderContact": "Контактные данные находчика",
"fa.finishPay": "Завершить оплату",
"fa.foundDate": "Дата находки",
"fa.foundPlace": "Место находки",
"fa.hours24": "24 часа",
"fa.ht": "без НДС",
"fa.months3": "3 месяца",
"fa.noBoost": "Без повышения",
"fa.ownerContact": "Контактные данные владельца",
"fa.payPublish": "Оплатить и опубликовать",
"fa.pendingPayText": "Ваше объявление станет активным, как только платеж будет подтвержден.",
"fa.pendingPayTitle": "Ожидание платежа",
"fa.planSub": "Ваше объявление станет активным, как только платеж будет подтвержден.",
"fa.planTitle": "Срок объявления",
"fa.pubSuccessMsg": "Ваше объявление опубликовано. Вы получите уведомление, как только найдется находчик.",
"fa.pubSuccessTitle": "Объявление опубликовано",
"fa.publicNote": "Только описание, город, страна и фотографии показываются публично.",
"fa.redirectStripe": "Перенаправление на безопасный платеж…",
"fa.reject": "Отклонить",
"fa.rejectConfirm": "Отклонить эту декларацию? Ваше объявление остается в сети.",
"fa.rejected": "Декларация отклонена",
"fa.rejectedFinder": "Это не тот предмет, который они искали",
"fa.rejectedFinderText": "Владелец говорит, что этот предмет не их. Спасибо за вашу помощь!",
"fa.responsesTitle": "Декларации находчиков",
"fa.sent": "Декларация отправлена владельцу.",
"fa.submitDecl": "Отправить мою декларацию",
"fa.submitDeclPay": "Отправить и внести {amount}",
"fa.total": "Итого к оплате",
"fa.ttc": "включая НДС",
"fa.waitClaimText": "Находчик рассматривает вашу заявку. Вы получите уведомление об их решении.",
"fa.waitFinderText": "Мы сообщим вам, как только находчик отправит декларацию.",
"fa.waitFinderTitle": "Ваше объявление активно",
"fa.waitOwnerText": "Владелец сравнивает вашу декларацию с их. Вы получите уведомление об их решении.",
"fa.waitOwnerTitle": "Ожидание решения владельца",
"st.pending_payment": "Ожидание платежа",
"fa.africaFree": "Бесплатное размещение в Африке — предложение запуска Findloop, пользуйтесь!",
"fa.africaPublished": "Размещение опубликовано бесплатно — предложение запуска в Африке!",
"fa.approveClaimConfirm": "Подтвердить это требование? Владелец сможет разблокировать ваши контактные данные.",
"fa.checkInfo": "Проверьте свои данные перед отправкой: они будут сравнены с данными находящего.",
"fa.claimApprovedShort": "Владелец одобрил ваше требование",
"fa.claimRejectedShort": "Требование отклонено владельцем",
"fa.claimRejectedText": "Владелец считает, что этот предмет не ваш.",
"fa.claimSub": "Опишите ваш предмет и добавьте 2 фотографии. Владелец сравнит их с его объявлением.",
"fa.claimTitle": "Это мой предмет",
"fa.claimUnlockText": "Разблокируйте контактные данные владельца для обустройства возврата.",
"fa.claimUnlockedShort": "Контактные данные разблокированы — смотрите трекинг",
"fa.claimsTitle": "Заявления владельца",
"fa.colOwner": "Заявление владельца",
"fa.colYourAd": "Ваше размещение",
"fa.expired": "Размещение истекло",
"fa.free": "Бесплатно",
"fa.lostDate": "Дата потери",
"fa.lostPlace": "Место потери",
"fa.noReceipt": "Чек для этого размещения недоступен.",
"fa.planSubFree": "Выберите срок: ваше размещение будет активно немедленно, без оплаты.",
"fa.prefillPrevious": "Использовать данные моего предыдущего размещения в этой категории",
"fa.receipt": "PDF чек",
"fa.renewBtn": "Продлить",
"fa.renewDiscountBanner": "50% скидка: продлите до истечения размещения!",
"fa.renewDiscountHint": "Скидка 50% применена, поскольку вы продлеваете до истечения срока.",
"fa.renewEarly": "Продлить (−50%)",
"fa.renewTitle": "Продлить мое размещение",
"fa.renewed": "Размещение продлено",
"fa.sendClaim": "Отправить мое требование",
"fa.twoPhotos": "2 фото вашего предмета",
"fa.twoPhotosError": "Добавьте 2 фото вашего предмета.",
"fa.twoPhotosHint": "Личные фотографии, подтверждающие, что предмет ваш (с предметом, счетом, упаковкой…).",
"fa.unlockBtn": "Разблокировать контактные данные",
"fa.unlockFree": "Разблокировать бесплатно — предложение запуска",
"fa.waitClaimantText": "Мы сообщим вам, как только владелец заявит на этот предмет.",
"fa.waitFinderDecision": "Ожидание решения владельца",
"fa.waitUnlockText": "Вас уведомят, как только контактные данные будут обменяны.",
"fa.waitUnlockTitle": "Ожидание разблокировки владельцем",
"fa.cancel": "Отмена",
"fa.categoryRequired": "Выберите категорию для найденного предмета.",
"fa.confirmTitle": "Подтвердите ваше решение",
"fa.goBack": "Вернуться назад",
"dr.continue": "Продолжить мою декларацию",
"dr.delete": "Удалить навсегда",
"dr.deleteConfirm": "Навсегда удалить этот черновик? Это нельзя будет отменить.",
"dr.deleted": "Черновик удалён",
"dr.expiresIn": "Черновик хранится ещё {h} часов",
"dr.title": "У вас есть незавершенная декларация",
"form.step": "Этап",
"form.next": "Продолжить",
"form.back": "Назад",
"form.stepDetails": "Ваш отчет",
"form.stepPublish": "Длительность, усиление и оплата",
"form.stepThanks": "Спасибо и вклад",
"fthx.badge": "Отчет почти готов",
"fthx.title": "Спасибо, вы меняете мир к лучшему!",
"fthx.text": "Благодаря вам кто-то вскоре может получить то, что для него важно. Такие добрые поступки, как ваш, являются тем, что поддерживает Findloop.",
"fthx.impact1": "1 предмет сообщен",
"fthx.impact2": "Еще один шанс на воссоединение",
"fthx.tipTitle": "Небольшая поддержка для Findloop?",
"fthx.tipText": "Ваш вклад помогает нам сохранять доступность сервиса и возвращать всё больше предметов их владельцам.",
"fthx.optional": "На 100% по желанию — вы можете опубликовать без взноса.",
"fthx.thanksTip": "Большое спасибо за вашу щедрость!",
"fthx.suggest": "Предложенные суммы",
"fthx.none": "Нет чаевых",
"pay.pendingTitle": "Платеж не завершен",
"pay.pendingText": "Ваши данные сохранены. Продолжите платеж там, где остановились.",
"pay.resume": "Продолжить платеж",
"pay.expiredTitle": "Сессия платежа истекла",
"pay.expiredText": "Для вашей безопасности сессия платежа истекла. Ваши данные сохранены: перезапустите платеж в один клик.",
"pay.relaunch": "Перезапустить платеж",
"sub.received": "Отправлено!",
"sub.publishing": "Завершаем…",
"sub.toPayment": "Перенаправление на безопасный платеж…",
"fa.claimSubV2": "Опишите ваш потерянный предмет. Человек, который его нашёл, сравнит ваше описание с его объявлением.",
"fa.photosOptional": "Фотографии вашего предмета (по желанию)",
"fa.compareOwnerHint": "Сравните эту информацию с найденным предметом и укажите, является ли это тем же самым предметом.",
"fa.itsThisItem": "Да, это тот предмет",
"fa.notThisItem": "Нет, это не тот предмет",
"fa.confirmIsItem": "Подтвердите, что это тот предмет? Ваши контактные данные и данные владельца будут показаны в ваших аккаунтах.",
"fa.confirmNotItem": "Подтвердите, что это не тот предмет? Ваше сообщение будет закрыто.",
"fa.youConfirmed": "Вы подтвердили, что это предмет владельца",
"fa.youDeclined": "Вы указали, что это не тот предмет",
"fa.youDeclinedText": "Спасибо за вашу помощь! Владельцу сообщено.",
"fa.waitFinderDecisionOwner": "Ожидание решения находившего предмет",
"fa.finderConfirmed": "Подтверждено",
"fa.notYourItem": "Это не ваш предмет",
"fa.reportedOn": "Сообщено о",
"fa.ownerWaitHint": "Находящий предмет в данный момент проверяет информацию, пожалуйста, подождите.",
"fa.claimSentFinder": "Запрос отправлен человеку, который нашел предмет.",
"fa.compareClaimHint": "Сравните заявление владельца с вашим объявлением перед принятием решения.",
"fa.closeFollowup": "Закрыть этот последующий запрос",
"fa.closeFollowupConfirm": "Закрыть этот последующий запрос? Электронные адреса и номера телефонов обеих сторон будут навсегда удалены, как только владелец закроет своё объявление.",
"fa.safetyTitle": "Советы по безопасности перед передачей",
"fa.safety1": "Попросите владельца предоставить подробное описание скрытых особенностей вещи: конкретная царапина, точное содержимое сумки, обои, серийный номер…",
"fa.safety2": "Если возможно, попросите визуальное подтверждение (фото вещи) или proof of purchase.",
"fa.safety3": "Передавайте вещь в общественном месте или в партнёрском пункте Findloop и проверьте удостоверение личности владельца.",
"fa.safetyOk": "Понял, продолжить",
"fa.ownerClosedNote": "Владелец закрыл своё объявление.",
"fa.finderClosedNote": "Находящий закрыл свой последующий запрос.",
"fa.followupClosed": "Последующее обращение закрыто",
"fa.followupClosedText": "Вы закрыли это последующее обращение. Спасибо за вашу помощь!",
"fa.photoReviewTitle": "Найдено изображение. Это выглядит как ваш предмет?",
"fa.photoLooksLike": "Да, это похоже на мой предмет",
"fa.photoNotMine": "Нет, это не мой предмет",
"fa.photoNotMineConfirm": "Дело будет закрыто с обеих сторон, и ваше объявление останется открытым для нового искателя.",
"fa.photoLooksLikeDone": "Спасибо! Искатель теперь сравнит вашу декларацию.",
"fa.photoNotMineDone": "Сообщение отклонено. Ваше объявление остается открытым.",
"fa.ownerPhotoHint": "Только фото искателя показано вам. Сообщите нам, похоже ли это на ваш предмет.",
"fa.ownerReviewingPhoto": "Владелец рассматривает ваше фото",
"fa.ownerReviewingPhotoText": "Вы будете уведомлены, как только они ответят. Затем вы сможете сравнить их декларацию.",
"fa.ownerRejectedPhoto": "Это не предмет владельца",
"fa.ownerRejectedPhotoText": "Владелец говорит, что ваше фото не соответствует их предмету. Дело закрыто. Спасибо за вашу помощь!",
"fa.contribute": "Сделать вклад",
"fa.phoneMissing": "Не указано",
"fa.ownerSafety1": "Предпочитайте передать в общественном месте или у партнера Findloop. Если расстояние велико, предложите отправить по почте.",
"fa.ownerSafety2": "При передаче проверьте удостоверение личности находящего.",
"pub.changePhoto": "Сменить фото",
"ph.secured": "Фото защищено",
"ph.securing": "Защита фото…",
"fa.ownerSafety3": "Если фото находящего имеет водяной знак Findloop, не принимайте встречу. Фото должно быть оригиналом, сделанным находящим, без водяных знаков."
},
"uk": {
"a.back": "Назад",
"a.category": "Категорія",
"a.categoryPlaceholder": "Виберіть категорію",
"a.city": "Місто",
"a.confirmPassword": "Підтвердьте пароль",
"a.country": "Країна",
"a.createAccount": "Створити обліковий запис",
"a.createBtn": "Створити мій обліковий запис",
"a.creating": "Створюється…",
"a.email": "Електронна пошта",
"a.emailPro": "Комерційна електронна пошта",
"a.forgot": "Забули?",
"a.forgotSent": "Якщо обліковий запис існує, посилання для скидання тільки що надіслано.",
"a.forgotSub": "Отримайте посилання для скидання на електронну пошту.",
"a.forgotTitle": "Забули пароль",
"a.googleContinue": "Продовжити з Google",
"a.googleSignup": "Зареєструватися з Google",
"a.haveAccount": "Вже партнер?",
"a.legalHint": "Обов'язково для французької електронної виставлення рахунків (Factur-X) французьких установ.",
"a.legalRequiredFR": "SIRET та номер ПДВ всередині ЄС є обов'язковими для Франції.",
"a.loggingIn": "Авторизація…",
"a.login": "Увійти",
"a.loginSub": "Доступ до вашого простору управління.",
"a.loginTitle": "Вхід партнера",
"a.min6": "Цілком 6 символів",
"a.newPassword": "Новий пароль",
"a.noAccount": "Ще не партнер?",
"a.or": "АБО",
"a.org": "Назва установи",
"a.password": "Пароль",
"a.passwordMismatch": "Паролі не збігаються.",
"a.referral": "Реферальний код (необхідно)",
"a.registerSub": "Створіть свій простір за 1 хвилину — безкоштовно для початку.",
"a.registerTitle": "Станьте партнером",
"a.rememberMe": "Запам'ятати мене",
"a.reset": "Скинути",
"a.resetSub": "Виберіть новий пароль для свого облікового запису.",
"a.resetTitle": "Новий password",
"a.sendLink": "Надіслати посилання",
"a.sending": "Надсилається…",
"a.signin": "Увійти",
"a.siret": "SIRET",
"a.vat": "Номер ПДВ всередині ЄС",
"ac.africa": "Африка",
"ac.boostActive": "Підкреслити активне —",
"ac.boostSub": "З'являйтеся на вершині каталогу партнерів з позначкою “Підвищено”.",
"ac.boostTitle": "Підвищте свою пропозицію в каталозі",
"ac.categoryHint": "Щоб класифікувати свою установу в каталозі findloop.",
"ac.choose": "Вибрати",
"ac.cityHint": "Для точного позиціонування на публічній карті.",
"ac.cityLabel": "Місто установи",
"ac.cityPh": "Париж",
"ac.contact": "Контактні дані",
"ac.converted": "Конвертовано",
"ac.copyDeclLink": "Скопіювати посилання декларації",
"ac.copyLink": "Скопіювати посилання",
"ac.currentPlan": "Поточний план",
"ac.emailDesc": "Виберіть електронні листи, які хочете отримувати. Сповіщення у вашому робочому просторі завжди залишаються активними.",
"ac.emailMatch": "Сумісні",
"ac.emailMatchDesc": "Електронна пошта, коли елемент відповідає декларації",
"ac.emailNewDecl": "Нові заяви про збитки",
"ac.emailNewDeclDesc": "Лист, як тільки клієнт повідомляє про збиток у вас",
"ac.emailShip": "Запити на доставку",
"ac.emailShipDesc": "Лист, коли клієнт запитує доставку товару",
"ac.emailTitle": "Налаштування електронної пошти",
"ac.expireSoon": "Ваше виділення завершується незабаром —",
"ac.exportCsv": "Експорт (CSV)",
"ac.exportHint": "Експортуйте ваші перевірені зовнішні платежі для бухгалтерії.",
"ac.free": "Безкоштовно",
"ac.freeMonths": "Безкоштовні місяці",
"ac.hours": "годин",
"ac.howItWorks": "Як це працює?",
"ac.invited": "Запрошений",
"ac.legalFR": "Необхідно для електронного виставлення рахунків (Factur-X), що набирає чинності з вересня 2026 року.",
"ac.legalMissing": "⚠️ Неповні SIRET та внутрішньоєвропейський ПДВ — заповніть їх для дотримання вимог електронного виставлення рахунків.",
"ac.legalOther": "Рекомендується для ваших рахунків.",
"ac.legalPartnerQr": "QR-код",
"ac.legalTitle": "Юридичні ідентифікатори (виставлення рахунків)",
"ac.logoTitle": "Логотип закладу",
"ac.modeCurrent": "Поточний режим:",
"ac.modeExternal": "Зовнішній (ручна перевірка)",
"ac.modeInternal": "Внутрішній Findloop (авто)",
"ac.noSubReceipt": "Ще немає сплати за підписку.",
"ac.none": "Немає",
"ac.onYourListing": "у вашому списку",
"ac.pay1": "Введіть посилання на ваші платежі нижче, щоб перенаправити своїх клієнтів на вашу власну систему збору коштів.",
"ac.pay2": "Перевірка стає ручною: ви підтверджуєте отримання оплати в розділі “Заяви”.",
"ac.pay3": "Посилання “Вартість доставки” є консолідованим платежем (відшкодування + доставка).",
"ac.pay4": "Залиште поля порожніми, щоб використовувати внутрішній платіж Findloop (Stripe) з автоматичною перевіркою.",
"ac.paySub": "Збирайте кошти через свою власну платіжну систему.",
"ac.payTitle": "Зовнішні платежі",
"ac.permissive": "Лояльний",
"ac.phone": "Телефон",
"ac.posterA4": "Постер A4 (PDF)",
"ac.qMessage": "Повідомлення (необов'язково)",
"ac.qName": "Ім'я",
"ac.qOrg": "Організація",
"ac.qSites": "Кількість закладів (оцінка)",
"ac.qrHint": "Ваші клієнти сканують цей код, щоб повідомити про втрачену річ.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Ваш QR-код партнера",
"ac.quoteDesc": "Аеропорти, залізничні мережі, міжнародні мережі · ",
"ac.quoteEurope": "Європа / Світ",
"ac.quoteSent": "Запит на пропозицію надіслано. Наша команда зв'яжеться з вами незабаром.",
"ac.quoteTitle": "Запросити пропозицію — Бізнес",
"ac.recoveryLink": "Посилання “Вартість відшкодування”",
"ac.refSub": "Кожен залучений партнер, який підписується, надає вам 1 безкоштовний місяць.",
"ac.refTitle": "Запросіть, отримайте безкоштовний місяць",
"ac.reminderDelay": "Затримка нагадування про перевірку",
"ac.reminderHint": "Ви отримаєте нагадування електронною поштою, якщо зовнішній платіж залишиться неперевіреним понад цей термін (за замовчуванням: 48 годин).",
"ac.renewDesc1": "Це вже принесло вам",
"ac.renewDesc2": "Поновіть, щоб залишатися на вершині довідника та не втратити цю видимість.",
"ac.renewNow": "Поновити зараз",
"ac.requestQuote": "Запросити пропозицію",
"ac.saveLegal": "Зберегти ідентифікатори",
"ac.saveLinks": "Зберегти посилання",
"ac.sendRequest": "Надіслати мій запит",
"ac.sending": "Надсилаю…",
"ac.shippingLink": "Посилання “Вартість доставки” (консолідоване)",
"ac.shippingLinkHint": "Це посилання охоплює і відшкодування, і доставку.",
"ac.strict": "Суворий",
"ac.subReceipt": "Чек підписки (PDF)",
"ac.subReceiptsSub": "Завантажте PDF чек для кожного платежу за підписку.",
"ac.subReceiptsTitle": "Чеки підписки",
"ac.tCategory": "Категорію збережено",
"ac.tCity": "Місто збережено — карта оновлена",
"ac.tCityNeeded": "Введіть місто",
"ac.tCopied": "Скопійовано!",
"ac.tCover": "Фото обкладинки оновлено",
"ac.tEmailPrefs": "Параметри електронної пошти оновлено",
"ac.tErr": "Помилка",
"ac.tExportImpossible": "Експорт не вдався",
"ac.tLegal": "Юридичні ідентифікатори збережено",
"ac.tLegalNeeded": "SIRET та ПДВ потрібні для Франції",
"ac.tLogo": "Логотип оновлено",
"ac.tLogoRemoved": "Логотип видалено",
"ac.tPayLinks": "Посилання на оплату збережено",
"ac.tPhone": "Телефон збережено",
"ac.tSensitivity": "Чутливість збережена",
"ac.tVatInvalid": "Недійсний номер ПДВ",
"ac.tVatValid": "Дійсний ПДВ",
"ac.tabBoost": "Видимість",
"ac.tabPayments": "Платежі",
"ac.tabProfile": "Профіль",
"ac.tabQr": "QR та постер",
"ac.tabReferral": "Реферальна програма",
"ac.tabSub": "Підписка",
"ac.thisWeek": "Цього тижня",
"ac.thisWeekOf": " ({n} цього тижня)",
"ac.thresholdDesc": "Поріг довіри, з якого ШІ автоматично підтверджує збіг фотографій і повідомляє клієнта. Вищий = менше авто-збігів, але надійніше.",
"ac.thresholdTitle": "Чутливість візуального збігу ШІ",
"ac.trend": "Тренд",
"ac.upload": "Завантажити",
"ac.vatValidFmt": "Дійсний ПДВ{name} ({via})",
"ac.vatVerified": "ПДВ перевірено в межах ЄС",
"ac.verifyVat": "Перевірити ПДВ (VIES)",
"ac.verifying": "Перевіряється…",
"ac.views": "переглядів",
"ac.viewsTotal": "Отримані перегляди (всього)",
"ac.winbackBtn": "Відновити з -20%",
"ac.winbackDesc1": "Це принесло вам",
"ac.winbackDesc2": "Спеціальна пропозиція: -20% автоматично, якщо ви поновите протягом 24 годин.",
"ac.winbackTitle": "Ваш акцент тільки що закінчився — відновіть за -20%!",
"ad.boost": "Підвищити",
"ad.close": "Закрити",
"ad.closeConfirm": "Закрити це оголошення?",
"ad.closed": "Оголошення закрито",
"ad.edit": "Редагувати",
"ad.editTitle": "Редагувати оголошення",
"ad.saved": "Оголошення оновлено",
"an.allCountries": "Усі країни",
"an.badge": "Втрачено",
"an.boostLater": "Пізніше",
"an.boostNow": "Підвищити зараз",
"an.boostPrompt": "Підвищте своє оголошення, щоб вивести його на перше місце та швидше знайти.",
"an.boosted": "Підвищено",
"an.contact": "Я знайшов цей предмет",
"an.contactTitle": "Повідомити, що ви знайшли цей предмет",
"an.copyFailed": "Не вдалося скопіювати посилання",
"an.copyLink": "Копіювати посилання",
"an.country": "Країна",
"an.date": "Дата втрати",
"an.finderEmail": "Ваш email",
"an.finderName": "Ваше ім'я",
"an.finderPhone": "Ваш телефон",
"an.geoBanner": "Ви переглядаєте оголошення в",
"an.geoBannerWorld": "Ви переглядаєте оголошення по всьому світу",
"an.geoChange": "змінити країну",
"an.goAccount": "Перейти до мого акаунту",
"an.linkCopied": "Посилання скопійовано!",
"an.loginRequired": "Увійдіть, щоб повідомити про цей предмет та слідкувати за поверненням.",
"an.loginToBoost": "Увійдіть, щоб підняти це оголошення",
"an.lostAt": "Втрачено в",
"an.message": "Повідомлення (необов'язково)",
"an.none": "Оголошень поки немає.",
"an.photo": "Фото (необов'язково)",
"an.post": "Створити оголошення",
"an.postSubtitle": "Опишіть ваш загублений предмет — спільнота та наші партнери допоможуть вам його знайти.",
"an.postTitle": "Повідомити про загублений предмет",
"an.publish": "Опублікувати оголошення",
"an.published": "Оголошення опубліковане!",
"an.publishing": "Публікація…",
"an.remaining": "залишилось",
"an.requestInProgress": "Запит в обробці",
"an.resolved": "Предмет вже знайдено",
"an.reward": "Нагорода",
"an.searchPh": "Шукати оголошення…",
"an.send": "Надіслати",
"an.sent": "Повідомлення надіслано власнику!",
"an.shareConsent": "Я погоджуюсь, що мої контактні дані (ім'я, email, телефон) можуть бути передані власнику предмета.",
"an.shareConsentError": "Будь ласка, відмітьте поле, щоб поділитися вашими контактними даними.",
"an.sortRecent": "Найновіші",
"an.sortRelevance": "Актуальність",
"an.subtitle": "Перегляньте предмети, про які повідомила спільнота. Знайшли один із них?",
"an.title": "Оголошення про загублені предмети",
"anf.badge": "Знайдені предмети",
"anf.claim": "Це моє",
"anf.claimSent": "Повідомлення надіслано знахіднику!",
"anf.claimTitle": "Повідомити, що це ваш предмет",
"anf.consent": "Я погоджуюсь, що власник може бачити мої контактні дані, щоб повернути свій предмет.",
"anf.foundAt": "Знайдено в",
"anf.foundDate": "Дата знаходження",
"anf.loginCta": "Увійдіть / створіть акаунт",
"anf.loginDesc": "Акаунт знахідника потрібен для публікації оголошення та отримання балів Finder Hero.",
"anf.loginRequired": "Увійдіть, щоб опублікувати знайдений предмет",
"anf.photo": "Фото предмета",
"anf.pointsEarned": "Дякуємо! Ви щойно earned Finder Hero points.",
"anf.pointsPending": "Ваші бали будуть зараховані протягом 24 годин після перевірки.",
"anf.post": "Опублікувати знайдений предмет",
"anf.postSubtitle": "Опишіть предмет, який ви знайшли — допоможіть його власнику повернути його.",
"anf.postTitle": "Повідомити про знайдений предмет",
"anf.publishFound": "Опублікувати оголошення про знайдений предмет",
"anf.published": "Оголошення про знайдений предмет опубліковано",
"anf.publishedAs": "Опубліковано як",
"anf.shareConsent": "Я погоджуюсь, що мої контактні дані (ім'я, email, телефон) можуть бути передані особі, яка знайшла предмет.",
"anf.subtitle": "Перегляньте предмети, знайдені та повідомлені спільнотою. Визнали свій?",
"anf.title": "Оголошення про знайдені предмети",
"bo.active": "Підвищення активне",
"bo.africaPrice": "Застосовано преференційні ціни для африканської зони",
"bo.pay": "Оплатити & підвищити",
"bo.remaining": "Час залишився",
"bo.renew": "Оновити підняття",
"bo.since": "з моменту підняття",
"bo.subtitle": "Розмістіть ваше оголошення на початку списку з помітним значком.",
"bo.title": "Підняття оголошення",
"c.all": "Всі",
"c.cancel": "Скасувати",
"c.close": "Закрити",
"c.confirm": "Підтвердити",
"c.confirmed": "Підтверджено",
"c.download": "Завантажити",
"c.loading": "Завантаження…",
"c.reset": "Скинути",
"c.reviews": "відгуків",
"c.save": "Зберегти",
"c.transfer": "Передати",
"cat.Animal": "Тварина / Аксесуари для тварин",
"cat.AppareilPhoto": "Камера",
"cat.Argent": "Гроші / Готівка",
"cat.Autres": "Інше",
"cat.Bijoux": "Ювелірні вироби",
"cat.CarteBancaire": "Банківська картка",
"cat.CarteIdentite": "Посвідчення особи / Паспорт",
"cat.Casquette": "Кепка / Шапка",
"cat.Ceinture": "Ремінь",
"cat.Chargeur": "Зарядний пристрій / Кабель",
"cat.Chaussures": "Взуття",
"cat.CleVoiture": "Ключ від автомобіля",
"cat.Cles": "Ключі",
"cat.Console": "Ігрова консоль",
"cat.Documents": "Документи / Папери",
"cat.Echarpe": "Шарф",
"cat.Ecouteurs": "Навушники",
"cat.Electronique": "Електроніка (інше)",
"cat.Enceinte": "Динамік",
"cat.Gants": "Рукавички",
"cat.Gourde": "Пляшка для води / Термофляга",
"cat.Instrument": "Музичний інструмент",
"cat.Jouet": "Іграшка / М'яка іграшка",
"cat.Jumelles": "Біноклі",
"cat.Lampe": "Лампа / Фара",
"cat.Liseuse": "Електронна книга",
"cat.Livre": "Книга / Блокнот",
"cat.Lunettes": "Окуляри",
"cat.Manteau": "Пальто / Куртка",
"cat.Maquillage": "Сумка для макіяжу",
"cat.Medical": "Медичне обладнання",
"cat.Medicaments": "Ліки",
"cat.Montre": "Годинник / Смарт-годинник",
"cat.Ordinateur": "Ноутбук",
"cat.Parapluie": "Парасолька",
"cat.Portefeuille": "Гаманець / Сумочка",
"cat.Poussette": "Коляска / Аксесуари для дитини",
"cat.Sac": "Сумка / Дамська сумка",
"cat.SacADos": "Рюкзак",
"cat.Souris": "Миша / Клавіатура",
"cat.Sport": "Спортивне обладнання",
"cat.Tablette": "Планшет",
"cat.Telephone": "Телефон / Смартфон",
"cat.Trottinette": "Самокат",
"cat.Trousse": "Сумка / Чохол",
"cat.USB": "USB-накопичувач / Жорсткий диск",
"cat.Valise": "Чемодан / Багаж",
"cat.Velo": "Велосипед",
"cat.Vetements": "Одяг",
"cat.placeholder": "Оберіть категорію",
"cd.d": "д",
"cd.expired": "Термін дії закінчився",
"cd.h": "г",
"cd.m": "хв",
"ck.accept": "Прийняти",
"ck.acceptAll": "Прийняти все",
"ck.customize": "Налаштувати",
"ck.learn": "Дізнатися більше",
"ck.manage": "Керувати печивом",
"ck.measurement": "Вимірювання аудиторії",
"ck.measurementDesc": "Анонімна статистика для покращення сервісу.",
"ck.msg": "Ми використовуємо печиво, щоб сайт працював і вимірювати аудиторію.",
"ck.necessary": "Необхідне",
"ck.necessaryDesc": "Важливо для роботи сайту. Завжди увімкнене.",
"ck.refuse": "Відхилити",
"ck.save": "Зберегти мій вибір",
"ck.saved": "Налаштування збережено",
"ck.title": "Ваші налаштування печива",
"cm.found": "ЗНАЙДЕНО",
"cm.lost": "ВТРАТИ",
"cmp.adv": "Розширене",
"cmp.ai": "AI відповідність",
"cmp.autobill": "Автоматичне виставлення рахунків",
"cmp.basic": "Базове",
"cmp.community": "Спільнота",
"cmp.consol": "Консолідоване виставлення рахунків",
"cmp.custom": "Індивідуальне",
"cmp.dedicated": "Виділене",
"cmp.deploy": "Спеціалізований розгортання та SLA",
"cmp.estIncl": "Включені заклади",
"cmp.estSec": "Додатковий заклад",
"cmp.items": "Предмети / місяць",
"cmp.main": "1 основний",
"cmp.max20": "20 макс",
"cmp.members": "Запрошення членів",
"cmp.onQuote": "Індивідуальна пропозиція",
"cmp.priority": "Пріоритет",
"cmp.starterEst": "1 включено + необмежений додатковий",
"cmp.stats": "Статистика",
"cmp.statsAdv": "Розширена",
"cmp.statsBasic": "Базова",
"cmp.support": "Підтримка",
"cmp.unlimited": "Нескінченний",
"cmp.upTo3": "До 3",
"consent.required": "Вам потрібно погодитися поділитися своїми контактними даними, щоб продовжити.",
"consent.share": "Я погоджуюсь, що знаходячий мій предмет може бачити мої контактні дані (ім'я, електронна пошта, телефон), щоб зв'язатися зі мною для його повернення.",
"cover.add": "Додати",
"cover.change": "Змінити",
"cover.helper": "Показується як банер на вашій сторінці звіту та в довіднику.",
"cover.none": "Без обкладинки",
"cover.remove": "Видалити",
"cover.title": "Обкладинка",
"crop.desc": "Налаштуйте співвідношення кадрування до банера (3:1). Перетягуйте та збільшуйте.",
"crop.saving": "Зберігання…",
"crop.title": "Обрізати фото для обкладинки",
"cta.button": "Створити обліковий запис партнера",
"cta.subtitle": "Приєднуйтесь до закладів, які повертають речі швидше з findloop.",
"cta.title": "Готові зменшити кількість загублених речей?",
"db.account.s": "Керуйте своїм закладом, підпискою та QR-кодом.",
"db.account.t": "Мій обліковий запис",
"db.declarations.s": "Клієнти, які повідомили про загублену річ через ваш QR-код.",
"db.declarations.t": "Повідомлення про втрати",
"db.deposit.s": "Додайте фото, категорію та опис.",
"db.deposit.t": "Зареєструвати знайдену річ",
"db.registry.s": "Усі знайдені речі, зареєстровані у вашому закладі.",
"db.registry.t": "Реєстр речей",
"db.reviews.s": "Відповідайте публічно на відгуки ваших клієнтів.",
"db.reviews.t": "Відгуки клієнтів",
"db.shipments.s": "Генеруйте етикетки та відстежуйте відправлення.",
"db.shipments.t": "Відправлення",
"db.stats.s": "Ваші ключові показники ефективності.",
"db.stats.t": "Статистика",
"db.team.s": "Запросіть колег для управління речами.",
"db.team.t": "Команда",
"dc.partnerDesc": "Загубили свою річ у партнерському закладі (готель, станція, зал…)? Виберіть його для прямого повернення.",
"dc.partnerList": "Виберіть з списку",
"dc.partnerMap": "Виберіть на карті",
"dc.partnerTitle": "Повідомлення у партнері",
"dc.publicCta": "Опублікувати оголошення",
"dc.publicDesc": "Ваше оголошення буде видно всій спільноті findloop. Ідеально, якщо ви не знаєте, де загубили річ.",
"dc.publicTitle": "Публічне повідомлення",
"dc.subtitle": "Виберіть, як повідомити про загублену річ.",
"dc.title": "Що б ви хотіли зробити?",
"dec.addrPending": "Адреса чекає на від клієнта",
"dec.analyzing": "Аналізується…",
"dec.badge": "Повідомлення про втрату",
"dec.category": "Категорія речі",
"dec.clientDescription": "Опис клієнта",
"dec.clientPhoto": "Фото, надане клієнтом",
"dec.clientPhotoShort": "Фото клієнта",
"dec.comparePhotos": "Порівняти фото",
"dec.contactTitle": "Ваші контактні дані",
"dec.date": "Дата втрати",
"dec.declaredItemPhoto": "Фото заявленої речі",
"dec.descPh": "Описати річ: бренд, колір, відрізняючі знаки…",
"dec.description": "Опис",
"dec.email": "Електронна пошта",
"dec.emptyDesc": "Поділіться своїм QR-кодом, щоб отримувати повідомлення.",
"dec.emptyTitle": "Немає повідомлень",
"dec.enlarge": "Збільшити",
"dec.extBanner": "{n} зовнішніх платежів для підтвердження — підтвердіть отримання нижче, щоб розблокувати передачу або доставку.",
"dec.foundItemAlt": "Знайдена річ",
"dec.foundItemRegistry": "Знайдена річ (реєстр)",
"dec.home": "Повернутися на головну",
"dec.labelClient": "Клієнт",
"dec.labelRegistry": "Реєстр",
"dec.matchFound": "Вже знайдено співпадіння!",
"dec.name": "Повне ім'я",
"dec.noMatchYet": "Співпадінь поки немає.",
"dec.noPhoto": "Немає фото",
"dec.notfound": "Партнера не знайдено.",
"dec.pRecup": "відновлення",
"dec.pRecupP": "(відновлення)",
"dec.pRecupShip": "(відновлення + доставка)",
"dec.payConfirmed": "Платіж {x} підтверджено",
"dec.payPending": "Зовнішній платіж {x} в обробці",
"dec.phone": "Телефон",
"dec.pickup": "Особистий збір",
"dec.place": "Місце втрати",
"dec.placePh": "Наприклад, біля бару, кімната 204…",
"dec.recoverBtn": "Відновити мій предмет",
"dec.reject": "Відхилити",
"dec.rerun": "Перезапустити аналіз",
"dec.similarity": "Схожість {n}%",
"dec.submit": "Подати мій звіт",
"dec.submitting": "Надсилаємо…",
"dec.successText": "Ми шукаємо ваш предмет серед тих, що зберігаються в",
"dec.successTitle": "Звіт надіслано!",
"dec.suggestedMatches": "Запропоновані збіги",
"dec.toColon": " до:",
"dec.toShip": "Для доставки",
"dec.toastExtPay": "Платіж підтверджено — клієнт буде повідомлений.",
"dec.toastMatch": "Збіг підтверджено",
"dec.toastReject": "Пропозицію відхилено",
"dec.toastRerun": "Аналіз перезапущено",
"dec.toastVisualN": "{n} візуальних збігів",
"dec.toastVisualNone": "Немає візуального збігу",
"dec.trackBtn": "Слідкувати за моїм звітом",
"dec.viewBeforeAfter": "Перегляд до/після (накладення)",
"dec.viewSideBySide": "Порівняння боком до боку",
"dec.visualCompare": "Візуальне порівняння AI",
"dec.visualIdle": "Запустіть порівняння, щоб AI візуально порівняв фото клієнта з знайденими предметами.",
"dec.visualRunning": "AI порівнює фото клієнта з предметами у вашому реєстрі…",
"dec.zoomPhoto": "Збільшити фото",
"dep.addAnyway": "Додати все одно",
"dep.addError": "Помилка під час додавання",
"dep.addItem": "Додати предмет",
"dep.added": "Предмет додано до реєстру!",
"dep.adding": "Додавання…",
"dep.aiError": "Аналіз AI наразі недоступний.",
"dep.aiFilled": "Форма заповнена AI ✨",
"dep.aiUnavailable": "AI недоступний — заповніть форму вручну.",
"dep.analyzing": "Аналізуємо…",
"dep.analyzingPhoto": "Аналізуємо фото…",
"dep.brand": "Бренд",
"dep.brandPlaceholder": "наприклад, Apple",
"dep.category": "Категорія",
"dep.checkingDup": "Перевірка на дублікат…",
"dep.color": "Колір",
"dep.colorPlaceholder": "наприклад, чорний",
"dep.condition": "Стан",
"dep.conditionPlaceholder": "наприклад, у доброму стані",
"dep.depositorNote": "Примітка депозитора",
"dep.depositorNoteHint": "Операційні деталі введені вручну. AI ніколи не перезаписує цю примітку.",
"dep.depositorNotePlaceholder": "наприклад, вміст мішечка, бренд, як повідомлено, деталі, надані особою…",
"dep.descPlaceholder": "наприклад, чорний iPhone 15 з прозорим чохлом, знайдений біля бару…",
"dep.description": "Опис",
"dep.dupHint": "Переконайтеся, що не додаєте дублікат. Ви можете продовжити, якщо предмет дійсно відрізняється.",
"dep.dupTitle": "Схожі предмети вже зареєстровані",
"dep.dupWarn": "Виявлено схожий предмет — перегляньте, а потім натисніть ще раз для підтвердження.",
"dep.estHint": "Предмет буде додано до реєстру цього закладу.",
"dep.establishment": "Заклад",
"dep.fee": "Плата за відновлення (€) — необов'язково",
"dep.feePlaceholder": "Залиште порожнім для стандартної ціни категорії",
"dep.fillAI": "Заповнити за допомогою ШІ",
"dep.optional": "(за бажанням)",
"dep.photo": "Фото предмета",
"dep.principal": "основний",
"dep.reqError": "Категорія та опис є обов'язковими.",
"dep.savedItem": "Зареєстрований предмет",
"dep.similarity": "Схожість",
"dep.storage": "Фізичне місцезнаходження",
"dep.storageHint": "Де предмет фізично зберігається. QR-код буде створено для його пошуку.",
"dep.storagePlaceholder": "наприклад, Полиця А3, Шухляда 12, Сейф на ресепшені",
"dl.aClient": "клієнт",
"dl.alertsBlocked": "Блокування сповіщень браузера",
"dl.alertsBlockedHint": "Щоб повторно увімкнути їх: натисніть на значок 🔒 (або ⓘ) ліворуч від адреси сайту, потім дозволте сповіщення та перезавантажте сторінку.",
"dl.amountDue": "Сума до сплати: {amount} {currency}.",
"dl.enableAlerts": "Увімкнути сповіщення",
"dl.extPending": "Платежі для підтвердження",
"dl.freemiumNear": "Ви наближаєтеся до межі Freemium ({used}/{max} предметів цього місяця). Оновіть до Starter для необмеженої кількості предметів.",
"dl.freemiumReached": "Досягнуто межі Freemium ({used}/{max} предметів цього місяця). Оновіть до Starter, щоб зареєструвати необмежену кількість предметів.",
"dl.invoiceOverdue": "Рахунок {num} неоплачений — доступ обмежено.",
"dl.matchNotifTitle": "Findloop — Новий збіг ШІ 🔔",
"dl.matchToast": "Новий збіг ШІ — {name}",
"dl.matchToastDesc": "Предмет відповідає декларації.",
"dl.notifEmpty": "Ще немає сповіщень.",
"dl.notifEnabled": "Сповіщення браузера увімкнено",
"dl.notifTitle": "Сповіщення",
"dl.payInvoice": "Оплатити мій рахунок →",
"dl.rewardsPending": "Невикористані ваучери",
"dl.upgradeStarter": "Оновити до Starter →",
"est.all": "Всі заклади ({n})",
"est.label": "Заклад",
"est.primary": "основний",
"est.secondary": "додатковий",
"est2.add": "Додати заклад",
"est2.addressLabel": "Адреса",
"est2.addressPh": "вул. Республіки, 12",
"est2.autoInvoice": "Детальний рахунок генерується автоматично 1-го числа кожного місяця.",
"est2.baseSub": "Базова підписка",
"est2.billing": "Білінг",
"est2.boostActivated": "Посилення активовано для {name}",
"est2.boostBillingNote": "Білінг за поточною ставкою, згрупований у вашому консолідованому щомісячному рахунку.",
"est2.boostCta": "Посилити",
"est2.boostDesc": "Покращити видимість цього закладу в каталозі та на карті.",
"est2.boostDuration": "{h} годин підвищеної видимості",
"est2.boostExtend": "Подовжити",
"est2.boostTitle": "Посилити {name}",
"est2.boosted": "Посилено",
"est2.chartDesc": "Частка повернутих предметів з загальної кількості зареєстрованих, сайт за сайтом.",
"est2.chartTitle": "Темп повернення за закладом",
"est2.chartTooltip": "Повернення",
"est2.cityLabel": "Місто",
"est2.cityPh": "Ліон",
"est2.contactHint": "Ці деталі показуються клієнту для цього закладу (якщо порожньо, використовуються деталі облікового запису).",
"est2.countryLabel": "Країна",
"est2.coverLabel": "Обкладинка",
"est2.create": "Створити",
"est2.created": "Заклад створено",
"est2.delete": "Видалити",
"est2.deleteDesc": "Ця дія є незворотною. Ви можете видалити заклад лише якщо в ньому немає предметів.",
"est2.deleteTitle": "Видалити “{name}”?",
"est2.deleted": "Заклад видалено",
"est2.dialogDesc": "Введіть назву та адресу цього закладу.",
"est2.edit": "Редагувати",
"est2.editEst": "Редагувати заклад",
"est2.emailLabel": "Контактний email",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " заклад(и)",
"est2.extraNoteBase": "{n} додатковий заклад(и) до рахунку",
"est2.extraPrice": " за {price} €/місяць.",
"est2.extraQuote": " за запитом.",
"est2.imgChange": "Вибрати зображення",
"est2.imgDone": "Готово",
"est2.imgRemove": "Видалити",
"est2.imgRemoved": "Зображення видалено",
"est2.imgSaved": "Зображення збережено",
"est2.imgUploading": "Завантаження…",
"est2.includedPlan": "Входить у ваш план: {n}.",
"est2.kDeclarations": "Декларації",
"est2.kInStorage": "На зберіганні",
"est2.kItemsTotal": "Товари (всього)",
"est2.kRestituted": "Повернено",
"est2.limitReached": "Ліміт досягнуто",
"est2.logoLabel": "Логотип",
"est2.mDeclar": "Декл.",
"est2.mItems": "Товари",
"est2.mRestituted": "Повернено",
"est2.mStorage": "На зберіганні",
"est2.monthlyTotal": "Місячний підсумок",
"est2.nameLabel": "Назва *",
"est2.namePh": "напр. Belmont Hotel — Lyon Annex",
"est2.newEst": "Новий заклад",
"est2.onQuote": "За запитом",
"est2.phoneLabel": "Телефон",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "План",
"est2.planLimited": "Ваш план “{tier}” обмежений до {max} заклад(ів).",
"est2.primary": "Основний",
"est2.qr": "QR код",
"est2.qrDesc": "Відобразіть цей QR код у цьому закладі. Клієнти, які повідомлять про втрату, будуть пов’язані з цим сайтом.",
"est2.qrTitle": "QR код — {name}",
"est2.saving": "Збереження…",
"est2.seeInvoices": "Подивитися мої місячні рахунки",
"est2.seePlans": "Переглянути плани",
"est2.subtitle": "Управляйте всіма вашими сайтами в одному аккаунті — консолідований перегляд, товари, QR код та рахунки.",
"est2.suspended": "Призупинено",
"est2.tierFree": "1 заклад",
"est2.tierLarge": "необмежена кількість закладів",
"est2.tierMedium": "включено 5 закладів",
"est2.tierSmall": "включено 3 заклади",
"est2.title": "Заклади",
"est2.unlimitedPlan": "Ваш план дозволяє необмежену кількість закладів.",
"est2.unlimitedSuffix": " · необмежено",
"est2.updated": "Заклад оновлено",
"est2.upgradeHint": "Оновіть до вищого плану, щоб додати більше сайтів та централізувати всю вашу діяльність.",
"est2.visuals": "Логотип та фото",
"est2.visualsDesc": "Налаштуйте логотип і обкладинку цього закладу. Вони з'являться на його публічній сторінці та формі декларації.",
"est2.visualsTitle": "Візуали — {name}",
"est2.workOn": "Працювати над цим закладом",
"est2.working": "Ви працюєте над “{name}”",
"ev.created": "Звіт створено",
"ev.matched": "Визначено відповідний товар",
"ev.paid": "Оплата збору на відновлення",
"ev.pickup": "Збір на місці",
"ev.shipped": "Посилка відправлена",
"ev.shipping_paid": "Оплата вартості доставки",
"ev.shipping_requested": "Запит на доставку",
"feat1.d": "KPI, рівень повернення за категоріями, доходи та тенденції за 30 днів.",
"feat1.t": "Панель та аналітика",
"feat2.d": "Етикетки, відстеження перевізника та автоматичні електронні листи для відстеження.",
"feat2.t": "Модуль доставки",
"feat3.d": "Клієнти знаходять вас за містом та категорією, з сертифікованими відгуками.",
"feat3.t": "Публічний каталог та відгуки",
"fp.backToRanking": "Назад до рейтингу",
"fp.badge": "Значок",
"fp.hero": "Герой Finder",
"fp.notFound": "Профіль не знайдено або приватний.",
"fp.scoreTotal": "Загальна кількість балів",
"fp.scoreYear": "Бали за",
"fp.share": "Поділитися цим профілем",
"fp.shareText": "Перегляньте профіль {name} у Findloop!",
"fp.tagline": "ЧеснийFinder, який робить світ кращим.",
"ft.backAccount": "Назад до Мого облікового запису",
"ft.closeBtn": "Закрити справу",
"ft.closeConfirm": "Підтвердити, що товар був повернутий? Оголошення буде закрито.",
"ft.closeLockedHint": "Спочатку підтвердіть код власника, щоб розблокувати закриття.",
"ft.closed": "Справу закрито — товар повернуто!",
"ft.codeLabel": "Введіть код підтвердження, отриманий від власника",
"ft.codeNeeded": "Будь ласка, введіть код підтвердження.",
"ft.codeOk": "Код підтверджено — ви можете закрити справу.",
"ft.codePlaceholder": "напр. 4821",
"ft.codeVerified": "Підтверджено",
"ft.doneMsg": "Товар повернуто. Дякуємо за допомогу в поверненні до власника!",
"ft.stepInProgress": "Повернення у процесі",
"ft.stepPublished": "Оголошення опубліковано",
"ft.stepReturned": "Товар повернуто",
"ft.subtitle": "Слідуйте крокам, поки знайдений товар не буде повернуто.",
"ft.title": "Відстеження повернення",
"ft.verifyBtn": "Підтвердити код",
"hero.badge": "Рекомендовано",
"hero.ctaFound": "Я знайшов товар",
"hero.ctaLost": "Я втратив товар",
"hero.ctaPartner": "Станьте партнером",
"hero.subtitle": "Findloop допомагає закладам управляти знайденими речами - і дозволяє їхнім клієнтам повідомляти про втрату, а потім отримувати свої речі назад, на місці або через доставку.",
"hero.title": "Кожен загублений товар знаходить свого власника.",
"home.champBecome": "Станьте finder",
"home.champCta": "Переглянути рейтинг",
"home.champSubtitle": "Кожен повернутий товар приносить бали. Приєднуйтесь до рейтингу та вигравайте призи.",
"home.champTitle": "Наші топ знайдення",
"how.eyebrow": "Як це працює",
"how.title": "Від передачі до повернення, без зайвих зусиль.",
"inv.all": "Всі",
"inv.allYears": "Усі роки",
"inv.count": "Рахунки",
"inv.due": "підлягає оплаті",
"inv.empty": "Ще немає рахунків.",
"inv.exportCsv": "Експортувати CSV",
"inv.invoicePdf": "PDF рахунок",
"inv.issued": "Виписано",
"inv.noMatch": "Немає рахунку для цього фільтра.",
"inv.paid": "Оплачено (€)",
"inv.paidOn": "оплачено",
"inv.pay": "Оплатити",
"inv.receipt": "Чек",
"inv.reminders": "Нагадування",
"inv.remindersDesc": "Нагадування по електронній пошті та SMS, надіслані для цього рахунку.",
"inv.remindersEmpty": "Немає надісланих нагадувань.",
"inv.rmDue": "Нагадування про термін",
"inv.rmManual": "Ручне нагадування",
"inv.rmSms": "SMS нагадування D+30",
"inv.rmStage": "Нагадування",
"inv.statusPaid": "Сплачено",
"inv.statusUnpaid": "Не сплачено",
"inv.subtitle": "Переглядайте та завантажуйте свої рахунки та чеки.",
"inv.title": "Мої рахунки",
"inv.unpaid": "Не сплачено (€)",
"inv2.contractTitle": "Мій контракт Findloop",
"inv2.detailByEst": "Деталі за закладом",
"inv2.dueLabel": "Термін:",
"inv2.dueSuffix": " · термін {date}",
"inv2.error": "Помилка {status}",
"inv2.estCountIssued": "{n} заклад(и) · видано {date}",
"inv2.estimate": "Оцінка (не оплачується) · {n} заклад(и)",
"inv2.expired": " · прострочено",
"inv2.exportCsv": "Експортувати CSV",
"inv2.exportDone": "CSV експорт завантажено",
"inv2.included": "Включено",
"inv2.monthlyTitle": "Щомісячна оплата (підписка)",
"inv2.months": "+{n} місяців",
"inv2.paid": "Сплачено",
"inv2.pay": "Оплатити",
"inv2.previewTitle": "Попередній перегляд вашого наступного рахунку —",
"inv2.renew": "Продовжити мій контракт",
"inv2.renewalsTitle": "Історія подовжень ({n})",
"inv2.renewedUntil": "Контракт продовжено до {date}",
"inv2.serviceTitle": "Рахунки за послуги (відшкодування & котирування)",
"inv2.soon": "Швидко закінчується",
"inv2.toPay": "До сплати",
"inv2.totalHtTva": "Всього без податку · ПДВ",
"inv2.totalTtc": "Всього з податком",
"iu.addPhoto": "Додати фото",
"iu.change": "Змінити",
"lang.label": "Мова",
"lb.allCountries": "Усі країни",
"lb.badge": "Щорічний рейтинг",
"lb.champion": "🏆 Чемпіон року",
"lb.cityPh": "Фільтр за містом…",
"lb.empty": "Немає рейтингу для цих фільтрів ще.",
"lb.pts": "бали",
"lb.resetNote": "Рейтинг поточного року — скидається 1 січня.",
"lb.returned": "повернуто",
"lb.share": "Поділитися рейтингом",
"lb.shareText": "Перегляньте рейтинг найкращих шукачів на Findloop!",
"lb.subtitle": "Кожне повернення приносить бали. Рейтинг скидається 1 січня.",
"lb.tabFinders": "Шукачі",
"lb.tabPartners": "Заклади",
"lb.title": "Найкращі шукачі",
"lost.b2bDesc": "Втратили в готелі, транспортному вузлі чи партнерському закладі? Знайдіть заклад і повідомте про втрату.",
"lost.b2bTitle": "Повідомити партнеру",
"lost.b2cDesc": "Опублікуйте оголошення, видиме всім, запропонуйте винагороду та збільшіть його, щоб підвищити ваші шанси.",
"lost.b2cTitle": "Опублікувати публічне оголошення",
"lost.desc": "Виберіть, як ви хочете продовжити.",
"lost.title": "Втратили річ?",
"map.allCategories": "Усі категорії",
"map.clear": "Скинути",
"map.exitFullscreen": "Вийти",
"map.filterCity": "Місто або країна…",
"map.fullscreen": "На весь екран",
"map.heatmap": "Теплова карта",
"map.high": "Високий",
"map.impactMonth": "предметів повернуто цього місяця",
"map.impactTotal": "повернуто загалом",
"map.legend": "Кольорові крапки від червоного (низький) до зеленого (високий) на основі рівня повернення; розмір залежить від кількості предметів.",
"map.locating": "Визначення місця… додайте адресу до ваших об’єктів, щоб побачити їх на карті.",
"map.low": "Низький",
"map.mAll": "Усі",
"map.mFound": "Знайдено",
"map.mLost": "Втрачені",
"map.medium": "Середній",
"map.noItemRegistered": "Не зареєстровано жодного предмета",
"map.noItems": "Немає предметів",
"map.period30": "Останні 30 днів",
"map.period7": "Останні 7 днів",
"map.period90": "Останні 90 днів",
"map.periodAll": "Увесь час",
"map.returnedSuffix": "повернуто · {a}/{t} предметів",
"map.stats": "Статистика міста",
"map.statsTop": "Топ 5 місць (втрачені предмети)",
"map.statsTrend": "Тренд за 6 місяців",
"map.title": "Карта ваших об'єктів",
"map.topPlaces": "Популярні місця",
"mc.adClosed": "Оголошення закрито",
"mc.addPhoto": "Додати фотографію",
"mc.adsNone": "Немає оголошень про втрату предметів.",
"mc.archiveHide": "Приховати історію",
"mc.archiveNone": "Ще немає вирішених випадків.",
"mc.archiveShow": "Показати історію",
"mc.archiveSub": "Вирішені та повернуті випадки.",
"mc.archiveTitle": "Історія",
"mc.at": "У",
"mc.backToLogin": "Назад до входу",
"mc.boostContacts": "Контакти (підвищення)",
"mc.boostViews": "Перегляди (підвищення)",
"mc.cancel": "Скасувати",
"mc.certificate": "Сертифікат",
"mc.changePhoto": "Змінити фотографію",
"mc.city": "Місто",
"mc.closeAd": "Закрити",
"mc.closeAdConfirm": "Закрити це оголошення? Воно більше не буде видимим і займе вільне місце.",
"mc.confirmPassword": "Підтвердьте пароль",
"mc.confirmRestitution": "Підтвердити повернення",
"mc.connect": "Підключитися",
"mc.contacts": "Контакти",
"mc.country": "Країна",
"mc.declareFound": "Повідомити про знайдений предмет",
"mc.declareFoundSub": "Опублікуйте предмет, який ви знайшли",
"mc.declareLost": "Повідомити про втрату",
"mc.declareLostSub": "Опублікуйте оголошення про втрачені предмети",
"mc.deleteAccount": "Видалити мій обліковий запис",
"mc.deleteConfirm": "Так, видалити мій обліковий запис",
"mc.deleteConfirmBody": "Ваш обліковий запис буде постійно видалено, а ваші персональні дані анонімізовані. Цю дію не можна скасувати.",
"mc.deleteConfirmTitle": "Видалити ваш обліковий запис?",
"mc.deleteDesc": "Назавжди видаляє ваш акаунт та анонімізує вашу особисту інформацію. Цю дію не можна скасувати.",
"mc.deleted": "Ваш акаунт був видалений.",
"mc.deleting": "Видалення…",
"mc.email": "Електронна пошта",
"mc.expiresOn": "Термін дії закінчується",
"mc.exportData": "Завантажити мої дані (GDPR)",
"mc.exportDone": "Ваші дані були завантажені.",
"mc.exporting": "Підготовка…",
"mc.finderAccepted": "Прийнято",
"mc.finderProfile": "Профіль Findloop (додатково)",
"mc.finderProfileDesc": "Заробляйте бали, повертаючи речі, і з'являйтеся у загальному рейтингу.",
"mc.forYourAd": "Для вашого оголошення",
"mc.forgotLink": "Забули пароль?",
"mc.forgotSend": "Надіслати посилання",
"mc.forgotSent": "Якщо для цієї електронної пошти існує акаунт, посилання для скидання щойно надіслано.",
"mc.forgotTitle": "Забули пароль",
"mc.foundAdsNone": "Не публіковано жодного оголошення про знайдені речі.",
"mc.foundAt": "Знайдено на",
"mc.foundNone": "Не повідомлено про жодну знайдену річ.",
"mc.hAd": "Оголошення про загублену річ",
"mc.hDeclaration": "Декларація",
"mc.hFinderContact": "Поведена річ",
"mc.hFound": "Повернута річ",
"mc.hFoundAd": "Оголошення про знайдену річ",
"mc.histEarned": "Річ повернута",
"mc.historyTitle": "Історія моїх балів",
"mc.loginBtn": "Увійти",
"mc.loginTitle": "Вхід користувача",
"mc.logout": "Вийти",
"mc.lostAt": "Втрачене на",
"mc.matchPartner": "У партнера",
"mc.matchPublic": "Знайдена річ",
"mc.matches": "Збіги",
"mc.matchesSub": "Знайдені речі можуть відповідати вашим оголошенням про загублені речі.",
"mc.myAds": "Мої оголошення про загублені речі",
"mc.myDeclarations": "Мої звіти",
"mc.myFinds": "Речі, які я знайшов",
"mc.myFindsNone": "Ви ще не повідомляли про знайдену жодну річ.",
"mc.myFindsSub": "Речі, які ви повідомили про знайдені в оголошеннях про загублені речі.",
"mc.myFound": "Повідомлені знайдені речі",
"mc.myFoundAds": "Мої оголошення про знайдені речі",
"mc.myRewards": "Мої ваучери",
"mc.name": "Призвище та імя",
"mc.newPassword": "Новий пароль",
"mc.none": "Ще немає звіту.",
"mc.notEnough": "Недостатньо балів",
"mc.notifEmpty": "Ще немає повідомлень.",
"mc.notifOpen": "Переглянути",
"mc.notifTitle": "Повідомлення",
"mc.notifTrack": "Відстежувати",
"mc.notifViewAd": "Переглянути оголошення",
"mc.optInDesc": "Додаткова участь. Ви даєте згоду на публічний показ вибраних нижче речей. Можна змінити в будь-який час.",
"mc.optInTitle": "З'явитися у загальному рейтингу",
"mc.password": "Пароль",
"mc.passwordMismatch": "Паролі не співпадають.",
"mc.phone": "Телефон",
"mc.photoUpdated": "Фото профілю оновлено",
"mc.pointsAwaiting": "Бали в очікуванні",
"mc.pointsBalance": "Бали для витрат",
"mc.pointsOk": "Бали зараховано",
"mc.presentHint": "Покажіть цей QR партнеру: вони сканують його, щоб підтвердити вашу винагороду.",
"mc.presentInStore": "Показати в магазині",
"mc.presentTitle": "Показати цей ваучер",
"mc.privacy": "Конфіденційність та дані",
"mc.privacyDesc": "Завантажте копію всіх особистих даних, які Findloop зберігає про вас (GDPR, ст. 15 та 20).",
"mc.profileSaved": "Профіль оновлено.",
"mc.profileSettings": "Публічний профіль та рейтинги",
"mc.pseudo": "Ім'я або псевдонім",
"mc.redExpired": "Термін дії закінчився",
"mc.redReady": "Показати партнеру",
"mc.redUsed": "Використано",
"mc.redeem": "В redeem",
"mc.registerBtn": "Створити мій акаунт",
"mc.registerTitle": "Створити акаунт клієнта",
"mc.rememberMe": "Запам'ятати мене",
"mc.remove": "Видалити",
"mc.resetDone": "Пароль оновлено. Тепер ви можете увійти.",
"mc.resetExpired": "Ця посилання для скидання недійсна або термін дії закінчився. Запросіть нову нижче.",
"mc.resetSave": "Скинути мій пароль",
"mc.resetTitle": "Новий пароль",
"mc.restitutionConfirmed": "Повернення підтверджено.",
"mc.reward": "Винагорода",
"mc.rewardRedeemed": "Винагорода розблокована! Код:",
"mc.rewardsDesc": "Використовуйте свої бали для привілеїв, які пропонують наші партнери. Баланс:",
"mc.rewardsNone": "Ще немає доступних винагород.",
"mc.rewardsTitle": "Витратити мої бали",
"mc.scoreAwarded": "Добре зроблено! +1 до вашого Finder Score 🎉",
"mc.scoreEarned": "Одержано бал",
"mc.scorePts": "балів",
"mc.scoreThisYear": "Цього року",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Переглянути рейтинги",
"mc.share": "Поділитися",
"mc.statsTitle": "Статистика",
"mc.subtitle": "Слідкуйте за всіма вашими звітами в одному місці.",
"mc.title": "Мій акаунт",
"mc.toLogin": "Вже зареєстровані?",
"mc.toRegister": "Ще немає акаунту?",
"mc.track": "Слідкувати",
"mc.views": "Перегляди",
"mc.visCity": "Місто",
"mc.visCountry": "Країна",
"mc.visLabel": "Товари, видимі в рейтингу:",
"mc.visName": "Ім'я / псевдонім",
"mc.visPhoto": "Фото профілю",
"mc.welcome": "Привіт",
"mc2.acceptFinder": "Прийняти цього finder",
"mc2.accountActivity": "Активність акаунта",
"mc2.adsActive": "{n}/5 активних оголошень",
"mc2.autoDelete": "Автоматичне видалення заплановано на",
"mc2.badgeBronze": "Бронзовий",
"mc2.badgeGold": "Золотий",
"mc2.badgeSilver": "Срібний",
"mc2.boostEarnedAlready": "Він вже приніс вам",
"mc2.boostEarnedWin": "Він приніс вам",
"mc2.boostExpiredWin": "Ваш буст тільки що закінчився — поновіть зі знижкою -20%!",
"mc2.boostExpiresIn": "Ваш буст закінчується через",
"mc2.boostWinDetail2": ". -20% застосовано автоматично, якщо ви поновите протягом 24 годин.",
"mc2.claimCode": "Код для отримання:",
"mc2.codeSentFinder": "Код надісланий finder'у на електронну пошту",
"mc2.daysShort": "{n} д",
"mc2.downloadReceipt": "Завантажити мій чек",
"mc2.error": "Помилка {status}",
"mc2.finderAccepted": "Знайдена особа підтверджена — код відправлено на електронну пошту",
"mc2.finderContacts": "Контактні дані знайдених осіб",
"mc2.followFindo": "Слідкуйте за Findloop",
"mc2.imgInvalid": "Недійсне зображення",
"mc2.inactivityNote": " — у разі {n} місяців неактивності (GDPR).",
"mc2.lastActivity": "Остання активність:",
"mc2.lostEmailTitle": "У мене більше немає доступу до моєї електронної пошти",
"mc2.noPhotoPreset": "Ще немає фото? Виберіть стандартний аватар:",
"mc2.paidViaPartner": "Оплачено (через партнера)",
"mc2.payRecovery": "Сплатити відновлення",
"mc2.paySettle": "Урегулювати мій платіж",
"mc2.payShipping": "Сплатити вартість доставки",
"mc2.payUnavailable": "Платіж недоступний",
"mc2.peopleFound": "{n} особа(и) думають, що знайшли ваш предмет",
"mc2.phoneNumber": "Номер телефону",
"mc2.reactivateAccount": "Активувати мій рахунок",
"mc2.reactivated": "Рахунок активовано",
"mc2.reactivatedThanks": "Рахунок активовано — дякуємо за вашу лояльність!",
"mc2.recoverSmsBtn": "Отримати мій код SMS",
"mc2.recoverSmsDesc": "Отримайте код запиту через SMS на номер, зареєстрований на вашому рахунку.",
"mc2.recoverSmsFallback": "Якщо рахунок існує з цим номером, SMS було надіслано.",
"mc2.renewStayTop": ". поновіть, щоб залишитися на верхніх позиціях і відновити свій предмет.",
"mc2.resume20": "Поновити -20%",
"mc2.unlockContacts": "Відкрити контактні дані",
"mc2.unlockDesc": "Сплатіть комісію Findloop, щоб розкрити їх контактні дані та організувати передачу.",
"mc2.viewsWord": "переглядів",
"mc2.live": "Онлайн",
"mh.allCategories": "Всі категорії",
"mh.allPeriod": "Весь час",
"mh.autoMatch": "Авто AI відповідність",
"mh.blocked": "Заблоковано (суперечність)",
"mh.blockedReason": "Відповідність заблокована: основні ключові слова предмета та декларація суперечать один одному.",
"mh.days30": "Останні 30 днів",
"mh.days7": "Останні 7 днів",
"mh.days90": "Останні 90 днів",
"mh.emptyDesc": "AI відповідності з'являться тут, коли надійдуть декларації.",
"mh.emptyTitle": "Немає подій",
"mh.exportCsv": "Експортувати CSV",
"mh.exportDone": "CSV експорт завантажено",
"mh.exportImpossible": "Експорт не вдалий",
"mh.fBlocked": "Заблоковано",
"mh.fConfirmed": "Підтверджено",
"mh.fRejected": "Відхилено",
"mh.objectLabel": "Предмет:",
"mh.refresh": "Оновити",
"mh.rejected": "Відхилено",
"mh.srcManual": "Ручний",
"mh.srcText": "Текст",
"mh.srcVisual": "Візуальний (фото)",
"mh.subtitle": "Журнал відповідностей, запропонованих AI — автоматично збіглі, підтверджені та відхилені.",
"mh.title": "Історія AI",
"nav.ads": "Втрачені предмети",
"nav.dashboard": "Моя зона",
"nav.found": "Знайдені предмети",
"nav.how": "Як це працює",
"nav.login": "Увійти",
"nav.map": "Карта",
"nav.more": "Більше",
"nav.partners": "Партнери",
"nav.pricing": "Ціни",
"nav.ranking": "Рейтинг",
"nav.register": "Станьте партнером",
"nav.track": "Відстежити декларацію",
"nf.desc": "Сторінка, яку ви шукаєте, не існує або була переміщена.",
"nf.home": "Повернутися на головну",
"nf.title": "Сторінка не знайдена",
"par.allCities": "Усі міста",
"par.allCountries": "Усі країни",
"par.badge": "Каталог",
"par.certified": "Сертифікований",
"par.certifiedBadge": "Сертифікований",
"par.cityPh": "Місто",
"par.declare": "Повідомити",
"par.none": "Партнер не знайдений.",
"par.partnerBadge": "Партнер",
"par.searchPh": "Пошук закладу…",
"par.subtitle": "Знайдіть заклад, де ви загубили свій предмет, і повідомте про втрату.",
"par.title": "Наші партнери",
"pay.addr1": "Адреса",
"pay.addr2": "Адреса рядком 2 (необов'язково)",
"pay.addrIncomplete": "Будь ласка, заповніть вашу адресу доставки.",
"pay.badge": "Відновлення",
"pay.card": "Оплата карткою",
"pay.city": "Місто",
"pay.country": "Країна",
"pay.eurNote": "Суми вказані в євро (€).",
"pay.fee": "Плата за відновлення",
"pay.free": "безкоштовно",
"pay.howRecover": "Як ви хочете отримати свій предмет назад?",
"pay.momo": "Оплата через Mobile Money",
"pay.momoConfirm": "Підтвердити оплату",
"pay.noMatch": "Для цієї декларації поки що не підтверджено жодного відповідного предмета.",
"pay.notfound": "Декларацію не знайдено.",
"pay.phonePh": "Номер телефону",
"pay.pickup": "Забрати особисто",
"pay.pickupDesc": "У",
"pay.postal": "Поштовий індекс",
"pay.secure": "Безпечна оплата",
"pay.serviceFee": "плата за послуги Findloop",
"pay.ship": "Відправити мені",
"pay.shipAfter": "— пропонується після оплати.",
"pay.shipDesc": "Доставка за моєю адресою",
"pay.shipNote": "Доставка доступна",
"pay.shipping": "Плата за доставку",
"pay.subtitleWith": "Оплатіть плату за відновлення до",
"pay.title": "Відновити мій предмет",
"pay.total": "Сума",
"pcat.city_hall": "Міські ради",
"pcat.hotel": "Готелі",
"pcat.other": "Інше",
"pcat.park": "Парки",
"pcat.prefecture": "Префектури",
"pcat.restaurant": "Ресторани",
"pcat.uncategorized": "Некатегоризоване",
"pd.about": "Про",
"pd.back": "Усі партнери",
"pd.certified": "Сертифікований партнер",
"pd.declare": "Повідомити про втрату тут",
"pd.itemsReturned": "повернені предмети",
"pd.itemsTotal": "зареєстровані предмети",
"pd.map": "Локація",
"pd.noItems": "Останнім часом не знайдено жодного предмета.",
"pd.noReviews": "Ще немає відгуків.",
"pd.notFound": "Партнера не знайдено.",
"pd.recentItems": "Нещодавно знайдені предмети",
"pd.reply": "Відповідь від закладу",
"pd.reviews": "Відгуки клієнтів",
"pd.verified": "Перевірений відгук",
"pd.verifiedEstablishment": "перевірений заклад Findloop",
"pg.next": "Далі",
"pg.prev": "Назад",
"pg.showing": "{from}–{to} з {total}",
"pk.bodyCopy": "Текст",
"pk.bodyText": "Основний текст",
"pk.brandColors": "Кольори бренду",
"pk.colorRed": "Червоний",
"pk.colorWhite": "Білий",
"pk.darkBg": "Темний фон",
"pk.download": "Завантажити",
"pk.downloadZip": "Завантажити весь комплект (ZIP)",
"pk.headings": "Заголовки",
"pk.heroDesc": "Офіційні логотипи, банери в соціальних мережах, кольори та типографіка. Виберіть мову слогану та варіант, а потім завантажте візуал або весь комплект.",
"pk.lightBg": "Світлий фон (друк)",
"pk.logoWordmark": "Логотип / словесний знак",
"pk.logosVisuals": "Логотипи та візуали",
"pk.mapCollect": "Карта / пункти збору",
"pk.plain": "Простий",
"pk.pressKit": "Прес-кіт",
"pk.taglineLang": "Мова слогану",
"pk.typography": "Типографіка",
"pk.variant": "Варіант",
"pr.shipBtn": "Замовити доставку предмета",
"pr2.adBoostMsg": "Чудовий вибір! Ви збільшуєте свої шанси на швидке повернення предмета.",
"pr2.boostActivated": "Підвищення активовано!",
"pr2.canRecoverNow": "Тепер ви можете повернути свій предмет.",
"pr2.continue": "Продовжити",
"pr2.downloadReceiptPdf": "Завантажити чек (PDF)",
"pr2.goToSpaceNow": "Перейти до мого облікового запису зараз",
"pr2.partnerBoostMsg": "Чудовий вибір! Більша видимість означає залучення нових клієнтів до вашого закладу.",
"pr2.paymentSuccess": "Платіж успішний!",
"pr2.redirectingSpace": "Перенаправлення на ваш обліковий запис…",
"pr2.subActivated": "Платіж успішний! Ваша підписка активна, ви тепер можете керувати своїми закладами.",
"prev.allSites": "Всі заклади",
"prev.editReply": "Редагувати відповідь",
"prev.none": "Ще немає відгуків.",
"prev.published": "Відповідь опублікована",
"prev.reply": "Відповідь",
"prev.replyPh": "Напишіть ввічливу відповідь…",
"prev.send": "Опублікувати відповідь",
"prev.sending": "Публікація…",
"prev.yourReply": "Ваша відповідь",
"pricing.annual": "Щорічно",
"pricing.annualBadge": "-20% пропозиція",
"pricing.choose": "Виберіть",
"pricing.compareFeature": "Особливість",
"pricing.compareTitle": "Порівняти плани",
"pricing.eyebrow": "Ціноутворення",
"pricing.month": "/міс",
"pricing.monthly": "Щомісячно",
"pricing.perYear": "/рік",
"pricing.popular": "Популярний",
"pricing.quoteMsg": "Ваші потреби (допоміжно)",
"pricing.quoteOrg": "Організація",
"pricing.quoteSend": "Відправити запит",
"pricing.quoteSent": "Запит надіслано! Ми зв’яжемося з вами найближчим часом.",
"pricing.quoteSites": "Кількість сайтів / терміналів",
"pricing.quoteTitle": "Запит на отримання кошторису",
"pricing.requestQuote": "Запит на отримання кошторису",
"pricing.saveLabel": "Ви економите",
"pricing.savePerYear": "/рік за додатковий заклад",
"pricing.start": "Почати",
"pricing.subtitle": "Почніть безкоштовно, масштабуйте, коли зростаєте.",
"pricing.title": "План для кожної організації",
"promo.badge": "Партнерська програма",
"promo.cta": "Дізнатися більше",
"promo.text": "Кожен партнер, якого ви порекомендуєте, підписавшись, надає вам один безкоштовний місяць. Без обмежень.",
"promo.title": "Порекомендуйте партнера, отримайте безкоштовний місяць.",
"pub.accessGranted": "Доступ надано",
"pub.accessLimited2h": "Доступ обмежено на 2 години",
"pub.accountEmailConcerned": "Електронна пошта зацікавленого акаунта",
"pub.adAppearPublic": "Ось як ваша реклама з'явиться публічно.",
"pub.adPreviewBtn": "Попередній перегляд реклами",
"pub.alertMeOnArrival": "Повідомити мене про прибуття",
"pub.allActionsLogged": "Усі дії записуються",
"pub.allCategories": "Усі категорії",
"pub.authorizeAccess": "Авторизувати доступ",
"pub.authorizeSupportQ": "Авторизувати доступ до підтримки?",
"pub.available": "Доступно",
"pub.backHome": "Назад на головну",
"pub.boostAdCta": "Просунути мою рекламу",
"pub.boostAdTitle": "Просунути вашу рекламу",
"pub.boostCarouselSub": "Перемістіть на верхню частину сторінки в каруселі “Просунутих” та помножте перегляди, щоб швидше повернути ваш предмет.",
"pub.boostEstablishment": "Просунути ваш заклад",
"pub.boostEstablishmentDesc": "З’являйтеся на верху каталогу з ярликом “Просунутий” та залучайте більше звітів.",
"pub.boostFicheCta": "Просунути мою сторінку",
"pub.brandReady": "Бренд Findloop, готовий до використання",
"pub.cantFindItem": "Не можете знайти ваш предмет?",
"pub.cantProcessImage": "Не вдалося обробити це зображення",
"pub.claimQr": "Отримати QR-код",
"pub.clickToZoom": "Натисніть, щоб збільшити",
"pub.codeAlreadyValidated": "Код підтверджено — контакти розблоковано.",
"pub.codeExample": "напр. ABCD2345",
"pub.confirmRenewal": "Підтвердити продовження",
"pub.contactIntro": "Запитання, прохання? Напишіть нам, ми зв’яжемося з вами найближчим часом.",
"pub.contactTypeDeceased": "Видалення акаунта (померла особа)",
"pub.contactTypeGeneral": "Загальне запитання",
"pub.contactTypeSupport": "Підтримка / технічна проблема",
"pub.contactUs": "Зв’яжіться з нами",
"pub.continueWithoutEmail": "Продовжити без залишення електронної пошти",
"pub.contractLabel": "Контракт",
"pub.contractNotFound": "Контракт не знайдено або вже закінчився.",
"pub.contractRenewed": "Контракт продовжено!",
"pub.contractRenewedFor": "Ваш контракт продовжено на {n} місяців.",
"pub.copyFailed": "Копіювання не вдалося",
"pub.createPartnerAccount": "Створити мій партнерський акаунт",
"pub.currentDeadline": "Поточний термін",
"pub.deceasedInfo": "Як родич або спадкоємець, ви можете запросити видалення акаунта Findloop померлої особи. Ми обробимо ваше прохання відповідно до GDPR (можуть бути запитані підтверджуючі документи).",
"pub.declareMyLoss": "Повідомити про мою втрату",
"pub.describeItemPlaceholder": "Опишіть ваш предмет (наприклад, чорний парасоль, ключі…)",
"pub.downloadImage": "Завантажити зображення",
"pub.drawSignature": "Будь ласка, накресліть свій підпис.",
"pub.drawSignatureHint": "Накресліть свій підпис мишею або пальцем.",
"pub.duration": "Тривалість",
"pub.eSignature": "Електронний підпис",
"pub.eSignatureDesc": "Введіть своє ім'я для підпису. Дата зафіксована автоматично.",
"pub.edit": "Редагувати",
"pub.editorialTitles": "Редакційні заголовки",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "Введіть отриманий по електронній пошті код, щоб розблокувати контактні дані власника.",
"pub.errorWord": "Помилка",
"pub.foundSelfService": "Знайдені предмети · Самообслуговування",
"pub.haveOwnerCode": "Я отримав код від власника",
"pub.home": "Головна",
"pub.immediateRenewal": "Негайне поновлення, без нової пропозиції.",
"pub.impAdminReq1": "Адміністратор",
"pub.impAdminReq2": "потребує дозволу на тимчасовий доступ до вашого облікового запису",
"pub.impAdminReq3": "щоб допомогти вам.",
"pub.impGrantedDesc": "Команда підтримки зможе отримати доступ до вашого облікового запису на максимальний термін 2 години. Усі дії будуть зафіксовані. Ви можете закрити цю сторінку.",
"pub.invitedOnFindo": "Вас запросили до Findloop",
"pub.isThisYourItem": "Це ваш предмет?",
"pub.itemsAvailableCount": "{n} предмет(и) наразі доступні",
"pub.itemsFoundOwner": "знайдених довірених предметів, які знайшли свого власника",
"pub.itemsReturnedOwners": "предмети повернуті їх власникам",
"pub.itsMine": "Це моє",
"pub.joinFindoDesc": "Приєднайтесь до Findloop та легко керуйте вашими знайденими предметами.",
"pub.joinInvitesYou": "запрошує вас приєднатися до findloop. Створіть свій партнерський обліковий запис для керування знайденими предметами.",
"pub.linkCopied": "Посилання скопійовано!",
"pub.loadingContract": "Завантаження контракту…",
"pub.lsClaimDesc": "Повідомте про свою втрату, щоб її відшукати. Залиште свою електронну пошту, і ми надішлемо вам нагадування, якщо ваш звіт не буде завершено.",
"pub.lsHeroDesc": "Перевірте самостійно, чи було знайдено ваш загублений предмет і залишено тут. Знайшли? Повідомте про це, щоб його відшукати.",
"pub.lsSearchTitle": "Пошук знайдених предметів",
"pub.makeOffer": "Сформулювати пропозицію",
"pub.makeOfferDesc": "Пропонуйте свою суму. Суперадміністратор її перегляне.",
"pub.mapNearYou": "Предмети та партнери біля вас",
"pub.mapWord": "Карта",
"pub.messageSentToast": "Повідомлення надіслано — наша команда найближчим часом відповість.",
"pub.messageWord": "Повідомлення",
"pub.momoInitiated": "Ініційовано оплату Mobile Money",
"pub.monthsWord": "місяців",
"pub.nameConsentRequired": "Ім'я та згода потрібні.",
"pub.newDeadline": "Новий термін",
"pub.noActionRequired": "Дії не потрібні.",
"pub.noAmountCharged": "Сума не стягувалася.",
"pub.noItemMatch": "На даний момент немає доступного предмета, який відповідає вашому запиту.",
"pub.noMatchingItem": "Немає відповідного предмета",
"pub.noPaymentSession": "Немає сесії оплати.",
"pub.noPhoto": "Немає фотографії",
"pub.noPointsYet": "Поки немає балів для відображення.",
"pub.noSecondPayment": "Друга оплата для цього предмета не потрібна.",
"pub.notHereYet": "Ще не тут? Отримайте сповіщення, як тільки він прибуде.",
"pub.notifyDone": "Занесено до списку! Ми сповістимо вас електронною поштою, як тільки з'явиться відповідний предмет.",
"pub.offerSubmitted": "Ваша пропозиція надіслана.",
"pub.oops": "Упс",
"pub.orAlertEmail": "Або отримаєте сповіщення електронною поштою, як тільки з'явиться відповідний предмет:",
"pub.ownerContacts": "Контактні дані власника",
"pub.ownerContactsUnlocked": "Контактні дані власника розблоковані",
"pub.partnerContact": "Контакт партнера",
"pub.payLinkUnavailable": "Посилання для оплати недоступне — зв’яжіться з партнером.",
"pub.paymentCancelled": "Платіж скасовано",
"pub.paymentConfirmed": "Платіж підтверджено 🎉",
"pub.paymentConfirmedDesc": "Ви отримаєте електронний лист з деталями для відновлення вашого предмета.",
"pub.paymentNotConfirmed": "Платіж не підтверджено",
"pub.paymentNotConfirmedDesc": "Платіж не вдалося перевірити. Спробуйте ще раз або зв'яжіться з партнером.",
"pub.paymentProcessing": "Платіж обробляється. Оновіть через мить.",
"pub.photoAdded": "✓ Фото додано",
"pub.photoRequired": "Потрібне фото предмета.",
"pub.previewAlt": "перегляд",
"pub.publish": "Опублікувати",
"pub.publishingWord": "Публікується…",
"pub.qty": "Кількість",
"pub.quoteDeclined": "Пропозицію відхилено.",
"pub.quoteNotFound": "Пропозицію не знайдено або термін придатності сплив.",
"pub.reasonLabel": "Причина",
"pub.recoveryAlreadyPaid": "Кошти за відновлення вже сплачені",
"pub.referralCode": "Реферальний код:",
"pub.relationshipPlaceholder": "Син, дружина, нотаріус…",
"pub.renewYourContract": "Продовжте свій контракт",
"pub.renewalFailed": "Не вдалося продовжити. Спробуйте згодом.",
"pub.renewing": "Продовження…",
"pub.replySoon": "Наша команда відповість якнайшвидше.",
"pub.requestGone": "Цей запит більше не існує.",
"pub.requestHandled": "Запит вже оброблено",
"pub.requestNotFound": "Запит не знайдено або термін придатності сплив.",
"pub.requestUnavailable": "Запит недоступний",
"pub.required": "(обов'язково)",
"pub.retroClosing": "Разом ми робимо світ трохи менш загубленим.",
"pub.retroClosing2": "Разом ми робимо світ трохи менш загубленим.",
"pub.retroScroll": "Рік відновлення важливого. Прокрутіть вниз ↓",
"pub.revokeAnytime": "Ви можете відкликати в будь-який час, зв'язавшись з нами",
"pub.scene": "Сцена",
"pub.sendImpossible": "Неможливо надіслати",
"pub.sendMessage": "Надіслати повідомлення",
"pub.sending": "Надсилаю…",
"pub.sharePreview": "Поділитися прев'ю",
"pub.shareYourAd": "Поділитися вашим оголошенням",
"pub.signedSuccess": "Успішно підписано!",
"pub.signerFullName": "Повне ім'я підписувача",
"pub.spreadNetwork": "Поділіться цим з тими, хто вас оточує, щоб збільшити ваші шанси.",
"pub.spreadOwner": "Поділіться цим, щоб допомогти власнику відновити свої речі.",
"pub.statusLabel": "Статус:",
"pub.subject": "Тема",
"pub.thanksSent": "Дякуємо, ваше повідомлення надіслано.",
"pub.thisYear": "Цього року",
"pub.validate": "Валідувати",
"pub.verifyingPayment": "Перевірка платежу…",
"pub.verifyingYourPayment": "Перевірка вашого платежу…",
"pub.viewAd": "Переглянути оголошення →",
"pub.viewPartner": "Переглянути партнера →",
"pub.yourAdPreview": "Попередній перегляд вашого оголошення",
"pub.yourEmail": "Ваш електронний лист",
"pub.yourEmailRecommended": "Ваш електронний лист (рекомендується)",
"pub.yourEmailShort": "Ваш електронний лист",
"pub.yourName": "Ваше ім'я",
"pub.yourRelationship": "Ваші стосунки з особою",
"qv.acceptAndSign": "Прийняти та підписати мою пропозицію",
"qv.certifyAuthorized": "Я підтверджую, що маю право підписувати і приймаю умови цього {what} (обов'язкове значення).",
"qv.clear": "Очистити",
"qv.client": "Клієнт",
"qv.conditions": "Умови",
"qv.confirmDecline": "Підтвердити відмову від цього пропозиції?",
"qv.countersignedFindo": "Підписано Findloop · {name} {date}",
"qv.decline": "Відмовити",
"qv.description": "Опис",
"qv.downloadPdf": "Завантажити PDF",
"qv.handwrittenSignature": "Ручний підпис",
"qv.inclTax": "Включно з ПДВ",
"qv.invalidAmount": "Некоректна сума.",
"qv.invoice": "Рахунок",
"qv.invoicePaid": "Рахунок оплачено",
"qv.issuer": "Емітент",
"qv.messageOptional": "Повідомлення (додатково)",
"qv.negotiatedAmount": "Сума переговорів",
"qv.payInvoiceOnline": "Оплатити рахунок онлайн",
"qv.quote": "Пропозиція",
"qv.quoteValidDays": "Пропозиція дійсна {n} днів.",
"qv.sendMyOffer": "Надіслати мою пропозицію",
"qv.signContract": "Підписати мій контракт",
"qv.signNow": "Підписати зараз",
"qv.signatureAlt": "Підпис",
"qv.signedByOn": "✔ Підписано {name} {date}",
"qv.stContractSigned": "Контракт підписано. Дякуємо!",
"qv.stCounterAccepted": "Ваша пропозиція була прийнята! Підпишіть свій контракт нижче.",
"qv.stCounterRefused": "Ваша пропозиція не могла бути прийнята.",
"qv.stCountered": "Ваша пропозиція надіслана. Очікуємо на відповідь від findloop.",
"qv.stDeclined": "Ви відмовилися від цієї пропозиції.",
"qv.stSigned": "Пропозиція прийнята та підписана. Дякуємо!",
"qv.totalHt": "Всього без ПДВ",
"qv.totalTtc": "Всього з ПДВ",
"qv.unitHt": "Одиниця без ПДВ",
"qv.vat": "ПДВ",
"qv.yourProposedAmount": "Ваша запропонована сума ({cur})",
"rate.chooseNote": "Будь ласка, оберіть рейтинг.",
"rate.commentPh": "Коментар (додатково)…",
"rate.home": "Повернутися на головну",
"rate.submit": "Надіслати мій відгук",
"rate.submitting": "Надсилається…",
"rate.subtitle": "Як пройшло відновлення вашого предмета?",
"rate.successText": "Ваш відгук допомагає іншим користувачам.",
"rate.successTitle": "Дякуємо за ваш відгук!",
"rate.title": "Оцініть свій досвід",
"reg.add": "Зареєструвати предмет",
"reg.allBrands": "Усі бренди",
"reg.allColors": "Усі кольори",
"reg.allLocations": "Усі місця",
"reg.detailDesc": "Деталі та дії для знайденого предмета.",
"reg.dispAuction": "Аукціон",
"reg.dispAuthorities": "Передано владі",
"reg.dispDestroyed": "Знищено",
"reg.dispDonate": "Пожертвування на благодійність",
"reg.dispositionHint": "Запишіть предмет, що залишає зберігання. Підраховано в статистиці за категорією.",
"reg.emptyCta": "Зареєструвати предмет",
"reg.emptyDesc": "Почніть з реєстрації вашого першого знайденого предмета.",
"reg.emptyTitle": "Предметів не знайдено",
"reg.establishmentFallback": "установа",
"reg.lblAuctioned": "перелік на аукціоні",
"reg.lblAuctionedShort": "аукціон",
"reg.lblAuthorities": "передано владі",
"reg.lblDestroyed": "знищено",
"reg.lblDonated": "пожертвовано на благодійність",
"reg.legalCount": "{n} предмет(и): досягнуто законного терміну зберігання",
"reg.legalHint": "Ви можете виставити їх на аукціон, пожертвувати на благодійність або повідомити про передачу владі.",
"reg.legalLimitCountry": "Кінцевий термін: {date} · країна застосування: {country}",
"reg.legalOver": "Термін закінчився: {date} · {country}",
"reg.legalReached": "Досягнуто законного терміну",
"reg.legalReachedFull": "Досягнуто законного терміну зберігання",
"reg.limitShort": "термін",
"reg.location": "Локація",
"reg.markRestituted": "Позначити як повернуте",
"reg.markedAs": "Предмет позначено як {label}",
"reg.moveHistory": "Історія переміщення",
"reg.overBy": "перевищено на {n}д",
"reg.physicalLocation": "Фізичне місцезнаходження",
"reg.popupBlocked": "Дозвольте спливаючі вікна для друку етикеток.",
"reg.popupBlockedOne": "Дозвольте спливаюче вікно для друку етикетки.",
"reg.printLabel": "Друкувати етикетку",
"reg.printN": "Друкувати {n} етикетку(и)",
"reg.qrCodeItem": "QR код предмета",
"reg.qrLabelTitle": "QR етикетка",
"reg.qrLabelsTitle": "QR етикетки",
"reg.qrNotFound": "Не знайдено предмета за цим QR кодом.",
"reg.qrScanHint": "Скануйте, щоб безпосередньо відкрити цей запис та знайти місцезнаходження.",
"reg.recoveryFee": "Плата за відновлення (€)",
"reg.searchPh": "Пошук за описом…",
"reg.selectQr": "Виберіть для друку QR етикеток",
"reg.selectedN": "{n} вибрано",
"reg.shipPricePh": "Вартість доставки (€)",
"reg.shippingPossible": "Доставка доступна",
"reg.storagePh": "наприклад, Полиця A3, Шафа 12",
"reg.tAuction": "Аукціон на Findloop",
"reg.tAuthorities": "Повідомити про передачу владі",
"reg.tDonate": "Пожертвувати на благодійність",
"reg.toastFee": "Плата оновлена",
"reg.toastLocation": "Місцезнаходження збережено",
"reg.toastRestituted": "Предмет позначено як повернуте",
"reg.toastShipping": "Опція доставки оновлена",
"reg.toastTransferred": "Предмет передано «{name}»",
"reg.unclaimedDisposition": "Непридбаний предмет — остаточне розпорядження",
"res.codeValidated": "Код підтверджено",
"res.empty": "Ще немає зафіксованого повернення.",
"res.error": "Помилка {status}",
"res.proofPdf": "PDF доказ",
"res.signed": "Підписано",
"res.stRestituted": "Передано особисто",
"res.stShipped": "Повернуто шляхом доставки",
"res.subtitle": "Всі завершені передачі з їх завантажуваними підписаними доказами.",
"res.title": "Історія повернень",
"rev.b2b": "Партнери B2B",
"rev.b2c": "Клієнти",
"rev.based": "на основі {n} відгуків",
"rev.eyebrow": "Свідчення",
"rev.restitutedBy": "Повернуто {org}",
"rev.storiesEyebrow": "Щасливі фінали",
"rev.storiesSubtitle": "Реальні історії від клієнтів, які повернули свої речі з findloop.",
"rev.storiesTitle": "Вони знайшли свої речі!",
"rev.subtitle": "Партнери та клієнти діляться своїм досвідом.",
"rev.title": "Вони довіряють Findloop",
"rev.verified": "Підтверджено",
"rp.already": "Ви вже повідомляли про цей запис.",
"rp.comment": "Деталі (необов'язково)",
"rp.duplicate": "Дубль",
"rp.fraud": "Шахрайство / обман",
"rp.inappropriate": "Неприпустимий контент",
"rp.offensive": "Образливий контент",
"rp.other": "Інше",
"rp.reason": "Причина",
"rp.report": "Поскаржитись",
"rp.send": "Надіслати скаргу",
"rp.sent": "Скаргу надіслано. Дякуємо за ваш внесок.",
"rp.spam": "Спам / реклама",
"rp.title": "Поскаржитись на це оголошення",
"rp.wrongCategory": "Неправильна категорія",
"rt.annualGoal": "Річна мета",
"rt.championCity": "Місто-лідер",
"rt.cityRate": "{rate}% повернення",
"rt.goalProgress": "{rate}% досягнуто з мети {target}%",
"rt.reached": "Досягнуто 🎉",
"rt.restitutionRate": "Коефіцієнт повернення",
"rt.shareRecap": "Поділитися моєю доповіддю",
"rt.thanks": "Дякую Findloop {year} 💛",
"rt.yourRecap": "Ваша доповідь за {year}",
"rw.active": "Активно",
"rw.add": "Додати",
"rw.camUnavailable": "Камера недоступна. Введіть код вручну нижче.",
"rw.codeValidated": "Код підтверджено",
"rw.codesTitle": "Коди, які були погашені користувачами",
"rw.confirmDelete": "Видалити “{title}”?",
"rw.deleted": "Видалено",
"rw.edit": "Редагувати",
"rw.editReward": "Редагувати винагороду",
"rw.empty": "Немає винагороди.",
"rw.expired": "Термін дії закінчився",
"rw.expiresOn": "Термін дії до {date}",
"rw.fActive": "Активно (видимо користувачам)",
"rw.fCost": "Вартість (бали)",
"rw.fDesc": "Опис",
"rw.fStock": "Запас (порожньо = без обмежень)",
"rw.fTitle": "Назва",
"rw.fValidity": "Термін дії ваучера (дні після погашення)",
"rw.inactive": "Неактивно",
"rw.newReward": "Нова винагорода",
"rw.noExchange": "Без погашення.",
"rw.pageSubtitle": "Скануйте ваучери, представлені користувачами, щоб підтвердити їхні винагороди.",
"rw.redeemedN": "Погашено: {n}×",
"rw.saved": "Винагороду збережено",
"rw.scanVoucher": "Сканувати ваучер",
"rw.staffScanOnly": "Сканувати тільки",
"rw.statActive": "Представлено",
"rw.statExpired": "Термін дії закінчився",
"rw.statRedeemed": "Ваучери погашені",
"rw.statUsed": "Підтверджено",
"rw.stock": "Запас",
"rw.subtitle": "Пропонуйте немонетарні переваги (ваучери, покращення…) які користувачі можуть погашати за свої бали Finder Score.",
"rw.title": "Винагороди для користувачів",
"rw.used": "Використано",
"rw.validate": "Підтвердити",
"rw.validateCode": "Підтвердити код",
"rw.validity": "Термін дії: {n} д",
"shell.f1d": "Автоматично пов'язувати загублені та знайдені предмети.",
"shell.f1t": "Смарт AI підбір",
"shell.f2d": "Відстежуйте рівень повернення та доходи в режимі реального часу.",
"shell.f2t": "Дашборд та доходи",
"shell.f3d": "Ваші клієнти звітують за 30 секунд.",
"shell.f3t": "QR-код партнера",
"shell.title": "Перетворіть втрачені речі на задоволених клієнтів.",
"ship.addr1": "Адреса",
"ship.addr2": "Лінія адреси 2 (необов'язково)",
"ship.badge": "Доставка",
"ship.city": "Місто",
"ship.country": "Країна",
"ship.needPaid": "Спершу сплатіть збір за відновлення, щоб запросити доставку.",
"ship.notShippable": "Цю річ не можна доставити.",
"ship.notfound": "Звіт не знайдено.",
"ship.postal": "Поштовий індекс",
"ship.price": "Вартість доставки",
"ship.submit": "Запросити доставку",
"ship.submitting": "Відправляється…",
"ship.subtitle": "Введіть вашу адресу доставки.",
"ship.successText": "Партнер підготує вашу посилку. Ви будете сповіщені після відправлення.",
"ship.successTitle": "Запит на доставку надіслано!",
"ship.title": "Доставте вашу річ",
"ship.weight": "Орієнтовна вага (кг)",
"shp.carrier": "Перевізник",
"shp.download": "Завантажити PDF",
"shp.generating": "Генерується…",
"shp.label": "Генерувати етикетку",
"shp.none": "Доставка не запитана.",
"shp.setTracking": "Зберегти трекінг",
"shp.status": "Статус",
"shp.to": "Одержувач",
"shp.tracking": "Номер трекінгу",
"shp.trackingSaved": "Трекінг збережено",
"side.account": "Мій аккаунт",
"side.declarations": "Звіти",
"side.deposit": "Зареєструвати річ",
"side.establishments": "Установи",
"side.invoices": "Рахунки",
"side.logout": "Вийти",
"side.matchHistory": "Історія AI",
"side.partner": "Партнер",
"side.refresh": "Оновити",
"side.registry": "Реєстр",
"side.restitutions": "Повернення",
"side.reviews": "Відгуки",
"side.rewards": "Нагороди та ваучери",
"side.settings": "Налаштування",
"side.shipments": "Відправлення",
"side.stats": "Статистика",
"side.storage": "Сховище та QR",
"side.team": "Команда",
"side.viewSite": "Переглянути публічний сайт",
"st.auctioned": "Продано на аукціоні",
"st.claimed": "Претендується",
"st.closed": "Закрито",
"st.delivered": "Доставлено",
"st.destroyed": "Знищено",
"st.donated": "Подаровано (на благодійність)",
"st.handed_to_authorities": "Передано владі",
"st.in_storage": "На складі",
"st.matched": "Знайдено збіг",
"st.open": "Відкрити",
"st.paid": "Сплачено",
"st.pending": "В очікуванні",
"st.resolved": "Вирішено",
"st.restituted": "Повернуто",
"st.second_chance": "Другий шанс",
"st.shipped": "Відправлено",
"st.shipping_requested": "Запит на доставку",
"st.submitted": "Подано",
"st.verified": "Перевірено",
"stat.items": "Зареєстровані предмети",
"stat.partners": "Партнери",
"stat.restituted": "Повернуті предмети",
"status.auctioned": "Викладено на аукціон",
"status.destroyed": "Знищено",
"status.donated": "Пожертвувано (на благодійність)",
"status.handed_to_authorities": "Передано владі",
"status.in_storage": "На складі",
"status.matched": "Збіг",
"status.open": "Відкрити",
"status.paid": "Сплачено",
"status.pending": "В очікуванні",
"status.restituted": "Повернуто",
"status.shipped": "Відправлено",
"status.shipping_requested": "Запит на доставку",
"status.submitted": "Подано",
"step1.tag": "Установа",
"step1.text": "За кілька секунд установа реєструє знайдений предмет з фото, категорією та описом. Усе централізоване в зрозумілому, безпечному реєстрі.",
"step1.title": "Партнер реєструє предмет",
"step2.tag": "Клієнт",
"step2.text": "За допомогою QR-коду партнера ваш клієнт описує втрачений предмет за 30 секунд. Не потрібно встановлювати додаток — усе відбувається в браузері.",
"step2.title": "Клієнт повідомляє про втрату",
"step3.tag": "Інтелект",
"step3.text": "Наш інтелектуальний механізм зіставлення порівнює описи та пропонує найбільш ймовірні варіанти, готові до підтвердження.",
"step3.title": "Штучний інтелект пов'язує втрату та знайдений предмет",
"step4.tag": "Відновлення",
"step4.text": "Після безпечної оплати за відновлення клієнт отримує предмет на місці — або отримує його через перевірену доставку.",
"step4.title": "Клієнт отримує свій предмет назад",
"stg.allLabels": "Усі QR-мітки",
"stg.camHint": "Використовуйте ручний ввід нижче.",
"stg.camStarting": "Запуск камери...",
"stg.camUnavailable": "Камера недоступна.",
"stg.clear": "Очистити",
"stg.clearAll": "Очистити все",
"stg.codeUnreadable": "Нечитабельний код.",
"stg.emptyDesc": "Збережені предмети з'являться тут, згруповані за місцем розташування.",
"stg.emptyTitle": "Немає предметів на складі",
"stg.exportAudit": "Експортувати аудит CSV",
"stg.exportDone": "CSV експорт завантажено",
"stg.exportImpossible": "Експорт зараз недоступний.",
"stg.itemFound": "Предмет знайдено ✅",
"stg.kLocations": "Використані місця",
"stg.kObjects": "Збережені предмети",
"stg.kToClear": "Місця для очищення",
"stg.locFreed": "Місце очищено",
"stg.locsFreed": "{n} місце(ць) очищено",
"stg.manualLabel": "Або введіть код / ID предмета",
"stg.manualPh": "Вставте ID або URL QR",
"stg.noItemMatch": "Немає предметів, що відповідають цьому QR / коду.",
"stg.noLocation": "Немає місця",
"stg.objectsAxis": "Предмети",
"stg.objectsN": "{n} предмет(ів)",
"stg.occAvg": "середнє {n} предметів/місце",
"stg.occHint": "Місця в жовтому перевищують середнє (потенційно перевантажені).",
"stg.occupancy": "Завантаження місця",
"stg.openPage": "Відкрити сторінку",
"stg.posterPdf": "PDF постер (A4)",
"stg.printAll": "Друкувати все",
"stg.printGroupTitle": "Друкувати етикетки для цієї полиці",
"stg.qrAlt": "QR для самообслуговування",
"stg.qrDownload": "Завантажити QR",
"stg.qrHint": "Показати цей QR на стійці: ваші клієнти сканують його, щоб перевірити, чи доступний їх предмет.",
"stg.qrTitle": "QR для самообслуговування клієнтів",
"stg.scanDesc": "Скануйте етикетку предмета, щоб миттєво відкрити його запис.",
"stg.scanQr": "Сканувати QR",
"stg.scanTitle": "Сканувати QR-код",
"stg.search": "Пошук",
"stg.shelf": "Полиця {loc}",
"stg.shelfPlan": "План полиці",
"stg.staleHint": "Очистіть ці місця, щоб підтримувати ваш фізичний запас в актуальному стані.",
"stg.staleTitle": "{n} предмет(ів) залишили зберігання, але все ще мають місце",
"stg.subtitle": "План полиці, сканер QR та облік фізичного запасу.",
"stg.title": "Зберігання та QR",
"stt.acceptRate": "Рівень прийняття",
"stt.accepted": "Прийнято",
"stt.activity30": "Активність (останні 30 днів)",
"stt.ai6mo": "Останні 6 місяців · прийнято = автоматично зіставлено + підтверджено.",
"stt.aiEmpty": "Зараз немає AI співпадінь за цей період.",
"stt.aiTitle": "AI співпадіння — прийняті проти відхилених",
"stt.auctionShort": "Аукціон",
"stt.auctionedSold": "Аукціоновано (продано)",
"stt.authShort": "Влади",
"stt.authorities": "Передано владі",
"stt.avgRating": "Середня оцінка",
"stt.awaitingRestitution": "предмети, що чекають на повернення",
"stt.boostClicks": "Кліки на вашій довідці цього тижня завдяки підвищенню",
"stt.boostInactive": "Підвищення неактивне — активуйте його, щоб отримати видимість",
"stt.certifiedPremium": "Преміум сертифікований",
"stt.declarations": "Декларації",
"stt.destroyed": "Знищено",
"stt.dispoEmpty": "Немає необраних предметів, які залишили зберігання.",
"stt.donatedAssoc": "Пожертвувано (благодійність)",
"stt.donatedShort": "Пожертвувано",
"stt.gateCta": "Відкрийте плани",
"stt.gateDesc": "Оновіть до Starter, щоб розблокувати основну статистику, або до Business для розширеної статистики та аналізу по установах.",
"stt.gateTitle": "Статистика, зарезервована для платних планів",
"stt.inStorage": "На зберіганні",
"stt.kItems": "Зареєстровані предмети",
"stt.kRate": "Рівень повернення",
"stt.kRestituted": "Повернуті предмети",
"stt.kRevenue": "Доходи (місяць)",
"stt.noDeclYet": "Декларацій ще немає.",
"stt.recapDownloaded": "Резюме завантажено — готове до обміну!",
"stt.recapError": "Не вдалося згенерувати резюме",
"stt.recapText": "Наше резюме Findloop {year}: повернуті предмети та задоволеність клієнтів 🎉",
"stt.recapTitle": "резюме Findloop {year}",
"stt.rejected": "Відхилено",
"stt.restitutions": "Повернення",
"stt.shareRecap": "Поділитися моїм резюме за {year}",
"stt.topCategories": "Найбільш заявлені категорії",
"stt.unclaimedDesc": "Кількість предметів, які були знищені, передані благодійним організаціям та виставлені на аукціон, за категоріями.",
"stt.unclaimedTitle": "Непоранені предмети — вихід зі сховища",
"stt.vsLastWeek": "в порівнянні з минулим тижнем",
"sub.cancel": "Скасувати підписку",
"sub.cancelAbort": "Скасувати",
"sub.cancelConfirm1": "Ви впевнені, що хочете скасувати? Ваш доступ залишиться активним до",
"sub.cancelConfirm2": "Виплата компенсації не буде здійснена.",
"sub.cancelConfirmBtn": "Підтвердити скасування",
"sub.cancelTitle": "Скасування підписки",
"sub.cancelledToast": "Скасування зафіксовано.",
"sub.cguAnd": "та",
"sub.cguDesc": "Будь ласка, підтверджте свою згоду перед оплатою.",
"sub.cguLink": "Умови використання",
"sub.cguPay": "Продовжити до оплати",
"sub.cguPre": "Я прочитав(ла) та приймаю",
"sub.cguRequired": "Ви повинні прийняти Умови використання та Політику конфіденційності, щоб продовжити.",
"sub.cguSuffix": "від Findloop.",
"sub.cguTitle": "Завершити підписку",
"sub.expiresOn": "Ваша підписка закінчується",
"sub.noProrata": "Без пропорційної компенсації.",
"sub.privacyLink": "Політика конфіденційності",
"sub.renewsOn": "Ваша підписка поновлюється",
"sub.resume": "Підписатися знову",
"sub.resumedToast": "Підписка підтверджена.",
"tier.free": "Фреміум",
"tier.large": "Ентерпрайз",
"tier.medium": "Бізнес",
"tier.small": "Стартовий",
"tm.add": "Додати",
"tm.adminOpt": "Адмін (повний перегляд)",
"tm.chooseEst": "Обрати заклад",
"tm.chooseEstPh": "Обрати заклад",
"tm.copyFail": "Копіювання не вдалося",
"tm.copyLink": "Скопіювати посилання",
"tm.copyOk": "Посилання для запрошення скопійовано",
"tm.emailHint": "Електронний лист запрошення буде надіслано для створення пароля.",
"tm.expiresOn": "закінчується {date}",
"tm.forEmail": " для {email}",
"tm.forbidden": "Управління командою зарезервовано для власника акаунту.",
"tm.inviteCreated": "Запрошення створено",
"tm.inviteDesc": "Електронний лист запрошення дозволяє члену команди створити свій пароль.",
"tm.invitePending": "Запрошення в очікуванні",
"tm.inviteResent": "Запрошення повторно надіслано",
"tm.inviteSent": "Запрошення надіслано електронною поштою",
"tm.inviteTitle": "Запросити учасника",
"tm.invitedOn": "Запрошено {date}",
"tm.linkExpired": "Посилання стало недійсним",
"tm.memberRemoved": "Учасника видалено",
"tm.name": "Ім'я",
"tm.noMembers": "Ще немає учасників команди.",
"tm.resendTitle": "Повторно надіслати запрошення",
"tm.role": "Роль",
"tm.roleAdmin": "Адмін",
"tm.roleOwner": "Власник",
"tm.roleStaff": "Співробітник",
"tm.roleUpdated": "Роль оновлено",
"tm.sendInvite": "Надіслати запрошення",
"tm.sending": "Надсилання…",
"tm.staffOpt": "Співробітник (бачить лише свій заклад)",
"trk.at": "У",
"trk.badge": "Відстеження",
"trk.carrier": "Перевізник",
"trk.codeValidated": "Код підтверджено партнером",
"trk.dlProof": "Завантажити моє підтвердження передачі (PDF)",
"trk.emailLabel": "Електронна пошта (необов'язково — щоб побачити ваші дані)",
"trk.enterEmailCode": "Введіть вашу електронну пошту зверху, щоб відобразити ваш код заяви.",
"trk.idLabel": "Номер звіту",
"trk.lostEmail": "Я більше не маю доступу до своєї електронної пошти",
"trk.phonePh": "Ваш номер телефону",
"trk.photoBefore": "Фото предмета перед відправкою",
"trk.recoverBtn": "Відновити мій предмет",
"trk.recoverHint": "Отримайте ваш код заяви SMS на ваш зареєстрований номер.",
"trk.searching": "Шукаю…",
"trk.secureRest": "Безпечна передача",
"trk.send": "Відправити",
"trk.shipPending": "Відправлення готується — номер відстеження з'явиться тут після відправлення.",
"trk.shipTitle": "Відстеження відправлення",
"trk.showQr": "Показати цей QR партнеру для підтвердження передачі",
"trk.sigSaved": "Підпис збережено",
"trk.signFirst": "Будь ласка, підпишіть перед підтвердженням.",
"trk.signProof": "Підпишіть ваше підтвердження передачі",
"trk.signSubmit": "Підтвердити мій підпис і згенерувати PDF",
"trk.submit": "Відстежувати",
"trk.subtitle": "Введіть номер вашого звіту, щоб відстежити прогрес.",
"trk.title": "Відстежити мій звіт",
"trk.trackShipment": "Відстежити посилку",
"trk.trackingNo": "Номер відстеження",
"trk.yourCode": "Ваш код заяви (щоб передати партнеру)",
"hc.estShipRate": "Оцінка вартості доставки (Sendcloud + {m}% націнка):",
"hc.establishment": "Установа",
"hc.establishment2": "Установа:",
"hc.establishmentInItsSendcloudAccount": "установа у вашому обліковому записі Sendcloud та надає вам ID відправника",
"hc.establishmentSettings": "Налаштування установи",
"hc.exCode": "наприклад, ABCD2345",
"hc.exId": "наприклад, 3f2a…",
"hc.exit": "Вихід",
"hc.explainWhyThisItemIs": "Поясніть, чому цей предмет не ваш…",
"hc.externalPaymentLinks": "Зовнішні платіжні посилання",
"hc.failed": "Не вдалося",
"hc.feesEnabled": "Збори увімкнені",
"hc.field": ") поле.",
"hc.finderAcceptedCloseTheCase": "Finder прийняв — закрийте справу, як тільки предмет буде передано особисто.",
"hc.findoCityRanking": "Findloop — Рейтинг міст",
"hc.findoForEstablishments": "Findloop для установ",
"hc.findoPresentationVideo": "відео-презентація Findloop",
"hc.findoRegistersTheAddressOf": "Findloop реєструє адресу вашого",
"hc.findoReviewShare": "відгук Findloop {year}: {n} предметів повернуто, {rate}% рівень повернення 🎉",
"hc.firstVerifyTheClaimCode": "Спочатку підтвердіть код заяви вище",
"hc.forEveryNewShipmentFrom": "за кожну нову відправку з",
"hc.free": "безкоштовно",
"hc.freeRecovery0": "Безкоштовне відновлення (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Безкоштовне відновлення по всій Африці – Акційна пропозиція",
"hc.freeRecoveryFeesDisabled0": "Безкоштовне відновлення: збори вимкнені (0 €)",
"hc.fromTeamInviteYourColleagues": "З \"Команди\" запрошуйте своїх колег електронною поштою та призначайте їм установу. Кожен учасник бачить лише свою область.",
"hc.fullName": "Повне ім'я",
"hc.fullPhoto": "Повне фото",
"hc.gallery": "Галерея",
"hc.giveTheReasonForCancelling": "Вкажіть причину скасування. Партнер буде поінформований.",
"hc.goToLogin": "Перейти до входу",
"hc.goToMyAccount": "Перейти до мого аккаунта",
"hc.gold": "Золото",
"hc.googleLoginFailed": "Не вдалося увійти за допомогою Google",
"hc.hasConfirmedYourPaymentYou": "підтвердив вашу оплату, ви будете автоматично переадресовані",
"hc.helpCenter": "Центр допомоги",
"hc.helpUsImproveWhyAre": "Допоможіть нам покращити: чому ви йдете? Ваш акаунт буде деактивовано та може бути повторно активовано протягом 30 днів.",
"hc.hidePassword": "Сховати пароль",
"hc.high": "Високий",
"hc.historyOfYourMonthlySubscriptions": "Історія ваших щомісячних підписок та їх статус платежів.",
"hc.hotelBelmont": "Готель Белмонт",
"hc.howConfigureSenderId": "Як налаштувати свій числовий ID відправника?",
"hc.iDonTUseIt": "Я недостатньо його використовую",
"hc.iFoundItElsewhere": "Я знайшов це в іншому місці",
"hc.iNoLongerNeedMy": "Мені більше не потрібен мій товар",
"hc.identityVerification": "Перевірка особи",
"hc.idleLogoutIn": "Ви вийдете з системи через {n} с через бездіяльність.",
"hc.ifProvidedTheVolumetricWeight": "Якщо надано, використовується об'ємна вага.",
"hc.ifThePartnerHasNot": "Якщо партнер не підтвердив отримання зовнішнього платежу після цього терміну, Findloop автоматично нагадує партнеру про його підтвердження.",
"hc.impersonationEnded": "Імітацію завершено.",
"hc.impersonationMode": "Режим імітації",
"hc.impersonationSessionExpired": "Сесія імітації закінчилася.",
"hc.inTheField": ", в полі",
"hc.inTransit": "У процесі транспортування",
"hc.inclVat": "включно з ПДВ",
"hc.intraEuVatNumberOptional": "Внутрішній європейський номер ПДВ необов'язковий, SIRET не потрібен (за межами Франції).",
"hc.invalidInvitationLink": "Недійсне посилання на запрошення.",
"hc.invalidInvitationLink2": "Недійсне посилання на запрошення",
"hc.invalidInviteLink": "Недійсне або прострочене посилання на запрошення.",
"hc.invalidNumberEnterAnInternational": "Недійсний номер. Введіть міжнародний номер, наприклад, +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Недійсне або прострочене посилання.",
"hc.invalidOrExpiredReactivationLink": "Недійсне або прострочене посилання на реактивацію",
"hc.invalidSendcloudId": "Недійсний ID Sendcloud",
"hc.inviteSubtitle": "{org} запрошує вас приєднатися до їхньої команди findloop. Виберіть свій пароль для активації облікового запису.",
"hc.isAvailableOnSendcloudFor": "доступно на Sendcloud для всіх ваших маршрутів (внутрішні + міжнародні).",
"hc.isNotEnabledOnYour": "не увімкнено у вашому обліковому записі Sendcloud для деяких напрямків. Наклейки для них будуть створені з іншим доступним перевізником.",
"hc.isThisReallyYourItem": "Це дійсно ваш товар?",
"hc.isThisYourItem": "Це ваш товар?",
"hc.item": "Товар",
"hc.itemAlreadyConfirmed": "Товар вже підтверджено",
"hc.itemDetails": "Деталі товару",
"hc.itemFoundAt": "Товар знайдено в",
"hc.itemFoundAtAPartner": "Товар знайдено у партнера",
"hc.itemMarkedAsReturned": "Товар позначено як повернений ✓",
"hc.itemPhotoRequiredBeforeShipping": "Фото товару (необхідно перед відправкою)",
"hc.itemPhotoSaved": "Фото товару збережено",
"hc.itemPreview": "Попередній перегляд товару",
"hc.itemPutBackInStorage": "Товар повернуто на зберігання.",
"hc.itemWeight": "Вага товару:",
"hc.itemsReturned": "товар(и) повернено",
"hc.itemsReturnedThisYear": "повернені предмети цього року",
"hc.itemsWhoseLegalDeadlineIs": "Предмети, термін яких спливає за 15 днів або менше (включно з простроченими). Матчі залишаються видимими.",
"hc.kbisNumber": "Номер Kbis",
"hc.keysForgottenOnABench": "Ключі, забуті на лавці",
"hc.labelBeingGenerated": "Мітка генерується",
"hc.leaveTheFieldsEmptyTo": "Залиште поля порожніми, щоб запропонувати безкоштовне відшкодування.",
"hc.legalNotice": "Юридичне повідомлення",
"hc.limitReachedUpgradeToA": "Досягнуто ліміту — оновіть до вищого плану",
"hc.linkCopiedShareOn": "Посилання скопійовано — поділіться ним на {label}",
"hc.linkUnavailable": "Посилання недоступне",
"hc.linkedTo": "Сполучено з",
"hc.listingHiddenByModeration": "Оголошення приховане модерацією.",
"hc.loading": "Завантаження…",
"hc.locateMe": "Знайти мене",
"hc.logIn": "Увійти",
"hc.logInToGetBack": "Увійдіть, щоб повернутися у свій простір та керувати підпискою.",
"hc.loginFailed": "Не вдалося увійти",
"hc.lostFoundPlatform": "Платформа втрат і знаходжень.",
"hc.lostIn": "втрачений у",
"hc.lowRate": "Низька ставка",
"hc.mainReason": "Головна причина",
"hc.mainStreet": "Головна вулиця",
"hc.makeSureThisIsThe": "Переконайтеся, що це предмет, який ви втратили, перед тим як розблокувати контактні дані знахідника.",
"hc.manageCookies": "Керування куками",
"hc.manageMyTeam": "Управляти моєю командою",
"hc.manageYourTeam": "Управляти вашою командою",
"hc.markAsReturned": "Позначити як повернуте",
"hc.matchNoClaimInTime": "На матч не надійшло жодного позову в межах терміну.",
"hc.matchNotFound": "Матч не знайдено",
"hc.medium": "Середній",
"hc.milestoneFmt": "{m} досягнуто повернених предметів! На шляху до {next}.",
"hc.missingFeatures": "Відсутні функції",
"hc.monthly": "Щомісячно",
"hc.monthlyBilling": "Щомісячна виставлення рахунків",
"hc.moveThePhotoToFit": "Перемістіть фото, щоб вмістити його в коло.",
"hc.myAccount": "Мій акаунт",
"hc.myInvoices": "Мої рахунки",
"hc.myMonthlyInvoices": "Мої щомісячні рахунки",
"hc.nArchived": "{n} оголошень архівовано.",
"hc.newCodeGeneratedAndSent": "Новий код згенеровано та надіслано клієнту електронною поштою та SMS",
"hc.newCodeGeneratedAndSent2": "Новий код згенеровано та надіслано власнику",
"hc.newPassword": "Новий пароль",
"hc.next": "Далі",
"hc.nextPhoto": "Наступне фото",
"hc.no": "Ні",
"hc.noAnswerProvided": "Відповіді не надано.",
"hc.noArchivedDeclarations": "Немає архівованих декларацій",
"hc.noCountryFound": "Країну не знайдено",
"hc.noDeclarations": "Немає декларацій",
"hc.noFeesAreChargedTo": "Платежі з клієнта не стягуються.",
"hc.noInvoiceYet": "Ще немає рахунку.",
"hc.noInvoiceYetYourInvoices": "Ще немає рахунку. Ваші рахунки з'являться тут автоматично після кожного платежу.",
"hc.noMatchIsAvailableFor": "Відповідностей наразі немає. Ми повідомимо вас, як тільки з’явиться товар, що відповідає вашій декларації.",
"hc.noShipmentMatchesYourSearch": "Жодна відправка не відповідає вашому запиту.",
"hc.noShipmentsYet": "Ще немає відправлень.",
"hc.noShipmentsYet2": "Ще немає відправлень",
"hc.none": "немає",
"hc.noneChooseForEachShipment": "Немає (оберіть для кожної відправки)",
"hc.notMine": "Це не моє",
"hc.of": "з",
"hc.only": "Тільки",
"hc.onlyEachSiteManagesIts": "лише. Кожен сайт керує своїми банківськими рахунками: ці посилання не впливають на жодний інший заклад.",
"hc.onlyTheOwnerOrAn": "Тільки власник або адміністратор можуть налаштувати платіжні посилання закладу.",
"hc.openDepositInTheMenu": "Відкрийте \"Депозит\" у меню, опишіть товар і зробіть фото. Воно одразу зберігається та готове до повернення.",
"hc.openSettings": "Відкрийте Налаштування →",
"hc.openTheDeclarationToManage": "Відкрийте декларацію для керування відправкою",
"hc.optional": "— необов'язковий",
"hc.optional2": "(необов'язковий)",
"hc.optional3": "необов'язковий",
"hc.originalListingPhotoUsed": "Використано оригінальне фото оголошення",
"hc.other": "Інше",
"hc.other2": "Інше…",
"hc.ourProducts": "Наші продукти",
"hc.overallRateTrendLast6": "Загальна тенденція ставок (останні 6 місяців)",
"hc.ownerSClaimCode": "Код претензії власника",
"hc.ownershipConfirmed": "Права власності підтверджено",
"hc.paid": "Сплачено",
"hc.paidOn": "Сплачено",
"hc.paidViaPartner": "Оплачено (через партнера)",
"hc.parcelBeingPrepared": "Посилка готується",
"hc.parcelDelivered": "Посилка доставлена",
"hc.parcelShipped": "Посилку відправлено",
"hc.parisGareDeLyon": "Париж, Гара де Ліон…",
"hc.partner": "Партнер",
"hc.partner2": "партнер",
"hc.partnerDirectory": "Каталог партнерів",
"hc.passedOnToTheCustomer": "— надіслано клієнту посилання для оплати.",
"hc.password": "Пароль",
"hc.passwordResetPleaseLogIn": "Скидання пароля, будь ласка, увійдіть.",
"hc.passwordUpdated": "Пароль оновлено.",
"hc.passwordsDoNotMatch": "Паролі не співпадають.",
"hc.pasteThisSenderIdIn": "Вставте цей ID відправника в Findloop → Налаштування",
"hc.payForTheShipmentOf": "Оплату за доставку вашого товару через Findloop з безпечним платежем.",
"hc.payTheRecoveryFees": "Сплатіть збори за відновлення",
"hc.payTheShippingFees": "Сплатіть збори за доставку",
"hc.payment": "Оплата",
"hc.paymentAlreadyConfirmedByThe": "Оплата вже підтверджена партнером",
"hc.paymentLinksAreNowConfigured": "Посилання на оплату тепер налаштовані для кожного закладу",
"hc.paymentNotCompletedYourAccount": "Оплату не завершено, ваш акаунт не створено — будь ласка, спробуйте ще раз.",
"hc.paymentReceived": "Оплату отримано",
"hc.paymentSuccessful": "Оплата успішна!",
"hc.pdfInvoice": "PDF рахунок",
"hc.pending": "Очікує",
"hc.period": "Період",
"hc.phoneNumber": "Номер телефону",
"hc.phoneOptional": "Телефон (за бажанням)",
"hc.planAt": "план на",
"hc.planLimitFmt": "Ваш план \"{plan}\" обмежений {max} закладами. Щоб керувати {n} сайтами, ми рекомендуємо",
"hc.platformReturnTarget": "Ціль повернення платформи",
"hc.pleaseCompleteYourShippingAddress": "Будь ласка, заповніть вашу адресу доставки.",
"hc.pleaseProvideAPhoneNumber": "Будь ласка, надайте номер телефону: це вимагає перевізник для доставки.",
"hc.pleaseProvideAReason": "Будь ласка, надайте причину.",
"hc.pleaseSetYourOwnPassword": "будь ласка, встановіть свій власний пароль перед продовженням.",
"hc.pointsToGoal": "{n} додаткових балів до нашої спільної мети.",
"hc.posterPreview": "Попередній перегляд плакату",
"hc.potentialMatchBeingVerified": "Потенційна відповідність перевіряється",
"hc.potentialOwner": "Потенційний власник",
"hc.preFilledAutomaticallyYouCan": "Автоматично заповнено — ви можете замінити це фотографією посилки.",
"hc.pressKit": "Прес-кит",
"hc.previewMode": "Режим попереднього перегляду:",
"hc.previewOfThePrintReady": "Попередній перегляд готового для друку постера A4 для цього закладу.",
"hc.previous": "Попередній",
"hc.previousPhoto": "Попереднє фото",
"hc.primary": "основний",
"hc.printThePoster": "Надрукувати постер",
"hc.privacy": "Конфіденційність",
"hc.privacyPolicy": "Політика конфіденційності",
"hc.processedCasesWillAppearHere": "Оброблені справи з'являться тут.",
"hc.proofOfReturnPdf": "Доказ повернення (PDF)",
"hc.protectedByRecaptcha": "Захищено reCAPTCHA",
"hc.publicMatch": "Публічне співпадіння",
"hc.putBackInStorage": "Повернути в сх storage",
"hc.pwdResetByTeam": "Ваш пароль було скинуто нашою командою. Для вашої безпеки,",
"hc.questionsToAskTheOwner": "Питання до власника",
"hc.rateChargedToTheCustomer": "Тариф, що стягується з клієнта:",
"hc.rateOfTarget": "{rate}% досягнуто з {target}% цілі",
"hc.reached": "досягнуто",
"hc.reactivating": "Активується знову…",
"hc.reasonSavedYouCanStill": "Причина збережена. Ви все ще можете вимагати свій предмет.",
"hc.recentMatchesFirst": "Найновіші співпадіння першими",
"hc.recognizedThePhotoYouSent": "розпізнав фото, яке ви надіслали, і описав ці характеристики. Підтверджуйте лише в разі, якщо вони відповідають предмету у вашій власності.",
"hc.recommended": "Рекомендовано",
"hc.recoveryFees": "Платежі за відновлення",
"hc.recoveryFeesArePaidDirectly": "Платежі за відновлення сплачуються безпосередньо партнерському закладу. Findloop не отримує оплату від клієнтів.",
"hc.recoveryFeesEnabled": "Платежі за відновлення увімкнені",
"hc.recoveryOfferedByTheEstablishment": "Відновлення, запропоноване закладом — Findloop не стягує жодних зборів.",
"hc.recoveryPaymentLink": "Посилання для оплати відновлення",
"hc.recoveryPaymentLinkSavedFor": "Посилання для оплати відновлення збережене для цього закладу",
"hc.redirecting": "Перенаправляємо…",
"hc.redirectingToPayment": "Перенаправляємо на оплату…",
"hc.redirectingToTheRecoveryOf": "Перенаправляємо на відновлення вашого предмета…",
"hc.regenerateAndResendToThe": "Перегенерувати та надіслати власнику",
"hc.regenerateTheCode": "Перегенерувати код",
"hc.registerAFoundItem": "Зареєструвати знайдений предмет",
"hc.rejectTheClaim": "Відхилити претензію",
"hc.reminderDelaySaved": "Затримка нагадування збережена",
"hc.reopenThePaymentLink": "Відкрити посилання для оплати знову",
"hc.repeatThePassword": "Повторіть пароль",
"hc.reportAProblem": "Повідомити про проблему",
"hc.reportDismissedYourListingRemains": "Скаргу відхилено. Ваше оголошення залишається публічним.",
"hc.requiredUsedToCalculateThe": "Обов'язково: використовується для розрахунку вартості доставки Sendcloud. Доставка недоступна понад 30 кг.",
"hc.reset": "Скинути",
"hc.resume": "Поновити",
"hc.resumeRegistration": "Поновити реєстрацію",
"hc.retro": "Рік в огляді",
"hc.returnSecurity": "Безпека повернення",
"hc.returnToTheOwner": "Повернути власнику",
"hc.returned": "повернуто",
"hc.reviewTheItemDetails": "Перегляньте деталі товару",
"hc.revokeAccess": "Вилучити доступ",
"hc.role": "Роль:",
"hc.save": "Зберегти",
"hc.save2": "зберегти",
"hc.saveAndContinue": "Зберегти та продовжити",
"hc.saving": "Збереження…",
"hc.scanTheClaimCode": "Сканувати код претензії",
"hc.scanTheOwnerSQr": "Сканувати QR-код власника",
"hc.scrollThroughLanguages": "Пролистати мови",
"hc.searchByCustomerItemOr": "Шукати за клієнтом, товаром або номером відстеження…",
"hc.searchForACountry": "Шукати країну…",
"hc.secureFindoVerification": "Безпечна верифікація Findloop",
"hc.seeRetro": "Переглянути рік в огляді",
"hc.selectedCarrier": "Вибраний перевізник:",
"hc.selectedPlan": "Вибраний план",
"hc.send": "Надіслати",
"hc.sendcloudSenderIdSaved": "ID відправника Sendcloud збережено",
"hc.sendcloudSenderIdSenderId": "ID відправника Sendcloud (sender_id)",
"hc.sending": "Надсилання…",
"hc.sessionExpired": "Сесію завершено",
"hc.setUpYourEstablishments": "Налаштуйте свої заклади",
"hc.settings": "Налаштування",
"hc.settingsSubtitle": "Зовнішні платежі та нагадування, налаштовані для кожного закладу.",
"hc.shareFoundText": "Я знайшов предмет — допоможіть знайти його власника на Findloop",
"hc.shareLostText": "Я втратив предмет — допоможіть знайти його на Findloop",
"hc.sharePreview": "Поділитися попереднім переглядом",
"hc.shareTheRanking": "Поділитися рейтингом",
"hc.shareYourQrCodeTo": "Поділіться своїм QR-кодом для отримання декларацій.",
"hc.shipRateAutoWeight": "Вартість доставки розраховується автоматично через Sendcloud (вага {w}) під час відправки.",
"hc.shipRateForWeight": "Вартість доставки (Sendcloud + {m}% націнка) за {w}:",
"hc.shipments": "Відправлення",
"hc.shipmentsSubtitle": "Консолідований перегляд усіх відправлень закладу по всіх випадках. Клацніть рядок, щоб керувати відправленням у його декларації.",
"hc.shipping": "Доставка",
"hc.shippingAddress": "Адреса доставки",
"hc.shippingFeesAreHandledAutomatically": "Витрати на доставку обробляються автоматично за допомогою Findloop (Sendcloud) — немає посилання для введення.",
"hc.shippingFeesHaveAlreadyBeen": "Витрати на доставку вже сплачені: перевізника більше змінити не можна.",
"hc.shippingNotAvailableForItems": "Доставка недоступна для предметів вагою понад 30 кг. Клієнту потрібно буде забрати виріб особисто.",
"hc.shippingPaid": "Доставка сплачена ✓",
"hc.showOnlyItemsMatchingA": "Показати лише предмети, що відповідають публічному (клієнтському) списку",
"hc.showPassword": "Показати пароль",
"hc.signInTheBoxAbove": "Увійдіть у полі вище",
"hc.signatureSaved": "Підпис збережено",
"hc.signedInWithGoogle": "Увійшли через Google",
"hc.signupFailed": "Не вдалося зареєструватися",
"hc.silver": "Срібло",
"hc.simulatedRatesInPreProduction": "(симульовані тарифи в передвиробництві)",
"hc.siretAndVatNumberRequired": "Потрібен номер SIRET та VAT (Франція).",
"hc.skip": "Пропустити",
"hc.smsSentIfAccount": "Якщо обліковий запис існує з цим номером, вам надіслано SMS.",
"hc.sortItemsWithAPublic": "Сортувати: предмети з публічною відповідністю (найновіші) спочатку",
"hc.specifyWhetherYouRecoveredYour": "Вкажіть, чи ви забрали свій предмет або просто хочете видалити цей список.",
"hc.specifyYourReason": "Вкажіть вашу причину",
"hc.specifyYourReason2": "Вкажіть вашу причину…",
"hc.staff": "Персонал",
"hc.status": "Статус",
"hc.staySignedIn": "Залишатися підписаним",
"hc.step": "Крок",
"hc.stillThere": "Все ще там?",
"hc.stopScrolling": "Зупинити прокрутку",
"hc.storeFindWithQr": "Зберігати та знаходити за QR",
"hc.streetName": "Назва вулиці",
"hc.streetNo": "Номер вулиці",
"hc.switchTo": "Переключитися на",
"hc.switchToDarkMode": "Перемкнутися в темний режим",
"hc.switchToLightMode": "Перемкнутися в світлий режим",
"hc.takeAPhoto": "Зробити фото",
"hc.takeChangeThePhoto": "Зробити / змінити фото",
"hc.takenFromYourDeclaration": "взято з вашої декларації",
"hc.target": "Ціль",
"hc.thisValidationLinkIsInvalid": "Цей лінк для валідації недійсний або термін його дії закінчився.",
"hc.toCheckBeforeMarkingThe": "Перевірте перед тим, як позначити товар як повернутий.",
"hc.toConfigureTheLinksAnd": "щоб налаштувати посилання та затримку нагадування для кожного закладу.",
"hc.toReachOurFirstMilestone": "щоб досягти нашого першого етапу в 100 повернень.",
"hc.toTheCustomer": "до клієнта.",
"hc.toTheShippingFeePayment": "до оплати за доставку.",
"hc.toYourRecoveryTracking": "до вашого трекінгу відшкодування.",
"hc.tooExpensiveBudget": "Занадто дорого / бюджет",
"hc.topCitiesForReturns": "Топ міста для повернень",
"hc.trackMyRecovery": "Відстежити моє відшкодування",
"hc.trackTheShipmentAndDownload": "Відстежити відправлення та завантажити етикетку (згенеровано автоматично) без виходу з вкладки Декларації.",
"hc.trackYourStatistics": "Відстежити вашу статистику",
"hc.tracking": "Відстеження",
"hc.unableToOpenTheShipping": "Не вдалося відкрити оплату за доставку. Будь ласка, спробуйте ще раз.",
"hc.unableToRetrieveTheInvoice": "Не вдалося отримати рахунок-фактуру.",
"hc.unclaimed": "Не заявлено",
"hc.unclaimedCustomerReason": "Не заявлений товар. Причина клієнта: \"{reason}\".",
"hc.unclaimedItem": "Не заявлений товар",
"hc.unclaimedItemNoClaimWithin": "Не заявлений товар — не було заявок у терміни.",
"hc.unclaimedItems": "Не заявлені товари",
"hc.unclaimedItemsMatchLeftWithout": "Не заявлені товари: матч залишився без заявки у терміни. Ви можете повернути їх на склад.",
"hc.unlockTheFinderSContact": "Розблокуйте контактні дані знайдена, щоб організувати передачу.",
"hc.upcoming": "Попередні",
"hc.updateFailed": "Оновлення не вдалося.",
"hc.usedForInvoices": "Використовується для видання ваших рахунків findloop.",
"hc.vatNumber": "Номер ПДВ",
"hc.verificationPending": "Перевірка в процесі",
"hc.verificationSentToTheFinder": "Перевірка надіслана знайденому. Ви будете проінформовані про їхнє рішення.",
"hc.verificationSentToThePartner": "Перевірка надіслана партнеру. Ви будете проінформовані про їхнє рішення.",
"hc.verify": "Підтвердити",
"hc.verifyingInvite": "Перевірка посилання на запрошення…",
"hc.verifyingTheLink": "Перевірка посилання…",
"hc.viewInRegistry": "Переглянути в реєстрі",
"hc.viewItem": "Переглянути товар",
"hc.viewItemRecover": "Переглянути товар та відшкодувати",
"hc.visibleToTheOwnerAutomatically": "Видимо для власника · автоматично видаляється через 60 днів.",
"hc.waitingForPartnerConfirmation": "Очікування підтвердження партнера",
"hc.waitingForThePartnerS": "Очікування підтвердження партнера",
"hc.weHaveInformedTheEstablishment": "Ми повідомили заклад, що цей товар не ваш, і перезапустили аналіз. Ви будете проінформовані, як тільки буде знайдено новий матч.",
"hc.weHaveInformedThePartner": "Ми повідомили партнера, що цей товар не ваш. Ваше оголошення залишається активним для майбутніх матчів.",
"hc.targetReached": "Мету досягнуто",
"hc.targetReachedThankYouTo": "Мету досягнуто — дякуємо всій спільноті Findloop!",
"hc.tellUsMore": "Розкажіть більше…",
"hc.tellUsWhyYouCancel": "Скажіть, чому ви скасовуєте. Це допоможе партнеру обробити ваш запит.",
"hc.tellUsWhyYourListing": "Скажіть, чому. Ваше оголошення залишається активним, і ви все ще можете забрати свій товар.",
"hc.termsAndConditions": "Умови та положення",
"hc.termsAndPolicies": "Умови та політики",
"hc.thankYouForYourFeedback": "Дякуємо за ваш відгук",
"hc.theBannerDisplayedInThe": "банер, що відображається в реєстрі.",
"hc.theClaimantHasBeenInformed": "Заявник був проінформований. Товар залишається доступним в публічному списку.",
"hc.theClaimantHasBeenNotified": "Заявник був повідомлений і тепер може продовжити повернення.",
"hc.theCustomerPaysTheFees": "Клієнт сплачує збори установі.",
"hc.theDayTheLegalRetention": "День, коли закінчується строк законного утримання.",
"hc.theEstablishmentConsideredThatThis": "Установа вважає, що цей товар не ваш.",
"hc.theEstablishmentIsReviewingYour": "Установа перевіряє ваші відповіді. Ви будете сповіщені, як тільки ваша вимога буде підтверджена, тоді ви зможете сплатити збори за повернення.",
"hc.theFeesAreTooHigh": "Збори занадто високі",
"hc.theFinderConsideredThatThis": "Знахідник вважає, що цей товар не ваш.",
"hc.theFinderIsReviewingYour": "Знахідник перевіряє вашу вимогу. Ви будете сповіщені, як тільки вона буде підтверджена.",
"hc.theItem": "Товар",
"hc.theItemWillBeRemoved": "Товар буде видалено з реєстру (немає активної вимоги).",
"hc.theItemWillBeSet": "Товар буде повернуто до статусу \"в наявності\", а відповідна вимога буде скасована.",
"hc.theKbisNumberAndVat": "Номер Kbis та номер ПДВ потрібні для Франції.",
"hc.theLabelIsGeneratedAutomatically": "Етикетка генерується автоматично, як тільки клієнт сплачує транспортні збори. Її можна буде завантажити тут.",
"hc.theLinkMayHaveExpired": "Посилання могло вже завершити дію (дійсне 30 днів). Зверніться до служби підтримки Findloop, якщо потрібно.",
"hc.theOwnerDescribesTheirItem": "Власник описує свій товар",
"hc.theOwnerReceivedItBy": "Власник отримав це електронною поштою (або SMS). Введіть або відскануйте його перед передачею.",
"hc.thePartnerConsideredThatThis": "Партнер вважає, що цей товар не ваш. Товар залишається доступним.",
"hc.thePartnerIsReviewingYour": "Партнер перевіряє ваші відповіді. Ви будете сповіщені, як тільки ваша вимога буде підтверджена.",
"hc.theShipmentIsCreatedAutomatically": "Відправлення створюється автоматично після того, як клієнт підтвердив свою адресу та сплатив збори за повернення. Етикетка буде згенерована автоматично після сплати за доставку і її можна буде завантажити тут.",
"hc.theShippingRateWillBe": "Тариф на доставку буде розраховано автоматично через Sendcloud під час доставки (задокументована вага).",
"hc.thisCarrierWillBe": "Цей перевізник буде",
"hc.thisEstablishment": "ця установа",
"hc.thisFieldIsRequiredFor": "Це поле є обов'язковим для автоматичного генерування етикетки.",
"hc.thisIsMyItem": "Це мій товар",
"hc.thisIsMyItemContinue": "Це мій товар — продовжити",
"hc.thisIsMyItemStart": "Це мій товар — розпочати повернення",
"hc.thisIsNotMyItem": "Це не мій товар",
"hc.thisMatchIsNoLonger": "Цей матч більше не доступний або вже оброблений.",
"hc.thisRateWillBeCharged": "Цей тариф буде стягнутий з клієнта. Високий тариф може зменшити ймовірність повернення.",
"hc.thisStepIsRequiredFor": "Цей крок є обов'язковим для генерування етикеток для доставки",
"hc.weRanTheAnalysisAgain": "Ми знову провели аналіз і виявили ще один предмет, який може бути вашим. Будь ласка, перевірте ще раз.",
"hc.weight": "Вага",
"hc.weightNotProvidedTheShipping": "Вага не вказана: тариф на доставку буде розраховано під час відправлення.",
"hc.weightUnit": "Одиниця ваги",
"hc.welcome": "Ласкаво просимо!",
"hc.welcomeToFindo": "Ласкаво просимо до Findloop",
"hc.whenACustomerComesTo": "Коли клієнт приходить забрати свої речі, відкрийте їх декларацію та підтвердіть повернення. Ось і все!",
"hc.whenDisabledFeesDropTo": ". Коли вимкнено, збори знижуються до",
"hc.whyIsThisNotYour": "Чому це не ваш предмет?",
"hc.willBeMarkedAs": "буде позначено як",
"hc.wrongColor": "Неправильний колір",
"hc.wrongModel": "Неправильна модель",
"hc.yesCancel": "Так, скасувати",
"hc.yesContactTheFinder": "Так, зв'язатися з знахідником",
"hc.youAreHere": "Ви тут",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Тепер ви можете розпочати повернення.",
"hc.youCanStillChangeIt": ". Ви все ще можете змінити це в кожному окремому випадку.",
"hc.youHaveAlreadyConfirmedThat": "Ви вже підтвердили, що це ваш предмет.",
"hc.youWillBeRedirectedTo": "Ви будете перенаправлені на безпечний платіж через Stripe.",
"hc.yourAccountHasBeenReactivated": "Ваш акаунт було реактивовано.",
"hc.yourAccountIsActiveYou": "Ваш акаунт активний, тепер ви можете керувати своїми закладами.",
"hc.yourEstablishment": "Ваш заклад",
"hc.yourFeedbackHelpsUsImprove": "Ваш відгук допомагає нам покращити наші підбори.",
"hc.yourFeedbackHelpsUsRestart": "Ваш відгук допомагає нам перезапустити аналіз і покращити наші підбори.",
"hc.yourFirstSteps": "Ваші перші кроки",
"hc.yourFirstStepsAdmin": "Ваші перші кроки (адмін)",
"hc.yourItemHasBeenHanded": "Ваш предмет був переданий особисто партнером — закрийте справу, як тільки передача буде підтверджена.",
"hc.yourItemHasBeenShipped": "Ваш предмет був відправлений партнером — закрийте справу, як тільки доставка буде підтверджена.",
"hc.yourPaymentHasBeenRecorded": "Ваш платіж було зафіксовано.",
"hc.yourShipmentIsBeingPrepared": "Ваша відправка готується. Ви отримаєте свою посилку протягом 3 до 5 робочих днів.",
"hc.yourShippingFeesHaveAlready": "Ваші витрати на доставку вже сплачені. Доставка оплачена ✓",
"hc.yourShippingFeesHaveBeen": "Ваші витрати на доставку були сплачені. Ваша посилка готується.",
"hc.yourVerificationQuestionsDeposit": "Ваші запитання для верифікації (депозит)",
"hero.einvoiceBadge": "Е-інвойсинг відповідно до вимог 2027 року",
"home.recentAdsAll": "Переглянути всі оголошення",
"home.recentAdsEyebrow": "Зараз",
"home.recentAdsSubtitle": "Загублені і знайдені предмети, про які повідомила спільнота.",
"home.recentAdsTitle": "Останні оголошення",
"home.reunions": "Недавні зустрічі",
"home.videoEyebrow": "Дивитися",
"home.videoSubtitle": "Як ми повертаємо втрачені речі їхнім власникам без зусиль.",
"home.videoTitle": "Відкрийте для себе Findloop за 2 хвилини",
"home.watchYoutube": "Дивитися на YouTube",
"impact.already": "Вже",
"impact.citiesWord": "місто/міста",
"impact.eachPoint": "Кожна крапка - це місто, де Findloop допомагає повернути втрачені речі.",
"impact.emptyMap": "Карта заповнюється в міру повернення речей.",
"impact.eyebrow": "Наш вплив",
"impact.inCities": "по всій",
"impact.restitutedTo": "речі, повернуті їхнім власникам",
"impact.title": "Речі повернуті, скрізь поруч із вами",
"inv2.download": "Завантажити",
"inv2.view": "Переглянути",
"map.objectsOnMapPlural": "речі на мапі",
"map.objectsOnMapSingular": "річ на мапі",
"mc.claimConfirmDesc": "Перевірте річ, знайдену шукачем, перед тим як сплатити, щоб отримати його дані для зв’язку.",
"mc.claimConfirmNo": "Це не моя річ",
"mc.claimConfirmTitle": "Це справді ваша річ?",
"mc.claimConfirmYes": "Так, це моє — сплатити",
"mc.claimFinderContacts": "Дані для зв’язку шукача",
"mc.claimNotMineDone": "Дякуємо — шукач був сповіщений, а ваш запит видалено з оголошення.",
"mc.claimUnlockDesc": "Сплатіть збір управління Findloop, щоб отримати дані для зв’язку особи, яка знайшла вашу річ.",
"mc.claimUnlockTitle": "Відкрити дані для зв’язку шукача",
"mc.hideCountryOffers": "Сховати пропозиції в моїй країні",
"mc.myClaims": "Речі, які я.claim",
"mc.myClaimsSub": "Речі, знайдені іншими, які ви заявляєте. Відкрийте дані для зв’язку шукача, щоб організувати передачу.",
"mc.notifAdCancelled": "Оголошення скасовано",
"mc.notifCancelAd": "Скасувати моє оголошення",
"mc.offersInCountry": "Пропозиції в моїй країні",
"mc.offersInCountryDesc": "Всі активні винагороди від партнерів у вашій країні, за містом.",
"mc.redArchived": "Архівовано",
"mc.rewardsCountryNone": "Ще немає пропозицій у вашій країні.",
"mc.rewardsForYou": "Винагороди для вас",
"mc.rewardsForYouDesc": "Пропоновані партнером(ами), у якого ви залишили річ.",
"mc.rewardsMineNone": "Ще немає винагороди від ваших партнерів.",
"mc.showCountryOffers": "Переглянути пропозиції в моїй країні",
"mc2.cancelDecl": "Скасувати мою декларацію",
"mc2.cancelDeclDone": "Декларацію скасовано.",
"pricing.physInvDesc": "Коли річ повертається, її місце автоматично звільняється та доступне для нової речі.",
"pricing.physInvTitle": "Відстеження фізичних запасів",
"pricing.physModalTitle": "Управління фізичними предметами",
"pricing.physQrDesc": "Для кожного предмета генерується унікальний QR-код, який зв'язується з усією його інформацією.",
"pricing.physQrTitle": "Спеціальна QR-мітка",
"pricing.physShelfDesc": "Кожному зареєстрованому предмету можна призначити фізичне місце в установі.",
"pricing.physShelfTitle": "План полиць",
"pricing.physicalMgmt": "Управління фізичними предметами (полиці, QR, запаси)",
"pub.addSecondPhoto": "Додати 2-ге фото (за бажанням)",
"pub.photo2Added": "✓ 2-ге фото додано",
"reg.dispositionJournal": "Журнал розпорядження",
"reg.dispositionNoteAuthHint": "ℹ️ Необхідна записка для “Вручено владі” (номер звіту, відділ…).",
"reg.dispositionNotePh": "Записка (за бажанням): благодійна організація, посилання влади, ім'я покупця…",
"reg.dispositionNoteRequired": "Для передачі владі потрібне офіційне посилання.",
"reg.legalPrealert": "Юридичний термін через {days} день(і)",
"reg.legalPrealertOptions": "Опції на термін: аукціон, donation to a charity, передача владі.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Повний огляд",
"rev.readMore": "Читати далі",
"rw.activeCodes": "Активні ваучери",
"rw.archived": "Архівовано",
"rw.archivedTitle": "Викуплені ваучери (архівовані)",
"rw.hideArchived": "Сховати викуплені ваучери",
"rw.noArchived": "Немає архівованих ваучерів.",
"rw.showArchived": "Показати викуплені ваучери",
"shp.labelAuto": "Етикетка генерується автоматично, щойно клієнт сплатить вартість доставки. Її можна буде завантажити тут.",
"st.cancelled_by_customer": "Скасовано",
"stt.dispoPdfBtn": "Експорт PDF",
"stt.dispoPdfError": "Експорт PDF не вдався.",
"stt.dispoPdfExporting": "Експортується…",
"trk.matchVerifying": "Перевіряється потенційна збіг",
"a.firstName": "Ім'я",
"ac.emailCrossMatch": "B2C перехресні співпадіння",
"ac.emailCrossMatchDesc": "Електронний лист, коли публічне оголошення про загублений предмет відповідає предмету, що знаходиться у вас",
"ac.emailCrossReject": "Відхилення публічних співпадінь",
"ac.emailCrossRejectDesc": "Отримуйте електронний лист, коли клієнт зазначає, що запропоноване публічне співпадіння не є їхнім предметом.",
"ac.emailLoginNotif": "Повідомлення про вхід",
"ac.emailLoginNotifDesc": "Отримуйте електронний лист щоразу, коли хтось входить у ваш обліковий запис.",
"ad.closeNoCancel": "Ні, видалити оголошення",
"ad.closeQuestion": "Предмет був повернутий вам?",
"ad.closeQuestionDesc": "Повідомте нас, чи ви отримали свій предмет назад, або ж просто хочете видалити це оголошення.",
"ad.closeYesRestituted": "Так, предмет був повернутий",
"ad.closedRestituted": "Предмет повернутий — оголошення закрите 🎉",
"an.lostLoginDesc": "Обліковий запис потрібен для повідомлення про загублений предмет та відстеження його повернення.",
"an.lostLoginRequired": "Увійдіть, щоб повідомити про загублений предмет",
"an.qfAll": "Усі",
"an.qfBoosted": "Підвищені",
"an.qfPhoto": "З фотографією",
"an.qfRecent": "Цього тижня",
"an.qfResolved": "Вирішено",
"an.restitutionInProgress": "Предмет повертається",
"dec.descPhLong": "Опишіть предмет: бренд, колір, відмінні знаки… (Чим більше деталей ви надасте, тим вищі ваші шанси на повернення предмета)",
"dec.loadError": "Не вдалося завантажити партнера зараз. Перевірте підключення та спробуйте знову.",
"dec.retry": "Спробувати знову",
"dec.shippingMode": "Доставка",
"dep.photo2": "Фотографія 2-го предмета",
"dep.photo2Hint": "Додатково — інший кут покращує точність візуального співпадіння.",
"dl.accountSuspended": "Обліковий запис призупинено через неоплачену рахунку. Вирішіть це, щоб відновити доступ.",
"dl.regularize": "Вирішити зараз →",
"dl.suspensionCountdown": "Рахунок {num} неоплачений — ваш обліковий запис буде призупинено через {days} день(ів). Вирішіть це, щоб уникнути цього.",
"ft.cancelConfirm": "Скасувати ваш звіт? Власник предмета буде повідомлений.",
"ft.cancelDone": "Звіт скасовано.",
"ft.cancelLocked": "Скасування більше неможливе після того, як власник сплатив.",
"ft.cancelReport": "Скасувати мій звіт",
"ft.claimCodeHelp": "Дайте цей код знаходящому під час передачі, щоб підтвердити, що ви отримали свій предмет.",
"ft.claimCodeTitle": "Ваш код відшкодування",
"ft.claimDone": "Предмет повернутий. Дякуємо за використання Findloop!",
"ft.claimUnlockHint": "Розблокувати контактні дані знаходячого",
"ft.claimUnlockHintSub": "Перейдіть до \"Предмети, які я претендую\" у вашому обліковому записі, щоб сплатити збори та отримати контактні дані.",
"ft.finderCodeShownHelp": "Власник сплатив і обрав вас. Скопіюйте цей код нижче, щоб підтвердити повернення — не потрібно перевіряти електронну пошту.",
"ft.finderCodeShownTitle": "Код підтвердження власника",
"hc.analyzing": "Аналізую...",
"hc.andRecoveryIs": "і відновлення є",
"hc.andTheDeclarationWillBe": "і декларація буде закрита (пер moved to history). Ця дія є остаточною.",
"hc.annual20": "Річний -20%",
"hc.annualBilling20": "Річна оплата (−20%)",
"hc.annualTarget": "Річна мета",
"hc.anyCommentsOptional": "Будь-які коментарі? (необов'язково)",
"hc.approveTheClaim": "Схвалити заяву",
"hc.archiveCancelledConfirm": "Архівувати {n} списки \"Скасовано клієнтом\"? Вони будуть видалені з реєстру.",
"hc.asSoonAs": "Якомога швидше",
"hc.askTheOwnerToDisplay": "Запитайте власника про відображення QR-коду їхнього кода (сторінка відстеження).",
"hc.askThemAtTheCounter": "Запитайте їх на касі для підтвердження особи — ніколи не буде публічно видимим.",
"hc.assistance": "Підтримка",
"hc.assistanceSessionRevoked": "Сесію допомоги скасовано.",
"hc.atLeast6Characters": "Щонайменше 6 символів",
"hc.automaticallyPreSelected": "автоматично попередньо вибрано",
"hc.automaticallyWhenShipping": "автоматично під час доставки.",
"hc.awaitingClaim": "Очікування заяви",
"hc.awaitingPayment": "Очікування оплати",
"hc.b2cCustomer": "Клієнт B2C",
"hc.back": "Назад",
"hc.backToHome": "Повернутися на главну",
"hc.backToMyAccount": "Повернутися до мого рахунку",
"hc.backToPayment": "Повернутися до оплати",
"hc.beforeAfterComparisonSlider": "Слайдер порівняння до/після",
"hc.billingInformation": "Інформація для виставлення рахунків",
"hc.billingInformationSaved": "Інформація для виставлення рахунків збережена ✓",
"hc.brand": "Бренд",
"hc.bronze": "Бронзовий",
"hc.calculatingTheShippingRate": "Розрахунок вартості доставки...",
"hc.cameraUnavailableEnterTheCode": "Камера недоступна. Введіть код вручну.",
"hc.cancel": "Скасувати",
"hc.cancelMyDeclaration": "Скасувати мою декларацію",
"hc.cancelSavedFmt": "Скасування збережено: \"{reason}\". Ви все ще можете подати заяву.",
"hc.cancelTheDeposit": "Скасувати депозит",
"hc.cancelThisMatch": "Скасувати цю угоду",
"hc.cancellationReason": "Причина скасування",
"hc.cancelled": "Скасовано",
"hc.cancelledByTheCustomer": "Скасовано клієнтом",
"hc.cannotOpenPayment": "Не вдалося відкрити оплату. Будь ласка, спробуйте ще раз.",
"ft.finderContactsTitle": "Контактні дані Finder",
"ft.foundCodeHelp": "Покажіть цей код власнику під час передачі, щоб підтвердити, що предмет був повернутий.",
"ft.inProgressOther": "Предмет повертається",
"ft.inProgressOtherHelp": "Власник обрав іншого розпорядника для цього предмета. Додаткових дій з вашого боку не потрібно.",
"ft.restitutionCodeHelp": "Цей код підтверджує передачу предмета. Він вже заповнений нижче; перевірте його, а потім закрийте справу.",
"ft.restitutionCodeTitle": "Ваш код відшкодування",
"hc.14Digits": "14 цифр",
"hc.15DaysBeforeAnItem": "15 днів до законного терміну предмета.",
"hc.7DaysBeforeAnItem": "7 днів до законного терміну предмета.",
"hc.8CharactersMinimum": "Мінімум 8 символів.",
"hc.aClaimToValidate": "Заявка для підтвердження",
"hc.aFindoAssistanceSessionIs": "Сесія підтримки Findloop наразі активна на вашому обліковому записі.",
"hc.aNewMatchHasBeen": "Знайдено нове співпадіння",
"hc.aUser": "Користувач",
"hc.aUserClaimsToBe": "Користувач стверджує, що він є власником. Перевірте їхні відповіді, перш ніж уповноважити повернення.",
"hc.aboutFindo": "Про Findloop",
"hc.accountActivatedPleaseLogIn": "Обліковий запис активовано, будь ласка, увійдіть.",
"hc.accountActivation": "Активація облікового запису",
"hc.accountCreated": "Обліковий запис створено!",
"hc.accountDeactivatedAReactivationEmail": "Обліковий запис деактивовано. Вам надіслано електронний лист про повторну активацію (діє 30 днів).",
"hc.accountReactivation": "Повторна активація облікового запису",
"hc.activateMyAccount": "Активувати мій обліковий запис",
"hc.activateMyAdminAccount": "Активувати мій адміністративний обліковий запис",
"hc.activating": "Активація…",
"hc.activeMatchCancelReason": "Активне співпадіння. Причина скасування клієнта: \"{reason}\". Предмет ще чекає на заявку.",
"hc.activeMatchWithAPublic": "Активне співпадіння з публічним (клієнтським) оголошенням. Чекаємо на заявку власника.",
"hc.addAPhoto": "Додати фото",
"hc.addAndConfigureYourEstablishments": "Додайте та налаштуйте ваші заклади в \"Заклади\": контактні дані, категорія та фізичне зберігання предметів.",
"hc.addOnGoogle": "Додати в Google",
"hc.address": "Адреса",
"hc.addressSaved": "Адресу збережено",
"hc.addressStreet": "Адреса — Вулиця",
"hc.adjustThePhoto": "Налаштувати фото",
"hc.adminFullView": "Адміністратор (повний перегляд)",
"hc.administratorOnly": "Тільки для адміністраторів",
"hc.africa": "Африка",
"hc.aiVisualComparison": "AI візуальне порівняння",
"hc.all": "Всі",
"hc.amount": "Сума",
"hc.anOrganization": "Організація",
"hc.careers": "Кар'єра",
"hc.carrier": "Перевізник",
"hc.carrierAvailabilityCannotBeChecked": "Доступність перевізника не може бути перевірена, поки ваш відправник Sendcloud не налаштований.",
"hc.carrierConfirmedCharged": "Перевізник підтверджений — {price} € стягнуто з клієнта",
"hc.carrierOther": "Перевізник (інший)",
"hc.carrierSelection": "Вибір перевізника",
"hc.caseClosedThankYou": "Справа закрита. Дякуємо!",
"hc.category": "Категорія",
"hc.changeMethod": "Змінити метод",
"hc.characteristic": "Характеристика",
"hc.chargedToCustomer": "стягнуто з клієнта.",
"hc.checkOrEditYourDetails": "Перевірте або відредагуйте свої дані перед безпечним платежем.",
"hc.checkStatisticsToTrackDeposited": "Перевірте \"Статистику\", щоб відстежити депоновані предмети, рівень повернень і продуктивність кожного закладу.",
"hc.checkTheDetailsBeforeContacting": "Перевірте деталі перед тим, як зв'язатися з шукачем.",
"hc.checkTheDetailsBelowBefore": "Перевірте деталі нижче перед тим, як почати запит на повернення.",
"hc.checkTheNewItem": "Перевірте новий предмет",
"hc.checkThePhotosAndCharacteristics": "Перевірте фотографії та характеристики нижче, перш ніж переходити до відновлення.",
"hc.chooseACountry": "Виберіть країну",
"hc.chooseANewPassword": "Виберіть новий пароль",
"hc.chooseAReason": "Виберіть причину",
"hc.chooseTheLegalRetentionAlerts": "Виберіть юридичні оповіщення про зберігання, які отримуються електронною поштою для",
"hc.chooseYourPasswordToAccess": "Виберіть свій пароль для входу до адміністративної консолі.",
"hc.city": "Місто",
"hc.claimApproved": "Позов схвалено",
"hc.claimApproved2": "Позов схвалено.",
"hc.claimCodeExpired": "Термін дії коду позову закінчився",
"hc.claimCodeVerified": "Код позову перевірено",
"hc.claimNotFound": "Позов не знайдено",
"hc.claimNotValidated": "Позов не підтверджено",
"hc.claimRejected": "Позов відхилено",
"hc.claimRejected2": "Позов відхилено.",
"hc.claimValidated": "Позов підтверджено",
"hc.claimValidatedByThePartner": "Позов підтверджено партнером",
"hc.claimant": "Позивач",
"hc.claimsToBeTheOwner": "стверджує, що є власником цього предмета і відповів на запитання для перевірки. Схвалюйте лише в разі відповідності відповідей.",
"hc.claimsToValidate": "Позови для підтвердження",
"hc.clear": "Очистити",
"hc.clickToZoom": "Натисніть для збільшення",
"hc.close": "Закрити",
"hc.close2": "Закрити",
"hc.closeTheDeclaration": "Закрити декларацію",
"hc.closeTheDeclaration2": "Закрити декларацію?",
"hc.codeAlreadyVerified": "Код вже підтверджено",
"hc.codeCopied": "Код скопійовано",
"hc.collapse": "Згорнути",
"hc.color": "Колір",
"hc.company": "Компанія",
"hc.companyName": "Назва компанії",
"hc.comparePhotos": "Порівняти фотографії",
"hc.compareThemWithTheOwner": "Порівняти їх з відповідями власника — ніколи не буде видно публічно.",
"hc.condition": "Стан",
"hc.confirmAndPay": "Підтвердити та оплатити",
"hc.confirmCancellation": "Підтвердити скасування",
"hc.confirmCrop": "Підтвердити обрізку",
"hc.confirmDeletion": "Підтвердити видалення",
"hc.confirmPassword": "Підтвердити пароль",
"hc.confirmThatThisIsYour": "Підтвердьте, що це ваш предмет. Перевірка особи буде запитуватись у знайшовшого перед будь-яким контактом.",
"hc.confirmTheCarrier": "Підтвердити перевізника",
"hc.confirmThePassword": "Підтвердити пароль",
"hc.confirmYourShippingAddressTo": "Підтверджуйте свою адресу доставки, щоб продовжити оплату.",
"hc.confirmYourSubscription": "Підтвердьте свою підписку",
"hc.confirmed": "Підтверджено ✓",
"hc.contactFindoToGetYour": "Зв'яжіться з Findloop, щоб отримати свій ID відправника.",
"hc.contactUs": "Зв'яжіться з нами",
"hc.continueTheReturn": "Продовжити повернення",
"hc.continueToPayment": "Продовжити до оплати",
"hc.copy": "Копіювати",
"hc.correctMyDetails": "виправити мої дані",
"hc.correctThisEntry": "Виправити цей запис?",
"hc.country": "Країна",
"hc.countryAddress": "Країна (адреса)",
"hc.countryIsoCodeEG": "Країна (ISO код, напр. FR)",
"hc.cover": "обкладинка",
"hc.createTheShipment": "Створити відправлення",
"hc.cropThePhoto": "Обрізати фотографію",
"hc.customer": "Клієнт",
"hc.customerClaimCodeToCheck": "Код претензії клієнта — для перевірки під час отримання:",
"hc.customerReasonFmt": "Причина клієнта: \"{reason}\".",
"hc.customerReminderDelay": "Затримка нагадування клієнта",
"hc.customerWhosePublicListingMatches": "Клієнт, чий публічний листинг відповідає цьому предмету — видимый тільки для вас.",
"hc.d15": "Д-15",
"hc.dangerZone": "Зона небезпеки",
"hc.date": "Дата",
"hc.dateNewest": "Дата (найновіша)",
"hc.dateOldest": "Дата (найстаріша)",
"hc.daysToYearEnd": "{n} днів до кінця року",
"hc.deadlineAlert": "Попередження про термін",
"hc.declarationClosed": "Декларація закрита ✓",
"hc.declarationNotFound": "Декларацію не знайдено.",
"hc.declarationNotFound2": "Декларацію не знайдено",
"hc.declarationTracking": "Відстеження декларації",
"hc.defaultCarrier": "Стандартний перевізник",
"hc.defaultCarrierPreselected": "Стандартний перевізник попередньо вибраний — може бути змінений для цієї відправки. Актуальна ставка (Sendcloud + {m}% маржа).",
"hc.defaultCarrierRemoved": "Стандартний перевізник видалено",
"hc.delayHours": "Затримка (години)",
"hc.deleteMyAccount": "Видалити мій акаунт",
"hc.deleting": "Видалення…",
"hc.deletingDeactivatesYourAccountLogin": "Видалення деактивує ваш акаунт: вхід заблоковано, а дані зберігаються протягом 30 днів. Ви отримаєте електронний лист із посиланням для реактивації, дійсним 30 днів.",
"hc.delivered": "Доставлено",
"hc.depositAnItem": "Внести предмет",
"hc.depositCancelledItemPutBack": "Внесення скасовано — предмет повернуто на склад.",
"hc.depositCancelledItemRemovedFrom": "Внесення скасовано — предмет вилучено з реєстру.",
"hc.depositedOn": "Внесено",
"hc.describeTheItemBrandColor": "Опишіть предмет: бренд, колір, відмінні знаки… (Чим більше деталей ви надасте, тим більше шансів знайти ваш предмет)",
"hc.dimensionsCm": "Розміри (см)",
"hc.disablingAnEmail": "Вимкнення електронної пошти",
"hc.doesNotHide": "не приховує",
"hc.download": "Завантажити",
"hc.downloadThePdf": "Завантажити PDF",
"hc.draftRestoredPickUpYour": "Чернетка відновлена — продовжте оформлення декларації з того місця, де зупинилися.",
"hc.dragToReposition": "Перетягніть, щоб перенести",
"hc.eGColisPriv": "Наприклад, Colis Privé",
"hc.eachItemGetsAQr": "Кожен предмет отримує QR-мітку. Скануйте її з \"Сховища та QR\", щоб швидко знайти предмет.",
"hc.eachSiteManagesItsOwn": "Кожен сайт керує своїм банківським рахунком. Перейдіть до",
"hc.edit": "Редагувати",
"hc.emailNotificationPreferences": "Переваги електронних сповіщень",
"hc.emailPreferencesUpdated": "Переваги електронної пошти оновлено",
"hc.enableOrDisableRecoveryFees": "Увімкнути або вимкнути збори за повернення для",
"hc.enlargePhoto": "Збільшити фотографію",
"hc.enterTheCustomerSCode": "Введіть код клієнта",
"pcat.stadium_arena": "Стадіон / Арена",
"pcat.supermarket": "Супермаркет",
"pcat.taxi_vtc": "Таксі / Замовлення таксі",
"pcat.tourism_office": "Туристичний офіс",
"pcat.train_bus_station": "Вокзал / Автовокзал",
"pcat.travel_agency": "Туристична агенція",
"hc.and": "і",
"hc.demoObj0": "гаманець",
"hc.demoObj1": "спортивна сумка",
"hc.demoObj2": "телефон",
"hc.demoObj3": "пара окулярів",
"hc.demoObj4": "набір ключів",
"hc.demoObj5": "шарф",
"hc.demoObj6": "ноутбук",
"hc.demoObj7": "пляшка для води",
"hc.demoWhen0": "2 години тому",
"hc.demoWhen1": "5 годин тому",
"hc.demoWhen2": "вчора",
"hc.demoWhen3": "3 години тому",
"hc.demoWhen4": "сьогодні вранці",
"hc.demoWhen5": "1 день тому",
"hc.feedDemo": "{obj} був повернутий в {city} {when}.",
"hc.feedReal": "Предмет ({cat}) був повернутий в {city}.",
"hc.saveBtn": "Зберегти",
"hc.saveLink": "Зберегти посилання",
"hc.terms": "Умови",
"hc.view": "Перегляд",
"pcat.airline": "Авіакомпанія",
"pcat.airport": "Аеропорт",
"pcat.amusement_park": "Тематичний парк",
"pcat.bank": "Банк",
"pcat.bar_cafe": "Бар / Кафе",
"pcat.beauty_salon": "Перукарня / Салон краси",
"pcat.cinema": "Кінотеатр",
"pcat.concert_theater": "Концертний зал / Театр",
"pcat.coworking": "Коворкінг",
"pcat.gym_fitness": "Спортзал / Фітнес",
"pcat.hospital_clinic": "Лікарня / Клініка",
"pcat.library": "Бібліотека",
"pcat.mall": "Торговий центр",
"pcat.museum": "Музей",
"pcat.pharmacy": "Аптека",
"pcat.private_company": "Приватна компанія",
"pcat.public_transport": "Громадський транспорт",
"pcat.school_university": "Школа / Університет",
"pcat.sports_center": "Спортивний центр",
"an.found": "Знайдено",
"an.lost": "Втрачене",
"hc.shareReview": "Поділитися відгуком",
"hc.citiesAboveTarget": "{n} міст перевищують свою ціль",
"hc.cityAboveTarget": "{n} місто перевищує свою ціль",
"hc.j15EarlyReminder": "Д-15 попередження",
"hc.j7EarlyReminder": "Д-7 попередження",
"hc.annualTotal": "Річна сума",
"hc.billedOnceYear": "Оплачується один раз за 12 місяців, поновлюється щороку.",
"hc.monthlyPrice": "Щомісячна ціна",
"hc.perMonth": "/ місяць",
"hc.perYear": "/ рік",
"hc.billedEachMonth": "Автоматично стягується щомісяця.",
"nav.business": "Бізнес",
"nav.individual": "Індивідуальний",
"hc.circumstancesFound": "Обставини знаходження",
"hc.circumstancesFoundPh": "Наприклад, знайдено на землі біля входу в метро",
"hc.circumstancesLost": "Обставини втрати",
"hc.circumstancesLostPh": "Наприклад, залишено на лавці, чекаючи автобус",
"hc.conditionPh": "Наприклад, в хорошому стані, подряпаний…",
"hc.firstName": "Ім'я",
"hc.lastName": "Призвище",
"hc.quantity": "Кількість предметів",
"fa.approve": "Схвалити",
"fa.approveConfirm": "Схвалити цю декларацію? Ваші повні контактні дані (ім'я, електронна пошта, телефон) будуть передані знахіднику.",
"fa.approved": "Декларацію схвалено — контактні дані обміняно",
"fa.approvedFinder": "Власник схвалив вашу декларацію",
"fa.approvedFinderText": "Зв'яжіться з ними, щоб організувати повернення.",
"fa.boostSub": "Ваше оголошення залишиться на вершині протягом вибраного часу.",
"fa.boostTitle": "Підвищити моє оголошення (необов'язково)",
"fa.colFinder": "Декларація знахідника",
"fa.colYours": "Ваша декларація",
"fa.compareHint": "Порівняйте декларацію знахідника зі своєю перед ухваленням рішення.",
"fa.contribNone": "Без внесків",
"fa.contribPaid": "Внесок отримано — дякуємо!",
"fa.contribPending": "Внесок очікує на оплату",
"fa.contribSub": "Підтримайте Findloop, щоб допомогти більше людям повернути свої речі. Ви можете вибрати €0.",
"fa.contribSuccessMsg": "Ваша декларація надіслана власнику.",
"fa.contribSuccessTitle": "Дякуємо за ваш внесок",
"fa.contribTitle": "Добровільний внесок",
"fa.days3": "3 дні",
"fa.days30": "30 днів",
"fa.days7": "7 днів",
"fa.declSub": "Опишіть знайдену річ. Власник порівняє вашу декларацію зі своєю.",
"fa.declTitle": "Я знайшов цю річ",
"fa.expiresOn": "Строк дії до",
"fa.fBrand": "Бренд",
"fa.fCircumstances": "Обставини",
"fa.fCity": "Місто",
"fa.fColor": "Колір",
"fa.fCondition": "Стан",
"fa.fDate": "Дата",
"fa.fMessage": "Повідомлення знахідника",
"fa.fPlace": "Місце",
"fa.fQuantity": "Кількість",
"fa.finderContact": "Контактні дані знахідника",
"fa.finishPay": "Завершити оплату",
"fa.foundDate": "Дата знаходження",
"fa.foundPlace": "Місце знаходження",
"fa.hours24": "24 години",
"fa.ht": "без ПДВ",
"fa.months3": "3 місяці",
"fa.noBoost": "Без підвищення",
"fa.ownerContact": "Контактні дані власника",
"fa.payPublish": "Оплатити та опублікувати",
"fa.pendingPayText": "Ваше оголошення з'явиться, як тільки підтвердять оплату.",
"fa.pendingPayTitle": "Очікування платежу",
"fa.planSub": "Ваше оголошення з'явиться, як тільки підтвердять оплату.",
"fa.planTitle": "Тривалість оголошення",
"fa.pubSuccessMsg": "Ваше оголошення опубліковано. Ви будете поінформовані, як тільки знайдеться шукач.",
"fa.pubSuccessTitle": "Оголошення опубліковано",
"fa.publicNote": "Публічно відображаються лише опис, місто, країна та фотографії.",
"fa.redirectStripe": "Переходжу до безпечного платежу…",
"fa.reject": "Відхилити",
"fa.rejectConfirm": "Відхиляти цю декларацію? Ваше оголошення залишиться в онлайн.",
"fa.rejected": "Декларацію відхилено",
"fa.rejectedFinder": "Це не те, що вони шукали",
"fa.rejectedFinderText": "Власник каже, що цей предмет не їхній. Дякуємо за вашу допомогу!",
"fa.responsesTitle": "Декларації шукачів",
"fa.sent": "Декларацію надіслано власнику.",
"fa.submitDecl": "Надіслати мою декларацію",
"fa.submitDeclPay": "Надіслати та внести {amount}",
"fa.total": "Разом до сплати",
"fa.ttc": "включаючи ПДВ",
"fa.waitClaimText": "Шукач розглядає ваш запит. Ви будете поінформовані про їхнє рішення.",
"fa.waitFinderText": "Ми повідомимо вас, як тільки шукач надішле декларацію.",
"fa.waitFinderTitle": "Ваше оголошення активне",
"fa.waitOwnerText": "Власник порівнює вашу декларацію зі своєю. Ви будете поінформовані про їхнє рішення.",
"fa.waitOwnerTitle": "Очікування рішення власника",
"st.pending_payment": "Очікування платежу",
"fa.africaFree": "Безкоштовне оголошення в Африці — пропозиція запуску Findloop, скористайтеся!",
"fa.africaPublished": "Оголошення опубліковане безкоштовно — пропозиція запуску в Африці!",
"fa.approveClaimConfirm": "Схвалити цю заяву? Власник зможе розблокувати ваші контактні дані.",
"fa.checkInfo": "Перевірте свої дані перед відправкою: вони будуть порівняні з даними знахідки.",
"fa.claimApprovedShort": "Знахідка схвалила вашу заяву",
"fa.claimRejectedShort": "Заява відхилена знахідкою",
"fa.claimRejectedText": "Знахідка вважає, що цей предмет не ваш.",
"fa.claimSub": "Опишіть свій предмет та додайте 2 фотографії. Знахідка порівняє їх зі своїм оголошенням.",
"fa.claimTitle": "Це мій предмет",
"fa.claimUnlockText": "Розблокуйте контактні дані знахідки, щоб організувати повернення.",
"fa.claimUnlockedShort": "Контактні дані розблоковані — дивіться трекінг",
"fa.claimsTitle": "Заяви власника",
"fa.colOwner": "Декларація власника",
"fa.colYourAd": "Ваше оголошення",
"fa.expired": "Термін дії оголошення закінчився",
"fa.free": "Безкоштовно",
"fa.lostDate": "Дата втрати",
"fa.lostPlace": "Місце втрати",
"fa.noReceipt": "Чек недоступний для цього оголошення.",
"fa.planSubFree": "Виберіть тривалість: ваше оголошення з'явиться негайно, оплата не потрібна.",
"fa.prefillPrevious": "Повторно використати дані мого попереднього оголошення в цій категорії",
"fa.receipt": "PDF чек",
"fa.renewBtn": "Продовжити",
"fa.renewDiscountBanner": "50% знижки: продовжте до закінчення терміну дії!",
"fa.renewDiscountHint": "Знижка 50% застосована, оскільки ви продовжуєте до закінчення терміну.",
"fa.renewEarly": "Продовжити (−50%)",
"fa.renewTitle": "Продовжити моє оголошення",
"fa.renewed": "Оголошення продовжено",
"fa.sendClaim": "Відправити мою заяву",
"fa.twoPhotos": "2 фотографії вашого предмета",
"fa.twoPhotosError": "Додайте 2 фотографії вашого предмета.",
"fa.twoPhotosHint": "Особисті фотографії, що доводять, що предмет ваш (з предметом, рахунком, коробкою…).",
"fa.unlockBtn": "Розблокувати контактні дані",
"fa.unlockFree": "Розблокувати безкоштовно — пропозиція запуску",
"fa.waitClaimantText": "Ми повідомимо вас, як тільки власник заявить про цей предмет.",
"fa.waitFinderDecision": "Очікування рішення знахідки",
"fa.waitUnlockText": "Вам буде повідомлено, як тільки контактні дані будуть обміняні.",
"fa.waitUnlockTitle": "Очікування, поки власник розблокує",
"fa.cancel": "Скасувати",
"fa.categoryRequired": "Виберіть категорію для знайденого елемента.",
"fa.confirmTitle": "Підтвердіть своє рішення",
"fa.goBack": "Назад",
"dr.continue": "Продовжити мою декларацію",
"dr.delete": "Видалити назавжди",
"dr.deleteConfirm": "Видалити цей чернетку назавжди? Цю дію не можна скасувати.",
"dr.deleted": "Чернетка видалена",
"dr.expiresIn": "Чернетка зберігається ще {h} годин",
"dr.title": "У вас є незавершена декларація",
"form.step": "Крок",
"form.next": "Продовжити",
"form.back": "Назад",
"form.stepDetails": "Ваш звіт",
"form.stepPublish": "Тривалість, підвищення та оплата",
"form.stepThanks": "Дякуємо та внесок",
"fthx.badge": "Звіт майже готовий",
"fthx.title": "Дякуємо, ви робите різницю!",
"fthx.text": "Завдяки вам, хтось може незабаром отримати назад те, що є для них важливим. Вчинки доброти, як ваші, саме те, що підтримує Findloop.",
"fthx.impact1": "1 елементreported",
"fthx.impact2": "1 додаткова можливість зустрічі",
"fthx.tipTitle": "Невеличкий внесок для Findloop?",
"fthx.tipText": "Ваш внесок допомагає нам зберігати сервіс доступним та повертати все більше речей їхнім власникам.",
"fthx.optional": "100% добровільно — ви можете публікувати без внеску.",
"fthx.thanksTip": "Дуже дякуємо за вашу щедрість!",
"fthx.suggest": "Запропоновані суми",
"fthx.none": "Без поради",
"pay.pendingTitle": "Платіж не завершено",
"pay.pendingText": "Ваші дані збережено. Продовжте платіж з того місця, де зупинилися.",
"pay.resume": "Продовжити платіж",
"pay.expiredTitle": "Сесію платежу закінчено",
"pay.expiredText": "З метою безпеки сесію платежу завершено. Ваші дані збережено: перезапустіть платіж в один клік.",
"pay.relaunch": "Перезапустити платіж",
"sub.received": "Відправлено!",
"sub.publishing": "Ми завершуємо…",
"sub.toPayment": "Перенаправляємо на безпечний платіж…",
"fa.claimSubV2": "Опишіть вашу втрату. Людина, яка її знайшла, порівняє вашу заяву з її оголошенням.",
"fa.photosOptional": "Фото вашого предмета (необов'язково)",
"fa.compareOwnerHint": "Порівняйте цю інформацію з предметом, який ви знайшли, а потім скажіть, чи це той самий предмет.",
"fa.itsThisItem": "Так, це саме той предмет",
"fa.notThisItem": "Ні, це не той предмет",
"fa.confirmIsItem": "Підтвердити, що це предмет? Ваші контактні дані та дані власника будуть показані у ваших відповідних облікових записах.",
"fa.confirmNotItem": "Підтвердити, що це не предмет? Ваш звіт буде закрито.",
"fa.youConfirmed": "Ви підтвердили, що це предмет власника",
"fa.youDeclined": "Ви вказали, що це не той предмет",
"fa.youDeclinedText": "Дякуємо за вашу допомогу! Власника було проінформовано.",
"fa.waitFinderDecisionOwner": "Очікуємо рішення знахідника",
"fa.finderConfirmed": "Підтверджено",
"fa.notYourItem": "Цей предмет не ваш",
"fa.reportedOn": "Подається",
"fa.ownerWaitHint": "Знахідник наразі перевіряє інформацію, будь ласка, зачекайте.",
"fa.claimSentFinder": "Заявка на відшкодування надіслана особі, яка знайшла предмет.",
"fa.compareClaimHint": "Порівняйте заяву власника з вашим оголошенням перед ухваленням рішення.",
"fa.closeFollowup": "Закрити цей супровід",
"fa.closeFollowupConfirm": "Закрити цей супровід? Електронні адреси та номери телефонів обох сторін будуть назавжди видалені, як тільки власник також закриє своє оголошення.",
"fa.safetyTitle": "Поради з безпеки перед передачею",
"fa.safety1": "Запитайте у власника детальний опис прихованих особливостей предмета: конкретну подряпину, точний вміст сумки, шпалери, серійний номер…",
"fa.safety2": "Якщо можливо, попросіть візуальне підтвердження (фото предмета) або чек про покупку.",
"fa.safety3": "Передавайте предмет у громадському місці або у партнера Findloop та перевірте посвідчення особи власника.",
"fa.safetyOk": "Зрозуміло, продовжити",
"fa.ownerClosedNote": "Власник закрив своє оголошення.",
"fa.finderClosedNote": "Знайомий закрив свій супровід.",
"fa.followupClosed": "Наступний етап закрито",
"fa.followupClosedText": "Ви закрили цей наступний етап. Дякуємо за вашу допомогу!",
"fa.photoReviewTitle": "Знайшов надіслав фото. Це виглядає як ваш предмет?",
"fa.photoLooksLike": "Так, це виглядає як мій предмет",
"fa.photoNotMine": "Ні, це не мій предмет",
"fa.photoNotMineConfirm": "Наступний крок буде закрито з обох сторін, і ваше оголошення залишиться відкритим для нового шукача.",
"fa.photoLooksLikeDone": "Дякуємо! Тепер знаfinder буде порівнювати вашу декларацію.",
"fa.photoNotMineDone": "Доповідь відхилена. Ваше оголошення залишається відкритим.",
"fa.ownerPhotoHint": "Показується лише фото шукача. Скажіть нам, чи це виглядає як ваш предмет.",
"fa.ownerReviewingPhoto": "Власник розглядає ваше фото",
"fa.ownerReviewingPhotoText": "Ви будете сповіщені, як тільки вони дадуть відповідь. Потім ви зможете порівняти їхню декларацію.",
"fa.ownerRejectedPhoto": "Це не предмет власника",
"fa.ownerRejectedPhotoText": "Власник каже, що ваше фото не відповідає їхній речі. Наступний крок закрито. Дякуємо за вашу допомогу!",
"fa.contribute": "Внести свій внесок",
"fa.phoneMissing": "Не надано",
"fa.ownerSafety1": "Перевага віддається передачі в публічному місці або у партнера Findloop. Якщо відстань велика, запропонуйте надіслати його поштою.",
"fa.ownerSafety2": "Під час передачі перевірте посвідчення особи знавця.",
"pub.changePhoto": "Змінити фото",
"ph.secured": "Фото захищено",
"ph.securing": "Захист фото…",
"fa.ownerSafety3": "Якщо фото знайдено з водяним знаком Findloop, не приймайте зустріч. Фото має бути оригінальним зображенням, зробленим знаходячим, без водяного знака."
},
"ar": {
"ac.africa": "أفريقيا",
"ac.boostActive": "تمييز نشط —",
"ac.boostSub": "ظهور في أعلى دليل الشركاء مع شارة “معززة”.",
"ac.boostTitle": "قم بزيادة ظهور إدراجك في الدليل",
"ac.categoryHint": "لتصنيف مؤسستك في دليل findloop.",
"ac.choose": "اختر",
"ac.cityHint": "للتحديد الدقيق على الخريطة العامة.",
"ac.cityLabel": "مدينة المؤسسة",
"ac.cityPh": "باريس",
"ac.contact": "تفاصيل الاتصال",
"ac.converted": "تم تحويله",
"ac.copyDeclLink": "نسخ رابط الإقرار",
"ac.copyLink": "نسخ الرابط",
"ac.currentPlan": "الخطة الحالية",
"ac.emailDesc": "اختر الرسائل الإلكترونية التي ترغب في تلقيها. ستبقى الإشعارات في مساحتك نشطة دائمًا.",
"ac.emailMatch": "مطابقات",
"ac.emailMatchDesc": "بريد إلكتروني عندما يتطابق عنصر مع إقرار",
"ac.emailNewDecl": "إقرارات فقد جديدة",
"ac.emailNewDeclDesc": "بريد إلكتروني بمجرد أن يقوم العميل بالإبلاغ عن فقد في مكانك",
"ac.emailShip": "طلبات الشحن",
"ac.emailShipDesc": "بريد إلكتروني عندما يطلب العميل شحن عنصر",
"ac.emailTitle": "تفضيلات البريد الإلكتروني",
"ac.expireSoon": "سينتهي تمييزك قريبًا —",
"ac.exportCsv": "تصدير (CSV)",
"ac.exportHint": "قم بتصدير مدفوعاتك الخارجية المعتمدة للمحاسبة الخاصة بك.",
"ac.free": "مجاني",
"ac.freeMonths": "أشهر مجانية",
"ac.hours": "ساعات",
"ac.howItWorks": "كيف يعمل؟",
"ac.invited": "تمت الدعوة",
"ac.legalFR": "مطلوب للفوترة الإلكترونية (Factur-X) ساري المفعول من سبتمبر 2026.",
"ac.legalMissing": "⚠️ سِرِيت ورمز ضريبة القيمة المضافة داخل الاتحاد الأوروبي مفقود — أكملهم للبقاء متوافقًا مع الفوترة الإلكترونية.",
"ac.legalOther": "موصى به لفواتيرك.",
"ac.legalPartnerQr": "رمز الاستجابة السريعة",
"ac.legalTitle": "الهوية القانونية (الفوترة)",
"ac.logoTitle": "شعار المؤسسة",
"ac.modeCurrent": "الوضع الحالي:",
"ac.modeExternal": "خارجي (تحقق يدوي)",
"ac.modeInternal": "داخلي Findloop (آلي)",
"ac.noSubReceipt": "لا يوجد دفع اشتراك مدفوع بعد.",
"ac.none": "لا شيء",
"ac.onYourListing": "على إدراجك",
"ac.pay1": "أدخل روابط الدفع الخاصة بك أدناه لتحويل عملائك إلى نظام تحصيلك الخاص.",
"ac.pay2": "التحقق يصبح يدويًا: تؤكد استلام الدفع من علامة التبويب “الإقرارات”.",
"ac.pay3": "رابط “رسوم الشحن” هو دفع موحد (استرداد + شحن).",
"ac.pay4": "اترك الحقول فارغة لاستخدام الدفع الداخلي لـ Findloop (Stripe) مع التحقق التلقائي.",
"ac.paySub": "قم بتحصيل الرسوم عبر نظام الدفع الخاص بك.",
"ac.payTitle": "المدفوعات الخارجية",
"ac.permissive": "متساهل",
"ac.phone": "الهاتف",
"ac.posterA4": "ملصق A4 (PDF)",
"ac.qMessage": "رسالة (اختياري)",
"ac.qName": "الاسم",
"ac.qOrg": "المنظمة",
"ac.qSites": "عدد المؤسسات (تقديري)",
"ac.qrHint": "عملاؤك يقومون بمسح هذا الرمز للإبلاغ عن عنصر مفقود.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "رمز QR الخاص بشريكك",
"ac.quoteDesc": "المطارات، شبكات السكك الحديدية، السلاسل الدولية · ",
"ac.quoteEurope": "أوروبا / العالم",
"ac.quoteSent": "تم إرسال طلب الاقتباس. سيتواصل معك فريقنا قريبًا.",
"ac.quoteTitle": "اطلب اقتباسًا — مؤسسة",
"ac.recoveryLink": "رابط “رسوم الاسترداد”",
"ac.refSub": "كل شريك مُحيل يشترك يمنحك شهرًا مجانيًا واحدًا.",
"ac.refTitle": "أحِل، واربح شهرًا مجانيًا",
"ac.reminderDelay": "تأخير تذكير التحقق",
"ac.reminderHint": "ستتلقى تذكيرًا عبر البريد الإلكتروني إذا كان هناك دفع خارجي لم يتم التحقق منه بعد هذا التأخير (افتراضي: 48 ساعة).",
"ac.renewDesc1": "لقد جلب لك بالفعل",
"ac.renewDesc2": "قم بالتجديد لتبقى في قمة الدليل ولا تفقد هذه الرؤية.",
"ac.renewNow": "جدد الآن",
"ac.requestQuote": "اطلب اقتباسًا",
"ac.saveLegal": "احفظ المعرفات",
"ac.saveLinks": "احفظ الروابط",
"ac.sendRequest": "أرسل طلبي",
"ac.sending": "يتم الإرسال…",
"ac.shippingLink": "رابط “رسوم الشحن” (موحد)",
"ac.shippingLinkHint": "يغطي هذا الرابط كل من الاسترداد والشحن.",
"ac.strict": "صارم",
"ac.subReceipt": "إيصال الاشتراك (PDF)",
"ac.subReceiptsSub": "قم بتنزيل إيصال PDF لكل دفعة اشتراك.",
"ac.subReceiptsTitle": "إيصالات الاشتراك",
"ac.tCategory": "فئة محفوظة",
"ac.tCity": "مدينة محفوظة — تم تحديث الخريطة",
"ac.tCityNeeded": "أدخل مدينة",
"ac.tCopied": "تم النسخ!",
"ac.tCover": "تم تحديث الصورة الرئيسية",
"ac.tEmailPrefs": "تم تحديث تفضيلات البريد الإلكتروني",
"ac.tErr": "خطأ",
"ac.tExportImpossible": "فشل التصدير",
"ac.tLegal": "تم حفظ المعرفات القانونية",
"ac.tLegalNeeded": "SIRET و VAT مطلوبان لفرنسا",
"ac.tLogo": "تم تحديث الشعار",
"ac.tLogoRemoved": "تم إزالة الشعار",
"ac.tPayLinks": "تم حفظ روابط الدفع",
"ac.tPhone": "تم حفظ الهاتف",
"ac.tSensitivity": "تم حفظ الحساسية",
"ac.tVatInvalid": "رقم VAT غير صالح",
"ac.tVatValid": "VAT صالح",
"ac.tabBoost": "رؤية",
"ac.tabPayments": "المدفوعات",
"ac.tabProfile": "الملف الشخصي",
"ac.tabQr": "QR & ملصق",
"ac.tabReferral": "الإحالة",
"ac.tabSub": "الاشتراك",
"ac.thisWeek": "هذا الأسبوع",
"ac.thisWeekOf": " ({n} هذا الأسبوع)",
"ac.thresholdDesc": "عتبة الثقة التي عندها يقوم الذكاء الاصطناعي تلقائيًا بالتحقق من تطابق الصورة وإخطار العميل. أعلى = تطابقات تلقائية أقل ولكن أكثر موثوقية.",
"ac.thresholdTitle": "حساسية التطابق المرئي للذكاء الاصطناعي",
"ac.trend": "اتجاه",
"ac.upload": "تحميل",
"ac.vatValidFmt": "VAT صالح{name} ({via})",
"ac.vatVerified": "تم التحقق من VAT داخل الاتحاد الأوروبي",
"ac.verifyVat": "تحقق من VAT (VIES)",
"ac.verifying": "جارٍ التحقق…",
"ac.views": "مشاهدات",
"ac.viewsTotal": "المشاهدات المكتسبة (مجموع)",
"ac.winbackBtn": "استئناف مع -20%",
"ac.winbackDesc1": "لقد جلب لك",
"ac.winbackDesc2": "عرض خاص: -20% يتم تطبيقه تلقائيًا إذا قمت بالتجديد خلال 24 ساعة.",
"ac.winbackTitle": "لقد انتهت صلاحية تسليط الضوء عليك — استأنف بخصم -20%!",
"an.allCountries": "جميع البلدان",
"an.country": "البلد",
"an.geoBanner": "أنت تشاهد القوائم في",
"an.geoBannerWorld": "أنت تشاهد القوائم على مستوى العالم",
"an.geoChange": "تغيير البلد",
"an.loginRequired": "قم بتسجيل الدخول للإبلاغ عن هذا العنصر واتباع الإرجاع.",
"an.requestInProgress": "الطلب قيد التقدم",
"an.resolved": "تم استرداد العنصر بالفعل",
"an.shareConsent": "أوافق على أنه يمكن مشاركة تفاصيل الاتصال الخاصة بي (الاسم، البريد الإلكتروني، الهاتف) مع مالك العنصر.",
"an.shareConsentError": "يرجى تحديد المربع لمشاركة تفاصيل الاتصال الخاصة بك.",
"an.sortRecent": "الأحدث",
"an.sortRelevance": "الصلة",
"anf.shareConsent": "أوافق على أنه يمكن مشاركة تفاصيل الاتصال الخاصة بي (الاسم، البريد الإلكتروني، الهاتف) مع الشخص الذي وجد العنصر.",
"bo.africaPrice": "تم تطبيق أسعار تفضيلية لمنطقة إفريقيا",
"c.all": "الجميع",
"c.close": "إغلاق",
"c.confirm": "تأكيد",
"c.confirmed": "تم التأكيد",
"c.download": "تنزيل",
"c.reset": "إعادة تعيين",
"c.transfer": "نقل",
"cat.Animal": "حيوان أليف / ملحقات حيوانات أليفة",
"cat.AppareilPhoto": "كاميرا",
"cat.Argent": "مال / نقد",
"cat.Autres": "أخرى",
"cat.Bijoux": "مجوهرات",
"cat.CarteBancaire": "بطاقة بنكية",
"cat.CarteIdentite": "بطاقة هوية / جواز سفر",
"cat.Casquette": "قبعة",
"cat.Ceinture": "حزام",
"cat.Chargeur": "شاحن / كابل",
"cat.Chaussures": "أحذية",
"cat.CleVoiture": "مفتاح السيارة",
"cat.Cles": "مفاتيح",
"cat.Console": "وحدة تحكم ألعاب",
"cat.Documents": "مستندات / أوراق",
"cat.Echarpe": "وشاح",
"cat.Ecouteurs": "سماعات الأذن / سماعات الرأس",
"cat.Electronique": "إلكترونيات (أخرى)",
"cat.Enceinte": "مكبر صوت",
"cat.Gants": "قفازات",
"cat.Gourde": "زجاجة ماء / قارورة",
"cat.Instrument": "آلة موسيقية",
"cat.Jouet": "لعبة / دمية",
"cat.Jumelles": "مناظير",
"cat.Lampe": "مصباح / مصباح يدوي",
"cat.Liseuse": "قارئ إلكتروني",
"cat.Livre": "كتاب / دفتر",
"cat.Lunettes": "نظارات",
"cat.Manteau": "معطف / سترة",
"cat.Maquillage": "حقيبة مكياج",
"cat.Medical": "معدات طبية",
"cat.Medicaments": "أدوية",
"cat.Montre": "ساعة / ساعة ذكية",
"cat.Ordinateur": "حاسوب محمول",
"cat.Parapluie": "مظلة",
"cat.Portefeuille": "محفظة / حقيبة يد",
"cat.Poussette": "عربة أطفال / ملحقات للأطفال",
"cat.Sac": "حقيبة / حقيبة يد",
"cat.SacADos": "حقيبة ظهر",
"cat.Souris": "ماوس / لوحة مفاتيح",
"cat.Sport": "معدات رياضية",
"cat.Tablette": "جهاز لوحي",
"cat.Telephone": "هاتف / سمارتفون",
"cat.Trottinette": "سكوتر",
"cat.Trousse": "حقيبة / علبة",
"cat.USB": "فلاش USB / قرص صلب",
"cat.Valise": "حقيبة سفر",
"cat.Velo": "دراجة",
"cat.Vetements": "ملابس",
"cm.found": "موجود",
"cm.lost": "مفقود",
"cmp.starterEst": "1 مشمول + اضافي غير محدود",
"consent.required": "يجب عليك الموافقة على مشاركة تفاصيل الاتصال الخاصة بك للمتابعة.",
"consent.share": "أوافق على أن الشخص الذي عثر على غرضي قد يرى تفاصيل الاتصال الخاصة بي (الاسم، البريد الإلكتروني، الهاتف) للتواصل معي لإعادته.",
"dc.partnerDesc": "فقدت غرضك في مكان شريك (فندق، محطة، قاعة…)? اختره لإعادة مباشرة.",
"dc.partnerList": "اختر من القائمة",
"dc.partnerMap": "اختر من الخريطة",
"dc.partnerTitle": "إعلان في شريك",
"dc.publicCta": "نشر إعلان عام",
"dc.publicDesc": "سيكون إعلانك مرئيًا لمجتمع Findloop بالكامل. مثالي إذا لم تكن تعرف أين فقدت الغرض.",
"dc.publicTitle": "إعلان عام",
"dc.subtitle": "اختر كيفية الإبلاغ عن غرضك المفقود.",
"dc.title": "ماذا تريد أن تفعل؟",
"dec.addrPending": "العنوان قيد الانتظار من العميل",
"dec.analyzing": "جارٍ التحليل…",
"dec.clientDescription": "وصف العميل",
"dec.clientPhoto": "صورة مقدمة من العميل",
"dec.clientPhotoShort": "صورة العميل",
"dec.comparePhotos": "مقارنة الصور",
"dec.declaredItemPhoto": "صورة الغرض المعلن عنه",
"dec.emptyDesc": "شارك رمز الاستجابة السريعة الخاص بك لتلقي الإعلانات.",
"dec.emptyTitle": "لا توجد إعلانات",
"dec.enlarge": "تكبير",
"dec.extBanner": "{n} مدفوعات خارجية للتأكيد — اكد الاستلام أدناه لفتح التسليم أو الشحن.",
"dec.foundItemAlt": "غرض موجود",
"dec.foundItemRegistry": "غرض موجود (سجل)",
"dec.labelClient": "عميل",
"dec.labelRegistry": "سجل",
"dec.noMatchYet": "لا توجد مطابقة حتى الآن.",
"dec.noPhoto": "لا يوجد صورة",
"dec.pRecup": "استرداد",
"dec.pRecupP": "(استرداد)",
"dec.pRecupShip": "(استرداد + شحن)",
"dec.payConfirmed": "تم تأكيد الدفع {x}",
"dec.payPending": "مدفوعات خارجية {x} قيد الانتظار",
"dec.pickup": "استلام شخصي",
"dec.reject": "رفض",
"dec.rerun": "إعادة تشغيل التحليل",
"dec.similarity": "تشابه {n}%",
"dec.suggestedMatches": "مطابقات مقترحة",
"dec.toColon": " إلى:",
"dec.toShip": "لـ الشحن",
"dec.toastExtPay": "تم التأكيد على الدفع — سيتم إبلاغ العميل.",
"dec.toastMatch": "تم تأكيد المطابقة",
"dec.toastReject": "تم رفض الاقتراح",
"dec.toastRerun": "تم إعادة بدء التحليل",
"dec.toastVisualN": "{n} مطابقة بصرية",
"dec.toastVisualNone": "لا توجد مطابقة بصرية",
"dec.viewBeforeAfter": "عرض قبل/بعد (تراكب)",
"dec.viewSideBySide": "عرض جنبًا إلى جنب",
"dec.visualCompare": "مقارنة بصرية بواسطة AI",
"dec.visualIdle": "قم بتشغيل المقارنة حتى يتطابق AI بصريًا مع صورة العميل مع العناصر الموجودة.",
"dec.visualRunning": "AI يقارن صورة العميل مع العناصر في سجلك…",
"dec.zoomPhoto": "تكبير الصورة",
"dep.addAnyway": "أضف على أي حال",
"dep.addError": "خطأ أثناء الإضافة",
"dep.addItem": "أضف عنصر",
"dep.added": "تمت إضافة العنصر إلى السجل!",
"dep.adding": "جارٍ الإضافة…",
"dep.aiError": "تحليل AI غير متاح الآن.",
"dep.aiFilled": "نموذج تم ملؤه مسبقًا بواسطة AI ✨",
"dep.aiUnavailable": "AI غير متاحة — املأ النموذج يدويًا.",
"dep.analyzing": "جارٍ التحليل…",
"dep.analyzingPhoto": "جارٍ تحليل الصورة…",
"dep.brand": "علامة تجارية",
"dep.brandPlaceholder": "مثل آبل",
"dep.category": "فئة",
"dep.checkingDup": "جارٍ التحقق من المكررات…",
"dep.color": "لون",
"dep.colorPlaceholder": "مثل الأسود",
"dep.condition": "حالة",
"dep.conditionPlaceholder": "مثل حالة جيدة",
"dep.depositorNote": "ملاحظة المودع",
"dep.depositorNoteHint": "تفاصيل تشغيلية مكتوبة يدويًا. AI لا تكتب فوق هذه الملاحظة أبدًا.",
"dep.depositorNotePlaceholder": "مثل محتويات حقيبة، علامة تجارية كما تم الإبلاغ عنها، تفاصيل قدمها الشخص…",
"dep.descPlaceholder": "مثل آيفون 15 الأسود مع غلاف شفاف، تم العثور عليه في البار…",
"dep.description": "وصف",
"dep.dupHint": "تأكد أنك لا تضيف مكرر. يمكنك المتابعة إذا كان العنصر مختلفًا حقًا.",
"dep.dupTitle": "عنصر(ات) مشابهة مسجلة بالفعل",
"dep.dupWarn": "تم اكتشاف عنصر مشابه — راجعه، ثم انقر مرة أخرى للتأكيد.",
"dep.estHint": "سيتم إضافة العنصر إلى سجل هذا المؤسسة.",
"dep.establishment": "مؤسسة",
"dep.fee": "رسوم الاسترجاع (€) — اختيارية",
"dep.feePlaceholder": "اتركه فارغًا لسعر الفئة الافتراضي",
"dep.fillAI": "املأ بواسطة AI",
"dep.optional": "(اختياري)",
"dep.photo": "صورة العنصر",
"dep.principal": "أساسي",
"dep.reqError": "الفئة والوصف مطلوبان.",
"dep.savedItem": "عنصر مسجل",
"dep.similarity": "التشابه",
"dep.storage": "الموقع الفعلي",
"dep.storageHint": "حيث يتم تخزين العنصر فعليًا. سيتم إنشاء رمز QR للعثور عليه.",
"dep.storagePlaceholder": "مثل الرف A3، الخزنة 12، خزنة الاستقبال",
"dl.aClient": "عميل",
"dl.alertsBlocked": "تم حظر تنبيهات المتصفح",
"dl.alertsBlockedHint": "لإعادة تمكينها: انقر على رمز 🔒 (أو ⓘ) إلى يسار عنوان الموقع، ثم اسمح بالإشعارات وأعد تحميل الصفحة.",
"dl.amountDue": "المبلغ المستحق: {amount} {currency}.",
"dl.enableAlerts": "تفعيل التنبيهات",
"dl.extPending": "مدفوعات تحتاج إلى التحقق",
"dl.freemiumNear": "أنت تقترب من حد freemium ({used}/{max} عنصر هذا الشهر). قم بالترقية إلى Starter لعناصر غير محدودة.",
"dl.freemiumReached": "تم الوصول إلى حد freemium ({used}/{max} عنصر هذا الشهر). قم بالترقية إلى Starter لتسجيل عناصر غير محدودة.",
"dl.invoiceOverdue": "الفاتورة {num} غير مدفوعة — الوصول مقيد.",
"dl.matchNotifTitle": "Findloop — تطابق جديد بواسطة AI 🔔",
"dl.matchToast": "تطابق جديد بواسطة AI — {name}",
"dl.matchToastDesc": "عنصر يتطابق مع إقرار.",
"dl.notifEmpty": "لا توجد إشعارات حتى الآن.",
"dl.notifEnabled": "تنبيهات المتصفح مفعلة",
"dl.notifTitle": "الإشعارات",
"dl.payInvoice": "ادفع الفاتورة الخاصة بي →",
"dl.rewardsPending": "قسائم لتقديمها",
"dl.upgradeStarter": "ترقية إلى ستارتير →",
"est.all": "جميع المؤسسات ({n})",
"est.label": "مؤسسة",
"est.primary": "أساسي",
"est.secondary": "ثانوي",
"est2.add": "إضافة مؤسسة",
"est2.addressLabel": "العنوان",
"est2.addressPh": "12 شارع الجمهورية",
"est2.autoInvoice": "يتم إنشاء فاتورة تفصيلية تلقائيًا في اليوم الأول من كل شهر.",
"est2.baseSub": "الاشتراك الأساسي",
"est2.billing": "الفوترة",
"est2.boostActivated": "تم تفعيل التعزيز لـ {name}",
"est2.boostBillingNote": "يتم فوترة السعر الحالي ومجموعه في فاتورتك الشهرية المجمعة.",
"est2.boostCta": "تعزيز",
"est2.boostDesc": "تحسين رؤية هذه المؤسسة في الدليل وعلى الخريطة.",
"est2.boostDuration": "{h} ساعة من الرؤية المعززة",
"est2.boostExtend": "تمديد",
"est2.boostTitle": "تعزيز {name}",
"est2.boosted": "معزز",
"est2.chartDesc": "نسبة العناصر المعادة من مجموع المسجل، موقعًا بموقع.",
"est2.chartTitle": "نسبة الإرجاع حسب المؤسسة",
"est2.chartTooltip": "إرجاع",
"est2.cityLabel": "المدينة",
"est2.cityPh": "ليون",
"est2.contactHint": "تظهر هذه التفاصيل للعميل لهذه المؤسسة (تعود إلى الحساب إذا كانت فارغة).",
"est2.countryLabel": "الدولة",
"est2.coverLabel": "صورة الغلاف",
"est2.create": "إنشاء",
"est2.created": "تم إنشاء المؤسسة",
"est2.delete": "حذف",
"est2.deleteDesc": "هذا الإجراء دائم. يمكنك حذف المؤسسة فقط إذا كانت لا تحتوي على عناصر.",
"est2.deleteTitle": "حذف “{name}”؟",
"est2.deleted": "تم حذف المؤسسة",
"est2.dialogDesc": "أدخل اسم وعنوان هذا الموقع.",
"est2.edit": "تعديل",
"est2.editEst": "تعديل المؤسسة",
"est2.emailLabel": "البريد الإلكتروني للتواصل",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " مؤسسة(ات)",
"est2.extraNoteBase": "{n} مؤسسة(ات) إضافية مفوترة",
"est2.extraPrice": " بسعر {price} يورو/الشهر.",
"est2.extraQuote": " بناءً على الاقتباس.",
"est2.imgChange": "اختر صورة",
"est2.imgDone": "تم",
"est2.imgRemove": "إزالة",
"est2.imgRemoved": "تمت إزالة الصورة",
"est2.imgSaved": "تم حفظ الصورة",
"est2.imgUploading": "جاري التحميل…",
"est2.includedPlan": "مدرج في خطتك: {n}.",
"est2.kDeclarations": "الإعلانات",
"est2.kInStorage": "في المخزن",
"est2.kItemsTotal": "العناصر (مجموع)",
"est2.kRestituted": "المعاد",
"est2.limitReached": "تم الوصول إلى الحد",
"est2.logoLabel": "الشعار",
"est2.mDeclar": "الإعلانات",
"est2.mItems": "العناصر",
"est2.mRestituted": "المعاد",
"est2.mStorage": "في التخزين",
"est2.monthlyTotal": "الإجمالي الشهري",
"est2.nameLabel": "الاسم *",
"est2.namePh": "مثل. فندق بلمونت — جناح ليون",
"est2.newEst": "إنشاء جديد",
"est2.onQuote": "على اقتباس",
"est2.phoneLabel": "الهاتف",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "خطة",
"est2.planLimited": "خطتك “{tier}” محدودة ب {max} منشأة.",
"est2.primary": "أساسي",
"est2.qr": "رمز الاستجابة السريعة",
"est2.qrDesc": "قم بعرض رمز الاستجابة السريعة هذا في هذه المنشأة. سيتم ربط العملاء الذين يبلغون عن فقدان بهذا الموقع.",
"est2.qrTitle": "رمز الاستجابة السريعة — {name}",
"est2.saving": "جارٍ الحفظ...",
"est2.seeInvoices": "عرض فواتيري الشهرية",
"est2.seePlans": "عرض الخطط",
"est2.subtitle": "إدارة جميع مواقعك تحت حساب واحد — عرض موحد، عناصر، رمز الاستجابة السريعة والفواتير.",
"est2.suspended": "معلق",
"est2.tierFree": "1 منشأة",
"est2.tierLarge": "منشآت غير محدودة",
"est2.tierMedium": "5 منشآت متضمنة",
"est2.tierSmall": "3 منشآت متضمنة",
"est2.title": "المنشآت",
"est2.unlimitedPlan": "تسمح لك خطتك بعدد غير محدود من المنشآت.",
"est2.unlimitedSuffix": " · غير محدود",
"est2.updated": "تم تحديث المنشأة",
"est2.upgradeHint": "قم بالترقية إلى خطة أعلى لإضافة المزيد من المواقع وموحد جميع أنشطتك.",
"est2.visuals": "الشعار والصورة",
"est2.visualsDesc": "قم بتخصيص شعار هذه المنشأة وصورة الغلاف. ستظهر على صفحتها العامة ونموذج الإقرار.",
"est2.visualsTitle": "المرئيات — {name}",
"est2.workOn": "العمل على هذه المنشأة",
"est2.working": "أنت تعمل على “{name}”",
"ft.backAccount": "العودة إلى حسابي",
"ft.closeBtn": "إغلاق القضية",
"ft.closeConfirm": "تأكيد أن العنصر قد تم إرجاعه؟ سيتم إغلاق الإعلان.",
"ft.closeLockedHint": "تحقق من رمز المالك أولاً لإلغاء قفل الإغلاق.",
"ft.closed": "تم إغلاق القضية — العنصر تم إرجاعه!",
"ft.codeLabel": "أدخل رمز التحقق المستلم من المالك",
"ft.codeNeeded": "يرجى إدخال رمز التحقق.",
"ft.codeOk": "تم التحقق من الرمز — يمكنك إغلاق القضية.",
"ft.codePlaceholder": "مثل. 4821",
"ft.codeVerified": "تم التحقق",
"ft.doneMsg": "تم إرجاع العنصر. شكرًا لمساعدتك في إرجاعه إلى مالكه!",
"ft.stepInProgress": "الإرجاع جاري",
"ft.stepPublished": "الإعلان منشور",
"ft.stepReturned": "تم إرجاع العنصر",
"ft.subtitle": "اتبع الخطوات حتى يتم إرجاع العنصر المفقود.",
"ft.title": "تتبع الإرجاع",
"ft.verifyBtn": "تحقق من الرمز",
"inv2.contractTitle": "عقدي مع Findloop",
"inv2.detailByEst": "التفاصيل حسب المنشأة",
"inv2.dueLabel": "المستحق:",
"inv2.dueSuffix": " · مستحق {date}",
"inv2.error": "خطأ {status}",
"inv2.estCountIssued": "{n} منشأة(ات) · صدرت في {date}",
"inv2.estimate": "تقدير (غير مفوتر) · {n} منشأة(ات)",
"inv2.expired": " · منتهية",
"inv2.exportCsv": "تصدير CSV",
"inv2.exportDone": "تم تنزيل تصدير CSV",
"inv2.included": "مُدرَج",
"inv2.monthlyTitle": "الفوترة الشهرية (الاشتراك)",
"inv2.months": "+{n} أشهر",
"inv2.paid": "مدفوع",
"inv2.pay": "ادفع",
"inv2.previewTitle": "معاينة فاتورتك القادمة —",
"inv2.renew": "تجديد عقدي",
"inv2.renewalsTitle": "تاريخ التجديد ({n})",
"inv2.renewedUntil": "تم تجديد العقد حتى {date}",
"inv2.serviceTitle": "فواتير الخدمة (الاستردادات والعروض)",
"inv2.soon": "ستنتهي قريبًا",
"inv2.toPay": "للدفع",
"inv2.totalHtTva": "الإجمالي بدون الضريبة · VAT",
"inv2.totalTtc": "الإجمالي شامل الضريبة",
"iu.addPhoto": "أضف صورة",
"iu.change": "تغيير",
"map.high": "مرتفع",
"map.legend": "نقاط ملونة من الأحمر (منخفض) إلى الأخضر (مرتفع) بناءً على معدل الاسترداد؛ الحجم يعتمد على عدد العناصر.",
"map.locating": "جاري تحديد الموقع… أضف عنوانًا لمؤسساتك لتراها على الخريطة.",
"map.low": "منخفض",
"map.medium": "متوسط",
"map.noItemRegistered": "لا توجد عنصر مسجل",
"map.noItems": "لا توجد عناصر",
"map.returnedSuffix": "مرتجعة · {a}/{t} عناصر",
"map.title": "خريطة مؤسساتك",
"mc.archiveHide": "إخفاء التاريخ",
"mc.archiveNone": "لا توجد حالات مُحَلَّة حتى الآن.",
"mc.archiveShow": "عرض التاريخ",
"mc.archiveSub": "الحالات المُحَلَّة والمُرجعة.",
"mc.archiveTitle": "التاريخ",
"mc.certificate": "شهادة",
"mc.finderAccepted": "مقبول",
"mc.hAd": "إعلان مفقود",
"mc.hDeclaration": "إعلان",
"mc.hFinderContact": "عنصر تم الإبلاغ عنه",
"mc.hFound": "عنصر مُرجع",
"mc.hFoundAd": "إعلان تم العثور عليه",
"mc.myFinds": "العناصر التي وجدتها",
"mc.myFindsNone": "لم تقم بالإبلاغ عن العثور على أي عنصر حتى الآن.",
"mc.myFindsSub": "العناصر التي قمت بالإبلاغ عنها في إعلانات العناصر المفقودة.",
"mc.notifOpen": "عرض",
"mc.notifTrack": "تعقب",
"mc.notifViewAd": "عرض الإعلان",
"mc.presentHint": "اعرض هذا الرمز الشريطي للشريك: يقومون بمسحه لإلغاء تأكيد مكافأتك.",
"mc.presentInStore": "عرض في المتجر",
"mc.presentTitle": "عرض هذا القسيمة",
"mc2.acceptFinder": "قبول هذا المُكتشف",
"mc2.accountActivity": "نشاط الحساب",
"mc2.adsActive": "{n}/5 إعلانات نشطة",
"mc2.autoDelete": "حذف تلقائي مُجدول لـ",
"mc2.badgeBronze": "برونزي",
"mc2.badgeGold": "ذهبي",
"mc2.badgeSilver": "فضي",
"mc2.boostEarnedAlready": "لقد حصلت بالفعل على",
"mc2.boostEarnedWin": "لقد كسبت",
"mc2.boostExpiredWin": "عنكوشك انتهت للتو — استأنف بـ -20%! ",
"mc2.boostExpiresIn": "ستنتهي منحتك في",
"mc2.boostWinDetail2": ". -20% مُطبقة تلقائيًا إذا قمت بالتجديد خلال 24 ساعة.",
"mc2.claimCode": "كود المطالبة:",
"mc2.codeSentFinder": "تم إرسال الكود إلى المُكتشف عبر البريد الإلكتروني",
"mc2.daysShort": "{n} يوم",
"mc2.downloadReceipt": "تحميل الإيصال",
"mc2.error": "خطأ {status}",
"mc2.finderAccepted": "تم قبول المُعثر — تم إرسال الرمز عبر البريد الإلكتروني",
"mc2.finderContacts": "تفاصيل اتصال المُعثر(ين)",
"mc2.followFindo": "تابع Findloop",
"mc2.imgInvalid": "صورة غير صالحة",
"mc2.inactivityNote": " — في حالة {n} أشهر من عدم النشاط (GDPR).",
"mc2.lastActivity": "آخر نشاط:",
"mc2.lostEmailTitle": "لم أعد أملك وصولًا إلى بريدي الإلكتروني",
"mc2.noPhotoPreset": "لا توجد صورة بعد؟ اختر صورة إفتراضية:",
"mc2.paidViaPartner": "مدفوع (عبر شريك)",
"mc2.payRecovery": "دفع رسوم الاستعادة",
"mc2.paySettle": "تسوية مدفوعيتي",
"mc2.payShipping": "دفع رسوم الشحن",
"mc2.payUnavailable": "الدفع غير متاح",
"mc2.peopleFound": "{n} شخص(أشخاص) يعتقدون أنهم وجدوا غرضك",
"mc2.phoneNumber": "رقم الهاتف",
"mc2.reactivateAccount": "إعادة تنشيط حسابي",
"mc2.reactivated": "تم إعادة تنشيط الحساب",
"mc2.reactivatedThanks": "تم إعادة تنشيط الحساب — شكرًا على وفائك!",
"mc2.recoverSmsBtn": "احصل على الرمز عبر SMS",
"mc2.recoverSmsDesc": "استلم رمز المطالبة الخاص بك عبر SMS إلى الرقم المسجل في حسابك.",
"mc2.recoverSmsFallback": "إذا كان هناك حساب بهذا الرقم، فقد تم إرسال رسالة SMS.",
"mc2.renewStayTop": ". جدد لتبقى في الصدارة واستعد غرضك.",
"mc2.resume20": "استئناف -20%",
"mc2.unlockContacts": "فتح تفاصيل الاتصال",
"mc2.unlockDesc": "ادفع رسوم معالجة Findloop لكشف تفاصيل الاتصال وترتيب التسليم.",
"mc2.viewsWord": "مشاهدات",
"mc2.live": "مباشر",
"mh.allCategories": "جميع الفئات",
"mh.allPeriod": "في كل الأوقات",
"mh.autoMatch": "تطابق تلقائي بالذكاء الاصطناعي",
"mh.blocked": "محظور (تناقض)",
"mh.blockedReason": "التطابق محظور: الكلمات الرئيسية الرئيسية للغرض والإعلان تتناقض مع بعضها.",
"mh.days30": "آخر 30 يومًا",
"mh.days7": "آخر 7 أيام",
"mh.days90": "آخر 90 يومًا",
"mh.emptyDesc": "سيظهر التطابقات الذكاء الاصطناعي هنا عند ورود الإعلانات.",
"mh.emptyTitle": "لا توجد أحداث",
"mh.exportCsv": "تصدير CSV",
"mh.exportDone": "تم تحميل تصدير CSV",
"mh.exportImpossible": "فشل التصدير",
"mh.fBlocked": "محظور",
"mh.fConfirmed": "مؤكد",
"mh.fRejected": "مرفوض",
"mh.objectLabel": "غرض:",
"mh.refresh": "تحديث",
"mh.rejected": "مرفوض",
"mh.srcManual": "يدوي",
"mh.srcText": "نص",
"mh.srcVisual": "بصري (صورة)",
"mh.subtitle": "سجل المطابقات المقترحة بواسطة الذكاء الاصطناعي — المطابقات التلقائية، المؤكدة والمرفوضة.",
"mh.title": "تاريخ الذكاء الاصطناعي",
"nf.desc": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
"nf.home": "العودة إلى الصفحة الرئيسية",
"nf.title": "الصفحة غير موجودة",
"par.allCities": "جميع المدن",
"par.cityPh": "مدينة",
"pay.eurNote": "المبالغ المعروضة باليورو (€).",
"pg.next": "التالي",
"pg.prev": "السابق",
"pg.showing": "{from}–{to} من {total}",
"pk.bodyCopy": "نص محتوى",
"pk.bodyText": "نص الجسد",
"pk.brandColors": "ألوان العلامة التجارية",
"pk.colorRed": "أحمر",
"pk.colorWhite": "أبيض",
"pk.darkBg": "خلفية داكنة",
"pk.download": "تحميل",
"pk.downloadZip": "تحميل المجموعة بالكامل (ZIP)",
"pk.headings": "العناوين",
"pk.heroDesc": "شعارات رسمية، لافتات وسائل التواصل الاجتماعي، ألوان وخطوط. اختر لغة الشعار والنسخة، ثم قم بتحميل الصورة أو المجموعة الكاملة.",
"pk.lightBg": "خلفية فاتحة (طباعة)",
"pk.logoWordmark": "شعار / علامة نصية",
"pk.logosVisuals": "شعارات ومرئيات",
"pk.mapCollect": "نقاط الخريطة / التجميع",
"pk.plain": "بسيط",
"pk.pressKit": "مجموعة الصحافة",
"pk.taglineLang": "لغة الشعار",
"pk.typography": "طباعة",
"pk.variant": "نسخة",
"pr2.adBoostMsg": "اختيار رائع! ستحسن فرصك في استرداد العنصر الخاص بك بسرعة.",
"pr2.boostActivated": "تم تفعيل التعزيز!",
"pr2.canRecoverNow": "يمكنك الآن استرداد العنصر الخاص بك.",
"pr2.continue": "استمر",
"pr2.downloadReceiptPdf": "تحميل الإيصال (PDF)",
"pr2.goToSpaceNow": "اذهب إلى حسابي الآن",
"pr2.partnerBoostMsg": "اختيار رائع! أن تكون أكثر وضوحًا يعني جذب زبائن جدد إلى منشأتك.",
"pr2.paymentSuccess": "تمت عملية الدفع بنجاح!",
"pr2.redirectingSpace": "يتم التحويل إلى حسابك…",
"pr2.subActivated": "تمت عملية الدفع بنجاح! اشتراكك نشط، يمكنك الآن إدارة منشآتك.",
"prev.allSites": "جميع المنشآت",
"pricing.annual": "سنوي",
"pricing.annualBadge": "-20% عرض",
"pricing.monthly": "شهري",
"pricing.perYear": "/سنة",
"pricing.saveLabel": "أنت توفر",
"pricing.savePerYear": "/سنة لكل منشأة إضافية",
"pub.accessGranted": "تم منح الوصول",
"pub.accessLimited2h": "الوصول محدود إلى ساعتين",
"pub.accountEmailConcerned": "البريد الإلكتروني للحساب المعني",
"pub.adAppearPublic": "هذه هي كيفية ظهور إعلانك للجمهور.",
"pub.adPreviewBtn": "معاينة الإعلان",
"pub.alertMeOnArrival": "أبلغني عند الوصول",
"pub.allActionsLogged": "تم تسجيل جميع الإجراءات",
"pub.allCategories": "جميع الفئات",
"pub.authorizeAccess": "تخويل الوصول",
"pub.authorizeSupportQ": "هل ترغب في تخويل وصول الدعم؟",
"pub.available": "متاح",
"pub.backHome": "العودة إلى الصفحة الرئيسية",
"pub.boostAdCta": "تعزيز إعلاني",
"pub.boostAdTitle": "عزز إعلانك",
"pub.boostCarouselSub": "انتقل إلى أعلى الصفحة في دوار “المعزز” وزد المشاهدات لاسترداد عنصرك بشكل أسرع.",
"pub.boostEstablishment": "عزز منشأتك",
"pub.boostEstablishmentDesc": "اظهر في أعلى الدليل مع شارة “معزز” واجذب مزيد من التقارير.",
"pub.boostFicheCta": "تعزيز قائمتي",
"pub.brandReady": "علامة Findloop التجارية، جاهزة للاستخدام",
"pub.cantFindItem": "لا يمكن العثور على العنصر الخاص بك؟",
"pub.cantProcessImage": "غير قادر على معالجة هذه الصورة",
"pub.claimQr": "استرداد رمز الاستجابة السريعة",
"pub.clickToZoom": "اضغط للتكبير",
"pub.codeAlreadyValidated": "تم التحقق من الكود — تم فتح جهات الاتصال.",
"pub.codeExample": "مثل ABCD2345",
"pub.confirmRenewal": "تأكيد التجديد",
"pub.contactIntro": "لديك سؤال، أو طلب؟ اكتب لنا، وسنرد عليك قريبًا.",
"pub.contactTypeDeceased": "حذف الحساب (شخص متوفى)",
"pub.contactTypeGeneral": "سؤال عام",
"pub.contactTypeSupport": "الدعم / مشكلة تقنية",
"pub.contactUs": "اتصل بنا",
"pub.continueWithoutEmail": "استمر دون ترك بريدي الإلكتروني",
"pub.contractLabel": "عقد",
"pub.contractNotFound": "لا يوجد عقد أو انتهت صلاحيته بالفعل.",
"pub.contractRenewed": "تم تجديد العقد!",
"pub.contractRenewedFor": "تم تجديد عقدك لمدة {n} أشهر.",
"pub.copyFailed": "فشل النسخ",
"pub.createPartnerAccount": "إنشاء حساب شريك",
"pub.currentDeadline": "الموعد النهائي الحالي",
"pub.deceasedInfo": "كأحد الأقارب أو الورثة، يمكنك طلب حذف حساب Findloop لشخص متوفى. سنعالج طلبك وفقًا لـ GDPR (قد يتم طلب مستندات داعمة).",
"pub.declareMyLoss": "أبلغ عن خسارتي",
"pub.describeItemPlaceholder": "صف غرضك (مثل: مظلة سوداء، مفاتيح…)",
"pub.downloadImage": "تحميل الصورة",
"pub.drawSignature": "يرجى رسم توقيعك.",
"pub.drawSignatureHint": "ارسم توقيعك باستخدام الفأرة أو الإصبع.",
"pub.duration": "مدة",
"pub.eSignature": "توقيع إلكتروني",
"pub.eSignatureDesc": "ادخل اسمك للتوقيع. سيتم تسجيل التاريخ تلقائيًا.",
"pub.edit": "تحرير",
"pub.editorialTitles": "عناوين تحريرية",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "أدخل الرمز الذي تم استلامه عبر البريد الإلكتروني لفتح تفاصيل الاتصال بالمالك.",
"pub.errorWord": "خطأ",
"pub.foundSelfService": "العناصر الموجودة · الخدمة الذاتية",
"pub.haveOwnerCode": "تلقيت رمزًا من المالك",
"pub.home": "الرئيسية",
"pub.immediateRenewal": "تجديد فوري، دون عرض جديد.",
"pub.impAdminReq1": "المسؤول",
"pub.impAdminReq2": "يطلب إذنًا للوصول مؤقتًا إلى حسابك",
"pub.impAdminReq3": "لمساعدتك.",
"pub.impGrantedDesc": "يمكن لفريق الدعم الوصول إلى حسابك لمدة أقصاها ساعتان. سيتم تسجيل كل إجراء. يمكنك إغلاق هذه الصفحة.",
"pub.invitedOnFindo": "لقد تم دعوتك للانضمام إلى Findloop",
"pub.isThisYourItem": "هل هذا غرضك؟",
"pub.itemsAvailableCount": "{n} عنصر(عناصر) متاحة حاليًا",
"pub.itemsFoundOwner": "من العناصر الموكلة التي وجدت مالكها",
"pub.itemsReturnedOwners": "العناصر التي تم إرجاعها لمالكيها",
"pub.itsMine": "إنه لي",
"pub.joinFindoDesc": "انضم إلى Findloop واد管理 items المفقودة بسهولة.",
"pub.joinInvitesYou": "يدعوك للانضمام إلى findloop. أنشئ حساب شريكك لإدارة العناصر التي وجدتها.",
"pub.linkCopied": "تم نسخ الرابط!",
"pub.loadingContract": "جارٍ تحميل العقد…",
"pub.lsClaimDesc": "أبلغ عن خسارتك لاستعادتها. اترك بريدك الإلكتروني وسنرسل لك تذكيرًا إذا لم يكتمل تقريرك.",
"pub.lsHeroDesc": "تحقق بنفسك مما إذا كان غرضك المفقود قد تم العثور عليه وترك هنا. هل وجدته؟ أبلغ عنه لاستعادته.",
"pub.lsSearchTitle": "ابحث عن العناصر الموجودة",
"pub.makeOffer": "قدم عرضًا",
"pub.makeOfferDesc": "اقترح المبلغ الخاص بك. سيقوم المشرف بمراجعته.",
"pub.mapNearYou": "العناصر والشركاء بالقرب منك",
"pub.mapWord": "خريطة",
"pub.messageSentToast": "تم إرسال الرسالة — سيرد فريقنا قريبًا.",
"pub.messageWord": "رسالة",
"pub.momoInitiated": "تم بدء دفع Mobile Money",
"pub.monthsWord": "أشهر",
"pub.nameConsentRequired": "الاسم والموافقة مطلوبة.",
"pub.newDeadline": "موعد نهائي جديد",
"pub.noActionRequired": "لا توجد إجراءات مطلوبة.",
"pub.noAmountCharged": "لم يتم فرض أي مبلغ.",
"pub.noItemMatch": "لا يوجد عنصر متاح يطابق بحثك في الوقت الحالي.",
"pub.noMatchingItem": "لا يوجد عنصر مطابق",
"pub.noPaymentSession": "لا جلسة دفع.",
"pub.noPhoto": "لا يوجد صورة",
"pub.noPointsYet": "لا توجد نقاط للعرض بعد.",
"pub.noSecondPayment": "لا يوجد دفعة ثانية مطلوبة لهذا العنصر.",
"pub.notHereYet": "لم يصل بعد؟ احصل على إشعار بمجرد وصوله.",
"pub.notifyDone": "تم ملاحظته! سنخطرك عبر البريد الإلكتروني بمجرد وصول عنصر مطابق.",
"pub.offerSubmitted": "تم تقديم عرضك.",
"pub.oops": "عذرًا",
"pub.orAlertEmail": "أو احصل على إشعار عبر البريد الإلكتروني بمجرد وصول عنصر مطابق:",
"pub.ownerContacts": "تفاصيل الاتصال بالمالك",
"pub.ownerContactsUnlocked": "تم فك قفل تفاصيل الاتصال بالمالك",
"pub.partnerContact": "جهة الاتصال بالشريك",
"pub.payLinkUnavailable": "رابط الدفع غير متوفر - اتصل بالشريك.",
"pub.paymentCancelled": "تم إلغاء الدفع",
"pub.paymentConfirmed": "تم تأكيد الدفع 🎉",
"pub.paymentConfirmedDesc": "ستتلقى بريدًا إلكترونيًا بالتفاصيل لاسترداد عنصرّك.",
"pub.paymentNotConfirmed": "لم يتم تأكيد الدفع",
"pub.paymentNotConfirmedDesc": "لم يتم التحقق من الدفع. حاول مرة أخرى أو اتصل بالشريك.",
"pub.paymentProcessing": "يتم معالجة الدفع. انتظر لحظة.",
"pub.photoAdded": "✓ تمت إضافة الصورة",
"pub.photoRequired": "تتطلب صورة للعنصر.",
"pub.previewAlt": "معاينة",
"pub.publish": "نشر",
"pub.publishingWord": "يتم النشر…",
"pub.qty": "الكمية",
"pub.quoteDeclined": "تم رفض السعر المقتبس.",
"pub.quoteNotFound": "السعر المقتبس غير موجود أو منتهي.",
"pub.reasonLabel": "السبب",
"pub.recoveryAlreadyPaid": "تم دفع رسوم الاسترداد بالفعل",
"pub.referralCode": "رمز الإحالة:",
"pub.relationshipPlaceholder": "ابن، زوج، موثق…",
"pub.renewYourContract": "قم بتجديد عقدك",
"pub.renewalFailed": "فشل التجديد. حاول مرة أخرى لاحقًا.",
"pub.renewing": "يتم التجديد…",
"pub.replySoon": "فريقنا سيرد بأسرع ما يمكن.",
"pub.requestGone": "هذه الطلبية لم تعد موجودة.",
"pub.requestHandled": "تم التعامل مع الطلب بالفعل",
"pub.requestNotFound": "الطلب غير موجود أو منتهي.",
"pub.requestUnavailable": "الطلب غير متوفر",
"pub.required": "(مطلوب)",
"pub.retroClosing": "معًا، نجعل العالم أقل ضياعًا قليلًا.",
"pub.retroClosing2": "معًا، نجعل العالم أقل ضياعًا قليلًا.",
"pub.retroScroll": "عام من استعادة ما يهم. قم بالتمرير لأسفل ↓",
"pub.revokeAnytime": "يمكنك إلغاءه في أي وقت بالاتصال بنا",
"pub.scene": "المشهد",
"pub.sendImpossible": "لا يمكن الإرسال",
"pub.sendMessage": "أرسل الرسالة",
"pub.sending": "يتم الإرسال…",
"pub.sharePreview": "شارك المعاينة",
"pub.shareYourAd": "شارك إعلانك",
"pub.signedSuccess": "تم التوقيع بنجاح!",
"pub.signerFullName": "الاسم الكامل للموّقع",
"pub.spreadNetwork": "شاركه مع من حولك لتعزيز فرصك.",
"pub.spreadOwner": "شاركه لمساعدة المالك على استعادة ممتلكاته.",
"pub.statusLabel": "الحالة:",
"pub.subject": "الموضوع",
"pub.thanksSent": "شكراً لك، تم إرسال رسالتك.",
"pub.thisYear": "هذا العام",
"pub.validate": "تحقق",
"pub.verifyingPayment": "جارٍ التحقق من الدفع…",
"pub.verifyingYourPayment": "جارٍ التحقق من دفعك…",
"pub.viewAd": "عرض الإعلان →",
"pub.viewPartner": "عرض الشريك →",
"pub.yourAdPreview": "معاينة إعلانك",
"pub.yourEmail": "بريدك الإلكتروني",
"pub.yourEmailRecommended": "بريدك الإلكتروني (مستحسن)",
"pub.yourEmailShort": "بريدك الإلكتروني",
"pub.yourName": "اسمك",
"pub.yourRelationship": "علاقتك بالشخص",
"qv.acceptAndSign": "قبول وتوقيع عرضي",
"qv.certifyAuthorized": "أقر بأنني مفوض بالتوقيع وأقبل شروط هذا {what} (قيمة ملزمة).",
"qv.clear": "مسح",
"qv.client": "العميل",
"qv.conditions": "الشروط",
"qv.confirmDecline": "تأكيد رفض هذا العرض؟",
"qv.countersignedFindo": "موقّعة من قبل Findloop · {name} في {date}",
"qv.decline": "رفض",
"qv.description": "الوصف",
"qv.downloadPdf": "تحميل ملف PDF",
"qv.handwrittenSignature": "توقيع بخط اليد",
"qv.inclTax": "شاملاً الضريبة",
"qv.invalidAmount": "مبلغ غير صالح.",
"qv.invoice": "الفاتورة",
"qv.invoicePaid": "تم دفع الفاتورة",
"qv.issuer": "المصدر",
"qv.messageOptional": "رسالة (اختياري)",
"qv.negotiatedAmount": "المبلغ المتفاوض عليه",
"qv.payInvoiceOnline": "دفع الفاتورة عبر الإنترنت",
"qv.quote": "عرض السعر",
"qv.quoteValidDays": "عرض السعر صالح لمدة {n} يومًا.",
"qv.sendMyOffer": "إرسال عرضي",
"qv.signContract": "توقيع عقدي",
"qv.signNow": "توقيع الآن",
"qv.signatureAlt": "التوقيع",
"qv.signedByOn": "✔ موقّع من قبل {name} في {date}",
"qv.stContractSigned": "تم توقيع العقد. شكرًا لك!",
"qv.stCounterAccepted": "تم قبول عرضك! قم بتوقيع عقدك أدناه.",
"qv.stCounterRefused": "لم يتم قبول عرضك.",
"qv.stCountered": "تم تقديم عرضك. في انتظار رد findloop.",
"qv.stDeclined": "لقد رفضت هذا العرض.",
"qv.stSigned": "تم قبول العرض وتوقيعه. شكرًا لك!",
"qv.totalHt": "الإجمالي بدون ضريبة",
"qv.totalTtc": "الإجمالي شامل الضريبة",
"qv.unitHt": "الوحدة بدون ضريبة",
"qv.vat": "ضريبة القيمة المضافة",
"qv.yourProposedAmount": "المبلغ المقترح من قبلك ({cur})",
"reg.add": "تسجيل عنصر",
"reg.allBrands": "جميع العلامات التجارية",
"reg.allColors": "جميع الألوان",
"reg.allLocations": "جميع المواقع",
"reg.detailDesc": "التفاصيل والإجراءات لهذا العنصر الموجود.",
"reg.dispAuction": "مزاد",
"reg.dispAuthorities": "تم تسليمه إلى السلطات",
"reg.dispDestroyed": "تم تدميره",
"reg.dispDonate": "تبرع خيري",
"reg.dispositionHint": "سجل العنصر الذي يغادر التخزين. يتم احتسابه في الإحصائيات حسب الفئة.",
"reg.emptyCta": "سجل عنصرًا",
"reg.emptyDesc": "ابدأ بتسجيل أول عنصر تم العثور عليه.",
"reg.emptyTitle": "لا توجد عناصر موجودة",
"reg.establishmentFallback": "المؤسسة",
"reg.lblAuctioned": "مدرج في المزاد",
"reg.lblAuctionedShort": "مزاد",
"reg.lblAuthorities": "تم تسليمه للسلطات",
"reg.lblDestroyed": "تم تدميره",
"reg.lblDonated": "تم التبرع به لجمعية خيرية",
"reg.legalCount": "{n} عنصر(عناصر): تم الوصول إلى فترة الاحتفاظ القانونية",
"reg.legalHint": "يمكنك إدراجها في المزاد، أو التبرع بها لجمعية خيرية، أو الإبلاغ عن تسليمها للسلطات.",
"reg.legalLimitCountry": "الموعد النهائي: {date} · الدولة المعنية: {country}",
"reg.legalOver": "الموعد النهائي مضى عليه: {date} · {country}",
"reg.legalReached": "تم الوصول إلى الفترة القانونية",
"reg.legalReachedFull": "تم الوصول إلى فترة الاحتفاظ القانونية",
"reg.limitShort": "الموعد النهائي",
"reg.location": "الموقع",
"reg.markRestituted": "علامة على أنها عادت",
"reg.markedAs": "تمت الإشارة إلى العنصر كـ {label}",
"reg.moveHistory": "تاريخ الحركة",
"reg.overBy": "أكثر من {n} يوم",
"reg.physicalLocation": "الموقع الفيزيائي",
"reg.popupBlocked": "اسمح بالنوافذ المنبثقة لطباعة الملصقات.",
"reg.popupBlockedOne": "اسمح بالنوافذ المنبثقة لطباعة الملصق.",
"reg.printLabel": "طباعة الملصق",
"reg.printN": "طباعة {n} ملصق(ملصقات)",
"reg.qrCodeItem": "رمز QR للعنصر",
"reg.qrLabelTitle": "ملصق QR",
"reg.qrLabelsTitle": "ملصقات QR",
"reg.qrNotFound": "لم يتم العثور على عنصر لهذا الرمز الشريطي.",
"reg.qrScanHint": "قم بمسحه لفتح هذا السجل مباشرة والعثور على الموقع.",
"reg.recoveryFee": "رسوم الاسترداد (€)",
"reg.searchPh": "ابحث عن وصف…",
"reg.selectQr": "اختر لطباعة ملصقات QR",
"reg.selectedN": "{n} محدد",
"reg.shipPricePh": "سعر الشحن (€)",
"reg.shippingPossible": "الشحن متاح",
"reg.storagePh": "مثل: الرف A3، القفل 12",
"reg.tAuction": "مزاد على Findloop",
"reg.tAuthorities": "الإبلاغ عن التسليم للسلطات",
"reg.tDonate": "تبرع لجمعية خيرية",
"reg.toastFee": "تم تحديث الرسوم",
"reg.toastLocation": "تم حفظ الموقع",
"reg.toastRestituted": "تمت الإشارة إلى العنصر كـ عائد",
"reg.toastShipping": "تم تحديث خيار الشحن",
"reg.toastTransferred": "تم نقل العنصر إلى “{name}”",
"reg.unclaimedDisposition": "عنصر غير مطالب به — التصرف النهائي",
"res.codeValidated": "تم التحقق من الرمز",
"res.empty": "لم يتم تسجيل أي استرداد بعد.",
"res.error": "خطأ {status}",
"res.proofPdf": "إثبات PDF",
"res.signed": "موقع",
"res.stRestituted": "تم تسليمه شخصيًا",
"res.stShipped": "تمت إعادته عن طريق الشحن",
"res.subtitle": "جميع التسليمات المكتملة، مع إثباتات موقعة قابلة للتنزيل.",
"res.title": "تاريخ الاسترداد",
"rev.restitutedBy": "تمت إعادته بواسطة {org}",
"rev.storiesEyebrow": "نهايات سعيدة",
"rev.storiesSubtitle": "قصص واقعية من عملاء استعادوا ممتلكاتهم مع findloop.",
"rev.storiesTitle": "لقد وجدوا ممتلكاتهم!",
"rp.already": "لقد قمت بالفعل بالإبلاغ عن هذا الإعلان.",
"rp.duplicate": "مكرر",
"rp.inappropriate": "محتوى غير مناسب",
"rp.wrongCategory": "فئة خاطئة",
"rt.annualGoal": "الهدف السنوي",
"rt.championCity": "مدينة الأبطال",
"rt.cityRate": "نسبة استعادة {rate}%",
"rt.goalProgress": "{rate}% تم تحقيقه من هدف {target}%",
"rt.reached": "تم الوصول إليه 🎉",
"rt.restitutionRate": "نسبة الاسترداد",
"rt.shareRecap": "شارك ملخصي",
"rt.thanks": "شكرًا لك Findloop {year} 💛",
"rt.yourRecap": "ملخصك لعام {year}",
"rw.active": "نشط",
"rw.add": "إضافة",
"rw.camUnavailable": "الكاميرا غير متاحة. أدخل الرمز يدويًا أدناه.",
"rw.codeValidated": "تم التحقق من الرمز",
"rw.codesTitle": "الرموز التي استردها عمالقة Findloop",
"rw.confirmDelete": "هل تريد حذف “{title}”?",
"rw.deleted": "تم الحذف",
"rw.edit": "تعديل",
"rw.editReward": "تعديل المكافأة",
"rw.empty": "لا توجد مكافأة بعد.",
"rw.expired": "منتهية",
"rw.expiresOn": "تنتهي في {date}",
"rw.fActive": "نشط (مرئي للعمالقة)",
"rw.fCost": "التكلفة (نقاط)",
"rw.fDesc": "الوصف",
"rw.fStock": "المخزون (فارغ = غير محدود)",
"rw.fTitle": "العنوان",
"rw.fValidity": "صلاحية القسيمة (أيام بعد الاسترداد)",
"rw.inactive": "غير نشط",
"rw.newReward": "مكافأة جديدة",
"rw.noExchange": "لا توجد استردادات بعد.",
"rw.pageSubtitle": "امسح القسائم المقدمة من قبل العمالقة للتحقق من مكافآتهم.",
"rw.redeemedN": "تم استرداد: {n}×",
"rw.saved": "تم حفظ المكافأة",
"rw.scanVoucher": "امسح قسيمة",
"rw.staffScanOnly": "امسح فقط",
"rw.statActive": "للعرض",
"rw.statExpired": "منتهية",
"rw.statRedeemed": "القسائم المستردة",
"rw.statUsed": "موثقة",
"rw.stock": "المخزون",
"rw.subtitle": "قدم مزايا غير نقدية (قسائم، ترقيات…) يقوم العمالقة باستردادها لنقاط Finder Score الخاصة بهم.",
"rw.title": "المكافآت للعمالقة",
"rw.used": "مستخدم",
"rw.validate": "تحقق",
"rw.validateCode": "تحقق من الرمز",
"rw.validity": "الصلاحية: {n} يوم",
"side.establishments": "المؤسسات",
"side.restitutions": "المرتجعات",
"side.rewards": "المكافآت والقسائم",
"side.settings": "الإعدادات",
"side.storage": "التخزين والرمز السريع",
"status.auctioned": "مزاد",
"status.destroyed": "مدمر",
"status.donated": "م donated (خيرية)",
"status.handed_to_authorities": "تم تسليمه للسلطات",
"status.in_storage": "في التخزين",
"status.matched": "مطابقة",
"status.open": "فتح",
"status.paid": "مدفوع",
"status.pending": "قيد الانتظار",
"status.restituted": "تم إعادته",
"status.shipped": "شُحن",
"status.shipping_requested": "تم طلب الشحن",
"status.submitted": "تم تقديمه",
"stg.allLabels": "جميع ملصقات QR",
"stg.camHint": "استخدم الإدخال اليدوي أدناه.",
"stg.camStarting": "بدء الكاميرا…",
"stg.camUnavailable": "الكاميرا غير متاحة.",
"stg.clear": "مسح",
"stg.clearAll": "مسح الكل",
"stg.codeUnreadable": "رمز غير قابل للقراءة.",
"stg.emptyDesc": "ستظهر العناصر المخزنة هنا، مجمعة حسب الموقع.",
"stg.emptyTitle": "لا توجد عناصر في التخزين",
"stg.exportAudit": "تصدير مراجعة CSV",
"stg.exportDone": "تم تنزيل تصدير CSV",
"stg.exportImpossible": "التصدير غير متاح في الوقت الحالي.",
"stg.itemFound": "تم العثور على العنصر ✅",
"stg.kLocations": "المواقع المستخدمة",
"stg.kObjects": "العناصر المخزنة",
"stg.kToClear": "المواقع المراد مسحها",
"stg.locFreed": "تم مسح الموقع",
"stg.locsFreed": "تم مسح {n} موقع(مواقع)",
"stg.manualLabel": "أو أدخل رمز العنصر / الهوية",
"stg.manualPh": "الصق هوية QR أو URL",
"stg.noItemMatch": "لا يوجد عنصر يطابق هذا QR / الرمز.",
"stg.noLocation": "لا يوجد موقع",
"stg.objectsAxis": "عناصر",
"stg.objectsN": "{n} عنصر(عناصر)",
"stg.occAvg": "متوسط {n} عناصر/موقع",
"stg.occHint": "المواقع باللون البرتقالي تتجاوز المتوسط (قد تكون محملة زائداً).",
"stg.occupancy": "شغل الموقع",
"stg.openPage": "افتح الصفحة",
"stg.posterPdf": "ملصق PDF (A4)",
"stg.printAll": "طباعة الكل",
"stg.printGroupTitle": "طباعة الملصقات لهذا الرف",
"stg.qrAlt": "QR الخدمة الذاتية",
"stg.qrDownload": "تحميل QR",
"stg.qrHint": "اعرض هذا QR عند الكاونتر: يمكن لعملائك مسحه للتحقق مما إذا كانت عناصرهم متاحة.",
"stg.qrTitle": "QR الخدمة الذاتية للعملاء",
"stg.scanDesc": "امسح ملصق أحد العناصر لفتح سجله على الفور.",
"stg.scanQr": "امسح QR",
"stg.scanTitle": "امسح رمز QR",
"stg.search": "بحث",
"stg.shelf": "الرف {loc}",
"stg.shelfPlan": "خطة الرف",
"stg.staleHint": "قم بمسح هذه المواقع للحفاظ على تحديث مخزونك الفعلي.",
"stg.staleTitle": "{n} عنصر(عناصر) خرجت من التخزين لكنها لا تزال تحتفظ بموقع",
"stg.subtitle": "خطة الرف، ماسح QR وتتبع المخزون الفعلي.",
"stg.title": "التخزين و QR",
"stt.acceptRate": "معدل القبول",
"stt.accepted": "مقبول",
"stt.activity30": "النشاط (آخر 30 يوم)",
"stt.ai6mo": "آخر 6 أشهر · المقبول = مُطابق تلقائياً + مؤكد.",
"stt.aiEmpty": "لا توجد مطابقة AI خلال هذه الفترة بعد.",
"stt.aiTitle": "مطابقات الذكاء الاصطناعي — المقبولة مقابل المرفوضة",
"stt.auctionShort": "مزاد",
"stt.auctionedSold": "تم المزاد (مباع)",
"stt.authShort": "السلطات",
"stt.authorities": "تم تسليمها للسلطات",
"stt.avgRating": "معدل التقييم المتوسط",
"stt.awaitingRestitution": "أصناف بانتظار الإرجاع",
"stt.boostClicks": "النقرات على أدلتك هذا الأسبوع بفضل التعزيز",
"stt.boostInactive": "التعزيز غير مفعل — قم بتفعيله لزيادة الظهور",
"stt.certifiedPremium": "مؤهل ممتاز",
"stt.declarations": "التصريحات",
"stt.destroyed": "مدمر",
"stt.dispoEmpty": "لا توجد عناصر غير مدعى بها خرجت من التخزين بعد.",
"stt.donatedAssoc": "تم التبرع به (جمعية خيرية)",
"stt.donatedShort": "تبرع",
"stt.gateCta": "استكشف الخطط",
"stt.gateDesc": "قم بالترقية إلى Starter لفتح إحصائياتك الأساسية، أو إلى Business للحصول على إحصائيات متقدمة وتحليل لكل مؤسسة.",
"stt.gateTitle": "إحصائيات محجوزة للخطط المدفوعة",
"stt.inStorage": "في التخزين",
"stt.kItems": "العناصر المسجلة",
"stt.kRate": "معدل الإرجاع",
"stt.kRestituted": "العناصر المرتجعة",
"stt.kRevenue": "الإيرادات (شهر)",
"stt.noDeclYet": "لا توجد تصريحات بعد.",
"stt.recapDownloaded": "تم تنزيل الملخص — جاهز للمشاركة!",
"stt.recapError": "غير قادر على إنشاء الملخص",
"stt.recapText": "ملخص Findloop {year}: العناصر المرتجعة ورضا العملاء 🎉",
"stt.recapTitle": "ملخص Findloop {year}",
"stt.rejected": "مرفوض",
"stt.restitutions": "الإرجاعات",
"stt.shareRecap": "شارك ملخصي لعام {year}",
"stt.topCategories": "أكثر الفئات المعلنة",
"stt.unclaimedDesc": "حجم العناصر المدمرة، المتبرع بها للجمعيات الخيرية والمزودة، حسب الفئة.",
"stt.unclaimedTitle": "عناصر غير مدعى بها — تخرج من التخزين",
"stt.vsLastWeek": "مقارنة بالأسبوع الماضي",
"sub.cancel": "إلغاء اشتراكي",
"sub.cancelAbort": "إلغاء",
"sub.cancelConfirm1": "هل أنت متأكد أنك تريد الإلغاء؟ يبقى الوصول الخاص بك نشطًا حتى",
"sub.cancelConfirm2": "لن يتم إصدار أي استرداد.",
"sub.cancelConfirmBtn": "تأكيد الإلغاء",
"sub.cancelTitle": "إلغاء اشتراكك",
"sub.cancelledToast": "تم تسجيل الإلغاء.",
"sub.cguAnd": "و",
"sub.cguDesc": "يرجى تأكيد موافقتك قبل الدفع.",
"sub.cguLink": "شروط الاستخدام",
"sub.cguPay": "تابع إلى الدفع",
"sub.cguPre": "لقد قرأت وأوافق على",
"sub.cguRequired": "يجب عليك قبول شروط الاستخدام وسياسة الخصوصية للمتابعة.",
"sub.cguSuffix": "لـ Findloop.",
"sub.cguTitle": "إتمام اشتراكك",
"sub.expiresOn": "ينتهي اشتراكك في",
"sub.noProrata": "لا استرداد مبدئي.",
"sub.privacyLink": "سياسة الخصوصية",
"sub.renewsOn": "يتم تجديد اشتراكك في",
"sub.resume": "إعادة الاشتراك",
"sub.resumedToast": "تم تأكيد إعادة الاشتراك.",
"tier.free": "مجاني",
"tier.large": "مؤسسة",
"tier.medium": "أعمال",
"tier.small": "مبتدئ",
"tm.add": "إضافة",
"tm.adminOpt": "مدير (عرض كامل)",
"tm.chooseEst": "اختر مؤسسة",
"tm.chooseEstPh": "اختر مؤسسة",
"tm.copyFail": "فشل النسخ",
"tm.copyLink": "نسخ الرابط",
"tm.copyOk": "تم نسخ رابط الدعوة",
"tm.emailHint": "سيتم إرسال بريد دعوة لإنشاء كلمة المرور.",
"tm.expiresOn": "ينتهي في {date}",
"tm.forEmail": " لـ {email}",
"tm.forbidden": "إدارة الفريق مخصصة لمالك الحساب.",
"tm.inviteCreated": "تم إنشاء الدعوة",
"tm.inviteDesc": "يمكن لعضو الفريق إنشاء كلمة مروره عبر بريد الدعوة.",
"tm.invitePending": "دعوة معلقة",
"tm.inviteResent": "تم إعادة إرسال الدعوة",
"tm.inviteSent": "تم إرسال الدعوة عبر البريد الإلكتروني",
"tm.inviteTitle": "دعوة عضو",
"tm.invitedOn": "تمت الدعوة في {date}",
"tm.linkExpired": "الرابط منتهي",
"tm.memberRemoved": "تمت إزالة العضو",
"tm.name": "الاسم",
"tm.noMembers": "لا يوجد أعضاء بعد.",
"tm.resendTitle": "إعادة إرسال الدعوة",
"tm.role": "الدور",
"tm.roleAdmin": "مدير",
"tm.roleOwner": "مالك",
"tm.roleStaff": "موظف",
"tm.roleUpdated": "تم تحديث الدور",
"tm.sendInvite": "إرسال الدعوة",
"tm.sending": "جاري الإرسال…",
"tm.staffOpt": "موظف (يرى مؤسسته فقط)",
"trk.carrier": "شركة الشحن",
"trk.shipPending": "الشحنة قيد التحضير — سيتم عرض رقم التتبع هنا بمجرد شحنها.",
"trk.shipTitle": "تتبع الشحنة",
"trk.trackShipment": "تتبع الطرد",
"trk.trackingNo": "رقم التتبع",
"a.firstName": "الاسم الأول",
"ac.emailCrossMatch": "مطابقات B2C",
"ac.emailCrossMatchDesc": "البريد الإلكتروني عند مطابقة إعلان مفقود عام مع عنصر تم إيداعه في منشأتك",
"ac.emailCrossReject": "رفض المطابقات العامة",
"ac.emailCrossRejectDesc": "استقبل بريدًا إلكترونيًا عندما يشير عميل إلى أن المطابقة المقترحة العامة ليست عنصره.",
"ac.emailLoginNotif": "إشعار تسجيل الدخول",
"ac.emailLoginNotifDesc": "استقبل بريدًا إلكترونيًا في كل مرة يقوم فيها شخص ما بتسجيل الدخول إلى حسابك.",
"ad.closeNoCancel": "لا، أزل القائمة",
"ad.closeQuestion": "هل تم استرجاع العنصر إليك؟",
"ad.closeQuestionDesc": "دعنا نعرف ما إذا كنت قد استعدت عنصرًا ما، أو إذا كنت تريد ببساطة إزالة هذه القائمة.",
"ad.closeYesRestituted": "نعم، تم استرجاع العنصر",
"ad.closedRestituted": "تم استرجاع العنصر — القائمة مغلقة 🎉",
"an.lostLoginDesc": "مطلوب حساب للإبلاغ عن عنصر مفقود ومتابعة استرجاعه.",
"an.lostLoginRequired": "تسجيل الدخول للإبلاغ عن عنصر مفقود",
"an.qfAll": "الكل",
"an.qfBoosted": "مدعوم",
"an.qfPhoto": "مع صورة",
"an.qfRecent": "هذا الأسبوع",
"an.qfResolved": "تم الحل",
"an.restitutionInProgress": "العنصر يتم استرجاعه",
"dec.descPhLong": "صف العنصر: العلامة التجارية، اللون، العلامات المميزة… (كلما زادت التفاصيل التي تقدمها، زادت فرصك في استعادة عنصر لك)",
"dec.loadError": "تعذر تحميل الشريك الآن. تحقق من اتصالك وحاول مرة أخرى.",
"dec.retry": "أعد المحاولة",
"dec.shippingMode": "الشحن",
"dep.photo2": "صورة العنصر الثانية",
"dep.photo2Hint": "اختياري — زاوية أخرى تحسن من دقة المطابقة البصرية.",
"dl.accountSuspended": "الحساب مُعلق لفاتورة غير مدفوعة. قم بتسويتها لاستعادة الوصول.",
"dl.regularize": "قم بالتسوية الآن →",
"dl.suspensionCountdown": "الفاتورة {num} غير مدفوعة — سيتم تعليق حسابك خلال {days} يوم(أيام). قم بتسويتها لتجنب ذلك.",
"ft.cancelConfirm": "إلغاء تقريرك؟ سيتم إبلاغ مالك العنصر.",
"ft.cancelDone": "تم إلغاء التقرير.",
"ft.cancelLocked": "لم يعد ممكنًا الإلغاء بعد أن قام المالك بالدفع.",
"ft.cancelReport": "إلغاء تقريره",
"ft.claimCodeHelp": "قم بإعطاء هذا الرمز للعثور عند التسليم لتأكيد أنك استلمت عنصرك.",
"ft.claimCodeTitle": "رمز استردادك",
"ft.claimDone": "تم استرجاع العنصر. شكرًا لاستخدامك Findloop!",
"ft.claimUnlockHint": "افتح تفاصيل اتصال المُكتشف",
"ft.claimUnlockHintSub": "اذهب إلى \"العناصر التي أطالب بها\" في حسابك لدفع الرسوم والحصول على تفاصيل الاتصال.",
"ft.finderCodeShownHelp": "قد دفع المالك واختارك. انسخ هذا الرمز أدناه لتأكيد الاسترجاع — لا حاجة للتحقق من بريدك الإلكتروني.",
"ft.finderCodeShownTitle": "رمز التحقق من المالك",
"ft.finderContactsTitle": "تفاصيل الاتصال بـ Finder",
"ft.foundCodeHelp": "أظهر هذا الرمز للمالِك عند التسليم لتأكيد عودة العنصر.",
"ft.inProgressOther": "العنصر قيد العودة",
"ft.inProgressOtherHelp": "المالِك اختار مُكتشفًا آخر لهذا العنصر. لا حاجة لأي إجراء إضافي من جانبك.",
"ft.restitutionCodeHelp": "هذا الرمز يؤكد تسليم العنصر. تم ملؤه مسبقًا أدناه؛ تحقق منه ثم اغلق القضية.",
"ft.restitutionCodeTitle": "رمز الاسترداد الخاص بك",
"hc.14Digits": "14 رقم",
"hc.15DaysBeforeAnItem": "15 يومًا قبل الموعد النهائي القانوني للعنصر.",
"hc.7DaysBeforeAnItem": "7 أيام قبل الموعد النهائي القانوني للعنصر.",
"hc.8CharactersMinimum": "8 أحرف على الأقل.",
"hc.aClaimToValidate": "دعوى للتحقق",
"hc.aFindoAssistanceSessionIs": "توجد جلسة مساعدة من Findloop نشطة حاليًا على حسابك.",
"hc.aNewMatchHasBeen": "تم العثور على تطابق جديد",
"hc.aUser": "مستخدم",
"hc.aUserClaimsToBe": "مستخدم يدعي أنه المالِك. تحقق من أجوبتهم قبل السماح بالتسليم.",
"hc.aboutFindo": "حول Findloop",
"hc.accountActivatedPleaseLogIn": "تم تفعيل الحساب، يرجى تسجيل الدخول.",
"hc.accountActivation": "تفعيل الحساب",
"hc.accountCreated": "تم إنشاء الحساب!",
"hc.accountDeactivatedAReactivationEmail": "تم إلغاء تنشيط الحساب. تم إرسال بريد إلكتروني لإعادة التنشيط (صالح لمدة 30 يومًا) إليك.",
"hc.accountReactivation": "إعادة تنشيط الحساب",
"hc.activateMyAccount": "تنشيط حسابي",
"hc.activateMyAdminAccount": "تنشيط حساب المسؤول الخاص بي",
"hc.activating": "جارٍ التنشيط…",
"hc.activeMatchCancelReason": "تطابق نشط. سبب إلغاء العميل: \"{reason}\". العنصر لا يزال ينتظر الادعاء.",
"hc.activeMatchWithAPublic": "تطابق نشط مع إعلان عام (عميل). في انتظار ادعاء المالِك.",
"hc.addAPhoto": "إضافة صورة",
"hc.addAndConfigureYourEstablishments": "إضافة وضبط مؤسساتك في \"المؤسسات\": تفاصيل الاتصال، الفئة والتخزين الفعلي للعناصر.",
"hc.addOnGoogle": "إضافة على جوجل",
"hc.address": "العنوان",
"hc.addressSaved": "تم حفظ العنوان",
"hc.addressStreet": "العنوان - الشارع",
"hc.adjustThePhoto": "ضبط الصورة",
"hc.adminFullView": "المسؤول (عرض كامل)",
"hc.administratorOnly": "مسؤول فقط",
"hc.africa": "أفريقيا",
"hc.aiVisualComparison": "المقارنة البصرية بالذكاء الاصطناعي",
"hc.all": "الكل",
"hc.amount": "المبلغ",
"hc.anOrganization": "منظمة",
"hc.analyzing": "جارٍ التحليل…",
"hc.andRecoveryIs": "واسترداد هو",
"hc.andTheDeclarationWillBe": "وسيتم إغلاق الإقرار (تم نقله إلى التاريخ). هذا الإجراء نهائي.",
"hc.annual20": "سنوي -20%",
"hc.annualBilling20": "الفوترة السنوية (−20%)",
"hc.annualTarget": "الهدف السنوي",
"hc.anyCommentsOptional": "أي تعليقات؟ (اختياري)",
"hc.approveTheClaim": "الموافقة على المطالبة",
"hc.archiveCancelledConfirm": "أرشفة {n} قائمة \"ملغاة من قبل العميل\"؟ سيتم إزالتها من السجل.",
"hc.asSoonAs": "بمجرد",
"hc.askTheOwnerToDisplay": "اطلب من المالك عرض رمز الاستجابة السريعة الخاص بهم (صفحة التتبع).",
"hc.askThemAtTheCounter": "اطلب منهم عند العداد لتأكيد الهوية — لا تظهر علنًا أبدًا.",
"hc.assistance": "الدعم",
"hc.assistanceSessionRevoked": "تم إلغاء جلسة الدعم.",
"hc.atLeast6Characters": "يجب أن تكون 6 أحرف على الأقل",
"hc.automaticallyPreSelected": "محدد مسبقًا تلقائيًا",
"hc.automaticallyWhenShipping": "محدد تلقائيًا عند الشحن.",
"hc.awaitingClaim": "في انتظار المطالبة",
"hc.awaitingPayment": "في انتظار الدفع",
"hc.b2cCustomer": "عميل B2C",
"hc.back": "رجوع",
"hc.backToHome": "العودة إلى الصفحة الرئيسية",
"hc.backToMyAccount": "العودة إلى حسابي",
"hc.backToPayment": "العودة إلى الدفع",
"hc.beforeAfterComparisonSlider": "شريط مقارنة قبل/بعد",
"hc.billingInformation": "معلومات الفوترة",
"hc.billingInformationSaved": "تم حفظ معلومات الفوترة ✓",
"hc.brand": "الماركة",
"hc.bronze": "برونزي",
"hc.calculatingTheShippingRate": "جارٍ حساب تكلفة الشحن…",
"hc.cameraUnavailableEnterTheCode": "الكاميرا غير متاحة. أدخل الرمز يدويًا.",
"hc.cancel": "إلغاء",
"hc.cancelMyDeclaration": "إلغاء الإقرار الخاص بي",
"hc.cancelSavedFmt": "تم تسجيل الإلغاء: \"{reason}\". يمكنك المطالبة مرة أخرى.",
"hc.cancelTheDeposit": "إلغاء الوديعة",
"hc.cancelThisMatch": "إلغاء هذه المطابقة",
"hc.cancellationReason": "سبب الإلغاء",
"hc.cancelled": "ملغى",
"hc.cancelledByTheCustomer": "ملغاة من قبل العميل",
"hc.cannotOpenPayment": "تعذر فتح الدفع. يرجى المحاولة مرة أخرى.",
"hc.careers": "وظائف",
"hc.carrier": "شركة الشحن",
"hc.carrierAvailabilityCannotBeChecked": "لا يمكن التحقق من توفر شركة الشحن حتى يتم إعداد مرسل Sendcloud الخاص بك.",
"hc.carrierConfirmedCharged": "تم تأكيد شركة الشحن - {price} € تم خصمها من العميل",
"hc.carrierOther": "شركة الشحن (أخرى)",
"hc.carrierSelection": "اختيار شركة الشحن",
"hc.caseClosedThankYou": "تم إغلاق الحالة. شكرًا لك!",
"hc.category": "فئة",
"hc.changeMethod": "تغيير الطريقة",
"hc.characteristic": "سمة",
"hc.chargedToCustomer": "تم خصمه من العميل.",
"hc.checkOrEditYourDetails": "تحقق أو عدل تفاصيلك قبل الدفع الآمن.",
"hc.checkStatisticsToTrackDeposited": "تحقق من \"الإحصائيات\" لتتبع العناصر المودعة، معدل الإرجاع وأداء كل منشأة.",
"hc.checkTheDetailsBeforeContacting": "تحقق من التفاصيل قبل الاتصال بالباحث.",
"hc.checkTheDetailsBelowBefore": "تحقق من التفاصيل أدناه قبل بدء طلب الإرجاع.",
"hc.checkTheNewItem": "تحقق من العنصر الجديد",
"hc.checkThePhotosAndCharacteristics": "تحقق من الصور والخصائص أدناه قبل متابعة الاسترجاع.",
"hc.chooseACountry": "اختيار دولة",
"hc.chooseANewPassword": "اختر كلمة مرور جديدة",
"hc.chooseAReason": "اختر سببًا",
"hc.chooseTheLegalRetentionAlerts": "اختر تنبيهات الاحتفاظ القانونية المستلمة عبر البريد الإلكتروني لـ",
"hc.chooseYourPasswordToAccess": "اختر كلمة المرور الخاصة بك للوصول إلى وحدة الإدارة.",
"hc.city": "مدينة",
"hc.claimApproved": "تمت الموافقة على المطالبة",
"hc.claimApproved2": "تمت الموافقة على المطالبة.",
"hc.claimCodeExpired": "انتهت صلاحية رمز المطالبة",
"hc.claimCodeVerified": "تم التحقق من رمز المطالبة",
"hc.claimNotFound": "المطالبة غير موجودة",
"hc.claimNotValidated": "المطالبة غير مفعلّة",
"hc.claimRejected": "تم رفض المطالبة",
"hc.claimRejected2": "تم رفض المطالبة.",
"hc.claimValidated": "تمت الموافقة على المطالبة",
"hc.claimValidatedByThePartner": "تمت الموافقة على المطالبة من قبل الشريك",
"hc.claimant": "المطالب",
"hc.claimsToBeTheOwner": "يدعي أنه مالك هذا العنصر وأجاب على أسئلة التحقق. فقط وافق إذا كانت الإجابات متطابقة.",
"hc.claimsToValidate": "مطالبات للتأكيد",
"hc.clear": "مسح",
"hc.clickToZoom": "انقر للتكبير",
"hc.close": "إغلاق",
"hc.close2": "إغلاق",
"hc.closeTheDeclaration": "اغلاق الإشعار",
"hc.closeTheDeclaration2": "هل تريد اغلاق الإشعار؟",
"hc.codeAlreadyVerified": "تم التحقق من الكود مسبقاً",
"hc.codeCopied": "تم نسخ الكود",
"hc.collapse": "طي",
"hc.color": "لون",
"hc.company": "شركة",
"hc.companyName": "اسم الشركة",
"hc.comparePhotos": "قارن الصور",
"hc.compareThemWithTheOwner": "قارنها بإجابات المالك - لن تكون مرئية علنًا.",
"hc.condition": "الحالة",
"hc.confirmAndPay": "تأكيد والدفع",
"hc.confirmCancellation": "تأكيد الإلغاء",
"hc.confirmCrop": "تأكيد القص",
"hc.confirmDeletion": "تأكيد الحذف",
"hc.confirmPassword": "تأكيد كلمة المرور",
"hc.confirmThatThisIsYour": "تأكيد أن هذه هي كما تنتمي لك. سيتم طلب تحقق الهوية من المُكتشف قبل أي اتصال.",
"hc.confirmTheCarrier": "تأكيد الشاحن",
"hc.confirmThePassword": "تأكيد كلمة المرور",
"hc.confirmYourShippingAddressTo": "تأكيد عنوان الشحن الخاص بك للمتابعة مع الدفع.",
"hc.confirmYourSubscription": "تأكيد اشتراكك",
"hc.confirmed": "تم التأكيد ✓",
"hc.contactFindoToGetYour": "اتصل بـ Findloop للحصول على رقم الهوية المرسل الخاصة بك.",
"hc.contactUs": "اتصل بنا",
"hc.continueTheReturn": "تابع الإرجاع",
"hc.continueToPayment": "الاستمرار إلى الدفع",
"hc.copy": "نسخ",
"hc.correctMyDetails": "تصحيح تفاصيلي",
"hc.correctThisEntry": "تصحيح هذا الإدخال؟",
"hc.country": "الدولة",
"hc.countryAddress": "الدولة (العنوان)",
"hc.countryIsoCodeEG": "الدولة (رمز ISO، مثل FR)",
"hc.cover": "غطاء",
"hc.createTheShipment": "إنشاء الشحنة",
"hc.cropThePhoto": "قص الصورة",
"hc.customer": "العميل",
"hc.customerClaimCodeToCheck": "كود مطالبة العميل - للتحقق عند الاستلام:",
"hc.customerReasonFmt": "سبب العميل: \"{reason}\".",
"hc.customerReminderDelay": "تأخير تذكير العميل",
"hc.customerWhosePublicListingMatches": "العميل الذي يتطابق إدراجه العام مع هذا العنصر - مرئي فقط لك.",
"hc.d15": "D-15",
"hc.dangerZone": "منطقة الخطر",
"hc.date": "التاريخ",
"hc.dateNewest": "التاريخ (الأحدث)",
"hc.dateOldest": "التاريخ (الأقدم)",
"hc.daysToYearEnd": "{n} يوم حتى نهاية السنة",
"hc.deadlineAlert": "تنبيه الموعد النهائي",
"hc.declarationClosed": "الإعلان مغلق ✓",
"hc.declarationNotFound": "لم يتم العثور على الإعلان.",
"hc.declarationNotFound2": "لم يتم العثور على الإعلان",
"hc.declarationTracking": "تتبع الإعلان",
"hc.defaultCarrier": "الناقل الافتراضي",
"hc.defaultCarrierPreselected": "الناقل الافتراضي محدد مسبقًا — يمكن تغييره لهذه الشحنة. السعر الفعلي (Sendcloud + {m}% هامش).",
"hc.defaultCarrierRemoved": "تمت إزالة الناقل الافتراضي",
"hc.delayHours": "التأخير (ساعات)",
"hc.deleteMyAccount": "حذف حسابي",
"hc.deleting": "جارٍ الحذف…",
"hc.deletingDeactivatesYourAccountLogin": "الحذف يؤدي إلى تعطيل تسجيل دخول حسابك: تم حظر تسجيل الدخول وستبقى البيانات محفوظة لمدة 30 يومًا. ستحصل على بريد إلكتروني برابط لإعادة التفعيل صالح لمدة 30 يومًا.",
"hc.delivered": "تم التوصيل",
"hc.depositAnItem": "إيداع عنصر",
"hc.depositCancelledItemPutBack": "تم إلغاء الإيداع — العنصر أعيد إلى المخزون.",
"hc.depositCancelledItemRemovedFrom": "تم إلغاء الإيداع — العنصر تمت إزالته من السجل.",
"hc.depositedOn": "تم الإيداع في",
"hc.describeTheItemBrandColor": "وصف العنصر: العلامة التجارية، اللون، العلامات المميزة… (كلما زادت التفاصيل المقدمة، كانت فرصتك أفضل في العثور على العنصر)",
"hc.dimensionsCm": "الأبعاد (سم)",
"hc.disablingAnEmail": "تعطيل بريد إلكتروني",
"hc.doesNotHide": "لا يخفي",
"hc.download": "تنزيل",
"hc.downloadThePdf": "تنزيل PDF",
"hc.draftRestoredPickUpYour": "تم استعادة المسودة — التقط إعلانك من حيث تركته.",
"hc.dragToReposition": "اسحب لتغيير الموضع",
"hc.eGColisPriv": "مثل: Colis Privé",
"hc.eachItemGetsAQr": "كل عنصر يحصل على ملصق QR. امسحه من \"التخزين و QR\" لتحديد موقع عنصر في لحظة.",
"hc.eachSiteManagesItsOwn": "كل موقع يدير نظامه المصرفي الخاص. انتقل إلى",
"hc.edit": "تعديل",
"hc.emailNotificationPreferences": "تفضيلات إشعارات البريد الإلكتروني",
"hc.emailPreferencesUpdated": "تمت تحديث تفضيلات البريد الإلكتروني",
"hc.enableOrDisableRecoveryFees": "تفعيل أو تعطيل رسوم الاسترداد لـ",
"hc.enlargePhoto": "تكبير الصورة",
"hc.enterTheCustomerSCode": "أدخل رمز العميل",
"hc.estShipRate": "معدل الشحن التقريبي (Sendcloud + {m}% هامش):",
"hc.establishment": "المنشأة",
"hc.establishment2": "المنشأة:",
"hc.establishmentInItsSendcloudAccount": "المنشأة في حساب Sendcloud الخاص به وتمنحك معرف المرسل",
"hc.establishmentSettings": "إعدادات المنشأة",
"hc.exCode": "مثال: ABCD2345",
"hc.exId": "مثال: 3f2a…",
"hc.exit": "خروج",
"hc.explainWhyThisItemIs": "اشرح لماذا هذا العنصر ليس لك…",
"hc.externalPaymentLinks": "روابط الدفع الخارجية",
"hc.failed": "فشل",
"hc.feesEnabled": "الرسوم مفعلّة",
"hc.field": ") حقل.",
"hc.finderAcceptedCloseTheCase": "تمت الموافقة من قبل Finder — اغلق القضية بمجرد تسليم العنصر شخصيًا.",
"hc.findoCityRanking": "Findloop — تصنيف المدينة",
"hc.findoForEstablishments": "Findloop للمنشآت",
"hc.findoPresentationVideo": "فيديو تقديم Findloop",
"hc.findoRegistersTheAddressOf": "تسجل Findloop عنوان",
"hc.findoReviewShare": "مراجعة Findloop {year}: {n} عنصر تم إرجاعه، نسبة الإرجاع {rate}% 🎉",
"hc.firstVerifyTheClaimCode": "أولاً تحقق من رمز المطالبة أعلاه",
"hc.forEveryNewShipmentFrom": "لكل شحنة جديدة من",
"hc.free": "مجاني",
"hc.freeRecovery0": "استرجاع مجاني (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "استرجاع مجاني عبر إفريقيا – عرض إطلاق",
"hc.freeRecoveryFeesDisabled0": "استرجاع مجاني: الرسوم معطلة (0 €)",
"hc.fromTeamInviteYourColleagues": "من \"الفريق\"، دعوة زملائك عبر البريد الإلكتروني وتعيينهم منشأة. كل عضو يرى نطاقه الخاص فقط.",
"hc.fullName": "الاسم الكامل",
"hc.fullPhoto": "صورة كاملة",
"hc.gallery": "معرض",
"hc.giveTheReasonForCancelling": "أعطِ سبب الإلغاء. سيتم إعلام الشريك.",
"hc.goToLogin": "اذهب لتسجيل الدخول",
"hc.goToMyAccount": "اذهب إلى حسابي",
"hc.gold": "ذهبي",
"hc.googleLoginFailed": "فشل تسجيل الدخول باستخدام Google",
"hc.hasConfirmedYourPaymentYou": "قد أكد دفعك، سيتم توجيهك تلقائيًا",
"hc.helpCenter": "مركز المساعدة",
"hc.helpUsImproveWhyAre": "ساعدنا في التحسين: لماذا تغادر؟ سيتم تعطيل حسابك ويمكن إعادة تنشيطه خلال 30 يومًا.",
"hc.hidePassword": "إخفاء كلمة المرور",
"hc.high": "عالي",
"hc.historyOfYourMonthlySubscriptions": "تاريخ اشتراكاتك الشهرية وحالة دفعها.",
"hc.hotelBelmont": "فندق بيلمونت",
"hc.howConfigureSenderId": "كيف أعد الرقم المرسل الخاص بي؟",
"hc.iDonTUseIt": "لا أستخدمه بما فيه الكفاية",
"hc.iFoundItElsewhere": "وجدته في مكان آخر",
"hc.iNoLongerNeedMy": "لم أعد أحتاج إلى خاصتي",
"hc.identityVerification": "التحقق من الهوية",
"hc.idleLogoutIn": "سوف يتم تسجيل خروجك في {n} ثانية بسبب inactivity.",
"hc.ifProvidedTheVolumetricWeight": "إذا تم تقديمه، سيتم استخدام الوزن الحجمي.",
"hc.ifThePartnerHasNot": "إذا لم يؤكد الشريك استلام الدفع الخارجي بعد هذا التأخير، ستقوم Findloop بتذكير الشريك تلقائيًا بالتحقق منه.",
"hc.impersonationEnded": "انتهت عملية انتحال الهوية.",
"hc.impersonationMode": "وضع انتحال الهوية",
"hc.impersonationSessionExpired": "انتهت جلسة انتحال الهوية.",
"hc.inTheField": ", في الميدان",
"hc.inTransit": "في النقل",
"hc.inclVat": "شاملة ضريبة القيمة المضافة",
"hc.intraEuVatNumberOptional": "رقم ضريبة القيمة المضافة داخل الاتحاد الأوروبي اختياري، لا حاجة لـ SIRET (خارج فرنسا).",
"hc.invalidInvitationLink": "رابط الدعوة غير صالح.",
"hc.invalidInvitationLink2": "رابط الدعوة غير صالح",
"hc.invalidInviteLink": "رابط الدعوة غير صالح أو منتهي الصلاحية.",
"hc.invalidNumberEnterAnInternational": "رقم غير صالح. أدخل رقم دولي، مثل +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "رابط غير صالح أو منتهي الصلاحية.",
"hc.invalidOrExpiredReactivationLink": "رابط إعادة التفعيل غير صالح أو منتهي الصلاحية",
"hc.invalidSendcloudId": "معرف Sendcloud غير صالح",
"hc.inviteSubtitle": "{org} يدعوك للانضمام إلى فريق Findloop الخاص بهم. اختر كلمة المرور الخاصة بك لتفعيل حسابك.",
"hc.isAvailableOnSendcloudFor": "متاح على Sendcloud لجميع مساراتك (محلية + دولية).",
"hc.isNotEnabledOnYour": "ليس مفعلًا على حساب Sendcloud الخاص بك لبعض الوجهات. سيتم إنشاء ملصقات لتلك باستخدام ناقل آخر متاح.",
"hc.isThisReallyYourItem": "هل هذه حقًا خاصتك؟",
"hc.isThisYourItem": "هل هذه خاصتك؟",
"hc.item": "عنصر",
"hc.itemAlreadyConfirmed": "تم تأكيد العنصر بالفعل",
"hc.itemDetails": "تفاصيل العنصر",
"hc.itemFoundAt": "العنصر وُجد في",
"hc.itemFoundAtAPartner": "العنصر وُجد عند شريك",
"hc.itemMarkedAsReturned": "تم وضع علامة على العنصر كمرتجع ✓",
"hc.itemPhotoRequiredBeforeShipping": "صورة العنصر (مطلوبة قبل الشحن)",
"hc.itemPhotoSaved": "تم حفظ صورة العنصر",
"hc.itemPreview": "معاينة العنصر",
"hc.itemPutBackInStorage": "تم إرجاع العنصر إلى التخزين.",
"hc.itemWeight": "وزن العنصر:",
"hc.itemsReturned": "العنصر (العناصر) المرتجعة",
"hc.itemsReturnedThisYear": "العناصر المرتجعة هذا العام",
"hc.itemsWhoseLegalDeadlineIs": "العناصر التي موعدها القانوني بعد 15 يومًا أو أقل (بما في ذلك المتأخرة). تبقى المطابقات مرئية.",
"hc.kbisNumber": "رقم Kbis",
"hc.keysForgottenOnABench": "المفاتيح المنسية على مقعد",
"hc.labelBeingGenerated": "يتم إنشاء الملصق",
"hc.leaveTheFieldsEmptyTo": "اترك الحقول فارغة لتقديم الاسترداد مجانًا.",
"hc.legalNotice": "إشعار قانوني",
"hc.limitReachedUpgradeToA": "تم الوصول إلى الحد - قم بالترقية إلى خطة أعلى",
"hc.linkCopiedShareOn": "تم نسخ الرابط - شاركه على {label}",
"hc.linkUnavailable": "الرابط غير متاح",
"hc.linkedTo": "مرتبط بـ",
"hc.listingHiddenByModeration": "تم إخفاء الإدراج بواسطة الإشراف.",
"hc.loading": "جارٍ التحميل…",
"hc.locateMe": "حدد موقعي",
"hc.logIn": "تسجيل الدخول",
"hc.logInToGetBack": "تسجيل الدخول للعودة إلى مساحتك وإدارة اشتراكك.",
"hc.loginFailed": "فشل تسجيل الدخول",
"hc.lostFoundPlatform": "منصة المفقودات والعثور عليها.",
"hc.lostIn": "مفقود في",
"hc.lowRate": "سعر منخفض",
"hc.mainReason": "السبب الرئيسي",
"hc.mainStreet": "الشارع الرئيسي",
"hc.makeSureThisIsThe": "تأكد أن هذه هي العنصر الذي فقدته قبل فتح تفاصيل الاتصال بالعثور عليه.",
"hc.manageCookies": "إدارة ملفات تعريف الارتباط",
"hc.manageMyTeam": "إدارة فريقي",
"hc.manageYourTeam": "إدارة فريقك",
"hc.markAsReturned": "تحديد كمرتجع",
"hc.matchNoClaimInTime": "لم تتلقى المطابقة أي طلب ضمن المهلة.",
"hc.matchNotFound": "المطابقة غير موجودة",
"hc.medium": "متوسط",
"hc.milestoneFmt": "تم الوصول إلى معلم {m} من العناصر المرتجعة! في الطريق إلى {next}.",
"hc.missingFeatures": "ميزات مفقودة",
"hc.monthly": "شهريًا",
"hc.monthlyBilling": "الفوترة الشهرية",
"hc.moveThePhotoToFit": "قم بتحريك الصورة لتناسب الدائرة.",
"hc.myAccount": "حسابي",
"hc.myInvoices": "فواتيري",
"hc.myMonthlyInvoices": "فواتيري الشهرية",
"hc.nArchived": "{n} قائمة(قوائم) مؤرشفة.",
"hc.newCodeGeneratedAndSent": "تم إنشاء رمز جديد وإرساله إلى العميل عبر البريد الإلكتروني والرسائل القصيرة",
"hc.newCodeGeneratedAndSent2": "تم إنشاء رمز جديد وإرساله إلى المالك",
"hc.newPassword": "كلمة مرور جديدة",
"hc.next": "التالي",
"hc.nextPhoto": "الصورة التالية",
"hc.no": "لا",
"hc.noAnswerProvided": "لم يتم تقديم أي إجابة.",
"hc.noArchivedDeclarations": "لا توجد إقرارات مؤرشفة",
"hc.noCountryFound": "لا توجد دولة",
"hc.noDeclarations": "لا توجد إقرارات",
"hc.noFeesAreChargedTo": "لا توجد أي رسوم تُفرض على العميل.",
"hc.noInvoiceYet": "لا توجد فاتورة بعد.",
"hc.noInvoiceYetYourInvoices": "لا توجد فاتورة بعد. سيتم عرض فواتيرك هنا تلقائيًا بعد كل عملية دفع.",
"hc.noMatchIsAvailableFor": "لا توجد تطابقات متاحة الآن. سنخبرك بمجرد أن يتناسب عنصر مع إقرارك.",
"hc.noShipmentMatchesYourSearch": "لا توجد شحنات تتطابق مع بحثك.",
"hc.noShipmentsYet": "لا توجد شحنات بعد.",
"hc.noShipmentsYet2": "لا توجد شحنات بعد",
"hc.none": "لا شيء",
"hc.noneChooseForEachShipment": "لا شيء (اختر لكل شحنة)",
"hc.notMine": "ليس لي",
"hc.of": "من",
"hc.only": "فقط",
"hc.onlyEachSiteManagesIts": "فقط. كل موقع يدير بنكه الخاص: هذه الروابط لا تؤثر على أي مؤسسة أخرى.",
"hc.onlyTheOwnerOrAn": "يمكن فقط للمالك أو المسؤول تكوين روابط الدفع للمؤسسة.",
"hc.openDepositInTheMenu": "افتح \"الإيداع\" في القائمة، وصف العنصر والتقاط صورة. يتم تخزينه على الفور وجاهزًا للإرجاع.",
"hc.openSettings": "افتح الإعدادات →",
"hc.openTheDeclarationToManage": "افتح الإقرار لإدارة الشحنة",
"hc.optional": "— اختياري",
"hc.optional2": "(اختياري)",
"hc.optional3": "اختياري",
"hc.originalListingPhotoUsed": "تم استخدام صورة الإدراج الأصلية",
"hc.other": "أخرى",
"hc.other2": "أخرى…",
"hc.ourProducts": "منتجاتنا",
"hc.overallRateTrendLast6": "اتجاه السعر العام (آخر 6 أشهر)",
"hc.ownerSClaimCode": "رمز مطالبة المالك",
"hc.ownershipConfirmed": "تم تأكيد الملكية",
"hc.paid": "مدفوع",
"hc.paidOn": "مدفوع في",
"hc.paidViaPartner": "مدفوع (عبر الشريك)",
"hc.parcelBeingPrepared": "يتم إعداد الطرد",
"hc.parcelDelivered": "تم توصيل الطرد",
"hc.parcelShipped": "تم شحن الطرد",
"hc.parisGareDeLyon": "باريس، محطة ليون…",
"hc.partner": "شريك",
"hc.partner2": "شريك",
"hc.partnerDirectory": "دليل الشركاء",
"hc.passedOnToTheCustomer": "— تم تحويله إلى العميل رابط الدفع.",
"hc.password": "كلمة المرور",
"hc.passwordResetPleaseLogIn": "إعادة تعيين كلمة المرور، يرجى تسجيل الدخول.",
"hc.passwordUpdated": "تم تحديث كلمة المرور.",
"hc.passwordsDoNotMatch": "كلمات المرور غير متطابقة.",
"hc.pasteThisSenderIdIn": "الصق معرف المرسل هذا في Findloop → الإعدادات",
"hc.payForTheShipmentOf": "ادفع لشحن عنصر بوساطة Findloop بطريقة دفع آمنة.",
"hc.payTheRecoveryFees": "ادفع رسوم الاسترداد",
"hc.payTheShippingFees": "ادفع رسوم الشحن",
"hc.payment": "الدفع",
"hc.paymentAlreadyConfirmedByThe": "تم تأكيد الدفع بالفعل بواسطة الشريك",
"hc.paymentLinksAreNowConfigured": "روابط الدفع الآن تم إعدادها لكل منشأة",
"hc.paymentNotCompletedYourAccount": "لم يكتمل الدفع، لم يتم إنشاء حسابك — يرجى المحاولة مرة أخرى.",
"hc.paymentReceived": "تم استلام الدفع",
"hc.paymentSuccessful": "تم الدفع بنجاح!",
"hc.pdfInvoice": "فاتورة PDF",
"hc.pending": "معلق",
"hc.period": "فترة",
"hc.phoneNumber": "رقم الهاتف",
"hc.phoneOptional": "الهاتف (اختياري)",
"hc.planAt": "التخطيط في",
"hc.planLimitFmt": "خطة \"{plan}\" الخاصة بك محدودة بـ {max} منشأة. لإدارة {n} مواقع، نوصي بـ",
"hc.platformReturnTarget": "هدف عائدات المنصة",
"hc.pleaseCompleteYourShippingAddress": "يرجى إكمال عنوان الشحن الخاص بك.",
"hc.pleaseProvideAPhoneNumber": "يرجى تقديم رقم هاتف: هو مطلوب من قبل الناقل للشحن.",
"hc.pleaseProvideAReason": "يرجى تقديم سبب.",
"hc.pleaseSetYourOwnPassword": "يرجى تعيين كلمة المرور الخاصة بك قبل المتابعة.",
"hc.pointsToGoal": "{n} نقاط أخرى للوصول إلى هدفنا المشترك.",
"hc.posterPreview": "معاينة الملصق",
"hc.potentialMatchBeingVerified": "مطابقة محتملة قيد التحقق",
"hc.potentialOwner": "المالك المحتمل",
"hc.preFilledAutomaticallyYouCan": "تم ملؤه تلقائيًا — يمكنك استبداله بصورة الطرد.",
"hc.pressKit": "حزمة الصحافة",
"hc.previewMode": "وضع المعاينة:",
"hc.previewOfThePrintReady": "معاينة الملصق الجاهز للطباعة A4 لهذه المنشأة.",
"hc.previous": "السابق",
"hc.previousPhoto": "الصورة السابقة",
"hc.primary": "أساسي",
"hc.printThePoster": "طباعة الملصق",
"hc.privacy": "الخصوصية",
"hc.privacyPolicy": "سياسة الخصوصية",
"hc.processedCasesWillAppearHere": "ستظهر الحالات المعالجة هنا.",
"hc.proofOfReturnPdf": "إثبات الإرجاع (PDF)",
"hc.protectedByRecaptcha": "محمي بواسطة reCAPTCHA",
"hc.publicMatch": "مباراة عامة",
"hc.putBackInStorage": "إعادة التخزين",
"hc.pwdResetByTeam": "تم إعادة تعيين كلمة المرور الخاصة بك بواسطة فريقنا. لسلامتك،",
"hc.questionsToAskTheOwner": "أسئلة لطرحها على المالك",
"hc.rateChargedToTheCustomer": "المعدل المفروض على العميل:",
"hc.rateOfTarget": "{rate}% تم تحقيقه من هدف {target}%",
"hc.reached": "تم الوصول",
"hc.reactivating": "إعادة التنشيط…",
"hc.reasonSavedYouCanStill": "تم حفظ السبب. يمكنك المطالبة بممتلكاتك.",
"hc.recentMatchesFirst": "أحدث المباريات أولاً",
"hc.recognizedThePhotoYouSent": "حدد الصورة التي أرسلتها ووصفت هذه الخصائص. يرجى التأكيد فقط إذا تطابقت مع العنصر في حوزتك.",
"hc.recommended": "موصى به",
"hc.recoveryFees": "رسوم الاسترداد",
"hc.recoveryFeesArePaidDirectly": "تُدفع رسوم الاسترداد مباشرة إلى المنشأة الشريكة. لا تتلقى Findloop أي مدفوعات من العملاء.",
"hc.recoveryFeesEnabled": "تم تفعيل رسوم الاسترداد",
"hc.recoveryOfferedByTheEstablishment": "الاسترداد المقدم من المنشأة — لا تفرض Findloop أي رسوم.",
"hc.recoveryPaymentLink": "رابط دفع الاسترداد",
"hc.recoveryPaymentLinkSavedFor": "تم حفظ رابط دفع الاسترداد لهذه المنشأة",
"hc.redirecting": "إعادة توجيه…",
"hc.redirectingToPayment": "إعادة توجيه إلى الدفع…",
"hc.redirectingToTheRecoveryOf": "إعادة توجيه لاسترداد ممتلكاتك…",
"hc.regenerateAndResendToThe": "إعادة توليد وإعادة إرسال إلى المالك",
"hc.regenerateTheCode": "إعادة توليد الشيفرة",
"hc.registerAFoundItem": "تسجيل عنصر تم العثور عليه",
"hc.rejectTheClaim": "رفض المطالبة",
"hc.reminderDelaySaved": "تم حفظ تأخير التذكير",
"hc.reopenThePaymentLink": "إعادة فتح رابط الدفع",
"hc.repeatThePassword": "إعادة إدخال كلمة المرور",
"hc.reportAProblem": "الإبلاغ عن مشكلة",
"hc.reportDismissedYourListingRemains": "تم إغلاق البلاغ. لا يزال إعلانك عامًا.",
"hc.requiredUsedToCalculateThe": "مطلوب: يُستخدم لحساب سعر شحن Sendcloud. الشحن غير متاح لأكثر من 30 كجم.",
"hc.reset": "إعادة تعيين",
"hc.resume": "استئناف",
"hc.resumeRegistration": "استئناف التسجيل",
"hc.retro": "سنة في مراجعة",
"hc.returnSecurity": "أمان الإرجاع",
"hc.returnToTheOwner": "إرجاع إلى المالك",
"hc.returned": "تم الإرجاع",
"hc.reviewTheItemDetails": "مراجعة تفاصيل العنصر",
"hc.revokeAccess": "إلغاء الوصول",
"hc.role": "الدور:",
"hc.save": "احفظ",
"hc.save2": "احفظ",
"hc.saveAndContinue": "احفظ واستمر",
"hc.saving": "جارٍ الحفظ…",
"hc.scanTheClaimCode": "امسح رمز المطالبة",
"hc.scanTheOwnerSQr": "امسح QR المالك",
"hc.scrollThroughLanguages": "قم بالتمرير عبر اللغات",
"hc.searchByCustomerItemOr": "ابحث حسب العميل أو العنصر أو رقم التتبع…",
"hc.searchForACountry": "ابحث عن دولة…",
"hc.secureFindoVerification": "تحقق آمن من Findloop",
"hc.seeRetro": "عرض السنة في مراجعة",
"hc.selectedCarrier": "الناقل المختار:",
"hc.selectedPlan": "الخطة المختارة",
"hc.send": "إرسال",
"hc.sendcloudSenderIdSaved": "تم حفظ معرف مرسل Sendcloud",
"hc.sendcloudSenderIdSenderId": "معرف مرسل Sendcloud (sender_id)",
"hc.sending": "جارٍ الإرسال…",
"hc.sessionExpired": "انتهت الجلسة",
"hc.setUpYourEstablishments": "قم بإعداد مؤسساتك",
"hc.settings": "الإعدادات",
"hc.settingsSubtitle": "المدفوعات الخارجية والتذكيرات، مُعدة لكل مؤسسة.",
"hc.shareFoundText": "لقد وجدت عنصرًا - ساعدني في العثور على مالكه على Findloop",
"hc.shareLostText": "لقد فقدت عنصرًا - ساعدني في العثور عليه على Findloop",
"hc.sharePreview": "مشاركة المعاينة",
"hc.shareTheRanking": "مشاركة التصنيف",
"hc.shareYourQrCodeTo": "شارك رمز QR الخاص بك لتلقي الإعلانات.",
"hc.shipRateAutoWeight": "يتم حساب سعر الشحن تلقائيًا عبر Sendcloud (الوزن {w}) في وقت الشحن.",
"hc.shipRateForWeight": "معدل الشحن (Sendcloud + {m}% هامش) لـ {w}:",
"hc.shipments": "الشحنات",
"hc.shipmentsSubtitle": "عرض موحد لجميع شحنات المؤسسة، عبر جميع الحالات. انقر على صف لإدارة الشحنة في تصريحها.",
"hc.shipping": "الشحن",
"hc.shippingAddress": "عنوان الشحن",
"hc.shippingFeesAreHandledAutomatically": "تتم معالجة رسوم الشحن تلقائيًا بواسطة Findloop (Sendcloud) — لا يوجد رابط لإدخاله.",
"hc.shippingFeesHaveAlreadyBeen": "تم دفع رسوم الشحن بالفعل: لا يمكن تغيير الناقل.",
"hc.shippingNotAvailableForItems": "الشحن غير متوفر للعناصر التي تزيد عن 30 كجم. سيتعين على العميل استلام العنصر شخصيًا.",
"hc.shippingPaid": "تم دفع الشحن ✓",
"hc.showOnlyItemsMatchingA": "عرض العناصر التي تتطابق مع قائمة عامة (للعملاء) فقط",
"hc.showPassword": "عرض كلمة المرور",
"hc.signInTheBoxAbove": "قم بتسجيل الدخول في المربع أعلاه",
"hc.signatureSaved": "تم حفظ التوقيع",
"hc.signedInWithGoogle": "تم تسجيل الدخول باستخدام Google",
"hc.signupFailed": "فشل التسجيل",
"hc.silver": "فضي",
"hc.simulatedRatesInPreProduction": "(أسعار محاكاة في مرحلة الإنتاج المسبق)",
"hc.siretAndVatNumberRequired": "رقم SIRET ورقم الضريبة على القيمة المضافة مطلوبان (فرنسا).",
"hc.skip": "تخطي",
"hc.smsSentIfAccount": "إذا كان هناك حساب بهذا الرقم، تم إرسال رسالة نصية قصيرة لك.",
"hc.sortItemsWithAPublic": "ترتيب: العناصر التي تتطابق مع عامة (الأحدث) أولاً",
"hc.specifyWhetherYouRecoveredYour": "حدد ما إذا كنت قد استعدت العنصر الخاص بك أو تريد ببساطة إزالة هذه القائمة.",
"hc.specifyYourReason": "حدد سببك",
"hc.specifyYourReason2": "حدد سببك…",
"hc.staff": "الفريق",
"hc.status": "الحالة",
"hc.staySignedIn": "البقاء مسجلاً",
"hc.step": "خطوة",
"hc.stillThere": "هل ما زلت هنا؟",
"hc.stopScrolling": "إيقاف التمرير",
"hc.storeFindWithQr": "تخزين وإيجاد باستخدام QR",
"hc.streetName": "اسم الشارع",
"hc.streetNo": "رقم الشارع.",
"hc.switchTo": "التبديل إلى",
"hc.switchToDarkMode": "التبديل إلى الوضع المظلم",
"hc.switchToLightMode": "التبديل إلى الوضع الفاتح",
"hc.takeAPhoto": "التقاط صورة",
"hc.takeChangeThePhoto": "التقاط / تغيير الصورة",
"hc.takenFromYourDeclaration": "المأخوذ من تصريحك",
"hc.target": "الهدف",
"hc.targetReached": "تم الوصول إلى الهدف",
"hc.targetReachedThankYouTo": "تم الوصول إلى الهدف - شكرًا لكافة مجتمع Findloop!",
"hc.tellUsMore": "أخبرنا المزيد…",
"hc.tellUsWhyYouCancel": "أخبرنا لماذا تلغي. سيساعد ذلك الشريك في معالجة طلبك.",
"hc.tellUsWhyYourListing": "أخبرنا لماذا. تظل قائمتك نشطة ويمكنك المطالبة بعنصرك.",
"hc.termsAndConditions": "الشروط والأحكام",
"hc.termsAndPolicies": "الشروط والسياسات",
"hc.thankYouForYourFeedback": "شكرًا على ملاحظاتك",
"hc.theBannerDisplayedInThe": "البانر المعروض في السجل.",
"hc.theClaimantHasBeenInformed": "لقد تم إبلاغ المدعي. العنصر متاح في القائمة العامة.",
"hc.theClaimantHasBeenNotified": "لقد تم إشعار المدعي ويمكنه الآن متابعة العودة.",
"hc.theCustomerPaysTheFees": "العميل يدفع الرسوم للمؤسسة.",
"hc.theDayTheLegalRetention": "اليوم الذي يتم فيه الوصول إلى فترة الاحتفاظ القانونية.",
"hc.theEstablishmentConsideredThatThis": "المؤسسة اعتبرت أن هذا العنصر ليس لك.",
"hc.theEstablishmentIsReviewingYour": "المؤسسة تراجع إجاباتك. ستتلقى إشعارًا بمجرد التحقق من مطالبك، ثم يمكنك دفع رسوم الاسترداد.",
"hc.theFeesAreTooHigh": "الرسوم مرتفعة جدًا",
"hc.theFinderConsideredThatThis": "المكتشف اعتبر أن هذا العنصر ليس لك.",
"hc.theFinderIsReviewingYour": "المكتشف يراجع طلبك. ستتلقى إشعارًا بمجرد المصادقة عليه.",
"hc.theItem": "العنصر",
"hc.theItemWillBeRemoved": "سيتم إزالة العنصر من السجل (لا توجد مطالبة جارية).",
"hc.theItemWillBeSet": "سيتم إعادة ضبط العنصر إلى \"متوفر في المخزون\" وسيتم إلغاء المطالبة ذات الصلة.",
"hc.theKbisNumberAndVat": "رقم Kbis ورقم ضريبة القيمة المضافة مطلوبان لفرنسا.",
"hc.theLabelIsGeneratedAutomatically": "يتم إنشاء الملصق تلقائيًا بمجرد أن يدفع العميل رسوم الشحن. سيكون قابلًا للتنزيل هنا.",
"hc.theLinkMayHaveExpired": "قد تكون الرابط قد انتهت صلاحيته (صالح لمدة 30 يومًا). اتصل بدعم Findloop إذا لزم الأمر.",
"hc.theOwnerDescribesTheirItem": "المالك يصف عنصرة",
"hc.theOwnerReceivedItBy": "المالك تلقاه عبر البريد الإلكتروني (أو الرسائل النصية). أدخله أو امسح رمز الاستجابة السريعة قبل التسليم.",
"hc.thePartnerConsideredThatThis": "الشريك اعتبر أن هذا العنصر ليس لك. العنصر ما زال متاحًا.",
"hc.thePartnerIsReviewingYour": "الشريك يراجع إجاباتك. ستتلقى إشعارًا بمجرد التحقق من طلبك.",
"hc.theShipmentIsCreatedAutomatically": "يتم إنشاء الشحنة تلقائيًا بمجرد أن يؤكد العميل عنوانه ويدفع رسوم الاسترداد. سيتم إنشاء الملصق تلقائيًا بعد دفع الشحن، ويمكن تنزيله هنا.",
"hc.theShippingRateWillBe": "سيتم حساب معدل الشحن تلقائيًا عبر Sendcloud وقت الشحن (الوزن المسجل).",
"hc.thisCarrierWillBe": "هذه الناقلة ستكون",
"hc.thisEstablishment": "هذه المؤسسة",
"hc.thisFieldIsRequiredFor": "هذا الحقل مطلوب لإنشاء الملصق تلقائيًا.",
"hc.thisIsMyItem": "هذا هو عنصر من ممتلكاتي",
"hc.thisIsMyItemContinue": "هذا هو عنصر من ممتلكاتي - تابع",
"hc.thisIsMyItemStart": "هذا هو عنصر من ممتلكاتي - ابدأ العودة",
"hc.thisIsNotMyItem": "هذا ليس عنصر من ممتلكاتي",
"hc.thisMatchIsNoLonger": "هذه المطابقة لم تعد متاحة أو تمت معالجتها بالفعل.",
"hc.thisRateWillBeCharged": "سيتم خصم هذه الرسوم من العميل. قد تؤدي الرسوم العالية إلى تثبيط الاسترداد.",
"hc.thisStepIsRequiredFor": "هذه الخطوة مطلوبة لإنشاء ملصقات الشحن",
"hc.thisValidationLinkIsInvalid": "رابط التحقق هذا غير صالح أو قد انتهت صلاحيته.",
"hc.toCheckBeforeMarkingThe": "للتحقق قبل علامة العنصر كمرتجع.",
"hc.toConfigureTheLinksAnd": "لتهيئة الروابط ومدة التذكير لكل منشأة.",
"hc.toReachOurFirstMilestone": "للوصول إلى أول مرحلة لنا من 100 عملية إرجاع.",
"hc.toTheCustomer": "إلى العميل.",
"hc.toTheShippingFeePayment": "إلى دفع رسوم الشحن.",
"hc.toYourRecoveryTracking": "إلى تتبع استردادك.",
"hc.tooExpensiveBudget": "مكلف جداً / الميزانية",
"hc.topCitiesForReturns": "أفضل المدن للإرجاع",
"hc.trackMyRecovery": "تتبع استردادي",
"hc.trackTheShipmentAndDownload": "تتبع الشحنة وتنزيل الملصق (تم إنشاؤه تلقائيًا) دون مغادرة علامة التبويب التصريحات.",
"hc.trackYourStatistics": "تتبع إحصائياتك",
"hc.tracking": "التتبع",
"hc.unableToOpenTheShipping": "غير قادر على فتح دفع رسوم الشحن. يرجى المحاولة مرة أخرى.",
"hc.unableToRetrieveTheInvoice": "غير قادر على استرجاع الفاتورة.",
"hc.unclaimed": "غير مُطالب به",
"hc.unclaimedCustomerReason": "عنصر غير مُطالب به. سبب العميل: \"{reason}\".",
"hc.unclaimedItem": "عنصر غير مُطالب به",
"hc.unclaimedItemNoClaimWithin": "عنصر غير مُطالب به — لا مطالبة ضمن المهلة النهائية.",
"hc.unclaimedItems": "عناصر غير مُطالبة",
"hc.unclaimedItemsMatchLeftWithout": "عناصر غير مُطالبة: مباراة تركت دون مطالبة ضمن المهلة النهائية. يمكنك إعادتها إلى التخزين.",
"hc.unlockTheFinderSContact": "فتح تفاصيل اتصال المكتشف لترتيب التسليم.",
"hc.upcoming": "قريباً",
"hc.updateFailed": "فشل التحديث.",
"hc.usedForInvoices": "يستخدم لإصدار فواتير Findloop الخاصة بك.",
"hc.vatNumber": "رقم ضريبة القيمة المضافة",
"hc.verificationPending": "التحقق معلق",
"hc.verificationSentToTheFinder": "تم إرسال التحقق إلى المكتشف. ستتلقى إشعارًا بقرارهم.",
"hc.verificationSentToThePartner": "تم إرسال التحقق إلى الشريك. ستتلقى إشعارًا بقرارهم.",
"hc.verify": "تحقق",
"hc.verifyingInvite": "جارٍ التحقق من رابط الدعوة…",
"hc.verifyingTheLink": "جارٍ التحقق من الرابط…",
"hc.viewInRegistry": "عرض في السجل",
"hc.viewItem": "عرض العنصر",
"hc.viewItemRecover": "عرض العنصر واسترداده",
"hc.visibleToTheOwnerAutomatically": "مرئي للمالك · يتم حذفه تلقائيًا بعد 60 يومًا.",
"hc.waitingForPartnerConfirmation": "في انتظار تأكيد الشريك",
"hc.waitingForThePartnerS": "في انتظار تأكيد الشريك",
"hc.weHaveInformedTheEstablishment": "لقد أبلغنا المنشأة أن هذا العنصر ليس ملكك وأعدنا بدء التحليل. سيتم إبلاغك بمجرد العثور على تطابق جديد.",
"hc.weHaveInformedThePartner": "لقد أبلغنا الشريك أن هذا العنصر ليس ملكك. تظل قائمتك نشطة للتطابقات المستقبلية.",
"hc.weRanTheAnalysisAgain": "قمنا بإعادة تحليل ووجدنا عنصرًا آخر قد يكون لك. يرجى التحقق مرة أخرى.",
"hc.weight": "الوزن",
"hc.weightNotProvidedTheShipping": "لم يتم توفير الوزن: سيتم حساب رسوم الشحن في وقت الشحن.",
"hc.weightUnit": "وحدة الوزن",
"hc.welcome": "أهلاً وسهلاً!",
"hc.welcomeToFindo": "مرحبًا بك في Findloop",
"hc.whenACustomerComesTo": "عندما يأتي العميل لاستلام ممتلكاته، افتح إعلانه وحقق في العودة. هذا كل شيء!",
"hc.whenDisabledFeesDropTo": ". عند التعطيل، تنخفض الرسوم إلى",
"hc.whyIsThisNotYour": "لماذا هذا ليس عنصرًا لك؟",
"hc.willBeMarkedAs": "سيتم وضع علامة على",
"hc.wrongColor": "لون خاطئ",
"hc.wrongModel": "نموذج خاطئ",
"hc.yesCancel": "نعم، ألغِ",
"hc.yesContactTheFinder": "نعم، اتصل بالباحث",
"hc.youAreHere": "أنت هنا",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "يمكنك الآن بدء العودة.",
"hc.youCanStillChangeIt": ". لا يزال بإمكانك تغييره من حالة إلى أخرى.",
"hc.youHaveAlreadyConfirmedThat": "لقد أكدت بالفعل أن هذا هو العنصر الخاص بك.",
"hc.youWillBeRedirectedTo": "سيتم توجيهك إلى عملية الدفع الآمن عبر Stripe.",
"hc.yourAccountHasBeenReactivated": "تم إعادة تنشيط حسابك.",
"hc.yourAccountIsActiveYou": "حسابك مفعل، يمكنك الآن إدارة مؤسساتك.",
"hc.yourEstablishment": "مؤسستك",
"hc.yourFeedbackHelpsUsImprove": "ملاحظاتك تساعدنا في تحسين مطابقتنا.",
"hc.yourFeedbackHelpsUsRestart": "ملاحظاتك تساعدنا في إعادة بدء التحليل وتحسين مطابقتنا.",
"hc.yourFirstSteps": "خطواتك الأولى",
"hc.yourFirstStepsAdmin": "خطواتك الأولى (مسؤول)",
"hc.yourItemHasBeenHanded": "تم تسليم عنصرك شخصيًا من قبل الشريك - أغلق القضية بمجرد تأكيد التسليم.",
"hc.yourItemHasBeenShipped": "تم شحن عنصرك من قبل الشريك - أغلق القضية بمجرد تأكيد التسليم.",
"hc.yourPaymentHasBeenRecorded": "تم تسجيل مدفوعتك.",
"hc.yourShipmentIsBeingPrepared": "يتم إعداد شحنتك. ستستلم طردك خلال 3 إلى 5 أيام عمل.",
"hc.yourShippingFeesHaveAlready": "تم دفع رسوم الشحن بالفعل. الشحن مدفوع ✓",
"hc.yourShippingFeesHaveBeen": "تم دفع رسوم الشحن. يتم إعداد طردك.",
"hc.yourVerificationQuestionsDeposit": "أسئلة التحقق الخاصة بك (وديعة)",
"hero.einvoiceBadge": "الفواتير الإلكترونية المتوافقة مع 2027",
"home.recentAdsAll": "عرض جميع الإعلانات",
"home.recentAdsEyebrow": "في الوقت الحالي",
"home.recentAdsSubtitle": "عناصر مفقودة وعثر عليها تم الإبلاغ عنها من قبل المجتمع.",
"home.recentAdsTitle": "أحدث الإعلانات",
"home.reunions": "إعادة لقاءات حديثة",
"home.videoEyebrow": "شاهد",
"home.videoSubtitle": "كيف نعيد العناصر المفقودة إلى أصحابها بسهولة.",
"home.videoTitle": "اكتشف Findloop في دقيقتين",
"home.watchYoutube": "شاهد على يوتيوب",
"impact.already": "بالفعل",
"impact.citiesWord": "مدينة/مدن",
"impact.eachPoint": "كل نقطة هي مدينة حيث يساعد Findloop في استعادة العناصر المفقودة.",
"impact.emptyMap": "تملأ الخريطة مع حدوث الاستردادات.",
"impact.eyebrow": "أثرنا",
"impact.inCities": "في",
"impact.restitutedTo": "العناصر المعادة إلى أصحابها",
"impact.title": "العناصر المعادة، في كل مكان بالقرب منك",
"inv2.download": "تحميل",
"inv2.view": "عرض",
"map.objectsOnMapPlural": "عناصر على الخريطة",
"map.objectsOnMapSingular": "عنصر على الخريطة",
"mc.claimConfirmDesc": "تحقق من العنصر الذي وجده المكتشف قبل الدفع لفتح تفاصيل الاتصال الخاصة به.",
"mc.claimConfirmNo": "هذا ليس عنصرًا لي",
"mc.claimConfirmTitle": "هل هذا هو عنصرًا لك حقًا؟",
"mc.claimConfirmYes": "نعم، إنه لي — ادفع",
"mc.claimFinderContacts": "تفاصيل اتصال المكتشف",
"mc.claimNotMineDone": "شكرًا — تم إبلاغ المكتشف وتمت إزالة طلبك من الإعلان.",
"mc.claimUnlockDesc": "ادفع رسوم إدارة Findloop للحصول على تفاصيل الاتصال بالشخص الذي وجد عنصرًا لك.",
"mc.claimUnlockTitle": "افتح تفاصيل اتصال المكتشف",
"mc.hideCountryOffers": "إخفاء العروض في بلدي",
"mc.myClaims": "العناصر التي أطالب بها",
"mc.myClaimsSub": "العناصر التي وجدها الآخرون والتي تطالب بها. افتح تفاصيل اتصال المكتشف لترتيب التسليم.",
"mc.notifAdCancelled": "تم إلغاء الإعلان",
"mc.notifCancelAd": "إلغاء إعلاني",
"mc.offersInCountry": "عروض في بلدي",
"mc.offersInCountryDesc": "جميع المكافآت النشطة من الشركاء في بلدك، حسب المدينة.",
"mc.redArchived": "أرشيف",
"mc.rewardsCountryNone": "لا توجد عروض في بلدك بعد.",
"mc.rewardsForYou": "مكافآت لك",
"mc.rewardsForYouDesc": "مقدمة من الشريك (الشركاء) حيث قمت بتسليم عنصر.",
"mc.rewardsMineNone": "لا توجد مكافآت من شركاء التسليم لديك بعد.",
"mc.showCountryOffers": "عرض العروض في بلدي",
"mc2.cancelDecl": "إلغاء إعلاني",
"mc2.cancelDeclDone": "تم إلغاء الإعلان.",
"pricing.physInvDesc": "عند إعادة عنصر، يتم تحرير موقعه تلقائيًا ويتاح لعنصر جديد.",
"pricing.physInvTitle": "تتبع المخزون الفعلي",
"pricing.physModalTitle": "إدارة العناصر الفعلية",
"pricing.physQrDesc": "يتم إنشاء رمز QR فريد لكل عنصر ويرتبط بجميع معلوماته.",
"pricing.physQrTitle": "ملصق QR مخصص",
"pricing.physShelfDesc": "يمكن تعيين موقع فعلي لكل عنصر مسجل داخل المنشأة.",
"pricing.physShelfTitle": "خطة الرفوف",
"pricing.physicalMgmt": "إدارة العناصر الفعلية (رفوف، QR، مخزون)",
"pub.addSecondPhoto": "إضافة صورة ثانية (اختياري)",
"pub.photo2Added": "✓ تم إضافة الصورة الثانية",
"reg.dispositionJournal": "سجل التصرف",
"reg.dispositionNoteAuthHint": "ℹ️ ملاحظة مطلوبة لـ “تم تسليمها للسلطات” (رقم التقرير، القسم…).",
"reg.dispositionNotePh": "ملاحظة (اختياري): جمعية المستلم، مرجع السلطات، اسم المشتري…",
"reg.dispositionNoteRequired": "مرجع رسمي مطلوب للتسليم للسلطات.",
"reg.legalPrealert": "الموعد النهائي القانوني في {days} يومًا",
"reg.legalPrealertOptions": "خيارات عند الموعد النهائي: بيع بالمزاد، تبرع لجمعية خيرية، تسليم للسلطات.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "مراجعة كاملة",
"rev.readMore": "اقرأ المزيد",
"rw.activeCodes": "قسائم نشطة",
"rw.archived": "مؤرشف",
"rw.archivedTitle": "قسائم مستردة (مؤرشفة)",
"rw.hideArchived": "إخفاء القسائم المستردة",
"rw.noArchived": "لا توجد قسائم مؤرشفة.",
"rw.showArchived": "عرض القسائم المستردة",
"shp.labelAuto": "يتم إنشاء الملصق تلقائيًا بمجرد أن يدفع العميل رسوم الشحن. سيكون قابلًا للتنزيل هنا.",
"st.cancelled_by_customer": "ملغى",
"stt.dispoPdfBtn": "تصدير PDF",
"stt.dispoPdfError": "فشل تصدير PDF.",
"stt.dispoPdfExporting": "جارٍ التصدير…",
"trk.matchVerifying": "مطابقة محتملة قيد التحقق",
"pcat.stadium_arena": "استاد / ساحة",
"pcat.supermarket": "سوبرماركت",
"pcat.taxi_vtc": "تاكسي / خدمات سيارات الأجرة",
"pcat.tourism_office": "مكتب سياحي",
"pcat.train_bus_station": "محطة القطار / الحافلات",
"pcat.travel_agency": "وكالة سفر",
"hc.and": "و",
"hc.demoObj0": "محفظة",
"hc.demoObj1": "حقيبة رياضية",
"hc.demoObj2": "هاتف",
"hc.demoObj3": "نظارات",
"hc.demoObj4": "مجموعة مفاتيح",
"hc.demoObj5": "وشاح",
"hc.demoObj6": "حاسوب محمول",
"hc.demoObj7": "زجاجة ماء",
"hc.demoWhen0": "قبل ساعتين",
"hc.demoWhen1": "قبل 5 ساعات",
"hc.demoWhen2": "أمس",
"hc.demoWhen3": "قبل 3 ساعات",
"hc.demoWhen4": "هذا الصباح",
"hc.demoWhen5": "قبل يوم",
"hc.feedDemo": "{obj} تم إرجاعه في {city} {when}.",
"hc.feedReal": "تم إرجاع عنصر ({cat}) في {city}.",
"hc.saveBtn": "احفظ",
"hc.saveLink": "احفظ الرابط",
"hc.terms": "الشروط",
"hc.view": "عرض",
"pcat.airline": "شركة طيران",
"pcat.airport": "مطار",
"pcat.amusement_park": "حديقة ترفيهية",
"pcat.bank": "بنك",
"pcat.bar_cafe": "بار / مقهى",
"pcat.beauty_salon": "صالون شعر / تجميل",
"pcat.cinema": "سينما",
"pcat.concert_theater": "قاعة حفلات / مسرح",
"pcat.coworking": "مساحة عمل مشتركة",
"pcat.gym_fitness": "نادي رياضي / لياقة",
"pcat.hospital_clinic": "مستشفى / عيادة",
"pcat.library": "مكتبة",
"pcat.mall": "مركز تسوق",
"pcat.museum": "متحف",
"pcat.pharmacy": "صيدلية",
"pcat.private_company": "شركة خاصة",
"pcat.public_transport": "نقل عام",
"pcat.school_university": "مدرسة / جامعة",
"pcat.sports_center": "مركز رياضي",
"an.found": "تم العثور عليه",
"an.lost": "مفقود",
"hc.shareReview": "شارك المراجعة",
"hc.citiesAboveTarget": "{n} مدينة فوق هدفها",
"hc.cityAboveTarget": "{n} مدينة فوق هدفها",
"hc.j15EarlyReminder": "تذكير مبكر قبل 15 يومًا",
"hc.j7EarlyReminder": "تذكير مبكر قبل 7 أيام",
"hc.annualTotal": "الإجمالي السنوي",
"hc.billedOnceYear": "يتم خصمه مرة واحدة لمدة 12 شهراً، يتم تجديده كل عام.",
"hc.monthlyPrice": "السعر الشهري",
"hc.perMonth": "/ شهر",
"hc.perYear": "/ سنة",
"hc.billedEachMonth": "يتم فرض الرسوم تلقائيًا كل شهر.",
"nav.business": "أعمال",
"nav.individual": "فردي",
"hc.circumstancesFound": "ظروف العثور",
"hc.circumstancesFoundPh": "مثل: تم العثور عليه على الأرض بالقرب من مدخل المترو",
"hc.circumstancesLost": "ظروف الفقدان",
"hc.circumstancesLostPh": "مثل: تُرك على مقعد أثناء انتظار الحافلة",
"hc.conditionPh": "مثل: جيد، مخدوش...",
"hc.firstName": "الاسم الأول",
"hc.lastName": "اسم العائلة",
"hc.quantity": "عدد العناصر",
"fa.ownerContact": "تفاصيل الاتصال بالمالك",
"fa.payPublish": "دفع ونشر",
"fa.pendingPayText": "سيتم نشر قائمتك بمجرد تأكيد الدفع.",
"fa.pendingPayTitle": "الدفع معلق",
"fa.planSub": "ستكون قائمتك متاحة بمجرد تأكيد الدفع.",
"fa.planTitle": "مدة القائمة",
"fa.pubSuccessMsg": "قائمتك الآن على الهواء. ستتلقى إشعارًا بمجرد أن يأتي شخص للعثور عليها.",
"fa.pubSuccessTitle": "تم نشر القائمة",
"fa.publicNote": "يتم عرض الوصف، المدينة، الدولة والصور بشكل عام فقط.",
"fa.redirectStripe": "يتم التحويل إلى الدفع الآمن…",
"fa.reject": "رفض",
"fa.rejectConfirm": "رفض هذا الإعلان؟ ستظل قائمتك على الإنترنت.",
"fa.rejected": "تم رفض الإعلان",
"fa.rejectedFinder": "لم يكن العنصر الذي يبحثون عنه",
"fa.rejectedFinderText": "يقول المالك إن هذا العنصر ليس له. شكرًا لمساعدتك!",
"fa.responsesTitle": "إعلانات الباحثين",
"fa.sent": "تم إرسال الإعلان إلى المالك.",
"fa.submitDecl": "إرسال إعلانى",
"fa.submitDeclPay": "إرسال والمساهمة بمبلغ {amount}",
"fa.total": "الإجمالي للدفع",
"fa.ttc": "شاملة الضريبة المضافة",
"fa.waitClaimText": "الباحث يقوم بمراجعة طلبك. ستتلقى إشعارًا بقرارهم.",
"fa.waitFinderText": "سنnotifyك بمجرد أن يقدم الباحث إعلانًا.",
"fa.waitFinderTitle": "قائمتك على الهواء",
"fa.waitOwnerText": "المالك يقارن إعلانك بإعلانه. ستتلقى إشعارًا بقرارهم.",
"fa.waitOwnerTitle": "في انتظار قرار المالك",
"st.pending_payment": "الدفع معلق",
"fa.approve": "موافقة",
"fa.approveConfirm": "هل تريد الموافقة على هذا التصريح؟ سيتم تبادل تفاصيل الاتصال الكاملة الخاصة بك (الاسم، البريد الإلكتروني، الهاتف) مع المكتشف.",
"fa.approved": "تمت الموافقة على التصريح — تم تبادل تفاصيل الاتصال",
"fa.approvedFinder": "قام المالك بالموافقة على تصريحك",
"fa.approvedFinderText": "اتصل بهم لترتيب العودة.",
"fa.boostSub": "تظل قائمتي في الأعلى لمدة الاختيار.",
"fa.boostTitle": "زيادة ظهور قائمتي (اختياري)",
"fa.colFinder": "تصريح المكتشف",
"fa.colYours": "تصريحك",
"fa.compareHint": "قارن تصريح المكتشف مع تصريحك قبل اتخاذ القرار.",
"fa.contribNone": "لا توجد مساهمة",
"fa.contribPaid": "تم استلام المساهمة — شكرًا لك!",
"fa.contribPending": "المساهمة في انتظار الدفع",
"fa.contribSub": "ادعم Findloop لمساعدة المزيد من الأشخاص على استعادة ممتلكاتهم. يمكنك اختيار €0.",
"fa.contribSuccessMsg": "تم إرسال تصريحك إلى المالك.",
"fa.contribSuccessTitle": "شكرًا لمساهمتك",
"fa.contribTitle": "مساهمة طوعية",
"fa.days3": "3 أيام",
"fa.days30": "30 يومًا",
"fa.days7": "7 أيام",
"fa.declSub": "صف العنصر الذي وجدته. سيقارن المالك تصريحك مع تصريحه.",
"fa.declTitle": "لقد وجدت هذا العنصر",
"fa.expiresOn": "تنتهي في",
"fa.fBrand": "العلامة التجارية",
"fa.fCircumstances": "الظروف",
"fa.fCity": "المدينة",
"fa.fColor": "اللون",
"fa.fCondition": "الحالة",
"fa.fDate": "التاريخ",
"fa.fMessage": "رسالة المكتشف",
"fa.fPlace": "المكان",
"fa.fQuantity": "الكمية",
"fa.finderContact": "تفاصيل الاتصال بالمكتشف",
"fa.finishPay": "أكمل الدفع",
"fa.foundDate": "تاريخ العثور",
"fa.foundPlace": "مكان العثور",
"fa.hours24": "24 ساعة",
"fa.ht": "غير شامل الضريبة",
"fa.months3": "3 أشهر",
"fa.noBoost": "لا توجد زيادة",
"fa.africaFree": "إدراج مجاني في إفريقيا — عرض إطلاق Findloop، استمتع به!",
"fa.africaPublished": "تم نشر الإدراج مجانًا — عرض إطلاق إفريقيا!",
"fa.approveClaimConfirm": "هل توافق على هذا الادعاء؟ سيتمكن المالك من فك قفل تفاصيل الاتصال الخاصة بك.",
"fa.checkInfo": "تحقق من تفاصيلك قبل الإرسال: سيتم مقارنتها بتفاصيل الباحث.",
"fa.claimApprovedShort": "وافق الباحث على ادعائك",
"fa.claimRejectedShort": "تم رفض الادعاء من قبل الباحث",
"fa.claimRejectedText": "يعتقد الباحث أن هذا العنصر ليس لك.",
"fa.claimSub": "صف عنصرَك وأضف صورتين. سيقارن الباحث بينهما وبين الإدراج الخاص به.",
"fa.claimTitle": "هذا هو عنصرّي",
"fa.claimUnlockText": "افتح تفاصيل الاتصال الخاصة بالباحث لترتيب عملية الإرجاع.",
"fa.claimUnlockedShort": "تفاصيل الاتصال مفتوحة — راقب تتبعك",
"fa.claimsTitle": "ادعاءات المالك",
"fa.colOwner": "إقرار المالك",
"fa.colYourAd": "إدراجك",
"fa.expired": "الإدراج منتهي",
"fa.free": "مجاني",
"fa.lostDate": "تاريخ فقد العنصر",
"fa.lostPlace": "مكان فقد العنصر",
"fa.noReceipt": "لا يوجد إيصال متاح لهذا الإدراج.",
"fa.planSubFree": "اختر المدة: إدراجك سيبدأ على الفور، دون دفع.",
"fa.prefillPrevious": "إعادة استخدام تفاصيل إدراجي السابق في هذه الفئة",
"fa.receipt": "إيصال PDF",
"fa.renewBtn": "تجديد",
"fa.renewDiscountBanner": "خصم 50%: جدد قبل انتهاء إدراجك!",
"fa.renewDiscountHint": "تم تطبيق خصم 50% لأنك تجدد قبل الانتهاء.",
"fa.renewEarly": "تجديد (−50%)",
"fa.renewTitle": "جدد إدراجي",
"fa.renewed": "تم تجديد الإدراج",
"fa.sendClaim": "أرسل ادعائي",
"fa.twoPhotos": "صورتان لعنكرك",
"fa.twoPhotosError": "أضف صورتين لعنكرك.",
"fa.twoPhotosHint": "صور شخصية تثبت أن العنصر لك (مع العنصر، الفاتورة، الصندوق…).",
"fa.unlockBtn": "افتح تفاصيل الاتصال",
"fa.unlockFree": "افتح مجانًا — عرض الإطلاق",
"fa.waitClaimantText": "سنخبرك حالما يقوم مالك بإدعاء هذا العنصر.",
"fa.waitFinderDecision": "انتظار قرار الباحث",
"fa.waitUnlockText": "ستتلقى إشعارًا حالما يتم تبادل تفاصيل الاتصال.",
"fa.waitUnlockTitle": "انتظار المالك لفتح",
"fa.cancel": "إلغاء",
"fa.categoryRequired": "اختر فئة للعنصر الذي تم العثور عليه.",
"fa.confirmTitle": "أكد قرارك",
"fa.goBack": "ارجع",
"dr.continue": "استمرار إعلاني",
"dr.delete": "حذف نهائي",
"dr.deleteConfirm": "هل ترغب في حذف هذه المسودة بشكل نهائي؟ لا يمكن التراجع عن ذلك.",
"dr.deleted": "تم حذف المسودة",
"dr.expiresIn": "تم الاحتفاظ بالمسودة لمدة {h} ساعة أخرى",
"dr.title": "لديك إقرار غير مكتمل",
"form.step": "خطوة",
"form.next": "تابع",
"form.back": "عودة",
"form.stepDetails": "تقريرك",
"form.stepPublish": "المدة، التعزيز والدفع",
"form.stepThanks": "شكرًا لك ومساهمتك",
"fthx.badge": "التقرير شبه مكتمل",
"fthx.title": "شكرًا لك، أنت تُحدث فرقًا!",
"fthx.text": "بفضلك، قد يستعيد شخص ما قريبًا شيئًا يهمه. أفعال اللطف مثل أفعالك هي ما يبقي Findloop حيًا.",
"fthx.impact1": "عنصر واحد تم الإبلاغ عنه",
"fthx.impact2": "فرصة واحدة أخرى للعثور على المفقودات",
"fthx.tipTitle": "دفعة صغيرة لـ Findloop؟",
"fthx.tipText": "تساعد مساهمتك في إبقاء الخدمة متاحة وإعادة المزيد من العناصر إلى أصحابها.",
"fthx.optional": "اختياري 100% — يمكنك النشر دون المساهمة.",
"fthx.thanksTip": "شكرًا جزيلًا على كرمك!",
"fthx.suggest": "المبالغ المقترحة",
"fthx.none": "لا يوجد تبرع",
"pay.pendingTitle": "لم تكتمل عملية الدفع",
"pay.pendingText": "تم حفظ تفاصيلك. استأنف عملية الدفع من حيث توقفت.",
"pay.resume": "استئناف الدفع",
"pay.expiredTitle": "انتهت مدة جلسة الدفع",
"pay.expiredText": "لأمانك، انتهت مدة جلسة الدفع. تم حفظ تفاصيلك: أعد تشغيل الدفع بنقرة واحدة.",
"pay.relaunch": "إعادة تشغيل الدفع",
"sub.received": "تم الإرسال!",
"sub.publishing": "نجري اللمسات الأخيرة…",
"sub.toPayment": "انتقل إلى الدفع الآمن…",
"fa.claimSubV2": "وصف غرضك المفقود. الشخص الذي وجده سيقارن إقرارك مع القائمة الخاصة به.",
"fa.photosOptional": "صور من غرضك (اختياري)",
"fa.compareOwnerHint": "قارن هذه المعلومات مع الغرض الذي وجدته، ثم قل ما إذا كان هو نفس الغرض.",
"fa.itsThisItem": "نعم، هذا هو الغرض",
"fa.notThisItem": "لا، هذا ليس الغرض",
"fa.confirmIsItem": "هل تؤكد أن هذا هو الغرض؟ ستظهر تفاصيل اتصالك ومالك الغرض في حسابيكما.",
"fa.confirmNotItem": "هل تؤكد أن هذا ليس الغرض؟ سيتم إغلاق تقريرك.",
"fa.youConfirmed": "لقد أكدت أن هذا هو غرض المالك",
"fa.youDeclined": "لقد أشرت إلى أن هذا ليس الغرض",
"fa.youDeclinedText": "شكرًا لمساعدتك! تم إبلاغ المالك.",
"fa.waitFinderDecisionOwner": "في انتظار قرار المكتشف",
"fa.finderConfirmed": "تم التأكيد",
"fa.notYourItem": "هذا لم يكن غرضك",
"fa.reportedOn": "تم الإبلاغ في",
"fa.ownerWaitHint": "المكتشف الآن يتحقق من المعلومات، يرجى الانتظار.",
"fa.claimSentFinder": "تم إرسال المطالبة إلى الشخص الذي وجد العنصر.",
"fa.compareClaimHint": "قارن بين بيان المالك وقائمتك قبل اتخاذ القرار.",
"fa.closeFollowup": "أغلق هذا المتابعة",
"fa.closeFollowupConfirm": "هل ترغب في إغلاق هذا المتابعة؟ سيتم حذف رسائل البريد الإلكتروني وأرقام الهواتف لكلا الطرفين بشكل دائم بمجرد أن يغلق المالك قائمتهم أيضًا.",
"fa.safetyTitle": "نصائح الأمان قبل التسليم",
"fa.safety1": "اسأل المالك عن وصف تفصيلي للميزات المخفية للعنصر: خدش معين، المحتويات الدقيقة لحقيبة، ورق الحائط، الرقم التسلسلي...",
"fa.safety2": "إذا أمكن، اطلب دليل بصري (صورة للعنصر) أو إثبات الشراء.",
"fa.safety3": "قم بتسليم العنصر في مكان عام أو في شريك لـ Findloop، وتحقق من هوية المالك.",
"fa.safetyOk": "فهمت، تابع",
"fa.ownerClosedNote": "المالك قد أغلق قائمتهم.",
"fa.finderClosedNote": "الباحث قد أغلق متابعته.",
"fa.followupClosed": "تم إغلاق المتابعة",
"fa.followupClosedText": "لقد قمت بإغلاق هذه المتابعة. شكرًا لمساعدتك!",
"fa.photoReviewTitle": "أرسل مكتشف صورة. هل يبدو كأنه عنصر خاص بك؟",
"fa.photoLooksLike": "نعم، يبدو كأنه عنصر خاص بي",
"fa.photoNotMine": "لا، هذا ليس العنصر الخاص بي",
"fa.photoNotMineConfirm": "سيتم إغلاق المتابعة من كلا الجانبين وسيبقى إعلانك مفتوحًا لمكتشف جديد.",
"fa.photoLooksLikeDone": "شكراً! سيو比 المكتشف الآن مقارنة إعلانك.",
"fa.photoNotMineDone": "تم رفض التقرير. سيبقى إعلانك مفتوحاً.",
"fa.ownerPhotoHint": "ستظهر لك صورة المكتشف فقط. أخبرنا ما إذا كانت تشبه عنصر خاص بك.",
"fa.ownerReviewingPhoto": "المالك يقوم بمراجعة صورتك",
"fa.ownerReviewingPhotoText": "ستتلقى إشعاراً بمجرد أن يجيبوا. ستتمكن بعد ذلك من مقارنة إعلانهم.",
"fa.ownerRejectedPhoto": "هذا ليس عنصر المالك",
"fa.ownerRejectedPhotoText": "يقول المالك أن صورتك لا تطابق عنصرهم. تم إغلاق المتابعة. شكراً لمساعدتك!",
"fa.contribute": "ساهم",
"fa.phoneMissing": "غير متوفر",
"fa.ownerSafety1": "يفضل تسليمها في مكان عام أو عند شريك لـ Findloop. إذا كانت المسافة بعيدة، اقترح إرسالها بالبريد بدلاً من ذلك.",
"fa.ownerSafety2": "عند التسليم، تحقق من هوية المكتشف.",
"pub.changePhoto": "تغيير الصورة",
"ph.secured": "الصورة مؤمنة",
"ph.securing": "يتم تأمين الصورة...",
"fa.ownerSafety3": "إذا كانت صورة المكتشف تحمل علامة Findloop، فلا تقبل الاجتماع. يجب أن تكون الصورة صورة أصلية التقطها المكتشف، بدون علامة مائية."
},
"he": {
"a.back": "חזור",
"a.category": "קטגוריה",
"a.categoryPlaceholder": "בחר קטגוריה",
"a.city": "עיר",
"a.confirmPassword": "אשר סיסמה",
"a.country": "מדינה",
"a.createAccount": "יצירת חשבון",
"a.createBtn": "צור את החשבון שלי",
"a.creating": "יוצר…",
"a.email": "אימייל",
"a.emailPro": "אימייל עסקי",
"a.forgot": "שכחת?",
"a.forgotSent": "אם קיים חשבון, לינק לאיפוס נשלח זה עתה.",
"a.forgotSub": "קבל לינק לאיפוס באימייל.",
"a.forgotTitle": "שכחת סיסמה",
"a.googleContinue": "המשך עם Google",
"a.googleSignup": "הירשם עם Google",
"a.haveAccount": "כבר שותף?",
"a.legalHint": "נדרש לשירותי חשבונית אלקטרונית בצרפת (Factur-X) של מוסדות צרפתיים.",
"a.legalRequiredFR": "מספר SIRET ומספר מע”מ בתוך האיחוד האירופי הם חובה בצרפת.",
"a.loggingIn": "מתחבר…",
"a.login": "חיבור",
"a.loginSub": "גשת לחלל הניהול שלך.",
"a.loginTitle": "חיבור שותף",
"a.min6": "מינימום 6 תווים",
"a.newPassword": "סיסמה חדשה",
"a.noAccount": "עדיין לא שותף?",
"a.or": "או",
"a.org": "שם המוסד",
"a.password": "סיסמה",
"a.passwordMismatch": "הסיסמאות אינן תואמות.",
"a.referral": "קוד הפנייה (אופציונלי)",
"a.registerSub": "צרו את החלל שלכם בדקה אחת — חינם להתחלה.",
"a.registerTitle": "הפוך לשותף",
"a.rememberMe": "זכור אותי",
"a.reset": "איפוס",
"a.resetSub": "בחר סיסמה חדשה לחשבון שלך.",
"a.resetTitle": "סיסמה חדשה",
"a.sendLink": "שלח את הלינק",
"a.sending": "שולח…",
"a.signin": "התחברות",
"a.siret": "SIRET",
"a.vat": "מס ערך מוסף בתוך האיחוד האירופי.",
"ac.africa": "אפריקה",
"ac.boostActive": "הבלט פעיל —",
"ac.boostSub": "הופע בראש מדריך השותפים עם תווית “בתוספת”.",
"ac.boostTitle": "שדרג את הרישום שלך במדריך",
"ac.categoryHint": "כדי לסווג את המוסד שלך במדריך findloop.",
"ac.choose": "בחר",
"ac.cityHint": "לעמדה מדויקת במפה הציבורית.",
"ac.cityLabel": "עיר המוסד",
"ac.cityPh": "פריז",
"ac.contact": "פרטי התקשרות",
"ac.converted": "מומר",
"ac.copyDeclLink": "העתק את לינק ההצהרה",
"ac.copyLink": "העתק את הלינק",
"ac.currentPlan": "תכנית נוכחית",
"ac.emailDesc": "בחר את האימיילים שתרצה לקבל. התראות במקום העבודה שלך תמיד נשארות פעילות.",
"ac.emailMatch": "תואם",
"ac.emailMatchDesc": "אימייל כאשר פריט תואם הצהרה",
"ac.emailNewDecl": "הצהרות אובדן חדשות",
"ac.emailNewDeclDesc": "מייל ברגע שלקוח מדווח על אובדן במקום שלך",
"ac.emailShip": "בקשות משלוח",
"ac.emailShipDesc": "מייל כאשר לקוח מבקש לשלוח פריט",
"ac.emailTitle": "העדפות דואר אלקטרוני",
"ac.expireSoon": "ההדגשה שלך תפג תוקף בקרוב —",
"ac.exportCsv": "ייצוא (CSV)",
"ac.exportHint": "ייצא את התשלומים החיצוניים המאומתים שלך לצורך הנהלת חשבונות.",
"ac.free": "חינם",
"ac.freeMonths": "חודשים בחינם",
"ac.hours": "שעות",
"ac.howItWorks": "איך זה עובד?",
"ac.invited": "מוזמן",
"ac.legalFR": "דרוש למתן חשבוניות אלקטרוניות (Factur-X) שיתקף החל מספטמבר 2026.",
"ac.legalMissing": "⚠️ SIRET ומע''מ פנימי של האיחוד האירופי חסרים — השלם אותם כדי לשמור על תאימות עם חשבוניות אלקטרוניות.",
"ac.legalOther": "מומלץ עבור החשבוניות שלך.",
"ac.legalPartnerQr": "קוד QR",
"ac.legalTitle": "זיהויים חוקיים (חשבונית)",
"ac.logoTitle": "לוגו המוסד",
"ac.modeCurrent": "מצב נוכחי:",
"ac.modeExternal": "חיצוני (אימות ידני)",
"ac.modeInternal": "פנימי Findloop (אוטומטי)",
"ac.noSubReceipt": "עדיין אין תשלום מנוי שמשולמת.",
"ac.none": "שום דבר",
"ac.onYourListing": "ברשימה שלך",
"ac.pay1": "שמור את קישורי התשלום שלך למטה כדי להפנות את הלקוחות שלך למערכת האיסוף שלך.",
"ac.pay2": "האימות הופך לידני: אתה מאשר את קבלת התשלום מהטאב “הצהרות”.",
"ac.pay3": "קישור “דמי משלוח” הוא תשלום מאוחד (איסוף + משלוח).",
"ac.pay4": "השאר את השדות ריקים כדי להשתמש בתשלום הפנימי של Findloop (Stripe) עם אימות אוטומטי.",
"ac.paySub": "גבייה באמצעות מערכת התשלום שלך.",
"ac.payTitle": "תשלומים חיצוניים",
"ac.permissive": "סלחני",
"ac.phone": "טלפון",
"ac.posterA4": "פוסטר A4 (PDF)",
"ac.qMessage": "הודעה (אופציונלי)",
"ac.qName": "ש name",
"ac.qOrg": "ארגון",
"ac.qSites": "מספר המוסדות (מוערך)",
"ac.qrHint": "הלקוחות שלך סורקים קוד זה כדי לדווח על פריט שאבד.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "קוד QR של השותף שלך",
"ac.quoteDesc": "נמלי תעופה, רשתות רכבת, רשתות בינלאומיות · ",
"ac.quoteEurope": "אירופה / עולם",
"ac.quoteSent": "בקשת הצעת מחיר נשלחה. הצוות שלנו יחזור אליך בקרוב.",
"ac.quoteTitle": "בקש הצעת מחיר — עסק",
"ac.recoveryLink": "קישור “דמי איסוף”",
"ac.refSub": "כל שותף שהופנה המנוי נותן לך חודש חינם אחד.",
"ac.refTitle": "הפנה, הרווח חודש חינם",
"ac.reminderDelay": "עיכוב תזכורת לאימות",
"ac.reminderHint": "תקבל מייל תזכורת אם תשלום חיצוני נשאר לא מאומת מעבר לעיכוב זה (ברירת מחדל: 48שעה).",
"ac.renewDesc1": "זה כבר הרוויח לך",
"ac.renewDesc2": "חדש כדי להישאר למעלה במדריך ולא לאבד את הנראות הזאת.",
"ac.renewNow": "חדש עכשיו",
"ac.requestQuote": "בקש הצעת מחיר",
"ac.saveLegal": "שמור את הזיהויים",
"ac.saveLinks": "שמור את הקישורים",
"ac.sendRequest": "שלח את הבקשה שלי",
"ac.sending": "נשלח…",
"ac.shippingLink": "קישור “דמי משלוח” (מאוחד)",
"ac.shippingLinkHint": "קישור זה מכסה גם את האיסוף וגם את המשלוח.",
"ac.strict": "מחמיר",
"ac.subReceipt": "קבלת מנוי (PDF)",
"ac.subReceiptsSub": "הורד את קבלת ה-PDF עבור כל תשלום מנוי.",
"ac.subReceiptsTitle": "קבלות מנוי",
"ac.tCategory": "קטגוריה נשמרה",
"ac.tCity": "עיר נשמרה — המפה עודכנה",
"ac.tCityNeeded": "הכנס עיר",
"ac.tCopied": "הועתק!",
"ac.tCover": "תמונת כיסוי עודכנה",
"ac.tEmailPrefs": "העדפות דוא\"ל עודכנו",
"ac.tErr": "שגיאה",
"ac.tExportImpossible": "ייצוא נכשל",
"ac.tLegal": "זיהויים חוקיים נשמרו",
"ac.tLegalNeeded": "SIRET ומע\"מ נדרשים עבור צרפת",
"ac.tLogo": "לוגו עודכן",
"ac.tLogoRemoved": "לוגו הוסר",
"ac.tPayLinks": "לינקים לתשלום נשמרים",
"ac.tPhone": "טלפון נשמר",
"ac.tSensitivity": "רגישות נשמרה",
"ac.tVatInvalid": "מספר מע\"מ לא חוקי",
"ac.tVatValid": "מע\"מ חוקי",
"ac.tabBoost": "נראות",
"ac.tabPayments": "תשלומים",
"ac.tabProfile": "פרופיל",
"ac.tabQr": "QR ופלח",
"ac.tabReferral": "הפניה",
"ac.tabSub": "מנוי",
"ac.thisWeek": "השבוע",
"ac.thisWeekOf": " ({n} השבוע)",
"ac.thresholdDesc": "סף הביטחון שממנו ה-AI מאמת אוטומטית התאמה בתמונה ומודיעה ללקוח. גבוה יותר = פחות התאמות אוטומטיות אך יותר מהימנות.",
"ac.thresholdTitle": "רגישות התאמה חזותית של AI",
"ac.trend": "נטייה",
"ac.upload": "העלה",
"ac.vatValidFmt": "מע\"מ חוקי{name} ({via})",
"ac.vatVerified": "מע\"מ פנימי לאיחוד האירופי אומת",
"ac.verifyVat": "אמת מע\"מ (VIES)",
"ac.verifying": "מאמת…",
"ac.views": "צפיות",
"ac.viewsTotal": "צפיות שהושגו (סה\"כ)",
"ac.winbackBtn": "המשך עם -20%",
"ac.winbackDesc1": "זה הרוויח לך",
"ac.winbackDesc2": "הצעה מיוחדת: -20% מיושם אוטומטית אם תחRenew within 24h.",
"ac.winbackTitle": "ההדגשה שלך פגה — המשך ב-20%! ",
"ad.boost": "הגדל",
"ad.close": "סגור",
"ad.closeConfirm": "לסגור את הרשימה הזו?",
"ad.closed": "הרשימה נסגרה",
"ad.edit": "ערוך",
"ad.editTitle": "ערוך רשימה",
"ad.saved": "הרשימה עודכנה",
"an.allCountries": "כל המדינות",
"an.badge": "פריטים אבודים",
"an.boostLater": "מאוחר יותר",
"an.boostNow": "הגדל עכשיו",
"an.boostPrompt": "הגדל את הרשימה שלך כדי למקם אותה בראש ולקבל מציאות מהר יותר.",
"an.boosted": "הוגדל",
"an.contact": "מצאתי פריט זה",
"an.contactTitle": "דווח שמצאת פריט זה",
"an.copyFailed": "לא ניתן היה להעתיק את הקישור",
"an.copyLink": "העתק קישור",
"an.country": "מדינה",
"an.date": "תאריך אובדן",
"an.finderEmail": "המייל שלך",
"an.finderName": "השם שלך",
"an.finderPhone": "הטלפון שלך",
"an.geoBanner": "אתה צופה ברשימות ב",
"an.geoBannerWorld": "אתה צופה ברשימות ברחבי העולם",
"an.geoChange": "שנה מדינה",
"an.goAccount": "לך אל החשבון שלי",
"an.linkCopied": "הקישור הועתק!",
"an.loginRequired": "התחבר כדי לדווח על הפריט ולבצע מעקב אחרי ההחזרה.",
"an.loginToBoost": "התחבר כדי להעלות את הרשימה הזו",
"an.lostAt": "נאבד ב",
"an.message": "הודעה (אופציונלי)",
"an.none": "אין רשימה עדיין.",
"an.photo": "תמונה (אופציונלי)",
"an.post": "פרסם רשימה",
"an.postSubtitle": "תאר את הפריט שאבד — הקהילה והשותפים שלנו יעזרו לך למצוא אותו.",
"an.postTitle": "דווח על פריט אבוד",
"an.publish": "פרסם רשימה",
"an.published": "הרשימה פורסמה!",
"an.publishing": "מתפרסם…",
"an.remaining": "נותר",
"an.requestInProgress": "בקשה בתהליך",
"an.resolved": "הפריט כברRecovered",
"an.reward": "פרס",
"an.searchPh": "חפש רשימה…",
"an.send": "שלח",
"an.sent": "ההודעה נשלחה לבעלים!",
"an.shareConsent": "אני מסכים שפרטי הקשר שלי (שם, מייל, טלפון) עשויים להיות משותפים עם בעל הפריט.",
"an.shareConsentError": "אנא סמן את התיבה כדי לשתף את פרטי הקשר שלך.",
"an.sortRecent": "הכי חדש",
"an.sortRelevance": "רלוונטיות",
"an.subtitle": "גלול בין פריטים שדווחו כאבודים על ידי הקהילה. מצאת אחד מהם?",
"an.title": "רשימות פריטים אבודים",
"anf.badge": "פריטים שנמצאו",
"anf.claim": "זה שלי",
"anf.claimSent": "הודעה נשלחה למוצא!",
"anf.claimTitle": "דווח שזה הפריט שלך",
"anf.consent": "אני מסכים שהבעלים יראו את פרטי הקשר שלי כדי לשחזר את הפריט שלהם.",
"anf.foundAt": "נמצא ב",
"anf.foundDate": "תאריך נמצא",
"anf.loginCta": "התחבר / צור חשבון",
"anf.loginDesc": "חשבון מוצא נחוץ כדי לפרסם רשימה ולהרוויח נקודות Finder Hero.",
"anf.loginRequired": "התחבר כדי לפרסם פריט שנמצא",
"anf.photo": "תמונת פריט",
"anf.pointsEarned": "תודה! הרווחת עכשיו נקודות Finder Hero.",
"anf.pointsPending": "הנקודות שלך יזוכו תוך 24 שעות, לאחר אימות.",
"anf.post": "פרסם פריט שנמצא",
"anf.postSubtitle": "תאר את הפריט שמצאת — עזור לבעליו לקבל אותו חזרה.",
"anf.postTitle": "דווח על פריט שנמצא",
"anf.publishFound": "פרסם רשימה שנמצאה",
"anf.published": "רשימת פריט שנמצא פורסמה",
"anf.publishedAs": "פורסם כ",
"anf.shareConsent": "אני מסכים שפרטי הקשר שלי (שם, מייל, טלפון) עשויים להיות משותפים עם האדם שמצא את הפריט.",
"anf.subtitle": "גלול בין פריטים שנמצאו ודווחו על ידי הקהילה. הכרת את שלך?",
"anf.title": "רשימות פריטים שנמצאו",
"bo.active": "העלאה פעילה",
"bo.africaPrice": "מחיר מועדף לאזור אפריקה חל",
"bo.pay": "שלם והעלה",
"bo.remaining": "זמן שנותר",
"bo.renew": "חדש שדרוג",
"bo.since": "מאז שדרוג",
"bo.subtitle": "שים את הרישום שלך בראש הרשימה עם תווית גלויה.",
"bo.title": "שדרוג רישום",
"c.all": "כל",
"c.cancel": "ביטול",
"c.close": "סגירה",
"c.confirm": "אישור",
"c.confirmed": "מאושר",
"c.download": "הורדה",
"c.loading": "טוען…",
"c.reset": "איפוס",
"c.reviews": "ביקורות",
"c.save": "שמירה",
"c.transfer": "העברה",
"cat.Animal": "חיית מחמד / אביזר לחיית מחמד",
"cat.AppareilPhoto": "מצלמה",
"cat.Argent": "כסף / מזומן",
"cat.Autres": "אחר",
"cat.Bijoux": "תכשיטים",
"cat.CarteBancaire": "כרטיס בנק",
"cat.CarteIdentite": "תעודת זהות / דרכון",
"cat.Casquette": "כובע",
"cat.Ceinture": "חגורה",
"cat.Chargeur": "מטען / כבל",
"cat.Chaussures": "נעליים",
"cat.CleVoiture": "מפתח רכב",
"cat.Cles": "מפתחות",
"cat.Console": "קונסולת משחקים",
"cat.Documents": "מסמכים",
"cat.Echarpe": "צעיף",
"cat.Ecouteurs": "אוזניות",
"cat.Electronique": "אלקטרוניקה (אחר)",
"cat.Enceinte": "רמקול",
"cat.Gants": "כפפות",
"cat.Gourde": "בקבוק מים / flask",
"cat.Instrument": "כלי נגינה",
"cat.Jouet": "צעצוע / בובת פרווה",
"cat.Jumelles": "משקפת",
"cat.Lampe": "מנורה / פנס",
"cat.Liseuse": "קורא ספרים",
"cat.Livre": "ספר / מחברת",
"cat.Lunettes": "משקפיים",
"cat.Manteau": "מעיל",
"cat.Maquillage": "תיק איפור",
"cat.Medical": "ציוד רפואי",
"cat.Medicaments": "תרופות",
"cat.Montre": "שעון / שעון חכם",
"cat.Ordinateur": "מחשב נייד",
"cat.Parapluie": "מטרייה",
"cat.Portefeuille": "ארנק",
"cat.Poussette": "עגלת תינוק / אביזר לתינוק",
"cat.Sac": "תיק / תיק יד",
"cat.SacADos": "תיק גב",
"cat.Souris": "עכבר / מקלדת",
"cat.Sport": "ציוד ספורט",
"cat.Tablette": "טבלט",
"cat.Telephone": "טלפון / סמארטפון",
"cat.Trottinette": "סקטור",
"crop.title": "גזור את תמונת הכיסוי",
"cta.button": "צור חשבון שותף",
"cta.subtitle": "הצטרף למוסדות שמחזירים פריטים במהירות עם findloop.",
"cta.title": "מוכן להפחית פריטים אבודים?",
"db.account.s": "נהל את המוסד שלך, מנוי וקוד QR.",
"db.account.t": "החשבון שלי",
"db.declarations.s": "לקוחות שדיווחו על פריט אבוד דרך קוד ה-QR שלך.",
"db.declarations.t": "דיווחי אובדן",
"db.deposit.s": "הוסף תמונה, קטגוריה ותיאור.",
"db.deposit.t": "דווח על פריט נמצא",
"db.registry.s": "כל הפריטים שנמצאו שנרשמו במוסד שלך.",
"db.registry.t": "רשימת פריטים",
"db.reviews.s": "ענו באופן פומבי על ביקורות הלקוחות שלכם.",
"db.reviews.t": "ביקורות לקוחות",
"db.shipments.s": ".generate תוויות ועקוב אחרי חבילות לשליחה.",
"db.shipments.t": "משלוחים",
"db.stats.s": "המדדים המרכזיים שלך.",
"db.stats.t": "סטטיסטיקות",
"db.team.s": "הזמן את העמיתים שלך לנהל פריטים.",
"db.team.t": "צוות",
"dc.partnerDesc": "אבדת את הפריט שלך במקום שותף (מלון, תחנה, אולם…)? בחר אותו להחזרה ישירה.",
"dc.partnerList": "בחר מרשימה",
"dc.partnerMap": "בחר על המפה",
"dc.partnerTitle": "דיווח בשותף",
"dc.publicCta": "פרסם מודעה פומבית",
"dc.publicDesc": "המודעה שלך תהיה גלויה לכלל קהילת findloop. אידיאלי אם אינך יודע היכן איבדת את הפריט.",
"dc.publicTitle": "הכרזה פומבית",
"dc.subtitle": "בחר כיצד לדווח על הפריט האבוד שלך.",
"dc.title": "מה תרצה לעשות?",
"dec.addrPending": "כתובת ממתינה מהלקוח",
"dec.analyzing": "מנתחים…",
"dec.badge": "דיווח אובדן",
"dec.category": "קטגוריית פריט",
"dec.clientDescription": "תיאור הלקוח",
"dec.clientPhoto": "תמונה שסיפק הלקוח",
"dec.clientPhotoShort": "תמונת הלקוח",
"dec.comparePhotos": "השווה תמונות",
"dec.contactTitle": "פרטי הקשר שלך",
"dec.date": "תאריך אובדן",
"dec.declaredItemPhoto": "תמונה של הפריט המוצהר",
"dec.descPh": "תאר את הפריט: מותג, צבע, סימנים ייחודיים…",
"dec.description": "תיאור",
"dec.email": "אימייל",
"dec.emptyDesc": "שיתף את קוד ה-QR שלך כדי לקבל דיווחים.",
"dec.emptyTitle": "אין דיווחים",
"dec.enlarge": "הגדל",
"dec.extBanner": "{n} תשלום(ים) חיצוניים לאישור — אשר קבלה למטה לפתיחת מסירה או משלוח.",
"dec.foundItemAlt": "פריט נמצא",
"dec.foundItemRegistry": "פריט נמצא (רישום)",
"dec.home": "חזור לבית",
"dec.labelClient": "לקוח",
"dec.labelRegistry": "רישום",
"dec.matchFound": "התאמה כבר זוהתה!",
"dec.name": "שם מלא",
"dec.noMatchYet": "אין התאמה עדיין.",
"dec.noPhoto": "אין תמונה",
"dec.notfound": "שותף לא נמצא.",
"dec.pRecup": "שחזור",
"dec.pRecupP": "(שחזור)",
"dec.pRecupShip": "(שחזור + משלוח)",
"dep.fillAI": "מלא עם AI",
"dep.optional": "(אופציונלי)",
"dep.photo": "תמונת פריט",
"dep.principal": "ראשי",
"dep.reqError": "קטגוריה ותיאור נדרשים.",
"dep.savedItem": "פריט שנרשם",
"dep.similarity": "דמיון",
"dep.storage": "מיקום פיזי",
"dep.storageHint": "איפה הפריט מאוחסן פיזית. קוד QR יווצר כדי למצוא אותו.",
"dep.storagePlaceholder": "למשל, מדף A3, תיבת 12, כספת בקבלה",
"dl.aClient": "לקוח",
"dl.alertsBlocked": "התראות בדפדפן חסומות",
"dl.alertsBlockedHint": "כדי להפעיל מחדש: לחץ על האייקון 🔒 (או ⓘ) משמאל לכתובת האתר, ואז אפשר התראות וטען מחדש את העמוד.",
"dl.amountDue": "סכום לתשלום: {amount} {currency}.",
"dl.enableAlerts": "הפעל התראות",
"dl.extPending": "תשלומים לאישור",
"dl.freemiumNear": "אתה מתקרב למגבלת Freemium ({used}/{max} פריטים החודש). שדרג ל-Starter עבור פריטים ללא הגבלה.",
"dl.freemiumReached": "מגבלת Freemium הצלחה ({used}/{max} פריטים החודש). שדרג ל-Starter כדי לרשום פריטים ללא הגבלה.",
"dl.invoiceOverdue": "חשבונית {num} לא שולם — גישה מוגבלת.",
"dl.matchNotifTitle": "Findloop — התאמת AI חדשה 🔔",
"dl.matchToast": "התאמת AI חדשה — {name}",
"dl.matchToastDesc": "פריט תואם הצהרה.",
"dl.notifEmpty": "אין התראות עדיין.",
"dl.notifEnabled": "התראות בדפדפן מופעלות",
"dl.notifTitle": "התראות",
"dl.payInvoice": "שלם את החשבונית שלי →",
"dl.rewardsPending": "שוברי תשלום להציג",
"dl.upgradeStarter": "שדרג ל-Starter →",
"est.all": "כל המוסדות ({n})",
"est.label": "מוסד",
"est.primary": "ראשי",
"est.secondary": "משני",
"est2.add": "הוסף מוסד",
"est2.addressLabel": "כתובת",
"est2.addressPh": "רחוב 12 רפובליקה",
"est2.autoInvoice": "חשבונית מפורטת נוצרת אוטומטית ב-1 לכל חודש.",
"est2.baseSub": "מנוי בסיסי",
"est2.billing": "חBilling",
"est2.boostActivated": "הגברת פעילה עבור {name}",
"est2.boostBillingNote": "חויב לפי השיעור הנוכחי ומאוחד בחשבונית החודשית שלך.",
"est2.boostCta": "הגברת",
"est2.boostDesc": "שפר את הנראות של מוסד זה במדריך ובמפה.",
"est2.boostDuration": "{h}ש שעות נראות מוגברת",
"est2.boostExtend": "הארך",
"est2.boostTitle": "הגבר את {name}",
"est2.boosted": "מוגבר",
"est2.chartDesc": "חלק הפריטים שהוחזרו מתוך הסך הכולל שנרשם, אתר אחר אתר.",
"est2.chartTitle": "שיעור ההחזרה לפי מוסד",
"est2.chartTooltip": "החזרה",
"est2.cityLabel": "עיר",
"est2.cityPh": "ליון",
"est2.contactHint": "פרטים אלו מוצגים ללקוח עבור מוסד זה (יחזור לחשבון אם ריק).",
"est2.countryLabel": "מדינה",
"est2.coverLabel": "תמונת כיסוי",
"est2.create": "צור",
"est2.created": "המוסד נוצר",
"est2.delete": "מחק",
"est2.deleteDesc": "פעולה זו קבועה. אתה יכול למחוק מוסד רק אם אין בו פריטים.",
"est2.deleteTitle": "מחק “{name}”?",
"est2.deleted": "המוסד נמחק",
"est2.dialogDesc": "הכנס את השם והכתובת של האתר הזה.",
"est2.edit": "ערוך",
"est2.editEst": "ערוך מוסד",
"est2.emailLabel": "דוא\"ל ליצירת קשר",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " מוסד(ים)",
"est2.extraNoteBase": "{n} מוסד(ים) נוספים יחויבו",
"est2.extraPrice": " ב{price} €/לחודש.",
"est2.extraQuote": " על פי הצעת מחיר.",
"est2.imgChange": "בחר תמונה",
"est2.imgDone": "בוצע",
"est2.imgRemove": "הסר",
"est2.imgRemoved": "תמונה הוסרה",
"est2.imgSaved": "תמונה נשמרה",
"est2.imgUploading": "מעלה…",
"est2.includedPlan": "כלול בתוכנית שלך: {n}.",
"est2.kDeclarations": "הצהרות",
"est2.kInStorage": "במחסן",
"est2.kItemsTotal": "פריטים (במלואם)",
"est2.kRestituted": "חזר",
"est2.limitReached": "התגובה הושגה",
"est2.logoLabel": "לוגו",
"est2.mDeclar": "הצה.",
"est2.mItems": "פריטים",
"est2.mRestituted": "חזר",
"est2.mStorage": "במחסן",
"est2.monthlyTotal": "סך חודשי",
"est2.nameLabel": "שם *",
"est2.namePh": "למשל: מלון בלמונט — סניף ליון",
"est2.newEst": "מוסד חדש",
"est2.onQuote": "על פי הצעת מחיר",
"est2.phoneLabel": "טלפון",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "תוכנית",
"est2.planLimited": "התוכנית שלך “{tier}” מוגבלת ל{max} מוסד(ים).",
"est2.primary": "ראשי",
"est2.qr": "קוד QR",
"est2.qrDesc": "הצג קוד QR זה במוסד הזה. לקוחות המדווחים על אובדן יחוברו לאתר הזה.",
"est2.qrTitle": "קוד QR — {name}",
"est2.saving": "שמור…",
"est2.seeInvoices": "ראה את החשבוניות החודשיות שלי",
"est2.seePlans": "ראה את התוכניות",
"est2.subtitle": "נהל את כל האתרים שלך בחשבון אחד — תצוגה מאוחדת, פריטים, קוד QR וחיוב.",
"est2.suspended": "מושעים",
"est2.tierFree": "1 מוסד",
"est2.tierLarge": "מוסדות בלתי מוגבלים",
"est2.tierMedium": "5 מוסדות כלולים",
"est2.tierSmall": "3 מוסדות כלולים",
"est2.title": "מוסדות",
"est2.unlimitedPlan": "התוכנית שלך מאפשרת מספר בלתי מוגבל של מוסדות.",
"est2.unlimitedSuffix": " · בלתי מוגבל",
"est2.updated": "המוסד עודכן",
"est2.upgradeHint": "שדרג לתוכנית גבוהה יותר כדי להוסיף יותר אתרים ולרכז את כל הפעילות שלך.",
"est2.visuals": "לוגו ותמונה",
"est2.visualsDesc": "התאם אישית את הלוגו ותמונת השער של המוסד הזה. הם מופיעים בדף הציבורי ובטופס ההצהרה שלו.",
"est2.visualsTitle": "חזותיות — {name}",
"est2.workOn": "עבוד על מוסד זה",
"est2.working": "אתה עובד על “{name}”",
"ev.created": "דו\"ח נוצר",
"ev.matched": "פריט תואם זוהה",
"ev.paid": "דמי שיקום שולמו",
"ev.pickup": "איסוף במקום",
"ev.shipped": "החבילה נשלחה",
"ev.shipping_paid": "דמי משלוח שולמו",
"ev.shipping_requested": "בקשת משלוח",
"feat1.d": "מדדי ביצוע, שיעור החזר לפי קטגוריה, הכנסות ומגמות של 30 יום.",
"feat1.t": "לוח מחוונים & ניתוחים",
"feat2.d": "תוויות, מעקב מטען ודוא\"ל מעקב אוטומטי.",
"feat2.t": "מודול משלוחים",
"feat3.d": "לקוחות מוצאים אותך לפי עיר וקטגוריה, עם ביקורות מאושרות.",
"feat3.t": "מדריך ציבורי & ביקורות",
"fp.backToRanking": "חזרה לדירוג",
"fp.badge": "תג",
"fp.hero": "גיבור המוצא",
"fp.notFound": "פרופיל לא נמצא או פרטי.",
"fp.scoreTotal": "סך נקודות",
"fp.scoreYear": "נקודות ב",
"fp.share": "שתף פרופיל זה",
"fp.shareText": "צפה בפרופיל המוצא של {name} ב-findloop!",
"fp.tagline": "מוצא ישר שעושה את העולם מקום טוב יותר.",
"ft.backAccount": "חזרה לחשבון שלי",
"ft.closeBtn": "סגור את המקרה",
"ft.closeConfirm": "לאשר שהפריט הוחזר? המודעות תיסגר.",
"ft.closeLockedHint": "אמת את קוד הבעלים קודם כדי לפתוח סגירה.",
"ft.closed": "המקרה נסגר — הפריט הוחזר!",
"ft.codeLabel": "הכנס את קוד האימות שהתקבל מהבעלים",
"ft.codeNeeded": "אנא הכנס את קוד האימות.",
"ft.codeOk": "הקוד אומת — אתה יכול לסגור את המקרה.",
"ft.codePlaceholder": "למשל 4821",
"ft.codeVerified": "מאומת",
"ft.doneMsg": "הפריט הוחזר. תודה על העזרה בהחזרתו לבעליו!",
"ft.stepInProgress": "החזרה בתהליך",
"ft.stepPublished": "מודעה פורסמה",
"ft.stepReturned": "הפריט הוחזר",
"ft.subtitle": "עקוב אחרי הצעדים עד שהפריט שנמצא יוחזר.",
"ft.title": "מעקב החזרה",
"ft.verifyBtn": "אמת קוד",
"hero.badge": "מומלץ",
"hero.ctaFound": "מצאתי פריט",
"hero.ctaLost": "איבדתי פריט",
"hero.ctaPartner": "הפוך לשותף",
"hero.subtitle": "Findloop עוזר למוסדות לנהל פריטים שנמצאו — ומאפשר ללקוחות שלהם לדווח על אובדן ואז לשחזר את רכושם, במקום או על ידי משלוח.",
"hero.title": "כל פריט אבוד מוצא את בעליו.",
"home.champBecome": "הפוך למוצא",
"home.champCta": "ראה דירוג",
"home.champSubtitle": "כל פריט מוחזר מקבל נקודות. הצטרף לדירוג וזכה בפרסים.",
"home.champTitle": "המוצאים שלנו",
"how.eyebrow": "איך זה עובד",
"how.title": "ממקום השארה להחזרה, ללא מאמץ.",
"inv.all": "כל",
"inv.allYears": "כל השנים",
"inv.count": "חשבוניות",
"inv.due": "מגיע",
"inv.empty": "אין חשבוניות עדיין.",
"inv.exportCsv": "ייצוא CSV",
"inv.invoicePdf": "חשבונית PDF",
"inv.issued": "נפלטה",
"inv.noMatch": "אין חשבונית עבור הפילטר הזה.",
"inv.paid": "שולם (€)",
"inv.paidOn": "שולם ב",
"inv.pay": "שלם",
"inv.receipt": "קבלה",
"inv.reminders": "תזכורות",
"inv.remindersDesc": "תזכורות בדואר אלקטרוני וב-SMS נשלחו עבור חשבונית זו.",
"inv.remindersEmpty": "לא נשלחה תזכורת.",
"inv.rmDue": "תזכורת מועד פירעון",
"inv.rmManual": "תזכורת ידנית",
"inv.rmSms": "תזכורת SMS ד+30",
"inv.rmStage": "תזכורת",
"inv.statusPaid": "שולם",
"inv.statusUnpaid": "לא שולם",
"inv.subtitle": "צפה בהורד את החשבוניות והקבלות שלך.",
"inv.title": "החשבוניות שלי",
"inv.unpaid": "לא שולם (€)",
"inv2.contractTitle": "החוזה שלי עם Findloop",
"inv2.detailByEst": "פרטים לפי מוסד",
"inv2.dueLabel": "מועד פירעון:",
"inv2.dueSuffix": " · עד {date}",
"inv2.error": "שגיאה {status}",
"inv2.estCountIssued": "{n} מוסד(ים) · הונפקה ב-{date}",
"inv2.estimate": "הערכה (לא נגבה) · {n} מוסד(ים)",
"inv2.expired": " · פג תוקף",
"inv2.exportCsv": "ייצוא CSV",
"inv2.exportDone": "ייצוא CSV שהורד",
"inv2.included": "כולל",
"inv2.monthlyTitle": "חיוב חודשי (מנוי)",
"inv2.months": "+{n} חודשים",
"inv2.paid": "שולם",
"inv2.pay": "שלם",
"inv2.previewTitle": "תצוגה מקדימה של החשבונית הבאה שלך —",
"inv2.renew": "חדש את החוזה שלי",
"inv2.renewalsTitle": "היסטוריית חידושים ({n})",
"inv2.renewedUntil": "החוזה הוארך עד {date}",
"inv2.serviceTitle": "חשבוניות שירות (שחזורים וציטוטים)",
"inv2.soon": "פג תוקף בקרוב",
"inv2.toPay": "לתשלום",
"inv2.totalHtTva": "סכום כולל ללא מע\"מ · מע\"מ",
"inv2.totalTtc": "סכום כולל עם מע\"מ",
"iu.addPhoto": "הוסף תמונה",
"iu.change": "שנה",
"lang.label": "שפה",
"lb.allCountries": "כל המדינות",
"lb.badge": "לוח זמנים שנתי",
"lb.champion": "🏆 אלוף השנה",
"lb.cityPh": "סנן לפי עיר…",
"lb.empty": "אין דירוג עבור סינונים אלה עדיין.",
"lb.pts": "נקודות",
"lb.resetNote": "לוח המובילים של השנה הנוכחית — מת-reset בכל 1 בינואר.",
"lb.returned": "הוחזר",
"lb.share": "שתף את לוח המובילים",
"lb.shareText": "בדוק את לוח המובילים של המוצאים הטובים ביותר ב-findloop!",
"lb.subtitle": "כל החזרה מקנה נקודות. לוח המובילים מת-reset בכל 1 בינואר.",
"lb.tabFinders": "מוצאים",
"lb.tabPartners": "מוסדות",
"lb.title": "המוצאים הטובים ביותר",
"lost.b2bDesc": "איבדת את זה במלון, במרכז תחבורה או במקום שותף? מצא את המוסד ודווח על האובדן שלך.",
"lost.b2bTitle": "דווח לשותף",
"lost.b2cDesc": "פרסם מודעה גלויה לכולם, הצע פרס וקדמו אותה כדי להגדיל את הסיכויים שלך.",
"lost.b2cTitle": "פרסם מודעה ציבורית",
"lost.desc": "בחר כיצד תרצה להמשיך.",
"lost.title": "איבדת פריט?",
"map.allCategories": "כל הקטגוריות",
"map.clear": "אפס",
"map.exitFullscreen": "יציאה",
"map.filterCity": "עיר או מדינה…",
"map.fullscreen": "מסך מלא",
"map.heatmap": "מפת חום",
"map.high": "גבוה",
"map.impactMonth": "פריטים מוחזרים החודש",
"map.impactTotal": "כולל מוחזרים",
"map.legend": "נקודות צבעוניות אדומות (נמוך) עד ירוקות (גבוה) בהתאם לשיעור ההחזרה; גודל בהתבסס על מספר הפריטים.",
"map.locating": "מאתר… הוסף כתובת למוסדות שלך כדי לראותם על המפה.",
"map.low": "נמוך",
"map.mAll": "הכל",
"map.mFound": "נמצא",
"map.mLost": "אבד",
"map.medium": "בינוני",
"map.noItemRegistered": "לא נרשם פריט",
"map.noItems": "לא קיים פריט",
"map.period30": "30 הימים האחרונים",
"map.period7": "7 הימים האחרונים",
"map.period90": "90 הימים האחרונים",
"map.periodAll": "כל הזמן",
"map.returnedSuffix": "מוחזר · {a}/{t} פריטים",
"map.stats": "סטטיסטיקות עירוניות",
"map.statsTop": "5 המקומות המובילים (פריטים אבודים)",
"map.statsTrend": "מגמת 6 חודשים",
"map.title": "מפה של המוסדות שלך",
"map.topPlaces": "מקומות פופולריים",
"mc.adClosed": "רשימה סגורה",
"mc.addPhoto": "הוסף תמונה",
"mc.adsNone": "אין מודעת פריט אבוד.",
"mc.archiveHide": "הסתר היסטוריה",
"mc.archiveNone": "אין מקרה שנפתר עדיין.",
"mc.archiveShow": "הצג היסטוריה",
"mc.archiveSub": "מקרים שנפתרו והוחזרו.",
"mc.archiveTitle": "היסטוריה",
"mc.at": "ב",
"mc.backToLogin": "חזור להתחברות",
"mc.boostContacts": "פרטי קשר (שדרוג)",
"mc.boostViews": "צפיות (שדרוג)",
"mc.cancel": "בטל",
"mc.certificate": "תעודה",
"mc.changePhoto": "שנה תמונה",
"mc.city": "עיר",
"mc.closeAd": "סגור",
"mc.closeAdConfirm": "לסגור רשימה זו? היא לא תהיה נראית יותר ותפנה מקום.",
"mc.confirmPassword": "אשר סיסמה",
"mc.confirmRestitution": "אשר החזרה",
"mc.connect": "חבר",
"mc.contacts": "פרטי קשר",
"mc.country": "מדינה",
"mc.declareFound": "דווח על פריט שנמצא",
"mc.declareFoundSub": "פרסם פריט שמצאת",
"mc.declareLost": "דווח על אובדן",
"mc.declareLostSub": "פרסם רשימת פריט אבוד",
"mc.deleteAccount": "מחק את החשבון שלי",
"mc.deleteConfirm": "כן, מחק את החשבון שלי",
"mc.deleteConfirmBody": "החשבון שלך ימחק לצמיתות ונתוניך האישיים יאנונימיזו. פעולה זו אינה ניתנת לביטול.",
"mc.deleteConfirmTitle": "מחק את החשבון שלך?",
"mc.deleteDesc": "מוחק את החשבון שלך לצמיתות ומאיין את הנתונים האישיים שלך. פעולה זו אינה ניתנת לביטול.",
"mc.deleted": "החשבון שלך נמחק.",
"mc.deleting": "מוחק…",
"mc.email": "אימייל",
"mc.expiresOn": "מסתיים ב",
"mc.exportData": "הורד את הנתונים שלי (GDPR)",
"mc.exportDone": "הנתונים שלך הורדו.",
"mc.exporting": "מכין…",
"mc.finderAccepted": "מאושר",
"mc.finderProfile": "פרופיל Finder (אופציונלי)",
"mc.finderProfileDesc": "הרווח נקודות על ידי החזרת פריטים והופיע בלוח המודעות הציבורי.",
"mc.forYourAd": "למודעה שלך",
"mc.forgotLink": "שכחת את הסיסמה?",
"mc.forgotSend": "שלח את הקישור",
"mc.forgotSent": "אם קיים חשבון לאימייל הזה, קישור לאיפוס נשלח זה עתה.",
"mc.forgotTitle": "שכחתי סיסמה",
"mc.foundAdsNone": "לא פורסמה מודעה על פריט שנמצא.",
"mc.foundAt": "נמצא ב",
"mc.foundNone": "לא דווח על פריט שנמצא.",
"mc.hAd": "מודעת אובדן",
"mc.hDeclaration": "הצהרה",
"mc.hFinderContact": "פריט מדווח",
"mc.hFound": "פריט מוחזר",
"mc.hFoundAd": "מודעת פריט שנמצא",
"mc.histEarned": "פריט מוחזר",
"mc.historyTitle": "היסטוריית הנקודות שלי",
"mc.loginBtn": "התחבר",
"mc.loginTitle": "התחברות לקוח",
"mc.logout": "התנתק",
"mc.lostAt": "אבד ב",
"mc.matchPartner": "בשותף",
"mc.matchPublic": "פריט שנמצא",
"mc.matches": "התאמות",
"mc.matchesSub": "פריטים שנמצאו עשויים להתאים למודעות הפריטים האבודים שלך.",
"mc.myAds": "מודעות הפריטים האבודים שלי",
"mc.myDeclarations": "הדיווחים שלי",
"mc.myFinds": "פריטים שמצאתי",
"mc.myFindsNone": "עדיין לא דיווחת על מציאת פריט כלשהו.",
"mc.myFindsSub": "פריטים שדיווחת עליהם שמצאת במודעות הפריטים האבודים.",
"mc.myFound": "פריטים שנמצאו מדווחים",
"mc.myFoundAds": "מודעות הפריטים שנמצאו שלי",
"mc.myRewards": "השוברים שלי",
"mc.name": "שם מלא",
"mc.newPassword": "סיסמה חדשה",
"mc.none": "אין דיווח עדיין.",
"mc.notEnough": "נקודות לא מספיקות",
"mc.notifEmpty": "אין התראות עדיין.",
"mc.notifOpen": "צפה",
"mc.notifTitle": "התראות",
"mc.notifTrack": "מעקוב",
"mc.notifViewAd": "צפה במודעה",
"mc.optInDesc": "השתתפות אופציונלית. אתה מסכים להציג בפומבי את הפריטים שנבחרו למטה. ניתן לשנות בכל עת.",
"mc.optInTitle": "הופעה בלוח המודעות הציבורי",
"mc.password": "סיסמה",
"mc.passwordMismatch": "הסיסמאות אינן תואמות.",
"mc.phone": "טלפון",
"mc.photoUpdated": "תמונת פרופיל עודכנה",
"mc.pointsAwaiting": "נקודות ממתינות",
"mc.pointsBalance": "נקודות להוצאות",
"mc.pointsOk": "נקודות זכו",
"mc.presentHint": "הצג את קוד ה-QR הזה לשותף: הם סורקים אותו כדי לאמת את הפרס שלך.",
"mc.presentInStore": "הצג בחנות",
"mc.presentTitle": "הצג שובר זה",
"mc.privacy": "פרטיות ונתונים",
"mc.privacyDesc": "הורד עותק של כל הנתונים האישיים שיש ל-findloop לגביך (GDPR, סעיף 15 ו-20).",
"mc.profileSaved": "הפרופיל עודכן.",
"mc.profileSettings": "פרופיל ציבורי ולוח זמנים",
"mc.pseudo": "שם פרטי או כינוי",
"mc.redExpired": "פג תוקף",
"mc.redReady": "הצג לשותף",
"mc.redUsed": "שימוש",
"mc.redeem": "ממש את",
"mc.registerBtn": "צור את החשבון שלי",
"mc.registerTitle": "צור חשבון לקוח",
"mc.rememberMe": "זכור אותי",
"mc.remove": "הסר",
"mc.resetDone": "הסיסמה עודכנה. אתה יכול עכשיו להתחבר.",
"mc.resetExpired": "קישור האיפוס הזה אינו תקף או פג תוקף. בקש אחד חדש למטה.",
"mc.resetSave": "אפס את הסיסמה שלי",
"mc.resetTitle": "סיסמה חדשה",
"mc.restitutionConfirmed": "החזרה אושרה.",
"mc.reward": "פרס",
"mc.rewardRedeemed": "הפרס ננעל! קוד:",
"mc.rewardsDesc": "השתמש בנקודות שלך עבור הטבות המוצעות על ידי השותפים שלנו. יתרה:",
"mc.rewardsNone": "עדיין אין פרס זמין.",
"mc.rewardsTitle": "השתמש בנקודות שלי",
"mc.scoreAwarded": "יופי! +1 ל- Finder Score שלך 🎉",
"mc.scoreEarned": "נקודה שהושגה",
"mc.scorePts": "נקודות",
"mc.scoreThisYear": "שנה זו",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "צפה בלוח הדירוג",
"mc.share": "שיתוף",
"mc.statsTitle": "סטטיסטיקות",
"mc.subtitle": "עקוב אחרי כל הדוחות שלך במקום אחד.",
"mc.title": "החשבון שלי",
"mc.toLogin": "כבר רשום?",
"mc.toRegister": "עדיין אין חשבון?",
"mc.track": "עקוב",
"mc.views": "צפיות",
"mc.visCity": "עיר",
"mc.visCountry": "מדינה",
"mc.visLabel": "פריטים גלויים על לוח הדירוג:",
"mc.visName": "שם פרטי / כינוי",
"mc.visPhoto": "תמונת פרופיל",
"mc.welcome": "שלום",
"mc2.acceptFinder": "קבל את המאתרת הזו",
"mc2.accountActivity": "פעילות חשבון",
"mc2.adsActive": "{n}/5 מודעות פעילות",
"mc2.autoDelete": "מחיקה אוטומטית מתוכננת ל-",
"mc2.badgeBronze": "ברונזה",
"mc2.badgeGold": "זהב",
"mc2.badgeSilver": "כסף",
"mc2.boostEarnedAlready": "היא כבר הרוויחה לך",
"mc2.boostEarnedWin": "זה הרוויח לך",
"mc2.boostExpiredWin": "הבוסט שלך פג תוקף — חזור על כך בהנחה של -20%!",
"mc2.boostExpiresIn": "הבוסט שלך פג תוקף בעוד",
"mc2.boostWinDetail2": ". -20% יחול אוטומטית אם תחדש בתוך 24 שעות.",
"mc2.claimCode": "קוד תביעה:",
"mc2.codeSentFinder": "קוד שנשלח למאתרת בדוא\"ל",
"mc2.daysShort": "{n} י",
"mc2.downloadReceipt": "הורד את הקבלה שלי",
"mc2.error": "שגיאה {status}",
"mc2.finderAccepted": "המגלה התקבל — קוד נשלח בדואר אלקטרוני",
"mc2.finderContacts": "פרטי הקשר של המגלה/ים",
"mc2.followFindo": "עקוב אחרי Findloop",
"mc2.imgInvalid": "תמונה לא תקינה",
"mc2.inactivityNote": " — במקרה של {n} חודשים של חוסר פעילות (GDPR).",
"mc2.lastActivity": "פעולה אחרונה:",
"mc2.lostEmailTitle": "אין לי יותר גישה לדואר האלקטרוני שלי",
"mc2.noPhotoPreset": "אין תמונה עדיין? בחרו אווטאר ברירת מחדל:",
"mc2.paidViaPartner": "שולם (בעזרת שותף)",
"mc2.payRecovery": "שבע את דמי השיקום",
"mc2.paySettle": "סיים את התשלום שלי",
"mc2.payShipping": "שבע את דמי המשלוח",
"mc2.payUnavailable": "תשלום אינו זמין",
"mc2.peopleFound": "{n} אדם/ים חושבים שהם מצאו את הפריט שלך",
"mc2.phoneNumber": "מספר טלפון",
"mc2.reactivateAccount": "הפעל מחדש את החשבון שלי",
"mc2.reactivated": "החשבון הופעל מחדש",
"mc2.reactivatedThanks": "החשבון הופעל מחדש — תודה על הנ loyalty שלך!",
"mc2.recoverSmsBtn": "קבל את הקוד שלי ב-SMS",
"mc2.recoverSmsDesc": "קבל את קוד התביעה שלך ב-SMS למספר הרשום בחשבונך.",
"mc2.recoverSmsFallback": "אם קיימת חשבון עם מספר זה, נשלח SMS.",
"mc2.renewStayTop": ". חידוש כדי להישאר בראש ולשחזר את הפריט שלך.",
"mc2.resume20": "המשך -20%",
"mc2.unlockContacts": "פתח את פרטי הקשר",
"mc2.unlockDesc": "שבע את דמי טיפול של Findloop כדי לחשוף את פרטי הקשר שלהם ולתאם את ההעברה.",
"mc2.viewsWord": "צפיות",
"mc2.live": "בשידור חי",
"mh.allCategories": "כל הקטגוריות",
"mh.allPeriod": "כל הזמן",
"mh.autoMatch": "התאמה אוטומטית של AI",
"mh.blocked": "חסום (סתירה)",
"mh.blockedReason": "ההתאמה חסומה: המילים המרכזיות של הפריט וההצהרה סותרות זו את זו.",
"mh.days30": "30 הימים האחרונים",
"mh.days7": "7 הימים האחרונים",
"mh.days90": "90 הימים האחרונים",
"mh.emptyDesc": "התאמות AI יופיעו כאן כשיש הצהרות.",
"mh.emptyTitle": "אין אירועים",
"mh.exportCsv": "יצוא CSV",
"mh.exportDone": "יצוא CSV הורד",
"mh.exportImpossible": "היצוא נכשל",
"mh.fBlocked": "חסום",
"mh.fConfirmed": "מאושר",
"mh.fRejected": "נדחה",
"mh.objectLabel": "פריט:",
"mh.refresh": "רענן",
"mh.rejected": "נדחה",
"mh.srcManual": "ידני",
"mh.srcText": "טקסט",
"mh.srcVisual": "ויזואלי (תמונה)",
"mh.subtitle": "יומן ההתאמות שהוצעו על ידי AI — מותאם אוטומטית, מאושר ונדחה.",
"mh.title": "היסטוריית AI",
"nav.ads": "פריטים אבודים",
"nav.dashboard": "המרחב שלי",
"nav.found": "פריטים נמצאו",
"nav.how": "איך זה עובד",
"nav.login": "התחבר",
"nav.map": "מפה",
"nav.more": "עוד",
"nav.partners": "שותפים",
"nav.pricing": "תמחור",
"nav.ranking": "לוח זמנים",
"nav.register": "הפוך לשותף",
"nav.track": "עקוב אחרי הצהרה",
"nf.desc": "העמוד שאתה מחפש לא קיים או הועבר.",
"nf.home": "חזרה לדף הבית",
"nf.title": "העמוד לא נמצא",
"par.allCities": "כל הערים",
"par.allCountries": "כל המדינות",
"par.badge": "קטלוג",
"par.certified": "מוסמך",
"par.certifiedBadge": "מוסמך",
"par.cityPh": "עיר",
"par.declare": "דווח",
"par.none": "לא נמצא שותף.",
"par.partnerBadge": "שותף",
"par.searchPh": "חפש מוסד…",
"par.subtitle": "מצא את המוסד שבו איבדת את הפריט שלך ודווח על אובדן.",
"par.title": "השותפים שלנו",
"pay.addr1": "כתובת",
"pay.addr2": "קו כתובת 2 (לא חובה)",
"pay.addrIncomplete": "אנא מלא את כתובת המשלוח שלך.",
"pay.badge": "שחזור",
"pay.card": "שלם בכרטיס",
"pay.city": "עיר",
"pay.country": "מדינה",
"pay.eurNote": "סכומים מוצגים באירו (€).",
"pay.fee": "עמלת שחזור",
"pay.free": "חינם",
"pay.howRecover": "איך תרצה לקבל את הפריט שלך חזרה?",
"pay.momo": "שלם בכסף נייד",
"pay.momoConfirm": "אשר תשלום",
"pay.noMatch": "עדיין לא אושר פריט תואם לדיווח זה.",
"pay.notfound": "הדיווח לא נמצא.",
"pay.phonePh": "מספר טלפון",
"pay.pickup": "אסוף אישית",
"pay.pickupDesc": "ב-",
"pay.postal": "מיקוד",
"pay.secure": "תשלום מאובטח",
"pay.serviceFee": "עמלת שירות Findloop",
"pay.ship": "שלח לי",
"pay.shipAfter": "— מוצע לאחר התשלום.",
"pay.shipDesc": "משלוח לכתובת שלי",
"pay.shipNote": "משלוח זמין",
"pay.shipping": "עמלת משלוח",
"pay.subtitleWith": "שלם את עמלת השחזור ל",
"pay.title": "שחזר את הפריט שלי",
"pay.total": "סך הכל",
"pcat.city_hall": "מרכזים עירוניים",
"pcat.hotel": "מלונות",
"pcat.other": "אחר",
"pcat.park": "פארקים",
"pcat.prefecture": "משרדים מינהליים",
"pcat.restaurant": "מסעדות",
"pcat.uncategorized": "לא מקוטלג",
"pd.about": "על",
"pd.back": "כל השותפים",
"pd.certified": "שותף מוסמך",
"pd.declare": "דווח על אובדן כאן",
"pd.itemsReturned": "פריטים הוחזרו",
"pd.itemsTotal": "פריטים רשומים",
"pd.map": "מיקום",
"pd.noItems": "לא נמצאו פריטים לאחרונה.",
"pd.noReviews": "אין עדיין ביקורות.",
"pd.notFound": "השותף לא נמצא.",
"pd.recentItems": "פריטים שנמצאו לאחרונה",
"pd.reply": "תגובה מהעסק",
"pd.reviews": "ביקורות לקוחות",
"pd.verified": "ביקורת מאומתת",
"pd.verifiedEstablishment": "עסק מאומת על ידי Findloop",
"pg.next": "הבא",
"pg.prev": "קודם",
"pg.showing": "{from}–{to} מתוך {total}",
"pk.bodyCopy": "גוף הטקסט",
"pk.bodyText": "טקסט גוף",
"pk.brandColors": "צבעי המותג",
"pk.colorRed": "אדום",
"pk.colorWhite": "לבן",
"pk.darkBg": "רקע כהה",
"pk.download": "הורדה",
"pk.downloadZip": "הורד את כל הערכה (ZIP)",
"pk.headings": "כותרות",
"pk.heroDesc": "לוגואים רשמיים, באנרים לרשתות חברתיות, צבעים וטיפוגרפיה. בחר את שפת הסלוגן והגרסה, ואז הורד את הוויזואל או את הערכה המלאה.",
"pk.lightBg": "רקע בהיר (הדפסה)",
"pk.logoWordmark": "לוגו / סימן מילולי",
"pk.logosVisuals": "לוגואים & וויזואלים",
"pk.mapCollect": "מפה / נקודות איסוף",
"pk.plain": "פשוט",
"pk.pressKit": "ערכת לעיתונות",
"pk.taglineLang": "שפת הסלוגן",
"pk.typography": "טיפוגרפיה",
"pk.variant": "גרסה",
"pr.shipBtn": "שלח את הפריט",
"pr2.adBoostMsg": "בחירה מצוינת! אתה מכפיל את הסיכויים שלך לשחזר את הפריט במהירות.",
"pr2.boostActivated": "הגברת הופעלה!",
"pr2.canRecoverNow": "אתה יכול כעת לשחזר את הפריט שלך.",
"pr2.continue": "להמשיך",
"pr2.downloadReceiptPdf": "להוריד את הקבלה (PDF)",
"pr2.goToSpaceNow": "לך למדוּע עכשיו",
"pr2.partnerBoostMsg": "בחירה מצוינת! להיות יותר גלוי משמעותו למשוך לקוחות חדשים לעסק שלך.",
"pr2.paymentSuccess": "תשלום הצליח!",
"pr2.redirectingSpace": "מופנה לחשבון שלך…",
"pr2.subActivated": "תשלום הצליח! המנוי שלך פעיל, עכשיו תוכל לנהל את העסקים שלך.",
"prev.allSites": "כל העסקים",
"prev.editReply": "שנה תגובה",
"prev.none": "אין ביקורת עדיין.",
"prev.published": "תגובה פורסמה",
"prev.reply": "תגובה",
"prev.replyPh": "כתוב תגובה מנומסת…",
"prev.send": "פרסם תגובה",
"prev.sending": "מתפרסם…",
"prev.yourReply": "התגובה שלך",
"pricing.annual": "שנתי",
"pricing.annualBadge": "-20% הצעה",
"pricing.choose": "בחר",
"pricing.compareFeature": "תכונה",
"pricing.compareTitle": "השווה תכניות",
"pricing.eyebrow": "תמחור",
"pricing.month": "/לחודש",
"pricing.monthly": "חודשי",
"pricing.perYear": "/שנה",
"pricing.popular": "פופולרי",
"pricing.quoteMsg": "צרכים שלך (אופציונלי)",
"pricing.quoteOrg": "ארגון",
"pricing.quoteSend": "שלח בקשה",
"pricing.quoteSent": "הבקשה נשלחה! נחזור אליך בקרוב.",
"pricing.quoteSites": "מספר אתרים / מסופים",
"pricing.quoteTitle": "בקשה להצעת מחיר",
"pricing.requestQuote": "בקשה להצעת מחיר",
"pricing.saveLabel": "אתה חוסך",
"pricing.savePerYear": "/שנה עבור כל הקמה נוספת",
"pricing.start": "התחל",
"pricing.subtitle": "התחל בחינם, התפתח ככל שאתה גדל.",
"pricing.title": "תוכנית לכל ארגון",
"promo.badge": "תוכנית שותפים",
"promo.cta": "למד עוד",
"promo.text": "כל שותף שתפנה שמנוי נותן לך חודש חינם. בלי מגבלות.",
"promo.title": "הפנה שותף, קבל חודש חינם.",
"pub.accessGranted": "גישה הוענקה",
"pub.accessLimited2h": "גישה מוגבלת ל-2 שעות",
"pub.accountEmailConcerned": "אימייל של החשבון הרלוונטי",
"pub.adAppearPublic": "כך תיראה הפרסומת שלך בציבור.",
"pub.adPreviewBtn": "תצוגה מקדימה של הפרסומת",
"pub.alertMeOnArrival": "הודע לי בהגעה",
"pub.allActionsLogged": "כל הפעולות נרשמו",
"pub.allCategories": "כל הקטגוריות",
"pub.authorizeAccess": "אשר גישה",
"pub.authorizeSupportQ": "לאשר גישה לתמיכה?",
"pub.available": "זמין",
"pub.backHome": "חזור לבית",
"pub.boostAdCta": "הגדל את הפרסומת שלי",
"pub.boostAdTitle": "הגדל את הפרסומת שלך",
"pub.boostCarouselSub": "עבור למקום הראשון בדף בקרוסלת “המוגברים” והכפל צפיות כדי לשחזר את הפריט שלך מהר יותר.",
"pub.boostEstablishment": "הגדל את ההקמה שלך",
"pub.boostEstablishmentDesc": "הופיעו בראש הקטלוג עם תג “מוגבר” ומשכו יותר דוחות.",
"pub.boostFicheCta": "הגדל את הרשימה שלי",
"pub.brandReady": "מותג Findloop, מוכן לשימוש",
"pub.cantFindItem": "לא יכול למצוא את הפריט שלך?",
"pub.cantProcessImage": "לא ניתן לעבד את התמונה הזו",
"pub.claimQr": "דרוש קוד QR",
"pub.clickToZoom": "לחץ להגדלה",
"pub.codeAlreadyValidated": "הקוד אושר — הקשרים הוכנסו.",
"pub.codeExample": "למשל ABCD2345",
"pub.confirmRenewal": "אשר חידוש",
"pub.contactIntro": "שאלה, בקשה? כתוב לנו, נחזור אליך בקרוב.",
"pub.contactTypeDeceased": "מחיקת חשבון (אדם שנפטר)",
"pub.contactTypeGeneral": "שאלה כללית",
"pub.contactTypeSupport": "תמיכה / בעיה טכנית",
"pub.contactUs": "צור קשר",
"pub.continueWithoutEmail": "המשך מבלי להשאיר את האימייל שלי",
"pub.contractLabel": "חוזה",
"pub.contractNotFound": "החוזה לא נמצא או שיפג תוקף.",
"pub.contractRenewed": "החוזה חודש!",
"pub.contractRenewedFor": "החוזה שלך חודש ל-{n} חודשים.",
"pub.copyFailed": "ההעתקה נכשלה",
"pub.createPartnerAccount": "צור את חשבון השותף שלי",
"pub.currentDeadline": "המועד האחרון הנוכחי",
"pub.deceasedInfo": "כקרוב משפחה או יורש, אתה יכול לבקש את מחיקת חשבון Findloop של אדם שנפטר. ננגיש את הבקשה שלך בהתאם ל-GDPR (מסמכים תומכים עשויים להתבקש).",
"pub.declareMyLoss": "דווח על האבדה שלי",
"pub.describeItemPlaceholder": "תאר את הפריט שלך (למשל, מטרייה שחורה, מפתחות…)",
"pub.downloadImage": "הורד את התמונה",
"pub.drawSignature": "אנא שרטט את החתימה שלך.",
"pub.drawSignatureHint": "שרטט את החתימה שלך עם העכבר או האצבע.",
"pub.duration": "משך",
"pub.eSignature": "חתימה אלקטרונית",
"pub.eSignatureDesc": "הכנס את שמך כדי לחתום. התאריך נרשם אוטומטית.",
"pub.edit": "ערוך",
"pub.editorialTitles": "כותרות עיתונאיות",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "הכנס את הקוד שהתקבל בדוא\"ל כדי לפתוח את פרטי הקשר של בעל הפריט.",
"pub.errorWord": "שגיאה",
"pub.foundSelfService": "פריטים שנמצאו · שירות עצמי",
"pub.haveOwnerCode": "קיבלתי קוד מבעל הפריט",
"pub.home": "בית",
"pub.immediateRenewal": "חידוש מיידי, ללא הצעת מחיר חדשה.",
"pub.impAdminReq1": "מנהל",
"pub.impAdminReq2": "מבקש רשות לגשת באופן זמני לחשבון שלך",
"pub.impAdminReq3": "כדי לעזור לך.",
"pub.impGrantedDesc": "צוות התמיכה יוכל לגשת לחשבון שלך למשך מקסימום של 2 שעות. כל פעולה תתועד. אתה יכול לסגור דף זה.",
"pub.invitedOnFindo": "הוזמנת להצטרף ל-findloop",
"pub.isThisYourItem": "האם זה הפריט שלך?",
"pub.itemsAvailableCount": "{n} פריט(ים) זמינים כרגע",
"pub.itemsFoundOwner": "של פריטים מופקדים שמצאו את בעליהם",
"pub.itemsReturnedOwners": "פריטים שחזרו לבעליהם",
"pub.itsMine": "זה שלי",
"pub.joinFindoDesc": "הצטרף ל-findloop ונהל את הפריטים שמצאת בקלות.",
"pub.joinInvitesYou": "מזמין אותך להצטרף ל-findloop. צור חשבון שותף כדי לנהל את הפריטים שמצאת.",
"pub.linkCopied": "הלינק הועתק!",
"pub.loadingContract": "טוען את ההסכם…",
"pub.lsClaimDesc": "דווח על ההפסד שלך כדי לשחזר אותו. השאר את האימייל שלך ונשלח לך תזכורת אם הדיווח שלך לא הושלם.",
"pub.lsHeroDesc": "בדוק בעצמך אם הפריט האבוד שלך נמצא והשאירו כאן. מצאת אותו? דווח עליו כדי לשחזר אותו.",
"pub.lsSearchTitle": "חפש פריטים שנמצאו",
"pub.makeOffer": "עשה הצעה",
"pub.makeOfferDesc": "הצע את הסכום שלך. הסופר אדמין יסקור את זה.",
"pub.mapNearYou": "פריטים ושותפים לידך",
"pub.mapWord": "מפה",
"pub.messageSentToast": "הודעה נשלחה — הצוות שלנו יגיב בהקדם.",
"pub.messageWord": "הודעה",
"pub.momoInitiated": "תשלום באמצעות כסף נייד הופעל",
"pub.monthsWord": "חודשים",
"pub.nameConsentRequired": "נדרשים שם ואישור.",
"pub.newDeadline": "מועד חדש",
"pub.noActionRequired": "אין צורך בפעולה.",
"pub.noAmountCharged": "לא נגבה שום סכום.",
"pub.noItemMatch": "אין פריט זמין שמתאים לחיפוש שלך כרגע.",
"pub.noMatchingItem": "אין פריט תואם",
"pub.noPaymentSession": "אין מושב תשלום.",
"pub.noPhoto": "אין תמונה",
"pub.noPointsYet": "אין נקודות להציג עדיין.",
"pub.noSecondPayment": "אין צורך בתשלום נוסף עבור פריט זה.",
"pub.notHereYet": "עדיין לא כאן? קבל התראה ברגע שזה arrives.",
"pub.notifyDone": "נרשם! נודיע לך בדוא\"ל ברגע שיגיע פריט תואם.",
"pub.offerSubmitted": "ההצעה שלך נשלחה.",
"pub.oops": "אופס",
"pub.orAlertEmail": "או קבל התראה בדוא\"ל ברגע שיגיע פריט תואם:",
"pub.ownerContacts": "פרטי קשר של הבעל",
"pub.ownerContactsUnlocked": "פרטי קשר של הבעל נפתחו",
"pub.partnerContact": "קשר עם השותף",
"pub.payLinkUnavailable": "לינק תשלום אינו זמין — צור קשר עם השותף.",
"pub.paymentCancelled": "התשלום בוטל",
"pub.paymentConfirmed": "התשלום אושר 🎉",
"pub.paymentConfirmedDesc": "תקבל/י אימייל עם הפרטים כדי לשחזר את הפריט שלך.",
"pub.paymentNotConfirmed": "התשלום לא אושר",
"pub.paymentNotConfirmedDesc": "לא ניתן לאמת את התשלום. נסה/י שוב או צור/י קשר עם השותף.",
"pub.paymentProcessing": "התשלום מעובד. רענן/י בעוד רגע.",
"pub.photoAdded": "✓ התמונה נוספה",
"pub.photoRequired": "דרושה תמונה של הפריט.",
"pub.previewAlt": "תצוגה מקדימה",
"pub.publish": "פרסם",
"pub.publishingWord": "מפרסם…",
"pub.qty": "כמות",
"pub.quoteDeclined": "הצעת המחיר נדחתה.",
"pub.quoteNotFound": "הצעת המחיר לא נמצאה או שפג תוקפה.",
"pub.reasonLabel": "סיבה",
"pub.recoveryAlreadyPaid": "דמי השחזור כבר שולמו",
"pub.referralCode": "קוד הפניה:",
"pub.relationshipPlaceholder": "בן, בן זוג, נוטריון…",
"pub.renewYourContract": "חדש את החוזה שלך",
"pub.renewalFailed": "חידוש נכשל. נסה/י שוב מאוחר יותר.",
"pub.renewing": "מחדש…",
"pub.replySoon": "הצוות שלנו יגיב בהקדם האפשרי.",
"pub.requestGone": "בקשה זו לא קיימת יותר.",
"pub.requestHandled": "הבקשה כבר טופלה",
"pub.requestNotFound": "הבקשה לא נמצאה או שפג תוקפה.",
"pub.requestUnavailable": "הבקשה אינה זמינה",
"pub.required": "(נדרש)",
"pub.retroClosing": "יחד, אנו עושים את העולם קצת פחות אבוד.",
"pub.retroClosing2": "יחד, אנו עושים את העולם קצת פחות אבוד.",
"pub.retroScroll": "שנה של שחזור מה שחשוב. גלול למטה ↓",
"pub.revokeAnytime": "באפשרותך לבטל בכל עת על ידי פנייה אלינו",
"pub.scene": "סצנה",
"pub.sendImpossible": "לא ניתן לשלוח",
"pub.sendMessage": "שלח את ההודעה",
"pub.sending": "שולח…",
"pub.sharePreview": "שתף תצוגה מקדימה",
"pub.shareYourAd": "שתף את המודעות שלך",
"pub.signedSuccess": "נחתם בהצלחה!",
"pub.signerFullName": "שם מלא של החותם",
"pub.spreadNetwork": "שתף עם הסובבים אותך כדי לשפר את הסיכויים שלך.",
"pub.spreadOwner": "שתף כדי לעזור לבעל להחזיר את הדברים שלו.",
"pub.statusLabel": "סטטוס:",
"pub.subject": "נושא",
"pub.thanksSent": "תודה, ההודעה שלך נשלחה.",
"pub.thisYear": "השנה",
"pub.validate": "אמת",
"pub.verifyingPayment": "מאמת את התשלום…",
"pub.verifyingYourPayment": "מאמת את התשלום שלך…",
"pub.viewAd": "ראה את המודעה →",
"pub.viewPartner": "ראה את השותף →",
"pub.yourAdPreview": "תצוגה מקדימה של המודעה שלך",
"pub.yourEmail": "האימייל שלך",
"pub.yourEmailRecommended": "האימייל שלך (מומלץ)",
"pub.yourEmailShort": "האימייל שלך",
"pub.yourName": "שמך",
"pub.yourRelationship": "הקשר שלך לאדם",
"qv.acceptAndSign": "קבל וחתום על הצעת המחיר שלי",
"qv.certifyAuthorized": "אני מאשר/ת שאני מוסמך/ת לחתום ואני מקבל/ה את תנאי ה-{what} הזה (ערך מחייב).",
"qv.clear": "נקה",
"qv.client": "לקוח",
"qv.conditions": "תנאים",
"qv.confirmDecline": "האם לאשר את הסירוב לצטוט הזה?",
"qv.countersignedFindo": "נחתם על ידי Findloop · {name} בתאריך {date}",
"qv.decline": "סירוב",
"qv.description": "תיאור",
"qv.downloadPdf": "הורד את ה-PDF",
"qv.handwrittenSignature": "חתימה בכתב יד",
"qv.inclTax": "כולל מיסים",
"qv.invalidAmount": "סכום לא תקף.",
"qv.invoice": "חשבון",
"qv.invoicePaid": "החשבון שולם",
"qv.issuer": "מנפיק",
"qv.messageOptional": "הודעה (אופציונלית)",
"qv.negotiatedAmount": "סכום מושג",
"qv.payInvoiceOnline": "שלם את החשבון באופן מקוון",
"qv.quote": "הצעת מחיר",
"qv.quoteValidDays": "הצעת המחיר תקפה ל-{n} ימים.",
"qv.sendMyOffer": "שלח את ההצעה שלי",
"qv.signContract": "חתום על החוזה שלי",
"qv.signNow": "חתום עכשיו",
"qv.signatureAlt": "חתימה",
"qv.signedByOn": "✔ נחתם על ידי {name} בתאריך {date}",
"qv.stContractSigned": "החוזה נחתם. תודה!",
"qv.stCounterAccepted": "ההצעה שלך התקבלה! חתום על החוזה שלך למטה.",
"qv.stCounterRefused": "ההצעה שלך לא התקבלה.",
"qv.stCountered": "ההצעה שלך הוגשה. מחכים לתגובה של findloop.",
"qv.stDeclined": "סירבת להצעה זו.",
"qv.stSigned": "ההצעה התקבלה ונחתמה. תודה!",
"qv.totalHt": "סה''כ לא כולל מיסים",
"qv.totalTtc": "סה''כ כולל מיסים",
"qv.unitHt": "יחידה לא כולל מיסים",
"qv.vat": "מע''מ",
"qv.yourProposedAmount": "הסכום המוצע שלך ({cur})",
"rate.chooseNote": "אנא בחר דירוג.",
"rate.commentPh": "הערה (אופציונלית)…",
"rate.home": "חזרה לדף הבית",
"rate.submit": "שלח את הביקורת שלי",
"rate.submitting": "שולח…",
"rate.subtitle": "איך הלך השבת הפריט שלך?",
"rate.successText": "המשוב שלך עוזר למשתמשים אחרים.",
"rate.successTitle": "תודה על הביקורת שלך!",
"rate.title": "דירוג החוויה שלך",
"reg.add": "רשום פריט",
"reg.allBrands": "כל המותגים",
"reg.allColors": "כל הצבעים",
"reg.allLocations": "כל המיקומים",
"reg.detailDesc": "פרטים ופעולות עבור פריט שנמצא זה.",
"reg.dispAuction": "מכירה פומבית",
"reg.dispAuthorities": "נמסר לרשויות",
"reg.dispDestroyed": "הושמד",
"reg.dispDonate": "תרומת צדקה",
"reg.dispositionHint": "רשום את הפריט שעוזב את האחסון. נספר בסטטיסטיקות לפי קטגוריה.",
"reg.emptyCta": "רשום פריט",
"reg.emptyDesc": "התחל על ידי רישום הפריט הראשון שנמצא.",
"reg.emptyTitle": "לא נמצאו פריטים",
"reg.establishmentFallback": "ההוקעה",
"reg.lblAuctioned": "רשום במכירה פומבית",
"reg.lblAuctionedShort": "מכר",
"reg.lblAuthorities": "הועבר לרשויות",
"reg.lblDestroyed": "הושמד",
"reg.lblDonated": "נתרם לעמותה",
"reg.legalCount": "{n} פריט(ים): התקופה החוקית הגיעה",
"reg.legalHint": "אתה יכול לרשום אותם במכירה פומבית, לתרום אותם לעמותה, או לדווח על העברתם לרשויות.",
"reg.legalLimitCountry": "מועד אחרון: {date} · מדינה מיועדת: {country}",
"reg.legalOver": "המועד האחרון חלף: {date} · {country}",
"reg.legalReached": "התקופה החוקית הושגה",
"reg.legalReachedFull": "התקופה החוקית הגיעה",
"reg.limitShort": "מועד אחרון",
"reg.location": "מיקום",
"reg.markRestituted": "סמן כהושב",
"reg.markedAs": "הפריט סומן כ-{label}",
"reg.moveHistory": "היסטוריית תנועה",
"reg.overBy": "מעבר ב-{n} ימים",
"reg.physicalLocation": "מיקום פיזי",
"reg.popupBlocked": "אפשר חלונות קופצים להדפסת התוויות.",
"reg.popupBlockedOne": "אפשר חלון קופץ להדפסת התווית.",
"reg.printLabel": "הדפס את התווית",
"reg.printN": "הדפס {n} תווית(ות)",
"reg.qrCodeItem": "קוד QR של הפריט",
"reg.qrLabelTitle": "תווית QR",
"reg.qrLabelsTitle": "תוויות QR",
"reg.qrNotFound": "לא נמצא פריט עבור קוד QR זה.",
"reg.qrScanHint": "סרוק כדי לפתוח רשומה זו ישירות ולמצוא את המיקום.",
"reg.recoveryFee": "עמלת השבה (€)",
"reg.searchPh": "חפש לפי תיאור…",
"reg.selectQr": "בחר להדפיס תוויות QR",
"reg.selectedN": "{n} נבחרו",
"reg.shipPricePh": "מחיר משלוח (€)",
"reg.shippingPossible": "משלוח זמין",
"reg.storagePh": "למשל, מדף A3, תא 12",
"reg.tAuction": "מכירה פומבית ב-findо",
"reg.tAuthorities": "דווח על העברה לרשויות",
"reg.tDonate": "תרום לעמותה",
"reg.toastFee": "דמי הושגו",
"reg.toastLocation": "המיקום שמור",
"reg.toastRestituted": "הפריט סומן כהושב",
"reg.toastShipping": "אפשרות המשלוח עודכנה",
"reg.toastTransferred": "הפריט הועבר ל- “{name}”",
"reg.unclaimedDisposition": "פריט לא נתבע — סילוק סופי",
"res.codeValidated": "הקוד אומת",
"res.empty": "לא נרשמה החזרה עדיין.",
"res.error": "שגיאה {status}",
"res.proofPdf": "ממצא PDF",
"res.signed": "חתום",
"res.stRestituted": "הועבר אישית",
"res.stShipped": "הושב באמצעות משלוח",
"res.subtitle": "כל ההעברות הושלמו, עם הוכחת חתימה שניתן להוריד.",
"res.title": "היסטוריית החזרות",
"rev.b2b": "שותפי B2B",
"rev.b2c": "לקוחות",
"rev.based": "מבוסס על {n} ביקורות",
"rev.eyebrow": "עדויות",
"rev.restitutedBy": "הושב על ידי {org}",
"rev.storiesEyebrow": "סיפורים מאושרים",
"rev.storiesSubtitle": "סיפורים אמיתיים מלקוחות שהשיבו את חפציהם עם findloop.",
"rev.storiesTitle": "הם מצאו את חפציהם!",
"rev.subtitle": "שותפים ולקוחות משתפים את ניסיונם.",
"rev.title": "הם סומכים על Findloop",
"rev.verified": "מאומת",
"rp.already": "כבר דיווחת על רישום זה.",
"rp.comment": "פרטים (אופציונלי)",
"rp.duplicate": "כפול",
"rp.fraud": "הונאה / רמאות",
"rp.inappropriate": "תוכן לא הולם",
"rp.offensive": "תוכן פוגעני",
"rp.other": "אחר",
"rp.reason": "סיבה",
"rp.report": "דיווח",
"rp.send": "שלח דיווח",
"rp.sent": "הדיווח נשלח. תודה על התרומה שלך.",
"rp.spam": "ספאם / פרסום",
"rp.title": "דווח על רשימה זו",
"rp.wrongCategory": "קטגוריה שגויה",
"rt.annualGoal": "מטרה שנתית",
"rt.championCity": "עיר Champion",
"rt.cityRate": "{rate}% שיעור החזרה",
"rt.goalProgress": "{rate}% הושג מתוך מטרה של {target}%",
"rt.reached": "הושג 🎉",
"rt.restitutionRate": "שיעור החזרה",
"rt.shareRecap": "שתף את הסיכום שלי",
"rt.thanks": "תודה Findloop {year} 💛",
"rt.yourRecap": "הסיכום שלך לשנת {year}",
"rw.active": "פעיל",
"rw.add": "הוסף",
"rw.camUnavailable": "המפיק לא זמין. הזן את הקוד ידנית למטה.",
"rw.codeValidated": "הקוד מאומת",
"rw.codesTitle": "קודים שנניצלו על ידי מוצאים",
"rw.confirmDelete": "למחוק את “{title}”? ",
"rw.deleted": "נמחק",
"rw.edit": "ערוך",
"rw.editReward": "ערוך את הפרס",
"rw.empty": "אין פרס עדיין.",
"rw.expired": "פג תוקף",
"rw.expiresOn": "פג תוקף ב-{date}",
"rw.fActive": "פעיל (נראה למוצאים)",
"rw.fCost": "עלות (נקודות)",
"rw.fDesc": "תיאור",
"rw.fStock": "מלאי (ריק = ללא הגבלה)",
"rw.fTitle": "כותרת",
"rw.fValidity": "תוקף שובר (ימים לאחר הניצול)",
"rw.inactive": "לא פעיל",
"rw.newReward": "פרס חדש",
"rw.noExchange": "עדיין אין ניצול.",
"rw.pageSubtitle": "סרוק את השוברים שהוצגו על ידי מוצאים כדי לאמת את הפרסים שלהם.",
"rw.redeemedN": "נניצל: {n}×",
"rw.saved": "הפרס נשמר",
"rw.scanVoucher": "סרוק שובר",
"rw.staffScanOnly": "סרוק בלבד",
"rw.statActive": "להציג",
"rw.statExpired": "פג תוקף",
"rw.statRedeemed": "שוברים שנניצלו",
"rw.statUsed": "מאומת",
"rw.stock": "מלאי",
"rw.subtitle": "הצע הטבות לא כספיות (שוברים, שדרוגים…) שמוצאים מנצלים עבור נקודות ה-Finder Score שלהם.",
"rw.title": "פרסים עבור מוצאים",
"rw.used": "שימושי",
"rw.validate": "אמת",
"rw.validateCode": "אמת את הקוד",
"rw.validity": "תוקף: {n} ד",
"shell.f1d": "קשר אוטומטית בין פריטים שנlost ל-found.",
"st.matched": "התאמה נמצאה",
"st.open": "פתוח",
"st.paid": "שולם",
"st.pending": "בהמתנה",
"st.resolved": "נפתר",
"st.restituted": "הוחזר",
"st.second_chance": "סיכוי שני",
"st.shipped": "נשלח",
"st.shipping_requested": "בקשת שילוח",
"st.submitted": "נשלח",
"st.verified": "מאומת",
"stat.items": "פריטים רשומים",
"stat.partners": "שותפים",
"stat.restituted": "פריטים שהוחזרו",
"status.auctioned": "כשאמר",
"status.destroyed": "הושמד",
"status.donated": "תרם (לעמותה)",
"status.handed_to_authorities": "נמסר לרשויות",
"status.in_storage": "במאגר",
"status.matched": "התאמה",
"status.open": "פתוח",
"status.paid": "שולם",
"status.pending": "בהמתנה",
"status.restituted": "הוחזר",
"status.shipped": "נשלח",
"status.shipping_requested": "בקשת שילוח",
"status.submitted": "נשלח",
"step1.tag": "מוסד",
"step1.text": "בשניות, המוסד רושם את הפריט שנמצא עם תמונה, קטגוריה ותיאור. הכל מרוכז במאגר ברור ובטוח.",
"step1.title": "השותף רושם את הפריט",
"step2.tag": "לקוח",
"step2.text": "באמצעות קוד ה-QR של השותף, הלקוח שלך מתאר את הפריט האבוד בתוך 30 שניות. אין צורך להתקין אפליקציה - הכל מתבצע בדפדפן.",
"step2.title": "הלקוח מדווח על האובדן",
"step3.tag": "בינה מלאכותית",
"step3.text": "מנוע ההתאמה החכם שלנו משווה תיאורים ומציע את ההתאמות הסבירות ביותר, מוכן לאישור.",
"step3.title": "בינה מלאכותית מקשרת בין האובדן לפריט שנמצא",
"step4.tag": "שיקום",
"step4.text": "לאחר תשלום מאובטח עבור דמי השיקום, הלקוח אוסף את הפריט במקום - או מקבל אותו באמצעות שילוח מעוקב.",
"step4.title": "הלקוח מקבל את הפריט שלו בחזרה",
"stg.allLabels": "כל התוויות QR",
"stg.camHint": "השתמש בהזנה ידנית למטה.",
"stg.camStarting": "מתחילים את המצלמה…",
"stg.camUnavailable": "המצלמה לא זמינה.",
"stg.clear": "נקה",
"stg.clearAll": "נקה הכל",
"stg.codeUnreadable": "קוד לא קריא.",
"stg.emptyDesc": "פריטים מאוחסנים יופיעו כאן, מקובצים לפי מיקום.",
"stg.emptyTitle": "אין פריטים במאגרים",
"stg.exportAudit": "ייצוא ביקורת CSV",
"stg.exportDone": "ייצוא CSV הורד",
"stg.exportImpossible": "ייצוא לא זמין כרגע.",
"stg.itemFound": "הפריט נמצא ✅",
"stg.kLocations": "מיקומים בשימוש",
"stg.kObjects": "פריטים מאוחסנים",
"stg.kToClear": "מיקומים לנקות",
"stg.locFreed": "המיקום פונה",
"stg.locsFreed": "{n} מיקום(ים) פונים",
"stg.manualLabel": "או הזן את הקוד / מזהה של הפריט",
"stg.manualPh": "הדבק את מזהה או ה-URL של ה-QR",
"stg.noItemMatch": "לא נמצא פריט תואם לקוד QR / קוד זה.",
"stg.noLocation": "אין מיקום",
"stg.objectsAxis": "פריטים",
"stg.objectsN": "{n} פריט(ים)",
"stg.occAvg": "ממוצע {n} פריטים/מיקום",
"stg.occHint": "מיקומים בצהוב חורגים מהממוצע (עלולים להיות עמוסים).",
"stg.occupancy": "תפוסת מיקום",
"stg.openPage": "פתח את הדף",
"stg.posterPdf": "פוסטר PDF (A4)",
"stg.printAll": "הדפס הכל",
"stg.printGroupTitle": "הדפס תוויות למדף הזה",
"stg.qrAlt": "QR לשירות עצמי",
"stg.qrDownload": "הורד את הQR",
"stg.qrHint": "הצג את הQR הזה בקופה: הלקוחות שלך סורקים אותו כדי לבדוק אם הפריט שלהם זמין.",
"stg.qrTitle": "QR לשירות עצמי ללקוחות",
"stg.scanDesc": "סרוק את תווית הפריט כדי לפתוח את הרשומה שלו מיד.",
"stg.scanQr": "סרוק QR",
"stg.scanTitle": "סרוק קוד QR",
"stg.search": "חיפוש",
"stg.shelf": "מדף {loc}",
"stg.shelfPlan": "תוכנית מדף",
"stg.staleHint": "נקה את המיקומים האלה כדי לשמור על המלאי הפיזי שלך עדכני.",
"stg.staleTitle": "{n} פריט(ים) עזבו את האחסון אבל עדיין יש להם מיקום",
"stg.subtitle": "תוכנית מדף, סורק QR ומעקב מלאי פיזי.",
"stg.title": "אחסון וQR",
"stt.acceptRate": "שיעור קבלה",
"stt.accepted": "התקבל",
"stt.activity30": "פעילות (30 ימים אחרונים)",
"stt.ai6mo": "6 החודשים האחרונים · התקבל = שידור אוטומטי + מאושר.",
"stt.aiEmpty": "אין התאמות AI במהלך התקופה הזו עדיין.",
"stt.aiTitle": "התאמות AI — התקבל לעומת דחוי",
"stt.auctionShort": "מכרז",
"stt.auctionedSold": "מוצע למכירה (נמכר)",
"stt.authShort": "רשויות",
"stt.authorities": "נמסר לרשויות",
"stt.avgRating": "דירוג ממוצע",
"stt.awaitingRestitution": "פריטים ממתינים להחזרה",
"stt.boostClicks": "קליקים על המדריך שלך השבוע בזכות ההגברה",
"stt.boostInactive": "ההגברה לא פעילה — הפעל אותה כדי להגדיל החשיפה",
"stt.certifiedPremium": "מאושר פרימיום",
"stt.declarations": "הצהרות",
"stt.destroyed": "הרוס",
"stt.dispoEmpty": "אין פריט לא נתבע שעזב את האחסון עדיין.",
"stt.donatedAssoc": "נתרם (慈善)",
"stt.donatedShort": "נתרם",
"stt.gateCta": "גלה את התוכניות",
"stt.gateDesc": "שדרג לStarter כדי לנעול את הסטטיסטיקות הבסיסיות שלך, או לBusiness עבור סטטיסטיקות מתקדמות וניתוח לפי מוסדות.",
"stt.gateTitle": "סטטיסטיקות שמורות לתוכניות בתשלום",
"stt.inStorage": "באחסון",
"stt.kItems": "פריטים רשומים",
"stt.kRate": "שיעור החזרה",
"stt.kRestituted": "פריטים שהוחזרו",
"stt.kRevenue": "הכנסות (חודש)",
"stt.noDeclYet": "אין הצהרות עדיין.",
"stt.recapDownloaded": "סיכום הורד - מוכן לשיתוף!",
"stt.recapError": "לא ניתן לייצר את הסיכום",
"stt.recapText": "הסיכום שלנו Findloop {year}: פריטים שהוחזרו ושביעות רצון לקוחות 🎉",
"stt.recapTitle": "סיכום Findloop {year}",
"stt.rejected": "נדחה",
"stt.restitutions": "החזרות",
"stt.shareRecap": "שיתוף סיכום {year} שלי",
"stt.topCategories": "קטגוריות המוצהרות ביותר",
"stt.unclaimedDesc": "היקף הפריטים שנפגעו, נ donations לתרומות ומוצעים במכירה פומבית, לפי קטגוריה.",
"stt.unclaimedTitle": "פריטים לא הנתבעים — עזיבת אחסון",
"stt.vsLastWeek": "לעומת השבוע שעבר",
"sub.cancel": "ביטול המנוי שלי",
"sub.cancelAbort": "ביטול",
"sub.cancelConfirm1": "האם אתה בטוח שברצונך לבטל? הגישה שלך תישאר פעילה עד",
"sub.cancelConfirm2": "לא יינתן החזר.",
"sub.cancelConfirmBtn": "אשר ביטול",
"sub.cancelTitle": "ביטול המנוי שלך",
"sub.cancelledToast": "ביטול נרשם.",
"sub.cguAnd": "ומשום כך",
"sub.cguDesc": "אנא אמת את ההסכמה שלך לפני התשלום.",
"sub.cguLink": "תנאי שימוש",
"sub.cguPay": "ממשיך לתשלום",
"sub.cguPre": "קראתי ומקבל את",
"sub.cguRequired": "עליך לקבל את תנאי השימוש ומדיניות הפרטיות כדי להמשיך.",
"sub.cguSuffix": "של Findloop.",
"sub.cguTitle": "סיים את המנוי שלך",
"sub.expiresOn": "המנוי שלך פג בתאריך",
"sub.noProrata": "אין החזר פרו- rata.",
"sub.privacyLink": "מדיניות פרטיות",
"sub.renewsOn": "המנוי שלך מתחדש בתאריך",
"sub.resume": "חדש מנויים",
"sub.resumedToast": "חדש מנוי אושר.",
"tier.free": "חינם",
"tier.large": "ארגוני",
"tier.medium": "עסקי",
"tier.small": "מנוי ראשוני",
"tm.add": "הוסף",
"tm.adminOpt": "מנהל (תצוגה מלאה)",
"tm.chooseEst": "בחר מוסד",
"tm.chooseEstPh": "בחר מוסד",
"tm.copyFail": "העתקה נכשלה",
"tm.copyLink": "העתק את הקישור",
"tm.copyOk": "קישור הזמנה הועתק",
"tm.emailHint": "דואר הזמנה יישלח ליצירת הסיסמה.",
"tm.expiresOn": "פג בתאריך {date}",
"tm.forEmail": " עבור {email}",
"tm.forbidden": "ניהול צוות שמור לבעל החשבון.",
"tm.inviteCreated": "הזמנה נעשתה",
"tm.inviteDesc": "דואר הזמנה מאפשר לחבר הצוות ליצור את הסיסמה שלו.",
"tm.invitePending": "הזמנה ממתינה",
"tm.inviteResent": "הזמנה נשלחה שוב",
"tm.inviteSent": "הזמנה נשלחה בדואר אלקטרוני",
"tm.inviteTitle": "הזמן חבר",
"tm.invitedOn": "הוזמן בתאריך {date}",
"tm.linkExpired": "הקישור פג",
"tm.memberRemoved": "החבר הוסר",
"tm.name": "שם",
"tm.noMembers": "עדיין אין חבר צוות.",
"tm.resendTitle": "שלח מחדש את ההזמנה",
"tm.role": "תפקיד",
"tm.roleAdmin": "מנהל",
"tm.roleOwner": "בעלים",
"tm.roleStaff": "צוות",
"tm.roleUpdated": "התפקיד עודכן",
"tm.sendInvite": "שלח את ההזמנה",
"tm.sending": "שולח…",
"tm.staffOpt": "צוות (רואה רק את המוסד שלהם)",
"trk.at": "ב",
"trk.badge": "מעקב",
"trk.carrier": "ספק שירות",
"trk.codeValidated": "הקוד אושר על ידי השותף",
"trk.dlProof": "הורד את הראיה שלי למסירה (PDF)",
"trk.emailLabel": "דוא\"ל (אופציונלי — כדי לראות את הפרטים שלך)",
"trk.enterEmailCode": "הכנס את הדוא\"ל שלך למעלה כדי להציג את קוד התביעה שלך.",
"trk.idLabel": "מספר דיווח",
"trk.lostEmail": "אני כבר לא доступен לדוא\"ל שלי",
"trk.phonePh": "מספר הטלפון שלך",
"trk.photoBefore": "תמונה של הפריט לפני השילוח",
"trk.recoverBtn": "שחזר את הפריט שלי",
"trk.recoverHint": "קבל את קוד התביעה שלך בהודעת SMS למספר הרשום שלך.",
"trk.searching": "מחפש…",
"trk.secureRest": "מסירה מאובטחת",
"trk.send": "שלח",
"trk.shipPending": "השילוח מתוכנן — מספר המעקב יופיע כאן ברגע שישלח.",
"trk.shipTitle": "מעקב משלוחים",
"trk.showQr": "הצג את ה-QR הזה לשותף כדי לאמת את המסירה",
"trk.sigSaved": "החתימה נשמרה",
"trk.signFirst": "אנא חתום לפני אישור.",
"trk.signProof": "חתום על הראיה שלך למסירה",
"trk.signSubmit": "אשר את חתימתי והפק את ה-PDF",
"trk.submit": "עקוב",
"trk.subtitle": "הכנס את מספר הדיווח שלך כדי לעקוב אחרי ההתקדמות.",
"trk.title": "עקוב אחרי הדיווח שלי",
"trk.trackShipment": "עקוב אחרי החבילה",
"trk.trackingNo": "מספר מעקב",
"trk.yourCode": "קוד התביעה שלך (כדי לתת לשותף)",
"a.firstName": "שם פרטי",
"ac.emailCrossMatch": "התאמות B2C",
"ac.emailCrossMatchDesc": "מייל כאשר מודעת פריט ציבורי אבודה תואמת פריט שהונח במתקן שלך",
"ac.emailCrossReject": "דחיות התאמה ציבוריות",
"ac.emailCrossRejectDesc": "קבל מייל כאשר לקוח מציין שההתאמה הציבורית המומלצת אינה הפריט שלו.",
"ac.emailLoginNotif": "התראה על התחברות",
"ac.emailLoginNotifDesc": "קבל מייל בכל פעם שמישהו מתחבר לחשבון שלך.",
"ad.closeNoCancel": "לא, הסר את המודעה",
"ad.closeQuestion": "האם הפריט הושב אליך?",
"ad.closeQuestionDesc": "יידע אותנו אם חזרת על הפריט שלך, או אם אתה פשוט רוצה להסיר את המודעה הזו.",
"ad.closeYesRestituted": "כן, הפריט הושב",
"ad.closedRestituted": "הפריט הושב — המודעה נסגרה 🎉",
"an.lostLoginDesc": "נדרש חשבון לדווח על פריט אבוד ולעקוב אחר חזרתו.",
"an.lostLoginRequired": "התחבר לדווח על פריט אבוד",
"an.qfAll": "כל",
"an.qfBoosted": "מוגבר",
"an.qfPhoto": "עם תמונה",
"an.qfRecent": "השבוע",
"an.qfResolved": "פתרון",
"an.restitutionInProgress": "הפריט מוחזר",
"cat.Trousse": "תיק / קייס",
"cat.USB": "סיסמא USB / דיסק קשיח",
"cat.Valise": "מזוודה / מטען",
"cat.Velo": "אופניים",
"cat.Vetements": "ביגוד",
"cat.placeholder": "בחר קטגוריה",
"cd.d": "ד",
"cd.expired": "פג תוקף",
"cd.h": "ש",
"cd.m": "דק",
"ck.accept": "קבל",
"ck.acceptAll": "קבל הכל",
"ck.customize": "התאם אישית",
"ck.learn": "מידע נוסף",
"ck.manage": "נהל עוגיות",
"ck.measurement": "מדידת קהל",
"ck.measurementDesc": "סטטיסטיקות אנונימיות כדי לשפר את השירות.",
"ck.msg": "אנחנו משתמשים בעוגיות כדי לשמור על הפעולה של האתר ולמדוד את הקהל.",
"ck.necessary": "נחוץ",
"ck.necessaryDesc": "חיוני לפעולת האתר. תמיד פועל.",
"dep.aiFilled": "טופס מולא על ידי AI ✨",
"dep.aiUnavailable": "AI אינו זמין — מלא את הטופס ידנית.",
"dep.analyzing": "מנתחים…",
"dep.analyzingPhoto": "מנתחים תמונה…",
"dep.brand": "מותג",
"dep.brandPlaceholder": "למשל, אפל",
"dep.category": "קטגוריה",
"dep.checkingDup": "בודקים כפילויות…",
"dep.color": "צבע",
"dep.colorPlaceholder": "למשל, שחור",
"dep.condition": "מצב",
"dep.conditionPlaceholder": "למשל, מצב טוב",
"dep.depositorNote": "הערת מניח",
"dep.depositorNoteHint": "פרטים תפעוליים שנכתבו ביד. ה-AI לא מוחק הערה זו.",
"dep.depositorNotePlaceholder": "למשל, תכולת תיק, מותג כפי שדווח, פרטים שנמסרו על ידי האדם…",
"dep.descPlaceholder": "למשל, אייפון 15 שחור עם כיסוי שקוף, נמצא בבר…",
"dep.description": "תיאור",
"dep.dupHint": "ודא שאינך מוסיף כפילות. אתה יכול להמשיך אם הפריט שונה לחלוטין.",
"dep.dupTitle": "פריט/ים דומים כבר רשומים",
"dep.dupWarn": "פריט דומה זוהה — בדוק, ואז לחץ שוב כדי לאשר.",
"dep.estHint": "הפריט יתווסף לרישום של המוסד הזה.",
"dep.establishment": "מוסד",
"dep.fee": "דמי משחק (€) — אופציונלי",
"dep.feePlaceholder": "השאר ריק עבור מחיר ברירת המחדל בקטגוריה",
"dep.photo2": "תמונת פריט 2",
"dep.photo2Hint": "אופציונלי — זווית נוספת משפרת את דיוק ההתאמה הוויזואלית.",
"dl.accountSuspended": "החשבון הוקפא בגלל חשבונית未שולמת. סיים זאת כדי לשחזר את הגישה שלך.",
"dl.regularize": "סיים עכשיו →",
"dl.suspensionCountdown": "חשבונית {num}未שולמת — החשבון שלך יוקפא בעוד {days} יום/ימים. סיים זאת כדי להימנע מכך.",
"ft.cancelConfirm": "לבטל את הדיווח שלך? בעל הפריט יידע.",
"ft.cancelDone": "הדיווח בוטל.",
"ft.cancelLocked": "ביטול אינו אפשרי לאחר שבעל הפריט שילם.",
"ft.cancelReport": "בטל את הדיווח שלי",
"ft.claimCodeHelp": "תן קוד זה למוצא בזמן מסירה כדי לאשר שקיבלת את הפריט שלך.",
"ft.claimCodeTitle": "קוד ההחזרה שלך",
"ft.claimDone": "הפריט הוחזר. תודה על השימוש ב-findloop!",
"ft.claimUnlockHint": "פתח את פרטי הקשר של המוצא",
"ft.claimUnlockHintSub": "עבור ל\"פריטים שאני תובע\" בחשבון שלך כדי לשלם את הדמי ולקבל את פרטי הקשר.",
"ft.finderCodeShownHelp": "הבעל שילם ובחר אותך. העתק קוד זה למטה כדי לאשר את ההחזרה — אין צורך לבדוק את הדוא\"ל שלך.",
"ft.finderCodeShownTitle": "קוד האישור של בעל הפריט",
"ft.finderContactsTitle": "פרטי קשר של המוצא",
"ft.foundCodeHelp": "הצג קוד זה לבעל בעת מסירת הפריט כדי לאשר שהפריט הוחזר.",
"ft.inProgressOther": "פריט בהחזרה",
"ft.inProgressOtherHelp": "הבעל בחר מוצא אחר עבור פריט זה. אין צורך בפעולה נוספת מצדך.",
"ft.restitutionCodeHelp": "קוד זה מאשר את מסירת הפריט. הוא כבר מלא למטה; אשר אותו ואז סגור את המקרה.",
"ft.restitutionCodeTitle": "קוד ההחזרה שלך",
"hc.14Digits": "14 תווים",
"hc.15DaysBeforeAnItem": "15 ימים לפני המועד החוקי של הפריט.",
"hc.7DaysBeforeAnItem": "7 ימים לפני המועד החוקי של הפריט.",
"hc.8CharactersMinimum": "8 תווים מינימום.",
"hc.aClaimToValidate": "דרישה לאישור",
"hc.aFindoAssistanceSessionIs": "יש סשן תמיכה של Findloop פעיל כרגע בחשבון שלך.",
"hc.aNewMatchHasBeen": "הושג התאמה חדשה",
"hc.aUser": "משתמש",
"hc.aUserClaimsToBe": "משתמש טוען להיות הבעלים. בדוק את התשובות שלהם לפני שמאשרים את ההחזרה.",
"hc.aboutFindo": "על Findloop",
"hc.accountActivatedPleaseLogIn": "החשבונות הופעל, אנא התחבר.",
"hc.accountActivation": "הפעלת חשבון",
"hc.accountCreated": "החשבון נוצר!",
"hc.accountDeactivatedAReactivationEmail": "החשבון נבנה. הודעת דוא\"ל על הפעלה מחדש (בתוקף ל-30 יום) נשלחה אליך.",
"hc.accountReactivation": "הפעלה מחדש של החשבון",
"hc.activateMyAccount": "הפעל את החשבון שלי",
"hc.activateMyAdminAccount": "הפעל את החשבון המנהלי שלי",
"hc.activating": "מפעיל…",
"hc.activeMatchCancelReason": "התאמה פעילה. סיבת הביטול של הלקוח: \"{reason}\". הפריט עדיין ממתין לדרישה.",
"hc.activeMatchWithAPublic": "התאמה פעילה עם רשימה ציבורית (לקוח). מחכה לדרישה של הבעל.",
"hc.addAPhoto": "הוסף תמונה",
"hc.addAndConfigureYourEstablishments": "הוסף והגדר את המוסדות שלך ב\"מוסדות\": פרטי קשר, קטגוריה ואחסון פיזי של פריטים.",
"hc.addOnGoogle": "הוסף ב-Google",
"hc.address": "כתובת",
"hc.addressSaved": "כתובת נשמרה",
"hc.addressStreet": "כתובת — רחוב",
"hc.adjustThePhoto": "התאם את התמונה",
"hc.adminFullView": "מנהל (תצוגה מלאה)",
"hc.administratorOnly": "רק למנהל",
"hc.africa": "אפריקה",
"hc.aiVisualComparison": "השוואת חזותית בעזרת AI",
"hc.all": "כל",
"hc.amount": "סכום",
"hc.anOrganization": "ארגון",
"hc.analyzing": "בוחן…",
"hc.andRecoveryIs": "והשחזור הוא",
"hc.andTheDeclarationWillBe": "וההכרזה תיסגר (תועבר להיסטוריה). פעולה זו סופית.",
"hc.annual20": "שנתי -20%",
"hc.annualBilling20": "חיוב שנתי (−20%)",
"hc.annualTarget": "יעד שנתי",
"hc.anyCommentsOptional": "האם יש הערות? (אופציונלי)",
"hc.approveTheClaim": "אשר את התביעה",
"hc.archiveCancelledConfirm": "לארכב {n} רישום/רישומים \"בוטל על ידי הלקוח\"? הם יוסרו מהרשימה.",
"hc.asSoonAs": "ברגע ש",
"hc.askTheOwnerToDisplay": "שאל את הבעלים להציג את ה-QR של הקוד שלו (דף מעקב).",
"hc.askThemAtTheCounter": "שאל אותם בדלפק לאישור זהות — לא גלוי לציבור.",
"hc.assistance": "תמיכה",
"hc.assistanceSessionRevoked": "הפסקת מפגש התמיכה.",
"hc.atLeast6Characters": "לפחות 6 תווים",
"hc.automaticallyPreSelected": "נבחר אוטומטית",
"hc.automaticallyWhenShipping": "אוטומטית בעת שליחה.",
"hc.awaitingClaim": "ממתין לתביעה",
"hc.awaitingPayment": "ממתין לתשלום",
"hc.b2cCustomer": "לקוח B2C",
"hc.back": "חזור",
"hc.backToHome": "חזור לדף הבית",
"hc.backToMyAccount": "חזור לחשבון שלי",
"hc.backToPayment": "חזור לתשלום",
"hc.beforeAfterComparisonSlider": "סליידר השוואת לפני/אחרי",
"hc.billingInformation": "מידע לחיוב",
"hc.billingInformationSaved": "מידע לחיוב נשמר ✓",
"hc.brand": "מותג",
"hc.bronze": "ברונזה",
"hc.calculatingTheShippingRate": "מחושב את שיעור המשלוח…",
"hc.cameraUnavailableEnterTheCode": "המצלמה לא זמינה. הכנס את הקוד ידנית.",
"hc.cancel": "בטל",
"hc.cancelMyDeclaration": "בטל את ההכרזה שלי",
"hc.cancelSavedFmt": "ביטול נשמר: \"{reason}\". עדיין תוכל לתבוע.",
"hc.cancelTheDeposit": "בטל את ההפקדה",
"hc.cancelThisMatch": "בטל את ההתאמה הזו",
"hc.cancellationReason": "סיבת הביטול",
"hc.cancelled": "בוטל",
"hc.cancelledByTheCustomer": "בוטל על ידי הלקוח",
"hc.cannotOpenPayment": "לא ניתן לפתוח את התשלום. אנא נסה שוב.",
"dec.descPhLong": "תאר את הפריט: מותג, צבע, סימנים ייחודיים… (ככל שתספק יותר פרטים, הסיכוי שלך לשחזר את הפריט שלך גבוה יותר)",
"dec.loadError": "לא ניתן לטעון את השותף כרגע. בדוק את החיבור שלך ונסה שוב.",
"dec.payConfirmed": "תשלום {x} אושר",
"dec.payPending": "תשלום חיצוני {x} ממתין",
"dec.phone": "טלפון",
"dec.pickup": "איסוף אישי",
"dec.place": "מקום אובדן",
"dec.placePh": "למשל: ליד הבר, חדר 204…",
"dec.recoverBtn": "שחזר את הפריט שלי",
"dec.reject": "דחה",
"dec.rerun": "רוץ שוב את הניתוח",
"dec.retry": "נסה שוב",
"dec.shippingMode": "משלוח",
"dec.similarity": "דמיון {n}%",
"dec.submit": "שלח את הדיווח שלי",
"dec.submitting": "שולח…",
"dec.successText": "אנחנו מחפשים את הפריט שלך בין אלה שנמצאים ב",
"dec.successTitle": "דיווח נשלח!",
"dec.suggestedMatches": "תוצאות מוצעות",
"dec.toColon": " ל:",
"dec.toShip": "לשלוח",
"dec.toastExtPay": "התשלום אושר — הלקוח יקבל הודעה.",
"dec.toastMatch": "התאמה אושרה",
"dec.toastReject": "ההצעה נדחתה",
"dec.toastRerun": "הניתוח מחדש הושק",
"dec.toastVisualN": "{n} התאמה ויזואלית/ות",
"dec.toastVisualNone": "אין התאמה ויזואלית",
"dec.trackBtn": "עקוב אחרי הדיווח שלי",
"dec.viewBeforeAfter": "תצוגת לפני/אחרי ( Overlay )",
"dec.viewSideBySide": "תצוגה צד לצד",
"dec.visualCompare": "השוואה ויזואלית של AI",
"dec.visualIdle": "הרץ את ההשוואה כך שה-AI יתאים ויזואלית את התמונה של הלקוח עם הפריטים שנמצאו.",
"dec.visualRunning": "ה-AI משווה את התמונה של הלקוח עם הפריטים ברשימה שלך…",
"dec.zoomPhoto": "הגדל את התמונה",
"dep.addAnyway": "הוסף בכל מקרה",
"dep.addError": "שגיאה בזמן הוספה",
"dep.addItem": "הוסף פריט",
"dep.added": "הפריט הוסף לרשימה!",
"dep.adding": "מוסיף…",
"dep.aiError": "ניתוח ה-AI לא זמין כרגע.",
"hc.careers": "קריירה",
"hc.carrier": "ספק שירותים",
"hc.carrierAvailabilityCannotBeChecked": "לא ניתן לבדוק את זמינות הספק עד אשר שליח ה-Sendcloud שלך מת configured.",
"hc.carrierConfirmedCharged": "הספק אישר — {price} € יחויבו מהלקוח",
"hc.carrierOther": "ספק שירותים (אחר)",
"hc.carrierSelection": "בחירת ספק שירותים",
"hc.caseClosedThankYou": "המקרה נסגר. תודה!",
"hc.category": "קטגוריה",
"hc.changeMethod": "שנה שיטה",
"hc.characteristic": "מאפיין",
"hc.chargedToCustomer": "חויב מהלקוח.",
"hc.checkOrEditYourDetails": "בדוק או ערוך את הפרטים שלך לפני התשלום המאובטח.",
"hc.checkStatisticsToTrackDeposited": "בדוק \"סטטיסטיקות\" כדי לעקוב אחרי פריטים מופקדים, שיעור החזר וביצועים של כל מוסד.",
"hc.checkTheDetailsBeforeContacting": "בדוק את הפרטים לפני שאתה פונה למגלה.",
"hc.checkTheDetailsBelowBefore": "בדוק את הפרטים למטה לפני התחלת בקשת ההחזרה שלך.",
"hc.checkTheNewItem": "בדוק את הפריט החדש",
"hc.checkThePhotosAndCharacteristics": "בדוק את התמונות והמאפיינים למטה לפני שאתה ממשיך בקבלת המוצר.",
"hc.chooseACountry": "בחר מדינה",
"hc.chooseANewPassword": "בחר סיסמה חדשה",
"hc.chooseAReason": "בחר סיבה",
"hc.chooseTheLegalRetentionAlerts": "בחר את התראות השימור החוקי שתקבל בדוא\"ל עבור",
"hc.chooseYourPasswordToAccess": "בחר את הסיסמה שלך כדי לגשת למסוף הניהול.",
"hc.city": "עיר",
"hc.claimApproved": "תביעה אושרה",
"hc.claimApproved2": "תביעה אושרה.",
"hc.claimCodeExpired": "קוד התביעה פג",
"hc.claimCodeVerified": "קוד התביעה אומת",
"hc.claimNotFound": "לא נמצאה תביעה",
"hc.claimNotValidated": "התביעה לא אומתה",
"hc.claimRejected": "התביעה נדחתה",
"hc.claimRejected2": "התביעה נדחתה.",
"hc.claimValidated": "התביעה אומתה",
"hc.claimValidatedByThePartner": "התביעה אומתה על ידי השותף",
"hc.claimant": "תובע",
"hc.claimsToBeTheOwner": "טוען להיות בעל הפריט הזה וענה על שאלות האימות. אשר רק אם התשובות תואמות.",
"hc.claimsToValidate": "תביעות לאימות",
"hc.clear": "נקה",
"hc.clickToZoom": "לחץ כדי לזום",
"hc.close": "סגור",
"hc.close2": "סגור",
"hc.closeTheDeclaration": "סגור את ההצהרה",
"hc.closeTheDeclaration2": "לסגור את ההצהרה?",
"hc.codeAlreadyVerified": "הקוד כבר אומת",
"hc.codeCopied": "הקוד הועתק",
"hc.collapse": " collapsed ",
"hc.color": "צבע",
"hc.company": " חברה",
"hc.companyName": "שם החברה",
"hc.comparePhotos": "השווה תמונות",
"hc.compareThemWithTheOwner": "השווה אותם עם התשובות של בעל המוצר - לא ייראו בציבור.",
"hc.condition": "מצב",
"hc.confirmAndPay": "אשר ושתף",
"hc.confirmCancellation": "אשר ביטול",
"hc.confirmCrop": "אשר חיתוך",
"hc.confirmDeletion": "אשר מחיקה",
"hc.confirmPassword": "אשר סיסמה",
"hc.confirmThatThisIsYour": "אשר שזה פריט שלך. בדיקת זהות תתבקש מהמאתר לפני כל קשר.",
"hc.confirmTheCarrier": "אשר את המוביל",
"hc.confirmThePassword": "אשר את הסיסמה",
"hc.confirmYourShippingAddressTo": "אשר את כתובת המשלוח שלך כדי להמשיך בתשלום.",
"hc.confirmYourSubscription": "אשר את המנוי שלך",
"hc.confirmed": "מאושר ✓",
"hc.contactFindoToGetYour": "צור קשר עם Findloop כדי לקבל את מזהה השולח שלך.",
"hc.contactUs": "צור קשר",
"hc.continueTheReturn": "המשך בהחזרה",
"hc.continueToPayment": "המשך לתשלום",
"hc.copy": "העתק",
"hc.correctMyDetails": "תקן את הפרטים שלי",
"hc.correctThisEntry": "לתקן את הרשומה הזו?",
"hc.country": "מדינה",
"hc.countryAddress": "מדינה (כתובת)",
"hc.countryIsoCodeEG": "מדינה (קוד ISO, לדוגמה FR)",
"hc.cover": "כריכה",
"hc.createTheShipment": "צור את המשלוח",
"hc.cropThePhoto": "חיתוך התמונה",
"hc.customer": "לקוח",
"hc.customerClaimCodeToCheck": "קוד תביעה של הלקוח - לבדוק באיסוף:",
"hc.customerReasonFmt": "סיבת הלקוח: \"{reason}\".",
"hc.customerReminderDelay": "עיכוב תזכורת ללקוח",
"hc.customerWhosePublicListingMatches": "לקוח שמודעות הציבור שלו תואמות פריט זה - נראה רק לך.",
"hc.d15": "D-15",
"hc.dangerZone": "אזור סכנה",
"hc.date": "תאריך",
"hc.dateNewest": "תאריך (החדש ביותר)",
"hc.dateOldest": "תאריך (הישן ביותר)",
"hc.daysToYearEnd": "{n} ימים עד סוף השנה",
"hc.deadlineAlert": "התראה על מועד אחרון",
"hc.declarationClosed": "הצהרה סגורה ✓",
"hc.declarationNotFound": "הצהרה לא נמצאה.",
"hc.declarationNotFound2": "הצהרה לא נמצאה",
"hc.declarationTracking": "מעקב אחר ההצהרה",
"hc.defaultCarrier": "שירות ברירת מחדל",
"hc.defaultCarrierPreselected": "שירות ברירת מחדל נבחר מראש — ניתן לשנות עבור משלוח זה. שיעור בפועל (Sendcloud + {m}% רווח).",
"hc.defaultCarrierRemoved": "שירות ברירת מחדל הוסר",
"hc.delayHours": "עיכוב (שעות)",
"hc.deleteMyAccount": "מחק את החשבון שלי",
"hc.deleting": "מוחק…",
"hc.deletingDeactivatesYourAccountLogin": "מחקה מבטל את החיבור לחשבון שלך: גישה נחסמת והנתונים נשמרים למשך 30 ימים. תקבל דוא\"ל עם קישור להחזרה בתוקף למשך 30 ימים.",
"hc.delivered": "נמסר",
"hc.depositAnItem": "הפקד פריט",
"hc.depositCancelledItemPutBack": "הפקדה בוטלה — הפריט הוחזר למלאי.",
"hc.depositCancelledItemRemovedFrom": "הפקדה בוטלה — הפריט הוסר מהרשימה.",
"hc.depositedOn": "הופקד ב",
"hc.describeTheItemBrandColor": "תאר את הפריט: מותג, צבע, סימנים מזהים… (ככל שתיתן יותר פרטים, הסיכויים שלך למצוא את הפריט שלך גדלים.)",
"hc.dimensionsCm": "ממדים (ס\"מ)",
"hc.disablingAnEmail": "השבתת דוא\"ל",
"hc.doesNotHide": "לא מסתיר",
"hc.download": "הורד",
"hc.downloadThePdf": "הורד את ה-PDF",
"hc.draftRestoredPickUpYour": "טיוטה שוחזרה — אסוף את ההצהרה שלך מהמקום שבו הפסקת.",
"hc.dragToReposition": "גרור כדי למקם מחדש",
"hc.eGColisPriv": "למשל: Colis Privé",
"hc.eachItemGetsAQr": "כל פריט מקבל תווית QR. סרוק אותו מ\"אחסון ו-QR\" כדי למקם פריט ברגע.",
"hc.eachSiteManagesItsOwn": "כל אתר מנהל את הבנקאות שלו. עבור ל",
"hc.edit": "ערוך",
"hc.emailNotificationPreferences": "העדפות התראות בדוא\"ל",
"hc.emailPreferencesUpdated": "העדפות הדוא\"ל עודכנו",
"hc.enableOrDisableRecoveryFees": "אפשר או השבת דמי חזרת עבור",
"hc.enlargePhoto": "הגדל תמונה",
"hc.enterTheCustomerSCode": "הזן את קוד הלקוח",
"hc.estShipRate": "שער משלוח מוערך (Sendcloud + {m}% רווח):",
"hc.establishment": "מוסד",
"hc.establishment2": "מוסד:",
"hc.establishmentInItsSendcloudAccount": "מוסד בחשבון ה-Sendcloud שלו ומספק לך את מזהה השולח",
"hc.establishmentSettings": "הגדרות המוסד",
"hc.exCode": "למשל, ABCD2345",
"hc.exId": "למשל, 3f2a…",
"hc.exit": "יציאה",
"hc.explainWhyThisItemIs": "הסבר למה הפריט הזה לא שלך…",
"hc.externalPaymentLinks": "קישורי תשלום חיצוניים",
"hc.failed": "נכשל",
"hc.feesEnabled": "עמלות מופעלות",
"hc.field": ") שדה.",
"hc.finderAcceptedCloseTheCase": "המגלה קיבל — סגור את המקרה ברגע שהפריט הועבר באופן אישי.",
"hc.findoCityRanking": "Findloop — דירוג ערים",
"hc.findoForEstablishments": "Findloop עבור מוסדות",
"hc.findoPresentationVideo": "וידאו מצגת Findloop",
"hc.findoRegistersTheAddressOf": "Findloop רושם את הכתובת של ה",
"hc.findoReviewShare": "סקירת Findloop {year}: {n} פריטים הוחזרו, שיעור החזרה {rate}% 🎉",
"hc.firstVerifyTheClaimCode": "ראשית אשר את קוד התביעה למעלה",
"hc.forEveryNewShipmentFrom": "עבור כל משלוח חדש מ-",
"hc.free": "חינם",
"hc.freeRecovery0": "שחזור חינם (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "שחזור חינם ברחבי אפריקה – הצעת השקה",
"hc.freeRecoveryFeesDisabled0": "שחזור חינם: עמלות מבוטלות (0 €)",
"hc.fromTeamInviteYourColleagues": "מ\"צוות\", הזמן את הקולגות שלך בדוא\"ל והענק להם מוסד. כל חבר רואה רק את התחום שלו.",
"hc.fullName": "שם מלא",
"hc.fullPhoto": "תמונה מלאה",
"hc.gallery": "גלריה",
"hc.giveTheReasonForCancelling": "הענק את הסיבה לביטול. השותף ייעודע.",
"hc.goToLogin": "עבור להתחברות",
"hc.goToMyAccount": "עבור לחשבון שלי",
"hc.gold": "זהב",
"hc.googleLoginFailed": "התחברות באמצעות Google נכשלה",
"hc.hasConfirmedYourPaymentYou": "אישר את התשלום שלך, תועבר אוטומטית",
"hc.helpCenter": "מרכז עזרה",
"hc.helpUsImproveWhyAre": "עזור לנו להשתפר: למה אתה עוזב? החשבון שלך יתבטל וניתן להפעילו מחדש במשך 30 ימים.",
"hc.hidePassword": "הסתיר סיסמה",
"hc.high": "גבוה",
"hc.historyOfYourMonthlySubscriptions": "היסטוריה של המנויים החודשיים שלך ומצב התשלום שלהם.",
"hc.hotelBelmont": "מלון בלמונט",
"hc.howConfigureSenderId": "איך להגדיר את מזהה השולח המספרי שלי?",
"hc.iDonTUseIt": "אני לא משתמש בזה מספיק",
"hc.iFoundItElsewhere": "מצאתי את זה במקום אחר",
"hc.iNoLongerNeedMy": "אני כבר לא צריך את הפריט שלי",
"hc.identityVerification": "אימות זהות",
"hc.idleLogoutIn": "תתנתק בעוד {n} שניות בשל חוסר פעילות.",
"hc.ifProvidedTheVolumetricWeight": "אם סופק, משקל המיכלים ייעשה בו שימוש.",
"hc.ifThePartnerHasNot": "אם השותף לא אישר את קבלת התשלום החיצוני לאחר שהשהות הזו, Findloop מזכיר אוטומטית לשותף לאמת את זה.",
"hc.impersonationEnded": "סיום חיקוי.",
"hc.impersonationMode": "מצב חיקוי",
"hc.impersonationSessionExpired": "פגישת החיקוי פגה.",
"hc.inTheField": ", בשטח",
"hc.inTransit": "בתוך העברה",
"hc.inclVat": "כולל מע\"מ",
"hc.intraEuVatNumberOptional": "מספר מע\"מ בין מדינות האיחוד האירופי אופציונלי, ללא דרישת SIRET (מחוץ לצרפת).",
"hc.invalidInvitationLink": "קישור הזמנה לא חוקי.",
"hc.invalidInvitationLink2": "קישור הזמנה לא חוקי",
"hc.invalidInviteLink": "קישור הזמנה לא חוקי או פג.",
"hc.invalidNumberEnterAnInternational": "מספר לא חוקי. הזן מספר בינלאומי, למשל +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "קישור לא חוקי או פג.",
"hc.invalidOrExpiredReactivationLink": "קישור להפעלת מחדש לא חוקי או פג",
"hc.invalidSendcloudId": "מזהה Sendcloud לא חוקי",
"hc.inviteSubtitle": "{org} מזמין אותך להצטרף לצוות Findloop שלהם. בחר את הסיסמה שלך כדי להפעיל את החשבון שלך.",
"hc.isAvailableOnSendcloudFor": "זמין על Sendcloud עבור כל המסלולים שלך (פנימיים + בינלאומיים).",
"hc.isNotEnabledOnYour": "לא מופעל בחשבון Sendcloud שלך עבור כמה יעדים. תוויות עבור אלה ייווצרו עם חברת משלוחים זמינה אחרת.",
"hc.isThisReallyYourItem": "האם זה באמת הפריט שלך?",
"hc.isThisYourItem": "האם זה הפריט שלך?",
"hc.item": "פריט",
"hc.itemAlreadyConfirmed": "הפריט כבר אושר",
"hc.itemDetails": "פרטי הפריט",
"hc.itemFoundAt": "הפריט נמצא ב",
"hc.itemFoundAtAPartner": "הפריט נמצא אצל שותף",
"hc.itemMarkedAsReturned": "הפריט סימן כהוחזר ✓",
"hc.itemPhotoRequiredBeforeShipping": "תמונת הפריט (דרושה לפני המשלוח)",
"hc.itemPhotoSaved": "תמונת הפריט נשמרה",
"hc.itemPreview": "תצוגה מקדימה של הפריט",
"hc.itemPutBackInStorage": "הפריט הוחזר לאחסון.",
"hc.itemWeight": "משקל הפריט:",
"hc.itemsReturned": "פריט(ים) חוזרים",
"hc.itemsReturnedThisYear": "פריטים שהוחזרו השנה",
"hc.itemsWhoseLegalDeadlineIs": "פריטים שהמועד החוקי שלהם הוא 15 ימים או פחות (כולל פיגורים). ההתאמות נשארות גלויות.",
"hc.kbisNumber": "מספר קביס",
"hc.keysForgottenOnABench": "מפתחות שנשכחו על ספסל",
"hc.labelBeingGenerated": "תווית נוצרת",
"hc.leaveTheFieldsEmptyTo": "השאירו את השדות ריקים כדי להציע שיחזור בחינם.",
"hc.legalNotice": "הודעה משפטית",
"hc.limitReachedUpgradeToA": "הגעת למגבלה - שנה לתוכנית גבוהה יותר",
"hc.linkCopiedShareOn": "הקישור הועתק - שתף אותו ב-{label}",
"hc.linkUnavailable": "הקישור אינו זמין",
"hc.linkedTo": "מקושר ל",
"hc.listingHiddenByModeration": "הרשימה מוסתרת על ידי מודרציה.",
"hc.loading": "בטעינה…",
"hc.locateMe": "מצא אותי",
"hc.logIn": "התחבר",
"hc.logInToGetBack": "התחבר כדי לחזור למקום שלך ולנהל את המנוי שלך.",
"hc.loginFailed": "ההתחברות נכשלה",
"hc.lostFoundPlatform": "פלטפורמת אבודה & מצאה.",
"hc.lostIn": "אבוד ב",
"hc.lowRate": "שיעור נמוך",
"hc.mainReason": "סיבה עיקרית",
"hc.mainStreet": "רחוב ראשי",
"hc.makeSureThisIsThe": "ודא שזה הפריט שאיבדת לפני שתחלוק את פרטי הקשר של המוצא.",
"hc.manageCookies": "נהל עוגיות",
"hc.manageMyTeam": "נהל את הצוות שלי",
"hc.manageYourTeam": "נהל את הצוות שלך",
"hc.markAsReturned": "סמן כהחזר",
"hc.matchNoClaimInTime": "לא התקבלה טענה לגבי ההתאמה בזמן.",
"hc.matchNotFound": "ההתאמה לא נמצאה",
"hc.medium": "בינוני",
"hc.milestoneFmt": "{m} פריטים שהוחזרו הושגו! בדרך ל-{next}.",
"hc.missingFeatures": "תכונות חסרות",
"hc.monthly": "חודשי",
"hc.monthlyBilling": "חיוב חודשי",
"hc.moveThePhotoToFit": "הזז את התמונה כדי להתאים אותה במעגל.",
"hc.myAccount": "החשבון שלי",
"hc.myInvoices": "החשבים שלי",
"hc.myMonthlyInvoices": "החשבוניות החודשיות שלי",
"hc.nArchived": "{n} רשימה(ות) ארכיבות.",
"hc.newCodeGeneratedAndSent": "קוד חדש נוצר ונשלח ללקוח בדואר אלקטרוני וב-SMS",
"hc.newCodeGeneratedAndSent2": "קוד חדש נוצר ונשלח לבעלים",
"hc.newPassword": "סיסמה חדשה",
"hc.next": "הבא",
"hc.nextPhoto": "תמונה הבאה",
"hc.no": "לא",
"hc.noAnswerProvided": "לא ניתנה תשובה.",
"hc.noArchivedDeclarations": "אין הצהרות ארכובות",
"hc.noCountryFound": "לא נמצא אף מדינה",
"hc.noDeclarations": "אין הצהרות",
"hc.noFeesAreChargedTo": "לא גובים דמי שירות מהלקוח.",
"hc.noInvoiceYet": "אין עדיין חשבונית.",
"hc.noInvoiceYetYourInvoices": "אין עדיין חשבונית. החשבוניות שלך יופיעו כאן אוטומטית לאחר כל תשלום.",
"hc.noMatchIsAvailableFor": "אין התאמה זמינה בשלב זה. נודיע לך ברגע שמוצר יתאים להצהרה שלך.",
"hc.noShipmentMatchesYourSearch": "אין משלוחים שמתאימים לחיפוש שלך.",
"hc.noShipmentsYet": "אין עדיין משלוחים.",
"hc.noShipmentsYet2": "אין עדיין משלוחים",
"hc.none": "אין",
"hc.noneChooseForEachShipment": "אין (בחר עבור כל משלוח)",
"hc.notMine": "זה לא שלי",
"hc.of": "של",
"hc.only": "רק",
"hc.onlyEachSiteManagesIts": "רק. כל אתר מנהל את הבנקאות שלו: הקישורים הללו לא משפיעים על שום מוסד אחר.",
"hc.onlyTheOwnerOrAn": "רק הבעלים או מנהל יכולים להגדיר את קישורי התשלום של המוסד.",
"hc.openDepositInTheMenu": "פתח את \"הפקדה\" בתפריט, תאר את הפריט וצור תמונה. הוא נשמר מיד ומוכן להחזיר.",
"hc.openSettings": "פתח הגדרות →",
"hc.openTheDeclarationToManage": "פתח את ההצהרה כדי לנהל את המשלוח",
"hc.optional": "— אופציונלי",
"hc.optional2": "(אופציונלי)",
"hc.optional3": "אופציונלי",
"hc.originalListingPhotoUsed": "התמונה המקורית של הרשימה בשימוש",
"hc.other": "אחר",
"hc.other2": "אחר…",
"hc.ourProducts": "המוצרים שלנו",
"hc.overallRateTrendLast6": "מגמת ריבית כוללת (6 החודשים האחרונים)",
"hc.ownerSClaimCode": "קוד התביעה של הבעלים",
"hc.ownershipConfirmed": "בעלות אושרה",
"hc.paid": "שולם",
"hc.paidOn": "שולם ב",
"hc.paidViaPartner": "שולם (דרך שותף)",
"hc.parcelBeingPrepared": "חבילה בהכנה",
"hc.parcelDelivered": "חבילה נמסרה",
"hc.parcelShipped": "חבילה נשלחה",
"hc.parisGareDeLyon": "פריז, גאר דה ליון…",
"hc.partner": "שותף",
"hc.partner2": "שותף",
"hc.partnerDirectory": "מדריך שותפים",
"hc.passedOnToTheCustomer": "— הועבר ללקוח קישור לתשלום.",
"hc.password": "סיסמה",
"hc.passwordResetPleaseLogIn": "איפוס סיסמה, אנא התחבר.",
"hc.passwordUpdated": "הסיסמה עודכנה.",
"hc.passwordsDoNotMatch": "הסיסמאות אינן תואמות.",
"hc.pasteThisSenderIdIn": "הדבק את מזהה השולח הזה ב-Findloop → הגדרות",
"hc.payForTheShipmentOf": "שלם עבור משלוח הפריט שלך דרך Findloop עם תשלום מאובטח.",
"hc.payTheRecoveryFees": "שלם את דמי השחזור",
"hc.payTheShippingFees": "שלם את דמי המשלוח",
"hc.payment": "תשלום",
"hc.paymentAlreadyConfirmedByThe": "התשלום כבר אושר על ידי השותף",
"hc.paymentLinksAreNowConfigured": "קישורי התשלום כעת מוגדרים לפי מוסד",
"hc.paymentNotCompletedYourAccount": "התשלום לא הושלם, החשבון שלך לא נוצר — אנא נסה שוב.",
"hc.paymentReceived": "התשלום התקבל",
"hc.paymentSuccessful": "התשלום הצליח!",
"hc.pdfInvoice": "חשבונית PDF",
"hc.pending": "ממתין",
"hc.period": "תקופה",
"hc.phoneNumber": "מספר טלפון",
"hc.phoneOptional": "טלפון (אופציונלי)",
"hc.planAt": "תכנית ב",
"hc.planLimitFmt": "התכנית שלך \"{plan}\" מוגבלת ל-{max} מוסדות. לניהול {n} אתרים, אנו ממליצים על",
"hc.platformReturnTarget": "מטרה לחזרה בפלטפורמה",
"hc.pleaseCompleteYourShippingAddress": "אנא מלא את כתובת המשלוח שלך.",
"hc.pleaseProvideAPhoneNumber": "אנא ספק מספר טלפון: זה נדרש על ידי המוביל למשלוח.",
"hc.pleaseProvideAReason": "אנא ספק סיבה.",
"hc.pleaseSetYourOwnPassword": "אנא קבע סיסמה משלהך לפני המשך.",
"hc.pointsToGoal": "{n} נקודות נוספות כדי להגיע למטרה המשותפת שלנו.",
"hc.posterPreview": "תצוגה מקדימה של פוסטר",
"hc.potentialMatchBeingVerified": "תיאום פוטנציאלי מאומת",
"hc.potentialOwner": "בעל פוטנציאלי",
"hc.preFilledAutomaticallyYouCan": "מולא באופן אוטומטי — תוכל להחליף זאת בתמונה של החבילה.",
"hc.pressKit": "ערכת עיתונאים",
"hc.previewMode": "מצב תצוגה מקדימה:",
"hc.previewOfThePrintReady": "תצוגה מקדימה של פוסטר A4 המוכן להדפסה עבור המקום הזה.",
"hc.previous": "הקודם",
"hc.previousPhoto": "התמונה הקודמת",
"hc.primary": "ראשי",
"hc.printThePoster": "הדפס את הפוסטר",
"hc.privacy": "פרטיות",
"hc.privacyPolicy": "מדיניות פרטיות",
"hc.processedCasesWillAppearHere": "מקרים מעובדים יופיעו כאן.",
"hc.proofOfReturnPdf": "הוכחת החזרה (PDF)",
"hc.protectedByRecaptcha": "מוגן על ידי reCAPTCHA",
"hc.publicMatch": "מתאם ציבורי",
"hc.putBackInStorage": "שוב במאגרים",
"hc.pwdResetByTeam": "סיסמתך הוחלפה על ידי הצוות שלנו. למען ביטחונך,",
"hc.questionsToAskTheOwner": "שאלות לשאול את הבעלים",
"hc.rateChargedToTheCustomer": "שיעור שנגבה מהלקוח:",
"hc.rateOfTarget": "{rate}% הושג מתוך {target}%",
"hc.reached": "הושג",
"hc.reactivating": "מגיב מחדש…",
"hc.reasonSavedYouCanStill": "סיבה נשמרה. אתה עדיין יכול לדרוש את הפריט שלך.",
"hc.recentMatchesFirst": "התאמות האחרונות ראשונות",
"hc.recognizedThePhotoYouSent": "זיהה את התמונה ששלחת ותיאר את המאפיינים הללו. אשר רק אם הם תואמים את הפריט שברשותך.",
"hc.recommended": "מומלץ",
"hc.recoveryFees": "עמלות שחזור",
"hc.recoveryFeesArePaidDirectly": "עמלות השחזור משולמות ישירות למוסד שותף. Findloop לא מקבל תשלום מהלקוחות.",
"hc.recoveryFeesEnabled": "עמלות השחזור מותאמות",
"hc.recoveryOfferedByTheEstablishment": "שחזור המוצע על ידי המוסד — Findloop לא גובה דמי טיפול.",
"hc.recoveryPaymentLink": "קישור לתשלום שחזור",
"hc.recoveryPaymentLinkSavedFor": "קישור לתשלום שחזור נשמר עבור מקום זה",
"hc.redirecting": "מכוון מחדש…",
"hc.redirectingToPayment": "מכוון מחדש לתשלום…",
"hc.redirectingToTheRecoveryOf": "מכוון מחדש לשחזור הפריט שלך…",
"hc.regenerateAndResendToThe": "גנרציה מחדש ושליחה לבעלים",
"hc.regenerateTheCode": "גנרציה מחדש של הקוד",
"hc.registerAFoundItem": "רישום פריט נמצא",
"hc.rejectTheClaim": "דחיית התביעה",
"hc.reminderDelaySaved": "עיכוב תזכורת נשמר",
"hc.reopenThePaymentLink": "פתח מחדש את קישור התשלום",
"hc.repeatThePassword": "חזור על הסיסמה",
"hc.targetReached": "היעד הושג",
"hc.targetReachedThankYouTo": "היעד הושג — תודה לכל קהילת Findloop!",
"hc.tellUsMore": "ספרו לנו עוד…",
"hc.tellUsWhyYouCancel": "תגידו לנו למה אתם מבטלים. זה עוזר להתPartner לעבד את הבקשה שלכם.",
"hc.tellUsWhyYourListing": "תגידו לנו למה. הרשימה שלכם נשארת פעילה ואתם יכולים עדיין לדרוש את הפריט שלכם.",
"hc.termsAndConditions": "תנאים והגבלות",
"hc.termsAndPolicies": "תנאים ופוליסות",
"hc.thankYouForYourFeedback": "תודה על הפידבק שלכם",
"hc.theBannerDisplayedInThe": "הבאנר מוצג ברישום.",
"hc.theClaimantHasBeenInformed": "המבקש הודע. הפריט נשאר זמין ברשימה הציבורית.",
"hc.theClaimantHasBeenNotified": "המבקש עודכן וברשותו להמשיך בהחזרה.",
"hc.theCustomerPaysTheFees": "הלקוח משלם את העמלות למוסד.",
"hc.theDayTheLegalRetention": "היום שבו מגיעה תקופת ההחזרה החוקית.",
"hc.theEstablishmentConsideredThatThis": "המוסד שחשב שהפריט הזה לא שייך לך.",
"hc.theEstablishmentIsReviewingYour": "המוסד בודק את התשובות שלך. תודע כשבקשתך תאושר, ואז תוכל לשלם את העמלות להחזרה.",
"hc.theFeesAreTooHigh": "העמלות גבוהות מדי",
"hc.theFinderConsideredThatThis": "המוצא שחשב שהפריט הזה לא שייך לך.",
"hc.theFinderIsReviewingYour": "המוצא בודק את הבקשה שלך. תודע כשזו תאושר.",
"hc.theItem": "הפריט",
"hc.theItemWillBeRemoved": "הפריט יוסר מהרישום (אין דרישה בתהליך).",
"hc.theItemWillBeSet": "הפריט יוחזר ל\"זמין\" והדרישה המדוברת תבוטל.",
"hc.theKbisNumberAndVat": "מספר Kbis ומספר מע\"מ נדרשים לצרפת.",
"hc.theLabelIsGeneratedAutomatically": "התיוג נוצר אוטומטית ברגע שהלקוח שילם את דמי המשלוח. הוא יהיה ניתן להורדה כאן.",
"hc.theLinkMayHaveExpired": "הקישור עשוי להיות פג תוקף (בתוקף ל-30 ימים). פנו לתמיכת Findloop אם צריך.",
"hc.theOwnerDescribesTheirItem": "הבעל מתאר את הפריט שלו",
"hc.theOwnerReceivedItBy": "הבעל קיבל את זה בדואר אלקטרוני (או SMS). הכנס או סרוק את זה לפני המסירה.",
"hc.thePartnerConsideredThatThis": "השותף חשב שהפריט הזה לא שייך לך. הפריט נשאר זמין.",
"hc.thePartnerIsReviewingYour": "השותף בודק את התשובות שלך. תודע כאשר בקשתך תאושר.",
"hc.theShipmentIsCreatedAutomatically": "המשלוח נוצר אוטומטית כאשר הלקוח אישר את הכתובת שלו ושילם את העמלות להחזרה. התיוג ייווצר אוטומטית לאחר תשלום המשלוח, וניתן להורדה כאן.",
"hc.theShippingRateWillBe": "עלויות המשלוח יחשבו אוטומטית דרך Sendcloud בשעת המשלוח (משקל רשום).",
"hc.thisCarrierWillBe": "המוביל הזה יהיה",
"hc.thisEstablishment": "המוסד הזה",
"hc.thisFieldIsRequiredFor": "שדה זה נדרש ליצירת תיוג אוטומטי.",
"hc.thisIsMyItem": "זה הפריט שלי",
"hc.thisIsMyItemContinue": "זה הפריט שלי — המשך",
"hc.thisIsMyItemStart": "זה הפריט שלי — התחל את ההחזרה",
"hc.thisIsNotMyItem": "זה לא הפריט שלי",
"hc.thisMatchIsNoLonger": "התאמה זו אינה זמינה יותר או כבר טופלה.",
"hc.thisRateWillBeCharged": "עלות זו תחויב ללקוח. עלות גבוהה עשויה להרתיע מהחזרה.",
"hc.thisStepIsRequiredFor": "שלב זה נדרש על מנת ליצור תוויות משלוח.",
"hc.thisValidationLinkIsInvalid": "קישור האימות הזה אינו תקף או שפג תוקפו.",
"hc.toCheckBeforeMarkingThe": "לפני סימון הפריט כמוחזר, יש לבדוק.",
"hc.toConfigureTheLinksAnd": "לבודד את הקישורים ועיכובי התזכורת עבור כל מוסד.",
"hc.toReachOurFirstMilestone": "להשיג את הישג הראשון שלנו של 100 החזרות.",
"hc.toTheCustomer": "ללקוח.",
"hc.toTheShippingFeePayment": "לתשלום על דמי השילוח.",
"hc.toYourRecoveryTracking": "לעקוב אחרי ההתאוששות שלך.",
"hc.tooExpensiveBudget": "יקר מדי / תקציב",
"hc.topCitiesForReturns": "ערים מובילות להחזרות",
"hc.trackMyRecovery": "עקוב אחרי ההתאוששות שלי",
"hc.trackTheShipmentAndDownload": "עקוב אחרי השילוח והורד את הלייבל (נוצר אוטומטית) מבלי לצאת מהטאב של ההצהרות.",
"hc.trackYourStatistics": "עקוב אחרי הסטטיסטיקות שלך",
"hc.tracking": "מעקב",
"hc.unableToOpenTheShipping": "Unable to open the shipping fee payment. Please try again.",
"hc.unableToRetrieveTheInvoice": "לא ניתן retrieve את החשבונית.",
"hc.unclaimed": "לא נתבע",
"hc.unclaimedCustomerReason": "פריט לא נתבע. סיבת הלקוח: \"{reason}\".",
"hc.unclaimedItem": "פריט לא נתבע",
"hc.unclaimedItemNoClaimWithin": "פריט לא נתבע — לא נתבע בתוך המועד.",
"hc.unclaimedItems": "פריטים לא נתבעים",
"hc.unclaimedItemsMatchLeftWithout": "פריטים לא נתבעים: התאמה שנשארה ללא תביעה בתוך המועד. ניתן להחזיר אותם לאחסון.",
"hc.unlockTheFinderSContact": "שחרר את פרטי הקשר של המוצא כדי לסדר את העברת הפריט.",
"hc.upcoming": "קרוב",
"hc.updateFailed": "עדכון נכשל.",
"hc.usedForInvoices": "שמש ליצירת החשבוניות שלך ב-findloop.",
"hc.vatNumber": "מספר מע\"מ",
"hc.verificationPending": "אימות ממתין",
"hc.verificationSentToTheFinder": "אימות נשלח למוצא. תתעדכן בהחלטתם.",
"hc.verificationSentToThePartner": "אימות נשלח לשותף. תתעדכן בהחלטתם.",
"hc.verify": "אמת",
"hc.verifyingInvite": "מאמת את קישור ההזמנה…",
"hc.verifyingTheLink": "מאמת את הקישור…",
"hc.viewInRegistry": "הצג במרשם",
"hc.viewItem": "הצג פריט",
"hc.viewItemRecover": "הצג פריט & התאושש",
"hc.visibleToTheOwnerAutomatically": "נראה לבעלים · נמחק אוטומטית לאחר 60 ימים.",
"hc.waitingForPartnerConfirmation": "ממתין לאישור השותף",
"hc.waitingForThePartnerS": "ממתין לאישור השותף",
"hc.weHaveInformedTheEstablishment": "הודענו למוסד שהפריט הזה אינו שלך והתחלנו מחדש את הניתוח. תתעדכן ברגע שימצא התאמה חדשה.",
"hc.weHaveInformedThePartner": "הודענו לשותף שהפריט הזה אינו שלך. הרישום שלך נשאר פעיל להתאמות עתידיות.",
"hc.weRanTheAnalysisAgain": "ערכנו את הניתוח שוב וזיהינו פריט נוסף שעשוי להיות שלך. אנא בדוק זאת שוב.",
"hc.weight": "משקל",
"hc.weightNotProvidedTheShipping": "משקל לא סופק: שיעור המשלוח יחושב בעת המשלוח.",
"hc.weightUnit": "יחידת משקל",
"hc.welcome": "ברוך הבא!",
"hc.welcomeToFindo": "ברוך הבא ל-findloop",
"hc.whenACustomerComesTo": "כאשר לקוח מגיע לאסוף את חפציו, פתח את ההצהרה שלו ואמת את החזרה. זהו זה!",
"hc.whenDisabledFeesDropTo": ". כאשר מושבת, העמלות יורדות ל",
"hc.whyIsThisNotYour": "למה זה לא הפריט שלך?",
"hc.willBeMarkedAs": "יסומן כ",
"hc.wrongColor": "צבע שגוי",
"hc.wrongModel": "דגם שגוי",
"hc.yesCancel": "כן, לבטל",
"hc.yesContactTheFinder": "כן, צור קשר עם המוצ Encontrado",
"hc.youAreHere": "אתה כאן",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "אתה יכול להתחיל עכשיו את ההחזרה.",
"hc.youCanStillChangeIt": ". אתה עדיין יכול לשנות זאת מקרה למקרה.",
"hc.youHaveAlreadyConfirmedThat": "אימות שאתה כבר אישרת שזה הפריט שלך.",
"hc.youWillBeRedirectedTo": "אתה תנותב לתשלום המאובטח של Stripe.",
"hc.yourAccountHasBeenReactivated": "החשבון שלך הופעל מחדש.",
"hc.yourAccountIsActiveYou": "החשבון שלך פעיל, אתה יכול לנהל את המוסדות שלך עכשיו.",
"hc.yourEstablishment": "המוסד שלך",
"hc.yourFeedbackHelpsUsImprove": "המשוב שלך עוזר לנו לשפר את ההתאמות שלנו.",
"hc.yourFeedbackHelpsUsRestart": "המשוב שלך עוזר לנו להתחיל מחדש את הניתוח ולשפר את ההתאמות שלנו.",
"hc.yourFirstSteps": "הצעדים הראשונים שלך",
"hc.yourFirstStepsAdmin": "הצעדים הראשונים שלך (מנהל)",
"hc.yourItemHasBeenHanded": "הפריט שלך הועבר באופן אישי על ידי השותף — סגור את המקרה once ההעברה מאושרת.",
"hc.yourItemHasBeenShipped": "הפריט שלך נשלח על ידי השותף — סגור את המקרה once האספקה מאושרת.",
"hc.yourPaymentHasBeenRecorded": "התשלום שלך נרשם.",
"hc.yourShipmentIsBeingPrepared": "המשלוח שלך מתכונן. אתה תקבל את המשלוח שלך בתוך 3 עד 5 ימי עסקים.",
"hc.yourShippingFeesHaveAlready": "העמלות שלך עבור המשלוח כבר שולם. משלוח שולם ✓",
"hc.yourShippingFeesHaveBeen": "העמלות שלך עבור המשלוח שולם. המשלוח שלך מתכונן.",
"hc.yourVerificationQuestionsDeposit": "השאלות שלך לאימות (פקדון)",
"hero.einvoiceBadge": "חיוב אלקטרוני תואם 2027",
"home.recentAdsAll": "ראה את כל המודעות",
"home.recentAdsEyebrow": "ברגע זה",
"home.recentAdsSubtitle": "פריטים שנמצאו ודווחו על ידי הקהילה.",
"home.recentAdsTitle": "המודעות האחרונות",
"home.reunions": "איחודים האחרונים",
"home.videoEyebrow": "צפה",
"home.videoTitle": "גלה את Findloop ב-2 דקות",
"home.watchYoutube": "צפה ביוטיוב",
"impact.already": "כבר",
"impact.citiesWord": "עיר/ערים",
"impact.eachPoint": "כל נקודה היא עיר שבה Findloop עוזר להחזיר פריטים אבודים.",
"impact.emptyMap": "המפה מתמלאת ככל שהשבה מתרחשת.",
"impact.eyebrow": "ההשפעה שלנו",
"impact.inCities": "בעבר",
"impact.restitutedTo": "פריטים מוחזרים לבעליהם",
"impact.title": "פריטים מוחזרים, בכל מקום סביבך",
"inv2.download": "הורד",
"inv2.view": "צפה",
"map.objectsOnMapPlural": "פריטים על המפה",
"map.objectsOnMapSingular": "פריט על המפה",
"mc.claimConfirmDesc": "בדוק את הפריט שנמצא על ידי המוצא לפני תשלום כדי לשחרר את פרטי הקשר שלו.",
"mc.claimConfirmNo": "זה לא הפריט שלי",
"mc.claimConfirmTitle": "האם זה באמת הפריט שלך?",
"mc.claimConfirmYes": "כן, זה שלי — תשלם",
"mc.claimFinderContacts": "פרטי הקשר של המוצא",
"mc.claimNotMineDone": "תודה — המוצא עודכן והבקשה שלך הוסרה מהמודעה.",
"mc.claimUnlockDesc": "שלם את דמי הניהול של Findloop כדי לקבל את פרטי הקשר של האדם שמצא את הפריט שלך.",
"mc.claimUnlockTitle": "שחרר את פרטי הקשר של המוצא",
"mc.hideCountryOffers": "הסתר הצעות במדינה שלי",
"mc.myClaims": "פריטים שאני דורש",
"mc.myClaimsSub": "פריטים שנמצאו על ידי אחרים שאתה דורש. שחרר את פרטי הקשר של המוצא כדי לתאם את ההגשה.",
"mc.notifAdCancelled": "מודעה בוטלה",
"mc.notifCancelAd": "בטל את המודעה שלי",
"mc.offersInCountry": "הצעות במדינה שלי",
"mc.offersInCountryDesc": "כל הפרסים הפעילים ממדינות שותפות במדינה שלך, לפי עיר.",
"mc.redArchived": "מוקלט",
"mc.rewardsCountryNone": "אין הצעה במדינה שלך עדיין.",
"mc.rewardsForYou": "פרסים עבורך",
"mc.rewardsForYouDesc": "המוצעים על ידי השותף/שותפים שבהם השארת פריט.",
"mc.rewardsMineNone": "אין פרס מהשותפים שהשארת עדיין.",
"mc.showCountryOffers": "ראה הצעות במדינה שלי",
"mc2.cancelDecl": "בטל את ההצהרה שלי",
"mc2.cancelDeclDone": "ההצהרה בוטלה.",
"pricing.physInvDesc": "כאשר פריט מוחזר, המיקום שלו משוחרר אוטומטית וזמין עבור פריט חדש.",
"st.closed": "נסגר",
"st.delivered": "נמסר",
"st.destroyed": "הושמד",
"st.donated": "נתרם (לעמותה)",
"st.handed_to_authorities": "נמסר לרשויות",
"st.in_storage": "במחסן",
"stt.dispoPdfBtn": "ייצוא PDF",
"stt.dispoPdfError": "ייצוא PDF נכשל.",
"stt.dispoPdfExporting": "מייצא…",
"trk.matchVerifying": "מתאים פוטנציאלי מתאמת",
"pricing.physInvTitle": "מעקב אחר מלאי פיזי",
"pricing.physModalTitle": "ניהול פריטים פיזיים",
"pricing.physQrDesc": "קוד QR ייחודי נוצר לכל פריט ומקשר לכל המידע עליו.",
"pricing.physQrTitle": "תוית QR ייחודית",
"pricing.physShelfDesc": "כל פריט רשום יכול להיות משויך למיקום פיזי בתוך המוסד.",
"pricing.physShelfTitle": "תכנית מדף",
"pricing.physicalMgmt": "ניהול פריטים פיזיים (מדפים, QR, מלאי)",
"pub.addSecondPhoto": "הוסף תמונה שנייה (אופציונלי)",
"pub.photo2Added": "✓ התמונה השנייה נוספה",
"reg.dispositionJournal": "יומן הפסקה",
"reg.dispositionNoteAuthHint": "ℹ️ יש צורך בהערה עבור “נמסר לרשויות” (מספר דוח, מחלקה...).",
"reg.dispositionNotePh": "הערה (אופציונלית): צדקה שמקבלת, הפניה לרשויות, שם רוכש…",
"reg.dispositionNoteRequired": "דרושה הפניה רשמית למסור לרשויות.",
"reg.legalPrealert": "מועד אחרון חוקי ב-{days} יום/ימים",
"reg.legalPrealertOptions": "אפשרויות במועד האחרון: מכירה פומבית, תרומה לצדקה, מסירה לרשויות.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "סקירה מלאה",
"rev.readMore": "קרא עוד",
"rw.activeCodes": "שוברי מתנה פעילים",
"rw.archived": "ארכיון",
"rw.archivedTitle": "שוברי מתנה שנממשו (ארכיון)",
"rw.hideArchived": "הסתר שוברי מתנה שנממשו",
"rw.noArchived": "אין שובר מתנה בארכיון.",
"rw.showArchived": "הצג שוברי מתנה שנממשו",
"shell.f1t": "התאמת AI חכם",
"shell.f2d": "עקוב אחר שיעור החזרה וההכנסות בזמן אמת.",
"shell.f2t": "לוח מחוונים והכנסות",
"shell.f3d": "הלקוחות שלך מדווחים ב-30 שניות.",
"shell.f3t": "קוד QR של שותף",
"shell.title": "הפוך פריטים אבודים ללקוחות מרוצים.",
"ship.addr1": "כתובת",
"ship.addr2": "שורת כתובת 2 (אופציונלי)",
"ship.badge": "משלוח",
"ship.city": "עיר",
"ship.country": "מדינה",
"ship.needPaid": "שלם את דמי השחזור קודם לבקשת משלוח.",
"ship.notShippable": "פריט זה אינו זמין למשלוח.",
"ship.notfound": "דוח לא נמצא.",
"ship.postal": "מיקוד",
"ship.price": "דמי משלוח",
"ck.refuse": "סירוב",
"ck.save": "שמור את הבחירות שלי",
"ck.saved": "העדפות נשמרו",
"ck.title": "העדפות העוגיות שלך",
"cm.found": "נמצא",
"cm.lost": "אבוד",
"cmp.adv": "מתקדם",
"cmp.ai": "התאמה בינה מלאכותית",
"cmp.autobill": "ח billing אוטומטי",
"cmp.basic": "בסיסי",
"cmp.community": "קהילה",
"cmp.consol": "ח billing מאוחד",
"cmp.custom": "מותאם אישית",
"cmp.dedicated": "ייעודי",
"cmp.deploy": "הפצה ייעודית & SLA",
"cmp.estIncl": "מוסדות כלולים",
"cmp.estSec": "מוסד נוסף",
"cmp.items": "פריטים / חודש",
"cmp.main": "1 עיקרי",
"cmp.max20": "20 מקסימום",
"cmp.members": "הזמנות חברים",
"cmp.onQuote": "ציטוט מותאם",
"cmp.priority": "עדיפות",
"cmp.starterEst": "1 כלול + נוסף ללא הגבלה",
"cmp.stats": "סטטיסטיקות",
"cmp.statsAdv": "מתקדם",
"cmp.statsBasic": "בסיסי",
"cmp.support": "תמיכה",
"cmp.unlimited": "ללא הגבלה",
"cmp.upTo3": "עד 3",
"consent.required": "עליך להסכים לשתף את פרטי הקשר שלך להמשך.",
"consent.share": "אני מסכים שהמוצא של הפריט שלי יכול לראות את פרטי הקשר שלי (שם, דוא\"ל, טלפון) כדי להגיע אלי לצורך החזרת הפריט.",
"cover.add": "הוסף",
"cover.change": "שנה",
"cover.helper": "נצפה כבאנר בעמוד הדו\"ח שלך ובספרייה.",
"cover.none": "אין תמונת כיסוי",
"cover.remove": "הסר",
"cover.title": "תמונת כיסוי",
"crop.desc": "כוונן את המסגרת ליחס הבאנר (3:1). גרור וזום.",
"crop.saving": "שומר…",
"hc.reportAProblem": "דווח על בעיה",
"hc.reportDismissedYourListingRemains": "דיווח נדחה. הרשימה שלך נשארת ציבורית.",
"hc.requiredUsedToCalculateThe": "נדרש: משמש לחישוב שיעור המשלוח של Sendcloud. משלוח לא זמין מעל 30 ק\"ג.",
"hc.reset": "אפס",
"hc.resume": "קורות חיים",
"hc.resumeRegistration": "המשך רישום",
"hc.retro": "סקירה שנתית",
"hc.returnSecurity": "החזרת אבטחה",
"hc.returnToTheOwner": "חזור לבעל",
"hc.returned": "חוזר",
"hc.reviewTheItemDetails": "סקור את פרטי הפריט",
"hc.revokeAccess": "שלילת גישה",
"hc.role": "תפקיד:",
"hc.save": "שמור",
"hc.save2": "שמור",
"hc.saveAndContinue": "שמור והמשך",
"hc.saving": "שומר…",
"hc.scanTheClaimCode": "סרוק את קוד התביעה",
"hc.scanTheOwnerSQr": "סרוק את ה-QR של הבעלים",
"hc.scrollThroughLanguages": "גלול בין שפות",
"hc.searchByCustomerItemOr": "חפש לפי לקוח, פריט או מספר מעקב…",
"hc.searchForACountry": "חפש מדינה…",
"hc.secureFindoVerification": "אימות מאובטח של Findloop",
"hc.seeRetro": "ראו את השנה בסקירה",
"hc.selectedCarrier": "המוביל שנבחר:",
"hc.selectedPlan": "תוכנית נבחרת",
"hc.send": "שלח",
"hc.sendcloudSenderIdSaved": "מזהה השולח של Sendcloud נשמר",
"hc.sendcloudSenderIdSenderId": "מזהה השולח של Sendcloud (sender_id)",
"hc.sending": "שולח…",
"hc.sessionExpired": "הסשן פג תוקף",
"hc.setUpYourEstablishments": "קבע את המוסדות שלך",
"hc.settings": "הגדרות",
"hc.settingsSubtitle": "תשלומים חיצוניים והתראות, מוגדרות לפי מוסד.",
"hc.shareFoundText": "מצאתי פריט — עזור לי למצוא את הבעלים שלו ב-findloop",
"hc.shareLostText": "איבדתי פריט — עזור לי למצוא אותו ב-findloop",
"hc.sharePreview": "שתף תצוגה מקדימה",
"hc.shareTheRanking": "שתף את הדירוג",
"hc.shareYourQrCodeTo": "שתף את קוד ה-QR שלך לקבלת הצהרות.",
"hc.shipRateAutoWeight": "שיעור המשלוח מחושב אוטומטית באמצעות Sendcloud (משקל {w}) בזמן המשלוח.",
"hc.shipRateForWeight": "עלות משלוח (Sendcloud + {m}% רווח) עבור {w}:",
"hc.shipments": "שילוחים",
"hc.shipmentsSubtitle": "תצוגה מגובשת של כל המשלוחים של המוסד, בכל המקרים. לחץ על שורה כדי לנהל את המשלוח בהצהרתו.",
"hc.shipping": "שילוח",
"hc.shippingAddress": "כתובת משלוח",
"hc.shippingFeesAreHandledAutomatically": "דמי המשלוח מנוהלים אוטומטית بواسطة Findloop (Sendcloud) — אין קישור להזין.",
"hc.shippingFeesHaveAlreadyBeen": "דמי השילוח כבר שולמו: לא ניתן לשנות את המוביל.",
"hc.shippingNotAvailableForItems": "משלוח אינו זמין עבור פריטים מעל 30 ק\"ג. הלקוח יצטרך לאסוף את הפריט בעצמו.",
"hc.shippingPaid": "עלות המשלוח שולמה ✓",
"hc.showOnlyItemsMatchingA": "הצג רק פריטים התואמים לרשימה ציבורית (לקוח)",
"hc.showPassword": "הצג סיסמה",
"hc.signInTheBoxAbove": "התחבר בקופסה למעלה",
"hc.signatureSaved": "החתימה נשמרה",
"hc.signedInWithGoogle": "חובר עם Google",
"hc.signupFailed": "רישום נכשל",
"hc.silver": "כסף",
"hc.simulatedRatesInPreProduction": "(שיעורים מדומים בשלב טרום הייצור)",
"hc.siretAndVatNumberRequired": "דרוש מספר SIRET ומספר VAT (צרפת).",
"hc.skip": "דלג",
"hc.smsSentIfAccount": "אם חשבון קיים עם מספר זה, נשלחה אליך SMS.",
"hc.sortItemsWithAPublic": "מיין: פריטים עם משחק ציבורי (האחרון ביותר) ראשון",
"hc.specifyWhetherYouRecoveredYour": "ציין האם שחזרת את הפריט שלך או פשוט רוצה להסיר את הרשימה הזו.",
"hc.specifyYourReason": "ציין את הסיבה שלך",
"hc.specifyYourReason2": "ציין את הסיבה שלך…",
"hc.staff": "צוות",
"hc.status": "סטטוס",
"hc.staySignedIn": "להישאר מחובר",
"hc.step": "שלב",
"hc.stillThere": "עדיין שם?",
"hc.stopScrolling": "תפסיק לגלול",
"hc.storeFindWithQr": "אחסן ומצא עם QR",
"hc.streetName": "שם הרחוב",
"hc.streetNo": "מס' רחוב",
"hc.switchTo": "עבור ל",
"hc.switchToDarkMode": "העבר למצב כהה",
"hc.switchToLightMode": "לעבור למצב אור",
"hc.takeAPhoto": "צא לתמונה",
"hc.takeChangeThePhoto": "קח / שנה את התמונה",
"hc.takenFromYourDeclaration": "נלקח מן ההצהרה שלך",
"hc.target": "מטרה",
"ship.submit": "בקשת משלוח",
"ship.submitting": "שולח…",
"ship.subtitle": "הזן את כתובת המשלוח שלך.",
"ship.successText": "השותף יכין את החבילה שלך. תקבל הודעה ברגע שהיא תישלח.",
"ship.successTitle": "בקשת משלוח נשלחה!",
"ship.title": "שלח את הפריט שלך",
"ship.weight": "משקל מוערך (ק\"ג)",
"shp.carrier": "נושא",
"shp.download": "הורד PDF",
"shp.generating": "מייצר…",
"shp.label": "צור תווית",
"shp.labelAuto": "התיוג נוצר באופן אוטומטי ברגע שהלקוח שילם את עלויות המשלוח. ניתן להוריד אותו כאן.",
"shp.none": "לא נדרשה משלוח.",
"shp.setTracking": "שמור מעקב",
"shp.status": "סטטוס",
"shp.to": "מקבל",
"shp.tracking": "מס' מעקב",
"shp.trackingSaved": "מעקב נשמר",
"side.account": "החשבון שלי",
"side.declarations": "דוחות",
"side.deposit": "רשום פריט",
"side.establishments": "מוסדות",
"side.invoices": "חשבוניות",
"side.logout": "התנתק",
"side.matchHistory": "היסטוריית AI",
"side.partner": "שותף",
"side.refresh": "רענן",
"side.registry": "רשימה",
"side.restitutions": "החזרות",
"side.reviews": "ביקורות",
"side.rewards": "פרסים ותחליפים",
"side.settings": "הגדרות",
"side.shipments": "משלוחים",
"side.stats": "סטטיסטיקות",
"side.storage": "אחסון וקוד QR",
"side.team": "צוות",
"side.viewSite": "הצג אתר ציבורי",
"st.auctioned": "נמכר במכירה פומבית",
"st.cancelled_by_customer": "בוטל",
"st.claimed": "נקבע",
"pcat.stadium_arena": "אצטדיון / זירה",
"pcat.supermarket": "סופרמרקט",
"pcat.taxi_vtc": "מונית / שירות הסעות",
"pcat.tourism_office": "משרד תיירות",
"pcat.train_bus_station": "תחנת רכבת / אוטובוס",
"pcat.travel_agency": "סוכנות נסיעות",
"hc.and": "וְ",
"hc.demoObj0": "ארנק",
"hc.demoObj1": "תיק ספורט",
"hc.demoObj2": "טלפון",
"hc.demoObj3": "זוג משקפיים",
"hc.demoObj4": "סט מפתחות",
"hc.demoObj5": " scarf",
"hc.demoObj6": "מחשב נייד",
"hc.demoObj7": "בקבוק מים",
"hc.demoWhen0": "לפני 2 שעות",
"hc.demoWhen1": "לפני 5 שעות",
"hc.demoWhen2": "אתמול",
"hc.demoWhen3": "לפני 3 שעות",
"hc.demoWhen4": "הבוקר",
"hc.demoWhen5": "לפני יום",
"hc.feedDemo": "{obj} הוחזר ב-{city} {when}.",
"hc.feedReal": "פריט ({cat}) הוחזר ב-{city}.",
"hc.saveBtn": "שמור",
"hc.saveLink": "שמור קישור",
"hc.terms": "תנאים",
"hc.view": "צפה",
"pcat.airline": "חברת תעופה",
"pcat.airport": "נמל תעופה",
"pcat.amusement_park": "פארק שעשועים",
"pcat.bank": "בנק",
"pcat.bar_cafe": "בר / קפה",
"pcat.beauty_salon": "מספרה / סלון יופי",
"pcat.cinema": "קולנוע",
"pcat.concert_theater": "אולם קונצרטים / תיאטרון",
"pcat.coworking": "מרחב עבודה משותף",
"pcat.gym_fitness": "חדר כושר / כושר",
"pcat.hospital_clinic": "בית חולים / קליניקה",
"pcat.library": "ספרייה",
"pcat.mall": "קניון",
"pcat.museum": "מוזיאון",
"pcat.pharmacy": "בית מרקחת",
"pcat.private_company": "חברה פרטית",
"pcat.public_transport": "תחבורה ציבורית",
"pcat.school_university": "בית ספר / אוניברסיטה",
"pcat.sports_center": "מרכז ספורט",
"an.found": "נמצא",
"an.lost": "אבוד",
"hc.shareReview": "שתף את הביקורת",
"home.videoSubtitle": "איך אנחנו מאחדים פריטים אבודים עם הבעלים שלהם, בקלות.",
"hc.citiesAboveTarget": "{n} ערים מעל היעד שלהן",
"hc.cityAboveTarget": "{n} עיר מעל היעד שלה",
"hc.j15EarlyReminder": "תזכורת מוקדמת D-15",
"hc.j7EarlyReminder": "תזכורת מוקדמת D-7",
"hc.annualTotal": "סכום שנתי",
"hc.billedOnceYear": "חיוב一次 за 12 חודשים, מתחדש מדי שנה.",
"hc.monthlyPrice": "מחיר חודשי",
"hc.perMonth": "/ חודש",
"hc.perYear": "/ שנה",
"hc.billedEachMonth": "נדרש אוטומטית כל חודש.",
"nav.business": "עסקים",
"nav.individual": "אישי",
"hc.circumstancesFound": "נסיבות הממצא",
"hc.circumstancesFoundPh": "לדוגמה, נמצא על הקרקע ליד כניסת המטרו",
"hc.circumstancesLost": "נסיבות האובדן",
"hc.circumstancesLostPh": "לדוגמה, השארתי על ספסל בזמן שחיכיתי לאוטובוס",
"hc.conditionPh": "לדוגמה, טוב, מגרד…",
"hc.firstName": "שם פרטי",
"hc.lastName": "שם משפחה",
"hc.quantity": "מספר פריטים",
"fa.approve": "אשר",
"fa.approveConfirm": "לאשר את ההצהרה הזו? פרטי הקשר שלך (שם, דוא\"ל, טלפון) יוחלפו עם המוצא.",
"fa.approved": "ההצהרה אושרה — פרטי הקשר הוחלפו",
"fa.approvedFinder": "הבעלים אישר את ההצהרה שלך",
"fa.approvedFinderText": "צרו קשר איתם כדי לסדר את ההחזרה.",
"fa.boostSub": "הרש listing שלך נשאר למעלה בזמן שנבחר.",
"fa.boostTitle": "הגדלת הרש listing שלי (אופציונלי)",
"fa.colFinder": "הצהרת המוצא",
"fa.colYours": "ההצהרה שלך",
"fa.compareHint": "שווה את ההצהרה של המוצא מול שלך לפני שתחליט.",
"fa.contribNone": "אין תרומה",
"fa.contribPaid": "תרומה התקבלה — תודה!",
"fa.contribPending": "תרומה ממתינה לתשלום",
"fa.contribSub": "תמכו בfindloop כדי לעזור ליותר אנשים לקבל את העניינים שלהם בחזרה. תוכל לבחור €0.",
"fa.contribSuccessMsg": "ההצהרה שלך נשלחה לבעלים.",
"fa.contribSuccessTitle": "תודה על התרומה שלך",
"fa.contribTitle": "תרומת נדיבות",
"fa.days3": "3 ימים",
"fa.days30": "30 ימים",
"fa.days7": "7 ימים",
"fa.declSub": "תאר את הפריט שמצאת. הבעלים ישווה את ההצהרה שלך עם שלהם.",
"fa.declTitle": "מצאתי את הפריט הזה",
"fa.expiresOn": "פג תוקף ב",
"fa.fBrand": "מותג",
"fa.fCircumstances": "נסיבות",
"fa.fCity": "עיר",
"fa.fColor": "צבע",
"fa.fCondition": "מצב",
"fa.fDate": "תאריך",
"fa.fMessage": "הודעת המוצא",
"fa.fPlace": "מקום",
"fa.fQuantity": "כמות",
"fa.finderContact": "פרטי קשר של המוצא",
"fa.finishPay": "השלמת תשלום",
"fa.foundDate": "תאריך מציאה",
"fa.foundPlace": "מקום מציאה",
"fa.hours24": "24 שעות",
"fa.ht": "לא כולל מע\"מ",
"fa.months3": "3 חודשים",
"fa.noBoost": "ללא הגדלה",
"fa.ownerContact": "פרטי קשר של בעלים",
"fa.payPublish": "שלם ופרסם",
"fa.pendingPayText": "המפרט שלך ייכנס לאוויר ברגע שהתשלום מאושר.",
"fa.pendingPayTitle": "תשלום ממתין",
"fa.planSub": "המפרט שלך ייכנס לאוויר ברגע שהתשלום מאושר.",
"fa.planTitle": "משך המפרט",
"fa.pubSuccessMsg": "המפרט שלך חי. תקבל הודעה ברגע שמוצא יפנה אליך.",
"fa.pubSuccessTitle": "המפרט פורסם",
"fa.publicNote": "רק התיאור, העיר, המדינה והתמונות מוצגות בציבור.",
"fa.redirectStripe": "מעביר לתשלום מאובטח…",
"fa.reject": "דחה",
"fa.rejectConfirm": "לדחות הצהרה זו? המפרט שלך נשאר באינטרנט.",
"fa.rejected": "ההצהרה נדחתה",
"fa.rejectedFinder": "זה לא היה הפריט שהם חיפשו",
"fa.rejectedFinderText": "הבעלים אומר שהפריט הזה לא שייך לו. תודה על עזרתה!",
"fa.responsesTitle": "הצהרות של מוצאים",
"fa.sent": "הצהרה נשלחה לבעלים.",
"fa.submitDecl": "שלח את ההצהרה שלי",
"fa.submitDeclPay": "שלח ותורם {amount}",
"fa.total": "סה\"כ לתשלום",
"fa.ttc": "כולל מע\"מ",
"fa.waitClaimText": "המוצא בודק את הבקשה שלך. תקבל הודעה על ההחלטה שלהם.",
"fa.waitFinderText": "נודיע לך ברגע שמוצא ישלח הצהרה.",
"fa.waitFinderTitle": "המפרט שלך חי",
"fa.waitOwnerText": "הבעלים משווה את ההצהרה שלך עם שלו. תקבל הודעה על ההחלטה שלהם.",
"fa.waitOwnerTitle": "ממתין להחלטת הבעלים",
"st.pending_payment": "תשלום ממתין",
"fa.africaFree": "רישום חינם באפריקה — הצעת השקה של Findloop, תהנה!",
"fa.africaPublished": "הרישום פורסם בחינם — הצעת השקה באפריקה!",
"fa.approveClaimConfirm": "לאשר את התביעה הזו? בעל הרכוש יוכל לאחר מכן לפתוח את פרטי ההתקשרות שלך.",
"fa.checkInfo": "ודא את הפרטים שלך לפני שליחה: הם יושוו עם פרטי המוצא.",
"fa.claimApprovedShort": "המוצא אישר את התביעה שלך",
"fa.claimRejectedShort": "התביעה נדחתה על ידי המוצא",
"fa.claimRejectedText": "המוצא מאמין שהפריט הזה אינו שלך.",
"fa.claimSub": "תאר את הפריט שלך והוסף 2 תמונות. המוצא ישווה אותם עם הרישום שלו.",
"fa.claimTitle": "זה הפריט שלי",
"fa.claimUnlockText": "פתח את פרטי ההתקשרות של המוצא כדי לארגן את ההחזרה.",
"fa.claimUnlockedShort": "פרטי ההתקשרות פתוחים — ראה מעקב",
"fa.claimsTitle": "תביעות של בעלים",
"fa.colOwner": "הצהרת בעלים",
"fa.colYourAd": "הרישום שלך",
"fa.expired": "הרישום פג",
"fa.free": "חינם",
"fa.lostDate": "תאריך אובדן",
"fa.lostPlace": "מקום אובדן",
"fa.noReceipt": "אין קבלה זמינה עבור רישום זה.",
"fa.planSubFree": "בחר את משך הזמן: הרישום שלך יתפרסם מיד, ללא תשלום נדרש.",
"fa.prefillPrevious": "השתמש שוב בפרטי הרישום הקודם שלי בקטגוריה הזו",
"fa.receipt": "קבלה בפורמט PDF",
"fa.renewBtn": "חידוש",
"fa.renewDiscountBanner": "50% הנחה: חRenew לפני שהרישום שלך פג!",
"fa.renewDiscountHint": "50% הנחה הוחלה כי חידשת לפני פג.",
"fa.renewEarly": "חידוש (−50%)",
"fa.renewTitle": "חידוש הרישום שלי",
"fa.renewed": "הרישום חודש",
"fa.sendClaim": "שלח את התביעה שלי",
"fa.twoPhotos": "2 תמונות של הפריט שלך",
"fa.twoPhotosError": "הוסף 2 תמונות של הפריט שלך.",
"fa.twoPhotosHint": "תמונות אישיות שמוכיחות שהפריט שלך (עם הפריט, חשבונית, קופסה…).",
"fa.unlockBtn": "פתח פרטי התקשרות",
"fa.unlockFree": "פתח בחינם — הצעת השקה",
"fa.waitClaimantText": "נודיע לך ברגע שבעל רכוש ידרוש פריט זה.",
"fa.waitFinderDecision": "מחכים להחלטת המוצא",
"fa.waitUnlockText": "אתה תודע ברגע שפרטי ההתקשרות יתממשו.",
"fa.waitUnlockTitle": "מחכים לבעל הרכוש שיפתח",
"fa.cancel": "לבטל",
"fa.categoryRequired": "בחר קטגוריה עבור הפריט שנמצא.",
"fa.confirmTitle": "אשר את ההחלטה שלך",
"fa.goBack": "חזור",
"dr.continue": "להמשיך את ההצהרה שלי",
"dr.delete": "מחק לצמיתות",
"dr.deleteConfirm": "האם למחוק את הטיוטה הזאת לצמיתות? זה לא ניתן לשחזור.",
"dr.deleted": "הטיוטה נמחקה",
"dr.expiresIn": "הטיוטה נשמרת לעוד {h} שעות",
"dr.title": "יש לך הצהרה לא גמורה",
"form.step": "שלב",
"form.next": "המשך",
"form.back": "חזור",
"form.stepDetails": "הדיווח שלך",
"form.stepPublish": "משך, בוסט ותשלום",
"form.stepThanks": "תודה ותרומה",
"fthx.badge": "הדיווח כמעט גמור",
"fthx.title": "תודה, אתה עושה שינוי!",
"fthx.text": "בעזרתך, מישהו עשוי בקרוב לקבל חזרה משהו שחשוב לו. מעשי טוב כמו שלך הם בדיוק מה ששומר על Findloop בחיים.",
"fthx.impact1": "1 פריט דווח",
"fthx.impact2": "1 סיכוי נוסף לפגישה",
"fthx.tipTitle": "דחיפה קטנה ל-Findloop?",
"fthx.tipText": "התרומה שלך עוזרת לנו לשמור על השירות נגיש ולחבר עוד פריטים עם בעליהם.",
"fthx.optional": "100% אופציונלי — אפשר לפרסם ללא תרומה.",
"fthx.thanksTip": "תודה רבה על generosity שלך!",
"fthx.suggest": "סכומים מוצעים",
"fthx.none": "אין טיפ",
"pay.pendingTitle": "התשלום לא הושלם",
"pay.pendingText": "פרטיך נשמרו. המשך מהנקודה בה הפסקת.",
"pay.resume": "המשך לתשלום",
"pay.expiredTitle": "מושב התשלום פג",
"pay.expiredText": "לבטחונך, מושב התשלום פג. פרטיך נשמרו: התחל את התשלום בלחיצה אחת.",
"pay.relaunch": "התחל את התשלום מחדש",
"sub.received": "נשלח!",
"sub.publishing": "אנחנו מסיימים…",
"sub.toPayment": "מעבר לתשלום מאובטח…",
"fa.claimSubV2": "תאר את הפריט האבוד שלך. האדם שמצא אותו ישווה את ההצהרה שלך עם הרשימה שלו.",
"fa.photosOptional": "תמונות של הפריט שלך (אופציונלי)",
"fa.compareOwnerHint": "השווה את המידע הזה עם הפריט שמצאת, ואז אומר אם זה אותו פריט.",
"fa.itsThisItem": "כן, זה הפריט",
"fa.notThisItem": "לא, זה לא הפריט",
"fa.confirmIsItem": "אשר שזהו הפריט? פרטי הקשר שלך ופרטי הבעלים יוצגו בחשבונות שלך בהתאמה.",
"fa.confirmNotItem": "אשר שזה לא הפריט? הדיווח שלך ייסגר.",
"fa.youConfirmed": "אישרת שזה הפריט של בעלים",
"fa.youDeclined": "ציינת שזה לא הפריט",
"fa.youDeclinedText": "תודה על העזרה שלך! הבעלים wurdeinformed.",
"fa.waitFinderDecisionOwner": "מחכים להחלטת המוצא",
"fa.finderConfirmed": "אושר",
"fa.notYourItem": "זה לא היה הפריט שלך",
"fa.reportedOn": "דווח ב",
"fa.ownerWaitHint": "מחכה שהמוצא יבדוק את המידע, אנא המתן.",
"fa.claimSentFinder": "תביעה נשלחה לאדם שמצא את הפריט.",
"fa.compareClaimHint": "השווה את הצהרת הבעלים עם הרשימה שלך לפני שתחליט.",
"fa.closeFollowup": "סגור את המעקב הזה",
"fa.closeFollowupConfirm": "לסגור את המעקב הזה? המיילים ומספרי הטלפון של שתי הצדדים ימחקו לצמיתות לאחר שהבעלים יסגור גם את הרישום שלו.",
"fa.safetyTitle": "טיפים לביטחון לפני העברת הפריט",
"fa.safety1": "שאל את הבעלים על תיאור מפורט של תכונות סמויות של הפריט: שריטה מסוימת, התכולה המדויקת של תיק, טפטים, מספר סידורי...",
"fa.safety2": "אם אפשר, בקש הוכחה ויזואלית (תמונה של הפריט) או הוכחת רכישה.",
"fa.safety3": "העבר את הפריט במקום ציבורי או אצל שותף של Findloop, ובדוק את תעודת הזהות של הבעלים.",
"fa.safetyOk": "הבנתי, המשך",
"fa.ownerClosedNote": "הבעלים סגר את הרישום שלו.",
"fa.finderClosedNote": "המבצע סגר את המעקב שלו.",
"fa.followupClosed": "המעקב נסגר",
"fa.followupClosedText": "סגרת את המעקב הזה. תודה על העזרה!",
"fa.photoReviewTitle": "מאתר שלח תמונה. האם זה נראה כמו הפריט שלך?",
"fa.photoLooksLike": "כן, זה נראה כמו הפריט שלי",
"fa.photoNotMine": "לא, זה לא הפריט שלי",
"fa.photoNotMineConfirm": "המעקב ייסגר משני הצדדים ורישום שלך יישאר פתוח למאתרים חדשים.",
"fa.photoLooksLikeDone": "תודה! המאתר ישווה עכשיו את ההצהרה שלך.",
"fa.photoNotMineDone": "דיווח נדחה. רישום שלך נשאר פתוח.",
"fa.ownerPhotoHint": "רק התמונה של המאתר מוצגת לך. תודיע לנו אם זה נראה כמו הפריט שלך.",
"fa.ownerReviewingPhoto": "הבעלים בודק את התמונה שלך",
"fa.ownerReviewingPhotoText": "תקבל הודעה ברגע שהם יענו. אז תוכל להשוות את ההצהרה שלהם.",
"fa.ownerRejectedPhoto": "זה לא הפריט של הבעלים",
"fa.ownerRejectedPhotoText": "הבעלים אומר שהתמונה שלך לא תואמת את הפריט שלהם. המעקב נסגר. תודה על עזרתך!",
"fa.contribute": "תרום",
"fa.phoneMissing": "לא צוין",
"fa.ownerSafety1": "מומלץ לבצע מסירה במקום ציבורי או אצל שותף של Findloop. אם המרחק רב, כדאי להציע לשלוח בדואר במקום.",
"fa.ownerSafety2": "בעת המסירה, בדוק את תעודת הזהות של המוצא.",
"pub.changePhoto": "שנה תמונה",
"ph.secured": "התמונה מאובטחת",
"ph.securing": "מאבטח את התמונה…",
"fa.ownerSafety3": "אם התמונה של המייקר נושאת את סימן המים של Findloop, אל תקבל את הפגישה. התמונה חייבת להיות תמונה מקורית שצולמה על ידי המייקר, ללא סימן מים."
},
"zh": {
"ac.africa": "非洲",
"ac.boostActive": "高亮活动 —",
"ac.boostSub": "在合作伙伴目录的顶部显示“提升”徽章。",
"ac.boostTitle": "在目录中提升您的列表",
"ac.categoryHint": "将您的机构分类到findloop目录中。",
"ac.choose": "选择",
"ac.cityHint": "以便在公共地图上准确定位。",
"ac.cityLabel": "机构城市",
"ac.cityPh": "巴黎",
"ac.contact": "联系信息",
"ac.converted": "已转换",
"ac.copyDeclLink": "复制声明链接",
"ac.copyLink": "复制链接",
"ac.currentPlan": "当前计划",
"ac.emailDesc": "选择您想接收的邮件。您的工作区通知始终保持激活。",
"ac.emailMatch": "匹配",
"ac.emailMatchDesc": "当某个项目与声明匹配时发送一封邮件",
"ac.emailNewDecl": "新的损失声明",
"ac.emailNewDeclDesc": "客户在您的地方报告损失时立即发送一封邮件",
"ac.emailShip": "运输请求",
"ac.emailShipDesc": "客户请求运输某个项目时发送一封邮件",
"ac.emailTitle": "电子邮件偏好",
"ac.expireSoon": "您的高亮即将到期 —",
"ac.exportCsv": "导出（CSV）",
"ac.exportHint": "导出您的已验证外部支付以便进行会计。",
"ac.free": "免费",
"ac.freeMonths": "免费月份",
"ac.hours": "小时",
"ac.howItWorks": "这如何运作？",
"ac.invited": "已邀请",
"ac.legalFR": "电子发票（Factur-X）所需，从2026年9月开始适用。",
"ac.legalMissing": "⚠️ 缺少SIRET和欧盟增值税 — 完成它们以保持电子发票的合规性。",
"ac.legalOther": "建议用于您的发票。",
"ac.legalPartnerQr": "二维码",
"ac.legalTitle": "法律识别信息（账单）",
"ac.logoTitle": "机构标志",
"ac.modeCurrent": "当前模式:",
"ac.modeExternal": "外部（手动验证）",
"ac.modeInternal": "Findloop内部（自动）",
"ac.noSubReceipt": "尚未支付的订阅费用。",
"ac.none": "无",
"ac.onYourListing": "在您的列表上",
"ac.pay1": "在下方输入您的支付链接，将您的客户重定向到您自己的收款系统。",
"ac.pay2": "验证变为手动：您从“声明”标签中确认支付收到。",
"ac.pay3": "“运费”链接是一个合并支付（回收 + 运输）。",
"ac.pay4": "将字段留空，以使用Findloop的内部支付（Stripe）进行自动验证。",
"ac.paySub": "通过您自己的支付系统收取费用。",
"ac.payTitle": "外部支付",
"ac.permissive": "宽容",
"ac.phone": "电话",
"ac.posterA4": "A4海报（PDF）",
"ac.qMessage": "信息（可选）",
"ac.qName": "姓名",
"ac.qOrg": "组织",
"ac.qSites": "机构数量（估计）",
"ac.qrHint": "您的客户扫描此代码以报告丢失物品。",
"ac.qrPng": "二维码（PNG）",
"ac.qrTitle": "您的合作伙伴二维码",
"ac.quoteDesc": "机场、铁路网络、国际连锁 · ",
"ac.quoteEurope": "欧洲 / 世界",
"ac.quoteSent": "报价请求已发送。我们的团队将尽快与您联系。",
"ac.quoteTitle": "请求报价 — 企业",
"ac.recoveryLink": "“恢复费用”链接",
"ac.refSub": "每位订阅的推荐合作伙伴为您赢得 1 个月的免费服务。",
"ac.refTitle": "推荐，获得免费一个月",
"ac.reminderDelay": "验证提醒延迟",
"ac.reminderHint": "如果外部付款在此延迟（默认：48小时）后仍未验证，您将收到电子邮件提醒。",
"ac.renewDesc1": "它已经为您赚取了",
"ac.renewDesc2": "续订以保持在目录的顶端，避免失去此可见性。",
"ac.renewNow": "立即续订",
"ac.requestQuote": "请求报价",
"ac.saveLegal": "保存标识符",
"ac.saveLinks": "保存链接",
"ac.sendRequest": "发送我的请求",
"ac.sending": "发送中…",
"ac.shippingLink": "“运输费用”链接（合并）",
"ac.shippingLinkHint": "此链接涵盖恢复和运输费用。",
"ac.strict": "严格",
"ac.subReceipt": "订阅收据（PDF）",
"ac.subReceiptsSub": "下载每个订阅付款的 PDF 收据。",
"ac.subReceiptsTitle": "订阅收据",
"ac.tCategory": "类别已保存",
"ac.tCity": "城市已保存 — 地图已更新",
"ac.tCityNeeded": "请输入城市",
"ac.tCopied": "已复制！",
"ac.tCover": "封面照片已更新",
"ac.tEmailPrefs": "电子邮件偏好已更新",
"ac.tErr": "错误",
"ac.tExportImpossible": "导出失败",
"ac.tLegal": "法律标识符已保存",
"ac.tLegalNeeded": "法国需要 SIRET 和增值税",
"ac.tLogo": "标志已更新",
"ac.tLogoRemoved": "标志已移除",
"ac.tPayLinks": "支付链接已保存",
"ac.tPhone": "电话已保存",
"ac.tSensitivity": "敏感性已保存",
"ac.tVatInvalid": "无效的增值税号码",
"ac.tVatValid": "有效的增值税",
"ac.tabBoost": "可见性",
"ac.tabPayments": "付款",
"ac.tabProfile": "个人资料",
"ac.tabQr": "二维码 & 海报",
"ac.tabReferral": "推荐",
"ac.tabSub": "订阅",
"ac.thisWeek": "本周",
"ac.thisWeekOf": "（本周 {n}）",
"ac.thresholdDesc": "AI 自动验证照片匹配并通知客户的信心阈值。越高=自动匹配越少，但更可靠。",
"ac.thresholdTitle": "AI 视觉匹配敏感度",
"ac.trend": "趋势",
"ac.upload": "上传",
"ac.vatValidFmt": "有效增值税{name} （{via}）",
"ac.vatVerified": "欧盟内增值税已验证",
"ac.verifyVat": "验证增值税（VIES）",
"ac.verifying": "验证中…",
"ac.views": "查看次数",
"ac.viewsTotal": "获得的查看次数（总计）",
"ac.winbackBtn": "以-20%恢复",
"ac.winbackDesc1": "它为您赚取了",
"ac.winbackDesc2": "特别优惠：如果您在 24 小时内续订，将自动应用 -20%。",
"ac.winbackTitle": "您的高亮已过期 — 以 -20% 恢复！",
"an.allCountries": "所有国家",
"an.country": "国家",
"an.geoBanner": "您正在查看的列表在",
"an.geoBannerWorld": "您正在查看全球列表",
"an.geoChange": "更改国家",
"an.loginRequired": "登录以举报此项并跟踪退货。",
"an.requestInProgress": "请求进行中",
"an.resolved": "物品已恢复",
"an.shareConsent": "我同意我的联系信息（姓名、电子邮件、电话）可以与物品拥有者共享。",
"an.shareConsentError": "请勾选此框以共享您的联系信息。",
"an.sortRecent": "最新",
"an.sortRelevance": "相关性",
"anf.shareConsent": "我同意我的联系信息（姓名、电子邮件、电话）可以与找到该物品的人共享。",
"bo.africaPrice": "已应用非洲区优惠定价",
"c.all": "所有",
"c.close": "关闭",
"c.confirm": "确认",
"c.confirmed": "已确认",
"c.download": "下载",
"c.reset": "重置",
"c.transfer": "转移",
"cat.Animal": "宠物 / 宠物配件",
"cat.AppareilPhoto": "相机",
"cat.Argent": "钱 / 现金",
"cat.Autres": "其他",
"cat.Bijoux": "珠宝",
"cat.CarteBancaire": "银行卡",
"cat.CarteIdentite": "身份证 / 护照",
"cat.Casquette": "帽子",
"cat.Ceinture": "腰带",
"cat.Chargeur": "充电器 / 数据线",
"cat.Chaussures": "鞋子",
"cat.CleVoiture": "车钥匙",
"cat.Cles": "钥匙",
"cat.Console": "游戏机",
"cat.Documents": "文件 / 材料",
"cat.Echarpe": "围巾",
"cat.Ecouteurs": "耳机",
"cat.Electronique": "电子产品（其他）",
"cat.Enceinte": "扬声器",
"cat.Gants": "手套",
"cat.Gourde": "水瓶 / 漏斗",
"cat.Instrument": "乐器",
"cat.Jouet": "玩具 / 毛绒玩具",
"cat.Jumelles": "望远镜",
"cat.Lampe": "灯 / 手电筒",
"cat.Liseuse": "电子书阅读器",
"cat.Livre": "书 / 笔记本",
"cat.Lunettes": "眼镜",
"cat.Manteau": "外套 / 夹克",
"cat.Maquillage": "化妆包",
"cat.Medical": "医疗设备",
"cat.Medicaments": "药物",
"cat.Montre": "手表 / 智能手表",
"cat.Ordinateur": "笔记本电脑",
"cat.Parapluie": "伞",
"cat.Portefeuille": "钱包 / 钱夹",
"cat.Poussette": "婴儿车 / 婴儿配件",
"cat.Sac": "包 / 手提包",
"cat.SacADos": "背包",
"cat.Souris": "鼠标 / 键盘",
"cat.Sport": "体育器材",
"cat.Tablette": "平板电脑",
"cat.Telephone": "电话 / 智能手机",
"cat.Trottinette": "滑板车",
"cat.Trousse": "袋子 / 盒子",
"cat.USB": "USB闪存 / 硬盘",
"cat.Valise": "行李箱 / 行李",
"cat.Velo": "自行车",
"cat.Vetements": "衣物",
"cm.found": "已找到",
"cm.lost": "已丢失",
"cmp.starterEst": "1 个包含 + 无限额外",
"consent.required": "您必须同意分享您的联系信息以继续。",
"consent.share": "我同意我的物品发现者可以查看我的联系信息（姓名，电子邮件，电话），以便联系我归还物品。",
"dc.partnerDesc": "在合作伙伴场所（酒店，车站，大厅…）丢失了物品？选择它以进行直接归还。",
"dc.partnerList": "从列表中选择",
"dc.partnerMap": "在地图上选择",
"dc.partnerTitle": "在合作伙伴处声明",
"dc.publicCta": "发布公共广告",
"dc.publicDesc": "您的广告将对整个 Findloop 社区可见。如果您不知道物品丢失的地方，这很理想。",
"dc.publicTitle": "公共声明",
"dc.subtitle": "选择如何报告您丢失的物品。",
"dc.title": "您想做什么？",
"dec.addrPending": "客户地址待定",
"dec.analyzing": "分析中…",
"dec.clientDescription": "客户描述",
"dec.clientPhoto": "客户提供的照片",
"dec.clientPhotoShort": "客户照片",
"dec.comparePhotos": "比较照片",
"dec.declaredItemPhoto": "已声明物品的照片",
"dec.emptyDesc": "分享您的二维码以接收声明。",
"dec.emptyTitle": "没有声明",
"dec.enlarge": "放大",
"dec.extBanner": "待验证 {n} 个外部付款 — 确认下面的收据以解锁交接或发货。",
"dec.foundItemAlt": "已找到物品",
"dec.foundItemRegistry": "已找到物品（登记）",
"dec.labelClient": "客户",
"dec.labelRegistry": "登记",
"dec.noMatchYet": "尚无匹配。",
"dec.noPhoto": "没有照片",
"dec.pRecup": "恢复",
"dec.pRecupP": "（恢复）",
"dec.pRecupShip": "（恢复 + 发货）",
"dec.payConfirmed": "付款 {x} 已确认",
"dec.payPending": "外部付款 {x} 待定",
"dec.pickup": "亲自取货",
"dec.reject": "拒绝",
"dec.rerun": "重新运行分析",
"dec.similarity": "相似度 {n}%",
"dec.suggestedMatches": "建议的匹配",
"dec.toColon": " 到:",
"dec.toShip": "待发货",
"dec.toastExtPay": "付款已确认 — 客户将收到通知。",
"dec.toastMatch": "匹配已确认",
"dec.toastReject": "建议被拒绝",
"dec.toastRerun": "分析已重新启动",
"dec.toastVisualN": "{n} 个视觉匹配",
"dec.toastVisualNone": "没有视觉匹配",
"dec.viewBeforeAfter": "前后视图（叠加）",
"dec.viewSideBySide": "并排视图",
"dec.visualCompare": "AI视觉比较",
"dec.visualIdle": "进行比较，以便AI将客户的照片与找到的物品进行视觉匹配。",
"dec.visualRunning": "AI正在将客户的照片与您登记的物品进行比较…",
"dec.zoomPhoto": "放大照片",
"dep.addAnyway": "仍然添加",
"dep.addError": "添加时出错",
"dep.addItem": "添加物品",
"dep.added": "物品已添加到登记中！",
"dep.adding": "正在添加…",
"dep.aiError": "目前无法进行AI分析。",
"dep.aiFilled": "表单已由AI预填 ✨",
"dep.aiUnavailable": "AI不可用 - 请手动填写表单。",
"dep.analyzing": "正在分析…",
"dep.analyzingPhoto": "正在分析照片…",
"dep.brand": "品牌",
"dep.brandPlaceholder": "例如：苹果",
"dep.category": "类别",
"dep.checkingDup": "检查重复项中…",
"dep.color": "颜色",
"dep.colorPlaceholder": "例如：黑色",
"dep.condition": "状态",
"dep.conditionPlaceholder": "例如：良好状态",
"dep.depositorNote": "存款人备注",
"dep.depositorNoteHint": "手动输入的操作细节。AI不会覆盖此备注。",
"dep.depositorNotePlaceholder": "例如：袋子内容、报告的品牌、提供的细节…",
"dep.descPlaceholder": "例如：带清晰外壳的黑色iPhone 15，在酒吧找到…",
"dep.description": "描述",
"dep.dupHint": "确保您不是在添加重复项。如果物品确实不同，可以继续。",
"dep.dupTitle": "相似物品已注册",
"dep.dupWarn": "检测到类似物品 — 请审核，然后再次单击以确认。",
"dep.estHint": "该物品将被添加到该机构的登记中。",
"dep.establishment": "机构",
"dep.fee": "恢复费用 (€) — 可选",
"dep.feePlaceholder": "留空以使用类别默认价格",
"dep.fillAI": "用AI填写",
"dep.optional": "(可选)",
"dep.photo": "物品照片",
"dep.principal": "主要",
"dep.reqError": "类别和描述为必填项。",
"dep.savedItem": "注册物品",
"dep.similarity": "相似度",
"dep.storage": "物理位置",
"dep.storageHint": "物品的实际存放位置。将生成QR码以便找到它。",
"dep.storagePlaceholder": "例如：A3架、12号储物柜、接待处保险箱",
"dl.aClient": "一位客户",
"dl.alertsBlocked": "浏览器警报已阻止",
"dl.alertsBlockedHint": "要重新启用它们：单击网站地址左侧的🔒（或ⓘ）图标，然后允许通知并重新加载页面。",
"dl.amountDue": "应付金额：{amount} {currency}。",
"dl.enableAlerts": "启用警报",
"dl.extPending": "待验证的付款",
"dl.freemiumNear": "您已接近Freemium限制（本月{used}/{max}个物品）。升级到Starter以注册无限物品。",
"dl.freemiumReached": "已达到Freemium限制（本月{used}/{max}个物品）。升级到Starter以注册无限物品。",
"dl.invoiceOverdue": "发票{num}未支付 - 访问受限。",
"dl.matchNotifTitle": "Findloop — 新的AI匹配 🔔",
"dl.matchToast": "新的AI匹配 — {name}",
"dl.matchToastDesc": "有物品与声明匹配。",
"dl.notifEmpty": "尚无通知。",
"dl.notifEnabled": "浏览器警报已启用",
"dl.notifTitle": "通知",
"dl.payInvoice": "支付我的发票 →",
"dl.rewardsPending": "待兑换的优惠券",
"dl.upgradeStarter": "升级到初级版 →",
"est.all": "所有商家 ({n})",
"est.label": "商家",
"est.primary": "主要",
"est.secondary": "次要",
"est2.add": "添加商家",
"est2.addressLabel": "地址",
"est2.addressPh": "十二号共和国街",
"est2.autoInvoice": "每月1日会自动生成详细发票。",
"est2.baseSub": "基础订阅",
"est2.billing": "账单",
"est2.boostActivated": "为 {name} 激活提升",
"est2.boostBillingNote": "按当前费率计费，并在您的综合月度账单中汇总。",
"est2.boostCta": "提升",
"est2.boostDesc": "提升该商家在目录和地图中的可见度。",
"est2.boostDuration": "{h}小时的提升可见度",
"est2.boostExtend": "延长",
"est2.boostTitle": "提升 {name}",
"est2.boosted": "已提升",
"est2.chartDesc": "各站点注册总数中退货项目的比例。",
"est2.chartTitle": "按商家计算的退货率",
"est2.chartTooltip": "退货",
"est2.cityLabel": "城市",
"est2.cityPh": "里昂",
"est2.contactHint": "这些信息会展示给客户（如果为空，则回退到账户信息）。",
"est2.countryLabel": "国家",
"est2.coverLabel": "封面照片",
"est2.create": "创建",
"est2.created": "商家已创建",
"est2.delete": "删除",
"est2.deleteDesc": "此操作是永久性的。只有在商家没有项目时，您才能删除。",
"est2.deleteTitle": "删除“{name}”?",
"est2.deleted": "商家已删除",
"est2.dialogDesc": "输入该站点的名称和地址。",
"est2.edit": "编辑",
"est2.editEst": "编辑商家",
"est2.emailLabel": "联系邮箱",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": "个商家",
"est2.extraNoteBase": "额外 {n} 个商家已计费",
"est2.extraPrice": " 每月 {price} €。",
"est2.extraQuote": " 报价中。",
"est2.imgChange": "选择一张图片",
"est2.imgDone": "完成",
"est2.imgRemove": "移除",
"est2.imgRemoved": "图片已移除",
"est2.imgSaved": "图片已保存",
"est2.imgUploading": "上传中…",
"est2.includedPlan": "包含在您的计划中： {n}。",
"est2.kDeclarations": "声明",
"est2.kInStorage": "在库存中",
"est2.kItemsTotal": "物品（总数）",
"est2.kRestituted": "已退货",
"est2.limitReached": "已达上限",
"est2.logoLabel": " logo",
"est2.mDeclar": "申报",
"est2.mItems": "物品",
"est2.mRestituted": "已退货",
"est2.mStorage": "存储中",
"est2.monthlyTotal": "每月总计",
"est2.nameLabel": "名称 *",
"est2.namePh": "例如：贝尔蒙特酒店——里昂分部",
"est2.newEst": "新机构",
"est2.onQuote": "已报价",
"est2.phoneLabel": "电话",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "计划",
"est2.planLimited": "您的“{tier}”计划限于 {max} 个机构。",
"est2.primary": "主要",
"est2.qr": "二维码",
"est2.qrDesc": "在此机构展示此二维码。报告丢失的客户将被链接到该站点。",
"est2.qrTitle": "二维码 — {name}",
"est2.saving": "保存中…",
"est2.seeInvoices": "查看我的每月发票",
"est2.seePlans": "查看计划",
"est2.subtitle": "在一个账户下管理所有网站 — 综合视图、项目、二维码和账单。",
"est2.suspended": "已暂停",
"est2.tierFree": "1 个机构",
"est2.tierLarge": "无限制机构",
"est2.tierMedium": "包含 5 个机构",
"est2.tierSmall": "包含 3 个机构",
"est2.title": "机构",
"est2.unlimitedPlan": "您的计划允许无限数量的机构。",
"est2.unlimitedSuffix": " · 无限",
"est2.updated": "机构已更新",
"est2.upgradeHint": "升级到更高的计划以增加更多网站并集中管理您的所有活动。",
"est2.visuals": "徽标与照片",
"est2.visualsDesc": "自定义该机构的徽标和封面照片。它们将在其公共页面和声明表单上显示。",
"est2.visualsTitle": "视觉 — {name}",
"est2.workOn": "在此机构工作",
"est2.working": "您正在处理“{name}”",
"ft.backAccount": "返回我的账户",
"ft.closeBtn": "关闭案件",
"ft.closeConfirm": "确认物品已归还？广告将被关闭。",
"ft.closeLockedHint": "请先验证所有者的代码以解锁关闭。",
"ft.closed": "案件已关闭 — 物品已归还！",
"ft.codeLabel": "输入从所有者处收到的验证代码",
"ft.codeNeeded": "请输入验证代码。",
"ft.codeOk": "代码已验证 — 您可以关闭案件。",
"ft.codePlaceholder": "例如：4821",
"ft.codeVerified": "已验证",
"ft.doneMsg": "物品已归还。感谢您帮助将其归还给所有者！",
"ft.stepInProgress": "归还进行中",
"ft.stepPublished": "广告已发布",
"ft.stepReturned": "物品已归还",
"ft.subtitle": "按照步骤操作，直到找到的物品被归还。",
"ft.title": "归还追踪",
"ft.verifyBtn": "验证代码",
"inv2.contractTitle": "我的 Findloop 合同",
"inv2.detailByEst": "按机构详细信息",
"inv2.dueLabel": "到期：",
"inv2.dueSuffix": " · 到期 {date}",
"inv2.error": "错误 {status}",
"inv2.estCountIssued": "{n} 个机构 · 于 {date} 发布",
"inv2.estimate": "估计（未收费） · {n} 个机构",
"inv2.expired": " · 已过期",
"inv2.exportCsv": "导出 CSV",
"inv2.exportDone": "CSV 导出已下载",
"inv2.included": "包含",
"inv2.monthlyTitle": "每月计费（订阅）",
"inv2.months": "+{n}个月",
"inv2.paid": "已支付",
"inv2.pay": "支付",
"inv2.previewTitle": "您下一个发票的预览 —",
"inv2.renew": "续订我的合同",
"inv2.renewalsTitle": "续订历史 ({n})",
"inv2.renewedUntil": "合同续订至 {date}",
"inv2.serviceTitle": "服务发票（回收及报价）",
"inv2.soon": "即将到期",
"inv2.toPay": "待支付",
"inv2.totalHtTva": "总计不含税 · 增值税",
"inv2.totalTtc": "总计含税",
"iu.addPhoto": "添加照片",
"iu.change": "更改",
"map.high": "高",
"map.legend": "根据回报率从红色（低）到绿色（高）标记的彩色点；大小基于项目数量。",
"map.locating": "定位中… 添加地址到您的机构以在地图上查看。",
"map.low": "低",
"map.medium": "中",
"map.noItemRegistered": "没有注册项目",
"map.noItems": "没有项目",
"map.returnedSuffix": "已归还 · {a}/{t} 项",
"map.title": "您的机构地图",
"mc.archiveHide": "隐藏历史",
"mc.archiveNone": "尚无解决案例。",
"mc.archiveShow": "显示历史",
"mc.archiveSub": "已解决并归还的案例。",
"mc.archiveTitle": "历史记录",
"mc.certificate": "证书",
"mc.finderAccepted": "已接受",
"mc.hAd": "丢失广告",
"mc.hDeclaration": "声明",
"mc.hFinderContact": "报告的物品",
"mc.hFound": "归还的物品",
"mc.hFoundAd": "找到的广告",
"mc.myFinds": "我找到的物品",
"mc.myFindsNone": "您还未报告找到任何物品。",
"mc.myFindsSub": "您在失物广告中报告的找到物品。",
"mc.notifOpen": "查看",
"mc.notifTrack": "追踪",
"mc.notifViewAd": "查看广告",
"mc.presentHint": "向合作伙伴展示这个二维码：他们扫描后验证您的奖励。",
"mc.presentInStore": "店内展示",
"mc.presentTitle": "展示此代金券",
"mc2.acceptFinder": "接受此寻物主",
"mc2.accountActivity": "帐户活动",
"mc2.adsActive": "{n}/5 个活跃广告",
"mc2.autoDelete": "定于自动删除",
"mc2.badgeBronze": "铜牌",
"mc2.badgeGold": "金牌",
"mc2.badgeSilver": "银牌",
"mc2.boostEarnedAlready": "它已经为您赚取了",
"mc2.boostEarnedWin": "它为您赚取了",
"mc2.boostExpiredWin": "您的提升刚刚过期 — 在 -20% 的情况下继续！",
"mc2.boostExpiresIn": "您的提升将在内过期",
"mc2.boostWinDetail2": "。 如果您在24小时内续订，将自动应用 -20%。",
"mc2.claimCode": "领取代码：",
"mc2.codeSentFinder": "代码通过电子邮件发送给寻物主",
"mc2.daysShort": "{n} 天",
"mc2.downloadReceipt": "下载我的收据",
"mc2.error": "错误 {status}",
"mc2.finderAccepted": "查找者已接受 — 代码已通过电子邮件发送",
"mc2.finderContacts": "查找者联系信息",
"mc2.followFindo": "关注 Findloop",
"mc2.imgInvalid": "无效的图片",
"mc2.inactivityNote": " — 在 {n} 个月的不活动情况下 (GDPR)。",
"mc2.lastActivity": "最后活动:",
"mc2.lostEmailTitle": "我不再能够访问我的电子邮件",
"mc2.noPhotoPreset": "还没有照片？选择一个默认头像:",
"mc2.paidViaPartner": "已支付（通过合作伙伴）",
"mc2.payRecovery": "支付恢复费用",
"mc2.paySettle": "结清我的付款",
"mc2.payShipping": "支付运费",
"mc2.payUnavailable": "支付不可用",
"mc2.peopleFound": "{n} 人认为他们找到了您的物品",
"mc2.phoneNumber": "电话号码",
"mc2.reactivateAccount": "重新激活我的账户",
"mc2.reactivated": "账户已重新激活",
"mc2.reactivatedThanks": "账户已重新激活 — 感谢你的忠诚！",
"mc2.recoverSmsBtn": "通过短信获取我的代码",
"mc2.recoverSmsDesc": "将您的索赔代码以短信发送到您账户上注册的号码。",
"mc2.recoverSmsFallback": "如果此号码有账户，短信已发送。",
"mc2.renewStayTop": ". 续费以保持在顶部并恢复您的物品。",
"mc2.resume20": "恢复 -20%",
"mc2.unlockContacts": "解锁联系信息",
"mc2.unlockDesc": "支付 Findloop 手续费以揭示他们的联系信息并安排交接。",
"mc2.viewsWord": "查看",
"mc2.live": "实时",
"mh.allCategories": "所有分类",
"mh.allPeriod": "所有时间",
"mh.autoMatch": "自动 AI 匹配",
"mh.blocked": "已阻止（矛盾）",
"mh.blockedReason": "匹配被阻止：物品的主要关键词与声明相互矛盾。",
"mh.days30": "过去 30 天",
"mh.days7": "过去 7 天",
"mh.days90": "过去 90 天",
"mh.emptyDesc": "AI 匹配将在这里出现，随着声明的到来。",
"mh.emptyTitle": "没有事件",
"mh.exportCsv": "导出 CSV",
"mh.exportDone": "CSV 导出已下载",
"mh.exportImpossible": "导出失败",
"mh.fBlocked": "已阻止",
"mh.fConfirmed": "已确认",
"mh.fRejected": "已拒绝",
"mh.objectLabel": "物品:",
"mh.refresh": "刷新",
"mh.rejected": "已拒绝",
"mh.srcManual": "手动",
"mh.srcText": "文本",
"mh.srcVisual": "视觉（照片）",
"mh.subtitle": "AI 提出的匹配日志 — 自动匹配、确认和拒绝。",
"mh.title": "AI 历史",
"nf.desc": "您寻找的页面不存在或已被移动。",
"nf.home": "返回首页",
"nf.title": "页面未找到",
"par.allCities": "所有城市",
"par.cityPh": "城市",
"pay.eurNote": "金额以欧元 (€) 显示。",
"pg.next": "下一步",
"pg.prev": "上一页",
"pg.showing": "{from}–{to} of {total}",
"pk.bodyCopy": "主体文本",
"pk.bodyText": "正文",
"pk.brandColors": "品牌颜色",
"pk.colorRed": "红色",
"pk.colorWhite": "白色",
"pk.darkBg": "深色背景",
"pk.download": "下载",
"pk.downloadZip": "下载整个套件（ZIP）",
"pk.headings": "标题",
"pk.heroDesc": "官方标志、社交媒体横幅、颜色和排版。选择标语语言和变体，然后下载视觉素材或完整套件。",
"pk.lightBg": "浅色背景（打印）",
"pk.logoWordmark": "标志/文字商标",
"pk.logosVisuals": "标志与视觉",
"pk.mapCollect": "地图/收集点",
"pk.plain": "简洁",
"pk.pressKit": "新闻资料",
"pk.taglineLang": "标语语言",
"pk.typography": "排版",
"pk.variant": "变体",
"pr2.adBoostMsg": "好选择！你提高了快速找回物品的机会。",
"pr2.boostActivated": "提升已激活！",
"pr2.canRecoverNow": "你现在可以找回你的物品。",
"pr2.continue": "继续",
"pr2.downloadReceiptPdf": "下载收据（PDF）",
"pr2.goToSpaceNow": "现在前往我的账户",
"pr2.partnerBoostMsg": "好选择！提高可见性意味着吸引新客户来你的商家。",
"pr2.paymentSuccess": "支付成功！",
"pr2.redirectingSpace": "正在重定向到你的账户…",
"pr2.subActivated": "支付成功！你的订阅已激活，你现在可以管理你的商家。",
"prev.allSites": "所有商家",
"pricing.annual": "年度",
"pricing.annualBadge": "-20% 优惠",
"pricing.monthly": "每月",
"pricing.perYear": "/年",
"pricing.saveLabel": "你节省了",
"pricing.savePerYear": "/年每个额外商家",
"pub.accessGranted": "访问许可",
"pub.accessLimited2h": "访问限制为2小时",
"pub.accountEmailConcerned": "相关账户的电子邮件",
"pub.adAppearPublic": "这是你的广告将如何公开展示。",
"pub.adPreviewBtn": "广告预览",
"pub.alertMeOnArrival": "到达时提醒我",
"pub.allActionsLogged": "所有操作均已记录",
"pub.allCategories": "所有类别",
"pub.authorizeAccess": "授权访问",
"pub.authorizeSupportQ": "授权支持访问吗？",
"pub.available": "可用",
"pub.backHome": "返回主页",
"pub.boostAdCta": "提升我的广告",
"pub.boostAdTitle": "提升你的广告",
"pub.boostCarouselSub": "在“提升”轮播中移动到页面顶部，增加浏览量以更快找回你的物品。",
"pub.boostEstablishment": "提升你的商家",
"pub.boostEstablishmentDesc": "以“提升”标记出现在目录顶部，并吸引更多报告。",
"pub.boostFicheCta": "提升我的列表",
"pub.brandReady": "Findloop 品牌，随时可用",
"pub.cantFindItem": "找不到你的物品？",
"pub.cantProcessImage": "无法处理此图像",
"pub.claimQr": "索取二维码",
"pub.clickToZoom": "点击以缩放",
"pub.codeAlreadyValidated": "代码已验证 - 联系人解锁。",
"pub.codeExample": "例如 ABCD2345",
"pub.confirmRenewal": "确认续订",
"pub.contactIntro": "有问题或请求？写给我们，我们会尽快回复你。",
"pub.contactTypeDeceased": "账户删除（已故人员）",
"pub.contactTypeGeneral": "一般问题",
"pub.contactTypeSupport": "支持 / 技术问题",
"pub.contactUs": "联系我们",
"pub.continueWithoutEmail": "继续而不留我的邮箱",
"pub.contractLabel": "合同",
"pub.contractNotFound": "找不到合同或已过期。",
"pub.contractRenewed": "合同已续签！",
"pub.contractRenewedFor": "您的合同续签了 {n} 个月。",
"pub.copyFailed": "复制失败",
"pub.createPartnerAccount": "创建我的合作伙伴账户",
"pub.currentDeadline": "当前截止日期",
"pub.deceasedInfo": "作为亲属或继承人，您可以请求删除已故人员的 Findloop 账户。我们将按照GDPR处理您的请求（可能会要求提供支持文件）。",
"pub.declareMyLoss": "报告我的遗失",
"pub.describeItemPlaceholder": "描述您的物品（例如，黑色雨伞，钥匙…）",
"pub.downloadImage": "下载图片",
"pub.drawSignature": "请手写您的签名。",
"pub.drawSignatureHint": "用鼠标或手指绘制您的签名。",
"pub.duration": "持续时间",
"pub.eSignature": "电子签名",
"pub.eSignatureDesc": "输入您的名字进行签名。日期会自动记录。",
"pub.edit": "编辑",
"pub.editorialTitles": "编辑标题",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "输入通过电子邮件收到的代码以解锁所有者的联系方式。",
"pub.errorWord": "错误",
"pub.foundSelfService": "找回物品 · 自助服务",
"pub.haveOwnerCode": "我收到了来自所有者的代码",
"pub.home": "首页",
"pub.immediateRenewal": "即时续订，无需新报价。",
"pub.impAdminReq1": "管理员",
"pub.impAdminReq2": "请求临时访问您的账户",
"pub.impAdminReq3": "以协助您。",
"pub.impGrantedDesc": "支持团队将能够在最多 2 小时内访问您的账户。所有操作将被记录。您可以关闭此页面。",
"pub.invitedOnFindo": "您被邀请加入 Findloop",
"pub.isThisYourItem": "这是您的物品吗？",
"pub.itemsAvailableCount": "目前可用 {n} 件物品",
"pub.itemsFoundOwner": "已找到其所有者的委托物品",
"pub.itemsReturnedOwners": "物品已归还给其所有者",
"pub.itsMine": "这是我的",
"pub.joinFindoDesc": "加入 Findloop 并轻松管理您的找回物品。",
"pub.joinInvitesYou": "邀请您加入 Findloop。创建您的合作伙伴账户以管理您的找回物品。",
"pub.linkCopied": "链接已复制！",
"pub.loadingContract": "加载合同…",
"pub.lsClaimDesc": "报告您的遗失以找回它。留下您的邮箱，如果您的报告未完成，我们会给您发送提醒。",
"pub.lsHeroDesc": "亲自检查您的遗失物品是否已被找到并留在这里。找到了吗？报告以找回它。",
"pub.lsSearchTitle": "搜索找回物品",
"pub.makeOffer": "提出报价",
"pub.makeOfferDesc": "提出您的金额。超级管理员将审核它。",
"pub.mapNearYou": "您附近的物品和合作伙伴",
"pub.mapWord": "地图",
"pub.messageSentToast": "消息已发送 - 我们的团队会尽快回复。",
"pub.messageWord": "消息",
"pub.momoInitiated": "移动支付已启动",
"pub.monthsWord": "个月",
"pub.nameConsentRequired": "需要姓名和同意。",
"pub.newDeadline": "新截止日期",
"pub.noActionRequired": "无需任何操作。",
"pub.noAmountCharged": "未收取任何费用。",
"pub.noItemMatch": "当前没有可用的项目与您的搜索匹配。",
"pub.noMatchingItem": "没有匹配项",
"pub.noPaymentSession": "没有支付会话。",
"pub.noPhoto": "没有照片",
"pub.noPointsYet": "还没有积分可显示。",
"pub.noSecondPayment": "此项目不需要第二次付款。",
"pub.notHereYet": "还没到吗？一到就通知您。",
"pub.notifyDone": "已记录！我们会尽快通过电子邮件通知您匹配项到达的消息。",
"pub.offerSubmitted": "您的报价已提交。",
"pub.oops": "糟糕",
"pub.orAlertEmail": "或者，通过电子邮件早日获得匹配项的提醒：",
"pub.ownerContacts": "所有者的联系信息",
"pub.ownerContactsUnlocked": "所有者的联系信息已解锁",
"pub.partnerContact": "合作伙伴联系方式",
"pub.payLinkUnavailable": "付款链接不可用 - 请联系合作伙伴。",
"pub.paymentCancelled": "付款已取消",
"pub.paymentConfirmed": "付款已确认 🎉",
"pub.paymentConfirmedDesc": "您将收到一封电子邮件，包含取回您物品的详细信息。",
"pub.paymentNotConfirmed": "付款未确认",
"pub.paymentNotConfirmedDesc": "无法验证付款。请重试或联系合作伙伴。",
"pub.paymentProcessing": "付款正在处理中。请稍后刷新。",
"pub.photoAdded": "✓ 照片已添加",
"pub.photoRequired": "需要该项目的照片。",
"pub.previewAlt": "预览",
"pub.publish": "发布",
"pub.publishingWord": "发布中…",
"pub.qty": "数量",
"pub.quoteDeclined": "报价被拒绝。",
"pub.quoteNotFound": "未找到报价或已过期。",
"pub.reasonLabel": "原因",
"pub.recoveryAlreadyPaid": "恢复费用已支付",
"pub.referralCode": "推荐代码：",
"pub.relationshipPlaceholder": "儿子，配偶，公证人…",
"pub.renewYourContract": "续签合同",
"pub.renewalFailed": "续签失败。请稍后再试。",
"pub.renewing": "正在续签…",
"pub.replySoon": "我们的团队会尽快回复。",
"pub.requestGone": "该请求不存在。",
"pub.requestHandled": "请求已处理",
"pub.requestNotFound": "请求未找到或已过期。",
"pub.requestUnavailable": "请求不可用",
"pub.required": "（必填）",
"pub.retroClosing": "一起，让世界变得少一点迷失。",
"pub.retroClosing2": "一起，让世界变得少一点迷失。",
"pub.retroScroll": "一年来恢复重要的东西。向下滚动 ↓",
"pub.revokeAnytime": "您可以随时通过联系我们撤销",
"pub.scene": "场景",
"pub.sendImpossible": "无法发送",
"pub.sendMessage": "发送消息",
"pub.sending": "发送中…",
"pub.sharePreview": "分享预览",
"pub.shareYourAd": "分享您的广告",
"pub.signedSuccess": "签署成功！",
"pub.signerFullName": "签署人的全名",
"pub.spreadNetwork": "与您周围的人分享，以提升您的机会。",
"pub.spreadOwner": "分享帮助所有者找回他们的物品。",
"pub.statusLabel": "状态：",
"pub.subject": "主题",
"pub.thanksSent": "谢谢您，您的消息已发送。",
"pub.thisYear": "今年",
"pub.validate": "验证",
"pub.verifyingPayment": "正在验证付款…",
"pub.verifyingYourPayment": "正在验证您的付款…",
"pub.viewAd": "查看广告 →",
"pub.viewPartner": "查看合作伙伴 →",
"pub.yourAdPreview": "您的广告预览",
"pub.yourEmail": "您的电子邮件",
"pub.yourEmailRecommended": "您的电子邮件（推荐）",
"pub.yourEmailShort": "您的电子邮件",
"pub.yourName": "您的姓名",
"pub.yourRelationship": "您与此人的关系",
"qv.acceptAndSign": "接受并签署我的报价",
"qv.certifyAuthorized": "我证明我有权签字并接受此{what}（具约束力的价值）的条款。",
"qv.clear": "清除",
"qv.client": "客户",
"qv.conditions": "条款",
"qv.confirmDecline": "确认拒绝此报价吗？",
"qv.countersignedFindo": "由findloop签署 · {name} 于 {date}",
"qv.decline": "拒绝",
"qv.description": "描述",
"qv.downloadPdf": "下载PDF",
"qv.handwrittenSignature": "手写签名",
"qv.inclTax": "含税",
"qv.invalidAmount": "无效金额。",
"qv.invoice": "发票",
"qv.invoicePaid": "发票已支付",
"qv.issuer": "发行人",
"qv.messageOptional": "留言（可选）",
"qv.negotiatedAmount": "协商金额",
"qv.payInvoiceOnline": "在线支付发票",
"qv.quote": "报价",
"qv.quoteValidDays": "报价有效期 {n} 天。",
"qv.sendMyOffer": "发送我的报价",
"qv.signContract": "签署我的合同",
"qv.signNow": "立即签署",
"qv.signatureAlt": "签名",
"qv.signedByOn": "✔ {name} 于 {date} 签署",
"qv.stContractSigned": "合同已签署。谢谢！",
"qv.stCounterAccepted": "您的报价已被接受！请在下面签署合同。",
"qv.stCounterRefused": "您的报价未被接受。",
"qv.stCountered": "您的报价已提交。等待findloop的回复。",
"qv.stDeclined": "您已拒绝此报价。",
"qv.stSigned": "报价已接受并签署。谢谢！",
"qv.totalHt": "总计（不含税）",
"qv.totalTtc": "总计（含税）",
"qv.unitHt": "单价（不含税）",
"qv.vat": "增值税",
"qv.yourProposedAmount": "您提议的金额（{cur}）",
"reg.add": "记录项目",
"reg.allBrands": "所有品牌",
"reg.allColors": "所有颜色",
"reg.allLocations": "所有地点",
"reg.detailDesc": "此找到项目的详细信息和操作。",
"reg.dispAuction": "拍卖",
"reg.dispAuthorities": "交给当局",
"reg.dispDestroyed": "已销毁",
"reg.dispDonate": "慈善捐赠",
"reg.dispositionHint": "记录物品离开存储的情况。按类别统计。",
"reg.emptyCta": "记录物品",
"reg.emptyDesc": "开始记录你的第一个物品。",
"reg.emptyTitle": "未找到物品",
"reg.establishmentFallback": "该机构",
"reg.lblAuctioned": "已列出拍卖",
"reg.lblAuctionedShort": "已拍卖",
"reg.lblAuthorities": "已交给当局",
"reg.lblDestroyed": "已销毁",
"reg.lblDonated": "已捐赠给慈善组织",
"reg.legalCount": "{n} 件物品：法定保留期限已到",
"reg.legalHint": "你可以将其列出拍卖、捐赠给慈善组织或报告交给当局。",
"reg.legalLimitCountry": "截止日期：{date} · 适用国家：{country}",
"reg.legalOver": "截止日期已过：{date} · {country}",
"reg.legalReached": "法定期限已到",
"reg.legalReachedFull": "法定保留期限到期",
"reg.limitShort": "截止日期",
"reg.location": "位置",
"reg.markRestituted": "标记为已归还",
"reg.markedAs": "物品标记为 {label}",
"reg.moveHistory": "移动历史",
"reg.overBy": "超过 {n} 天",
"reg.physicalLocation": "物理位置",
"reg.popupBlocked": "允许弹出窗口以打印标签。",
"reg.popupBlockedOne": "允许弹出窗口以打印标签。",
"reg.printLabel": "打印标签",
"reg.printN": "打印 {n} 个标签",
"reg.qrCodeItem": "物品二维码",
"reg.qrLabelTitle": "二维码标签",
"reg.qrLabelsTitle": "二维码标签",
"reg.qrNotFound": "未找到此二维码对应的物品。",
"reg.qrScanHint": "扫描以直接打开此记录并查找位置。",
"reg.recoveryFee": "回收费用 (€)",
"reg.searchPh": "按描述搜索……",
"reg.selectQr": "选择以打印二维码标签",
"reg.selectedN": "已选择 {n} 个",
"reg.shipPricePh": "运费 (€)",
"reg.shippingPossible": "可进行配送",
"reg.storagePh": "例如：A3架子，12号储物柜",
"reg.tAuction": "Findloop 拍卖",
"reg.tAuthorities": "报告交给当局",
"reg.tDonate": "捐赠给慈善组织",
"reg.toastFee": "费用已更新",
"reg.toastLocation": "位置已保存",
"reg.toastRestituted": "物品标记为已归还",
"reg.toastShipping": "运输选项已更新",
"reg.toastTransferred": "物品已转移至 “{name}”",
"reg.unclaimedDisposition": "无人认领的物品 — 最终处理",
"res.codeValidated": "代码已验证",
"res.empty": "尚未记录任何物品归还。",
"res.error": "错误 {status}",
"res.proofPdf": "PDF 证明",
"res.signed": "已签署",
"res.stRestituted": "亲自交付",
"res.stShipped": "通过运输返回",
"res.subtitle": "所有已完成的交接及其可下载的签署证明。",
"res.title": "物品归还历史",
"rev.restitutedBy": "由 {org} 归还",
"rev.storiesEyebrow": "幸福的结局",
"rev.storiesSubtitle": "来自客户的真实故事，他们通过findloop找回了他们的物品。",
"rev.storiesTitle": "他们找回了他们的物品！",
"rp.already": "您已经报告了此列表。",
"rp.duplicate": "重复",
"rp.inappropriate": "不当内容",
"rp.wrongCategory": "错误类别",
"rt.annualGoal": "年度目标",
"rt.championCity": "冠军城市",
"rt.cityRate": "{rate}% 的回收率",
"rt.goalProgress": "{rate}% 达成 {target}% 的目标",
"rt.reached": "已达成 🎉",
"rt.restitutionRate": "回收率",
"rt.shareRecap": "分享我的总结",
"rt.thanks": "谢谢你，Findloop {year} 💛",
"rt.yourRecap": "您的 {year} 总结",
"rw.active": "活跃",
"rw.add": "添加",
"rw.camUnavailable": "相机不可用。请在下面手动输入代码。",
"rw.codeValidated": "代码已验证",
"rw.codesTitle": "找回者兑换的代码",
"rw.confirmDelete": "删除“{title}”吗？",
"rw.deleted": "已删除",
"rw.edit": "编辑",
"rw.editReward": "编辑奖励",
"rw.empty": "尚无奖励。",
"rw.expired": "已过期",
"rw.expiresOn": "到期于 {date}",
"rw.fActive": "活跃（对找回者可见）",
"rw.fCost": "成本（积分）",
"rw.fDesc": "描述",
"rw.fStock": "库存（空=无限）",
"rw.fTitle": "标题",
"rw.fValidity": "凭证有效期（兑换后天数）",
"rw.inactive": "非活跃",
"rw.newReward": "新奖励",
"rw.noExchange": "尚无兑换。",
"rw.pageSubtitle": "扫描找回者呈现的凭证以验证他们的奖励。",
"rw.redeemedN": "已兑换: {n}×",
"rw.saved": "奖励已保存",
"rw.scanVoucher": "扫描凭证",
"rw.staffScanOnly": "仅限扫码",
"rw.statActive": "待呈现",
"rw.statExpired": "已过期",
"rw.statRedeemed": "凭证已兑换",
"rw.statUsed": "已验证",
"rw.stock": "库存",
"rw.subtitle": "提供非货币福利（凭证，升级…），让找回者兑换他们的Finder Score积分。",
"rw.title": "找回者奖励",
"rw.used": "已使用",
"rw.validate": "验证",
"rw.validateCode": "验证代码",
"rw.validity": "有效期: {n} 天",
"side.establishments": "机构",
"side.restitutions": "归还",
"side.rewards": "奖励与凭证",
"side.settings": "设置",
"side.storage": "存储与二维码",
"status.auctioned": "拍卖",
"status.destroyed": "已销毁",
"status.donated": "已捐赠（慈善）",
"status.handed_to_authorities": "交给了有关部门",
"status.in_storage": "在存储中",
"status.matched": "匹配",
"status.open": "开放",
"status.paid": "已支付",
"status.pending": "待处理",
"status.restituted": "已归还",
"status.shipped": "已发货",
"status.shipping_requested": "已申请发货",
"status.submitted": "已提交",
"stg.allLabels": "所有二维码标签",
"stg.camHint": "请在下面手动输入。",
"stg.camStarting": "正在启动相机…",
"stg.camUnavailable": "相机不可用。",
"stg.clear": "清除",
"stg.clearAll": "清除所有",
"stg.codeUnreadable": "无法读取的代码。",
"stg.emptyDesc": "存储的物品将在此处显示，按位置分组。",
"stg.emptyTitle": "存储中没有物品",
"stg.exportAudit": "导出审核 CSV",
"stg.exportDone": "CSV 导出已下载",
"stg.exportImpossible": "当前无法导出。",
"stg.itemFound": "物品已找到 ✅",
"stg.kLocations": "使用的位置",
"stg.kObjects": "存储的物品",
"stg.kToClear": "要清除的位置",
"stg.locFreed": "位置已清除",
"stg.locsFreed": "{n} 个位置已清除",
"stg.manualLabel": "或输入物品的代码 / ID",
"stg.manualPh": "粘贴二维码的 ID 或 URL",
"stg.noItemMatch": "没有物品与此二维码 / 代码匹配。",
"stg.noLocation": "没有位置",
"stg.objectsAxis": "物品",
"stg.objectsN": "{n} 个物品",
"stg.occAvg": "每个位置平均 {n} 个物品",
"stg.occHint": "琥珀色的位置超出了平均值（可能过载）。",
"stg.occupancy": "位置占用率",
"stg.openPage": "打开页面",
"stg.posterPdf": "PDF 海报 (A4)",
"stg.printAll": "打印全部",
"stg.printGroupTitle": "为此货架打印标签",
"stg.qrAlt": "自助服务二维码",
"stg.qrDownload": "下载二维码",
"stg.qrHint": "在柜台展示此二维码：您的客户扫描它以检查他们的物品是否可用。",
"stg.qrTitle": "客户自助服务二维码",
"stg.scanDesc": "扫描物品的标签以立即打开其记录。",
"stg.scanQr": "扫描二维码",
"stg.scanTitle": "扫描二维码",
"stg.search": "搜索",
"stg.shelf": "货架 {loc}",
"stg.shelfPlan": "货架计划",
"stg.staleHint": "清理这些位置以保持您的物理库存最新。",
"stg.staleTitle": "{n} 个物品已离开存储但仍保留一个位置",
"stg.subtitle": "货架计划、二维码扫描和物理库存跟踪。",
"stg.title": "存储与二维码",
"stt.acceptRate": "接受率",
"stt.accepted": "已接受",
"stt.activity30": "活动（过去 30 天）",
"stt.ai6mo": "最近 6 个月 · 接受 = 自动匹配 + 确认。",
"stt.aiEmpty": "在此期间尚无 AI 匹配。",
"stt.aiTitle": "人工智能匹配 — 接受与拒绝",
"stt.auctionShort": "拍卖",
"stt.auctionedSold": "已拍卖（售出）",
"stt.authShort": "机构",
"stt.authorities": "交给机构",
"stt.avgRating": "平均评分",
"stt.awaitingRestitution": "待返回物品",
"stt.boostClicks": "本周因推广而获得的目录点击量",
"stt.boostInactive": "推广未启用 — 启用它以增加可见性",
"stt.certifiedPremium": "认证优质",
"stt.declarations": "声明",
"stt.destroyed": "已销毁",
"stt.dispoEmpty": "尚未有任何未认领的物品离开存储。",
"stt.donatedAssoc": "捐赠（慈善）",
"stt.donatedShort": "捐赠",
"stt.gateCta": "发现计划",
"stt.gateDesc": "升级到基础版以解锁基本统计，或升级到企业版以获得高级统计和每个机构的分析。",
"stt.gateTitle": "仅限付费计划的统计数据",
"stt.inStorage": "在存储中",
"stt.kItems": "注册物品",
"stt.kRate": "退货率",
"stt.kRestituted": "已退还物品",
"stt.kRevenue": "收入（月份）",
"stt.noDeclYet": "尚未有声明。",
"stt.recapDownloaded": "回顾已下载 — 准备分享！",
"stt.recapError": "无法生成回顾",
"stt.recapText": "我们的 Findloop {year} 回顾：已退还物品和客户满意度 🎉",
"stt.recapTitle": "Findloop {year} 回顾",
"stt.rejected": "已拒绝",
"stt.restitutions": "退还",
"stt.shareRecap": "分享我的 {year} 回顾",
"stt.topCategories": "最多声明的类别",
"stt.unclaimedDesc": "按类别的销毁、捐赠给慈善机构和拍卖的物品数量。",
"stt.unclaimedTitle": "未认领物品 — 离开存储",
"stt.vsLastWeek": "与上周相比",
"sub.cancel": "取消我的订阅",
"sub.cancelAbort": "取消",
"sub.cancelConfirm1": "您确定要取消吗？您的访问将保持有效直到",
"sub.cancelConfirm2": "不予退款。",
"sub.cancelConfirmBtn": "确认取消",
"sub.cancelTitle": "取消您的订阅",
"sub.cancelledToast": "取消已记录。",
"sub.cguAnd": "和",
"sub.cguDesc": "请在付款前确认您的同意。",
"sub.cguLink": "使用条款",
"sub.cguPay": "继续付款",
"sub.cguPre": "我已阅读并接受",
"sub.cguRequired": "您必须接受使用条款和隐私政策才能继续。",
"sub.cguSuffix": "的 Findloop。",
"sub.cguTitle": "完成您的订阅",
"sub.expiresOn": "您的订阅将在此日期到期",
"sub.noProrata": "不予按比例退款。",
"sub.privacyLink": "隐私政策",
"sub.renewsOn": "您的订阅将在此日期续订",
"sub.resume": "重新订阅",
"sub.resumedToast": "重新订阅已确认。",
"tier.free": "免费",
"tier.large": "企业版",
"tier.medium": "商业版",
"tier.small": "基础版",
"tm.add": "添加",
"tm.adminOpt": "管理员（完整视图）",
"tm.chooseEst": "选择一个机构",
"tm.chooseEstPh": "选择一个机构",
"tm.copyFail": "复制失败",
"tm.copyLink": "复制链接",
"tm.copyOk": "邀请链接已复制",
"tm.emailHint": "将发送一封邀请电子邮件以创建密码。",
"tm.expiresOn": "在 {date} 到期",
"tm.forEmail": " 针对 {email}",
"tm.forbidden": "团队管理仅限账户所有者。",
"tm.inviteCreated": "邀请已创建",
"tm.inviteDesc": "邀请电子邮件允许团队成员创建他们的密码。",
"tm.invitePending": "待处理邀请",
"tm.inviteResent": "邀请已重新发送",
"tm.inviteSent": "邀请已通过电子邮件发送",
"tm.inviteTitle": "邀请成员",
"tm.invitedOn": "于 {date} 邀请",
"tm.linkExpired": "链接已过期",
"tm.memberRemoved": "成员已移除",
"tm.name": "姓名",
"tm.noMembers": "尚无团队成员。",
"tm.resendTitle": "重新发送邀请",
"tm.role": "角色",
"tm.roleAdmin": "管理员",
"tm.roleOwner": "所有者",
"tm.roleStaff": "员工",
"tm.roleUpdated": "角色已更新",
"tm.sendInvite": "发送邀请",
"tm.sending": "发送中…",
"tm.staffOpt": "员工（仅查看他们的机构）",
"trk.carrier": "承运商",
"trk.shipPending": "货物正在准备中 — 追踪号码将在发送后显示在此处。",
"trk.shipTitle": "货物追踪",
"trk.trackShipment": "追踪包裹",
"trk.trackingNo": "追踪号码",
"a.firstName": "名字",
"ac.emailCrossMatch": "B2C 交叉匹配",
"ac.emailCrossMatchDesc": "当公共失物广告与您场所存放的物品匹配时发送电子邮件",
"ac.emailCrossReject": "公共匹配拒绝",
"ac.emailCrossRejectDesc": "当客户表示建议的公共匹配不是他们的物品时，接收电子邮件",
"ac.emailLoginNotif": "登录通知",
"ac.emailLoginNotifDesc": "每当有人登录到您的账户时，接收电子邮件",
"ad.closeNoCancel": "不，移除列表",
"ad.closeQuestion": "物品是否已归还给您？",
"ad.closeQuestionDesc": "让我们知道您是否找回了物品，或者您只是想删除此列表。",
"ad.closeYesRestituted": "是的，物品已归还",
"ad.closedRestituted": "物品归还 — 列表已关闭 🎉",
"an.lostLoginDesc": "报告失物并跟踪归还需要一个账户。",
"an.lostLoginRequired": "登录以报告失物",
"an.qfAll": "全部",
"an.qfBoosted": "提升",
"an.qfPhoto": "带照片",
"an.qfRecent": "本周",
"an.qfResolved": "已解决",
"an.restitutionInProgress": "物品正在归还中",
"dec.descPhLong": "描述物品：品牌、颜色、明显特征……（您提供的细节越多，找回物品的机会就越大）",
"dec.loadError": "当前无法加载合作伙伴。检查您的连接并重试。",
"dec.retry": "重试",
"dec.shippingMode": "运输",
"dep.photo2": "第二件物品照片",
"dep.photo2Hint": "可选 — 另一个角度可以提高视觉匹配的准确性。",
"dl.accountSuspended": "因未支付发票而暂停账户。请结算以恢复访问。",
"dl.regularize": "立即结算 →",
"dl.suspensionCountdown": "发票 {num} 未付款 — 您的账户将在 {days} 天内被暂停。请结算以避免此情况。",
"ft.cancelConfirm": "取消您的报告？物主将会被通知。",
"ft.cancelDone": "报告已取消。",
"ft.cancelLocked": "在物主付款后无法再取消。",
"ft.cancelReport": "取消我的报告",
"ft.claimCodeHelp": "在交接时将此代码提供给寻物者，以确认您已收到您的物品。",
"ft.claimCodeTitle": "您的归还代码",
"ft.claimDone": "物品已归还。感谢使用 Findloop！",
"ft.claimUnlockHint": "解锁寻物者的联系信息",
"ft.claimUnlockHintSub": "前往您的账户中的“我正在索取的物品”，支付费用以获取联系信息。",
"ft.finderCodeShownHelp": "物主已付款并选择了您。复制下面的代码以确认归还 — 无需检查您的电子邮件。",
"ft.finderCodeShownTitle": "物主的验证代码",
"ft.finderContactsTitle": "Finder 的联系信息",
"ft.foundCodeHelp": "在交接时向所有者出示此代码以确认物品已被归还。",
"ft.inProgressOther": "物品正在归还中",
"ft.inProgressOtherHelp": "所有者为此物品选择了另一个查找者。您这边无需采取进一步行动。",
"ft.restitutionCodeHelp": "此代码确认物品交接。下面已经预填，请验证后关闭案件。",
"ft.restitutionCodeTitle": "您的归还代码",
"hc.14Digits": "14 位数字",
"hc.15DaysBeforeAnItem": "在物品的法定截止日期前 15 天。",
"hc.7DaysBeforeAnItem": "在物品的法定截止日期前 7 天。",
"hc.8CharactersMinimum": "最低 8 位字符。",
"hc.aClaimToValidate": "一个待验证的请求",
"hc.aFindoAssistanceSessionIs": "您的账户上当前有一个 Findloop 帮助会话。",
"hc.aNewMatchHasBeen": "已找到一个新匹配",
"hc.aUser": "一个用户",
"hc.aUserClaimsToBe": "一个用户声称是所有者。在授权归还之前，请检查他们的答案。",
"hc.aboutFindo": "关于 Findloop",
"hc.accountActivatedPleaseLogIn": "账户已激活，请登录。",
"hc.accountActivation": "账户激活",
"hc.accountCreated": "账户创建成功！",
"hc.accountDeactivatedAReactivationEmail": "账户已停用。已向您发送了一封 reactivation 邮件（有效期 30 天）。",
"hc.accountReactivation": "账户重新激活",
"hc.activateMyAccount": "激活我的账户",
"hc.activateMyAdminAccount": "激活我的管理员账户",
"hc.activating": "正在激活…",
"hc.activeMatchCancelReason": "活跃匹配。客户的取消原因：“{reason}”。该物品仍在等待索赔。",
"hc.activeMatchWithAPublic": "与公众（客户）名单的活跃匹配。等待所有者的索赔。",
"hc.addAPhoto": "添加照片",
"hc.addAndConfigureYourEstablishments": "在“场所”中添加和配置您的场所：联系信息、类别和物品的实际存储。",
"hc.addOnGoogle": "在 Google 上添加",
"hc.address": "地址",
"hc.addressSaved": "地址已保存",
"hc.addressStreet": "地址 — 街道",
"hc.adjustThePhoto": "调整照片",
"hc.adminFullView": "管理员（完整视图）",
"hc.administratorOnly": "仅管理员",
"hc.africa": "非洲",
"hc.aiVisualComparison": "AI 视觉比较",
"hc.all": "所有",
"hc.amount": "金额",
"hc.anOrganization": "一个组织",
"hc.analyzing": "正在分析…",
"hc.andRecoveryIs": "和恢复是",
"hc.andTheDeclarationWillBe": "声明将会被关闭（移至历史）。此操作是最终的。",
"hc.annual20": "年度 -20%",
"hc.annualBilling20": "年度账单（−20%）",
"hc.annualTarget": "年度目标",
"hc.anyCommentsOptional": "有任何评论？（可选）",
"hc.approveTheClaim": "批准索赔",
"hc.archiveCancelledConfirm": "归档 {n} 个 \"客户取消\" 的列表吗？它们将从注册中删除。",
"hc.asSoonAs": "尽快",
"hc.askTheOwnerToDisplay": "请业主展示其代码的二维码（跟踪页面）。",
"hc.askThemAtTheCounter": "请他们在柜台确认身份 — 永远不会公开显示。",
"hc.assistance": "支持",
"hc.assistanceSessionRevoked": "支持会话已撤销。",
"hc.atLeast6Characters": "至少6个字符",
"hc.automaticallyPreSelected": "自动预选",
"hc.automaticallyWhenShipping": "在发货时自动。",
"hc.awaitingClaim": "等待索赔",
"hc.awaitingPayment": "等待付款",
"hc.b2cCustomer": "B2C客户",
"hc.back": "返回",
"hc.backToHome": "返回主页",
"hc.backToMyAccount": "返回我的账户",
"hc.backToPayment": "返回付款",
"hc.beforeAfterComparisonSlider": "前后对比滑块",
"hc.billingInformation": "账单信息",
"hc.billingInformationSaved": "账单信息已保存 ✓",
"hc.brand": "品牌",
"hc.bronze": "铜",
"hc.calculatingTheShippingRate": "正在计算运费…",
"hc.cameraUnavailableEnterTheCode": "相机不可用。请手动输入代码。",
"hc.cancel": "取消",
"hc.cancelMyDeclaration": "取消我的声明",
"hc.cancelSavedFmt": "已保存取消：\"{reason}\"。您仍然可以索赔。",
"hc.cancelTheDeposit": "取消押金",
"hc.cancelThisMatch": "取消此匹配",
"hc.cancellationReason": "取消原因",
"hc.cancelled": "已取消",
"hc.cancelledByTheCustomer": "由客户取消",
"hc.cannotOpenPayment": "无法打开支付。请再试一次。",
"hc.careers": "职业",
"hc.carrier": "承运商",
"hc.carrierAvailabilityCannotBeChecked": "在配置 Sendcloud 发件人之前无法检查承运商可用性。",
"hc.carrierConfirmedCharged": "承运商确认 - 已向客户收取 {price} €",
"hc.carrierOther": "承运商（其他）",
"hc.carrierSelection": "承运商选择",
"hc.caseClosedThankYou": "案件已关闭。谢谢！",
"hc.category": "类别",
"hc.changeMethod": "更改方式",
"hc.characteristic": "特征",
"hc.chargedToCustomer": "向客户收费。",
"hc.checkOrEditYourDetails": "在安全付款前检查或编辑您的详细信息。",
"hc.checkStatisticsToTrackDeposited": "查看“统计”以跟踪已存放的物品、退货率和各个机构的表现。",
"hc.checkTheDetailsBeforeContacting": "在联系寻物者之前检查详细信息。",
"hc.checkTheDetailsBelowBefore": "在开始退货请求之前检查以下详细信息。",
"hc.checkTheNewItem": "检查新项目",
"hc.checkThePhotosAndCharacteristics": "在继续恢复之前，请检查以下照片和特征。",
"hc.chooseACountry": "选择一个国家",
"hc.chooseANewPassword": "选择一个新密码",
"hc.chooseAReason": "选择一个理由",
"hc.chooseTheLegalRetentionAlerts": "选择通过电子邮件接收的法律保留通知",
"hc.chooseYourPasswordToAccess": "选择您的密码以访问管理控制台。",
"hc.city": "城市",
"hc.claimApproved": "索赔已批准",
"hc.claimApproved2": "索赔已批准。",
"hc.claimCodeExpired": "索赔代码已过期",
"hc.claimCodeVerified": "索赔代码已验证",
"hc.claimNotFound": "未找到索赔",
"hc.claimNotValidated": "索赔未验证",
"hc.claimRejected": "索赔被拒绝",
"hc.claimRejected2": "索赔被拒绝。",
"hc.claimValidated": "索赔已验证",
"hc.claimValidatedByThePartner": "索赔已由合作伙伴验证",
"hc.claimant": "索赔人",
"hc.claimsToBeTheOwner": "声称是该物品的所有者并回答了验证问题。只有在答案匹配时才批准。",
"hc.claimsToValidate": "待验证的索赔",
"hc.clear": "清除",
"hc.clickToZoom": "点击放大",
"hc.close": "关闭",
"hc.close2": "关闭",
"hc.closeTheDeclaration": "关闭声明",
"hc.closeTheDeclaration2": "关闭声明？",
"hc.codeAlreadyVerified": "代码已验证",
"hc.codeCopied": "代码已复制",
"hc.collapse": "折叠",
"hc.color": "颜色",
"hc.company": "公司",
"hc.companyName": "公司名称",
"hc.comparePhotos": "比较照片",
"hc.compareThemWithTheOwner": "与所有者的回答进行比较——永远不公开可见。",
"hc.condition": "状态",
"hc.confirmAndPay": "确认并支付",
"hc.confirmCancellation": "确认取消",
"hc.confirmCrop": "确认裁剪",
"hc.confirmDeletion": "确认删除",
"hc.confirmPassword": "确认密码",
"hc.confirmThatThisIsYour": "确认这是你的物品。在任何联系之前，查找者将要求进行身份验证。",
"hc.confirmTheCarrier": "确认承运人",
"hc.confirmThePassword": "确认密码",
"hc.confirmYourShippingAddressTo": "确认您的送货地址以继续付款。",
"hc.confirmYourSubscription": "确认您的订阅",
"hc.confirmed": "已确认 ✓",
"hc.contactFindoToGetYour": "联系 Findloop 获取您的发件人 ID。",
"hc.contactUs": "联系我们",
"hc.continueTheReturn": "继续退货",
"hc.continueToPayment": "继续付款",
"hc.copy": "复制",
"hc.correctMyDetails": "更正我的信息",
"hc.correctThisEntry": "更正此条目？",
"hc.country": "国家",
"hc.countryAddress": "国家（地址）",
"hc.countryIsoCodeEG": "国家（ISO 代码，例如 FR）",
"hc.cover": "封面",
"hc.createTheShipment": "创建货件",
"hc.cropThePhoto": "裁剪照片",
"hc.customer": "客户",
"hc.customerClaimCodeToCheck": "客户索赔代码 — 在取件时检查：",
"hc.customerReasonFmt": "客户的原因：\"{reason}\"。",
"hc.customerReminderDelay": "客户提醒延迟",
"hc.customerWhosePublicListingMatches": "与此物品匹配的客户公共列表——仅对您可见。",
"hc.d15": "D-15",
"hc.dangerZone": "危险区域",
"hc.date": "日期",
"hc.dateNewest": "日期（最新）",
"hc.dateOldest": "日期（最旧）",
"hc.daysToYearEnd": "距离年底还有 {n} 天",
"hc.deadlineAlert": "截止日期提醒",
"hc.declarationClosed": "声明已关闭 ✓",
"hc.declarationNotFound": "未找到声明。",
"hc.declarationNotFound2": "未找到声明",
"hc.declarationTracking": "声明跟踪",
"hc.defaultCarrier": "默认承运商",
"hc.defaultCarrierPreselected": "默认承运商已预选 - 可以更改为此货件。实际费用（Sendcloud + {m}% 的利润）。",
"hc.defaultCarrierRemoved": "默认承运商已移除",
"hc.delayHours": "延迟（小时）",
"hc.deleteMyAccount": "删除我的账户",
"hc.deleting": "正在删除…",
"hc.deletingDeactivatesYourAccountLogin": "删除会停用您的账户：登录被阻止，数据保留 30 天。您将收到一封包含有效 30 天的重新激活链接的电子邮件。",
"hc.delivered": "已交付",
"hc.depositAnItem": "存放物品",
"hc.depositCancelledItemPutBack": "存放取消 — 物品已放回库存。",
"hc.depositCancelledItemRemovedFrom": "存放取消 — 物品已从登记册中移除。",
"hc.depositedOn": "存放于",
"hc.describeTheItemBrandColor": "描述物品：品牌、颜色、特征标记…（提供越多细节，找到物品的几率越高）",
"hc.dimensionsCm": "尺寸（厘米）",
"hc.disablingAnEmail": "停用电子邮件",
"hc.doesNotHide": "不隐藏",
"hc.download": "下载",
"hc.downloadThePdf": "下载 PDF",
"hc.draftRestoredPickUpYour": "草稿已恢复 - 从您停留的地方取回声明。",
"hc.dragToReposition": "拖动以重新定位",
"hc.eGColisPriv": "例如：Colis Privé",
"hc.eachItemGetsAQr": "每个物品都有一个二维码标签。通过“存储与二维码”快速扫描以定位物品。",
"hc.eachSiteManagesItsOwn": "每个网站独立管理其银行事务。前往",
"hc.edit": "编辑",
"hc.emailNotificationPreferences": "电子邮件通知偏好",
"hc.emailPreferencesUpdated": "电子邮件偏好已更新",
"hc.enableOrDisableRecoveryFees": "启用或禁用恢复费用",
"hc.enlargePhoto": "放大照片",
"hc.enterTheCustomerSCode": "输入客户的代码",
"hc.estShipRate": "预计运费 (Sendcloud + {m}% 利润):",
"hc.establishment": "机构",
"hc.establishment2": "机构:",
"hc.establishmentInItsSendcloudAccount": "在其 Sendcloud 账户中的机构，并提供发件人 ID",
"hc.establishmentSettings": "机构设置",
"hc.exCode": "例如 ABCD2345",
"hc.exId": "例如 3f2a…",
"hc.exit": "退出",
"hc.explainWhyThisItemIs": "解释为什么这个物品不是你的…",
"hc.externalPaymentLinks": "外部支付链接",
"hc.failed": "失败",
"hc.feesEnabled": "费用已启用",
"hc.field": ") 字段。",
"hc.finderAcceptedCloseTheCase": "查找器已接受 — 一旦物品亲自交接，关闭案件。",
"hc.findoCityRanking": "Findloop — 城市排名",
"hc.findoForEstablishments": "Findloop 为机构",
"hc.findoPresentationVideo": "Findloop 演示视频",
"hc.findoRegistersTheAddressOf": "Findloop 注册您的地址",
"hc.findoReviewShare": "Findloop {year} 回顾: {n} 件物品被退回，{rate}% 退货率 🎉",
"hc.firstVerifyTheClaimCode": "首先验证上述索赔代码",
"hc.forEveryNewShipmentFrom": "对于每个新的发货来自",
"hc.free": "免费",
"hc.freeRecovery0": "免费恢复 (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "非洲范围内免费恢复 – 首发优惠",
"hc.freeRecoveryFeesDisabled0": "免费恢复: 费用已禁用 (0 €)",
"hc.fromTeamInviteYourColleagues": "从 \"团队\"，通过电子邮件邀请您的同事并分配给他们一个机构。每个成员只会看到他们自己的权限范围。",
"hc.fullName": "全名",
"hc.fullPhoto": "全照片",
"hc.gallery": "画廊",
"hc.giveTheReasonForCancelling": "给出取消的原因。合作伙伴会被通知。",
"hc.goToLogin": "前往登录",
"hc.goToMyAccount": "前往我的账户",
"hc.gold": "金",
"hc.googleLoginFailed": "谷歌登录失败",
"hc.hasConfirmedYourPaymentYou": "已确认您的付款，您将自动被重定向",
"hc.helpCenter": "帮助中心",
"hc.helpUsImproveWhyAre": "帮助我们改进: 您为什么要离开？您的账户将被停用，并可以在 30 天内重新激活。",
"hc.hidePassword": "隐藏密码",
"hc.high": "高",
"hc.historyOfYourMonthlySubscriptions": "您每月订阅的历史及其付款状态。",
"hc.hotelBelmont": "贝尔蒙酒店",
"hc.howConfigureSenderId": "我该如何设置我的数字发件人ID？",
"hc.iDonTUseIt": "我不经常使用它",
"hc.iFoundItElsewhere": "我在其他地方找到了它",
"hc.iNoLongerNeedMy": "我不再需要我的物品",
"hc.identityVerification": "身份验证",
"hc.idleLogoutIn": "由于无操作，您将在 {n} 秒后被登出。",
"hc.ifProvidedTheVolumetricWeight": "如果提供，体积重量将被使用。",
"hc.ifThePartnerHasNot": "如果合作伙伴在此延迟后尚未确认收到外部付款，Findloop将自动提醒合作伙伴进行验证。",
"hc.impersonationEnded": "冒充结束。",
"hc.impersonationMode": "冒充模式",
"hc.impersonationSessionExpired": "冒充会话已过期。",
"hc.inTheField": "，在现场",
"hc.inTransit": "运输中",
"hc.inclVat": "含增值税",
"hc.intraEuVatNumberOptional": "欧盟内部增值税号可选，法国以外不需要SIRET。",
"hc.invalidInvitationLink": "无效的邀请链接。",
"hc.invalidInvitationLink2": "无效的邀请链接",
"hc.invalidInviteLink": "无效或过期的邀请链接。",
"hc.invalidNumberEnterAnInternational": "无效号码。请输入国际号码，例如 +33 6 12 34 56 78。",
"hc.invalidOrExpiredLink": "无效或过期的链接。",
"hc.invalidOrExpiredReactivationLink": "无效或过期的重新激活链接",
"hc.invalidSendcloudId": "无效的Sendcloud ID",
"hc.inviteSubtitle": "{org} 邀请您加入他们的findloop团队。选择您的密码以激活您的帐户。",
"hc.isAvailableOnSendcloudFor": "在Sendcloud上适用于您所有的路线（国内 + 国际）。",
"hc.isNotEnabledOnYour": "在您的Sendcloud帐户中某些目的地未启用。对于这些目的地，标签将由其他可用承运商生成。",
"hc.isThisReallyYourItem": "这真的是您的物品吗？",
"hc.isThisYourItem": "这是您的物品吗？",
"hc.item": "物品",
"hc.itemAlreadyConfirmed": "物品已确认",
"hc.itemDetails": "物品详情",
"hc.itemFoundAt": "物品找到在",
"hc.itemFoundAtAPartner": "物品找到在合作伙伴处",
"hc.itemMarkedAsReturned": "物品标记为已退回 ✓",
"hc.itemPhotoRequiredBeforeShipping": "物品照片（发货前必需）",
"hc.itemPhotoSaved": "物品照片已保存",
"hc.itemPreview": "物品预览",
"hc.itemPutBackInStorage": "物品已放回存储。",
"hc.itemWeight": "物品重量：",
"hc.itemsReturned": "已退回物品",
"hc.itemsReturnedThisYear": "今年已退还的物品",
"hc.itemsWhoseLegalDeadlineIs": "法律截止日期在 15 天内（包括逾期）的物品。匹配项仍然可见。",
"hc.kbisNumber": "Kbis 号码",
"hc.keysForgottenOnABench": "遗忘在长椅上的钥匙",
"hc.labelBeingGenerated": "标签生成中",
"hc.leaveTheFieldsEmptyTo": "将字段留空以提供免费恢复。",
"hc.legalNotice": "法律通知",
"hc.limitReachedUpgradeToA": "已达到限制 — 升级到更高的计划",
"hc.linkCopiedShareOn": "链接已复制 — 在 {label} 上分享",
"hc.linkUnavailable": "链接不可用",
"hc.linkedTo": "链接到",
"hc.listingHiddenByModeration": "清单已被审核隐藏。",
"hc.loading": "加载中…",
"hc.locateMe": "定位我",
"hc.logIn": "登录",
"hc.logInToGetBack": "登录以返回到您的空间并管理您的订阅。",
"hc.loginFailed": "登录失败",
"hc.lostFoundPlatform": "失物招领平台。",
"hc.lostIn": "丢失于",
"hc.lowRate": "低费率",
"hc.mainReason": "主要原因",
"hc.mainStreet": "主街",
"hc.makeSureThisIsThe": "请确保这是您丢失的物品，然后再解锁找人的联系方式。",
"hc.manageCookies": "管理 cookies",
"hc.manageMyTeam": "管理我的团队",
"hc.manageYourTeam": "管理您的团队",
"hc.markAsReturned": "标记为已退还",
"hc.matchNoClaimInTime": "在截止日期内没有收到索赔的匹配项。",
"hc.matchNotFound": "未找到匹配项",
"hc.medium": "中等",
"hc.milestoneFmt": "{m} 个已退还物品里程碑已达成！正在前往 {next}。",
"hc.missingFeatures": "缺失的功能",
"hc.monthly": "每月",
"hc.monthlyBilling": "每月账单",
"hc.moveThePhotoToFit": "移动照片以适应圆圈。",
"hc.myAccount": "我的账户",
"hc.myInvoices": "我的发票",
"hc.myMonthlyInvoices": "我的每月发票",
"hc.nArchived": "{n} 条列表已归档。",
"hc.newCodeGeneratedAndSent": "新代码已生成，并通过电子邮件和短信发送给客户",
"hc.newCodeGeneratedAndSent2": "新代码已生成，并发送给业主",
"hc.newPassword": "新密码",
"hc.next": "下一个",
"hc.nextPhoto": "下一张照片",
"hc.no": "没有",
"hc.noAnswerProvided": "未提供答案。",
"hc.noArchivedDeclarations": "没有归档声明",
"hc.noCountryFound": "未找到国家",
"hc.noDeclarations": "没有声明",
"hc.noFeesAreChargedTo": "客户无需支付费用。",
"hc.noInvoiceYet": "尚无发票。",
"hc.noInvoiceYetYourInvoices": "尚无发票。您的发票将在每次付款后自动显示在此处。",
"hc.noMatchIsAvailableFor": "目前没有匹配项。我们会在有项目与您的声明匹配时尽快通知您。",
"hc.noShipmentMatchesYourSearch": "没有与您的搜索匹配的货物。",
"hc.noShipmentsYet": "尚无货物。",
"hc.noShipmentsYet2": "尚无货物",
"hc.none": "无",
"hc.noneChooseForEachShipment": "无（为每个货物选择）",
"hc.notMine": "这不是我的",
"hc.of": "的",
"hc.only": "仅",
"hc.onlyEachSiteManagesIts": "仅。每个站点管理自己的银行：这些链接不影响其他任何机构。",
"hc.onlyTheOwnerOrAn": "只有业主或管理员才能配置该机构的支付链接。",
"hc.openDepositInTheMenu": "在菜单中打开“存款”，描述项目并拍照。它会立即存储并准备返回。",
"hc.openSettings": "打开设置 →",
"hc.openTheDeclarationToManage": "打开声明以管理货物",
"hc.optional": "— 可选",
"hc.optional2": "（可选）",
"hc.optional3": "可选",
"hc.originalListingPhotoUsed": "使用了原始列表照片",
"hc.other": "其他",
"hc.other2": "其他…",
"hc.ourProducts": "我们的产品",
"hc.overallRateTrendLast6": "总体利率趋势（过去6个月）",
"hc.ownerSClaimCode": "业主索赔代码",
"hc.ownershipConfirmed": "所有权已确认",
"hc.paid": "已付款",
"hc.paidOn": "支付日期",
"hc.paidViaPartner": "已付款 (通过合作伙伴)",
"hc.parcelBeingPrepared": "包裹正在准备中",
"hc.parcelDelivered": "包裹已送达",
"hc.parcelShipped": "包裹已发货",
"hc.parisGareDeLyon": "巴黎, 里昂车站…",
"hc.partner": "合作伙伴",
"hc.partner2": "合作伙伴",
"hc.partnerDirectory": "合作伙伴目录",
"hc.passedOnToTheCustomer": "— 已将支付链接转发给客户。",
"hc.password": "密码",
"hc.passwordResetPleaseLogIn": "密码已重置，请登录。",
"hc.passwordUpdated": "密码已更新。",
"hc.passwordsDoNotMatch": "密码不一致。",
"hc.pasteThisSenderIdIn": "将此发件人 ID 粘贴到 Findloop → 设置中",
"hc.payForTheShipmentOf": "通过 Findloop 安全支付您的物品运费。",
"hc.payTheRecoveryFees": "支付恢复费用",
"hc.payTheShippingFees": "支付运费",
"hc.payment": "付款",
"hc.paymentAlreadyConfirmedByThe": "付款已由合作伙伴确认",
"hc.paymentLinksAreNowConfigured": "支付链接现已根据每个单位配置",
"hc.paymentNotCompletedYourAccount": "付款未完成，您的帐户未创建 — 请重试。",
"hc.paymentReceived": "已收到付款",
"hc.paymentSuccessful": "付款成功！",
"hc.pdfInvoice": "PDF 发票",
"hc.pending": "待处理",
"hc.period": "期间",
"hc.phoneNumber": "电话号码",
"hc.phoneOptional": "电话（可选）",
"hc.planAt": "计划在",
"hc.planLimitFmt": "您的 \"{plan}\" 计划限制为 {max} 个单位。要管理 {n} 个站点，我们推荐",
"hc.platformReturnTarget": "平台退货目标",
"hc.pleaseCompleteYourShippingAddress": "请填写您的收货地址。",
"hc.pleaseProvideAPhoneNumber": "请提供电话号码：这是承运商发货所需的。",
"hc.pleaseProvideAReason": "请提供原因。",
"hc.pleaseSetYourOwnPassword": "请在继续之前设置自己的密码。",
"hc.pointsToGoal": "距离我们的共同目标还有 {n} 个积分。",
"hc.posterPreview": "海报预览",
"hc.potentialMatchBeingVerified": "潜在匹配正在验证",
"hc.potentialOwner": "潜在所有者",
"hc.preFilledAutomaticallyYouCan": "自动预填 — 您可以用包裹的照片替换它。",
"hc.pressKit": "新闻资料",
"hc.previewMode": "预览模式:",
"hc.previewOfThePrintReady": "此机构的A4海报打印预览。",
"hc.previous": "上一页",
"hc.previousPhoto": "上一张照片",
"hc.primary": "主要",
"hc.printThePoster": "打印海报",
"hc.privacy": "隐私",
"hc.privacyPolicy": "隐私政策",
"hc.processedCasesWillAppearHere": "处理的案例将出现在这里。",
"hc.proofOfReturnPdf": "退货证明（PDF）",
"hc.protectedByRecaptcha": "受reCAPTCHA保护",
"hc.publicMatch": "公开匹配",
"hc.putBackInStorage": "放回存储",
"hc.pwdResetByTeam": "您的密码已通过我们团队重置。为了您的安全，",
"hc.questionsToAskTheOwner": "询问所有者的问题",
"hc.rateChargedToTheCustomer": "向客户收取的费用:",
"hc.rateOfTarget": "{rate}% 已达到 {target}% 的目标",
"hc.reached": "已达到",
"hc.reactivating": "正在重新激活…",
"hc.reasonSavedYouCanStill": "原因已保存。您仍然可以索回您的物品。",
"hc.recentMatchesFirst": "最近的匹配优先",
"hc.recognizedThePhotoYouSent": "识别了您发送的照片并描述了这些特征。仅在与您持有的物品匹配时确认。",
"hc.recommended": "推荐",
"hc.recoveryFees": "恢复费用",
"hc.recoveryFeesArePaidDirectly": "恢复费用直接支付给合作机构。Findloop 不从客户收取费用。",
"hc.recoveryFeesEnabled": "恢复费用已启用",
"hc.recoveryOfferedByTheEstablishment": "由机构提供的恢复服务 - Findloop 不收取费用。",
"hc.recoveryPaymentLink": "恢复支付链接",
"hc.recoveryPaymentLinkSavedFor": "已为此机构保存恢复支付链接",
"hc.redirecting": "正在重定向…",
"hc.redirectingToPayment": "正在重定向到支付…",
"hc.redirectingToTheRecoveryOf": "正在重定向到您的物品恢复…",
"hc.regenerateAndResendToThe": "重新生成并重新发送给所有者",
"hc.regenerateTheCode": "重新生成代码",
"hc.registerAFoundItem": "注册找到的物品",
"hc.rejectTheClaim": "拒绝索赔",
"hc.reminderDelaySaved": "提醒延迟已保存",
"hc.reopenThePaymentLink": "重新打开支付链接",
"hc.repeatThePassword": "重复密码",
"hc.reportAProblem": "报告问题",
"hc.reportDismissedYourListingRemains": "报告被驳回。您的列表仍然公开。",
"hc.requiredUsedToCalculateThe": "必填：用于计算 Sendcloud 运费。超过 30 公斤无法发货。",
"hc.reset": "重置",
"hc.resume": "继续",
"hc.resumeRegistration": "继续注册",
"hc.retro": "年度回顾",
"hc.returnSecurity": "返回安全",
"hc.returnToTheOwner": "归还给所有者",
"hc.returned": "已归还",
"hc.reviewTheItemDetails": "查看物品详情",
"hc.revokeAccess": "撤销访问",
"hc.role": "角色:",
"hc.save": "保存",
"hc.save2": "保存",
"hc.saveAndContinue": "保存并继续",
"hc.saving": "正在保存…",
"hc.scanTheClaimCode": "扫描索赔代码",
"hc.scanTheOwnerSQr": "扫描所有者的二维码",
"hc.scrollThroughLanguages": "浏览语言",
"hc.searchByCustomerItemOr": "按客户、物品或追踪号搜索…",
"hc.searchForACountry": "搜索国家…",
"hc.secureFindoVerification": "安全的 Findloop 验证",
"hc.seeRetro": "查看年度回顾",
"hc.selectedCarrier": "选择的承运商:",
"hc.selectedPlan": "选择的计划",
"hc.send": "发送",
"hc.sendcloudSenderIdSaved": "Sendcloud 发件人 ID 已保存",
"hc.sendcloudSenderIdSenderId": "Sendcloud 发件人 ID (sender_id)",
"hc.sending": "正在发送…",
"hc.sessionExpired": "会话已过期",
"hc.setUpYourEstablishments": "设置您的机构",
"hc.settings": "设置",
"hc.settingsSubtitle": "按机构配置的外部支付和提醒。",
"hc.shareFoundText": "我找到了一个物品——请帮助我在 Findloop 上找到它的主人",
"hc.shareLostText": "我丢失了一个物品——请帮助我在 Findloop 上找到它",
"hc.sharePreview": "分享预览",
"hc.shareTheRanking": "分享排名",
"hc.shareYourQrCodeTo": "分享您的二维码以接收声明。",
"hc.shipRateAutoWeight": "运费通过 Sendcloud 自动计算（重量 {w}），在发货时。",
"hc.shipRateForWeight": "运费（Sendcloud + {m}% 利润）适用于 {w}：",
"hc.shipments": "发货",
"hc.shipmentsSubtitle": "所有商家发货的汇总视图，包括所有案例。点击一行以管理声明中的发货。",
"hc.shipping": "运送",
"hc.shippingAddress": "送货地址",
"hc.shippingFeesAreHandledAutomatically": "运费由 Findloop (Sendcloud) 自动处理 — 无需输入链接。",
"hc.shippingFeesHaveAlreadyBeen": "运费已支付：承运人无法更改。",
"hc.shippingNotAvailableForItems": "超过 30 公斤的物品无法发货。客户需亲自取件。",
"hc.shippingPaid": "运费已支付 ✓",
"hc.showOnlyItemsMatchingA": "仅显示与公开（客户）列表匹配的物品",
"hc.showPassword": "显示密码",
"hc.signInTheBoxAbove": "在上面的框中登陆",
"hc.signatureSaved": "签名已保存",
"hc.signedInWithGoogle": "使用 Google 登录",
"hc.signupFailed": "注册失败",
"hc.silver": "银牌",
"hc.simulatedRatesInPreProduction": "(预生产中的模拟费率)",
"hc.siretAndVatNumberRequired": "需要 SIRET 和增值税号码（法国）。",
"hc.skip": "跳过",
"hc.smsSentIfAccount": "如果此号码有账户，已向您发送 SMS。",
"hc.sortItemsWithAPublic": "排序：按公共匹配的物品（最新）优先",
"hc.specifyWhetherYouRecoveredYour": "请说明您是否已找回物品或仅想删除此列表。",
"hc.specifyYourReason": "请说明您的理由",
"hc.specifyYourReason2": "请说明您的理由…",
"hc.staff": "员工",
"hc.status": "状态",
"hc.staySignedIn": "保持登录状态",
"hc.step": "步骤",
"hc.stillThere": "还在吗？",
"hc.stopScrolling": "停止滚动",
"hc.storeFindWithQr": "使用二维码存储和查找",
"hc.streetName": "街道名称",
"hc.streetNo": "街道号码",
"hc.switchTo": "切换到",
"hc.switchToDarkMode": "切换到暗黑模式",
"hc.switchToLightMode": "切换到亮色模式",
"hc.takeAPhoto": "拍照",
"hc.takeChangeThePhoto": "拍摄/更改照片",
"hc.takenFromYourDeclaration": "来自您的声明",
"hc.target": "目标",
"hc.targetReached": "目标已达成",
"hc.targetReachedThankYouTo": "目标已达成 — 感谢整个 Findloop 社区！",
"hc.tellUsMore": "告诉我们更多…",
"hc.tellUsWhyYouCancel": "告诉我们您取消的原因。这有助于合作伙伴处理您的请求。",
"hc.tellUsWhyYourListing": "告诉我们原因。您的列表保持活动，您仍然可以认领您的物品。",
"hc.termsAndConditions": "条款和条件",
"hc.termsAndPolicies": "条款和政策",
"hc.thankYouForYourFeedback": "感谢您的反馈",
"hc.theBannerDisplayedInThe": "在注册中显示的横幅。",
"hc.theClaimantHasBeenInformed": "索赔人已被通知。该物品仍在公共列表中。",
"hc.theClaimantHasBeenNotified": "索赔人已被通知，现在可以继续进行退货。",
"hc.theCustomerPaysTheFees": "客户支付商家的费用。",
"hc.theDayTheLegalRetention": "法律保留期限达到的日期。",
"hc.theEstablishmentConsideredThatThis": "该商家认为该物品不是您的。",
"hc.theEstablishmentIsReviewingYour": "商家正在审核您的回答。您的索赔验证后会通知您，然后您可以支付取回费用。",
"hc.theFeesAreTooHigh": "费用太高",
"hc.theFinderConsideredThatThis": "寻找者认为该物品不是您的。",
"hc.theFinderIsReviewingYour": "寻找者正在审核您的索赔。验证后会通知您。",
"hc.theItem": "该物品",
"hc.theItemWillBeRemoved": "该物品将从注册中移除（没有正在进行的索赔）。",
"hc.theItemWillBeSet": "该物品将被恢复为“有货”，相关索赔将被取消。",
"hc.theKbisNumberAndVat": "在法国，需要提供 Kbis 号码和增值税号码。",
"hc.theLabelIsGeneratedAutomatically": "标签将在客户支付运费后自动生成。可以在这里下载。",
"hc.theLinkMayHaveExpired": "链接可能已过期（有效期为 30 天）。如有需要，请联系 Findloop 支持。",
"hc.theOwnerDescribesTheirItem": "所有者描述他们的物品",
"hc.theOwnerReceivedItBy": "所有者通过电子邮件（或短信）收到该物品。在交接前输入或扫描它。",
"hc.thePartnerConsideredThatThis": "合作伙伴认为该物品不是您的。该物品仍然可用。",
"hc.thePartnerIsReviewingYour": "合作伙伴正在审核您的回答。您的索赔验证后会通知您。",
"hc.theShipmentIsCreatedAutomatically": "一旦客户确认地址并支付取回费用，货件将自动创建。然后将自动生成标签，并可以在此下载。",
"hc.theShippingRateWillBe": "运费将在运输时通过 Sendcloud 自动计算（记录的重量）。",
"hc.thisCarrierWillBe": "此承运人将是",
"hc.thisEstablishment": "该商家",
"hc.thisFieldIsRequiredFor": "此字段是自动生成标签所需的。",
"hc.thisIsMyItem": "这是我的物品",
"hc.thisIsMyItemContinue": "这是我的物品 — 继续",
"hc.thisIsMyItemStart": "这是我的物品 — 开始退货",
"hc.thisIsNotMyItem": "这不是我的物品",
"hc.thisMatchIsNoLonger": "此匹配不再可用或已处理。",
"hc.thisRateWillBeCharged": "此费率将向客户收取。高费率可能会阻碍取回。",
"hc.thisStepIsRequiredFor": "此步骤是生成运输标签所需的",
"hc.thisValidationLinkIsInvalid": "此验证链接无效或已过期。",
"hc.toCheckBeforeMarkingThe": "在标记物品为已退货之前进行检查。",
"hc.toConfigureTheLinksAnd": "为每个机构配置链接和提醒延迟。",
"hc.toReachOurFirstMilestone": "达到我们的第一个里程碑：100个退货。",
"hc.toTheCustomer": "给客户。",
"hc.toTheShippingFeePayment": "前往运费支付。",
"hc.toYourRecoveryTracking": "前往您的找回跟踪。",
"hc.tooExpensiveBudget": "太贵 / 预算",
"hc.topCitiesForReturns": "退货的热门城市",
"hc.trackMyRecovery": "跟踪我的找回",
"hc.trackTheShipmentAndDownload": "跟踪货物并下载标签（自动生成），无需离开申报标签。",
"hc.trackYourStatistics": "跟踪您的统计信息",
"hc.tracking": "跟踪",
"hc.unableToOpenTheShipping": "无法打开运费支付。请重试。",
"hc.unableToRetrieveTheInvoice": "无法检索发票。",
"hc.unclaimed": "未领取",
"hc.unclaimedCustomerReason": "未领取物品。客户原因：\"{reason}\"。",
"hc.unclaimedItem": "未领取物品",
"hc.unclaimedItemNoClaimWithin": "未领取物品 - 在截止日期内没有索赔。",
"hc.unclaimedItems": "未领取物品",
"hc.unclaimedItemsMatchLeftWithout": "未领取物品：匹配未在截止日期内索赔。您可以将其放回存储。",
"hc.unlockTheFinderSContact": "解锁发现者的联系信息以安排交接。",
"hc.upcoming": "即将到来",
"hc.updateFailed": "更新失败。",
"hc.usedForInvoices": "用于开具您的findloop发票。",
"hc.vatNumber": "增值税号",
"hc.verificationPending": "验证待处理",
"hc.verificationSentToTheFinder": "验证已发送给发现者。您会收到他们决定的通知。",
"hc.verificationSentToThePartner": "验证已发送给合作伙伴。您会收到他们决定的通知。",
"hc.verify": "验证",
"hc.verifyingInvite": "正在验证邀请链接…",
"hc.verifyingTheLink": "正在验证链接…",
"hc.viewInRegistry": "在记录中查看",
"hc.viewItem": "查看物品",
"hc.viewItemRecover": "查看物品及找回",
"hc.visibleToTheOwnerAutomatically": "对所有者可见 · 60天后自动删除。",
"hc.waitingForPartnerConfirmation": "等待合作伙伴确认",
"hc.waitingForThePartnerS": "等待合作伙伴的确认",
"hc.weHaveInformedTheEstablishment": "我们已通知该机构该物品不是您的，并重新启动分析。我们会在找到新匹配时通知您。",
"hc.weHaveInformedThePartner": "我们已通知合作伙伴该物品不是您的。您的列表将保持活跃以便未来匹配。",
"hc.weRanTheAnalysisAgain": "我们再次进行了分析，并确定了可能属于您的另一个物品。请再次检查。",
"hc.weight": "重量",
"hc.weightNotProvidedTheShipping": "未提供重量：运费将在发货时计算。",
"hc.weightUnit": "重量单位",
"hc.welcome": "欢迎！",
"hc.welcomeToFindo": "欢迎来到findloop",
"hc.whenACustomerComesTo": "当客户前来提取他们的物品时，打开他们的声明并验证退货。就这样！",
"hc.whenDisabledFeesDropTo": "。禁用时，费用降至",
"hc.whyIsThisNotYour": "这为什么不是您的物品？",
"hc.willBeMarkedAs": "将标记为",
"hc.wrongColor": "错误的颜色",
"hc.wrongModel": "错误的型号",
"hc.yesCancel": "是的，取消",
"hc.yesContactTheFinder": "是的，联系寻物者",
"hc.youAreHere": "您在这里",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "您现在可以开始退货。",
"hc.youCanStillChangeIt": "。您仍然可以根据情况进行更改。",
"hc.youHaveAlreadyConfirmedThat": "您已经确认这是您的物品。",
"hc.youWillBeRedirectedTo": "您将被重定向到安全的Stripe支付。",
"hc.yourAccountHasBeenReactivated": "您的账户已被重新激活。",
"hc.yourAccountIsActiveYou": "您的账户是活跃的，您现在可以管理您的机构。",
"hc.yourEstablishment": "您的机构",
"hc.yourFeedbackHelpsUsImprove": "您的反馈帮助我们改善匹配。",
"hc.yourFeedbackHelpsUsRestart": "您的反馈帮助我们重新启动分析并改善匹配。",
"hc.yourFirstSteps": "您的第一步",
"hc.yourFirstStepsAdmin": "您的第一步（管理员）",
"hc.yourItemHasBeenHanded": "您的物品已由合作伙伴亲自交接 - 一旦交接确认后请关闭案件。",
"hc.yourItemHasBeenShipped": "您的物品已由合作伙伴发货 - 一旦确认送达请关闭案件。",
"hc.yourPaymentHasBeenRecorded": "您的付款已被记录。",
"hc.yourShipmentIsBeingPrepared": "您的货物正在准备中。您将在 3 到 5 个工作日内收到包裹。",
"hc.yourShippingFeesHaveAlready": "您的运费已支付。运费已支付✓",
"hc.yourShippingFeesHaveBeen": "您的运费已支付。您的包裹正在准备中。",
"hc.yourVerificationQuestionsDeposit": "您的验证问题（扣款）",
"hero.einvoiceBadge": "符合2027年电子发票标准",
"home.recentAdsAll": "查看所有列表",
"home.recentAdsEyebrow": "现在",
"home.recentAdsSubtitle": "社区报告的遗失和发现物品。",
"home.recentAdsTitle": "最新列表",
"home.reunions": "最近的重聚",
"home.videoEyebrow": "观看",
"home.videoTitle": "在 2 分钟内发现 Findloop",
"home.watchYoutube": "在 YouTube 上观看",
"impact.already": "已经",
"impact.citiesWord": "城市/城市",
"impact.eachPoint": "每个点代表一个 Findloop 帮助找回失物的城市。",
"impact.emptyMap": "随着物品归还，地图逐渐填满。",
"impact.eyebrow": "我们的影响",
"impact.inCities": "遍及",
"impact.restitutedTo": "返回给它们主人的物品",
"impact.title": "物品被归还，您身边的每个地方",
"inv2.download": "下载",
"inv2.view": "查看",
"map.objectsOnMapPlural": "地图上的物品",
"map.objectsOnMapSingular": "地图上的物品",
"mc.claimConfirmDesc": "在支付以解锁联系信息之前，检查找到物品的寻找者。",
"mc.claimConfirmNo": "这不是我的物品",
"mc.claimConfirmTitle": "这真的是您的物品吗？",
"mc.claimConfirmYes": "是的，这是我的 — 支付",
"mc.claimFinderContacts": "寻找者的联系信息",
"mc.claimNotMineDone": "谢谢 — 寻找者已经被通知，您的请求已从广告中删除。",
"mc.claimUnlockDesc": "支付 Findloop 管理费以获取找到您物品的人的联系方式。",
"mc.claimUnlockTitle": "解锁寻找者的联系信息",
"mc.hideCountryOffers": "隐藏我所在国家的优惠",
"mc.myClaims": "我正在申领的物品",
"mc.myClaimsSub": "您正在申领的他人找到的物品。解锁寻找者的联系信息以安排交接。",
"mc.notifAdCancelled": "广告已取消",
"mc.notifCancelAd": "取消我的广告",
"mc.offersInCountry": "我所在国家的优惠",
"mc.offersInCountryDesc": "您所在国家按城市列出的所有活跃奖励。",
"mc.redArchived": "已归档",
"mc.rewardsCountryNone": "您所在国家尚无优惠。",
"mc.rewardsForYou": "为您提供的奖励",
"mc.rewardsForYouDesc": "由您投放物品的合作伙伴提供。",
"mc.rewardsMineNone": "您投放的合作伙伴尚未提供奖励。",
"mc.showCountryOffers": "查看我所在国家的优惠",
"mc2.cancelDecl": "取消我的声明",
"mc2.cancelDeclDone": "声明已取消。",
"pricing.physInvDesc": "当物品被归还时，其位置会自动释放，并可用于新物品。",
"pricing.physInvTitle": "实物库存追踪",
"pricing.physModalTitle": "实物物品管理",
"pricing.physQrDesc": "每个物品生成一个独特的二维码，链接到其所有信息。",
"pricing.physQrTitle": "专用二维码标签",
"pricing.physShelfDesc": "每个注册物品可以在商家内分配一个实物位置。",
"pricing.physShelfTitle": "货架规划",
"pricing.physicalMgmt": "实物物品管理（货架、二维码、库存）",
"pub.addSecondPhoto": "添加第二张照片（可选）",
"pub.photo2Added": "✓ 第二张照片已添加",
"reg.dispositionJournal": "处置日志",
"reg.dispositionNoteAuthHint": "ℹ️ “交给当局”需要备注（报告号码、部门等…）。",
"reg.dispositionNotePh": "备注（可选）：收件慈善机构、当局参考、买家姓名…",
"reg.dispositionNoteRequired": "交给当局需要官方参考。",
"reg.legalPrealert": "法律截止日期在{days}天内",
"reg.legalPrealertOptions": "截止日期选项：拍卖、捐赠给慈善机构、交给当局。",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "完整评审",
"rev.readMore": "阅读更多",
"rw.activeCodes": "有效优惠券",
"rw.archived": "已归档",
"rw.archivedTitle": "已兑换优惠券（已归档）",
"rw.hideArchived": "隐藏已兑换优惠券",
"rw.noArchived": "没有归档的优惠券。",
"rw.showArchived": "显示已兑换优惠券",
"shp.labelAuto": "标签将在客户支付运费后自动生成。您可以在这里下载。",
"st.cancelled_by_customer": "已取消",
"stt.dispoPdfBtn": "导出PDF",
"stt.dispoPdfError": "PDF导出失败。",
"stt.dispoPdfExporting": "正在导出…",
"trk.matchVerifying": "潜在匹配正在验证中",
"hc.and": "和",
"hc.demoObj0": "钱包",
"hc.demoObj1": "运动包",
"hc.demoObj2": "手机",
"hc.demoObj3": "一副眼镜",
"hc.demoObj4": "一串钥匙",
"hc.demoObj5": "围巾",
"hc.demoObj6": "笔记本电脑",
"hc.demoObj7": "水瓶",
"hc.demoWhen0": "2小时前",
"hc.demoWhen1": "5小时前",
"hc.demoWhen2": "昨天",
"hc.demoWhen3": "3小时前",
"hc.demoWhen4": "今天早上",
"hc.demoWhen5": "1天前",
"hc.feedDemo": "{obj} 在 {city} {when} 被退回。",
"hc.feedReal": "一件物品 ({cat}) 在 {city} 被退回。",
"hc.saveBtn": "保存",
"hc.saveLink": "保存链接",
"hc.terms": "条款",
"hc.view": "查看",
"pcat.airline": "航空公司",
"pcat.airport": "机场",
"pcat.amusement_park": "游乐园",
"pcat.bank": "银行",
"pcat.bar_cafe": "酒吧 / 咖啡馆",
"pcat.beauty_salon": "美发 / 美容院",
"pcat.cinema": "电影院",
"pcat.concert_theater": "音乐厅 / 剧院",
"pcat.coworking": "共享办公空间",
"pcat.gym_fitness": "健身房 / 健身",
"pcat.hospital_clinic": "医院 / 诊所",
"pcat.library": "图书馆",
"pcat.mall": "购物中心",
"pcat.museum": "博物馆",
"pcat.pharmacy": "药店",
"pcat.private_company": "私营企业",
"pcat.public_transport": "公共交通",
"pcat.school_university": "学校 / 大学",
"pcat.sports_center": "体育中心",
"pcat.stadium_arena": "体育场 / 竞技场",
"pcat.supermarket": "超市",
"pcat.taxi_vtc": "出租车 / 叫车服务",
"pcat.tourism_office": "旅游办公室",
"pcat.train_bus_station": "火车 / 汽车站",
"pcat.travel_agency": "旅行社",
"an.found": "找到",
"an.lost": "丢失",
"hc.shareReview": "分享评价",
"home.videoSubtitle": "我们如何轻松地将失物与它们的主人团聚。",
"hc.citiesAboveTarget": "{n} 个城市超过目标",
"hc.cityAboveTarget": "{n} 个城市超过目标",
"hc.j15EarlyReminder": "D-15 提前提醒",
"hc.j7EarlyReminder": "D-7 提前提醒",
"hc.annualTotal": "年度总计",
"hc.billedOnceYear": "一次收费12个月，每年续订。",
"hc.monthlyPrice": "月度价格",
"hc.perMonth": "/ 月",
"hc.perYear": "/ 年",
"hc.billedEachMonth": "每月自动扣费。",
"nav.business": "商业",
"nav.individual": "个人",
"hc.circumstancesFound": "发现情况",
"hc.circumstancesFoundPh": "例如：在地铁入口附近的地面上发现",
"hc.circumstancesLost": "丢失情况",
"hc.circumstancesLostPh": "例如：在等公交时把它留在长椅上",
"hc.conditionPh": "例如：好，划伤…",
"hc.firstName": "名字",
"hc.lastName": "姓氏",
"hc.quantity": "物品数量",
"fa.approve": "批准",
"fa.approveConfirm": "您确定要批准此声明吗？您的完整联系信息（姓名、电子邮件、电话）将与寻物者交换。",
"fa.approved": "声明已批准 — 联系信息已交换",
"fa.approvedFinder": "所有者已批准您的声明",
"fa.approvedFinderText": "联系他们安排归还。",
"fa.boostSub": "您的列表将在选择的时间内保持在顶部。",
"fa.boostTitle": "提升我的列表（可选）",
"fa.colFinder": "寻物者的声明",
"fa.colYours": "您的声明",
"fa.compareHint": "在决定之前，将寻物者的声明与您的进行比较。",
"fa.contribNone": "无贡献",
"fa.contribPaid": "已收到贡献 - 谢谢！",
"fa.contribPending": "贡献等待付款",
"fa.contribSub": "支持findloop，帮助更多人找回他们的物品。您可以选择 €0。",
"fa.contribSuccessMsg": "您的声明已发送给所有者。",
"fa.contribSuccessTitle": "感谢您的贡献",
"fa.contribTitle": "自愿贡献",
"fa.days3": "3天",
"fa.days30": "30天",
"fa.days7": "7天",
"fa.declSub": "描述您找到的物品。所有者将比较您的声明与他们的声明。",
"fa.declTitle": "我找到了这个物品",
"fa.expiresOn": "到期日",
"fa.fBrand": "品牌",
"fa.fCircumstances": "情况",
"fa.fCity": "城市",
"fa.fColor": "颜色",
"fa.fCondition": "状态",
"fa.fDate": "日期",
"fa.fMessage": "寻物者的留言",
"fa.fPlace": "地点",
"fa.fQuantity": "数量",
"fa.finderContact": "寻物者的联系信息",
"fa.finishPay": "完成付款",
"fa.foundDate": "找到的日期",
"fa.foundPlace": "找到的地点",
"fa.hours24": "24小时",
"fa.ht": "不含增值税",
"fa.months3": "3个月",
"fa.noBoost": "无提升",
"fa.ownerContact": "所有者的联系方式",
"fa.payPublish": "支付并发布",
"fa.pendingPayText": "您的列表将在付款确认后立即上线。",
"fa.pendingPayTitle": "付款待处理",
"fa.planSub": "您的列表将在付款确认后立即上线。",
"fa.planTitle": "列表持续时间",
"fa.pubSuccessMsg": "您的列表已上线。找到人后会立即通知您。",
"fa.pubSuccessTitle": "列表已发布",
"fa.publicNote": "仅公开显示描述、城市、国家和照片。",
"fa.redirectStripe": "正在重定向到安全支付…",
"fa.reject": "拒绝",
"fa.rejectConfirm": "拒绝此声明？您的列表将保留在线。",
"fa.rejected": "声明已被拒绝",
"fa.rejectedFinder": "这不是他们要寻找的物品",
"fa.rejectedFinderText": "所有者表示这个物品不是他们的。感谢您的帮助！",
"fa.responsesTitle": "寻找者声明",
"fa.sent": "声明已发送给所有者。",
"fa.submitDecl": "发送我的声明",
"fa.submitDeclPay": "发送并贡献 {amount}",
"fa.total": "总计需支付",
"fa.ttc": "含增值税",
"fa.waitClaimText": "寻找者正在审核您的请求。您将收到他们的决定通知。",
"fa.waitFinderText": "一旦找到人提交声明，我们会及时通知您。",
"fa.waitFinderTitle": "您的列表已上线",
"fa.waitOwnerText": "所有者正在将您的声明与他们的进行比较。您将收到他们的决定通知。",
"fa.waitOwnerTitle": "等待所有者的决定",
"st.pending_payment": "付款待处理",
"fa.africaFree": "非洲免费发布 — Findloop 开幕优惠，尽情享受！",
"fa.africaPublished": "免费发布列表 — 非洲开幕优惠！",
"fa.approveClaimConfirm": "确认批准此索赔吗？拥有者将能够解锁您的联系信息。",
"fa.checkInfo": "在发送前检查您的详细信息：它们将与找人的信息进行比较。",
"fa.claimApprovedShort": "找人已批准您的索赔",
"fa.claimRejectedShort": "索赔被找人拒绝",
"fa.claimRejectedText": "找人认为此物品不是您的。",
"fa.claimSub": "描述您的物品并添加 2 张照片。找人将与他们的列表进行比较。",
"fa.claimTitle": "这是我的物品",
"fa.claimUnlockText": "解锁找人的联系信息以安排物品归还。",
"fa.claimUnlockedShort": "联系信息已解锁 — 查看追踪",
"fa.claimsTitle": "所有者索赔",
"fa.colOwner": "所有者声明",
"fa.colYourAd": "您的列表",
"fa.expired": "列表已过期",
"fa.free": "免费",
"fa.lostDate": "丢失日期",
"fa.lostPlace": "丢失地点",
"fa.noReceipt": "此列表没有可用收据。",
"fa.planSubFree": "选择持续时间：您的列表立即上线，无需付款。",
"fa.prefillPrevious": "重复使用我在此类别中之前列表的详细信息",
"fa.receipt": "PDF 收据",
"fa.renewBtn": "续订",
"fa.renewDiscountBanner": "50% 折扣：在您的列表到期前续订！",
"fa.renewDiscountHint": "因为您在到期前续订，所以应用了 50% 折扣。",
"fa.renewEarly": "续订 (−50%)",
"fa.renewTitle": "续订我的列表",
"fa.renewed": "列表已续订",
"fa.sendClaim": "发送我的索赔",
"fa.twoPhotos": "您物品的 2 张照片",
"fa.twoPhotosError": "添加 2 张您物品的照片。",
"fa.twoPhotosHint": "证明物品属于您的个人照片（与物品、发票、盒子…一起）。",
"fa.unlockBtn": "解锁联系信息",
"fa.unlockFree": "免费解锁 — 开幕优惠",
"fa.waitClaimantText": "一旦有所有者索赔此物品，我们会立即通知您。",
"fa.waitFinderDecision": "等待找人的决定",
"fa.waitUnlockText": "一旦交换联系信息，您将收到通知。",
"fa.waitUnlockTitle": "等待所有者解锁",
"fa.cancel": "取消",
"fa.categoryRequired": "为找到的物品选择一个类别。",
"fa.confirmTitle": "确认您的决定",
"fa.goBack": "返回",
"dr.continue": "继续我的声明",
"dr.delete": "永久删除",
"dr.deleteConfirm": "永久删除这个草稿？此操作无法撤销。",
"dr.deleted": "草稿已删除",
"dr.expiresIn": "草稿将再保留 {h} 小时",
"dr.title": "您有未完成的声明",
"form.step": "步骤",
"form.next": "继续",
"form.back": "返回",
"form.stepDetails": "您的报告",
"form.stepPublish": "持续时间、提升与付款",
"form.stepThanks": "感谢与贡献",
"fthx.badge": "报告即将完成",
"fthx.title": "谢谢您，您正在创造改变！",
"fthx.text": "感谢您，可能很快就会有人重新找回对他们重要的东西。像您这样的善举正是Findloop继续前行的动力。",
"fthx.impact1": "报告了 1 项物品",
"fthx.impact2": "多了一次重聚的机会",
"fthx.tipTitle": "给 Findloop 一点小帮助吗？",
"fthx.tipText": "您的支持帮助我们保持服务的可达性，让更多物品与他们的主人团聚。",
"fthx.optional": "100% 自愿 — 您可以在不贡献的情况下发布。",
"fthx.thanksTip": "非常感谢您的慷慨！",
"fthx.suggest": "建议金额",
"fthx.none": "没有小费",
"pay.pendingTitle": "付款未完成",
"pay.pendingText": "您的信息已保存。请在您离开的地方继续付款。",
"pay.resume": "继续付款",
"pay.expiredTitle": "付款会话已过期",
"pay.expiredText": "为了您的安全，付款会话已过期。您的信息已保存：一键重启付款。",
"pay.relaunch": "重启付款",
"sub.received": "已发送！",
"sub.publishing": "我们正在完成…",
"sub.toPayment": "正在重定向到安全付款…",
"fa.claimSubV2": "描述一下您丢失的物品。找到它的人将会对比您的声明和他们的列表。",
"fa.photosOptional": "您物品的照片（可选）",
"fa.compareOwnerHint": "将此信息与您找到的物品进行比较，然后说明是否为同一物品。",
"fa.itsThisItem": "是的，这就是该物品",
"fa.notThisItem": "不，这不是该物品",
"fa.confirmIsItem": "确认这是该物品吗？您的联系方式和物主的联系方式将在各自账户中显示。",
"fa.confirmNotItem": "确认这不是该物品吗？您的报告将被关闭。",
"fa.youConfirmed": "您确认这是物主的物品",
"fa.youDeclined": "您表示这不是该物品",
"fa.youDeclinedText": "感谢您的帮助！物主已被通知。",
"fa.waitFinderDecisionOwner": "等待找到者的决定",
"fa.finderConfirmed": "已确认",
"fa.notYourItem": "这不是您的物品",
"fa.reportedOn": "报告于",
"fa.ownerWaitHint": "找到者正在检查信息，请稍等。",
"fa.claimSentFinder": "索赔已发送给找到该物品的人。",
"fa.compareClaimHint": "在决定之前，请将所有者的声明与您的列表进行比较。",
"fa.closeFollowup": "关闭此跟进",
"fa.closeFollowupConfirm": "确定关闭此跟进吗？一旦所有者也关闭了他们的列表，双方的电子邮件和电话号码将被永久删除。",
"fa.safetyTitle": "交接前的安全提示",
"fa.safety1": "询问所有者有关物品隐藏功能的详细描述：具体的划痕、包的确切内容、墙纸、序列号…",
"fa.safety2": "如果可能，请求视觉证明（物品照片）或购买证明。",
"fa.safety3": "在公共场所或Findloop合作伙伴处交接物品，并检查所有者的身份证。",
"fa.safetyOk": "明白了，继续",
"fa.ownerClosedNote": "所有者已关闭他们的列表。",
"fa.finderClosedNote": "寻找者已关闭他们的跟进。",
"fa.followupClosed": "跟进已关闭",
"fa.followupClosedText": "您已关闭此跟进。感谢您的帮助！",
"fa.photoReviewTitle": "一位寻找者发送了一张照片。看起来像你的物品吗？",
"fa.photoLooksLike": "是的，它看起来像我的物品",
"fa.photoNotMine": "不，这不是我的物品",
"fa.photoNotMineConfirm": "后续将双方关闭，你的列表将保持开放以供新寻找者使用。",
"fa.photoLooksLikeDone": "谢谢！寻找者将比较你的声明。",
"fa.photoNotMineDone": "报告已驳回。你的列表保持开放。",
"fa.ownerPhotoHint": "仅向你展示寻找者的照片。告诉我们它是否看起来像你的物品。",
"fa.ownerReviewingPhoto": "所有者正在审核你的照片",
"fa.ownerReviewingPhotoText": "一旦他们回答，你将会收到通知。然后你可以比较他们的声明。",
"fa.ownerRejectedPhoto": "这不是所有者的物品",
"fa.ownerRejectedPhotoText": "所有者表示你的照片与他们的物品不匹配。后续已关闭。感谢你的帮助！",
"fa.contribute": "贡献",
"fa.phoneMissing": "未提供",
"fa.ownerSafety1": "建议在公共场所或在Findloop合作伙伴处进行交接。如果距离较远，可以建议通过邮寄的方式寄送。",
"fa.ownerSafety2": "在交接时，请检查找到者的身份证。",
"pub.changePhoto": "更换照片",
"ph.secured": "照片已保护",
"ph.securing": "正在保护照片…",
"fa.ownerSafety3": "如果发现者的照片带有Findloop水印，请不要接受会议。照片必须是发现者拍摄的原始图像，且不得带有水印。"
},
"hi": {
"a.back": "वापस",
"a.category": "श्रेणी",
"a.categoryPlaceholder": "एक श्रेणी चुनें",
"a.city": "शहर",
"a.confirmPassword": "पासवर्ड की पुष्टि करें",
"a.country": "देश",
"a.createAccount": "खाता बनाएं",
"a.createBtn": "मेरा खाता बनाएं",
"a.creating": "बनाते हुए…",
"a.email": "ईमेल",
"a.emailPro": "व्यवसायिक ईमेल",
"a.forgot": "भूल गए?",
"a.forgotSent": "यदि खाता मौजूद है, तो एक रीसेट लिंक अभी भेजा गया है।",
"a.forgotSub": "ईमेल द्वारा रीसेट लिंक प्राप्त करें।",
"a.forgotTitle": "पासवर्ड भूल गए",
"a.googleContinue": "Google के साथ आगे बढ़ें",
"a.googleSignup": "Google के साथ साइन अप करें",
"a.haveAccount": "क्या आप पहले से ही साझेदार हैं?",
"a.legalHint": "फ्रांसीसी संस्थाओं के लिए फ्रांसीसी ई-चालान (Factur-X) के लिए आवश्यक।",
"a.legalRequiredFR": "फ्रांस के लिए SIRET और intra-EU VAT नंबर अनिवार्य हैं।",
"a.loggingIn": "लॉग इन कर रहे हैं…",
"a.login": "लॉग इन",
"a.loginSub": "अपने प्रबंधन स्थान तक पहुंचें।",
"a.loginTitle": "साझेदार लॉगिन",
"a.min6": "न्यूनतम 6 अक्षर",
"a.newPassword": "नया पासवर्ड",
"a.noAccount": "क्या आप अभी तक साझेदार नहीं हैं?",
"a.or": "या",
"a.org": "संस्थान का नाम",
"a.password": "पासवर्ड",
"a.passwordMismatch": "पासवर्ड मेल नहीं खाते।",
"a.referral": "रेफरल कोड (वैकल्पिक)",
"a.registerSub": "1 मिनट में अपना स्थान बनाएं - शुरू करने के लिए मुफ्त।",
"a.registerTitle": "साझेदार बनें",
"a.rememberMe": "मुझे याद रखें",
"a.reset": "रीसेट करें",
"a.resetSub": "अपने खाते के लिए नया पासवर्ड चुनें।",
"a.resetTitle": "नया पासवर्ड",
"a.sendLink": "लिंक भेजें",
"a.sending": "भेजते हुए…",
"a.signin": "लॉग इन",
"a.siret": "SIRET",
"a.vat": "Intra-EU VAT संख्या।",
"ac.africa": "अफ्रीका",
"ac.boostActive": "सक्रिय हाइलाइट —",
"ac.boostSub": "एक “बूस्टेड” बैज के साथ साझेदार निर्देशिका के शीर्ष पर दिखाई दें।",
"ac.boostTitle": "निर्देशिका में अपनी लिस्टिंग बढ़ाएं",
"ac.categoryHint": "अपने संस्थान को Findloop निर्देशिका में वर्गीकृत करने के लिए।",
"ac.choose": "चुनें",
"ac.cityHint": "सार्वजनिक मानचित्र पर सटीक स्थिति के लिए।",
"ac.cityLabel": "संस्थान का शहर",
"ac.cityPh": "पेरिस",
"ac.contact": "संपर्क विवरण",
"ac.converted": "परिवर्तित",
"ac.copyDeclLink": "घोषणा लिंक कॉपी करें",
"ac.copyLink": "लिंक कॉपी करें",
"ac.currentPlan": "वर्तमान योजना",
"ac.emailDesc": "वे ईमेल चुनें जो आप प्राप्त करना चाहते हैं। आपके कार्यक्षेत्र में सूचनाएं हमेशा सक्रिय रहती हैं।",
"ac.emailMatch": "मेल खाता है",
"ac.emailMatchDesc": "जब कोई आइटम एक घोषणा से मेल खाता है तो एक ईमेल।",
"ac.emailNewDecl": "नई हानि घोषणाएँ",
"ac.emailNewDeclDesc": "एक ईमेल जब एक ग्राहक आपके स्थान पर हानि की रिपोर्ट करता है",
"ac.emailShip": "शिपिंग अनुरोध",
"ac.emailShipDesc": "एक ईमेल जब एक ग्राहक किसी आइटम की शिपिंग का अनुरोध करता है",
"ac.emailTitle": "ईमेल प्राथमिकताएँ",
"ac.expireSoon": "आपकी हाइलाइट जल्द ही समाप्त हो रही है —",
"ac.exportCsv": "निर्यात (CSV)",
"ac.exportHint": "अपनी मान्यता प्राप्त बाहरी भुगतानों को अपने लेखांकन के लिए निर्यात करें।",
"ac.free": "फ्री",
"ac.freeMonths": "फ्री महीने",
"ac.hours": "घंटे",
"ac.howItWorks": "यह कैसे काम करता है?",
"ac.invited": "निमंत्रित",
"ac.legalFR": "इलेक्ट्रॉनिक बिलिंग (Factur-X) के लिए आवश्यक, सितंबर 2026 से लागू।",
"ac.legalMissing": "⚠️ SIRET और अंतर-ईयू VAT गायब — इलेक्ट्रॉनिक बिलिंग के साथ compliant रहने के लिए इन्हें पूरा करें।",
"ac.legalOther": "आपकी विधियों के लिए अनुशंसित।",
"ac.legalPartnerQr": "QR कोड",
"ac.legalTitle": "कानूनी पहचानकर्ता (बिलिंग)",
"ac.logoTitle": "संस्थान का लोगो",
"ac.modeCurrent": "वर्तमान मोड:",
"ac.modeExternal": "बाहरी (मैनुअल मान्यता)",
"ac.modeInternal": "आंतरिक Findloop (ऑटो)",
"ac.noSubReceipt": "अभी तक कोई भुगतान किया गया सब्सक्रिप्शन भुगतान नहीं।",
"ac.none": "कोई नहीं",
"ac.onYourListing": "आपकी लिस्टिंग पर",
"ac.pay1": "अपने भुगतान लिंक नीचे दर्ज करें ताकि आप अपने ग्राहकों को अपने संग्रह प्रणाली में पुनर्निर्देशित कर सकें।",
"ac.pay2": "मान्यता मैनुअल हो जाती है: आप “घोषणाओं” टैब से भुगतान की रसीद की पुष्टि करते हैं।",
"ac.pay3": "“शिपिंग शुल्क” लिंक एक समेकित भुगतान है (पुनर्प्राप्ति + शिपिंग)।",
"ac.pay4": "Findloop के आंतरिक भुगतान (Stripe) का उपयोग करने के लिए फ़ील्ड को खाली छोड़ दें।",
"ac.paySub": "अपने स्वयं के भुगतान प्रणाली के माध्यम से शुल्क एकत्र करें।",
"ac.payTitle": "बाहरी भुगतान",
"ac.permissive": "अनुमति देने वाला",
"ac.phone": "फोन",
"ac.posterA4": "A4 पोस्टर (PDF)",
"ac.qMessage": "संदेश (वैकल्पिक)",
"ac.qName": "नाम",
"ac.qOrg": "संस्थान",
"ac.qSites": "संस्थानों की संख्या (अनुमानित)",
"ac.qrHint": "आपके ग्राहक हानि की रिपोर्ट करने के लिए इस कोड को स्कैन करते हैं।",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "आपका साझीदार QR कोड",
"ac.quoteDesc": "हवाई अड्डे, रेल नेटवर्क, अंतरराष्ट्रीय श्रृंखलाएं · ",
"ac.quoteEurope": "यूरोप / दुनिया",
"ac.quoteSent": "कोट अनुरोध भेजा गया। हमारी टीम जल्दी ही आपसे संपर्क करेगी।",
"ac.quoteTitle": "कोट का अनुरोध करें — एंटरप्राइज",
"ac.recoveryLink": "“पुनर्प्राप्ति शुल्क” लिंक",
"ac.refSub": "प्रत्येक संदर्भित साझीदार जो सदस्यता लेता है, आपको 1 मुफ्त महीना देता है।",
"ac.refTitle": "संदर्भित करें, एक मुफ्त महीना कमाएँ",
"ac.reminderDelay": "मान्यता अनुस्मारक विलंब",
"ac.reminderHint": "अगर कोई बाहरी भुगतान इस विलंब के पार बिना मान्यता के रहता है, तो आपको एक ईमेल अनुस्मारक प्राप्त होगा (डिफ़ॉल्ट: 48घंटे)।",
"ac.renewDesc1": "यह पहले से ही आपको कमाया है",
"ac.renewDesc2": "निर्देशिका के शीर्ष पर बने रहने के लिए नवीनीकरण करें और इस दृश्यता को न खोएँ।",
"ac.renewNow": "अभी नवीनीकरण करें",
"ac.requestQuote": "कोट का अनुरोध करें",
"ac.saveLegal": "पहचानकर्ताओं को सहेजें",
"ac.saveLinks": "लिंक सहेजें",
"ac.sendRequest": "मेरा अनुरोध भेजें",
"ac.sending": "भेजना…",
"ac.shippingLink": "“शिपिंग शुल्क” लिंक (समेकित)",
"ac.shippingLinkHint": "यह लिंक पुनर्प्राप्ति और शिपिंग दोनों को कवर करता है।",
"ac.strict": "सख्त",
"ac.subReceipt": "सदस्यता रसीद (PDF)",
"ac.subReceiptsSub": "प्रत्येक सदस्यता भुगतान के लिए PDF रसीद डाउनलोड करें।",
"ac.subReceiptsTitle": "सदस्यता रसीदें",
"ac.tCategory": "श्रेणी सहेजी गई",
"ac.tCity": "शहर सहेजा गया — मानचित्र अपडेट किया गया",
"ac.tCityNeeded": "एक शहर दर्ज करें",
"ac.tCopied": "कॉपी कर लिया!",
"ac.tCover": "कवर फोटो अपडेट किया गया",
"ac.tEmailPrefs": "ईमेल प्राथमिकताएँ अपडेट की गईं",
"ac.tErr": "त्रुटि",
"ac.tExportImpossible": "निर्यात विफल",
"ac.tLegal": "कानूनी पहचानकर्ता सहेजे गए",
"ac.tLegalNeeded": "फ्रांस के लिए SIRET और VAT आवश्यक हैं",
"ac.tLogo": "लोगो अपडेट किया गया",
"ac.tLogoRemoved": "लोगो हटा दिया गया",
"ac.tPayLinks": "भुगतान लिंक सहेजे गए",
"ac.tPhone": "फोन सहेजा गया",
"ac.tSensitivity": "संवेदनशीलता सहेजी गई",
"ac.tVatInvalid": "अमान्य VAT संख्या",
"ac.tVatValid": "वैध VAT",
"ac.tabBoost": "दृश्यता",
"ac.tabPayments": "भुगतान",
"ac.tabProfile": "प्रोफ़ाइल",
"ac.tabQr": "QR और पोस्टर",
"ac.tabReferral": "रेफरल",
"ac.tabSub": "सदस्यता",
"ac.thisWeek": "इस सप्ताह",
"ac.thisWeekOf": " ({n} इस सप्ताह)",
"ac.thresholdDesc": "विश्वास का थ्रेशोल्ड जिससे AI स्वचालित रूप से फोटो मैच को मान्यता देता है और ग्राहक को सूचित करता है। उच्च = कम ऑटो-मैच लेकिन अधिक विश्वसनीय।",
"ac.thresholdTitle": "AI दृश्य मिलान संवेदनशीलता",
"ac.trend": "प्रवृत्ति",
"ac.upload": "अपलोड",
"ac.vatValidFmt": "वैध VAT{name} ({via})",
"ac.vatVerified": "इंट्रा-ईयू VAT सत्यापित",
"ac.verifyVat": "VAT सत्यापित करें (VIES)",
"ac.verifying": "सत्यापन हो रहा है…",
"ac.views": "दृश्य",
"ac.viewsTotal": "दृश्य प्राप्त हुए (कुल)",
"ac.winbackBtn": "पुनः प्रारंभ करें -20% पर",
"ac.winbackDesc1": "इसने आपको कमाया",
"ac.winbackDesc2": "विशेष प्रस्ताव: यदि आप 24 घंटे के भीतर नवीनीकरण करते हैं तो -20% स्वचालित रूप से लागू किया गया।",
"ac.winbackTitle": "आपका हाइलाइट समाप्त हो गया है — -20% पर फिर से प्रारंभ करें!",
"ad.boost": "बढ़ाना",
"ad.close": "बंद करें",
"ad.closeConfirm": "क्या आप इस लिस्टिंग को बंद करना चाहते हैं?",
"ad.closed": "लिस्टिंग बंद",
"ad.edit": "संपादित करें",
"ad.editTitle": "लिस्टिंग संपादित करें",
"ad.saved": "लिस्टिंग अपडेट की गई",
"an.allCountries": "सभी देश",
"an.badge": "गुम वस्तुएं",
"an.boostLater": "बाद में",
"an.boostNow": "अब बढ़ाएँ",
"an.boostPrompt": "अपनी लिस्टिंग को बढ़ाएं ताकि इसे शीर्ष पर रखा जा सके और तेज़ी से मिल सके।",
"an.boosted": "बढ़ा दिया गया",
"an.contact": "मैंने यह वस्तु पाई",
"an.contactTitle": "रिपोर्ट करें कि आपने यह वस्तु पाई",
"an.copyFailed": "लिंक कॉपी करने में असफल",
"an.copyLink": "लिंक कॉपी करें",
"an.country": "देश",
"an.date": "खोने की तारीख",
"an.finderEmail": "आपका ईमेल",
"an.finderName": "आपका नाम",
"an.finderPhone": "आपका फोन",
"an.geoBannerWorld": "आप विश्व स्तर पर लिस्टिंग देख रहे हैं",
"an.geoChange": "देश बदलें",
"an.goAccount": "मेरे खाते पर जाएं",
"an.linkCopied": "लिंक कॉपी किया गया!",
"an.loginRequired": "इस आइटम की रिपोर्ट करने और वापसी को फॉलो करने के लिए लॉग इन करें।",
"an.loginToBoost": "इस लिस्टिंग को बढ़ाने के लिए लॉग इन करें",
"an.lostAt": "खोया हुआ",
"an.message": "संदेश (वैकल्पिक)",
"an.none": "अभी तक कोई लिस्टिंग नहीं।",
"an.photo": "फोटो (वैकल्पिक)",
"an.post": "लिस्टिंग प्रकाशित करें",
"an.postSubtitle": "अपने खोए हुए आइटम का वर्णन करें — समुदाय और हमारे साथी आपकी मदद करेंगे।",
"an.postTitle": "खोए हुए आइटम की रिपोर्ट करें",
"an.publish": "लिस्टिंग प्रकाशित करें",
"an.published": "लिस्टिंग प्रकाशित हो गई!",
"an.publishing": "प्रकाशित किया जा रहा है…",
"an.remaining": "बचे हुए",
"an.requestInProgress": "अनुरोध प्रगति में है",
"an.resolved": "आइटम पहले ही पुनः प्राप्त कर लिया गया है",
"an.reward": "इनाम",
"an.searchPh": "लिस्टिंग खोजें…",
"an.send": "भेजें",
"an.sent": "संदेश मालिक को भेजा गया!",
"an.shareConsent": "मैं सहमत हूँ कि मेरी संपर्क जानकारी (नाम, ईमेल, फोन) आइटम के मालिक के साथ साझा की जा सकती है।",
"an.shareConsentError": "कृपया अपनी संपर्क जानकारी साझा करने के लिए बॉक्स पर टिक करें।",
"an.sortRecent": "सबसे हालिया",
"an.sortRelevance": "प्रासंगिकता",
"an.subtitle": "समुदाय द्वारा रिपोर्ट किए गए खोए हुए आइटम ब्राउज़ करें। क्या आपने उनमें से कोई पाया?",
"an.title": "खोए हुए आइटम की लिस्टिंग",
"anf.badge": "पाए गए आइटम",
"anf.claim": "यह मेरा है",
"anf.claimSent": "संदेश खोजकर्ता को भेजा गया!",
"anf.claimTitle": "रिपोर्ट करें कि यह आपका आइटम है",
"anf.consent": "मैं सहमत हूँ कि मालिक अपनी वस्तु पुनः प्राप्त करने के लिए मेरी संपर्क जानकारी देख सकता है।",
"anf.foundAt": "पाया गया",
"anf.foundDate": "पाने की तारीख",
"anf.loginCta": "लॉग इन करें / खाता बनाएं",
"anf.loginDesc": "एक खोजकर्ता खाता लिस्टिंग प्रकाशित करने और फाइंडर हीरो अंक अर्जित करने के लिए आवश्यक है।",
"anf.loginRequired": "पाए गए आइटम को पोस्ट करने के लिए लॉग इन करें",
"anf.photo": "आइटम का फोटो",
"anf.pointsEarned": "धन्यवाद! आपने अभी फाइंडर हीरो अंक अर्जित किए हैं।",
"anf.pointsPending": "आपके अंक 24 घंटे के भीतर, सत्यापन के बाद, क्रेडिट किए जाएंगे।",
"anf.post": "पाए गए आइटम को पोस्ट करें",
"anf.postSubtitle": "उस आइटम का वर्णन करें जो आपने पाया — इसके मालिक को वापस पाने में मदद करें।",
"anf.postTitle": "पाए गए आइटम की रिपोर्ट करें",
"anf.publishFound": "पाई गई लिस्टिंग प्रकाशित करें",
"anf.published": "पाए गए आइटम की लिस्टिंग प्रकाशित",
"anf.publishedAs": "के रूप में प्रकाशित",
"anf.shareConsent": "मैं सहमत हूँ कि मेरी संपर्क जानकारी (नाम, ईमेल, फोन) उस व्यक्ति के साथ साझा की जा सकती है जिसने आइटम पाया है।",
"anf.subtitle": "समुदाय द्वारा पाए गए और रिपोर्ट किए गए आइटम ब्राउज़ करें। क्या आपका है?",
"anf.title": "पाए गए आइटम की लिस्टिंग",
"bo.active": "बूस्ट सक्रिय",
"bo.africaPrice": "अफ्रीका-क्षेत्रीय वरीयता मूल्य निर्धारण लागू",
"bo.pay": "भुगतान करें और बूस्ट करें",
"bo.remaining": "बाकी समय",
"bo.renew": "बूस्ट नवीनीकरण",
"bo.since": "बूस्ट से",
"bo.subtitle": "<b>अपनी लिस्टिंग को लिस्ट के शीर्ष पर एक दृश्य बैज के साथ रखें।</b>",
"bo.title": "लिस्टिंग बूस्ट करें",
"c.all": "सभी",
"c.cancel": "रद्द करें",
"c.close": "बंद करें",
"c.confirm": "पुष्टि करें",
"c.confirmed": "पुष्टि हो गई",
"c.download": "डाउनलोड करें",
"c.loading": "लोड हो रहा है…",
"c.reset": "रीसेट करें",
"c.reviews": "समीक्षाएँ",
"c.save": "सहेजें",
"c.transfer": "स्थानांतरण",
"cat.Animal": "पालतू जानवर / पालतू सहायक",
"cat.AppareilPhoto": "कैमरा",
"cat.Argent": "पैसा / नकद",
"cat.Autres": "अन्य",
"cat.Bijoux": "गहने",
"cat.CarteBancaire": "बैंक कार्ड",
"cat.CarteIdentite": "ID कार्ड / पासपोर्ट",
"cat.Casquette": "टोपी",
"cat.Ceinture": "बेल्ट",
"cat.Chargeur": "चार्जर / केबल",
"cat.Chaussures": "जूते",
"cat.CleVoiture": "कार की चाबी",
"cat.Cles": "चाबियाँ",
"cat.Console": "गेम कंसोल",
"cat.Documents": "दस्तावेज़ / कागजात",
"cat.Echarpe": "स्कार्फ",
"cat.Ecouteurs": "इयरफ़ोन / हेडफ़ोन",
"cat.Electronique": "इलेक्ट्रॉनिक्स (अन्य)",
"cat.Enceinte": "स्पीकर",
"cat.Gants": "दस्ताने",
"cat.Gourde": "पानी की बोतल / फ्लास्क",
"cat.Instrument": "संगीत उपकरण",
"cat.Jouet": "खिलौना / प्लश",
"cat.Jumelles": "दूरबीन",
"cat.Lampe": "लैम्प / टॉर्च",
"cat.Liseuse": "ई-रीडर",
"cat.Livre": "किताब / नोटबुक",
"cat.Lunettes": "चश्मा",
"cat.Manteau": "कोट / जैकेट",
"cat.Maquillage": "मेकअप बैग",
"cat.Medical": "चिकित्सा उपकरण",
"cat.Medicaments": "दवा",
"cat.Montre": "घड़ी / स्मार्टवॉच",
"cat.Ordinateur": "लैपटॉप",
"cat.Parapluie": "छाता",
"cat.Portefeuille": "बटुआ / पर्स",
"cat.Poussette": "स्टोलर / बेबी सहायक",
"cat.Sac": "बैग / हैंडबैग",
"cat.SacADos": "स्कूल बैग",
"cat.Souris": "माउस / कीबोर्ड",
"cat.Sport": "खेल उपकरण",
"cat.Tablette": "टैबलेट",
"cat.Telephone": "फोन / स्मार्टफोन",
"cat.Trottinette": "स्कूटर",
"cat.Trousse": "पाउच / केस",
"cat.USB": "यूएसबी स्टिक / हार्ड ड्राइव",
"cat.Valise": "सूटकेस / लगेज",
"cat.Velo": "साइकिल",
"cat.Vetements": "वस्त्र",
"cat.placeholder": "एक श्रेणी चुनें",
"cd.d": "d",
"cd.expired": "समय सीमा समाप्त",
"cd.h": "h",
"cd.m": "मिनट",
"ck.accept": "स्वीकार करें",
"ck.acceptAll": "सभी स्वीकार करें",
"ck.customize": "अनुकूलित करें",
"ck.learn": "और जानें",
"ck.manage": "कुकीज़ प्रबंधित करें",
"ck.measurement": "दर्शक मापन",
"ck.measurementDesc": "सेवा में सुधार के लिए गुमनाम आंकड़े।",
"ck.msg": "हम साइट को काम करने और दर्शकों को मापने के लिए कुकीज़ का उपयोग करते हैं।",
"ck.necessary": "आवश्यक",
"ck.necessaryDesc": "साइट के काम करने के लिए आवश्यक। हमेशा चालू।",
"ck.refuse": "अस्वीकृत करें",
"ck.save": "मेरे विकल्प सहेजें",
"ck.saved": "पसंद सहेज ली गई",
"ck.title": "आपकी कुकी सेटिंग्स",
"cm.found": "मिला",
"cm.lost": "खो गया",
"cmp.adv": "उन्नत",
"cmp.ai": "एआई मिलान",
"cmp.autobill": "स्वचालित बिलिंग",
"cmp.basic": "बुनियादी",
"cmp.community": "समुदाय",
"cmp.consol": "संक्षिप्त बिलिंग",
"cmp.custom": "कस्टम",
"cmp.dedicated": "समर्पित",
"cmp.deploy": "समर्पित तैनाती & SLA",
"cmp.estIncl": "प्रविष्टियाँ शामिल हैं",
"cmp.estSec": "अतिरिक्त प्रतिष्ठान",
"cmp.items": "आइटम / माह",
"cmp.main": "1 मुख्य",
"cmp.max20": "20 अधिकतम",
"cmp.members": "सदस्य आमंत्रण",
"cmp.onQuote": "कस्टम कोट",
"cmp.priority": "प्राथमिकता",
"cmp.starterEst": "1 शामिल + असीमित अतिरिक्त",
"cmp.stats": "आकड़े",
"cmp.statsAdv": "उन्नत",
"cmp.statsBasic": "बुनियादी",
"cmp.support": "समर्थन",
"cmp.unlimited": "असीमित",
"cmp.upTo3": "3 तक",
"consent.required": "जारी रखने के लिए आपको अपनी संपर्क जानकारी साझा करने की सहमति देनी होगी।",
"consent.share": "मैं सहमत हूँ कि मेरी आइटम के खोजकर्ता मेरी संपर्क जानकारी (नाम, ईमेल, फोन) देख सकता है ताकि वह मुझे इसकी वापसी के लिए संपर्क कर सके।",
"cover.add": "जोड़े",
"cover.change": "बदलें",
"cover.helper": "यह आपके रिपोर्ट पृष्ठ और निर्देशिका पर बैनर के रूप में दिखाया जाएगा।",
"cover.none": "कोई कवर फोटो नहीं",
"cover.remove": "हटाएं",
"cover.title": "कवर फोटो",
"crop.desc": "banner अनुपात (3:1) के लिए फ्रेमिंग को समायोजित करें। खींचें और ज़ूम करें।",
"crop.saving": "सहेज रहा है…",
"crop.title": "कवर फोटो क्रॉप करें",
"cta.button": "मेरे साथी खाता बनाएं",
"cta.subtitle": "Findloop के साथ आइटम तेजी से लौटाने वाले प्रतिष्ठानों में शामिल हों।",
"cta.title": "खोई हुई वस्तुओं को कम करने के लिए तैयार हैं?",
"db.account.s": "अपने प्रतिष्ठान, सब्सक्रिप्शन और QR कोड का प्रबंधन करें।",
"db.account.t": "मेरा खाता",
"db.declarations.s": "जो ग्राहक आपके QR कोड के माध्यम से खोई हुई वस्तु की रिपोर्ट करते हैं।",
"db.declarations.t": "हानि रिपोर्ट",
"db.deposit.s": "एक फोटो, एक श्रेणी और एक विवरण जोड़ें।",
"db.deposit.t": "खोई हुई वस्तु दर्ज करें",
"db.registry.s": "आपके प्रतिष्ठान पर लॉग की गई सभी खोई हुई वस्तुएं।",
"db.registry.t": "आइटम रजिस्ट्रि",
"db.reviews.s": "अपने ग्राहकों की समीक्षाओं का सार्वजनिक रूप से उत्तर दें।",
"db.reviews.t": "ग्राहक समीक्षाएँ",
"db.shipments.s": "लेबल उत्पन्न करें और भेजने के लिए पार्सल को ट्रैक करें।",
"db.shipments.t": "शिपमेंट",
"db.stats.s": "आपके प्रमुख प्रदर्शन संकेतक।",
"db.stats.t": "आंकड़े",
"db.team.s": "अपनी टीम के सदस्यों को आइटम प्रबंधित करने के लिए आमंत्रित करें।",
"db.team.t": "टीम",
"dc.partnerDesc": "क्या आप अपने आइटम को एक साझेदार स्थल (होटल, स्टेशन, हॉल…) पर खो चुके हैं? सीधी वापसी के लिए इसे चुनें।",
"dc.partnerList": "सूची में से चुनें",
"dc.partnerMap": "नक्शे पर चुनें",
"dc.partnerTitle": "साझेदार पर घोषणा",
"dc.publicCta": "एक सार्वजनिक विज्ञापन पोस्ट करें",
"dc.publicDesc": "आपका विज्ञापन पूरे Findloop समुदाय को दिखाई देगा। यदि आप नहीं जानते कि आपने आइटम कहां खोया है तो यह आदर्श है।",
"dc.publicTitle": "सार्वजनिक घोषणा",
"dc.subtitle": "अपनी खोई हुई वस्तु की रिपोर्ट करने का तरीका चुनें।",
"dc.title": "आप क्या करना चाहेंगे?",
"dec.addrPending": "ग्राहक से पता लंबित",
"dec.analyzing": "विश्लेषण कर रहे हैं...",
"dec.badge": "हानि रिपोर्ट",
"dec.category": "आइटम श्रेणी",
"dec.clientDescription": "ग्राहक विवरण",
"dec.clientPhoto": "ग्राहक द्वारा प्रदान की गई फोटो",
"dec.clientPhotoShort": "ग्राहक की फोटो",
"dec.comparePhotos": "फोटो की तुलना करें",
"dec.contactTitle": "आपकी संपर्क जानकारी",
"dec.date": "हानि की तारीख",
"dec.declaredItemPhoto": "घोषित आइटम की फोटो",
"dec.descPh": "आइटम का वर्णन करें: ब्रांड, रंग, विशिष्ट चिन्ह...",
"dec.description": "विवरण",
"dec.email": "ईमेल",
"dec.emptyDesc": "घोषणाएं प्राप्त करने के लिए अपना QR कोड साझा करें।",
"dec.emptyTitle": "कोई घोषणा नहीं",
"dec.enlarge": "बढ़ाएं",
"dec.extBanner": "{n} बाहरी भुगतान मान्य करने के लिए — हस्तांतरण या शिपिंग को अनलॉक करने के लिए नीचे सत्यापन करें।",
"dec.foundItemAlt": "खींची गई वस्तु",
"dec.foundItemRegistry": "खींची गई वस्तु (रजिस्ट्रि)",
"dec.home": "घर पर लौटें",
"dec.labelClient": "ग्राहक",
"dec.labelRegistry": "रजिस्ट्रि",
"dec.matchFound": "एक मेल पहले से ही पहचान ली गई है!",
"dec.name": "पूरा नाम",
"dec.noMatchYet": "अभी तक कोई मेल नहीं।",
"dec.noPhoto": "कोई फोटो नहीं",
"dec.notfound": "साझेदार नहीं मिला।",
"dec.pRecup": "पुनर्प्राप्ति",
"dec.pRecupP": "(पुनर्प्राप्ति)",
"dec.pRecupShip": "(पुनर्प्राप्ति + शिपिंग)",
"dec.payConfirmed": "भुगतान {x} पुष्टि हो गई",
"dec.payPending": "बाहरी भुगतान {x} लंबित",
"dec.phone": "फोन",
"dec.pickup": "व्यक्तिगत रूप से उठाना",
"dec.place": "नुकसान की जगह",
"dec.placePh": "उदाहरण: बार में, कमरा 204…",
"dec.recoverBtn": "मेरी वस्तु पुनः प्राप्त करें",
"dec.reject": "अस्वीकृत करें",
"dec.rerun": "विश्लेषण पुनः चलाएं",
"dec.similarity": "समानता {n}%",
"dec.submit": "मेरी रिपोर्ट सबमिट करें",
"dec.submitting": "भेजना…",
"dec.successText": "हम आपकी वस्तु को ढूंढ रहे हैं जो रखा गया है",
"dec.successTitle": "रिपोर्ट सबमिट कर दी गई!",
"dec.suggestedMatches": "सुझावित मेल",
"dec.toColon": " को:",
"dec.toShip": "शिप करने के लिए",
"dec.toastExtPay": "भुगतान पुष्टि हो गई — ग्राहक को सूचित किया जाएगा।",
"dec.toastMatch": "मेल पुष्टि हो गई",
"dec.toastReject": "सुझाव अस्वीकृत",
"dec.toastRerun": "विश्लेषण पुनः प्रारंभ",
"dec.toastVisualN": "{n} दृश्य मेल",
"dec.toastVisualNone": "कोई दृश्य मेल नहीं",
"dec.trackBtn": "मेरी रिपोर्ट ट्रैक करें",
"dec.viewBeforeAfter": "पहले/बाद का दृश्य (ओवरले)",
"dec.viewSideBySide": "साइड-बाय-साइड दृश्य",
"dec.visualCompare": "AI दृश्य तुलना",
"dec.visualIdle": "तुलना चलाएं ताकि AI ग्राहक के फोटो को ढूंढी गई वस्तुओं के साथ दृश्य मेल कर सके।",
"dec.visualRunning": "AI ग्राहक के फोटो की तुलना आपकी रजिस्ट्री में वस्तुओं से कर रहा है…",
"dec.zoomPhoto": "फोटो को बड़ा करें",
"dep.addAnyway": "फिर भी जोड़ें",
"dep.addError": "जोड़ने में त्रुटि",
"dep.addItem": "वस्तु जोड़ें",
"dep.added": "वस्तु रजिस्ट्री में जोड़ दी गई!",
"dep.adding": "जोड़ने…",
"dep.aiError": "AI विश्लेषण अभी उपलब्ध नहीं है।",
"dep.aiFilled": "फॉर्म AI द्वारा पूर्व-भर दिया गया ✨",
"dep.aiUnavailable": "AI उपलब्ध नहीं है — फॉर्म को मैन्युअल रूप से भरें।",
"dep.analyzing": "विश्लेषण कर रहा है…",
"dep.analyzingPhoto": "फोटो का विश्लेषण कर रहा है…",
"dep.brand": "ब्रांड",
"dep.brandPlaceholder": "उदाहरण: Apple",
"dep.category": "श्रेणी",
"dep.checkingDup": "डुप्लिकेट के लिए चेक कर रहा है…",
"dep.color": "रंग",
"dep.colorPlaceholder": "उदाहरण: काला",
"dep.condition": "स्थिति",
"dep.conditionPlaceholder": "उदाहरण: अच्छी स्थिति",
"dep.depositorNote": "जमाकर्ता नोट",
"dep.depositorNoteHint": "हाथ से टाइप किए गए परिचालन विवरण। AI कभी भी इस नोट को अधिलेखित नहीं करता।",
"dep.depositorNotePlaceholder": "उदाहरण: थैली की सामग्री, जैसे रिपोर्ट किया गया ब्रांड, व्यक्ति द्वारा दिए गए विवरण…",
"dep.descPlaceholder": "उदाहरण: स्पष्ट केस के साथ काला आईफोन 15, जो बार में मिला…",
"dep.description": "विवरण",
"dep.dupHint": "सुनिश्चित करें कि आप डुप्लिकेट नहीं जोड़ रहे हैं। यदि वस्तु वास्तव में अलग है तो आप जारी रख सकते हैं।",
"dep.dupTitle": "समान वस्तुएं पहले से रजिस्टर्ड हैं",
"dep.dupWarn": "समान वस्तु का पता चला — समीक्षा करें, फिर पुष्टि करने के लिए फिर से क्लिक करें।",
"dep.estHint": "यह वस्तु इस प्रतिष्ठान की रजिस्ट्री में जोड़ी जाएगी।",
"dep.establishment": "प्रतिष्ठान",
"dep.fee": "पुनर्प्राप्ति शुल्क (€) — वैकल्पिक",
"dep.feePlaceholder": "श्रेणी के डिफ़ॉल्ट मूल्य के लिए छोड़ें",
"dep.fillAI": "AI से भरें",
"dep.optional": "(ऐच्छिक)",
"dep.photo": "आइटम फोटो",
"dep.principal": "प्राथमिक",
"dep.reqError": "श्रेणी और विवरण आवश्यक हैं।",
"dep.savedItem": "पंजीकृत आइटम",
"dep.similarity": "समानता",
"dep.storage": "भौतिक स्थान",
"dep.storageHint": "जहाँ आइटम भौतिक रूप से संग्रहित है। इसे ढूंढने के लिए एक QR कोड उत्पन्न होगा।",
"dep.storagePlaceholder": "जैसे कि शेल्फ A3, लॉकर 12, रिसेप्शन सुरक्षित",
"dl.aClient": "एक ग्राहक",
"dl.alertsBlocked": "ब्राउज़र अलर्ट अवरुद्ध",
"dl.alertsBlockedHint": "इन्हें फिर से सक्षम करने के लिए: साइट पते के बाएँ 🔒 (या ⓘ) आइकन पर क्लिक करें, फिर Notifications को अनुमति दें और पृष्ठ को फिर से लोड करें।",
"dl.amountDue": "देय राशि: {amount} {currency}।",
"dl.enableAlerts": "अलर्ट सक्षम करें",
"dl.extPending": "भुगतान पुष्टि की प्रतीक्षा में",
"dl.freemiumNear": "आप Freemium सीमा ({used}/{max} आइटम इस महीने) के पास पहुंच रहे हैं। अनलिमिटेड आइटम के लिए Starter में अपग्रेड करें।",
"dl.freemiumReached": "Freemium सीमा पहुँच गई ({used}/{max} आइटम इस महीने)। अनलिमिटेड आइटम के लिए Starter में अपग्रेड करें।",
"dl.invoiceOverdue": "बिल {num} अवैतनिक — पहुंच प्रतिबंधित।",
"dl.matchNotifTitle": "Findloop — नया AI मिलान 🔔",
"dl.matchToast": "नया AI मिलान — {name}",
"dl.matchToastDesc": "एक आइटम एक घोषणा के साथ मेल खाता है।",
"dl.notifEmpty": "अभी कोई अधिसूचना नहीं।",
"dl.notifEnabled": "ब्राउज़र अलर्ट सक्षम",
"dl.notifTitle": "अधिसूचनाएँ",
"dl.payInvoice": "मेरा बिल भुगतान करें →",
"dl.rewardsPending": "बदान प्रस्तुत करने के लिए",
"dl.upgradeStarter": "Starter में अपग्रेड करें →",
"est.all": "सभी संस्थान ({n})",
"est.label": "संस्थान",
"est.primary": "प्राथमिक",
"est.secondary": "माध्यमिक",
"est2.add": "एक संस्थान जोड़ें",
"est2.addressLabel": "पता",
"est2.addressPh": "12 रिपब्लिक स्ट्रीट",
"est2.autoInvoice": "प्रत्येक महीने की 1 तारीख को एक विस्तृत बिल स्वचालित रूप से उत्पन्न होता है।",
"est2.baseSub": "बेस सदस्यता",
"est2.billing": "बिलिंग",
"est2.boostActivated": "{name} के लिए बूस्ट सक्रिय किया गया",
"est2.boostBillingNote": "वर्तमान दर पर बिल किया गया और आपके समेकित मासिक बिल पर समूहित किया गया।",
"est2.boostCta": "बूस्ट",
"est2.boostDesc": "इस संस्थान की दृश्यता को डायरेक्टरी और मानचित्र पर सुधारें।",
"est2.boostDuration": "{h}घंटे की वृद्धि हुई दृश्यता",
"est2.boostExtend": "विस्तार करें",
"est2.boostTitle": "बूस्ट {name}",
"est2.boosted": "बूस्ट किया गया",
"est2.chartDesc": "कुल पंजीकृत आइटमों में से लौटाए गए आइटम का हिस्सा, साइट दर साइट।",
"est2.chartTitle": "संस्थान द्वारा लौटने की दर",
"est2.chartTooltip": "लौटाना",
"est2.cityLabel": "शहर",
"est2.cityPh": "ल्यों",
"est2.contactHint": "ये विवरण ग्राहक को इस संस्थान के लिए दिखाए जाते हैं (यदि खाली हैं तो खाते पर वापस करते हैं)।",
"est2.countryLabel": "देश",
"est2.coverLabel": "कवर फोटो",
"est2.create": "बनाएं",
"est2.created": "संस्थान बनाया गया",
"est2.delete": "हटाएँ",
"est2.deleteDesc": "यह क्रिया स्थायी है। आप केवल तभी एक संस्थान हटा सकते हैं जब उसमें कोई आइटम न हो।",
"est2.deleteTitle": "“{name}” हटाएँ?",
"est2.deleted": "संस्थान हटा दिया गया",
"est2.dialogDesc": "इस साइट का नाम और पता दर्ज करें।",
"est2.edit": "संपादित करें",
"est2.editEst": "संस्थान संपादित करें",
"est2.emailLabel": "संपर्क ईमेल",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " संस्थान(ों)",
"est2.extraNoteBase": "{n} अतिरिक्त संस्थान(ों) के लिए बिलिंग",
"est2.extraPrice": " {price} €/महीना पर.",
"est2.extraQuote": " उद्धरण पर.",
"est2.imgChange": "चित्र चुनें",
"est2.imgDone": "पूरा",
"est2.imgRemove": "हटाएं",
"est2.imgRemoved": "चित्र हटाया गया",
"est2.imgSaved": "चित्र सुरक्षित किया गया",
"est2.imgUploading": "अपलोड हो रहा है…",
"est2.includedPlan": "आपकी योजना में शामिल: {n}.",
"est2.kDeclarations": "घोषणाएँ",
"est2.kInStorage": "भंडारण में",
"est2.kItemsTotal": "आइटम (कुल)",
"est2.kRestituted": "वापस किया गया",
"est2.limitReached": "सीमा पहुँच गई",
"est2.logoLabel": "लोगो",
"est2.mDeclar": "घो.",
"est2.mItems": "आइटम",
"est2.mRestituted": "वापस किया गया",
"est2.mStorage": "भंडारण में",
"est2.monthlyTotal": "मासिक कुल",
"est2.nameLabel": "नाम *",
"est2.namePh": "उदाहरण: बेलमोंट होटल — ल्यों अतिरिक्त",
"est2.newEst": "नया संस्थान",
"est2.onQuote": "उद्धरण पर",
"est2.phoneLabel": "फोन",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "योजना",
"est2.planLimited": "आपकी “{tier}” योजना {max} संस्थान(ों) तक सीमित है।",
"est2.primary": "प्राथमिक",
"est2.qr": "QR कोड",
"est2.qrDesc": "इस संस्थान में इस QR कोड को प्रदर्शित करें। खोने की रिपोर्ट करने वाले ग्राहक इस साइट से जुड़े होंगे।",
"est2.qrTitle": "QR कोड — {name}",
"est2.saving": "सहेजना…",
"est2.seeInvoices": "मेरी मासिक चालान देखें",
"est2.seePlans": "योजनाएँ देखें",
"est2.subtitle": "एक खाते के तहत सभी अपनी साइटों का प्रबंधन करें — एकीकृत दृश्य, आइटम, QR कोड और बिलिंग।",
"est2.suspended": "निलंबित",
"est2.tierFree": "1 संस्थान",
"est2.tierLarge": "असीमित संस्थान",
"est2.tierMedium": "5 संस्थान शामिल",
"est2.tierSmall": "3 संस्थान शामिल",
"est2.title": "संस्थानों",
"est2.unlimitedPlan": "आपकी योजना कई संस्थानों की अनुमति देती है।",
"est2.unlimitedSuffix": " · असीमित",
"est2.updated": "संस्थान अपडेट किया गया",
"est2.upgradeHint": "अधिक साइटों को जोड़ने और आपकी सभी गतिविधियों को केंद्रीकरण करने के लिए उच्च योजना में अपग्रेड करें।",
"est2.visuals": "लोगो और फोटो",
"est2.visualsDesc": "इस संस्थान का लोगो और कवर फोटो कस्टमाइज़ करें। ये इसके सार्वजनिक पृष्ठ और घोषणा फॉर्म पर दिखाई देते हैं।",
"est2.visualsTitle": "दृश्य — {name}",
"est2.workOn": "इस संस्थान पर काम करें",
"est2.working": "आप “{name}” पर काम कर रहे हैं",
"ev.created": "रिपोर्ट बनाई गई",
"ev.matched": "मेल खाने वाला आइटम पहचाना गया",
"ev.paid": "भुगतान किया गया पुनर्प्राप्ति शुल्क",
"ev.pickup": "साइट पर पिकअप",
"ev.shipped": "पार्सल शिप किया गया",
"ev.shipping_paid": "शिपिंग शुल्क भुगतान किया गया",
"ev.shipping_requested": "शिपिंग का अनुरोध किया गया",
"feat1.d": "केपीआई, श्रेणी अनुसार वापसी दर, राजस्व और 30-दिन के रुझान।",
"feat1.t": "डैशबोर्ड और विश्लेषण",
"feat2.d": "लेबल, कैरियर ट्रैकिंग और स्वचालित ट्रैकिंग ईमेल।",
"feat2.t": "शिपिंग मॉड्यूल",
"feat3.d": "ग्राहक आपको शहर और श्रेणी द्वारा खोजते हैं, प्रमाणित समीक्षाओं के साथ।",
"feat3.t": "सार्वजनिक निर्देशिका और समीक्षाएं",
"fp.backToRanking": "लीडरबोर्ड पर वापस जाएं",
"fp.badge": "बैज",
"fp.hero": "फाइंडर हीरो",
"fp.notFound": "प्रोफ़ाइल नहीं मिली या निजी।",
"fp.scoreTotal": "कुल अंक",
"fp.scoreYear": "में अंक",
"fp.share": "इस प्रोफ़ाइल को साझा करें",
"fp.shareText": "फिंदो पर {name} की फाइंडर प्रोफ़ाइल देखें!",
"fp.tagline": "एक ईमानदार फाइंडर जो दुनिया को बेहतर बनाता है।",
"ft.backAccount": "मेरे खाते पर वापस जाएं",
"ft.closeBtn": "केस बंद करें",
"ft.closeConfirm": "क्या पुष्टि करें कि आइटम वापस किया गया था? विज्ञापन बंद कर दिया जाएगा।",
"ft.closeLockedHint": "बंद करने के लिए पहले मालिक का कोड मान्य करें।",
"ft.closed": "केस बंद — आइटम वापस किया गया!",
"ft.codeLabel": "मालिक से प्राप्त मान्यता कोड दर्ज करें",
"ft.codeNeeded": "कृपया मान्यता कोड दर्ज करें।",
"ft.codeOk": "कोड मान्य किया गया — आप केस बंद कर सकते हैं।",
"ft.codePlaceholder": "उदाहरण: 4821",
"ft.codeVerified": "मान्य",
"ft.doneMsg": "आइटम वापस किया गया। इसे वापस करने में मदद करने के लिए धन्यवाद!",
"ft.stepInProgress": "वापसी प्रगति में है",
"ft.stepPublished": "विज्ञापन प्रकाशित",
"ft.stepReturned": "आइटम वापस किया गया",
"ft.subtitle": "पाई गई वस्तु वापस करने तक कदम उठाते रहें।",
"ft.title": "वापसी ट्रैकिंग",
"ft.verifyBtn": "कोड मान्य करें",
"hero.badge": "विशेष रूप से प्रदर्शित",
"hero.ctaFound": "मैंने एक आइटम पाया",
"hero.ctaLost": "मैंने एक आइटम खो दिया",
"hero.ctaPartner": "एक भागीदार बनें",
"hero.subtitle": "फिंदो संस्थानों को पाई गई वस्तुओं का प्रबंध करने में मदद करता है — और उनके ग्राहकों को एक कमी की रिपोर्ट करने की अनुमति देता है फिर अपनी चीज़ों को साइट पर या शिपिंग द्वारा पुनर्प्राप्त करें।",
"hero.title": "हर खोई हुई वस्तु अपने मालिक को मिलती है।",
"home.champBecome": "एक फाइंडर बनें",
"home.champCta": "लीडरबोर्ड देखें",
"home.champSubtitle": "प्रत्येक वापस किए गए आइटम से अंक मिलते हैं। लीडरबोर्ड में शामिल हों और पुरस्कार जीतें।",
"home.champTitle": "हमारे शीर्ष फाइंडर्स",
"how.eyebrow": "यह कैसे काम करता है",
"how.title": "ड्रॉप-ऑफ से लेकर वापसी तक, बिना किसी प्रयास के।",
"inv.all": "सभी",
"inv.allYears": "सभी वर्ष",
"inv.count": "इनवॉइस",
"inv.due": "देय",
"inv.empty": "अभी तक कोई इनवॉइस नहीं।",
"inv.exportCsv": "सीएसवी निर्यात करें",
"inv.invoicePdf": "इनवॉइस पीडीएफ",
"inv.issued": "जारी",
"inv.noMatch": "इस फ़िल्टर के लिए कोई इनवॉइस नहीं।",
"inv.paid": "भुगतान किया गया (€)",
"inv.paidOn": "पर भुगतान किया गया",
"inv.pay": "भुगतान करें",
"inv.receipt": "रसीद",
"inv.reminders": "याद दिलाने वाले",
"inv.remindersDesc": "इस चालान के लिए ईमेल और एसएमएस याद दिलाने वाले भेजे गए।",
"inv.remindersEmpty": "कोई याद दिलाने वाला नहीं भेजा गया।",
"inv.rmDue": "नियत तिथि याद दिलाने वाला",
"inv.rmManual": "मैनुअल याद दिलाने वाला",
"inv.rmSms": "एसएमएस याद दिलाने वाला D+30",
"inv.rmStage": "याद दिलाने वाला",
"inv.statusPaid": "भुगतान किया गया",
"inv.statusUnpaid": "अभुगत नहीं",
"inv.subtitle": "अपने चालान और रसीदें देखें और डाउनलोड करें।",
"inv.title": "मेरे चालान",
"inv.unpaid": "अभुगत नहीं (€)",
"inv2.contractTitle": "मेरा Findloop अनुबंध",
"inv2.detailByEst": "संस्थापन द्वारा विवरण",
"inv2.dueLabel": "नियत:",
"inv2.dueSuffix": " · नियत {date}",
"inv2.error": "त्रुटि {status}",
"inv2.estCountIssued": "{n} संस्थापन(ों) · {date} को जारी किया गया",
"inv2.estimate": "अनुमान (चार्ज नहीं किया गया) · {n} संस्थापन(ों)",
"inv2.expired": " · समाप्त",
"inv2.exportCsv": "CSV निर्यात करें",
"inv2.exportDone": "CSV निर्यात डाउनलोड किया गया",
"inv2.included": "शामिल",
"inv2.monthlyTitle": "मासिक चालान (सब्सक्रिप्शन)",
"inv2.months": "+{n} महीने",
"inv2.paid": "भुगतान किया गया",
"inv2.pay": "भुगतान करें",
"inv2.previewTitle": "आपके अगले चालान का पूर्वावलोकन —",
"inv2.renew": "मेरा अनुबंध नवीनीकरण करें",
"inv2.renewalsTitle": "नवीनीकरण इतिहास ({n})",
"inv2.renewedUntil": "अनुबंध {date} तक नवीनीकरण किया गया",
"inv2.serviceTitle": "सेवा चालान (रिकवरी और कोट)",
"inv2.soon": "जल्द समाप्त हो रहा है",
"inv2.toPay": "भुगतान करना है",
"inv2.totalHtTva": "कुल बिना कर · जीएसटी",
"inv2.totalTtc": "कुल कर सहित",
"iu.addPhoto": "एक फोटो जोड़ें",
"iu.change": "बदलें",
"lang.label": "भाषा",
"lb.allCountries": "सभी देश",
"lb.badge": "वार्षिक लीडरबोर्ड",
"lb.champion": "🏆 वर्ष का चैंपियन",
"lb.cityPh": "शहर के द्वारा फ़िल्टर करें…",
"lb.empty": "इन फ़िल्टरों के लिए अभी कोई रैंकिंग नहीं है।",
"lb.pts": "अंक",
"lb.resetNote": "वर्तमान वर्ष का लीडरबोर्ड — हर 1 जनवरी को रीसेट होता है।",
"lb.returned": "वापस किया गया",
"lb.share": "लीडरबोर्ड साझा करें",
"lb.shareText": "Findloop पर शीर्ष खोजकर्ताओं का लीडरबोर्ड देखें!",
"lb.subtitle": "प्रत्येक वापसी अंक अर्जित करती है। लीडरबोर्ड हर 1 जनवरी को रीसेट होता है।",
"lb.tabFinders": "खोजकर्ता",
"lb.tabPartners": "संस्थापन",
"lb.title": "शीर्ष खोजकर्ता",
"lost.b2bDesc": "क्या इसे होटल, परिवहन हब या साझेदार स्थल में खो दिया? संस्थान खोजें और अपनी हानि की रिपोर्ट करें।",
"lost.b2bTitle": "साझेदार को रिपोर्ट करें",
"lost.b2cDesc": "एक सार्वजनिक विज्ञापन प्रकाशित करें जो हर किसी के लिए दृश्य हो, इनाम दें और इसे बढ़ावा दें ताकि आपके अवसर अधिकतम हों।",
"lost.b2cTitle": "एक सार्वजनिक विज्ञापन पोस्ट करें",
"lost.desc": "चुनें कि आप कैसे आगे बढ़ना चाहेंगे।",
"lost.title": "क्या आपने एक आइटम खो दिया है?",
"map.allCategories": "सभी श्रेणियाँ",
"map.clear": "रीसेट",
"map.exitFullscreen": "बंद करें",
"map.filterCity": "शहर या देश...",
"map.fullscreen": "पूर्ण स्क्रीन",
"map.heatmap": "हीटमैप",
"map.high": "उच्च",
"map.impactMonth": "इस महीने लौटाए गए आइटम",
"map.impactTotal": "कुल लौटाए गए",
"map.legend": "लौटाने की दर के आधार पर लाल (कम) से हरे (ज्यादा) में रंगीन बिंदु; आकार आइटम की संख्या के अनुसार।",
"map.locating": "स्थान खोज रहे हैं... अपने प्रतिष्ठानों के लिए एक पता जोड़ें ताकि आप इसे मैप पर देख सकें।",
"map.low": "कम",
"map.mAll": "सभी",
"map.mFound": "मिला",
"map.mLost": "खोया",
"map.medium": "मध्यम",
"map.noItemRegistered": "कोई आइटम पंजीकृत नहीं है",
"map.noItems": "कोई आइटम नहीं",
"map.period30": "पिछले 30 दिन",
"map.period7": "पिछले 7 दिन",
"map.period90": "पिछले 90 दिन",
"map.periodAll": "सभी समय",
"map.returnedSuffix": "लौटाए गए · {a}/{t} आइटम",
"map.stats": "शहर के आँकड़े",
"map.statsTop": "शीर्ष 5 स्थान (खोए हुए आइटम)",
"map.statsTrend": "6-महीने का ट्रेंड",
"map.title": "आपके प्रतिष्ठानों का मानचित्र",
"map.topPlaces": "लोकप्रिय स्थान",
"mc.adClosed": "सूची बंद",
"mc.addPhoto": "एक फोटो जोड़ें",
"mc.adsNone": "कोई खोई हुई आइटम विज्ञापन नहीं है।",
"mc.archiveHide": "इतिहास छिपाएँ",
"mc.archiveNone": "अभी तक कोई हल किया गया मामला नहीं है।",
"mc.archiveShow": "इतिहास दिखाएँ",
"mc.archiveSub": "हल किए गए और लौटाए गए मामले।",
"mc.archiveTitle": "इतिहास",
"mc.at": "पर",
"mc.backToLogin": "लॉगिन पर वापस जाएं",
"mc.boostContacts": "संपर्क (बूस्ट)",
"mc.boostViews": "दृश्य (बूस्ट)",
"mc.cancel": "रद्द करें",
"mc.certificate": "प्रमाण पत्र",
"mc.changePhoto": "फोटो बदलें",
"mc.city": "शहर",
"mc.closeAd": "बंद करें",
"mc.closeAdConfirm": "क्या आप इस सूची को बंद करना चाहते हैं? यह अब दृश्य में नहीं रहेगा और एक स्लॉट खाली करेगा।",
"mc.confirmPassword": "पासवर्ड की पुष्टि करें",
"mc.confirmRestitution": "लौटाने की पुष्टि करें",
"mc.connect": "जोड़ें",
"mc.contacts": "संपर्क",
"mc.country": "देश",
"mc.declareFound": "एक मिला हुआ आइटम रिपोर्ट करें",
"mc.declareFoundSub": "आपने जो आइटम पाया है उसे पोस्ट करें",
"mc.declareLost": "खोने की रिपोर्ट करें",
"mc.declareLostSub": "खोई हुई आइटम सूची डालें",
"mc.deleteAccount": "मेरा खाता हटाएं",
"mc.deleteConfirm": "हां, मेरा खाता हटाएं",
"mc.deleteConfirmBody": "आपका खाता स्थायी रूप से हटा दिया जाएगा और आपका व्यक्तिगत डेटा अनामित किया जाएगा। यह क्रिया पूर्ववत नहीं की जा सकती।",
"mc.deleteConfirmTitle": "अपने खाते को हटाएं?",
"mc.deleteDesc": "आपका खाता स्थायी रूप से हटा दिया जाएगा और आपका व्यक्तिगत डेटा गुमनाम कर दिया जाएगा। यह कार्रवाई अपारणीय है।",
"mc.deleted": "आपका खाता हटा दिया गया है।",
"mc.deleting": "हटाया जा रहा है…",
"mc.email": "ईमेल",
"mc.expiresOn": "समाप्ति तारीख",
"mc.exportData": "मेरे डेटा को डाउनलोड करें (GDPR)",
"mc.exportDone": "आपका डेटा डाउनलोड किया गया है।",
"mc.exporting": "तैयारी कर रहे हैं…",
"mc.finderAccepted": "स्वीकृत",
"mc.finderProfile": "फाइंडर प्रोफ़ाइल (वैकल्पिक)",
"mc.finderProfileDesc": "आइटम लौटाकर अंक अर्जित करें और सार्वजनिक लीडरबोर्ड पर प्रदर्शित हों।",
"mc.forYourAd": "आपकी लिस्टिंग के लिए",
"mc.forgotLink": "पासवर्ड भूल गए?",
"mc.forgotSend": "लिंक भेजें",
"mc.forgotSent": "यदि इस ईमेल के लिए एक खाता है, तो एक रीसेट लिंक अभी भेजा गया है।",
"mc.forgotTitle": "पासवर्ड भूल गए",
"mc.foundAdsNone": "कोई फाउंड-आइटम लिस्टिंग प्रकाशित नहीं है।",
"mc.foundAt": "यहां मिला",
"mc.foundNone": "कोई फाउंड आइटम रिपोर्ट नहीं किया गया।",
"mc.hAd": "खोई हुई विज्ञापन",
"mc.hDeclaration": "घोषणा",
"mc.hFinderContact": "रिपोर्ट की गई वस्तु",
"mc.hFound": "लौटी हुई वस्तु",
"mc.hFoundAd": "मिला विज्ञापन",
"mc.histEarned": "वस्तु लौटाई गई",
"mc.historyTitle": "मेरे अंकों का इतिहास",
"mc.loginBtn": "लॉग इन करें",
"mc.loginTitle": "ग्राहक लॉगिन",
"mc.logout": "लॉग आउट करें",
"mc.lostAt": "खोया यहां",
"mc.matchPartner": "एक भागीदार पर",
"mc.matchPublic": "मिली हुई वस्तु",
"mc.matches": "मेल खाता है",
"mc.matchesSub": "मिली हुई वस्तुएं आपकी खोई हुई वस्तुओं की लिस्टिंग से मेल खा सकती हैं।",
"mc.myAds": "मेरे खोई हुए वस्तुओं के विज्ञापन",
"mc.myDeclarations": "मेरी रिपोर्ट",
"mc.myFinds": "मुझे मिली वस्तुएं",
"mc.myFindsNone": "आपने अभी तक किसी वस्तु के मिल जाने की रिपोर्ट नहीं की है।",
"mc.myFindsSub": "खोई हुई वस्तुओं के विज्ञापनों पर मिलने वाली वस्तुएं।",
"mc.myFound": "रिपोर्ट की गई मिली हुई वस्तुएं",
"mc.myFoundAds": "मेरी मिली हुई वस्तुओं की लिस्टिंग",
"mc.myRewards": "मेरे वाउचर",
"mc.name": "पूरा नाम",
"mc.newPassword": "नया पासवर्ड",
"mc.none": "अभी तक कोई रिपोर्ट नहीं।",
"mc.notEnough": "पर्याप्त अंक नहीं",
"mc.notifEmpty": "अभी तक कोई सूचना नहीं।",
"mc.notifOpen": "देखें",
"mc.notifTitle": "सूचनाएं",
"mc.notifTrack": "ट्रैक करें",
"mc.notifViewAd": "विज्ञापन देखें",
"mc.optInDesc": "वैकल्पिक भागीदारी। आप नीचे चयनित वस्तुओं को सार्वजनिक रूप से प्रदर्शित करने के लिए सहमति देते हैं। किसी भी समय परिवर्तनीय।",
"mc.optInTitle": "सार्वजनिक लीडरबोर्ड पर दिखें",
"mc.password": "पासवर्ड",
"mc.passwordMismatch": "पासवर्ड मेल नहीं खाते।",
"mc.phone": "फोन",
"mc.photoUpdated": "प्रोफाइल चित्र अपडेट किया गया",
"mc.pointsAwaiting": "अंक लंबित",
"mc.pointsBalance": "खर्च करने के लिए अंक",
"mc.pointsOk": "अंक जमा किए गए",
"mc.presentHint": "इस QR को पार्टनर को दिखाएं: वे इसे स्कैन करके आपके पुरस्कार को मान्य करते हैं।",
"mc.presentInStore": "स्टोर में दिखाएं",
"mc.presentTitle": "इस वाउचर को दिखाएं",
"mc.privacy": "गोपनीयता और डेटा",
"mc.privacyDesc": "Findloop द्वारा आपके बारे में रखे गए सभी व्यक्तिगत डेटा की एक प्रति डाउनलोड करें (GDPR, लेख 15 और 20)।",
"mc.profileSaved": "प्रोफ़ाइल अपडेट की गई।",
"mc.profileSettings": "सार्वजनिक प्रोफ़ाइल और लीडरबोर्ड",
"mc.pseudo": "पहला नाम या उपनाम",
"mc.redExpired": "समाप्त",
"mc.redReady": "पार्टनर को दिखाएं",
"mc.redUsed": "उपयोग किया गया",
"mc.redeem": "भुगतान करें",
"mc.registerBtn": "मेरा खाता बनाएं",
"mc.registerTitle": "एक ग्राहक खाता बनाएं",
"mc.rememberMe": "मुझे याद रखें",
"mc.remove": "हटाएं",
"mc.resetDone": "पासवर्ड अपडेट किया गया। आप अब लॉग इन कर सकते हैं।",
"mc.resetExpired": "यह रीसेट लिंक अमान्य या समाप्त हो गया है। नीचे एक नया अनुरोध करें।",
"mc.resetSave": "मेरा पासवर्ड रीसेट करें",
"mc.resetTitle": "नया पासवर्ड",
"mc.restitutionConfirmed": "वापसी की पुष्टि हो गई।",
"mc.reward": "इनाम",
"mc.rewardRedeemed": "इनाम अनलॉक किया गया! कोड:",
"mc.rewardsDesc": "अपने पॉइंट्स का उपयोग हमारे पार्टनर द्वारा पेश किए गए लाभों के लिए करें। बैलेंस:",
"mc.rewardsNone": "अभी कोई पुरस्कार उपलब्ध नहीं है।",
"mc.rewardsTitle": "मेरे पॉइंट्स खर्च करें",
"mc.scoreAwarded": "बहुत अच्छा! आपके फ़ाइंडर स्कोर में +1 🎉",
"mc.scoreEarned": "पॉइंट अर्जित किया",
"mc.scorePts": "pts",
"mc.scoreThisYear": "इस वर्ष",
"mc.scoreTitle": "फाइंडर स्कोर",
"mc.seeRanking": "लीडरबोर्ड देखें",
"mc.share": "शेयर करें",
"mc.statsTitle": "आ statistics",
"mc.subtitle": "एक जगह में अपने सभी रिपोर्टों को ट्रैक करें।",
"mc.title": "मेरा खाता",
"mc.toLogin": "क्या आपने पहले से पंजीकरण कराया है?",
"mc.toRegister": "अभी तक कोई खाता नहीं?",
"mc.track": "ट्रैक करें",
"mc.views": "दृश्य",
"mc.visCity": "शहर",
"mc.visCountry": "देश",
"mc.visLabel": "लीडरबोर्ड पर दिखने वाली वस्तुएं:",
"mc.visName": "पहला नाम / उपनाम",
"mc.visPhoto": "प्रोफ़ाइल फ़ोटो",
"mc.welcome": "नमस्ते",
"mc2.acceptFinder": "इस फ़ाइंडर को स्वीकार करें",
"mc2.accountActivity": "खाते की गतिविधि",
"mc2.adsActive": "{n}/5 सक्रिय विज्ञापन",
"mc2.autoDelete": "स्वचालित हटाना अनुसूचित है",
"mc2.badgeBronze": "कांस्य",
"mc2.badgeGold": "सोना",
"mc2.badgeSilver": "चाँदी",
"mc2.boostEarnedAlready": "इसने पहले ही आपको कमाई की है",
"mc2.boostEarnedWin": "इसने आपको कमाई की है",
"mc2.boostExpiredWin": "आपका बूस्ट अभी समाप्त हो गया - 20% पर फिर से शुरू करें!",
"mc2.boostExpiresIn": "आपका बूस्ट समाप्त होगा",
"mc2.boostWinDetail2": ". यदि आप 24 घंटे के भीतर नवीनीकरण करते हैं तो -20% स्वचालित रूप से लागू होता है।",
"mc2.claimCode": "कोड प्राप्त करें:",
"mc2.codeSentFinder": "कोड ईमेल द्वारा फ़ाइंडर को भेजा गया",
"mc2.daysShort": "{n} दिन",
"mc2.downloadReceipt": "अपना रसीद डाउनलोड करें",
"mc2.error": "त्रुटि {status}",
"mc2.finderAccepted": "फाइंडर स्वीकार किया गया - कोड ईमेल द्वारा भेजा गया",
"mc2.finderContacts": "फाइंडर(ों) की संपर्क जानकारी",
"mc2.followFindo": "Findloop का पालन करें",
"mc2.imgInvalid": "अमान्य छवि",
"mc2.inactivityNote": " - {n} महीनों की inactivity की स्थिति में (GDPR)।",
"mc2.lastActivity": "अंतिम गतिविधि:",
"mc2.lostEmailTitle": "मेरे पास अब मेरे ईमेल तक पहुंच नहीं है",
"mc2.noPhotoPreset": "अभी तक कोई फोटो नहीं? एक डिफ़ॉल्ट अवतार चुनें:",
"mc2.paidViaPartner": "भुगतान किया गया (साझेदार के माध्यम से)",
"mc2.payRecovery": "रिकवरी शुल्क का भुगतान करें",
"mc2.paySettle": "मेरी भुगतान निपटाएं",
"mc2.payShipping": "शिपिंग शुल्क का भुगतान करें",
"mc2.payUnavailable": "भुगतान अनुपलब्ध",
"mc2.peopleFound": "{n} व्यक्ति(ों) को लगता है कि उन्होंने आपकी वस्तु पाई है",
"mc2.phoneNumber": "फोन नंबर",
"mc2.reactivateAccount": "मेरे खाते को पुनः सक्रिय करें",
"mc2.reactivated": "खाता पुनः सक्रिय किया गया",
"mc2.reactivatedThanks": "खाता पुनः सक्रिय किया गया - आपकी निष्ठा के लिए धन्यवाद!",
"mc2.recoverSmsBtn": "SMS द्वारा मेरा कोड प्राप्त करें",
"mc2.recoverSmsDesc": "अपने खाते पर पंजीकृत नंबर पर SMS द्वारा अपना दावा कोड प्राप्त करें।",
"mc2.recoverSmsFallback": "यदि इस नंबर के साथ खाता मौजूद है, तो एक SMS भेजा गया है।",
"mc2.renewStayTop": ". शीर्ष पर रहने और अपनी वस्तु को पुनः प्राप्त करने के लिए नवीनीकरण करें।",
"mc2.resume20": "फिर से शुरू करें -20%",
"mc2.unlockContacts": "संपर्क विवरण अनलॉक करें",
"mc2.unlockDesc": "हस्तांतरण की व्यवस्था करने के लिए उनके संपर्क विवरण प्रकट करने के लिए Findloop हैंडलिंग शुल्क का भुगतान करें।",
"mc2.viewsWord": "दृश्य",
"mc2.live": "लाइव",
"mh.allCategories": "सभी कैटेगरी",
"mh.allPeriod": "सभी समय",
"mh.autoMatch": "स्वतः AI मिलान",
"mh.blocked": "रोका गया (विरोधाभास)",
"mh.blockedReason": "मिलान रोका गया: वस्तु के मुख्य कीवर्ड और घोषणा एक-दूसरे के विरोधाभासी हैं।",
"mh.days30": "अंतिम 30 दिन",
"mh.days7": "अंतिम 7 दिन",
"mh.days90": "अंतिम 90 दिन",
"mh.emptyDesc": "AI मिलान यहां दिखाई देगा जैसे-जैसे घोषणाएं आती हैं।",
"mh.emptyTitle": "कोई घटनाएं नहीं",
"mh.exportCsv": "CSV निर्यात करें",
"mh.exportDone": "CSV निर्यात डाउनलोड किया गया",
"mh.exportImpossible": "निर्यात असंभव",
"mh.fBlocked": "ब्लॉक किया गया",
"mh.fConfirmed": "पुष्टि की गई",
"mh.fRejected": "रद्द किया गया",
"mh.objectLabel": "वस्तु:",
"mh.refresh": "ताज़ा करें",
"mh.rejected": "रद्द किया गया",
"mh.srcManual": "मैनुअल",
"mh.srcText": "पाठ",
"mh.srcVisual": "दृश्य (फोटो)",
"mh.subtitle": "AI द्वारा प्रस्तावित मिलानों का लॉग - स्वचालित रूप से मिलान, पुष्टि की गई और अस्वीकार की गई।",
"mh.title": "AI इतिहास",
"nav.ads": "खोई हुई वस्तुएं",
"nav.dashboard": "मेरी जगह",
"nav.found": "पाई गई वस्तुएं",
"nav.how": "यह कैसे काम करता है",
"nav.login": "लॉगिन करें",
"nav.map": "मानचित्र",
"nav.more": "और अधिक",
"nav.partners": "साझेदार",
"nav.pricing": "मूल्य निर्धारण",
"nav.ranking": "लीडरबोर्ड",
"nav.register": "साझेदार बनें",
"nav.track": "घोषणा को ट्रैक करें",
"nf.desc": "जिस पृष्ठ की आप तलाश कर रहे हैं वह अस्तित्व में नहीं है या स्थानांतरित कर दिया गया है।",
"nf.home": "मुख्य पृष्ठ पर वापस जाएं",
"nf.title": "पृष्ठ नहीं मिला",
"par.allCities": "सभी शहर",
"par.allCountries": "सभी देश",
"par.badge": "निर्देशिका",
"par.certified": "प्रमाणित",
"par.certifiedBadge": "प्रमाणित",
"par.cityPh": "शहर",
"par.declare": "रिपोर्ट करें",
"par.none": "कोई साझेदार नहीं मिला।",
"par.partnerBadge": "साझेदार",
"par.searchPh": "एक प्रतिष्ठान खोजें…",
"par.subtitle": "उस प्रतिष्ठान को खोजें जहाँ आपने अपना आइटम खोया और अपनी हानि की रिपोर्ट करें।",
"par.title": "हमारे साझेदार",
"pay.addr1": "पता",
"pay.addr2": "पता लाइन 2 (वैकल्पिक)",
"pay.addrIncomplete": "कृपया अपना डिलीवरी पता भरें।",
"pay.badge": "पुनर्प्राप्ति",
"pay.card": "कार्ड द्वारा भुगतान करें",
"pay.city": "शहर",
"pay.country": "देश",
"pay.eurNote": "राशियाँ यूरो (€) में दर्शायी गई हैं।",
"pay.fee": "पुनर्प्राप्ति शुल्क",
"pay.free": "नि:शुल्क",
"pay.howRecover": "आप अपना आइटम वापस पाने के लिए क्या तरीका अपनाना चाहेंगे?",
"pay.momo": "मोबाइल मनी द्वारा भुगतान करें",
"pay.momoConfirm": "भुगतान की पुष्टि करें",
"pay.noMatch": "इस रिपोर्ट के लिए अभी तक कोई मेल खाते आइटम की पुष्टि नहीं हुई है।",
"pay.notfound": "रिपोर्ट नहीं मिली।",
"pay.phonePh": "फोन नंबर",
"pay.pickup": "व्यक्तिगत रूप से उठाएँ",
"pay.pickupDesc": "पर",
"pay.postal": "पोस्टल कोड",
"pay.secure": "सुरक्षित भुगतान",
"pay.serviceFee": "Findloop सेवा शुल्क",
"pay.ship": "मुझे भेजें",
"pay.shipAfter": "— भुगतान के बाद प्रदान किया जाएगा।",
"pay.shipDesc": "मेरे पते पर डिलीवरी",
"pay.shipNote": "शिपिंग उपलब्ध",
"pay.shipping": "शिपिंग शुल्क",
"pay.subtitleWith": "पुनर्प्राप्ति शुल्क का भुगतान करें",
"pay.title": "मेरा आइटम पुनर्प्राप्त करें",
"pay.total": "कुल",
"pcat.city_hall": "नगर निगम",
"pcat.hotel": "होटल",
"pcat.other": "अन्य",
"pcat.park": "पार्क",
"pcat.prefecture": "प्रिफेक्चर",
"pcat.restaurant": "रेस्टोरेंट",
"pcat.uncategorized": "श्रेणीबद्ध नहीं",
"pd.about": "के बारे में",
"pd.back": "सभी साझेदार",
"pd.certified": "प्रमाणित साझेदार",
"pd.declare": "यहाँ हानि की रिपोर्ट करें",
"pd.itemsReturned": "वापस किए गए आइटम",
"pd.itemsTotal": "पंजीकृत आइटम",
"pd.map": "स्थान",
"pd.noItems": "हाल ही में कोई आइटम नहीं मिला।",
"pd.noReviews": "अभी तक कोई समीक्षा नहीं।",
"pd.notFound": "साझेदार नहीं मिला।",
"pd.recentItems": "हाल में मिले आइटम",
"pd.reply": "संस्थान से जवाब",
"pd.reviews": "ग्राहक समीक्षाएँ",
"pd.verified": "सत्यापित समीक्षा",
"pd.verifiedEstablishment": "Findloop सत्यापित संस्थान",
"pg.next": "अगला",
"pg.prev": "पिछला",
"pg.showing": "{from}–{to} מתוך {total}",
"pk.bodyCopy": "बॉडी कॉपी",
"pk.bodyText": "बॉडी टेक्स्ट",
"pk.brandColors": "ब्रांड रंग",
"pk.colorRed": "लाल",
"pk.colorWhite": "सफेद",
"pk.darkBg": "गहरे पृष्ठभूमि",
"pk.download": "डाउनलोड",
"pk.downloadZip": "पूरा किट डाउनलोड करें (ZIP)",
"pk.headings": "हेडिंग्स",
"pk.heroDesc": "आधिकारिक लोगो, सोशल मीडिया बैनर, रंग और टाइपोग्राफी। टैगलाइन भाषा और रूप चुनें, फिर दृश्य या पूरा किट डाउनलोड करें।",
"pk.lightBg": "हल्की पृष्ठभूमि (प्रिंट)",
"pk.logoWordmark": "लोगो / शब्दचिह्न",
"pk.logosVisuals": "लोगो और दृश्य",
"pk.mapCollect": "मैप / संग्रह बिंदु",
"pk.plain": "सादा",
"pk.pressKit": "प्रेस किट",
"pk.taglineLang": "टैगलाइन भाषा",
"pk.typography": "टाइपोग्राफी",
"pk.variant": "रूप",
"pr.shipBtn": "आइटम भेजें",
"pr2.adBoostMsg": "शानदार चयन! आप अपने आइटम को जल्दी वापस पाने के अपने अवसर बढ़ाते हैं।",
"pr2.boostActivated": "बूस्ट सक्रिय किया गया!",
"pr2.canRecoverNow": "आप अब अपने आइटम को वापस पा सकते हैं।",
"pr2.continue": "जारी रखें",
"pr2.downloadReceiptPdf": "रसीद डाउनलोड करें (PDF)",
"pr2.goToSpaceNow": "अब मेरे खाते पर जाएं",
"pr2.partnerBoostMsg": "शानदार चयन! अधिक दिखाई देना आपके संस्थान के लिए नए ग्राहकों को आकर्षित करने का मतलब है।",
"pr2.paymentSuccess": "भुगतान सफल!",
"pr2.redirectingSpace": "आपके खाते की ओर रीडायरेक्ट किया जा रहा है…",
"pr2.subActivated": "भुगतान सफल! आपकी सदस्यता सक्रिय है, आप अब अपने संस्थानों का प्रबंधन कर सकते हैं।",
"prev.allSites": "सभी संस्थान",
"prev.editReply": "जवाब संपादित करें",
"prev.none": "अभी तक कोई समीक्षा नहीं।",
"prev.published": "जवाब प्रकाशित",
"prev.reply": "जवाब",
"prev.replyPh": "एक शिष्ट जवाब लिखें…",
"prev.send": "जवाब प्रकाशित करें",
"prev.sending": "प्रकाशित हो रहा है…",
"prev.yourReply": "आपका जवाब",
"pricing.annual": "वार्षिक",
"pricing.annualBadge": "-20% ऑफर",
"pricing.choose": "चुनें",
"pricing.compareFeature": "विशेषता",
"pricing.compareTitle": "योजनाओं की तुलना करें",
"pricing.eyebrow": "मूल्य निर्धारण",
"pricing.month": "/महीना",
"pricing.monthly": "मासिक",
"pricing.perYear": "/वर्ष",
"pricing.popular": "लोकप्रिय",
"pricing.quoteMsg": "आपकी आवश्यकताएँ (ऐच्छिक)",
"pricing.quoteOrg": "संस्थान",
"pricing.quoteSend": "अनुरोध भेजें",
"pricing.quoteSent": "अनुरोध भेजा गया! हम आपको शीघ्र ही उत्तर देंगे।",
"pricing.quoteSites": "साइटों / टर्मिनलों की संख्या",
"pricing.quoteTitle": "कोट के लिए अनुरोध करें",
"pricing.requestQuote": "कोट के लिए अनुरोध करें",
"pricing.saveLabel": "आपकी बचत",
"pricing.savePerYear": "/वर्ष प्रति अतिरिक्त स्थापना",
"pricing.start": "शुरू करें",
"pricing.subtitle": "सुरू करें फ्री, जैसे-जैसे आप बढ़ें।",
"pricing.title": "हर संगठन के लिए एक योजना",
"promo.badge": "भागीदार कार्यक्रम",
"promo.cta": "और जानें",
"promo.text": "हर भागीदार जिसे आप संदर्भित करते हैं जो सदस्यता लेता है, आपको एक मुफ्त महीना देता है। कोई सीमा नहीं।",
"promo.title": "एक भागीदार को संदर्भित करें, एक मुफ्त महीना प्राप्त करें।",
"pub.accessGranted": "पहुँच दी गई",
"pub.accessLimited2h": "पहुँच 2 घंटों के लिए सीमित",
"pub.accountEmailConcerned": "संबंधित खाते की ईमेल",
"pub.adAppearPublic": "आपका विज्ञापन सार्वजनिक रूप से ऐसा दिखाई देगा।",
"pub.adPreviewBtn": "विज्ञापन पूर्वावलोकन",
"pub.alertMeOnArrival": "आगमन पर मुझे सूचित करें",
"pub.allActionsLogged": "सभी कार्रवाइयाँ लॉग की गई हैं",
"pub.allCategories": "सभी श्रेणियाँ",
"pub.authorizeAccess": "पहुँच की अनुमति दें",
"pub.authorizeSupportQ": "सहायता पहुँच की अनुमति दें?",
"pub.available": "उपलब्ध",
"pub.backHome": "घर पर वापस जाएँ",
"pub.boostAdCta": "मेरे विज्ञापन को बढ़ावा दें",
"pub.boostAdTitle": "अपने विज्ञापन को बढ़ावा दें",
"pub.boostCarouselSub": "“बढ़ाए गए” कैरोसेल में पृष्ठ के शीर्ष पर जाएं और अपने आइटम को तेजी से पुनर्प्राप्त करने के लिए व्यूज को बढ़ाएं।",
"pub.boostEstablishment": "अपने प्रतिष्ठान को बढ़ावा दें",
"pub.boostEstablishmentDesc": "एक “बढ़ाए गए” बैज के साथ निर्देशिका के शीर्ष पर दिखाई दें और अधिक रिपोर्ट्स आकर्षित करें।",
"pub.boostFicheCta": "मेरी लिस्टिंग को बढ़ावा दें",
"pub.brandReady": "Findloop ब्रांड, उपयोग के लिए तैयार",
"pub.cantFindItem": "आपका आइटम नहीं मिल रहा?",
"pub.cantProcessImage": "इस छवि को संसाधित नहीं किया जा सका",
"pub.claimQr": "QR कोड का दावा करें",
"pub.clickToZoom": "ज़ूम करने के लिए क्लिक करें",
"pub.codeAlreadyValidated": "कोड मान्य किया गया — संपर्क अनलॉक किए गए।",
"pub.codeExample": "जैसे: ABCD2345",
"pub.confirmRenewal": "नवीनीकरण की पुष्टि करें",
"pub.contactIntro": "कोई प्रश्न, कोई अनुरोध? हमसे लिखें, हम शीघ्र ही आपको उत्तर देंगे।",
"pub.contactTypeDeceased": "खाते की हटाना (अवसादित व्यक्ति)",
"pub.contactTypeGeneral": "सामान्य प्रश्न",
"pub.contactTypeSupport": "सहायता / तकनीकी समस्या",
"pub.contactUs": "हमसे संपर्क करें",
"pub.continueWithoutEmail": "मेरी ईमेल छोड़े बिना जारी रखें",
"pub.contractLabel": "संविदा",
"pub.contractNotFound": "संविदा नहीं मिली या पहले से ही समाप्त हो गई।",
"pub.contractRenewed": "संविदा नवीनीकरण किया गया!",
"pub.contractRenewedFor": "आपकी संविदा {n} महीनों के लिए नवीनीकरण किया गया है।",
"pub.copyFailed": "कॉपी विफल",
"pub.createPartnerAccount": "मेरा भागीदार खाता बनाएं",
"pub.currentDeadline": "वर्तमान समय सीमा",
"pub.deceasedInfo": "एक रिश्तेदार या वारिस के रूप में, आप एक मृत व्यक्ति के Findloop खाते को हटाने का अनुरोध कर सकते हैं। हम आपके अनुरोध को GDPR के अनुपालन में संसाधित करेंगे (समर्थन दस्तावेजों की मांग की जा सकती है)।",
"pub.declareMyLoss": "मेरी हानि की रिपोर्ट करें",
"pub.describeItemPlaceholder": "अपनी वस्तु का विवरण दें (जैसे काला छाता, चाबी…)",
"pub.downloadImage": "छवि डाउनलोड करें",
"pub.drawSignature": "कृपया अपना हस्ताक्षर.draw करें।",
"pub.drawSignatureHint": "अपने हस्ताक्षर को माउस या ऊंगली से.draw करें।",
"pub.duration": "अवधि",
"pub.eSignature": "इलेक्ट्रॉनिक हस्ताक्षर",
"pub.eSignatureDesc": "हस्ताक्षर करने के लिए अपना नाम दर्ज करें। तारीख अपने आप रिकॉर्ड हो जाएगी।",
"pub.edit": "संपादित करें",
"pub.editorialTitles": "संपादकीय शीर्षक",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "स्वामी का संपर्क विवरण अनलॉक करने के लिए ईमेल द्वारा प्राप्त कोड डालें।",
"pub.errorWord": "त्रुटि",
"pub.foundSelfService": "मिल गए आइटम · खुद की सेवा",
"pub.haveOwnerCode": "मुझे मालिक से कोड मिला",
"pub.home": "घर",
"pub.immediateRenewal": "तत्काल नवीकरण, बिना नए कोट के।",
"pub.impAdminReq1": "Administrator",
"pub.impAdminReq2": "आपके खाते तक अस्थायी रूप से पहुंचने की अनुमति मांगता है",
"pub.impAdminReq3": "आपकी सहायता करने के लिए।",
"pub.impGrantedDesc": "समर्थन टीम आपके खाते तक अधिकतम 2 घंटे तक पहुंच सकेगी। हर क्रिया का लॉग किया जाएगा। आप इस पृष्ठ को बंद कर सकते हैं।",
"pub.invitedOnFindo": "आपको Findloop में आमंत्रित किया गया है",
"pub.isThisYourItem": "क्या यह आपकी वस्तु है?",
"pub.itemsAvailableCount": "{n} आइटम(s) वर्तमान में उपलब्ध",
"pub.itemsFoundOwner": "आवंटित आइटम के मालिक मिले",
"pub.itemsReturnedOwners": "आइटम अपने मालिकों को लौटाए गए",
"pub.itsMine": "यह मेरा है",
"pub.joinFindoDesc": "Findloop से जुड़ें और आसानी से अपने मिले हुए आइटम का प्रबंधन करें।",
"pub.joinInvitesYou": "आपको Findloop में शामिल होने के लिए आमंत्रित करता है। अपने मिले हुए आइटम का प्रबंधन करने के लिए अपना साझेदार खाता बनाएं।",
"pub.linkCopied": "लिंक कॉपी किया गया!",
"pub.loadingContract": "संविदा लोड हो रही है…",
"pub.lsClaimDesc": "अपनी हानि की रिपोर्ट करें ताकि आप इसे पुनः प्राप्त कर सकें। अपनी ईमेल छोड़ें और यदि आपकी रिपोर्ट पूर्ण नहीं हुई है तो हम आपको एक अनुस्मारक भेजेंगे।",
"pub.lsHeroDesc": "अपने आप जांचें कि क्या आपकी खोई हुई वस्तु मिली है और यहां छोड़ दी गई है। मिला? इसे पुनः प्राप्त करने के लिए रिपोर्ट करें।",
"pub.lsSearchTitle": "मिले हुए आइटम के लिए खोजें",
"pub.makeOffer": "ऑफर बनाएं",
"pub.makeOfferDesc": "अपनी राशि का प्रस्ताव करें। सुपरadmin इसे समीक्षा करेगा।",
"pub.mapNearYou": "आपके पास आइटम और साझेदार",
"pub.mapWord": " मानचित्र",
"pub.messageSentToast": "संदेश भेज दिया गया - हमारी टीम शीघ्र ही उत्तर देगी।",
"pub.messageWord": "संदेश",
"pub.momoInitiated": "मोबाइल मनी भुगतान शुरू किया गया",
"pub.monthsWord": "महीने",
"pub.nameConsentRequired": "नाम और सहमति आवश्यक है।",
"pub.newDeadline": "नई समय-सीमा",
"pub.noActionRequired": "कोई कार्रवाई की आवश्यकता नहीं है।",
"pub.noAmountCharged": "कोई राशि चार्ज नहीं की गई।",
"pub.noItemMatch": "आपकी खोज से मेल खाने वाला कोई उपलब्ध आइटम नहीं है।",
"pub.noMatchingItem": "कोई मेल खाने वाला आइटम नहीं",
"pub.noPaymentSession": "कोई भुगतान सत्र नहीं।",
"pub.noPhoto": "कोई फोटो नहीं",
"pub.noPointsYet": "अभी तक दिखाने के लिए कोई अंक नहीं।",
"pub.noSecondPayment": "इस आइटम के लिए कोई दूसरी भुगतान की आवश्यकता नहीं है।",
"pub.notHereYet": "अभी यहाँ नहीं? इसे आने पर सूचित करें।",
"pub.notifyDone": "नोट किया गया! जैसे ही कोई मेल खाने वाला आइटम आएगा, हम आपको ईमेल द्वारा सूचित करेंगे।",
"pub.offerSubmitted": "आपका ऑफर प्रस्तुत किया गया है।",
"pub.oops": "उफ़",
"pub.orAlertEmail": "या जैसे ही कोई मेल खाने वाला आइटम आएगा, ईमेल के द्वारा सूचित होने के लिए:",
"pub.ownerContacts": "मालिक के संपर्क विवरण",
"pub.ownerContactsUnlocked": "मालिक के संपर्क विवरण अनलॉक किए गए",
"pub.partnerContact": "साझेदार संपर्क",
"pub.payLinkUnavailable": "भुगतान लिंक उपलब्ध नहीं है - साझेदार से संपर्क करें।",
"pub.paymentCancelled": "भुगतान रद्द कर दिया गया",
"pub.paymentConfirmed": "भुगतान की पुष्टि हो गई 🎉",
"pub.paymentConfirmedDesc": "आपको आपकी वस्तु को पुनः प्राप्त करने के विवरण के साथ एक ईमेल प्राप्त होगा।",
"pub.paymentNotConfirmed": "भुगतान की पुष्टि नहीं हुई",
"pub.paymentNotConfirmedDesc": "भुगतान को सत्यापित नहीं किया जा सका। पुनः प्रयास करें या भागीदार से संपर्क करें।",
"pub.paymentProcessing": "भुगतान किया जा रहा है। एक पल में रिफ्रेश करें।",
"pub.photoAdded": "✓ फोटो जोड़ी गई",
"pub.photoRequired": "वस्तु की एक फोटो आवश्यक है।",
"pub.previewAlt": "पूर्वावलोकन",
"pub.publish": "प्रकाशित करें",
"pub.publishingWord": "प्रकाशित किया जा रहा है…",
"pub.qty": "संख्या",
"pub.quoteDeclined": "कोट अस्वीकार कर दिया गया।",
"pub.quoteNotFound": "कोट नहीं मिला या समाप्त हो गया।",
"pub.reasonLabel": "कारण",
"pub.recoveryAlreadyPaid": "पुनर्प्राप्ति शुल्क पहले ही चुकाया जा चुका है",
"pub.referralCode": "रेफरल कोड:",
"pub.relationshipPlaceholder": "बेटा, जीवनसाथी, नोटरी…",
"pub.renewYourContract": "अपने अनुबंध का नवीनीकरण करें",
"pub.renewalFailed": "नवीनीकरण विफल। बाद में पुनः प्रयास करें।",
"pub.renewing": "नवीनीकरण किया जा रहा है…",
"pub.replySoon": "हमारी टीम जल्द से जल्द जवाब देगी।",
"pub.requestGone": "यह अनुरोध अब अस्तित्व में नहीं है।",
"pub.requestHandled": "अनुरोध पहले ही संभाला जा चुका है",
"pub.requestNotFound": "अनुरोध नहीं मिला या समाप्त हो गया।",
"pub.requestUnavailable": "अनुरोध उपलब्ध नहीं है",
"pub.required": "(आवश्यक)",
"pub.retroClosing": "एक साथ, हम दुनिया को थोड़ा कम खोया हुआ बनाते हैं।",
"pub.retroClosing2": "एक साथ, हम दुनिया को थोड़ा कम खोया हुआ बनाते हैं।",
"pub.retroScroll": "महत्वपूर्ण चीजों को पुनः प्राप्त करने का एक वर्ष। नीचे स्क्रॉल करें ↓",
"pub.revokeAnytime": "आप किसी भी समय हमसे संपर्क करके इसे वापस ले सकते हैं",
"pub.scene": "दृश्य",
"pub.sendImpossible": "भेजना संभव नहीं है",
"pub.sendMessage": "संदेश भेजें",
"pub.sending": "भेजा जा रहा है…",
"pub.sharePreview": "पूर्वावलोकन साझा करें",
"pub.shareYourAd": "अपने विज्ञापन को साझा करें",
"pub.signedSuccess": "सफलता से हस्ताक्षर किया गया!",
"pub.signerFullName": "हस्ताक्षरकर्ता का पूरा नाम",
"pub.spreadNetwork": "अपने आस-पास के लोगों के साथ इसे साझा करें ताकि आपके अवसर बढ़ें।",
"pub.spreadOwner": "स्वामी की वस्त्र पुनः प्राप्त करने में मदद करने के लिए इसे साझा करें।",
"pub.statusLabel": "स्थिति:",
"pub.subject": "विषय",
"pub.thanksSent": "धन्यवाद, आपका संदेश भेजा गया है।",
"pub.thisYear": "इस वर्ष",
"pub.validate": "सर्वेल करें",
"pub.verifyingPayment": "भुगतान की पुष्टि की जा रही है…",
"pub.verifyingYourPayment": "आपके भुगतान की पुष्टि की जा रही है…",
"pub.viewAd": "विज्ञापन देखें →",
"pub.viewPartner": "भागीदार को देखें →",
"pub.yourAdPreview": "आपके विज्ञापन का पूर्वावलोकन",
"pub.yourEmail": "आपका ईमेल",
"pub.yourEmailRecommended": "आपका ईमेल (अनुशंसित)",
"pub.yourEmailShort": "आपका ईमेल",
"pub.yourName": "आपका नाम",
"pub.yourRelationship": "उस व्यक्ति से आपका संबंध",
"qv.acceptAndSign": "मेरे कोट को स्वीकार करें और हस्ताक्षर करें",
"qv.certifyAuthorized": "मैं प्रमाणित करता हूं कि मुझे हस्ताक्षर करने का अधिकार है और मैं इस {what} के शर्तों को स्वीकार करता हूं (बाध्यकारी मूल्य)।",
"qv.clear": "स्वच्छ करें",
"qv.client": "ग्राहक",
"qv.conditions": "शर्तें",
"qv.confirmDecline": "क्या आप इस उद्धरण का अस्वीकृति की पुष्टि करना चाहते हैं?",
"qv.countersignedFindo": "Findloop द्वारा काउंटरसाइन किया गया · {name} पर {date}",
"qv.decline": "अस्वीकृत करें",
"qv.description": "विवरण",
"qv.downloadPdf": "पीडीएफ डाउनलोड करें",
"qv.handwrittenSignature": "हस्ताक्षरित हस्ताक्षर",
"qv.inclTax": "टैक्स सहित",
"qv.invalidAmount": "अमान्य राशि।",
"qv.invoice": "चालान",
"qv.invoicePaid": "चालान भुगतान किया गया",
"qv.issuer": "जारीकर्ता",
"qv.messageOptional": "संदेश (वैकल्पिक)",
"qv.negotiatedAmount": "बातचीत की गई राशि",
"qv.payInvoiceOnline": "ऑनलाइन चालान का भुगतान करें",
"qv.quote": "उद्धरण",
"qv.quoteValidDays": "उद्धरण {n} दिनों के लिए मान्य है।",
"qv.sendMyOffer": "मेरी पेशकश भेजें",
"qv.signContract": "मेरे अनुबंध पर हस्ताक्षर करें",
"qv.signNow": "अब हस्ताक्षर करें",
"qv.signatureAlt": "हस्ताक्षर",
"qv.signedByOn": "✔ {name} द्वारा {date} पर हस्ताक्षरित",
"qv.stContractSigned": "अनुबंध हस्ताक्षरित। धन्यवाद!",
"qv.stCounterAccepted": "आपकी पेशकश स्वीकार कर ली गई है! नीचे अनुबंध पर हस्ताक्षर करें।",
"qv.stCounterRefused": "आपकी पेशकश स्वीकार नहीं की जा सकी।",
"qv.stCountered": "आपकी पेशकश प्रस्तुत कर दी गई है। Findloop की प्रतिक्रिया की प्रतीक्षा कर रहे हैं।",
"qv.stDeclined": "आपने इस उद्धरण को अस्वीकार कर दिया है।",
"qv.stSigned": "उद्धरण स्वीकार कर लिया गया और हस्ताक्षरित। धन्यवाद!",
"qv.totalHt": "कुल बिना टैक्स",
"qv.totalTtc": "कुल टैक्स सहित",
"qv.unitHt": "प्रतilit बिना टैक्स",
"qv.vat": "वैट",
"qv.yourProposedAmount": "आपकी प्रस्तावित राशि ({cur})",
"rate.chooseNote": "कृपया एक रेटिंग चुनें।",
"rate.commentPh": "एक टिप्पणी (वैकल्पिक)…",
"rate.home": "घर पर वापस जाएं",
"rate.submit": "मेरी समीक्षा सबमिट करें",
"rate.submitting": "भेज रहे हैं…",
"rate.subtitle": "आपकी वस्तु की वसूली कैसे हुई?",
"rate.successText": "आपकी प्रतिक्रिया अन्य उपयोगकर्ताओं की मदद करती है।",
"rate.successTitle": "आपकी समीक्षा के लिए धन्यवाद!",
"rate.title": "अपने अनुभव को रेट करें",
"reg.add": "एक वस्तु लॉग करें",
"reg.allBrands": "सभी ब्रांड",
"reg.allColors": "सभी रंग",
"reg.allLocations": "सभी स्थान",
"reg.detailDesc": "इस मिली हुई वस्तु के लिए विवरण और क्रियाएँ।",
"reg.dispAuction": "नीलामी",
"reg.dispAuthorities": "अधिकारियों को सौंपा गया",
"reg.dispDestroyed": "नष्ट किया गया",
"reg.dispDonate": "चैरिटी दान",
"reg.dispositionHint": "भंडारण से वस्तु को छोड़ने का रिकॉर्ड बनाएँ। श्रेणी द्वारा आंकड़ों में गिना जाता है।",
"reg.emptyCta": "एक वस्तु लॉग करें",
"reg.emptyDesc": "अपने पहले मिली हुई वस्तु को लॉग करके शुरू करें।",
"reg.emptyTitle": "कोई वस्तु नहीं मिली",
"reg.establishmentFallback": "संस्थापन",
"reg.lblAuctioned": "नीलामी में सूचीबद्ध",
"reg.lblAuctionedShort": "नीलामी में",
"reg.lblAuthorities": "अधिकारियों को सौंपा गया",
"reg.lblDestroyed": "नष्ट किया गया",
"reg.lblDonated": "एक चैरिटी को दान किया",
"reg.legalCount": "{n} वस्तु(एं): कानूनी संग्रहण अवधि समाप्त",
"reg.legalHint": "आप इन्हें नीलामी में सूचीबद्ध कर सकते हैं, एक चैरिटी को दान कर सकते हैं, या इसे अधिकारियों को सौंपने की रिपोर्ट कर सकते हैं।",
"reg.legalLimitCountry": "अवधि: {date} · लागू देश: {country}",
"reg.legalOver": "अवधि समाप्त: {date} · {country}",
"reg.legalReached": "कानूनी अवधि समाप्त",
"reg.legalReachedFull": "कानूनी संग्रहण अवधि समाप्त",
"reg.limitShort": "अवधि",
"reg.location": "स्थान",
"reg.markRestituted": "वापस के रूप में मार्क करें",
"reg.markedAs": "वस्तु को {label} के रूप में मार्क किया गया",
"reg.moveHistory": "आंदोलन इतिहास",
"reg.overBy": "{n}d द्वारा समाप्त",
"reg.physicalLocation": "भौतिक स्थान",
"reg.popupBlocked": "लेबल प्रिंट करने के लिए पॉप-अप की अनुमति दें।",
"reg.popupBlockedOne": "लेबल प्रिंट करने के लिए पॉप-अप की अनुमति दें।",
"reg.printLabel": "लेबल प्रिंट करें",
"reg.printN": "{n} लेबल(एं) प्रिंट करें",
"reg.qrCodeItem": "वस्तु QR कोड",
"reg.qrLabelTitle": "QR लेबल",
"reg.qrLabelsTitle": "QR लेबल",
"reg.qrNotFound": "इस QR कोड के लिए कोई वस्तु नहीं मिली।",
"reg.qrScanHint": "इसे स्कैन करें ताकि आप इस रिकॉर्ड को सीधे खोल सकें और स्थान ढूंढ सकें।",
"reg.recoveryFee": "रिकवरी शुल्क (€)",
"reg.searchPh": "विवरण द्वारा खोजें…",
"reg.selectQr": "QR लेबल प्रिंट करने के लिए चयन करें",
"reg.selectedN": "{n} चयनित",
"reg.shipPricePh": "शिपिंग मूल्य (€)",
"reg.shippingPossible": "शिपिंग उपलब्ध",
"reg.storagePh": "जैसे: शेल्फ A3, लॉकर 12",
"reg.tAuction": "Findloop पर नीलामी",
"reg.tAuthorities": "अधिकारियों को सौंपने की रिपोर्ट करें",
"reg.tDonate": "एक चैरिटी को दान करें",
"reg.toastFee": "शुल्क अपडेट किया गया",
"reg.toastLocation": "स्थान सुरक्षित किया गया",
"reg.toastRestituted": "वस्तु को वापस के रूप में मार्क किया गया",
"reg.toastShipping": "शिपिंग विकल्प अपडेट किया गया",
"reg.toastTransferred": "वस्तु “{name}” को स्थानांतरित की गई",
"reg.unclaimedDisposition": "अप्राप्त वस्तु — अंतिम आवंटन",
"res.codeValidated": "कोड मान्य किया गया",
"res.empty": "अभी तक कोई पुनर्प्राप्ति रिकॉर्ड नहीं किया गया।",
"res.error": "त्रुटि {status}",
"res.proofPdf": "PDF प्रमाण",
"res.signed": "हस्ताक्षरित",
"res.stRestituted": "निजी रूप से सौंपा गया",
"res.stShipped": "शिपिंग द्वारा वापस किया गया",
"res.subtitle": "सभी पूर्ण हस्तांतरण, जिनके डाउनलोड करने योग्य हस्ताक्षरित प्रमाण के साथ।",
"res.title": "पुनर्प्राप्ति इतिहास",
"rev.b2b": "B2B भागीदार",
"rev.b2c": "ग्राहक",
"rev.based": "{n} समीक्षाओं के आधार पर",
"rev.eyebrow": "साक्षात्कार",
"rev.restitutedBy": "{org} द्वारा लौटाई गई",
"rev.storiesEyebrow": "सुखद अंत",
"rev.storiesSubtitle": "वास्तविक कहानियाँ उन ग्राहकों से जिन्होंने Findloop के साथ अपनी चीजें पुनर्प्राप्त कीं।",
"rev.storiesTitle": "उन्होंने अपनी चीजें खोज लीं!",
"rev.subtitle": "भागीदार और ग्राहक अपने अनुभव साझा करते हैं।",
"rev.title": "वे Findloop पर विश्वास करते हैं",
"rev.verified": "मान्य",
"rp.already": "आपने पहले ही इस सूची की रिपोर्ट की है।",
"rp.comment": "विवरण (वैकल्पिक)",
"rp.duplicate": "नकली",
"rp.fraud": "धोखा / फ्रॉड",
"rp.inappropriate": "अयोग्य सामग्री",
"rp.offensive": "अपमानजनक सामग्री",
"rp.other": "अन्य",
"rp.reason": "कारण",
"rp.report": "रिपोर्ट",
"rp.send": "रिपोर्ट भेजें",
"rp.sent": "रिपोर्ट भेज दी गई है। आपके योगदान के लिए धन्यवाद।",
"rp.spam": "स्पैम / विज्ञापन",
"rp.title": "इस लिस्टिंग की रिपोर्ट करें",
"rp.wrongCategory": "गलत श्रेणी",
"rt.annualGoal": "वार्षिक लक्ष्य",
"rt.championCity": "चैम्पियन शहर",
"rt.cityRate": "{rate}% वापस दर",
"rt.goalProgress": "{rate}% प्राप्त हुआ {target}% लक्ष्य में",
"rt.reached": "पहुंच गया 🎉",
"rt.restitutionRate": "वापसी दर",
"rt.shareRecap": "मेरा सारांश साझा करें",
"rt.thanks": "धन्यवाद Findloop {year} 💛",
"rt.yourRecap": "आपका {year} सारांश",
"rw.active": "सक्रिय",
"rw.add": "जोड़ें",
"rw.camUnavailable": "कैमरा उपलब्ध नहीं है। नीचे कोड मैन्युअल रूप से दर्ज करें।",
"rw.codeValidated": "कोड मान्य किया गया",
"rw.codesTitle": "फाइंडर्स द्वारा भुना गए कोड",
"rw.confirmDelete": "“{title}” को हटाएं?",
"rw.deleted": "हटा दिया गया",
"rw.edit": "संपादित करें",
"rw.editReward": "इनाम संपादित करें",
"rw.empty": "अभी तक कोई इनाम नहीं।",
"rw.expired": "समय पूरा",
"rw.expiresOn": "समय सीमा {date} को समाप्त होगी",
"rw.fActive": "सक्रिय (फाइंडर्स के लिए दृश्यमान)",
"rw.fCost": "लागत (अंक)",
"rw.fDesc": "विवरण",
"rw.fStock": "स्टॉक (खाली = असीमित)",
"rw.fTitle": "शीर्षक",
"rw.inactive": "गैर-सक्रिय",
"rw.newReward": "नया इनाम",
"rw.noExchange": "अभी तक कोई भत्ता नहीं।",
"rw.pageSubtitle": "अपने इनाम की पुष्टि करने के लिए फाइंडर्स द्वारा प्रस्तुत वाउचर को स्कैन करें।",
"rw.redeemedN": "भुगतान किया गया: {n}×",
"rw.saved": "इनाम सहेजा गया",
"rw.scanVoucher": "वाउचर स्कैन करें",
"rw.staffScanOnly": "केवल स्कैन करें",
"rw.statActive": "प्रस्तुत करने के लिए",
"rw.statExpired": "समय पूरा",
"rw.statRedeemed": "भुगतान किए गए वाउचर",
"rw.statUsed": "मान्य",
"rw.stock": "स्टॉक",
"rw.subtitle": "फाइंडर्स के लिए गैर-नकद लाभ (वाउचर, अपग्रेड…) प्रदान करें जिन्हें वे अपने फाइंडर स्कोर अंक के लिए भुना सकते हैं।",
"rw.title": "फाइंडर्स के लिए पुरस्कार",
"rw.used": "उपयोग किया गया",
"rw.validate": "मान्य करें",
"rw.validateCode": "कोड की पुष्टि करें",
"rw.validity": "वैधता: {n} d",
"shell.f1d": "खोई और मिली वस्तुओं को स्वचालित रूप से लिंक करें।",
"shell.f1t": "स्मार्ट एआई मिलान",
"shell.f2d": "वास्तविक समय में वापसी दर और राजस्व को ट्रैक करें।",
"shell.f2t": "डैशबोर्ड & राजस्व",
"shell.f3d": "आपके ग्राहक 30 सेकंड में रिपोर्ट करेंगे।",
"shell.f3t": "साझेदार QR कोड",
"shell.title": "खोई हुई वस्तुओं को संतुष्ट ग्राहकों में बदलें।",
"ship.addr1": "पता",
"ship.addr2": "पता पंक्ति 2 (वैकल्पिक)",
"ship.badge": "शिपिंग",
"ship.city": "शहर",
"ship.country": "देश",
"ship.needPaid": "शिपिंग की मांग करने के लिए पहले वसूली शुल्क का भुगतान करें।",
"ship.notShippable": "यह वस्तु शिपिंग के लिए उपलब्ध नहीं है।",
"ship.notfound": "रिपोर्ट नहीं मिली।",
"ship.postal": "पोस्टल कोड",
"ship.price": "शिपिंग शुल्क",
"ship.submit": "शिपिंग का अनुरोध करें",
"ship.submitting": "भेज रहा है…",
"ship.subtitle": "अपना डिलीवरी पता दर्ज करें।",
"ship.successText": "साझेदार आपका पार्सल तैयार करेगा। जब शिप किया जाएगा, आपको सूचित किया जाएगा।",
"ship.successTitle": "शिपिंग अनुरोध भेजा गया!",
"ship.title": "अपनी वस्तु भेजें",
"ship.weight": "अनुमानित वजन (किलोग्राम)",
"shp.carrier": "कैरेयर",
"shp.download": "PDF डाउनलोड करें",
"shp.generating": "जनरेट कर रहा है…",
"shp.label": "लेबल उत्पन्न करें",
"shp.none": "कोई शिपमेंट अनुरोध नहीं किया गया।",
"shp.setTracking": "ट्रैकिंग सहेजें",
"shp.status": "स्थिति",
"shp.to": "प्राप्तकर्ता",
"shp.tracking": "ट्रैकिंग नंबर",
"shp.trackingSaved": "ट्रैकिंग सहेजा गया",
"side.account": "मेरा खाता",
"side.declarations": "रिपोर्ट",
"side.deposit": "एक वस्तु लॉग करें",
"side.establishments": "संस्थाएँ",
"side.invoices": "इनवॉइस",
"side.logout": "लॉग आउट",
"side.matchHistory": "एआई इतिहास",
"side.partner": "साझेदार",
"side.refresh": "रीफ्रेश",
"side.registry": "रजिस्ट्रा",
"side.restitutions": "वापसी",
"side.reviews": "समीक्षाएँ",
"side.rewards": "इनाम & वाउचर",
"side.settings": "सेटिंग्स",
"side.shipments": "शिपमेंट",
"side.stats": "आंकड़े",
"side.storage": "स्टोरेज & QR",
"side.team": "टीम",
"side.viewSite": "सार्वजनिक साइट देखें",
"st.auctioned": "नीलामी में बेचा गया",
"st.claimed": "अधिग्रहित",
"st.closed": "बंद",
"st.delivered": "डिलीवर किया गया",
"st.destroyed": "नष्ट",
"st.donated": "दान किया गया (चैरिटी)",
"st.handed_to_authorities": "प्राधिकरण को सौंपा गया",
"st.in_storage": "स्टोरेज में",
"st.matched": "मेल मिला",
"st.open": "खुला",
"st.paid": "भुगतान किया",
"st.pending": "लंबित",
"st.resolved": "हल किया गया",
"st.restituted": "लौटा दिया गया",
"st.second_chance": "दूसरा मौका",
"st.shipped": "भेजा गया",
"st.shipping_requested": "शिपिंग रिक्वेस्ट की गई",
"st.submitted": "सबमिट किया गया",
"st.verified": "सत्यापित",
"stat.items": "पंजीकृत आइटम",
"stat.partners": "साझेदार",
"stat.restituted": "लौटा दिए गए आइटम",
"status.auctioned": "नीलामी में",
"status.destroyed": "नष्ट किया गया",
"status.donated": "दान किया गया (चैरिटी)",
"status.handed_to_authorities": "अधिकारियों को सौंप दिया गया",
"status.in_storage": "संग्रह में",
"status.matched": "मेल",
"status.open": "खुला",
"status.paid": "भुगतान किया",
"status.pending": "लंबित",
"status.restituted": "लौटा दिया गया",
"status.shipped": "भेजा गया",
"status.shipping_requested": "शिपिंग रिक्वेस्ट की गई",
"status.submitted": "सबमिट किया गया",
"step1.tag": "संस्थान",
"step1.text": "कुछ ही सेकंड में, संस्थान खोई हुई वस्तु को फोटो, श्रेणी और विवरण के साथ लॉग करता है। सब कुछ एक स्पष्ट, सुरक्षित रजिस्टर में केंद्रीकृत होता है।",
"step1.title": "साझेदार वस्तु को पंजीकृत करता है",
"step2.tag": "ग्राहक",
"step2.text": "साझेदार के QR कोड के माध्यम से, आपका ग्राहक 30 सेकंड में खोई हुई वस्तु का विवरण देता है। कोई ऐप इंस्टॉल करने की आवश्यकता नहीं — सब कुछ ब्राउजर में होता है।",
"step2.title": "ग्राहक हानि की रिपोर्ट करता है",
"step3.tag": "बुद्धिमत्ता",
"step3.text": "हमारा स्मार्ट मिलान इंजन विवरणों की तुलना करता है और सबसे संभावित मेल सुझाता है, पुष्टि के लिए तैयार।",
"step3.title": "AI हानि और खोई हुई वस्तु को लिंक करता है",
"step4.tag": "अनुक्रमण",
"step4.text": "पुनर्प्राप्ति शुल्क के सुरक्षित भुगतान के बाद, ग्राहक साइट पर वस्तु प्राप्त करता है — या ट्रैक की गई शिपिंग से प्राप्त करता है।",
"step4.title": "ग्राहक अपनी वस्तु वापस पाता है",
"stg.allLabels": "सभी QR लेबल",
"stg.camHint": "नीचे मैन्युअल एंट्री का प्रयोग करें।",
"stg.camStarting": "कैमरा शुरू हो रहा है…",
"stg.camUnavailable": "कैमरा अनुपलब्ध।",
"stg.clear": "स्पष्ट करें",
"stg.clearAll": "सभी स्पष्ट करें",
"stg.codeUnreadable": "अविज्ञापित कोड।",
"stg.emptyDesc": "संग्रहीत वस्तुएं यहाँ दिखाई देंगी, स्थान के अनुसार समूहित।",
"stg.emptyTitle": "संग्रह में कोई वस्तु नहीं",
"stg.exportAudit": "ऑडिट CSV निर्यात करें",
"stg.exportDone": "CSV निर्यात डाउनलोड किया गया",
"stg.exportImpossible": "वर्तमान में निर्यात अनुपलब्ध है।",
"stg.itemFound": "वस्तु मिली ✅",
"stg.kLocations": "उपयोग किए गए स्थान",
"stg.kObjects": "संग्रहीत वस्तुएं",
"stg.kToClear": "स्पष्ट करने के लिए स्थान",
"stg.locFreed": "स्थान साफ किया गया",
"stg.locsFreed": "{n} स्थान(s) साफ किए गए",
"stg.manualLabel": "या वस्तु का कोड / आईडी दर्ज करें",
"stg.manualPh": "QR का ID या URL चिपकाएं",
"stg.noItemMatch": "कोई वस्तु इस QR / कोड से मेल नहीं खाती।",
"stg.noLocation": "कोई स्थान नहीं",
"stg.objectsAxis": "आइटम",
"stg.objectsN": "{n} आइटम(ों)",
"stg.occAvg": "औसत {n} आइटम/स्थान",
"stg.occHint": "अंबर में मौजूद स्थान औसत को पार करते हैं (संभवतः ओवरलोडेड)।",
"stg.occupancy": "स्थान की ocupancy",
"stg.openPage": "पृष्ठ खोलें",
"stg.posterPdf": "पीडीएफ पोस्टर (A4)",
"stg.printAll": "सभी प्रिंट करें",
"stg.printGroupTitle": "इस शेल्फ के लिए लेबल प्रिंट करें",
"stg.qrAlt": "स्वयं-सेवा QR",
"stg.qrDownload": "QR डाउनलोड करें",
"stg.qrHint": "काउंटर पर इस QR को दिखाएँ: आपके ग्राहक इसे स्कैन करके देख सकते हैं कि उनका आइटम उपलब्ध है या नहीं।",
"stg.qrTitle": "ग्राहक स्वयं-सेवा QR",
"stg.scanDesc": "आइटम के लेबल को स्कैन करें ताकि इसका रिकॉर्ड तुरंत खुल जाए।",
"stg.scanQr": "एक QR स्कैन करें",
"stg.scanTitle": "QR कोड स्कैन करें",
"stg.search": "खोजें",
"stg.shelf": "शेल्फ {loc}",
"stg.shelfPlan": "शेल्फ योजना",
"stg.staleHint": "अपने भौतिक इन्वेंट्री को अद्यतित रखने के लिए इन स्थानों को साफ करें।",
"stg.staleTitle": "{n} आइटम(ों) ने भंडार छोड़ा है लेकिन अभी भी एक स्थान रखा है",
"stg.subtitle": "शेल्फ योजना, QR स्कैनर और भौतिक इन्वेंट्री ट्रैकिंग।",
"stg.title": "भंडारण और QR",
"stt.acceptRate": "स्वीकृति दर",
"stt.accepted": "स्वीकृत",
"stt.activity30": "गतिविधि (पिछले 30 दिन)",
"stt.ai6mo": "अंतिम 6 महीने · स्वीकार = स्व-जोड़ा + पुष्टि किया गया।",
"stt.aiEmpty": "इस अवधि में कोई AI मैच नहीं हुआ।",
"stt.aiTitle": "AI मैच — स्वीकृत बनाम अस्वीकृत",
"stt.auctionShort": "नीलामी",
"stt.auctionedSold": "नीलाम किया गया (बिका)",
"stt.authShort": "प्राधिकरण",
"stt.authorities": "प्राधिकरण को सौंपा गया",
"stt.avgRating": "औसत रेटिंग",
"stt.awaitingRestitution": "वापसी की प्रतीक्षा में आइटम",
"stt.boostClicks": "इस सप्ताह आपकी निर्देशिका पर क्लिक करें धन्यवाद बूस्ट",
"stt.boostInactive": "बूस्ट निष्क्रिय — दृश्यता प्राप्त करने के लिए इसे सक्रिय करें",
"stt.certifiedPremium": "प्रीमियम प्रमाणित",
"stt.declarations": "घोषणाएँ",
"stt.destroyed": "नष्ट किया गया",
"stt.dispoEmpty": "कोई बिना दावा किया गया आइटम भंडार नहीं छोड़ा है।",
"stt.donatedAssoc": "दान किया गया (चैरिटी)",
"stt.donatedShort": "दान किया गया",
"stt.gateCta": "योजनाओं का अन्वेषण करें",
"stt.gateDesc": "अपने मूल आंकड़ों को अनलॉक करने के लिए स्टार्टर में अपग्रेड करें, या उन्नत आंकड़ों और प्रति-संस्थान विश्लेषण के लिए व्यवसाय में।",
"stt.gateTitle": "भुगतान योजनाओं के लिए आरक्षित आंकड़े",
"stt.inStorage": "भंडारण में",
"stt.kItems": "पंजीकरण किए गए आइटम",
"stt.kRate": "वापसी दर",
"stt.kRestituted": "वापस किए गए आइटम",
"stt.kRevenue": "राजस्व (महीना)",
"stt.noDeclYet": "अभी तक कोई घोषणाएँ नहीं।",
"stt.recapDownloaded": "रिकैप डाउनलोड किया गया — साझा करने के लिए तैयार!",
"stt.recapError": "रिकैप उत्पन्न करने में असमर्थ",
"stt.recapText": "हमारा Findloop {year} रिकैप: वापस किए गए आइटम और ग्राहक संतोष 🎉",
"stt.recapTitle": "Findloop {year} रिकैप",
"stt.rejected": "अस्वीकृत",
"stt.restitutions": "वापसी",
"stt.shareRecap": "मेरी {year} रिकैप साझा करें",
"stt.topCategories": "सबसे घोषित श्रेणियाँ",
"stt.unclaimedDesc": "प्रत्येक श्रेणी के अनुसार नष्ट, दान किए गए और नीलामी में रखे गए आइटमों की मात्रा।",
"stt.unclaimedTitle": "अप्राप्त आइटम — संग्रहण छोड़ना",
"stt.vsLastWeek": "पिछले सप्ताह के मुकाबले",
"sub.cancel": "मेरी सब्सक्रिप्शन रद्द करें",
"sub.cancelAbort": "रद्द करें",
"sub.cancelConfirm1": "क्या आप वाकई रद्द करना चाहते हैं? आपकी पहुंच सक्रिय है जब तक",
"sub.cancelConfirm2": "कोई धनवापसी नहीं की जाएगी।",
"sub.cancelConfirmBtn": "रद्दीकरण की पुष्टि करें",
"sub.cancelTitle": "अपनी सब्सक्रिप्शन रद्द करें",
"sub.cancelledToast": "रद्दीकरण दर्ज किया गया।",
"sub.cguAnd": "और",
"sub.cguDesc": "कृपया भुगतान से पहले अपनी सहमति की पुष्टि करें।",
"sub.cguLink": "उपयोग की शर्तें",
"sub.cguPay": "भुगतान के लिए आगे बढ़ें",
"sub.cguPre": "मैंने पढ़ लिया है और स्वीकार किया है",
"sub.cguRequired": "जारी रखने के लिए आपको उपयोग की शर्तों और गोपनीयता नीति को स्वीकार करना होगा।",
"sub.cguSuffix": "फिंडो की।",
"sub.cguTitle": "अपनी सब्सक्रिप्शन का अंतिम रूप देना",
"sub.expiresOn": "आपकी सब्सक्रिप्शन समाप्त होती है",
"sub.noProrata": "कोई प्रोराटा धनवापसी नहीं।",
"sub.privacyLink": "गोपनीयता नीति",
"sub.renewsOn": "आपकी सब्सक्रिप्शन नवीनीकरण होता है",
"sub.resume": "फिर से सब्सक्राइब करें",
"sub.resumedToast": "फिर से सब्सक्रिप्शन की पुष्टि की गई।",
"tier.free": "फ्रीमियम",
"tier.large": "एंटरप्राइज",
"tier.medium": "बिजनेस",
"tier.small": "स्टार्टर",
"tm.add": "जोड़ें",
"tm.adminOpt": "व्यवस्थापक (पूर्ण दृश्य)",
"tm.chooseEst": "एक प्रतिष्ठान चुनें",
"tm.chooseEstPh": "एक प्रतिष्ठान चुनें",
"tm.copyFail": "कॉपी करना विफल रहा",
"tm.copyLink": "लिंक कॉपी करें",
"tm.copyOk": "आमंत्रण लिंक कॉपी किया गया",
"tm.emailHint": "एक आमंत्रण ईमेल भेजा जाएगा जिससे पासवर्ड बनाया जा सके।",
"tm.expiresOn": "मियाद समाप्त होने की तारीख {date}",
"tm.forEmail": " के लिए {email}",
"tm.forbidden": "टीम प्रबंधन खाते के मालिक के लिए आरक्षित है।",
"tm.inviteCreated": "आमंत्रण बनाया गया",
"tm.inviteDesc": "एक आमंत्रण ईमेल टीम के साथी को अपना पासवर्ड बनाने की अनुमति देता है।",
"tm.invitePending": "लंबित आमंत्रण",
"tm.inviteResent": "आमंत्रण फिर से भेजा गया",
"tm.inviteSent": "आमंत्रण ईमेल द्वारा भेजा गया",
"tm.inviteTitle": "एक सदस्य को आमंत्रित करें",
"tm.invitedOn": "आमंत्रित किया गया {date}",
"tm.linkExpired": "लिंक की समय सीमा समाप्त हो गई",
"tm.memberRemoved": "सदस्य हटा दिया गया",
"tm.name": "नाम",
"tm.noMembers": "अभी कोई साथी नहीं।",
"tm.resendTitle": "आमंत्रण फिर से भेजें",
"tm.role": "भूमिका",
"tm.roleAdmin": "व्यवस्थापक",
"tm.roleOwner": "मालिक",
"tm.roleStaff": "स्टाफ",
"tm.roleUpdated": "भूमिका अपडेट की गई",
"tm.sendInvite": "आमंत्रण भेजें",
"tm.sending": "भेजा जा रहा है...",
"tm.staffOpt": "स्टाफ (केवल अपने प्रतिष्ठान को देखते हैं)",
"trk.at": "पर",
"trk.badge": "ट्रैकिंग",
"trk.carrier": "कैरियर",
"trk.codeValidated": "कोड साझेदार द्वारा मान्य",
"trk.dlProof": "मेरी हस्तांतरण का प्रमाण डाउनलोड करें (PDF)",
"trk.emailLabel": "ईमेल (वैकल्पिक - आपके विवरण देखने के लिए)",
"trk.enterEmailCode": "अपने ईमेल को ऊपर दर्ज करें ताकि आपका दावे का कोड प्रदर्शित हो सके।",
"trk.idLabel": "रिपोर्ट नंबर",
"trk.lostEmail": "मेरे पास अब मेरे ईमेल का एक्सेस नहीं है",
"trk.phonePh": "आपका फोन नंबर",
"trk.photoBefore": "शिपिंग से पहले वस्तु का फोटो",
"trk.recoverBtn": "मेरी वस्तु पुनर्प्राप्त करें",
"trk.recoverHint": "अपने पंजीकृत नंबर पर SMS द्वारा अपना दावा कोड प्राप्त करें।",
"trk.searching": "खोज रहा है…",
"trk.secureRest": "सुरक्षित हस्तांतरण",
"trk.send": "भेजें",
"trk.shipPending": "शिपमेंट तैयार हो रहा है - ट्रैकिंग नंबर यहां भेजे जाने के बाद दिखाई देगा।",
"trk.shipTitle": "शिपमेंट ट्रैकिंग",
"trk.showQr": "हस्तांतरण को मान्य करने के लिए साझेदार को यह QR दिखाएं",
"trk.sigSaved": "हस्ताक्षर सहेजा गया",
"trk.signFirst": "कृपया पुष्टि करने से पहले हस्ताक्षर करें।",
"trk.signProof": "अपने हस्तांतरण का प्रमाण पर हस्ताक्षर करें",
"trk.signSubmit": "मेरे हस्ताक्षर की पुष्टि करें और PDF उत्पन्न करें",
"trk.submit": "ट्रैक करें",
"trk.subtitle": "प्रगति ट्रैक करने के लिए अपना रिपोर्ट नंबर दर्ज करें।",
"trk.title": "मेरी रिपोर्ट ट्रैक करें",
"trk.trackShipment": "पार्सल ट्रैक करें",
"trk.trackingNo": "ट्रैकिंग नंबर",
"trk.yourCode": "आपका दावा कोड (साझेदार को देने के लिए)",
"ft.finderContactsTitle": "फाइंडर के संपर्क विवरण",
"ft.foundCodeHelp": "इस कोड को सौंपने पर मालिक को दिखाएँ ताकि पुष्टि हो सके कि आइटम वापस किया गया है।",
"ft.inProgressOther": "आइटम लौटाया जा रहा है",
"ft.inProgressOtherHelp": "मालिक ने इस आइटम के लिए एक और फाइंडर का चयन किया है। आपकी ओर से कोई और कार्रवाई की आवश्यकता नहीं है।",
"ft.restitutionCodeHelp": "यह कोड आइटम के सौंपने की पुष्टि करता है। यह नीचे पहले से भरा हुआ है; इसे मान्य करें फिर मामला बंद करें।",
"ft.restitutionCodeTitle": "आपको मिलने वाला पुनर्स्थापन कोड",
"hc.14Digits": "14 अंक",
"hc.15DaysBeforeAnItem": "एक आइटम की कानूनी समय सीमा से 15 दिन पहले।",
"hc.7DaysBeforeAnItem": "एक आइटम की कानूनी समय सीमा से 7 दिन पहले।",
"hc.8CharactersMinimum": "न्यूनतम 8 अक्षर।",
"hc.aClaimToValidate": "एक दावा मान्य करने के लिए",
"hc.aFindoAssistanceSessionIs": "आपके खाते में वर्तमान में एक Findloop सहायता सत्र सक्रिय है।",
"hc.aNewMatchHasBeen": "एक नया मिलान पाया गया है",
"hc.aUser": "एक उपयोगकर्ता",
"hc.aUserClaimsToBe": "एक उपयोगकर्ता मालिक होने का दावा करता है। लौटाने को अधिकृत करने से पहले उनके उत्तरों की जांच करें।",
"hc.aboutFindo": "Findloop के बारे में",
"hc.accountActivatedPleaseLogIn": "खाता सक्रिय हो गया, कृपया लॉगिन करें।",
"hc.accountActivation": "खाता सक्रियकरण",
"hc.accountCreated": "खाता बनाया गया!",
"hc.accountDeactivatedAReactivationEmail": "खाता निष्क्रिय कर दिया गया। आपको फिर से सक्रियण हेतु एक ईमेल (30 दिनों के लिए मान्य) भेजा गया है।",
"hc.accountReactivation": "खाता पुनः सक्रियण",
"hc.activateMyAccount": "मेरा खाता सक्रिय करें",
"hc.activateMyAdminAccount": "मेरा व्यवस्थापक खाता सक्रिय करें",
"hc.activating": "सक्रिय किया जा रहा है…",
"hc.activeMatchCancelReason": "सक्रिय मिलान। ग्राहक का रद्दीकरण कारण: \"{reason}\"। आइटम अभी भी एक दावे की प्रतीक्षा कर रहा है।",
"hc.activeMatchWithAPublic": "सार्वजनिक (ग्राहक) लिस्टिंग के साथ सक्रिय मिलान। मालिक के दावे की प्रतीक्षा कर रहा है।",
"hc.addAPhoto": "एक फोटो जोड़ें",
"hc.addAndConfigureYourEstablishments": "\"स्थापना\" में अपनी संस्थाएँ जोड़ें और कॉन्फ़िगर करें: संपर्क विवरण, श्रेणी और आइटम का भौतिक भंडारण।",
"hc.addOnGoogle": "गूगल पर जोड़ें",
"hc.address": "पता",
"hc.addressSaved": "पता सुरक्षित किया गया",
"hc.addressStreet": "पता — सड़क",
"hc.adjustThePhoto": "फोटो समायोजित करें",
"hc.adminFullView": "व्यवस्थापक (पूर्ण दृश्य)",
"hc.administratorOnly": "केवल व्यवस्थापक",
"hc.africa": "अफ्रीका",
"hc.aiVisualComparison": "AI दृश्य तुलना",
"hc.all": "सभी",
"hc.amount": "राशि",
"hc.anOrganization": "एक संगठन",
"a.firstName": "पहला नाम",
"ac.emailCrossMatch": "B2C क्रॉस-मेल",
"ac.emailCrossMatchDesc": "जब एक सार्वजनिक खोई हुई वस्तु का विज्ञापन आपके स्थान पर जमा की गई वस्तु से मेल खाता है, तो एक ईमेल प्राप्त करें",
"ac.emailCrossReject": "सार्वजनिक मेल अस्वीकृति",
"ac.emailCrossRejectDesc": "जब एक ग्राहक बताता है कि सुझाई गई सार्वजनिक मेल उनकी वस्तु नहीं है, तब एक ईमेल प्राप्त करें।",
"ac.emailLoginNotif": "लॉगिन सूचन",
"ac.emailLoginNotifDesc": "जब भी कोई आपके खाते में लॉग इन करता है, तब एक ईमेल प्राप्त करें।",
"ad.closeNoCancel": "नहीं, लिस्टिंग हटाएँ",
"ad.closeQuestion": "क्या वस्तु आपको वापस की गई थी?",
"ad.closeQuestionDesc": "हमें बताएं कि क्या आपने अपनी वस्तु रिकवर की, या यदि आप केवल इस लिस्टिंग को हटाना चाहते हैं।",
"ad.closeYesRestituted": "हाँ, वस्तु वापस की गई",
"ad.closedRestituted": "वस्तु वापस की गई — लिस्टिंग बंद 🎉",
"an.lostLoginDesc": "खोई हुई वस्तु की रिपोर्ट करने और इसकी वापसी का पालन करने के लिए एक खाते की आवश्यकता है।",
"an.lostLoginRequired": "खोई हुई वस्तु की रिपोर्ट करने के लिए लॉग इन करें",
"an.qfAll": "सभी",
"an.qfBoosted": "बूस्टेड",
"an.qfPhoto": "फोटो के साथ",
"an.qfRecent": "इस सप्ताह",
"an.qfResolved": "हल किया गया",
"an.restitutionInProgress": "वस्तु वापस की जा रही है",
"dec.descPhLong": "वस्तु का वर्णन करें: ब्रांड, रंग, विशिष्ट चिह्न... (जितनी अधिक जानकारी आप देंगे, उतनी ही आपकी वस्तु को वापस पाने की संभावनाएं उच्च रहेंगी)",
"dec.loadError": "इस समय साझेदार को लोड करने में असमर्थ। अपने कनेक्शन की जांच करें और फिर से प्रयास करें।",
"dec.retry": "फिर से प्रयास करें",
"dec.shippingMode": "शिपिंग",
"dep.photo2": "2रा वस्तु फोटो",
"dep.photo2Hint": "वैकल्पिक — एक अन्य कोण दृश्य मेलिंग सटीकता को बढ़ाता है।",
"dl.accountSuspended": "बकाया चालान के लिए खाता निलंबित। अपनी पहुँच बहाल करने के लिए इसे निपटाएँ।",
"dl.regularize": "अब निपटाएँ →",
"dl.suspensionCountdown": "चालान {num} बकाया — आपका खाता {days} दिन(s) में निलंबित किया जाएगा। इससे बचने के लिए इसे निपटाएँ।",
"ft.cancelConfirm": "क्या आप अपनी रिपोर्ट रद्द करना चाहते हैं? वस्तु के मालिक को सूचित किया जाएगा।",
"ft.cancelDone": "रिपोर्ट रद्द कर दी गई।",
"ft.cancelLocked": "मालिक के भुगतान के बाद रद्द करना अब संभव नहीं है।",
"ft.cancelReport": "मेरी रिपोर्ट रद्द करें",
"ft.claimCodeHelp": "यह कोड फाइंडर को देने पर उसकी पुष्टि करें कि आपने अपनी वस्तु प्राप्त की है।",
"ft.claimCodeTitle": "आपका पुनर्स्थापन कोड",
"ft.claimDone": "वस्तु वापस की गई। Findloop का उपयोग करने के लिए धन्यवाद!",
"ft.claimUnlockHint": "फाइंडर के संपर्क विवरण अनलॉक करें",
"ft.claimUnlockHintSub": "शुल्क का भुगतान करें और संपर्क विवरण प्राप्त करने के लिए अपने खाते में \"मैं जिन वस्तुओं का दावा कर रहा हूँ\" पर जाएं।",
"ft.finderCodeShownHelp": "मालिक ने भुगतान किया है और आपको चुना है। लौटने की पुष्टि करने के लिए नीचे दिए गए कोड को कॉपी करें — अपने ईमेल की जांच करने की आवश्यकता नहीं है।",
"ft.finderCodeShownTitle": "मालिक का सत्यापन कोड",
"hc.analyzing": "विश्लेषण कर रहा है…",
"hc.andRecoveryIs": "और पुनर्प्राप्ति है",
"hc.andTheDeclarationWillBe": "और घोषणा बंद कर दी जाएगी (इतिहास में स्थानांतरित)। यह क्रिया अंतिम है।",
"hc.annual20": "वार्षिक -20%",
"hc.annualBilling20": "वार्षिक बिलिंग (−20%)",
"hc.annualTarget": "वार्षिक लक्ष्य",
"hc.anyCommentsOptional": "कोई टिप्पणियाँ? (वैकल्पिक)",
"hc.approveTheClaim": "दावे को स्वीकृत करें",
"hc.archiveCancelledConfirm": "आर्काइव {n} सूची \"ग्राहक द्वारा रद्द\"? ये रजिस्ट्र्री से हटा दिए जाएंगे।",
"hc.asSoonAs": "जल्द से जल्द",
"hc.askTheOwnerToDisplay": "स्वामी से उनके कोड का QR दिखाने के लिए कहें (ट्रैकिंग पृष्ठ)।",
"hc.askThemAtTheCounter": "उनसे काउंटर पर पहचान की पुष्टि करने के लिए कहें — कभी भी सार्वजनिक रूप से दिखाई नहीं देगा।",
"hc.assistance": "सहायता",
"hc.assistanceSessionRevoked": "सहायता सत्र रद्द कर दिया गया।",
"hc.atLeast6Characters": "कम से कम 6 वर्ण",
"hc.automaticallyPreSelected": "स्वतः पूर्व-चयनित",
"hc.automaticallyWhenShipping": "शिपिंग के दौरान स्वचालित रूप से।",
"hc.awaitingClaim": "दावे की प्रतीक्षा कर रहा है",
"hc.awaitingPayment": "भुगतान की प्रतीक्षा कर रहा है",
"hc.b2cCustomer": "B2C ग्राहक",
"hc.back": "वापस",
"hc.backToHome": "मुख्य पृष्ठ पर लौटें",
"hc.backToMyAccount": "मेरे खाते पर लौटें",
"hc.backToPayment": "भुगतान पर लौटें",
"hc.beforeAfterComparisonSlider": "पहले/बाद तुलना स्लाइडर",
"hc.billingInformation": "बिलिंग जानकारी",
"hc.billingInformationSaved": "बिलिंग जानकारी सहेजी गई ✓",
"hc.brand": "ब्रांड",
"hc.bronze": "कांस्य",
"hc.calculatingTheShippingRate": "शिपिंग दर की गणना कर रहा है…",
"hc.cameraUnavailableEnterTheCode": "कैमरा अनुपलब्ध। कोड को मैन्युअल रूप से दर्ज करें।",
"hc.cancel": "रद्द करें",
"hc.cancelMyDeclaration": "मेरी घोषणा रद्द करें",
"hc.cancelSavedFmt": "रद्द करना सहेजा गया: \"{reason}\"। आप अभी भी दावा कर सकते हैं।",
"hc.cancelTheDeposit": "जमा रद्द करें",
"hc.cancelThisMatch": "इस मैच को रद्द करें",
"hc.cancellationReason": "रद्द करने का कारण",
"hc.cancelled": "रद्द कर दिया गया",
"hc.cancelledByTheCustomer": "ग्राहक द्वारा रद्द",
"hc.cannotOpenPayment": "भुगतान खोलने में असमर्थ। कृपया पुनः प्रयास करें।",
"hc.careers": "करियर",
"hc.carrier": "कैरेयर",
"hc.carrierAvailabilityCannotBeChecked": "कैरेयर की उपलब्धता तब तक जांची नहीं जा सकती जब तक आपका Sendcloud भेजने वाला कॉन्फ़िगर नहीं होता।",
"hc.carrierConfirmedCharged": "कैरेयर ने पुष्टि की - {price} € ग्राहक से चार्ज किए गए",
"hc.carrierOther": "कैरेयर (अन्य)",
"hc.carrierSelection": "कैरेयर चयन",
"hc.caseClosedThankYou": "मामला बंद। धन्यवाद!",
"hc.category": "श्रेणी",
"hc.changeMethod": "विधि बदलें",
"hc.characteristic": "विशेषता",
"hc.chargedToCustomer": "ग्राहक से चार्ज किया गया।",
"hc.checkOrEditYourDetails": "सुरक्षित भुगतान से पहले अपने विवरण की जांच करें या संपादित करें।",
"hc.checkStatisticsToTrackDeposited": "\"आँकड़े\" की जांच करें ताकि जमा की गई वस्तुओं, वापसी दर और प्रत्येक स्थापना के प्रदर्शन की जांच की जा सके।",
"hc.checkTheDetailsBeforeContacting": "संपर्क करने से पहले विवरण की जांच करें।",
"hc.checkTheDetailsBelowBefore": "आपकी वापसी अनुरोध शुरू करने से पहले नीचे दिए गए विवरणों की जांच करें।",
"hc.checkTheNewItem": "नई वस्तु की जांच करें",
"hc.checkThePhotosAndCharacteristics": "वसूली के साथ आगे बढ़ने से पहले नीचे दिए गए चित्रों और विशेषताओं की जांच करें।",
"hc.chooseACountry": "एक देश चुनें",
"hc.chooseANewPassword": "एक नया पासवर्ड चुनें",
"hc.chooseAReason": "एक कारण चुनें",
"hc.chooseTheLegalRetentionAlerts": "चुनें कानूनी रिटेंशन अलर्ट्स जो ईमेल द्वारा प्राप्त होते हैं",
"hc.chooseYourPasswordToAccess": "प्रशासनिक कंसोल तक पहुँचने के लिए अपना पासवर्ड चुनें।",
"hc.city": "शहर",
"hc.claimApproved": "दावा स्वीकृत",
"hc.claimApproved2": "दावा स्वीकृत।",
"hc.claimCodeExpired": "दावा कोड समाप्त",
"hc.claimCodeVerified": "दावा कोड सत्यापित किया गया",
"hc.claimNotFound": "दावा नहीं मिला",
"hc.claimNotValidated": "दावा मान्य नहीं हुआ",
"hc.claimRejected": "दावा अस्वीकृत",
"hc.claimRejected2": "दावा अस्वीकृत।",
"hc.claimValidated": "दावा मान्य किया गया",
"hc.claimValidatedByThePartner": "दावा भागीदार द्वारा मान्य किया गया",
"hc.claimant": "दावा करने वाला",
"hc.claimsToBeTheOwner": "इस वस्तु का मालिक होने का दावा करता है और सत्यापन प्रश्नों के उत्तर दिए हैं। केवल तभी स्वीकृत करें जब उत्तर मेल खाते हों।",
"hc.claimsToValidate": "मान्य करने के लिए दावे",
"hc.clear": "स्पष्ट करें",
"hc.clickToZoom": "जूम करने के लिए क्लिक करें",
"hc.close": "बंद करें",
"hc.close2": "बंद करें",
"hc.closeTheDeclaration": "घोषणा बंद करें",
"hc.closeTheDeclaration2": "घोषणा बंद करें?",
"hc.codeAlreadyVerified": "कोड पहले ही सत्यापित किया जा चुका है",
"hc.codeCopied": "कोड कॉपी किया गया",
"hc.collapse": "संकुचित करें",
"hc.color": "रंग",
"hc.company": "कंपनी",
"hc.companyName": "कंपनी का नाम",
"hc.comparePhotos": "फोटो की तुलना करें",
"hc.compareThemWithTheOwner": "इन्हें मालिक के उत्तरों के साथ तुलना करें - जिसे सार्वजनिक रूप से नहीं देखा जा सकता।",
"hc.condition": "स्थिति",
"hc.confirmAndPay": "पुष्टि करें और भुगतान करें",
"hc.confirmCancellation": "रद्दीकरण की पुष्टि करें",
"hc.confirmCrop": "क्रॉप की पुष्टि करें",
"hc.confirmDeletion": "हटाने की पुष्टि करें",
"hc.confirmPassword": "पासवर्ड की पुष्टि करें",
"hc.confirmThatThisIsYour": "पुष्टि करें कि यह आपका आइटम है। किसी भी संपर्क से पहले खोजकर्ता से पहचान जांच का अनुरोध किया जाएगा।",
"hc.confirmTheCarrier": "वाहक की पुष्टि करें",
"hc.confirmThePassword": "पासवर्ड की पुष्टि करें",
"hc.confirmYourShippingAddressTo": "भुगतान जारी रखने के लिए अपना शिपिंग पता की पुष्टि करें।",
"hc.confirmYourSubscription": "अपनी सदस्यता की पुष्टि करें",
"hc.confirmed": "पुष्टि हो गई ✓",
"hc.contactFindoToGetYour": "अपने प्रेषक आईडी पाने के लिए Findloop से संपर्क करें।",
"hc.contactUs": "हमसे संपर्क करें",
"hc.continueTheReturn": "वापसी जारी रखें",
"hc.continueToPayment": "भुगतान की ओर जारी रखें",
"hc.copy": "कॉपी करें",
"hc.correctMyDetails": "मेरे विवरण ठीक करें",
"hc.correctThisEntry": "क्या इस प्रविष्टि को सही करें?",
"hc.country": "देश",
"hc.countryAddress": "देश (पता)",
"hc.countryIsoCodeEG": "देश (ISO कोड, जैसे FR)",
"hc.cover": "कवर",
"hc.createTheShipment": "शिपमेंट बनाएँ",
"hc.cropThePhoto": "फोटो को काटें",
"hc.customer": "ग्राहक",
"hc.customerClaimCodeToCheck": "ग्राहक दावा कोड - पिकअप पर जांचें:",
"hc.customerReasonFmt": "ग्राहक का कारण: \"{reason}\"।",
"hc.customerReminderDelay": "ग्राहक अनुस्मारक देरी",
"hc.customerWhosePublicListingMatches": "ग्राहक जिसका सार्वजनिक लिस्टिंग इस आइटम से मेल खाता है - बस आपको दिखता है।",
"hc.d15": "D-15",
"hc.dangerZone": "खतरनाक क्षेत्र",
"hc.date": "तारीख",
"hc.dateNewest": "तारीख (नया)",
"hc.dateOldest": "तारीख (पुराना)",
"hc.daysToYearEnd": "{n} दिन वर्ष के अंत तक",
"hc.deadlineAlert": "समय सीमा का अलर्ट",
"hc.declarationClosed": "घोषणा बंद ✓",
"hc.declarationNotFound": "घोषणा नहीं मिली।",
"hc.declarationNotFound2": "घोषणा नहीं मिली",
"hc.declarationTracking": "घोषणा ट्रैकिंग",
"hc.defaultCarrier": "डिफ़ॉल्ट वाहक",
"hc.defaultCarrierPreselected": "डिफ़ॉल्ट वाहक पूर्व-चयनित — इस शिपमेंट के लिए बदला जा सकता है। वास्तविक दर (Sendcloud + {m}% मार्जिन)।",
"hc.defaultCarrierRemoved": "डिफ़ॉल्ट वाहक हटा दिया गया",
"hc.delayHours": "देरी (घंटे)",
"hc.deleteMyAccount": "मेरा खाता हटाएं",
"hc.deleting": "हटाया जा रहा है...",
"hc.deletingDeactivatesYourAccountLogin": "हटाने से आपका खाता निष्क्रिय हो जाता है: लॉगिन अवरुद्ध है और डेटा 30 दिनों के लिए रखा जाता है। आपको 30 दिनों के लिए वैध पुन: सक्रियण लिंक के साथ एक ईमेल प्राप्त होगा।",
"hc.delivered": "वितरित",
"hc.depositAnItem": "एक आइटम जमा करें",
"hc.depositCancelledItemPutBack": "जमा रद्द कर दिया गया — आइटम स्टॉक में वापस डाल दिया गया।",
"hc.depositCancelledItemRemovedFrom": "जमा रद्द कर दिया गया — आइटम रजिस्ट्री से हटा दिया गया।",
"hc.depositedOn": "जमा किया गया",
"hc.describeTheItemBrandColor": "आइटम का वर्णन करें: ब्रांड, रंग, विशेष अंक… (आप जितने अधिक विवरण देंगे, अपने आइटम को खोजने की आपकी संभावना उतनी ही बेहतर होगी)",
"hc.dimensionsCm": "आयाम (सेमी)",
"hc.disablingAnEmail": "एक ईमेल को निष्क्रिय करना",
"hc.doesNotHide": "छुपाता नहीं है",
"hc.download": "डाउनलोड करें",
"hc.downloadThePdf": "पीडीएफ डाउनलोड करें",
"hc.draftRestoredPickUpYour": "ड्राफ्ट बहाल किया गया — अपनी घोषणा वहीं से उठाएं जहां आपने छोड़ी थी।",
"hc.dragToReposition": "पुनर्व्यवस्थित करने के लिए खींचें",
"hc.eGColisPriv": "उदाहरण के लिए, कोलिस प्रिवé",
"hc.eachItemGetsAQr": "हर आइटम को एक QR लेबल मिलता है। इसे \"स्टोरेज & QR\" से स्कैन करें ताकि आप तुरंत किसी आइटम को ढूंढ सकें।",
"hc.eachSiteManagesItsOwn": "हर साइट अपनी स्वयं की बैंकिंग प्रबंधित करती है। जाओ",
"hc.edit": "संपादित करें",
"hc.emailNotificationPreferences": "ईमेल नोटिफिकेशन प्राथमिकताएँ",
"hc.emailPreferencesUpdated": "ईमेल प्राथमिकताएँ अपडेट की गई",
"hc.enableOrDisableRecoveryFees": "व्यवसाय के लिए पुनर्प्राप्ति शुल्क सक्षम या अक्षम करें",
"hc.enlargePhoto": "फोटो बढ़ाएं",
"hc.enterTheCustomerSCode": "ग्राहक का कोड दर्ज करें",
"hc.estShipRate": "अनुमानित शिपिंग दर (Sendcloud + {m}% मार्जिन):",
"hc.establishment": "संस्थान",
"hc.establishment2": "संस्थान:",
"hc.establishmentInItsSendcloudAccount": "Sendcloud खाते में संस्थान और आपको प्रेषक ID देता है",
"hc.establishmentSettings": "संस्थान सेटिंग्स",
"hc.exCode": "जैसे ABCD2345",
"hc.exId": "जैसे 3f2a…",
"hc.exit": "बाहर निकलें",
"hc.explainWhyThisItemIs": "व्याख्या करें कि यह वस्तु आपकी क्यों नहीं है...",
"hc.externalPaymentLinks": "बाहरी भुगतान लिंक",
"hc.failed": "विफल",
"hc.feesEnabled": "शुल्क सक्षम",
"hc.field": ") फ़ील्ड।",
"hc.finderAcceptedCloseTheCase": "Finder स्वीकार किया — जब वस्तु व्यक्तिगत रूप से सौंप दी जाए तो मामला बंद करें।",
"hc.findoCityRanking": "Findloop — शहर रैंकिंग",
"hc.findoForEstablishments": "संस्थानों के लिए Findloop",
"hc.findoPresentationVideo": "Findloop प्रस्तुति वीडियो",
"hc.findoRegistersTheAddressOf": "Findloop आपके का पता पंजीकृत करता है",
"hc.findoReviewShare": "Findloop {year} समीक्षा: {n} वस्तुएं लौटाई गईं, {rate}% वापसी दर 🎉",
"hc.firstVerifyTheClaimCode": "पहले ऊपर दिए गए दावे के कोड की पुष्टि करें",
"hc.forEveryNewShipmentFrom": "के लिए हर नए शिपमेंट से",
"hc.free": "मुफ्त",
"hc.freeRecovery0": "मुफ्त वसूली (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "अफ्रीका में मुफ्त वसूली - लॉन्च ऑफ़र",
"hc.freeRecoveryFeesDisabled0": "मुफ्त वसूली: शुल्क अक्षम (0 €)",
"hc.fromTeamInviteYourColleagues": "\"टीम\" से, अपने सहयोगियों को ईमेल से आमंत्रित करें और उन्हें एक संस्थान सौंपें। प्रत्येक सदस्य केवल अपनी श्रेणी देखता है।",
"hc.fullName": "पूरा नाम",
"hc.fullPhoto": "पूर्ण फोटो",
"hc.gallery": "गैलरी",
"hc.giveTheReasonForCancelling": "रद्द करने का कारण बताएं। भागीदार को सूचित किया जाएगा।",
"hc.goToLogin": "लॉगिन पर जाएं",
"hc.goToMyAccount": "मेरे खाते पर जाएं",
"hc.gold": "सोना",
"hc.googleLoginFailed": "गूगल साइन-इन विफल",
"hc.hasConfirmedYourPaymentYou": "ने आपकी भुगतान की पुष्टि की है, आपको स्वचालित रूप से पुनःनिर्देशित किया जाएगा",
"hc.helpCenter": "सहायता केंद्र",
"hc.helpUsImproveWhyAre": "हमें सुधारने में मदद करें: आप क्यों छोड़ रहे हैं? आपका खाता निष्क्रिय कर दिया जाएगा और 30 दिनों के लिए पुनः सक्रिय किया जा सकता है।",
"hc.hidePassword": "पासवर्ड छिपाएं",
"hc.high": "उच्च",
"hc.historyOfYourMonthlySubscriptions": "आपकी मासिक सदस्यताओं का इतिहास और उनकी भुगतान स्थिति।",
"hc.hotelBelmont": "होटल बेलमोंट",
"hc.howConfigureSenderId": "मैं अपने नंबरिक सेंडर आईडी को कैसे सेट करूँ?",
"hc.iDonTUseIt": "मैं इसका पर्याप्त उपयोग नहीं करता",
"hc.iFoundItElsewhere": "मैंने इसे कहीं और पाया",
"hc.iNoLongerNeedMy": "मुझे अपने आइटम की अब कोई आवश्यकता नहीं है",
"hc.identityVerification": "पहचान सत्यापन",
"hc.idleLogoutIn": "आप {n} सेकंड के बाद निष्क्रियता के कारण लॉग आउट हो जाएँगे।",
"hc.ifProvidedTheVolumetricWeight": "यदि दिया गया है, तो आयामी वजन का उपयोग किया जाता है।",
"hc.ifThePartnerHasNot": "यदि partenaire ने इस देरी के बाद बाहरी भुगतान की प्राप्ति की पुष्टि नहीं की है, तो Findloop स्वचालित रूप से partenaire को इसे मान्य करने के लिए याद दिलाएगा।",
"hc.impersonationEnded": "प्रतिनिधित्व समाप्त हुआ।",
"hc.impersonationMode": "प्रतिनिधित्व मोड",
"hc.impersonationSessionExpired": "प्रतिनिधित्व सत्र समाप्त हो गया।",
"hc.inTheField": ", क्षेत्र में",
"hc.inTransit": "परिवहन में",
"hc.inclVat": "शामिल। VAT",
"hc.intraEuVatNumberOptional": "इंट्रा-ईयू VAT नंबर वैकल्पिक, SIRET की आवश्यकता नहीं (फ्रांस के बाहर)।",
"hc.invalidInvitationLink": "अमान्य आमंत्रण लिंक।",
"hc.invalidInvitationLink2": "अमान्य आमंत्रण लिंक",
"hc.invalidInviteLink": "अमान्य या समाप्त आमंत्रण लिंक।",
"hc.invalidNumberEnterAnInternational": "अमान्य संख्या। एक अंतरराष्ट्रीय संख्या दर्ज करें, जैसे +33 6 12 34 56 78।",
"hc.invalidOrExpiredLink": "अमान्य या समाप्त लिंक।",
"hc.invalidOrExpiredReactivationLink": "अमान्य या समाप्त पुनः सक्रियण लिंक",
"hc.invalidSendcloudId": "अमान्य Sendcloud आईडी",
"hc.inviteSubtitle": "{org} आपको उनके Findloop टीम में शामिल होने के लिए आमंत्रित करता है। अपने खाते को सक्रिय करने के लिए अपना पासवर्ड चुनें।",
"hc.isAvailableOnSendcloudFor": "आपके सभी मार्गों (घरेलू + अंतरराष्ट्रीय) के लिए Sendcloud पर उपलब्ध है।",
"hc.isNotEnabledOnYour": "आपके Sendcloud खाते पर कुछ गंतव्यों के लिए सक्षम नहीं है। उनके लिए लेबल किसी अन्य उपलब्ध वाहक के साथ उत्पन्न किए जाएंगे।",
"hc.isThisReallyYourItem": "क्या यह वास्तव में आपका आइटम है?",
"hc.isThisYourItem": "क्या यह आपका आइटम है?",
"hc.item": "आइटम",
"hc.itemAlreadyConfirmed": "आइटम पहले से ही पुष्टि की गई",
"hc.itemDetails": "आइटम विवरण",
"hc.itemFoundAt": "आइटम मिला",
"hc.itemFoundAtAPartner": "आइटम एक साथी पर मिला",
"hc.itemMarkedAsReturned": "आइटम को वापस किया गया ✓",
"hc.itemPhotoRequiredBeforeShipping": "आइटम का फोटो (शिपिंग से पहले आवश्यक)",
"hc.itemPhotoSaved": "आइटम का फोटो सहेजा गया",
"hc.itemPreview": "आइटम पूर्वावलोकन",
"hc.itemPutBackInStorage": "आइटम को भंडारण में वापस रखा गया।",
"hc.itemWeight": "आइटम का वजन:",
"hc.itemsReturned": "आइटम(हरू) वापस किए गए",
"hc.itemsReturnedThisYear": "इस वर्ष लौटाए गए आइटम",
"hc.itemsWhoseLegalDeadlineIs": "वे आइटम जिनकी कानूनी समय सीमा 15 दिन दूर या उससे कम है (अवधि समाप्त शामिल हैं)। मिलान दिखाई देते हैं।",
"hc.kbisNumber": "Kbis संख्या",
"hc.keysForgottenOnABench": "बेंच पर भुली हुई चाबियाँ",
"hc.labelBeingGenerated": "लेबल उत्पन्न किया जा रहा है",
"hc.leaveTheFieldsEmptyTo": "फ्री में पुनर्प्राप्ति की पेशकश करने के लिए फ़ील्ड को खाली छोड़ दें।",
"hc.legalNotice": "कानूनी नोटिस",
"hc.limitReachedUpgradeToA": "सीमा पार — उच्च योजना में अपग्रेड करें",
"hc.linkCopiedShareOn": "लिंक कॉपी किया गया — इसे {label} पर साझा करें",
"hc.linkUnavailable": "लिंक अनुपलब्ध",
"hc.linkedTo": "जुड़ा हुआ",
"hc.listingHiddenByModeration": "सूची संचलन द्वारा छिपाई गई।",
"hc.loading": "लोड हो रहा है…",
"hc.locateMe": "मुझे खोजें",
"hc.logIn": "लॉग इन करें",
"hc.logInToGetBack": "अपने स्थान पर वापस जाने और अपनी सदस्यता प्रबंधित करने के लिए लॉग इन करें।",
"hc.loginFailed": "लॉगिन विफल",
"hc.lostFoundPlatform": "गुम और मिला платформा।",
"hc.lostIn": "में खो गया",
"hc.lowRate": "कम दर",
"hc.mainReason": "मुख्य कारण",
"hc.mainStreet": "मुख्य सड़क",
"hc.makeSureThisIsThe": "यह सुनिश्चित कर लें कि यह वह आइटम है जो आपने खोया है, खोजक के संपर्क विवरण अनलॉक करने से पहले।",
"hc.manageCookies": "कुकीज़ प्रबंधित करें",
"hc.manageMyTeam": "मेरी टीम प्रबंधित करें",
"hc.manageYourTeam": "अपनी टीम प्रबंधित करें",
"hc.markAsReturned": "लौटाए गए के रूप में चिह्नित करें",
"hc.matchNoClaimInTime": "मिलान के लिए समय सीमा के भीतर कोई दावा नहीं किया गया।",
"hc.matchNotFound": "मिलान नहीं मिला",
"hc.medium": "मध्यम",
"hc.milestoneFmt": "{m} लौटाए गए आइटम मील का पत्थर पूरा किया! {next} की ओर जा रहे हैं।",
"hc.missingFeatures": "गायब सुविधाएँ",
"hc.monthly": "मासिक",
"hc.monthlyBilling": "मासिक बिलिंग",
"hc.moveThePhotoToFit": "फोटो को गोल में फिट करने के लिए ले जाएँ।",
"hc.myAccount": "मेरा खाता",
"hc.myInvoices": "मेरे चालान",
"hc.myMonthlyInvoices": "मेरे मासिक चालान",
"hc.nArchived": "{n} लिस्टिंग(ज़) संग्रहित की गई हैं।",
"hc.newCodeGeneratedAndSent": "नया कोड उत्पन्न किया गया और ग्राहक को ईमेल और SMS द्वारा भेजा गया",
"hc.newCodeGeneratedAndSent2": "नया कोड उत्पन्न किया गया और मालिक को भेजा गया",
"hc.newPassword": "नया पासवर्ड",
"hc.next": "अगला",
"hc.nextPhoto": "अगली फ़ोटो",
"hc.no": "नहीं",
"hc.noAnswerProvided": "कोई उत्तर नहीं दिया गया।",
"hc.noArchivedDeclarations": "कोई संग्रहित घोषणाएँ नहीं",
"hc.noCountryFound": "कोई देश नहीं मिला",
"hc.noDeclarations": "कोई घोषणाएँ नहीं",
"hc.noFeesAreChargedTo": "ग्राहक से कोई शुल्क नहीं लिया गया।",
"hc.noInvoiceYet": "अभी तक कोई चालान नहीं।",
"hc.noInvoiceYetYourInvoices": "अभी तक कोई चालान नहीं। आपके चालान प्रत्येक भुगतान के बाद यहां स्वचालित रूप से दिखाई देंगे।",
"hc.noMatchIsAvailableFor": "अभी कोई मेल उपलब्ध नहीं है। जब भी कोई वस्तु आपकी घोषणा से मेल खाती है, हम आपको सूचित करेंगे।",
"hc.noShipmentMatchesYourSearch": "आपकी खोज से मेल खाने वाला कोई शिपमेंट नहीं है।",
"hc.noShipmentsYet": "अभी तक कोई शिपमेंट नहीं।",
"hc.noShipmentsYet2": "अभी तक कोई शिपमेंट नहीं",
"hc.none": "कोई नहीं",
"hc.noneChooseForEachShipment": "कोई नहीं (प्रत्येक शिपमेंट के लिए चुनें)",
"hc.notMine": "यह मेरा नहीं है",
"hc.of": "का",
"hc.only": "केवल",
"hc.onlyEachSiteManagesIts": "केवल। प्रत्येक साइट अपने स्वयं के बैंकिंग का प्रबंधन करती है: ये लिंक किसी अन्य संस्थान पर असर नहीं डालते।",
"hc.onlyTheOwnerOrAn": "केवल मालिक या एक प्रशासक संस्थान के भुगतान लिंक को कॉन्फ़िगर कर सकते हैं।",
"hc.openDepositInTheMenu": "메नू में \"जमा\" खोलें, वस्तु का वर्णन करें और एक फ़ोटो लें। यह तुरंत संग्रहीत किया जाता है और वापस करने के लिए तैयार होता है।",
"hc.openSettings": "सेटिंग्स खोलें →",
"hc.openTheDeclarationToManage": "शिपमेंट प्रबंधित करने के लिए घोषणा खोलें",
"hc.optional": "— वैकल्पिक",
"hc.optional2": "(वैकल्पिक)",
"hc.optional3": "वैकल्पिक",
"hc.originalListingPhotoUsed": "मूल लिस्टिंग फ़ोटो का उपयोग किया गया",
"hc.other": "अन्य",
"hc.other2": "अन्य…",
"hc.ourProducts": "हमारे उत्पाद",
"hc.overallRateTrendLast6": "समग्र दर प्रवृत्ति (अंतिम 6 महीने)",
"hc.ownerSClaimCode": "मालिक का दावा कोड",
"hc.ownershipConfirmed": "स्वामित्व की पुष्टि की गई",
"hc.paid": "भुगतान किया गया",
"hc.paidOn": "पर भुगतान किया गया",
"hc.paidViaPartner": "भुगतान (साझेदार के माध्यम से)",
"hc.parcelBeingPrepared": "पार्सल तैयार किया जा रहा है",
"hc.parcelDelivered": "पार्सल वितरित किया गया",
"hc.parcelShipped": "पार्सल भेज दिया गया",
"hc.parisGareDeLyon": "पेरिस, Gare de Lyon…",
"hc.partner": "साझेदार",
"hc.partner2": "साझेदार",
"hc.partnerDirectory": "साझेदार डायरेक्टरी",
"hc.passedOnToTheCustomer": "— ग्राहक को भुगतान लिंक सौंपा गया।",
"hc.password": "पासवर्ड",
"hc.passwordResetPleaseLogIn": "पासवर्ड रीसेट, कृपया लॉग इन करें।",
"hc.passwordUpdated": "पासवर्ड अपडेट किया गया।",
"hc.passwordsDoNotMatch": "पासवर्ड मेल नहीं खाते।",
"hc.pasteThisSenderIdIn": "यह सेंडर आईडी Findloop → सेटिंग्स में पेस्ट करें",
"hc.payForTheShipmentOf": "अपने आइटम के शिपमेंट के लिए Findloop के माध्यम से सुरक्षित भुगतान करें।",
"hc.payTheRecoveryFees": "पुनर्प्राप्ति शुल्क का भुगतान करें",
"hc.payTheShippingFees": "शिपिंग शुल्क का भुगतान करें",
"hc.payment": "भुगतान",
"hc.paymentAlreadyConfirmedByThe": "भुगतान पहले ही साझेदार द्वारा पुष्टि की गई है",
"hc.paymentLinksAreNowConfigured": "भुगतान लिंक अब प्रत्येक स्थापना के अनुसार कॉन्फ़िगर किए गए हैं",
"hc.paymentNotCompletedYourAccount": "भुगतान पूर्ण नहीं हुआ, आपका खाता नहीं बनाया गया है — कृपया पुनः प्रयास करें।",
"hc.paymentReceived": "भुगतान प्राप्त हुआ",
"hc.paymentSuccessful": "भुगतान सफल!",
"hc.pdfInvoice": "PDF चालान",
"hc.pending": "लंबित",
"hc.period": "अवधि",
"hc.phoneNumber": "फोन नंबर",
"hc.phoneOptional": "फोन (वैकल्पिक)",
"hc.planAt": "योजना पर",
"hc.planLimitFmt": "आपकी \"{plan}\" योजना {max} स्थापना तक सीमित है। {n} साइटों का प्रबंधन करने के लिए, हम अनुशंसा करते हैं",
"hc.platformReturnTarget": "प्लेटफार्म रिटर्न लक्ष्य",
"hc.pleaseCompleteYourShippingAddress": "कृपया अपना शिपिंग पता पूरा करें।",
"hc.pleaseProvideAPhoneNumber": "कृपया एक फोन नंबर प्रदान करें: यह परिवहनकर्ता द्वारा शिपिंग के लिए आवश्यक है।",
"hc.pleaseProvideAReason": "कृपया एक कारण प्रदान करें।",
"hc.pleaseSetYourOwnPassword": "कृपया आगे बढ़ने से पहले अपना खुद का पासवर्ड सेट करें।",
"hc.pointsToGoal": "{n} अधिक अंक हमारे साझा लक्ष्य तक पहुँचने के लिए।",
"hc.posterPreview": "पोस्टर पूर्वावलोकन",
"hc.potentialMatchBeingVerified": "संभावित मैच की जांच की जा रही है",
"hc.potentialOwner": "संभावित मालिक",
"hc.preFilledAutomaticallyYouCan": "स्वतः भरी गई — आप इसे पार्सल की फोटो से बदल सकते हैं।",
"hc.pressKit": "प्रेस किट",
"hc.previewMode": "पूर्वावलोकन मोड:",
"hc.previewOfThePrintReady": "इस प्रतिष्ठान के लिए प्रिंट-रेडी A4 पोस्टर का पूर्वावलोकन।",
"hc.previous": "पिछला",
"hc.previousPhoto": "पिछली फोटो",
"hc.primary": "प्राथमिक",
"hc.printThePoster": "पोस्टर प्रिंट करें",
"hc.privacy": "गोपनीयता",
"hc.privacyPolicy": "गोपनीयता नीति",
"hc.processedCasesWillAppearHere": "प्रसंस्कृत मामले यहाँ दिखाई देंगे।",
"hc.proofOfReturnPdf": "वापसी का प्रमाण (PDF)",
"hc.protectedByRecaptcha": "reCAPTCHA द्वारा सुरक्षित",
"hc.publicMatch": "सार्वजनिक मिलान",
"hc.putBackInStorage": "स्टोरेज में वापस डालें",
"hc.pwdResetByTeam": "आपका पासवर्ड हमारी टीम द्वारा रिसेट किया गया। आपकी सुरक्षा के लिए,",
"hc.questionsToAskTheOwner": "स्वामी से पूछने के लिए प्रश्न",
"hc.rateChargedToTheCustomer": "ग्राहक से फिर से वसूल की गई दर:",
"hc.rateOfTarget": "{rate}% का {target}% लक्ष्य प्राप्त किया गया",
"hc.reached": "पहुँच गया",
"hc.reactivating": "पुनः सक्रिय कर रहे हैं…",
"hc.reasonSavedYouCanStill": "कारण सुरक्षित किया गया। आप अभी भी अपनी वस्तु का दावा कर सकते हैं।",
"hc.recentMatchesFirst": "हाल के मिलान सबसे पहले",
"hc.recognizedThePhotoYouSent": "आपके द्वारा भेजी गई फोटो पहचानी गई और इन विशेषताओं का वर्णन किया गया। केवल पुष्टि करें यदि ये आपके पास मौजूद वस्तु से मेल खाते हैं।",
"hc.recommended": "अनुशंसित",
"hc.recoveryFees": "पुनर्प्राप्ति शुल्क",
"hc.recoveryFeesArePaidDirectly": "पुनर्प्राप्ति शुल्क सीधे भागीदार प्रतिष्ठान को भुगतान किया जाता है। Findloop ग्राहकों से कोई भुगतान नहीं लेता।",
"hc.recoveryFeesEnabled": "पुनर्प्राप्ति शुल्क सक्षम",
"hc.recoveryOfferedByTheEstablishment": "प्रतिष्ठान द्वारा पुनर्प्राप्ति की पेशकश की गई — Findloop कोई शुल्क नहीं लेता।",
"hc.recoveryPaymentLink": "पुनर्प्राप्ति भुगतान लिंक",
"hc.recoveryPaymentLinkSavedFor": "इस प्रतिष्ठान के लिए पुनर्प्राप्ति भुगतान लिंक सुरक्षित किया गया",
"hc.redirecting": "रीडायरेक्ट कर रहे हैं…",
"hc.redirectingToPayment": "भुगतान की ओर रीडायरेक्ट कर रहे हैं…",
"hc.redirectingToTheRecoveryOf": "आपकी वस्तु की पुनर्प्राप्ति की ओर रीडायरेक्ट कर रहे हैं…",
"hc.regenerateAndResendToThe": "स्वामी को फिर से उत्पन्न करें और पुनः भेजें",
"hc.regenerateTheCode": "कोड को फिर से उत्पन्न करें",
"hc.registerAFoundItem": "मिली हुई वस्तु को पंजीकरण करें",
"hc.rejectTheClaim": "दावे को अस्वीकार करें",
"hc.reminderDelaySaved": "याद दिलाने का विलंब सुरक्षित किया गया",
"hc.reopenThePaymentLink": "भुगतान लिंक को फिर से खोलें",
"hc.repeatThePassword": "पासवर्ड दोहराएँ",
"hc.reportAProblem": "समस्या की रिपोर्ट करें",
"hc.reportDismissedYourListingRemains": "रिपोर्ट अस्वीकृत। आपकी लिस्टिंग सार्वजनिक बनी रहती है।",
"hc.requiredUsedToCalculateThe": "आवश्यक: Sendcloud शिपिंग दर की गणना के लिए उपयोग किया जाता है। 30 किलोग्राम से ऊपर शिपिंग उपलब्ध नहीं है।",
"hc.reset": "रीसेट करें",
"hc.resume": "जारी रखें",
"hc.resumeRegistration": "पंजीकरण जारी रखें",
"hc.retro": "साल का अवलोकन",
"hc.returnSecurity": "प्रतिपूर्ति सुरक्षा",
"hc.returnToTheOwner": "स्वामी को वापस करें",
"hc.returned": "वापस किया गया",
"hc.reviewTheItemDetails": "वस्तु के विवरण की समीक्षा करें",
"hc.revokeAccess": "पहुँच को रद्द करें",
"hc.role": "भूमिका:",
"hc.save": "सहेजें",
"hc.save2": "सहेजें",
"hc.saveAndContinue": "सहेजें और जारी रखें",
"hc.saving": "सहेज रहा है…",
"hc.scanTheClaimCode": "दावा कोड स्कैन करें",
"hc.scanTheOwnerSQr": "स्वामी का क्यूआर स्कैन करें",
"hc.scrollThroughLanguages": "भाषाओं के माध्यम से स्क्रॉल करें",
"hc.searchByCustomerItemOr": "ग्राहक, वस्तु या ट्रैकिंग नंबर से खोजें…",
"hc.searchForACountry": "एक देश के लिए खोजें…",
"hc.secureFindoVerification": "सुरक्षित Findloop सत्यापन",
"hc.seeRetro": "साल का अवलोकन देखें",
"hc.selectedCarrier": "चुना हुआ कैरियर:",
"hc.selectedPlan": "चुना हुआ योजना",
"hc.send": "भेजें",
"hc.sendcloudSenderIdSaved": "Sendcloud प्रेषक आईडी सहेजी गई",
"hc.sendcloudSenderIdSenderId": "Sendcloud प्रेषक आईडी (sender_id)",
"hc.sending": "भेज रहा है…",
"hc.sessionExpired": "सेशन समाप्त हो गया",
"hc.setUpYourEstablishments": "अपने प्रतिष्ठानों की सेटअप करें",
"hc.settings": "सेटिंग्स",
"hc.settingsSubtitle": "बाहरी भुगतान और अलर्ट, प्रतिष्ठान के अनुसार कॉन्फ़िगर किया गया।",
"hc.shareFoundText": "मैंने एक वस्तु पाई - मुझे Findloop पर इसके स्वामी को खोजने में मदद करें",
"hc.shareLostText": "मैंने एक वस्तु खोई - मुझे Findloop पर इसे खोजने में मदद करें",
"hc.sharePreview": "पूर्वावलोकन साझा करें",
"hc.shareTheRanking": "रैंकिंग साझा करें",
"hc.shareYourQrCodeTo": "घोषणाएँ प्राप्त करने के लिए अपना क्यूआर कोड साझा करें।",
"hc.shipRateAutoWeight": "शिपिंग दर स्वचालित रूप से Sendcloud के माध्यम से गणना की जाती है (वजन {w}) शिपिंग के समय।",
"hc.shipRateForWeight": "शिपिंग दर (Sendcloud + {m}% मार्जिन) {w} के लिए:",
"hc.shipments": "शिपमेंट",
"hc.shipmentsSubtitle": "सभी मामलों में सभी प्रतिष्ठानों के शिपमेंट का समेकित दृश्य। शिपमेंट के प्रबंधन के लिए किसी पंक्ति पर क्लिक करें।",
"hc.shipping": "शिपिंग",
"hc.shippingAddress": "शिपिंग पता",
"hc.shippingFeesAreHandledAutomatically": "शिपिंग शुल्क स्वचालित रूप से Findloop (Sendcloud) द्वारा संभाले जाते हैं - दर्ज करने के लिए कोई लिंक नहीं।",
"hc.shippingFeesHaveAlreadyBeen": "शिपिंग शुल्क पहले ही भुगतान किए जा चुके हैं: वाहक को अब नहीं बदला जा सकता।",
"hc.shippingNotAvailableForItems": "30 किलोग्राम से अधिक सामान के लिए शिपिंग उपलब्ध नहीं है। ग्राहक को सामान व्यक्तिगत रूप से प्राप्त करना होगा।",
"hc.shippingPaid": "शिपिंग भुगतान किया ✓",
"hc.showOnlyItemsMatchingA": "केवल उन सामानों को दिखाएं जो एक सार्वजनिक (ग्राहक) सूची से मेल खाते हैं",
"hc.showPassword": "पासवर्ड दिखाएँ",
"hc.signInTheBoxAbove": "ऊपर दिए गए बॉक्स में साइन इन करें",
"hc.signatureSaved": "हस्ताक्षर सहेजा गया",
"hc.signedInWithGoogle": "गूगल से साइन इन किया गया",
"hc.signupFailed": "साइन-अप विफल",
"hc.silver": "चांदी",
"hc.simulatedRatesInPreProduction": "(पूर्व उत्पादन में अनुकरण किए गए दरें)",
"hc.siretAndVatNumberRequired": "SIRET और VAT नंबर आवश्यक है (फ्रांस)।",
"hc.skip": "छोड़ें",
"hc.smsSentIfAccount": "यदि इस नंबर के साथ एक खाता मौजूद है, तो आपको एक SMS भेजा गया है।",
"hc.sortItemsWithAPublic": "तरतीब: सार्वजनिक मेल के साथ सामान (सबसे हाल का) पहले",
"hc.specifyWhetherYouRecoveredYour": "यह निर्दिष्ट करें कि क्या आपने अपना सामान पुनर्प्राप्त किया या बस इस सूची को हटाना चाहते हैं।",
"hc.specifyYourReason": "अपने कारण को स्पष्ट करें",
"hc.specifyYourReason2": "अपने कारण को स्पष्ट करें…",
"hc.staff": "स्टाफ",
"hc.status": "स्थिति",
"hc.staySignedIn": "साइन इन रहिए",
"hc.step": "कदम",
"hc.stillThere": "अभी भी वहाँ?",
"hc.stopScrolling": "स्क्रॉल करना बंद करें",
"hc.storeFindWithQr": "QR के साथ स्टोर और खोजें",
"hc.streetName": "सड़क का नाम",
"hc.streetNo": "सड़क नंबर।",
"hc.switchTo": "पर स्विच करें",
"hc.switchToDarkMode": "अंधेरे मोड में स्विच करें",
"hc.switchToLightMode": "हल्के मोड में स्विच करें",
"hc.takeAPhoto": "एक फोटो लें",
"hc.takeChangeThePhoto": "फोटो लें / बदलें",
"hc.takenFromYourDeclaration": "आपकी घोषणा से लिया गया",
"hc.target": "लक्ष्य",
"hc.targetReached": "लक्ष्य प्राप्त किया",
"hc.targetReachedThankYouTo": "लक्ष्य प्राप्त किया — पूरी Findloop समुदाय को धन्यवाद!",
"hc.tellUsMore": "हमें अधिक बताएं…",
"hc.tellUsWhyYouCancel": "हमें बताएं कि आप क्यों रद्द कर रहे हैं। यह साथी को आपकी अनुरोध को संसाधित करने में मदद करता है।",
"hc.tellUsWhyYourListing": "हमें बताएं क्यों। आपकी लिस्टिंग सक्रिय है और आप अभी भी अपनी वस्तु का दावा कर सकते हैं।",
"hc.termsAndConditions": "नियम और शर्तें",
"hc.termsAndPolicies": "नियम और नीतियाँ",
"hc.thankYouForYourFeedback": "आपकी प्रतिक्रिया के लिए धन्यवाद",
"hc.theBannerDisplayedInThe": "रजिस्ट्र्री में प्रदर्शित बैनर।",
"hc.theClaimantHasBeenInformed": "दावेदार को सूचित कर दिया गया है। वस्तु सार्वजनिक लिस्टिंग में उपलब्ध है।",
"hc.theClaimantHasBeenNotified": "दावेदार को सूचित कर दिया गया है और अब वह वापसी की प्रक्रिया शुरू कर सकता है।",
"hc.theCustomerPaysTheFees": "ग्राहक संस्थान को फीस का भुगतान करता है।",
"hc.theDayTheLegalRetention": "विधिक रोक अवधि समाप्त होने का दिन।",
"hc.theEstablishmentConsideredThatThis": "संस्थान ने यह माना कि यह वस्तु आपकी नहीं है।",
"hc.theEstablishmentIsReviewingYour": "संस्थान आपके उत्तरों की समीक्षा कर रहा है। आपकी दावे की पुष्टि होने पर आपको सूचित किया जाएगा, तब आप वसूली शुल्क का भुगतान कर सकते हैं।",
"hc.theFeesAreTooHigh": "फीस बहुत अधिक हैं",
"hc.theFinderConsideredThatThis": "खोजकर्ता ने यह माना कि यह वस्तु आपकी नहीं है।",
"hc.theFinderIsReviewingYour": "खोजकर्ता आपका दावा समीक्षा कर रहा है। इसकी पुष्टि होने पर आपको सूचित किया जाएगा।",
"hc.theItem": "वस्तु",
"hc.theItemWillBeRemoved": "वस्तु रजिस्ट्र्री से हटा दी जाएगी (कोई दावा प्रगति में नहीं)।",
"hc.theItemWillBeSet": "वस्तु \"स्टॉक में\" पर वापस सेट की जाएगी और संबंधित दावा रद्द कर दिया जाएगा।",
"hc.theKbisNumberAndVat": "फ्रांस के लिए Kbis संख्या और VAT संख्या आवश्यक हैं।",
"hc.theLabelIsGeneratedAutomatically": "लेबल अपने आप उत्पन्न होता है जब ग्राहक ने शिपिंग शुल्क का भुगतान किया है। यह यहाँ से डाउनलोड किया जा सकेगा।",
"hc.theLinkMayHaveExpired": "लिंक समाप्त हो सकता है (30 दिनों के लिए मान्य)। आवश्यकता होने पर Findloop सहायता से संपर्क करें।",
"hc.theOwnerDescribesTheirItem": "मालिक अपनी वस्तु का विवरण देता है",
"hc.theOwnerReceivedItBy": "मालिक ने इसे ईमेल (या SMS) द्वारा प्राप्त किया। सौंपने से पहले इसे दर्ज करें या स्कैन करें।",
"hc.thePartnerConsideredThatThis": "साथी ने यह माना कि यह वस्तु आपकी नहीं है। वस्तु उपलब्ध है।",
"hc.thePartnerIsReviewingYour": "साथी आपके उत्तरों की समीक्षा कर रहा है। आपकी दावे की पुष्टि होने पर आपको सूचित किया जाएगा।",
"hc.theShipmentIsCreatedAutomatically": "शिपमेंट अपने आप उत्पन्न होता है जब ग्राहक ने अपना पता पुष्टि किया है और वसूली शुल्क का भुगतान किया है। लेबल फिर शिपिंग भुगतान के बाद अपने आप उत्पन्न होगा, और यहाँ से डाउनलोड किया जा सकेगा।",
"hc.theShippingRateWillBe": "शिपिंग दर शिपिंग के समय Sendcloud के माध्यम से अपने आप गणना की जाएगी (रिकॉर्डेड वजन)।",
"hc.thisCarrierWillBe": "यह कैरियर होगा",
"hc.thisEstablishment": "यह संस्थान",
"hc.thisFieldIsRequiredFor": "इस क्षेत्र की स्वचालित लेबल उत्पादन के लिए आवश्यकता है।",
"hc.thisIsMyItem": "यह मेरी वस्तु है",
"hc.thisIsMyItemContinue": "यह मेरी वस्तु है — जारी रखें",
"hc.thisIsMyItemStart": "यह मेरी वस्तु है — वापसी शुरू करें",
"hc.thisIsNotMyItem": "यह मेरी वस्तु नहीं है",
"hc.thisMatchIsNoLonger": "यह मिलान अब उपलब्ध नहीं है या पहले ही संसाधित हो चुका है।",
"hc.thisRateWillBeCharged": "यह दर ग्राहक से ली जाएगी। एक उच्च दर वसूली को हतोत्साहित कर सकती है।",
"hc.thisStepIsRequiredFor": "इस चरण की आवश्यकता शिपिंग लेबल उत्पन्न करने के लिए है।",
"hc.thisValidationLinkIsInvalid": "यह सत्यापन लिंक अमान्य है या समाप्त हो गया है।",
"hc.toCheckBeforeMarkingThe": "आइटम को वापस किया गया के रूप में मार्क करने से पहले जांचें।",
"hc.toConfigureTheLinksAnd": "प्रत्येक प्रतिष्ठान के लिए लिंक और अनुस्मारक समय सीमा कॉन्फ़िगर करने के लिए।",
"hc.toReachOurFirstMilestone": "हमारे पहले मील के पत्थर 100 रिटर्न को पूरा करने के लिए।",
"hc.toTheCustomer": "ग्राहक के लिए।",
"hc.toTheShippingFeePayment": "शिपिंग शुल्क भुगतान के लिए।",
"hc.toYourRecoveryTracking": "आपकी पुनर्प्राप्ति ट्रैकिंग के लिए।",
"hc.tooExpensiveBudget": "बहुत महंगा / बजट",
"hc.topCitiesForReturns": "रिटर्न के लिए शीर्ष शहर",
"hc.trackMyRecovery": "मेरी पुनर्प्राप्ति ट्रैक करें",
"hc.trackTheShipmentAndDownload": "शिपमेंट को ट्रैक करें और लेबल डाउनलोड करें (स्वचालित रूप से उत्पन्न) बिना डिक्लेरेशन टैब छोड़े।",
"hc.trackYourStatistics": "अपनी सांख्यिकी ट्रैक करें",
"hc.tracking": "ट्रैकिंग",
"hc.unableToOpenTheShipping": "शिपिंग शुल्क भुगतान खोलने में असमर्थ। कृपया पुनः प्रयास करें।",
"hc.unableToRetrieveTheInvoice": "चालान पुनर्प्राप्त करने में असमर्थ।",
"hc.unclaimed": "अअनुचित",
"hc.unclaimedCustomerReason": "अअनुचित आइटम। ग्राहक का कारण: \"{reason}\"।",
"hc.unclaimedItem": "अअनुचित आइटम",
"hc.unclaimedItemNoClaimWithin": "अअनुचित आइटम - समय सीमा के भीतर कोई दावा नहीं।",
"hc.unclaimedItems": "अअनुचित आइटम",
"hc.unclaimedItemsMatchLeftWithout": "अअनुचित आइटम: समय सीमा के भीतर कोई दावा नहीं किया गया। आप इन्हें स्टोरेज में वापस रख सकते हैं।",
"hc.unlockTheFinderSContact": "हस्तांतरण की व्यवस्था के लिए फाइंडर का संपर्क विवरण अनलॉक करें।",
"hc.upcoming": "आगामी",
"hc.updateFailed": "अपडेट विफल रहा।",
"hc.usedForInvoices": "आपके Findloop चालान जारी करने के लिए उपयोग किया जाता है।",
"hc.vatNumber": "वैट नंबर",
"hc.verificationPending": "सत्यापन लंबित",
"hc.verificationSentToTheFinder": "सत्यापन फाइंडर को भेजा गया। आपको उनके निर्णय के बारे में सूचित किया जाएगा।",
"hc.verificationSentToThePartner": "सत्यापन भागीदार को भेजा गया। आपको उनके निर्णय के बारे में सूचित किया जाएगा।",
"hc.verify": "सत्यापित करें",
"hc.verifyingInvite": "आमंत्रण लिंक की सत्यापन कर रहे हैं…",
"hc.verifyingTheLink": "लिंक की सत्यापन कर रहे हैं…",
"hc.viewInRegistry": "पंजीकरण में देखें",
"hc.viewItem": "आइटम देखें",
"hc.viewItemRecover": "आइटम देखें और पुनर्प्राप्त करें",
"hc.visibleToTheOwnerAutomatically": "स्वामी के लिए दिखाई देने योग्य · 60 दिन बाद स्वचालित रूप से हटा दिया जाएगा।",
"hc.waitingForPartnerConfirmation": "भागीदार की पुष्टि के लिए प्रतीक्षा कर रहे हैं",
"hc.waitingForThePartnerS": "भागीदार की पुष्टि की प्रतीक्षा कर रहे हैं",
"hc.weHaveInformedTheEstablishment": "हमने प्रतिष्ठान को सूचित किया है कि यह आइटम आपका नहीं है और विश्लेषण फिर से शुरू कर दिया है। आपको सूचित किया जाएगा जैसे ही एक नया मिलान पाया जाएगा।",
"hc.weHaveInformedThePartner": "हमने भागीदार को सूचित किया है कि यह आइटम आपका नहीं है। आपकी लिस्टिंग भविष्य के मैच के लिए सक्रिय रहती है।",
"pricing.physInvTitle": "शारीरिक सूची ट्रैकिंग",
"pricing.physModalTitle": "शारीरिक वस्तु प्रबंधन",
"pricing.physQrDesc": "प्रत्येक वस्तु के लिए एक अद्वितीय QR कोड उत्पन्न होता है और यह इसकी सभी जानकारी से जुड़ता है।",
"pricing.physQrTitle": "निर्धारित QR लेबल",
"pricing.physShelfDesc": "प्रत्येक पंजीकृत वस्तु को संस्थान के भीतर एक भौतिक स्थान सौंपा जा सकता है।",
"pricing.physShelfTitle": "शेल्फ योजना",
"pricing.physicalMgmt": "भौतिक वस्तु प्रबंधन (शेल्फ, QR, सूची)",
"pub.addSecondPhoto": "एक 2रा फोटो जोड़ें (वैकल्पिक)",
"pub.photo2Added": "✓ 2रा फोटो जोड़ा गया",
"reg.dispositionJournal": "डिस्पोजिशन जर्नल",
"reg.dispositionNoteAuthHint": "ℹ️ “संपर्क अधिकारियों को सौंपा गया” के लिए एक नोट आवश्यक है (रिपोर्ट संख्या, विभाग…)",
"reg.dispositionNotePh": "नोट (वैकल्पिक): प्राप्तकर्ता चैरिटी, अधिकारियों का संदर्भ, खरीदार का नाम…",
"reg.dispositionNoteRequired": "अधिकारियों को सौंपने के लिए एक आधिकारिक संदर्भ आवश्यक है।",
"reg.legalPrealert": "{days} दिन में कानूनी समय सीमा",
"reg.legalPrealertOptions": "समय सीमा पर विकल्प: नीलामी बिक्री, चैरिटी को दान, अधिकारियों को सौंपना।",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "पूर्ण समीक्षा",
"rev.readMore": "और पढ़ें",
"rw.activeCodes": "सक्रिय वाउचर",
"rw.archived": "आर्काइव किया गया",
"rw.archivedTitle": "अधिग्रहित वाउचर (आर्काइव किया गया)",
"rw.hideArchived": "अधिग्रहित वाउचर छिपाएँ",
"rw.noArchived": "कोई आर्काइव किया गया वाउचर नहीं।",
"rw.showArchived": "अधिग्रहित वाउचर दिखाएँ",
"shp.labelAuto": "लेबल ग्राहक द्वारा शिपिंग शुल्क चुकाने पर स्वतः उत्पन्न होता है। इसे यहाँ डाउनलोड किया जा सकेगा।",
"st.cancelled_by_customer": "रद्द किया गया",
"stt.dispoPdfBtn": "PDF निर्यात करें",
"stt.dispoPdfError": "PDF निर्यात असफल।",
"stt.dispoPdfExporting": "निर्यात किया जा रहा है…",
"trk.matchVerifying": "संभावित मिलान की पुष्टि की जा रही है",
"home.videoEyebrow": "देखें",
"home.videoSubtitle": "कैसे हम खोई हुई वस्तुओं को उनके मालिकों से बिना किसी कठिनाई के वापस मिलाते हैं।",
"home.videoTitle": "2 मिनट में Findloop का पता लगाएं",
"home.watchYoutube": "YouTube पर देखें",
"impact.already": "पहले से ही",
"impact.citiesWord": "शहर/शहरों",
"impact.eachPoint": "हर बिंदु एक शहर है जहाँ Findloop खोई हुई वस्तुओं की वसूली करने में मदद करता है।",
"impact.emptyMap": "नक्शा भरेगा जैसे-जैसे पुनर्प्राप्तियाँ होती हैं।",
"impact.eyebrow": "हमारा प्रभाव",
"impact.inCities": "में",
"impact.restitutedTo": "वस्तुएं उनके मालिकों को वापस की गईं",
"impact.title": "वस्तुएं, आपके आसपास हर जगह वापस की गईं",
"inv2.download": "डाउनलोड करें",
"inv2.view": "देखें",
"map.objectsOnMapPlural": "नक्शे पर वस्तुएं",
"map.objectsOnMapSingular": "नक्शे पर वस्तु",
"mc.claimConfirmDesc": "भुगतान करने से पहले फाइंडर द्वारा पाए गए वस्तु की जांच करें ताकि उनके संपर्क विवरण अनलॉक हो सकें।",
"mc.claimConfirmNo": "यह मेरी वस्तु नहीं है",
"mc.claimConfirmTitle": "क्या यह सच में आपकी वस्तु है?",
"mc.claimConfirmYes": "हाँ, यह मेरी है — भुगतान करें",
"mc.claimFinderContacts": "फाइंडर के संपर्क विवरण",
"mc.claimNotMineDone": "धन्यवाद — फाइंडर को सूचित कर दिया गया है और आपका अनुरोध विज्ञापन से हटा दिया गया है।",
"mc.claimUnlockDesc": "आपकी वस्तु जिसे पाया गया है, उसके व्यक्ति के संपर्क विवरण प्राप्त करने के लिए Findloop प्रबंधन शुल्क का भुगतान करें।",
"mc.claimUnlockTitle": "फाइंडर के संपर्क विवरण अनलॉक करें",
"mc.hideCountryOffers": "मेरे देश में ऑफ़र छुपाएँ",
"mc.myClaims": "वस्तुएं जिन्हें मैं दावे कर रहा हूँ",
"mc.myClaimsSub": "अन्य द्वारा पाई गई वस्तुएं जिन्हें आप दावा कर रहे हैं। फाइंडर के संपर्क विवरण अनलॉक करें ताकि सौदे को व्यवस्थित किया जा सके।",
"mc.notifAdCancelled": "विज्ञापन रद्द किया गया",
"mc.notifCancelAd": "मेरे विज्ञापन को रद्द करें",
"mc.offersInCountry": "मेरे देश में ऑफ़र",
"mc.offersInCountryDesc": "आपके देश में शहर के अनुसार भागीदारों से सभी सक्रिय पुरस्कार।",
"mc.redArchived": "आर्काइव्ड",
"mc.rewardsCountryNone": "अभी आपके देश में कोई ऑफ़र नहीं है।",
"mc.rewardsForYou": "आपके लिए पुरस्कार",
"mc.rewardsForYouDesc": "जिन भागीदारों के माध्यम से आपने वस्तु गिराई, द्वारा पेश किए गए।",
"mc.rewardsMineNone": "आपके ड्रॉप-ऑफ भागीदारों से अभी कोई पुरस्कार नहीं है।",
"mc.showCountryOffers": "मेरे देश में ऑफ़र देखें",
"mc2.cancelDecl": "मेरे घोषणा को रद्द करें",
"mc2.cancelDeclDone": "घोषणा रद्द कर दी गई।",
"pricing.physInvDesc": "जब कोई वस्तु वापस की जाती है, तो इसका स्थान स्वचालित रूप से मुक्त हो जाता है और एक नई वस्तु के लिए उपलब्ध हो जाता है।",
"hc.weRanTheAnalysisAgain": "हमने फिर से विश्लेषण किया और एक और आइटम पहचाना जो आपका हो सकता है। कृपया इसे फिर से चेक करें।",
"hc.weight": "वजन",
"hc.weightNotProvidedTheShipping": "वजन प्रदान नहीं किया गया: शिपिंग दर शिपिंग के समय पर निर्धारित की जाएगी।",
"hc.weightUnit": "वजन इकाई",
"hc.welcome": "स्वागत है!",
"hc.welcomeToFindo": "Findloop में आपका स्वागत है",
"hc.whenACustomerComesTo": "जब एक ग्राहक अपनी वस्तुएं लेने आता है, तो उनका घोषणा पत्र खोलें और वापसी को मान्य करें। बस इतना ही!",
"hc.whenDisabledFeesDropTo": ". जब अक्षम हो, फीस घटकर",
"hc.whyIsThisNotYour": "यह आइटम आपका क्यों नहीं है?",
"hc.willBeMarkedAs": "को चिह्नित किया जाएगा",
"hc.wrongColor": "गलत रंग",
"hc.wrongModel": "गलत मॉडल",
"hc.yesCancel": "हाँ, रद्द करें",
"hc.yesContactTheFinder": "हाँ, खोजकर्ता से संपर्क करें",
"hc.youAreHere": "आप यहाँ हैं",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "आप अब वापसी शुरू कर सकते हैं।",
"hc.youCanStillChangeIt": ". आप इसे मामले दर मामले अभी भी बदल सकते हैं।",
"hc.youHaveAlreadyConfirmedThat": "आपने पहले ही पुष्टि कर दी है कि यह आपका आइटम है।",
"hc.youWillBeRedirectedTo": "आपका सुरक्षित Stripe भुगतान पृष्ठ पर पुनर्निर्देशित किया जाएगा।",
"hc.yourAccountHasBeenReactivated": "आपका खाता फिर से सक्रिय किया गया है।",
"hc.yourAccountIsActiveYou": "आपका खाता सक्रिय है, आप अब अपने प्रतिष्ठानों का प्रबंधन कर सकते हैं।",
"hc.yourEstablishment": "आपका प्रतिष्ठान",
"hc.yourFeedbackHelpsUsImprove": "आपका फीडबैक हमें अपने मिलान सुधारने में मदद करता है।",
"hc.yourFeedbackHelpsUsRestart": "आपका फीडबैक हमें विश्लेषण फिर से शुरू करने और अपने मिलान सुधारने में मदद करता है।",
"hc.yourFirstSteps": "आपके पहले कदम",
"hc.yourFirstStepsAdmin": "आपके पहले कदम (व्यवस्थापक)",
"hc.yourItemHasBeenHanded": "आपका आइटम भागीदार द्वारा व्यक्तिगत रूप से सौंपा गया है - हैंडओवर की पुष्टि होने पर केस बंद करें।",
"hc.yourItemHasBeenShipped": "आपका आइटम भागीदार द्वारा भेज दिया गया है - डिलीवरी की पुष्टि होने पर केस बंद करें।",
"hc.yourPaymentHasBeenRecorded": "आपका भुगतान रिकॉर्ड कर लिया गया है।",
"hc.yourShipmentIsBeingPrepared": "आपका शिपमेंट तैयार किया जा रहा है। आपको 3 से 5 कार्य दिवसों के भीतर आपका पैकेज मिलेगा।",
"hc.yourShippingFeesHaveAlready": "आपकी शिपिंग शुल्क पहले ही चुकाई जा चुकी है। शिपिंग चुकाई गई ✓",
"hc.yourShippingFeesHaveBeen": "आपकी शिपिंग शुल्क का भुगतान किया गया है। आपका पैकेज तैयार किया जा रहा है।",
"hc.yourVerificationQuestionsDeposit": "आपके सत्यापन प्रश्न (जमा)",
"hero.einvoiceBadge": "2027-अनुरूप ई-इनवॉइस",
"home.recentAdsAll": "सभी सूचियाँ देखें",
"home.recentAdsEyebrow": "अभी",
"home.recentAdsSubtitle": "समुदाय द्वारा रिपोर्ट की गई खोई हुई और मिली वस्तुएं।",
"home.recentAdsTitle": "नवीनतम सूचनाएँ",
"home.reunions": "हालिया पुनर्मिलन",
"pcat.stadium_arena": "स्टेडियम / एरिना",
"pcat.supermarket": "सुपरमार्केट",
"pcat.taxi_vtc": "टैक्सी / राइड-हेलिंग",
"pcat.tourism_office": "पर्यटक कार्यालय",
"pcat.train_bus_station": "ट्रेन / बस स्टेशन",
"pcat.travel_agency": "यात्रा एजेंसी",
"hc.and": "और",
"hc.demoObj0": "एक बटुआ",
"hc.demoObj1": "एक खेल बैग",
"hc.demoObj2": "एक फोन",
"hc.demoObj3": "एक चश्मे का जोड़ा",
"hc.demoObj4": "कुंजियों का एक सेट",
"hc.demoObj5": "एक स्कार्फ",
"hc.demoObj6": "एक लैपटॉप",
"hc.demoObj7": "एक पानी की बोतल",
"hc.demoWhen0": "2 घंटे पहले",
"hc.demoWhen1": "5 घंटे पहले",
"hc.demoWhen2": "कल",
"hc.demoWhen3": "3 घंटे पहले",
"hc.demoWhen4": "आज सुबह",
"hc.demoWhen5": "1 दिन पहले",
"hc.feedDemo": "{obj} को {city} में {when} लौटाया गया।",
"hc.feedReal": "एक वस्तु ({cat}) को {city} में लौटाया गया।",
"hc.saveBtn": "सहेजें",
"hc.saveLink": "लिंक सहेजें",
"hc.terms": "नियतियाँ",
"hc.view": "देखें",
"pcat.airline": "एयरलाइन",
"pcat.airport": "हवाई अड़डा",
"pcat.amusement_park": "मनोरंजन पार्क",
"pcat.bank": "बैंक",
"pcat.bar_cafe": "बार / कैफ़े",
"pcat.beauty_salon": "बाल / ब्यूटी सैलून",
"pcat.cinema": "सिनेमाघर",
"pcat.concert_theater": "संगीत समारोह हॉल / रंगमंच",
"pcat.coworking": "को-वर्किंग स्पेस",
"pcat.gym_fitness": "जिम / फिटनेस",
"pcat.hospital_clinic": "अस्पताल / क्लिनिक",
"pcat.library": "पुस्तकालय",
"pcat.mall": "शॉपिंग मॉल",
"pcat.museum": "संग्रहालय",
"pcat.pharmacy": "फार्मेसी",
"pcat.private_company": "निजी कंपनी",
"pcat.public_transport": "सार्वजनिक परिवहन",
"pcat.school_university": "स्कूल / विश्वविद्यालय",
"pcat.sports_center": "खेल केंद्र",
"an.geoBanner": "आप लिस्टिंग देख रहे हैं",
"rw.fValidity": "वाउचर वैधता (भुनाने के {days} दिन बाद)",
"an.found": "मिला",
"an.lost": "खो गया",
"hc.shareReview": "समीक्षा साझा करें",
"hc.citiesAboveTarget": "{n} शहर अपने लक्ष्य से ऊपर",
"hc.cityAboveTarget": "{n} शहर अपने लक्ष्य से ऊपर",
"hc.j15EarlyReminder": "D-15 प्रारंभिक अनुस्मारक",
"hc.j7EarlyReminder": "D-7 प्रारंभिक अनुस्मारक",
"hc.annualTotal": "वार्षिक कुल",
"hc.billedOnceYear": "12 महीनों के लिए एक बार शुल्क लिया जाता है, हर वर्ष नवीनीकरण होता है।",
"hc.monthlyPrice": "मासिक मूल्य",
"hc.perMonth": "/ माह",
"hc.perYear": "/ वर्ष",
"hc.billedEachMonth": "हर महीने स्वतः शुल्क लिया जाएगा।",
"nav.business": "व्यवसाय",
"nav.individual": "व्यक्तिगत",
"hc.circumstancesFound": "खोज के हालात",
"hc.circumstancesFoundPh": "जैसे, मेट्रो के प्रवेश द्वार के पास ज़मीन पर मिला",
"hc.circumstancesLost": "खोने के हालात",
"hc.circumstancesLostPh": "जैसे, बस का इंतज़ार करते समय बेंच पर छोड़ा",
"hc.conditionPh": "जैसे, अच्छा, खरोंच वाला...",
"hc.firstName": "पहला नाम",
"hc.lastName": "अंतिम नाम",
"hc.quantity": "सामानों की संख्या",
"fa.approve": "स्वीकृत करें",
"fa.approveConfirm": "क्या आप इस घोषणा को स्वीकृत करते हैं? आपकी पूर्ण संपर्क जानकारी (नाम, ईमेल, फोन) खोजकर्ता के साथ साझा की जाएगी।",
"fa.approved": "घोषणा स्वीकृत — संपर्क जानकारी साझा की गई",
"fa.approvedFinder": "स्वामी ने आपकी घोषणा को स्वीकृत किया",
"fa.approvedFinderText": "वापसी की व्यवस्था करने के लिए उनसे संपर्क करें।",
"fa.boostSub": "आपकी लिस्टिंग चयनित अवधि के लिए शीर्ष पर रहती है।",
"fa.boostTitle": "मेरी लिस्टिंग बढ़ाएं (वैकल्पिक)",
"fa.colFinder": "खोजकर्ता की घोषणा",
"fa.colYours": "आपकी घोषणा",
"fa.compareHint": "निर्णय लेने से पहले खोजकर्ता की घोषणा की तुलना आपकी घोषणा से करें।",
"fa.contribNone": "कोई योगदान नहीं",
"fa.contribPaid": "योगदान प्राप्त हुआ — धन्यवाद!",
"fa.contribPending": "योगदान भुगतान की प्रतीक्षा है",
"fa.contribSub": "ज्यादा लोगों को उनके सामान वापस पाने में मदद करने के लिए Findloop का समर्थन करें। आप €0 चुन सकते हैं।",
"fa.contribSuccessMsg": "आपकी घोषणा स्वामी को भेज दी गई है।",
"fa.contribSuccessTitle": "आपके योगदान के लिए धन्यवाद",
"fa.contribTitle": "स्वैच्छिक योगदान",
"fa.days3": "3 दिन",
"fa.days30": "30 दिन",
"fa.days7": "7 दिन",
"fa.declSub": "उस वस्तु का वर्णन करें जो आप ने पाई है। स्वामी आपकी घोषणा की तुलना उनकी से करेगा।",
"fa.declTitle": "मैंने यह वस्तु पाई",
"fa.expiresOn": "समाप्ति तिथि",
"fa.fBrand": "ब्रांड",
"fa.fCircumstances": "परिस्थितियाँ",
"fa.fCity": "शहर",
"fa.fColor": "रंग",
"fa.fCondition": "स्थिति",
"fa.fDate": "तारीख",
"fa.fMessage": "खोजकर्ता का संदेश",
"fa.fPlace": "स्थान",
"fa.fQuantity": "मात्रा",
"fa.finderContact": "खोजकर्ता के संपर्क विवरण",
"fa.finishPay": "भुगतान पूरा करें",
"fa.foundDate": "पाई गई तारीख",
"fa.foundPlace": "पाई गई जगह",
"fa.hours24": "24 घंटे",
"fa.ht": "बिना VAT",
"fa.months3": "3 महीने",
"fa.noBoost": "कोई बढ़ावा नहीं",
"fa.ownerContact": "मालिक की संपर्क जानकारी",
"fa.payPublish": "भुगतान करें और प्रकाशित करें",
"fa.pendingPayText": "आपकी सूची तब लाइव होगी जब भुगतान की पुष्टि हो जाएगी।",
"fa.pendingPayTitle": "भुगतान लंबित",
"fa.planSub": "आपकी सूची तब लाइव होगी जब भुगतान की पुष्टि हो जाएगी।",
"fa.planTitle": "सूची की अवधि",
"fa.pubSuccessMsg": "आपकी सूची लाइव है। आपको सूचित किया जाएगा जब कोई खोजने वाला सामने आएगा।",
"fa.pubSuccessTitle": "सूची प्रकाशित",
"fa.publicNote": "केवल विवरण, शहर, देश और फोटो सार्वजनिक रूप से दिखाए जाते हैं।",
"fa.redirectStripe": "सुरक्षित भुगतान के लिए रीडायरेक्ट किया जा रहा है…",
"fa.reject": "अस्वीकृत करें",
"fa.rejectConfirm": "क्या इस घोषणा को अस्वीकृत करें? आपकी सूची ऑनलाइन रहेगी।",
"fa.rejected": "घोषणा अस्वीकृत",
"fa.rejectedFinder": "यह वह सामान नहीं था जिसे वे ढूंढ रहे थे",
"fa.rejectedFinderText": "मालिक का कहना है कि यह सामान उनका नहीं है। आपकी मदद के लिए धन्यवाद!",
"fa.responsesTitle": "खोजकर्ता की घोषणाएं",
"fa.sent": "घोषणा मालिक को भेजी गई।",
"fa.submitDecl": "मेरी घोषणा भेजें",
"fa.submitDeclPay": "भेजें और योगदान करें {amount}",
"fa.total": "कुल भुगतान",
"fa.ttc": "समावेशित। VAT",
"fa.waitClaimText": "खोजकर्ता आपके अनुरोध की समीक्षा कर रहा है। आपको उनके निर्णय की जानकारी दी जाएगी।",
"fa.waitFinderText": "जब कोई खोजने वाला घोषणा प्रस्तुत करेगा, तो हम आपको सूचित करेंगे।",
"fa.waitFinderTitle": "आपकी सूची लाइव है",
"fa.waitOwnerText": "मालिक आपकी घोषणा की तुलना अपनी के साथ कर रहा है। आपको उनके निर्णय की जानकारी दी जाएगी।",
"fa.waitOwnerTitle": "मालिक के निर्णय की प्रतीक्षा कर रहे हैं",
"st.pending_payment": "भुगतान लंबित",
"fa.africaFree": "अफ्रीका में मुफ्त लिस्टिंग — Findloop लॉन्च ऑफर, इसका आनंद लें!",
"fa.africaPublished": "लिस्टिंग मुफ्त में प्रकाशित हुई — अफ्रीका लॉन्च ऑफर!",
"fa.approveClaimConfirm": "क्या आप इस दावा को मंजूर करते हैं? फिर मालिक आपके संपर्क विवरण को अनलॉक कर सकेगा।",
"fa.checkInfo": "भेजने से पहले अपने विवरण की जाँच करें: उन्हें खोजकर्ता के साथ तुलना की जाएगी।",
"fa.claimApprovedShort": "खोजकर्ता ने आपका दावा मंजूर कर लिया",
"fa.claimRejectedShort": "दावा खोजकर्ता द्वारा अस्वीकृत",
"fa.claimRejectedText": "खोजकर्ता मानता है कि यह आइटम आपका नहीं है।",
"fa.claimSub": "अपनी आइटम का विवरण दें और 2 फोटो जोड़ें। खोजकर्ता उन्हें अपनी लिस्टिंग के साथ तुलना करेगा।",
"fa.claimTitle": "यह मेरी आइटम है",
"fa.claimUnlockText": "वापसी व्यवस्था करने के लिए खोजकर्ता के संपर्क विवरण अनलॉक करें।",
"fa.claimUnlockedShort": "संपर्क विवरण अनलॉक किया गया — ट्रैकिंग देखें",
"fa.claimsTitle": "मालिक के दावे",
"fa.colOwner": "मालिक की घोषणा",
"fa.colYourAd": "आपकी लिस्टिंग",
"fa.expired": "लिस्टिंग समाप्त",
"fa.free": "मुफ्त",
"fa.lostDate": "खोने की तिथि",
"fa.lostPlace": "खोने का स्थान",
"fa.noReceipt": "इस लिस्टिंग के लिए कोई रसीद उपलब्ध नहीं है।",
"fa.planSubFree": "अवधि चुनें: आपकी लिस्टिंग तुरंत लाइव होती है, कोई भुगतान आवश्यक नहीं।",
"fa.prefillPrevious": "इस श्रेणी में मेरी पिछली लिस्टिंग के विवरण का पुनः उपयोग करें",
"fa.receipt": "PDF रसीद",
"fa.renewBtn": "नवीनीकरण करें",
"fa.renewDiscountBanner": "50% छूट: अपनी लिस्टिंग समाप्त होने से पहले नवीनीकरण करें!",
"fa.renewDiscountHint": "समय समाप्त होने से पहले नवीनीकरण करने पर 50% छूट लागू की गई।",
"fa.renewEarly": "नवीनीकरण करें (−50%)",
"fa.renewTitle": "मेरी लिस्टिंग का नवीनीकरण करें",
"fa.renewed": "लिस्टिंग नवीनीकरण किया गया",
"fa.sendClaim": "मेरा दावा भेजें",
"fa.twoPhotos": "आपकी आइटम की 2 फोटो",
"fa.twoPhotosError": "अपनी आइटम की 2 फोटो जोड़ें।",
"fa.twoPhotosHint": "व्यक्तिगत फोटो जो साबित करती हैं कि यह आइटम आपका है (आइटम के साथ, चालान, बॉक्स…)।",
"fa.unlockBtn": "संपर्क विवरण अनलॉक करें",
"fa.unlockFree": "मुफ्त के लिए अनलॉक करें — लॉन्च ऑफर",
"fa.waitClaimantText": "जैसे ही कोई मालिक इस आइटम का दावा करता है, हम आपको सूचित करेंगे।",
"fa.waitFinderDecision": "खोजकर्ता के निर्णय की प्रतीक्षा कर रहे हैं",
"fa.waitUnlockText": "जैसे ही संपर्क विवरण का आदान-प्रदान होगा, आपको सूचित किया जाएगा।",
"fa.waitUnlockTitle": "मालिक के अनलॉक करने का इंतजार",
"fa.cancel": "रद्द करें",
"fa.categoryRequired": "पाई गई वस्तु के लिए एक श्रेणी चुनें।",
"fa.confirmTitle": "अपने निर्णय की पुष्टि करें",
"fa.goBack": "वापस जाओ",
"dr.continue": "मेरी घोषणा जारी रखें",
"dr.delete": "स्थायी रूप से हटाएं",
"dr.deleteConfirm": "क्या आप इस ड्राफ्ट को स्थायी रूप से हटाना चाहते हैं? यह वापस नहीं किया जा सकता।",
"dr.deleted": "ड्राफ्ट हटाया गया",
"dr.expiresIn": "{h} और घंटों तक ड्राफ्ट रखा गया",
"dr.title": "आपके पास एक अधूरी घोषणा है",
"form.step": "कदम",
"form.next": "जारी रखें",
"form.back": "पीछे",
"form.stepDetails": "आपकी रिपोर्ट",
"form.stepPublish": "अवधि, बूस्ट और भुगतान",
"form.stepThanks": "धन्यवाद एवं योगदान",
"fthx.badge": "रिपोर्ट लगभग पूरी हुई",
"fthx.title": "धन्यवाद, आप एक बदलाव ला रहे हैं!",
"fthx.text": "आपकी वजह से, कोई जल्द ही वह चीज़ वापस पा सकता है जो उनके लिए महत्वपूर्ण है। आपकी तरह की दयालुता वह है जो Findloop को जीवित रखती है।",
"fthx.impact1": "1 आइटम रिपोर्ट किया गया",
"fthx.impact2": "पुनर्मिलन का 1 और मौका",
"fthx.tipTitle": "Findloop के लिए एक छोटा सा प्रोत्साहन?",
"fthx.tipText": "आपका योगदान हमें सेवा को सुलभ बनाने और अधिक से अधिक वस्तुओं को उनके मालिकों के साथ पुनः जोड़ने में मदद करता है।",
"fthx.optional": "100% वैकल्पिक — आप योगदान किए बिना प्रकाशित कर सकते हैं।",
"fthx.thanksTip": "आपकी उदारता के लिए बहुत धन्यवाद!",
"fthx.suggest": "सुझाए गए आंकड़े",
"fthx.none": "कोई टिप नहीं",
"pay.pendingTitle": "भुगतान पूरा नहीं हुआ",
"pay.pendingText": "आपकी जानकारी सेव कर ली गई है। भुगतान वहीं से जारी रखें जहां आपने छोड़ा था।",
"pay.resume": "भुगतान फिर से शुरू करें",
"pay.expiredTitle": "भुगतान सत्र समाप्त हो गया",
"pay.expiredText": "आपकी सुरक्षा के लिए, भुगतान सत्र समाप्त हो गया। आपकी जानकारी सुरक्षित है: एक क्लिक में भुगतान फिर से शुरू करें।",
"pay.relaunch": "भुगतान फिर से शुरू करें",
"sub.received": "भेजा गया!",
"sub.publishing": "हम अंतिम प्रक्रिया कर रहे हैं…",
"sub.toPayment": "सुरक्षित भुगतान के लिए पुनर्निर्देशित किया जा रहा है…",
"fa.claimSubV2": "अपने खोए हुए वस्तु का वर्णन करें। जिसने इसे पाया है, वह आपके विवरण की तुलना अपनी सूची से करेगा।",
"fa.photosOptional": "आपकी वस्तु की फोटो (वैकल्पिक)",
"fa.compareOwnerHint": "इस जानकारी की तुलना उस वस्तु से करें जो आपने पाई है, फिर बताएं कि यह वही वस्तु है या नहीं।",
"fa.itsThisItem": "हाँ, यह वही वस्तु है",
"fa.notThisItem": "नहीं, यह वस्तु नहीं है",
"fa.confirmIsItem": "क्या पुष्टि करें कि यह वस्तु है? आपके संपर्क विवरण और मालिक के विवरण आपके संबंधित खातों में दिखाए जाएंगे।",
"fa.confirmNotItem": "क्या पुष्टि करें कि यह वस्तु नहीं है? आपकी रिपोर्ट बंद कर दी जाएगी।",
"fa.youConfirmed": "आपने पुष्टि की कि यह मालिक की वस्तु है",
"fa.youDeclined": "आपने संकेत दिया कि यह वस्तु नहीं है",
"fa.youDeclinedText": "आपकी मदद के लिए धन्यवाद! मालिक को सूचित कर दिया गया है।",
"fa.waitFinderDecisionOwner": "खोजकर्ता के निर्णय का इंतजार कर रहे हैं",
"fa.finderConfirmed": "पुष्टि हो गई",
"fa.notYourItem": "यह आपकी वस्तु नहीं थी",
"fa.reportedOn": "रिपोर्ट की गई",
"fa.ownerWaitHint": "एक खोजकर्ता वर्तमान में जानकारी की जांच कर रहा है, कृपया प्रतीक्षा करें।",
"fa.claimSentFinder": "दावा उस व्यक्ति को भेजा गया जो वस्तु को पाया है।",
"fa.compareClaimHint": "निर्णय लेने से पहले मालिक के घोषणा की तुलना अपनी लिस्टिंग से करें।",
"fa.closeFollowup": "इस फॉलो-अप को बंद करें",
"fa.closeFollowupConfirm": "क्या आप इस फॉलो-अप को बंद करना चाहते हैं? दोनों पक्षों के ईमेल और फोन नंबर स्थायी रूप से हटा दिए जाएंगे जब मालिक भी अपनी लिस्टिंग बंद कर देगा।",
"fa.safetyTitle": "हस्तांतरण से पहले सुरक्षा टिप्स",
"fa.safety1": "मालिक से आइटम की छिपी सुविधाओं का विस्तृत विवरण पूछें: एक विशेष खरोंच, बैग की सटीक सामग्री, वॉलपेपर, श्रृंखलांक…",
"fa.safety2": "यदि संभव हो, तो दृश्य प्रमाण (आइटम की एक फोटो) या खरीद का प्रमाण मांगें।",
"fa.safety3": "आइटम को एक सार्वजनिक स्थान पर या Findloop के साझेदार के पास सौंपें, और मालिक की ID की जांच करें।",
"fa.safetyOk": "समझ गया, आगे बढ़ें",
"fa.ownerClosedNote": "मालिक ने अपनी लिस्टिंग बंद कर दी है।",
"fa.finderClosedNote": "खोजकर्ता ने अपना फॉलो-अप बंद कर दिया है।",
"fa.followupClosed": "फॉलो-अप बंद किया गया",
"fa.followupClosedText": "आपने यह फॉलो-अप बंद किया। आपकी मदद के लिए धन्यवाद!",
"fa.photoReviewTitle": "एक खोजकर्ता ने एक फोटो भेजी है। क्या यह आपकी वस्तु की तरह दिखती है?",
"fa.photoLooksLike": "हाँ, यह मेरी वस्तु की तरह दिखती है",
"fa.photoNotMine": "नहीं, यह मेरी वस्तु नहीं है",
"fa.photoNotMineConfirm": "फॉलो-अप दोनों पक्षों पर बंद किया जाएगा और आपकी लिस्टिंग नए खोजकर्ता के लिए खुली रहेगी।",
"fa.photoLooksLikeDone": "धन्यवाद! अब खोजकर्ता आपकी घोषणा की तुलना करेगा।",
"fa.photoNotMineDone": "रिपोर्ट खारिज कर दी गई। आपकी लिस्टिंग खुली रहेगी।",
"fa.ownerPhotoHint": "केवल खोजकर्ता की फोटो आपको दिखाई देती है। हमें बताएं कि क्या यह आपकी वस्तु की तरह दिखती है।",
"fa.ownerReviewingPhoto": "स्वामी आपकी फोटो की समीक्षा कर रहा है",
"fa.ownerReviewingPhotoText": "जैसे ही वे जवाब देंगे, आपको सूचित किया जाएगा। तब आप उनकी घोषणा की तुलना कर सकेंगे।",
"fa.ownerRejectedPhoto": "यह स्वामी की वस्तु नहीं है",
"fa.ownerRejectedPhotoText": "स्वामी का कहना है कि आपकी फोटो उनकी वस्तु से मेल नहीं खाती। फॉलो-अप बंद है। आपकी मदद के लिए धन्यवाद!",
"fa.contribute": "योगदान करें",
"fa.phoneMissing": "उपलब्ध नहीं",
"fa.ownerSafety1": "सार्वजनिक स्थान पर या Findloop भागीदार के पास हैंड-ओवर करना पसंद करें। यदि दूरी लंबी है, तो इसके बजाय पोस्ट द्वारा भेजने का सुझाव दें।",
"fa.ownerSafety2": "हैंड-ओवर के समय, खोजने वाले की पहचान जांचें।",
"pub.changePhoto": "फोटो बदलें",
"ph.secured": "फोटो सुरक्षित",
"ph.securing": "फोटो को सुरक्षित किया जा रहा है…",
"fa.ownerSafety3": "अगर खोजने वाले की फोटो में Findloop वॉटरमार्क है, तो बैठक स्वीकार न करें। फोटो खोजने वाले द्वारा ली गई एक मूल छवि होनी चाहिए, बिना वॉटरमार्क के।"
},
"id": {
"a.back": "Kembali",
"a.category": "Kategori",
"a.categoryPlaceholder": "Pilih kategori",
"a.city": "Kota",
"a.confirmPassword": "Konfirmasi password",
"a.country": "Negara",
"a.createAccount": "Buat akun",
"a.createBtn": "Buat akun saya",
"a.creating": "Membuat…",
"a.email": "Email",
"a.emailPro": "Email bisnis",
"a.forgot": "Lupa?",
"a.forgotSent": "Jika akun ada, tautan reset baru saja dikirim.",
"a.forgotSub": "Dapatkan tautan reset melalui email.",
"a.forgotTitle": "Lupa password",
"a.googleContinue": "Lanjutkan dengan Google",
"a.googleSignup": "Daftar dengan Google",
"a.haveAccount": "Sudah menjadi mitra?",
"a.legalHint": "Diperlukan untuk e-faktur Prancis (Factur-X) dari lembaga Prancis.",
"a.legalRequiredFR": "SIRET dan nomor PPN intra-UE wajib untuk Prancis.",
"a.loggingIn": "Masuk…",
"a.login": "Masuk",
"a.loginSub": "Akses ruang manajemen Anda.",
"a.loginTitle": "Masuk mitra",
"a.min6": "Minimal 6 karakter",
"a.newPassword": "Password baru",
"a.noAccount": "Belum menjadi mitra?",
"a.or": "ATAU",
"a.org": "Nama lembaga",
"a.password": "Password",
"a.passwordMismatch": "Password tidak cocok.",
"a.referral": "Kode referensi (opsional)",
"a.registerSub": "Buat ruang Anda dalam 1 menit - gratis untuk memulai.",
"a.registerTitle": "Jadi mitra",
"a.rememberMe": "Ingat saya",
"a.reset": "Atur ulang",
"a.resetSub": "Pilih password baru untuk akun Anda.",
"a.resetTitle": "Password baru",
"a.sendLink": "Kirim tautan",
"a.sending": "Mengirim…",
"a.signin": "Masuk",
"a.siret": "SIRET",
"a.vat": "Nomor PPN intra-UE",
"ac.africa": "Afrika",
"ac.boostActive": "Sorot aktif —",
"ac.boostSub": "Tampil di bagian atas direktori mitra dengan lencana “Ditingkatkan”.",
"ac.boostTitle": "Tingkatkan listing Anda di direktori",
"ac.categoryHint": "Untuk mengklasifikasikan lembaga Anda di direktori findloop.",
"ac.choose": "Pilih",
"ac.cityHint": "Untuk penempatan yang tepat di peta publik.",
"ac.cityLabel": "Kota lembaga",
"ac.cityPh": "Paris",
"ac.contact": "Detail kontak",
"ac.converted": "Dikonversi",
"ac.copyDeclLink": "Salin tautan deklarasi",
"ac.copyLink": "Salin tautan",
"ac.currentPlan": "Rencana saat ini",
"ac.emailDesc": "Pilih email yang ingin Anda terima. Notifikasi di ruang kerja Anda selalu aktif.",
"ac.emailMatch": "Cocok",
"ac.emailMatchDesc": "Email ketika item cocok dengan deklarasi",
"ac.emailNewDecl": "Deklarasi kerugian baru",
"ac.emailNewDeclDesc": "Email segera setelah pelanggan melaporkan kerugian di tempat Anda",
"ac.emailShip": "Permintaan pengiriman",
"ac.emailShipDesc": "Email ketika pelanggan meminta pengiriman barang",
"ac.emailTitle": "Preferensi email",
"ac.expireSoon": "Sorotan Anda akan segera berakhir —",
"ac.exportCsv": "Ekspor (CSV)",
"ac.exportHint": "Ekspor pembayaran eksternal yang telah divalidasi untuk akuntansi Anda.",
"ac.free": "Gratis",
"ac.freeMonths": "Bulan gratis",
"ac.hours": "jam",
"ac.howItWorks": "Bagaimana cara kerjanya?",
"ac.invited": "Diundang",
"ac.legalFR": "Diperlukan untuk penagihan elektronik (Factur-X) berlaku mulai September 2026.",
"ac.legalMissing": "⚠️ SIRET dan PPN intra-UE hilang — lengkapi untuk tetap mematuhi penagihan elektronik.",
"ac.legalOther": "Disarankan untuk faktur Anda.",
"ac.legalPartnerQr": "Kode QR",
"ac.legalTitle": "Identifikasi hukum (penagihan)",
"ac.logoTitle": "Logo lembaga",
"ac.modeCurrent": "Mode saat ini:",
"ac.modeExternal": "Eksternal (validasi manual)",
"ac.modeInternal": "Internal Findloop (otomatis)",
"ac.noSubReceipt": "Belum ada pembayaran langganan yang dibayar.",
"ac.none": "Tidak ada",
"ac.onYourListing": "di daftar Anda",
"ac.pay1": "Masukkan tautan pembayaran Anda di bawah ini untuk mengarahkan pelanggan Anda ke sistem penagihan Anda sendiri.",
"ac.pay2": "Validasi menjadi manual: Anda mengonfirmasi penerimaan pembayaran dari tab “Deklarasi”.",
"ac.pay3": "Tautan “Biaya pengiriman” adalah pembayaran yang terakumulasi (pemulihan + pengiriman).",
"ac.pay4": "Biarkan kolom kosong untuk menggunakan pembayaran internal Findloop (Stripe) dengan validasi otomatis.",
"ac.paySub": "Kumpulkan biaya melalui sistem pembayaran Anda sendiri.",
"ac.payTitle": "Pembayaran eksternal",
"ac.permissive": "Luwes",
"ac.phone": "Telepon",
"ac.posterA4": "Poster A4 (PDF)",
"ac.qMessage": "Pesan (opsional)",
"ac.qName": "Nama",
"ac.qOrg": "Organisasi",
"ac.qSites": "Jumlah lembaga (perkiraan)",
"ac.qrHint": "Pelanggan Anda memindai kode ini untuk melaporkan barang yang hilang.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Kode QR mitra Anda",
"ac.quoteDesc": "Bandara, jaringan kereta api, rantai internasional · ",
"ac.quoteEurope": "Eropa / Dunia",
"ac.quoteSent": "Permintaan kutipan telah dikirim. Tim kami akan menghubungi Anda segera.",
"ac.quoteTitle": "Minta kutipan — Perusahaan",
"ac.recoveryLink": "Tautan “biaya pemulihan”",
"ac.refSub": "Setiap mitra yang dirujuk yang berlangganan memberi Anda 1 bulan gratis.",
"ac.refTitle": "Rujuk, dapatkan bulan gratis",
"ac.reminderDelay": "Penundaan pengingat validasi",
"ac.reminderHint": "Anda akan menerima pengingat email jika pembayaran eksternal tetap belum divalidasi melewati penundaan ini (default: 48 jam).",
"ac.renewDesc1": "Ini sudah memberi Anda",
"ac.renewDesc2": "Perbarui untuk tetap di atas direktori dan tidak kehilangan visibilitas ini.",
"ac.renewNow": "Perbarui sekarang",
"ac.requestQuote": "Minta kutipan",
"ac.saveLegal": "Simpan identifikasi",
"ac.saveLinks": "Simpan tautan",
"ac.sendRequest": "Kirim permintaan saya",
"ac.sending": "Mengirim…",
"ac.shippingLink": "Tautan “biaya pengiriman” (terakumulasi)",
"ac.shippingLinkHint": "Tautan ini mencakup pemulihan dan pengiriman.",
"ac.strict": "Ketat",
"ac.subReceipt": "Bukti langganan (PDF)",
"ac.subReceiptsSub": "Unduh bukti PDF untuk setiap pembayaran langganan.",
"ac.subReceiptsTitle": "Bukti langganan",
"ac.tCategory": "Kategori disimpan",
"ac.tCity": "Kota disimpan — peta diperbarui",
"ac.tCityNeeded": "Masukkan sebuah kota",
"ac.tCopied": "Disalin!",
"ac.tCover": "Foto sampul diperbarui",
"ac.tEmailPrefs": "Preferensi email diperbarui",
"ac.tErr": "Kesalahan",
"ac.tExportImpossible": "Ekspor gagal",
"ac.tLegal": "Identifikasi hukum disimpan",
"ac.tLegalNeeded": "SIRET dan PPN diperlukan untuk Prancis",
"ac.tLogo": "Logo diperbarui",
"ac.tLogoRemoved": "Logo dihapus",
"ac.tPayLinks": "Tautan pembayaran disimpan",
"ac.tPhone": "Telepon disimpan",
"ac.tSensitivity": "Sensitivitas disimpan",
"ac.tVatInvalid": "Nomor PPN tidak valid",
"ac.tVatValid": "PPN valid",
"ac.tabBoost": "Visibilitas",
"ac.tabPayments": "Pembayaran",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Poster",
"ac.tabReferral": "Referral",
"ac.tabSub": "Langganan",
"ac.thisWeek": "Minggu ini",
"ac.thisWeekOf": " ({n} minggu ini)",
"ac.thresholdDesc": "Ambang kepercayaan di mana AI secara otomatis memvalidasi kecocokan foto dan memberi tahu pelanggan. Semakin tinggi = semakin sedikit kecocokan otomatis tetapi lebih dapat diandalkan.",
"ac.thresholdTitle": "Sensitivitas kecocokan visual AI",
"ac.trend": "Tren",
"ac.upload": "Unggah",
"ac.vatValidFmt": "PPN valid{name} ({via})",
"ac.vatVerified": "PPN intra-UE terverifikasi",
"ac.verifyVat": "Verifikasi PPN (VIES)",
"ac.verifying": "Memverifikasi…",
"ac.views": "tampilan",
"ac.viewsTotal": "Tampilan yang didapat (total)",
"ac.winbackBtn": "Lanjutkan dengan -20%",
"ac.winbackDesc1": "Ini memberi Anda",
"ac.winbackDesc2": "Penawaran spesial: -20% diterapkan secara otomatis jika Anda memperbarui dalam 24 jam.",
"ac.winbackTitle": "Sorotan Anda baru saja kedaluwarsa — lanjutkan dengan -20%!",
"ad.boost": "Dorong",
"ad.close": "Tutup",
"ad.closeConfirm": "Tutup daftar ini?",
"ad.closed": "Daftar ditutup",
"ad.edit": "Edit",
"ad.editTitle": "Edit daftar",
"ad.saved": "Daftar diperbarui",
"an.allCountries": "Semua negara",
"an.badge": "Barang hilang",
"an.boostLater": "Nanti",
"an.boostNow": "Dorong sekarang",
"an.boostPrompt": "Dorong daftar Anda untuk menempatkannya di atas dan ditemukan lebih cepat.",
"an.boosted": "Didorong",
"an.contact": "Saya menemukan barang ini",
"an.contactTitle": "Laporkan bahwa Anda menemukan barang ini",
"an.copyFailed": "Tidak dapat menyalin tautan",
"an.copyLink": "Salin tautan",
"an.country": "Negara",
"an.date": "Tanggal hilang",
"an.finderEmail": "Email Anda",
"an.finderName": "Nama Anda",
"an.finderPhone": "Telepon Anda",
"an.geoBanner": "Anda sedang melihat daftar di",
"an.geoBannerWorld": "Anda sedang melihat daftar di seluruh dunia",
"an.geoChange": "ubah negara",
"an.goAccount": "Pergi ke akun saya",
"an.linkCopied": "Tautan disalin!",
"an.loginRequired": "Masuk untuk melaporkan item ini dan mengikuti pengembaliannya.",
"an.loginToBoost": "Masuk untuk meningkatkan daftar ini",
"an.lostAt": "Hilang di",
"an.message": "Pesan (opsional)",
"an.none": "Belum ada daftar.",
"an.photo": "Foto (opsional)",
"an.post": "Pasang daftar",
"an.postSubtitle": "Deskripsikan item yang hilang — komunitas dan mitra kami membantu Anda menemukannya.",
"an.postTitle": "Laporkan item yang hilang",
"an.publish": "Publikasikan daftar",
"an.published": "Daftar dipublikasikan!",
"an.publishing": "Mempublikasikan…",
"an.remaining": "tersisa",
"an.requestInProgress": "Permintaan sedang diproses",
"an.resolved": "Item sudah ditemukan",
"an.reward": "Hadiah",
"an.searchPh": "Cari daftar…",
"an.send": "Kirim",
"an.sent": "Pesan dikirim ke pemilik!",
"an.shareConsent": "Saya setuju bahwa rincian kontak saya (nama, email, telepon) dapat dibagikan dengan pemilik item.",
"an.shareConsentError": "Silakan centang kotak untuk membagikan rincian kontak Anda.",
"an.sortRecent": "Paling baru",
"an.sortRelevance": "Relevansi",
"an.subtitle": "Jelajahi item yang dilaporkan hilang oleh komunitas. Temukan salah satunya?",
"an.title": "Daftar item hilang",
"anf.badge": "Item ditemukan",
"anf.claim": "Ini milik saya",
"anf.claimSent": "Pesan dikirim ke penemu!",
"anf.claimTitle": "Laporkan bahwa ini adalah item Anda",
"anf.consent": "Saya setuju bahwa pemilik dapat melihat rincian kontak saya untuk mengambil item mereka.",
"anf.foundAt": "Ditemukan di",
"anf.foundDate": "Tanggal ditemukan",
"anf.loginCta": "Masuk / buat akun",
"anf.loginDesc": "Akun penemu diperlukan untuk mempublikasikan daftar dan mendapatkan poin Finder Hero.",
"anf.loginRequired": "Masuk untuk memposting item yang ditemukan",
"anf.photo": "Foto item",
"anf.pointsEarned": "Terima kasih! Anda baru saja mendapatkan poin Finder Hero.",
"anf.pointsPending": "Poin Anda akan dikreditkan dalam 24 jam, setelah verifikasi.",
"anf.post": "Pasang item yang ditemukan",
"anf.postSubtitle": "Deskripsikan item yang Anda temukan — bantu pemiliknya mendapatkan kembali.",
"anf.postTitle": "Laporkan item yang ditemukan",
"anf.publishFound": "Publikasikan daftar yang ditemukan",
"anf.published": "Daftar item ditemukan dipublikasikan",
"anf.publishedAs": "Dipublikasikan sebagai",
"anf.shareConsent": "Saya setuju bahwa rincian kontak saya (nama, email, telepon) dapat dibagikan dengan orang yang menemukan item tersebut.",
"anf.subtitle": "Jelajahi item yang ditemukan dan dilaporkan oleh komunitas. Apakah itu milik Anda?",
"anf.title": "Daftar item ditemukan",
"bo.active": "Peningkatan aktif",
"bo.africaPrice": "Harga preferensial zona Afrika diterapkan",
"bo.pay": "Bayar & tingkatkan",
"bo.remaining": "Waktu tersisa",
"bo.renew": "Perbarui boost",
"bo.since": "sejak boost",
"bo.subtitle": "Letakkan listing Anda di atas daftar dengan lencana yang terlihat.",
"bo.title": "Boost listing",
"c.all": "Semua",
"c.cancel": "Batal",
"c.close": "Tutup",
"c.confirm": "Konfirmasi",
"c.confirmed": "Dikonfirmasi",
"c.download": "Unduh",
"c.loading": "Memuat…",
"c.reset": "Reset",
"c.reviews": "ulasan",
"c.save": "Simpan",
"c.transfer": "Transfer",
"cat.Animal": "Hewan Peliharaan / Aksesoris Hewan Peliharaan",
"cat.AppareilPhoto": "Kamera",
"cat.Argent": "Uang / Tunai",
"cat.Autres": "Lainnya",
"cat.Bijoux": "Perhiasan",
"cat.CarteBancaire": "Kartu bank",
"cat.CarteIdentite": "Kartu ID / Paspor",
"cat.Casquette": "Topi",
"cat.Ceinture": "Sabuk",
"cat.Chargeur": "Pengisi daya / Kabel",
"cat.Chaussures": "Sepatu",
"cat.CleVoiture": "Kunci mobil",
"cat.Cles": "Kunci",
"cat.Console": "Konsol permainan",
"cat.Documents": "Dokumen / Kertas",
"cat.Echarpe": "Scarf",
"cat.Ecouteurs": "Earphone / Headphone",
"cat.Electronique": "Elektronik (lainnya)",
"cat.Enceinte": "Speaker",
"cat.Gants": "Sarung tangan",
"cat.Gourde": "Botol air / Flas",
"cat.Instrument": "Alat musik",
"cat.Jouet": "Mainan / Boneka",
"cat.Jumelles": "Teropong",
"cat.Lampe": "Lampu / Senter",
"cat.Liseuse": "E-reader",
"cat.Livre": "Buku / Buku Catatan",
"cat.Lunettes": "Kacamata",
"cat.Manteau": "Mantel / Jaket",
"cat.Maquillage": "Tas Makeup",
"cat.Medical": "Peralatan medis",
"cat.Medicaments": "Obat",
"cat.Montre": "Jam / Jam Tangan Pintar",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Payung",
"cat.Portefeuille": "Dompet",
"cat.Poussette": "Kereta bayi / Aksesoris bayi",
"cat.Sac": "Tas / Tas Tangan",
"cat.SacADos": "Ransel",
"cat.Souris": "Mouse / Keyboard",
"cat.Sport": "Peralatan olahraga",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telepon / Smartphone",
"cat.Trottinette": "Skuter",
"cat.Trousse": "Tas / Kotak",
"cat.USB": "USB / Hard drive",
"cat.Valise": "Koper / Bagasi",
"cat.Velo": "Sepeda",
"cat.Vetements": "Pakaian",
"cat.placeholder": "Pilih kategori",
"cd.d": "h",
"cd.expired": "Kedaluwarsa",
"cd.h": "jam",
"cd.m": "menit",
"ck.accept": "Terima",
"ck.acceptAll": "Terima semua",
"ck.customize": "Sesuaikan",
"ck.learn": "Pelajari lebih lanjut",
"ck.manage": "Kelola cookie",
"ck.measurement": "Pengukuran audiens",
"ck.measurementDesc": "Statistik anonim untuk meningkatkan layanan.",
"ck.msg": "Kami menggunakan cookie untuk menjaga situs tetap berjalan dan mengukur audiens.",
"ck.necessary": "Perlu",
"ck.necessaryDesc": "Penting agar situs berfungsi. Selalu aktif.",
"ck.refuse": "Tolak",
"ck.save": "Simpan pilihan saya",
"ck.saved": "Preferensi disimpan",
"ck.title": "Preferensi cookie Anda",
"cm.found": "DITEMUKAN",
"cm.lost": "HILANG",
"cmp.adv": "Lanjutan",
"cmp.ai": "Kecocokan AI",
"cmp.autobill": "Penagihan otomatis",
"cmp.basic": "Dasar",
"cmp.community": "Komunitas",
"cmp.consol": "Penagihan terintegrasi",
"cmp.custom": "Kustom",
"cmp.dedicated": "Diddedikasikan",
"cmp.deploy": "Penerapan & SLA yang diddedikasikan",
"cmp.estIncl": "Kantor termasuk",
"cmp.estSec": "Kantor tambahan",
"cmp.items": "Item / bulan",
"cmp.main": "1 utama",
"cmp.max20": "20 max",
"cmp.members": "Undangan anggota",
"cmp.onQuote": "Penawaran kustom",
"cmp.priority": "Prioritas",
"cmp.starterEst": "1 termasuk + tak terbatas tambahan",
"cmp.stats": "Statistik",
"cmp.statsAdv": "Lanjutan",
"cmp.statsBasic": "Dasar",
"cmp.support": "Dukungan",
"cmp.unlimited": "Tidak terbatas",
"cmp.upTo3": "Hingga 3",
"consent.required": "Anda harus setuju untuk membagikan rincian kontak Anda untuk melanjutkan.",
"consent.share": "Saya setuju agar penemu barang saya dapat melihat rincian kontak saya (nama, email, telepon) untuk menghubungi saya untuk pengembaliannya.",
"cover.add": "Tambah",
"cover.change": "Ubah",
"cover.helper": "Ditampilkan sebagai spanduk di halaman laporan Anda dan di direktori.",
"cover.none": "Tidak ada foto sampul",
"cover.remove": "Hapus",
"cover.title": "Foto sampul",
"crop.desc": "Sesuaikan rasio bingkai ke spanduk (3:1). Seret dan perbesar.",
"crop.saving": "Menyimpan…",
"crop.title": "Pangkas foto sampul",
"cta.button": "Buat akun mitra saya",
"cta.subtitle": "Bergabunglah dengan tempat yang mengembalikan barang lebih cepat dengan findloop.",
"cta.title": "Siap memangkas barang yang hilang?",
"db.account.s": "Kelola tempat Anda, langganan, dan kode QR.",
"db.account.t": "Akun saya",
"db.declarations.s": "Pelanggan yang melaporkan barang hilang melalui kode QR Anda.",
"db.declarations.t": "Laporan kehilangan",
"db.deposit.s": "Tambahkan foto, kategori, dan deskripsi.",
"db.deposit.t": "Catat barang yang ditemukan",
"db.registry.s": "Semua barang yang ditemukan dicatat di tempat Anda.",
"db.registry.t": "Registri barang",
"db.reviews.s": "Balas ulasan pelanggan Anda secara publik.",
"db.reviews.t": "Ulasan pelanggan",
"db.shipments.s": "Buat label dan lacak paket untuk dikirim.",
"db.shipments.t": "Pengiriman",
"db.stats.s": "Indikator kinerja utama Anda.",
"db.stats.t": "Statistik",
"db.team.s": "Undang rekan Anda untuk mengelola barang.",
"db.team.t": "Tim",
"dc.partnerDesc": "Kehilangan barang di lokasi mitra (hotel, stasiun, aula…)? Pilih untuk pengembalian langsung.",
"dc.partnerList": "Pilih dari daftar",
"dc.partnerMap": "Pilih di peta",
"dc.partnerTitle": "Pernyataan di mitra",
"dc.publicCta": "Pasang iklan publik",
"dc.publicDesc": "Iklan Anda akan terlihat oleh seluruh komunitas findloop. Ideal jika Anda tidak tahu di mana Anda kehilangan barang tersebut.",
"dc.publicTitle": "Pernyataan publik",
"dc.subtitle": "Pilih cara melaporkan barang hilang Anda.",
"dc.title": "Apa yang ingin Anda lakukan?",
"dec.addrPending": "Alamat menunggu dari pelanggan",
"dec.analyzing": "Menganalisis…",
"dec.badge": "Laporan kehilangan",
"dec.category": "Kategori barang",
"dec.clientDescription": "Deskripsi pelanggan",
"dec.clientPhoto": "Foto yang diberikan oleh pelanggan",
"dec.clientPhotoShort": "Foto pelanggan",
"dec.comparePhotos": "Bandingkan foto",
"dec.contactTitle": "Detail kontak Anda",
"dec.date": "Tanggal kehilangan",
"dec.declaredItemPhoto": "Foto barang yang dilaporkan",
"dec.descPh": "Jelaskan barang: merek, warna, tanda khas…",
"dec.description": "Deskripsi",
"dec.email": "Email",
"dec.emptyDesc": "Bagikan kode QR Anda untuk menerima pernyataan.",
"dec.emptyTitle": "Tidak ada pernyataan",
"dec.enlarge": "Perbesar",
"dec.extBanner": "{n} pembayaran eksternal untuk memvalidasi — konfirmasi penerimaan di bawah ini untuk membuka pengalihan atau pengiriman.",
"dec.foundItemAlt": "Barang ditemukan",
"dec.foundItemRegistry": "Barang yang ditemukan (registri)",
"dec.home": "Kembali ke beranda",
"dec.labelClient": "Pelanggan",
"dec.labelRegistry": "Registri",
"dec.matchFound": "Sebuah kecocokan telah diidentifikasi!",
"dec.name": "Nama lengkap",
"dec.noMatchYet": "Belum ada kecocokan.",
"dec.noPhoto": "Tidak ada foto",
"dec.notfound": "Mitra tidak ditemukan.",
"dec.pRecup": "pemulihan",
"dec.pRecupP": "(pemulihan)",
"dec.pRecupShip": "(pemulihan + pengiriman)",
"dec.payConfirmed": "Pembayaran {x} terkonfirmasi",
"dec.payPending": "Pembayaran eksternal {x} tertunda",
"dec.phone": "Telepon",
"dec.pickup": "Ambil langsung",
"dec.place": "Tempat kehilangan",
"dec.placePh": "mis. di bar, ruang 204…",
"dec.recoverBtn": "Pulihkan barang saya",
"dec.reject": "Tolak",
"dec.rerun": "Jalankan analisis lagi",
"dec.similarity": "Kesamaan {n}%",
"dec.submit": "Kirim laporan saya",
"dec.submitting": "Mengirim…",
"dec.successText": "Kami sedang mencari barang Anda di antara yang dipegang di",
"dec.successTitle": "Laporan terkirim!",
"dec.suggestedMatches": "Padanan yang disarankan",
"dec.toColon": " ke:",
"dec.toShip": "Untuk dikirim",
"dec.toastExtPay": "Pembayaran terkonfirmasi — pelanggan akan diberitahu.",
"dec.toastMatch": "Padanan terkonfirmasi",
"dec.toastReject": "Saran ditolak",
"dec.toastRerun": "Analisis dimulai ulang",
"dec.toastVisualN": "{n} padanan visual",
"dec.toastVisualNone": "Tidak ada padanan visual",
"dec.trackBtn": "Lacak laporan saya",
"dec.viewBeforeAfter": "Tampilan sebelum/setelah (overlay)",
"dec.viewSideBySide": "Tampilan berdampingan",
"dec.visualCompare": "Perbandingan visual AI",
"dec.visualIdle": "Jalankan perbandingan agar AI mencocokkan foto pelanggan dengan barang yang ditemukan.",
"dec.visualRunning": "AI sedang membandingkan foto pelanggan dengan barang di registri Anda…",
"dec.zoomPhoto": "Perbesar foto",
"dep.addAnyway": "Tambahkan saja",
"dep.addError": "Kesalahan saat menambahkan",
"dep.addItem": "Tambahkan barang",
"dep.added": "Barang berhasil ditambahkan ke registri!",
"dep.adding": "Menambahkan…",
"dep.aiError": "Analisis AI tidak tersedia saat ini.",
"dep.aiFilled": "Formulir diisi otomatis oleh AI ✨",
"dep.aiUnavailable": "AI tidak tersedia — isi formulir secara manual.",
"dep.analyzing": "Menganalisis…",
"dep.analyzingPhoto": "Menganalisis foto…",
"dep.brand": "Merek",
"dep.brandPlaceholder": "mis. Apple",
"dep.category": "Kategori",
"dep.checkingDup": "Memeriksa duplikat…",
"dep.color": "Warna",
"dep.colorPlaceholder": "mis. hitam",
"dep.condition": "Kondisi",
"dep.conditionPlaceholder": "mis. kondisi baik",
"dep.depositorNote": "Catatan penyetor",
"dep.depositorNoteHint": "Detail operasional yang diketik tangan. AI tidak pernah menimpa catatan ini.",
"dep.depositorNotePlaceholder": "mis. isi pouch, merek yang dilaporkan, detail yang diberikan oleh orang…",
"dep.descPlaceholder": "mis. iPhone 15 hitam dengan casing bening, ditemukan di bar…",
"dep.description": "Deskripsi",
"dep.dupHint": "Pastikan Anda tidak menambahkan duplikat. Anda bisa melanjutkan jika barangnya benar-benar berbeda.",
"dep.dupTitle": "Barang serupa sudah terdaftar",
"dep.dupWarn": "Barang serupa terdeteksi — tinjau, lalu klik lagi untuk mengonfirmasi.",
"dep.estHint": "Barang akan ditambahkan ke registri tempat ini.",
"dep.establishment": "Tempat",
"dep.fee": "Biaya pemulihan (€) — opsional",
"dep.feePlaceholder": "Biarkan kosong untuk harga default kategori",
"dep.fillAI": "Isi dengan AI",
"dep.optional": "(opsional)",
"dep.photo": "Foto item",
"dep.principal": "utama",
"dep.reqError": "Kategori dan deskripsi diperlukan.",
"dep.savedItem": "Item terdaftar",
"dep.similarity": "Kesamaan",
"dep.storage": "Lokasi fisik",
"dep.storageHint": "Tempat di mana item disimpan secara fisik. Kode QR akan dihasilkan untuk menemukannya.",
"dep.storagePlaceholder": "mis. Rak A3, Loker 12, brankas penerimaan",
"dl.aClient": "seorang pelanggan",
"dl.alertsBlocked": "Pemberitahuan browser diblokir",
"dl.alertsBlockedHint": "Untuk mengaktifkannya kembali: klik ikon 🔒 (atau ⓘ) di sebelah kiri alamat situs, lalu izinkan Notifikasi dan muat ulang halaman.",
"dl.amountDue": "Jumlah yang harus dibayar: {amount} {currency}.",
"dl.enableAlerts": "Aktifkan pemberitahuan",
"dl.extPending": "Pembayaran yang perlu divalidasi",
"dl.freemiumNear": "Anda mendekati batas Freemium ({used}/{max} item bulan ini). Tingkatkan ke Starter untuk item tanpa batas.",
"dl.freemiumReached": "Batas Freemium tercapai ({used}/{max} item bulan ini). Tingkatkan ke Starter untuk mendaftar item tanpa batas.",
"dl.invoiceOverdue": "Faktur {num} belum dibayar — akses dibatasi.",
"dl.matchNotifTitle": "Findloop — Kecocokan AI baru 🔔",
"dl.matchToast": "Kecocokan AI baru — {name}",
"dl.matchToastDesc": "Sebuah item cocok dengan deklarasi.",
"dl.notifEmpty": "Belum ada pemberitahuan.",
"dl.notifEnabled": "Pemberitahuan browser diaktifkan",
"dl.notifTitle": "Pemberitahuan",
"dl.payInvoice": "Bayar faktur saya →",
"dl.rewardsPending": "Voucher untuk disajikan",
"dl.upgradeStarter": "Tingkatkan ke Starter →",
"est.all": "Semua tempat ({n})",
"est.label": "Tempat",
"est.primary": "utama",
"est.secondary": "sekunder",
"est2.add": "Tambahkan tempat",
"est2.addressLabel": "Alamat",
"est2.addressPh": "12 Jalan République",
"est2.autoInvoice": "Faktur rinci dihasilkan secara otomatis pada tanggal 1 setiap bulan.",
"est2.baseSub": "Langganan dasar",
"est2.billing": "Penagihan",
"est2.boostActivated": "Boost diaktifkan untuk {name}",
"est2.boostBillingNote": "Ditagih dengan tarif saat ini dan dikelompokkan pada faktur bulanan konsolidasi Anda.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Tingkatkan visibilitas tempat ini di direktori dan peta.",
"est2.boostDuration": "{h}jam visibilitas yang ditingkatkan",
"est2.boostExtend": "Perpanjang",
"est2.boostTitle": "Boost {name}",
"est2.boosted": "Ditangkap",
"est2.chartDesc": "Bagian item yang dikembalikan dari total yang terdaftar, situs demi situs.",
"est2.chartTitle": "Tingkat pengembalian berdasarkan tempat",
"est2.chartTooltip": "Kembali",
"est2.cityLabel": "Kota",
"est2.cityPh": "Lyon",
"est2.contactHint": "Detail ini ditampilkan kepada pelanggan untuk tempat ini (kembali ke akun jika kosong).",
"est2.countryLabel": "Negara",
"est2.coverLabel": "Foto sampul",
"est2.create": "Buat",
"est2.created": "Tempat dibuat",
"est2.delete": "Hapus",
"est2.deleteDesc": "Tindakan ini permanen. Anda hanya dapat menghapus tempat jika tidak mengandung item.",
"est2.deleteTitle": "Hapus “{name}”?",
"est2.deleted": "Tempat dihapus",
"est2.dialogDesc": "Masukkan nama dan alamat situs ini.",
"est2.edit": "Edit",
"est2.editEst": "Edit tempat",
"est2.emailLabel": "Email kontak",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " tempat",
"est2.extraNoteBase": "{n} tempat tambahan yang ditagih",
"est2.extraPrice": " seharga {price} €/bulan.",
"est2.extraQuote": " pada penawaran.",
"est2.imgChange": "Pilih gambar",
"est2.imgDone": "Selesai",
"est2.imgRemove": "Hapus",
"est2.imgRemoved": "Gambar dihapus",
"est2.imgSaved": "Gambar disimpan",
"est2.imgUploading": "Mengupload…",
"est2.includedPlan": "Termasuk dalam rencana Anda: {n}.",
"est2.kDeclarations": "Deklarasi",
"est2.kInStorage": "Dalam penyimpanan",
"est2.kItemsTotal": "Item (total)",
"est2.kRestituted": "Dikembalikan",
"est2.limitReached": "Batas tercapai",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Dek.",
"est2.mItems": "Item",
"est2.mRestituted": "Dikembalikan",
"est2.mStorage": "Dalam penyimpanan",
"est2.monthlyTotal": "Total bulanan",
"est2.nameLabel": "Nama *",
"est2.namePh": "contoh: Belmont Hotel — Lyon Annex",
"est2.newEst": "Tempat baru",
"est2.onQuote": "Pada penawaran",
"est2.phoneLabel": "Telepon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Rencana",
"est2.planLimited": "Rencana “{tier}” Anda terbatas pada {max} tempat.",
"est2.primary": "Utama",
"est2.qr": "Kode QR",
"est2.qrDesc": "Tampilkan kode QR ini di tempat ini. Pelanggan yang melaporkan kehilangan akan terhubung ke situs ini.",
"est2.qrTitle": "Kode QR — {name}",
"est2.saving": "Menyimpan…",
"est2.seeInvoices": "Lihat faktur bulanan saya",
"est2.seePlans": "Lihat rencana",
"est2.subtitle": "Kelola semua situs Anda di bawah satu akun — tampilan terkompilasi, item, kode QR, dan penagihan.",
"est2.suspended": "Ditangguhkan",
"est2.tierFree": "1 tempat",
"est2.tierLarge": "tempat tak terbatas",
"est2.tierMedium": "5 tempat termasuk",
"est2.tierSmall": "3 tempat termasuk",
"est2.title": "Tempat",
"est2.unlimitedPlan": "Rencana Anda memungkinkan jumlah tempat yang tidak terbatas.",
"est2.unlimitedSuffix": " · tidak terbatas",
"est2.updated": "Tempat diperbarui",
"est2.upgradeHint": "Tingkatkan ke rencana yang lebih tinggi untuk menambahkan lebih banyak situs dan memusatkan semua aktivitas Anda.",
"est2.visuals": "Logo & foto",
"est2.visualsDesc": "Sesuaikan logo dan foto sampul tempat ini. Mereka muncul di halaman publik dan formulir deklarasi.",
"est2.visualsTitle": "Visual — {name}",
"est2.workOn": "Bekerja pada tempat ini",
"est2.working": "Anda sedang bekerja pada “{name}”",
"ev.created": "Laporan dibuat",
"ev.matched": "Item yang cocok teridentifikasi",
"ev.paid": "Biaya pemulihan dibayar",
"ev.pickup": "Pengambilan di lokasi",
"ev.shipped": "Paket dikirim",
"ev.shipping_paid": "Biaya pengiriman dibayar",
"ev.shipping_requested": "Pengiriman diminta",
"feat1.d": "KPI, tingkat pengembalian per kategori, pendapatan, dan tren 30 hari.",
"feat1.t": "Dasbor & analitik",
"feat2.d": "Label, pelacakan pengirim, dan email pelacakan otomatis.",
"feat2.t": "Modul pengiriman",
"feat3.d": "Pelanggan menemukan Anda berdasarkan kota dan kategori, dengan ulasan terverifikasi.",
"feat3.t": "Direktori publik & ulasan",
"fp.backToRanking": "Kembali ke papan peringkat",
"fp.badge": "Lencana",
"fp.hero": "Finder Hero",
"fp.notFound": "Profil tidak ditemukan atau privat.",
"fp.scoreTotal": "Total poin",
"fp.scoreYear": "Poin di",
"fp.share": "Bagikan profil ini",
"fp.shareText": "Lihat profil finder {name} di Findloop!",
"fp.tagline": "Finder yang jujur membuat dunia menjadi tempat yang lebih baik.",
"ft.backAccount": "Kembali ke Akun Saya",
"ft.closeBtn": "Tutup kasus",
"ft.closeConfirm": "Konfirmasi apakah barang sudah dikembalikan? Iklan akan ditutup.",
"ft.closeLockedHint": "Verifikasi kode pemilik terlebih dahulu untuk membuka penutupan.",
"ft.closed": "Kasus ditutup — barang dikembalikan!",
"ft.codeLabel": "Masukkan kode validasi yang diterima dari pemilik",
"ft.codeNeeded": "Silakan masukkan kode validasi.",
"ft.codeOk": "Kode terverifikasi — Anda bisa menutup kasus.",
"ft.codePlaceholder": "mis. 4821",
"ft.codeVerified": "Terverifikasi",
"ft.doneMsg": "Barang dikembalikan. Terima kasih telah membantu mengembalikannya kepada pemilik!",
"ft.stepInProgress": "Pengembalian dalam proses",
"ft.stepPublished": "Iklan diterbitkan",
"ft.stepReturned": "Barang dikembalikan",
"ft.subtitle": "Ikuti langkah-langkah hingga barang yang ditemukan dikembalikan.",
"ft.title": "Pelacakan pengembalian",
"ft.verifyBtn": "Verifikasi kode",
"hero.badge": "Ditampilkan",
"hero.ctaFound": "Saya menemukan barang",
"hero.ctaLost": "Saya kehilangan barang",
"hero.ctaPartner": "Jadilah mitra",
"hero.subtitle": "Findloop membantu tempat usaha mengelola barang yang ditemukan — dan membiarkan pelanggannya melaporkan kehilangan dan mengembalikan barang mereka, secara langsung atau melalui pengiriman.",
"hero.title": "Setiap barang yang hilang menemukan pemiliknya.",
"home.champBecome": "Jadilah finder",
"home.champCta": "Lihat papan peringkat",
"home.champSubtitle": "Setiap barang yang dikembalikan mendapatkan poin. Bergabunglah di papan peringkat dan menangkan hadiah.",
"home.champTitle": "Finder terbaik kami",
"how.eyebrow": "Cara kerjanya",
"how.title": "Dari penyerahan hingga pengembalian, tanpa usaha.",
"inv.all": "Semua",
"inv.allYears": "Semua tahun",
"inv.count": "Faktur",
"inv.due": "jatuh tempo",
"inv.empty": "Belum ada faktur.",
"inv.exportCsv": "Ekspor CSV",
"inv.invoicePdf": "Faktur PDF",
"inv.issued": "Diterbitkan",
"inv.noMatch": "Tidak ada faktur untuk filter ini.",
"inv.paid": "Dibayar (€)",
"inv.paidOn": "dibayar pada",
"inv.pay": "Bayar",
"inv.receipt": "Struk",
"inv.reminders": "Pengingat",
"inv.remindersDesc": "Pengingat email dan SMS dikirim untuk faktur ini.",
"inv.remindersEmpty": "Tidak ada pengingat yang dikirim.",
"inv.rmDue": "Pengingat tanggal jatuh tempo",
"inv.rmManual": "Pengingat manual",
"inv.rmSms": "Pengingat SMS D+30",
"inv.rmStage": "Pengingat",
"inv.statusPaid": "Telah dibayar",
"inv.statusUnpaid": "Belum dibayar",
"inv.subtitle": "Lihat dan unduh faktur serta struk Anda.",
"inv.title": "Faktur saya",
"inv.unpaid": "Belum dibayar (€)",
"inv2.contractTitle": "Kontrak Findloop saya",
"inv2.detailByEst": "Detail berdasarkan tempat",
"inv2.dueLabel": "Jatuh tempo:",
"inv2.dueSuffix": " · jatuh tempo {date}",
"inv2.error": "Kesalahan {status}",
"inv2.estCountIssued": "{n} tempat · diterbitkan pada {date}",
"inv2.estimate": "Estimasi (tidak dikenakan biaya) · {n} tempat",
"inv2.expired": " · kedaluwarsa",
"inv2.exportCsv": "Ekspor CSV",
"inv2.exportDone": "Ekspor CSV diunduh",
"inv2.included": "Termasuk",
"inv2.monthlyTitle": "Penagihan bulanan (langganan)",
"inv2.months": "+{n} bulan",
"inv2.paid": "Telah dibayar",
"inv2.pay": "Bayar",
"inv2.previewTitle": "Prabaca faktur Anda selanjutnya —",
"inv2.renew": "Perpanjang kontrak saya",
"inv2.renewalsTitle": "Riwayat perpanjangan ({n})",
"inv2.renewedUntil": "Kontrak diperpanjang hingga {date}",
"inv2.serviceTitle": "Faktur layanan (pemulihan & kutipan)",
"inv2.soon": "Akan segera berakhir",
"inv2.toPay": "Yang harus dibayar",
"inv2.totalHtTva": "Total excl. pajak · PPN",
"inv2.totalTtc": "Total incl. pajak",
"iu.addPhoto": "Tambah foto",
"iu.change": "Ganti",
"lang.label": "Bahasa",
"lb.allCountries": "Semua negara",
"lb.badge": "Papan peringkat tahunan",
"lb.champion": "🏆 Juara tahun ini",
"lb.cityPh": "Filter berdasarkan kota…",
"lb.empty": "Belum ada peringkat untuk filter ini.",
"lb.pts": "poin",
"lb.resetNote": "Papan peringkat tahun ini — direset setiap 1 Januari.",
"lb.returned": "dikembalikan",
"lb.share": "Bagikan papan peringkat",
"lb.shareText": "Lihat papan peringkat penyelidik teratas di Findloop!",
"lb.subtitle": "Setiap pengembalian mendapatkan poin. Papan peringkat direset setiap 1 Januari.",
"lb.tabFinders": "Pencari",
"lb.tabPartners": "Tempat",
"lb.title": "Pencari teratas",
"lost.b2bDesc": "Kehilangan di hotel, pusat transportasi atau tempat mitra? Temukan tempat dan laporkan kehilangan Anda.",
"lost.b2bTitle": "Lapor ke mitra",
"lost.b2cDesc": "Terbitkan iklan yang terlihat oleh semua orang, tawarkan hadiah dan promosikan untuk memaksimalkan peluang Anda.",
"lost.b2cTitle": "Pasang iklan publik",
"lost.desc": "Pilih cara Anda ingin melanjutkan.",
"lost.title": "Kehilangan barang?",
"map.allCategories": "Semua kategori",
"map.clear": "Atur ulang",
"map.exitFullscreen": "Keluar",
"map.filterCity": "Kota atau negara…",
"map.fullscreen": "Layar penuh",
"map.heatmap": "Peta panas",
"map.high": "Tinggi",
"map.impactMonth": "barang yang dikembalikan bulan ini",
"map.impactTotal": "dikembalikan total",
"map.legend": "Titik berwarna dari merah (rendah) ke hijau (tinggi) berdasarkan tingkat pengembalian; ukuran berdasarkan jumlah barang.",
"map.locating": "Menentukan lokasi… tambahkan alamat ke tempat Anda untuk melihatnya di peta.",
"map.low": "Rendah",
"map.mAll": "Semua",
"map.mFound": "Ditemukan",
"map.mLost": "Hilang",
"map.medium": "Sedang",
"map.noItemRegistered": "Tidak ada barang yang terdaftar",
"map.noItems": "Tidak ada barang",
"map.period30": "30 hari terakhir",
"map.period7": "7 hari terakhir",
"map.period90": "90 hari terakhir",
"map.periodAll": "Sepanjang waktu",
"map.returnedSuffix": "dikembalikan · {a}/{t} barang",
"map.stats": "Statistik kota",
"map.statsTop": "5 tempat teratas (barang hilang)",
"map.statsTrend": "Tren 6 bulan",
"map.title": "Peta tempat Anda",
"map.topPlaces": "Tempat populer",
"mc.adClosed": "Iklan ditutup",
"mc.addPhoto": "Tambahkan foto",
"mc.adsNone": "Tidak ada iklan barang hilang.",
"mc.archiveHide": "Sembunyikan riwayat",
"mc.archiveNone": "Belum ada kasus yang diselesaikan.",
"mc.archiveShow": "Tampilkan riwayat",
"mc.archiveSub": "Kasus yang diselesaikan dan dikembalikan.",
"mc.archiveTitle": "Riwayat",
"mc.at": "Di",
"mc.backToLogin": "Kembali ke login",
"mc.boostContacts": "Kontak (boost)",
"mc.boostViews": "Tampilan (boost)",
"mc.cancel": "Batal",
"mc.certificate": "Sertifikat",
"mc.changePhoto": "Ubah foto",
"mc.city": "Kota",
"mc.closeAd": "Tutup",
"mc.closeAdConfirm": "Tutup iklan ini? Iklan ini tidak akan terlihat lagi dan akan menghapus slot.",
"mc.confirmPassword": "Konfirmasi kata sandi",
"mc.confirmRestitution": "Konfirmasi pengembalian",
"mc.connect": "Sambungkan",
"mc.contacts": "Kontak",
"mc.country": "Negara",
"mc.declareFound": "Laporkan barang yang ditemukan",
"mc.declareFoundSub": "Pasang barang yang Anda temukan",
"mc.declareLost": "Laporkan kehilangan",
"mc.declareLostSub": "Pasang iklan barang hilang",
"mc.deleteAccount": "Hapus akun saya",
"mc.deleteConfirm": "Ya, hapus akun saya",
"mc.deleteConfirmBody": "Akun Anda akan dihapus secara permanen dan data pribadi Anda akan dianonimkan. Tindakan ini tidak bisa dibatalkan.",
"mc.deleteConfirmTitle": "Hapus akun Anda?",
"mc.deleteDesc": "Menghapus akun Anda secara permanen dan menganonimkan data pribadi Anda. Tindakan ini tidak dapat dibatalkan.",
"mc.deleted": "Akun Anda telah dihapus.",
"mc.deleting": "Menghapus…",
"mc.email": "Email",
"mc.expiresOn": "Berlaku hingga",
"mc.exportData": "Unduh data saya (GDPR)",
"mc.exportDone": "Data Anda telah diunduh.",
"mc.exporting": "Mempersiapkan…",
"mc.finderAccepted": "Diterima",
"mc.finderProfile": "Profil finder (opsional)",
"mc.finderProfileDesc": "Dapatkan poin dengan mengembalikan barang dan tampil di papan peringkat publik.",
"mc.forYourAd": "Untuk daftar Anda",
"mc.forgotLink": "Lupa kata sandi?",
"mc.forgotSend": "Kirim tautan",
"mc.forgotSent": "Jika akun untuk email ini ada, tautan reset baru saja dikirim.",
"mc.forgotTitle": "Lupa kata sandi",
"mc.foundAdsNone": "Tidak ada daftar barang yang ditemukan yang dipublikasikan.",
"mc.foundAt": "Ditemukan di",
"mc.foundNone": "Tidak ada barang yang ditemukan dilaporkan.",
"mc.hAd": "Iklan hilang",
"mc.hDeclaration": "Pernyataan",
"mc.hFinderContact": "Barang yang dilaporkan",
"mc.hFound": "Barang yang dikembalikan",
"mc.hFoundAd": "Iklan ditemukan",
"mc.histEarned": "Barang dikembalikan",
"mc.historyTitle": "Riwayat poin saya",
"mc.loginBtn": "Masuk",
"mc.loginTitle": "Masuk pelanggan",
"mc.logout": "Keluar",
"mc.lostAt": "Hilang di",
"mc.matchPartner": "Di mitra",
"mc.matchPublic": "Barang ditemukan",
"mc.matches": "Kecocokan",
"mc.matchesSub": "Barang yang ditemukan mungkin cocok dengan daftar barang hilang Anda.",
"mc.myAds": "Iklan barang hilang saya",
"mc.myDeclarations": "Laporan saya",
"mc.myFinds": "Barang yang saya temukan",
"mc.myFindsNone": "Anda belum melaporkan menemukan barang apapun.",
"mc.myFindsSub": "Barang yang Anda laporkan ditemukan di iklan barang hilang.",
"mc.myFound": "Barang yang ditemukan dilaporkan",
"mc.myFoundAds": "Daftar barang yang ditemukan saya",
"mc.myRewards": "Voucher saya",
"mc.name": "Nama lengkap",
"mc.newPassword": "Kata sandi baru",
"mc.none": "Belum ada laporan.",
"mc.notEnough": "Poin tidak cukup",
"mc.notifEmpty": "Belum ada notifikasi.",
"mc.notifOpen": "Lihat",
"mc.notifTitle": "Notifikasi",
"mc.notifTrack": "Lacak",
"mc.notifViewAd": "Lihat iklan",
"mc.optInDesc": "Partisipasi opsional. Anda setuju untuk menampilkan barang yang dipilih di bawah ini secara publik. Dapat diubah kapan saja.",
"mc.optInTitle": "Tampil di papan peringkat publik",
"mc.password": "Kata sandi",
"mc.passwordMismatch": "Kata sandi tidak cocok.",
"mc.phone": "Telepon",
"mc.photoUpdated": "Foto profil diperbarui",
"mc.pointsAwaiting": "Poin yang menunggu",
"mc.pointsBalance": "Poin untuk dibelanjakan",
"mc.pointsOk": "Poin telah dikreditkan",
"mc.presentHint": "Tunjukkan QR ini kepada mitra: mereka akan memindainya untuk memvalidasi reward Anda.",
"mc.presentInStore": "Tampilkan di toko",
"mc.presentTitle": "Tampilkan voucher ini",
"mc.privacy": "Privasi & data",
"mc.privacyDesc": "Unduh salinan semua data pribadi yang dimiliki Findloop tentang Anda (GDPR, pasal 15 & 20).",
"mc.profileSaved": "Profil diperbarui.",
"mc.profileSettings": "Profil publik & papan peringkat",
"mc.pseudo": "Nama depan atau nama panggilan",
"mc.redExpired": "Kedaluwarsa",
"mc.redReady": "Tampilkan kepada mitra",
"mc.redUsed": "Digunakan",
"mc.redeem": "Tebus",
"mc.registerBtn": "Buat akun saya",
"mc.registerTitle": "Buat akun pelanggan",
"mc.rememberMe": "Ingat saya",
"mc.remove": "Hapus",
"mc.resetDone": "Kata sandi diperbarui. Anda sekarang bisa masuk.",
"mc.resetExpired": "Tautan reset ini tidak valid atau sudah kedaluwarsa. Minta yang baru di bawah.",
"mc.resetSave": "Reset kata sandi saya",
"mc.resetTitle": "Kata sandi baru",
"mc.restitutionConfirmed": "Pengembalian dikonfirmasi.",
"mc.reward": "Reward",
"mc.rewardRedeemed": "Reward dibuka! Kode:",
"mc.rewardsDesc": "Gunakan poin Anda untuk keuntungan yang ditawarkan oleh mitra kami. Saldo:",
"mc.rewardsNone": "Belum ada reward tersedia.",
"mc.rewardsTitle": "Belanjakan poin saya",
"mc.scoreAwarded": "Bagus! +1 untuk Skor Finder Anda 🎉",
"mc.scoreEarned": "Poin diperoleh",
"mc.scorePts": "pts",
"mc.scoreThisYear": "Tahun ini",
"mc.scoreTitle": "Skor Finder",
"mc.seeRanking": "Lihat papan peringkat",
"mc.share": "Bagikan",
"mc.statsTitle": "Statistik",
"mc.subtitle": "Lacak semua laporan Anda di satu tempat.",
"mc.title": "Akun saya",
"mc.toLogin": "Sudah terdaftar?",
"mc.toRegister": "Belum punya akun?",
"mc.track": "Lacak",
"mc.views": "Tampilan",
"mc.visCity": "Kota",
"mc.visCountry": "Negara",
"mc.visLabel": "Item yang terlihat di papan peringkat:",
"mc.visName": "Nama depan / nama panggilan",
"mc.visPhoto": "Foto profil",
"mc.welcome": "Halo",
"mc2.acceptFinder": "Terima finder ini",
"mc2.accountActivity": "Aktivitas akun",
"mc2.adsActive": "{n}/5 iklan aktif",
"mc2.autoDelete": "Penghapusan otomatis dijadwalkan untuk",
"mc2.badgeBronze": "Perunggu",
"mc2.badgeGold": "Emas",
"mc2.badgeSilver": "Perak",
"mc2.boostEarnedAlready": "Itu sudah memberi Anda",
"mc2.boostEarnedWin": "Itu memberi Anda",
"mc2.boostExpiredWin": "Peningkatan Anda baru saja kedaluwarsa — lanjutkan dengan -20%!",
"mc2.boostExpiresIn": "Peningkatan Anda akan kedaluwarsa dalam",
"mc2.boostWinDetail2": ". -20% diterapkan secara otomatis jika Anda memperbarui dalam 24 jam.",
"mc2.claimCode": "Kode klaim:",
"mc2.codeSentFinder": "Kode dikirim ke finder melalui email",
"mc2.daysShort": "{n} h",
"mc2.downloadReceipt": "Unduh struk saya",
"mc2.error": "Kesalahan {status}",
"mc2.finderAccepted": "Finder diterima — kode dikirim melalui email",
"mc2.finderContacts": "Detail kontak Finder(s)",
"mc2.followFindo": "Ikuti Findloop",
"mc2.imgInvalid": "Gambar tidak valid",
"mc2.inactivityNote": " — jika terjadi {n} bulan tidak aktif (GDPR).",
"mc2.lastActivity": "Aktivitas terakhir:",
"mc2.lostEmailTitle": "Saya tidak lagi memiliki akses ke email saya",
"mc2.noPhotoPreset": "Belum ada foto? Pilih avatar default:",
"mc2.paidViaPartner": "Dibayar (melalui mitra)",
"mc2.payRecovery": "Bayar biaya pemulihan",
"mc2.paySettle": "Selesaikan pembayaran saya",
"mc2.payShipping": "Bayar biaya pengiriman",
"mc2.payUnavailable": "Pembayaran tidak tersedia",
"mc2.peopleFound": "{n} orang berpikir mereka telah menemukan barang Anda",
"mc2.phoneNumber": "Nomor telepon",
"mc2.reactivateAccount": "Aktifkan kembali akun saya",
"mc2.reactivated": "Akun diaktifkan kembali",
"mc2.reactivatedThanks": "Akun diaktifkan kembali — terima kasih atas loyalitas Anda!",
"mc2.recoverSmsBtn": "Dapatkan kode saya melalui SMS",
"mc2.recoverSmsDesc": "Terima kode klaim Anda melalui SMS ke nomor yang terdaftar di akun Anda.",
"mc2.recoverSmsFallback": "Jika akun ada dengan nomor ini, SMS telah dikirim.",
"mc2.renewStayTop": ". Perpanjang untuk tetap teratas dan mendapatkan kembali barang Anda.",
"mc2.resume20": "Lanjutkan -20%",
"mc2.unlockContacts": "Buka detail kontak",
"mc2.unlockDesc": "Bayar biaya penanganan Findloop untuk mengungkap detail kontak mereka dan mengatur serah terima.",
"mc2.viewsWord": "tampilan",
"mc2.live": "Langsung",
"mh.allCategories": "Semua kategori",
"mh.allPeriod": "Seluruh waktu",
"mh.autoMatch": "Pencocokan AI otomatis",
"mh.blocked": "Diblokir (kontradiksi)",
"mh.blockedReason": "Pencocokan diblokir: kata kunci utama barang dan pernyataan saling bertentangan.",
"mh.days30": "30 hari terakhir",
"mh.days7": "7 hari terakhir",
"mh.days90": "90 hari terakhir",
"mh.emptyDesc": "Pencocokan AI akan muncul di sini saat pernyataan masuk.",
"mh.emptyTitle": "Tidak ada acara",
"mh.exportCsv": "Ekspor CSV",
"mh.exportDone": "Ekspor CSV selesai diunduh",
"mh.exportImpossible": "Ekspor gagal",
"mh.fBlocked": "Diblokir",
"mh.fConfirmed": "Dikonfirmasi",
"mh.fRejected": "Ditolak",
"mh.objectLabel": "Barang:",
"mh.refresh": "Segarkan",
"mh.rejected": "Ditolak",
"mh.srcManual": "Manual",
"mh.srcText": "Teks",
"mh.srcVisual": "Visual (foto)",
"mh.subtitle": "Log pencocokan yang diusulkan oleh AI — dipadankan secara otomatis, dikonfirmasi, dan ditolak.",
"mh.title": "Riwayat AI",
"nav.ads": "Barang hilang",
"nav.dashboard": "Ruang saya",
"nav.found": "Barang ditemukan",
"nav.how": "Cara kerjanya",
"nav.login": "Masuk",
"nav.map": "Peta",
"nav.more": "Lebih banyak",
"nav.partners": "Mit partner",
"nav.pricing": "Harga",
"nav.ranking": "Papan peringkat",
"nav.register": "Menjadi mitra",
"nav.track": "Lacak deklarasi",
"nf.desc": "Halaman yang Anda cari tidak ada atau telah dipindahkan.",
"nf.home": "Kembali ke beranda",
"nf.title": "Halaman tidak ditemukan",
"par.allCities": "Semua kota",
"par.allCountries": "Semua negara",
"par.badge": "Direktori",
"par.certified": "Tersertifikasi",
"par.certifiedBadge": "Tersertifikasi",
"par.cityPh": "Kota",
"par.declare": "Laporkan",
"par.none": "Tidak ada mitra yang ditemukan.",
"par.partnerBadge": "Mitra",
"par.searchPh": "Cari sebuah tempat…",
"par.subtitle": "Temukan tempat di mana Anda kehilangan barang dan laporkan kehilangan Anda.",
"par.title": "Mitra kami",
"pay.addr1": "Alamat",
"pay.addr2": "Baris alamat 2 (opsional)",
"pay.addrIncomplete": "Silakan isi alamat pengiriman Anda.",
"pay.badge": "Pemulihan",
"pay.card": "Bayar dengan kartu",
"pay.city": "Kota",
"pay.country": "Negara",
"pay.eurNote": "Jumlah yang ditampilkan dalam euro (€).",
"pay.fee": "Biaya pemulihan",
"pay.free": "gratis",
"pay.howRecover": "Bagaimana Anda ingin mendapatkan barang Anda kembali?",
"pay.momo": "Bayar dengan Mobile Money",
"pay.momoConfirm": "Konfirmasi pembayaran",
"pay.noMatch": "Tidak ada barang yang cocok yang dikonfirmasi untuk laporan ini.",
"pay.notfound": "Laporan tidak ditemukan.",
"pay.phonePh": "Nomor telepon",
"pay.pickup": "Ambil secara langsung",
"pay.pickupDesc": "Di",
"pay.postal": "Kode pos",
"pay.secure": "Pembayaran aman",
"pay.serviceFee": "Biaya layanan Findloop",
"pay.ship": "Kirimkan kepada saya",
"pay.shipAfter": "— ditawarkan setelah pembayaran.",
"pay.shipDesc": "Pengiriman ke alamat saya",
"pay.shipNote": "Pengiriman tersedia",
"pay.shipping": "Biaya pengiriman",
"pay.subtitleWith": "Bayar biaya pemulihan kepada",
"pay.title": "Pulihkan barang saya",
"pay.total": "Total",
"pcat.city_hall": "Balai kota",
"pcat.hotel": "Hotel",
"pcat.other": "Lainnya",
"pcat.park": "Taman",
"pcat.prefecture": "Prefektur",
"pcat.restaurant": "Restoran",
"pcat.uncategorized": "Belum dikategorikan",
"pd.about": "Tentang",
"pd.back": "Semua mitra",
"pd.certified": "Mitra tersertifikasi",
"pd.declare": "Laporkan kehilangan di sini",
"pd.itemsReturned": "barang dikembalikan",
"pd.itemsTotal": "barang terdaftar",
"pd.map": "Lokasi",
"pd.noItems": "Tidak ada barang yang ditemukan baru-baru ini.",
"pd.noReviews": "Belum ada ulasan.",
"pd.notFound": "Partner tidak ditemukan.",
"pd.recentItems": "Barang yang ditemukan baru-baru ini",
"pd.reply": "Balasan dari tempat usaha",
"pd.reviews": "Ulasan pelanggan",
"pd.verified": "Ulasan terverifikasi",
"pd.verifiedEstablishment": "tempat usaha terverifikasi Findloop",
"pg.next": "Selanjutnya",
"pg.prev": "Sebelumnya",
"pg.showing": "{from}–{to} dari {total}",
"pk.bodyCopy": "Salinan isi",
"pk.bodyText": "Teks isi",
"pk.brandColors": "Warna merek",
"pk.colorRed": "Merah",
"pk.colorWhite": "Putih",
"pk.darkBg": "Latar belakang gelap",
"pk.download": "Unduh",
"pk.downloadZip": "Unduh seluruh paket (ZIP)",
"pk.headings": "Judul",
"pk.heroDesc": "Logo resmi, spanduk media sosial, warna dan tipografi. Pilih bahasa dan varian tagline, lalu unduh visual atau seluruh paket.",
"pk.lightBg": "Latar belakang terang (cetak)",
"pk.logoWordmark": "Logo / tanda kata",
"pk.logosVisuals": "Logo & visual",
"pk.mapCollect": "Peta / titik pengambilan",
"pk.plain": "Sederhana",
"pk.pressKit": "Paket pers",
"pk.taglineLang": "Bahasa tagline",
"pk.typography": "Tipografi",
"pk.variant": "Varian",
"pr.shipBtn": "Kirim barang",
"pr2.adBoostMsg": "Pilihan yang bagus! Anda menggandakan peluang untuk segera mendapatkan kembali barang Anda.",
"pr2.boostActivated": "Boost diaktifkan!",
"pr2.canRecoverNow": "Anda sekarang dapat mengambil kembali barang Anda.",
"pr2.continue": "Lanjutkan",
"pr2.downloadReceiptPdf": "Unduh bukti pembayaran (PDF)",
"pr2.goToSpaceNow": "Pergi ke akun saya sekarang",
"pr2.partnerBoostMsg": "Pilihan yang bagus! Menjadi lebih terlihat berarti menarik pelanggan baru ke tempat usaha Anda.",
"pr2.paymentSuccess": "Pembayaran berhasil!",
"pr2.redirectingSpace": "Mengalihkan ke akun Anda…",
"pr2.subActivated": "Pembayaran berhasil! Langganan Anda aktif, Anda sekarang dapat mengelola tempat usaha Anda.",
"prev.allSites": "Semua tempat usaha",
"prev.editReply": "Edit balasan",
"prev.none": "Belum ada ulasan.",
"prev.published": "Balasan diterbitkan",
"prev.reply": "Balasan",
"prev.replyPh": "Tulis balasan yang sopan…",
"prev.send": "Terbitkan balasan",
"prev.sending": "Menerbitkan…",
"prev.yourReply": "Balasan Anda",
"pricing.annual": "Tahunan",
"pricing.annualBadge": "-20% penawaran",
"pricing.choose": "Pilih",
"pricing.compareFeature": "Fitur",
"pricing.compareTitle": "Bandingkan paket",
"pricing.eyebrow": "Harga",
"pricing.month": "/bulan",
"pricing.monthly": "Bulanan",
"pricing.perYear": "/th",
"pricing.popular": "Populer",
"pricing.quoteMsg": "Kebutuhan Anda (opsional)",
"pricing.quoteOrg": "Organisasi",
"pricing.quoteSend": "Kirim permintaan",
"pricing.quoteSent": "Permintaan telah dikirim! Kami akan menghubungi Anda segera.",
"pricing.quoteSites": "Jumlah situs / terminal",
"pricing.quoteTitle": "Minta penawaran",
"pricing.requestQuote": "Minta penawaran",
"pricing.saveLabel": "Anda menghemat",
"pricing.savePerYear": "/th per tambahan tempat",
"pricing.start": "Mulai",
"pricing.subtitle": "Mulai gratis, skala saat Anda tumbuh.",
"pricing.title": "Rencana untuk setiap organisasi",
"promo.badge": "Program mitra",
"promo.cta": "Pelajari lebih lanjut",
"promo.text": "Setiap mitra yang Anda referensikan dan berlangganan memberi Anda satu bulan gratis. Tanpa batas.",
"promo.title": "Referensikan mitra, dapatkan bulan gratis.",
"pub.accessGranted": "Akses diberikan",
"pub.accessLimited2h": "Akses terbatas 2 jam",
"pub.accountEmailConcerned": "Email akun yang bersangkutan",
"pub.adAppearPublic": "Inilah tampilan iklan Anda secara publik.",
"pub.adPreviewBtn": "Prabaca iklan",
"pub.alertMeOnArrival": "Beritahu saya saat tiba",
"pub.allActionsLogged": "Semua tindakan dicatat",
"pub.allCategories": "Semua kategori",
"pub.authorizeAccess": "Otorisasi akses",
"pub.authorizeSupportQ": "Otorisasi akses dukungan?",
"pub.available": "Tersedia",
"pub.backHome": "Kembali ke beranda",
"pub.boostAdCta": "Tingkatkan iklan saya",
"pub.boostAdTitle": "Tingkatkan iklan Anda",
"pub.boostCarouselSub": "Pindah ke bagian atas halaman di carousel “Ditingkatkan” dan kalikan tampilan untuk mendapatkan item Anda lebih cepat.",
"pub.boostEstablishment": "Tingkatkan tempat Anda",
"pub.boostEstablishmentDesc": "Tampil di bagian atas direktori dengan lencana “Ditingkatkan” dan tarik lebih banyak laporan.",
"pub.boostFicheCta": "Tingkatkan daftar saya",
"pub.brandReady": "Merek Findloop, siap digunakan",
"pub.cantFindItem": "Tidak dapat menemukan item Anda?",
"pub.cantProcessImage": "Tidak dapat memproses gambar ini",
"pub.claimQr": "Klaim kode QR",
"pub.clickToZoom": "Klik untuk memperbesar",
"pub.codeAlreadyValidated": "Kode sudah divalidasi — kontak terunlock.",
"pub.codeExample": "mis. ABCD2345",
"pub.confirmRenewal": "Konfirmasi perpanjangan",
"pub.contactIntro": "Ada pertanyaan, permintaan? Tulis kepada kami, kami akan menghubungi Anda segera.",
"pub.contactTypeDeceased": "Penghapusan akun (orang yang sudah meninggal)",
"pub.contactTypeGeneral": "Pertanyaan umum",
"pub.contactTypeSupport": "Dukungan / masalah teknis",
"pub.contactUs": "Hubungi kami",
"pub.continueWithoutEmail": "Lanjutkan tanpa meninggalkan email saya",
"pub.contractLabel": "Kontrak",
"pub.contractNotFound": "Kontrak tidak ditemukan atau sudah kedaluwarsa.",
"pub.contractRenewed": "Kontrak diperpanjang!",
"pub.contractRenewedFor": "Kontrak Anda diperpanjang selama {n} bulan.",
"pub.copyFailed": "Penyalinan gagal",
"pub.createPartnerAccount": "Buat akun mitra saya",
"pub.currentDeadline": "Batas waktu saat ini",
"pub.deceasedInfo": "Sebagai kerabat atau ahli waris, Anda dapat meminta penghapusan akun Findloop orang yang sudah meninggal. Kami akan memproses permintaan Anda sesuai dengan GDPR (dokumen pendukung mungkin diminta).",
"pub.declareMyLoss": "Laporkan kehilangan saya",
"pub.describeItemPlaceholder": "Deskripsikan item Anda (misalnya payung hitam, kunci…)",
"pub.downloadImage": "Unduh gambar",
"pub.drawSignature": "Silakan gambar tanda tangan Anda.",
"pub.drawSignatureHint": "Gambar tanda tangan Anda dengan mouse atau jari.",
"pub.duration": "Durasi",
"pub.eSignature": "Tanda tangan elektronik",
"pub.eSignatureDesc": "Masukkan nama Anda untuk menandatangani. Tanggal dicatat secara otomatis.",
"pub.edit": "Sunting",
"pub.editorialTitles": "Judul editorial",
"pub.emailPlaceholder": "anda@example.com",
"pub.enterCodeUnlockOwner": "Masukkan kode yang diterima melalui email untuk membuka detail kontak pemilik.",
"pub.errorWord": "Kesalahan",
"pub.foundSelfService": "Item ditemukan · Layanan mandiri",
"pub.haveOwnerCode": "Saya telah menerima kode dari pemilik",
"pub.home": "Beranda",
"pub.immediateRenewal": "Perpanjangan segera, tanpa penawaran baru.",
"pub.impAdminReq1": "Administrator",
"pub.impAdminReq2": "meminta izin untuk mengakses akun Anda sementara",
"pub.impAdminReq3": "untuk membantu Anda.",
"pub.impGrantedDesc": "Tim dukungan akan dapat mengakses akun Anda selama maksimal 2 jam. Setiap tindakan akan dicatat. Anda bisa menutup halaman ini.",
"pub.invitedOnFindo": "Anda diundang untuk bergabung dengan Findloop",
"pub.isThisYourItem": "Apakah ini item Anda?",
"pub.itemsAvailableCount": "{n} item yang tersedia saat ini",
"pub.itemsFoundOwner": "item yang dipercayakan telah menemukan pemiliknya",
"pub.itemsReturnedOwners": "item yang dikembalikan ke pemiliknya",
"pub.itsMine": "Ini milik saya",
"pub.joinFindoDesc": "Bergabunglah dengan Findloop dan kelola item yang Anda temukan dengan mudah.",
"pub.joinInvitesYou": "mengundang Anda untuk bergabung dengan findloop. Buat akun mitra Anda untuk mengelola item yang Anda temukan.",
"pub.linkCopied": "Tautan disalin!",
"pub.loadingContract": "Memuat kontrak…",
"pub.lsClaimDesc": "Laporkan kehilangan Anda untuk memulihkannya. Tinggalkan email Anda dan kami akan mengirimkan pengingat jika laporan Anda belum selesai.",
"pub.lsHeroDesc": "Periksa sendiri apakah item yang hilang telah ditemukan dan ditinggalkan di sini. Menemukannya? Laporkan untuk memulihkannya.",
"pub.lsSearchTitle": "Cari item yang ditemukan",
"pub.makeOffer": "Ajukan tawaran",
"pub.makeOfferDesc": "Usulkan jumlah Anda. Superadmin akan meninjaunya.",
"pub.mapNearYou": "Item & mitra di dekat Anda",
"pub.mapWord": "Peta",
"pub.messageSentToast": "Pesan terkirim — tim kami akan segera membalas.",
"pub.messageWord": "Pesan",
"pub.momoInitiated": "Pembayaran Mobile Money dimulai",
"pub.monthsWord": "bulan",
"pub.nameConsentRequired": "Nama dan persetujuan diperlukan.",
"pub.newDeadline": "Batas waktu baru",
"pub.noActionRequired": "Tidak ada tindakan yang diperlukan.",
"pub.noAmountCharged": "Tidak ada jumlah yang dibebankan.",
"pub.noItemMatch": "Tidak ada item yang tersedia yang cocok dengan pencarian Anda saat ini.",
"pub.noMatchingItem": "Tidak ada item yang cocok",
"pub.noPaymentSession": "Tidak ada sesi pembayaran.",
"pub.noPhoto": "Tidak ada foto",
"pub.noPointsYet": "Belum ada poin yang ditampilkan.",
"pub.noSecondPayment": "Tidak ada pembayaran kedua yang diperlukan untuk item ini.",
"pub.notHereYet": "Belum sampai sini? Dapatkan pemberitahuan segera setelah sampai.",
"pub.notifyDone": "Dicatat! Kami akan memberi tahu Anda melalui email segera setelah item yang cocok tiba.",
"pub.offerSubmitted": "Tawaran Anda telah diajukan.",
"pub.oops": "Ups",
"pub.orAlertEmail": "Atau dapatkan pemberitahuan melalui email segera setelah item yang cocok tiba:",
"pub.ownerContacts": "Detail kontak pemilik",
"pub.ownerContactsUnlocked": "Detail kontak pemilik dibuka",
"pub.partnerContact": "Kontak mitra",
"pub.payLinkUnavailable": "Tautan pembayaran tidak tersedia — hubungi mitra.",
"pub.paymentCancelled": "Pembayaran dibatalkan",
"pub.paymentConfirmed": "Pembayaran dikonfirmasi 🎉",
"pub.paymentConfirmedDesc": "Anda akan menerima email dengan detail untuk mendapatkan kembali barang Anda.",
"pub.paymentNotConfirmed": "Pembayaran tidak dikonfirmasi",
"pub.paymentNotConfirmedDesc": "Pembayaran tidak dapat diverifikasi. Coba lagi atau hubungi mitra.",
"pub.paymentProcessing": "Pembayaran sedang diproses. Segarkan sebentar lagi.",
"pub.photoAdded": "✓ Foto ditambahkan",
"pub.photoRequired": "Diperlukan foto dari barang.",
"pub.previewAlt": "prabaca",
"pub.publish": "Terbitkan",
"pub.publishingWord": "Menerbitkan…",
"pub.qty": "Jumlah",
"pub.quoteDeclined": "Kutipan ditolak.",
"pub.quoteNotFound": "Kutipan tidak ditemukan atau telah kedaluwarsa.",
"pub.reasonLabel": "Alasan",
"pub.recoveryAlreadyPaid": "Biaya pemulihan sudah dibayar",
"pub.referralCode": "Kode rujukan:",
"pub.relationshipPlaceholder": "Anak, pasangan, notaris…",
"pub.renewYourContract": "Perbarui kontrak Anda",
"pub.renewalFailed": "Perpanjangan gagal. Coba lagi nanti.",
"pub.renewing": "Memperbarui…",
"pub.replySoon": "Tim kami akan membalas secepatnya.",
"pub.requestGone": "Permintaan ini tidak ada lagi.",
"pub.requestHandled": "Permintaan sudah ditangani",
"pub.requestNotFound": "Permintaan tidak ditemukan atau telah kedaluwarsa.",
"pub.requestUnavailable": "Permintaan tidak tersedia",
"pub.required": "(diperlukan)",
"pub.retroClosing": "Bersama-sama, kita membuat dunia sedikit kurang tersesat.",
"pub.retroClosing2": "Bersama-sama, kita membuat dunia sedikit kurang tersesat.",
"pub.retroScroll": "Setahun memulihkan apa yang penting. Gulir ke bawah ↓",
"pub.revokeAnytime": "Anda dapat mencabut kapan saja dengan menghubungi kami",
"pub.scene": "Adegan",
"pub.sendImpossible": "Tidak dapat dikirim",
"pub.sendMessage": "Kirim pesan",
"pub.sending": "Mengirim…",
"pub.sharePreview": "Bagikan prabaca",
"pub.shareYourAd": "Bagikan iklan Anda",
"pub.signedSuccess": "Ditandatangani dengan sukses!",
"pub.signerFullName": "Nama lengkap penandatangan",
"pub.spreadNetwork": "Bagikan kepada yang ada di sekitar Anda untuk meningkatkan peluang.",
"pub.spreadOwner": "Bagikan untuk membantu pemilik mendapatkan kembali barang-barang mereka.",
"pub.statusLabel": "Status:",
"pub.subject": "Subjek",
"pub.thanksSent": "Terima kasih, pesan Anda telah dikirim.",
"pub.thisYear": "Tahun ini",
"pub.validate": "Validasi",
"pub.verifyingPayment": "Memverifikasi pembayaran…",
"pub.verifyingYourPayment": "Memverifikasi pembayaran Anda…",
"pub.viewAd": "Lihat iklan →",
"pub.viewPartner": "Lihat mitra →",
"pub.yourAdPreview": "Prabaca iklan Anda",
"pub.yourEmail": "Email Anda",
"pub.yourEmailRecommended": "Email Anda (direkomendasikan)",
"pub.yourEmailShort": "Email Anda",
"pub.yourName": "Nama Anda",
"pub.yourRelationship": "Hubungan Anda dengan orang tersebut",
"qv.acceptAndSign": "Terima dan tandatangani kutipan saya",
"qv.certifyAuthorized": "Saya menyatakan bahwa saya diberi wewenang untuk menandatangani dan saya menerima syarat dari {what} ini (nilai mengikat).",
"qv.clear": "Hapus",
"qv.client": "Klien",
"qv.conditions": "Syarat",
"qv.confirmDecline": "Konfirmasi penolakan kutipan ini?",
"qv.countersignedFindo": "Ditandatangani oleh Findloop · {name} pada {date}",
"qv.decline": "Tolak",
"qv.description": "Deskripsi",
"qv.downloadPdf": "Unduh PDF",
"qv.handwrittenSignature": "Tanda tangan tulisan tangan",
"qv.inclTax": "Termasuk pajak",
"qv.invalidAmount": "Jumlah tidak valid.",
"qv.invoice": "Tagihan",
"qv.invoicePaid": "Tagihan dibayar",
"qv.issuer": "Penerbit",
"qv.messageOptional": "Pesan (opsional)",
"qv.negotiatedAmount": "Jumlah yang dinegosiasikan",
"qv.payInvoiceOnline": "Bayar tagihan secara online",
"qv.quote": "Kutipan",
"qv.quoteValidDays": "Kutipan berlaku selama {n} hari.",
"qv.sendMyOffer": "Kirim tawaran saya",
"qv.signContract": "Tandatangani kontrak saya",
"qv.signNow": "Tandatangani sekarang",
"qv.signatureAlt": "Tanda tangan",
"qv.signedByOn": "✔ Ditandatangani oleh {name} pada {date}",
"qv.stContractSigned": "Kontrak ditandatangani. Terima kasih!",
"qv.stCounterAccepted": "Tawaran Anda telah diterima! Tandatangani kontrak Anda di bawah ini.",
"qv.stCounterRefused": "Tawaran Anda tidak dapat diterima.",
"qv.stCountered": "Tawaran Anda telah diajukan. Menunggu tanggapan dari findloop.",
"qv.stDeclined": "Anda telah menolak kutipan ini.",
"qv.stSigned": "Kutipan diterima dan ditandatangani. Terima kasih!",
"qv.totalHt": "Total tanpa pajak",
"qv.totalTtc": "Total termasuk pajak",
"qv.unitHt": "Unit tanpa pajak",
"qv.vat": "PPN",
"qv.yourProposedAmount": "Jumlah yang Anda tawarkan ({cur})",
"rate.chooseNote": "Silakan pilih penilaian.",
"rate.commentPh": "Komentar (opsional)…",
"rate.home": "Kembali ke beranda",
"rate.submit": "Kirim ulasan saya",
"rate.submitting": "Mengirim…",
"rate.subtitle": "Bagaimana pemulihan barang Anda?",
"rate.successText": "Umpan balik Anda membantu pengguna lain.",
"rate.successTitle": "Terima kasih atas ulasan Anda!",
"rate.title": "Nilai pengalaman Anda",
"reg.add": "Catat barang",
"reg.allBrands": "Semua merek",
"reg.allColors": "Semua warna",
"reg.allLocations": "Semua lokasi",
"reg.detailDesc": "Detail dan tindakan untuk barang yang ditemukan ini.",
"reg.dispAuction": "Lelang",
"reg.dispAuthorities": "Diserahkan kepada otoritas",
"reg.dispDestroyed": "Dihancurkan",
"reg.dispDonate": "Donasi amal",
"reg.dispositionHint": "Catat barang yang keluar dari penyimpanan. Dihitung dalam statistik berdasarkan kategori.",
"reg.emptyCta": "Catat barang",
"reg.emptyDesc": "Mulai dengan mencatat barang yang Anda temukan.",
"reg.emptyTitle": "Tidak ada barang ditemukan",
"reg.establishmentFallback": "perusahaan",
"reg.lblAuctioned": "terdaftar pada lelang",
"reg.lblAuctionedShort": "lelang",
"reg.lblAuthorities": "diserahkan kepada pihak berwenang",
"reg.lblDestroyed": "dihancurkan",
"reg.lblDonated": "didonasikan ke amal",
"reg.legalCount": "{n} item: periode retensi hukum telah tercapai",
"reg.legalHint": "Anda dapat mencantumkannya di lelang, mendonasikannya ke amal, atau melaporkan penyerahannya kepada pihak berwenang.",
"reg.legalLimitCountry": "Batas waktu: {date} · negara yang diterapkan: {country}",
"reg.legalOver": "Batas waktu telah berlalu: {date} · {country}",
"reg.legalReached": "Periode hukum telah tercapai",
"reg.legalReachedFull": "Periode retensi hukum telah tercapai",
"reg.limitShort": "batas waktu",
"reg.location": "Lokasi",
"reg.markRestituted": "Tandai sebagai dikembalikan",
"reg.markedAs": "Item ditandai sebagai {label}",
"reg.moveHistory": "Riwayat pergerakan",
"reg.overBy": "melebihi {n} hari",
"reg.physicalLocation": "Lokasi fisik",
"reg.popupBlocked": "Izinkan pop-up untuk mencetak label.",
"reg.popupBlockedOne": "Izinkan pop-up untuk mencetak label.",
"reg.printLabel": "Cetak label",
"reg.printN": "Cetak {n} label",
"reg.qrCodeItem": "QR kode item",
"reg.qrLabelTitle": "Label QR",
"reg.qrLabelsTitle": "Label QR",
"reg.qrNotFound": "Tidak ada item yang ditemukan untuk kode QR ini.",
"reg.qrScanHint": "Pindai untuk membuka catatan ini secara langsung dan menemukan lokasinya.",
"reg.recoveryFee": "Biaya pemulihan (€)",
"reg.searchPh": "Cari berdasarkan deskripsi…",
"reg.selectQr": "Pilih untuk mencetak label QR",
"reg.selectedN": "{n} terpilih",
"reg.shipPricePh": "Harga pengiriman (€)",
"reg.shippingPossible": "Pengiriman tersedia",
"reg.storagePh": "mis. Rak A3, Lemari 12",
"reg.tAuction": "Lelang di Findloop",
"reg.tAuthorities": "Laporkan penyerahan kepada pihak berwenang",
"reg.tDonate": "Donasikan ke amal",
"reg.toastFee": "Biaya diperbarui",
"reg.toastLocation": "Lokasi disimpan",
"reg.toastRestituted": "Item ditandai sebagai dikembalikan",
"reg.toastShipping": "Opsi pengiriman diperbarui",
"reg.toastTransferred": "Item dipindahkan ke “{name}”",
"reg.unclaimedDisposition": "Item tidak diklaim — disposisi akhir",
"res.codeValidated": "Kode divalidasi",
"res.empty": "Belum ada restitusi yang dicatat.",
"res.error": "Kesalahan {status}",
"res.proofPdf": "Bukti PDF",
"res.signed": "Ditandatangani",
"res.stRestituted": "Diserahkan secara langsung",
"res.stShipped": "Dikembalikan melalui pengiriman",
"res.subtitle": "Semua penyerahan yang selesai, dengan bukti tanda tangan yang dapat diunduh.",
"res.title": "Riwayat restitusi",
"rev.b2b": "Mitra B2B",
"rev.b2c": "Pelanggan",
"rev.based": "berdasarkan {n} ulasan",
"rev.eyebrow": "Testimoni",
"rev.restitutedBy": "Dikembalikan oleh {org}",
"rev.storiesEyebrow": "Akhir bahagia",
"rev.storiesSubtitle": "Cerita nyata dari pelanggan yang mendapatkan kembali barang-barang mereka dengan findloop.",
"rev.storiesTitle": "Mereka menemukan barang-barang mereka!",
"rev.subtitle": "Mitra dan pelanggan berbagi pengalaman mereka.",
"rev.title": "Mereka percaya Findloop",
"rev.verified": "Terverifikasi",
"rp.already": "Anda telah melaporkan daftar ini.",
"rp.comment": "Detail (opsional)",
"rp.duplicate": "Duplikat",
"rp.fraud": "Penipuan / scam",
"rp.inappropriate": "Konten tidak pantas",
"rp.offensive": "Konten ofensif",
"rp.other": "Lainnya",
"rp.reason": "Alasan",
"rp.report": "Laporkan",
"rp.send": "Kirim laporan",
"rp.sent": "Laporan terkirim. Terima kasih atas kontribusi Anda.",
"rp.spam": "Spam / iklan",
"rp.title": "Laporkan listing ini",
"rp.wrongCategory": "Kategori salah",
"rt.annualGoal": "Tujuan tahunan",
"rt.championCity": "Kota juara",
"rt.cityRate": "Tingkat pengembalian {rate}%",
"rt.goalProgress": "{rate}% tercapai dari tujuan {target}%",
"rt.reached": "Dicapai 🎉",
"rt.restitutionRate": "Tingkat pengembalian",
"rt.shareRecap": "Bagikan rekap saya",
"rt.thanks": "Terima kasih Findloop {year} 💛",
"rt.yourRecap": "Rekap {year} Anda",
"rw.active": "Aktif",
"rw.add": "Tambah",
"rw.camUnavailable": "Kamera tidak tersedia. Masukkan kode secara manual di bawah.",
"rw.codeValidated": "Kode telah divalidasi",
"rw.codesTitle": "Kode yang ditebus oleh pencari",
"rw.confirmDelete": "Hapus '{title}'?",
"rw.deleted": "Dihapus",
"rw.edit": "Edit",
"rw.editReward": "Edit hadiah",
"rw.empty": "Belum ada hadiah.",
"rw.expired": "Kedaluwarsa",
"rw.expiresOn": "Kedaluwarsa pada {date}",
"rw.fActive": "Aktif (terlihat oleh pencari)",
"rw.fCost": "Biaya (point)",
"rw.fDesc": "Deskripsi",
"rw.fStock": "Stok (kosong = tidak terbatas)",
"rw.fTitle": "Judul",
"rw.fValidity": "Masa berlaku voucher (hari setelah penukaran)",
"rw.inactive": "Tidak aktif",
"rw.newReward": "Hadiah baru",
"rw.noExchange": "Belum ada penukaran.",
"rw.pageSubtitle": "Pindai voucher yang disajikan oleh pencari untuk memvalidasi hadiah mereka.",
"rw.redeemedN": "Tebus: {n}×",
"rw.saved": "Hadiah disimpan",
"rw.scanVoucher": "Pindai voucher",
"rw.staffScanOnly": "Pindai saja",
"rw.statActive": "Untuk disajikan",
"rw.statExpired": "Kedaluwarsa",
"rw.statRedeemed": "Voucher yang ditebus",
"rw.statUsed": "Divalidasi",
"rw.stock": "Stok",
"rw.subtitle": "Tawarkan manfaat non-moneter (voucher, upgrade…) yang ditebus oleh pencari untuk poin Skor Finder mereka.",
"rw.title": "Hadiah untuk pencari",
"rw.used": "Digunakan",
"rw.validate": "Validasi",
"rw.validateCode": "Validasi kode",
"rw.validity": "Masa berlaku: {n} h",
"shell.f1d": "Secara otomatis menghubungkan barang yang hilang dan ditemukan.",
"shell.f1t": "Kecerdasan Buatan yang Cerdas",
"shell.f2d": "Lacak tingkat pengembalian dan pendapatan secara real time.",
"shell.f2t": "Dasbor & pendapatan",
"shell.f3d": "Pelanggan Anda melapor dalam 30 detik.",
"shell.f3t": "Kode QR Mitra",
"shell.title": "Ubah barang hilang menjadi pelanggan yang puas.",
"ship.addr1": "Alamat",
"ship.addr2": "Baris alamat 2 (opsional)",
"ship.badge": "Pengiriman",
"ship.city": "Kota",
"ship.country": "Negara",
"ship.needPaid": "Bayar biaya pemulihan terlebih dahulu untuk meminta pengiriman.",
"ship.notShippable": "Barang ini tidak tersedia untuk pengiriman.",
"ship.notfound": "Laporan tidak ditemukan.",
"ship.postal": "Kode pos",
"ship.price": "Biaya pengiriman",
"ship.submit": "Minta pengiriman",
"ship.submitting": "Mengirim…",
"ship.subtitle": "Masukkan alamat pengiriman Anda.",
"ship.successText": "Mitra akan menyiapkan paket Anda. Anda akan diberitahu setelah dikirim.",
"ship.successTitle": "Permintaan pengiriman terkirim!",
"ship.title": "Kirim barang Anda",
"ship.weight": "Perkiraan berat (kg)",
"shp.carrier": "Pengangkut",
"shp.download": "Unduh PDF",
"shp.generating": "Menghasilkan…",
"shp.label": "Buat label",
"shp.none": "Tidak ada pengiriman yang diminta.",
"shp.setTracking": "Simpan pelacakan",
"shp.status": "Status",
"shp.to": "Penerima",
"shp.tracking": "No. pelacakan",
"shp.trackingSaved": "Pelacakan disimpan",
"side.account": "Akun saya",
"side.declarations": "Laporan",
"side.deposit": "Catat barang",
"side.establishments": "Tempat",
"side.invoices": "Faktur",
"side.logout": "Keluar",
"side.matchHistory": "Riwayat AI",
"side.partner": "Mitra",
"side.refresh": "Menyegarkan",
"side.registry": "Daftar",
"side.restitutions": "Pengembalian",
"side.reviews": "Ulasan",
"side.rewards": "Hadiah & Voucher",
"side.settings": "Pengaturan",
"side.shipments": "Pengiriman",
"side.stats": "Statistik",
"side.storage": "Penyimpanan & QR",
"side.team": "Tim",
"side.viewSite": "Lihat situs publik",
"st.auctioned": "Terjual di lelang",
"st.claimed": "Diklaim",
"st.closed": "Ditutup",
"st.delivered": "Dikirim",
"st.destroyed": "Dihancurkan",
"st.donated": "Disumbangkan (amal)",
"st.handed_to_authorities": "Diserahkan kepada pihak berwenang",
"st.in_storage": "Dalam penyimpanan",
"st.matched": "Cocok ditemukan",
"st.open": "Buka",
"st.paid": "Dibayar",
"st.pending": "Menunggu",
"st.resolved": "Diselesaikan",
"st.restituted": "Dikembalikan",
"st.second_chance": "Kesempatan kedua",
"st.shipped": "Dikirim",
"st.shipping_requested": "Pengiriman diminta",
"st.submitted": "Dikirim",
"st.verified": "Terverifikasi",
"stat.items": "Barang terdaftar",
"stat.partners": "Mitra",
"stat.restituted": "Barang dikembalikan",
"status.auctioned": "Dilelang",
"status.destroyed": "Dihancurkan",
"status.donated": "Donasi (amal)",
"status.handed_to_authorities": "Diserahkan ke pihak berwenang",
"status.in_storage": "Dalam penyimpanan",
"status.matched": "Cocok",
"status.open": "Buka",
"status.paid": "Dibayar",
"status.pending": "Menunggu",
"status.restituted": "Dikembalikan",
"status.shipped": "Dikirim",
"status.shipping_requested": "Pengiriman diminta",
"status.submitted": "Dikirim",
"step1.tag": "Pendirian",
"step1.text": "Dalam detik, pendirian mencatat barang yang ditemukan dengan foto, kategori, dan deskripsi. Semuanya terpusat dalam registri yang jelas dan aman.",
"step1.title": "Mitra mendaftarkan barang",
"step2.tag": "Pelanggan",
"step2.text": "Melalui kode QR mitra, pelanggan Anda menggambarkan barang hilang dalam 30 detik. Tidak perlu aplikasi — semuanya terjadi di browser.",
"step2.title": "Pelanggan melaporkan kehilangan",
"step3.tag": "Kecerdasan",
"step3.text": "Mesin pencocokan pintar kami membandingkan deskripsi dan menyarankan kecocokan yang paling mungkin, siap untuk dikonfirmasi.",
"step3.title": "AI menghubungkan kehilangan dan barang yang ditemukan",
"step4.tag": "Pemulihan",
"step4.text": "Setelah pembayaran biaya pemulihan yang aman, pelanggan mengambil barang di lokasi — atau menerimanya melalui pengiriman yang dilacak.",
"step4.title": "Pelanggan mendapatkan barang mereka kembali",
"stg.allLabels": "Semua label QR",
"stg.camHint": "Gunakan entri manual di bawah.",
"stg.camStarting": "Memulai kamera…",
"stg.camUnavailable": "Kamera tidak tersedia.",
"stg.clear": "Bersihkan",
"stg.clearAll": "Bersihkan semua",
"stg.codeUnreadable": "Kode tidak terbaca.",
"stg.emptyDesc": "Barang yang disimpan akan muncul di sini, dikelompokkan menurut lokasi.",
"stg.emptyTitle": "Tidak ada barang di penyimpanan",
"stg.exportAudit": "Ekspor audit CSV",
"stg.exportDone": "Ekspor CSV diunduh",
"stg.exportImpossible": "Ekspor tidak tersedia saat ini.",
"stg.itemFound": "Barang ditemukan ✅",
"stg.kLocations": "Lokasi yang digunakan",
"stg.kObjects": "Barang yang disimpan",
"stg.kToClear": "Lokasi yang akan dibersihkan",
"stg.locFreed": "Lokasi dibersihkan",
"stg.locsFreed": "{n} lokasi telah dibersihkan",
"stg.manualLabel": "Atau masukkan kode / ID barang",
"stg.manualPh": "Tempel ID atau URL QR",
"stg.noItemMatch": "Tidak ada barang yang cocok dengan QR / kode ini.",
"stg.noLocation": "Tidak ada lokasi",
"stg.objectsAxis": "Item",
"stg.objectsN": "{n} item",
"stg.occAvg": "rata-rata {n} item/lokasi",
"stg.occHint": "Lokasi yang berwarna amber melebihi rata-rata (berpotensi overload).",
"stg.occupancy": "Kepadatan lokasi",
"stg.openPage": "Buka halaman",
"stg.posterPdf": "Poster PDF (A4)",
"stg.printAll": "Cetak semua",
"stg.printGroupTitle": "Cetak label untuk rak ini",
"stg.qrAlt": "QR swadaya",
"stg.qrDownload": "Unduh QR",
"stg.qrHint": "Tampilkan QR ini di meja: pelanggan Anda memindainya untuk memeriksa apakah item mereka tersedia.",
"stg.qrTitle": "QR swadaya pelanggan",
"stg.scanDesc": "Pindai label item untuk membuka catatannya secara instan.",
"stg.scanQr": "Pindai QR",
"stg.scanTitle": "Pindai kode QR",
"stg.search": "Cari",
"stg.shelf": "Rak {loc}",
"stg.shelfPlan": "Rencana rak",
"stg.staleHint": "Bersihkan lokasi ini untuk menjaga inventaris fisik Anda tetap terbaru.",
"stg.staleTitle": "{n} item telah meninggalkan penyimpanan tetapi masih memiliki lokasi",
"stg.subtitle": "Rencana rak, pemindai QR dan pelacakan inventaris fisik.",
"stg.title": "Penyimpanan & QR",
"stt.acceptRate": "Tingkat penerimaan",
"stt.accepted": "Diterima",
"stt.activity30": "Aktivitas (30 hari terakhir)",
"stt.ai6mo": "6 bulan terakhir · diterima = auto-matched + terkonfirmasi.",
"stt.aiEmpty": "Belum ada pencocokan AI selama periode ini.",
"stt.aiTitle": "Pencocokan AI — diterima vs ditolak",
"stt.auctionShort": "Lelang",
"stt.auctionedSold": "Lelang (terjual)",
"stt.authShort": "Otoritas",
"stt.authorities": "Diserahkan kepada otoritas",
"stt.avgRating": "Rating rata-rata",
"stt.awaitingRestitution": "item menunggu pengembalian",
"stt.boostClicks": "Klik di direktori Anda minggu ini berkat boost",
"stt.boostInactive": "Boost tidak aktif — aktifkan untuk mendapatkan visibilitas",
"stt.certifiedPremium": "Tersertifikasi premium",
"stt.declarations": "Deklarasi",
"stt.destroyed": "Dihancurkan",
"stt.dispoEmpty": "Belum ada item yang tidak diklaim meninggalkan penyimpanan.",
"stt.donatedAssoc": "Disumbangkan (amal)",
"stt.donatedShort": "Disumbangkan",
"stt.gateCta": "Temukan rencana",
"stt.gateDesc": "Upgrade ke Starter untuk membuka statistik dasar Anda, atau ke Business untuk statistik lanjutan dan analisis per-cabang.",
"stt.gateTitle": "Statistik yang diperuntukkan untuk rencana berbayar",
"stt.inStorage": "Dalam penyimpanan",
"stt.kItems": "Item terdaftar",
"stt.kRate": "Tingkat pengembalian",
"stt.kRestituted": "Item dikembalikan",
"stt.kRevenue": "Pendapatan (bulan)",
"stt.noDeclYet": "Belum ada deklarasi.",
"stt.recapDownloaded": "Rekap diunduh — siap untuk dibagikan!",
"stt.recapError": "Tidak dapat menghasilkan rekap",
"stt.recapText": "Rekap Findloop {year} kami: item yang dikembalikan dan kepuasan pelanggan 🎉",
"stt.recapTitle": "rekap Findloop {year}",
"stt.rejected": "Ditolak",
"stt.restitutions": "Pengembalian",
"stt.shareRecap": "Bagikan rekap {year} saya",
"stt.topCategories": "Kategori yang paling banyak dilaporkan",
"stt.unclaimedDesc": "Volume barang yang dihancurkan, disumbangkan ke badan amal, dan dilelang, menurut kategori.",
"stt.unclaimedTitle": "Barang yang tidak terklaim — meninggalkan penyimpanan",
"stt.vsLastWeek": "dibandingkan minggu lalu",
"sub.cancel": "Batalkan langganan saya",
"sub.cancelAbort": "Batalkan",
"sub.cancelConfirm1": "Apakah Anda yakin ingin membatalkan? Akses Anda tetap aktif hingga",
"sub.cancelConfirm2": "Tidak ada pengembalian dana yang akan diterbitkan.",
"sub.cancelConfirmBtn": "Konfirmasi pembatalan",
"sub.cancelTitle": "Batalkan langganan Anda",
"sub.cancelledToast": "Pembatalan tercatat.",
"sub.cguAnd": "dan",
"sub.cguDesc": "Silakan konfirmasi persetujuan Anda sebelum pembayaran.",
"sub.cguLink": "Syarat Penggunaan",
"sub.cguPay": "Lanjutkan ke pembayaran",
"sub.cguPre": "Saya telah membaca dan menerima",
"sub.cguRequired": "Anda harus menerima Syarat Penggunaan dan Kebijakan Privasi untuk melanjutkan.",
"sub.cguSuffix": "dari findloop.",
"sub.cguTitle": "Selesaikan langganan Anda",
"sub.expiresOn": "Langganan Anda berakhir pada",
"sub.noProrata": "Tidak ada pengembalian dana pro-rata.",
"sub.privacyLink": "Kebijakan Privasi",
"sub.renewsOn": "Langganan Anda diperpanjang pada",
"sub.resume": "Daftar ulang",
"sub.resumedToast": "Pendaftaran ulang dikonfirmasi.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Bisnis",
"tier.small": "Pemula",
"tm.add": "Tambahkan",
"tm.adminOpt": "Admin (tampilan penuh)",
"tm.chooseEst": "Pilih sebuah tempat",
"tm.chooseEstPh": "Pilih sebuah tempat",
"tm.copyFail": "Salin gagal",
"tm.copyLink": "Salin tautan",
"tm.copyOk": "Tautan undangan disalin",
"tm.emailHint": "Email undangan akan dikirim untuk membuat kata sandi.",
"tm.expiresOn": "berakhir pada {date}",
"tm.forEmail": " untuk {email}",
"tm.forbidden": "Manajemen tim hanya untuk pemilik akun.",
"tm.inviteCreated": "Undangan dibuat",
"tm.inviteDesc": "Email undangan memungkinkan rekan tim membuat kata sandi mereka.",
"tm.invitePending": "Undangan tertunda",
"tm.inviteResent": "Undangan dikirim ulang",
"tm.inviteSent": "Undangan telah dikirim melalui email",
"tm.inviteTitle": "Undang anggota",
"tm.invitedOn": "Diundang pada {date}",
"tm.linkExpired": "Tautan telah kadaluarsa",
"tm.memberRemoved": "Anggota dihapus",
"tm.name": "Nama",
"tm.noMembers": "Belum ada rekan tim.",
"tm.resendTitle": "Kirim ulang undangan",
"tm.role": "Peran",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Pemilik",
"tm.roleStaff": "Staf",
"tm.roleUpdated": "Peran diperbarui",
"tm.sendInvite": "Kirim undangan",
"tm.sending": "Mengirim…",
"tm.staffOpt": "Staf (hanya melihat tempat mereka)",
"trk.at": "Di",
"trk.badge": "Pelacakan",
"trk.carrier": "Pengangkut",
"trk.codeValidated": "Kode telah divalidasi oleh mitra",
"trk.dlProof": "Unduh bukti serah terima saya (PDF)",
"trk.emailLabel": "Email (opsional — untuk melihat detail Anda)",
"trk.enterEmailCode": "Masukkan email Anda di atas untuk menampilkan kode klaim Anda.",
"trk.idLabel": "Nomor laporan",
"trk.lostEmail": "Saya tidak lagi memiliki akses ke email saya",
"trk.phonePh": "Nomor telepon Anda",
"trk.photoBefore": "Foto barang sebelum pengiriman",
"trk.recoverBtn": "Pulihkan barang saya",
"trk.recoverHint": "Dapatkan kode klaim Anda melalui SMS di nomor terdaftar Anda.",
"trk.searching": "Mencari…",
"trk.secureRest": "Serah terima yang aman",
"trk.send": "Kirim",
"trk.shipPending": "Pengiriman sedang disiapkan — nomor pelacakan akan muncul di sini setelah dikirim.",
"trk.shipTitle": "Pelacakan pengiriman",
"trk.showQr": "Tampilkan QR ini kepada mitra untuk memvalidasi serah terima",
"trk.sigSaved": "Tanda tangan disimpan",
"trk.signFirst": "Silakan tanda tangani sebelum mengonfirmasi.",
"trk.signProof": "Tanda tangani bukti serah terima Anda",
"trk.signSubmit": "Konfirmasi tanda tangan saya dan buat PDF",
"trk.submit": "Lacak",
"trk.subtitle": "Masukkan nomor laporan Anda untuk melacak progres.",
"trk.title": "Lacak laporan saya",
"trk.trackShipment": "Lacak paket",
"trk.trackingNo": "Nomor pelacakan",
"trk.yourCode": "Kode klaim Anda (untuk diberikan kepada mitra)",
"hc.nArchived": "{n} listing yang diarsipkan.",
"hc.newCodeGeneratedAndSent": "Kode baru telah dihasilkan dan dikirim ke pelanggan melalui email dan SMS",
"hc.newCodeGeneratedAndSent2": "Kode baru telah dihasilkan dan dikirim ke pemilik",
"hc.newPassword": "Kata sandi baru",
"hc.next": "Selanjutnya",
"hc.nextPhoto": "Foto selanjutnya",
"hc.no": "Tidak",
"hc.noAnswerProvided": "Tidak ada jawaban yang diberikan.",
"hc.noArchivedDeclarations": "Tidak ada dekralasi yang diarsipkan",
"hc.noCountryFound": "Tidak ada negara ditemukan",
"hc.noDeclarations": "Tidak ada deklarasi",
"hc.noFeesAreChargedTo": "Tidak ada biaya yang dibebankan kepada pelanggan.",
"hc.noInvoiceYet": "Belum ada faktur.",
"hc.noInvoiceYetYourInvoices": "Belum ada faktur. Faktur Anda akan muncul di sini secara otomatis setelah setiap pembayaran.",
"hc.noMatchIsAvailableFor": "Tidak ada kecocokan yang tersedia saat ini. Kami akan memberi tahu Anda segera setelah ada item yang sesuai dengan deklarasi Anda.",
"hc.noShipmentMatchesYourSearch": "Tidak ada pengiriman yang cocok dengan pencarian Anda.",
"hc.noShipmentsYet": "Belum ada pengiriman.",
"hc.noShipmentsYet2": "Belum ada pengiriman",
"hc.none": "tidak ada",
"hc.noneChooseForEachShipment": "Tidak ada (pilih untuk setiap pengiriman)",
"hc.notMine": "Itu bukan milik saya",
"hc.of": "dari",
"hc.only": "Hanya",
"hc.onlyEachSiteManagesIts": "hanya. Setiap situs mengelola banknya sendiri: tautan ini tidak mempengaruhi lembaga lain.",
"hc.onlyTheOwnerOrAn": "Hanya pemilik atau administrator yang dapat mengonfigurasi tautan pembayaran lembaga.",
"hc.openDepositInTheMenu": "Buka \"Deposit\" di menu, deskripsikan item dan ambil foto. Itu langsung disimpan dan siap untuk dikembalikan.",
"hc.openSettings": "Buka Pengaturan →",
"hc.openTheDeclarationToManage": "Buka deklarasi untuk mengelola pengiriman",
"hc.optional": "— opsional",
"hc.optional2": "(opsional)",
"hc.optional3": "opsional",
"hc.originalListingPhotoUsed": "Foto listing asli digunakan",
"hc.other": "Lainnya",
"hc.other2": "Lainnya…",
"hc.ourProducts": "Produk kami",
"hc.overallRateTrendLast6": "Tren tarif keseluruhan (6 bulan terakhir)",
"hc.ownerSClaimCode": "Kode klaim pemilik",
"hc.ownershipConfirmed": "Kepemilikan dikonfirmasi",
"hc.paid": "Dibayar",
"hc.paidOn": "Dibayar pada",
"hc.itemsReturnedThisYear": "item yang dikembalikan tahun ini",
"hc.itemsWhoseLegalDeadlineIs": "Item yang batas waktu hukum adalah 15 hari atau kurang (terlambat termasuk). Pencocokan tetap terlihat.",
"hc.kbisNumber": "Nomor kbis",
"hc.keysForgottenOnABench": "Kunci yang terlupakan di bangku",
"hc.labelBeingGenerated": "Label sedang dibuat",
"hc.leaveTheFieldsEmptyTo": "Biarkan kolom kosong untuk menawarkan pemulihan secara gratis.",
"hc.legalNotice": "Pemberitahuan hukum",
"hc.limitReachedUpgradeToA": "Batas tercapai — tingkatkan ke rencana yang lebih tinggi",
"hc.linkCopiedShareOn": "Tautan disalin — bagikan di {label}",
"hc.linkUnavailable": "Tautan tidak tersedia",
"hc.linkedTo": "Terkait dengan",
"hc.listingHiddenByModeration": "Daftar disembunyikan oleh moderasi.",
"hc.loading": "Memuat…",
"hc.locateMe": "Temukan saya",
"hc.logIn": "Masuk",
"hc.logInToGetBack": "Masuk untuk kembali ke ruang Anda dan kelola langganan Anda.",
"hc.loginFailed": "Gagal masuk",
"hc.lostFoundPlatform": "Platform hilang & ditemukan.",
"hc.lostIn": "hilang di",
"hc.lowRate": "Tarif rendah",
"hc.mainReason": "Alasan utama",
"hc.mainStreet": "Jalan Utama",
"hc.makeSureThisIsThe": "Pastikan ini adalah item yang Anda hilangkan sebelum membuka detail kontak penemu.",
"hc.manageCookies": "Kelola cookie",
"hc.manageMyTeam": "Kelola tim saya",
"hc.manageYourTeam": "Kelola tim Anda",
"hc.markAsReturned": "Tandai sebagai dikembalikan",
"hc.matchNoClaimInTime": "Pencocokan tidak menerima klaim dalam batas waktu.",
"hc.matchNotFound": "Pencocokan tidak ditemukan",
"hc.medium": "Sedang",
"hc.milestoneFmt": "{m} milestone item dikembalikan tercapai! Dalam perjalanan menuju {next}.",
"hc.missingFeatures": "Fitur yang hilang",
"hc.monthly": "Bulanan",
"hc.monthlyBilling": "Penagihan bulanan",
"hc.moveThePhotoToFit": "Pindahkan foto untuk menyesuaikan di lingkaran.",
"hc.myAccount": "Akun saya",
"hc.myInvoices": "Faktur saya",
"hc.myMonthlyInvoices": "Faktur bulanan saya",
"hc.paidViaPartner": "Dibayar (melalui mitra)",
"hc.parcelBeingPrepared": "Paket sedang disiapkan",
"hc.parcelDelivered": "Paket terkirim",
"hc.parcelShipped": "Paket dikirim",
"hc.parisGareDeLyon": "Paris, Gare de Lyon…",
"hc.partner": "Mitra",
"hc.partner2": "mitra",
"hc.partnerDirectory": "Direktori mitra",
"hc.passedOnToTheCustomer": "— diteruskan kepada pelanggan tautan pembayaran.",
"hc.password": "Kata sandi",
"hc.passwordResetPleaseLogIn": "Pengaturan ulang kata sandi, silakan masuk.",
"hc.passwordUpdated": "Kata sandi diperbarui.",
"hc.passwordsDoNotMatch": "Kata sandi tidak cocok.",
"hc.pasteThisSenderIdIn": "Tempelkan ID Pengirim ini di Findloop → Pengaturan",
"hc.payForTheShipmentOf": "Bayar untuk pengiriman barang Anda melalui Findloop dengan pembayaran yang aman.",
"hc.payTheRecoveryFees": "Bayar biaya pemulihan",
"hc.payTheShippingFees": "Bayar biaya pengiriman",
"hc.payment": "Pembayaran",
"hc.paymentAlreadyConfirmedByThe": "Pembayaran sudah dikonfirmasi oleh mitra",
"hc.paymentLinksAreNowConfigured": "Tautan pembayaran kini telah dikonfigurasi per tempat.",
"hc.paymentNotCompletedYourAccount": "Pembayaran tidak selesai, akun Anda belum dibuat — silakan coba lagi.",
"hc.paymentReceived": "Pembayaran diterima",
"hc.paymentSuccessful": "Pembayaran berhasil!",
"hc.pdfInvoice": "Faktur PDF",
"hc.pending": "Tertunda",
"hc.period": "Periode",
"hc.phoneNumber": "Nomor telepon",
"hc.phoneOptional": "Telepon (opsional)",
"hc.planAt": "rencana di",
"hc.planLimitFmt": "Rencana \"{plan}\" Anda terbatas pada {max} tempat. Untuk mengelola {n} situs, kami menyarankan",
"hc.platformReturnTarget": "Target pengembalian platform",
"hc.pleaseCompleteYourShippingAddress": "Silakan lengkapi alamat pengiriman Anda.",
"hc.pleaseProvideAPhoneNumber": "Silakan berikan nomor telepon: ini diperlukan oleh kurir untuk pengiriman.",
"hc.pleaseProvideAReason": "Silakan berikan alasan.",
"hc.pleaseSetYourOwnPassword": "silakan atur kata sandi Anda sendiri sebelum melanjutkan.",
"hc.pointsToGoal": "{n} poin lagi untuk mencapai tujuan bersama kita.",
"hc.posterPreview": "Prabaca poster",
"hc.potentialMatchBeingVerified": "Kecocokan potensial sedang diverifikasi",
"hc.potentialOwner": "Pemilik potensial",
"hc.preFilledAutomaticallyYouCan": "Diisi otomatis — Anda bisa menggantinya dengan foto paket.",
"hc.pressKit": "Kits pers",
"hc.previewMode": "Mode pratinjau:",
"hc.previewOfThePrintReady": "Pratinjau poster A4 siap cetak untuk tempat ini.",
"hc.previous": "Sebelumnya",
"hc.previousPhoto": "Foto sebelumnya",
"hc.primary": "utama",
"hc.printThePoster": "Cetak poster",
"hc.privacy": "Privasi",
"hc.privacyPolicy": "Kebijakan privasi",
"hc.processedCasesWillAppearHere": "Kasus yang diproses akan muncul di sini.",
"hc.proofOfReturnPdf": "Bukti pengembalian (PDF)",
"hc.protectedByRecaptcha": "Dilindungi oleh reCAPTCHA",
"hc.publicMatch": "Pertandingan publik",
"hc.putBackInStorage": "Kembalikan ke penyimpanan",
"hc.pwdResetByTeam": "Kata sandi Anda telah direset oleh tim kami. Untuk keamanan Anda,",
"hc.questionsToAskTheOwner": "Pertanyaan untuk ditanyakan kepada pemilik",
"hc.rateChargedToTheCustomer": "Tarif yang dibebankan kepada pelanggan:",
"hc.rateOfTarget": "{rate}% tercapai dari target {target}%",
"hc.reached": "tercapai",
"hc.reactivating": "Mengaktifkan kembali…",
"hc.reasonSavedYouCanStill": "Alasan disimpan. Anda masih bisa mengklaim barang Anda.",
"hc.recentMatchesFirst": "Pertandingan terbaru pertama",
"hc.recognizedThePhotoYouSent": "mengakui foto yang Anda kirim dan menggambarkan karakteristik ini. Hanya konfirmasi jika sesuai dengan barang yang Anda miliki.",
"hc.recommended": "Direkomendasikan",
"hc.recoveryFees": "Biaya pemulihan",
"hc.recoveryFeesArePaidDirectly": "Biaya pemulihan dibayarkan langsung ke tempat mitra. Findloop tidak menerima pembayaran dari pelanggan.",
"hc.recoveryFeesEnabled": "Biaya pemulihan diaktifkan",
"hc.recoveryOfferedByTheEstablishment": "Pemulihan yang ditawarkan oleh tempat — Findloop tidak mengenakan biaya.",
"hc.recoveryPaymentLink": "Tautan pembayaran pemulihan",
"hc.recoveryPaymentLinkSavedFor": "Tautan pembayaran pemulihan disimpan untuk tempat ini",
"hc.redirecting": "Mengalihkan…",
"hc.redirectingToPayment": "Mengalihkan ke pembayaran…",
"hc.redirectingToTheRecoveryOf": "Mengalihkan ke pemulihan barang Anda…",
"hc.regenerateAndResendToThe": "Regenerasi dan kirim ulang kepada pemilik",
"hc.regenerateTheCode": "Regenerasi kode",
"hc.registerAFoundItem": "Daftarkan barang yang ditemukan",
"hc.rejectTheClaim": "Tolak klaim",
"hc.reminderDelaySaved": "Penundaan pengingat disimpan",
"hc.reopenThePaymentLink": "Buka kembali tautan pembayaran",
"hc.repeatThePassword": "Ulangi kata sandi",
"hc.reportAProblem": "Laporkan masalah",
"hc.reportDismissedYourListingRemains": "Laporan ditolak. Daftar Anda tetap publik.",
"hc.requiredUsedToCalculateThe": "Diperlukan: digunakan untuk menghitung tarif pengiriman Sendcloud. Pengiriman tidak tersedia di atas 30 kg.",
"hc.reset": "Atur ulang",
"hc.resume": "Lanjutkan",
"hc.resumeRegistration": "Lanjutkan pendaftaran",
"hc.retro": "Tahun dalam tinjauan",
"hc.returnSecurity": "Keamanan pengembalian",
"hc.returnToTheOwner": "Kembalikan kepada pemilik",
"hc.returned": "dikembalikan",
"hc.reviewTheItemDetails": "Tinjau detail barang",
"hc.revokeAccess": "Cabut akses",
"hc.role": "Peran:",
"hc.save": "Simpan",
"hc.save2": "simpan",
"hc.saveAndContinue": "Simpan dan lanjutkan",
"hc.saving": "Menyimpan…",
"hc.scanTheClaimCode": "Pindai kode klaim",
"hc.scanTheOwnerSQr": "Pindai QR pemilik",
"hc.scrollThroughLanguages": "Gulir melalui bahasa",
"hc.searchByCustomerItemOr": "Cari berdasarkan pelanggan, item atau nomor pelacakan…",
"hc.searchForACountry": "Cari negara…",
"hc.secureFindoVerification": "Verifikasi Findloop yang aman",
"hc.seeRetro": "Lihat tahun dalam tinjauan",
"hc.selectedCarrier": "Pengangkut yang dipilih:",
"hc.selectedPlan": "Rencana yang dipilih",
"hc.send": "Kirim",
"hc.sendcloudSenderIdSaved": "ID pengirim Sendcloud disimpan",
"hc.sendcloudSenderIdSenderId": "ID pengirim Sendcloud (sender_id)",
"hc.sending": "Mengirim…",
"hc.sessionExpired": "Sesi telah kedaluwarsa",
"hc.setUpYourEstablishments": "Atur tempat usaha Anda",
"hc.settings": "Pengaturan",
"hc.settingsSubtitle": "Pembayaran dan pengingat eksternal, dikonfigurasi per tempat usaha.",
"hc.shareFoundText": "Saya menemukan sebuah barang — bantu saya menemukan pemiliknya di Findloop",
"hc.shareLostText": "Saya kehilangan sebuah barang — bantu saya menemukannya di Findloop",
"hc.sharePreview": "Pratayang berbagi",
"hc.shareTheRanking": "Bagikan peringkat",
"hc.shareYourQrCodeTo": "Bagikan kode QR Anda untuk menerima deklarasi.",
"hc.shipRateAutoWeight": "Tarif pengiriman dihitung secara otomatis melalui Sendcloud (berat {w}) pada saat pengiriman.",
"hc.shipRateForWeight": "Tarif pengiriman (Sendcloud + {m}% margin) untuk {w}:",
"hc.shipments": "Pengiriman",
"hc.shipmentsSubtitle": "Tampilan terintegrasi dari semua pengiriman di seluruh kasus. Klik sebuah baris untuk mengelola pengiriman dalam deklarasinya.",
"hc.shipping": "Pengiriman",
"hc.shippingAddress": "Alamat pengiriman",
"hc.shippingFeesAreHandledAutomatically": "Biaya pengiriman diatur secara otomatis oleh Findloop (Sendcloud) — tidak perlu memasukkan tautan.",
"hc.shippingFeesHaveAlreadyBeen": "Biaya pengiriman telah dibayar: pengirim tidak dapat diubah lagi.",
"hc.shippingNotAvailableForItems": "Pengiriman tidak tersedia untuk barang yang melebihi 30 kg. Pelanggan harus mengambil barang tersebut secara langsung.",
"hc.shippingPaid": "Pengiriman dibayar ✓",
"hc.showOnlyItemsMatchingA": "Tampilkan hanya barang yang cocok dengan daftar publik (pelanggan)",
"hc.showPassword": "Tampilkan kata sandi",
"hc.signInTheBoxAbove": "Masuk di kotak di atas",
"hc.signatureSaved": "Tanda tangan disimpan",
"hc.signedInWithGoogle": "Masuk dengan Google",
"hc.signupFailed": "Pendaftaran gagal",
"hc.silver": "Perak",
"hc.simulatedRatesInPreProduction": "(tarif simulas yang dalam praproduksi)",
"hc.siretAndVatNumberRequired": "Nomor SIRET dan VAT diperlukan (Perancis).",
"hc.skip": "Lewati",
"hc.smsSentIfAccount": "Jika akun dengan nomor ini ada, SMS telah dikirim kepada Anda.",
"hc.sortItemsWithAPublic": "Urutkan: barang dengan kecocokan publik (yang terbaru) pertama",
"hc.specifyWhetherYouRecoveredYour": "Tentukan apakah Anda telah mengambil barang Anda atau hanya ingin menghapus daftar ini.",
"hc.specifyYourReason": "Tentukan alasan Anda",
"hc.specifyYourReason2": "Tentukan alasan Anda…",
"hc.staff": "Staf",
"hc.status": "Status",
"hc.staySignedIn": "Tetap masuk",
"hc.step": "Langkah",
"hc.stillThere": "Masih ada?",
"hc.stopScrolling": "Hentikan pengguliran",
"hc.storeFindWithQr": "Simpan & temukan dengan QR",
"hc.streetName": "Nama jalan",
"hc.streetNo": "No. jalan",
"hc.switchTo": "Beralih ke",
"hc.switchToDarkMode": "Beralih ke mode gelap",
"hc.switchToLightMode": "Beralih ke mode terang",
"hc.takeAPhoto": "Ambil foto",
"hc.takeChangeThePhoto": "Ambil / ganti foto",
"hc.takenFromYourDeclaration": "diambil dari deklarasi Anda",
"hc.target": "Tujuan",
"hc.targetReached": "Target tercapai",
"hc.targetReachedThankYouTo": "Target tercapai — terima kasih kepada seluruh komunitas Findloop!",
"hc.tellUsMore": "Beritahu kami lebih banyak…",
"hc.tellUsWhyYouCancel": "Katakan kepada kami mengapa Anda membatalkan. Ini membantu mitra memproses permintaan Anda.",
"hc.tellUsWhyYourListing": "Katakan kepada kami mengapa. Daftar Anda tetap aktif dan Anda masih bisa mengklaim item Anda.",
"hc.termsAndConditions": "Syarat dan ketentuan",
"hc.termsAndPolicies": "Syarat dan kebijakan",
"hc.thankYouForYourFeedback": "Terima kasih atas umpan balik Anda",
"hc.theBannerDisplayedInThe": "spanduk yang ditampilkan di registri.",
"hc.theClaimantHasBeenInformed": "Klaim telah diberitahukan. Item tetap tersedia di daftar publik.",
"hc.theClaimantHasBeenNotified": "Klaim telah diberitahukan dan sekarang dapat melanjutkan dengan pengembalian.",
"hc.theCustomerPaysTheFees": "Pelanggan membayar biaya ke lokasi.",
"hc.theDayTheLegalRetention": "Hari dimana periode retensi hukum tercapai.",
"hc.theEstablishmentConsideredThatThis": "Lokasi menganggap bahwa item ini bukan milik Anda.",
"hc.theEstablishmentIsReviewingYour": "Lokasi sedang meninjau jawaban Anda. Anda akan diberitahukan segera setelah klaim Anda divalidasi, kemudian Anda dapat membayar biaya pemulihan.",
"hc.theFeesAreTooHigh": "Biaya terlalu tinggi",
"hc.theFinderConsideredThatThis": "Penemu menganggap bahwa item ini bukan milik Anda.",
"hc.theFinderIsReviewingYour": "Penemu sedang meninjau klaim Anda. Anda akan diberitahukan segera setelah divalidasi.",
"hc.theItem": "Item",
"hc.theItemWillBeRemoved": "Item akan dihapus dari registri (tidak ada klaim yang sedang diproses).",
"hc.theItemWillBeSet": "Item akan dikembalikan ke \"tersedia\" dan klaim terkait dibatalkan.",
"hc.theKbisNumberAndVat": "Nomor Kbis dan nomor PPN diperlukan untuk Prancis.",
"hc.theLabelIsGeneratedAutomatically": "Label dihasilkan secara otomatis segera setelah pelanggan membayar biaya pengiriman. Ini akan dapat diunduh di sini.",
"hc.theLinkMayHaveExpired": "Tautan mungkin sudah kedaluwarsa (berlaku selama 30 hari). Hubungi dukungan Findloop jika perlu.",
"hc.theOwnerDescribesTheirItem": "Pemilik mendeskripsikan item mereka",
"hc.theOwnerReceivedItBy": "Pemilik menerimanya melalui email (atau SMS). Masukkan atau pindai sebelum penyerahan.",
"hc.thePartnerConsideredThatThis": "Mitra menganggap bahwa item ini bukan milik Anda. Item tetap tersedia.",
"hc.thePartnerIsReviewingYour": "Mitra sedang meninjau jawaban Anda. Anda akan diberitahukan segera setelah klaim Anda divalidasi.",
"hc.theShipmentIsCreatedAutomatically": "Pengiriman dibuat secara otomatis setelah pelanggan mengonfirmasi alamat mereka dan membayar biaya pemulihan. Label kemudian akan dihasilkan secara otomatis setelah pembayaran pengiriman, dan dapat diunduh di sini.",
"hc.theShippingRateWillBe": "Tarif pengiriman akan dihitung secara otomatis melalui Sendcloud saat pengiriman (berat yang dicatat).",
"hc.thisCarrierWillBe": "Pengangkut ini akan menjadi",
"hc.thisEstablishment": "lokasi ini",
"hc.thisFieldIsRequiredFor": "Field ini diperlukan untuk menghasilkan label otomatis.",
"hc.thisIsMyItem": "Ini adalah item saya",
"hc.thisIsMyItemContinue": "Ini adalah item saya — lanjutkan",
"hc.thisIsMyItemStart": "Ini adalah item saya — mulai pengembalian",
"hc.thisIsNotMyItem": "Ini bukan item saya",
"hc.thisMatchIsNoLonger": "Pencocokan ini tidak tersedia lagi atau telah diproses.",
"hc.thisRateWillBeCharged": "Tarif ini akan dibebankan kepada pelanggan. Tarif yang tinggi dapat menghalangi pemulihan.",
"hc.thisStepIsRequiredFor": "Langkah ini diperlukan agar label pengiriman dapat dihasilkan",
"hc.thisValidationLinkIsInvalid": "Tautan verifikasi ini tidak valid atau telah kedaluwarsa.",
"hc.toCheckBeforeMarkingThe": "Untuk memeriksa sebelum menandai item sebagai dikembalikan.",
"hc.toConfigureTheLinksAnd": "untuk mengonfigurasi tautan dan penundaan pengingat untuk setiap tempat.",
"hc.toReachOurFirstMilestone": "untuk mencapai pencapaian pertama kami sebesar 100 pengembalian.",
"hc.toTheCustomer": "kepada pelanggan.",
"hc.toTheShippingFeePayment": "ke pembayaran biaya pengiriman.",
"hc.toYourRecoveryTracking": "ke pelacakan pemulihan Anda.",
"hc.tooExpensiveBudget": "Terlalu mahal / anggaran",
"hc.topCitiesForReturns": "Kota-kota teratas untuk pengembalian",
"hc.trackMyRecovery": "Lacak pemulihan saya",
"hc.trackTheShipmentAndDownload": "Lacak kiriman dan unduh label (dihasilkan secara otomatis) tanpa meninggalkan tab Deklarasi.",
"hc.trackYourStatistics": "Lacak statistik Anda",
"hc.tracking": "Pelacakan",
"hc.unableToOpenTheShipping": "Tidak dapat membuka pembayaran biaya pengiriman. Silakan coba lagi.",
"hc.unableToRetrieveTheInvoice": "Tidak dapat mengambil faktur.",
"hc.unclaimed": "Belum di klaim",
"hc.unclaimedCustomerReason": "Item yang belum di klaim. Alasan pelanggan: \"{reason}\".",
"hc.unclaimedItem": "Item yang belum di klaim",
"hc.unclaimedItemNoClaimWithin": "Item yang belum di klaim — tidak ada klaim dalam batas waktu.",
"hc.unclaimedItems": "Item yang belum di klaim",
"hc.unclaimedItemsMatchLeftWithout": "Item yang belum di klaim: kecocokan tersisa tanpa klaim dalam batas waktu. Anda dapat mengembalikannya ke penyimpanan.",
"hc.unlockTheFinderSContact": "Buka detail kontak penemu untuk mengatur serah terima.",
"hc.upcoming": "Akan datang",
"hc.updateFailed": "Pembaruan gagal.",
"hc.usedForInvoices": "Digunakan untuk menerbitkan faktur Findloop Anda.",
"hc.vatNumber": "Nomor PPN",
"hc.verificationPending": "Verifikasi tertunda",
"hc.verificationSentToTheFinder": "Verifikasi dikirim ke penemu. Anda akan diberi tahu tentang keputusan mereka.",
"hc.verificationSentToThePartner": "Verifikasi dikirim ke mitra. Anda akan diberi tahu tentang keputusan mereka.",
"hc.verify": "Verifikasi",
"hc.verifyingInvite": "Memverifikasi tautan undangan…",
"hc.verifyingTheLink": "Memverifikasi tautan…",
"hc.viewInRegistry": "Lihat di registri",
"hc.viewItem": "Lihat item",
"hc.viewItemRecover": "Lihat item & pulihkan",
"hc.visibleToTheOwnerAutomatically": "Terlihat oleh pemilik · dihapus secara otomatis setelah 60 hari.",
"hc.waitingForPartnerConfirmation": "Menunggu konfirmasi mitra",
"hc.waitingForThePartnerS": "Menunggu konfirmasi mitra",
"hc.weHaveInformedTheEstablishment": "Kami telah memberi tahu tempat bahwa item ini bukan milik Anda dan memulai ulang analisis. Anda akan diberi tahu segera setelah kecocokan baru ditemukan.",
"hc.weHaveInformedThePartner": "Kami telah memberi tahu mitra bahwa item ini bukan milik Anda. Daftar Anda tetap aktif untuk kecocokan di masa depan.",
"hc.weRanTheAnalysisAgain": "Kami telah menjalankan analisis lagi dan mengidentifikasi item lain yang mungkin milik Anda. Silakan periksa lagi.",
"hc.weight": "Berat",
"hc.weightNotProvidedTheShipping": "Berat tidak tersedia: tarif pengiriman akan dihitung pada saat pengiriman.",
"hc.weightUnit": "Satuan berat",
"hc.welcome": "Selamat datang!",
"hc.welcomeToFindo": "Selamat datang di Findloop",
"hc.whenACustomerComesTo": "Ketika seorang pelanggan datang untuk mengambil barangnya, buka deklarasinya dan validasi pengembalian. Itu saja!",
"hc.whenDisabledFeesDropTo": ". Ketika dinonaktifkan, biaya turun menjadi",
"hc.whyIsThisNotYour": "Mengapa ini bukan barang Anda?",
"hc.willBeMarkedAs": "akan ditandai sebagai",
"hc.wrongColor": "Warna salah",
"hc.wrongModel": "Model salah",
"hc.yesCancel": "Ya, batalkan",
"hc.yesContactTheFinder": "Ya, hubungi penemu",
"hc.youAreHere": "Anda berada di sini",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Anda sekarang dapat memulai pengembalian.",
"hc.youCanStillChangeIt": ". Anda masih dapat mengubahnya tergantung kasus.",
"hc.youHaveAlreadyConfirmedThat": "Anda sudah mengkonfirmasi bahwa ini adalah barang Anda.",
"hc.youWillBeRedirectedTo": "Anda akan dialihkan ke pembayaran Stripe yang aman.",
"hc.yourAccountHasBeenReactivated": "Akun Anda telah diaktifkan kembali.",
"hc.yourAccountIsActiveYou": "Akun Anda aktif, Anda sekarang dapat mengelola tempat Anda.",
"hc.yourEstablishment": "Tempat Anda",
"hc.yourFeedbackHelpsUsImprove": "Umpan balik Anda membantu kami meningkatkan pencocokan kami.",
"hc.yourFeedbackHelpsUsRestart": "Umpan balik Anda membantu kami memulai ulang analisis dan meningkatkan pencocokan kami.",
"hc.yourFirstSteps": "Langkah pertama Anda",
"hc.yourFirstStepsAdmin": "Langkah pertama Anda (admin)",
"hc.yourItemHasBeenHanded": "Barang Anda telah diserahkan secara langsung oleh mitra — tutup kasus setelah penyerahan dikonfirmasi.",
"hc.yourItemHasBeenShipped": "Barang Anda telah dikirim oleh mitra — tutup kasus setelah pengiriman dikonfirmasi.",
"hc.yourPaymentHasBeenRecorded": "Pembayaran Anda telah dicatat.",
"hc.yourShipmentIsBeingPrepared": "Pengiriman Anda sedang disiapkan. Anda akan menerima paket Anda dalam 3 hingga 5 hari kerja.",
"hc.yourShippingFeesHaveAlready": "Biaya pengiriman Anda telah dibayar. Pengiriman dibayar ✓",
"hc.yourShippingFeesHaveBeen": "Biaya pengiriman Anda telah dibayar. Paket Anda sedang disiapkan.",
"hc.yourVerificationQuestionsDeposit": "Pertanyaan verifikasi Anda (deposit)",
"hero.einvoiceBadge": "e-invoicing yang sesuai dengan 2027",
"home.recentAdsAll": "Lihat semua daftar",
"home.recentAdsEyebrow": "Saat ini",
"home.recentAdsSubtitle": "Item yang hilang dan ditemukan dilaporkan oleh komunitas.",
"home.recentAdsTitle": "Daftar terbaru",
"home.reunions": "Reuni terbaru",
"home.videoEyebrow": "Tonton",
"home.videoSubtitle": "Bagaimana kami mengembalikan barang-barang yang hilang kepada pemiliknya, dengan mudah.",
"home.videoTitle": "Temukan Findloop dalam 2 menit",
"home.watchYoutube": "Tonton di YouTube",
"impact.already": "Sudah",
"impact.citiesWord": "kota/kota",
"impact.eachPoint": "Setiap titik merupakan kota di mana Findloop membantu mengembalikan barang yang hilang.",
"impact.emptyMap": "Peta akan terisi seiring dengan restitusi yang terjadi.",
"impact.eyebrow": "Dampak kami",
"impact.inCities": "di seluruh",
"impact.restitutedTo": "barang yang dikembalikan kepada pemiliknya",
"impact.title": "Barang-barang yang dikembalikan, di sekitar Anda",
"inv2.download": "Unduh",
"inv2.view": "Lihat",
"map.objectsOnMapPlural": "barang di peta",
"map.objectsOnMapSingular": "barang di peta",
"mc.claimConfirmDesc": "Periksa barang yang ditemukan oleh penemu sebelum membayar untuk membuka detail kontak mereka.",
"mc.claimConfirmNo": "Ini bukan barang saya",
"mc.claimConfirmTitle": "Apakah ini benar-benar barang Anda?",
"mc.claimConfirmYes": "Ya, itu milik saya — bayar",
"mc.claimFinderContacts": "Detail kontak penemu",
"mc.claimNotMineDone": "Terima kasih — penemu telah diberitahu dan permintaan Anda telah dihapus dari iklan.",
"mc.claimUnlockDesc": "Bayar biaya administrasi Findloop untuk mendapatkan detail kontak orang yang menemukan barang Anda.",
"mc.claimUnlockTitle": "Buka detail kontak penemu",
"mc.hideCountryOffers": "Sembunyikan tawaran di negara saya",
"mc.myClaims": "Barang yang saya klaim",
"mc.myClaimsSub": "Barang yang ditemukan oleh orang lain yang Anda klaim. Buka detail kontak penemu untuk mengatur penyerahan.",
"mc.notifAdCancelled": "Iklan dibatalkan",
"mc.notifCancelAd": "Batalkan iklan saya",
"mc.offersInCountry": "Tawaran di negara saya",
"mc.offersInCountryDesc": "Semua imbalan aktif dari mitra di negara Anda, berdasarkan kota.",
"mc.redArchived": "Diarsipkan",
"mc.rewardsCountryNone": "Belum ada tawaran di negara Anda.",
"mc.rewardsForYou": "Imbalan untuk Anda",
"mc.rewardsForYouDesc": "Ditawarkan oleh mitra tempat Anda menyerahkan barang.",
"mc.rewardsMineNone": "Belum ada imbalan dari mitra penyerahan Anda.",
"mc.showCountryOffers": "Lihat tawaran di negara saya",
"mc2.cancelDecl": "Batalkan deklarasi saya",
"mc2.cancelDeclDone": "Deklarasi dibatalkan.",
"pricing.physInvDesc": "Ketika barang dikembalikan, lokasinya secara otomatis dibebaskan dan tersedia untuk barang baru.",
"pricing.physInvTitle": "Pelacakan inventaris fisik",
"pricing.physModalTitle": "Manajemen barang fisik",
"pricing.physQrDesc": "Kode QR unik dihasilkan per item dan menghubungkan ke semua informasinya.",
"pricing.physQrTitle": "Label QR khusus",
"pricing.physShelfDesc": "Setiap item yang terdaftar dapat ditugaskan lokasi fisik di dalam tempat tersebut.",
"pricing.physShelfTitle": "Rencana rak",
"pricing.physicalMgmt": "Manajemen barang fisik (rak, QR, inventaris)",
"pub.addSecondPhoto": "Tambahkan foto ke-2 (opsional)",
"pub.photo2Added": "✓ Foto ke-2 ditambahkan",
"reg.dispositionJournal": "Jurnal disposisi",
"reg.dispositionNoteAuthHint": "ℹ️ Catatan diperlukan untuk “Diserahkan ke pihak berwenang” (nomor laporan, departemen…).",
"reg.dispositionNotePh": "Catatan (opsional): amal penerima, referensi pihak berwenang, nama pembeli…",
"reg.dispositionNoteRequired": "Referensi resmi diperlukan untuk diserahkan kepada pihak berwenang.",
"reg.legalPrealert": "Batas waktu hukum dalam {days} hari",
"reg.legalPrealertOptions": "Opsi pada batas waktu: penjualan lelang, sumbangan untuk amal, diserahkan ke pihak berwenang.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Ulasan lengkap",
"rev.readMore": "Baca selengkapnya",
"rw.activeCodes": "Kupon aktif",
"rw.archived": "Arsip",
"rw.archivedTitle": "Kupon yang ditukarkan (arsip)",
"rw.hideArchived": "Sembunyikan kupon yang ditukarkan",
"rw.noArchived": "Tidak ada kupon yang diarsipkan.",
"rw.showArchived": "Tampilkan kupon yang ditukarkan",
"shp.labelAuto": "Label dihasilkan secara otomatis segera setelah pelanggan membayar biaya pengiriman. Ini akan dapat diunduh di sini.",
"st.cancelled_by_customer": "Dibatalkan",
"stt.dispoPdfBtn": "Ekspor PDF",
"stt.dispoPdfError": "Ekspor PDF gagal.",
"stt.dispoPdfExporting": "Mengeskpor…",
"trk.matchVerifying": "Kecocokan potensial sedang diverifikasi",
"a.firstName": "Nama depan",
"ac.emailCrossMatch": "Cocokan B2C",
"ac.emailCrossMatchDesc": "Email ketika iklan barang hilang publik cocok dengan item yang disimpan di tempat Anda",
"ac.emailCrossReject": "Penolakan cocokan publik",
"ac.emailCrossRejectDesc": "Terima email ketika seorang pelanggan menunjukkan bahwa cocokan publik yang disarankan bukanlah barang mereka.",
"ac.emailLoginNotif": "Notifikasi login",
"ac.emailLoginNotifDesc": "Terima email setiap kali seseorang melakukan login ke akun Anda.",
"ad.closeNoCancel": "Tidak, hapus listing",
"ad.closeQuestion": "Apakah barangnya telah dikembalikan kepada Anda?",
"ad.closeQuestionDesc": "Beri tahu kami apakah Anda berhasil memulihkan barang Anda, atau jika Anda hanya ingin menghapus listing ini.",
"ad.closeYesRestituted": "Ya, barangnya telah dikembalikan",
"ad.closedRestituted": "Barang dikembalikan — listing ditutup 🎉",
"an.lostLoginDesc": "Akun diperlukan untuk melaporkan barang hilang dan mengikuti pengembaliannya.",
"an.lostLoginRequired": "Masuk untuk melaporkan barang hilang",
"an.qfAll": "Semua",
"an.qfBoosted": "Ditingkatkan",
"an.qfPhoto": "Dengan foto",
"an.qfRecent": "Minggu ini",
"an.qfResolved": "Selesai",
"an.restitutionInProgress": "Barang sedang dikembalikan",
"dec.descPhLong": "Deskripsikan barang: merek, warna, tanda-tanda khas… (Semakin banyak detail yang Anda berikan, semakin tinggi peluang Anda untuk memulihkan barang Anda)",
"dec.loadError": "Tidak dapat memuat mitra saat ini. Periksa koneksi Anda dan coba lagi.",
"dec.retry": "Coba lagi",
"dec.shippingMode": "Pengiriman",
"dep.photo2": "Foto item ke-2",
"dep.photo2Hint": "Opsional — sudut lain meningkatkan akurasi pencocokan visual.",
"dl.accountSuspended": "Akun ditangguhkan karena faktur yang belum dibayar. Selesaikan untuk memulihkan akses Anda.",
"dl.regularize": "Selesaikan sekarang →",
"dl.suspensionCountdown": "Faktur {num} belum dibayar — akun Anda akan ditangguhkan dalam {days} hari. Selesaikan untuk menghindari ini.",
"ft.cancelConfirm": "Batalkan laporan Anda? Pemilik barang akan diberitahu.",
"ft.cancelDone": "Laporan dibatalkan.",
"ft.cancelLocked": "Pembatalan tidak lagi mungkin setelah pemilik membayar.",
"ft.cancelReport": "Batalkan laporan saya",
"ft.claimCodeHelp": "Berikan kode ini kepada penemu saat penyerahan untuk mengkonfirmasi Anda telah menerima barang Anda.",
"ft.claimCodeTitle": "Kode restitusi Anda",
"ft.claimDone": "Barang dikembalikan. Terima kasih telah menggunakan Findloop!",
"ft.claimUnlockHint": "Buka kunci detail kontak penemu",
"ft.claimUnlockHintSub": "Pergi ke \"Barang yang saya klaim\" di akun Anda untuk membayar biaya dan mendapatkan detail kontak.",
"ft.finderCodeShownHelp": "Pemilik telah membayar dan memilih Anda. Salin kode ini di bawah untuk mengkonfirmasi pengembalian — tidak perlu memeriksa email Anda.",
"ft.finderCodeShownTitle": "Kode validasi pemilik",
"ft.finderContactsTitle": "Detail kontak Finder",
"ft.foundCodeHelp": "Tunjukkan kode ini kepada pemilik saat penyerahan untuk mengonfirmasi bahwa barang telah dikembalikan.",
"ft.inProgressOther": "Barang sedang dikembalikan",
"ft.inProgressOtherHelp": "Pemilik telah memilih finder lain untuk barang ini. Tidak perlu tindakan lebih lanjut dari pihak Anda.",
"ft.restitutionCodeHelp": "Kode ini mengonfirmasi penyerahan barang. Ini sudah terisi otomatis di bawah; validasi lalu tutup kasusnya.",
"ft.restitutionCodeTitle": "Kode restitusi Anda",
"hc.14Digits": "14 digit",
"hc.15DaysBeforeAnItem": "15 hari sebelum batas waktu hukum barang.",
"hc.7DaysBeforeAnItem": "7 hari sebelum batas waktu hukum barang.",
"hc.8CharactersMinimum": "Minimal 8 karakter.",
"hc.aClaimToValidate": "Sebuah klaim untuk divalidasi",
"hc.aFindoAssistanceSessionIs": "Sesi bantuan Findloop saat ini aktif di akun Anda.",
"hc.aNewMatchHasBeen": "Kecocokan baru telah ditemukan",
"hc.aUser": "Seorang pengguna",
"hc.aUserClaimsToBe": "Seorang pengguna mengaku sebagai pemilik. Periksa jawaban mereka sebelum mengizinkan pengembalian.",
"hc.aboutFindo": "Tentang Findloop",
"hc.accountActivatedPleaseLogIn": "Akun telah diaktifkan, silakan masuk.",
"hc.accountActivation": "Aktivasi akun",
"hc.accountCreated": "Akun telah dibuat!",
"hc.accountDeactivatedAReactivationEmail": "Akun dinonaktifkan. Email reaktivasi (berlaku selama 30 hari) telah dikirim kepada Anda.",
"hc.accountReactivation": "Reaktivasi akun",
"hc.activateMyAccount": "Aktifkan akun saya",
"hc.activateMyAdminAccount": "Aktifkan akun admin saya",
"hc.activating": "Mengaktifkan…",
"hc.activeMatchCancelReason": "Kecocokan aktif. Alasan pembatalan pelanggan: \"{reason}\". Barang masih menunggu klaim.",
"hc.activeMatchWithAPublic": "Kecocokan aktif dengan listing publik (pelanggan). Menunggu klaim dari pemilik.",
"hc.addAPhoto": "Tambahkan foto",
"hc.addAndConfigureYourEstablishments": "Tambahkan dan konfigurasi tempat Anda di \"Tempat\": detail kontak, kategori, dan penyimpanan fisik barang.",
"hc.addOnGoogle": "Tambahkan di Google",
"hc.address": "Alamat",
"hc.addressSaved": "Alamat tersimpan",
"hc.addressStreet": "Alamat — Jalan",
"hc.adjustThePhoto": "Sesuaikan foto",
"hc.adminFullView": "Admin (tampilan penuh)",
"hc.administratorOnly": "Hanya administrator",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "Perbandingan visual AI",
"hc.all": "Semua",
"hc.amount": "Jumlah",
"hc.anOrganization": "Sebuah organisasi",
"hc.analyzing": "Menganalisis…",
"hc.andRecoveryIs": "dan pemulihan adalah",
"hc.andTheDeclarationWillBe": "dan deklarasi akan ditutup (dipindahkan ke sejarah). Tindakan ini bersifat final.",
"hc.annual20": "Tahunan -20%",
"hc.annualBilling20": "Penagihan tahunan (−20%)",
"hc.annualTarget": "Target tahunan",
"hc.anyCommentsOptional": "Komentar apapun? (opsional)",
"hc.approveTheClaim": "Setujui klaim",
"hc.archiveCancelledConfirm": "Arsip {n} listing \"Dibatalkan oleh pelanggan\"? Mereka akan dihapus dari registri.",
"hc.asSoonAs": "Segera setelah",
"hc.askTheOwnerToDisplay": "Minta pemilik untuk menampilkan QR kode mereka (halaman pelacakan).",
"hc.askThemAtTheCounter": "Tanyakan kepada mereka di konter untuk mengonfirmasi identitas - tidak pernah terlihat secara publik.",
"hc.assistance": "Dukungan",
"hc.assistanceSessionRevoked": "Sesi bantuan dibatalkan.",
"hc.atLeast6Characters": "Setidaknya 6 karakter",
"hc.automaticallyPreSelected": "secara otomatis terpilih",
"hc.automaticallyWhenShipping": "secara otomatis saat pengiriman.",
"hc.awaitingClaim": "Menunggu klaim",
"hc.awaitingPayment": "Menunggu pembayaran",
"hc.b2cCustomer": "Pelanggan B2C",
"hc.back": "Kembali",
"hc.backToHome": "Kembali ke beranda",
"hc.backToMyAccount": "Kembali ke akun saya",
"hc.backToPayment": "Kembali ke pembayaran",
"hc.beforeAfterComparisonSlider": "Penggeser perbandingan sebelum/setelah",
"hc.billingInformation": "Informasi penagihan",
"hc.billingInformationSaved": "Informasi penagihan disimpan ✓",
"hc.brand": "Merek",
"hc.bronze": "Perunggu",
"hc.calculatingTheShippingRate": "Menghitung tarif pengiriman…",
"hc.cameraUnavailableEnterTheCode": "Kamera tidak tersedia. Masukkan kode secara manual.",
"hc.cancel": "Batal",
"hc.cancelMyDeclaration": "Batalkan deklarasiku",
"hc.cancelSavedFmt": "Pembatalan disimpan: \"{reason}\". Anda masih bisa mengklaim.",
"hc.cancelTheDeposit": "Batalkan deposit",
"hc.cancelThisMatch": "Batalkan pertandingan ini",
"hc.cancellationReason": "Alasan pembatalan",
"hc.cancelled": "Dibatalkan",
"hc.cancelledByTheCustomer": "Dibatalkan oleh pelanggan",
"hc.cannotOpenPayment": "Tidak dapat membuka pembayaran. Harap coba lagi.",
"hc.careers": "Karir",
"hc.carrier": "Pengangkut",
"hc.carrierAvailabilityCannotBeChecked": "Ketersediaan pengangkut tidak dapat diperiksa hingga pengirim Sendcloud Anda dikonfigurasi.",
"hc.carrierConfirmedCharged": "Pengangkut telah dikonfirmasi — {price} € dikenakan kepada pelanggan",
"hc.carrierOther": "Pengangkut (lain)",
"hc.carrierSelection": "Pemilihan pengangkut",
"hc.caseClosedThankYou": "Kasus ditutup. Terima kasih!",
"hc.category": "Kategori",
"hc.changeMethod": "Ubah metode",
"hc.characteristic": "Karakteristik",
"hc.chargedToCustomer": "dikenakan kepada pelanggan.",
"hc.checkOrEditYourDetails": "Periksa atau edit detail Anda sebelum pembayaran yang aman.",
"hc.checkStatisticsToTrackDeposited": "Periksa \"Statistik\" untuk melacak barang yang disetor, tingkat pengembalian dan kinerja masing-masing tempat.",
"hc.checkTheDetailsBeforeContacting": "Periksa detail sebelum menghubungi pencari.",
"hc.checkTheDetailsBelowBefore": "Periksa detail di bawah ini sebelum memulai permintaan pengembalian Anda.",
"hc.checkTheNewItem": "Periksa barang baru",
"hc.checkThePhotosAndCharacteristics": "Periksa foto dan karakteristik di bawah ini sebelum melanjutkan dengan pemulihan.",
"hc.chooseACountry": "Pilih negara",
"hc.chooseANewPassword": "Pilih kata sandi baru",
"hc.chooseAReason": "Pilih alasan",
"hc.chooseTheLegalRetentionAlerts": "Pilih pemberitahuan penyimpanan hukum yang diterima melalui email untuk",
"hc.chooseYourPasswordToAccess": "Pilih kata sandi Anda untuk mengakses konsol administrasi.",
"hc.city": "Kota",
"hc.claimApproved": "Klaim disetujui",
"hc.claimApproved2": "Klaim disetujui.",
"hc.claimCodeExpired": "Kode klaim kedaluwarsa",
"hc.claimCodeVerified": "Kode klaim terverifikasi",
"hc.claimNotFound": "Klaim tidak ditemukan",
"hc.claimNotValidated": "Klaim tidak divalidasi",
"hc.claimRejected": "Klaim ditolak",
"hc.claimRejected2": "Klaim ditolak.",
"hc.claimValidated": "Klaim divalidasi",
"hc.claimValidatedByThePartner": "Klaim divalidasi oleh mitra",
"hc.claimant": "Pengklaim",
"hc.claimsToBeTheOwner": "mengklaim menjadi pemilik barang ini dan menjawab pertanyaan verifikasi. Hanya disetujui jika jawabannya cocok.",
"hc.claimsToValidate": "Klaim untuk divalidasi",
"hc.clear": "Bersihkan",
"hc.clickToZoom": "Klik untuk memperbesar",
"hc.close": "Tutup",
"hc.close2": "Tutup",
"hc.closeTheDeclaration": "Tutup deklarasi",
"hc.closeTheDeclaration2": "Tutup deklarasi?",
"hc.codeAlreadyVerified": "Kode sudah diverifikasi",
"hc.codeCopied": "Kode disalin",
"hc.collapse": "Liput",
"hc.color": "Warna",
"hc.company": "Perusahaan",
"hc.companyName": "Nama perusahaan",
"hc.comparePhotos": "Bandingkan foto",
"hc.compareThemWithTheOwner": "Bandingkan dengan jawaban pemilik — tidak pernah terlihat publik.",
"hc.condition": "Kondisi",
"hc.confirmAndPay": "Konfirmasi dan bayar",
"hc.confirmCancellation": "Konfirmasi pembatalan",
"hc.confirmCrop": "Konfirmasi pemotongan",
"hc.confirmDeletion": "Konfirmasi penghapusan",
"hc.confirmPassword": "Konfirmasi kata sandi",
"hc.confirmThatThisIsYour": "Konfirmasi bahwa ini adalah barang Anda. Pemeriksaan identitas akan diminta dari penemu sebelum ada kontak.",
"hc.confirmTheCarrier": "Konfirmasi pengirim",
"hc.confirmThePassword": "Konfirmasi kata sandi",
"hc.confirmYourShippingAddressTo": "Konfirmasi alamat pengiriman Anda untuk melanjutkan pembayaran.",
"hc.confirmYourSubscription": "Konfirmasi langganan Anda",
"hc.confirmed": "Dikonfirmasi ✓",
"hc.contactFindoToGetYour": "Hubungi Findloop untuk mendapatkan ID Pengirim Anda.",
"hc.contactUs": "Hubungi kami",
"hc.continueTheReturn": "Lanjutkan pengembalian",
"hc.continueToPayment": "Lanjutkan ke pembayaran",
"hc.copy": "Salin",
"hc.correctMyDetails": "benarkan detail saya",
"hc.correctThisEntry": "Benarkan entri ini?",
"hc.country": "Negara",
"hc.countryAddress": "Negara (alamat)",
"hc.countryIsoCodeEG": "Negara (kode ISO, mis. FR)",
"hc.cover": "sampul",
"hc.createTheShipment": "Buat pengiriman",
"hc.cropThePhoto": "Potong foto",
"hc.customer": "Pelanggan",
"hc.customerClaimCodeToCheck": "Kode klaim pelanggan — untuk diperiksa saat pengambilan:",
"hc.customerReasonFmt": "Alasan pelanggan: \"{reason}\".",
"hc.customerReminderDelay": "Keterlambatan pengingat pelanggan",
"hc.customerWhosePublicListingMatches": "Pelanggan yang daftar publiknya cocok dengan barang ini — hanya terlihat oleh Anda.",
"hc.d15": "D-15",
"hc.dangerZone": "Zona berbahaya",
"hc.date": "Tanggal",
"hc.dateNewest": "Tanggal (terbaru)",
"hc.dateOldest": "Tanggal (terlama)",
"hc.daysToYearEnd": "{n} hari hingga akhir tahun",
"hc.deadlineAlert": "Peringatan batas waktu",
"hc.declarationClosed": "Deklarasi ditutup ✓",
"hc.declarationNotFound": "Deklarasi tidak ditemukan.",
"hc.declarationNotFound2": "Deklarasi tidak ditemukan",
"hc.declarationTracking": "Pelacakan deklarasi",
"hc.defaultCarrier": "Pengangkut default",
"hc.defaultCarrierPreselected": "Pengangkut default sudah dipilih — dapat diubah untuk pengiriman ini. Tarif aktual (Sendcloud + {m}% margin).",
"hc.defaultCarrierRemoved": "Pengangkut default dihapus",
"hc.delayHours": "Penundaan (jam)",
"hc.deleteMyAccount": "Hapus akun saya",
"hc.deleting": "Menghapus…",
"hc.deletingDeactivatesYourAccountLogin": "Penghapusan menonaktifkan login akun Anda: login diblokir dan data disimpan selama 30 hari. Anda akan menerima email dengan tautan reaktivasi yang berlaku selama 30 hari.",
"hc.delivered": "Dikirim",
"hc.depositAnItem": "Deposit suatu item",
"hc.depositCancelledItemPutBack": "Deposit dibatalkan — item dikembalikan ke stok.",
"hc.depositCancelledItemRemovedFrom": "Deposit dibatalkan — item dihapus dari registry.",
"hc.depositedOn": "Didepositkan pada",
"hc.describeTheItemBrandColor": "Deskripsikan item: merek, warna, tanda khas… (Semakin banyak detail yang Anda berikan, semakin besar peluang Anda untuk menemukan item Anda)",
"hc.dimensionsCm": "Dimensi (cm)",
"hc.disablingAnEmail": "Menonaktifkan email",
"hc.doesNotHide": "tidak menyembunyikan",
"hc.download": "Unduh",
"hc.downloadThePdf": "Unduh PDF",
"hc.draftRestoredPickUpYour": "Draf dipulihkan — ambil deklarasi Anda di tempat Anda meninggalkan.",
"hc.dragToReposition": "Seret untuk memindahkan",
"hc.eGColisPriv": "Mis. Colis Privé",
"hc.eachItemGetsAQr": "Setiap item mendapatkan label QR. Pindai dari \"Penyimpanan & QR\" untuk menemukan item dalam sekejap.",
"hc.eachSiteManagesItsOwn": "Setiap situs mengelola banknya sendiri. Pergi ke",
"hc.edit": "Edit",
"hc.emailNotificationPreferences": "Preferensi notifikasi email",
"hc.emailPreferencesUpdated": "Preferensi email diperbarui",
"hc.enableOrDisableRecoveryFees": "Aktifkan atau nonaktifkan biaya pemulihan untuk",
"hc.enlargePhoto": "Perbesar foto",
"hc.enterTheCustomerSCode": "Masukkan kode pelanggan",
"hc.estShipRate": "Perkiraan tarif pengiriman (Sendcloud + {m}% margin):",
"hc.establishment": "Pendiri",
"hc.establishment2": "Pendiri:",
"hc.establishmentInItsSendcloudAccount": "pendiri dalam akun Sendcloud-nya dan memberi Anda ID pengirim",
"hc.establishmentSettings": "Pengaturan pendiri",
"hc.exCode": "mis. ABCD2345",
"hc.exId": "mis. 3f2a…",
"hc.exit": "Keluar",
"hc.explainWhyThisItemIs": "Jelaskan mengapa item ini bukan milik Anda…",
"hc.externalPaymentLinks": "Tautan pembayaran eksternal",
"hc.failed": "Gagal",
"hc.feesEnabled": "Biaya diaktifkan",
"hc.field": ") kolom.",
"hc.finderAcceptedCloseTheCase": "Finder diterima — tutup kasus setelah item diserahkan secara langsung.",
"hc.findoCityRanking": "Findloop — Peringkat kota",
"hc.findoForEstablishments": "Findloop untuk pendiri",
"hc.findoPresentationVideo": "video presentasi Findloop",
"hc.findoRegistersTheAddressOf": "Findloop mendaftarkan alamat dari",
"hc.findoReviewShare": "ulasan Findloop {year}: {n} item dikembalikan, tingkat pengembalian {rate}% 🎉",
"hc.firstVerifyTheClaimCode": "Pertama verifikasi kode klaim di atas",
"hc.forEveryNewShipmentFrom": "untuk setiap pengiriman baru dari",
"hc.free": "gratis",
"hc.freeRecovery0": "Pemulihan gratis (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Pemulihan gratis di seluruh Afrika – Penawaran peluncuran",
"hc.freeRecoveryFeesDisabled0": "Pemulihan gratis: biaya dinonaktifkan (0 €)",
"hc.fromTeamInviteYourColleagues": "Dari \"Tim\", undang rekan kerja Anda melalui email dan tetapkan mereka sebagai pendiri. Setiap anggota hanya melihat lingkup mereka sendiri.",
"hc.fullName": "Nama lengkap",
"hc.fullPhoto": "Foto lengkap",
"hc.gallery": "Galeri",
"hc.giveTheReasonForCancelling": "Berikan alasan untuk membatalkan. Mitra akan diberi tahu.",
"hc.goToLogin": "Masuk",
"hc.goToMyAccount": "Pergi ke akun saya",
"hc.gold": "Emas",
"hc.googleLoginFailed": "Masuk Google gagal",
"hc.hasConfirmedYourPaymentYou": "telah mengonfirmasi pembayaran Anda, Anda akan dialihkan secara otomatis",
"hc.helpCenter": "Pusat bantuan",
"hc.helpUsImproveWhyAre": "Bantu kami meningkatkan: mengapa Anda meninggalkan? Akun Anda akan dinonaktifkan dan dapat diaktifkan ulang dalam 30 hari.",
"hc.hidePassword": "Sembunyikan kata sandi",
"hc.high": "Tinggi",
"hc.historyOfYourMonthlySubscriptions": "Riwayat langganan bulanan Anda dan status pembayarannya.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Bagaimana cara mengatur ID Pengirim numerik saya?",
"hc.iDonTUseIt": "Saya tidak menggunakannya cukup",
"hc.iFoundItElsewhere": "Saya menemukannya di tempat lain",
"hc.iNoLongerNeedMy": "Saya tidak lagi memerlukan barang saya",
"hc.identityVerification": "Verifikasi identitas",
"hc.idleLogoutIn": "Anda akan keluar dalam {n} detik karena tidak aktif.",
"hc.ifProvidedTheVolumetricWeight": "Jika disediakan, berat volumetrik digunakan.",
"hc.ifThePartnerHasNot": "Jika mitra belum mengonfirmasi penerimaan pembayaran eksternal setelah penundaan ini, Findloop secara otomatis mengingatkan mitra untuk memvalidasinya.",
"hc.impersonationEnded": "Peniruan selesai.",
"hc.impersonationMode": "Mode peniruan",
"hc.impersonationSessionExpired": "Sesi peniruan telah kedaluwarsa.",
"hc.inTheField": ", di lapangan",
"hc.inTransit": "Dalam perjalanan",
"hc.inclVat": "termasuk PPN",
"hc.intraEuVatNumberOptional": "Nomor PPN intra-EU opsional, tidak diperlukan SIRET (di luar Prancis).",
"hc.invalidInvitationLink": "Tautan undangan tidak valid.",
"hc.invalidInvitationLink2": "Tautan undangan tidak valid",
"hc.invalidInviteLink": "Tautan undangan tidak valid atau telah kedaluwarsa.",
"hc.invalidNumberEnterAnInternational": "Nomor tidak valid. Masukkan nomor internasional, mis. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Tautan tidak valid atau telah kedaluwarsa.",
"hc.invalidOrExpiredReactivationLink": "Tautan reaktivasi tidak valid atau telah kedaluwarsa",
"hc.invalidSendcloudId": "ID Sendcloud tidak valid",
"hc.inviteSubtitle": "{org} mengundang Anda untuk bergabung dengan tim Findloop mereka. Pilih kata sandi Anda untuk mengaktifkan akun Anda.",
"hc.isAvailableOnSendcloudFor": "tersedia di Sendcloud untuk semua rute Anda (domestik + internasional).",
"hc.isNotEnabledOnYour": "tidak diaktifkan di akun Sendcloud Anda untuk beberapa tujuan. Label untuk tujuan tersebut akan dihasilkan dengan pengantar lain yang tersedia.",
"hc.isThisReallyYourItem": "Apakah ini benar-benar barang Anda?",
"hc.isThisYourItem": "Apakah ini barang Anda?",
"hc.item": "Barang",
"hc.itemAlreadyConfirmed": "Barang sudah dikonfirmasi",
"hc.itemDetails": "Detail barang",
"hc.itemFoundAt": "Barang ditemukan di",
"hc.itemFoundAtAPartner": "Barang ditemukan di mitra",
"hc.itemMarkedAsReturned": "Barang ditandai sebagai dikembalikan ✓",
"hc.itemPhotoRequiredBeforeShipping": "Foto barang (diperlukan sebelum pengiriman)",
"hc.itemPhotoSaved": "Foto barang disimpan",
"hc.itemPreview": "Pratampilan barang",
"hc.itemPutBackInStorage": "Barang dikembalikan ke penyimpanan.",
"hc.itemWeight": "Berat barang:",
"hc.itemsReturned": "barang yang dikembalikan",
"pcat.stadium_arena": "Stadion / Arena",
"pcat.supermarket": "Supermarket",
"pcat.taxi_vtc": "Taksi / Ride-hailing",
"pcat.tourism_office": "Kantor Pariwisata",
"pcat.train_bus_station": "Stasiun Kereta / Bus",
"pcat.travel_agency": "Agen Perjalanan",
"hc.and": "dan",
"hc.demoObj0": "dompet",
"hc.demoObj1": "tas olahraga",
"hc.demoObj2": "telepon",
"hc.demoObj3": "sepasang kacamata",
"hc.demoObj4": "seperangkat kunci",
"hc.demoObj5": "syal",
"hc.demoObj6": "laptop",
"hc.demoObj7": "botol air",
"hc.demoWhen0": "2 jam yang lalu",
"hc.demoWhen1": "5 jam yang lalu",
"hc.demoWhen2": "kemarin",
"hc.demoWhen3": "3 jam yang lalu",
"hc.demoWhen4": "pagi ini",
"hc.demoWhen5": "1 hari yang lalu",
"hc.feedDemo": "{obj} dikembalikan di {city} {when}.",
"hc.feedReal": "Sebua item ({cat}) dikembalikan di {city}.",
"hc.saveBtn": "Simpan",
"hc.saveLink": "Simpan tautan",
"hc.terms": "Syarat",
"hc.view": "Lihat",
"pcat.airline": "Maskapai",
"pcat.airport": "Bandara",
"pcat.amusement_park": "Taman hiburan",
"pcat.bank": "Bank",
"pcat.bar_cafe": "Bar / Kafe",
"pcat.beauty_salon": "Salon Rambut / Kecantikan",
"pcat.cinema": "Bioskop",
"pcat.concert_theater": "Gedung konser / Teater",
"pcat.coworking": "Ruang kerja bersama",
"pcat.gym_fitness": "Gym / Kebugaran",
"pcat.hospital_clinic": "Rumah sakit / Klinik",
"pcat.library": "Perpustakaan",
"pcat.mall": "Pusat perbelanjaan",
"pcat.museum": "Museum",
"pcat.pharmacy": "Apotek",
"pcat.private_company": "Perusahaan swasta",
"pcat.public_transport": "Transportasi umum",
"pcat.school_university": "Sekolah / Universitas",
"pcat.sports_center": "Pusat olahraga",
"an.found": "Ditemukan",
"an.lost": "Hilang",
"hc.shareReview": "Bagikan ulasan",
"hc.citiesAboveTarget": "{n} kota di atas target mereka",
"hc.cityAboveTarget": "{n} kota di atas targetnya",
"hc.j15EarlyReminder": "Pengingat awal D-15",
"hc.j7EarlyReminder": "Pengingat awal D-7",
"hc.annualTotal": "Total tahunan",
"hc.billedOnceYear": "Dikenakan biaya sekali untuk 12 bulan, diperbarui setiap tahun.",
"hc.monthlyPrice": "Harga bulanan",
"hc.perMonth": "/ bulan",
"hc.perYear": "/ tahun",
"hc.billedEachMonth": "Dikenakan secara otomatis setiap bulan.",
"nav.business": "Bisnis",
"nav.individual": "Individu",
"hc.circumstancesFound": "Kondisi penemuan",
"hc.circumstancesFoundPh": "Misalnya ditemukan di tanah dekat pintu masuk metro",
"hc.circumstancesLost": "Kondisi kehilangan",
"hc.circumstancesLostPh": "Misalnya ditinggalkan di bangku saat menunggu bus",
"hc.conditionPh": "Misalnya baik, tergores…",
"hc.firstName": "Nama depan",
"hc.lastName": "Nama belakang",
"hc.quantity": "Jumlah barang",
"fa.approve": "Setujui",
"fa.approveConfirm": "Setujui deklarasi ini? Detail kontak lengkap Anda (nama, email, telepon) akan ditukarkan dengan penemu.",
"fa.approved": "Deklarasi disetujui — detail kontak ditukarkan",
"fa.approvedFinder": "Pemilik telah menyetujui deklarasi Anda",
"fa.approvedFinderText": "Hubungi mereka untuk mengatur pengembalian.",
"fa.boostSub": "Iklan Anda tetap di atas selama durasi yang dipilih.",
"fa.boostTitle": "Tingkatkan iklan saya (opsional)",
"fa.colFinder": "Deklarasi penemu",
"fa.colYours": "Deklarasi Anda",
"fa.compareHint": "Bandingkan deklarasi penemu dengan milik Anda sebelum memutuskan.",
"fa.contribNone": "Tidak ada kontribusi",
"fa.contribPaid": "Kontribusi diterima — terima kasih!",
"fa.contribPending": "Kontribusi menunggu pembayaran",
"fa.contribSub": "Dukung Findloop untuk membantu lebih banyak orang mendapatkan barang mereka kembali. Anda dapat memilih €0.",
"fa.contribSuccessMsg": "Deklarasi Anda telah dikirim ke pemilik.",
"fa.contribSuccessTitle": "Terima kasih atas kontribusi Anda",
"fa.contribTitle": "Kontribusi sukarela",
"fa.days3": "3 hari",
"fa.days30": "30 hari",
"fa.days7": "7 hari",
"fa.declSub": "Jelaskan barang yang Anda temukan. Pemilik akan membandingkan deklarasi Anda dengan milik mereka.",
"fa.declTitle": "Saya menemukan barang ini",
"fa.expiresOn": "Kedaluwarsa pada",
"fa.fBrand": "Merek",
"fa.fCircumstances": "Keadaan",
"fa.fCity": "Kota",
"fa.fColor": "Warna",
"fa.fCondition": "Kondisi",
"fa.fDate": "Tanggal",
"fa.fMessage": "Pesan penemu",
"fa.fPlace": "Tempat",
"fa.fQuantity": "Kuantitas",
"fa.finderContact": "Detail kontak penemu",
"fa.finishPay": "Selesaikan pembayaran",
"fa.foundDate": "Tanggal ditemukan",
"fa.foundPlace": "Tempat ditemukan",
"fa.hours24": "24 jam",
"fa.ht": "excl. PPN",
"fa.months3": "3 bulan",
"fa.noBoost": "Tidak ada peningkatan",
"fa.ownerContact": "Detail kontak pemilik",
"fa.payPublish": "Bayar dan terbitkan",
"fa.pendingPayText": "Iklan Anda akan ditayangkan setelah pembayaran dikonfirmasi.",
"fa.pendingPayTitle": "Pembayaran tertunda",
"fa.planSub": "Iklan Anda tayang setelah pembayaran dikonfirmasi.",
"fa.planTitle": "Durasi iklan",
"fa.pubSuccessMsg": "Iklan Anda sudah tayang. Anda akan diberitahu segera setelah ada penemu yang mengajukan.",
"fa.pubSuccessTitle": "Iklan diterbitkan",
"fa.publicNote": "Hanya deskripsi, kota, negara, dan foto yang ditampilkan secara publik.",
"fa.redirectStripe": "Mengalihkan ke pembayaran yang aman...",
"fa.reject": "Tolak",
"fa.rejectConfirm": "Tolak deklarasi ini? Iklan Anda tetap online.",
"fa.rejected": "Deklarasi ditolak",
"fa.rejectedFinder": "Itu bukan barang yang mereka cari",
"fa.rejectedFinderText": "Pemilik mengatakan barang ini bukan miliknya. Terima kasih atas bantuan Anda!",
"fa.responsesTitle": "Deklarasi penemu",
"fa.sent": "Deklarasi telah dikirim ke pemilik.",
"fa.submitDecl": "Kirim deklarasi saya",
"fa.submitDeclPay": "Kirim dan kontribusi {amount}",
"fa.total": "Total yang harus dibayar",
"fa.ttc": "termasuk PPN",
"fa.waitClaimText": "Penemu sedang meninjau permintaan Anda. Anda akan diberitahu tentang keputusan mereka.",
"fa.waitFinderText": "Kami akan memberi tahu Anda segera setelah penemu mengajukan deklarasi.",
"fa.waitFinderTitle": "Iklan Anda sudah tayang",
"fa.waitOwnerText": "Pemilik sedang membandingkan deklarasi Anda dengan miliknya. Anda akan diberitahu tentang keputusan mereka.",
"fa.waitOwnerTitle": "Menunggu keputusan pemilik",
"st.pending_payment": "Pembayaran tertunda",
"fa.africaFree": "Iklan gratis di Afrika — tawaran peluncuran Findloop, nikmati!",
"fa.africaPublished": "Iklan dipublikasikan secara gratis — tawaran peluncuran Afrika!",
"fa.approveClaimConfirm": "Setujui klaim ini? Pemilik kemudian akan dapat membuka rincian kontak Anda.",
"fa.checkInfo": "Periksa rincian Anda sebelum mengirim: mereka akan dibandingkan dengan milik pencari.",
"fa.claimApprovedShort": "Pencari menyetujui klaim Anda",
"fa.claimRejectedShort": "Klaim ditolak oleh pencari",
"fa.claimRejectedText": "Pencari percaya bahwa barang ini bukan milik Anda.",
"fa.claimSub": "Deskripsikan barang Anda dan tambahkan 2 foto. Pencari akan membandingkannya dengan iklan mereka.",
"fa.claimTitle": "Ini adalah barang saya",
"fa.claimUnlockText": "Buka rincian kontak pencari untuk mengatur pengembalian.",
"fa.claimUnlockedShort": "Rincian kontak dibuka — lihat pelacakan",
"fa.claimsTitle": "Klaim pemilik",
"fa.colOwner": "Pernyataan pemilik",
"fa.colYourAd": "Iklan Anda",
"fa.expired": "Iklan kedaluwarsa",
"fa.free": "Gratis",
"fa.lostDate": "Tanggal hilang",
"fa.lostPlace": "Tempat hilang",
"fa.noReceipt": "Tidak ada tanda terima tersedia untuk iklan ini.",
"fa.planSubFree": "Pilih durasi: iklan Anda aktif segera, tanpa pembayaran.",
"fa.prefillPrevious": "Gunakan kembali rincian iklan saya sebelumnya di kategori ini",
"fa.receipt": "Tanda terima PDF",
"fa.renewBtn": "Perbarui",
"fa.renewDiscountBanner": "Diskon 50%: perbarui sebelum iklan Anda kedaluwarsa!",
"fa.renewDiscountHint": "Diskon 50% diterapkan karena Anda memperbarui sebelum kedaluwarsa.",
"fa.renewEarly": "Perbarui (−50%)",
"fa.renewTitle": "Perbarui iklan saya",
"fa.renewed": "Iklan diperbarui",
"fa.sendClaim": "Kirim klaim saya",
"fa.twoPhotos": "2 foto barang Anda",
"fa.twoPhotosError": "Tambahkan 2 foto barang Anda.",
"fa.twoPhotosHint": "Foto pribadi yang membuktikan barang itu milik Anda (dengan barang, faktur, kotak…).",
"fa.unlockBtn": "Buka rincian kontak",
"fa.unlockFree": "Buka gratis — tawaran peluncuran",
"fa.waitClaimantText": "Kami akan memberi tahu Anda segera setelah seorang pemilik mengklaim barang ini.",
"fa.waitFinderDecision": "Menunggu keputusan pencari",
"fa.waitUnlockText": "Anda akan diberitahu segera setelah rincian kontak dipertukarkan.",
"fa.waitUnlockTitle": "Menunggu pemilik untuk membuka",
"fa.cancel": "Batal",
"fa.categoryRequired": "Pilih kategori untuk item yang ditemukan.",
"fa.confirmTitle": "Konfirmasi keputusan Anda",
"fa.goBack": "Kembali",
"dr.continue": "Lanjutkan deklarasi saya",
"dr.delete": "Hapus selamanya",
"dr.deleteConfirm": "Hapus draf ini selamanya? Ini tidak dapat dibatalkan.",
"dr.deleted": "Draf telah dihapus",
"dr.expiresIn": "Draf disimpan selama {h} jam lagi",
"dr.title": "Anda memiliki deklarasi yang belum selesai",
"form.step": "Langkah",
"form.next": "Lanjut",
"form.back": "Kembali",
"form.stepDetails": "Laporan Anda",
"form.stepPublish": "Durasi, dorongan & pembayaran",
"form.stepThanks": "Terima kasih & kontribusi",
"fthx.badge": "Laporan hampir selesai",
"fthx.title": "Terima kasih, Anda membuat perbedaan!",
"fthx.text": "Berkat Anda, seseorang mungkin segera mendapatkan kembali sesuatu yang berharga bagi mereka. Tindakan kebaikan seperti milik Anda adalah apa yang menjaga Findloop tetap hidup.",
"fthx.impact1": "1 item dilaporkan",
"fthx.impact2": "1 kesempatan lagi untuk reuni",
"fthx.tipTitle": "Sedikit dukungan untuk Findloop?",
"fthx.tipText": "Kontribusi Anda membantu kami menjaga layanan tetap terjangkau dan menyatukan semakin banyak barang dengan pemiliknya.",
"fthx.optional": "100% opsional — Anda dapat mempublikasikan tanpa berkontribusi.",
"fthx.thanksTip": "Terima kasih banyak atas kemurahan hati Anda!",
"fthx.suggest": "Jumlah yang disarankan",
"fthx.none": "Tidak ada tip",
"pay.pendingTitle": "Pembayaran belum selesai",
"pay.pendingText": "Detail Anda telah disimpan. Lanjutkan pembayaran dari tempat Anda berhenti.",
"pay.resume": "Lanjutkan pembayaran",
"pay.expiredTitle": "Sesi pembayaran kedaluwarsa",
"pay.expiredText": "Untuk keamanan Anda, sesi pembayaran telah kedaluwarsa. Detail Anda telah disimpan: mulai ulang pembayaran dengan satu klik.",
"pay.relaunch": "Mulai ulang pembayaran",
"sub.received": "Dikirim!",
"sub.publishing": "Kami sedang menyelesaikannya…",
"sub.toPayment": "Pengalihan ke pembayaran aman…",
"fa.claimSubV2": "Deskripsikan barang yang hilang. Orang yang menemukannya akan membandingkan deklarasi Anda dengan daftar mereka.",
"fa.photosOptional": "Foto barang Anda (opsional)",
"fa.compareOwnerHint": "Bandingkan informasi ini dengan barang yang Anda temukan, lalu katakan apakah itu barang yang sama.",
"fa.itsThisItem": "Ya, ini adalah barangnya",
"fa.notThisItem": "Tidak, ini bukan barangnya",
"fa.confirmIsItem": "Konfirmasi bahwa ini adalah barangnya? Detail kontak Anda dan pemilik akan ditunjukkan di akun masing-masing.",
"fa.confirmNotItem": "Konfirmasi bahwa ini bukan barangnya? Laporan Anda akan ditutup.",
"fa.youConfirmed": "Anda mengonfirmasi ini adalah barang pemilik",
"fa.youDeclined": "Anda menyatakan ini bukan barangnya",
"fa.youDeclinedText": "Terima kasih atas bantuan Anda! Pemilik sudah diberitahu.",
"fa.waitFinderDecisionOwner": "Menunggu keputusan penemu",
"fa.finderConfirmed": "Dikonfirmasi",
"fa.notYourItem": "Ini bukan barang Anda",
"fa.reportedOn": "Dilaporkan pada",
"fa.ownerWaitHint": "Seorang penemu sedang memeriksa informasi, silakan tunggu.",
"fa.claimSentFinder": "Klaim telah dikirim ke orang yang menemukan barang tersebut.",
"fa.compareClaimHint": "Bandingkan pernyataan pemilik dengan daftar Anda sebelum memutuskan.",
"fa.closeFollowup": "Tutup tindak lanjut ini",
"fa.closeFollowupConfirm": "Tutup tindak lanjut ini? Email dan nomor telepon kedua belah pihak akan dihapus secara permanen setelah pemilik juga menutup daftar mereka.",
"fa.safetyTitle": "Tips keselamatan sebelum penyerahan",
"fa.safety1": "Tanyakan kepada pemilik untuk deskripsi rinci tentang fitur tersembunyi dari barang tersebut: goresan tertentu, isi pasti dari tas, wallpaper, nomor seri…",
"fa.safety2": "Jika memungkinkan, minta bukti visual (foto barang) atau bukti pembelian.",
"fa.safety3": "Serahkan barang di tempat umum atau di mitra Findloop, dan periksa ID pemilik.",
"fa.safetyOk": "Mengerti, lanjutkan",
"fa.ownerClosedNote": "Pemilik telah menutup daftar mereka.",
"fa.finderClosedNote": "Penemu telah menutup tindak lanjut mereka.",
"fa.followupClosed": "Tindak lanjut ditutup",
"fa.followupClosedText": "Anda telah menutup tindak lanjut ini. Terima kasih atas bantuan Anda!",
"fa.photoReviewTitle": "Seorang pencari mengirimkan foto. Apakah ini terlihat seperti barang Anda?",
"fa.photoLooksLike": "Ya, ini terlihat seperti barang saya",
"fa.photoNotMine": "Tidak, ini bukan barang saya",
"fa.photoNotMineConfirm": "Tindak lanjut akan ditutup di kedua sisi dan daftar Anda akan tetap terbuka untuk pencari baru.",
"fa.photoLooksLikeDone": "Terima kasih! Pencari sekarang akan membandingkan pernyataan Anda.",
"fa.photoNotMineDone": "Laporan dibatalkan. Daftar Anda tetap terbuka.",
"fa.ownerPhotoHint": "Hanya foto pencari yang ditampilkan kepada Anda. Beritahu kami apakah ini terlihat seperti barang Anda.",
"fa.ownerReviewingPhoto": "Pemilik sedang meninjau foto Anda",
"fa.ownerReviewingPhotoText": "Anda akan diberi tahu segera setelah mereka menjawab. Anda kemudian dapat membandingkan pernyataan mereka.",
"fa.ownerRejectedPhoto": "Ini bukan barang pemilik",
"fa.ownerRejectedPhotoText": "Pemilik mengatakan foto Anda tidak cocok dengan barang mereka. Tindak lanjut ditutup. Terima kasih atas bantuan Anda!",
"fa.contribute": "Berkontribusi",
"fa.phoneMissing": "Tidak disediakan",
"fa.ownerSafety1": "Sebaiknya bertemu di tempat umum atau di lokasi mitra Findloop. Jika jaraknya jauh, disarankan untuk mengirimkannya melalui pos.",
"fa.ownerSafety2": "Saat serah terima, periksa ID penemu.",
"pub.changePhoto": "Ubah foto",
"ph.secured": "Foto aman",
"ph.securing": "Mengamankan foto…",
"fa.ownerSafety3": "Jika foto penemu memiliki watermark Findloop, jangan terima pertemuan. Foto harus merupakan gambar asli yang diambil oleh penemu, tanpa watermark."
},
"th": {
"a.back": "กลับ",
"a.category": "หมวดหมู่",
"a.categoryPlaceholder": "เลือกหมวดหมู่",
"a.city": "เมือง",
"a.confirmPassword": "ยืนยันรหัสผ่าน",
"a.country": "ประเทศ",
"a.createAccount": "สร้างบัญชี",
"a.createBtn": "สร้างบัญชีของฉัน",
"a.creating": "กำลังสร้าง…",
"a.email": "อีเมล",
"a.emailPro": "อีเมลธุรกิจ",
"a.forgot": "ลืม?",
"a.forgotSent": "หากมีบัญชีอยู่ ลิงก์รีเซ็ตได้ถูกส่งไปแล้ว.",
"a.forgotSub": "ขอลิงก์รีเซ็ตทางอีเมล.",
"a.forgotTitle": "ลืมรหัสผ่าน",
"a.googleContinue": "ดำเนินการต่อด้วย Google",
"a.googleSignup": "สมัครด้วย Google",
"a.haveAccount": "เป็นพันธมิตรอยู่แล้ว?",
"a.legalHint": "จำเป็นสำหรับการออกใบแจ้งหนี้อิเล็กทรอนิกส์ (Factur-X) ของสถานประกอบการในฝรั่งเศส.",
"a.legalRequiredFR": "หมายเลข SIRET และหมายเลข VAT สหภาพยุโรปเป็นสิ่งที่จำเป็นสำหรับฝรั่งเศส.",
"a.loggingIn": "กำลังเข้าสู่ระบบ…",
"a.login": "เข้าสู่ระบบ",
"a.loginSub": "เข้าถึงพื้นที่การจัดการของคุณ.",
"a.loginTitle": "เข้าสู่ระบบพันธมิตร",
"a.min6": "ขั้นต่ำ 6 ตัวอักษร",
"a.newPassword": "รหัสผ่านใหม่",
"a.noAccount": "ยังไม่เป็นพันธมิตร?",
"a.or": "หรือ",
"a.org": "ชื่อสถานประกอบการ",
"a.password": "รหัสผ่าน",
"a.passwordMismatch": "รหัสผ่านไม่ตรงกัน.",
"a.referral": "รหัสแนะนำ (ไม่จำเป็น)",
"a.registerSub": "สร้างพื้นที่ของคุณใน 1 นาที — เริ่มต้นฟรี.",
"a.registerTitle": "เป็นพันธมิตร",
"a.rememberMe": "จำฉันไว้",
"a.reset": "รีเซ็ต",
"a.resetSub": "เลือกกรุณารหัสผ่านใหม่สำหรับบัญชีของคุณ.",
"a.resetTitle": "รหัสผ่านใหม่",
"a.sendLink": "ส่งลิงก์",
"a.sending": "กำลังส่ง…",
"a.signin": "เข้าสู่ระบบ",
"a.siret": "SIRET",
"a.vat": "หมายเลข VAT สหภาพยุโรป.",
"ac.africa": "แอฟริกา",
"ac.boostActive": "เน้นที่ใช้งานอยู่ —",
"ac.boostSub": "ปรากฏที่ด้านบนของไดเรกทอรีพันธมิตรด้วยตรา “เพิ่มขึ้น”.",
"ac.boostTitle": "เพิ่มการแสดงรายชื่อของคุณในไดเรกทอรี",
"ac.categoryHint": "เพื่อจัดหมวดหมู่สถานประกอบการของคุณในไดเรกทอรี findloop.",
"ac.choose": "เลือก",
"ac.cityHint": "สำหรับการวางตำแหน่งที่แม่นยำบนแผนที่สาธารณะ.",
"ac.cityLabel": "เมืองของสถานประกอบการ",
"ac.cityPh": "ปารีส",
"ac.contact": "รายละเอียดการติดต่อ",
"ac.converted": "แปลงแล้ว",
"ac.copyDeclLink": "คัดลอกลิงก์ประกาศ",
"ac.copyLink": "คัดลอกลิงก์",
"ac.currentPlan": "แผนปัจจุบัน",
"ac.emailDesc": "เลือกอีเมลที่คุณต้องการรับ. การแจ้งเตือนในพื้นที่ทำงานของคุณจะยังคงเปิดอยู่.",
"ac.emailMatch": "ตรงกัน",
"ac.emailMatchDesc": "อีเมลเมื่อมีรายการตรงกับใบแจ้งหนี้",
"ac.emailNewDecl": "การประกาศการสูญเสียใหม่",
"ac.emailNewDeclDesc": "อีเมลเมื่อมีลูกค้าแจ้งการสูญเสียที่สถานที่ของคุณ",
"ac.emailShip": "คำขอการจัดส่ง",
"ac.emailShipDesc": "อีเมลเมื่อมีลูกค้าขอให้จัดส่งสินค้า",
"ac.emailTitle": "การตั้งค่าอีเมล",
"ac.expireSoon": "ไฮไลท์ของคุณจะหมดอายุในเร็ว ๆ นี้ —",
"ac.exportCsv": "ส่งออก (CSV)",
"ac.exportHint": "ส่งออกการชำระเงินภายนอกที่ได้รับการตรวจสอบสำหรับการบัญชีของคุณ.",
"ac.free": "ฟรี",
"ac.freeMonths": "เดือนฟรี",
"ac.hours": "ชั่วโมง",
"ac.howItWorks": "มันทำงานอย่างไร?",
"ac.invited": "ได้รับเชิญ",
"ac.legalFR": "ต้องใช้สำหรับการออกใบแจ้งหนี้อิเล็กทรอนิกส์ (Factur-X) ตั้งแต่เดือนกันยายน 2026.",
"ac.legalMissing": "⚠️ ข้อมูล SIRET และ VAT ในสหภาพยุโรปหายไป — กรุณากรอกข้อมูลเพื่อให้สอดคล้องกับการออกใบแจ้งหนี้อิเล็กทรอนิกส์.",
"ac.legalOther": "แนะนำสำหรับใบแจ้งหนี้ของคุณ.",
"ac.legalPartnerQr": "รหัส QR",
"ac.legalTitle": "รหัสทางกฎหมาย (การเรียกเก็บเงิน)",
"ac.logoTitle": "โลโก้สถานประกอบการ",
"ac.modeCurrent": "โหมดปัจจุบัน:",
"ac.modeExternal": "ภายนอก (การตรวจสอบด้วยตนเอง)",
"ac.modeInternal": "ภายใน Findloop (อัตโนมัติ)",
"ac.noSubReceipt": "ยังไม่มีการชำระเงินสมาชิกที่ชำระแล้ว.",
"ac.none": "ไม่มี",
"ac.onYourListing": "บนรายการของคุณ",
"ac.pay1": "กรอกลิงก์การชำระเงินของคุณด้านล่างเพื่อนำลูกค้าไปยังระบบการเก็บเงินของคุณเอง.",
"ac.pay2": "การตรวจสอบกลายเป็นการทำด้วยตนเอง: คุณยืนยันการรับเงินจากแท็บ “การประกาศ”.",
"ac.pay3": "ลิงก์ “ค่าจัดส่ง” เป็นการชำระเงินรวม (การกู้คืน + การจัดส่ง).",
"ac.pay4": "ปล่อยให้ฟิลด์ว่างเพื่อใช้การชำระเงินภายในของ Findloop (Stripe) พร้อมการตรวจสอบอัตโนมัติ.",
"ac.paySub": "เก็บค่าธรรมเนียมผ่านระบบการชำระเงินของคุณเอง.",
"ac.payTitle": "การชำระเงินภายนอก",
"ac.permissive": "อนุญาต",
"ac.phone": "โทรศัพท์",
"ac.posterA4": "โปสเตอร์ A4 (PDF)",
"ac.qMessage": "ข้อความ (ไม่บังคับ)",
"ac.qName": "ชื่อ",
"ac.qOrg": "องค์กร",
"ac.qSites": "จำนวนสถานประกอบการ (ประมาณการ)",
"ac.qrHint": "ลูกค้าของคุณสแกนรหัสนี้เพื่อลงทะเบียนสิ่งของที่สูญหาย.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "รหัส QR ของคู่ค้าของคุณ",
"ac.quoteDesc": "สนามบิน, เครือข่ายรถไฟ, เครือข่ายระหว่างประเทศ · ",
"ac.quoteEurope": "ยุโรป / โลก",
"ac.quoteSent": "ส่งคำขอใบเสนอราคาแล้ว ทีมงานของเราจะติดต่อคุณกลับในไม่ช้า.",
"ac.quoteTitle": "ขอใบเสนอราคา — ธุรกิจ",
"ac.recoveryLink": "ลิงก์ “ค่ากู้คืน”",
"ac.refSub": "แต่ละพันธมิตรที่แนะนำที่สมัครจะทำให้คุณได้รับฟรี 1 เดือน.",
"ac.refTitle": "แนะนำ, รับฟรี 1 เดือน",
"ac.reminderDelay": "ระยะเวลาเตือนการตรวจสอบ",
"ac.reminderHint": "คุณจะได้รับอีเมลเตือนหากการชำระเงินภายนอยด์ยังไม่ได้รับการตรวจสอบหลังจากระยะเวลานี้ (ค่าเริ่มต้น: 48 ชม.).",
"ac.renewDesc1": "มันได้ทำให้คุณมีรายได้แล้ว",
"ac.renewDesc2": "ต่ออายุเพื่ออยู่ในอันดับต้น ๆ ในไดเรกทอรีและไม่สูญเสียการมองเห็นนี้.",
"ac.renewNow": "ต่ออายุทันที",
"ac.requestQuote": "ขอใบเสนอราคา",
"ac.saveLegal": "บันทึกรหัสประจำตัว",
"ac.saveLinks": "บันทึกลิงก์",
"ac.sendRequest": "ส่งคำขอของฉัน",
"ac.sending": "กำลังส่ง…",
"ac.shippingLink": "ลิงก์ “ค่าจัดส่ง” (รวม)",
"ac.shippingLinkHint": "ลิงก์นี้รวมทั้งการกู้คืนและการจัดส่ง.",
"ac.strict": "เข้มงวด",
"ac.subReceipt": "ใบเสร็จสมาชิก (PDF)",
"ac.subReceiptsSub": "ดาวน์โหลดใบเสร็จ PDF สำหรับการชำระเงินสมาชิกแต่ละรายการ.",
"ac.subReceiptsTitle": "ใบเสร็จสมาชิก",
"ac.tCategory": "หมวดหมู่ที่บันทึก",
"ac.tCity": "เมืองที่บันทึก — แผนที่อัปเดต",
"ac.tCityNeeded": "กรอกชื่อเมือง",
"ac.tCopied": "คัดลอกแล้ว!",
"ac.tCover": "อัปเดตภาพปก",
"ac.tEmailPrefs": "การตั้งค่าอีเมลที่อัปเดต",
"ac.tErr": "ข้อผิดพลาด",
"ac.tExportImpossible": "ส่งออกล้มเหลว",
"ac.tLegal": "รหัสทางกฎหมายที่บันทึก",
"ac.tLegalNeeded": "ต้องการ SIRET และ VAT สำหรับฝรั่งเศส",
"ac.tLogo": "อัปเดตโลโก้",
"ac.tLogoRemoved": "ลบโลโก้แล้ว",
"ac.tPayLinks": "ลิงก์การชำระเงินที่บันทึก",
"ac.tPhone": "โทรศัพท์ที่บันทึก",
"ac.tSensitivity": "ความไวที่บันทึก",
"ac.tVatInvalid": "หมายเลข VAT ไม่ถูกต้อง",
"ac.tVatValid": "VAT ถูกต้อง",
"ac.tabBoost": "การมองเห็น",
"ac.tabPayments": "การชำระเงิน",
"ac.tabProfile": "โปรไฟล์",
"ac.tabQr": "QR & โปสเตอร์",
"ac.tabReferral": "การอ้างอิง",
"ac.tabSub": "การสมัครสมาชิก",
"ac.thisWeek": "สัปดาห์นี้",
"ac.thisWeekOf": " ({n} สัปดาห์นี้)",
"ac.thresholdDesc": "เกณฑ์ความมั่นใจที่ AI จะตรวจสอบการจับคู่ของภาพโดยอัตโนมัติและแจ้งเตือลูกค้า ยิ่งสูง = ยิ่งมีการจับคู่โดยอัตโนมัติน้อยลง แต่เชื่อถือได้มากขึ้น.",
"ac.thresholdTitle": "ความไวในการจับคู่ภาพของ AI",
"ac.trend": "แนวโน้ม",
"ac.upload": "อัปโหลด",
"ac.vatValidFmt": "VAT ถูกต้อง{name} ({via})",
"ac.vatVerified": "VAT ภายในสหภาพยุโรปได้รับการตรวจสอบ",
"ac.verifyVat": "ตรวจสอบ VAT (VIES)",
"ac.verifying": "กำลังตรวจสอบ…",
"ac.views": "มุมมอง",
"ac.viewsTotal": "มุมมองที่ได้รับ (รวม)",
"ac.winbackBtn": "กลับมาที่ -20%",
"ac.winbackDesc1": "มันทำให้คุณได้รับ",
"ac.winbackDesc2": "ข้อเสนอพิเศษ: -20% ใช้งานโดยอัตโนมัติหากคุณต่ออายุภายใน 24 ชั่วโมง.",
"ac.winbackTitle": "ไฮไลท์ของคุณเพิ่งหมดอายุ — กลับมาที่ -20%!",
"ad.boost": "เพิ่มการมองเห็น",
"ad.close": "ปิด",
"ad.closeConfirm": "ต้องการปิดรายการนี้ไหม?",
"ad.closed": "รายการปิด",
"ad.edit": "แก้ไข",
"ad.editTitle": "แก้ไขรายการ",
"ad.saved": "อัปเดตรายการแล้ว",
"an.allCountries": "ทุกประเทศ",
"an.badge": "รายการที่หาย",
"an.boostLater": "ภายหลัง",
"an.boostNow": "เพิ่มการมองเห็นเดี๋ยวนี้",
"an.boostPrompt": "เพิ่มการมองเห็นรายการของคุณเพื่อให้อยู่ด้านบนและค้นหาได้เร็วขึ้น.",
"an.boosted": "เพิ่มการมองเห็นแล้ว",
"an.contact": "ผมพบรายการนี้",
"an.contactTitle": "รายงานว่าคุณพบรายการนี้",
"an.copyFailed": "ไม่สามารถคัดลอกลิงก์ได้",
"an.copyLink": "คัดลอกลิงก์",
"an.country": "ประเทศ",
"an.date": "วันที่สูญหาย",
"an.finderEmail": "อีเมลของคุณ",
"an.finderName": "ชื่อของคุณ",
"an.finderPhone": "โทรศัพท์ของคุณ",
"an.geoBanner": "คุณกำลังดูประกาศใน",
"an.geoBannerWorld": "คุณกำลังดูประกาศทั่วโลก",
"an.geoChange": "เปลี่ยนประเทศ",
"an.goAccount": "ไปที่บัญชีของฉัน",
"an.linkCopied": "ลิงก์ถูกคัดลอก!",
"an.loginRequired": "เข้าสู่ระบบเพื่อลงรายงานรายการนี้และติดตามการคืน.",
"an.loginToBoost": "เข้าสู่ระบบเพื่อเพิ่มรายการนี้",
"an.lostAt": "สูญหายที่",
"an.message": "ข้อความ (เลือกได้)",
"an.none": "ยังไม่มีรายการ.",
"an.photo": "รูปถ่าย (เลือกได้)",
"an.post": "ลงประกาศ",
"an.postSubtitle": "อธิบายรายการที่สูญหายของคุณ — ช่วยโดยชุมชนและพันธมิตรของเราในการค้นหา.",
"an.postTitle": "รายงานรายการที่สูญหาย",
"an.publish": "เผยแพร่ประกาศ",
"an.published": "ประกาศเผยแพร่แล้ว!",
"an.publishing": "กำลังเผยแพร่…",
"an.remaining": "เหลือ",
"an.requestInProgress": "กำลังดำเนินการขอ",
"an.resolved": "รายการได้รับการฟื้นฟูแล้ว",
"an.reward": "รางวัล",
"an.searchPh": "ค้นหารายการ…",
"an.send": "ส่ง",
"an.sent": "ข้อความส่งไปยังเจ้าของแล้ว!",
"an.shareConsent": "ฉันยอมรับว่าข้อมูลการติดต่อของฉัน (ชื่อ, อีเมล, โทรศัพท์) อาจถูกแชร์กับเจ้าของรายการ.",
"an.shareConsentError": "กรุณาเลือกช่องเพื่อแชร์ข้อมูลการติดต่อของคุณ.",
"an.sortRecent": "ล่าสุด",
"an.sortRelevance": "ความเกี่ยวข้อง",
"an.subtitle": "เรียกดูรายการที่ถูกแจ้งว่าสูญหายโดยชุมชน. พบหนึ่งในนั้นไหม?",
"an.title": "ประกาศรายการสูญหาย",
"anf.badge": "รายการที่พบ",
"anf.claim": "นี่เป็นของฉัน",
"anf.claimSent": "ข้อความส่งไปยังผู้พบแล้ว!",
"anf.claimTitle": "รายงานว่านี่เป็นรายการของคุณ",
"anf.consent": "ฉันยอมรับว่าเจ้าของอาจเห็นข้อมูลการติดต่อของฉันเพื่อฟื้นฟูรายการของพวกเขา.",
"anf.foundAt": "พบที่",
"anf.foundDate": "วันที่พบ",
"anf.loginCta": "เข้าสู่ระบบ / สร้างบัญชี",
"anf.loginDesc": "บัญชีผู้พบจำเป็นต้องเผยแพร่ประกาศและรับคะแนน Finder Hero.",
"anf.loginRequired": "เข้าสู่ระบบเพื่อลงประกาศรายการที่พบ",
"anf.photo": "รูปภาพรายการ",
"anf.pointsEarned": "ขอบคุณ! คุณเพิ่งได้รับคะแนน Finder Hero.",
"anf.pointsPending": "คะแนนของคุณจะถูกเครดิตภายใน 24 ชั่วโมงหลังการตรวจสอบ.",
"anf.post": "ลงประกาศรายการที่พบ",
"anf.postSubtitle": "อธิบายรายการที่คุณพบ — ช่วยเจ้าของในการคืนกลับ.",
"anf.postTitle": "รายงานรายการที่พบ",
"anf.publishFound": "เผยแพร่ประกาศรายการที่พบ",
"anf.published": "ประกาศรายการที่พบเผยแพร่แล้ว",
"anf.publishedAs": "เผยแพร่เป็น",
"anf.shareConsent": "ฉันยอมรับว่าข้อมูลการติดต่อของฉัน (ชื่อ, อีเมล, โทรศัพท์) อาจถูกแชร์กับคนที่พบรายการ.",
"anf.subtitle": "เรียกดูรายการที่พบและถูกแจ้งโดยชุมชน. จำของคุณได้ไหม?",
"anf.title": "ประกาศรายการที่พบ",
"bo.active": "การเพิ่มกิจกรรม",
"bo.africaPrice": "การกำหนดราคาแบบเป็นพิเศษสำหรับโซนแอฟริกา",
"bo.pay": "จ่ายและเพิ่ม",
"bo.remaining": "เวลาที่เหลือ",
"bo.renew": "ต่ออายุการเพิ่ม",
"bo.since": "ตั้งแต่การเพิ่ม",
"bo.subtitle": "นำการลงประกาศของคุณไปยังยอดรายการด้วยป้ายที่มองเห็นได้.",
"bo.title": "เพิ่มการลงประกาศ",
"c.all": "ทั้งหมด",
"c.cancel": "ยกเลิก",
"c.close": "ปิด",
"c.confirm": "ยืนยัน",
"c.confirmed": "ได้รับการยืนยัน",
"c.download": "ดาวน์โหลด",
"c.loading": "กำลังโหลด…",
"c.reset": "รีเซ็ต",
"c.reviews": "รีวิว",
"c.save": "บันทึก",
"c.transfer": "โอน",
"cat.Animal": "สัตว์เลี้ยง / อุปกรณ์สัตว์เลี้ยง",
"cat.AppareilPhoto": "กล้อง",
"cat.Argent": "เงิน / เงินสด",
"cat.Autres": "อื่นๆ",
"cat.Bijoux": "เครื่องประดับ",
"cat.CarteBancaire": "บัตรธนาคาร",
"cat.CarteIdentite": "บัตรประชาชน / หนังสือเดินทาง",
"cat.Casquette": "หมวก",
"cat.Ceinture": "เข็มขัด",
"cat.Chargeur": "ที่ชาร์จ / สายเคเบิล",
"cat.Chaussures": "รองเท้า",
"cat.CleVoiture": "กุญแจรถ",
"cat.Cles": "กุญแจ",
"cat.Console": "คอนโซลเกม",
"cat.Documents": "เอกสาร / กระดาษ",
"cat.Echarpe": "ผ้าพันคอ",
"cat.Ecouteurs": "หูฟัง",
"cat.Electronique": "อุปกรณ์อิเล็กทรอนิกส์ (อื่นๆ)",
"cat.Enceinte": "ลำโพง",
"cat.Gants": "ถุงมือ",
"cat.Gourde": "ขวดน้ำ / แฟลสก์",
"cat.Instrument": "เครื่องดนตรี",
"cat.Jouet": "ของเล่น / ตุ๊กตา",
"cat.Jumelles": "กล้องส่องทางไกล",
"cat.Lampe": "โคมไฟ / ไฟฉาย",
"cat.Liseuse": "เครื่องอ่านอีบุ๊ก",
"cat.Livre": "หนังสือ / สมุดโน้ต",
"cat.Lunettes": "แว่นตา",
"cat.Manteau": "เสื้อโค้ต / แจ็กเก็ต",
"cat.Maquillage": "กระเป๋าเครื่องสำอาง",
"cat.Medical": "อุปกรณ์การแพทย์",
"cat.Medicaments": "ยา",
"cat.Montre": "นาฬิกา / สมาร์ทวอทช์",
"cat.Ordinateur": "แล็ปท็อป",
"cat.Parapluie": "ร่ม",
"cat.Portefeuille": "กระเป๋าสตางค์ / กระเป๋าถือ",
"cat.Poussette": "รถเข็นเด็ก / อุปกรณ์เด็ก",
"cat.Sac": "กระเป๋า / กระเป๋าถือ",
"cat.SacADos": "เป้สะพายหลัง",
"cat.Souris": "เมาส์ / คีย์บอร์ด",
"cat.Sport": "อุปกรณ์กีฬา",
"cat.Tablette": "แท็บเล็ต",
"cat.Telephone": "โทรศัพท์ / สมาร์ทโฟน",
"cat.Trottinette": "สกู๊ตเตอร์",
"cat.Trousse": "กระเป๋า / เคส",
"cat.USB": "แฟลชไดรฟ์ / ฮาร์ดไดรฟ์",
"cat.Valise": "กระเป๋าเดินทาง",
"cat.Velo": "จักรยาน",
"cat.Vetements": "เสื้อผ้า",
"cat.placeholder": "เลือกหมวดหมู่",
"cd.d": "วัน",
"cd.expired": "หมดอายุ",
"cd.h": "ชม.",
"cd.m": "น.",
"ck.accept": "ยอมรับ",
"ck.acceptAll": "ยอมรับทั้งหมด",
"ck.customize": "ปรับแต่ง",
"ck.learn": "เรียนรู้เพิ่มเติม",
"ck.manage": "จัดการคุกกี้",
"ck.measurement": "การวัดผู้ชม",
"ck.measurementDesc": "สถิติที่ไม่ระบุชื่อเพื่อปรับปรุงบริการ.",
"ck.msg": "เราใช้คุกกี้เพื่อให้เว็บไซต์ทำงานและวัดกลุ่มผู้ชม.",
"ck.necessary": "จำเป็น",
"ck.necessaryDesc": "สำคัญสำหรับการทำงานของเว็บไซต์ เปิดใช้งานตลอดเวลา.",
"ck.refuse": "ปฏิเสธ",
"ck.save": "บันทึกตัวเลือกของฉัน",
"ck.saved": "บันทึกการตั้งค่าแล้ว",
"ck.title": "การตั้งค่าคุกกี้ของคุณ",
"cm.found": "พบแล้ว",
"cm.lost": "หายไป",
"cmp.adv": "ขั้นสูง",
"cmp.ai": "การจับคู่ AI",
"cmp.autobill": "การเรียกเก็บเงินอัตโนมัติ",
"cmp.basic": "พื้นฐาน",
"cmp.community": "ชุมชน",
"cmp.consol": "การเรียกเก็บเงินรวม",
"cmp.custom": "กำหนดเอง",
"cmp.dedicated": "เฉพาะสำหรับ",
"cmp.deploy": "การปรับใช้เฉพาะและ SLA",
"cmp.estIncl": "สถานประกอบการที่รวมอยู่",
"cmp.estSec": "สถานประกอบการเพิ่มเติม",
"cmp.items": "รายการ / เดือน",
"cmp.main": "หลัก 1 รายการ",
"cmp.max20": "สูงสุด 20",
"cmp.members": "คำเชิญสมาชิก",
"cmp.onQuote": "เสนอราคาที่กำหนดเอง",
"cmp.priority": "ลำดับความสำคัญ",
"cmp.starterEst": "รวม 1 ที่ + เพิ่มเติมไม่จำกัด",
"cmp.stats": "สถิติ",
"cmp.statsAdv": "ขั้นสูง",
"cmp.statsBasic": "พื้นฐาน",
"cmp.support": "สนับสนุน",
"cmp.unlimited": "ไม่จำกัด",
"cmp.upTo3": "สูงสุด 3",
"consent.required": "คุณต้องยอมรับเพื่อแชร์ข้อมูลการติดต่อของคุณเพื่อดำเนินการต่อ.",
"consent.share": "ฉันยอมรับว่า ผู้ค้นหาสิ่งของของฉันสามารถเห็นข้อมูลการติดต่อของฉัน (ชื่อ, อีเมล, โทรศัพท์) เพื่อที่จะติดต่อฉันเพื่อคืนสิ่งของ.",
"cover.add": "เพิ่ม",
"cover.change": "เปลี่ยน",
"cover.helper": "แสดงเป็นแบนเนอร์บนหน้ารายงานของคุณและในไดเรกทอรี.",
"cover.none": "ไม่มีภาพปก",
"cover.remove": "ลบ",
"cover.title": "ภาพปก",
"crop.desc": "ปรับกรอบให้เข้ากับอัตราส่วนแบนเนอร์ (3:1). ลากและซูม.",
"crop.saving": "กำลังบันทึก…",
"crop.title": "ตัดรูปภาพหน้าปก",
"cta.button": "สร้างบัญชีพันธมิตรของฉัน",
"cta.subtitle": "เข้าร่วมกับสถานประกอบการที่ส่งคืนรายการได้เร็วขึ้นด้วย findloop.",
"cta.title": "พร้อมลดการสูญหายของรายการหรือยัง?",
"db.account.s": "จัดการสถานประกอบการ การสมัครสมาชิก และรหัส QR ของคุณ.",
"db.account.t": "บัญชีของฉัน",
"db.declarations.s": "ลูกค้าที่รายงานรายการสูญหายผ่านรหัส QR ของคุณ.",
"db.declarations.t": "รายงานการสูญหาย",
"db.deposit.s": "เพิ่มรูปภาพ หมวดหมู่ และคำบรรยาย.",
"db.deposit.t": "ลงบันทึกรายการที่ถูกพบ",
"db.registry.s": "รายการที่ถูกพบทั้งหมดที่ลงทะเบียนที่สถานประกอบการของคุณ.",
"db.registry.t": "ทะเบียนรายการ",
"db.reviews.s": "ตอบความคิดเห็นของลูกค้าแบบสาธารณะ.",
"db.reviews.t": "ความคิดเห็นจากลูกค้า",
"db.shipments.s": "สร้างป้ายและติดตามพัสดุที่ต้องส่ง.",
"db.shipments.t": "การจัดส่ง",
"db.stats.s": "ตัวชี้วัดประสิทธิภาพหลักของคุณ.",
"db.stats.t": "สถิติ",
"db.team.s": "เชิญเพื่อนร่วมงานของคุณมาจัดการรายการ.",
"db.team.t": "ทีม",
"dc.partnerDesc": "สูญหายที่สถานที่พันธมิตร (โรงแรม สถานี หอประชุม…)? เลือกเพื่อการส่งคืนโดยตรง.",
"dc.partnerList": "เลือกจากรายการ",
"dc.partnerMap": "เลือกบนแผนที่",
"dc.partnerTitle": "การประกาศที่พันธมิตร",
"dc.publicCta": "โพสต์โฆษณาสาธารณะ",
"dc.publicDesc": "โฆษณาของคุณจะแสดงให้ชุมชน Findloop ทั้งหมดเห็น เหมาะสำหรับผู้ที่ไม่รู้ว่าหายที่ไหน.",
"dc.publicTitle": "การประกาศสาธารณะ",
"dc.subtitle": "เลือกวิธีการรายงานรายการที่สูญหายของคุณ.",
"dc.title": "คุณต้องการทำอะไร?",
"dec.addrPending": "ที่อยู่รอการตอบกลับจากลูกค้า",
"dec.analyzing": "กำลังวิเคราะห์…",
"dec.badge": "รายงานการสูญหาย",
"dec.category": "หมวดหมู่รายการ",
"dec.clientDescription": "คำอธิบายจากลูกค้า",
"dec.clientPhoto": "รูปภาพที่ลูกค้าให้มา",
"dec.clientPhotoShort": "รูปภาพจากลูกค้า",
"dec.comparePhotos": "เปรียบเทียบรูปภาพ",
"dec.contactTitle": "รายละเอียดการติดต่อของคุณ",
"dec.date": "วันที่สูญหาย",
"dec.declaredItemPhoto": "รูปภาพของรายการที่ประกาศ",
"dec.descPh": "อธิบายรายการ: ยี่ห้อ สี มาร์คที่เด่นชัด…",
"dec.description": "คำบรรยาย",
"dec.email": "อีเมล",
"dec.emptyDesc": "แชร์รหัส QR ของคุณเพื่อรับการประกาศ.",
"dec.emptyTitle": "ไม่มีการประกาศ",
"dec.enlarge": "ขยาย",
"dec.extBanner": "{n} การชำระเงินภายนอกเพื่อการตรวจสอบ — ยืนยันการรับด้านล่างเพื่อปลดล็อคการมอบหรือการจัดส่ง.",
"dec.foundItemAlt": "รายการที่ถูกพบ",
"dec.foundItemRegistry": "รายการที่ถูกพบ (ทะเบียน)",
"dec.home": "กลับไปที่หน้าหลัก",
"dec.labelClient": "ลูกค้า",
"dec.labelRegistry": "ทะเบียน",
"dec.matchFound": "มีการจับคู่ที่ระบุแล้ว!",
"dec.name": "ชื่อเต็ม",
"dec.noMatchYet": "ยังไม่มีการจับคู่.",
"dec.noPhoto": "ไม่มีรูปภาพ",
"dec.notfound": "ไม่พบพันธมิตร.",
"dec.pRecup": "การกู้คืน",
"dec.pRecupP": "(การกู้คืน)",
"dec.pRecupShip": "(การกู้คืน + การจัดส่ง)",
"dec.payConfirmed": "การชำระเงิน {x} ยืนยันแล้ว",
"dec.payPending": "การชำระเงินภายนอก {x} รอดำเนินการ",
"dec.phone": "โทรศัพท์",
"dec.pickup": "รับของด้วยตัวเอง",
"dec.place": "สถานที่ที่สูญหาย",
"dec.placePh": "เช่น ที่บาร์, ห้อง 204…",
"dec.recoverBtn": "กู้คืนรายการของฉัน",
"dec.reject": "ปฏิเสธ",
"dec.rerun": "รันการวิเคราะห์อีกครั้ง",
"dec.similarity": "ความคล้ายคลึง {n}%",
"dec.submit": "ส่งรายงานของฉัน",
"dec.submitting": "กำลังส่ง…",
"dec.successText": "เรากำลังค้นหารายการของคุณในที่เก็บที่",
"dec.successTitle": "ส่งรายงานเรียบร้อย!",
"dec.suggestedMatches": "รายการที่แนะนำ",
"dec.toColon": " ถึง:",
"dec.toShip": "ที่จะจัดส่ง",
"dec.toastExtPay": "การชำระเงินยืนยันแล้ว — ลูกค้าจะได้รับการแจ้งเตือน.",
"dec.toastMatch": "การจับคู่ยืนยันแล้ว",
"dec.toastReject": "ข้อเสนอถูกปฏิเสธ",
"dec.toastRerun": "การวิเคราะห์เริ่มต้นใหม่",
"dec.toastVisualN": "{n} การจับคู่ภาพ",
"dec.toastVisualNone": "ไม่มีการจับคู่ภาพ",
"dec.trackBtn": "ติดตามรายงานของฉัน",
"dec.viewBeforeAfter": "มุมมองก่อน/หลัง (ซ้อนทับ)",
"dec.viewSideBySide": "มุมมองข้างเคียง",
"dec.visualCompare": "การเปรียบเทียบภาพ AI",
"dec.visualIdle": "รันการเปรียบเทียบเพื่อให้ AI จับคู่ภาพลูกค้ากับรายการที่พบ.",
"dec.visualRunning": "AI กำลังเปรียบเทียบภาพลูกค้ากับรายการในทะเบียนของคุณ…",
"dec.zoomPhoto": "ขยายภาพ",
"dep.addAnyway": "เพิ่มต่อไป",
"dep.addError": "เกิดข้อผิดพลาดขณะเพิ่ม",
"dep.addItem": "เพิ่มรายการ",
"dep.added": "รายการเพิ่มลงในทะเบียนแล้ว!",
"dep.adding": "กำลังเพิ่ม…",
"dep.aiError": "การวิเคราะห์ AI ใช้งานไม่ได้ในขณะนี้.",
"dep.aiFilled": "แบบฟอร์มกรอกล่วงหน้าโดย AI ✨",
"dep.aiUnavailable": "AI ใช้งานไม่ได้ — กรุณากรอกแบบฟอร์มด้วยตนเอง.",
"dep.analyzing": "กำลังวิเคราะห์…",
"dep.analyzingPhoto": "กำลังวิเคราะห์ภาพ…",
"dep.brand": "แบรนด์",
"dep.brandPlaceholder": "เช่น Apple",
"dep.category": "หมวดหมู่",
"dep.checkingDup": "กำลังตรวจสอบรายการซ้ำ…",
"dep.color": "สี",
"dep.colorPlaceholder": "เช่น สีดำ",
"dep.condition": "สถานะ",
"dep.conditionPlaceholder": "เช่น สภาพดี",
"dep.depositorNote": "หมายเหตุจากผู้ฝาก",
"dep.depositorNoteHint": "รายละเอียดการดำเนินการที่พิมพ์ด้วยมือ AI จะไม่เขียนทับหมายเขียนนี้.",
"dep.depositorNotePlaceholder": "เช่น เนื้อหาของกระเป๋า, แบรนด์ที่แจ้ง, รายละเอียดจากบุคคล…",
"dep.descPlaceholder": "เช่น iPhone 15 สีดำพร้อมเคสใส, พบที่บาร์…",
"dep.description": "คำอธิบาย",
"dep.dupHint": "โปรดตรวจสอบว่าไม่ได้เพิ่มรายการซ้ำ คุณสามารถดำเนินการต่อได้หากรายการนั้นแตกต่างจริงๆ.",
"dep.dupTitle": "รายการที่คล้ายกันถูกลงทะเบียนแล้ว",
"dep.dupWarn": "พบรายการคล้ายกัน — โปรดตรวจสอบ, แล้วคลิกอีกครั้งเพื่อยืนยัน.",
"dep.estHint": "รายการจะถูกเพิ่มในทะเบียนของสถานที่นี้.",
"dep.establishment": "สถานประกอบการ",
"dep.fee": "ค่าธรรมเนียมการกู้คืน (€) — ไม่บังคับ",
"dep.feePlaceholder": "ไม่ต้องกรอกเพื่อใช้ราคาปกติของหมวดหมู่",
"dep.fillAI": "เติมด้วย AI",
"dep.optional": "(ไม่บังคับ)",
"dep.photo": "รูปภาพสินค้า",
"dep.principal": "หลัก",
"dep.reqError": "ต้องระบุหมวดหมู่และคำบรรยาย.",
"dep.savedItem": "สินค้าที่ลงทะเบียน",
"dep.similarity": "ความคล้ายคลึง",
"dep.storage": "ตำแหน่งที่ตั้ง",
"dep.storageHint": "ที่เก็บสินค้าทางกายภาพ จะมี QR โค้ดที่สร้างขึ้นเพื่อค้นหา.",
"dep.storagePlaceholder": "เช่น ชั้น A3, ตู้เก็บของ 12, ตู้เซฟกลาง",
"dl.aClient": "ลูกค้า",
"dl.alertsBlocked": "การแจ้งเตือนของเบราว์เซอร์ถูกบล็อก",
"dl.alertsBlockedHint": "เพื่อเปิดใช้งานอีกครั้ง: คลิกที่ 🔒 (หรือ ⓘ) ทางซ้ายของที่อยู่เว็บไซต์ จากนั้นอนุญาตการแจ้งเตือนและโหลดหน้าใหม่.",
"dl.amountDue": "จำนวนเงินที่ต้องชำระ: {amount} {currency}.",
"dl.enableAlerts": "เปิดการแจ้งเตือน",
"dl.extPending": "การชำระเงินที่รอการตรวจสอบ",
"dl.freemiumNear": "คุณใกล้จะถึงขีดจำกัด Freemium ({used}/{max} รายการในเดือนนี้). อัปเกรดเป็น Starter เพื่อให้สามารถลงทะเบียนรายการได้ไม่จำกัด.",
"dl.freemiumReached": "ถึงขีดจำกัด Freemium แล้ว ({used}/{max} รายการในเดือนนี้). อัปเกรดเป็น Starter เพื่อให้สามารถลงทะเบียนรายการได้ไม่จำกัด.",
"dl.invoiceOverdue": "ใบแจ้งหนี้ {num} ที่ยังไม่ได้ชำระ — การเข้าถึงถูกจำกัด.",
"dl.matchNotifTitle": "Findloop — การจับคู่ AI ใหม่ 🔔",
"dl.matchToast": "การจับคู่ AI ใหม่ — {name}",
"dl.matchToastDesc": "รายการตรงกับการประกาศ.",
"dl.notifEmpty": "ยังไม่มีการแจ้งเตือน.",
"dl.notifEnabled": "การแจ้งเตือนของเบราว์เซอร์เปิดใช้งาน",
"dl.notifTitle": "การแจ้งเตือน",
"dl.payInvoice": "ชำระใบแจ้งหนี้ของฉัน →",
"dl.rewardsPending": "คูปองที่รอการแสดง",
"dl.upgradeStarter": "อัปเกรดเป็น Starter →",
"est.all": "สถานประกอบการทั้งหมด ({n})",
"est.label": "สถานประกอบการ",
"est.primary": "หลัก",
"est.secondary": "รอง",
"est2.add": "เพิ่มสถานประกอบการ",
"est2.addressLabel": "ที่อยู่",
"est2.addressPh": "12 ถนน République",
"est2.autoInvoice": "ใบแจ้งหนี้รายละเอียดจะถูกสร้างโดยอัตโนมัติในวันแรกของทุกเดือน.",
"est2.baseSub": "การสมัครสมาชิกพื้นฐาน",
"est2.billing": "การเรียกเก็บเงิน",
"est2.boostActivated": "เปิดการเพิ่มระดับสำหรับ {name}",
"est2.boostBillingNote": "ถูกเรียกเก็บเงินตามอัตราที่กำหนดและรวมอยู่ในใบแจ้งหนี้ประจำเดือนที่รวมกันของคุณ.",
"est2.boostCta": "เพิ่มระดับ",
"est2.boostDesc": "ปรับปรุงการมองเห็นของสถานประกอบการนี้ในไดเรกทอรีและแผนที่.",
"est2.boostDuration": "{h} ชั่วโมงของการมองเห็นที่เพิ่มระดับ",
"est2.boostExtend": "ขยายเวลา",
"est2.boostTitle": "เพิ่มระดับ {name}",
"est2.boosted": "ได้รับการเพิ่มระดับแล้ว",
"est2.chartDesc": "ส่วนแบ่งของรายการที่ถูกส่งกลับจากรายการทั้งหมดที่ลงทะเบียน ตำแหน่งโดยตำแหน่ง.",
"est2.chartTitle": "อัตราการส่งคืนโดยสถานประกอบการ",
"est2.chartTooltip": "ส่งคืน",
"est2.cityLabel": "เมือง",
"est2.cityPh": "ลียง",
"est2.contactHint": "รายละเอียดเหล่านี้จะแสดงให้ลูกค้าเห็นสำหรับสถานประกอบการนี้ (หากว่างจะย้อนกลับไปยังบัญชี).",
"est2.countryLabel": "ประเทศ",
"est2.coverLabel": "รูปภาพปก",
"est2.create": "สร้าง",
"est2.created": "สร้างสถานประกอบการแล้ว",
"est2.delete": "ลบ",
"est2.deleteDesc": "การดำเนินการนี้เป็นสิ่งถาวร คุณสามารถลบสถานประกอบการได้เฉพาะเมื่อไม่มีรายการอยู่ในนั้น.",
"est2.deleteTitle": "ลบ “{name}”?",
"est2.deleted": "ลบสถานประกอบการแล้ว",
"est2.dialogDesc": "กรุณากรอกชื่อและที่อยู่ของสถานที่นี้.",
"est2.edit": "แก้ไข",
"est2.editEst": "แก้ไขสถานที่",
"est2.emailLabel": "อีเมลสำหรับติดต่อ",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " สถานที่",
"est2.extraNoteBase": "{n} สถานที่เพิ่มเติมถูกเรียกเก็บเงิน",
"est2.extraPrice": " ที่ {price} €/เดือน.",
"est2.extraQuote": " ตามใบเสนอราคา.",
"est2.imgChange": "เลือกภาพ",
"est2.imgDone": "เสร็จสิ้น",
"est2.imgRemove": "ลบ",
"est2.imgRemoved": "ลบภาพแล้ว",
"est2.imgSaved": "บันทึกรูปภาพแล้ว",
"est2.imgUploading": "กำลังอัปโหลด…",
"est2.includedPlan": "รวมอยู่ในแผนของคุณ: {n}.",
"est2.kDeclarations": "การประกาศ",
"est2.kInStorage": "ในคลัง",
"est2.kItemsTotal": "รายการ (ทั้งหมด)",
"est2.kRestituted": "คืนแล้ว",
"est2.limitReached": "ถึงขีดจำกัด",
"est2.logoLabel": "โลโก้",
"est2.mDeclar": "การแจ้งเตือน",
"est2.mItems": "รายการ",
"est2.mRestituted": "คืนแล้ว",
"est2.mStorage": "ในคลัง",
"est2.monthlyTotal": "ยอดรวมรายเดือน",
"est2.nameLabel": "ชื่อ *",
"est2.namePh": "ตัวอย่าง: Belmont Hotel — Lyon Annex",
"est2.newEst": "สถานที่ใหม่",
"est2.onQuote": "ตามใบเสนอราคา",
"est2.phoneLabel": "โทรศัพท์",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "แผน",
"est2.planLimited": "แผน “{tier}” ของคุณจำกัดที่ {max} สถานที่.",
"est2.primary": "หลัก",
"est2.qr": "รหัส QR",
"est2.qrDesc": "แสดงรหัส QR นี้ในสถานที่นี้ ลูกค้าที่แจ้งการสูญหายจะถูกเชื่อมโยงไปยังสถานที่นี้.",
"est2.qrTitle": "รหัส QR — {name}",
"est2.saving": "กำลังบันทึก…",
"est2.seeInvoices": "ดูใบแจ้งหนี้รายเดือนของฉัน",
"est2.seePlans": "ดูแผน",
"est2.subtitle": "จัดการสถานที่ทั้งหมดของคุณภายใต้บัญชีเดียว — มุมมองที่รวมรายการ, รหัส QR และการเรียกเก็บเงิน.",
"est2.suspended": "ถูกระงับ",
"est2.tierFree": "1 สถานที่",
"est2.tierLarge": "สถานที่ไม่จำกัด",
"est2.tierMedium": "สถานที่รวม 5 สถานที่",
"est2.tierSmall": "สถานที่รวม 3 สถานที่",
"est2.title": "สถานที่",
"est2.unlimitedPlan": "แผนของคุณอนุญาตให้มีจำนวนสถานที่ไม่จำกัด.",
"est2.unlimitedSuffix": " · ไม่จำกัด",
"est2.updated": "สถานที่อัปเดตแล้ว",
"est2.upgradeHint": "อัปเกรดเป็นแผนที่สูงขึ้นเพื่อเพิ่มสถานที่และรวมศูนย์กิจกรรมของคุณทั้งหมด.",
"est2.visuals": "โลโก้ & รูปภาพ",
"est2.visualsDesc": "ปรับแต่งโลโก้และภาพปกของสถานที่นี้ พวกเขาจะแสดงบนหน้าแสดงของสถานที่และฟอร์มการประกาศ.",
"est2.visualsTitle": "ภาพ — {name}",
"est2.workOn": "ทำงานบนสถานที่นี้",
"est2.working": "คุณกำลังทำงานบน “{name}”",
"ev.created": "รายงานถูกสร้างขึ้น",
"ev.matched": "รายการที่ตรงกันถูกระบุ",
"ev.paid": "ค่าธรรมเนียมการฟื้นฟูที่ชำระแล้ว",
"ev.pickup": "รับสินค้า ณ สถานที่",
"ev.shipped": "พัสดุส่งแล้ว",
"ev.shipping_paid": "ค่าจัดส่งที่ชำระแล้ว",
"ev.shipping_requested": "ขอการจัดส่ง",
"feat1.d": "KPI อัตราการคืนตามหมวดหมู่ รายได้และแนวโน้ม 30 วัน",
"feat1.t": "แดชบอร์ด & วิเคราะห์",
"feat2.d": "ป้ายกำกับ ติดตามผู้ขนส่ง และอีเมลติดตามอัตโนมัติ",
"feat2.t": "โมดูลการจัดส่ง",
"feat3.d": "ลูกค้าหาคุณได้ตามเมืองและหมวดหมู่ พร้อมรีวิวที่ได้รับการรับรอง",
"feat3.t": "สมุดไดเรกทอรีสาธารณะ & รีวิว",
"fp.backToRanking": "กลับสู่กระดานผู้นำ",
"fp.badge": "เหรียญตรา",
"fp.hero": "ฮีโร่ผู้ค้นหา",
"fp.notFound": "ไม่พบโปรไฟล์หรือโปรไฟล์ส่วนตัว",
"fp.scoreTotal": "คะแนนรวม",
"fp.scoreYear": "คะแนนในปี",
"fp.share": "แชร์โปรไฟล์นี้",
"fp.shareText": "ดูโปรไฟล์ของ {name} ใน Findloop!",
"fp.tagline": "ผู้ค้นหาที่ซื่อสัตย์ทำให้โลกนี้ดีขึ้น",
"ft.backAccount": "กลับไปที่บัญชีของฉัน",
"ft.closeBtn": "ปิดเคส",
"ft.closeConfirm": "ยืนยันว่าสินค้าถูกส่งคืนแล้วหรือไม่? โฆษณาจะถูกปิด",
"ft.closeLockedHint": "ตรวจสอบรหัสเจ้าของก่อนเพื่อปลดล็อกการปิด",
"ft.closed": "เคสปิด — สินค้าถูกส่งคืน!",
"ft.codeLabel": "กรอกรหัสการตรวจสอบที่ได้รับจากเจ้าของ",
"ft.codeNeeded": "กรุณากรอกรหัสการตรวจสอบ",
"ft.codeOk": "รหัสได้รับการตรวจสอบแล้ว — คุณสามารถปิดเคสได้",
"ft.codePlaceholder": "เช่น 4821",
"ft.codeVerified": "ตรวจสอบแล้ว",
"ft.doneMsg": "ส่งคืนสินค้า ขอบคุณที่ช่วยนำกลับไปยังเจ้าของ!",
"ft.stepInProgress": "อยู่ระหว่างการส่งคืน",
"ft.stepPublished": "โฆษณาที่เผยแพร่",
"ft.stepReturned": "สินค้าถูกส่งคืน",
"ft.subtitle": "ทำตามขั้นตอนจนกว่าสินค้าที่พบจะถูกส่งคืน",
"ft.title": "ติดตามการส่งคืน",
"ft.verifyBtn": "ตรวจสอบรหัส",
"hero.badge": "เนื้อหาพิเศษ",
"hero.ctaFound": "ฉันพบสินค้า",
"hero.ctaLost": "ฉันทำของหาย",
"hero.ctaPartner": "เข้าร่วมเป็นพันธมิตร",
"hero.subtitle": "Findloop ช่วยสถานประกอบการจัดการสินค้าที่พบ — และให้ลูกค้ารายงานการสูญหายและกู้คืนทรัพย์สินของพวกเขา ณ สถานที่หรือโดยการจัดส่ง",
"hero.title": "ทุกสิ่งที่หายไปจะพบเจ้าของ",
"home.champBecome": "เข้าร่วมเป็นผู้ค้นหา",
"home.champCta": "ดูอันดับผู้นำ",
"home.champSubtitle": "ทุกชิ้นที่ส่งคืนจะได้รับคะแนน เข้าร่วมกระดานผู้นำและชนะรางวัล",
"home.champTitle": "ผู้ค้นหาที่ดีที่สุดของเรา",
"how.eyebrow": "มันทำงานอย่างไร",
"how.title": "จากการส่งมอบไปจนถึงการส่งคืน อย่างง่ายดาย",
"inv.all": "ทั้งหมด",
"inv.allYears": "ทุกปี",
"inv.count": "ใบแจ้งหนี้",
"inv.due": "ถึงกำหนด",
"inv.empty": "ยังไม่มีใบแจ้งหนี้",
"inv.exportCsv": "ส่งออก CSV",
"inv.invoicePdf": "ใบแจ้งหนี้ PDF",
"inv.issued": "ออกแล้ว",
"inv.noMatch": "ไม่มีใบแจ้งหนี้สำหรับตัวกรองนี้",
"inv.paid": "ชำระแล้ว (€)",
"inv.paidOn": "ชำระเมื่อ",
"inv.pay": "ชำระเงิน",
"inv.receipt": "ใบเสร็จ",
"inv.reminders": "การเตือนความจำ",
"inv.remindersDesc": "ส่งการเตือนความจำทางอีเมลและ SMS สำหรับใบแจ้งหนี้นี้",
"inv.remindersEmpty": "ไม่มีการส่งการเตือนความจำ",
"inv.rmDue": "การเตือนกำหนดวันครบกำหนด",
"inv.rmManual": "การเตือนแบบแมนนวล",
"inv.rmSms": "การเตือนทาง SMS D+30",
"inv.rmStage": "การเตือนความจำ",
"inv.statusPaid": "ชำระเงินแล้ว",
"inv.statusUnpaid": "ยังไม่ชำระ",
"inv.subtitle": "ดูและดาวน์โหลดใบแจ้งหนี้และใบเสร็จของคุณ",
"inv.title": "ใบแจ้งหนี้ของฉัน",
"inv.unpaid": "ยังไม่ชำระ (€)",
"inv2.contractTitle": "สัญญา Findloop ของฉัน",
"inv2.detailByEst": "รายละเอียดตามสถานประกอบการ",
"inv2.dueLabel": "กำหนดวันครบกำหนด:",
"inv2.dueSuffix": " · ครบกำหนด {date}",
"inv2.error": "ข้อผิดพลาด {status}",
"inv2.estCountIssued": "{n} สถานประกอบการ · ออกเมื่อ {date}",
"inv2.estimate": "ประมาณการ (ไม่มีการเรียกเก็บเงิน) · {n} สถานประกอบการ",
"inv2.expired": " · หมดอายุ",
"inv2.exportCsv": "ส่งออก CSV",
"inv2.exportDone": "ดาวน์โหลดการส่งออก CSV เสร็จสิ้น",
"inv2.included": "รวมอยู่ด้วย",
"inv2.monthlyTitle": "การเรียกเก็บรายเดือน (การสมัครสมาชิก)",
"inv2.months": "+{n} เดือน",
"inv2.paid": "ชำระเงินแล้ว",
"inv2.pay": "ชำระเงิน",
"inv2.previewTitle": "ดูตัวอย่างใบแจ้งหนี้ถัดไปของคุณ —",
"inv2.renew": "ต่ออายุสัญญาของฉัน",
"inv2.renewalsTitle": "ประวัติการต่ออายุ ({n})",
"inv2.renewedUntil": "สัญญาต่ออายุจนถึง {date}",
"inv2.serviceTitle": "ใบแจ้งหนี้บริการ (การเรียกเก็บและการเสนอราคา)",
"inv2.soon": "หมดอายุเร็วๆ นี้",
"inv2.toPay": "ต้องชำระ",
"inv2.totalHtTva": "รวมไม่รวมภาษี · VAT",
"inv2.totalTtc": "รวมภาษีทั้งหมด",
"iu.addPhoto": "เพิ่มภาพถ่าย",
"iu.change": "เปลี่ยน",
"lang.label": "ภาษา",
"lb.allCountries": "ทุกประเทศ",
"lb.badge": "ตารางผู้นำประจำปี",
"lb.champion": "🏆 แชมป์ประจำปี",
"lb.cityPh": "กรองตามเมือง…",
"lb.empty": "ยังไม่มีการจัดอันดับสำหรับตัวกรองเหล่านี้",
"lb.pts": "คะแนน",
"lb.resetNote": "ตารางผู้นำประจำปี — รีเซ็ตทุกวันที่ 1 มกราคม",
"lb.returned": "คืนแล้ว",
"lb.share": "แชร์ตารางผู้นำ",
"lb.shareText": "ตรวจสอบตารางผู้นำผู้ค้นหาที่ดีที่สุดใน Findloop!",
"lb.subtitle": "ทุกการคืนจะได้รับคะแนน ตารางผู้นำจะรีเซ็ตทุกวันที่ 1 มกราคม",
"lb.tabFinders": "ผู้ค้นหา",
"lb.tabPartners": "สถานประกอบการ",
"lb.title": "ผู้ค้นหาที่ดีที่สุด",
"lost.b2bDesc": "สูญหายในโรงแรม ศูนย์ขนส่ง หรือสถานที่พันธมิตร? ค้นหาสถานประกอบการและรายงานการสูญหายของคุณ",
"lost.b2bTitle": "รายงานต่อพันธมิตร",
"lost.b2cDesc": "เผยแพร่โฆษณาที่มองเห็นได้ทุกคน มอบรางวัลและส่งเสริมเพื่อเพิ่มโอกาสของคุณ",
"lost.b2cTitle": "โพสต์โฆษณาสาธารณะ",
"lost.desc": "เลือกวิธีที่คุณต้องการดำเนินการต่อ",
"lost.title": "ทำของหาย?",
"map.allCategories": "หมวดหมู่ทั้งหมด",
"map.clear": "รีเซ็ต",
"map.exitFullscreen": "ออกจากโหมดเต็มจอ",
"map.filterCity": "เมืองหรือประเทศ…",
"map.fullscreen": "โหมดเต็มจอ",
"map.heatmap": "แผนที่ความร้อน",
"map.high": "สูง",
"map.impactMonth": "ของที่ส่งคืนในเดือนนี้",
"map.impactTotal": "ส่งคืนทั้งหมด",
"map.legend": "จุดสีจากแดง (ต่ำ) ไปเขียว (สูง) ตามอัตราการคืน; ขนาดตามจำนวนของที่ส่งคืน.",
"map.locating": "กำลังค้นหาตำแหน่ง… เพิ่มที่อยู่ในสถานประกอบการของคุณเพื่อดูในแผนที่.",
"map.low": "ต่ำ",
"map.mAll": "ทั้งหมด",
"map.mFound": "พบแล้ว",
"map.mLost": "หาย",
"map.medium": "กลาง",
"map.noItemRegistered": "ไม่มีรายการที่ลงทะเบียน",
"map.noItems": "ไม่มีรายการ",
"map.period30": "30 วันที่ผ่านมา",
"map.period7": "7 วันที่ผ่านมา",
"map.period90": "90 วันที่ผ่านมา",
"map.periodAll": "ทั้งหมด",
"map.returnedSuffix": "ส่งคืน · {a}/{t} รายการ",
"map.stats": "สถิติเส้นทางเมือง",
"map.statsTop": "5 สถานที่ชั้นนำ (ของที่หาย)",
"map.statsTrend": "แนวโน้ม 6 เดือน",
"map.title": "แผนที่ของสถานประกอบการของคุณ",
"map.topPlaces": "สถานที่ยอดนิยม",
"mc.adClosed": "รายการปิดแล้ว",
"mc.addPhoto": "เพิ่มรูปภาพ",
"mc.adsNone": "ไม่มีโฆษณาของหาย.",
"mc.archiveHide": "ซ่อนประวัติ",
"mc.archiveNone": "ยังไม่มีกรณีที่แก้ไขเสร็จ.",
"mc.archiveShow": "แสดงประวัติ",
"mc.archiveSub": "กรณีที่แก้ไขและส่งคืน.",
"mc.archiveTitle": "ประวัติ",
"mc.at": "ที่",
"mc.backToLogin": "กลับไปที่ล็อกอิน",
"mc.boostContacts": "ติดต่อ (เพิ่มพลัง)",
"mc.boostViews": "การมองเห็น (เพิ่มพลัง)",
"mc.cancel": "ยกเลิก",
"mc.certificate": "ใบรับรอง",
"mc.changePhoto": "เปลี่ยนรูปภาพ",
"mc.city": "เมือง",
"mc.closeAd": "ปิด",
"mc.closeAdConfirm": "ปิดรายการนี้? จะไม่สามารถมองเห็นได้อีกและจะปล่อยช่องว่าง.",
"mc.confirmPassword": "ยืนยันรหัสผ่าน",
"mc.confirmRestitution": "ยืนยันการคืน",
"mc.connect": "เชื่อมต่อ",
"mc.contacts": "ติดต่อ",
"mc.country": "ประเทศ",
"mc.declareFound": "รายงานของที่พบ",
"mc.declareFoundSub": "โพสต์ของที่คุณพบ",
"mc.declareLost": "รายงานการหาย",
"mc.declareLostSub": "โพสต์รายการของหาย",
"mc.deleteAccount": "ลบบัญชีของฉัน",
"mc.deleteConfirm": "ใช่, ลบบัญชีของฉัน",
"mc.deleteConfirmBody": "บัญชีของคุณจะถูกลบอย่างถาวรและข้อมูลส่วนบุคคลของคุณจะถูกทำให้ไม่สามารถระบุตัวตนได้ การกระทำนี้ไม่สามารถย้อนกลับได้.",
"mc.deleteConfirmTitle": "คุณแน่ใจว่าจะลบบัญชีของคุณ?",
"mc.deleteDesc": "ลบบัญชีของคุณอย่างถาวรและทำให้ข้อมูลส่วนตัวของคุณไม่ระบุชื่อ การกระทำนี้ไม่สามารถย้อนกลับได้",
"mc.deleted": "บัญชีของคุณถูกลบแล้ว",
"mc.deleting": "กำลังลบ…",
"mc.email": "อีเมล",
"mc.expiresOn": "หมดอายุวันที่",
"mc.exportData": "ดาวน์โหลดข้อมูลของฉัน (GDPR)",
"mc.exportDone": "ข้อมูลของคุณดาวน์โหลดเสร็จแล้ว",
"mc.exporting": "กำลังเตรียม…",
"mc.finderAccepted": "ยอมรับแล้ว",
"mc.finderProfile": "โปรไฟล์ผู้ค้นหา (ไม่บังคับ)",
"mc.finderProfileDesc": "Earn points by returning items and appear on the public leaderboard.",
"mc.forYourAd": "สำหรับการลงประกาศของคุณ",
"mc.forgotLink": "ลืมรหัสผ่าน?",
"mc.forgotSend": "ส่งลิงค์",
"mc.forgotSent": "หากมีบัญชีสำหรับอีเมลนี้ ลิงค์รีเซ็ตได้ถูกส่งไปแล้ว",
"mc.forgotTitle": "ลืมรหัสผ่าน",
"mc.foundAdsNone": "ไม่มีการลงประกาศรายการที่พบ",
"mc.foundAt": "พบที่",
"mc.foundNone": "ไม่มีรายการที่พบที่รายงาน",
"mc.hAd": "ประกาศที่หายไป",
"mc.hDeclaration": "การประกาศ",
"mc.hFinderContact": "รายการที่รายงาน",
"mc.hFound": "รายการที่คืน",
"mc.hFoundAd": "ประกาศที่พบ",
"mc.histEarned": "รายการที่คืน",
"mc.historyTitle": "ประวัติคะแนนของฉัน",
"mc.loginBtn": "เข้าสู่ระบบ",
"mc.loginTitle": "เข้าสู่ระบบลูกค้า",
"mc.logout": "ออกจากระบบ",
"mc.lostAt": "สูญหายที่",
"mc.matchPartner": "ที่คู่ค้า",
"mc.matchPublic": "รายการที่พบ",
"mc.matches": "การจับคู่",
"mc.matchesSub": "รายการที่พบอาจตรงกับการลงประกาศรายการที่หายไปของคุณ",
"mc.myAds": "ประกาศที่หายไปของฉัน",
"mc.myDeclarations": "รายงานของฉัน",
"mc.myFinds": "รายการที่ฉันพบ",
"mc.myFindsNone": "คุณยังไม่ได้รายงานการพบรายการใดๆ",
"mc.myFindsSub": "รายการที่คุณรายงานว่าพบจากประกาศที่หายไป",
"mc.myFound": "รายการที่พบที่รายงาน",
"mc.myFoundAds": "การลงประกาศรายการที่พบของฉัน",
"mc.myRewards": "คูปองของฉัน",
"mc.name": "ชื่อเต็ม",
"mc.newPassword": "รหัสผ่านใหม่",
"mc.none": "ยังไม่มีรายงาน",
"mc.notEnough": "คะแนนไม่เพียงพอ",
"mc.notifEmpty": "ยังไม่มีการแจ้งเตือน",
"mc.notifOpen": "ดู",
"mc.notifTitle": "การแจ้งเตือน",
"mc.notifTrack": "ติดตาม",
"mc.notifViewAd": "ดูประกาศ",
"mc.optInDesc": "การเข้าร่วมเป็นทางเลือก คุณยินยอมให้แสดงรายการที่เลือกด้านล่างต่อสาธารณะ สามารถเปลี่ยนแปลงได้ตลอดเวลา",
"mc.optInTitle": "แสดงบนกระดานผู้นำสาธารณะ",
"mc.password": "รหัสผ่าน",
"mc.passwordMismatch": "รหัสผ่านไม่ตรงกัน",
"mc.phone": "โทรศัพท์",
"mc.photoUpdated": "อัปเดตรูปโปรไฟล์แล้ว",
"mc.pointsAwaiting": "คะแนนรอดำเนินการ",
"mc.pointsBalance": "คะแนนคงเหลือ",
"mc.pointsOk": "คะแนนได้รับการเติม",
"mc.presentHint": "แสดง QR นี้ให้กับพันธมิตร: พวกเขาสแกนเพื่อยืนยันรางวัลของคุณ.",
"mc.presentInStore": "แสดงในร้าน",
"mc.presentTitle": "แสดงบัตรกำนัลนี้",
"mc.privacy": "ความเป็นส่วนตัว & ข้อมูล",
"mc.privacyDesc": "ดาวน์โหลดสำเนาข้อมูลส่วนตัวทั้งหมดที่ Findloop ถือครองเกี่ยวกับคุณ (GDPR, มาตรา 15 & 20).",
"mc.profileSaved": "อัปเดตโปรไฟล์เรียบร้อย.",
"mc.profileSettings": "โปรไฟล์สาธารณะ & ตารางอันดับ",
"mc.pseudo": "ชื่อจริงหรือนามแฝง",
"mc.redExpired": "หมดอายุ",
"mc.redReady": "แสดงที่พันธมิตร",
"mc.redUsed": "ใช้แล้ว",
"mc.redeem": "แลก",
"mc.registerBtn": "สร้างบัญชีของฉัน",
"mc.registerTitle": "สร้างบัญชีลูกค้า",
"mc.rememberMe": "จำฉัน",
"mc.remove": "ลบ",
"mc.resetDone": "อัปเดตชื่อผู้ใช้เสร็จสิ้น คุณสามารถเข้าสู่ระบบได้เเล้ว.",
"mc.resetExpired": "ลิงก์รีเซ็ตนี้ไม่ถูกต้องหรือหมดอายุแล้ว ขอใหม่ด้านล่าง.",
"mc.resetSave": "รีเซ็ตพาสเวิร์ดของฉัน",
"mc.resetTitle": "รหัสผ่านใหม่",
"mc.restitutionConfirmed": "การคืนยืนยันแล้ว.",
"mc.reward": "รางวัล",
"mc.rewardRedeemed": "รางวัลปลดล็อคแล้ว! รหัส:",
"mc.rewardsDesc": "ใช้คะแนนของคุณสำหรับสิทธิประโยชน์ที่เสนอโดยพันธมิตรของเรา จำนวนเงิน:",
"mc.rewardsNone": "ยังไม่มีกิจกรรมที่รางวัล.",
"mc.rewardsTitle": "ใช้คะแนนของฉัน",
"mc.scoreAwarded": "ยอดเยี่ยม! +1 ให้กับคะแนน Finder ของคุณ 🎉",
"mc.scoreEarned": "คะแนนที่ได้รับ",
"mc.scorePts": "คะแนน",
"mc.scoreThisYear": "ปีนี้",
"mc.scoreTitle": "คะแนน Finder",
"mc.seeRanking": "ดูตารางอันดับ",
"mc.share": "แชร์",
"mc.statsTitle": "สถิติ",
"mc.subtitle": "ติดตามรายงานทั้งหมดของคุณในที่เดียว.",
"mc.title": "บัญชีของฉัน",
"mc.toLogin": "ลงทะเบียนแล้วใช่ไหม?",
"mc.toRegister": "ยังไม่มีบัญชีใช่ไหม?",
"mc.track": "ติดตาม",
"mc.views": "การดู",
"mc.visCity": "เมือง",
"mc.visCountry": "ประเทศ",
"mc.visLabel": "รายการที่มองเห็นในตารางอันดับ:",
"mc.visName": "ชื่อจริง / ชื่อเล่น",
"mc.visPhoto": "รูปโปรไฟล์",
"mc.welcome": "สวัสดี",
"mc2.acceptFinder": "ยอมรับ finder นี้",
"mc2.accountActivity": "กิจกรรมบัญชี",
"mc2.adsActive": "{n}/5 โฆษณาที่ใช้งานอยู่",
"mc2.autoDelete": "การลบอัตโนมัติถูกกำหนดไว้สำหรับ",
"mc2.badgeBronze": "ทองแดง",
"mc2.badgeGold": "ทอง",
"mc2.badgeSilver": "เงิน",
"mc2.boostEarnedAlready": "มันได้สร้างผลกำไรให้คุณแล้ว",
"mc2.boostEarnedWin": "มันสร้างผลกำไรให้คุณ",
"mc2.boostExpiredWin": "การกระตุ้นของคุณเพิ่งหมดอายุ - ต่อไปที่ -20%!",
"mc2.boostExpiresIn": "การกระตุ้นของคุณจะหมดอายุใน",
"mc2.boostWinDetail2": ". -20% จะถูกนำไปใช้โดยอัตโนมัติหากคุณต่ออายุภายใน 24 ชั่วโมง.",
"mc2.claimCode": "รหัสการเรียกร้อง:",
"mc2.codeSentFinder": "รหัสถูกส่งไปยัง finder ทางอีเมล",
"mc2.daysShort": "{n} วัน",
"mc2.downloadReceipt": "ดาวน์โหลดใบเสร็จของฉัน",
"mc2.error": "ข้อผิดพลาด {status}",
"mc2.finderAccepted": "Finder ได้รับการอนุมัติ — รหัสได้ถูกส่งทางอีเมล",
"mc2.finderContacts": "รายละเอียดการติดต่อของ Finder(s)",
"mc2.followFindo": "ติดตาม Findloop",
"mc2.imgInvalid": "รูปภาพไม่ถูกต้อง",
"mc2.inactivityNote": " — ในกรณีที่ไม่มีการใช้งาน {n} เดือน (GDPR).",
"mc2.lastActivity": "กิจกรรมล่าสุด:",
"mc2.lostEmailTitle": "ฉันไม่มีการเข้าถึงอีเมลอีกต่อไป",
"mc2.noPhotoPreset": "ยังไม่มีรูปภาพ? เลือกอวาตาร์เริ่มต้น:",
"mc2.paidViaPartner": "ชำระเงิน (ผ่านพันธมิตร)",
"mc2.payRecovery": "ชำระค่าฟื้นฟู",
"mc2.paySettle": "ชำระเงินของฉัน",
"mc2.payShipping": "ชำระค่าจัดส่ง",
"mc2.payUnavailable": "การชำระเงินไม่พร้อมใช้งาน",
"mc2.peopleFound": "{n} คนคิดว่าพวกเขาพบสิ่งของของคุณ",
"mc2.phoneNumber": "หมายเลขโทรศัพท์",
"mc2.reactivateAccount": "เปิดใช้งานบัญชีของฉันอีกครั้ง",
"mc2.reactivated": "บัญชีเปิดใช้งานอีกครั้ง",
"mc2.reactivatedThanks": "บัญชีเปิดใช้งานอีกครั้ง — ขอบคุณที่เป็นสมาชิกที่ดี!",
"mc2.recoverSmsBtn": "รับรหัสของฉันทาง SMS",
"mc2.recoverSmsDesc": "รับรหัสคำร้องของคุณทาง SMS ที่หมายเลขที่ลงทะเบียนในบัญชีของคุณ.",
"mc2.recoverSmsFallback": "หากมีบัญชีที่หมายเลขนี้, SMS ได้ถูกส่งไปแล้ว.",
"mc2.renewStayTop": ". ต่ออายุเพื่ออยู่บนสุดและกู้คืนสิ่งของของคุณ.",
"mc2.resume20": "คืนสถานะ -20%",
"mc2.unlockContacts": "ปลดล็อกรายละเอียดการติดต่อ",
"mc2.unlockDesc": "ชำระค่าดำเนินการของ Findloop เพื่อเปิดเผยรายละเอียดการติดต่อของพวกเขาและจัดการส่งมอบ.",
"mc2.viewsWord": "การดู",
"mc2.live": "สด",
"mh.allCategories": "ทั้งหมด",
"mh.allPeriod": "ตลอดเวลา",
"mh.autoMatch": "จับคู่ AI อัตโนมัติ",
"mh.blocked": "ถูกบล็อก",
"mh.blockedReason": "การจับคู่ถูกบล็อก: คำหลักหลักของสิ่งของและการประกาศขัดแย้งกัน.",
"mh.days30": "30 วันที่ผ่านมา",
"mh.days7": "7 วันที่ผ่านมา",
"mh.days90": "90 วันที่ผ่านมา",
"mh.emptyDesc": "การจับคู่ AI จะปรากฏที่นี่เมื่อมีการประกาศเข้ามา.",
"mh.emptyTitle": "ไม่มีเหตุการณ์",
"mh.exportCsv": "ส่งออก CSV",
"mh.exportDone": "ดาวน์โหลดการส่งออก CSV เสร็จสิ้น",
"mh.exportImpossible": "การส่งออกล้มเหลว",
"mh.fBlocked": "ถูกบล็อก",
"mh.fConfirmed": "ได้รับการยืนยัน",
"mh.fRejected": "ถูกปฏิเสธ",
"mh.objectLabel": "สิ่งของ:",
"mh.refresh": "รีเฟรช",
"mh.rejected": "ถูกปฏิเสธ",
"mh.srcManual": "คู่มือ",
"mh.srcText": "ข้อความ",
"mh.srcVisual": "ภาพถ่าย",
"mh.subtitle": "บันทึกการจับคู่ที่เสนอโดย AI — จับคู่โดยอัตโนมัติ, ยืนยันและถูกปฏิเสธ.",
"mh.title": "ประวัติ AI",
"nav.ads": "สิ่งของที่หายไป",
"nav.dashboard": "พื้นที่ของฉัน",
"nav.found": "สิ่งของที่พบ",
"nav.how": "ใช้งานอย่างไร",
"nav.login": "เข้าสู่ระบบ",
"nav.map": "แผนที่",
"nav.more": "เพิ่มเติม",
"nav.partners": "พันธมิตร",
"nav.pricing": "ราคา",
"nav.ranking": "อันดับผู้เล่น",
"nav.register": "สมัครเป็นพันธมิตร",
"nav.track": "ติดตามการประกาศ",
"nf.desc": "หน้าที่คุณกำลังมองหาไม่มีอยู่จริงหรือถูกย้ายไปแล้ว.",
"nf.home": "กลับสู่หน้าหลัก",
"nf.title": "ไม่พบหน้า",
"par.allCities": "ทุกเมือง",
"par.allCountries": "ทุกประเทศ",
"par.badge": "ไดเรกทอรี",
"par.certified": "ได้รับการรับรอง",
"par.certifiedBadge": "ได้รับการรับรอง",
"par.cityPh": "เมือง",
"par.declare": "รายงาน",
"par.none": "ไม่พบพันธมิตร.",
"par.partnerBadge": "พันธมิตร",
"par.searchPh": "ค้นหาสถานประกอบการ…",
"par.subtitle": "ค้นหาสถานประกอบการที่คุณทำของหายและรายงานการขาดหาย.",
"par.title": "พันธมิตรของเรา",
"pay.addr1": "ที่อยู่",
"pay.addr2": "ที่อยู่บรรทัด 2 (ไม่บังคับ)",
"pay.addrIncomplete": "กรุณากรอกที่อยู่สำหรับส่งสินค้า.",
"pay.badge": "การกู้คืน",
"pay.card": "จ่ายด้วยบัตร",
"pay.city": "เมือง",
"pay.country": "ประเทศ",
"pay.eurNote": "จำนวนเงินที่แสดงเป็นยูโร (€).",
"pay.fee": "ค่าธรรมเนียมการกู้คืน",
"pay.free": "ฟรี",
"pay.howRecover": "คุณต้องการรับของคืนอย่างไร?",
"pay.momo": "จ่ายด้วย Mobile Money",
"pay.momoConfirm": "ยืนยันการชำระเงิน",
"pay.noMatch": "ไม่มีรายการที่ตรงกันได้รับการยืนยันสำหรับรายงานนี้ในขณะนี้.",
"pay.notfound": "ไม่พบรายงาน.",
"pay.phonePh": "หมายเลขโทรศัพท์",
"pay.pickup": "รับของด้วยตัวเอง",
"pay.pickupDesc": "ที่",
"pay.postal": "รหัสไปรษณีย์",
"pay.secure": "การชำระเงินที่ปลอดภัย",
"pay.serviceFee": "ค่าธรรมเนียมบริการ Findloop",
"pay.ship": "จัดส่งให้ฉัน",
"pay.shipAfter": "— จะให้บริการหลังจากการชำระเงิน.",
"pay.shipDesc": "จัดส่งไปยังที่อยู่ของฉัน",
"pay.shipNote": "มีบริการจัดส่ง",
"pay.shipping": "ค่าจัดส่ง",
"pay.subtitleWith": "ชำระค่าธรรมเนียมการกู้คืนที่",
"pay.title": "กู้คืนของฉัน",
"pay.total": "รวม",
"pcat.city_hall": "ห้องประชุมเทศบาล",
"pcat.hotel": "โรงแรม",
"pcat.other": "อื่นๆ",
"pcat.park": "สวนสาธารณะ",
"pcat.prefecture": "จังหวัด",
"pcat.restaurant": "ร้านอาหาร",
"pcat.uncategorized": "ไม่มีหมวดหมู่",
"pd.about": "เกี่ยวกับ",
"pd.back": "พันธมิตรทั้งหมด",
"pd.certified": "พันธมิตรที่ได้รับการรับรอง",
"pd.declare": "รายงานการขาดหายที่นี่",
"pd.itemsReturned": "รายการที่ส่งคืน",
"pd.itemsTotal": "รายการที่ลงทะเบียน",
"pd.map": "ที่ตั้ง",
"pd.noItems": "ไม่พบรายการล่าสุด",
"pd.noReviews": "ยังไม่มีรีวิว",
"pd.notFound": "ไม่พบพันธมิตร",
"pd.recentItems": "รายการที่พบล่าสุด",
"pd.reply": "ตอบกลับจากสถานประกอบการ",
"pd.reviews": "รีวิวจากลูกค้า",
"pd.verified": "รีวิวที่ตรวจสอบแล้ว",
"pd.verifiedEstablishment": "สถานประกอบการที่ตรวจสอบโดย Findloop",
"pg.next": "ถัดไป",
"pg.prev": "ก่อนหน้า",
"pg.showing": "{from}–{to} จาก {total}",
"pk.bodyCopy": "ข้อความหลัก",
"pk.bodyText": "ข้อความหลัก",
"pk.brandColors": "สีแบรนด์",
"pk.colorRed": "แดง",
"pk.colorWhite": "ขาว",
"pk.darkBg": "พื้นหลังเข้ม",
"pk.download": "ดาวน์โหลด",
"pk.downloadZip": "ดาวน์โหลดชุดทั้งหมด (ZIP)",
"pk.headings": "หัวเรื่อง",
"pk.heroDesc": "โลโก้อย่างเป็นทางการ, แบนเนอร์โซเชียลมีเดีย, สีและตัวอักษร เลือกภาษาของคำขวัญและแบบ แล้วดาวน์โหลดภาพหรือชุดทั้งหมด",
"pk.lightBg": "พื้นหลังอ่อน (พิมพ์)",
"pk.logoWordmark": "โลโก้ / ชื่อแบรนด์",
"pk.logosVisuals": "โลโก้ & สื่อภาพ",
"pk.mapCollect": "แผนที่ / จุดรวบรวม",
"pk.plain": "ธรรมดา",
"pk.pressKit": "ชุดสื่อ",
"pk.taglineLang": "ภาษาของคำขวัญ",
"pk.typography": "การพิมพ์",
"pk.variant": "แบบ",
"pr.shipBtn": "จัดส่งรายการ",
"pr2.adBoostMsg": "เลือกที่ดี! คุณเพิ่มโอกาสในการกู้คืนรายการของคุณอย่างรวดเร็ว",
"pr2.boostActivated": "เปิดใช้งานการเพิ่ม!",
"pr2.canRecoverNow": "คุณสามารถกู้คืนรายการของคุณได้แล้ว",
"pr2.continue": "ดำเนินการต่อ",
"pr2.downloadReceiptPdf": "ดาวน์โหลดใบเสร็จ (PDF)",
"pr2.goToSpaceNow": "ไปที่บัญชีของฉันทันที",
"pr2.partnerBoostMsg": "เลือกที่ดี! การมองเห็นที่มากขึ้นหมายถึงการดึงดูดลูกค้าใหม่ไปยังสถานประกอบการของคุณ",
"pr2.paymentSuccess": "ชำระเงินสำเร็จ!",
"pr2.redirectingSpace": "กำลังเปลี่ยนเส้นทางไปยังบัญชีของคุณ…",
"pr2.subActivated": "ชำระเงินสำเร็จ! การสมัครสมาชิกของคุณเปิดใช้งานแล้ว คุณสามารถจัดการสถานประกอบการของคุณได้แล้ว",
"prev.allSites": "สถานประกอบการทั้งหมด",
"prev.editReply": "แก้ไขการตอบกลับ",
"prev.none": "ยังไม่มีรีวิว",
"prev.published": "เผยแพร่การตอบกลับ",
"prev.reply": "ตอบกลับ",
"prev.replyPh": "เขียนการตอบกลับที่สุภาพ…",
"prev.send": "เผยแพร่การตอบกลับ",
"prev.sending": "กำลังเผยแพร่…",
"prev.yourReply": "การตอบกลับของคุณ",
"pricing.annual": "รายปี",
"pricing.annualBadge": "-20% ข้อเสนอ",
"pricing.choose": "เลือก",
"pricing.compareFeature": "ฟีเจอร์",
"pricing.compareTitle": "เปรียบเทียบแผน",
"pricing.eyebrow": "ราคา",
"pricing.month": "/เดือน",
"pricing.monthly": "รายเดือน",
"pricing.perYear": "/ปี",
"pricing.popular": "เป็นที่นิยม",
"pricing.quoteMsg": "ความต้องการของคุณ (เลือกได้)",
"pricing.quoteOrg": "องค์กร",
"pricing.quoteSend": "ส่งคำขอ",
"pricing.quoteSent": "ส่งคำขอเรียบร้อยแล้ว! เราจะติดต่อกลับโดยเร็วที่สุด.",
"pricing.quoteSites": "จำนวนไซต์ / เทอร์มินัล",
"pricing.quoteTitle": "ขอใบเสนอราคา",
"pricing.requestQuote": "ขอใบเสนอราคา",
"pricing.saveLabel": "คุณประหยัด",
"pricing.savePerYear": "/ปี ต่อการตั้งค่าทางธุรกิจเพิ่มเติม",
"pricing.start": "เริ่มต้น",
"pricing.subtitle": "เริ่มฟรี ขยายเมื่อคุณเติบโต.",
"pricing.title": "แผนสำหรับทุกองค์กร",
"promo.badge": "โปรแกรมพันธมิตร",
"promo.cta": "เรียนรู้เพิ่มเติม",
"promo.text": "ทุกพันธมิตรที่คุณแนะนำซึ่งสมัครสมาชิกจะมอบเดือนฟรีให้คุณ 1 เดือน ไม่จำกัด.",
"promo.title": "แนะนำพันธมิตร รับเดือนฟรี.",
"pub.accessGranted": "เข้าถึงได้",
"pub.accessLimited2h": "เข้าถึงจำกัด 2 ชั่วโมง",
"pub.accountEmailConcerned": "อีเมลของบัญชีที่เกี่ยวข้อง",
"pub.adAppearPublic": "นี่คือวิธีที่โฆษณาของคุณจะปรากฏสาธารณะ.",
"pub.adPreviewBtn": "ดูตัวอย่างโฆษณา",
"pub.alertMeOnArrival": "แจ้งเตือนเมื่อมาถึง",
"pub.allActionsLogged": "บันทึกการดำเนินการทั้งหมด",
"pub.allCategories": "ทุกประเภท",
"pub.authorizeAccess": "อนุญาตการเข้าถึง",
"pub.authorizeSupportQ": "อนุญาตการเข้าถึงการสนับสนุน?",
"pub.available": "พร้อมใช้งาน",
"pub.backHome": "กลับไปที่หน้าแรก",
"pub.boostAdCta": "เพิ่มโฆษณาของฉัน",
"pub.boostAdTitle": "เพิ่มโฆษณาของคุณ",
"pub.boostCarouselSub": "เคลื่อนขึ้นไปยังด้านบนของหน้าในแถบ “เพิ่ม” และเพิ่มการมองเห็นเพื่อฟื้นฟูรายการของคุณให้เร็วขึ้น.",
"pub.boostEstablishment": "เพิ่มสถานประกอบการของคุณ",
"pub.boostEstablishmentDesc": "ปรากฏที่ด้านบนของไดเรกทอรีพร้อมตรา “เพิ่ม” และดึงดูดรายงานมากขึ้น.",
"pub.boostFicheCta": "เพิ่มรายชื่อของฉัน",
"pub.brandReady": "แบรนด์ Findloop พร้อมใช้งาน",
"pub.cantFindItem": "ไม่สามารถหาสิ่งของของคุณได้?",
"pub.cantProcessImage": "ไม่สามารถประมวลผลภาพนี้ได้",
"pub.claimQr": "เรียกร้องรหัส QR",
"pub.clickToZoom": "คลิกเพื่อขยาย",
"pub.codeAlreadyValidated": "รหัสได้รับการตรวจสอบแล้ว — ติดต่อเปิดแล้ว.",
"pub.codeExample": "เช่น ABCD2345",
"pub.confirmRenewal": "ยืนยันการต่ออายุ",
"pub.contactIntro": "มีคำถามหรือคำขอ? เขียนถึงเรา เราจะติดต่อกลับโดยเร็วที่สุด.",
"pub.contactTypeDeceased": "การลบบัญชี (บุคคลที่เสียชีวิต)",
"pub.contactTypeGeneral": "คำถามทั่วไป",
"pub.contactTypeSupport": "ปัญหาการสนับสนุน / เทคนิค",
"pub.contactUs": "ติดต่อเรา",
"pub.continueWithoutEmail": "ดำเนินการโดยไม่ต้องทิ้งอีเมลของฉัน",
"pub.contractLabel": "สัญญา",
"pub.contractNotFound": "ไม่พบสัญญาหรือหมดอายุแล้ว.",
"pub.contractRenewed": "ต่ออายุสัญญาแล้ว!",
"pub.contractRenewedFor": "สัญญาของคุณต่ออายุเป็นเวลา {n} เดือน.",
"pub.copyFailed": "การคัดลอกล้มเหลว",
"pub.createPartnerAccount": "สร้างบัญชีพันธมิตรของฉัน",
"pub.currentDeadline": "กำหนดเส้นตายปัจจุบัน",
"pub.deceasedInfo": "ในฐานะที่เป็นญาติหรือทายาท คุณสามารถขอลบบัญชี Findloop ของบุคคลที่เสียชีวิต เราจะดำเนินการตามคำขอของคุณตามข้อกำหนด GDPR (อาจมีการขอเอกสารประกอบ).",
"pub.declareMyLoss": "รายงานความสูญเสียของฉัน",
"pub.describeItemPlaceholder": "อธิบายสิ่งของของคุณ (เช่น ร่มสีดำ, กุญแจ…)",
"pub.downloadImage": "ดาวน์โหลดภาพ",
"pub.drawSignature": "กรุณาร่างลายเซ็นของคุณ",
"pub.drawSignatureHint": "ใช้เมาส์หรือปลายนิ้วในการร่างลายเซ็นของคุณ",
"pub.duration": "ระยะเวลา",
"pub.eSignature": "ลายเซ็นอิเล็กทรอนิกส์",
"pub.eSignatureDesc": "กรอกชื่อของคุณเพื่อเซ็นชื่อ วันที่จะถูกบันทึกโดยอัตโนมัติ",
"pub.edit": "แก้ไข",
"pub.editorialTitles": "ชื่อบทบรรณาธิการ",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "กรอกรหัสที่ได้รับทางอีเมลเพื่อปลดล็อกข้อมูลติดต่อของเจ้าของ",
"pub.errorWord": "ข้อผิดพลาด",
"pub.foundSelfService": "พบสิ่งของ · บริการตนเอง",
"pub.haveOwnerCode": "ฉันได้รับรหัสจากเจ้าของ",
"pub.home": "หน้าหลัก",
"pub.immediateRenewal": "ต่ออายุทันที โดยไม่ต้องมีการเสนอราคาใหม่",
"pub.impAdminReq1": "ผู้ดูแลระบบ",
"pub.impAdminReq2": "ขออนุญาตเข้าถึงบัญชีของคุณชั่วคราว",
"pub.impAdminReq3": "เพื่อให้ความช่วยเหลือคุณ",
"pub.impGrantedDesc": "ทีมสนับสนุนสามารถเข้าถึงบัญชีของคุณได้สูงสุด 2 ชั่วโมง ทุกการกระทำจะถูกบันทึก คุณสามารถปิดหน้านี้ได้",
"pub.invitedOnFindo": "คุณได้รับเชิญเข้าร่วม Findloop",
"pub.isThisYourItem": "นี่คือสิ่งของของคุณหรือไม่?",
"pub.itemsAvailableCount": "{n} รายการที่พร้อมใช้งานในขณะนี้",
"pub.itemsFoundOwner": "ของที่ถูกมอบหมายพบเจ้าของ",
"pub.itemsReturnedOwners": "รายการที่กลับคืนสู่เจ้าของ",
"pub.itsMine": "มันเป็นของฉัน",
"pub.joinFindoDesc": "เข้าร่วม Findloop และจัดการสิ่งของที่คุณพบได้อย่างง่ายดาย",
"pub.joinInvitesYou": "เชิญคุณเข้าร่วม Findloop สร้างบัญชีสำหรับคู่ค้าของคุณเพื่อจัดการสิ่งของที่คุณพบ",
"pub.linkCopied": "ลิงก์ถูกคัดลอกแล้ว!",
"pub.loadingContract": "กำลังโหลดสัญญา…",
"pub.lsClaimDesc": "รายงานการสูญหายของคุณเพื่อดำเนินการคืน เราจะส่งการแจ้งเตือนหากรายงานของคุณยังไม่เสร็จสิ้น",
"pub.lsHeroDesc": "ตรวจสอบด้วยตัวเองว่าสิ่งของที่สูญหายของคุณถูกพบและส่งมาที่นี่หรือไม่ พบแล้ว? รายงานเพื่อให้คืนแก่คุณ",
"pub.lsSearchTitle": "ค้นหารายการที่พบ",
"pub.makeOffer": "ทำข้อเสนอ",
"pub.makeOfferDesc": "เสนอจำนวนของคุณ ผู้ดูแลระบบจะพิจารณา",
"pub.mapNearYou": "รายการ & คู่ค้าที่ใกล้คุณ",
"pub.mapWord": "แผนที่",
"pub.messageSentToast": "ส่งข้อความแล้ว — ทีมของเราจะตอบกลับเร็ว ๆ นี้",
"pub.messageWord": "ข้อความ",
"pub.momoInitiated": "เริ่มการชำระเงินด้วย Mobile Money",
"pub.monthsWord": "เดือน",
"pub.nameConsentRequired": "ต้องมีชื่อและความยินยอม",
"pub.newDeadline": "กำหนดเวลาใหม่",
"pub.noActionRequired": "ไม่ต้องดำเนินการใด ๆ",
"pub.noAmountCharged": "ไม่มีจำนวนเงินถูกเรียกเก็บ",
"pub.noItemMatch": "ขณะนี้ไม่มีรายการที่ตรงกับการค้นหาของคุณ",
"pub.noMatchingItem": "ไม่มีรายการที่ตรงกัน",
"pub.noPaymentSession": "ไม่มีเซสชันการชำระเงิน",
"pub.noPhoto": "ไม่มีภาพ",
"pub.noPointsYet": "ยังไม่มีคะแนนให้แสดง",
"pub.noSecondPayment": "ไม่ต้องชำระเงินครั้งที่สองสำหรับรายการนี้",
"pub.notHereYet": "ยังไม่มาที่นี่? รับการแจ้งเตือนเมื่อมันมาถึง",
"pub.notifyDone": "บันทึกแล้ว! เราจะแจ้งให้คุณทราบทางอีเมลเมื่อมีรายการที่ตรงกันมาถึง",
"pub.offerSubmitted": "ข้อเสนอของคุณถูกส่งแล้ว",
"pub.oops": "โอ้ย",
"pub.orAlertEmail": "หรือรับการแจ้งเตือนทางอีเมลเมื่อมีรายการที่ตรงกันมาถึง:",
"pub.ownerContacts": "ข้อมูลติดต่อของเจ้าของ",
"pub.ownerContactsUnlocked": "ข้อมูลติดต่อของเจ้าของถูกปลดล็อก",
"pub.partnerContact": "ข้อมูลติดต่อของคู่ค้า",
"pub.payLinkUnavailable": "ลิงก์ชำระเงินไม่สามารถใช้ได้ — ติดต่อคู่ค้า",
"pub.paymentCancelled": "ชำระเงินถูกยกเลิก",
"pub.paymentConfirmed": "ชำระเงินยืนยันแล้ว 🎉",
"pub.paymentConfirmedDesc": "คุณจะได้รับอีเมลที่มีรายละเอียดเพื่อกู้คืนสินค้า",
"pub.paymentNotConfirmed": "ชำระเงินยังไม่ได้รับการยืนยัน",
"pub.paymentNotConfirmedDesc": "ไม่สามารถตรวจสอบการชำระเงินได้ กรุณาลองอีกครั้งหรือ ติดต่อพันธมิตร",
"pub.paymentProcessing": "กำลังดำเนินการชำระเงิน โปรดรีเฟรชในไม่ช้า",
"pub.photoAdded": "✓ เพิ่มรูปภาพแล้ว",
"pub.photoRequired": "ต้องการรูปภาพของสินค้า",
"pub.previewAlt": "ตัวอย่าง",
"pub.publish": "เผยแพร่",
"pub.publishingWord": "กำลังเผยแพร่…",
"pub.qty": "จำนวน",
"pub.quoteDeclined": "ไม่รับใบเสนอราคา",
"pub.quoteNotFound": "ไม่พบใบเสนอราคาหรือลงวันที่หมดอายุ",
"pub.reasonLabel": "เหตุผล",
"pub.recoveryAlreadyPaid": "ค่าฟื้นฟูชำระแล้ว",
"pub.referralCode": "โค้ดแนะนำ:",
"pub.relationshipPlaceholder": "ลูก, คู่สมรส, ทนายความ…",
"pub.renewYourContract": "ต่ออายุสัญญาของคุณ",
"pub.renewalFailed": "การต่ออายุล้มเหลว กรุณาลองอีกครั้งในภายหลัง",
"pub.renewing": "กำลังต่ออายุ…",
"pub.replySoon": "ทีมงานของเราจะตอบกลับโดยเร็วที่สุด",
"pub.requestGone": "คำขอนี้ไม่มีอยู่แล้ว",
"pub.requestHandled": "คำขอได้รับการจัดการแล้ว",
"pub.requestNotFound": "ไม่พบคำขอหรือลงวันที่หมดอายุ",
"pub.requestUnavailable": "คำขอไม่มีให้บริการ",
"pub.required": "(ต้องการ)",
"pub.retroClosing": "ร่วมกัน เราทำให้โลกนี้ไม่หลงทางน้อยลง",
"pub.retroClosing2": "ร่วมกัน เราทำให้โลกนี้ไม่หลงทางน้อยลง",
"pub.retroScroll": "ปีแห่งการกู้คืนสิ่งที่สำคัญ เลื่อนลง ↓",
"pub.revokeAnytime": "คุณสามารถเพิกถอนได้ตลอดเวลาโดยการติดต่อเรา",
"pub.scene": "ฉาก",
"pub.sendImpossible": "ไม่สามารถส่งได้",
"pub.sendMessage": "ส่งข้อความ",
"pub.sending": "กำลังส่ง…",
"pub.sharePreview": "แชร์ตัวอย่าง",
"pub.shareYourAd": "แชร์โฆษณาของคุณ",
"pub.signedSuccess": "ลงนามสำเร็จ!",
"pub.signerFullName": "ชื่อเต็มของผู้ลงนาม",
"pub.spreadNetwork": "แชร์กับบุคคลรอบข้างเพื่อเพิ่มโอกาสของคุณ",
"pub.spreadOwner": "แชร์เพื่อช่วยเจ้าของกู้คืนทรัพย์สิน",
"pub.statusLabel": "สถานะ:",
"pub.subject": "หัวข้อ",
"pub.thanksSent": "ขอบคุณ ข้อความของคุณถูกส่งแล้ว",
"pub.thisYear": "ปีนี้",
"pub.validate": "ตรวจสอบ",
"pub.verifyingPayment": "กำลังตรวจสอบการชำระเงิน…",
"pub.verifyingYourPayment": "กำลังตรวจสอบการชำระเงินของคุณ…",
"pub.viewAd": "ดูโฆษณา →",
"pub.viewPartner": "ดูพันธมิตร →",
"pub.yourAdPreview": "ตัวอย่างโฆษณาของคุณ",
"pub.yourEmail": "อีเมลของคุณ",
"pub.yourEmailRecommended": "อีเมลของคุณ (แนะนำ)",
"pub.yourEmailShort": "อีเมลของคุณ",
"pub.yourName": "ชื่อของคุณ",
"pub.yourRelationship": "ความสัมพันธ์ของคุณกับบุคคลนั้น",
"qv.acceptAndSign": "ยอมรับและลงนามใบเสนอราคาของฉัน",
"qv.certifyAuthorized": "ฉันขอรับรองว่าฉันมีอำนาจในการลงนามและยอมรับข้อกำหนดของ {what} นี้ (มูลค่าผูกพัน)",
"qv.clear": "ล้าง",
"qv.client": "ลูกค้า",
"qv.conditions": "เงื่อนไข",
"qv.confirmDecline": "ยืนยันการปฏิเสธใบเสนอราคานี้?",
"qv.countersignedFindo": "ลงนามโดย Findloop · {name} ในวันที่ {date}",
"qv.decline": "ปฏิเสธ",
"qv.description": "รายละเอียด",
"qv.downloadPdf": "ดาวน์โหลด PDF",
"qv.handwrittenSignature": "ลายเซ็นเขียนด้วยมือ",
"qv.inclTax": "รวมภาษี",
"qv.invalidAmount": "จำนวนเงินไม่ถูกต้อง.",
"qv.invoice": "ใบแจ้งหนี้",
"qv.invoicePaid": "ชำระเงินใบแจ้งหนี้แล้ว",
"qv.issuer": "ผู้ออกใบแจ้งหนี้",
"qv.messageOptional": "ข้อความ (เลือกได้)",
"qv.negotiatedAmount": "จำนวนเงินที่เจรจา",
"qv.payInvoiceOnline": "ชำระใบแจ้งหนี้ออนไลน์",
"qv.quote": "ใบเสนอราคา",
"qv.quoteValidDays": "ใบเสนอราคามีอายุ {n} วัน.",
"qv.sendMyOffer": "ส่งข้อเสนอของฉัน",
"qv.signContract": "ลงนามในสัญญาของฉัน",
"qv.signNow": "ลงนามตอนนี้",
"qv.signatureAlt": "ลายเซ็น",
"qv.signedByOn": "✔ ลงนามโดย {name} ในวันที่ {date}",
"qv.stContractSigned": "สัญญาได้ลงนามเรียบร้อย ขอบคุณ!",
"qv.stCounterAccepted": "ข้อเสนอของคุณได้รับการตอบรับแล้ว! ลงนามในสัญญาของคุณด้านล่าง.",
"qv.stCounterRefused": "ข้อเสนอของคุณไม่สามารถตอบรับได้.",
"qv.stCountered": "ข้อเสนอของคุณถูกส่งแล้ว กำลังรอการตอบกลับจาก findloop.",
"qv.stDeclined": "คุณได้ปฏิเสธใบเสนอราคานี้.",
"qv.stSigned": "ใบเสนอราคาได้รับการตอบรับและลงนาม ขอบคุณ!",
"qv.totalHt": "รวมทั้งหมดไม่รวมภาษี",
"qv.totalTtc": "รวมทั้งหมดรวมภาษี",
"qv.unitHt": "หน่วยไม่รวมภาษี",
"qv.vat": "VAT",
"qv.yourProposedAmount": "จำนวนเงินที่คุณเสนอ ({cur})",
"rate.chooseNote": "กรุณาเลือกการให้คะแนน.",
"rate.commentPh": "ความคิดเห็น (เลือกได้)…",
"rate.home": "กลับไปที่หน้าแรก",
"rate.submit": "ส่งรีวิวของฉัน",
"rate.submitting": "กำลังส่ง…",
"rate.subtitle": "การกู้คืนรายการของคุณเป็นอย่างไร?",
"rate.successText": "ความคิดเห็นของคุณช่วยผู้ใช้อื่น.",
"rate.successTitle": "ขอบคุณสำหรับรีวิวของคุณ!",
"rate.title": "ให้คะแนนประสบการณ์ของคุณ",
"reg.add": "บันทึกรายการ",
"reg.allBrands": "ทุกแบรนด์",
"reg.allColors": "ทุกสี",
"reg.allLocations": "ทุกสถานที่",
"reg.detailDesc": "รายละเอียดและการดำเนินการสำหรับรายการที่พบนี้.",
"reg.dispAuction": "การประมูล",
"reg.dispAuthorities": "ส่งให้หน่วยงาน",
"reg.dispDestroyed": "ถูกทำลาย",
"reg.dispDonate": "บริจาคเพื่อการกุศล",
"reg.dispositionHint": "บันทึกการนำรายการออกจากพื่นที่เก็บ. นับในสถิติแยกตามประเภท.",
"reg.emptyCta": "บันทึกรายการ",
"reg.emptyDesc": "เริ่มต้นด้วยการบันทึกของที่คุณพบเป็นครั้งแรก.",
"reg.emptyTitle": "ไม่พบรายการ",
"reg.establishmentFallback": "สถานประกอบการ",
"reg.lblAuctioned": "ลงทะเบียนที่การประมูล",
"reg.lblAuctionedShort": "ประมูล",
"reg.lblAuthorities": "ส่งให้หน่วยงาน",
"reg.lblDestroyed": "ถูกทำลาย",
"reg.lblDonated": "บริจาคให้การกุศล",
"reg.legalCount": "{n} รายการ: ผ่านระยะเวลาการเก็บรักษาทางกฎหมาย",
"reg.legalHint": "คุณสามารถนำไปประมูล บริจาคให้การกุศล หรือรายงานการส่งมอบให้เจ้าหน้าที่.",
"reg.legalLimitCountry": "กำหนดเส้นตาย: {date} · ประเทศที่ใช้: {country}",
"reg.legalOver": "เส้นตายผ่านพ้นไปแล้ว: {date} · {country}",
"reg.legalReached": "ระยะเวลาทางกฎหมายถึงแล้ว",
"reg.legalReachedFull": "ระยะเวลาการเก็บรักษาทางกฎหมายถึงแล้ว",
"reg.limitShort": "เส้นตาย",
"reg.location": "สถานที่",
"reg.markRestituted": "ทำเครื่องหมายว่าได้คืน",
"reg.markedAs": "รายการทำเครื่องหมายว่า {label}",
"reg.moveHistory": "ประวัติการเคลื่อนไหว",
"reg.overBy": "เกิน {n} วัน",
"reg.physicalLocation": "ที่ตั้งทางกายภาพ",
"reg.popupBlocked": "อนุญาตให้เปิดป๊อปอัปเพื่อพิมพ์ฉลาก.",
"reg.popupBlockedOne": "อนุญาตให้เปิดป๊อปอัปเพื่อพิมพ์ฉลาก.",
"reg.printLabel": "พิมพ์ฉลาก",
"reg.printN": "พิมพ์ {n} ฉLABEL",
"reg.qrCodeItem": "รหัส QR ของรายการ",
"reg.qrLabelTitle": "ฉลาก QR",
"reg.qrLabelsTitle": "ฉลาก QR",
"reg.qrNotFound": "ไม่พบรายการสำหรับรหัส QR นี้.",
"reg.qrScanHint": "สแกนเพื่อเปิดบันทึกนี้โดยตรงและหาสถานที่.",
"reg.recoveryFee": "ค่าฟื้นฟู (€)",
"reg.searchPh": "ค้นหาตามคำอธิบาย…",
"reg.selectQr": "เลือกเพื่อพิมพ์ฉลาก QR",
"reg.selectedN": "{n} รายการที่เลือก",
"reg.shipPricePh": "ค่าขนส่ง (€)",
"reg.shippingPossible": "มีบริการจัดส่ง",
"reg.storagePh": "เช่น ชั้น A3, ล็อกเกอร์ 12",
"reg.tAuction": "ประมูลบน Findloop",
"reg.tAuthorities": "รายงานการส่งมอบให้เจ้าหน้าที่",
"reg.tDonate": "บริจาคให้การกุศล",
"reg.toastFee": "อัปเดตค่าธรรมเนียม",
"reg.toastLocation": "บันทึกสถานที่เรียบร้อย",
"reg.toastRestituted": "ทำเครื่องหมายรายการว่าได้คืน",
"reg.toastShipping": "อัปเดตตัวเลือกการจัดส่ง",
"reg.toastTransferred": "รายการถูกโอนให้กับ “{name}”",
"reg.unclaimedDisposition": "รายการที่ยังไม่ได้รับ — การจัดการขั้นสุดท้าย",
"res.codeValidated": "รหัสได้รับการตรวจสอบแล้ว",
"res.empty": "ยังไม่มีการบันทึกการคืน.",
"res.error": "ข้อผิดพลาด {status}",
"res.proofPdf": "เอกสาร PDF",
"res.signed": "ลงชื่อแล้ว",
"res.stRestituted": "ส่งมอบด้วยตนเอง",
"res.stShipped": "ส่งคืนโดยการจัดส่ง",
"res.subtitle": "การส่งมอบทั้งหมดที่เสร็จสิ้น พร้อมหลักฐานที่ลงนามแล้วให้ดาวน์โหลด.",
"res.title": "ประวัติการคืน",
"rev.b2b": "พันธมิตร B2B",
"rev.b2c": "ลูกค้า",
"rev.based": "อิงจาก {n} รีวิว",
"rev.eyebrow": "คำแนะนำ",
"rev.restitutedBy": "คืนโดย {org}",
"rev.storiesEyebrow": "บทสรุปที่น่าพอใจ",
"rev.storiesSubtitle": "เรื่องจริงจากลูกค้าที่ฟื้นคืนทรัพย์สินของตนด้วย findloop.",
"rev.storiesTitle": "พวกเขาพบทรัพย์สินของพวกเขา!",
"rev.subtitle": "พันธมิตรและลูกค้าแชร์ประสบการณ์ของพวกเขา.",
"rev.title": "พวกเขาเชื่อมั่นใน Findloop",
"rev.verified": "ได้รับการตรวจสอบแล้ว",
"rp.already": "คุณได้รายงานประกาศนี้แล้ว.",
"rp.comment": "รายละเอียด (เลือกได้)",
"rp.duplicate": "ทำซ้ำ",
"rp.fraud": "หลอกลวง / การฉ้อโกง",
"rp.inappropriate": "เนื้อหาที่ไม่เหมาะสม",
"rp.offensive": "เนื้อหาที่ไม่เหมาะสม",
"rp.other": "อื่นๆ",
"rp.reason": "เหตุผล",
"rp.report": "รายงาน",
"rp.send": "ส่งรายงาน",
"rp.sent": "ส่งรายงานแล้ว ขอบคุณสำหรับการมีส่วนร่วม",
"rp.spam": "สแปม / โฆษณา",
"rp.title": "รายงานประกาศนี้",
"rp.wrongCategory": "หมวดหมู่ผิด",
"rt.annualGoal": "เป้าหมายประจำปี",
"rt.championCity": "เมืองแชมป์",
"rt.cityRate": "{rate}% อัตราผลตอบแทน",
"rt.goalProgress": "{rate}% ที่บรรลุจากเป้าหมาย {target}%",
"rt.reached": "บรรลุเป้าหมาย 🎉",
"rt.restitutionRate": "อัตราผลตอบแทน",
"rt.shareRecap": "แชร์บันทึกของฉัน",
"rt.thanks": "ขอบคุณ Findloop {year} 💛",
"rt.yourRecap": "บันทึกของคุณ {year}",
"rw.active": "ใช้งาน",
"rw.add": "เพิ่ม",
"rw.camUnavailable": "กล้องไม่พร้อมใช้งาน กรุณากรอกโค้ดด้วยตนเองด้านล่าง",
"rw.codeValidated": "โค้ดยืนยันแล้ว",
"rw.codesTitle": "รหัสที่แลกโดยผู้ค้นหา",
"rw.confirmDelete": "ลบ “{title}”?",
"rw.deleted": "ถูกลบ",
"rw.edit": "แก้ไข",
"rw.editReward": "แก้ไขรางวัล",
"rw.empty": "ยังไม่มีรางวัล",
"rw.expired": "หมดอายุ",
"rw.expiresOn": "หมดอายุในวันที่ {date}",
"rw.fActive": "ใช้งาน (มองเห็นโดยผู้ค้นหา)",
"rw.fCost": "ค่าใช้จ่าย (คะแนน)",
"rw.fDesc": "คำอธิบาย",
"rw.fStock": "สต็อก (ว่าง = ไม่จำกัด)",
"rw.fTitle": "ชื่อ",
"rw.fValidity": "ความถูกต้องของบัตรกำนัล (วันหลังจากแลก)",
"rw.inactive": "ไม่ใช้งาน",
"rw.newReward": "รางวัลใหม่",
"rw.noExchange": "ยังไม่มีการแลก",
"rw.pageSubtitle": "สแกนบัตรกำนัลที่นำเสนอโดยผู้ค้นหาเพื่อยืนยันรางวัลของพวกเขา",
"rw.redeemedN": "แลกแล้ว: {n}×",
"rw.saved": "บันทึกรางวัลแล้ว",
"rw.scanVoucher": "สแกนบัตรกำนัล",
"rw.staffScanOnly": "สแกนเท่านั้น",
"rw.statActive": "นำเสนอ",
"rw.statExpired": "หมดอายุ",
"rw.statRedeemed": "บัตรกำนัลที่แลก",
"rw.statUsed": "ยืนยันแล้ว",
"rw.stock": "สต็อก",
"rw.subtitle": "เสนอสิทธิประโยชน์ที่ไม่ใช่เป็นเงิน (บัตรกำนัล การอัปเกรด…) ที่ผู้ค้นแลกเพื่อรับคะแนน Finder Score ของตน",
"rw.title": "รางวัลสำหรับผู้ค้นหา",
"rw.used": "ใช้งาน",
"rw.validate": "ยืนยัน",
"rw.validateCode": "ยืนยันโค้ด",
"rw.validity": "ความถูกต้อง: {n} วัน",
"shell.f1d": "เชื่อมโยงรายการที่สูญหายและพบโดยอัตโนมัติ.",
"shell.f1t": "การจับคู่ AI ที่ชาญฉลาด",
"shell.f2d": "ติดตามอัตราการส่งคืนและรายได้แบบเรียลไทม์",
"shell.f2t": "แดชบอร์ด & รายได้",
"shell.f3d": "ลูกค้าของคุณรายงานใน 30 วินาที",
"shell.f3t": "รหัส QR พาร์ทเนอร์",
"shell.title": "เปลี่ยนสิ่งของที่หายไปเป็นลูกค้าที่พอใจ",
"ship.addr1": "ที่อยู่",
"ship.addr2": "ที่อยู่บรรทัด 2 (เลือกได้)",
"ship.badge": "การจัดส่ง",
"ship.city": "เมือง",
"ship.country": "ประเทศ",
"ship.needPaid": "ชำระค่าธรรมเนียมการกู้คืนก่อนเพื่อขอการจัดส่ง",
"ship.notShippable": "สินค้านี้ไม่สามารถจัดส่งได้",
"ship.notfound": "ไม่พบรายงาน",
"ship.postal": "รหัสไปรษณีย์",
"ship.price": "ค่าจัดส่ง",
"ship.submit": "ขอการจัดส่ง",
"ship.submitting": "กำลังส่ง…",
"ship.subtitle": "กรอกที่อยู่ส่งของคุณ",
"ship.successText": "พาร์ทเนอร์จะเตรียมพัสดุของคุณ คุณจะได้รับการแจ้งเตือนเมื่อจัดส่งแล้ว",
"ship.successTitle": "ขอการจัดส่งส่งแล้ว!",
"ship.title": "จัดส่งสิ่งของของคุณ",
"ship.weight": "น้ำหนักประมาณ (กก.)",
"shp.carrier": "ผู้ให้บริการ",
"shp.download": "ดาวน์โหลด PDF",
"shp.generating": "กำลังสร้าง…",
"shp.label": "สร้างป้ายกำกับ",
"shp.none": "ไม่มีการร้องขอการจัดส่ง",
"shp.setTracking": "บันทึกการติดตาม",
"shp.status": "สถานะ",
"shp.to": "ผู้รับ",
"shp.tracking": "หมายเลขติดตาม",
"shp.trackingSaved": "บันทึกการติดตามแล้ว",
"side.account": "บัญชีของฉัน",
"side.declarations": "รายงาน",
"side.deposit": "บันทึกรายการ",
"side.establishments": "สถานประกอบการ",
"side.invoices": "ใบแจ้งหนี้",
"side.logout": "ออกจากระบบ",
"side.matchHistory": "ประวัติ AI",
"side.partner": "พาร์ทเนอร์",
"side.refresh": "รีเฟรช",
"side.registry": "ทะเบียน",
"side.restitutions": "การคืนสินค้า",
"side.reviews": "รีวิว",
"side.rewards": "รางวัล & คูปอง",
"side.settings": "การตั้งค่า",
"side.shipments": "การจัดส่ง",
"side.stats": "สถิติ",
"side.storage": "การจัดเก็บ & QR",
"side.team": "ทีม",
"side.viewSite": "ดูเว็บไซต์สาธารณะ",
"st.auctioned": "ขายที่ประมูล",
"st.claimed": "เรียกร้องแล้ว",
"st.closed": "ปิดแล้ว",
"st.delivered": "จัดส่งแล้ว",
"st.destroyed": "ทำลายแล้ว",
"st.donated": "บริจาค (การกุศล)",
"st.handed_to_authorities": "ส่งให้หน่วยงาน",
"st.in_storage": "อยู่ในที่เก็บ",
"st.matched": "พบรายการที่ตรงกัน",
"st.open": "เปิด",
"st.paid": "ชำระเงินแล้ว",
"st.pending": "รอดำเนินการ",
"st.resolved": "แก้ไขแล้ว",
"st.restituted": "คืนแล้ว",
"st.second_chance": "โอกาสครั้งที่สอง",
"st.shipped": "จัดส่งแล้ว",
"st.shipping_requested": "ขอจัดส่ง",
"st.submitted": "ส่งแล้ว",
"st.verified": "ตรวจสอบแล้ว",
"stat.items": "รายการที่ลงทะเบียน",
"stat.partners": "พันธมิตร",
"stat.restituted": "รายการที่คืน",
"status.auctioned": "ประมูลแล้ว",
"status.destroyed": "ทำลายแล้ว",
"status.donated": "บริจาค (เพื่อการกุศล)",
"status.handed_to_authorities": "มอบให้หน่วยงาน",
"status.in_storage": "อยู่ในคลัง",
"status.matched": "ตรงกัน",
"status.open": "เปิด",
"status.paid": "ชำระเงินแล้ว",
"status.pending": "รอดำเนินการ",
"status.restituted": "คืนแล้ว",
"status.shipped": "จัดส่งแล้ว",
"status.shipping_requested": "ขอจัดส่ง",
"status.submitted": "ส่งแล้ว",
"step1.tag": "สถานประกอบการ",
"step1.text": "ในไม่กี่วินาที สถานประกอบการจะบันทึกรายการที่พบพร้อมรูปภาพ ประเภท และคำอธิบาย ทุกอย่างรวบรวมไว้ในทะเบียนที่ชัดเจนและปลอดภัย",
"step1.title": "พันธมิตรลงทะเบียนรายการ",
"step2.tag": "ลูกค้า",
"step2.text": "ผ่าน QR โค้ดของพันธมิตร ลูกค้าของคุณสามารถอธิบายรายการที่หายในเวลา 30 วินาที ไม่ต้องติดตั้งแอป — ทุกอย่างเกิดขึ้นในเบราว์เซอร์",
"step2.title": "ลูกค้ารายงานการสูญหาย",
"step3.tag": "ปัญญาประดิษฐ์",
"step3.text": "เครื่องมือจับคู่ที่ชาญฉลาดของเราจะเปรียบเทียบคำอธิบายและแนะนำรายการที่ตรงกันมากที่สุด พร้อมสำหรับการยืนยัน",
"step3.title": "AI เชื่อมโยงการสูญหายกับรายการที่พบ",
"step4.tag": "การกู้คืน",
"step4.text": "หลังจากชำระค่าธรรมเนียมการกู้คืนอย่างปลอดภัย ลูกค้าจะไปรับรายการที่สถานที่ — หรือรับทางการจัดส่งที่ติดตามได้",
"step4.title": "ลูกค้าได้รับรายการคืน",
"stg.allLabels": "QR label ทั้งหมด",
"stg.camHint": "ใช้การกรอกข้อมูลด้วยตนเองด้านล่าง.",
"stg.camStarting": "เริ่มกล้อง…",
"stg.camUnavailable": "กล้องไม่พร้อมใช้งาน.",
"stg.clear": "ล้าง",
"stg.clearAll": "ล้างทั้งหมด",
"stg.codeUnreadable": "โค้ดอ่านไม่ออก.",
"stg.emptyDesc": "รายการที่จัดเก็บจะปรากฏที่นี่ แบ่งกลุ่มตามสถานที่.",
"stg.emptyTitle": "ไม่มีรายการในคลัง",
"stg.exportAudit": "ส่งออก CSV การตรวจสอบ",
"stg.exportDone": "ดาวน์โหลด CSV เสร็จแล้ว",
"stg.exportImpossible": "การส่งออกไม่สามารถทำได้ในขณะนี้.",
"stg.itemFound": "พบรายการ ✅",
"stg.kLocations": "สถานที่ที่ใช้",
"stg.kObjects": "รายการที่เก็บ",
"stg.kToClear": "สถานที่ที่ต้องล้าง",
"stg.locFreed": "ปล่อยสถานที่",
"stg.locsFreed": "ปล่อย {n} สถานที่",
"stg.manualLabel": "หรือกรอกรหัส / ID ของรายการ",
"stg.manualPh": "วาง ID หรือ URL ของ QR",
"stg.noItemMatch": "ไม่มีรายการตรงกับ QR / โค้ดนี้.",
"stg.noLocation": "ไม่มีตำแหน่ง",
"stg.objectsAxis": "รายการ",
"stg.objectsN": "{n} รายการ",
"stg.occAvg": "เฉลี่ย {n} รายการ/ตำแหน่ง",
"stg.occHint": "ตำแหน่งที่อยู่ในโทนสีน้ำตาลเข้มเกินค่าเฉลี่ย (อาจเกินกำลัง).",
"stg.occupancy": "การเข้าพักของตำแหน่ง",
"stg.openPage": "เปิดหน้า",
"stg.posterPdf": "โปสเตอร์ PDF (A4)",
"stg.printAll": "พิมพ์ทั้งหมด",
"stg.printGroupTitle": "พิมพ์ป้ายสำหรับชั้นวางนี้",
"stg.qrAlt": "QR เซลฟ์เซอร์วิส",
"stg.qrDownload": "ดาวน์โหลด QR",
"stg.qrHint": "แสดง QR นี้ที่เคาน์เตอร์: ลูกค้าของคุณสแกนเพื่อเช็คว่ารายการของพวกเขามีอยู่หรือไม่.",
"stg.qrTitle": "QR เซลฟ์เซอร์วิสสำหรับลูกค้า",
"stg.scanDesc": "สแกนป้ายรายการเพื่อเปิดบันทึกทันที.",
"stg.scanQr": "สแกน QR",
"stg.scanTitle": "สแกนโค้ด QR",
"stg.search": "ค้นหา",
"stg.shelf": "ชั้นวาง {loc}",
"stg.shelfPlan": "แผนชั้นวาง",
"stg.staleHint": "ล้างตำแหน่งเหล่านี้เพื่อตรวจสอบสินค้าคงคลังทางกายภาพของคุณให้อัปเดต.",
"stg.staleTitle": "{n} รายการออกจากการเก็บแต่ยังคงอยู่ในตำแหน่ง",
"stg.subtitle": "แผนชั้นวาง, สแกน QR และติดตามสินค้าคงคลังทางกายภาพ.",
"stg.title": "การจัดเก็บ & QR",
"stt.acceptRate": "อัตราการยอมรับ",
"stt.accepted": "ได้รับการยอมรับ",
"stt.activity30": "กิจกรรม (30 วันที่ผ่านมา)",
"stt.ai6mo": "6 เดือนที่ผ่านมา · ได้รับการยอมรับ = การแมตช์อัตโนมัติ + ยืนยัน.",
"stt.aiEmpty": "ยังไม่มีการแมตช์ AI ในช่วงเวลานี้.",
"stt.aiTitle": "การแมตช์ AI — ได้รับการยอมรับ vs ถูกปฏิเสธ",
"stt.auctionShort": "การประมูล",
"stt.auctionedSold": "ประมูล (ขายแล้ว)",
"stt.authShort": "หน่วยงาน",
"stt.authorities": "มอบให้หน่วยงาน",
"stt.avgRating": "คะแนนเฉลี่ย",
"stt.awaitingRestitution": "รายการที่รอการคืน",
"stt.boostClicks": "คลิกในไดเรกทอรีของคุณในสัปดาห์นี้ขอบคุณโหมดเพิ่มพลัง",
"stt.boostInactive": "โหมดเพิ่มพลังไม่ทำงาน — เปิดใช้งานเพื่อเพิ่มการมองเห็น",
"stt.certifiedPremium": "ได้รับการรับรองพรีเมี่ยม",
"stt.declarations": "การประกาศ",
"stt.destroyed": "ถูกทำลาย",
"stt.dispoEmpty": "ยังไม่มีรายการที่ไม่ถูกอ้างสิทธิ์ออกจากการเก็บ.",
"stt.donatedAssoc": "บริจาค (การกุศล)",
"stt.donatedShort": "บริจาค",
"stt.gateCta": "ค้นพบแผนการ",
"stt.gateDesc": "อัปเกรดเป็น Starter เพื่อปลดล็อกสถิติพื้นฐานของคุณ, หรือเป็น Business สำหรับสถิติขั้นสูงและการวิเคราะห์ตามสาขา.",
"stt.gateTitle": "สถิติที่สงวนไว้สำหรับแผนที่ชำระเงิน",
"stt.inStorage": "ในที่เก็บ",
"stt.kItems": "รายการที่ลงทะเบียน",
"stt.kRate": "อัตราการคืน",
"stt.kRestituted": "รายการที่คืน",
"stt.kRevenue": "รายได้ (เดือน)",
"stt.noDeclYet": "ยังไม่มีการประกาศ.",
"stt.recapDownloaded": "สรุปดาวน์โหลดแล้ว — พร้อมแบ่งปัน!",
"stt.recapError": "ไม่สามารถสร้างสรุปได้",
"stt.recapText": "สรุป {year} ของเรา Findloop: รายการที่คืนและความพึงพอใจของลูกค้า 🎉",
"stt.recapTitle": "สรุป {year} ของ Findloop",
"stt.rejected": "ถูกปฏิเสธ",
"stt.restitutions": "การคืน",
"stt.shareRecap": "แบ่งปันสรุป {year} ของฉัน",
"stt.topCategories": "หมวดหมู่ที่ถูกประกาศมากที่สุด",
"stt.unclaimedDesc": "จำนวนรายการที่ถูกทำลาย, บริจาคให้การกุศลและขายประมูล แบ่งตามหมวดหมู่.",
"stt.unclaimedTitle": "รายการที่ไม่มีเจ้าของ — ออกจากที่จัดเก็บ",
"stt.vsLastWeek": "เทียบกับสัปดาห์ที่แล้ว",
"sub.cancel": "ยกเลิกการสมัครสมาชิกของฉัน",
"sub.cancelAbort": "ยกเลิก",
"sub.cancelConfirm1": "คุณแน่ใจหรือว่าต้องการยกเลิก? การเข้าถึงของคุณจะยังคงใช้งานได้จนกว่า",
"sub.cancelConfirm2": "ไม่มีการคืนเงินจะถูกดำเนินการ.",
"sub.cancelConfirmBtn": "ยืนยันการยกเลิก",
"sub.cancelTitle": "ยกเลิกการสมัครสมาชิกของคุณ",
"sub.cancelledToast": "บันทึกการยกเลิกเรียบร้อย.",
"sub.cguAnd": "และ",
"sub.cguDesc": "กรุณายืนยันความเห็นชอบของคุณก่อนทำการชำระเงิน.",
"sub.cguLink": "เงื่อนไขการใช้งาน",
"sub.cguPay": "ดำเนินการชำระเงินต่อ",
"sub.cguPre": "ฉันได้อ่านและยอมรับ",
"sub.cguRequired": "คุณต้องยอมรับเงื่อนไขการใช้งานและนโยบายความเป็นส่วนตัวเพื่อดำเนินการต่อ.",
"sub.cguSuffix": "ของ Findloop.",
"sub.cguTitle": "ทำให้การสมัครสมาชิกของคุณเสร็จสมบูรณ์",
"sub.expiresOn": "การสมัครสมาชิกของคุณหมดอายุในวันที่",
"sub.noProrata": "ไม่คืนเงินแบบสัดส่วน.",
"sub.privacyLink": "นโยบายความเป็นส่วนตัว",
"sub.renewsOn": "การสมัครสมาชิกของคุณจะต่ออายุในวันที่",
"sub.resume": "สมัครสมาชิกใหม่",
"sub.resumedToast": "การสมัครสมาชิกใหม่ได้รับการยืนยันแล้ว.",
"tier.free": "ฟรี",
"tier.large": "องค์กร",
"tier.medium": "ธุรกิจ",
"tier.small": "เริ่มต้น",
"tm.add": "เพิ่ม",
"tm.adminOpt": "ผู้ดูแล (มุมมองทั้งหมด)",
"tm.chooseEst": "เลือกสถานประกอบการ",
"tm.chooseEstPh": "เลือกสถานประกอบการ",
"tm.copyFail": "การคัดลอกล้มเหลว",
"tm.copyLink": "คัดลอกลิงก์",
"tm.copyOk": "คัดลอกลิงก์เชิญแล้ว",
"tm.emailHint": "อีเมลเชิญจะถูกส่งไปเพื่อสร้างรหัสผ่าน.",
"tm.expiresOn": "หมดอายุใน {date}",
"tm.forEmail": " สำหรับ {email}",
"tm.forbidden": "การจัดการทีมสงวนไว้สำหรับเจ้าของบัญชี.",
"tm.inviteCreated": "สร้างคำเชิญแล้ว",
"tm.inviteDesc": "อีเมลเชิญให้สมาชิกสร้างรหัสผ่านของตนเอง.",
"tm.invitePending": "คำเชิญอยู่ระหว่างรอ",
"tm.inviteResent": "ส่งคำเชิญใหม่",
"tm.inviteSent": "ส่งคำเชิญทางอีเมลแล้ว",
"tm.inviteTitle": "เชิญสมาชิก",
"tm.invitedOn": "เชิญเมื่อ {date}",
"tm.linkExpired": "ลิงก์หมดอายุ",
"tm.memberRemoved": "สมาชิกถูกลบ",
"tm.name": "ชื่อ",
"tm.noMembers": "ยังไม่มีสมาชิก.",
"tm.resendTitle": "ส่งคำเชิญใหม่อีกครั้ง",
"tm.role": "บทบาท",
"tm.roleAdmin": "ผู้ดูแล",
"tm.roleOwner": "เจ้าของ",
"tm.roleStaff": "พนักงาน",
"tm.roleUpdated": "อัปเดตบทบาทเรียบร้อย",
"tm.sendInvite": "ส่งคำเชิญ",
"tm.sending": "กำลังส่ง…",
"tm.staffOpt": "พนักงาน (เห็นเฉพาะสถานประกอบการของตนเอง)",
"trk.at": "ที่",
"trk.badge": "การติดตาม",
"trk.carrier": "ผู้ให้บริการ",
"trk.codeValidated": "รหัสได้รับการตรวจสอบโดยพันธมิตร",
"trk.dlProof": "ดาวน์โหลดหลักฐานการส่งมอบของฉัน (PDF)",
"trk.emailLabel": "อีเมล (ไม่บังคับ — เพื่อดูรายละเอียดของคุณ)",
"trk.enterEmailCode": "กรอกอีเมลของคุณข้างต้นเพื่อแสดงรหัสการเรียกร้องของคุณ.",
"trk.idLabel": "หมายเลขรายงาน",
"trk.lostEmail": "ฉันไม่มีการเข้าถึงอีเมลอีกต่อไป",
"trk.phonePh": "หมายเลขโทรศัพท์ของคุณ",
"trk.photoBefore": "รูปภาพของรายการก่อนการจัดส่ง",
"trk.recoverBtn": "กู้คืนรายการของฉัน",
"trk.recoverHint": "รับรหัสการเรียกร้องของคุณทาง SMS บนหมายเลขที่ลงทะเบียนของคุณ.",
"trk.searching": "กำลังค้นหา…",
"trk.secureRest": "การส่งมอบอย่างปลอดภัย",
"trk.send": "ส่ง",
"trk.shipPending": "กำลังเตรียมการจัดส่ง — หมายเลขติดตามจะปรากฏที่นี่เมื่อตส่งแล้ว.",
"trk.shipTitle": "ติดตามการจัดส่ง",
"trk.showQr": "แสดง QR นี้ให้พันธมิตรเพื่อยืนยันการส่งมอบ",
"trk.sigSaved": "ลายเซ็นบันทึกสำเร็จ",
"trk.signFirst": "กรุณาเซ็นก่อนยืนยัน.",
"trk.signProof": "เซ็นหลักฐานการส่งมอบของคุณ",
"trk.signSubmit": "ยืนยันลายเซ็นของฉันและสร้าง PDF",
"trk.submit": "ติดตาม",
"trk.subtitle": "กรอกหมายเลขรายงานของคุณเพื่อติดตามความก้าวหน้า.",
"trk.title": "ติดตามรายงานของฉัน",
"trk.trackShipment": "ติดตามพัสดุ",
"trk.trackingNo": "หมายเลขติดตาม",
"trk.yourCode": "รหัสการเรียกร้องของคุณ (เพื่อให้กับพันธมิตร)",
"a.firstName": "ชื่อ",
"ac.emailCrossMatch": "การจับคู่ B2C",
"ac.emailCrossMatchDesc": "จะมีอีเมลเมื่อการประกาศของที่สูญหายตรงกับรายการที่ฝากไว้ที่สถานที่ของคุณ",
"ac.emailCrossReject": "การปฏิเสธการจับคู่สาธารณะ",
"ac.emailCrossRejectDesc": "รับอีเมลเมื่อมีลูกค้าระบุว่าการจับคู่สาธารณะที่แนะนำไม่ใช่ของเขา",
"ac.emailLoginNotif": "การแจ้งเตือนการเข้าสู่ระบบ",
"ac.emailLoginNotifDesc": "รับอีเมลทุกครั้งที่มีคนเข้าสู่บัญชีของคุณ",
"ad.closeNoCancel": "ไม่, ลบรายการ",
"ad.closeQuestion": "รายการนั้นถูกส่งคืนให้คุณหรือไม่?",
"ad.closeQuestionDesc": "แจ้งให้เราทราบว่าคุณได้รับรายการของคุณหรือไม่ หรือคุณต้องการลบรายการนี้เท่านั้น",
"ad.closeYesRestituted": "ใช่, รายการถูกส่งคืน",
"ad.closedRestituted": "รายการถูกส่งคืน — ปิดรายการ 🎉",
"an.lostLoginDesc": "ต้องมีบัญชีเพื่อรายงานรายการที่สูญหายและติดตามการคืน",
"an.lostLoginRequired": "เข้าสู่ระบบเพื่อรายงานรายการที่สูญหาย",
"an.qfAll": "ทั้งหมด",
"an.qfBoosted": "ได้รับการเพิ่มโฆษณา",
"an.qfPhoto": "พร้อมภาพ",
"an.qfRecent": "สัปดาห์นี้",
"an.qfResolved": "ได้รับการแก้ไข",
"an.restitutionInProgress": "กำลังส่งคืนรายการ",
"dec.descPhLong": "อธิบายรายการ: แบรนด์, สี, ลักษณะเฉพาะ… (ยิ่งคุณให้รายละเอียดมาก โอกาสในการกู้คืนรายการของคุณก็ยิ่งสูงขึ้น)",
"dec.loadError": "ไม่สามารถโหลดข้อมูลพันธมิตรในขณะนี้ ตรวจสอบการเชื่อมต่อของคุณและลองอีกครั้ง",
"dec.retry": "ลองอีกครั้ง",
"dec.shippingMode": "การจัดส่ง",
"dep.photo2": "ภาพรายการที่ 2",
"dep.photo2Hint": "ไม่บังคับ — มุมมองที่ต่างออกไปช่วยเพิ่มความแม่นยำในการจับคู่ภาพ",
"dl.accountSuspended": "บัญชีถูกระงับเนื่องจากใบแจ้งหนี้ที่ยังไม่ชำระ ชำระเงินเพื่อกู้คืนการเข้าถึงของคุณ",
"dl.regularize": "ชำระเงินตอนนี้ →",
"dl.suspensionCountdown": "ใบแจ้งหนี้ {num} ยังไม่ชำระ — บัญชีของคุณจะถูกระงับใน {days} วัน ชำระเงินเพื่อหลีกเลี่ยงเรื่องนี้",
"ft.cancelConfirm": "ยกเลิกการรายงานของคุณ? เจ้าของรายการจะได้รับข้อมูล",
"ft.cancelDone": "ยกเลิกการรายงานเรียบร้อยแล้ว",
"ft.cancelLocked": "ไม่สามารถยกเลิกได้อีกต่อไปหลังจากที่เจ้าของชำระเงิน",
"ft.cancelReport": "ยกเลิกการรายงานของฉัน",
"ft.claimCodeHelp": "ให้รหัสนี้กับผู้ค้นหาที่ส่งมอบเพื่อยืนยันว่าคุณได้รับรายการของคุณ",
"ft.claimCodeTitle": "รหัสการคืนของคุณ",
"ft.claimDone": "รายการถูกส่งคืน ขอบคุณที่ใช้ Findloop!",
"ft.claimUnlockHint": "ปลดล็อครายละเอียดการติดต่อของผู้ค้นหา",
"ft.claimUnlockHintSub": "ไปที่ \"Items I'm claiming\" ในบัญชีของคุณเพื่อชำระค่าธรรมเนียมและรับรายละเอียดการติดต่อ",
"ft.finderCodeShownHelp": "เจ้าของชำระเงินและเลือกคุณแล้ว คัดลอกรหัสนี้ด้านล่างเพื่อยืนยันการคืน — ไม่จำเป็นต้องตรวจสอบอีเมลของคุณ",
"ft.finderCodeShownTitle": "รหัสยืนยันของเจ้าของ",
"ft.finderContactsTitle": "รายละเอียดการติดต่อของ Finder",
"ft.foundCodeHelp": "แสดงรหัสนี้ให้เจ้าของในขณะที่ส่งมอบเพื่อยืนยันว่าสินค้าถูกส่งคืนแล้ว",
"ft.inProgressOther": "สินค้ากำลังถูกส่งคืน",
"ft.inProgressOtherHelp": "เจ้าของเลือกผู้ค้นหาอื่นสำหรับสินค้านี้ ไม่จำเป็นต้องดำเนินการเพิ่มเติมจากฝั่งคุณ",
"ft.restitutionCodeHelp": "รหัสนี้ยืนยันการส่งมอบสินค้า มันถูกกรอกไว้ล่วงล่างแล้ว โปรดตรวจสอบและปิดกรณี",
"ft.restitutionCodeTitle": "รหัสการส่งมอบของคุณ",
"hc.14Digits": "14 หลัก",
"hc.15DaysBeforeAnItem": "15 วันก่อนวันสิ้นสุดกฎหมายของสินค้า",
"hc.7DaysBeforeAnItem": "7 วันก่อนวันสิ้นสุดกฎหมายของสินค้า",
"hc.8CharactersMinimum": "ขั้นต่ำ 8 ตัวอักษร",
"hc.aClaimToValidate": "การเรียกร้องที่ต้องตรวจสอบ",
"hc.aFindoAssistanceSessionIs": "เซสชันการช่วยเหลือของ Findloop กำลังดำเนินอยู่ในบัญชีของคุณ",
"hc.aNewMatchHasBeen": "ได้พบการจับคู่ใหม่",
"hc.aUser": "ผู้ใช้",
"hc.aUserClaimsToBe": "ผู้ใช้กล่าวอ้างว่าเป็นเจ้าของ โปรดตรวจสอบคำตอบก่อนอนุมัติการส่งคืน",
"hc.aboutFindo": "เกี่ยวกับ Findloop",
"hc.accountActivatedPleaseLogIn": "บัญชีถูกเปิดใช้แล้ว กรุณาล็อกอิน",
"hc.accountActivation": "การเปิดใช้งานบัญชี",
"hc.accountCreated": "สร้างบัญชีเรียบร้อย!",
"hc.accountDeactivatedAReactivationEmail": "บัญชีถูกปิดใช้งานแล้ว อีเมลการเปิดใช้งาน (ใช้ได้ 30 วัน) ได้ถูกส่งไปยังคุณ",
"hc.accountReactivation": "การเปิดใช้งานบัญชีอีกครั้ง",
"hc.activateMyAccount": "เปิดใช้งานบัญชีของฉัน",
"hc.activateMyAdminAccount": "เปิดใช้งานบัญชีผู้ดูแลระบบของฉัน",
"hc.activating": "กำลังเปิดใช้งาน…",
"hc.activeMatchCancelReason": "จับคู่ที่ใช้งานอยู่ สาเหตุการยกเลิกของลูกค้า: \"{reason}\". สินค้ายังรอการเรียกร้อง",
"hc.activeMatchWithAPublic": "จับคู่ที่ใช้งานอยู่ที่มีรายการสาธารณะ (ของลูกค้า) รอการเรียกร้องจากเจ้าของ",
"hc.addAPhoto": "เพิ่มภาพถ่าย",
"hc.addAndConfigureYourEstablishments": "เพิ่มและกำหนดค่าสถานประกอบการของคุณใน \"สถานประกอบการ\": รายละเอียดการติดต่อ ประเภท และที่เก็บสินค้าทางกายภาพ",
"hc.addOnGoogle": "เพิ่มบน Google",
"hc.address": "ที่อยู่",
"hc.addressSaved": "บันทึกที่อยู่แล้ว",
"hc.addressStreet": "ที่อยู่ — ถนน",
"hc.adjustThePhoto": "ปรับภาพถ่าย",
"hc.adminFullView": "ผู้ดูแลระบบ (มุมมองทั้งหมด)",
"hc.administratorOnly": "ผู้ดูแลระบบเท่านั้น",
"hc.africa": "แอฟริกา",
"hc.aiVisualComparison": "การเปรียบเทียบภาพด้วย AI",
"hc.all": "ทั้งหมด",
"hc.amount": "จำนวน",
"hc.anOrganization": "องค์กรหนึ่ง",
"hc.analyzing": "กำลังวิเคราะห์…",
"hc.andRecoveryIs": "และการกู้คืนคือ",
"hc.andTheDeclarationWillBe": "และการประกาศจะถูกปิด (ย้ายไปยังประวัติ). การกระทำนี้ถือเป็นขั้นตอนสุดท้าย.",
"hc.annual20": "ทุกปี -20%",
"hc.annualBilling20": "การเรียกเก็บรายปี (−20%)",
"hc.annualTarget": "เป้าหมายรายปี",
"hc.anyCommentsOptional": "มีข้อคิดเห็นหรือไม่? (ไม่บังคับ)",
"hc.approveTheClaim": "อนุมัติการเรียกร้อง",
"hc.archiveCancelledConfirm": "ต้องการจัดเก็บรายการ {n} \"ยกเลิกโดยลูกค้า\" หรือไม่? พวกเขาจะถูกนำออกจากทะเบียน.",
"hc.asSoonAs": "โดยเร็วที่สุด",
"hc.askTheOwnerToDisplay": "ขอเจ้าของแสดง QR โค้ดของพวกเขา (หน้าติดตาม).",
"hc.askThemAtTheCounter": "ถามเขาที่เคาน์เตอร์เพื่อยืนยันตัวตน — ไม่แสดงต่อสาธารณะ.",
"hc.assistance": "การสนับสนุน",
"hc.assistanceSessionRevoked": "เซสชันการช่วยเหลือถูกเพิกถอน.",
"hc.atLeast6Characters": "อย่างน้อย 6 อักขระ",
"hc.automaticallyPreSelected": "ถูกเลือกโดยอัตโนมัติ",
"hc.automaticallyWhenShipping": "โดยอัตโนมัติเมื่อจัดส่ง.",
"hc.awaitingClaim": "รอการเรียกร้อง",
"hc.awaitingPayment": "รอการชำระเงิน",
"hc.b2cCustomer": "ลูกค้า B2C",
"hc.back": "กลับ",
"hc.backToHome": "กลับไปที่หน้าแรก",
"hc.backToMyAccount": "กลับไปที่บัญชีของฉัน",
"hc.backToPayment": "กลับไปที่การชำระเงิน",
"hc.beforeAfterComparisonSlider": "แถบเลื่อนเปรียบเทียบก่อน/หลัง",
"hc.billingInformation": "ข้อมูลการเรียกเก็บเงิน",
"hc.billingInformationSaved": "บันทึกข้อมูลการเรียกเก็บเงิน ✓",
"hc.brand": "แบรนด์",
"hc.bronze": "ทองสัมฤทธิ์",
"hc.calculatingTheShippingRate": "กำลังคำนวณอัตราค่าขนส่ง…",
"hc.cameraUnavailableEnterTheCode": "กล้องไม่สามารถใช้ได้. กรุณาป้อนโค้ดด้วยตนเอง.",
"hc.cancel": "ยกเลิก",
"hc.cancelMyDeclaration": "ยกเลิกการประกาศของฉัน",
"hc.cancelSavedFmt": "บันทึกการยกเลิก: \"{reason}\". คุณยังสามารถเรียกร้องได้.",
"hc.cancelTheDeposit": "ยกเลิกการฝาก",
"hc.cancelThisMatch": "ยกเลิกการจับคู่ครั้งนี้",
"hc.cancellationReason": "เหตุผลในการยกเลิก",
"hc.cancelled": "ถูกยกเลิก",
"hc.cancelledByTheCustomer": "ถูกยกเลิกโดยลูกค้า",
"hc.cannotOpenPayment": "ไม่สามารถเปิดการชำระเงินได้. กรุณาลองอีกครั้ง.",
"hc.careers": "อาชีพ",
"hc.carrier": "ผู้ให้บริการ",
"hc.carrierAvailabilityCannotBeChecked": "ไม่สามารถตรวจสอบความพร้อมของผู้ให้บริการจนกว่าจะตั้งค่าผู้ส่ง Sendcloud ของคุณ",
"hc.carrierConfirmedCharged": "ผู้ให้บริการยืนยัน — คิดค่าบริการ {price} € ส่งให้ลูกค้า",
"hc.carrierOther": "ผู้ให้บริการ (อื่นๆ)",
"hc.carrierSelection": "การเลือกผู้ให้บริการ",
"hc.caseClosedThankYou": "เคสปิดแล้ว ขอบคุณ!",
"hc.category": "หมวดหมู่",
"hc.changeMethod": "เปลี่ยนวิธี",
"hc.characteristic": "ลักษณะ",
"hc.chargedToCustomer": "เรียกเก็บจากลูกค้า.",
"hc.checkOrEditYourDetails": "ตรวจสอบหรือแก้ไขข้อมูลของคุณก่อนชำระเงินอย่างปลอดภัย",
"hc.checkStatisticsToTrackDeposited": "ตรวจสอบ \"สถิติ\" เพื่อติดตามรายการที่ฝาก, อัตราการคืน และประสิทธิภาพของแต่ละสถานที่",
"hc.checkTheDetailsBeforeContacting": "ตรวจสอบรายละเอียดก่อนติดต่อผู้ค้นหา",
"hc.checkTheDetailsBelowBefore": "ตรวจสอบรายละเอียดด้านล่างก่อนเริ่มคำขอคืนสินค้า",
"hc.checkTheNewItem": "ตรวจสอบรายการใหม่",
"hc.checkThePhotosAndCharacteristics": "ตรวจสอบภาพถ่ายและลักษณะด้านล่างก่อนดำเนินการกู้คืน",
"hc.chooseACountry": "เลือกประเทศ",
"hc.chooseANewPassword": "เลือกพาสเวิร์ดใหม่",
"hc.chooseAReason": "เลือกเหตุผล",
"hc.chooseTheLegalRetentionAlerts": "เลือกการแจ้งเตือนการเก็บตามกฎหมายที่ได้รับทางอีเมลสำหรับ",
"hc.chooseYourPasswordToAccess": "เลือกพาสเวิร์ดของคุณเพื่อเข้าถึงคอนโซลการบริหารจัดการ",
"hc.city": "เมือง",
"hc.claimApproved": "การเรียกร้องได้รับการอนุมัติ",
"hc.claimApproved2": "การเรียกร้องได้รับการอนุมัติ.",
"hc.claimCodeExpired": "รหัสการเรียกร้องหมดอายุ",
"hc.claimCodeVerified": "รหัสการเรียกร้องได้รับการตรวจสอบแล้ว",
"hc.claimNotFound": "ไม่พบการเรียกร้อง",
"hc.claimNotValidated": "การเรียกร้องไม่ผ่านการตรวจสอบ",
"hc.claimRejected": "การเรียกร้องถูกปฏิเสธ",
"hc.claimRejected2": "การเรียกร้องถูกปฏิเสธ.",
"hc.claimValidated": "การเรียกร้องได้รับการตรวจสอบแล้ว",
"hc.claimValidatedByThePartner": "การเรียกร้องได้รับการตรวจสอบโดยพันธมิตร",
"hc.claimant": "ผู้เรียกร้อง",
"hc.claimsToBeTheOwner": "อ้างว่าเป็นเจ้าของรายการนี้และตอบคำถามการตรวจสอบ ถูกต้องเฉพาะเมื่อคำตอบตรงกัน",
"hc.claimsToValidate": "การเรียกร้องที่ต้องตรวจสอบ",
"hc.clear": "ล้าง",
"hc.clickToZoom": "คลิกเพื่อขยาย",
"hc.close": "ปิด",
"hc.close2": "ปิด",
"hc.closeTheDeclaration": "ปิดการประกาศ",
"hc.closeTheDeclaration2": "ปิดการประกาศ?",
"hc.codeAlreadyVerified": "รหัสได้รับการยืนยันแล้ว",
"hc.codeCopied": "คัดลอกรหัสแล้ว",
"hc.collapse": "ย่อ",
"hc.color": "สี",
"hc.company": "บริษัท",
"hc.companyName": "ชื่อบริษัท",
"hc.comparePhotos": "เปรียบเทียบภาพ",
"hc.compareThemWithTheOwner": "เปรียบเทียบกับคำตอบของเจ้าของ — มองไม่เห็นต่อสาธารณะ.",
"hc.condition": "สภาพ",
"hc.confirmAndPay": "ยืนยันและชำระเงิน",
"hc.confirmCancellation": "ยืนยันการยกเลิก",
"hc.confirmCrop": "ยืนยันการตัดภาพ",
"hc.confirmDeletion": "ยืนยันการลบ",
"hc.confirmPassword": "ยืนยันรหัสผ่าน",
"hc.confirmThatThisIsYour": "ยืนยันว่านี่คือสินค้าของคุณ จะมีการตรวจสอบตัวตนจากผู้ค้นหาก่อนการติดต่อ.",
"hc.confirmTheCarrier": "ยืนยันผู้ส่ง",
"hc.confirmThePassword": "ยืนยันรหัสผ่าน",
"hc.confirmYourShippingAddressTo": "ยืนยันที่อยู่จัดส่งของคุณเพื่อดำเนินการชำระเงินต่อ.",
"hc.confirmYourSubscription": "ยืนยันการสมัครสมาชิกของคุณ",
"hc.confirmed": "ยืนยันแล้ว ✓",
"hc.contactFindoToGetYour": "ติดต่อ Findloop เพื่อรับ ID ผู้ส่งของคุณ.",
"hc.contactUs": "ติดต่อเรา",
"hc.continueTheReturn": "ดำเนินการคืนสินค้าต่อ",
"hc.continueToPayment": "ดำเนินการชำระเงินต่อ",
"hc.copy": "คัดลอก",
"hc.correctMyDetails": "แก้ไขรายละเอียดของฉัน",
"hc.correctThisEntry": "แก้ไขรายการนี้?",
"hc.country": "ประเทศ",
"hc.countryAddress": "ประเทศ (ที่อยู่)",
"hc.countryIsoCodeEG": "ประเทศ (รหัส ISO, เช่น FR)",
"hc.cover": "ปก",
"hc.createTheShipment": "สร้างการจัดส่ง",
"hc.cropThePhoto": "ตัดภาพ",
"hc.customer": "ลูกค้า",
"hc.customerClaimCodeToCheck": "รหัสลูกค้า — เพื่อตรวจสอบที่จุดรับ:",
"hc.customerReasonFmt": "เหตุผลของลูกค้า: \"{reason}\".",
"hc.customerReminderDelay": "ระยะเวลาการเตือนลูกค้า",
"hc.customerWhosePublicListingMatches": "ลูกค้าที่มีรายการสาธารณะตรงกับสินค้านี้ — มองเห็นได้เฉพาะคุณ.",
"hc.d15": "D-15",
"hc.dangerZone": "เขตอันตราย",
"hc.date": "วันที่",
"hc.dateNewest": "วันที่ (ล่าสุด)",
"hc.dateOldest": "วันที่ (เก่าสุด)",
"hc.daysToYearEnd": "{n} วันจนถึงสิ้นปี",
"hc.deadlineAlert": "แจ้งเตือนกำหนดเวลา",
"hc.declarationClosed": "ประกาศปิด ✓",
"hc.declarationNotFound": "ไม่พบประกาศ.",
"hc.declarationNotFound2": "ไม่พบประกาศ",
"hc.declarationTracking": "ติดตามประกาศ",
"hc.defaultCarrier": "ผู้ให้บริการเริ่มต้น",
"hc.defaultCarrierPreselected": "ผู้ให้บริการเริ่มต้นที่เลือกไว้แล้ว — สามารถเปลี่ยนแปลงได้สำหรับการจัดส่งนี้ อัตราที่แท้จริง (Sendcloud + {m}% มาร์จิน).",
"hc.defaultCarrierRemoved": "ผู้ให้บริการเริ่มต้นถูกลบ",
"hc.delayHours": "ล่าช้า (ชั่วโมง)",
"hc.deleteMyAccount": "ลบบัญชีของฉัน",
"hc.deleting": "กำลังลบ…",
"hc.deletingDeactivatesYourAccountLogin": "การลบจะทำให้บัญชีของคุณถูกยกเลิก: การเข้าสู่ระบบถูกบล็อกและข้อมูลจะถูกเก็บรักษาไว้เป็นเวลา 30 วัน คุณจะได้รับอีเมลพร้อมลิงก์ในการเปิดใช้งานใหม่ที่ใช้ได้เป็นเวลา 30 วัน.",
"hc.delivered": "ส่งแล้ว",
"hc.depositAnItem": "ฝากรายการ",
"hc.depositCancelledItemPutBack": "ฝากถูกยกเลิก — รายการถูกนำกลับไปในสต็อก.",
"hc.depositCancelledItemRemovedFrom": "ฝากถูกยกเลิก — รายการถูกลบออกจากทะเบียน.",
"hc.depositedOn": "ฝากเมื่อ",
"hc.describeTheItemBrandColor": "อธิบายรายการ: ยี่ห้อ, สี, ลักษณะเฉพาะ… (ยิ่งคุณให้รายละเอียดมากเท่าไหร่ คุณก็ยิ่งมีโอกาสหาสิ่งของได้ดีขึ้น)",
"hc.dimensionsCm": "ขนาด (ซม.)",
"hc.disablingAnEmail": "การปิดการใช้งานอีเมล",
"hc.doesNotHide": "ไม่ซ่อน",
"hc.download": "ดาวน์โหลด",
"hc.downloadThePdf": "ดาวน์โหลด PDF",
"hc.draftRestoredPickUpYour": "ร่างถูกกู้คืน — รับประกาศของคุณจากจุดที่คุณหยุดไว้.",
"hc.dragToReposition": "ลากเพื่อปรับตำแหน่ง",
"hc.eGColisPriv": "เช่น Colis Privé",
"hc.eachItemGetsAQr": "แต่ละรายการจะได้รับฉลาก QR สแกนจาก \"คลัง & QR\" เพื่อหาสิ่งของในทันที.",
"hc.eachSiteManagesItsOwn": "แต่ละไซต์จัดการการธนาคารของตนเอง ไปที่",
"hc.edit": "แก้ไข",
"hc.emailNotificationPreferences": "การตั้งค่าแจ้งเตือนทางอีเมล",
"hc.emailPreferencesUpdated": "การตั้งค่าอีเมลได้รับการอัปเดต",
"hc.enableOrDisableRecoveryFees": "เปิดหรือปิดค่าธรรมเนียมการกู้คืนสำหรับ",
"hc.enlargePhoto": "ขยายรูปภาพ",
"hc.enterTheCustomerSCode": "กรอกรหัสของลูกค้า",
"hc.estShipRate": "อัตราค่าขนส่งโดยประมาณ (Sendcloud + {m}% ค่าตอบแทน):",
"hc.establishment": "สถานประกอบการ",
"hc.establishment2": "สถานประกอบการ:",
"hc.establishmentInItsSendcloudAccount": "สถานประกอบการในบัญชี Sendcloud ของคุณและให้รหัสผู้ส่ง",
"hc.establishmentSettings": "การตั้งค่าสถานประกอบการ",
"hc.exCode": "เช่น ABCD2345",
"hc.exId": "เช่น 3f2a…",
"hc.exit": "ออก",
"hc.explainWhyThisItemIs": "อธิบายว่าทำไมสินค้านี้ถึงไม่ใช่ของคุณ…",
"hc.externalPaymentLinks": "ลิงก์การชำระเงินภายนอก",
"hc.failed": "ล้มเหลว",
"hc.feesEnabled": "เปิดใช้งานค่าธรรมเนียม",
"hc.field": ") ฟิลด์.",
"hc.finderAcceptedCloseTheCase": "Finder ได้ยอมรับแล้ว — ปิดคดีเมื่อได้ส่งมอบสินค้าเป็นการส่วนตัว.",
"hc.findoCityRanking": "Findloop — การจัดอันดับเมือง",
"hc.findoForEstablishments": "Findloop สำหรับสถานประกอบการ",
"hc.findoPresentationVideo": "วิดีโอเสนอ Findloop",
"hc.findoRegistersTheAddressOf": "Findloop ลงทะเบียนที่อยู่ของคุณ",
"hc.findoReviewShare": "Findloop {year} รีวิว: {n} รายการถูกส่งคืน, {rate}% อัตราการส่งคืน 🎉",
"hc.firstVerifyTheClaimCode": "ตรวจสอบรหัสคำร้องขอในตอนแรก",
"hc.forEveryNewShipmentFrom": "สำหรับทุกการจัดส่งใหม่จาก",
"hc.free": "ฟรี",
"hc.freeRecovery0": "การกู้คืนฟรี (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "การกู้คืนฟรีทั่วแอฟริกา – ข้อเสนอเปิดตัว",
"hc.freeRecoveryFeesDisabled0": "การกู้คืนฟรี: ค่าธรรมเนียมถูกปิดใช้งาน (0 €)",
"hc.fromTeamInviteYourColleagues": "จาก \"ทีม\", เชิญเพื่อนร่วมงานของคุณทางอีเมลและมอบหมายให้พวกเขาเป็นสถานประกอบการ สมาชิกแต่ละคนจะเห็นขอบเขตของตนเองเท่านั้น.",
"hc.fullName": "ชื่อเต็ม",
"hc.fullPhoto": "รูปถ่ายเต็ม",
"hc.gallery": "แกลเลอรี",
"hc.giveTheReasonForCancelling": "ให้เหตุผลในการยกเลิก โดยพันธมิตรจะได้รับข้อมูล.",
"hc.goToLogin": "ไปที่หน้าเข้าสู่ระบบ",
"hc.goToMyAccount": "ไปที่บัญชีของฉัน",
"hc.gold": "ทอง",
"hc.googleLoginFailed": "การลงชื่อเข้าสู่ระบบ Google ล้มเหลว",
"hc.hasConfirmedYourPaymentYou": "ได้ยืนยันการชำระเงินของคุณแล้ว, คุณจะถูกนำทางโดยอัตโนมัติ",
"hc.helpCenter": "ศูนย์ช่วยเหลือ",
"hc.helpUsImproveWhyAre": "ช่วยเราให้ดีขึ้น: ทำไมคุณถึงออกจากระบบ? บัญชีของคุณจะถูกปิดใช้งานและสามารถเปิดใช้งานใหม่ได้ภายใน 30 วัน.",
"hc.hidePassword": "ซ่อนรหัสผ่าน",
"hc.high": "สูง",
"hc.historyOfYourMonthlySubscriptions": "ประวัติการสมัครสมาชิกรายเดือนของคุณและสถานะการชำระเงินของพวกเขา.",
"hc.hotelBelmont": "โรงแรมเบลมอนต์",
"hc.howConfigureSenderId": "ฉันจะตั้งค่า Sender ID หมายเลขของฉันได้อย่างไร?",
"hc.iDonTUseIt": "ฉันไม่ค่อยได้ใช้มัน",
"hc.iFoundItElsewhere": "ฉันพบมันที่อื่น",
"hc.iNoLongerNeedMy": "ฉันไม่ต้องการของฉันอีกต่อไป",
"hc.identityVerification": "การยืนยันตัวตน",
"hc.idleLogoutIn": "คุณจะถูกออกจากระบบใน {n} วินาที เนื่องจากไม่มีการใช้งาน.",
"hc.ifProvidedTheVolumetricWeight": "ถ้ามีการแจ้งน้ำหนักตามขนาด จะใช้ค่านี้.",
"hc.ifThePartnerHasNot": "ถ้าผู้ร่วมงานยังไม่ได้ยืนยันการรับการชำระเงินภายนอกหลังจากเวลานี้ Findloop จะเตือนผู้ร่วมงานให้อยู่ในการยืนยัน.",
"hc.impersonationEnded": "การแสดงตัวตนสิ้นสุดลง.",
"hc.impersonationMode": "โหมดการแสดงตัวตน",
"hc.impersonationSessionExpired": "เซสชันการแสดงตัวตนหมดอายุ.",
"hc.inTheField": ", ในสาขา",
"hc.inTransit": "อยู่ระหว่างการขนส่ง",
"hc.inclVat": "รวม VAT",
"hc.intraEuVatNumberOptional": "หมายเลข VAT ในสหภาพยุโรปเป็นทางเลือก, ไม่ต้องการ SIRET (นอกฝรั่งเศส).",
"hc.invalidInvitationLink": "ลิงก์เชิญไม่ถูกต้อง.",
"hc.invalidInvitationLink2": "ลิงก์เชิญไม่ถูกต้อง",
"hc.invalidInviteLink": "ลิงก์เชิญไม่ถูกต้องหรือหมดอายุ.",
"hc.invalidNumberEnterAnInternational": "หมายเลขไม่ถูกต้อง. กรุณากรอกหมายเลขนานาชาติ เช่น +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "ลิงก์ไม่ถูกต้องหรือหมดอายุ.",
"hc.invalidOrExpiredReactivationLink": "ลิงก์สำหรับเปิดใช้งานซ้ำไม่ถูกต้องหรือหมดอายุ",
"hc.invalidSendcloudId": "หมายเลข Sendcloud ไม่ถูกต้อง",
"hc.inviteSubtitle": "{org} เชิญคุณเข้าร่วมทีม Findloop ของพวกเขา เลือกบัญชีของคุณเพื่อเปิดใช้งานบัญชีของคุณ.",
"hc.isAvailableOnSendcloudFor": "มีให้ใช้ใน Sendcloud สำหรับทุกเส้นทางของคุณ (ในประเทศ + ต่างประเทศ).",
"hc.isNotEnabledOnYour": "ไม่ได้เปิดใช้งานในบัญชี Sendcloud ของคุณสำหรับบางจุดหมายปลายทาง. แท็กสำหรับจุดหมายปลายทางเหล่านั้นจะถูกสร้างโดยผู้ให้บริการอื่นที่มีอยู่.",
"hc.isThisReallyYourItem": "นี่คือของคุณจริงๆ หรือ?",
"hc.isThisYourItem": "นี่คือของคุณใช่ไหม?",
"hc.item": "รายการ",
"hc.itemAlreadyConfirmed": "รายการได้รับการยืนยันแล้ว",
"hc.itemDetails": "รายละเอียดรายการ",
"hc.itemFoundAt": "พบรายการที่",
"hc.itemFoundAtAPartner": "พบรายการที่คู่ค้า",
"hc.itemMarkedAsReturned": "รายการถูกทำเครื่องหมายเป็นส่งคืน ✓",
"hc.itemPhotoRequiredBeforeShipping": "รูปภาพของรายการ (จำเป็นก่อนการจัดส่ง)",
"hc.itemPhotoSaved": "รูปภาพของรายการถูกบันทึก",
"hc.itemPreview": "ตัวอย่างรายการ",
"hc.itemPutBackInStorage": "รายการกลับไปยังที่จัดเก็บ.",
"hc.itemWeight": "น้ำหนักของรายการ:",
"hc.itemsReturned": "รายการที่ส่งคืน",
"hc.itemsReturnedThisYear": "สินค้าที่คืนในปีนี้",
"hc.itemsWhoseLegalDeadlineIs": "สินค้าที่มีเส้นตายทางกฎหมายภายใน 15 วัน หรือไม่เกิน (รวมถึงสินค้าที่ล่าช้า)",
"hc.kbisNumber": "หมายเลข Kbis",
"hc.keysForgottenOnABench": "กุญแจที่ลืมไว้บนม้านั่ง",
"hc.labelBeingGenerated": "กำลังสร้างป้าย",
"hc.leaveTheFieldsEmptyTo": "เว้นช่องว่างเพื่อเสนอการกู้คืนฟรี",
"hc.legalNotice": "คำชี้แจงทางกฎหมาย",
"hc.limitReachedUpgradeToA": "ถึงขีด จำกัด — กรุณาอัปเกรดเป็นแผนที่สูงขึ้น",
"hc.linkCopiedShareOn": "ลิงก์ถูกคัดลอก — แชร์บน {label}",
"hc.linkUnavailable": "ลิงก์ไม่สามารถใช้งานได้",
"hc.linkedTo": "เชื่อมโยงกับ",
"hc.listingHiddenByModeration": "รายการที่ถูกซ่อนโดยการตรวจสอบ",
"hc.loading": "กำลังโหลด…",
"hc.locateMe": "หาตำแหน่งฉัน",
"hc.logIn": "เข้าสู่ระบบ",
"hc.logInToGetBack": "เข้าสู่ระบบเพื่อกลับไปยังพื้นที่ของคุณและจัดการการสมัครสมาชิก",
"hc.loginFailed": "เข้าสู่ระบบล้มเหลว",
"hc.lostFoundPlatform": "แพลตฟอร์มของที่สูญหายและพบ",
"hc.lostIn": "สูญหายใน",
"hc.lowRate": "อัตราต่ำ",
"hc.mainReason": "เหตุผลหลัก",
"hc.mainStreet": "ถนนหลัก",
"hc.makeSureThisIsThe": "โปรดยืนยันว่านี่คือสินค้าที่คุณสูญเสียก่อนที่จะปลดล็อกข้อมูลติดต่อของผู้ค้นพบ",
"hc.manageCookies": "จัดการคุกกี้",
"hc.manageMyTeam": "จัดการทีมของฉัน",
"hc.manageYourTeam": "จัดการทีมของคุณ",
"hc.markAsReturned": "ทำเครื่องหมายว่าได้คืนแล้ว",
"hc.matchNoClaimInTime": "การแข่งขันไม่มีการเรียกร้องภายในกำหนดเวลา",
"hc.matchNotFound": "ไม่พบการแข่งขัน",
"hc.medium": "กลาง",
"hc.milestoneFmt": "{m} บรรลุเป้าหมายการคืนสินค้า! กำลังไปถึง {next}",
"hc.missingFeatures": "ฟีเจอร์ที่หายไป",
"hc.monthly": "รายเดือน",
"hc.monthlyBilling": "การเรียกเก็บเงินรายเดือน",
"hc.moveThePhotoToFit": "เลื่อนรูปภาพให้พอดีกับวงกลม",
"hc.myAccount": "บัญชีของฉัน",
"hc.myInvoices": "ใบแจ้งหนี้ของฉัน",
"hc.myMonthlyInvoices": "ใบแจ้งหนี้รายเดือนของฉัน",
"hc.nArchived": "{n} รายการที่ถูกเก็บไว้.",
"hc.newCodeGeneratedAndSent": "รหัสใหม่ถูกสร้างและส่งไปยังลูกค้าทางอีเมลและ SMS",
"hc.newCodeGeneratedAndSent2": "รหัสใหม่ถูกสร้างและส่งไปยังเจ้าของ",
"hc.newPassword": "รหัสผ่านใหม่",
"hc.next": "ถัดไป",
"hc.nextPhoto": "รูปถัดไป",
"hc.no": "ไม่",
"hc.noAnswerProvided": "ไม่มีการตอบกลับ.",
"hc.noArchivedDeclarations": "ไม่มีการประกาศที่ถูกเก็บไว้",
"hc.noCountryFound": "ไม่มีประเทศที่พบ",
"hc.noDeclarations": "ไม่มีการประกาศ",
"hc.noFeesAreChargedTo": "ไม่มีค่าธรรมเนียมที่เรียกเก็บจากลูกค้า.",
"hc.noInvoiceYet": "ยังไม่มีใบแจ้งหนี้.",
"hc.noInvoiceYetYourInvoices": "ยังไม่มีใบแจ้งหนี้ ใบแจ้งหนี้ของคุณจะปรากฏที่นี่โดยอัตโนมัติหลังจากการชำระเงินแต่ละครั้ง.",
"hc.noMatchIsAvailableFor": "ไม่มีการจับคู่ในขณะนี้ เราจะแจ้งให้คุณทราบเมื่อมีรายการตรงกับการประกาศของคุณ.",
"hc.noShipmentMatchesYourSearch": "ไม่มีการจัดส่งที่ตรงกับการค้นหาของคุณ.",
"hc.noShipmentsYet": "ยังไม่มีการจัดส่ง.",
"hc.noShipmentsYet2": "ยังไม่มีการจัดส่ง",
"hc.none": "ไม่มี",
"hc.noneChooseForEachShipment": "ไม่มี (เลือกสำหรับแต่ละการจัดส่ง)",
"hc.notMine": "มันไม่ใช่ของฉัน",
"hc.of": "ของ",
"hc.only": "เฉพาะ",
"hc.onlyEachSiteManagesIts": "เท่านั้น แต่ละไซต์จัดการบัญชีธนาคารของตนเอง: ลิงก์เหล่านี้ไม่มีผลกระทบต่อสถานประกอบการอื่น.",
"hc.onlyTheOwnerOrAn": "เฉพาะเจ้าของหรือผู้ดูแลระบบเท่านั้นที่สามารถกำหนดค่า ลิงก์การชำระเงินของสถานประกอบการ.",
"hc.openDepositInTheMenu": "เปิด \"ฝากเงิน\" ในเมนู อธิบายรายการและถ่ายภาพ มันจะถูกจัดเก็บทันทีและพร้อมที่จะส่งกลับ.",
"hc.openSettings": "เปิดการตั้งค่า →",
"hc.openTheDeclarationToManage": "เปิดการประกาศเพื่อจัดการการจัดส่ง",
"hc.optional": "— ตัวเลือก",
"hc.optional2": "(ตัวเลือก)",
"hc.optional3": "ตัวเลือก",
"hc.originalListingPhotoUsed": "ใช้ภาพรายการดั้งเดิม",
"hc.other": "อื่นๆ",
"hc.other2": "อื่นๆ…",
"hc.ourProducts": "ผลิตภัณฑ์ของเรา",
"hc.overallRateTrendLast6": "แนวโน้มอัตราทั้งหมด (6 เดือนที่ผ่านมา)",
"hc.ownerSClaimCode": "รหัสเรียกร้องของเจ้าของ",
"hc.ownershipConfirmed": "การเป็นเจ้าของได้รับการยืนยัน",
"hc.paid": "ชำระเงินแล้ว",
"hc.paidOn": "ชำระเงินเมื่อ",
"hc.paidViaPartner": "ชำระเงิน (ผ่านพันธมิตร)",
"hc.parcelBeingPrepared": "กำลังเตรียมพัสดุ",
"hc.parcelDelivered": "พัสดุถูกจัดส่งแล้ว",
"hc.parcelShipped": "พัสดุถูกส่งออก",
"hc.parisGareDeLyon": "ปารีส, Gare de Lyon…",
"hc.partner": "พันธมิตร",
"hc.partner2": "พันธมิตร",
"hc.partnerDirectory": "ไดเรกทอรีพันธมิตร",
"hc.passedOnToTheCustomer": "— ส่งต่อไปยังลูกค้าลิงก์การชำระเงิน.",
"hc.password": "รหัสผ่าน",
"hc.passwordResetPleaseLogIn": "ตั้งค่ารหัสผ่านใหม่, กรุณาล็อกอิน.",
"hc.passwordUpdated": "อัปเดตรหัสผ่านเรียบร้อย.",
"hc.passwordsDoNotMatch": "รหัสผ่านไม่ตรงกัน.",
"hc.pasteThisSenderIdIn": "วาง Sender ID นี้ใน Findloop → การตั้งค่า",
"hc.payForTheShipmentOf": "ชำระเงินสำหรับการจัดส่งสินค้าของคุณผ่าน Findloop ด้วยการชำระเงินที่ปลอดภัย.",
"hc.payTheRecoveryFees": "ชำระค่าธรรมเนียมการกู้คืน",
"hc.payTheShippingFees": "ชำระค่าธรรมเนียมการจัดส่ง",
"hc.payment": "การชำระเงิน",
"hc.paymentAlreadyConfirmedByThe": "การชำระเงินได้รับการยืนยันแล้วโดยพันธมิตร",
"hc.paymentLinksAreNowConfigured": "ลิงก์การชำระเงินถูกตั้งค่าแล้วตามสถานประกอบการ",
"hc.paymentNotCompletedYourAccount": "การชำระเงินไม่สมบูรณ์, บัญชีของคุณยังไม่ได้สร้าง — กรุณาลองอีกครั้ง.",
"hc.paymentReceived": "การชำระเงินได้ถูกรับแล้ว",
"hc.paymentSuccessful": "การชำระเงินสำเร็จ!",
"hc.pdfInvoice": "ใบแจ้งหนี้ PDF",
"hc.pending": "รอดำเนินการ",
"hc.period": "ระยะเวลา",
"hc.phoneNumber": "หมายเลขโทรศัพท์",
"hc.phoneOptional": "โทรศัพท์ (เลือกได้)",
"hc.planAt": "แผนที่",
"hc.planLimitFmt": "แผน \"{plan}\" ของคุณจำกัดอยู่ที่ {max} สถานประกอบการ. เพื่อจัดการ {n} ไซต์, เราขอแนะนำ",
"hc.platformReturnTarget": "เป้าหมายการกลับคืนแพลตฟอร์ม",
"hc.pleaseCompleteYourShippingAddress": "กรุณากรอกที่อยู่จัดส่งของคุณให้ครบถ้วน.",
"hc.pleaseProvideAPhoneNumber": "กรุณาให้หมายเลขโทรศัพท์: จำเป็นต้องใช้โดยผู้ขนส่งสำหรับการจัดส่ง.",
"hc.pleaseProvideAReason": "กรุณาให้เหตุผล.",
"hc.pleaseSetYourOwnPassword": "กรุณากำหนดรหัสผ่านของคุณเองก่อนดำเนินการต่อ.",
"hc.pointsToGoal": "{n} คะแนนอีกมากมายเพื่อไปถึงเป้าหมายร่วมกันของเรา.",
"hc.posterPreview": "ตัวอย่างโปสเตอร์",
"hc.potentialMatchBeingVerified": "การจับคู่ที่เป็นไปได้กำลังถูกตรวจสอบ",
"hc.potentialOwner": "เจ้าของที่เป็นไปได้",
"hc.preFilledAutomaticallyYouCan": "กรอกอัตโนมัติ — คุณสามารถเปลี่ยนด้วยภาพของพัสดุ.",
"hc.pressKit": "ชุดสื่อสารมวลชน",
"hc.previewMode": "โหมดพรีวิว:",
"hc.previewOfThePrintReady": "พรีวิวโปสเตอร์ A4 ที่พร้อมพิมพ์สำหรับสถานประกอบการนี้.",
"hc.previous": "ก่อนหน้า",
"hc.previousPhoto": "รูปภาพก่อนหน้า",
"hc.primary": "หลัก",
"hc.printThePoster": "พิมพ์โปสเตอร์",
"hc.privacy": "ความเป็นส่วนตัว",
"hc.privacyPolicy": "นโยบายความเป็นส่วนตัว",
"hc.processedCasesWillAppearHere": "กรณีที่ประมวลผลแล้วจะปรากฏที่นี่.",
"hc.proofOfReturnPdf": "หลักฐานการส่งคืน (PDF)",
"hc.protectedByRecaptcha": "ป้องกันโดย reCAPTCHA",
"hc.publicMatch": "การแข่งขันสาธารณะ",
"hc.putBackInStorage": "นำกลับไปเก็บ",
"hc.pwdResetByTeam": "รหัสผ่านของคุณถูกรีเซ็ตโดยทีมงานของเรา เพื่อความปลอดภัยของคุณ,",
"hc.questionsToAskTheOwner": "คำถามที่ควรถามเจ้าของ",
"hc.rateChargedToTheCustomer": "อัตราที่เรียกเก็บจากลูกค้า:",
"hc.rateOfTarget": "{rate}% ที่บรรลุจากเป้าหมาย {target}%",
"hc.reached": "ถึง",
"hc.reactivating": "กำลังเปิดใช้งานใหม่…",
"hc.reasonSavedYouCanStill": "เหตุผลที่บันทึก คุณยังสามารถเรียกร้องไอเทมของคุณได้.",
"hc.recentMatchesFirst": "การแข่งขันล่าสุดก่อน",
"hc.recognizedThePhotoYouSent": "ระบุตัวตนรูปภาพที่คุณส่งและระบุคุณลักษณะเหล่านี้. โปรดยืนยันเฉพาะเมื่อพวกเขาตรงกับรายการในความครอบครองของคุณ.",
"hc.recommended": "แนะนำ",
"hc.recoveryFees": "ค่าธรรมเนียมการกู้คืน",
"hc.recoveryFeesArePaidDirectly": "ค่าธรรมเนียมการกู้คืนจะต้องชำระโดยตรงให้กับสถานประกอบการที่เป็นพันธมิตร Findloop จะไม่ได้รับค่าตอบแทนจากลูกค้า.",
"hc.recoveryFeesEnabled": "เปิดใช้งานค่าธรรมเนียมการกู้คืน",
"hc.recoveryOfferedByTheEstablishment": "การกู้คืนที่เสนอโดยสถานประกอบการ — Findloop ไม่เรียกเก็บค่าธรรมเนียม.",
"hc.recoveryPaymentLink": "ลิงค์การชำระเงินเพื่อการกู้คืน",
"hc.recoveryPaymentLinkSavedFor": "ลิงค์การชำระเงินเพื่อการกู้คืนถูกบันทึกสำหรับสถานประกอบการนี้",
"hc.redirecting": "กำลังเปลี่ยนเส้นทาง…",
"hc.redirectingToPayment": "กำลังเปลี่ยนเส้นทางไปยังการชำระเงิน…",
"hc.redirectingToTheRecoveryOf": "กำลังเปลี่ยนเส้นทางไปยังการกู้คืนของไอเทมของคุณ…",
"hc.regenerateAndResendToThe": "สร้างใหม่และส่งให้เจ้าของ",
"hc.regenerateTheCode": "สร้างรหัสใหม่",
"hc.registerAFoundItem": "ลงทะเบียนรายการที่พบ",
"hc.rejectTheClaim": "ปฏิเสธการเรียกร้อง",
"hc.reminderDelaySaved": "การหน่วงเวลาการเตือนถูกบันทึก",
"hc.reopenThePaymentLink": "เปิดลิงค์การชำระเงินอีกครั้ง",
"hc.repeatThePassword": "พิมพ์รหัสผ่านอีกครั้ง",
"hc.reportAProblem": "รายงานปัญหา",
"hc.reportDismissedYourListingRemains": "รายงานถูกปฏิเสธ รายชื่อของคุณยังคงเผยแพร่ต่อสาธารณะ",
"hc.requiredUsedToCalculateThe": "จำเป็น: ใช้ในการคำนวณอัตราค่าขนส่ง Sendcloud การขนส่งไม่พร้อมใช้งานเกิน 30 กก.",
"hc.reset": "รีเซ็ต",
"hc.resume": "ดำเนินการต่อ",
"hc.resumeRegistration": "ดำเนินการลงทะเบียนต่อ",
"hc.retro": "ปีที่ผ่านมาจำได้",
"hc.returnSecurity": "ความปลอดภัยในการคืนสินค้า",
"hc.returnToTheOwner": "คืนให้เจ้าของ",
"hc.returned": "คืนแล้ว",
"hc.reviewTheItemDetails": "ตรวจสอบรายละเอียดสินค้า",
"hc.revokeAccess": "เพิกถอนการเข้าถึง",
"hc.role": "บทบาท:",
"hc.save": "บันทึก",
"hc.save2": "บันทึก",
"hc.saveAndContinue": "บันทึกและดำเนินการต่อ",
"hc.saving": "กำลังบันทึก…",
"hc.scanTheClaimCode": "สแกนรหัสการเรียกร้อง",
"hc.scanTheOwnerSQr": "สแกน QR ของเจ้าของ",
"hc.scrollThroughLanguages": "เลื่อนผ่านภาษา",
"hc.searchByCustomerItemOr": "ค้นหาจากลูกค้า สินค้า หรือหมายเลขติดตาม…",
"hc.searchForACountry": "ค้นหาประเทศ…",
"hc.secureFindoVerification": "การตรวจสอบ Findloop อย่างปลอดภัย",
"hc.seeRetro": "ดูปีที่ผ่านมา",
"hc.selectedCarrier": "ผู้ให้บริการที่เลือก:",
"hc.selectedPlan": "แผนที่เลือก",
"hc.send": "ส่ง",
"hc.sendcloudSenderIdSaved": "บันทึก ID ผู้ส่ง Sendcloud",
"hc.sendcloudSenderIdSenderId": "ID ผู้ส่ง Sendcloud (sender_id)",
"hc.sending": "กำลังส่ง…",
"hc.sessionExpired": "หมดอายุเซสชัน",
"hc.setUpYourEstablishments": "ตั้งค่าองค์กรของคุณ",
"hc.settings": "การตั้งค่า",
"hc.settingsSubtitle": "การชำระเงินและการแจ้งเตือนภายนอก ตั้งค่าตามแต่ละองค์กร",
"hc.shareFoundText": "ฉันพบสินค้าชิ้นหนึ่ง — ช่วยฉันหาผู้เป็นเจ้าของบน Findloop",
"hc.shareLostText": "ฉันทำของหาย — ช่วยฉันหามันบน Findloop",
"hc.sharePreview": "แชร์พรีวิว",
"hc.shareTheRanking": "แชร์อันดับ",
"hc.shareYourQrCodeTo": "แชร์ QR code ของคุณเพื่อรับการประกาศ.",
"hc.shipRateAutoWeight": "อัตราค่าจัดส่งจะถูกคำนวณโดยอัตโนมัติผ่าน Sendcloud (น้ำหนัก {w}) ในขณะจัดส่ง.",
"hc.targetReached": "ถึงเป้าหมายแล้ว",
"hc.targetReachedThankYouTo": "ถึงเป้าหมายแล้ว — ขอบคุณชุมชน Findloop ทั้งหมด!",
"hc.tellUsMore": "บอกเรามากกว่านี้…",
"hc.tellUsWhyYouCancel": "บอกเราว่าทำไมคุณถึงยกเลิก นี่จะช่วยให้พันธมิตรดำเนินการคำขอของคุณ",
"hc.tellUsWhyYourListing": "บอกเราว่าทำไม รายการของคุณยังคงเปิดอยู่และคุณยังสามารถเรียกร้องไอเทมของคุณได้",
"hc.termsAndConditions": "ข้อกำหนดและเงื่อนไข",
"hc.termsAndPolicies": "ข้อกำหนดและนโยบาย",
"hc.thankYouForYourFeedback": "ขอบคุณสำหรับข้อเสนอแนะแต่",
"hc.theBannerDisplayedInThe": "แบนเนอร์ที่แสดงในทะเบียน",
"hc.theClaimantHasBeenInformed": "ผู้เรียกร้องได้รับข้อมูลแล้ว ไอเทมยังคงมีในรายการสาธารณะ",
"hc.theClaimantHasBeenNotified": "ผู้เรียกร้องได้รับการแจ้งเตือนและสามารถดำเนินการคืนสินค้าได้",
"hc.theCustomerPaysTheFees": "ลูกค้าจะชำระค่าธรรมเนียมให้กับสถานประกอบการ",
"hc.theDayTheLegalRetention": "วันที่ครบกำหนดเก็บรักษาตามกฎหมาย",
"hc.theEstablishmentConsideredThatThis": "สถานประกอบการพิจารณาว่าไอเทมนี้ไม่ใช่ของคุณ",
"hc.theEstablishmentIsReviewingYour": "สถานประกอบการกำลังตรวจสอบคำตอบของคุณ คุณจะได้รับการแจ้งเตือนทันทีที่คำร้องของคุณได้รับการตรวจสอบแล้ว จากนั้นคุณสามารถชำระค่าธรรมเนียมการกู้คืนได้",
"hc.theFeesAreTooHigh": "ค่าธรรมเนียมสูงเกินไป",
"hc.theFinderConsideredThatThis": "ผู้ค้นหาพิจารณาว่าไอเทมนี้ไม่ใช่ของคุณ",
"hc.theFinderIsReviewingYour": "ผู้ค้นกำลังตรวจสอบคำร้องของคุณ คุณจะได้รับการแจ้งเตือนทันทีที่มันได้รับการตรวจสอบ",
"hc.theItem": "ไอเทม",
"hc.theItemWillBeRemoved": "ไอเทมจะถูกลบออกจากทะเบียน (ไม่มีการเรียกร้องในระหว่างดำเนินการ)",
"hc.theItemWillBeSet": "ไอเทมจะถูกตั้งกลับไปที่ \"พร้อมขาย\" และการเรียกร้องที่เกี่ยวข้องจะถูกยกเลิก",
"hc.theKbisNumberAndVat": "หมายเลข Kbis และหมายเลข VAT เป็นสิ่งจำเป็นสำหรับฝรั่งเศส",
"hc.theLabelIsGeneratedAutomatically": "ฉลากจะถูกสร้างขึ้นโดยอัตโนมัติทันทีที่ลูกค้าชำระค่าธรรมเนียมการส่งสินค้า มันจะสามารถดาวน์โหลดได้ที่นี่",
"hc.theLinkMayHaveExpired": "ลิงก์อาจหมดอายุ (ใช้ได้ 30 วัน) ติดต่อฝ่ายสนับสนุน Findloop หากจำเป็น",
"hc.theOwnerDescribesTheirItem": "เจ้าของอธิบายไอเทมของพวกเขา",
"hc.theOwnerReceivedItBy": "เจ้าของได้รับทางอีเมล (หรือ SMS) กรุณาใส่หรือสแกนก่อนการส่งมอบ",
"hc.thePartnerConsideredThatThis": "พันธมิตรพิจารณาว่าไอเทมนี้ไม่ใช่ของคุณ ไอเทมยังคงเปิดให้บริการ",
"hc.thePartnerIsReviewingYour": "พันธมิตรกำลังตรวจสอบคำตอบของคุณ คุณจะได้รับการแจ้งเตือนทันทีที่คำร้องของคุณได้รับการตรวจสอบ",
"hc.theShipmentIsCreatedAutomatically": "การจัดส่งจะถูกสร้างขึ้นโดยอัตโนมัติเมื่อผู้ใช้ยืนยันที่อยู่และชำระค่าธรรมเนียมการกู้คืน จากนั้นจะสร้างฉลากโดยอัตโนมัติหลังการชำระเงินค่าขนส่ง และสามารถดาวน์โหลดได้ที่นี่",
"hc.theShippingRateWillBe": "อัตราค่าขนส่งจะถูกคำนวณโดยอัตโนมัติผ่าน Sendcloud ในขณะจัดส่ง (น้ำหนักที่บันทึกไว้)",
"hc.thisCarrierWillBe": "ผู้ให้บริการนี้จะเป็น",
"hc.thisEstablishment": "สถานประกอบการนี้",
"hc.thisFieldIsRequiredFor": "ฟิลด์นี้จำเป็นสำหรับการสร้างฉลากอัตโนมัติ",
"hc.thisIsMyItem": "นี่คือไอเทมของฉัน",
"hc.thisIsMyItemContinue": "นี่คือไอเทมของฉัน — ดำเนินการต่อ",
"hc.thisIsMyItemStart": "นี่คือไอเทมของฉัน — เริ่มการคืน",
"hc.thisIsNotMyItem": "นี่ไม่ใช่ไอเทมของฉัน",
"hc.thisMatchIsNoLonger": "การจับคู่นี้ไม่มีอยู่แล้วหรือได้ถูกดำเนินการไปแล้ว",
"hc.thisRateWillBeCharged": "อัตรานี้จะถูกเรียกเก็บจากลูกค้า อัตราที่สูงอาจทำให้การกู้คืนถูกยับยั้ง",
"hc.thisStepIsRequiredFor": "ขั้นตอนนี้จำเป็นสำหรับการสร้างฉลากการจัดส่ง",
"hc.shipRateForWeight": "อัตราค่าขนส่ง (Sendcloud + {m}% มาร์จิ้น) สำหรับ {w}:",
"hc.shipments": "การจัดส่ง",
"hc.shipmentsSubtitle": "มุมมองรวมของการจัดส่งทั้งหมดของสถานประกอบการในทุกกรณี คลิกที่แถวเพื่อจัดการการจัดส่งในคำประกาศของคุณ.",
"hc.shipping": "การจัดส่ง",
"hc.shippingAddress": "ที่อยู่จัดส่ง",
"hc.shippingFeesAreHandledAutomatically": "ค่าขนส่งถูกจัดการโดยอัตโนมัติจาก Findloop (Sendcloud) — ไม่มีลิงก์ให้กรอก.",
"hc.shippingFeesHaveAlreadyBeen": "ค่าขนส่งได้ถูกชำระแล้ว: ผู้ให้บริการไม่สามารถเปลี่ยนแปลงได้อีก.",
"hc.shippingNotAvailableForItems": "ไม่สามารถจัดส่งสินค้าเกิน 30 กิโลกรัมได้ ลูกค้าจะต้องมารับสินค้าด้วยตนเอง.",
"hc.shippingPaid": "ค่าขนส่งจ่ายแล้ว ✓",
"hc.showOnlyItemsMatchingA": "แสดงเฉพาะรายการที่ตรงกับรายการสาธารณะ (ลูกค้า)",
"hc.showPassword": "แสดงรหัสผ่าน",
"hc.signInTheBoxAbove": "เข้าสู่ระบบที่กล่องด้านบน",
"hc.signatureSaved": "ลงชื่อบันทึกไว้",
"hc.signedInWithGoogle": "เข้าสู่ระบบด้วย Google",
"hc.signupFailed": "การลงทะเบียนล้มเหลว",
"hc.silver": "เงิน",
"hc.simulatedRatesInPreProduction": "(อัตราที่จำลองในระหว่างการผลิต)",
"hc.siretAndVatNumberRequired": "ต้องระบุ SIRET และหมายเลข VAT (ฝรั่งเศส).",
"hc.skip": "ข้าม",
"hc.smsSentIfAccount": "หากมีบัญชีที่มีหมายเลขนี้ SMS จะถูกส่งให้คุณ.",
"hc.sortItemsWithAPublic": "เรียง: รายการที่มีการจับคู่สาธารณะ (ใหม่ที่สุด) ก่อน",
"hc.specifyWhetherYouRecoveredYour": "ระบุว่าคุณได้กู้คืนสินค้าของคุณหรือเพียงแค่ต้องการลบบันทึกนี้.",
"hc.specifyYourReason": "ระบุเหตุผลของคุณ",
"hc.specifyYourReason2": "ระบุเหตุผลของคุณ…",
"hc.staff": "พนักงาน",
"hc.status": "สถานะ",
"hc.staySignedIn": "อยู่ในระบบ",
"hc.step": "ขั้นตอน",
"hc.stillThere": "ยังอยู่ไหม?",
"hc.stopScrolling": "หยุดเลื่อน",
"hc.storeFindWithQr": "เก็บและค้นหาด้วย QR",
"hc.streetName": "ชื่อถนน",
"hc.streetNo": "หมายเลขถนน",
"hc.switchTo": "เปลี่ยนไปที่",
"hc.switchToDarkMode": "เปลี่ยนเป็นโหมดมืด",
"hc.switchToLightMode": "เปลี่ยนเป็นโหมดสว่าง",
"hc.takeAPhoto": "ถ่ายภาพ",
"hc.takeChangeThePhoto": "ถ่าย / เปลี่ยนภาพ",
"hc.takenFromYourDeclaration": "ที่ถูกดึงมาจากคำประกาศของคุณ",
"hc.target": "เป้าหมาย",
"hc.thisValidationLinkIsInvalid": "ลิงก์การตรวจสอบนี้ไม่ถูกต้องหรือหมดอายุแล้ว",
"hc.toCheckBeforeMarkingThe": "ตรวจสอบก่อนทำเครื่องหมายรายการว่าเป็นสินค้าที่คืนแล้ว",
"hc.toConfigureTheLinksAnd": "เพื่อกำหนดลิงก์และระยะเวลาสำหรับแต่ละสถานที่",
"hc.toReachOurFirstMilestone": "เพื่อไปถึงเป้าหมายแรกของเราคือการคืน 100 รายการ",
"hc.toTheCustomer": "ถึงลูกค้า",
"hc.toTheShippingFeePayment": "ถึงการชำระค่าจัดส่ง",
"hc.toYourRecoveryTracking": "ถึงการติดตามการคืนของคุณ",
"hc.tooExpensiveBudget": "แพงเกินไป / งบประมาณ",
"hc.topCitiesForReturns": "เมืองยอดนิยมสำหรับการคืนสินค้า",
"hc.trackMyRecovery": "ติดตามการคืนของฉัน",
"hc.trackTheShipmentAndDownload": "ติดตามการจัดส่งและดาวน์โหลดฉลาก (สร้างอัตโนมัติ) โดยไม่ออกจากแท็บการประกาศ",
"hc.trackYourStatistics": "ติดตามสถิติของคุณ",
"hc.tracking": "ติดตาม",
"hc.unableToOpenTheShipping": "ไม่สามารถเปิดการชำระค่าจัดส่งได้ โปรดลองอีกครั้ง",
"hc.unableToRetrieveTheInvoice": "ไม่สามารถดึงใบแจ้งหนี้ได้",
"hc.unclaimed": "ยังไม่ได้เรียกร้อง",
"hc.unclaimedCustomerReason": "รายการยังไม่ได้เรียกร้อง เหตุผลของลูกค้า: \"{reason}\"",
"hc.unclaimedItem": "รายการยังไม่ได้เรียกร้อง",
"hc.unclaimedItemNoClaimWithin": "รายการยังไม่ได้เรียกร้อง — ไม่มีการเรียกร้องภายในกำหนดเวลา",
"hc.unclaimedItems": "รายการยังไม่ได้เรียกร้อง",
"hc.unclaimedItemsMatchLeftWithout": "รายการยังไม่ได้เรียกร้อง: แมตช์ที่เหลือโดยไม่มีการเรียกร้องภายในกำหนดเวลา คุณสามารถเก็บกลับไปในคลังสินค้า",
"hc.unlockTheFinderSContact": "ปลดล็อกข้อมูลการติดต่อของผู้ค้นหาเพื่อดำเนินการส่งมอบ",
"hc.upcoming": "ที่จะมาถึง",
"hc.updateFailed": "การอัปเดตล้มเหลว",
"hc.usedForInvoices": "ใช้ในการออกใบแจ้งหนี้ Findloop ของคุณ",
"hc.vatNumber": "หมายเลข VAT",
"hc.verificationPending": "รอการตรวจสอบ",
"hc.verificationSentToTheFinder": "การตรวจสอบถูกส่งไปยังผู้ค้นหา คุณจะได้รับการแจ้งเตือนเกี่ยวกับการตัดสินใจของพวกเขา",
"hc.verificationSentToThePartner": "การตรวจสอบถูกส่งไปยังคู่ค้า คุณจะได้รับการแจ้งเตือนเกี่ยวกับการตัดสินใจของพวกเขา",
"hc.verify": "ตรวจสอบ",
"hc.verifyingInvite": "กำลังตรวจสอบลิงก์คำเชิญ…",
"hc.verifyingTheLink": "กำลังตรวจสอบลิงก์…",
"hc.viewInRegistry": "ดูในทะเบียน",
"hc.viewItem": "ดูรายการ",
"hc.viewItemRecover": "ดูรายการ & คืน",
"hc.visibleToTheOwnerAutomatically": "มองเห็นได้โดยเจ้าของ · ถูกลบโดยอัตโนมัติหลังจาก 60 วัน",
"hc.waitingForPartnerConfirmation": "รอการยืนยันจากคู่ค้า",
"hc.waitingForThePartnerS": "รอการยืนยันจากคู่ค้า",
"hc.weHaveInformedTheEstablishment": "เราได้แจ้งสถานที่ว่าไอเทมนี้ไม่ใช่ของคุณและเริ่มการวิเคราะห์ใหม่ คุณจะได้รับการแจ้งเตือนเมื่อมีการจับคู่ใหม่",
"hc.weHaveInformedThePartner": "เราได้แจ้งคู่ค้าว่าไอเทมนี้ไม่ใช่ของคุณ รายการของคุณยังคงใช้ได้สำหรับการจับคู่ในอนาคต",
"hc.weRanTheAnalysisAgain": "เราได้ทำการวิเคราะห์อีกครั้งและพบรายการอื่นที่อาจเป็นของคุณ กรุณาตรวจสอบอีกครั้งค่ะ",
"hc.weight": "น้ำหนัก",
"hc.weightNotProvidedTheShipping": "น้ำหนักไม่ได้ระบุ: อัตราค่าจัดส่งจะถูกคำนวณในขณะจัดส่ง",
"hc.weightUnit": "หน่วยน้ำหนัก",
"hc.welcome": "ยินดีต้อนรับ!",
"hc.welcomeToFindo": "ยินดีต้อนรับสู่ Findloop",
"hc.whenACustomerComesTo": "เมื่อมีลูกค้ามารับของ ให้เปิดการประกาศและยืนยันการคืน นั่นแหละ!",
"hc.whenDisabledFeesDropTo": ". เมื่อปิดใช้งาน ค่าธรรมเนียมจะลดลงเหลือ",
"hc.whyIsThisNotYour": "ทำไมสิ่งนี้ถึงไม่ใช่ของคุณ?",
"hc.willBeMarkedAs": "จะถูกระบุว่าเป็น",
"hc.wrongColor": "สีผิด",
"hc.wrongModel": "รุ่นผิด",
"hc.yesCancel": "ใช่ ยกเลิก",
"hc.yesContactTheFinder": "ใช่ ติดต่อผู้ค้นหา",
"hc.youAreHere": "คุณอยู่ที่นี่",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "คุณสามารถเริ่มการคืนได้แล้ว",
"hc.youCanStillChangeIt": ". คุณยังสามารถเปลี่ยนได้ทีละกรณี",
"hc.youHaveAlreadyConfirmedThat": "คุณได้ยืนยันแล้วว่านี่คือของคุณ",
"hc.youWillBeRedirectedTo": "คุณจะถูกเปลี่ยนเส้นทางไปที่การชำระเงินผ่าน Stripe ที่ปลอดภัย",
"hc.yourAccountHasBeenReactivated": "บัญชีของคุณได้ถูกเปิดใช้งานอีกครั้ง",
"hc.yourAccountIsActiveYou": "บัญชีของคุณใช้งานได้แล้ว ตอนนี้คุณสามารถจัดการสถานประกอบการของคุณได้",
"hc.yourEstablishment": "สถานประกอบการของคุณ",
"hc.yourFeedbackHelpsUsImprove": "ความคิดเห็นของคุณช่วยให้เราพัฒนาความตรงกันของเราได้ดียิ่งขึ้น",
"hc.yourFeedbackHelpsUsRestart": "ความคิดเห็นของคุณช่วยให้เรากลับมาวิเคราะห์และพัฒนาความตรงกันของเราให้ดีขึ้น",
"hc.yourFirstSteps": "ก้าวแรกของคุณ",
"hc.yourFirstStepsAdmin": "ก้าวแรกของคุณ (ผู้ดูแล)",
"hc.yourItemHasBeenHanded": "รายการของคุณได้ถูกส่งมอบด้วยตนเองจากพันธมิตร — ปิดเคสเมื่อการส่งมอบได้รับการยืนยัน",
"hc.yourItemHasBeenShipped": "รายการของคุณได้ถูกจัดส่งโดยพันธมิตร — ปิดเคสเมื่อการจัดส่งได้รับการยืนยัน",
"hc.yourPaymentHasBeenRecorded": "การชำระเงินของคุณได้รับการบันทึกแล้ว",
"hc.yourShipmentIsBeingPrepared": "การจัดส่งของคุณกำลังถูกเตรียม คุณจะได้รับพัสดุภายใน 3 ถึง 5 วันทำการ",
"hc.yourShippingFeesHaveAlready": "ค่าจัดส่งของคุณได้ถูกชำระแล้ว จัดส่งชำระแล้ว ✓",
"hc.yourShippingFeesHaveBeen": "ค่าจัดส่งของคุณได้ถูกชำระแล้ว พัสดุกำลังถูกเตรียม",
"hc.yourVerificationQuestionsDeposit": "คำถามการยืนยันของคุณ (เงินฝาก)",
"hero.einvoiceBadge": "การออกใบกำกับภาษีอิเล็กทรอนิกส์ที่เป็นไปตามมาตรฐาน 2027",
"home.recentAdsAll": "ดูรายการทั้งหมด",
"home.recentAdsEyebrow": "ตอนนี้",
"home.recentAdsSubtitle": "รายการที่ถูกสูญหายและพบโดยชุมชน",
"home.recentAdsTitle": "รายการล่าสุด",
"home.reunions": "การรวมตัวเมื่อเร็ว ๆ นี้",
"home.videoEyebrow": "ดู",
"home.videoSubtitle": "วิธีที่เรานำสิ่งของที่หายไปกลับคืนสู่เจ้าของได้อย่างง่ายดาย",
"home.videoTitle": "ค้นพบ Findloop ใน 2 นาที",
"home.watchYoutube": "ดูบน YouTube",
"impact.already": "แล้ว",
"impact.citiesWord": "เมือง/เมืองต่างๆ",
"impact.eachPoint": "ทุกจุดคือเมืองที่ Findloop ช่วยกู้คืนสิ่งของที่หายไป",
"impact.emptyMap": "แผนที่จะเติมเต็มเมื่อมีการคืนของ",
"impact.eyebrow": "ผลกระทบของเรา",
"impact.inCities": "ทั่ว",
"impact.restitutedTo": "สิ่งของที่คืนให้เจ้าของ",
"impact.title": "สิ่งของที่ถูกคืน ทุกที่ใกล้คุณ",
"inv2.download": "ดาวน์โหลด",
"inv2.view": "ดู",
"map.objectsOnMapPlural": "สิ่งของบนแผนที่",
"map.objectsOnMapSingular": "สิ่งของบนแผนที่",
"mc.claimConfirmDesc": "ตรวจสอบสิ่งของที่พบโดยผู้ค้นหาก่อนชำระเงินเพื่อปลดล็อกข้อมูลติดต่อของพวกเขา",
"mc.claimConfirmNo": "นี่不是我的东西",
"mc.claimConfirmTitle": "นี่เป็นสิ่งของของคุณจริงๆ หรือ?",
"mc.claimConfirmYes": "ใช่ มันของฉัน — ชำระเงิน",
"mc.claimFinderContacts": "ข้อมูลติดต่อของผู้ค้นหา",
"mc.claimNotMineDone": "ขอบคุณ — ผู้ค้นหาได้รับการแจ้งเตือนและคำร้องขอของคุณถูกลบออกจากโฆษณา",
"mc.claimUnlockDesc": "ชำระค่าธรรมเนียมการจัดการ Findloop เพื่อรับข้อมูลติดต่อของผู้ที่พบสิ่งของของคุณ",
"mc.claimUnlockTitle": "ปลดล็อกข้อมูลติดต่อของผู้ค้นหา",
"mc.hideCountryOffers": "ซ่อนข้อเสนอในประเทศของฉัน",
"mc.myClaims": "สิ่งของที่ฉันกำลังเรียกร้อง",
"mc.myClaimsSub": "สิ่งของที่พบโดยบุคคลอื่นที่คุณกำลังเรียกร้อง ปลดล็อคข้อมูลติดต่อของผู้ค้นหาเพื่อจัดการส่งมอบ",
"mc.notifAdCancelled": "โฆษณาถูกยกเลิก",
"mc.notifCancelAd": "ยกเลิกโฆษณาของฉัน",
"mc.offersInCountry": "ข้อเสนอในประเทศของฉัน",
"mc.offersInCountryDesc": "รางวัลทั้งหมดที่ยังมีอยู่จากพันธมิตรในประเทศของคุณ ตามเมือง",
"mc.redArchived": "เก็บถาวร",
"mc.rewardsCountryNone": "ยังไม่มีข้อเสนอในประเทศของคุณ",
"mc.rewardsForYou": "รางวัลสำหรับคุณ",
"mc.rewardsForYouDesc": "เสนอโดยพันธมิตรที่คุณนำสิ่งของไปฝาก",
"mc.rewardsMineNone": "ยังไม่มีรางวัลจากพันธมิตรที่คุณฝากของ",
"mc.showCountryOffers": "ดูข้อเสนอในประเทศของฉัน",
"mc2.cancelDecl": "ยกเลิกคำประกาศของฉัน",
"mc2.cancelDeclDone": "ยกเลิกคำประกาศเรียบร้อย",
"pricing.physInvDesc": "เมื่อสิ่งของถูกส่งคืน สถานที่จะถูกปล่อยอัตโนมัติและพร้อมสำหรับสิ่งของใหม่",
"pricing.physInvTitle": "การติดตามสินค้าทางกายภาพ",
"pricing.physModalTitle": "การจัดการรายการทางกายภาพ",
"pricing.physQrDesc": "รหัส QR ที่ไม่ซ้ำกันจะถูกสร้างขึ้นสำหรับแต่ละรายการและเชื่อมโยงไปยังข้อมูลทั้งหมดของมัน.",
"pricing.physQrTitle": "ป้าย QR ที่จัดทำขึ้นเฉพาะ",
"pricing.physShelfDesc": "รายการที่ลงทะเบียนทั้งหมดสามารถถูกกำหนดที่ตั้งทางกายภาพภายในสถานที่นั้น.",
"pricing.physShelfTitle": "แผนชั้นวาง",
"pricing.physicalMgmt": "การจัดการสินค้าทางกายภาพ (ชั้นวาง, QR, สินค้า)",
"pub.addSecondPhoto": "เพิ่มภาพที่ 2 (ไม่บังคับ)",
"pub.photo2Added": "✓ เพิ่มภาพที่ 2",
"reg.dispositionJournal": "บันทึกการจัดการ",
"reg.dispositionNoteAuthHint": "ℹ️ ต้องมีบันทึกสำหรับ “ส่งให้เจ้าหน้าที่” (หมายเลขรายงาน, แผนก…).",
"reg.dispositionNotePh": "บันทึก (ไม่บังคับ): การกุศลที่ได้รับ, อ้างอิงจากเจ้าหน้าที่, ชื่อผู้ซื้อ…",
"reg.dispositionNoteRequired": "ต้องมีอ้างอิงอย่างเป็นทางการเพื่อส่งมือให้เจ้าหน้าที่.",
"reg.legalPrealert": "กำหนดเวลาทางกฎหมายใน {days} วัน",
"reg.legalPrealertOptions": "ตัวเลือกเมื่อถึงกำหนด: การประมูล, บริจาคให้การกุศล, ส่งมอบให้เจ้าหน้าที่.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "การตรวจสอบเต็มรูปแบบ",
"rev.readMore": "อ่านเพิ่มเติม",
"rw.activeCodes": "คูปองที่ใช้งานอยู่",
"rw.archived": "เก็บถาวร",
"rw.archivedTitle": "คูปองที่แลกแล้ว (เก็บถาวร)",
"rw.hideArchived": "ซ่อนคูปองที่แลกแล้ว",
"rw.noArchived": "ไม่มีคูปองที่เก็บถาวร.",
"rw.showArchived": "แสดงคูปองที่แลกแล้ว",
"shp.labelAuto": "ป้ายจะถูกสร้างโดยอัตโนมัติเมื่อผู้ซื้อได้ชำระค่าจัดส่งแล้ว สามารถดาวน์โหลดที่นี่.",
"st.cancelled_by_customer": "ถูกยกเลิก",
"stt.dispoPdfBtn": "ส่งออก PDF",
"stt.dispoPdfError": "การส่งออก PDF ล้มเหลว.",
"stt.dispoPdfExporting": "กำลังส่งออก…",
"trk.matchVerifying": "กำลังตรวจสอบการจับคู่ที่มีศักยภาพ",
"pcat.stadium_arena": "สนามกีฬา / อารีน่า",
"pcat.supermarket": "ซูเปอร์มาร์เก็ต",
"pcat.taxi_vtc": "แท็กซี่ / แพลตฟอร์มเรียกรถ",
"pcat.tourism_office": "สำนักงานท่องเที่ยว",
"pcat.train_bus_station": "สถานีรถไฟ / รถบัส",
"pcat.travel_agency": "บริษัทท่องเที่ยว",
"hc.and": "และ",
"hc.demoObj0": "กระเป๋าเงิน",
"hc.demoObj1": "กระเป๋ากีฬา",
"hc.demoObj2": "โทรศัพท์",
"hc.demoObj3": "แว่นตา",
"hc.demoObj4": "ช่างกุญแจ",
"hc.demoObj5": "ผ้าพันคอ",
"hc.demoObj6": "แล็ปท็อป",
"hc.demoObj7": "ขวดน้ำ",
"hc.demoWhen0": "2 ชั่วโมงที่แล้ว",
"hc.demoWhen1": "5 ชั่วโมงที่แล้ว",
"hc.demoWhen2": "เมื่อวาน",
"hc.demoWhen3": "3 ชั่วโมงที่แล้ว",
"hc.demoWhen4": "เช้านี้",
"hc.demoWhen5": "1 วันที่แล้ว",
"hc.feedDemo": "{obj} ถูกส่งกลับใน {city} {when}.",
"hc.feedReal": "รายการ ({cat}) ถูกส่งกลับใน {city}.",
"hc.saveBtn": "บันทึก",
"hc.saveLink": "บันทึกลิงก์",
"hc.terms": "เงื่อนไข",
"hc.view": "ดู",
"pcat.airline": "สายการบิน",
"pcat.airport": "สนามบิน",
"pcat.amusement_park": "สวนสนุก",
"pcat.bank": "ธนาคาร",
"pcat.bar_cafe": "บาร์ / คาเฟ่",
"pcat.beauty_salon": "ร้านทำผม / ความงาม",
"pcat.cinema": "โรงหนัง",
"pcat.concert_theater": "ห้องแสดงคอนเสิร์ต / โรงละคร",
"pcat.coworking": "พื้นที่ทำงานร่วมกัน",
"pcat.gym_fitness": "ฟิตเนส",
"pcat.hospital_clinic": "โรงพยาบาล / คลินิก",
"pcat.library": "ห้องสมุด",
"pcat.mall": "ห้างสรรพสินค้า",
"pcat.museum": "พิพิธภัณฑ์",
"pcat.pharmacy": "ร้านขายยา",
"pcat.private_company": "บริษัทเอกชน",
"pcat.public_transport": "การขนส่งสาธารณะ",
"pcat.school_university": "โรงเรียน / มหาวิทยาลัย",
"pcat.sports_center": "ศูนย์กีฬา",
"an.found": "พบแล้ว",
"an.lost": "หายไป",
"hc.shareReview": "แชร์รีวิว",
"hc.citiesAboveTarget": "{n} เมืองที่เกินเป้าหมาย",
"hc.cityAboveTarget": "{n} เมืองที่เกินเป้าหมาย",
"hc.j15EarlyReminder": "เตือนความจำล่วงหน้า D-15",
"hc.j7EarlyReminder": "เตือนความจำล่วงหน้า D-7",
"hc.annualTotal": "ยอดรวมประจำปี",
"hc.billedOnceYear": "ชำระเงินครั้งเดียวสำหรับ 12 เดือน ต่ออายุทุกปี.",
"hc.monthlyPrice": "ราคาต่อเดือน",
"hc.perMonth": "/ เดือน",
"hc.perYear": "/ ปี",
"hc.billedEachMonth": "คิดค่าบริการอัตโนมัติทุกเดือน.",
"nav.business": "ธุรกิจ",
"nav.individual": "บุคคล",
"hc.circumstancesFound": "สภาพการค้นพบ",
"hc.circumstancesFoundPh": "เช่น พบอยู่บนพื้นใกล้ทางเข้าเมโทร",
"hc.circumstancesLost": "สภาพการสูญหาย",
"hc.circumstancesLostPh": "เช่น ทิ้งไว้บนม้านั่งขณะรอรถบัส",
"hc.conditionPh": "เช่น สภาพดี ขีดข่วน…",
"hc.firstName": "ชื่อ",
"hc.lastName": "นามสกุล",
"hc.quantity": "จำนวนรายการ",
"fa.approve": "อนุมัติ",
"fa.approveConfirm": "อนุมัติเสียครั้งนี้? รายละเอียดการติดต่อทั้งหมดของคุณ (ชื่อ, อีเมล, โทรศัพท์) จะถูกแลกเปลี่ยนกับผู้ค้นหา.",
"fa.approved": "การประกาศได้รับการอนุมัติ — รายละเอียดการติดต่อถูกแลกเปลี่ยน",
"fa.approvedFinder": "เจ้าของได้อนุมัติการประกาศของคุณ",
"fa.approvedFinderText": "ติดต่อพวกเขาเพื่อนัดหมายการคืน.",
"fa.boostSub": "การประกาศของคุณจะอยู่ที่ด้านบนเป็นระยะเวลาที่เลือก.",
"fa.boostTitle": "โปรโมตการประกาศของฉัน (เลือกได้)",
"fa.colFinder": "การประกาศของผู้ค้นหา",
"fa.colYours": "การประกาศของคุณ",
"fa.compareHint": "เปรียบเทียบการประกาศของผู้ค้นหากับของคุณก่อนตัดสินใจ.",
"fa.contribNone": "ไม่มีการสนับสนุน",
"fa.contribPaid": "ได้รับการสนับสนุนแล้ว — ขอบคุณ!",
"fa.contribPending": "การสนับสนุนรอการชำระเงิน",
"fa.contribSub": "สนับสนุน Findloop เพื่อช่วยให้ผู้คนมากขึ้นได้รับสิ่งของกลับคืน คุณสามารถเลือก €0.",
"fa.contribSuccessMsg": "การประกาศของคุณได้ถูกส่งไปยังเจ้าของ.",
"fa.contribSuccessTitle": "ขอบคุณสำหรับการสนับสนุนของคุณ",
"fa.contribTitle": "การสนับสนุนโดยสมัครใจ",
"fa.days3": "3 วัน",
"fa.days30": "30 วัน",
"fa.days7": "7 วัน",
"fa.declSub": "ระบุรายละเอียดของสิ่งที่คุณพบ เจ้าของจะเปรียบเทียบการประกาศของคุณกับของพวกเขา.",
"fa.declTitle": "ฉันพบสิ่งนี้",
"fa.expiresOn": "หมดอายุใน",
"fa.fBrand": "แบรนด์",
"fa.fCircumstances": "สถานการณ์",
"fa.fCity": "เมือง",
"fa.fColor": "สี",
"fa.fCondition": "สภาพ",
"fa.fDate": "วันที่",
"fa.fMessage": "ข้อความจากผู้ค้นหา",
"fa.fPlace": "สถานที่",
"fa.fQuantity": "จำนวน",
"fa.finderContact": "รายละเอียดการติดต่อของผู้ค้นหา",
"fa.finishPay": "ชำระเงินให้เสร็จสิ้น",
"fa.foundDate": "วันที่พบ",
"fa.foundPlace": "สถานที่พบ",
"fa.hours24": "24 ชั่วโมง",
"fa.ht": "ไม่รวม VAT",
"fa.months3": "3 เดือน",
"fa.noBoost": "ไม่มีการโปรโมต",
"fa.ownerContact": "รายละเอียดการติดต่อของเจ้าของ",
"fa.payPublish": "ชำระเงินและเผยแพร่",
"fa.pendingPayText": "รายการของคุณจะพร้อมใช้งานเมื่อการชำระเงินได้รับการยืนยันแล้ว",
"fa.pendingPayTitle": "การชำระเงินยังรอดำเนินการ",
"fa.planSub": "รายการของคุณจะพร้อมใช้งานเมื่อการชำระเงินได้รับการยืนยันแล้ว",
"fa.planTitle": "ระยะเวลาการลงรายการ",
"fa.pubSuccessMsg": "รายการของคุณพร้อมใช้งานแล้ว คุณจะได้รับการแจ้งเตือนเมื่อมีผู้ค้นหาติดต่อเข้ามา",
"fa.pubSuccessTitle": "เผยแพร่รายการแล้ว",
"fa.publicNote": "เฉพาะคำบรรยาย, เมือง, ประเทศ และภาพถ่ายจะถูกแสดงสาธารณะ",
"fa.redirectStripe": "กำลังเปลี่ยนเส้นทางไปยังการชำระเงินที่ปลอดภัย…",
"fa.reject": "ปฏิเสธ",
"fa.rejectConfirm": "ปฏิเสธการประกาศนี้ใช่หรือไม่? รายการของคุณจะยังคงออนไลน์อยู่",
"fa.rejected": "การประกาศถูกปฏิเสธ",
"fa.rejectedFinder": "มันไม่ใช่สินค้าที่พวกเขากำลังมองหา",
"fa.rejectedFinderText": "เจ้าของบอกว่าสินค้านี้不是ของเขา ขอบคุณสำหรับความช่วยเหลือ!",
"fa.responsesTitle": "การประกาศจากผู้ค้นหา",
"fa.sent": "ส่งการประกาศไปยังเจ้าของแล้ว",
"fa.submitDecl": "ส่งการประกาศของฉัน",
"fa.submitDeclPay": "ส่งและมีส่วนร่วม {amount}",
"fa.total": "ยอดรวมที่ต้องชำระ",
"fa.ttc": "รวม VAT",
"fa.waitClaimText": "ผู้ค้นกำลังตรวจสอบคำขอของคุณ คุณจะได้รับการแจ้งเตือนเกี่ยวกับการตัดสินใจของพวกเขา",
"fa.waitFinderText": "เราจะแจ้งให้คุณทราบเมื่อผู้ค้นส่งการประกาศ",
"fa.waitFinderTitle": "รายการของคุณพร้อมใช้งาน",
"fa.waitOwnerText": "เจ้าของกำลังเปรียบเทียบการประกาศของคุณกับของพวกเขา คุณจะได้รับการแจ้งเตือนเกี่ยวกับการตัดสินใจของพวกเขา",
"fa.waitOwnerTitle": "รอการตัดสินใจจากเจ้าของ",
"st.pending_payment": "การชำระเงินยังรอดำเนินการ",
"fa.africaFree": "ประกาศฟรีในแอฟริกา — ข้อเสนอเปิดตัว Findloop, สนุกกับมัน!",
"fa.africaPublished": "ประกาศเผยแพร่ฟรี — ข้อเสนอเปิดตัวแอฟริกา!",
"fa.approveClaimConfirm": "อนุมัติการเรียกร้องนี้หรือไม่? เจ้าของจะสามารถปลดล็อกข้อมูลติดต่อของคุณได้.",
"fa.checkInfo": "ตรวจสอบรายละเอียดของคุณก่อนส่ง: จะเปรียบเทียบกับของผู้ค้นหา.",
"fa.claimApprovedShort": "ผู้ค้นหาได้อนุมัติการเรียกร้องของคุณ",
"fa.claimRejectedShort": "การเรียกร้องถูกปฏิเสธโดยผู้ค้นหา",
"fa.claimRejectedText": "ผู้ค้นเชื่อว่าสิ่งนี้ไม่ใช่ของคุณ.",
"fa.claimSub": "อธิบายสิ่งของของคุณและเพิ่ม 2 รูปภาพ. ผู้ค้นจะเปรียบเทียบกับประกาศของเขา.",
"fa.claimTitle": "นี่คือสิ่งของของฉัน",
"fa.claimUnlockText": "ปลดล็อกข้อมูลติดต่อของผู้ค้นเพื่อจัดการการคืน.",
"fa.claimUnlockedShort": "ข้อมูลติดต่อถูกปลดล็อก — ดูการติดตาม",
"fa.claimsTitle": "การเรียกร้องของเจ้าของ",
"fa.colOwner": "แถลงการณ์ของเจ้าของ",
"fa.colYourAd": "ประกาศของคุณ",
"fa.expired": "ประกาศหมดอายุ",
"fa.free": "ฟรี",
"fa.lostDate": "วันที่หาย",
"fa.lostPlace": "สถานที่หาย",
"fa.noReceipt": "ไม่มีใบเสร็จสำหรับประกาศนี้.",
"fa.planSubFree": "เลือกระยะเวลา: ประกาศของคุณจะออนไลน์ทันที, ไม่มีการชำระเงิน.",
"fa.prefillPrevious": "ใช้รายละเอียดจากประกาศก่อนหน้านี้ในหมวดนี้",
"fa.receipt": "ใบเสร็จ PDF",
"fa.renewBtn": "ต่ออายุ",
"fa.renewDiscountBanner": "ลด 50%: ต่ออายุก่อนประกาศของคุณหมดอายุ!",
"fa.renewDiscountHint": "ลด 50% เนื่องจากคุณต่ออายุก่อนหมดอายุ.",
"fa.renewEarly": "ต่ออายุ (−50%)",
"fa.renewTitle": "ต่ออายุประกาศของฉัน",
"fa.renewed": "ประกาศต่ออายุแล้ว",
"fa.sendClaim": "ส่งการเรียกร้องของฉัน",
"fa.twoPhotos": "2 รูปภาพของสิ่งของของคุณ",
"fa.twoPhotosError": "เพิ่ม 2 รูปภาพของสิ่งของของคุณ.",
"fa.twoPhotosHint": "รูปภาพส่วนตัวที่พิสูจน์ว่าสิ่งของเป็นของคุณ (กับสิ่งของ, ใบแจ้งหนี้, กล่อง…).",
"fa.unlockBtn": "ปลดล็อกข้อมูลติดต่อ",
"fa.unlockFree": "ปลดล็อกฟรี — ข้อเสนอเปิดตัว",
"fa.waitClaimantText": "เราจะแจ้งให้คุณทราบทันทีที่เจ้าของเรียกร้องสิ่งนี้.",
"fa.waitFinderDecision": "รอการตัดสินใจของผู้ค้น",
"fa.waitUnlockText": "คุณจะได้รับการแจ้งเตือนทันทีที่มีการแลกเปลี่ยนข้อมูลติดต่อ.",
"fa.waitUnlockTitle": "รอให้เจ้าของปลดล็อก",
"fa.cancel": "ยกเลิก",
"fa.categoryRequired": "เลือกหมวดหมู่สำหรับรายการที่พบ.",
"fa.confirmTitle": "ยืนยันการตัดสินใจของคุณ",
"fa.goBack": "กลับ",
"dr.continue": "ดำเนินการประกาศของฉันต่อ",
"dr.delete": "ลบอย่างถาวร",
"dr.deleteConfirm": "ลบร่างนี้อย่างถาวร? สิ่งนี้ไม่สามารถย้อนกลับได้.",
"dr.deleted": "ร่างถูกลบ",
"dr.expiresIn": "ร่างจะถูกเก็บไว้เป็นเวลา {h} ชั่วโมงอีก",
"dr.title": "คุณมีการประกาศที่ยังไม่เสร็จ",
"form.step": "ขั้นตอน",
"form.next": "ดำเนินการต่อ",
"form.back": "กลับ",
"form.stepDetails": "รายงานของคุณ",
"form.stepPublish": "ระยะเวลา, การสนับสนุน & การชำระเงิน",
"form.stepThanks": "ขอบคุณ & การมีส่วนร่วม",
"fthx.badge": "รายงานเกือบเสร็จสมบูรณ์",
"fthx.title": "ขอบคุณที่คุณทำให้เกิดการเปลี่ยนแปลง!",
"fthx.text": "ด้วยความช่วยเหลือของคุณ ใครบางคนอาจจะได้กลับไปยังสิ่งที่สำคัญสำหรับพวกเขา การกระทำแห่งความกรุณาเช่นของคุณคือสิ่งที่ทำให้ Findloop ยังคงดำเนินต่อไป.",
"fthx.impact1": "1 รายการที่รายงาน",
"fthx.impact2": "1 โอกาสเพิ่มเติมในการกลับมาพบกัน",
"fthx.tipTitle": "แรงบันดาลใจเล็กน้อยสำหรับ Findloop?",
"fthx.tipText": "การสนับสนุนของคุณช่วยให้เรารักษาบริการให้สามารถเข้าถึงได้และนำสิ่งของมากมายกลับคืนสู่เจ้าของได้มากขึ้น.",
"fthx.optional": "100% เป็นทางเลือก — คุณสามารถเผยแพร่โดยไม่ต้องสนับสนุน.",
"fthx.thanksTip": "ขอบคุณมากสำหรับความเอื้อเฟื้อของคุณ!",
"fthx.suggest": "จำนวนที่แนะนำ",
"fthx.none": "ไม่มีคำแนะนำ",
"pay.pendingTitle": "การชำระเงินยังไม่เสร็จสมบูรณ์",
"pay.pendingText": "รายละเอียดของคุณถูกบันทึกไว้แล้ว กรุณาดำเนินการชำระเงินจากจุดที่คุณหยุดไว้.",
"pay.resume": "ดำเนินการชำระเงินต่อ",
"pay.expiredTitle": "เซสชันการชำระเงินหมดอายุ",
"pay.expiredText": "เพื่อความปลอดภัย เซสชันการชำระเงินหมดอายุ รายละเอียดของคุณถูกบันทึกไว้: เริ่มต้นการชำระเงินใหม่เพียงคลิกเดียว.",
"pay.relaunch": "เริ่มต้นการชำระเงินใหม่",
"sub.received": "ส่งแล้ว!",
"sub.publishing": "เรากำลังทำให้เสร็จ…",
"sub.toPayment": "กำลังเปลี่ยนเส้นทางไปยังการชำระเงินที่ปลอดภัย…",
"fa.claimSubV2": "กรุณาอธิบายสิ่งของที่คุณสูญหาย คนที่พบจะเปรียบเทียบการแจ้งของคุณกับรายการของพวกเขา",
"fa.photosOptional": "รูปภาพของสิ่งของของคุณ (ไม่บังคับ)",
"fa.compareOwnerHint": "เปรียบเทียบข้อมูลนี้กับสิ่งของที่คุณพบ แล้วบอกว่ามันเป็นสิ่งของเดียวกันหรือไม่",
"fa.itsThisItem": "ใช่ นี่คือสิ่งของที่คุณกล่าวถึง",
"fa.notThisItem": "ไม่ นี่不是สิ่งของนั้น",
"fa.confirmIsItem": "ยืนยันว่านี่คือสิ่งของใช่ไหม? รายละเอียดการติดต่อของคุณและเจ้าของจะถูกแสดงในบัญชีของคุณตามลำดับ",
"fa.confirmNotItem": "ยืนยันว่านี่不是สิ่งของใช่ไหม? รายงานของคุณจะถูกปิด",
"fa.youConfirmed": "คุณยืนยันว่านี่คือสิ่งของของเจ้าของ",
"fa.youDeclined": "คุณระบุว่านี่不是สิ่งของนั้น",
"fa.youDeclinedText": "ขอบคุณสำหรับความช่วยเหลือ! เจ้าของได้รับข้อมูลแล้ว",
"fa.waitFinderDecisionOwner": "รอการตัดสินใจจากผู้ที่พบ",
"fa.finderConfirmed": "ยืนยันแล้ว",
"fa.notYourItem": "นี่不是สิ่งของของคุณ",
"fa.reportedOn": "รายงานเมื่อ",
"fa.ownerWaitHint": "ผู้ที่พบกำลังตรวจสอบข้อมูล กรุณารอ",
"fa.claimSentFinder": "ส่งคำร้องไปยังผู้ที่พบสิ่งของแล้ว",
"fa.compareClaimHint": "เปรียบเทียบการประกาศของเจ้าของกับรายการของคุณก่อนตัดสินใจ",
"fa.closeFollowup": "ปิดการติดตามนี้",
"fa.closeFollowupConfirm": "คุณแน่ใจว่าต้องการปิดการติดตามนี้ใช่ไหม? อีเมลและหมายเลขโทรศัพท์ของทั้งสองฝ่ายจะถูกลบถาวรเมื่อเจ้าของปิดรายการของตนด้วย",
"fa.safetyTitle": "เคล็ดลับความปลอดภัยก่อนโอนสินค้า",
"fa.safety1": "ขอรายละเอียดที่เจาะจงเกี่ยวกับคุณสมบัติที่ซ่อนอยู่ของสินค้า: รอยขีดข่วนที่เฉพาะเจาะจง, เนื้อหาภายในกระเป๋า, วอลล์เปเปอร์, หมายเลขซีเรียล…",
"fa.safety2": "ถ้าเป็นไปได้ ขอหลักฐานภาพถ่าย (ภาพของสินค้า) หรือหลักฐานการซื้อ.",
"fa.safety3": "โอนสินค้าที่สถานที่สาธารณะหรือตัวแทนของ Findloop และตรวจสอบบัตรประจำตัวของเจ้าของ.",
"fa.safetyOk": "เข้าใจแล้ว, ไปต่อ",
"fa.ownerClosedNote": "เจ้าของได้ปิดรายการของตนแล้ว.",
"fa.finderClosedNote": "ผู้ค้นหาได้ปิดการติดตามของตนแล้ว.",
"fa.followupClosed": "ติดตามปิดแล้ว",
"fa.followupClosedText": "คุณได้ปิดการติดตามนี้ ขอบคุณสำหรับความช่วยเหลือของคุณ!",
"fa.photoReviewTitle": "ผู้ค้นหาได้ส่งภาพมา หรือนี่คือของของคุณ?",
"fa.photoLooksLike": "ใช่ ดูเหมือนของฉัน",
"fa.photoNotMine": "ไม่ นี่ไม่ใช่ของฉัน",
"fa.photoNotMineConfirm": "การติดตามจะถูกปิดทั้งสองฝ่ายและรายการของคุณจะยังเปิดอยู่สำหรับผู้ค้นหาใหม่",
"fa.photoLooksLikeDone": "ขอบคุณ! ผู้ค้นหาจะเปรียบเทียบคำประกาศของคุณต่อไป",
"fa.photoNotMineDone": "รายงานถูกยกเลิก รายการของคุณยังคงเปิดอยู่",
"fa.ownerPhotoHint": "เฉพาะภาพจากผู้ค้นหาที่แสดงให้คุณเห็น บอกเราว่ามันเหมือนของคุณหรือไม่",
"fa.ownerReviewingPhoto": "เจ้าของกำลังตรวจสอบภาพของคุณ",
"fa.ownerReviewingPhotoText": "คุณจะได้รับการแจ้งเตือนทันทีที่พวกเขาตอบ คุณจะได้เปรียบเทียบคำประกาศของพวกเขา",
"fa.ownerRejectedPhoto": "นี่ไม่ใช่ของเจ้าของ",
"fa.ownerRejectedPhotoText": "เจ้าของบอกว่าภาพของคุณไม่ตรงกับของพวกเขา การติดตามถูกปิด ขอบคุณสำหรับความช่วยเหลือ!",
"fa.contribute": "มีส่วนร่วม",
"fa.phoneMissing": "ไม่ได้ระบุ",
"fa.ownerSafety1": "ควรส่งมอบในสถานที่สาธารณะหรือที่พันธมิตรของ Findloop หากระยะทางไกล แนะนำให้ส่งทางไปรษณีย์แทน",
"fa.ownerSafety2": "ในขณะส่งมอบ ให้ตรวจสอบบัตรประชาชนของผู้ที่พบ",
"pub.changePhoto": "เปลี่ยนรูปภาพ",
"ph.secured": "ภาพถ่ายได้รับการรักษาความปลอดภัย",
"ph.securing": "กำลังรักษาความปลอดภัยให้กับภาพถ่าย…",
"fa.ownerSafety3": "หากภาพถ่ายของผู้พบมีลายน้ำของ Findloop อย่ารับการนัดหมาย ภาพถ่ายต้องเป็นภาพต้นฉบับที่ถ่ายโดยผู้พบ โดยไม่มีลายน้ำ"
},
"vi": {
"a.back": "Quay lại",
"a.category": "Danh mục",
"a.categoryPlaceholder": "Chọn một danh mục",
"a.city": "Thành phố",
"a.confirmPassword": "Xác nhận mật khẩu",
"a.country": "Quốc gia",
"a.createAccount": "Tạo tài khoản",
"a.createBtn": "Tạo tài khoản của tôi",
"a.creating": "Đang tạo…",
"a.email": "Email",
"a.emailPro": "Email doanh nghiệp",
"a.forgot": "Quên?",
"a.forgotSent": "Nếu có tài khoản, một liên kết đặt lại vừa được gửi đến.",
"a.forgotSub": "Nhận liên kết đặt lại qua email.",
"a.forgotTitle": "Quên mật khẩu",
"a.googleContinue": "Tiếp tục với Google",
"a.googleSignup": "Đăng ký với Google",
"a.haveAccount": "Đã là đối tác?",
"a.legalHint": "Cần thiết cho hóa đơn điện tử Pháp (Factur-X) của các cơ sở tại Pháp.",
"a.legalRequiredFR": "SIRET và mã VAT nội khối EU là bắt buộc cho Pháp.",
"a.loggingIn": "Đang đăng nhập…",
"a.login": "Đăng nhập",
"a.loginSub": "Truy cập không gian quản lý của bạn.",
"a.loginTitle": "Đăng nhập đối tác",
"a.min6": "Tối thiểu 6 ký tự",
"a.newPassword": "Mật khẩu mới",
"a.noAccount": "Chưa phải là đối tác?",
"a.or": "HOẶC",
"a.org": "Tên cơ sở",
"a.password": "Mật khẩu",
"a.passwordMismatch": "Mật khẩu không khớp.",
"a.referral": "Mã giới thiệu (tùy chọn)",
"a.registerSub": "Tạo không gian của bạn trong 1 phút — miễn phí để bắt đầu.",
"a.registerTitle": "Trở thành đối tác",
"a.rememberMe": "Nhớ tôi",
"a.reset": "Đặt lại",
"a.resetSub": "Chọn một mật khẩu mới cho tài khoản của bạn.",
"a.resetTitle": "Mật khẩu mới",
"a.sendLink": "Gửi liên kết",
"a.sending": "Đang gửi…",
"a.signin": "Đăng nhập",
"a.siret": "SIRET",
"a.vat": "Mã VAT nội khối EU.",
"ac.africa": "Châu Phi",
"ac.boostActive": "Nổi bật hoạt động —",
"ac.boostSub": "Xuất hiện ở đầu danh bạ đối tác với huy hiệu “Được tăng cường”.",
"ac.boostTitle": "Tăng cường danh sách của bạn trong danh bạ",
"ac.categoryHint": "Để phân loại cơ sở của bạn trong danh bạ findloop.",
"ac.choose": "Chọn",
"ac.cityHint": "Để định vị chính xác trên bản đồ công khai.",
"ac.cityLabel": "Thành phố cơ sở",
"ac.cityPh": "Paris",
"ac.contact": "Thông tin liên hệ",
"ac.converted": "Đã chuyển đổi",
"ac.copyDeclLink": "Sao chép liên kết khai báo",
"ac.copyLink": "Sao chép liên kết",
"ac.currentPlan": "Kế hoạch hiện tại",
"ac.emailDesc": "Chọn các email bạn muốn nhận. Thông báo trong không gian làm việc của bạn luôn duy trì hoạt động.",
"ac.emailMatch": "Trùng khớp",
"ac.emailMatchDesc": "Một email khi một mục trùng khớp với một khai báo",
"ac.emailNewDecl": "Thông báo mất mới",
"ac.emailNewDeclDesc": "Một email ngay khi khách hàng báo cáo mất mát tại địa điểm của bạn",
"ac.emailShip": "Yêu cầu giao hàng",
"ac.emailShipDesc": "Một email khi khách hàng yêu cầu giao hàng một mặt hàng",
"ac.emailTitle": "Tùy chọn email",
"ac.expireSoon": "Nổi bật của bạn sẽ hết hạn sớm —",
"ac.exportCsv": "Xuất (CSV)",
"ac.exportHint": "Xuất các khoản thanh toán bên ngoài đã được xác nhận cho kế toán của bạn.",
"ac.free": "Miễn phí",
"ac.freeMonths": "Tháng miễn phí",
"ac.hours": "giờ",
"ac.howItWorks": "Nó hoạt động như thế nào?",
"ac.invited": "Đã mời",
"ac.legalFR": "Cần thiết cho lập hóa đơn điện tử (Factur-X) bắt buộc từ tháng 9 năm 2026.",
"ac.legalMissing": "⚠️ Thiếu SIRET và VAT nội bộ EU — hoàn thành chúng để duy trì sự phù hợp với lập hóa đơn điện tử.",
"ac.legalOther": "Khuyến nghị cho các hóa đơn của bạn.",
"ac.legalPartnerQr": "Mã QR",
"ac.legalTitle": "Các định danh pháp lý (hóa đơn)",
"ac.logoTitle": "Logo cơ sở",
"ac.modeCurrent": "Chế độ hiện tại:",
"ac.modeExternal": "Bên ngoài (xác nhận thủ công)",
"ac.modeInternal": "Nội bộ Findloop (tự động)",
"ac.noSubReceipt": "Chưa có thanh toán đăng ký nào.",
"ac.none": "Không có",
"ac.onYourListing": "trên danh sách của bạn",
"ac.pay1": "Nhập các liên kết thanh toán của bạn bên dưới để chuyển hướng khách hàng đến hệ thống thu tiền của riêng bạn.",
"ac.pay2": "Xác nhận trở thành thủ công: bạn xác nhận việc nhận thanh toán từ tab “Khai báo”.",
"ac.pay3": "Liên kết “Phí giao hàng” là một khoản thanh toán hợp nhất (thu hồi + giao hàng).",
"ac.pay4": "Để trống các trường để sử dụng thanh toán nội bộ của Findloop (Stripe) với xác nhận tự động.",
"ac.paySub": "Thu phí qua hệ thống thanh toán của riêng bạn.",
"ac.payTitle": "Thanh toán bên ngoài",
"ac.permissive": "Cho phép",
"ac.phone": "Điện thoại",
"ac.posterA4": "Áp phích A4 (PDF)",
"ac.qMessage": "Tin nhắn (tùy chọn)",
"ac.qName": "Tên",
"ac.qOrg": "Tổ chức",
"ac.qSites": "Số lượng cơ sở (ước tính)",
"ac.qrHint": "Khách hàng của bạn quét mã này để báo cáo một mặt hàng bị mất.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Mã QR đối tác của bạn",
"ac.quoteDesc": "Các sân bay, mạng lưới đường sắt, chuỗi quốc tế · ",
"ac.quoteEurope": "Châu Âu / Thế giới",
"ac.quoteSent": "Yêu cầu báo giá đã được gửi. Nhóm của chúng tôi sẽ liên hệ với bạn sớm.",
"ac.quoteTitle": "Xin báo giá — Doanh nghiệp",
"ac.recoveryLink": "Liên kết “Phí thu hồi”",
"ac.refSub": "Mỗi đối tác được giới thiệu đăng ký sẽ cho bạn 1 tháng miễn phí.",
"ac.refTitle": "Giới thiệu, nhận một tháng miễn phí",
"ac.reminderDelay": "Thời gian nhắc nhở xác nhận",
"ac.reminderHint": "Bạn sẽ nhận được một email nhắc nhở nếu một khoản thanh toán bên ngoài vẫn chưa được xác nhận sau thời gian này (mặc định: 48h).",
"ac.renewDesc1": "Nó đã mang lại cho bạn",
"ac.renewDesc2": "Gia hạn để giữ vị trí hàng đầu trong danh bạ và không mất đi độ hiển thị này.",
"ac.renewNow": "Gia hạn ngay",
"ac.requestQuote": "Yêu cầu báo giá",
"ac.saveLegal": "Lưu các định danh",
"ac.saveLinks": "Lưu các liên kết",
"ac.sendRequest": "Gửi yêu cầu của tôi",
"ac.sending": "Đang gửi…",
"ac.shippingLink": "Liên kết “Phí giao hàng” (hợp nhất)",
"ac.shippingLinkHint": "Liên kết này bao gồm cả thu hồi và giao hàng.",
"ac.strict": "Nghiêm ngặt",
"ac.subReceipt": "Biên lai đăng ký (PDF)",
"ac.subReceiptsSub": "Tải xuống biên lai PDF cho mỗi khoản thanh toán đăng ký.",
"ac.subReceiptsTitle": "Biên lai đăng ký",
"ac.tCategory": "Danh mục đã lưu",
"ac.tCity": "Thành phố đã lưu — bản đồ đã cập nhật",
"ac.tCityNeeded": "Nhập một thành phố",
"ac.tCopied": "Đã sao chép!",
"ac.tCover": "Ảnh bìa đã cập nhật",
"ac.tEmailPrefs": "Tùy chọn email đã cập nhật",
"ac.tErr": "Lỗi",
"ac.tExportImpossible": "Xuất không thành công",
"ac.tLegal": "Mã số pháp lý đã lưu",
"ac.tLegalNeeded": "SIRET và VAT là bắt buộc đối với Pháp",
"ac.tLogo": "Logo đã cập nhật",
"ac.tLogoRemoved": "Logo đã được xóa",
"ac.tPayLinks": "Liên kết thanh toán đã lưu",
"ac.tPhone": "Số điện thoại đã lưu",
"ac.tSensitivity": "Mức độ nhạy đã lưu",
"ac.tVatInvalid": "Số VAT không hợp lệ",
"ac.tVatValid": "VAT hợp lệ",
"ac.tabBoost": "Độ hiển thị",
"ac.tabPayments": "Thanh toán",
"ac.tabProfile": "Hồ sơ",
"ac.tabQr": "QR & Biển quảng cáo",
"ac.tabReferral": "Giới thiệu",
"ac.tabSub": "Đăng ký",
"ac.thisWeek": "Tuần này",
"ac.thisWeekOf": " ({n} trong tuần này)",
"ac.thresholdDesc": "Ngưỡng tự tin mà AI tự động xác nhận sự khớp ảnh và thông báo cho khách hàng. Cao hơn = ít khớp tự động hơn nhưng đáng tin cậy hơn.",
"ac.thresholdTitle": "Độ nhạy khớp hình ảnh AI",
"ac.trend": "Xu hướng",
"ac.upload": "Tải lên",
"ac.vatValidFmt": "VAT hợp lệ{name} ({via})",
"ac.vatVerified": "VAT trong EU đã được xác minh",
"ac.verifyVat": "Xác minh VAT (VIES)",
"ac.verifying": "Đang xác minh…",
"ac.views": "lượt xem",
"ac.viewsTotal": "Lượt xem thu được (tổng)",
"ac.winbackBtn": "Tiếp tục với -20%",
"ac.winbackDesc1": "Bạn đã kiếm được",
"ac.winbackDesc2": "Khuyến mãi đặc biệt: -20% sẽ được áp dụng tự động nếu bạn gia hạn trong vòng 24h.",
"ac.winbackTitle": "Điểm nổi bật của bạn vừa hết hạn — tiếp tục với -20%!",
"ad.boost": "Tăng cường",
"ad.close": "Đóng",
"ad.closeConfirm": "Đóng danh sách này?",
"ad.closed": "Danh sách đã đóng",
"ad.edit": "Chỉnh sửa",
"ad.editTitle": "Chỉnh sửa danh sách",
"ad.saved": "Danh sách đã cập nhật",
"an.allCountries": "Tất cả các quốc gia",
"an.badge": "Món đồ mất",
"an.boostLater": "Sau",
"an.boostNow": "Tăng cường ngay",
"an.boostPrompt": "Tăng cường danh sách của bạn để đưa nó lên đầu và được tìm thấy nhanh hơn.",
"an.boosted": "Đã tăng cường",
"an.contact": "Tôi đã tìm thấy món đồ này",
"an.contactTitle": "Báo cáo rằng bạn đã tìm thấy món đồ này",
"an.copyFailed": "Không thể sao chép liên kết",
"an.copyLink": "Sao chép liên kết",
"an.country": "Quốc gia",
"an.date": "Ngày mất",
"an.finderEmail": "Email của bạn",
"an.finderName": "Tên của bạn",
"an.finderPhone": "Số điện thoại của bạn",
"an.geoBanner": "Bạn đang xem danh sách ở",
"an.geoBannerWorld": "Bạn đang xem danh sách toàn cầu",
"an.geoChange": "thay đổi quốc gia",
"an.goAccount": "Đi tới tài khoản của tôi",
"an.linkCopied": "Liên kết đã được sao chép!",
"an.loginRequired": "Đăng nhập để báo cáo món này và theo dõi việc trả lại.",
"an.loginToBoost": "Đăng nhập để nâng cao danh sách này",
"an.lostAt": "Mất tại",
"an.message": "Tin nhắn (tùy chọn)",
"an.none": "Chưa có danh sách nào.",
"an.photo": "Ảnh (tùy chọn)",
"an.post": "Đăng một danh sách",
"an.postSubtitle": "Mô tả món đồ bạn đã mất — cộng đồng và các đối tác của chúng tôi sẽ giúp bạn tìm lại nó.",
"an.postTitle": "Báo cáo một món đồ đã mất",
"an.publish": "Đăng danh sách",
"an.published": "Danh sách đã được công bố!",
"an.publishing": "Đang công bố…",
"an.remaining": "còn lại",
"an.requestInProgress": "Yêu cầu đang được xử lý",
"an.resolved": "Món đồ đã được phục hồi",
"an.reward": "Phần thưởng",
"an.searchPh": "Tìm một danh sách…",
"an.send": "Gửi",
"an.sent": "Tin nhắn đã được gửi tới chủ sở hữu!",
"an.shareConsent": "Tôi đồng ý rằng thông tin liên hệ của tôi (tên, email, điện thoại) có thể được chia sẻ với chủ sở hữu của món đồ.",
"an.shareConsentError": "Vui lòng đánh dấu vào ô để chia sẻ thông tin liên hệ của bạn.",
"an.sortRecent": "Mới nhất",
"an.sortRelevance": "Liên quan",
"an.subtitle": "Duyệt các món đồ được báo cáo mất bởi cộng đồng. Bạn đã tìm thấy một trong số chúng?",
"an.title": "Danh sách món đồ đã mất",
"anf.badge": "Món đồ đã tìm thấy",
"anf.claim": "Đây là của tôi",
"anf.claimSent": "Tin nhắn đã được gửi tới người tìm!",
"anf.claimTitle": "Báo cáo rằng đây là món đồ của bạn",
"anf.consent": "Tôi đồng ý rằng chủ sở hữu có thể xem thông tin liên hệ của tôi để phục hồi món đồ của họ.",
"anf.foundAt": "Tìm thấy tại",
"anf.foundDate": "Ngày tìm thấy",
"anf.loginCta": "Đăng nhập / tạo tài khoản",
"anf.loginDesc": "Cần có tài khoản người tìm để đăng danh sách và kiếm điểm Finder Hero.",
"anf.loginRequired": "Đăng nhập để đăng một món đồ đã tìm thấy",
"anf.photo": "Ảnh món đồ",
"anf.pointsEarned": "Cảm ơn bạn! Bạn vừa kiếm được điểm Finder Hero.",
"anf.pointsPending": "Điểm của bạn sẽ được ghi có trong vòng 24h, sau khi xác minh.",
"anf.post": "Đăng một món đồ đã tìm thấy",
"anf.postSubtitle": "Mô tả món đồ bạn đã tìm thấy — giúp chủ sở hữu lấy lại nó.",
"anf.postTitle": "Báo cáo một món đồ đã tìm thấy",
"anf.publishFound": "Đăng danh sách đã tìm",
"anf.published": "Danh sách món đồ đã tìm được công bố",
"anf.publishedAs": "Được công bố dưới",
"anf.shareConsent": "Tôi đồng ý rằng thông tin liên hệ của tôi (tên, email, điện thoại) có thể được chia sẻ với người đã tìm thấy món đồ.",
"anf.subtitle": "Duyệt các món đồ đã tìm thấy và được báo cáo bởi cộng đồng. Nhận ra của bạn không?",
"anf.title": "Danh sách món đồ đã tìm thấy",
"bo.active": "Đang tăng cường",
"bo.africaPrice": "Giá ưu đãi khu vực châu Phi đã được áp dụng",
"bo.pay": "Thanh toán & tăng cường",
"bo.remaining": "Thời gian còn lại",
"bo.renew": "Gia hạn tăng cường",
"bo.since": "kể từ khi tăng cường",
"bo.subtitle": "Đưa danh sách của bạn lên đầu danh sách với một huy hiệu dễ thấy.",
"bo.title": "Tăng cường danh sách",
"c.all": "Tất cả",
"c.cancel": "Hủy",
"c.close": "Đóng",
"c.confirm": "Xác nhận",
"c.confirmed": "Đã xác nhận",
"c.download": "Tải xuống",
"c.loading": "Đang tải…",
"c.reset": "Đặt lại",
"c.reviews": "đánh giá",
"c.save": "Lưu",
"c.transfer": "Chuyển khoản",
"cat.Animal": "Thú cưng / Phụ kiện thú cưng",
"cat.AppareilPhoto": "Máy ảnh",
"cat.Argent": "Tiền / Tiền mặt",
"cat.Autres": "Khác",
"cat.Bijoux": "Trang sức",
"cat.CarteBancaire": "Thẻ ngân hàng",
"cat.CarteIdentite": "Thẻ ID / Hộ chiếu",
"cat.Casquette": "Mũ / Nón",
"cat.Ceinture": "Thắt lưng",
"cat.Chargeur": "Sạc / Cáp",
"cat.Chaussures": "Giày",
"cat.CleVoiture": "Chìa khóa xe",
"cat.Cles": "Chìa khóa",
"cat.Console": "Máy chơi game",
"cat.Documents": "Tài liệu / Giấy tờ",
"cat.Echarpe": "Khăn quàng",
"cat.Ecouteurs": "Tai nghe",
"cat.Electronique": "Điện tử (khác)",
"cat.Enceinte": "Loa",
"cat.Gants": "Găng tay",
"cat.Gourde": "Bình nước / Bình giữ nhiệt",
"cat.Instrument": "Nhạc cụ",
"cat.Jouet": "Đồ chơi / Gấu bông",
"cat.Jumelles": "Kính viễn vọng",
"cat.Lampe": "Đèn / Đèn pin",
"cat.Liseuse": "Sách điện tử",
"cat.Livre": "Sách / vở",
"cat.Lunettes": "Kính",
"cat.Manteau": "Áo khoác",
"cat.Maquillage": "Túi trang điểm",
"cat.Medical": "Thiết bị y tế",
"cat.Medicaments": "Thuốc",
"cat.Montre": "Đồng hồ / Đồng hồ thông minh",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Ô",
"cat.Portefeuille": "Ví / Túi tiền",
"cat.Poussette": "Xe đẩy / Phụ kiện trẻ em",
"cat.Sac": "Túi / Túi xách",
"cat.SacADos": "Balo",
"cat.Souris": "Chuột / Bàn phím",
"cat.Sport": "Thiết bị thể thao",
"cat.Tablette": "Máy tính bảng",
"cat.Telephone": "Điện thoại / Smartphone",
"cat.Trottinette": "Xe scooter",
"cat.Trousse": "Túi / Bao",
"cat.USB": "USB / Ổ cứng",
"cat.Valise": "Va li / Hành lý",
"cat.Velo": "Xe đạp",
"cat.Vetements": "Quần áo",
"cat.placeholder": "Chọn một danh mục",
"cd.d": "d",
"cd.expired": "Đã hết hạn",
"cd.h": "h",
"cd.m": "ph",
"ck.accept": "Chấp nhận",
"ck.acceptAll": "Chấp nhận tất cả",
"ck.customize": "Tùy chỉnh",
"ck.learn": "Tìm hiểu thêm",
"ck.manage": "Quản lý cookie",
"ck.measurement": "Đo lường đối tượng",
"ck.measurementDesc": "Thống kê ẩn danh để cải thiện dịch vụ.",
"ck.msg": "Chúng tôi sử dụng cookie để duy trì hoạt động của trang và đo lường đối tượng.",
"ck.necessary": "Cần thiết",
"ck.necessaryDesc": "Cần thiết cho trang hoạt động. Luôn bật.",
"ck.refuse": "Từ chối",
"ck.save": "Lưu lựa chọn của tôi",
"ck.saved": "Tùy chọn đã được lưu",
"ck.title": "Tùy chọn cookie của bạn",
"cm.found": "ĐÃ TÌM THẤY",
"cm.lost": "ĐÃ MẤT",
"cmp.adv": "Nâng cao",
"cmp.ai": "Ghép đôi AI",
"cmp.autobill": "Lập hóa đơn tự động",
"cmp.basic": "Cơ bản",
"cmp.community": "Cộng đồng",
"cmp.consol": "Hóa đơn hợp nhất",
"cmp.custom": "Tùy chỉnh",
"cmp.dedicated": "Dành riêng",
"cmp.deploy": "Triển khai & SLA dành riêng",
"cmp.estIncl": "Các cơ sở bao gồm",
"cmp.estSec": "Cơ sở bổ sung",
"cmp.items": "Mục / tháng",
"cmp.main": "1 chính",
"cmp.max20": "Tối đa 20",
"cmp.members": "Lời mời thành viên",
"cmp.onQuote": "Báo giá tùy chỉnh",
"cmp.priority": "Ưu tiên",
"cmp.starterEst": "1 bao gồm + không giới hạn thêm",
"cmp.stats": "Thống kê",
"cmp.statsAdv": "Nâng cao",
"cmp.statsBasic": "Cơ bản",
"cmp.support": "Hỗ trợ",
"cmp.unlimited": "Không giới hạn",
"cmp.upTo3": "Tối đa 3",
"consent.required": "Bạn phải đồng ý chia sẻ thông tin liên hệ của mình để tiếp tục.",
"consent.share": "Tôi đồng ý rằng người tìm thấy đồ vật của tôi có thể xem thông tin liên hệ của tôi (tên, email, điện thoại) để liên lạc với tôi để trả lại.",
"cover.add": "Thêm",
"cover.change": "Thay đổi",
"cover.helper": "Hiển thị dưới dạng banner trên trang báo cáo của bạn và trong danh bạ.",
"cover.none": "Không có ảnh bìa",
"cover.remove": "Xóa",
"cover.title": "Ảnh bìa",
"crop.desc": "Điều chỉnh tỷ lệ khung hình cho banner (3:1). Kéo và phóng to.",
"crop.saving": "Đang lưu…",
"crop.title": "Cắt ảnh bìa",
"cta.button": "Tạo tài khoản đối tác của tôi",
"cta.subtitle": "Tham gia các cơ sở trả lại đồ nhanh hơn với findloop.",
"cta.title": "Bạn đã sẵn sàng để giảm thiểu đồ thất lạc chưa?",
"db.account.s": "Quản lý cơ sở, đăng ký và mã QR của bạn.",
"db.account.t": "Tài khoản của tôi",
"db.declarations.s": "Khách hàng đã báo cáo một món đồ bị thất lạc qua mã QR của bạn.",
"db.declarations.t": "Báo cáo thất lạc",
"db.deposit.s": "Thêm một bức ảnh, một danh mục và một mô tả.",
"db.deposit.t": "Ghi lại một món đồ tìm thấy",
"db.registry.s": "Tất cả các món đồ tìm thấy được ghi lại tại cơ sở của bạn.",
"db.registry.t": "Sổ đăng ký món đồ",
"db.reviews.s": "Đáp lại công khai nhận xét của khách hàng.",
"db.reviews.t": "Nhận xét của khách hàng",
"db.shipments.s": "Tạo nhãn và theo dõi bưu kiện để gửi.",
"db.shipments.t": "Giao hàng",
"db.stats.s": "Các chỉ số hiệu suất chính của bạn.",
"db.stats.t": "Thống kê",
"db.team.s": "Mời đồng nghiệp của bạn quản lý các món đồ.",
"db.team.t": "Đội ngũ",
"dc.partnerDesc": "Bạn đã làm mất đồ tại một địa điểm đối tác (khách sạn, ga, hội trường…)? Chọn nó để trả lại trực tiếp.",
"dc.partnerList": "Chọn từ danh sách",
"dc.partnerMap": "Chọn trên bản đồ",
"dc.partnerTitle": "Khai báo tại đối tác",
"dc.publicCta": "Đăng một thông báo công khai",
"dc.publicDesc": "Thông báo của bạn sẽ được nhìn thấy bởi toàn bộ cộng đồng findloop. Thích hợp nếu bạn không biết nơi đã mất đồ.",
"dc.publicTitle": "Khai báo công khai",
"dc.subtitle": "Chọn cách báo cáo món đồ bị mất của bạn.",
"dc.title": "Bạn muốn làm gì?",
"dec.addrPending": "Địa chỉ đang chờ từ khách hàng",
"dec.analyzing": "Đang phân tích…",
"dec.badge": "Báo cáo mất đồ",
"dec.category": "Danh mục món đồ",
"dec.clientDescription": "Mô tả của khách hàng",
"dec.clientPhoto": "Ảnh do khách hàng cung cấp",
"dec.clientPhotoShort": "Ảnh của khách hàng",
"dec.comparePhotos": "So sánh ảnh",
"dec.contactTitle": "Thông tin liên lạc của bạn",
"dec.date": "Ngày mất",
"dec.declaredItemPhoto": "Ảnh của món đồ đã khai báo",
"dec.descPh": "Mô tả món đồ: thương hiệu, màu sắc, dấu hiệu đặc trưng…",
"dec.description": "Mô tả",
"dec.email": "Email",
"dec.emptyDesc": "Chia sẻ mã QR của bạn để nhận báo cáo.",
"dec.emptyTitle": "Không có báo cáo",
"dec.enlarge": "Phóng to",
"dec.extBanner": "{n} giao dịch thanh toán bên ngoài cần xác nhận — xác nhận đã nhận bên dưới để mở khóa việc bàn giao hoặc giao hàng.",
"dec.foundItemAlt": "Món đồ tìm thấy",
"dec.foundItemRegistry": "Món đồ tìm thấy (sổ đăng ký)",
"dec.home": "Quay lại trang chính",
"dec.labelClient": "Khách hàng",
"dec.labelRegistry": "Sổ đăng ký",
"dec.matchFound": "Đã xác định được một sự trùng khớp!",
"dec.name": "Họ và tên",
"dec.noMatchYet": "Chưa có sự trùng khớp nào.",
"dec.noPhoto": "Không có ảnh",
"dec.notfound": "Đối tác không tìm thấy.",
"dec.pRecup": "khôi phục",
"dec.pRecupP": "(khôi phục)",
"dec.pRecupShip": "(khôi phục + giao hàng)",
"dec.payConfirmed": "Thanh toán {x} đã được xác nhận",
"dec.payPending": "Thanh toán bên ngoài {x} đang chờ",
"dec.phone": "Điện thoại",
"dec.pickup": "Nhận trực tiếp",
"dec.place": "Nơi mất",
"dec.placePh": "ví dụ: tại quán bar, phòng 204…",
"dec.recoverBtn": "Khôi phục đồ của tôi",
"dec.reject": "Từ chối",
"dec.rerun": "Chạy lại phân tích",
"dec.similarity": "Sự tương đồng {n}%",
"dec.submit": "Gửi báo cáo của tôi",
"dec.submitting": "Đang gửi…",
"dec.successText": "Chúng tôi đang tìm đồ của bạn trong số các đồ đang giữ tại",
"dec.successTitle": "Báo cáo đã được gửi!",
"dec.suggestedMatches": "Các kết quả gợi ý",
"dec.toColon": " đến:",
"dec.toShip": "Để gửi",
"dec.toastExtPay": "Thanh toán đã xác nhận - khách hàng sẽ được thông báo.",
"dec.toastMatch": "Kết quả đã được xác nhận",
"dec.toastReject": "Gợi ý bị từ chối",
"dec.toastRerun": "Phân tích đã được khởi động lại",
"dec.toastVisualN": "{n} kết quả hình ảnh",
"dec.toastVisualNone": "Không có kết quả hình ảnh",
"dec.trackBtn": "Theo dõi báo cáo của tôi",
"dec.viewBeforeAfter": "Hình ảnh trước/sau (chồng lên)",
"dec.viewSideBySide": "Xem song song",
"dec.visualCompare": "So sánh hình ảnh AI",
"dec.visualIdle": "Chạy so sánh để AI đối chiếu hình ảnh của khách hàng với các đồ đã tìm thấy.",
"dec.visualRunning": "AI đang so sánh hình ảnh của khách hàng với các đồ trong danh sách của bạn…",
"dec.zoomPhoto": "Phóng to ảnh",
"dep.addAnyway": "Thêm vẫn tiếp tục",
"dep.addError": "Lỗi khi thêm",
"dep.addItem": "Thêm đồ",
"dep.added": "Đồ đã được thêm vào danh sách!",
"dep.adding": "Đang thêm…",
"dep.aiError": "Phân tích AI hiện không khả dụng.",
"dep.aiFilled": "Mẫu đã được điền sẵn bởi AI ✨",
"dep.aiUnavailable": "AI không khả dụng - hãy điền mẫu thủ công.",
"dep.analyzing": "Đang phân tích…",
"dep.analyzingPhoto": "Đang phân tích ảnh…",
"dep.brand": "Thương hiệu",
"dep.brandPlaceholder": "ví dụ: Apple",
"dep.category": "Danh mục",
"dep.checkingDup": "Đang kiểm tra trùng lặp…",
"dep.color": "Màu sắc",
"dep.colorPlaceholder": "ví dụ: đen",
"dep.condition": "Tình trạng",
"dep.conditionPlaceholder": "ví dụ: tình trạng tốt",
"dep.depositorNote": "Ghi chú của người gửi",
"dep.depositorNoteHint": "Thông tin hoạt động được nhập thủ công. AI không bao giờ ghi đè lên ghi chú này.",
"dep.depositorNotePlaceholder": "ví dụ: nội dung của một túi, thương hiệu như đã báo cáo, chi tiết do người đó cung cấp…",
"dep.descPlaceholder": "ví dụ: iPhone 15 màu đen với ốp trong suốt, tìm thấy tại quán bar…",
"dep.description": "Mô tả",
"dep.dupHint": "Đảm bảo bạn không thêm một bản trùng lặp. Bạn có thể tiếp tục nếu món đồ thực sự khác biệt.",
"dep.dupTitle": "Món đồ tương tự đã được đăng ký",
"dep.dupWarn": "Món đồ tương tự đã được phát hiện - xem xét, sau đó nhấn lần nữa để xác nhận.",
"dep.estHint": "Món đồ sẽ được thêm vào danh sách của cơ sở này.",
"dep.establishment": "Cơ sở",
"dep.fee": "Phí khôi phục (€) - tùy chọn",
"dep.feePlaceholder": "Để trống cho giá mặc định của danh mục",
"dep.fillAI": "Điền bằng AI",
"dep.optional": "(tùy chọn)",
"dep.photo": "Hình ảnh mục",
"dep.principal": "chính",
"dep.reqError": "Danh mục và mô tả là bắt buộc.",
"dep.savedItem": "Mục đã đăng ký",
"dep.similarity": "Sự tương đồng",
"dep.storage": "Vị trí vật lý",
"dep.storageHint": "Nơi vật phẩm được lưu trữ. Một mã QR sẽ được tạo ra để tìm kiếm nó.",
"dep.storagePlaceholder": "ví dụ: Kệ A3, Tủ khóa 12, két an toàn tiếp tân",
"dl.aClient": "một khách hàng",
"dl.alertsBlocked": "Thông báo trình duyệt bị chặn",
"dl.alertsBlockedHint": "Để kích hoạt lại: nhấn vào biểu tượng 🔒 (hoặc ⓘ) bên trái địa chỉ trang web, sau đó cho phép Thông báo và tải lại trang.",
"dl.amountDue": "Số tiền phải trả: {amount} {currency}.",
"dl.enableAlerts": "Kích hoạt thông báo",
"dl.extPending": "Các khoản thanh toán cần xác thực",
"dl.freemiumNear": "Bạn gần đến giới hạn Freemium ({used}/{max} mục trong tháng này). Nâng cấp lên Starter để có số lượng mục không giới hạn.",
"dl.freemiumReached": "Đã đạt đến giới hạn Freemium ({used}/{max} mục trong tháng này). Nâng cấp lên Starter để đăng ký số lượng mục không giới hạn.",
"dl.invoiceOverdue": "Hóa đơn {num} chưa thanh toán — truy cập bị hạn chế.",
"dl.matchNotifTitle": "Findloop — Khớp AI mới 🔔",
"dl.matchToast": "Khớp AI mới — {name}",
"dl.matchToastDesc": "Một mục phù hợp với một khai báo.",
"dl.notifEmpty": "Chưa có thông báo nào.",
"dl.notifEnabled": "Thông báo trình duyệt đã được kích hoạt",
"dl.notifTitle": "Thông báo",
"dl.payInvoice": "Thanh toán hóa đơn của tôi →",
"dl.rewardsPending": "Phiếu quà tặng cần xuất trình",
"dl.upgradeStarter": "Nâng cấp lên Starter →",
"est.all": "Tất cả cơ sở ({n})",
"est.label": "Cơ sở",
"est.primary": "chính",
"est.secondary": "phụ",
"est2.add": "Thêm một cơ sở",
"est2.addressLabel": "Địa chỉ",
"est2.addressPh": "12 Đường République",
"est2.autoInvoice": "Hóa đơn chi tiết được tạo tự động vào ngày 1 hàng tháng.",
"est2.baseSub": "Đăng ký cơ bản",
"est2.billing": "Thanh toán",
"est2.boostActivated": "Kích hoạt tăng cường cho {name}",
"est2.boostBillingNote": "Tính phí theo mức giá hiện tại và được nhóm trong hóa đơn hàng tháng tổng hợp của bạn.",
"est2.boostCta": "Tăng cường",
"est2.boostDesc": "Cải thiện khả năng hiển thị của cơ sở này trong danh bạ và trên bản đồ.",
"est2.boostDuration": "{h}h khả năng hiển thị được tăng cường",
"est2.boostExtend": "Gia hạn",
"est2.boostTitle": "Tăng cường {name}",
"est2.boosted": "Đã được tăng cường",
"est2.chartDesc": "Tỷ lệ mục trả lại trong tổng số mục đã đăng ký, trang này qua trang khác.",
"est2.chartTitle": "Tỷ lệ trả lại theo cơ sở",
"est2.chartTooltip": "Trả lại",
"est2.cityLabel": "Thành phố",
"est2.cityPh": "Lyon",
"est2.contactHint": "Các chi tiết này được hiển thị cho khách hàng cho cơ sở này (trở về tài khoản nếu trống).",
"est2.countryLabel": "Quốc gia",
"est2.coverLabel": "Hình ảnh bìa",
"est2.create": "Tạo",
"est2.created": "Cơ sở đã được tạo",
"est2.delete": "Xóa",
"est2.deleteDesc": "Hành động này là vĩnh viễn. Bạn chỉ có thể xóa một cơ sở nếu nó không chứa mục nào.",
"est2.deleteTitle": "Xóa “{name}”?",
"est2.deleted": "Cơ sở đã bị xóa",
"est2.dialogDesc": "Nhập tên và địa chỉ của trang này.",
"est2.edit": "Chỉnh sửa",
"est2.editEst": "Chỉnh sửa cơ sở",
"est2.emailLabel": "Email liên hệ",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " cơ sở",
"est2.extraNoteBase": "{n} cơ sở bổ sung được tính phí",
"est2.extraPrice": " với {price} €/tháng.",
"est2.extraQuote": " theo báo giá.",
"est2.imgChange": "Chọn một hình ảnh",
"est2.imgDone": "Hoàn tất",
"est2.imgRemove": "Gỡ bỏ",
"est2.imgRemoved": "Hình ảnh đã gỡ bỏ",
"est2.imgSaved": "Hình ảnh đã lưu",
"est2.imgUploading": "Đang tải lên…",
"est2.includedPlan": "Bao gồm trong gói của bạn: {n}.",
"est2.kDeclarations": "Khai báo",
"est2.kInStorage": "Trong kho",
"est2.kItemsTotal": "Sản phẩm (tổng)",
"est2.kRestituted": "Đã trả lại",
"est2.limitReached": "Đã đạt giới hạn",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Khai báo",
"est2.mItems": "Sản phẩm",
"est2.mRestituted": "Đã trả lại",
"est2.mStorage": "Trong kho",
"est2.monthlyTotal": "Tổng hàng tháng",
"est2.nameLabel": "Tên *",
"est2.namePh": "ví dụ: Khách sạn Belmont — Lyon Annex",
"est2.newEst": "Cơ sở mới",
"est2.onQuote": "Theo báo giá",
"est2.phoneLabel": "Điện thoại",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Gói",
"est2.planLimited": "Gói “{tier}” của bạn bị giới hạn ở {max} cơ sở.",
"est2.primary": "Chính",
"est2.qr": "Mã QR",
"est2.qrDesc": "Hiển thị mã QR này tại cơ sở này. Khách hàng báo mất sẽ được liên kết với trang này.",
"est2.qrTitle": "Mã QR — {name}",
"est2.saving": "Đang lưu…",
"est2.seeInvoices": "Xem hóa đơn hàng tháng của tôi",
"est2.seePlans": "Xem các gói",
"est2.subtitle": "Quản lý tất cả các trang của bạn dưới một tài khoản — xem tổng hợp, sản phẩm, mã QR và thanh toán.",
"est2.suspended": "Tạm dừng",
"est2.tierFree": "1 cơ sở",
"est2.tierLarge": "cơ sở không giới hạn",
"est2.tierMedium": "5 cơ sở bao gồm",
"est2.tierSmall": "3 cơ sở bao gồm",
"est2.title": "Cơ sở",
"est2.unlimitedPlan": "Gói của bạn cho phép số lượng cơ sở không giới hạn.",
"est2.unlimitedSuffix": " · không giới hạn",
"est2.updated": "Cơ sở đã được cập nhật",
"est2.upgradeHint": "Nâng cấp lên gói cao hơn để thêm nhiều trang hơn và tập trung tất cả hoạt động của bạn.",
"est2.visuals": "Logo & ảnh",
"est2.visualsDesc": "Tùy chỉnh logo và ảnh bìa của cơ sở này. Chúng xuất hiện trên trang công khai và mẫu khai báo của nó.",
"est2.visualsTitle": "Hình ảnh — {name}",
"est2.workOn": "Làm việc trên cơ sở này",
"est2.working": "Bạn đang làm việc trên “{name}”",
"ev.created": "Báo cáo đã được tạo",
"ev.matched": "Sản phẩm phù hợp đã được xác định",
"ev.paid": "Phí phục hồi đã được thanh toán",
"ev.pickup": "Lấy hàng tại chỗ",
"ev.shipped": "Gói hàng đã được gửi",
"ev.shipping_paid": "Phí vận chuyển đã được thanh toán",
"ev.shipping_requested": "Yêu cầu vận chuyển",
"feat1.d": "KPIs, tỷ lệ hoàn trả theo danh mục, doanh thu và xu hướng 30 ngày.",
"feat1.t": "Bảng điều khiển & phân tích",
"feat2.d": "Nhãn hàng, theo dõi đơn vị vận chuyển và email theo dõi tự động.",
"feat2.t": "Mô-đun vận chuyển",
"feat3.d": "Khách hàng tìm bạn theo thành phố và danh mục, với đánh giá được chứng nhận.",
"feat3.t": "Danh bạ công cộng & đánh giá",
"fp.backToRanking": "Quay lại bảng xếp hạng",
"fp.badge": "Huy hiệu",
"fp.hero": "Anh hùng Finder",
"fp.notFound": "Hồ sơ không tìm thấy hoặc ở chế độ riêng tư.",
"fp.scoreTotal": "Tổng điểm",
"fp.scoreYear": "Điểm trong",
"fp.share": "Chia sẻ hồ sơ này",
"fp.shareText": "Xem hồ sơ finder của {name} trên Findloop!",
"fp.tagline": "Một finder trung thực đang làm cho thế giới trở nên tốt đẹp hơn.",
"ft.backAccount": "Quay lại Tài khoản của tôi",
"ft.closeBtn": "Đóng trường hợp",
"ft.closeConfirm": "Xác nhận món hàng đã được trả lại? Quảng cáo sẽ bị đóng.",
"ft.closeLockedHint": "Xác thực mã của chủ sở hữu trước để mở khóa việc đóng lại.",
"ft.closed": "Trường hợp đã đóng — món hàng đã được trả lại!",
"ft.codeLabel": "Nhập mã xác thực nhận từ chủ sở hữu",
"ft.codeNeeded": "Xin vui lòng nhập mã xác thực.",
"ft.codeOk": "Mã đã được xác thực — bạn có thể đóng trường hợp.",
"ft.codePlaceholder": "vd. 4821",
"ft.codeVerified": "Đã xác thực",
"ft.doneMsg": "Món hàng đã được trả lại. Cảm ơn bạn đã giúp trả lại cho chủ sở hữu!",
"ft.stepInProgress": "Quá trình trả hàng đang diễn ra",
"ft.stepPublished": "Quảng cáo đã được đăng",
"ft.stepReturned": "Món hàng đã được trả",
"ft.subtitle": "Theo dõi các bước cho đến khi món hàng được tìm thấy được trả lại.",
"ft.title": "Theo dõi hoàn trả",
"ft.verifyBtn": "Xác thực mã",
"hero.badge": "Nổi bật",
"hero.ctaFound": "Tôi đã tìm thấy một món hàng",
"hero.ctaLost": "Tôi đã mất một món hàng",
"hero.ctaPartner": "Trở thành đối tác",
"hero.subtitle": "Findloop giúp các cơ sở quản lý các món đồ bị mất — và cho phép khách hàng báo cáo mất mát sau đó lấy lại tài sản của họ, tại chỗ hoặc bằng cách vận chuyển.",
"hero.title": "Mỗi món hàng bị mất đều tìm thấy chủ sở hữu của nó.",
"home.champBecome": "Trở thành một finder",
"home.champCta": "Xem bảng xếp hạng",
"home.champSubtitle": "Mỗi món hàng được trả lại đều kiếm điểm. Tham gia bảng xếp hạng và giành phần thưởng.",
"home.champTitle": "Những người tìm kiếm hàng đầu của chúng tôi",
"how.eyebrow": "Cách thức hoạt động",
"how.title": "Từ giao hàng đến trả lại, một cách dễ dàng.",
"inv.all": "Tất cả",
"inv.allYears": "Tất cả các năm",
"inv.count": "Hóa đơn",
"inv.due": "đến hạn",
"inv.empty": "Chưa có hóa đơn nào.",
"inv.exportCsv": "Xuất CSV",
"inv.invoicePdf": "Hóa đơn PDF",
"inv.issued": "Đã phát hành",
"inv.noMatch": "Không có hóa đơn cho bộ lọc này.",
"inv.paid": "Đã thanh toán (€)",
"inv.paidOn": "đã thanh toán vào",
"inv.pay": "Thanh toán",
"inv.receipt": "Biên nhận",
"inv.reminders": "Nhắc nhở",
"inv.remindersDesc": "Nhắc nhở qua email và SMS đã được gửi cho hóa đơn này.",
"inv.remindersEmpty": "Chưa có nhắc nhở nào được gửi.",
"inv.rmDue": "Nhắc nhở ngày đến hạn",
"inv.rmManual": "Nhắc nhở thủ công",
"inv.rmSms": "Nhắc nhở SMS D+30",
"inv.rmStage": "Nhắc nhở",
"inv.statusPaid": "Đã thanh toán",
"inv.statusUnpaid": "Chưa thanh toán",
"inv.subtitle": "Xem và tải hóa đơn và biên nhận của bạn.",
"inv.title": "Hóa đơn của tôi",
"inv.unpaid": "Chưa thanh toán (€)",
"inv2.contractTitle": "Hợp đồng Findloop của tôi",
"inv2.detailByEst": "Chi tiết theo cơ sở",
"inv2.dueLabel": "Hạn nộp:",
"inv2.dueSuffix": " · hạn {date}",
"inv2.error": "Lỗi {status}",
"inv2.estCountIssued": "{n} cơ sở · phát hành vào {date}",
"inv2.estimate": "Ước tính (không tính phí) · {n} cơ sở",
"inv2.expired": " · đã hết hạn",
"inv2.exportCsv": "Xuất CSV",
"inv2.exportDone": "Tải xuống CSV hoàn tất",
"inv2.included": "Đã bao gồm",
"inv2.monthlyTitle": "Hóa đơn hàng tháng (đăng ký)",
"inv2.months": "+{n} tháng",
"inv2.paid": "Đã thanh toán",
"inv2.pay": "Thanh toán",
"inv2.previewTitle": "Xem trước hóa đơn tiếp theo của bạn —",
"inv2.renew": "Gia hạn hợp đồng của tôi",
"inv2.renewalsTitle": "Lịch sử gia hạn ({n})",
"inv2.renewedUntil": "Hợp đồng được gia hạn đến {date}",
"inv2.serviceTitle": "Hóa đơn dịch vụ (thu hồi & báo giá)",
"inv2.soon": "Sắp hết hạn",
"inv2.toPay": "Phải thanh toán",
"inv2.totalHtTva": "Tổng chưa bao gồm thuế · VAT",
"inv2.totalTtc": "Tổng đã bao gồm thuế",
"iu.addPhoto": "Thêm ảnh",
"iu.change": "Thay đổi",
"lang.label": "Ngôn ngữ",
"lb.allCountries": "Tất cả các quốc gia",
"lb.badge": "Bảng xếp hạng hàng năm",
"lb.champion": "🏆 Nhà vô địch của năm",
"lb.cityPh": "Lọc theo thành phố…",
"lb.empty": "Chưa có bảng xếp hạng cho các bộ lọc này.",
"lb.pts": "điểm",
"lb.resetNote": "Bảng xếp hạng năm hiện tại — được đặt lại vào ngày 1 tháng 1 hàng năm.",
"lb.returned": "đã được trả lại",
"lb.share": "Chia sẻ bảng xếp hạng",
"lb.shareText": "Xem bảng xếp hạng các nhà tìm kiếm hàng đầu trên Findloop!",
"lb.subtitle": "Mỗi lượt trả lại đều kiếm được điểm. Bảng xếp hạng sẽ được đặt lại vào ngày 1 tháng 1 hàng năm.",
"lb.tabFinders": "Nhà tìm kiếm",
"lb.tabPartners": "Cơ sở",
"lb.title": "Nhà tìm kiếm hàng đầu",
"lost.b2bDesc": "Bạn đã đánh mất nó ở khách sạn, trung tâm giao thông hoặc địa điểm đối tác? Tìm cơ sở và báo cáo mất mát của bạn.",
"lost.b2bTitle": "Báo cáo cho đối tác",
"lost.b2cDesc": "Đăng một quảng cáo công khai cho mọi người thấy, đề nghị phần thưởng và quảng bá nó để tăng cơ hội của bạn.",
"lost.b2cTitle": "Đăng quảng cáo công khai",
"lost.desc": "Chọn cách bạn muốn tiến hành.",
"lost.title": "Mất một món đồ?",
"map.allCategories": "Tất cả các danh mục",
"map.clear": "Đặt lại",
"map.exitFullscreen": "Thoát",
"map.filterCity": "Thành phố hoặc quốc gia…",
"map.fullscreen": "Toàn màn hình",
"map.heatmap": "Bản đồ nhiệt",
"map.high": "Cao",
"map.impactMonth": "món đồ được trả lại trong tháng này",
"map.impactTotal": "được trả lại tổng cộng",
"map.legend": "Các chấm màu từ đỏ (thấp) đến xanh (cao) dựa trên tỷ lệ trả lại; kích thước dựa trên số lượng món đồ.",
"map.locating": "Đang định vị… thêm địa chỉ vào cơ sở của bạn để xem chúng trên bản đồ.",
"map.low": "Thấp",
"map.mAll": "Tất cả",
"map.mFound": "Đã tìm thấy",
"map.mLost": "Đã mất",
"map.medium": "Trung bình",
"map.noItemRegistered": "Không có món đồ nào được đăng ký",
"map.noItems": "Không có món đồ",
"map.period30": "30 ngày qua",
"map.period7": "7 ngày qua",
"map.period90": "90 ngày qua",
"map.periodAll": "Tất cả thời gian",
"map.returnedSuffix": "được trả lại · {a}/{t} món đồ",
"map.stats": "Thống kê thành phố",
"map.statsTop": "5 địa điểm hàng đầu (món đồ đã mất)",
"map.statsTrend": "Xu hướng 6 tháng",
"map.title": "Bản đồ của các cơ sở của bạn",
"map.topPlaces": "Địa điểm phổ biến",
"mc.adClosed": "Danh sách đã đóng",
"mc.addPhoto": "Thêm ảnh",
"mc.adsNone": "Không có quảng cáo món đồ bị mất.",
"mc.archiveHide": "Ẩn lịch sử",
"mc.archiveNone": "Chưa có trường hợp nào được giải quyết.",
"mc.archiveShow": "Hiển thị lịch sử",
"mc.archiveSub": "Các trường hợp đã được giải quyết và trả lại.",
"mc.archiveTitle": "Lịch sử",
"mc.at": "Tại",
"mc.backToLogin": "Quay lại đăng nhập",
"mc.boostContacts": "Liên hệ (tăng cường)",
"mc.boostViews": "Lượt xem (tăng cường)",
"mc.cancel": "Hủy",
"mc.certificate": "Chứng chỉ",
"mc.changePhoto": "Thay đổi ảnh",
"mc.city": "Thành phố",
"mc.closeAd": "Đóng",
"mc.closeAdConfirm": "Đóng danh sách này? Nó sẽ không còn hiển thị và sẽ giải phóng một slot.",
"mc.confirmPassword": "Xác nhận mật khẩu",
"mc.confirmRestitution": "Xác nhận trả lại",
"mc.connect": "Kết nối",
"mc.contacts": "Liên hệ",
"mc.country": "Quốc gia",
"mc.declareFound": "Báo cáo một món đồ đã tìm thấy",
"mc.declareFoundSub": "Đăng một món đồ bạn đã tìm thấy",
"mc.declareLost": "Báo cáo một món đồ đã mất",
"mc.declareLostSub": "Đăng một danh sách món đồ đã mất",
"mc.deleteAccount": "Xóa tài khoản của tôi",
"mc.deleteConfirm": "Có, xóa tài khoản của tôi",
"mc.deleteConfirmBody": "Tài khoản của bạn sẽ bị xóa vĩnh viễn và dữ liệu cá nhân của bạn sẽ được ẩn danh. Hành động này không thể thu hồi.",
"mc.deleteConfirmTitle": "Bạn có muốn xóa tài khoản không?",
"mc.deleteDesc": "Xóa tài khoản của bạn vĩnh viễn và ẩn danh dữ liệu cá nhân. Hành động này không thể hoàn tác.",
"mc.deleted": "Tài khoản của bạn đã được xóa.",
"mc.deleting": "Đang xóa…",
"mc.email": "Email",
"mc.expiresOn": "Hết hạn vào",
"mc.exportData": "Tải dữ liệu của tôi (GDPR)",
"mc.exportDone": "Dữ liệu của bạn đã được tải xuống.",
"mc.exporting": "Đang chuẩn bị…",
"mc.finderAccepted": "Đã chấp nhận",
"mc.finderProfile": "Hồ sơ tìm kiếm (tùy chọn)",
"mc.finderProfileDesc": "Kiếm điểm bằng cách trả lại đồ vật và xuất hiện trên bảng xếp hạng công khai.",
"mc.forYourAd": "Cho danh sách của bạn",
"mc.forgotLink": "Quên mật khẩu?",
"mc.forgotSend": "Gửi liên kết",
"mc.forgotSent": "Nếu tài khoản tồn tại cho email này, một liên kết đặt lại vừa được gửi đi.",
"mc.forgotTitle": "Quên mật khẩu",
"mc.foundAdsNone": "Chưa có danh sách đồ vật tìm thấy nào được công bố.",
"mc.foundAt": "Tìm thấy tại",
"mc.foundNone": "Chưa có đồ vật tìm thấy nào được báo cáo.",
"mc.hAd": "Quảng cáo mất",
"mc.hDeclaration": "Tuyên bố",
"mc.hFinderContact": "Đồ vật đã báo cáo",
"mc.hFound": "Đồ vật được trả lại",
"mc.hFoundAd": "Quảng cáo tìm thấy",
"mc.histEarned": "Đồ vật đã trả lại",
"mc.historyTitle": "Lịch sử điểm của tôi",
"mc.loginBtn": "Đăng nhập",
"mc.loginTitle": "Đăng nhập khách hàng",
"mc.logout": "Đăng xuất",
"mc.lostAt": "Mất tại",
"mc.matchPartner": "Tại một đối tác",
"mc.matchPublic": "Đồ vật tìm thấy",
"mc.matches": "Trận đấu",
"mc.matchesSub": "Các đồ vật tìm thấy có thể trùng khớp với danh sách đồ vật đã mất của bạn.",
"mc.myAds": "Quảng cáo đồ vật đã mất của tôi",
"mc.myDeclarations": "Báo cáo của tôi",
"mc.myFinds": "Các đồ vật tôi tìm thấy",
"mc.myFindsNone": "Bạn vẫn chưa báo cáo tìm thấy đồ vật nào.",
"mc.myFindsSub": "Các đồ vật bạn đã báo cáo tìm thấy trên quảng cáo đồ vật đã mất.",
"mc.myFound": "Đồ vật tìm thấy đã báo cáo",
"mc.myFoundAds": "Danh sách đồ vật tìm thấy của tôi",
"mc.myRewards": "Phiếu thưởng của tôi",
"mc.name": "Họ và tên",
"mc.newPassword": "Mật khẩu mới",
"mc.none": "Chưa có báo cáo nào.",
"mc.notEnough": "Không đủ điểm",
"mc.notifEmpty": "Chưa có thông báo nào.",
"mc.notifOpen": "Xem",
"mc.notifTitle": "Thông báo",
"mc.notifTrack": "Theo dõi",
"mc.notifViewAd": "Xem quảng cáo",
"mc.optInDesc": "Tham gia tùy chọn. Bạn đồng ý hiển thị công khai các đồ vật được chọn bên dưới. Có thể thay đổi bất cứ lúc nào.",
"mc.optInTitle": "Xuất hiện trên bảng xếp hạng công khai",
"mc.password": "Mật khẩu",
"mc.passwordMismatch": "Mật khẩu không khớp.",
"mc.phone": "Điện thoại",
"mc.photoUpdated": "Ảnh đại diện đã được cập nhật",
"mc.pointsAwaiting": "Điểm đang chờ",
"mc.pointsBalance": "Điểm để sử dụng",
"mc.pointsOk": "Điểm đã được ghi có",
"mc.presentHint": "Hiển thị QR này cho đối tác: họ quét nó để xác nhận phần thưởng của bạn.",
"mc.presentInStore": "Hiển thị tại cửa hàng",
"mc.presentTitle": "Hiển thị voucher này",
"mc.privacy": "Quyền riêng tư & dữ liệu",
"mc.privacyDesc": "Tải xuống bản sao tất cả dữ liệu cá nhân mà Findloop lưu giữ về bạn (GDPR, điều 15 & 20).",
"mc.profileSaved": "Hồ sơ đã được cập nhật.",
"mc.profileSettings": "Hồ sơ công khai & bảng xếp hạng",
"mc.pseudo": "Tên đầu tiên hoặc biệt danh",
"mc.redExpired": "Hết hạn",
"mc.redReady": "Hiển thị tại đối tác",
"mc.redUsed": "Đã sử dụng",
"mc.redeem": "Đổi thưởng",
"mc.registerBtn": "Tạo tài khoản của tôi",
"mc.registerTitle": "Tạo tài khoản khách hàng",
"mc.rememberMe": "Ghi nhớ tôi",
"mc.remove": "Xóa",
"mc.resetDone": "Mật khẩu đã được cập nhật. Bạn có thể đăng nhập ngay bây giờ.",
"mc.resetExpired": "Liên kết đặt lại này không hợp lệ hoặc đã hết hạn. Yêu cầu một cái mới bên dưới.",
"mc.resetSave": "Đặt lại mật khẩu của tôi",
"mc.resetTitle": "Mật khẩu mới",
"mc.restitutionConfirmed": "Trả lại đã được xác nhận.",
"mc.reward": "Phần thưởng",
"mc.rewardRedeemed": "Phần thưởng đã được mở khóa! Mã:",
"mc.rewardsDesc": "Sử dụng điểm của bạn cho những đặc quyền mà các đối tác của chúng tôi cung cấp. Số dư:",
"mc.rewardsNone": "Chưa có phần thưởng nào khả dụng.",
"mc.rewardsTitle": "Chi tiêu điểm của tôi",
"mc.scoreAwarded": "Làm tốt lắm! +1 vào Điểm Finder của bạn 🎉",
"mc.scoreEarned": "Điểm đã kiếm được",
"mc.scorePts": "điểm",
"mc.scoreThisYear": "Năm nay",
"mc.scoreTitle": "Điểm Finder",
"mc.seeRanking": "Xem bảng xếp hạng",
"mc.share": "Chia sẻ",
"mc.statsTitle": "Thống kê",
"mc.subtitle": "Theo dõi tất cả báo cáo của bạn tại một nơi.",
"mc.title": "Tài khoản của tôi",
"mc.toLogin": "Đã đăng ký chưa?",
"mc.toRegister": "Chưa có tài khoản?",
"mc.track": "Theo dõi",
"mc.views": "Lượt xem",
"mc.visCity": "Thành phố",
"mc.visCountry": "Quốc gia",
"mc.visLabel": "Các mục hiển thị trên bảng xếp hạng:",
"mc.visName": "Tên đầu tiên / biệt danh",
"mc.visPhoto": "Ảnh đại diện",
"mc.welcome": "Xin chào",
"mc2.acceptFinder": "Chấp nhận người tìm này",
"mc2.accountActivity": "Hoạt động tài khoản",
"mc2.adsActive": "{n}/5 quảng cáo đang hoạt động",
"mc2.autoDelete": "Xóa tự động được lên lịch cho",
"mc2.badgeBronze": "Đồng",
"mc2.badgeGold": "Vàng",
"mc2.badgeSilver": "Bạc",
"mc2.boostEarnedAlready": "Nó đã kiếm cho bạn",
"mc2.boostEarnedWin": "Nó đã kiếm cho bạn",
"mc2.boostExpiredWin": "Tăng tốc của bạn vừa hết hạn - tiếp tục với -20%!",
"mc2.boostExpiresIn": "Tăng tốc của bạn sẽ hết hạn trong",
"mc2.boostWinDetail2": ". -20% sẽ được áp dụng tự động nếu bạn gia hạn trong vòng 24h.",
"mc2.claimCode": "Mã yêu cầu:",
"mc2.codeSentFinder": "Mã đã được gửi đến người tìm qua email",
"mc2.daysShort": "{n} ngày",
"mc2.downloadReceipt": "Tải biên lai của tôi",
"mc2.error": "Lỗi {status}",
"mc2.finderAccepted": "Finder được chấp nhận — mã đã được gửi qua email",
"mc2.finderContacts": "Thông tin liên lạc của Finder(s)",
"mc2.followFindo": "Theo dõi Findloop",
"mc2.imgInvalid": "Hình ảnh không hợp lệ",
"mc2.inactivityNote": " — trong trường hợp {n} tháng không hoạt động (GDPR).",
"mc2.lastActivity": "Hoạt động gần nhất:",
"mc2.lostEmailTitle": "Tôi không còn truy cập vào email của mình",
"mc2.noPhotoPreset": "Chưa có ảnh? Chọn một avatar mặc định:",
"mc2.paidViaPartner": "Đã thanh toán (qua đối tác)",
"mc2.payRecovery": "Thanh toán phí phục hồi",
"mc2.paySettle": "Giải quyết khoản thanh toán của tôi",
"mc2.payShipping": "Thanh toán phí vận chuyển",
"mc2.payUnavailable": "Thanh toán không khả dụng",
"mc2.peopleFound": "{n} người nghĩ rằng họ đã tìm thấy đồ vật của bạn",
"mc2.phoneNumber": "Số điện thoại",
"mc2.reactivateAccount": "Kích hoạt lại tài khoản của tôi",
"mc2.reactivated": "Tài khoản đã được kích hoạt lại",
"mc2.reactivatedThanks": "Tài khoản đã được kích hoạt lại — cảm ơn bạn vì sự trung thành!",
"mc2.recoverSmsBtn": "Nhận mã của tôi qua SMS",
"mc2.recoverSmsDesc": "Nhận mã yêu cầu của bạn qua SMS đến số đã đăng ký trên tài khoản của bạn.",
"mc2.recoverSmsFallback": "Nếu có tài khoản với số này, một SMS đã được gửi.",
"mc2.renewStayTop": ". Gia hạn để giữ vị trí hàng đầu và phục hồi đồ vật của bạn.",
"mc2.resume20": "Tiếp tục -20%",
"mc2.unlockContacts": "Mở khóa thông tin liên lạc",
"mc2.unlockDesc": "Thanh toán phí xử lý của Findloop để hiển thị thông tin liên lạc của họ và sắp xếp việc bàn giao.",
"mc2.viewsWord": "lượt xem",
"mc2.live": "Trực tiếp",
"mh.allCategories": "Tất cả danh mục",
"mh.allPeriod": "Tất cả thời gian",
"mh.autoMatch": "Giao diện phù hợp tự động AI",
"mh.blocked": "Bị chặn (mâu thuẫn)",
"mh.blockedReason": "Giao diện bị chặn: các từ khóa chính của đồ vật và tuyên bố mâu thuẫn với nhau.",
"mh.days30": "30 ngày qua",
"mh.days7": "7 ngày qua",
"mh.days90": "90 ngày qua",
"mh.emptyDesc": "Các giao diện AI sẽ xuất hiện ở đây khi có các tuyên bố được gửi đến.",
"mh.emptyTitle": "Không có sự kiện",
"mh.exportCsv": "Xuất khẩu CSV",
"mh.exportDone": "Tải về CSV đã hoàn tất",
"mh.exportImpossible": "Xuất khẩu thất bại",
"mh.fBlocked": "Đã bị chặn",
"mh.fConfirmed": "Đã xác nhận",
"mh.fRejected": "Bị từ chối",
"mh.objectLabel": "Đồ vật:",
"mh.refresh": "Làm mới",
"mh.rejected": "Bị từ chối",
"mh.srcManual": "Thủ công",
"mh.srcText": "Văn bản",
"mh.srcVisual": "Hình ảnh (ảnh)",
"mh.subtitle": "Nhật ký các giao diện được đề nghị bởi AI — được tự động phù hợp, xác nhận và bị từ chối.",
"mh.title": "Lịch sử AI",
"nav.ads": "Đồ vật bị mất",
"nav.dashboard": "Không gian của tôi",
"nav.found": "Đồ vật đã tìm thấy",
"nav.how": "Cách hoạt động",
"nav.login": "Đăng nhập",
"nav.map": "Bản đồ",
"nav.more": "Thêm",
"nav.partners": "Đối tác",
"nav.pricing": "Giá cả",
"nav.ranking": "Bảng xếp hạng",
"nav.register": "Trở thành đối tác",
"nav.track": "Theo dõi báo cáo",
"nf.desc": "Trang bạn đang tìm kiếm không tồn tại hoặc đã được chuyển đi.",
"nf.home": "Quay về trang chủ",
"nf.title": "Không tìm thấy trang",
"par.allCities": "Tất cả các thành phố",
"par.allCountries": "Tất cả các quốc gia",
"par.badge": "Danh bạ",
"par.certified": "Được chứng nhận",
"par.certifiedBadge": "Chứng nhận",
"par.cityPh": "Thành phố",
"par.declare": "Báo cáo",
"par.none": "Không tìm thấy đối tác nào.",
"par.partnerBadge": "Đối tác",
"par.searchPh": "Tìm kiếm một cơ sở …",
"par.subtitle": "Tìm cơ sở nơi bạn đã đánh mất đồ và báo cáo mất mát của bạn.",
"par.title": "Những đối tác của chúng tôi",
"pay.addr1": "Địa chỉ",
"pay.addr2": "Địa chỉ line 2 (tùy chọn)",
"pay.addrIncomplete": "Vui lòng điền địa chỉ giao hàng của bạn.",
"pay.badge": "Phục hồi",
"pay.card": "Thanh toán bằng thẻ",
"pay.city": "Thành phố",
"pay.country": "Quốc gia",
"pay.eurNote": "Số tiền hiển thị bằng euro (€).",
"pay.fee": "Phí phục hồi",
"pay.free": "miễn phí",
"pay.howRecover": "Bạn muốn nhận đồ của mình lại bằng cách nào?",
"pay.momo": "Thanh toán bằng Mobile Money",
"pay.momoConfirm": "Xác nhận thanh toán",
"pay.noMatch": "Chưa có đồ nào phù hợp được xác nhận cho báo cáo này.",
"pay.notfound": "Không tìm thấy báo cáo.",
"pay.phonePh": "Số điện thoại",
"pay.pickup": "Nhận trực tiếp",
"pay.pickupDesc": "Tại",
"pay.postal": "Mã bưu điện",
"pay.secure": "Thanh toán an toàn",
"pay.serviceFee": "Phí dịch vụ Findloop",
"pay.ship": "Gửi hàng cho tôi",
"pay.shipAfter": "— được cung cấp sau khi thanh toán.",
"pay.shipDesc": "Giao hàng đến địa chỉ của tôi",
"pay.shipNote": "Có sẵn giao hàng",
"pay.shipping": "Phí vận chuyển",
"pay.subtitleWith": "Thanh toán phí phục hồi cho",
"pay.title": "Phục hồi đồ của tôi",
"pay.total": "Tổng cộng",
"pcat.city_hall": "Biển báo thành phố",
"pcat.hotel": "Khách sạn",
"pcat.other": "Khác",
"pcat.park": "Công viên",
"pcat.prefecture": "Tỉnh",
"pcat.restaurant": "Nhà hàng",
"pcat.uncategorized": "Chưa được phân loại",
"pd.about": "Giới thiệu",
"pd.back": "Tất cả các đối tác",
"pd.certified": "Đối tác được chứng nhận",
"pd.declare": "Báo cáo mất mát tại đây",
"pd.itemsReturned": "hạng mục đã trả",
"pd.itemsTotal": "hạng mục đã đăng ký",
"pd.map": "Địa điểm",
"pd.noItems": "Không tìm thấy hạng mục nào gần đây.",
"pd.noReviews": "Chưa có đánh giá nào.",
"pd.notFound": "Đối tác không tìm thấy.",
"pd.recentItems": "Hạng mục tìm thấy gần đây",
"pd.reply": "Phản hồi từ cơ sở",
"pd.reviews": "Đánh giá của khách hàng",
"pd.verified": "Đánh giá đã xác thực",
"pd.verifiedEstablishment": "cơ sở đã xác thực của Findloop",
"pg.next": "Tiếp theo",
"pg.prev": "Trước đó",
"pg.showing": "{from}–{to} của {total}",
"pk.bodyCopy": "Nội dung chính",
"pk.bodyText": "Văn bản chính",
"pk.brandColors": "Màu thương hiệu",
"pk.colorRed": "Đỏ",
"pk.colorWhite": "Trắng",
"pk.darkBg": "Nền tối",
"pk.download": "Tải về",
"pk.downloadZip": "Tải toàn bộ bộ (ZIP)",
"pk.headings": "Tiêu đề",
"pk.heroDesc": "Logo chính thức, b banner mạng xã hội, màu sắc và kiểu chữ. Chọn ngôn ngữ và biến thể của slogan, sau đó tải về hình ảnh hoặc toàn bộ bộ.",
"pk.lightBg": "Nền sáng (in ấn)",
"pk.logoWordmark": "Logo / chữ thương hiệu",
"pk.logosVisuals": "Logos & hình ảnh",
"pk.mapCollect": "Bản đồ / điểm tập hợp",
"pk.plain": "Đơn giản",
"pk.pressKit": "Bộ tài liệu báo chí",
"pk.taglineLang": "Ngôn ngữ slogan",
"pk.typography": "Kiểu chữ",
"pk.variant": "Biến thể",
"pr.shipBtn": "Gửi hạng mục",
"pr2.adBoostMsg": "Lựa chọn tuyệt vời! Bạn tăng khả năng phục hồi hạng mục của mình một cách nhanh chóng.",
"pr2.boostActivated": "Tăng cường đã kích hoạt!",
"pr2.canRecoverNow": "Bạn có thể phục hồi hạng mục của mình ngay bây giờ.",
"pr2.continue": "Tiếp tục",
"pr2.downloadReceiptPdf": "Tải biên lai (PDF)",
"pr2.goToSpaceNow": "Đi đến tài khoản của tôi ngay bây giờ",
"pr2.partnerBoostMsg": "Lựa chọn tuyệt vời! Tăng cường độ hiển thị có nghĩa là thu hút khách hàng mới đến cơ sở của bạn.",
"pr2.paymentSuccess": "Thanh toán thành công!",
"pr2.redirectingSpace": "Đang chuyển hướng đến tài khoản của bạn…",
"pr2.subActivated": "Thanh toán thành công! Đăng ký của bạn đã hoạt động, bạn có thể quản lý các cơ sở của mình ngay bây giờ.",
"prev.allSites": "Tất cả các cơ sở",
"prev.editReply": "Chỉnh sửa phản hồi",
"prev.none": "Chưa có đánh giá nào.",
"prev.published": "Phản hồi đã được xuất bản",
"prev.reply": "Phản hồi",
"prev.replyPh": "Viết một phản hồi lịch sự…",
"prev.send": "Xuất bản phản hồi",
"prev.sending": "Đang xuất bản…",
"prev.yourReply": "Phản hồi của bạn",
"pricing.annual": "Hàng năm",
"pricing.annualBadge": "-20% ưu đãi",
"pricing.choose": "Chọn",
"pricing.compareFeature": "Tính năng",
"pricing.compareTitle": "So sánh gói",
"pricing.eyebrow": "Giá cả",
"pricing.month": "/tháng",
"pricing.monthly": "Hàng tháng",
"pricing.perYear": "/năm",
"pricing.popular": "Phổ biến",
"pricing.quoteMsg": "Nhu cầu của bạn (tùy chọn)",
"pricing.quoteOrg": "Tổ chức",
"pricing.quoteSend": "Gửi yêu cầu",
"pricing.quoteSent": "Yêu cầu đã được gửi! Chúng tôi sẽ phản hồi lại bạn sớm.",
"pricing.quoteSites": "Số lượng trang / đầu cuối",
"pricing.quoteTitle": "Yêu cầu báo giá",
"pricing.requestQuote": "Yêu cầu báo giá",
"pricing.saveLabel": "Bạn tiết kiệm",
"pricing.savePerYear": "/năm cho mỗi cơ sở thêm",
"pricing.start": "Bắt đầu",
"pricing.subtitle": "Bắt đầu miễn phí, mở rộng khi bạn phát triển.",
"pricing.title": "Kế hoạch cho mọi tổ chức",
"promo.badge": "Chương trình đối tác",
"promo.cta": "Tìm hiểu thêm",
"promo.text": "Mỗi đối tác bạn giới thiệu đăng ký sẽ cho bạn một tháng miễn phí. Không giới hạn.",
"promo.title": "Giới thiệu đối tác, nhận một tháng miễn phí.",
"pub.accessGranted": "Truy cập đã được cấp",
"pub.accessLimited2h": "Truy cập giới hạn trong 2 giờ",
"pub.accountEmailConcerned": "Email của tài khoản liên quan",
"pub.adAppearPublic": "Đây là cách quảng cáo của bạn sẽ xuất hiện công khai.",
"pub.adPreviewBtn": "Xem trước quảng cáo",
"pub.alertMeOnArrival": "Thông báo cho tôi khi đến",
"pub.allActionsLogged": "Tất cả hành động đều được ghi lại",
"pub.allCategories": "Tất cả danh mục",
"pub.authorizeAccess": "Cấp quyền truy cập",
"pub.authorizeSupportQ": "Cấp quyền truy cập hỗ trợ?",
"pub.available": "Có sẵn",
"pub.backHome": "Quay lại trang chủ",
"pub.boostAdCta": "Cải thiện quảng cáo của tôi",
"pub.boostAdTitle": "Cải thiện quảng cáo của bạn",
"pub.boostCarouselSub": "Di chuyển lên đầu trang trong carousel “Đã cải thiện” và tăng lượt xem để phục hồi vật phẩm của bạn nhanh hơn.",
"pub.boostEstablishment": "Cải thiện cơ sở của bạn",
"pub.boostEstablishmentDesc": "Xuất hiện ở đầu danh bạ với huy hiệu “Đã cải thiện” và thu hút nhiều báo cáo hơn.",
"pub.boostFicheCta": "Cải thiện danh sách của tôi",
"pub.brandReady": "Thương hiệu Findloop, sẵn sàng sử dụng",
"pub.cantFindItem": "Không tìm thấy vật phẩm của bạn?",
"pub.cantProcessImage": "Không thể xử lý hình ảnh này",
"pub.claimQr": "Khiếu nại mã QR",
"pub.clickToZoom": "Nhấn vào để phóng to",
"pub.codeAlreadyValidated": "Mã đã được xác thực — liên lạc đã được mở khóa.",
"pub.codeExample": "vd. ABCD2345",
"pub.confirmRenewal": "Xác nhận gia hạn",
"pub.contactIntro": "Một câu hỏi, một yêu cầu? Viết cho chúng tôi, chúng tôi sẽ phản hồi lại bạn sớm.",
"pub.contactTypeDeceased": "Xóa tài khoản (người đã qua đời)",
"pub.contactTypeGeneral": "Câu hỏi chung",
"pub.contactTypeSupport": "Hỗ trợ / vấn đề kỹ thuật",
"pub.contactUs": "Liên hệ với chúng tôi",
"pub.continueWithoutEmail": "Tiếp tục mà không để lại email của tôi",
"pub.contractLabel": "Hợp đồng",
"pub.contractNotFound": "Hợp đồng không được tìm thấy hoặc đã hết hạn.",
"pub.contractRenewed": "Hợp đồng đã được gia hạn!",
"pub.contractRenewedFor": "Hợp đồng của bạn được gia hạn trong {n} tháng.",
"pub.copyFailed": "Sao chép không thành công",
"pub.createPartnerAccount": "Tạo tài khoản đối tác của tôi",
"pub.currentDeadline": "Thời hạn hiện tại",
"pub.deceasedInfo": "Là người thân hoặc thừa kế, bạn có thể yêu cầu xóa tài khoản Findloop của người đã qua đời. Chúng tôi sẽ xử lý yêu cầu của bạn theo quy định GDPR (có thể yêu cầu tài liệu hỗ trợ).",
"pub.declareMyLoss": "Báo cáo mất mát của tôi",
"pub.describeItemPlaceholder": "Mô tả món đồ của bạn (ví dụ: ô đen, chìa khóa…)",
"pub.downloadImage": "Tải ảnh xuống",
"pub.drawSignature": "Vui lòng ký tên của bạn.",
"pub.drawSignatureHint": "Ký tên của bạn bằng chuột hoặc ngón tay.",
"pub.duration": "Thời gian",
"pub.eSignature": "Chữ ký điện tử",
"pub.eSignatureDesc": "Nhập tên của bạn để ký. Ngày tháng sẽ được ghi lại tự động.",
"pub.edit": "Chỉnh sửa",
"pub.editorialTitles": "Tiêu đề biên tập",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "Nhập mã đã nhận qua email để mở khóa thông tin liên lạc của chủ sở hữu.",
"pub.errorWord": "Lỗi",
"pub.foundSelfService": "Đã tìm thấy món đồ · Tự phục vụ",
"pub.haveOwnerCode": "Tôi đã nhận mã từ chủ sở hữu",
"pub.home": "Trang chủ",
"pub.immediateRenewal": "Gia hạn ngay lập tức, không cần báo giá mới.",
"pub.impAdminReq1": "Quản trị viên",
"pub.impAdminReq2": "yêu cầu quyền truy cập tạm thời vào tài khoản của bạn",
"pub.impAdminReq3": "để hỗ trợ bạn.",
"pub.impGrantedDesc": "Nhóm hỗ trợ sẽ có thể truy cập vào tài khoản của bạn trong tối đa 2 giờ. Mọi hành động sẽ được ghi lại. Bạn có thể đóng trang này.",
"pub.invitedOnFindo": "Bạn đã được mời tham gia Findloop",
"pub.isThisYourItem": "Có phải đây là món đồ của bạn không?",
"pub.itemsAvailableCount": "{n} món đồ hiện có",
"pub.itemsFoundOwner": "các món đồ được ủy thác đã tìm thấy chủ sở hữu",
"pub.itemsReturnedOwners": "món đồ đã được trả lại cho chủ sở hữu",
"pub.itsMine": "Nó là của tôi",
"pub.joinFindoDesc": "Tham gia Findloop và quản lý các món đồ bạn đã tìm thấy một cách dễ dàng.",
"pub.joinInvitesYou": "mời bạn tham gia findloop. Tạo tài khoản đối tác của bạn để quản lý các món đồ bạn đã tìm thấy.",
"pub.linkCopied": "Đã sao chép liên kết!",
"pub.loadingContract": "Đang tải hợp đồng…",
"pub.lsClaimDesc": "Báo cáo sự mất mát của bạn để khôi phục nó. Để lại email của bạn và chúng tôi sẽ gửi cho bạn một lời nhắc nếu báo cáo của bạn chưa hoàn thành.",
"pub.lsHeroDesc": "Kiểm tra xem món đồ bị mất của bạn đã được tìm thấy và để lại đây hay chưa. Đã tìm thấy? Báo cáo để khôi phục nó.",
"pub.lsSearchTitle": "Tìm kiếm các món đồ đã tìm thấy",
"pub.makeOffer": "Đưa ra đề nghị",
"pub.makeOfferDesc": "Đề xuất số tiền của bạn. Superadmin sẽ xem xét nó.",
"pub.mapNearYou": "Món đồ & đối tác gần bạn",
"pub.mapWord": "Bản đồ",
"pub.messageSentToast": "Tin nhắn đã được gửi — đội ngũ của chúng tôi sẽ trả lời sớm.",
"pub.messageWord": "Tin nhắn",
"pub.momoInitiated": "Thanh toán Mobile Money đã được khởi động",
"pub.monthsWord": "tháng",
"pub.nameConsentRequired": "Cần có tên và sự đồng ý.",
"pub.newDeadline": "Thời hạn mới",
"pub.noActionRequired": "Không cần hành động nào.",
"pub.noAmountCharged": "Không có số tiền nào được tính.",
"pub.noItemMatch": "Hiện tại không có món đồ nào phù hợp với tìm kiếm của bạn.",
"pub.noMatchingItem": "Không có món đồ nào phù hợp",
"pub.noPaymentSession": "Không có phiên thanh toán.",
"pub.noPhoto": "Không có ảnh",
"pub.noPointsYet": "Chưa có điểm nào để hiển thị.",
"pub.noSecondPayment": "Không cần thanh toán lần thứ hai cho món đồ này.",
"pub.notHereYet": "Chưa có ở đây? Nhận thông báo ngay khi nó đến nơi.",
"pub.notifyDone": "Đã ghi nhận! Chúng tôi sẽ thông báo cho bạn qua email ngay khi có món đồ phù hợp đến nơi.",
"pub.offerSubmitted": "Đề nghị của bạn đã được gửi.",
"pub.oops": "Ôi",
"pub.orAlertEmail": "Hoặc nhận thông báo qua email ngay khi có món đồ phù hợp đến nơi:",
"pub.ownerContacts": "Thông tin liên lạc của chủ sở hữu",
"pub.ownerContactsUnlocked": "Thông tin liên lạc của chủ sở hữu đã được mở khóa",
"pub.partnerContact": "Thông tin liên lạc của đối tác",
"pub.payLinkUnavailable": "Liên kết thanh toán không khả dụng — liên hệ với đối tác.",
"pub.paymentCancelled": "Thanh toán đã bị hủy",
"pub.paymentConfirmed": "Thanh toán đã được xác nhận 🎉",
"pub.paymentConfirmedDesc": "Bạn sẽ nhận được email với chi tiết để lấy lại vật phẩm của bạn.",
"pub.paymentNotConfirmed": "Thanh toán chưa được xác nhận",
"pub.paymentNotConfirmedDesc": "Không thể xác minh thanh toán. Hãy thử lại hoặc liên hệ với đối tác.",
"pub.paymentProcessing": "Đang xử lý thanh toán. Vui lòng làm mới sau một chút.",
"pub.photoAdded": "✓ Ảnh đã được thêm",
"pub.photoRequired": "Cần có ảnh của vật phẩm.",
"pub.previewAlt": "xem trước",
"pub.publish": "Đăng",
"pub.publishingWord": "Đang đăng…",
"pub.qty": "Số lượng",
"pub.quoteDeclined": "Báo giá bị từ chối.",
"pub.quoteNotFound": "Báo giá không tìm thấy hoặc đã hết hạn.",
"pub.reasonLabel": "Lý do",
"pub.recoveryAlreadyPaid": "Phí phục hồi đã được thanh toán",
"pub.referralCode": "Mã giới thiệu:",
"pub.relationshipPlaceholder": "Con, vợ/chồng, công chứng viên…",
"pub.renewYourContract": "Gia hạn hợp đồng của bạn",
"pub.renewalFailed": "Gia hạn không thành công. Hãy thử lại sau.",
"pub.renewing": "Đang gia hạn…",
"pub.replySoon": "Nhóm của chúng tôi sẽ phản hồi sớm nhất có thể.",
"pub.requestGone": "Yêu cầu này không còn tồn tại.",
"pub.requestHandled": "Yêu cầu đã được xử lý",
"pub.requestNotFound": "Yêu cầu không tìm thấy hoặc đã hết hạn.",
"pub.requestUnavailable": "Yêu cầu không khả dụng",
"pub.required": "(bắt buộc)",
"pub.retroClosing": "Cùng nhau, chúng ta làm cho thế giới bớt lạc lối một chút.",
"pub.retroClosing2": "Cùng nhau, chúng ta làm cho thế giới bớt lạc lối một chút.",
"pub.retroScroll": "Một năm phục hồi những gì quan trọng. Cuộn xuống ↓",
"pub.revokeAnytime": "Bạn có thể hủy bất cứ lúc nào bằng cách liên hệ với chúng tôi",
"pub.scene": "Cảnh",
"pub.sendImpossible": "Không thể gửi",
"pub.sendMessage": "Gửi tin nhắn",
"pub.sending": "Đang gửi…",
"pub.sharePreview": "Chia sẻ xem trước",
"pub.shareYourAd": "Chia sẻ quảng cáo của bạn",
"pub.signedSuccess": "Đã ký thành công!",
"pub.signerFullName": "Họ và tên người ký",
"pub.spreadNetwork": "Chia sẻ với những người xung quanh để tăng cơ hội của bạn.",
"pub.spreadOwner": "Chia sẻ để giúp chủ sở hữu lấy lại tài sản của họ.",
"pub.statusLabel": "Trạng thái:",
"pub.subject": "Chủ đề",
"pub.thanksSent": "Cảm ơn, tin nhắn của bạn đã được gửi.",
"pub.thisYear": "Năm nay",
"pub.validate": "Xác nhận",
"pub.verifyingPayment": "Đang xác minh thanh toán…",
"pub.verifyingYourPayment": "Đang xác minh thanh toán của bạn…",
"pub.viewAd": "Xem quảng cáo →",
"pub.viewPartner": "Xem đối tác →",
"pub.yourAdPreview": "Xem trước quảng cáo của bạn",
"pub.yourEmail": "Email của bạn",
"pub.yourEmailRecommended": "Email của bạn (khuyến nghị)",
"pub.yourEmailShort": "Email của bạn",
"pub.yourName": "Tên của bạn",
"pub.yourRelationship": "Mối quan hệ của bạn với người đó",
"qv.acceptAndSign": "Chấp nhận và ký báo giá của tôi",
"qv.certifyAuthorized": "Tôi xác nhận rằng tôi được phép ký và tôi chấp nhận các điều khoản của {what} này (giá trị ràng buộc).",
"qv.clear": "Xóa",
"qv.client": "Khách hàng",
"qv.conditions": "Điều khoản",
"qv.confirmDecline": "Xác nhận từ chối báo giá này?",
"qv.countersignedFindo": "Được đối chiếu bởi Findloop · {name} vào {date}",
"qv.decline": "Từ chối",
"qv.description": "Mô tả",
"qv.downloadPdf": "Tải xuống PDF",
"qv.handwrittenSignature": "Chữ ký tay",
"qv.inclTax": "Đã bao gồm thuế",
"qv.invalidAmount": "Số tiền không hợp lệ.",
"qv.invoice": "Hóa đơn",
"qv.invoicePaid": "Hóa đơn đã được thanh toán",
"qv.issuer": "Người phát hành",
"qv.messageOptional": "Tin nhắn (tuỳ chọn)",
"qv.negotiatedAmount": "Số tiền đã thương lượng",
"qv.payInvoiceOnline": "Thanh toán hóa đơn trực tuyến",
"qv.quote": "Báo giá",
"qv.quoteValidDays": "Báo giá có hiệu lực trong {n} ngày.",
"qv.sendMyOffer": "Gửi đề nghị của tôi",
"qv.signContract": "Ký hợp đồng của tôi",
"qv.signNow": "Ký ngay",
"qv.signatureAlt": "Chữ ký",
"qv.signedByOn": "✔ Được ký bởi {name} vào {date}",
"qv.stContractSigned": "Hợp đồng đã được ký. Cảm ơn bạn!",
"qv.stCounterAccepted": "Đề nghị của bạn đã được chấp nhận! Ký hợp đồng của bạn bên dưới.",
"qv.stCounterRefused": "Đề nghị của bạn không thể được chấp nhận.",
"qv.stCountered": "Đề nghị của bạn đã được gửi. Đang chờ phản hồi từ findloop.",
"qv.stDeclined": "Bạn đã từ chối báo giá này.",
"qv.stSigned": "Báo giá đã được chấp nhận và ký. Cảm ơn bạn!",
"qv.totalHt": "Tổng chưa bao gồm thuế",
"qv.totalTtc": "Tổng đã bao gồm thuế",
"qv.unitHt": "Đơn vị chưa bao gồm thuế",
"qv.vat": "VAT",
"qv.yourProposedAmount": "Số tiền đề nghị của bạn ({cur})",
"rate.chooseNote": "Vui lòng chọn đánh giá.",
"rate.commentPh": "Một bình luận (tuỳ chọn)…",
"rate.home": "Quay về trang chủ",
"rate.submit": "Gửi đánh giá của tôi",
"rate.submitting": "Đang gửi…",
"rate.subtitle": "Quá trình phục hồi đồ vật của bạn diễn ra như thế nào?",
"rate.successText": "Phản hồi của bạn giúp ích cho người dùng khác.",
"rate.successTitle": "Cảm ơn bạn vì đánh giá của bạn!",
"rate.title": "Đánh giá trải nghiệm của bạn",
"reg.add": "Ghi nhận một đồ vật",
"reg.allBrands": "Tất cả thương hiệu",
"reg.allColors": "Tất cả màu sắc",
"reg.allLocations": "Tất cả địa điểm",
"reg.detailDesc": "Chi tiết và hành động cho đồ vật tìm thấy này.",
"reg.dispAuction": "Đấu giá",
"reg.dispAuthorities": "Đã giao cho chính quyền",
"reg.dispDestroyed": "Đã tiêu hủy",
"reg.dispDonate": "Quyên góp từ thiện",
"reg.dispositionHint": "Ghi lại đồ vật rời khỏi kho. Được tính vào thống kê theo danh mục.",
"reg.emptyCta": "Ghi nhận một đồ vật",
"reg.emptyDesc": "Bắt đầu bằng cách ghi nhận đồ vật đầu tiên của bạn.",
"reg.emptyTitle": "Chưa tìm thấy đồ vật nào",
"reg.establishmentFallback": "cơ sở",
"reg.lblAuctioned": "được liệt kê tại đấu giá",
"reg.lblAuctionedShort": "đã đấu giá",
"reg.lblAuthorities": "đã giao cho chính quyền",
"reg.lblDestroyed": "đã bị tiêu hủy",
"reg.lblDonated": "đã quyên góp cho từ thiện",
"reg.legalCount": "{n} mục: thời gian lưu giữ pháp lý đã đạt",
"reg.legalHint": "Bạn có thể đưa chúng vào đấu giá, quyên góp cho từ thiện, hoặc báo cáo cho cơ quan chức năng.",
"reg.legalLimitCountry": "Thời hạn: {date} · quốc gia áp dụng: {country}",
"reg.legalOver": "Thời hạn đã qua: {date} · {country}",
"reg.legalReached": "Thời gian pháp lý đã đạt",
"reg.legalReachedFull": "Thời gian lưu giữ pháp lý đã đạt",
"reg.limitShort": "thời hạn",
"reg.location": "Vị trí",
"reg.markRestituted": "Đánh dấu là đã trả lại",
"reg.markedAs": "Mục đã được đánh dấu là {label}",
"reg.moveHistory": "Lịch sử di chuyển",
"reg.overBy": "quá {n} ngày",
"reg.physicalLocation": "Vị trí vật lý",
"reg.popupBlocked": "Cho phép pop-up để in nhãn.",
"reg.popupBlockedOne": "Cho phép pop-up để in nhãn.",
"reg.printLabel": "In nhãn",
"reg.printN": "In {n} nhãn",
"reg.qrCodeItem": "Mã QR của mục",
"reg.qrLabelTitle": "Nhãn QR",
"reg.qrLabelsTitle": "Nhãn QR",
"reg.qrNotFound": "Không tìm thấy mục cho mã QR này.",
"reg.qrScanHint": "Quét để mở hồ sơ này trực tiếp và tìm vị trí.",
"reg.recoveryFee": "Phí phục hồi (€)",
"reg.searchPh": "Tìm kiếm theo mô tả…",
"reg.selectQr": "Chọn để in nhãn QR",
"reg.selectedN": "{n} đã chọn",
"reg.shipPricePh": "Giá vận chuyển (€)",
"reg.shippingPossible": "Vận chuyển có sẵn",
"reg.storagePh": "vd. Kệ A3, Tủ khóa 12",
"reg.tAuction": "Đấu giá trên Findloop",
"reg.tAuthorities": "Báo cáo cho cơ quan chức năng",
"reg.tDonate": "Quyên góp cho từ thiện",
"reg.toastFee": "Phí đã được cập nhật",
"reg.toastLocation": "Vị trí đã được lưu",
"reg.toastRestituted": "Mục đã được đánh dấu là đã trả lại",
"reg.toastShipping": "Tùy chọn vận chuyển đã được cập nhật",
"reg.toastTransferred": "Mục đã được chuyển đến “{name}”",
"reg.unclaimedDisposition": "Mục không được nhận — xử lý cuối cùng",
"res.codeValidated": "Mã đã được xác thực",
"res.empty": "Chưa ghi nhận sự trả lại nào.",
"res.error": "Lỗi {status}",
"res.proofPdf": "Chứng từ PDF",
"res.signed": "Đã ký",
"res.stRestituted": "Đã trả lại trực tiếp",
"res.stShipped": "Đã trả lại qua vận chuyển",
"res.subtitle": "Tất cả các bàn giao đã hoàn thành, với chứng từ đã ký có thể tải xuống.",
"res.title": "Lịch sử hoàn trả",
"rev.b2b": "Đối tác B2B",
"rev.b2c": "Khách hàng",
"rev.based": "dựa trên {n} đánh giá",
"rev.eyebrow": "Chứng thực",
"rev.restitutedBy": "Được trả lại bởi {org}",
"rev.storiesEyebrow": "Kết thúc hạnh phúc",
"rev.storiesSubtitle": "Câu chuyện thực tế từ khách hàng đã lấy lại tài sản của họ với findloop.",
"rev.storiesTitle": "Họ đã tìm thấy tài sản của mình!",
"rev.subtitle": "Đối tác và khách hàng chia sẻ kinh nghiệm của họ.",
"rev.title": "Họ tin tưởng Findloop",
"rev.verified": "Đã xác thực",
"rp.already": "Bạn đã báo cáo danh sách này rồi.",
"rp.comment": "Chi tiết (tuỳ chọn)",
"rp.duplicate": "Trùng lặp",
"rp.fraud": "Lừa đảo",
"rp.inappropriate": "Nội dung không phù hợp",
"rp.offensive": "Nội dung phản cảm",
"rp.other": "Khác",
"rp.reason": "Lý do",
"rp.report": "Báo cáo",
"rp.send": "Gửi báo cáo",
"rp.sent": "Báo cáo đã được gửi. Cảm ơn bạn đã đóng góp.",
"rp.spam": "Spam / quảng cáo",
"rp.title": "Báo cáo danh sách này",
"rp.wrongCategory": "Danh mục sai",
"rt.annualGoal": "Mục tiêu hàng năm",
"rt.championCity": "Thành phố dẫn đầu",
"rt.cityRate": "Tỷ lệ hoàn lại {rate}%",
"rt.goalProgress": "{rate}% đã đạt được trong số {target}%",
"rt.reached": "Đã đạt 🎉",
"rt.restitutionRate": "Tỷ lệ hoàn lại",
"rt.shareRecap": "Chia sẻ tóm tắt của tôi",
"rt.thanks": "Cảm ơn Findloop {year} 💛",
"rt.yourRecap": "Tóm tắt {year} của bạn",
"rw.active": "Đang hoạt động",
"rw.add": "Thêm",
"rw.camUnavailable": "Camera không khả dụng. Nhập mã bằng tay ở dưới.",
"rw.codeValidated": "Mã đã được xác thực",
"rw.codesTitle": "Mã đã được tìm thấy bởi những người tìm",
"rw.confirmDelete": "Xóa “{title}”?",
"rw.deleted": "Đã xóa",
"rw.edit": "Chỉnh sửa",
"rw.editReward": "Chỉnh sửa phần thưởng",
"rw.empty": "Chưa có phần thưởng nào.",
"rw.expired": "Đã hết hạn",
"rw.expiresOn": "Hết hạn vào {date}",
"rw.fActive": "Đang hoạt động (thấy bởi những người tìm)",
"rw.fCost": "Chi phí (điểm)",
"rw.fDesc": "Mô tả",
"rw.fStock": "Kho (trống = không giới hạn)",
"rw.fTitle": "Tiêu đề",
"rw.fValidity": "Thời hạn voucher (ngày sau khi đổi)",
"rw.inactive": "Không hoạt động",
"rw.newReward": "Phần thưởng mới",
"rw.noExchange": "Chưa có đổi nào.",
"rw.pageSubtitle": "Quét các voucher được trình bày bởi những người tìm để xác thực các phần thưởng của họ.",
"rw.redeemedN": "Đã đổi: {n}×",
"rw.saved": "Phần thưởng đã lưu",
"rw.scanVoucher": "Quét một voucher",
"rw.staffScanOnly": "Chỉ quét",
"rw.statActive": "Để trình bày",
"rw.statExpired": "Đã hết hạn",
"rw.statRedeemed": "Voucher đã được đổi",
"rw.statUsed": "Đã xác thực",
"rw.stock": "Kho",
"rw.subtitle": "Cung cấp các quyền lợi không tiền tệ (voucher, nâng cấp…) mà những người tìm đổi lấy điểm Finder Score của họ.",
"rw.title": "Phần thưởng cho những người tìm",
"rw.used": "Đã sử dụng",
"rw.validate": "Xác thực",
"rw.validateCode": "Xác thực mã",
"rw.validity": "Thời hạn: {n} d",
"shell.f1d": "Tự động liên kết các vật bị mất và tìm thấy.",
"shell.f1t": "Khớp AI thông minh",
"shell.f2d": "Theo dõi tỷ lệ trả hàng và doanh thu theo thời gian thực.",
"shell.f2t": "Bảng điều khiển & doanh thu",
"shell.f3d": "Khách hàng của bạn báo cáo trong 30 giây.",
"shell.f3t": "Mã QR đối tác",
"shell.title": "Biến đồ thất lạc thành khách hàng hài lòng.",
"ship.addr1": "Địa chỉ",
"ship.addr2": "Dòng địa chỉ 2 (tùy chọn)",
"ship.badge": "Vận chuyển",
"ship.city": "Thành phố",
"ship.country": "Quốc gia",
"ship.needPaid": "Thanh toán phí phục hồi trước khi yêu cầu vận chuyển.",
"ship.notShippable": "Mặt hàng này không có sẵn để vận chuyển.",
"ship.notfound": "Báo cáo không tìm thấy.",
"ship.postal": "Mã bưu chính",
"ship.price": "Phí vận chuyển",
"ship.submit": "Yêu cầu vận chuyển",
"ship.submitting": "Đang gửi…",
"ship.subtitle": "Nhập địa chỉ giao hàng của bạn.",
"ship.successText": "Đối tác sẽ chuẩn bị gói hàng của bạn. Bạn sẽ nhận được thông báo khi đã được gửi đi.",
"ship.successTitle": "Yêu cầu vận chuyển đã được gửi!",
"ship.title": "Vận chuyển mặt hàng của bạn",
"ship.weight": "Trọng lượng ước tính (kg)",
"shp.carrier": "Nhà vận chuyển",
"shp.download": "Tải PDF",
"shp.generating": "Đang tạo…",
"shp.label": "Tạo nhãn",
"shp.none": "Chưa yêu cầu vận chuyển.",
"shp.setTracking": "Lưu theo dõi",
"shp.status": "Trạng thái",
"shp.to": "Người nhận",
"shp.tracking": "Số theo dõi",
"shp.trackingSaved": "Theo dõi đã được lưu",
"side.account": "Tài khoản của tôi",
"side.declarations": "Báo cáo",
"side.deposit": "Ghi nhận mặt hàng",
"side.establishments": "Cơ sở",
"side.invoices": "Hóa đơn",
"side.logout": "Đăng xuất",
"side.matchHistory": "Lịch sử AI",
"side.partner": "Đối tác",
"side.refresh": "Làm mới",
"side.registry": "Đăng ký",
"side.restitutions": "Trả hàng",
"side.reviews": "Đánh giá",
"side.rewards": "Phần thưởng & Voucher",
"side.settings": "Cài đặt",
"side.shipments": "Gói hàng",
"side.stats": "Thống kê",
"side.storage": "Lưu trữ & QR",
"side.team": "Nhóm",
"side.viewSite": "Xem trang công khai",
"st.auctioned": "Bán đấu giá",
"st.claimed": "Đã lấy lại",
"st.closed": "Đã đóng",
"st.delivered": "Đã giao",
"st.destroyed": "Đã bị phá hủy",
"st.donated": "Đã quyên góp (từ thiện)",
"st.handed_to_authorities": "Đã giao cho chính quyền",
"st.in_storage": "Đang lưu trữ",
"st.matched": "Đã tìm thấy đối tượng",
"st.open": "Mở",
"st.paid": "Đã thanh toán",
"st.pending": "Đang chờ",
"st.resolved": "Đã giải quyết",
"st.restituted": "Đã trả lại",
"st.second_chance": "Cơ hội thứ hai",
"st.shipped": "Đã giao hàng",
"st.shipping_requested": "Yêu cầu vận chuyển",
"st.submitted": "Đã nộp",
"st.verified": "Đã xác minh",
"stat.items": "Các mặt hàng đã đăng ký",
"stat.partners": "Đối tác",
"stat.restituted": "Các mặt hàng đã trả lại",
"status.auctioned": "Đã đấu giá",
"status.destroyed": "Đã tiêu hủy",
"status.donated": "Đã quyên góp (từ thiện)",
"status.handed_to_authorities": "Đã bàn giao cho chính quyền",
"status.in_storage": "Trong kho",
"status.matched": "Trùng khớp",
"status.open": "Mở",
"status.paid": "Đã thanh toán",
"status.pending": "Đang chờ",
"status.restituted": "Đã trả lại",
"status.shipped": "Đã giao hàng",
"status.shipping_requested": "Yêu cầu vận chuyển",
"status.submitted": "Đã nộp",
"step1.tag": "Thiết lập",
"step1.text": "Chỉ trong vài giây, cơ sở ghi lại mặt hàng đã tìm thấy với ảnh, danh mục và mô tả. Tất cả được tập trung trong một đăng ký rõ ràng, an toàn.",
"step1.title": "Đối tác đăng ký mặt hàng",
"step2.tag": "Khách hàng",
"step2.text": "Thông qua mã QR của đối tác, khách hàng của bạn mô tả mặt hàng bị mất trong 30 giây. Không cần cài đặt ứng dụng — tất cả diễn ra trên trình duyệt.",
"step2.title": "Khách hàng báo cáo mất mát",
"step3.tag": "Trí tuệ",
"step3.text": "Công cụ so khớp thông minh của chúng tôi so sánh mô tả và gợi ý các sự trùng khớp có khả năng cao nhất, sẵn sàng xác nhận.",
"step3.title": "AI liên kết mất mát và mặt hàng tìm thấy",
"step4.tag": "Khôi phục",
"step4.text": "Sau khi thanh toán phí khôi phục một cách an toàn, khách hàng sẽ lấy lại mặt hàng tại chỗ — hoặc nhận nó qua vận chuyển đã được theo dõi.",
"step4.title": "Khách hàng nhận lại mặt hàng",
"stg.allLabels": "Tất cả nhãn QR",
"stg.camHint": "Sử dụng nhập thủ công bên dưới.",
"stg.camStarting": "Đang khởi động camera…",
"stg.camUnavailable": "Camera không khả dụng.",
"stg.clear": "Xóa",
"stg.clearAll": "Xóa tất cả",
"stg.codeUnreadable": "Mã không thể đọc được.",
"stg.emptyDesc": "Các mặt hàng đã lưu sẽ xuất hiện đây, được nhóm theo vị trí.",
"stg.emptyTitle": "Không có mặt hàng trong kho",
"stg.exportAudit": "Xuất báo cáo CSV",
"stg.exportDone": "Tải xuống xuất CSV",
"stg.exportImpossible": "Xuất không khả dụng ngay bây giờ.",
"stg.itemFound": "Đã tìm thấy mặt hàng ✅",
"stg.kLocations": "Các vị trí đã sử dụng",
"stg.kObjects": "Các mặt hàng đã lưu",
"stg.kToClear": "Các vị trí cần xóa",
"stg.locFreed": "Vị trí đã được xóa",
"stg.locsFreed": "{n} vị trí đã được xóa",
"stg.manualLabel": "Hoặc nhập mã / ID của mặt hàng",
"stg.manualPh": "Dán ID hoặc URL của QR",
"stg.noItemMatch": "Không có mặt hàng nào trùng khớp với QR / mã này.",
"stg.noLocation": "Không có vị trí",
"stg.objectsAxis": "Mục",
"stg.objectsN": "{n} mục",
"stg.occAvg": "trung bình {n} mục/vị trí",
"stg.occHint": "Cac vị trí màu hổ phách vượt quá mức trung bình (có thể quá tải).",
"stg.occupancy": "Tình trạng chiếm dụng vị trí",
"stg.openPage": "Mở trang",
"stg.posterPdf": "Áp phích PDF (A4)",
"stg.printAll": "In tất cả",
"stg.printGroupTitle": "In nhãn cho kệ này",
"stg.qrAlt": "QR tự phục vụ",
"stg.qrDownload": "Tải QR",
"stg.qrHint": "Hiển thị QR này tại quầy: khách hàng của bạn quét nó để kiểm tra xem mục của họ có sẵn không.",
"stg.qrTitle": "QR tự phục vụ cho khách hàng",
"stg.scanDesc": "Quét nhãn của một mục để mở hồ sơ của nó ngay lập tức.",
"stg.scanQr": "Quét QR",
"stg.scanTitle": "Quét mã QR",
"stg.search": "Tìm kiếm",
"stg.shelf": "Kệ {loc}",
"stg.shelfPlan": "Kế hoạch kệ",
"stg.staleHint": "Xóa những vị trí này để giữ cho hàng tồn kho của bạn được cập nhật.",
"stg.staleTitle": "{n} mục đã rời khỏi kho nhưng vẫn giữ vị trí",
"stg.subtitle": "Kế hoạch kệ, máy quét QR và theo dõi hàng tồn kho vật lý.",
"stg.title": "Kho & QR",
"stt.acceptRate": "Tỷ lệ chấp nhận",
"stt.accepted": "Đã chấp nhận",
"stt.activity30": "Hoạt động (30 ngày qua)",
"stt.ai6mo": "6 tháng qua · chấp nhận = tự động khớp + đã xác nhận.",
"stt.aiEmpty": "Chưa có khớp AI nào trong khoảng thời gian này.",
"stt.aiTitle": "Khớp AI — đã chấp nhận so với bị từ chối",
"stt.auctionShort": "Đấu giá",
"stt.auctionedSold": "Đấu giá (đã bán)",
"stt.authShort": "Cơ quan",
"stt.authorities": "Đã giao cho cơ quan",
"stt.avgRating": "Đánh giá trung bình",
"stt.awaitingRestitution": "mục đang chờ hoàn trả",
"stt.boostClicks": "Lượt nhấp vào danh mục của bạn trong tuần này nhờ tăng cường",
"stt.boostInactive": "Tăng cường không hoạt động — kích hoạt để có được sự chú ý",
"stt.certifiedPremium": "Chứng nhận cao cấp",
"stt.declarations": "Khai báo",
"stt.destroyed": "Đã tiêu hủy",
"stt.dispoEmpty": "Chưa có mục không được yêu cầu nào rời kho.",
"stt.donatedAssoc": "Đã quyên góp (từ thiện)",
"stt.donatedShort": "Đã quyên góp",
"stt.gateCta": "Khám phá các kế hoạch",
"stt.gateDesc": "Nâng cấp lên Starter để mở khóa các thống kê cơ bản của bạn, hoặc lên Business để có các thống kê nâng cao và phân tích theo đơn vị.",
"stt.gateTitle": "Thống kê dành riêng cho các gói trả phí",
"stt.inStorage": "Trong kho",
"stt.kItems": "Mục đã đăng ký",
"stt.kRate": "Tỷ lệ trả lại",
"stt.kRestituted": "Mục đã trả lại",
"stt.kRevenue": "Doanh thu (tháng)",
"stt.noDeclYet": "Chưa có khai báo nào.",
"stt.recapDownloaded": "Tóm tắt đã được tải xuống — sẵn sàng để chia sẻ!",
"stt.recapError": "Không thể tạo tóm tắt",
"stt.recapText": "Tóm tắt {year} của chúng tôi từ Findloop: các mục đã trả lại và sự hài lòng của khách hàng 🎉",
"stt.recapTitle": "Tóm tắt {year} của Findloop",
"stt.rejected": "Bị từ chối",
"stt.restitutions": "Hoàn trả",
"stt.shareRecap": "Chia sẻ tóm tắt {year} của tôi",
"stt.topCategories": "Các danh mục được khai báo nhiều nhất",
"stt.unclaimedDesc": "Khối lượng đồ vật bị tiêu hủy, quyên góp cho tổ chức từ thiện và đấu giá, theo danh mục.",
"stt.unclaimedTitle": "Các đồ vật không được yêu cầu — rời khỏi kho",
"stt.vsLastWeek": "so với tuần trước",
"sub.cancel": "Hủy đăng ký của tôi",
"sub.cancelAbort": "Hủy",
"sub.cancelConfirm1": "Bạn có chắc chắn muốn hủy không? Quyền truy cập của bạn sẽ vẫn hoạt động cho đến",
"sub.cancelConfirm2": "Sẽ không có khoản hoàn tiền nào được phát hành.",
"sub.cancelConfirmBtn": "Xác nhận hủy",
"sub.cancelTitle": "Hủy đăng ký của bạn",
"sub.cancelledToast": "Đã ghi nhận việc hủy.",
"sub.cguAnd": "và",
"sub.cguDesc": "Vui lòng xác nhận sự đồng ý của bạn trước khi thanh toán.",
"sub.cguLink": "Điều khoản sử dụng",
"sub.cguPay": "Tiếp tục đến thanh toán",
"sub.cguPre": "Tôi đã đọc và chấp nhận",
"sub.cguRequired": "Bạn phải chấp nhận Điều khoản sử dụng và Chính sách quyền riêng tư để tiếp tục.",
"sub.cguSuffix": "của findloop.",
"sub.cguTitle": "Hoàn tất đăng ký của bạn",
"sub.expiresOn": "Đăng ký của bạn hết hạn vào",
"sub.noProrata": "Không hoàn tiền pro-rata.",
"sub.privacyLink": "Chính sách quyền riêng tư",
"sub.renewsOn": "Đăng ký của bạn sẽ được gia hạn vào",
"sub.resume": "Đăng ký lại",
"sub.resumedToast": "Đã xác nhận đăng ký lại.",
"tier.free": "Freemium",
"tier.large": "Doanh nghiệp lớn",
"tier.medium": "Doanh nghiệp vừa",
"tier.small": "Khởi đầu",
"tm.add": "Thêm",
"tm.adminOpt": "Quản trị viên (xem đầy đủ)",
"tm.chooseEst": "Chọn một cơ sở",
"tm.chooseEstPh": "Chọn một cơ sở",
"tm.copyFail": "Sao chép không thành công",
"tm.copyLink": "Sao chép liên kết",
"tm.copyOk": "Liên kết mời đã được sao chép",
"tm.emailHint": "Một email mời sẽ được gửi để tạo mật khẩu.",
"tm.expiresOn": "hết hạn vào {date}",
"tm.forEmail": " cho {email}",
"tm.forbidden": "Quản lý nhóm chỉ dành cho chủ tài khoản.",
"tm.inviteCreated": "Đã tạo mời",
"tm.inviteDesc": "Một email mời cho phép thành viên tạo mật khẩu của họ.",
"tm.invitePending": "Mời đang chờ",
"tm.inviteResent": "Đã gửi lại mời",
"tm.inviteSent": "Mời đã được gửi qua email",
"tm.inviteTitle": "Mời một thành viên",
"tm.invitedOn": "Được mời vào {date}",
"tm.linkExpired": "Liên kết hết hạn",
"tm.memberRemoved": "Thành viên đã bị gỡ bỏ",
"tm.name": "Tên",
"tm.noMembers": "Chưa có thành viên nào.",
"tm.resendTitle": "Gửi lại lời mời",
"tm.role": "Vai trò",
"tm.roleAdmin": "Quản trị viên",
"tm.roleOwner": "Chủ sở hữu",
"tm.roleStaff": "Nhân viên",
"tm.roleUpdated": "Vai trò đã được cập nhật",
"tm.sendInvite": "Gửi lời mời",
"tm.sending": "Đang gửi…",
"tm.staffOpt": "Nhân viên (chỉ thấy cơ sở của họ)",
"trk.at": "Tại",
"trk.badge": "Theo dõi",
"trk.carrier": "Nhà vận chuyển",
"trk.codeValidated": "Mã đã được đối tác xác nhận",
"trk.dlProof": "Tải xuống chứng từ bàn giao của tôi (PDF)",
"trk.emailLabel": "Email (tuỳ chọn - để xem chi tiết của bạn)",
"trk.enterEmailCode": "Nhập email của bạn ở trên để hiển thị mã yêu cầu của bạn.",
"trk.idLabel": "Số báo cáo",
"trk.lostEmail": "Tôi không còn quyền truy cập vào email của mình",
"trk.phonePh": "Số điện thoại của bạn",
"trk.photoBefore": "Hình ảnh của món hàng trước khi gửi",
"trk.recoverBtn": "Khôi phục món hàng của tôi",
"trk.recoverHint": "Nhận mã yêu cầu của bạn qua SMS đến số đã đăng ký.",
"trk.searching": "Đang tìm kiếm…",
"trk.secureRest": "Bàn giao an toàn",
"trk.send": "Gửi",
"trk.shipPending": "Đang chuẩn bị gửi hàng — số theo dõi sẽ xuất hiện ở đây khi đã gửi.",
"trk.shipTitle": "Theo dõi gửi hàng",
"trk.showQr": "Hiện QR này cho đối tác để xác nhận bàn giao",
"trk.sigSaved": "Chữ ký đã được lưu",
"trk.signFirst": "Vui lòng ký trước khi xác nhận.",
"trk.signProof": "Ký vào chứng từ bàn giao của bạn",
"trk.signSubmit": "Xác nhận chữ ký của tôi và tạo PDF",
"trk.submit": "Theo dõi",
"trk.subtitle": "Nhập số báo cáo của bạn để theo dõi tiến độ.",
"trk.title": "Theo dõi báo cáo của tôi",
"trk.trackShipment": "Theo dõi gói hàng",
"trk.trackingNo": "Số theo dõi",
"trk.yourCode": "Mã yêu cầu của bạn (để đưa cho đối tác)",
"a.firstName": "Tên",
"ac.emailCrossMatch": "B2C đối chiếu",
"ac.emailCrossMatchDesc": "Một email khi một quảng cáo vật mất công khai phù hợp với một vật được gửi tại cơ sở của bạn",
"ac.emailCrossReject": "Từ chối đối chiếu công khai",
"ac.emailCrossRejectDesc": "Nhận email khi khách hàng chỉ ra rằng một đối chiếu công khai được đề xuất không phải là vật của họ.",
"ac.emailLoginNotif": "Thông báo đăng nhập",
"ac.emailLoginNotifDesc": "Nhận email mỗi khi ai đó đăng nhập vào tài khoản của bạn.",
"ad.closeNoCancel": "Không, xóa danh sách",
"ad.closeQuestion": "Vật đó có được trả lại cho bạn không?",
"ad.closeQuestionDesc": "Cho chúng tôi biết bạn đã phục hồi vật của mình hay chỉ muốn xóa danh sách này.",
"ad.closeYesRestituted": "Có, vật đã được trả lại",
"ad.closedRestituted": "Vật đã được trả lại — danh sách đã đóng 🎉",
"an.lostLoginDesc": "Cần có tài khoản để báo cáo một vật bị mất và theo dõi việc trả lại.",
"an.lostLoginRequired": "Đăng nhập để báo cáo vật bị mất",
"an.qfAll": "Tất cả",
"an.qfBoosted": "Được tăng cường",
"an.qfPhoto": "Có ảnh",
"an.qfRecent": "Tuần này",
"an.qfResolved": "Đã giải quyết",
"an.restitutionInProgress": "Vật đang được trả lại",
"dec.descPhLong": "Mô tả vật: thương hiệu, màu sắc, dấu hiệu đặc biệt… (Càng nhiều chi tiết bạn cung cấp, cơ hội phục hồi vật của bạn càng cao)",
"dec.loadError": "Không thể tải đối tác ngay bây giờ. Kiểm tra kết nối của bạn và thử lại.",
"dec.retry": "Thử lại",
"dec.shippingMode": "Vận chuyển",
"dep.photo2": "Ảnh vật phẩm thứ 2",
"dep.photo2Hint": "Tùy chọn — góc độ khác cải thiện độ chính xác trong việc khớp hình.",
"dl.accountSuspended": "Tài khoản bị đình chỉ do hóa đơn chưa thanh toán. Thanh toán để khôi phục quyền truy cập của bạn.",
"dl.regularize": "Thanh toán ngay →",
"dl.suspensionCountdown": "Hóa đơn {num} chưa thanh toán — tài khoản của bạn sẽ bị đình chỉ sau {days} ngày. Thanh toán để tránh điều này.",
"ft.cancelConfirm": "Hủy báo cáo của bạn? Chủ sở hữu vật sẽ được thông báo.",
"ft.cancelDone": "Báo cáo đã bị hủy.",
"ft.cancelLocked": "Hủy không còn khả thi sau khi chủ sở hữu đã thanh toán.",
"ft.cancelReport": "Hủy báo cáo của tôi",
"ft.claimCodeHelp": "Đưa mã này cho người tìm khi trao lại vật để xác nhận bạn đã nhận vật của mình.",
"ft.claimCodeTitle": "Mã khôi phục của bạn",
"ft.claimDone": "Vật đã được trả lại. Cảm ơn bạn đã sử dụng Findloop!",
"ft.claimUnlockHint": "Mở khóa thông tin liên hệ của người tìm",
"ft.claimUnlockHintSub": "Đi đến \"Các vật tôi đang yêu cầu\" trong tài khoản của bạn để thanh toán phí và nhận thông tin liên hệ.",
"ft.finderCodeShownHelp": "Chủ sở hữu đã thanh toán và chọn bạn. Sao chép mã này bên dưới để xác nhận việc trở lại — không cần kiểm tra email của bạn.",
"ft.finderCodeShownTitle": "Mã xác thực của chủ sở hữu",
"ft.finderContactsTitle": "Thông tin liên hệ của Finder",
"ft.foundCodeHelp": "Hiển thị mã này cho chủ sở hữu khi bàn giao để xác nhận rằng món đồ đã được trả lại.",
"ft.inProgressOther": "Món đồ đang được trả lại",
"ft.inProgressOtherHelp": "Chủ sở hữu đã chọn một người tìm khác cho món đồ này. Bạn không cần thực hiện thêm hành động nào.",
"ft.restitutionCodeHelp": "Mã này xác nhận việc bàn giao món đồ. Nó đã được điền sẵn bên dưới; xác nhận nó rồi đóng vụ việc.",
"ft.restitutionCodeTitle": "Mã bồi hoàn của bạn",
"hc.14Digits": "14 chữ số",
"hc.15DaysBeforeAnItem": "15 ngày trước hạn pháp lý của món đồ.",
"hc.7DaysBeforeAnItem": "7 ngày trước hạn pháp lý của món đồ.",
"hc.8CharactersMinimum": "Tối thiểu 8 ký tự.",
"hc.aClaimToValidate": "Một yêu cầu cần xác thực",
"hc.aFindoAssistanceSessionIs": "Một phiên hỗ trợ Findloop hiện đang hoạt động trên tài khoản của bạn.",
"hc.aNewMatchHasBeen": "Một sự phù hợp mới đã được tìm thấy",
"hc.aUser": "Một người dùng",
"hc.aUserClaimsToBe": "Một người dùng tuyên bố là chủ sở hữu. Kiểm tra câu trả lời của họ trước khi cho phép trả lại.",
"hc.aboutFindo": "Về Findloop",
"hc.accountActivatedPleaseLogIn": "Tài khoản đã được kích hoạt, vui lòng đăng nhập.",
"hc.accountActivation": "Kích hoạt tài khoản",
"hc.accountCreated": "Tài khoản đã được tạo!",
"hc.accountDeactivatedAReactivationEmail": "Tài khoản đã bị vô hiệu hóa. Một email tái kích hoạt (có giá trị trong 30 ngày) đã được gửi đến bạn.",
"hc.accountReactivation": "Tái kích hoạt tài khoản",
"hc.activateMyAccount": "Kích hoạt tài khoản của tôi",
"hc.activateMyAdminAccount": "Kích hoạt tài khoản quản trị của tôi",
"hc.activating": "Đang kích hoạt…",
"hc.activeMatchCancelReason": "Sự phù hợp đang hoạt động. Lý do khách hàng hủy: \"{reason}\". Món đồ vẫn đang chờ yêu cầu.",
"hc.activeMatchWithAPublic": "Sự phù hợp đang hoạt động với một danh sách công khai (khách hàng). Đang chờ yêu cầu từ chủ sở hữu.",
"hc.addAPhoto": "Thêm một bức ảnh",
"hc.addAndConfigureYourEstablishments": "Thêm và cấu hình các cơ sở của bạn trong \"Cơ sở\": thông tin liên lạc, thể loại và kho lưu trữ vật lý của món đồ.",
"hc.addOnGoogle": "Thêm vào Google",
"hc.address": "Địa chỉ",
"hc.addressSaved": "Địa chỉ đã được lưu",
"hc.addressStreet": "Địa chỉ — Đường",
"hc.adjustThePhoto": "Điều chỉnh bức ảnh",
"hc.adminFullView": "Quản trị viên (toàn bộ quyền xem)",
"hc.administratorOnly": "Chỉ dành cho quản trị viên",
"hc.africa": "Châu Phi",
"hc.aiVisualComparison": "So sánh hình ảnh AI",
"hc.all": "Tất cả",
"hc.amount": "Số tiền",
"hc.anOrganization": "Một tổ chức",
"hc.analyzing": "Đang phân tích…",
"hc.andRecoveryIs": "và việc phục hồi là",
"hc.andTheDeclarationWillBe": "và tuyên bố sẽ được đóng (di chuyển vào lịch sử). Hành động này là cuối cùng.",
"hc.annual20": "Hàng năm -20%",
"hc.annualBilling20": "Hóa đơn hàng năm (−20%)",
"hc.annualTarget": "Mục tiêu hàng năm",
"hc.anyCommentsOptional": "Có bình luận nào không? (tùy chọn)",
"hc.approveTheClaim": "Phê duyệt yêu cầu",
"hc.archiveCancelledConfirm": "Lưu trữ {n} danh sách \"Đã hủy bởi khách hàng\"? Chúng sẽ được xóa khỏi sổ đăng ký.",
"hc.asSoonAs": "Ngay khi",
"hc.askTheOwnerToDisplay": "Yêu cầu chủ sở hữu hiển thị mã QR của họ (trang theo dõi).",
"hc.askThemAtTheCounter": "Hỏi họ tại quầy để xác nhận danh tính — không bao giờ công khai.",
"hc.assistance": "Hỗ trợ",
"hc.assistanceSessionRevoked": "Phiên hỗ trợ đã bị thu hồi.",
"hc.atLeast6Characters": "Tối thiểu 6 ký tự",
"hc.automaticallyPreSelected": "được chọn tự động",
"hc.automaticallyWhenShipping": "tự động khi giao hàng.",
"hc.awaitingClaim": "Đang chờ yêu cầu",
"hc.awaitingPayment": "Đang chờ thanh toán",
"hc.b2cCustomer": "Khách hàng B2C",
"hc.back": "Quay lại",
"hc.backToHome": "Quay lại trang chính",
"hc.backToMyAccount": "Quay lại tài khoản của tôi",
"hc.backToPayment": "Quay lại thanh toán",
"hc.beforeAfterComparisonSlider": "Thanh trượt so sánh trước/sau",
"hc.billingInformation": "Thông tin thanh toán",
"hc.billingInformationSaved": "Thông tin thanh toán đã được lưu ✓",
"hc.brand": "Thương hiệu",
"hc.bronze": "Đồng",
"hc.calculatingTheShippingRate": "Đang tính toán mức phí vận chuyển…",
"hc.cameraUnavailableEnterTheCode": "Camera không khả dụng. Nhập mã thủ công.",
"hc.cancel": "Hủy",
"hc.cancelMyDeclaration": "Hủy tuyên bố của tôi",
"hc.cancelSavedFmt": "Hủy đã được lưu: \"{reason}\". Bạn vẫn có thể yêu cầu.",
"hc.cancelTheDeposit": "Hủy đặt cọc",
"hc.cancelThisMatch": "Hủy trận đấu này",
"hc.cancellationReason": "Lý do hủy",
"hc.cancelled": "Đã hủy",
"hc.cancelledByTheCustomer": "Đã hủy bởi khách hàng",
"hc.cannotOpenPayment": "Không thể mở thanh toán. Vui lòng thử lại.",
"hc.careers": "Ngành nghề",
"hc.carrier": "Nhà vận chuyển",
"hc.carrierAvailabilityCannotBeChecked": "Không thể kiểm tra tình trạng sẵn có của nhà vận chuyển cho đến khi người gửi Sendcloud của bạn được cấu hình.",
"hc.carrierConfirmedCharged": "Nhà vận chuyển đã xác nhận — {price} € đã được tính cho khách hàng",
"hc.carrierOther": "Nhà vận chuyển (khác)",
"hc.carrierSelection": "Lựa chọn nhà vận chuyển",
"hc.caseClosedThankYou": "Vụ việc đã được đóng. Cảm ơn bạn!",
"hc.category": "Danh mục",
"hc.changeMethod": "Thay đổi phương thức",
"hc.characteristic": "Đặc điểm",
"hc.chargedToCustomer": "đã được tính cho khách hàng.",
"hc.checkOrEditYourDetails": "Kiểm tra hoặc chỉnh sửa thông tin của bạn trước khi thanh toán an toàn.",
"hc.checkStatisticsToTrackDeposited": "Kiểm tra \"Thống kê\" để theo dõi các mục đã gửi, tỷ lệ hoàn trả và hiệu suất của từng cơ sở.",
"hc.checkTheDetailsBeforeContacting": "Kiểm tra thông tin trước khi liên hệ với người tìm.",
"hc.checkTheDetailsBelowBefore": "Kiểm tra thông tin bên dưới trước khi bắt đầu yêu cầu hoàn trả của bạn.",
"hc.checkTheNewItem": "Kiểm tra mục mới",
"hc.checkThePhotosAndCharacteristics": "Kiểm tra ảnh và đặc điểm bên dưới trước khi tiến hành thu hồi.",
"hc.chooseACountry": "Chọn một quốc gia",
"hc.chooseANewPassword": "Chọn một mật khẩu mới",
"hc.chooseAReason": "Chọn một lý do",
"hc.chooseTheLegalRetentionAlerts": "Chọn các thông báo giữ lại hợp pháp nhận qua email cho",
"hc.chooseYourPasswordToAccess": "Chọn mật khẩu của bạn để truy cập vào bảng điều khiển quản trị.",
"hc.city": "Thành phố",
"hc.claimApproved": "Yêu cầu đã được chấp thuận",
"hc.claimApproved2": "Yêu cầu đã được chấp thuận.",
"hc.claimCodeExpired": "Mã yêu cầu đã hết hạn",
"hc.claimCodeVerified": "Mã yêu cầu đã được xác minh",
"hc.claimNotFound": "Không tìm thấy yêu cầu",
"hc.claimNotValidated": "Yêu cầu chưa được xác nhận",
"hc.claimRejected": "Yêu cầu đã bị từ chối",
"hc.claimRejected2": "Yêu cầu đã bị từ chối.",
"hc.claimValidated": "Yêu cầu đã được xác nhận",
"hc.claimValidatedByThePartner": "Yêu cầu đã được xác nhận bởi đối tác",
"hc.claimant": "Người yêu cầu",
"hc.claimsToBeTheOwner": "tuyên bố là chủ sở hữu của mục này và đã trả lời các câu hỏi xác minh. Chỉ phê duyệt nếu các câu trả lời khớp.",
"hc.claimsToValidate": "Các yêu cầu cần xác nhận",
"hc.clear": "Xóa",
"hc.clickToZoom": "Nhấn để phóng to",
"hc.close": "Đóng",
"hc.close2": "Đóng",
"hc.closeTheDeclaration": "Đóng khai báo",
"hc.closeTheDeclaration2": "Đóng khai báo?",
"hc.codeAlreadyVerified": "Mã đã được xác minh",
"hc.codeCopied": "Mã đã được sao chép",
"hc.collapse": "Thu gọn",
"hc.color": "Màu sắc",
"hc.company": "Công ty",
"hc.companyName": "Tên công ty",
"hc.comparePhotos": "So sánh hình ảnh",
"hc.compareThemWithTheOwner": "So sánh chúng với câu trả lời của chủ sở hữu — không bao giờ được hiển thị công khai.",
"hc.condition": "Tình trạng",
"hc.confirmAndPay": "Xác nhận và thanh toán",
"hc.confirmCancellation": "Xác nhận hủy bỏ",
"hc.confirmCrop": "Xác nhận cắt",
"hc.confirmDeletion": "Xác nhận xóa",
"hc.confirmPassword": "Xác nhận mật khẩu",
"hc.confirmThatThisIsYour": "Xác nhận rằng đây là món đồ của bạn. Một kiểm tra danh tính sẽ được yêu cầu từ người tìm trước khi liên hệ.",
"hc.confirmTheCarrier": "Xác nhận đơn vị vận chuyển",
"hc.confirmThePassword": "Xác nhận mật khẩu",
"hc.confirmYourShippingAddressTo": "Xác nhận địa chỉ giao hàng của bạn để tiếp tục với thanh toán.",
"hc.confirmYourSubscription": "Xác nhận đăng ký của bạn",
"hc.confirmed": "Đã xác nhận ✓",
"hc.contactFindoToGetYour": "Liên hệ với Findloop để nhận ID Gửi của bạn.",
"hc.contactUs": "Liên hệ với chúng tôi",
"hc.continueTheReturn": "Tiếp tục trả hàng",
"hc.continueToPayment": "Tiếp tục đến thanh toán",
"hc.copy": "Sao chép",
"hc.correctMyDetails": "sửa thông tin của tôi",
"hc.correctThisEntry": "Sửa mục này?",
"hc.country": "Quốc gia",
"hc.countryAddress": "Quốc gia (địa chỉ)",
"hc.countryIsoCodeEG": "Quốc gia (mã ISO, ví dụ FR)",
"hc.cover": "bìa",
"hc.createTheShipment": "Tạo đơn hàng",
"hc.cropThePhoto": "Cắt ảnh",
"hc.customer": "Khách hàng",
"hc.customerClaimCodeToCheck": "Mã yêu cầu của khách hàng — để kiểm tra tại điểm lấy hàng:",
"hc.customerReasonFmt": "Lý do của khách hàng: \"{reason}\".",
"hc.customerReminderDelay": "Thời gian nhắc nhở của khách hàng",
"hc.customerWhosePublicListingMatches": "Khách hàng có danh sách công khai trùng khớp với món đồ này — chỉ hiển thị cho bạn.",
"hc.d15": "D-15",
"hc.dangerZone": "Khu vực nguy hiểm",
"hc.date": "Ngày",
"hc.dateNewest": "Ngày (mới nhất)",
"hc.dateOldest": "Ngày (cũ nhất)",
"hc.daysToYearEnd": "{n} ngày đến cuối năm",
"hc.deadlineAlert": "Thông báo hạn chót",
"hc.declarationClosed": "Tờ khai đã đóng ✓",
"hc.declarationNotFound": "Không tìm thấy tờ khai.",
"hc.declarationNotFound2": "Không tìm thấy tờ khai",
"hc.declarationTracking": "Theo dõi tờ khai",
"hc.defaultCarrier": "Nhà vận chuyển mặc định",
"hc.defaultCarrierPreselected": "Nhà vận chuyển mặc định đã được chọn trước — có thể thay đổi cho lô hàng này. Giá thực tế (Sendcloud + {m}% phí tổn).",
"hc.defaultCarrierRemoved": "Nhà vận chuyển mặc định đã được loại bỏ",
"hc.delayHours": "Trì hoãn (giờ)",
"hc.deleteMyAccount": "Xóa tài khoản của tôi",
"hc.deleting": "Đang xóa…",
"hc.deletingDeactivatesYourAccountLogin": "Việc xóa tài khoản sẽ vô hiệu hóa đăng nhập của bạn: truy cập bị chặn và dữ liệu sẽ được giữ trong 30 ngày. Bạn sẽ nhận được email với liên kết kích hoạt lại có hiệu lực trong 30 ngày.",
"hc.delivered": "Đã giao",
"hc.depositAnItem": "Gửi một món đồ",
"hc.depositCancelledItemPutBack": "Gửi bị hủy — món đồ đã được đưa trở lại kho.",
"hc.depositCancelledItemRemovedFrom": "Gửi bị hủy — món đồ đã được xóa khỏi sổ đăng ký.",
"hc.depositedOn": "Đã gửi vào",
"hc.describeTheItemBrandColor": "Mô tả món đồ: thương hiệu, màu sắc, dấu hiệu phân biệt… (Càng nhiều chi tiết bạn cung cấp, cơ hội tìm thấy món đồ của bạn càng cao)",
"hc.dimensionsCm": "Kích thước (cm)",
"hc.disablingAnEmail": "Vô hiệu hóa email",
"hc.doesNotHide": "không ẩn",
"hc.download": "Tải xuống",
"hc.downloadThePdf": "Tải xuống PDF",
"hc.draftRestoredPickUpYour": "Bản nháp đã được khôi phục — hãy lấy tờ khai của bạn từ vị trí bạn đã dừng lại.",
"hc.dragToReposition": "Kéo để định vị lại",
"hc.eGColisPriv": "Ví dụ: Colis Privé",
"hc.eachItemGetsAQr": "Mỗi món đồ sẽ nhận được một nhãn QR. Quét nó từ \"Kho & QR\" để xác định vị trí một món đồ ngay lập tức.",
"hc.eachSiteManagesItsOwn": "Mỗi trang web quản lý ngân hàng riêng của nó. Đi đến",
"hc.edit": "Chỉnh sửa",
"hc.emailNotificationPreferences": "Tùy chọn thông báo email",
"hc.emailPreferencesUpdated": "Tùy chọn email đã được cập nhật",
"hc.enableOrDisableRecoveryFees": "Bật hoặc tắt phí phục hồi cho",
"hc.enlargePhoto": "Phóng to ảnh",
"hc.enterTheCustomerSCode": "Nhập mã khách hàng",
"hc.estShipRate": "Tỷ lệ vận chuyển ước tính (Sendcloud + {m}% lợi nhuận):",
"hc.establishment": "Cơ sở",
"hc.establishment2": "Cơ sở:",
"hc.establishmentInItsSendcloudAccount": "cơ sở trong tài khoản Sendcloud của bạn và cho bạn ID người gửi",
"hc.establishmentSettings": "Cài đặt cơ sở",
"hc.exCode": "vd. ABCD2345",
"hc.exId": "vd. 3f2a…",
"hc.exit": "Thoát",
"hc.explainWhyThisItemIs": "Giải thích tại sao món hàng này không thuộc về bạn…",
"hc.externalPaymentLinks": "Liên kết thanh toán bên ngoài",
"hc.failed": "Thất bại",
"hc.feesEnabled": "Phí đã được kích hoạt",
"hc.field": ") trường.",
"hc.finderAcceptedCloseTheCase": "Người tìm đã chấp nhận — đóng vụ việc khi món hàng đã được giao tận tay.",
"hc.findoCityRanking": "Findloop — Xếp hạng thành phố",
"hc.findoForEstablishments": "Findloop cho các cơ sở",
"hc.findoPresentationVideo": "Video giới thiệu Findloop",
"hc.findoRegistersTheAddressOf": "Findloop đăng ký địa chỉ của bạn",
"hc.findoReviewShare": "Đánh giá Findloop {year}: {n} món hàng được hoàn trả, tỷ lệ hoàn trả {rate}% 🎉",
"hc.firstVerifyTheClaimCode": "Đầu tiên xác minh mã yêu cầu bên trên",
"hc.forEveryNewShipmentFrom": "cho mỗi lô hàng mới từ",
"hc.free": "miễn phí",
"hc.freeRecovery0": "Khôi phục miễn phí (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Khôi phục miễn phí trên toàn châu Phi – Khuyến mãi ra mắt",
"hc.freeRecoveryFeesDisabled0": "Khôi phục miễn phí: phí đã bị vô hiệu hóa (0 €)",
"hc.fromTeamInviteYourColleagues": "Từ \"Đội\", mời đồng nghiệp của bạn qua email và chỉ định cho họ một cơ sở. Mỗi thành viên chỉ thấy phạm vi của riêng mình.",
"hc.fullName": "Họ và tên",
"hc.fullPhoto": "Ảnh đầy đủ",
"hc.gallery": "Thư viện",
"hc.giveTheReasonForCancelling": "Cho biết lý do hủy. Đối tác sẽ được thông báo.",
"hc.goToLogin": "Đi đến đăng nhập",
"hc.goToMyAccount": "Đi đến tài khoản của tôi",
"hc.gold": "Vàng",
"hc.googleLoginFailed": "Đăng nhập Google thất bại",
"hc.hasConfirmedYourPaymentYou": "đã xác nhận thanh toán của bạn, bạn sẽ được chuyển hướng tự động",
"hc.helpCenter": "Trung tâm trợ giúp",
"hc.helpUsImproveWhyAre": "Giúp chúng tôi cải thiện: tại sao bạn rời đi? Tài khoản của bạn sẽ bị vô hiệu hóa và có thể được kích hoạt lại trong 30 ngày.",
"hc.hidePassword": "Ẩn mật khẩu",
"hc.high": "Cao",
"hc.historyOfYourMonthlySubscriptions": "Lịch sử các đăng ký hàng tháng của bạn và trạng thái thanh toán của chúng.",
"hc.hotelBelmont": "Khách sạn Belmont",
"hc.howConfigureSenderId": "Làm thế nào để thiết lập ID Người Gửi số của tôi?",
"hc.iDonTUseIt": "Tôi không sử dụng nó đủ",
"hc.iFoundItElsewhere": "Tôi tìm thấy nó ở nơi khác",
"hc.iNoLongerNeedMy": "Tôi không còn cần món đồ của mình",
"hc.identityVerification": "Xác minh danh tính",
"hc.idleLogoutIn": "Bạn sẽ bị đăng xuất trong {n} giây do không hoạt động.",
"hc.ifProvidedTheVolumetricWeight": "Nếu được cung cấp, trọng lượng volumetric sẽ được sử dụng.",
"hc.ifThePartnerHasNot": "Nếu đối tác chưa xác nhận việc nhận thanh toán bên ngoài sau khoảng thời gian này, Findloop sẽ tự động nhắc nhở đối tác để xác nhận.",
"hc.impersonationEnded": "Kết thúc giả mạo.",
"hc.impersonationMode": "Chế độ giả mạo",
"hc.impersonationSessionExpired": "Phiên giả mạo đã hết hạn.",
"hc.inTheField": ", trong lĩnh vực",
"hc.inTransit": "Đang vận chuyển",
"hc.inclVat": "bao gồm VAT",
"hc.intraEuVatNumberOptional": "Mã số VAT nội khối EU là tùy chọn, không yêu cầu SIRET (ngoài Pháp).",
"hc.invalidInvitationLink": "Liên kết mời không hợp lệ.",
"hc.invalidInvitationLink2": "Liên kết mời không hợp lệ",
"hc.invalidInviteLink": "Liên kết mời không hợp lệ hoặc đã hết hạn.",
"hc.invalidNumberEnterAnInternational": "Số không hợp lệ. Nhập số quốc tế, ví dụ +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Liên kết không hợp lệ hoặc đã hết hạn.",
"hc.invalidOrExpiredReactivationLink": "Liên kết tái kích hoạt không hợp lệ hoặc đã hết hạn",
"hc.invalidSendcloudId": "ID Sendcloud không hợp lệ",
"hc.inviteSubtitle": "{org} mời bạn tham gia đội ngũ Findloop của họ. Chọn mật khẩu của bạn để kích hoạt tài khoản.",
"hc.isAvailableOnSendcloudFor": "có sẵn trên Sendcloud cho tất cả các tuyến đường của bạn (nội địa + quốc tế).",
"hc.isNotEnabledOnYour": "không được kích hoạt trên tài khoản Sendcloud của bạn cho một số điểm đến. Nhãn cho những cái đó sẽ được tạo ra với một nhà vận chuyển khác có sẵn.",
"hc.isThisReallyYourItem": "Có phải đây thật sự là món đồ của bạn?",
"hc.isThisYourItem": "Có phải đây là món đồ của bạn?",
"hc.item": "Món đồ",
"hc.itemAlreadyConfirmed": "Món đồ đã được xác nhận",
"hc.itemDetails": "Chi tiết món đồ",
"hc.itemFoundAt": "Món đồ được tìm thấy tại",
"hc.itemFoundAtAPartner": "Món đồ được tìm thấy tại một đối tác",
"hc.itemMarkedAsReturned": "Món đồ được đánh dấu là đã trả lại ✓",
"hc.itemPhotoRequiredBeforeShipping": "Ảnh món đồ (cần thiết trước khi giao hàng)",
"hc.itemPhotoSaved": "Ảnh món đồ đã được lưu",
"hc.itemPreview": "Xem trước món đồ",
"hc.itemPutBackInStorage": "Món đồ đã được đưa lại vào kho.",
"hc.itemWeight": "Trọng lượng món đồ:",
"hc.itemsReturned": "món đồ đã được trả lại",
"hc.itemsReturnedThisYear": "món đã trả lại năm nay",
"hc.itemsWhoseLegalDeadlineIs": "Các món có thời hạn pháp lý còn 15 ngày hoặc ít hơn (bao gồm quá hạn). Các mục vẫn hiển thị.",
"hc.kbisNumber": "Số Kbis",
"hc.keysForgottenOnABench": "Chìa khóa để quên trên ghế",
"hc.labelBeingGenerated": "Nhãn đang được tạo",
"hc.leaveTheFieldsEmptyTo": "Để trống các trường để cung cấp phục hồi miễn phí.",
"hc.legalNotice": "Thông báo pháp lý",
"hc.limitReachedUpgradeToA": "Đã đạt giới hạn — nâng cấp lên kế hoạch cao hơn",
"hc.linkCopiedShareOn": "Liên kết đã sao chép — chia sẻ trên {label}",
"hc.linkUnavailable": "Liên kết không khả dụng",
"hc.linkedTo": "Liên kết đến",
"hc.listingHiddenByModeration": "Danh sách bị ẩn bởi sự điều chỉnh.",
"hc.loading": "Đang tải…",
"hc.locateMe": "Định vị tôi",
"hc.logIn": "Đăng nhập",
"hc.logInToGetBack": "Đăng nhập để quay lại không gian của bạn và quản lý đăng ký của bạn.",
"hc.loginFailed": "Đăng nhập không thành công",
"hc.lostFoundPlatform": "Nền tảng thất lạc & tìm thấy.",
"hc.lostIn": "mất ở",
"hc.lowRate": "Tỷ lệ thấp",
"hc.mainReason": "Lý do chính",
"hc.mainStreet": "Phố chính",
"hc.makeSureThisIsThe": "Đảm bảo đây là món đồ bạn đã mất trước khi mở khóa thông tin liên lạc của người tìm thấy.",
"hc.manageCookies": "Quản lý cookie",
"hc.manageMyTeam": "Quản lý đội nhóm của tôi",
"hc.manageYourTeam": "Quản lý đội nhóm của bạn",
"hc.markAsReturned": "Đánh dấu là đã trả lại",
"hc.matchNoClaimInTime": "Một đối tượng không nhận được yêu cầu trong thời hạn.",
"hc.matchNotFound": "Không tìm thấy đối tượng",
"hc.medium": "Trung bình",
"hc.milestoneFmt": "{m} mục đã trả lại đạt cột mốc! Đang tiến đến {next}.",
"hc.missingFeatures": "Thiếu tính năng",
"hc.monthly": "Hàng tháng",
"hc.monthlyBilling": "Thanh toán hàng tháng",
"hc.moveThePhotoToFit": "Di chuyển ảnh để vừa vào vòng tròn.",
"hc.myAccount": "Tài khoản của tôi",
"hc.myInvoices": "Hóa đơn của tôi",
"hc.myMonthlyInvoices": "Hóa đơn hàng tháng của tôi",
"hc.nArchived": "{n} danh sách đã được lưu trữ.",
"hc.newCodeGeneratedAndSent": "Mã mới đã được tạo và gửi cho khách hàng qua email và SMS",
"hc.newCodeGeneratedAndSent2": "Mã mới đã được tạo và gửi cho chủ sở hữu",
"hc.newPassword": "Mật khẩu mới",
"hc.next": "Tiếp theo",
"hc.nextPhoto": "Ảnh tiếp theo",
"hc.no": "Không",
"hc.noAnswerProvided": "Không có câu trả lời nào được cung cấp.",
"hc.noArchivedDeclarations": "Không có tờ khai nào được lưu trữ",
"hc.noCountryFound": "Không tìm thấy quốc gia",
"hc.noDeclarations": "Không có tờ khai nào",
"hc.noFeesAreChargedTo": "Không có phí nào được tính cho khách hàng.",
"hc.noInvoiceYet": "Chưa có hóa đơn nào.",
"hc.noInvoiceYetYourInvoices": "Chưa có hóa đơn nào. Hóa đơn của bạn sẽ xuất hiện ở đây tự động sau mỗi lần thanh toán.",
"hc.noMatchIsAvailableFor": "Hiện tại không có kết quả nào. Chúng tôi sẽ thông báo cho bạn ngay khi có mục nào khớp với tờ khai của bạn.",
"hc.noShipmentMatchesYourSearch": "Không có lô hàng nào khớp với tìm kiếm của bạn.",
"hc.noShipmentsYet": "Chưa có lô hàng nào.",
"hc.noShipmentsYet2": "Chưa có lô hàng nào",
"hc.none": "không có",
"hc.noneChooseForEachShipment": "Không có (chọn cho mỗi lô hàng)",
"hc.notMine": "Không phải của tôi",
"hc.of": "của",
"hc.only": "Chỉ",
"hc.onlyEachSiteManagesIts": "chỉ. Mỗi trang quản lý ngân hàng của riêng mình: những liên kết này không ảnh hưởng đến bất kỳ cơ sở nào khác.",
"hc.onlyTheOwnerOrAn": "Chỉ chủ sở hữu hoặc một quản trị viên mới có thể cấu hình các liên kết thanh toán của cơ sở.",
"hc.openDepositInTheMenu": "Mở \"Gửi tiền\" trong menu, mô tả mục và chụp ảnh. Nó sẽ ngay lập tức được lưu trữ và sẵn sàng để được trả lại.",
"hc.openSettings": "Mở Cài đặt →",
"hc.openTheDeclarationToManage": "Mở tờ khai để quản lý lô hàng",
"hc.optional": "— tùy chọn",
"hc.optional2": "(tùy chọn)",
"hc.optional3": "tùy chọn",
"hc.originalListingPhotoUsed": "Ảnh gốc của danh sách đã được sử dụng",
"hc.other": "Khác",
"hc.other2": "Khác…",
"hc.ourProducts": "Sản phẩm của chúng tôi",
"hc.overallRateTrendLast6": "Xu hướng tỷ lệ tổng thể (6 tháng qua)",
"hc.ownerSClaimCode": "Mã yêu cầu của chủ sở hữu",
"hc.ownershipConfirmed": "Quyền sở hữu đã được xác nhận",
"hc.paid": "Đã thanh toán",
"hc.paidOn": "Thanh toán vào",
"hc.paidViaPartner": "Đã thanh toán (qua đối tác)",
"hc.parcelBeingPrepared": "Gói hàng đang được chuẩn bị",
"hc.parcelDelivered": "Gói hàng đã được giao",
"hc.parcelShipped": "Gói hàng đã được vận chuyển",
"hc.parisGareDeLyon": "Paris, Gare de Lyon…",
"hc.partner": "Đối tác",
"hc.partner2": "đối tác",
"hc.partnerDirectory": "Danh bạ đối tác",
"hc.passedOnToTheCustomer": "— đã chuyển cho khách hàng liên kết thanh toán.",
"hc.password": "Mật khẩu",
"hc.passwordResetPleaseLogIn": "Đặt lại mật khẩu, vui lòng đăng nhập.",
"hc.passwordUpdated": "Mật khẩu đã được cập nhật.",
"hc.passwordsDoNotMatch": "Mật khẩu không khớp.",
"hc.pasteThisSenderIdIn": "Dán ID người gửi này vào Findloop → Cài đặt",
"hc.payForTheShipmentOf": "Thanh toán cho việc vận chuyển món hàng của bạn qua Findloop với một thanh toán an toàn.",
"hc.payTheRecoveryFees": "Thanh toán phí phục hồi",
"hc.payTheShippingFees": "Thanh toán phí vận chuyển",
"hc.payment": "Thanh toán",
"hc.paymentAlreadyConfirmedByThe": "Thanh toán đã được xác nhận bởi đối tác",
"hc.paymentLinksAreNowConfigured": "Liên kết thanh toán hiện đã được cấu hình cho từng cơ sở",
"hc.paymentNotCompletedYourAccount": "Thanh toán chưa hoàn tất, tài khoản của bạn chưa được tạo — vui lòng thử lại.",
"hc.paymentReceived": "Thanh toán đã được nhận",
"hc.paymentSuccessful": "Thanh toán thành công!",
"hc.pdfInvoice": "Hóa đơn PDF",
"hc.pending": "Đang chờ",
"hc.period": "Thời gian",
"hc.phoneNumber": "Số điện thoại",
"hc.phoneOptional": "Điện thoại (tùy chọn)",
"hc.planAt": "kế hoạch tại",
"hc.planLimitFmt": "Gói \"{plan}\" của bạn bị giới hạn ở {max} cơ sở. Để quản lý {n} địa điểm, chúng tôi khuyến nghị",
"hc.platformReturnTarget": "Mục tiêu trở lại nền tảng",
"hc.pleaseCompleteYourShippingAddress": "Vui lòng hoàn thành địa chỉ giao hàng của bạn.",
"hc.pleaseProvideAPhoneNumber": "Vui lòng cung cấp một số điện thoại: điều này là cần thiết cho nhà vận chuyển để giao hàng.",
"hc.pleaseProvideAReason": "Vui lòng cung cấp một lý do.",
"hc.pleaseSetYourOwnPassword": "vui lòng đặt mật khẩu của riêng bạn trước khi tiếp tục.",
"hc.pointsToGoal": "{n} điểm nữa để đạt được mục tiêu chung của chúng ta.",
"hc.posterPreview": "Xem trước áp phích",
"hc.potentialMatchBeingVerified": "Trường hợp tiềm năng đang được xác minh",
"hc.potentialOwner": "Chủ sở hữu tiềm năng",
"hc.preFilledAutomaticallyYouCan": "Tự động điền — bạn có thể thay thế bằng ảnh của gói hàng.",
"hc.pressKit": "Bộ công cụ báo chí",
"hc.previewMode": "Chế độ xem trước:",
"hc.previewOfThePrintReady": "Xem trước poster A4 sẵn sàng in cho cơ sở này.",
"hc.previous": "Trước",
"hc.previousPhoto": "Ảnh trước",
"hc.primary": "chính",
"hc.printThePoster": "In poster",
"hc.privacy": "Quyền riêng tư",
"hc.privacyPolicy": "Chính sách quyền riêng tư",
"hc.processedCasesWillAppearHere": "Các trường hợp đã xử lý sẽ xuất hiện ở đây.",
"hc.proofOfReturnPdf": "Bằng chứng trả lại (PDF)",
"hc.protectedByRecaptcha": "Được bảo vệ bởi reCAPTCHA",
"hc.publicMatch": "Khớp công khai",
"hc.putBackInStorage": "Đưa trở lại kho",
"hc.pwdResetByTeam": "Mật khẩu của bạn đã được đội ngũ của chúng tôi đặt lại. Để bảo vệ bạn,",
"hc.questionsToAskTheOwner": "Câu hỏi cần hỏi chủ sở hữu",
"hc.rateChargedToTheCustomer": "Mức phí tính cho khách hàng:",
"hc.rateOfTarget": "{rate}% đạt được trong số {target}%",
"hc.reached": "đã đạt",
"hc.reactivating": "Đang kích hoạt lại…",
"hc.reasonSavedYouCanStill": "Lý do đã được lưu. Bạn vẫn có thể yêu cầu lại vật phẩm của mình.",
"hc.recentMatchesFirst": "Các khớp gần đây trước",
"hc.recognizedThePhotoYouSent": "nhận diện được bức ảnh bạn gửi và mô tả những đặc điểm này. Chỉ xác nhận nếu chúng khớp với vật phẩm trong tay bạn.",
"hc.recommended": "Được khuyên dùng",
"hc.recoveryFees": "Phí phục hồi",
"hc.recoveryFeesArePaidDirectly": "Phí phục hồi được thanh toán trực tiếp cho cơ sở đối tác. Findloop không nhận được thanh toán từ khách hàng.",
"hc.recoveryFeesEnabled": "Phí phục hồi được kích hoạt",
"hc.recoveryOfferedByTheEstablishment": "Phục hồi được cung cấp bởi cơ sở — Findloop không tính phí.",
"hc.recoveryPaymentLink": "Liên kết thanh toán phục hồi",
"hc.recoveryPaymentLinkSavedFor": "Liên kết thanh toán phục hồi đã được lưu cho cơ sở này",
"hc.redirecting": "Đang chuyển hướng…",
"hc.redirectingToPayment": "Đang chuyển hướng đến thanh toán…",
"hc.redirectingToTheRecoveryOf": "Đang chuyển hướng đến phục hồi vật phẩm của bạn…",
"hc.regenerateAndResendToThe": "Tạo lại và gửi lại cho chủ sở hữu",
"hc.regenerateTheCode": "Tạo lại mã",
"hc.registerAFoundItem": "Đăng ký một vật phẩm đã tìm thấy",
"hc.rejectTheClaim": "Từ chối yêu cầu",
"hc.reminderDelaySaved": "Thời gian nhắc nhở đã được lưu",
"hc.reopenThePaymentLink": "Mở lại liên kết thanh toán",
"hc.repeatThePassword": "Nhập lại mật khẩu",
"hc.reportAProblem": "Báo cáo sự cố",
"hc.reportDismissedYourListingRemains": "Báo cáo bị từ chối. Danh sách của bạn vẫn công khai.",
"hc.requiredUsedToCalculateThe": "Bắt buộc: dùng để tính toán phí vận chuyển Sendcloud. Vận chuyển không khả dụng trên 30 kg.",
"hc.reset": "Đặt lại",
"hc.resume": "Tiếp tục",
"hc.resumeRegistration": "Tiếp tục đăng ký",
"hc.retro": "Năm trong ảnh",
"hc.returnSecurity": "Đảm bảo hoàn trả",
"hc.returnToTheOwner": "Trả lại cho chủ sở hữu",
"hc.returned": "đã trả",
"hc.reviewTheItemDetails": "Xem lại thông tin chi tiết sản phẩm",
"hc.revokeAccess": "Thu hồi quyền truy cập",
"hc.role": "Vai trò:",
"hc.save": "Lưu",
"hc.save2": "lưu",
"hc.saveAndContinue": "Lưu và tiếp tục",
"hc.saving": "Đang lưu…",
"hc.scanTheClaimCode": "Quét mã yêu cầu",
"hc.scanTheOwnerSQr": "Quét mã QR của chủ sở hữu",
"hc.scrollThroughLanguages": "Cuộn qua các ngôn ngữ",
"hc.searchByCustomerItemOr": "Tìm kiếm theo khách hàng, sản phẩm hoặc số theo dõi…",
"hc.searchForACountry": "Tìm kiếm một quốc gia…",
"hc.secureFindoVerification": "Xác minh Findloop an toàn",
"hc.seeRetro": "Xem năm trong ảnh",
"hc.selectedCarrier": "Nhà vận chuyển đã chọn:",
"hc.selectedPlan": "Gói đã chọn",
"hc.send": "Gửi",
"hc.sendcloudSenderIdSaved": "ID người gửi Sendcloud đã được lưu",
"hc.sendcloudSenderIdSenderId": "ID người gửi Sendcloud (sender_id)",
"hc.sending": "Đang gửi…",
"hc.sessionExpired": "Phiên đã hết hạn",
"hc.setUpYourEstablishments": "Thiết lập cơ sở của bạn",
"hc.settings": "Cài đặt",
"hc.settingsSubtitle": "Thanh toán và nhắc nhở bên ngoài, được cấu hình theo cơ sở.",
"hc.shareFoundText": "Tôi đã tìm thấy một món đồ — giúp tôi tìm chủ sở hữu của nó trên Findloop",
"hc.shareLostText": "Tôi đã mất một món đồ — giúp tôi tìm nó trên Findloop",
"hc.sharePreview": "Chia sẻ bản xem trước",
"hc.shareTheRanking": "Chia sẻ bảng xếp hạng",
"hc.shareYourQrCodeTo": "Chia sẻ mã QR của bạn để nhận thông báo.",
"hc.shipRateAutoWeight": "Phí vận chuyển được tính tự động qua Sendcloud (trọng lượng {w}) tại thời điểm vận chuyển.",
"hc.shipRateForWeight": "Tỷ lệ vận chuyển (Sendcloud + {m}% lợi nhuận) cho {w}:",
"hc.shipments": "Lô hàng",
"hc.shipmentsSubtitle": "Nhìn tổng quan về tất cả các lô hàng của cơ sở, trên tất cả các trường hợp. Nhấp vào một dòng để quản lý lô hàng trong khai báo của nó.",
"hc.shipping": "Vận chuyển",
"hc.shippingAddress": "Địa chỉ giao hàng",
"hc.shippingFeesAreHandledAutomatically": "Phí vận chuyển được xử lý tự động bởi Findloop (Sendcloud) — không cần nhập liên kết.",
"hc.shippingFeesHaveAlreadyBeen": "Phí vận chuyển đã được thanh toán: nhà vận chuyển không thể thay đổi nữa.",
"hc.shippingNotAvailableForItems": "Không có vận chuyển cho các mặt hàng nặng hơn 30 kg. Khách hàng sẽ phải tự đến lấy mặt hàng.",
"hc.shippingPaid": "Vận chuyển đã thanh toán ✓",
"hc.showOnlyItemsMatchingA": "Chỉ hiển thị các mặt hàng khớp với danh sách công khai (khách hàng)",
"hc.showPassword": "Hiện mật khẩu",
"hc.signInTheBoxAbove": "Đăng nhập ở ô bên trên",
"hc.signatureSaved": "Chữ ký đã lưu",
"hc.signedInWithGoogle": "Đã đăng nhập bằng Google",
"hc.signupFailed": "Đăng ký không thành công",
"hc.silver": "Bạc",
"hc.simulatedRatesInPreProduction": "(tỷ lệ mô phỏng trong giai đoạn tiền sản xuất)",
"hc.siretAndVatNumberRequired": "Cần số SIRET và số VAT (Pháp).",
"hc.skip": "Bỏ qua",
"hc.smsSentIfAccount": "Nếu có tài khoản với số này, một SMS đã được gửi đến bạn.",
"hc.sortItemsWithAPublic": "Sắp xếp: các mặt hàng có khớp công khai (mới nhất) lên trước",
"hc.specifyWhetherYouRecoveredYour": "Xác định xem bạn đã lấy lại mặt hàng của mình hay chỉ muốn xóa danh sách này.",
"hc.specifyYourReason": "Xác định lý do của bạn",
"hc.specifyYourReason2": "Xác định lý do của bạn…",
"hc.staff": "Nhân viên",
"hc.status": "Trạng thái",
"hc.staySignedIn": "Giữ đăng nhập",
"hc.step": "Bước",
"hc.stillThere": "Vẫn còn đó?",
"hc.stopScrolling": "Dừng cuộn",
"hc.storeFindWithQr": "Lưu & tìm với QR",
"hc.streetName": "Tên đường",
"hc.streetNo": "Số đường",
"hc.switchTo": "Chuyển sang",
"hc.switchToDarkMode": "Chuyển sang chế độ tối",
"hc.switchToLightMode": "Chuyển sang chế độ sáng",
"hc.takeAPhoto": "Chụp một bức ảnh",
"hc.takeChangeThePhoto": "Chụp / thay đổi bức ảnh",
"hc.takenFromYourDeclaration": "lấy từ khai báo của bạn",
"hc.target": "Mục tiêu",
"hc.targetReached": "Mục tiêu đã đạt được",
"hc.targetReachedThankYouTo": "Mục tiêu đã đạt được — cảm ơn toàn thể cộng đồng Findloop!",
"hc.tellUsMore": "Cho chúng tôi biết thêm…",
"hc.tellUsWhyYouCancel": "Cho chúng tôi biết lý do bạn huỷ. Điều này giúp đối tác xử lý yêu cầu của bạn.",
"hc.tellUsWhyYourListing": "Cho chúng tôi biết lý do. Danh sách của bạn vẫn hoạt động và bạn có thể tiếp tục yêu cầu lại vật phẩm.",
"hc.termsAndConditions": "Điều khoản và điều kiện",
"hc.termsAndPolicies": "Điều khoản và chính sách",
"hc.thankYouForYourFeedback": "Cảm ơn bạn đã phản hồi",
"hc.theBannerDisplayedInThe": "bảng quảng cáo được hiển thị trong danh sách.",
"hc.theClaimantHasBeenInformed": "Người yêu cầu đã được thông báo. Vật phẩm vẫn khả dụng trong danh sách công khai.",
"hc.theClaimantHasBeenNotified": "Người yêu cầu đã được thông báo và có thể tiến hành trả lại.",
"hc.theCustomerPaysTheFees": "Khách hàng sẽ thanh toán phí cho cơ sở.",
"hc.theDayTheLegalRetention": "Ngày giai đoạn giữ hợp pháp được áp dụng.",
"hc.theEstablishmentConsideredThatThis": "Cơ sở đã xem xét rằng vật phẩm này không phải của bạn.",
"hc.theEstablishmentIsReviewingYour": "Cơ sở đang xem xét câu trả lời của bạn. Bạn sẽ được thông báo ngay khi yêu cầu của bạn được xác nhận, sau đó bạn có thể thanh toán phí phục hồi.",
"hc.theFeesAreTooHigh": "Phí quá cao",
"hc.theFinderConsideredThatThis": "Người tìm đã xem xét rằng vật phẩm này không phải của bạn.",
"hc.theFinderIsReviewingYour": "Người tìm đang xem xét yêu cầu của bạn. Bạn sẽ được thông báo ngay khi nó được xác nhận.",
"hc.theItem": "Vật phẩm",
"hc.theItemWillBeRemoved": "Vật phẩm sẽ bị loại bỏ khỏi danh sách (không có yêu cầu nào đang diễn ra).",
"hc.theItemWillBeSet": "Vật phẩm sẽ được đặt lại thành \"còn hàng\" và yêu cầu liên quan sẽ bị hủy.",
"hc.theKbisNumberAndVat": "Số Kbis và số VAT là bắt buộc đối với Pháp.",
"hc.theLabelIsGeneratedAutomatically": "Nhãn được tạo tự động ngay khi khách hàng đã thanh toán phí vận chuyển. Nó có thể tải xuống ở đây.",
"hc.theLinkMayHaveExpired": "Liên kết có thể đã hết hạn (có hiệu lực trong 30 ngày). Liên hệ với hỗ trợ Findloop nếu cần.",
"hc.theOwnerDescribesTheirItem": "Chủ sở hữu mô tả vật phẩm của họ",
"hc.theOwnerReceivedItBy": "Chủ sở hữu đã nhận nó qua email (hoặc SMS). Nhập hoặc quét nó trước khi chuyển giao.",
"hc.thePartnerConsideredThatThis": "Đối tác đã xem xét rằng vật phẩm này không phải của bạn. Vật phẩm vẫn khả dụng.",
"hc.thePartnerIsReviewingYour": "Đối tác đang xem xét câu trả lời của bạn. Bạn sẽ được thông báo ngay khi yêu cầu của bạn được xác nhận.",
"hc.theShipmentIsCreatedAutomatically": "Việc vận chuyển được tạo tự động ngay khi khách hàng đã xác nhận địa chỉ và thanh toán phí phục hồi. Nhãn sẽ được tạo tự động sau khi thanh toán vận chuyển và có thể tải xuống ở đây.",
"hc.theShippingRateWillBe": "Phí vận chuyển sẽ được tính tự động qua Sendcloud tại thời điểm vận chuyển (trọng lượng đã ghi lại).",
"hc.thisCarrierWillBe": "Nhà vận chuyển này sẽ là",
"hc.thisEstablishment": "cơ sở này",
"hc.thisFieldIsRequiredFor": "Trường này là bắt buộc để tạo nhãn tự động.",
"hc.thisIsMyItem": "Đây là vật phẩm của tôi",
"hc.thisIsMyItemContinue": "Đây là vật phẩm của tôi — tiếp tục",
"hc.thisIsMyItemStart": "Đây là vật phẩm của tôi — bắt đầu trả lại",
"hc.thisIsNotMyItem": "Đây không phải là vật phẩm của tôi",
"hc.thisMatchIsNoLonger": "Sự khớp này không còn khả dụng hoặc đã được xử lý.",
"hc.thisRateWillBeCharged": "Phí này sẽ được tính cho khách hàng. Một mức phí cao có thể làm nản lòng việc phục hồi.",
"hc.thisStepIsRequiredFor": "Bước này là bắt buộc để tạo nhãn vận chuyển",
"hc.thisValidationLinkIsInvalid": "Liên kết xác thực này không hợp lệ hoặc đã hết hạn.",
"hc.toCheckBeforeMarkingThe": "Để kiểm tra trước khi đánh dấu món hàng là đã trả.",
"hc.toConfigureTheLinksAnd": "để cấu hình các liên kết và khoảng thời gian nhắc nhở cho từng cơ sở.",
"hc.toReachOurFirstMilestone": "để đạt mốc đầu tiên của chúng tôi là 100 lượt trả.",
"hc.toTheCustomer": "đến tay khách hàng.",
"hc.toTheShippingFeePayment": "đến thanh toán phí vận chuyển.",
"hc.toYourRecoveryTracking": "đến theo dõi việc phục hồi của bạn.",
"hc.tooExpensiveBudget": "Quá đắt / ngân sách",
"hc.topCitiesForReturns": "Các thành phố hàng đầu cho việc trả hàng",
"hc.trackMyRecovery": "Theo dõi việc phục hồi của tôi",
"hc.trackTheShipmentAndDownload": "Theo dõi lô hàng và tải nhãn (tự động tạo) mà không rời khỏi tab Khai báo.",
"hc.trackYourStatistics": "Theo dõi thống kê của bạn",
"hc.tracking": "Theo dõi",
"hc.unableToOpenTheShipping": "Không thể mở thanh toán phí vận chuyển. Vui lòng thử lại.",
"hc.unableToRetrieveTheInvoice": "Không thể lấy hóa đơn.",
"hc.unclaimed": "Chưa được yêu cầu",
"hc.unclaimedCustomerReason": "Món hàng chưa được yêu cầu. Lý do của khách hàng: \"{reason}\".",
"hc.unclaimedItem": "Món hàng chưa được yêu cầu",
"hc.unclaimedItemNoClaimWithin": "Món hàng chưa được yêu cầu — không có yêu cầu trong thời hạn.",
"hc.unclaimedItems": "Món hàng chưa được yêu cầu",
"hc.unclaimedItemsMatchLeftWithout": "Món hàng chưa được yêu cầu: trận đấu còn lại mà không có yêu cầu trong thời hạn. Bạn có thể để chúng lại trong kho.",
"hc.unlockTheFinderSContact": "Mở khóa thông tin liên lạc của người tìm để sắp xếp việc bàn giao.",
"hc.upcoming": "Sắp tới",
"hc.updateFailed": "Cập nhật không thành công.",
"hc.usedForInvoices": "Sử dụng để phát hành hóa đơn Findloop của bạn.",
"hc.vatNumber": "Số VAT",
"hc.verificationPending": "Đang chờ xác thực",
"hc.verificationSentToTheFinder": "Xác thực đã được gửi đến người tìm. Bạn sẽ được thông báo về quyết định của họ.",
"hc.verificationSentToThePartner": "Xác thực đã được gửi đến đối tác. Bạn sẽ được thông báo về quyết định của họ.",
"hc.verify": "Xác thực",
"hc.verifyingInvite": "Đang xác thực liên kết mời…",
"hc.verifyingTheLink": "Đang xác thực liên kết…",
"hc.viewInRegistry": "Xem trong sổ đăng ký",
"hc.viewItem": "Xem món hàng",
"hc.viewItemRecover": "Xem món hàng & phục hồi",
"hc.visibleToTheOwnerAutomatically": "Hiển thị cho chủ sở hữu · tự động xóa sau 60 ngày.",
"hc.waitingForPartnerConfirmation": "Đang chờ xác nhận từ đối tác",
"hc.waitingForThePartnerS": "Đang chờ xác nhận từ đối tác",
"hc.weHaveInformedTheEstablishment": "Chúng tôi đã thông báo cho cơ sở rằng món hàng này không phải của bạn và đã khởi động lại phân tích. Bạn sẽ được thông báo ngay khi có trận đấu mới được tìm thấy.",
"hc.weHaveInformedThePartner": "Chúng tôi đã thông báo cho đối tác rằng món hàng này không phải của bạn. Danh sách của bạn vẫn hoạt động cho các trận đấu trong tương lai.",
"hc.weRanTheAnalysisAgain": "Chúng tôi đã phân tích lại và xác định thêm một món đồ có thể là của bạn. Vui lòng kiểm tra lại.",
"hc.weight": "Trọng lượng",
"hc.weightNotProvidedTheShipping": "Trọng lượng chưa được cung cấp: phí vận chuyển sẽ được tính vào thời điểm giao hàng.",
"hc.weightUnit": "Đơn vị trọng lượng",
"hc.welcome": "Chào mừng!",
"hc.welcomeToFindo": "Chào mừng đến với Findloop",
"hc.whenACustomerComesTo": "Khi một khách hàng đến để nhận tài sản của họ, hãy mở khai báo của họ và xác nhận hoàn trả. Chỉ vậy thôi!",
"hc.whenDisabledFeesDropTo": ". Khi bị tắt, phí giảm xuống",
"hc.whyIsThisNotYour": "Tại sao đây không phải là món đồ của bạn?",
"hc.willBeMarkedAs": "sẽ được đánh dấu là",
"hc.wrongColor": "Màu sắc sai",
"hc.wrongModel": "Mẫu sai",
"hc.yesCancel": "Có, hủy",
"hc.yesContactTheFinder": "Có, liên hệ với người tìm thấy",
"hc.youAreHere": "Bạn đang ở đây",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Bạn có thể bắt đầu hoàn trả ngay bây giờ.",
"hc.youCanStillChangeIt": ". Bạn vẫn có thể thay đổi từng trường hợp.",
"hc.youHaveAlreadyConfirmedThat": "Bạn đã xác nhận rằng đây là món đồ của bạn.",
"hc.youWillBeRedirectedTo": "Bạn sẽ được chuyển hướng đến thanh toán bảo mật của Stripe.",
"hc.yourAccountHasBeenReactivated": "Tài khoản của bạn đã được kích hoạt lại.",
"hc.yourAccountIsActiveYou": "Tài khoản của bạn đang hoạt động, bạn có thể quản lý các cơ sở của mình.",
"hc.yourEstablishment": "Cơ sở của bạn",
"hc.yourFeedbackHelpsUsImprove": "Phản hồi của bạn giúp chúng tôi cải thiện các kết quả.",
"hc.yourFeedbackHelpsUsRestart": "Phản hồi của bạn giúp chúng tôi bắt đầu lại phân tích và cải thiện các kết quả.",
"hc.yourFirstSteps": "Những bước đầu tiên của bạn",
"hc.yourFirstStepsAdmin": "Những bước đầu tiên của bạn (quản trị viên)",
"hc.yourItemHasBeenHanded": "Món đồ của bạn đã được bàn giao trực tiếp bởi đối tác — hãy đóng vụ việc khi bàn giao đã được xác nhận.",
"hc.yourItemHasBeenShipped": "Món đồ của bạn đã được gửi bởi đối tác — hãy đóng vụ việc khi giao hàng đã được xác nhận.",
"hc.yourPaymentHasBeenRecorded": "Thanh toán của bạn đã được ghi nhận.",
"hc.yourShipmentIsBeingPrepared": "Gói hàng của bạn đang được chuẩn bị. Bạn sẽ nhận được bưu phẩm trong vòng 3 đến 5 ngày làm việc.",
"hc.yourShippingFeesHaveAlready": "Phí vận chuyển của bạn đã được thanh toán. Đã thanh toán phí vận chuyển ✓",
"hc.yourShippingFeesHaveBeen": "Phí vận chuyển của bạn đã được thanh toán. Gói hàng của bạn đang được chuẩn bị.",
"hc.yourVerificationQuestionsDeposit": "Các câu hỏi xác minh của bạn (đặt cọc)",
"hero.einvoiceBadge": "Hóa đơn điện tử tuân thủ 2027",
"home.recentAdsAll": "Xem tất cả danh sách",
"home.recentAdsEyebrow": "Hiện tại",
"home.recentAdsSubtitle": "Các món đồ đã mất và được tìm thấy do cộng đồng báo cáo.",
"home.recentAdsTitle": "Danh sách mới nhất",
"home.reunions": "Các cuộc hội ngộ gần đây",
"home.videoEyebrow": "Xem",
"home.videoSubtitle": "Cách chúng tôi giúp đoàn tụ những món đồ bị mất với chủ sở hữu của chúng một cách dễ dàng.",
"home.videoTitle": "Khám phá Findloop trong 2 phút",
"home.watchYoutube": "Xem trên YouTube",
"impact.already": "Đã",
"impact.citiesWord": "thành phố/thành phố",
"impact.eachPoint": "Mỗi chấm là một thành phố nơi Findloop giúp phục hồi đồ bị mất.",
"impact.emptyMap": "Bản đồ sẽ dần đầy lên khi các món đồ được trả lại.",
"impact.eyebrow": "Tác động của chúng tôi",
"impact.inCities": "trên khắp",
"impact.restitutedTo": "món đồ được trả lại cho chủ sở hữu",
"impact.title": "Món đồ được trả lại, khắp nơi gần bạn",
"inv2.download": "Tải xuống",
"inv2.view": "Xem",
"map.objectsOnMapPlural": "món đồ trên bản đồ",
"map.objectsOnMapSingular": "món đồ trên bản đồ",
"mc.claimConfirmDesc": "Kiểm tra món đồ được tìm thấy bởi người phát hiện trước khi thanh toán để mở khóa thông tin liên lạc của họ.",
"mc.claimConfirmNo": "Đây không phải là món đồ của tôi",
"mc.claimConfirmTitle": "Đây có thật sự là món đồ của bạn không?",
"mc.claimConfirmYes": "Đúng rồi, nó là của tôi — thanh toán",
"mc.claimFinderContacts": "Thông tin liên lạc của người phát hiện",
"mc.claimNotMineDone": "Cảm ơn — người phát hiện đã được thông báo và yêu cầu của bạn đã được gỡ bỏ khỏi quảng cáo.",
"mc.claimUnlockDesc": "Thanh toán phí quản lý Findloop để nhận thông tin liên lạc của người đã tìm thấy món đồ của bạn.",
"mc.claimUnlockTitle": "Mở khóa thông tin liên lạc của người phát hiện",
"mc.hideCountryOffers": "Ẩn các ưu đãi ở quốc gia của tôi",
"mc.myClaims": "Món đồ tôi đang yêu cầu",
"mc.myClaimsSub": "Món đồ được tìm thấy bởi người khác mà bạn đang yêu cầu. Mở khóa thông tin liên lạc của người phát hiện để sắp xếp việc trao đồ.",
"mc.notifAdCancelled": "Quảng cáo đã bị hủy",
"mc.notifCancelAd": "Hủy quảng cáo của tôi",
"mc.offersInCountry": "Ưu đãi ở quốc gia của tôi",
"mc.offersInCountryDesc": "Tất cả các phần thưởng hoạt động từ đối tác ở quốc gia của bạn, theo thành phố.",
"mc.redArchived": "Đã lưu trữ",
"mc.rewardsCountryNone": "Chưa có ưu đãi nào ở quốc gia của bạn.",
"mc.rewardsForYou": "Phần thưởng dành cho bạn",
"mc.rewardsForYouDesc": "Được cung cấp bởi đối tác mà bạn đã gửi một món đồ.",
"mc.rewardsMineNone": "Chưa có phần thưởng nào từ đối tác gửi đồ của bạn.",
"mc.showCountryOffers": "Xem ưu đãi ở quốc gia của tôi",
"mc2.cancelDecl": "Hủy khai báo của tôi",
"mc2.cancelDeclDone": "Khai báo đã bị hủy.",
"pricing.physInvDesc": "Khi một món đồ được trả lại, vị trí của nó sẽ tự động được giải phóng và có sẵn cho một món đồ mới.",
"pricing.physInvTitle": "Theo dõi hàng tồn kho vật lý",
"pricing.physModalTitle": "Quản lý vật phẩm vật lý",
"pricing.physQrDesc": "Một mã QR duy nhất được tạo cho mỗi vật phẩm và liên kết đến tất cả thông tin của nó.",
"pricing.physQrTitle": "Nhãn QR chuyên dụng",
"pricing.physShelfDesc": "Mỗi vật phẩm đã đăng ký có thể được gán một vị trí vật lý trong cơ sở.",
"pricing.physShelfTitle": "Kế hoạch kệ",
"pricing.physicalMgmt": "Quản lý vật phẩm vật lý (kệ, QR, hàng tồn kho)",
"pub.addSecondPhoto": "Thêm ảnh thứ 2 (tùy chọn)",
"pub.photo2Added": "✓ Ảnh thứ 2 đã được thêm",
"reg.dispositionJournal": "Nhật ký phân phối",
"reg.dispositionNoteAuthHint": "ℹ️ Cần có ghi chú cho “Đã giao cho cơ quan” (số báo cáo, phòng…).",
"reg.dispositionNotePh": "Ghi chú (tùy chọn): tổ chức nhận, tham khảo cơ quan, tên người mua…",
"reg.dispositionNoteRequired": "Cần có tham khảo chính thức để bàn giao cho cơ quan.",
"reg.legalPrealert": "Thời hạn pháp lý trong {days} ngày",
"reg.legalPrealertOptions": "Các tùy chọn tại thời hạn: bán đấu giá, tặng cho tổ chức từ thiện, bàn giao cho cơ quan.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Đánh giá đầy đủ",
"rev.readMore": "Đọc thêm",
"rw.activeCodes": "Phiếu quà tặng đang hoạt động",
"rw.archived": "Lưu trữ",
"rw.archivedTitle": "Phiếu quà tặng đã đổi (lưu trữ)",
"rw.hideArchived": "Ẩn phiếu quà tặng đã đổi",
"rw.noArchived": "Không có phiếu quà tặng nào đã lưu trữ.",
"rw.showArchived": "Hiển thị phiếu quà tặng đã đổi",
"shp.labelAuto": "Nhãn được tạo tự động ngay khi khách hàng đã thanh toán phí vận chuyển. Nó sẽ được tải xuống ở đây.",
"st.cancelled_by_customer": "Đã hủy",
"stt.dispoPdfBtn": "Xuất PDF",
"stt.dispoPdfError": "Xuất PDF không thành công.",
"stt.dispoPdfExporting": "Đang xuất…",
"trk.matchVerifying": "Đối tượng tiềm năng đang được xác minh",
"pcat.stadium_arena": "Sân vận động / Arena",
"pcat.supermarket": "Siêu thị",
"pcat.taxi_vtc": "Taxi / Gọi xe",
"pcat.tourism_office": "Văn phòng du lịch",
"pcat.train_bus_station": "Ga tàu / bến xe",
"pcat.travel_agency": "Đại lý du lịch",
"hc.and": "và",
"hc.demoObj0": "một chiếc ví",
"hc.demoObj1": "một chiếc túi thể thao",
"hc.demoObj2": "một chiếc điện thoại",
"hc.demoObj3": "một cặp kính",
"hc.demoObj4": "một bộ chìa khóa",
"hc.demoObj5": "một chiếc khăn",
"hc.demoObj6": "một chiếc laptop",
"hc.demoObj7": "một chai nước",
"hc.demoWhen0": "2 giờ trước",
"hc.demoWhen1": "5 giờ trước",
"hc.demoWhen2": "hôm qua",
"hc.demoWhen3": "3 giờ trước",
"hc.demoWhen4": "sáng nay",
"hc.demoWhen5": "1 ngày trước",
"hc.feedDemo": "{obj} đã được trả lại ở {city} {when}.",
"hc.feedReal": "Một món đồ ({cat}) đã được trả lại ở {city}.",
"hc.saveBtn": "Lưu",
"hc.saveLink": "Lưu liên kết",
"hc.terms": "Điều khoản",
"hc.view": "Xem",
"pcat.airline": "Hãng hàng không",
"pcat.airport": "Sân bay",
"pcat.amusement_park": "Công viên giải trí",
"pcat.bank": "Ngân hàng",
"pcat.bar_cafe": "Quán bar / Café",
"pcat.beauty_salon": "Salon tóc / Làm đẹp",
"pcat.cinema": "Rạp chiếu phim",
"pcat.concert_theater": "Nhà hát / Buổi hòa nhạc",
"pcat.coworking": "Không gian làm việc chung",
"pcat.gym_fitness": "Phòng tập / Thể hình",
"pcat.hospital_clinic": "Bệnh viện / Phòng khám",
"pcat.library": "Thư viện",
"pcat.mall": "Trung tâm mua sắm",
"pcat.museum": "Bảo tàng",
"pcat.pharmacy": "Nhà thuốc",
"pcat.private_company": "Công ty tư nhân",
"pcat.public_transport": "Giao thông công cộng",
"pcat.school_university": "Trường học / Đại học",
"pcat.sports_center": "Trung tâm thể thao",
"an.found": "Đã tìm thấy",
"an.lost": "Đã mất",
"hc.shareReview": "Chia sẻ đánh giá",
"hc.citiesAboveTarget": "{n} thành phố vượt chỉ tiêu của họ",
"hc.cityAboveTarget": "{n} thành phố vượt chỉ tiêu của nó",
"hc.j15EarlyReminder": "Nhắc nhở sớm D-15",
"hc.j7EarlyReminder": "Nhắc nhở sớm D-7",
"hc.annualTotal": "Tổng hàng năm",
"hc.billedOnceYear": "Thanh toán một lần cho 12 tháng, gia hạn hàng năm.",
"hc.monthlyPrice": "Giá hàng tháng",
"hc.perMonth": "/ tháng",
"hc.perYear": "/ năm",
"hc.billedEachMonth": "Tự động bị tính phí mỗi tháng.",
"nav.business": "Doanh nghiệp",
"nav.individual": "Cá nhân",
"hc.circumstancesFound": "Hoàn cảnh phát hiện",
"hc.circumstancesFoundPh": "Ví dụ: tìm thấy trên mặt đất gần lối vào metro",
"hc.circumstancesLost": "Hoàn cảnh mất mát",
"hc.circumstancesLostPh": "Ví dụ: để lại trên ghế khi chờ xe buýt",
"hc.conditionPh": "Ví dụ: tốt, xước…",
"hc.firstName": "Tên",
"hc.lastName": "Họ",
"hc.quantity": "Số lượng đồ vật",
"fa.approve": "Chấp thuận",
"fa.approveConfirm": "Bạn có muốn chấp thuận tuyên bố này không? Thông tin liên hệ đầy đủ của bạn (tên, email, điện thoại) sẽ được chia sẻ với người tìm.",
"fa.approved": "Tuyên bố đã được chấp thuận — thông tin liên hệ đã được trao đổi",
"fa.approvedFinder": "Chủ sở hữu đã chấp thuận tuyên bố của bạn",
"fa.approvedFinderText": "Liên hệ với họ để sắp xếp việc trả lại.",
"fa.boostSub": "Danh sách của bạn sẽ ở vị trí trên cùng trong khoảng thời gian đã chọn.",
"fa.boostTitle": "Tăng cường danh sách của tôi (tùy chọn)",
"fa.colFinder": "Tuyên bố của người tìm",
"fa.colYours": "Tuyên bố của bạn",
"fa.compareHint": "So sánh tuyên bố của người tìm với tuyên bố của bạn trước khi quyết định.",
"fa.contribNone": "Không có đóng góp",
"fa.contribPaid": "Đóng góp đã được nhận — cảm ơn bạn!",
"fa.contribPending": "Đóng góp đang chờ thanh toán",
"fa.contribSub": "Hỗ trợ Findloop để giúp nhiều người lấy lại đồ đạc của họ. Bạn có thể chọn €0.",
"fa.contribSuccessMsg": "Tuyên bố của bạn đã được gửi tới chủ sở hữu.",
"fa.contribSuccessTitle": "Cảm ơn vì đóng góp của bạn",
"fa.contribTitle": "Đóng góp tự nguyện",
"fa.days3": "3 ngày",
"fa.days30": "30 ngày",
"fa.days7": "7 ngày",
"fa.declSub": "Mô tả món đồ mà bạn đã tìm thấy. Chủ sở hữu sẽ so sánh tuyên bố của bạn với của họ.",
"fa.declTitle": "Tôi đã tìm thấy món đồ này",
"fa.expiresOn": "Hết hạn vào",
"fa.fBrand": "Thương hiệu",
"fa.fCircumstances": "Tình huống",
"fa.fCity": "Thành phố",
"fa.fColor": "Màu sắc",
"fa.fCondition": "Tình trạng",
"fa.fDate": "Ngày",
"fa.fMessage": "Tin nhắn của người tìm",
"fa.fPlace": "Nơi",
"fa.fQuantity": "Số lượng",
"fa.finderContact": "Thông tin liên hệ của người tìm",
"fa.finishPay": "Hoàn tất thanh toán",
"fa.foundDate": "Ngày tìm thấy",
"fa.foundPlace": "Nơi tìm thấy",
"fa.hours24": "24 giờ",
"fa.ht": "không bao gồm VAT",
"fa.months3": "3 tháng",
"fa.noBoost": "Không tăng cường",
"fa.ownerContact": "Thông tin liên hệ của chủ sở hữu",
"fa.payPublish": "Thanh toán và đăng",
"fa.pendingPayText": "Tin rao của bạn sẽ được công khai ngay khi thanh toán được xác nhận.",
"fa.pendingPayTitle": "Thanh toán đang chờ",
"fa.planSub": "Tin rao của bạn sẽ được công khai ngay khi thanh toán được xác nhận.",
"fa.planTitle": "Thời gian đăng tin",
"fa.pubSuccessMsg": "Tin rao của bạn đã được công khai. Bạn sẽ nhận được thông báo ngay khi có người tìm đến.",
"fa.pubSuccessTitle": "Tin rao đã được đăng",
"fa.publicNote": "Chỉ mô tả, thành phố, quốc gia và hình ảnh được hiển thị công khai.",
"fa.redirectStripe": "Chuyển hướng đến thanh toán an toàn…",
"fa.reject": "Từ chối",
"fa.rejectConfirm": "Từ chối tuyên bố này? Tin rao của bạn vẫn đang trực tuyến.",
"fa.rejected": "Tuyên bố bị từ chối",
"fa.rejectedFinder": "Đó không phải là món họ đang tìm",
"fa.rejectedFinderText": "Chủ sở hữu cho biết món này không phải của họ. Cảm ơn bạn đã giúp đỡ!",
"fa.responsesTitle": "Tuyên bố của người tìm",
"fa.sent": "Tuyên bố đã được gửi đến chủ sở hữu.",
"fa.submitDecl": "Gửi tuyên bố của tôi",
"fa.submitDeclPay": "Gửi và đóng góp {amount}",
"fa.total": "Tổng phải thanh toán",
"fa.ttc": "đã bao gồm VAT",
"fa.waitClaimText": "Người tìm đang xem xét yêu cầu của bạn. Bạn sẽ được thông báo về quyết định của họ.",
"fa.waitFinderText": "Chúng tôi sẽ thông báo cho bạn ngay khi một người tìm gửi tuyên bố.",
"fa.waitFinderTitle": "Tin rao của bạn đã được công khai",
"fa.waitOwnerText": "Chủ sở hữu đang so sánh tuyên bố của bạn với tuyên bố của họ. Bạn sẽ được thông báo về quyết định của họ.",
"fa.waitOwnerTitle": "Đang chờ quyết định của chủ sở hữu",
"st.pending_payment": "Thanh toán đang chờ",
"fa.africaFree": "Danh sách miễn phí ở Châu Phi — Ưu đãi ra mắt Findloop, hãy tận hưởng!",
"fa.africaPublished": "Danh sách đã được xuất bản miễn phí — Ưu đãi ra mắt ở Châu Phi!",
"fa.approveClaimConfirm": "Bạn có muốn duyệt yêu cầu này không? Chủ sở hữu sẽ có thể mở khóa thông tin liên lạc của bạn.",
"fa.checkInfo": "Kiểm tra chi tiết của bạn trước khi gửi: chúng sẽ được đối chiếu với của người tìm.",
"fa.claimApprovedShort": "Người tìm đã duyệt yêu cầu của bạn",
"fa.claimRejectedShort": "Yêu cầu bị từ chối bởi người tìm",
"fa.claimRejectedText": "Người tìm cho rằng món đồ này không phải của bạn.",
"fa.claimSub": "Mô tả món đồ của bạn và thêm 2 bức ảnh. Người tìm sẽ so sánh chúng với danh sách của họ.",
"fa.claimTitle": "Đây là món đồ của tôi",
"fa.claimUnlockText": "Mở khóa thông tin liên lạc của người tìm để sắp xếp việc trả lại.",
"fa.claimUnlockedShort": "Thông tin liên lạc đã được mở khóa — xem theo dõi",
"fa.claimsTitle": "Yêu cầu của chủ sở hữu",
"fa.colOwner": "Khai báo của chủ sở hữu",
"fa.colYourAd": "Danh sách của bạn",
"fa.expired": "Danh sách đã hết hạn",
"fa.free": "Miễn phí",
"fa.lostDate": "Ngày mất",
"fa.lostPlace": "Nơi mất",
"fa.noReceipt": "Không có biên lai cho danh sách này.",
"fa.planSubFree": "Chọn thời gian: danh sách của bạn sẽ được phát trực tiếp ngay lập tức, không cần thanh toán.",
"fa.prefillPrevious": "Sử dụng lại chi tiết của danh sách trước đó trong danh mục này",
"fa.receipt": "Biên lai PDF",
"fa.renewBtn": "Gia hạn",
"fa.renewDiscountBanner": "Giảm giá 50%: gia hạn trước khi danh sách của bạn hết hạn!",
"fa.renewDiscountHint": "Giảm giá 50% được áp dụng vì bạn gia hạn trước khi hết hạn.",
"fa.renewEarly": "Gia hạn (−50%)",
"fa.renewTitle": "Gia hạn danh sách của tôi",
"fa.renewed": "Danh sách đã được gia hạn",
"fa.sendClaim": "Gửi yêu cầu của tôi",
"fa.twoPhotos": "2 bức ảnh của món đồ của bạn",
"fa.twoPhotosError": "Thêm 2 bức ảnh của món đồ của bạn.",
"fa.twoPhotosHint": "Ảnh cá nhân chứng minh món đồ này là của bạn (với món đồ, hóa đơn, hộp…).",
"fa.unlockBtn": "Mở khóa thông tin liên lạc",
"fa.unlockFree": "Mở khóa miễn phí — ưu đãi ra mắt",
"fa.waitClaimantText": "Chúng tôi sẽ thông báo cho bạn ngay khi có chủ sở hữu yêu cầu món đồ này.",
"fa.waitFinderDecision": "Đang chờ quyết định của người tìm",
"fa.waitUnlockText": "Bạn sẽ được thông báo ngay khi thông tin liên lạc được trao đổi.",
"fa.waitUnlockTitle": "Đang chờ chủ sở hữu mở khóa",
"fa.cancel": "Hủy",
"fa.categoryRequired": "Chọn một danh mục cho món đồ được tìm thấy.",
"fa.confirmTitle": "Xác nhận quyết định của bạn",
"fa.goBack": "Quay lại",
"dr.continue": "Tiếp tục khai báo của tôi",
"dr.delete": "Xóa vĩnh viễn",
"dr.deleteConfirm": "Xóa bản nháp này vĩnh viễn? Điều này không thể hoàn tác.",
"dr.deleted": "Bản nháp đã bị xóa",
"dr.expiresIn": "Bản nháp giữ trong {h} giờ nữa",
"dr.title": "Bạn có một khai báo chưa hoàn thành",
"form.step": "Bước",
"form.next": "Tiếp tục",
"form.back": "Quay lại",
"form.stepDetails": "Báo cáo của bạn",
"form.stepPublish": "Thời gian, tăng cường & thanh toán",
"form.stepThanks": "Cảm ơn & đóng góp",
"fthx.badge": "Báo cáo gần hoàn thành",
"fthx.title": "Cảm ơn bạn, bạn đang tạo ra sự khác biệt!",
"fthx.text": "Nhờ bạn, có thể sớm có người nhận lại điều gì đó quan trọng với họ. Những hành động tốt đẹp như của bạn chính là điều giữ cho Findloop tồn tại.",
"fthx.impact1": "1 mục đã được báo cáo",
"fthx.impact2": "1 cơ hội tái hợp thêm",
"fthx.tipTitle": "Một chút hỗ trợ cho Findloop?",
"fthx.tipText": "Sự đóng góp của bạn giúp chúng tôi giữ cho dịch vụ luôn sẵn có và kết nối nhiều item hơn với chủ sở hữu của chúng.",
"fthx.optional": "100% tùy chọn — bạn có thể công bố mà không cần đóng góp.",
"fthx.thanksTip": "Cảm ơn bạn rất nhiều vì sự hào phóng!",
"fthx.suggest": "Các khoản gợi ý",
"fthx.none": "Không có mẹo",
"pay.pendingTitle": "Thanh toán chưa hoàn tất",
"pay.pendingText": "Chi tiết của bạn đã được lưu. Tiếp tục thanh toán ngay tại chỗ bạn đã dừng lại.",
"pay.resume": "Tiếp tục thanh toán",
"pay.expiredTitle": "Phiên thanh toán đã hết hạn",
"pay.expiredText": "Để đảm bảo an toàn cho bạn, phiên thanh toán đã hết hạn. Chi tiết của bạn đã được lưu: bắt đầu lại thanh toán chỉ với một lần nhấp.",
"pay.relaunch": "Khởi động lại thanh toán",
"sub.received": "Đã gửi!",
"sub.publishing": "Chúng tôi đang hoàn tất…",
"sub.toPayment": "Đang chuyển đến thanh toán bảo mật…",
"fa.claimSubV2": "Mô tả đồ vật bạn đã mất. Người đã tìm thấy sẽ so sánh thông tin của bạn với danh sách của họ.",
"fa.photosOptional": "Hình ảnh của đồ vật (tùy chọn)",
"fa.compareOwnerHint": "So sánh thông tin này với đồ vật bạn đã tìm thấy, sau đó cho biết liệu đó có phải là cùng một đồ vật không.",
"fa.itsThisItem": "Đúng, đây là đồ vật",
"fa.notThisItem": "Không, đây không phải là đồ vật",
"fa.confirmIsItem": "Xác nhận đây là đồ vật? Thông tin liên hệ của bạn và của chủ sở hữu sẽ hiển thị trong tài khoản của bạn.",
"fa.confirmNotItem": "Xác nhận đây không phải là đồ vật? Báo cáo của bạn sẽ được đóng.",
"fa.youConfirmed": "Bạn đã xác nhận đây là đồ vật của chủ sở hữu",
"fa.youDeclined": "Bạn đã chỉ ra rằng đây không phải là đồ vật",
"fa.youDeclinedText": "Cảm ơn bạn đã giúp đỡ! Chủ sở hữu đã được thông báo.",
"fa.waitFinderDecisionOwner": "Đang chờ quyết định của người tìm thấy",
"fa.finderConfirmed": "Đã xác nhận",
"fa.notYourItem": "Đây không phải là đồ vật của bạn",
"fa.reportedOn": "Đã báo cáo vào ngày",
"fa.ownerWaitHint": "Một người tìm thấy đang kiểm tra thông tin, xin hãy chờ.",
"fa.claimSentFinder": "Yêu cầu đã được gửi đến người đã tìm thấy món đồ.",
"fa.compareClaimHint": "So sánh tuyên bố của chủ sở hữu với danh sách của bạn trước khi quyết định.",
"fa.closeFollowup": "Đóng theo dõi này",
"fa.closeFollowupConfirm": "Bạn có chắc muốn đóng theo dõi này? Email và số điện thoại của cả hai bên sẽ bị xóa vĩnh viễn khi người sở hữu cũng đóng danh sách của họ.",
"fa.safetyTitle": "Mẹo an toàn trước khi chuyển giao",
"fa.safety1": "Hãy hỏi người sở hữu về mô tả chi tiết các tính năng ẩn của sản phẩm: một vết xước cụ thể, nội dung chính xác của một chiếc túi, giấy dán tường, số seri…",
"fa.safety2": "Nếu có thể, hãy yêu cầu bằng chứng hình ảnh (hình ảnh của sản phẩm) hoặc chứng từ mua hàng.",
"fa.safety3": "Chuyển giao sản phẩm ở nơi công cộng hoặc tại một đối tác của Findloop, và kiểm tra ID của người sở hữu.",
"fa.safetyOk": "Hiểu rồi, tiếp tục",
"fa.ownerClosedNote": "Người sở hữu đã đóng danh sách của họ.",
"fa.finderClosedNote": "Người tìm đã đóng theo dõi của họ.",
"fa.followupClosed": "Theo dõi đã đóng",
"fa.followupClosedText": "Bạn đã đóng theo dõi này. Cảm ơn bạn đã giúp đỡ!",
"fa.photoReviewTitle": "Một người tìm kiếm đã gửi một bức ảnh. Nó có giống với món đồ của bạn không?",
"fa.photoLooksLike": "Có, nó giống với món đồ của tôi",
"fa.photoNotMine": "Không, đây không phải là món đồ của tôi",
"fa.photoNotMineConfirm": "Đơn theo dõi sẽ được đóng từ cả hai phía và danh sách của bạn sẽ vẫn mở cho một người tìm kiếm mới.",
"fa.photoLooksLikeDone": "Cảm ơn! Người tìm kiếm sẽ so sánh với tuyên bố của bạn.",
"fa.photoNotMineDone": "Báo cáo đã bị hủy. Danh sách của bạn vẫn mở.",
"fa.ownerPhotoHint": "Chỉ có bức ảnh của người tìm kiếm được hiển thị cho bạn. Hãy cho chúng tôi biết liệu nó có giống với món đồ của bạn không.",
"fa.ownerReviewingPhoto": "Chủ sở hữu đang xem xét bức ảnh của bạn",
"fa.ownerReviewingPhotoText": "Bạn sẽ được thông báo ngay khi họ trả lời. Sau đó, bạn sẽ có thể so sánh tuyên bố của họ.",
"fa.ownerRejectedPhoto": "Đây không phải là món đồ của chủ sở hữu",
"fa.ownerRejectedPhotoText": "Chủ sở hữu cho biết bức ảnh của bạn không khớp với món đồ của họ. Đơn theo dõi đã được đóng. Cảm ơn bạn đã giúp đỡ!",
"fa.contribute": "Đóng góp",
"fa.phoneMissing": "Chưa cung cấp",
"fa.ownerSafety1": "Nên gặp mặt tại một nơi công cộng hoặc tại một đối tác của Findloop. Nếu khoảng cách xa, hãy đề xuất gửi qua bưu điện.",
"fa.ownerSafety2": "Khi trao tay, hãy kiểm tra chứng minh nhân dân của người nhặt được.",
"pub.changePhoto": "Thay đổi hình ảnh",
"ph.secured": "Ảnh đã được bảo mật",
"ph.securing": "Đang bảo mật ảnh…",
"fa.ownerSafety3": "Nếu ảnh của người tìm kiếm có dấu ấn của Findloop, đừng chấp nhận cuộc hẹn. Ảnh phải là hình ảnh gốc do người tìm kiếm chụp, không có dấu ấn."
},
"sv": {
"a.back": "Tillbaka",
"a.category": "Kategori",
"a.categoryPlaceholder": "Välj en kategori",
"a.city": "Stad",
"a.confirmPassword": "Bekräfta lösenord",
"a.country": "Land",
"a.createAccount": "Skapa ett konto",
"a.createBtn": "Skapa mitt konto",
"a.creating": "Skapar…",
"a.email": "E-post",
"a.emailPro": "Företagse-post",
"a.forgot": "Glömt?",
"a.forgotSent": "Om ett konto finns har en återställningslänk just skickats.",
"a.forgotSub": "Få en återställningslänk via e-post.",
"a.forgotTitle": "Glömt lösenord",
"a.googleContinue": "Fortsätt med Google",
"a.googleSignup": "Registrera dig med Google",
"a.haveAccount": "Redan en partner?",
"a.legalHint": "Obligatoriskt för fransk e-faktura (Factur-X) av franska verksamheter.",
"a.legalRequiredFR": "SIRET och momsregistreringsnummer inom EU är obligatoriska för Frankrike.",
"a.loggingIn": "Loggar in…",
"a.login": "Logga in",
"a.loginSub": "Få tillgång till ditt hanteringsutrymme.",
"a.loginTitle": "Partnerinloggning",
"a.min6": "Minst 6 tecken",
"a.newPassword": "Nytt lösenord",
"a.noAccount": "Inte en partner än?",
"a.or": "ELLER",
"a.org": "Verksamhetsnamn",
"a.password": "Lösenord",
"a.passwordMismatch": "Lösenorden matchar inte.",
"a.referral": "Referenskod (valfritt)",
"a.registerSub": "Skapa ditt utrymme på 1 minut — gratis att börja.",
"a.registerTitle": "Bli en partner",
"a.rememberMe": "Kom ihåg mig",
"a.reset": "Återställ",
"a.resetSub": "Välj ett nytt lösenord för ditt konto.",
"a.resetTitle": "Nytt lösenord",
"a.sendLink": "Skicka länken",
"a.sending": "Skickar…",
"a.signin": "Logga in",
"a.siret": "SIRET",
"a.vat": "Momsregistreringsnummer inom EU",
"ac.africa": "Afrika",
"ac.boostActive": "Lyft fram aktiv —",
"ac.boostSub": "Synas högst upp i partnerkatalogen med en “Boostad” badge.",
"ac.boostTitle": "Lyft din listning i katalogen",
"ac.categoryHint": "För att klassificera din verksamhet i findloop-katalogen.",
"ac.choose": "Välj",
"ac.cityHint": "För exakt positionering på den offentliga kartan.",
"ac.cityLabel": "Verksamhetsstad",
"ac.cityPh": "Paris",
"ac.contact": "Kontaktuppgifter",
"ac.converted": "Konverterad",
"ac.copyDeclLink": "Kopiera deklarationslänken",
"ac.copyLink": "Kopiera länken",
"ac.currentPlan": "Nuvarande plan",
"ac.emailDesc": "Välj de e-postmeddelanden du vill ta emot. Notifikationer i ditt arbetsutrymme är alltid aktiva.",
"ac.emailMatch": "Matchar",
"ac.emailMatchDesc": "Ett e-postmeddelande när en punkt matchar en deklaration",
"ac.emailNewDecl": "Nya förlustanmälningar",
"ac.emailNewDeclDesc": "Ett mejl så snart en kund rapporterar en förlust hos dig",
"ac.emailShip": "Fraktbegärningar",
"ac.emailShipDesc": "Ett mejl när en kund begär frakt av en vara",
"ac.emailTitle": "E-postinställningar",
"ac.expireSoon": "Ditt fokus upphör snart —",
"ac.exportCsv": "Exportera (CSV)",
"ac.exportHint": "Exportera dina validerade externa betalningar för din bokföring.",
"ac.free": "Gratis",
"ac.freeMonths": "Gratis månader",
"ac.hours": "timmar",
"ac.howItWorks": "Hur fungerar det?",
"ac.invited": "Bjuden",
"ac.legalFR": "Krävs för elektronisk fakturering (Factur-X) gäller från september 2026.",
"ac.legalMissing": "⚠️ SIRET och intra-EU moms saknas — fyll i dem för att fortsätta vara kompatibel med elektronisk fakturering.",
"ac.legalOther": "Rekommenderad för dina fakturor.",
"ac.legalPartnerQr": "QR-kod",
"ac.legalTitle": "Jurisdiktionella identifierare (fakturering)",
"ac.logoTitle": "Etableringslogotyp",
"ac.modeCurrent": "Aktuellt läge:",
"ac.modeExternal": "Extern (manuell validering)",
"ac.modeInternal": "Intern Findloop (automatisk)",
"ac.noSubReceipt": "Ingen betalning för betald prenumeration ännu.",
"ac.none": "Ingen",
"ac.onYourListing": "på din lista",
"ac.pay1": "Ange dina betalningslänkar nedan för att omdirigera dina kunder till ditt eget insamlingssystem.",
"ac.pay2": "Validering blir manuell: du bekräftar betalningsmottagande från “Förklaringar” fliken.",
"ac.pay3": "Länken “Fraktkostnad” är en konsoliderad betalning (återvinning + frakt).",
"ac.pay4": "Lämna fälten tomma för att använda Findos interna betalning (Stripe) med automatisk validering.",
"ac.paySub": "Samla avgifter via ditt eget betalsystem.",
"ac.payTitle": "Externa betalningar",
"ac.permissive": "Tillåtande",
"ac.phone": "Telefon",
"ac.posterA4": "A4-affisch (PDF)",
"ac.qMessage": "Meddelande (valfritt)",
"ac.qName": "Namn",
"ac.qOrg": "Organisation",
"ac.qSites": "Antal etableringar (beräknat)",
"ac.qrHint": "Dina kunder skannar den här koden för att rapportera ett förlorat föremål.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Din partners QR-kod",
"ac.quoteDesc": "Flygplatser, järnvägsnät, internationella kedjor · ",
"ac.quoteEurope": "Europa / Världen",
"ac.quoteSent": "Offertförfrågan skickad. Vårt team kommer att återkomma till dig snart.",
"ac.quoteTitle": "Begär en offert — Företag",
"ac.recoveryLink": "Länk till “Återvinningsavgift”",
"ac.refSub": "Varje hänvisad partner som prenumererar ger dig 1 gratis månad.",
"ac.refTitle": "Hänvisa, tjäna en gratis månad",
"ac.reminderDelay": "Påminnelse för valideringsfördröjning",
"ac.reminderHint": "Du kommer att få ett mejluppmaning om en extern betalning förblir ovaltiderad efter denna fördröjning (standard: 48h).",
"ac.renewDesc1": "Det har redan gett dig",
"ac.renewDesc2": "Förnya för att förbli på toppen av katalogen och inte tappa denna synlighet.",
"ac.renewNow": "Förnya nu",
"ac.requestQuote": "Begär en offert",
"ac.saveLegal": "Spara identifierarna",
"ac.saveLinks": "Spara länkarna",
"ac.sendRequest": "Skicka min begäran",
"ac.sending": "Skickar…",
"ac.shippingLink": "Länk till “Fraktkostnad” (konsoliderad)",
"ac.shippingLinkHint": "Den här länken täcker både återvinning och frakt.",
"ac.strict": "Strikt",
"ac.subReceipt": "Prenumerationskvitto (PDF)",
"ac.subReceiptsSub": "Ladda ner PDF-kvittot för varje prenumerationsbetalning.",
"ac.subReceiptsTitle": "Prenumerationskvittot",
"ac.tCategory": "Kategori sparad",
"ac.tCity": "Stad sparad — kartan uppdaterad",
"ac.tCityNeeded": "Ange en stad",
"ac.tCopied": "Kopierad!",
"ac.tCover": "Ombildad omslagsbild",
"ac.tEmailPrefs": "E-postpreferenser uppdaterade",
"ac.tErr": "Fel",
"ac.tExportImpossible": "Export misslyckades",
"ac.tLegal": "Juridiska identifierare sparade",
"ac.tLegalNeeded": "SIRET och moms krävs för Frankrike",
"ac.tLogo": "Logotyp uppdaterad",
"ac.tLogoRemoved": "Logotyp borttagen",
"ac.tPayLinks": "Betalningslänkar sparade",
"ac.tPhone": "Telefon sparad",
"ac.tSensitivity": "Känslighet sparad",
"ac.tVatInvalid": "Ogiltigt momsnummer",
"ac.tVatValid": "Giltig moms",
"ac.tabBoost": "Synlighet",
"ac.tabPayments": "Betalningar",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Affisch",
"ac.tabReferral": "Remiss",
"ac.tabSub": "Prenumeration",
"ac.thisWeek": "Denna vecka",
"ac.thisWeekOf": " ({n} denna vecka)",
"ac.thresholdDesc": "Konfidensgräns från vilken AI automatiskt validerar en fot match och meddelar kunden. Högre = färre automatiska matcher men mer pålitliga.",
"ac.thresholdTitle": "AI visuell matchkänslighet",
"ac.trend": "Trend",
"ac.upload": "Ladda upp",
"ac.vatValidFmt": "Giltig moms{name} ({via})",
"ac.vatVerified": "Intra-EU moms verifierad",
"ac.verifyVat": "Verifiera moms (VIES)",
"ac.verifying": "Verifierar…",
"ac.views": "visningar",
"ac.viewsTotal": "Visningar som fåtts (totalt)",
"ac.winbackBtn": "Fortsätt med -20%",
"ac.winbackDesc1": "Det tjänade dig",
"ac.winbackDesc2": "Specialerbjudande: -20% tillämpas automatiskt om du förnyar inom 24h.",
"ac.winbackTitle": "Ditt höjdpunt just har löpt ut — fortsätt med -20%!",
"ad.boost": "Öka",
"ad.close": "Stäng",
"ad.closeConfirm": "Stäng denna annons?",
"ad.closed": "Annons stängd",
"ad.edit": "Redigera",
"ad.editTitle": "Redigera annons",
"ad.saved": "Annons uppdaterad",
"an.allCountries": "Alla länder",
"an.badge": "Förlorade föremål",
"an.boostLater": "Senare",
"an.boostNow": "Öka nu",
"an.boostPrompt": "Öka din annons för att placera den överst och bli funnen snabbare.",
"an.boosted": "Ökad",
"an.contact": "Jag hittade detta föremål",
"an.contactTitle": "Rapportera att du hittat detta föremål",
"an.copyFailed": "Kunde inte kopiera länken",
"an.copyLink": "Kopiera länk",
"an.country": "Land",
"an.date": "Datum då den förlorades",
"an.finderEmail": "Din e-post",
"an.finderName": "Ditt namn",
"an.finderPhone": "Ditt telefonnummer",
"an.geoBanner": "Du ser listor i",
"an.geoBannerWorld": "Du ser listor världen över",
"an.geoChange": "ändra land",
"an.goAccount": "Gå till mitt konto",
"an.linkCopied": "Länk kopierad!",
"an.loginRequired": "Logga in för att rapportera denna artikel och följa återlämnandet.",
"an.loginToBoost": "Logga in för att stärka denna lista",
"an.lostAt": "Förlorad vid",
"an.message": "Meddelande (valfritt)",
"an.none": "Inga listor ännu.",
"an.photo": "Foto (valfritt)",
"an.post": "Lägg upp en lista",
"an.postSubtitle": "Beskriv din förlorade artikel — gemenskapen och våra partner hjälper dig att hitta den.",
"an.postTitle": "Rapportera en förlorad artikel",
"an.publish": "Publicera lista",
"an.published": "Lista publicerad!",
"an.publishing": "Publicerar…",
"an.remaining": "kvar",
"an.requestInProgress": "Begäran pågår",
"an.resolved": "Artikel redan återfunnit",
"an.reward": "Belöning",
"an.searchPh": "Sök en lista…",
"an.send": "Skicka",
"an.sent": "Meddelande skickat till ägaren!",
"an.shareConsent": "Jag godkänner att mina kontaktuppgifter (namn, e-post, telefon) kan delas med ägaren av artikeln.",
"an.shareConsentError": "Vänligen kryssa i rutan för att dela dina kontaktuppgifter.",
"an.sortRecent": "Senaste",
"an.sortRelevance": "Relevans",
"an.subtitle": "Bläddra bland artiklar som rapporterats som förlorade av gemenskapen. Har du hittat en av dem?",
"an.title": "Listor över förlorade artiklar",
"anf.badge": "Hittade artiklar",
"anf.claim": "Detta är mitt",
"anf.claimSent": "Meddelande skickat till den som hittade!",
"anf.claimTitle": "Rapportera att detta är din artikel",
"anf.consent": "Jag godkänner att ägaren kan se mina kontaktuppgifter för att återfå sin artikel.",
"anf.foundAt": "Hittad vid",
"anf.foundDate": "Datum hittad",
"anf.loginCta": "Logga in / skapa ett konto",
"anf.loginDesc": "Ett konto för fyndare krävs för att publicera en lista och tjäna Finder Hero-poäng.",
"anf.loginRequired": "Logga in för att lägga upp en hittad artikel",
"anf.photo": "Artikel foto",
"anf.pointsEarned": "Tack! Du har just tjänat Finder Hero-poäng.",
"anf.pointsPending": "Dina poäng kommer att krediteras inom 24 timmar, efter verifiering.",
"anf.post": "Lägg upp en hittad artikel",
"anf.postSubtitle": "Beskriv artikeln du hittade — hjälp dess ägare att få tillbaka den.",
"anf.postTitle": "Rapportera en hittad artikel",
"anf.publishFound": "Publicera lista över hittade objekt",
"anf.published": "Lista över hittade artiklar publicerad",
"anf.publishedAs": "Publicerad som",
"anf.shareConsent": "Jag godkänner att mina kontaktuppgifter (namn, e-post, telefon) kan delas med den person som hittade artikeln.",
"anf.subtitle": "Bläddra bland artiklar som hittats och rapporterats av gemenskapen. Känner du igen din?",
"anf.title": "Listor över hittade artiklar",
"bo.active": "Boost aktiv",
"bo.africaPrice": "Preferentiell prissättning för Afrikazonen tillämpad",
"bo.pay": "Betala & boost",
"bo.remaining": "Tid kvar",
"bo.renew": "Förnya boost",
"bo.since": "sedan boost",
"bo.subtitle": "Sätt din annons högst upp på listan med en synlig badge.",
"bo.title": "Boost annons",
"c.all": "Alla",
"c.cancel": "Avbryt",
"c.close": "Stäng",
"c.confirm": "Bekräfta",
"c.confirmed": "Bekräftad",
"c.download": "Ladda ner",
"c.loading": "Laddar…",
"c.reset": "Återställ",
"c.reviews": "recensioner",
"c.save": "Spara",
"c.transfer": "Överför",
"cat.Animal": "Djur / Djurtillbehör",
"cat.AppareilPhoto": "Kamera",
"cat.Argent": "Pengar / Kontanter",
"cat.Autres": "Övrigt",
"cat.Bijoux": "Smycken",
"cat.CarteBancaire": "Bankkort",
"cat.CarteIdentite": "ID-kort / Pass",
"cat.Casquette": "Keps / Hatt",
"cat.Ceinture": "Bälte",
"cat.Chargeur": "Laddare / Kabel",
"cat.Chaussures": "Skor",
"cat.CleVoiture": "Bilnyckel",
"cat.Cles": "Nycklar",
"cat.Console": "Spelkonsol",
"cat.Documents": "Dokument / Papper",
"cat.Echarpe": "Sjal",
"cat.Ecouteurs": "Öronproppar / Hörlurar",
"cat.Electronique": "Elektronik (övrigt)",
"cat.Enceinte": "Högtalare",
"cat.Gants": "Handskar",
"cat.Gourde": "Vattenflaska / Termos",
"cat.Instrument": "Musikinstrument",
"cat.Jouet": "Leksak / Gosedjur",
"cat.Jumelles": "Kikare",
"cat.Lampe": "Lampa / Ficklampa",
"cat.Liseuse": "E-läsare",
"cat.Livre": "Bok / Anteckningsbok",
"cat.Lunettes": "Glasögon",
"cat.Manteau": "Kappa / Jacka",
"cat.Maquillage": "Makeupväska",
"cat.Medical": "Medicinsk utrustning",
"cat.Medicaments": "Läkemedel",
"cat.Montre": "Klocka / Smartwatch",
"cat.Ordinateur": "Bärbar dator",
"cat.Parapluie": "Paraply",
"cat.Portefeuille": "Plånbok / Börs",
"cat.Poussette": "Barnvagn / Babytillbehör",
"cat.Sac": "Väska / Handväska",
"cat.SacADos": "Ryggsäck",
"cat.Souris": "Mus / Tangentbord",
"cat.Sport": "Sportutrustning",
"cat.Tablette": "Surfplatta",
"cat.Telephone": "Telefon / Smartphone",
"cat.Trottinette": "Sparkcykel",
"cat.Trousse": "Sachs / Fodral",
"cat.USB": "USB-sticka / Hårddisk",
"cat.Valise": "Resväska / Bagage",
"cat.Velo": "Cykel",
"cat.Vetements": "Kläder",
"cat.placeholder": "Välj en kategori",
"cd.d": "d",
"cd.expired": "Utgått",
"cd.h": "h",
"cd.m": "min",
"ck.accept": "Acceptera",
"ck.acceptAll": "Acceptera alla",
"ck.customize": "Anpassa",
"ck.learn": "Läs mer",
"ck.manage": "Hantera cookies",
"ck.measurement": "Publikmätning",
"ck.measurementDesc": "Anonyma statistik för att förbättra tjänsten.",
"ck.msg": "Vi använder cookies för att hålla sidan fungerande och mäta publik.",
"ck.necessary": "Nödvändig",
"ck.necessaryDesc": "Nödvändig för att sidan ska fungera. Alltid aktiv.",
"ck.refuse": "Avböj",
"ck.save": "Spara mina val",
"ck.saved": "Inställningar sparade",
"ck.title": "Dina cookieinställningar",
"cm.found": "HITTAD",
"cm.lost": "FÖRLORAD",
"cmp.adv": "Avancerad",
"cmp.ai": "AI-matchning",
"cmp.autobill": "Automatisk fakturering",
"cmp.basic": "Grundläggande",
"cmp.community": "Gemenskap",
"cmp.consol": "Konsoliderad fakturering",
"cmp.custom": "Anpassad",
"cmp.dedicated": "Dedikerad",
"cmp.deploy": "Dedikerad distribution & SLA",
"cmp.estIncl": "Inkluderade verksamheter",
"cmp.estSec": "Extra verksamhet",
"cmp.items": "Objekt / månad",
"cmp.main": "1 huvud",
"cmp.max20": "20 max",
"cmp.members": "Medlemsinbjudningar",
"cmp.onQuote": "Anpassad offert",
"cmp.priority": "Prioritet",
"cmp.starterEst": "1 inkluderad + obegränsat extra",
"cmp.stats": "Statistik",
"cmp.statsAdv": "Avancerad",
"cmp.statsBasic": "Grundläggande",
"cmp.support": "Support",
"cmp.unlimited": "Obegränsad",
"cmp.upTo3": "Upp till 3",
"consent.required": "Du måste samtycka till att dela dina kontaktuppgifter för att fortsätta.",
"consent.share": "Jag samtycker till att den som hittar mitt föremål får se mina kontaktuppgifter (namn, e-post, telefon) för att nå mig för återlämning.",
"cover.add": "Lägg till",
"cover.change": "Ändra",
"cover.helper": "Visas som en banner på din rapport sida och i katalogen.",
"cover.none": "Ingen omslagsfoto",
"cover.remove": "Ta bort",
"cover.title": "Omslagsfoto",
"crop.desc": "Justera inramningen till bannerförhållandet (3:1). Dra och zooma.",
"crop.saving": "Sparar…",
"crop.title": "Beskära omslagsbilden",
"cta.button": "Skapa mitt partnerkonto",
"cta.subtitle": "Gå med i de verksamheter som returnerar föremål snabbare med findloop.",
"cta.title": "Redo att minska borttappade föremål?",
"db.account.s": "Hantera din verksamhet, prenumeration och QR-kod.",
"db.account.t": "Mitt konto",
"db.declarations.s": "Kunder som har rapporterat ett borttappat föremål via din QR-kod.",
"db.declarations.t": "Borttappade rapporter",
"db.deposit.s": "Lägg till ett foto, en kategori och en beskrivning.",
"db.deposit.t": "Registrera ett hittat föremål",
"db.registry.s": "Alla hittade föremål registrerade på din verksamhet.",
"db.registry.t": "Föremålsregister",
"db.reviews.s": "Svara offentligt på dina kunders recensioner.",
"db.reviews.t": "Kundrecensioner",
"db.shipments.s": "Generera etiketter och spåra paket att skicka.",
"db.shipments.t": "Leveranser",
"db.stats.s": "Dina nyckeltal för prestation.",
"db.stats.t": "Statistik",
"db.team.s": "Bjud in dina kollegor att hantera föremål.",
"db.team.t": "Team",
"dc.partnerDesc": "Har du tappat ditt föremål på en partnerverksamhet (hotell, station, hall…)? Välj den för en direkt återlämning.",
"dc.partnerList": "Välj från listan",
"dc.partnerMap": "Välj på kartan",
"dc.partnerTitle": "Anmälan hos en partner",
"dc.publicCta": "Lägg upp en offentlig annons",
"dc.publicDesc": "Din annons kommer att vara synlig för hela findloop-gemenskapen. Idealisk om du inte vet var du tappade föremålet.",
"dc.publicTitle": "Offentlig anmälan",
"dc.subtitle": "Välj hur du vill rapportera ditt borttappade föremål.",
"dc.title": "Vad vill du göra?",
"dec.addrPending": "Adress väntar från kunden",
"dec.analyzing": "Analyserar…",
"dec.badge": "Borttappad rapport",
"dec.category": "Föremålskategori",
"dec.clientDescription": "Kundbeskrivning",
"dec.clientPhoto": "Foto som tillhandahålls av kunden",
"dec.clientPhotoShort": "Kundens foto",
"dec.comparePhotos": "Jämför foton",
"dec.contactTitle": "Dina kontaktuppgifter",
"dec.date": "Datum för förlust",
"dec.declaredItemPhoto": "Foto av det anmälda föremålet",
"dec.descPh": "Beskriv föremålet: märke, färg, särskilda kännetecken…",
"dec.description": "Beskrivning",
"dec.email": "E-post",
"dec.emptyDesc": "Dela din QR-kod för att ta emot anmälningar.",
"dec.emptyTitle": "Inga anmälningar",
"dec.enlarge": "Förstora",
"dec.extBanner": "{n} externa betalning(ar) att validera — bekräfta mottagandet nedan för att låsa upp överlämning eller frakt.",
"dec.foundItemAlt": "Hittat föremål",
"dec.foundItemRegistry": "Hittat föremål (register)",
"dec.home": "Tillbaka till startsidan",
"dec.labelClient": "Kund",
"dec.labelRegistry": "Register",
"dec.matchFound": "En match har redan identifierats!",
"dec.name": "Fullständigt namn",
"dec.noMatchYet": "Ingen match än.",
"dec.noPhoto": "Inget foto",
"dec.notfound": "Partner inte hittad.",
"dec.pRecup": "återvinning",
"dec.pRecupP": "(återvinning)",
"dec.pRecupShip": "(återvinning + frakt)",
"dec.payConfirmed": "Betalning {x} bekräftad",
"dec.payPending": "Extern betalning {x} pågående",
"dec.phone": "Telefon",
"dec.pickup": "Avhämtning på plats",
"dec.place": "Plats för förlust",
"dec.placePh": "t.ex. vid baren, rum 204…",
"dec.recoverBtn": "Återfå min sak",
"dec.reject": "Avvisa",
"dec.rerun": "Kör om analysen",
"dec.similarity": "Likhet {n}%",
"dec.submit": "Skicka min rapport",
"dec.submitting": "Skickar…",
"dec.successText": "Vi letar efter din sak bland de som hålls vid",
"dec.successTitle": "Rapport inlämnad!",
"dec.suggestedMatches": "Föreslagna matchningar",
"dec.toColon": " till:",
"dec.toShip": "Att skicka",
"dec.toastExtPay": "Betalning bekräftad — kunden kommer att meddelas.",
"dec.toastMatch": "Match bekräftad",
"dec.toastReject": "Förslag avvisat",
"dec.toastRerun": "Analys återstartad",
"dec.toastVisualN": "{n} visuella matchningar",
"dec.toastVisualNone": "Ingen visuell matchning",
"dec.trackBtn": "Spåra min rapport",
"dec.viewBeforeAfter": "Före/efter vy (överlagring)",
"dec.viewSideBySide": "Sidobytes vy",
"dec.visualCompare": "AI visuell jämförelse",
"dec.visualIdle": "Kör jämförelsen så att AI:n visuellt matchar kundens foto med hittade föremål.",
"dec.visualRunning": "AI:n jämför kundens foto med föremål i ditt register…",
"dec.zoomPhoto": "Förstora fotot",
"dep.addAnyway": "Lägg till ändå",
"dep.addError": "Fel vid tillägg",
"dep.addItem": "Lägg till föremål",
"dep.added": "Föremålet tillagt i registret!",
"dep.adding": "Lägger till…",
"dep.aiError": "AI-analys otillgänglig just nu.",
"dep.aiFilled": "Formulär förifyllt av AI ✨",
"dep.aiUnavailable": "AI otillgänglig — fyll i formuläret manuellt.",
"dep.analyzing": "Analyserar…",
"dep.analyzingPhoto": "Analyserar foto…",
"dep.brand": "Märke",
"dep.brandPlaceholder": "t.ex. Apple",
"dep.category": "Kategori",
"dep.checkingDup": "Kontrollerar efter dubbletter…",
"dep.color": "Färg",
"dep.colorPlaceholder": "t.ex. svart",
"dep.condition": "Skick",
"dep.conditionPlaceholder": "t.ex. gott skick",
"dep.depositorNote": "Inlagd anteckning",
"dep.depositorNoteHint": "Operativa detaljer skrivna för hand. AI:n skriver aldrig över denna anteckning.",
"dep.depositorNotePlaceholder": "t.ex. innehåll i en påse, märke som rapporterats, detaljer givna av personen…",
"dep.descPlaceholder": "t.ex. svart iPhone 15 med ett genomskinligt fodral, hittad vid baren…",
"dep.description": "Beskrivning",
"dep.dupHint": "Se till att du inte lägger till en dubblett. Du kan fortsätta om föremålet verkligen är annorlunda.",
"dep.dupTitle": "Liknande föremål redan registrerade",
"dep.dupWarn": "Liknande föremål upptäcktes — granska, klicka sedan igen för att bekräfta.",
"dep.estHint": "Föremålet kommer att läggas till detta establishments register.",
"dep.establishment": "Etablering",
"dep.fee": "Återvinningsavgift (€) — valfri",
"dep.feePlaceholder": "Lämna tomt för standardpris i kategorin",
"dep.fillAI": "Fyll med AI",
"dep.optional": "(valfritt)",
"dep.photo": "Produktfoto",
"dep.principal": "primär",
"dep.reqError": "Kategori och beskrivning krävs.",
"dep.savedItem": "Registrerad produkt",
"dep.similarity": "Likhet",
"dep.storage": "Fysisk plats",
"dep.storageHint": "Var produkten är fysiskt lagrad. En QR-kod kommer att genereras för att hitta den.",
"dep.storagePlaceholder": "t.ex. Hylla A3, Fack 12, Mottagningsskåp",
"dl.aClient": "en kund",
"dl.alertsBlocked": "Webbläsarmeddelanden blockerade",
"dl.alertsBlockedHint": "För att återaktivera dem: klicka på 🔒 (eller ⓘ) ikonen till vänster om webbplatsens adress, aktivera Meddelanden och ladda om sidan.",
"dl.amountDue": "Belopp att betala: {amount} {currency}.",
"dl.enableAlerts": "Aktivera meddelanden",
"dl.extPending": "Betalningar att validera",
"dl.freemiumNear": "Du närmar dig Freemium-gränsen ({used}/{max} produkter denna månad). Uppgradera till Starter för obegränsat antal produkter.",
"dl.freemiumReached": "Freemium-gräns nådd ({used}/{max} produkter denna månad). Uppgradera till Starter för att registrera obegränsat antal produkter.",
"dl.invoiceOverdue": "Faktura {num} obetald — åtkomst begränsad.",
"dl.matchNotifTitle": "Findloop — Ny AI-matchning 🔔",
"dl.matchToast": "Ny AI-matchning — {name}",
"dl.matchToastDesc": "En produkt matchar en deklaration.",
"dl.notifEmpty": "Inga meddelanden än.",
"dl.notifEnabled": "Webbläsarmeddelanden aktiverade",
"dl.notifTitle": "Meddelanden",
"dl.payInvoice": "Betala min faktura →",
"dl.rewardsPending": "Kuponger att presentera",
"dl.upgradeStarter": "Uppgradera till Starter →",
"est.all": "Alla anläggningar ({n})",
"est.label": "Anläggning",
"est.primary": "primär",
"est.secondary": "sekundär",
"est2.add": "Lägg till en anläggning",
"est2.addressLabel": "Adress",
"est2.addressPh": "12 République Street",
"est2.autoInvoice": "En detaljerad faktura genereras automatiskt den 1:a varje månad.",
"est2.baseSub": "Basprenumeration",
"est2.billing": "Fakturering",
"est2.boostActivated": "Boost aktiverad för {name}",
"est2.boostBillingNote": "Faktureras till nuvarande pris och sammanfattas på din konsoliderade månatliga faktura.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Förbättra denna anläggnings synlighet i katalogen och på kartan.",
"est2.boostDuration": "{h}h av förbättrad synlighet",
"est2.boostExtend": "Förläng",
"est2.boostTitle": "Boost {name}",
"est2.boosted": "Boostad",
"est2.chartDesc": "Andel returnerade produkter av det totala registrerade, site för site.",
"est2.chartTitle": "Returneringsgrad per anläggning",
"est2.chartTooltip": "Returnera",
"est2.cityLabel": "Stad",
"est2.cityPh": "Lyon",
"est2.contactHint": "Dessa uppgifter visas för kunden för denna anläggning (återgår till kontot om tomt).",
"est2.countryLabel": "Land",
"est2.coverLabel": "Ombilder",
"est2.create": "Skapa",
"est2.created": "Anläggning skapad",
"est2.delete": "Radera",
"est2.deleteDesc": "Denna åtgärd är permanent. Du kan bara radera en anläggning om den inte innehåller några produkter.",
"est2.deleteTitle": "Radera “{name}”?",
"est2.deleted": "Anläggning raderad",
"est2.dialogDesc": "Ange namnet och adressen för denna plats.",
"est2.edit": "Redigera",
"est2.editEst": "Redigera etablering",
"est2.emailLabel": "Kontakt-e-post",
"est2.emailPh": "kontakt@site.com",
"est2.estSuffix": " etablering(ar)",
"est2.extraNoteBase": "{n} ytterligare etablering(ar) debiteras",
"est2.extraPrice": " för {price} €/månad.",
"est2.extraQuote": " vid offert.",
"est2.imgChange": "Välj en bild",
"est2.imgDone": "Klar",
"est2.imgRemove": "Ta bort",
"est2.imgRemoved": "Bild borttagen",
"est2.imgSaved": "Bild sparad",
"est2.imgUploading": "Laddar upp…",
"est2.includedPlan": "Inkluderad i din plan: {n}.",
"est2.kDeclarations": "Deklarationer",
"est2.kInStorage": "I lager",
"est2.kItemsTotal": "Objekt (totalt)",
"est2.kRestituted": "Återlämnad",
"est2.limitReached": "Gräns nådd",
"est2.logoLabel": "Logotyp",
"est2.mDeclar": "Dekl.",
"est2.mItems": "Objekt",
"est2.mRestituted": "Återlämnad",
"est2.mStorage": "I lager",
"est2.monthlyTotal": "Månadens total",
"est2.nameLabel": "Namn *",
"est2.namePh": "t.ex. Belmont Hotel — Lyon Annex",
"est2.newEst": "Ny etablering",
"est2.onQuote": "På offert",
"est2.phoneLabel": "Telefon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plan",
"est2.planLimited": "Din “{tier}” plan är begränsad till {max} etablering(ar).",
"est2.primary": "Primär",
"est2.qr": "QR-kod",
"est2.qrDesc": "Visa denna QR-kod på denna etablering. Kunder som rapporterar en förlust kommer att kopplas till denna plats.",
"est2.qrTitle": "QR-kod — {name}",
"est2.saving": "Sparar…",
"est2.seeInvoices": "Se mina månatliga fakturor",
"est2.seePlans": "Se planerna",
"est2.subtitle": "Hantera alla dina platser under ett konto – konsoliderad vy, objekt, QR-kod och fakturering.",
"est2.suspended": "Suspenderad",
"est2.tierFree": "1 etablering",
"est2.tierLarge": "obegränsat antal etableringar",
"est2.tierMedium": "5 etableringar inkluderade",
"est2.tierSmall": "3 etableringar inkluderade",
"est2.title": "Etableringar",
"est2.unlimitedPlan": "Din plan tillåter ett obegränsat antal etableringar.",
"est2.unlimitedSuffix": " · obegränsad",
"est2.updated": "Etablering uppdaterad",
"est2.upgradeHint": "Uppgradera till en högre plan för att lägga till fler platser och centralisera all din aktivitet.",
"est2.visuals": "Logotyp & foto",
"est2.visualsDesc": "Anpassa denna etablerings logotyp och omslagsfoto. De visas på dess offentliga sida och deklarationsformulär.",
"est2.visualsTitle": "Visuellt — {name}",
"est2.workOn": "Arbeta med denna etablering",
"est2.working": "Du arbetar med “{name}”",
"ev.created": "Rapport skapad",
"ev.matched": "Matchande objekt identifierat",
"ev.paid": "Återställningsavgift betald",
"ev.pickup": "Upphämtning på plats",
"ev.shipped": "Paket skickat",
"ev.shipping_paid": "Fraktavgift betald",
"ev.shipping_requested": "Frakt begärd",
"feat1.d": "KPI:er, returgrad per kategori, intäkter och trender över 30 dagar.",
"feat1.t": "Dashboard & analyser",
"feat2.d": "Etiketter, transportörspårning och automatiska spårningsmejl.",
"feat2.t": "Fraktmodul",
"feat3.d": "Kunder hittar dig efter stad och kategori, med certifierade recensioner.",
"feat3.t": "Offentlig katalog & recensioner",
"fp.backToRanking": "Tillbaka till topplistan",
"fp.badge": "Märke",
"fp.hero": "Finder Hero",
"fp.notFound": "Profilen hittades inte eller är privat.",
"fp.scoreTotal": "Totala poäng",
"fp.scoreYear": "Poäng i",
"fp.share": "Dela denna profil",
"fp.shareText": "Kolla in {name} sin finder-profil på Findloop!",
"fp.tagline": "En ärlig finder som gör världen till en bättre plats.",
"ft.backAccount": "Tillbaka till Mitt konto",
"ft.closeBtn": "Stäng ärendet",
"ft.closeConfirm": "Bekräfta att objektet har återlämnats? Annonsen stängs.",
"ft.closeLockedHint": "Verifiera ägarens kod först för att låsa upp stängningen.",
"ft.closed": "Ärendet stängt — objektet återlämnat!",
"ft.codeLabel": "Ange verifieringskoden som mottogs från ägaren",
"ft.codeNeeded": "Vänligen ange verifieringskoden.",
"ft.codeOk": "Kod verifierad — du kan stänga ärendet.",
"ft.codePlaceholder": "t.ex. 4821",
"ft.codeVerified": "Verifierad",
"ft.doneMsg": "Objektet återlämnat. Tack för att du hjälpt till att återlämna det till ägaren!",
"ft.stepInProgress": "Återlämning pågår",
"ft.stepPublished": "Annons publicerad",
"ft.stepReturned": "Objektet återlämnat",
"ft.subtitle": "Följ stegen tills det hittade objektet återlämnas.",
"ft.title": "Återlämningsspårning",
"ft.verifyBtn": "Verifiera kod",
"hero.badge": "Utmärkt",
"hero.ctaFound": "Jag hittade ett objekt",
"hero.ctaLost": "Jag förlorade ett objekt",
"hero.ctaPartner": "Bli en partner",
"hero.subtitle": "Findloop hjälper verksamheter att hantera hittade föremål — och låter deras kunder rapportera en förlust och återfå sina tillhörigheter, på plats eller genom frakt.",
"hero.title": "Varje förlorat objekt hittar sin ägare.",
"home.champBecome": "Bli en finder",
"home.champCta": "Se topplistan",
"home.champSubtitle": "Varje återlämnat objekt tjänar poäng. Gå med i topplistan och vinn belöningar.",
"home.champTitle": "Våra främsta finders",
"how.eyebrow": "Hur det fungerar",
"how.title": "Från inlämning till återlämning, utan ansträngning.",
"inv.all": "Alla",
"inv.allYears": "Alla år",
"inv.count": "Fakturor",
"inv.due": "förfallo",
"inv.empty": "Inga fakturor ännu.",
"inv.exportCsv": "Exportera CSV",
"inv.invoicePdf": "Faktura PDF",
"inv.issued": "Utfärdad",
"inv.noMatch": "Ingen faktura för detta filter.",
"inv.paid": "Betald (€)",
"inv.paidOn": "betald den",
"inv.pay": "Betala",
"inv.receipt": "Kvitto",
"inv.reminders": "Påminnelser",
"inv.remindersDesc": "E-post och SMS påminnelser skickade för denna faktura.",
"inv.remindersEmpty": "Ingen påminnelse skickad.",
"inv.rmDue": "Påminnelse om förfallodatum",
"inv.rmManual": "Manuell påminnelse",
"inv.rmSms": "SMS-påminnelse D+30",
"inv.rmStage": "Påminnelse",
"inv.statusPaid": "Betald",
"inv.statusUnpaid": "Obetald",
"inv.subtitle": "Granska och ladda ner dina fakturor och kvitton.",
"inv.title": "Mina fakturor",
"inv.unpaid": "Obetald (€)",
"inv2.contractTitle": "Mitt findloop-avtal",
"inv2.detailByEst": "Detaljer efter etablering",
"inv2.dueLabel": "Förfallodag:",
"inv2.dueSuffix": " · förfall {date}",
"inv2.error": "Fel {status}",
"inv2.estCountIssued": "{n} etablering(ar) · utfärdat {date}",
"inv2.estimate": "Kostnadsförslag (inte debiterat) · {n} etablering(ar)",
"inv2.expired": " · utgått",
"inv2.exportCsv": "Exportera CSV",
"inv2.exportDone": "CSV-export nedladdad",
"inv2.included": "Inkluderad",
"inv2.monthlyTitle": "Månadsfakturering (prenumeration)",
"inv2.months": "+{n} månader",
"inv2.paid": "Betald",
"inv2.pay": "Betala",
"inv2.previewTitle": "Förhandsvisning av din nästa faktura —",
"inv2.renew": "Förnya mitt avtal",
"inv2.renewalsTitle": "Förnyelsehistorik ({n})",
"inv2.renewedUntil": "Avtal förnyat till {date}",
"inv2.serviceTitle": "Tjänstefakturor (återvinningar & offerter)",
"inv2.soon": "Utgår snart",
"inv2.toPay": "Att betala",
"inv2.totalHtTva": "Totalt exkl. skatt · moms",
"inv2.totalTtc": "Totalt inkl. skatt",
"iu.addPhoto": "Lägg till foto",
"iu.change": "Ändra",
"lang.label": "Språk",
"lb.allCountries": "Alla länder",
"lb.badge": "Årlig topplista",
"lb.champion": "🏆 Årets mästare",
"lb.cityPh": "Filtrera efter stad…",
"lb.empty": "Ingen ranking för dessa filter ännu.",
"lb.pts": "poäng",
"lb.resetNote": "Nuvarande års topplista — återställs den 1 januari.",
"lb.returned": "återlämnad",
"lb.share": "Dela topplista",
"lb.shareText": "Kolla in topplistan för främlingar på Findloop!",
"lb.subtitle": "Varje återlämning ger poäng. Topplistan återställs varje 1 januari.",
"lb.tabFinders": "Främlingar",
"lb.tabPartners": "Etableringar",
"lb.title": "Toppfrämlingar",
"lost.b2bDesc": "Förlorat det på ett hotell, transportscentrum eller partnerställe? Hitta etableringen och rapportera din förlust.",
"lost.b2bTitle": "Rapportera till en partner",
"lost.b2cDesc": "Publicera en annons som är synlig för alla, erbjud en belöning och boosta den för att maximera dina chanser.",
"lost.b2cTitle": "Lägg upp en offentlig annons",
"lost.desc": "Välj hur du vill gå vidare.",
"lost.title": "Har du tappat ett föremål?",
"map.allCategories": "Alla kategorier",
"map.clear": "Återställ",
"map.exitFullscreen": "Avsluta",
"map.filterCity": "Stad eller land…",
"map.fullscreen": "Helskärm",
"map.heatmap": "Värmekarta",
"map.high": "Hög",
"map.impactMonth": "föremål återlämnade denna månad",
"map.impactTotal": "återlämnade totalt",
"map.legend": "Färgade prickar från röd (låg) till grön (hög) baserat på återlämningsfrekvens; storlek baserat på antalet föremål.",
"map.locating": "Lokaliserar… lägg till en adress till dina verksamheter för att se dem på kartan.",
"map.low": "Låg",
"map.mAll": "Alla",
"map.mFound": "Återfunna",
"map.mLost": "Tappade",
"map.medium": "Medel",
"map.noItemRegistered": "Inget föremål registrerat",
"map.noItems": "Inget föremål",
"map.period30": "Senaste 30 dagarna",
"map.period7": "Senaste 7 dagarna",
"map.period90": "Senaste 90 dagarna",
"map.periodAll": "Alltid",
"map.returnedSuffix": "återlämnat · {a}/{t} föremål",
"map.stats": "Stadens statistik",
"map.statsTop": "Topp 5 platser (förlorade föremål)",
"map.statsTrend": "6-månaders trend",
"map.title": "Karta över dina verksamheter",
"map.topPlaces": "Populära platser",
"mc.adClosed": "Annons stängd",
"mc.addPhoto": "Lägg till en bild",
"mc.adsNone": "Ingen annons för förlorade föremål.",
"mc.archiveHide": "Dölj historik",
"mc.archiveNone": "Inga lösta ärenden än.",
"mc.archiveShow": "Visa historik",
"mc.archiveSub": "Lösta och återlämnade ärenden.",
"mc.archiveTitle": "Historik",
"mc.at": "Vid",
"mc.backToLogin": "Tillbaka till inloggning",
"mc.boostContacts": "Kontakter (öka)",
"mc.boostViews": "Visningar (öka)",
"mc.cancel": "Avbryt",
"mc.certificate": "Intyg",
"mc.changePhoto": "Byt bild",
"mc.city": "Stad",
"mc.closeAd": "Stäng",
"mc.closeAdConfirm": "Stäng denna annons? Den kommer inte längre att vara synlig och en plats kommer att frigöras.",
"mc.confirmPassword": "Bekräfta lösenord",
"mc.confirmRestitution": "Bekräfta återlämnande",
"mc.connect": "Anslut",
"mc.contacts": "Kontakter",
"mc.country": "Land",
"mc.declareFound": "Rapportera ett återfunnet föremål",
"mc.declareFoundSub": "Lägg upp ett föremål du har funnit",
"mc.declareLost": "Rapportera en förlust",
"mc.declareLostSub": "Lägg upp en annons för ett förlorat föremål",
"mc.deleteAccount": "Radera mitt konto",
"mc.deleteConfirm": "Ja, radera mitt konto",
"mc.deleteConfirmBody": "Ditt konto kommer att raderas permanent och dina personuppgifter anonymiseras. Denna åtgärd kan inte ångras.",
"mc.deleteConfirmTitle": "Vill du radera ditt konto?",
"mc.deleteDesc": "Raderar permanent ditt konto och anonymiserar dina personuppgifter. Denna åtgärd kan inte ångras.",
"mc.deleted": "Ditt konto har raderats.",
"mc.deleting": "Raderar…",
"mc.email": "E-post",
"mc.expiresOn": "Går ut den",
"mc.exportData": "Ladda ner mina data (GDPR)",
"mc.exportDone": "Dina data har laddats ner.",
"mc.exporting": "Förbereder…",
"mc.finderAccepted": "Godkänd",
"mc.finderProfile": "Finder-profil (valfritt)",
"mc.finderProfileDesc": "Tjäna poäng genom att återlämna föremål och synas på offentliga topplistor.",
"mc.forYourAd": "För din annons",
"mc.forgotLink": "Glömt lösenord?",
"mc.forgotSend": "Skicka länken",
"mc.forgotSent": "Om ett konto finns för denna e-post har en återställningslänk just skickats.",
"mc.forgotTitle": "Glömt lösenord",
"mc.foundAdsNone": "Ingen publicerad lista över hittade föremål.",
"mc.foundAt": "Hittad vid",
"mc.foundNone": "Inga hittade föremål rapporterade.",
"mc.hAd": "Förlorad annons",
"mc.hDeclaration": "Deklaration",
"mc.hFinderContact": "Rapporterat föremål",
"mc.hFound": "Återlämnat föremål",
"mc.hFoundAd": "Hittad annons",
"mc.histEarned": "Föremål återlämnat",
"mc.historyTitle": "Min poänghistorik",
"mc.loginBtn": "Logga in",
"mc.loginTitle": "Kundinloggning",
"mc.logout": "Logga ut",
"mc.lostAt": "Förlorad vid",
"mc.matchPartner": "Hos en partner",
"mc.matchPublic": "Hittat föremål",
"mc.matches": "Matchningar",
"mc.matchesSub": "Hittade föremål kan matcha dina förlorade föremålsannonser.",
"mc.myAds": "Mina förlorade föremålsannonser",
"mc.myDeclarations": "Mina rapporter",
"mc.myFinds": "Föremål jag hittade",
"mc.myFindsNone": "Du har ännu inte rapporterat att du hittat något föremål.",
"mc.myFindsSub": "Föremål du rapporterade att du hittade på annonser för förlorade föremål.",
"mc.myFound": "Rapporterade hittade föremål",
"mc.myFoundAds": "Mina annonser för hittade föremål",
"mc.myRewards": "Mina kuponger",
"mc.name": "Fullständigt namn",
"mc.newPassword": "Nytt lösenord",
"mc.none": "Ingen rapport ännu.",
"mc.notEnough": "Inte tillräckligt med poäng",
"mc.notifEmpty": "Inga meddelanden ännu.",
"mc.notifOpen": "Visa",
"mc.notifTitle": "Meddelanden",
"mc.notifTrack": "Spåra",
"mc.notifViewAd": "Visa annons",
"mc.optInDesc": "Valfri medverkan. Du samtycker till att offentligt visa de föremål som valts nedan. Kan ändras när som helst.",
"mc.optInTitle": "Synas på offentliga topplistor",
"mc.password": "Lösenord",
"mc.passwordMismatch": "Lösenord matchar inte.",
"mc.phone": "Telefon",
"mc.photoUpdated": "Profilbild uppdaterad",
"mc.pointsAwaiting": "Poäng på väg",
"mc.pointsBalance": "Poäng att använda",
"mc.pointsOk": "Poäng krediterade",
"mc.presentHint": "Visa denna QR-kod för partnern: de skannar den för att validera din belöning.",
"mc.presentInStore": "Visa i butik",
"mc.presentTitle": "Visa denna kupong",
"mc.privacy": "Integritet & data",
"mc.privacyDesc": "Ladda ner en kopia av all personlig data som Findloop har om dig (GDPR, art. 15 & 20).",
"mc.profileSaved": "Profil uppdaterad.",
"mc.profileSettings": "Offentlig profil & leaderboard",
"mc.pseudo": "Förnamn eller smeknamn",
"mc.redExpired": "Utgått",
"mc.redReady": "Visa hos partnern",
"mc.redUsed": "Använd",
"mc.redeem": "Lösa in",
"mc.registerBtn": "Skapa mitt konto",
"mc.registerTitle": "Skapa ett kundkonto",
"mc.rememberMe": "Kom ihåg mig",
"mc.remove": "Ta bort",
"mc.resetDone": "Lösenord uppdaterat. Du kan nu logga in.",
"mc.resetExpired": "Denna återställningslänk är ogiltig eller har gått ut. Begär en ny nedan.",
"mc.resetSave": "Återställ mitt lösenord",
"mc.resetTitle": "Nytt lösenord",
"mc.restitutionConfirmed": "Återlämning bekräftad.",
"mc.reward": "Belöning",
"mc.rewardRedeemed": "Belöning upplåst! Kod:",
"mc.rewardsDesc": "Använd dina poäng för förmåner erbjudna av våra partners. Balans:",
"mc.rewardsNone": "Ingen belöning tillgänglig ännu.",
"mc.rewardsTitle": "Spendera mina poäng",
"mc.scoreAwarded": "Bra gjort! +1 till din Finder Score 🎉",
"mc.scoreEarned": "Poäng intjänad",
"mc.scorePts": "poäng",
"mc.scoreThisYear": "Detta år",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Visa leaderboard",
"mc.share": "Dela",
"mc.statsTitle": "Statistik",
"mc.subtitle": "Följ alla dina rapporter på ett ställe.",
"mc.title": "Mitt konto",
"mc.toLogin": "Redan registrerad?",
"mc.toRegister": "Inte något konto ännu?",
"mc.track": "Spåra",
"mc.views": "Visningar",
"mc.visCity": "Stad",
"mc.visCountry": "Land",
"mc.visLabel": "Objekt synliga på leaderboard:",
"mc.visName": "Förnamn / smeknamn",
"mc.visPhoto": "Profilfoto",
"mc.welcome": "Hej",
"mc2.acceptFinder": "Acceptera denna finder",
"mc2.accountActivity": "Kontoinformation",
"mc2.adsActive": "{n}/5 aktiva annonser",
"mc2.autoDelete": "Automatisk radering planerad för",
"mc2.badgeBronze": "Brons",
"mc2.badgeGold": "Guld",
"mc2.badgeSilver": "Silver",
"mc2.boostEarnedAlready": "Det har redan gett dig",
"mc2.boostEarnedWin": "Det gav dig",
"mc2.boostExpiredWin": "Din boost har just gått ut — återuppta med -20%!",
"mc2.boostExpiresIn": "Din boost går ut om",
"mc2.boostWinDetail2": ". -20% tillämpas automatiskt om du förnyar inom 24h.",
"mc2.claimCode": "Kravkod:",
"mc2.codeSentFinder": "Kod skickad till findern via e-post",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Ladda ner min kvittens",
"mc2.error": "Fel {status}",
"mc2.finderAccepted": "Finder accepterad — kod skickad via e-post",
"mc2.finderContacts": "Finder(s) kontaktuppgifter",
"mc2.followFindo": "Följ Findloop",
"mc2.imgInvalid": "Ogiltig bild",
"mc2.inactivityNote": " — vid {n} månaders inaktivitet (GDPR).",
"mc2.lastActivity": "Senaste aktivitet:",
"mc2.lostEmailTitle": "Jag har inte längre tillgång till min e-post",
"mc2.noPhotoPreset": "Ingen bild än? Välj en standardavatar:",
"mc2.paidViaPartner": "Betald (via partner)",
"mc2.payRecovery": "Betala återställningsavgiften",
"mc2.paySettle": "Avveckla min betalning",
"mc2.payShipping": "Betala fraktavgiften",
"mc2.payUnavailable": "Betalning otillgänglig",
"mc2.peopleFound": "{n} person(er) tror att de har hittat din sak",
"mc2.phoneNumber": "Telefonnummer",
"mc2.reactivateAccount": "Återaktivera mitt konto",
"mc2.reactivated": "Konto återaktiverat",
"mc2.reactivatedThanks": "Konto återaktiverat — tack för din lojalitet!",
"mc2.recoverSmsBtn": "Få min kod via SMS",
"mc2.recoverSmsDesc": "Ta emot din kravkod via SMS till numret som är registrerat på ditt konto.",
"mc2.recoverSmsFallback": "Om ett konto finns med detta nummer har ett SMS skickats.",
"mc2.renewStayTop": ". Förnya för att stanna på toppen och återfå din sak.",
"mc2.resume20": "Återuppta -20%",
"mc2.unlockContacts": "Låsa upp kontaktuppgifter",
"mc2.unlockDesc": "Betala Findloop hanteringsavgiften för att avslöja deras kontaktuppgifter och ordna överlämningen.",
"mc2.viewsWord": "visningar",
"mc2.live": "Live",
"mh.allCategories": "Alla kategorier",
"mh.allPeriod": "Alla tider",
"mh.autoMatch": "Automatisk AI-matchning",
"mh.blocked": "Blockerad (motstridighet)",
"mh.blockedReason": "Match blockerad: huvudnyckelorden för objektet och deklarationen motsäger varandra.",
"mh.days30": "Senaste 30 dagarna",
"mh.days7": "Senaste 7 dagarna",
"mh.days90": "Senaste 90 dagarna",
"mh.emptyDesc": "AI-matchningar kommer att visas här när deklarationerna kommer in.",
"mh.emptyTitle": "Inga händelser",
"mh.exportCsv": "Exportera CSV",
"mh.exportDone": "CSV-export nedladdad",
"mh.exportImpossible": "Export misslyckades",
"mh.fBlocked": "Blockerad",
"mh.fConfirmed": "Bekräftad",
"mh.fRejected": "Avvisad",
"mh.objectLabel": "Sak:",
"mh.refresh": "Uppdatera",
"mh.rejected": "Avvisad",
"mh.srcManual": "Manuell",
"mh.srcText": "Text",
"mh.srcVisual": "Visuell (foto)",
"mh.subtitle": "Logg över matchningar föreslagna av AI — automatisk matchning, bekräftad och avvisad.",
"mh.title": "AI Historik",
"nav.ads": "Förlorade föremål",
"nav.dashboard": "Mitt utrymme",
"nav.found": "Hittade föremål",
"nav.how": "Hur det fungerar",
"nav.login": "Logga in",
"nav.map": "Karta",
"nav.more": "Mer",
"nav.partners": "Partners",
"nav.pricing": "Prissättning",
"nav.ranking": "Topplista",
"nav.register": "Bli en partner",
"nav.track": "Spåra en deklaration",
"nf.desc": "Sidan du söker finns inte eller har flyttats.",
"nf.home": "Tillbaka till startsidan",
"nf.title": "Sidan hittades inte",
"par.allCities": "Alla städer",
"par.allCountries": "Alla länder",
"par.badge": "Katalog",
"par.certified": "Certifierad",
"par.certifiedBadge": "Certifierad",
"par.cityPh": "Stad",
"par.declare": "Rapportera",
"par.none": "Ingen partner hittades.",
"par.partnerBadge": "Partner",
"par.searchPh": "Sök en anläggning…",
"par.subtitle": "Hitta anläggningen där du tappade ditt föremål och rapportera din förlust.",
"par.title": "Våra partners",
"pay.addr1": "Adress",
"pay.addr2": "Adressrad 2 (valfritt)",
"pay.addrIncomplete": "Vänligen fyll i din leveransadress.",
"pay.badge": "Återvinning",
"pay.card": "Betala med kort",
"pay.city": "Stad",
"pay.country": "Land",
"pay.eurNote": "Belopp anges i euro (€).",
"pay.fee": "Återvinningsavgift",
"pay.free": "gratis",
"pay.howRecover": "Hur vill du ha tillbaka ditt föremål?",
"pay.momo": "Betala med Mobile Money",
"pay.momoConfirm": "Bekräfta betalning",
"pay.noMatch": "Inga matchande föremål har bekräftats för denna rapport än.",
"pay.notfound": "Rapporten hittades inte.",
"pay.phonePh": "Telefonnummer",
"pay.pickup": "Hämta personligen",
"pay.pickupDesc": "Vid",
"pay.postal": "Postnummer",
"pay.secure": "Säker betalning",
"pay.serviceFee": "Findloop serviceavgift",
"pay.ship": "Skicka det till mig",
"pay.shipAfter": "— erbjuds efter betalning.",
"pay.shipDesc": "Leverans till min adress",
"pay.shipNote": "Frakt tillgänglig",
"pay.shipping": "Fraktavgift",
"pay.subtitleWith": "Betala återvinningsavgiften till",
"pay.title": "Återfå mitt föremål",
"pay.total": "Totalt",
"pcat.city_hall": "Rådhus",
"pcat.hotel": "Hotell",
"pcat.other": "Övrigt",
"pcat.park": "Parker",
"pcat.prefecture": "Prefekturer",
"pcat.restaurant": "Restauranger",
"pcat.uncategorized": "Okategoriserat",
"pd.about": "Om",
"pd.back": "Alla partners",
"pd.certified": "Certifierad partner",
"pd.declare": "Rapportera en förlust här",
"pd.itemsReturned": "returnerade objekt",
"pd.itemsTotal": "registrerade objekt",
"pd.map": "Plats",
"pd.noItems": "Inga objekt hittades nyligen.",
"pd.noReviews": "Inga recensioner ännu.",
"pd.notFound": "Partnern hittades inte.",
"pd.recentItems": "Nyligen hittade objekt",
"pd.reply": "Svar från verksamheten",
"pd.reviews": "Kundrecensioner",
"pd.verified": "Verifierad recension",
"pd.verifiedEstablishment": "Findloop verifierad verksamhet",
"pg.next": "Nästa",
"pg.prev": "Föregående",
"pg.showing": "{from}–{to} av {total}",
"pk.bodyCopy": "Brödtext",
"pk.bodyText": "Textinnehåll",
"pk.brandColors": "Varumärkesfärger",
"pk.colorRed": "Röd",
"pk.colorWhite": "Vit",
"pk.darkBg": "Mörk bakgrund",
"pk.download": "Ladda ner",
"pk.downloadZip": "Ladda ner hela paketet (ZIP)",
"pk.headings": "Rubriker",
"pk.heroDesc": "Officiella logotyper, banners för sociala medier, färger och typografi. Välj språk och variant för slogan, och ladda sedan ner visualen eller hela paketet.",
"pk.lightBg": "Ljus bakgrund (tryck)",
"pk.logoWordmark": "Logotyp / ordmärke",
"pk.logosVisuals": "Logotyper & visualer",
"pk.mapCollect": "Karta / insamlingspunkter",
"pk.plain": "Enkel",
"pk.pressKit": "Presskit",
"pk.taglineLang": "Språk för slogan",
"pk.typography": "Typografi",
"pk.variant": "Variant",
"pr.shipBtn": "Få objektet skickat",
"pr2.adBoostMsg": "Bra val! Du multiplicerar dina chanser att snabbt återfå ditt objekt.",
"pr2.boostActivated": "Boosten aktiverad!",
"pr2.canRecoverNow": "Du kan nu återfå ditt objekt.",
"pr2.continue": "Fortsätt",
"pr2.downloadReceiptPdf": "Ladda ner kvittot (PDF)",
"pr2.goToSpaceNow": "Gå till mitt konto nu",
"pr2.partnerBoostMsg": "Bra val! Att vara mer synlig innebär att attrahera nya kunder till din verksamhet.",
"pr2.paymentSuccess": "Betalning genomförd!",
"pr2.redirectingSpace": "Omdirigerar till ditt konto…",
"pr2.subActivated": "Betalning genomförd! Din prenumeration är aktiv, du kan nu hantera dina verksamheter.",
"prev.allSites": "Alla verksamheter",
"prev.editReply": "Redigera svar",
"prev.none": "Ingen recension ännu.",
"prev.published": "Svar publicerat",
"prev.reply": "Svar",
"prev.replyPh": "Skriv ett artigt svar…",
"prev.send": "Publicera svar",
"prev.sending": "Publicerar…",
"prev.yourReply": "Ditt svar",
"pricing.annual": "Årlig",
"pricing.annualBadge": "-20% erbjudande",
"pricing.choose": "Välj",
"pricing.compareFeature": "Funktion",
"pricing.compareTitle": "Jämför planer",
"pricing.eyebrow": "Prissättning",
"pricing.month": "/månad",
"pricing.monthly": "Månatligt",
"pricing.perYear": "/år",
"pricing.popular": "Populär",
"pricing.quoteMsg": "Dina behov (valfritt)",
"pricing.quoteOrg": "Organisation",
"pricing.quoteSend": "Skicka förfrågan",
"pricing.quoteSent": "Förfrågan skickad! Vi återkommer snart.",
"pricing.quoteSites": "Antal platser / terminaler",
"pricing.quoteTitle": "Begär en offert",
"pricing.requestQuote": "Begär en offert",
"pricing.saveLabel": "Du sparar",
"pricing.savePerYear": "/år per extra etablering",
"pricing.start": "Starta",
"pricing.subtitle": "Börja gratis, växa i takt med att du växer.",
"pricing.title": "En plan för varje organisation",
"promo.badge": "Partnerprogram",
"promo.cta": "Läs mer",
"promo.text": "Varje partner du hänvisar som prenumererar ger dig en gratis månad. Ingen gräns.",
"promo.title": "Hänvisa en partner, få en gratis månad.",
"pub.accessGranted": "Åtkomst beviljad",
"pub.accessLimited2h": "Åtkomst begränsad till 2 timmar",
"pub.accountEmailConcerned": "E-post för det berörda kontot",
"pub.adAppearPublic": "Så här kommer din annons att visas offentligt.",
"pub.adPreviewBtn": "Annonsförhandsvisning",
"pub.alertMeOnArrival": "Meddela mig vid ankomst",
"pub.allActionsLogged": "Alla åtgärder loggas",
"pub.allCategories": "Alla kategorier",
"pub.authorizeAccess": "Behörighet för åtkomst",
"pub.authorizeSupportQ": "Godkänna stödåtkomst?",
"pub.available": "Tillgänglig",
"pub.backHome": "Tillbaka till startsidan",
"pub.boostAdCta": "Öka min annons",
"pub.boostAdTitle": "Öka din annons",
"pub.boostCarouselSub": "Flytta till toppen av sidan i det “Ökade” karusellen och multiplicera visningar för att återfå din artikel snabbare.",
"pub.boostEstablishment": "Öka din etablering",
"pub.boostEstablishmentDesc": "Visa dig högst upp i katalogen med en “Ökad” badge och attrahera fler rapporter.",
"pub.boostFicheCta": "Öka min notering",
"pub.brandReady": "findloop-varumärket, redo att användas",
"pub.cantFindItem": "Kan du inte hitta din artikel?",
"pub.cantProcessImage": "Kunde inte bearbeta denna bild",
"pub.claimQr": "Kräv QR-kod",
"pub.clickToZoom": "Klicka för att zooma",
"pub.codeAlreadyValidated": "Kod validerad — kontakter upplåsta.",
"pub.codeExample": "t.ex. ABCD2345",
"pub.confirmRenewal": "Bekräfta förnyelse",
"pub.contactIntro": "En fråga, en begäran? Skriv till oss, vi återkommer snart.",
"pub.contactTypeDeceased": "Kontots radering (avliden person)",
"pub.contactTypeGeneral": "Allmän fråga",
"pub.contactTypeSupport": "Support / tekniskt problem",
"pub.contactUs": "Kontakta oss",
"pub.continueWithoutEmail": "Fortsätt utan att lämna min e-post",
"pub.contractLabel": "Kontrakt",
"pub.contractNotFound": "Kontraktet hittades inte eller har redan gått ut.",
"pub.contractRenewed": "Kontrakt förnyat!",
"pub.contractRenewedFor": "Ditt kontrakt är förnyat i {n} månader.",
"pub.copyFailed": "Kopiering misslyckades",
"pub.createPartnerAccount": "Skapa mitt partnerkonto",
"pub.currentDeadline": "Nuvarande deadline",
"pub.deceasedInfo": "Som släkting eller arvinge kan du begära radering av en avliden persons findloop-konto. Vi kommer att behandla din begäran i enlighet med GDPR (stödjande dokument kan begäras).",
"pub.declareMyLoss": "Anmäl min förlust",
"pub.describeItemPlaceholder": "Beskriv din artikel (t.ex. svart paraply, nycklar…)",
"pub.downloadImage": "Ladda ner bilden",
"pub.drawSignature": "Vänligen rita din signatur.",
"pub.drawSignatureHint": "Rita din signatur med musen eller fingret.",
"pub.duration": "Varaktighet",
"pub.eSignature": "Elektronisk signatur",
"pub.eSignatureDesc": "Ange ditt namn för att signera. Datumet registreras automatiskt.",
"pub.edit": "Redigera",
"pub.editorialTitles": "Redaktionella titlar",
"pub.emailPlaceholder": "du@example.com",
"pub.enterCodeUnlockOwner": "Ange koden som du fått via e-post för att låsa upp ägarens kontaktuppgifter.",
"pub.errorWord": "Fel",
"pub.foundSelfService": "Hittade artiklar · Självbetjäning",
"pub.haveOwnerCode": "Jag har fått en kod från ägaren",
"pub.home": "Hem",
"pub.immediateRenewal": "Omedelbar förnyelse, utan ny offert.",
"pub.impAdminReq1": "Administratör",
"pub.impAdminReq2": "begär tillstånd att tillfälligt få tillgång till ditt konto",
"pub.impAdminReq3": "för att hjälpa dig.",
"pub.impGrantedDesc": "Supportteamet kommer att kunna få tillgång till ditt konto i högst 2 timmar. Varje åtgärd kommer att loggas. Du kan stänga den här sidan.",
"pub.invitedOnFindo": "Du är inbjuden till Findloop",
"pub.isThisYourItem": "Är detta din artikel?",
"pub.itemsAvailableCount": "{n} artikel(ar) är för närvarande tillgängliga",
"pub.itemsFoundOwner": "av de överlämnade artiklarna har funnit sin ägare",
"pub.itemsReturnedOwners": "artiklar återlämnade till sina ägare",
"pub.itsMine": "Det är min",
"pub.joinFindoDesc": "Gå med i Findloop och hantera dina hittade artiklar enkelt.",
"pub.joinInvitesYou": "inbjuder dig att gå med i findloop. Skapa ditt partnerkonto för att hantera dina hittade artiklar.",
"pub.linkCopied": "Länken kopierad!",
"pub.loadingContract": "Laddar kontraktet…",
"pub.lsClaimDesc": "Rapportera din förlust för att återfå den. Lämna din e-postadress så skickar vi en påminnelse om din rapport inte är slutförd.",
"pub.lsHeroDesc": "Kontrollera själv om din förlorade artikel har hittats och lämnats här. Hittade du den? Rapportera det för att återfå den.",
"pub.lsSearchTitle": "Sök efter hittade artiklar",
"pub.makeOffer": "Lägg ett erbjudande",
"pub.makeOfferDesc": "Föreslå ditt belopp. Superadministratören kommer att granska det.",
"pub.mapNearYou": "Artiklar & partners nära dig",
"pub.mapWord": "Karta",
"pub.messageSentToast": "Meddelande skickat — vårt team kommer att svara snart.",
"pub.messageWord": "Meddelande",
"pub.momoInitiated": "Mobilbetalning initierad",
"pub.monthsWord": "månader",
"pub.nameConsentRequired": "Namn och samtycke krävs.",
"pub.newDeadline": "Ny deadline",
"pub.noActionRequired": "Ingen åtgärd krävs.",
"pub.noAmountCharged": "Inget belopp har debiterats.",
"pub.noItemMatch": "Inga tillgängliga artiklar matchar din sökning just nu.",
"pub.noMatchingItem": "Ingen matchande artikel",
"pub.noPaymentSession": "Ingen betalningssession.",
"pub.noPhoto": "Ingen bild",
"pub.noPointsYet": "Inga poäng att visa än.",
"pub.noSecondPayment": "Ingen andra betalning krävs för denna artikel.",
"pub.notHereYet": "Är den inte här än? Få ett meddelande så snart den anländer.",
"pub.notifyDone": "Noterat! Vi kommer att meddela dig via e-post så snart en matchande artikel anländer.",
"pub.offerSubmitted": "Ditt erbjudande har skickats in.",
"pub.oops": "Oj",
"pub.orAlertEmail": "Eller få en avisering via e-post så snart en matchande artikel anländer:",
"pub.ownerContacts": "Ägarens kontaktuppgifter",
"pub.ownerContactsUnlocked": "Ägarens kontaktuppgifter upplåsta",
"pub.partnerContact": "Partnerkontakt",
"pub.payLinkUnavailable": "Betalningslänk inte tillgänglig — kontakta partnern.",
"pub.paymentCancelled": "Betalning avbruten",
"pub.paymentConfirmed": "Betalning bekräftad 🎉",
"pub.paymentConfirmedDesc": "Du kommer att få ett mejl med detaljer för att återfå din vara.",
"pub.paymentNotConfirmed": "Betalning ej bekräftad",
"pub.paymentNotConfirmedDesc": "Betalningen kunde inte verifieras. Försök igen eller kontakta partnern.",
"pub.paymentProcessing": "Betalning behandlas. Uppdatera om en stund.",
"pub.photoAdded": "✓ Foto tillagt",
"pub.photoRequired": "Ett foto av varan krävs.",
"pub.previewAlt": "förhandsgranskning",
"pub.publish": "Publicera",
"pub.publishingWord": "Publicerar…",
"pub.qty": "Antal",
"pub.quoteDeclined": "Erbjudande avböjt.",
"pub.quoteNotFound": "Erbjudande hittades inte eller har löpt ut.",
"pub.reasonLabel": "Orsak",
"pub.recoveryAlreadyPaid": "Återhämtningsavgift redan betald",
"pub.referralCode": "Referenskod:",
"pub.relationshipPlaceholder": "Son, make, notarien…",
"pub.renewYourContract": "Förnya ditt avtal",
"pub.renewalFailed": "Förnyelse misslyckades. Försök igen senare.",
"pub.renewing": "Förnyar…",
"pub.replySoon": "Vårt team svarar så snart som möjligt.",
"pub.requestGone": "Denna begäran existerar inte längre.",
"pub.requestHandled": "Begäran har redan hanterats",
"pub.requestNotFound": "Begäran hittades inte eller har löpt ut.",
"pub.requestUnavailable": "Begäran otillgänglig",
"pub.required": "(obligatoriskt)",
"pub.retroClosing": "Tillsammans gör vi världen lite mindre förlorad.",
"pub.retroClosing2": "Tillsammans gör vi världen lite mindre förlorad.",
"pub.retroScroll": "Ett år av att återfå det som betyder något. Scrolla ner ↓",
"pub.revokeAnytime": "Du kan återkalla när som helst genom att kontakta oss",
"pub.scene": "Scen",
"pub.sendImpossible": "Ett skickande var omöjligt",
"pub.sendMessage": "Skicka meddelandet",
"pub.sending": "Skickar…",
"pub.sharePreview": "Dela förhandsgranskning",
"pub.shareYourAd": "Dela din annons",
"pub.signedSuccess": "Signerad framgångsrikt!",
"pub.signerFullName": "Signerandes fullständiga namn",
"pub.spreadNetwork": "Dela det med dem omkring dig för att öka dina chanser.",
"pub.spreadOwner": "Dela det för att hjälpa ägaren att återfå sina tillhörigheter.",
"pub.statusLabel": "Status:",
"pub.subject": "Ämne",
"pub.thanksSent": "Tack, ditt meddelande har skickats.",
"pub.thisYear": "Detta år",
"pub.validate": "Validera",
"pub.verifyingPayment": "Verifierar betalning…",
"pub.verifyingYourPayment": "Verifierar din betalning…",
"pub.viewAd": "Se annonsen →",
"pub.viewPartner": "Se partnern →",
"pub.yourAdPreview": "Förhandsgranskning av din annons",
"pub.yourEmail": "Din e-post",
"pub.yourEmailRecommended": "Din e-post (rekommenderas)",
"pub.yourEmailShort": "Din e-post",
"pub.yourName": "Ditt namn",
"pub.yourRelationship": "Din relation till personen",
"qv.acceptAndSign": "Acceptera och signera mitt erbjudande",
"qv.certifyAuthorized": "Jag intygar att jag är behörig att signera och jag accepterar villkoren för denna {what} (bindande värde).",
"qv.clear": "Rensa",
"qv.client": "Kund",
"qv.conditions": "Villkor",
"qv.confirmDecline": "Bekräfta avvisningen av denna offert?",
"qv.countersignedFindo": "Kontrakterad av Findloop · {name} den {date}",
"qv.decline": "Avvisa",
"qv.description": "Beskrivning",
"qv.downloadPdf": "Ladda ner PDF",
"qv.handwrittenSignature": "Handskriven signatur",
"qv.inclTax": "Inkl. skatt",
"qv.invalidAmount": "Ogiltigt belopp.",
"qv.invoice": "Faktura",
"qv.invoicePaid": "Faktura betald",
"qv.issuer": "Utfärdare",
"qv.messageOptional": "Meddelande (valfritt)",
"qv.negotiatedAmount": "Förhandlat belopp",
"qv.payInvoiceOnline": "Betala fakturan online",
"qv.quote": "Offert",
"qv.quoteValidDays": "Offert giltig i {n} dagar.",
"qv.sendMyOffer": "Skicka mitt erbjudande",
"qv.signContract": "Signera mitt kontrakt",
"qv.signNow": "Signera nu",
"qv.signatureAlt": "Signatur",
"qv.signedByOn": "✔ Signerad av {name} den {date}",
"qv.stContractSigned": "Kontrakt signerat. Tack!",
"qv.stCounterAccepted": "Ditt erbjudande har accepterats! Signera ditt kontrakt nedan.",
"qv.stCounterRefused": "Ditt erbjudande kunde inte accepteras.",
"qv.stCountered": "Ditt erbjudande har skickats. Väntar på findos svar.",
"qv.stDeclined": "Du har avvisat denna offert.",
"qv.stSigned": "Offert accepterad och signerad. Tack!",
"qv.totalHt": "Totalt exkl. skatt",
"qv.totalTtc": "Totalt inkl. skatt",
"qv.unitHt": "Enhet exkl. skatt",
"qv.vat": "Moms",
"qv.yourProposedAmount": "Ditt föreslagna belopp ({cur})",
"rate.chooseNote": "Vänligen välj en bedömning.",
"rate.commentPh": "En kommentar (valfritt)…",
"rate.home": "Tillbaka till startsidan",
"rate.submit": "Skicka min recension",
"rate.submitting": "Skickar…",
"rate.subtitle": "Hur gick det att återfå ditt föremål?",
"rate.successText": "Din feedback hjälper andra användare.",
"rate.successTitle": "Tack för din recension!",
"rate.title": "Betygsätt din upplevelse",
"reg.add": "Logga ett föremål",
"reg.allBrands": "Alla märken",
"reg.allColors": "Alla färger",
"reg.allLocations": "Alla platser",
"reg.detailDesc": "Detaljer och åtgärder för detta fyndade föremål.",
"reg.dispAuction": "Auktion",
"reg.dispAuthorities": "Överlämnat till myndigheterna",
"reg.dispDestroyed": "Förstört",
"reg.dispDonate": "Veldedig donation",
"reg.dispositionHint": "Registrera föremålet som lämnar lagring. Räknas i statistik per kategori.",
"reg.emptyCta": "Logga ett föremål",
"reg.emptyDesc": "Börja med att logga ditt första fyndade föremål.",
"reg.emptyTitle": "Inga föremål funna",
"reg.establishmentFallback": "etableringen",
"reg.lblAuctioned": "listad på auktion",
"reg.lblAuctionedShort": "auktionerad",
"reg.lblAuthorities": "överlämnat till myndigheterna",
"reg.lblDestroyed": "förstört",
"reg.lblDonated": "donerat till en välgörenhet",
"reg.legalCount": "{n} föremål: den juridiska bevarandeperioden nådd",
"reg.legalHint": "Du kan lista dem på auktion, donera dem till en välgörenhet eller rapportera att du överlämnat dem till myndigheterna.",
"reg.legalLimitCountry": "Deadline: {date} · tillämpat land: {country}",
"reg.legalOver": "Deadline passerad: {date} · {country}",
"reg.legalReached": "Juridisk period nådd",
"reg.legalReachedFull": "Juridisk bevarandeperiod nådd",
"reg.limitShort": "deadline",
"reg.location": "Plats",
"reg.markRestituted": "Markera som återlämnad",
"reg.markedAs": "Föremål markerat som {label}",
"reg.moveHistory": "Rörelsehistorik",
"reg.overBy": "över med {n}d",
"reg.physicalLocation": "Fysisk plats",
"reg.popupBlocked": "Tillåt pop-ups för att skriva ut etiketterna.",
"reg.popupBlockedOne": "Tillåt pop-ups för att skriva ut etiketten.",
"reg.printLabel": "Skriv ut etiketten",
"reg.printN": "Skriv ut {n} etikett(er)",
"reg.qrCodeItem": "Föremålets QR-kod",
"reg.qrLabelTitle": "QR-etikett",
"reg.qrLabelsTitle": "QR-etiketter",
"reg.qrNotFound": "Inget föremål hittades för denna QR-kod.",
"reg.qrScanHint": "Skanna den för att öppna detta register direkt och hitta platsen.",
"reg.recoveryFee": "Återställningsavgift (€)",
"reg.searchPh": "Sök efter beskrivning…",
"reg.selectQr": "Välj för att skriva ut QR-etiketter",
"reg.selectedN": "{n} valda",
"reg.shipPricePh": "Fraktpris (€)",
"reg.shippingPossible": "Frakt tillgänglig",
"reg.storagePh": "t.ex. Hylla A3, Fack 12",
"reg.tAuction": "Auktion på Findloop",
"reg.tAuthorities": "Rapportera överlämnande till myndigheterna",
"reg.tDonate": "Donera till en välgörenhet",
"reg.toastFee": "Avgift uppdaterad",
"reg.toastLocation": "Plats sparad",
"reg.toastRestituted": "Föremål markerat som återlämnat",
"reg.toastShipping": "Fraktalternativ uppdaterat",
"reg.toastTransferred": "Föremål överfört till “{name}”",
"reg.unclaimedDisposition": "Oanvänt föremål - slutlig disposition",
"res.codeValidated": "Kod validerad",
"res.empty": "Inga restitutioner registrerade än.",
"res.error": "Fel {status}",
"res.proofPdf": "PDF-bevis",
"res.signed": "Undertecknad",
"res.stRestituted": "Överlämnad personligen",
"res.stShipped": "Återlämnad genom frakt",
"res.subtitle": "Alla genomförda överlämnanden, med deras nedladdningsbara signerade bevis.",
"res.title": "Restitutionshistorik",
"rev.b2b": "B2B-partners",
"rev.b2c": "Kunder",
"rev.based": "baserat på {n} recensioner",
"rev.eyebrow": "Testimonialer",
"rev.restitutedBy": "Återlämnad av {org}",
"rev.storiesEyebrow": "Lyckliga slut",
"rev.storiesSubtitle": "Verkliga berättelser från kunder som återfick sina tillhörigheter med findloop.",
"rev.storiesTitle": "De hittade sina tillhörigheter!",
"rev.subtitle": "Partners och kunder delar sina erfarenheter.",
"rev.title": "De litar på Findloop",
"rev.verified": "Verifierad",
"rp.already": "Du har redan rapporterat denna lista.",
"rp.comment": "Detaljer (valfritt)",
"rp.duplicate": "Duplicera",
"rp.fraud": "Bedrägeri",
"rp.inappropriate": "Innehåll som är olämpligt",
"rp.offensive": "Stötande innehåll",
"rp.other": "Annat",
"rp.reason": "Orsak",
"rp.report": "Rapportera",
"rp.send": "Skicka rapport",
"rp.sent": "Rapport skickad. Tack för ditt bidrag.",
"rp.spam": "Spam / reklam",
"rp.title": "Rapportera denna annons",
"rp.wrongCategory": "Fel kategori",
"rt.annualGoal": "Årligt mål",
"rt.championCity": "Mästarstad",
"rt.cityRate": "{rate}% återbetalningsgrad",
"rt.goalProgress": "{rate}% uppnått av ett {target}% mål",
"rt.reached": "Uppnått 🎉",
"rt.restitutionRate": "Återbetalningsgrad",
"rt.shareRecap": "Dela min sammanställning",
"rt.thanks": "Tack Findloop {year} 💛",
"rt.yourRecap": "Din {year} sammanställning",
"rw.active": "Aktiv",
"rw.add": "Lägg till",
"rw.camUnavailable": "Kamera otillgänglig. Ange koden manuellt nedan.",
"rw.codeValidated": "Koden validerad",
"rw.codesTitle": "Koder inlösta av finders",
"rw.confirmDelete": "Ta bort “{title}”? ",
"rw.deleted": "Borttagen",
"rw.edit": "Redigera",
"rw.editReward": "Redigera belöningen",
"rw.empty": "Ingen belöning ännu.",
"rw.expired": "Utgått",
"rw.expiresOn": "Går ut {date}",
"rw.fActive": "Aktiv (synlig för finders)",
"rw.fCost": "Kostnad (poäng)",
"rw.fDesc": "Beskrivning",
"rw.fStock": "Lager (tomt = obegränsat)",
"rw.fTitle": "Titel",
"rw.fValidity": "Kupongens giltighet (dagar efter inlösen)",
"rw.inactive": "Inaktiv",
"rw.newReward": "Ny belöning",
"rw.noExchange": "Ingen inlösen än.",
"rw.pageSubtitle": "Skanna kupongerna som presenteras av finders för att validera deras belöningar.",
"rw.redeemedN": "Inlösta: {n}×",
"rw.saved": "Belöning sparad",
"rw.scanVoucher": "Skanna en kupong",
"rw.staffScanOnly": "Skanna endast",
"rw.statActive": "Att presentera",
"rw.statExpired": "Utgått",
"rw.statRedeemed": "Kuponger inlösta",
"rw.statUsed": "Validerad",
"rw.stock": "Lager",
"rw.subtitle": "Erbjud icke-monetära förmåner (kuponger, uppgraderingar…) som finders kan lösa in för sina Finder Score-poäng.",
"rw.title": "Belöningar för finders",
"rw.used": "Används",
"rw.validate": "Validera",
"rw.validateCode": "Validera koden",
"rw.validity": "Giltighet: {n} d",
"shell.f1d": "Automatiskt koppla förlorade och hittade föremål.",
"shell.f1t": "Smart AI-matchning",
"shell.f2d": "Spåra returprocent och intäkter i realtid.",
"shell.f2t": "Instrumentpanel & intäkter",
"shell.f3d": "Dina kunder rapporterar på 30 sekunder.",
"shell.f3t": "Partner QR-kod",
"shell.title": "Omvandla förlorade föremål till nöjda kunder.",
"ship.addr1": "Adress",
"ship.addr2": "Adressrad 2 (valfritt)",
"ship.badge": "Frakt",
"ship.city": "Stad",
"ship.country": "Land",
"ship.needPaid": "Betala återvinningsavgiften först för att begära frakt.",
"ship.notShippable": "Detta föremål är inte tillgängligt för frakt.",
"ship.notfound": "Rapporten hittades inte.",
"ship.postal": "Postnummer",
"ship.price": "Fraktkostnad",
"ship.submit": "Begär frakt",
"ship.submitting": "Skickar…",
"ship.subtitle": "Ange din leveransadress.",
"ship.successText": "Partnern kommer att förbereda ditt paket. Du kommer att bli meddelad när det skickas.",
"ship.successTitle": "Fraktbegäran skickad!",
"ship.title": "Få ditt föremål skickat",
"ship.weight": "Uppskattad vikt (kg)",
"shp.carrier": "Fraktföretag",
"shp.download": "Ladda ner PDF",
"shp.generating": "Genererar…",
"shp.label": "Generera etikett",
"shp.none": "Ingen frakt begärd.",
"shp.setTracking": "Spara spårning",
"shp.status": "Status",
"shp.to": "Mottagare",
"shp.tracking": "Tracking nr.",
"shp.trackingSaved": "Spårning sparad",
"side.account": "Mitt konto",
"side.declarations": "Rapporter",
"side.deposit": "Logga ett föremål",
"side.establishments": "Etableringar",
"side.invoices": "Fakturor",
"side.logout": "Logga ut",
"side.matchHistory": "AI-historik",
"side.partner": "Partner",
"side.refresh": "Uppdatera",
"side.registry": "Registrering",
"side.restitutions": "Returer",
"side.reviews": "Recensioner",
"side.rewards": "Belöningar & Vouchers",
"side.settings": "Inställningar",
"side.shipments": "Leveranser",
"side.stats": "Statistik",
"side.storage": "Lagring & QR",
"side.team": "Team",
"side.viewSite": "Visa offentlig webbplats",
"st.auctioned": "Såld på auktion",
"st.claimed": "Anmäld",
"st.closed": "Stängd",
"st.delivered": "Levererad",
"st.destroyed": "Förstörd",
"st.donated": "Donerad (välgörenhet)",
"st.handed_to_authorities": "Överlämnad till myndigheterna",
"st.in_storage": "I lager",
"st.matched": "Match hittad",
"st.open": "Öppen",
"st.paid": "Betald",
"st.pending": "Väntande",
"st.resolved": "Löst",
"st.restituted": "Återlämnad",
"st.second_chance": "Andra chansen",
"st.shipped": "Skickad",
"st.shipping_requested": "Frakt begärd",
"st.submitted": "Inskickad",
"st.verified": "Verifierad",
"stat.items": "Registrerade objekt",
"stat.partners": "Partners",
"stat.restituted": "Återlämnade objekt",
"status.auctioned": "Auktionerad",
"status.destroyed": "Förstörd",
"status.donated": "Donerad (välgörenhet)",
"status.handed_to_authorities": "Överlämnad till myndigheterna",
"status.in_storage": "I förvaring",
"status.matched": "Match",
"status.open": "Öppen",
"status.paid": "Betald",
"status.pending": "Väntande",
"status.restituted": "Återlämnad",
"status.shipped": "Skickad",
"status.shipping_requested": "Frakt begärd",
"status.submitted": "Inskickad",
"step1.tag": "Etablering",
"step1.text": "På sekunder loggar etableringen det hittade objektet med foto, kategori och beskrivning. Allt är centraliserat i ett tydligt, säkert register.",
"step1.title": "Partnern registrerar objektet",
"step2.tag": "Kund",
"step2.text": "Via partnerns QR-kod beskriver din kund det förlorade objektet på 30 sekunder. Ingen app att installera — allt sker i webbläsaren.",
"step2.title": "Kunden rapporterar förlusten",
"step3.tag": "Intelligens",
"step3.text": "Vår smarta matchningsmotor jämför beskrivningar och föreslår de mest troliga matcherna, redo för bekräftelse.",
"step3.title": "AI kopplar förlust och hittat objekt",
"step4.tag": "Återhämtning",
"step4.text": "Efter en säker betalning av avgiften för återhämtning hämtar kunden objektet på plats — eller får det via spårad frakt.",
"step4.title": "Kunden får tillbaka sitt objekt",
"stg.allLabels": "Alla QR-etiketter",
"stg.camHint": "Använd manuell inmatning nedan.",
"stg.camStarting": "Startar kameran…",
"stg.camUnavailable": "Kamera otillgänglig.",
"stg.clear": "Rensa",
"stg.clearAll": "Rensa alla",
"stg.codeUnreadable": "Otillgänglig kod.",
"stg.emptyDesc": "Lagrade objekt kommer att visas här, grupperade efter plats.",
"stg.emptyTitle": "Inga objekt i förvaring",
"stg.exportAudit": "Exportera revisions-CSV",
"stg.exportDone": "CSV-export nedladdad",
"stg.exportImpossible": "Export otillgänglig just nu.",
"stg.itemFound": "Objekt hittat ✅",
"stg.kLocations": "Använda platser",
"stg.kObjects": "Lagrade objekt",
"stg.kToClear": "Platser att rensa",
"stg.locFreed": "Plats rensad",
"stg.locsFreed": "{n} plats(er) rensad(e)",
"stg.manualLabel": "Eller ange objektets kod / ID",
"stg.manualPh": "Klistra in QR:s ID eller URL",
"stg.noItemMatch": "Inga objekt matchar denna QR / kod.",
"stg.noLocation": "Ingen plats",
"stg.objectsAxis": "Objekt",
"stg.objectsN": "{n} objekt",
"stg.occAvg": "i genomsnitt {n} objekt/plats",
"stg.occHint": "Platser i amber överstiger genomsnittet (potentiellt överbelastade).",
"stg.occupancy": "Platstillgång",
"stg.openPage": "Öppna sidan",
"stg.posterPdf": "PDF-plakat (A4)",
"stg.printAll": "Skriv ut allt",
"stg.printGroupTitle": "Skriv ut etiketter för denna hylla",
"stg.qrAlt": "Självbetjänings QR",
"stg.qrDownload": "Ladda ner QR",
"stg.qrHint": "Visa denna QR i kassan: dina kunder skannar den för att kontrollera om deras objekt finns tillgängligt.",
"stg.qrTitle": "Självbetjänings QR för kunder",
"stg.scanDesc": "Skanna en etikett för att direkt öppna dess post.",
"stg.scanQr": "Skanna en QR",
"stg.scanTitle": "Skanna en QR-kod",
"stg.search": "Sök",
"stg.shelf": "Hylla {loc}",
"stg.shelfPlan": "Hylla plan",
"stg.staleHint": "Rensa dessa platser för att hålla ditt fysiska lager uppdaterat.",
"stg.staleTitle": "{n} objekt har lämnat lagret men har fortfarande en plats",
"stg.subtitle": "Hylla plan, QR-skanner och spårning av fysiskt lager.",
"stg.title": "Lager & QR",
"stt.acceptRate": "Acceptansnivå",
"stt.accepted": "Accepterad",
"stt.activity30": "Aktivitet (senaste 30 dagarna)",
"stt.ai6mo": "Senaste 6 månaderna · accepterad = automatiskt matchad + bekräftad.",
"stt.aiEmpty": "Inga AI-matcher under denna period ännu.",
"stt.aiTitle": "AI-matcher — accepterade vs avvisade",
"stt.auctionShort": "Auktion",
"stt.auctionedSold": "Auktionsförsäljning",
"stt.authShort": "Myndigheter",
"stt.authorities": "Överlämnat till myndigheterna",
"stt.avgRating": "Genomsnittlig bedömning",
"stt.awaitingRestitution": "objekt som väntar på återlämnande",
"stt.boostClicks": "Klick på din katalog denna vecka tack vare boost",
"stt.boostInactive": "Boost inaktiv — aktivera den för att få synlighet",
"stt.certifiedPremium": "Premiumcertifierad",
"stt.declarations": "Deklarationer",
"stt.destroyed": "Förstörd",
"stt.dispoEmpty": "Inga oclaimade objekt har lämnat lagret än.",
"stt.donatedAssoc": "Donerat (välgörenhet)",
"stt.donatedShort": "Donerat",
"stt.gateCta": "Upptäck planerna",
"stt.gateDesc": "Uppgradera till Starter för att låsa upp dina grundläggande statistiker, eller till Business för avancerad statistik och analys per verksamhet.",
"stt.gateTitle": "Statistik reserverad för betalda planer",
"stt.inStorage": "I lagret",
"stt.kItems": "Registrerade objekt",
"stt.kRate": "Återlämningsgrad",
"stt.kRestituted": "Objekt återlämnade",
"stt.kRevenue": "Intäkter (månad)",
"stt.noDeclYet": "Inga deklarationer ännu.",
"stt.recapDownloaded": "Sammanfattning nedladdad — redo att dela!",
"stt.recapError": "Kunde inte generera sammanfattningen",
"stt.recapText": "Vår Findloop {year} sammanfattning: objekt återlämnade och kundnöjdhet 🎉",
"stt.recapTitle": "Findloop {year} sammanfattning",
"stt.rejected": "Avvisad",
"stt.restitutions": "Återlämningar",
"stt.shareRecap": "Dela min {year} sammanfattning",
"stt.topCategories": "Mest angivna kategorier",
"stt.unclaimedDesc": "Volymen av föremål som förstörts, donerats till välgörenhet och auktionerats, per kategori.",
"stt.unclaimedTitle": "Oannonserade föremål — lämnar lagring",
"stt.vsLastWeek": "jämfört med förra veckan",
"sub.cancel": "Avbryt min prenumeration",
"sub.cancelAbort": "Avbryt",
"sub.cancelConfirm1": "Är du säker på att du vill avsluta? Din tillgång förblir aktiv till",
"sub.cancelConfirm2": "Ingen återbetalning kommer att utfärdas.",
"sub.cancelConfirmBtn": "Bekräfta avbokning",
"sub.cancelTitle": "Avbryt din prenumeration",
"sub.cancelledToast": "Avbokning registrerad.",
"sub.cguAnd": "och",
"sub.cguDesc": "Var god bekräfta ditt samtycke innan betalning.",
"sub.cguLink": "Användarvillkor",
"sub.cguPay": "Fortsätt till betalning",
"sub.cguPre": "Jag har läst och accepterar",
"sub.cguRequired": "Du måste acceptera Användarvillkoren och Integritetspolicyn för att fortsätta.",
"sub.cguSuffix": "från findloop.",
"sub.cguTitle": "Slutför din prenumeration",
"sub.expiresOn": "Din prenumeration löper ut den",
"sub.noProrata": "Ingen pro-rata återbetalning.",
"sub.privacyLink": "Integritetspolicy",
"sub.renewsOn": "Din prenumeration förnyas den",
"sub.resume": "Återprenumerera",
"sub.resumedToast": "Återprenumeration bekräftad.",
"tier.free": "Freemium",
"tier.large": "Företag",
"tier.medium": "Business",
"tier.small": "Uppstart",
"tm.add": "Lägg till",
"tm.adminOpt": "Admin (fullständig vy)",
"tm.chooseEst": "Välj en anläggning",
"tm.chooseEstPh": "Välj en anläggning",
"tm.copyFail": "Kopiering misslyckades",
"tm.copyLink": "Kopiera länken",
"tm.copyOk": "Inbjudningslänk kopierad",
"tm.emailHint": "Ett inbjudningsmejl kommer att skickas för att skapa lösenordet.",
"tm.expiresOn": "löper ut den {date}",
"tm.forEmail": " för {email}",
"tm.forbidden": "Teamhantering är reserverad för kontoinnehavaren.",
"tm.inviteCreated": "Inbjudan skapad",
"tm.inviteDesc": "Ett inbjudningsmejl låter teammedlemmen skapa sitt lösenord.",
"tm.invitePending": "Väntande inbjudan",
"tm.inviteResent": "Inbjudan har skickats på nytt",
"tm.inviteSent": "Inbjudan skickad via mejl",
"tm.inviteTitle": "Bjud in en medlem",
"tm.invitedOn": "Bjuden den {date}",
"tm.linkExpired": "Länk har gått ut",
"tm.memberRemoved": "Medlem borttagen",
"tm.name": "Namn",
"tm.noMembers": "Inga teammedlemmar ännu.",
"tm.resendTitle": "Skicka inbjudan igen",
"tm.role": "Roll",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Ägare",
"tm.roleStaff": "Personal",
"tm.roleUpdated": "Roll uppdaterad",
"tm.sendInvite": "Skicka inbjudan",
"tm.sending": "Skickar…",
"tm.staffOpt": "Personal (ser endast sin anläggning)",
"trk.at": "Vid",
"trk.badge": "Spårning",
"trk.carrier": "Fraktbolag",
"trk.codeValidated": "Kod validerad av partnern",
"trk.dlProof": "Ladda ner mitt bevis på överlämning (PDF)",
"trk.emailLabel": "E-post (valfritt — för att se dina uppgifter)",
"trk.enterEmailCode": "Ange din e-post ovan för att visa din kravkod.",
"trk.idLabel": "Rapportnummer",
"trk.lostEmail": "Jag har inte längre tillgång till min e-post",
"trk.phonePh": "Ditt telefonnummer",
"trk.photoBefore": "Bild på varan innan frakt",
"trk.recoverBtn": "Återhämta min vara",
"trk.recoverHint": "Få din kravkod via SMS på ditt registrerade nummer.",
"trk.searching": "Söker…",
"trk.secureRest": "Säker överlämning",
"trk.send": "Skicka",
"trk.shipPending": "Frakt på väg att förberedas — spårningsnumret dyker upp här när det har skickats.",
"trk.shipTitle": "Fraktspårning",
"trk.showQr": "Visa denna QR till partnern för att validera överlämningen",
"trk.sigSaved": "Signatur sparad",
"trk.signFirst": "Vänligen signera innan du bekräftar.",
"trk.signProof": "Signera ditt bevis på överlämning",
"trk.signSubmit": "Bekräfta min signatur och generera PDF:en",
"trk.submit": "Spåra",
"trk.subtitle": "Ange ditt rapportnummer för att spåra framsteg.",
"trk.title": "Spåra min rapport",
"trk.trackShipment": "Spåra paket",
"trk.trackingNo": "Spårningsnummer",
"trk.yourCode": "Din kravkod (att ge till partnern)",
"a.firstName": "Förnamn",
"ac.emailCrossMatch": "B2C korsmatchningar",
"ac.emailCrossMatchDesc": "Ett e-postmeddelande när en offentlig annons om hittade föremål matchar ett föremål som lagts in hos dig",
"ac.emailCrossReject": "Offentliga matchningsavvisningar",
"ac.emailCrossRejectDesc": "Ta emot ett e-postmeddelande när en kund anger att en föreslagen offentlig match inte är deras föremål.",
"ac.emailLoginNotif": "Inloggningsmeddelande",
"ac.emailLoginNotifDesc": "Ta emot ett e-postmeddelande varje gång någon loggar in på ditt konto.",
"ad.closeNoCancel": "Nej, ta bort annonsen",
"ad.closeQuestion": "Blev föremålet återlämnat till dig?",
"ad.closeQuestionDesc": "Låt oss veta om du återfick ditt föremål, eller om du bara vill ta bort denna annons.",
"ad.closeYesRestituted": "Ja, föremålet återlämnades",
"ad.closedRestituted": "Föremål återlämnat — annons stängd 🎉",
"an.lostLoginDesc": "Ett konto krävs för att rapportera ett hittat föremål och följa dess återlämnande.",
"an.lostLoginRequired": "Logga in för att rapportera ett hittat föremål",
"an.qfAll": "Alla",
"an.qfBoosted": "Boostade",
"an.qfPhoto": "Med foto",
"an.qfRecent": "Denna vecka",
"an.qfResolved": "Löst",
"an.restitutionInProgress": "Föremål återlämnas",
"dec.descPhLong": "Beskriv föremålet: märke, färg, särskiljande kännetecken… (Ju fler detaljer du ger, desto högre är dina chanser att återfå ditt föremål)",
"dec.loadError": "Det går inte att ladda partnern just nu. Kontrollera din uppkoppling och försök igen.",
"dec.retry": "Försök igen",
"dec.shippingMode": "Frakt",
"dep.photo2": "2:a föremålsfoto",
"dep.photo2Hint": "Valfritt — en annan vinkel förbättrar den visuella matchningsnoggrannheten.",
"dl.accountSuspended": "Kontot suspenderat på grund av en obetald faktura. Betala den för att återfå din åtkomst.",
"dl.regularize": "Betala nu →",
"dl.suspensionCountdown": "Faktura {num} obetald — ditt konto kommer att stängas av om {days} dag(ar). Betala den för att undvika detta.",
"ft.cancelConfirm": "Vill du avbryta din rapport? Föremålets ägare kommer att informeras.",
"ft.cancelDone": "Rapport avbruten.",
"ft.cancelLocked": "Avbokning är inte längre möjlig efter att ägaren har betalat.",
"ft.cancelReport": "Avbryt min rapport",
"ft.claimCodeHelp": "Ge denna kod till fyndaren vid överlämnandet för att bekräfta att du fick ditt föremål.",
"ft.claimCodeTitle": "Din restitutionskod",
"ft.claimDone": "Föremål återlämnat. Tack för att du använde Findloop!",
"ft.claimUnlockHint": "Lås upp fyndarens kontaktinformation",
"ft.claimUnlockHintSub": "Gå till \"Föremål jag gör anspråk på\" i ditt konto för att betala avgiften och få kontaktinformationen.",
"ft.finderCodeShownHelp": "Ägaren har betalat och valt dig. Kopiera denna kod nedan för att bekräfta återlämnandet — ingen anledning att kolla din e-post.",
"ft.finderCodeShownTitle": "Ägarens valideringskod",
"ft.finderContactsTitle": "Finders kontaktuppgifter",
"ft.foundCodeHelp": "Visa denna kod för ägaren vid överlämning för att bekräfta att objektet har returnerats.",
"ft.inProgressOther": "Objekt som återlämnas",
"ft.inProgressOtherHelp": "Ägaren valde en annan finder för detta objekt. Ingen ytterligare åtgärd krävs från din sida.",
"ft.restitutionCodeHelp": "Denna kod bekräftar överlämningen av objektet. Den är redan förifylld nedan; validera den och stäng ärendet.",
"ft.restitutionCodeTitle": "Din restitutionskod",
"hc.14Digits": "14 siffror",
"hc.15DaysBeforeAnItem": "15 dagar innan ett objekts lagliga tidsgräns.",
"hc.7DaysBeforeAnItem": "7 dagar innan ett objekts lagliga tidsgräns.",
"hc.8CharactersMinimum": "Minst 8 tecken.",
"hc.aClaimToValidate": "Ett krav att validera",
"hc.aFindoAssistanceSessionIs": "En Findloop hjälpsession är för närvarande aktiv på ditt konto.",
"hc.aNewMatchHasBeen": "En ny match har hittats",
"hc.aUser": "En användare",
"hc.aUserClaimsToBe": "En användare påstår sig vara ägaren. Kontrollera deras svar innan du autoriserar returen.",
"hc.aboutFindo": "Om Findloop",
"hc.accountActivatedPleaseLogIn": "Kontot aktiverat, vänligen logga in.",
"hc.accountActivation": "Kontots aktivering",
"hc.accountCreated": "Konto skapat!",
"hc.accountDeactivatedAReactivationEmail": "Kontot avaktiverat. Ett reaktiveringsmail (giltigt i 30 dagar) har skickats till dig.",
"hc.accountReactivation": "Kontoreaktivering",
"hc.activateMyAccount": "Aktivera mitt konto",
"hc.activateMyAdminAccount": "Aktivera mitt admin-konto",
"hc.activating": "Aktiverar…",
"hc.activeMatchCancelReason": "Aktiv match. Kundens avbokningsorsak: \"{reason}\". Objektet väntar fortfarande på ett krav.",
"hc.activeMatchWithAPublic": "Aktiv match med en offentlig (kund)listning. Väntar på ägarens krav.",
"hc.addAPhoto": "Lägg till ett foto",
"hc.addAndConfigureYourEstablishments": "Lägg till och konfigurera dina anläggningar i \"Anläggningar\": kontaktuppgifter, kategori och fysisk förvaring av objekt.",
"hc.addOnGoogle": "Lägg till på Google",
"hc.address": "Adress",
"hc.addressSaved": "Adress sparad",
"hc.addressStreet": "Adress — Gata",
"hc.adjustThePhoto": "Justera fotot",
"hc.adminFullView": "Admin (full vy)",
"hc.administratorOnly": "Endast administratör",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "AI visuell jämförelse",
"hc.all": "Alla",
"hc.amount": "Belopp",
"hc.anOrganization": "En organisation",
"hc.analyzing": "Analyserar…",
"hc.andRecoveryIs": "och återhämtningen är",
"hc.andTheDeclarationWillBe": "och deklarationen kommer att stängas (flyttas till historik). Denna åtgärd är slutgiltig.",
"hc.annual20": "Års -20%",
"hc.annualBilling20": "Årsfaktura (−20%)",
"hc.annualTarget": "Årligt mål",
"hc.anyCommentsOptional": "Eventuella kommentarer? (valfritt)",
"hc.approveTheClaim": "Godkänn kravet",
"hc.archiveCancelledConfirm": "Arkivera {n} lista(er) \"Avbruten av kunden\"? De kommer att tas bort från registret.",
"hc.asSoonAs": "Så snart som",
"hc.askTheOwnerToDisplay": "Be ägaren att visa sin kodes QR (spårningssida).",
"hc.askThemAtTheCounter": "Fråga dem vid disken för att bekräfta identitet — aldrig offentligt synligt.",
"hc.assistance": "Support",
"hc.assistanceSessionRevoked": "Assistanssession avbruten.",
"hc.atLeast6Characters": "Minst 6 tecken",
"hc.automaticallyPreSelected": "automatiskt förvalt",
"hc.automaticallyWhenShipping": "automatiskt vid frakt.",
"hc.awaitingClaim": "Inväntar krav",
"hc.awaitingPayment": "Inväntar betalning",
"hc.b2cCustomer": "B2C-kund",
"hc.back": "Tillbaka",
"hc.backToHome": "Tillbaka till startsidan",
"hc.backToMyAccount": "Tillbaka till mitt konto",
"hc.backToPayment": "Tillbaka till betalning",
"hc.beforeAfterComparisonSlider": "Före/efter jämförelse-slider",
"hc.billingInformation": "Faktureringsinformation",
"hc.billingInformationSaved": "Faktureringsinformation sparad ✓",
"hc.brand": "Märke",
"hc.bronze": "Brons",
"hc.calculatingTheShippingRate": "Beräknar fraktkostnaden…",
"hc.cameraUnavailableEnterTheCode": "Kamera otillgänglig. Skriv in koden manuellt.",
"hc.cancel": "Avbryt",
"hc.cancelMyDeclaration": "Avbryt min deklaration",
"hc.cancelSavedFmt": "Avbokning sparad: \"{reason}\". Du kan fortfarande göra anspråk.",
"hc.cancelTheDeposit": "Avbryt insättningen",
"hc.cancelThisMatch": "Avbryt denna match",
"hc.cancellationReason": "Avbokningsorsak",
"hc.cancelled": "Avbruten",
"hc.cancelledByTheCustomer": "Avbruten av kunden",
"hc.cannotOpenPayment": "Kan inte öppna betalningen. Vänligen försök igen.",
"hc.careers": "Karriärer",
"hc.carrier": "Fraktföretag",
"hc.carrierAvailabilityCannotBeChecked": "Fraktföretagets tillgänglighet kan inte kontrolleras förrän din Sendcloud-avsändare är konfigurerad.",
"hc.carrierConfirmedCharged": "Fraktföretaget bekräftat — {price} € debiterat kunden",
"hc.carrierOther": "Fraktföretag (annat)",
"hc.carrierSelection": "Val av fraktföretag",
"hc.caseClosedThankYou": "Ärendet är stängt. Tack!",
"hc.category": "Kategori",
"hc.changeMethod": "Ändra metod",
"hc.characteristic": "Egenskap",
"hc.chargedToCustomer": "debiterat kunden.",
"hc.checkOrEditYourDetails": "Kontrollera eller redigera dina uppgifter före den säkra betalningen.",
"hc.checkStatisticsToTrackDeposited": "Kontrollera \"Statistik\" för att spåra inskickade föremål, returgrad och prestation för varje enhet.",
"hc.checkTheDetailsBeforeContacting": "Kontrollera detaljerna innan du kontaktar findern.",
"hc.checkTheDetailsBelowBefore": "Kontrollera detaljerna nedan innan du påbörjar din returförfrågan.",
"hc.checkTheNewItem": "Kontrollera den nya varan",
"hc.checkThePhotosAndCharacteristics": "Kontrollera bilderna och egenskaperna nedan innan du fortsätter med hämtningen.",
"hc.chooseACountry": "Välj ett land",
"hc.chooseANewPassword": "Välj ett nytt lösenord",
"hc.chooseAReason": "Välj en anledning",
"hc.chooseTheLegalRetentionAlerts": "Välj de lagliga bevarandeaviseringarna som tas emot via e-post för",
"hc.chooseYourPasswordToAccess": "Välj ditt lösenord för att få tillgång till administrationskonsolen.",
"hc.city": "Stad",
"hc.claimApproved": "Krav godkänt",
"hc.claimApproved2": "Krav godkänt.",
"hc.claimCodeExpired": "Kravkod har gått ut",
"hc.claimCodeVerified": "Kravkod verifierad",
"hc.claimNotFound": "Krav hittades inte",
"hc.claimNotValidated": "Krav valdiderades inte",
"hc.claimRejected": "Krav avvisat",
"hc.claimRejected2": "Krav avvisat.",
"hc.claimValidated": "Krav validerat",
"hc.claimValidatedByThePartner": "Krav validerat av partnern",
"hc.claimant": "Kravställare",
"hc.claimsToBeTheOwner": "hävdar att vara ägaren av detta föremål och har svarat på verifieringsfrågorna. Godkänn endast om svaren stämmer.",
"hc.claimsToValidate": "Krav att validera",
"hc.clear": "Rensa",
"hc.clickToZoom": "Klicka för att zooma",
"hc.close": "Stäng",
"hc.close2": "Stäng",
"hc.closeTheDeclaration": "Stäng deklarationen",
"hc.closeTheDeclaration2": "Stäng deklarationen?",
"hc.codeAlreadyVerified": "Koden är redan verifierad",
"hc.codeCopied": "Koden kopierad",
"hc.collapse": "Kollapsa",
"hc.color": "Färg",
"hc.company": "Företag",
"hc.companyName": "Företagsnamn",
"hc.comparePhotos": "Jämför foton",
"hc.compareThemWithTheOwner": "Jämför dem med ägarens svar — aldrig offentligt synliga.",
"hc.condition": "Skick",
"hc.confirmAndPay": "Bekräfta och betala",
"hc.confirmCancellation": "Bekräfta avbokning",
"hc.confirmCrop": "Bekräfta beskärning",
"hc.confirmDeletion": "Bekräfta borttagning",
"hc.confirmPassword": "Bekräfta lösenord",
"hc.confirmThatThisIsYour": "Bekräfta att detta är din vara. En identitetskontroll kommer att begäras från fyndaren innan kontakt.",
"hc.confirmTheCarrier": "Bekräfta transportören",
"hc.confirmThePassword": "Bekräfta lösenordet",
"hc.confirmYourShippingAddressTo": "Bekräfta din leveransadress för att fortsätta med betalningen.",
"hc.confirmYourSubscription": "Bekräfta din prenumeration",
"hc.confirmed": "Bekräftad ✓",
"hc.contactFindoToGetYour": "Kontakta Findloop för att få ditt avsändar-ID.",
"hc.contactUs": "Kontakta oss",
"hc.continueTheReturn": "Fortsätt med returen",
"hc.continueToPayment": "Fortsätt till betalning",
"hc.copy": "Kopiera",
"hc.correctMyDetails": "rätta mina uppgifter",
"hc.correctThisEntry": "Rätta denna post?",
"hc.country": "Land",
"hc.countryAddress": "Land (adress)",
"hc.countryIsoCodeEG": "Land (ISO-kod, t.ex. FR)",
"hc.cover": "omslag",
"hc.createTheShipment": "Skapa frakten",
"hc.cropThePhoto": "Beskär fotot",
"hc.customer": "Kund",
"hc.customerClaimCodeToCheck": "Kundens kravkod — att kontrollera vid upphämtning:",
"hc.customerReasonFmt": "Kundens skäl: \"{reason}\".",
"hc.customerReminderDelay": "Kundens påminnelsefördröjning",
"hc.customerWhosePublicListingMatches": "Kund vars offentliga listning matchar denna vara — synlig endast för dig.",
"hc.d15": "D-15",
"hc.dangerZone": "Farlig zon",
"hc.date": "Datum",
"hc.dateNewest": "Datum (nyast)",
"hc.dateOldest": "Datum (äldst)",
"hc.daysToYearEnd": "{n} dagar till årets slut",
"hc.deadlineAlert": "Deadline-varning",
"hc.declarationClosed": "Deklaration stängd ✓",
"hc.declarationNotFound": "Deklaration hittades inte.",
"hc.declarationNotFound2": "Deklaration hittades inte",
"hc.declarationTracking": "Deklarationsspårning",
"hc.defaultCarrier": "Standardfraktföretag",
"hc.defaultCarrierPreselected": "Standardfraktföretag förvalt — kan ändras för denna försändelse. Aktuell taxa (Sendcloud + {m}% marginal).",
"hc.defaultCarrierRemoved": "Standardfraktföretag borttaget",
"hc.delayHours": "Försening (timmar)",
"hc.deleteMyAccount": "Ta bort mitt konto",
"hc.deleting": "Tar bort…",
"hc.deletingDeactivatesYourAccountLogin": "Att ta bort inaktiverar ditt konto: inloggning blockeras och data sparas i 30 dagar. Du kommer att få ett e-postmeddelande med en reaktiveringslänk som är giltig i 30 dagar.",
"hc.delivered": "Levererad",
"hc.depositAnItem": "Deposition av en artikel",
"hc.depositCancelledItemPutBack": "Deposition avbruten — artikel återställd till lagret.",
"hc.depositCancelledItemRemovedFrom": "Deposition avbruten — artikel borttagen från registret.",
"hc.depositedOn": "Deposition på",
"hc.describeTheItemBrandColor": "Beskriv artikeln: märke, färg, kännetecken… (Ju fler detaljer du ger, desto bättre chanser att hitta din artikel)",
"hc.dimensionsCm": "Dimensioner (cm)",
"hc.disablingAnEmail": "Inaktivera ett e-postmeddelande",
"hc.doesNotHide": "döljer inte",
"hc.download": "Ladda ner",
"hc.downloadThePdf": "Ladda ner PDF-filen",
"hc.draftRestoredPickUpYour": "Utkast återställt — hämta din deklaration där du slutade.",
"hc.dragToReposition": "Dra för att omplacera",
"hc.eGColisPriv": "T.ex. Colis Privé",
"hc.eachItemGetsAQr": "Varje artikel får en QR-etikett. Skanna den från \"Lager & QR\" för att snabbt lokalisera en artikel.",
"hc.eachSiteManagesItsOwn": "Varje webbplats hanterar sin egen bankverksamhet. Gå till",
"hc.edit": "Redigera",
"hc.emailNotificationPreferences": "Inställningar för e-postaviseringar",
"hc.emailPreferencesUpdated": "E-postinställningar uppdaterade",
"hc.enableOrDisableRecoveryFees": "Aktivera eller inaktivera återvinningsavgifter för",
"hc.enlargePhoto": "Förstora foto",
"hc.enterTheCustomerSCode": "Ange kundens kod",
"hc.estShipRate": "Beräknad fraktkostnad (Sendcloud + {m}% marginal):",
"hc.establishment": "Etablering",
"hc.establishment2": "Etablering:",
"hc.establishmentInItsSendcloudAccount": "etablering i sitt Sendcloud-konto och ger dig avsändar-ID",
"hc.establishmentSettings": "Inställningar för etablering",
"hc.exCode": "t.ex. ABCD2345",
"hc.exId": "t.ex. 3f2a…",
"hc.exit": "Avsluta",
"hc.explainWhyThisItemIs": "Förklara varför den här artikeln inte är din…",
"hc.externalPaymentLinks": "Externa betalningslänkar",
"hc.failed": "Misslyckades",
"hc.feesEnabled": "Avgifter aktiverade",
"hc.field": ") fält.",
"hc.finderAcceptedCloseTheCase": "Finder accepterade — stäng ärendet när artikeln har överlämnats personligen.",
"hc.findoCityRanking": "Findloop — Stadsranking",
"hc.findoForEstablishments": "Findloop för etableringar",
"hc.findoPresentationVideo": "Findloop presentationsvideo",
"hc.findoRegistersTheAddressOf": "Findloop registrerar adressen till din",
"hc.findoReviewShare": "Findloop {year} recension: {n} artiklar returnerade, {rate}% returgrad 🎉",
"hc.firstVerifyTheClaimCode": "Verifiera först kravkoden ovan",
"hc.forEveryNewShipmentFrom": "för varje ny försändelse från",
"hc.free": "gratis",
"hc.freeRecovery0": "Kostnadsfri återvinning (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Kostnadsfri återvinning över hela Afrika – Lanseringserbjudande",
"hc.freeRecoveryFeesDisabled0": "Kostnadsfri återvinning: avgifter inaktiverade (0 €)",
"hc.fromTeamInviteYourColleagues": "Från \"Team\", bjud in dina kollegor via e-post och tilldela dem en etablering. Varje medlem ser endast sitt eget omfattning.",
"hc.fullName": "Fullständigt namn",
"hc.fullPhoto": "Fullständig foto",
"hc.gallery": "Galleri",
"hc.giveTheReasonForCancelling": "Ge anledningen till avbokning. Partnern kommer att informeras.",
"hc.goToLogin": "Gå till inloggning",
"hc.goToMyAccount": "Gå till mitt konto",
"hc.gold": "Guld",
"hc.googleLoginFailed": "Google-inloggning misslyckades",
"hc.hasConfirmedYourPaymentYou": "har bekräftat din betalning, du kommer att omdirigeras automatiskt",
"hc.helpCenter": "Hjälpcenter",
"hc.helpUsImproveWhyAre": "Hjälp oss att förbättra: varför lämnar du? Ditt konto kommer att inaktiveras och kan återaktiveras inom 30 dagar.",
"hc.hidePassword": "Dölj lösenord",
"hc.high": "Hög",
"hc.historyOfYourMonthlySubscriptions": "Historik över dina månatliga prenumerationer och deras betalningsstatus.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Hur ställer jag in mitt numeriska avsändar-ID?",
"hc.iDonTUseIt": "Jag använder det inte tillräckligt",
"hc.iFoundItElsewhere": "Jag hittade det någon annanstans",
"hc.iNoLongerNeedMy": "Jag behöver inte min vara längre",
"hc.identityVerification": "Identitetsverifiering",
"hc.idleLogoutIn": "Du blir utloggad om {n} s på grund av inaktivitet.",
"hc.ifProvidedTheVolumetricWeight": "Om det anges, används den volymetriska vikten.",
"hc.ifThePartnerHasNot": "Om partnern inte har bekräftat mottagandet av den externa betalningen efter denna tidsfrist, påminner Findloop automatiskt partnern att validera den.",
"hc.impersonationEnded": "Identitetsstölden avslutad.",
"hc.impersonationMode": "Identitetsstölderläge",
"hc.impersonationSessionExpired": "Identitetsstöldsessionen har gått ut.",
"hc.inTheField": ", i fältet",
"hc.inTransit": "Under transport",
"hc.inclVat": "inkl. moms",
"hc.intraEuVatNumberOptional": "Intra-EU-momsnummer valfritt, inget SIRET krävs (utanför Frankrike).",
"hc.invalidInvitationLink": "Ogiltig inbjudningslänk.",
"hc.invalidInvitationLink2": "Ogiltig inbjudningslänk",
"hc.invalidInviteLink": "Ogiltig eller utgången inbjudningslänk.",
"hc.invalidNumberEnterAnInternational": "Ogiltigt nummer. Ange ett internationellt nummer, t.ex. +46 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Ogiltig eller utgången länk.",
"hc.invalidOrExpiredReactivationLink": "Ogiltig eller utgången reaktiveringslänk",
"hc.invalidSendcloudId": "Ogiltig Sendcloud ID",
"hc.inviteSubtitle": "{org} bjuder in dig att gå med i sitt findloop-team. Välj ditt lösenord för att aktivera ditt konto.",
"hc.isAvailableOnSendcloudFor": "är tillgänglig på Sendcloud för alla dina rutter (inrikes + internationellt).",
"hc.isNotEnabledOnYour": "är inte aktiverat på ditt Sendcloud-konto för vissa destinationer. Etiketter för dessa kommer att genereras med en annan tillgänglig transportör.",
"hc.isThisReallyYourItem": "Är detta verkligen din vara?",
"hc.isThisYourItem": "Är detta din vara?",
"hc.item": "Vara",
"hc.itemAlreadyConfirmed": "Vara redan bekräftad",
"hc.itemDetails": "Vardetaljer",
"hc.itemFoundAt": "Vara hittad på",
"hc.itemFoundAtAPartner": "Vara hittad hos en partner",
"hc.itemMarkedAsReturned": "Vara markerad som returnerad ✓",
"hc.itemPhotoRequiredBeforeShipping": "Vara foto (krävs innan frakt)",
"hc.itemPhotoSaved": "Vara foto sparad",
"hc.itemPreview": "Vara förhandsvisning",
"hc.itemPutBackInStorage": "Vara lagd tillbaka i lagret.",
"hc.itemWeight": "Vara vikt:",
"hc.itemsReturned": "vara(r) returnerade",
"hc.itemsReturnedThisYear": "objekt returnerade i år",
"hc.itemsWhoseLegalDeadlineIs": "Objekt vars juridiska deadline är 15 dagar bort eller mindre (överskridna inkluderade). Matcher förblir synliga.",
"hc.kbisNumber": "Kbis-nummer",
"hc.keysForgottenOnABench": "Nycklar glömda på en bänk",
"hc.labelBeingGenerated": "Etikett som skapas",
"hc.leaveTheFieldsEmptyTo": "Lämna fälten tomma för att erbjuda återvinning gratis.",
"hc.legalNotice": "Juridisk information",
"hc.limitReachedUpgradeToA": "Gräns nådd — uppgradera till en högre plan",
"hc.linkCopiedShareOn": "Länk kopierad — dela den på {label}",
"hc.linkUnavailable": "Länk otillgänglig",
"hc.linkedTo": "Länkad till",
"hc.listingHiddenByModeration": "Annons dold av moderering.",
"hc.loading": "Laddar…",
"hc.locateMe": "Lokalisera mig",
"hc.logIn": "Logga in",
"hc.logInToGetBack": "Logga in för att komma tillbaka till ditt utrymme och hantera din prenumeration.",
"hc.loginFailed": "Inloggning misslyckades",
"hc.lostFoundPlatform": "Förlorat & funnet plattform.",
"hc.lostIn": "förlorad i",
"hc.lowRate": "Låg avgift",
"hc.mainReason": "Huvudorsak",
"hc.mainStreet": "Huvudgatan",
"hc.makeSureThisIsThe": "Se till att detta är objektet du förlorade innan du låser upp kontaktuppgifterna till den som hittade det.",
"hc.manageCookies": "Hantera cookies",
"hc.manageMyTeam": "Hantera mitt team",
"hc.manageYourTeam": "Hantera ditt team",
"hc.markAsReturned": "Markera som returnerad",
"hc.matchNoClaimInTime": "Matchen fick ingen krav inom tidsramen.",
"hc.matchNotFound": "Match hittades inte",
"hc.medium": "Medium",
"hc.milestoneFmt": "{m} returnerade objekt milstolpe nådd! På väg till {next}.",
"hc.missingFeatures": "Saknade funktioner",
"hc.monthly": "Månatlig",
"hc.monthlyBilling": "Månatlig fakturering",
"hc.moveThePhotoToFit": "Flytta fotot för att passa in i cirkeln.",
"hc.myAccount": "Mitt konto",
"hc.myInvoices": "Mina fakturor",
"hc.myMonthlyInvoices": "Mina månatliga fakturor",
"hc.nArchived": "{n} lista(-or) arkiverade.",
"hc.newCodeGeneratedAndSent": "Ny kod genererad och skickad till kunden via e-post och SMS",
"hc.newCodeGeneratedAndSent2": "Ny kod genererad och skickad till ägaren",
"hc.newPassword": "Nytt lösenord",
"hc.next": "Nästa",
"hc.nextPhoto": "Nästa foto",
"hc.no": "Nej",
"hc.noAnswerProvided": "Inget svar angivet.",
"hc.noArchivedDeclarations": "Inga arkiverade deklarationer",
"hc.noCountryFound": "Inget land hittades",
"hc.noDeclarations": "Inga deklarationer",
"hc.noFeesAreChargedTo": "Inga avgifter debiteras kunden.",
"hc.noInvoiceYet": "Ingen faktura ännu.",
"hc.noInvoiceYetYourInvoices": "Ingen faktura ännu. Dina fakturor kommer att visas här automatiskt efter varje betalning.",
"hc.noMatchIsAvailableFor": "Inga matchningar är tillgängliga just nu. Vi meddelar dig så snart en post matchar din deklaration.",
"hc.noShipmentMatchesYourSearch": "Ingen försändelse matchar din sökning.",
"hc.noShipmentsYet": "Inga försändelser ännu.",
"hc.noShipmentsYet2": "Inga försändelser ännu",
"hc.none": "ingen",
"hc.noneChooseForEachShipment": "Ingen (välj för varje försändelse)",
"hc.notMine": "Det är inte mitt",
"hc.of": "av",
"hc.only": "Endast",
"hc.onlyEachSiteManagesIts": "endast. Varje webbplats hanterar sin egen bankverksamhet: dessa länkar påverkar inga andra företag.",
"hc.onlyTheOwnerOrAn": "Endast ägaren eller en administratör kan konfigurera etableringens betalningslänkar.",
"hc.openDepositInTheMenu": "Öppna \"Insättning\" i menyn, beskriv objektet och ta ett foto. Det lagras omedelbart och är redo att returneras.",
"hc.openSettings": "Öppna Inställningar →",
"hc.openTheDeclarationToManage": "Öppna deklarationen för att hantera försändelsen",
"hc.optional": "— valfritt",
"hc.optional2": "(valfritt)",
"hc.optional3": "valfritt",
"hc.originalListingPhotoUsed": "Originalbild av listan använd",
"hc.other": "Annat",
"hc.other2": "Annat…",
"hc.ourProducts": "Våra produkter",
"hc.overallRateTrendLast6": "Övergripande pristrend (de senaste 6 månaderna)",
"hc.ownerSClaimCode": "Ägarens anspråkskod",
"hc.ownershipConfirmed": "Ägarskap bekräftat",
"hc.paid": "Betald",
"hc.paidOn": "Betald den",
"hc.paidViaPartner": "Betald (via partner)",
"hc.parcelBeingPrepared": "Paket som förbereds",
"hc.parcelDelivered": "Paket levererat",
"hc.parcelShipped": "Paket skickat",
"hc.parisGareDeLyon": "Paris, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Partnerkatalog",
"hc.passedOnToTheCustomer": "— vidarebefordrad till kunden betalningslänk.",
"hc.password": "Lösenord",
"hc.passwordResetPleaseLogIn": "Lösenord återställt, vänligen logga in.",
"hc.passwordUpdated": "Lösenord uppdaterat.",
"hc.passwordsDoNotMatch": "Lösenorden matchar inte.",
"hc.pasteThisSenderIdIn": "Klistra in detta avsändar-ID i Findloop → Inställningar",
"hc.payForTheShipmentOf": "Betala för frakten av din vara genom Findloop med en säker betalning.",
"hc.payTheRecoveryFees": "Betala återvinningsavgifterna",
"hc.payTheShippingFees": "Betala fraktkostnaderna",
"hc.payment": "Betalning",
"hc.paymentAlreadyConfirmedByThe": "Betalning redan bekräftad av partnern",
"hc.paymentLinksAreNowConfigured": "Betalningslänkar är nu konfigurerade per etablering",
"hc.paymentNotCompletedYourAccount": "Betalning ej genomförd, ditt konto har inte skapats — vänligen försök igen.",
"hc.paymentReceived": "Betalning mottagen",
"hc.paymentSuccessful": "Betalning lyckades!",
"hc.pdfInvoice": "PDF-faktura",
"hc.pending": "Avvaktande",
"hc.period": "Period",
"hc.phoneNumber": "Telefonnummer",
"hc.phoneOptional": "Telefon (valfritt)",
"hc.planAt": "planera på",
"hc.planLimitFmt": "Din \"{plan}\" plan är begränsad till {max} etableringar. För att hantera {n} platser rekommenderar vi",
"hc.platformReturnTarget": "Plattformsreturmål",
"hc.pleaseCompleteYourShippingAddress": "Vänligen slutför din leveransadress.",
"hc.pleaseProvideAPhoneNumber": "Vänligen ange ett telefonnummer: det krävs av transportören för frakt.",
"hc.pleaseProvideAReason": "Vänligen ange ett skäl.",
"hc.pleaseSetYourOwnPassword": "vänligen ställ in ditt eget lösenord innan du fortsätter.",
"hc.pointsToGoal": "{n} fler poäng för att nå vårt gemensamma mål.",
"hc.posterPreview": "Affischförhandsvisning",
"hc.potentialMatchBeingVerified": "Potentiell match som verifieras",
"hc.potentialOwner": "Potentiell ägare",
"hc.preFilledAutomaticallyYouCan": "Förifyllt automatiskt — du kan byta ut det mot en bild av paketet.",
"hc.pressKit": "Presskit",
"hc.previewMode": "Förhandsgranskningsläge:",
"hc.previewOfThePrintReady": "Förhandsgranskning av den tryckklara A4-affischen för denna anläggning.",
"hc.previous": "Föregående",
"hc.previousPhoto": "Föregående foto",
"hc.primary": "primär",
"hc.printThePoster": "Skriv ut affischen",
"hc.privacy": "Integritet",
"hc.privacyPolicy": "Integritetspolicy",
"hc.processedCasesWillAppearHere": "Behandlade ärenden kommer att visas här.",
"hc.proofOfReturnPdf": "Bevis på återkomst (PDF)",
"hc.protectedByRecaptcha": "Skyddad av reCAPTCHA",
"hc.publicMatch": "Offentligt match",
"hc.putBackInStorage": "Lägg tillbaka i förvaring",
"hc.pwdResetByTeam": "Ditt lösenord har återställts av vårt team. För din säkerhet,",
"hc.questionsToAskTheOwner": "Frågor att ställa till ägaren",
"hc.rateChargedToTheCustomer": "Avgift som debiteras kunden:",
"hc.rateOfTarget": "{rate}% uppnått av ett {target}% mål",
"hc.reached": "uppnått",
"hc.reactivating": "Reaktiverar…",
"hc.reasonSavedYouCanStill": "Orsaken är sparad. Du kan fortfarande göra anspråk på din sak.",
"hc.recentMatchesFirst": "Senaste matcherna först",
"hc.recognizedThePhotoYouSent": "erkände fotot du skickade och beskrev dessa egenskaper. Bekräfta endast om de stämmer överens med den sak du har.",
"hc.recommended": "Rekommenderad",
"hc.recoveryFees": "Återvinningsavgifter",
"hc.recoveryFeesArePaidDirectly": "Återvinningsavgifter betalas direkt till den partneranläggning. Findloop får ingen betalning från kunder.",
"hc.recoveryFeesEnabled": "Återvinningsavgifter aktiverade",
"hc.recoveryOfferedByTheEstablishment": "Återvinning erbjuden av anläggningen — Findloop tar inga avgifter.",
"hc.recoveryPaymentLink": "Länk för återvinningsbetalning",
"hc.recoveryPaymentLinkSavedFor": "Länk för återvinningsbetalning sparad för denna anläggning",
"hc.redirecting": "Omdirigerar…",
"hc.redirectingToPayment": "Omdirigerar till betalning…",
"hc.redirectingToTheRecoveryOf": "Omdirigerar till återvinning av din sak…",
"hc.regenerateAndResendToThe": "Regenerera och skicka igen till ägaren",
"hc.regenerateTheCode": "Regenerera koden",
"hc.registerAFoundItem": "Registrera en hittad sak",
"hc.rejectTheClaim": "Avvisa kravet",
"hc.reminderDelaySaved": "Påminnelsefördröjning sparad",
"hc.reopenThePaymentLink": "Öppna betalningslänken igen",
"hc.repeatThePassword": "Upprepa lösenordet",
"hc.reportAProblem": "Rapportera ett problem",
"hc.reportDismissedYourListingRemains": "Rapport avvisad. Din annons förblir offentlig.",
"hc.requiredUsedToCalculateThe": "Obligatorisk: används för att beräkna fraktavgiften via Sendcloud. Frakt otillgänglig över 30 kg.",
"hc.reset": "Återställ",
"hc.resume": "Fortsätt",
"hc.resumeRegistration": "Fortsätt registrering",
"hc.retro": "Året i översyn",
"hc.returnSecurity": "Retur säkerhet",
"hc.returnToTheOwner": "Återlämna till ägaren",
"hc.returned": "återlämnad",
"hc.reviewTheItemDetails": "Granska artikeluppgifterna",
"hc.revokeAccess": "Återkalla åtkomst",
"hc.role": "Roll:",
"hc.save": "Spara",
"hc.save2": "spara",
"hc.saveAndContinue": "Spara och fortsätt",
"hc.saving": "Sparar…",
"hc.scanTheClaimCode": "Skanna kravkoden",
"hc.scanTheOwnerSQr": "Skanna ägarens QR",
"hc.scrollThroughLanguages": "Bläddra genom språk",
"hc.searchByCustomerItemOr": "Sök efter kund, artikel eller spårningsnummer…",
"hc.searchForACountry": "Sök efter ett land…",
"hc.secureFindoVerification": "Säker findloop-verifiering",
"hc.seeRetro": "Se året i översyn",
"hc.selectedCarrier": "Vald transportör:",
"hc.selectedPlan": "Vald plan",
"hc.send": "Skicka",
"hc.sendcloudSenderIdSaved": "Sendcloud avsändar-ID sparat",
"hc.sendcloudSenderIdSenderId": "Sendcloud avsändar-ID (sender_id)",
"hc.sending": "Skickar…",
"hc.sessionExpired": "Sessionen har gått ut",
"hc.setUpYourEstablishments": "Ställ in dina anläggningar",
"hc.settings": "Inställningar",
"hc.settingsSubtitle": "Externa betalningar och påminnelser, konfigurerade per anläggning.",
"hc.shareFoundText": "Jag hittade en artikel — hjälp mig att hitta dess ägare på Findloop",
"hc.shareLostText": "Jag tappade en artikel — hjälp mig att hitta den på Findloop",
"hc.sharePreview": "Dela förhandsgranskning",
"hc.shareTheRanking": "Dela rankingen",
"hc.shareYourQrCodeTo": "Dela din QR-kod för att ta emot deklarationer.",
"hc.shipRateAutoWeight": "Fraktavgiften beräknas automatiskt via Sendcloud (vikt {w}) vid tidpunkten för frakt.",
"hc.shipRateForWeight": "Fraktkostnad (Sendcloud + {m}% marginal) för {w}:",
"hc.shipments": "Sändningar",
"hc.shipmentsSubtitle": "Konsoliderad vy av alla etableringens sändningar, över alla ärenden. Klicka på en rad för att hantera sändningen i dess deklaration.",
"hc.shipping": "Frakt",
"hc.shippingAddress": "Fraktadress",
"hc.shippingFeesAreHandledAutomatically": "Fraktavgifter hanteras automatiskt av Findloop (Sendcloud) — ingen länk att ange.",
"hc.shippingFeesHaveAlreadyBeen": "Fraktavgifter har redan betalats: transportören kan inte längre ändras.",
"hc.shippingNotAvailableForItems": "Frakt inte tillgängligt för varor över 30 kg. Kunden måste hämta varan personligen.",
"hc.shippingPaid": "Frakt betald ✓",
"hc.showOnlyItemsMatchingA": "Visa endast varor som matchar en offentlig (kund) notering",
"hc.showPassword": "Visa lösenord",
"hc.signInTheBoxAbove": "Logga in i rutan ovan",
"hc.signatureSaved": "Signatur sparad",
"hc.signedInWithGoogle": "Inloggad med Google",
"hc.signupFailed": "Registrering misslyckades",
"hc.silver": "Silver",
"hc.simulatedRatesInPreProduction": "(simulerade priser i förproduktion)",
"hc.siretAndVatNumberRequired": "SIRET och momsnummer krävs (Frankrike).",
"hc.skip": "Hoppa över",
"hc.smsSentIfAccount": "Om ett konto finns med detta nummer har ett SMS skickats till dig.",
"hc.sortItemsWithAPublic": "Sortera: varor med offentlig matchning (senaste först)",
"hc.specifyWhetherYouRecoveredYour": "Specificera om du återfick din vara eller helt enkelt vill ta bort denna notering.",
"hc.specifyYourReason": "Specificera din anledning",
"hc.specifyYourReason2": "Specificera din anledning…",
"hc.staff": "Personal",
"hc.status": "Status",
"hc.staySignedIn": "Förbli inloggad",
"hc.step": "Steg",
"hc.stillThere": "Är du fortfarande där?",
"hc.stopScrolling": "Sluta rulla",
"hc.storeFindWithQr": "Spara & hitta med QR",
"hc.streetName": "Gatunamn",
"hc.streetNo": "Gatunr.",
"hc.switchTo": "Byt till",
"hc.switchToDarkMode": "Byt till mörkt läge",
"hc.switchToLightMode": "Byt till ljust läge",
"hc.takeAPhoto": "Ta ett foto",
"hc.takeChangeThePhoto": "Ta / ändra fotot",
"hc.takenFromYourDeclaration": "tagen från din deklaration",
"hc.target": "Mål",
"hc.targetReached": "Mål nått",
"hc.targetReachedThankYouTo": "Mål nått — tack till hela findloop-gemenskapen!",
"hc.tellUsMore": "Berätta mer…",
"hc.tellUsWhyYouCancel": "Berätta varför du avbokar. Det hjälper partnern att behandla din begäran.",
"hc.tellUsWhyYourListing": "Berätta varför. Din annons förblir aktiv och du kan fortfarande göra anspråk på din artikel.",
"hc.termsAndConditions": "Villkor",
"hc.termsAndPolicies": "Villkor och policyer",
"hc.thankYouForYourFeedback": "Tack för din feedback",
"hc.theBannerDisplayedInThe": "banderet som visas i registret.",
"hc.theClaimantHasBeenInformed": "Sökanden har informerats. Artikeln förblir tillgänglig i den offentliga annonsen.",
"hc.theClaimantHasBeenNotified": "Sökanden har meddelats och kan nu gå vidare med returen.",
"hc.theCustomerPaysTheFees": "Kunden betalar avgifterna till företaget.",
"hc.theDayTheLegalRetention": "Den dag den lagliga kvarhållandetiden uppnås.",
"hc.theEstablishmentConsideredThatThis": "Företaget ansåg att den här artikeln inte tillhör dig.",
"hc.theEstablishmentIsReviewingYour": "Företaget granskar dina svar. Du kommer att bli informerad så snart din ansökan har validerats, då kan du betala återvinningsavgifterna.",
"hc.theFeesAreTooHigh": "Avgifterna är för höga",
"hc.theFinderConsideredThatThis": "Hittaren ansåg att den här artikeln inte tillhör dig.",
"hc.theFinderIsReviewingYour": "Hittaren granskar din ansökan. Du kommer att bli informerad så snart den har validerats.",
"hc.theItem": "Artikeln",
"hc.theItemWillBeRemoved": "Artikeln kommer att tas bort från registret (ingen ansökan pågår).",
"hc.theItemWillBeSet": "Artikeln kommer att återställas till \"i lager\" och den relaterade ansökan avbryts.",
"hc.theKbisNumberAndVat": "Kbis-nummer och momsregistreringsnummer krävs för Frankrike.",
"hc.theLabelIsGeneratedAutomatically": "Etiketten skapas automatiskt så snart kunden har betalat fraktavgifterna. Den kommer att gå att ladda ner här.",
"hc.theLinkMayHaveExpired": "Länken kan ha gått ut (giltig i 30 dagar). Kontakta findloop-support om det behövs.",
"hc.theOwnerDescribesTheirItem": "Ägaren beskriver sin artikel",
"hc.theOwnerReceivedItBy": "Ägaren fick den via e-post (eller SMS). Ange eller skanna den före överlåtelsen.",
"hc.thePartnerConsideredThatThis": "Partnern ansåg att den här artikeln inte tillhör dig. Artikeln förblir tillgänglig.",
"hc.thePartnerIsReviewingYour": "Partnern granskar dina svar. Du kommer att bli informerad så snart din ansökan har validerats.",
"hc.theShipmentIsCreatedAutomatically": "Frakten skapas automatiskt när kunden har bekräftat sin adress och betalat återvinningsavgifterna. Etiketten kommer då att skapas automatiskt efter fraktbetalningen och kan laddas ner här.",
"hc.theShippingRateWillBe": "Fraktavgiften kommer att beräknas automatiskt via Sendcloud vid tidpunkten för frakten (registrerad vikt).",
"hc.thisCarrierWillBe": "Denna transportör kommer att vara",
"hc.thisEstablishment": "detta företag",
"hc.thisFieldIsRequiredFor": "Detta fält krävs för automatisk etikettgenerering.",
"hc.thisIsMyItem": "Detta är min artikel",
"hc.thisIsMyItemContinue": "Detta är min artikel — fortsätt",
"hc.thisIsMyItemStart": "Detta är min artikel — starta returen",
"hc.thisIsNotMyItem": "Detta är inte min artikel",
"hc.thisMatchIsNoLonger": "Denna match är inte längre tillgänglig eller har redan behandlats.",
"hc.thisRateWillBeCharged": "Denna avgift kommer att debiteras kunden. En hög avgift kan avskräcka från återvinning.",
"hc.thisStepIsRequiredFor": "Detta steg krävs för att fraktetiketter ska kunna genereras.",
"hc.thisValidationLinkIsInvalid": "Denna valideringslänk är ogiltig eller har gått ut.",
"hc.toCheckBeforeMarkingThe": "Att kontrollera innan du markerar objektet som returned.",
"hc.toConfigureTheLinksAnd": "att konfigurera länkarna och påminnelsefördröjningen för varje anläggning.",
"hc.toReachOurFirstMilestone": "att nå vår första milstolpe med 100 returer.",
"hc.toTheCustomer": "till kunden.",
"hc.toTheShippingFeePayment": "till betalningen av fraktavgiften.",
"hc.toYourRecoveryTracking": "till din återhämtningsspårning.",
"hc.tooExpensiveBudget": "För dyrt / budget",
"hc.topCitiesForReturns": "Toppstäder för returer",
"hc.trackMyRecovery": "Spåra min återhämtning",
"hc.trackTheShipmentAndDownload": "Spåra leveransen och ladda ner etiketten (genereras automatiskt) utan att lämna fliken Deklarationer.",
"hc.trackYourStatistics": "Spåra dina statistik",
"hc.tracking": "Spårning",
"hc.unableToOpenTheShipping": "Kunde inte öppna betalningen av fraktavgiften. Försök igen.",
"hc.unableToRetrieveTheInvoice": "Kunde inte hämta fakturan.",
"hc.unclaimed": "Otidad",
"hc.unclaimedCustomerReason": "Otidad vara. Kundens orsak: \"{reason}\".",
"hc.unclaimedItem": "Otidad vara",
"hc.unclaimedItemNoClaimWithin": "Otidad vara — ingen begäran inom tidsfristen.",
"hc.unclaimedItems": "Otidade varor",
"hc.unclaimedItemsMatchLeftWithout": "Otidade varor: match kvar utan en begäran inom tidsfristen. Du kan lägga tillbaka dem i lagring.",
"hc.unlockTheFinderSContact": "Lås upp finnerens kontaktuppgifter för att ordna överlämningen.",
"hc.upcoming": "Kommande",
"hc.updateFailed": "Uppdatering misslyckades.",
"hc.usedForInvoices": "Använt för att utfärda dina findloop-fakturor.",
"hc.vatNumber": "Momsnummer",
"hc.verificationPending": "Verifikation pågår",
"hc.verificationSentToTheFinder": "Verifikation skickad till findern. Du kommer att informeras om deras beslut.",
"hc.verificationSentToThePartner": "Verifikation skickad till partnern. Du kommer att informeras om deras beslut.",
"hc.verify": "Verifiera",
"hc.verifyingInvite": "Verifierar inbjudningslänken…",
"hc.verifyingTheLink": "Verifierar länken…",
"hc.viewInRegistry": "Visa i registret",
"hc.viewItem": "Visa objekt",
"hc.viewItemRecover": "Visa objekt & återhämta",
"hc.visibleToTheOwnerAutomatically": "Synlig för ägaren · tas automatiskt bort efter 60 dagar.",
"hc.waitingForPartnerConfirmation": "Väntar på partnerbekräftelse",
"hc.waitingForThePartnerS": "Väntar på partnerns bekräftelse",
"hc.weHaveInformedTheEstablishment": "Vi har informerat anläggningen att detta objekt inte är ditt och återupptagit analysen. Du kommer att informeras så snart en ny match hittas.",
"hc.weHaveInformedThePartner": "Vi har informerat partnern att detta objekt inte är ditt. Din listning förblir aktiv för framtida matchningar.",
"hc.weRanTheAnalysisAgain": "Vi har kört analysen igen och identifierat en annan artikel som kan vara din. Vänligen kontrollera den igen.",
"hc.weight": "Vikt",
"hc.weightNotProvidedTheShipping": "Vikt ej angiven: fraktkostnaden kommer att beräknas vid tidpunkten för frakten.",
"hc.weightUnit": "Viktenhet",
"hc.welcome": "Välkommen!",
"hc.welcomeToFindo": "Välkommen till Findloop",
"hc.whenACustomerComesTo": "När en kund kommer för att hämta sina tillhörigheter, öppna deras deklaration och verifiera retur. Det är allt!",
"hc.whenDisabledFeesDropTo": ". När inaktiverat, sjunker avgifterna till",
"hc.whyIsThisNotYour": "Varför är detta inte din artikel?",
"hc.willBeMarkedAs": "kommer att markeras som",
"hc.wrongColor": "Fel färg",
"hc.wrongModel": "Fel modell",
"hc.yesCancel": "Ja, avbryt",
"hc.yesContactTheFinder": "Ja, kontakta den som hittade det",
"hc.youAreHere": "Du är här",
"hc.youBusinessCom": "du@företag.com",
"hc.youCanNowStartThe": "Du kan nu påbörja returen.",
"hc.youCanStillChangeIt": ". Du kan fortfarande ändra det fall för fall.",
"hc.youHaveAlreadyConfirmedThat": "Du har redan bekräftat att detta är din artikel.",
"hc.youWillBeRedirectedTo": "Du kommer att omdirigeras till den säkra Stripe betalningen.",
"hc.yourAccountHasBeenReactivated": "Ditt konto har återaktiverats.",
"hc.yourAccountIsActiveYou": "Ditt konto är aktivt, du kan nu hantera dina etableringar.",
"hc.yourEstablishment": "Din etablering",
"hc.yourFeedbackHelpsUsImprove": "Din feedback hjälper oss att förbättra våra matchningar.",
"hc.yourFeedbackHelpsUsRestart": "Din feedback hjälper oss att återstarta analysen och förbättra våra matchningar.",
"hc.yourFirstSteps": "Dina första steg",
"hc.yourFirstStepsAdmin": "Dina första steg (admin)",
"hc.yourItemHasBeenHanded": "Din artikel har överlämnats personligen av partnern – stäng ärendet när överlämningen är bekräftad.",
"hc.yourItemHasBeenShipped": "Din artikel har skickats av partnern – stäng ärendet när leverans är bekräftad.",
"hc.yourPaymentHasBeenRecorded": "Din betalning har registrerats.",
"hc.yourShipmentIsBeingPrepared": "Din försändelse håller på att förberedas. Du kommer att få ditt paket inom 3 till 5 arbetsdagar.",
"hc.yourShippingFeesHaveAlready": "Dina fraktkostnader har redan betalats. Frakt betald ✓",
"hc.yourShippingFeesHaveBeen": "Dina fraktkostnader har betalats. Ditt paket håller på att förberedas.",
"hc.yourVerificationQuestionsDeposit": "Dina verifieringsfrågor (insättning)",
"hero.einvoiceBadge": "2027-kompatibel e-fakturering",
"home.recentAdsAll": "Se alla annonser",
"home.recentAdsEyebrow": "Just nu",
"home.recentAdsSubtitle": "Förlorade och hittade föremål rapporterade av gemenskapen.",
"home.recentAdsTitle": "Senaste annonser",
"home.reunions": "Nyliga återföreningar",
"home.videoEyebrow": "Titta",
"home.videoSubtitle": "Hur vi återförenar förlorade föremål med sina ägare, utan ansträngning.",
"home.videoTitle": "Upptäck Findloop på 2 minuter",
"home.watchYoutube": "Titta på YouTube",
"impact.already": "Redan",
"impact.citiesWord": "stad/städer",
"impact.eachPoint": "Varje punkt är en stad där Findloop hjälper till att återfå förlorade föremål.",
"impact.emptyMap": "Kartan fylls på när återställningar sker.",
"impact.eyebrow": "V vår påverkan",
"impact.inCities": "över",
"impact.restitutedTo": "föremål återlämnade till sina ägare",
"impact.title": "Föremål återlämnade, överallt nära dig",
"inv2.download": "Ladda ner",
"inv2.view": "Visa",
"map.objectsOnMapPlural": "föremål på kartan",
"map.objectsOnMapSingular": "föremål på kartan",
"mc.claimConfirmDesc": "Kontrollera föremålet som hittades av hittaren innan du betalar för att låsa upp deras kontaktuppgifter.",
"mc.claimConfirmNo": "Detta är inte mitt föremål",
"mc.claimConfirmTitle": "Är detta verkligen ditt föremål?",
"mc.claimConfirmYes": "Ja, det är mitt — betala",
"mc.claimFinderContacts": "Hittarens kontaktuppgifter",
"mc.claimNotMineDone": "Tack — hittaren har blivit meddelad och din begäran har tagits bort från annonsen.",
"mc.claimUnlockDesc": "Betala findloop-administrationsavgiften för att få kontaktuppgifterna till den som hittade ditt föremål.",
"mc.claimUnlockTitle": "Lås upp hittarens kontaktuppgifter",
"mc.hideCountryOffers": "Dölj erbjudanden i mitt land",
"mc.myClaims": "Föremål jag gör anspråk på",
"mc.myClaimsSub": "Föremål som hittats av andra som du gör anspråk på. Lås upp hittarens kontaktuppgifter för att ordna överlämningen.",
"mc.notifAdCancelled": "Annons avbruten",
"mc.notifCancelAd": "Avbryt min annons",
"mc.offersInCountry": "Erbjudanden i mitt land",
"mc.offersInCountryDesc": "Alla aktiva belöningar från partners i ditt land, efter stad.",
"mc.redArchived": "Arkiverad",
"mc.rewardsCountryNone": "Inga erbjudanden i ditt land än.",
"mc.rewardsForYou": "Belöningar för dig",
"mc.rewardsForYouDesc": "Erbjuds av partnern/partnerna där du lämnade ett föremål.",
"mc.rewardsMineNone": "Ingen belöning från dina inlämningspartners än.",
"mc.showCountryOffers": "Se erbjudanden i mitt land",
"mc2.cancelDecl": "Avbryt min deklaration",
"mc2.cancelDeclDone": "Deklaration avbruten.",
"pricing.physInvDesc": "När ett föremål återlämnas frigörs dess plats automatiskt och blir tillgänglig för ett nytt föremål.",
"pricing.physInvTitle": "Fysisk inventariehantering",
"pricing.physModalTitle": "Fysisk hantering av objekt",
"pricing.physQrDesc": "En unik QR-kod genereras per objekt och kopplar till all dess information.",
"pricing.physQrTitle": "Dedikerad QR-etikett",
"pricing.physShelfDesc": "Varje registrerat objekt kan tilldelas en fysisk plats inom anläggningen.",
"pricing.physShelfTitle": "Hylla plan",
"pricing.physicalMgmt": "Fysisk hantering av objekt (hyllor, QR, inventarier)",
"pub.addSecondPhoto": "Lägg till en 2:a bild (valfritt)",
"pub.photo2Added": "✓ 2:a bild tillagd",
"reg.dispositionJournal": "Disposition journal",
"reg.dispositionNoteAuthHint": "ℹ️ En anteckning krävs för “Överlämnat till myndigheterna” (ärendenummer, avdelning…).",
"reg.dispositionNotePh": "Anteckning (valfritt): mottagande välgörenhet, referens till myndigheter, köparens namn…",
"reg.dispositionNoteRequired": "En officiell referens krävs för att överlämna till myndigheterna.",
"reg.legalPrealert": "Laglig tidsfrist om {days} dag(ar)",
"reg.legalPrealertOptions": "Alternativ vid tidsfrist: auktion, donation till välgörenhet, överlämnande till myndigheterna.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Full recension",
"rev.readMore": "Läs mer",
"rw.activeCodes": "Aktiva kuponger",
"rw.archived": "Arkiverad",
"rw.archivedTitle": "Inlösta kuponger (arkiverade)",
"rw.hideArchived": "Dölj inlösta kuponger",
"rw.noArchived": "Ingen arkiverad kupong.",
"rw.showArchived": "Visa inlösta kuponger",
"shp.labelAuto": "Etiketten genereras automatiskt så snart kunden har betalat fraktavgifterna. Den kommer att vara nedladdningsbar här.",
"st.cancelled_by_customer": "Avbokad",
"stt.dispoPdfBtn": "Exportera PDF",
"stt.dispoPdfError": "PDF-export misslyckades.",
"stt.dispoPdfExporting": "Exporterar…",
"trk.matchVerifying": "Potentiell match verifieras",
"hc.and": "och",
"hc.demoObj0": "en plånbok",
"hc.demoObj1": "en sportväska",
"hc.demoObj2": "en telefon",
"hc.demoObj3": "ett par glasögon",
"hc.demoObj4": "ett nyckelknippa",
"hc.demoObj5": "en scarf",
"hc.demoObj6": "en bärbar dator",
"hc.demoObj7": "en vattenflaska",
"hc.demoWhen0": "för 2 timmar sedan",
"hc.demoWhen1": "för 5 timmar sedan",
"hc.demoWhen2": "igår",
"hc.demoWhen3": "för 3 timmar sedan",
"hc.demoWhen4": "i morse",
"hc.demoWhen5": "för 1 dag sedan",
"hc.feedDemo": "{obj} returnerades i {city} {when}.",
"hc.feedReal": "En artikel ({cat}) returnerades i {city}.",
"hc.saveBtn": "Spara",
"hc.saveLink": "Spara länk",
"hc.terms": "Villkor",
"hc.view": "Visa",
"pcat.airline": "Flygbolag",
"pcat.airport": "Flygplats",
"pcat.amusement_park": "Tivoli",
"pcat.bank": "Bank",
"pcat.bar_cafe": "Bar / Café",
"pcat.beauty_salon": "Frisör / Skönhetssalong",
"pcat.cinema": "Biograf",
"pcat.concert_theater": "Konserthus / Teater",
"pcat.coworking": "Coworking-utrymme",
"pcat.gym_fitness": "Gym / Fitness",
"pcat.hospital_clinic": "Sjukhus / Klinik",
"pcat.library": "Bibliotek",
"pcat.mall": "Köpcentrum",
"pcat.museum": "Museum",
"pcat.pharmacy": "Apotek",
"pcat.private_company": "Privat företag",
"pcat.public_transport": "Kollektivtrafik",
"pcat.school_university": "Skola / Universitet",
"pcat.sports_center": "Idrottsanläggning",
"pcat.stadium_arena": "Stadium / Arena",
"pcat.supermarket": "Stormarknad",
"pcat.taxi_vtc": "Taxi / Samåkning",
"pcat.tourism_office": "Turistinformation",
"pcat.train_bus_station": "Tåg- / busstation",
"pcat.travel_agency": "Resebyrå",
"an.found": "Hittad",
"an.lost": "Förlorad",
"hc.shareReview": "Dela recensionen",
"hc.citiesAboveTarget": "{n} städer över deras mål",
"hc.cityAboveTarget": "{n} stad över sitt mål",
"hc.j15EarlyReminder": "D-15 tidig påminnelse",
"hc.j7EarlyReminder": "D-7 tidig påminnelse",
"hc.annualTotal": "Årlig total",
"hc.billedOnceYear": "Debiteras en gång för 12 månader, förnyas varje år.",
"hc.monthlyPrice": "Månatligt pris",
"hc.perMonth": "/ månad",
"hc.perYear": "/ år",
"hc.billedEachMonth": "Debiteras automatiskt varje månad.",
"nav.business": "Företag",
"nav.individual": "Individuell",
"hc.circumstancesFound": "Omgivningar för fyndet",
"hc.circumstancesFoundPh": "T.ex. hittad på marken nära metroingången",
"hc.circumstancesLost": "Omgivningar för förlusten",
"hc.circumstancesLostPh": "T.ex. kvarlämnad på en bänk medan jag väntade på bussen",
"hc.conditionPh": "T.ex. bra, repad…",
"hc.firstName": "Förnamn",
"hc.lastName": "Efternamn",
"hc.quantity": "Antal föremål",
"fa.approve": "Godkänna",
"fa.approveConfirm": "Godkänna denna deklaration? Ditt fullständiga kontaktinformation (namn, e-post, telefon) kommer att utbytas med fyndaren.",
"fa.approved": "Deklaration godkänd — kontaktuppgifter utbytta",
"fa.approvedFinder": "Ägaren har godkänt din deklaration",
"fa.approvedFinderText": "Kontakta dem för att ordna återlämningen.",
"fa.boostSub": "Din annons stannar på toppen under vald tid.",
"fa.boostTitle": "Öka min annons (valfritt)",
"fa.colFinder": "Fyndarens deklaration",
"fa.colYours": "Din deklaration",
"fa.compareHint": "Jämför fyndarens deklaration med din innan du bestämmer dig.",
"fa.contribNone": "Ingen bidrag",
"fa.contribPaid": "Bidrag mottaget — tack!",
"fa.contribPending": "Bidrag som väntar på betalning",
"fa.contribSub": "Stöd Findloop för att hjälpa fler människor få tillbaka sina tillhörigheter. Du kan välja €0.",
"fa.contribSuccessMsg": "Din deklaration har skickats till ägaren.",
"fa.contribSuccessTitle": "Tack för ditt bidrag",
"fa.contribTitle": "Voluntär bidrag",
"fa.days3": "3 dagar",
"fa.days30": "30 dagar",
"fa.days7": "7 dagar",
"fa.declSub": "Beskriv föremålet du hittat. Ägaren kommer att jämföra din deklaration med sin.",
"fa.declTitle": "Jag har hittat detta föremål",
"fa.expiresOn": "Utgår den",
"fa.fBrand": "Märke",
"fa.fCircumstances": "Omständigheter",
"fa.fCity": "Stad",
"fa.fColor": "Färg",
"fa.fCondition": "Skick",
"fa.fDate": "Datum",
"fa.fMessage": "Fyndarens meddelande",
"fa.fPlace": "Plats",
"fa.fQuantity": "Mängd",
"fa.finderContact": "Fyndarens kontaktuppgifter",
"fa.finishPay": "Slutför betalning",
"fa.foundDate": "Datum hittad",
"fa.foundPlace": "Plats hittad",
"fa.hours24": "24 timmar",
"fa.ht": "exkl. moms",
"fa.months3": "3 månader",
"fa.noBoost": "Ingen ökning",
"fa.ownerContact": "Ägarens kontaktuppgifter",
"fa.payPublish": "Betala och publicera",
"fa.pendingPayText": "Din annons kommer att bli live så snart betalningen har bekräftats.",
"fa.pendingPayTitle": "Betalning pågår",
"fa.planSub": "Din annons går live så snart betalningen har bekräftats.",
"fa.planTitle": "Annonsens varaktighet",
"fa.pubSuccessMsg": "Din annons är live. Du kommer att meddelas så snart en sökare träder fram.",
"fa.pubSuccessTitle": "Annons publicerad",
"fa.publicNote": "Endast beskrivningen, staden, landet och bilderna visas offentligt.",
"fa.redirectStripe": "Omdirigerar till säker betalning…",
"fa.reject": "Avvisa",
"fa.rejectConfirm": "Avvisa denna deklaration? Din annons förblir online.",
"fa.rejected": "Deklaration avvisad",
"fa.rejectedFinder": "Det var inte det föremål de letade efter",
"fa.rejectedFinderText": "Ägaren säger att detta föremål inte är deras. Tack för din hjälp!",
"fa.responsesTitle": "Sökares deklarationer",
"fa.sent": "Deklaration skickad till ägaren.",
"fa.submitDecl": "Skicka min deklaration",
"fa.submitDeclPay": "Skicka och bidra {amount}",
"fa.total": "Totalt att betala",
"fa.ttc": "inkl. moms",
"fa.waitClaimText": "Sökaren granskar din begäran. Du kommer att meddelas om deras beslut.",
"fa.waitFinderText": "Vi meddelar dig så snart en sökare skickar en deklaration.",
"fa.waitFinderTitle": "Din annons är live",
"fa.waitOwnerText": "Ägaren jämför din deklaration med deras. Du kommer att meddelas om deras beslut.",
"fa.waitOwnerTitle": "Väntar på ägarens beslut",
"st.pending_payment": "Betalning pågår",
"fa.africaFree": "Gratis annonsering i Afrika — Findloop lanseringserbjudande, njut av det!",
"fa.africaPublished": "Annons publicerad gratis — Afrika lanseringserbjudande!",
"fa.approveClaimConfirm": "Godkänna detta krav? Ägaren kan då låsa upp dina kontaktuppgifter.",
"fa.checkInfo": "Kontrollera dina uppgifter innan du skickar: de kommer att jämföras med finderns.",
"fa.claimApprovedShort": "Findern godkände ditt krav",
"fa.claimRejectedShort": "Krav avvisat av findern",
"fa.claimRejectedText": "Findern anser att föremålet inte är ditt.",
"fa.claimSub": "Beskriv ditt föremål och lägg till 2 foton. Findern kommer att jämföra dem med sin annons.",
"fa.claimTitle": "Detta är mitt föremål",
"fa.claimUnlockText": "Lås upp finderns kontaktuppgifter för att ordna återlämningen.",
"fa.claimUnlockedShort": "Kontaktuppgifter upplåsta — se spårning",
"fa.claimsTitle": "Ägarens krav",
"fa.colOwner": "Ägarens intygande",
"fa.colYourAd": "Din annons",
"fa.expired": "Annonseringens giltighet har gått ut",
"fa.free": "Gratis",
"fa.lostDate": "Datum för förlust",
"fa.lostPlace": "Plats för förlust",
"fa.noReceipt": "Ingen kvitto tillgänglig för denna annons.",
"fa.planSubFree": "Välj tidsperiod: din annons går live omedelbart, ingen betalning krävs.",
"fa.prefillPrevious": "Återanvänd detaljerna från min tidigare annons i denna kategori",
"fa.receipt": "PDF-kvitto",
"fa.renewBtn": "Förnya",
"fa.renewDiscountBanner": "50% rabatt: förnya innan din annons går ut!",
"fa.renewDiscountHint": "50% rabatt tillämpad eftersom du förnyar innan utgång.",
"fa.renewEarly": "Förnya (−50%)",
"fa.renewTitle": "Förnya min annons",
"fa.renewed": "Annons förnyad",
"fa.sendClaim": "Skicka mitt krav",
"fa.twoPhotos": "2 foton av ditt föremål",
"fa.twoPhotosError": "Lägg till 2 foton av ditt föremål.",
"fa.twoPhotosHint": "Personliga foton som bevisar att föremålet är ditt (med föremålet, faktura, låda…).",
"fa.unlockBtn": "Lås upp kontaktuppgifter",
"fa.unlockFree": "Lås upp gratis — lanseringserbjudande",
"fa.waitClaimantText": "Vi meddelar dig så snart en ägare gör anspråk på detta föremål.",
"fa.waitFinderDecision": "Väntar på finderns beslut",
"fa.waitUnlockText": "Du meddelas så snart kontaktuppgifter byts.",
"fa.waitUnlockTitle": "Väntar på att ägaren ska låsa upp",
"fa.cancel": "Avbryt",
"fa.categoryRequired": "Välj en kategori för den hittade artikeln.",
"fa.confirmTitle": "Bekräfta ditt beslut",
"fa.goBack": "Gå tillbaka",
"dr.continue": "Fortsätt min deklaration",
"dr.delete": "Ta bort permanent",
"dr.deleteConfirm": "Vill du permanent ta bort detta utkast? Detta kan inte ångras.",
"dr.deleted": "Utkast borttaget",
"dr.expiresIn": "Utkast behålls i {h} ytterligare timmar",
"dr.title": "Du har en ofullständig deklaration",
"form.step": "Steg",
"form.next": "Fortsätt",
"form.back": "Tillbaka",
"form.stepDetails": "Din rapport",
"form.stepPublish": "Varaktighet, boost & betalning",
"form.stepThanks": "Tack och bidrag",
"fthx.badge": "Rapporten nästan klar",
"fthx.title": "Tack, du gör skillnad!",
"fthx.text": "Tack vare dig kan någon snart få tillbaka något som betyder mycket för dem. Handlingar av vänlighet som din är precis vad som håller Findloop vid liv.",
"fthx.impact1": "1 objekt rapporterat",
"fthx.impact2": "1 chans mer till återförening",
"fthx.tipTitle": "Ett litet stöd för Findloop?",
"fthx.tipText": "Ditt bidrag hjälper oss att hålla tjänsten tillgänglig och återförena allt fler föremål med sina ägare.",
"fthx.optional": "100% valfritt — du kan publicera utan att bidra.",
"fthx.thanksTip": "Tack så mycket för din generositet!",
"fthx.suggest": "Föreslagna belopp",
"fthx.none": "Inget tips",
"pay.pendingTitle": "Betalning inte slutförd",
"pay.pendingText": "Dina uppgifter är sparade. Fortsätt med betalningen där du slutade.",
"pay.resume": "Fortsätt betalning",
"pay.expiredTitle": "Betalningssessionen har gått ut",
"pay.expiredText": "För din säkerhet har betalningssessionen gått ut. Dina uppgifter är sparade: starta om betalningen med ett klick.",
"pay.relaunch": "Starta om betalning",
"sub.received": "Skickat!",
"sub.publishing": "Vi avslutar …",
"sub.toPayment": "Omdirigerar till säker betalning …",
"fa.claimSubV2": "Beskriv din förlorade sak. Personen som hittade den kommer att jämföra din beskrivning med sin lista.",
"fa.photosOptional": "Bilder på din sak (valfritt)",
"fa.compareOwnerHint": "Jämför den här informationen med den sak du hittade, och säg sedan om det är samma sak.",
"fa.itsThisItem": "Ja, det här är saken",
"fa.notThisItem": "Nej, det här är inte saken",
"fa.confirmIsItem": "Bekräfta att detta är saken? Dina kontaktuppgifter och ägarens kommer att visas i era respektive konton.",
"fa.confirmNotItem": "Bekräfta att detta inte är saken? Din rapport kommer att stängas.",
"fa.youConfirmed": "Du bekräftade att detta är ägarens sak",
"fa.youDeclined": "Du angav att detta inte var saken",
"fa.youDeclinedText": "Tack för din hjälp! Ägaren har informerats.",
"fa.waitFinderDecisionOwner": "Väntar på finderens beslut",
"fa.finderConfirmed": "Bekräftad",
"fa.notYourItem": "Detta var inte din sak",
"fa.reportedOn": "Rapporterad den",
"fa.ownerWaitHint": "En upphittare kontrollerar för närvarande informationen, vänligen vänta.",
"fa.claimSentFinder": "Ansökan skickad till personen som hittade föremålet.",
"fa.compareClaimHint": "Jämför ägarens deklaration med din annons innan du fattar beslut.",
"fa.closeFollowup": "Stäng detta uppföljning",
"fa.closeFollowupConfirm": "Vill du stänga denna uppföljning? Båda parters e-postadresser och telefonnummer kommer att raderas permanent när ägaren även har stängt sin annons.",
"fa.safetyTitle": "Säkerhetstips innan överlämnandet",
"fa.safety1": "Fråga ägaren om en detaljerad beskrivning av dolda funktioner på objektet: en specifik repa, det exakta innehållet i en väska, tapeten, serienumret…",
"fa.safety2": "Om möjligt, be om visuellt bevis (ett foto av objektet) eller köpbevis.",
"fa.safety3": "Överlämna objektet på en offentlig plats eller hos en Findloop-partner, och kontrollera ägarens ID.",
"fa.safetyOk": "Förstått, fortsätt",
"fa.ownerClosedNote": "Ägaren har stängt sin annons.",
"fa.finderClosedNote": "Fyndaren har stängt sin uppföljning.",
"fa.followupClosed": "Uppföljning stängd",
"fa.followupClosedText": "Du stängde denna uppföljning. Tack för din hjälp!",
"fa.photoReviewTitle": "En findare har skickat ett foto. Ser det ut som din vara?",
"fa.photoLooksLike": "Ja, det ser ut som min vara",
"fa.photoNotMine": "Nej, detta är inte min vara",
"fa.photoNotMineConfirm": "Uppföljningen kommer att stängas från båda sidor och din annons förblir öppen för en ny findare.",
"fa.photoLooksLikeDone": "Tack! Findaren kommer nu att jämföra din deklaration.",
"fa.photoNotMineDone": "Rapport avfärdad. Din annons förblir öppen.",
"fa.ownerPhotoHint": "Endast findarens foto visas för dig. Berätta för oss om det ser ut som din vara.",
"fa.ownerReviewingPhoto": "Ägaren granskar ditt foto",
"fa.ownerReviewingPhotoText": "Du blir meddelad så snart de svarar. Då kan du jämföra deras deklaration.",
"fa.ownerRejectedPhoto": "Detta är inte ägarens vara",
"fa.ownerRejectedPhotoText": "Ägaren säger att ditt foto inte matchar deras vara. Uppföljningen är stängd. Tack för din hjälp!",
"fa.contribute": "Bidra",
"fa.phoneMissing": "Ej angiven",
"fa.ownerSafety1": "Föredra en överlämning på en offentlig plats eller hos en Findloop-partner. Om avståndet är långt, föreslå att skicka det istället.",
"fa.ownerSafety2": "Vid överlämningen, kontrollera hittarnas ID.",
"pub.changePhoto": "Ändra foto",
"ph.secured": "Foto säkrad",
"ph.securing": "Säkrar bilden…",
"fa.ownerSafety3": "Om fyndarens foto bär Findloop-vattenstämpel, acceptera inte mötet. Bilden måste vara en originalbild tagen av fyndaren, utan vattenstämpel."
},
"fi": {
"a.back": "Takaisin",
"a.category": "Kategoria",
"a.categoryPlaceholder": "Valitse kategoria",
"a.city": "Kaupunki",
"a.confirmPassword": "Vahvista salasana",
"a.country": "Maa",
"a.createAccount": "Luo tili",
"a.createBtn": "Luo tilini",
"a.creating": "Luodaan…",
"a.email": "Sähköposti",
"a.emailPro": "Liikesähköposti",
"a.forgot": "Unohtuiko?",
"a.forgotSent": "Jos tili on olemassa, palautuslinkki on juuri lähetetty.",
"a.forgotSub": "Hanki palautuslinkki sähköpostilla.",
"a.forgotTitle": "Unohdettu salasana",
"a.googleContinue": "Jatka Googlilla",
"a.googleSignup": "Rekisteröidy Googlilla",
"a.haveAccount": "Oletko jo kumppani?",
"a.legalHint": "Vaaditaan Ranskan e-laskutuksessa (Factur-X) ranskalaisille toimipaikoille.",
"a.legalRequiredFR": "SIRET ja intra-EU ALV-numero ovat pakollisia Ranskassa.",
"a.loggingIn": "Kirjautuminen…",
"a.login": "Kirjaudu sisään",
"a.loginSub": "Pääsy hallintatilaan.",
"a.loginTitle": "Kumppanin kirjautuminen",
"a.min6": "Vähintään 6 merkkiä",
"a.newPassword": "Uusi salasana",
"a.noAccount": "Ei vielä kumppani?",
"a.or": "TAI",
"a.org": "Toimipaikan nimi",
"a.password": "Salasana",
"a.passwordMismatch": "Salasanat eivät täsmää.",
"a.referral": "Suosituskoodi (valinnainen)",
"a.registerSub": "Luo tilasi 1 minuutissa — ilmainen aloittaa.",
"a.registerTitle": "Tule kumppaniksi",
"a.rememberMe": "Muista minut",
"a.reset": "Nollaa",
"a.resetSub": "Valitse uusi salasana tilillesi.",
"a.resetTitle": "Uusi salasana",
"a.sendLink": "Lähetä linkki",
"a.sending": "Lähetetään…",
"a.signin": "Kirjaudu sisään",
"a.siret": "SIRET",
"a.vat": "Intra-EU ALV nro.",
"ac.africa": "Afrikka",
"ac.boostActive": "Korosta aktiivista —",
"ac.boostSub": "Näy korkeammalla kumppaniluettelossa “Korotettu” -merkillä.",
"ac.boostTitle": "Korosta ilmoitustasi luettelossa",
"ac.categoryHint": "Luokittele toimipaikkasi findloop-luetteloon.",
"ac.choose": "Valitse",
"ac.cityHint": "Tarkkaa sijaintia varten julkisella kartalla.",
"ac.cityLabel": "Toimipaikan kaupunki",
"ac.cityPh": "Pariisi",
"ac.contact": "Yhteystiedot",
"ac.converted": "Muutettu",
"ac.copyDeclLink": "Kopioi ilmoituslinkki",
"ac.copyLink": "Kopioi linkki",
"ac.currentPlan": "Nykyinen suunnitelma",
"ac.emailDesc": "Valitse sähköpostit, jotka haluat vastaanottaa. Ilmoitukset työtilassasi pysyvät aina aktiivisina.",
"ac.emailMatch": "Vastaavuus",
"ac.emailMatchDesc": "Sähköposti, kun kohde vastaa ilmoitusta.",
"ac.emailNewDecl": "Uudet vahinkoilmoitukset",
"ac.emailNewDeclDesc": "Sähköpostiviesti heti, kun asiakas ilmoittaa vahingosta paikassasi",
"ac.emailShip": "Lähetystehot",
"ac.emailShipDesc": "Sähköpostiviesti, kun asiakas pyytää tuotteen lähetystä",
"ac.emailTitle": "Sähköpostivalinnat",
"ac.expireSoon": "Korostuksesi vanhenee pian —",
"ac.exportCsv": "Vie (CSV)",
"ac.exportHint": "Vie validoidut ulkoiset maksusi kirjanpitoasi varten.",
"ac.free": "Ilmainen",
"ac.freeMonths": "Ilmaiset kuukaudet",
"ac.hours": "tuntia",
"ac.howItWorks": "Miten se toimii?",
"ac.invited": "Kutsuttu",
"ac.legalFR": "Vaaditaan sähköiseen laskutukseen (Factur-X), voimassa syyskuusta 2026 alkaen.",
"ac.legalMissing": "⚠️ SIRET ja intrakommunitaarinen ALV puuttuvat — täydennä ne pysyäksesi sähköisen laskutuksen vaatimusten mukaisena.",
"ac.legalOther": "Suositellaan laskuille.",
"ac.legalPartnerQr": "QR-koodi",
"ac.legalTitle": "Lakisääteiset tunnisteet (laskutus)",
"ac.logoTitle": "Liikelaitoksen logo",
"ac.modeCurrent": "Nykyinen tila:",
"ac.modeExternal": "Ulkoinen (manuaalinen validointi)",
"ac.modeInternal": "Sisäinen Findloop (automaattinen)",
"ac.noSubReceipt": "Ei maksamista vielä rekisteröityydestä.",
"ac.none": "Ei mitään",
"ac.onYourListing": "listauksessasi",
"ac.pay1": "Anna maksulinkkisi alla ohjataksesi asiakkaasi omaan keräysjärjestelmääsi.",
"ac.pay2": "Validointi muuttuu manuaaliseksi: vahvistat maksunsaamisen “Ilmoitukset”-välilehdeltä.",
"ac.pay3": "“Lähetysmaksu” -linkki on yhdistelemaksu (perintä + lähetys).",
"ac.pay4": "Jätä kentät tyhjiksi käyttääkseen Findon sisäistä maksua (Stripe) automaattisella validoinnilla.",
"ac.paySub": "Kerää maksuja oman maksujärjestelmäsi kautta.",
"ac.payTitle": "Ulkona maksut",
"ac.permissive": "Suvaitseva",
"ac.phone": "Puhelin",
"ac.posterA4": "A4 juliste (PDF)",
"ac.qMessage": "Viesti (valinnainen)",
"ac.qName": "Nimi",
"ac.qOrg": "Organisaatio",
"ac.qSites": "Liiketoimintapaikkojen määrä (arvio)",
"ac.qrHint": "Asiakkaasi skannaavat tämän koodin ilmoittaakseen kadonneesta esineestä.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Kumppanisi QR-koodi",
"ac.quoteDesc": "Lentokentät, rautatieverkot, kansainväliset ketjut · ",
"ac.quoteEurope": "Eurooppa / Maailma",
"ac.quoteSent": "Tarjouspyyntö lähetetty. Tiimimme palaa pian asiaan.",
"ac.quoteTitle": "Pyydä tarjous — Yritys",
"ac.recoveryLink": "“Perintämaksu” -linkki",
"ac.refSub": "Jokainen viitattu kumppani, joka tilaa, antaa sinulle 1 ilmaisen kuukauden.",
"ac.refTitle": "Viittaa, ansaitse ilmainen kuukausi",
"ac.reminderDelay": "Validointimuistutuksen viive",
"ac.reminderHint": "Saat sähköpostimuistutuksen, jos ulkoinen maksu jää validoimatta tämän viiveen yli (oletus: 48h).",
"ac.renewDesc1": "Se on jo tuottanut sinulle",
"ac.renewDesc2": "Uudista pysyäksesi hakemistosi kärjessä etkä menettäisi näkyvyyttäsi.",
"ac.renewNow": "Uudista nyt",
"ac.requestQuote": "Pyydä tarjous",
"ac.saveLegal": "Tallenna tunnisteet",
"ac.saveLinks": "Tallenna linkit",
"ac.sendRequest": "Lähetä pyyntöni",
"ac.sending": "Lähetetään…",
"ac.shippingLink": "“Lähetysmaksu” -linkki (yhdistetty)",
"ac.shippingLinkHint": "Tämä linkki kattaa sekä perinnän että lähetyksen.",
"ac.strict": "Tiukka",
"ac.subReceipt": "Tilauksen kuitti (PDF)",
"ac.subReceiptsSub": "Lataa PDF-kuitti jokaisesta tilausmaksusta.",
"ac.subReceiptsTitle": "Tilauskuiteet",
"ac.tCategory": "Kategoria tallennettu",
"ac.tCity": "Kaupunki tallennettu — kartta päivitetty",
"ac.tCityNeeded": "Syötä kaupunki",
"ac.tCopied": "Kopioitu!",
"ac.tCover": "Kansikuva päivitetty",
"ac.tEmailPrefs": "Sähköpostiasetukset päivitetty",
"ac.tErr": "Virhe",
"ac.tExportImpossible": "Vienti epäonnistui",
"ac.tLegal": "Lailliset tunnistetiedot tallennettu",
"ac.tLegalNeeded": "SIRET ja ALV vaaditaan Ranskassa",
"ac.tLogo": "Logo päivitetty",
"ac.tLogoRemoved": "Logo poistettu",
"ac.tPayLinks": "Maksulinkit tallennettu",
"ac.tPhone": "Puhelin tallennettu",
"ac.tSensitivity": "Herkkyys tallennettu",
"ac.tVatInvalid": "Virheellinen ALV-numero",
"ac.tVatValid": "Voimassa oleva ALV",
"ac.tabBoost": "Näkyvyys",
"ac.tabPayments": "Maksut",
"ac.tabProfile": "Profiili",
"ac.tabQr": "QR & Juliste",
"ac.tabReferral": "Viittaus",
"ac.tabSub": "Tilaus",
"ac.thisWeek": "Tällä viikolla",
"ac.thisWeekOf": " ({n} tällä viikolla)",
"ac.thresholdDesc": "Luottamusraja, jolta lähtien AI automaattisesti validoi valokuvavastaavuuden ja ilmoittaa asiakkaalle. Korkeampi = vähemmän automaattisia vastaavuuksia, mutta luotettavampi.",
"ac.thresholdTitle": "AI:n visuaalisen vastaavuuden herkkyys",
"ac.trend": "Trend",
"ac.upload": "Lataa",
"ac.vatValidFmt": "Voimassa oleva ALV{name} ({via})",
"ac.vatVerified": "Sisäisen EU:n ALV tarkistettu",
"ac.verifyVat": "Vahvista ALV (VIES)",
"ac.verifying": "Vahvistetaan…",
"ac.views": "näyttöä",
"ac.viewsTotal": "Saadut näytöt (yhteensä)",
"ac.winbackBtn": "Jatka -20%",
"ac.winbackDesc1": "Se ansaitsi sinulle",
"ac.winbackDesc2": "Erikoistarjous: -20% sovelletaan automaattisesti, jos uusit 24 tunnin sisällä.",
"ac.winbackTitle": "Korostuksesi juuri päättyi — jatka -20%:lla!",
"ad.boost": "Tehosta",
"ad.close": "Sulje",
"ad.closeConfirm": "Sulje tämä ilmoitus?",
"ad.closed": "Ilmoitus suljettu",
"ad.edit": "Muokkaa",
"ad.editTitle": "Muokkaa ilmoitusta",
"ad.saved": "Ilmoitus päivitetty",
"an.allCountries": "Kaikki maat",
"an.badge": "Kadonneet esineet",
"an.boostLater": "Myöhemmin",
"an.boostNow": "Tehosta nyt",
"an.boostPrompt": "Tehosta ilmoitustasi saadaksesi sen ylös ja löydettäväksi nopeammin.",
"an.boosted": "Tehostettu",
"an.contact": "Löysin tämän esineen",
"an.contactTitle": "Ilmoita, että löysit tämän esineen",
"an.copyFailed": "Linkin kopioiminen epäonnistui",
"an.copyLink": "Kopioi linkki",
"an.country": "Maa",
"an.date": "Kadonnut päivämäärä",
"an.finderEmail": "Sähköpostisi",
"an.finderName": "Nimesi",
"an.finderPhone": "Puhelimesi",
"an.geoBanner": "Näet ilmoituksia paikassa",
"an.geoBannerWorld": "Näet ilmoituksia ympäri maailmaa",
"an.geoChange": "vaihda maata",
"an.goAccount": "Siirry tiliini",
"an.linkCopied": "Linkki kopioitu!",
"an.loginRequired": "Kirjaudu sisään ilmoittaaksesi tästä esineestä ja seurataksesi palautusta.",
"an.loginToBoost": "Kirjaudu sisään voidaksesi nostaa tämän ilmoituksen",
"an.lostAt": "Kadonnut paikassa",
"an.message": "Viesti (valinnainen)",
"an.none": "Ei ilmoituksia vielä.",
"an.photo": "Valokuva (valinnainen)",
"an.post": "Jätä ilmoitus",
"an.postSubtitle": "Kuvaile kadonnut esineesi — yhteisö ja kumppanimme auttavat löytämään sen.",
"an.postTitle": "Ilmoita kadonneesta esineestä",
"an.publish": "Julkaise ilmoitus",
"an.published": "Ilmoitus julkaistu!",
"an.publishing": "Julkaistaan…",
"an.remaining": "jäljellä",
"an.requestInProgress": "Pyyntö käynnissä",
"an.resolved": "Esine on jo palautettu",
"an.reward": "Palkkio",
"an.searchPh": "Etsi ilmoitusta…",
"an.send": "Lähetä",
"an.sent": "Viesti lähetetty omistajalle!",
"an.shareConsent": "Hyväksyn, että yhteystietoni (nimi, sähköposti, puhelin) voidaan jakaa esineen omistajan kanssa.",
"an.shareConsentError": "Valitse ruutu jakaaaksesi yhteystietosi.",
"an.sortRecent": "Uusimmat",
"an.sortRelevance": "Relevanssi",
"an.subtitle": "Selvytä yhteisön ilmoittamat kadonneet esineet. Löysitkö yhden niistä?",
"an.title": "Kadonneet esinelistat",
"anf.badge": "Löydetyt esineet",
"anf.claim": "Tämä on minun",
"anf.claimSent": "Viesti lähetetty löytäneelle!",
"anf.claimTitle": "Ilmoita, että tämä on sinun esineesi",
"anf.consent": "Hyväksyn, että omistaja voi nähdä yhteystietoni palauttaakseen esineensä.",
"anf.foundAt": "Löydetty paikassa",
"anf.foundDate": "Löydetty päivämäärä",
"anf.loginCta": "Kirjaudu sisään / luo tili",
"anf.loginDesc": "Löytäjätili vaaditaan ilmoituksen julkaisemiseen ja Finder Hero -pisteiden ansaitsemiseen.",
"anf.loginRequired": "Kirjaudu sisään voidaksesi jättää ilmoituksen löydetystä esineestä",
"anf.photo": "Esineen valokuva",
"anf.pointsEarned": "Kiitos! Olet juuri ansainnut Finder Hero -pisteitä.",
"anf.pointsPending": "Pisteesi hyväksytään 24 tunnin kuluessa, vahvistuksen jälkeen.",
"anf.post": "Jätä ilmoitus löydetystä esineestä",
"anf.postSubtitle": "Kuvaile löytämäsi esine — auta omistajaa saamaan se takaisin.",
"anf.postTitle": "Ilmoita löydetystä esineestä",
"anf.publishFound": "Julkaise löydetty ilmoitus",
"anf.published": "Löydetty-esinelista julkaistu",
"anf.publishedAs": "Julkaistu nimellä",
"anf.shareConsent": "Hyväksyn, että yhteystietoni (nimi, sähköposti, puhelin) voidaan jakaa esineen löytäneen kanssa.",
"anf.subtitle": "Selvytä yhteisön löytämät ja ilmoitetut esineet. Tunnetko omasi?",
"anf.title": "Löydetyt esinelistat",
"bo.active": "Tehostus aktiivinen",
"bo.africaPrice": "Afrikan alueen erityishinta käytössä",
"bo.pay": "Maksa & tehosta",
"bo.remaining": "Jäljellä oleva aika",
"bo.renew": "Uudista tehostus",
"bo.since": "tehostuksesta lähtien",
"bo.subtitle": "Aseta ilmoituksesi listan kärkeen näkyvällä tarralla.",
"bo.title": "Tehosta ilmoitusta",
"c.all": "Kaikki",
"c.cancel": "Peruuta",
"c.close": "Sulje",
"c.confirm": "Vahvista",
"c.confirmed": "Vahvistettu",
"c.download": "Lataa",
"c.loading": "Ladataan…",
"c.reset": "Nollaa",
"c.reviews": "arvostelua",
"c.save": "Tallenna",
"c.transfer": "Siirrä",
"cat.Animal": "Lemmikki / Lemmikkitarvikkeet",
"cat.AppareilPhoto": "Kamera",
"cat.Argent": "Raha / Käteinen",
"cat.Autres": "Muut",
"cat.Bijoux": "Korut",
"cat.CarteBancaire": "Pankkikortti",
"cat.CarteIdentite": "Henkilökortti / Passi",
"cat.Casquette": "Lippalakki / Hattu",
"cat.Ceinture": "Vyö",
"cat.Chargeur": "Laturi / Kaapeli",
"cat.Chaussures": "Kengät",
"cat.CleVoiture": "Auton avain",
"cat.Cles": "Avaimet",
"cat.Console": "Pelikonsoli",
"cat.Documents": "Dokumentit / Paperit",
"cat.Echarpe": "Huivi",
"cat.Ecouteurs": "Kuulokkeet",
"cat.Electronique": "Elektroniikka (muut)",
"cat.Enceinte": "Kaiutin",
"cat.Gants": "Käsineet",
"cat.Gourde": "Vesipullo / Termospullo",
"cat.Instrument": "Musiikkiväline",
"cat.Jouet": "Lelu / Pehmolelu",
"cat.Jumelles": "Kiikareita",
"cat.Lampe": "Lamppu / Taskulamppu",
"cat.Liseuse": "Sähkökirja",
"cat.Livre": "Kirja / Muistikirja",
"cat.Lunettes": "Aurinkolasit",
"cat.Manteau": "Takki",
"cat.Maquillage": "Meikkipussi",
"cat.Medical": "Lääketieteelliset välineet",
"cat.Medicaments": "Lääkkeet",
"cat.Montre": "Kello / Älykello",
"cat.Ordinateur": "Kannettava tietokone",
"cat.Parapluie": "Sadetakki",
"cat.Portefeuille": "Lompakko",
"cat.Poussette": "Vaunu / Vauvan tarvikkeet",
"cat.Sac": "Laukku / Käsilaukku",
"cat.SacADos": "Reppu",
"cat.Souris": "Hiiri / Näppäimistö",
"cat.Sport": "Urheiluvälineet",
"cat.Tablette": "Tabletti",
"cat.Telephone": "Puhelin / Älypuhelin",
"cat.Trottinette": "Scooter",
"cat.Trousse": "Pussi / Laukku",
"cat.USB": "USB-tikku / Kiintolevy",
"cat.Valise": "Matkalaukku / Luggage",
"cat.Velo": "Polkupyörä",
"cat.Vetements": "Vaatteet",
"cat.placeholder": "Valitse kategoria",
"cd.d": "pv",
"cd.expired": "Vanhentunut",
"cd.h": "h",
"cd.m": "min",
"ck.accept": "Hyväksy",
"ck.acceptAll": "Hyväksy kaikki",
"ck.customize": "Mukauta",
"ck.learn": "Lisätietoja",
"ck.manage": "Hallitse evästeitä",
"ck.measurement": "Yleisön mittaus",
"ck.measurementDesc": "Anonyymit tilastot palvelun parantamiseksi.",
"ck.msg": "Käytämme evästeitä pitääksemme sivuston toiminnassa ja mittaamaan yleisöä.",
"ck.necessary": "Tarvittavat",
"ck.necessaryDesc": "Olennainen sivuston toimivuudelle. Aina päällä.",
"ck.refuse": "Hylkää",
"ck.save": "Tallenna valintani",
"ck.saved": "Asetukset tallennettu",
"ck.title": "Evästeasetuksesi",
"cm.found": "LÖYTYNYT",
"cm.lost": "KADONNUT",
"cmp.adv": "Kehittynyt",
"cmp.ai": "AI-vastaavuus",
"cmp.autobill": "Automaattinen laskutus",
"cmp.basic": "Perus",
"cmp.community": "Yhteisö",
"cmp.consol": "Yhdistetty laskutus",
"cmp.custom": "Mukautettu",
"cmp.dedicated": "Omistettu",
"cmp.deploy": "Omistettu käyttöönottaminen & SLA",
"cmp.estIncl": "Liiketoimintayksiköt mukana",
"cmp.estSec": "Lisäliiketoimintayksikkö",
"cmp.items": "Esineet / kuukausi",
"cmp.main": "1 pää",
"cmp.max20": "20 max",
"cmp.members": "Jäsenkutsut",
"cmp.onQuote": "Mukautettu tarjous",
"cmp.priority": "Prioriteetti",
"cmp.starterEst": "1 mukaan + rajattomasti lisä",
"cmp.stats": "Tilastot",
"cmp.statsAdv": "Kehittynyt",
"cmp.statsBasic": "Perus",
"cmp.support": "Tuki",
"cmp.unlimited": "Rajatonta",
"cmp.upTo3": "Jopa 3",
"consent.required": "Sinun on hyväksyttävä, että jaat yhteystietosi jatkaaksesi.",
"consent.share": "Hyväksyn, että esineeni löytäjä voi nähdä yhteystietoni (nimi, sähköposti, puhelin) ottaakseen minuun yhteyttä palautusta varten.",
"cover.add": "Lisää",
"cover.change": "Vaihda",
"cover.helper": "Näytetään bannerina raporttisivullasi ja hakemistossa.",
"cover.none": "Ei kansikuvia",
"cover.remove": "Poista",
"cover.title": "Kansikuva",
"crop.desc": "Säädä kehykset bannerin suhteeseen (3:1). Vedä ja zoomaa.",
"crop.saving": "Tallennetaan…",
"crop.title": "Rajaa kansikuvasta",
"cta.button": "Luo kumppanitili",
"cta.subtitle": "Liity nopeammin palauttaviin liikkeisiin findon avulla.",
"cta.title": "Valmiina vähentämään kadonneita esineitä?",
"db.account.s": "Hallitse liikettänne, tilaustasi ja QR-koodiasi.",
"db.account.t": "Oma tili",
"db.declarations.s": "Asiakkaat, jotka ovat ilmoittaneet kadonneesta esineestä QR-koodisi avulla.",
"db.declarations.t": "Katoa ilmoitukset",
"db.deposit.s": "Lisää valokuva, kategoria ja kuvaus.",
"db.deposit.t": "Kirjaa löytynyt esine",
"db.registry.s": "Kaikki liiketilassasi kirjatut löydettyt esineet.",
"db.registry.t": "Esinerekisteri",
"db.reviews.s": "Vastaa julkisesti asiakkaidesi arvosteluihin.",
"db.reviews.t": "Asiakasarvostelut",
"db.shipments.s": "Luo tarroja ja seuraa lähetettävät paketit.",
"db.shipments.t": "Lähetykset",
"db.stats.s": "Avainmittarit.",
"db.stats.t": "Tilastot",
"db.team.s": "Kutsu kollegasi hallitsemaan esineitä.",
"db.team.t": "Tiimi",
"dc.partnerDesc": "Kadotitko esineesi kumppanipaikassa (hotelli, asema, halli…)? Valitse se suoraa palautusta varten.",
"dc.partnerList": "Valitse listalta",
"dc.partnerMap": "Valitse kartalta",
"dc.partnerTitle": "Ilmoitus kumppanilla",
"dc.publicCta": "Julkaise julkinen ilmoitus",
"dc.publicDesc": "Ilmoituksesi näkyy koko findloop-yhteisölle. Ihanteellinen, jos et tiedä, missä kadotit esineen.",
"dc.publicTitle": "Julkinen ilmoitus",
"dc.subtitle": "Valitse, miten haluat ilmoittaa kadonneesta esineestäsi.",
"dc.title": "Mitä haluaisit tehdä?",
"dec.addrPending": "Osoite odottaa asiakkaalta",
"dec.analyzing": "Analysoidaan…",
"dec.badge": "Katoamisilmoitus",
"dec.category": "Esineen kategoria",
"dec.clientDescription": "Asiakkaan kuvaus",
"dec.clientPhoto": "Asiakkaan tarjoama valokuva",
"dec.clientPhotoShort": "Asiakkaan kuva",
"dec.comparePhotos": "Vertaa valokuvia",
"dec.contactTitle": "Yhteystietosi",
"dec.date": "Katoamispäivämäärä",
"dec.declaredItemPhoto": "Kuvattu esine",
"dec.descPh": "Kuvaile esinettä: merkki, väri, erottuvat merkit…",
"dec.description": "Kuvaus",
"dec.email": "Sähköposti",
"dec.emptyDesc": "Jaa QR-koodisi saadaksesi ilmoituksia.",
"dec.emptyTitle": "Ei ilmoituksia",
"dec.enlarge": "Suurenna",
"dec.extBanner": "{n} ulkoista maksua odottaa vahvistamista — vahvista vastaanotto alla, jotta voit avata luovutuksen tai lähetyksen.",
"dec.foundItemAlt": "Löydetty esine",
"dec.foundItemRegistry": "Löydetty esine (rekisteri)",
"dec.home": "Takaisin kotiin",
"dec.labelClient": "Asiakas",
"dec.labelRegistry": "Rekisteri",
"dec.matchFound": "Match on jo löydetty!",
"dec.name": "Koko nimi",
"dec.noMatchYet": "Ei vielä otteluja.",
"dec.noPhoto": "Ei kuvaa",
"dec.notfound": "Kumppania ei löydy.",
"dec.pRecup": "palautus",
"dec.pRecupP": "(palautus)",
"dec.pRecupShip": "(palautus + lähetys)",
"dec.payConfirmed": "Maksu {x} vahvistettu",
"dec.payPending": "Ulkoista maksua {x} odotetaan",
"dec.phone": "Puhelin",
"dec.pickup": "Henkilökohtainen nouto",
"dec.place": "Häviämispaikka",
"dec.placePh": "esim. baarissa, huoneessa 204...",
"dec.recoverBtn": "Palauta esineeni",
"dec.reject": "Hylkää",
"dec.rerun": "Aja analyysi uudestaan",
"dec.similarity": "Samanlaisuus {n}%",
"dec.submit": "Lähetä raporttini",
"dec.submitting": "Lähetetään...",
"dec.successText": "Etsimme esinettäsi niiden joukosta, jotka ovat",
"dec.successTitle": "Raportti lähetetty!",
"dec.suggestedMatches": "Ehdotetut vastaavuudet",
"dec.toColon": " :",
"dec.toShip": "Lähetettävä",
"dec.toastExtPay": "Maksu vahvistettu — asiakas ilmoitetaan.",
"dec.toastMatch": "Vastaavuus vahvistettu",
"dec.toastReject": "Ehdotus hylätty",
"dec.toastRerun": "Analyysi käynnistetty uudelleen",
"dec.toastVisualN": "{n} visuaalista vastaavuutta",
"dec.toastVisualNone": "Ei visuaalista vastaavuutta",
"dec.trackBtn": "Seuraa raporttiani",
"dec.viewBeforeAfter": "Ennen/jälkeen katselu (päällekkäin)",
"dec.viewSideBySide": "Sivuttain katselu",
"dec.visualCompare": "AI visuaalinen vertailu",
"dec.visualIdle": "Suorita vertailu, jotta AI voi visuaalisesti verrata asiakkaan kuvaa löydettyihin esineisiin.",
"dec.visualRunning": "AI vertailee asiakkaan kuvaa rekisterissä oleviin esineisiin...",
"dec.zoomPhoto": "Suurenna kuva",
"dep.addAnyway": "Lisää silti",
"dep.addError": "Virhe lisättäessä",
"dep.addItem": "Lisää esine",
"dep.added": "Esine lisätty rekisteriin!",
"dep.adding": "Lisätään...",
"dep.aiError": "AI-analyysi ei ole tällä hetkellä saatavilla.",
"dep.aiFilled": "Lomake esitäytetty AI:n toimesta ✨",
"dep.aiUnavailable": "AI ei saatavilla — täytä lomake käsin.",
"dep.analyzing": "Analysoidaan...",
"dep.analyzingPhoto": "Analysoidaan kuvaa...",
"dep.brand": "Brändi",
"dep.brandPlaceholder": "esim. Apple",
"dep.category": "Kategoria",
"dep.checkingDup": "Tarkistetaan duplikaatteja...",
"dep.color": "Väri",
"dep.colorPlaceholder": "esim. musta",
"dep.condition": "Kunto",
"dep.conditionPlaceholder": "esim. hyvä kunto",
"dep.depositorNote": "Tallettajan huomautus",
"dep.depositorNoteHint": "Toimintatiedot kirjoitettu käsin. AI ei koskaan ylikirjoita tätä huomautusta.",
"dep.depositorNotePlaceholder": "esim. pussin sisältö, raportoidun brändin tiedot, henkilön antamat tiedot...",
"dep.descPlaceholder": "esim. musta iPhone 15 läpinäkyvässä kuoressa, löydetty baarista...",
"dep.description": "Kuvaus",
"dep.dupHint": "Varmista, ettet lisää duplikaattia. Voit jatkaa, jos esine on todella erilainen.",
"dep.dupTitle": "Samanlaisia esineitä rekisteröity",
"dep.dupWarn": "Samanlainen esine havaittu — tarkista, sitten klikkaa uudelleen vahvistaaksesi.",
"dep.estHint": "Esine lisätään tämän laitoksen rekisteriin.",
"dep.establishment": "Laitos",
"dep.fee": "Palautusmaksu (€) — valinnainen",
"dep.feePlaceholder": "Jätä tyhjäksi saadaksesi kategoriaan oletushinnan",
"dep.fillAI": "Täytä AI:lla",
"dep.optional": "(valinnainen)",
"dep.photo": "Tuotteen valokuva",
"dep.principal": "pääasiallinen",
"dep.reqError": "Kategoria ja kuvaus ovat pakollisia.",
"dep.savedItem": "Rekisteröity tuote",
"dep.similarity": "Samanlaisuus",
"dep.storage": "Fyysinen sijainti",
"dep.storageHint": "Missä tuote on fyysisesti varastoituna. QR-koodi luodaan sen löytämiseksi.",
"dep.storagePlaceholder": "esim. Hylly A3, Lokero 12, Vastaanoton talletus",
"dl.aClient": "asiakas",
"dl.alertsBlocked": "Selaimen hälytykset estetty",
"dl.alertsBlockedHint": "Ota ne takaisin käyttöön: napsauta 🔒 (tai ⓘ) -ikonia sivuston osoitteen vasemmalla puolella, sitten salli Ilmoitukset ja lataa sivu uudelleen.",
"dl.amountDue": "Maksettava summa: {amount} {currency}.",
"dl.enableAlerts": "Ota hälytykset käyttöön",
"dl.extPending": "Maksut odottavat vahvistusta",
"dl.freemiumNear": "Lähestyt Freemium-rajaa ({used}/{max} tuotetta tämän kuukauden aikana). Päivitä Starteriksi rajoittamattomalle määrälle tuotteita.",
"dl.freemiumReached": "Freemium-raja saavutettu ({used}/{max} tuotetta tämän kuukauden aikana). Päivitä Starteriksi rekisteröidäksesi rajoittamaton määrä tuotteita.",
"dl.invoiceOverdue": "Lasku {num} maksamaton — käyttö rajoitettu.",
"dl.matchNotifTitle": "Findloop — Uusi AI-ottelu 🔔",
"dl.matchToast": "Uusi AI-ottelu — {name}",
"dl.matchToastDesc": "Tuote vastaa julkilausumaa.",
"dl.notifEmpty": "Ei ilmoituksia vielä.",
"dl.notifEnabled": "Selaimen hälytykset käytössä",
"dl.notifTitle": "Ilmoitukset",
"dl.payInvoice": "Maksa laskuni →",
"dl.rewardsPending": "Esitettävät kuponkit",
"dl.upgradeStarter": "Päivitä Starteriksi →",
"est.all": "Kaikki laitokset ({n})",
"est.label": "Laitos",
"est.primary": "pääasiallinen",
"est.secondary": "toissijainen",
"est2.add": "Lisää laitos",
"est2.addressLabel": "Osoite",
"est2.addressPh": "12 République Street",
"est2.autoInvoice": "Yksityiskohtainen lasku luodaan automaattisesti joka kuukauden 1. päivänä.",
"est2.baseSub": "Perusliittymä",
"est2.billing": "Laskutus",
"est2.boostActivated": "Boost aktiivinen {name}:",
"est2.boostBillingNote": "Laskutetaan nykyisellä hinnalla ja ryhmitellään konsolidoidulle kuukausilaskulle.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Paranna tämän laitoksen näkyvyyttä hakemistossa ja kartalla.",
"est2.boostDuration": "{h}h parannettua näkyvyyttä",
"est2.boostExtend": "Laajenna",
"est2.boostTitle": "Boostaa {name}",
"est2.boosted": "Boostattu",
"est2.chartDesc": "Palautettujen tuotteiden osuus kaikista rekisteröidyistä, sivustokohtaisesti.",
"est2.chartTitle": "Palautusaste laitoksen mukaan",
"est2.chartTooltip": "Palautus",
"est2.cityLabel": "Kaupunki",
"est2.cityPh": "Lyon",
"est2.contactHint": "Nämä tiedot näytetään asiakkaalle tälle laitokselle (palautuu tiliin, jos tyhjää).",
"est2.countryLabel": "Maa",
"est2.coverLabel": "Kansikuva",
"est2.create": "Luo",
"est2.created": "Laitos luotu",
"est2.delete": "Poista",
"est2.deleteDesc": "Tämä toimenpide on pysyvä. Voit poistaa laitoksen vain, jos se ei sisällä tuotteita.",
"est2.deleteTitle": "Poista “{name}”?",
"est2.deleted": "Laitos poistettu",
"est2.dialogDesc": "Syötä tämän sivuston nimi ja osoite.",
"est2.edit": "Muokkaa",
"est2.editEst": "Muokkaa toimipistettä",
"est2.emailLabel": "Yhteystuotteviesti",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " toimipistettä",
"est2.extraNoteBase": "{n} lisätään laskutettavaa toimipistettä",
"est2.extraPrice": " {price} €/kuukausi.",
"est2.extraQuote": " tarjouksessa.",
"est2.imgChange": "Valitse kuva",
"est2.imgDone": "Valmis",
"est2.imgRemove": "Poista",
"est2.imgRemoved": "Kuva poistettu",
"est2.imgSaved": "Kuva tallennettu",
"est2.imgUploading": "Ladataan…",
"est2.includedPlan": "Sisältyy suunnitelmaasi: {n}.",
"est2.kDeclarations": "Ilmoitukset",
"est2.kInStorage": "Varastossa",
"est2.kItemsTotal": "Kohteet (yhteensä)",
"est2.kRestituted": "Palautettu",
"est2.limitReached": "Raja saavutettu",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Ilmo.",
"est2.mItems": "Kohteet",
"est2.mRestituted": "Palautettu",
"est2.mStorage": "Varastossa",
"est2.monthlyTotal": "Kuukausittainen yhteensä",
"est2.nameLabel": "Nimi *",
"est2.namePh": "esim. Belmont Hotel — Lyon Annex",
"est2.newEst": "Uusi toimipiste",
"est2.onQuote": "Tarjouksessa",
"est2.phoneLabel": "Puhelin",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Suunnitelma",
"est2.planLimited": "Your “{tier}” plan is limited to {max} toimipistettä.",
"est2.primary": "Pääasiallinen",
"est2.qr": "QR-koodi",
"est2.qrDesc": "Näytä tämä QR-koodi tässä toimipisteessä. Asiakkaat, jotka raportoivat häviöitä, linkitetään tälle sivustolle.",
"est2.qrTitle": "QR-koodi — {name}",
"est2.saving": "Tallennetaan…",
"est2.seeInvoices": "Näytä kuukausittaiset laskuni",
"est2.seePlans": "Näytä suunnitelmat",
"est2.subtitle": "Hallitse kaikkia sivustoja yhden tilin alla — keskitetty näkymä, kohteet, QR-koodi ja laskutus.",
"est2.suspended": "Keskeytetty",
"est2.tierFree": "1 toimipiste",
"est2.tierLarge": "rajoittamaton toimipisteitä",
"est2.tierMedium": "5 toimipistettä sisältyy",
"est2.tierSmall": "3 toimipistettä sisältyy",
"est2.title": "Toimipisteet",
"est2.unlimitedPlan": "Suunnitelmasi sallii rajoittamattoman määrän toimipisteitä.",
"est2.unlimitedSuffix": " · rajoittamaton",
"est2.updated": "Toimipiste päivitetty",
"est2.upgradeHint": "Päivitä korkeampaan suunnitelmaan lisätäksesi lisää sivustoja ja keskittääksesi kaiken toimintasi.",
"est2.visuals": "Logo & kuva",
"est2.visualsDesc": "Mukauta tämän toimipisteen logoa ja kansikuvaa. Ne näkyvät sen julkisella sivulla ja ilmoituslomakkeessa.",
"est2.visualsTitle": "Visuaalit — {name}",
"est2.workOn": "Työskentele tämän toimipisteen parissa",
"est2.working": "Työskentelet “{name}” parissa",
"ev.created": "Raportti luotu",
"ev.matched": "Vastaava kohde tunnistettu",
"ev.paid": "Palautusmaksu maksettu",
"ev.pickup": "Noudettavissa paikan päällä",
"ev.shipped": "Paketti lähetetty",
"ev.shipping_paid": "Toimitusmaksu maksettu",
"ev.shipping_requested": "Toimituspyyntö lähetetty",
"feat1.d": "KPI:t, palautusprosentti kuukausittain, tulot ja 30 päivän trendit.",
"feat1.t": "Ohjaus- ja analytiikka",
"feat2.d": "Tarrat, kuljetin seuranta ja automaattiset seurantaviestit.",
"feat2.t": "Toimitusmoduuli",
"feat3.d": "Asiakkaat löytävät sinut kaupungin ja kategorian mukaan, sertifioiduilla arvosteluilla.",
"feat3.t": "Julkinen hakemisto & arvostelut",
"fp.backToRanking": "Takaisin tulostaulukkoon",
"fp.badge": "Merkit",
"fp.hero": "Finder Sankari",
"fp.notFound": "Profiilia ei löytynyt tai se on yksityinen.",
"fp.scoreTotal": "Yhteispisteet",
"fp.scoreYear": "Pisteet vuonna",
"fp.share": "Jaa tämä profiili",
"fp.shareText": "Tarkista {name}n finder-profiili findossa!",
"fp.tagline": "Rehellinen finder, joka tekee maailmasta paremman paikan.",
"ft.backAccount": "Takaisin Omat tiedot",
"ft.closeBtn": "Sulje tapaus",
"ft.closeConfirm": "Vahvista, että esine on palautettu? Ilmoitus suljetaan.",
"ft.closeLockedHint": "Varmista ensin omistajan koodi, jotta voit avata sulkemisen.",
"ft.closed": "Tapaus suljettu — esine palautettu!",
"ft.codeLabel": "Syötä omistajalta vastaanotettu vahvistuskoodi",
"ft.codeNeeded": "Ole hyvä ja syötä vahvistuskoodi.",
"ft.codeOk": "Koodi vahvistettu — voit sulkea tapauksen.",
"ft.codePlaceholder": "esim. 4821",
"ft.codeVerified": "Vahvistettu",
"ft.doneMsg": "Esine palautettu. Kiitos, että autat palauttamaan sen omistajalleen!",
"ft.stepInProgress": "Palautus käynnissä",
"ft.stepPublished": "Ilmoitus julkaistu",
"ft.stepReturned": "Esine palautettu",
"ft.subtitle": "Noudata vaiheita, kunnes löytynyt esine on palautettu.",
"ft.title": "Palautuksen seuranta",
"ft.verifyBtn": "Vahvista koodi",
"hero.badge": "Esitelty",
"hero.ctaFound": "Löysin esineen",
"hero.ctaLost": "Menetin esineen",
"hero.ctaPartner": "Liity kumppaniksi",
"hero.subtitle": "Findloop auttaa yrityksiä hallitsemaan löytyneitä esineitä - ja antaa asiakkaille mahdollisuuden ilmoittaa katoamisesta ja palauttaa omaisuutensa paikan päällä tai lähettämällä.",
"hero.title": "Jokainen kadonnut esine löytää omistajansa.",
"home.champBecome": "Liity finderiksi",
"home.champCta": "Näytä tulostaulu",
"home.champSubtitle": "Jokainen palautettu esine tuo pisteitä. Liity tulostaulukkoon ja voita palkintoja.",
"home.champTitle": "Parhaat finderimme",
"how.eyebrow": "Kuinka se toimii",
"how.title": "Ladasta palautukseen vaivattomasti.",
"inv.all": "Kaikki",
"inv.allYears": "Kaikki vuodet",
"inv.count": "Laskut",
"inv.due": "eräpäivänä",
"inv.empty": "Ei vielä laskuja.",
"inv.exportCsv": "Vie CSV",
"inv.invoicePdf": "Lasku PDF",
"inv.issued": "Myönnetty",
"inv.noMatch": "Ei laskua tälle suodattimelle.",
"inv.paid": "Maksettu (€)",
"inv.paidOn": "maksettu",
"inv.pay": "Maksa",
"inv.receipt": "Kuitti",
"inv.reminders": "Muistutukset",
"inv.remindersDesc": "Sähköposti- ja SMS-muistutukset lähetetään tälle laskulle.",
"inv.remindersEmpty": "Ei muistutusta lähetetty.",
"inv.rmDue": "Eräpäivämuistutus",
"inv.rmManual": "Manuaalinen muistutus",
"inv.rmSms": "SMS-muistutus D+30",
"inv.rmStage": "Muistutus",
"inv.statusPaid": "Maksettu",
"inv.statusUnpaid": "Maksamatta",
"inv.subtitle": "Näe ja lataa laskusi ja kuitit.",
"inv.title": "Omat laskuni",
"inv.unpaid": "Maksamatta (€)",
"inv2.contractTitle": "Oma findloop-sopimus",
"inv2.detailByEst": "Tiedot toimipaikan mukaan",
"inv2.dueLabel": "Eräpäivä:",
"inv2.dueSuffix": " · eräpäivä {date}",
"inv2.error": "Virhe {status}",
"inv2.estCountIssued": "{n} toimipaikka(ta) · annettu {date}",
"inv2.estimate": "Arvio (ei veloitettu) · {n} toimipaikka(ta)",
"inv2.expired": " · voimassaolon päättynyt",
"inv2.exportCsv": "Vie CSV",
"inv2.exportDone": "CSV-vienti ladattu",
"inv2.included": "Sisältää",
"inv2.monthlyTitle": "Kuukausittainen laskutus (tilaus)",
"inv2.months": "+{n} kuukautta",
"inv2.paid": "Maksettu",
"inv2.pay": "Maksa",
"inv2.previewTitle": "Esikatselu seuraavasta laskustasi —",
"inv2.renew": "Uudista sopimukseni",
"inv2.renewalsTitle": "Uudistushistoria ({n})",
"inv2.renewedUntil": "Sopimus uusittu {date} asti",
"inv2.serviceTitle": "Palvelulaskut (perinnät & tarjoukset)",
"inv2.soon": "Voimassa pian",
"inv2.toPay": "Maksettavaa",
"inv2.totalHtTva": "Yhteensä ilman veroa · ALV",
"inv2.totalTtc": "Yhteensä veron kanssa",
"iu.addPhoto": "Lisää valokuva",
"iu.change": "Vaihda",
"lang.label": "Kieli",
"lb.allCountries": "Kaikki maat",
"lb.badge": "Vuosittainen ranking",
"lb.champion": "🏆 Vuoden mestari",
"lb.cityPh": "Suodata kaupungin mukaan…",
"lb.empty": "Näille suodattimille ei vielä ole rankingia.",
"lb.pts": "pistettä",
"lb.resetNote": "Tämän vuoden ranking — nollautuu joka 1. tammikuuta.",
"lb.returned": "palautettu",
"lb.share": "Jaa ranking",
"lb.shareText": "Tutustu findon parhaisiin löytäjiin rankingissa!",
"lb.subtitle": "Jokainen palautus tuo pisteitä. Ranking nollautuu joka 1. tammikuuta.",
"lb.tabFinders": "Löytäjät",
"lb.tabPartners": "Toimipaikat",
"lb.title": "Parhaat löytävät",
"lost.b2bDesc": "Löysitkö sen hotellista, liikennekeskuksesta tai kumppanipaikasta? Etsi toimipaikka ja ilmoita menetys.",
"lost.b2bTitle": "Ilmoita kumppanille",
"lost.b2cDesc": "Julkaise ilmoitus, joka näkyy kaikille, tarjoa palkinto ja nostaa se maksimoidaksesi mahdollisuutesi.",
"lost.b2cTitle": "Julkaise julkinen ilmoitus",
"lost.desc": "Valitse, miten haluat edetä.",
"lost.title": "Oletko kadottanut esineen?",
"map.allCategories": "Kaikki kategoriat",
"map.clear": "Nollaa",
"map.exitFullscreen": "Poistu",
"map.filterCity": "Kaupunki tai maa…",
"map.fullscreen": "Koko näyttö",
"map.heatmap": "Lämpökartta",
"map.high": "Korkea",
"map.impactMonth": "esinettä palautettu tänä kuukautena",
"map.impactTotal": "yhteensä palautettu",
"map.legend": "Väritetyt pisteet punaisesta (matala) vihreään (korkea) palautusprosentin mukaan; koko esineiden määrän mukaan.",
"map.locating": "Paikannetaan… lisää osoite liiketiloihisi nähdäksesi ne kartalla.",
"map.low": "Matala",
"map.mAll": "Kaikki",
"map.mFound": "Löydetty",
"map.mLost": "Kadonnut",
"map.medium": "Keskikorkea",
"map.noItemRegistered": "Ei esinettä rekisteröity",
"map.noItems": "Ei esinettä",
"map.period30": "Viimeiset 30 päivää",
"map.period7": "Viimeiset 7 päivää",
"map.period90": "Viimeiset 90 päivää",
"map.periodAll": "Kaikki ajat",
"map.returnedSuffix": "palautettu · {a}/{t} esinettä",
"map.stats": "Kaupungin tilastot",
"map.statsTop": "Top 5 paikkaa (kadonneet esineet)",
"map.statsTrend": "6 kuukauden trendi",
"map.title": "Kartta liiketiloistasi",
"map.topPlaces": "Suositut paikat",
"mc.adClosed": "Ilmoitus suljettu",
"mc.addPhoto": "Lisää valokuva",
"mc.adsNone": "Ei kadonneen esineen ilmoitusta.",
"mc.archiveHide": "Piilota historia",
"mc.archiveNone": "Ei vielä ratkaistua tapausta.",
"mc.archiveShow": "Näytä historia",
"mc.archiveSub": "Ratkaistut ja palautetut tapaukset.",
"mc.archiveTitle": "Historia",
"mc.at": "Osoitteessa",
"mc.backToLogin": "Takaisin kirjautumiseen",
"mc.boostContacts": "Yhteystiedot (nosta)",
"mc.boostViews": "Näytöt (nosta)",
"mc.cancel": "Peruuta",
"mc.certificate": "Todistus",
"mc.changePhoto": "Vaihda valokuva",
"mc.city": "Kaupunki",
"mc.closeAd": "Sulje",
"mc.closeAdConfirm": "Sulje tämä ilmoitus? Se ei enää näy ja vapauttaa tilan.",
"mc.confirmPassword": "Vahvista salasana",
"mc.confirmRestitution": "Vahvista palautus",
"mc.connect": "Yhdistä",
"mc.contacts": "Yhteystiedot",
"mc.country": "Maa",
"mc.declareFound": "Ilmoita löytyneestä esineestä",
"mc.declareFoundSub": "Julkaise löytämäsi esine",
"mc.declareLost": "Ilmoita katoamisesta",
"mc.declareLostSub": "Julkaise kadonneen esineen ilmoitus",
"mc.deleteAccount": "Poista tili",
"mc.deleteConfirm": "Kyllä, poista tilini",
"mc.deleteConfirmBody": "Tilisi poistetaan pysyvästi ja henkilökohtaiset tietosi anonymisoidaan. Tätä toimintoa ei voida peruuttaa.",
"mc.deleteConfirmTitle": "Poista tili?",
"mc.deleteDesc": "Poistaa tilisi pysyvästi ja anonymisoi henkilötietosi. Tätä toimintoa ei voi peruuttaa.",
"mc.deleted": "Tilisi on poistettu.",
"mc.deleting": "Poistetaan…",
"mc.email": "Sähköposti",
"mc.expiresOn": "Erääntyy",
"mc.exportData": "Lataa tietoni (GDPR)",
"mc.exportDone": "Tietosi on ladattu.",
"mc.exporting": "Valmistellaan…",
"mc.finderAccepted": "Hyväksytty",
"mc.finderProfile": "Finder-profiili (valinnainen)",
"mc.finderProfileDesc": "Ansaitse pisteitä palauttamalla esineitä ja näy julkisella sijoituslistalla.",
"mc.forYourAd": "Ilmoitustasi varten",
"mc.forgotLink": "Unohditko salasanan?",
"mc.forgotSend": "Lähetä linkki",
"mc.forgotSent": "Jos tälle sähköpostille on olemassa tili, palautuslinkki on juuri lähetetty.",
"mc.forgotTitle": "Unohdin salasanan",
"mc.foundAdsNone": "Ei löytynyt kohteen ilmoitusta julkaistu.",
"mc.foundAt": "Löydetty",
"mc.foundNone": "Ei ilmoitettuja löytyneitä esineitä.",
"mc.hAd": "Kadonnut ilmoitus",
"mc.hDeclaration": "Ilmoitus",
"mc.hFinderContact": "Ilmoitettu esine",
"mc.hFound": "Palautettu esine",
"mc.hFoundAd": "Löydetty ilmoitus",
"mc.histEarned": "Esine palautettu",
"mc.historyTitle": "Pistehistoriani",
"mc.loginBtn": "Kirjaudu sisään",
"mc.loginTitle": "Asiakastili",
"mc.logout": "Kirjaudu ulos",
"mc.lostAt": "Kadonnut",
"mc.matchPartner": "Kumppanilla",
"mc.matchPublic": "Löytynyt esine",
"mc.matches": "Ottaumat",
"mc.matchesSub": "Löydetyt esineet voivat vastata kadonneiden ilmoitustesi sisältöä.",
"mc.myAds": "Kadonneet ilmoitukseni",
"mc.myDeclarations": "Ilmoitukseni",
"mc.myFinds": "Löydetyt esineeni",
"mc.myFindsNone": "Et ole vielä ilmoittanut löytäneesi mitään esinettä.",
"mc.myFindsSub": "Esineet, jotka olet ilmoittanut löytäneesi kadonneista ilmoituksista.",
"mc.myFound": "Ilmoitetut löydetyt esineet",
"mc.myFoundAds": "Löydetyt ilmoitukseni",
"mc.myRewards": "Vouchersi",
"mc.name": "Koko nimi",
"mc.newPassword": "Uusi salasana",
"mc.none": "Ei vielä ilmoitusta.",
"mc.notEnough": "Ei tarpeeksi pisteitä",
"mc.notifEmpty": "Ei vielä ilmoituksia.",
"mc.notifOpen": "Näytä",
"mc.notifTitle": "Ilmoitukset",
"mc.notifTrack": "Seuraa",
"mc.notifViewAd": "Katso ilmoitusta",
"mc.optInDesc": "Valinnainen osallistuminen. Suostut näyttämään julkisesti alla valitut esineet. Vaihdettavissa milloin tahansa.",
"mc.optInTitle": "Näy julkisella sijoituslistalla",
"mc.password": "Salasana",
"mc.passwordMismatch": "Salasanat eivät täsmää.",
"mc.phone": "Puhelin",
"mc.photoUpdated": "Profiilikuva päivitetty",
"mc.pointsAwaiting": "Pisteet odottavat",
"mc.pointsBalance": "Käytettävissä olevat pisteet",
"mc.pointsOk": "Pisteet hyvitetty",
"mc.presentHint": "Näytä tämä QR-koodi kumppanille: he skannaavat sen vahvistaakseen palkkiosi.",
"mc.presentInStore": "Näytä myymälässä",
"mc.presentTitle": "Näytä tämä kuponki",
"mc.privacy": "Yksityisyys & tiedot",
"mc.privacyDesc": "Lataa kopio kaikista henkilökohtaisista tiedoista, joita Findloop hallussaan pitää (GDPR, art. 15 & 20).",
"mc.profileSaved": "Profiili päivitetty.",
"mc.profileSettings": "Julkinen profiili & johtotaulu",
"mc.pseudo": "Etunimi tai lempinimi",
"mc.redExpired": "Vanhentunut",
"mc.redReady": "Näytä kumppanilla",
"mc.redUsed": "Käytetty",
"mc.redeem": "Hyväksy",
"mc.registerBtn": "Luo tili",
"mc.registerTitle": "Luo asiakastili",
"mc.rememberMe": "Muista minut",
"mc.remove": "Poista",
"mc.resetDone": "Salasana päivitetty. Voit nyt kirjautua sisään.",
"mc.resetExpired": "Tämä nollauslinkki on virheellinen tai vanhentunut. Pyydä uutta alla.",
"mc.resetSave": "Nollaa salasanani",
"mc.resetTitle": "Uusi salasana",
"mc.restitutionConfirmed": "Palautus vahvistettu.",
"mc.reward": "Palkinto",
"mc.rewardRedeemed": "Palkinto avattu! Koodi:",
"mc.rewardsDesc": "Käytä pisteitäsi kumppaneidemme tarjoamiin etuihin. Saldo:",
"mc.rewardsNone": "Ei vielä saatavilla olevaa palkintoa.",
"mc.rewardsTitle": "Käytä pisteitäni",
"mc.scoreAwarded": "Hyvin tehty! +1 Finder Scoreesi 🎉",
"mc.scoreEarned": "Piste saatu",
"mc.scorePts": "p",
"mc.scoreThisYear": "Tänä vuonna",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Näytä johtotaulu",
"mc.share": "Jaa",
"mc.statsTitle": "Tilastot",
"mc.subtitle": "Seuraa kaikki raporttisi yhdessä paikassa.",
"mc.title": "Omat tietoni",
"mc.toLogin": "Oletko jo rekisteröitynyt?",
"mc.toRegister": "Ei vielä tiliä?",
"mc.track": "Seuraa",
"mc.views": "Näytöt",
"mc.visCity": "Kaupunki",
"mc.visCountry": "Maa",
"mc.visLabel": "Johtotaulussa näkyvät kohteet:",
"mc.visName": "Etunimi / lempinimi",
"mc.visPhoto": "Profiilikuva",
"mc.welcome": "Hei",
"mc2.acceptFinder": "Hyväksy tämä löytö",
"mc2.accountActivity": "Tilitoiminta",
"mc2.adsActive": "{n}/5 aktiivista ilmoitusta",
"mc2.autoDelete": "Automaattinen poistaminen ajoitettu",
"mc2.badgeBronze": "Pronssi",
"mc2.badgeGold": "Kulta",
"mc2.badgeSilver": "Hopea",
"mc2.boostEarnedAlready": "Se on jo tuottanut sinulle",
"mc2.boostEarnedWin": "Se teki sinulle",
"mc2.boostExpiredWin": "Tehosteesi on juuri vanhentunut — jatka -20%:lla!",
"mc2.boostExpiresIn": "Tehosteesi vanhenee",
"mc2.boostWinDetail2": ". -20% sovelletaan automaattisesti, jos uusit 24 tunnin sisällä.",
"mc2.claimCode": "Vaatimuskoodi:",
"mc2.codeSentFinder": "Koodi lähetetty löytöön sähköpostitse",
"mc2.daysShort": "{n} p",
"mc2.downloadReceipt": "Lataa kuitini",
"mc2.error": "Virhe {status}",
"mc2.finderAccepted": "Finder hyväksytty — koodi lähetetty sähköpostitse",
"mc2.finderContacts": "Finderin yhteystiedot",
"mc2.followFindo": "Seuraa Findloop",
"mc2.imgInvalid": "Virheellinen kuva",
"mc2.inactivityNote": " — jos {n} kuukautta toimimattomuutta (GDPR).",
"mc2.lastActivity": "Viimeisin aktiviteetti:",
"mc2.lostEmailTitle": "Minulla ei enää ole pääsyä sähköpostiini",
"mc2.noPhotoPreset": "Ei kuvaa vielä? Valitse oletus avatar:",
"mc2.paidViaPartner": "Maksettu (kumppanin kautta)",
"mc2.payRecovery": "Maksa palautusmaksu",
"mc2.paySettle": "Maksa maksuni",
"mc2.payShipping": "Maksa toimitusmaksu",
"mc2.payUnavailable": "Maksu ei saatavilla",
"mc2.peopleFound": "{n} henkilö(t) uskoo löytäneensä esineesi",
"mc2.phoneNumber": "Puhelinnumero",
"mc2.reactivateAccount": "Aktivoi tilini uudelleen",
"mc2.reactivated": "Tili aktivoitu uudelleen",
"mc2.reactivatedThanks": "Tili aktivoitu uudelleen — kiitos uskollisuudestasi!",
"mc2.recoverSmsBtn": "Hanki koodi SMS:llä",
"mc2.recoverSmsDesc": "Saat vaatimuskoodisi SMS:llä rekisteröityyn numeroosi.",
"mc2.recoverSmsFallback": "Jos tili on olemassa tämän numeron kanssa, SMS on lähetetty.",
"mc2.renewStayTop": ". Uudista pysyäksesi huipulla ja palauttaaksesi esineesi.",
"mc2.resume20": "Jatka -20%",
"mc2.unlockContacts": "Vapauta yhteystiedot",
"mc2.unlockDesc": "Maksa findon käsittelymaksu paljastaaksesi heidän yhteystietonsa ja järjestääksesi luovutuksen.",
"mc2.viewsWord": "näyttöä",
"mc2.live": "Live",
"mh.allCategories": "Kaikki kategoriat",
"mh.allPeriod": "Kaikki ajat",
"mh.autoMatch": "Automaattinen AI-ottelu",
"mh.blocked": "Estetty (ristiriita)",
"mh.blockedReason": "Ottelu estetty: esineen pääavainsanat ja ilmoitus ovat ristiriidassa keskenään.",
"mh.days30": "Viimeiset 30 päivää",
"mh.days7": "Viimeiset 7 päivää",
"mh.days90": "Viimeiset 90 päivää",
"mh.emptyDesc": "AI-ottelut näkyvät täällä, kun ilmoituksia tulee sisään.",
"mh.emptyTitle": "Ei tapahtumia",
"mh.exportCsv": "Vie CSV",
"mh.exportDone": "CSV-vientisi ladattu",
"mh.exportImpossible": "Vienti epäonnistui",
"mh.fBlocked": "Estetty",
"mh.fConfirmed": "Vahvistettu",
"mh.fRejected": "Hylätty",
"mh.objectLabel": "Esine:",
"mh.refresh": "Päivitä",
"mh.rejected": "Hylätty",
"mh.srcManual": "Manuaalinen",
"mh.srcText": "Teksti",
"mh.srcVisual": "Visuaalinen (kuva)",
"mh.subtitle": "AI:n ehdottamien ottelujen loki — automaattisesti ottelut, vahvistetut ja hylätyt.",
"mh.title": "AI Historia",
"nav.ads": "Löydetyt esineet",
"nav.dashboard": "Oma tila",
"nav.found": "Löydetyt esineet",
"nav.how": "Miten se toimii",
"nav.login": "Kirjaudu sisään",
"nav.map": "Kartta",
"nav.more": "Lisää",
"nav.partners": "Kumppanit",
"nav.pricing": "Hinnoittelu",
"nav.ranking": "Parhaat",
"nav.register": "Liity kumppaniksi",
"nav.track": "Seuraa ilmoitusta",
"nf.desc": "Etsimääsi sivua ei ole olemassa tai se on siirretty.",
"nf.home": "Takaisin etusivulle",
"nf.title": "Sivua ei löytynyt",
"par.allCities": "Kaikki kaupungit",
"par.allCountries": "Kaikki maat",
"par.badge": "Hakemisto",
"par.certified": "Vahvistettu",
"par.certifiedBadge": "Vahvistettu",
"par.cityPh": "Kaupunki",
"par.declare": "Ilmoita",
"par.none": "Kumppania ei löytynyt.",
"par.partnerBadge": "Kumppani",
"par.searchPh": "Etsi toimipistettä…",
"par.subtitle": "Löydä toimipiste, jossa kadotit esineesi ja ilmoita menetyksestäsi.",
"par.title": "Kumppanimme",
"pay.addr1": "Osoite",
"pay.addr2": "Osoite rivi 2 (valinnainen)",
"pay.addrIncomplete": "Täytä toimitusosoite.",
"pay.badge": "Palautus",
"pay.card": "Maksaa kortilla",
"pay.city": "Kaupunki",
"pay.country": "Maa",
"pay.eurNote": "Näytetyt summat euroina (€).",
"pay.fee": "Palautusmaksu",
"pay.free": "ilmainen",
"pay.howRecover": "Miten haluaisit saada esineesi takaisin?",
"pay.momo": "Maksaa Mobile Money -palvelulla",
"pay.momoConfirm": "Vahvista maksu",
"pay.noMatch": "Tälle ilmoitukselle ei ole vielä vahvistettu vastaavaa esinettä.",
"pay.notfound": "Ilmoitusta ei löytynyt.",
"pay.phonePh": "Puhelinnumero",
"pay.pickup": "Nouta henkilökohtaisesti",
"pay.pickupDesc": "Paikasta",
"pay.postal": "Postinumero",
"pay.secure": "Turvallinen maksu",
"pay.serviceFee": "Findloop palvelumaksu",
"pay.ship": "Lähetä se minulle",
"pay.shipAfter": "— tarjotaan maksun jälkeen.",
"pay.shipDesc": "Toimitus osoitteeseeni",
"pay.shipNote": "Toimitus saatavilla",
"pay.shipping": "Toimitusmaksu",
"pay.subtitleWith": "Maksa palautusmaksu",
"pay.title": "Palauta esineeni",
"pay.total": "Yhteensä",
"pcat.city_hall": "Kaupungintalot",
"pcat.hotel": "Hotellit",
"pcat.other": "Muut",
"pcat.park": "Puistot",
"pcat.prefecture": "Prefektuutit",
"pcat.restaurant": "Ravintolat",
"pcat.uncategorized": "Luokittelematon",
"pd.about": "Tietoa",
"pd.back": "Kaikki kumppanit",
"pd.certified": "Vahvistettu kumppani",
"pd.declare": "Ilmoita menetys täällä",
"pd.itemsReturned": "palautetut tavarat",
"pd.itemsTotal": "rekisteröidyt tavarat",
"pd.map": "Sijainti",
"pd.noItems": "Ei löytynyt tavaroita viime aikoina.",
"pd.noReviews": "Ei arvioita vielä.",
"pd.notFound": "Kumppania ei löytynyt.",
"pd.recentItems": "Äskettäin löytyneet tavarat",
"pd.reply": "Vastaus toimipisteeltä",
"pd.reviews": "Asiakasarviot",
"pd.verified": "Vahvistettu arvio",
"pd.verifiedEstablishment": "Findloop vahvistettu toimipiste",
"pg.next": "Seuraava",
"pg.prev": "Edellinen",
"pg.showing": "{from}–{to} yhteensä {total}",
"pk.bodyCopy": "Tekstisisältö",
"pk.bodyText": "Kehote",
"pk.brandColors": "Brändivärit",
"pk.colorRed": "Punainen",
"pk.colorWhite": "Valkoinen",
"pk.darkBg": "Tumma tausta",
"pk.download": "Lataa",
"pk.downloadZip": "Lataa koko paketti (ZIP)",
"pk.headings": "Otsikot",
"pk.heroDesc": "Viralliset logot, sosiaalisen median bannerit, värit ja typografia. Valitse iskulauseen kieli ja versio, ja lataa sitten visuaali tai koko paketti.",
"pk.lightBg": "Vaalea tausta (paino)",
"pk.logoWordmark": "Logo / sanamerkki",
"pk.logosVisuals": "Logot & visuaalit",
"pk.mapCollect": "Kartta / keräyspisteet",
"pk.plain": "Yksinkertainen",
"pk.pressKit": "Lehdistötiedote",
"pk.taglineLang": "Iskulauseen kieli",
"pk.typography": "Typografia",
"pk.variant": "Versio",
"pr.shipBtn": "Toimitetaan tavara",
"pr2.adBoostMsg": "Hyvä valinta! Moninkertaistat mahdollisuutesi löytää tavarasi nopeasti.",
"pr2.boostActivated": "Tehostus aktivoitu!",
"pr2.canRecoverNow": "Voit nyt löytää tavarasi.",
"pr2.continue": "Jatka",
"pr2.downloadReceiptPdf": "Lataa kuitti (PDF)",
"pr2.goToSpaceNow": "Siirry tiliini nyt",
"pr2.partnerBoostMsg": "Hyvä valinta! Lisää näkyvyyttä tarkoittaa uusien asiakkaiden houkuttelemista toimipisteeseesi.",
"pr2.paymentSuccess": "Maksu onnistui!",
"pr2.redirectingSpace": "Siirretään tilillesi…",
"pr2.subActivated": "Maksu onnistui! Tilauksesi on aktiivinen, nyt voit hallita toimipisteitäsi.",
"prev.allSites": "Kaikki toimipisteet",
"prev.editReply": "Muokkaa vastausta",
"prev.none": "Ei arvioita vielä.",
"prev.published": "Vastaus julkaistu",
"prev.reply": "Vastaus",
"prev.replyPh": "Kirjoita kohtelias vastaus…",
"prev.send": "Julkaise vastaus",
"prev.sending": "Julkaistaan…",
"prev.yourReply": "Vastauksesi",
"pricing.annual": "Vuosimaksu",
"pricing.annualBadge": "-20% tarjous",
"pricing.choose": "Valitse",
"pricing.compareFeature": "Ominaisuus",
"pricing.compareTitle": "Vertaile suunnitelmia",
"pricing.eyebrow": "Hinnoittelu",
"pricing.month": "/kk",
"pricing.monthly": "Kuukausittain",
"pricing.perYear": "/v",
"pricing.popular": "Suosittu",
"pricing.quoteMsg": "Tarpeesi (valinnainen)",
"pricing.quoteOrg": "Organisaatio",
"pricing.quoteSend": "Lähetä pyyntö",
"pricing.quoteSent": "Pyyntö lähetetty! Otamme sinuun pian yhteyttä.",
"pricing.quoteSites": "Sivustojen / päätelaitteiden määrä",
"pricing.quoteTitle": "Pyydä tarjous",
"pricing.requestQuote": "Pyydä tarjous",
"pricing.saveLabel": "Säästät",
"pricing.savePerYear": "/v per lisäliike",
"pricing.start": "Aloita",
"pricing.subtitle": "Aloita ilmaiseksi, skaalaa kasvun myötä.",
"pricing.title": "Suunnitelma jokaiselle organisaatiolle",
"promo.badge": "Kumppaniohjelma",
"promo.cta": "Lue lisää",
"promo.text": "Jokaisesta kumppanista, jonka suosittelet ja joka tilaa, saat yhden ilmaisen kuukauden. Ei rajoituksia.",
"promo.title": "Suosittele kumppania, saat ilmaisen kuukauden.",
"pub.accessGranted": "Pääsy myönnetty",
"pub.accessLimited2h": "Pääsy rajoitettu 2 tuntiin",
"pub.accountEmailConcerned": "Huolehtivan tilin sähköposti",
"pub.adAppearPublic": "Näin ilmoituksesi näkyy julkisesti.",
"pub.adPreviewBtn": "Ilmoituksen esikatselu",
"pub.alertMeOnArrival": "Ilmoita minulle saapumisesta",
"pub.allActionsLogged": "Kaikki toimet on kirjattu",
"pub.allCategories": "Kaikki kategoriat",
"pub.authorizeAccess": "Hyväksy pääsy",
"pub.authorizeSupportQ": "Hyväksy tukipääsy?",
"pub.available": "Saatavilla",
"pub.backHome": "Takaisin kotiin",
"pub.boostAdCta": "Korota ilmoitustani",
"pub.boostAdTitle": "Korota ilmoitustasi",
"pub.boostCarouselSub": "Siirry sivun yläosaan 'Korotetut' -karusellissa ja moninkertaista näyttökerrat saadaksesi kohteesi nopeasti takaisin.",
"pub.boostEstablishment": "Korota yrityksesi",
"pub.boostEstablishmentDesc": "Näy hakemistossa ylimpänä 'Korotettu' -merkillä ja houkuttele lisää ilmoituksia.",
"pub.boostFicheCta": "Korota ilmoitustani",
"pub.brandReady": "findloop-brändi, valmis käyttöön",
"pub.cantFindItem": "Et löydä kohteesi?",
"pub.cantProcessImage": "Kuvan käsittely epäonnistui",
"pub.claimQr": "Vaatimuksesi QR-koodi",
"pub.clickToZoom": "Napsauta zoomataksesi",
"pub.codeAlreadyValidated": "Koodi validoitu — kontaktit avattu.",
"pub.codeExample": "esim. ABCD2345",
"pub.confirmRenewal": "Vahvista uusiminen",
"pub.contactIntro": "Kysymys, pyyntö? Kirjoita meille, otamme sinuun pian yhteyttä.",
"pub.contactTypeDeceased": "Tilin poistaminen (vainaja)",
"pub.contactTypeGeneral": "Yleinen kysymys",
"pub.contactTypeSupport": "Tuki / tekninen ongelma",
"pub.contactUs": "Ota yhteyttä",
"pub.continueWithoutEmail": "Jatka ilman sähköpostin jättämistä",
"pub.contractLabel": "Sopimus",
"pub.contractNotFound": "Sopimusta ei löytynyt tai se on jo vanhentunut.",
"pub.contractRenewed": "Sopimus uusittu!",
"pub.contractRenewedFor": "Sopimuksesi on uusittu {n} kuukaudeksi.",
"pub.copyFailed": "Kopiointi epäonnistui",
"pub.createPartnerAccount": "Luo kumppanitilini",
"pub.currentDeadline": "Nykyinen määräaika",
"pub.deceasedInfo": "Läheisenä tai perillisenä voit pyytää vainajan findloop-tilin poistamista. Käsittelemme pyyntösi GDPR:n mukaisesti (tukiasiakirjoja saatetaan pyytää).",
"pub.declareMyLoss": "Ilmoita tappiostani",
"pub.describeItemPlaceholder": "Kuvaile esineesi (esim. musta sateenvarjo, avaimet…)",
"pub.downloadImage": "Lataa kuva",
"pub.drawSignature": "Ole hyvä ja piirrä allekirjoituksesi.",
"pub.drawSignatureHint": "Piirrä allekirjoituksesi hiirellä tai sormella.",
"pub.duration": "Kesto",
"pub.eSignature": "Sähköinen allekirjoitus",
"pub.eSignatureDesc": "Syötä nimesi allekirjoittaaksesi. Päivämäärä tallennetaan automaattisesti.",
"pub.edit": "Muokkaa",
"pub.editorialTitles": "Toimitukselliset otsikot",
"pub.emailPlaceholder": "sinä@esimerkki.com",
"pub.enterCodeUnlockOwner": "Syötä sähköpostitse saatu koodi omistajan yhteystietojen avaamiseksi.",
"pub.errorWord": "Virhe",
"pub.foundSelfService": "Löydetyt esineet · Itsepalvelu",
"pub.haveOwnerCode": "Sain koodin omistajalta",
"pub.home": "Koti",
"pub.immediateRenewal": "Välitön uusiutus, ilman uutta tarjouspyyntöä.",
"pub.impAdminReq1": "Ylläpitäjä",
"pub.impAdminReq2": "pyytää lupaa tilapäisesti käyttää tiliäsi",
"pub.impAdminReq3": "auttaakseen sinua.",
"pub.impGrantedDesc": "Tukitiimi voi käyttää tiliäsi enintään 2 tuntia. Jokainen toiminto tallennetaan. Voit sulkea tämän sivun.",
"pub.invitedOnFindo": "Olet kutsuttu findoon",
"pub.isThisYourItem": "Onko tämä sinun esineesi?",
"pub.itemsAvailableCount": "{n} esine(t) tällä hetkellä saatavilla",
"pub.itemsFoundOwner": "luovutetuista esineistä löytyi omistaja",
"pub.itemsReturnedOwners": "esineet palautettu omistajille",
"pub.itsMine": "Se on minun",
"pub.joinFindoDesc": "Liity findoon ja hallinnoi löytämisiäsi vaivattomasti.",
"pub.joinInvitesYou": "kutsuu sinut liittymään findoon. Luo kumppanitili hallitaksesi löytämisiäsi.",
"pub.linkCopied": "Linkki kopioitu!",
"pub.loadingContract": "Ladataan sopimusta…",
"pub.lsClaimDesc": "Ilmoita menetyksesi saadaksesi se takaisin. Jätä sähköpostisi, niin lähetämme sinulle muistutuksen, jos ilmoituksesi ei ole valmis.",
"pub.lsHeroDesc": "Tarkista itse, onko kadonnut esineesi löytynyt ja jätetty tänne. Löysitkö sen? Ilmoita se saadaksesi se takaisin.",
"pub.lsSearchTitle": "Etsi löydettyjä esineitä",
"pub.makeOffer": "Tee tarjous",
"pub.makeOfferDesc": "Ehdota omaa summaasi. Superadmin tarkistaa sen.",
"pub.mapNearYou": "Esineet & kumppanit lähelläsi",
"pub.mapWord": "Kartta",
"pub.messageSentToast": "Viesti lähetetty — tiimimme vastaa pian.",
"pub.messageWord": "Viesti",
"pub.momoInitiated": "Mobiilimaksu aloitettu",
"pub.monthsWord": "kuukautta",
"pub.nameConsentRequired": "Nimi ja suostumus vaaditaan.",
"pub.newDeadline": "Uusi määräaika",
"pub.noActionRequired": "Ei toimenpiteitä vaadita.",
"pub.noAmountCharged": "Maksua ei ole peritty.",
"pub.noItemMatch": "Käytettävissä ei ole esinettä, joka vastaa hakua tällä hetkellä.",
"pub.noMatchingItem": "Ei vastaavaa esinettä",
"pub.noPaymentSession": "Ei maksusessiota.",
"pub.noPhoto": "Ei kuvaa",
"pub.noPointsYet": "Ei vielä näytettäviä pisteitä.",
"pub.noSecondPayment": "Tälle esineelle ei tarvita toista maksua.",
"pub.notHereYet": "Ei vielä täällä? Saat ilmoituksen, kun se saapuu.",
"pub.notifyDone": "Huomioitu! Ilmoitamme sinulle sähköpostitse, kun vastaava esine saapuu.",
"pub.offerSubmitted": "Tarjouksesi on lähetetty.",
"pub.oops": "Hups",
"pub.orAlertEmail": "Tai saat ilmoituksen sähköpostitse, kun vastaava esine saapuu:",
"pub.ownerContacts": "Omistajan yhteystiedot",
"pub.ownerContactsUnlocked": "Omistajan yhteystiedot avattu",
"pub.partnerContact": "Kumppanin yhteystieto",
"pub.payLinkUnavailable": "Maksulinkki ei saatavilla — ota yhteys kumppaniin.",
"pub.paymentCancelled": "Maksu peruutettu",
"pub.paymentConfirmed": "Maksu vahvistettu 🎉",
"pub.paymentConfirmedDesc": "Saat sähköpostin, jossa on tiedot esineesi palauttamisesta.",
"pub.paymentNotConfirmed": "Maksua ei vahvistettu",
"pub.paymentNotConfirmedDesc": "Maksua ei voitu vahvistaa. Yritä uudelleen tai ota yhteyttä kumppaniin.",
"pub.paymentProcessing": "Maksua käsitellään. Päivitä hetken kuluttua.",
"pub.photoAdded": "✓ Kuva lisätty",
"pub.photoRequired": "Esineestä on toimitettava kuva.",
"pub.previewAlt": "esikatselu",
"pub.publish": "Julkaise",
"pub.publishingWord": "Julkaistaan…",
"pub.qty": "Määrä",
"pub.quoteDeclined": "Tarjous evätty.",
"pub.quoteNotFound": "Tarjousta ei löytynyt tai se on vanhentunut.",
"pub.reasonLabel": "Syytä",
"pub.recoveryAlreadyPaid": "Palautusmaksu on jo maksettu",
"pub.referralCode": "Suosituskoodi:",
"pub.relationshipPlaceholder": "Poika, puoliso, notaari…",
"pub.renewYourContract": "Uudista sopimuksesi",
"pub.renewalFailed": "Uudistus epäonnistui. Yritä myöhemmin uudelleen.",
"pub.renewing": "Uudistetaan…",
"pub.replySoon": "Tiimimme vastaa mahdollisimman pian.",
"pub.requestGone": "Tätä pyyntöä ei enää ole.",
"pub.requestHandled": "Pyyntö käsitelty",
"pub.requestNotFound": "Pyyntöä ei löytynyt tai se on vanhentunut.",
"pub.requestUnavailable": "Pyyntö ei saatavilla",
"pub.required": "(pakollinen)",
"pub.retroClosing": "Yhdessä teemme maailmasta hieman vähemmän eksyneen.",
"pub.retroClosing2": "Yhdessä teemme maailmasta hieman vähemmän eksyneen.",
"pub.retroScroll": "Vuosi asioiden palauttamisesta. Rullaa alas ↓",
"pub.revokeAnytime": "Voit peruuttaa milloin tahansa ottamalla meihin yhteyttä",
"pub.scene": "Kohtaus",
"pub.sendImpossible": "Lähetys epäonnistui",
"pub.sendMessage": "Lähetä viesti",
"pub.sending": "Lähetetään…",
"pub.sharePreview": "Jaa esikatselu",
"pub.shareYourAd": "Jaa ilmoituksesi",
"pub.signedSuccess": "Allekirjoitettu onnistuneesti!",
"pub.signerFullName": "Allekirjoittajan koko nimi",
"pub.spreadNetwork": "Jaa se ympärilläsi oleville, jotta mahdollisuutesi paranevat.",
"pub.spreadOwner": "Jaa se auttaaksesi omistajaa palauttamaan omaisuutensa.",
"pub.statusLabel": "Tila:",
"pub.subject": "Aihe",
"pub.thanksSent": "Kiitos, viestisi on lähetetty.",
"pub.thisYear": "Tänä vuonna",
"pub.validate": "Vahvista",
"pub.verifyingPayment": "Maksua vahvistetaan…",
"pub.verifyingYourPayment": "Vahvistetaan maksua…",
"pub.viewAd": "Näytä ilmoitus →",
"pub.viewPartner": "Näytä kumppani →",
"pub.yourAdPreview": "Ilmoituksesi esikatselu",
"pub.yourEmail": "Sähköpostiosoitteesi",
"pub.yourEmailRecommended": "Sähköpostiosoitteesi (suositeltava)",
"pub.yourEmailShort": "Sähköpostisi",
"pub.yourName": "Nimesi",
"pub.yourRelationship": "Suhteesi henkilöön",
"qv.acceptAndSign": "Hyväksy ja allekirjoita tarjoukseni",
"qv.certifyAuthorized": "Vastaanotettuani, vakuutan, että olen valtuutettu allekirjoittamaan ja hyväksyn tämän {what} ehdot (sitova arvo).",
"qv.clear": "Tyhjennä",
"qv.client": "Asiakas",
"qv.conditions": "Ehdot",
"qv.confirmDecline": "Vahvista tämän tarjouksen hylkääminen?",
"qv.countersignedFindo": "Vahvistettu Findloop:n toimesta · {name} {date}",
"qv.decline": "Hylkää",
"qv.description": "Kuvaus",
"qv.downloadPdf": "Lataa PDF",
"qv.handwrittenSignature": "Käsinkirjoitettu allekirjoitus",
"qv.inclTax": "Sis. alv",
"qv.invalidAmount": "Virheellinen summa.",
"qv.invoice": "Lasku",
"qv.invoicePaid": "Lasku maksettu",
"qv.issuer": "Myöntäjä",
"qv.messageOptional": "Viesti (valinnainen)",
"qv.negotiatedAmount": "Neuvoteltu summa",
"qv.payInvoiceOnline": "Maksa lasku verkossa",
"qv.quote": "Tarjous",
"qv.quoteValidDays": "Tarjous voimassa {n} päivää.",
"qv.sendMyOffer": "Lähetä tarjous",
"qv.signContract": "Allekirjoita sopimus",
"qv.signNow": "Allekirjoita nyt",
"qv.signatureAlt": "Allekirjoitus",
"qv.signedByOn": "✔ Allekirjoitettu {name} {date}",
"qv.stContractSigned": "Sopimus allekirjoitettu. Kiitos!",
"qv.stCounterAccepted": "Tarjouksesi on hyväksytty! Allekirjoita sopimuksesi alla.",
"qv.stCounterRefused": "Tarjouksesi ei voitu hyväksyä.",
"qv.stCountered": "Tarjouksesi on lähetetty. Odotetaan Findloop:n vastausta.",
"qv.stDeclined": "Olet hylännyt tämän tarjouksen.",
"qv.stSigned": "Tarjous hyväksytty ja allekirjoitettu. Kiitos!",
"qv.totalHt": "Yhteensä ilman alv",
"qv.totalTtc": "Yhteensä sis. alv",
"qv.unitHt": "Yksikkö ilman alv",
"qv.vat": "ALV",
"qv.yourProposedAmount": "Ehdottamasi summa ({cur})",
"rate.chooseNote": "Valitse arvio.",
"rate.commentPh": "Kommentti (valinnainen)…",
"rate.home": "Takaisin etusivulle",
"rate.submit": "Lähetä arvostelu",
"rate.submitting": "Lähetetään…",
"rate.subtitle": "Miten tavarasi palautus sujui?",
"rate.successText": "Palaute auttaa muita käyttäjiä.",
"rate.successTitle": "Kiitos arvostelustasi!",
"rate.title": "Arvioi kokemuksesi",
"reg.add": "Kirjaa esine",
"reg.allBrands": "Kaikki merkit",
"reg.allColors": "Kaikki värit",
"reg.allLocations": "Kaikki paikat",
"reg.detailDesc": "Yksityiskohdat ja toimenpiteet tälle löydetylle esineelle.",
"reg.dispAuction": "Huuto",
"reg.dispAuthorities": "Luovutettu viranomaisille",
"reg.dispDestroyed": "Tuhoettu",
"reg.dispDonate": "Hyväntekeväisyyslahjoitus",
"reg.dispositionHint": "Kirjaa esine varastosta poistettavaksi. Lasketaan tilastoissa kategoriattain.",
"reg.emptyCta": "Kirjaa esine",
"reg.emptyDesc": "Aloita kirjaamalla ensimmäinen löytämäsi esine.",
"reg.emptyTitle": "Esineitä ei löytynyt",
"reg.establishmentFallback": "liiketoiminta",
"reg.lblAuctioned": "huutokaupassa",
"reg.lblAuctionedShort": "huutokaupattu",
"reg.lblAuthorities": "luovutettu viranomaisille",
"reg.lblDestroyed": "tuhoettu",
"reg.lblDonated": "lahjoitettu hyväntekeväisyyteen",
"reg.legalCount": "{n} kappaletta: laillinen säilytysaika on saavutettu",
"reg.legalHint": "Voit myydä ne huutokaupassa, lahjoittaa ne hyväntekeväisyyteen tai ilmoittaa niiden luovuttamisesta viranomaisille.",
"reg.legalLimitCountry": "Määräaika: {date} · sovellettava maa: {country}",
"reg.legalOver": "Määräaika umpeutunut: {date} · {country}",
"reg.legalReached": "Laillinen aika saavutettu",
"reg.legalReachedFull": "Laillinen säilytysaika on saavutettu",
"reg.limitShort": "määräaika",
"reg.location": "Sijainti",
"reg.markRestituted": "Merkitse palautetuksi",
"reg.markedAs": "Kappale merkitty nimellä {label}",
"reg.moveHistory": "Liiketiedot",
"reg.overBy": "ylittää {n} päivää",
"reg.physicalLocation": "Fyysinen sijainti",
"reg.popupBlocked": "Salli ponnahdusikkunat etikettien tulostamista varten.",
"reg.popupBlockedOne": "Salli ponnahdusikkuna etikettien tulostamista varten.",
"reg.printLabel": "Tulosta etiketti",
"reg.printN": "Tulosta {n} etikettiä",
"reg.qrCodeItem": "Kappaleen QR-koodi",
"reg.qrLabelTitle": "QR-etiketti",
"reg.qrLabelsTitle": "QR-etiketit",
"reg.qrNotFound": "Tätä QR-koodia ei löytynyt.",
"reg.qrScanHint": "Skannaa se avatakseesi tämän tiedoston suoraan ja löytääksesi sijainnin.",
"reg.recoveryFee": "Palautusmaksu (€)",
"reg.searchPh": "Etsi kuvauksen mukaan…",
"reg.selectQr": "Valitse tulostaaksesi QR-etikettejä",
"reg.selectedN": "{n} valittua",
"reg.shipPricePh": "Toimitushinta (€)",
"reg.shippingPossible": "Toimitus mahdollista",
"reg.storagePh": "esim. Hylly A3, Lokero 12",
"reg.tAuction": "Huutokauppa findossa",
"reg.tAuthorities": "Ilmoita viranomaisille",
"reg.tDonate": "Lahjoita hyväntekeväisyyteen",
"reg.toastFee": "Maksu päivitetty",
"reg.toastLocation": "Sijainti tallennettu",
"reg.toastRestituted": "Kappale merkitty palautetuksi",
"reg.toastShipping": "Toimitusvaihtoehto päivitetty",
"reg.toastTransferred": "Kappale siirretty \"{name}\"",
"reg.unclaimedDisposition": "Vailla omistajaa oleva esine — lopullinen käsittely",
"res.codeValidated": "Koodi varmennettu",
"res.empty": "Palautuksia ei ole vielä kirjattu.",
"res.error": "Virhe {status}",
"res.proofPdf": "PDF-todistus",
"res.signed": "Allekirjoitettu",
"res.stRestituted": "Luovutettu henkilökohtaisesti",
"res.stShipped": "Palautettu lähetyksenä",
"res.subtitle": "Kaikki suoritetut luovutukset, joihin liittyvä allekirjoitettu todistus on ladattavissa.",
"res.title": "Palautushistoria",
"rev.b2b": "B2B-kumppanit",
"rev.b2c": "Asiakkaat",
"rev.based": "perustuu {n} arvioon",
"rev.eyebrow": "Asiakaspalautteet",
"rev.restitutedBy": "Palautettu {org} toimesta",
"rev.storiesEyebrow": "Onnelliset loput",
"rev.storiesSubtitle": "Todelliset tarinat asiakkailta, jotka saivat omistamansa tavarat takaisin findon avulla.",
"rev.storiesTitle": "He löysivät omistamansa tavarat!",
"rev.subtitle": "Kumppanit ja asiakkaat jakavat kokemuksiaan.",
"rev.title": "He luottavat findoon",
"rev.verified": "Vahvistettu",
"rp.already": "Olet jo ilmoittanut tästä ilmoituksesta.",
"rp.comment": "Yksityiskohdat (valinnainen)",
"rp.duplicate": "Kopio",
"rp.fraud": "Huijaus / petos",
"rp.inappropriate": "Sopimaton sisältö",
"rp.offensive": "Loukkava sisältö",
"rp.other": "Muu",
"rp.reason": "Syynä",
"rp.report": "Ilmoita",
"rp.send": "Lähetä ilmoitus",
"rp.sent": "Ilmoitus lähetetty. Kiitos panoksestasi.",
"rp.spam": "Roskaposti / mainonta",
"rp.title": "Ilmoita tämä ilmoitus",
"rp.wrongCategory": "Väärä kategoria",
"rt.annualGoal": "Vuositavoite",
"rt.championCity": "Voittajakaupunki",
"rt.cityRate": "{rate}% palautusprosentti",
"rt.goalProgress": "{rate}% saavutettu {target}% tavoitteesta",
"rt.reached": "Saavutettu 🎉",
"rt.restitutionRate": "Palautusprosentti",
"rt.shareRecap": "Jaa yhteenveto",
"rt.thanks": "Kiitos Findloop {year} 💛",
"rt.yourRecap": "Sinun {year} yhteenveto",
"rw.active": "Aktiivinen",
"rw.add": "Lisää",
"rw.camUnavailable": "Kamera ei ole käytettävissä. Syötä koodi manuaalisesti alla.",
"rw.codeValidated": "Koodi validoitu",
"rw.codesTitle": "Koodit, jotka etsijät ovat lunastaneet",
"rw.confirmDelete": "Poista “{title}”? ",
"rw.deleted": "Poistettu",
"rw.edit": "Muokkaa",
"rw.editReward": "Muokkaa palkkiota",
"rw.empty": "Ei vielä palkkiota.",
"rw.expired": "Vanhentunut",
"rw.expiresOn": "Vanhentuu {date}",
"rw.fActive": "Aktiivinen (näkyvissä etsijöille)",
"rw.fCost": "Hinta (pisteet)",
"rw.fDesc": "Kuvaus",
"rw.fStock": "Varasto (tyhjät = rajattomat)",
"rw.fTitle": "Otsikko",
"rw.fValidity": "Lahjakortin voimassaolo (päiviä lunastuksen jälkeen)",
"rw.inactive": "Passiivinen",
"rw.newReward": "Uusi palkkio",
"rw.noExchange": "Ei vielä lunastusta.",
"rw.pageSubtitle": "Skannaa etsijöiden esittämät lahjakortit palkkioidensa vahvistamiseksi.",
"rw.redeemedN": "Lunastettu: {n}×",
"rw.saved": "Palkkio tallennettu",
"rw.scanVoucher": "Skannaa lahjakortti",
"rw.staffScanOnly": "Skannaa vain",
"rw.statActive": "Esitettävänä",
"rw.statExpired": "Vanhentunut",
"rw.statRedeemed": "Lunastetut lahjakortit",
"rw.statUsed": "Vahvistettu",
"rw.stock": "Varasto",
"rw.subtitle": "Tarjoa ei-rahaetuja (lahjakortteja, parannuksia…) joita etsijät lunastavat Finder Score -pisteidensä vuoksi.",
"rw.title": "Palkkiot etsijöille",
"rw.used": "Käytetty",
"rw.validate": "Vahvista",
"rw.validateCode": "Vahvista koodi",
"rw.validity": "Voimassaolo: {n} p",
"shell.f1d": "Linkitä automaattisesti kadonneet ja löydetyt esineet.",
"shell.f1t": "Älykäs AI-matching",
"shell.f2d": "Seuraa palautusprosenttia ja tuloja reaaliajassa.",
"shell.f2t": "Ohjaamo & tulot",
"shell.f3d": "Asiakkaasi raportoivat 30 sekunnissa.",
"shell.f3t": "Yhteistyökumppanin QR-koodi",
"shell.title": "Muuta kadonneet esineet tyytyväisiksi asiakkaiksi.",
"ship.addr1": "Osoite",
"ship.addr2": "Osoiterivi 2 (valinnainen)",
"ship.badge": "Toimitus",
"ship.city": "Kaupunki",
"ship.country": "Maa",
"ship.needPaid": "Maksa ensin palautusmaksu pyytääksesi toimitusta.",
"ship.notShippable": "Tätä esinettä ei voida toimittaa.",
"ship.notfound": "Raporttia ei löytynyt.",
"ship.postal": "Postinumero",
"ship.price": "Toimitusmaksu",
"ship.submit": "Pyydä toimitusta",
"ship.submitting": "Lähetetään…",
"ship.subtitle": "Syötä toimitusosoitteesi.",
"ship.successText": "Yhteistyökumppani valmistaa pakettisi. Saat ilmoituksen, kun se on lähetetty.",
"ship.successTitle": "Toimituspyyntö lähetetty!",
"ship.title": "Toimita esineesi",
"ship.weight": "Arvioitu paino (kg)",
"shp.carrier": "Kuljettaja",
"shp.download": "Lataa PDF",
"shp.generating": "Luodaan…",
"shp.label": "Luo etiketti",
"shp.none": "Toimitusta ei ole pyydetty.",
"shp.setTracking": "Tallenna seuranta",
"shp.status": "Tila",
"shp.to": "Vastaanottaja",
"shp.tracking": "Seurantanro.",
"shp.trackingSaved": "Seuranta tallennettu",
"side.account": "Oma tili",
"side.declarations": "Raportit",
"side.deposit": "Kirjaa esine",
"side.establishments": "Yritykset",
"side.invoices": "Laskut",
"side.logout": "Kirjaudu ulos",
"side.matchHistory": "AI-historia",
"side.partner": "Yhteistyökumppani",
"side.refresh": "Päivitä",
"side.registry": "Rekisteri",
"side.restitutions": "Palautukset",
"side.reviews": "Arvostelut",
"side.rewards": "Palkinnot & Vouchers",
"side.settings": "Asetukset",
"side.shipments": "Toimitukset",
"side.stats": "Tilastot",
"side.storage": "Varasto & QR",
"side.team": "Tiimi",
"side.viewSite": "Näytä julkinen sivusto",
"st.auctioned": "Myyty huutokaupassa",
"st.claimed": "Vaatiminen",
"st.closed": "Suljettu",
"st.delivered": "Toimitettu",
"st.destroyed": "Tuhoettu",
"st.donated": "Lahjoitettu (hyväntekeväisyys)",
"st.handed_to_authorities": "Luovutettu viranomaisille",
"st.in_storage": "Varastossa",
"st.matched": "Osoite löydetty",
"st.open": "Avaa",
"st.paid": "Maksettu",
"st.pending": "Odottaa",
"st.resolved": "Ratkaistu",
"st.restituted": "Palautettu",
"st.second_chance": "Toinen mahdollisuus",
"st.shipped": "Lähetetty",
"st.shipping_requested": "Lähetys pyydetty",
"st.submitted": "Lähetetty",
"st.verified": "Vahvistettu",
"stat.items": "Rekisteröidyt esineet",
"stat.partners": "Kumppanit",
"stat.restituted": "Palautetut esineet",
"status.auctioned": "Huudettu",
"status.destroyed": "Tuhoettu",
"status.donated": "Lahjoitettu (hyväntekeväisyys)",
"status.handed_to_authorities": "Luovutettu viranomaisille",
"status.in_storage": "Varastossa",
"status.matched": "Osoite",
"status.open": "Avaa",
"status.paid": "Maksettu",
"status.pending": "Odottaa",
"status.restituted": "Palautettu",
"status.shipped": "Lähetetty",
"status.shipping_requested": "Lähetys pyydetty",
"status.submitted": "Lähetetty",
"step1.tag": "Laitos",
"step1.text": "Sekunnissa laitos rekisteröi löydetyn esineen valokuvalla, kategorialla ja kuvauksella. Kaikki on keskitetty selkeään, turvalliseen rekisteriin.",
"step1.title": "Kumppani rekisteröi esineen",
"step2.tag": "Asiakas",
"step2.text": "Kumppanin QR-koodin kautta asiakkaasi kuvaa kadonneen esineen 30 sekunnissa. Ei sovellusta asennettavaksi — kaikki tapahtuu selaimessa.",
"step2.title": "Asiakas ilmoittaa häviämisestä",
"step3.tag": "Älykkyys",
"step3.text": "Älykäs erittelymoottorimme vertaa kuvauksia ja ehdottaa todennäköisesti sopivimpia osumia, valmiina vahvistettavaksi.",
"step3.title": "AI yhdistää häviön ja löydetyn esineen",
"step4.tag": "Palautus",
"step4.text": "Turvallisen palautusmaksun jälkeen asiakas noutaa esineen paikan päältä — tai saa sen seurannassa olevana lähetyksenä.",
"step4.title": "Asiakas saa esineensä takaisin",
"stg.allLabels": "Kaikki QR-tunnisteet",
"stg.camHint": "Käytä alla olevaa manuaalista syötettä.",
"stg.camStarting": "Avaan kameraa…",
"stg.camUnavailable": "Kamera ei käytettävissä.",
"stg.clear": "Tyhjennä",
"stg.clearAll": "Tyhjennä kaikki",
"stg.codeUnreadable": "Lukematon koodi.",
"stg.emptyDesc": "Varastoidut esineet näkyvät täällä, ryhmiteltynä sijainnin mukaan.",
"stg.emptyTitle": "Ei esinettä varastossa",
"stg.exportAudit": "Vie tarkastus CSV",
"stg.exportDone": "CSV-vienti ladattu",
"stg.exportImpossible": "Vienti ei tällä hetkellä käytettävissä.",
"stg.itemFound": "Esine löydetty ✅",
"stg.kLocations": "Käytetyt sijainnit",
"stg.kObjects": "Varastoidut esineet",
"stg.kToClear": "Tyhjennettävät sijainnit",
"stg.locFreed": "Sijainti tyhjennetty",
"stg.locsFreed": "{n} sijainti(a) tyhjennetty",
"stg.manualLabel": "Tai syötä esineen koodi / ID",
"stg.manualPh": "Liitä QR:n ID tai URL",
"stg.noItemMatch": "Ei esinettä, joka vastaa tätä QR:ää / koodia.",
"stg.noLocation": "Ei sijaintia",
"stg.objectsAxis": "Esineet",
"stg.objectsN": "{n} esine(e)t",
"stg.occAvg": "keskimäärin {n} esinettä/sijainti",
"stg.occHint": "Oranssilla merkittyjen sijaintien määrä ylittää keskiarvon (mahdollisesti ylikuormitettu).",
"stg.occupancy": "Sijainnin käyttöaste",
"stg.openPage": "Avaa sivu",
"stg.posterPdf": "PDF-juliste (A4)",
"stg.printAll": "Tulosta kaikki",
"stg.printGroupTitle": "Tulosta tarrat tälle hyllylle",
"stg.qrAlt": "Itsepalvelu QR",
"stg.qrDownload": "Lataa QR",
"stg.qrHint": "Näytä tämä QR tiskillä: asiakkaasi skannaavat sen tarkistaakseen, onko heidän esineensä saatavilla.",
"stg.qrTitle": "Asiakkaan itsepalvelu QR",
"stg.scanDesc": "Skannaa esineen etiketti avataksesi sen tiedot heti.",
"stg.scanQr": "Skannaa QR",
"stg.scanTitle": "Skannaa QR-koodi",
"stg.search": "Etsi",
"stg.shelf": "Hylly {loc}",
"stg.shelfPlan": "Hyllysuunnitelma",
"stg.staleHint": "Tyhjennä nämä sijainnit, jotta fyysinen varastosi pysyy ajan tasalla.",
"stg.staleTitle": "{n} esine(e)t ovat poistuneet varastosta, mutta pitävät edelleen sijainnin",
"stg.subtitle": "Hyllysuunnitelma, QR-skanneri ja fyysinen varaston seuranta.",
"stg.title": "Varasto & QR",
"stt.acceptRate": "Hyväksymisaste",
"stt.accepted": "Hyväksytty",
"stt.activity30": "Toiminta (viimeiset 30 päivää)",
"stt.ai6mo": "Viimeiset 6 kuukautta · hyväksytty = automaattisesti sovitettu + vahvistettu.",
"stt.aiEmpty": "Ei AI-sovituksia tänä aikana.",
"stt.aiTitle": "AI-sovitukset — hyväksytty vs hylätty",
"stt.auctionShort": "Huuto",
"stt.auctionedSold": "Huudettu (myyty)",
"stt.authShort": "Viranomaiset",
"stt.authorities": "Viranomaisille luovutettu",
"stt.avgRating": "Keskimääräinen arvio",
"stt.awaitingRestitution": "esineet odottavat palautusta",
"stt.boostClicks": "Klikkaukset hakemistossasi tällä viikolla boostin ansiosta",
"stt.boostInactive": "Boost ei käytössä — ota se käyttöön saadaksesi näkyvyyttä",
"stt.certifiedPremium": "Premium-sertifioitu",
"stt.declarations": "Ilmoitukset",
"stt.destroyed": "Tuhoettu",
"stt.dispoEmpty": "Ei vielä mitään vaatimattomaa esinettä, joka olisi poistunut varastosta.",
"stt.donatedAssoc": "Lahjoitettu (hyväntekeväisyys)",
"stt.donatedShort": "Lahjoitettu",
"stt.gateCta": "Tutustu suunnitelmiin",
"stt.gateDesc": "Päivitä Starteriin saadaksesi perusanalytiikkaa, tai Businessiin saadaksesi edistynyttä analytiikkaa ja per-instituutiotason analyysin.",
"stt.gateTitle": "Tilastot varattu maksetuille suunnitelmille",
"stt.inStorage": "Varastossa",
"stt.kItems": "Rekisteröidyt esineet",
"stt.kRate": "Palautusaste",
"stt.kRestituted": "Palautetut esineet",
"stt.kRevenue": "Tulot (kuukausi)",
"stt.noDeclYet": "Ei vielä ilmoituksia.",
"stt.recapDownloaded": "Yhteenveto ladattu — valmis jaettavaksi!",
"stt.recapError": "Yhteenvetoa ei voida luoda",
"stt.recapText": "Meidän Findloop {year} yhteenveto: palautetut esineet ja asiakastyytyväisyys 🎉",
"stt.recapTitle": "Findloop {year} yhteenveto",
"stt.rejected": "Hylätty",
"stt.restitutions": "Palautukset",
"stt.shareRecap": "Jaa oma {year} yhteenveto",
"stt.topCategories": "Eniten ilmoitetut kategoriat",
"stt.unclaimedDesc": "Tuhojen, hyväntekeväisyyteen lahjoitettujen ja huutokaupattujen tuotteiden määrä, kategorian mukaan.",
"stt.unclaimedTitle": "Vaatimattomat esineet — poistuvat varastosta",
"stt.vsLastWeek": "vs viime viikko",
"sub.cancel": "Peruuta tilaukseni",
"sub.cancelAbort": "Peruuta",
"sub.cancelConfirm1": "Oletko varma, että haluat peruuttaa? Pääsysi pysyy aktiivisena asti",
"sub.cancelConfirm2": "Palautusta ei myönnetä.",
"sub.cancelConfirmBtn": "Vahvista peruutus",
"sub.cancelTitle": "Peruuta tilauksesi",
"sub.cancelledToast": "Peruutus kirjattu.",
"sub.cguAnd": "ja",
"sub.cguDesc": "Vahvista suostumuksesi ennen maksamista.",
"sub.cguLink": "Käyttöehdot",
"sub.cguPay": "Jatka maksamiseen",
"sub.cguPre": "Olen lukenut ja hyväksyn",
"sub.cguRequired": "Sinun on hyväksyttävä käyttöehdot ja tietosuojakäytäntö jatkaaksesi.",
"sub.cguSuffix": "Findon.",
"sub.cguTitle": "Vahvista tilauksesi",
"sub.expiresOn": "Tilauksesi vanhenee",
"sub.noProrata": "Ei osittaista palautusta.",
"sub.privacyLink": "Tietosuojakäytäntö",
"sub.renewsOn": "Tilauksesi uusitaan",
"sub.resume": "Tilaa uudelleen",
"sub.resumedToast": "Uudelleen tilaaminen vahvistettu.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Business",
"tier.small": "Aloittelija",
"tm.add": "Lisää",
"tm.adminOpt": "Ylläpito (täysi näkymä)",
"tm.chooseEst": "Valitse toimipaikka",
"tm.chooseEstPh": "Valitse toimipaikka",
"tm.copyFail": "Kopiointi epäonnistui",
"tm.copyLink": "Kopioi linkki",
"tm.copyOk": "Kutsu-linkki kopioitu",
"tm.emailHint": "Kutsusähköposti lähetetään salasanan luomiseksi.",
"tm.expiresOn": "vanhenee {date}",
"tm.forEmail": " varten {email}",
"tm.forbidden": "Tiimin hallinta on varattu tilin omistajalle.",
"tm.inviteCreated": "Kutsu luotu",
"tm.inviteDesc": "Kutsusähköposti antaa tiimin jäsenelle mahdollisuuden luoda salasanansa.",
"tm.invitePending": "Odottaa kutsua",
"tm.inviteResent": "Kutsu lähetetty uudelleen",
"tm.inviteSent": "Kutsu lähetetty sähköpostilla",
"tm.inviteTitle": "Kutsu jäsen",
"tm.invitedOn": "Kutsuttu {date}",
"tm.linkExpired": "Linkki vanhentunut",
"tm.memberRemoved": "Jäsen poistettu",
"tm.name": "Nimi",
"tm.noMembers": "Ei vielä tiimikavereita.",
"tm.resendTitle": "Lähetä kutsu uudelleen",
"tm.role": "Rooli",
"tm.roleAdmin": "Ylläpitäjä",
"tm.roleOwner": "Omistaja",
"tm.roleStaff": "Henkilökunta",
"tm.roleUpdated": "Rooli päivitetty",
"tm.sendInvite": "Lähetä kutsu",
"tm.sending": "Lähetetään…",
"tm.staffOpt": "Henkilökunta (näkee vain oman toimipaikan)",
"trk.at": "At",
"trk.badge": "Seuranta",
"trk.carrier": "Kuljetus",
"trk.codeValidated": "Koodi vahvistettu kumppanilta",
"trk.dlProof": "Lataa käsittelytodistukseni (PDF)",
"trk.emailLabel": "Sähköposti (valinnainen — nähdäksesi tietosi)",
"trk.enterEmailCode": "Syötä sähköpostisi ylle näyttäksesi vaatimuskoodisi.",
"trk.idLabel": "Ilmoitusnumero",
"trk.lostEmail": "Minulla ei enää ole pääsyä sähköpostiini",
"trk.phonePh": "Puhelinnumerosi",
"trk.photoBefore": "Kuva esineestä ennen lähettämistä",
"trk.recoverBtn": "Palauta esineeni",
"trk.recoverHint": "Saat vaatimuskoodisi SMS:llä rekisteröityyn numeroosi.",
"trk.searching": "Etsitään…",
"trk.secureRest": "Turvallinen luovutus",
"trk.send": "Lähetä",
"trk.shipPending": "Lähetys valmistellaan — seurantatunnus ilmestyy tänne, kun se on lähetetty.",
"trk.shipTitle": "Lähetyksen seuranta",
"trk.showQr": "Näytä tämä QR kumppanille luovutuksen vahvistamiseksi",
"trk.sigSaved": "Allekirjoitus tallennettu",
"trk.signFirst": "Ole hyvä ja allekirjoita ennen vahvistamista.",
"trk.signProof": "Allekirjoita käsittelytodistuksesi",
"trk.signSubmit": "Vahvista allekirjoitukseni ja luo PDF",
"trk.submit": "Seuraa",
"trk.subtitle": "Syötä ilmoitusnumerosi seuratakseen edistymistä.",
"trk.title": "Seuraa ilmoitustani",
"trk.trackShipment": "Seuraa lähetystä",
"trk.trackingNo": "Seurantatunnus",
"trk.yourCode": "Vaatimuskoodisi (annettavaksi kumppanille)",
"a.firstName": "Etunimi",
"ac.emailCrossMatch": "B2C-yhdisteet",
"ac.emailCrossMatchDesc": "Sähköposti, kun julkinen kadonneen esineen ilmoitus vastaa tiloissasi talletettua esinettä",
"ac.emailCrossReject": "Julkiset yhdistelyhylkäykset",
"ac.emailCrossRejectDesc": "Saat sähköpostin, kun asiakas ilmoittaa, että ehdotettu julkinen yhdistelmä ei ole heidän esineensä.",
"ac.emailLoginNotif": "Sisäänkirjautumisilmoitus",
"ac.emailLoginNotifDesc": "Saat sähköpostin joka kerta, kun joku kirjautuu sisään tiliisi.",
"ad.closeNoCancel": "Ei, poista ilmoitus",
"ad.closeQuestion": "Palautettiinko esine sinulle?",
"ad.closeQuestionDesc": "Kerro meille, palautettiinko esineesi, tai haluatko vain poistaa tämän ilmoituksen.",
"ad.closeYesRestituted": "Kyllä, esine palautettiin",
"ad.closedRestituted": "Esine palautettu — ilmoitus suljettu 🎉",
"an.lostLoginDesc": "Tili on tarpeen kadonneen esineen ilmoittamiseen ja sen palautuksen seuraamiseksi.",
"an.lostLoginRequired": "Kirjaudu sisään ilmoittaaksesi kadonneesta esineestä",
"an.qfAll": "Kaikki",
"an.qfBoosted": "Korotettu",
"an.qfPhoto": "Kuvalla",
"an.qfRecent": "Tällä viikolla",
"an.qfResolved": "Ratkaistu",
"an.restitutionInProgress": "Esine palautetaan",
"dec.descPhLong": "Kuvaile esinettä: brändi, väri, erottuvat merkit… (Mitä enemmän yksityiskohtia annat, sitä suuremmat mahdollisuudet sinulla on saada esineesi takaisin)",
"dec.loadError": "Yhteistyökumppania ei voi ladata juuri nyt. Tarkista yhteytesi ja kokeile uudelleen.",
"dec.retry": "Yritä uudelleen",
"dec.shippingMode": "Toimitus",
"dep.photo2": "2. esinekuva",
"dep.photo2Hint": "Valinnainen — toinen kulma parantaa visuaalista yhdisteyntä.",
"dl.accountSuspended": "Tili keskeytetty maksamattoman laskun vuoksi. Maksaminen palauttaa pääsysi.",
"dl.regularize": "Maksaa nyt →",
"dl.suspensionCountdown": "Lasku {num} maksamatta — tilisi keskeytetään {days} päivän kuluttua. Maksaminen auttaa välttämään tämän.",
"ft.cancelConfirm": "Peruutatko ilmoituksesi? Esineen omistajalle ilmoitetaan.",
"ft.cancelDone": "Ilmoitus peruutettu.",
"ft.cancelLocked": "Peruutus ei ole enää mahdollista, kun omistaja on maksanut.",
"ft.cancelReport": "Peruuta ilmoitukseni",
"ft.claimCodeHelp": "Anna tämä koodi löytäneelle henkilöltä esineen luovutuksessa vahvistaaksesi, että sait esineesi.",
"ft.claimCodeTitle": "Palautuskoodisi",
"ft.claimDone": "Esine palautettu. Kiitos, että käytit findoa!",
"ft.claimUnlockHint": "Avaa löytäneen yhteystiedot",
"ft.claimUnlockHintSub": "Siirry tiliisi kohtaan \"Esineet, joita vaadin\" maksaaksesi maksun ja saadaksesi yhteystiedot.",
"ft.finderCodeShownHelp": "Omistaja on maksanut ja valinnut sinut. Kopioi tämä koodi alle vahvistaaksesi palautuksen — ei tarvitse tarkistaa sähköpostia.",
"ft.finderCodeShownTitle": "Omistajan vahvistuskoodi",
"ft.finderContactsTitle": "Finderin yhteystiedot",
"ft.foundCodeHelp": "Näytä tämä koodi omistajalle luovutuksessa vahvistaaksesi, että esine on palautettu.",
"ft.inProgressOther": "Esineen palautus",
"ft.inProgressOtherHelp": "Omistaja valitsi tälle esineelle toisen löytäjän. Sinun ei tarvitse tehdä mitään lisätoimenpiteitä.",
"ft.restitutionCodeHelp": "Tämä koodi vahvistaa esineen luovutuksen. Se on jo esitäytetty alla; varmista se ja sulje tapaus.",
"ft.restitutionCodeTitle": "Sinun palautuskoodisi",
"hc.14Digits": "14 numeroa",
"hc.15DaysBeforeAnItem": "15 päivää ennen esineen laillista määräaikaa.",
"hc.7DaysBeforeAnItem": "7 päivää ennen esineen laillista määräaikaa.",
"hc.8CharactersMinimum": "Vähintään 8 merkkiä.",
"hc.aClaimToValidate": "Väite, joka on vahvistettava",
"hc.aFindoAssistanceSessionIs": "Findloop-avustussessio on tällä hetkellä aktiivinen tililläsi.",
"hc.aNewMatchHasBeen": "Uusi ottelu on löydetty",
"hc.aUser": "Käyttäjä",
"hc.aUserClaimsToBe": "Käyttäjä väittää olevan omistaja. Tarkista heidän vastauksensa ennen palautuksen hyväksymistä.",
"hc.aboutFindo": "Tietoja findosta",
"hc.accountActivatedPleaseLogIn": "Tili aktivoitu, kirjaudu sisään.",
"hc.accountActivation": "Tilin aktivointi",
"hc.accountCreated": "Tili luotu!",
"hc.accountDeactivatedAReactivationEmail": "Tili deaktivoitu. Aktivointisähköposti (voimassa 30 päivää) on lähetetty sinulle.",
"hc.accountReactivation": "Tilin aktivointi",
"hc.activateMyAccount": "Aktivoi tilini",
"hc.activateMyAdminAccount": "Aktivoi admin-tilini",
"hc.activating": "Aktivoidaan…",
"hc.activeMatchCancelReason": "Aktiivinen ottelu. Asiakkaan peruutusperuste: \"{reason}\". Esine odottaa edelleen väitettä.",
"hc.activeMatchWithAPublic": "Aktiivinen ottelu julkisella (asiakastieto) listalla. Odottaa omistajan väitettä.",
"hc.addAPhoto": "Lisää valokuva",
"hc.addAndConfigureYourEstablishments": "Lisää ja määritä laitoksesi \"Laitokset\": yhteystiedot, kategoria ja fyysinen varastointi esineille.",
"hc.addOnGoogle": "Lisää Googleen",
"hc.address": "Osoite",
"hc.addressSaved": "Osoite tallennettu",
"hc.addressStreet": "Osoite — Katu",
"hc.adjustThePhoto": "Säädä valokuvaa",
"hc.adminFullView": "Admin (koko näkymä)",
"hc.administratorOnly": "Vain ylläpitäjälle",
"hc.africa": "Afrikka",
"hc.aiVisualComparison": "AI visuaalinen vertailu",
"hc.all": "Kaikki",
"hc.amount": "Määrä",
"hc.anOrganization": "Organisaatio",
"hc.analyzing": "Analysoidaan…",
"hc.andRecoveryIs": "ja palautus on",
"hc.andTheDeclarationWillBe": "ja ilmoitus suljetaan (siirretty historiaan). Tämä toimenpide on lopullinen.",
"hc.annual20": "Vuosittain -20%",
"hc.annualBilling20": "Vuosittainen laskutus (−20%)",
"hc.annualTarget": "Vuosittainen tavoite",
"hc.anyCommentsOptional": "Onko kommentteja? (valinnainen)",
"hc.approveTheClaim": "Hyväksy vaade",
"hc.archiveCancelledConfirm": "Arkistoidaanko {n} luettelo(a) \"Peruttu asiakkaan toimesta\"? Ne poistetaan rekisteristä.",
"hc.asSoonAs": "Niissä tapauksissa",
"hc.askTheOwnerToDisplay": "Pyydä omistajaa näyttämään koodinsa QR (seurantasisältö).",
"hc.askThemAtTheCounter": "Kysy heiltä tiskiltä identiteetin vahvistamiseksi — ei koskaan julkisesti näkyvissä.",
"hc.assistance": "Tuki",
"hc.assistanceSessionRevoked": "Tukisessio peruutettu.",
"hc.atLeast6Characters": "Vähintään 6 merkkiä",
"hc.automaticallyPreSelected": "automaattisesti esivalittu",
"hc.automaticallyWhenShipping": "automaattisesti toimituksen yhteydessä.",
"hc.awaitingClaim": "Odottava vaade",
"hc.awaitingPayment": "Odottava maksaminen",
"hc.b2cCustomer": "B2C-asiakas",
"hc.back": "Takaisin",
"hc.backToHome": "Takaisin aloitussivulle",
"hc.backToMyAccount": "Takaisin omaan tiliini",
"hc.backToPayment": "Takaisin maksamiseen",
"hc.beforeAfterComparisonSlider": "Ennen/jälkeen vertailu-sivusäätön",
"hc.billingInformation": "Laskutustiedot",
"hc.billingInformationSaved": "Laskutustiedot tallennettu ✓",
"hc.brand": "Brändi",
"hc.bronze": "Pronssi",
"hc.calculatingTheShippingRate": "Lähetyskulujen laskeminen...",
"hc.cameraUnavailableEnterTheCode": "Kamera ei käytettävissä. Syötä koodi manuaalisesti.",
"hc.cancel": "Peruuta",
"hc.cancelMyDeclaration": "Peruuta ilmoitukseni",
"hc.cancelSavedFmt": "Peruutus tallennettu: \"{reason}\". Voit silti tehdä vaateen.",
"hc.cancelTheDeposit": "Peruuta talletus",
"hc.cancelThisMatch": "Peruuta tämä pari",
"hc.cancellationReason": "Peruutuksen syy",
"hc.cancelled": "Peruttu",
"hc.cancelledByTheCustomer": "Peruttu asiakkaan toimesta",
"hc.cannotOpenPayment": "Maksua ei voi avata. Yritä uudelleen.",
"hc.closeTheDeclaration": "Sulje ilmoitus",
"hc.closeTheDeclaration2": "Sulje ilmoitus?",
"hc.codeAlreadyVerified": "Koodi on jo vahvistettu",
"hc.codeCopied": "Koodi kopioitu",
"hc.collapse": "Yhdistele",
"hc.color": "Väri",
"hc.company": "Yritys",
"hc.companyName": "Yrityksen nimi",
"hc.comparePhotos": "Vertaile valokuvia",
"hc.compareThemWithTheOwner": "Vertaile niitä omistajan vastauksiin — ei koskaan julkisesti näkyvissä.",
"hc.condition": "Kunto",
"hc.confirmAndPay": "Vahvista ja maksa",
"hc.confirmCancellation": "Vahvista peruutus",
"hc.confirmCrop": "Vahvista rajaus",
"hc.confirmDeletion": "Vahvista poisto",
"hc.confirmPassword": "Vahvista salasana",
"hc.confirmThatThisIsYour": "Vahvista, että tämä on sinun esineesi. Identiteettitarkastus pyydetään löytöpaikalta ennen yhteydenottoa.",
"hc.confirmTheCarrier": "Vahvista kuljettaja",
"hc.confirmThePassword": "Vahvista salasana",
"hc.confirmYourShippingAddressTo": "Vahvista toimitusosoitteesi jatkaaksesi maksamista.",
"hc.confirmYourSubscription": "Vahvista tilauksesi",
"hc.confirmed": "Vahvistettu ✓",
"hc.contactFindoToGetYour": "Ota yhteyttä Findoon saadaksesi Lähettäjän ID:n.",
"hc.contactUs": "Ota meihin yhteyttä",
"hc.continueTheReturn": "Jatka palautusta",
"hc.continueToPayment": "Jatka maksamiseen",
"hc.copy": "Kopioi",
"hc.correctMyDetails": "korjaa tietoni",
"hc.correctThisEntry": "Korjataanko tämä merkintä?",
"hc.country": "Maa",
"hc.countryAddress": "Maa (osoite)",
"hc.countryIsoCodeEG": "Maa (ISO-koodi, esim. FR)",
"hc.cover": "kansilehti",
"hc.createTheShipment": "Luo lähetys",
"hc.cropThePhoto": "Rajaa valokuva",
"hc.customer": "Asiakas",
"hc.customerClaimCodeToCheck": "Asiakkaan vaatimuskoodi — tarkistettavaksi noudon yhteydessä:",
"hc.customerReasonFmt": "Asiakkaan syy: \"{reason}\".",
"hc.customerReminderDelay": "Asiakkaan muistutuksen viive",
"hc.customerWhosePublicListingMatches": "Asiakas, jonka julkinen ilmoitus vastaa tätä esinettä — näkyvissä vain sinulle.",
"hc.careers": "Työpaikat",
"hc.carrier": "Kuljetusliike",
"hc.carrierAvailabilityCannotBeChecked": "Kuljetusliikkeen saatavuutta ei voida tarkistaa ennen kuin Sendcloud-lähettäjäsi on määritetty.",
"hc.carrierConfirmedCharged": "Kuljetusliike vahvistettu — {price} € veloitettu asiakkaalta",
"hc.carrierOther": "Kuljetusliike (muu)",
"hc.carrierSelection": "Kuljetusliikkeen valinta",
"hc.caseClosedThankYou": "Tapaus suljettu. Kiitos!",
"hc.category": "Kategoria",
"hc.changeMethod": "Vaihda menetelmä",
"hc.characteristic": "Ominaisuus",
"hc.chargedToCustomer": "veloitettu asiakkaalta.",
"hc.checkOrEditYourDetails": "Tarkista tai muokkaa tietojasi ennen turvallista maksua.",
"hc.checkStatisticsToTrackDeposited": "Tarkista \"Tilastot\" seuratakseen talletettuja kohteita, palautusprosenttia ja jokaisen laitoksen suorituskykyä.",
"hc.checkTheDetailsBeforeContacting": "Tarkista tiedot ennen kuin otat yhteyttä löytöpalveluun.",
"hc.checkTheDetailsBelowBefore": "Tarkista alla olevat tiedot ennen palautuspyynnön aloittamista.",
"hc.checkTheNewItem": "Tarkista uusi kohde",
"hc.checkThePhotosAndCharacteristics": "Tarkista alla olevat valokuvat ja ominaisuudet ennen toipumisen aloittamista.",
"hc.chooseACountry": "Valitse maa",
"hc.chooseANewPassword": "Valitse uusi salasana",
"hc.chooseAReason": "Valitse syy",
"hc.chooseTheLegalRetentionAlerts": "Valitse lain mukaiset säilytysohjeet, jotka vastaanotetaan sähköpostilla",
"hc.chooseYourPasswordToAccess": "Valitse salasanasi päästäksesi hallintokonsoliin.",
"hc.city": "Kaupunki",
"hc.claimApproved": "Vaatimus hyväksytty",
"hc.claimApproved2": "Vaatimus hyväksytty.",
"hc.claimCodeExpired": "Vaatimuskoode expired",
"hc.claimCodeVerified": "Vaatimuskoode vahvistettu",
"hc.claimNotFound": "Vaatimusta ei löytynyt",
"hc.claimNotValidated": "Vaatimusta ei vahvistettu",
"hc.claimRejected": "Vaatimus hylätty",
"hc.claimRejected2": "Vaatimus hylätty.",
"hc.claimValidated": "Vaatimus vahvistettu",
"hc.claimValidatedByThePartner": "Vaatimus vahvistettu kumppanin toimesta",
"hc.claimant": "Vaatija",
"hc.claimsToBeTheOwner": "väittää olevansa tämän kohteen omistaja ja on vastannut varmennuskysymyksiin. Hyväksy vain, jos vastaukset täsmäävät.",
"hc.claimsToValidate": "Vaatimukset vahvistettavaksi",
"hc.clear": "Tyhjennä",
"hc.clickToZoom": "Napsauta zoomataksesi",
"hc.close": "Sulje",
"hc.close2": "Sulje",
"hc.d15": "D-15",
"hc.dangerZone": "Vaaravyöhyke",
"hc.date": "Päivämäärä",
"hc.dateNewest": "Päivämäärä (uusimmat)",
"hc.dateOldest": "Päivämäärä (vanhimmat)",
"hc.daysToYearEnd": "{n} päivää vuoden loppuun",
"hc.deadlineAlert": "Deadline-ilmoitus",
"hc.declarationClosed": "Ilmoitus suljettu ✓",
"hc.declarationNotFound": "Ilmoitusta ei löytynyt.",
"hc.declarationNotFound2": "Ilmoitusta ei löytynyt",
"hc.declarationTracking": "Ilmoituksen seuranta",
"hc.defaultCarrier": "Oletuslähettäjä",
"hc.defaultCarrierPreselected": "Oletuslähettäjä esivalittuna — voidaan vaihtaa tälle lähetykselle. Todellinen hinta (Sendcloud + {m}% marginaali).",
"hc.defaultCarrierRemoved": "Oletuslähettäjä poistettu",
"hc.delayHours": "Viive (tunnit)",
"hc.deleteMyAccount": "Poista tilini",
"hc.deleting": "Poistetaan…",
"hc.deletingDeactivatesYourAccountLogin": "Poistaminen deaktivoittaa tilisi: kirjautuminen on estetty ja tiedot säilytetään 30 päivää. Saat sähköpostin, jossa on reaktivoimislinkki, joka on voimassa 30 päivää.",
"hc.delivered": "Toimitettu",
"hc.depositAnItem": "Talleta tuote",
"hc.depositCancelledItemPutBack": "Talletus peruttu — tuote palautettu varastoon.",
"hc.depositCancelledItemRemovedFrom": "Talletus peruttu — tuote poistettu rekisteristä.",
"hc.depositedOn": "Talletettu",
"hc.describeTheItemBrandColor": "Kuvaa tuotetta: merkki, väri, tunnusmerkit… (Mitä enemmän tietoja annat, sitä paremmat mahdollisuudet tuotteen löytämiseen)",
"hc.dimensionsCm": "Mitat (cm)",
"hc.disablingAnEmail": "Sähköpostin deaktivointi",
"hc.doesNotHide": "ei piilota",
"hc.download": "Lataa",
"hc.downloadThePdf": "Lataa PDF",
"hc.draftRestoredPickUpYour": "Luonnos palautettu — nouda ilmoituksesi siitä, mihin jäit.",
"hc.dragToReposition": "Raahaa sijoittamiseksi",
"hc.eGColisPriv": "Esim. Colis Privé",
"hc.eachItemGetsAQr": "Jokainen tuote saa QR-tunnisteen. Skannaa se \"Varasto & QR\" -kohdasta löytääksesi tuotteen hetkessä.",
"hc.eachSiteManagesItsOwn": "Jokainen sivusto hallinnoi omaa pankkitoimintaansa. Siirry ",
"hc.edit": "Muokkaa",
"hc.emailNotificationPreferences": "Sähköposti-ilmoitusasetukset",
"hc.emailPreferencesUpdated": "Sähköpostiasetukset päivitetty",
"hc.enableOrDisableRecoveryFees": "Ota käyttöön tai poista käytöstä palautusmaksut",
"hc.enlargePhoto": "Suurenna kuvaa",
"hc.enterTheCustomerSCode": "Syötä asiakkaan koodi",
"hc.estShipRate": "Arvioitu toimitushinta (Sendcloud + {m}% marginaali):",
"hc.establishment": "Liiketoiminta",
"hc.establishment2": "Liiketoiminta:",
"hc.establishmentInItsSendcloudAccount": "liiketoiminta Sendcloud-tilillään ja antaa sinulle lähettäjän ID:n",
"hc.establishmentSettings": "Liiketoiminnan asetukset",
"hc.exCode": "esim. ABCD2345",
"hc.exId": "esim. 3f2a…",
"hc.exit": "Poistu",
"hc.explainWhyThisItemIs": "Selitä, miksi tämä tuote ei ole sinun…",
"hc.externalPaymentLinks": "Ulkoiset maksulinkit",
"hc.failed": "Epäonnistui",
"hc.feesEnabled": "Maksut käytössä",
"hc.field": ") kenttä.",
"hc.finderAcceptedCloseTheCase": "Finder hyväksytty — sulje tapaus, kun tuote on luovutettu henkilökohtaisesti.",
"hc.findoCityRanking": "Findloop — Kaupunkiranking",
"hc.findoForEstablishments": "Findloop liiketoiminnalle",
"hc.findoPresentationVideo": "Findloop esittelyvideo",
"hc.findoRegistersTheAddressOf": "Findloop rekisteröi osoitteen",
"hc.findoReviewShare": "Findloop {year} arvio: {n} tuotetta palautettu, {rate}% palautusprosentti 🎉",
"hc.firstVerifyTheClaimCode": "Vahvista ensin yllä oleva vaatimuskoodi",
"hc.forEveryNewShipmentFrom": "jokaisesta uudesta lähetyksestä",
"hc.free": "ilmainen",
"hc.freeRecovery0": "Ilmainen palautus (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Ilmainen palautus Afrikassa – Käynnistys tarjous",
"hc.freeRecoveryFeesDisabled0": "Ilmainen palautus: maksut poistettu käytöstä (0 €)",
"hc.fromTeamInviteYourColleagues": "\"Tiimistä\", kutsu kollegasi sähköpostitse ja määritä heille liiketoiminta. Jokainen jäsen näkee vain oman alueensa.",
"hc.fullName": "Koko nimi",
"hc.fullPhoto": "Koko kuva",
"hc.gallery": "Galleria",
"hc.giveTheReasonForCancelling": "Anna syy peruutukselle. Kumppani saa tiedon.",
"hc.goToLogin": "Siirry kirjautumiseen",
"hc.goToMyAccount": "Siirry tiliini",
"hc.gold": "Kulta",
"hc.googleLoginFailed": "Google-kirjautuminen epäonnistui",
"hc.hasConfirmedYourPaymentYou": "on vahvistanut maksusi, sinut ohjataan automaattisesti",
"hc.helpCenter": "Ohjeet",
"hc.helpUsImproveWhyAre": "Auta meitä parantamaan: miksi lähdet? Tilisi poistetaan ja se voidaan aktivoida uudelleen 30 päivän kuluessa.",
"hc.hidePassword": "Piilota salasana",
"hc.high": "Korkea",
"hc.historyOfYourMonthlySubscriptions": "Kuukausittaisen tilauksesi historia ja niiden maksustatus.",
"hc.hotelBelmont": "Hotelli Belmont",
"hc.howConfigureSenderId": "Kuinka asetat numerollisen Lähettäjä-ID:n?",
"hc.iDonTUseIt": "En käytä sitä tarpeeksi",
"hc.iFoundItElsewhere": "Löysin sen muualta",
"hc.iNoLongerNeedMy": "En enää tarvitse tavaraani",
"hc.identityVerification": "Henkilöllisyyden vahvistaminen",
"hc.idleLogoutIn": "Kirjaudut ulos {n} sekunnin kuluttua toimimattomuuden vuoksi.",
"hc.ifProvidedTheVolumetricWeight": "Jos se on annettu, tilavuuspaino otetaan huomioon.",
"hc.ifThePartnerHasNot": "Jos kumppani ei ole vahvistanut ulkoisen maksun vastaanottamista tämän viiveen jälkeen, Findloop muistuttaa kumppania sen vahvistamisesta automaattisesti.",
"hc.impersonationEnded": "Käyttäjän mukaantulo päättyi.",
"hc.impersonationMode": "Käyttäjän mukaantulotila",
"hc.impersonationSessionExpired": "Käyttäjän mukaantulosessio on vanhentunut.",
"hc.inTheField": ", kentällä",
"hc.inTransit": "Kuljetuksessa",
"hc.inclVat": "sis. ALV",
"hc.intraEuVatNumberOptional": "Intra-EU ALV-numero valinnainen, ei SIRET vaadittu (Ranskan ulkopuolella).",
"hc.invalidInvitationLink": "Virheellinen kutsulinkki.",
"hc.invalidInvitationLink2": "Virheellinen kutsulinkki",
"hc.invalidInviteLink": "Virheellinen tai vanhentunut kutsulinkki.",
"hc.invalidNumberEnterAnInternational": "Virheellinen numero. Syötä kansainvälinen numero, esim. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Virheellinen tai vanhentunut linkki.",
"hc.invalidOrExpiredReactivationLink": "Virheellinen tai vanhentunut aktivoimislinkki",
"hc.invalidSendcloudId": "Virheellinen Sendcloud ID",
"hc.inviteSubtitle": "{org} kutsuu sinut liittymään heidän findloop-tiimiinsä. Valitse salasana aktivoidaksesi tilisi.",
"hc.isAvailableOnSendcloudFor": "on saatavilla Sendcloudissa kaikille reiteillesi (kotimaiset + kansainväliset).",
"hc.isNotEnabledOnYour": "ei ole käytössä Sendcloud-tililläsi joillekin kohteille. Niiden tarrat luodaan toisen saatavilla olevan kuljetinpalvelun kanssa.",
"hc.isThisReallyYourItem": "Onko tämä todella sinun tavarasi?",
"hc.isThisYourItem": "Onko tämä sinun tavarasi?",
"hc.item": "Tuote",
"hc.itemAlreadyConfirmed": "Tuote on jo vahvistettu",
"hc.itemDetails": "Tuotteen tiedot",
"hc.itemFoundAt": "Tuote löytyi",
"hc.itemFoundAtAPartner": "Tuote löytyi kumppanilta",
"hc.itemMarkedAsReturned": "Tuote merkitty palautetuksi ✓",
"hc.itemPhotoRequiredBeforeShipping": "Tuotekuva (vaaditaan ennen lähettämistä)",
"hc.itemPhotoSaved": "Tuotekuva tallennettu",
"hc.itemPreview": "Tuotteen esikatselu",
"hc.itemPutBackInStorage": "Tuote palautettu varastoon.",
"hc.itemWeight": "Tuotteen paino:",
"hc.itemsReturned": "tuote(t) palautettu",
"hc.itemsReturnedThisYear": "palautetut tuotteet tänä vuonna",
"hc.itemsWhoseLegalDeadlineIs": "Tuotteet, joiden laillinen viimeinen päivämäärä on 15 päivää tai vähemmän (myöhässä mukaan lukien). Ottelut pysyvät näkyvissä.",
"hc.kbisNumber": "Kbis-numero",
"hc.keysForgottenOnABench": "Avaimet unohtuneet penkille",
"hc.labelBeingGenerated": "Tarraa luodaan",
"hc.leaveTheFieldsEmptyTo": "Jätä kentät tyhjiksi tarjotaksesi palautuksen ilmaiseksi.",
"hc.legalNotice": "Lakihuomautus",
"hc.limitReachedUpgradeToA": "Raja saavutettu — päivitä korkeampaan suunnitelmaan",
"hc.linkCopiedShareOn": "Linkki kopioitu — jaa se {label}ssa",
"hc.linkUnavailable": "Linkki ei käytettävissä",
"hc.linkedTo": "Liitetty",
"hc.listingHiddenByModeration": "Ilmoitus piilotettu moderoinnin vuoksi.",
"hc.loading": "Ladataan…",
"hc.locateMe": "Sijaintini",
"hc.logIn": "Kirjaudu sisään",
"hc.logInToGetBack": "Kirjaudu sisään päästäksesi takaisin tilaasi ja hallitaksesi tilaustasi.",
"hc.loginFailed": "Sisäänkirjautuminen epäonnistui",
"hc.lostFoundPlatform": "Käytettyjen ja löydettyjen alusta.",
"hc.lostIn": "hävinnyt",
"hc.lowRate": "Alhainen hinta",
"hc.mainReason": "Pääsyy",
"hc.mainStreet": "Pääkatu",
"hc.makeSureThisIsThe": "Varmista, että tämä on kadonnut esine ennen löytjän yhteystietojen vapauttamista.",
"hc.manageCookies": "Hallitse evästeitä",
"hc.manageMyTeam": "Hallitse tiimiani",
"hc.manageYourTeam": "Hallitse tiimiäsi",
"hc.markAsReturned": "Merkitse palautetuksi",
"hc.matchNoClaimInTime": "Ottelua ei vaadittu määräajassa.",
"hc.matchNotFound": "Ottelua ei löytynyt",
"hc.medium": "Keskikoko",
"hc.milestoneFmt": "{m} palautetun tuotteen virstanpylväs saavutettu! Matka kohti {next}.",
"hc.missingFeatures": "Puuttuvat ominaisuudet",
"hc.monthly": "Kuukausittain",
"hc.monthlyBilling": "Kuukausittainen laskutus",
"hc.moveThePhotoToFit": "Siirrä kuvaa, jotta se mahtuu ympyrään.",
"hc.myAccount": "Oma tili",
"hc.myInvoices": "Omat laskuni",
"hc.myMonthlyInvoices": "Kuukausilaskuni",
"hc.nArchived": "{n} ilmoitusta arkistoitu.",
"hc.newCodeGeneratedAndSent": "Uusi koodi luotu ja lähetetty asiakkaalle sähköpostitse ja SMS:llä",
"hc.newCodeGeneratedAndSent2": "Uusi koodi luotu ja lähetetty omistajalle",
"hc.newPassword": "Uusi salasana",
"hc.next": "Seuraava",
"hc.nextPhoto": "Seuraava valokuva",
"hc.no": "Ei",
"hc.noAnswerProvided": "Ei vastausta annettu.",
"hc.noArchivedDeclarations": "Ei arkistoituja ilmoituksia",
"hc.noCountryFound": "Ei maata löytynyt",
"hc.noDeclarations": "Ei ilmoituksia",
"hc.noFeesAreChargedTo": "Asiakkaalta ei peritä maksuja.",
"hc.noInvoiceYet": "Ei laskua vielä.",
"hc.noInvoiceYetYourInvoices": "Ei laskua vielä. Laskusi näkyvät täällä automaattisesti jokaisen maksun jälkeen.",
"hc.noMatchIsAvailableFor": "Ei ottelua saatavilla tällä hetkellä. Ilmoitamme sinulle heti, kun tuote vastaa ilmoitustasi.",
"hc.noShipmentMatchesYourSearch": "Ei lähetystä vastaa hakuaasi.",
"hc.noShipmentsYet": "Ei lähetyksiä vielä.",
"hc.noShipmentsYet2": "Ei lähetyksiä vielä",
"hc.none": "ei mitään",
"hc.noneChooseForEachShipment": "Ei mitään (valitse jokaiselle lähetykselle)",
"hc.notMine": "Se ei ole minun",
"hc.of": "kohtaan",
"hc.only": "Vain",
"hc.onlyEachSiteManagesIts": "vain. Jokainen sivusto hallinnoi omaa pankkitoimintaansa: nämä linkit eivät vaikuta muihin liikepaikkoihin.",
"hc.onlyTheOwnerOrAn": "Vain omistaja tai järjestelmänvalvoja voi määrittää toimipaikan maksulinkkejä.",
"hc.openDepositInTheMenu": "Avaa \"Talletus\" valikosta, kuvaa kohde ja ota valokuva. Se tallennetaan heti ja on valmis palautettavaksi.",
"hc.openSettings": "Avaa Asetukset →",
"hc.openTheDeclarationToManage": "Avaa ilmoitus hallitaksesi lähetystä",
"hc.optional": "— valinnainen",
"hc.optional2": "(valinnainen)",
"hc.optional3": "valinnainen",
"hc.originalListingPhotoUsed": "Alkuperäinen ilmoituskuva käytetty",
"hc.other": "Muu",
"hc.other2": "Muu…",
"hc.ourProducts": "Tuotteemme",
"hc.overallRateTrendLast6": "Yleinen hintatrendi (viimeiset 6 kuukautta)",
"hc.ownerSClaimCode": "Omistajan vaatimuskoodi",
"hc.ownershipConfirmed": "Omistajuus vahvistettu",
"hc.paid": "Maksettu",
"hc.paidOn": "Maksettu",
"hc.paidViaPartner": "Maksettu (kumppanin kautta)",
"hc.parcelBeingPrepared": "Paketti valmistuu",
"hc.parcelDelivered": "Paketti toimitettu",
"hc.parcelShipped": "Paketti lähetetty",
"hc.parisGareDeLyon": "Pariisi, Gare de Lyon…",
"hc.partner": "Kumppani",
"hc.partner2": "kumppani",
"hc.partnerDirectory": "Kumppanihakemisto",
"hc.passedOnToTheCustomer": "— siirretty asiakkaalle maksulinkki.",
"hc.password": "Salasana",
"hc.passwordResetPleaseLogIn": "Salasanan palautus, kirjaudu sisään.",
"hc.passwordUpdated": "Salasana päivitetty.",
"hc.passwordsDoNotMatch": "Salasanat eivät täsmää.",
"hc.pasteThisSenderIdIn": "Liitä tämä Lähettäjän ID Findloop → Asetukset",
"hc.payForTheShipmentOf": "Maksa lähetyksesi findon kautta turvallisella maksulla.",
"hc.payTheRecoveryFees": "Maksa palautusmaksut",
"hc.payTheShippingFees": "Maksa toimitusmaksut",
"hc.payment": "Maksu",
"hc.paymentAlreadyConfirmedByThe": "Maksu on jo vahvistettu kumppanin toimesta",
"hc.paymentLinksAreNowConfigured": "Maksulinkit on nyt määritetty jokaiseen toimipisteeseen",
"hc.paymentNotCompletedYourAccount": "Maksua ei ole suoritettu, tiliäsi ei ole luotu — yritä uudelleen.",
"hc.paymentReceived": "Maksu vastaanotettu",
"hc.paymentSuccessful": "Maksu onnistui!",
"hc.pdfInvoice": "PDF-lasku",
"hc.pending": "Odottaa",
"hc.period": "Aika",
"hc.phoneNumber": "Puhelinnumero",
"hc.phoneOptional": "Puhelin (valinnainen)",
"hc.planAt": "suunnitelma",
"hc.planLimitFmt": "\"{plan}\"-suunnitelmasi on rajoitettu {max} toimipaikkaan. Hallitaksesi {n} sivustoa, suosittelemme",
"hc.platformReturnTarget": "Alustapalautustavoite",
"hc.pleaseCompleteYourShippingAddress": "Täytä lähetystittelisi.",
"hc.pleaseProvideAPhoneNumber": "Anna puhelinnumero: kuljetusyhtiö tarvitsee sen toimitusta varten.",
"hc.pleaseProvideAReason": "Anna syy.",
"hc.pleaseSetYourOwnPassword": "asetathan oman salasanasi ennen jatkamista.",
"hc.pointsToGoal": "{n} pistettä vielä yhteiseen tavoitteeseemme.",
"hc.posterPreview": "Julisteen esikatselu",
"hc.potentialMatchBeingVerified": "Mahdollinen vastaavuus vahvistetaan",
"hc.potentialOwner": "Mahdollinen omistaja",
"hc.preFilledAutomaticallyYouCan": "Esitäytetty automaattisesti — voit korvata sen paketin valokuvalla.",
"hc.reportAProblem": "Ilmoita ongelmasta",
"hc.reportDismissedYourListingRemains": "Ilmoitus hylätty. Ilmoituksesi pysyy julkisena.",
"hc.requiredUsedToCalculateThe": "Pakollinen: käytetään Sendcloudin toimituskustannusten laskemiseen. Toimitus ei saatavilla yli 30 kg.",
"hc.reset": "Nollaa",
"hc.resume": "Jatka",
"hc.resumeRegistration": "Jatka rekisteröitymistä",
"hc.retro": "Vuosi lyhyesti",
"hc.returnSecurity": "Palautusturva",
"hc.returnToTheOwner": "Palauta omistajalle",
"hc.returned": "palautettu",
"hc.reviewTheItemDetails": "Tarkista kohteen tiedot",
"hc.revokeAccess": "Peruusele pääsy",
"hc.role": "Rooli:",
"hc.save": "Tallenna",
"hc.save2": "tallenna",
"hc.saveAndContinue": "Tallenna ja jatka",
"hc.saving": "Tallennetaan…",
"hc.scanTheClaimCode": "Skannaa vaatimuskoodi",
"hc.scanTheOwnerSQr": "Skannaa omistajan QR",
"hc.scrollThroughLanguages": "Selaa kieliä",
"hc.searchByCustomerItemOr": "Etsi asiakkaan, kohteen tai seurantakoodin mukaan…",
"hc.searchForACountry": "Etsi maata…",
"hc.secureFindoVerification": "Turvallinen findloop-vahvistus",
"hc.seeRetro": "Katso vuosi lyhyesti",
"hc.selectedCarrier": "Valittu kuljetusliike:",
"hc.selectedPlan": "Valittu suunnitelma",
"hc.send": "Lähetä",
"hc.sendcloudSenderIdSaved": "Sendcloudin lähettäjän ID tallennettu",
"hc.sendcloudSenderIdSenderId": "Sendcloud lähettäjän ID (sender_id)",
"hc.sending": "Lähetetään…",
"hc.sessionExpired": "Istunto päättynyt",
"hc.setUpYourEstablishments": "Aseta liiketoimintasi",
"hc.settings": "Asetukset",
"hc.settingsSubtitle": "Ulkoiset maksut ja muistutukset, konfiguroitu per liiketoiminta.",
"hc.shareFoundText": "Löysin kohteen — auta minua löytämään sen omistaja findosta",
"hc.shareLostText": "Jouduin hälyttämään kohteen — auta minua löytämään se findosta",
"hc.sharePreview": "Jaa esikatselu",
"hc.shareTheRanking": "Jaa sijoitus",
"hc.shareYourQrCodeTo": "Jaa QR-koodisi saadaksesi ilmoituksia.",
"hc.shipRateAutoWeight": "Toimituskustannus lasketaan automaattisesti Sendcloudin kautta (paino {w}) toimitushetkellä.",
"hc.pressKit": "Lehdistötiedote",
"hc.previewMode": "Esikatselutila:",
"hc.previewOfThePrintReady": "Esikatselu tästä tulostusvalmiista A4-julisteesta.",
"hc.previous": "Edellinen",
"hc.previousPhoto": "Edellinen kuva",
"hc.primary": "päätason",
"hc.printThePoster": "Tulosta juliste",
"hc.privacy": "Yksityisyys",
"hc.privacyPolicy": "Tietosuojakäytäntö",
"hc.processedCasesWillAppearHere": "Käsitellyt tapaukset näkyvät täällä.",
"hc.proofOfReturnPdf": "Todistus palautuksesta (PDF)",
"hc.protectedByRecaptcha": "Suojaus reCAPTCHA:lla",
"hc.publicMatch": "Julkinen ottelu",
"hc.putBackInStorage": "Laita takaisin varastoon",
"hc.pwdResetByTeam": "Salasanasi palautettiin tiimimme toimesta. Turvallisuutesi vuoksi,",
"hc.questionsToAskTheOwner": "Kysymyksiä omistajalle",
"hc.rateChargedToTheCustomer": "Asiakkaalle veloitettava hinta:",
"hc.rateOfTarget": "{rate}% saavutettu {target}% tavoitteesta",
"hc.reached": "saavutettu",
"hc.reactivating": "Aktivoidaan uudelleen…",
"hc.reasonSavedYouCanStill": "Syys tallennettu. Voit silti vaatia esinettäsi.",
"hc.recentMatchesFirst": "Uusimmat ottelut ensin",
"hc.recognizedThePhotoYouSent": "tunnisti lähettämäsi kuvan ja kuvasi näitä ominaisuuksia. Vahvista vain, jos ne vastaavat hallussasi olevaa esinettä.",
"hc.recommended": "Suositeltu",
"hc.recoveryFees": "Palautusmaksut",
"hc.recoveryFeesArePaidDirectly": "Palautusmaksut maksetaan suoraan kumppanilaitokselle. Findloop ei saa maksua asiakkailta.",
"hc.recoveryFeesEnabled": "Palautusmaksut käytössä",
"hc.recoveryOfferedByTheEstablishment": "Palautus kumppanilaitokselta - Findloop ei veloita maksuja.",
"hc.recoveryPaymentLink": "Palautuksen maksulinkki",
"hc.recoveryPaymentLinkSavedFor": "Palautuksen maksulinkki tallennettu tälle laitokselle",
"hc.redirecting": "Ohjataan…",
"hc.redirectingToPayment": "Ohjataan maksamiseen…",
"hc.redirectingToTheRecoveryOf": "Ohjataan esineesi palautukseen…",
"hc.regenerateAndResendToThe": "Uudelleensynnyttä ja lähetä omistajalle",
"hc.regenerateTheCode": "Uudelleensynnyttä koodi",
"hc.registerAFoundItem": "Rekisteröi löytynyt esine",
"hc.rejectTheClaim": "Hylkää vaatimus",
"hc.reminderDelaySaved": "Muistutuksen viivytys tallennettu",
"hc.reopenThePaymentLink": "Avaa maksulinkki uudelleen",
"hc.repeatThePassword": "Toista salasana",
"hc.shipRateForWeight": "Toimitusmaksu (Sendcloud + {m}% marginaali) {w}:lle:",
"hc.shipments": "Toimitukset",
"hc.shipmentsSubtitle": "Konsolidoitu näkymä kaikista laitoksen toimituksista kaikissa tapauksissa. Klikkaa riviä hallitaksesi toimitusta sen ilmoituksessa.",
"hc.shipping": "Toimitus",
"hc.shippingAddress": "Toimitusosoite",
"hc.shippingFeesAreHandledAutomatically": "Toimitusmaksut käsitellään automaattisesti Findloop:n (Sendcloud) toimesta — ei tarvitse syöttää linkkiä.",
"hc.shippingFeesHaveAlreadyBeen": "Toimitusmaksut on jo maksettu: kuljetusliikettä ei voi muuttaa.",
"hc.shippingNotAvailableForItems": "Toimitus ei ole saatavilla yli 30 kg:n tuotteille. Asiakkaan on noudettava tuote henkilökohtaisesti.",
"hc.shippingPaid": "Toimitus maksettu ✓",
"hc.showOnlyItemsMatchingA": "Näytä vain tuotteet, jotka vastaavat julkista (asiakas) listaa",
"hc.showPassword": "Näytä salasana",
"hc.signInTheBoxAbove": "Kirjaudu yllä olevaan laatikkoon",
"hc.signatureSaved": "Allekirjoitus tallennettu",
"hc.signedInWithGoogle": "Kirjautunut Googlella",
"hc.signupFailed": "Rekisteröityminen epäonnistui",
"hc.silver": "Hopea",
"hc.simulatedRatesInPreProduction": "(simuloidut hinnat esituotannossa)",
"hc.siretAndVatNumberRequired": "SIRET ja ALV-numero vaaditaan (Ranska).",
"hc.skip": "Ohita",
"hc.smsSentIfAccount": "Jos tämä numero on olemassa tilinä, sinulle on lähetetty SMS.",
"hc.sortItemsWithAPublic": "Lajittele: tuotteet, joissa on julkinen vastaavuus (uusimmat) ensin",
"hc.specifyWhetherYouRecoveredYour": "Määritä, oletko noutanut tuotteen tai haluatko vain poistaa tämän listauksen.",
"hc.specifyYourReason": "Määritä syysi",
"hc.specifyYourReason2": "Määritä syysi…",
"hc.staff": "Henkilöstö",
"hc.status": "Tila",
"hc.staySignedIn": "Pysy sisäänkirjautuneena",
"hc.step": "Vaihe",
"hc.stillThere": "Onko vielä täällä?",
"hc.stopScrolling": "Lopeta vieritys",
"hc.storeFindWithQr": "Tallenna & löydä QR:n avulla",
"hc.streetName": "Katuosoite",
"hc.streetNo": "Katu nro.",
"hc.switchTo": "Vaihda",
"hc.switchToDarkMode": "Vaihda tummalle tilalle",
"hc.switchToLightMode": "Vaihda vaalealle tilalle",
"hc.takeAPhoto": "Ota valokuva",
"hc.takeChangeThePhoto": "Ota / vaihda valokuva",
"hc.takenFromYourDeclaration": "otettu ilmoituksestasi",
"hc.target": "Kohde",
"hc.thisValidationLinkIsInvalid": "Tämä vahvistuslinkki ei ole voimassa tai se on vanhentunut.",
"hc.toCheckBeforeMarkingThe": "Tarkista ennen tuotteen merkitsemistä palautetuksi.",
"hc.toConfigureTheLinksAnd": "konfiguroidaksesi linkit ja muistutusten viiveet jokaiselle toimipisteelle.",
"hc.toReachOurFirstMilestone": "saavuttaaksemme ensimmäisen etappimme, 100 palautusta.",
"hc.toTheCustomer": "asiakkaalle.",
"hc.toTheShippingFeePayment": "lähetysmaksun maksamiseen.",
"hc.toYourRecoveryTracking": "palautuksen seurantaan.",
"hc.tooExpensiveBudget": "Liian kallis / budjetti",
"hc.topCitiesForReturns": "Parhaat kaupungit palautuksille",
"hc.trackMyRecovery": "Seuraa palautustani",
"hc.trackTheShipmentAndDownload": "Seuraa lähetystä ja lataa etiketti (luodaan automaattisesti) siirtymättä Ilmoitukset-välilehdeltä.",
"hc.trackYourStatistics": "Seuraa tilastoja",
"hc.tracking": "Seuranta",
"hc.unableToOpenTheShipping": "Ei voida avata lähetysmaksun maksamista. Yritä uudelleen.",
"hc.unableToRetrieveTheInvoice": "Laskua ei voida noutaa.",
"hc.unclaimed": "Noutamatta",
"hc.unclaimedCustomerReason": "Noutamaton tuote. Asiakkaan syy: \"{reason}\".",
"hc.unclaimedItem": "Noutamaton tuote",
"hc.unclaimedItemNoClaimWithin": "Noutamaton tuote — ei vaatimusta määräajan sisällä.",
"hc.unclaimedItems": "Noutamattomat tuotteet",
"hc.unclaimedItemsMatchLeftWithout": "Noutamattomat tuotteet: vastaus jätetty ilman vaatimusta määräajan sisällä. Voit palauttaa ne varastoon.",
"hc.unlockTheFinderSContact": "Avaa löytöä tekevien yhteystiedot käsittelyn järjestämiseksi.",
"hc.upcoming": "Tulevat",
"hc.updateFailed": "Päivitys epäonnistui.",
"hc.usedForInvoices": "Käytetään findloop-laskujen antamiseen.",
"hc.vatNumber": "ALV-numero",
"hc.verificationPending": "Vahvistus odottaa",
"hc.verificationSentToTheFinder": "Vahvistus lähetetty löytämälle. Saat tiedon heidän päätöksestään.",
"hc.verificationSentToThePartner": "Vahvistus lähetetty kumppanille. Saat tiedon heidän päätöksestään.",
"hc.verify": "Vahvista",
"hc.verifyingInvite": "Vahvataan kutsulinkkiä…",
"hc.verifyingTheLink": "Vahvataan linkkiä…",
"hc.viewInRegistry": "Näytä rekisterissä",
"hc.viewItem": "Näytä tuote",
"hc.viewItemRecover": "Näytä tuote ja palauta",
"hc.visibleToTheOwnerAutomatically": "Näkyvissä omistajalle · automaattisesti poistettu 60 päivän jälkeen.",
"hc.waitingForPartnerConfirmation": "Odotetaan kumppanin vahvistusta",
"hc.waitingForThePartnerS": "Odotetaan kumppanin vahvistusta",
"hc.weHaveInformedTheEstablishment": "Olemme tiedottaneet toimipistettä, että tämä tuote ei ole sinun ja käynnistäneet analyysin uudelleen. Saat ilmoituksen heti, kun uusi vastaavuus löydetään.",
"hc.weHaveInformedThePartner": "Olemme tiedottaneet kumppanille, että tämä tuote ei ole sinun. Ilmoituksesi pysyy aktiivisena tulevia vastaavuuksia varten.",
"hc.targetReached": "Tavoite saavutettu",
"hc.targetReachedThankYouTo": "Tavoite saavutettu — kiitos koko findloop-yhteisölle!",
"hc.tellUsMore": "Kerro meille lisää…",
"hc.tellUsWhyYouCancel": "Kerro miksi peruutat. Tämä auttaa kumppania käsittelemään pyyntösi.",
"hc.tellUsWhyYourListing": "Kerro miksi. Listauksesi pysyy aktiivisena ja voit silti hakea esinettäsi.",
"hc.termsAndConditions": "Käyttöehdot",
"hc.termsAndPolicies": "Ehdot ja käytännöt",
"hc.thankYouForYourFeedback": "Kiitos palautteestasi",
"hc.theBannerDisplayedInThe": "banneri, joka näkyy rekisterissä.",
"hc.theClaimantHasBeenInformed": "Vaatija on saanut tiedon. Esine pysyy saatavilla julkisessa listassa.",
"hc.theClaimantHasBeenNotified": "Vaatija on saanut ilmoituksen ja voi nyt edetä palautuksen kanssa.",
"hc.theCustomerPaysTheFees": "Asiakas maksaa maksut yritykselle.",
"hc.theDayTheLegalRetention": "Päivä, jolloin laillinen säilytysaika saavutetaan.",
"hc.theEstablishmentConsideredThatThis": "Yritys katsoi, että tämä esine ei ole sinun.",
"hc.theEstablishmentIsReviewingYour": "Yritys tarkastelee vastauksiasi. Saat ilmoituksen heti, kun vaatimuksesi vahvistetaan, sitten voit maksaa palautusmaksut.",
"hc.theFeesAreTooHigh": "Maksut ovat liian korkeat",
"hc.theFinderConsideredThatThis": "Löytäjä katsoi, että tämä esine ei ole sinun.",
"hc.theFinderIsReviewingYour": "Löytäjä tarkastelee vaatimustasi. Saat ilmoituksen heti, kun se vahvistetaan.",
"hc.theItem": "Esine",
"hc.theItemWillBeRemoved": "Esine poistetaan rekisteristä (ei käynnissä olevaa vaatimusta).",
"hc.theItemWillBeSet": "Esine palautetaan \"varastossa\" -tilaan ja siihen liittyvä vaade peruutetaan.",
"hc.theKbisNumberAndVat": "Kbis-numero ja ALV-numero tarvitaan Ranskassa.",
"hc.theLabelIsGeneratedAutomatically": "Tunnusluettelo luodaan automaattisesti heti, kun asiakas on maksanut toimituskulut. Se voidaan ladata täältä.",
"hc.theLinkMayHaveExpired": "Linkki on saattanut vanhentua (voimassa 30 päivää). Ota yhteyttä findloop-tukeen tarvittaessa.",
"hc.theOwnerDescribesTheirItem": "Omistaja kuvailee esineensä",
"hc.theOwnerReceivedItBy": "Omistaja sai sen sähköpostitse (tai SMS). Syötä tai skannaa se ennen luovutusta.",
"hc.thePartnerConsideredThatThis": "Kumppani katsoi, että tämä esine ei ole sinun. Esine pysyy saatavilla.",
"hc.thePartnerIsReviewingYour": "Kumppani tarkastelee vastauksiasi. Saat ilmoituksen heti, kun vaatimuksesi vahvistetaan.",
"hc.theShipmentIsCreatedAutomatically": "Lähetys luodaan automaattisesti, kun asiakas on vahvistanut osoitteensa ja maksanut palautusmaksut. Tunnusluettelo luodaan sitten automaattisesti maksun jälkeen, ja sen voi ladata täältä.",
"hc.theShippingRateWillBe": "Toimituskulut lasketaan automaattisesti Sendcloudin kautta toimituksen aikana (järjestetty paino).",
"hc.thisCarrierWillBe": "Tämä kuljetusyritys tulee olemaan",
"hc.thisEstablishment": "tämä yritys",
"hc.thisFieldIsRequiredFor": "Tämä kenttä on pakollinen automaattista tunnusluettelon luontia varten.",
"hc.thisIsMyItem": "Tämä on minun esineeni",
"hc.thisIsMyItemContinue": "Tämä on minun esineeni — jatka",
"hc.thisIsMyItemStart": "Tämä on minun esineeni — aloita palautus",
"hc.thisIsNotMyItem": "Tämä ei ole minun esineeni",
"hc.thisMatchIsNoLonger": "Tämä ottelu ei ole enää saatavilla tai se on jo käsitelty.",
"hc.thisRateWillBeCharged": "Tämä maksu veloitetaan asiakkaalta. Korkea maksu voi estää palautuksen.",
"hc.thisStepIsRequiredFor": "Tämä vaihe on tarpeen toimitustunnusten luomista varten",
"hc.weRanTheAnalysisAgain": "Suoritimme analyysin uudelleen ja löysimme toisen esineen, joka voisi olla sinun. Tarkista se uudelleen.",
"hc.weight": "Paino",
"hc.weightNotProvidedTheShipping": "Painoa ei ole ilmoitettu: toimituskulut lasketaan lähetyksen yhteydessä.",
"hc.weightUnit": "Painoyksikkö",
"hc.welcome": "Tervetuloa!",
"hc.welcomeToFindo": "Tervetuloa findoon",
"hc.whenACustomerComesTo": "Kun asiakas tulee noutamaan tavaransa, avaa heidän ilmoituksensa ja vahvista palautus. Siinä kaikki!",
"hc.whenDisabledFeesDropTo": ". Kun se on poistettu käytöstä, maksut laskevat",
"hc.whyIsThisNotYour": "Miksi tämä ei ole sinun esineesi?",
"hc.willBeMarkedAs": "merkitään",
"hc.wrongColor": "Väärä väri",
"hc.wrongModel": "Väärä malli",
"hc.yesCancel": "Kyllä, peruuta",
"hc.yesContactTheFinder": "Kyllä, ota yhteyttä löytöön",
"hc.youAreHere": "Olet tässä",
"hc.youBusinessCom": "sinä@yritys.com",
"hc.youCanNowStartThe": "Voit nyt aloittaa palautuksen.",
"hc.youCanStillChangeIt": ". Voit silti muuttaa sen tapauskohtaisesti.",
"hc.youHaveAlreadyConfirmedThat": "Olet jo vahvistanut, että tämä on sinun esineesi.",
"hc.youWillBeRedirectedTo": "Sinut ohjataan turvalliseen Stripe-maksuun.",
"hc.yourAccountHasBeenReactivated": "Tilisi on aktivoitu uudelleen.",
"hc.yourAccountIsActiveYou": "Tilisi on aktiivinen, voit nyt hallita toimipisteitäsi.",
"hc.yourEstablishment": "Toimipisteesi",
"hc.yourFeedbackHelpsUsImprove": "Palautteesi auttaa meitä parantamaan vastaavuuksiamme.",
"hc.yourFeedbackHelpsUsRestart": "Palautteesi auttaa meitä käynnistämään analyysin uudelleen ja parantamaan vastaavuuksiamme.",
"hc.yourFirstSteps": "Ensimmäiset askeleesi",
"hc.yourFirstStepsAdmin": "Ensimmäiset askeleesi (ylläpito)",
"hc.yourItemHasBeenHanded": "Esineesi on luovutettu henkilökohtaisesti kumppanilta — sulje tapaus, kun luovutus on vahvistettu.",
"hc.yourItemHasBeenShipped": "Esineesi on lähetetty kumppanilta — sulje tapaus, kun toimitus on vahvistettu.",
"hc.yourPaymentHasBeenRecorded": "Maksusi on kirjattu.",
"hc.yourShipmentIsBeingPrepared": "Lähetyksesi valmistellaan. Saat pakettisi 3–5 arkipäivän sisällä.",
"hc.yourShippingFeesHaveAlready": "Toimituskulusi on jo maksettu. Toimitus maksettu ✓",
"hc.yourShippingFeesHaveBeen": "Toimituskulusi on maksettu. Pakettisi valmistellaan.",
"hc.yourVerificationQuestionsDeposit": "Vahvistuskysymyksesi (talletus)",
"hero.einvoiceBadge": "2027-yhteensopiva e-laskutus",
"home.recentAdsAll": "Näytä kaikki ilmoitukset",
"home.recentAdsEyebrow": "Tällä hetkellä",
"home.recentAdsSubtitle": "Yhteisön ilmoittamat kadonneet ja löydetyt esineet.",
"home.recentAdsTitle": "Uusimmat ilmoitukset",
"home.reunions": "Äskettäiset palautukset",
"home.videoEyebrow": "Katso",
"home.videoSubtitle": "Kuinka yhdistämme kadonneet esineet niiden omistajille vaivattomasti.",
"home.videoTitle": "Tutustu findoon 2 minuutissa",
"home.watchYoutube": "Katso YouTubessa",
"impact.already": "Jo",
"impact.citiesWord": "kaupunki/kaupungit",
"impact.eachPoint": "Jokainen piste on kaupunki, jossa Findloop auttaa kadonneiden esineiden löytämisessä.",
"impact.emptyMap": "Kartta täyttyy palautusten myötä.",
"impact.eyebrow": "Vaikutuksemme",
"impact.inCities": "kaupungeissa",
"impact.restitutedTo": "esineet palautettu omistajilleen",
"impact.title": "Palautetut esineet, kaikkialla lähelläsi",
"inv2.download": "Lataa",
"inv2.view": "Näytä",
"map.objectsOnMapPlural": "esineitä kartalla",
"map.objectsOnMapSingular": "esine kartalla",
"mc.claimConfirmDesc": "Tarkista löytäneen löytämä esine ennen maksamista yhteystietojen unlockaamiseksi.",
"mc.claimConfirmNo": "Tämä ei ole minun esineeni",
"mc.claimConfirmTitle": "Onko tämä todella sinun esineesi?",
"mc.claimConfirmYes": "Kyllä, se on minun — maksa",
"mc.claimFinderContacts": "Löytäjän yhteystiedot",
"mc.claimNotMineDone": "Kiitos — löytääjä on ilmoitettu ja pyyntösi poistettiin ilmoituksesta.",
"mc.claimUnlockDesc": "Maksa findon hallintomaksu saadaksesi yhteystiedot henkilöltä, joka löysi esineesi.",
"mc.claimUnlockTitle": "Avaa löytäneen yhteystiedot",
"mc.hideCountryOffers": "Piilota tarjoukset maamassani",
"mc.myClaims": "Esineet, joita vaadin",
"mc.myClaimsSub": "Muiden löytämät esineet, joita vaadit. Avaa löytäneen yhteystiedot järjestääksesi luovutuksen.",
"mc.notifAdCancelled": "Ilmoitus peruutettu",
"mc.notifCancelAd": "Peruuta ilmoitukseni",
"mc.offersInCountry": "Tarjoukset maassani",
"mc.offersInCountryDesc": "Kaikki aktiiviset palkinnot kumppaneilta maassasi, kaupungin mukaan.",
"mc.redArchived": "Arkistoitu",
"mc.rewardsCountryNone": "Ei vielä tarjouksia maassasi.",
"mc.rewardsForYou": "Palkinnot sinulle",
"mc.rewardsForYouDesc": "Tarjottu kumppaneilta, joille jätit esineen.",
"mc.rewardsMineNone": "Ei vielä palkintoja sinun pudotuskumppaneiltasi.",
"mc.showCountryOffers": "Näytä tarjoukset maassani",
"mc2.cancelDecl": "Peruuta ilmoitukseni",
"mc2.cancelDeclDone": "Ilmoitus peruutettu.",
"pricing.physInvDesc": "Kun esine palautetaan, sen sijainti vapautuu automaattisesti ja on käytettävissä uudelle esineelle.",
"pricing.physInvTitle": "Fyysinen inventaarioseuranta",
"pricing.physModalTitle": "Fyysisten tavaroiden hallinta",
"pricing.physQrDesc": "Jokaiselle tuotteelle luodaan ainutlaatuinen QR-koodi, joka linkittää kaikkiin sen tietoihin.",
"pricing.physQrTitle": "Oma QR-tunnus",
"pricing.physShelfDesc": "Jokaiselle rekisteröidylle tuotteelle voidaan määrittää fyysinen sijainti toimipaikassa.",
"pricing.physShelfTitle": "Hyllysuunnitelma",
"pricing.physicalMgmt": "Fyysisten tuotteiden hallinta (hyllyt, QR, varasto)",
"pub.addSecondPhoto": "Lisää 2. valokuva (valinnainen)",
"pub.photo2Added": "✓ 2. valokuva lisätty",
"reg.dispositionJournal": "Jakeluasiakirja",
"reg.dispositionNoteAuthHint": "ℹ️ Huomautus on pakollinen, kun valitaan “Luovutettu viranomaisille” (ilmoitusnumero, osasto…).",
"reg.dispositionNotePh": "Huomautus (valinnainen): vastaanottava hyväntekeväisyys, viranomaisviite, ostajan nimi…",
"reg.dispositionNoteRequired": "Virallinen viite on vaadittu luovutettaessa viranomaisille.",
"reg.legalPrealert": "Lakivaativa aikaraja {days} päivä(n)",
"reg.legalPrealertOptions": "Aikarajan vaihtoehdot: huutokauppa, lahjoitus hyväntekeväisyyteen, luovutus viranomaisille.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Kattava arvostelu",
"rev.readMore": "Lue lisää",
"rw.activeCodes": "Aktiiviset kupongit",
"rw.archived": "Arkistoitu",
"rw.archivedTitle": "Hyödynnetyt kupongit (arkistoitu)",
"rw.hideArchived": "Piilota hyödynnetyt kupongit",
"rw.noArchived": "Ei arkistoitua kuponkia.",
"rw.showArchived": "Näytä hyödynnetyt kupongit",
"shp.labelAuto": "Tunnus luodaan automaattisesti heti, kun asiakas on maksanut toimituskulut. Se on ladattavissa täältä.",
"st.cancelled_by_customer": "Peruutettu",
"stt.dispoPdfBtn": "Vienti PDF-muodossa",
"stt.dispoPdfError": "PDF-vienti epäonnistui.",
"stt.dispoPdfExporting": "Viedään…",
"trk.matchVerifying": "Mahdollinen ottelu vahvistetaan",
"pcat.stadium_arena": "Stadion / Areena",
"pcat.supermarket": "Supermarketti",
"pcat.taxi_vtc": "Taksi / Kyytipalvelu",
"pcat.tourism_office": "Matkailutoimisto",
"pcat.train_bus_station": "Juna- / bussiasema",
"pcat.travel_agency": "Matkatoimisto",
"hc.and": "ja",
"hc.demoObj0": "lompakko",
"hc.demoObj1": "urheilulaukku",
"hc.demoObj2": "puhelin",
"hc.demoObj3": "aurinkolasit",
"hc.demoObj4": "avaimet",
"hc.demoObj5": "huivi",
"hc.demoObj6": "kannettava",
"hc.demoObj7": "juomapullo",
"hc.demoWhen0": "2 tuntia sitten",
"hc.demoWhen1": "5 tuntia sitten",
"hc.demoWhen2": "eilen",
"hc.demoWhen3": "3 tuntia sitten",
"hc.demoWhen4": "tänä aamuna",
"hc.demoWhen5": "1 päivä sitten",
"hc.feedDemo": "{obj} palautettiin {city} {when}.",
"hc.feedReal": "Tuote ({cat}) palautettiin {city}.",
"hc.saveBtn": "Tallenna",
"hc.saveLink": "Tallenna linkki",
"hc.terms": "Ehdot",
"hc.view": "Näytä",
"pcat.airline": "Lentoyhtiö",
"pcat.airport": "Lentokenttä",
"pcat.amusement_park": "Huvipuisto",
"pcat.bank": "Pankki",
"pcat.bar_cafe": "Baari / Kahvila",
"pcat.beauty_salon": "Kampaamo / Kauneussalonki",
"pcat.cinema": "Elokuvateatteri",
"pcat.concert_theater": "Konserttisali / Teatteri",
"pcat.coworking": "Yhteistyötila",
"pcat.gym_fitness": "Kuntosali / Fitness",
"pcat.hospital_clinic": "Sairaala / Klinikka",
"pcat.library": "Kirjasto",
"pcat.mall": "Ostoskeskus",
"pcat.museum": "Museo",
"pcat.pharmacy": "Apteekki",
"pcat.private_company": "Yksityinen yritys",
"pcat.public_transport": "Julkinen liikenne",
"pcat.school_university": "Koulu / Yliopisto",
"pcat.sports_center": "Urheilukeskus",
"an.found": "Löydetty",
"an.lost": "Kadonnut",
"hc.shareReview": "Jaa arvostelu",
"hc.citiesAboveTarget": "{n} kaupunkia tavoitteen yläpuolella",
"hc.cityAboveTarget": "{n} kaupunki tavoitteen yläpuolella",
"hc.j15EarlyReminder": "D-15 ennakkovaroitus",
"hc.j7EarlyReminder": "D-7 ennakkovaroitus",
"hc.annualTotal": "Vuosittainen kokonaisuus",
"hc.billedOnceYear": "Laskutetaan kerran 12 kuukaudesta, uusitaan joka vuosi.",
"hc.monthlyPrice": "Kuukausihinta",
"hc.perMonth": "/ kuukausi",
"hc.perYear": "/ vuosi",
"hc.billedEachMonth": "Laskutetaan automaattisesti joka kuukausi.",
"nav.business": "Liiketoiminta",
"nav.individual": "Yksilö",
"hc.circumstancesFound": "Löytötilanne",
"hc.circumstancesFoundPh": "Esim. löytyi maasta metrooven läheltä",
"hc.circumstancesLost": "Hävikkitilanne",
"hc.circumstancesLostPh": "Esim. jätetty penkille bussin odotuksessa",
"hc.conditionPh": "Esim. hyvä, naarmuinen…",
"hc.firstName": "Etunimi",
"hc.lastName": "Sukunimi",
"hc.quantity": "Esineiden määrä",
"fa.approve": "Hyväksyä",
"fa.approveConfirm": "Hyväksytkö tämän ilmoituksen? Kokonaiscontact-tietosi (nimi, sähköposti, puhelin) vaihdetaan löytäneen kanssa.",
"fa.approved": "Ilmoitus hyväksytty — yhteystiedot vaihdettu",
"fa.approvedFinder": "Omistaja on hyväksynyt ilmoituksesi",
"fa.approvedFinderText": "Ota heihin yhteyttä järjestääksesi palautuksen.",
"fa.boostSub": "Ilmoituksesi pysyy ylimpänä valitun ajan.",
"fa.boostTitle": "Kohota ilmoitustani (valinnainen)",
"fa.colFinder": "Löytäjän ilmoitus",
"fa.colYours": "Sinun ilmoituksesi",
"fa.compareHint": "Vertaile löytäneen ilmoitusta omaasi ennen päätöksentekoa.",
"fa.contribNone": "Ei panostusta",
"fa.contribPaid": "Panostus vastaanotettu — kiitos!",
"fa.contribPending": "Panostus odottaa maksua",
"fa.contribSub": "Tue findoa, jotta voimme auttaa enemmän ihmisiä saamaan omistuksensa takaisin. Voit valita €0.",
"fa.contribSuccessMsg": "Ilmoituksesi on lähetetty omistajalle.",
"fa.contribSuccessTitle": "Kiitos panostuksestasi",
"fa.contribTitle": "Vapaaehtoinen panostus",
"fa.days3": "3 päivää",
"fa.days30": "30 päivää",
"fa.days7": "7 päivää",
"fa.declSub": "Kuvaile löytynyt esine. Omistaja vertaa ilmoitustasi omansa kanssa.",
"fa.declTitle": "Löysin tämän esineen",
"fa.expiresOn": "Vanhenee",
"fa.fBrand": "Brändi",
"fa.fCircumstances": "Olosuhteet",
"fa.fCity": "Kaupunki",
"fa.fColor": "Väri",
"fa.fCondition": "Kunto",
"fa.fDate": "Päivämäärä",
"fa.fMessage": "Löytäjän viesti",
"fa.fPlace": "Paikka",
"fa.fQuantity": "Määrä",
"fa.finderContact": "Löytäjän yhteystiedot",
"fa.finishPay": "Viimeistele maksaminen",
"fa.foundDate": "Löytöpäivämäärä",
"fa.foundPlace": "Löytöpaikka",
"fa.hours24": "24 tuntia",
"fa.ht": "ilman ALV:tä",
"fa.months3": "3 kuukautta",
"fa.noBoost": "Ei kohotusta",
"fa.ownerContact": "Omistajan yhteystiedot",
"fa.payPublish": "Maksa ja julkaise",
"fa.pendingPayText": "Ilmoituksesi tulee näkyviin heti, kun maksaminen on vahvistettu.",
"fa.pendingPayTitle": "Maksua odotellaan",
"fa.planSub": "Ilmoituksesi tulee näkyviin heti, kun maksaminen on vahvistettu.",
"fa.planTitle": "Ilmoituksen kesto",
"fa.pubSuccessMsg": "Ilmoituksesi on nähtävillä. Saat ilmoituksen heti, kun etsijä ottaa yhteyttä.",
"fa.pubSuccessTitle": "Ilmoitus julkaistu",
"fa.publicNote": "Vain kuvaus, kaupunki, maa ja valokuvat näkyvät julkisesti.",
"fa.redirectStripe": "Siirrytään turvalliseen maksamiseen…",
"fa.reject": "Hylkää",
"fa.rejectConfirm": "Hylkää tämä ilmoitus? Ilmoituksesi pysyy näkyvillä.",
"fa.rejected": "Ilmoitus hylätty",
"fa.rejectedFinder": "Se ei ollut etsimänsä tuote",
"fa.rejectedFinderText": "Omistaja sanoo, että tämä tuote ei ole hänen. Kiitos avustasi!",
"fa.responsesTitle": "Etsijöiden ilmoitukset",
"fa.sent": "Ilmoitus lähetetty omistajalle.",
"fa.submitDecl": "Lähetä ilmoitukseni",
"fa.submitDeclPay": "Lähetä ja osallistu {amount}",
"fa.total": "Maksettava summa",
"fa.ttc": "sis. ALV",
"fa.waitClaimText": "Etsijä tarkistaa pyyntösi. Saat ilmoituksen heidän päätöksestään.",
"fa.waitFinderText": "Ilmoitamme sinulle, heti kun etsijä lähettää ilmoituksen.",
"fa.waitFinderTitle": "Ilmoituksesi on näkyvillä",
"fa.waitOwnerText": "Omistaja vertaa ilmoitustasi omaansa. Saat ilmoituksen heidän päätöksestään.",
"fa.waitOwnerTitle": "Odotetaan omistajan päätöstä",
"st.pending_payment": "Maksua odotellaan",
"fa.africaFree": "Ilmainen ilmoitus Afrikassa — Findloop lanseeraustarjous, nauti siitä!",
"fa.africaPublished": "Ilmoitus julkaistu ilmaiseksi — Afrikan lanseeraustarjous!",
"fa.approveClaimConfirm": "Hyväksytkö tämän vaatimuksen? Omistaja voi sitten avata yhteystietosi.",
"fa.checkInfo": "Tarkista tietosi ennen lähettämistä: niitä verrataan löytjän tietoihin.",
"fa.claimApprovedShort": "Löytäjä hyväksyi vaatimuksesi",
"fa.claimRejectedShort": "Vaatimus hylätty löytjän toimesta",
"fa.claimRejectedText": "Löytäjä uskoo, että tämä esine ei ole sinun.",
"fa.claimSub": "Kuvaile esinettäsi ja lisää 2 kuvaa. Löytäjä vertaa niitä heidän ilmoitukseensa.",
"fa.claimTitle": "Tämä on esineeni",
"fa.claimUnlockText": "Avaa löytjän yhteystiedot järjestääksesi palautus.",
"fa.claimUnlockedShort": "Yhteystiedot avattu — katso seuranta",
"fa.claimsTitle": "Omistajan vaatimukset",
"fa.colOwner": "Omistajan ilmoitus",
"fa.colYourAd": "Ilmoituksesi",
"fa.expired": "Ilmoitus vanhentunut",
"fa.free": "Ilmainen",
"fa.lostDate": "Kadonnut päivä",
"fa.lostPlace": "Kadonnut paikka",
"fa.noReceipt": "Ei kuittia saatavilla tälle ilmoitukselle.",
"fa.planSubFree": "Valitse kesto: ilmoituksesi julkaistaan heti, ei maksua tarvitaan.",
"fa.prefillPrevious": "Käytä aikaisemman ilmoitukseni tietoja tässä kategoriassa",
"fa.receipt": "PDF-kuitti",
"fa.renewBtn": "Uudista",
"fa.renewDiscountBanner": "50% alennus: uudista ennen kuin ilmoituksesi vanhentuu!",
"fa.renewDiscountHint": "50% alennus sovellettiin, koska uudistat ennen vanhentumista.",
"fa.renewEarly": "Uudista (−50%)",
"fa.renewTitle": "Uudista ilmoitukseni",
"fa.renewed": "Ilmoitus uudistettu",
"fa.sendClaim": "Lähetä vaatimus",
"fa.twoPhotos": "2 kuvaa esineestäsi",
"fa.twoPhotosError": "Lisää 2 kuvaa esineestäsi.",
"fa.twoPhotosHint": "Henkilökohtaiset kuvat, jotka todistavat, että esine on sinun (esineen, laskun, laatikon kanssa…).",
"fa.unlockBtn": "Avaa yhteystiedot",
"fa.unlockFree": "Avaa ilmaiseksi — lanseeraustarjous",
"fa.waitClaimantText": "Ilmoitamme sinulle heti, kun omistaja hakee tätä esinettä.",
"fa.waitFinderDecision": "Odotetaan löytjän päätöstä",
"fa.waitUnlockText": "Saat ilmoituksen heti, kun yhteystiedot vaihdetaan.",
"fa.waitUnlockTitle": "Odotetaan, että omistaja avaa",
"fa.cancel": "Peruuta",
"fa.categoryRequired": "Valitse kategoria löydetylle tuotteelle.",
"fa.confirmTitle": "Vahvista päätöksesi",
"fa.goBack": "Palaa takaisin",
"dr.continue": "Jatka ilmoitustani",
"dr.delete": "Poista pysyvästi",
"dr.deleteConfirm": "Poistetaanko tämä luonnos pysyvästi? Tätä ei voi peruuttaa.",
"dr.deleted": "Luonnos poistettu",
"dr.expiresIn": "Luonnos säilytetään vielä {h} tuntia",
"dr.title": "Sinulla on keskeneräinen ilmoitus",
"form.step": "Vaihe",
"form.next": "Jatka",
"form.back": "Takaisin",
"form.stepDetails": "Raporttisi",
"form.stepPublish": "Kesto, tuki ja maksaminen",
"form.stepThanks": "Kiitos & panoksesi",
"fthx.badge": "Raportti lähes valmis",
"fthx.title": "Kiitos, teet eron!",
"fthx.text": "Kiitos sinulle, joku saattaa pian saada takaisin jotain, mikä merkitsee heille. Kaltaisesi ystävälliset teot pitävät Findloopin elinvoimaisena.",
"fthx.impact1": "1 ilmoitettu esine",
"fthx.impact2": "1 mahdollisuus uudelleen kokoontumiseen lisää",
"fthx.tipTitle": "Pieni tuki Findloopille?",
"fthx.tipText": "Panoksesi auttaa meitä pitämään palvelun saavutettavana ja yhdistämään yhä enemmän esineitä niiden omistajille.",
"fthx.optional": "100% vapaaehtoinen — voit julkaista ilman osallistumista.",
"fthx.thanksTip": "Kiitos paljon anteliaisuudestasi!",
"fthx.suggest": "Ehdotetut summat",
"fthx.none": "Ei vinkkiä",
"pay.pendingTitle": "Maksu ei ole valmis",
"pay.pendingText": "Tietosi on tallennettu. Jatka maksamista siitä, mihin jäit.",
"pay.resume": "Jatka maksamista",
"pay.expiredTitle": "Maksusessio on vanhentunut",
"pay.expiredText": "Turvallisuutesi vuoksi maksusessio on vanhentunut. Tietosi on tallennettu: käynnistä maksu yhdellä klikkauksella.",
"pay.relaunch": "Käynnistä maksu uudelleen",
"sub.received": "Lähetetty!",
"sub.publishing": "Viimeistelemme…",
"sub.toPayment": "Siirtyminen turvalliseen maksamiseen…",
"fa.claimSubV2": "Kuvaile kadonnutta esinettäsi. Esineen löytäjä vertaa ilmoitustasi heidän listaansa.",
"fa.photosOptional": "Kuvia esineestäsi (valinnainen)",
"fa.compareOwnerHint": "Vertaile tätä tietoa löytämäsi esineen kanssa ja kerro, onko se sama esine.",
"fa.itsThisItem": "Kyllä, tämä on esine",
"fa.notThisItem": "Ei, tämä ei ole esine",
"fa.confirmIsItem": "Vahvista, että tämä on esine? Yhteystietosi ja omistajan tiedot näkyvät omissa tileissäsi.",
"fa.confirmNotItem": "Vahvista, että tämä ei ole esine? Ilmoituksesi suljetaan.",
"fa.youConfirmed": "Vahvistit, että tämä on omistajan esine",
"fa.youDeclined": "Ilmoitit, että tämä ei ollut esine",
"fa.youDeclinedText": "Kiitos avustasi! Omistajalle on ilmoitettu.",
"fa.waitFinderDecisionOwner": "Odotetaan löytjän päätöstä",
"fa.finderConfirmed": "Vahvistettu",
"fa.notYourItem": "Tämä ei ollut sinun esineesi",
"fa.reportedOn": "Ilmoitettu",
"fa.ownerWaitHint": "Löytäjä tarkistaa parhaillaan tiedot, ole hyvä ja odota.",
"fa.claimSentFinder": "Väite lähetetty henkilölle, joka löysi esineen.",
"fa.compareClaimHint": "Vertaile omistajan ilmoitusta ilmoituksesi kanssa ennen päätöksen tekemistä.",
"fa.closeFollowup": "Sulje tämä seuranta",
"fa.closeFollowupConfirm": "Sulje tämä seuranta? Molempien osapuolten sähköpostiosoitteet ja puhelinnumerot poistetaan pysyvästi, kun omistaja on myös sulkenut ilmoituksensa.",
"fa.safetyTitle": "Turvallisuusvinkit luovutuksen ennen",
"fa.safety1": "Kysy omistajalta yksityiskohtainen kuvaus esineen piilotetuista ominaisuuksista: tietystä naarmusta, laukun tarkasta sisällöstä, tapetista, sarjanumerosta...",
"fa.safety2": "Jos mahdollista, pyydä visuaalista todistusta (valokuva esineestä) tai ostotositetta.",
"fa.safety3": "Luovuta esine julkisessa paikassa tai Findloopin kumppanilla, ja tarkista omistajan henkilöllisyys.",
"fa.safetyOk": "Selvä, jatka",
"fa.ownerClosedNote": "Omistaja on sulkenut ilmoituksensa.",
"fa.finderClosedNote": "Löytäjä on sulkenut seurannan.",
"fa.followupClosed": "Seuranta suljettu",
"fa.followupClosedText": "Sulkivat tämän seurannan. Kiitos avustasi!",
"fa.photoReviewTitle": "Etsijä lähetti valokuvan. Näyttääkö se oman esineesi kaltaiselta?",
"fa.photoLooksLike": "Kyllä, se näyttää omalta esineeltäni",
"fa.photoNotMine": "Ei, tämä ei ole minun esineeni",
"fa.photoNotMineConfirm": "Seuranta suljetaan molemmilta puolilta ja ilmoituksesi pysyy avoinna uudelle etsijälle.",
"fa.photoLooksLikeDone": "Kiitos! Etsijä vertaa nyt ilmoitustasi.",
"fa.photoNotMineDone": "Ilmoitus hylätty. Ilmoituksesi pysyy avoinna.",
"fa.ownerPhotoHint": "Näet vain etsijän valokuvan. Kerro meille, näyttääkö se omalta esineeltäsi.",
"fa.ownerReviewingPhoto": "Omistaja tarkistaa valokuvasi",
"fa.ownerReviewingPhotoText": "Saat ilmoituksen heti, kun he vastaavat. Voit sitten vertailla heidän ilmoitustaan.",
"fa.ownerRejectedPhoto": "Tämä ei ole omistajan esine",
"fa.ownerRejectedPhotoText": "Omistaja sanoo, että valokuvasi ei vastaa heidän esineensä. Seuranta on suljettu. Kiitos avustasi!",
"fa.contribute": "Osallistua",
"fa.phoneMissing": "Ei saatavilla",
"fa.ownerSafety1": "Suosi luovutusta julkisessa paikassa tai Findloopin kumppanin luona. Jos etäisyys on pitkä, ehdota lähettämistä postitse sen sijaan.",
"fa.ownerSafety2": "Luovutuksen yhteydessä tarkista löytäjän henkilöllisyys.",
"pub.changePhoto": "Vaihda kuva",
"ph.secured": "Valokuva suojattu",
"ph.securing": "Suojaan valokuvaa…",
"fa.ownerSafety3": "Jos löytäjän valokuvassa on Findloop-vedos, älä hyväksy tapaamista. Valokuvan on oltava alkuperäinen kuva, jonka löytäjä on ottanut, ilman vedosta."
},
"no": {
"a.back": "Tilbake",
"a.category": "Kategori",
"a.categoryPlaceholder": "Velg en kategori",
"a.city": "By",
"a.confirmPassword": "Bekreft passord",
"a.country": "Land",
"a.createAccount": "Opprett en konto",
"a.createBtn": "Opprett kontoen min",
"a.creating": "Oppretter…",
"a.email": "E-post",
"a.emailPro": "Bedrifts-e-post",
"a.forgot": "Glemt?",
"a.forgotSent": "Hvis en konto eksisterer, har en tilbakestillingslink nettopp blitt sendt.",
"a.forgotSub": "Få en tilbakestillingslink på e-post.",
"a.forgotTitle": "Glemt passord",
"a.googleContinue": "Fortsett med Google",
"a.googleSignup": "Registrer deg med Google",
"a.haveAccount": "Allerede en partner?",
"a.legalHint": "Påkrevd for fransk e-fakturering (Factur-X) av franske etableringer.",
"a.legalRequiredFR": "SIRET og intra-EU momsnummer er obligatorisk for Frankrike.",
"a.loggingIn": "Logger inn…",
"a.login": "Logg inn",
"a.loginSub": "Få tilgang til ditt administrasjonsområde.",
"a.loginTitle": "Partner innlogging",
"a.min6": "Minimum 6 tegn",
"a.newPassword": "Nytt passord",
"a.noAccount": "Ikke partner ennå?",
"a.or": "ELLER",
"a.org": "Etableringsnavn",
"a.password": "Passord",
"a.passwordMismatch": "Passordene samsvarer ikke.",
"a.referral": "Henvisningskode (valgfritt)",
"a.registerSub": "Opprett ditt område på 1 minutt — gratis for å starte.",
"a.registerTitle": "Bli partner",
"a.rememberMe": "Husk meg",
"a.reset": "Tilbakestill",
"a.resetSub": "Velg et nytt passord for kontoen din.",
"a.resetTitle": "Nytt passord",
"a.sendLink": "Send lenken",
"a.sending": "Sender…",
"a.signin": "Logg inn",
"a.siret": "SIRET",
"a.vat": "Intra-EU moms nr.",
"ac.africa": "Afrika",
"ac.boostActive": "Fremhev aktiv —",
"ac.boostSub": "Vises øverst i partnerkatalogen med et \"Fremhevet\" merke.",
"ac.boostTitle": "Fremhev oppføringen din i katalogen",
"ac.categoryHint": "For å klassifisere din etablissement i findloop-katalogen.",
"ac.choose": "Velg",
"ac.cityHint": "For presis posisjonering på det offentlige kartet.",
"ac.cityLabel": "Etableringsby",
"ac.cityPh": "Paris",
"ac.contact": "Kontaktopplysninger",
"ac.converted": "Konvertert",
"ac.copyDeclLink": "Kopier erklæringslenken",
"ac.copyLink": "Kopier lenken",
"ac.currentPlan": "Nåværende plan",
"ac.emailDesc": "Velg e-postene du vil motta. Varsler i arbeidsområdet ditt forblir alltid aktive.",
"ac.emailMatch": "Samsvarer",
"ac.emailMatchDesc": "En e-post når et element samsvarer med en erklæring",
"ac.emailNewDecl": "Nye tapsrapporter",
"ac.emailNewDeclDesc": "En e-post så snart en kunde rapporterer et tap på ditt sted",
"ac.emailShip": "Fraktforespørsel",
"ac.emailShipDesc": "En e-post når en kunde ber om frakt av en vare",
"ac.emailTitle": "E-postinnstillinger",
"ac.expireSoon": "Din høydepunkt utløper snart —",
"ac.exportCsv": "Eksporter (CSV)",
"ac.exportHint": "Eksporter dine validerte eksterne betalinger for regnskapet ditt.",
"ac.free": "Gratis",
"ac.freeMonths": "Gratis måneder",
"ac.hours": "timer",
"ac.howItWorks": "Hvordan fungerer det?",
"ac.invited": "Invitert",
"ac.legalFR": "Obligatorisk for elektronisk fakturering (Factur-X) gjeldende fra september 2026.",
"ac.legalMissing": "⚠️ SIRET og intra-EU MVA mangler — fullfør dem for å forbli i samsvar med elektronisk fakturering.",
"ac.legalOther": "Anbefalt for fakturaene dine.",
"ac.legalPartnerQr": "QR-kode",
"ac.legalTitle": "Juridiske identifikatorer (fakturering)",
"ac.logoTitle": "Etableringslogo",
"ac.modeCurrent": "Nåværende modus:",
"ac.modeExternal": "Ekstern (manuell validering)",
"ac.modeInternal": "Intern Findloop (automatisk)",
"ac.noSubReceipt": "Ingen betalt abonnementsbetaling ennå.",
"ac.none": "Ingen",
"ac.onYourListing": "på din oppføring",
"ac.pay1": "Skriv inn betalingslenkene dine nedenfor for å omdirigere kundene dine til ditt eget betalingssystem.",
"ac.pay2": "Validering blir manuell: du bekrefter betalingsmottak fra fanen “Erklæringer”.",
"ac.pay3": "Lenken “Fraktgebyr” er en samlet betaling (henting + frakt).",
"ac.pay4": "La feltene stå tomme for å bruke Findos interne betaling (Stripe) med automatisk validering.",
"ac.paySub": "Samle inn gebyrer via ditt eget betalningssystem.",
"ac.payTitle": "Eksterne betalinger",
"ac.permissive": "Tolerant",
"ac.phone": "Telefon",
"ac.posterA4": "A4 plakat (PDF)",
"ac.qMessage": "Melding (valgfritt)",
"ac.qName": "Navn",
"ac.qOrg": "Organisasjon",
"ac.qSites": "Antall etableringer (estimert)",
"ac.qrHint": "Dine kunder skanner denne koden for å rapportere et tapt objekt.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Din partner QR-kode",
"ac.quoteDesc": "Lufthavner, jernbanenett, internasjonale kjeder · ",
"ac.quoteEurope": "Europa / Verden",
"ac.quoteSent": "Forespørsel om tilbud sendt. Vårt team kommer snart tilbake til deg.",
"ac.quoteTitle": "Be om et tilbud — Bedrift",
"ac.recoveryLink": "“Hentingsgebyr” lenke",
"ac.refSub": "Hver henvist partner som abonnerer gir deg 1 gratis måned.",
"ac.refTitle": "Henvis, tjen en gratis måned",
"ac.reminderDelay": "Påminnelse om valideringsforsinkelse",
"ac.reminderHint": "Du vil motta en e-postpåminnelse hvis en ekstern betaling forblir uvaliderte utover denne forsinkelsen (standard: 48t).",
"ac.renewDesc1": "Det har allerede brakt deg",
"ac.renewDesc2": "Forny for å forbli på toppen av katalogen og ikke miste denne synligheten.",
"ac.renewNow": "Forny nå",
"ac.requestQuote": "Be om et tilbud",
"ac.saveLegal": "Lagre identifikatorene",
"ac.saveLinks": "Lagre lenkene",
"ac.sendRequest": "Send min forespørsel",
"ac.sending": "Sender…",
"ac.shippingLink": "“Fraktgebyr” lenke (samlet)",
"ac.shippingLinkHint": "Denne lenken dekker både henting og frakt.",
"ac.strict": "Streng",
"ac.subReceipt": "Abonnementskvittering (PDF)",
"ac.subReceiptsSub": "Last ned PDF-kvittering for hver abonnementsbetaling.",
"ac.subReceiptsTitle": "Abonnementskvitteringer",
"ac.tCategory": "Kategori lagret",
"ac.tCity": "By lagret — kart oppdatert",
"ac.tCityNeeded": "Skriv inn en by",
"ac.tCopied": "Kopiert!",
"ac.tCover": "Omslagsbilde oppdatert",
"ac.tEmailPrefs": "E-postinnstillinger oppdatert",
"ac.tErr": "Feil",
"ac.tExportImpossible": "Eksport mislyktes",
"ac.tLegal": "Juridiske identifikatorer lagret",
"ac.tLegalNeeded": "SIRET og MVA kreves for Frankrike",
"ac.tLogo": "Logo oppdatert",
"ac.tLogoRemoved": "Logo fjernet",
"ac.tPayLinks": "Betalingslenker lagret",
"ac.tPhone": "Telefon lagret",
"ac.tSensitivity": "Sensitivitet lagret",
"ac.tVatInvalid": "Ugyldig MVA-nummer",
"ac.tVatValid": "Gyldig MVA",
"ac.tabBoost": "Synlighet",
"ac.tabPayments": "Betalinger",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Plakat",
"ac.tabReferral": "Henvisning",
"ac.tabSub": "Abonnement",
"ac.thisWeek": "Denne uken",
"ac.thisWeekOf": " ({n} denne uken)",
"ac.thresholdDesc": "Tillitsgrense fra hvilken AI automatisk validerer et bildegjenkjennings-match og varsler kunden. Høyere = færre automatch, men mer pålitelig.",
"ac.thresholdTitle": "AI visuell match-sensitivitet",
"ac.trend": "Trend",
"ac.upload": "Last opp",
"ac.vatValidFmt": "Gyldig MVA{name} ({via})",
"ac.vatVerified": "Intra-EU MVA verifisert",
"ac.verifyVat": "Verifiser MVA (VIES)",
"ac.verifying": "Verifiserer…",
"ac.views": "visninger",
"ac.viewsTotal": "Visninger oppnådd (totalt)",
"ac.winbackBtn": "Gjenoppta med -20%",
"ac.winbackDesc1": "Det gav deg",
"ac.winbackDesc2": "Spesialtilbud: -20% anvendt automatisk hvis du fornyer innen 24h.",
"ac.winbackTitle": "Din høydepunkt har akkurat utløpt — gjenoppta med -20%!",
"ad.boost": "Boost",
"ad.close": "Lukk",
"ad.closeConfirm": "Lukke denne oppføringen?",
"ad.closed": "Oppføring lukket",
"ad.edit": "Rediger",
"ad.editTitle": "Rediger oppføring",
"ad.saved": "Oppføring oppdatert",
"an.allCountries": "Alle land",
"an.badge": "Tapte gjenstander",
"an.boostLater": "Senere",
"an.boostNow": "Boost nå",
"an.boostPrompt": "Boost oppføringen din for å plassere den på toppen og bli funnet raskere.",
"an.boosted": "Boostet",
"an.contact": "Jeg fant denne gjenstanden",
"an.contactTitle": "Rapporter at du fant denne gjenstanden",
"an.copyFailed": "Kunne ikke kopiere lenken",
"an.copyLink": "Kopier lenke",
"an.country": "Land",
"an.date": "Dato tapt",
"an.finderEmail": "Din e-post",
"an.finderName": "Ditt navn",
"an.finderPhone": "Din telefon",
"an.geoBanner": "Du ser på annonser i",
"an.geoBannerWorld": "Du ser på annonser verden over",
"an.geoChange": "endre land",
"an.goAccount": "Gå til kontoen min",
"an.linkCopied": "Lenke kopiert!",
"an.loginRequired": "Logg inn for å rapportere dette elementet og følge returen.",
"an.loginToBoost": "Logg inn for å booste denne annonsen",
"an.lostAt": "Tapt på",
"an.message": "Melding (valgfri)",
"an.none": "Ingen annonser enda.",
"an.photo": "Foto (valgfri)",
"an.post": "Legg ut en annonse",
"an.postSubtitle": "Beskriv din tapte gjenstand – fellesskapet og våre partnere hjelper deg med å finne den.",
"an.postTitle": "Rapporter en tapt gjenstand",
"an.publish": "Publiser annonse",
"an.published": "Annonse publisert!",
"an.publishing": "Publiserer…",
"an.remaining": "igjen",
"an.requestInProgress": "Forespørsel pågår",
"an.resolved": "Gjenstand allerede hentet",
"an.reward": "Belønning",
"an.searchPh": "Søk en annonse…",
"an.send": "Send",
"an.sent": "Melding sendt til eieren!",
"an.shareConsent": "Jeg samtykker i at mine kontaktopplysninger (navn, e-post, telefon) kan deles med eieren av gjenstanden.",
"an.shareConsentError": "Vennligst huk av boksen for å dele kontaktopplysningene dine.",
"an.sortRecent": "Nyeste",
"an.sortRelevance": "Relevans",
"an.subtitle": "Bla gjennom gjenstander rapportert tapt av fellesskapet. Fant du en av dem?",
"an.title": "Annonser for tapte gjenstander",
"anf.badge": "Funnet gjenstander",
"anf.claim": "Dette er mitt",
"anf.claimSent": "Melding sendt til finneren!",
"anf.claimTitle": "Rapporter at dette er din gjenstand",
"anf.consent": "Jeg samtykker i at eieren kan se mine kontaktopplysninger for å gjenvinne gjenstanden sin.",
"anf.foundAt": "Funnet på",
"anf.foundDate": "Dato funnet",
"anf.loginCta": "Logg inn / opprett en konto",
"anf.loginDesc": "En finnerkonto er nødvendig for å publisere en annonse og tjene Finder Hero-poeng.",
"anf.loginRequired": "Logg inn for å legge ut en funnet gjenstand",
"anf.photo": "Gjenstandens foto",
"anf.pointsEarned": "Takk! Du har nettopp tjent Finder Hero-poeng.",
"anf.pointsPending": "Poengene dine vil bli kreditert innen 24 timer, etter verifisering.",
"anf.post": "Legg ut en funnet gjenstand",
"anf.postSubtitle": "Beskriv gjenstanden du fant – hjelp eieren med å få den tilbake.",
"anf.postTitle": "Rapporter en funnet gjenstand",
"anf.publishFound": "Publiser funnet annonse",
"anf.published": "Annonse for funnet gjenstand publisert",
"anf.publishedAs": "Publisert som",
"anf.shareConsent": "Jeg samtykker i at mine kontaktopplysninger (navn, e-post, telefon) kan deles med personen som fant gjenstanden.",
"anf.subtitle": "Bla gjennom gjenstander funnet og rapportert av fellesskapet. Kjenner du igjen din?",
"anf.title": "Annonser for funnet gjenstand",
"bo.active": "Boost aktiv",
"bo.africaPrice": "Preferansepriser for Afrika-sonen gjelder",
"bo.pay": "Betal & boost",
"bo.remaining": "Tid igjen",
"bo.renew": "Forny boost",
"bo.since": "siden boost",
"bo.subtitle": "Sett oppføringen din på toppen av listen med et synlig merke.",
"bo.title": "Boost oppføring",
"c.all": "Alle",
"c.cancel": "Avbryt",
"c.close": "Lukk",
"c.confirm": "Bekreft",
"c.confirmed": "Bekreftet",
"c.download": "Last ned",
"c.loading": "Laster…",
"c.reset": "Tilbakestill",
"c.reviews": "vurderinger",
"c.save": "Lagre",
"c.transfer": "Overfør",
"cat.Animal": "Kjæledyr / Kjæledyrtilbehør",
"cat.AppareilPhoto": "Kamera",
"cat.Argent": "Penger / Kontanter",
"cat.Autres": "Annet",
"cat.Bijoux": "Smykker",
"cat.CarteBancaire": "Bankkort",
"cat.CarteIdentite": "ID-kort / Pass",
"cat.Casquette": "Caps / Hatt",
"cat.Ceinture": "Belte",
"cat.Chargeur": "Lader / Kabel",
"cat.Chaussures": "Sko",
"cat.CleVoiture": "Bilnøkkel",
"cat.Cles": "Nøkler",
"cat.Console": "Spillkonsoll",
"cat.Documents": "Dokumenter / Papirer",
"cat.Echarpe": "Skjerf",
"cat.Ecouteurs": "Ørepropper / Hodetelefoner",
"cat.Electronique": "Elektronikk (annet)",
"cat.Enceinte": "Høyttaler",
"cat.Gants": "Hansker",
"cat.Gourde": "Vannflaske / Termos",
"cat.Instrument": "Musikkinstrument",
"cat.Jouet": "Leke / Kosedyr",
"cat.Jumelles": "Kikkert",
"cat.Lampe": "Lampe / Lommelykt",
"cat.Liseuse": "E-bokleser",
"cat.Livre": "Bok / Notatbok",
"cat.Lunettes": "Briller",
"cat.Manteau": "Frakk / Jakke",
"cat.Maquillage": "Sminkepung",
"cat.Medical": "Medisinsk utstyr",
"cat.Medicaments": "Medikamenter",
"cat.Montre": "Klokke / Smartklokke",
"cat.Ordinateur": "Bærbar PC",
"cat.Parapluie": "Paraply",
"cat.Portefeuille": "Lommebok / Veske",
"cat.Poussette": "Barnevogn / Babytilbehør",
"cat.Sac": "Veske / Handvogn",
"cat.SacADos": "Rygsekk",
"cat.Souris": "Mus / Tastatur",
"cat.Sport": "Sportutstyr",
"cat.Tablette": "Tablett",
"cat.Telephone": "Telefon / Smarttelefon",
"cat.Trottinette": "Sparkesykkel",
"cat.Trousse": "Pung / Etui",
"cat.USB": "USB-minne / Harddisk",
"cat.Valise": "Koffert / Bagasje",
"cat.Velo": "Sykkel",
"cat.Vetements": "Klær",
"cat.placeholder": "Velg en kategori",
"cd.d": "d",
"cd.expired": "Utgått",
"cd.h": "t",
"cd.m": "min",
"ck.accept": "Godta",
"ck.acceptAll": "Godta alle",
"ck.customize": "Tilpass",
"ck.learn": "Lær mer",
"ck.manage": "Administrer informasjonskapsler",
"ck.measurement": "Publikumsmåling",
"ck.measurementDesc": "Anonyme statistikker for å forbedre tjenesten.",
"ck.msg": "Vi bruker informasjonskapsler for å holde nettstedet i gang og måle publikummet.",
"ck.necessary": "Nødvendig",
"ck.necessaryDesc": "Essensielt for at nettstedet skal fungere. Alltid aktivert.",
"ck.refuse": "Avslå",
"ck.save": "Lagre valg",
"ck.saved": "Innstillinger lagret",
"ck.title": "Dine informasjonskapselinnstillinger",
"cm.found": "FUNNET",
"cm.lost": "TAPT",
"cmp.adv": "Avansert",
"cmp.ai": "AI matching",
"cmp.autobill": "Automatisk fakturering",
"cmp.basic": "Grunnleggende",
"cmp.community": "Fellesskap",
"cmp.consol": "Sammenlagt fakturering",
"cmp.custom": "Tilpasset",
"cmp.dedicated": "Dedikert",
"cmp.deploy": "Dedikert distribusjon & SLA",
"cmp.estIncl": "Inkluderte etableringer",
"cmp.estSec": "Ekstra etablissement",
"cmp.items": "Elementer / måned",
"cmp.main": "1 hoved",
"cmp.max20": "20 maks",
"cmp.members": "Medlemsinvitasjoner",
"cmp.onQuote": "Tilpasset tilbud",
"cmp.priority": "Prioritet",
"cmp.starterEst": "1 inkludert + ubegrenset ekstra",
"cmp.stats": "Statistikk",
"cmp.statsAdv": "Avansert",
"cmp.statsBasic": "Grunnleggende",
"cmp.support": "Support",
"cmp.unlimited": "Ubegrenset",
"cmp.upTo3": "Opp til 3",
"consent.required": "Du må godta å dele kontaktinformasjonen din for å fortsette.",
"consent.share": "Jeg godtar at finneren av gjenstanden min kan se kontaktinformasjonen min (navn, e-post, telefon) for å kontakte meg for tilbakelevering.",
"cover.add": "Legg til",
"cover.change": "Endre",
"cover.helper": "Vises som et banner på rapport siden og i katalogen.",
"cover.none": "Ingen omslagsbilde",
"cover.remove": "Fjern",
"cover.title": "Omslagsbilde",
"crop.desc": "Juster innrammingen til bannerforhold (3:1). Dra og zoom.",
"crop.saving": "Lagrer…",
"crop.title": "Beskjær omslagsfotoet",
"cta.button": "Opprett min partnerkonto",
"cta.subtitle": "Bli med de virksomhetene som returnerer varer raskere med findloop.",
"cta.title": "Klar til å kutte ned tapt eiendom?",
"db.account.s": "Administrer din virksomhet, abonnement og QR-kode.",
"db.account.t": "Min konto",
"db.declarations.s": "Kunder som har rapportert et tapt objekt via din QR-kode.",
"db.declarations.t": "Tap rapporter",
"db.deposit.s": "Legg til et bilde, en kategori og en beskrivelse.",
"db.deposit.t": "Loggfør et funn",
"db.registry.s": "Alle registrerte funn ved din virksomhet.",
"db.registry.t": "Objektregister",
"db.reviews.s": "Svar offentlig på kundenes anmeldelser.",
"db.reviews.t": "Kundeanmeldelser",
"db.shipments.s": "Generer etiketter og spor pakker som skal sendes.",
"db.shipments.t": "Forsendelser",
"db.stats.s": "Dine nøkkelindikatorer for ytelse.",
"db.stats.t": "Statistikk",
"db.team.s": "Inviter kollegene dine til å administrere objekter.",
"db.team.t": "Team",
"dc.partnerDesc": "Mistet objektet ditt på en partnerlokasjon (hotell, stasjon, hall…)? Velg det for en direkte retur.",
"dc.partnerList": "Velg fra listen",
"dc.partnerMap": "Velg på kartet",
"dc.partnerTitle": "Erklæring ved en partner",
"dc.publicCta": "Legg ut en offentlig annonse",
"dc.publicDesc": "Annonsen din vil være synlig for hele findloop-fellesskapet. Ideelt hvis du ikke vet hvor du mistet objektet.",
"dc.publicTitle": "Offentlig erklæring",
"dc.subtitle": "Velg hvordan du vil rapportere det tapte objektet ditt.",
"dc.title": "Hva ønsker du å gjøre?",
"dec.addrPending": "Adresse venter fra kunden",
"dec.analyzing": "Analyserer…",
"dec.badge": "Tapsrapport",
"dec.category": "Objektkategori",
"dec.clientDescription": "Kundebeskrivelse",
"dec.clientPhoto": "Bilde levert av kunden",
"dec.clientPhotoShort": "Kundens bilde",
"dec.comparePhotos": "Sammenlign bilder",
"dec.contactTitle": "Dine kontaktopplysninger",
"dec.date": "Dato for tap",
"dec.declaredItemPhoto": "Bilde av det erklærte objektet",
"dec.descPh": "Beskriv objektet: merke, farge, særpreg…",
"dec.description": "Beskrivelse",
"dec.email": "E-post",
"dec.emptyDesc": "Del QR-koden din for å motta erklæringer.",
"dec.emptyTitle": "Ingen erklæringer",
"dec.enlarge": "Forstørr",
"dec.extBanner": "{n} eksterne betaling(er) å validere — bekreft mottak nedenfor for å låse opp overlevering eller frakt.",
"dec.foundItemAlt": "Funnet objekt",
"dec.foundItemRegistry": "Funnet objekt (register)",
"dec.home": "Tilbake til hjem",
"dec.labelClient": "Kunde",
"dec.labelRegistry": "Register",
"dec.matchFound": "En match har allerede blitt identifisert!",
"dec.name": "Fullt navn",
"dec.noMatchYet": "Ingen match ennå.",
"dec.noPhoto": "Ingen bilde",
"dec.notfound": "Partner ikke funnet.",
"dec.pRecup": "gjenoppretting",
"dec.pRecupP": "(gjenoppretting)",
"dec.pRecupShip": "(gjenoppretting + frakt)",
"dec.payConfirmed": "Betaling {x} bekreftet",
"dec.payPending": "Ekstern betaling {x} venter",
"dec.phone": "Telefon",
"dec.pickup": "Henting personlig",
"dec.place": "Sted for tap",
"dec.placePh": "f.eks. ved baren, rom 204…",
"dec.recoverBtn": "Gjenopprett min gjenstand",
"dec.reject": "Avvis",
"dec.rerun": "Kjør analysen på nytt",
"dec.similarity": "Likhet {n}%",
"dec.submit": "Send inn min rapport",
"dec.submitting": "Sender…",
"dec.successText": "Vi leter etter gjenstanden din blant de som er holdt på",
"dec.successTitle": "Rapport sendt!",
"dec.suggestedMatches": "Foreslåtte treff",
"dec.toColon": " til:",
"dec.toShip": "Å sende",
"dec.toastExtPay": "Betaling bekreftet – kunden vil bli varslet.",
"dec.toastMatch": "Treff bekreftet",
"dec.toastReject": "Forslag avvist",
"dec.toastRerun": "Analyse startet på nytt",
"dec.toastVisualN": "{n} visuelle treff",
"dec.toastVisualNone": "Ingen visuelle treff",
"dec.trackBtn": "Spor min rapport",
"dec.viewBeforeAfter": "Før/etter visning (overlay)",
"dec.viewSideBySide": "Side-ved-side visning",
"dec.visualCompare": "AI visuell sammenligning",
"dec.visualIdle": "Kjør sammenligningen slik at AI visuelt matcher kundens foto med funnede gjenstander.",
"dec.visualRunning": "AI sammenligner kundens foto med gjenstander i registeret ditt…",
"dec.zoomPhoto": "Forstørr foten",
"dep.addAnyway": "Legg til uansett",
"dep.addError": "Feil under adding",
"dep.addItem": "Legg til gjenstand",
"dep.added": "Gjenstand lagt til i registeret!",
"dep.adding": "Legger til…",
"dep.aiError": "AI-analyse utilgjengelig akkurat nå.",
"dep.aiFilled": "Skjema forhåndsutfylt av AI ✨",
"dep.aiUnavailable": "AI utilgjengelig – fyll ut skjemaet manuelt.",
"dep.analyzing": "Analyserer…",
"dep.analyzingPhoto": "Analyserer foto…",
"dep.brand": "Merke",
"dep.brandPlaceholder": "f.eks. Apple",
"dep.category": "Kategori",
"dep.checkingDup": "Sjekker for duplikater…",
"dep.color": "Farge",
"dep.colorPlaceholder": "f.eks. svart",
"dep.condition": "Tilstand",
"dep.conditionPlaceholder": "f.eks. god tilstand",
"dep.depositorNote": "Innskyternotat",
"dep.depositorNoteHint": "Operasjonelle detaljer skrevet for hånd. AI overskriver aldri dette notatet.",
"dep.depositorNotePlaceholder": "f.eks. innholdet i en pose, merke som rapportert, detaljer gitt av personen…",
"dep.descPlaceholder": "f.eks. svart iPhone 15 med et klart etui, funnet ved baren…",
"dep.description": "Beskrivelse",
"dep.dupHint": "Sørg for at du ikke legger til en duplikat. Du kan fortsette hvis gjenstanden virkelig er forskjellig.",
"dep.dupTitle": "Lignende gjenstand(er) allerede registrert",
"dep.dupWarn": "Lignende gjenstand oppdaget – gå gjennom, klikk deretter igjen for å bekrefte.",
"dep.estHint": "Gjenstanden vil bli lagt til dette etablissementets register.",
"dep.establishment": "Etablissement",
"dep.fee": "Gjenopprettingsgebyr (€) – valgfritt",
"dep.feePlaceholder": "La stå tom for standardpris for kategorien",
"dep.fillAI": "Fyll med AI",
"dep.optional": "(valgfritt)",
"dep.photo": "Varebilde",
"dep.principal": "primær",
"dep.reqError": "Kategori og beskrivelse er påkrevd.",
"dep.savedItem": "Registrert vare",
"dep.similarity": "Likhet",
"dep.storage": "Fysisk beliggenhet",
"dep.storageHint": "Hvor varen er fysisk lagret. En QR-kode vil bli generert for å finne den.",
"dep.storagePlaceholder": "f.eks. Hylle A3, Skap 12, Mottakssafe",
"dl.aClient": "en kunde",
"dl.alertsBlocked": "Nettleservarsler blokkert",
"dl.alertsBlockedHint": "For å reaktivere dem: klikk på 🔒 (eller ⓘ) ikonet til venstre for nettadressen, deretter tillat varsler og last inn siden på nytt.",
"dl.amountDue": "Beløp forfalt: {amount} {currency}.",
"dl.enableAlerts": "Aktiver varsler",
"dl.extPending": "Betalinger som må valideres",
"dl.freemiumNear": "Du nærmer deg Freemium-grensen ({used}/{max} varer denne måneden). Oppgrader til Starter for ubegrensede varer.",
"dl.freemiumReached": "Freemium-grense nådd ({used}/{max} varer denne måneden). Oppgrader til Starter for å registrere ubegrensede varer.",
"dl.invoiceOverdue": "Faktura {num} ubetalt — tilgang begrenset.",
"dl.matchNotifTitle": "Findloop — Ny AI-match 🔔",
"dl.matchToast": "Ny AI-match — {name}",
"dl.matchToastDesc": "En vare matcher en erklæring.",
"dl.notifEmpty": "Ingen varsler ennå.",
"dl.notifEnabled": "Nettleservarsler aktivert",
"dl.notifTitle": "Varsler",
"dl.payInvoice": "Betal min faktura →",
"dl.rewardsPending": "Kuponger som skal presenteres",
"dl.upgradeStarter": "Oppgrader til Starter →",
"est.all": "Alle etableringer ({n})",
"est.label": "Etablering",
"est.primary": "primær",
"est.secondary": "sekundær",
"est2.add": "Legg til en etablering",
"est2.addressLabel": "Adresse",
"est2.addressPh": "12 République Street",
"est2.autoInvoice": "En detaljert faktura genereres automatisk den 1. i hver måned.",
"est2.baseSub": "Grunnabonnement",
"est2.billing": "Fakturering",
"est2.boostActivated": "Boost aktivert for {name}",
"est2.boostBillingNote": "Fakturert med gjeldende sats og gruppert på din konsoliderte månedlige faktura.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Forbedre synligheten til denne etableringen i katalogen og på kartet.",
"est2.boostDuration": "{h}t med forbedret synlighet",
"est2.boostExtend": "Forleng",
"est2.boostTitle": "Boost {name}",
"est2.boosted": "Boostet",
"est2.chartDesc": "Andel returnerte varer av totalt registrerte, side for side.",
"est2.chartTitle": "Returprosent etter etablering",
"est2.chartTooltip": "Retur",
"est2.cityLabel": "By",
"est2.cityPh": "Lyon",
"est2.contactHint": "Disse detaljene vises for kunden for denne etableringen (faller tilbake til kontoen hvis tomt).",
"est2.countryLabel": "Land",
"est2.coverLabel": "Coverbilde",
"est2.create": "Opprett",
"est2.created": "Etablering opprettet",
"est2.delete": "Slett",
"est2.deleteDesc": "Denne handlingen er permanent. Du kan bare slette en etablering hvis den ikke inneholder varer.",
"est2.deleteTitle": "Slette “{name}”?",
"est2.deleted": "Etablering slettet",
"est2.dialogDesc": "Skriv inn navnet og adressen til dette stedet.",
"est2.edit": "Rediger",
"est2.editEst": "Rediger etablissemement",
"est2.emailLabel": "Kontakt e-post",
"est2.emailPh": "kontakt@nettsted.com",
"est2.estSuffix": " etablissement(er)",
"est2.extraNoteBase": "{n} ekstra etablissement(er) fakturert",
"est2.extraPrice": " til {price} €/måned.",
"est2.extraQuote": " ved forhåndsvisning.",
"est2.imgChange": "Velg et bilde",
"est2.imgDone": "Ferdig",
"est2.imgRemove": "Fjern",
"est2.imgRemoved": "Bilde fjernet",
"est2.imgSaved": "Bilde lagret",
"est2.imgUploading": "Laster opp…",
"est2.includedPlan": "Inkludert i planen din: {n}.",
"est2.kDeclarations": "Erklæringer",
"est2.kInStorage": "I lager",
"est2.kItemsTotal": "Elementer (totalt)",
"est2.kRestituted": "Tilbakeført",
"est2.limitReached": "Grense nådd",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Erkl.",
"est2.mItems": "Elementer",
"est2.mRestituted": "Tilbakeført",
"est2.mStorage": "I lager",
"est2.monthlyTotal": "Månedlig total",
"est2.nameLabel": "Navn *",
"est2.namePh": "f.eks. Belmont Hotel — Lyon Annex",
"est2.newEst": "Nytt etablissement",
"est2.onQuote": "På forhåndsvisning",
"est2.phoneLabel": "Telefon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plan",
"est2.planLimited": "Din “{tier}” plan er begrenset til {max} etablissement(er).",
"est2.primary": "Primær",
"est2.qr": "QR-kode",
"est2.qrDesc": "Vis denne QR-koden i dette etablissementet. Kunder som rapporterer et tap, vil bli koblet til dette stedet.",
"est2.qrTitle": "QR-kode — {name}",
"est2.saving": "Lagrer…",
"est2.seeInvoices": "Se mine månedlige fakturaer",
"est2.seePlans": "Se planene",
"est2.subtitle": "Administrer alle nettstedene dine under en konto — konsolidert oversikt, elementer, QR-kode og fakturering.",
"est2.suspended": "Utleid",
"est2.tierFree": "1 etablissement",
"est2.tierLarge": "ubegrensede etablissementer",
"est2.tierMedium": "5 etablissementer inkludert",
"est2.tierSmall": "3 etablissementer inkludert",
"est2.title": "Etableringer",
"est2.unlimitedPlan": "Planen din tillater et ubegrenset antall etablissementer.",
"est2.unlimitedSuffix": " · ubegrenset",
"est2.updated": "Etablering oppdatert",
"est2.upgradeHint": "Oppgrader til en høyere plan for å legge til flere nettsteder og sentralisere all aktiviteten din.",
"est2.visuals": "Logo & foto",
"est2.visualsDesc": "Tilpass denne etablissementets logo og omslagsbilde. De vises på den offentlige siden og erklæringsskjemaet.",
"est2.visualsTitle": "Visuelle elementer — {name}",
"est2.workOn": "Arbeid med dette etablissementet",
"est2.working": "Du arbeider med “{name}”",
"ev.created": "Rapport opprettet",
"ev.matched": "Matchende element identifisert",
"ev.paid": "Gjenopprettingsavgift betalt",
"ev.pickup": "Henting på stedet",
"ev.shipped": "Pakke sendt",
"ev.shipping_paid": "Fraktavgift betalt",
"ev.shipping_requested": "Frakt forespurt",
"feat1.d": "KPIer, returprosent per kategori, inntekter og trender for 30 dager.",
"feat1.t": "Dashbord & analyser",
"feat2.d": "Etiketter, leverandørsporing og automatiske sporings-e-poster.",
"feat2.t": "Fraktmodul",
"feat3.d": "Kunder finner deg etter by og kategori, med sertifiserte anmeldelser.",
"feat3.t": "Offentlig katalog & anmeldelser",
"fp.backToRanking": "Tilbake til topplisten",
"fp.badge": "Merke",
"fp.hero": "Finder Helten",
"fp.notFound": "Profil ikke funnet eller privat.",
"fp.scoreTotal": "Totalt poeng",
"fp.scoreYear": "Poeng i",
"fp.share": "Del denne profilen",
"fp.shareText": "Sjekk ut {name}s finder-profil på Findloop!",
"fp.tagline": "En ærlig finder som gjør verden til et bedre sted.",
"ft.backAccount": "Tilbake til Min konto",
"ft.closeBtn": "Lukk saken",
"ft.closeConfirm": "Bekreft at varen er returnert? Annonsen vil bli lukket.",
"ft.closeLockedHint": "Valider eierens kode først for å låse opp lukking.",
"ft.closed": "Sak lukket — varen returnert!",
"ft.codeLabel": "Skriv inn valideringskoden mottatt fra eieren",
"ft.codeNeeded": "Vennligst skriv inn valideringskoden.",
"ft.codeOk": "Koden er validert — du kan lukke saken.",
"ft.codePlaceholder": "f.eks. 4821",
"ft.codeVerified": "Valideres",
"ft.doneMsg": "Varen returnert. Takk for hjelpen med å returnere den til eieren!",
"ft.stepInProgress": "Retur pågår",
"ft.stepPublished": "Annonsen publisert",
"ft.stepReturned": "Varen returnert",
"ft.subtitle": "Følg trinnene til den funnet varen er returnert.",
"ft.title": "Retursporing",
"ft.verifyBtn": "Valider kode",
"hero.badge": "Utvalgt",
"hero.ctaFound": "Jeg fant en vare",
"hero.ctaLost": "Jeg mistet en vare",
"hero.ctaPartner": "Bli partner",
"hero.subtitle": "Findloop hjelper virksomheter med å håndtere funnede gjenstander — og lar kundene rapportere tap og deretter gjenopprette sine eiendeler, på stedet eller ved frakt.",
"hero.title": "Hver tapt gjenstand finner sin eier.",
"home.champBecome": "Bli en finder",
"home.champCta": "Se topplisten",
"home.champSubtitle": "Hver returnert gjenstand gir poeng. Bli med på topplisten og vinn belønninger.",
"home.champTitle": "Våre topp findere",
"how.eyebrow": "Slik fungerer det",
"how.title": "Fra innlevering til retur, uten anstrengelse.",
"inv.all": "Alle",
"inv.allYears": "Alle år",
"inv.count": "Fakturaer",
"inv.due": "forfall",
"inv.empty": "Ingen fakturaer ennå.",
"inv.exportCsv": "Eksporter CSV",
"inv.invoicePdf": "Faktura PDF",
"inv.issued": "Utstedt",
"inv.noMatch": "Ingen faktura for dette filteret.",
"inv.paid": "Betalt (€)",
"inv.paidOn": "betalt den",
"inv.pay": "Betal",
"inv.receipt": "Kvittering",
"inv.reminders": "Påminnelser",
"inv.remindersDesc": "E-post og SMS-påminnelser sendt for denne fakturaen.",
"inv.remindersEmpty": "Ingen påminnelse sendt.",
"inv.rmDue": "Påminnelse om forfall",
"inv.rmManual": "Manuell påminnelse",
"inv.rmSms": "SMS-påminnelse D+30",
"inv.rmStage": "Påminnelse",
"inv.statusPaid": "Betalt",
"inv.statusUnpaid": "Ubetalt",
"inv.subtitle": "Se og last ned fakturaene og kvitteringene dine.",
"inv.title": "Mine fakturaer",
"inv.unpaid": "Ubetalt (€)",
"inv2.contractTitle": "Min findloop-kontrakt",
"inv2.detailByEst": "Detaljert etter etabl.",
"inv2.dueLabel": "Forfall:",
"inv2.dueSuffix": " · forfall {date}",
"inv2.error": "Feil {status}",
"inv2.estCountIssued": "{n} etablissement(er) · utstedt {date}",
"inv2.estimate": "Estimert (ikke belastet) · {n} etablissement(er)",
"inv2.expired": " · utløpt",
"inv2.exportCsv": "Eksporter CSV",
"inv2.exportDone": "CSV-exportert nedlastet",
"inv2.included": "Inkludert",
"inv2.monthlyTitle": "Månedlig fakturering (abonnement)",
"inv2.months": "+{n} måneder",
"inv2.paid": "Betalt",
"inv2.pay": "Betal",
"inv2.previewTitle": "Forhåndsvisning av din neste faktura —",
"inv2.renew": "Fornye kontrakten min",
"inv2.renewalsTitle": "Fornyelseshistorikk ({n})",
"inv2.renewedUntil": "Kontrakt fornyet til {date}",
"inv2.serviceTitle": "Tjenestefakturaer (gjenvinninger & tilbud)",
"inv2.soon": "Utløper snart",
"inv2.toPay": "Til betaling",
"inv2.totalHtTva": "Total ekskl. skatt · MVA",
"inv2.totalTtc": "Total inkl. skatt",
"iu.addPhoto": "Legg til et bilde",
"iu.change": "Endre",
"lang.label": "Språk",
"lb.allCountries": "Alle land",
"lb.badge": "Årlig poengliste",
"lb.champion": "🏆 Årets mester",
"lb.cityPh": "Filtrer etter by…",
"lb.empty": "Ingen rangering for disse filtrene ennå.",
"lb.pts": "poeng",
"lb.resetNote": "Rangering for inneværende år — nullstilles 1. januar.",
"lb.returned": "returnert",
"lb.share": "Del poenglisten",
"lb.shareText": "Se de beste finnerne på poenglisten på Findloop!",
"lb.subtitle": "Hver retur gir poeng. Poenglisten nullstilles 1. januar.",
"lb.tabFinders": "Finnerne",
"lb.tabPartners": "Etableringer",
"lb.title": "Topp finnerne",
"lost.b2bDesc": "Mist den i et hotell, transportknutepunkt eller partnersted? Finn etablissementet og rapporter tapet ditt.",
"lost.b2bTitle": "Rapporter til en partner",
"lost.b2cDesc": "Publiser en annonse synlig for alle, tilby en belønning og promoter den for å maksimere sjansene dine.",
"lost.b2cTitle": "Legg ut en offentlig annonse",
"lost.desc": "Velg hvordan du ønsker å gå videre.",
"lost.title": "Tapt en gjenstand?",
"map.allCategories": "Alle kategorier",
"map.clear": "Tilbakestill",
"map.exitFullscreen": "Avslutt",
"map.filterCity": "By eller land…",
"map.fullscreen": "Fullskjerm",
"map.heatmap": "Varmekart",
"map.high": "Høy",
"map.impactMonth": "gjenstander returnert denne måneden",
"map.impactTotal": "returnert totalt",
"map.legend": "Fargede prikker fra rød (lav) til grønn (høy) basert på returprosent; størrelse basert på antall gjenstander.",
"map.locating": "Lokaliserer… legg til en adresse til dine foretak for å se dem på kartet.",
"map.low": "Lav",
"map.mAll": "Alle",
"map.mFound": "Funnet",
"map.mLost": "Tapt",
"map.medium": "Moderat",
"map.noItemRegistered": "Ingen gjenstand registrert",
"map.noItems": "Ingen gjenstand",
"map.period30": "Siste 30 dager",
"map.period7": "Siste 7 dager",
"map.period90": "Siste 90 dager",
"map.periodAll": "Hele tiden",
"map.returnedSuffix": "returnert · {a}/{t} gjenstander",
"map.stats": "Bystatistikk",
"map.statsTop": "Topp 5 steder (tapte gjenstander)",
"map.statsTrend": "6-måneders trend",
"map.title": "Kart over dine foretak",
"map.topPlaces": "Populære steder",
"mc.adClosed": "Annonse lukket",
"mc.addPhoto": "Legg til et bilde",
"mc.adsNone": "Ingen annonse for tapt gjenstand.",
"mc.archiveHide": "Skjul historikk",
"mc.archiveNone": "Ingen løste saker ennå.",
"mc.archiveShow": "Vis historikk",
"mc.archiveSub": "Løste og returnerte saker.",
"mc.archiveTitle": "Historikk",
"mc.at": "Ved",
"mc.backToLogin": "Tilbake til innlogging",
"mc.boostContacts": "Kontakter (boost)",
"mc.boostViews": "Visninger (boost)",
"mc.cancel": "Avbryt",
"mc.certificate": "Sertifikat",
"mc.changePhoto": "Endre bilde",
"mc.city": "By",
"mc.closeAd": "Lukk",
"mc.closeAdConfirm": "Lukke denne annonsen? Den vil ikke lenger være synlig og vil frigjøre en plass.",
"mc.confirmPassword": "Bekreft passord",
"mc.confirmRestitution": "Bekreft retur",
"mc.connect": "Koble til",
"mc.contacts": "Kontakter",
"mc.country": "Land",
"mc.declareFound": "Rapporter en funnet gjenstand",
"mc.declareFoundSub": "Post en gjenstand du har funnet",
"mc.declareLost": "Rapporter et tap",
"mc.declareLostSub": "Post en annonse for tapt gjenstand",
"mc.deleteAccount": "Slett min konto",
"mc.deleteConfirm": "Ja, slett min konto",
"mc.deleteConfirmBody": "Kontoen din vil bli permanent slettet og dine personopplysninger anonymisert. Denne handlingen kan ikke omgjøres.",
"mc.deleteConfirmTitle": "Slette kontoen din?",
"mc.deleteDesc": "Sletter kontoen din permanent og anonymiserer personopplysningene dine. Denne handlingen kan ikke angres.",
"mc.deleted": "Kontoen din har blitt slettet.",
"mc.deleting": "Sletter…",
"mc.email": "E-post",
"mc.expiresOn": "Utgår den",
"mc.exportData": "Last ned dataene mine (GDPR)",
"mc.exportDone": "Dataene dine har blitt lastet ned.",
"mc.exporting": "Forbereder…",
"mc.finderAccepted": "Godkjent",
"mc.finderProfile": "Finder-profil (valgfritt)",
"mc.finderProfileDesc": "Tjen poeng ved å returnere gjenstander og vis deg på den offentlige ranglisten.",
"mc.forYourAd": "For din annonse",
"mc.forgotLink": "Glemt passord?",
"mc.forgotSend": "Send lenke",
"mc.forgotSent": "Hvis det finnes en konto for denne e-posten, har en tilbakestillingslenke nettopp blitt sendt.",
"mc.forgotTitle": "Glemt passord",
"mc.foundAdsNone": "Ingen funnet-gjenstand annonser publisert.",
"mc.foundAt": "Funnet på",
"mc.foundNone": "Ingen funnet gjenstander rapportert.",
"mc.hAd": "Tapt annonse",
"mc.hDeclaration": "Erklæring",
"mc.hFinderContact": "Rapportert gjenstand",
"mc.hFound": "Returnert gjenstand",
"mc.hFoundAd": "Fant annonse",
"mc.histEarned": "Gjenstand returnert",
"mc.historyTitle": "Min poenghistorikk",
"mc.loginBtn": "Logg inn",
"mc.loginTitle": "Kundeinnlogging",
"mc.logout": "Logg ut",
"mc.lostAt": "Tapt på",
"mc.matchPartner": "Hos en partner",
"mc.matchPublic": "Funnet gjenstand",
"mc.matches": "Møter",
"mc.matchesSub": "Funnet gjenstander kan matche dine tapte gjenstand annonser.",
"mc.myAds": "Mine tapte gjenstand annonser",
"mc.myDeclarations": "Mine rapporter",
"mc.myFinds": "Gjenstander jeg har funnet",
"mc.myFindsNone": "Du har ikke rapportert å ha funnet noen gjenstand ennå.",
"mc.myFindsSub": "Gjenstander du rapporterte å ha funnet i annonser for tapte gjenstander.",
"mc.myFound": "Rapporterte funnede gjenstander",
"mc.myFoundAds": "Mine funnet-gjenstand annonser",
"mc.myRewards": "Mine kuponger",
"mc.name": "Fullt navn",
"mc.newPassword": "Nytt passord",
"mc.none": "Ingen rapport ennå.",
"mc.notEnough": "Ikke nok poeng",
"mc.notifEmpty": "Ingen varsler ennå.",
"mc.notifOpen": "Vis",
"mc.notifTitle": "Varsler",
"mc.notifTrack": "Spor",
"mc.notifViewAd": "Vis annonse",
"mc.optInDesc": "Valgfri deltakelse. Du samtykker til å vise offentlig de utvalgte gjenstandene nedenfor. Kan endres når som helst.",
"mc.optInTitle": "Vis deg på den offentlige ranglisten",
"mc.password": "Passord",
"mc.passwordMismatch": "Passordene samsvarer ikke.",
"mc.phone": "Telefon",
"mc.photoUpdated": "Profilbilde oppdatert",
"mc.pointsAwaiting": "Poeng venter",
"mc.pointsBalance": "Poeng å bruke",
"mc.pointsOk": "Poeng kreditert",
"mc.presentHint": "Vis denne QR-koden til partneren: de skanner den for å validere belønningen din.",
"mc.presentInStore": "Vis i butikk",
"mc.presentTitle": "Vis dette kupongen",
"mc.privacy": "Personvern & data",
"mc.privacyDesc": "Last ned en kopi av all personlig informasjon Findloop har om deg (GDPR, art. 15 & 20).",
"mc.profileSaved": "Profil oppdatert.",
"mc.profileSettings": "Offentlig profil & rangering",
"mc.pseudo": "Fornavn eller kallenavn",
"mc.redExpired": "Utløpt",
"mc.redReady": "Vis hos partner",
"mc.redUsed": "Brukt",
"mc.redeem": "Løs inn",
"mc.registerBtn": "Opprett min konto",
"mc.registerTitle": "Opprett en kundekonto",
"mc.rememberMe": "Husk meg",
"mc.remove": "Fjern",
"mc.resetDone": "Passord oppdatert. Du kan nå logge inn.",
"mc.resetExpired": "Denne tilbakestillingslenken er ikke gyldig eller har utløpt. Be om en ny nedenfor.",
"mc.resetSave": "Tilbakestill passordet mitt",
"mc.resetTitle": "Nytt passord",
"mc.restitutionConfirmed": "Retur bekreftet.",
"mc.reward": "Belønning",
"mc.rewardRedeemed": "Belønning låst opp! Kode:",
"mc.rewardsDesc": "Bruk poengene dine for fordeler tilbudt av våre partnere. Forbruk:",
"mc.rewardsNone": "Ingen belønning tilgjengelig ennå.",
"mc.rewardsTitle": "Bruk poengene mine",
"mc.scoreAwarded": "Bra jobba! +1 til din Finder Score 🎉",
"mc.scoreEarned": "Poeng opptjent",
"mc.scorePts": "poeng",
"mc.scoreThisYear": "I år",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Se rangering",
"mc.share": "Del",
"mc.statsTitle": "Statistikk",
"mc.subtitle": "Spor alle rapportene dine på ett sted.",
"mc.title": "Min konto",
"mc.toLogin": "Allerede registrert?",
"mc.toRegister": "Ingen konto ennå?",
"mc.track": "Spor",
"mc.views": "Visninger",
"mc.visCity": "By",
"mc.visCountry": "Land",
"mc.visLabel": "Elementer synlige på rangeringen:",
"mc.visName": "Fornavn / kallenavn",
"mc.visPhoto": "Profilbilde",
"mc.welcome": "Hallo",
"mc2.acceptFinder": "Aksepter denne finneren",
"mc2.accountActivity": "Kontoaktivitet",
"mc2.adsActive": "{n}/5 aktive annonser",
"mc2.autoDelete": "Automatisk sletting planlagt for",
"mc2.badgeBronze": "Bronse",
"mc2.badgeGold": "Gull",
"mc2.badgeSilver": "Sølv",
"mc2.boostEarnedAlready": "Det har allerede gitt deg",
"mc2.boostEarnedWin": "Det ga deg",
"mc2.boostExpiredWin": "Din boost har akkurat utløpt — fortsett med -20%!",
"mc2.boostExpiresIn": "Din boost utløper om",
"mc2.boostWinDetail2": ". -20% brukt automatisk hvis du fornyer innen 24 timer.",
"mc2.claimCode": "Innbetalingskode:",
"mc2.codeSentFinder": "Kode sendt til finneren på e-post",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Last ned kvitteringen min",
"mc2.error": "Feil {status}",
"mc2.finderAccepted": "Finder akseptert — kode sendt via e-post",
"mc2.finderContacts": "Kontaktopplysninger til Finder(e)",
"mc2.followFindo": "Følg Findloop",
"mc2.imgInvalid": "Ugyldig bilde",
"mc2.inactivityNote": " — i tilfelle av {n} måneders inaktivitet (GDPR).",
"mc2.lastActivity": "Siste aktivitet:",
"mc2.lostEmailTitle": "Jeg har ikke lenger tilgang til e-posten min",
"mc2.noPhotoPreset": "Ingen foto ennå? Velg en standard avatar:",
"mc2.paidViaPartner": "Betalt (via partner)",
"mc2.payRecovery": "Betal gjenopprettingsgebyret",
"mc2.paySettle": "Reguler betalingen min",
"mc2.payShipping": "Betal fraktgebyret",
"mc2.payUnavailable": "Betaling utilgjengelig",
"mc2.peopleFound": "{n} person(er) tror de har funnet gjenstanden din",
"mc2.phoneNumber": "Telefonnummer",
"mc2.reactivateAccount": "Gjenopprett kontoen min",
"mc2.reactivated": "Konto gjenopprettet",
"mc2.reactivatedThanks": "Konto gjenopprettet — takk for din lojalitet!",
"mc2.recoverSmsBtn": "Få koden min via SMS",
"mc2.recoverSmsDesc": "Motta krav-koden din via SMS til nummeret som er registrert på kontoen din.",
"mc2.recoverSmsFallback": "Hvis en konto eksisterer med dette nummeret, er en SMS sendt.",
"mc2.renewStayTop": ". Forny for å forbli på topp og gjenvinne gjenstanden din.",
"mc2.resume20": "Gjenoppta -20%",
"mc2.unlockContacts": "Lås opp kontaktopplysninger",
"mc2.unlockDesc": "Betal Findloop behandlingsgebyret for å avdekke deres kontaktopplysninger og ordne overleveringen.",
"mc2.viewsWord": "visninger",
"mc2.live": "Live",
"mh.allCategories": "Alle kategorier",
"mh.allPeriod": "All tid",
"mh.autoMatch": "Auto AI matching",
"mh.blocked": "Blokkert (motstrid)",
"mh.blockedReason": "Match blokkert: de viktigste nøkkelordene for gjenstanden og forklaringen motstrider hverandre.",
"mh.days30": "Siste 30 dager",
"mh.days7": "Siste 7 dager",
"mh.days90": "Siste 90 dager",
"mh.emptyDesc": "AI-matching vil vises her etter hvert som erklæringer kommer inn.",
"mh.emptyTitle": "Ingen hendelser",
"mh.exportCsv": "Eksporter CSV",
"mh.exportDone": "CSV-eksport lastet ned",
"mh.exportImpossible": "Eksport mislyktes",
"mh.fBlocked": "Blokkert",
"mh.fConfirmed": "Bekreftet",
"mh.fRejected": "Avvist",
"mh.objectLabel": "Gjenstand:",
"mh.refresh": "Oppdater",
"mh.rejected": "Avvist",
"mh.srcManual": "Manuell",
"mh.srcText": "Tekst",
"mh.srcVisual": "Visuell (foto)",
"mh.subtitle": "Logg over matcher foreslått av AI — automatisk matchet, bekreftet og avvist.",
"mh.title": "AI Historikk",
"nav.ads": "Tapte gjenstander",
"nav.dashboard": "Min plass",
"nav.found": "Fant gjenstander",
"nav.how": "Hvordan det fungerer",
"nav.login": "Logg inn",
"nav.map": "Kart",
"nav.more": "Mer",
"nav.partners": "Partnere",
"nav.pricing": "Priser",
"nav.ranking": "Toppliste",
"nav.register": "Bli partner",
"nav.track": "Spor en erklæring",
"nf.desc": "Siden du leter etter eksisterer ikke eller har blitt flyttet.",
"nf.home": "Tilbake til forsiden",
"nf.title": "Siden ble ikke funnet",
"par.allCities": "Alle byer",
"par.allCountries": "Alle land",
"par.badge": "Katalog",
"par.certified": "Sertifisert",
"par.certifiedBadge": "Sertifisert",
"par.cityPh": "By",
"par.declare": "Rapporter",
"par.none": "Ingen partner funnet.",
"par.partnerBadge": "Partner",
"par.searchPh": "Søk etter en etablering…",
"par.subtitle": "Finn etableringen hvor du mistet gjenstanden din og rapporter tapet.",
"par.title": "Våre partnere",
"pay.addr1": "Adresse",
"pay.addr2": "Adresselinje 2 (valgfritt)",
"pay.addrIncomplete": "Vennligst fyll inn din leveringsadresse.",
"pay.badge": "Gjenfinning",
"pay.card": "Betal med kort",
"pay.city": "By",
"pay.country": "Land",
"pay.eurNote": "Beløp vist i euro (€).",
"pay.fee": "Gjenfinningsgebyr",
"pay.free": "gratis",
"pay.howRecover": "Hvordan vil du ha gjenstanden din tilbake?",
"pay.momo": "Betal med Mobile Money",
"pay.momoConfirm": "Bekreft betaling",
"pay.noMatch": "Ingen samsvarende gjenstand er bekreftet for denne rapporten ennå.",
"pay.notfound": "Rapport ikke funnet.",
"pay.phonePh": "Telefonnummer",
"pay.pickup": "Hent personlig",
"pay.pickupDesc": "Ved",
"pay.postal": "Postnummer",
"pay.secure": "Sikker betaling",
"pay.serviceFee": "Findloop servicegebyr",
"pay.ship": "Send det til meg",
"pay.shipAfter": "— tilbys etter betaling.",
"pay.shipDesc": "Levering til min adresse",
"pay.shipNote": "Frakt tilgjengelig",
"pay.shipping": "Fraktgebyr",
"pay.subtitleWith": "Betal gjenfinningsgebyret til",
"pay.title": "Få tilbake gjenstanden min",
"pay.total": "Total",
"pcat.city_hall": "Rådhus",
"pcat.hotel": "Hoteller",
"pcat.other": "Annet",
"pcat.park": "Parker",
"pcat.prefecture": "Prefekturer",
"pcat.restaurant": "Restauranter",
"pcat.uncategorized": "Uklassifisert",
"pd.about": "Om",
"pd.back": "Alle partnere",
"pd.certified": "Sertifisert partner",
"pd.declare": "Rapporter et tap her",
"pd.itemsReturned": "returnerte varer",
"pd.itemsTotal": "registrerte varer",
"pd.map": "Sted",
"pd.noItems": "Ingen varer funnet nylig.",
"pd.noReviews": "Ingen vurderinger ennå.",
"pd.notFound": "Partner ikke funnet.",
"pd.recentItems": "Nylig funnet varer",
"pd.reply": "Svar fra virksomheten",
"pd.reviews": "Kundeanmeldelser",
"pd.verified": "Verifisert anmeldelse",
"pd.verifiedEstablishment": "Findloop verifisert virksomhet",
"pg.next": "Neste",
"pg.prev": "Forrige",
"pg.showing": "{from}–{to} av {total}",
"pk.bodyCopy": "Brødtekst",
"pk.bodyText": "Brødtekst",
"pk.brandColors": "Fargevalg",
"pk.colorRed": "Rød",
"pk.colorWhite": "Hvit",
"pk.darkBg": "Mørk bakgrunn",
"pk.download": "Last ned",
"pk.downloadZip": "Last ned hele pakken (ZIP)",
"pk.headings": "Overskrifter",
"pk.heroDesc": "Offisielle logoer, bannere for sosiale medier, farger og typografi. Velg språk og variant for slagord, så laster du ned det visuelle eller hele pakken.",
"pk.lightBg": "Lys bakgrunn (trykk)",
"pk.logoWordmark": "Logo / ordmerke",
"pk.logosVisuals": "Logos & visuals",
"pk.mapCollect": "Kart / innsamlingssteder",
"pk.plain": "Enkel",
"pk.pressKit": "Pressemelding",
"pk.taglineLang": "Språk for slagord",
"pk.typography": "Typografi",
"pk.variant": "Variant",
"pr.shipBtn": "Få varen sendt",
"pr2.adBoostMsg": "Flott valg! Du øker sjansene for raskt å gjenvinne varen din.",
"pr2.boostActivated": "Boost aktivert!",
"pr2.canRecoverNow": "Du kan nå gjenvinne varen din.",
"pr2.continue": "Fortsett",
"pr2.downloadReceiptPdf": "Last ned kvittering (PDF)",
"pr2.goToSpaceNow": "Gå til kontoen min nå",
"pr2.partnerBoostMsg": "Flott valg! Mer synlighet betyr å tiltrekke nye kunder til virksomheten din.",
"pr2.paymentSuccess": "Betaling vellykket!",
"pr2.redirectingSpace": "Omstiller til kontoen din…",
"pr2.subActivated": "Betaling vellykket! Abonnementet ditt er aktivt, du kan nå administrere virksomhetene dine.",
"prev.allSites": "Alle virksomheter",
"prev.editReply": "Rediger svar",
"prev.none": "Ingen anmeldelse ennå.",
"prev.published": "Svar publisert",
"prev.reply": "Svar",
"prev.replyPh": "Skriv et høflig svar…",
"prev.send": "Publiser svar",
"prev.sending": "Publiserer…",
"prev.yourReply": "Ditt svar",
"pricing.annual": "Årlig",
"pricing.annualBadge": "-20% tilbud",
"pricing.choose": "Velg",
"pricing.compareFeature": "Funksjon",
"pricing.compareTitle": "Sammenlign planer",
"pricing.eyebrow": "Priser",
"pricing.month": "/måned",
"pricing.monthly": "Månedlig",
"pricing.perYear": "/år",
"pricing.popular": "Populær",
"pricing.quoteMsg": "Dine behov (valgfritt)",
"pricing.quoteOrg": "Organisasjon",
"pricing.quoteSend": "Send forespørsel",
"pricing.quoteSent": "Forespørsel sendt! Vi tar kontakt snart.",
"pricing.quoteSites": "Antall steder / terminaler",
"pricing.quoteTitle": "Be om et pristilbud",
"pricing.requestQuote": "Be om et pristilbud",
"pricing.saveLabel": "Du sparer",
"pricing.savePerYear": "/år per ekstra oppføring",
"pricing.start": "Start",
"pricing.subtitle": "Start gratis, skaler etterhvert som du vokser.",
"pricing.title": "En plan for hver organisasjon",
"promo.badge": "Partnerprogram",
"promo.cta": "Lær mer",
"promo.text": "Hver partner du henviser som abonnerer gir deg en gratis måned. Ingen begrensning.",
"promo.title": "Henvis en partner, få en gratis måned.",
"pub.accessGranted": "Tilgang gitt",
"pub.accessLimited2h": "Tilgang begrenset til 2 timer",
"pub.accountEmailConcerned": "E-post for kontoen det gjelder",
"pub.adAppearPublic": "Slik vil annonsen din vises offentlig.",
"pub.adPreviewBtn": "Forhåndsvis annonse",
"pub.alertMeOnArrival": "Gi meg beskjed når jeg ankommer",
"pub.allActionsLogged": "Alle handlinger er logget",
"pub.allCategories": "Alle kategorier",
"pub.authorizeAccess": "Autoriser tilgang",
"pub.authorizeSupportQ": "Autoriser støtte tilgang?",
"pub.available": "Tilgjengelig",
"pub.backHome": "Tilbake til hjem",
"pub.boostAdCta": "Øk annonsen min",
"pub.boostAdTitle": "Øk din annonse",
"pub.boostCarouselSub": "Flytt til toppen av siden i “Boosted” karusellen og øk visningene for å hente varen din raskere.",
"pub.boostEstablishment": "Øk din oppføring",
"pub.boostEstablishmentDesc": "Vis deg på toppen av katalogen med et “Boosted” merke og tiltrekk flere rapporter.",
"pub.boostFicheCta": "Øk oppføringen min",
"pub.brandReady": "findloop-merket, klart til bruk",
"pub.cantFindItem": "Kan ikke finne varen din?",
"pub.cantProcessImage": "Kan ikke behandle dette bildet",
"pub.claimQr": "Krev QR-kode",
"pub.clickToZoom": "Klikk for å zoome",
"pub.codeAlreadyValidated": "Kode validert — kontakter låst opp.",
"pub.codeExample": "f.eks. ABCD2345",
"pub.confirmRenewal": "Bekreft fornyelse",
"pub.contactIntro": "Et spørsmål, en forespørsel? Skriv til oss, vi tar kontakt snart.",
"pub.contactTypeDeceased": "Kontodekning (avdød person)",
"pub.contactTypeGeneral": "Generelt spørsmål",
"pub.contactTypeSupport": "Støtte / teknisk problem",
"pub.contactUs": "Kontakt oss",
"pub.continueWithoutEmail": "Fortsett uten å oppgi e-posten min",
"pub.contractLabel": "Kontrakt",
"pub.contractNotFound": "Kontrakt ikke funnet eller allerede utløpt.",
"pub.contractRenewed": "Kontrakt fornyet!",
"pub.contractRenewedFor": "Din kontrakt er fornyet i {n} måneder.",
"pub.copyFailed": "Kopiering mislyktes",
"pub.createPartnerAccount": "Opprett min partnerkonto",
"pub.currentDeadline": "Nåværende frist",
"pub.deceasedInfo": "Som pårørende eller arving kan du be om sletting av en avdød persons findloop-konto. Vi behandler forespørselen din i samsvar med GDPR (støttedokumenter kan bli forespurt).",
"pub.declareMyLoss": "Rapporter mitt tap",
"pub.describeItemPlaceholder": "Beskriv gjenstanden din (f.eks. svart paraply, nøkler…)",
"pub.downloadImage": "Last ned bildet",
"pub.drawSignature": "Vennligst tegn signaturen din.",
"pub.drawSignatureHint": "Tegn signaturen din med musen eller fingeren.",
"pub.duration": "Varighet",
"pub.eSignature": "Elektronisk signatur",
"pub.eSignatureDesc": "Skriv inn navnet ditt for å signere. Datoen blir registrert automatisk.",
"pub.edit": "Rediger",
"pub.editorialTitles": "Redaksjonelle titler",
"pub.emailPlaceholder": "du@eksempel.com",
"pub.enterCodeUnlockOwner": "Skriv inn koden mottatt på e-post for å låse opp eierens kontaktinformasjon.",
"pub.errorWord": "Feil",
"pub.foundSelfService": "Funnet gjenstander · Selvbetjening",
"pub.haveOwnerCode": "Jeg har mottatt en kode fra eieren",
"pub.home": "Hjem",
"pub.immediateRenewal": "Umiddelbar fornyelse, uten nytt tilbud.",
"pub.impAdminReq1": "Administrator",
"pub.impAdminReq2": "ber om tillatelse til midlertidig tilgang til kontoen din",
"pub.impAdminReq3": "for å hjelpe deg.",
"pub.impGrantedDesc": "Supportteamet vil kunne få tilgang til kontoen din i maksimalt 2 timer. Hver handling vil bli logget. Du kan lukke denne siden.",
"pub.invitedOnFindo": "Du er invitert til Findloop",
"pub.isThisYourItem": "Er dette gjenstanden din?",
"pub.itemsAvailableCount": "{n} gjenstand(er) tilgjengelig for øyeblikket",
"pub.itemsFoundOwner": "av betrodde gjenstander fant sin eier",
"pub.itemsReturnedOwners": "gjenstander returnert til sine eiere",
"pub.itsMine": "Den er min",
"pub.joinFindoDesc": "Bli med i Findloop og administrer de funnet gjenstandene med letthet.",
"pub.joinInvitesYou": "inviterer deg til å bli med i findloop. Opprett din partnerkonto for å administrere de funnet gjenstandene.",
"pub.linkCopied": "Lenke kopiert!",
"pub.loadingContract": "Laster kontrakten…",
"pub.lsClaimDesc": "Rapporter tapet ditt for å få det tilbake. Legg igjen e-posten din, så sender vi deg en påminnelse hvis rapporten din ikke er fullført.",
"pub.lsHeroDesc": "Sjekk selv om den tapte gjenstanden din er funnet og etterlatt her. Fant du den? Rapportér den for å få den tilbake.",
"pub.lsSearchTitle": "Søk etter funnet gjenstander",
"pub.makeOffer": "Gi et tilbud",
"pub.makeOfferDesc": "Foreslå beløpet ditt. Superadministrator vil vurdere det.",
"pub.mapNearYou": "Gjenstander og partnere nær deg",
"pub.mapWord": "Kart",
"pub.messageSentToast": "Melding sendt - teamet vårt vil svare snart.",
"pub.messageWord": "Melding",
"pub.momoInitiated": "Mobilbetalingsprosess initiert",
"pub.monthsWord": "måneder",
"pub.nameConsentRequired": "Navn og samtykke kreves.",
"pub.newDeadline": "Ny frist",
"pub.noActionRequired": "Ingen handling nødvendig.",
"pub.noAmountCharged": "Ingen beløp ble trukket.",
"pub.noItemMatch": "Ingen tilgjengelig gjenstand matcher søket ditt for øyeblikket.",
"pub.noMatchingItem": "Ingen matcher gjenstand",
"pub.noPaymentSession": "Ingen betalingsøkt.",
"pub.noPhoto": "Ingen foto",
"pub.noPointsYet": "Ingen poeng å vise ennå.",
"pub.noSecondPayment": "Ingen annen betaling er nødvendig for denne gjenstanden.",
"pub.notHereYet": "Ikke her ennå? Få beskjed så snart det ankommer.",
"pub.notifyDone": "Notert! Vi vil varsle deg via e-post så snart en matchende gjenstand ankommer.",
"pub.offerSubmitted": "Tilbudet ditt har blitt sendt.",
"pub.oops": "Oops",
"pub.orAlertEmail": "Eller bli varslet på e-post så snart en matchende gjenstand ankommer:",
"pub.ownerContacts": "Eierens kontaktinformasjon",
"pub.ownerContactsUnlocked": "Eierens kontaktinformasjon låst opp",
"pub.partnerContact": "Partnerkontakt",
"pub.payLinkUnavailable": "Betalingslenke utilgjengelig - kontakt partneren.",
"pub.paymentCancelled": "Betaling avbrutt",
"pub.paymentConfirmed": "Betaling bekreftet 🎉",
"pub.paymentConfirmedDesc": "Du vil motta en e-post med detaljer for å gjenvinne gjenstanden din.",
"pub.paymentNotConfirmed": "Betaling ikke bekreftet",
"pub.paymentNotConfirmedDesc": "Betalingen kunne ikke verifiseres. Prøv igjen eller kontakt partneren.",
"pub.paymentProcessing": "Betalingen behandles. Oppdater om et øyeblikk.",
"pub.photoAdded": "✓ Foto lagt til",
"pub.photoRequired": "Et foto av gjenstanden er påkrevd.",
"pub.previewAlt": "forhåndsvisning",
"pub.publish": "Publiser",
"pub.publishingWord": "Publiserer…",
"pub.qty": "Ant.",
"pub.quoteDeclined": "Tilbud avvist.",
"pub.quoteNotFound": "Tilbud ikke funnet eller utløpt.",
"pub.reasonLabel": "Årsak",
"pub.recoveryAlreadyPaid": "Gjenopprettingsgebyr allerede betalt",
"pub.referralCode": "Henvisningskode:",
"pub.relationshipPlaceholder": "Sønn, ektefelle, notar…",
"pub.renewYourContract": "Forny kontrakten din",
"pub.renewalFailed": "Fornyting mislyktes. Prøv igjen senere.",
"pub.renewing": "Fornyer…",
"pub.replySoon": "Teamet vårt vil svare så snart som mulig.",
"pub.requestGone": "Denne forespørselen finnes ikke lenger.",
"pub.requestHandled": "Forespørsel allerede håndtert",
"pub.requestNotFound": "Forespørsel ikke funnet eller utløpt.",
"pub.requestUnavailable": "Forespørsel utilgjengelig",
"pub.required": "(påkrevd)",
"pub.retroClosing": "Sammen gjør vi verden litt mindre tapt.",
"pub.retroClosing2": "Sammen gjør vi verden litt mindre tapt.",
"pub.retroScroll": "Et år med å gjenvinne det som betyr noe. Bla ned ↓",
"pub.revokeAnytime": "Du kan tilbakekalle når som helst ved å kontakte oss",
"pub.scene": "Scene",
"pub.sendImpossible": "Kan ikke sende",
"pub.sendMessage": "Send meldingen",
"pub.sending": "Sender…",
"pub.sharePreview": "Del forhåndsvisning",
"pub.shareYourAd": "Del annonsen din",
"pub.signedSuccess": "Signert med suksess!",
"pub.signerFullName": "Signerens fulle navn",
"pub.spreadNetwork": "Del det med de rundt deg for å øke sjansene dine.",
"pub.spreadOwner": "Del det for å hjelpe eieren med å gjenvinne sine eiendeler.",
"pub.statusLabel": "Status:",
"pub.subject": "Emne",
"pub.thanksSent": "Takk, meldingen din er sendt.",
"pub.thisYear": "I år",
"pub.validate": "Valider",
"pub.verifyingPayment": "Verifiserer betaling…",
"pub.verifyingYourPayment": "Verifiserer betalingen din…",
"pub.viewAd": "Se annonsen →",
"pub.viewPartner": "Se partneren →",
"pub.yourAdPreview": "Forhåndsvisning av annonsen din",
"pub.yourEmail": "Din e-post",
"pub.yourEmailRecommended": "Din e-post (anbefalt)",
"pub.yourEmailShort": "Din e-post",
"pub.yourName": "Ditt navn",
"pub.yourRelationship": "Ditt forhold til personen",
"qv.acceptAndSign": "Accepter og signer mitt tilbud",
"qv.certifyAuthorized": "Jeg bekrefter at jeg er autorisert til å signere og jeg godtar vilkårene for denne {what} (bindende verdi).",
"qv.clear": "Tøm",
"qv.client": "Kunde",
"qv.conditions": "Vilkår",
"qv.confirmDecline": "Bekreft avslaget på dette tilbudet?",
"qv.countersignedFindo": "Bekreftet av Findloop · {name} den {date}",
"qv.decline": "Avslå",
"qv.description": "Beskrivelse",
"qv.downloadPdf": "Last ned PDF",
"qv.handwrittenSignature": "Håndskrevet signatur",
"qv.inclTax": "Inkl. avgift",
"qv.invalidAmount": "Ugyldig beløp.",
"qv.invoice": "Faktura",
"qv.invoicePaid": "Faktura betalt",
"qv.issuer": "Utsteder",
"qv.messageOptional": "Melding (valgfritt)",
"qv.negotiatedAmount": "Forhandlet beløp",
"qv.payInvoiceOnline": "Betal fakturaen online",
"qv.quote": "Tilbud",
"qv.quoteValidDays": "Tilbud gyldig i {n} dager.",
"qv.sendMyOffer": "Send mitt tilbud",
"qv.signContract": "Signer min kontrakt",
"qv.signNow": "Signer nå",
"qv.signatureAlt": "Signatur",
"qv.signedByOn": "✔ Signert av {name} den {date}",
"qv.stContractSigned": "Kontrakten er signert. Takk!",
"qv.stCounterAccepted": "Ditt tilbud har blitt akseptert! Signer kontrakten din nedenfor.",
"qv.stCounterRefused": "Ditt tilbud kunne ikke bli akseptert.",
"qv.stCountered": "Ditt tilbud er sendt. Venter på finds svar.",
"qv.stDeclined": "Du har avslått dette tilbudet.",
"qv.stSigned": "Tilbud akseptert og signert. Takk!",
"qv.totalHt": "Total ekskl. avgift",
"qv.totalTtc": "Total inkl. avgift",
"qv.unitHt": "Enhet ekskl. avgift",
"qv.vat": "MVA",
"qv.yourProposedAmount": "Ditt foreslåtte beløp ({cur})",
"rate.chooseNote": "Vennligst velg en vurdering.",
"rate.commentPh": "En kommentar (valgfritt)…",
"rate.home": "Tilbake til hjem",
"rate.submit": "Send min vurdering",
"rate.submitting": "Sender…",
"rate.subtitle": "Hvordan gikk det med å hente objektet ditt?",
"rate.successText": "Din tilbakemelding hjelper andre brukere.",
"rate.successTitle": "Takk for din vurdering!",
"rate.title": "Vurder din opplevelse",
"reg.add": "Logg et objekt",
"reg.allBrands": "Alle merker",
"reg.allColors": "Alle farger",
"reg.allLocations": "Alle steder",
"reg.detailDesc": "Detaljer og handlinger for dette funnet objektet.",
"reg.dispAuction": "Auksjon",
"reg.dispAuthorities": "Overlevert til myndighetene",
"reg.dispDestroyed": "Ødelagt",
"reg.dispDonate": "Donasjon til veldedighet",
"reg.dispositionHint": "Registrer objektet som forlater lager. Telles i statistikken etter kategori.",
"reg.emptyCta": "Logg et objekt",
"reg.emptyDesc": "Start med å logge ditt første funnet objekt.",
"reg.emptyTitle": "Ingen objekter funnet",
"reg.establishmentFallback": "etablissementet",
"reg.lblAuctioned": "listet på auksjon",
"reg.lblAuctionedShort": "auksjonert",
"reg.lblAuthorities": "overlevert til myndighetene",
"reg.lblDestroyed": "ødelagt",
"reg.lblDonated": "donert til en veldedighet",
"reg.legalCount": "{n} gjenstand(er): lovlig oppbevaringsperiode nådd",
"reg.legalHint": "Du kan liste dem på auksjon, donere dem til en veldedighet, eller rapportere at du har gitt dem til myndighetene.",
"reg.legalLimitCountry": "Frist: {date} · anvendt land: {country}",
"reg.legalOver": "Frist utgått: {date} · {country}",
"reg.legalReached": "Lovlig periode nådd",
"reg.legalReachedFull": "Lovlig oppbevaringsperiode nådd",
"reg.limitShort": "frist",
"reg.location": "Sted",
"reg.markRestituted": "Merk som returnert",
"reg.markedAs": "Gjenstand merket som {label}",
"reg.moveHistory": "Bevegelseshistorikk",
"reg.overBy": "over av {n}d",
"reg.physicalLocation": "Fysisk plassering",
"reg.popupBlocked": "Tillat vinduer for å skrive ut etikettene.",
"reg.popupBlockedOne": "Tillat vinduer for å skrive ut etiketten.",
"reg.printLabel": "Skriv ut etiketten",
"reg.printN": "Skriv ut {n} etikett(er)",
"reg.qrCodeItem": "Gjenstand QR-kode",
"reg.qrLabelTitle": "QR-etikett",
"reg.qrLabelsTitle": "QR-etiketter",
"reg.qrNotFound": "Ingen gjenstand funnet for denne QR-koden.",
"reg.qrScanHint": "Skann den for å åpne denne oppføringen direkte og finne stedet.",
"reg.recoveryFee": "Gjenopprettingsgebyr (€)",
"reg.searchPh": "Søk etter beskrivelse…",
"reg.selectQr": "Velg for å skrive ut QR-etiketter",
"reg.selectedN": "{n} valgt",
"reg.shipPricePh": "Fraktpris (€)",
"reg.shippingPossible": "Frakt tilgjengelig",
"reg.storagePh": "f.eks. Hyll A3, Skap 12",
"reg.tAuction": "Auksjon på Findloop",
"reg.tAuthorities": "Rapporter levering til myndighetene",
"reg.tDonate": "Doner til en veldedighet",
"reg.toastFee": "Gebyr oppdatert",
"reg.toastLocation": "Sted lagret",
"reg.toastRestituted": "Gjenstand merket som returnert",
"reg.toastShipping": "Fraktalternativ oppdatert",
"reg.toastTransferred": "Gjenstand overført til “{name}”",
"reg.unclaimedDisposition": "Urevidert gjenstand — endelig disposisjon",
"res.codeValidated": "Kode validert",
"res.empty": "Ingen tilbakelevering registrert ennå.",
"res.error": "Feil {status}",
"res.proofPdf": "PDF bevis",
"res.signed": "Signert",
"res.stRestituted": "Overlevert personlig",
"res.stShipped": "Returnert med frakt",
"res.subtitle": "Alle fullførte overleveringer, med deres nedlastbare signerte bevis.",
"res.title": "Historikk for tilbakelevering",
"rev.b2b": "B2B partnere",
"rev.b2c": "Kunder",
"rev.based": "basert på {n} anmeldelser",
"rev.eyebrow": "Uttalelser",
"rev.restitutedBy": "Returnert av {org}",
"rev.storiesEyebrow": "Lykkelige slutninger",
"rev.storiesSubtitle": "Virkelige historier fra kunder som har fått tilbake sine eiendeler med findloop.",
"rev.storiesTitle": "De fant sine eiendeler!",
"rev.subtitle": "Partnere og kunder deler sin erfaring.",
"rev.title": "De stoler på Findloop",
"rev.verified": "Verifisert",
"rp.already": "Du har allerede rapportert denne oppføringen.",
"rp.comment": "Detaljer (valgfritt)",
"rp.duplicate": "Duplikat",
"rp.fraud": "Svindel / bedrageri",
"rp.inappropriate": "Upassende innhold",
"rp.offensive": "Støtende innhold",
"rp.other": "Annet",
"rp.reason": "Årsak",
"rp.report": "Rapporter",
"rp.send": "Send rapport",
"rp.sent": "Rapport sendt. Takk for ditt bidrag.",
"rp.spam": "Spam / reklame",
"rp.title": "Rapporter denne oppføringen",
"rp.wrongCategory": "Feil kategori",
"rt.annualGoal": "Årlig mål",
"rt.championCity": "Mesterby",
"rt.cityRate": "{rate}% retur rate",
"rt.goalProgress": "{rate}% oppnådd av et {target}% mål",
"rt.reached": "Oppnådd 🎉",
"rt.restitutionRate": "Retur rate",
"rt.shareRecap": "Del min oppsummering",
"rt.thanks": "Takk, Findloop {year} 💛",
"rt.yourRecap": "Din {year} oppsummering",
"rw.active": "Aktiv",
"rw.add": "Legg til",
"rw.camUnavailable": "Kamera utilgjengelig. Skriv inn koden manuelt nedenfor.",
"rw.codeValidated": "Koden er validert",
"rw.codesTitle": "Koder innløst av finnerne",
"rw.confirmDelete": "Slette “{title}”?",
"rw.deleted": "Slettet",
"rw.edit": "Rediger",
"rw.editReward": "Rediger belønningen",
"rw.empty": "Ingen belønning ennå.",
"rw.expired": "Utløpt",
"rw.expiresOn": "Utløper {date}",
"rw.fActive": "Aktiv (synlig for finnerne)",
"rw.fCost": "Kostnad (poeng)",
"rw.fDesc": "Beskrivelse",
"rw.fStock": "Lager (tomt = ubegrenset)",
"rw.fTitle": "Tittel",
"rw.fValidity": "Gyldighet av kupong (dager etter innløsning)",
"rw.inactive": "Inaktiv",
"rw.newReward": "Ny belønning",
"rw.noExchange": "Ingen innløsning ennå.",
"rw.pageSubtitle": "Scan kupongene presentert av finnerne for å validere belønningene deres.",
"rw.redeemedN": "Inløst: {n}×",
"rw.saved": "Belønning lagret",
"rw.scanVoucher": "Scan en kupong",
"rw.staffScanOnly": "Bare scan",
"rw.statActive": "Å presentere",
"rw.statExpired": "Utløpt",
"rw.statRedeemed": "Kuponger innløst",
"rw.statUsed": "Validert",
"rw.stock": "Lager",
"rw.subtitle": "Tilby ikke-monetære fordeler (kuponger, oppgraderinger…) som finnerne kan innløse for sine Finder Score-poeng.",
"rw.title": "Belønninger for finnerne",
"rw.used": "Brukt",
"rw.validate": "Validere",
"rw.validateCode": "Validere koden",
"rw.validity": "Gyldighet: {n} d",
"shell.f1d": "Knytt automatisk tapte og funnede gjenstander.",
"shell.f1t": "Smart AI-matching",
"shell.f2d": "Spor returneringsrate og inntekter i sanntid.",
"shell.f2t": "Dashbord & inntekter",
"shell.f3d": "Dine kunder rapporterer på 30 sekunder.",
"shell.f3t": "Partner QR-kode",
"shell.title": "Gjør tapte gjenstander til fornøyde kunder.",
"ship.addr1": "Adresse",
"ship.addr2": "Adresse linje 2 (valgfritt)",
"ship.badge": "Frakt",
"ship.city": "By",
"ship.country": "Land",
"ship.needPaid": "Betal først innløsningsavgiften for å be om frakt.",
"ship.notShippable": "Denne gjenstanden er ikke tilgjengelig for frakt.",
"ship.notfound": "Rapport ikke funnet.",
"ship.postal": "Postnummer",
"ship.price": "Fraktkostnad",
"ship.submit": "Be om frakt",
"ship.submitting": "Sender…",
"ship.subtitle": "Skriv inn leveringsadressen din.",
"ship.successText": "Partneren vil forberede pakken din. Du vil bli varslet når den er sendt.",
"ship.successTitle": "Fraktforespørsel sendt!",
"ship.title": "Få gjenstanden din sendt",
"ship.weight": "Estimert vekt (kg)",
"shp.carrier": "Fraktgiver",
"shp.download": "Last ned PDF",
"shp.generating": "Genererer…",
"shp.label": "Generer etikett",
"shp.none": "Ingen frakt forespurt.",
"shp.setTracking": "Lagre sporing",
"shp.status": "Status",
"shp.to": "Mottaker",
"shp.tracking": "Sporingsnr.",
"shp.trackingSaved": "Sporing lagret",
"side.account": "Min konto",
"side.declarations": "Rapporter",
"side.deposit": "Logg en gjenstand",
"side.establishments": "Etableringer",
"side.invoices": "Fakturaer",
"side.logout": "Logg ut",
"side.matchHistory": "AI-historikk",
"side.partner": "Partner",
"side.refresh": "Oppdater",
"side.registry": "Register",
"side.restitutions": "Returer",
"side.reviews": "Vurderinger",
"side.rewards": "Belønninger & Vouchers",
"side.settings": "Innstillinger",
"side.shipments": "Sendinger",
"side.stats": "Statistikk",
"side.storage": "Lagring & QR",
"side.team": "Team",
"side.viewSite": "Se offentlig side",
"st.auctioned": "Solgt på auksjon",
"st.claimed": "Krevd",
"st.closed": "Lukket",
"st.delivered": "Levert",
"st.destroyed": "Ødelagt",
"st.donated": "Donert (veldedighet)",
"st.handed_to_authorities": "Overlevert til myndighetene",
"st.in_storage": "I lager",
"st.matched": "Match funnet",
"st.open": "Åpen",
"st.paid": "Betalt",
"st.pending": "Under behandling",
"st.resolved": "Løst",
"st.restituted": "Returnert",
"st.second_chance": "Andre sjanse",
"st.shipped": "Sendt",
"st.shipping_requested": "Frakt forespurt",
"st.submitted": "Innsendt",
"st.verified": "Bekreftet",
"stat.items": "Registrerte gjenstander",
"stat.partners": "Partnere",
"stat.restituted": "Returnerte gjenstander",
"status.auctioned": "Auksjonert",
"status.destroyed": "Ødelagt",
"status.donated": "Donert (veldedighet)",
"status.handed_to_authorities": "Overlevert til myndighetene",
"status.in_storage": "I lager",
"status.matched": "Match",
"status.open": "Åpen",
"status.paid": "Betalt",
"status.pending": "Under behandling",
"status.restituted": "Returnert",
"status.shipped": "Sendt",
"status.shipping_requested": "Frakt forespurt",
"status.submitted": "Innsendt",
"step1.tag": "Etablering",
"step1.text": "I løpet av sekunder logger etableringen den funne gjenstanden med et bilde, kategori og beskrivelse. Alt er sentralisert i et klart, sikkert register.",
"step1.title": "Partneren registrerer gjenstanden",
"step2.tag": "Kunde",
"step2.text": "Via partnerens QR-kode beskriver kunden din den tapte gjenstanden på 30 sekunder. Ingen app å installere — alt skjer i nettleseren.",
"step2.title": "Kunden rapporterer tapet",
"step3.tag": "Intelligens",
"step3.text": "Vår smarte matchingsmotor sammenligner beskrivelser og foreslår de mest sannsynlige samsvarene, klare til å bekreftes.",
"step3.title": "AI kobler tap og funnet gjenstand",
"step4.tag": "Gjenoppretting",
"step4.text": "Etter en sikker betaling av gjenopprettingsgebyret henter kunden gjenstanden på stedet — eller mottar den med sporet frakt.",
"step4.title": "Kunden får gjenstanden sin tilbake",
"stg.allLabels": "Alle QR-etiketter",
"stg.camHint": "Bruk manuell inntasting nedenfor.",
"stg.camStarting": "Starter kameraet…",
"stg.camUnavailable": "Kamera utilgjengelig.",
"stg.clear": "Tøm",
"stg.clearAll": "Tøm alt",
"stg.codeUnreadable": "Uleselig kode.",
"stg.emptyDesc": "Lagrerte gjenstander vises her, gruppert etter sted.",
"stg.emptyTitle": "Ingen gjenstand i lager",
"stg.exportAudit": "Eksporter revisjon CSV",
"stg.exportDone": "CSV-eksport lastet ned",
"stg.exportImpossible": "Eksport utilgjengelig akkurat nå.",
"stg.itemFound": "Gjenstand funnet ✅",
"stg.kLocations": "Brukte steder",
"stg.kObjects": "Lagrerte gjenstander",
"stg.kToClear": "Steder som skal tømmes",
"stg.locFreed": "Sted tømt",
"stg.locsFreed": "{n} sted(er) tømt",
"stg.manualLabel": "Eller skriv inn gjenstandens kode / ID",
"stg.manualPh": "Lim inn QR-kodens ID eller URL",
"stg.noItemMatch": "Ingen gjenstand samsvarer med denne QR / koden.",
"stg.noLocation": "Ingen lokasjon",
"stg.objectsAxis": "Gjenstander",
"stg.objectsN": "{n} gjenstand(er)",
"stg.occAvg": "gjennomsnitt {n} gjenstander/lokasjon",
"stg.occHint": "Lokasjoner i amber overskrider gjennomsnittet (potensielt overbelastet).",
"stg.occupancy": "Lokasjonsopptak",
"stg.openPage": "Åpne siden",
"stg.posterPdf": "PDF-plakat (A4)",
"stg.printAll": "Skriv ut alt",
"stg.printGroupTitle": "Skriv ut merkelapper for denne hyllen",
"stg.qrAlt": "Selvbetjenings QR",
"stg.qrDownload": "Last ned QR-en",
"stg.qrHint": "Vis denne QR-en i kassen: kundene dine skanner den for å sjekke om gjenstanden er tilgjengelig.",
"stg.qrTitle": "Kundens selvbetjente QR",
"stg.scanDesc": "Skann en gjenstands etikett for å åpne dens post umiddelbart.",
"stg.scanQr": "Skann en QR",
"stg.scanTitle": "Skann en QR-kode",
"stg.search": "Søk",
"stg.shelf": "Hylle {loc}",
"stg.shelfPlan": "Hylla plan",
"stg.staleHint": "Rydd disse lokasjonene for å holde ditt fysiske inventar oppdatert.",
"stg.staleTitle": "{n} gjenstand(er) har forlatt lageret, men har fortsatt en lokasjon",
"stg.subtitle": "Hylla plan, QR-skanner og fysisk inventarsporing.",
"stg.title": "Lager & QR",
"stt.acceptRate": "Akseptansegrad",
"stt.accepted": "Akseptert",
"stt.activity30": "Aktivitet (siste 30 dager)",
"stt.ai6mo": "Siste 6 måneder · akseptert = automatisk matchet + bekreftet.",
"stt.aiEmpty": "Ingen AI-matcher over denne perioden ennå.",
"stt.aiTitle": "AI-matcher — akseptert vs avvist",
"stt.auctionShort": "Auksjon",
"stt.auctionedSold": "Auksjonert (solgt)",
"stt.authShort": "Myndigheter",
"stt.authorities": "Overlevert myndighetene",
"stt.avgRating": "Gjennomsnittlig vurdering",
"stt.awaitingRestitution": "gjenstander som venter på tilbakelevering",
"stt.boostClicks": "Klikk på din katalog denne uken takket være boost",
"stt.boostInactive": "Boost inaktiv — aktiver den for å få synlighet",
"stt.certifiedPremium": "Premium sertifisert",
"stt.declarations": "Erklæringer",
"stt.destroyed": "Ødelagt",
"stt.dispoEmpty": "Ingen uoppdagede gjenstander har forlatt lageret ennå.",
"stt.donatedAssoc": "Donert (veldedighet)",
"stt.donatedShort": "Donert",
"stt.gateCta": "Oppdag planene",
"stt.gateDesc": "Oppgrader til Starter for å låse opp dine grunnleggende statistikker, eller til Business for avanserte statistikker og analyse per etablissement.",
"stt.gateTitle": "Statistikk forbeholdt betalte planer",
"stt.inStorage": "I lager",
"stt.kItems": "Registrerte gjenstander",
"stt.kRate": "Tilbakeleveringsgrad",
"stt.kRestituted": "Gjenstander returnert",
"stt.kRevenue": "Inntekt (måned)",
"stt.noDeclYet": "Ingen erklæringer ennå.",
"stt.recapDownloaded": "Oppsummering lastet ned — klar til å dele!",
"stt.recapError": "Kunne ikke generere oppsummeringen",
"stt.recapText": "Vår Findloop {year} oppsummering: gjenstander returnert og kundetilfredshet 🎉",
"stt.recapTitle": "Findloop {year} oppsummering",
"stt.rejected": "Avvist",
"stt.restitutions": "Returer",
"stt.shareRecap": "Del min {year} oppsummering",
"stt.topCategories": "Mest deklarerte kategorier",
"stt.unclaimedDesc": "Mengde varer ødelagt, donert til veldedighet og auksjonert, etter kategori.",
"stt.unclaimedTitle": "Ukrevede gjenstander — forlater lagring",
"stt.vsLastWeek": "mot forrige uke",
"sub.cancel": "Avbryt abonnementet mitt",
"sub.cancelAbort": "Avbryt",
"sub.cancelConfirm1": "Er du sikker på at du vil avbryte? Din tilgang forblir aktiv til",
"sub.cancelConfirm2": "Ingen refusjon vil bli utstedt.",
"sub.cancelConfirmBtn": "Bekreft avbestilling",
"sub.cancelTitle": "Avbryt abonnementet ditt",
"sub.cancelledToast": "Avbestilling registrert.",
"sub.cguAnd": "og",
"sub.cguDesc": "Vennligst bekreft din avtale før betaling.",
"sub.cguLink": "Bruksvilkår",
"sub.cguPay": "Fortsett til betaling",
"sub.cguPre": "Jeg har lest og aksepterer",
"sub.cguRequired": "Du må akseptere Bruksvilkårene og personvernerklæringen for å fortsette.",
"sub.cguSuffix": "til findloop.",
"sub.cguTitle": "Fullfør abonnementet ditt",
"sub.expiresOn": "Ditt abonnement utløper den",
"sub.noProrata": "Ingen pro-rata refusjon.",
"sub.privacyLink": "Personvernerklæring",
"sub.renewsOn": "Ditt abonnement fornyes den",
"sub.resume": "Abonner igjen",
"sub.resumedToast": "Gjenabonnement bekreftet.",
"tier.free": "Freemium",
"tier.large": "Bedrift",
"tier.medium": "Virksomhet",
"tier.small": "Starter",
"tm.add": "Legg til",
"tm.adminOpt": "Admin (full visning)",
"tm.chooseEst": "Velg en virksomhet",
"tm.chooseEstPh": "Velg en virksomhet",
"tm.copyFail": "Kopiering mislyktes",
"tm.copyLink": "Kopier lenken",
"tm.copyOk": "Invitasjonslenke kopiert",
"tm.emailHint": "En invitasjons-e-post vil bli sendt for å opprette passordet.",
"tm.expiresOn": "utløper den {date}",
"tm.forEmail": " for {email}",
"tm.forbidden": "Teamledelse er forbeholdt konto-eieren.",
"tm.inviteCreated": "Invitasjon opprettet",
"tm.inviteDesc": "En invitasjons-e-post lar teammedlemmet opprette sitt passord.",
"tm.invitePending": "Venter på invitasjon",
"tm.inviteResent": "Invitasjon sendt på nytt",
"tm.inviteSent": "Invitasjon sendt på e-post",
"tm.inviteTitle": "Inviter et medlem",
"tm.invitedOn": "Invitert den {date}",
"tm.linkExpired": "Lenke utløpt",
"tm.memberRemoved": "Medlem fjernet",
"tm.name": "Navn",
"tm.noMembers": "Ingen teammedlem ennå.",
"tm.resendTitle": "Send invitasjonen på nytt",
"tm.role": "Rolle",
"tm.roleAdmin": "Administrator",
"tm.roleOwner": "Eier",
"tm.roleStaff": "Ansatt",
"tm.roleUpdated": "Rolle oppdatert",
"tm.sendInvite": "Send invitasjonen",
"tm.sending": "Sender…",
"tm.staffOpt": "Ansatt (ser bare sin egen virksomhet)",
"trk.at": "På",
"trk.badge": "Sporing",
"trk.carrier": "Fraktfører",
"trk.codeValidated": "Kode validert av partneren",
"trk.dlProof": "Last ned mitt bevis på overlevering (PDF)",
"trk.emailLabel": "E-post (valgfritt — for å se detaljene dine)",
"trk.enterEmailCode": "Skriv inn e-posten din ovenfor for å vise kravkoden din.",
"trk.idLabel": "Rapportnummer",
"trk.lostEmail": "Jeg har ikke lenger tilgang til e-posten min",
"trk.phonePh": "Ditt telefonnummer",
"trk.photoBefore": "Foto av varen før frakt",
"trk.recoverBtn": "Gjenopprett min vare",
"trk.recoverHint": "Få kravkoden din via SMS til ditt registrerte nummer.",
"trk.searching": "Søker…",
"trk.secureRest": "Sikker overlevering",
"trk.send": "Send",
"trk.shipPending": "Frakt forberedes — sporingsnummeret vil vises her når det er sendt.",
"trk.shipTitle": "Sporing av forsendelse",
"trk.showQr": "Vis denne QR-koden til partneren for å validere overleveringen",
"trk.sigSaved": "Signatur lagret",
"trk.signFirst": "Vennligst signer før du bekrefter.",
"trk.signProof": "Signer ditt bevis på overlevering",
"trk.signSubmit": "Bekreft signaturen min og generer PDF",
"trk.submit": "Spor",
"trk.subtitle": "Skriv inn rapportnummeret ditt for å spore fremdriften.",
"trk.title": "Spor min rapport",
"trk.trackShipment": "Spor pakke",
"trk.trackingNo": "Sporingsnummer",
"trk.yourCode": "Din kravkode (å gi til partneren)",
"a.firstName": "Fornavn",
"ac.emailCrossMatch": "B2C kryss-sjekk",
"ac.emailCrossMatchDesc": "En e-post når en offentlig tapt-gjenstand annonse matcher en gjenstand levert hos deg",
"ac.emailCrossReject": "Offentlige matchavvisninger",
"ac.emailCrossRejectDesc": "Motta en e-post når en kunde indikerer at et foreslått offentlig match ikke er deres gjenstand.",
"ac.emailLoginNotif": "Innlogging varsling",
"ac.emailLoginNotifDesc": "Motta en e-post hver gang noen logger inn på kontoen din.",
"ad.closeNoCancel": "Nei, fjern oppføringen",
"ad.closeQuestion": "Ble gjenstanden returnert til deg?",
"ad.closeQuestionDesc": "Gi oss beskjed om du har fått tilbake gjenstanden din, eller om du rett og slett vil fjerne denne oppføringen.",
"ad.closeYesRestituted": "Ja, gjenstanden ble returnert",
"ad.closedRestituted": "Gjenstand returnert — oppføringen er lukket 🎉",
"an.lostLoginDesc": "En konto er nødvendig for å rapportere en tapt gjenstand og følge med på tilbakeføringen.",
"an.lostLoginRequired": "Logg inn for å rapportere en tapt gjenstand",
"an.qfAll": "Alle",
"an.qfBoosted": "Boostet",
"an.qfPhoto": "Med foto",
"an.qfRecent": "Denne uken",
"an.qfResolved": "Løst",
"an.restitutionInProgress": "Gjenstand som returneres",
"dec.descPhLong": "Beskriv gjenstanden: merke, farge, særegne kjennetegn… (Jo flere detaljer du gir, jo høyere sjanser for å få tilbake gjenstanden din)",
"dec.loadError": "Kan ikke laste partneren akkurat nå. Sjekk tilkoblingen din og prøv igjen.",
"dec.retry": "Prøv igjen",
"dec.shippingMode": "Frakt",
"dep.photo2": "2. gjenstand foto",
"dep.photo2Hint": "Valgfritt — en annen vinkel forbedrer visuell samsvars nøyaktighet.",
"dl.accountSuspended": "Konto suspendert for en ubetalt faktura. Betal for å gjenopprette tilgangen din.",
"dl.regularize": "Betal nå →",
"dl.suspensionCountdown": "Faktura {num} ubetalt — kontoen din vil bli suspendert om {days} dag(er). Betal for å unngå dette.",
"ft.cancelConfirm": "Avbryte rapporten din? Eieren av gjenstanden vil bli informert.",
"ft.cancelDone": "Rapport avbrutt.",
"ft.cancelLocked": "Avbestilling er ikke lenger mulig etter at eieren har betalt.",
"ft.cancelReport": "Avbryt rapporten min",
"ft.claimCodeHelp": "Gi denne koden til finneren ved overlevering for å bekrefte at du har mottatt gjenstanden din.",
"ft.claimCodeTitle": "Din restitutionskode",
"ft.claimDone": "Gjenstand returnert. Takk for at du bruker Findloop!",
"ft.claimUnlockHint": "Lås opp finnerens kontaktopplysninger",
"ft.claimUnlockHintSub": "Gå til \"Gjenstander jeg krever\" i kontoen din for å betale gebyret og få kontaktinformasjonen.",
"ft.finderCodeShownHelp": "Eieren har betalt og valgt deg. Kopier denne koden nedenfor for å bekrefte tilbakeføringen — du trenger ikke å sjekke e-posten din.",
"ft.finderCodeShownTitle": "Eierens valideringskode",
"ft.finderContactsTitle": "Finderens kontaktinformasjon",
"ft.foundCodeHelp": "Vis denne koden til eieren ved overlevering for å bekrefte at varen ble returnert.",
"ft.inProgressOther": "Vare som returneres",
"ft.inProgressOtherHelp": "Eieren valgte en annen finder for denne varen. Ingen videre tiltak er nødvendig fra din side.",
"ft.restitutionCodeHelp": "Denne koden bekrefter overlevering av varen. Den er allerede forhåndsutfylt nedenfor; bekreft den og lukk saken.",
"ft.restitutionCodeTitle": "Din restitusjonskode",
"hc.14Digits": "14 sifre",
"hc.15DaysBeforeAnItem": "15 dager før varens lovlige frist.",
"hc.7DaysBeforeAnItem": "7 dager før varens lovlige frist.",
"hc.8CharactersMinimum": "8 tegn minimum.",
"hc.aClaimToValidate": "En krav som skal valideres",
"hc.aFindoAssistanceSessionIs": "En Findloop hjelpesesjon er for øyeblikket aktiv på kontoen din.",
"hc.aNewMatchHasBeen": "En ny kamp har blitt funnet",
"hc.aUser": "En bruker",
"hc.aUserClaimsToBe": "En bruker påstår å være eieren. Sjekk deres svar før du godkjenner returen.",
"hc.aboutFindo": "Om Findloop",
"hc.accountActivatedPleaseLogIn": "Konto aktivert, vennligst logg inn.",
"hc.accountActivation": "Kontoaktivering",
"hc.accountCreated": "Konto opprettet!",
"hc.accountDeactivatedAReactivationEmail": "Konto deaktivert. En reaktiverings-e-post (gyldig i 30 dager) er sendt til deg.",
"hc.accountReactivation": "Konto reaktivering",
"hc.activateMyAccount": "Aktiver min konto",
"hc.activateMyAdminAccount": "Aktiver min admin-konto",
"hc.activating": "Aktiverer…",
"hc.activeMatchCancelReason": "Aktiv kamp. Kundens avbestillingsgrunn: \"{reason}\". Varen venter fortsatt på et krav.",
"hc.activeMatchWithAPublic": "Aktiv kamp med en offentlig (kunde) oppføring. Venter på eierens krav.",
"hc.addAPhoto": "Legg til et foto",
"hc.addAndConfigureYourEstablishments": "Legg til og konfigurer dine etablissementer i \"Etableringer\": kontaktinformasjon, kategori og fysisk lagring av varer.",
"hc.addOnGoogle": "Legg til på Google",
"hc.address": "Adresse",
"hc.addressSaved": "Adresse lagret",
"hc.addressStreet": "Adresse — Gate",
"hc.adjustThePhoto": "Juster fotoet",
"hc.adminFullView": "Administrator (full visning)",
"hc.administratorOnly": "Kun administrator",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "AI visuell sammenligning",
"hc.all": "Alle",
"hc.amount": "Beløp",
"hc.anOrganization": "En organisasjon",
"hc.analyzing": "Analyserer…",
"hc.andRecoveryIs": "og gjenopprettingen er",
"hc.andTheDeclarationWillBe": "og erklæringen vil bli lukket (flyttet til historikk). Denne handlingen er endelig.",
"hc.annual20": "Årlig -20%",
"hc.annualBilling20": "Årlig fakturering (−20%)",
"hc.annualTarget": "Årlig mål",
"hc.anyCommentsOptional": "Eventuelle kommentarer? (valgfritt)",
"hc.approveTheClaim": "Godkjenn kravet",
"hc.archiveCancelledConfirm": "Arkivere {n} oppføring(er) \"Avbestilt av kunden\"? De vil bli fjernet fra registeret.",
"hc.asSoonAs": "Så snart som",
"hc.askTheOwnerToDisplay": "Be eieren vise QR-koden deres (sporingsside).",
"hc.askThemAtTheCounter": "Be dem i skranken bekrefte identitet — aldri offentlig synlig.",
"hc.assistance": "Support",
"hc.assistanceSessionRevoked": "Hjelpesessionen er tilbakekalt.",
"hc.atLeast6Characters": "Minst 6 tegn",
"hc.automaticallyPreSelected": "automatiskt forhåndsvalgt",
"hc.automaticallyWhenShipping": "automatiskt ved frakt.",
"hc.awaitingClaim": "Venter på krav",
"hc.awaitingPayment": "Venter på betaling",
"hc.b2cCustomer": "B2C-kunde",
"hc.back": "Tilbake",
"hc.backToHome": "Tilbake til startsiden",
"hc.backToMyAccount": "Tilbake til kontoen min",
"hc.backToPayment": "Tilbake til betaling",
"hc.beforeAfterComparisonSlider": "Før/etter sammenligningsskyver",
"hc.billingInformation": "Faktureringsinformasjon",
"hc.billingInformationSaved": "Faktureringsinformasjon lagret ✓",
"hc.brand": "Merke",
"hc.bronze": "Bronse",
"hc.calculatingTheShippingRate": "Beregner fraktkostnad…",
"hc.cameraUnavailableEnterTheCode": "Kamera utilgjengelig. Skriv inn koden manuelt.",
"hc.cancel": "Avbryt",
"hc.cancelMyDeclaration": "Avbryt min erklæring",
"hc.cancelSavedFmt": "Avbestilling lagret: \"{reason}\". Du kan fortsatt kreve.",
"hc.cancelTheDeposit": "Avbryt innskuddet",
"hc.cancelThisMatch": "Avbryt denne kampen",
"hc.cancellationReason": "Årsak til avbestilling",
"hc.cancelled": "Avbestilt",
"hc.cancelledByTheCustomer": "Avbestilt av kunden",
"hc.cannotOpenPayment": "Kan ikke åpne betalingen. Vennligst prøv igjen.",
"hc.careers": "Karrierer",
"hc.carrier": "Fraktleverandør",
"hc.carrierAvailabilityCannotBeChecked": "Tilgjengelighet for fraktleverandør kan ikke sjekkes før Sendcloud-avsenderen din er konfigurert.",
"hc.carrierConfirmedCharged": "Fraktleverandør bekreftet — {price} € belastet kunden",
"hc.carrierOther": "Fraktleverandør (andre)",
"hc.carrierSelection": "Valg av fraktleverandør",
"hc.caseClosedThankYou": "Sak avsluttet. Takk!",
"hc.category": "Kategori",
"hc.changeMethod": "Endre metode",
"hc.characteristic": "Egenskap",
"hc.chargedToCustomer": "belastet kunden.",
"hc.checkOrEditYourDetails": "Sjekk eller rediger opplysningene dine før sikker betaling.",
"hc.checkStatisticsToTrackDeposited": "Sjekk \"Statistikk\" for å spore deponerte gjenstander, returprosent og ytelse for hver etablering.",
"hc.checkTheDetailsBeforeContacting": "Sjekk detaljene før du kontakter finneren.",
"hc.checkTheDetailsBelowBefore": "Sjekk detaljene nedenfor før du starter returforespørselen.",
"hc.checkTheNewItem": "Sjekk den nye gjenstanden",
"hc.checkThePhotosAndCharacteristics": "Sjekk bildene og egenskaper nedenfor før du går videre med henting.",
"hc.chooseACountry": "Velg et land",
"hc.chooseANewPassword": "Velg et nytt passord",
"hc.chooseAReason": "Velg en grunn",
"hc.chooseTheLegalRetentionAlerts": "Velg de juridiske oppbevaringsvarslene som mottas på e-post for",
"hc.chooseYourPasswordToAccess": "Velg passordet ditt for å få tilgang til administrasjonskonsollen.",
"hc.city": "By",
"hc.claimApproved": "Krav godkjent",
"hc.claimApproved2": "Krav godkjent.",
"hc.claimCodeExpired": "Kravkode utløpt",
"hc.claimCodeVerified": "Kravkode verifisert",
"hc.claimNotFound": "Krav ikke funnet",
"hc.claimNotValidated": "Krav ikke gyldiggjort",
"hc.claimRejected": "Krav avvist",
"hc.claimRejected2": "Krav avvist.",
"hc.claimValidated": "Krav gyldiggjort",
"hc.claimValidatedByThePartner": "Krav gyldiggjort av partneren",
"hc.claimant": "Kravstiller",
"hc.claimsToBeTheOwner": "påstår å være eier av denne gjenstanden og har besvart verifiseringsspørsmålene. Bare godkjenn hvis svarene samsvarer.",
"hc.claimsToValidate": "Krav å validere",
"hc.clear": "Tøm",
"hc.clickToZoom": "Klikk for å zoome",
"hc.close": "Lukk",
"hc.close2": "Lukk",
"hc.closeTheDeclaration": "Lukk erklæringen",
"hc.closeTheDeclaration2": "Lukk erklæringen?",
"hc.codeAlreadyVerified": "Koden er allerede verifisert",
"hc.codeCopied": "Koden er kopiert",
"hc.collapse": "Collaps",
"hc.color": "Farge",
"hc.company": "Firma",
"hc.companyName": "Firmanavn",
"hc.comparePhotos": "Sammenlign bilder",
"hc.compareThemWithTheOwner": "Sammenlign dem med eierens svar — aldri offentlig synlig.",
"hc.condition": "Tilstand",
"hc.confirmAndPay": "Bekreft og betal",
"hc.confirmCancellation": "Bekreft avbestilling",
"hc.confirmCrop": "Bekreft beskjæring",
"hc.confirmDeletion": "Bekreft sletting",
"hc.confirmPassword": "Bekreft passord",
"hc.confirmThatThisIsYour": "Bekreft at dette er din gjenstand. En identitetskontroll vil bli forespurt fra finneren før eventuell kontakt.",
"hc.confirmTheCarrier": "Bekreft transportøren",
"hc.confirmThePassword": "Bekreft passordet",
"hc.confirmYourShippingAddressTo": "Bekreft leveringsadressen din for å fortsette med betalingen.",
"hc.confirmYourSubscription": "Bekreft abonnementet ditt",
"hc.confirmed": "Bekreftet ✓",
"hc.contactFindoToGetYour": "Kontakt Findloop for å få din Sender ID.",
"hc.contactUs": "Kontakt oss",
"hc.continueTheReturn": "Fortsett returen",
"hc.continueToPayment": "Fortsett til betaling",
"hc.copy": "Kopier",
"hc.correctMyDetails": "rett mine detaljer",
"hc.correctThisEntry": "Korriger denne oppføringen?",
"hc.country": "Land",
"hc.countryAddress": "Land (adresse)",
"hc.countryIsoCodeEG": "Land (ISO kode, f.eks. FR)",
"hc.cover": "dekke",
"hc.createTheShipment": "Opprett forsendelsen",
"hc.cropThePhoto": "Beskjær bildet",
"hc.customer": "Kunde",
"hc.customerClaimCodeToCheck": "Kunde kravkode — for å sjekke ved henting:",
"hc.customerReasonFmt": "Kundens årsak: \"{reason}\".",
"hc.customerReminderDelay": "Kundepåminnelse forsinkelse",
"hc.customerWhosePublicListingMatches": "Kunde hvis offentlige oppføring samsvarer med denne gjenstanden — synlig kun for deg.",
"hc.d15": "D-15",
"hc.dangerZone": "Fareområde",
"hc.date": "Dato",
"hc.dateNewest": "Dato (nyeste)",
"hc.dateOldest": "Dato (eldste)",
"hc.daysToYearEnd": "{n} dager til slutten av året",
"hc.deadlineAlert": "Fristvarsel",
"hc.declarationClosed": "Deklarasjon stengt ✓",
"hc.declarationNotFound": "Deklarasjon ikke funnet.",
"hc.declarationNotFound2": "Deklarasjon ikke funnet",
"hc.declarationTracking": "Deklarasjonsoppfølging",
"hc.defaultCarrier": "Standard transportør",
"hc.defaultCarrierPreselected": "Standard transportør forhåndsvalt — kan endres for denne sendingen. Faktisk pris (Sendcloud + {m}% margen).",
"hc.defaultCarrierRemoved": "Standard transportør fjernet",
"hc.delayHours": "Forsinkelse (timer)",
"hc.deleteMyAccount": "Slett kontoen min",
"hc.deleting": "Sletter…",
"hc.deletingDeactivatesYourAccountLogin": "Sletting deaktiverer kontoen din: innlogging er blokkert og data blir oppbevart i 30 dager. Du vil motta en e-post med en reaktiveringslenke som er gyldig i 30 dager.",
"hc.delivered": "Levert",
"hc.depositAnItem": "Sett inn en vare",
"hc.depositCancelledItemPutBack": "Innsetting kansellert — vare satt tilbake på lager.",
"hc.depositCancelledItemRemovedFrom": "Innsetting kansellert — vare fjernet fra registret.",
"hc.depositedOn": "Innsatt den",
"hc.describeTheItemBrandColor": "Beskriv varen: merke, farge, kjennetegn… (Jo flere detaljer du gir, desto bedre sjanser har du for å finne varen din)",
"hc.dimensionsCm": "Mål (cm)",
"hc.disablingAnEmail": "Deaktivering av e-post",
"hc.doesNotHide": "skjuler ikke",
"hc.download": "Last ned",
"hc.downloadThePdf": "Last ned PDF-en",
"hc.draftRestoredPickUpYour": "Utkast gjenopprettet — hent deklarasjonen din der du slapp.",
"hc.dragToReposition": "Dra for å omplassere",
"hc.eGColisPriv": "F.eks. Colis Privé",
"hc.eachItemGetsAQr": "Hver vare får en QR-merke. Skann den fra \"Lagring & QR\" for å finne en vare på et øyeblikk.",
"hc.eachSiteManagesItsOwn": "Hver nettside forvalter sin egen bank. Gå til",
"hc.edit": "Rediger",
"hc.emailNotificationPreferences": "Innstillinger for e-postvarsler",
"hc.emailPreferencesUpdated": "E-postinnstillinger oppdatert",
"hc.enableOrDisableRecoveryFees": "Aktiver eller deaktiver inndrivingsgebyrer for",
"hc.enlargePhoto": "Forstørr bilde",
"hc.enterTheCustomerSCode": "Skriv inn kundens kode",
"hc.estShipRate": "Estimert fraktpris (Sendcloud + {m}% margin):",
"hc.establishment": "Etablering",
"hc.establishment2": "Etablering:",
"hc.establishmentInItsSendcloudAccount": "etablering i sin Sendcloud-konto og gir deg avsender-ID",
"hc.establishmentSettings": "Innstillinger for etablering",
"hc.exCode": "f.eks. ABCD2345",
"hc.exId": "f.eks. 3f2a…",
"hc.exit": "Avslutt",
"hc.explainWhyThisItemIs": "Forklar hvorfor dette objektet ikke tilhører deg…",
"hc.externalPaymentLinks": "Eksterne betalingslenker",
"hc.failed": "Mislyktes",
"hc.feesEnabled": "Avgifter aktivert",
"hc.field": ") felt.",
"hc.finderAcceptedCloseTheCase": "Finder akseptert — avslutt saken når objektet er overlevert personlig.",
"hc.findoCityRanking": "Findloop — By ranking",
"hc.findoForEstablishments": "Findloop for etableringer",
"hc.findoPresentationVideo": "Findloop presentasjonsvideo",
"hc.findoRegistersTheAddressOf": "Findloop registrerer adressen til din",
"hc.findoReviewShare": "Findloop {year} anmeldelse: {n} gjenstander returnert, {rate}% returprosent 🎉",
"hc.firstVerifyTheClaimCode": "Først verifiser kravkoden ovenfor",
"hc.forEveryNewShipmentFrom": "for hver ny sending fra",
"hc.free": "gratis",
"hc.freeRecovery0": "Gratis gjenoppretting (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Gratis gjenoppretting over hele Afrika – Lanseringstilbud",
"hc.freeRecoveryFeesDisabled0": "Gratis gjenoppretting: avgifter deaktivert (0 €)",
"hc.fromTeamInviteYourColleagues": "Fra \"Team\", inviter kollegene dine via e-post og tildel dem en etablering. Hvert medlem ser kun sitt eget omfang.",
"hc.fullName": "Fullt navn",
"hc.fullPhoto": "Fullt bilde",
"hc.gallery": "Galleri",
"hc.giveTheReasonForCancelling": "Gi grunnen til avbestilling. Partneren vil bli informert.",
"hc.goToLogin": "Gå til innlogging",
"hc.goToMyAccount": "Gå til min konto",
"hc.gold": "Gull",
"hc.googleLoginFailed": "Google-pålogging mislyktes",
"hc.hasConfirmedYourPaymentYou": "har bekreftet betalingen din, du vil bli omdirigert automatisk",
"hc.helpCenter": "Hjelpesenter",
"hc.helpUsImproveWhyAre": "Hjelp oss å forbedre: hvorfor forlater du? Kontoen din vil bli deaktivert og kan reaktiveres i 30 dager.",
"hc.hidePassword": "Skjul passord",
"hc.high": "Høy",
"hc.historyOfYourMonthlySubscriptions": "Historikk over dine månedlige abonnementer og deres betalingsstatus.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Hvordan setter jeg opp mitt numeriske Sender ID?",
"hc.iDonTUseIt": "Jeg bruker det ikke nok",
"hc.iFoundItElsewhere": "Jeg fant det et annet sted",
"hc.iNoLongerNeedMy": "Jeg trenger ikke min vare lenger",
"hc.identityVerification": "Identitetsverifisering",
"hc.idleLogoutIn": "Du vil bli logget ut om {n} s på grunn av inaktivitet.",
"hc.ifProvidedTheVolumetricWeight": "Hvis oppgitt, benyttes den volumetriske vekten.",
"hc.ifThePartnerHasNot": "Hvis partneren ikke har bekreftet mottak av den eksterne betalingen etter denne forsinkelsen, minner Findloop automatisk partneren om å validere den.",
"hc.impersonationEnded": "Utenomsorg avsluttet.",
"hc.impersonationMode": "Utenomsorg-modus",
"hc.impersonationSessionExpired": "Utenomsorgsøkten er utløpt.",
"hc.inTheField": ", i feltet",
"hc.inTransit": "I transitt",
"hc.inclVat": "inkl. MVA",
"hc.intraEuVatNumberOptional": "Intra-EU MVA-nummer valgfritt, ingen SIRET nødvendig (utenfor Frankrike).",
"hc.invalidInvitationLink": "Ugyldig invitasjonslenke.",
"hc.invalidInvitationLink2": "Ugyldig invitasjonslenke",
"hc.invalidInviteLink": "Ugyldig eller utløpt invitasjonslenke.",
"hc.invalidNumberEnterAnInternational": "Ugyldig nummer. Skriv inn et internasjonalt nummer, f.eks. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Ugyldig eller utløpt lenke.",
"hc.invalidOrExpiredReactivationLink": "Ugyldig eller utløpt reaktiveringslenke",
"hc.invalidSendcloudId": "Ugyldig Sendcloud ID",
"hc.inviteSubtitle": "{org} inviterer deg til å bli med i deres findloop-team. Velg passordet ditt for å aktivere kontoen din.",
"hc.isAvailableOnSendcloudFor": "er tilgjengelig på Sendcloud for alle dine ruter (innlands + internasjonal).",
"hc.isNotEnabledOnYour": "er ikke aktivert på din Sendcloud-konto for enkelte destinasjoner. Etiketter for disse vil bli generert med en annen tilgjengelig transportør.",
"hc.isThisReallyYourItem": "Er dette virkelig din vare?",
"hc.isThisYourItem": "Er dette din vare?",
"hc.item": "Vare",
"hc.itemAlreadyConfirmed": "Vare allerede bekreftet",
"hc.itemDetails": "Varedetaljer",
"hc.itemFoundAt": "Vare funnet på",
"hc.itemFoundAtAPartner": "Vare funnet hos en partner",
"hc.itemMarkedAsReturned": "Vare merket som returnert ✓",
"hc.itemPhotoRequiredBeforeShipping": "Varebilde (påkrevd før sending)",
"hc.itemPhotoSaved": "Varebilde lagret",
"hc.itemPreview": "Vareforhåndsvisning",
"hc.itemPutBackInStorage": "Vare lagt tilbake i lagring.",
"hc.itemWeight": "Varevekt:",
"hc.itemsReturned": "vare(r) returnert",
"hc.itemsReturnedThisYear": "objekter returnert i år",
"hc.itemsWhoseLegalDeadlineIs": "Objekter hvis rettslige frist er 15 dager unna eller mindre (forsinkede inkludert). Kampene forblir synlige.",
"hc.kbisNumber": "Kbis-nummer",
"hc.keysForgottenOnABench": "Nøkler glemt på en benk",
"hc.labelBeingGenerated": "Merke blir generert",
"hc.leaveTheFieldsEmptyTo": "La feltene stå tomme for å tilby gratis gjenoppretting.",
"hc.legalNotice": "Juridisk merknad",
"hc.limitReachedUpgradeToA": "Grense nådd — oppgrader til en høyere plan",
"hc.linkCopiedShareOn": "Lenke kopiert — del den på {label}",
"hc.linkUnavailable": "Lenke utilgjengelig",
"hc.linkedTo": "Knyttet til",
"hc.listingHiddenByModeration": "Oppføring skjult av moderering.",
"hc.loading": "Laster…",
"hc.locateMe": "Finn meg",
"hc.logIn": "Logg inn",
"hc.logInToGetBack": "Logg inn for å komme tilbake til plassen din og administrere abonnementet ditt.",
"hc.loginFailed": "Innlogging mislyktes",
"hc.lostFoundPlatform": "Tapt & funnet plattform.",
"hc.lostIn": "tapt i",
"hc.lowRate": "Lav sats",
"hc.mainReason": "Hovedårsak",
"hc.mainStreet": "Hovedgate",
"hc.makeSureThisIsThe": "Forsikre deg om at dette er objektet du mistet før du låser opp kontaktinformasjonen til finneren.",
"hc.manageCookies": "Administrer informasjonskapsler",
"hc.manageMyTeam": "Administrer teamet mitt",
"hc.manageYourTeam": "Administrer teamet ditt",
"hc.markAsReturned": "Merk som returnert",
"hc.matchNoClaimInTime": "Kampen fikk ingen krav innen fristen.",
"hc.matchNotFound": "Kamp ikke funnet",
"hc.medium": "Medium",
"hc.milestoneFmt": "{m} returnerte objekter milepæl nådd! På vei mot {next}.",
"hc.missingFeatures": "Manglende funksjoner",
"hc.monthly": "Månedlig",
"hc.monthlyBilling": "Månedlig fakturering",
"hc.moveThePhotoToFit": "Flytt bildet for å passe inn i sirkelen.",
"hc.myAccount": "Min konto",
"hc.myInvoices": "Mine fakturaer",
"hc.myMonthlyInvoices": "Mine månedlige fakturaer",
"hc.nArchived": "{n} annonse(r) arkivert.",
"hc.newCodeGeneratedAndSent": "Ny kode generert og sendt til kunden via e-post og SMS",
"hc.newCodeGeneratedAndSent2": "Ny kode generert og sendt til eieren",
"hc.newPassword": "Nytt passord",
"hc.next": "Neste",
"hc.nextPhoto": "Neste bilde",
"hc.no": "Nei",
"hc.noAnswerProvided": "Ingen svar gitt.",
"hc.noArchivedDeclarations": "Ingen arkiverte deklarasjoner",
"hc.noCountryFound": "Ingen land funnet",
"hc.noDeclarations": "Ingen deklarasjoner",
"hc.noFeesAreChargedTo": "Ingen gebyrer belastes kunden.",
"hc.noInvoiceYet": "Ingen faktura ennå.",
"hc.noInvoiceYetYourInvoices": "Ingen faktura ennå. Dine fakturaer vil vises her automatisk etter hver betaling.",
"hc.noMatchIsAvailableFor": "Ingen match er tilgjengelig nå. Vi gir deg beskjed så snart en vare matcher din deklarasjon.",
"hc.noShipmentMatchesYourSearch": "Ingen forsendelser matcher søket ditt.",
"hc.noShipmentsYet": "Ingen forsendelser ennå.",
"hc.noShipmentsYet2": "Ingen forsendelser ennå",
"hc.none": "ingen",
"hc.noneChooseForEachShipment": "Ingen (velg for hver forsendelse)",
"hc.notMine": "Det er ikke mitt",
"hc.of": "av",
"hc.only": "Bare",
"hc.onlyEachSiteManagesIts": "bare. Hver side administrerer sin egen bankvirksomhet: disse lenkene påvirker ikke noen annen virksomhet.",
"hc.onlyTheOwnerOrAn": "Bare eieren eller en administrator kan konfigurere betalingslenkene for virksomheten.",
"hc.openDepositInTheMenu": "Åpne \"Depositum\" i menyen, beskriv varen og ta et bilde. Den lagres umiddelbart og er klar til å returneres.",
"hc.openSettings": "Åpne Innstillinger →",
"hc.openTheDeclarationToManage": "Åpne deklarasjonen for å administrere forsendelsen",
"hc.optional": "— valgfritt",
"hc.optional2": "(valgfritt)",
"hc.optional3": "valgfritt",
"hc.originalListingPhotoUsed": "Originalt annonsebilde brukt",
"hc.other": "Annet",
"hc.other2": "Annet…",
"hc.ourProducts": "Våre produkter",
"hc.overallRateTrendLast6": "Generell rattetendens (siste 6 måneder)",
"hc.ownerSClaimCode": "Eierens kravkode",
"hc.ownershipConfirmed": "Eierskap bekreftet",
"hc.paid": "Betalt",
"hc.paidOn": "Betalt den",
"hc.paidViaPartner": "Betalt (via partner)",
"hc.parcelBeingPrepared": "Pakke under forberedelse",
"hc.parcelDelivered": "Pakke levert",
"hc.parcelShipped": "Pakke sendt",
"hc.parisGareDeLyon": "Paris, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Partnerkatalog",
"hc.passedOnToTheCustomer": "— videresendt til kunden betalingslenke.",
"hc.password": "Passord",
"hc.passwordResetPleaseLogIn": "Passord tilbakestilt, vennligst logg inn.",
"hc.passwordUpdated": "Passord oppdatert.",
"hc.passwordsDoNotMatch": "Passordene samsvarer ikke.",
"hc.pasteThisSenderIdIn": "Lim inn denne avsender-ID-en i Findloop → Innstillinger",
"hc.payForTheShipmentOf": "Betal for sending av varen din gjennom Findloop med en sikker betaling.",
"hc.payTheRecoveryFees": "Betal innhentingsgebyrene",
"hc.payTheShippingFees": "Betal fraktgebyrene",
"hc.payment": "Betaling",
"hc.paymentAlreadyConfirmedByThe": "Betaling allerede bekreftet av partneren",
"hc.paymentLinksAreNowConfigured": "Betalingslenker er nå konfigurert per virksomhet",
"hc.paymentNotCompletedYourAccount": "Betaling ikke fullført, kontoen din er ikke opprettet — prøv igjen.",
"hc.paymentReceived": "Betaling mottatt",
"hc.paymentSuccessful": "Betaling vellykket!",
"hc.pdfInvoice": "PDF-faktura",
"hc.pending": "Venter",
"hc.period": "Periode",
"hc.phoneNumber": " Telefonnummer",
"hc.phoneOptional": "Telefon (valgfritt)",
"hc.planAt": "plan på",
"hc.planLimitFmt": "Din \"{plan}\"-plan er begrenset til {max} virksomheter. For å administrere {n} nettsteder, anbefaler vi",
"hc.platformReturnTarget": "Plattform tilbakeleveringsmål",
"hc.pleaseCompleteYourShippingAddress": "Vennligst fullfør fraktadressen din.",
"hc.pleaseProvideAPhoneNumber": "Vennligst oppgi et telefonnummer: det er påkrevd av transportøren for frakt.",
"hc.pleaseProvideAReason": "Vennligst oppgi en grunn.",
"hc.pleaseSetYourOwnPassword": "vennligst sett ditt eget passord før du fortsetter.",
"hc.pointsToGoal": "{n} flere poeng for å nå vårt felles mål.",
"hc.posterPreview": "Plakat forhåndsvisning",
"hc.potentialMatchBeingVerified": "Potensiell treff blir verifisert",
"hc.potentialOwner": "Potensiell eier",
"hc.preFilledAutomaticallyYouCan": "Fylles automatisk — du kan erstatte det med et bilde av pakken.",
"hc.pressKit": "Pressekit",
"hc.previewMode": "Forhåndsvisningsmodus:",
"hc.previewOfThePrintReady": "Forhåndsvisning av den trykkeklare A4-plakaten for denne enheten.",
"hc.previous": "Forrige",
"hc.previousPhoto": "Forrige bilde",
"hc.primary": "primær",
"hc.printThePoster": "Skriv ut plakaten",
"hc.privacy": "Personvern",
"hc.privacyPolicy": "Personvernerklæring",
"hc.processedCasesWillAppearHere": "Behandlede saker vil vises her.",
"hc.proofOfReturnPdf": "Bevis på retur (PDF)",
"hc.protectedByRecaptcha": "Beskyttet av reCAPTCHA",
"hc.publicMatch": "Offentlig match",
"hc.putBackInStorage": "Sett tilbake i lager",
"hc.pwdResetByTeam": "Passordet ditt ble tilbakestilt av teamet vårt. For din sikkerhet,",
"hc.questionsToAskTheOwner": "Spørsmål å stille eieren",
"hc.rateChargedToTheCustomer": "Sats belastet kunden:",
"hc.rateOfTarget": "{rate}% oppnådd av et {target}% mål",
"hc.reached": "nådd",
"hc.reactivating": "Aktiverer på nytt…",
"hc.reasonSavedYouCanStill": "Årsak lagret. Du kan fortsatt kreve gjenstanden din.",
"hc.recentMatchesFirst": "Siste matcher først",
"hc.recognizedThePhotoYouSent": "gjenkjente bildet du sendte og beskrev disse egenskapene. Bekreft kun hvis de samsvarer med gjenstanden i din besittelse.",
"hc.recommended": "Anbefalt",
"hc.recoveryFees": "Gjenopprettingsgebyrer",
"hc.recoveryFeesArePaidDirectly": "Gjenopprettingsgebyrer betales direkte til partnerenheten. Findloop mottar ingen betaling fra kunder.",
"hc.recoveryFeesEnabled": "Gjenopprettingsgebyrer aktivert",
"hc.recoveryOfferedByTheEstablishment": "Gjenoppretting tilbudt av enheten — Findloop tar ingen gebyrer.",
"hc.recoveryPaymentLink": "Gjenopprettingsbetalingslenke",
"hc.recoveryPaymentLinkSavedFor": "Gjenopprettingsbetalingslenke lagret for denne enheten",
"hc.redirecting": "Omdirigerer…",
"hc.redirectingToPayment": "Omdirigerer til betaling…",
"hc.redirectingToTheRecoveryOf": "Omdirigerer til gjenoppretting av gjenstanden din…",
"hc.regenerateAndResendToThe": "Regenerer og send på nytt til eieren",
"hc.regenerateTheCode": "Regenerer koden",
"hc.registerAFoundItem": "Registrer en funnet gjenstand",
"hc.rejectTheClaim": "Avvis kravet",
"hc.reminderDelaySaved": "Påminnelseforsinkelse lagret",
"hc.reopenThePaymentLink": "Gjenåpne betalingslenken",
"hc.repeatThePassword": "Gjenta passordet",
"hc.reportAProblem": "Rapporter et problem",
"hc.reportDismissedYourListingRemains": "Rapport avvist. Din oppføring forblir offentlig.",
"hc.requiredUsedToCalculateThe": "Nødvendig: brukt for å beregne Sendcloud fraktpris. Frakt er ikke tilgjengelig over 30 kg.",
"hc.reset": "Tilbakestill",
"hc.resume": "Gjenoppta",
"hc.resumeRegistration": "Gjenoppta registrering",
"hc.retro": "Året i gjennomgang",
"hc.returnSecurity": "Retur sikkerhet",
"hc.returnToTheOwner": "Returner til eieren",
"hc.returned": "returnert",
"hc.reviewTheItemDetails": "Gjennomgå detaljene for varen",
"hc.revokeAccess": "Inndra tilgang",
"hc.role": "Rolle:",
"hc.save": "Lagre",
"hc.save2": "lagre",
"hc.saveAndContinue": "Lagre og fortsett",
"hc.saving": "Lagrer…",
"hc.scanTheClaimCode": "Skann kravkoden",
"hc.scanTheOwnerSQr": "Skann eierens QR",
"hc.scrollThroughLanguages": "Rull gjennom språk",
"hc.searchByCustomerItemOr": "Søk etter kunde, vare eller sporingsnummer…",
"hc.searchForACountry": "Søk etter et land…",
"hc.secureFindoVerification": "Sikker Findloop bekreftelse",
"hc.seeRetro": "Se året i gjennomgang",
"hc.selectedCarrier": "Valgt transportør:",
"hc.selectedPlan": "Valgt plan",
"hc.send": "Send",
"hc.sendcloudSenderIdSaved": "Sendcloud sender-ID lagret",
"hc.sendcloudSenderIdSenderId": "Sendcloud sender-ID (sender_id)",
"hc.sending": "Sender…",
"hc.sessionExpired": "Økten utløpt",
"hc.setUpYourEstablishments": "Sett opp dine etablissementer",
"hc.settings": "Innstillinger",
"hc.settingsSubtitle": "Eksterne betalinger og påminnelser, konfigurert per etablissement.",
"hc.shareFoundText": "Jeg fant en vare — hjelp meg med å finne eieren på Findloop",
"hc.shareLostText": "Jeg mistet en vare — hjelp meg med å finne den på Findloop",
"hc.sharePreview": "Del forhåndsvisning",
"hc.shareTheRanking": "Del rangeringen",
"hc.shareYourQrCodeTo": "Del din QR-kode for å motta erklæringer.",
"hc.shipRateAutoWeight": "Fraktprisen beregnes automatisk via Sendcloud (vekt {w}) på tidspunktet for frakt.",
"hc.shipRateForWeight": "Fraktpris (Sendcloud + {m}% margin) for {w}:",
"hc.shipments": "Forsendelser",
"hc.shipmentsSubtitle": "Konsolidert visning av alle forsendelser fra etableringen, på tvers av alle saker. Klikk på en rad for å administrere forsendelsen i erklæringen.",
"hc.shipping": "Frakt",
"hc.shippingAddress": "Fraktadresse",
"hc.shippingFeesAreHandledAutomatically": "Fraktgebyrer håndteres automatisk av Findloop (Sendcloud) — ingen lenke å angi.",
"hc.shippingFeesHaveAlreadyBeen": "Fraktgebyrer har allerede blitt betalt: transportøren kan ikke lenger endres.",
"hc.shippingNotAvailableForItems": "Frakt ikke tilgjengelig for varer over 30 kg. Kunden må hente varen personlig.",
"hc.shippingPaid": "Frakt betalt ✓",
"hc.showOnlyItemsMatchingA": "Vis kun varer som samsvarer med en offentlig (kunde) liste",
"hc.showPassword": "Vis passord",
"hc.signInTheBoxAbove": "Logg inn i boksen over",
"hc.signatureSaved": "Signatur lagret",
"hc.signedInWithGoogle": "Logget inn med Google",
"hc.signupFailed": "Registrering feilet",
"hc.silver": "Sølv",
"hc.simulatedRatesInPreProduction": "(simulerte priser i forhåndsproduksjon)",
"hc.siretAndVatNumberRequired": "SIRET og momsnummer er påkrevd (Frankrike).",
"hc.skip": "Hopp over",
"hc.smsSentIfAccount": "Hvis det eksisterer en konto med dette nummeret, har et SMS blitt sendt til deg.",
"hc.sortItemsWithAPublic": "Sorter: varer med offentlig samsvar (nyeste) først",
"hc.specifyWhetherYouRecoveredYour": "Angi om du har hentet varen din eller bare ønsker å fjerne denne oppføringen.",
"hc.specifyYourReason": "Angi din grunn",
"hc.specifyYourReason2": "Angi din grunn…",
"hc.staff": "Ansatte",
"hc.status": "Status",
"hc.staySignedIn": "Forbli pålogget",
"hc.step": "Steg",
"hc.stillThere": "Fortsatt der?",
"hc.stopScrolling": "Stopp rulling",
"hc.storeFindWithQr": "Lagre & finn med QR",
"hc.streetName": "Gate navn",
"hc.streetNo": "Gate nr.",
"hc.switchTo": "Bytt til",
"hc.switchToDarkMode": "Bytt til mørk modus",
"hc.switchToLightMode": "Bytt til lys modus",
"hc.takeAPhoto": "Ta et bilde",
"hc.takeChangeThePhoto": "Ta / endre bildet",
"hc.takenFromYourDeclaration": "tatt fra din erklæring",
"hc.target": "Mål",
"hc.targetReached": "Mål nådd",
"hc.targetReachedThankYouTo": "Mål nådd — takk til hele findloop-fellesskapet!",
"hc.tellUsMore": "Fortell oss mer…",
"hc.tellUsWhyYouCancel": "Fortell oss hvorfor du avbestiller. Dette hjelper partneren med å behandle forespørselen din.",
"hc.tellUsWhyYourListing": "Fortell oss hvorfor. Din oppføring forblir aktiv og du kan fortsatt kreve objektet ditt.",
"hc.termsAndConditions": "Vilkår og betingelser",
"hc.termsAndPolicies": "Vilkår og retningslinjer",
"hc.thankYouForYourFeedback": "Takk for tilbakemeldingen din",
"hc.theBannerDisplayedInThe": "banneret vist i registreringen.",
"hc.theClaimantHasBeenInformed": "Søker har blitt informert. Objektet forblir tilgjengelig i den offentlige oppføringen.",
"hc.theClaimantHasBeenNotified": "Søker har blitt varslet og kan nå fortsette med returen.",
"hc.theCustomerPaysTheFees": "Kunden betaler avgiftene til etablissementet.",
"hc.theDayTheLegalRetention": "Dagen den lovlige oppbevaringsperioden nås.",
"hc.theEstablishmentConsideredThatThis": "Etablissementet anså at dette objektet ikke er ditt.",
"hc.theEstablishmentIsReviewingYour": "Etablissementet vurderer svarene dine. Du vil bli varslet så snart kravet ditt er validert, så kan du betale henteravgiftene.",
"hc.theFeesAreTooHigh": "Avgiftene er for høye",
"hc.theFinderConsideredThatThis": "Finneren anså at dette objektet ikke er ditt.",
"hc.theFinderIsReviewingYour": "Finneren vurderer kravet ditt. Du vil bli varslet så snart det er validert.",
"hc.theItem": "Objektet",
"hc.theItemWillBeRemoved": "Objektet vil bli fjernet fra registreringen (ingen krav pågående).",
"hc.theItemWillBeSet": "Objektet vil bli satt tilbake til \"på lager\" og det relaterte kravet annulert.",
"hc.theKbisNumberAndVat": "Kbis-nummeret og MVA-nummeret er nødvendig for Frankrike.",
"hc.theLabelIsGeneratedAutomatically": "Labelen genereres automatisk så snart kunden har betalt fraktavgiftene. Den vil være lastbar her.",
"hc.theLinkMayHaveExpired": "Lenken kan ha utløpt (gyldig i 30 dager). Kontakt findloop-support hvis nødvendig.",
"hc.theOwnerDescribesTheirItem": "Eieren beskriver objektet sitt",
"hc.theOwnerReceivedItBy": "Eieren mottok det via e-post (eller SMS). Skriv inn eller skann det før overlevering.",
"hc.thePartnerConsideredThatThis": "Partneren anså at dette objektet ikke er ditt. Objektet forblir tilgjengelig.",
"hc.thePartnerIsReviewingYour": "Partneren vurderer svarene dine. Du vil bli varslet så snart kravet ditt er validert.",
"hc.theShipmentIsCreatedAutomatically": "Forsendelsen opprettes automatisk når kunden har bekreftet adressen sin og betalt henteravgiftene. Labelen vil deretter bli generert automatisk etter fraktbetaling, og kan lastes ned her.",
"hc.theShippingRateWillBe": "Fraktkostnaden vil bli beregnet automatisk via Sendcloud ved tidspunktet for frakt (registrert vekt).",
"hc.thisCarrierWillBe": "Dette fraktselskapet vil være",
"hc.thisEstablishment": "dette etablissementet",
"hc.thisFieldIsRequiredFor": "Dette feltet er påkrevd for automatisk labelgenerering.",
"hc.thisIsMyItem": "Dette er mitt objekt",
"hc.thisIsMyItemContinue": "Dette er mitt objekt — fortsett",
"hc.thisIsMyItemStart": "Dette er mitt objekt — start returen",
"hc.thisIsNotMyItem": "Dette er ikke mitt objekt",
"hc.thisMatchIsNoLonger": "Denne matchen er ikke lenger tilgjengelig eller har allerede blitt behandlet.",
"hc.thisRateWillBeCharged": "Denne avgiften vil bli belastet kunden. En høy avgift kan avskrekke fra henting.",
"hc.thisStepIsRequiredFor": "Dette steget er påkrevd for at fraktetiketter skal bli generert",
"hc.thisValidationLinkIsInvalid": "Denne valideringslenken er ugyldig eller har utløpt.",
"hc.toCheckBeforeMarkingThe": "For å sjekke før du merker varen som returnert.",
"hc.toConfigureTheLinksAnd": "for å konfigurere lenkene og påminnelsesforsinkelsen for hver etablering.",
"hc.toReachOurFirstMilestone": "for å nå vårt første milepælsmål med 100 returer.",
"hc.toTheCustomer": "til kunden.",
"hc.toTheShippingFeePayment": "til betalingen av fraktkostnaden.",
"hc.toYourRecoveryTracking": "til din sporingsinformasjon for gjenoppretting.",
"hc.tooExpensiveBudget": "For dyrt / budsjett",
"hc.topCitiesForReturns": "Toppbyer for returer",
"hc.trackMyRecovery": "Spor min gjenoppretting",
"hc.trackTheShipmentAndDownload": "Spor sendingen og last ned etiketten (generert automatisk) uten å forlate Erklæringer-fanen.",
"hc.trackYourStatistics": "Spor statistikken din",
"hc.tracking": "Sporing",
"hc.unableToOpenTheShipping": "Kan ikke åpne betalingen av fraktkostnaden. Vennligst prøv igjen.",
"hc.unableToRetrieveTheInvoice": "Kan ikke hente fakturaen.",
"hc.unclaimed": "Ikke krevd",
"hc.unclaimedCustomerReason": "Ikke krevd vare. Kundens grunn: \"{reason}\".",
"hc.unclaimedItem": "Ikke krevd vare",
"hc.unclaimedItemNoClaimWithin": "Ikke krevd vare — ingen krav innen fristen.",
"hc.unclaimedItems": "Ikke krevde varer",
"hc.unclaimedItemsMatchLeftWithout": "Ikke krevde varer: match igjen uten krav innen fristen. Du kan sette dem tilbake i lager.",
"hc.unlockTheFinderSContact": "Lås opp finnerens kontaktinformasjon for å ordne overleveringen.",
"hc.upcoming": "Kommende",
"hc.updateFailed": "Oppdatering mislyktes.",
"hc.usedForInvoices": "Brukt til å utstede dine findloop-fakturaer.",
"hc.vatNumber": "MVA-nummer",
"hc.verificationPending": "Verifisering pågår",
"hc.verificationSentToTheFinder": "Verifisering sendt til finneren. Du vil bli varslet om deres beslutning.",
"hc.verificationSentToThePartner": "Verifisering sendt til partneren. Du vil bli varslet om deres beslutning.",
"hc.verify": "Verifiser",
"hc.verifyingInvite": "Verifiserer invitasjonslenken…",
"hc.verifyingTheLink": "Verifiserer lenken…",
"hc.viewInRegistry": "Vis i registeret",
"hc.viewItem": "Vis vare",
"hc.viewItemRecover": "Vis vare & gjenopprett",
"hc.visibleToTheOwnerAutomatically": "Synlig for eieren · automatisk slettet etter 60 dager.",
"hc.waitingForPartnerConfirmation": "Venter på partnerbekreftelse",
"hc.waitingForThePartnerS": "Venter på partnerens bekreftelse",
"hc.weHaveInformedTheEstablishment": "Vi har informert etablissementet om at denne varen ikke tilhører deg og restartet analysen. Du vil bli varslet så snart en ny match er funnet.",
"hc.weHaveInformedThePartner": "Vi har informert partneren om at denne varen ikke tilhører deg. Din oppføring forblir aktiv for fremtidige matcher.",
"hc.weRanTheAnalysisAgain": "Vi har kjørt analysen på nytt og identifisert et annet objekt som kan være ditt. Vennligst sjekk det igjen.",
"hc.weight": "Vekt",
"hc.weightNotProvidedTheShipping": "Vekt ikke oppgitt: fraktprisen vil bli beregnet ved fraktid.",
"hc.weightUnit": "Vekteining",
"hc.welcome": "Velkommen!",
"hc.welcomeToFindo": "Velkommen til Findloop",
"hc.whenACustomerComesTo": "Når en kunde kommer for å hente tingene sine, åpner de deklarasjonen og bekrefter returen. Det er alt!",
"hc.whenDisabledFeesDropTo": ". Når deaktivert, faller gebyrene til",
"hc.whyIsThisNotYour": "Hvorfor er ikke dette objektet ditt?",
"hc.willBeMarkedAs": "vil bli merket som",
"hc.wrongColor": "Feil farge",
"hc.wrongModel": "Feil modell",
"hc.yesCancel": "Ja, kanseller",
"hc.yesContactTheFinder": "Ja, kontakt finneren",
"hc.youAreHere": "Du er her",
"hc.youBusinessCom": "du@firma.com",
"hc.youCanNowStartThe": "Du kan nå starte returen.",
"hc.youCanStillChangeIt": ". Du kan fortsatt endre det fra sak til sak.",
"hc.youHaveAlreadyConfirmedThat": "Du har allerede bekreftet at dette er ditt objekt.",
"hc.youWillBeRedirectedTo": "Du vil bli videresendt til den sikre Stripe-betalingen.",
"hc.yourAccountHasBeenReactivated": "Din konto har blitt reaktivert.",
"hc.yourAccountIsActiveYou": "Din konto er aktiv, du kan nå administrere etableringene dine.",
"hc.yourEstablishment": "Din etablering",
"hc.yourFeedbackHelpsUsImprove": "Din tilbakemelding hjelper oss med å forbedre matchene våre.",
"hc.yourFeedbackHelpsUsRestart": "Din tilbakemelding hjelper oss med å starte analysen på nytt og forbedre matchene våre.",
"hc.yourFirstSteps": "Dine første steg",
"hc.yourFirstStepsAdmin": "Dine første steg (admin)",
"hc.yourItemHasBeenHanded": "Ditt objekt har blitt overlevert personlig av partneren — lukk saken når overleveringen er bekreftet.",
"hc.yourItemHasBeenShipped": "Ditt objekt har blitt sendt av partneren — lukk saken når levering er bekreftet.",
"hc.yourPaymentHasBeenRecorded": "Din betaling har blitt registrert.",
"hc.yourShipmentIsBeingPrepared": "Din sending blir forberedt. Du vil motta pakken innen 3 til 5 virkedager.",
"hc.yourShippingFeesHaveAlready": "Dine fraktgebyrer har allerede blitt betalt. Frakt betalt ✓",
"hc.yourShippingFeesHaveBeen": "Dine fraktgebyrer har blitt betalt. Pakken din blir forberedt.",
"hc.yourVerificationQuestionsDeposit": "Dine verifikasjons spørsmål (depositum)",
"hero.einvoiceBadge": "2027-kompatibel e-fakturering",
"home.recentAdsAll": "Se alle oppføringer",
"home.recentAdsEyebrow": "Akkurat nå",
"home.recentAdsSubtitle": "Mistet og funnet gjenstander rapportert av samfunnet.",
"home.recentAdsTitle": "Nylige oppføringer",
"home.reunions": "Nylige gjenforeninger",
"home.videoEyebrow": "Se",
"home.videoSubtitle": "Hvordan vi gjenforener tapte gjenstander med eierne, uten problemer.",
"home.videoTitle": "Oppdag Findloop på 2 minutter",
"home.watchYoutube": "Se på YouTube",
"impact.already": "Allerede",
"impact.citiesWord": "by/byer",
"impact.eachPoint": "Hver prikk er en by der Findloop hjelper til med å gjenvinne tapte gjenstander.",
"impact.emptyMap": "Kartet fylles opp etter hvert som tilbakeleveringer skjer.",
"impact.eyebrow": "Vår påvirkning",
"impact.inCities": "i",
"impact.restitutedTo": "gjenstander returnert til sine eiere",
"impact.title": "Gjenstander returnert, overalt nær deg",
"inv2.download": "Last ned",
"inv2.view": "Vis",
"map.objectsOnMapPlural": "gjenstander på kartet",
"map.objectsOnMapSingular": "gjenstand på kartet",
"mc.claimConfirmDesc": "Sjekk gjenstanden som er funnet av finneren før du betaler for å låse opp kontaktinformasjonen deres.",
"mc.claimConfirmNo": "Dette er ikke min gjenstand",
"mc.claimConfirmTitle": "Er dette virkelig din gjenstand?",
"mc.claimConfirmYes": "Ja, den er min — betal",
"mc.claimFinderContacts": "Finderens kontaktinformasjon",
"mc.claimNotMineDone": "Takk — finneren har blitt varslet og forespørselen din ble fjernet fra annonsen.",
"mc.claimUnlockDesc": "Betal findloop-administrasjonsgebyret for å få kontaktinformasjonen til personen som fant gjenstanden din.",
"mc.claimUnlockTitle": "Lås opp finnerens kontaktinformasjon",
"mc.hideCountryOffers": "Skjul tilbud i mitt land",
"mc.myClaims": "Gjenstander jeg krever",
"mc.myClaimsSub": "Gjenstander funnet av andre som du krever. Lås opp finderens kontaktinformasjon for å ordne overleveringen.",
"mc.notifAdCancelled": "Annonse kansellert",
"mc.notifCancelAd": "Kanseller annonsen min",
"mc.offersInCountry": "Tilbud i mitt land",
"mc.offersInCountryDesc": "Alle aktive belønninger fra partnere i ditt land, etter by.",
"mc.redArchived": "Arkivert",
"mc.rewardsCountryNone": "Ingen tilbud i ditt land ennå.",
"mc.rewardsForYou": "Belønninger for deg",
"mc.rewardsForYouDesc": "Tilbudt av partnerne der du leverte inn en gjenstand.",
"mc.rewardsMineNone": "Ingen belønning fra dine leveringspartnere ennå.",
"mc.showCountryOffers": "Se tilbud i mitt land",
"mc2.cancelDecl": "Kanseller min erklæring",
"mc2.cancelDeclDone": "Erklæring kansellert.",
"pricing.physInvDesc": "Når en gjenstand returneres, blir plasseringen automatisk frigjort og tilgjengelig for en ny gjenstand.",
"pricing.physInvTitle": "Fysisk varelageroppfølging",
"pricing.physModalTitle": "Håndtering av fysiske gjenstander",
"pricing.physQrDesc": "En unik QR-kode genereres per gjenstand og lenker til all informasjon om den.",
"pricing.physQrTitle": "Egen QR-etikett",
"pricing.physShelfDesc": "Hver registrert gjenstand kan tildeles en fysisk plassering innenfor etablissementet.",
"pricing.physShelfTitle": "Hylleplan",
"pricing.physicalMgmt": "Håndtering av fysiske gjenstander (hyller, QR, varelager)",
"pub.addSecondPhoto": "Legg til et 2. bilde (valgfritt)",
"pub.photo2Added": "✓ 2. bilde lagt til",
"reg.dispositionJournal": "Disposisjonsjournal",
"reg.dispositionNoteAuthHint": "ℹ️ En melding er nødvendig for “Overlevert til myndighetene” (rapportnummer, avdeling…).",
"reg.dispositionNotePh": "Melding (valgfritt): mottaker velgjørenhet, referanse fra myndigheter, kjøpers navn…",
"reg.dispositionNoteRequired": "En offisiell referanse er nødvendig for å overlevere til myndighetene.",
"reg.legalPrealert": "Juridisk frist om {days} dag(er)",
"reg.legalPrealertOptions": "Alternativer ved frist: auksjonssalg, donasjon til en velgjørenhet, overlevering til myndighetene.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Full gjennomgang",
"rev.readMore": "Les mer",
"rw.activeCodes": "Aktive kuponger",
"rw.archived": "Arkivert",
"rw.archivedTitle": "Innløste kuponger (arkivert)",
"rw.hideArchived": "Skjul innløste kuponger",
"rw.noArchived": "Ingen arkiverte kuponger.",
"rw.showArchived": "Vis innløste kuponger",
"shp.labelAuto": "Etiketten genereres automatisk så snart kunden har betalt fraktkostnadene. Den vil være nedlastbar her.",
"st.cancelled_by_customer": "Avbestilt",
"stt.dispoPdfBtn": "Eksporter PDF",
"stt.dispoPdfError": "PDF-eksport mislyktes.",
"stt.dispoPdfExporting": "Eksporterer…",
"trk.matchVerifying": "Potensiell match blir verifisert",
"hc.and": "og",
"hc.demoObj0": "en lommebok",
"hc.demoObj1": "en sportsekk",
"hc.demoObj2": "en telefon",
"hc.demoObj3": "et par briller",
"hc.demoObj4": "et sett med nøkler",
"hc.demoObj5": "et skjerf",
"hc.demoObj6": "en bærbar datamaskin",
"hc.demoObj7": "en vannflaske",
"hc.demoWhen0": "for 2 timer siden",
"hc.demoWhen1": "for 5 timer siden",
"hc.demoWhen2": "i går",
"hc.demoWhen3": "for 3 timer siden",
"hc.demoWhen4": "i dag tidlig",
"hc.demoWhen5": "for 1 dag siden",
"hc.feedDemo": "{obj} ble returnert i {city} {when}.",
"hc.feedReal": "En gjenstand ({cat}) ble returnert i {city}.",
"hc.saveBtn": "Lagre",
"hc.saveLink": "Lagre lenke",
"hc.terms": "Vilkår",
"hc.view": "Se",
"pcat.airline": "Flyselskap",
"pcat.airport": "Flyplass",
"pcat.amusement_park": "Tivoli",
"pcat.bank": "Bank",
"pcat.bar_cafe": "Bar / Café",
"pcat.beauty_salon": "Hår- / skjønnhetssalong",
"pcat.cinema": "Kino",
"pcat.concert_theater": "Konsertsal / Teater",
"pcat.coworking": "Coworking område",
"pcat.gym_fitness": "Treningssenter",
"pcat.hospital_clinic": "Sykehus / Klinikk",
"pcat.library": "Bibliotek",
"pcat.mall": "Kjøpesenter",
"pcat.museum": "Museum",
"pcat.pharmacy": "Apotek",
"pcat.private_company": "Privat selskap",
"pcat.public_transport": "Kollektivtransport",
"pcat.school_university": "Skole / Universitet",
"pcat.sports_center": "Sportssenter",
"pcat.stadium_arena": "Stadion / Arena",
"pcat.supermarket": "Supermarked",
"pcat.taxi_vtc": "Taxi / Bestillingstjeneste",
"pcat.tourism_office": "TURISTKONTORET",
"pcat.train_bus_station": "Tog- / busstasjon",
"pcat.travel_agency": "Reisebyrå",
"an.found": "Funnet",
"an.lost": "Tapt",
"hc.shareReview": "Del anmeldelsen",
"hc.citiesAboveTarget": "{n} byer over deres mål",
"hc.cityAboveTarget": "{n} by over sitt mål",
"hc.j15EarlyReminder": "D-15 tidlig påminnelse",
"hc.j7EarlyReminder": "D-7 tidlig påminnelse",
"hc.annualTotal": "Årlig total",
"hc.billedOnceYear": "Belastes én gang for 12 måneder, fornyes hvert år.",
"hc.monthlyPrice": "Månedlig pris",
"hc.perMonth": "/ måned",
"hc.perYear": "/ år",
"hc.billedEachMonth": "Belastes automatisk hver måned.",
"nav.business": "Bedrift",
"nav.individual": "Individuell",
"hc.circumstancesFound": "Omstendigheter ved funnet",
"hc.circumstancesFoundPh": "F.eks. funnet på bakken nær metroinngangen",
"hc.circumstancesLost": "Omstendigheter ved tapet",
"hc.circumstancesLostPh": "F.eks. glemt på en benk mens jeg ventet på bussen",
"hc.conditionPh": "F.eks. god, riper…",
"hc.firstName": "Fornavn",
"hc.lastName": "Etternavn",
"hc.quantity": "Antall gjenstander",
"fa.approve": "Godkjenn",
"fa.approveConfirm": "Godkjenne denne erklæringen? Dine kontaktopplysninger (navn, e-post, telefon) vil bli utvekslet med finneren.",
"fa.approved": "Erklæring godkjent — kontaktopplysninger utvekslet",
"fa.approvedFinder": "Eieren godkjente din erklæring",
"fa.approvedFinderText": "Kontakt dem for å avtale tilbakelevering.",
"fa.boostSub": "Din annonse forblir på toppen i den valgte perioden.",
"fa.boostTitle": "Øk synligheten til annonsen min (valgfritt)",
"fa.colFinder": "Finnerens erklæring",
"fa.colYours": "Din erklæring",
"fa.compareHint": "Sammenlign finnerens erklæring med din før du bestemmer deg.",
"fa.contribNone": "Ingen bidrag",
"fa.contribPaid": "Bidrag mottatt — takk!",
"fa.contribPending": "Bidrag venter på betaling",
"fa.contribSub": "Støtt Findloop for å hjelpe flere mennesker med å få tilbake eiendelene sine. Du kan velge €0.",
"fa.contribSuccessMsg": "Din erklæring er sendt til eieren.",
"fa.contribSuccessTitle": "Takk for ditt bidrag",
"fa.contribTitle": "Frivillig bidrag",
"fa.days3": "3 dager",
"fa.days30": "30 dager",
"fa.days7": "7 dager",
"fa.declSub": "Beskriv gjenstanden du fant. Eieren vil sammenligne din erklæring med deres.",
"fa.declTitle": "Jeg fant denne gjenstanden",
"fa.expiresOn": "Utløper den",
"fa.fBrand": "Merke",
"fa.fCircumstances": "Omstendigheter",
"fa.fCity": "By",
"fa.fColor": "Farge",
"fa.fCondition": "Tilstand",
"fa.fDate": "Dato",
"fa.fMessage": "Finnerens melding",
"fa.fPlace": "Sted",
"fa.fQuantity": "Mengde",
"fa.finderContact": "Finnerens kontaktopplysninger",
"fa.finishPay": "Fullfør betaling",
"fa.foundDate": "Dato funnet",
"fa.foundPlace": "Sted funnet",
"fa.hours24": "24 timer",
"fa.ht": "ekskl. moms",
"fa.months3": "3 måneder",
"fa.noBoost": "Ingen økning",
"fa.ownerContact": "Eierens kontaktinformasjon",
"fa.payPublish": "Betal og publiser",
"fa.pendingPayText": "Annonsen din vil bli aktivert så snart betalingen er bekreftet.",
"fa.pendingPayTitle": "Betaling pågår",
"fa.planSub": "Annonsen din blir aktivert så snart betalingen er bekreftet.",
"fa.planTitle": "Annonsevarighet",
"fa.pubSuccessMsg": "Annonsen din er aktiv. Du blir varslet så snart en finner kommer frem.",
"fa.pubSuccessTitle": "Annonse publisert",
"fa.publicNote": "Bare beskrivelse, by, land og bilder vises offentlig.",
"fa.redirectStripe": "Omdirigerer til sikker betaling…",
"fa.reject": "Avvis",
"fa.rejectConfirm": "Avvise denne erklæringen? Annonsen din forblir online.",
"fa.rejected": "Erklæring avvist",
"fa.rejectedFinder": "Det var ikke gjenstanden de lette etter",
"fa.rejectedFinderText": "Eieren sier denne gjenstanden ikke tilhører dem. Takk for hjelpen!",
"fa.responsesTitle": "Findererklæringer",
"fa.sent": "Erklæring sendt til eieren.",
"fa.submitDecl": "Send min erklæring",
"fa.submitDeclPay": "Send og bidra {amount}",
"fa.total": "Totalt å betale",
"fa.ttc": "inkl. MVA",
"fa.waitClaimText": "Finneren vurderer forespørselen din. Du vil bli varslet om deres avgjørelse.",
"fa.waitFinderText": "Vi gir deg beskjed så snart en finner sender inn en erklæring.",
"fa.waitFinderTitle": "Annonsen din er aktiv",
"fa.waitOwnerText": "Eieren sammenligner erklæringen din med sin. Du vil bli varslet om deres avgjørelse.",
"fa.waitOwnerTitle": "Venter på eierens avgjørelse",
"st.pending_payment": "Betaling pågår",
"fa.africaFree": "Gratis oppføring i Afrika — Findloop lanseringstilbud, nyt det!",
"fa.africaPublished": "Oppføringen publisert gratis — Afrika lanseringstilbud!",
"fa.approveClaimConfirm": "Godkjenne dette kravet? Eieren vil da kunne låse opp dine kontaktopplysninger.",
"fa.checkInfo": "Sjekk opplysningene dine før du sender: de vil bli sammenlignet med finnerens.",
"fa.claimApprovedShort": "Finneren godkjente forespørselen din",
"fa.claimRejectedShort": "Kravet ble avvist av finneren",
"fa.claimRejectedText": "Finneren mener at denne gjenstanden ikke tilhører deg.",
"fa.claimSub": "Beskriv gjenstanden din og legg til 2 bilder. Finneren vil sammenligne dem med sin oppføring.",
"fa.claimTitle": "Dette er min gjenstand",
"fa.claimUnlockText": "Lås opp finnerens kontaktopplysninger for å avtale retur.",
"fa.claimUnlockedShort": "Kontaktopplysninger låst opp — se sporing",
"fa.claimsTitle": "Eierkrav",
"fa.colOwner": "Eierens erklæring",
"fa.colYourAd": "Din oppføring",
"fa.expired": "Oppføringen er utløpt",
"fa.free": "Gratis",
"fa.lostDate": "Tapt dato",
"fa.lostPlace": "Tapt sted",
"fa.noReceipt": "Ingen kvittering tilgjengelig for denne oppføringen.",
"fa.planSubFree": "Velg varighet: oppføringen din går live umiddelbart, ingen betaling nødvendig.",
"fa.prefillPrevious": "Bruk detaljene fra min forrige oppføring i denne kategorien",
"fa.receipt": "PDF kvittering",
"fa.renewBtn": "Forny",
"fa.renewDiscountBanner": "50% rabatt: forny før oppføringen din utløper!",
"fa.renewDiscountHint": "50% rabatt anvendt fordi du fornyer før utløp.",
"fa.renewEarly": "Forny (−50%)",
"fa.renewTitle": "Forny oppføringen min",
"fa.renewed": "Oppføringen fornyet",
"fa.sendClaim": "Send min forespørsel",
"fa.twoPhotos": "2 bilder av gjenstanden din",
"fa.twoPhotosError": "Legg til 2 bilder av gjenstanden din.",
"fa.twoPhotosHint": "Personlige bilder som beviser at gjenstanden er din (med gjenstanden, faktura, eske…).",
"fa.unlockBtn": "Lås opp kontaktopplysninger",
"fa.unlockFree": "Lås opp gratis — lanseringstilbud",
"fa.waitClaimantText": "Vi gir deg beskjed så snart en eier gjør krav på denne gjenstanden.",
"fa.waitFinderDecision": "Venter på finnerens beslutning",
"fa.waitUnlockText": "Du vil bli varslet så snart kontaktopplysninger blir byttet.",
"fa.waitUnlockTitle": "Venter på at eieren skal låse opp",
"fa.cancel": "Avbryt",
"fa.categoryRequired": "Velg en kategori for det funnet objektet.",
"fa.confirmTitle": "Bekreft din beslutning",
"fa.goBack": "Gå tilbake",
"dr.continue": "Fortsett deklarasjonen min",
"dr.delete": "Slett permanent",
"dr.deleteConfirm": "Vil du permanent slette dette utkastet? Dette kan ikke angres.",
"dr.deleted": "Utkast slettet",
"dr.expiresIn": "Utkast holdes i {h} timer til",
"dr.title": "Du har en ufullført deklarasjon",
"form.step": "Steg",
"form.next": "Fortsett",
"form.back": "Tilbake",
"form.stepDetails": "Din rapport",
"form.stepPublish": "Varighet, støtte og betaling",
"form.stepThanks": "Takk og bidrag",
"fthx.badge": "Rapporten nesten ferdig",
"fthx.title": "Takk, du gjør en forskjell!",
"fthx.text": "Takket være deg, kan noen snart få tilbake noe som betyr noe for dem. Gode gjerninger som dine er akkurat det som holder Findloop i live.",
"fthx.impact1": "1 element rapportert",
"fthx.impact2": "1 sjanse mer for gjenforening",
"fthx.tipTitle": "En liten oppmuntring for Findloop?",
"fthx.tipText": "Ditt bidrag hjelper oss med å holde tjenesten tilgjengelig og gjenforene flere gjenstander med sine eiere.",
"fthx.optional": "100% valgfritt — du kan publisere uten å bidra.",
"fthx.thanksTip": "Tusen takk for din generøsitet!",
"fthx.suggest": "Forslåtte beløp",
"fthx.none": "Ingen gave",
"pay.pendingTitle": "Betaling ikke fullført",
"pay.pendingText": "Dine detaljer er lagret. Fortsett betalingen der du slapp.",
"pay.resume": "Gjenoppta betaling",
"pay.expiredTitle": "Betalingsøkt utløpt",
"pay.expiredText": "Av sikkerhetsgrunner har betalingsøkten utløpt. Dine detaljer er lagret: start betalingen på nytt med ett klikk.",
"pay.relaunch": "Start betaling på nytt",
"sub.received": "Sendt!",
"sub.publishing": "Vi avslutter...",
"sub.toPayment": "Omdirigerer til sikker betaling...",
"fa.claimSubV2": "Beskriv det tapte objektet ditt. Personen som fant det vil sammenligne erklæringen din med oppføringen deres.",
"fa.photosOptional": "Bilder av objektet ditt (valgfritt)",
"fa.compareOwnerHint": "Sammenlign denne informasjonen med objektet du fant, og si deretter om det er det samme objektet.",
"fa.itsThisItem": "Ja, dette er objektet",
"fa.notThisItem": "Nei, dette er ikke objektet",
"fa.confirmIsItem": "Bekreft at dette er objektet? Dine kontaktopplysninger og eierens vil bli vist i deres respektive kontoer.",
"fa.confirmNotItem": "Bekreft at dette ikke er objektet? Rapporten din vil bli avsluttet.",
"fa.youConfirmed": "Du bekreftet at dette er eierens objekt",
"fa.youDeclined": "Du indikerte at dette ikke var objektet",
"fa.youDeclinedText": "Takk for hjelpen! Eieren har blitt informert.",
"fa.waitFinderDecisionOwner": "Venter på finnerens beslutning",
"fa.finderConfirmed": "Bekreftet",
"fa.notYourItem": "Dette var ikke ditt objekt",
"fa.reportedOn": "Rapportert den",
"fa.ownerWaitHint": "En finner sjekker for tiden informasjonen, vær så snill å vente.",
"fa.claimSentFinder": "Krav sendt til personen som fant gjenstanden.",
"fa.compareClaimHint": "Sammenlign eierens erklæring med oppføringen din før du bestemmer.",
"fa.closeFollowup": "Lukk denne oppfølgingen",
"fa.closeFollowupConfirm": "Vil du lukke denne oppfølgingen? Begge parters e-poster og telefonnumre vil bli permanent slettet når eieren også har lukket sin oppføring.",
"fa.safetyTitle": "Sikkerhetstips før overlevering",
"fa.safety1": "Be eieren om en detaljert beskrivelse av skjulte egenskaper ved gjenstanden: en spesifikk ripe, innholdet i en veske, tapetet, serienummeret…",
"fa.safety2": "Hvis mulig, be om visuell bekreftelse (et bilde av gjenstanden) eller kjøpebevis.",
"fa.safety3": "Overlever gjenstanden på et offentlig sted eller hos en Findloop-partner, og sjekk eierens ID.",
"fa.safetyOk": "Få det, fortsett",
"fa.ownerClosedNote": "Eieren har lukket sin oppføring.",
"fa.finderClosedNote": "Finneren har lukket sin oppfølging.",
"fa.followupClosed": "Oppfølging avsluttet",
"fa.followupClosedText": "Du har avsluttet denne oppfølgingen. Takk for hjelpen!",
"fa.photoReviewTitle": "En finder sendte et bilde. Ser det ut som din gjenstand?",
"fa.photoLooksLike": "Ja, det ser ut som min gjenstand",
"fa.photoNotMine": "Nei, dette er ikke min gjenstand",
"fa.photoNotMineConfirm": "Oppfølgingen vil bli lukket på begge sider, og oppføringen din vil forbli åpen for en ny finder.",
"fa.photoLooksLikeDone": "Takk! Finderen vil nå sammenligne erklæringen din.",
"fa.photoNotMineDone": "Rapporten ble avvist. Oppføringen din forblir åpen.",
"fa.ownerPhotoHint": "Kun finderen sitt bilde vises for deg. Si ifra om det ligner på din gjenstand.",
"fa.ownerReviewingPhoto": "Eieren vurderer bildet ditt",
"fa.ownerReviewingPhotoText": "Du vil bli varslet så snart de svarer. Du vil da kunne sammenligne erklæringen deres.",
"fa.ownerRejectedPhoto": "Dette er ikke eierens gjenstand",
"fa.ownerRejectedPhotoText": "Eieren sier at bildet ditt ikke samsvarer med deres gjenstand. Oppfølgingen er lukket. Takk for hjelpen!",
"fa.contribute": "Bidra",
"fa.phoneMissing": "Ikke oppgitt",
"fa.ownerSafety1": "Foretrekk en overlevering på et offentlig sted eller hos en Findloop-partner. Hvis avstanden er lang, foreslå å sende det med post i stedet.",
"fa.ownerSafety2": "Ved overleveringen, sjekk finnerens ID.",
"pub.changePhoto": "Endre bilde",
"ph.secured": "Bildet er sikret",
"ph.securing": "Sikrer bildet...",
"fa.ownerSafety3": "Hvis finnerens bilde har Findloop-vannmerket, ikke aksepter møtet. Bildet må være et originalbilde tatt av finneren, uten vannmerke."
},
"da": {
"a.back": "Tilbage",
"a.category": "Kategori",
"a.categoryPlaceholder": "Vælg en kategori",
"a.city": "By",
"a.confirmPassword": "Bekræft adgangskode",
"a.country": "Land",
"a.createAccount": "Opret en konto",
"a.createBtn": "Opret min konto",
"a.creating": "Opretter…",
"a.email": "E-mail",
"a.emailPro": "Erhvervse-mail",
"a.forgot": "Glemt?",
"a.forgotSent": "Hvis en konto eksisterer, er et link til nulstilling netop blevet sendt.",
"a.forgotSub": "Få et reset-link via e-mail.",
"a.forgotTitle": "Glemt adgangskode",
"a.googleContinue": "Fortsæt med Google",
"a.googleSignup": "Tilmeld dig med Google",
"a.haveAccount": "Allerede partner?",
"a.legalHint": "Nødvendig for fransk e-fakturering (Factur-X) af franske etableringer.",
"a.legalRequiredFR": "SIRET og intra-EU momsnummer er obligatoriske for Frankrig.",
"a.loggingIn": "Logger ind…",
"a.login": "Log ind",
"a.loginSub": "Adgang til dit administrationsområde.",
"a.loginTitle": "Partnerlogin",
"a.min6": "Mindst 6 tegn",
"a.newPassword": "Ny adgangskode",
"a.noAccount": "Ikke partner endnu?",
"a.or": "ELLER",
"a.org": "Etableringsnavn",
"a.password": "Adgangskode",
"a.passwordMismatch": "Adgangskoderne matcher ikke.",
"a.referral": "Henvisningskode (valgfrit)",
"a.registerSub": "Opret dit område på 1 minut — gratis at starte.",
"a.registerTitle": "Bliv partner",
"a.rememberMe": "Husk mig",
"a.reset": "Nulstil",
"a.resetSub": "Vælg en ny adgangskode til din konto.",
"a.resetTitle": "Ny adgangskode",
"a.sendLink": "Send linket",
"a.sending": "Sender…",
"a.signin": "Log ind",
"a.siret": "SIRET",
"a.vat": "Intra-EU momsnummer",
"ac.africa": "Afrika",
"ac.boostActive": "Fremhæv aktiv —",
"ac.boostSub": "Vis i toppen af partnerkataloget med et “Fremhævet” badge.",
"ac.boostTitle": "Fremhæv din opføring i kataloget",
"ac.categoryHint": "For at klassificere din etablering i findloop-kataloget.",
"ac.choose": "Vælg",
"ac.cityHint": "For præcis placering på det offentlige kort.",
"ac.cityLabel": "Etableringsby",
"ac.cityPh": "Paris",
"ac.contact": "Kontaktoplysninger",
"ac.converted": "Konverteret",
"ac.copyDeclLink": "Kopier erklæringslinket",
"ac.copyLink": "Kopier linket",
"ac.currentPlan": "Nuværende plan",
"ac.emailDesc": "Vælg de e-mails, du vil modtage. Notifikationer i dit arbejdsområde forbliver altid aktive.",
"ac.emailMatch": "Matcher",
"ac.emailMatchDesc": "En e-mail når en vare matcher en erklæring",
"ac.emailNewDecl": "Nye tabserklæringer",
"ac.emailNewDeclDesc": "En e-mail så snart en kunde rapporterer et tab hos dig",
"ac.emailShip": "Forsendelsesanmodninger",
"ac.emailShipDesc": "En e-mail når en kunde anmoder om forsendelse af en vare",
"ac.emailTitle": "E-mail præferencer",
"ac.expireSoon": "Din fremhævelse udløber snart —",
"ac.exportCsv": "Eksportér (CSV)",
"ac.exportHint": "Eksportér dine validerede eksterne betalinger til dit regnskab.",
"ac.free": "Gratis",
"ac.freeMonths": "Gratis måneder",
"ac.hours": "timer",
"ac.howItWorks": "Hvordan fungerer det?",
"ac.invited": "Inviteret",
"ac.legalFR": "Påkrævet for elektronisk fakturering (Factur-X) gældende fra september 2026.",
"ac.legalMissing": "⚠️ SIRET og intra-EU MOMS mangler — udfyld dem for at forblive i overensstemmelse med elektronisk fakturering.",
"ac.legalOther": "Anbefalet til dine fakturaer.",
"ac.legalPartnerQr": "QR-kode",
"ac.legalTitle": "Juridiske identifikatorer (fakturering)",
"ac.logoTitle": "Etableringslogo",
"ac.modeCurrent": "Nuværende tilstand:",
"ac.modeExternal": "Ekstern (manuel validering)",
"ac.modeInternal": "Intern Findloop (automatisk)",
"ac.noSubReceipt": "Ingen betalt abonnementsbetaling endnu.",
"ac.none": "Ingen",
"ac.onYourListing": "på din liste",
"ac.pay1": "Indtast dine betalingslinks herunder for at omdirigere dine kunder til dit eget indtægtsystem.",
"ac.pay2": "Validering bliver manuel: du bekræfter betalingsmodtagelse fra fanen “Erklæringer”.",
"ac.pay3": "Linket “Forsendelsesgebyr” er en sammenlagt betaling (inddrivelse + forsendelse).",
"ac.pay4": "Lad felterne stå tomme for at bruge Findos interne betaling (Stripe) med automatisk validering.",
"ac.paySub": "Indsaml gebyrer via dit eget betalingssystem.",
"ac.payTitle": "Eksterne betalinger",
"ac.permissive": "Klausulerende",
"ac.phone": "Telefon",
"ac.posterA4": "A4 plakat (PDF)",
"ac.qMessage": "Besked (valgfri)",
"ac.qName": "Navn",
"ac.qOrg": "Organisation",
"ac.qSites": "Antal etablissementer (skønnet)",
"ac.qrHint": "Dine kunder scanner denne kode for at rapportere et tabt objekt.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Din partner QR-kode",
"ac.quoteDesc": "Lufthavne, jernbanenet, internationale kæder · ",
"ac.quoteEurope": "Europa / Verden",
"ac.quoteSent": "Tilbudsanmodning sendt. Vores team vil kontakte dig snart.",
"ac.quoteTitle": "Anmod om et tilbud — Virksomhed",
"ac.recoveryLink": "“Inddrivelsesgebyr” link",
"ac.refSub": "Hver henviste partner, der abonnerer, giver dig 1 gratis måned.",
"ac.refTitle": "Henvis, tjen en gratis måned",
"ac.reminderDelay": "Valideringspåmindelse forsinkelse",
"ac.reminderHint": "Du vil modtage en e-mailpåmindelse, hvis en ekstern betaling forbliver uvalideret ud over denne forsinkelse (standard: 48 timer).",
"ac.renewDesc1": "Det har allerede givet dig",
"ac.renewDesc2": "Forny for at forblive i toppen af kataloget og ikke miste denne synlighed.",
"ac.renewNow": "Forny nu",
"ac.requestQuote": "Anmod om et tilbud",
"ac.saveLegal": "Gem identifikatorerne",
"ac.saveLinks": "Gem linkene",
"ac.sendRequest": "Send min anmodning",
"ac.sending": "Sender…",
"ac.shippingLink": "“Forsendelsesgebyr” link (sammenlagt)",
"ac.shippingLinkHint": "Dette link dækker både inddrivelse og forsendelse.",
"ac.strict": "Streng",
"ac.subReceipt": "Abonnementskvittering (PDF)",
"ac.subReceiptsSub": "Download PDF-kvitteringen for hver abonnementsbetaling.",
"ac.subReceiptsTitle": "Abonnementskvitteringer",
"ac.tCategory": "Kategori gemt",
"ac.tCity": "By gemt — kort opdateret",
"ac.tCityNeeded": "Indtast en by",
"ac.tCopied": "Kopieret!",
"ac.tCover": "Coverbillede opdateret",
"ac.tEmailPrefs": "E-mailpræferencer opdateret",
"ac.tErr": "Fejl",
"ac.tExportImpossible": "Eksporten mislykkedes",
"ac.tLegal": "Juridiske identificerede gemt",
"ac.tLegalNeeded": "SIRET og moms kræves for Frankrig",
"ac.tLogo": "Logo opdateret",
"ac.tLogoRemoved": "Logo fjernet",
"ac.tPayLinks": "Betalingslinks gemt",
"ac.tPhone": "Telefon gemt",
"ac.tSensitivity": "Følsomhed gemt",
"ac.tVatInvalid": "Ugyldigt momsnummer",
"ac.tVatValid": "Gyldig moms",
"ac.tabBoost": "Synlighed",
"ac.tabPayments": "Betalinger",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Plakat",
"ac.tabReferral": "Henvisning",
"ac.tabSub": "Abonnement",
"ac.thisWeek": "Denne uge",
"ac.thisWeekOf": " ({n} denne uge)",
"ac.thresholdDesc": "Tillidsgrænse, fra hvilken AI automatisk validerer et foto match og underretter kunden. Højere = færre automatisk matches, men mere pålideligt.",
"ac.thresholdTitle": "AI visuel match følsomhed",
"ac.trend": "Trend",
"ac.upload": "Upload",
"ac.vatValidFmt": "Gyldig moms{name} ({via})",
"ac.vatVerified": "Intra-EU moms verificeret",
"ac.verifyVat": "Verificer moms (VIES)",
"ac.verifying": "Verificerer…",
"ac.views": "visninger",
"ac.viewsTotal": "Visninger opnået (total)",
"ac.winbackBtn": "Fortsæt med -20%",
"ac.winbackDesc1": "Det har givet dig",
"ac.winbackDesc2": "Specialtilbud: -20% anvendt automatisk, hvis du fornyer inden for 24 timer.",
"ac.winbackTitle": "Dit højdepunkt er lige udløbet — fortsæt med -20%!",
"ad.boost": "Boost",
"ad.close": "Luk",
"ad.closeConfirm": "Lukke denne annonce?",
"ad.closed": "Annonce lukket",
"ad.edit": "Rediger",
"ad.editTitle": "Rediger annonce",
"ad.saved": "Annonce opdateret",
"an.allCountries": "Alle lande",
"an.badge": "Mistede genstande",
"an.boostLater": "Senere",
"an.boostNow": "Boost nu",
"an.boostPrompt": "Boost din annonce for at placere den øverst og blive fundet hurtigere.",
"an.boosted": "Boostet",
"an.contact": "Jeg fandt denne genstand",
"an.contactTitle": "Rapporter at du fandt denne genstand",
"an.copyFailed": "Kunne ikke kopiere linket",
"an.copyLink": "Kopier link",
"an.country": "Land",
"an.date": "Dato for tab",
"an.finderEmail": "Din email",
"an.finderName": "Dit navn",
"an.finderPhone": "Dit telefonnummer",
"an.geoBanner": "Du ser annoncer i",
"an.geoBannerWorld": "Du ser annoncer verden over",
"an.geoChange": "ændre land",
"an.goAccount": "Gå til min konto",
"an.linkCopied": "Link kopieret!",
"an.loginRequired": "Log ind for at rapportere denne genstand og følge tilbageleveringen.",
"an.loginToBoost": "Log ind for at booste denne annonce",
"an.lostAt": "Tabt ved",
"an.message": "Besked (valgfrit)",
"an.none": "Ingen annoncer endnu.",
"an.photo": "Foto (valgfrit)",
"an.post": "Opret en annonce",
"an.postSubtitle": "Beskriv din tabte genstand — fællesskabet og vores partnere hjælper dig med at finde den.",
"an.postTitle": "Rapportér en tabt genstand",
"an.publish": "Publicer annonce",
"an.published": "Annonce publiceret!",
"an.publishing": "Publicerer…",
"an.remaining": "tilbage",
"an.requestInProgress": "Anmodning i gang",
"an.resolved": "Genstand allerede genfundet",
"an.reward": "Belønning",
"an.searchPh": "Søg en annonce…",
"an.send": "Send",
"an.sent": "Besked sendt til ejeren!",
"an.shareConsent": "Jeg accepterer, at mine kontaktoplysninger (navn, email, telefon) må deles med ejer af genstanden.",
"an.shareConsentError": "Vær venlig at sætte flueben i boksen for at dele dine kontaktoplysninger.",
"an.sortRecent": "Seneste",
"an.sortRelevance": "Relevans",
"an.subtitle": "Gennemse genstande rapporteret tabt af fællesskabet. Har du set en af dem?",
"an.title": "Annoncer for tabte genstande",
"anf.badge": "Fundne genstande",
"anf.claim": "Dette er mit",
"anf.claimSent": "Besked sendt til finder!",
"anf.claimTitle": "Rapporter at dette er din genstand",
"anf.consent": "Jeg accepterer, at ejeren må se mine kontaktoplysninger for at få deres genstand tilbage.",
"anf.foundAt": "Fundet ved",
"anf.foundDate": "Dato for fund",
"anf.loginCta": "Log ind / opret en konto",
"anf.loginDesc": "En finder-konto er påkrævet for at publicere en annonce og optjene Finder Hero-point.",
"anf.loginRequired": "Log ind for at poste en fundet genstand",
"anf.photo": "Genstand foto",
"anf.pointsEarned": "Tak! Du har lige optjent Finder Hero-point.",
"anf.pointsPending": "Dine point vil blive krediteret inden for 24 timer, efter verifikation.",
"anf.post": "Opret en fundet genstand",
"anf.postSubtitle": "Beskriv den genstand, du fandt — hjælp dens ejer med at få den tilbage.",
"anf.postTitle": "Rapporter en fundet genstand",
"anf.publishFound": "Publicer fundet annonce",
"anf.published": "Annonce for fundne genstande publiceret",
"anf.publishedAs": "Publiceret som",
"anf.shareConsent": "Jeg accepterer, at mine kontaktoplysninger (navn, email, telefon) må deles med den, der fandt genstanden.",
"anf.subtitle": "Gennemse genstande fundet og rapporteret af fællesskabet. Genkender du din?",
"anf.title": "Annoncer for fundne genstande",
"bo.active": "Boost aktiv",
"bo.africaPrice": "Afrika-zone præferencepris anvendt",
"bo.pay": "Betal & boost",
"bo.remaining": "Tid tilbage",
"bo.renew": "Forny boost",
"bo.since": "siden boost",
"bo.subtitle": "Sæt din annonce øverst på listen med et synligt mærke.",
"bo.title": "Boost annonce",
"c.all": "Alle",
"c.cancel": "Annuller",
"c.close": "Luk",
"c.confirm": "Bekræft",
"c.confirmed": "Bekræftet",
"c.download": "Download",
"c.loading": "Indlæser…",
"c.reset": "Nulstil",
"c.reviews": "anmeldelser",
"c.save": "Gem",
"c.transfer": "Overfør",
"cat.Animal": "Kæledyr / Kæledyrsudstyr",
"cat.AppareilPhoto": "Kamera",
"cat.Argent": "Penge / Kontanter",
"cat.Autres": "Andet",
"cat.Bijoux": "Smykker",
"cat.CarteBancaire": "Bankkort",
"cat.CarteIdentite": "ID-kort / Pas",
"cat.Casquette": "Kasket / Hat",
"cat.Ceinture": "Bælte",
"cat.Chargeur": "Oplader / Kabel",
"cat.Chaussures": "Sko",
"cat.CleVoiture": "Bilnøgle",
"cat.Cles": "Nøgler",
"cat.Console": "Spilkonsol",
"cat.Documents": "Dokumenter / Papirer",
"cat.Echarpe": "Tørklæde",
"cat.Ecouteurs": "Øretelefoner / Hovedtelefoner",
"cat.Electronique": "Elektronik (andre)",
"cat.Enceinte": "Højttaler",
"cat.Gants": "Handsker",
"cat.Gourde": "Vandflaske / Termokande",
"cat.Instrument": "Musikinstrument",
"cat.Jouet": "Legetøj / Krammedyr",
"cat.Jumelles": "Kikkert",
"cat.Lampe": "Lampe / Lommelygte",
"cat.Liseuse": "E-læser",
"cat.Livre": "Bog / Notatbog",
"cat.Lunettes": "Briller",
"cat.Manteau": "Frakke / Jakke",
"cat.Maquillage": "Makeuptaske",
"cat.Medical": "Medicinsk udstyr",
"cat.Medicaments": "Medicin",
"cat.Montre": "Ur / Smartur",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Paraply",
"cat.Portefeuille": "Pung / Tegne",
"cat.Poussette": "Barnevogn / Babyudstyr",
"cat.Sac": "Taske / Håndtaske",
"cat.SacADos": "Rygsæk",
"cat.Souris": "Mus / Tastatur",
"cat.Sport": "Sportsudstyr",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefon / Smartphone",
"cat.Trottinette": "Løbehjul",
"cat.Trousse": "Punge / Etui",
"cat.USB": "USB stik / Harddisk",
"cat.Valise": "Kuffert / Bagage",
"cat.Velo": "Cykel",
"cat.Vetements": "Tøj",
"cat.placeholder": "Vælg en kategori",
"cd.d": "d",
"cd.expired": "Udløbet",
"cd.h": "t",
"cd.m": "min",
"ck.accept": "Accepter",
"ck.acceptAll": "Accepter alle",
"ck.customize": "Tilpas",
"ck.learn": "Lær mere",
"ck.manage": "Administrer cookies",
"ck.measurement": "Publikumsmåling",
"ck.measurementDesc": "Anonyme statistikker for at forbedre servicen.",
"ck.msg": "Vi bruger cookies for at holde siden kørende og måle publikum.",
"ck.necessary": "Nødvendig",
"ck.necessaryDesc": "Vigtig for at siden fungerer. Altid tændt.",
"ck.refuse": "Afvis",
"ck.save": "Gem mine valg",
"ck.saved": "Præferencer gemt",
"ck.title": "Dine cookie-præferencer",
"cm.found": "FUNDEN",
"cm.lost": "TABT",
"cmp.adv": "Avanceret",
"cmp.ai": "AI matchning",
"cmp.autobill": "Automatisk fakturering",
"cmp.basic": "Basis",
"cmp.community": "Fællesskab",
"cmp.consol": "Konsolideret fakturering",
"cmp.custom": "Brugerdefineret",
"cmp.dedicated": "Dedikeret",
"cmp.deploy": "Dedikeret implementering & SLA",
"cmp.estIncl": "Inkluderede enheder",
"cmp.estSec": "Ekstra enhed",
"cmp.items": "Elementer / måned",
"cmp.main": "1 hoved",
"cmp.max20": "20 maks",
"cmp.members": "Medlemsinvitationer",
"cmp.onQuote": "Skræddersyet tilbud",
"cmp.priority": "Prioritet",
"cmp.starterEst": "1 inkluderet + ubegrænsede ekstra",
"cmp.stats": "Statistikker",
"cmp.statsAdv": "Avanceret",
"cmp.statsBasic": "Basis",
"cmp.support": "Support",
"cmp.unlimited": "Ubegribset",
"cmp.upTo3": "Op til 3",
"consent.required": "Du skal acceptere at dele dine kontaktoplysninger for at fortsætte.",
"consent.share": "Jeg accepterer, at finder af mit objekt kan se mine kontaktoplysninger (navn, e-mail, telefon) for at kontakte mig angående tilbagesendelse.",
"cover.add": "Tilføj",
"cover.change": "Ændre",
"cover.helper": "Vist som et banner på din rapportside og i kataloget.",
"cover.none": "Ingen coverfoto",
"cover.remove": "Fjern",
"cover.title": "Coverfoto",
"crop.desc": "Justér indramningen til bannerforhold (3:1). Træk og zoom.",
"crop.saving": "Gemmer…",
"crop.title": "Beskær coverbilledet",
"cta.button": "Opret min partnerkonto",
"cta.subtitle": "Deltag i de establishmenter, der returnerer varer hurtigere med findloop.",
"cta.title": "Klar til at reducere mistede genstande?",
"db.account.s": "Administrer dit establishment, abonnement og QR-kode.",
"db.account.t": "Min konto",
"db.declarations.s": "Kunder, der har rapporteret en mistet genstand via din QR-kode.",
"db.declarations.t": "Mistede genstande",
"db.deposit.s": "Tilføj et billede, en kategori og en beskrivelse.",
"db.deposit.t": "Registrer en fundet genstand",
"db.registry.s": "Alle fundne genstande registreret på dit establishment.",
"db.registry.t": "Genstandsregister",
"db.reviews.s": "Svar offentligt på dine kunders anmeldelser.",
"db.reviews.t": "Kundeanmeldelser",
"db.shipments.s": "Generer labels og spore pakker til forsendelse.",
"db.shipments.t": "Forsendelser",
"db.stats.s": "Dine nøglepræstationsindikatorer.",
"db.stats.t": "Statistik",
"db.team.s": "Inviter dine kolleger til at administrere genstande.",
"db.team.t": "Team",
"dc.partnerDesc": "Har du mistet din genstand på et partnersted (hotel, station, hal…)? Vælg det for en direkte returnering.",
"dc.partnerList": "Vælg fra listen",
"dc.partnerMap": "Vælg på kortet",
"dc.partnerTitle": "Deklaration hos en partner",
"dc.publicCta": "Post en offentlig annonce",
"dc.publicDesc": "Din annonce vil være synlig for hele findloop-fællesskabet. Ideelt hvis du ikke ved, hvor du mistede genstanden.",
"dc.publicTitle": "Offentlig deklaration",
"dc.subtitle": "Vælg, hvordan du vil rapportere din mistede genstand.",
"dc.title": "Hvad vil du gerne gøre?",
"dec.addrPending": "Adresse afventer fra kunden",
"dec.analyzing": "Analyserer…",
"dec.badge": "Misterapport",
"dec.category": "Genstandskategori",
"dec.clientDescription": "Kundens beskrivelse",
"dec.clientPhoto": "Billede leveret af kunden",
"dec.clientPhotoShort": "Kundens billede",
"dec.comparePhotos": "Sammenlign billeder",
"dec.contactTitle": "Dine kontaktoplysninger",
"dec.date": "Dato for tab",
"dec.declaredItemPhoto": "Billede af den deklarerede genstand",
"dec.descPh": "Beskriv genstanden: mærke, farve, særpræg…",
"dec.description": "Beskrivelse",
"dec.email": "Email",
"dec.emptyDesc": "Del din QR-kode for at modtage deklarationer.",
"dec.emptyTitle": "Ingen deklarationer",
"dec.enlarge": "Forstør",
"dec.extBanner": "{n} ekstern(e) betaling(er) til validering — bekræft modtagelse nedenfor for at låse op for overdragelsen eller forsendelsen.",
"dec.foundItemAlt": "Fundet genstand",
"dec.foundItemRegistry": "Fundet genstand (register)",
"dec.home": "Tilbage til start",
"dec.labelClient": "Kunde",
"dec.labelRegistry": "Register",
"dec.matchFound": "Et match er allerede blevet identificeret!",
"dec.name": "Fulde navn",
"dec.noMatchYet": "Ingen match endnu.",
"dec.noPhoto": "Intet billede",
"dec.notfound": "Partner ikke fundet.",
"dec.pRecup": "genopretning",
"dec.pRecupP": "(genopretning)",
"dec.pRecupShip": "(genopretning + forsendelse)",
"dec.payConfirmed": "Betaling {x} bekræftet",
"dec.payPending": "Ekstern betaling {x} afventende",
"dec.phone": "Telefon",
"dec.pickup": "Personlig afhentning",
"dec.place": "Sted for tab",
"dec.placePh": "f.eks. ved baren, værelse 204…",
"dec.recoverBtn": "Gendan min genstand",
"dec.reject": "Afvis",
"dec.rerun": "Kør analysen igen",
"dec.similarity": "Lighed {n}%",
"dec.submit": "Indsend min rapport",
"dec.submitting": "Sender…",
"dec.successText": "Vi søger efter din genstand blandt dem, der opbevares på",
"dec.successTitle": "Rapport indsendt!",
"dec.suggestedMatches": "Foreslåede match",
"dec.toColon": " til:",
"dec.toShip": "At sende",
"dec.toastExtPay": "Betaling bekræftet — kunden vil blive underrettet.",
"dec.toastMatch": "Match bekræftet",
"dec.toastReject": "Forslag afvist",
"dec.toastRerun": "Analyse genstartet",
"dec.toastVisualN": "{n} visuel match",
"dec.toastVisualNone": "Ingen visuel match",
"dec.trackBtn": "Spor min rapport",
"dec.viewBeforeAfter": "Før/efter visning (overlay)",
"dec.viewSideBySide": "Side om side visning",
"dec.visualCompare": "AI visuel sammenligning",
"dec.visualIdle": "Kør sammenligningen, så AI'en visuelt matcher kundens foto med fundne genstande.",
"dec.visualRunning": "AI'en sammenligner kundens foto med genstande i dit register…",
"dec.zoomPhoto": "Forstør fotoet",
"dep.addAnyway": "Tilføj alligevel",
"dep.addError": "Fejl under tilføjelse",
"dep.addItem": "Tilføj genstand",
"dep.added": "Genstand tilføjet til registret!",
"dep.adding": "Tilføjer…",
"dep.aiError": "AI-analyse er ikke tilgængelig lige nu.",
"dep.aiFilled": "Formular forudfyldt af AI ✨",
"dep.aiUnavailable": "AI ikke tilgængelig — udfyld formularen manuelt.",
"dep.analyzing": "Analysere…",
"dep.analyzingPhoto": "Analyserer foto…",
"dep.brand": "Mærke",
"dep.brandPlaceholder": "f.eks. Apple",
"dep.category": "Kategori",
"dep.checkingDup": "Tjekker for dubletter…",
"dep.color": "Farve",
"dep.colorPlaceholder": "f.eks. sort",
"dep.condition": "Tilstand",
"dep.conditionPlaceholder": "f.eks. god stand",
"dep.depositorNote": "Notat fra indskyder",
"dep.depositorNoteHint": "Operationelle detaljer skrevet i hånden. AI'en overskriver aldrig dette notat.",
"dep.depositorNotePlaceholder": "f.eks. indholdet af en taske, mærket som rapporteret, oplysninger givet af personen…",
"dep.descPlaceholder": "f.eks. sort iPhone 15 med et klart cover, fundet ved baren…",
"dep.description": "Beskrivelse",
"dep.dupHint": "Sørg for, at du ikke tilføjer en duplikat. Du kan fortsætte, hvis genstanden er ægte forskellig.",
"dep.dupTitle": "Lignende genstand(e) allerede registreret",
"dep.dupWarn": "Lignende genstand fundet — gennemgå, og klik derefter igen for at bekræfte.",
"dep.estHint": "Genstanden vil blive tilføjet til denne institutions register.",
"dep.establishment": "Institution",
"dep.fee": "Recovery gebyr (€) — valgfrit",
"dep.feePlaceholder": "Lad det stå tomt for standardprisen i kategorien",
"dep.fillAI": "Udfyld med AI",
"dep.optional": "(valgfri)",
"dep.photo": "Varebillede",
"dep.principal": "primær",
"dep.reqError": "Kategori og beskrivelse er påkrævet.",
"dep.savedItem": "Registreret vare",
"dep.similarity": "Lighed",
"dep.storage": "Fysisk placering",
"dep.storageHint": "Hvor varen er fysisk opbevaret. En QR-kode vil blive genereret for at finde den.",
"dep.storagePlaceholder": "f.eks. Hylde A3, Skab 12, Receptionens sikre",
"dl.aClient": "en kunde",
"dl.alertsBlocked": "Browserunderretninger blokeret",
"dl.alertsBlockedHint": "For at genaktivere dem: klik på 🔒 (eller ⓘ) ikonet til venstre for webadressen, tillad derefter underretninger og genindlæs siden.",
"dl.amountDue": "Beløb skyldig: {amount} {currency}.",
"dl.enableAlerts": "Aktivér underretninger",
"dl.extPending": "Betalinger til validere",
"dl.freemiumNear": "Du nærmer dig Freemium-grænsen ({used}/{max} varer i denne måned). Opgrader til Starter for ubegrænsede varer.",
"dl.freemiumReached": "Freemium-grænsen nået ({used}/{max} varer i denne måned). Opgrader til Starter for at registrere ubegrænsede varer.",
"dl.invoiceOverdue": "Faktura {num} ubetalt — adgang begrænset.",
"dl.matchNotifTitle": "Findloop — Ny AI-match 🔔",
"dl.matchToast": "Ny AI-match — {name}",
"dl.matchToastDesc": "En vare matcher en erklæring.",
"dl.notifEmpty": "Ingen underretninger endnu.",
"dl.notifEnabled": "Browserunderretninger aktiveret",
"dl.notifTitle": "Underretninger",
"dl.payInvoice": "Betal min faktura →",
"dl.rewardsPending": "Kuponer til præsentation",
"dl.upgradeStarter": "Opgrader til Starter →",
"est.all": "Alle etableringer ({n})",
"est.label": "Etablering",
"est.primary": "primær",
"est.secondary": "sekundær",
"est2.add": "Tilføj en etablering",
"est2.addressLabel": "Adresse",
"est2.addressPh": "12 République Street",
"est2.autoInvoice": "En detaljeret faktura genereres automatisk den 1. i hver måned.",
"est2.baseSub": "Base abonnement",
"est2.billing": "Fakturering",
"est2.boostActivated": "Boost aktiveret for {name}",
"est2.boostBillingNote": "Faktureres til den aktuelle sats og grupperet på din samlede månedlige faktura.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Forbedr denne etablerings synlighed i kataloget og på kortet.",
"est2.boostDuration": "{h}t af boosted synlighed",
"est2.boostExtend": "Forlæng",
"est2.boostTitle": "Boost {name}",
"est2.boosted": "Boostet",
"est2.chartDesc": "Andel af returnerede varer ud af det samlede registrerede, site for site.",
"est2.chartTitle": "Retour rate efter etablering",
"est2.chartTooltip": "Returner",
"est2.cityLabel": "By",
"est2.cityPh": "Lyon",
"est2.contactHint": "Disse detaljer vises til kunden for denne etablering (fald tilbage til kontoen hvis tom).",
"est2.countryLabel": "Land",
"est2.coverLabel": "Coverbillede",
"est2.create": "Opret",
"est2.created": "Etablering oprettet",
"est2.delete": "Slet",
"est2.deleteDesc": "Denne handling er permanent. Du kan kun slette en etablering, hvis den ikke indeholder nogen varer.",
"est2.deleteTitle": "Slet “{name}”?",
"est2.deleted": "Etablering slettet",
"est2.dialogDesc": "Indtast navnet og adressen på dette sted.",
"est2.edit": "Rediger",
"est2.editEst": "Rediger etablering",
"est2.emailLabel": "Kontakt-e-mail",
"est2.emailPh": "kontakt@site.com",
"est2.estSuffix": " etablering(er)",
"est2.extraNoteBase": "{n} ekstra etablering(er) faktureret",
"est2.extraPrice": " til {price} €/måned.",
"est2.extraQuote": " på tilbud.",
"est2.imgChange": "Vælg et billede",
"est2.imgDone": "Færdig",
"est2.imgRemove": "Fjern",
"est2.imgRemoved": "Billede fjernet",
"est2.imgSaved": "Billede gemt",
"est2.imgUploading": "Uploader…",
"est2.includedPlan": "Inkluderet i din plan: {n}.",
"est2.kDeclarations": "Erklæringer",
"est2.kInStorage": "På lager",
"est2.kItemsTotal": "Vare(r) (total)",
"est2.kRestituted": "Returneret",
"est2.limitReached": "Grænse nået",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Erkl.",
"est2.mItems": "Vare(r)",
"est2.mRestituted": "Returneret",
"est2.mStorage": "På lager",
"est2.monthlyTotal": "Månedligt total",
"est2.nameLabel": "Navn *",
"est2.namePh": "f.eks. Belmont Hotel — Lyon Annex",
"est2.newEst": "Ny etablering",
"est2.onQuote": "På tilbud",
"est2.phoneLabel": "Telefon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plan",
"est2.planLimited": "Din “{tier}” plan er begrænset til {max} etablering(er).",
"est2.primary": "Primær",
"est2.qr": "QR-kode",
"est2.qrDesc": "Vis denne QR-kode på denne etablering. Kunder, der rapporterer et tab, vil blive linket til dette sted.",
"est2.qrTitle": "QR-kode — {name}",
"est2.saving": "Gemmer…",
"est2.seeInvoices": "Se mine månedlige fakturaer",
"est2.seePlans": "Se planerne",
"est2.subtitle": "Administrer alle dine steder under én konto — samlet oversigt, varer, QR-kode og fakturering.",
"est2.suspended": "Suspenderet",
"est2.tierFree": "1 etablering",
"est2.tierLarge": "uendelige etableringer",
"est2.tierMedium": "5 etableringer inkluderet",
"est2.tierSmall": "3 etableringer inkluderet",
"est2.title": "Etableringer",
"est2.unlimitedPlan": "Din plan tillader et ubegriblet antal etableringer.",
"est2.unlimitedSuffix": " · ubegriblet",
"est2.updated": "Etablering opdateret",
"est2.upgradeHint": "Opgrader til en højere plan for at tilføje flere steder og centralisere al din aktivitet.",
"est2.visuals": "Logo & foto",
"est2.visualsDesc": "Tilpas denne etablerings logo og coverbillede. De vises på dens offentlige side og erklæringsformular.",
"est2.visualsTitle": "Visuelle elementer — {name}",
"est2.workOn": "Arbejd på denne etablering",
"est2.working": "Du arbejder på “{name}”",
"ev.created": "Rapport oprettet",
"ev.matched": "Matchende vare identificeret",
"ev.paid": "Betalingsgebyr betalt",
"ev.pickup": "Afhentning på stedet",
"ev.shipped": "Pakke sendt",
"ev.shipping_paid": "Fragtgebyr betalt",
"ev.shipping_requested": "Fragt anmodet",
"feat1.d": "KPIs, returprocent pr. kategori, indtægter og 30-dages tendenser.",
"feat1.t": "Dashboard & analyser",
"feat2.d": "Etiketter, transportsporingsinformation og automatiske sporings-e-mails.",
"feat2.t": "Fragtmodul",
"feat3.d": "Kunder finder dig efter by og kategori, med vurderede anmeldelser.",
"feat3.t": "Offentlig katalog & anmeldelser",
"fp.backToRanking": "Tilbage til leaderboard",
"fp.badge": "Mærke",
"fp.hero": "Finder Hero",
"fp.notFound": "Profil ikke fundet eller privat.",
"fp.scoreTotal": "Samlede point",
"fp.scoreYear": "Point i",
"fp.share": "Del denne profil",
"fp.shareText": "Tjek {name}'s finderprofil på Findloop!",
"fp.tagline": "En ærlig finder der gør verden til et bedre sted.",
"ft.backAccount": "Tilbage til Min konto",
"ft.closeBtn": "Luk sagen",
"ft.closeConfirm": "Bekræft at varen blev returneret? Annoncen vil blive lukket.",
"ft.closeLockedHint": "Valider ejerens kode først for at låse op for lukningen.",
"ft.closed": "Sagen lukket — varen returneret!",
"ft.codeLabel": "Indtast valideringskoden modtaget fra ejeren",
"ft.codeNeeded": "Indtast venligst valideringskoden.",
"ft.codeOk": "Kode valideret — du kan lukke sagen.",
"ft.codePlaceholder": "f.eks. 4821",
"ft.codeVerified": "Valideret",
"ft.doneMsg": "Varen returneret. Tak for at hjælpe med at returnere den til ejeren!",
"ft.stepInProgress": "Returnering i gang",
"ft.stepPublished": "Annonce offentliggjort",
"ft.stepReturned": "Varen returneret",
"ft.subtitle": "Følg trinene indtil den fundne vare er returneret.",
"ft.title": "Returnering overvågning",
"ft.verifyBtn": "Valider kode",
"hero.badge": "Udf Featured",
"hero.ctaFound": "Jeg fandt en vare",
"hero.ctaLost": "Jeg mistede en vare",
"hero.ctaPartner": "Bliv partner",
"hero.subtitle": "Findloop hjælper virksomheder med at håndtere fundne genstande — og lader deres kunder rapportere et tab og derefter genvinde deres ejendele, på stedet eller ved forsendelse.",
"hero.title": "Hver mistet genstand finder sin ejer.",
"home.champBecome": "Bliv finder",
"home.champCta": "Se leaderboard",
"home.champSubtitle": "Hver returneret genstand indtjenes point. Deltag i leaderboard og vind belønninger.",
"home.champTitle": "Vores top findere",
"how.eyebrow": "Hvordan det virker",
"how.title": "Fra aflevering til returnering, uden besvær.",
"inv.all": "Alle",
"inv.allYears": "Alle år",
"inv.count": "Fakturaer",
"inv.due": "forfaldne",
"inv.empty": "Ingen fakturaer endnu.",
"inv.exportCsv": "Eksporter CSV",
"inv.invoicePdf": "Faktura PDF",
"inv.issued": "Udstedt",
"inv.noMatch": "Ingen faktura for dette filter.",
"inv.paid": "Betalt (€)",
"inv.paidOn": "betalt den",
"inv.pay": "Betal",
"inv.receipt": "Kvittering",
"inv.reminders": "Påmindelser",
"inv.remindersDesc": "E-mail og SMS påmindelser sendt for denne faktura.",
"inv.remindersEmpty": "Ingen påmindelse sendt.",
"inv.rmDue": "Påmindelse om forfaldsdato",
"inv.rmManual": "Manuel påmindelse",
"inv.rmSms": "SMS påmindelse D+30",
"inv.rmStage": "Påmindelse",
"inv.statusPaid": "Betalt",
"inv.statusUnpaid": "Ikke betalt",
"inv.subtitle": "Vis og download dine fakturaer og kvitteringer.",
"inv.title": "Mine fakturaer",
"inv.unpaid": "Ikke betalt (€)",
"inv2.contractTitle": "Min Findloop kontrakt",
"inv2.detailByEst": "Detaljer efter etablering",
"inv2.dueLabel": "Forfalder:",
"inv2.dueSuffix": " · forfalder {date}",
"inv2.error": "Fejl {status}",
"inv2.estCountIssued": "{n} etablering(er) · udstedt den {date}",
"inv2.estimate": "Estimato (ikke opkrævet) · {n} etablering(er)",
"inv2.expired": " · udløbet",
"inv2.exportCsv": "Eksporter CSV",
"inv2.exportDone": "CSV eksport downloadet",
"inv2.included": "Inkluderet",
"inv2.monthlyTitle": "Månedlig fakturering (abonnement)",
"inv2.months": "+{n} måneder",
"inv2.paid": "Betalt",
"inv2.pay": "Betal",
"inv2.previewTitle": "Forhåndsvisning af din næste faktura —",
"inv2.renew": "Forny min kontrakt",
"inv2.renewalsTitle": "Fornyelseshistorik ({n})",
"inv2.renewedUntil": "Kontrakt fornyet til {date}",
"inv2.serviceTitle": "Servicefakturaer (genindvindelser & tilbud)",
"inv2.soon": "Udløber snart",
"inv2.toPay": "At betale",
"inv2.totalHtTva": "Total ekskl. skat · moms",
"inv2.totalTtc": "Total inkl. skat",
"iu.addPhoto": "Tilføj et foto",
"iu.change": "Ændre",
"lang.label": "Sprog",
"lb.allCountries": "Alle lande",
"lb.badge": "Årlig rangliste",
"lb.champion": "🏆 Årets mester",
"lb.cityPh": "Filtrer efter by…",
"lb.empty": "Ingen rangliste for disse filtre endnu.",
"lb.pts": "point",
"lb.resetNote": "Rangliste for nuværende år — nulstilles hvert 1. januar.",
"lb.returned": "returneret",
"lb.share": "Del ranglisten",
"lb.shareText": "Tjek den bedste finders rangliste på Findloop!",
"lb.subtitle": "Hver returnering tjener point. Ranglisten nulstilles hvert 1. januar.",
"lb.tabFinders": "Findere",
"lb.tabPartners": "Etableringer",
"lb.title": "Top findere",
"lost.b2bDesc": "Tabte du det på et hotel, transportknudepunkt eller partnersted? Find etableringen og rapporter dit tab.",
"lost.b2bTitle": "Rapportér til en partner",
"lost.b2cDesc": "Udgiv en annonce synlig for alle, tilbyd en belønning og boost den for at maksimere dine chancer.",
"lost.b2cTitle": "Post en offentlig annonce",
"lost.desc": "Vælg hvordan du ønsker at fortsætte.",
"lost.title": "Tabt en genstand?",
"map.allCategories": "Alle kategorier",
"map.clear": "Nulstil",
"map.exitFullscreen": "Forlad",
"map.filterCity": "By eller land…",
"map.fullscreen": "Fuldskærm",
"map.heatmap": "Varme kort",
"map.high": "Høj",
"map.impactMonth": "genstande returneret i denne måned",
"map.impactTotal": "returneret i alt",
"map.legend": "Farvede prikker fra rød (lav) til grøn (høj) baseret på tilbageholdelsesraten; størrelse baseret på antallet af genstande.",
"map.locating": "Lokaliserer… tilføj en adresse til dine steder for at se dem på kortet.",
"map.low": "Lav",
"map.mAll": "Alle",
"map.mFound": "Fundet",
"map.mLost": "Tabt",
"map.medium": "Middel",
"map.noItemRegistered": "Ingen genstand registreret",
"map.noItems": "Ingen genstand",
"map.period30": "Sidste 30 dage",
"map.period7": "Sidste 7 dage",
"map.period90": "Sidste 90 dage",
"map.periodAll": "Al tid",
"map.returnedSuffix": "returneret · {a}/{t} genstande",
"map.stats": "Bystatistikker",
"map.statsTop": "Top 5 steder (tabte genstande)",
"map.statsTrend": "6-måneders trend",
"map.title": "Kort over dine steder",
"map.topPlaces": "Populære steder",
"mc.adClosed": "Annoncering lukket",
"mc.addPhoto": "Tilføj et foto",
"mc.adsNone": "Ingen tabt-genstand annoncer.",
"mc.archiveHide": "Skjul historik",
"mc.archiveNone": "Ingen løste sager endnu.",
"mc.archiveShow": "Vis historik",
"mc.archiveSub": "Løste og returnerede sager.",
"mc.archiveTitle": "Historik",
"mc.at": "Ved",
"mc.backToLogin": "Tilbage til login",
"mc.boostContacts": "Kontakter (boost)",
"mc.boostViews": "Visninger (boost)",
"mc.cancel": "Annuller",
"mc.certificate": "Certifikat",
"mc.changePhoto": "Skift foto",
"mc.city": "By",
"mc.closeAd": "Luk",
"mc.closeAdConfirm": "Luk denne annonce? Den vil ikke længere være synlig og vil frigive en plads.",
"mc.confirmPassword": "Bekræft adgangskode",
"mc.confirmRestitution": "Bekræft returnering",
"mc.connect": "Forbind",
"mc.contacts": "Kontakter",
"mc.country": "Land",
"mc.declareFound": "Rapporter en fundet genstand",
"mc.declareFoundSub": "Post en genstand, du har fundet",
"mc.declareLost": "Rapporter et tab",
"mc.declareLostSub": "Post en annonce for tabte genstande",
"mc.deleteAccount": "Slet min konto",
"mc.deleteConfirm": "Ja, slet min konto",
"mc.deleteConfirmBody": "Din konto vil blive permanent slettet, og dine personlige data anonymiseres. Denne handling kan ikke fortrydes.",
"mc.deleteConfirmTitle": "Slet din konto?",
"mc.deleteDesc": "Sletter din konto permanent og anonymiserer dine personlige data. Denne handling kan ikke fortrydes.",
"mc.deleted": "Din konto er blevet slettet.",
"mc.deleting": "Sletter…",
"mc.email": "Email",
"mc.expiresOn": "Udløber den",
"mc.exportData": "Download mine data (GDPR)",
"mc.exportDone": "Dine data er blevet downloaded.",
"mc.exporting": "Forbereder…",
"mc.finderAccepted": "Godkendt",
"mc.finderProfile": "Finderprofil (valgfrit)",
"mc.finderProfileDesc": "Optjen point ved at returnere varer og vis på den offentlige rangliste.",
"mc.forYourAd": "For din annonce",
"mc.forgotLink": "Glemt kodeord?",
"mc.forgotSend": "Send link",
"mc.forgotSent": "Hvis der findes en konto for denne email, er et nulstillingslink lige blevet sendt.",
"mc.forgotTitle": "Glemt kodeord",
"mc.foundAdsNone": "Ingen fundet-vare annoncer offentliggjort.",
"mc.foundAt": "Fundet ved",
"mc.foundNone": "Ingen fundet vare rapporteret.",
"mc.hAd": "Tabt annonce",
"mc.hDeclaration": "Erklæring",
"mc.hFinderContact": "Rapporteret vare",
"mc.hFound": "Returneret vare",
"mc.hFoundAd": "Fundet annonce",
"mc.histEarned": "Vare returneret",
"mc.historyTitle": "Min pointshistorik",
"mc.loginBtn": "Log ind",
"mc.loginTitle": "Kunde login",
"mc.logout": "Log ud",
"mc.lostAt": "Tabt ved",
"mc.matchPartner": "Hos en partner",
"mc.matchPublic": "Fundet vare",
"mc.matches": "Kampagner",
"mc.matchesSub": "Fundne varer kan matche dine tabte vare annoncer.",
"mc.myAds": "Mine tabte vare annoncer",
"mc.myDeclarations": "Mine rapporter",
"mc.myFinds": "Varer jeg har fundet",
"mc.myFindsNone": "Du har endnu ikke rapporteret at have fundet nogen varer.",
"mc.myFindsSub": "Varer, du har rapporteret at have fundet i annoncer for tabte varer.",
"mc.myFound": "Rapporterede fundne varer",
"mc.myFoundAds": "Mine fundne vare annoncer",
"mc.myRewards": "Mine vouchers",
"mc.name": "Fulde navn",
"mc.newPassword": "Nyt kodeord",
"mc.none": "Ingen rapport endnu.",
"mc.notEnough": "Ikke nok point",
"mc.notifEmpty": "Ingen notifikationer endnu.",
"mc.notifOpen": "Vis",
"mc.notifTitle": "Notifikationer",
"mc.notifTrack": "Spor",
"mc.notifViewAd": "Vis annonce",
"mc.optInDesc": "Valgfri deltagelse. Du giver samtykke til offentligt at vise de valgte varer nedenfor. Kan ændres når som helst.",
"mc.optInTitle": "Vis på den offentlige rangliste",
"mc.password": "Kodeord",
"mc.passwordMismatch": "Kodeordene stemmer ikke overens.",
"mc.phone": "Telefon",
"mc.photoUpdated": "Profilbillede opdateret",
"mc.pointsAwaiting": "Ventende point",
"mc.pointsBalance": "Point til at bruge",
"mc.pointsOk": "Point tilskrevet",
"mc.presentHint": "Vis denne QR til partneren: de scanner den for at validere din belønning.",
"mc.presentInStore": "Vis i butik",
"mc.presentTitle": "Vis dette gavekort",
"mc.privacy": "Privatliv & data",
"mc.privacyDesc": "Download en kopi af alle personlige data, Findloop har om dig (GDPR, art. 15 & 20).",
"mc.profileSaved": "Profil opdateret.",
"mc.profileSettings": "Offentlig profil & leaderboard",
"mc.pseudo": "Fornavn eller kaldenavn",
"mc.redExpired": "Udløbet",
"mc.redReady": "Vis hos partner",
"mc.redUsed": "Brugt",
"mc.redeem": "Indløs",
"mc.registerBtn": "Opret min konto",
"mc.registerTitle": "Opret en kundekonto",
"mc.rememberMe": "Husk mig",
"mc.remove": "Fjern",
"mc.resetDone": "Adgangskode opdateret. Du kan nu logge ind.",
"mc.resetExpired": "Dette nulstillingslink er ugyldigt eller udløbet. Anmod om en ny nedenfor.",
"mc.resetSave": "Nulstil min adgangskode",
"mc.resetTitle": "Ny adgangskode",
"mc.restitutionConfirmed": "Returnering bekræftet.",
"mc.reward": "Belønning",
"mc.rewardRedeemed": "Belønning låst op! Kode:",
"mc.rewardsDesc": "Brug dine pointe til fordele tilbudt af vores partnere. Balance:",
"mc.rewardsNone": "Ingen belønning tilgængelig endnu.",
"mc.rewardsTitle": "Brug mine pointe",
"mc.scoreAwarded": "Godt klaret! +1 til din Finder Score 🎉",
"mc.scoreEarned": "Point optjent",
"mc.scorePts": "pts",
"mc.scoreThisYear": "I år",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Se leaderboard",
"mc.share": "Del",
"mc.statsTitle": "Statistik",
"mc.subtitle": "Spor alle dine rapporter ét sted.",
"mc.title": "Min konto",
"mc.toLogin": "Allerede registreret?",
"mc.toRegister": "Ingen konto endnu?",
"mc.track": "Spor",
"mc.views": "Visninger",
"mc.visCity": "By",
"mc.visCountry": "Land",
"mc.visLabel": "Elementer synlige på leaderboard:",
"mc.visName": "Fornavn / kaldenavn",
"mc.visPhoto": "Profilfoto",
"mc.welcome": "Hej",
"mc2.acceptFinder": "Accepter denne finder",
"mc2.accountActivity": "Konto aktivitet",
"mc2.adsActive": "{n}/5 aktive annoncer",
"mc2.autoDelete": "Automatisk sletning planlagt til",
"mc2.badgeBronze": "Bronze",
"mc2.badgeGold": "Guld",
"mc2.badgeSilver": "Sølv",
"mc2.boostEarnedAlready": "Det har allerede indbragt dig",
"mc2.boostEarnedWin": "Det indbragte dig",
"mc2.boostExpiredWin": "Din boost er lige udløbet — genoptag med -20%!",
"mc2.boostExpiresIn": "Din boost udløber om",
"mc2.boostWinDetail2": ". -20% anvendt automatisk, hvis du fornyer indenfor 24 timer.",
"mc2.claimCode": "Kravkode:",
"mc2.codeSentFinder": "Kode sendt til finderen via e-mail",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Download min kvittering",
"mc2.error": "Fejl {status}",
"mc2.finderAccepted": "Finder accepteret — kode sendt via e-mail",
"mc2.finderContacts": "Finder(e)s kontaktoplysninger",
"mc2.followFindo": "Følg Findloop",
"mc2.imgInvalid": "Ugyldigt billede",
"mc2.inactivityNote": " — i tilfælde af {n} måneders inaktivitet (GDPR).",
"mc2.lastActivity": "Seneste aktivitet:",
"mc2.lostEmailTitle": "Jeg har ikke længere adgang til min e-mail",
"mc2.noPhotoPreset": "Ingen foto endnu? Vælg en standard avatar:",
"mc2.paidViaPartner": "Betalt (via partner)",
"mc2.payRecovery": "Betal gebyret for genopretning",
"mc2.paySettle": "Afvikl min betaling",
"mc2.payShipping": "Betal forsendelsesgebyret",
"mc2.payUnavailable": "Betaling utilgængelig",
"mc2.peopleFound": "{n} person(er) mener, at de har fundet din genstand",
"mc2.phoneNumber": "Telefonnummer",
"mc2.reactivateAccount": "Genaktivér min konto",
"mc2.reactivated": "Konto genaktiveret",
"mc2.reactivatedThanks": "Konto genaktiveret — tak for din loyalitet!",
"mc2.recoverSmsBtn": "Få min kode ved SMS",
"mc2.recoverSmsDesc": "Modtag din kravkode via SMS til det nummer, der er registreret på din konto.",
"mc2.recoverSmsFallback": "Hvis der eksisterer en konto med dette nummer, er der sendt en SMS.",
"mc2.renewStayTop": ". Forny for at forblive på toppen og genvinde din genstand.",
"mc2.resume20": "Gendannelse -20%",
"mc2.unlockContacts": "Låse kontaktoplysninger op",
"mc2.unlockDesc": "Betal Findloop gebyret for at afsløre deres kontaktoplysninger og arrangere overdragelsen.",
"mc2.viewsWord": "visninger",
"mc2.live": "Live",
"mh.allCategories": "Alle kategorier",
"mh.allPeriod": "Alle tider",
"mh.autoMatch": "Auto AI match",
"mh.blocked": "Blokeret (modsætning)",
"mh.blockedReason": "Match blokeret: de vigtigste nøgleord for genstanden og erklæringen modsiger hinanden.",
"mh.days30": "Sidste 30 dage",
"mh.days7": "Sidste 7 dage",
"mh.days90": "Sidste 90 dage",
"mh.emptyDesc": "AI-matches vises her, efterhånden som erklæringerne kommer ind.",
"mh.emptyTitle": "Ingen aktiviteter",
"mh.exportCsv": "Eksportér CSV",
"mh.exportDone": "CSV eksport downloadet",
"mh.exportImpossible": "Eksport mislykkedes",
"mh.fBlocked": "Blokeret",
"mh.fConfirmed": "Bekræftet",
"mh.fRejected": "Afvist",
"mh.objectLabel": "Genstand:",
"mh.refresh": "Opdater",
"mh.rejected": "Afvist",
"mh.srcManual": "Manuel",
"mh.srcText": "Tekst",
"mh.srcVisual": "Visuel (foto)",
"mh.subtitle": "Log over matches foreslået af AI — automatisk matchet, bekræftet og afvist.",
"mh.title": "AI Historik",
"nav.ads": "Mistede genstande",
"nav.dashboard": "Mit rum",
"nav.found": "Fundne genstande",
"nav.how": "Hvordan det fungerer",
"nav.login": "Log ind",
"nav.map": "Kort",
"nav.more": "Mere",
"nav.partners": "Partnere",
"nav.pricing": "Priser",
"nav.ranking": "Leaderboard",
"nav.register": "Bliv partner",
"nav.track": "Spor en erklæring",
"nf.desc": "Siden du leder efter eksisterer ikke eller er blevet flyttet.",
"nf.home": "Tilbage til startside",
"nf.title": "Siden blev ikke fundet",
"par.allCities": "Alle byer",
"par.allCountries": "Alle lande",
"par.badge": "Directory",
"par.certified": "Certificeret",
"par.certifiedBadge": "Certificeret",
"par.cityPh": "By",
"par.declare": "Rapporter",
"par.none": "Ingen partner fundet.",
"par.partnerBadge": "Partner",
"par.searchPh": "Søg efter en etablering…",
"par.subtitle": "Find den etablering, hvor du har mistet din genstand, og rapporter dit tab.",
"par.title": "Vores partnere",
"pay.addr1": "Adresse",
"pay.addr2": "Adresselinje 2 (valgfri)",
"pay.addrIncomplete": "Udfyld venligst din leveringsadresse.",
"pay.badge": "Genfinding",
"pay.card": "Betal med kort",
"pay.city": "By",
"pay.country": "Land",
"pay.eurNote": "Beløb vist i euro (€).",
"pay.fee": "Genfinding gebyr",
"pay.free": "gratis",
"pay.howRecover": "Hvordan vil du gerne have din genstand tilbage?",
"pay.momo": "Betal med Mobile Money",
"pay.momoConfirm": "Bekræft betaling",
"pay.noMatch": "Ingen matchende genstand er bekræftet for denne rapport endnu.",
"pay.notfound": "Rapport ikke fundet.",
"pay.phonePh": "Telefonnummer",
"pay.pickup": "Afhent personligt",
"pay.pickupDesc": "Ved",
"pay.postal": "Postnummer",
"pay.secure": "Sikker betaling",
"pay.serviceFee": "Findloop servicegebyr",
"pay.ship": "Send det til mig",
"pay.shipAfter": "— tilbydes efter betaling.",
"pay.shipDesc": "Levering til min adresse",
"pay.shipNote": "Forsendelse tilgængelig",
"pay.shipping": "Forsendelsesgebyr",
"pay.subtitleWith": "Betal genfindingsgebyret til",
"pay.title": "Genfind min genstand",
"pay.total": "Total",
"pcat.city_hall": "Rådhuse",
"pcat.hotel": "Hoteller",
"pcat.other": "Andet",
"pcat.park": "Parker",
"pcat.prefecture": "Præfekturer",
"pcat.restaurant": "Restauranter",
"pcat.uncategorized": "Ukategoriseret",
"pd.about": "Om",
"pd.back": "Alle partnere",
"pd.certified": "Certificeret partner",
"pd.declare": "Rapporter et tab her",
"pd.itemsReturned": "returnerede varer",
"pd.itemsTotal": "registrerede varer",
"pd.map": "Placeringssted",
"pd.noItems": "Ingen varer fundet for nylig.",
"pd.noReviews": "Ingen anmeldelser endnu.",
"pd.notFound": "Partner ikke fundet.",
"pd.recentItems": "Nyligt fundne varer",
"pd.reply": "Svar fra virksomheden",
"pd.reviews": "Kundeanmeldelser",
"pd.verified": "Verificeret anmeldelse",
"pd.verifiedEstablishment": "Findloop verificeret virksomhed",
"pg.next": "Næste",
"pg.prev": "Forrige",
"pg.showing": "{from}–{to} af {total}",
"pk.bodyCopy": "Brødtekst",
"pk.bodyText": "Brødtekst",
"pk.brandColors": "Brandfarver",
"pk.colorRed": "Rød",
"pk.colorWhite": "Hvid",
"pk.darkBg": "Mørk baggrund",
"pk.download": "Download",
"pk.downloadZip": "Download hele sættet (ZIP)",
"pk.headings": "Overskrifter",
"pk.heroDesc": "Officielle logoer, sociale medier bannere, farver og typografi. Vælg tagline sproget og varianten, og download derefter det visuelle eller hele sættet.",
"pk.lightBg": "Lys baggrund (tryk)",
"pk.logoWordmark": "Logo / ordmærke",
"pk.logosVisuals": "Logoer & visuals",
"pk.mapCollect": "Kort / indsamlingspunkter",
"pk.plain": "Enkel",
"pk.pressKit": "Pressekit",
"pk.taglineLang": "Tagline sprog",
"pk.typography": "Typografi",
"pk.variant": "Variant",
"pr.shipBtn": "Få varen sendt",
"pr2.adBoostMsg": "Godt valg! Du multiplicerer dine chancer for hurtigt at få din vare tilbage.",
"pr2.boostActivated": "Boost aktiveret!",
"pr2.canRecoverNow": "Du kan nu få din vare tilbage.",
"pr2.continue": "Fortsæt",
"pr2.downloadReceiptPdf": "Download kvitteringen (PDF)",
"pr2.goToSpaceNow": "Gå til min konto nu",
"pr2.partnerBoostMsg": "Godt valg! At være mere synlig betyder at tiltrække nye kunder til din virksomhed.",
"pr2.paymentSuccess": "Betaling gennemført!",
"pr2.redirectingSpace": "Omstiller til din konto…",
"pr2.subActivated": "Betaling gennemført! Dit abonnement er aktivt, du kan nu administrere dine virksomheder.",
"prev.allSites": "Alle virksomheder",
"prev.editReply": "Rediger svar",
"prev.none": "Ingen anmeldelse endnu.",
"prev.published": "Svar offentliggjort",
"prev.reply": "Svar",
"prev.replyPh": "Skriv et høfligt svar…",
"prev.send": "Offentliggør svar",
"prev.sending": "Offentliggør…",
"prev.yourReply": "Dit svar",
"pricing.annual": "Årligt",
"pricing.annualBadge": "-20% tilbud",
"pricing.choose": "Vælg",
"pricing.compareFeature": "Funktion",
"pricing.compareTitle": "Sammenlign planer",
"pricing.eyebrow": "Priser",
"pricing.month": "/md",
"pricing.monthly": "Månedligt",
"pricing.perYear": "/år",
"pricing.popular": "Populær",
"pricing.quoteMsg": "Dine behov (valgfrit)",
"pricing.quoteOrg": "Organisation",
"pricing.quoteSend": "Send anmodning",
"pricing.quoteSent": "Anmodning sendt! Vi vender tilbage til dig snart.",
"pricing.quoteSites": "Antal steder / terminaler",
"pricing.quoteTitle": "Anmod om et tilbud",
"pricing.requestQuote": "Anmod om et tilbud",
"pricing.saveLabel": "Du sparer",
"pricing.savePerYear": "/år per ekstra oprettelse",
"pricing.start": "Start",
"pricing.subtitle": "Start gratis, skaler efterhånden som du vokser.",
"pricing.title": "En plan for hver organisation",
"promo.badge": "Partnerprogram",
"promo.cta": "Lær mere",
"promo.text": "Hver partner, du henviser, som abonnerer, giver dig en gratis måned. Ingen grænser.",
"promo.title": "Henvis en partner, få en gratis måned.",
"pub.accessGranted": "Adgang givet",
"pub.accessLimited2h": "Adgang begrænset til 2 timer",
"pub.accountEmailConcerned": "Email på den berørte konto",
"pub.adAppearPublic": "Sådan vil din annonce vises offentligt.",
"pub.adPreviewBtn": "Annonceforhåndsvisning",
"pub.alertMeOnArrival": "Giv mig besked ved ankomst",
"pub.allActionsLogged": "Alle handlinger er logget",
"pub.allCategories": "Alle kategorier",
"pub.authorizeAccess": "Autoriser adgang",
"pub.authorizeSupportQ": "Autoriser supportadgang?",
"pub.available": "Tilgængelig",
"pub.backHome": "Tilbage til hjemmesiden",
"pub.boostAdCta": "Boost min annonce",
"pub.boostAdTitle": "Boost din annonce",
"pub.boostCarouselSub": "Bevæg dig til toppen af siden i det “Boostede” karusel og multiplicer visninger for hurtigere at genvinde dit item.",
"pub.boostEstablishment": "Boost din oprettelse",
"pub.boostEstablishmentDesc": "Vis dig øverst i kataloget med et “Boosted”-badge og tiltræk flere rapporter.",
"pub.boostFicheCta": "Boost min liste",
"pub.brandReady": "Findloop mærket, klar til brug",
"pub.cantFindItem": "Kan ikke finde dit item?",
"pub.cantProcessImage": "Kunne ikke behandle dette billede",
"pub.claimQr": "Gennemfør QR-kode",
"pub.clickToZoom": "Klik for at zoome",
"pub.codeAlreadyValidated": "Kode valideret – kontakter låst op.",
"pub.codeExample": "f.eks. ABCD2345",
"pub.confirmRenewal": "Bekræft fornyelse",
"pub.contactIntro": "Et spørgsmål, en anmodning? Skriv til os, vi vender tilbage til dig snart.",
"pub.contactTypeDeceased": "Kontosletning (afdød person)",
"pub.contactTypeGeneral": "Generelt spørgsmål",
"pub.contactTypeSupport": "Support / teknisk problem",
"pub.contactUs": "Kontakt os",
"pub.continueWithoutEmail": "Fortsæt uden at efterlade min email",
"pub.contractLabel": "Kontrakt",
"pub.contractNotFound": "Kontrakt ikke fundet eller allerede udløbet.",
"pub.contractRenewed": "Kontrakt fornyet!",
"pub.contractRenewedFor": "Din kontrakt er fornyet i {n} måneder.",
"pub.copyFailed": "Kopiering mislykkedes",
"pub.createPartnerAccount": "Opret min partnerkonto",
"pub.currentDeadline": "Nuværende frist",
"pub.deceasedInfo": "Som pårørende eller arving kan du anmode om sletning af en afdød persons findloop-konto. Vi vil behandle din anmodning i overensstemmelse med GDPR (dokumentation kan blive bedt om).",
"pub.declareMyLoss": "Rapporter mit tab",
"pub.describeItemPlaceholder": "Beskriv dit fund (f.eks. sort paraply, nøgler…)",
"pub.downloadImage": "Download billedet",
"pub.drawSignature": "Please draw your signature.",
"pub.drawSignatureHint": "Tegn din underskrift med musen eller fingeren.",
"pub.duration": "Varighed",
"pub.eSignature": "Elektronisk underskrift",
"pub.eSignatureDesc": "Indtast dit navn for at underskrive. Datoen registreres automatisk.",
"pub.edit": "Redigér",
"pub.editorialTitles": "Redaktionelle titler",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "Indtast koden modtaget via e-mail for at låse ejerens kontaktoplysninger op.",
"pub.errorWord": "Fejl",
"pub.foundSelfService": "Fundne genstande · Selvbetjening",
"pub.haveOwnerCode": "Jeg har modtaget en kode fra ejeren",
"pub.home": "Hjem",
"pub.immediateRenewal": "Øjeblikkelig fornyelse uden ny tilbud.",
"pub.impAdminReq1": "Administrator",
"pub.impAdminReq2": "anmoder om tilladelse til midlertidigt at få adgang til din konto",
"pub.impAdminReq3": "for at hjælpe dig.",
"pub.impGrantedDesc": "Supportteamet vil kunne få adgang til din konto i højst 2 timer. Hver handling vil blive logget. Du kan lukke denne side.",
"pub.invitedOnFindo": "Du er inviteret til Findloop",
"pub.isThisYourItem": "Er dette din genstand?",
"pub.itemsAvailableCount": "{n} genstand(e) tilgængelige lige nu",
"pub.itemsFoundOwner": "af betroede genstande har fundet deres ejer",
"pub.itemsReturnedOwners": "genstande returneret til deres ejere",
"pub.itsMine": "Det er mit",
"pub.joinFindoDesc": "Bliv en del af Findloop og administrer dine fundne genstande nemt.",
"pub.joinInvitesYou": "inviterer dig til at blive en del af findloop. Opret din partnerkonto for at administrere dine fundne genstande.",
"pub.linkCopied": "Link kopieret!",
"pub.loadingContract": "Indlæser kontrakt…",
"pub.lsClaimDesc": "Rapporter dit tab for at få det tilbage. Læg din e-mail, så sender vi dig en påmindelse, hvis din rapport ikke er færdiggjort.",
"pub.lsHeroDesc": "Tjek selv, om din tabte genstand er blevet fundet og efterladt her. Har du fundet den? Rapporter det for at få det tilbage.",
"pub.lsSearchTitle": "Søg efter fundne genstande",
"pub.makeOffer": "Giv et tilbud",
"pub.makeOfferDesc": "Foreslå dit beløb. Superadministratoren vil gennemgå det.",
"pub.mapNearYou": "Genstande & partnere nær dig",
"pub.mapWord": "Kort",
"pub.messageSentToast": "Besked sendt — vores team vil svare hurtigst muligt.",
"pub.messageWord": "Besked",
"pub.momoInitiated": "Mobile Money betaling initieret",
"pub.monthsWord": "måneder",
"pub.nameConsentRequired": "Navn og samtykke kræves.",
"pub.newDeadline": "Ny frist",
"pub.noActionRequired": "Ingen handling kræves.",
"pub.noAmountCharged": "Ingen beløb er blevet opkrævet.",
"pub.noItemMatch": "Ingen tilgængelig genstand matcher din søgning lige nu.",
"pub.noMatchingItem": "Ingen matchende genstand",
"pub.noPaymentSession": "Ingen betalingssession.",
"pub.noPhoto": "Ingen foto",
"pub.noPointsYet": "Ingen point at vise endnu.",
"pub.noSecondPayment": "Ingen anden betaling er nødvendig for denne genstand.",
"pub.notHereYet": "Ikke her endnu? Bliv underrettet, så snart den ankommer.",
"pub.notifyDone": "Noteret! Vi underretter dig via e-mail, så snart en matchende genstand ankommer.",
"pub.offerSubmitted": "Dit tilbud er blevet sendt.",
"pub.oops": "Ups",
"pub.orAlertEmail": "Eller bliv underrettet via e-mail, så snart en matchende genstand ankommer:",
"pub.ownerContacts": "Ejerens kontaktoplysninger",
"pub.ownerContactsUnlocked": "Ejerens kontaktoplysninger låst op",
"pub.partnerContact": "Partnerkontakt",
"pub.payLinkUnavailable": "Betalingslink ikke tilgængeligt — kontakt partneren.",
"pub.paymentCancelled": "Betaling annulleret",
"pub.paymentConfirmed": "Betaling bekræftet 🎉",
"pub.paymentConfirmedDesc": "Du vil modtage en email med detaljerne til at genfinde din genstand.",
"pub.paymentNotConfirmed": "Betaling ikke bekræftet",
"pub.paymentNotConfirmedDesc": "Betaling kunne ikke verificeres. Prøv igen eller kontakt partneren.",
"pub.paymentProcessing": "Betaling bliver behandlet. Opdater om et øjeblik.",
"pub.photoAdded": "✓ Foto tilføjet",
"pub.photoRequired": "Et foto af genstanden er påkrævet.",
"pub.previewAlt": "forside",
"pub.publish": "Udgiv",
"pub.publishingWord": "Udgiver…",
"pub.qty": "Antal",
"pub.quoteDeclined": "Tilbud afvist.",
"pub.quoteNotFound": "Tilbud ikke fundet eller udløbet.",
"pub.reasonLabel": "Grund",
"pub.recoveryAlreadyPaid": "Gebyr for genfinding er allerede betalt",
"pub.referralCode": "Henvisningskode:",
"pub.relationshipPlaceholder": "Søn, ægtefælle, notar…",
"pub.renewYourContract": "Forny din kontrakt",
"pub.renewalFailed": "Fornyelse fejlede. Prøv igen senere.",
"pub.renewing": "Fornyer…",
"pub.replySoon": "Vores team vil svare hurtigst muligt.",
"pub.requestGone": "Denne anmodning eksisterer ikke længere.",
"pub.requestHandled": "Anmodning allerede behandlet",
"pub.requestNotFound": "Anmodning ikke fundet eller udløbet.",
"pub.requestUnavailable": "Anmodning utilgængelig",
"pub.required": "(påkrævet)",
"pub.retroClosing": "Sammen gør vi verden lidt mindre fortabt.",
"pub.retroClosing2": "Sammen gør vi verden lidt mindre fortabt.",
"pub.retroScroll": "Et år med at genfinde hvad der betyder noget. Rul ned ↓",
"pub.revokeAnytime": "Du kan tilbagekalde når som helst ved at kontakte os",
"pub.scene": "Scene",
"pub.sendImpossible": "Kan ikke sende",
"pub.sendMessage": "Send beskeden",
"pub.sending": "Sender…",
"pub.sharePreview": "Del forsiden",
"pub.shareYourAd": "Del din annonce",
"pub.signedSuccess": "Delt med succes!",
"pub.signerFullName": "Signerens fulde navn",
"pub.spreadNetwork": "Del det med dem omkring dig for at øge dine chancer.",
"pub.spreadOwner": "Del det for at hjælpe ejeren med at genfinde deres ejendele.",
"pub.statusLabel": "Status:",
"pub.subject": "Emne",
"pub.thanksSent": "Tak, din besked er blevet sendt.",
"pub.thisYear": "I år",
"pub.validate": "Bekræft",
"pub.verifyingPayment": "Verificerer betaling…",
"pub.verifyingYourPayment": "Verificerer din betaling…",
"pub.viewAd": "Se annoncen →",
"pub.viewPartner": "Se partneren →",
"pub.yourAdPreview": "Forside af din annonce",
"pub.yourEmail": "Din email",
"pub.yourEmailRecommended": "Din email (anbefalet)",
"pub.yourEmailShort": "Din email",
"pub.yourName": "Dit navn",
"pub.yourRelationship": "Din relation til personen",
"qv.acceptAndSign": "Accepter og signér mit tilbud",
"qv.certifyAuthorized": "Jeg bekræfter, at jeg er autoriseret til at underskrive og jeg accepterer vilkårene for dette {what} (bindende værdi).",
"qv.clear": "Ryd",
"qv.client": "Klient",
"qv.conditions": "Betingelser",
"qv.confirmDecline": "Bekræft afvisningen af dette tilbud?",
"qv.countersignedFindo": "Modtegnet af Findloop · {name} den {date}",
"qv.decline": "Afvis",
"qv.description": "Beskrivelse",
"qv.downloadPdf": "Download PDF'en",
"qv.handwrittenSignature": "Håndskreven signatur",
"qv.inclTax": "Inkl. moms",
"qv.invalidAmount": "Ugyldigt beløb.",
"qv.invoice": "Faktura",
"qv.invoicePaid": "Faktura betalt",
"qv.issuer": "Udsteder",
"qv.messageOptional": "Besked (valgfri)",
"qv.negotiatedAmount": "Forhandlet beløb",
"qv.payInvoiceOnline": "Betal fakturaen online",
"qv.quote": "Tilbud",
"qv.quoteValidDays": "Tilbud gyldigt i {n} dage.",
"qv.sendMyOffer": "Send mit tilbud",
"qv.signContract": "Underskriv min kontrakt",
"qv.signNow": "Underskriv nu",
"qv.signatureAlt": "Underskrift",
"qv.signedByOn": "✔ Underskrevet af {name} den {date}",
"qv.stContractSigned": "Kontrakt underskrevet. Tak!",
"qv.stCounterAccepted": "Dit tilbud er blevet accepteret! Underskriv din kontrakt nedenfor.",
"qv.stCounterRefused": "Dit tilbud kunne ikke accepteres.",
"qv.stCountered": "Dit tilbud er blevet indsendt. Venter på Findloop's svar.",
"qv.stDeclined": "Du har afvist dette tilbud.",
"qv.stSigned": "Tilbud accepteret og underskrevet. Tak!",
"qv.totalHt": "Total ekskl. moms",
"qv.totalTtc": "Total inkl. moms",
"qv.unitHt": "Enhed ekskl. moms",
"qv.vat": "Moms",
"qv.yourProposedAmount": "Dit foreslåede beløb ({cur})",
"rate.chooseNote": "Vælg venligst en vurdering.",
"rate.commentPh": "En kommentar (valgfri)…",
"rate.home": "Tilbage til start",
"rate.submit": "Indsend min anmeldelse",
"rate.submitting": "Sender…",
"rate.subtitle": "Hvordan gik det med at hente dit item?",
"rate.successText": "Din feedback hjælper andre brugere.",
"rate.successTitle": "Tak for din anmeldelse!",
"rate.title": "Vurder din oplevelse",
"reg.add": "Log et item",
"reg.allBrands": "Alle mærker",
"reg.allColors": "Alle farver",
"reg.allLocations": "Alle steder",
"reg.detailDesc": "Detaljer og handlinger for dette fundne item.",
"reg.dispAuction": "Auktion",
"reg.dispAuthorities": "Overgivet til myndighederne",
"reg.dispDestroyed": "Ødelagt",
"reg.dispDonate": "Donation til velgørenhed",
"reg.dispositionHint": "Registrer itemet, der forlader opbevaring. Tælles i statistikken efter kategori.",
"reg.emptyCta": "Log et item",
"reg.emptyDesc": "Start med at logge dit første fundne item.",
"reg.emptyTitle": "Ingen fundne items",
"reg.establishmentFallback": "etablissementet",
"reg.lblAuctioned": "listet på auktion",
"reg.lblAuctionedShort": "auktioneret",
"reg.lblAuthorities": "overgivet til myndighederne",
"reg.lblDestroyed": "ødelagt",
"reg.lblDonated": "doneret til en velgørenhed",
"reg.legalCount": "{n} vare(r): juridisk opbevaringsperiode nået",
"reg.legalHint": "Du kan sætte dem på auktion, donere dem til en velgørenhed eller rapportere, at de er overgivet til myndighederne.",
"reg.legalLimitCountry": "Frist: {date} · anvendt land: {country}",
"reg.legalOver": "Frist udløbet: {date} · {country}",
"reg.legalReached": "Juridisk periode nået",
"reg.legalReachedFull": "Juridisk opbevaringsperiode nået",
"reg.limitShort": "frist",
"reg.location": "Beliggenhed",
"reg.markRestituted": "Marker som returneret",
"reg.markedAs": "Vare markeret som {label}",
"reg.moveHistory": "Bevægelseshistorik",
"reg.overBy": "over {n}d",
"reg.physicalLocation": "Fysisk beliggenhed",
"reg.popupBlocked": "Tillad pop-ups for at udskrive etiketterne.",
"reg.popupBlockedOne": "Tillad pop-ups for at udskrive etiketten.",
"reg.printLabel": "Udskriv etiketten",
"reg.printN": "Udskriv {n} etiketter",
"reg.qrCodeItem": "Vare QR-kode",
"reg.qrLabelTitle": "QR etikette",
"reg.qrLabelsTitle": "QR etiketter",
"reg.qrNotFound": "Ingen vare fundet for denne QR-kode.",
"reg.qrScanHint": "Scan den for at åbne denne post direkte og finde beliggenheden.",
"reg.recoveryFee": "Genoprettelsesgebyr (€)",
"reg.searchPh": "Søg efter beskrivelse…",
"reg.selectQr": "Vælg for at udskrive QR etiketter",
"reg.selectedN": "{n} valgt",
"reg.shipPricePh": "Fragtspris (€)",
"reg.shippingPossible": "Forsendelse tilgængelig",
"reg.storagePh": "f.eks. Hylde A3, Skab 12",
"reg.tAuction": "Auktion på Findloop",
"reg.tAuthorities": "Rapporter overgivelse til myndighederne",
"reg.tDonate": "Doner til en velgørenhed",
"reg.toastFee": "Gebyr opdateret",
"reg.toastLocation": "Beliggenhed gemt",
"reg.toastRestituted": "Vare markeret som returneret",
"reg.toastShipping": "Forsendelsesmulighed opdateret",
"reg.toastTransferred": "Vare overført til “{name}”",
"reg.unclaimedDisposition": "Uafhentet vare — endelig disposition",
"res.codeValidated": "Kode valideret",
"res.empty": "Ingen restitution registreret endnu.",
"res.error": "Fejl {status}",
"res.proofPdf": "PDF bevis",
"res.signed": "Underskrevet",
"res.stRestituted": "Udleveret personligt",
"res.stShipped": "Returneret via forsendelse",
"res.subtitle": "Alle afsluttede overdragelser med deres downloadbare underskrevne bevis.",
"res.title": "Restitution historie",
"rev.b2b": "B2B partnere",
"rev.b2c": "Kunder",
"rev.based": "baseret på {n} anmeldelser",
"rev.eyebrow": "Udtalelser",
"rev.restitutedBy": "Returneret af {org}",
"rev.storiesEyebrow": "Lykkelige slutninger",
"rev.storiesSubtitle": "Virkelige historier fra kunder, der har fået deres ejendele tilbage med findloop.",
"rev.storiesTitle": "De fandt deres ejendele!",
"rev.subtitle": "Partnere og kunder deler deres erfaring.",
"rev.title": "De stoler på Findloop",
"rev.verified": "Verifieret",
"rp.already": "Du har allerede rapporteret denne opføring.",
"rp.comment": "Detaljer (valgfrit)",
"rp.duplicate": "Duplikat",
"rp.fraud": "Svindel / bedrageri",
"rp.inappropriate": "Inhold der ikke er passende",
"rp.offensive": "Offensivt indhold",
"rp.other": "Andet",
"rp.reason": "Årsag",
"rp.report": "Rapporter",
"rp.send": "Send rapport",
"rp.sent": "Rapport sendt. Tak for dit bidrag.",
"rp.spam": "Spam / reklame",
"rp.title": "Rapporter denne annonce",
"rp.wrongCategory": "Forkert kategori",
"rt.annualGoal": "Årligt mål",
"rt.championCity": "Championsby",
"rt.cityRate": "{rate}% tilbagebetalingsrate",
"rt.goalProgress": "{rate}% opnået af et {target}% mål",
"rt.reached": "Nået 🎉",
"rt.restitutionRate": "Tilbagebetalingsrate",
"rt.shareRecap": "Del min opsummering",
"rt.thanks": "Tak Findloop {year} 💛",
"rt.yourRecap": "Din {year} opsummering",
"rw.active": "Aktiv",
"rw.add": "Tilføj",
"rw.camUnavailable": "Kamera utilgængeligt. Indtast koden manuelt nedenfor.",
"rw.codeValidated": "Kode valideret",
"rw.codesTitle": "Koder indløst af findere",
"rw.confirmDelete": "Slette “{title}”? ",
"rw.deleted": "Slettet",
"rw.edit": "Rediger",
"rw.editReward": "Rediger belønningen",
"rw.empty": "Ingen belønning endnu.",
"rw.expired": "Udløbet",
"rw.expiresOn": "Udløber den {date}",
"rw.fActive": "Aktiv (synlig for findere)",
"rw.fCost": "Omkostning (point)",
"rw.fDesc": "Beskrivelse",
"rw.fStock": "Lager (tomt = ubegrænset)",
"rw.fTitle": "Titel",
"rw.fValidity": "Gyldighed af voucher (dage efter indløsning)",
"rw.inactive": "Inaktiv",
"rw.newReward": "Ny belønning",
"rw.noExchange": "Ingen indløsning endnu.",
"rw.pageSubtitle": "Scan de vouchers, som findere præsenterer for at validere deres belønninger.",
"rw.redeemedN": "Indløst: {n}×",
"rw.saved": "Belønning gemt",
"rw.scanVoucher": "Scan en voucher",
"rw.staffScanOnly": "Scan kun",
"rw.statActive": "At præsentere",
"rw.statExpired": "Udløbet",
"rw.statRedeemed": "Vouchers indløst",
"rw.statUsed": "Valideret",
"rw.stock": "Lager",
"rw.subtitle": "Tilbyde ikke-monetære fordele (vouchers, opgraderinger…) som findere indløser for deres Finder Score point.",
"rw.title": "Belønninger for findere",
"rw.used": "Brugt",
"rw.validate": "Valider",
"rw.validateCode": "Valider koden",
"rw.validity": "Gyldighed: {n} d",
"shell.f1d": "Automatisk linke mistede og fundne genstande.",
"shell.f1t": "Smart AI matchning",
"shell.f2d": "Spor returprocent og indtægter i realtid.",
"shell.f2t": "Dashboard & indtægter",
"shell.f3d": "Dine kunder rapporterer på 30 sekunder.",
"shell.f3t": "Partner QR kode",
"shell.title": "Gør tabte genstande til tilfredse kunder.",
"ship.addr1": "Adresse",
"ship.addr2": "Adresselinje 2 (valgfrit)",
"ship.badge": "Forsendelse",
"ship.city": "By",
"ship.country": "Land",
"ship.needPaid": "Betal gebyret for tilbagelevering først for at anmode om forsendelse.",
"ship.notShippable": "Denne genstand kan ikke sendes.",
"ship.notfound": "Rapport ikke fundet.",
"ship.postal": "Postnummer",
"ship.price": "Forsendelsesgebyr",
"ship.submit": "Anmod om forsendelse",
"ship.submitting": "Sender…",
"ship.subtitle": "Indtast din leveringsadresse.",
"ship.successText": "Partneren vil forberede din pakke. Du vil blive underrettet, når den er sendt.",
"ship.successTitle": "Forsendelsesanmodning sendt!",
"ship.title": "Få din genstand sendt",
"ship.weight": "Estimateret vægt (kg)",
"shp.carrier": "Transportør",
"shp.download": "Download PDF",
"shp.generating": "Genererer…",
"shp.label": "Generer label",
"shp.none": "Ingen forsendelse anmodet.",
"shp.setTracking": "Gem sporingsnummer",
"shp.status": "Status",
"shp.to": "Modtager",
"shp.tracking": "Sporingsnr.",
"shp.trackingSaved": "Sporing gemt",
"side.account": "Min konto",
"side.declarations": "Rapporter",
"side.deposit": "Log en genstand",
"side.establishments": "Etableringer",
"side.invoices": "Fakturaer",
"side.logout": "Log ud",
"side.matchHistory": "AI Historik",
"side.partner": "Partner",
"side.refresh": "Opdater",
"side.registry": "Register",
"side.restitutions": "Returer",
"side.reviews": "Anmeldelser",
"side.rewards": "Belønninger & Kuponer",
"side.settings": "Indstillinger",
"side.shipments": "Forsendelser",
"side.stats": "Statistik",
"side.storage": "Opbevaring & QR",
"side.team": "Team",
"side.viewSite": "Se offentlig side",
"st.auctioned": "Solgt på auktion",
"st.claimed": "Krav",
"st.closed": "Lukket",
"st.delivered": "Leveret",
"st.destroyed": "Ødelagt",
"st.donated": "Doneret (velgørenhed)",
"st.handed_to_authorities": "Overgivet til myndighederne",
"st.in_storage": "I opbevaring",
"st.matched": "Match fundet",
"st.open": "Åben",
"st.paid": "Betalt",
"st.pending": "Afventer",
"st.resolved": "Løst",
"st.restituted": "Returneret",
"st.second_chance": "Anden chance",
"st.shipped": "Forsendt",
"st.shipping_requested": "Forsendelse anmodet",
"st.submitted": "Indsendt",
"st.verified": "Verificeret",
"stat.items": "Registrerede genstande",
"stat.partners": "Partnere",
"stat.restituted": "Returnerede genstande",
"status.auctioned": "Solgt på auktion",
"status.destroyed": "Ødelagt",
"status.donated": "Doneret (velgørenhed)",
"status.handed_to_authorities": "Givet til myndighederne",
"status.in_storage": "I opbevaring",
"status.matched": "Match",
"status.open": "Åben",
"status.paid": "Betalt",
"status.pending": "Afventer",
"status.restituted": "Returneret",
"status.shipped": "Forsendt",
"status.shipping_requested": "Forsendelse anmodet",
"status.submitted": "Indsendt",
"step1.tag": "Etablering",
"step1.text": "På få sekunder registrerer etableringen den fundne genstand med et billede, kategori og beskrivelse. Alt er centraliseret i et klart, sikkert register.",
"step1.title": "Partneren registrerer genstanden",
"step2.tag": "Kunde",
"step2.text": "Via partnerens QR-kode beskriver din kunde den tabte genstand på 30 sekunder. Ingen app at installere - det hele sker i browseren.",
"step2.title": "Kunden anmelder tabet",
"step3.tag": "Intelligens",
"step3.text": "Vores smarte matchingsmotor sammenligner beskrivelser og foreslår de mest sandsynlige matches, klar til at bekræfte.",
"step3.title": "AI forbinder tabt og fundet genstand",
"step4.tag": "Genfinding",
"step4.text": "Efter en sikker betaling af gebyret for genfinding henter kunden genstanden på stedet - eller modtager den med sporbar forsendelse.",
"step4.title": "Kunden får deres genstand tilbage",
"stg.allLabels": "Alle QR-labels",
"stg.camHint": "Brug manuel indtastning nedenfor.",
"stg.camStarting": "Starter kameraet…",
"stg.camUnavailable": "Kamera ikke tilgængeligt.",
"stg.clear": "Ryd",
"stg.clearAll": "Ryd alle",
"stg.codeUnreadable": "Ulæselig kode.",
"stg.emptyDesc": "Opbevarede genstande vises her, grupperet efter placering.",
"stg.emptyTitle": "Ingen genstand i opbevaring",
"stg.exportAudit": "Eksporter revisions-CSV",
"stg.exportDone": "CSV-eksport downloadet",
"stg.exportImpossible": "Eksport ikke tilgængelig lige nu.",
"stg.itemFound": "Genstand fundet ✅",
"stg.kLocations": "Brugte lokationer",
"stg.kObjects": "Opbevarede genstande",
"stg.kToClear": "Lokationer der skal ryddes",
"stg.locFreed": "Lokation ryddet",
"stg.locsFreed": "{n} lokation(er) ryddet",
"stg.manualLabel": "Eller indtast genstandens kode / ID",
"stg.manualPh": "Indsæt QR-id eller URL",
"stg.noItemMatch": "Ingen genstande matcher denne QR / kode.",
"stg.noLocation": "Ingen placering",
"stg.objectsAxis": "Elementer",
"stg.objectsN": "{n} element(er)",
"stg.occAvg": "gennemsnit {n} elementer/placering",
"stg.occHint": "Placeringer i amber overskrider gennemsnittet (potentielt overbelastede).",
"stg.occupancy": "Placeringens beboelse",
"stg.openPage": "Åbn siden",
"stg.posterPdf": "PDF plakat (A4)",
"stg.printAll": "Print alt",
"stg.printGroupTitle": "Print etiketter til denne hylde",
"stg.qrAlt": "Selvbetjening QR",
"stg.qrDownload": "Download QR",
"stg.qrHint": "Vis denne QR ved skranken: dine kunder scanner den for at tjekke, om deres element er tilgængeligt.",
"stg.qrTitle": "Kunde selvbetjening QR",
"stg.scanDesc": "Scan et elements etikette for at åbne dets register med det samme.",
"stg.scanQr": "Scan en QR",
"stg.scanTitle": "Scan en QR kode",
"stg.search": "Søg",
"stg.shelf": "Hylde {loc}",
"stg.shelfPlan": "Hyldeplan",
"stg.staleHint": "Ryd disse placeringer for at holde dit fysiske lager opdateret.",
"stg.staleTitle": "{n} element(er) har forladt opbevaringen, men har stadig en placering",
"stg.subtitle": "Hyldeplan, QR scanner og fysisk lageropfølgning.",
"stg.title": "Lager & QR",
"stt.acceptRate": "Acceptancesats",
"stt.accepted": "Accepteret",
"stt.activity30": "Aktivitet (sidste 30 dage)",
"stt.ai6mo": "Sidste 6 måneder · accepteret = automatisk match + bekræftet.",
"stt.aiEmpty": "Ingen AI matches over denne periode endnu.",
"stt.aiTitle": "AI matches — accepteret vs afvist",
"stt.auctionShort": "Auktion",
"stt.auctionedSold": "Auktioneret (solgt)",
"stt.authShort": "Myndigheder",
"stt.authorities": "Overdraget til myndighederne",
"stt.avgRating": "Gennemsnitlig bedømmelse",
"stt.awaitingRestitution": "elementer afventer returnering",
"stt.boostClicks": "Klik på din katalog i denne uge takket være boost",
"stt.boostInactive": "Boost inaktiv – aktiver det for at få synlighed",
"stt.certifiedPremium": "Premium certificeret",
"stt.declarations": "Erklæringer",
"stt.destroyed": "Ødelagt",
"stt.dispoEmpty": "Ingen uoverholdte elementer har forladt opbevaringen endnu.",
"stt.donatedAssoc": "Doneret (velgørenhed)",
"stt.donatedShort": "Doneret",
"stt.gateCta": "Udforsk planerne",
"stt.gateDesc": "Opgrader til Starter for at låse op for dine grundlæggende statistikker, eller til Business for avancerede statistikker og analyse pr. etablering.",
"stt.gateTitle": "Statistikker forbeholdt betalte planer",
"stt.inStorage": "I opbevaring",
"stt.kItems": "Registrerede elementer",
"stt.kRate": "Returneringssats",
"stt.kRestituted": "Returnerede elementer",
"stt.kRevenue": "Indkomst (måned)",
"stt.noDeclYet": "Ingen erklæringer endnu.",
"stt.recapDownloaded": "Resumé downloadet – klar til at dele!",
"stt.recapError": "Kan ikke generere resumeet",
"stt.recapText": "Vores Findloop {year} resumé: returnerede elementer og kundetilfredshed 🎉",
"stt.recapTitle": "Findloop {year} resumé",
"stt.rejected": "Afvist",
"stt.restitutions": "Returer",
"stt.shareRecap": "Del mit {year} resumé",
"stt.topCategories": "Mest erklærede kategorier",
"stt.unclaimedDesc": "Mængde af genstande, der er blevet ødelagt, doneret til velgørenhed og solgt på auktion, opdelt efter kategori.",
"stt.unclaimedTitle": "Ikke krævede genstande — forlader opbevaring",
"stt.vsLastWeek": "vs sidste uge",
"sub.cancel": "Annuller mit abonnement",
"sub.cancelAbort": "Annuller",
"sub.cancelConfirm1": "Er du sikker på, at du vil annullere? Din adgang forbliver aktiv indtil",
"sub.cancelConfirm2": "Der vil ikke blive udstedt nogen refundering.",
"sub.cancelConfirmBtn": "Bekræft annullering",
"sub.cancelTitle": "Annuller dit abonnement",
"sub.cancelledToast": "Annullering registreret.",
"sub.cguAnd": "og den",
"sub.cguDesc": "Bekræft venligst din accept inden betalingen.",
"sub.cguLink": "Brugsbetingelser",
"sub.cguPay": "Fortsæt til betaling",
"sub.cguPre": "Jeg har læst og accepterer",
"sub.cguRequired": "Du skal acceptere Brugsbetingelserne og Privatlivspolitikken for at fortsætte.",
"sub.cguSuffix": "fra findloop.",
"sub.cguTitle": "Afslut dit abonnement",
"sub.expiresOn": "Dit abonnement udløber den",
"sub.noProrata": "Ingen pro-rata refundering.",
"sub.privacyLink": "Privatlivspolitik",
"sub.renewsOn": "Dit abonnement fornyes den",
"sub.resume": "Genabonnér",
"sub.resumedToast": "Genabonnementsbekræftelse.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Business",
"tier.small": "Starter",
"tm.add": "Tilføj",
"tm.adminOpt": "Admin (fuld visning)",
"tm.chooseEst": "Vælg en virksomhed",
"tm.chooseEstPh": "Vælg en virksomhed",
"tm.copyFail": "Kopiering mislykkedes",
"tm.copyLink": "Kopier linket",
"tm.copyOk": "Invitationslink kopieret",
"tm.emailHint": "En invitations-e-mail vil blive sendt for at oprette adgangskoden.",
"tm.expiresOn": "udløber den {date}",
"tm.forEmail": " for {email}",
"tm.forbidden": "Teammesteradministration er forbeholdt kontoindehaveren.",
"tm.inviteCreated": "Invitation oprettet",
"tm.inviteDesc": "En invitations-e-mail giver teammedlemmet mulighed for at oprette deres adgangskode.",
"tm.invitePending": "Afventende invitation",
"tm.inviteResent": "Invitation sendt igen",
"tm.inviteSent": "Invitation sendt via e-mail",
"tm.inviteTitle": "Inviter et medlem",
"tm.invitedOn": "Inviteret den {date}",
"tm.linkExpired": "Linket er udløbet",
"tm.memberRemoved": "Medlem fjernet",
"tm.name": "Navn",
"tm.noMembers": "Ingen teammedlemmer endnu.",
"tm.resendTitle": "Send invitationen igen",
"tm.role": "Rolle",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Ejer",
"tm.roleStaff": "Personalet",
"tm.roleUpdated": "Rolle opdateret",
"tm.sendInvite": "Send invitationen",
"tm.sending": "Sender…",
"tm.staffOpt": "Personalet (ser kun deres virksomhed)",
"trk.at": "Ved",
"trk.badge": "Sporing",
"trk.carrier": "Selskab",
"trk.codeValidated": "Kode valideret af partneren",
"trk.dlProof": "Download mit bevis for aflevering (PDF)",
"trk.emailLabel": "Email (valgfrit - for at se dine oplysninger)",
"trk.enterEmailCode": "Indtast din email ovenfor for at vise din kravkode.",
"trk.idLabel": "Rapportnummer",
"trk.lostEmail": "Jeg har ikke længere adgang til min email",
"trk.phonePh": "Dit telefonnummer",
"trk.photoBefore": "Foto af varen før forsendelse",
"trk.recoverBtn": "Gendan min vare",
"trk.recoverHint": "Få din kravkode via SMS til dit registrerede nummer.",
"trk.searching": "Søger…",
"trk.secureRest": "Sikker aflevering",
"trk.send": "Send",
"trk.shipPending": "Forsendelse er under forberedelse - trackingnummeret vil vises her, når det er sendt.",
"trk.shipTitle": "Forsendelsessporing",
"trk.showQr": "Vis denne QR til partneren for at validere afleveringen",
"trk.sigSaved": "Underskrift gemt",
"trk.signFirst": "Venligst underskriv før bekræftelse.",
"trk.signProof": "Underskriv dit bevis for aflevering",
"trk.signSubmit": "Bekræft min underskrift og generer PDF'en",
"trk.submit": "Spor",
"trk.subtitle": "Indtast dit rapportnummer for at spore fremskridt.",
"trk.title": "Spor min rapport",
"trk.trackShipment": "Spor pakke",
"trk.trackingNo": "Trackingnummer",
"trk.yourCode": "Din kravkode (til at give til partneren)",
"a.firstName": "Fornavn",
"ac.emailCrossMatch": "B2C krydsmatch",
"ac.emailCrossMatchDesc": "En email når en offentlig mistet genstand annonce matcher en genstand deponeret på dine lokaler",
"ac.emailCrossReject": "Offentlige matchafvisninger",
"ac.emailCrossRejectDesc": "Modtag en email, når en kunde angiver, at et foreslået offentligt match ikke er deres genstand.",
"ac.emailLoginNotif": "Login notifikation",
"ac.emailLoginNotifDesc": "Modtag en email hver gang nogen logger ind på din konto.",
"ad.closeNoCancel": "Nej, fjern annoncen",
"ad.closeQuestion": "Blev genstanden returneret til dig?",
"ad.closeQuestionDesc": "Lad os vide, om du har genvundet din genstand, eller hvis du blot vil fjerne denne annonce.",
"ad.closeYesRestituted": "Ja, genstanden blev returneret",
"ad.closedRestituted": "Genstand returneret — annonce lukket 🎉",
"an.lostLoginDesc": "En konto er nødvendig for at rapportere en mistet genstand og følge dens returnering.",
"an.lostLoginRequired": "Log ind for at rapportere en mistet genstand",
"an.qfAll": "Alle",
"an.qfBoosted": "Fremhævet",
"an.qfPhoto": "Med foto",
"an.qfRecent": "Denne uge",
"an.qfResolved": "Løst",
"an.restitutionInProgress": "Genstand er ved at blive returneret",
"dec.descPhLong": "Beskriv genstanden: mærke, farve, særlige mærker… (Jo flere detaljer du giver, jo højere chancer har du for at genvinde din genstand)",
"dec.loadError": "Kan ikke indlæse partneren lige nu. Tjek din forbindelse og prøv igen.",
"dec.retry": "Prøv igen",
"dec.shippingMode": "Forsendelse",
"dep.photo2": "2. genstands foto",
"dep.photo2Hint": "Valgfri — en anden vinkel forbedrer den visuelle matchingsnøjagtighed.",
"dl.accountSuspended": "Konto suspenderet for en ubetalt faktura. Betal den for at genoprette din adgang.",
"dl.regularize": "Betal nu →",
"dl.suspensionCountdown": "Faktura {num} ubetalt — din konto vil blive suspenderet om {days} dag(e). Betal den for at undgå dette.",
"ft.cancelConfirm": "Afbestille din rapport? Genstandens ejer vil blive informeret.",
"ft.cancelDone": "Rapport afbestilt.",
"ft.cancelLocked": "Afbestilling er ikke længere muligt, efter ejeren har betalt.",
"ft.cancelReport": "Afbestil min rapport",
"ft.claimCodeHelp": "Giv denne kode til finder ved overdragelse for at bekræfte, at du har modtaget din genstand.",
"ft.claimCodeTitle": "Din restitutionskode",
"ft.claimDone": "Genstand returneret. Tak fordi du brugte Findloop!",
"ft.claimUnlockHint": "Lås op for finderens kontaktoplysninger",
"ft.claimUnlockHintSub": "Gå til \"Genstande jeg gør krav på\" i din konto for at betale gebyret og få kontaktoplysningerne.",
"ft.finderCodeShownHelp": "Ejeren har betalt og valgt dig. Kopiér denne kode nedenfor for at bekræfte returneringen — ingen grund til at tjekke din email.",
"ft.finderCodeShownTitle": "Ejerens valideringskode",
"ft.finderContactsTitle": "Finderens kontaktoplysninger",
"ft.foundCodeHelp": "Vis denne kode til ejeren ved overdragelsen for at bekræfte, at genstanden er blevet returneret.",
"ft.inProgressOther": "Genstand der returneres",
"ft.inProgressOtherHelp": "Ejeren valgte en anden finder til denne genstand. Ingen yderligere handling er nødvendig fra din side.",
"ft.restitutionCodeHelp": "Denne kode bekræfter overdragelsen af genstanden. Den er allerede forudfyldt nedenfor; valider den og luk sagen.",
"ft.restitutionCodeTitle": "Din restitutionskode",
"hc.14Digits": "14 cifre",
"hc.15DaysBeforeAnItem": "15 dage før en genstands lovmæssige frist.",
"hc.7DaysBeforeAnItem": "7 dage før en genstands lovmæssige frist.",
"hc.8CharactersMinimum": "Minimum 8 tegn.",
"hc.aClaimToValidate": "Et krav at validere",
"hc.aFindoAssistanceSessionIs": "En Findloop supportsession er i øjeblikket aktiv på din konto.",
"hc.aNewMatchHasBeen": "Et nyt match er fundet",
"hc.aUser": "En bruger",
"hc.aUserClaimsToBe": "En bruger påstår at være ejer. Tjek deres svar, før du godkender returneringen.",
"hc.aboutFindo": "Om Findloop",
"hc.accountActivatedPleaseLogIn": "Kontoen er aktiveret, log venligst ind.",
"hc.accountActivation": "Kontoadministration",
"hc.accountCreated": "Kontoen er oprettet!",
"hc.accountDeactivatedAReactivationEmail": "Kontoen er deaktiveret. En reaktiverings-e-mail (gyldig i 30 dage) er blevet sendt til dig.",
"hc.accountReactivation": "Konto-reaktivering",
"hc.activateMyAccount": "Aktiver min konto",
"hc.activateMyAdminAccount": "Aktiver min admin-konto",
"hc.activating": "Aktiverer…",
"hc.activeMatchCancelReason": "Aktivt match. Kundens afbestillingsårsag: \"{reason}\". Genstanden afventer stadig et krav.",
"hc.activeMatchWithAPublic": "Aktivt match med en offentlig (kunde) oplysning. Venter på ejerens krav.",
"hc.addAPhoto": "Tilføj et foto",
"hc.addAndConfigureYourEstablishments": "Tilføj og konfigurer dine institutioner i \"Institutioner\": kontaktoplysninger, kategori og fysisk opbevaring af genstande.",
"hc.addOnGoogle": "Tilføj på Google",
"hc.address": "Adresse",
"hc.addressSaved": "Adresse gemt",
"hc.addressStreet": "Adresse — Gade",
"hc.adjustThePhoto": "Justér fotoet",
"hc.adminFullView": "Admin (fuld visning)",
"hc.administratorOnly": "Kun administrator",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "AI visuel sammenligning",
"hc.all": "Alle",
"hc.amount": "Beløb",
"hc.anOrganization": "En organisation",
"hc.analyzing": "Analysere…",
"hc.andRecoveryIs": "og genopretning er",
"hc.andTheDeclarationWillBe": "og erklæringen vil blive afsluttet (flyttet til historik). Denne handling er endelig.",
"hc.annual20": "Årligt -20%",
"hc.annualBilling20": "Årlig fakturering (−20%)",
"hc.annualTarget": "Årligt mål",
"hc.anyCommentsOptional": "Eventuelle kommentarer? (valgfrit)",
"hc.approveTheClaim": "Godkend kravet",
"hc.archiveCancelledConfirm": "Arkivere {n} optegnelse(r) \"Afbrudt af kunden\"? De vil blive fjernet fra registret.",
"hc.asSoonAs": "Så snart",
"hc.askTheOwnerToDisplay": "Bed ejeren om at vise deres kodes QR (sporingsside).",
"hc.askThemAtTheCounter": "Spørg dem ved skranken for at bekræfte identitet — aldrig offentligt synligt.",
"hc.assistance": "Support",
"hc.assistanceSessionRevoked": "Supportsession annulleret.",
"hc.atLeast6Characters": "Mindst 6 tegn",
"hc.automaticallyPreSelected": "automatisk forudvalgt",
"hc.automaticallyWhenShipping": "automatisk ved forsendelse.",
"hc.awaitingClaim": "Venter på krav",
"hc.awaitingPayment": "Venter på betaling",
"hc.b2cCustomer": "B2C-kunde",
"hc.back": "Tilbage",
"hc.backToHome": "Tilbage til startside",
"hc.backToMyAccount": "Tilbage til min konto",
"hc.backToPayment": "Tilbage til betaling",
"hc.beforeAfterComparisonSlider": "Før/efter sammenligningsslider",
"hc.billingInformation": "Faktureringsoplysninger",
"hc.billingInformationSaved": "Faktureringsoplysninger gemt ✓",
"hc.brand": "Mærke",
"hc.bronze": "Bronze",
"hc.calculatingTheShippingRate": "Beregnings af forsendelsesprisen…",
"hc.cameraUnavailableEnterTheCode": "Kamera ikke tilgængeligt. Indtast koden manuelt.",
"hc.cancel": "Annuller",
"hc.cancelMyDeclaration": "Annuller min erklæring",
"hc.cancelSavedFmt": "Annullering gemt: \"{reason}\". Du kan stadig kræve.",
"hc.cancelTheDeposit": "Annullere depositummet",
"hc.cancelThisMatch": "Annuller denne kamp",
"hc.cancellationReason": "Årsag til annullering",
"hc.cancelled": "Annulleret",
"hc.cancelledByTheCustomer": "Annulleret af kunden",
"hc.cannotOpenPayment": "Kan ikke åbne betalingen. Prøv venligst igen.",
"hc.careers": "Karrierer",
"hc.carrier": "Transportør",
"hc.carrierAvailabilityCannotBeChecked": "Transportørens tilgængelighed kan ikke kontrolleres, indtil din Sendcloud afsender er konfigureret.",
"hc.carrierConfirmedCharged": "Transportør bekræftet — {price} € opkrævet fra kunden",
"hc.carrierOther": "Transportør (andet)",
"hc.carrierSelection": "Valg af transportør",
"hc.caseClosedThankYou": "Sagen er lukket. Tak!",
"hc.category": "Kategori",
"hc.changeMethod": "Ændr metode",
"hc.characteristic": "Egenskab",
"hc.chargedToCustomer": "opkrævet fra kunden.",
"hc.checkOrEditYourDetails": "Tjek eller rediger dine oplysninger før den sikre betaling.",
"hc.checkStatisticsToTrackDeposited": "Tjek \"Statistikker\" for at følge indleverede genstande, returprocent og ydelse for hver virksomhed.",
"hc.checkTheDetailsBeforeContacting": "Tjek oplysningerne før du kontakter finderen.",
"hc.checkTheDetailsBelowBefore": "Tjek oplysningerne nedenfor før du påbegynder din returforespørgsel.",
"hc.checkTheNewItem": "Tjek den nye genstand",
"hc.checkThePhotosAndCharacteristics": "Tjek billederne og egenskaberne nedenfor før du fortsætter med indsamlingen.",
"hc.chooseACountry": "Vælg et land",
"hc.chooseANewPassword": "Vælg et nyt kodeord",
"hc.chooseAReason": "Vælg en grund",
"hc.chooseTheLegalRetentionAlerts": "Vælg de juridiske opbevaringsunderretninger, der modtages via e-mail for",
"hc.chooseYourPasswordToAccess": "Vælg dit kodeord for at få adgang til administrationspanelet.",
"hc.city": "By",
"hc.claimApproved": "Krav godkendt",
"hc.claimApproved2": "Krav godkendt.",
"hc.claimCodeExpired": "Kravkode udløbet",
"hc.claimCodeVerified": "Kravkode verificeret",
"hc.claimNotFound": "Krav ikke fundet",
"hc.claimNotValidated": "Krav ikke valideret",
"hc.claimRejected": "Krav afvist",
"hc.claimRejected2": "Krav afvist.",
"hc.claimValidated": "Krav valideret",
"hc.claimValidatedByThePartner": "Krav valideret af partneren",
"hc.claimant": "Kravstiller",
"hc.claimsToBeTheOwner": "hævdar at være ejer af denne genstand og har besvaret verificeringsspørgsmålene. Godkend kun, hvis svarene matcher.",
"hc.claimsToValidate": "Krav der skal valideres",
"hc.clear": "Ryd",
"hc.clickToZoom": "Klik for at zoome",
"hc.close": "Luk",
"hc.close2": "Luk",
"hc.closeTheDeclaration": "Luk deklarationen",
"hc.closeTheDeclaration2": "Luk deklarationen?",
"hc.codeAlreadyVerified": "Kode allerede verificeret",
"hc.codeCopied": "Kode kopieret",
"hc.collapse": "Sammenklap",
"hc.color": "Farve",
"hc.company": "Virksomhed",
"hc.companyName": "Firmanavn",
"hc.comparePhotos": "Sammenlign fotos",
"hc.compareThemWithTheOwner": "Sammenlign dem med ejerens svar — aldrig offentligt synligt.",
"hc.condition": "Stand",
"hc.confirmAndPay": "Bekræft og betal",
"hc.confirmCancellation": "Bekræft aflysning",
"hc.confirmCrop": "Bekræft beskæring",
"hc.confirmDeletion": "Bekræft sletning",
"hc.confirmPassword": "Bekræft adgangskode",
"hc.confirmThatThisIsYour": "Bekræft at dette er din vare. En identitetskontrol vil blive anmodet fra finderen før nogen kontakt.",
"hc.confirmTheCarrier": "Bekræft transportøren",
"hc.confirmThePassword": "Bekræft adgangskoden",
"hc.confirmYourShippingAddressTo": "Bekræft din leveringsadresse for at fortsætte med betalingen.",
"hc.confirmYourSubscription": "Bekræft dit abonnement",
"hc.confirmed": "Bekræftet ✓",
"hc.contactFindoToGetYour": "Kontakt Findloop for at få dit Sender ID.",
"hc.contactUs": "Kontakt os",
"hc.continueTheReturn": "Fortsæt returneringen",
"hc.continueToPayment": "Fortsæt til betaling",
"hc.copy": "Kopiér",
"hc.correctMyDetails": "ret mine oplysninger",
"hc.correctThisEntry": "Ret denne post?",
"hc.country": "Land",
"hc.countryAddress": "Land (adresse)",
"hc.countryIsoCodeEG": "Land (ISO kode, f.eks. FR)",
"hc.cover": "cover",
"hc.createTheShipment": "Opret forsendelsen",
"hc.cropThePhoto": "Beskær fotoet",
"hc.customer": "Kunde",
"hc.customerClaimCodeToCheck": "Kunde kravkode — for at kontrollere ved afhentning:",
"hc.customerReasonFmt": "Kundens grund: \"{reason}\".",
"hc.customerReminderDelay": "Kundepåmindelse forsinkelse",
"hc.customerWhosePublicListingMatches": "Kunde hvis offentlige opslag matcher denne vare — kun synligt for dig.",
"hc.d15": "D-15",
"hc.dangerZone": "Farlig zone",
"hc.date": "Dato",
"hc.dateNewest": "Dato (nyeste)",
"hc.dateOldest": "Dato (ældste)",
"hc.daysToYearEnd": "{n} dage til årets slutning",
"hc.deadlineAlert": "Fristadvarsel",
"hc.declarationClosed": "Deklaration lukket ✓",
"hc.declarationNotFound": "Deklaration ikke fundet.",
"hc.declarationNotFound2": "Deklaration ikke fundet",
"hc.declarationTracking": "Deklaration sporing",
"hc.defaultCarrier": "Standard transportør",
"hc.defaultCarrierPreselected": "Standard transportør forudvalgt — kan ændres for denne forsendelse. Aktuel sats (Sendcloud + {m}% margin).",
"hc.defaultCarrierRemoved": "Standard transportør fjernet",
"hc.delayHours": "Forsinkelse (timer)",
"hc.deleteMyAccount": "Slet min konto",
"hc.deleting": "Sletter…",
"hc.deletingDeactivatesYourAccountLogin": "Sletning deaktiverer din konto: login er blokeret, og data opbevares i 30 dage. Du vil modtage en e-mail med et reaktiveringslink gyldigt i 30 dage.",
"hc.delivered": "Leveret",
"hc.depositAnItem": "Indbetal en vare",
"hc.depositCancelledItemPutBack": "Indbetaling annulleret — vare sat tilbage på lager.",
"hc.depositCancelledItemRemovedFrom": "Indbetaling annulleret — vare fjernet fra registreringen.",
"hc.depositedOn": "Indbetalt den",
"hc.describeTheItemBrandColor": "Beskriv varen: mærke, farve, kendetegn… (Jo flere oplysninger du giver, desto bedre chancer for at finde din vare)",
"hc.dimensionsCm": "Dimensioner (cm)",
"hc.disablingAnEmail": "Deaktivering af en e-mail",
"hc.doesNotHide": "skjuler ikke",
"hc.download": "Download",
"hc.downloadThePdf": "Download PDF'en",
"hc.draftRestoredPickUpYour": "Udkast gendannet — hent din deklaration, hvor du stoppede.",
"hc.dragToReposition": "Træk for at omplacere",
"hc.eGColisPriv": "F.eks. Colis Privé",
"hc.eachItemGetsAQr": "Hver vare får en QR-etiket. Scan den fra \"Lager & QR\" for straks at finde en vare.",
"hc.eachSiteManagesItsOwn": "Hver side håndterer sin egen bank. Gå til",
"hc.edit": "Rediger",
"hc.emailNotificationPreferences": "E-mail underretning præferencer",
"hc.emailPreferencesUpdated": "E-mail præferencer opdateret",
"hc.enableOrDisableRecoveryFees": "Aktiver eller deaktiver gebyrer for genopretning for",
"hc.enlargePhoto": "Forstør foto",
"hc.enterTheCustomerSCode": "Indtast kundens kode",
"hc.estShipRate": "Estimeret forsendelsespris (Sendcloud + {m}% margin):",
"hc.establishment": "Etablering",
"hc.establishment2": "Etablering:",
"hc.establishmentInItsSendcloudAccount": "etablering i din Sendcloud-konto og giver dig afsender-ID'et",
"hc.establishmentSettings": "Etableringsindstillinger",
"hc.exCode": "f.eks. ABCD2345",
"hc.exId": "f.eks. 3f2a…",
"hc.exit": "Forlad",
"hc.explainWhyThisItemIs": "Forklar hvorfor dette objekt ikke er dit…",
"hc.externalPaymentLinks": "Eksterne betalingslinks",
"hc.failed": "Mislykket",
"hc.feesEnabled": "Gebyrer aktiveret",
"hc.field": ") felt.",
"hc.finderAcceptedCloseTheCase": "Finder accepteret — luk sagen, når objektet er blevet overdraget personligt.",
"hc.findoCityRanking": "Findloop — By rangordning",
"hc.findoForEstablishments": "Findloop for etableringer",
"hc.findoPresentationVideo": "Findloop præsentationsvideo",
"hc.findoRegistersTheAddressOf": "Findloop registrerer adressen på din",
"hc.findoReviewShare": "Findloop {year} anmeldelse: {n} genstande returneret, {rate}% tilbagebetalingsrate 🎉",
"hc.firstVerifyTheClaimCode": "Først bekræft kravkoden ovenfor",
"hc.forEveryNewShipmentFrom": "for hver ny forsendelse fra",
"hc.free": "gratis",
"hc.freeRecovery0": "Gratis genopretning (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Gratis genopretning i hele Afrika – Introduktionstilbud",
"hc.freeRecoveryFeesDisabled0": "Gratis genopretning: gebyrer deaktiveret (0 €)",
"hc.fromTeamInviteYourColleagues": "Fra \"Team\", inviter dine kolleger via email og tildel dem en etablering. Hvert medlem ser kun deres eget omfang.",
"hc.fullName": "Fulde navn",
"hc.fullPhoto": "Fuldt billede",
"hc.gallery": "Galleri",
"hc.giveTheReasonForCancelling": "Angiv årsagen til annullering. Partneren vil blive informeret.",
"hc.goToLogin": "Gå til login",
"hc.goToMyAccount": "Gå til min konto",
"hc.gold": "Guld",
"hc.googleLoginFailed": "Google login mislykkedes",
"hc.hasConfirmedYourPaymentYou": "har bekræftet din betaling, du vil blive omdirigeret automatisk",
"hc.helpCenter": "Hjælp center",
"hc.helpUsImproveWhyAre": "Hjælp os med at forbedre: hvorfor forlader du? Din konto vil blive deaktiveret og kan genaktiveres i 30 dage.",
"hc.hidePassword": "Skjul adgangskode",
"hc.high": "Høj",
"hc.historyOfYourMonthlySubscriptions": "Historik for dine månedlige abonnementer og deres betalingsstatus.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Hvordan sætter jeg min numeriske afsender-ID op?",
"hc.iDonTUseIt": "Jeg bruger det ikke nok",
"hc.iFoundItElsewhere": "Jeg fandt det et andet sted",
"hc.iNoLongerNeedMy": "Jeg har ikke længere brug for min genstand",
"hc.identityVerification": "Identitetsbekræftelse",
"hc.idleLogoutIn": "Du vil blive logget ud om {n} sekunder på grund af inaktivitet.",
"hc.ifProvidedTheVolumetricWeight": "Hvis angivet, anvendes den volumetriske vægt.",
"hc.ifThePartnerHasNot": "Hvis partneren ikke har bekræftet modtagelsen af den eksterne betaling efter denne forsinkelse, minder Findloop automatisk partneren om at validere den.",
"hc.impersonationEnded": "Identitetsforfalskning afsluttet.",
"hc.impersonationMode": "Identitetsforfalskningsmode",
"hc.impersonationSessionExpired": "Session for identitetsforfalskning er udløbet.",
"hc.inTheField": ", i marken",
"hc.inTransit": "Under transport",
"hc.inclVat": "incl. moms",
"hc.intraEuVatNumberOptional": "Intra-EU momsnummer valgfrit, intet SIRET kræves (uden for Frankrig).",
"hc.invalidInvitationLink": "Ugyldig invitationslink.",
"hc.invalidInvitationLink2": "Ugyldig invitationslink",
"hc.invalidInviteLink": "Ugyldig eller udløbet invitationslink.",
"hc.invalidNumberEnterAnInternational": "Ugyldigt nummer. Indtast et internationalt nummer f.eks. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Ugyldig eller udløbet link.",
"hc.invalidOrExpiredReactivationLink": "Ugyldig eller udløbet reaktiveringslink",
"hc.invalidSendcloudId": "Ugyldigt Sendcloud ID",
"hc.inviteSubtitle": "{org} inviterer dig til at blive en del af deres Findloop team. Vælg dit kodeord for at aktivere din konto.",
"hc.isAvailableOnSendcloudFor": "er tilgængelig på Sendcloud for alle dine ruter (nationalt + internationalt).",
"hc.isNotEnabledOnYour": "er ikke aktiveret på din Sendcloud-konto for nogle destinationer. Etiketter for disse vil blive genereret med en anden tilgængelig transportør.",
"hc.isThisReallyYourItem": "Er dette virkelig din genstand?",
"hc.isThisYourItem": "Er dette din genstand?",
"hc.item": "Genstand",
"hc.itemAlreadyConfirmed": "Genstand allerede bekræftet",
"hc.itemDetails": "Genstandsdetaljer",
"hc.itemFoundAt": "Genstand fundet ved",
"hc.itemFoundAtAPartner": "Genstand fundet hos en partner",
"hc.itemMarkedAsReturned": "Genstand markeret som returneret ✓",
"hc.itemPhotoRequiredBeforeShipping": "Genstandsbillede (påkrævet før afsendelse)",
"hc.itemPhotoSaved": "Genstandsbillede gemt",
"hc.itemPreview": "Genstandsvisning",
"hc.itemPutBackInStorage": "Genstand lagt tilbage i lager.",
"hc.itemWeight": "Genstands vægt:",
"hc.itemsReturned": "genstand(e) returneret",
"hc.itemsReturnedThisYear": "genstande returneret i år",
"hc.itemsWhoseLegalDeadlineIs": "Genstande hvis juridiske deadline er 15 dage væk eller mindre (overdue inkluderet). Matches forbliver synlige.",
"hc.kbisNumber": "Kbis nummer",
"hc.keysForgottenOnABench": "Nøgler glemt på en bænk",
"hc.labelBeingGenerated": "Etikette genereres",
"hc.leaveTheFieldsEmptyTo": "Lad felterne stå tomme for at tilbyde gratis genfinding.",
"hc.legalNotice": "Juridisk meddelelse",
"hc.limitReachedUpgradeToA": "Grænse nået — opgrader til en højere plan",
"hc.linkCopiedShareOn": "Link kopieret — del det på {label}",
"hc.linkUnavailable": "Link utilgængelig",
"hc.linkedTo": "Forbundet til",
"hc.listingHiddenByModeration": "Opgørelse skjult af moderation.",
"hc.loading": "Indlæser…",
"hc.locateMe": "Find mig",
"hc.logIn": "Log ind",
"hc.logInToGetBack": "Log ind for at komme tilbage til dit område og administrere dit abonnement.",
"hc.loginFailed": "Login mislykkedes",
"hc.lostFoundPlatform": "Tabt & fundet platform.",
"hc.lostIn": "tabet i",
"hc.lowRate": "Lav sats",
"hc.mainReason": "Hovedårsag",
"hc.mainStreet": "Hovedgade",
"hc.makeSureThisIsThe": "Sørg for, at dette er genstanden, du har mistet, før du låser op for finderens kontaktoplysninger.",
"hc.manageCookies": "Administrer cookies",
"hc.manageMyTeam": "Administrer mit team",
"hc.manageYourTeam": "Administrer dit team",
"hc.markAsReturned": "Marker som returneret",
"hc.matchNoClaimInTime": "Matchen modtog ingen krav inden fristen.",
"hc.matchNotFound": "Match ikke fundet",
"hc.medium": "Medium",
"hc.milestoneFmt": "{m} returnerede genstande milepæl nået! På vej til {next}.",
"hc.missingFeatures": "Manglende funktioner",
"hc.monthly": "Månedligt",
"hc.monthlyBilling": "Månedlig fakturering",
"hc.moveThePhotoToFit": "Flyt billedet for at passe det ind i cirklen.",
"hc.myAccount": "Min konto",
"hc.myInvoices": "Mine fakturaer",
"hc.myMonthlyInvoices": "Mine månedlige fakturaer",
"hc.nArchived": "{n} optegnelse(r) arkiveret.",
"hc.newCodeGeneratedAndSent": "Ny kode genereret og sendt til kunden via e-mail og SMS",
"hc.newCodeGeneratedAndSent2": "Ny kode genereret og sendt til ejeren",
"hc.newPassword": "Ny adgangskode",
"hc.next": "Næste",
"hc.nextPhoto": "Næste foto",
"hc.no": "Nej",
"hc.noAnswerProvided": "Ingen svar givet.",
"hc.noArchivedDeclarations": "Ingen arkiverede erklæringer",
"hc.noCountryFound": "Ingen land fundet",
"hc.noDeclarations": "Ingen erklæringer",
"hc.noFeesAreChargedTo": "Ingen gebyrer pålægges kunden.",
"hc.noInvoiceYet": "Ingen faktura endnu.",
"hc.noInvoiceYetYourInvoices": "Ingen faktura endnu. Dine fakturaer vises her automatisk efter hver betaling.",
"hc.noMatchIsAvailableFor": "Ingen match er tilgængelig lige nu. Vi giver besked, så snart en vare matcher din erklæring.",
"hc.noShipmentMatchesYourSearch": "Ingen forsendelse matcher din søgning.",
"hc.noShipmentsYet": "Ingen forsendelser endnu.",
"hc.noShipmentsYet2": "Ingen forsendelser endnu",
"hc.none": "ingen",
"hc.noneChooseForEachShipment": "Ingen (vælg for hver forsendelse)",
"hc.notMine": "Det er ikke min",
"hc.of": "af",
"hc.only": "Kun",
"hc.onlyEachSiteManagesIts": "kun. Hvert site håndterer sin egen bank: disse links påvirker ikke nogen anden virksomhed.",
"hc.onlyTheOwnerOrAn": "Kun ejeren eller en administrator kan konfigurere virksomhedens betalingslinks.",
"hc.openDepositInTheMenu": "Åbn \"Indbetaling\" i menuen, beskriv varen og tag et foto. Det gemmes straks og er klar til at blive returneret.",
"hc.openSettings": "Åbn Indstillinger →",
"hc.openTheDeclarationToManage": "Åbn erklæringen for at administrere forsendelsen",
"hc.optional": "— valgfri",
"hc.optional2": "(valgfri)",
"hc.optional3": "valgfri",
"hc.originalListingPhotoUsed": "Originalt listingsfoto brugt",
"hc.other": "Andet",
"hc.other2": "Andet…",
"hc.ourProducts": "Vores produkter",
"hc.overallRateTrendLast6": "Overordnet pristrend (sidste 6 måneder)",
"hc.ownerSClaimCode": "Ejerens kravkode",
"hc.ownershipConfirmed": "Ejerskab bekræftet",
"hc.paid": "Betalt",
"hc.paidOn": "Betalt den",
"hc.paidViaPartner": "Betalt (via partner)",
"hc.parcelBeingPrepared": "Pakke under forberedelse",
"hc.parcelDelivered": "Pakke leveret",
"hc.parcelShipped": "Pakke sendt",
"hc.parisGareDeLyon": "Paris, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Partnerkatalog",
"hc.passedOnToTheCustomer": "— sendt videre til kunden betalingslink.",
"hc.password": "Adgangskode",
"hc.passwordResetPleaseLogIn": "Adgangskode nulstillet, log venligst ind.",
"hc.passwordUpdated": "Adgangskode opdateret.",
"hc.passwordsDoNotMatch": "Adgangskoderne matcher ikke.",
"hc.pasteThisSenderIdIn": "Indsæt denne afsender-ID i Findloop → Indstillinger",
"hc.payForTheShipmentOf": "Betal for forsendelsen af dit emne gennem Findloop med en sikker betaling.",
"hc.payTheRecoveryFees": "Betal omkostningerne ved genindhentning",
"hc.payTheShippingFees": "Betal forsendelsesomkostningerne",
"hc.payment": "Betaling",
"hc.paymentAlreadyConfirmedByThe": "Betaling allerede bekræftet af partneren",
"hc.paymentLinksAreNowConfigured": "Betalingslinks er nu konfigureret pr. virksomhed",
"hc.paymentNotCompletedYourAccount": "Betaling ikke gennemført, din konto er ikke oprettet — prøv venligst igen.",
"hc.paymentReceived": "Betaling modtaget",
"hc.paymentSuccessful": "Betaling gennemført!",
"hc.pdfInvoice": "PDF-faktura",
"hc.pending": "Afventende",
"hc.period": "Periode",
"hc.phoneNumber": "Telefonnummer",
"hc.phoneOptional": "Telefon (valgfri)",
"hc.planAt": "plan på",
"hc.planLimitFmt": "Dit \"{plan}\" abonnement er begrænset til {max} virksomheder. For at administrere {n} steder, anbefaler vi",
"hc.platformReturnTarget": "Platformens returmål",
"hc.pleaseCompleteYourShippingAddress": "Venligst udfyld din leveringsadresse.",
"hc.pleaseProvideAPhoneNumber": "Venligst oplys et telefonnummer: det er nødvendigt for transportøren til forsendelse.",
"hc.pleaseProvideAReason": "Venligst angiv en grund.",
"hc.pleaseSetYourOwnPassword": "venligst indstil din egen adgangskode, før du fortsætter.",
"hc.pointsToGoal": "{n} flere point for at nå vores fælles mål.",
"hc.posterPreview": "Plakat forhåndsvisning",
"hc.potentialMatchBeingVerified": "Potentiel match bliver verificeret",
"hc.potentialOwner": "Potentiel ejer",
"hc.preFilledAutomaticallyYouCan": "Forudfyldt automatisk — du kan erstatte det med et billede af pakken.",
"hc.pressKit": "Pressekit",
"hc.previewMode": "Forhåndsvisningstilstand:",
"hc.previewOfThePrintReady": "Forhåndsvisning af den trykklar A4-plakat for denne virksomhed.",
"hc.previous": "Forrige",
"hc.previousPhoto": "Forrige foto",
"hc.primary": "primær",
"hc.printThePoster": "Print plakaten",
"hc.privacy": "Privatliv",
"hc.privacyPolicy": "Privatlivspolitik",
"hc.processedCasesWillAppearHere": "Behandlede sager vil vises her.",
"hc.proofOfReturnPdf": "Bevis for returnering (PDF)",
"hc.protectedByRecaptcha": "Beskyttet af reCAPTCHA",
"hc.publicMatch": "Offentligt match",
"hc.putBackInStorage": "Læg tilbage i opbevaring",
"hc.pwdResetByTeam": "Din adgangskode blev nulstillet af vores team. For din sikkerhed,",
"hc.questionsToAskTheOwner": "Spørgsmål til ejer",
"hc.rateChargedToTheCustomer": "Gebyr opkrævet til kunden:",
"hc.rateOfTarget": "{rate}% opnået ud af et {target}% mål",
"hc.reached": "nået",
"hc.reactivating": "Genaktiverer…",
"hc.reasonSavedYouCanStill": "Årsag gemt. Du kan stadig kræve din genstand.",
"hc.recentMatchesFirst": "Seneste matcher først",
"hc.recognizedThePhotoYouSent": "genkendte det foto, du sendte, og beskrev disse karakteristika. Bekræft kun, hvis de matcher den genstand, du har.",
"hc.recommended": "Anbefalet",
"hc.recoveryFees": "Hentningsgebyrer",
"hc.recoveryFeesArePaidDirectly": "Hentningsgebyrer betales direkte til partneretableringen. Findloop modtager ingen betaling fra kunder.",
"hc.recoveryFeesEnabled": "Hentningsgebyrer aktiveret",
"hc.recoveryOfferedByTheEstablishment": "Hentning tilbudt af virksomheden — Findloop opkræver ingen gebyrer.",
"hc.recoveryPaymentLink": "Link til hentningsbetaling",
"hc.recoveryPaymentLinkSavedFor": "Link til hentningsbetaling gemt for denne virksomhed",
"hc.redirecting": "Omdirigerer…",
"hc.redirectingToPayment": "Omdirigerer til betaling…",
"hc.redirectingToTheRecoveryOf": "Omdirigerer til hentningen af din genstand…",
"hc.regenerateAndResendToThe": "Regenerer og gensend til ejeren",
"hc.regenerateTheCode": "Regenerer koden",
"hc.registerAFoundItem": "Registrer en fundet genstand",
"hc.rejectTheClaim": "Afvis kravet",
"hc.reminderDelaySaved": "Påmindelsesforskydning gemt",
"hc.reopenThePaymentLink": "Genåbn betalingslinket",
"hc.repeatThePassword": "Gentag adgangskoden",
"hc.reportAProblem": "Rapporter et problem",
"hc.reportDismissedYourListingRemains": "Rapport afvist. Din annonce forbliver offentlig.",
"hc.requiredUsedToCalculateThe": "Påkrævet: bruges til at beregne Sendcloud fragtprisen. Fragt ikke tilgængelig over 30 kg.",
"hc.reset": "Nulstil",
"hc.resume": "Genoptag",
"hc.resumeRegistration": "Genoptag registrering",
"hc.retro": "Året i gennemgang",
"hc.returnSecurity": "Returnér sikkerhed",
"hc.returnToTheOwner": "Returnér til ejeren",
"hc.returned": "returneret",
"hc.reviewTheItemDetails": "Gennemgå vareoplysningerne",
"hc.revokeAccess": "Tilbagetræk adgang",
"hc.role": "Rolle:",
"hc.save": "Gem",
"hc.save2": "gem",
"hc.saveAndContinue": "Gem og fortsæt",
"hc.saving": "Gemmer…",
"hc.scanTheClaimCode": "Scan kravkoden",
"hc.scanTheOwnerSQr": "Scan ejerens QR",
"hc.scrollThroughLanguages": "Rul gennem sprog",
"hc.searchByCustomerItemOr": "Søg efter kunde, vare eller tracking nummer…",
"hc.searchForACountry": "Søg efter et land…",
"hc.secureFindoVerification": "Sikker findloop-verifikation",
"hc.seeRetro": "Se året i gennemgang",
"hc.selectedCarrier": "Valgt transportør:",
"hc.selectedPlan": "Valgt plan",
"hc.send": "Send",
"hc.sendcloudSenderIdSaved": "Sendcloud afsender ID gemt",
"hc.sendcloudSenderIdSenderId": "Sendcloud afsender ID (sender_id)",
"hc.sending": "Sender…",
"hc.sessionExpired": "Session udløbet",
"hc.setUpYourEstablishments": "Opsæt dine etableringer",
"hc.settings": "Indstillinger",
"hc.settingsSubtitle": "Eksterne betalinger og påmindelser, konfigureret pr. etablering.",
"hc.shareFoundText": "Jeg har fundet en genstand — hjælp mig med at finde ejeren på Findloop",
"hc.shareLostText": "Jeg har mistet en genstand — hjælp mig med at finde den på Findloop",
"hc.sharePreview": "Del preview",
"hc.shareTheRanking": "Del rangeringen",
"hc.shareYourQrCodeTo": "Del din QR-kode for at modtage erklæringer.",
"hc.shipRateAutoWeight": "Fragtprisen beregnes automatisk via Sendcloud (vægt {w}) på tidspunktet for forsendelse.",
"hc.shipRateForWeight": "Fragtomkostninger (Sendcloud + {m}% margin) for {w}:",
"hc.shipments": "Forsendelser",
"hc.shipmentsSubtitle": "Konsolideret visning af alle virksomhedens forsendelser på tværs af alle sager. Klik på en række for at administrere forsendelsen i dens deklaration.",
"hc.shipping": "Forsendelse",
"hc.shippingAddress": "Forsendelsesadresse",
"hc.shippingFeesAreHandledAutomatically": "Forsendelsesomkostninger håndteres automatisk af Findloop (Sendcloud) - ingen link at indtaste.",
"hc.shippingFeesHaveAlreadyBeen": "Forsendelsesomkostninger er allerede betalt: transportøren kan ikke længere ændres.",
"hc.shippingNotAvailableForItems": "Forsendelse ikke tilgængelig for varer over 30 kg. Kunden skal hente varen personligt.",
"hc.shippingPaid": "Forsendelse betalt ✓",
"hc.showOnlyItemsMatchingA": "Vis kun varer der matcher en offentlig (kunde) liste",
"hc.showPassword": "Vis kodeord",
"hc.signInTheBoxAbove": "Log ind i boksen ovenfor",
"hc.signatureSaved": "Underskrift gemt",
"hc.signedInWithGoogle": "Logget ind med Google",
"hc.signupFailed": "Tilmelding mislykkedes",
"hc.silver": "Sølv",
"hc.simulatedRatesInPreProduction": "(simulerede priser i præ-produktion)",
"hc.siretAndVatNumberRequired": "SIRET og momsnummer krævet (Frankrig).",
"hc.skip": "Spring over",
"hc.smsSentIfAccount": "Hvis der findes en konto med dette nummer, er der sendt en SMS til dig.",
"hc.sortItemsWithAPublic": "Sortér: varer med et offentligt match (seneste) først",
"hc.specifyWhetherYouRecoveredYour": "Angiv om du har genvundet din vare eller bare ønsker at fjerne denne liste.",
"hc.specifyYourReason": "Angiv din grund",
"hc.specifyYourReason2": "Angiv din grund…",
"hc.staff": "Personale",
"hc.status": "Status",
"hc.staySignedIn": "Bliv logget ind",
"hc.step": "Trin",
"hc.stillThere": "Er du stadig der?",
"hc.stopScrolling": "Stop med at rulle",
"hc.storeFindWithQr": "Gem & find med QR",
"hc.streetName": "Vejnavn",
"hc.streetNo": "Vej nr.",
"hc.switchTo": "Skift til",
"hc.switchToDarkMode": "Skift til mørk tilstand",
"hc.switchToLightMode": "Skift til lys tilstand",
"hc.takeAPhoto": "Tag et billede",
"hc.takeChangeThePhoto": "Tag / ændr billedet",
"hc.takenFromYourDeclaration": "taget fra din deklaration",
"hc.target": "Mål",
"hc.targetReached": "Mål nået",
"hc.targetReachedThankYouTo": "Mål nået - tak til hele Findloop fællesskabet!",
"hc.tellUsMore": "Fortæl os mere…",
"hc.tellUsWhyYouCancel": "Fortæl os, hvorfor du annullerer. Dette hjælper partneren med at behandle din anmodning.",
"hc.tellUsWhyYourListing": "Fortæl os hvorfor. Din opføring forbliver aktiv, og du kan stadig gøre krav på din genstand.",
"hc.termsAndConditions": "Vilkår og betingelser",
"hc.termsAndPolicies": "Vilkår og politikker",
"hc.thankYouForYourFeedback": "Tak for din feedback",
"hc.theBannerDisplayedInThe": "banneret vist i registret.",
"hc.theClaimantHasBeenInformed": "Kræveren er blevet informeret. Genstanden forbliver tilgængelig i den offentlige opføring.",
"hc.theClaimantHasBeenNotified": "Kræveren er blevet underrettet og kan nu fortsætte med returneringen.",
"hc.theCustomerPaysTheFees": "Kunden betaler gebyrerne til etableringen.",
"hc.theDayTheLegalRetention": "Den dag den lovpligtige opbevaringsperiode er nået.",
"hc.theEstablishmentConsideredThatThis": "Etableringen mente, at denne genstand ikke tilhører dig.",
"hc.theEstablishmentIsReviewingYour": "Etableringen gennemgår dine svar. Du vil blive underrettet, så snart dit krav er valideret, og du kan betale genvindingsgebyrerne.",
"hc.theFeesAreTooHigh": "Gebyrerne er for høje",
"hc.theFinderConsideredThatThis": "Finder mente, at denne genstand ikke tilhører dig.",
"hc.theFinderIsReviewingYour": "Finder gennemgår dit krav. Du vil blive underrettet, så snart det er valideret.",
"hc.theItem": "Genstanden",
"hc.theItemWillBeRemoved": "Genstanden vil blive fjernet fra registret (intet krav under behandling).",
"hc.theItemWillBeSet": "Genstanden vil blive sat tilbage til \"på lager\" og det relaterede krav annulleres.",
"hc.theKbisNumberAndVat": "Kbis nummeret og momsnummeret er påkrævet for Frankrig.",
"hc.theLabelIsGeneratedAutomatically": "Labelen genereres automatisk, så snart kunden har betalt fraktgebyrerne. Den kan hentes her.",
"hc.theLinkMayHaveExpired": "Vinklen kan være udløbet (gyldig i 30 dage). Kontakt Findloop support hvis nødvendigt.",
"hc.theOwnerDescribesTheirItem": "Ejeren beskriver deres genstand",
"hc.theOwnerReceivedItBy": "Ejeren modtog det via e-mail (eller SMS). Indtast eller scan det før overdragelsen.",
"hc.thePartnerConsideredThatThis": "Partneren mente, at denne genstand ikke tilhører dig. Genstanden forbliver tilgængelig.",
"hc.thePartnerIsReviewingYour": "Partneren gennemgår dine svar. Du vil blive underrettet, så snart dit krav er valideret.",
"hc.theShipmentIsCreatedAutomatically": "Forsendelsen oprettes automatisk, når kunden har bekræftet deres adresse og betalt genvindingsgebyrerne. Labelen vil derefter blive genereret automatisk efter fraktbetalingen og kan hentes her.",
"hc.theShippingRateWillBe": "Fraktprisen vil blive beregnet automatisk via Sendcloud på tidspunktet for forsendelsen (registreret vægt).",
"hc.thisCarrierWillBe": "Denne transportør vil være",
"hc.thisEstablishment": "denne etablering",
"hc.thisFieldIsRequiredFor": "Dette felt er påkrævet for automatisk labelgenerering.",
"hc.thisIsMyItem": "Dette er min genstand",
"hc.thisIsMyItemContinue": "Dette er min genstand - fortsæt",
"hc.thisIsMyItemStart": "Dette er min genstand - start returneringen",
"hc.thisIsNotMyItem": "Dette er ikke min genstand",
"hc.thisMatchIsNoLonger": "Dette match er ikke længere tilgængeligt eller er allerede blevet behandlet.",
"hc.thisRateWillBeCharged": "Denne sats vil blive opkrævet kunden. En høj sats kan afskrække genvinding.",
"hc.thisStepIsRequiredFor": "Dette trin er påkrævet for at generere fraktlabels.",
"hc.thisValidationLinkIsInvalid": "Dette valideringslink er ugyldigt eller er udløbet.",
"hc.toCheckBeforeMarkingThe": "For at tjekke før du markerer varen som returneret.",
"hc.toConfigureTheLinksAnd": "for at konfigurere linksene og påmindelsesforsinkelsen for hver establishment.",
"hc.toReachOurFirstMilestone": "for at nå vores første milepæl på 100 returneringer.",
"hc.toTheCustomer": "til kunden.",
"hc.toTheShippingFeePayment": "til betalingen af forsendelsesgebyret.",
"hc.toYourRecoveryTracking": "til din genindvindingssporing.",
"hc.tooExpensiveBudget": "For dyrt / budget",
"hc.topCitiesForReturns": "Topbyer for returneringer",
"hc.trackMyRecovery": "Spor min genindvinding",
"hc.trackTheShipmentAndDownload": "Spor forsendelsen og download etiketten (genereret automatisk) uden at forlade fanen for deklarationer.",
"hc.trackYourStatistics": "Spor dine statistikker",
"hc.tracking": "Sporing",
"hc.unableToOpenTheShipping": "Kan ikke åbne betalingen af forsendelsesgebyret. Prøv venligst igen.",
"hc.unableToRetrieveTheInvoice": "Kan ikke hente fakturaen.",
"hc.unclaimed": "Uden krav",
"hc.unclaimedCustomerReason": "Uden krav. Kundens årsag: \"{reason}\".",
"hc.unclaimedItem": "Uden krav vare",
"hc.unclaimedItemNoClaimWithin": "Uden krav vare — intet krav inden for fristen.",
"hc.unclaimedItems": "Uden krav varer",
"hc.unclaimedItemsMatchLeftWithout": "Uden krav varer: match tilbage uden et krav inden fristen. Du kan lægge dem tilbage i opbevaring.",
"hc.unlockTheFinderSContact": "Lås op for finderens kontaktoplysninger for at arrangere overdragelsen.",
"hc.upcoming": "Kommende",
"hc.updateFailed": "Opdatering mislykkedes.",
"hc.usedForInvoices": "Brugt til at udstede dine findloop-fakturaer.",
"hc.vatNumber": "Momsnummer",
"hc.verificationPending": "Verifikation afventer",
"hc.verificationSentToTheFinder": "Verifikation sendt til finder. Du vil blive underrettet om deres beslutning.",
"hc.verificationSentToThePartner": "Verifikation sendt til partner. Du vil blive underrettet om deres beslutning.",
"hc.verify": "Verificer",
"hc.verifyingInvite": "Verificerer invitationens link…",
"hc.verifyingTheLink": "Verificerer linket…",
"hc.viewInRegistry": "Vis i registret",
"hc.viewItem": "Vis vare",
"hc.viewItemRecover": "Vis vare & genvind",
"hc.visibleToTheOwnerAutomatically": "Synlig for ejeren · automatisk slettet efter 60 dage.",
"hc.waitingForPartnerConfirmation": "Venter på partnerbekræftelse",
"hc.waitingForThePartnerS": "Venter på partnerens bekræftelse",
"hc.weHaveInformedTheEstablishment": "Vi har informeret establishmentet om, at denne vare ikke er din og genstartet analysen. Du vil blive underrettet, så snart et nyt match findes.",
"hc.weHaveInformedThePartner": "Vi har informeret partneren om, at denne vare ikke er din. Din oplysning forbliver aktiv for fremtidige match.",
"hc.weRanTheAnalysisAgain": "Vi har analyseret igen og identificeret en anden genstand, der kunne være din. Tjek venligst igen.",
"hc.weight": "Vægt",
"hc.weightNotProvidedTheShipping": "Vægt ikke angivet: fragtomkostningerne beregnes på tidspunktet for forsendelse.",
"hc.weightUnit": "Vægtenhed",
"hc.welcome": "Velkommen!",
"hc.welcomeToFindo": "Velkommen til Findloop",
"hc.whenACustomerComesTo": "Når en kunde kommer for at hente deres ejendele, åbner du deres erklæring og validerer returneringen. Det er det!",
"hc.whenDisabledFeesDropTo": ". Når deaktiveret, falder gebyrerne til",
"hc.whyIsThisNotYour": "Hvorfor er dette ikke din genstand?",
"hc.willBeMarkedAs": "vil blive markeret som",
"hc.wrongColor": "Forkert farve",
"hc.wrongModel": "Forkert model",
"hc.yesCancel": "Ja, annuller",
"hc.yesContactTheFinder": "Ja, kontakt finder",
"hc.youAreHere": "Du er her",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Du kan nu starte returneringen.",
"hc.youCanStillChangeIt": ". Du kan stadig ændre det fra sag til sag.",
"hc.youHaveAlreadyConfirmedThat": "Du har allerede bekræftet, at dette er din genstand.",
"hc.youWillBeRedirectedTo": "Du vil blive omdirigeret til den sikre Stripe betaling.",
"hc.yourAccountHasBeenReactivated": "Din konto er blevet reaktiveret.",
"hc.yourAccountIsActiveYou": "Din konto er aktiv, du kan nu administrere dine etableringer.",
"hc.yourEstablishment": "Din etablering",
"hc.yourFeedbackHelpsUsImprove": "Din feedback hjælper os med at forbedre vores matches.",
"hc.yourFeedbackHelpsUsRestart": "Din feedback hjælper os med at genstarte analysen og forbedre vores matches.",
"hc.yourFirstSteps": "Dine første skridt",
"hc.yourFirstStepsAdmin": "Dine første skridt (admin)",
"hc.yourItemHasBeenHanded": "Din genstand er blevet overdraget personligt af partneren — luk sagen, når overdragelsen er bekræftet.",
"hc.yourItemHasBeenShipped": "Din genstand er blevet afsendt af partneren — luk sagen, når levering er bekræftet.",
"hc.yourPaymentHasBeenRecorded": "Din betaling er blevet registreret.",
"hc.yourShipmentIsBeingPrepared": "Din forsendelse bliver forberedt. Du vil modtage din pakke inden for 3 til 5 arbejdsdage.",
"hc.yourShippingFeesHaveAlready": "Dine fragtomkostninger er allerede betalt. Fragt betalt ✓",
"hc.yourShippingFeesHaveBeen": "Dine fragtomkostninger er blevet betalt. Din pakke bliver forberedt.",
"hc.yourVerificationQuestionsDeposit": "Dine verifikationsspørgsmål (depositum)",
"hero.einvoiceBadge": "2027-kompatibel e-fakturering",
"home.recentAdsAll": "Se alle annoncer",
"home.recentAdsEyebrow": "Lige nu",
"home.recentAdsSubtitle": "Mistede og fundne genstande rapporteret af fællesskabet.",
"home.recentAdsTitle": "Seneste opslag",
"home.reunions": "Seneste genforeninger",
"pricing.physInvTitle": "Fysisk lagerregistrering",
"pricing.physModalTitle": "Fysisk varehåndtering",
"pricing.physQrDesc": "En unik QR-kode genereres pr. vare og linker til al dens information.",
"pricing.physQrTitle": "Dedikeret QR-label",
"pricing.physShelfDesc": "Hver registreret vare kan tildeles en fysisk placering inden for etableringen.",
"pricing.physShelfTitle": "Hyldeplan",
"pricing.physicalMgmt": "Fysisk varehåndtering (hylder, QR, lager)",
"pub.addSecondPhoto": "Tilføj et 2. foto (valgfrit)",
"pub.photo2Added": "✓ 2. foto tilføjet",
"reg.dispositionJournal": "Disposition journal",
"reg.dispositionNoteAuthHint": "ℹ️ En note er nødvendig for “Givet til myndighederne” (rapnummer, afdeling…).",
"reg.dispositionNotePh": "Note (valgfrit): modtager velgørenhed, myndighedsref., købers navn…",
"reg.dispositionNoteRequired": "En officiel reference er påkrævet for at give til myndighederne.",
"reg.legalPrealert": "Juridisk frist om {days} dag(e)",
"reg.legalPrealertOptions": "Muligheder ved frist: auktion, donation til velgørenhed, overdragelse til myndighederne.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Fuld anmeldelse",
"rev.readMore": "Læs mere",
"rw.activeCodes": "Aktive kuponer",
"rw.archived": "Arkiveret",
"rw.archivedTitle": "Indløste kuponer (arkiveret)",
"rw.hideArchived": "Skjul indløste kuponer",
"rw.noArchived": "Ingen arkiveret kupon.",
"rw.showArchived": "Vis indløste kuponer",
"shp.labelAuto": "Labelen genereres automatisk, så snart kunden har betalt forsendelsesomkostningerne. Den vil være tilgængelig her.",
"st.cancelled_by_customer": "Aflyst",
"stt.dispoPdfBtn": "Eksporter PDF",
"stt.dispoPdfError": "PDF eksport mislykkedes.",
"stt.dispoPdfExporting": "Eksporterer…",
"trk.matchVerifying": "Potentiel match bliver verificeret",
"home.videoEyebrow": "Se",
"home.videoSubtitle": "Hvordan vi genforener tabte genstande med deres ejere, uden besvær.",
"home.videoTitle": "Oplev Findloop på 2 minutter",
"home.watchYoutube": "Se på YouTube",
"impact.already": "Allerede",
"impact.citiesWord": "by/byer",
"impact.eachPoint": "Hver prik er en by, hvor Findloop hjælper med at genfinde tabte genstande.",
"impact.emptyMap": "Kortet fyldes op, når restitutionsprocessen sker.",
"impact.eyebrow": "Vores indflydelse",
"impact.inCities": "på tværs af",
"impact.restitutedTo": "genstande returneret til deres ejere",
"impact.title": "Genstande returneret, overalt nær dig",
"inv2.download": "Download",
"inv2.view": "Vis",
"map.objectsOnMapPlural": "genstande på kortet",
"map.objectsOnMapSingular": "genstand på kortet",
"mc.claimConfirmDesc": "Tjek den genstand, der er fundet af finderens før betaling for at få adgang til deres kontaktoplysninger.",
"mc.claimConfirmNo": "Dette er ikke min genstand",
"mc.claimConfirmTitle": "Er dette virkelig din genstand?",
"mc.claimConfirmYes": "Ja, det er min — betal",
"mc.claimFinderContacts": "Finderens kontaktoplysninger",
"mc.claimNotMineDone": "Tak — finderen er blevet underrettet, og din anmodning er blevet fjernet fra annoncen.",
"mc.claimUnlockDesc": "Betal Findloop administrationsgebyret for at få kontaktoplysningerne til den person, der fandt din genstand.",
"mc.claimUnlockTitle": "Lås finderens kontaktoplysninger op",
"mc.hideCountryOffers": "Skjul tilbud i mit land",
"mc.myClaims": "Genstande jeg kræver",
"mc.myClaimsSub": "Genstande fundet af andre, som du kræver. Lås finderens kontaktoplysninger op for at arrangere overleveringen.",
"mc.notifAdCancelled": "Annonce annulleret",
"mc.notifCancelAd": "Annuller min annonce",
"mc.offersInCountry": "Tilbud i mit land",
"mc.offersInCountryDesc": "Alle aktive belønninger fra partnere i dit land, opdelt efter by.",
"mc.redArchived": "Arkiveret",
"mc.rewardsCountryNone": "Ingen tilbud i dit land endnu.",
"mc.rewardsForYou": "Belønninger til dig",
"mc.rewardsForYouDesc": "Tilbudt af partner(e), hvor du har afleveret en genstand.",
"mc.rewardsMineNone": "Ingen belønning fra dine afleveringspartnere endnu.",
"mc.showCountryOffers": "Se tilbud i mit land",
"mc2.cancelDecl": "Annuller min erklæring",
"mc2.cancelDeclDone": "Erklæring annulleret.",
"pricing.physInvDesc": "Når en genstand returneres, frigives dens placering automatisk og bliver tilgængelig for en ny genstand.",
"pcat.stadium_arena": "Stadion / Arena",
"pcat.supermarket": "Supermarked",
"pcat.taxi_vtc": "Taxa / Ride-hailing",
"pcat.tourism_office": "Turistkontor",
"pcat.train_bus_station": "Tog- / busstation",
"pcat.travel_agency": "Rejsebureau",
"hc.and": "og",
"hc.demoObj0": "en pung",
"hc.demoObj1": "en sportstaske",
"hc.demoObj2": "en telefon",
"hc.demoObj3": "et par briller",
"hc.demoObj4": "et sæt nøgler",
"hc.demoObj5": "et tørklæde",
"hc.demoObj6": "en laptop",
"hc.demoObj7": "en vandflaske",
"hc.demoWhen0": "for 2 timer siden",
"hc.demoWhen1": "for 5 timer siden",
"hc.demoWhen2": "i går",
"hc.demoWhen3": "for 3 timer siden",
"hc.demoWhen4": "i morges",
"hc.demoWhen5": "for 1 dag siden",
"hc.feedDemo": "{obj} blev returneret i {city} {when}.",
"hc.feedReal": "Et objekt ({cat}) blev returneret i {city}.",
"hc.saveBtn": "Gem",
"hc.saveLink": "Gem link",
"hc.terms": "Betingelser",
"hc.view": "Se",
"pcat.airline": "Luftfartsselskab",
"pcat.airport": "Lufthavn",
"pcat.amusement_park": "Forlystelsespark",
"pcat.bank": "Bank",
"pcat.bar_cafe": "Bar / Café",
"pcat.beauty_salon": "Frisør / Skønhedssalon",
"pcat.cinema": "Biograf",
"pcat.concert_theater": "Koncertsal / Teater",
"pcat.coworking": "Coworking space",
"pcat.gym_fitness": "Fitness / Gym",
"pcat.hospital_clinic": "Hospital / Klinik",
"pcat.library": "Bibliotek",
"pcat.mall": "Shoppingcenter",
"pcat.museum": "Museum",
"pcat.pharmacy": "Apotek",
"pcat.private_company": "Privat virksomhed",
"pcat.public_transport": "Offentlig transport",
"pcat.school_university": "Skole / Universitet",
"pcat.sports_center": "Sportscenter",
"an.found": "Fundet",
"an.lost": "Mistede",
"hc.shareReview": "Del anmeldelsen",
"hc.citiesAboveTarget": "{n} byer over deres mål",
"hc.cityAboveTarget": "{n} by over sit mål",
"hc.j15EarlyReminder": "D-15 tidlig påmindelse",
"hc.j7EarlyReminder": "D-7 tidlig påmindelse",
"hc.annualTotal": "Årligt totalbeløb",
"hc.billedOnceYear": "Opkræves én gang for 12 måneder, fornyes hvert år.",
"hc.monthlyPrice": "Månedlig pris",
"hc.perMonth": "/ måned",
"hc.perYear": "/ år",
"hc.billedEachMonth": "Beskåret automatisk hver måned.",
"nav.business": "Virksomhed",
"nav.individual": "Personlig",
"hc.circumstancesFound": "Omgivelserne for fundet",
"hc.circumstancesFoundPh": "F.eks. fundet på jorden nær metroindgangen",
"hc.circumstancesLost": "Omgivelserne for tabet",
"hc.circumstancesLostPh": "F.eks. efterladt på en bænk mens man ventede på bussen",
"hc.conditionPh": "F.eks. god, ridset…",
"hc.firstName": "Fornavn",
"hc.lastName": "Efternavn",
"hc.quantity": "Antal genstande",
"fa.ownerContact": "Ejerens kontaktoplysninger",
"fa.payPublish": "Betal og offentliggør",
"fa.pendingPayText": "Din annonce går online så snart betalingen er bekræftet.",
"fa.pendingPayTitle": "Betaling afventer",
"fa.planSub": "Din annonce går online så snart betalingen er bekræftet.",
"fa.planTitle": "Annoncevarighed",
"fa.pubSuccessMsg": "Din annonce er online. Du vil blive underrettet, så snart en finder henvender sig.",
"fa.pubSuccessTitle": "Annonce offentliggjort",
"fa.publicNote": "Kun beskrivelsen, byen, landet og billederne vises offentligt.",
"fa.redirectStripe": "Omfordeler til sikker betaling…",
"fa.reject": "Afvis",
"fa.rejectConfirm": "Afviser du denne erklæring? Din annonce forbliver online.",
"fa.rejected": "Erklæring afvist",
"fa.rejectedFinder": "Det var ikke det, de ledte efter",
"fa.rejectedFinderText": "Ejeren siger, at denne genstand ikke er deres. Tak for din hjælp!",
"fa.responsesTitle": "Findererklæringer",
"fa.sent": "Erklæring sendt til ejeren.",
"fa.submitDecl": "Send min erklæring",
"fa.submitDeclPay": "Send og bidrag {amount}",
"fa.total": "Total at betale",
"fa.ttc": "inkl. moms",
"fa.waitClaimText": "Finderen gennemgår din anmodning. Du vil blive underrettet om deres beslutning.",
"fa.waitFinderText": "Vi giver dig besked, så snart en finder indsender en erklæring.",
"fa.waitFinderTitle": "Din annonce er online",
"fa.waitOwnerText": "Ejeren sammenligner din erklæring med deres. Du vil blive underrettet om deres beslutning.",
"fa.waitOwnerTitle": "Venter på ejerens beslutning",
"st.pending_payment": "Betaling afventer",
"fa.approve": "Godkend",
"fa.approveConfirm": "Godkender du denne erklæring? Dine fulde kontaktoplysninger (navn, e-mail, telefon) vil blive udvekslet med finderen.",
"fa.approved": "Erklæring godkendt - kontaktoplysninger udvekslet",
"fa.approvedFinder": "Ejeren har godkendt din erklæring",
"fa.approvedFinderText": "Kontakt dem for at arrangere tilbageleveringen.",
"fa.boostSub": "Din annonce forbliver øverst i den valgte periode.",
"fa.boostTitle": "Boost min annonce (valgfrit)",
"fa.colFinder": "Finderens erklæring",
"fa.colYours": "Din erklæring",
"fa.compareHint": "Sammenlign finderens erklæring med din, før du beslutter dig.",
"fa.contribNone": "Ingen bidrag",
"fa.contribPaid": "Bidrag modtaget - tak!",
"fa.contribPending": "Bidrag afventer betaling",
"fa.contribSub": "Støt Findloop for at hjælpe flere med at få deres ejendele tilbage. Du kan vælge €0.",
"fa.contribSuccessMsg": "Din erklæring er blevet sendt til ejeren.",
"fa.contribSuccessTitle": "Tak for dit bidrag",
"fa.contribTitle": "Frivilligt bidrag",
"fa.days3": "3 dage",
"fa.days30": "30 dage",
"fa.days7": "7 dage",
"fa.declSub": "Beskriv den genstand, du har fundet. Ejeren vil sammenligne din erklæring med deres.",
"fa.declTitle": "Jeg fandt denne genstand",
"fa.expiresOn": "Udløber den",
"fa.fBrand": "Mærke",
"fa.fCircumstances": "Omstændigheder",
"fa.fCity": "By",
"fa.fColor": "Farve",
"fa.fCondition": "Stand",
"fa.fDate": "Dato",
"fa.fMessage": "Finderens besked",
"fa.fPlace": "Sted",
"fa.fQuantity": "Mængde",
"fa.finderContact": "Finderens kontaktoplysninger",
"fa.finishPay": "Afslut betaling",
"fa.foundDate": "Dato fundet",
"fa.foundPlace": "Sted fundet",
"fa.hours24": "24 timer",
"fa.ht": "eksl. moms",
"fa.months3": "3 måneder",
"fa.noBoost": "Ingen boost",
"fa.africaFree": "Gratis oprettelse i Afrika — Findloop lanceringstilbud, nyd det!",
"fa.africaPublished": "Oprettelse offentliggjort gratis — Afrika lanceringstilbud!",
"fa.approveClaimConfirm": "Godkende denne krav? Ejeren vil derefter kunne låse dine kontaktoplysninger op.",
"fa.checkInfo": "Tjek dine oplysninger inden du sender: de vil blive sammenlignet med finderens.",
"fa.claimApprovedShort": "Finder godkendte dit krav",
"fa.claimRejectedShort": "Krav afvist af finder",
"fa.claimRejectedText": "Finder mener, at denne genstand ikke tilhører dig.",
"fa.claimSub": "Beskriv din genstand og tilføj 2 fotos. Finder vil sammenligne dem med deres oprettelse.",
"fa.claimTitle": "Dette er min genstand",
"fa.claimUnlockText": "Lås finderens kontaktoplysninger op for at arrangere returnering.",
"fa.claimUnlockedShort": "Kontaktoplysninger låst op — se tracking",
"fa.claimsTitle": "Ejerkrav",
"fa.colOwner": "Ejers erklæring",
"fa.colYourAd": "Din oprettelse",
"fa.expired": "Oprettelse udløbet",
"fa.free": "Gratis",
"fa.lostDate": "Dato mistet",
"fa.lostPlace": "Sted mistet",
"fa.noReceipt": "Ingen kvittering tilgængelig for denne oprettelse.",
"fa.planSubFree": "Vælg varigheden: din oprettelse går live med det samme, ingen betaling nødvendig.",
"fa.prefillPrevious": "Genbrug oplysningerne fra min tidligere oprettelse i denne kategori",
"fa.receipt": "PDF kvittering",
"fa.renewBtn": "Forny",
"fa.renewDiscountBanner": "50% rabat: forny før din oprettelse udløber!",
"fa.renewDiscountHint": "50% rabat anvendt, fordi du fornyer før udløb.",
"fa.renewEarly": "Forny (−50%)",
"fa.renewTitle": "Forny min oprettelse",
"fa.renewed": "Oprettelse fornyet",
"fa.sendClaim": "Send mit krav",
"fa.twoPhotos": "2 fotos af din genstand",
"fa.twoPhotosError": "Tilføj 2 fotos af din genstand.",
"fa.twoPhotosHint": "Personlige fotos der beviser, at genstanden tilhører dig (med genstanden, faktura, kasse…).",
"fa.unlockBtn": "Lås kontaktoplysninger op",
"fa.unlockFree": "Lås op gratis — lanceringstilbud",
"fa.waitClaimantText": "Vi giver dig besked, så snart en ejer kræver denne genstand.",
"fa.waitFinderDecision": "Venter på finderens beslutning",
"fa.waitUnlockText": "Du vil blive underrettet, så snart kontaktoplysninger udveksles.",
"fa.waitUnlockTitle": "Venter på, at ejeren låser op",
"fa.cancel": "Annuller",
"fa.categoryRequired": "Vælg en kategori for den fundne genstand.",
"fa.confirmTitle": "Bekræft din beslutning",
"fa.goBack": "Gå tilbage",
"dr.continue": "Fortsæt min erklæring",
"dr.delete": "Slet permanent",
"dr.deleteConfirm": "Slette dette udkast permanent? Dette kan ikke fortrydes.",
"dr.deleted": "Udkast slettet",
"dr.expiresIn": "Udkast gemt i {h} flere timer",
"dr.title": "Du har en ufuldkommen erklæring",
"form.step": "Trin",
"form.next": "Fortsæt",
"form.back": "Tilbage",
"form.stepDetails": "Din rapport",
"form.stepPublish": "Varighed, boost & betaling",
"form.stepThanks": "Tak & bidrag",
"fthx.badge": "Rapporten er næsten færdig",
"fthx.title": "Tak, du gør en forskel!",
"fthx.text": "Takket være dig kan nogen snart få tilbage, hvad der betyder noget for dem. Sådanne venlige handlinger som dine er netop det, der holder Findloop i live.",
"fthx.impact1": "1 genstand rapporteret",
"fthx.impact2": "1 chance mere for genforening",
"fthx.tipTitle": "Lidt hjælp til Findloop?",
"fthx.tipText": "Din støtte hjælper os med at holde servicen tilgængelig og genforene flere genstande med deres ejere.",
"fthx.optional": "100% frivilligt — du kan udgive uden at bidrage.",
"fthx.thanksTip": "Tusind tak for din generøsitet!",
"fthx.suggest": "Foreslåede beløb",
"fthx.none": "Ingen tip",
"pay.pendingTitle": "Betaling ikke gennemført",
"pay.pendingText": "Dine oplysninger er gemt. Fortsæt betalingen der, hvor du slap.",
"pay.resume": "Fortsæt betaling",
"pay.expiredTitle": "Betalingssession er udløbet",
"pay.expiredText": "For din sikkerhed er betalingssessionen udløbet. Dine oplysninger er gemt: genstart betalingen med ét klik.",
"pay.relaunch": "Genstart betaling",
"sub.received": "Sendt!",
"sub.publishing": "Vi er ved at afslutte…",
"sub.toPayment": "Omdirigerer til sikker betaling…",
"fa.claimSubV2": "Beskriv din mistede genstand. Den person, der fandt den, vil sammenligne din erklæring med deres annonce.",
"fa.photosOptional": "Billeder af din genstand (valgfrit)",
"fa.compareOwnerHint": "Sammenlign disse oplysninger med den genstand, du fandt, og sig derefter, om det er den samme genstand.",
"fa.itsThisItem": "Ja, det er genstanden",
"fa.notThisItem": "Nej, det er ikke genstanden",
"fa.confirmIsItem": "Bekræft, at dette er genstanden? Dine kontaktoplysninger og ejerens vil blive vist i jeres respektive konti.",
"fa.confirmNotItem": "Bekræft, at dette ikke er genstanden? Din rapport vil blive lukket.",
"fa.youConfirmed": "Du bekræftede, at dette er ejerens genstand",
"fa.youDeclined": "Du angav, at dette ikke var genstanden",
"fa.youDeclinedText": "Tak for din hjælp! Ejeren er blevet informeret.",
"fa.waitFinderDecisionOwner": "Venter på finderens beslutning",
"fa.finderConfirmed": "Bekræftet",
"fa.notYourItem": "Dette var ikke din genstand",
"fa.reportedOn": "Rapporteret den",
"fa.ownerWaitHint": "En finder tjekker i øjeblikket oplysningerne, vent venligst.",
"fa.claimSentFinder": "Krav sendt til den person, der fandt genstanden.",
"fa.compareClaimHint": "Sammenlign ejerens erklæring med din liste, før du træffer en beslutning.",
"fa.closeFollowup": "Luk denne opfølgning",
"fa.closeFollowupConfirm": "Lukke denne opfølgning? Begge parters e-mails og telefonnumre vil blive permanent slettet, når ejeren også har lukket sin annonce.",
"fa.safetyTitle": "Sikkerhedstip før overdragelsen",
"fa.safety1": "Bed ejeren om en detaljeret beskrivelse af skjulte funktioner ved genstanden: en specifik ridse, det præcise indhold af en taske, tapetet, serienummeret…",
"fa.safety2": "Hvis muligt, spørg om visuel dokumentation (et billede af genstanden) eller købsbevis.",
"fa.safety3": "Overdrag genstanden på et offentligt sted eller hos en Findloop-partner, og tjek ejerens ID.",
"fa.safetyOk": "Forstået, fortsæt",
"fa.ownerClosedNote": "Ejeren har lukket sin annonce.",
"fa.finderClosedNote": "Finder har lukket sin opfølgning.",
"fa.followupClosed": "Opfølgning lukket",
"fa.followupClosedText": "Du har lukket denne opfølgning. Tak for din hjælp!",
"fa.photoReviewTitle": "En finder har sendt et billede. Ligner det dit item?",
"fa.photoLooksLike": "Ja, det ligner mit item",
"fa.photoNotMine": "Nej, dette er ikke mit item",
"fa.photoNotMineConfirm": "Opfølgningen lukkes fra begge sider, og din annonce forbliver åben for en ny finder.",
"fa.photoLooksLikeDone": "Tak! Finderen vil nu sammenligne din erklæring.",
"fa.photoNotMineDone": "Rapport afvist. Din annonce forbliver åben.",
"fa.ownerPhotoHint": "Kun finderens billede vises for dig. Fortæl os, om det ligner dit item.",
"fa.ownerReviewingPhoto": "Ejeren vurderer dit billede",
"fa.ownerReviewingPhotoText": "Du vil blive notificeret, så snart de svarer. Du vil derefter kunne sammenligne deres erklæring.",
"fa.ownerRejectedPhoto": "Dette er ikke ejerens item",
"fa.ownerRejectedPhotoText": "Ejeren siger, at dit billede ikke matcher deres item. Opfølgningen er lukket. Tak for din hjælp!",
"fa.contribute": "Bidrag",
"fa.phoneMissing": "Ikke angivet",
"fa.ownerSafety1": "Foretræk en overdragelse på et offentligt sted eller hos en Findloop-partner. Hvis afstanden er lang, foreslå at sende det med posten i stedet.",
"fa.ownerSafety2": "Ved overdragelsen, tjek finderens ID.",
"pub.changePhoto": "Skift billede",
"ph.secured": "Foto sikret",
"ph.securing": "Sikrer fotoet…",
"fa.ownerSafety3": "Hvis finderens foto har Findloop vandmærket, så accepter ikke mødet. Fotografiet skal være et originalt billede taget af finder, uden vandmærke."
},
"el": {
"a.back": "Πίσω",
"a.category": "Κατηγορία",
"a.categoryPlaceholder": "Επιλέξτε μια κατηγορία",
"a.city": "Πόλη",
"a.confirmPassword": "Επιβεβαίωση κωδικού",
"a.country": "Χώρα",
"a.createAccount": "Δημιουργία λογαριασμού",
"a.createBtn": "Δημιουργία του λογαριασμού μου",
"a.creating": "Δημιουργία…",
"a.email": "Email",
"a.emailPro": "Επαγγελματικό email",
"a.forgot": "Ξεχάσατε;",
"a.forgotSent": "Αν υπάρχει λογαριασμός, έχει μόλις σταλεί ένας σύνδεσμος επαναφοράς.",
"a.forgotSub": "Λάβετε έναν σύνδεσμο επαναφοράς μέσω email.",
"a.forgotTitle": "Ξεχάσατε τον κωδικό",
"a.googleContinue": "Συνέχεια με το Google",
"a.googleSignup": "Εγγραφή με το Google",
"a.haveAccount": "Είστε ήδη συνεργάτης;",
"a.legalHint": "Απαιτείται για την ηλεκτρονική τιμολόγηση (Factur-X) γαλλικών εγκαταστάσεων.",
"a.legalRequiredFR": "Ο αριθμός SIRET και ο ενδο-ΕΕ αριθμός ΦΠΑ είναι υποχρεωτικοί για τη Γαλλία.",
"a.loggingIn": "Σύνδεση…",
"a.login": "Σύνδεση",
"a.loginSub": "Πρόσβαση στον χώρο διαχείρισης σας.",
"a.loginTitle": "Σύνδεση συνεργάτη",
"a.min6": "Ελάχιστο 6 χαρακτήρες",
"a.newPassword": "Νέος κωδικός",
"a.noAccount": "Δεν είστε ακόμη συνεργάτης;",
"a.or": "Η",
"a.org": "Όνομα εγκατάστασης",
"a.password": "Κωδικός",
"a.passwordMismatch": "Οι κωδικοί δεν ταιριάζουν.",
"a.referral": "Κωδικός παραπομπής (προαιρετικός)",
"a.registerSub": "Δημιουργήστε το χώρο σας σε 1 λεπτό — δωρεάν για να ξεκινήσετε.",
"a.registerTitle": "Γίνετε συνεργάτης",
"a.rememberMe": "Να με θυμάστε",
"a.reset": "Επαναφορά",
"a.resetSub": "Επιλέξτε έναν νέο κωδικό για τον λογαριασμό σας.",
"a.resetTitle": "Νέος κωδικός",
"a.sendLink": "Στείλτε τον σύνδεσμο",
"a.sending": "Αποστολή…",
"a.signin": "Σύνδεση",
"a.siret": "SIRET",
"a.vat": "Αριθμός ΦΠΑ ενδο-ΕΕ.",
"ac.africa": "Αφρική",
"ac.boostActive": "Επισημάνετε ενεργό —",
"ac.boostSub": "Εμφανιστείτε στην κορυφή του καταλόγου συνεργατών με σήμα “Επιταχυνόμενο”.",
"ac.boostTitle": "Ενίσχυση της καταχώρισής σας στον κατάλογο",
"ac.categoryHint": "Για να ταξινομήσετε την εγκατάσταση σας στον κατάλογο findloop.",
"ac.choose": "Επιλέξτε",
"ac.cityHint": "Για ακριβή θέση στον δημόσιο χάρτη.",
"ac.cityLabel": "Πόλη εγκατάστασης",
"ac.cityPh": "Παρίσι",
"ac.contact": "Στοιχεία επικοινωνίας",
"ac.converted": "Μετατράπηκε",
"ac.copyDeclLink": "Αντιγραφή του συνδέσμου δήλωσης",
"ac.copyLink": "Αντιγραφή του συνδέσμου",
"ac.currentPlan": "Τρέχων σχέδιο",
"ac.emailDesc": "Επιλέξτε τα emails που θέλετε να λαμβάνετε. Οι ειδοποιήσεις στο χώρο εργασίας σας παραμένουν πάντα ενεργές.",
"ac.emailMatch": "Ταιριάζει",
"ac.emailMatchDesc": "Ένα email όταν ένα στοιχείο ταιριάζει με μια δήλωση",
"ac.emailNewDecl": "Νέες δηλώσεις απώλειας",
"ac.emailNewDeclDesc": "Ένα email μόλις ένας πελάτης αναφέρει μια απώλεια στον χώρο σας",
"ac.emailShip": "Αιτήματα αποστολής",
"ac.emailShipDesc": "Ένα email όταν ένας πελάτης ζητήσει την αποστολή ενός αντικειμένου",
"ac.emailTitle": "Προτιμήσεις email",
"ac.expireSoon": "Η επισημάνσή σας λήγει σύντομα —",
"ac.exportCsv": "Εξαγωγή (CSV)",
"ac.exportHint": "Εξάγετε τις επικυρωμένες εξωτερικές πληρωμές σας για τη λογιστική σας.",
"ac.free": "Δωρεάν",
"ac.freeMonths": "Δωρεάν μήνες",
"ac.hours": "ώρες",
"ac.howItWorks": "Πώς λειτουργεί;",
"ac.invited": "Προσκληθείς",
"ac.legalFR": "Απαραίτητο για ηλεκτρονική τιμολόγηση (Factur-X) που ισχύει από Σεπτέμβριο 2026.",
"ac.legalMissing": "⚠️ Λείπει το SIRET και ο ενδο-ΕΕ ΦΠΑ — συμπληρώστε τα για να μείνετε συμ compliant με την ηλεκτρονική τιμολόγηση.",
"ac.legalOther": "Συνιστάται για τα τιμολόγιά σας.",
"ac.legalPartnerQr": "QR code",
"ac.legalTitle": "Νομικά αναγνωριστικά (χρέωση)",
"ac.logoTitle": "Λογότυπο εγκαταστάσεως",
"ac.modeCurrent": "Τρέχουσα μέθοδος:",
"ac.modeExternal": "Εξωτερική (χειροκίνητη επικύρωση)",
"ac.modeInternal": "Εσωτερική Findloop (αυτόματη)",
"ac.noSubReceipt": "Δεν υπάρχει ακόμα πληρωμή συνδρομής.",
"ac.none": "Καμία",
"ac.onYourListing": "στην καταχώρισή σας",
"ac.pay1": "Εισάγετε τους συνδέσμους πληρωμής σας παρακάτω για να ανακατευθύνετε τους πελάτες σας στο δικό σας σύστημα συλλογής.",
"ac.pay2": "Η επικύρωση γίνεται χειροκίνητη: επιβεβαιώνετε την παραλαβή της πληρωμής από την καρτέλα “Δηλώσεις”.",
"ac.pay3": "Ο σύνδεσμος “Χρέωση αποστολής” είναι μια ενοποιημένη πληρωμή (ανάκτηση + αποστολή).",
"ac.pay4": "Αφήστε τα πεδία κενά για να χρησιμοποιήσετε την εσωτερική πληρωμή της Findloop (Stripe) με αυτόματη επικύρωση.",
"ac.paySub": "Συλλέξτε τέλη μέσω του δικού σας συστήματος πληρωμών.",
"ac.payTitle": "Εξωτερικές πληρωμές",
"ac.permissive": "Ευέλικτο",
"ac.phone": "Τηλέφωνο",
"ac.posterA4": "Φυλλάδιο A4 (PDF)",
"ac.qMessage": "Μήνυμα (προαιρετικό)",
"ac.qName": "Όνομα",
"ac.qOrg": "Οργάνωση",
"ac.qSites": "Αριθμός εγκαταστάσεων (εκτιμώμενος)",
"ac.qrHint": "Οι πελάτες σας σκανάρουν αυτόν τον κωδικό για να αναφέρουν ένα χαμένο αντικείμενο.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Ο QR κωδικός του συνεργάτη σας",
"ac.quoteDesc": "Αεροδρόμια, σιδηροδρομικά δίκτυα, διεθνείς αλυσίδες · ",
"ac.quoteEurope": "Ευρώπη / Κόσμος",
"ac.quoteSent": "Αίτημα προσφοράς έχει σταλεί. Η ομάδα μας θα σας απαντήσει σύντομα.",
"ac.quoteTitle": "Ζητήστε μια προσφορά — Επιχείρηση",
"ac.recoveryLink": "Σύνδεσμος “Χρέωση ανάκτησης”",
"ac.refSub": "Κάθε παραπεμπόμενος συνεργάτης που εγγραφεί σας δίνει 1 δωρεάν μήνα.",
"ac.refTitle": "Παραπέμψτε, κερδίστε έναν δωρεάν μήνα",
"ac.reminderDelay": "Καθυστέρηση υπενθύμισης επικύρωσης",
"ac.reminderHint": "Θα λάβετε μια υπενθύμιση μέσω email αν μια εξωτερική πληρωμή παραμείνει μη επικυρωμένη πέρα από αυτήν την καθυστέρηση (προεπιλογή: 48h).",
"ac.renewDesc1": "Έχει ήδη σας κερδίσει",
"ac.renewDesc2": "Ανανεώστε για να παραμείνετε στην κορυφή του καταλόγου και να μην χάσετε αυτή τη ορατότητα.",
"ac.renewNow": "Ανανεώστε τώρα",
"ac.requestQuote": "Ζητήστε μια προσφορά",
"ac.saveLegal": "Αποθηκεύστε τα αναγνωριστικά",
"ac.saveLinks": "Αποθηκεύστε τους συνδέσμους",
"ac.sendRequest": "Στείλτε το αίτημά μου",
"ac.sending": "Αποστολή…",
"ac.shippingLink": "Σύνδεσμος “Χρέωση αποστολής” (ενοποιημένος)",
"ac.shippingLinkHint": "Αυτός ο σύνδεσμος καλύπτει τόσο την ανάκτηση όσο και την αποστολή.",
"ac.strict": "Αυστηρό",
"ac.subReceipt": "Απόδειξη συνδρομής (PDF)",
"ac.subReceiptsSub": "Κατεβάστε την PDF απόδειξη για κάθε πληρωμή συνδρομής.",
"ac.subReceiptsTitle": "Αποδείξεις συνδρομής",
"ac.tCategory": "Κατηγορία αποθηκευμένη",
"ac.tCity": "Πόλη αποθηκευμένη — χάρτης ενημερωμένος",
"ac.tCityNeeded": "Εισάγετε μια πόλη",
"ac.tCopied": "Αντιγράφηκε!",
"ac.tCover": "Φωτογραφία εξωφύλλου ενημερωμένη",
"ac.tEmailPrefs": "Προτιμήσεις email ενημερωμένες",
"ac.tErr": "Σφάλμα",
"ac.tExportImpossible": "Η εξαγωγή απέτυχε",
"ac.tLegal": "Νομικά στοιχεία αποθηκευμένα",
"ac.tLegalNeeded": "Απαιτούνται SIRET και ΦΠΑ για τη Γαλλία",
"ac.tLogo": "Λογότυπο ενημερωμένο",
"ac.tLogoRemoved": "Λογότυπο αφαιρέθηκε",
"ac.tPayLinks": "Συνδέσεις πληρωμής αποθηκευμένες",
"ac.tPhone": "Τηλέφωνο αποθηκευμένο",
"ac.tSensitivity": "Ευαισθησία αποθηκευμένη",
"ac.tVatInvalid": "Άκυρος αριθμός ΦΠΑ",
"ac.tVatValid": "Έγκυρος ΦΠΑ",
"ac.tabBoost": "Ορατότητα",
"ac.tabPayments": "Πληρωμές",
"ac.tabProfile": "Προφίλ",
"ac.tabQr": "QR & Αφίσα",
"ac.tabReferral": "Παραπομπή",
"ac.tabSub": "Συνδρομή",
"ac.thisWeek": "Αυτή την εβδομάδα",
"ac.thisWeekOf": " ({n} αυτή την εβδομάδα)",
"ac.thresholdDesc": "Κατώφλι εμπιστοσύνης από το οποίο η AI επικυρώνει αυτόματα μια αντιστοιχία φωτογραφίας και ειδοποιεί τον πελάτη. Υψηλότερο = λιγότερες αυτόματες αντιστοιχίσεις αλλά πιο αξιόπιστο.",
"ac.thresholdTitle": "Ευαισθησία οπτικής αντιστοίχισης AI",
"ac.trend": "Τάση",
"ac.upload": "Μεταφόρτωση",
"ac.vatValidFmt": "Έγκυρος ΦΠΑ{name} ({via})",
"ac.vatVerified": "Επιβεβαιωμένος ΦΠΑ ΕΕ",
"ac.verifyVat": "Επιβεβαίωση ΦΠΑ (VIES)",
"ac.verifying": "Επιβεβαίωση…",
"ac.views": "προβολές",
"ac.viewsTotal": "Προβολές κερδισμένες (σύνολο)",
"ac.winbackBtn": "Συνέχεια με -20%",
"ac.winbackDesc1": "Σας κέρδισε",
"ac.winbackDesc2": "Ειδική προσφορά: -20% εφαρμόζεται αυτόματα αν ανανεώσετε μέσα σε 24 ώρες.",
"ac.winbackTitle": "Η προβολή σας μόλις λήξει — συνεχίστε με -20%! ",
"ad.boost": "Αύξηση",
"ad.close": "Κλείσιμο",
"ad.closeConfirm": "Να κλείσω αυτή τη καταχώρηση;",
"ad.closed": "Καταχώρηση κλειστή",
"ad.edit": "Επεξεργασία",
"ad.editTitle": "Επεξεργασία καταχώρησης",
"ad.saved": "Καταχώρηση ενημερωμένη",
"an.allCountries": "Όλες οι χώρες",
"an.badge": "Χαμένα αντικείμενα",
"an.boostLater": "Αργότερα",
"an.boostNow": "Αύξηση τώρα",
"an.boostPrompt": "Αυξήστε την καταχώρησή σας για να την τοποθετήσετε στην κορυφή και να σας βρουν πιο γρήγορα.",
"an.boosted": "Αυξημένο",
"an.contact": "Βρήκα αυτό το αντικείμενο",
"an.contactTitle": "Αναφέρετε ότι βρήκατε αυτό το αντικείμενο",
"an.copyFailed": "Δεν ήταν δυνατή η αντιγραφή του συνδέσμου",
"an.copyLink": "Αντιγραφή συνδέσμου",
"an.country": "Χώρα",
"an.date": "Ημερομηνία απώλειας",
"an.finderEmail": "Το email σας",
"an.finderName": "Το όνομά σας",
"an.finderPhone": "Το τηλέφωνό σας",
"an.geoBanner": "Βλέπετε καταχωρίσεις σε",
"an.geoBannerWorld": "Βλέπετε καταχωρίσεις παγκοσμίως",
"an.geoChange": "αλλαγή χώρας",
"an.goAccount": "Κάντε σύνδεση στον λογαριασμό μου",
"an.linkCopied": "Ο σύνδεσμος αντιγράφηκε!",
"an.loginRequired": "Συνδεθείτε για να αναφέρετε αυτό το αντικείμενο και να ακολουθήσετε την επιστροφή.",
"an.loginToBoost": "Συνδεθείτε για να προωθήσετε αυτήν την καταχώριση",
"an.lostAt": "Χάθηκε στο",
"an.message": "Μήνυμα (προαιρετικό)",
"an.none": "Δεν υπάρχει καμία καταχώριση ακόμη.",
"an.photo": "Φωτογραφία (προαιρετική)",
"an.post": "Δημοσιεύστε μια καταχώριση",
"an.postSubtitle": "Περιγράψτε το χαμένο σας αντικείμενο — η κοινότητα και οι συνεργάτες μας βοηθούν να το βρείτε.",
"an.postTitle": "Αναφέρετε ένα χαμένο αντικείμενο",
"an.publish": "Δημοσίευση καταχώρισης",
"an.published": "Η καταχώριση δημοσιεύθηκε!",
"an.publishing": "Δημοσίευση…",
"an.remaining": "απομένον",
"an.requestInProgress": "Αίτηση σε εξέλιξη",
"an.resolved": "Το αντικείμενο έχει ανακτηθεί",
"an.reward": "Ανταμοιβή",
"an.searchPh": "Αναζητήστε μια καταχώριση…",
"an.send": "Αποστολή",
"an.sent": "Το μήνυμα στάλθηκε στον κάτοχο!",
"an.shareConsent": "Συμφωνώ ότι τα στοιχεία επικοινωνίας μου (όνομα, email, τηλέφωνο) μπορεί να κοινοποιηθούν στον κάτοχο του αντικειμένου.",
"an.shareConsentError": "Παρακαλώ επιλέξτε την επιλογή για να κοινοποιήσετε τα στοιχεία επικοινωνίας σας.",
"an.sortRecent": "Πιο πρόσφατα",
"an.sortRelevance": "Σημαντικότητα",
"an.subtitle": "Περιηγηθείτε σε αντικείμενα που αναφέρθηκαν ως χαμένα από την κοινότητα. Βρήκατε ένα από αυτά;",
"an.title": "Καταχωρίσεις χαμένων αντικειμένων",
"anf.badge": "Βρέθηκαν αντικείμενα",
"anf.claim": "Αυτό είναι δικό μου",
"anf.claimSent": "Το μήνυμα στάλθηκε στον ανιχνευτή!",
"anf.claimTitle": "Αναφέρετε ότι αυτό είναι το αντικείμενό σας",
"anf.consent": "Συμφωνώ ότι ο κάτοχος μπορεί να δει τα στοιχεία επικοινωνίας μου για να ανακτήσει το αντικείμενό τους.",
"anf.foundAt": "Βρέθηκε στο",
"anf.foundDate": "Ημερομηνία ευρέσεως",
"anf.loginCta": "Συνδεθείτε / δημιουργήστε λογαριασμό",
"anf.loginDesc": "Απαιτείται λογαριασμός ανιχνευτή για να δημοσιεύσετε μια καταχώριση και να κερδίσετε πόντους Finder Hero.",
"anf.loginRequired": "Συνδεθείτε για να δημοσιεύσετε ένα βρεθέν αντικείμενο",
"anf.photo": "Φωτογραφία αντικειμένου",
"anf.pointsEarned": "Ευχαριστώ! Μόλις κερδίσατε πόντους Finder Hero.",
"anf.pointsPending": "Οι πόντοι σας θα πιστωθούν εντός 24 ωρών, μετά την επαλήθευση.",
"anf.post": "Δημοσιεύστε ένα βρεθέν αντικείμενο",
"anf.postSubtitle": "Περιγράψτε το αντικείμενο που βρήκατε — βοηθήστε τον κάτοχό του να το πάρει πίσω.",
"anf.postTitle": "Αναφέρετε ένα βρεθέν αντικείμενο",
"anf.publishFound": "Δημοσίευση καταχώρισης βρέθέντος",
"anf.published": "Καταχώριση βρέθέντος αντικειμένου δημοσιεύθηκε",
"anf.publishedAs": "Δημοσιεύθηκε ως",
"anf.shareConsent": "Συμφωνώ ότι τα στοιχεία επικοινωνίας μου (όνομα, email, τηλέφωνο) μπορεί να κοινοποιηθούν στο άτομο που βρήκε το αντικείμενο.",
"anf.subtitle": "Περιηγηθείτε σε αντικείμενα που βρέθηκαν και αναφέρθηκαν από την κοινότητα. Αναγνωρίζετε το δικό σας;",
"anf.title": "Καταχωρίσεις βρέθέντων αντικειμένων",
"bo.active": "Η προώθηση είναι ενεργή",
"bo.africaPrice": "Εφαρμόσθηκε προνομιακή τιμολόγηση ζώνης Αφρικής",
"bo.pay": "Πληρώστε & προωθήστε",
"bo.remaining": "Χρόνος απομένουσας",
"bo.renew": "Ανανέωση ενίσχυσης",
"bo.since": "από την ενίσχυση",
"bo.subtitle": "Τοποθετήστε την καταχώρισή σας στην κορυφή της λίστας με ένα ορατό σήμα.",
"bo.title": "Ενίσχυση καταχώρισης",
"c.all": "Όλα",
"c.cancel": "Ακύρωση",
"c.close": "Κλείσιμο",
"c.confirm": "Επιβεβαίωση",
"c.confirmed": "Επιβεβαιωμένο",
"c.download": "Λήψη",
"c.loading": "Φόρτωση…",
"c.reset": "Επαναφορά",
"c.reviews": "κριτικές",
"c.save": "Αποθήκευση",
"c.transfer": "Μεταφορά",
"cat.Animal": "Κατοικίδιο / Αξεσουάρ κατοικιδίου",
"cat.AppareilPhoto": "Κάμερα",
"cat.Argent": "Χρήματα / Μετρητά",
"cat.Autres": "Άλλα",
"cat.Bijoux": "Κοσμήματα",
"cat.CarteBancaire": "Κάρτα τράπεζας",
"cat.CarteIdentite": "Δελτίο ταυτότητας / Διαβατήριο",
"cat.Casquette": "Καπέλο",
"cat.Ceinture": "Ζώνη",
"cat.Chargeur": "Φορτιστής / Καλώδιο",
"cat.Chaussures": "Παπούτσια",
"cat.CleVoiture": "Κλειδί αυτοκινήτου",
"cat.Cles": "Κλειδιά",
"cat.Console": "Κονσόλα παιχνιδιών",
"cat.Documents": "Έγγραφα",
"cat.Echarpe": "Κασκόλ",
"cat.Ecouteurs": "Ακουστικά",
"cat.Electronique": "Ηλεκτρονικά (άλλα)",
"cat.Enceinte": "Ηχείο",
"cat.Gants": "Γάντια",
"cat.Gourde": "Μπουκάλι νερού / Θερμός",
"cat.Instrument": "Μουσικό όργανο",
"cat.Jouet": "Παιχνίδι / Λούτρινο",
"cat.Jumelles": "Κιάλια",
"cat.Lampe": "Λάμπα / Φακός",
"cat.Liseuse": "E-reader",
"cat.Livre": "Βιβλίο / Τετράδιο",
"cat.Lunettes": "Γυαλιά",
"cat.Manteau": "Μπουφάν",
"cat.Maquillage": "Τσάντα μακιγιάζ",
"cat.Medical": "Ιατρικός εξοπλισμός",
"cat.Medicaments": "Φάρμακα",
"cat.Montre": "Ρολόι / Έξυπνο ρολόι",
"cat.Ordinateur": "Λάπτοπ",
"cat.Parapluie": "Ομπρέλα",
"cat.Portefeuille": "Πορτοφόλι",
"cat.Poussette": "Καρότσι / Αξεσουάρ μωρού",
"cat.Sac": "Τσάντα",
"cat.SacADos": "Σακίδιο",
"cat.Souris": "Ποντίκι / Πληκτρολόγιο",
"cat.Sport": "Αθλητικός εξοπλισμός",
"cat.Tablette": "Ταμπλέτα",
"cat.Telephone": "Τηλέφωνο / Σμαρτφόν",
"cat.Trottinette": "Σκηνίτσα",
"cat.Trousse": "Θήκη / Κουτί",
"cat.USB": "USB stick / Σκληρός δίσκος",
"cat.Valise": "Βαλίτσα / Αποσκευές",
"cat.Velo": "Ποδήλατο",
"cat.Vetements": "Ρούχα",
"cat.placeholder": "Επιλέξτε κατηγορία",
"cd.d": "η",
"cd.expired": "Έχει λήξει",
"cd.h": "ώ",
"cd.m": "λ",
"ck.accept": "Αποδοχή",
"ck.acceptAll": "Αποδοχή όλων",
"ck.customize": "Προσαρμογή",
"ck.learn": "Μάθετε περισσότερα",
"ck.manage": "Διαχείριση cookies",
"ck.measurement": "Μέτρηση κοινού",
"ck.measurementDesc": "Ανώνυμες στατιστικές για την βελτίωση της υπηρεσίας.",
"ck.msg": "Χρησιμοποιούμε cookies για να κρατάμε τον ιστότοπο λειτουργικό και να μετράμε το κοινό.",
"ck.necessary": "Απαραίτητο",
"ck.necessaryDesc": "Απαραίτητο για να λειτουργήσει ο ιστότοπος. Πάντα ενεργό.",
"ck.refuse": "Απόρριψη",
"ck.save": "Αποθήκευση επιλογών μου",
"ck.saved": "Προτιμήσεις αποθηκευμένες",
"ck.title": "Οι προτιμήσεις cookie σας",
"cm.found": "ΒΡΕΘΗΚΕ",
"cm.lost": "ΧΑΘΗΚΕ",
"cmp.adv": "Ειδικές επιλογές",
"cmp.ai": "Ταιριάσματα AI",
"cmp.autobill": "Αυτόματη χρέωση",
"cmp.basic": "Βασικό",
"cmp.community": "Κοινότητα",
"cmp.consol": "Συγκεντρωμένη χρέωση",
"cmp.custom": "Προσαρμοσμένο",
"cmp.dedicated": "Αφοσιωμένο",
"cmp.deploy": "Ειδική ανάπτυξη & SLA",
"cmp.estIncl": "Εγκαταστάσεις συμπεριλαμβανομένες",
"cmp.estSec": "Επιπλέον εγκατάσταση",
"cmp.items": "Είδη / μήνα",
"cmp.main": "1 κύριο",
"cmp.max20": "20 μέγιστο",
"cmp.members": "Προσκλήσεις μελών",
"cmp.onQuote": "Προσαρμοσμένο κόστος",
"cmp.priority": "Προτεραιότητα",
"cmp.starterEst": "1 συμπεριλαμβανόμενο + απεριόριστο επιπλέον",
"cmp.stats": "Στατιστικά",
"cmp.statsAdv": "Ειδικές επιλογές",
"cmp.statsBasic": "Βασικό",
"cmp.support": "Υποστήριξη",
"cmp.unlimited": "Απεριόριστο",
"cmp.upTo3": "Έως 3",
"consent.required": "Πρέπει να συμφωνήσετε να μοιραστείτε τα στοιχεία επαφής σας για να συνεχίσετε.",
"consent.share": "Συμφωνώ ότι ο ανιχνευτής του αντικειμένου μου μπορεί να δει τα στοιχεία επαφής μου (όνομα, email, τηλέφωνο) για να με προσεγγίσει για την επιστροφή του.",
"cover.add": "Προσθέστε",
"cover.change": "Αλλαγή",
"cover.helper": "Εμφανίζεται ως ειδοποίηση στη σελίδα αναφοράς σας και στον κατάλογο.",
"cover.none": "Χωρίς φωτογραφία κάλυψης",
"cover.remove": "Αφαίρεση",
"cover.title": "Φωτογραφία κάλυψης",
"crop.desc": "Ρυθμίστε το πλαίσιο στη αναλογία πανό (3:1). Σύρετε και ζουμάρετε.",
"crop.saving": "Αποθήκευση…",
"crop.title": "Κόψτε την εξώφυλλο φωτογραφία",
"cta.button": "Δημιουργία λογαριασμού συνεργάτη",
"cta.subtitle": "Συμμετάσχετε στις εγκαταστάσεις που επιστρέφουν αντικείμενα γρηγορότερα με το findloop.",
"cta.title": "Έτοιμοι να μειώσετε τα χαμένα αντικείμενα;",
"db.account.s": "Διαχειριστείτε την εγκατάστασή σας, τη συνδρομή σας και τον QR κωδικό σας.",
"db.account.t": "Ο λογαριασμός μου",
"db.declarations.s": "Πελάτες που δήλωσαν ένα χαμένο αντικείμενο μέσω του QR κωδικού σας.",
"db.declarations.t": "Δηλώσεις απώλειας",
"db.deposit.s": "Προσθέστε μια φωτογραφία, μια κατηγορία και μια περιγραφή.",
"db.deposit.t": "Καταγραφή βρέθηκε αντικειμένου",
"db.registry.s": "Όλα τα βρέθηκαν αντικείμενα που καταγράφηκαν στην εγκατάστασή σας.",
"db.registry.t": "Μητρώο αντικειμένων",
"db.reviews.s": "Απαντήστε δημόσια στις κριτικές των πελατών σας.",
"db.reviews.t": "Κριτικές πελατών",
"db.shipments.s": "Δημιουργήστε ετικέτες και παρακολουθήστε δέματα προς αποστολή.",
"db.shipments.t": "Αποστολές",
"db.stats.s": "Οι βασικοί δείκτες απόδοσής σας.",
"db.stats.t": "Στατιστικά",
"db.team.s": "Παρέχετε πρόσκληση στους συναδέλφους σας για να διαχειριστούν αντικείμενα.",
"db.team.t": "Ομάδα",
"dc.partnerDesc": "Χάσατε το αντικείμενό σας σε μια συνεργατική τοποθεσία (ξενοδοχείο, σταθμό, αίθουσα…); Επιλέξτε την για άμεση επιστροφή.",
"dc.partnerList": "Επιλέξτε από τη λίστα",
"dc.partnerMap": "Επιλέξτε στον χάρτη",
"dc.partnerTitle": "Δήλωση σε συνεργάτη",
"dc.publicCta": "Δημοσιεύστε μια δημόσια αγγελία",
"dc.publicDesc": "Η αγγελία σας θα είναι ορατή σε ολόκληρη την κοινότητα του findloop. Ιδανικό αν δεν ξέρετε πού χάσατε το αντικείμενο.",
"dc.publicTitle": "Δημόσια δήλωση",
"dc.subtitle": "Επιλέξτε πώς να δηλώσετε το χαμένο σας αντικείμενο.",
"dc.title": "Τι θα θέλατε να κάνετε;",
"dec.addrPending": "Διεύθυνση αναμένοντας από τον πελάτη",
"dec.analyzing": "Ανάλυση…",
"dec.badge": "Δήλωση απώλειας",
"dec.category": "Κατηγορία αντικειμένου",
"dec.clientDescription": "Περιγραφή πελάτη",
"dec.clientPhoto": "Φωτογραφία που παρέχεται από τον πελάτη",
"dec.clientPhotoShort": "Φωτογραφία πελάτη",
"dec.comparePhotos": "Συγκρίνετε φωτογραφίες",
"dec.contactTitle": "Στοιχεία επικοινωνίας σας",
"dec.date": "Ημερομηνία απώλειας",
"dec.declaredItemPhoto": "Φωτογραφία του δηλωθέντος αντικειμένου",
"dec.descPh": "Περιγράψτε το αντικείμενο: μάρκα, χρώμα, διακριτικά σημάδια…",
"dec.description": "Περιγραφή",
"dec.email": "Email",
"dec.emptyDesc": "Μοιραστείτε τον QR κωδικό σας για να λάβετε δηλώσεις.",
"dec.emptyTitle": "Καμία δήλωση",
"dec.enlarge": "Μεγέθυνση",
"dec.extBanner": "{n} εξωτερική πληρωμή(ές) προς επιβεβαίωση — επιβεβαιώστε την παραλαβή παρακάτω για να ξεκλειδώσετε την παράδοση ή την αποστολή.",
"dec.foundItemAlt": "Βρέθηκε αντικείμενο",
"dec.foundItemRegistry": "Βρέθηκε αντικείμενο (μητρώο)",
"dec.home": "Επιστροφή στην αρχική",
"dec.labelClient": "Πελάτης",
"dec.labelRegistry": "Μητρώο",
"dec.matchFound": "Έχουν ήδη ταυτοποιηθεί ταίριασμα!",
"dec.name": "Πλήρες όνομα",
"dec.noMatchYet": "Κανένα ταίριασμα ακόμα.",
"dec.noPhoto": "Καμία φωτογραφία",
"dec.notfound": "Συνεργάτης δεν βρέθηκε.",
"dec.pRecup": "ανάκτηση",
"dec.pRecupP": "(ανάκτηση)",
"dec.pRecupShip": "(ανάκτηση + αποστολή)",
"dec.payConfirmed": "Η πληρωμή {x} επιβεβαιώθηκε",
"dec.payPending": "Εξωτερική πληρωμή {x} σε εκκρεμότητα",
"dec.phone": "Τηλέφωνο",
"dec.pickup": "Αυτοπρόσωπη παραλαβή",
"dec.place": "Τόπος απώλειας",
"dec.placePh": "π.χ. στο μπαρ, δωμάτιο 204…",
"dec.recoverBtn": "Ανάκτηση του αντικειμένου μου",
"dec.reject": "Απόρριψη",
"dec.rerun": "Επαναφορά της ανάλυσης",
"dec.similarity": "Ομοιότητα {n}%",
"dec.submit": "Υποβολή της αναφοράς μου",
"dec.submitting": "Αποστολή…",
"dec.successText": "Ψάχνουμε για το αντικείμενό σας μεταξύ αυτών που διατηρούνται στο",
"dec.successTitle": "Η αναφορά υποβλήθηκε!",
"dec.suggestedMatches": "Προτεινόμενοι αγώνες",
"dec.toColon": " σε:",
"dec.toShip": "Για αποστολή",
"dec.toastExtPay": "Η πληρωμή επιβεβαιώθηκε — ο πελάτης θα ειδοποιηθεί.",
"dec.toastMatch": "Αγώνας επιβεβαιώθηκε",
"dec.toastReject": "Η πρόταση απορρίφθηκε",
"dec.toastRerun": "Η ανάλυση επαναλήφθηκε",
"dec.toastVisualN": "{n} οπτικός αγώνας(ες)",
"dec.toastVisualNone": "Κανένας οπτικός αγώνας",
"dec.trackBtn": "Παρακολούθηση της αναφοράς μου",
"dec.viewBeforeAfter": "Προβολή πριν/μετά (επικάλυψη)",
"dec.viewSideBySide": "Προβολή πλάι-πλάι",
"dec.visualCompare": "Οπτική σύγκριση AI",
"dec.visualIdle": "Εκτελέστε τη σύγκριση ώστε να ταιριάξει ο οπτικός AI με τη φωτογραφία του πελάτη με τα βρεθέντα αντικείμενα.",
"dec.visualRunning": "Ο AI συγκρίνει τη φωτογραφία του πελάτη με τα αντικείμενα στη βάση δεδομένων σας…",
"dec.zoomPhoto": "Μεγέθυνση της φωτογραφίας",
"dep.addAnyway": "Προσθήκη παρ' όλα αυτά",
"dep.addError": "Σφάλμα κατά την προσθήκη",
"dep.addItem": "Προσθήκη αντικειμένου",
"dep.added": "Αντικείμενο προστέθηκε στη βάση δεδομένων!",
"dep.adding": "Προσθήκη…",
"dep.aiError": "Η ανάλυση AI δεν είναι διαθέσιμη αυτή τη στιγμή.",
"dep.aiFilled": "Η φόρμα έχει συμπληρωθεί από τον AI ✨",
"dep.aiUnavailable": "AI μη διαθέσιμο — συμπληρώστε τη φόρμα χειροκίνητα.",
"dep.analyzing": "Ανάλυση…",
"dep.analyzingPhoto": "Ανάλυση φωτογραφίας…",
"dep.brand": "Μάρκα",
"dep.brandPlaceholder": "π.χ. Apple",
"dep.category": "Κατηγορία",
"dep.checkingDup": "Έλεγχος για διπλότυπα…",
"dep.color": "Χρώμα",
"dep.colorPlaceholder": "π.χ. μαύρο",
"dep.condition": "Κατάσταση",
"dep.conditionPlaceholder": "π.χ. σε καλή κατάσταση",
"dep.depositorNote": "Σημείωση καταθέτη",
"dep.depositorNoteHint": "Λειτουργικές λεπτομέρειες που πληκτρολογήθηκαν χειροκίνητα. Ο AI ποτέ δεν αντικαθιστά αυτή τη σημείωση.",
"dep.depositorNotePlaceholder": "π.χ. περιεχόμενα μιας τσέπης, μάρκα όπως αναφέρθηκε, λεπτομέρειες από το άτομο…",
"dep.descPlaceholder": "π.χ. μαύρο iPhone 15 με διαφανή θήκη, βρέθηκε στο μπαρ…",
"dep.description": "Περιγραφή",
"dep.dupHint": "Βεβαιωθείτε ότι δεν προσθέτετε ένα διπλότυπο. Μπορείτε να συνεχίσετε αν το αντικείμενο είναι πραγματικά διαφορετικό.",
"dep.dupTitle": "Παρόμοιο αντικείμενο(α) ήδη καταγεγραμμένα",
"dep.dupWarn": "Ανιχνεύθηκε παρόμοιο αντικείμενο — αναθεωρήστε, στη συνέχεια κάντε κλικ ξανά για επιβεβαίωση.",
"dep.estHint": "Το αντικείμενο θα προστεθεί στην βάση δεδομένων αυτού του καταστήματος.",
"dep.establishment": "Κατάστημα",
"dep.fee": "Τέλος ανάκτησης (€) — προαιρετικό",
"dep.feePlaceholder": "Αφήστε κενό για την προεπιλεγμένη τιμή της κατηγορίας",
"dep.fillAI": "Συμπλήρωση με AI",
"dep.optional": "(προαιρετικό)",
"dep.photo": "Φωτογραφία αντικειμένου",
"dep.principal": "κύριο",
"dep.reqError": "Η κατηγορία και η περιγραφή είναι υποχρεωτικές.",
"dep.savedItem": "Καταγεγραμμένο αντικείμενο",
"dep.similarity": "Ομοιότητα",
"dep.storage": "Φυσική τοποθεσία",
"dep.storageHint": "Όπου είναι φυσικά αποθηκευμένο το αντικείμενο. Θα παραχθεί ένας QR κωδικός για να το βρείτε.",
"dep.storagePlaceholder": "π.χ. Ράφι A3, Ντουλάπι 12, Θυρίδα υποδοχής",
"dl.aClient": "ένας πελάτης",
"dl.alertsBlocked": "Οι ειδοποιήσεις του προγράμματος περιήγησης είναι αποκλεισμένες",
"dl.alertsBlockedHint": "Για να τις ενεργοποιήσετε ξανά: κάντε κλικ στο εικονίδιο 🔒 (ή ⓘ) στα αριστερά της διεύθυνσης του ιστότοπου, στη συνέχεια επιτρέψτε τις Ειδοποιήσεις και ανανεώστε τη σελίδα.",
"dl.amountDue": "Οφειλόμενο ποσό: {amount} {currency}.",
"dl.enableAlerts": "Ενεργοποίηση ειδοποιήσεων",
"dl.extPending": "Πληρωμές προς επαλήθευση",
"dl.freemiumNear": "Πλησιάζετε στο όριο Freemium ({used}/{max} αντικείμενα αυτόν τον μήνα). Αναβαθμίστε σε Starter για απεριόριστα αντικείμενα.",
"dl.freemiumReached": "Επιτεύχθηκε το όριο Freemium ({used}/{max} αντικείμενα αυτόν τον μήνα). Αναβαθμίστε σε Starter για να καταχωρίσετε απεριόριστα αντικείμενα.",
"dl.invoiceOverdue": "Τιμολόγιο {num} μη πληρωμένο — πρόσβαση περιορισμένη.",
"dl.matchNotifTitle": "Findloop — Νέα αντιστοίχιση AI 🔔",
"dl.matchToast": "Νέα αντιστοίχιση AI — {name}",
"dl.matchToastDesc": "Ένα αντικείμενο ταιριάζει με μια δήλωση.",
"dl.notifEmpty": "Δεν υπάρχουν ειδοποιήσεις ακόμα.",
"dl.notifEnabled": "Οι ειδοποιήσεις του προγράμματος περιήγησης είναι ενεργοποιημένες",
"dl.notifTitle": "Ειδοποιήσεις",
"dl.payInvoice": "Πληρώστε το τιμολόγιό μου →",
"dl.rewardsPending": "Κουπόνια προς παρουσίαση",
"dl.upgradeStarter": "Αναβάθμιση σε Starter →",
"est.all": "Όλες οι εγκαταστάσεις ({n})",
"est.label": "Εγκατάσταση",
"est.primary": "κύριο",
"est.secondary": "δευτερεύον",
"est2.add": "Προσθήκη εγκατάστασης",
"est2.addressLabel": "Διεύθυνση",
"est2.addressPh": "12 Οδός République",
"est2.autoInvoice": "Ένα λεπτομερές τιμολόγιο δημιουργείται αυτόματα την 1η κάθε μήνα.",
"est2.baseSub": "Βασική συνδρομή",
"est2.billing": "Χρέωση",
"est2.boostActivated": "Ενεργοποιήθηκε η προώθηση για {name}",
"est2.boostBillingNote": "Χρεώνεται με την τρέχουσα τιμή και ομαδοποιείται στο συνοδευτικό μηνιαίο τιμολόγιό σας.",
"est2.boostCta": "Προώθηση",
"est2.boostDesc": "Βελτιώστε την ορατότητα αυτής της εγκατάστασης στον κατάλογο και στον χάρτη.",
"est2.boostDuration": "{h}h προωθημένης ορατότητας",
"est2.boostExtend": "Παράταση",
"est2.boostTitle": "Προώθηση {name}",
"est2.boosted": "Προωθημένο",
"est2.chartDesc": "Μερίδιο επιστρεφόμενων αντικειμένων από τον συνολικό καταγεγραμμένο αριθμό, κατά ιστότοπο.",
"est2.chartTitle": "Ποσοστό επιστροφής ανά εγκατάσταση",
"est2.chartTooltip": "Επιστροφή",
"est2.cityLabel": "Πόλη",
"est2.cityPh": "Λυών",
"est2.contactHint": "Αυτές οι λεπτομέρειες εμφανίζονται στον πελάτη για αυτή την εγκατάσταση (επιστρέφει στον λογαριασμό αν είναι κενές).",
"est2.countryLabel": "Χώρα",
"est2.coverLabel": "Φωτογραφία εξωφύλλου",
"est2.create": "Δημιουργία",
"est2.created": "Η εγκατάσταση δημιουργήθηκε",
"est2.delete": "Διαγραφή",
"est2.deleteDesc": "Αυτή η ενέργεια είναι μόνιμη. Μπορείτε να διαγράψετε μια εγκατάσταση μόνο εάν δεν περιέχει αντικείμενα.",
"est2.deleteTitle": "Διαγραφή “{name}”;",
"est2.deleted": "Η εγκατάσταση διαγράφηκε",
"est2.dialogDesc": "Εισάγετε το όνομα και τη διεύθυνση αυτού του χώρου.",
"est2.edit": "Επεξεργασία",
"est2.editEst": "Επεξεργασία εγκατάστασης",
"est2.emailLabel": "Email επαφής",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " εγκατάσταση(εις)",
"est2.extraNoteBase": "{n} επιπλέον εγκατάσταση(εις) χρεώνονται",
"est2.extraPrice": " στα {price} €/μήνα.",
"est2.extraQuote": " σε προσφορά.",
"est2.imgChange": "Επιλέξτε μια εικόνα",
"est2.imgDone": "Έγινε",
"est2.imgRemove": "Αφαίρεση",
"est2.imgRemoved": "Η εικόνα αφαιρέθηκε",
"est2.imgSaved": "Η εικόνα αποθηκεύτηκε",
"est2.imgUploading": "Μεταφόρτωση…",
"est2.includedPlan": "Περιλαμβάνεται στο σχέδιο σας: {n}.",
"est2.kDeclarations": "Δηλώσεις",
"est2.kInStorage": "Σε αποθήκευση",
"est2.kItemsTotal": "Αντικείμενα (συνολικά)",
"est2.kRestituted": "Επιστραφέντα",
"est2.limitReached": "Επιτεύχθηκε το όριο",
"est2.logoLabel": "Λογότυπο",
"est2.mDeclar": "Δηλ.",
"est2.mItems": "Αντικείμενα",
"est2.mRestituted": "Επιστραφέντα",
"est2.mStorage": "Σε αποθήκευση",
"est2.monthlyTotal": "Μηνιαίο σύνολο",
"est2.nameLabel": "Όνομα *",
"est2.namePh": "π.χ. Ξενοδοχείο Belmont — Παράρτημα Λυόν",
"est2.newEst": "Νέα εγκατάσταση",
"est2.onQuote": "Σε προσφορά",
"est2.phoneLabel": "Τηλέφωνο",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Σχέδιο",
"est2.planLimited": "Το σχέδιο σας “{tier}” περιορίζεται σε {max} εγκατάσταση(εις).",
"est2.primary": "Πρωτεύων",
"est2.qr": "QR κωδικός",
"est2.qrDesc": "Εμφανίστε αυτόν τον QR κωδικό σε αυτή την εγκατάσταση. Οι πελάτες που αναφέρουν απώλεια θα συνδεθούν με αυτόν τον χώρο.",
"est2.qrTitle": "QR κωδικός — {name}",
"est2.saving": "Αποθήκευση…",
"est2.seeInvoices": "Δείτε τις μηνιαίες τιμολόγήσεις μου",
"est2.seePlans": "Δείτε τα σχέδια",
"est2.subtitle": "Διαχειριστείτε όλους τους χώρους σας κάτω από έναν λογαριασμό — ενοποιημένη θέα, αντικείμενα, QR κωδικός και χρέωση.",
"est2.suspended": "Ανασταλεί",
"est2.tierFree": "1 εγκατάσταση",
"est2.tierLarge": "απεριόριστες εγκαταστάσεις",
"est2.tierMedium": "5 εγκαταστάσεις περιλαμβάνονται",
"est2.tierSmall": "3 εγκαταστάσεις περιλαμβάνονται",
"est2.title": "Εγκαταστάσεις",
"est2.unlimitedPlan": "Το σχέδιο σας επιτρέπει απεριόριστο αριθμό εγκαταστάσεων.",
"est2.unlimitedSuffix": " · απεριόριστο",
"est2.updated": "Η εγκατάσταση ενημερώθηκε",
"est2.upgradeHint": "Αναβαθμίστε σε ανώτερο σχέδιο για να προσθέσετε περισσότερους χώρους και να ενοποιήσετε όλη σας την δραστηριότητα.",
"est2.visuals": "Λογότυπο & φωτογραφία",
"est2.visualsDesc": "Προσαρμόστε το λογότυπο και την εξώφυλλη φωτογραφία αυτής της εγκατάστασης. Εμφανίζονται στη δημόσια σελίδα της και στη φόρμα δήλωσης.",
"est2.visualsTitle": "Οπτικά — {name}",
"est2.workOn": "Εργασία σε αυτή την εγκατάσταση",
"est2.working": "Εργάζεστε στην “{name}”",
"ev.created": "Αναφορά δημιουργήθηκε",
"ev.matched": "Αντίστοιχο αντικείμενο εντοπίστηκε",
"ev.paid": "Τέλος ανάκτησης πληρωμένο",
"ev.pickup": "Παραλαβή στον τόπο",
"ev.shipped": "Δέμα αποστάλθηκε",
"ev.shipping_paid": "Τέλος αποστολής πληρωμένο",
"ev.shipping_requested": "Αποστολή ζητήθηκε",
"feat1.d": "KPIs, ποσοστό επιστροφών ανά κατηγορία, έσοδα και τάσεις 30 ημερών.",
"feat1.t": "Πίνακας ελέγχου & αναλύσεις",
"feat2.d": "Ετικέτες, παρακολούθηση μεταφορέα και αυτόματα emails παρακολούθησης.",
"feat2.t": "Μονάδα αποστολής",
"feat3.d": "Οι πελάτες σας βρίσκουν ανά πόλη και κατηγορία, με πιστοποιημένες κριτικές.",
"feat3.t": "Δημόσιος κατάλογος & κριτικές",
"fp.backToRanking": "Πίσω στην κατάταξη",
"fp.badge": "Εμβληματικό",
"fp.hero": "Finder Hero",
"fp.notFound": "Προφίλ δεν βρέθηκε ή είναι ιδιωτικό.",
"fp.scoreTotal": "Συνολικοί πόντοι",
"fp.scoreYear": "Πόντοι το",
"fp.share": "Μοιραστείτε αυτό το προφίλ",
"fp.shareText": "Δείτε το προφίλ του {name} στον finder στο Findloop!",
"fp.tagline": "Ένας ειλικρινής finder κάνει τον κόσμο καλύτερο.",
"ft.backAccount": "Πίσω στον Λογαριασμό μου",
"ft.closeBtn": "Κλείσιμο της υπόθεσης",
"ft.closeConfirm": "Επιβεβαιώνετε ότι το αντικείμενο επιστράφηκε; Η διαφήμιση θα κλείσει.",
"ft.closeLockedHint": "Επιβεβαιώστε πρώτα τον κωδικό του ιδιοκτήτη για να ξεκλειδώσετε το κλείσιμο.",
"ft.closed": "Υπόθεση κλειστή — το αντικείμενο επιστράφηκε!",
"ft.codeLabel": "Εισάγετε τον κωδικό επιβεβαίωσης που λάβατε από τον ιδιοκτήτη",
"ft.codeNeeded": "Παρακαλώ εισάγετε τον κωδικό επιβεβαίωσης.",
"ft.codeOk": "Κωδικός επιβεβαιωμένος — μπορείτε να κλείσετε την υπόθεση.",
"ft.codePlaceholder": "π.χ. 4821",
"ft.codeVerified": "Επιβεβαιωμένος",
"ft.doneMsg": "Το αντικείμενο επιστράφηκε. Ευχαριστούμε που βοηθήσατε να επιστραφεί στον ιδιοκτήτη του!",
"ft.stepInProgress": "Επιστροφή σε εξέλιξη",
"ft.stepPublished": "Διαφήμιση δημοσιευμένη",
"ft.stepReturned": "Το αντικείμενο επιστράφηκε",
"ft.subtitle": "Ακολουθήστε τα βήματα μέχρι το βρεθέν αντικείμενο να επιστραφεί.",
"ft.title": "Παρακολούθηση επιστροφής",
"ft.verifyBtn": "Επιβεβαίωση κωδικού",
"hero.badge": "Δημοφιλές",
"hero.ctaFound": "Βρήκα ένα αντικείμενο",
"hero.ctaLost": "Είχα ένα αντικείμενο που χάθηκε",
"hero.ctaPartner": "Γίνετε συνεργάτης",
"hero.subtitle": "το Findloop βοηθά τις επιχειρήσεις να διαχειρίζονται τα βρεθέντα αντικείμενα — και επιτρέπει στους πελάτες τους να αναφέρουν μια απώλεια και να ανακτούν τα αντικείμενά τους, είτε στο σημείο είτε με αποστολή.",
"hero.title": "Κάθε χαμένο αντικείμενο βρίσκει τον ιδιοκτήτη του.",
"home.champBecome": "Γίνετε finder",
"home.champCta": "Δείτε την κατάταξη",
"home.champSubtitle": "Κάθε επιστραμμένο αντικείμενο κερδίζει πόντους. Εγγραφείτε στην κατάταξη και κερδίστε ανταμοιβές.",
"home.champTitle": "Οι κορυφαίοι μας finders",
"how.eyebrow": "Πώς λειτουργεί",
"how.title": "Από την παράδοση μέχρι την επιστροφή, χωρίς κόπο.",
"inv.all": "Όλα",
"inv.allYears": "Όλες οι χρονιές",
"inv.count": "Τιμολόγια",
"inv.due": "ληγμένα",
"inv.empty": "Δεν υπάρχουν τιμολόγια ακόμα.",
"inv.exportCsv": "Εξαγωγή CSV",
"inv.invoicePdf": "Τιμολόγιο PDF",
"inv.issued": "Εκδόθηκε",
"inv.noMatch": "Δεν υπάρχει τιμολόγιο για αυτό το φίλτρο.",
"inv.paid": "Πληρωμένο (€)",
"inv.paidOn": "πληρώθηκε στις",
"inv.pay": "Πληρωμή",
"inv.receipt": "Απόδειξη",
"inv.reminders": "Υποδείξεις",
"inv.remindersDesc": "Υποδείξεις μέσω email και SMS αποστέλλονται για αυτό το τιμολόγιο.",
"inv.remindersEmpty": "Καμία υπενθύμιση δεν στάλθηκε.",
"inv.rmDue": "Υπενθύμιση προθεσμίας",
"inv.rmManual": "Χειροκίνητη υπενθύμιση",
"inv.rmSms": "Υπενθύμιση SMS D+30",
"inv.rmStage": "Υπενθύμιση",
"inv.statusPaid": "Πληρωμένο",
"inv.statusUnpaid": "Απλήρωτο",
"inv.subtitle": "Δείτε και κατεβάστε τα τιμολόγια και τις αποδείξεις σας.",
"inv.title": "Τα τιμολόγιά μου",
"inv.unpaid": "Απλήρωτο (€)",
"inv2.contractTitle": "Η σύμβαση μου με την Findloop",
"inv2.detailByEst": "Λεπτομέρειες ανά ίδρυμα",
"inv2.dueLabel": "Προθεσμία:",
"inv2.dueSuffix": " · προθεσμία {date}",
"inv2.error": "Σφάλμα {status}",
"inv2.estCountIssued": "{n} ίδρυμα(τα) · εκδόθηκε στις {date}",
"inv2.estimate": "Εκτίμηση (χωρίς χρέωση) · {n} ίδρυμα(τα)",
"inv2.expired": " · ληξιπρόθεσμο",
"inv2.exportCsv": "Εξαγωγή CSV",
"inv2.exportDone": "Η εξαγωγή CSV κατεβάστηκε",
"inv2.included": "Συμπεριλαμβάνεται",
"inv2.monthlyTitle": "Μηνιαία χρέωση (συνδρομή)",
"inv2.months": "+{n} μήνες",
"inv2.paid": "Πληρωμένο",
"inv2.pay": "Πληρωμή",
"inv2.previewTitle": "Προεπισκόπηση του επόμενου τιμολογίου σας —",
"inv2.renew": "Ανανεώστε τη σύμβασή μου",
"inv2.renewalsTitle": "Ιστορικό ανανεώσεων ({n})",
"inv2.renewedUntil": "Η σύμβαση ανανεώθηκε μέχρι {date}",
"inv2.serviceTitle": "Τιμολόγια υπηρεσιών (αποκαταστάσεις & προσφορές)",
"inv2.soon": "Λήγει σύντομα",
"inv2.toPay": "Προς πληρωμή",
"inv2.totalHtTva": "Σύνολο χωρίς φόρο · ΦΠΑ",
"inv2.totalTtc": "Σύνολο με φόρο",
"iu.addPhoto": "Προσθέστε μια φωτογραφία",
"iu.change": "Αλλαγή",
"lang.label": "Γλώσσα",
"lb.allCountries": "Όλες οι χώρες",
"lb.badge": "Ετήσιος πίνακας κορυφαίων",
"lb.champion": "🏆 Πρωταθλητής της χρονιάς",
"lb.cityPh": "Φιλτράρετε κατά πόλη…",
"lb.empty": "Δεν υπάρχουν κατατάξεις για αυτά τα φίλτρα ακόμα.",
"lb.pts": "πόντοι",
"lb.resetNote": "Πίνακας κορυφαίων τρέχουσας χρονιάς — επαναρυθμίζεται κάθε 1 Ιανουαρίου.",
"lb.returned": "επιστράφηκε",
"lb.share": "Μοιραστείτε τον πίνακα κορυφαίων",
"lb.shareText": "Δείτε τον πίνακα κορυφαίων ανιχνευτών στο Findloop!",
"lb.subtitle": "Κάθε επιστροφή κερδίζει πόντους. Ο πίνακας κορυφαίων επαναρυθμίζεται κάθε 1 Ιανουαρίου.",
"lb.tabFinders": "Ανιχνευτές",
"lb.tabPartners": "Ιδρύματα",
"lb.title": "Κορυφαίοι ανιχνευτές",
"lost.b2bDesc": "Το χάσατε σε ξενοδοχείο, κόμβο μεταφορών ή συνεργαζόμενο χώρο; Βρείτε το ίδρυμα και αναφέρετε την απώλειά σας.",
"lost.b2bTitle": "Αναφορά σε συνεργάτη",
"lost.b2cDesc": "Δημοσιεύστε μια διαφήμιση ορατή σε όλους, προσφέρετε ανταμοιβή και προβάλετέ την για να αυξήσετε τις πιθανότητές σας.",
"lost.b2cTitle": "Δημοσιεύστε μια δημόσια διαφήμιση",
"lost.desc": "Επιλέξτε πώς θέλετε να προχωρήσετε.",
"lost.title": "Χάσατε ένα αντικείμενο;",
"map.allCategories": "Όλες οι κατηγορίες",
"map.clear": "Επαναφορά",
"map.exitFullscreen": "Έξοδος",
"map.filterCity": "Πόλη ή χώρα…",
"map.fullscreen": "Πλήρης οθόνη",
"map.heatmap": "Θερμικός χάρτης",
"map.high": "Υψηλό",
"map.impactMonth": "αντικείμενα που επιστράφηκαν αυτόν τον μήνα",
"map.impactTotal": "επιστραφέντα συνολικά",
"map.legend": "Χρωματιστές κουκίδες από κόκκινο (χαμηλό) έως πράσινο (υψηλό) με βάση τον ρυθμό επιστροφής; μέγεθος με βάση τον αριθμό των αντικειμένων.",
"map.locating": "Εντοπισμός… προσθέστε μια διεύθυνση στις εγκαταστάσεις σας για να τις δείτε στον χάρτη.",
"map.low": "Χαμηλό",
"map.mAll": "Όλα",
"map.mFound": "Βρέθηκαν",
"map.mLost": "Χάθηκαν",
"map.medium": "Μεσαίο",
"map.noItemRegistered": "Δεν έχει καταχωρηθεί αντικείμενο",
"map.noItems": "Κανένα αντικείμενο",
"map.period30": "Τελευταίες 30 ημέρες",
"map.period7": "Τελευταίες 7 ημέρες",
"map.period90": "Τελευταίες 90 ημέρες",
"map.periodAll": "Όλος ο χρόνος",
"map.returnedSuffix": "επιστραφέντα · {a}/{t} αντικείμενα",
"map.stats": "Στατιστικά πόλης",
"map.statsTop": "Top 5 μέρη (χαμένα αντικείμενα)",
"map.statsTrend": "Τάση 6 μηνών",
"map.title": "Χάρτης των εγκαταστάσεών σας",
"map.topPlaces": "Δημοφιλή μέρη",
"mc.adClosed": "Η καταχώριση έχει κλείσει",
"mc.addPhoto": "Προσθήκη φωτογραφίας",
"mc.adsNone": "Δεν υπάρχουν καταχωρίσεις χαμένων αντικειμένων.",
"mc.archiveHide": "Απόκρυψη ιστορικού",
"mc.archiveNone": "Δεν υπάρχει ακόμη ούτε μία λυμένη περίπτωση.",
"mc.archiveShow": "Εμφάνιση ιστορικού",
"mc.archiveSub": "Λυμένες και επιστραμμένες περιπτώσεις.",
"mc.archiveTitle": "Ιστορικό",
"mc.at": "Στο",
"mc.backToLogin": "Πίσω στην είσοδο",
"mc.boostContacts": "Επαφές (ενίσχυση)",
"mc.boostViews": "Προβολές (ενίσχυση)",
"mc.cancel": "Ακύρωση",
"mc.certificate": "Πιστοποιητικό",
"mc.changePhoto": "Αλλαγή φωτογραφίας",
"mc.city": "Πόλη",
"mc.closeAd": "Κλείσιμο",
"mc.closeAdConfirm": "Θέλετε να κλείσετε αυτήν την καταχώριση; Δεν θα είναι πλέον ορατή και θα ελευθερωθεί μια θέση.",
"mc.confirmPassword": "Επιβεβαίωση κωδικού",
"mc.confirmRestitution": "Επιβεβαίωση επιστροφής",
"mc.connect": "Σύνδεση",
"mc.contacts": "Επαφές",
"mc.country": "Χώρα",
"mc.declareFound": "Αναφορά ευρέσιμου αντικειμένου",
"mc.declareFoundSub": "Δημοσιεύστε ένα αντικείμενο που βρήκατε",
"mc.declareLost": "Αναφορά απώλειας",
"mc.declareLostSub": "Δημοσιεύστε μία καταχώριση χαμένου αντικειμένου",
"mc.deleteAccount": "Διαγραφή του λογαριασμού μου",
"mc.deleteConfirm": "Ναι, διαγραφή του λογαριασμού μου",
"mc.deleteConfirmBody": "Ο λογαριασμός σας θα διαγραφεί μόνιμα και τα προσωπικά σας δεδομένα θα μετατραπούν σε ανώνυμα. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
"mc.deleteConfirmTitle": "Θέλετε να διαγράψετε τον λογαριασμό σας;",
"mc.deleteDesc": "Διαγράφει μόνιμα τον λογαριασμό σας και ανωνυμοποιεί τα προσωπικά σας δεδομένα. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
"mc.deleted": "Ο λογαριασμός σας έχει διαγραφεί.",
"mc.deleting": "Διαγραφή…",
"mc.email": "Email",
"mc.expiresOn": "Λήγει στις",
"mc.exportData": "Κατεβάστε τα δεδομένα μου (GDPR)",
"mc.exportDone": "Τα δεδομένα σας έχουν κατεβεί.",
"mc.exporting": "Ετοιμασία…",
"mc.finderAccepted": "Εγκεκριμένο",
"mc.finderProfile": "Προφίλ finder (προαιρετικό)",
"mc.finderProfileDesc": "Κερδίστε πόντους επιστρέφοντας αντικείμενα και εμφανίστε τον δημόσιο πίνακα κατάταξης.",
"mc.forYourAd": "Για την καταχώρισή σας",
"mc.forgotLink": "Ξεχάσατε τον κωδικό;",
"mc.forgotSend": "Στείλτε τον σύνδεσμο",
"mc.forgotSent": "Αν υπάρχει λογαριασμός με αυτό το email, έχει μόλις σταλεί ένας σύνδεσμος επαναφοράς.",
"mc.forgotTitle": "Ξεχάσατε τον κωδικό",
"mc.foundAdsNone": "Δεν έχει δημοσιευθεί καμία καταχώριση αντικειμένου που βρέθηκε.",
"mc.foundAt": "Βρέθηκε στο",
"mc.foundNone": "Δεν έχει αναφερθεί κανένα αντικείμενο που βρέθηκε.",
"mc.hAd": "Αγγελία για χαμένο αντικείμενο",
"mc.hDeclaration": "Δήλωση",
"mc.hFinderContact": "Αναφερθέν αντικείμενο",
"mc.hFound": "Επιστραφέν αντικείμενο",
"mc.hFoundAd": "Αγγελία για βρέθηκαν αντικείμενα",
"mc.histEarned": "Αντικείμενο επιστραμμένο",
"mc.historyTitle": "Ιστορικό πόντων μου",
"mc.loginBtn": "Σύνδεση",
"mc.loginTitle": "Σύνδεση πελάτη",
"mc.logout": "Αποσύνδεση",
"mc.lostAt": "Χαμένο στο",
"mc.matchPartner": "Σε συνεργάτη",
"mc.matchPublic": "Βρέθηκε αντικείμενο",
"mc.matches": "Ταίριασμα",
"mc.matchesSub": "Τα βρέθηκαν αντικείμενα μπορεί να ταιριάζουν με τις καταχωρίσεις χαμένων αντικειμένων σας.",
"mc.myAds": "Οι αγγελίες χαμένων αντικειμένων μου",
"mc.myDeclarations": "Οι αναφορές μου",
"mc.myFinds": "Αντικείμενα που βρήκα",
"mc.myFindsNone": "Δεν έχετε αναφέρει ότι βρήκατε κάποιο αντικείμενο ακόμα.",
"mc.myFindsSub": "Αντικείμενα που αναφέρατε ότι βρήκατε στις αγγελίες χαμένων αντικειμένων.",
"mc.myFound": "Αναφερθέντα βρέθηκαν αντικείμενα",
"mc.myFoundAds": "Οι καταχωρίσεις βρέθηκαν αντικείμενα μου",
"mc.myRewards": "Τα κουπόνια μου",
"mc.name": "Πλήρες όνομα",
"mc.newPassword": "Νέος κωδικός",
"mc.none": "Δεν υπάρχει αναφορά ακόμα.",
"mc.notEnough": "Δεν είναι αρκετοί πόντοι",
"mc.notifEmpty": "Δεν υπάρχουν ειδοποιήσεις ακόμα.",
"mc.notifOpen": "Προβολή",
"mc.notifTitle": "Ειδοποιήσεις",
"mc.notifTrack": "Παρακολούθηση",
"mc.notifViewAd": "Προβολή αγγελίας",
"mc.optInDesc": "Προαιρετική συμμετοχή. Συμφωνείτε να εμφανίζονται δημόσια τα αντικείμενα που επιλέγετε παρακάτω. Μπορεί να αλλάξει ανά πάσα στιγμή.",
"mc.optInTitle": "Εμφάνιση στον δημόσιο πίνακα κατάταξης",
"mc.password": "Κωδικός",
"mc.passwordMismatch": "Οι κωδικοί δεν ταιριάζουν.",
"mc.phone": "Τηλέφωνο",
"mc.photoUpdated": "Η εικόνα προφίλ ενημερώθηκε",
"mc.pointsAwaiting": "Πόντοι σε αναμονή",
"mc.pointsBalance": "Πόντοι προς ξόδεμα",
"mc.pointsOk": "Πόντοι πιστωμένοι",
"mc.presentHint": "Δείξε αυτό το QR στον συνεργάτη: το σκανάρει για να επικυρώσει την ανταμοιβή σου.",
"mc.presentInStore": "Δείξε στο κατάστημα",
"mc.presentTitle": "Δείξε αυτό το κουπόνι",
"mc.privacy": "Απόρρητο & δεδομένα",
"mc.privacyDesc": "Κατέβασε ένα αντίγραφο όλων των προσωπικών δεδομένων που διατηρεί η Findloop για σένα (GDPR, άρθρο 15 & 20).",
"mc.profileSaved": "Το προφίλ ενημερώθηκε.",
"mc.profileSettings": "Δημόσιο προφίλ & κατάταξη",
"mc.pseudo": "Όνομα ή ψευδώνυμο",
"mc.redExpired": "Ληξιπρόθεσμο",
"mc.redReady": "Δείξε στον συνεργάτη",
"mc.redUsed": "Χρησιμοποιημένο",
"mc.redeem": "Εξαργύρωση",
"mc.registerBtn": "Δημιουργία λογαριασμού",
"mc.registerTitle": "Δημιουργία λογαριασμού πελάτη",
"mc.rememberMe": "Να με θυμάσαι",
"mc.remove": "Αφαίρεση",
"mc.resetDone": "Ο κωδικός πρόσβασης ενημερώθηκε. Μπορείς τώρα να συνδεθείς.",
"mc.resetExpired": "Αυτός ο σύνδεσμος επαναφοράς είναι μη έγκυρος ή έχει λήξει. Ζήτησε έναν νέο παρακάτω.",
"mc.resetSave": "Επαναφορά του κωδικού μου",
"mc.resetTitle": "Νέος κωδικός πρόσβασης",
"mc.restitutionConfirmed": "Η επιστροφή επιβεβαιώθηκε.",
"mc.reward": "Ανταμοιβή",
"mc.rewardRedeemed": "Η ανταμοιβή ξεκλειδώθηκε! Κωδικός:",
"mc.rewardsDesc": "Χρησιμοποίησε τους πόντους σου για προνόμια που προσφέρουν οι συνεργάτες μας. Υπόλοιπο:",
"mc.rewardsNone": "Δεν υπάρχουν διαθέσιμες ανταμοιβές ακόμα.",
"mc.rewardsTitle": "Ξόδευσε τους πόντους μου",
"mc.scoreAwarded": "Μπράβο! +1 στο Finder Score σου 🎉",
"mc.scoreEarned": "Πόντος κερδισμένος",
"mc.scorePts": "pts",
"mc.scoreThisYear": "Αυτή την χρονιά",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Δες κατάταξη",
"mc.share": "Μοιράσου",
"mc.statsTitle": "Στατιστικά",
"mc.subtitle": "Παρακολούθησε όλες τις αναφορές σου σε μία θέση.",
"mc.title": "Ο λογαριασμός μου",
"mc.toLogin": "Ήδη έχεις εγγραφεί;",
"mc.toRegister": "Δεν έχεις λογαριασμό ακόμα;",
"mc.track": "Παρακολούθηση",
"mc.views": "Προβολές",
"mc.visCity": "Πόλη",
"mc.visCountry": "Χώρα",
"mc.visLabel": "Στοιχεία που φαίνονται στην κατάταξη:",
"mc.visName": "Όνομα / ψευδώνυμο",
"mc.visPhoto": "Φωτογραφία προφίλ",
"mc.welcome": "Γειά σου",
"mc2.acceptFinder": "Αποδέξου αυτόν τον ανακριτή",
"mc2.accountActivity": "Δραστηριότητα λογαριασμού",
"mc2.adsActive": "{n}/5 ενεργές αγγελίες",
"mc2.autoDelete": "Αυτόματη διαγραφή προγραμματισμένη για",
"mc2.badgeBronze": "Χάλκινο",
"mc2.badgeGold": "Χρυσό",
"mc2.badgeSilver": "Ασημί",
"mc2.boostEarnedAlready": "Σου έχει ήδη αποφέρει",
"mc2.boostEarnedWin": "Σου απέφερε",
"mc2.boostExpiredWin": "Η προώθησή σου έχει λήξει — συνέχισε με -20%!",
"mc2.boostExpiresIn": "Η προώθησή σου λήγει σε",
"mc2.boostWinDetail2": ". -20% εφαρμόζεται αυτόματα αν ανανεώσεις εντός 24h.",
"mc2.claimCode": "Κωδικός απαίτησης:",
"mc2.codeSentFinder": "Κωδικός στάλθηκε στον ανακριτή μέσω email",
"mc2.daysShort": "{n} η",
"mc2.downloadReceipt": "Κατέβασμα απόδειξης",
"mc2.error": "Σφάλμα {status}",
"mc2.finderAccepted": "Ο finder έχει γίνει αποδεκτός — ο κωδικός έχει σταλεί μέσω email",
"mc2.finderContacts": "Στοιχεία επικοινωνίας του/των finder(s)",
"mc2.followFindo": "Ακολούθησε το Findloop",
"mc2.imgInvalid": "Μη έγκυρη εικόνα",
"mc2.inactivityNote": " — σε περίπτωση {n} μηνών αδράνειας (GDPR).",
"mc2.lastActivity": "Τελευταία δραστηριότητα:",
"mc2.lostEmailTitle": "Δεν έχω πια πρόσβαση στο email μου",
"mc2.noPhotoPreset": "Δεν έχεις φωτογραφία ακόμα; Επίλεξε μία προεπιλεγμένη εικόνα:",
"mc2.paidViaPartner": "Πληρωμένο (μέσω συνεργάτη)",
"mc2.payRecovery": "Πλήρωσε τη χρέωση αποκατάστασης",
"mc2.paySettle": "Τακτοποίησε την πληρωμή μου",
"mc2.payShipping": "Πλήρωσε τα έξοδα αποστολής",
"mc2.payUnavailable": "Μη διαθέσιμη πληρωμή",
"mc2.peopleFound": "{n} άτομο(α) νομίζουν ότι βρήκαν το αντικείμενό σου",
"mc2.phoneNumber": "Αριθμός τηλεφώνου",
"mc2.reactivateAccount": "Επαναενεργοποίηση του λογαριασμού μου",
"mc2.reactivated": "Ο λογαριασμός επαναενεργοποιήθηκε",
"mc2.reactivatedThanks": "Ο λογαριασμός σας επαναενεργοποιήθηκε — ευχαριστούμε για την πίστη σας!",
"mc2.recoverSmsBtn": "Λάβετε τον κωδικό μου με SMS",
"mc2.recoverSmsDesc": "Λάβετε τον κωδικό της αίτησής σας με SMS στον αριθμό που είναι καταχωρισμένος στον λογαριασμό σας.",
"mc2.recoverSmsFallback": "Εάν υπάρχει λογαριασμός με αυτόν τον αριθμό, έχει αποσταλεί ένα SMS.",
"mc2.renewStayTop": ". Ανανεώστε για να παραμείνετε στην κορυφή και να ανακτήσετε το αντικείμενό σας.",
"mc2.resume20": "Ανακτήστε -20%",
"mc2.unlockContacts": "Ξεκλείδωμα στοιχείων επικοινωνίας",
"mc2.unlockDesc": "Πληρώστε την χρέωση χειρισμού του Findloop για να αποκαλύψετε τα στοιχεία επικοινωνίας τους και να κανονίσετε την παράδοση.",
"mc2.viewsWord": "προβολές",
"mc2.live": "Ζωντανά",
"mh.allCategories": "Όλες οι κατηγορίες",
"mh.allPeriod": "Όλος ο χρόνος",
"mh.autoMatch": "Αυτόματη αντιστοίχιση AI",
"mh.blocked": "Μπλοκαρισμένο (αντίφαση)",
"mh.blockedReason": "Η αντιστοίχιση έχει μπλοκαριστεί: οι κύριες λέξεις-κλειδιά του αντικειμένου και η δήλωση αντιφάσκουν.",
"mh.days30": "Τελευταίοι 30 ημέρες",
"mh.days7": "Τελευταίοι 7 ημέρες",
"mh.days90": "Τελευταίοι 90 ημέρες",
"mh.emptyDesc": "Οι αντιστοιχίσεις AI θα εμφανιστούν εδώ καθώς οι δηλώσεις έρχονται.",
"mh.emptyTitle": "Χωρίς γεγονότα",
"mh.exportCsv": "Εξαγωγή CSV",
"mh.exportDone": "Η εξαγωγή CSV έχει κατέβει",
"mh.exportImpossible": "Η εξαγωγή απέτυχε",
"mh.fBlocked": "Μπλοκαρισμένο",
"mh.fConfirmed": "Επιβεβαιωμένο",
"mh.fRejected": "Απορριφθέν",
"mh.objectLabel": "Αντικείμενο:",
"mh.refresh": "Ανανέωση",
"mh.rejected": "Απορριφθέν",
"mh.srcManual": "Χειροκίνητο",
"mh.srcText": "Κείμενο",
"mh.srcVisual": "Οπτικό (φωτογραφία)",
"mh.subtitle": "Αρχείο προτάσεων αντιστοίχισης από AI — αυτόματες αντιστοιχίσεις, επιβεβαιώσεις και απορρίψεις.",
"mh.title": "Ιστορία AI",
"nav.ads": "Χαμένα αντικείμενα",
"nav.dashboard": "Ο χώρος μου",
"nav.found": "Βρέθηκαν αντικείμενα",
"nav.how": "Πώς λειτουργεί",
"nav.login": "Σύνδεση",
"nav.map": "Χάρτης",
"nav.more": "Περισσότερα",
"nav.partners": "Συνεργάτες",
"nav.pricing": "Τιμολόγηση",
"nav.ranking": "Κατάταξη",
"nav.register": "Γίνε συνεργάτης",
"nav.track": "Προβολή δήλωσης",
"nf.desc": "Η σελίδα που αναζητάτε δεν υπάρχει ή έχει μετακινηθεί.",
"nf.home": "Επιστροφή στην αρχική",
"nf.title": "Η σελίδα δεν βρέθηκε",
"par.allCities": "Όλες οι πόλεις",
"par.allCountries": "Όλες οι χώρες",
"par.badge": "Κατάλογος",
"par.certified": "Πιστοποιημένος",
"par.certifiedBadge": "Πιστοποιημένος",
"par.cityPh": "Πόλη",
"par.declare": "Δήλωση",
"par.none": "Δεν βρέθηκε συνεργάτης.",
"par.partnerBadge": "Συνεργάτης",
"par.searchPh": "Αναζητήστε έναν οργανισμό…",
"par.subtitle": "Βρείτε τον οργανισμό όπου χάσατε το αντικείμενό σας και δηλώστε την απώλεια.",
"par.title": "Οι συνεργάτες μας",
"pay.addr1": "Διεύθυνση",
"pay.addr2": "Γραμμή διεύθυνσης 2 (προαιρετική)",
"pay.addrIncomplete": "Παρακαλώ συμπληρώστε τη διεύθυνση παράδοσης.",
"pay.badge": "Ανάκτηση",
"pay.card": "Πληρωμή με κάρτα",
"pay.city": "Πόλη",
"pay.country": "Χώρα",
"pay.eurNote": "Τα ποσά εμφανίζονται σε ευρώ (€).",
"pay.fee": "Τέλος ανάκτησης",
"pay.free": "δωρεάν",
"pay.howRecover": "Πώς θα θέλατε να παραλάβετε το αντικείμενό σας;",
"pay.momo": "Πληρωμή με Mobile Money",
"pay.momoConfirm": "Επιβεβαίωση πληρωμής",
"pay.noMatch": "Δεν έχει επιβεβαιωθεί κάποιο αντίστοιχο αντικείμενο για αυτή τη δήλωση.",
"pay.notfound": "Η δήλωση δεν βρέθηκε.",
"pay.phonePh": "Αριθμός τηλεφώνου",
"pay.pickup": "Παραλαβή αυτοπροσώπως",
"pay.pickupDesc": "Στο",
"pay.postal": "Ταχυδρομικός κώδικας",
"pay.secure": "Ασφαλής πληρωμή",
"pay.serviceFee": "Χρέωση υπηρεσίας Findloop",
"pay.ship": "Αποστολή σε μένα",
"pay.shipAfter": "— προσφέρεται μετά την πληρωμή.",
"pay.shipDesc": "Παράδοση στη διεύθυνσή μου",
"pay.shipNote": "Διαθέσιμη αποστολή",
"pay.shipping": "Χρέωση αποστολής",
"pay.subtitleWith": "Πληρώστε την χρέωση ανάκτησης σε",
"pay.title": "Ανακτώ το αντικείμενό μου",
"pay.total": "Σύνολο",
"pcat.city_hall": "Δημαρχεία",
"pcat.hotel": "Ξενοδοχεία",
"pcat.other": "Άλλα",
"pcat.park": "Πάρκα",
"pcat.prefecture": "Διευθύνσεις",
"pcat.restaurant": "Εστιατόρια",
"pcat.uncategorized": "Μη κατηγοριοποιημένα",
"pd.about": "Σχετικά",
"pd.back": "Όλοι οι συνεργάτες",
"pd.certified": "Πιστοποιημένος συνεργάτης",
"pd.declare": "Δηλώστε μια απώλεια εδώ",
"pd.itemsReturned": "αντικείμενα που επιστράφηκαν",
"pd.itemsTotal": "καταγεγραμμένα αντικείμενα",
"pd.map": "Τοποθεσία",
"pd.noItems": "Δεν βρέθηκαν αντικείμενα πρόσφατα.",
"pd.noReviews": "Δεν υπάρχουν κριτικές ακόμα.",
"pd.notFound": "Ο συνεργάτης δεν βρέθηκε.",
"pd.recentItems": "Πρόσφατα βρεθέντα αντικείμενα",
"pd.reply": "Απάντηση από την επιχείρηση",
"pd.reviews": "Κριτικές πελατών",
"pd.verified": "Επαληθευμένη κριτική",
"pd.verifiedEstablishment": "επιχείρηση verified από την Findloop",
"pg.next": "Επόμενο",
"pg.prev": "Προηγούμενο",
"pg.showing": "{from}–{to} από {total}",
"pk.bodyCopy": "Κείμενο σώματος",
"pk.bodyText": "Κείμενο",
"pk.brandColors": "Χρώματα μάρκας",
"pk.colorRed": "Κόκκινο",
"pk.colorWhite": "Λευκό",
"pk.darkBg": "Σκοτεινό φόντο",
"pk.download": "Λήψη",
"pk.downloadZip": "Λήψη ολόκληρου του κιτ (ZIP)",
"pk.headings": "Τίτλοι",
"pk.heroDesc": "Επίσημα λογότυπα, μπanners κοινωνικών δικτύων, χρώματα και τυπογραφία. Επιλέξτε τη γλώσσα και την παραλλαγή του tagline, στη συνέχεια κατεβάστε το οπτικό ή το πλήρες κιτ.",
"pk.lightBg": "Φωτεινό φόντο (εκτύπωση)",
"pk.logoWordmark": "Λογότυπο / λεκτικό σημάδι",
"pk.logosVisuals": "Λογότυπα & οπτικά",
"pk.mapCollect": "Χάρτης / σημεία συλλογής",
"pk.plain": "Απλό",
"pk.pressKit": "Δελτίο τύπου",
"pk.taglineLang": "Γλώσσα tagline",
"pk.typography": "Τυπογραφία",
"pk.variant": "Παραλλαγή",
"pr.shipBtn": "Αποστολή αντικειμένου",
"pr2.adBoostMsg": "Καλή επιλογή! Πολλαπλασιάζετε τις πιθανότητες να ανακτήσετε γρήγορα το αντικείμενό σας.",
"pr2.boostActivated": "Ενεργοποίηση boost!",
"pr2.canRecoverNow": "Μπορείτε τώρα να ανακτήσετε το αντικείμενό σας.",
"pr2.continue": "Συνέχεια",
"pr2.downloadReceiptPdf": "Λήψη απόδειξης (PDF)",
"pr2.goToSpaceNow": "Πηγαίνετε στον λογαριασμό μου τώρα",
"pr2.partnerBoostMsg": "Καλή επιλογή! Η μεγαλύτερη ορατότητα σημαίνει ότι προσελκύετε νέους πελάτες στην επιχείρησή σας.",
"pr2.paymentSuccess": "Επιτυχής πληρωμή!",
"pr2.redirectingSpace": "Ανακατεύθυνση στον λογαριασμό σας…",
"pr2.subActivated": "Επιτυχής πληρωμή! Η συνδρομή σας είναι ενεργή, μπορείτε τώρα να διαχειριστείτε τις επιχειρήσεις σας.",
"prev.allSites": "Όλες οι επιχειρήσεις",
"prev.editReply": "Επεξεργασία απάντησης",
"prev.none": "Δεν υπάρχει κριτική ακόμα.",
"prev.published": "Δημοσιευμένη απάντηση",
"prev.reply": "Απάντηση",
"prev.replyPh": "Γράψτε μια ευγενική απάντηση…",
"prev.send": "Δημοσίευση απάντησης",
"prev.sending": "Δημοσίευση…",
"prev.yourReply": "Η απάντησή σας",
"pricing.annual": "Ετήσια",
"pricing.annualBadge": "-20% προσφορά",
"pricing.choose": "Επιλέξτε",
"pricing.compareFeature": "Χαρακτηριστικό",
"pricing.compareTitle": "Σύγκριση σχεδίων",
"pricing.eyebrow": "Τιμολόγηση",
"pricing.month": "/μήνα",
"pricing.monthly": "Μηνιαίο",
"pricing.perYear": "/έτος",
"pricing.popular": "Δημοφιλές",
"pricing.quoteMsg": "Οι ανάγκες σας (προαιρετικά)",
"pricing.quoteOrg": "Οργανισμός",
"pricing.quoteSend": "Αποστολή αίτησης",
"pricing.quoteSent": "Η αίτηση στάλθηκε! Θα επικοινωνήσουμε μαζί σας σύντομα.",
"pricing.quoteSites": "Αριθμός τοποθεσιών / τερματικών",
"pricing.quoteTitle": "Αίτημα προσφοράς",
"pricing.requestQuote": "Αίτημα προσφοράς",
"pricing.saveLabel": "Εξοικονομείτε",
"pricing.savePerYear": "/έτος ανά επιπλέον εγκατάσταση",
"pricing.start": "Έναρξη",
"pricing.subtitle": "Ξεκινήστε δωρεάν, κλιμακώστε καθώς αναπτύσσεστε.",
"pricing.title": "Ένα σχέδιο για κάθε οργανισμό",
"promo.badge": "Πρόγραμμα συνεργατών",
"promo.cta": "Μάθετε περισσότερα",
"promo.text": "Κάθε συνεργάτης που προτείνετε και εγγράφεται σας δίνει έναν δωρεάν μήνα. Χωρίς περιορισμούς.",
"promo.title": "Προτείνετε έναν συνεργάτη, αποκτήστε έναν δωρεάν μήνα.",
"pub.accessGranted": "Η πρόσβαση παραχωρήθηκε",
"pub.accessLimited2h": "Η πρόσβαση περιορίζεται σε 2 ώρες",
"pub.accountEmailConcerned": "Email του σχετικού λογαριασμού",
"pub.adAppearPublic": "Έτσι θα εμφανίζεται η διαφήμισή σας δημόσια.",
"pub.adPreviewBtn": "Προεπισκόπηση διαφήμισης",
"pub.alertMeOnArrival": "Ενημερώστε με κατά την άφιξη",
"pub.allActionsLogged": "Όλες οι ενέργειες καταγράφονται",
"pub.allCategories": "Όλες οι κατηγορίες",
"pub.authorizeAccess": "Επιτρέψτε την πρόσβαση",
"pub.authorizeSupportQ": "Να επιτρέψω την υποστήριξη;",
"pub.available": "Διαθέσιμο",
"pub.backHome": "Πίσω στην αρχική",
"pub.boostAdCta": "Προώθηση της διαφήμισής μου",
"pub.boostAdTitle": "Προωθήστε τη διαφήμισή σας",
"pub.boostCarouselSub": "Μεταβείτε στην κορυφή της σελίδας στο καρουσέλ «Προωθημένα» και πολλαπλασιάστε τις προβολές για να ανακτήσετε το αντικείμενό σας πιο γρήγορα.",
"pub.boostEstablishment": "Προωθήστε την επιχείρησή σας",
"pub.boostEstablishmentDesc": "Εμφανιστείτε στην κορυφή του καταλόγου με σήμα «Προωθημένο» και προσελκύσετε περισσότερες αναφορές.",
"pub.boostFicheCta": "Προώθηση της εγγραφής μου",
"pub.brandReady": "Η μάρκα Findloop, έτοιμη προς χρήση",
"pub.cantFindItem": "Δεν μπορείτε να βρείτε το αντικείμενό σας;",
"pub.cantProcessImage": "Δεν είναι δυνατή η επεξεργασία αυτής της εικόνας",
"pub.claimQr": "Διεκδικήστε το QR code",
"pub.clickToZoom": "Κάντε κλικ για μεγέθυνση",
"pub.codeAlreadyValidated": "Ο κωδικός επικυρώθηκε — οι επαφές ξεκλειδώθηκαν.",
"pub.codeExample": "π.χ. ABCD2345",
"pub.confirmRenewal": "Επιβεβαίωση ανανέωσης",
"pub.contactIntro": "Μια ερώτηση, μια αίτηση; Γράψτε μας, θα επικοινωνήσουμε μαζί σας σύντομα.",
"pub.contactTypeDeceased": "Διαγραφή λογαριασμού (αποβιώσας)",
"pub.contactTypeGeneral": "Γενική ερώτηση",
"pub.contactTypeSupport": "Υποστήριξη / τεχνικό πρόβλημα",
"pub.contactUs": "Επικοινωνήστε μαζί μας",
"pub.continueWithoutEmail": "Συνέχιση χωρίς να αφήσω το email μου",
"pub.contractLabel": "Σύμβαση",
"pub.contractNotFound": "Η σύμβαση δεν βρέθηκε ή έχει λήξει.",
"pub.contractRenewed": "Η σύμβαση ανανεώθηκε!",
"pub.contractRenewedFor": "Η σύμβασή σας ανανεώθηκε για {n} μήνες.",
"pub.copyFailed": "Η αντιγραφή απέτυχε",
"pub.createPartnerAccount": "Δημιουργία λογαριασμού συνεργάτη",
"pub.currentDeadline": "Τρέχουσα προθεσμία",
"pub.deceasedInfo": "Ως συγγενής ή κληρονόμος, μπορείτε να ζητήσετε τη διαγραφή του λογαριασμού Findloop ενός αποβιώσαντος. Θα επεξεργαστούμε την αίτησή σας σύμφωνα με τον GDPR (μπορεί να ζητηθούν υποστηρικτικά έγγραφα).",
"pub.declareMyLoss": "Αναφέρετε την απώλειά μου",
"pub.describeItemPlaceholder": "Περιγράψτε το αντικείμενό σας (π.χ. μαύρη ομπρέλα, κλειδιά…)",
"pub.downloadImage": "Κατεβάστε την εικόνα",
"pub.drawSignature": "Παρακαλώ σχεδιάστε την υπογραφή σας.",
"pub.drawSignatureHint": "Σχεδιάστε την υπογραφή σας με το ποντίκι ή το δάχτυλο.",
"pub.duration": "Διάρκεια",
"pub.eSignature": "Ηλεκτρονική υπογραφή",
"pub.eSignatureDesc": "Εισάγετε το όνομά σας για να υπογράψετε. Η ημερομηνία καταγράφεται αυτόματα.",
"pub.edit": "Επεξεργασία",
"pub.editorialTitles": "Εκδοτικοί τίτλοι",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "Εισάγετε τον κωδικό που λάβατε μέσω email για να ξεκλειδώσετε τα στοιχεία επικοινωνίας του ιδιοκτήτη.",
"pub.errorWord": "Σφάλμα",
"pub.foundSelfService": "Βρέθηκαν αντικείμενα · Αυτοεξυπηρέτηση",
"pub.haveOwnerCode": "Έλαβα έναν κωδικό από τον ιδιοκτήτη",
"pub.home": "Αρχική",
"pub.immediateRenewal": "Άμεση ανανέωση, χωρίς νέα προσφορά.",
"pub.impAdminReq1": "Διαχειριστής",
"pub.impAdminReq2": "ζητά άδεια για να έχει προσωρινή πρόσβαση στον λογαριασμό σας",
"pub.impAdminReq3": "για να σας βοηθήσει.",
"pub.impGrantedDesc": "Η ομάδα υποστήριξης θα μπορεί να έχει πρόσβαση στον λογαριασμό σας για μέγιστο χρονικό διάστημα 2 ωρών. Κάθε ενέργεια θα καταγράφεται. Μπορείτε να κλείσετε αυτή τη σελίδα.",
"pub.invitedOnFindo": "Είστε προσκεκλημένος στο Findloop",
"pub.isThisYourItem": "Είναι αυτό το αντικείμενό σας;",
"pub.itemsAvailableCount": "{n} αντικείμενο(α) προς το παρόν διαθέσιμα",
"pub.itemsFoundOwner": "των εμπιστευμένων αντικειμένων που βρήκαν τον ιδιοκτήτη τους",
"pub.itemsReturnedOwners": "αντικείμενα που επιστράφηκαν στους ιδιοκτήτες τους",
"pub.itsMine": "Είναι δικό μου",
"pub.joinFindoDesc": "Εγγραφείτε στο Findloop και διαχειριστείτε τα βρεθέντα αντικείμενά σας με ευκολία.",
"pub.joinInvitesYou": "σας προσκαλεί να εγγραφείτε στο findloop. Δημιουργήστε τον λογαριασμό σας για να διαχειριστείτε τα βρεθέντα αντικείμενα.",
"pub.linkCopied": "Ο σύνδεσμος αντιγράφηκε!",
"pub.loadingContract": "Φόρτωση της σύμβασης…",
"pub.lsClaimDesc": "Αναφέρετε την απώλειά σας για να την ανακτήσετε. Αφήστε το email σας και θα σας στείλουμε υπενθύμιση αν η αναφορά σας δεν ολοκληρωθεί.",
"pub.lsHeroDesc": "Δείτε μόνοι σας αν το χαμένο αντικείμενό σας έχει βρεθεί και αφεθεί εδώ. Το βρήκατε; Αναφέρετέ το για να το ανακτήσετε.",
"pub.lsSearchTitle": "Αναζητήστε βρεθέντα αντικείμενα",
"pub.makeOffer": "Κάντε μία προσφορά",
"pub.makeOfferDesc": "Προτείνετε το ποσό σας. Ο superadmin θα το εξετάσει.",
"pub.mapNearYou": "Αντικείμενα & συνεργάτες κοντά σας",
"pub.mapWord": "Χάρτης",
"pub.messageSentToast": "Μήνυμα στάλθηκε — η ομάδα μας θα απαντήσει σύντομα.",
"pub.messageWord": "Μήνυμα",
"pub.momoInitiated": "Η πληρωμή μέσω Mobile Money ξεκίνησε",
"pub.monthsWord": "μήνες",
"pub.nameConsentRequired": "Απαιτείται όνομα και συγκατάθεση.",
"pub.newDeadline": "Νέα προθεσμία",
"pub.noActionRequired": "Δεν απαιτείται καμία ενέργεια.",
"pub.noAmountCharged": "Δεν χρεώθηκε κανένα ποσό.",
"pub.noItemMatch": "Δεν υπάρχει διαθέσιμο αντικείμενο που να ταιριάζει στην αναζήτησή σας αυτή τη στιγμή.",
"pub.noMatchingItem": "Δεν υπάρχει ταιριαστό αντικείμενο",
"pub.noPaymentSession": "Δεν υπάρχει συνεδρία πληρωμής.",
"pub.noPhoto": "Δεν υπάρχει φωτογραφία",
"pub.noPointsYet": "Δεν υπάρχουν πόντοι προς εμφάνιση ακόμα.",
"pub.noSecondPayment": "Δεν απαιτείται δεύτερη πληρωμή για αυτό το αντικείμενο.",
"pub.notHereYet": "Δεν έχει έρθει ακόμα; Ενημερωθείτε μόλις φτάσει.",
"pub.notifyDone": "Σημειώθηκε! Θα σας ενημερώσουμε μέσω email μόλις φτάσει ένα ταιριαστό αντικείμενο.",
"pub.offerSubmitted": "Η προσφορά σας υποβλήθηκε.",
"pub.oops": "Ωχ",
"pub.orAlertEmail": "Ή ενημερωθείτε μέσω email μόλις φτάσει ένα ταιριαστό αντικείμενο:",
"pub.ownerContacts": "Στοιχεία επικοινωνίας του ιδιοκτήτη",
"pub.ownerContactsUnlocked": "Απελευθερώθηκαν τα στοιχεία επικοινωνίας του ιδιοκτήτη",
"pub.partnerContact": "Επικοινωνία συνεργάτη",
"pub.payLinkUnavailable": "Μη διαθέσιμος σύνδεσμος πληρωμής — επικοινωνήστε με τον συνεργάτη.",
"pub.paymentCancelled": "Η πληρωμή ακυρώθηκε",
"pub.paymentConfirmed": "Η πληρωμή επιβεβαιώθηκε 🎉",
"pub.paymentConfirmedDesc": "Θα λάβετε ένα email με τις λεπτομέρειες για να ανακτήσετε το αντικείμενό σας.",
"pub.paymentNotConfirmed": "Η πληρωμή δεν επιβεβαιώθηκε",
"pub.paymentNotConfirmedDesc": "Η πληρωμή δεν μπόρεσε να επιβεβαιωθεί. Δοκιμάστε ξανά ή επικοινωνήστε με τον συνεργάτη.",
"pub.paymentProcessing": "Η πληρωμή επεξεργάζεται. Ανανεώστε σε λίγο.",
"pub.photoAdded": "✓ Η φωτογραφία προστέθηκε",
"pub.photoRequired": "Απαιτείται φωτογραφία του αντικειμένου.",
"pub.previewAlt": "προεπισκόπηση",
"pub.publish": "Δημοσίευση",
"pub.publishingWord": "Δημοσίευση…",
"pub.qty": "Ποσότητα",
"pub.quoteDeclined": "Η προσφορά απορρίφθηκε.",
"pub.quoteNotFound": "Η προσφορά δεν βρέθηκε ή έχει λήξει.",
"pub.reasonLabel": "Λόγος",
"pub.recoveryAlreadyPaid": "Η συνδρομή ανάκτησης έχει ήδη πληρωθεί",
"pub.referralCode": "Κωδικός παραπομπής:",
"pub.relationshipPlaceholder": "Γιος, σύζυγος, συμβολαιογράφος…",
"pub.renewYourContract": "Ανανεώστε τη σύμβασή σας",
"pub.renewalFailed": "Η ανανέωση απέτυχε. Δοκιμάστε ξανά αργότερα.",
"pub.renewing": "Ανανεώνεται…",
"pub.replySoon": "Η ομάδα μας θα απαντήσει το συντομότερο δυνατό.",
"pub.requestGone": "Αυτή η αίτηση δεν υπάρχει πλέον.",
"pub.requestHandled": "Η αίτηση έχει ήδη επεξεργαστεί",
"pub.requestNotFound": "Η αίτηση δεν βρέθηκε ή έχει λήξει.",
"pub.requestUnavailable": "Η αίτηση δεν είναι διαθέσιμη",
"pub.required": "(απαιτείται)",
"pub.retroClosing": "Μαζί, κάνουμε τον κόσμο λίγο λιγότερο χαμένο.",
"pub.retroClosing2": "Μαζί, κάνουμε τον κόσμο λίγο λιγότερο χαμένο.",
"pub.retroScroll": "Μια χρονιά ανάκτησης όσων έχουν σημασία. Κάντε κύλιση προς τα κάτω ↓",
"pub.revokeAnytime": "Μπορείτε να ανακαλέσετε οποτεδήποτε επικοινωνώντας μαζί μας",
"pub.scene": "Σκηνή",
"pub.sendImpossible": "Αδυναμία αποστολής",
"pub.sendMessage": "Στείλτε το μήνυμα",
"pub.sending": "Αποστολή…",
"pub.sharePreview": "Μοιραστείτε την προεπισκόπηση",
"pub.shareYourAd": "Μοιραστείτε τη διαφήμισή σας",
"pub.signedSuccess": "Υπογράφηκε με επιτυχία!",
"pub.signerFullName": "Ολόκληρο όνομα υπογράφοντα",
"pub.spreadNetwork": "Μοιραστείτε το με τους γύρω σας για να ενισχύσετε τις πιθανότητές σας.",
"pub.spreadOwner": "Μοιραστείτε το για να βοηθήσετε τον ιδιοκτήτη να ανακτήσει τα αντικείμενά του.",
"pub.statusLabel": "Κατάσταση:",
"pub.subject": "Θέμα",
"pub.thanksSent": "Ευχαριστώ, το μήνυμά σας έχει αποσταλεί.",
"pub.thisYear": "Αυτό το έτος",
"pub.validate": "Επιβεβαίωση",
"pub.verifyingPayment": "Επιβεβαίωση πληρωμής…",
"pub.verifyingYourPayment": "Επιβεβαίωση της πληρωμής σας…",
"pub.viewAd": "Δείτε τη διαφήμιση →",
"pub.viewPartner": "Δείτε τον συνεργάτη →",
"pub.yourAdPreview": "Προεπισκόπηση της διαφήμισής σας",
"pub.yourEmail": "Το email σας",
"pub.yourEmailRecommended": "Το email σας (συνιστώμενο)",
"pub.yourEmailShort": "Το email σας",
"pub.yourName": "Το όνομά σας",
"pub.yourRelationship": "Η σχέση σας με το άτομο",
"qv.acceptAndSign": "Αποδεχτείτε και υπογράψτε την προσφορά μου",
"qv.certifyAuthorized": "Πιστοποιώ ότι είμαι εξουσιοδοτημένος να υπογράψει και αποδέχομαι τους όρους αυτού του {what} (δεσμευτική αξία).",
"qv.clear": "Καθαρισμός",
"qv.client": "Πελάτης",
"qv.conditions": "Όροι",
"qv.confirmDecline": "Επιβεβαίωση της άρνησης αυτής της προσφοράς;",
"qv.countersignedFindo": "Υπογεγραμμένο από την Findloop · {name} στις {date}",
"qv.decline": "Άρνηση",
"qv.description": "Περιγραφή",
"qv.downloadPdf": "Κατέβασμα PDF",
"qv.handwrittenSignature": "Χειρόγραφα υπογραφή",
"qv.inclTax": "Συμπ. φόρος",
"qv.invalidAmount": "Μη έγκυρο ποσό.",
"qv.invoice": "Τιμολόγιο",
"qv.invoicePaid": "Τιμολόγιο πληρωμένο",
"qv.issuer": "Εκδότης",
"qv.messageOptional": "Μήνυμα (προαιρετικό)",
"qv.negotiatedAmount": "Διαπραγματευμένο ποσό",
"qv.payInvoiceOnline": "Πληρωμή τιμολογίου online",
"qv.quote": "Προσφορά",
"qv.quoteValidDays": "Η προσφορά ισχύει για {n} ημέρες.",
"qv.sendMyOffer": "Στείλτε την προσφορά μου",
"qv.signContract": "Υπογράψτε τη σύμβασή μου",
"qv.signNow": "Υπογράψτε τώρα",
"qv.signatureAlt": "Υπογραφή",
"qv.signedByOn": "✔ Υπογεγραμμένο από {name} στις {date}",
"qv.stContractSigned": "Η σύμβαση υπεγράφη. Ευχαριστώ!",
"qv.stCounterAccepted": "Η προσφορά σας έχει γίνει αποδεκτή! Υπογράψτε τη σύμβασή σας παρακάτω.",
"qv.stCounterRefused": "Η προσφορά σας δεν μπορεί να γίνει αποδεκτή.",
"qv.stCountered": "Η προσφορά σας έχει υποβληθεί. Περιμένουμε την απάντηση της findloop.",
"qv.stDeclined": "Αρνηθήκατε αυτήν την προσφορά.",
"qv.stSigned": "Η προσφορά έγινε αποδεκτή και υπογράφηκε. Ευχαριστώ!",
"qv.totalHt": "Συνολικό χωρίς φόρο",
"qv.totalTtc": "Συνολικό συμπ. φόρου",
"qv.unitHt": "Μονάδα χωρίς φόρο",
"qv.vat": "ΦΠΑ",
"qv.yourProposedAmount": "Το προτεινόμενο ποσό σας ({cur})",
"rate.chooseNote": "Παρακαλώ επιλέξτε μια βαθμολογία.",
"rate.commentPh": "Ένα σχόλιο (προαιρετικό)…",
"rate.home": "Επιστροφή στην αρχική",
"rate.submit": "Υποβολή της κριτικής μου",
"rate.submitting": "Αποστολή…",
"rate.subtitle": "Πώς πήγε η ανάκτηση του αντικειμένου σας;",
"rate.successText": "Η ανατροφοδότησή σας βοηθά άλλους χρήστες.",
"rate.successTitle": "Ευχαριστώ για την κριτική σας!",
"rate.title": "Βαθμολογήστε την εμπειρία σας",
"reg.add": "Καταγραφή αντικειμένου",
"reg.allBrands": "Όλες οι μάρκες",
"reg.allColors": "Όλα τα χρώματα",
"reg.allLocations": "Όλες οι τοποθεσίες",
"reg.detailDesc": "Λεπτομέρειες και ενέργειες για αυτό το βρέθέν αντικείμενο.",
"reg.dispAuction": "Δημοπρασία",
"reg.dispAuthorities": "Παραδώθηκε στις αρχές",
"reg.dispDestroyed": "Καταστράφηκε",
"reg.dispDonate": "Δωρεά σε φιλανθρωπίες",
"reg.dispositionHint": "Καταγράψτε το αντικείμενο που φεύγει από την αποθήκευση. Μετράται στα στατιστικά ανά κατηγορία.",
"reg.emptyCta": "Καταγραφή αντικειμένου",
"reg.emptyDesc": "Ξεκινήστε καταγράφοντας το πρώτο σας βρεθέν αντικείμενο.",
"reg.emptyTitle": "Δεν βρέθηκαν αντικείμενα",
"reg.establishmentFallback": "η εγκατάσταση",
"reg.lblAuctioned": "αναρτημένο σε δημοπρασία",
"reg.lblAuctionedShort": "δημοπρατημένο",
"reg.lblAuthorities": "παραδοθέν στις αρχές",
"reg.lblDestroyed": "κατεστραμμένο",
"reg.lblDonated": "δωρεά σε φιλανθρωπία",
"reg.legalCount": "{n} αντικείμενο(α): έφτασε η νομική περίοδος διατήρησης",
"reg.legalHint": "Μπορείτε να τα καταχωρήσετε σε δημοπρασία, να τα δωρίσετε σε φιλανθρωπία ή να αναφέρετε την παράδοση στις αρχές.",
"reg.legalLimitCountry": "Προθεσμία: {date} · εφαρμοσμένη χώρα: {country}",
"reg.legalOver": "Η προθεσμία πέρασε: {date} · {country}",
"reg.legalReached": "Η νομική περίοδος ολοκληρώθηκε",
"reg.legalReachedFull": "Έφτασε η νομική περίοδος διατήρησης",
"reg.limitShort": "προθεσμία",
"reg.location": "Τοποθεσία",
"reg.markRestituted": "Σημειώστε ως επιστραφέν",
"reg.markedAs": "Αντικείμενο σημειωμένο ως {label}",
"reg.moveHistory": "Ιστορικό μετακινήσεων",
"reg.overBy": "πάνω από {n}η",
"reg.physicalLocation": "Φυσική τοποθεσία",
"reg.popupBlocked": "Επιτρέψτε τα αναδυόμενα για να εκτυπώσετε τις ετικέτες.",
"reg.popupBlockedOne": "Επιτρέψτε τα αναδυόμενα για να εκτυπώσετε την ετικέτα.",
"reg.printLabel": "Εκτύπωση της ετικέτας",
"reg.printN": "Εκτύπωση {n} ετικέτα(ων)",
"reg.qrCodeItem": "QR code αντικειμένου",
"reg.qrLabelTitle": "QR ετικέτα",
"reg.qrLabelsTitle": "QR ετικέτες",
"reg.qrNotFound": "Δεν βρέθηκε αντικείμενο για αυτό το QR code.",
"reg.qrScanHint": "Σαρώστε το για να ανοίξετε αυτή την καταχώρηση απευθείας και να βρείτε την τοποθεσία.",
"reg.recoveryFee": "Τέλος αποκατάστασης (€)",
"reg.searchPh": "Αναζητήστε κατά περιγραφή…",
"reg.selectQr": "Επιλέξτε για να εκτυπώσετε QR ετικέτες",
"reg.selectedN": "{n} επιλεγμένα",
"reg.shipPricePh": "Τιμή αποστολής (€)",
"reg.shippingPossible": "Διαθέσιμη αποστολή",
"reg.storagePh": "π.χ. Ράφι A3, Ντουλάπι 12",
"reg.tAuction": "Δημοπρασία στο Findloop",
"reg.tAuthorities": "Αναφορά παράδοσης στις αρχές",
"reg.tDonate": "Δωρεά σε φιλανθρωπία",
"reg.toastFee": "Το τέλος ενημερώθηκε",
"reg.toastLocation": "Η τοποθεσία αποθηκεύτηκε",
"reg.toastRestituted": "Αντικείμενο σημειωμένο ως επιστραφέν",
"reg.toastShipping": "Η επιλογή αποστολής ενημερώθηκε",
"reg.toastTransferred": "Το αντικείμενο μεταφέρθηκε στο “{name}”",
"reg.unclaimedDisposition": "Ανεπίσημο αντικείμενο — τελική διάθεση",
"res.codeValidated": "Κωδικός επικυρωμένος",
"res.empty": "Δεν έχει καταχωρηθεί καμία αποκατάσταση ακόμα.",
"res.error": "Σφάλμα {status}",
"res.proofPdf": "PDF απόδειξη",
"res.signed": "Υπογεγραμμένο",
"res.stRestituted": "Παραδόθηκε αυτοπροσώπως",
"res.stShipped": "Επιστράφηκε μέσω αποστολής",
"res.subtitle": "Όλες οι ολοκληρωμένες παραδόσεις, με την υπογεγραμμένη απόδειξή τους διαθέσιμη για λήψη.",
"res.title": "Ιστορικό αποκατάστασης",
"rev.b2b": "Συνεργάτες B2B",
"rev.b2c": "Πελάτες",
"rev.based": "βασισμένο σε {n} αξιολογήσεις",
"rev.eyebrow": "Μαρτυρίες",
"rev.restitutedBy": "Επιστράφηκε από {org}",
"rev.storiesEyebrow": "Χαρούμενες καταλήξεις",
"rev.storiesSubtitle": "Πραγματικές ιστορίες πελατών που ανέκτησαν τα αντικείμενά τους με το findloop.",
"rev.storiesTitle": "Βρήκαν τα αντικείμενά τους!",
"rev.subtitle": "Συνεργάτες και πελάτες μοιράζονται την εμπειρία τους.",
"rev.title": "Εμπιστεύονται το Findloop",
"rev.verified": "Επικυρωμένο",
"rp.already": "Έχετε ήδη αναφέρει αυτήν την καταχώρηση.",
"rp.comment": "Λεπτομέρειες (προαιρετικά)",
"rp.duplicate": "Διπλό",
"rp.fraud": "Απάτη / ψευδείς πληροφορίες",
"rp.inappropriate": "Ακατάλληλο περιεχόμενο",
"rp.offensive": "Επιθετικό περιεχόμενο",
"rp.other": "Άλλο",
"rp.reason": "Λόγος",
"rp.report": "Αναφορά",
"rp.send": "Αποστολή αναφοράς",
"rp.sent": "Αναφορά αποσταλεί. Ευχαριστούμε για τη συμβολή σας.",
"rp.spam": "Ανεπιθύμητη αλληλογραφία / διαφήμιση",
"rp.title": "Αναφορά αυτήν τη καταχώριση",
"rp.wrongCategory": "Λάθος κατηγορία",
"rt.annualGoal": "Ετήσιος στόχος",
"rt.championCity": "Πόλη πρωταθλητής",
"rt.cityRate": "{rate}% ποσοστό επιστροφής",
"rt.goalProgress": "{rate}% επιτεύχθηκε από έναν στόχο {target}%",
"rt.reached": "Επιτεύχθηκε 🎉",
"rt.restitutionRate": "Ποσοστό επιστροφής",
"rt.shareRecap": "Μοιραστείτε τη σύνοψη μου",
"rt.thanks": "Σας ευχαριστούμε Findloop {year} 💛",
"rt.yourRecap": "Η σύνοψη σας για το {year}",
"rw.active": "Ενεργό",
"rw.add": "Προσθήκη",
"rw.camUnavailable": "Η κάμερα δεν είναι διαθέσιμη. Εισάγετε τον κωδικό χειροκίνητα παρακάτω.",
"rw.codeValidated": "Ο κωδικός επικυρώθηκε",
"rw.codesTitle": "Κωδικοί που εξαργυρώθηκαν από τους tìmers",
"rw.confirmDelete": "Διαγραφή “{title}”;",
"rw.deleted": "Διαγράφηκε",
"rw.edit": "Επεξεργασία",
"rw.editReward": "Επεξεργασία της ανταμοιβής",
"rw.empty": "Δεν υπάρχει ανταμοιβή ακόμα.",
"rw.expired": "Έληξε",
"rw.expiresOn": "Λήγει στις {date}",
"rw.fActive": "Ενεργό (ορατό στους tìmers)",
"rw.fCost": "Κόστος (πόντοι)",
"rw.fDesc": "Περιγραφή",
"rw.fStock": "Απόθεμα (κενό = απεριόριστο)",
"rw.fTitle": "Τίτλος",
"rw.fValidity": "Ικανότητα κουπονιού (ημέρες μετά την εξαργύρωση)",
"rw.inactive": "Ανενεργό",
"rw.newReward": "Νέα ανταμοιβή",
"rw.noExchange": "Δεν έχει γίνει εξαργύρωση ακόμα.",
"rw.pageSubtitle": "Σαρώστε τα κουπόνια που παρουσιάζονται από τους tìmers για να επικυρώσετε τις ανταμοιβές τους.",
"rw.redeemedN": "Εξαργυρώθηκε: {n}×",
"rw.saved": "Ανταμοιβή αποθηκευμένη",
"rw.scanVoucher": "Σαρώστε ένα κουπόνι",
"rw.staffScanOnly": "Σαρώστε μόνο",
"rw.statActive": "Προς παρουσίαση",
"rw.statExpired": "Έληξε",
"rw.statRedeemed": "Κουπόνια που έχουν εξαργυρωθεί",
"rw.statUsed": "Επικυρωμένα",
"rw.stock": "Απόθεμα",
"rw.subtitle": "Προσφέρετε μη χρηματικά προνόμια (κουπόνια, αναβαθμίσεις…) που οι tìmers θα εξαργυρώνουν για τους πόντους Finder Score τους.",
"rw.title": "Ανταμοιβές για τους tìmers",
"rw.used": "Χρησιμοποιημένο",
"rw.validate": "Επικύρωση",
"rw.validateCode": "Επικυρώστε τον κωδικό",
"rw.validity": "Ικανότητα: {n} δ",
"shell.f1d": "Συνδέστε αυτόματα χαμένα και βρέθηκαν αντικείμενα.",
"shell.f1t": "Έξυπνος αλγόριθμος αντιστοίχισης AI",
"shell.f2d": "Παρακολούθηση ποσοστού επιστροφής και εσόδων σε πραγματικό χρόνο.",
"shell.f2t": "Πίνακας & έσοδα",
"shell.f3d": "Οι πελάτες σας αναφέρουν σε 30 δευτερόλεπτα.",
"shell.f3t": "QR κωδικός συνεργάτη",
"shell.title": "Μετατρέψτε τα χαμένα αντικείμενα σε ικανοποιημένους πελάτες.",
"ship.addr1": "Διεύθυνση",
"ship.addr2": "Γραμμή διεύθυνσης 2 (προαιρετικό)",
"ship.badge": "Αποστολή",
"ship.city": "Πόλη",
"ship.country": "Χώρα",
"ship.needPaid": "Πληρώστε πρώτα την αμοιβή ανάκτησης για να ζητήσετε αποστολή.",
"ship.notShippable": "Αυτό το αντικείμενο δεν είναι διαθέσιμο για αποστολή.",
"ship.notfound": "Η αναφορά δεν βρέθηκε.",
"ship.postal": "Ταχυδρομικός κωδικός",
"ship.price": "Κόστος αποστολής",
"ship.submit": "Ζητήστε αποστολή",
"ship.submitting": "Αποστολή…",
"ship.subtitle": "Εισάγετε τη διεύθυνση παράδοσης σας.",
"ship.successText": "Ο συνεργάτης θα προετοιμάσει το δέμα σας. Θα ειδοποιηθείτε μόλις αποσταλεί.",
"ship.successTitle": "Αίτημα αποστολής στάλθηκε!",
"ship.title": "Έχετε το αντικείμενό σας αποσταλεί",
"ship.weight": "Εκτιμώμενο βάρος (κιλά)",
"shp.carrier": "Μεταφορέας",
"shp.download": "Κατεβάστε PDF",
"shp.generating": "Δημιουργία…",
"shp.label": "Δημιουργία ετικέτας",
"shp.none": "Δεν έχουν ζητηθεί αποστολές.",
"shp.setTracking": "Αποθήκευση παρακολούθησης",
"shp.status": "Κατάσταση",
"shp.to": "Παραλήπτης",
"shp.tracking": "Αριθμός παρακολούθησης",
"shp.trackingSaved": "Η παρακολούθηση αποθηκεύτηκε",
"side.account": "Ο λογαριασμός μου",
"side.declarations": "Αναφορές",
"side.deposit": "Καταγράψτε ένα αντικείμενο",
"side.establishments": "Καταστήματα",
"side.invoices": "Τιμολόγια",
"side.logout": "Αποσύνδεση",
"side.matchHistory": "Ιστορικό AI",
"side.partner": "Συνεργάτης",
"side.refresh": "Ανανέωση",
"side.registry": "Μητρώο",
"side.restitutions": "Επιστροφές",
"side.reviews": "Κριτικές",
"side.rewards": "Ανταμοιβές & Κουπόνια",
"side.settings": "Ρυθμίσεις",
"side.shipments": "Αποστολές",
"side.stats": "Στατιστικά",
"side.storage": "Αποθήκευση & QR",
"side.team": "Ομάδα",
"side.viewSite": "Προβολή δημόσιου ιστότοπου",
"st.auctioned": "Πωλήθηκε σε δημοπρασία",
"st.claimed": "Δηλώθηκε",
"st.closed": "Κλειστό",
"st.delivered": "Παραδομένο",
"st.destroyed": "Κατεστραμμένο",
"st.donated": "Δωρεά (φιλανθρωπία)",
"st.handed_to_authorities": "Παραδιδόμενο στις αρχές",
"st.in_storage": "Σε αποθήκευση",
"st.matched": "Βρέθηκε ταίριασμα",
"st.open": "Ανοιχτό",
"st.paid": "Πληρωμένο",
"st.pending": "Εκκρεμές",
"st.resolved": "Λυμένο",
"st.restituted": "Επιστρεμμένο",
"st.second_chance": "Δεύτερη ευκαιρία",
"st.shipped": "Απεστάλη",
"st.shipping_requested": "Αίτημα αποστολής",
"st.submitted": "Υποβλημένο",
"st.verified": "Επιβεβαιωμένο",
"stat.items": "Εγγεγραμμένα αντικείμενα",
"stat.partners": "Συνεργάτες",
"stat.restituted": "Επιστρεμμένα αντικείμενα",
"status.auctioned": "Δημοπρατήθηκε",
"status.destroyed": "Καταστράφηκε",
"status.donated": "Δωρεά (φιλανθρωπία)",
"status.handed_to_authorities": "Παραδόθηκε στις αρχές",
"status.in_storage": "Σε αποθήκευση",
"status.matched": "Ταίριασμα",
"status.open": "Ανοιχτό",
"status.paid": "Πληρωμένο",
"status.pending": "Εκκρεμές",
"status.restituted": "Επιστρεμμένο",
"status.shipped": "Απεστάλη",
"status.shipping_requested": "Αίτημα αποστολής",
"status.submitted": "Υποβλημένο",
"step1.tag": "Κατάστημα",
"step1.text": "Σε δευτερόλεπτα, το κατάστημα καταγράφει το βρεθέν αντικείμενο με φωτογραφία, κατηγορία και περιγραφή. Όλα είναι κεντροποιημένα σε μια σαφή, ασφαλή καταχώρηση.",
"step1.title": "Ο συνεργάτης καταγράφει το αντικείμενο",
"step2.tag": "Πελάτης",
"step2.text": "Μέσω του QR code του συνεργάτη, ο πελάτης σας περιγράφει το χαμένο αντικείμενο σε 30 δευτερόλεπτα. Χωρίς εφαρμογή να εγκατασταθεί — όλα γίνονται στον περιηγητή.",
"step2.title": "Ο πελάτης αναφέρει την απώλεια",
"step3.tag": "Νοημοσύνη",
"step3.text": "Η έξυπνη μηχανή ταυτοποίησης μας συγκρίνει περιγραφές και προτείνει τα πιο πιθανά ταίριασματα, έτοιμη για επιβεβαίωση.",
"step3.title": "Η AI συνδέει την απώλεια με το βρεθέν αντικείμενο",
"step4.tag": "Ανάκτηση",
"step4.text": "Μετά από ασφαλή πληρωμή του τέλους ανάκτησης, ο πελάτης παραλαμβάνει το αντικείμενο στον χώρο — ή το λαμβάνει μέσω παρακολούθησης αποστολής.",
"step4.title": "Ο πελάτης παραλαμβάνει το αντικείμενό του",
"stg.allLabels": "Όλες οι ετικέτες QR",
"stg.camHint": "Χρησιμοποιήστε την χειροκίνητη είσοδο παρακάτω.",
"stg.camStarting": "Έναρξη κάμερας…",
"stg.camUnavailable": "Η κάμερα δεν είναι διαθέσιμη.",
"stg.clear": "Καθαρισμός",
"stg.clearAll": "Καθαρισμός όλων",
"stg.codeUnreadable": "Μη αναγνώσιμος κωδικός.",
"stg.emptyDesc": "Αποθηκευμένα αντικείμενα θα εμφανιστούν εδώ, ομαδοποιημένα κατά τοποθεσία.",
"stg.emptyTitle": "Δεν υπάρχουν αντικείμενα στην αποθήκη",
"stg.exportAudit": "Εξαγωγή CSV ελέγχου",
"stg.exportDone": "Εξαγωγή CSV κατεβασμένη",
"stg.exportImpossible": "Εξαγωγή μη διαθέσιμη αυτή τη στιγμή.",
"stg.itemFound": "Αντικείμενο βρέθηκε ✅",
"stg.kLocations": "Χρησιμοποιούμενες τοποθεσίες",
"stg.kObjects": "Αποθηκευμένα αντικείμενα",
"stg.kToClear": "Τοποθεσίες προς καθαρισμό",
"stg.locFreed": "Τοποθεσία ελεύθερη",
"stg.locsFreed": "{n} τοποθεσία(-ες) ελεύθερη",
"stg.manualLabel": "Ή εισαγάγετε τον κωδικό / ID του αντικειμένου",
"stg.manualPh": "Επικολλήστε το ID ή URL του QR",
"stg.noItemMatch": "Κανένα αντικείμενο δεν ταιριάζει σε αυτό το QR / κωδικό.",
"stg.noLocation": "Καμία τοποθεσία",
"stg.objectsAxis": "Αντικείμενα",
"stg.objectsN": "{n} αντικείμενο(α)",
"stg.occAvg": "μέσο {n} αντικείμενα/τοποθεσία",
"stg.occHint": "Οι τοποθεσίες με πορτοκαλί χρώμα υπερβαίνουν τον μέσο όρο (πιθανώς φορτωμένες).",
"stg.occupancy": "Πληρότητα τοποθεσίας",
"stg.openPage": "Άνοιγμα της σελίδας",
"stg.posterPdf": "PDF αφίσα (A4)",
"stg.printAll": "Εκτύπωση όλων",
"stg.printGroupTitle": "Εκτύπωση ετικετών για αυτό το ράφι",
"stg.qrAlt": "QR αυτοεξυπηρέτησης",
"stg.qrDownload": "Λήψη του QR",
"stg.qrHint": "Εμφανίστε αυτό το QR στο ταμείο: οι πελάτες σας το σκανάρετε για να ελέγξουν αν το αντικείμενό τους είναι διαθέσιμο.",
"stg.qrTitle": "QR αυτοεξυπηρέτησης πελάτη",
"stg.scanDesc": "Σαρώστε την ετικέτα ενός αντικειμένου για να ανοίξετε αμέσως την καταχώρησή του.",
"stg.scanQr": "Σαρώστε ένα QR",
"stg.scanTitle": "Σαρώστε έναν QR κωδικό",
"stg.search": "Αναζήτηση",
"stg.shelf": "Ράφι {loc}",
"stg.shelfPlan": "Σχέδιο ραφιού",
"stg.staleHint": "Καθαρίστε αυτές τις τοποθεσίες για να διατηρήσετε το φυσικό σας απόθεμα ενημερωμένο.",
"stg.staleTitle": "{n} αντικείμενο(α) έχουν φύγει από την αποθήκη αλλά κρατούν ακόμα μια τοποθεσία",
"stg.subtitle": "Σχέδιο ραφιού, σαρωτής QR και παρακολούθηση φυσικού αποθέματος.",
"stg.title": "Αποθήκευση & QR",
"stt.acceptRate": "Ποσοστό αποδοχής",
"stt.accepted": "Αποδεκτό",
"stt.activity30": "Δραστηριότητα (τελευταίες 30 ημέρες)",
"stt.ai6mo": "Τελευταίοι 6 μήνες · αποδεκτό = αυτόματα αντιστοιχισμένο + επιβεβαιωμένο.",
"stt.aiEmpty": "Δεν υπάρχουν αντιστοιχίες AI σε αυτή την περίοδο ακόμα.",
"stt.aiTitle": "Αντιστοιχίες AI — αποδεκτές έναντι απορριφθεισών",
"stt.auctionShort": "Δημοπρασία",
"stt.auctionedSold": "Δημοπρατημένο (πωληθέν)",
"stt.authShort": "Αρχές",
"stt.authorities": "Παραδείχθηκε στις αρχές",
"stt.avgRating": "Μέση βαθμολογία",
"stt.awaitingRestitution": "αντικείμενα που αναμένουν επιστροφή",
"stt.boostClicks": "Κλικ στο κατάλογό σας αυτή την εβδομάδα χάρη στην ενίσχυση",
"stt.boostInactive": "Η ενίσχυση είναι ανενεργή — ενεργοποιήστε την για να κερδίσετε ορατότητα",
"stt.certifiedPremium": "Πιστοποιημένο premium",
"stt.declarations": "Δηλώσεις",
"stt.destroyed": "Καταστραμμένο",
"stt.dispoEmpty": "Δεν έχει φύγει κανένα αμαύρωτο αντικείμενο από την αποθήκη ακόμα.",
"stt.donatedAssoc": "Δωρεά (φιλανθρωπία)",
"stt.donatedShort": "Δωρεά",
"stt.gateCta": "Ανακαλύψτε τα σχέδια",
"stt.gateDesc": "Αναβαθμίστε σε Starter για να ξεκλειδώσετε τα βασικά σας στατιστικά, ή σε Business για προχωρημένα στατιστικά και ανάλυση ανά κατάστημα.",
"stt.gateTitle": "Στατιστικά που διατηρούνται για πληρωμένα σχέδια",
"stt.inStorage": "Στην αποθήκη",
"stt.kItems": "Εγγεγραμμένα αντικείμενα",
"stt.kRate": "Ποσοστό επιστροφής",
"stt.kRestituted": "Επιστραφέντα αντικείμενα",
"stt.kRevenue": "Έσοδα (μήνας)",
"stt.noDeclYet": "Δεν υπάρχουν δηλώσεις ακόμα.",
"stt.recapDownloaded": "Ανακεφαλαίωση ληφθείσα — έτοιμη προς κοινοποίηση!",
"stt.recapError": "Αδύνατη η δημιουργία ανακεφαλαίωσης",
"stt.recapText": "Η ανακεφαλαίωση {year} της Findloop: επιστραμμένα αντικείμενα και ικανοποίηση πελατών 🎉",
"stt.recapTitle": "ανακεφαλαίωση Findloop {year}",
"stt.rejected": "Απορριφθείς",
"stt.restitutions": "Επιστροφές",
"stt.shareRecap": "Κοινοποιήστε την ανακεφαλαίωσή μου {year}",
"stt.topCategories": "Οι πιο δηλωμένες κατηγορίες",
"stt.unclaimedDesc": "Όγκος αντικειμένων που καταστράφηκαν, δωρήθηκαν σε φιλανθρωπίες και πωλήθηκαν σε δημοπρασίες, κατά κατηγορία.",
"stt.unclaimedTitle": "Ανεclaimα αντικείμενα — αποχωρούν από την αποθήκευση",
"stt.vsLastWeek": "σε σχέση με την προηγούμενη εβδομάδα",
"sub.cancel": "Ακύρωση της συνδρομής μου",
"sub.cancelAbort": "Ακύρωση",
"sub.cancelConfirm1": "Είσαι σίγουρος ότι θες να ακυρώσεις; Η πρόσβαση σου παραμένει ενεργή μέχρι",
"sub.cancelConfirm2": "Δεν θα εκδοθεί επιστροφή χρημάτων.",
"sub.cancelConfirmBtn": "Επιβεβαίωση ακύρωσης",
"sub.cancelTitle": "Ακύρωση της συνδρομής σου",
"sub.cancelledToast": "Η ακύρωση καταγράφηκε.",
"sub.cguAnd": "και το",
"sub.cguDesc": "Παρακαλώ επιβεβαίωσε τη συμφωνία σου πριν την πληρωμή.",
"sub.cguLink": "Όροι Χρήσης",
"sub.cguPay": "Συνέχεια στην πληρωμή",
"sub.cguPre": "Έχω διαβάσει και αποδέχομαι τους",
"sub.cguRequired": "Πρέπει να αποδεχτείς τους Όρους Χρήσης και την Πολιτική Απορρήτου για να προχωρήσεις.",
"sub.cguSuffix": "του Findloop.",
"sub.cguTitle": "Ολοκλήρωση της συνδρομής σου",
"sub.expiresOn": "Η συνδρομή σου λήγει στις",
"sub.noProrata": "Καμία επιστροφή χρημάτων pro-rata.",
"sub.privacyLink": "Πολιτική Απορρήτου",
"sub.renewsOn": "Η συνδρομή σου ανανεώνεται στις",
"sub.resume": "Επανεγγραφή",
"sub.resumedToast": "Η επανεγγραφή επιβεβαιώθηκε.",
"tier.free": "Δωρεάν",
"tier.large": "Επιχείρηση",
"tier.medium": "Επαγγελματική",
"tier.small": "Εκκίνησης",
"tm.add": "Προσθήκη",
"tm.adminOpt": "Διαχειριστής (πλήρης θέα)",
"tm.chooseEst": "Επίλεξε μια εγκατάσταση",
"tm.chooseEstPh": "Επίλεξε μια εγκατάσταση",
"tm.copyFail": "Αντιγραφή απέτυχε",
"tm.copyLink": "Αντιγραφή του συνδέσμου",
"tm.copyOk": "Ο σύνδεσμος πρόσκλησης αντιγράφηκε",
"tm.emailHint": "Ένα email πρόσκλησης θα σταλεί για να δημιουργήσεις τον κωδικό.",
"tm.expiresOn": "λήγει στις {date}",
"tm.forEmail": " για {email}",
"tm.forbidden": "Η διαχείριση ομάδας διατίθεται μόνο στον κάτοχο του λογαριασμού.",
"tm.inviteCreated": "Πρόσκληση δημιουργήθηκε",
"tm.inviteDesc": "Ένα email πρόσκλησης επιτρέπει στον συνεργάτη να δημιουργήσει τον κωδικό του.",
"tm.invitePending": "Πρόσκληση σε εκκρεμότητα",
"tm.inviteResent": "Πρόσκληση επαναστάλθηκε",
"tm.inviteSent": "Η πρόσκληση στάλθηκε μέσω email",
"tm.inviteTitle": "Πρόσκληση μέλους",
"tm.invitedOn": "Προσκληθέν στις {date}",
"tm.linkExpired": "Ο σύνδεσμος έχει λήξει",
"tm.memberRemoved": "Μέλος αφαιρέθηκε",
"tm.name": "Όνομα",
"tm.noMembers": "Δεν έχεις κανέναν συνεργάτη ακόμα.",
"tm.resendTitle": "Επαναποστολή πρόσκλησης",
"tm.role": "Ρόλος",
"tm.roleAdmin": "Διαχειριστής",
"tm.roleOwner": "Κάτοχος",
"tm.roleStaff": "Προσωπικό",
"tm.roleUpdated": "Ρόλος ενημερώθηκε",
"tm.sendInvite": "Στείλε την πρόσκληση",
"tm.sending": "Αποστολή…",
"tm.staffOpt": "Προσωπικό (βλέπει μόνο την εγκατάστασή τους)",
"trk.at": "Στη",
"trk.badge": "Παρακολούθηση",
"trk.carrier": "Μεταφορέας",
"trk.codeValidated": "Ο κωδικός επικυρώθηκε από τον συνεργάτη",
"trk.dlProof": "Κατεβάστε την απόδειξή μου για την παράδοση (PDF)",
"trk.emailLabel": "Email (προαιρετικό — για να δείτε τα στοιχεία σας)",
"trk.enterEmailCode": "Εισάγετε το email σας παραπάνω για να προβάλετε τον κωδικό σας.",
"trk.idLabel": "Αριθμός αναφοράς",
"trk.lostEmail": "Δεν έχω πλέον πρόσβαση στο email μου",
"trk.phonePh": "Ο αριθμός τηλεφώνου σας",
"trk.photoBefore": "Φωτογραφία του αντικειμένου πριν την αποστολή",
"trk.recoverBtn": "Ανάκτηση του αντικειμένου μου",
"trk.recoverHint": "Λάβετε τον κωδικό σας μέσω SMS στον καταχωρημένο αριθμό σας.",
"trk.searching": "Αναζητώ…",
"trk.secureRest": "Ασφαλής παράδοση",
"trk.send": "Αποστολή",
"trk.shipPending": "Αποστολή σε προετοιμασία — ο αριθμός παρακολούθησης θα εμφανιστεί εδώ μόλις σταλεί.",
"trk.shipTitle": "Παρακολούθηση αποστολής",
"trk.showQr": "Δείξτε αυτό το QR στον συνεργάτη για να επικυρώσετε την παράδοση",
"trk.sigSaved": "Η υπογραφή αποθηκεύτηκε",
"trk.signFirst": "Παρακαλώ υπογράψτε πριν επιβεβαιώσετε.",
"trk.signProof": "Υπογράψτε την απόδειξή σας για την παράδοση",
"trk.signSubmit": "Επιβεβαιώστε την υπογραφή μου και δημιουργήστε το PDF",
"trk.submit": "Παρακολούθηση",
"trk.subtitle": "Εισάγετε τον αριθμό αναφοράς σας για να παρακολουθήσετε την πρόοδο.",
"trk.title": "Παρακολουθήστε την αναφορά μου",
"trk.trackShipment": "Παρακολουθήστε το πακέτο",
"trk.trackingNo": "Αριθμός παρακολούθησης",
"trk.yourCode": "Ο κωδικός σας (για να το δώσετε στον συνεργάτη)",
"hc.analyzing": "Ανάλυση…",
"hc.andRecoveryIs": "και η αποκατάσταση είναι",
"hc.andTheDeclarationWillBe": "και η δήλωση θα κλείσει (μεταφέρεται στην ιστορία). Αυτή η ενέργεια είναι οριστική.",
"hc.annual20": "Ετήσιο -20%",
"hc.annualBilling20": "Ετήσια χρέωση (−20%)",
"hc.annualTarget": "Ετήσιος στόχος",
"hc.anyCommentsOptional": "Οποιαδήποτε σχόλια; (προαιρετικά)",
"hc.approveTheClaim": "Εγκρίνω την απαίτηση",
"hc.archiveCancelledConfirm": "Αρχειοθέτηση {n} καταχώρισης \"Ακυρώθηκε από τον πελάτη\"; Θα αφαιρεθούν από το μητρώο.",
"hc.asSoonAs": "Μόλις",
"hc.askTheOwnerToDisplay": "Ζητήστε από τον ιδιοκτήτη να εμφανίσει τον QR κωδικό του (σελίδα παρακολούθησης).",
"hc.askThemAtTheCounter": "Ρωτήστε τους στο γκισέ να επιβεβαιώσουν την ταυτότητα — ποτέ δημόσια ορατό.",
"hc.assistance": "Υποστήριξη",
"hc.assistanceSessionRevoked": "Η συνεδρία υποστήριξης ακυρώθηκε.",
"hc.atLeast6Characters": " Τουλάχιστον 6 χαρακτήρες",
"hc.automaticallyPreSelected": "αυτόματα προεπιλεγμένο",
"hc.automaticallyWhenShipping": "αυτόματα κατά την αποστολή.",
"hc.awaitingClaim": "Αναμονή απαίτησης",
"hc.awaitingPayment": "Αναμονή πληρωμής",
"hc.b2cCustomer": "Πελάτης B2C",
"hc.back": "Πίσω",
"hc.backToHome": "Πίσω στην αρχική",
"hc.backToMyAccount": "Πίσω στον λογαριασμό μου",
"hc.backToPayment": "Πίσω στην πληρωμή",
"hc.beforeAfterComparisonSlider": "Ρυθμιστής σύγκρισης πριν/μετά",
"hc.billingInformation": "Πληροφορίες χρέωσης",
"hc.billingInformationSaved": "Οι πληροφορίες χρέωσης αποθηκεύτηκαν ✓",
"hc.brand": "Μάρκα",
"hc.bronze": "Χάλκινο",
"hc.calculatingTheShippingRate": "Υπολογισμός του κόστους αποστολής…",
"hc.cameraUnavailableEnterTheCode": "Η κάμερα δεν είναι διαθέσιμη. Εισάγετε τον κωδικό χειροκίνητα.",
"hc.cancel": "Ακύρωση",
"hc.cancelMyDeclaration": "Ακύρωση της δήλωσής μου",
"hc.cancelSavedFmt": "Η ακύρωση αποθηκεύτηκε: \"{reason}\". Μπορείτε ακόμα να απαιτήσετε.",
"hc.cancelTheDeposit": "Ακύρωση της κατάθεσης",
"hc.cancelThisMatch": "Ακύρωση αυτού του αγώνα",
"hc.cancellationReason": "Λόγος ακύρωσης",
"hc.cancelled": "Ακυρώθηκε",
"hc.cancelledByTheCustomer": "Ακυρώθηκε από τον πελάτη",
"hc.cannotOpenPayment": "Δεν είναι δυνατή η ανοικτή πληρωμή. Παρακαλώ δοκιμάστε ξανά.",
"hc.careers": "Καριέρες",
"hc.carrier": "Μεταφορέας",
"hc.carrierAvailabilityCannotBeChecked": "Η διαθεσιμότητα του μεταφορέα δεν μπορεί να ελεγχθεί μέχρι να ρυθμιστεί ο αποστολέας Sendcloud.",
"hc.carrierConfirmedCharged": "Ο μεταφορέας επιβεβαίωσε — {price} € χρεώθηκε στον πελάτη",
"hc.carrierOther": "Μεταφορέας (άλλος)",
"hc.carrierSelection": "Επιλογή μεταφορέα",
"hc.caseClosedThankYou": "Υπόθεση κλειστή. Ευχαριστούμε!",
"hc.category": "Κατηγορία",
"hc.changeMethod": "Αλλαγή μεθόδου",
"hc.characteristic": "Χαρακτηριστικό",
"hc.chargedToCustomer": "χρεώθηκε στον πελάτη.",
"hc.checkOrEditYourDetails": "Ελέγξτε ή επεξεργαστείτε τα στοιχεία σας πριν από την ασφαλή πληρωμή.",
"hc.checkStatisticsToTrackDeposited": "Ελέγξτε τα \"Στατιστικά\" για να παρακολουθήσετε τα κατατεθειμένα αντικείμενα, το ποσοστό επιστροφής και την απόδοση κάθε καταστήματος.",
"hc.checkTheDetailsBeforeContacting": "Ελέγξτε τις λεπτομέρειες πριν επικοινωνήσετε με τον ανιχνευτή.",
"hc.checkTheDetailsBelowBefore": "Ελέγξτε τις λεπτομέρειες παρακάτω πριν ξεκινήσετε το αίτημα επιστροφής σας.",
"hc.checkTheNewItem": "Ελέγξτε το νέο αντικείμενο",
"hc.checkThePhotosAndCharacteristics": "Ελέγξτε τις φωτογραφίες και τα χαρακτηριστικά παρακάτω πριν προχωρήσετε στην ανάκτηση.",
"hc.chooseACountry": "Επιλέξτε μια χώρα",
"hc.chooseANewPassword": "Επιλέξτε έναν νέο κωδικό πρόσβασης",
"hc.chooseAReason": "Επιλέξτε έναν λόγο",
"hc.chooseTheLegalRetentionAlerts": "Επιλέξτε τις νομικές ειδοποιήσεις διατήρησης που λαμβάνονται μέσω email για",
"hc.chooseYourPasswordToAccess": "Επιλέξτε τον κωδικό σας για πρόσβαση στην κονσόλα διαχείρισης.",
"hc.city": "Πόλη",
"hc.claimApproved": "Αίτημα εγκρίθηκε",
"hc.claimApproved2": "Αίτημα εγκρίθηκε.",
"hc.claimCodeExpired": "Ο κωδικός αιτήματος έχει λήξει",
"hc.claimCodeVerified": "Ο κωδικός αιτήματος επιβεβαιώθηκε",
"hc.claimNotFound": "Δεν βρέθηκε αίτημα",
"hc.claimNotValidated": "Το αίτημα δεν έχει επικυρωθεί",
"hc.claimRejected": "Αίτημα απορρίφθηκε",
"hc.claimRejected2": "Αίτημα απορρίφθηκε.",
"hc.claimValidated": "Αίτημα επικυρωμένο",
"hc.claimValidatedByThePartner": "Αίτημα επικυρωμένο από τον συνεργάτη",
"hc.claimant": "Αιτών",
"hc.claimsToBeTheOwner": "δηλώνει ότι είναι ο ιδιοκτήτης αυτού του αντικειμένου και απάντησε στις ερωτήσεις επιβεβαίωσης. Εγκρίνετε μόνο αν οι απαντήσεις ταιριάζουν.",
"hc.claimsToValidate": "Αιτήματα προς επικύρωση",
"hc.clear": "Καθαρισμός",
"hc.clickToZoom": "Κάντε κλικ για μεγέθυνση",
"hc.close": "Κλείσιμο",
"hc.close2": "Κλείσιμο",
"hc.closeTheDeclaration": "Κλείσιμο δήλωσης",
"hc.closeTheDeclaration2": "Κλείσιμο δήλωσης;",
"hc.codeAlreadyVerified": "Κωδικός ήδη επιβεβαιωμένος",
"hc.codeCopied": "Κωδικός αντιγραφής",
"hc.collapse": "Σύμπτυξη",
"hc.color": "Χρώμα",
"hc.company": "Εταιρεία",
"hc.companyName": "Όνομα εταιρείας",
"hc.comparePhotos": "Σύγκριση φωτογραφιών",
"hc.compareThemWithTheOwner": "Συγκρίνετε τα με τις απαντήσεις του ιδιοκτήτη — ποτέ δημόσια ορατές.",
"hc.condition": "Κατάσταση",
"hc.confirmAndPay": "Επιβεβαίωση και πληρωμή",
"hc.confirmCancellation": "Επιβεβαίωση ακύρωσης",
"hc.confirmCrop": "Επιβεβαίωση κοπής",
"hc.confirmDeletion": "Επιβεβαίωση διαγραφής",
"hc.confirmPassword": "Επιβεβαίωση κωδικού πρόσβασης",
"hc.confirmThatThisIsYour": "Επιβεβαιώστε ότι αυτό είναι το αντικείμενό σας. Θα ζητηθεί έλεγχος ταυτότητας από τον ανιχνευτή πριν από οποιαδήποτε επαφή.",
"hc.confirmTheCarrier": "Επιβεβαίωση μεταφορέα",
"hc.confirmThePassword": "Επιβεβαίωση του κωδικού πρόσβασης",
"hc.confirmYourShippingAddressTo": "Επιβεβαιώστε τη διεύθυνση αποστολής σας για να προχωρήσετε στην πληρωμή.",
"hc.confirmYourSubscription": "Επιβεβαίωση συνδρομής σας",
"hc.confirmed": "Επιβεβαιωμένο ✓",
"hc.contactFindoToGetYour": "Επικοινωνήστε με το Findloop για να λάβετε το ID αποστολέα σας.",
"hc.contactUs": "Επικοινωνήστε μαζί μας",
"hc.continueTheReturn": "Συνέχεια επιστροφής",
"hc.continueToPayment": "Συνέχεια στην πληρωμή",
"hc.copy": "Αντιγραφή",
"hc.correctMyDetails": "διόρθωση λεπτομερειών μου",
"hc.correctThisEntry": "Διόρθωση αυτής της καταχώρισης;",
"hc.country": "Χώρα",
"hc.countryAddress": "Χώρα (διεύθυνση)",
"hc.countryIsoCodeEG": "Χώρα (ISO κωδικός, π.χ. FR)",
"hc.cover": "κάλυψη",
"hc.createTheShipment": "Δημιουργία αποστολής",
"hc.cropThePhoto": "Κόψτε τη φωτογραφία",
"hc.customer": "Πελάτης",
"hc.customerClaimCodeToCheck": "Κωδικός αξίωσης πελάτη — για έλεγχο κατά την παραλαβή:",
"hc.customerReasonFmt": "Λόγος πελάτη: \"{reason}\".",
"hc.customerReminderDelay": "Καθυστέρηση υπενθύμισης πελάτη",
"hc.customerWhosePublicListingMatches": "Πελάτης του οποίου η δημόσια καταχώριση ταιριάζει με αυτό το αντικείμενο — ορατή μόνο σε εσάς.",
"hc.d15": "D-15",
"hc.dangerZone": "Ζώνη κινδύνου",
"hc.date": "Ημερομηνία",
"hc.dateNewest": "Ημερομηνία (πιο πρόσφατη)",
"hc.dateOldest": "Ημερομηνία (πιο παλιά)",
"hc.daysToYearEnd": "{n} ημέρες μέχρι το τέλος του έτους",
"hc.deadlineAlert": "Ειδοποίηση προθεσμίας",
"hc.declarationClosed": "Δήλωση κλειστή ✓",
"hc.declarationNotFound": "Δήλωση δεν βρέθηκε.",
"hc.declarationNotFound2": "Δήλωση δεν βρέθηκε",
"hc.declarationTracking": "Παρακολούθηση δήλωσης",
"hc.defaultCarrier": "Προεπιλεγμένος μεταφορέας",
"hc.defaultCarrierPreselected": "Προεπιλεγμένος μεταφορέας προεπιλεγμένος — μπορεί να αλλάξει για αυτή τη σκήση. Πραγματική τιμή (Sendcloud + {m}% περιθώριο).",
"hc.defaultCarrierRemoved": "Προεπιλεγμένος μεταφορέας αφαιρέθηκε",
"hc.delayHours": "Καθυστέρηση (ώρες)",
"hc.deleteMyAccount": "Διαγραφή του λογαριασμού μου",
"hc.deleting": "Διαγράφεται…",
"hc.deletingDeactivatesYourAccountLogin": "Η διαγραφή αποενεργοποιεί την είσοδο στον λογαριασμό σας: η είσοδος είναι μπλοκαρισμένη και τα δεδομένα διατηρούνται για 30 ημέρες. Θα λάβετε ένα email με έναν σύνδεσμο επαναδραστηριοποίησης έγκυρο για 30 ημέρες.",
"hc.delivered": "Παραλήφθηκε",
"hc.depositAnItem": "Καταθέστε ένα αντικείμενο",
"hc.depositCancelledItemPutBack": "Η κατάθεση ακυρώθηκε — το αντικείμενο επιστρέφει στο απόθεμα.",
"hc.depositCancelledItemRemovedFrom": "Η κατάθεση ακυρώθηκε — το αντικείμενο αφαιρέθηκε από το μητρώο.",
"hc.depositedOn": "Κατατέθηκε στις",
"hc.describeTheItemBrandColor": "Περιγράψτε το αντικείμενο: μάρκα, χρώμα, διακριτικά σημάδια… (Όσο περισσότερες λεπτομέρειες δώσετε, τόσο καλύτερες είναι οι πιθανότητες εύρεσης του αντικειμένου σας)",
"hc.dimensionsCm": "Διαστάσεις (cm)",
"hc.disablingAnEmail": "Απενεργοποίηση ενός email",
"hc.doesNotHide": "δεν κρύβει",
"hc.download": "Λήψη",
"hc.downloadThePdf": "Λήψη του PDF",
"hc.draftRestoredPickUpYour": "Πρόχειρο αποκατέστησε — παραλάβετε τη δήλωσή σας εκεί που τη σταματήσατε.",
"hc.dragToReposition": "Σύρετε για επανατοποθέτηση",
"hc.eGColisPriv": "π.χ. Colis Privé",
"hc.eachItemGetsAQr": "Κάθε αντικείμενο αποκτά μια ετικέτα QR. Σαρώστε την από \"Αποθήκευση & QR\" για να εντοπίσετε ένα αντικείμενο αμέσως.",
"hc.eachSiteManagesItsOwn": "Κάθε ιστότοπος διαχειρίζεται τη δική του τραπεζική. Μεταβείτε στο",
"hc.edit": "Επεξεργασία",
"hc.emailNotificationPreferences": "Προτιμήσεις ειδοποιήσεων email",
"hc.emailPreferencesUpdated": "Οι προτιμήσεις email ενημερώθηκαν",
"hc.enableOrDisableRecoveryFees": "Ενεργοποίηση ή απενεργοποίηση τελών ανάκτησης για",
"hc.enlargePhoto": "Μεγέθυνση φωτογραφίας",
"hc.enterTheCustomerSCode": "Εισάγετε τον κωδικό του πελάτη",
"hc.estShipRate": "Εκτιμώμενο κόστος αποστολής (Sendcloud + {m}% περιθώριο):",
"hc.establishment": "Κατάστημα",
"hc.establishment2": "Κατάστημα:",
"hc.establishmentInItsSendcloudAccount": "κατάστημα στο λογαριασμό του Sendcloud και σας δίνει το ID αποστολέα",
"hc.establishmentSettings": "Ρυθμίσεις καταστήματος",
"hc.exCode": "π.χ. ABCD2345",
"hc.exId": "π.χ. 3f2a…",
"hc.exit": "Έξοδος",
"hc.explainWhyThisItemIs": "Εξηγήστε γιατί αυτό το αντικείμενο δεν είναι δικό σας…",
"hc.externalPaymentLinks": "Εξωτερικοί σύνδεσμοι πληρωμής",
"hc.failed": "Απέτυχε",
"hc.feesEnabled": "Τέλη ενεργοποιημένα",
"hc.field": ") πεδίο.",
"hc.finderAcceptedCloseTheCase": "Ο Finder αποδέχτηκε — κλείστε την υπόθεση μόλις παραδοθεί το αντικείμενο αυτοπροσώπως.",
"hc.findoCityRanking": "Findloop — Κατάταξη πόλης",
"hc.findoForEstablishments": "Findloop για καταστήματα",
"hc.findoPresentationVideo": "Βίντεο παρουσίασης Findloop",
"hc.findoRegistersTheAddressOf": "Ο Findloop καταχωρεί τη διεύθυνση του",
"hc.findoReviewShare": "Findloop {year} ανασκόπηση: {n} αντικείμενα επιστράφηκαν, ποσοστό επιστροφής {rate}% 🎉",
"hc.firstVerifyTheClaimCode": "Επιβεβαιώστε πρώτα τον κωδικό αξίωσης παραπάνω",
"hc.forEveryNewShipmentFrom": "για κάθε νέα αποστολή από",
"hc.free": "δωρεάν",
"hc.freeRecovery0": "Δωρεάν ανάκτηση (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Δωρεάν ανάκτηση σε όλη την Αφρική – Προσφορά έναρξης",
"hc.freeRecoveryFeesDisabled0": "Δωρεάν ανάκτηση: τέλη απενεργοποιημένα (0 €)",
"hc.fromTeamInviteYourColleagues": "Από \"Ομάδα\", προσκαλέστε τους συναδέλφους σας μέσω email και αναθέστε τους μια επιχείρηση. Κάθε μέλος βλέπει μόνο το δικό του πεδίο.",
"hc.fullName": "Πλήρες όνομα",
"hc.fullPhoto": "Ολόκληρη φωτογραφία",
"hc.gallery": "Γκαλερί",
"hc.giveTheReasonForCancelling": "Δώστε τον λόγο για την ακύρωση. Ο συνεργάτης θα ενημερωθεί.",
"hc.goToLogin": "Μετάβαση στην είσοδο",
"hc.goToMyAccount": "Μετάβαση στον λογαριασμό μου",
"hc.gold": "Χρυσό",
"hc.googleLoginFailed": "Η είσοδος μέσω Google απέτυχε",
"hc.hasConfirmedYourPaymentYou": "έχει επιβεβαιώσει την πληρωμή σας, θα ανακατευθυνθείτε αυτόματα",
"hc.helpCenter": "Κέντρο βοήθειας",
"hc.helpUsImproveWhyAre": "Βοηθήστε μας να βελτιωθούμε: γιατί φεύγετε; Ο λογαριασμός σας θα απενεργοποιηθεί και μπορεί να ενεργοποιηθεί ξανά για 30 ημέρες.",
"hc.hidePassword": "Απόκρυψη κωδικού πρόσβασης",
"hc.high": "Υψηλό",
"hc.historyOfYourMonthlySubscriptions": "Ιστορικό των μηνιαίων συνδρομών σας και της κατάστασης πληρωμής τους.",
"hc.hotelBelmont": "Ξενοδοχείο Belmont",
"hc.howConfigureSenderId": "Πώς μπορώ να ρυθμίσω τον αριθμητικό Sender ID;",
"hc.iDonTUseIt": "Δεν το χρησιμοποιώ αρκετά",
"hc.iFoundItElsewhere": "Το βρήκα αλλού",
"hc.iNoLongerNeedMy": "Δεν χρειάζομαι πια το αντικείμενό μου",
"hc.identityVerification": "Επαλήθευση ταυτότητας",
"hc.idleLogoutIn": "Θα αποσυνδεθείτε σε {n} δευτερόλεπτα λόγω αδράνειας.",
"hc.ifProvidedTheVolumetricWeight": "Αν παρέχεται, ισχύει το όγκο βάρος.",
"hc.ifThePartnerHasNot": "Εάν ο συνεργάτης δεν έχει επιβεβαιώσει την παραλαβή της εξωτερικής πληρωμής μετά από αυτήν την καθυστέρηση, η Findloop υπενθυμίζει αυτόματως στον συνεργάτη να την επικυρώσει.",
"hc.impersonationEnded": "Η παριστία έχει λήξει.",
"hc.impersonationMode": "Λειτουργία παριστίας",
"hc.impersonationSessionExpired": "Η συνεδρία παριστίας έχει λήξει.",
"hc.inTheField": ", στον τομέα",
"hc.inTransit": "Σε μεταφορά",
"hc.inclVat": "περιλ. ΦΠΑ",
"hc.intraEuVatNumberOptional": "Αριθμός ΦΠΑ εντός Ε.Ε. προαιρετικός, δεν απαιτείται SIRET (εκτός Γαλλίας).",
"hc.invalidInvitationLink": "Μη έγκυρος σύνδεσμος πρόσκλησης.",
"hc.invalidInvitationLink2": "Μη έγκυρος σύνδεσμος πρόσκλησης",
"hc.invalidInviteLink": "Μη έγκυρος ή ληγμένος σύνδεσμος πρόσκλησης.",
"hc.invalidNumberEnterAnInternational": "Μη έγκυρος αριθμός. Εισάγετε έναν διεθνή αριθμό, π.χ. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Μη έγκυρος ή ληγμένος σύνδεσμος.",
"hc.invalidOrExpiredReactivationLink": "Μη έγκυρος ή ληγμένος σύνδεσμος εκ νέου ενεργοποίησης",
"hc.invalidSendcloudId": "Μη έγκυρος ταυτοποιητής Sendcloud",
"hc.inviteSubtitle": "{org} σας προσκαλεί να ενωθείτε με την ομάδα Findloop τους. Επιλέξτε τον κωδικό πρόσβασής σας για να ενεργοποιήσετε τον λογαριασμό σας.",
"hc.isAvailableOnSendcloudFor": "είναι διαθέσιμο στο Sendcloud για όλες τις διαδρομές σας (εγχώριες + διεθνείς).",
"hc.isNotEnabledOnYour": "δεν είναι ενεργοποιημένο στον λογαριασμό σας Sendcloud για ορισμένους προορισμούς. Οι ετικέτες για αυτούς θα δημιουργηθούν με άλλο διαθέσιμο μεταφορέα.",
"hc.isThisReallyYourItem": "Είναι αυτό πραγματικά το αντικείμενό σας;",
"hc.isThisYourItem": "Είναι αυτό το αντικείμενό σας;",
"hc.item": "Αντικείμενο",
"hc.itemAlreadyConfirmed": "Αντικείμενο ήδη επιβεβαιωμένο",
"hc.itemDetails": "Λεπτομέρειες αντικειμένου",
"hc.itemFoundAt": "Αντικείμενο βρέθηκε στο",
"hc.itemFoundAtAPartner": "Αντικείμενο βρέθηκε σε συνεργάτη",
"hc.itemMarkedAsReturned": "Αντικείμενο σημειωμένο ως επιστραμμένο ✓",
"hc.itemPhotoRequiredBeforeShipping": "Φωτογραφία αντικειμένου (απαιτείται πριν από την αποστολή)",
"hc.itemPhotoSaved": "Φωτογραφία αντικειμένου αποθηκεύτηκε",
"hc.itemPreview": "Προεπισκόπηση αντικειμένου",
"hc.itemPutBackInStorage": "Αντικείμενο επιστρέφει προς αποθήκευση.",
"hc.itemWeight": "Βάρος αντικειμένου:",
"hc.itemsReturned": "αντικείμενο(α) επιστραμμένο(α)",
"hc.itemsReturnedThisYear": "αντικείμενα που επιστράφηκαν φέτος",
"hc.itemsWhoseLegalDeadlineIs": "Αντικείμενα που η νομική προθεσμία τους είναι 15 ημέρες ή λιγότερο (συμπεριλαμβανομένων των καθυστερημένων). Οι αγορές παραμένουν ορατές.",
"hc.kbisNumber": "Αριθμός Kbis",
"hc.keysForgottenOnABench": "Κλειδιά που ξεχάστηκαν σε ένα παγκάκι",
"hc.labelBeingGenerated": "Ετικέτα που δημιουργείται",
"hc.leaveTheFieldsEmptyTo": "Αφήστε τα πεδία κενά για να προσφέρετε αποκατάσταση δωρεάν.",
"hc.legalNotice": "Νομική ειδοποίηση",
"hc.limitReachedUpgradeToA": "Έφτασε το όριο — αναβαθμίστε σε ανώτερο σχέδιο",
"hc.linkCopiedShareOn": "Σύνδεσμος αντιγράφηκε — μοιραστείτε τον στο {label}",
"hc.linkUnavailable": "Σύνδεσμος μη διαθέσιμος",
"hc.linkedTo": "Συνδεδεμένο με",
"hc.listingHiddenByModeration": "Καταχώριση κρυμμένη από τη μετρίαση.",
"hc.loading": "Φόρτωση…",
"hc.locateMe": "Εντοπίστε με",
"hc.logIn": "Σύνδεση",
"hc.logInToGetBack": "Συνδεθείτε για να επιστρέψετε στο χώρο σας και να διαχειριστείτε την συνδρομή σας.",
"hc.loginFailed": "Αποτυχία σύνδεσης",
"hc.lostFoundPlatform": "Πλατφόρμα χαμένων & ευρεθέντων.",
"hc.lostIn": "χαμένο σε",
"hc.lowRate": "Χαμηλή τιμή",
"hc.mainReason": "Κύριος λόγος",
"hc.mainStreet": "Κεντρικός Δρόμος",
"hc.makeSureThisIsThe": "Βεβαιωθείτε ότι αυτό είναι το αντικείμενο που χάσατε πριν ξεκλειδώσετε τα στοιχεία επικοινωνίας του ανακριτή.",
"hc.manageCookies": "Διαχείριση cookies",
"hc.manageMyTeam": "Διαχείριση της ομάδας μου",
"hc.manageYourTeam": "Διαχείριση της ομάδας σας",
"hc.markAsReturned": "Σημειώστε ως επιστραφέν",
"hc.matchNoClaimInTime": "Η αντιστοίχιση δεν έλαβε καμία απαίτηση εντός της προθεσμίας.",
"hc.matchNotFound": "Η αντιστοίχιση δεν βρέθηκε",
"hc.medium": "Μέσο",
"hc.milestoneFmt": "{m} ορόσημο επιστραφέντων αντικειμένων επιτεύχθηκε! Στον δρόμο για {next}.",
"hc.missingFeatures": "Λείπουν δυνατότητες",
"hc.monthly": "Μηνιαία",
"hc.monthlyBilling": "Μηνιαία χρέωση",
"hc.moveThePhotoToFit": "Μετακινήστε την φωτογραφία για να ταιριάξει στον κύκλο.",
"hc.myAccount": "Ο λογαριασμός μου",
"hc.myInvoices": "Οι τιμολόγιές μου",
"hc.myMonthlyInvoices": "Τα μηνιαία τιμολόγιά μου",
"hc.nArchived": "{n} καταχώρηση(εις) αρχειοθετημένες.",
"hc.newCodeGeneratedAndSent": "Νέος κωδικός δημιουργήθηκε και εστάλη στον πελάτη μέσω email και SMS",
"hc.newCodeGeneratedAndSent2": "Νέος κωδικός δημιουργήθηκε και εστάλη στον κάτοχο",
"hc.newPassword": "Νέος κωδικός πρόσβασης",
"hc.next": "Επόμενο",
"hc.nextPhoto": "Επόμενη φωτογραφία",
"hc.no": "Όχι",
"hc.noAnswerProvided": "Δεν παρέχεται καμία απάντηση.",
"hc.noArchivedDeclarations": "Δεν υπάρχουν αρχειοθετημένες δηλώσεις",
"hc.noCountryFound": "Δεν βρέθηκε καμία χώρα",
"hc.noDeclarations": "Δεν υπάρχουν δηλώσεις",
"hc.noFeesAreChargedTo": "Δεν χρεώνονται τέλη στον πελάτη.",
"hc.noInvoiceYet": "Δεν υπάρχει καμία απόδειξη ακόμα.",
"hc.noInvoiceYetYourInvoices": "Δεν υπάρχει καμία απόδειξη ακόμα. Οι αποδείξεις σας θα εμφανιστούν εδώ αυτόματα μετά από κάθε πληρωμή.",
"hc.noMatchIsAvailableFor": "Δεν υπάρχει διαθέσιμος αγώνας τώρα. Θα σας ενημερώσουμε μόλις βρεθεί ένα αντικείμενο που ταιριάζει στη δήλωσή σας.",
"hc.noShipmentMatchesYourSearch": "Δεν υπάρχει καμία αποστολή που να ταιριάζει στην αναζήτησή σας.",
"hc.noShipmentsYet": "Δεν υπάρχουν αποστολές ακόμα.",
"hc.noShipmentsYet2": "Δεν υπάρχουν αποστολές ακόμα",
"hc.none": "κανένα",
"hc.noneChooseForEachShipment": "Κανένα (επιλέξτε για κάθε αποστολή)",
"hc.notMine": "Δεν είναι δικό μου",
"hc.of": "του",
"hc.only": "Μόνο",
"hc.onlyEachSiteManagesIts": "μόνο. Κάθε ιστότοπος διαχειρίζεται τη δική του τραπεζική: αυτοί οι σύνδεσμοι δεν επηρεάζουν καμία άλλη επιχείρηση.",
"hc.onlyTheOwnerOrAn": "Μόνο ο κάτοχος ή ένας διαχειριστής μπορεί να διαμορφώσει τους συνδέσμους πληρωμής της επιχείρησης.",
"hc.openDepositInTheMenu": "Ανοίξτε το «Κατάθεση» στο μενού, περιγράψτε το αντικείμενο και βγάλτε μια φωτογραφία. Αμέσως αποθηκεύεται και είναι έτοιμο να επιστραφεί.",
"hc.openSettings": "Ανοίξτε Ρυθμίσεις →",
"hc.openTheDeclarationToManage": "Ανοίξτε τη δήλωση για να διαχειριστείτε την αποστολή",
"hc.optional": "— προαιρετικό",
"hc.optional2": "(προαιρετικό)",
"hc.optional3": "προαιρετικό",
"hc.originalListingPhotoUsed": "Χρησιμοποιήθηκε η αρχική φωτογραφία καταχώρησης",
"hc.other": "Άλλο",
"hc.other2": "Άλλο…",
"hc.ourProducts": "Τα προϊόντα μας",
"hc.overallRateTrendLast6": "Γενική τάση ρυθμού (τελευταίοι 6 μήνες)",
"hc.ownerSClaimCode": "Κωδικός αξίωσης κατόχου",
"hc.ownershipConfirmed": "Η κυριότητα επιβεβαιώθηκε",
"hc.paid": "Πληρωμένο",
"hc.paidOn": "Πληρώθηκε στις",
"hc.paidViaPartner": "Πληρωμή (μέσω συνεργάτη)",
"hc.parcelBeingPrepared": "Πακέτο σε προετοιμασία",
"hc.parcelDelivered": "Πακέτο παραδόθηκε",
"hc.parcelShipped": "Πακέτο αποστάλθηκε",
"hc.parisGareDeLyon": "Παρίσι, Gare de Lyon…",
"hc.partner": "Συνεργάτης",
"hc.partner2": "συνεργάτης",
"hc.partnerDirectory": "Κατάλογος συνεργατών",
"hc.passedOnToTheCustomer": "— μεταφέρθηκε στον πελάτη σύνδεσμος πληρωμής.",
"hc.password": "Κωδικός πρόσβασης",
"hc.passwordResetPleaseLogIn": "Επαναφορά κωδικού πρόσβασης, παρακαλώ συνδεθείτε.",
"hc.passwordUpdated": "Ο κωδικός πρόσβασης ενημερώθηκε.",
"hc.passwordsDoNotMatch": "Οι κωδικοί πρόσβασης δεν ταιριάζουν.",
"hc.pasteThisSenderIdIn": "Επικολλήστε αυτό το Sender ID στο Findloop → Ρυθμίσεις",
"hc.payForTheShipmentOf": "Πληρώστε για την αποστολή του αντικειμένου σας μέσω του Findloop με ασφαλή πληρωμή.",
"hc.payTheRecoveryFees": "Πληρώστε τα τέλη ανάκτησης",
"hc.payTheShippingFees": "Πληρώστε τα τέλη αποστολής",
"hc.payment": "Πληρωμή",
"hc.paymentAlreadyConfirmedByThe": "Η πληρωμή έχει ήδη επιβεβαιωθεί από τον συνεργάτη",
"hc.paymentLinksAreNowConfigured": "Οι σύνδεσμοι πληρωμής είναι τώρα ρυθμισμένοι ανά ίδρυμα",
"hc.paymentNotCompletedYourAccount": "Η πληρωμή δεν ολοκληρώθηκε, ο λογαριασμός σας δεν έχει δημιουργηθεί — παρακαλώ προσπαθήστε ξανά.",
"hc.paymentReceived": "Πληρωμή παραλήφθηκε",
"hc.paymentSuccessful": "Η πληρωμή ήταν επιτυχής!",
"hc.pdfInvoice": "Τιμολόγιο PDF",
"hc.pending": "Εκκρεμεί",
"hc.period": "Περίοδος",
"hc.phoneNumber": "Τηλεφωνικός αριθμός",
"hc.phoneOptional": "Τηλέφωνο (προαιρετικό)",
"hc.planAt": "σχέδιο στο",
"hc.planLimitFmt": "Το πρόγραμμα \"{plan}\" σας περιορίζεται σε {max} ιδρύματα. Για να διαχειριστείτε {n} τοποθεσίες, προτείνουμε το",
"hc.platformReturnTarget": "Στόχος επιστροφής πλατφόρμας",
"hc.pleaseCompleteYourShippingAddress": "Παρακαλώ συμπληρώστε τη διεύθυνση αποστολής σας.",
"hc.pleaseProvideAPhoneNumber": "Παρακαλώ παρέχετε έναν τηλεφωνικό αριθμό: απαιτείται από τον διανομέα για την αποστολή.",
"hc.pleaseProvideAReason": "Παρακαλώ παρέχετε έναν λόγο.",
"hc.pleaseSetYourOwnPassword": "παρακαλώ ορίστε τον δικό σας κωδικό πρόσβασης πριν προχωρήσετε.",
"hc.pointsToGoal": "{n} περισσότερες πόντοι για να φτάσουμε τον κοινό μας στόχο.",
"hc.posterPreview": "Προεπισκόπηση αφίσας",
"hc.potentialMatchBeingVerified": "Πιθανός ταιριασμένος επαληθεύεται",
"hc.potentialOwner": "Πιθανός ιδιοκτήτης",
"hc.preFilledAutomaticallyYouCan": "Προ-συμπληρωμένο αυτόματα — μπορείτε να το αντικαταστήσετε με μια φωτογραφία του πακέτου.",
"hc.reportAProblem": "Αναφορά προβλήματος",
"hc.reportDismissedYourListingRemains": "Η αναφορά απορρίφθηκε. Η καταχώρισή σας παραμένει δημόσια.",
"hc.requiredUsedToCalculateThe": "Απαιτείται: χρησιμοποιείται για τον υπολογισμό του κόστους αποστολής Sendcloud. Η αποστολή δεν είναι διαθέσιμη πάνω από 30 kg.",
"hc.reset": "Επαναφορά",
"hc.resume": "Συνέχεια",
"hc.resumeRegistration": "Συνέχεια εγγραφής",
"hc.retro": "Έτος σε ανασκόπηση",
"hc.returnSecurity": "Ασφάλεια επιστροφής",
"hc.returnToTheOwner": "Επιστροφή στον ιδιοκτήτη",
"hc.returned": "επιστράφηκε",
"hc.reviewTheItemDetails": "Εξετάστε τις λεπτομέρειες του αντικειμένoυ",
"hc.revokeAccess": "Ανάκληση πρόσβασης",
"hc.role": "Ρόλος:",
"hc.save": "Αποθήκευση",
"hc.save2": "αποθήκευση",
"hc.saveAndContinue": "Αποθήκευση και συνέχεια",
"hc.saving": "Αποθήκευση…",
"hc.scanTheClaimCode": "Σαρώστε τον κωδικό αξίωσης",
"hc.scanTheOwnerSQr": "Σαρώστε τον QR του ιδιοκτήτη",
"hc.scrollThroughLanguages": "Περιστροφή μέσω γλωσσών",
"hc.searchByCustomerItemOr": "Αναζητήστε ανά πελάτη, αντικείμενο ή αριθμό παρακολούθησης…",
"hc.searchForACountry": "Αναζητήστε μια χώρα…",
"hc.secureFindoVerification": "Ασφαλής επιβεβαίωση Findloop",
"hc.seeRetro": "Δείτε το έτος σε ανασκόπηση",
"hc.selectedCarrier": "Επιλεγμένος πάροχος:",
"hc.selectedPlan": "Επιλεγμένο πλάνο",
"hc.send": "Αποστολή",
"hc.sendcloudSenderIdSaved": "Αποθηκεύθηκε ο αποστολέας Sendcloud ID",
"hc.sendcloudSenderIdSenderId": "Sendcloud αποστολέας ID (sender_id)",
"hc.sending": "Αποστολή…",
"hc.sessionExpired": "Η συνεδρία έχει λήξει",
"hc.setUpYourEstablishments": "Ρυθμίστε τις εγκαταστάσεις σας",
"hc.settings": "Ρυθμίσεις",
"hc.settingsSubtitle": "Εξωτερικές πληρωμές και υπενθυμίσεις, διαμορφωμένες ανά εγκατάσταση.",
"hc.shareFoundText": "Βρήκα ένα αντικείμενο — βοήθησέ με να βρω τον ιδιοκτήτη του στο Findloop",
"hc.shareLostText": "Έχω χάσει ένα αντικείμενο — βοήθησέ με να το βρω στο Findloop",
"hc.sharePreview": "Κοινοποίηση προεπισκόπησης",
"hc.shareTheRanking": "Κοινοποίηση της κατάταξης",
"hc.shareYourQrCodeTo": "Κοινοποιήστε τον QR κωδικό σας για να λάβετε δηλώσεις.",
"hc.shipRateAutoWeight": "Η χρέωση αποστολής υπολογίζεται αυτόματα μέσω του Sendcloud (βάρος {w}) τη στιγμή της αποστολής.",
"hc.pressKit": "Κείμενο τύπου",
"hc.previewMode": "Λειτουργία προεπισκόπησης:",
"hc.previewOfThePrintReady": "Προεπισκόπηση της έτοιμης προς εκτύπωση αφίσας A4 για αυτή την επιχείρηση.",
"hc.previous": "Προηγούμενο",
"hc.previousPhoto": "Προηγούμενη φωτογραφία",
"hc.primary": "κύριο",
"hc.printThePoster": "Εκτύπωση της αφίσας",
"hc.privacy": "Προστασία προσωπικών δεδομένων",
"hc.privacyPolicy": "Πολιτική προστασίας προσωπικών δεδομένων",
"hc.processedCasesWillAppearHere": "Οι επεξεργασμένες περιπτώσεις θα εμφανιστούν εδώ.",
"hc.proofOfReturnPdf": "Απόδειξη επιστροφής (PDF)",
"hc.protectedByRecaptcha": "Προστατευμένο από reCAPTCHA",
"hc.publicMatch": "Δημόσια αντιστοιχία",
"hc.putBackInStorage": "Επιστροφή στην αποθήκευση",
"hc.pwdResetByTeam": "Ο κωδικός πρόσβασης σας επαναρυθμίστηκε από την ομάδα μας. Για την ασφάλειά σας,",
"hc.questionsToAskTheOwner": "Ερωτήσεις προς τον ιδιοκτήτη",
"hc.rateChargedToTheCustomer": "Χρέωση προς τον πελάτη:",
"hc.rateOfTarget": "{rate}% επιτευχθέν από στόχο {target}%",
"hc.reached": "επιτεύχθηκε",
"hc.reactivating": "Επαναδραστηριοποίηση…",
"hc.reasonSavedYouCanStill": "Η αιτία αποθηκεύτηκε. Μπορείτε να διεκδικήσετε το αντικείμενό σας.",
"hc.recentMatchesFirst": "Πρώτα οι πρόσφατες αντιστοιχίες",
"hc.recognizedThePhotoYouSent": "αναγνώρισε τη φωτογραφία που στείλατε και περιέγραψε αυτά τα χαρακτηριστικά. Επιβεβαιώστε μόνο εάν συμφωνούν με το αντικείμενο που έχετε.",
"hc.recommended": "Συνιστάται",
"hc.recoveryFees": "Τέλη ανάκτησης",
"hc.recoveryFeesArePaidDirectly": "Τα τέλη ανάκτησης καταβάλλονται απευθείας στο συνεργαζόμενο κατάστημα. Ο Findloop δεν λαμβάνει πληρωμή από τους πελάτες.",
"hc.recoveryFeesEnabled": "Ενεργοποιημένα τέλη ανάκτησης",
"hc.recoveryOfferedByTheEstablishment": "Ανάκτηση που προσφέρεται από την επιχείρηση – ο Findloop δεν χρεώνει τέλη.",
"hc.recoveryPaymentLink": "Σύνδεσμος πληρωμής ανάκτησης",
"hc.recoveryPaymentLinkSavedFor": "Ο σύνδεσμος πληρωμής ανάκτησης αποθηκεύτηκε για αυτή την επιχείρηση",
"hc.redirecting": "Ανακατεύθυνση…",
"hc.redirectingToPayment": "Ανακατεύθυνση στη πληρωμή…",
"hc.redirectingToTheRecoveryOf": "Ανακατεύθυνση στην ανάκτηση του αντικειμένου σας…",
"hc.regenerateAndResendToThe": "Αναδημιουργία και επαναποστολή στον ιδιοκτήτη",
"hc.regenerateTheCode": "Αναδημιουργία του κωδικού",
"hc.registerAFoundItem": "Καταχώρηση ενός βρεθέντος αντικειμένου",
"hc.rejectTheClaim": "Απόρριψη της αξίωσης",
"hc.reminderDelaySaved": "Η καθυστέρηση υπενθύμισης αποθηκεύτηκε",
"hc.reopenThePaymentLink": "Επαναφορά του συνδέσμου πληρωμής",
"hc.repeatThePassword": "Επανάληψη του κωδικού πρόσβασης",
"hc.shipRateForWeight": "Τιμή αποστολής (Sendcloud + {m}% περιθώριο) για {w}:",
"hc.shipments": "Αποστολές",
"hc.shipmentsSubtitle": "Συγκεντρωτική προβολή όλων των αποστολών του καταστήματος, σε όλες τις περιπτώσεις. Κάντε κλικ σε μια γραμμή για να διαχειριστείτε την αποστολή στην δήλωσή της.",
"hc.shipping": "Αποστολή",
"hc.shippingAddress": "Διεύθυνση αποστολής",
"hc.shippingFeesAreHandledAutomatically": "Οι χρεώσεις αποστολής διεκπεραιώνονται αυτόματα από την Findloop (Sendcloud) — δεν χρειάζεται να εισαγάγετε σύνδεσμο.",
"hc.shippingFeesHaveAlreadyBeen": "Οι χρεώσεις αποστολής έχουν ήδη εξοφληθεί: η εταιρεία ταχυμεταφορών δεν μπορεί να αλλάξει.",
"hc.shippingNotAvailableForItems": "Η αποστολή δεν είναι διαθέσιμη για αντικείμενα άνω των 30 kg. Ο πελάτης θα πρέπει να παραλάβει το αντικείμενο αυτοπροσώπως.",
"hc.shippingPaid": "Αποστολή εξοφλημένη ✓",
"hc.showOnlyItemsMatchingA": "Εμφάνιση μόνο αντικειμένων που ταιριάζουν με μια δημόσια (πελάτη) καταχώριση",
"hc.showPassword": "Εμφάνιση κωδικού πρόσβασης",
"hc.signInTheBoxAbove": "Συνδεθείτε στο κουτί παραπάνω",
"hc.signatureSaved": "Υπογραφή αποθηκεύθηκε",
"hc.signedInWithGoogle": "Συνδεδεμένος με Google",
"hc.signupFailed": "Η εγγραφή απέτυχε",
"hc.silver": "Ασημένιο",
"hc.simulatedRatesInPreProduction": "(προσομοιωμένες τιμές σε προ-παραγωγή)",
"hc.siretAndVatNumberRequired": "Απαιτείται αριθμός SIRET και ΦΠΑ (Γαλλία).",
"hc.skip": "Παράλειψη",
"hc.smsSentIfAccount": "Αν υπάρχει λογαριασμός με αυτόν τον αριθμό, σας έχει σταλεί SMS.",
"hc.sortItemsWithAPublic": "Ταξινόμηση: αντικείμενα με δημόσιο ταίρι (πιο πρόσφατα) πρώτα",
"hc.specifyWhetherYouRecoveredYour": "Δηλώστε αν ανακτήσατε το αντικείμενό σας ή αν απλώς θέλετε να αφαιρέσετε αυτήν την καταχώριση.",
"hc.specifyYourReason": "Δηλώστε τον λόγο σας",
"hc.specifyYourReason2": "Δηλώστε τον λόγο σας…",
"hc.staff": "Προσωπικό",
"hc.status": "Κατάσταση",
"hc.staySignedIn": "Μείνετε συνδεδεμένοι",
"hc.step": "Βήμα",
"hc.stillThere": "Ακόμα εδώ;",
"hc.stopScrolling": "Σταματήστε την κύλιση",
"hc.storeFindWithQr": "Αποθηκεύστε & βρείτε με QR",
"hc.streetName": "Όνομα οδού",
"hc.streetNo": "Αριθμός οδού",
"hc.switchTo": "Αλλαγή σε",
"hc.switchToDarkMode": "Αλλαγή σε σκοτεινή λειτουργία",
"hc.switchToLightMode": "Αλλαγή σε φωτεινή λειτουργία",
"hc.takeAPhoto": "Βγάλτε μια φωτογραφία",
"hc.takeChangeThePhoto": "Βγάλτε / αλλάξτε τη φωτογραφία",
"hc.takenFromYourDeclaration": "λαμβάνεται από τη δήλωσή σας",
"hc.target": "Στόχος",
"hc.targetReached": "Ο στόχος επετεύχθη",
"hc.targetReachedThankYouTo": "Ο στόχος επετεύχθη — ευχαριστώ όλη την κοινότητα του Findloop!",
"hc.tellUsMore": "Πες μας περισσότερα…",
"hc.tellUsWhyYouCancel": "Πες μας γιατί ακυρώνεις. Αυτό βοηθά τον συνεργάτη να επεξεργαστεί το αίτημά σου.",
"hc.tellUsWhyYourListing": "Πες μας γιατί. Η καταχώριση σου παραμένει ενεργή και μπορείς ακόμα να διεκδικήσεις το αντικείμενό σου.",
"hc.termsAndConditions": "Όροι και προϋποθέσεις",
"hc.termsAndPolicies": "Όροι και πολιτικές",
"hc.thankYouForYourFeedback": "Ευχαριστούμε για την ανατροφοδότηση",
"hc.theBannerDisplayedInThe": "η διαφήμιση που εμφανίζεται στο μητρώο.",
"hc.theClaimantHasBeenInformed": "Ο αιτών έχει ενημερωθεί. Το αντικείμενο παραμένει διαθέσιμο στην δημόσια καταχώριση.",
"hc.theClaimantHasBeenNotified": "Ο αιτών έχει ειδοποιηθεί και μπορεί τώρα να προχωρήσει στην επιστροφή.",
"hc.theCustomerPaysTheFees": "Ο πελάτης πληρώνει τις χρεώσεις στο κατάστημα.",
"hc.theDayTheLegalRetention": "Η ημέρα που επιτυγχάνεται η νομική περίοδος διατήρησης.",
"hc.theEstablishmentConsideredThatThis": "Το κατάστημα θεώρησε ότι αυτό το αντικείμενο δεν είναι δικό σου.",
"hc.theEstablishmentIsReviewingYour": "Το κατάστημα εξετάζει τις απαντήσεις σου. Θα ειδοποιηθείς μόλις το αίτημά σου επιβεβαιωθεί, τότε μπορείς να πληρώσεις τις χρεώσεις αποκατάστασης.",
"hc.theFeesAreTooHigh": "Οι χρεώσεις είναι πολύ υψηλές",
"hc.theFinderConsideredThatThis": "Ο εντοπιστής θεώρησε ότι αυτό το αντικείμενο δεν είναι δικό σου.",
"hc.theFinderIsReviewingYour": "Ο εντοπιστής εξετάζει την αξίωσή σου. Θα ειδοποιηθείς μόλις επιβεβαιωθεί.",
"hc.theItem": "Το αντικείμενο",
"hc.theItemWillBeRemoved": "Το αντικείμενο θα αφαιρεθεί από το μητρώο (δεν υπάρχει σε εξέλιξη αξίωση).",
"hc.theItemWillBeSet": "Το αντικείμενο θα επαναρυθμιστεί σε \"διαθέσιμο\" και η σχετική αξίωση θα ακυρωθεί.",
"hc.theKbisNumberAndVat": "Ο αριθμός Kbis και ο αριθμός ΦΠΑ απαιτούνται για τη Γαλλία.",
"hc.theLabelIsGeneratedAutomatically": "Η ετικέτα δημιουργείται αυτόματα μόλις ο πελάτης πληρώσει τις χρεώσεις αποστολής. Θα είναι διαθέσιμη για λήψη εδώ.",
"hc.theLinkMayHaveExpired": "Ο σύνδεσμος μπορεί να έχει λήξει (έγκυρος για 30 ημέρες). Επικοινωνήστε με την υποστήριξη του Findloop αν χρειαστεί.",
"hc.theOwnerDescribesTheirItem": "Ο ιδιοκτήτης περιγράφει το αντικείμενό του",
"hc.theOwnerReceivedItBy": "Ο ιδιοκτήτης το έλαβε μέσω email (ή SMS). Εισάγετε ή σαρώστε το πριν την παράδοση.",
"hc.thePartnerConsideredThatThis": "Ο συνεργάτης θεώρησε ότι αυτό το αντικείμενο δεν είναι δικό σου. Το αντικείμενο παραμένει διαθέσιμο.",
"hc.thePartnerIsReviewingYour": "Ο συνεργάτης εξετάζει τις απαντήσεις σου. Θα ειδοποιηθείς μόλις το αίτημά σου επιβεβαιωθεί.",
"hc.theShipmentIsCreatedAutomatically": "Η αποστολή δημιουργείται αυτόματα μόλις ο πελάτης επιβεβαιώσει τη διεύθυνση του και πληρώσει τις χρεώσεις αποκατάστασης. Η ετικέτα θα δημιουργηθεί αυτόματα μετά την πληρωμή αποστολής και θα μπορεί να ληφθεί εδώ.",
"hc.theShippingRateWillBe": "Η χρέωση αποστολής θα υπολογιστεί αυτόματα μέσω του Sendcloud κατά την αποστολή (καταμετρημένο βάρος).",
"hc.thisCarrierWillBe": "Αυτός ο μεταφορέας θα είναι",
"hc.thisEstablishment": "αυτή η επιχείρηση",
"hc.thisFieldIsRequiredFor": "Αυτή η πεδία απαιτείται για τη δημιουργία αυτόματης ετικέτας.",
"hc.thisIsMyItem": "Αυτό είναι το αντικείμενό μου",
"hc.thisIsMyItemContinue": "Αυτό είναι το αντικείμενό μου — συνέχισε",
"hc.thisIsMyItemStart": "Αυτό είναι το αντικείμενό μου — ξεκίνα την επιστροφή",
"hc.thisIsNotMyItem": "Αυτό δεν είναι το αντικείμενό μου",
"hc.thisMatchIsNoLonger": "Αυτή η αντιστοίχιση δεν είναι πλέον διαθέσιμη ή έχει ήδη επεξεργαστεί.",
"hc.thisRateWillBeCharged": "Αυτή η χρέωση θα επιβληθεί στον πελάτη. Μία υψηλή χρέωση μπορεί να αποτρέψει την αποκατάσταση.",
"hc.thisStepIsRequiredFor": "Αυτή η διαδικασία απαιτείται για να παραχθούν ετικέτες αποστολής.",
"hc.thisValidationLinkIsInvalid": "Αυτός ο σύνδεσμος επιβεβαίωσης είναι μη έγκυρος ή έχει λήξει.",
"hc.toCheckBeforeMarkingThe": "Για να ελέγξετε πριν σημάνετε το αντικείμενο ως επιστραμμένο.",
"hc.toConfigureTheLinksAnd": "για να ρυθμίσετε τους συνδέσμους και την καθυστέρηση υπενθύμισης για κάθε κατάστημα.",
"hc.toReachOurFirstMilestone": "για να φτάσουμε στο πρώτο μας ορόσημο των 100 επιστροφών.",
"hc.toTheCustomer": "στον πελάτη.",
"hc.toTheShippingFeePayment": "στην πληρωμή των εξόδων αποστολής.",
"hc.toYourRecoveryTracking": "στην παρακολούθηση της αποκατάστασής σας.",
"hc.tooExpensiveBudget": "Πολύ ακριβό / προϋπολογισμός",
"hc.topCitiesForReturns": "Κορυφαίοι προορισμοί για επιστροφές",
"hc.trackMyRecovery": "Παρακολούθηση της αποκατάστασής μου",
"hc.trackTheShipmentAndDownload": "Παρακολουθήστε την αποστολή και κατεβάστε την ετικέτα (δημιουργείται αυτόματα) χωρίς να αποχωρήσετε από την καρτέλα Δηλώσεις.",
"hc.trackYourStatistics": "Παρακολουθήστε τα στατιστικά σας",
"hc.tracking": "Παρακολούθηση",
"hc.unableToOpenTheShipping": "Αδυναμία ανοίγματος της πληρωμής αποστολής. Δοκιμάστε ξανά.",
"hc.unableToRetrieveTheInvoice": "Αδυναμία ανάκτησης του τιμολογίου.",
"hc.unclaimed": "Αναζητούμενο",
"hc.unclaimedCustomerReason": "Αναζητούμενο αντικείμενο. Λόγος του πελάτη: \"{reason}\".",
"hc.unclaimedItem": "Αναζητούμενο αντικείμενο",
"hc.unclaimedItemNoClaimWithin": "Αναζητούμενο αντικείμενο — καμία αίτηση εντός της προθεσμίας.",
"hc.unclaimedItems": "Αναζητούμενα αντικείμενα",
"hc.unclaimedItemsMatchLeftWithout": "Αναζητούμενα αντικείμενα: ταίριαξε αριστερά χωρίς αίτηση εντός της προθεσμίας. Μπορείτε να τα επιστρέψετε στη αποθήκευση.",
"hc.unlockTheFinderSContact": "Ξεκλειδώστε τα στοιχεία επικοινωνίας του ευρέτη για να κανονίσετε την παράδοση.",
"hc.upcoming": "Επερχόμενα",
"hc.updateFailed": "Η ενημέρωση απέτυχε.",
"hc.usedForInvoices": "Χρησιμοποιείται για την έκδοση των τιμολογίων σας από την findloop.",
"hc.vatNumber": "Αριθμός ΦΠΑ",
"hc.verificationPending": "Επιβεβαίωση σε εκκρεμότητα",
"hc.verificationSentToTheFinder": "Επιβεβαίωση αποστάληκε στον ευρέτη. Θα ενημερωθείτε για την απόφασή τους.",
"hc.verificationSentToThePartner": "Επιβεβαίωση αποστάληκε στον συνεργάτη. Θα ενημερωθείτε για την απόφασή τους.",
"hc.verify": "Επιβεβαίωση",
"hc.verifyingInvite": "Επιβεβαίωση του συνδέσμου πρόσκλησης…",
"hc.verifyingTheLink": "Επιβεβαίωση του συνδέσμου…",
"hc.viewInRegistry": "Προβολή στο μητρώο",
"hc.viewItem": "Προβολή αντικειμένου",
"hc.viewItemRecover": "Προβολή αντικειμένου & αποκατάσταση",
"hc.visibleToTheOwnerAutomatically": "Ορατό στον ιδιοκτήτη · αυτόματα διαγράφεται μετά από 60 ημέρες.",
"hc.waitingForPartnerConfirmation": "Αναμονή για επιβεβαίωση συνεργάτη",
"hc.waitingForThePartnerS": "Αναμονή για την επιβεβαίωση του συνεργάτη",
"hc.weHaveInformedTheEstablishment": "Έχουμε ενημερώσει το κατάστημα ότι αυτό το αντικείμενο δεν είναι δικό σας και επανεκκινήσαμε την ανάλυση. Θα ενημερωθείτε μόλις βρεθεί ένας νέος συσχετισμός.",
"hc.weHaveInformedThePartner": "Έχουμε ενημερώσει τον συνεργάτη ότι αυτό το αντικείμενο δεν είναι δικό σας. Η καταχώρισή σας παραμένει ενεργή για μελλοντικές αντιστοιχίες.",
"hc.weRanTheAnalysisAgain": "Δημιουργήσαμε ξανά την ανάλυση και εντοπίσαμε ένα άλλο αντικείμενο που θα μπορούσε να είναι δικό σας. Παρακαλώ ελέγξτε το ξανά.",
"hc.weight": "Βάρος",
"hc.weightNotProvidedTheShipping": "Το βάρος δεν παρέχεται: η χρέωση αποστολής θα υπολογιστεί κατά τη στιγμή της αποστολής.",
"hc.weightUnit": "Μονάδα βάρους",
"hc.welcome": "Καλώς ήρθατε!",
"hc.welcomeToFindo": "Καλώς ήρθατε στο Findloop",
"hc.whenACustomerComesTo": "Όταν ένας πελάτης έρχεται να παραλάβει τα αντικείμενά του, ανοίξτε τη δήλωσή τους και επιβεβαιώστε την επιστροφή. Αυτό είναι!",
"hc.whenDisabledFeesDropTo": ". Όταν είναι απενεργοποιημένο, οι χρεώσεις μειώνονται σε",
"hc.whyIsThisNotYour": "Γιατί δεν είναι αυτό το αντικείμενό σας;",
"hc.willBeMarkedAs": "θα σημειωθεί ως",
"hc.wrongColor": "Λάθος χρώμα",
"hc.wrongModel": "Λάθος μοντέλο",
"hc.yesCancel": "Ναι, ακυρώστε",
"hc.yesContactTheFinder": "Ναι, επικοινωνήστε με τον ανιχνευτή",
"hc.youAreHere": "Είστε εδώ",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Μπορείτε τώρα να ξεκινήσετε την επιστροφή.",
"hc.youCanStillChangeIt": ". Μπορείτε ακόμα να το αλλάξετε κατά περίπτωση.",
"hc.youHaveAlreadyConfirmedThat": "Έχετε ήδη επιβεβαιώσει ότι αυτό είναι το αντικείμενό σας.",
"hc.youWillBeRedirectedTo": "Θα ανακατευθυνθείτε στην ασφαλή πληρωμή Stripe.",
"hc.yourAccountHasBeenReactivated": "Ο λογαριασμός σας έχει ξαναενεργοποιηθεί.",
"hc.yourAccountIsActiveYou": "Ο λογαριασμός σας είναι ενεργός, μπορείτε τώρα να διαχειριστείτε τα καταστήματά σας.",
"hc.yourEstablishment": "Το κατάστημά σας",
"hc.yourFeedbackHelpsUsImprove": "Η ανατροφοδότησή σας μας βοηθά να βελτιώσουμε τις αντιστοιχίες μας.",
"hc.yourFeedbackHelpsUsRestart": "Η ανατροφοδότησή σας μας βοηθά να ξαναρχίσουμε την ανάλυση και να βελτιώσουμε τις αντιστοιχίες μας.",
"hc.yourFirstSteps": "Τα πρώτα σας βήματα",
"hc.yourFirstStepsAdmin": "Τα πρώτα σας βήματα (διαχείριση)",
"hc.yourItemHasBeenHanded": "Το αντικείμενό σας έχει παραδοθεί προσωπικά από τον συνεργάτη — κλείστε την υπόθεση μόλις επιβεβαιωθεί η παράδοση.",
"hc.yourItemHasBeenShipped": "Το αντικείμενό σας έχει αποσταλεί από τον συνεργάτη — κλείστε την υπόθεση μόλις επιβεβαιωθεί η παράδοση.",
"hc.yourPaymentHasBeenRecorded": "Η πληρωμή σας έχει καταχωρηθεί.",
"hc.yourShipmentIsBeingPrepared": "Η αποστολή σας ετοιμάζεται. Θα παραλάβετε το δέμα σας εντός 3 έως 5 εργάσιμων ημερών.",
"hc.yourShippingFeesHaveAlready": "Οι χρεώσεις αποστολής σας έχουν ήδη πληρωθεί. Αποστολή πληρωμένη ✓",
"hc.yourShippingFeesHaveBeen": "Οι χρεώσεις αποστολής σας έχουν πληρωθεί. Το δέμα σας ετοιμάζεται.",
"hc.yourVerificationQuestionsDeposit": "Οι ερωτήσεις επαλήθευσης σας (κατάθεση)",
"hero.einvoiceBadge": "Συμβατό ηλεκτρονικό τιμολόγιο 2027",
"home.recentAdsAll": "Δείτε όλες τις καταχωρίσεις",
"home.recentAdsEyebrow": "Αυτή τη στιγμή",
"home.recentAdsSubtitle": "Αναφερόμενα αντικείμενα που χάθηκαν και βρέθηκαν από την κοινότητα.",
"home.recentAdsTitle": "Τελευταίες καταχωρίσεις",
"home.reunions": "Πρόσφατες επανασυνδέσεις",
"home.videoEyebrow": "Παρακολούθησε",
"home.videoSubtitle": "Πώς επαναφέρουμε τα χαμένα αντικείμενα στους ιδιοκτήτες τους, χωρίς καμία προσπάθεια.",
"home.videoTitle": "Ανακάλυψε το Findloop σε 2 λεπτά",
"home.watchYoutube": "Παρακολούθησε στο YouTube",
"impact.already": "Ήδη",
"impact.citiesWord": "πόλη/πόλεις",
"impact.eachPoint": "Κάθε τελεία είναι μια πόλη όπου το Findloop βοηθά στην αποκατάσταση χαμένων αντικειμένων.",
"impact.emptyMap": "Ο χάρτης γεμίζει καθώς οι αποκαταστάσεις συμβαδίζουν.",
"impact.eyebrow": "Η επιρροή μας",
"impact.inCities": "σε όλη την",
"impact.restitutedTo": "αντικείμενα που επιστράφηκαν στους ιδιοκτήτες τους",
"impact.title": "Αντικείμενα που επιστρέφονται, παντού κοντά σου",
"inv2.download": "Λήψη",
"inv2.view": "Προβολή",
"map.objectsOnMapPlural": "αντικείμενα στον χάρτη",
"map.objectsOnMapSingular": "αντικείμενο στον χάρτη",
"mc.claimConfirmDesc": "Έλεγξε το αντικείμενο που βρέθηκε από τον ανιχνευτή πριν πληρώσεις για να ξεκλειδώσεις τα στοιχεία επικοινωνίας του.",
"mc.claimConfirmNo": "Αυτό δεν είναι το αντικείμενό μου",
"mc.claimConfirmTitle": "Είναι πραγματικά το αντικείμενό σου;",
"mc.claimConfirmYes": "Ναι, είναι δικό μου — πληρώστε",
"mc.claimFinderContacts": "Στοιχεία επικοινωνίας ανιχνευτή",
"mc.claimNotMineDone": "Ευχαριστώ — ο ανιχνευτής έχει ειδοποιηθεί και το αίτημά σου αφαιρέθηκε από την αγγελία.",
"mc.claimUnlockDesc": "Πλήρωσε τη χρέωση διαχείρισης του Findloop για να λάβεις τα στοιχεία επικοινωνίας του ατόμου που βρήκε το αντικείμενό σου.",
"mc.claimUnlockTitle": "Ξεκλείδωσε τα στοιχεία επικοινωνίας του ανιχνευτή",
"mc.hideCountryOffers": "Κρύψε τις προσφορές στη χώρα μου",
"mc.myClaims": "Αντικείμενα που διεκδικώ",
"mc.myClaimsSub": "Αντικείμενα που βρέθηκαν από άλλους και διεκδικείς. Ξεκλείδωσε τα στοιχεία επικοινωνίας του ανιχνευτή για να οργανώσεις την παράδοση.",
"mc.notifAdCancelled": "Η αγγελία ακυρώθηκε",
"mc.notifCancelAd": "Ακύρωσε την αγγελία μου",
"mc.offersInCountry": "Προσφορές στη χώρα μου",
"mc.offersInCountryDesc": "Όλες οι ενεργές ανταμοιβές από συνεργάτες στη χώρα σου, κατά πόλη.",
"mc.redArchived": "Αρχειοθετημένο",
"mc.rewardsCountryNone": "Δεν υπάρχει προσφορά στη χώρα σου ακόμη.",
"mc.rewardsForYou": "Ανταμοιβές για σένα",
"mc.rewardsForYouDesc": "Προσφορά από τους συνεργάτες όπου άφησες ένα αντικείμενο.",
"mc.rewardsMineNone": "Δεν υπάρχει ανταμοιβή από τους συνεργάτες σου ακόμη.",
"mc.showCountryOffers": "Δες προσφορές στη χώρα μου",
"mc2.cancelDecl": "Ακύρωσε την δήλωσή μου",
"mc2.cancelDeclDone": "Δήλωση ακυρώθηκε.",
"pricing.physInvDesc": "Όταν επιστρέφεται ένα αντικείμενο, η τοποθεσία του απελευθερώνεται αυτόματα και είναι διαθέσιμη για ένα νέο αντικείμενο.",
"pricing.physInvTitle": "Παρακολούθηση φυσικού αποθέματος",
"pricing.physModalTitle": "Διαχείριση φυσικών αντικειμένων",
"pricing.physQrDesc": "Ένας μοναδικός QR κωδικός δημιουργείται ανά αντικείμενο και συνδέεται με όλες τις πληροφορίες του.",
"pricing.physQrTitle": "Αφίσα QR",
"pricing.physShelfDesc": "Κάθε καταγεγραμμένο αντικείμενο μπορεί να ανατεθεί σε μια φυσική τοποθεσία εντός του καταστήματος.",
"pricing.physShelfTitle": "Σχέδιο ραφιών",
"pricing.physicalMgmt": "Διαχείριση φυσικών αντικειμένων (ραφιά, QR, απόθεμα)",
"pub.addSecondPhoto": "Προσθήκη 2ης φωτογραφίας (προαιρετική)",
"pub.photo2Added": "✓ 2η φωτογραφία προστέθηκε",
"reg.dispositionJournal": "Ημερολόγιο διάθεσης",
"reg.dispositionNoteAuthHint": "ℹ️ Απαιτείται σημείωση για “Παραδόθηκε στις αρχές” (αριθμός αναφοράς, τμήμα…).",
"reg.dispositionNotePh": "Σημείωση (προαιρετική): φιλανθρωπική οργάνωση παραλήπτη, αναφορά αρχών, όνομα αγοραστή…",
"reg.dispositionNoteRequired": "Απαιτείται επίσημη αναφορά για να παραδοθεί στις αρχές.",
"reg.legalPrealert": "Νομική προθεσμία σε {days} ημέρες",
"reg.legalPrealertOptions": "Επιλογές στην προθεσμία: πώληση δημοπρασίας, δωρεά σε φιλανθρωπία, παράδοση στις αρχές.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Πλήρης ανασκόπηση",
"rev.readMore": "Διαβάστε περισσότερα",
"rw.activeCodes": "Ενεργά κουπόνια",
"rw.archived": "Αρχειοθετημένα",
"rw.archivedTitle": "Αξιοποιημένα κουπόνια (αρχειοθετημένα)",
"rw.hideArchived": "Απόκρυψη αξιοποιημένων κουπονιών",
"rw.noArchived": "Δεν υπάρχουν αρχειοθετημένα κουπόνια.",
"rw.showArchived": "Εμφάνιση αξιοποιημένων κουπονιών",
"shp.labelAuto": "Η ετικέτα δημιουργείται αυτόματα μόλις ο πελάτης πληρώσει τα έξοδα αποστολής. Θα είναι διαθέσιμη προς λήψη εδώ.",
"st.cancelled_by_customer": "Ακυρώθηκε",
"stt.dispoPdfBtn": "Εξαγωγή PDF",
"stt.dispoPdfError": "Αποτυχία εξαγωγής PDF.",
"stt.dispoPdfExporting": "Εξάγεται…",
"trk.matchVerifying": "Ενδεχόμενη αντιστοίχιση υπό επαλήθευση",
"a.firstName": "Όνομα",
"ac.emailCrossMatch": "Διασταυρώσεις B2C",
"ac.emailCrossMatchDesc": "Ένα email όταν μια δημόσια αγγελία χαμένου αντικειμένου ταιριάζει με ένα αντικείμενο που έχει κατατεθεί στις εγκαταστάσεις σας",
"ac.emailCrossReject": "Απορρίψεις δημόσιων ταιριάσματος",
"ac.emailCrossRejectDesc": "Λάβετε ένα email όταν ένας πελάτης δηλώνει ότι μια προτεινόμενη δημόσια αντιστοιχία δεν είναι το αντικείμενό του.",
"ac.emailLoginNotif": "Ειδοποίηση σύνδεσης",
"ac.emailLoginNotifDesc": "Λάβετε ένα email κάθε φορά που κάποιος συνδέεται στον λογαριασμό σας.",
"ad.closeNoCancel": "Όχι, αφαίρεσε την καταχώρηση",
"ad.closeQuestion": "Επιστράφηκε το αντικείμενο σε εσάς;",
"ad.closeQuestionDesc": "Πείτε μας αν ανακτήσατε το αντικείμενό σας, ή αν απλά θέλετε να αφαιρέσετε αυτή την καταχώρηση.",
"ad.closeYesRestituted": "Ναι, το αντικείμενο επιστράφηκε",
"ad.closedRestituted": "Αντικείμενο επιστραμμένο — καταχώρηση κλειστή 🎉",
"an.lostLoginDesc": "Απαιτείται λογαριασμός για να αναφέρετε ένα χαμένο αντικείμενο και να παρακολουθήσετε την επιστροφή του.",
"an.lostLoginRequired": "Συνδεθείτε για να αναφέρετε ένα χαμένο αντικείμενο",
"an.qfAll": "Όλα",
"an.qfBoosted": "Αναβαθμισμένα",
"an.qfPhoto": "Με φωτογραφία",
"an.qfRecent": "Αυτή την εβδομάδα",
"an.qfResolved": "Επιλύθηκε",
"an.restitutionInProgress": "Αντικείμενο σε επιστροφή",
"dec.descPhLong": "Περιγράψτε το αντικείμενο: μάρκα, χρώμα, διακριτικά σημάδια… (Όσο περισσότερες λεπτομέρειες δώσετε, τόσο μεγαλύτερες είναι οι πιθανότητες να επιστραφεί το αντικείμενό σας)",
"dec.loadError": "Δεν είναι δυνατή η φόρτωση του συνεργάτη αυτή τη στιγμή. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.",
"dec.retry": "Δοκιμάστε ξανά",
"dec.shippingMode": "Αποστολή",
"dep.photo2": "Φωτογραφία 2ου αντικειμένου",
"dep.photo2Hint": "Προαιρετικό — άλλη γωνία βελτιώνει την ακρίβεια οπτικής αντιστοίχισης.",
"dl.accountSuspended": "Ο λογαριασμός είναι ανασταλμένος λόγω απλήρωτης τιμής. Ρυθμίστε την για να αποκαταστήσετε την πρόσβαση σας.",
"dl.regularize": "Ρυθμίστε τώρα →",
"dl.suspensionCountdown": "Τιμολόγιο {num} απλήρωτο — ο λογαριασμός σας θα ανασταλεί σε {days} ημέρα(ες). Ρυθμίστε το για να αποφύγετε αυτό.",
"ft.cancelConfirm": "Θέλετε να ακυρώσετε την αναφορά σας; Ο κάτοχος του αντικειμένου θα ειδοποιηθεί.",
"ft.cancelDone": "Η αναφορά ακυρώθηκε.",
"ft.cancelLocked": "Η ακύρωση δεν είναι πλέον δυνατή μετά την πληρωμή από τον κάτοχο.",
"ft.cancelReport": "Ακυρώστε την αναφορά μου",
"ft.claimCodeHelp": "Δώστε αυτόν τον κωδικό στον εύρετη κατά την παράδοση για να επιβεβαιώσετε ότι λάβατε το αντικείμενό σας.",
"ft.claimCodeTitle": "Ο κωδικός αποκατάστασής σας",
"ft.claimDone": "Αντικείμενο επιστραμμένο. Ευχαριστούμε που χρησιμοποιείτε το Findloop!",
"ft.claimUnlockHint": "Ξεκλειδώστε τα στοιχεία επικοινωνίας του εύρετη",
"ft.claimUnlockHintSub": "Πηγαίνετε στο \"Αντικείμενα που απαιτώ\" στον λογαριασμό σας για να πληρώσετε τη χρέωση και να αποκτήσετε τα στοιχεία επικοινωνίας.",
"ft.finderCodeShownHelp": "Ο κάτοχος έχει πληρώσει και σας έχει επιλέξει. Αντιγράψτε αυτόν τον κωδικό παρακάτω για να επιβεβαιώσετε την επιστροφή — δεν χρειάζεται να ελέγξετε το email σας.",
"ft.finderCodeShownTitle": "Κωδικός επιβεβαίωσης κατόχου",
"ft.finderContactsTitle": "Στοιχεία επικοινωνίας του Finder",
"ft.foundCodeHelp": "Δείξτε αυτόν τον κωδικό στον κάτοχο κατά την παράδοση για να επιβεβαιωθεί ότι το αντικείμενο επιστράφηκε.",
"ft.inProgressOther": "Αντικείμενο που επιστρέφεται",
"ft.inProgressOtherHelp": "Ο κάτοχος έχει επιλέξει άλλο finder για αυτό το αντικείμενο. Δεν απαιτείται περαιτέρω ενέργεια από εσάς.",
"ft.restitutionCodeHelp": "Αυτός ο κωδικός επιβεβαιώνει την παράδοση του αντικειμένου. Είναι ήδη προγεμισμένος παρακάτω; Επιβεβαιώστε τον και στη συνέχεια κλείστε την υπόθεση.",
"ft.restitutionCodeTitle": "Ο κωδικός επιστροφής σας",
"hc.14Digits": "14 ψηφία",
"hc.15DaysBeforeAnItem": "15 ημέρες πριν από την νομική προθεσμία ενός αντικειμένου.",
"hc.7DaysBeforeAnItem": "7 ημέρες πριν από την νομική προθεσμία ενός αντικειμένου.",
"hc.8CharactersMinimum": "8 χαρακτήρες τουλάχιστον.",
"hc.aClaimToValidate": "Μια αξίωση προς επιβεβαίωση",
"hc.aFindoAssistanceSessionIs": "Μια συνεδρία βοήθειας Findloop είναι αυτή τη στιγμή ενεργή στον λογαριασμό σας.",
"hc.aNewMatchHasBeen": "Η νέα αντιστοίχιση έχει βρεθεί",
"hc.aUser": "Ένας χρήστης",
"hc.aUserClaimsToBe": "Ένας χρήστης ισχυρίζεται ότι είναι ο κάτοχος. Ελέγξτε τις απαντήσεις τους πριν εξουσιοδοτήσετε την επιστροφή.",
"hc.aboutFindo": "Σχετικά με το Findloop",
"hc.accountActivatedPleaseLogIn": "Ο λογαριασμός ενεργοποιήθηκε, παρακαλώ συνδεθείτε.",
"hc.accountActivation": "Ενεργοποίηση λογαριασμού",
"hc.accountCreated": "Ο λογαριασμός δημιουργήθηκε!",
"hc.accountDeactivatedAReactivationEmail": "Ο λογαριασμός απενεργοποιήθηκε. Ένα email επανενεργοποίησης (έγκυρο για 30 ημέρες) έχει σταλεί σε εσάς.",
"hc.accountReactivation": "Επανενεργοποίηση λογαριασμού",
"hc.activateMyAccount": "Ενεργοποιήστε τον λογαριασμό μου",
"hc.activateMyAdminAccount": "Ενεργοποιήστε τον διαχειριστικό μου λογαριασμό",
"hc.activating": "Ενεργοποίηση…",
"hc.activeMatchCancelReason": "Ενεργή αντιστοίχιση. Λόγος ακύρωσης πελάτη: \"{reason}\". Το αντικείμενο αναμένει ακόμη αξίωση.",
"hc.activeMatchWithAPublic": "Ενεργή αντιστοίχιση με δημόσια (πελάτη) καταχώριση. Περιμένει την αξίωση του κατόχου.",
"hc.addAPhoto": "Προσθέστε μια φωτογραφία",
"hc.addAndConfigureYourEstablishments": "Προσθέστε και ρυθμίστε τις εγκαταστάσεις σας στην \"Εγκαταστάσεις\": στοιχεία επικοινωνίας, κατηγορία και φυσική αποθήκευση αντικειμένων.",
"hc.addOnGoogle": "Προσθήκη στο Google",
"hc.address": "Διεύθυνση",
"hc.addressSaved": "Διεύθυνση αποθηκευμένη",
"hc.addressStreet": "Διεύθυνση — Οδός",
"hc.adjustThePhoto": "Ρυθμίστε τη φωτογραφία",
"hc.adminFullView": "Διαχειριστής (πλήρης θέα)",
"hc.administratorOnly": "Μόνο για διαχειριστές",
"hc.africa": "Αφρική",
"hc.aiVisualComparison": "AI οπτική σύγκριση",
"hc.all": "Όλα",
"hc.amount": "Ποσό",
"hc.anOrganization": "Μια οργάνωση",
"pcat.stadium_arena": "Γήπεδο / Αρένα",
"pcat.supermarket": "Σούπερ Μάρκετ",
"pcat.taxi_vtc": "Ταξί / Εφαρμογές μεταφοράς",
"pcat.tourism_office": "Γραφείο Τουρισμού",
"pcat.train_bus_station": "Σταθμός Τρένων / Λεωφορείων",
"pcat.travel_agency": "Ταξιδιωτικό Γραφείο",
"hc.and": "και",
"hc.demoObj0": "ένα πορτοφόλι",
"hc.demoObj1": "μία αθλητική τσάντα",
"hc.demoObj2": "ένα τηλέφωνο",
"hc.demoObj3": "ένα ζευγάρι γυαλιών",
"hc.demoObj4": "μία σειρά κλειδιών",
"hc.demoObj5": "ένα κασκόλ",
"hc.demoObj6": "ένα λάπτοπ",
"hc.demoObj7": "μία φιάλη νερού",
"hc.demoWhen0": "πριν 2 ώρες",
"hc.demoWhen1": "πριν 5 ώρες",
"hc.demoWhen2": "χθες",
"hc.demoWhen3": "πριν 3 ώρες",
"hc.demoWhen4": "το πρωί",
"hc.demoWhen5": "πριν 1 ημέρα",
"hc.feedDemo": "{obj} επιστράφηκε στην {city} {when}.",
"hc.feedReal": "Ένα αντικείμενο ({cat}) επιστράφηκε στην {city}.",
"hc.saveBtn": "Αποθήκευση",
"hc.saveLink": "Αποθήκευση συνδέσμου",
"hc.terms": "Όροι",
"hc.view": "Προβολή",
"pcat.airline": "Αεροπορική εταιρεία",
"pcat.airport": "Αεροδρόμιο",
"pcat.amusement_park": "Θεματικό πάρκο",
"pcat.bank": "Τράπεζα",
"pcat.bar_cafe": "Μπαρ / Καφετέρια",
"pcat.beauty_salon": "Κομμωτήριο / Σαλόνι ομορφιάς",
"pcat.cinema": "Κινηματογράφος",
"pcat.concert_theater": "Συναυλιακή αίθουσα / Θέατρο",
"pcat.coworking": "Χώρος συνεργασίας",
"pcat.gym_fitness": "Γυμναστήριο / Fitness",
"pcat.hospital_clinic": "Νοσοκομείο / Κλινική",
"pcat.library": "Βιβλιοθήκη",
"pcat.mall": "Εμπορικό κέντρο",
"pcat.museum": "Μουσείο",
"pcat.pharmacy": "Φαρμακείο",
"pcat.private_company": "Ιδιωτική εταιρεία",
"pcat.public_transport": "Δημόσιες μεταφορές",
"pcat.school_university": "Σχολείο / Πανεπιστήμιο",
"pcat.sports_center": "Αθλητικό κέντρο",
"an.found": "Βρέθηκε",
"an.lost": "Χαμένο",
"hc.shareReview": "Μοιραστείτε την κριτική",
"hc.citiesAboveTarget": "{n} πόλεις πάνω από τον στόχο τους",
"hc.cityAboveTarget": "{n} πόλη πάνω από τον στόχο της",
"hc.j15EarlyReminder": "D-15 πρώιμη υπενθύμιση",
"hc.j7EarlyReminder": "D-7 πρώιμη υπενθύμιση",
"hc.annualTotal": "Ετήσιο σύνολο",
"hc.billedOnceYear": "Χρεώνεται μία φορά για 12 μήνες, ανανεώνεται κάθε χρόνο.",
"hc.monthlyPrice": "Μηνιαία τιμή",
"hc.perMonth": "/ μήνα",
"hc.perYear": "/ χρόνο",
"hc.billedEachMonth": "Χρεώνεται αυτόματα κάθε μήνα.",
"nav.business": "Επιχείρηση",
"nav.individual": "Ατομικό",
"hc.circumstancesFound": "Συνθήκες του ευρήματος",
"hc.circumstancesFoundPh": "Π.χ. βρέθηκε στο έδαφος κοντά στην είσοδο του μετρό",
"hc.circumstancesLost": "Συνθήκες της απώλειας",
"hc.circumstancesLostPh": "Π.χ. άφησα σε έναν πάγκο ενώ περίμενα το λεωφορείο",
"hc.conditionPh": "Π.χ. καλή, γρατσουνισμένη…",
"hc.firstName": "Όνομα",
"hc.lastName": "Επώνυμο",
"hc.quantity": "Αριθμός αντικειμένων",
"fa.ownerContact": "Στοιχεία επαφής του ιδιοκτήτη",
"fa.payPublish": "Πληρώστε και δημοσιεύστε",
"fa.pendingPayText": "Η καταχώρισή σας θα είναι ζωντανή μόλις επιβεβαιωθεί η πληρωμή.",
"fa.pendingPayTitle": "Πληρωμή σε εκκρεμότητα",
"fa.planSub": "Η καταχώρισή σας θα είναι ζωντανή μόλις επιβεβαιωθεί η πληρωμή.",
"fa.planTitle": "Διάρκεια καταχώρισης",
"fa.pubSuccessMsg": "Η καταχώρισή σας είναι ζωντανή. Θα ειδοποιηθείτε μόλις εμφανιστεί ένας ανιχνευτής.",
"fa.pubSuccessTitle": "Καταχώριση δημοσιευμένη",
"fa.publicNote": "Μόνο η περιγραφή, η πόλη, η χώρα και οι φωτογραφίες εμφανίζονται δημόσια.",
"fa.redirectStripe": "Ανακατεύθυνση σε ασφαλή πληρωμή…",
"fa.reject": "Απόρριψη",
"fa.rejectConfirm": "Να απορρίψω αυτή τη δήλωση; Η καταχώρισή σας παραμένει online.",
"fa.rejected": "Δήλωση απορριφθείσα",
"fa.rejectedFinder": "Δεν ήταν το αντικείμενο που έψαχναν",
"fa.rejectedFinderText": "Ο ιδιοκτήτης λέει ότι αυτό το αντικείμενο δεν είναι δικό του. Ευχαριστούμε για τη βοήθειά σας!",
"fa.responsesTitle": "Δηλώσεις ανιχνευτών",
"fa.sent": "Δήλωση αποσταλεί στον ιδιοκτήτη.",
"fa.submitDecl": "Στείλτε τη δήλωσή μου",
"fa.submitDeclPay": "Στείλτε και συμβάλετε {amount}",
"fa.total": "Σύνολο προς πληρωμή",
"fa.ttc": "συμπ. ΦΠΑ",
"fa.waitClaimText": "Ο ανιχνευτής εξετάζει το αίτημά σας. Θα ειδοποιηθείτε για την απόφασή του.",
"fa.waitFinderText": "Θα σας ενημερώσουμε μόλις υποβληθεί μια δήλωση από ανιχνευτή.",
"fa.waitFinderTitle": "Η καταχώρισή σας είναι ζωντανή",
"fa.waitOwnerText": "Ο ιδιοκτήτης συγκρίνει τη δήλωσή σας με τη δική του. Θα ειδοποιηθείτε για την απόφασή του.",
"fa.waitOwnerTitle": "Αναμονή για την απόφαση του ιδιοκτήτη",
"st.pending_payment": "Πληρωμή σε εκκρεμότητα",
"fa.approve": "Εγκρίνω",
"fa.approveConfirm": "Να εγκρίνω αυτή τη δήλωση; Τα πλήρη στοιχεία επικοινωνίας σας (όνομα, email, τηλέφωνο) θα ανταλλαγούν με τον ανιχνευτή.",
"fa.approved": "Δήλωση εγκεκριμένη — αντηλλάγησαν τα στοιχεία επικοινωνίας",
"fa.approvedFinder": "Ο ιδιοκτήτης ενέκρινε τη δήλωσή σας",
"fa.approvedFinderText": "Επικοινωνήστε μαζί τους για να κανονίσετε την επιστροφή.",
"fa.boostSub": "Η καταχώρισή σας παραμένει στην κορυφή για την επιλεγμένη διάρκεια.",
"fa.boostTitle": "Αυξήστε την καταχώρισή μου (προαιρετικό)",
"fa.colFinder": "Δήλωση ανιχνευτή",
"fa.colYours": "Η δήλωσή σας",
"fa.compareHint": "Συγκρίνετε τη δήλωση του ανιχνευτή με τη δική σας πριν αποφασίσετε.",
"fa.contribNone": "Καμία συνεισφορά",
"fa.contribPaid": "Λαβή συνεισφοράς — σας ευχαριστούμε!",
"fa.contribPending": "Συνεισφορά υπό αναμονή πληρωμής",
"fa.contribSub": "Υποστηρίξτε το Findloop για να βοηθήσετε περισσότερους ανθρώπους να επιστρέψουν τα αντικείμενά τους. Μπορείτε να επιλέξετε €0.",
"fa.contribSuccessMsg": "Η δήλωσή σας έχει σταλεί στον ιδιοκτήτη.",
"fa.contribSuccessTitle": "Σας ευχαριστούμε για τη συνεισφορά σας",
"fa.contribTitle": "Εθελοντική συνεισφορά",
"fa.days3": "3 ημέρες",
"fa.days30": "30 ημέρες",
"fa.days7": "7 ημέρες",
"fa.declSub": "Περιγράψτε το αντικείμενο που βρήκατε. Ο ιδιοκτήτης θα συγκρίνει τη δήλωσή σας με τη δική του.",
"fa.declTitle": "Βρήκα αυτό το αντικείμενο",
"fa.expiresOn": "Λήγει στις",
"fa.fBrand": "Μάρκα",
"fa.fCircumstances": "Συνθήκες",
"fa.fCity": "Πόλη",
"fa.fColor": "Χρώμα",
"fa.fCondition": "Κατάσταση",
"fa.fDate": "Ημερομηνία",
"fa.fMessage": "Μήνυμα ανιχνευτή",
"fa.fPlace": "Τόπος",
"fa.fQuantity": "Ποσότητα",
"fa.finderContact": "Στοιχεία επικοινωνίας ανιχνευτή",
"fa.finishPay": "Ολοκλήρωση πληρωμής",
"fa.foundDate": "Ημερομηνία εύρεσης",
"fa.foundPlace": "Τόπος εύρεσης",
"fa.hours24": "24 ώρες",
"fa.ht": "χωρίς ΦΠΑ",
"fa.months3": "3 μήνες",
"fa.noBoost": "Χωρίς αύξηση",
"fa.africaFree": "Δωρεάν καταχώριση στην Αφρική — προσφορά εκκίνησης της Findloop, απολαύστε την!",
"fa.africaPublished": "Καταχώριση δημοσιευμένη δωρεάν — προσφορά εκκίνησης στην Αφρική!",
"fa.approveClaimConfirm": "Επιβεβαιώνετε αυτή την αξίωση; Ο ιδιοκτήτης θα μπορεί να ξεκλειδώσει τα στοιχεία επικοινωνίας σας.",
"fa.checkInfo": "Ελέγξτε τα στοιχεία σας πριν στείλετε: θα συγκριθούν με αυτά του βρίσκοντος.",
"fa.claimApprovedShort": "Ο βρίσκων ενέκρινε την αξίωσή σας",
"fa.claimRejectedShort": "Η αξίωση απορρίφθηκε από τον βρίσκοντα",
"fa.claimRejectedText": "Ο βρίσκων πιστεύει ότι αυτό το αντικείμενο δεν είναι δικό σας.",
"fa.claimSub": "Περιγράψτε το αντικείμενό σας και προσθέστε 2 φωτογραφίες. Ο βρίσκων θα τις συγκρίνει με την καταχώρισή του.",
"fa.claimTitle": "Αυτό είναι το αντικείμενό μου",
"fa.claimUnlockText": "Ξεκλειδώστε τα στοιχεία επικοινωνίας του βρίσκοντα για να οργανώσετε την επιστροφή.",
"fa.claimUnlockedShort": "Τα στοιχεία επικοινωνίας ξεκλειδώθηκαν — δείτε την παρακολούθηση",
"fa.claimsTitle": "Αξιώσεις ιδιοκτήτη",
"fa.colOwner": "Δήλωση ιδιοκτήτη",
"fa.colYourAd": "Η καταχώρισή σας",
"fa.expired": "Η καταχώριση έχει λήξει",
"fa.free": "Δωρεάν",
"fa.lostDate": "Ημερομηνία απώλειας",
"fa.lostPlace": "Τόπος απώλειας",
"fa.noReceipt": "Δεν υπάρχει διαθέσιμη απόδειξη για αυτή την καταχώριση.",
"fa.planSubFree": "Επιλέξτε τη διάρκεια: η καταχώρισή σας αρχίζει αμέσως, χωρίς πληρωμή.",
"fa.prefillPrevious": "Χρησιμοποιήστε ξανά τα στοιχεία της προηγούμενης καταχώρισής μου σε αυτή την κατηγορία",
"fa.receipt": "Απόδειξη PDF",
"fa.renewBtn": "Ανανέωση",
"fa.renewDiscountBanner": "50% έκπτωση: ανανεώστε πριν λήξει η καταχώρισή σας!",
"fa.renewDiscountHint": "Εφαρμόστηκε 50% έκπτωση επειδή ανανεώνετε πριν τη λήξη.",
"fa.renewEarly": "Ανανέωση (−50%)",
"fa.renewTitle": "Ανανεώστε την καταχώρισή μου",
"fa.renewed": "Η καταχώριση ανανεώθηκε",
"fa.sendClaim": "Στείλτε την αξίωσή μου",
"fa.twoPhotos": "2 φωτογραφίες του αντικειμένου σας",
"fa.twoPhotosError": "Προσθέστε 2 φωτογραφίες του αντικειμένου σας.",
"fa.twoPhotosHint": "Προσωπικές φωτογραφίες που αποδεικνύουν ότι το αντικείμενο είναι δικό σας (με το αντικείμενο, τιμολόγιο, κουτί…).",
"fa.unlockBtn": "Ξεκλειδώστε τα στοιχεία επικοινωνίας",
"fa.unlockFree": "Ξεκλείδωμα δωρεάν — προσφορά εκκίνησης",
"fa.waitClaimantText": "Θα σας ενημερώσουμε μόλις ένας ιδιοκτήτης αξιώσει αυτό το αντικείμενο.",
"fa.waitFinderDecision": "Αναμονή για απόφαση του βρίσκοντα",
"fa.waitUnlockText": "Θα ειδοποιηθείτε μόλις ανταλλαγούν τα στοιχεία επικοινωνίας.",
"fa.waitUnlockTitle": "Αναμονή για να ξεκλειδώσει ο ιδιοκτήτης",
"fa.cancel": "Ακύρωση",
"fa.categoryRequired": "Επιλέξτε μια κατηγορία για το β найден товар.",
"fa.confirmTitle": "Επιβεβαιώστε την απόφασή σας",
"fa.goBack": "Επιστροφή",
"dr.continue": "Συνέχεια της δήλωσής μου",
"dr.delete": "Διαγραφή μόνιμα",
"dr.deleteConfirm": "Θέλετε να διαγράψετε μόνιμα αυτό το σχέδιο; Αυτή η ενέργεια δεν αναιρείται.",
"dr.deleted": "Το σχέδιο διαγράφηκε",
"dr.expiresIn": "Το σχέδιο θα διατηρηθεί για {h} ακόμη ώρες",
"dr.title": "Έχετε μια ατελή δήλωση",
"form.step": "Βήμα",
"form.next": "Συνέχεια",
"form.back": "Πίσω",
"form.stepDetails": "Η αναφορά σας",
"form.stepPublish": "Διάρκεια, ενίσχυση & πληρωμή",
"form.stepThanks": "Ευχαριστούμε & συμβολή",
"fthx.badge": "Η αναφορά είναι σχεδόν έτοιμη",
"fthx.title": "Ευχαριστώ, κάνετε τη διαφορά!",
"fthx.text": "Χάρη σε εσάς, κάποιος μπορεί σύντομα να πάρει πίσω κάτι που έχει αξία για εκείνον. Οι πράξεις καλοσύνης σαν τη δική σας είναι ακριβώς αυτό που κρατάει τη Findloop ζωντανή.",
"fthx.impact1": "1 αντικείμενο αναφοράς",
"fthx.impact2": "1 ακόμα ευκαιρία επανένωσης",
"fthx.tipTitle": "Λίγη ώθηση για το Findloop;",
"fthx.tipText": "Η συνεισφορά σας μας βοηθά να κρατήσουμε την υπηρεσία προσβάσιμη και να επαναφέρουμε όλο και περισσότερα αντικείμενα στους ιδιοκτήτες τους.",
"fthx.optional": "100% προαιρετικό — μπορείτε να δημοσιεύσετε χωρίς να συνεισφέρετε.",
"fthx.thanksTip": "Σας ευχαριστούμε τόσο πολύ για τη γενναιοδωρία σας!",
"fthx.suggest": "Προτεινόμενα ποσά",
"fthx.none": "Κανένα φιλοδόρημα",
"pay.pendingTitle": "Η πληρωμή δεν ολοκληρώθηκε",
"pay.pendingText": "Τα στοιχεία σας έχουν αποθηκευτεί. Συνεχίστε την πληρωμή από εκεί που σταματήσατε.",
"pay.resume": "Συνεχίστε την πληρωμή",
"pay.expiredTitle": "Η συνεδρία πληρωμής έχει λήξει",
"pay.expiredText": "Για την ασφάλειά σας, η συνεδρία πληρωμής έχει λήξει. Τα στοιχεία σας είναι αποθηκευμένα: επανεκκινήστε την πληρωμή με ένα κλικ.",
"pay.relaunch": "Επανεκκίνηση πληρωμής",
"sub.received": "Απεστάλη!",
"sub.publishing": "Ολοκληρώνουμε…",
"sub.toPayment": "Ανακατεύθυνση σε ασφαλή πληρωμή…",
"fa.claimSubV2": "Περιγράψτε το χαμένο σας αντικείμενο. Το άτομο που το βρήκε θα συγκρίνει την δήλωσή σας με την καταχώρισή του.",
"fa.photosOptional": "Φωτογραφίες του αντικειμένου σας (προαιρετικά)",
"fa.compareOwnerHint": "Συγκρίνετε αυτές τις πληροφορίες με το αντικείμενο που βρήκατε και στη συνέχεια δηλώστε αν είναι το ίδιο αντικείμενο.",
"fa.itsThisItem": "Ναι, αυτό είναι το αντικείμενο",
"fa.notThisItem": "Όχι, δεν είναι το αντικείμενο",
"fa.confirmIsItem": "Επιβεβαιώνετε ότι είναι το αντικείμενο; Τα στοιχεία επικοινωνίας σας και του ιδιοκτήτη θα εμφανιστούν στους αντίστοιχους λογαριασμούς σας.",
"fa.confirmNotItem": "Επιβεβαιώνετε ότι δεν είναι το αντικείμενο; Η αναφορά σας θα κλείσει.",
"fa.youConfirmed": "Επιβεβαιώσατε ότι αυτό είναι το αντικείμενο του ιδιοκτήτη",
"fa.youDeclined": "Δηλώσατε ότι αυτό δεν ήταν το αντικείμενο",
"fa.youDeclinedText": "Σας ευχαριστούμε για τη βοήθειά σας! Ο ιδιοκτήτης έχει ενημερωθεί.",
"fa.waitFinderDecisionOwner": "Περιμένοντας την απόφαση του ευρέτη",
"fa.finderConfirmed": "Επιβεβαιώθηκε",
"fa.notYourItem": "Αυτό δεν ήταν το αντικείμενό σας",
"fa.reportedOn": "Δηλώθηκε στις",
"fa.ownerWaitHint": "Ένας ευρέτης ελέγχει επί του παρόντος τις πληροφορίες, παρακαλώ περιμένετε.",
"fa.claimSentFinder": "Η αξίωση στάλθηκε στο άτομο που βρήκε το αντικείμενο.",
"fa.compareClaimHint": "Σύγκρινε τη δήλωση του ιδιοκτήτη με τη λίστα σου πριν αποφασίσεις.",
"fa.closeFollowup": "Κλείστε αυτή την παρακολούθηση",
"fa.closeFollowupConfirm": "Να κλείσω αυτή την παρακολούθηση; Οι διευθύνσεις email και οι αριθμοί τηλεφώνου και των δύο μερών θα διαγραφούν μόνιμα αφού ο κάτοχος κλείσει επίσης την καταχώρισή του.",
"fa.safetyTitle": "Συμβουλές ασφαλείας πριν την παράδοση",
"fa.safety1": "Ζητήστε από τον κάτοχο μια λεπτομερή περιγραφή των κρυφών χαρακτηριστικών του αντικειμένου: μια συγκεκριμένη γρατσουνιά, το ακριβές περιεχόμενο μιας τσάντας, το ταπισερί, τον σειριακό αριθμό…",
"fa.safety2": "Εάν είναι εφικτό, ζητήστε οπτική απόδειξη (μια φωτογραφία του αντικειμένου) ή απόδειξη αγοράς.",
"fa.safety3": "Παραδώστε το αντικείμενο σε δημόσιο χώρο ή σε έναν συνεργάτη του Findloop, και ελέγξτε την ταυτότητα του κατόχου.",
"fa.safetyOk": "Εντάξει, συνεχίστε",
"fa.ownerClosedNote": "Ο κάτοχος έχει κλείσει την καταχώρισή του.",
"fa.finderClosedNote": "Ο ανιχνευτής έχει κλείσει την παρακολούθησή του.",
"fa.followupClosed": "Η παρακολούθηση έκλεισε",
"fa.followupClosedText": "Κλείσατε αυτή την παρακολούθηση. Ευχαριστούμε για τη βοήθειά σας!",
"fa.photoReviewTitle": "Ένας ανιχνευτής έστειλε μια φωτογραφία. Μοιάζει με το αντικείμενό σας;",
"fa.photoLooksLike": "Ναι, μοιάζει με το αντικείμενό μου",
"fa.photoNotMine": "Όχι, αυτό δεν είναι το αντικείμενό μου",
"fa.photoNotMineConfirm": "Η παρακολούθηση θα κλείσει και από τις δύο πλευρές και η καταχώρισή σας θα παραμείνει ανοιχτή για έναν νέο ανιχνευτή.",
"fa.photoLooksLikeDone": "Ευχαριστώ! Ο ανιχνευτής θα συγκρίνει τώρα την δήλωσή σας.",
"fa.photoNotMineDone": "Η αναφορά απορρίφθηκε. Η καταχώρισή σας παραμένει ανοιχτή.",
"fa.ownerPhotoHint": "Μόνο η φωτογραφία του ανιχνευτή σας δείχνεται. Πείτε μας αν μοιάζει με το αντικείμενό σας.",
"fa.ownerReviewingPhoto": "Ο ιδιοκτήτης ελέγχει τη φωτογραφία σας",
"fa.ownerReviewingPhotoText": "Θα ενημερωθείτε μόλις απαντήσουν. Έπειτα θα μπορείτε να συγκρίνετε τη δήλωσή τους.",
"fa.ownerRejectedPhoto": "Αυτό δεν είναι το αντικείμενο του ιδιοκτήτη",
"fa.ownerRejectedPhotoText": "Ο ιδιοκτήτης λέει ότι η φωτογραφία σας δεν ταιριάζει με το αντικείμενό του. Η παρακολούθηση κλείνει. Ευχαριστούμε για τη βοήθειά σας!",
"fa.contribute": "Συμβάλετε",
"fa.phoneMissing": "Δεν έχει παρασχεθεί",
"fa.ownerSafety1": "Προτιμήστε μια παράδοση σε δημόσιο χώρο ή σε συνεργάτη της Findloop. Αν η απόσταση είναι μεγάλη, προτείνετε να σταλεί ταχυδρομικώς.",
"fa.ownerSafety2": "Κατά την παράδοση, ελέγξτε την ταυτότητα του β найденό.",
"pub.changePhoto": "Αλλαγή φωτογραφίας",
"ph.secured": "Η φωτογραφία είναι ασφαλής",
"ph.securing": "Ασφαλίζω τη φωτογραφία…",
"fa.ownerSafety3": "Αν η φωτογραφία του ανιχνευτή φέρει το λογότυπο της Findloop, μην αποδεχθείτε την συνάντηση. Η φωτογραφία πρέπει να είναι αυθεντική εικόνα που έχει ληφθεί από τον ανιχνευτή, χωρίς λογότυπο."
},
"cs": {
"a.back": "Zpět",
"a.category": "Kategorie",
"a.categoryPlaceholder": "Vyberte kategorii",
"a.city": "Město",
"a.confirmPassword": "Potvrďte heslo",
"a.country": "Země",
"a.createAccount": "Vytvořte účet",
"a.createBtn": "Vytvořit můj účet",
"a.creating": "Vytváření…",
"a.email": "E-mail",
"a.emailPro": "Podnikatelský e-mail",
"a.forgot": "Zapomněli jste?",
"a.forgotSent": "Pokud účet existuje, odkaz na resetování byl právě odeslán.",
"a.forgotSub": "Získejte odkaz na resetování e-mailem.",
"a.forgotTitle": "Zapomenuté heslo",
"a.googleContinue": "Pokračovat s Googlem",
"a.googleSignup": "Registrovat se s Googlem",
"a.haveAccount": "Již partner?",
"a.legalHint": "Povinné pro francouzské e-faktury (Factur-X) francouzských subjektů.",
"a.legalRequiredFR": "SIRET a číslo DPH v rámci EU jsou povinné pro Francii.",
"a.loggingIn": "Přihlašování…",
"a.login": "Přihlásit se",
"a.loginSub": "Získejte přístup do svého správcovského prostoru.",
"a.loginTitle": "Přihlášení partnera",
"a.min6": "Minimálně 6 znaků",
"a.newPassword": "Nové heslo",
"a.noAccount": "Ještě nejste partner?",
"a.or": "NEBO",
"a.org": "Název subjektu",
"a.password": "Heslo",
"a.passwordMismatch": "Hesla se neshodují.",
"a.referral": "Referenční kód (nepovinné)",
"a.registerSub": "Vytvořte si svůj prostor za 1 minutu — zdarma na začátku.",
"a.registerTitle": "Staňte se partnerem",
"a.rememberMe": "Pamatuj si mě",
"a.reset": "Resetovat",
"a.resetSub": "Zvolte nové heslo pro svůj účet.",
"a.resetTitle": "Nové heslo",
"a.sendLink": "Odeslat odkaz",
"a.sending": "Odesílání…",
"a.signin": "Přihlásit se",
"a.siret": "SIRET",
"a.vat": "Č. DPH v rámci EU",
"ac.africa": "Afrika",
"ac.boostActive": "Zvýraznit aktivní —",
"ac.boostSub": "Objevit se na vrcholu adresáře partnerů s odznakem „Zvýhodněno“.",
"ac.boostTitle": "Zvyšte svůj záznam v adresáři",
"ac.categoryHint": "Pro klasifikaci vašeho subjektu v adresáři findloop.",
"ac.choose": "Vybrat",
"ac.cityHint": "Pro přesné umístění na veřejné mapě.",
"ac.cityLabel": "Město subjektu",
"ac.cityPh": "Paříž",
"ac.contact": "Kontaktní údaje",
"ac.converted": "Převedeno",
"ac.copyDeclLink": "Zkopírovat odkaz na prohlášení",
"ac.copyLink": "Zkopírovat odkaz",
"ac.currentPlan": "Současný plán",
"ac.emailDesc": "Vyberte e-maily, které chcete přijímat. Oznámení ve vaší pracovní oblasti zůstávají vždy aktivní.",
"ac.emailMatch": "Shody",
"ac.emailMatchDesc": "E-mail, když položka odpovídá prohlášení",
"ac.emailNewDecl": "Nové oznámení o ztrátě",
"ac.emailNewDeclDesc": "Email, jakmile klient nahlásí ztrátu na vašem místě",
"ac.emailShip": "Žádosti o dopravu",
"ac.emailShipDesc": "Email, když klient požádá o dopravu položky",
"ac.emailTitle": "Nastavení emailu",
"ac.expireSoon": "Vaše zvýraznění brzy vyprší —",
"ac.exportCsv": "Export (CSV)",
"ac.exportHint": "Exportujte své ověřené externí platby pro vaše účetnictví.",
"ac.free": "Zdarma",
"ac.freeMonths": "Bezplatné měsíce",
"ac.hours": "hodiny",
"ac.howItWorks": "Jak to funguje?",
"ac.invited": "Pozvaný",
"ac.legalFR": "Požadováno pro elektronické fakturace (Factur-X), platí od září 2026.",
"ac.legalMissing": "⚠️ Chybí SIRET a DPH v rámci EU — doplňte je, abyste byli v souladu s elektronickou fakturací.",
"ac.legalOther": "Doporučeno pro vaše faktury.",
"ac.legalPartnerQr": "QR kód",
"ac.legalTitle": "Právní identifikátory (fakturace)",
"ac.logoTitle": "Logo zařízení",
"ac.modeCurrent": "Aktuální režim:",
"ac.modeExternal": "Externí (ruční ověření)",
"ac.modeInternal": "Interní Findloop (automatické)",
"ac.noSubReceipt": "Zatím žádná platba za předplatné.",
"ac.none": "Žádný",
"ac.onYourListing": "ve vašem výpisu",
"ac.pay1": "Zadejte své platební odkazy níže pro přesměrování vašich zákazníků na váš vlastní vyřizovací systém.",
"ac.pay2": "Ověření se stává ručním: potvrzujete přijetí platby na kartě “Oznámení”",
"ac.pay3": "Odkaz “Poplatek za dopravu” je konsolidovaná platba (obnova + doprava).",
"ac.pay4": "Nechte pole prázdná pro použití interní platby Findloop (Stripe) s automatickým ověřením.",
"ac.paySub": "Vybírejte poplatky pomocí svého vlastního platebního systému.",
"ac.payTitle": "Externí platby",
"ac.permissive": "Povolující",
"ac.phone": "Telefon",
"ac.posterA4": "Plakát A4 (PDF)",
"ac.qMessage": "Zpráva (volitelně)",
"ac.qName": "Jméno",
"ac.qOrg": "Organizace",
"ac.qSites": "Počet zařízení (odhad)",
"ac.qrHint": "Vaši zákazníci skenují tento kód, aby nahlásili ztracenou položku.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Váš partner QR kód",
"ac.quoteDesc": "Letiště, železniční sítě, mezinárodní řetězce · ",
"ac.quoteEurope": "Evropa / Svět",
"ac.quoteSent": "Žádost o nabídku odeslána. Náš tým se vám brzy ozve.",
"ac.quoteTitle": "Požádat o nabídku — Podnik",
"ac.recoveryLink": "Odkaz “Poplatek za obnovu”",
"ac.refSub": "Každý doporučený partner, který se přihlásí, vám dává 1 bezplatný měsíc.",
"ac.refTitle": "Doporučte, získejte bezplatný měsíc",
"ac.reminderDelay": "Opoždění připomenutí ověření",
"ac.reminderHint": "Obdržíte emailové připomenutí, pokud zůstane externí platba neověřená po tomto zpoždění (výchozí: 48h).",
"ac.renewDesc1": "Už vám to vydělalo",
"ac.renewDesc2": "Obnovte, abyste zůstali na vrcholu adresáře a neztratili tuto viditelnost.",
"ac.renewNow": "Obnovit nyní",
"ac.requestQuote": "Požádat o nabídku",
"ac.saveLegal": "Uložit identifikátory",
"ac.saveLinks": "Uložit odkazy",
"ac.sendRequest": "Odeslat moji žádost",
"ac.sending": "Odesílání…",
"ac.shippingLink": "Odkaz “Poplatek za dopravu” (konsolidovaný)",
"ac.shippingLinkHint": "Tento odkaz pokrývá jak obnovu, tak dopravu.",
"ac.strict": "Přísné",
"ac.subReceipt": "Potvrzení o předplatném (PDF)",
"ac.subReceiptsSub": "Stáhněte si PDF potvrzení pro každou platbu předplatného.",
"ac.subReceiptsTitle": "Potvrzení o předplatném",
"ac.tCategory": "Kategorie uložena",
"ac.tCity": "Město uloženo — mapa byla aktualizována",
"ac.tCityNeeded": "Zadejte město",
"ac.tCopied": "Zkopírováno!",
"ac.tCover": "Obrázek na obálku byl aktualizován",
"ac.tEmailPrefs": "Nastavení e-mailu bylo aktualizováno",
"ac.tErr": "Chyba",
"ac.tExportImpossible": "Export selhal",
"ac.tLegal": "Právní identifikátory uloženy",
"ac.tLegalNeeded": "SIRET a DPH požadováno pro Francii",
"ac.tLogo": "Logo aktualizováno",
"ac.tLogoRemoved": "Logo odstraněno",
"ac.tPayLinks": "Platnostní odkazy uloženy",
"ac.tPhone": "Telefon uložen",
"ac.tSensitivity": "Citlivost uložena",
"ac.tVatInvalid": "Neplatné číslo DPH",
"ac.tVatValid": "Platné DPH",
"ac.tabBoost": "Viditelnost",
"ac.tabPayments": "Platby",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Plakát",
"ac.tabReferral": "Doporučení",
"ac.tabSub": "Předplatné",
"ac.thisWeek": "Tento týden",
"ac.thisWeekOf": " ({n} tento týden)",
"ac.thresholdDesc": "Prahová hodnota důvěry, od které AI automaticky ověřuje shodu fotografie a informuje zákazníka. Čím vyšší = méně automatických shod, ale spolehlivější.",
"ac.thresholdTitle": "Citlivost vizuální shody AI",
"ac.trend": "Trend",
"ac.upload": "Nahrát",
"ac.vatValidFmt": "Platné DPH{name} ({via})",
"ac.vatVerified": "Ovřené DPH v EU",
"ac.verifyVat": "Ověřit DPH (VIES)",
"ac.verifying": "Ověřuji…",
"ac.views": "zobrazení",
"ac.viewsTotal": "Celkový počet zobrazení",
"ac.winbackBtn": "Pokračovat s -20%",
"ac.winbackDesc1": "Získali jste",
"ac.winbackDesc2": "Speciální nabídka: -20% se automaticky aplikuje, pokud obnovíte do 24h.",
"ac.winbackTitle": "Vaše zvýraznění právě vypršelo — obnovte za -20%!",
"ad.boost": "Zvýšit",
"ad.close": "Zavřít",
"ad.closeConfirm": "Zavřít tento inzerát?",
"ad.closed": "Inzerát uzavřen",
"ad.edit": "Upravit",
"ad.editTitle": "Upravit inzerát",
"ad.saved": "Inzerát aktualizován",
"an.allCountries": "Všechny země",
"an.badge": "Ztracené předměty",
"an.boostLater": "Později",
"an.boostNow": "Zvýšit nyní",
"an.boostPrompt": "Zvyšte svůj inzerát, aby se umístil na vrchol a byl nalezen rychleji.",
"an.boosted": "Zvýšeno",
"an.contact": "Našel jsem tento předmět",
"an.contactTitle": "Nahlásit, že jste našli tento předmět",
"an.copyFailed": "Nešlo zkopírovat odkaz",
"an.copyLink": "Zkopírovat odkaz",
"an.country": "Země",
"an.date": "Datum ztráty",
"an.finderEmail": "Váš email",
"an.finderName": "Vaše jméno",
"an.finderPhone": "Váš telefon",
"an.geoBanner": "Zobrazuje se vám inzeráty v",
"an.geoBannerWorld": "Zobrazuje se vám inzeráty po celém světě",
"an.geoChange": "změnit zemi",
"an.goAccount": "Přejít na můj účet",
"an.linkCopied": "Odkaz zkopírován!",
"an.loginRequired": "Přihlaste se, abyste nahlásili tuto položku a sledovali vrácení.",
"an.loginToBoost": "Přihlaste se, aby jste podpořili tento inzerát",
"an.lostAt": "Ztraceno v",
"an.message": "Zpráva (volitelné)",
"an.none": "Zatím žádný inzerát.",
"an.photo": "Fotografie (volitelné)",
"an.post": "Nahrát inzerát",
"an.postSubtitle": "Popište svou ztracenou položku — komunita a naši partneři vám pomohou ji najít.",
"an.postTitle": "Nahlásit ztracenou položku",
"an.publish": "Publikovat inzerát",
"an.published": "Inzerát publikován!",
"an.publishing": "Publikování…",
"an.remaining": "zbývá",
"an.requestInProgress": "Žádost je zpracovávána",
"an.resolved": "Položka již byla nalezena",
"an.reward": "Odměna",
"an.searchPh": "Vyhledat inzerát…",
"an.send": "Odeslat",
"an.sent": "Zpráva odeslána majiteli!",
"an.shareConsent": "Souhlasím, že mé kontaktní údaje (jméno, email, telefon) mohou být sdíleny s majitelem položky.",
"an.shareConsentError": "Prosím, zaškrtněte políčko pro sdílení vašich kontaktních údajů.",
"an.sortRecent": "Nejnovější",
"an.sortRelevance": "Relevance",
"an.subtitle": "Prozkoumejte položky nahlášené jako ztracené komunitou. Našli jste jednu z nich?",
"an.title": "Inzeráty ztracených položek",
"anf.badge": "Nalezené položky",
"anf.claim": "Tohle je moje",
"anf.claimSent": "Zpráva odeslána nálezci!",
"anf.claimTitle": "Nahlásit, že toto je vaše položka",
"anf.consent": "Souhlasím, že majitel může vidět mé kontaktní údaje pro získání jejich položky.",
"anf.foundAt": "Nalezeno v",
"anf.foundDate": "Datum nálezu",
"anf.loginCta": "Přihlásit se / vytvořit účet",
"anf.loginDesc": "Účet nálezce je vyžadován pro publikaci inzerátu a získání bodů Finder Hero.",
"anf.loginRequired": "Přihlaste se, abyste nahráli nalezenou položku",
"anf.photo": "Fotografie položky",
"anf.pointsEarned": "Děkujeme! Právě jste získali body Finder Hero.",
"anf.pointsPending": "Vaše body budou připsány do 24h po ověření.",
"anf.post": "Nahrát nalezenou položku",
"anf.postSubtitle": "Popište položku, kterou jste našli — pomozte jejímu majiteli ji získat zpět.",
"anf.postTitle": "Nahlásit nalezenou položku",
"anf.publishFound": "Publikovat inzerát o nalezené položce",
"anf.published": "Inzerát o nalezené položce publikován",
"anf.publishedAs": "Publikováno jako",
"anf.shareConsent": "Souhlasím, že mé kontaktní údaje (jméno, email, telefon) mohou být sdíleny s osobou, která položku našla.",
"anf.subtitle": "Prozkoumejte položky nalezené a nahlášené komunitou. Poznali jste tu svou?",
"anf.title": "Inzeráty nalezených položek",
"bo.active": "Podpora aktivní",
"bo.africaPrice": "Preferenční ceny pro africkou zónu použity",
"bo.pay": "Platba & podpora",
"bo.remaining": "Čas zbývá",
"bo.renew": "Obnovit zvýšení",
"bo.since": "od zvýšení",
"bo.subtitle": "Umístěte svůj inzerát na začátek seznamu s viditelným odznakem.",
"bo.title": "Zvýšení inzerátu",
"c.all": "Vše",
"c.cancel": "Zrušit",
"c.close": "Zavřít",
"c.confirm": "Potvrdit",
"c.confirmed": "Potvrzeno",
"c.download": "Stáhnout",
"c.loading": "Načítání…",
"c.reset": "Resetovat",
"c.reviews": "recenze",
"c.save": "Uložit",
"c.transfer": "Převést",
"cat.Animal": "Domácí zvíře / Příslušenství pro zvířata",
"cat.AppareilPhoto": "Fotoaparát",
"cat.Argent": "Peníze / Hotovost",
"cat.Autres": "Ostatní",
"cat.Bijoux": "Šperky",
"cat.CarteBancaire": "Bankovní karta",
"cat.CarteIdentite": "Občanský průkaz / Pas",
"cat.Casquette": "Kšiltovka / Klobouk",
"cat.Ceinture": "Opasek",
"cat.Chargeur": "Nabíječka / Kabel",
"cat.Chaussures": "Boty",
"cat.CleVoiture": "Klíč od auta",
"cat.Cles": "Klíče",
"cat.Console": "Herní konzole",
"cat.Documents": "Dokumenty / Papíry",
"cat.Echarpe": "Šála",
"cat.Ecouteurs": "Sluchátka",
"cat.Electronique": "Elektronika (ostatní)",
"cat.Enceinte": "Reproduktor",
"cat.Gants": "Rukavice",
"cat.Gourde": "Láhev na vodu / Termoska",
"cat.Instrument": "Hudební nástroj",
"cat.Jouet": "Hračka / Plyš",
"cat.Jumelles": "Dalekohled",
"cat.Lampe": "Lampa / Svítilna",
"cat.Liseuse": "E-čtečka",
"cat.Livre": "Kniha / Sešit",
"cat.Lunettes": "Brýle",
"cat.Manteau": "Kabát / Bunda",
"cat.Maquillage": "Kosmetická taška",
"cat.Medical": "Lékařské vybavení",
"cat.Medicaments": "Léky",
"cat.Montre": "Hodinky / Chytré hodinky",
"cat.Ordinateur": "Notebook",
"cat.Parapluie": "Deštník",
"cat.Portefeuille": "Peněženka / Kabelka",
"cat.Poussette": "Kočárek / Příslušenství pro děti",
"cat.Sac": "Taška / Kabelka",
"cat.SacADos": "Batoh",
"cat.Souris": "Myš / Klávesnice",
"cat.Sport": "Sportovní vybavení",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefon / Chytrý telefon",
"cat.Trottinette": "Koloběžka",
"cat.Trousse": "Pytlík / Pouzdro",
"cat.USB": "USB flash disk / Pevný disk",
"cat.Valise": "Kufr / Zavazadlo",
"cat.Velo": "Bicykl",
"cat.Vetements": "Oblečení",
"cat.placeholder": "Vyberte kategorii",
"cd.d": "d",
"cd.expired": "Vypršelo",
"cd.h": "h",
"cd.m": "min",
"ck.accept": "Souhlasit",
"ck.acceptAll": "Souhlasit se vším",
"ck.customize": "Přizpůsobit",
"ck.learn": "Zjistit více",
"ck.manage": "Spravovat cookies",
"ck.measurement": "Měření publika",
"ck.measurementDesc": "Anonymní statistiky pro zlepšení služby.",
"ck.msg": "Používáme cookies, abychom udrželi web v chodu a měřili publikum.",
"ck.necessary": "Nezbytné",
"ck.necessaryDesc": "Základní pro fungování webu. Vždy zapnuto.",
"ck.refuse": "Odmítnout",
"ck.save": "Uložit moje volby",
"ck.saved": "Nastavení uloženo",
"ck.title": "Vaše preference cookies",
"cm.found": "NAŠEL",
"cm.lost": "ZTRACENO",
"cmp.adv": "Pokročilé",
"cmp.ai": "AI párování",
"cmp.autobill": "Automatické fakturace",
"cmp.basic": "Základní",
"cmp.community": "Komunita",
"cmp.consol": "Konsolidovaná fakturace",
"cmp.custom": "Vlastní",
"cmp.dedicated": "Dedikované",
"cmp.deploy": "Dedikované nasazení & SLA",
"cmp.estIncl": "Zahrnuté zařízení",
"cmp.estSec": "Další zařízení",
"cmp.items": "Položky / měsíc",
"cmp.main": "1 hlavní",
"cmp.max20": "20 max",
"cmp.members": "Pozvánky pro členy",
"cmp.onQuote": "Vlastní nabídka",
"cmp.priority": "Priorita",
"cmp.starterEst": "1 zahrnuté + neomezeně extra",
"cmp.stats": "Statistiky",
"cmp.statsAdv": "Pokročilé",
"cmp.statsBasic": "Základní",
"cmp.support": "Podpora",
"cmp.unlimited": "Neomezené",
"cmp.upTo3": "Až 3",
"consent.required": "Musíte souhlasit se sdílením svých kontaktních údajů, abyste mohli pokračovat.",
"consent.share": "Souhlasím, že nálezce mé položky může vidět mé kontaktní údaje (jméno, e-mail, telefon), aby mě mohl kontaktovat kvůli jejímu vrácení.",
"cover.add": "Přidat",
"cover.change": "Změnit",
"cover.helper": "Zobrazeno jako banner na vaší stránce zprávy a v adresáři.",
"cover.none": "Žádná fotografii na obálce",
"cover.remove": "Odstranit",
"cover.title": "Fotografie na obálce",
"crop.desc": "Upravte rámeček na poměr banneru (3:1). Táhněte a zoomujte.",
"crop.saving": "Ukládání…",
"crop.title": "Oříznout profilový obrázek",
"cta.button": "Vytvořit účet pro partnera",
"cta.subtitle": "Připojte se k provozovnám, které vracejí předměty rychleji s findloop.",
"cta.title": "Jste připraveni snížit ztracené předměty?",
"db.account.s": "Spravujte svou provozovnu, předplatné a QR kód.",
"db.account.t": "Můj účet",
"db.declarations.s": "Zákazníci, kteří nahlásili ztracený předmět prostřednictvím vašeho QR kódu.",
"db.declarations.t": "Hlášení ztrát",
"db.deposit.s": "Přidejte fotografii, kategorii a popis.",
"db.deposit.t": "Zaregistrovat nalezený předmět",
"db.registry.s": "Všechny nalezené předměty zaregistrované ve vaší provozovně.",
"db.registry.t": "Registr předmětů",
"db.reviews.s": "Odpovězte veřejně na recenze vašich zákazníků.",
"db.reviews.t": "Recenze zákazníků",
"db.shipments.s": "Vytvořte štítky a sledujte balíky k odeslání.",
"db.shipments.t": "Zásilky",
"db.stats.s": "Vaše klíčové ukazatele výkonnosti.",
"db.stats.t": "Statistiky",
"db.team.s": "Pozvěte své kolegy k správě předmětů.",
"db.team.t": "Tým",
"dc.partnerDesc": "Ztratili jste předmět na partnerském místě (hotel, nádraží, hala…)? Vyberte ho pro přímé vrácení.",
"dc.partnerList": "Vyberte ze seznamu",
"dc.partnerMap": "Vyberte na mapě",
"dc.partnerTitle": "Hlášení na partnerovi",
"dc.publicCta": "Publikovat veřejný inzerát",
"dc.publicDesc": "Váš inzerát bude viditelný celé komunitě findloop. Ideální, pokud nevíte, kde jste předmět ztratili.",
"dc.publicTitle": "Veřejné hlášení",
"dc.subtitle": "Zvolte, jak nahlásit váš ztracený předmět.",
"dc.title": "Co byste chtěli udělat?",
"dec.addrPending": "Adresa čeká na zákazníka",
"dec.analyzing": "Analyzuji…",
"dec.badge": "Hlášení ztráty",
"dec.category": "Kategorie předmětu",
"dec.clientDescription": "Popis zákazníka",
"dec.clientPhoto": "Fotografie poskytnutá zákazníkem",
"dec.clientPhotoShort": "Fotografie zákazníka",
"dec.comparePhotos": "Porovnat fotografie",
"dec.contactTitle": "Vaše kontaktní údaje",
"dec.date": "Datum ztráty",
"dec.declaredItemPhoto": "Fotografie nahlášeného předmětu",
"dec.descPh": "Popište předmět: značka, barva, zvláštní znaky…",
"dec.description": "Popis",
"dec.email": "Email",
"dec.emptyDesc": "Sdílejte svůj QR kód pro příjem hlášení.",
"dec.emptyTitle": "Žádná hlášení",
"dec.enlarge": "Zvětšit",
"dec.extBanner": "{n} externí platbu(aky) k ověření — potvrďte příjem níže pro odemknutí předání nebo odeslání.",
"dec.foundItemAlt": "Nalezený předmět",
"dec.foundItemRegistry": "Nalezený předmět (registr)",
"dec.home": "Zpět na domovskou stránku",
"dec.labelClient": "Zákazník",
"dec.labelRegistry": "Registr",
"dec.matchFound": "Shoda již byla identifikována!",
"dec.name": "Celé jméno",
"dec.noMatchYet": "Žádná shoda zatím.",
"dec.noPhoto": "Žádná fotografie",
"dec.notfound": "Partner nenalezen.",
"dec.pRecup": "obnova",
"dec.pRecupP": "(obnova)",
"dec.pRecupShip": "(obnova + odeslání)",
"dec.payConfirmed": "Platba {x} potvrzena",
"dec.payPending": "Externí platba {x} čeká na zpracování",
"dec.phone": "Telefon",
"dec.pickup": "Osobní vyzvednutí",
"dec.place": "Místo ztráty",
"dec.placePh": "např. u baru, místnost 204…",
"dec.recoverBtn": "Obnovit můj předmět",
"dec.reject": "Odmítnout",
"dec.rerun": "Znovu spustit analýzu",
"dec.similarity": "Podobnost {n}%",
"dec.submit": "Odeslat mou zprávu",
"dec.submitting": "Odesílání…",
"dec.successText": "Hledáme váš předmět mezi těmi, které máme v úschově na",
"dec.successTitle": "Zpráva odeslána!",
"dec.suggestedMatches": "Navrhované shody",
"dec.toColon": " do:",
"dec.toShip": "K odeslání",
"dec.toastExtPay": "Platba potvrzena — zákazník bude informován.",
"dec.toastMatch": "Shoda potvrzena",
"dec.toastReject": "Návrh odmítnut",
"dec.toastRerun": "Analýza znovu spuštěna",
"dec.toastVisualN": "{n} vizuální shoda(y)",
"dec.toastVisualNone": "Žádná vizuální shoda",
"dec.trackBtn": "Sledovat mou zprávu",
"dec.viewBeforeAfter": "Pohled před/po (overlay)",
"dec.viewSideBySide": "Pohled vedle sebe",
"dec.visualCompare": "AI vizuální porovnání",
"dec.visualIdle": "Spusťte porovnání, aby AI vizuálně srovnala fotografii zákazníka s nalezenými předměty.",
"dec.visualRunning": "AI porovnává fotografii zákazníka s předměty ve vaší registraci…",
"dec.zoomPhoto": "Přiblížit fotografii",
"dep.addAnyway": "Přidat přesto",
"dep.addError": "Chyba při přidávání",
"dep.addItem": "Přidat předmět",
"dep.added": "Předmět přidán do registru!",
"dep.adding": "Přidávání…",
"dep.aiError": "Analýza AI je momentálně nedostupná.",
"dep.aiFilled": "Formulář předvyplněn AI ✨",
"dep.aiUnavailable": "AI není k dispozici — vyplňte formulář ručně.",
"dep.analyzing": "Analyzuji…",
"dep.analyzingPhoto": "Analyzuji fotografii…",
"dep.brand": "Značka",
"dep.brandPlaceholder": "např. Apple",
"dep.category": "Kategorie",
"dep.checkingDup": "Kontrola duplicit…",
"dep.color": "Barva",
"dep.colorPlaceholder": "např. černá",
"dep.condition": "Stav",
"dep.conditionPlaceholder": "např. dobrý stav",
"dep.depositorNote": "Poznámka skladatele",
"dep.depositorNoteHint": "Provozní detaily napsané ručně. AI nikdy nepřepisuje tuto poznámku.",
"dep.depositorNotePlaceholder": "např. obsah sáčku, značka jak byla hlášena, detaily poskytnuté osobou…",
"dep.descPlaceholder": "např. černý iPhone 15 s průhledným pouzdrem, nalezený u baru…",
"dep.description": "Popis",
"dep.dupHint": "Ujistěte se, že nepřidáváte duplicitní předmět. Můžete pokračovat, pokud je předmět skutečně jiný.",
"dep.dupTitle": "Podobné předměty již registrovány",
"dep.dupWarn": "Byla detekována podobnost — prozkoumejte a poté klikněte znovu pro potvrzení.",
"dep.estHint": "Předmět bude přidán do registru tohoto zařízení.",
"dep.establishment": "Zařízení",
"dep.fee": "Poplatek za obnovu (€) — volitelné",
"dep.feePlaceholder": "Nechte prázdné pro výchozí cenu kategorie",
"dep.fillAI": "Vyplnit pomocí AI",
"dep.optional": "(volitelné)",
"dep.photo": "Fotografie položky",
"dep.principal": "primární",
"dep.reqError": "Kategorie a popis jsou povinné.",
"dep.savedItem": "Registrovaná položka",
"dep.similarity": "Podobnost",
"dep.storage": "Fyzická lokalita",
"dep.storageHint": "Kde je položka fyzicky uložena. Bude vygenerován QR kód pro její nalezení.",
"dep.storagePlaceholder": "např. Polička A3, Skříňka 12, Úschovna na recepci",
"dl.aClient": "zákazník",
"dl.alertsBlocked": "Oznámení prohlížeče zablokována",
"dl.alertsBlockedHint": "Pro opětovné povolení: klikněte na ikonu 🔒 (nebo ⓘ) nalevo od adresy webu, poté povolte Oznámení a znovu načtěte stránku.",
"dl.amountDue": "Dlužná částka: {amount} {currency}.",
"dl.enableAlerts": "Povolit oznámení",
"dl.extPending": "Platby k ověření",
"dl.freemiumNear": "Blížíte se k limitu Freemium ({used}/{max} položek tento měsíc). Přepněte na Starter pro neomezené položky.",
"dl.freemiumReached": "Limit Freemium dosažen ({used}/{max} položek tento měsíc). Přepněte na Starter pro registraci neomezeného počtu položek.",
"dl.invoiceOverdue": "Faktura {num} nezaplacena — přístup omezen.",
"dl.matchNotifTitle": "Findloop — Nová shoda AI 🔔",
"dl.matchToast": "Nová shoda AI — {name}",
"dl.matchToastDesc": "Položka odpovídá deklaraci.",
"dl.notifEmpty": "Zatím žádná oznámení.",
"dl.notifEnabled": "Oznámení prohlížeče povolena",
"dl.notifTitle": "Oznámení",
"dl.payInvoice": "Zaplatit moji fakturu →",
"dl.rewardsPending": "Poukazy k předložení",
"dl.upgradeStarter": "Přepnout na Starter →",
"est.all": "Všechna zařízení ({n})",
"est.label": "Zařízení",
"est.primary": "primární",
"est.secondary": "sekundární",
"est2.add": "Přidat zařízení",
"est2.addressLabel": "Adresa",
"est2.addressPh": "Ulice République 12",
"est2.autoInvoice": "Podrobná faktura se automaticky generuje 1. dne každého měsíce.",
"est2.baseSub": "Základní předplatné",
"est2.billing": "Fakturace",
"est2.boostActivated": "Boost aktivován pro {name}",
"est2.boostBillingNote": "Fakturováno aktuální sazbou a souhrnně na vaší konsolidované měsíční faktuře.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Zlepšete viditelnost tohoto zařízení v adresáři a na mapě.",
"est2.boostDuration": "{h}h posílené viditelnosti",
"est2.boostExtend": "Prodloužit",
"est2.boostTitle": "Boost {name}",
"est2.boosted": "Zvýšeno",
"est2.chartDesc": "Podíl vrácených položek z celkově registrovaných, místo od místa.",
"est2.chartTitle": "Míra vracení podle zařízení",
"est2.chartTooltip": "Vrátit",
"est2.cityLabel": "Město",
"est2.cityPh": "Lyon",
"est2.contactHint": "Tyto údaje jsou zákazníkovi zobrazeny pro toto zařízení (pokud chybí, vrátí se k účtu).",
"est2.countryLabel": "Země",
"est2.coverLabel": "Profilový obrázek",
"est2.create": "Vytvořit",
"est2.created": "Zařízení vytvořeno",
"est2.delete": "Smazat",
"est2.deleteDesc": "Tato akce je trvalá. Můžete smazat zařízení pouze pokud neobsahuje žádné položky.",
"est2.deleteTitle": "Smazat „{name}“?",
"est2.deleted": "Zařízení smazáno",
"est2.dialogDesc": "Zadejte název a adresu této provozovny.",
"est2.edit": "Upravit",
"est2.editEst": "Upravit provozovnu",
"est2.emailLabel": "Kontaktní e-mail",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " provozovna(e)",
"est2.extraNoteBase": "{n} další provozovna(e) účtována(y)",
"est2.extraPrice": " za {price} €/měsíc.",
"est2.extraQuote": " na základě nabídky.",
"est2.imgChange": "Vybrat obrázek",
"est2.imgDone": "Hotovo",
"est2.imgRemove": "Odstranit",
"est2.imgRemoved": "Obrázek odstraněn",
"est2.imgSaved": "Obrázek uložen",
"est2.imgUploading": "Nahrávám…",
"est2.includedPlan": "Zahrnuto ve vašem plánu: {n}.",
"est2.kDeclarations": "Prohlášení",
"est2.kInStorage": "Na skladě",
"est2.kItemsTotal": "Položky (celkem)",
"est2.kRestituted": "Vráceno",
"est2.limitReached": "Dosáhnuto limitu",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Prohláš.",
"est2.mItems": "Položky",
"est2.mRestituted": "Vráceno",
"est2.mStorage": "Na skladě",
"est2.monthlyTotal": "Měsíční celkem",
"est2.nameLabel": "Název *",
"est2.namePh": "např. Belmont Hotel — Lyon Annex",
"est2.newEst": "Nová provozovna",
"est2.onQuote": "Na cenové nabídce",
"est2.phoneLabel": "Telefon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plán",
"est2.planLimited": "Váš plán “{tier}” je omezen na {max} provozovna(e).",
"est2.primary": "Hlavní",
"est2.qr": "QR kód",
"est2.qrDesc": "Zobrazte tento QR kód v této provozovně. Zákazníci oznamující ztrátu budou propojeni s touto stránkou.",
"est2.qrTitle": "QR kód — {name}",
"est2.saving": "Ukládám…",
"est2.seeInvoices": "Zobrazit mé měsíční faktury",
"est2.seePlans": "Zobrazit plány",
"est2.subtitle": "Spravujte všechny své provozovny pod jedním účtem — konsolidovaný pohled, položky, QR kód a fakturace.",
"est2.suspended": "Pozastaveno",
"est2.tierFree": "1 provozovna",
"est2.tierLarge": "neomezené provozovny",
"est2.tierMedium": "5 provozoven zahrnuto",
"est2.tierSmall": "3 provozovny zahrnuty",
"est2.title": "Provozovny",
"est2.unlimitedPlan": "Váš plán umožňuje neomezený počet provozoven.",
"est2.unlimitedSuffix": " · neomezeně",
"est2.updated": "Provozovna aktualizována",
"est2.upgradeHint": "Zvýšení plánu na vyšší úroveň pro přidání více provozoven a centralizaci všech vašich aktivit.",
"est2.visuals": "Logo & foto",
"est2.visualsDesc": "Přizpůsobte logo a úvodní fotografii této provozovny. Objeví se na její veřejné stránce a v prohlášení.",
"est2.visualsTitle": "Vizuály — {name}",
"est2.workOn": "Pracujte na této provozovně",
"est2.working": "Pracujete na “{name}”",
"ev.created": "Zpráva vytvořena",
"ev.matched": "Byla identifikována shodující se položka",
"ev.paid": "Poplatek za obnovu zaplacen",
"ev.pickup": "Osobní vyzvednutí",
"ev.shipped": "Balíček odeslán",
"ev.shipping_paid": "Poplatek za dopravu zaplacen",
"ev.shipping_requested": "Doprava požadována",
"feat1.d": "KPI, míra vracení podle kategorie, příjmy a trendy za posledních 30 dní.",
"feat1.t": "Řídicí panel & analytika",
"feat2.d": "Štítky, sledování kurýrů a automatické e-maily o sledování.",
"feat2.t": "Modul dopravy",
"feat3.d": "Zákazníci vás najdou podle města a kategorie, s ověřenými recenzemi.",
"feat3.t": "Veřejný adresář & recenze",
"fp.backToRanking": "Zpět na žebříček",
"fp.badge": "Odznak",
"fp.hero": "Hrdina Finder",
"fp.notFound": "Profil nenalezen nebo soukromý.",
"fp.scoreTotal": "Celkové body",
"fp.scoreYear": "Body v",
"fp.share": "Sdílet tento profil",
"fp.shareText": "Podívejte se na profil nálezce {name} na Findloop!",
"fp.tagline": "Poctivý nalezce, který dělá svět lepším místem.",
"ft.backAccount": "Zpět na Můj účet",
"ft.closeBtn": "Uzavřít případ",
"ft.closeConfirm": "Potvrdit, že byl předmět vrácen? Inzerát bude uzavřen.",
"ft.closeLockedHint": "Nejprve ověřte kód majitele, abyste mohli uzavřít případ.",
"ft.closed": "Případ uzavřen — předmět vrácen!",
"ft.codeLabel": "Zadejte ověřovací kód, který jste obdrželi od majitele",
"ft.codeNeeded": "Prosím, zadejte ověřovací kód.",
"ft.codeOk": "Kód ověřen — můžete uzavřít případ.",
"ft.codePlaceholder": "např. 4821",
"ft.codeVerified": "Ověřeno",
"ft.doneMsg": "Předmět vrácen. Děkujeme, že jste pomohli jej vrátit majiteli!",
"ft.stepInProgress": "Vracení probíhá",
"ft.stepPublished": "Inzerát zveřejněn",
"ft.stepReturned": "Předmět vrácen",
"ft.subtitle": "Následujte kroky, dokud není nalezený předmět vrácen.",
"ft.title": "Sledování vracení",
"ft.verifyBtn": "Ověřit kód",
"hero.badge": "Zvýrazněno",
"hero.ctaFound": "Našel/a jsem předmět",
"hero.ctaLost": "Ztratil/a jsem předmět",
"hero.ctaPartner": "Staňte se partnerem",
"hero.subtitle": "Findloop pomáhá institucím spravovat nalezené předměty — a umožňuje jejich zákazníkům nahlásit ztrátu a poté si vyzvednout své věci, na místě nebo přepravou.",
"hero.title": "Každý ztracený předmět najde svého majitele.",
"home.champBecome": "Staňte se nalezcem",
"home.champCta": "Podívejte se na žebříček",
"home.champSubtitle": "Každý vrácený předmět získává body. Připojte se k žebříčku a vyhrajte odměny.",
"home.champTitle": "Naši nejlepší nalezci",
"how.eyebrow": "Jak to funguje",
"how.title": "Od odložení po vrácení, bez námahy.",
"inv.all": "Vše",
"inv.allYears": "Všechny roky",
"inv.count": "Faktury",
"inv.due": "splatné",
"inv.empty": "Zatím žádné faktury.",
"inv.exportCsv": "Exportovat CSV",
"inv.invoicePdf": "PDF faktura",
"inv.issued": "Vydáno",
"inv.noMatch": "Žádná faktura pro tento filtr.",
"inv.paid": "Zaplaceno (€)",
"inv.paidOn": "zaplaceno dne",
"inv.pay": "Platba",
"inv.receipt": "Osvědčení",
"inv.reminders": "Připomínky",
"inv.remindersDesc": "Emailové a SMS připomínky zaslané k této faktuře.",
"inv.remindersEmpty": "Žádná připomínka poslána.",
"inv.rmDue": "Připomínka termínu",
"inv.rmManual": "Manuální připomínka",
"inv.rmSms": "SMS připomínka D+30",
"inv.rmStage": "Připomínka",
"inv.statusPaid": "Zap pago",
"inv.statusUnpaid": "Nezaplaceno",
"inv.subtitle": "Zobrazte a stáhněte si své faktury a osvědčení.",
"inv.title": "Moje faktury",
"inv.unpaid": "Nezaplaceno (€)",
"inv2.contractTitle": "Moje Findloop smlouva",
"inv2.detailByEst": "Detail podle zařízení",
"inv2.dueLabel": "Splatné:",
"inv2.dueSuffix": " · splatné {date}",
"inv2.error": "Chyba {status}",
"inv2.estCountIssued": "{n} zařízení · vydáno {date}",
"inv2.estimate": "Odhad (neúčtováno) · {n} zařízení",
"inv2.expired": " · vypršelo",
"inv2.exportCsv": "Exportovat CSV",
"inv2.exportDone": "CSV export stažen",
"inv2.included": "Zahrnuto",
"inv2.monthlyTitle": "Měsíční fakturace (předplatné)",
"inv2.months": "+{n} měsíců",
"inv2.paid": "Zaplaceno",
"inv2.pay": "Platba",
"inv2.previewTitle": "Náhled vaší další faktury —",
"inv2.renew": "Obnovit moji smlouvu",
"inv2.renewalsTitle": "Historie obnov ({n})",
"inv2.renewedUntil": "Smlouva obnovena do {date}",
"inv2.serviceTitle": "Faktury za služby (vymáhání & nabídky)",
"inv2.soon": "Brzy vyprší",
"inv2.toPay": "K zaplacení",
"inv2.totalHtTva": "Celkem bez DPH · DPH",
"inv2.totalTtc": "Celkem včetně DPH",
"iu.addPhoto": "Přidat fotografii",
"iu.change": "Změnit",
"lang.label": "Jazyk",
"lb.allCountries": "Všechny země",
"lb.badge": "Roční žebříček",
"lb.champion": "🏆 Šampion roku",
"lb.cityPh": "Filtr podle města…",
"lb.empty": "Pro tyto filtry zatím žádné hodnocení.",
"lb.pts": "body",
"lb.resetNote": "Žebříček aktuálního roku — resetuje se každý 1. leden.",
"lb.returned": "vráceno",
"lb.share": "Sdílet žebříček",
"lb.shareText": "Podívejte se na žebříček nejlepších nálezců na Findloop!",
"lb.subtitle": "Každé vrácení earns points. Žebříček se resetuje každý 1. leden.",
"lb.tabFinders": "Nálezci",
"lb.tabPartners": "Zařízení",
"lb.title": "Nejlepší nálezci",
"lost.b2bDesc": "Ztratili jste to v hotelu, dopravním uzlu nebo partnerském místě? Najděte zařízení a nahlaste svou ztrátu.",
"lost.b2bTitle": "Nahlásit partnerovi",
"lost.b2cDesc": "Zveřejněte inzerát viditelný pro všechny, nabídněte odměnu a zvýrazněte ho, abyste maximalizovali své šance.",
"lost.b2cTitle": "Uveřejnit veřejný inzerát",
"lost.desc": "Zvolte, jak chcete pokračovat.",
"lost.title": "Ztratili jste věc?",
"map.allCategories": "Všechny kategorie",
"map.clear": "Obnovit",
"map.exitFullscreen": "Konec",
"map.filterCity": "Město nebo země…",
"map.fullscreen": "Celá obrazovka",
"map.heatmap": "Teplotní mapa",
"map.high": "Vysoké",
"map.impactMonth": "předměty vráceny tento měsíc",
"map.impactTotal": "vráceno celkem",
"map.legend": "Barevné tečky od červené (nízké) po zelenou (vysoké) podle míry vrácení; velikost podle počtu předmětů.",
"map.locating": "Určování polohy… přidejte adresu k vašim provozovnám, abyste je viděli na mapě.",
"map.low": "Nízké",
"map.mAll": "Vše",
"map.mFound": "Nalezeno",
"map.mLost": "Ztraceno",
"map.medium": "Střední",
"map.noItemRegistered": "Žádný předmět nenalezen",
"map.noItems": "Žádný předmět",
"map.period30": "Posledních 30 dní",
"map.period7": "Posledních 7 dní",
"map.period90": "Posledních 90 dní",
"map.periodAll": "Všechny časy",
"map.returnedSuffix": "vráceno · {a}/{t} předmětů",
"map.stats": "Statistiky města",
"map.statsTop": "Top 5 míst (ztracené předměty)",
"map.statsTrend": "6měsíční trend",
"map.title": "Mapa vašich provozoven",
"map.topPlaces": "Oblíbená místa",
"mc.adClosed": "Inzerát uzavřen",
"mc.addPhoto": "Přidat fotografii",
"mc.adsNone": "Žádný inzerát na ztracený předmět.",
"mc.archiveHide": "Skrýt historii",
"mc.archiveNone": "Žádný vyřešený případ zatím.",
"mc.archiveShow": "Zobrazit historii",
"mc.archiveSub": "Vyřešené a vrácené případy.",
"mc.archiveTitle": "Historie",
"mc.at": "Na",
"mc.backToLogin": "Zpět na přihlášení",
"mc.boostContacts": "Kontakty (zvýšit)",
"mc.boostViews": "Zobrazení (zvýšit)",
"mc.cancel": "Zrušit",
"mc.certificate": "Certifikát",
"mc.changePhoto": "Změnit fotografii",
"mc.city": "Město",
"mc.closeAd": "Zavřít",
"mc.closeAdConfirm": "Zavřít tento inzerát? Nebude již viditelný a uvolní místo.",
"mc.confirmPassword": "Potvrďte heslo",
"mc.confirmRestitution": "Potvrďte vrácení",
"mc.connect": "Připojit",
"mc.contacts": "Kontakty",
"mc.country": "Země",
"mc.declareFound": "Nahlásit nalezený předmět",
"mc.declareFoundSub": "Nabídnout nalezený předmět",
"mc.declareLost": "Nahlásit ztrátu",
"mc.declareLostSub": "Nabídnout inzerát na ztracený předmět",
"mc.deleteAccount": "Smazat můj účet",
"mc.deleteConfirm": "Ano, smazat můj účet",
"mc.deleteConfirmBody": "Váš účet bude trvale smazán a vaše osobní údaje anonymizovány. Tuto akci nelze vrátit zpět.",
"mc.deleteConfirmTitle": "Smazat váš účet?",
"mc.deleteDesc": "Trvale smaže váš účet a anonymizuje vaše osobní údaje. Tuto akci není možné vrátit zpět.",
"mc.deleted": "Váš účet byl smazán.",
"mc.deleting": "Mazání…",
"mc.email": "Email",
"mc.expiresOn": "Vyprší dne",
"mc.exportData": "Stáhnout má data (GDPR)",
"mc.exportDone": "Vaše data byla stažena.",
"mc.exporting": "Připravuje se…",
"mc.finderAccepted": "Akceptováno",
"mc.finderProfile": "Finder profil (volitelné)",
"mc.finderProfileDesc": "Získejte body vracením předmětů a objevte se na veřejném leaderboardu.",
"mc.forYourAd": "Pro váš inzerát",
"mc.forgotLink": "Zapomenuté heslo?",
"mc.forgotSend": "Odeslat odkaz",
"mc.forgotSent": "Pokud účet pro tento email existuje, právě byl odeslán odkaz pro obnovení.",
"mc.forgotTitle": "Zapomenuté heslo",
"mc.foundAdsNone": "Nebylo publikováno žádné oznámení o nalezeném předmětu.",
"mc.foundAt": "Nalezeno u",
"mc.foundNone": "Nebyly hlášeny žádné nalezené předměty.",
"mc.hAd": "Ztracené oznámení",
"mc.hDeclaration": "Prohlášení",
"mc.hFinderContact": "Nahlášený předmět",
"mc.hFound": "Vrácený předmět",
"mc.hFoundAd": "Oznámení o nalezeném předmětu",
"mc.histEarned": "Předmět vrácen",
"mc.historyTitle": "Historie mých bodů",
"mc.loginBtn": "Přihlásit se",
"mc.loginTitle": "Přihlášení zákazníka",
"mc.logout": "Odhlásit se",
"mc.lostAt": "Ztraceno dne",
"mc.matchPartner": "U partnera",
"mc.matchPublic": "Nalezený předmět",
"mc.matches": "Návrhy",
"mc.matchesSub": "Nalezené předměty mohou odpovídat vašim inzerátům ztracených předmětů.",
"mc.myAds": "Moje inzeráty na ztracené předměty",
"mc.myDeclarations": "Moje hlášení",
"mc.myFinds": "Předměty, které jsem našel",
"mc.myFindsNone": "Ještě jste nenahlásili žádný nalezený předmět.",
"mc.myFindsSub": "Předměty, které jste nahlásili jako nalezené na inzerátech ztracených předmětů.",
"mc.myFound": "Nahlášené nalezené předměty",
"mc.myFoundAds": "Moje inzeráty o nalezených předmětech",
"mc.myRewards": "Moje poukázky",
"mc.name": "Celé jméno",
"mc.newPassword": "Nové heslo",
"mc.none": "Žádné hlášení zatím není.",
"mc.notEnough": "Není dostatek bodů",
"mc.notifEmpty": "Žádné oznámení zatím není.",
"mc.notifOpen": "Zobrazit",
"mc.notifTitle": "Oznámení",
"mc.notifTrack": "Sledovat",
"mc.notifViewAd": "Zobrazit oznámení",
"mc.optInDesc": "Volitelná účast. Souhlasíte s veřejnou výdisplay předmětů vybraných níže. Měnitelné kdykoliv.",
"mc.optInTitle": "Objevit se na veřejném leaderboardu",
"mc.password": "Heslo",
"mc.passwordMismatch": "Hesla se neshodují.",
"mc.phone": "Telefon",
"mc.photoUpdated": "Profilový obrázek upraven",
"mc.pointsAwaiting": "Body čekající",
"mc.pointsBalance": "Body k utracení",
"mc.pointsOk": "Body připsány",
"mc.presentHint": "Zobrazte tento QR kód partnerovi: naskenuje ho, aby potvrdil vaši odměnu.",
"mc.presentInStore": "Zobrazit v obchodě",
"mc.presentTitle": "Zobrazit tento voucher",
"mc.privacy": "Ochrana soukromí & data",
"mc.privacyDesc": "Stáhněte si kopii všech osobních údajů, které o vás Findloop uchovává (GDPR, čl. 15 & 20).",
"mc.profileSaved": "Profil aktualizován.",
"mc.profileSettings": "Veřejný profil & žebříček",
"mc.pseudo": "Křestní jméno nebo přezdívka",
"mc.redExpired": "Expirace",
"mc.redReady": "Zobrazit u partnera",
"mc.redUsed": "Použito",
"mc.redeem": "Uplatnit",
"mc.registerBtn": "Vytvořit můj účet",
"mc.registerTitle": "Vytvořit zákaznický účet",
"mc.rememberMe": "Zapamatovat si mě",
"mc.remove": "Odstranit",
"mc.resetDone": "Heslo aktualizováno. Nyní se můžete přihlásit.",
"mc.resetExpired": "Tento odkaz na resetování je neplatný nebo vypršel. Požádejte o nový níže.",
"mc.resetSave": "Resetovat moje heslo",
"mc.resetTitle": "Nové heslo",
"mc.restitutionConfirmed": "Vrácení potvrzeno.",
"mc.reward": "Odměna",
"mc.rewardRedeemed": "Odměna odemčena! Kód:",
"mc.rewardsDesc": "Využijte své body na výhody nabízené našimi partnery. Zůstatek:",
"mc.rewardsNone": "Žádná odměna zatím není k dispozici.",
"mc.rewardsTitle": "Utratit mé body",
"mc.scoreAwarded": "Dobrá práce! +1 k vašemu Finder Score 🎉",
"mc.scoreEarned": "Bod získán",
"mc.scorePts": "b.",
"mc.scoreThisYear": "Tento rok",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Zobrazit žebříček",
"mc.share": "Sdílet",
"mc.statsTitle": "Statistiky",
"mc.subtitle": "Sledujte všechny své zprávy na jednom místě.",
"mc.title": "Můj účet",
"mc.toLogin": "Již registrováni?",
"mc.toRegister": "Ještě nemáte účet?",
"mc.track": "Sledovat",
"mc.views": "Zobrazení",
"mc.visCity": "Město",
"mc.visCountry": "Země",
"mc.visLabel": "Položky viditelné na žebříčku:",
"mc.visName": "Křestní jméno / přezdívka",
"mc.visPhoto": "Profilová fotografie",
"mc.welcome": "Ahoj",
"mc2.acceptFinder": "Přijmout tohoto findera",
"mc2.accountActivity": "Činnost účtu",
"mc2.adsActive": "{n}/5 aktivních inzerátů",
"mc2.autoDelete": "Automatické odstranění naplánováno na",
"mc2.badgeBronze": "Bronz",
"mc2.badgeGold": "Zlato",
"mc2.badgeSilver": "Stříbro",
"mc2.boostEarnedAlready": "Už vám to vydělalo",
"mc2.boostEarnedWin": "Vydělalo vám to",
"mc2.boostExpiredWin": "Váš boost právě vypršel — obnovte s -20%!",
"mc2.boostExpiresIn": "Váš boost vyprší za",
"mc2.boostWinDetail2": ". -20% automaticky uplatněno, pokud obnovíte do 24h.",
"mc2.claimCode": "Uplatnit kód:",
"mc2.codeSentFinder": "Kód odeslán finderovi e-mailem",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Stáhnout můj doklad",
"mc2.error": "Chyba {status}",
"mc2.finderAccepted": "Finder přijat — kód zaslán e-mailem",
"mc2.finderContacts": "Kontaktní údaje Finder(a)",
"mc2.followFindo": "Sledujte Findloop",
"mc2.imgInvalid": "Neplatný obrázek",
"mc2.inactivityNote": " — v případě {n} měsíců nečinnosti (GDPR).",
"mc2.lastActivity": "Poslední aktivita:",
"mc2.lostEmailTitle": "Nedostanu se už na svůj email",
"mc2.noPhotoPreset": "Žádná fotografie? Vyberte si výchozí avatar:",
"mc2.paidViaPartner": "Zap Paid (přes partnera)",
"mc2.payRecovery": "Zaplatit poplatek za obnovu",
"mc2.paySettle": "Uhradit moji platbu",
"mc2.payShipping": "Uhradit poplatek za dopravu",
"mc2.payUnavailable": "Platba není k dispozici",
"mc2.peopleFound": "{n} osoba(y) si myslí, že našli váš předmět",
"mc2.phoneNumber": "Telefonní číslo",
"mc2.reactivateAccount": "Znovu aktivovat můj účet",
"mc2.reactivated": "Účet znovu aktivován",
"mc2.reactivatedThanks": "Účet znovu aktivován — děkujeme za vaši loajalitu!",
"mc2.recoverSmsBtn": "Získat kód SMS",
"mc2.recoverSmsDesc": "Obdržte svůj kód nároku prostřednictvím SMS na číslo registrované ve vašem účtu.",
"mc2.recoverSmsFallback": "Pokud účet existuje s tímto číslem, SMS byla odeslána.",
"mc2.renewStayTop": ". Obnovte, abyste zůstali na vrcholu a obnovili svůj předmět.",
"mc2.resume20": "Pokračovat -20%",
"mc2.unlockContacts": "Odemknout kontaktní údaje",
"mc2.unlockDesc": "Zaplatiť poplatek za zpracování Findloop, abyste odhalili kontaktní údaje a domluvili se na předání.",
"mc2.viewsWord": "zobrazení",
"mc2.live": "Živě",
"mh.allCategories": "Všechny kategorie",
"mh.allPeriod": "Všechna doba",
"mh.autoMatch": "Automatické AI shodování",
"mh.blocked": "Zablokováno (rozpor)",
"mh.blockedReason": "Shoda zablokována: hlavní klíčová slova předmětu a prohlášení si navzájem odporují.",
"mh.days30": "Posledních 30 dní",
"mh.days7": "Posledních 7 dní",
"mh.days90": "Posledních 90 dní",
"mh.emptyDesc": "AI shody se zde objeví, jakmile dojdou prohlášení.",
"mh.emptyTitle": "Žádné události",
"mh.exportCsv": "Exportovat CSV",
"mh.exportDone": "CSV export stažen",
"mh.exportImpossible": "Export selhal",
"mh.fBlocked": "Zablokováno",
"mh.fConfirmed": "Potvrzeno",
"mh.fRejected": "Odmítnuto",
"mh.objectLabel": "Předmět:",
"mh.refresh": "Obnovit",
"mh.rejected": "Odmítnuto",
"mh.srcManual": "Manuální",
"mh.srcText": "Text",
"mh.srcVisual": "Vizuální (foto)",
"mh.subtitle": "Záznam o shodách navržených AI — automaticky shodný, potvrzený a odmítnutý.",
"mh.title": "Historie AI",
"nav.ads": "Ztracené předměty",
"nav.dashboard": "Můj prostor",
"nav.found": "Nalezené předměty",
"nav.how": "Jak to funguje",
"nav.login": "Přihlásit se",
"nav.map": "Mapa",
"nav.more": "Více",
"nav.partners": "Partneři",
"nav.pricing": "Ceny",
"nav.ranking": "Žebříček",
"nav.register": "Staňte se partnerem",
"nav.track": "Sledovat prohlášení",
"nf.desc": "Stránka, kterou hledáte, neexistuje nebo byla přesunuta.",
"nf.home": "Zpět na domovskou stránku",
"nf.title": "Stránka nenalezena",
"par.allCities": "Všechna města",
"par.allCountries": "Všechny země",
"par.badge": "Adresář",
"par.certified": "Certifikovaný",
"par.certifiedBadge": "Certifikovaný",
"par.cityPh": "Město",
"par.declare": "Nahlásit",
"par.none": "Žádný partner nenalezen.",
"par.partnerBadge": "Partner",
"par.searchPh": "Hledat zařízení…",
"par.subtitle": "Najděte zařízení, kde jste ztratili svou položku, a nahlaste svou ztrátu.",
"par.title": "Naši partneři",
"pay.addr1": "Adresa",
"pay.addr2": "Adresa řádek 2 (volitelně)",
"pay.addrIncomplete": "Vyplňte prosím svou dodací adresu.",
"pay.badge": "Obnova",
"pay.card": "Platba kartou",
"pay.city": "Město",
"pay.country": "Země",
"pay.eurNote": "Částky uvedené v eurech (€).",
"pay.fee": "Poplatek za obnovu",
"pay.free": "zdarma",
"pay.howRecover": "Jak byste chtěli získat svou položku zpět?",
"pay.momo": "Platba přes Mobilní peníze",
"pay.momoConfirm": "Potvrdit platbu",
"pay.noMatch": "Žádná odpovídající položka pro tuto zprávu zatím nebyla potvrzena.",
"pay.notfound": "Zpráva nenalezena.",
"pay.phonePh": "Telefonní číslo",
"pay.pickup": "Osobní vyzvednutí",
"pay.pickupDesc": "Na",
"pay.postal": "PSČ",
"pay.secure": "Bezpečná platba",
"pay.serviceFee": "Findloop poplatek za služby",
"pay.ship": "Doručit mi",
"pay.shipAfter": "— nabídka po platbě.",
"pay.shipDesc": "Doručení na moji adresu",
"pay.shipNote": "Doprava k dispozici",
"pay.shipping": "Dopravní poplatek",
"pay.subtitleWith": "Zaplaťte poplatek za obnovu k",
"pay.title": "Obnovit svou položku",
"pay.total": "Celkem",
"pcat.city_hall": "Městské úřady",
"pcat.hotel": "Hotely",
"pcat.other": "Jiné",
"pcat.park": "Parky",
"pcat.prefecture": "Kanceláře prefektur",
"pcat.restaurant": "Restaurace",
"pcat.uncategorized": "Nekategorizováno",
"pd.about": "O nás",
"pd.back": "Všichni partneři",
"pd.certified": "Certifikovaný partner",
"pd.declare": "Nahlaste ztrátu zde",
"pd.itemsReturned": "vrácené položky",
"pd.itemsTotal": "registrované položky",
"pd.map": "Umístění",
"pd.noItems": "Nebyly nalezeny žádné položky.",
"pd.noReviews": "Žádné recenze zatím.",
"pd.notFound": "Partner nenalezen.",
"pd.recentItems": "Nedávno nalezené položky",
"pd.reply": "Odpověď od zařízení",
"pd.reviews": "Recenze zákazníků",
"pd.verified": "Ověřená recenze",
"pd.verifiedEstablishment": "ověřené zařízení Findloop",
"pg.next": "Další",
"pg.prev": "Předchozí",
"pg.showing": "{from}–{to} z {total}",
"pk.bodyCopy": "Text těla",
"pk.bodyText": "Tělový text",
"pk.brandColors": "Barvy značky",
"pk.colorRed": "Červená",
"pk.colorWhite": "Bílá",
"pk.darkBg": "Tmavé pozadí",
"pk.download": "Stáhnout",
"pk.downloadZip": "Stáhnout celý balíček (ZIP)",
"pk.headings": "Nadpisy",
"pk.heroDesc": "Oficiální loga, bannery na sociálních sítích, barvy a typografie. Vyberte jazyk a variantu sloganu, poté stáhněte vizuál nebo celý balíček.",
"pk.lightBg": "Světlé pozadí (tisk)",
"pk.logoWordmark": "Logo / označení značky",
"pk.logosVisuals": "Loga a vizuály",
"pk.mapCollect": "Místa sběru / mapy",
"pk.plain": "Jednoduché",
"pk.pressKit": "Tiskový balíček",
"pk.taglineLang": "Jazyk sloganu",
"pk.typography": "Typografie",
"pk.variant": "Varianta",
"pr.shipBtn": "Nechat položku zaslat",
"pr2.adBoostMsg": "Skvělá volba! Zvyšujete šance na rychlé nalezení vaší položky.",
"pr2.boostActivated": "Zvýšení aktivováno!",
"pr2.canRecoverNow": "Nyní můžete svou položku získat zpět.",
"pr2.continue": "Pokračovat",
"pr2.downloadReceiptPdf": "Stáhnout účtenku (PDF)",
"pr2.goToSpaceNow": "Přejít na můj účet nyní",
"pr2.partnerBoostMsg": "Skvělá volba! Vyšší viditelnost znamená přilákat nové zákazníky do vašeho zařízení.",
"pr2.paymentSuccess": "Platba úspěšná!",
"pr2.redirectingSpace": "Přesměrování na váš účet…",
"pr2.subActivated": "Platba úspěšná! Vaše předplatné je aktivní, nyní můžete spravovat svá zařízení.",
"prev.allSites": "Všechna zařízení",
"prev.editReply": "Upravit odpověď",
"prev.none": "Žádná recenze zatím.",
"prev.published": "Odpověď publikována",
"prev.reply": "Odpověď",
"prev.replyPh": "Napište slušnou odpověď…",
"prev.send": "Publikovat odpověď",
"prev.sending": "Publikování…",
"prev.yourReply": "Vaše odpověď",
"pricing.annual": "Roční",
"pricing.annualBadge": "-20% nabídka",
"pricing.choose": "Vyberte",
"pricing.compareFeature": "Funkce",
"pricing.compareTitle": "Porovnat plány",
"pricing.eyebrow": "Ceny",
"pricing.month": "/měsíc",
"pricing.monthly": "Měsíčně",
"pricing.perYear": "/rok",
"pricing.popular": "Oblíbené",
"pricing.quoteMsg": "Vaše potřeby (nepovinné)",
"pricing.quoteOrg": "Organizace",
"pricing.quoteSend": "Odeslat žádost",
"pricing.quoteSent": "Žádost odeslána! Brzy se vám ozveme.",
"pricing.quoteSites": "Počet míst / terminálů",
"pricing.quoteTitle": "Žádost o cenovou nabídku",
"pricing.requestQuote": "Žádost o cenovou nabídku",
"pricing.saveLabel": "Ušetříte",
"pricing.savePerYear": "/rok na každou další pobočku",
"pricing.start": "Začít",
"pricing.subtitle": "Začněte zdarma, rozšiřujte se, jak rostete.",
"pricing.title": "Plán pro každou organizaci",
"promo.badge": "Partnerský program",
"promo.cta": "Zjistit více",
"promo.text": "Každý partner, kterého doporučíte a který se přihlásí, vám přinese jeden měsíc zdarma. Bez limitu.",
"promo.title": "Doporučte partnera, získejte měsíc zdarma.",
"pub.accessGranted": "Přístup povolen",
"pub.accessLimited2h": "Přístup omezen na 2 hodiny",
"pub.accountEmailConcerned": "Email dotčeného účtu",
"pub.adAppearPublic": "Takto se vaše reklama zobrazí veřejně.",
"pub.adPreviewBtn": "Náhled reklamy",
"pub.alertMeOnArrival": "Upozornit mě na příjezd",
"pub.allActionsLogged": "Všechny akce jsou zaznamenány",
"pub.allCategories": "Všechny kategorie",
"pub.authorizeAccess": "Povolit přístup",
"pub.authorizeSupportQ": "Povolit přístup k podpoře?",
"pub.available": "Dostupné",
"pub.backHome": "Zpět na domovskou stránku",
"pub.boostAdCta": "Podpořit moji reklamu",
"pub.boostAdTitle": "Podpořte svou reklamu",
"pub.boostCarouselSub": "Přesuňte se na vrchol stránky v „Podporovaném“ karuselu a znásobte zhlédnutí, abyste rychleji vrátili svůj položku.",
"pub.boostEstablishment": "Podpořit svou pobočku",
"pub.boostEstablishmentDesc": "Zobrazte se na vrcholu adresáře s odznakem „Podporováno“ a přitáhněte více zpráv.",
"pub.boostFicheCta": "Podpořit můj záznam",
"pub.brandReady": " značka Findloop, připravena k použití",
"pub.cantFindItem": "Nemůžete najít svou položku?",
"pub.cantProcessImage": "Nelze zpracovat tento obrázek",
"pub.claimQr": "Převzít QR kód",
"pub.clickToZoom": "Klikněte pro zvětšení",
"pub.codeAlreadyValidated": "Kód ověřen – kontakty odemčeny.",
"pub.codeExample": "např. ABCD2345",
"pub.confirmRenewal": "Potvrdit obnovení",
"pub.contactIntro": "Dotaz, žádost? Napište nám, brzy se vám ozveme.",
"pub.contactTypeDeceased": "Zrušení účtu (zemřelá osoba)",
"pub.contactTypeGeneral": "Obecný dotaz",
"pub.contactTypeSupport": "Podpora / technický problém",
"pub.contactUs": "Kontaktujte nás",
"pub.continueWithoutEmail": "Pokračovat bez opuštění mého emailu",
"pub.contractLabel": "Smlouva",
"pub.contractNotFound": "Smlouva nenalezena nebo již vypršela.",
"pub.contractRenewed": "Smlouva obnovena!",
"pub.contractRenewedFor": "Vaše smlouva byla obnovena na {n} měsíců.",
"pub.copyFailed": "Kopie se nezdařila",
"pub.createPartnerAccount": "Vytvořit můj partnerský účet",
"pub.currentDeadline": "Aktuální termín",
"pub.deceasedInfo": "Jako příbuzný nebo dědic můžete požádat o zrušení účtu Findloop zemřelé osoby. Vaši žádost zpracujeme v souladu s GDPR (mohou být vyžadovány podpůrné dokumenty).",
"pub.declareMyLoss": "Oznámit mou ztrátu",
"pub.describeItemPlaceholder": "Popište svůj předmět (např. černé deštník, klíče…)",
"pub.downloadImage": "Stáhnout obrázek",
"pub.drawSignature": "Prosím, nakreslete svůj podpis.",
"pub.drawSignatureHint": "Nakreslete svůj podpis myší nebo prstem.",
"pub.duration": "Doba trvání",
"pub.eSignature": "Elektronický podpis",
"pub.eSignatureDesc": "Zadejte své jméno pro podepsání. Datum bude zaznamenáno automaticky.",
"pub.edit": "Upravit",
"pub.editorialTitles": "Redakční názvy",
"pub.emailPlaceholder": "vy@example.com",
"pub.enterCodeUnlockOwner": "Zadejte kód, který jste obdrželi e-mailem, k odemknutí kontaktních údajů majitele.",
"pub.errorWord": "Chyba",
"pub.foundSelfService": "Nalezené předměty · Služba pro uživatele",
"pub.haveOwnerCode": "Obdržel jsem kód od majitele",
"pub.home": "Domů",
"pub.immediateRenewal": "Okamžité obnovení, bez nového lejstra.",
"pub.impAdminReq1": "Administrátor",
"pub.impAdminReq2": "požaduje povolení k dočasnému přístupu do vašeho účtu",
"pub.impAdminReq3": "aby vám mohl pomoci.",
"pub.impGrantedDesc": "Tým podpory bude mít přístup k vašemu účtu maximálně na 2 hodiny. Každá akce bude zaznamenána. Tuto stránku můžete zavřít.",
"pub.invitedOnFindo": "Jste pozváni do Findloop",
"pub.isThisYourItem": "Je to váš předmět?",
"pub.itemsAvailableCount": "Aktuálně k dispozici {n} předmět(y)",
"pub.itemsFoundOwner": "důvěřovaných předmětů našlo svého majitele",
"pub.itemsReturnedOwners": "předměty vrácené jejich majitelům",
"pub.itsMine": "Je to moje",
"pub.joinFindoDesc": "Připojte se k Findloop a snadno spravujte své nalezené předměty.",
"pub.joinInvitesYou": "vás zve k připojení k findloop. Vytvořte si partnerský účet, abyste mohli spravovat své nalezené předměty.",
"pub.linkCopied": "Odkaz zkopírován!",
"pub.loadingContract": "Načítání smlouvy…",
"pub.lsClaimDesc": "Nahlaste svou ztrátu, abyste ji obnovili. Zanechte svůj e-mail a my vám pošleme připomínku, pokud váš hlášení nebude dokončeno.",
"pub.lsHeroDesc": "Zkontrolujte si sami, zda byl váš ztracený předmět nalezen a ponechán zde. Našli jste ho? Nahlaste ho, abyste ho obnovili.",
"pub.lsSearchTitle": "Vyhledávání nalezených předmětů",
"pub.makeOffer": "Udělejte nabídku",
"pub.makeOfferDesc": "Navrhněte svou částku. Superadmin ji zkontroluje.",
"pub.mapNearYou": "Předměty a partneři ve vaší blízkosti",
"pub.mapWord": "Mapa",
"pub.messageSentToast": "Zpráva odeslána — náš tým brzy odpoví.",
"pub.messageWord": "Zpráva",
"pub.momoInitiated": "Platba Mobile Money byla zahájena",
"pub.monthsWord": "měsíců",
"pub.nameConsentRequired": "Jméno a souhlas potřebné.",
"pub.newDeadline": "Nový termín",
"pub.noActionRequired": "Není potřeba žádná akce.",
"pub.noAmountCharged": "Nebyla účtována žádná částka.",
"pub.noItemMatch": "V tuto chvíli neexistuje žádný dostupný předmět, který by odpovídal vašemu vyhledávání.",
"pub.noMatchingItem": "Žádný odpovídající předmět",
"pub.noPaymentSession": "Žádná platební relace.",
"pub.noPhoto": "Žádný obrázek",
"pub.noPointsYet": "Zatím žádné body k zobrazení.",
"pub.noSecondPayment": "Žádná druhá platba není pro tento předmět vyžadována.",
"pub.notHereYet": "Ještě tady není? Buďte informováni, jakmile dorazí.",
"pub.notifyDone": "Poznamenáno! Oznámíme vám e-mailem, jakmile dorazí odpovídající předmět.",
"pub.offerSubmitted": "Vaše nabídka byla odeslána.",
"pub.oops": "Omlouváme se",
"pub.orAlertEmail": "Nebo buďte informováni e-mailem, jakmile dorazí odpovídající předmět:",
"pub.ownerContacts": "Kontaktní údaje majitele",
"pub.ownerContactsUnlocked": "Kontaktní údaje majitele odemčeny",
"pub.partnerContact": "Kontaktní informace partnera",
"pub.payLinkUnavailable": "Odkaz na platbu není k dispozici — kontaktujte partnera.",
"pub.paymentCancelled": "Platba byla zrušena",
"pub.paymentConfirmed": "Platba potvrzena 🎉",
"pub.paymentConfirmedDesc": "Obdržíte e-mail s podrobnostmi k obnovení vaší položky.",
"pub.paymentNotConfirmed": "Platba nebyla potvrzena",
"pub.paymentNotConfirmedDesc": "Platbu se nepodařilo ověřit. Zkuste to znovu nebo kontaktujte partnera.",
"pub.paymentProcessing": "Platba se zpracovává. Obnovte za chvíli.",
"pub.photoAdded": "✓ Fotografie přidána",
"pub.photoRequired": "Je nutná fotografie položky.",
"pub.previewAlt": "náhled",
"pub.publish": "Publikovat",
"pub.publishingWord": "Publikuji…",
"pub.qty": "Množství",
"pub.quoteDeclined": "Nabídka byla odmítnuta.",
"pub.quoteNotFound": "Nabídka nebyla nalezena nebo vypršela.",
"pub.reasonLabel": "Důvod",
"pub.recoveryAlreadyPaid": "Poplatek za obnovu již zaplacen",
"pub.referralCode": "Slevový kód:",
"pub.relationshipPlaceholder": "Syn, manžel, notář…",
"pub.renewYourContract": "Obnovte svou smlouvu",
"pub.renewalFailed": "Obnova se nezdařila. Zkuste to znovu později.",
"pub.renewing": "Obnovuji…",
"pub.replySoon": "Náš tým odpoví co nejdříve.",
"pub.requestGone": "Tento požadavek již neexistuje.",
"pub.requestHandled": "Požadavek již vyřízen",
"pub.requestNotFound": "Požadavek nebyl nalezen nebo vypršel.",
"pub.requestUnavailable": "Požadavek není k dispozici",
"pub.required": "(povinné)",
"pub.retroClosing": "Společně děláme svět o něco méně ztraceným.",
"pub.retroClosing2": "Společně děláme svět o něco méně ztraceným.",
"pub.retroScroll": "Rok obnovování toho, na čem záleží. Přejděte dolů ↓",
"pub.revokeAnytime": "Zrušit můžete kdykoli tím, že nás kontaktujete",
"pub.scene": "Scéna",
"pub.sendImpossible": "Odeslání není možné",
"pub.sendMessage": "Odeslat zprávu",
"pub.sending": "Odesílám…",
"pub.sharePreview": "Sdílet náhled",
"pub.shareYourAd": "Sdílet vaši reklamu",
"pub.signedSuccess": "Úspěšně podepsáno!",
"pub.signerFullName": "Celé jméno podpisujícího",
"pub.spreadNetwork": "Sdílejte to s lidmi kolem vás pro zvýšení vašich šancí.",
"pub.spreadOwner": "Sdílejte to, abyste pomohli majiteli obnovit jeho věci.",
"pub.statusLabel": "Stav:",
"pub.subject": "Předmět",
"pub.thanksSent": "Děkujeme, vaše zpráva byla odeslána.",
"pub.thisYear": "Tento rok",
"pub.validate": "Ověřit",
"pub.verifyingPayment": "Ověřuji platbu…",
"pub.verifyingYourPayment": "Ověřuji vaši platbu…",
"pub.viewAd": "Zobrazit reklamu →",
"pub.viewPartner": "Zobrazit partnera →",
"pub.yourAdPreview": "Náhled vaší reklamy",
"pub.yourEmail": "Váš e-mail",
"pub.yourEmailRecommended": "Váš e-mail (doporučeno)",
"pub.yourEmailShort": "Váš e-mail",
"pub.yourName": "Vaše jméno",
"pub.yourRelationship": "Váš vztah k osobě",
"qv.acceptAndSign": "Akceptovat a podepsat moji nabídku",
"qv.certifyAuthorized": "Potvrzuji, že jsem oprávněn podepsat a akceptuji podmínky tohoto {what} (závazná hodnota).",
"qv.clear": "Vymazat",
"qv.client": "Klient",
"qv.conditions": "Podmínky",
"qv.confirmDecline": "Potvrdit odmítnutí tohoto nabídky?",
"qv.countersignedFindo": "Odsouhlasené Findloop · {name} dne {date}",
"qv.decline": "Odmítnout",
"qv.description": "Popis",
"qv.downloadPdf": "Stáhnout PDF",
"qv.handwrittenSignature": "Ruční podpis",
"qv.inclTax": "Vrát. daně",
"qv.invalidAmount": "Neplatná částka.",
"qv.invoice": "Faktura",
"qv.invoicePaid": "Faktura zaplacena",
"qv.issuer": "Vydavatel",
"qv.messageOptional": "Zpráva (volitelné)",
"qv.negotiatedAmount": "Vyjednaná částka",
"qv.payInvoiceOnline": "Zaplatit fakturu online",
"qv.quote": "Nabídka",
"qv.quoteValidDays": "Nabídka platná po {n} dnech.",
"qv.sendMyOffer": "Odeslat moji nabídku",
"qv.signContract": "Podepsat moji smlouvu",
"qv.signNow": "Podepsat nyní",
"qv.signatureAlt": "Podpis",
"qv.signedByOn": "✔ Podepsáno {name} dne {date}",
"qv.stContractSigned": "Smlouva podepsána. Děkujeme!",
"qv.stCounterAccepted": "Vaše nabídka byla přijata! Podepište svou smlouvu níže.",
"qv.stCounterRefused": "Vaše nabídka nemohla být přijata.",
"qv.stCountered": "Vaše nabídka byla odeslána. Čeká se na odpověď findloop.",
"qv.stDeclined": "Tuto nabídku jste odmítli.",
"qv.stSigned": "Nabídka přijata a podepsána. Děkujeme!",
"qv.totalHt": "Celkem bez DPH",
"qv.totalTtc": "Celkem vč. DPH",
"qv.unitHt": "Jednotka bez DPH",
"qv.vat": "DPH",
"qv.yourProposedAmount": "Vaše navrhovaná částka ({cur})",
"rate.chooseNote": "Prosím, vyberte hodnocení.",
"rate.commentPh": "Komentář (volitelné)…",
"rate.home": "Zpět na domovskou stránku",
"rate.submit": "Odeslat moji recenzi",
"rate.submitting": "Odesílání…",
"rate.subtitle": "Jak probíhala obnova vašeho předmětu?",
"rate.successText": "Vaše zpětná vazba pomáhá ostatním uživatelům.",
"rate.successTitle": "Děkujeme za vaši recenzi!",
"rate.title": "Ohodnoťte svůj zážitek",
"reg.add": "Zaregistrovat předmět",
"reg.allBrands": "Všechny značky",
"reg.allColors": "Všechny barvy",
"reg.allLocations": "Všechny lokace",
"reg.detailDesc": "Podrobnosti a akce pro tento nalezený předmět.",
"reg.dispAuction": "Aukce",
"reg.dispAuthorities": "Předáno úřadům",
"reg.dispDestroyed": "Zničen",
"reg.dispDonate": "Charitativní dar",
"reg.dispositionHint": "Zaznamenejte odchod předmětu ze skladu. Započítáno ve statistikách podle kategorie.",
"reg.emptyCta": "Zaregistrovat předmět",
"reg.emptyDesc": "Začněte registrací svého prvního nalezeného předmětu.",
"reg.emptyTitle": "Žádné nalezené předměty",
"reg.establishmentFallback": "zařízení",
"reg.lblAuctioned": "uvedeno na aukci",
"reg.lblAuctionedShort": "aukce",
"reg.lblAuthorities": "předáno úřadům",
"reg.lblDestroyed": "zničeno",
"reg.lblDonated": "darováno na charitu",
"reg.legalCount": "{n} položka(y): uplynula právní doba uchování",
"reg.legalHint": "Můžete je nabídnout na aukci, darovat na charitu nebo nahlásit předání úřadům.",
"reg.legalLimitCountry": "Termín: {date} · použité země: {country}",
"reg.legalOver": "Termín uplynul: {date} · {country}",
"reg.legalReached": "Právní doba uplynula",
"reg.legalReachedFull": "Právní doba uchování uplynula",
"reg.limitShort": "termín",
"reg.location": "Umístění",
"reg.markRestituted": "Označit jako vrácené",
"reg.markedAs": "Položka označena jako {label}",
"reg.moveHistory": "Historie pohybu",
"reg.overBy": "o {n}d",
"reg.physicalLocation": "Fyzické umístění",
"reg.popupBlocked": "Povolte vyskakovací okna pro tisk štítků.",
"reg.popupBlockedOne": "Povolte vyskakovací okna pro tisk štítku.",
"reg.printLabel": "Tisknout štítek",
"reg.printN": "Tisknout {n} štítek(y)",
"reg.qrCodeItem": "QR kód položky",
"reg.qrLabelTitle": "QR štítek",
"reg.qrLabelsTitle": "QR štítky",
"reg.qrNotFound": "Žádná položka nenalezena pro tento QR kód.",
"reg.qrScanHint": "Naskenujte ho, abyste otevřeli tuto položku přímo a našli umístění.",
"reg.recoveryFee": "Poplatek za obnovení (€)",
"reg.searchPh": "Hledat podle popisu…",
"reg.selectQr": "Vyberte pro tisk QR štítků",
"reg.selectedN": "{n} vybráno",
"reg.shipPricePh": "Cena přepravy (€)",
"reg.shippingPossible": "Doprava k dispozici",
"reg.storagePh": "např. Policie A3, Skříňka 12",
"reg.tAuction": "Aukce na Findloop",
"reg.tAuthorities": "Nahlásit předání úřadům",
"reg.tDonate": "Darovat na charitu",
"reg.toastFee": "Poplatek aktualizován",
"reg.toastLocation": "Umístění uloženo",
"reg.toastRestituted": "Položka označena jako vrácená",
"reg.toastShipping": "Možnost dopravy aktualizována",
"reg.toastTransferred": "Položka převedena na “{name}”",
"reg.unclaimedDisposition": "Nepřijatá položka — konečná dispozice",
"res.codeValidated": "Kód ověřen",
"res.empty": "Zatím nebyla zaznamenána žádná restituce.",
"res.error": "Chyba {status}",
"res.proofPdf": "PDF důkaz",
"res.signed": "Podepsáno",
"res.stRestituted": "Předáno osobně",
"res.stShipped": "Vráceno zasláním",
"res.subtitle": "Všechny dokončené předání, se stažitelným podepsaným důkazem.",
"res.title": "Historie restitucí",
"rev.b2b": "B2B partneři",
"rev.b2c": "Zákazníci",
"rev.based": "na základě {n} recenzí",
"rev.eyebrow": "Reference",
"rev.restitutedBy": "Vráceno {org}",
"rev.storiesEyebrow": "Šťastné konce",
"rev.storiesSubtitle": "Skutečné příběhy od zákazníků, kteří získali své věci zpět s findloop.",
"rev.storiesTitle": "Našli své věci!",
"rev.subtitle": "Partneři a zákazníci sdílejí své zkušenosti.",
"rev.title": "Důvěřují Findloop",
"rev.verified": "Ověřeno",
"rp.already": "Tuto nabídku jste již nahlásili.",
"rp.comment": "Podrobnosti (nepovinné)",
"rp.duplicate": "Duplikát",
"rp.fraud": "Podvod / podvod",
"rp.inappropriate": "Nevhodný obsah",
"rp.offensive": "Útočný obsah",
"rp.other": "Jiné",
"rp.reason": "Důvod",
"rp.report": "Nahlásit",
"rp.send": "Odeslat hlášení",
"rp.sent": "Hlášení odesláno. Děkujeme za váš příspěvek.",
"rp.spam": "Spam / reklama",
"rp.title": "Nahlásit tento inzerát",
"rp.wrongCategory": "Špatná kategorie",
"rt.annualGoal": "Roční cíl",
"rt.championCity": "Město šampionů",
"rt.cityRate": "{rate}% míra návratnosti",
"rt.goalProgress": "{rate}% splněno z {target}% cíle",
"rt.reached": "Dosaženo 🎉",
"rt.restitutionRate": "Míra návratnosti",
"rt.shareRecap": "Sdílet mé shrnutí",
"rt.thanks": "Děkujeme Findloop {year} 💛",
"rt.yourRecap": "Vaše shrnutí {year}",
"rw.active": "Aktivní",
"rw.add": "Přidat",
"rw.camUnavailable": "Kamera není dostupná. Zadejte kód ručně níže.",
"rw.codeValidated": "Kód ověřen",
"rw.codesTitle": "Kódy vyměněné nálezci",
"rw.confirmDelete": "Smazat „{title}“?",
"rw.deleted": "Smazáno",
"rw.edit": "Upravit",
"rw.editReward": "Upravit odměnu",
"rw.empty": "Žádná odměna zatím.",
"rw.expired": "Expirace",
"rw.expiresOn": "Expiruje {date}",
"rw.fActive": "Aktivní (viditelné pro nálezce)",
"rw.fCost": "Náklady (body)",
"rw.fDesc": "Popis",
"rw.fStock": "Sklad (prázdné = neomezené)",
"rw.fTitle": "Název",
"rw.fValidity": "Platnost voucheru (dny po uplatnění)",
"rw.inactive": "Neaktivní",
"rw.newReward": "Nová odměna",
"rw.noExchange": "Žádná výměna zatím.",
"rw.pageSubtitle": "Naskenujte vouchery předložené nálezci k ověření jejich odměn.",
"rw.redeemedN": "Uplatněno: {n}×",
"rw.saved": "Odměna uložena",
"rw.scanVoucher": "Naskenujte voucher",
"rw.staffScanOnly": "Skener pouze",
"rw.statActive": "K prezentaci",
"rw.statExpired": "Expirace",
"rw.statRedeemed": "Vouchery uplatněny",
"rw.statUsed": "Ověřeno",
"rw.stock": "Sklad",
"rw.subtitle": "Nabídněte nemonetární výhody (vouchery, upgrady…) které nálezci uplatní za své body Finder Score.",
"rw.title": "Odměny pro nálezce",
"rw.used": "Použito",
"rw.validate": "Ověřit",
"rw.validateCode": "Ověřit kód",
"rw.validity": "Platnost: {n} d",
"shell.f1d": "Automaticky propojovat ztracené a nalezené předměty.",
"shell.f1t": "Chytré AI párování",
"shell.f2d": "Sledujte míru vrácení a příjmy v reálném čase.",
"shell.f2t": "Panel & příjmy",
"shell.f3d": "Vaši zákazníci hlásí do 30 sekund.",
"shell.f3t": "QR kód partnera",
"shell.title": "Přeměňte ztracené předměty na spokojené zákazníky.",
"ship.addr1": "Adresa",
"ship.addr2": "Adresa řádku 2 (volitelné)",
"ship.badge": "Doprava",
"ship.city": "Město",
"ship.country": "Země",
"ship.needPaid": "Nejprve zaplaťte poplatek za vyzvednutí, abyste požádali o dopravu.",
"ship.notShippable": "Tento předmět není možné zaslat.",
"ship.notfound": "Zpráva nebyla nalezena.",
"ship.postal": "PSČ",
"ship.price": "Poplatek za dopravu",
"ship.submit": "Požádat o dopravu",
"ship.submitting": "Odesílám…",
"ship.subtitle": "Zadejte svou doručovací adresu.",
"ship.successText": "Partner připraví váš balíček. Budete informováni, jakmile bude odeslán.",
"ship.successTitle": "Žádost o dopravu odeslána!",
"ship.title": "Nechte si zaslat svůj předmět",
"ship.weight": "Odhadovaná hmotnost (kg)",
"shp.carrier": "Dopravce",
"shp.download": "Stáhnout PDF",
"shp.generating": "Generuji…",
"shp.label": "Vytvořit štítek",
"shp.none": "Nebylo požadováno žádné zaslání.",
"shp.setTracking": "Uložit sledování",
"shp.status": "Stav",
"shp.to": "Příjemce",
"shp.tracking": "Sledovací číslo",
"shp.trackingSaved": "Sledování uloženo",
"side.account": "Můj účet",
"side.declarations": "Zprávy",
"side.deposit": "Zaregistrovat předmět",
"side.establishments": "Zřízení",
"side.invoices": "Faktury",
"side.logout": "Odhlásit se",
"side.matchHistory": "Historie AI",
"side.partner": "Partner",
"side.refresh": "Obnovit",
"side.registry": "Registr",
"side.restitutions": "Vrátí",
"side.reviews": "Hodnocení",
"side.rewards": "Odměny & Vouchery",
"side.settings": "Nastavení",
"side.shipments": "Zásilky",
"side.stats": "Statistiky",
"side.storage": "Úložiště & QR",
"side.team": "Tým",
"side.viewSite": "Zobrazit veřejnou stránku",
"st.auctioned": "Prodáno v aukci",
"st.claimed": "Uplatněno",
"st.closed": "Uzavřeno",
"st.delivered": "Doručeno",
"st.destroyed": "Zničeno",
"st.donated": "Darováno (charita)",
"st.handed_to_authorities": "Předáno úřadům",
"st.in_storage": "Ve skladě",
"st.matched": "Nalezeno",
"st.open": "Otevřít",
"st.paid": "Zaplaceno",
"st.pending": "Čeká na",
"st.resolved": "Vyřešeno",
"st.restituted": "Vráceno",
"st.second_chance": "Druhá šance",
"st.shipped": "Odesláno",
"st.shipping_requested": "Odeslání požadováno",
"st.submitted": "Odesláno",
"st.verified": "Ověřeno",
"stat.items": "Registrované položky",
"stat.partners": "Partneři",
"stat.restituted": "Vrácené položky",
"status.auctioned": "Prodáno v aukci",
"status.destroyed": "Zničeno",
"status.donated": "Darováno (na charitu)",
"status.handed_to_authorities": "Předáno úřadům",
"status.in_storage": "Na skladě",
"status.matched": "Shoda",
"status.open": "Otevřít",
"status.paid": "Zaplaceno",
"status.pending": "Čeká na",
"status.restituted": "Vráceno",
"status.shipped": "Odesláno",
"status.shipping_requested": "Odeslání požadováno",
"status.submitted": "Odesláno",
"step1.tag": "Zřízení",
"step1.text": "Během několika sekund zřízení zaregistruje nalezenou položku s fotografií, kategorií a popisem. Vše je centralizováno v přehledném a bezpečném registru.",
"step1.title": "Partner registruje položku",
"step2.tag": "Zákazník",
"step2.text": "Pomocí QR kódu partnera popisuje váš zákazník ztracenou položku během 30 sekund. Žádná aplikace k instalaci — vše probíhá v prohlížeči.",
"step2.title": "Zákazník hlásí ztrátu",
"step3.tag": "Inteligence",
"step3.text": "Náš chytrý párovací systém porovnává popisy a navrhuje nejpravděpodobnější shody, připravené k potvrzení.",
"step3.title": "AI propojuje ztrátu a nalezenou položku",
"step4.tag": "Obnovení",
"step4.text": "Po bezpečné platbě poplatku za obnovení si zákazník vyzvedne položku na místě — nebo ji obdrží zaslanou s sledováním.",
"step4.title": "Zákazník dostane svou položku zpět",
"stg.allLabels": "Všechny QR štítky",
"stg.camHint": "Použijte manuální zadání níže.",
"stg.camStarting": "Zahajuji kameru…",
"stg.camUnavailable": "Kamera není k dispozici.",
"stg.clear": "Vymazat",
"stg.clearAll": "Vymazat vše",
"stg.codeUnreadable": "Nečitelný kód.",
"stg.emptyDesc": "Uložené položky se zde objeví, seskupené podle umístění.",
"stg.emptyTitle": "Žádná položka na skladě",
"stg.exportAudit": "Exportovat audit CSV",
"stg.exportDone": "CSV export stažen",
"stg.exportImpossible": "Export aktuálně není k dispozici.",
"stg.itemFound": "Položka nalezena ✅",
"stg.kLocations": "Použitá umístění",
"stg.kObjects": "Uložené položky",
"stg.kToClear": "Umístění k vymazání",
"stg.locFreed": "Umístění vymazáno",
"stg.locsFreed": "{n} umístění uvolněna",
"stg.manualLabel": "Nebo zadejte kód / ID položky",
"stg.manualPh": "Vložte ID nebo URL QR",
"stg.noItemMatch": "Žádná položka neodpovídá tomuto QR / kódu.",
"stg.noLocation": "Žádná poloha",
"stg.objectsAxis": "Položky",
"stg.objectsN": "{n} položka(y)",
"stg.occAvg": "průměr {n} položek/poloha",
"stg.occHint": "Lokace se žlutým symbolem překračují průměr (potenciálně přetížené).",
"stg.occupancy": "Obsazenost lokace",
"stg.openPage": "Otevřít stránku",
"stg.posterPdf": "PDF plakát (A4)",
"stg.printAll": "Tisknout vše",
"stg.printGroupTitle": "Tisknout štítky pro tuto polici",
"stg.qrAlt": "Samozřejmý QR",
"stg.qrDownload": "Stáhnout QR",
"stg.qrHint": "Zobrazte tento QR na pultě: vaši zákazníci ho naskenují, aby zkontrolovali, zda je jejich položka dostupná.",
"stg.qrTitle": "QR pro samoservis zákazníků",
"stg.scanDesc": "Naskenujte štítek položky pro okamžité otevření jejího záznamu.",
"stg.scanQr": "Naskenovat QR",
"stg.scanTitle": "Naskenovat QR kód",
"stg.search": "Hledat",
"stg.shelf": "Police {loc}",
"stg.shelfPlan": "Plán police",
"stg.staleHint": "Vyčistěte tyto lokace, abyste udrželi fyzickou inventuru aktuální.",
"stg.staleTitle": "{n} položka(y) opustily sklad, ale stále mají lokaci",
"stg.subtitle": "Plán police, skener QR a sledování fyzické inventury.",
"stg.title": "Sklad & QR",
"stt.acceptRate": "Míra akceptace",
"stt.accepted": "Akceptováno",
"stt.activity30": "Aktivita (posledních 30 dní)",
"stt.ai6mo": "Posledních 6 měsíců · akceptováno = automaticky spojeno + potvrzeno.",
"stt.aiEmpty": "Za toto období zatím žádné AI shody.",
"stt.aiTitle": "Shody AI — akceptované vs. odmítnuté",
"stt.auctionShort": "Aukce",
"stt.auctionedSold": "Aukce (prodáno)",
"stt.authShort": "Úřady",
"stt.authorities": "Předáno úřadům",
"stt.avgRating": "Průměrné hodnocení",
"stt.awaitingRestitution": "položky čekající na vrácení",
"stt.boostClicks": "Kliknutí na váš adresář tento týden díky zvýšení",
"stt.boostInactive": "Zvýšení neaktivní — povolte jej pro dosažení viditelnosti",
"stt.certifiedPremium": "Certifikováno jako prémiové",
"stt.declarations": "Prohlášení",
"stt.destroyed": "Zničeno",
"stt.dispoEmpty": "Zatím žádná nevyzvednutá položka neopustila sklad.",
"stt.donatedAssoc": "Darováno (charita)",
"stt.donatedShort": "Darováno",
"stt.gateCta": "Objevte plány",
"stt.gateDesc": "Přejděte na Starter a odemkněte své základní statistiky, nebo na Business pro pokročilé statistiky a analýzu podle zařízení.",
"stt.gateTitle": "Statistiky vyhrazené pro placené plány",
"stt.inStorage": "Ve skladu",
"stt.kItems": "Registrované položky",
"stt.kRate": "Míra vracení",
"stt.kRestituted": "Vracené položky",
"stt.kRevenue": "Příjmy (měsíc)",
"stt.noDeclYet": "Zatím žádná prohlášení.",
"stt.recapDownloaded": "Rekapitulace stažena — připravena k sdílení!",
"stt.recapError": "Nelze vygenerovat rekapitulaci",
"stt.recapText": "Naše Findloop rekapitulace {year}: vrácené položky a spokojenost zákazníků 🎉",
"stt.recapTitle": "Findloop rekapitulace {year}",
"stt.rejected": "Odmítnuto",
"stt.restitutions": "Vrácení",
"stt.shareRecap": "Sdílet moji rekapitulaci za {year}",
"stt.topCategories": "Nejvíce deklarované kategorie",
"stt.unclaimedDesc": "Objem předmětů zničených, darovaných na charitu aaukcionovaných podle kategorie.",
"stt.unclaimedTitle": "Nepřijaté předměty — vyklizení skladu",
"stt.vsLastWeek": "oproti minulému týdnu",
"sub.cancel": "Zrušit mé předplatné",
"sub.cancelAbort": "Zrušit",
"sub.cancelConfirm1": "Opravdu si přejete zrušit? Váš přístup zůstane aktivní do",
"sub.cancelConfirm2": "Nebude vydána žádná náhrada.",
"sub.cancelConfirmBtn": "Potvrdit zrušení",
"sub.cancelTitle": "Zrušit vaše předplatné",
"sub.cancelledToast": "Zrušení zaznamenáno.",
"sub.cguAnd": "a",
"sub.cguDesc": "Potvrďte prosím svůj souhlas před platbou.",
"sub.cguLink": "Podmínky používání",
"sub.cguPay": "Pokračovat k platbě",
"sub.cguPre": "Přečetl(a) jsem a souhlasím s",
"sub.cguRequired": "Musíte přijmout Podmínky používání a Zásady ochrany osobních údajů, abyste mohli pokračovat.",
"sub.cguSuffix": "společnosti findloop.",
"sub.cguTitle": "Dokončit vaše předplatné",
"sub.expiresOn": "Vaše předplatné vyprší",
"sub.noProrata": "Žádná pro-rata náhrada.",
"sub.privacyLink": "Zásady ochrany osobních údajů",
"sub.renewsOn": "Vaše předplatné se obnoví",
"sub.resume": "Znovu předplatit",
"sub.resumedToast": "Znovupředplatné potvrzeno.",
"tier.free": "Bezplatný",
"tier.large": "Podniková",
"tier.medium": "Obchodní",
"tier.small": "Začátečník",
"tm.add": "Přidat",
"tm.adminOpt": "Admin (plný přehled)",
"tm.chooseEst": "Vyberte zařízení",
"tm.chooseEstPh": "Vyberte zařízení",
"tm.copyFail": "Kopírování selhalo",
"tm.copyLink": "Kopírovat odkaz",
"tm.copyOk": "Odkaz na pozvání zkopírován",
"tm.emailHint": "E-mail s pozvánkou bude odeslán k vytvoření hesla.",
"tm.expiresOn": "vyprší {date}",
"tm.forEmail": " pro {email}",
"tm.forbidden": "Správa týmu je vyhrazena pro vlastníka účtu.",
"tm.inviteCreated": "Pozvání vytvořeno",
"tm.inviteDesc": "E-mail s pozvánkou umožní členovi týmu vytvořit jejich heslo.",
"tm.invitePending": "Pozvání čeká",
"tm.inviteResent": "Pozvání znovu odesláno",
"tm.inviteSent": "Pozvání odesláno e-mailem",
"tm.inviteTitle": "Pozvat člena",
"tm.invitedOn": "Pozváno dne {date}",
"tm.linkExpired": "Odkaz vypršel",
"tm.memberRemoved": "Člen odstraněn",
"tm.name": "Jméno",
"tm.noMembers": "Zatím žádný člen týmu.",
"tm.resendTitle": "Znovu odeslat pozvání",
"tm.role": "Role",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Majitel",
"tm.roleStaff": "Zaměstnanec",
"tm.roleUpdated": "Role aktualizována",
"tm.sendInvite": "Odeslat pozvání",
"tm.sending": "Odesílání…",
"tm.staffOpt": "Zaměstnanec (vidí jen své zařízení)",
"trk.at": "Na",
"trk.badge": "Sledování",
"trk.carrier": "Dopravce",
"trk.codeValidated": "Kód ověřený partnerem",
"trk.dlProof": "Stáhnout můj důkaz o předání (PDF)",
"trk.emailLabel": "Email (volitelné — pro zobrazení vašich údajů)",
"trk.enterEmailCode": "Zadejte svůj email výše pro zobrazení vašeho kódu pro reklamaci.",
"trk.idLabel": "Číslo hlášení",
"trk.lostEmail": "Již nemám přístup k mému emailu",
"trk.phonePh": "Vaše telefonní číslo",
"trk.photoBefore": "Fotografie položky před odesláním",
"trk.recoverBtn": "Obnovit moji položku",
"trk.recoverHint": "Získejte svůj kód pro reklamaci prostřednictvím SMS na vašem registrovaném čísle.",
"trk.searching": "Hledání…",
"trk.secureRest": "Bezpečné předání",
"trk.send": "Odeslat",
"trk.shipPending": "Zásilka je připravována — sledovací číslo se zde objeví jakmile bude odesláno.",
"trk.shipTitle": "Sledování zásilky",
"trk.showQr": "Zobrazte tento QR kód partnerovi pro ověření předání",
"trk.sigSaved": "Podpis uložen",
"trk.signFirst": "Nejprve prosím podepište před potvrzením.",
"trk.signProof": "Podepište svůj důkaz o předání",
"trk.signSubmit": "Potvrďte svůj podpis a vygenerujte PDF",
"trk.submit": "Sledovat",
"trk.subtitle": "Zadejte své číslo hlášení pro sledování průběhu.",
"trk.title": "Sledovat mé hlášení",
"trk.trackShipment": "Sledovat balík",
"trk.trackingNo": "Sledovací číslo",
"trk.yourCode": "Váš kód pro reklamaci (pro partnera)",
"hc.paidViaPartner": "Zaplaceno (přes partnera)",
"hc.parcelBeingPrepared": "Balík se připravuje",
"hc.parcelDelivered": "Balík doručen",
"hc.parcelShipped": "Balík odeslán",
"hc.parisGareDeLyon": "Paříž, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Adresář partnerů",
"hc.passedOnToTheCustomer": "— předáno zákazníkovi platební odkaz.",
"hc.password": "Heslo",
"hc.passwordResetPleaseLogIn": "Obnovení hesla, prosím, přihlaste se.",
"hc.passwordUpdated": "Heslo aktualizováno.",
"hc.passwordsDoNotMatch": "Hesla se neshodují.",
"hc.pasteThisSenderIdIn": "Vložte toto ID odesílatele do Findloop → Nastavení",
"hc.payForTheShipmentOf": "Zaplaťte za odeslání vaší položky přes Findloop s bezpečnou platbou.",
"hc.payTheRecoveryFees": "Zaplaťte poplatky za obnovu",
"hc.payTheShippingFees": "Zaplaťte poplatky za dopravu",
"hc.payment": "Platba",
"hc.paymentAlreadyConfirmedByThe": "Platba již potvrzena partnerem",
"hc.paymentLinksAreNowConfigured": "Platby odkazy jsou nyní nastaveny podle zařízení",
"hc.paymentNotCompletedYourAccount": "Platba nebyla dokončena, váš účet nebyl vytvořen — zkuste to prosím znovu.",
"hc.paymentReceived": "Platba přijata",
"hc.paymentSuccessful": "Platba úspěšná!",
"hc.pdfInvoice": "PDF faktura",
"hc.pending": "Čekající",
"hc.period": "Období",
"hc.phoneNumber": "Telefonní číslo",
"hc.phoneOptional": "Telefon (volitelné)",
"hc.planAt": "plán na",
"hc.planLimitFmt": "Váš plán \"{plan}\" je omezen na {max} zařízení. Pro správu {n} míst doporučujeme",
"hc.platformReturnTarget": "Cíl návratu platformy",
"hc.pleaseCompleteYourShippingAddress": "Prosím, vyplňte svou adresu pro dodání.",
"hc.pleaseProvideAPhoneNumber": "Prosím, poskytněte telefonní číslo: je to požadováno dopravcem pro odeslání.",
"hc.pleaseProvideAReason": "Prosím, poskytněte důvod.",
"hc.pleaseSetYourOwnPassword": "prosím nastavte své vlastní heslo před pokračováním.",
"hc.pointsToGoal": "{n} další body k dosažení našeho společného cíle.",
"hc.posterPreview": "Náhled plakátu",
"hc.potentialMatchBeingVerified": "Ověřuje se potenciální shoda",
"hc.potentialOwner": "Potenciální vlastník",
"hc.preFilledAutomaticallyYouCan": "Předvyplněno automaticky — můžete to nahradit fotografií balíku.",
"hc.nArchived": "{n} inzerování archivováno.",
"hc.newCodeGeneratedAndSent": "Nový kód byl vygenerován a odeslán zákazníkovi e-mailem a SMS",
"hc.newCodeGeneratedAndSent2": "Nový kód byl vygenerován a odeslán vlastníkovi",
"hc.newPassword": "Nové heslo",
"hc.next": "Další",
"hc.nextPhoto": "Další fotografie",
"hc.no": "Ne",
"hc.noAnswerProvided": "Nebyla poskytnuta žádná odpověď.",
"hc.noArchivedDeclarations": "Žádná archivovaná prohlášení",
"hc.noCountryFound": "Žádná země nenalezena",
"hc.noDeclarations": "Žádná prohlášení",
"hc.noFeesAreChargedTo": "Žádné poplatky nejsou účtovány zákazníkovi.",
"hc.noInvoiceYet": "Žádná faktura zatím.",
"hc.noInvoiceYetYourInvoices": "Žádná faktura zatím. Vaše faktury se zde automaticky objeví po každé platbě.",
"hc.noMatchIsAvailableFor": "Žádná shoda zatím není k dispozici. Jakmile se objeví položka, která odpovídá vašemu prohlášení, dáme vám vědět.",
"hc.noShipmentMatchesYourSearch": "Žádná zásilka neodpovídá vašemu vyhledávání.",
"hc.noShipmentsYet": "Žádné zásilky zatím.",
"hc.noShipmentsYet2": "Žádné zásilky zatím",
"hc.none": "žádné",
"hc.noneChooseForEachShipment": "Žádné (vyberte pro každou zásilku)",
"hc.notMine": "Není to moje",
"hc.of": "z",
"hc.only": "Pouze",
"hc.onlyEachSiteManagesIts": "pouze. Každá stránka spravuje své vlastní bankovnictví: tyto odkazy nemají vliv na žádnou jinou provozovnu.",
"hc.onlyTheOwnerOrAn": "Pouze vlastník nebo správce může nakonfigurovat platební odkazy provozovny.",
"hc.openDepositInTheMenu": "Otevřete \"Vklad\" v nabídce, popište položku a pořiďte fotografii. Je okamžitě uložena a připravena k vrácení.",
"hc.openSettings": "Otevřít Nastavení →",
"hc.openTheDeclarationToManage": "Otevřít prohlášení pro správu zásilky",
"hc.optional": "— volitelné",
"hc.optional2": "(volitelné)",
"hc.optional3": "volitelné",
"hc.originalListingPhotoUsed": "Použitá původní fotografie inzerátu",
"hc.other": "Jiné",
"hc.other2": "Jiné…",
"hc.ourProducts": "Naše produkty",
"hc.overallRateTrendLast6": "Celkový trend sazeb (posledních 6 měsíců)",
"hc.ownerSClaimCode": "Kód nároku vlastníka",
"hc.ownershipConfirmed": "Vlastnictví potvrzeno",
"hc.paid": "Zaplaceno",
"hc.paidOn": "Zaplaceno dne",
"hc.pressKit": "Tiskový kit",
"hc.previewMode": "Režim náhledu:",
"hc.previewOfThePrintReady": "Náhled tiskového A4 plakátu pro tuto instituci.",
"hc.previous": "Předchozí",
"hc.previousPhoto": "Předchozí foto",
"hc.primary": "primární",
"hc.printThePoster": "Tisknout plakát",
"hc.privacy": "Ochrana soukromí",
"hc.privacyPolicy": "Zásady ochrany soukromí",
"hc.processedCasesWillAppearHere": "Zpracované případy se objeví zde.",
"hc.proofOfReturnPdf": "Doklad o vrácení (PDF)",
"hc.protectedByRecaptcha": "Chráněno reCAPTCHA",
"hc.publicMatch": "Veřejný zápas",
"hc.putBackInStorage": "Vrátit zpět do úložiště",
"hc.pwdResetByTeam": "Vaše heslo bylo resetováno naším týmem. Pro vaši bezpečnost,",
"hc.questionsToAskTheOwner": "Otázky k položení majiteli",
"hc.rateChargedToTheCustomer": "Sazba účtovaná zákazníkovi:",
"hc.rateOfTarget": "{rate}% dosaženo z {target}% cíle",
"hc.reached": "dosaženo",
"hc.reactivating": "Reaktivace…",
"hc.reasonSavedYouCanStill": "Důvod uložen. Svůj předmět stále můžete uplatnit.",
"hc.recentMatchesFirst": "Nedávné zápasy nejprve",
"hc.recognizedThePhotoYouSent": "rozpoznal fotografii, kterou jste poslali, a popsal tyto charakteristiky. Potvrďte pouze, pokud odpovídají předmětu ve vašem držení.",
"hc.recommended": "Doporučeno",
"hc.recoveryFees": "Poplatky za zisk",
"hc.recoveryFeesArePaidDirectly": "Poplatky za zisk jsou placeny přímo partneru instituce. Findloop od zákazníků žádnou platbu nedostává.",
"hc.recoveryFeesEnabled": "Poplatky za zisk povoleny",
"hc.recoveryOfferedByTheEstablishment": "Obnovení nabízené institucí — Findloop neúčtuje žádné poplatky.",
"hc.recoveryPaymentLink": "Odkaz na platbu za obnovu",
"hc.recoveryPaymentLinkSavedFor": "Odkaz na platbu za obnovu uložen pro tuto instituci",
"hc.redirecting": "Přesměrování…",
"hc.redirectingToPayment": "Přesměrování na platbu…",
"hc.redirectingToTheRecoveryOf": "Přesměrování na obnovu vašeho předmětu…",
"hc.regenerateAndResendToThe": "Znovu vygenerovat a znovu odeslat majiteli",
"hc.regenerateTheCode": "Znovu vygenerovat kód",
"hc.registerAFoundItem": "Registrovat nalezený předmět",
"hc.rejectTheClaim": "Zamítnout nárok",
"hc.reminderDelaySaved": "Zpoždění připomenutí uloženo",
"hc.reopenThePaymentLink": "Znovu otevřít platební odkaz",
"hc.repeatThePassword": "Opakujte heslo",
"hc.reportAProblem": "Nahlásit problém",
"hc.reportDismissedYourListingRemains": "Nahlášení zamítnuto. Vaše nabídka zůstává veřejná.",
"hc.requiredUsedToCalculateThe": "Povinné: používá se k výpočtu ceny za dopravu Sendcloud. Doprava není k dispozici nad 30 kg.",
"hc.reset": "Obnovit",
"hc.resume": "Pokračovat",
"hc.resumeRegistration": "Pokračovat v registraci",
"hc.retro": "Rok v přehled",
"hc.returnSecurity": "Bezpečnost vrácení",
"hc.returnToTheOwner": "Vrátit majiteli",
"hc.returned": "vráceno",
"hc.reviewTheItemDetails": "Zkontrolovat podrobnosti o položce",
"hc.revokeAccess": "Odebrat přístup",
"hc.role": "Role:",
"hc.save": "Uložit",
"hc.save2": "uložit",
"hc.saveAndContinue": "Uložit a pokračovat",
"hc.saving": "Ukládání…",
"hc.scanTheClaimCode": "Naskenovat kód žádosti",
"hc.scanTheOwnerSQr": "Naskenovat QR kód majitele",
"hc.scrollThroughLanguages": "Procházet jazyky",
"hc.searchByCustomerItemOr": "Hledat podle zákazníka, položky nebo sledovacího čísla…",
"hc.searchForACountry": "Hledat zemi…",
"hc.secureFindoVerification": "Zabezpečená verifikace Findloop",
"hc.seeRetro": "Podívejte se na rok v přehled",
"hc.selectedCarrier": "Vybraný dopravce:",
"hc.selectedPlan": "Vybraný plán",
"hc.send": "Odeslat",
"hc.sendcloudSenderIdSaved": "ID odesílatele Sendcloud uloženo",
"hc.sendcloudSenderIdSenderId": "ID odesílatele Sendcloud (sender_id)",
"hc.sending": "Odesílání…",
"hc.sessionExpired": "Platnost relace vypršela",
"hc.setUpYourEstablishments": "Nastavte své provozovny",
"hc.settings": "Nastavení",
"hc.settingsSubtitle": "Externí platby a připomínky, nastavené podle provozovny.",
"hc.shareFoundText": "Našel jsem položku — pomozte mi najít jejího majitele na Findloop",
"hc.shareLostText": "Ztratil jsem položku — pomozte mi ji najít na Findloop",
"hc.sharePreview": "Sdílet náhled",
"hc.shareTheRanking": "Sdílet hodnocení",
"hc.shareYourQrCodeTo": "Sdílejte svůj QR kód pro příjem prohlášení.",
"hc.shipRateAutoWeight": "Cena za dopravu je automaticky vypočítána prostřednictvím Sendcloud (hmotnost {w}) v době odeslání.",
"hc.shipRateForWeight": "Cena za dopravu (Sendcloud + {m}% marže) pro {w}:",
"hc.shipments": "Zásilky",
"hc.shipmentsSubtitle": "Konsolidovaný přehled všech zásilek podniku, napříč všemi případy. Klikněte na řádek pro správu zásilky v jejím prohlášení.",
"hc.shipping": "Doprava",
"hc.shippingAddress": "Doručovací adresa",
"hc.shippingFeesAreHandledAutomatically": "Poplatky za dopravu jsou automaticky zpracovány Findloop (Sendcloud) — není třeba zadávat odkaz.",
"hc.shippingFeesHaveAlreadyBeen": "Poplatky za dopravu byly již zaplaceny: dopravce již nelze změnit.",
"hc.shippingNotAvailableForItems": "Doprava není dostupná pro položky nad 30 kg. Zákazník si musí vyzvednout položku osobně.",
"hc.shippingPaid": "Doprava zaplacena ✓",
"hc.showOnlyItemsMatchingA": "Zobrazit pouze položky odpovídající veřejnému (zákaznickému) seznamu",
"hc.showPassword": "Zobrazit heslo",
"hc.signInTheBoxAbove": "Přihlaste se v poli výše",
"hc.signatureSaved": "Podpis uložen",
"hc.signedInWithGoogle": "Přihlášeno přes Google",
"hc.signupFailed": "Registrace se nezdařila",
"hc.silver": "Stříbrný",
"hc.simulatedRatesInPreProduction": "(simulované sazby v předvýrobě)",
"hc.siretAndVatNumberRequired": "Je vyžadováno číslo SIRET a DPH (Francie).",
"hc.skip": "Přeskočit",
"hc.smsSentIfAccount": "Pokud účet s tímto číslem existuje, bylo vám zasláno SMS.",
"hc.sortItemsWithAPublic": "Třídit: položky s veřejnou shodou (nejnovější) první",
"hc.specifyWhetherYouRecoveredYour": "Uveďte, zda jste si svou položku vyzvedli nebo jen chcete odstranit tento inzerát.",
"hc.specifyYourReason": "Uveďte svůj důvod",
"hc.specifyYourReason2": "Uveďte svůj důvod…",
"hc.staff": "Personál",
"hc.status": "Stav",
"hc.staySignedIn": "Zůstat přihlášen",
"hc.step": "Krok",
"hc.stillThere": "Pořád tam?",
"hc.stopScrolling": "Zastavit posouvání",
"hc.storeFindWithQr": "Uložit & najít pomocí QR",
"hc.streetName": "Název ulice",
"hc.streetNo": "Číslo ulice",
"hc.switchTo": "Přepnout na",
"hc.switchToDarkMode": "Přepnout na tmavý režim",
"hc.switchToLightMode": "Přepnout na světlý režim",
"hc.takeAPhoto": "Pořídit fotografii",
"hc.takeChangeThePhoto": "Pořídit / změnit fotografii",
"hc.takenFromYourDeclaration": "pořízeno z vašeho prohlášení",
"hc.target": "Cíl",
"hc.targetReached": "Cíl dosažen",
"hc.targetReachedThankYouTo": "Cíl dosažen — děkujeme celé komunitě Findloop!",
"hc.tellUsMore": "Řekněte nám více…",
"hc.tellUsWhyYouCancel": "Řekněte nám, proč rušíte. To pomůže partnerovi zpracovat váš požadavek.",
"hc.tellUsWhyYourListing": "Řekněte nám proč. Váš inzerát zůstává aktivní a můžete si stále nárokovat svou položku.",
"hc.termsAndConditions": "Podmínky",
"hc.termsAndPolicies": "Podmínky a pravidla",
"hc.thankYouForYourFeedback": "Děkujeme za vaši zpětnou vazbu",
"hc.theBannerDisplayedInThe": "banner zobrazený v registru.",
"hc.theClaimantHasBeenInformed": "Odpovědná osoba byla informována. Položka zůstává dostupná v veřejném seznamu.",
"hc.theClaimantHasBeenNotified": "Odpovědná osoba byla informována a nyní může pokračovat s vrácením.",
"hc.theCustomerPaysTheFees": "Zákazník hradí poplatky podniku.",
"hc.theDayTheLegalRetention": "Den, kdy byl dosažen zákonný retenční termín.",
"hc.theEstablishmentConsideredThatThis": "Podnik považoval tuto položku za vaši.",
"hc.theEstablishmentIsReviewingYour": "Podnik přezkoumává vaše odpovědi. Budete informováni, jakmile bude váš nárok potvrzen, poté můžete zaplatit poplatky za obnovení.",
"hc.theFeesAreTooHigh": "Poplatky jsou příliš vysoké",
"hc.theFinderConsideredThatThis": "Nálezce považoval tuto položku za vaši.",
"hc.theFinderIsReviewingYour": "Nálezce přezkoumává váš nárok. Budete informováni, jakmile bude potvrzen.",
"hc.theItem": "Položka",
"hc.theItemWillBeRemoved": "Položka bude odstraněna z registru (žádný nárok není v procesu).",
"hc.theItemWillBeSet": "Položka bude nastavena zpět na \"skladem\" a související nárok bude zrušen.",
"hc.theKbisNumberAndVat": "Číslo Kbis a DPH jsou požadovány pro Francii.",
"hc.theLabelIsGeneratedAutomatically": "Štítek je generován automaticky, jakmile zákazník zaplatil poplatky za dopravu. Bude ke stažení zde.",
"hc.theLinkMayHaveExpired": "Odkaz mohl vypršet (platný po dobu 30 dnů). Pokud je to potřeba, kontaktujte podporu findloop.",
"hc.theOwnerDescribesTheirItem": "Majitel popisuje svou položku",
"hc.theOwnerReceivedItBy": "Majitel to obdržel e-mailem (nebo SMS). Zadejte nebo naskenujte to před předáním.",
"hc.thePartnerConsideredThatThis": "Partner považoval tuto položku za vaši. Položka zůstává dostupná.",
"hc.thePartnerIsReviewingYour": "Partner přezkoumává vaše odpovědi. Budete informováni, jakmile bude váš nárok potvrzen.",
"hc.theShipmentIsCreatedAutomatically": "Zásilka je automaticky vytvořena, jakmile zákazník potvrdil svou adresu a zaplatil poplatky za obnovení. Štítek bude poté vygenerován automaticky po zaplacení dopravy a bude k dispozici ke stažení zde.",
"hc.theShippingRateWillBe": "Poplatek za dopravu bude automaticky vypočítán přes Sendcloud v době odeslání (zaznamenaná hmotnost).",
"hc.thisCarrierWillBe": "Tento dopravce bude",
"hc.thisEstablishment": "tento podnik",
"hc.thisFieldIsRequiredFor": "Toto pole je povinné pro automatickou generaci štítku.",
"hc.thisIsMyItem": "Tohle je moje položka",
"hc.thisIsMyItemContinue": "Tohle je moje položka — pokračovat",
"hc.thisIsMyItemStart": "Tohle je moje položka — zahájit vrácení",
"hc.thisIsNotMyItem": "Tohle není moje položka",
"hc.thisMatchIsNoLonger": "Tento nárok již není dostupný nebo byl již zpracován.",
"hc.thisRateWillBeCharged": "Tato sazba bude účtována zákazníkovi. Vysoká sazba může odradit od vrácení.",
"hc.thisStepIsRequiredFor": "Tento krok je nezbytný pro generaci zásilkových štítků.",
"hc.thisValidationLinkIsInvalid": "Tento validační odkaz je neplatný nebo vypršel.",
"hc.toCheckBeforeMarkingThe": "Zkontrolujte před označením položky jako vrácené.",
"hc.toConfigureTheLinksAnd": "konfigurovat odkazy a zpoždění připomenutí pro každé zařízení.",
"hc.toReachOurFirstMilestone": "dosáhnout našeho prvního cíle 100 vrácení.",
"hc.toTheCustomer": "zákazníkovi.",
"hc.toTheShippingFeePayment": "k platbě za přepravní poplatek.",
"hc.toYourRecoveryTracking": "k sledování vašeho zotavení.",
"hc.tooExpensiveBudget": "Příliš drahé / rozpočet",
"hc.topCitiesForReturns": "Nejlepší města pro vrácení",
"hc.trackMyRecovery": "Sledovat své zotavení",
"hc.trackTheShipmentAndDownload": "Sledujte zásilku a stáhněte štítek (generováno automaticky) bez opuštění záložky Prohlášení.",
"hc.trackYourStatistics": "Sledujte své statistiky",
"hc.tracking": "Sledování",
"hc.unableToOpenTheShipping": "Nelze otevřít platbu za přepravní poplatek. Zkuste prosím znovu.",
"hc.unableToRetrieveTheInvoice": "Nelze načíst fakturu.",
"hc.unclaimed": "Nepřevzato",
"hc.unclaimedCustomerReason": "Nepřevzatá položka. Důvod zákazníka: \"{reason}\".",
"hc.unclaimedItem": "Nepřevzatá položka",
"hc.unclaimedItemNoClaimWithin": "Nepřevzatá položka — žádný nárok v termínu.",
"hc.unclaimedItems": "Nepřevzaté položky",
"hc.unclaimedItemsMatchLeftWithout": "Nepřevzaté položky: shoda zůstala bez nároku v termínu. Můžete je vrátit zpět do skladu.",
"hc.unlockTheFinderSContact": "Odemkněte kontaktní údaje nálezce pro domluvení předání.",
"hc.upcoming": "Nadcházející",
"hc.updateFailed": "Aktualizace selhala.",
"hc.usedForInvoices": "Použito k vydání vašich Findloop faktur.",
"hc.vatNumber": "DIČ",
"hc.verificationPending": "Ověření probíhá",
"hc.verificationSentToTheFinder": "Ověření bylo odesláno nálezci. Budete informováni o jeho rozhodnutí.",
"hc.verificationSentToThePartner": "Ověření bylo odesláno partnerovi. Budete informováni o jeho rozhodnutí.",
"hc.verify": "Ověřit",
"hc.verifyingInvite": "Ověřování odkazu na pozvánku…",
"hc.verifyingTheLink": "Ověřování odkazu…",
"hc.viewInRegistry": "Zobrazit v registru",
"hc.viewItem": "Zobrazit položku",
"hc.viewItemRecover": "Zobrazit položku a obnovit",
"hc.visibleToTheOwnerAutomatically": "Viditelné pro vlastníka · automaticky smazáno po 60 dnech.",
"hc.waitingForPartnerConfirmation": "Čekání na potvrzení partnera",
"hc.waitingForThePartnerS": "Čekání na potvrzení partnera",
"hc.weHaveInformedTheEstablishment": "Informovali jsme zařízení, že tato položka není vaše a restartovali analýzu. Budete informováni, jakmile bude nalezena nová shoda.",
"hc.weHaveInformedThePartner": "Informovali jsme partnera, že tato položka není vaše. Váš seznam zůstává aktivní pro budoucí shody.",
"hc.weRanTheAnalysisAgain": "Analýzu jsme znovu provedli a identifikovali další položku, která by mohla být vaše. Prosím, zkontrolujte to znovu.",
"hc.weight": "Hmotnost",
"hc.weightNotProvidedTheShipping": "Hmotnost není uvedena: cena za dopravu bude vypočtena v době odeslání.",
"hc.weightUnit": "Jednotka hmotnosti",
"hc.welcome": "Vítejte!",
"hc.welcomeToFindo": "Vítejte ve Findloop",
"hc.whenACustomerComesTo": "Když zákazník přijde vyzvednout své věci, otevřete jeho prohlášení a potvrďte vrácení. A to je vše!",
"hc.whenDisabledFeesDropTo": ". Když je zakázáno, poplatky klesnou na",
"hc.whyIsThisNotYour": "Proč to není vaše položka?",
"hc.willBeMarkedAs": "bude označeno jako",
"hc.wrongColor": "Špatná barva",
"hc.wrongModel": "Špatný model",
"hc.yesCancel": "Ano, zrušit",
"hc.yesContactTheFinder": "Ano, kontaktovat nálezce",
"hc.youAreHere": "Jste zde",
"hc.youBusinessCom": "vy@firma.com",
"hc.youCanNowStartThe": "Nyní můžete začít s vracením.",
"hc.youCanStillChangeIt": ". Můžete to stále změnit případ od případu.",
"hc.youHaveAlreadyConfirmedThat": "Už jste potvrdili, že toto je vaše položka.",
"hc.youWillBeRedirectedTo": "Budete přesměrováni na zabezpečenou platbu přes Stripe.",
"hc.yourAccountHasBeenReactivated": "Váš účet byl znovu aktivován.",
"hc.yourAccountIsActiveYou": "Váš účet je aktivní, nyní můžete spravovat své provozovny.",
"hc.yourEstablishment": "Vaše provozovna",
"hc.yourFeedbackHelpsUsImprove": "Vaše zpětná vazba nám pomáhá zlepšovat naše shody.",
"hc.yourFeedbackHelpsUsRestart": "Vaše zpětná vazba nám pomáhá znovu spustit analýzu a zlepšit naše shody.",
"hc.yourFirstSteps": "Vaše první kroky",
"hc.yourFirstStepsAdmin": "Vaše první kroky (administrátor)",
"hc.yourItemHasBeenHanded": "Vaše položka byla předána osobně partnerem - uzavřete případ, jakmile bude předání potvrzeno.",
"hc.yourItemHasBeenShipped": "Vaše položka byla odeslána partnerem - uzavřete případ, jakmile bude dodání potvrzeno.",
"hc.yourPaymentHasBeenRecorded": "Vaše platba byla zaznamenána.",
"hc.yourShipmentIsBeingPrepared": "Vaše zásilka je připravována. Obdržíte svůj balíček během 3 až 5 pracovních dnů.",
"hc.yourShippingFeesHaveAlready": "Vaše náklady na dopravu byly již zaplaceny. Doprava zaplacena ✓",
"hc.yourShippingFeesHaveBeen": "Vaše náklady na dopravu byly zaplaceny. Váš balíček je připravován.",
"hc.yourVerificationQuestionsDeposit": "Vaše ověřovací otázky (záloha)",
"hero.einvoiceBadge": "E-fakturace v souladu s 2027",
"home.recentAdsAll": "Zobrazit všechny nabídky",
"home.recentAdsEyebrow": "Právě teď",
"home.recentAdsSubtitle": "Ztracené a nalezené předměty hlášené komunitou.",
"home.recentAdsTitle": "Nejnovější nabídky",
"home.reunions": "Nedávná setkání",
"home.videoEyebrow": "Sledujte",
"home.videoSubtitle": "Jak se bez námahy sjednocují ztracené předměty se svými majiteli.",
"home.videoTitle": "Objevte Findloop za 2 minuty",
"home.watchYoutube": "Sledujte na YouTube",
"impact.already": "Již",
"impact.citiesWord": "město/města",
"impact.eachPoint": "Každý bod je město, kde Findloop pomáhá obnovit ztracené předměty.",
"impact.emptyMap": "Mapa se zaplňuje, jakmile k vracení dojde.",
"impact.eyebrow": "Náš dopad",
"impact.inCities": "v rámci",
"impact.restitutedTo": "předměty vrácené jejich majitelům",
"impact.title": "Předměty vrácené, všude kolem vás",
"inv2.download": "Stáhnout",
"inv2.view": "Zobrazit",
"map.objectsOnMapPlural": "předměty na mapě",
"map.objectsOnMapSingular": "předmět na mapě",
"mc.claimConfirmDesc": "Zkontrolujte předmět nalezený nálezcem, než zaplatíte za odemčení jeho kontaktních údajů.",
"mc.claimConfirmNo": "To není můj předmět",
"mc.claimConfirmTitle": "Je to opravdu váš předmět?",
"mc.claimConfirmYes": "Ano, je to můj — zaplatit",
"mc.claimFinderContacts": "Kontaktní údaje nálezce",
"mc.claimNotMineDone": "Děkujeme — nálezce byl informován a vaše žádost byla odstraněna z inzerátu.",
"mc.claimUnlockDesc": "Zaplaťte poplatek za správu Findloop, abyste získali kontaktní údaje osoby, která našla váš předmět.",
"mc.claimUnlockTitle": "Odemkněte kontaktní údaje nálezce",
"mc.hideCountryOffers": "Skrýt nabídky v mé zemi",
"mc.myClaims": "Předměty, které si nárokuji",
"mc.myClaimsSub": "Předměty nalezené ostatními, které si nárokujete. Odemkněte kontaktní údaje nálezce pro domluvu předání.",
"mc.notifAdCancelled": "Inzerát zrušen",
"mc.notifCancelAd": "Zrušit můj inzerát",
"mc.offersInCountry": "Nabídky v mé zemi",
"mc.offersInCountryDesc": "Všechny aktivní odměny od partnerů ve vaší zemi, podle města.",
"mc.redArchived": "Archivováno",
"mc.rewardsCountryNone": "V vaší zemi zatím žádná nabídka není.",
"mc.rewardsForYou": "Odměny pro vás",
"mc.rewardsForYouDesc": "Nabídnuto partnerem/partnery, kde jste odevzdali předmět.",
"mc.rewardsMineNone": "Zatím žádná odměna od vašich partnerů na odevzdání.",
"mc.showCountryOffers": "Zobrazit nabídky v mé zemi",
"mc2.cancelDecl": "Zrušit moje prohlášení",
"mc2.cancelDeclDone": "Prohlášení zrušeno.",
"pricing.physInvDesc": "Když se předmět vrátí, jeho místo je automaticky uvolněno a dostupné pro nový předmět.",
"pricing.physInvTitle": "Sledování fyzických zásob",
"pricing.physModalTitle": "Správa fyzických položek",
"pricing.physQrDesc": "Pro každou položku je vygenerován unikátní QR kód, který odkazuje na všechny její informace.",
"pricing.physQrTitle": "Dedikovaná QR etiketa",
"pricing.physShelfDesc": "Každé registrované položce může být přiřazeno fyzické umístění v rámci zařízení.",
"pricing.physShelfTitle": "Plán regálů",
"pricing.physicalMgmt": "Správa fyzických položek (regály, QR, inventář)",
"pub.addSecondPhoto": "Přidat 2. fotografii (volitelné)",
"pub.photo2Added": "✓ 2. fotografie přidána",
"reg.dispositionJournal": "Deník dispozic",
"reg.dispositionNoteAuthHint": "ℹ️ Poznámka je vyžadována pro „Předáno úřadům“ (číslo hlášení, oddělení…).",
"reg.dispositionNotePh": "Poznámka (volitelné): obdržená charita, reference úřadů, jméno kupujícího…",
"reg.dispositionNoteRequired": "Oficiální reference je vyžadována pro předání úřadům.",
"reg.legalPrealert": "Právní lhůta za {days} den(y)",
"reg.legalPrealertOptions": "Možnosti při lhůtě: aukční prodej, darování charitě, předání úřadům.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Úplná recenze",
"rev.readMore": "Číst více",
"rw.activeCodes": "Aktivní poukázky",
"rw.archived": "Archivováno",
"rw.archivedTitle": "Využité poukázky (archivováno)",
"rw.hideArchived": "Skrýt využité poukázky",
"rw.noArchived": "Žádná archivovaná poukázka.",
"rw.showArchived": "Zobrazit využité poukázky",
"shp.labelAuto": "Etiketa se generuje automaticky, jakmile zákazník uhradí poplatky za dopravu. Bude ke stažení zde.",
"st.cancelled_by_customer": "Zrušeno",
"stt.dispoPdfBtn": "Exportovat PDF",
"stt.dispoPdfError": "Export PDF se nezdařil.",
"stt.dispoPdfExporting": "Exportuji…",
"trk.matchVerifying": "Potenciální shoda se ověřuje",
"a.firstName": "Jméno",
"ac.emailCrossMatch": "B2C shody",
"ac.emailCrossMatchDesc": "Email, když se veřejný inzerát ztraceného předmětu shoduje s předmětem uloženým ve vašich prostorách",
"ac.emailCrossReject": "Odmítnutí veřejné shody",
"ac.emailCrossRejectDesc": "Obdržíte email, když zákazník uvede, že navržená veřejná shoda není jeho předmět.",
"ac.emailLoginNotif": "Oznámení o přihlášení",
"ac.emailLoginNotifDesc": "Obdržíte email pokaždé, když se někdo přihlásí do vašeho účtu.",
"ad.closeNoCancel": "Ne, odstranit inzerát",
"ad.closeQuestion": "Byl vám předmět vrácen?",
"ad.closeQuestionDesc": "Dejte nám vědět, zda jste získali svůj předmět zpět, nebo zda chcete tento inzerát jednoduše odstranit.",
"ad.closeYesRestituted": "Ano, předmět byl vrácen",
"ad.closedRestituted": "Předmět vrácen — inzerát uzavřen 🎉",
"an.lostLoginDesc": "Účet je potřebný k nahlášení ztraceného předmětu a sledování jeho vrácení.",
"an.lostLoginRequired": "Přihlaste se k nahlášení ztraceného předmětu",
"an.qfAll": "Vše",
"an.qfBoosted": "Zvýhodněné",
"an.qfPhoto": "S fotkou",
"an.qfRecent": "Tento týden",
"an.qfResolved": "Vyřešeno",
"an.restitutionInProgress": "Předmět se vrací",
"dec.descPhLong": "Popište předmět: značka, barva, charakteristické znaky… (Čím více podrobností uvedete, tím vyšší jsou vaše šance na nalezení předmětu)",
"dec.loadError": "Není možné načíst partnera právě teď. Zkontrolujte své připojení a zkuste to znovu.",
"dec.retry": "Zkusit znovu",
"dec.shippingMode": "Zásilka",
"dep.photo2": "Fotka 2. předmětu",
"dep.photo2Hint": "Volitelné — jiný úhel zlepší přesnost vizuální shody.",
"dl.accountSuspended": "Účet pozastaven z důvodu neuhrazené faktury. Uhraďte ji, abyste obnovili svůj přístup.",
"dl.regularize": "Uhradit nyní →",
"dl.suspensionCountdown": "Faktura {num} neuhrazená — váš účet bude pozastaven za {days} den(ů). Uhraďte ji, abyste se tomu vyhnuli.",
"ft.cancelConfirm": "Zrušit váš report? Majitel předmětu bude informován.",
"ft.cancelDone": "Report zrušen.",
"ft.cancelLocked": "Zrušení již není možné po zaplacení majitele.",
"ft.cancelReport": "Zrušit můj report",
"ft.claimCodeHelp": "Dejte tento kód nálezci při předání, aby potvrdil, že jste svůj předmět obdrželi.",
"ft.claimCodeTitle": "Váš restitucní kód",
"ft.claimDone": "Předmět vrácen. Děkujeme, že používáte Findloop!",
"ft.claimUnlockHint": "Odemkněte kontaktní údaje nálezce",
"ft.claimUnlockHintSub": "Přejděte do \"Předměty, které nárokuji\" ve svém účtu, abyste zaplatili poplatek a získali kontaktní údaje.",
"ft.finderCodeShownHelp": "Majitel zaplatil a vybral vás. Zkopírujte tento kód níže pro potvrzení vrácení — není nutné kontrolovat svůj email.",
"ft.finderCodeShownTitle": "Potvrzovací kód majitele",
"ft.finderContactsTitle": "Kontaktní údaje findera",
"ft.foundCodeHelp": "Ukažte tento kód vlastníkovi při předání, abyste potvrdili, že položka byla vrácena.",
"ft.inProgressOther": "Položka je vracena",
"ft.inProgressOtherHelp": "Vlastník vybral jiného findera pro tuto položku. Na vaší straně není potřeba žádná další akce.",
"ft.restitutionCodeHelp": "Tento kód potvrzuje předání položky. Je již předvyplněn níže; ověřte ho a poté uzavřete případ.",
"ft.restitutionCodeTitle": "Váš restitucní kód",
"hc.14Digits": "14 číslic",
"hc.15DaysBeforeAnItem": "15 dní před právním termínem položky.",
"hc.7DaysBeforeAnItem": "7 dní před právním termínem položky.",
"hc.8CharactersMinimum": "Minimálně 8 znaků.",
"hc.aClaimToValidate": "Nárok na ověření",
"hc.aFindoAssistanceSessionIs": "Aktuálně probíhá sezení podpory Findloop na vašem účtu.",
"hc.aNewMatchHasBeen": "Byl nalezen nový shodný zápas",
"hc.aUser": "Uživatel",
"hc.aUserClaimsToBe": "Uživatel tvrdí, že je vlastníkem. Zkontrolujte jejich odpovědi před autorizací vrácení.",
"hc.aboutFindo": "O Findloop",
"hc.accountActivatedPleaseLogIn": "Účet aktivován, prosím přihlaste se.",
"hc.accountActivation": "Aktivace účtu",
"hc.accountCreated": "Účet vytvořen!",
"hc.accountDeactivatedAReactivationEmail": "Účet deaktivován. E-mail pro reaktivaci (platný po dobu 30 dní) vám byl odeslán.",
"hc.accountReactivation": "Reaktivace účtu",
"hc.activateMyAccount": "Aktivovat můj účet",
"hc.activateMyAdminAccount": "Aktivovat můj administrátorský účet",
"hc.activating": "Aktivuji…",
"hc.activeMatchCancelReason": "Aktivní zápas. Důvod zrušení zákazníka: \"{reason}\". Položka stále čeká na nárok.",
"hc.activeMatchWithAPublic": "Aktivní zápas s veřejným (zákaznickým) seznamem. Čeká se na nárok vlastníka.",
"hc.addAPhoto": "Přidat fotografii",
"hc.addAndConfigureYourEstablishments": "Přidejte a nakonfigurujte své zařízení v \"Zařízeních\": kontaktní údaje, kategorie a fyzické uskladnění položek.",
"hc.addOnGoogle": "Přidat na Google",
"hc.address": "Adresa",
"hc.addressSaved": "Adresa uložena",
"hc.addressStreet": "Adresa — Ulice",
"hc.adjustThePhoto": "Upravit fotografii",
"hc.adminFullView": "Admin (úplný pohled)",
"hc.administratorOnly": "Pouze pro administrátory",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "AI vizuální porovnání",
"hc.all": "Vše",
"hc.amount": "Částka",
"hc.anOrganization": "Organizace",
"hc.analyzing": "Analyzuji…",
"hc.andRecoveryIs": "a obnova je",
"hc.andTheDeclarationWillBe": "a prohlášení bude uzavřeno (přesunuto do historie). Tento krok je konečný.",
"hc.annual20": "Roční -20%",
"hc.annualBilling20": "Roční fakturace (−20%)",
"hc.annualTarget": "Roční cíl",
"hc.anyCommentsOptional": "Jakékoliv komentáře? (volitelné)",
"hc.approveTheClaim": "Schválit nárok",
"hc.archiveCancelledConfirm": "Archivovat {n} seznam(y) \"Zrušeno zákazníkem\"? Budou odstraněny z registru.",
"hc.asSoonAs": "Jakmile",
"hc.askTheOwnerToDisplay": "Požádejte vlastníka, aby zobrazil QR kód svého kódu (stránka sledování).",
"hc.askThemAtTheCounter": "Zeptejte se jich na přepážce, aby potvrdili totožnost — nikdy není veřejně viditelné.",
"hc.assistance": "Podpora",
"hc.assistanceSessionRevoked": "Zasedání podpory bylo zrušeno.",
"hc.atLeast6Characters": "Alespoň 6 znaků",
"hc.automaticallyPreSelected": "automaticky předvybráno",
"hc.automaticallyWhenShipping": "automaticky při odesílání.",
"hc.awaitingClaim": "Čeká na nárok",
"hc.awaitingPayment": "Čeká na platbu",
"hc.b2cCustomer": "B2C zákazník",
"hc.back": "Zpět",
"hc.backToHome": "Zpět na domovskou stránku",
"hc.backToMyAccount": "Zpět na můj účet",
"hc.backToPayment": "Zpět k platbě",
"hc.beforeAfterComparisonSlider": "Posuvník před/po porovnání",
"hc.billingInformation": "Fakturační informace",
"hc.billingInformationSaved": "Fakturační informace uloženy ✓",
"hc.brand": "Značka",
"hc.bronze": "Bronz",
"hc.calculatingTheShippingRate": "Vypočítávám cenu dopravy…",
"hc.cameraUnavailableEnterTheCode": "Kamera není dostupná. Zadejte kód ručně.",
"hc.cancel": "Zrušit",
"hc.cancelMyDeclaration": "Zrušit mé prohlášení",
"hc.cancelSavedFmt": "Zrušení uloženo: \"{reason}\". Stále můžete požádat o nárok.",
"hc.cancelTheDeposit": "Zrušit zálohu",
"hc.cancelThisMatch": "Zrušit tuto shodu",
"hc.cancellationReason": "Důvod zrušení",
"hc.cancelled": "Zrušeno",
"hc.cancelledByTheCustomer": "Zrušeno zákazníkem",
"hc.cannotOpenPayment": "Nelze otevřít platbu. Zkuste to prosím znovu.",
"hc.careers": "Kariéra",
"hc.carrier": "Dopravce",
"hc.carrierAvailabilityCannotBeChecked": "Dostupnost dopravce nelze zkontrolovat, dokud není váš odesílatel Sendcloud nakonfigurován.",
"hc.carrierConfirmedCharged": "Dopravce potvrzen — {price} € účtováno zákazníkovi",
"hc.carrierOther": "Dopravce (jiný)",
"hc.carrierSelection": "Výběr dopravce",
"hc.caseClosedThankYou": "Případ uzavřen. Děkujeme!",
"hc.category": "Kategorie",
"hc.changeMethod": "Změnit metodu",
"hc.characteristic": "Charakteristika",
"hc.chargedToCustomer": "účtováno zákazníkovi.",
"hc.checkOrEditYourDetails": "Zkontrolujte nebo upravte své údaje před zabezpečenou platbou.",
"hc.checkStatisticsToTrackDeposited": "Zkontrolujte \"Statistiky\" pro sledování vložených položek, míry návratu a výkonu každého zařízení.",
"hc.checkTheDetailsBeforeContacting": "Zkontrolujte údaje před kontaktováním nálezce.",
"hc.checkTheDetailsBelowBefore": "Zkontrolujte údaje níže před zahájením žádosti o vrácení.",
"hc.checkTheNewItem": "Zkontrolujte novou položku",
"hc.checkThePhotosAndCharacteristics": "Zkontrolujte fotografie a charakteristiky níže před pokračováním s vyhledáváním.",
"hc.chooseACountry": "Vyberte zemi",
"hc.chooseANewPassword": "Vyberte nové heslo",
"hc.chooseAReason": "Vyberte důvod",
"hc.chooseTheLegalRetentionAlerts": "Vyberte právní upozornění na uchování, které budou zaslány e-mailem pro",
"hc.chooseYourPasswordToAccess": "Vyberte své heslo pro přístup do administrativní konzole.",
"hc.city": "Město",
"hc.claimApproved": "Žádost schválena",
"hc.claimApproved2": "Žádost schválena.",
"hc.claimCodeExpired": "Platnost kódu žádosti vypršela",
"hc.claimCodeVerified": "Kód žádosti ověřen",
"hc.claimNotFound": "Žádost nenalezena",
"hc.claimNotValidated": "Žádost nebyla ověřena",
"hc.claimRejected": "Žádost zamítnuta",
"hc.claimRejected2": "Žádost zamítnuta.",
"hc.claimValidated": "Žádost ověřena",
"hc.claimValidatedByThePartner": "Žádost ověřena partnerem",
"hc.claimant": "Žadatel",
"hc.claimsToBeTheOwner": "tvrdí, že je vlastníkem této položky a odpověděl na ověřovací otázky. Schválte pouze v případě, že odpovědi se shodují.",
"hc.claimsToValidate": "Žádosti k ověření",
"hc.clear": "Vymazat",
"hc.clickToZoom": "Klikněte pro zvětšení",
"hc.close": "Zavřít",
"hc.close2": "Zavřít",
"hc.closeTheDeclaration": "Zavřít prohlášení",
"hc.closeTheDeclaration2": "Zavřít prohlášení?",
"hc.codeAlreadyVerified": "Kód již ověřen",
"hc.codeCopied": "Kód zkopírován",
"hc.collapse": "Sbalit",
"hc.color": "Barva",
"hc.company": "Společnost",
"hc.companyName": "Název společnosti",
"hc.comparePhotos": "Porovnat fotografie",
"hc.compareThemWithTheOwner": "Porovnat je s odpověďmi vlastníka — nikdy veřejně viditelné.",
"hc.condition": "Stav",
"hc.confirmAndPay": "Potvrdit a zaplatit",
"hc.confirmCancellation": "Potvrdit zrušení",
"hc.confirmCrop": "Potvrdit oříznutí",
"hc.confirmDeletion": "Potvrdit odstranění",
"hc.confirmPassword": "Potvrdit heslo",
"hc.confirmThatThisIsYour": "Potvrdit, že toto je váš předmět. Ověření identity bude požadováno od nálezce před jakýmkoliv kontaktem.",
"hc.confirmTheCarrier": "Potvrdit dopravce",
"hc.confirmThePassword": "Potvrdit heslo",
"hc.confirmYourShippingAddressTo": "Potvrdit vaši dodací adresu pro pokračování v platbě.",
"hc.confirmYourSubscription": "Potvrdit vaše předplatné",
"hc.confirmed": "Potvrzeno ✓",
"hc.contactFindoToGetYour": "Kontaktujte Findloop, abyste získali své ID odesílatele.",
"hc.contactUs": "Kontaktujte nás",
"hc.continueTheReturn": "Pokračovat v vrácení",
"hc.continueToPayment": "Pokračovat k platbě",
"hc.copy": "Kopírovat",
"hc.correctMyDetails": "opravit mé údaje",
"hc.correctThisEntry": "Opravit tuto položku?",
"hc.country": "Země",
"hc.countryAddress": "Země (adresa)",
"hc.countryIsoCodeEG": "Země (ISO kód, např. FR)",
"hc.cover": "obal",
"hc.createTheShipment": "Vytvořit zásilku",
"hc.cropThePhoto": "Oříznout foto",
"hc.customer": "Zákazník",
"hc.customerClaimCodeToCheck": "Kód reklamace zákazníka — pro ověření při vyzvednutí:",
"hc.customerReasonFmt": "Důvod zákazníka: \"{reason}\".",
"hc.customerReminderDelay": "Zpoždění připomenutí zákazníka",
"hc.customerWhosePublicListingMatches": "Zákazník, jehož veřejný seznam odpovídá tomuto předmětu — viditelné pouze pro vás.",
"hc.d15": "D-15",
"hc.dangerZone": "Nebezpečná zóna",
"hc.date": "Datum",
"hc.dateNewest": "Datum (nejnovější)",
"hc.dateOldest": "Datum (nejstarší)",
"hc.daysToYearEnd": "{n} dní do konce roku",
"hc.deadlineAlert": "Upozornění na termín",
"hc.declarationClosed": "Deklarace uzavřena ✓",
"hc.declarationNotFound": "Deklarace nebyla nalezena.",
"hc.declarationNotFound2": "Deklarace nebyla nalezena",
"hc.declarationTracking": "Sledování deklarace",
"hc.defaultCarrier": "Výchozí dopravce",
"hc.defaultCarrierPreselected": "Výchozí dopravce je předvybraný — lze změnit pro tuto zásilku. Skutečná cena (Sendcloud + {m}% marže).",
"hc.defaultCarrierRemoved": "Výchozí dopravce byl odstraněn",
"hc.delayHours": "Zpoždění (hodiny)",
"hc.deleteMyAccount": "Smazat můj účet",
"hc.deleting": "Mažu…",
"hc.deletingDeactivatesYourAccountLogin": "Smazání deaktivuje váš účet: přihlášení je zablokováno a data jsou uchována po dobu 30 dní. Obdržíte e-mail s odkazem na znovuaktivaci platným po dobu 30 dní.",
"hc.delivered": "Doručeno",
"hc.depositAnItem": "Vložit položku",
"hc.depositCancelledItemPutBack": "Vložení zrušeno — položka byla vrácena do skladu.",
"hc.depositCancelledItemRemovedFrom": "Vložení zrušeno — položka byla odstraněna z registru.",
"hc.depositedOn": "Uloženo dne",
"hc.describeTheItemBrandColor": "Popište položku: značka, barva, rozlišovací znaky… (Čím více detailů poskytnete, tím lepší šance na nalezení vaší položky)",
"hc.dimensionsCm": "Rozměry (cm)",
"hc.disablingAnEmail": "Deaktivace e-mailu",
"hc.doesNotHide": "nezakrývá",
"hc.download": "Stáhnout",
"hc.downloadThePdf": "Stáhnout PDF",
"hc.draftRestoredPickUpYour": "Návrh obnoven — vyzvedněte si svou deklaraci tam, kde jste skončili.",
"hc.dragToReposition": "Přetáhněte pro pře repositionování",
"hc.eGColisPriv": "Např. Colis Privé",
"hc.eachItemGetsAQr": "Každá položka dostane QR štítek. Naskenujte jej z \"Sklad & QR\" pro okamžité nalezení položky.",
"hc.eachSiteManagesItsOwn": "Každý web spravuje své vlastní bankovnictví. Jděte na",
"hc.edit": "Upravit",
"hc.emailNotificationPreferences": "Nastavení e-mailových upozornění",
"hc.emailPreferencesUpdated": "Nastavení e-mailu bylo aktualizováno",
"hc.enableOrDisableRecoveryFees": "Povolit nebo zakázat poplatky za obnovení pro",
"hc.enlargePhoto": "Zvětšit fotografii",
"hc.enterTheCustomerSCode": "Zadejte kód zákazníka",
"hc.estShipRate": "Odhad nákladů na dopravu (Sendcloud + {m}% marže):",
"hc.establishment": "Zřízení",
"hc.establishment2": "Zřízení:",
"hc.establishmentInItsSendcloudAccount": "zřízení ve vašem účtu Sendcloud a poskytne vám ID odesílatele",
"hc.establishmentSettings": "Nastavení zřízení",
"hc.exCode": "např. ABCD2345",
"hc.exId": "např. 3f2a…",
"hc.exit": "Odhlásit se",
"hc.explainWhyThisItemIs": "Vysvětlete, proč tento předmět není váš…",
"hc.externalPaymentLinks": "Externí platební odkazy",
"hc.failed": "Neúspěšné",
"hc.feesEnabled": "Poplatky povoleny",
"hc.field": ") pole.",
"hc.finderAcceptedCloseTheCase": "Finder akceptoval — uzavřete případ, jakmile bude předmět předán osobně.",
"hc.findoCityRanking": "Findloop — Městský žebříček",
"hc.findoForEstablishments": "Findloop pro zřízení",
"hc.findoPresentationVideo": "prezentační video Findloop",
"hc.findoRegistersTheAddressOf": "Findloop registruje adresu vašeho",
"hc.findoReviewShare": "Findloop {year} recenze: {n} předmětů vráceno, {rate}% míra vrácení 🎉",
"hc.firstVerifyTheClaimCode": "Nejprve ověřte výše uvedený kód nároku",
"hc.forEveryNewShipmentFrom": "za každou novou zásilku z",
"hc.free": "zdarma",
"hc.freeRecovery0": "Bezplatná obnova (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Bezplatná obnova po celé Africe – Úvodní nabídka",
"hc.freeRecoveryFeesDisabled0": "Bezplatná obnova: poplatky zakázány (0 €)",
"hc.fromTeamInviteYourColleagues": "Z \"Týmu\" pozvěte své kolegy e-mailem a přiřaďte jim zřízení. Každý člen vidí pouze svůj vlastní rozsah.",
"hc.fullName": "Celé jméno",
"hc.fullPhoto": "Úplná fotografie",
"hc.gallery": "Galerie",
"hc.giveTheReasonForCancelling": "Uveďte důvod pro zrušení. Partner bude informován.",
"hc.goToLogin": "Přejít na přihlášení",
"hc.goToMyAccount": "Přejít na můj účet",
"hc.gold": "Zlato",
"hc.googleLoginFailed": "Přihlášení pomocí Google se nezdařilo",
"hc.hasConfirmedYourPaymentYou": "potvrdil vaši platbu, budete automaticky přesměrováni",
"hc.helpCenter": "Centrum nápovědy",
"hc.helpUsImproveWhyAre": "Pomozte nám zlepšit: proč odcházíte? Váš účet bude deaktivován a může být znovu aktivován na 30 dní.",
"hc.hidePassword": "Skrýt heslo",
"hc.high": "Vysoké",
"hc.historyOfYourMonthlySubscriptions": "Historie vašich měsíčních předplatných a jejich stav platby.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Jak nastavit své číselné ID odesílatele?",
"hc.iDonTUseIt": "Používám to dostatečně málo",
"hc.iFoundItElsewhere": "Našel jsem to jinde",
"hc.iNoLongerNeedMy": "Už nepotřebuji svou věc",
"hc.identityVerification": "Ověření identity",
"hc.idleLogoutIn": "Budete odhlášeni za {n} s z důvodu neaktivity.",
"hc.ifProvidedTheVolumetricWeight": "Pokud je poskytnuta, používá se objemová hmotnost.",
"hc.ifThePartnerHasNot": "Pokud partner nepotvrdil přijetí externí platby po tomto zpoždění, Findloop automaticky připomene partnerovi, aby ji ověřil.",
"hc.impersonationEnded": "Napodobování skončilo.",
"hc.impersonationMode": "Režim napodobování",
"hc.impersonationSessionExpired": "Relace napodobování vypršela.",
"hc.inTheField": ", v terénu",
"hc.inTransit": "Na cestě",
"hc.inclVat": "vč. DPH",
"hc.intraEuVatNumberOptional": "Intra-EU DIČ volitelné, SIRET není požadováno (mimo Francii).",
"hc.invalidInvitationLink": "Neplatný pozvánkový odkaz.",
"hc.invalidInvitationLink2": "Neplatný pozvánkový odkaz",
"hc.invalidInviteLink": "Neplatný nebo vypršel pozvánkový odkaz.",
"hc.invalidNumberEnterAnInternational": "Neplatné číslo. Zadejte mezinárodní číslo, např. +420 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Neplatný nebo vypršel odkaz.",
"hc.invalidOrExpiredReactivationLink": "Neplatný nebo vypršel odkaz na reaktivaci",
"hc.invalidSendcloudId": "Neplatné Sendcloud ID",
"hc.inviteSubtitle": "{org} vás zve, abyste se připojili k jejich týmu findloop. Zvolte si své heslo pro aktivaci vašeho účtu.",
"hc.isAvailableOnSendcloudFor": "je k dispozici na Sendcloud pro všechny vaše trasy (domácí + mezinárodní).",
"hc.isNotEnabledOnYour": "není povoleno na vašem účtu Sendcloud pro některé destinace. Štítky pro tyto budou generovány jiným dostupným přepravcem.",
"hc.isThisReallyYourItem": "Je to opravdu vaše věc?",
"hc.isThisYourItem": "Je to vaše věc?",
"hc.item": "Položka",
"hc.itemAlreadyConfirmed": "Položka již potvrzena",
"hc.itemDetails": "Podrobnosti o položce",
"hc.itemFoundAt": "Položka nalezena na",
"hc.itemFoundAtAPartner": "Položka nalezena u partnera",
"hc.itemMarkedAsReturned": "Položka označena jako vrácená ✓",
"hc.itemPhotoRequiredBeforeShipping": "Fotografie položky (požadováno před odesláním)",
"hc.itemPhotoSaved": "Fotografie položky uložena",
"hc.itemPreview": "Náhled položky",
"hc.itemPutBackInStorage": "Položka vrácena do skladu.",
"hc.itemWeight": "Hmotnost položky:",
"hc.itemsReturned": "položka(e) vrácena(e)",
"hc.itemsReturnedThisYear": "předměty vrácené tento rok",
"hc.itemsWhoseLegalDeadlineIs": "Předměty, jejichž právní termín je za 15 dní nebo méně (zpožděné zahrnuty). Shody zůstávají viditelné.",
"hc.kbisNumber": "Kbis číslo",
"hc.keysForgottenOnABench": "Klíče zapomenuté na lavici",
"hc.labelBeingGenerated": "Štítek je generován",
"hc.leaveTheFieldsEmptyTo": "Nechte políčka prázdná, abyste nabídli obnovu zdarma.",
"hc.legalNotice": "Právní oznámení",
"hc.limitReachedUpgradeToA": "Dosáhnuto limitu — aktualizujte na vyšší plán",
"hc.linkCopiedShareOn": "Odkaz zkopírován — sdílejte ho na {label}",
"hc.linkUnavailable": "Odkaz není k dispozici",
"hc.linkedTo": "Propojeno s",
"hc.listingHiddenByModeration": "Inzerát skrytý moderací.",
"hc.loading": "Načítání…",
"hc.locateMe": "Najdi mě",
"hc.logIn": "Přihlásit se",
"hc.logInToGetBack": "Přihlaste se, abyste se vrátili do svého prostoru a spravovali své předplatné.",
"hc.loginFailed": "Přihlášení se nezdařilo",
"hc.lostFoundPlatform": "Platforma pro ztráty a nálezy.",
"hc.lostIn": "ztraceno v",
"hc.lowRate": "Nízká sazba",
"hc.mainReason": "Hlavní důvod",
"hc.mainStreet": "Hlavní ulice",
"hc.makeSureThisIsThe": "Ujistěte se, že se jedná o předmět, který jste ztratili, před odemknutím kontaktních údajů nálezce.",
"hc.manageCookies": "Spravovat cookies",
"hc.manageMyTeam": "Spravovat můj tým",
"hc.manageYourTeam": "Spravovat váš tým",
"hc.markAsReturned": "Oz označit jako vráceno",
"hc.matchNoClaimInTime": "Shoda nedostala žádný nárok v termínu.",
"hc.matchNotFound": "Shoda nenalezena",
"hc.medium": "Střední",
"hc.milestoneFmt": "{m} dosaženo milníku vrácených předmětů! Na cestě k {next}.",
"hc.missingFeatures": "Chybějící funkce",
"hc.monthly": "Měsíčně",
"hc.monthlyBilling": "Měsíční fakturace",
"hc.moveThePhotoToFit": "Posuňte fotografii, aby se vešla do kruhu.",
"hc.myAccount": "Můj účet",
"hc.myInvoices": "Moje faktury",
"hc.myMonthlyInvoices": "Moje měsíční faktury",
"pcat.stadium_arena": "Stadion / Aréna",
"pcat.supermarket": "Supermarket",
"pcat.taxi_vtc": "Taxi / Sdílená jízda",
"pcat.tourism_office": "Turistická kancelář",
"pcat.train_bus_station": "Železniční / autobusová stanice",
"pcat.travel_agency": "Cestovní kancelář",
"hc.and": "a",
"hc.demoObj0": "peněženka",
"hc.demoObj1": "sportovní taška",
"hc.demoObj2": "telefon",
"hc.demoObj3": "brýle",
"hc.demoObj4": "set klíčů",
"hc.demoObj5": "šátek",
"hc.demoObj6": "notebook",
"hc.demoObj7": "láhev na vodu",
"hc.demoWhen0": "před 2 hodinami",
"hc.demoWhen1": "před 5 hodinami",
"hc.demoWhen2": "včera",
"hc.demoWhen3": "před 3 hodinami",
"hc.demoWhen4": "dnes ráno",
"hc.demoWhen5": "před 1 dnem",
"hc.feedDemo": "{obj} byl vrácen v {city} {when}.",
"hc.feedReal": "Položka ({cat}) byla vrácena v {city}.",
"hc.saveBtn": "Uložit",
"hc.saveLink": "Uložit odkaz",
"hc.terms": "Podmínky",
"hc.view": "Zobrazit",
"pcat.airline": "Letecká společnost",
"pcat.airport": "Letiště",
"pcat.amusement_park": "Zábavní park",
"pcat.bank": "Banka",
"pcat.bar_cafe": "Bar / Kavárna",
"pcat.beauty_salon": "Kadeřnictví / Kosmetický salon",
"pcat.cinema": "Kino",
"pcat.concert_theater": "Koncertní sál / Divadlo",
"pcat.coworking": "Coworkingové prostory",
"pcat.gym_fitness": "Posilovna / Fitness",
"pcat.hospital_clinic": "Nemocnice / Klinika",
"pcat.library": "Knihovna",
"pcat.mall": "Nákupní centrum",
"pcat.museum": "Muzeum",
"pcat.pharmacy": "Lékárna",
"pcat.private_company": "Soukromá společnost",
"pcat.public_transport": "Veřejná doprava",
"pcat.school_university": "Škola / Univerzita",
"pcat.sports_center": "Sportovní centrum",
"an.found": "Nalezeno",
"an.lost": "Ztraceno",
"hc.shareReview": "Sdílet recenzi",
"hc.citiesAboveTarget": "{n} měst nad jejich cílem",
"hc.cityAboveTarget": "{n} město nad jeho cílem",
"hc.j15EarlyReminder": "D-15 předběžné upozornění",
"hc.j7EarlyReminder": "D-7 předběžné upozornění",
"hc.annualTotal": "Roční částka",
"hc.billedOnceYear": "Účtováno jednou na 12 měsíců, obnovováno každý rok.",
"hc.monthlyPrice": "Měsíční cena",
"hc.perMonth": "/ měsíc",
"hc.perYear": "/ rok",
"hc.billedEachMonth": "Naúčtováno automaticky každý měsíc.",
"nav.business": "Podnikání",
"nav.individual": "Jednotlivec",
"hc.circumstancesFound": "Z okolnosti nálezu",
"hc.circumstancesFoundPh": "Např. nalezeno na zemi u vchodu do metra",
"hc.circumstancesLost": "Z okolnosti ztráty",
"hc.circumstancesLostPh": "Např. ponecháno na lavičce při čekání na autobus",
"hc.conditionPh": "Např. dobrý, poškrábaný…",
"hc.firstName": "Jméno",
"hc.lastName": "Příjmení",
"hc.quantity": "Počet položek",
"fa.ownerContact": "Kontaktní údaje vlastníka",
"fa.payPublish": "Zaplatit a publikovat",
"fa.pendingPayText": "Váš inzerát bude živý, jakmile bude platba potvrzena.",
"fa.pendingPayTitle": "Platba probíhá",
"fa.planSub": "Váš inzerát bude živý, jakmile bude platba potvrzena.",
"fa.planTitle": "Doba trvání inzerátu",
"fa.pubSuccessMsg": "Váš inzerát je živý. Budete informováni, jakmile se někdo přihlásí jako nálezce.",
"fa.pubSuccessTitle": "Inzerát publikován",
"fa.publicNote": "Veřejně jsou zobrazeny pouze popis, město, země a fotografie.",
"fa.redirectStripe": "Přesměrování na bezpečnou platbu…",
"fa.reject": "Odmítnout",
"fa.rejectConfirm": "Odmítnout toto prohlášení? Váš inzerát zůstává online.",
"fa.rejected": "Prohlášení odmítnuto",
"fa.rejectedFinder": "To nebyl předmět, který hledali",
"fa.rejectedFinderText": "Majitel říká, že tento předmět není jeho. Děkujeme za vaši pomoc!",
"fa.responsesTitle": "Prohlášení nálezců",
"fa.sent": "Prohlášení bylo odesláno vlastníkovi.",
"fa.submitDecl": "Odeslat mé prohlášení",
"fa.submitDeclPay": "Odeslat a přispět {amount}",
"fa.total": "Celková částka k úhradě",
"fa.ttc": "vč. DPH",
"fa.waitClaimText": "Nálezce posuzuje vaši žádost. Budete informováni o jejich rozhodnutí.",
"fa.waitFinderText": "Dáme vám vědět, jakmile nálezce odešle prohlášení.",
"fa.waitFinderTitle": "Váš inzerát je živý",
"fa.waitOwnerText": "Majitel porovnává vaše prohlášení se svým. Budete informováni o jejich rozhodnutí.",
"fa.waitOwnerTitle": "Čeká se na rozhodnutí vlastníka",
"st.pending_payment": "Platba probíhá",
"fa.approve": "Schválit",
"fa.approveConfirm": "Schválit tuto deklaraci? Vaše kompletní kontaktní údaje (jméno, e-mail, telefon) budou vyměněny s nálezcem.",
"fa.approved": "Deklarace schválena — kontaktní údaje vyměněny",
"fa.approvedFinder": "Majitel schválil vaši deklaraci",
"fa.approvedFinderText": "Kontaktujte je, abyste se domluvili na vrácení.",
"fa.boostSub": "Váš inzerát zůstane nahoře po zvolenou dobu.",
"fa.boostTitle": "Zvýšit můj inzerát (volitelné)",
"fa.colFinder": "Nalezena deklarace",
"fa.colYours": "Vaše deklarace",
"fa.compareHint": "Porovnejte nalezenou deklaraci s vaší před rozhodnutím.",
"fa.contribNone": "Žádný příspěvek",
"fa.contribPaid": "Příspěvek přijat — děkujeme!",
"fa.contribPending": "Příspěvek čeká na platbu",
"fa.contribSub": "Podpořte Findloop, abyste pomohli více lidem dostat své věci zpět. Můžete zvolit €0.",
"fa.contribSuccessMsg": "Vaše deklarace byla odeslána majiteli.",
"fa.contribSuccessTitle": "Děkujeme za váš příspěvek",
"fa.contribTitle": "Dobrovolný příspěvek",
"fa.days3": "3 dny",
"fa.days30": "30 dnů",
"fa.days7": "7 dnů",
"fa.declSub": "Popište předmět, který jste našli. Majitel porovná vaši deklaraci s jejich.",
"fa.declTitle": "Našel(a) jsem tento předmět",
"fa.expiresOn": "Expiruje dne",
"fa.fBrand": "Značka",
"fa.fCircumstances": "Okolnosti",
"fa.fCity": "Město",
"fa.fColor": "Barva",
"fa.fCondition": "Stav",
"fa.fDate": "Datum",
"fa.fMessage": "Zpráva nálezce",
"fa.fPlace": "Místo",
"fa.fQuantity": "Množství",
"fa.finderContact": "Kontaktní údaje nálezce",
"fa.finishPay": "Dokončit platbu",
"fa.foundDate": "Datum nalezení",
"fa.foundPlace": "Místo nalezení",
"fa.hours24": "24 hodin",
"fa.ht": "bez DPH",
"fa.months3": "3 měsíce",
"fa.noBoost": "Žádné zvýšení",
"fa.africaFree": "Bezplatné inzerování v Africe — nabídka při spuštění Findloop, užijte si to!",
"fa.africaPublished": "Inzerát zveřejněn zdarma — nabídka při spuštění Afriky!",
"fa.approveClaimConfirm": "Schválit tento nárok? Majitel pak bude mít možnost odemknout vaše kontaktní údaje.",
"fa.checkInfo": "Zkontrolujte své údaje před odesláním: budou porovnány s údaji nálezce.",
"fa.claimApprovedShort": "Nálezce schválil váš nárok",
"fa.claimRejectedShort": "Nálezce zamítl nárok",
"fa.claimRejectedText": "Nálezce se domnívá, že tento předmět není váš.",
"fa.claimSub": "Popište svůj předmět a přidejte 2 fotografie. Nálezce je porovná s jejich inzerátem.",
"fa.claimTitle": "Tohle je můj předmět",
"fa.claimUnlockText": "Odemkněte kontaktní údaje nálezce pro domluvu návratu.",
"fa.claimUnlockedShort": "Kontaktní údaje odemčeny — sledujte doručení",
"fa.claimsTitle": "Nároky vlastníka",
"fa.colOwner": "Prohlášení vlastníka",
"fa.colYourAd": "Váš inzerát",
"fa.expired": "Inzerát vypršel",
"fa.free": "Zdarma",
"fa.lostDate": "Datum ztráty",
"fa.lostPlace": "Místo ztráty",
"fa.noReceipt": "K této nabídce není k dispozici žádný doklad.",
"fa.planSubFree": "Vyberte délku: váš inzerát se okamžitě zveřejní, žádná platba není třeba.",
"fa.prefillPrevious": "Použít údaje mého předchozího inzerátu v této kategorii",
"fa.receipt": "PDF doklad",
"fa.renewBtn": "Obnovit",
"fa.renewDiscountBanner": "Sleva 50 %: obnovte před tím, než váš inzerát vyprší!",
"fa.renewDiscountHint": "Sleva 50 % se vztahuje, protože obnovujete před vypršením.",
"fa.renewEarly": "Obnovit (−50 %)",
"fa.renewTitle": "Obnovit můj inzerát",
"fa.renewed": "Inzerát obnoven",
"fa.sendClaim": "Odeslat můj nárok",
"fa.twoPhotos": "2 fotografie vašeho předmětu",
"fa.twoPhotosError": "Přidejte 2 fotografie vašeho předmětu.",
"fa.twoPhotosHint": "Osobní fotografie dokazující, že předmět patří vám (s předmětem, fakturou, krabicí…).",
"fa.unlockBtn": "Odemknout kontaktní údaje",
"fa.unlockFree": "Odemknout zdarma — nabídka při spuštění",
"fa.waitClaimantText": "Hned vás informujeme, jakmile vlastník uvede tento předmět.",
"fa.waitFinderDecision": "Čekání na rozhodnutí nálezce",
"fa.waitUnlockText": "Budete informováni, jakmile dojde k výměně kontaktních údajů.",
"fa.waitUnlockTitle": "Čekání na odemčení vlastníkem",
"fa.cancel": "Zrušit",
"fa.categoryRequired": "Vyberte kategorii pro nalezenou položku.",
"fa.confirmTitle": "Potvrďte své rozhodnutí",
"fa.goBack": "Zpět",
"dr.continue": "Pokračovat v mé deklaraci",
"dr.delete": "Trvale smazat",
"dr.deleteConfirm": "Opravitelně smazat tento návrh? Toto nelze vrátit zpět.",
"dr.deleted": "Návrh smazán",
"dr.expiresIn": "Návrh uchován ještě {h} hodin",
"dr.title": "Máte nedokončenou deklaraci",
"form.step": "Krok",
"form.next": "Pokračovat",
"form.back": "Zpět",
"form.stepDetails": "Váš report",
"form.stepPublish": "Doba trvání, zvýšení a platba",
"form.stepThanks": "Děkujeme a příspěvek",
"fthx.badge": "Report téměř hotový",
"fthx.title": "Děkujeme, děláte rozdíl!",
"fthx.text": "Díky vám se může někdo brzy vrátit k něčemu, co pro něj má hodnotu. Takové laskavé činy, jako je ten váš, jsou přesně tím, co udržuje Findloop při životě.",
"fthx.impact1": "1 položka nahlášena",
"fthx.impact2": "1 další šance na shledání",
"fthx.tipTitle": "Trochu podpory pro Findloop?",
"fthx.tipText": "Váš příspěvek nám pomáhá udržovat službu dostupnou a vracet stále více předmětů jejich majitelům.",
"fthx.optional": "100 % volitelné — můžete publikovat bez příspěvku.",
"fthx.thanksTip": "Děkujeme vám za vaši štědrost!",
"fthx.suggest": "Doporučené částky",
"fthx.none": "Žádný příspěvek",
"pay.pendingTitle": "Platba nebyla dokončena",
"pay.pendingText": "Vaše údaje jsou uloženy. Pokračujte v platbě tam, kde jste skončili.",
"pay.resume": "Pokračovat v platbě",
"pay.expiredTitle": "Platnost relace platby vypršela",
"pay.expiredText": "Pro vaše zabezpečení vypršela relace platby. Vaše údaje jsou uloženy: znovu spusťte platbu jedním kliknutím.",
"pay.relaunch": "Znovu spustit platbu",
"sub.received": "Odesláno!",
"sub.publishing": "Dokončujeme to…",
"sub.toPayment": "Přesměrování na zabezpečenou platební bránu…",
"fa.claimSubV2": "Popište svou ztracenou věc. Osoba, která ji našla, porovná váš popis s jejich oznámením.",
"fa.photosOptional": "Fotky vaší věci (volitelné)",
"fa.compareOwnerHint": "Porovnejte tyto informace s věcí, kterou jste našli, a pak řekněte, zda se jedná o stejnou věc.",
"fa.itsThisItem": "Ano, tohle je ta věc",
"fa.notThisItem": "Ne, tohle není ta věc",
"fa.confirmIsItem": "Potvrdit, že tohle je ta věc? Vaše kontaktní údaje a údaje vlastníka budou zobrazeny ve vašich účtech.",
"fa.confirmNotItem": "Potvrdit, že tohle není ta věc? Váš hlášení bude uzavřeno.",
"fa.youConfirmed": "Potvrdili jste, že toto je věc vlastníka",
"fa.youDeclined": "Uvedli jste, že tohle nebyla ta věc",
"fa.youDeclinedText": "Děkujeme za vaši pomoc! Majitel byl informován.",
"fa.waitFinderDecisionOwner": "Čekáme na rozhodnutí nálezce",
"fa.finderConfirmed": "Potvrzeno",
"fa.notYourItem": "Tohle nebyla vaše věc",
"fa.reportedOn": "Ohlášeno dne",
"fa.ownerWaitHint": "Nálezce momentálně ověřuje informace, prosím čekejte.",
"fa.claimSentFinder": "Nárok byl odeslán osobě, která našla předmět.",
"fa.compareClaimHint": "Porovnejte prohlášení majitele s vaším označením předtím, než se rozhodnete.",
"fa.closeFollowup": "Uzavřít tuto následnou akci",
"fa.closeFollowupConfirm": "Opravdu chcete uzavřít tuto následnou akci? E-maily a telefonní čísla obou stran budou trvale vymazána, jakmile majitel také uzavře svůj inzerát.",
"fa.safetyTitle": "Tipy pro bezpečnost před předáním",
"fa.safety1": "Požádejte majitele o podrobný popis skrytých vlastností předmětu: konkrétní škrábance, přesný obsah tašky, tapeta, sériové číslo…",
"fa.safety2": "Pokud je to možné, požádejte o vizuální důkaz (fotografii předmětu) nebo doklad o koupi.",
"fa.safety3": "Předměty si předávejte na veřejném místě nebo u partnerského místa Findloop a zkontrolujte identifikaci majitele.",
"fa.safetyOk": "Rozumím, pokračovat",
"fa.ownerClosedNote": "Majitel uzavřel svůj inzerát.",
"fa.finderClosedNote": "Nalezenec uzavřel svou následnou akci.",
"fa.followupClosed": "Dohled uzavřen",
"fa.followupClosedText": "Tento dohled jste uzavřeli. Děkujeme za vaši pomoc!",
"fa.photoReviewTitle": "Nalezenec poslal fotografii. Vypadá to jako váš předmět?",
"fa.photoLooksLike": "Ano, vypadá to jako můj předmět",
"fa.photoNotMine": "Ne, to není můj předmět",
"fa.photoNotMineConfirm": "Následná akce bude uzavřena na obou stranách a váš inzerát zůstane otevřený pro nového nalezence.",
"fa.photoLooksLikeDone": "Děkujeme! Nalezenec nyní porovná vaše prohlášení.",
"fa.photoNotMineDone": "Oznámení bylo zamítnuto. Váš inzerát zůstane otevřený.",
"fa.ownerPhotoHint": "Zobrazí se vám pouze fotografie nalezence. Řekněte nám, zda se to podobá vašemu předmětu.",
"fa.ownerReviewingPhoto": "Majitel posuzuje vaši fotografii",
"fa.ownerReviewingPhotoText": "Budete upozorněni, jakmile odpoví. Poté budete moci porovnat jejich prohlášení.",
"fa.ownerRejectedPhoto": "To není majitelův předmět",
"fa.ownerRejectedPhotoText": "Majitel říká, že vaše fotografie neodpovídá jejich předmětu. Následná akce je uzavřena. Děkujeme za vaši pomoc!",
"fa.contribute": "Přispět",
"fa.phoneMissing": "Není poskytováno",
"fa.ownerSafety1": "Preferujte předání na veřejném místě nebo u partnera Findloop. Pokud je vzdálenost velká, navrhněte raději zaslání poštou.",
"fa.ownerSafety2": "Při předání zkontrolujte identifikaci nálezce.",
"pub.changePhoto": "Změnit foto",
"ph.secured": "Fotografie zabezpečena",
"ph.securing": "Zabezpečuji fotografii…",
"fa.ownerSafety3": "Pokud fotografie od nálezce nese watermark Findloop, nepřijímejte schůzku. Fotografie musí být originální snímek pořízený nálezcem, bez watermarku."
},
"ro": {
"a.back": "Înapoi",
"a.category": "Categorie",
"a.categoryPlaceholder": "Alege o categorie",
"a.city": "Oraș",
"a.confirmPassword": "Confirmați parola",
"a.country": "Țară",
"a.createAccount": "Creează un cont",
"a.createBtn": "Îmi creez contul",
"a.creating": "Creare…",
"a.email": "Email",
"a.emailPro": "Email de afaceri",
"a.forgot": "Ai uitat?",
"a.forgotSent": "Dacă există un cont, un link de resetare a fost trimis.",
"a.forgotSub": "Obține un link de resetare prin email.",
"a.forgotTitle": "Parolă uitată",
"a.googleContinue": "Continuați cu Google",
"a.googleSignup": "Înscrie-te cu Google",
"a.haveAccount": "Ești deja partener?",
"a.legalHint": "Necesar pentru facturarea electronică franceză (Factur-X) a unităților franceze.",
"a.legalRequiredFR": "SIRET și numărul de TVA intracomunitar sunt obligatorii pentru Franța.",
"a.loggingIn": "Autentificare…",
"a.login": "Autentificare",
"a.loginSub": "Accesați spațiul dvs. de administrare.",
"a.loginTitle": "Autentificare partener",
"a.min6": "Minimum 6 caractere",
"a.newPassword": "Parolă nouă",
"a.noAccount": "Nu ești încă partener?",
"a.or": "SAU",
"a.org": "Numele unității",
"a.password": "Parolă",
"a.passwordMismatch": "Parolele nu se potrivesc.",
"a.referral": "Cod de recomandare (opțional)",
"a.registerSub": "Creează-ți spațiul în 1 minut — gratuit pentru a începe.",
"a.registerTitle": "Deveniți partener",
"a.rememberMe": "Ține-mă minte",
"a.reset": "Resetare",
"a.resetSub": "Alegeți o parolă nouă pentru contul dvs.",
"a.resetTitle": "Parolă nouă",
"a.sendLink": "Trimite linkul",
"a.sending": "Se trimite…",
"a.signin": "Autentificare",
"a.siret": "SIRET",
"a.vat": "Număr TVA intracomunitar",
"ac.africa": "Africa",
"ac.boostActive": "Subliniere activă —",
"ac.boostSub": "Apareți în partea de sus a directorului partenerilor cu un badge „Boosted”.",
"ac.boostTitle": "Îmbunătățește-ți listarea în director",
"ac.categoryHint": "Pentru a clasifica unitatea dvs. în directorul findloop.",
"ac.choose": "Alege",
"ac.cityHint": "Pentru o poziționare precisă pe harta publică.",
"ac.cityLabel": "Orașul unității",
"ac.cityPh": "Paris",
"ac.contact": "Detalii de contact",
"ac.converted": "Convertit",
"ac.copyDeclLink": "Copiază linkul de declarație",
"ac.copyLink": "Copiază linkul",
"ac.currentPlan": "Plan curent",
"ac.emailDesc": "Alege emailurile pe care vrei să le primești. Notificările din spațiul tău de lucru rămân întotdeauna active.",
"ac.emailMatch": "Se potrivește",
"ac.emailMatchDesc": "Un email când un element se potrivește unei declarații",
"ac.emailNewDecl": "Declarații noi de pierdere",
"ac.emailNewDeclDesc": "Un e-mail imediat ce un client raportează o pierdere la tine",
"ac.emailShip": "Cereri de expediere",
"ac.emailShipDesc": "Un e-mail când un client solicită expedierea unui articol",
"ac.emailTitle": "Preferințe e-mail",
"ac.expireSoon": "Evidențierea ta expiră curând —",
"ac.exportCsv": "Export (CSV)",
"ac.exportHint": "Exportă plățile externe validate pentru contabilitatea ta.",
"ac.free": "Gratuit",
"ac.freeMonths": "Luni gratuite",
"ac.hours": "ore",
"ac.howItWorks": "Cum funcționează?",
"ac.invited": "Invitat",
"ac.legalFR": "Necesar pentru facturarea electronică (Factur-X) aplicabil din septembrie 2026.",
"ac.legalMissing": "⚠️ SIRET și TVA intra-UE lipsă — completează-le pentru a rămâne conform cu facturarea electronică.",
"ac.legalOther": "Recomandat pentru facturile tale.",
"ac.legalPartnerQr": "Cod QR",
"ac.legalTitle": "Identificatori legali (facturare)",
"ac.logoTitle": "Logo-ul unității",
"ac.modeCurrent": "Mod curent:",
"ac.modeExternal": "External (validare manuală)",
"ac.modeInternal": "Intern Findloop (auto)",
"ac.noSubReceipt": "Nu există încă plată pentru abonament.",
"ac.none": "Niciunul",
"ac.onYourListing": "pe lista ta",
"ac.pay1": "Introdu legăturile tale de plată mai jos pentru a redirecționa clienții către sistemul tău de colectare.",
"ac.pay2": "Validarea devine manuală: confirmi primirea plății din tab-ul “Declarații”.",
"ac.pay3": "Linkul „Taxă de expediere” este o plată consolidată (recuperare + expediere).",
"ac.pay4": "Lasă câmpurile necompletate pentru a folosi plata internă Findloop (Stripe) cu validare automată.",
"ac.paySub": "Colectează taxe prin propriul sistem de plată.",
"ac.payTitle": "Plăți externe",
"ac.permissive": "Permisiv",
"ac.phone": "Telefon",
"ac.posterA4": "Poster A4 (PDF)",
"ac.qMessage": "Mesaj (opțional)",
"ac.qName": "Nume",
"ac.qOrg": "Organizație",
"ac.qSites": "Numărul de unități (estimativ)",
"ac.qrHint": "Clienții tăi scanează acest cod pentru a raporta un articol pierdut.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Codul tău QR partener",
"ac.quoteDesc": "Aeroporturi, rețele feroviare, lanțuri internaționale · ",
"ac.quoteEurope": "Europa / Lume",
"ac.quoteSent": "Cererea de ofertă a fost trimisă. Echipa noastră te va contacta în curând.",
"ac.quoteTitle": "Solicită o ofertă — Întreprindere",
"ac.recoveryLink": "Linkul „Taxă de recuperare”",
"ac.refSub": "Fiecare partener referit care se abonează îți oferă 1 lună gratuită.",
"ac.refTitle": "Referă, câștigă o lună gratuită",
"ac.reminderDelay": "Întârziere memento validare",
"ac.reminderHint": "Vei primi un memento prin e-mail dacă o plată externă rămâne nevalidată dincolo de această întârziere (implicit: 48h).",
"ac.renewDesc1": "A câștigat deja pentru tine",
"ac.renewDesc2": "Renunță pentru a rămâne la vârful directorului și a nu pierde această vizibilitate.",
"ac.renewNow": "Renunță acum",
"ac.requestQuote": "Solicită o ofertă",
"ac.saveLegal": "Salvează identificatorii",
"ac.saveLinks": "Salvează legăturile",
"ac.sendRequest": "Trimite cererea mea",
"ac.sending": "Se trimite…",
"ac.shippingLink": "Linkul „Taxă de expediere” (consolidat)",
"ac.shippingLinkHint": "Acest link acoperă atât recuperarea, cât și expedierea.",
"ac.strict": "Strict",
"ac.subReceipt": "Chitanță de abonament (PDF)",
"ac.subReceiptsSub": "Descarcă chitanța PDF pentru fiecare plată a abonamentului.",
"ac.subReceiptsTitle": "Chitanțe de abonament",
"ac.tCategory": "Categorie salvată",
"ac.tCity": "Oraș salvat — hartă actualizată",
"ac.tCityNeeded": "Introdu un oraș",
"ac.tCopied": "Copiat!",
"ac.tCover": "Fotografia de copertă actualizată",
"ac.tEmailPrefs": "Preferințele de email actualizate",
"ac.tErr": "Eroare",
"ac.tExportImpossible": "Export imposibil",
"ac.tLegal": "Identificatori legali salvați",
"ac.tLegalNeeded": "SIRET și TVA necesare pentru Franța",
"ac.tLogo": "Logo actualizat",
"ac.tLogoRemoved": "Logo eliminat",
"ac.tPayLinks": "Linkuri de plată salvate",
"ac.tPhone": "Telefon salvat",
"ac.tSensitivity": "Sensibilitate salvată",
"ac.tVatInvalid": "Număr TVA invalid",
"ac.tVatValid": "TVA valid",
"ac.tabBoost": "Vizibilitate",
"ac.tabPayments": "Plăți",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Poster",
"ac.tabReferral": "Recomandare",
"ac.tabSub": "Abonament",
"ac.thisWeek": "Săptămâna aceasta",
"ac.thisWeekOf": " ({n} săptămâna aceasta)",
"ac.thresholdDesc": "Prag de încredere din care AI validează automat o potrivire a fotografiilor și notifică clientul. Mai mare = mai puține potriviri automate, dar mai fiabile.",
"ac.thresholdTitle": "Sensibilitatea potrivirii vizuale AI",
"ac.trend": "Tendință",
"ac.upload": "Încarcă",
"ac.vatValidFmt": "TVA valid{name} ({via})",
"ac.vatVerified": "TVA Intra-UE verificat",
"ac.verifyVat": "Verifică TVA (VIES)",
"ac.verifying": "Se verifică…",
"ac.views": "vizualizări",
"ac.viewsTotal": "Vizualizări câștigate (total)",
"ac.winbackBtn": "Reia cu -20%",
"ac.winbackDesc1": "Ai câștigat",
"ac.winbackDesc2": "Ofertă specială: -20% aplicat automat dacă rennoiești în termen de 24h.",
"ac.winbackTitle": "Evidența ta tocmai a expirat — reia cu -20%!",
"ad.boost": "Îmbunătățește",
"ad.close": "Închide",
"ad.closeConfirm": "Închizi această listare?",
"ad.closed": "Listare închisă",
"ad.edit": "Editează",
"ad.editTitle": "Editează listarea",
"ad.saved": "Listare actualizată",
"an.allCountries": "Toate țările",
"an.badge": "Obiecte pierdute",
"an.boostLater": "Mai târziu",
"an.boostNow": "Îmbunătățește acum",
"an.boostPrompt": "Îmbunătățește-ți listarea pentru a o plasa în vârf și a fi găsită mai repede.",
"an.boosted": "Îmbunătățită",
"an.contact": "Am găsit acest obiect",
"an.contactTitle": "Raportează că ai găsit acest obiect",
"an.copyFailed": "Nu s-a putut copia linkul",
"an.copyLink": "Copiază linkul",
"an.country": "Țară",
"an.date": "Data pierderii",
"an.finderEmail": "Emailul tău",
"an.finderName": "Numele tău",
"an.finderPhone": "Telefonul tău",
"an.geoBanner": "Vizualizezi anunțuri în",
"an.geoBannerWorld": "Vizualizezi anunțuri la nivel mondial",
"an.geoChange": "schimbă țara",
"an.goAccount": "Mergi la contul meu",
"an.linkCopied": "Link copiat!",
"an.loginRequired": "Conectează-te pentru a raporta acest obiect și a urmări întoarcerea.",
"an.loginToBoost": "Conectează-te pentru a promova acest anunț",
"an.lostAt": "Pierdut la",
"an.message": "Mesaj (opțional)",
"an.none": "Niciun anunț încă.",
"an.photo": "Fotografie (opțional)",
"an.post": "Postează un anunț",
"an.postSubtitle": "Descrie obiectul tău pierdut — comunitatea și partenerii noștri te ajută să-l găsești.",
"an.postTitle": "Raportează un obiect pierdut",
"an.publish": "Publică anunțul",
"an.published": "Anunț publicat!",
"an.publishing": "Publicare…",
"an.remaining": "rămas",
"an.requestInProgress": "Cererea este în curs de desfășurare",
"an.resolved": "Obiectul a fost deja recuperat",
"an.reward": "Recompensă",
"an.searchPh": "Caută un anunț…",
"an.send": "Trimite",
"an.sent": "Mesaj trimis proprietarului!",
"an.shareConsent": "Sunt de acord ca detaliile mele de contact (nume, email, telefon) să fie împărtășite cu proprietarul obiectului.",
"an.shareConsentError": "Te rog bifează căsuța pentru a împărtăși detaliile tale de contact.",
"an.sortRecent": "Cele mai recente",
"an.sortRelevance": "Relevanță",
"an.subtitle": "Răsfoiește obiectele raportate ca fiind pierdute de comunitate. Ai găsit unul dintre ele?",
"an.title": "Anunțuri pentru obiecte pierdute",
"anf.badge": "Obiecte găsite",
"anf.claim": "Aceasta este a mea",
"anf.claimSent": "Mesaj trimis celui care a găsit!",
"anf.claimTitle": "Raportează că acesta este obiectul tău",
"anf.consent": "Sunt de acord ca proprietarul să poată vedea detaliile mele de contact pentru a-și recupera obiectul.",
"anf.foundAt": "Găsit la",
"anf.foundDate": "Data găsirii",
"anf.loginCta": "Conectează-te / creează un cont",
"anf.loginDesc": "Un cont de găsitor este necesar pentru a publica un anunț și a câștiga puncte Finder Hero.",
"anf.loginRequired": "Conectează-te pentru a posta un obiect găsit",
"anf.photo": "Fotografia obiectului",
"anf.pointsEarned": "Îți mulțumim! Tocmai ai câștigat puncte Finder Hero.",
"anf.pointsPending": "Punctele tale vor fi creditate în termen de 24h, după verificare.",
"anf.post": "Postează un obiect găsit",
"anf.postSubtitle": "Descrie obiectul pe care l-ai găsit — ajută-i proprietarul să-l recupereze.",
"anf.postTitle": "Raportează un obiect găsit",
"anf.publishFound": "Publică anunțul găsit",
"anf.published": "Anunț pentru obiect găsit publicat",
"anf.publishedAs": "Publicat ca",
"anf.shareConsent": "Sunt de acord ca detaliile mele de contact (nume, email, telefon) să fie împărtășite cu persoana care a găsit obiectul.",
"anf.subtitle": "Răsfoiește obiectele găsite și raportate de comunitate. Îți recunoști obiectul?",
"anf.title": "Anunțuri pentru obiecte găsite",
"bo.active": "Promovare activă",
"bo.africaPrice": "Prețuri preferențiale pentru zona Africa aplicate",
"bo.pay": "Plătește & promovează",
"bo.remaining": "Timp rămas",
"bo.renew": "Reînnoiește boost-ul",
"bo.since": "din boost",
"bo.subtitle": "Pune anunțul tău în partea de sus a listei cu un badge vizibil.",
"bo.title": "Boost anunț",
"c.all": "Toate",
"c.cancel": "Anulează",
"c.close": "Închide",
"c.confirm": "Confirmă",
"c.confirmed": "Confirmat",
"c.download": "Descarcă",
"c.loading": "Se încarcă…",
"c.reset": "Resetare",
"c.reviews": "recenzii",
"c.save": "Salvează",
"c.transfer": "Transferă",
"cat.Animal": "Animal de companie / Accesorii pentru animale",
"cat.AppareilPhoto": "Cameră",
"cat.Argent": "Bani / Numerar",
"cat.Autres": "Altele",
"cat.Bijoux": "Bijuterii",
"cat.CarteBancaire": "Card bancar",
"cat.CarteIdentite": "Buletin / Pașaport",
"cat.Casquette": "Căciulă / Pălărie",
"cat.Ceinture": "Cureaua",
"cat.Chargeur": "Încărcător / Cablu",
"cat.Chaussures": "Pantofi",
"cat.CleVoiture": "Cheie de mașină",
"cat.Cles": "Chei",
"cat.Console": "Consola de jocuri",
"cat.Documents": "Documente / Hârtie",
"cat.Echarpe": "Fular",
"cat.Ecouteurs": "Căști",
"cat.Electronique": "Electronică (altele)",
"cat.Enceinte": "Difuzor",
"cat.Gants": "Mănuși",
"cat.Gourde": "Sticlă de apă / Thermos",
"cat.Instrument": "Instrument muzical",
"cat.Jouet": "Jucărie / Plush",
"cat.Jumelles": "Binoclu",
"cat.Lampe": "Lampă / Lanternă",
"cat.Liseuse": "Cititor electronic",
"cat.Livre": "Carte / Caiet",
"cat.Lunettes": "Ochelari",
"cat.Manteau": "Palton / Jachetă",
"cat.Maquillage": "Trusă de machiaj",
"cat.Medical": "Echipament medical",
"cat.Medicaments": "Medicamente",
"cat.Montre": "Ceas / Ceas inteligent",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Umbrelă",
"cat.Portefeuille": "Portofel / Clutch",
"cat.Poussette": "Cărucior / Accesorii pentru bebeluși",
"cat.Sac": "Geantă / Poșetă",
"cat.SacADos": "Rucsac",
"cat.Souris": "Mouse / Tastatură",
"cat.Sport": "Echipament sportiv",
"cat.Tablette": "Tabletă",
"cat.Telephone": "Telefon / Smartphone",
"cat.Trottinette": "Trotineta",
"cat.Trousse": "Pungă / Etui",
"cat.USB": "Stick USB / Hard disk",
"cat.Valise": "Valiză / Luggage",
"cat.Velo": "Bicicletă",
"cat.Vetements": "Îmbrăcăminte",
"cat.placeholder": "Alegeți o categorie",
"cd.d": "z",
"cd.expired": "Expirat",
"cd.h": "h",
"cd.m": "min",
"ck.accept": "Accept",
"ck.acceptAll": "Acceptă tot",
"ck.customize": "Personalizați",
"ck.learn": "Află mai multe",
"ck.manage": "Gestionează cookie-urile",
"ck.measurement": "Măsurarea audienței",
"ck.measurementDesc": "Statistici anonime pentru a îmbunătăți serviciul.",
"ck.msg": "Folosim cookie-uri pentru a menține site-ul funcțional și a măsura audiența.",
"ck.necessary": "Necesar",
"ck.necessaryDesc": "Esential pentru funcționarea site-ului. Întotdeauna activ.",
"ck.refuse": "Refuză",
"ck.save": "Salvează alegerile mele",
"ck.saved": "Preferințe salvate",
"ck.title": "Preferințele tale pentru cookie-uri",
"cm.found": "GĂSIT",
"cm.lost": "PIERDUT",
"cmp.adv": "Avansat",
"cmp.ai": "Potrivire AI",
"cmp.autobill": "Facturare automată",
"cmp.basic": "De bază",
"cmp.community": "Comunitate",
"cmp.consol": "Facturare consolidată",
"cmp.custom": "Personalizat",
"cmp.dedicated": "Dedicat",
"cmp.deploy": "Implementare dedicată & SLA",
"cmp.estIncl": "Unități incluse",
"cmp.estSec": "Unitate suplimentară",
"cmp.items": "Articole / lună",
"cmp.main": "1 principal",
"cmp.max20": "20 maxim",
"cmp.members": "Invitații pentru membri",
"cmp.onQuote": "Ofertă personalizată",
"cmp.priority": "Prioritate",
"cmp.starterEst": "1 inclus + nelimitat suplimentar",
"cmp.stats": "Statistici",
"cmp.statsAdv": "Avansat",
"cmp.statsBasic": "De bază",
"cmp.support": "Suport",
"cmp.unlimited": "Nelimitat",
"cmp.upTo3": "Până la 3",
"consent.required": "Trebuie să fii de acord să împărtășești detaliile tale de contact pentru a continua.",
"consent.share": "Sunt de acord ca persoana care găsește obiectul meu să poată vedea detaliile mele de contact (nume, email, telefon) pentru a mă contacta pentru returnare.",
"cover.add": "Adaugă",
"cover.change": "Schimbă",
"cover.helper": "Afișat ca un banner pe pagina ta de raport și în director.",
"cover.none": "Fără fotografie de copertă",
"cover.remove": "Șterge",
"cover.title": "Fotografie de copertă",
"crop.desc": "Ajustează raportul de cadru la banner (3:1). Trage și fă zoom.",
"crop.saving": "Se salvează…",
"crop.title": "Decupează fotografia de copertă",
"cta.button": "Creează contul meu de partener",
"cta.subtitle": "Alătură-te stabilimentelor care returnează articole mai repede cu findloop.",
"cta.title": "Pregătit să reduci articolele pierdute?",
"db.account.s": "Gestionează-ți stabilimentul, abonamentul și codul QR.",
"db.account.t": "Contul meu",
"db.declarations.s": "Clienți care au raportat un obiect pierdut prin codul tău QR.",
"db.declarations.t": "Raportări de pierdere",
"db.deposit.s": "Adaugă o fotografie, o categorie și o descriere.",
"db.deposit.t": "Înregistrează un obiect găsit",
"db.registry.s": "Toate obiectele găsite înregistrate la stabilimentul tău.",
"db.registry.t": "Registrul obiectelor",
"db.reviews.s": "Răspunde public recenziilor clienților tăi.",
"db.reviews.t": "Recenziile clienților",
"db.shipments.s": "Generați etichete și urmăriți coletele de trimis.",
"db.shipments.t": "Expediții",
"db.stats.s": "Indicatorii tăi cheie de performanță.",
"db.stats.t": "Statistici",
"db.team.s": "Invită-ți colegii să gestioneze articolele.",
"db.team.t": "Echipă",
"dc.partnerDesc": "Ai pierdut obiectul la un partener (hotel, gară, sală…)? Selectează-l pentru o returnare directă.",
"dc.partnerList": "Alege din listă",
"dc.partnerMap": "Alege de pe hartă",
"dc.partnerTitle": "Declarație la un partener",
"dc.publicCta": "Publică un anunț public",
"dc.publicDesc": "Anunțul tău va fi vizibil întregii comunități findloop. Ideal dacă nu știi unde ai pierdut obiectul.",
"dc.publicTitle": "Declarație publică",
"dc.subtitle": "Alege cum să raportezi obiectul tău pierdut.",
"dc.title": "Ce ai dori să faci?",
"dec.addrPending": "Adresă în așteptare de la client",
"dec.analyzing": "Analizăm…",
"dec.badge": "Raport de pierdere",
"dec.category": "Categorie de obiect",
"dec.clientDescription": "Descrierea clientului",
"dec.clientPhoto": "Fotografie furnizată de client",
"dec.clientPhotoShort": "Fotografia clientului",
"dec.comparePhotos": "Compară fotografiile",
"dec.contactTitle": "Detaliile tale de contact",
"dec.date": "Data pierderii",
"dec.declaredItemPhoto": "Fotografie a obiectului declarat",
"dec.descPh": "Descrie obiectul: marcă, culoare, semne distincte…",
"dec.description": "Descriere",
"dec.email": "Email",
"dec.emptyDesc": "Distribuie codul tău QR pentru a primi declarații.",
"dec.emptyTitle": "Fără declarații",
"dec.enlarge": "Îngroașă",
"dec.extBanner": "{n} plată(e) extern(e) de validat — confirmă primirea mai jos pentru a debloca predarea sau expedierea.",
"dec.foundItemAlt": "Obiect găsit",
"dec.foundItemRegistry": "Obiect găsit (registru)",
"dec.home": "Înapoi la început",
"dec.labelClient": "Client",
"dec.labelRegistry": "Registru",
"dec.matchFound": "O potrivire a fost deja identificată!",
"dec.name": "Nume complet",
"dec.noMatchYet": "Nicio potrivire până acum.",
"dec.noPhoto": "Fără fotografie",
"dec.notfound": "Partenerul nu a fost găsit.",
"dec.pRecup": "recuperare",
"dec.pRecupP": "(recuperare)",
"dec.pRecupShip": "(recuperare + expediere)",
"dec.payConfirmed": "Plata {x} confirmată",
"dec.payPending": "Plata externă {x} în așteptare",
"dec.phone": "Telefon",
"dec.pickup": "Ridicare personală",
"dec.place": "Locul pierderii",
"dec.placePh": "de ex. la bar, camera 204…",
"dec.recoverBtn": "Recuperează articolul meu",
"dec.reject": "Respinge",
"dec.rerun": "Reefectuează analiza",
"dec.similarity": "Similaritate {n}%",
"dec.submit": "Trimite raportul meu",
"dec.submitting": "Se trimite…",
"dec.successText": "Căutăm articolul tău printre cele păstrate la",
"dec.successTitle": "Raport trimis!",
"dec.suggestedMatches": "Sugestii de potrivire",
"dec.toColon": " către:",
"dec.toShip": "De expediat",
"dec.toastExtPay": "Plata confirmată — clientul va fi notificat.",
"dec.toastMatch": "Potrivire confirmată",
"dec.toastReject": "Sugestie respinsă",
"dec.toastRerun": "Analiza repornită",
"dec.toastVisualN": "{n} potriviri vizuale",
"dec.toastVisualNone": "Nici o potrivire vizuală",
"dec.trackBtn": "Urmează raportul meu",
"dec.viewBeforeAfter": "Vedere înainte/după (suprapunere)",
"dec.viewSideBySide": "Vedere unul lângă altul",
"dec.visualCompare": "Comparare vizuală AI",
"dec.visualIdle": "Execută comparația pentru ca AI să potrivească vizual fotografia clientului cu articolele găsite.",
"dec.visualRunning": "AI compară fotografia clientului cu articolele din registrul tău…",
"dec.zoomPhoto": "Mărește fotografia",
"dep.addAnyway": "Adaugă oricum",
"dep.addError": "Eroare la adăugare",
"dep.addItem": "Adaugă articol",
"dep.added": "Articol adăugat în registru!",
"dep.adding": "Adăugare…",
"dep.aiError": "Analiza AI nu este disponibilă acum.",
"dep.aiFilled": "Formular completat de AI ✨",
"dep.aiUnavailable": "AI indisponibil — completează formularul manual.",
"dep.analyzing": "Analizăm…",
"dep.analyzingPhoto": "Analizăm fotografia…",
"dep.brand": "Marcă",
"dep.brandPlaceholder": "de ex. Apple",
"dep.category": "Categorie",
"dep.checkingDup": "Verificăm duplicatul…",
"dep.color": "Culoare",
"dep.colorPlaceholder": "de ex. negru",
"dep.condition": "Stare",
"dep.conditionPlaceholder": "de ex. stare bună",
"dep.depositorNote": "Notă a depositarului",
"dep.depositorNoteHint": "Detalii operaționale scrise de mână. AI nu va suprascrie niciodată această notă.",
"dep.depositorNotePlaceholder": "de ex. conținutul unui pachet, marca așa cum s-a raportat, detalii furnizate de persoană…",
"dep.descPlaceholder": "de ex. iPhone 15 negru cu husă transparentă, găsit la bar…",
"dep.description": "Descriere",
"dep.dupHint": "Asigură-te că nu adaugi un duplicat. Poți continua dacă articolul este cu adevărat diferit.",
"dep.dupTitle": "Articol(e) similar(e) deja înregistrat(e)",
"dep.dupWarn": "Articol similar detectat — revizuiește, apoi apasă din nou pentru a confirma.",
"dep.estHint": "Articolul va fi adăugat în registrul acestui stabiliment.",
"dep.establishment": "Stabiliment",
"dep.fee": "Taxa de recuperare (€) — opțională",
"dep.feePlaceholder": "Lasă gol pentru prețul implicit al categoriei",
"dep.fillAI": "Completează cu AI",
"dep.optional": "(opțional)",
"dep.photo": "Fotografie articol",
"dep.principal": "principal",
"dep.reqError": "Categorie și descriere sunt necesare.",
"dep.savedItem": "Articol înregistrat",
"dep.similarity": "Similaritate",
"dep.storage": "Locație fizică",
"dep.storageHint": "Unde este stocat fizic articolul. Un cod QR va fi generat pentru a-l găsi.",
"dep.storagePlaceholder": "de exemplu. Raft A3, Dulap 12, seif Recepție",
"dl.aClient": "un client",
"dl.alertsBlocked": "Alerta browser-ului blocată",
"dl.alertsBlockedHint": "Pentru a le reactiva: faceți clic pe iconița 🔒 (sau ⓘ) din stânga adresei site-ului, apoi permiteți Notificările și reîncărcați pagina.",
"dl.amountDue": "Sumă de plată: {amount} {currency}.",
"dl.enableAlerts": "Activare alerte",
"dl.extPending": "Plăți de validat",
"dl.freemiumNear": "Te apropii de limita Freemium ({used}/{max} articole în această lună). Îmbunătățește la Starter pentru articole nelimitate.",
"dl.freemiumReached": "Limita Freemium atinsă ({used}/{max} articole în această lună). Îmbunătățează la Starter pentru a înregistra articole nelimitate.",
"dl.invoiceOverdue": "Factura {num} neachitată — acces restricționat.",
"dl.matchNotifTitle": "Findloop — Nouă potrivire AI 🔔",
"dl.matchToast": "Nouă potrivire AI — {name}",
"dl.matchToastDesc": "Un articol se potrivește cu o declarație.",
"dl.notifEmpty": "Nu sunt încă notificări.",
"dl.notifEnabled": "Alerte browser active",
"dl.notifTitle": "Notificări",
"dl.payInvoice": "Plătește factura mea →",
"dl.rewardsPending": "Vouchere de prezentat",
"dl.upgradeStarter": "Îmbunătățește la Starter →",
"est.all": "Toate stabilimentele ({n})",
"est.label": "Stabiliment",
"est.primary": "principal",
"est.secondary": "secundar",
"est2.add": "Adaugă un stabiliment",
"est2.addressLabel": "Adresă",
"est2.addressPh": "Strada 12 République",
"est2.autoInvoice": "O factură detaliată este generată automat pe 1 a fiecărei luni.",
"est2.baseSub": "Abonament de bază",
"est2.billing": "Facturare",
"est2.boostActivated": "Boost activat pentru {name}",
"est2.boostBillingNote": "Facturat la tariful actual și grupat pe factura ta lunară consolidată.",
"est2.boostCta": "Boost",
"est2.boostDesc": "Îmbunătățește vizibilitatea acestui stabiliment în director și pe hartă.",
"est2.boostDuration": "{h}h de vizibilitate îmbunătățită",
"est2.boostExtend": "Extinde",
"est2.boostTitle": "Boost {name}",
"est2.boosted": "Boosted",
"est2.chartDesc": "Ponderea articolelor returnate din totalul înregistrat, site cu site.",
"est2.chartTitle": "Rata de returnare pe stabiliment",
"est2.chartTooltip": "Returnare",
"est2.cityLabel": "Oraș",
"est2.cityPh": "Lyon",
"est2.contactHint": "Aceste detalii sunt afișate clientului pentru acest stabiliment (se va reveni la cont dacă sunt goale).",
"est2.countryLabel": "Țară",
"est2.coverLabel": "Poză de copertă",
"est2.create": "Creează",
"est2.created": "Stabiliment creat",
"est2.delete": "Șterge",
"est2.deleteDesc": "Această acțiune este permanentă. Poți șterge un stabiliment doar dacă nu conține articole.",
"est2.deleteTitle": "Șterge “{name}”?",
"est2.deleted": "Stabiliment șters",
"est2.dialogDesc": "Introdu numele și adresa acestui site.",
"est2.edit": "Editează",
"est2.editEst": "Editează stabilimentul",
"est2.emailLabel": "Email de contact",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " stabiliment(e)",
"est2.extraNoteBase": "{n} stabiliment(e) suplimentar(e) facturate",
"est2.extraPrice": " la {price} €/lună.",
"est2.extraQuote": " pe ofertă.",
"est2.imgChange": "Alege o imagine",
"est2.imgDone": "Finalizat",
"est2.imgRemove": "Înlătură",
"est2.imgRemoved": "Imagine ștearsă",
"est2.imgSaved": "Imagine salvată",
"est2.imgUploading": "Se încarcă…",
"est2.includedPlan": "Inclus în planul tău: {n}.",
"est2.kDeclarations": "Declarații",
"est2.kInStorage": "În stoc",
"est2.kItemsTotal": "Articole (total)",
"est2.kRestituted": "Restituit",
"est2.limitReached": "Limită atinsă",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Decl.",
"est2.mItems": "Articole",
"est2.mRestituted": "Restituit",
"est2.mStorage": "În stoc",
"est2.monthlyTotal": "Total lunar",
"est2.nameLabel": "Nume *",
"est2.namePh": "de ex. Belmont Hotel — Anexa Lyon",
"est2.newEst": "Stabiliment nou",
"est2.onQuote": "Pe ofertă",
"est2.phoneLabel": "Telefon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plan",
"est2.planLimited": "Planul tău „{tier}” este limitat la {max} stabiliment(e).",
"est2.primary": "Primar",
"est2.qr": "Cod QR",
"est2.qrDesc": "Afișează acest cod QR în acest stabiliment. Clienții care raportează o pierdere vor fi legați de acest site.",
"est2.qrTitle": "Cod QR — {name}",
"est2.saving": "Se salvează…",
"est2.seeInvoices": "Vezi facturile lunare",
"est2.seePlans": "Vezi planurile",
"est2.subtitle": "Gestionează toate site-urile tale dintr-un singur cont — vedere consolidată, articole, cod QR și facturare.",
"est2.suspended": "Suspendat",
"est2.tierFree": "1 stabiliment",
"est2.tierLarge": "stabilimente nelimitate",
"est2.tierMedium": "5 stabilimente incluse",
"est2.tierSmall": "3 stabilimente incluse",
"est2.title": "Stabilimente",
"est2.unlimitedPlan": "Planul tău permite un număr nelimitat de stabilimente.",
"est2.unlimitedSuffix": " · nelimitat",
"est2.updated": "Stabiliment actualizat",
"est2.upgradeHint": "Upgradează la un plan superior pentru a adăuga mai multe site-uri și a centraliza toată activitatea ta.",
"est2.visuals": "Logo & poză",
"est2.visualsDesc": "Personalizează logo-ul și poza de acoperire a acestui stabiliment. Acestea apar pe pagina publică și pe formularul de declarație.",
"est2.visualsTitle": "Vizuale — {name}",
"est2.workOn": "Lucrează la acest stabiliment",
"est2.working": "Lucrezi la „{name}”",
"ev.created": "Raport creat",
"ev.matched": "Articolul corespunzător identificat",
"ev.paid": "Taxa de recuperare plătită",
"ev.pickup": "Ridicare la fața locului",
"ev.shipped": "Pachet expediat",
"ev.shipping_paid": "Taxa de expediere plătită",
"ev.shipping_requested": "Expedierea solicitată",
"feat1.d": "KPI-uri, rata de returnare pe categorii, venit și tendințe pe 30 de zile.",
"feat1.t": "Tabloul de bord & analize",
"feat2.d": "Etichete, urmărirea transportatorului și e-mailuri automate de urmărire.",
"feat2.t": "Modul de expediere",
"feat3.d": "Clienții te găsesc după oraș și categorie, cu recenzii certificate.",
"feat3.t": "DIRECTOR PUBLIC & recenzii",
"fp.backToRanking": "Înapoi la tabela de clasament",
"fp.badge": "Insignă",
"fp.hero": "Eroul Finder",
"fp.notFound": "Profilul nu a fost găsit sau este privat.",
"fp.scoreTotal": "Puncte totale",
"fp.scoreYear": "Puncte în",
"fp.share": "Împărtășește acest profil",
"fp.shareText": "Verifică profilul finder al lui {name} pe Findloop!",
"fp.tagline": "Un finder onest care face lumea un loc mai bun.",
"ft.backAccount": "Înapoi la Contul meu",
"ft.closeBtn": "Închide cazul",
"ft.closeConfirm": "Confirmi că articolul a fost returnat? Reclama va fi închisă.",
"ft.closeLockedHint": "Validare codul proprietarului mai întâi pentru a debloca închiderea.",
"ft.closed": "Caz închis — articol returnat!",
"ft.codeLabel": "Introdu codul de validare primit de la proprietar",
"ft.codeNeeded": "Te rugăm să introduci codul de validare.",
"ft.codeOk": "Cod validat — poți închide cazul.",
"ft.codePlaceholder": "de ex. 4821",
"ft.codeVerified": "Validat",
"ft.doneMsg": "Articol returnat. Mulțumim că ai ajutat la returnarea acestuia proprietarului!",
"ft.stepInProgress": "Returnare în curs",
"ft.stepPublished": "Reclamă publicată",
"ft.stepReturned": "Articol returnat",
"ft.subtitle": "Urmează pașii până când articolul găsit este returnat.",
"ft.title": "Urmărirea returnării",
"ft.verifyBtn": "Validare cod",
"hero.badge": "Prezentat",
"hero.ctaFound": "Am găsit un articol",
"hero.ctaLost": "Am pierdut un articol",
"hero.ctaPartner": "Devino partener",
"hero.subtitle": "Findloop ajută instituțiile să gestioneze articolele găsite — și le permite clienților să raporteze o pierdere și apoi să-și recupereze bunurile, la fața locului sau prin expediere.",
"hero.title": "Fiecare articol pierdut își găsește proprietarul.",
"home.champBecome": "Devino un finder",
"home.champCta": "Vezi tabela de clasament",
"home.champSubtitle": "Fiecare articol returnat câștigă puncte. Alătură-te tabelei de clasament și câștigă recompense.",
"home.champTitle": "Cei mai buni finderi ai noștri",
"how.eyebrow": "Cum funcționează",
"how.title": "De la predare la returnare, fără efort.",
"inv.all": "Toate",
"inv.allYears": "Toți anii",
"inv.count": "Facturi",
"inv.due": "scadent",
"inv.empty": "Nu sunt facturi încă.",
"inv.exportCsv": "Exportă CSV",
"inv.invoicePdf": "Factură PDF",
"inv.issued": "Emis",
"inv.noMatch": "Nu există factură pentru acest filtru.",
"inv.paid": "Plătit (€)",
"inv.paidOn": "plătit pe",
"inv.pay": "Plătește",
"inv.receipt": "Chitanță",
"inv.reminders": "Memento-uri",
"inv.remindersDesc": "Memento-uri trimise prin Email și SMS pentru această factură.",
"inv.remindersEmpty": "Niciun memento trimis.",
"inv.rmDue": "Memento pentru data limită",
"inv.rmManual": "Memento manual",
"inv.rmSms": "Memento SMS D+30",
"inv.rmStage": "Memento",
"inv.statusPaid": "Plătit",
"inv.statusUnpaid": "Neplătit",
"inv.subtitle": "Vizualizează și descarcă facturile și chitanțele tale.",
"inv.title": "Facturile mele",
"inv.unpaid": "Neplătit (€)",
"inv2.contractTitle": "Contractul meu Findloop",
"inv2.detailByEst": "Detalii după unitate",
"inv2.dueLabel": "Scadent:",
"inv2.dueSuffix": " · scadent {date}",
"inv2.error": "Eroare {status}",
"inv2.estCountIssued": "{n} unitate (i) · emis pe {date}",
"inv2.estimate": "Estimare (nefacturată) · {n} unitate (i)",
"inv2.expired": " · expirat",
"inv2.exportCsv": "Export CSV",
"inv2.exportDone": "Export CSV descărcat",
"inv2.included": "Inclus",
"inv2.monthlyTitle": "Facturare lunară (abonament)",
"inv2.months": "+{n} luni",
"inv2.paid": "Plătit",
"inv2.pay": "Plătește",
"inv2.previewTitle": "Previzualizarea următoarei facturi —",
"inv2.renew": "Reînnoiesc contractul meu",
"inv2.renewalsTitle": "Istoricul reînnoirilor ({n})",
"inv2.renewedUntil": "Contract reînnoit până la {date}",
"inv2.serviceTitle": "Facturi pentru servicii (recuperări și oferte)",
"inv2.soon": "Expiră în curând",
"inv2.toPay": "De plătit",
"inv2.totalHtTva": "Total excl. taxă · TVA",
"inv2.totalTtc": "Total incl. taxă",
"iu.addPhoto": "Adaugă o fotografie",
"iu.change": "Schimbă",
"lang.label": "Limba",
"lb.allCountries": "Toate țările",
"lb.badge": "Clasament anual",
"lb.champion": "🏆 Campionul anului",
"lb.cityPh": "Filtrează după oraș…",
"lb.empty": "Nu există clasament pentru aceste filtre încă.",
"lb.pts": "puncte",
"lb.resetNote": "Clasamentul anului curent — resetează pe 1 ianuarie.",
"lb.returned": "returnat",
"lb.share": "Distribuie clasamentul",
"lb.shareText": "Verifică clasamentul celor mai buni găsitori pe Findloop!",
"lb.subtitle": "Fiecare returnare câștigă puncte. Clasamentul se resetează pe 1 ianuarie.",
"lb.tabFinders": "Găsitori",
"lb.tabPartners": "Unități",
"lb.title": "Cei mai buni găsitori",
"lost.b2bDesc": "L-ai pierdut într-un hotel, hub de transport sau loc de partener? Găsește unitatea și raportează pierderea ta.",
"lost.b2bTitle": "Raportează unui partener",
"lost.b2cDesc": "Publică un anunț vizibil pentru toată lumea, oferă o recompensă și promovează-l pentru a-ți maximiza șansele.",
"lost.b2cTitle": "Postează un anunț public",
"lost.desc": "Alege cum vrei să procedezi.",
"lost.title": "Ai pierdut un obiect?",
"map.allCategories": "Toate categoriile",
"map.clear": "Resetare",
"map.exitFullscreen": "Ieșire",
"map.filterCity": "Oraș sau țară…",
"map.fullscreen": "Mod complet",
"map.heatmap": "Harta de căldură",
"map.high": "Ridicat",
"map.impactMonth": "obiecte returnate în această lună",
"map.impactTotal": "returnate în total",
"map.legend": "Puncte colorate de la roșu (scăzut) la verde (ridicat) în funcție de rata de returnare; dimensiunea bazată pe numărul de obiecte.",
"map.locating": "Localizare… adaugă o adresă la stabilimentele tale pentru a le vedea pe hartă.",
"map.low": "Scăzut",
"map.mAll": "Toate",
"map.mFound": "Găsite",
"map.mLost": "Pierdute",
"map.medium": "Medie",
"map.noItemRegistered": "Niciun obiect înregistrat",
"map.noItems": "Niciun obiect",
"map.period30": "Ultimele 30 de zile",
"map.period7": "Ultimele 7 zile",
"map.period90": "Ultimele 90 de zile",
"map.periodAll": "Toată perioada",
"map.returnedSuffix": "returnate · {a}/{t} obiecte",
"map.stats": "Statistici pe oraș",
"map.statsTop": "Primele 5 locuri (obiecte pierdute)",
"map.statsTrend": "Tendința pe 6 luni",
"map.title": "Harta stabilimentelor tale",
"map.topPlaces": "Locuri populare",
"mc.adClosed": "Anunț închis",
"mc.addPhoto": "Adaugă o foto",
"mc.adsNone": "Niciun anunț pentru obiecte pierdute.",
"mc.archiveHide": "Ascunde istoria",
"mc.archiveNone": "Niciun caz rezolvat încă.",
"mc.archiveShow": "Arată istoria",
"mc.archiveSub": "Cazuri rezolvate și returnate.",
"mc.archiveTitle": "Istoric",
"mc.at": "La",
"mc.backToLogin": "Înapoi la conectare",
"mc.boostContacts": "Contacte (boost)",
"mc.boostViews": "Vizualizări (boost)",
"mc.cancel": "Anulează",
"mc.certificate": "Certificat",
"mc.changePhoto": "Schimbă foto",
"mc.city": "Oraș",
"mc.closeAd": "Închide",
"mc.closeAdConfirm": "Închizi acest anunț? Nu va mai fi vizibil și va elibera un loc.",
"mc.confirmPassword": "Confirmă parola",
"mc.confirmRestitution": "Confirmă returnarea",
"mc.connect": "Conectează-te",
"mc.contacts": "Contacte",
"mc.country": "Țară",
"mc.declareFound": "Raportează un obiect găsit",
"mc.declareFoundSub": "Postează un obiect pe care l-ai găsit",
"mc.declareLost": "Raportează o pierdere",
"mc.declareLostSub": "Postează un anunț pentru obiecte pierdute",
"mc.deleteAccount": "Șterge contul meu",
"mc.deleteConfirm": "Da, șterge contul meu",
"mc.deleteConfirmBody": "Contul tău va fi șters permanent și datele tale personale vor fi anonimizate. Această acțiune nu poate fi anulată.",
"mc.deleteConfirmTitle": "Șterge contul tău?",
"mc.deleteDesc": "Șterge permanent contul tău și anonimizează datele tale personale. Această acțiune nu poate fi anulată.",
"mc.deleted": "Contul tău a fost șters.",
"mc.deleting": "Se șterge…",
"mc.email": "Email",
"mc.expiresOn": "Expiră pe",
"mc.exportData": "Descarcă datele mele (GDPR)",
"mc.exportDone": "Datele tale au fost descărcate.",
"mc.exporting": "Se pregătește…",
"mc.finderAccepted": "Acceptat",
"mc.finderProfile": "Profilul finder-ului (opțional)",
"mc.finderProfileDesc": "Câștigă puncte returnând articole și apari pe tabelul de clasament public.",
"mc.forYourAd": "Pentru anunțul tău",
"mc.forgotLink": "Ai uitat parola?",
"mc.forgotSend": "Trimite linkul",
"mc.forgotSent": "Dacă există un cont pentru acest email, un link de resetare a fost trimis.",
"mc.forgotTitle": "Ai uitat parola",
"mc.foundAdsNone": "Niciun anunț cu articole găsite publicat.",
"mc.foundAt": "Găsit la",
"mc.foundNone": "Niciun articol găsit raportat.",
"mc.hAd": "Anunț pierdut",
"mc.hDeclaration": "Declarație",
"mc.hFinderContact": "Articol raportat",
"mc.hFound": "Articol returned",
"mc.hFoundAd": "Anunț găsit",
"mc.histEarned": "Articol returnat",
"mc.historyTitle": "Istoricul meu de puncte",
"mc.loginBtn": "Conectează-te",
"mc.loginTitle": "Conectare client",
"mc.logout": "Deconectează-te",
"mc.lostAt": "Pierdut la",
"mc.matchPartner": "La un partener",
"mc.matchPublic": "Articol găsit",
"mc.matches": "Potriviri",
"mc.matchesSub": "Articolele găsite pot corespunde anunțurilor tale cu articole pierdute.",
"mc.myAds": "Anunțurile mele cu articole pierdute",
"mc.myDeclarations": "Rapoartele mele",
"mc.myFinds": "Articolele pe care le-am găsit",
"mc.myFindsNone": "Nu ai raportat că ai găsit niciun articol încă.",
"mc.myFindsSub": "Articolele pe care le-ai raportat că le-ai găsit în anunțurile cu articole pierdute.",
"mc.myFound": "Articole găsite raportate",
"mc.myFoundAds": "Anunțurile mele cu articole găsite",
"mc.myRewards": "Voucherele mele",
"mc.name": "Numele complet",
"mc.newPassword": "Parolă nouă",
"mc.none": "Niciun raport încă.",
"mc.notEnough": "Nu sunt suficiente puncte",
"mc.notifEmpty": "Niciună notificare încă.",
"mc.notifOpen": "Vizualizează",
"mc.notifTitle": "Notificări",
"mc.notifTrack": "Urmărește",
"mc.notifViewAd": "Vizualizează anunțul",
"mc.optInDesc": "Participare opțională. Îți dai consimțământul să afișezi public articolele selectate mai jos. Poate fi schimbat în orice moment.",
"mc.optInTitle": "Apari pe tabelul de clasament public",
"mc.password": "Parolă",
"mc.passwordMismatch": "Parolele nu se potrivesc.",
"mc.phone": "Telefon",
"mc.photoUpdated": "Fotografia de profil a fost actualizată",
"mc.pointsAwaiting": "Puncte în așteptare",
"mc.pointsBalance": "Puncte de cheltuit",
"mc.pointsOk": "Puncte creditate",
"mc.presentHint": "Arată acest QR partenerului: ei îl scanează pentru a valida recompensa ta.",
"mc.presentInStore": "Arată în magazin",
"mc.presentTitle": "Arată acest voucher",
"mc.privacy": "Confidențialitate & date",
"mc.privacyDesc": "Descarcă o copie a tuturor datelor personale pe care Findloop le deține despre tine (GDPR, art. 15 & 20).",
"mc.profileSaved": "Profil actualizat.",
"mc.profileSettings": "Profil public & clasament",
"mc.pseudo": "Prenume sau poreclă",
"mc.redExpired": "Expirat",
"mc.redReady": "Arată partenerului",
"mc.redUsed": "Folosit",
"mc.redeem": "Răscumpără",
"mc.registerBtn": "Creează-mi contul",
"mc.registerTitle": "Creează un cont de client",
"mc.rememberMe": "Ține-mă minte",
"mc.remove": "Elimină",
"mc.resetDone": "Parola actualizată. Te poți conecta acum.",
"mc.resetExpired": "Acest link de resetare este invalid sau a expirat. Solicită unul nou mai jos.",
"mc.resetSave": "Resetează-mi parola",
"mc.resetTitle": "Parolă nouă",
"mc.restitutionConfirmed": "Returnare confirmată.",
"mc.reward": "Recompensă",
"mc.rewardRedeemed": "Recompensa deblocat! Cod:",
"mc.rewardsDesc": "Folosește-ți punctele pentru beneficii oferite de partenerii noștri. Sold:",
"mc.rewardsNone": "Nicio recompensă disponibilă încă.",
"mc.rewardsTitle": "Cheltuiește-mi punctele",
"mc.scoreAwarded": "Bravo! +1 la scorul tău Finder 🎉",
"mc.scoreEarned": "Punct câștigat",
"mc.scorePts": "pts",
"mc.scoreThisYear": "Anul acesta",
"mc.scoreTitle": "Scor Finder",
"mc.seeRanking": "Vezi clasamentul",
"mc.share": "Împărtășește",
"mc.statsTitle": "Statistici",
"mc.subtitle": "Urmărește toate rapoartele tale într-un singur loc.",
"mc.title": "Contul meu",
"mc.toLogin": "Deja înregistrat?",
"mc.toRegister": "Încă nu ai cont?",
"mc.track": "Urmărește",
"mc.views": "Vizionări",
"mc.visCity": "Oraș",
"mc.visCountry": "Țară",
"mc.visLabel": "Articole vizibile în clasament:",
"mc.visName": "Prenume / poreclă",
"mc.visPhoto": "Fotografie de profil",
"mc.welcome": "Salut",
"mc2.acceptFinder": "Acceptă acest finder",
"mc2.accountActivity": "Activitate cont",
"mc2.adsActive": "{n}/5 reclame active",
"mc2.autoDelete": "Ștergere automată programată pentru",
"mc2.badgeBronze": "Bronz",
"mc2.badgeGold": "Aur",
"mc2.badgeSilver": "Argint",
"mc2.boostEarnedAlready": "Ți-a câștigat deja",
"mc2.boostEarnedWin": "Ți-a câștigat",
"mc2.boostExpiredWin": "Boost-ul tău tocmai a expirat — reia la -20%!",
"mc2.boostExpiresIn": "Boost-ul tău expira în",
"mc2.boostWinDetail2": ". -20% aplicat automat dacă reînnoiești în 24h.",
"mc2.claimCode": "Cod de revendicare:",
"mc2.codeSentFinder": "Cod trimis finder-ului prin email",
"mc2.daysShort": "{n} z",
"mc2.downloadReceipt": "Descarcă chitanța mea",
"mc2.error": "Eroare {status}",
"mc2.finderAccepted": "Finder acceptat — cod trimis prin email",
"mc2.finderContacts": "Detalii de contact ale finder(ilor)",
"mc2.followFindo": "Urmărește Findloop",
"mc2.imgInvalid": "Imagine invalidă",
"mc2.inactivityNote": " — în cazul a {n} luni de inactivitate (GDPR).",
"mc2.lastActivity": "Ultima activitate:",
"mc2.lostEmailTitle": "Nu mai am acces la emailul meu",
"mc2.noPhotoPreset": "Nu ai o fotografie încă? Alege un avatar implicit:",
"mc2.paidViaPartner": "Plătit (prin partener)",
"mc2.payRecovery": "Plătește taxa de recuperare",
"mc2.paySettle": "Reglează plata",
"mc2.payShipping": "Plătește taxa de livrare",
"mc2.payUnavailable": "Plata indisponibilă",
"mc2.peopleFound": "{n} persoană(e) cred că au găsit obiectul tău",
"mc2.phoneNumber": "Număr de telefon",
"mc2.reactivateAccount": "Reactivează contul meu",
"mc2.reactivated": "Cont reactivat",
"mc2.reactivatedThanks": "Cont reactivat — mulțumim pentru loialitate!",
"mc2.recoverSmsBtn": "Primesc codul meu prin SMS",
"mc2.recoverSmsDesc": "Primește codul tău de revendicare prin SMS la numărul înregistrat pe cont.",
"mc2.recoverSmsFallback": "Dacă există un cont cu acest număr, a fost trimis un SMS.",
"mc2.renewStayTop": ". Reînnoiește pentru a rămâne în frunte și a recupera obiectul tău.",
"mc2.resume20": "Reia -20%",
"mc2.unlockContacts": "Deblochează detaliile de contact",
"mc2.unlockDesc": "Plătește taxa de manipulare Findloop pentru a dezvălui detaliile lor de contact și a organiza predarea.",
"mc2.viewsWord": "vizualizări",
"mc2.live": "Live",
"mh.allCategories": "Toate categoriile",
"mh.allPeriod": "Tot timpul",
"mh.autoMatch": "Potrivire automată AI",
"mh.blocked": "Blocat (contradictie)",
"mh.blockedReason": "Potrivire blocată: cuvintele cheie principale ale obiectului și declarația se contrazic.",
"mh.days30": "Ultimele 30 de zile",
"mh.days7": "Ultimele 7 zile",
"mh.days90": "Ultimele 90 de zile",
"mh.emptyDesc": "Potrivirile AI vor apărea aici pe măsură ce declarațiile sosesc.",
"mh.emptyTitle": "Niciun eveniment",
"mh.exportCsv": "Export CSV",
"mh.exportDone": "Export CSV descărcat",
"mh.exportImpossible": "Export eșuat",
"mh.fBlocked": "Blocat",
"mh.fConfirmed": "Confirmat",
"mh.fRejected": "Respins",
"mh.objectLabel": "Obiect:",
"mh.refresh": "Reîmprospătează",
"mh.rejected": "Respins",
"mh.srcManual": "Manual",
"mh.srcText": "Text",
"mh.srcVisual": "Vizual (foto)",
"mh.subtitle": "Jurnal al potrivirilor propuse de AI — potrivite automat, confirmate și respinse.",
"mh.title": "Istoric AI",
"nav.ads": "Obiecte pierdute",
"nav.dashboard": "Spațiul meu",
"nav.found": "Obiecte găsite",
"nav.how": "Cum funcționează",
"nav.login": "Conectează-te",
"nav.map": "Hartă",
"nav.more": "Mai multe",
"nav.partners": "Parteneri",
"nav.pricing": "Prețuri",
"nav.ranking": "Clasament",
"nav.register": "Deveniți partener",
"nav.track": "Urmăriți o declarație",
"nf.desc": "Pagina pe care o căutați nu există sau a fost mutată.",
"nf.home": "Înapoi la început",
"nf.title": "Pagina nu a fost găsită",
"par.allCities": "Toate orașele",
"par.allCountries": "Toate țările",
"par.badge": "Director",
"par.certified": "Certificat",
"par.certifiedBadge": "Certificat",
"par.cityPh": "Oraș",
"par.declare": "Raportați",
"par.none": "Niciun partener găsit.",
"par.partnerBadge": "Partener",
"par.searchPh": "Căutați un stabiliment…",
"par.subtitle": "Găsiți stabilimentul unde ați pierdut obiectul și raportați pierderea.",
"par.title": "Partenerii noștri",
"pay.addr1": "Adresă",
"pay.addr2": "Linia de adresă 2 (opțional)",
"pay.addrIncomplete": "Vă rugăm să completați adresa de livrare.",
"pay.badge": "Recuperare",
"pay.card": "Plătiți cu cardul",
"pay.city": "Oraș",
"pay.country": "Țară",
"pay.eurNote": "Sumele sunt afișate în euro (€).",
"pay.fee": "Taxă de recuperare",
"pay.free": "gratuit",
"pay.howRecover": "Cum doriți să vă recuperați obiectul?",
"pay.momo": "Plătiți prin Mobile Money",
"pay.momoConfirm": "Confirmați plata",
"pay.noMatch": "Nicio unealtă corespunzătoare nu este confirmată pentru acest raport deocamdată.",
"pay.notfound": "Raportul nu a fost găsit.",
"pay.phonePh": "Număr de telefon",
"pay.pickup": "Ridicați personal",
"pay.pickupDesc": "La",
"pay.postal": "Cod poștal",
"pay.secure": "Plată securizată",
"pay.serviceFee": "taxă de serviciu Findloop",
"pay.ship": "Expediați-mi",
"pay.shipAfter": "— oferit după plată.",
"pay.shipDesc": "Livrare la adresa mea",
"pay.shipNote": "Expediere disponibilă",
"pay.shipping": "Taxă de expediere",
"pay.subtitleWith": "Plătiți taxa de recuperare către",
"pay.title": "Recuperați obiectul meu",
"pay.total": "Total",
"pcat.city_hall": "Primării",
"pcat.hotel": "Hoteluri",
"pcat.other": "Altele",
"pcat.park": "Parcuri",
"pcat.prefecture": "Prefecturi",
"pcat.restaurant": "Restaurante",
"pcat.uncategorized": "Neclasificat",
"pd.about": "Despre",
"pd.back": "Toți partenerii",
"pd.certified": "Partener certificat",
"pd.declare": "Raportați o pierdere aici",
"pd.itemsReturned": "articole returnate",
"pd.itemsTotal": "articole înregistrate",
"pd.map": "Locație",
"pd.noItems": "Nu au fost găsite articole recent.",
"pd.noReviews": "Încă nu sunt recenzii.",
"pd.notFound": "Partenerul nu a fost găsit.",
"pd.recentItems": "Articole găsite recent",
"pd.reply": "Răspuns de la unitate",
"pd.reviews": "Recenzii ale clienților",
"pd.verified": "Recenzie verificată",
"pd.verifiedEstablishment": "unitate verificată Findloop",
"pg.next": "Următor",
"pg.prev": "Precedent",
"pg.showing": "{from}–{to} din {total}",
"pk.bodyCopy": "Text de bază",
"pk.bodyText": "Text principal",
"pk.brandColors": "Culori de brand",
"pk.colorRed": "Roșu",
"pk.colorWhite": "Alb",
"pk.darkBg": "Fundal închis",
"pk.download": "Descarcă",
"pk.downloadZip": "Descarcă întregul kit (ZIP)",
"pk.headings": "Titluri",
"pk.heroDesc": "Logouri oficiale, bannere pentru rețelele sociale, culori și tipografie. Alege limba și varianta sloganului, apoi descarcă vizualul sau întregul kit.",
"pk.lightBg": "Fundal deschis (print)",
"pk.logoWordmark": "Logo / cuvânt",
"pk.logosVisuals": "Logouri și vizualuri",
"pk.mapCollect": "Hartă / puncte de colectare",
"pk.plain": "Simplu",
"pk.pressKit": "Kit de presă",
"pk.taglineLang": "Limba sloganului",
"pk.typography": "Tipografie",
"pk.variant": "Variantă",
"pr.shipBtn": "Trimite articolul",
"pr2.adBoostMsg": "Alegere excelentă! Îți multiplici șansele de a-ți recupera rapid articolul.",
"pr2.boostActivated": "Îmbunătățire activată!",
"pr2.canRecoverNow": "Poți acum să-ți recuperezi articolul.",
"pr2.continue": "Continuă",
"pr2.downloadReceiptPdf": "Descarcă chitanța (PDF)",
"pr2.goToSpaceNow": "Du-te acum la contul meu",
"pr2.partnerBoostMsg": "Alegere excelentă! A fi mai vizibil înseamnă a atrage clienți noi către unitatea ta.",
"pr2.paymentSuccess": "Plata a fost efectuată cu succes!",
"pr2.redirectingSpace": "Redirecționare către contul tău…",
"pr2.subActivated": "Plata a fost efectuată cu succes! Abonamentul tău este activ, poți acum să-ți gestionezi unitățile.",
"prev.allSites": "Toate unitățile",
"prev.editReply": "Editează răspunsul",
"prev.none": "Încă nu există recenzie.",
"prev.published": "Răspuns publicat",
"prev.reply": "Răspuns",
"prev.replyPh": "Scrie un răspuns politicos…",
"prev.send": "Publică răspunsul",
"prev.sending": "Publicare…",
"prev.yourReply": "Răspunsul tău",
"pricing.annual": "Anual",
"pricing.annualBadge": "-20% ofertă",
"pricing.choose": "Alege",
"pricing.compareFeature": "Funcționalitate",
"pricing.compareTitle": "Compară planurile",
"pricing.eyebrow": "Prețuri",
"pricing.month": "/lună",
"pricing.monthly": "Lunar",
"pricing.perYear": "/an",
"pricing.popular": "Popular",
"pricing.quoteMsg": "Nevoile tale (opțional)",
"pricing.quoteOrg": "Organizație",
"pricing.quoteSend": "Trimite cererea",
"pricing.quoteSent": "Cererea a fost trimisă! Te vom contacta în curând.",
"pricing.quoteSites": "Număr de site-uri / terminale",
"pricing.quoteTitle": "Solicită o ofertă",
"pricing.requestQuote": "Solicită o ofertă",
"pricing.saveLabel": "Economisești",
"pricing.savePerYear": "/an pentru fiecare unitate suplimentară",
"pricing.start": "Începe",
"pricing.subtitle": "Începe gratuit, scalează pe măsură ce crești.",
"pricing.title": "Un plan pentru fiecare organizație",
"promo.badge": "Program de parteneri",
"promo.cta": "Află mai multe",
"promo.text": "Fiecare partener pe care îl recomanzi care se abonează îți oferă o lună gratuită. Fără limită.",
"promo.title": "Recomandă un partener, primește o lună gratuită.",
"pub.accessGranted": "Acces acordat",
"pub.accessLimited2h": "Accesul este limitat la 2 ore",
"pub.accountEmailConcerned": "Emailul contului preocupat",
"pub.adAppearPublic": "Așa va apărea reclama ta în mod public.",
"pub.adPreviewBtn": "Previzualizare reclamă",
"pub.alertMeOnArrival": "Alertă la sosire",
"pub.allActionsLogged": "Toate acțiunile sunt înregistrate",
"pub.allCategories": "Toate categoriile",
"pub.authorizeAccess": "Autorizează accesul",
"pub.authorizeSupportQ": "Autorizezi accesul pentru suport?",
"pub.available": "Disponibil",
"pub.backHome": "Înapoi acasă",
"pub.boostAdCta": "Promovează reclama mea",
"pub.boostAdTitle": "Promovează-ți reclama",
"pub.boostCarouselSub": "Mergi în partea de sus a paginii în caruselul “Promovat” și multiplica vizualizările pentru a recupera itemul mai repede.",
"pub.boostEstablishment": "Promovează-ți unitatea",
"pub.boostEstablishmentDesc": "Apari în partea de sus a directorului cu un badge “Promovat” și atrage mai multe rapoarte.",
"pub.boostFicheCta": "Promovează lista mea",
"pub.brandReady": "Marca Findloop, gata de utilizare",
"pub.cantFindItem": "Nu găsești itemul tău?",
"pub.cantProcessImage": "Impossible to process this image",
"pub.claimQr": "Cere codul QR",
"pub.clickToZoom": "Dă clic pentru a mări",
"pub.codeAlreadyValidated": "Cod validat — contacte deblocate.",
"pub.codeExample": "de ex. ABCD2345",
"pub.confirmRenewal": "Confirmă reînnoirea",
"pub.contactIntro": "O întrebare, o solicitare? Scrie-ne, te vom contacta în curând.",
"pub.contactTypeDeceased": "Ștergerea contului (persoană decedată)",
"pub.contactTypeGeneral": "Întrebare generală",
"pub.contactTypeSupport": "Suport / problemă tehnică",
"pub.contactUs": "Contactează-ne",
"pub.continueWithoutEmail": "Continuă fără a lăsa emailul meu",
"pub.contractLabel": "Contract",
"pub.contractNotFound": "Contractul nu a fost găsit sau a expirat deja.",
"pub.contractRenewed": "Contractul a fost reînnoit!",
"pub.contractRenewedFor": "Contractul tău este reînnoit pentru {n} luni.",
"pub.copyFailed": "Copiere eșuată",
"pub.createPartnerAccount": "Creează contul meu de partener",
"pub.currentDeadline": "Termen limită actual",
"pub.deceasedInfo": "Ca rudă sau moștenitor, poți solicita ștergerea contului Findloop al unei persoane decedate. Vom procesa solicitarea ta în conformitate cu GDPR (documentele de susținere pot fi solicitate).",
"pub.declareMyLoss": "Raportează pierderea mea",
"pub.describeItemPlaceholder": "Descrieți articolul dvs. (de exemplu, umbrelă neagră, chei…)",
"pub.downloadImage": "Descărcați imaginea",
"pub.drawSignature": "Vă rugăm să desenați semnătura dvs.",
"pub.drawSignatureHint": "Desenați semnătura cu mouse-ul sau degetul.",
"pub.duration": "Durata",
"pub.eSignature": "Semnătură electronică",
"pub.eSignatureDesc": "Introduceți numele dvs. pentru a semna. Data este înregistrată automat.",
"pub.edit": "Editați",
"pub.editorialTitles": "Titluri editoriale",
"pub.emailPlaceholder": "tu@example.com",
"pub.enterCodeUnlockOwner": "Introduceți codul primit prin email pentru a debloca detaliile de contact ale proprietarului.",
"pub.errorWord": "Eroare",
"pub.foundSelfService": "Articole găsite · Auto-servire",
"pub.haveOwnerCode": "Am primit un cod de la proprietar",
"pub.home": "Acasă",
"pub.immediateRenewal": "Reînnoire imediată, fără o nouă ofertă.",
"pub.impAdminReq1": "Administrator",
"pub.impAdminReq2": "solicită permisiunea de a accesa temporar contul dvs.",
"pub.impAdminReq3": "pentru a vă ajuta.",
"pub.impGrantedDesc": "Echipa de suport va putea accesa contul dvs. pentru maximum 2 ore. Fiecare acțiune va fi înregistrată. Puteți închide această pagină.",
"pub.invitedOnFindo": "Ești invitat la Findloop",
"pub.isThisYourItem": "Este acesta articolul tău?",
"pub.itemsAvailableCount": "{n} articol(e) disponibile în prezent",
"pub.itemsFoundOwner": "articole de încredere au găsit proprietarul",
"pub.itemsReturnedOwners": "articole returnate proprietarilor lor",
"pub.itsMine": "Este al meu",
"pub.joinFindoDesc": "Alăturați-vă Findloop și gestionați articolele găsite cu ușurință.",
"pub.joinInvitesYou": "te invită să te alături findloop. Creează-ți contul de partener pentru a gestiona articolele tale găsite.",
"pub.linkCopied": "Link copiat!",
"pub.loadingContract": "Încărcarea contractului…",
"pub.lsClaimDesc": "Raportează-ți pierderea pentru a o recupera. Lasă-ți emailul și îți vom trimite un memento dacă raportul tău nu este completat.",
"pub.lsHeroDesc": "Verifică pe cont propriu dacă articolul tău pierdut a fost găsit și lăsat aici. L-ai găsit? Raportează-l pentru a-l recupera.",
"pub.lsSearchTitle": "Căutați articole găsite",
"pub.makeOffer": "Fă o ofertă",
"pub.makeOfferDesc": "Propuneți suma dvs. Superadministratorul o va revizui.",
"pub.mapNearYou": "Articole și parteneri aproape de tine",
"pub.mapWord": "Hartă",
"pub.messageSentToast": "Mesaj trimis — echipa noastră va răspunde în curând.",
"pub.messageWord": "Mesaj",
"pub.momoInitiated": "Plata Mobile Money inițiată",
"pub.monthsWord": "luni",
"pub.nameConsentRequired": "Nume și acord necesare.",
"pub.newDeadline": "Termen limită nou",
"pub.noActionRequired": "Nu este necesară nicio acțiune.",
"pub.noAmountCharged": "Nu a fost percepută nicio sumă.",
"pub.noItemMatch": "Momentan, niciun articol disponibil nu se potrivește căutării tale.",
"pub.noMatchingItem": "Niciun articol corespunzător",
"pub.noPaymentSession": "Nici o sesiune de plată.",
"pub.noPhoto": "Fără fotografie",
"pub.noPointsYet": "Încă nu sunt puncte de afișat.",
"pub.noSecondPayment": "Pentru acest articol nu este necesară o a doua plată.",
"pub.notHereYet": "Încă nu a ajuns? Fii notificat imediat ce sosește.",
"pub.notifyDone": "Notat! Te vom anunța prin email de îndată ce un articol corespunzător sosește.",
"pub.offerSubmitted": "Oferta ta a fost trimisă.",
"pub.oops": "Ups",
"pub.orAlertEmail": "Sau fii alertat prin email imediat ce un articol corespunzător sosește:",
"pub.ownerContacts": "Detaliile de contact ale proprietarului",
"pub.ownerContactsUnlocked": "Detaliile de contact ale proprietarului deblocate",
"pub.partnerContact": "Contact partener",
"pub.payLinkUnavailable": "Link de plată indisponibil — contactați partenerul.",
"pub.paymentCancelled": "Plata anulată",
"pub.paymentConfirmed": "Plata confirmată 🎉",
"pub.paymentConfirmedDesc": "Veți primi un email cu detaliile pentru a recupera produsul.",
"pub.paymentNotConfirmed": "Plata neconfirmată",
"pub.paymentNotConfirmedDesc": "Plata nu a putut fi verificată. Încercați din nou sau contactați partenerul.",
"pub.paymentProcessing": "Plata este în curs de procesare. Reîncărcați în câteva momente.",
"pub.photoAdded": "✓ Fotografie adăugată",
"pub.photoRequired": "O fotografie a produsului este necesară.",
"pub.previewAlt": "previzualizare",
"pub.publish": "Publică",
"pub.publishingWord": "Se publică…",
"pub.qty": "Cantitate",
"pub.quoteDeclined": "Ofertă refuzată.",
"pub.quoteNotFound": "Ofertă negăsită sau expirat.",
"pub.reasonLabel": "Motiv",
"pub.recoveryAlreadyPaid": "Taxa de recuperare a fost deja plătită",
"pub.referralCode": "Cod de recomandare:",
"pub.relationshipPlaceholder": "Fiul, soț, notar…",
"pub.renewYourContract": "Reînnoiește-ți contractul",
"pub.renewalFailed": "Reînnoirea a eșuat. Încercați din nou mai târziu.",
"pub.renewing": "Reînnoim…",
"pub.replySoon": "Echipa noastră va răspunde cât mai curând posibil.",
"pub.requestGone": "Această cerere nu mai există.",
"pub.requestHandled": "Cererea a fost deja gestionată",
"pub.requestNotFound": "Cererea nu a fost găsită sau a expirat.",
"pub.requestUnavailable": "Cererea indisponibilă",
"pub.required": "(necesar)",
"pub.retroClosing": "Împreună, facem lumea puțin mai puțin pierdută.",
"pub.retroClosing2": "Împreună, facem lumea puțin mai puțin pierdută.",
"pub.retroScroll": "Un an de recuperare a ceea ce contează. Derulează în jos ↓",
"pub.revokeAnytime": "Puteți revoca în orice moment contactându-ne",
"pub.scene": "Scenă",
"pub.sendImpossible": "Imposibil de trimis",
"pub.sendMessage": "Trimite mesajul",
"pub.sending": "Trimit…",
"pub.sharePreview": "Partajează previzualizarea",
"pub.shareYourAd": "Partajează-ți anunțul",
"pub.signedSuccess": "Semnat cu succes!",
"pub.signerFullName": "Numele complet al semnatarului",
"pub.spreadNetwork": "Împărtășește-l celor din jur pentru a-ți spori șansele.",
"pub.spreadOwner": "Împărtășește-l pentru a ajuta proprietarul să-și recupereze bunurile.",
"pub.statusLabel": "Status:",
"pub.subject": "Subiect",
"pub.thanksSent": "Mulțumim, mesajul tău a fost trimis.",
"pub.thisYear": "Anul acesta",
"pub.validate": "Validează",
"pub.verifyingPayment": "Se verifică plata…",
"pub.verifyingYourPayment": "Se verifică plata ta…",
"pub.viewAd": "Vizualizează anunțul →",
"pub.viewPartner": "Vizualizează partenerul →",
"pub.yourAdPreview": "Previzualizarea anunțului tău",
"pub.yourEmail": "Emailul tău",
"pub.yourEmailRecommended": "Emailul tău (recomandat)",
"pub.yourEmailShort": "Emailul tău",
"pub.yourName": "Numele tău",
"pub.yourRelationship": "Relația ta cu persoana",
"qv.acceptAndSign": "Acceptă și semnează oferta mea",
"qv.certifyAuthorized": "Certific că sunt autorizat să semnez și accept termenii acestui {what} (valoare obligatorie).",
"qv.clear": "Curăță",
"qv.client": "Client",
"qv.conditions": "Termeni",
"qv.confirmDecline": "Confirmați refuzul acestei oferte?",
"qv.countersignedFindo": "Semnat de Findloop · {name} pe {date}",
"qv.decline": "Refuză",
"qv.description": "Descriere",
"qv.downloadPdf": "Descarcă PDF-ul",
"qv.handwrittenSignature": "Semnătură manuscrisă",
"qv.inclTax": "Incl. taxa",
"qv.invalidAmount": "Sumă invalidă.",
"qv.invoice": "Factură",
"qv.invoicePaid": "Factură plătită",
"qv.issuer": "Emitent",
"qv.messageOptional": "Mesaj (opțional)",
"qv.negotiatedAmount": "Sumă negociată",
"qv.payInvoiceOnline": "Plătește factura online",
"qv.quote": "Ofertă",
"qv.quoteValidDays": "Ofertă valabilă timp de {n} zile.",
"qv.sendMyOffer": "Trimite oferta mea",
"qv.signContract": "Semnează contractul meu",
"qv.signNow": "Semnează acum",
"qv.signatureAlt": "Semnătură",
"qv.signedByOn": "✔ Semnat de {name} pe {date}",
"qv.stContractSigned": "Contract semnat. Mulțumim!",
"qv.stCounterAccepted": "Oferta ta a fost acceptată! Semnează contractul mai jos.",
"qv.stCounterRefused": "Oferta ta nu a putut fi acceptată.",
"qv.stCountered": "Oferta ta a fost trimisă. Așteptăm răspunsul findloop.",
"qv.stDeclined": "Ai refuzat această ofertă.",
"qv.stSigned": "Ofertă acceptată și semnată. Mulțumim!",
"qv.totalHt": "Total excl. taxa",
"qv.totalTtc": "Total incl. taxa",
"qv.unitHt": "Unitate excl. taxa",
"qv.vat": "TVA",
"qv.yourProposedAmount": "Suma propusă de tine ({cur})",
"rate.chooseNote": "Te rugăm să alegi o evaluare.",
"rate.commentPh": "Un comentariu (opțional)…",
"rate.home": "Înapoi la început",
"rate.submit": "Trimite recenzia mea",
"rate.submitting": "Trimit…",
"rate.subtitle": "Cum a fost recuperarea obiectului tău?",
"rate.successText": "Feedback-ul tău ajută alți utilizatori.",
"rate.successTitle": "Mulțumim pentru recenzia ta!",
"rate.title": "Evaluează-ți experiența",
"reg.add": "Loghează un obiect",
"reg.allBrands": "Toate brandurile",
"reg.allColors": "Toate culorile",
"reg.allLocations": "Toate locațiile",
"reg.detailDesc": "Detalii și acțiuni pentru acest obiect găsit.",
"reg.dispAuction": "Licitație",
"reg.dispAuthorities": "Predat autorităților",
"reg.dispDestroyed": "Distrus",
"reg.dispDonate": "Donatie de caritate",
"reg.dispositionHint": "Înregistrează obiectul care părăsește depozitul. Contat în statistici pe categorii.",
"reg.emptyCta": "Loghează un obiect",
"reg.emptyDesc": "Începe prin a loga primul tău obiect găsit.",
"reg.emptyTitle": "Niciun obiect găsit",
"reg.establishmentFallback": "establismentul",
"reg.lblAuctioned": "listat la licitație",
"reg.lblAuctionedShort": "licitat",
"reg.lblAuthorities": "predat autorităților",
"reg.lblDestroyed": "distrus",
"reg.lblDonated": "donat unei organizații de caritate",
"reg.legalCount": "{n} obiect(e): perioada legală de păstrare a fost atinsă",
"reg.legalHint": "Îi poți lista la licitație, dona unei organizații de caritate sau raporta autorităților.",
"reg.legalLimitCountry": "Termen limită: {date} · țară aplicată: {country}",
"reg.legalOver": "Termenul a expirat: {date} · {country}",
"reg.legalReached": "Perioada legală a fost atinsă",
"reg.legalReachedFull": "Perioada legală de păstrare a fost atinsă",
"reg.limitShort": "termen limită",
"reg.location": "Locație",
"reg.markRestituted": "Marchează ca returnat",
"reg.markedAs": "Obiect marcat ca {label}",
"reg.moveHistory": "Istoricul mișcărilor",
"reg.overBy": "depășit cu {n}z",
"reg.physicalLocation": "Locație fizică",
"reg.popupBlocked": "Permite feroneriile pentru a imprima etichetele.",
"reg.popupBlockedOne": "Permite feroneria pentru a imprima eticheta.",
"reg.printLabel": "Imprimă eticheta",
"reg.printN": "Imprimă {n} etichetă(e)",
"reg.qrCodeItem": "Cod QR al obiectului",
"reg.qrLabelTitle": "Etichetă QR",
"reg.qrLabelsTitle": "Etichete QR",
"reg.qrNotFound": "Niciun obiect găsit pentru acest cod QR.",
"reg.qrScanHint": "Scanează-l pentru a deschide acest record direct și a găsi locația.",
"reg.recoveryFee": "Taxă de recuperare (€)",
"reg.searchPh": "Caută după descriere…",
"reg.selectQr": "Selectează pentru a imprima etichete QR",
"reg.selectedN": "{n} selectat(e)",
"reg.shipPricePh": "Prețul transportului (€)",
"reg.shippingPossible": "Transport disponibil",
"reg.storagePh": "de exemplu, Raft A3, Cuier 12",
"reg.tAuction": "Licitație pe Findloop",
"reg.tAuthorities": "Raportează autorizării",
"reg.tDonate": "Donație unei organizații de caritate",
"reg.toastFee": "Taxa actualizată",
"reg.toastLocation": "Locație salvată",
"reg.toastRestituted": "Obiect marcat ca returnat",
"reg.toastShipping": "Opțiunea de transport actualizată",
"reg.toastTransferred": "Obiect transferat către “{name}”",
"reg.unclaimedDisposition": "Obiect neiridicat — dispoziție finală",
"res.codeValidated": "Cod validat",
"res.empty": "Nici o restituire înregistrată încă.",
"res.error": "Eroare {status}",
"res.proofPdf": "Dovadă PDF",
"res.signed": "Semnat",
"res.stRestituted": "Predat personal",
"res.stShipped": "Returnat prin transport",
"res.subtitle": "Toate predările finalizate, cu dovadă semnată descărcabilă.",
"res.title": "Istoricul restituirii",
"rev.b2b": "Parteneri B2B",
"rev.b2c": "Clienți",
"rev.based": "bazat pe {n} recenzii",
"rev.eyebrow": "Mărturii",
"rev.restitutedBy": "Returnat de {org}",
"rev.storiesEyebrow": "Finaluri fericite",
"rev.storiesSubtitle": "Povești reale de la clienți care și-au recuperat lucrurile cu findloop.",
"rev.storiesTitle": "Au găsit lucrurile lor!",
"rev.subtitle": "Partenerii și clienții își împărtășesc experiența.",
"rev.title": "Ei au încredere în Findloop",
"rev.verified": "Verificat",
"rp.already": "Ai raportat deja această listare.",
"rp.comment": "Detalii (opțional)",
"rp.duplicate": "Dublură",
"rp.fraud": "Înșelătorie / fraudă",
"rp.inappropriate": "Conținut inadecvat",
"rp.offensive": "Conținut ofensator",
"rp.other": "Altul",
"rp.reason": "Motiv",
"rp.report": "Raportează",
"rp.send": "Trimite raportul",
"rp.sent": "Raport trimis. Mulțumim pentru contribuția ta.",
"rp.spam": "Spam / publicitate",
"rp.title": "Raportează această listare",
"rp.wrongCategory": "Categorie greșită",
"rt.annualGoal": "Obiectiv anual",
"rt.championCity": "Orașul campion",
"rt.cityRate": "{rate}% rată de returnare",
"rt.goalProgress": "{rate}% realizat dintr-un obiectiv de {target}%",
"rt.reached": "Realizat 🎉",
"rt.restitutionRate": "Rată de returnare",
"rt.shareRecap": "Împărtășește recapitularea mea",
"rt.thanks": "Mulțumim Findloop {year} 💛",
"rt.yourRecap": "Recapitularea ta {year}",
"rw.active": "Activ",
"rw.add": "Adaugă",
"rw.camUnavailable": "Cameră indisponibilă. Introduceți codul manual mai jos.",
"rw.codeValidated": "Cod validat",
"rw.codesTitle": "Coduri răscumpărate de finderi",
"rw.confirmDelete": "Ștergi „{title}”?",
"rw.deleted": "Șters",
"rw.edit": "Editează",
"rw.editReward": "Editează recompensa",
"rw.empty": "Nicio recompensă încă.",
"rw.expired": "Expirat",
"rw.expiresOn": "Expiră pe {date}",
"rw.fActive": "Activ (vizibil pentru finderi)",
"rw.fCost": "Cost (puncte)",
"rw.fDesc": "Descriere",
"rw.fStock": "Stoc (gol = nelimitat)",
"rw.fTitle": "Titlu",
"rw.fValidity": "Valabilitatea voucherului (zile după răscumpărare)",
"rw.inactive": "Inactiv",
"rw.newReward": "Recompensă nouă",
"rw.noExchange": "Nicio răscumpărare încă.",
"rw.pageSubtitle": "Scanează voucherele prezentate de finders pentru a valida recompensele lor.",
"rw.redeemedN": "Răscumpărat: {n}×",
"rw.saved": "Recompensă salvată",
"rw.scanVoucher": "Scanează un voucher",
"rw.staffScanOnly": "Scanează doar",
"rw.statActive": "De prezentat",
"rw.statExpired": "Expirat",
"rw.statRedeemed": "Vouchere răscumpărate",
"rw.statUsed": "Validat",
"rw.stock": "Stoc",
"rw.subtitle": "Oferă beneficii non-monetare (vouchere, îmbunătățiri…) pe care finders le răscumpără pentru punctele lor Finder Score.",
"rw.title": "Recompense pentru finders",
"rw.used": "Folositor",
"rw.validate": "Validează",
"rw.validateCode": " validează codul",
"rw.validity": "Valabilitate: {n} d",
"shell.f1d": "Leagă automat obiectele pierdute și găsite.",
"shell.f1t": "Potrivire AI inteligentă",
"shell.f2d": "Urmăriți rata de retur și veniturile în timp real.",
"shell.f2t": "Tabloul de bord & venituri",
"shell.f3d": "Clienții dvs. raport la 30 de secunde.",
"shell.f3t": "Cod QR partener",
"shell.title": "Transformați articolele pierdute în clienți mulțumiți.",
"ship.addr1": "Adresă",
"ship.addr2": "Linie de adresă 2 (opțional)",
"ship.badge": "Livrare",
"ship.city": "Oraș",
"ship.country": "Țară",
"ship.needPaid": "Plătiți mai întâi taxa de recuperare pentru a solicita livrarea.",
"ship.notShippable": "Acest articol nu este disponibil pentru livrare.",
"ship.notfound": "Raportul nu a fost găsit.",
"ship.postal": "Cod poștal",
"ship.price": "Taxa de livrare",
"ship.submit": "Solicitați livrarea",
"ship.submitting": "Se trimite…",
"ship.subtitle": "Introduceți adresa de livrare.",
"ship.successText": "Partenerul va pregăti coletul dvs. Veți fi notificat odată ce a fost expediat.",
"ship.successTitle": "Solicitare de livrare trimisă!",
"ship.title": "Aveți articolul livrat",
"ship.weight": "Greutate estimată (kg)",
"shp.carrier": "Curier",
"shp.download": "Descărcați PDF",
"shp.generating": "Generare…",
"shp.label": "Generați etichetă",
"shp.none": "Nici o expediere solicitată.",
"shp.setTracking": "Salvați urmărirea",
"shp.status": "Status",
"shp.to": "Destinatar",
"shp.tracking": "Nr. de urmărire",
"shp.trackingSaved": "Urmărirea salvată",
"side.account": "Contul meu",
"side.declarations": "Rapoarte",
"side.deposit": "Înregistrați un articol",
"side.establishments": "Stabilimente",
"side.invoices": "Facturi",
"side.logout": "Deconectare",
"side.matchHistory": "Istoric AI",
"side.partner": "Partener",
"side.refresh": "Reîmprospătare",
"side.registry": "Registru",
"side.restitutions": "Returnări",
"side.reviews": "Recenzii",
"side.rewards": "Recompense & Vouchere",
"side.settings": "Setări",
"side.shipments": "Expedieri",
"side.stats": "Statistică",
"side.storage": "Depozitare & QR",
"side.team": "Echipă",
"side.viewSite": "Vizualizați site-ul public",
"st.auctioned": "Vândut la licitație",
"st.claimed": "Revendicat",
"st.closed": "Închis",
"st.delivered": "Livrat",
"st.destroyed": "Distrus",
"st.donated": "Dăruit (caritate)",
"st.handed_to_authorities": "Predat autorităților",
"st.in_storage": "În depozit",
"st.matched": "Match găsit",
"st.open": "Deschis",
"st.paid": "Plătit",
"st.pending": "În așteptare",
"st.resolved": "Rezolvat",
"st.restituted": "Returnat",
"st.second_chance": "A doua șansă",
"st.shipped": "Expediat",
"st.shipping_requested": "Expediere solicitată",
"st.submitted": "Trimis",
"st.verified": "Verificat",
"stat.items": "Articole înregistrate",
"stat.partners": "Parteneri",
"stat.restituted": "Articole returnate",
"status.auctioned": "Licitat",
"status.destroyed": "Distrus",
"status.donated": "Donație (caritate)",
"status.handed_to_authorities": "Predat autorităților",
"status.in_storage": "În stoc",
"status.matched": "Match",
"status.open": "Deschis",
"status.paid": "Plătit",
"status.pending": "În așteptare",
"status.restituted": "Returnat",
"status.shipped": "Expediat",
"status.shipping_requested": "Expediere solicitată",
"status.submitted": "Trimis",
"step1.tag": "Stabilire",
"step1.text": "În câteva secunde, stabilirea înregistrează articolul găsit cu o fotografie, categorie și descriere. Totul este centralizat într-un registru clar și sigur.",
"step1.title": "Partenerul înregistrează articolul",
"step2.tag": "Client",
"step2.text": "Prin codul QR al partenerului, clientul tău descrie articolul pierdut în 30 de secunde. Fără aplicație de instalat — se întâmplă totul în browser.",
"step2.title": "Clientul raportează pierderea",
"step3.tag": "Inteligență",
"step3.text": "Motorul nostru inteligent de potrivire compară descrierile și sugerează cele mai probabile match-uri, gata să confirme.",
"step3.title": "AI leagă pierderea de articolul găsit",
"step4.tag": "Recuperare",
"step4.text": "După o plată sigură a taxei de recuperare, clientul își ridică articolul de la locație — sau îl primește prin expediere urmărită.",
"step4.title": "Clientul își recuperează articolul",
"stg.allLabels": "Toate etichetele QR",
"stg.camHint": "Folosește introducerea manuală mai jos.",
"stg.camStarting": "Pornirea camerei…",
"stg.camUnavailable": "Cameră indisponibilă.",
"stg.clear": "Șterge",
"stg.clearAll": "Șterge tot",
"stg.codeUnreadable": "Cod ilizibil.",
"stg.emptyDesc": "Articolele stocate vor apărea aici, grupate pe locație.",
"stg.emptyTitle": "Niciun articol în stoc",
"stg.exportAudit": "Export audit CSV",
"stg.exportDone": "Export CSV descărcat",
"stg.exportImpossible": "Export indisponibil în acest moment.",
"stg.itemFound": "Articol găsit ✅",
"stg.kLocations": "Locații utilizate",
"stg.kObjects": "Articole stocate",
"stg.kToClear": "Locații de șters",
"stg.locFreed": "Locația ștearsă",
"stg.locsFreed": "{n} locație(loci) ștearsă(e)",
"stg.manualLabel": "Sau introdu codul / ID-ul articolului",
"stg.manualPh": "Lipește ID-ul sau URL-ul QR-ului",
"stg.noItemMatch": "Niciun articol nu se potrivește cu acest QR / cod.",
"stg.noLocation": "Nicio locație",
"stg.objectsAxis": "Articole",
"stg.objectsN": "{n} articol(e)",
"stg.occAvg": "media {n} articole/locație",
"stg.occHint": "Locațiile cu indicii galbene depășesc media (potențial suprasolicitate).",
"stg.occupancy": "Ocupația locației",
"stg.openPage": "Deschide pagina",
"stg.posterPdf": "PDF poster (A4)",
"stg.printAll": "Imprimă tot",
"stg.printGroupTitle": "Imprimă etichete pentru această raft",
"stg.qrAlt": "QR self-service",
"stg.qrDownload": "Descarcă QR-ul",
"stg.qrHint": "Afișează acest QR la ghișeu: clienții tăi îl scanează pentru a verifica disponibilitatea articolului.",
"stg.qrTitle": "QR self-service pentru clienți",
"stg.scanDesc": "Scanează eticheta unui articol pentru a deschide instantaneu înregistrarea acestuia.",
"stg.scanQr": "Scanează un QR",
"stg.scanTitle": "Scanează un cod QR",
"stg.search": "Căutare",
"stg.shelf": "Raft {loc}",
"stg.shelfPlan": "Planul raftului",
"stg.staleHint": "Șterge aceste locații pentru a menține inventarul fizic actualizat.",
"stg.staleTitle": "{n} articol(e) au părăsit depozitul, dar încă păstrează o locație",
"stg.subtitle": "Planul raftului, scanner QR și urmărirea inventarului fizic.",
"stg.title": "Depozitare & QR",
"stt.acceptRate": "Rata de acceptare",
"stt.accepted": "Acceptat",
"stt.activity30": "Activitate (ultimele 30 de zile)",
"stt.ai6mo": "Ultimele 6 luni · acceptate = auto-perechează + confirmate.",
"stt.aiEmpty": "Nu sunt încă potriviri AI în această perioadă.",
"stt.aiTitle": "Potriviri AI — acceptate vs respinse",
"stt.auctionShort": "Licitație",
"stt.auctionedSold": "Licitat (vândut)",
"stt.authShort": "Autorități",
"stt.authorities": "Predat autorităților",
"stt.avgRating": "Rating mediu",
"stt.awaitingRestitution": "articole în așteptare de returnare",
"stt.boostClicks": "Clicuri pe directorul tău în această săptămână datorită boost-ului",
"stt.boostInactive": "Boost inactiv — activează-l pentru a câștiga vizibilitate",
"stt.certifiedPremium": "Certificat premium",
"stt.declarations": "Declarații",
"stt.destroyed": "Distrus",
"stt.dispoEmpty": "Niciun articol nepretins nu a părăsit depozitul încă.",
"stt.donatedAssoc": "Donat (caritate)",
"stt.donatedShort": "Donat",
"stt.gateCta": "Descoperă planurile",
"stt.gateDesc": "Actualizează la Starter pentru a debloca statisticile de bază sau la Business pentru statistici avansate și analiză pe unitățile de afaceri.",
"stt.gateTitle": "Statistici rezervate pentru planurile plătite",
"stt.inStorage": "În depozit",
"stt.kItems": "Articole înregistrate",
"stt.kRate": "Rata de returnare",
"stt.kRestituted": "Articole returnate",
"stt.kRevenue": "Venit (luna)",
"stt.noDeclYet": "Niciună declarație încă.",
"stt.recapDownloaded": "Recap descărcat — gata de partajat!",
"stt.recapError": "Imposibil de generat recapitularea",
"stt.recapText": "Recapitularea noastră Findloop {year}: articole returnate și satisfacția clientului 🎉",
"stt.recapTitle": "recapitularea Findloop {year}",
"stt.rejected": "Respingere",
"stt.restitutions": "Returnări",
"stt.shareRecap": "Împărtășește recapitularea mea din {year}",
"stt.topCategories": "Cele mai declarate categorii",
"stt.unclaimedDesc": "Volumul articolelor distruse, donate organizațiilor de caritate și vândute la licitație, pe categorii.",
"stt.unclaimedTitle": "Articole nepretinse — părăsirea depozitului",
"stt.vsLastWeek": "comparativ cu săptămâna trecută",
"sub.cancel": "Anulează abonamentul meu",
"sub.cancelAbort": "Anulează",
"sub.cancelConfirm1": "Ești sigur că dorești să anulezi? Accesul tău rămâne activ până la",
"sub.cancelConfirm2": "Nu va fi emisă nicio rambursare.",
"sub.cancelConfirmBtn": "Confirmă anularea",
"sub.cancelTitle": "Anulează abonamentul tău",
"sub.cancelledToast": "Anularea înregistrată.",
"sub.cguAnd": "și",
"sub.cguDesc": "Te rugăm să confirmi acordul tău înainte de plată.",
"sub.cguLink": "Termeni de utilizare",
"sub.cguPay": "Continuă la plată",
"sub.cguPre": "Am citit și accept termenii",
"sub.cguRequired": "Trebuie să accepți Termenii de utilizare și Politica de confidențialitate pentru a continua.",
"sub.cguSuffix": "de findloop.",
"sub.cguTitle": "Finalizează abonamentul tău",
"sub.expiresOn": "Abonamentul tău expiră pe",
"sub.noProrata": "Fără rambursare pro-rata.",
"sub.privacyLink": "Politica de confidențialitate",
"sub.renewsOn": "Abonamentul tău se reinnoiește pe",
"sub.resume": "Reabonează-te",
"sub.resumedToast": "Reabonarea confirmată.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Business",
"tier.small": "Starter",
"tm.add": "Adaugă",
"tm.adminOpt": "Admin (vizualizare completă)",
"tm.chooseEst": "Alege un stabiliment",
"tm.chooseEstPh": "Alege un stabiliment",
"tm.copyFail": "Copierea a eșuat",
"tm.copyLink": "Copiază linkul",
"tm.copyOk": "Linkul de invitație a fost copiat",
"tm.emailHint": "Un email de invitație va fi trimis pentru a crea parola.",
"tm.expiresOn": "expiră pe {date}",
"tm.forEmail": "pentru {email}",
"tm.forbidden": "Gestionarea echipei este rezervată proprietarului contului.",
"tm.inviteCreated": "Invitație creată",
"tm.inviteDesc": "Un email de invitație permite colegului să creeze parola.",
"tm.invitePending": "Invitație în așteptare",
"tm.inviteResent": "Invitație retrimisă",
"tm.inviteSent": "Invitație trimisă prin email",
"tm.inviteTitle": "Invită un membru",
"tm.invitedOn": "Invitat pe {date}",
"tm.linkExpired": "Linkul a expirat",
"tm.memberRemoved": "Membru eliminat",
"tm.name": "Nume",
"tm.noMembers": "Încă nu există colegi.",
"tm.resendTitle": "Retrimite invitația",
"tm.role": "Rol",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Proprietar",
"tm.roleStaff": "Personal",
"tm.roleUpdated": "Rol actualizat",
"tm.sendInvite": "Trimite invitația",
"tm.sending": "Se trimite…",
"tm.staffOpt": "Personal (puteți vedea doar stabilimentul lor)",
"trk.at": "La",
"trk.badge": "Urmărire",
"trk.carrier": "Transportator",
"trk.codeValidated": "Cod validat de partener",
"trk.dlProof": "Descarcă dovada mea de predare (PDF)",
"trk.emailLabel": "Email (opțional — pentru a vedea detaliile tale)",
"trk.enterEmailCode": "Introdu email-ul tău mai sus pentru a afișa codul tău de revendicare.",
"trk.idLabel": "Număr raport",
"trk.lostEmail": "Nu mai am acces la email-ul meu",
"trk.phonePh": "Numărul tău de telefon",
"trk.photoBefore": "Fotografie a articolului înainte de expediere",
"trk.recoverBtn": "Recuperează articolul meu",
"trk.recoverHint": "Obține codul tău de revendicare prin SMS pe numărul tău înregistrat.",
"trk.searching": "Căutare…",
"trk.secureRest": "Predare în siguranță",
"trk.send": "Trimite",
"trk.shipPending": "Expedierea se prepară — numărul de urmărire va apărea aici odată trimis.",
"trk.shipTitle": "Urmărirea expedierii",
"trk.showQr": "Arată acest QR partenerului pentru a valida predarea",
"trk.sigSaved": "Semnătură salvată",
"trk.signFirst": "Te rugăm să semnezi înainte de a confirma.",
"trk.signProof": "Semnează dovada ta de predare",
"trk.signSubmit": "Confirmă semnătura mea și generează PDF-ul",
"trk.submit": "Urmărește",
"trk.subtitle": "Introdu numărul raportului tău pentru a urmări progresul.",
"trk.title": "Urmărește raportul meu",
"trk.trackShipment": "Urmărește coletul",
"trk.trackingNo": "Număr de urmărire",
"trk.yourCode": "Codul tău de revendicare (pentru a-l da partenerului)",
"a.firstName": "Prenume",
"ac.emailCrossMatch": "Corelări B2C",
"ac.emailCrossMatchDesc": "Un email când un anunț public de obiect pierdut se potrivește cu un obiect depus la locația dumneavoastră",
"ac.emailCrossReject": "Refuzuri de corelări publice",
"ac.emailCrossRejectDesc": "Primiți un email când un client indică că o corelare publică sugerată nu este obiectul său.",
"ac.emailLoginNotif": "Notificare de conectare",
"ac.emailLoginNotifDesc": "Primiți un email de fiecare dată când cineva se conectează la contul dumneavoastră.",
"ad.closeNoCancel": "Nu, eliminați anunțul",
"ad.closeQuestion": "A fost obiectul returnat la dumneavoastră?",
"ad.closeQuestionDesc": "Lăsați-ne să știm dacă ați recuperat obiectul, sau dacă pur și simplu doriți să eliminați acest anunț.",
"ad.closeYesRestituted": "Da, obiectul a fost returnat",
"ad.closedRestituted": "Obiect returnat — anunț închis 🎉",
"an.lostLoginDesc": "Este necesar un cont pentru a raporta un obiect pierdut și a urmări returnarea acestuia.",
"an.lostLoginRequired": "Conectați-vă pentru a raporta un obiect pierdut",
"an.qfAll": "Toate",
"an.qfBoosted": "Promovat",
"an.qfPhoto": "Cu fotografie",
"an.qfRecent": "Săptămâna aceasta",
"an.qfResolved": "Rezolvat",
"an.restitutionInProgress": "Obiect în curs de returnare",
"dec.descPhLong": "Descrieți obiectul: marcă, culoare, semne distinctive… (Cu cât oferiți mai multe detalii, cu atât șansele de a recupera obiectul sunt mai mari)",
"dec.loadError": "Imposibil de încărcat partenerul în acest moment. Verificați conexiunea și încercați din nou.",
"dec.retry": "Reîncercați",
"dec.shippingMode": "Expediere",
"dep.photo2": "Fotografia 2 a obiectului",
"dep.photo2Hint": "Opțional — un alt unghi îmbunătățește precizia potrivirii vizuale.",
"dl.accountSuspended": "Cont suspendat pentru o factură neachitată. Reglați-o pentru a vă restabili accesul.",
"dl.regularize": "Reglați acum →",
"dl.suspensionCountdown": "Factura {num} neachitată — contul dumneavoastră va fi suspendat în {days} zi(le). Reglați-o pentru a evita asta.",
"ft.cancelConfirm": "Anulați raportul? Proprietarul obiectului va fi informat.",
"ft.cancelDone": "Raport anulat.",
"ft.cancelLocked": "Anularea nu mai este posibilă după ce proprietarul a plătit.",
"ft.cancelReport": "Anulează raportul meu",
"ft.claimCodeHelp": "Dați acest cod găsitorului la predare pentru a confirma că ați primit obiectul.",
"ft.claimCodeTitle": "Codul dumneavoastră de restituire",
"ft.claimDone": "Obiect returnat. Mulțumim că ați folosit Findloop!",
"ft.claimUnlockHint": "Deblocați detaliile de contact ale găsitorului",
"ft.claimUnlockHintSub": "Mergeți la \"Obiecte pe care le revendic\" în contul dumneavoastră pentru a plăti taxa și a obține detaliile de contact.",
"ft.finderCodeShownHelp": "Proprietarul a plătit și v-a selectat. Copiați acest cod mai jos pentru a confirma returnarea — nu este nevoie să verificați emailul.",
"ft.finderCodeShownTitle": "Codul de validare al proprietarului",
"ft.finderContactsTitle": "Detaliile de contact ale Finder-ului",
"ft.foundCodeHelp": "Arată acest cod proprietarului la predare pentru a confirma că articolul a fost returnat.",
"ft.inProgressOther": "Articol returnat",
"ft.inProgressOtherHelp": "Proprietarul a selectat un alt finder pentru acest articol. Nu este necesară nicio acțiune din partea ta.",
"ft.restitutionCodeHelp": "Acest cod confirmă predarea articolului. Este deja completat mai jos; validează-l și apoi închide cazul.",
"ft.restitutionCodeTitle": "Codul tău de restituire",
"hc.14Digits": "14 cifre",
"hc.15DaysBeforeAnItem": "15 zile înainte de termenul legal al unui articol.",
"hc.7DaysBeforeAnItem": "7 zile înainte de termenul legal al unui articol.",
"hc.8CharactersMinimum": "Minim 8 caractere.",
"hc.aClaimToValidate": "O reclamație de validat",
"hc.aFindoAssistanceSessionIs": "O sesiune de asistență Findloop este activă în contul tău.",
"hc.aNewMatchHasBeen": "A fost găsit un nou meci",
"hc.aUser": "Un utilizator",
"hc.aUserClaimsToBe": "Un utilizator susține că este proprietarul. Verifică răspunsurile lor înainte de a autoriza returnarea.",
"hc.aboutFindo": "Despre Findloop",
"hc.accountActivatedPleaseLogIn": "Cont activat, te rugăm să te conectezi.",
"hc.accountActivation": "Activarea contului",
"hc.accountCreated": "Cont creat!",
"hc.accountDeactivatedAReactivationEmail": "Contul a fost dezactivat. Ți-a fost trimis un email de reactivare (valabil 30 de zile).",
"hc.accountReactivation": "Reactivarea contului",
"hc.activateMyAccount": "Activează-mi contul",
"hc.activateMyAdminAccount": "Activează-mi contul de administrator",
"hc.activating": "Activare…",
"hc.activeMatchCancelReason": "Meci activ. Motivul anulării clientului: \"{reason}\". Articolul așteaptă în continuare o reclamație.",
"hc.activeMatchWithAPublic": "Meci activ cu o listare publică (client). Așteptăm reclamația proprietarului.",
"hc.addAPhoto": "Adaugă o fotografie",
"hc.addAndConfigureYourEstablishments": "Adaugă și configurează-ți unitățile în \"Unități\": detalii de contact, categorie și stocare fizică a articolelor.",
"hc.addOnGoogle": "Adaugă pe Google",
"hc.address": "Adresă",
"hc.addressSaved": "Adresă salvată",
"hc.addressStreet": "Adresă — Stradă",
"hc.adjustThePhoto": "Ajustează fotografia",
"hc.adminFullView": "Administrator (viziune completă)",
"hc.administratorOnly": "Numai administrator",
"hc.africa": "Africa",
"hc.aiVisualComparison": "Comparare vizuală AI",
"hc.all": "Toate",
"hc.amount": "Sumă",
"hc.anOrganization": "O organizație",
"hc.analyzing": "Se analizează…",
"hc.andRecoveryIs": "și recuperarea este",
"hc.andTheDeclarationWillBe": "și declarația va fi închisă (mutată în istoric). Această acțiune este finală.",
"hc.annual20": "Anual -20%",
"hc.annualBilling20": "Facturare anuală (−20%)",
"hc.annualTarget": "Obiectiv anual",
"hc.anyCommentsOptional": "Ați avea comentarii? (opțional)",
"hc.approveTheClaim": "Aprobă reclamația",
"hc.archiveCancelledConfirm": "Arhivează {n} listare(e) „Anulată de client”? Vor fi eliminate din registru.",
"hc.asSoonAs": "De îndată ce",
"hc.askTheOwnerToDisplay": "Întreabă proprietarul să afișeze QR-ul codului său (pagina de urmărire).",
"hc.askThemAtTheCounter": "Întreabă-i la birou pentru a confirma identitatea — niciodată vizibil public.",
"hc.assistance": "Asistență",
"hc.assistanceSessionRevoked": "Sesiunea de asistență revocată.",
"hc.atLeast6Characters": "Cel puțin 6 caractere",
"hc.automaticallyPreSelected": "pre-selectat automat",
"hc.automaticallyWhenShipping": "automat la expediere.",
"hc.awaitingClaim": "Așteptând reclamația",
"hc.awaitingPayment": "Așteptând plata",
"hc.b2cCustomer": "Client B2C",
"hc.back": "Înapoi",
"hc.backToHome": "Înapoi acasă",
"hc.backToMyAccount": "Înapoi la contul meu",
"hc.backToPayment": "Înapoi la plată",
"hc.beforeAfterComparisonSlider": "Glisor comparație înainte/după",
"hc.billingInformation": "Informații de facturare",
"hc.billingInformationSaved": "Informațiile de facturare salvate ✓",
"hc.brand": "Marcă",
"hc.bronze": "Bronz",
"hc.calculatingTheShippingRate": "Se calculează taxa de expediere…",
"hc.cameraUnavailableEnterTheCode": "Cameră indisponibilă. Introduceți codul manual.",
"hc.cancel": "Anulează",
"hc.cancelMyDeclaration": "Anulează declarația mea",
"hc.cancelSavedFmt": "Anularea salvată: „{reason}”. Poți reclama în continuare.",
"hc.cancelTheDeposit": "Anulează depozitul",
"hc.cancelThisMatch": "Anulează această confruntare",
"hc.cancellationReason": "Motivul anulării",
"hc.cancelled": "Anulat",
"hc.cancelledByTheCustomer": "Anulat de client",
"hc.cannotOpenPayment": "Imposibil de deschis plata. Te rugăm să încerci din nou.",
"hc.careers": "Carieră",
"hc.carrier": "Transportator",
"hc.carrierAvailabilityCannotBeChecked": "Disponibilitatea transportatorului nu poate fi verificată până când expeditorul tău Sendcloud nu este configurat.",
"hc.carrierConfirmedCharged": "Transportator confirmat — {price} € percepuți de la client",
"hc.carrierOther": "Transportator (altul)",
"hc.carrierSelection": "Selecția transportatorului",
"hc.caseClosedThankYou": "Caz închis. Mulțumim!",
"hc.category": "Categorie",
"hc.changeMethod": "Schimbă metoda",
"hc.characteristic": "Caracteristică",
"hc.chargedToCustomer": "percepuți de la client.",
"hc.checkOrEditYourDetails": "Verifică sau editează detaliile tale înainte de plată securizată.",
"hc.checkStatisticsToTrackDeposited": "Verifică \"Statistici\" pentru a urmări articolele depozitate, rata de returnare și performanța fiecărei unități.",
"hc.checkTheDetailsBeforeContacting": "Verifică detaliile înainte de a contacta finder-ul.",
"hc.checkTheDetailsBelowBefore": "Verifică detaliile de mai jos înainte de a începe cererea ta de returnare.",
"hc.checkTheNewItem": "Verifică noul articol",
"hc.checkThePhotosAndCharacteristics": "Verifică fotografiile și caracteristicile de mai jos înainte de a continua cu recuperarea.",
"hc.chooseACountry": "Alege o țară",
"hc.chooseANewPassword": "Alege o nouă parolă",
"hc.chooseAReason": "Alege un motiv",
"hc.chooseTheLegalRetentionAlerts": "Alege alertele de păstrare legală primite prin email pentru",
"hc.chooseYourPasswordToAccess": "Alege parola ta pentru a accesa consola de administrare.",
"hc.city": "Oraș",
"hc.claimApproved": "Cererea aprobată",
"hc.claimApproved2": "Cererea aprobată.",
"hc.claimCodeExpired": "Codul cererii a expirat",
"hc.claimCodeVerified": "Codul cererii verificat",
"hc.claimNotFound": "Cererea nu a fost găsită",
"hc.claimNotValidated": "Cererea nu a fost validată",
"hc.claimRejected": "Cererea respinsă",
"hc.claimRejected2": "Cererea respinsă.",
"hc.claimValidated": "Cererea validată",
"hc.claimValidatedByThePartner": "Cererea validată de partener",
"hc.claimant": "Reclamant",
"hc.claimsToBeTheOwner": "se pretinde a fi proprietarul acestui articol și a răspuns la întrebările de verificare. Aprobat doar dacă răspunsurile se potrivesc.",
"hc.claimsToValidate": "Cereri de validat",
"hc.clear": "Șterge",
"hc.clickToZoom": "Click pentru a mări",
"hc.close": "Închide",
"hc.close2": "Închide",
"hc.closeTheDeclaration": "Închide declarația",
"hc.closeTheDeclaration2": "Închizi declarația?",
"hc.codeAlreadyVerified": "Codul a fost deja verificat",
"hc.codeCopied": "Codul a fost copiat",
"hc.collapse": "Ascunde",
"hc.color": "Culoare",
"hc.company": "Companie",
"hc.companyName": "Numele companiei",
"hc.comparePhotos": "Compară fotografiile",
"hc.compareThemWithTheOwner": "Compară-le cu răspunsurile proprietarului — niciodată vizibile public.",
"hc.condition": "Stare",
"hc.confirmAndPay": "Confirmă și plătește",
"hc.confirmCancellation": "Confirmă anularea",
"hc.confirmCrop": "Confirmă decuparea",
"hc.confirmDeletion": "Confirmă ștergerea",
"hc.confirmPassword": "Confirmă parola",
"hc.confirmThatThisIsYour": "Confirmă că acesta este obiectul tău. O verificare a identității va fi solicitată de la găsitor înainte de orice contact.",
"hc.confirmTheCarrier": "Confirmă transportatorul",
"hc.confirmThePassword": "Confirmă parola",
"hc.confirmYourShippingAddressTo": "Confirmă adresa ta de livrare pentru a continua cu plata.",
"hc.confirmYourSubscription": "Confirmă abonamentul tău",
"hc.confirmed": "Confirmat ✓",
"hc.contactFindoToGetYour": "Contactează Findloop pentru a obține ID-ul tău de expeditor.",
"hc.contactUs": "Contactează-ne",
"hc.continueTheReturn": "Continuă returnarea",
"hc.continueToPayment": "Continuă la plată",
"hc.copy": "Copiază",
"hc.correctMyDetails": "corectează detaliile mele",
"hc.correctThisEntry": "Corectezi această înregistrare?",
"hc.country": "Țară",
"hc.countryAddress": "Țară (adresă)",
"hc.countryIsoCodeEG": "Țară (cod ISO, de ex. FR)",
"hc.cover": "copertă",
"hc.createTheShipment": "Creează expedierea",
"hc.cropThePhoto": "Decupează fotografia",
"hc.customer": "Client",
"hc.customerClaimCodeToCheck": "Cod de cerere al clientului — pentru a verifica la ridicare:",
"hc.customerReasonFmt": "Motivul clientului: \"{reason}\".",
"hc.customerReminderDelay": "Întârzierea memento-ului clientului",
"hc.customerWhosePublicListingMatches": "Clientul al cărui listare publică se potrivește cu acest articol — vizibilă doar pentru tine.",
"hc.d15": "D-15",
"hc.dangerZone": "Zonă de pericol",
"hc.date": "Data",
"hc.dateNewest": "Data (cea mai recentă)",
"hc.dateOldest": "Data (cea mai veche)",
"hc.daysToYearEnd": "{n} zile până la sfârșitul anului",
"hc.deadlineAlert": "Alertă termen limită",
"hc.declarationClosed": "Declarație închisă ✓",
"hc.declarationNotFound": "Declarație nesigură.",
"hc.declarationNotFound2": "Declarație nesigură",
"hc.declarationTracking": "Urmărire declarație",
"hc.defaultCarrier": "Transportator implicit",
"hc.defaultCarrierPreselected": "Transportator implicit preselectat — poate fi schimbat pentru această expediere. Tarif actual (Sendcloud + {m}% marjă).",
"hc.defaultCarrierRemoved": "Transportator implicit eliminat",
"hc.delayHours": "Întârziere (ore)",
"hc.deleteMyAccount": "Șterge contul meu",
"hc.deleting": "Șterg…",
"hc.deletingDeactivatesYourAccountLogin": "Ștergerea dezactivează autentificarea în contul tău: accesul este blocat și datele sunt păstrate timp de 30 de zile. Vei primi un email cu un link de reactivare valabil timp de 30 de zile.",
"hc.delivered": "Livrat",
"hc.depositAnItem": "Depune un articol",
"hc.depositCancelledItemPutBack": "Depunere anulată — articolul a fost pus înapoi în stoc.",
"hc.depositCancelledItemRemovedFrom": "Depunere anulată — articolul a fost eliminat din registru.",
"hc.depositedOn": "Depus pe",
"hc.describeTheItemBrandColor": "Descrie articolul: brand, culoare, semne distinctive… (Cu cât oferi mai multe detalii, cu atât șansele tale de a găsi articolul sunt mai mari)",
"hc.dimensionsCm": "Dimensiuni (cm)",
"hc.disablingAnEmail": "Dezactivarea unui email",
"hc.doesNotHide": "nu ascunde",
"hc.download": "Descarcă",
"hc.downloadThePdf": "Descarcă PDF-ul",
"hc.draftRestoredPickUpYour": "Ciornă restaurată — preia declarația de unde ai lăsat-o.",
"hc.dragToReposition": "Trage pentru a reposiționa",
"hc.eGColisPriv": "De exemplu, Colis Privé",
"hc.eachItemGetsAQr": "Fiecare articol primește un cod QR. Scanează-l de la \"Depozitare & QR\" pentru a localiza un articol instantaneu.",
"hc.eachSiteManagesItsOwn": "Fiecare site își gestionează propria bancă. Mergi la",
"hc.edit": "Editează",
"hc.emailNotificationPreferences": "Preferințe notificare email",
"hc.emailPreferencesUpdated": "Preferințele email actualizate",
"hc.enableOrDisableRecoveryFees": "Activează sau dezactivează comisioanele de recuperare pentru",
"hc.enlargePhoto": "Zoom pe fotografie",
"hc.enterTheCustomerSCode": "Introdu codul clientului",
"hc.estShipRate": "Tarif estimat de expediere (Sendcloud + {m}% marjă):",
"hc.establishment": "Stabiliment",
"hc.establishment2": "Stabiliment:",
"hc.establishmentInItsSendcloudAccount": "stabiliment în contul său Sendcloud și îți oferă ID-ul expeditorului",
"hc.establishmentSettings": "Setările stabilimentului",
"hc.exCode": "de ex. ABCD2345",
"hc.exId": "de ex. 3f2a…",
"hc.exit": "Ieșire",
"hc.explainWhyThisItemIs": "Explică de ce acest articol nu este al tău…",
"hc.externalPaymentLinks": "Linkuri externe de plată",
"hc.failed": "Eșuat",
"hc.feesEnabled": "Taxele sunt active",
"hc.field": ") câmp.",
"hc.finderAcceptedCloseTheCase": "Finder acceptat — închide cazul odată ce articolul a fost predat personal.",
"hc.findoCityRanking": "Findloop — Clasamentul orașelor",
"hc.findoForEstablishments": "Findloop pentru stabilimente",
"hc.findoPresentationVideo": "video de prezentare Findloop",
"hc.findoRegistersTheAddressOf": "Findloop înregistrează adresa ta de",
"hc.findoReviewShare": "recenzia Findloop {year}: {n} articole returnate, rată de returnare {rate}% 🎉",
"hc.firstVerifyTheClaimCode": "Verifică mai întâi codul de revendicare de mai sus",
"hc.forEveryNewShipmentFrom": "pentru fiecare expediere nouă de la",
"hc.free": "gratuit",
"hc.freeRecovery0": "Recuperare gratuită (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Recuperare gratuită în întreaga Africă – Ofertă de lansare",
"hc.freeRecoveryFeesDisabled0": "Recuperare gratuită: taxe dezactivate (0 €)",
"hc.fromTeamInviteYourColleagues": "Din \"Echipă\", invită-ți colegii prin email și atribuie-le un stabiliment. Fiecare membru vede doar propria sferă.",
"hc.fullName": "Nume complet",
"hc.fullPhoto": "Fotografie completă",
"hc.gallery": "Galerie",
"hc.giveTheReasonForCancelling": "Oferă motivul anulării. Partenerul va fi informat.",
"hc.goToLogin": "Mergi la conectare",
"hc.goToMyAccount": "Mergi la contul meu",
"hc.gold": "Aur",
"hc.googleLoginFailed": "Conectarea cu Google a eșuat",
"hc.hasConfirmedYourPaymentYou": "a confirmat plata ta, vei fi redirectat automat",
"hc.helpCenter": "Centrul de ajutor",
"hc.helpUsImproveWhyAre": "Ajută-ne să îmbunătățim: de ce pleci? Contul tău va fi dezactivat și poate fi reactivat timp de 30 de zile.",
"hc.hidePassword": "Ascunde parola",
"hc.high": "Ridicat",
"hc.historyOfYourMonthlySubscriptions": "Istoricul abonațiilor tale lunare și statutul plății acestora.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Cum îmi setez ID-ul numeric al expeditorului?",
"hc.iDonTUseIt": "Nu îl folosesc suficient",
"hc.iFoundItElsewhere": "L-am găsit în altă parte",
"hc.iNoLongerNeedMy": "Nu mai am nevoie de articolul meu",
"hc.identityVerification": "Verificarea identității",
"hc.idleLogoutIn": "Vei fi deconectat în {n} s din cauza inactivității.",
"hc.ifProvidedTheVolumetricWeight": "Dacă este oferit, se folosește greutatea volumetrică.",
"hc.ifThePartnerHasNot": "Dacă partenerul nu a confirmat primirea plății externe după această întârziere, Findloop îi amintește automat partenerului să o valideze.",
"hc.impersonationEnded": "Impersonarea s-a încheiat.",
"hc.impersonationMode": "Mod de impersonare",
"hc.impersonationSessionExpired": "Ședința de impersonare a expirat.",
"hc.inTheField": ", în teren",
"hc.inTransit": "În tranzit",
"hc.inclVat": "incl. TVA",
"hc.intraEuVatNumberOptional": "Numărul de TVA intracomunitar este opțional, fără SIRET necesar (în afara Franței).",
"hc.invalidInvitationLink": "Link de invitație invalid.",
"hc.invalidInvitationLink2": "Link de invitație invalid",
"hc.invalidInviteLink": "Link de invitație invalid sau expirat.",
"hc.invalidNumberEnterAnInternational": "Număr invalid. Introdu un număr internațional, de exemplu +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Link invalid sau expirat.",
"hc.invalidOrExpiredReactivationLink": "Link de reactivare invalid sau expirat",
"hc.invalidSendcloudId": "ID Sendcloud invalid",
"hc.inviteSubtitle": "{org} te invită să te alături echipei lor findloop. Alege-ți parola pentru a activa contul tău.",
"hc.isAvailableOnSendcloudFor": "este disponibil pe Sendcloud pentru toate rutele tale (intern + internațional).",
"hc.isNotEnabledOnYour": "nu este activat pe contul tău Sendcloud pentru unele destinații. Etichetele pentru acestea vor fi generate cu un alt transportator disponibil.",
"hc.isThisReallyYourItem": "Este acesta cu adevărat articolul tău?",
"hc.isThisYourItem": "Este acesta articolul tău?",
"hc.item": "Articol",
"hc.itemAlreadyConfirmed": "Articol deja confirmat",
"hc.itemDetails": "Detalii articol",
"hc.itemFoundAt": "Articol găsit la",
"hc.itemFoundAtAPartner": "Articol găsit la un partener",
"hc.itemMarkedAsReturned": "Articol marcat ca returnat ✓",
"hc.itemPhotoRequiredBeforeShipping": "Fotografie articol (necessară înainte de expediere)",
"hc.itemPhotoSaved": "Fotografie articol salvată",
"hc.itemPreview": "Previzualizare articol",
"hc.itemPutBackInStorage": "Articolul a fost pus înapoi în depozit.",
"hc.itemWeight": "Greutatea articolului:",
"hc.itemsReturned": "articol(e) returnate",
"hc.itemsReturnedThisYear": "articole returnate în acest an",
"hc.itemsWhoseLegalDeadlineIs": "Articole ale căror termen legal este la 15 zile sau mai puțin (inclusiv întârziate). Potriviturile rămân vizibile.",
"hc.kbisNumber": "Numărul Kbis",
"hc.keysForgottenOnABench": "Chei uitate pe o bancă",
"hc.labelBeingGenerated": "Eticheta este în curs de generare",
"hc.leaveTheFieldsEmptyTo": "Lăsați câmpurile goale pentru a oferi recuperarea gratuit.",
"hc.legalNotice": "Notificare legală",
"hc.limitReachedUpgradeToA": "Limită atinsă — faceți upgrade la un plan superior",
"hc.linkCopiedShareOn": "Link copiat — partajați-l pe {label}",
"hc.linkUnavailable": "Linkul este indisponibil",
"hc.linkedTo": "Legat de",
"hc.listingHiddenByModeration": "Anunțul este ascuns de moderare.",
"hc.loading": "Se încarcă…",
"hc.locateMe": "Găsește-mă",
"hc.logIn": "Conectează-te",
"hc.logInToGetBack": "Conectează-te pentru a reveni în spațiul tău și a-ți gestiona abonamentul.",
"hc.loginFailed": "Conectarea a eșuat",
"hc.lostFoundPlatform": "Platformă de obiecte pierdute și găsite.",
"hc.lostIn": "pierdut în",
"hc.lowRate": "Rată mică",
"hc.mainReason": "Motiv principal",
"hc.mainStreet": "Strada principală",
"hc.makeSureThisIsThe": "Asigură-te că acesta este articolul pe care l-ai pierdut înainte de a debloca detaliile de contact ale găsitorului.",
"hc.manageCookies": "Gestionează cookie-urile",
"hc.manageMyTeam": "Gestionează echipa mea",
"hc.manageYourTeam": "Gestionează-ți echipa",
"hc.markAsReturned": "Marchează ca returnat",
"hc.matchNoClaimInTime": "Potrivirea nu a primit nicio revendicare în termenul limită.",
"hc.matchNotFound": "Potrivirea nu a fost găsită",
"hc.medium": "Mediu",
"hc.milestoneFmt": "{m} articole returnate — obiectiv atins! Pe drum către {next}.",
"hc.missingFeatures": "Funcții lipsă",
"hc.monthly": "Lunar",
"hc.monthlyBilling": "Facturare lunară",
"hc.moveThePhotoToFit": "Mută fotografia pentru a o încadra în cerc.",
"hc.myAccount": "Contul meu",
"hc.myInvoices": "Facturile mele",
"hc.myMonthlyInvoices": "Facturile mele lunare",
"hc.nArchived": "{n} listare(e) arhivate.",
"hc.newCodeGeneratedAndSent": "Cod nou generat și trimis clientului prin email și SMS",
"hc.newCodeGeneratedAndSent2": "Cod nou generat și trimis proprietarului",
"hc.newPassword": "Parolă nouă",
"hc.next": "Următorul",
"hc.nextPhoto": "Următoarea fotografie",
"hc.no": "Nu",
"hc.noAnswerProvided": "Nu a fost oferit niciun răspuns.",
"hc.noArchivedDeclarations": "Nicio declarație arhivată",
"hc.noCountryFound": "Nicio țară găsită",
"hc.noDeclarations": "Nicio declarație",
"hc.noFeesAreChargedTo": "Nicio taxă nu este percepută clientului.",
"hc.noInvoiceYet": "Nicio factură încă.",
"hc.noInvoiceYetYourInvoices": "Nicio factură încă. Facturile tale vor apărea aici automat după fiecare plată.",
"hc.noMatchIsAvailableFor": "Niciun meci disponibil pentru moment. Te vom anunța imediat ce un articol se potrivește declarației tale.",
"hc.noShipmentMatchesYourSearch": "Niciuntransport nu se potrivește cu căutarea ta.",
"hc.noShipmentsYet": "Niciun transport încă.",
"hc.noShipmentsYet2": "Niciun transport încă",
"hc.none": "niciunul",
"hc.noneChooseForEachShipment": "Niciunul (alege pentru fiecare transport)",
"hc.notMine": "Nu este al meu",
"hc.of": "din",
"hc.only": "Doar",
"hc.onlyEachSiteManagesIts": "doar. Fiecare site își gestionează propriile bănci: aceste linkuri nu afectează nicio altă unitate.",
"hc.onlyTheOwnerOrAn": "Numai proprietarul sau un administrator poate configura linkurile de plată ale unității.",
"hc.openDepositInTheMenu": "Deschide „Depozit” în meniu, descrie articolul și fă o fotografie. Este salvată imediat și gata să fie returnată.",
"hc.openSettings": "Deschide Setări →",
"hc.openTheDeclarationToManage": "Deschide declarația pentru a gestiona transportul",
"hc.optional": "— opțional",
"hc.optional2": "(opțional)",
"hc.optional3": "opțional",
"hc.originalListingPhotoUsed": "Fotografie originală a listării utilizată",
"hc.other": "Altele",
"hc.other2": "Altele…",
"hc.ourProducts": "Produsele noastre",
"hc.overallRateTrendLast6": "Tendința generală a ratei (ultimele 6 luni)",
"hc.ownerSClaimCode": "Codul de reclamație al proprietarului",
"hc.ownershipConfirmed": "Proprietatea confirmată",
"hc.paid": "Plătit",
"hc.paidOn": "Plătit pe",
"hc.paidViaPartner": "Plătit (prin partener)",
"hc.parcelBeingPrepared": "Pachet în pregătire",
"hc.parcelDelivered": "Pachet livrat",
"hc.parcelShipped": "Pachet expediat",
"hc.parisGareDeLyon": "Paris, Gare de Lyon…",
"hc.partner": "Partener",
"hc.partner2": "partener",
"hc.partnerDirectory": "Director parteneri",
"hc.passedOnToTheCustomer": "— transmis clientului linkul de plată.",
"hc.password": "Parolă",
"hc.passwordResetPleaseLogIn": "Restabilire parolă, te rugăm să te conectezi.",
"hc.passwordUpdated": "Parola actualizată.",
"hc.passwordsDoNotMatch": "Parolele nu se potrivesc.",
"hc.pasteThisSenderIdIn": "Lipește acest ID de expeditor în Findloop → Setări",
"hc.payForTheShipmentOf": "Plătește pentru expedierea articolului tău prin Findloop cu o plată sigură.",
"hc.payTheRecoveryFees": "Plătește taxele de recuperare",
"hc.payTheShippingFees": "Plătește taxele de transport",
"hc.payment": "Plată",
"hc.paymentAlreadyConfirmedByThe": "Plata a fost deja confirmată de partener",
"hc.paymentLinksAreNowConfigured": "Linkurile de plată sunt acum configurate pe fiecare unitate",
"hc.paymentNotCompletedYourAccount": "Plata nu a fost finalizată, contul tău nu a fost creat — te rugăm să încerci din nou.",
"hc.paymentReceived": "Plata primită",
"hc.paymentSuccessful": "Plata a fost efectuată cu succes!",
"hc.pdfInvoice": "Factură PDF",
"hc.pending": "În așteptare",
"hc.period": "Perioadă",
"hc.phoneNumber": "Număr de telefon",
"hc.phoneOptional": "Telefon (opțional)",
"hc.planAt": "plan la",
"hc.planLimitFmt": "Planul tău \"{plan}\" este limitat la {max} unități. Pentru a gestiona {n} site-uri, recomandăm",
"hc.platformReturnTarget": "Obiectiv returnare platformă",
"hc.pleaseCompleteYourShippingAddress": "Te rugăm completează adresa ta de livrare.",
"hc.pleaseProvideAPhoneNumber": "Te rugăm să furnizezi un număr de telefon: este necesar de către transportator pentru livrare.",
"hc.pleaseProvideAReason": "Te rugăm să oferi un motiv.",
"hc.pleaseSetYourOwnPassword": "te rog să îți stabilești propria parolă înainte de a continua.",
"hc.pointsToGoal": "{n} puncte în plus pentru a atinge obiectivul nostru comun.",
"hc.posterPreview": "Previzualizare poster",
"hc.potentialMatchBeingVerified": "Posibilă potrivire în verificare",
"hc.potentialOwner": "Proprietar potențial",
"hc.preFilledAutomaticallyYouCan": "Completo automat — poți să-l înlocuiești cu o fotografie a pachetului.",
"hc.pressKit": "Pachet de presă",
"hc.previewMode": "Mod de previzualizare:",
"hc.previewOfThePrintReady": "Previzualizare a posterului A4 pregătit pentru tipar pentru acest stabiliment.",
"hc.previous": "Anterior",
"hc.previousPhoto": "Fotografia anterioară",
"hc.primary": "principal",
"hc.printThePoster": "Tipărește posterul",
"hc.privacy": "Confidențialitate",
"hc.privacyPolicy": "Politica de confidențialitate",
"hc.processedCasesWillAppearHere": "Cazurile procesate vor apărea aici.",
"hc.proofOfReturnPdf": "Dovada returnării (PDF)",
"hc.protectedByRecaptcha": "Protejat de reCAPTCHA",
"hc.publicMatch": "Potrivire publică",
"hc.putBackInStorage": "Puneți-l înapoi în depozit",
"hc.pwdResetByTeam": "Parola dumneavoastră a fost resetată de echipa noastră. Pentru securitatea dumneavoastră,",
"hc.questionsToAskTheOwner": "Întrebări de pus proprietarului",
"hc.rateChargedToTheCustomer": "Tariful perceput clientului:",
"hc.rateOfTarget": "{rate}% realizat dintr-un obiectiv de {target}%",
"hc.reached": "atins",
"hc.reactivating": "Reactivare…",
"hc.reasonSavedYouCanStill": "Motiv salvat. Încă mai puteți revendica articolul dumneavoastră.",
"hc.recentMatchesFirst": "Cele mai recente potriviri mai întâi",
"hc.recognizedThePhotoYouSent": "a recunoscut fotografia pe care ați trimis-o și a descris aceste caracteristici. Confirmați doar dacă se potrivesc cu articolul aflat în posesia dumneavoastră.",
"hc.recommended": "Recomandat",
"hc.recoveryFees": "Tarife de recuperare",
"hc.recoveryFeesArePaidDirectly": "Tarifele de recuperare se plătesc direct stabilimentului partener. Findloop nu primește nicio plată de la clienți.",
"hc.recoveryFeesEnabled": "Tarifele de recuperare sunt activate",
"hc.recoveryOfferedByTheEstablishment": "Recuperare oferită de stabiliment — Findloop nu percepe taxe.",
"hc.recoveryPaymentLink": "Link de plată pentru recuperare",
"hc.recoveryPaymentLinkSavedFor": "Linkul de plată pentru recuperare a fost salvat pentru acest stabiliment",
"hc.redirecting": "Redirecționare…",
"hc.redirectingToPayment": "Redirecționare către plată…",
"hc.redirectingToTheRecoveryOf": "Redirecționare către recuperarea articolului dumneavoastră…",
"hc.regenerateAndResendToThe": "Regenerați și trimiteți din nou proprietarului",
"hc.regenerateTheCode": "Regenerați codul",
"hc.registerAFoundItem": "Înregistrați un articol găsit",
"hc.rejectTheClaim": "Respingeți reclamația",
"hc.reminderDelaySaved": "Întârziere memento salvată",
"hc.reopenThePaymentLink": "Redeschideți linkul de plată",
"hc.repeatThePassword": "Repetați parola",
"hc.reportAProblem": "Raportează o problemă",
"hc.reportDismissedYourListingRemains": "Raport respins. Anunțul tău rămâne public.",
"hc.requiredUsedToCalculateThe": "Necesare: folosit pentru a calcula tariful de transport Sendcloud. Transportul nu este disponibil pentru peste 30 kg.",
"hc.reset": "Resetare",
"hc.resume": "Continuare",
"hc.resumeRegistration": "Continuare înregistrare",
"hc.retro": "Anul în revistă",
"hc.returnSecurity": "Securitate la retur",
"hc.returnToTheOwner": "Returnare către proprietar",
"hc.returned": "returnat",
"hc.reviewTheItemDetails": "Verifică detaliile articolului",
"hc.revokeAccess": "Revocare acces",
"hc.role": "Rol:",
"hc.save": "Salvează",
"hc.save2": "salvează",
"hc.saveAndContinue": "Salvează și continuă",
"hc.saving": "Salvând…",
"hc.scanTheClaimCode": "Scanează codul de revendicare",
"hc.scanTheOwnerSQr": "Scanează QR-ul proprietarului",
"hc.scrollThroughLanguages": "Derulează prin limbi",
"hc.searchByCustomerItemOr": "Caută după client, articol sau număr de urmărire…",
"hc.searchForACountry": "Caută o țară…",
"hc.secureFindoVerification": "Verificare sigură Findloop",
"hc.seeRetro": "Vezi anul în revistă",
"hc.selectedCarrier": "Transportator selectat:",
"hc.selectedPlan": "Plan selectat",
"hc.send": "Trimite",
"hc.sendcloudSenderIdSaved": "ID-ul expeditorului Sendcloud salvat",
"hc.sendcloudSenderIdSenderId": "ID-ul expeditorului Sendcloud (sender_id)",
"hc.sending": "Trimitere…",
"hc.sessionExpired": "Sesiune expirată",
"hc.setUpYourEstablishments": "Configurează-ți stabilimentele",
"hc.settings": "Setări",
"hc.settingsSubtitle": "Plăți externe și memento-uri, configurate pe fiecare stabiliment.",
"hc.shareFoundText": "Am găsit un articol — ajută-mă să-i găsesc proprietarul pe Findloop",
"hc.shareLostText": "Am pierdut un articol — ajută-mă să-l găsesc pe Findloop",
"hc.sharePreview": "Previzualizare partajare",
"hc.shareTheRanking": "Partajează clasamentul",
"hc.shareYourQrCodeTo": "Partajează codul tău QR pentru a primi declarații.",
"hc.shipRateAutoWeight": "Tariful de transport este calculat automat prin Sendcloud (greutate {w}) la momentul expedierii.",
"hc.shipRateForWeight": "Tarif de livrare (Sendcloud + {m}% marjă) pentru {w}:",
"hc.shipments": "Expediții",
"hc.shipmentsSubtitle": "Vedere consolidată a tuturor expedițiilor unității, în toate cazurile. Fă clic pe un rând pentru a gestiona expediția în declarația sa.",
"hc.shipping": "Livrare",
"hc.shippingAddress": "Adresă de livrare",
"hc.shippingFeesAreHandledAutomatically": "Taxele de livrare sunt gestionate automat de Findloop (Sendcloud) — fără link de introdus.",
"hc.shippingFeesHaveAlreadyBeen": "Taxele de livrare au fost deja plătite: transportatorul nu mai poate fi schimbat.",
"hc.shippingNotAvailableForItems": "Livrare indisponibilă pentru articole de peste 30 kg. Clientul va trebui să ridice articolul personal.",
"hc.shippingPaid": "Livrare plătită ✓",
"hc.showOnlyItemsMatchingA": "Afișează doar articolele care se potrivesc cu o listă publică (client)",
"hc.showPassword": "Arată parola",
"hc.signInTheBoxAbove": "Autentifică-te în caseta de mai sus",
"hc.signatureSaved": "Semnătura salvată",
"hc.signedInWithGoogle": "Autentificat cu Google",
"hc.signupFailed": "Înscriere eșuată",
"hc.silver": "Argintiu",
"hc.simulatedRatesInPreProduction": "(tarife simulate în pre-producție)",
"hc.siretAndVatNumberRequired": "Număr SIRET și TVA necesar (Franța).",
"hc.skip": "Sari",
"hc.smsSentIfAccount": "Dacă există un cont cu acest număr, ți-a fost trimis un SMS.",
"hc.sortItemsWithAPublic": "Sortează: articole cu o potrivire publică (cele mai recente) întâi",
"hc.specifyWhetherYouRecoveredYour": "Specifică dacă ai recuperat articolul tău sau pur și simplu vrei să îndepărtezi această listă.",
"hc.specifyYourReason": "Specifică motivul tău",
"hc.specifyYourReason2": "Specifică motivul tău…",
"hc.staff": "Personal",
"hc.status": "Status",
"hc.staySignedIn": "Rămâi autentificat",
"hc.step": "Pas",
"hc.stillThere": "Încă ești acolo?",
"hc.stopScrolling": "Oprește derularea",
"hc.storeFindWithQr": "Păstrează și găsește cu QR",
"hc.streetName": "Numele străzii",
"hc.streetNo": "Nr. str.",
"hc.switchTo": "Schimbă la",
"hc.switchToDarkMode": "Schimbă la modul întunecat",
"hc.switchToLightMode": "Schimbă la modul luminos",
"hc.takeAPhoto": "Fă o fotografie",
"hc.takeChangeThePhoto": "Fă / schimbă fotografia",
"hc.takenFromYourDeclaration": "luat din declarația ta",
"hc.target": "Țintă",
"hc.targetReached": "Obiectiv atins",
"hc.targetReachedThankYouTo": "Obiectiv atins — mulțumim întregii comunități Findloop!",
"hc.tellUsMore": "Spune-ne mai multe…",
"hc.tellUsWhyYouCancel": "Spune-ne de ce anulezi. Acest lucru ajută partenerul să proceseze cererea ta.",
"hc.tellUsWhyYourListing": "Spune-ne de ce. Lista ta rămâne activă și poți revendica în continuare articolul.",
"hc.termsAndConditions": "Termeni și condiții",
"hc.termsAndPolicies": "Termeni și politici",
"hc.thankYouForYourFeedback": "Îți mulțumim pentru feedback-ul tău",
"hc.theBannerDisplayedInThe": "bannerul afișat în registru.",
"hc.theClaimantHasBeenInformed": "Reclamantul a fost informat. Articolul rămâne disponibil în lista publică.",
"hc.theClaimantHasBeenNotified": "Reclamantul a fost notificat și poate acum să continue cu returul.",
"hc.theCustomerPaysTheFees": "Clientul plătește taxele către unitate.",
"hc.theDayTheLegalRetention": "Ziua în care se atinge perioada de retenție legală.",
"hc.theEstablishmentConsideredThatThis": "Unitatea a considerat că acest articol nu este al tău.",
"hc.theEstablishmentIsReviewingYour": "Unitatea îți revizuiește răspunsurile. Vei fi notificat imediat ce reclamația ta este validată, apoi poți plăti taxele de recuperare.",
"hc.theFeesAreTooHigh": "Taxele sunt prea mari",
"hc.theFinderConsideredThatThis": "Descoperitorul a considerat că acest articol nu este al tău.",
"hc.theFinderIsReviewingYour": "Descoperitorul îți revizuiește reclamația. Vei fi notificat imediat ce aceasta este validată.",
"hc.theItem": "Articolul",
"hc.theItemWillBeRemoved": "Articolul va fi eliminat din registru (fără reclamație în curs).",
"hc.theItemWillBeSet": "Articolul va fi setat la \"în stoc\" și reclamația aferentă anulată.",
"hc.theKbisNumberAndVat": "Numărul Kbis și numărul de TVA sunt necesare pentru Franța.",
"hc.theLabelIsGeneratedAutomatically": "Eticheta este generată automat imediat ce clientul a plătit taxele de livrare. Aceasta va fi descărcabilă aici.",
"hc.theLinkMayHaveExpired": "Linkul ar putea fi expirat (valabil timp de 30 de zile). Contactează suportul Findloop dacă este necesar.",
"hc.theOwnerDescribesTheirItem": "Proprietarul descrie articolul său",
"hc.theOwnerReceivedItBy": "Proprietarul l-a primit prin email (sau SMS). Introduceți sau scanati-l înainte de predare.",
"hc.thePartnerConsideredThatThis": "Partenerul a considerat că acest articol nu este al tău. Articolul rămâne disponibil.",
"hc.thePartnerIsReviewingYour": "Partenerul îți revizuiește răspunsurile. Vei fi notificat imediat ce reclamația ta este validată.",
"hc.theShipmentIsCreatedAutomatically": "Expedierea este creată automat imediat ce clientul și-a confirmat adresa și a plătit taxele de recuperare. Eticheta va fi generată automat după plata livrării și poate fi descărcată aici.",
"hc.theShippingRateWillBe": "Tariful de livrare va fi calculat automat prin Sendcloud la momentul expediției (greutate înregistrată).",
"hc.thisCarrierWillBe": "Acest transportator va fi",
"hc.thisEstablishment": "această unitate",
"hc.thisFieldIsRequiredFor": "Acest câmp este necesar pentru generarea automată a etichetei.",
"hc.thisIsMyItem": "Acesta este articolul meu",
"hc.thisIsMyItemContinue": "Acesta este articolul meu — continuă",
"hc.thisIsMyItemStart": "Acesta este articolul meu — începe returul",
"hc.thisIsNotMyItem": "Acesta nu este articolul meu",
"hc.thisMatchIsNoLonger": "Această potrivire nu mai este disponibilă sau a fost deja procesată.",
"hc.thisRateWillBeCharged": "Acest tarif va fi perceput clientului. Un tarif mare poate descuraja recuperarea.",
"hc.thisStepIsRequiredFor": "Această etapă este necesară pentru generarea etichetelor de livrare",
"hc.thisValidationLinkIsInvalid": "Acest link de validare este invalid sau a expirat.",
"hc.toCheckBeforeMarkingThe": "Pentru a verifica înainte de a marca articolul ca returnat.",
"hc.toConfigureTheLinksAnd": "pentru a configura link-urile și întârzierea memento pentru fiecare stabiliment.",
"hc.toReachOurFirstMilestone": "pentru a atinge primul nostru obiectiv de 100 de returnări.",
"hc.toTheCustomer": "către client.",
"hc.toTheShippingFeePayment": "la plata taxei de expediere.",
"hc.toYourRecoveryTracking": "la urmărirea recuperării tale.",
"hc.tooExpensiveBudget": "Prea scump / buget",
"hc.topCitiesForReturns": "Orașe de top pentru returnări",
"hc.trackMyRecovery": "Urmărește-mi recuperarea",
"hc.trackTheShipmentAndDownload": "Urmărește expedierea și descarcă eticheta (generată automat) fără a părăsi tab-ul Declarații.",
"hc.trackYourStatistics": "Urmărește-ți statisticile",
"hc.tracking": "Urmărire",
"hc.unableToOpenTheShipping": "Imposibil de deschis plata taxei de expediere. Te rugăm să încerci din nou.",
"hc.unableToRetrieveTheInvoice": "Imposibil de recuperat factura.",
"hc.unclaimed": "Nerevendicat",
"hc.unclaimedCustomerReason": "Articol nerevendicat. Motivul clientului: \"{reason}\".",
"hc.unclaimedItem": "Articol nerevendicat",
"hc.unclaimedItemNoClaimWithin": "Articol nerevendicat — fără revendicare în termenul limită.",
"hc.unclaimedItems": "Articole nerevendicate",
"hc.unclaimedItemsMatchLeftWithout": "Articole nerevendicate: meci lăsat fără o revendicare în termenul limită. Le poți pune înapoi în depozit.",
"hc.unlockTheFinderSContact": "Deblochează detaliile de contact ale găsitorului pentru a aranja predarea.",
"hc.upcoming": "Viitor",
"hc.updateFailed": "Actualizarea a eșuat.",
"hc.usedForInvoices": "Utilizat pentru a emite facturile tale findloop.",
"hc.vatNumber": "Număr TVA",
"hc.verificationPending": "Verificare în așteptare",
"hc.verificationSentToTheFinder": "Verificare trimisă către găsitor. Vei fi notificat cu privire la decizia lor.",
"hc.verificationSentToThePartner": "Verificare trimisă către partener. Vei fi notificat cu privire la decizia lor.",
"hc.verify": "Verifică",
"hc.verifyingInvite": "Verificând link-ul de invitație…",
"hc.verifyingTheLink": "Verificând link-ul…",
"hc.viewInRegistry": "Vezi în registru",
"hc.viewItem": "Vezi articolul",
"hc.viewItemRecover": "Vezi articolul & recuperează",
"hc.visibleToTheOwnerAutomatically": "Vizibil pentru proprietar · șters automat după 60 de zile.",
"hc.waitingForPartnerConfirmation": "Așteptând confirmarea partenerului",
"hc.waitingForThePartnerS": "Așteptând confirmarea partenerului",
"hc.weHaveInformedTheEstablishment": "Am informat stabilimentul că acest articol nu este al tău și am reluat analiza. Vei fi notificat imediat ce se găsește un nou meci.",
"hc.weHaveInformedThePartner": "Am informat partenerul că acest articol nu este al tău. Listarea ta rămâne activă pentru meciurile viitoare.",
"hc.weRanTheAnalysisAgain": "Am reluat analiza și am identificat încă un articol care ar putea fi al tău. Te rugăm să-l verifici din nou.",
"hc.weight": "Greutate",
"hc.weightNotProvidedTheShipping": "Greutatea nu a fost furnizată: tariful de livrare va fi calculat la momentul livrării.",
"hc.weightUnit": "Unitate de greutate",
"hc.welcome": "Bun venit!",
"hc.welcomeToFindo": "Bun venit la Findloop",
"hc.whenACustomerComesTo": "Când un client vine să-și ridice bunurile, deschide declarația și validează returnarea. Asta e tot!",
"hc.whenDisabledFeesDropTo": ". Când este dezactivat, taxele scad la",
"hc.whyIsThisNotYour": "De ce nu este acesta articolul tău?",
"hc.willBeMarkedAs": "va fi marcat ca",
"hc.wrongColor": "Culoare greșită",
"hc.wrongModel": "Model greșit",
"hc.yesCancel": "Da, anulează",
"hc.yesContactTheFinder": "Da, contactează căutătorul",
"hc.youAreHere": "Ești aici",
"hc.youBusinessCom": "tu@business.com",
"hc.youCanNowStartThe": "Poți acum să începi returnarea.",
"hc.youCanStillChangeIt": ". Poți încă să-l schimbi caz cu caz.",
"hc.youHaveAlreadyConfirmedThat": "Ai confirmat deja că acesta este articolul tău.",
"hc.youWillBeRedirectedTo": "Vei fi redirecționat către plata securizată Stripe.",
"hc.yourAccountHasBeenReactivated": "Contul tău a fost reactivat.",
"hc.yourAccountIsActiveYou": "Contul tău este activ, poți acum să-ți gestionezi stabilimentele.",
"hc.yourEstablishment": "Stabilimentul tău",
"hc.yourFeedbackHelpsUsImprove": "Feedback-ul tău ne ajută să îmbunătățim meciurile noastre.",
"hc.yourFeedbackHelpsUsRestart": "Feedback-ul tău ne ajută să reluăm analiza și să ne îmbunătățim meciurile.",
"hc.yourFirstSteps": "Primii tăi pași",
"hc.yourFirstStepsAdmin": "Primii tăi pași (admin)",
"hc.yourItemHasBeenHanded": "Articolul tău a fost predat personal de partener - închide cazul odată ce predarea este confirmată.",
"hc.yourItemHasBeenShipped": "Articolul tău a fost expediat de partener - închide cazul odată ce livrarea este confirmată.",
"hc.yourPaymentHasBeenRecorded": "Plata ta a fost înregistrată.",
"hc.yourShipmentIsBeingPrepared": "Expedierea ta este în curs de pregătire. Vei primi coletul în termen de 3 până la 5 zile lucrătoare.",
"hc.yourShippingFeesHaveAlready": "Taxele tale de livrare au fost deja plătite. Livrare plătită ✓",
"hc.yourShippingFeesHaveBeen": "Taxele tale de livrare au fost plătite. Coletul tău este în curs de pregătire.",
"hc.yourVerificationQuestionsDeposit": "Întrebările tale de verificare (depunere)",
"hero.einvoiceBadge": "Facturare electronică conformă 2027",
"home.recentAdsAll": "Vezi toate anunțurile",
"home.recentAdsEyebrow": "În acest moment",
"home.recentAdsSubtitle": "Articole pierdute și găsite raportate de comunitate.",
"home.recentAdsTitle": "Cele mai recente anunțuri",
"home.reunions": "Reîntâlniri recente",
"home.videoEyebrow": "Vizionați",
"home.videoSubtitle": "Cum reunim obiectele pierdute cu proprietarii lor, fără efort.",
"home.videoTitle": "Descoperiți Findloop în 2 minute",
"home.watchYoutube": "Vizionați pe YouTube",
"impact.already": "Deja",
"impact.citiesWord": "oraș/orase",
"impact.eachPoint": "Fiecare punct este un oraș în care Findloop ajută la recuperarea obiectelor pierdute.",
"impact.emptyMap": "Harta se umple pe măsură ce restituțiile au loc.",
"impact.eyebrow": "Impactul nostru",
"impact.inCities": "în întreaga",
"impact.restitutedTo": "obiecte returnate proprietarilor lor",
"impact.title": "Obiecte returnate, peste tot în apropierea ta",
"inv2.download": "Descarcă",
"inv2.view": "Vezi",
"map.objectsOnMapPlural": "obiecte pe hartă",
"map.objectsOnMapSingular": "obiect pe hartă",
"mc.claimConfirmDesc": "Verificați obiectul găsit de descoperitor înainte de a plăti pentru a debloca detaliile de contact.",
"mc.claimConfirmNo": "Acesta nu este obiectul meu",
"mc.claimConfirmTitle": "Este acesta cu adevărat obiectul tău?",
"mc.claimConfirmYes": "Da, este al meu — plătesc",
"mc.claimFinderContacts": "Detaliile de contact ale descoperitorului",
"mc.claimNotMineDone": "Mulțumim — descoperitorul a fost notificat și cererea ta a fost eliminată din anunț.",
"mc.claimUnlockDesc": "Plătiți taxa de gestionare Findloop pentru a obține detaliile de contact ale persoanei care a găsit obiectul dvs.",
"mc.claimUnlockTitle": "Deblocați detaliile de contact ale descoperitorului",
"mc.hideCountryOffers": "Ascunde ofertele din țara mea",
"mc.myClaims": "Obiecte pe care le reclam",
"mc.myClaimsSub": "Obiecte găsite de alții pe care le revendici. Deblochează detaliile de contact ale descoperitorului pentru a aranja predarea.",
"mc.notifAdCancelled": "Anunț anulat",
"mc.notifCancelAd": "Anulează anunțul meu",
"mc.offersInCountry": "Oferte în țara mea",
"mc.offersInCountryDesc": "Toate recompensele active de la parteneri din țara ta, pe orașe.",
"mc.redArchived": "Arhivat",
"mc.rewardsCountryNone": "Nu există oferte în țara ta încă.",
"mc.rewardsForYou": "Recompense pentru tine",
"mc.rewardsForYouDesc": "Oferite de partenerii unde ai predat un obiect.",
"mc.rewardsMineNone": "Nu există recompense de la partenerii tăi de predare încă.",
"mc.showCountryOffers": "Vezi ofertele din țara mea",
"mc2.cancelDecl": "Anulează declarația mea",
"mc2.cancelDeclDone": "Declarația anulată.",
"pricing.physInvDesc": "Când un obiect este returnat, locația sa este eliberată automat și disponibilă pentru un nou obiect.",
"pricing.physInvTitle": "Urmărirea inventarului fizic",
"pricing.physModalTitle": "Gestionarea articolelor fizice",
"pricing.physQrDesc": "Se generează un cod QR unic pentru fiecare articol, legându-se de toate informațiile acestuia.",
"pricing.physQrTitle": "Etichetă QR dedicată",
"pricing.physShelfDesc": "Fiecare articol înregistrat poate fi atribuit unei locații fizice în cadrul unității.",
"pricing.physShelfTitle": "Planul raftului",
"pricing.physicalMgmt": "Gestionarea articolelor fizice (rafturi, QR, inventar)",
"pub.addSecondPhoto": "Adăugați o a 2-a fotografie (opțional)",
"pub.photo2Added": "✓ A 2-a fotografie adăugată",
"reg.dispositionJournal": "Jurnal de dispoziție",
"reg.dispositionNoteAuthHint": "ℹ️ O notă este necesară pentru „Predat autorităților” (număr de raport, departament…).",
"reg.dispositionNotePh": "Notă (opțional): caritate destinatar, referință autorități, numele cumpărătorului…",
"reg.dispositionNoteRequired": "O referință oficială este necesară pentru a predare autorităților.",
"reg.legalPrealert": "Termen legal în {days} zi(le)",
"reg.legalPrealertOptions": "Opțiuni la termen: vânzare la licitație, donație unei carități, predare autorităților.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Recenzie completă",
"rev.readMore": "Citiți mai mult",
"rw.activeCodes": "Vouchere active",
"rw.archived": "Arhivat",
"rw.archivedTitle": "Vouchere răscumpărate (arhivate)",
"rw.hideArchived": "Ascunde voucherele răscumpărate",
"rw.noArchived": "Niciun voucher arhivat.",
"rw.showArchived": "Afișați voucherele răscumpărate",
"shp.labelAuto": "Eticheta este generată automat imediat ce clientul a plătit taxele de expediere. Va fi descărcabilă aici.",
"st.cancelled_by_customer": "Anulat",
"stt.dispoPdfBtn": "Export PDF",
"stt.dispoPdfError": "Exportul PDF a eșuat.",
"stt.dispoPdfExporting": "Se exportă…",
"trk.matchVerifying": "Verificarea unei potriviri potențiale",
"pcat.stadium_arena": "Stadion / Arenă",
"pcat.supermarket": "Supermarche",
"pcat.taxi_vtc": "Taxi / Ride-hailing",
"pcat.tourism_office": "Birou turistic",
"pcat.train_bus_station": "Gara / stația de autobuz",
"pcat.travel_agency": "Agenție de turism",
"hc.and": "și",
"hc.demoObj0": "o portofelă",
"hc.demoObj1": "o geantă sport",
"hc.demoObj2": "un telefon",
"hc.demoObj3": "o pereche de ochelari",
"hc.demoObj4": "un set de chei",
"hc.demoObj5": "o eșarfă",
"hc.demoObj6": "un laptop",
"hc.demoObj7": "o sticlă de apă",
"hc.demoWhen0": "cu 2 ore în urmă",
"hc.demoWhen1": "cu 5 ore în urmă",
"hc.demoWhen2": "ieri",
"hc.demoWhen3": "cu 3 ore în urmă",
"hc.demoWhen4": "în această dimineață",
"hc.demoWhen5": "cu 1 zi în urmă",
"hc.feedDemo": "{obj} a fost returnat în {city} {when}.",
"hc.feedReal": "Un articol ({cat}) a fost returnat în {city}.",
"hc.saveBtn": "Salvează",
"hc.saveLink": "Salvează linkul",
"hc.terms": "Termeni",
"hc.view": "Vizualizează",
"pcat.airline": "Companie aeriană",
"pcat.airport": "Aeroport",
"pcat.amusement_park": "Parc de distracții",
"pcat.bank": "Bancă",
"pcat.bar_cafe": "Bar / Cafenea",
"pcat.beauty_salon": "Frizerie / Salon de înfrumusețare",
"pcat.cinema": "Cinematograf",
"pcat.concert_theater": "Sală de concerte / Teatru",
"pcat.coworking": "Spațiu de coworking",
"pcat.gym_fitness": "Sală de sport / Fitness",
"pcat.hospital_clinic": "Spital / Clinica",
"pcat.library": "Bibliotecă",
"pcat.mall": "Centrul comercial",
"pcat.museum": "Muzeu",
"pcat.pharmacy": "Farmacie",
"pcat.private_company": "Companie privată",
"pcat.public_transport": "Transport public",
"pcat.school_university": "Școală / Universitate",
"pcat.sports_center": "Centrul sportiv",
"an.found": "Găsit",
"an.lost": "Pierdut",
"hc.shareReview": "Împărtășește recenzia",
"hc.citiesAboveTarget": "{n} orașe peste țintă",
"hc.cityAboveTarget": "{n} oraș peste țintă",
"hc.j15EarlyReminder": "Reminder anticipat D-15",
"hc.j7EarlyReminder": "Reminder anticipat D-7",
"hc.annualTotal": "Total anual",
"hc.billedOnceYear": "Taxat o dată pentru 12 luni, reînnoit anual.",
"hc.monthlyPrice": "Preț lunar",
"hc.perMonth": "/ lună",
"hc.perYear": "/ an",
"hc.billedEachMonth": "Facturat automat în fiecare lună.",
"nav.business": "Afaceri",
"nav.individual": "Individual",
"hc.circumstancesFound": "Circumstanțele găsirii",
"hc.circumstancesFoundPh": "De exemplu, găsit pe jos lângă intrarea în metrou",
"hc.circumstancesLost": "Circumstanțele pierderii",
"hc.circumstancesLostPh": "De exemplu, lăsat pe o bancă în timp ce așteptam autobuzul",
"hc.conditionPh": "De exemplu, bun, zgâriat…",
"hc.firstName": "Prenume",
"hc.lastName": "Nume",
"hc.quantity": "Numărul de articole",
"fa.ownerContact": "Detalii de contact ale proprietarului",
"fa.payPublish": "Plătește și publică",
"fa.pendingPayText": "Anunțul tău va fi activat imediat ce plata este confirmată.",
"fa.pendingPayTitle": "Plata în așteptare",
"fa.planSub": "Anunțul tău devine activ imediat ce plata este confirmată.",
"fa.planTitle": "Durata anunțului",
"fa.pubSuccessMsg": "Anunțul tău este activ. Vei fi notificat imediat ce un căutător se face cunoscut.",
"fa.pubSuccessTitle": "Anunț publicat",
"fa.publicNote": "Numai descrierea, orașul, țara și fotografiile sunt afișate public.",
"fa.redirectStripe": "Se redirecționează către plata securizată…",
"fa.reject": "Respinge",
"fa.rejectConfirm": "Respinge această declarație? Anunțul tău rămâne online.",
"fa.rejected": "Declarație respinsă",
"fa.rejectedFinder": "Nu era obiectul pe care-l căutau",
"fa.rejectedFinderText": "Proprietarul spune că acest obiect nu este al său. Mulțumim pentru ajutor!",
"fa.responsesTitle": "Declarații ale căutătorilor",
"fa.sent": "Declarația a fost trimisă proprietarului.",
"fa.submitDecl": "Trimite declarația mea",
"fa.submitDeclPay": "Trimite și contribuie {amount}",
"fa.total": "Total de plătit",
"fa.ttc": "incl. TVA",
"fa.waitClaimText": "Căutătorul îți revizuiește cererea. Vei fi notificat cu privire la decizia lor.",
"fa.waitFinderText": "Te vom informa imediat ce un căutător va trimite o declarație.",
"fa.waitFinderTitle": "Anunțul tău este activ",
"fa.waitOwnerText": "Proprietarul compară declarația ta cu a lui. Vei fi notificat cu privire la decizia lor.",
"fa.waitOwnerTitle": "Așteptând decizia proprietarului",
"st.pending_payment": "Plata în așteptare",
"fa.approve": "Aprobat",
"fa.approveConfirm": "Aprobați această declarație? Detaliile dvs. de contact complete (nume, email, telefon) vor fi schimbate cu finder's.",
"fa.approved": "Declarație aprobată — detalii de contact schimbate",
"fa.approvedFinder": "Proprietarul a aprobat declarația dvs.",
"fa.approvedFinderText": "Contactați-i pentru a aranja returul.",
"fa.boostSub": "Anunțul dvs. rămâne în partea de sus pentru durata aleasă.",
"fa.boostTitle": "Boost my listing (opțional)",
"fa.colFinder": "Declarația finder's",
"fa.colYours": "Declarația dvs.",
"fa.compareHint": "Comparați declarația finder's cu a dvs. înainte de a decide.",
"fa.contribNone": "Nicio contribuție",
"fa.contribPaid": "Contribuție primită — vă mulțumim!",
"fa.contribPending": "Contribuția așteaptă plată",
"fa.contribSub": "Sprijiniți Findloop pentru a ajuta mai mulți oameni să își recupereze bunurile. Puteți alege €0.",
"fa.contribSuccessMsg": "Declarația dvs. a fost trimisă proprietarului.",
"fa.contribSuccessTitle": "Vă mulțumim pentru contribuția dvs.",
"fa.contribTitle": "Contribuție voluntară",
"fa.days3": "3 zile",
"fa.days30": "30 zile",
"fa.days7": "7 zile",
"fa.declSub": "Descrieți obiectul pe care l-ați găsit. Proprietarul va compara declarația dvs. cu a lor.",
"fa.declTitle": "Am găsit acest obiect",
"fa.expiresOn": "Expire pe",
"fa.fBrand": "Brand",
"fa.fCircumstances": "Circumstanțe",
"fa.fCity": "Oraș",
"fa.fColor": "Culoare",
"fa.fCondition": "Condiție",
"fa.fDate": "Data",
"fa.fMessage": "Mesajul finder's",
"fa.fPlace": "Loc",
"fa.fQuantity": "Cantitate",
"fa.finderContact": "Detalii de contact ale finder's",
"fa.finishPay": "Finalizați plata",
"fa.foundDate": "Data găsirii",
"fa.foundPlace": "Locul găsirii",
"fa.hours24": "24 de ore",
"fa.ht": "excl. TVA",
"fa.months3": "3 luni",
"fa.noBoost": "Fără boost",
"fa.africaFree": "Listare gratuită în Africa — ofertă de lansare Findloop, bucură-te de ea!",
"fa.africaPublished": "Listare publicată gratuit — ofertă de lansare în Africa!",
"fa.approveClaimConfirm": "Aprobi această revendicare? Proprietarul va putea apoi să îți deblocheze datele tale de contact.",
"fa.checkInfo": "Verifică detaliile tale înainte de trimitere: acestea vor fi comparate cu cele ale găsitorului.",
"fa.claimApprovedShort": "Găsitorul ți-a aprobat revendicarea",
"fa.claimRejectedShort": "Revendicare respinsă de către găsitor",
"fa.claimRejectedText": "Găsitorul consideră că acest obiect nu îți aparține.",
"fa.claimSub": "Descrie-ți obiectul și adaugă 2 fotografii. Găsitorul le va compara cu listarea lor.",
"fa.claimTitle": "Acesta este obiectul meu",
"fa.claimUnlockText": "Deblochează datele de contact ale găsitorului pentru a organiza returnarea.",
"fa.claimUnlockedShort": "Datele de contact deblocate — vezi urmărirea",
"fa.claimsTitle": "Revendicări ale proprietarului",
"fa.colOwner": "Declarația proprietarului",
"fa.colYourAd": "Listarea ta",
"fa.expired": "Listare expirată",
"fa.free": "Gratuit",
"fa.lostDate": "Data pierderii",
"fa.lostPlace": "Locul pierderii",
"fa.noReceipt": "Nu există chitanță disponibilă pentru această listare.",
"fa.planSubFree": "Alege durata: listarea ta devine activă imediat, fără plată necesară.",
"fa.prefillPrevious": "Foloseste detaliile listării mele anterioare în această categorie",
"fa.receipt": "Chitanță PDF",
"fa.renewBtn": "Reînnoiește",
"fa.renewDiscountBanner": "50% reducere: reînnoiește înainte ca listarea ta să expire!",
"fa.renewDiscountHint": "50% reducere aplicată pentru că reînnoiești înainte de expirare.",
"fa.renewEarly": "Reînnoiește (−50%)",
"fa.renewTitle": "Reînnoiește listarea mea",
"fa.renewed": "Listare reînnoită",
"fa.sendClaim": "Trimite revendicarea mea",
"fa.twoPhotos": "2 fotografii ale obiectului tău",
"fa.twoPhotosError": "Adaugă 2 fotografii ale obiectului tău.",
"fa.twoPhotosHint": "Fotografii personale care dovedesc că obiectul este al tău (cu obiectul, factură, cutie…).",
"fa.unlockBtn": "Deblochează datele de contact",
"fa.unlockFree": "Deblochează gratuit — ofertă de lansare",
"fa.waitClaimantText": "Te vom anunța imediat ce un proprietar revendică acest obiect.",
"fa.waitFinderDecision": "Așteptând decizia găsitorului",
"fa.waitUnlockText": "Vei fi notificat imediat ce datele de contact sunt schimbate.",
"fa.waitUnlockTitle": "Așteptând ca proprietarul să deblocheze",
"fa.cancel": "Anulează",
"fa.categoryRequired": "Alege o categorie pentru articolul găsit.",
"fa.confirmTitle": "Confirmă decizia ta",
"fa.goBack": "Înapoi",
"dr.continue": "Continuă declarația mea",
"dr.delete": "Șterge permanent",
"dr.deleteConfirm": "Ștergi definitiv acest proiect? Aceasta nu poate fi anulată.",
"dr.deleted": "Proiect șters",
"dr.expiresIn": "Proiect păstrat pentru încă {h} ore",
"dr.title": "Ai o declarație neterminată",
"form.step": "Pas",
"form.next": "Continuă",
"form.back": "Înapoi",
"form.stepDetails": "Raportul tău",
"form.stepPublish": "Durată, promovare și plată",
"form.stepThanks": "Mulțumim și contribuția ta",
"fthx.badge": "Raport aproape finalizat",
"fthx.title": "Mulțumim, faci o diferență!",
"fthx.text": "Datorită ție, cineva ar putea primi în curând înapoi ceva ce contează pentru ei. Actele de bunătate precum al tău sunt exact ceea ce menține Findloop în viață.",
"fthx.impact1": "1 articol raportat",
"fthx.impact2": "1 șansă în plus de reuniune",
"fthx.tipTitle": "Un mic sprijin pentru Findloop?",
"fthx.tipText": "Contribuția ta ne ajută să menținem serviciul accesibil și să reunim și mai multe obiecte cu proprietarii lor.",
"fthx.optional": "100% opțional — poți publica fără a contribui.",
"fthx.thanksTip": "Îți mulțumim mult pentru generozitatea ta!",
"fthx.suggest": "Sume sugerate",
"fthx.none": "Fără contribuție",
"pay.pendingTitle": "Plata nefinalizată",
"pay.pendingText": "Detaliile tale sunt salvate. Continuă plata de unde ai rămas.",
"pay.resume": "Continua plata",
"pay.expiredTitle": "Secțiunea de plată a expirat",
"pay.expiredText": "Pentru siguranța ta, sesiunea de plată a expirat. Detaliile tale sunt salvate: reîncepe plata cu un singur clic.",
"pay.relaunch": "Reîncepe plata",
"sub.received": "Trimis!",
"sub.publishing": "Finalizăm…",
"sub.toPayment": "Redirecționare către plata securizată…",
"fa.claimSubV2": "Descrieți obiectul dvs. pierdut. Persoana care l-a găsit va compara declarația dvs. cu anunțul lor.",
"fa.photosOptional": "Fotografii ale obiectului dvs. (opțional)",
"fa.compareOwnerHint": "Comparați aceste informații cu obiectul pe care l-ați găsit, apoi spuneți dacă este același obiect.",
"fa.itsThisItem": "Da, acesta este obiectul",
"fa.notThisItem": "Nu, acesta nu este obiectul",
"fa.confirmIsItem": "Confirmați că acesta este obiectul? Detaliile dvs. de contact și cele ale proprietarului vor fi afișate în conturile respective.",
"fa.confirmNotItem": "Confirmați că acesta nu este obiectul? Raportul dvs. va fi închis.",
"fa.youConfirmed": "Ați confirmat că acesta este obiectul proprietarului",
"fa.youDeclined": "Ați indicat că acesta nu era obiectul",
"fa.youDeclinedText": "Vă mulțumim pentru ajutor! Proprietarul a fost informat.",
"fa.waitFinderDecisionOwner": "Așteptând decizia găsitorului",
"fa.finderConfirmed": "Confirmat",
"fa.notYourItem": "Acesta nu era obiectul dvs.",
"fa.reportedOn": "Raportat pe",
"fa.ownerWaitHint": "Un găsitor verifică în prezent informațiile, vă rugăm să așteptați.",
"fa.claimSentFinder": "Reclamă trimisă persoanei care a găsit obiectul.",
"fa.compareClaimHint": "Compară declarația proprietarului cu anunțul tău înainte de a decide.",
"fa.closeFollowup": "Închide acest follow-up",
"fa.closeFollowupConfirm": "Vrei să închizi acest follow-up? Emailurile și numerele de telefon ale ambelor părți vor fi șterse permanent după ce proprietarul își va închide și el anunțul.",
"fa.safetyTitle": "Sfaturi de siguranță înainte de predare",
"fa.safety1": "Cere proprietarului o descriere detaliată a caracteristicilor ascunse ale obiectului: o zgârietură specifică, conținutul exact al unei genți, tapetul, numărul de serie…",
"fa.safety2": "Dacă este posibil, cere dovada vizuală (o fotografie a obiectului) sau dovada achiziției.",
"fa.safety3": "Predă obiectul într-un loc public sau la un partener Findloop și verifică ID-ul proprietarului.",
"fa.safetyOk": "Am înțeles, continuă",
"fa.ownerClosedNote": "Proprietarul și-a închis anunțul.",
"fa.finderClosedNote": "Persoana care a găsit a închis follow-up-ul.",
"fa.followupClosed": "Urmărire închisă",
"fa.followupClosedText": "Ai închis această urmărire. Mulțumim pentru ajutor!",
"fa.photoReviewTitle": "Un finder a trimis o fotografie. Arată ca obiectul tău?",
"fa.photoLooksLike": "Da, arată ca obiectul meu",
"fa.photoNotMine": "Nu, acesta nu este obiectul meu",
"fa.photoNotMineConfirm": "Urmărirea va fi închisă de ambele părți și anunțul tău va rămâne activ pentru un nou finder.",
"fa.photoLooksLikeDone": "Mulțumim! Finderul va compara acum declarația ta.",
"fa.photoNotMineDone": "Raportul a fost respins. Anunțul tău rămâne activ.",
"fa.ownerPhotoHint": "Numai fotografia finderului îți este arătată. Spune-ne dacă arată ca obiectul tău.",
"fa.ownerReviewingPhoto": "Proprietarul îți revizuiește fotografia",
"fa.ownerReviewingPhotoText": "Vei fi notificat imediat ce ei răspund. Vei putea apoi să compari declarația lor.",
"fa.ownerRejectedPhoto": "Acesta nu este obiectul proprietarului",
"fa.ownerRejectedPhotoText": "Proprietarul spune că fotografia ta nu se potrivește cu obiectul lor. Urmărirea este închisă. Mulțumim pentru ajutor!",
"fa.contribute": "Contribuie",
"fa.phoneMissing": "Nu a fost furnizat",
"fa.ownerSafety1": "Preferă o predare într-un loc public sau la un partener Findloop. Dacă distanța este mare, sugerează trimiterea prin poștă.",
"fa.ownerSafety2": "La predare, verifică ID-ul celui care a găsit.",
"pub.changePhoto": "Schimbă fotografia",
"ph.secured": "Fotografia este securizată",
"ph.securing": "Se securizează fotografia…",
"fa.ownerSafety3": "Dacă fotografia găsitorului are sigla Findloop, nu acceptați întâlnirea. Fotografia trebuie să fie o imagine originală realizată de găsitor, fără siglă."
},
"hu": {
"a.back": "Vissza",
"a.category": "Kategória",
"a.categoryPlaceholder": "Válassz egy kategóriát",
"a.city": "Város",
"a.confirmPassword": "Jelszó megerősítése",
"a.country": "Ország",
"a.createAccount": "Fiók létrehozása",
"a.createBtn": "Fiókom létrehozása",
"a.creating": "Létrehozás…",
"a.email": "Email",
"a.emailPro": "Üzleti email",
"a.forgot": "Elfelejtetted?",
"a.forgotSent": "Ha létezik fiók, akkor egy visszaállító linket éppen most küldtünk.",
"a.forgotSub": "Kérj visszaállító linket emailben.",
"a.forgotTitle": "Elfelejtett jelszó",
"a.googleContinue": "Folytatás a Google-lal",
"a.googleSignup": "Regisztráció a Google-lal",
"a.haveAccount": "Már partner vagy?",
"a.legalHint": "Szükséges a francia e-számlázáshoz (Factur-X) francia létesítmények esetén.",
"a.legalRequiredFR": "A SIRET és az EU-n belüli ÁFA szám kötelező Franciaországra vonatkozóan.",
"a.loggingIn": "Bejelentkezés…",
"a.login": "Bejelentkezés",
"a.loginSub": "Hozzáférés a kezelőfelülethez.",
"a.loginTitle": "Partner bejelentkezés",
"a.min6": "Minimum 6 karakter",
"a.newPassword": "Új jelszó",
"a.noAccount": "Még nem partner?",
"a.or": "VAGY",
"a.org": "Létesítmény neve",
"a.password": "Jelszó",
"a.passwordMismatch": "A jelszavak nem egyeznek.",
"a.referral": "Ajánlói kód (választható)",
"a.registerSub": "Hozd létre a saját tered 1 perc alatt — ingyenesen kezdhetsz.",
"a.registerTitle": "Légy partner",
"a.rememberMe": "Emlékezz rám",
"a.reset": "Visszaállítás",
"a.resetSub": "Válassz egy új jelszót a fiókodhoz.",
"a.resetTitle": "Új jelszó",
"a.sendLink": "Link küldése",
"a.sending": "Küldés…",
"a.signin": "Bejelentkezés",
"a.siret": "SIRET",
"a.vat": "EU-n belüli ÁFA szám",
"ac.africa": "Afrika",
"ac.boostActive": "Kiugró aktív —",
"ac.boostSub": "Jelenj meg a partneri névjegyzék tetején egy “Fokozott” jelvényel.",
"ac.boostTitle": "Fokozd hirdetésed a névjegyzékben",
"ac.categoryHint": "Hogy a létesítményed a Findloop névjegyzékében legyen besorolva.",
"ac.choose": "Válassz",
"ac.cityHint": "Pontos helymeghatározáshoz a nyilvános térképen.",
"ac.cityLabel": "Létesítmény városa",
"ac.cityPh": "Párizs",
"ac.contact": "Kapcsolattartási adatok",
"ac.converted": "Konvertálva",
"ac.copyDeclLink": "A nyilatkozat link másolása",
"ac.copyLink": "Link másolása",
"ac.currentPlan": "Jelenlegi csomag",
"ac.emailDesc": "Válaszd ki azokat az emaileket, amelyeket meg akarod kapni. Az értesítések mindig aktívak a munkaterületen.",
"ac.emailMatch": "Egyezések",
"ac.emailMatchDesc": "Egy email, amikor egy tétel egyezik egy nyilatkozattal.",
"ac.emailNewDecl": "Új veszteségbejelentések",
"ac.emailNewDeclDesc": "Egy email, amint egy ügyfél bejelent egy veszteséget az Ön helyén",
"ac.emailShip": "Szállítási kérések",
"ac.emailShipDesc": "Egy email, amikor egy ügyfél egy termék szállítását kéri",
"ac.emailTitle": "Email beállítások",
"ac.expireSoon": "A kiemelésed hamarosan lejár —",
"ac.exportCsv": "Exportálás (CSV)",
"ac.exportHint": "Exportáld a validált külső kifizetéseidet a könyvelésedhez.",
"ac.free": "Ingyenes",
"ac.freeMonths": "Ingyenes hónapok",
"ac.hours": "órák",
"ac.howItWorks": "Hogyan működik?",
"ac.invited": "Meghívva",
"ac.legalFR": "Kötelező elektronikus számlázáshoz (Factur-X), érvényes 2026 szeptemberétől.",
"ac.legalMissing": "⚠️ Hiányzik a SIRET és az EU-n belüli ÁFA — egészítsd ki őket, hogy megfelelj az elektronikus számlázásnak.",
"ac.legalOther": "Ajánlott a számláidhoz.",
"ac.legalPartnerQr": "QR kód",
"ac.legalTitle": "Jogi azonosítók (számlázás)",
"ac.logoTitle": "Létesítmény logó",
"ac.modeCurrent": "Jelenlegi mód:",
"ac.modeExternal": "Külső (kézi ellenőrzés)",
"ac.modeInternal": "Belső Findloop (automatikus)",
"ac.noSubReceipt": "Még nincs kifizetett előfizetés.",
"ac.none": "Nincs",
"ac.onYourListing": "az Ön listáján",
"ac.pay1": "Add meg a kifizetési linkjeidet alul, hogy átirányíthasd az ügyfeleidet a saját begyűjtési rendszeredbe.",
"ac.pay2": "Az ellenőrzés kézi módra vált: megerősíted a kifizetés beérkezését a „Bejelentések” fülön.",
"ac.pay3": "A „Szállítási díj” link egy egyesített kifizetés (visszaszerzés + szállítás).",
"ac.pay4": "Hagyd üresen a mezőket, hogy a Findloop belső kifizetését (Stripe) használd automatikus ellenőrzéssel.",
"ac.paySub": "Gyűjtsd be a díjakat a saját kifizetési rendszereden keresztül.",
"ac.payTitle": "Külső kifizetések",
"ac.permissive": "Megengedő",
"ac.phone": "Telefon",
"ac.posterA4": "A4-es poszter (PDF)",
"ac.qMessage": "Üzenet (opcionális)",
"ac.qName": "Név",
"ac.qOrg": "Szervezet",
"ac.qSites": "Létesítmények száma (becslés)",
"ac.qrHint": "Az ügyfeleid ezt a kódot beolvassák, hogy bejelentsenek egy elveszett tárgyat.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "A partnered QR kódja",
"ac.quoteDesc": "Repülőterek, vasúti hálózatok, nemzetközi láncok · ",
"ac.quoteEurope": "Európa / Világ",
"ac.quoteSent": "Árajánlat kérés elküldve. Csapatunk hamarosan visszajelez Önnek.",
"ac.quoteTitle": "Kérj egy árajánlatot — Vállalat",
"ac.recoveryLink": "„Visszaszerzési díj” link",
"ac.refSub": "Minden ajánlott partner, aki előfizet, 1 ingyenes hónapot ad neked.",
"ac.refTitle": "Ajánlj, szerezz egy ingyenes hónapot",
"ac.reminderDelay": "Ellenőrzési emlékeztető késleltetése",
"ac.reminderHint": "Email emlékeztetőt kapsz, ha egy külső kifizetés ezen a késleltetésen túl nem lett validálva (alapértelmezett: 48 óra).",
"ac.renewDesc1": "Már keresett neked",
"ac.renewDesc2": "Újíts, hogy az adatbázis tetején maradj és ne veszítsd el ezt a láthatóságot.",
"ac.renewNow": "Újíts most",
"ac.requestQuote": "Kérj egy árajánlatot",
"ac.saveLegal": "Az azonosítók mentése",
"ac.saveLinks": "A linkek mentése",
"ac.sendRequest": "Küldj egy kérést",
"ac.sending": "Küldés…",
"ac.shippingLink": "„Szállítási díj” link (egyesített)",
"ac.shippingLinkHint": "Ez a link fedezi a visszaszerzést és a szállítást.",
"ac.strict": "Szigorú",
"ac.subReceipt": "Előfizetési nyugta (PDF)",
"ac.subReceiptsSub": "Töltse le az előfizetési fizetés PDF nyugtáját.",
"ac.subReceiptsTitle": "Előfizetési nyugták",
"ac.tCategory": "Kategória mentve",
"ac.tCity": "Város mentve — térkép frissítve",
"ac.tCityNeeded": "Adjon meg egy várost",
"ac.tCopied": "Másolva!",
"ac.tCover": "Borítókép frissítve",
"ac.tEmailPrefs": "Email beállítások frissítve",
"ac.tErr": "Hiba",
"ac.tExportImpossible": "Exportálás sikertelen",
"ac.tLegal": "Jogi azonosítók mentve",
"ac.tLegalNeeded": "SIRET és ÁFA szükséges Franciaországban",
"ac.tLogo": "Logó frissítve",
"ac.tLogoRemoved": "Logó eltávolítva",
"ac.tPayLinks": "Fizetési hivatkozások mentve",
"ac.tPhone": "Telefon mentve",
"ac.tSensitivity": "Érzékenység mentve",
"ac.tVatInvalid": "Érvénytelen ÁFA szám",
"ac.tVatValid": "Érvényes ÁFA",
"ac.tabBoost": "Láthatóság",
"ac.tabPayments": "Fizetések",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Poszter",
"ac.tabReferral": "Ajánlás",
"ac.tabSub": "Előfizetés",
"ac.thisWeek": "Ez a hét",
"ac.thisWeekOf": " ({n} ezen a héten)",
"ac.thresholdDesc": "Bizalmi küszöb, amely felett az MI automatikusan érvényesíti a fényképes egyezést és értesíti az ügyfelet. Magasabb = kevesebb automatikus egyezés, de megbízhatóbb.",
"ac.thresholdTitle": "MI vizuális egyezési érzékenység",
"ac.trend": "Tendencia",
"ac.upload": "Feltöltés",
"ac.vatValidFmt": "Érvényes ÁFÁ{name} ({via})",
"ac.vatVerified": "Belső-EU ÁFA verifikálva",
"ac.verifyVat": "ÁFA ellenőrzése (VIES)",
"ac.verifying": "Ellenőrzés…",
"ac.views": "megtekintések",
"ac.viewsTotal": "Megtekintések száma (összes)",
"ac.winbackBtn": "Folytatás -20%-kal",
"ac.winbackDesc1": "Önnek ez hozott",
"ac.winbackDesc2": "Különleges ajánlat: -20% automatikusan érvényes, ha 24 órán belül megújítja.",
"ac.winbackTitle": "A kiemelt ajánlata éppen most járt le — folytassa -20%-kal!",
"ad.boost": "Növelés",
"ad.close": "Bezárás",
"ad.closeConfirm": "Biztosan bezárja ezt a hirdetést?",
"ad.closed": "Hirdetés lezárva",
"ad.edit": "Szerkesztés",
"ad.editTitle": "Hirdetés szerkesztése",
"ad.saved": "Hirdetés frissítve",
"an.allCountries": "Minden ország",
"an.badge": "Elveszett tárgyak",
"an.boostLater": "Később",
"an.boostNow": "Növelés most",
"an.boostPrompt": "Növelje a hirdetését, hogy a tetejére kerüljön, és gyorsabban megtalálják.",
"an.boosted": "Növelve",
"an.contact": "Ezt a tárgyat találtam",
"an.contactTitle": "Jelentse, hogy ezt a tárgyat találta",
"an.copyFailed": "Nem sikerült másolni a linket",
"an.copyLink": "Link másolása",
"an.country": "Ország",
"an.date": "Elveszett dátum",
"an.finderEmail": "Az Ön email címe",
"an.finderName": "Az Ön neve",
"an.finderPhone": "Az Ön telefonszáma",
"an.geoBanner": "Az alábbi hirdetéseket nézi",
"an.geoBannerWorld": "Az alábbi hirdetéseket nézi világszerte",
"an.geoChange": "ország megváltoztatása",
"an.goAccount": "Menj a fiókomba",
"an.linkCopied": "Link másolva!",
"an.loginRequired": "Jelentkezzen be, hogy bejelentse ezt a tárgyat és kövesse a visszaállítást.",
"an.loginToBoost": "Jelentkezzen be a hirdetés népszerűsítéséhez",
"an.lostAt": "Elveszett itt",
"an.message": "Üzenet (opcionális)",
"an.none": "Még nincs hirdetés.",
"an.photo": "Fotó (opcionális)",
"an.post": "Hirdetés közzététele",
"an.postSubtitle": "Írja le elveszett tárgyát — a közösség és partnereink segítenek megtalálni.",
"an.postTitle": "Bejelentés elveszett tárgyról",
"an.publish": "Hirdetés közzététele",
"an.published": "Hirdetés közzétéve!",
"an.publishing": "Közzététel…",
"an.remaining": "maradt",
"an.requestInProgress": "Kérelem folyamatban",
"an.resolved": "Tárgy már visszakerült",
"an.reward": "Jutalom",
"an.searchPh": "Hirdetés keresése...",
"an.send": "Küldés",
"an.sent": "Üzenet elküldve a tulajdonosnak!",
"an.shareConsent": "Elfogadom, hogy az én elérhetőségeimet (név, email, telefon) megossza a tárgy tulajdonosával.",
"an.shareConsentError": "Kérjük, jelölje be a mezőt az elérhetőségek megosztásához.",
"an.sortRecent": "Legújabb",
"an.sortRelevance": "Relevancia",
"an.subtitle": "Böngésszen a közösség által bejelentett elveszett tárgyak között. Talált egyet közülük?",
"an.title": "Elveszett tárgyak hirdetései",
"anf.badge": "Talált tárgyak",
"anf.claim": "Ez az enyém",
"anf.claimSent": "Üzenet elküldve a megtalálónak!",
"anf.claimTitle": "Jelentse be, hogy ez az Ön tárgya",
"anf.consent": "Elfogadom, hogy a tulajdonos láthatja az elérhetőségeimet, hogy visszakapja a tárgyát.",
"anf.foundAt": "Találva itt",
"anf.foundDate": "Találás dátuma",
"anf.loginCta": "Jelentkezzen be / hozzon létre egy fiókot",
"anf.loginDesc": "A hirdetés közzétételéhez és Finder Hero pontok gyűjtéséhez szükséges egy megtaláló fiók.",
"anf.loginRequired": "Jelentkezzen be, hogy bejegyezzen egy talált tárgyat",
"anf.photo": "Tárgy fényképe",
"anf.pointsEarned": "Köszönjük! Most szerezte meg a Finder Hero pontokat.",
"anf.pointsPending": "A pontjai 24 órán belül jóváírásra kerülnek, a hitelesítést követően.",
"anf.post": "Hirdessen egy talált tárgyat",
"anf.postSubtitle": "Írja le a megtalált tárgyat — segítse a tulajdonost, hogy visszakapja.",
"anf.postTitle": "Bejelentés talált tárgyról",
"anf.publishFound": "Talált hirdetés közzététele",
"anf.published": "Talált tárgy hirdetése közzétéve",
"anf.publishedAs": "Közzétéve mint",
"anf.shareConsent": "Elfogadom, hogy az én elérhetőségeimet (név, email, telefon) megossza a találóval.",
"anf.subtitle": "Böngésszen a közösség által talált és bejelentett tárgyak között. Megismeri a sajátját?",
"anf.title": "Talált tárgyak hirdetései",
"bo.active": "Népszerűsítés aktív",
"bo.africaPrice": "Afrika-zónás kedvező ár alkalmazva",
"bo.pay": "Fizessen és népszerűsítsen",
"bo.remaining": "Hátralévő idő",
"bo.renew": "Boost megújítása",
"bo.since": "óta boost",
"bo.subtitle": "Tedd a hirdetésedet a lista tetejére egy látható jelvénnyel.",
"bo.title": "Hirdetés boostolása",
"c.all": "Összes",
"c.cancel": "Mégse",
"c.close": "Bezárás",
"c.confirm": "Megerősítés",
"c.confirmed": "Megerősítve",
"c.download": "Letöltés",
"c.loading": "Betöltés…",
"c.reset": "Visszaállítás",
"c.reviews": "értékelés",
"c.save": "Mentés",
"c.transfer": "Átutalás",
"cat.Animal": "Kedvenc / Kedvenc kiegészítő",
"cat.AppareilPhoto": "Fényképezőgép",
"cat.Argent": "Pénz / Készpénz",
"cat.Autres": "Egyéb",
"cat.Bijoux": "Ékszer",
"cat.CarteBancaire": "Bankkártya",
"cat.CarteIdentite": "Személyi igazolvány / Útlevél",
"cat.Casquette": "Sapka",
"cat.Ceinture": "Öv",
"cat.Chargeur": "Töltő / Kábel",
"cat.Chaussures": "Cipők",
"cat.CleVoiture": "Autókulcs",
"cat.Cles": "Kulcsok",
"cat.Console": "Játék konzol",
"cat.Documents": "Dokumentumok / Papírok",
"cat.Echarpe": "Sál",
"cat.Ecouteurs": "Fülhallgató",
"cat.Electronique": "Elektronikai eszközök (egyéb)",
"cat.Enceinte": "Hangszóró",
"cat.Gants": "Kesztyű",
"cat.Gourde": "Vízpalack / Flask",
"cat.Instrument": "Zenei hangszer",
"cat.Jouet": "Játék / Plüss",
"cat.Jumelles": "Távcső",
"cat.Lampe": "Lámpa / Zseblámpa",
"cat.Liseuse": "E-könyv olvasó",
"cat.Livre": "Könyv / Füzet",
"cat.Lunettes": "Szemüveg",
"cat.Manteau": "Kabát",
"cat.Maquillage": "Smink táska",
"cat.Medical": "Orvosi berendezés",
"cat.Medicaments": "Gyógyszer",
"cat.Montre": "Óra / Okosóra",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Esernyő",
"cat.Portefeuille": "Pénztárca / Táska",
"cat.Poussette": "Babakocsi / Baba kiegészítő",
"cat.Sac": "Táska / Kézitáska",
"cat.SacADos": "Hátizsák",
"cat.Souris": "Egér / Billentyűzet",
"cat.Sport": "Sportfelszerelés",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefon / Okostelefon",
"cat.Trottinette": "Roller",
"cat.Trousse": "Tok / Táska",
"cat.USB": "USB pendrive / Merevlemez",
"cat.Valise": "Bőrönd / Csomag",
"cat.Velo": "Bicikli",
"cat.Vetements": "Ruházat",
"cat.placeholder": "Válassz egy kategóriát",
"cd.d": "n",
"cd.expired": "Lejárt",
"cd.h": "ó",
"cd.m": "p",
"ck.accept": "Elfogad",
"ck.acceptAll": "Mindet elfogad",
"ck.customize": "Testreszabás",
"ck.learn": "Tudd meg többet",
"ck.manage": "Sütik kezelése",
"ck.measurement": "Közönségmérés",
"ck.measurementDesc": "Névtelen statisztikák a szolgáltatás javításához.",
"ck.msg": "Sütiket használunk az oldal működtetésére és a közönség mérésére.",
"ck.necessary": "Szükséges",
"ck.necessaryDesc": "Fontos az oldal működéséhez. Mindig engedélyezve van.",
"ck.refuse": "Elutasít",
"ck.save": "Mentem a választásaim",
"ck.saved": "Beállítások mentve",
"ck.title": "A sütik preferenciái",
"cm.found": "MEGTALÁLT",
"cm.lost": "ELVESZTETT",
"cmp.adv": "Haladó",
"cmp.ai": "AI párosítás",
"cmp.autobill": "Automatikus számlázás",
"cmp.basic": "Alap",
"cmp.community": "Közösség",
"cmp.consol": "Konzolidált számlázás",
"cmp.custom": "Egyedi",
"cmp.dedicated": "Dedikált",
"cmp.deploy": "Dedikált telepítés & SLA",
"cmp.estIncl": "Bevonva levő intézmények",
"cmp.estSec": "További intézmény",
"cmp.items": "Tételek / hónap",
"cmp.main": "1 fő",
"cmp.max20": "Maximum 20",
"cmp.members": "Tagmeghívók",
"cmp.onQuote": "Egyedi ajánlat",
"cmp.priority": "Prioritás",
"cmp.starterEst": "1 bevont + korlátlan extra",
"cmp.stats": "Statisztikák",
"cmp.statsAdv": "Haladó",
"cmp.statsBasic": "Alap",
"cmp.support": "Támogatás",
"cmp.unlimited": "Korlátlan",
"cmp.upTo3": "Legfeljebb 3",
"consent.required": "El kell fogadnod a kapcsolattartási adataid megosztását a folytatáshoz.",
"consent.share": "Hozzájárulok ahhoz, hogy a tárgyam megtalálója láthassa a kapcsolattartási adataimat (név, e-mail, telefon) a visszaszerzés érdekében.",
"cover.add": "Hozzáadás",
"cover.change": "Módosítás",
"cover.helper": "Bannerként jelenik meg a jelentésed oldalán és a könyvtárban.",
"cover.none": "Nincs borítókép",
"cover.remove": "Eltávolítás",
"cover.title": "Borítókép",
"crop.desc": "Állítsd be a keret arányát (3:1). Húzd és nagyítsd.",
"crop.saving": "Mentés…",
"crop.title": "Vágja le a borítóképet",
"cta.button": "Hozza létre a partner fiókját",
"cta.subtitle": "Csatlakozzon az intézményekhez, amelyek gyorsabban kezelik az elveszett tételeket a findloop-nál.",
"cta.title": "Készen áll az elveszett tételek csökkentésére?",
"db.account.s": "Kezelje az intézményét, előfizetését és QR kódját.",
"db.account.t": "Fiókom",
"db.declarations.s": "Azok az ügyfelek, akik elveszett tárgyat jelentettek a QR kódja segítségével.",
"db.declarations.t": "Elveszett jelentések",
"db.deposit.s": "Adjon hozzá egy fényképet, egy kategóriát és egy leírást.",
"db.deposit.t": "Elfogott tárgy bejegyzése",
"db.registry.s": "Minden megtalált tárgy, amit az intézményében bejegyeztek.",
"db.registry.t": "Tárgynyilvántartás",
"db.reviews.s": "Válaszoljon nyilvánosan az ügyfelei véleményeire.",
"db.reviews.t": "Ügyfél vélemények",
"db.shipments.s": "Címkék generálása és csomagok nyomon követése a küldéshez.",
"db.shipments.t": "Küldemények",
"db.stats.s": "A legfontosabb teljesítménymutatói.",
"db.stats.t": "Statisztikák",
"db.team.s": "Hívja meg kollégáit a tárgyak kezelésére.",
"db.team.t": "Csapat",
"dc.partnerDesc": "Elvesztette a tárgyát egy partnerhelyszínen (hotel, állomás, csarnok...)? Válassza ki a közvetlen visszatéréshez.",
"dc.partnerList": "Válasszon a listából",
"dc.partnerMap": "Válasszon a térképen",
"dc.partnerTitle": "Nyilatkozat egy partnernél",
"dc.publicCta": "Hozzon létre egy nyilvános hirdetést",
"dc.publicDesc": "A hirdetése látható lesz a teljes Findloop közösség számára. Ideális, ha nem tudja, hol vesztette el a tárgyat.",
"dc.publicTitle": "Nyilvános nyilatkozat",
"dc.subtitle": "Válassza ki, hogyan szeretné bejelenteni elveszett tárgyát.",
"dc.title": "Mit szeretne tenni?",
"dec.addrPending": "Cím várakozik az ügyféltől",
"dec.analyzing": "Elemzés…",
"dec.badge": "Elveszett jelentés",
"dec.category": "Tárgy kategória",
"dec.clientDescription": "Ügyfél leírása",
"dec.clientPhoto": "Az ügyfél által megadott fénykép",
"dec.clientPhotoShort": "Ügyfél fényképe",
"dec.comparePhotos": "Fényképek összehasonlítása",
"dec.contactTitle": "Kapcsolattartási adatai",
"dec.date": "Elvesztés dátuma",
"dec.declaredItemPhoto": "A bejelentett tárgy fényképe",
"dec.descPh": "Jellemezze a tárgyat: márka, szín, megkülönböztető jegyek…",
"dec.description": "Leírás",
"dec.email": "Email",
"dec.emptyDesc": "Ossza meg a QR kódját a bejelentések fogadásához.",
"dec.emptyTitle": "Nincs bejelentés",
"dec.enlarge": "Népszerűsít",
"dec.extBanner": "{n} külső kifizetés érvényesítése szükséges — a kézbesítés vagy szállítás feloldásához erősítse meg az átvételt lent.",
"dec.foundItemAlt": "Megtalált tárgy",
"dec.foundItemRegistry": "Megtalált tárgy (nyilvántartás)",
"dec.home": "Vissza a főoldalra",
"dec.labelClient": "Ügyfél",
"dec.labelRegistry": "Nyilvántartás",
"dec.matchFound": "Már azonosítottak egy egyezést!",
"dec.name": "Teljes név",
"dec.noMatchYet": "Még nincs egyezés.",
"dec.noPhoto": "Nincs fénykép",
"dec.notfound": "Partner nem található.",
"dec.pRecup": "visszaszerzés",
"dec.pRecupP": "(visszaszerzés)",
"dec.pRecupShip": "(visszaszerzés + szállítás)",
"dec.payConfirmed": "A(z) {x} kifizetés megerősítve",
"dec.payPending": "Külső kifizetés {x} folyamatban",
"dec.phone": "Telefon",
"dec.pickup": "Személyes átvétel",
"dec.place": "A veszteség helye",
"dec.placePh": "pl. a bárban, 204-es szoba…",
"dec.recoverBtn": "Tárgyam visszaszerzése",
"dec.reject": "Elutasít",
"dec.rerun": "Az elemzés újraindítása",
"dec.similarity": "{n}% hasonlóság",
"dec.submit": "Jelentésem benyújtása",
"dec.submitting": "Küldés…",
"dec.successText": "Tárgyadat keresünk a következők között:",
"dec.successTitle": "Jelentés benyújtva!",
"dec.suggestedMatches": "Javasolt egyezések",
"dec.toColon": " nek:",
"dec.toShip": "Küldéshez",
"dec.toastExtPay": "Kifizetés megerősítve — az ügyfelet értesítjük.",
"dec.toastMatch": "Egyezés megerősítve",
"dec.toastReject": "Javaslat elutasítva",
"dec.toastRerun": "Elemzés újraindítva",
"dec.toastVisualN": "{n} vizuális egyezés",
"dec.toastVisualNone": "Nincs vizuális egyezés",
"dec.trackBtn": "Jelentésem nyomon követése",
"dec.viewBeforeAfter": "Előtte/utána nézet (felülnézet)",
"dec.viewSideBySide": "Egymás melletti nézet",
"dec.visualCompare": "AI vizuális összehasonlítás",
"dec.visualIdle": "Futtassa az összehasonlítást, hogy az AI vizuálisan összehasonlítsa az ügyfél fényképét a talált tárgyakkal.",
"dec.visualRunning": "Az AI összehasonlítja az ügyfél fényképét a nyilvántartásban lévő tárgyakkal…",
"dec.zoomPhoto": "Fotó nagyítása",
"dep.addAnyway": "Hozzáadás mindenképpen",
"dep.addError": "Hiba a hozzáadás során",
"dep.addItem": "Tárgy hozzáadása",
"dep.added": "Tárgy hozzáadva a nyilvántartáshoz!",
"dep.adding": "Hozzáadás…",
"dep.aiError": "AI elemzés jelenleg nem elérhető.",
"dep.aiFilled": "Űrlap előtöltve AI által ✨",
"dep.aiUnavailable": "AI nem elérhető — töltse ki az űrlapot manuálisan.",
"dep.analyzing": "Elemzés…",
"dep.analyzingPhoto": "Fénykép elemzése…",
"dep.brand": "Márka",
"dep.brandPlaceholder": "pl. Apple",
"dep.category": "Kategória",
"dep.checkingDup": "Duplikátumok ellenőrzése…",
"dep.color": "Szín",
"dep.colorPlaceholder": "pl. fekete",
"dep.condition": "Állapot",
"dep.conditionPlaceholder": "pl. jó állapot",
"dep.depositorNote": "Letétkezelő megjegyzés",
"dep.depositorNoteHint": "Kézzel beírt működési részletek. Az AI soha nem írja felül ezt a megjegyzést.",
"dep.depositorNotePlaceholder": "pl. egy tasak tartalma, jelentett márka, a személy által megadott részletek…",
"dep.descPlaceholder": "pl. fekete iPhone 15 átlátszó tokban, a bárban talált…",
"dep.description": "Leírás",
"dep.dupHint": "Győződjön meg róla, hogy nem ad hozzá duplikátumot. Folytathatja, ha a tárgy valóban eltérő.",
"dep.dupTitle": "Hasonló tárgy(ak) már regisztrálva",
"dep.dupWarn": "Hasonló tárgy észlelve — ellenőrizze, majd kattintson újra a megerősítéshez.",
"dep.estHint": "A tárgy hozzáadva lesz ennek az intézménynek a nyilvántartásához.",
"dep.establishment": "Intézmény",
"dep.fee": "Visszaszerzési díj (€) — választható",
"dep.feePlaceholder": "Hagyja üresen az alapértelmezett árhoz",
"dep.fillAI": "Töltsd ki AI-val",
"dep.optional": "(választható)",
"dep.photo": "Tétel fényképe",
"dep.principal": "elsődleges",
"dep.reqError": "Kategória és leírás szükséges.",
"dep.savedItem": "Regisztrált tétel",
"dep.similarity": "Hasonlóság",
"dep.storage": "Fizikai helyszín",
"dep.storageHint": "Ahol a tétel fizikailag tárolva van. QR kódot generálunk a megtalálásához.",
"dep.storagePlaceholder": "pl. A3 polc, 12-es szekrény, Recepciói széf",
"dl.aClient": "egy ügyfél",
"dl.alertsBlocked": "Böngésző értesítések letiltva",
"dl.alertsBlockedHint": "A visszaengedéshez: kattints a 🔒 (vagy ⓘ) ikonra az oldal címétől balra, majd engedélyezd az értesítéseket és töltsd újra az oldalt.",
"dl.amountDue": "Esedékes összeg: {amount} {currency}.",
"dl.enableAlerts": "Értesítések engedélyezése",
"dl.extPending": "Fizetések érvényesítésre várnak",
"dl.freemiumNear": "Közel jársz a Freemium határhoz ({used}/{max} tétel ebben a hónapban). Frissíts a Starterre a korlátlan tételekért.",
"dl.freemiumReached": "Freemium határ elérve ({used}/{max} tétel ebben a hónapban). Frissíts a Starterre a korlátlan tételek regisztrálásához.",
"dl.invoiceOverdue": "{num} számú számla nem állt rendezve — a hozzáférés korlátozott.",
"dl.matchNotifTitle": "Findloop — Új AI egyezés 🔔",
"dl.matchToast": "Új AI egyezés — {name}",
"dl.matchToastDesc": "Egy tétel egyezik a nyilatkozattal.",
"dl.notifEmpty": "Még nincs értesítés.",
"dl.notifEnabled": "Böngésző értesítések engedélyezve",
"dl.notifTitle": "Értesítések",
"dl.payInvoice": "Számlám kifizetése →",
"dl.rewardsPending": "Beváltásra váró kuponok",
"dl.upgradeStarter": "Frissítés Starterre →",
"est.all": "Minden létesítmény ({n})",
"est.label": "Létesítmény",
"est.primary": "elsődleges",
"est.secondary": "másodlagos",
"est2.add": "Létesítmény hozzáadása",
"est2.addressLabel": "Cím",
"est2.addressPh": "12 République utca",
"est2.autoInvoice": "Részletes számla automatikusan generálódik minden hónap 1-én.",
"est2.baseSub": "Alapszolgáltatás",
"est2.billing": "Számlázás",
"est2.boostActivated": "Növelés aktiválva: {name}",
"est2.boostBillingNote": "A jelenlegi díjtétel szerint számlázva és a havi összevont számládra csoportosítva.",
"est2.boostCta": "Növelés",
"est2.boostDesc": "Javítsd ez a létesítmény láthatóságát a jegyzékben és a térképen.",
"est2.boostDuration": "{h} óra fokozott láthatóság",
"est2.boostExtend": "Hosszabbítás",
"est2.boostTitle": "Növelés: {name}",
"est2.boosted": "Növelt",
"est2.chartDesc": "A visszaküldött tételek aránya a regisztrált összeshez képest, helyszínenként.",
"est2.chartTitle": "Visszaküldési arány létesítmény szerint",
"est2.chartTooltip": "Visszaküldés",
"est2.cityLabel": "Város",
"est2.cityPh": "Lyon",
"est2.contactHint": "Ezek az adatok láthatók az ügyfél számára ehhez a létesítményhez (üres esetén visszaesik a fiókra).",
"est2.countryLabel": "Ország",
"est2.coverLabel": "Borítókép",
"est2.create": "Létrehozás",
"est2.created": "Létesítmény létrehozva",
"est2.delete": "Törlés",
"est2.deleteDesc": "Ez a művelet végleges. Csak akkor törölhetsz egy létesítményt, ha az nem tartalmaz tételeket.",
"est2.deleteTitle": "Törlés „{name}”?",
"est2.deleted": "Létesítmény törölve",
"est2.dialogDesc": "Írd be ennek az oldalnak a nevét és címét.",
"est2.edit": "Szerkesztés",
"est2.editEst": "Létesítmény szerkesztése",
"est2.emailLabel": "Kapcsolattartó email",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " létesítmény(e)",
"est2.extraNoteBase": "{n} további létesítmény(e) számlázva",
"est2.extraPrice": " {price} €/hó áron.",
"est2.extraQuote": " árajánlat alapján.",
"est2.imgChange": "Válassz egy képet",
"est2.imgDone": "Kész",
"est2.imgRemove": "Eltávolítás",
"est2.imgRemoved": "Kép eltávolítva",
"est2.imgSaved": "Kép mentve",
"est2.imgUploading": "Feltöltés…",
"est2.includedPlan": "A te tervedben szerepel: {n}.",
"est2.kDeclarations": "Nyilatkozatok",
"est2.kInStorage": "Raktáron",
"est2.kItemsTotal": "Tételek (összesen)",
"est2.kRestituted": "Visszaadva",
"est2.limitReached": "Elérte a határt",
"est2.logoLabel": "Logó",
"est2.mDeclar": "Nyil.",
"est2.mItems": "Tételek",
"est2.mRestituted": "Visszaadva",
"est2.mStorage": "Raktáron",
"est2.monthlyTotal": "Havi összeg",
"est2.nameLabel": "Név *",
"est2.namePh": "pl. Belmont Hotel — Lyon Annex",
"est2.newEst": "Új létesítmény",
"est2.onQuote": "Árajánlat alapján",
"est2.phoneLabel": "Telefon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Terv",
"est2.planLimited": "A „{tier}” terved maximum {max} létesítményre korlátozódik.",
"est2.primary": "Elsődleges",
"est2.qr": "QR kód",
"est2.qrDesc": "Mutasd be ezt a QR kódot ebben a létesítményben. Az elveszett megrendeléseket bejelentő ügyfelek ehhez az oldalhoz kapcsolódnak.",
"est2.qrTitle": "QR kód — {name}",
"est2.saving": "Mentés…",
"est2.seeInvoices": "Nézd meg a havi számláim",
"est2.seePlans": "Tervek megtekintése",
"est2.subtitle": "Minden helyedet egy fiók alatt kezeld — összevont nézet, tételek, QR kód és számlázás.",
"est2.suspended": "Felfüggesztve",
"est2.tierFree": "1 létesítmény",
"est2.tierLarge": "korlátlan létesítmények",
"est2.tierMedium": "5 létesítmény benne",
"est2.tierSmall": "3 létesítmény benne",
"est2.title": "Létesítmények",
"est2.unlimitedPlan": "A terved lehetővé teszi a létesítmények korlátlan számát.",
"est2.unlimitedSuffix": " · korlátlan",
"est2.updated": "Létesítmény frissítve",
"est2.upgradeHint": "Frissíts egy magasabb tervre, hogy több helyet adhass hozzá és központosíthasd az összes tevékenységedet.",
"est2.visuals": "Logó és kép",
"est2.visualsDesc": "Testreszabhatod ennek a létesítménynek a logóját és borítóképét. Ezek az ő nyilvános oldalán és nyilatkozati űrlapján jelennek meg.",
"est2.visualsTitle": "Vizualizációk — {name}",
"est2.workOn": "Dolgozz ezen a létesítményen",
"est2.working": "A „{name}” helyen dolgozol",
"ev.created": "Jelentés létrehozva",
"ev.matched": "Megfelelő tétel azonosítva",
"ev.paid": "Feltöltési díj kifizetve",
"ev.pickup": "Helyszíni átvétel",
"ev.shipped": "Csomag elküldve",
"ev.shipping_paid": "Szállítási díj kifizetve",
"ev.shipping_requested": "Szállítási kérés leadva",
"feat1.d": "KPI-k, visszaadási arány kategóriánként, bevétel és 30 napos trendek.",
"feat1.t": "Irányítópult & analytics",
"feat2.d": "Címkék, szállító nyomon követés és automatikus nyomon követési e-mailek.",
"feat2.t": "Szállítási modul",
"feat3.d": "Az ügyfelek a város és a kategória alapján találnak rád, hitelesített véleményekkel.",
"feat3.t": "Nyilvános könyvtár & vélemények",
"fp.backToRanking": "Vissza a ranglistához",
"fp.badge": "Jelvény",
"fp.hero": "Finder Hős",
"fp.notFound": "Profil nem található vagy privát.",
"fp.scoreTotal": "Összes pont",
"fp.scoreYear": "Pontok itt",
"fp.share": "Oszd meg ezt a profilt",
"fp.shareText": "Nézd meg {name} finder profilját a findo-n!",
"fp.tagline": "Egy őszinte finder, aki jobbá teszi a világot.",
"ft.backAccount": "Vissza a Fiókomhoz",
"ft.closeBtn": "Az eset lezárása",
"ft.closeConfirm": "Megerősíted, hogy az árut visszaküldték? A hirdetés le lesz zárva.",
"ft.closeLockedHint": "Először érvényesítsd a tulajdonos kódját a lezárás feloldásához.",
"ft.closed": "Eset lezárva — árucikk visszaküldve!",
"ft.codeLabel": "Írd be a tulajdonostól kapott érvényesítő kódot",
"ft.codeNeeded": "Kérlek, írd be az érvényesítő kódot.",
"ft.codeOk": "Kód érvényesítve — lezárhatod az esetet.",
"ft.codePlaceholder": "pl. 4821",
"ft.codeVerified": "Érvényesítve",
"ft.doneMsg": "A termék visszakerült. Köszönjük, hogy segítettél visszajuttatni a tulajdonoshoz!",
"ft.stepInProgress": "Visszaküldés folyamatban",
"ft.stepPublished": "Hirdetés közzétéve",
"ft.stepReturned": "Áru visszaküldve",
"ft.subtitle": "Kövesd a lépéseket, amíg a megtalált termék vissza nem kerül.",
"ft.title": "Visszakövetés",
"ft.verifyBtn": "Kód érvényesítése",
"hero.badge": "Kiemelt",
"hero.ctaFound": "Találtam egy tárgyat",
"hero.ctaLost": "Elvesztettem egy tárgyat",
"hero.ctaPartner": "Lépj partnerünkké",
"hero.subtitle": "A Findloop segít az intézményeknek kezelni a megtalált tárgyakat — és lehetővé teszi ügyfeleik számára, hogy bejelentsenek egy elvesztést, majd visszakapják a dolgaikat, a helyszínen vagy szállítással.",
"hero.title": "Minden elveszett tárgy megtalálja a tulajdonosát.",
"home.champBecome": "Legyél finder",
"home.champCta": "Nézd meg a ranglistát",
"home.champSubtitle": "Minden visszatérített tárgy pontokat ér. Csatlakozz a ranglistához és nyerj jutalmakat.",
"home.champTitle": "Legjobb findereink",
"how.eyebrow": "Hogyan működik",
"how.title": "A leadástól a visszatérésig, könnyedén.",
"inv.all": "Összes",
"inv.allYears": "Minden év",
"inv.count": "Számlák",
"inv.due": "esedékes",
"inv.empty": "Még nincsenek számlák.",
"inv.exportCsv": "CSV exportálása",
"inv.invoicePdf": "Számla PDF",
"inv.issued": "Kibocsátva",
"inv.noMatch": "Nincs számla ehhez a szűrőhöz.",
"inv.paid": "Kifizetve (€)",
"inv.paidOn": "kifizetve itt",
"inv.pay": "Fizetés",
"inv.receipt": "Nyugta",
"inv.reminders": "Emlékeztetők",
"inv.remindersDesc": "E-mailes és SMS emlékeztetők küldése ennek a számlának.",
"inv.remindersEmpty": "Nincs küldött emlékeztető.",
"inv.rmDue": "Esedékességi emlékeztető",
"inv.rmManual": "Kézi emlékeztető",
"inv.rmSms": "SMS emlékeztető D+30",
"inv.rmStage": "Emlékeztető",
"inv.statusPaid": "Kifizetve",
"inv.statusUnpaid": "Nem kifizetve",
"inv.subtitle": "Tekintse meg és töltse le a számláit és nyugtáit.",
"inv.title": "Saját számláim",
"inv.unpaid": "Nem kifizetve (€)",
"inv2.contractTitle": "Saját Findloop szerződésem",
"inv2.detailByEst": "Részletek az intézmény szerint",
"inv2.dueLabel": "Esedékes:",
"inv2.dueSuffix": " · esedékes {date}",
"inv2.error": "Hiba {status}",
"inv2.estCountIssued": "{n} intézmény(ek) · kiadva {date}",
"inv2.estimate": "Árajánlat (nem terhelt) · {n} intézmény(ek)",
"inv2.expired": " · lejárt",
"inv2.exportCsv": "CSV exportálása",
"inv2.exportDone": "CSV export letöltve",
"inv2.included": "Tartalmazza",
"inv2.monthlyTitle": "Havi számlázás (előfizetés)",
"inv2.months": "+{n} hónap",
"inv2.paid": "Kifizetve",
"inv2.pay": "Fizetés",
"inv2.previewTitle": "A következő számla előnézete —",
"inv2.renew": "Szerződésem megújítása",
"inv2.renewalsTitle": "Megújítási múlt ({n})",
"inv2.renewedUntil": "Szerződés megújítva {date} -ig",
"inv2.serviceTitle": "Szolgáltatási számlák (visszatérítések & ajánlatok)",
"inv2.soon": "Hamarosan lejár",
"inv2.toPay": "Fizetendő",
"inv2.totalHtTva": "Összesen adó nélkül · ÁFA",
"inv2.totalTtc": "Összesen adóval",
"iu.addPhoto": "Kép hozzáadása",
"iu.change": "Változtatás",
"lang.label": "Nyelv",
"lb.allCountries": "Összes ország",
"lb.badge": "Éves ranglista",
"lb.champion": "🏆 Az év bajnoka",
"lb.cityPh": "Szűrés város szerint…",
"lb.empty": "Nincs rangsor ezeknél a szűrőknél.",
"lb.pts": "pont",
"lb.resetNote": "Aktuális évi ranglista — minden év január 1-jén újraindul.",
"lb.returned": "visszaadott",
"lb.share": "Ranglista megosztása",
"lb.shareText": "Nézd meg a legjobb finders ranglistát a findo-n!",
"lb.subtitle": "Minden visszaadás pontokat ér. A ranglista minden év január 1-jén újraindul.",
"lb.tabFinders": "Finderek",
"lb.tabPartners": "Intézmények",
"lb.title": "Legjobb finderek",
"lost.b2bDesc": "Elvesztetted egy hotelben, közlekedési csomópontban vagy partnerhelyszínen? Találd meg az intézményt és jelentsd a veszteséged.",
"lost.b2bTitle": "Jelentsd a partnernek",
"lost.b2cDesc": "Tegyen közzé egy hirdetést, amely mindenki számára látható, ajánljon jutalmat és hirdesse a szöveget, hogy maximalizálja esélyeit.",
"lost.b2cTitle": "Tegyen közzé egy nyilvános hirdetést",
"lost.desc": "Válassza ki, hogyan szeretné folytatni.",
"lost.title": "Elveszett egy tárgy?",
"map.allCategories": "Minden kategória",
"map.clear": "Visszaállítás",
"map.exitFullscreen": "Kilépés",
"map.filterCity": "Város vagy ország…",
"map.fullscreen": "Teljes képernyő",
"map.heatmap": "Hőtérkép",
"map.high": "Magas",
"map.impactMonth": "tárgyak visszatérítve ezen a hónapon",
"map.impactTotal": "visszatérítve összesen",
"map.legend": "Színes pontok piros (alacsony) és zöld (magas) között a visszaadási arány alapján; méret a tárgyak számától függően.",
"map.locating": "Helymeghatározás… adj meg egy címet az üzleteidhez, hogy láthasd őket a térképen.",
"map.low": "Alacsony",
"map.mAll": "Minden",
"map.mFound": "Megtalálva",
"map.mLost": "Elveszett",
"map.medium": "Közepes",
"map.noItemRegistered": "Nincs regisztrált tárgy",
"map.noItems": "Nincs tárgy",
"map.period30": "Utolsó 30 nap",
"map.period7": "Utolsó 7 nap",
"map.period90": "Utolsó 90 nap",
"map.periodAll": "Minden idő",
"map.returnedSuffix": "visszatérítve · {a}/{t} tárgy",
"map.stats": "Városi statisztikák",
"map.statsTop": "Top 5 hely (elveszett tárgyak)",
"map.statsTrend": "6 hónapos trend",
"map.title": "Az üzleteid térképe",
"map.topPlaces": "Népszerű helyek",
"mc.adClosed": "Hirdetés lezárva",
"mc.addPhoto": "Fénykép hozzáadása",
"mc.adsNone": "Nincs elveszett tárgy hirdetés.",
"mc.archiveHide": "Történelem elrejtése",
"mc.archiveNone": "Még nincs megoldott eset.",
"mc.archiveShow": "Történelem megjelenítése",
"mc.archiveSub": "Megoldott és visszatért esetek.",
"mc.archiveTitle": "Történelem",
"mc.at": "Itt",
"mc.backToLogin": "Vissza a bejelentkezéshez",
"mc.boostContacts": "Kapcsolatok (növelés)",
"mc.boostViews": "Megtekintések (növelés)",
"mc.cancel": "Mégse",
"mc.certificate": "Tanúsítvány",
"mc.changePhoto": "Fénykép cseréje",
"mc.city": "Város",
"mc.closeAd": "Bezárás",
"mc.closeAdConfirm": "Biztosan bezárod ezt a hirdetést? Már nem lesz látható és felszabadít egy helyet.",
"mc.confirmPassword": "Jelszó megerősítése",
"mc.confirmRestitution": "Visszatérés megerősítése",
"mc.connect": "Csatlakozás",
"mc.contacts": "Kapcsolatok",
"mc.country": "Ország",
"mc.declareFound": "Bejelentés egy megtalált tárgyról",
"mc.declareFoundSub": "Tedd közzé a megtalált tárgyad",
"mc.declareLost": "Bejelentés egy elveszett tárgyról",
"mc.declareLostSub": "Tedd közzé az elveszett tárgy hirdetését",
"mc.deleteAccount": "Fiók törlése",
"mc.deleteConfirm": "Igen, töröld a fiókom",
"mc.deleteConfirmBody": "A fiókod véglegesen törlésre kerül, és a személyes adataid anonimizálva lesznek. Ez a művelet nem vonható vissza.",
"mc.deleteConfirmTitle": "Biztosan törlöd a fiókodat?",
"mc.deleteDesc": "A fiókod véglegesen törlésre kerül, és a személyes adataid anonimizálódnak. Ez a művelet nem vonható vissza.",
"mc.deleted": "A fiókod törlésre került.",
"mc.deleting": "Törlés…",
"mc.email": "Email",
"mc.expiresOn": "Lejárat",
"mc.exportData": "Adataim letöltése (GDPR)",
"mc.exportDone": "Az adataid le lettek töltve.",
"mc.exporting": "Előkészítés…",
"mc.finderAccepted": "Elfogadva",
"mc.finderProfile": "Finder profil (opcionális)",
"mc.finderProfileDesc": "Pontokat kereshetsz visszaadott tárgyakkal, és megjelenhetsz a nyilvános ranglistán.",
"mc.forYourAd": "A hirdetésedhez",
"mc.forgotLink": "Elfelejtett jelszó?",
"mc.forgotSend": "A hivatkozás küldése",
"mc.forgotSent": "Ha létezik fiók ehhez az emailhez, egy reset hivatkozás éppen most lett elküldve.",
"mc.forgotTitle": "Elfelejtett jelszó",
"mc.foundAdsNone": "Nincs közzétéve talált tárgy hirdetés.",
"mc.foundAt": "Találva itt:",
"mc.foundNone": "Nincs bejelentett talált tárgy.",
"mc.hAd": "Elveszett hirdetés",
"mc.hDeclaration": "Nyilatkozat",
"mc.hFinderContact": "Bejelentett tárgy",
"mc.hFound": "Visszaadott tárgy",
"mc.hFoundAd": "Talált hirdetés",
"mc.histEarned": "Tárgy visszaadva",
"mc.historyTitle": "Pontjaim története",
"mc.loginBtn": "Bejelentkezés",
"mc.loginTitle": "Vásárlói bejelentkezés",
"mc.logout": "Kijelentkezés",
"mc.lostAt": "Elveszve itt:",
"mc.matchPartner": "Partnernél",
"mc.matchPublic": "Talált tárgy",
"mc.matches": "Megfelelések",
"mc.matchesSub": "A talált tárgyak illeszkedhetnek az elveszett tárgy hirdetéseidhez.",
"mc.myAds": "Elveszett tárgy hirdetéseim",
"mc.myDeclarations": "Bejelentéseim",
"mc.myFinds": "Általam talált tárgyak",
"mc.myFindsNone": "Még nem jelentettél be talált tárgyat.",
"mc.myFindsSub": "Azok a tárgyak, amelyeket találtál elveszett tárgy hirdetéseken.",
"mc.myFound": "Bejelentett talált tárgyak",
"mc.myFoundAds": "Talált tárgy hirdetéseim",
"mc.myRewards": "Kupongyűjtőim",
"mc.name": "Teljes név",
"mc.newPassword": "Új jelszó",
"mc.none": "Még nincs bejelentés.",
"mc.notEnough": "Nem elég pont",
"mc.notifEmpty": "Még nincs értesítés.",
"mc.notifOpen": "Megtekintés",
"mc.notifTitle": "Értesítések",
"mc.notifTrack": "Követés",
"mc.notifViewAd": "Hirdetés megtekintése",
"mc.optInDesc": "Opcionális részvétel. Hozzájárulsz ahhoz, hogy a lent kiválasztott tárgyak nyilvánosan megjelenjenek. Bármikor módosítható.",
"mc.optInTitle": "Megjelenés a nyilvános ranglistán",
"mc.password": "Jelszó",
"mc.passwordMismatch": "A jelszavak nem egyeznek.",
"mc.phone": "Telefon",
"mc.photoUpdated": "Profilkép frissítve",
"mc.pointsAwaiting": "Pontok várakozás alatt",
"mc.pointsBalance": "Elköltendő pontok",
"mc.pointsOk": "Pontok jóváírva",
"mc.presentHint": "Mutasd ezt a QR-kódot a partnernek: ők beolvassák, hogy érvényesítsék a jutalmadat.",
"mc.presentInStore": "Mutasd be az üzletben",
"mc.presentTitle": "Mutasd be ezt a kupont",
"mc.privacy": "Adatvédelem & adatok",
"mc.privacyDesc": "Töltsd le a Findloop által rólad tárolt összes személyes adat másolatát (GDPR, 15. & 20. cikk).",
"mc.profileSaved": "Profil frissítve.",
"mc.profileSettings": "Nyilvános profil & ranglista",
"mc.pseudo": "Keresztnév vagy becenév",
"mc.redExpired": "Lejárt",
"mc.redReady": "Mutasd be a partnernél",
"mc.redUsed": "Használva",
"mc.redeem": "Beváltás",
"mc.registerBtn": "Fiókom létrehozása",
"mc.registerTitle": "Ügyfélfiók létrehozása",
"mc.rememberMe": "Emlékezz rám",
"mc.remove": "Eltávolítás",
"mc.resetDone": "Jelszó frissítve. Most már be tudsz jelentkezni.",
"mc.resetExpired": "Ez a visszaállítási link érvénytelen vagy lejárt. Kérj újat az alábbiakban.",
"mc.resetSave": "Jelszavam visszaállítása",
"mc.resetTitle": "Új jelszó",
"mc.restitutionConfirmed": "Visszatérés megerősítve.",
"mc.reward": "Jutalom",
"mc.rewardRedeemed": "Jutalom megnyitva! Kód:",
"mc.rewardsDesc": "Használj pontokat a partnereink által kínált kedvezményekre. Egyenleg:",
"mc.rewardsNone": "Még nincs rendelkezésre álló jutalom.",
"mc.rewardsTitle": "Költöm a pontjaimat",
"mc.scoreAwarded": "Gratulálunk! +1 a Finder Pontjaidhoz 🎉",
"mc.scoreEarned": "Pont megszerezve",
"mc.scorePts": "pts",
"mc.scoreThisYear": "Idén",
"mc.scoreTitle": "Finder Pontok",
"mc.seeRanking": "Ranglista megtekintése",
"mc.share": "Megosztás",
"mc.statsTitle": "Statisztikák",
"mc.subtitle": "Kövesd nyomon az összes riportodat egy helyen.",
"mc.title": "Saját fiókom",
"mc.toLogin": "Már regisztráltál?",
"mc.toRegister": "Még nincs fiókod?",
"mc.track": "Követés",
"mc.views": "Megtekintések",
"mc.visCity": "Város",
"mc.visCountry": "Ország",
"mc.visLabel": "Ranglistán látható tételek:",
"mc.visName": "Keresztnév / becenév",
"mc.visPhoto": "Profilkép",
"mc.welcome": "Helló",
"mc2.acceptFinder": "Fogadd el ezt a findert",
"mc2.accountActivity": "Fiók tevékenység",
"mc2.adsActive": "{n}/5 aktív hirdetés",
"mc2.autoDelete": "Automatikus törlés ütemezve",
"mc2.badgeBronze": "Bronz",
"mc2.badgeGold": "Arany",
"mc2.badgeSilver": "Ezüst",
"mc2.boostEarnedAlready": "Már ennyit keresett neked",
"mc2.boostEarnedWin": "Ez annyit hozott neked",
"mc2.boostExpiredWin": "A lendületed éppen lejárt — folytasd -20%-on!",
"mc2.boostExpiresIn": "A lendületed innen lejár",
"mc2.boostWinDetail2": ". -20% automatikusan érvényesül, ha 24 órán belül megújítod.",
"mc2.claimCode": "Igénylési kód:",
"mc2.codeSentFinder": "Kód elküldve a findernek e-mailben",
"mc2.daysShort": "{n} nap",
"mc2.downloadReceipt": "Letöltöm a nyugtát",
"mc2.error": "Hiba {status}",
"mc2.finderAccepted": "A Finder elfogadva — kód küldve e-mailben",
"mc2.finderContacts": "Finder(e) elérhetőségei",
"mc2.followFindo": "Kövessd a findloop-t",
"mc2.imgInvalid": "Érvénytelen kép",
"mc2.inactivityNote": " — {n} hónap tétlenség esetén (GDPR).",
"mc2.lastActivity": "Utolsó aktivitás:",
"mc2.lostEmailTitle": "Már nincs hozzáférésem az e-mail címemhez",
"mc2.noPhotoPreset": "Nincs még fénykép? Válassz alapértelmezett avatart:",
"mc2.paidViaPartner": "Ki van fizetve (partneren keresztül)",
"mc2.payRecovery": "Fizesd ki a helyreállítási díjat",
"mc2.paySettle": "Fizesd ki a tartozásomat",
"mc2.payShipping": "Fizesd ki a szállítási díjat",
"mc2.payUnavailable": "Fizetés nem elérhető",
"mc2.peopleFound": "{n} fő(k) azt hiszi, hogy megtalálta az elemét",
"mc2.phoneNumber": "Telefonszám",
"mc2.reactivateAccount": "Reaktiválom a fiókomat",
"mc2.reactivated": "Fiók reaktiválva",
"mc2.reactivatedThanks": "Fiók reaktiválva — köszönjük a hűségedet!",
"mc2.recoverSmsBtn": "Kérjem a kódom SMS-ben",
"mc2.recoverSmsDesc": "Kérd a kódodat SMS-ben az általad regisztrált számra.",
"mc2.recoverSmsFallback": "Ha létezik fiók ezzel a számmal, SMS-t küldtünk.",
"mc2.renewStayTop": ". Megújítás a csúcs pozíció megtartásához és az elem visszaszerzéséhez.",
"mc2.resume20": "Újraindítás -20%",
"mc2.unlockContacts": "Elérhetőségek feloldása",
"mc2.unlockDesc": "Fizesd ki a Findloop kezelési díjat, hogy megjelenjenek az elérhetőségek és megszervezhesd az átvételt.",
"mc2.viewsWord": "megtekintés",
"mc2.live": "Élő",
"mh.allCategories": "Minden kategória",
"mh.allPeriod": "Minden időszak",
"mh.autoMatch": "Automatikus AI párosítás",
"mh.blocked": "Lelőve (ellentmondás)",
"mh.blockedReason": "Párosítás leblokkolva: az elem fő kulcsszavai és a nyilatkozat ellentmondanak egymásnak.",
"mh.days30": "Utolsó 30 nap",
"mh.days7": "Utolsó 7 nap",
"mh.days90": "Utolsó 90 nap",
"mh.emptyDesc": "AI párosítások itt fognak megjelenni, ahogy a nyilatkozatok beérkeznek.",
"mh.emptyTitle": "Nincs esemény",
"mh.exportCsv": "CSV exportálása",
"mh.exportDone": "CSV export letöltve",
"mh.exportImpossible": "Exportálás nem sikerült",
"mh.fBlocked": "Lelőve",
"mh.fConfirmed": "Megerősítve",
"mh.fRejected": "Elutasítva",
"mh.objectLabel": "Elem:",
"mh.refresh": "Frissítés",
"mh.rejected": "Elutasítva",
"mh.srcManual": "Kézi",
"mh.srcText": "Szöveg",
"mh.srcVisual": "Vizuális (fénykép)",
"mh.subtitle": "AI által javasolt párosítások naplója — automatikusan párosított, megerősített és elutasított.",
"mh.title": "AI Történelem",
"nav.ads": "Eltűnt tárgyak",
"nav.dashboard": "Saját tér",
"nav.found": "Megtalált tárgyak",
"nav.how": "Hogyan működik",
"nav.login": "Bejelentkezés",
"nav.map": "Térkép",
"nav.more": "Több",
"nav.partners": "Partnerek",
"nav.pricing": "Árazás",
"nav.ranking": "Helyezések",
"nav.register": "Legyél partner",
"nav.track": "Nyomkövetés",
"nf.desc": "A keresett oldal nem létezik vagy áthelyezték.",
"nf.home": "Vissza a főoldalra",
"nf.title": "Az oldal nem található",
"par.allCities": "Összes város",
"par.allCountries": "Összes ország",
"par.badge": "Könyvtár",
"par.certified": "Hitelesített",
"par.certifiedBadge": "Hitelesített",
"par.cityPh": "Város",
"par.declare": "Bejelentés",
"par.none": "Nincs partner.",
"par.partnerBadge": "Partner",
"par.searchPh": "Keress egy intézményt…",
"par.subtitle": "Találd meg azt az intézményt, ahol elveszítetted a tárgyadat, és jelentsd be a veszteséget.",
"par.title": "Partnereink",
"pay.addr1": "Cím",
"pay.addr2": "Cím 2. sor (opcionális)",
"pay.addrIncomplete": "Kérjük, töltsd ki a szállítási címet.",
"pay.badge": "Visszakeresés",
"pay.card": "Fizetés kártyával",
"pay.city": "Város",
"pay.country": "Ország",
"pay.eurNote": "Az összegek euróban (€) vannak feltüntetve.",
"pay.fee": "Visszakeresési díj",
"pay.free": "ingyenes",
"pay.howRecover": "Hogyan szeretnéd visszakapni a tárgyadat?",
"pay.momo": "Fizetés Mobil Pénzben",
"pay.momoConfirm": "Fizetés megerősítése",
"pay.noMatch": "Ehhez a bejelentéshez még nincs megerősített, megfelelő tárgy.",
"pay.notfound": "Bejelentés nem található.",
"pay.phonePh": "Telefonszám",
"pay.pickup": "Személyes átvétel",
"pay.pickupDesc": "Itt:",
"pay.postal": "Irányítószám",
"pay.secure": "Biztonságos fizetés",
"pay.serviceFee": "Findloop szolgáltatási díj",
"pay.ship": "Küldjék el nekem",
"pay.shipAfter": "— a fizetés után kínálják.",
"pay.shipDesc": "Szállítás a címemre",
"pay.shipNote": "Szállítás elérhető",
"pay.shipping": "Szállítási díj",
"pay.subtitleWith": "Fizesd ki a visszakeresési díjat itt:",
"pay.title": "Tárgyam visszaszerzése",
"pay.total": "Összesen",
"pcat.city_hall": "Polgármesteri hivatalok",
"pcat.hotel": "Szállodák",
"pcat.other": "Egyéb",
"pcat.park": "Parkok",
"pcat.prefecture": "Prefektúrák",
"pcat.restaurant": "Éttermek",
"pcat.uncategorized": "Nincs kategorizálva",
"pd.about": "Rólunk",
"pd.back": "Összes partner",
"pd.certified": "Hitelesített partner",
"pd.declare": "Jelentsd be itt a veszteséget",
"pd.itemsReturned": "visszaküldött tételek",
"pd.itemsTotal": "regisztrált tételek",
"pd.map": "Helyszín",
"pd.noItems": "Nincsenek nemrégiben megtalált tételek.",
"pd.noReviews": "Nincsenek még értékelések.",
"pd.notFound": "Partner nem található.",
"pd.recentItems": "Nemrégiben található tételek",
"pd.reply": "Válasz az üzlettől",
"pd.reviews": "Vásárlói értékelések",
"pd.verified": "Hitelesített értékelés",
"pd.verifiedEstablishment": "Findloop hitelesített üzlet",
"pg.next": "Következő",
"pg.prev": "Előző",
"pg.showing": "{from}–{to} a(z) {total} közül",
"pk.bodyCopy": "Szöveg",
"pk.bodyText": "Törzs szöveg",
"pk.brandColors": "Márka színei",
"pk.colorRed": "Piros",
"pk.colorWhite": "Fehér",
"pk.darkBg": "Sötét háttér",
"pk.download": "Letöltés",
"pk.downloadZip": "Az egész csomag letöltése (ZIP)",
"pk.headings": "Címek",
"pk.heroDesc": "Hivatalos logók, közösségi média bannerek, színek és tipográfia. Válaszd ki a szlogen nyelvét és változatát, majd töltsd le a vizuális anyagot vagy a teljes csomagot.",
"pk.lightBg": "Világos háttér (nyomtatáshoz)",
"pk.logoWordmark": "Logó / szójel",
"pk.logosVisuals": "Logók és vizuális anyagok",
"pk.mapCollect": "Térkép / gyűjtőpontok",
"pk.plain": "Egyszerű",
"pk.pressKit": "Sajtócsomag",
"pk.taglineLang": "Szlogen nyelve",
"pk.typography": "Tipográfia",
"pk.variant": "Változat",
"pr.shipBtn": "Tétel kiszállítása",
"pr2.adBoostMsg": "Remek választás! Megtöbbszörözi a gyors tételvisszaszerzés esélyeit.",
"pr2.boostActivated": "Növelés aktiválva!",
"pr2.canRecoverNow": "Most visszaszerezheted a tételt.",
"pr2.continue": "Folytatás",
"pr2.downloadReceiptPdf": "A nyugta letöltése (PDF)",
"pr2.goToSpaceNow": "Menj most a fiókomhoz",
"pr2.partnerBoostMsg": "Remek választás! A nagyobb láthatóság új vásárlókat vonz az üzletedhez.",
"pr2.paymentSuccess": "Fizetés sikeres!",
"pr2.redirectingSpace": "Átirányítás a fiókodra…",
"pr2.subActivated": "Fizetés sikeres! Az előfizetésed aktív, most már kezelheted az üzleteidet.",
"prev.allSites": "Összes üzlet",
"prev.editReply": "Válasz szerkesztése",
"prev.none": "Még nincs értékelés.",
"prev.published": "Válasz közzétéve",
"prev.reply": "Válasz",
"prev.replyPh": "Írj egy udvarias választ…",
"prev.send": "Válasz közzététele",
"prev.sending": "Közzététel…",
"prev.yourReply": "A te válaszod",
"pricing.annual": "Éves",
"pricing.annualBadge": "-20% ajánlat",
"pricing.choose": "Válaszd ki",
"pricing.compareFeature": "Funkció",
"pricing.compareTitle": "Tervek összehasonlítása",
"pricing.eyebrow": "Árazás",
"pricing.month": "/hó",
"pricing.monthly": "Havonta",
"pricing.perYear": "/év",
"pricing.popular": "Népszerű",
"pricing.quoteMsg": "Az Ön igényei (nem kötelező)",
"pricing.quoteOrg": "Szervezet",
"pricing.quoteSend": "Kérjük, küldje el a kérést",
"pricing.quoteSent": "Kérés elküldve! Hamarosan jelentkezni fogunk.",
"pricing.quoteSites": "Helyek / terminálok száma",
"pricing.quoteTitle": "Kérjen árajánlatot",
"pricing.requestQuote": "Kérjen árajánlatot",
"pricing.saveLabel": "Ön megtakarít",
"pricing.savePerYear": "/év plusz létesítményenként",
"pricing.start": "Kezdet",
"pricing.subtitle": "Kezdj ingyen, méretezz a növekedésed szerint.",
"pricing.title": "Terv minden szervezet számára",
"promo.badge": "Partnerprogram",
"promo.cta": "Tudj meg többet",
"promo.text": "Minden partner, akit ajánlasz és aki előfizet, egy ingyenes hónapot ad neked. Nincs korlátozás.",
"promo.title": "Ajánlj egy partnert, kapj egy ingyenes hónapot.",
"pub.accessGranted": "Hozzáférés engedélyezve",
"pub.accessLimited2h": "Hozzáférés korlátozott 2 órára",
"pub.accountEmailConcerned": "A kérdéses fiók email címe",
"pub.adAppearPublic": "Így fog megjelenni a hirdetése nyilvánosan.",
"pub.adPreviewBtn": "Hirdetés előnézet",
"pub.alertMeOnArrival": "Értesíts a megérkezésről",
"pub.allActionsLogged": "Minden művelet naplózva van",
"pub.allCategories": "Minden kategória",
"pub.authorizeAccess": "Hozzáférés engedélyezése",
"pub.authorizeSupportQ": "Engedélyezi a támogatási hozzáférést?",
"pub.available": "Elérhető",
"pub.backHome": "Vissza a főoldalra",
"pub.boostAdCta": "Hirdetésem felerősítése",
"pub.boostAdTitle": "Hirdetésed felerősítése",
"pub.boostCarouselSub": "Mozgás az oldal tetejére a “Felerősített” körforgásban, és nézetek megsokszorozása az elem gyorsabb visszaszerzéséhez.",
"pub.boostEstablishment": "Létesítményed felerősítése",
"pub.boostEstablishmentDesc": "Jelenj meg a könyvtár élén egy “Felerősített” jelvénnyel, és vonzz több bejelentést.",
"pub.boostFicheCta": "Listám felerősítése",
"pub.brandReady": "A Findloop márka, készen a használatra",
"pub.cantFindItem": "Nem találom az elememet?",
"pub.cantProcessImage": "A kép feldolgozása nem lehetséges",
"pub.claimQr": "QR kód igénylése",
"pub.clickToZoom": "Kattints a nagyításhoz",
"pub.codeAlreadyValidated": "Kód érvényesítve — kapcsolatok feloldva.",
"pub.codeExample": "pl. ABCD2345",
"pub.confirmRenewal": "Megújítás megerősítése",
"pub.contactIntro": "Kérdésed van? Írj nekünk, hamarosan válaszolunk.",
"pub.contactTypeDeceased": "Fiók törlés (elhunyt személy)",
"pub.contactTypeGeneral": "Általános kérdés",
"pub.contactTypeSupport": "Támogatás / műszaki probléma",
"pub.contactUs": "Lépj velünk kapcsolatba",
"pub.continueWithoutEmail": "Folytatás email megadása nélkül",
"pub.contractLabel": "Szerződés",
"pub.contractNotFound": "Szerződés nem található vagy már lejárt.",
"pub.contractRenewed": "Szerződés megújítva!",
"pub.contractRenewedFor": "A szerződésed megújítva {n} hónapra.",
"pub.copyFailed": "Másolás sikertelen",
"pub.createPartnerAccount": "Partner fiókom létrehozása",
"pub.currentDeadline": "Jelenlegi határidő",
"pub.deceasedInfo": "Mint rokon vagy örökös, kérheti egy elhunyt személy Findloop fiókjának törlését. Kérjük, hogy a GDPR-nak megfelelően kezeljük a kérelmet (támogató dokumentumok kérhetők).",
"pub.declareMyLoss": "Jelentsem a veszteségem",
"pub.describeItemPlaceholder": "Írd le a tárgyadat (pl. fekete esernyő, kulcsok…)",
"pub.downloadImage": "Töltse le a képet",
"pub.drawSignature": "Kérjük, rajzolja le az aláírását.",
"pub.drawSignatureHint": "Rajzolja le az aláírását az egérrel vagy az ujjával.",
"pub.duration": "Időtartam",
"pub.eSignature": "Elektronikus aláírás",
"pub.eSignatureDesc": "Írd be a nevedet az aláíráshoz. A dátum automatikusan rögzítésre kerül.",
"pub.edit": "Szerkesztés",
"pub.editorialTitles": "Szerkesztői címek",
"pub.emailPlaceholder": "te@example.com",
"pub.enterCodeUnlockOwner": "Írd be a kódot, amit e-mailben kaptál, hogy feloldhasd a tulajdonos elérhetőségeit.",
"pub.errorWord": "Hiba",
"pub.foundSelfService": "Talált tárgyak · Önkiszolgálás",
"pub.haveOwnerCode": "Kaptam egy kódot a tulajdonostól",
"pub.home": "Főoldal",
"pub.immediateRenewal": "Azonnali megújítás, új ajánlat nélkül.",
"pub.impAdminReq1": "Adminisztrátor",
"pub.impAdminReq2": "engedélyt kér az ideiglenes fiókhozzáféréshez",
"pub.impAdminReq3": "az ön segítségére.",
"pub.impGrantedDesc": "A támogató csapat legfeljebb 2 órán át hozzáférhet a fiókodhoz. Minden tevékenységet rögzítenek. Ezt az oldalt bezárhatod.",
"pub.invitedOnFindo": "Ön meghívást kapott a findloop-ra",
"pub.isThisYourItem": "Ez a te tárgyad?",
"pub.itemsAvailableCount": "{n} db/termék jelenleg elérhető",
"pub.itemsFoundOwner": "az átadott tárgyak megtalálták a tulajdonosukat",
"pub.itemsReturnedOwners": "tárgyak visszaadva a tulajdonosaiknak",
"pub.itsMine": "Ez az enyém",
"pub.joinFindoDesc": "Csatlakozz a findloop-hoz, és kezeld a megtalált tárgyaidat könnyedén.",
"pub.joinInvitesYou": "meghív a findloop-hoz. Hozd létre a partnerfiókodat a megtalált tárgyaid kezeléséhez.",
"pub.linkCopied": "Link másolva!",
"pub.loadingContract": "A szerződés betöltése…",
"pub.lsClaimDesc": "Jelentsd a veszteségedet a visszaszerzéshez. Hagyj meg egy e-mail címet, és emlékeztetőt küldünk, ha a jelentésed nem fejeződik be.",
"pub.lsHeroDesc": "Ellenőrizd saját magad, hogy a keresett tárgyad megtalálható-e és itt hagyták-e. Megtaláltad? Jelentsd be a visszaszerzéshez.",
"pub.lsSearchTitle": "Keresés a megtalált tárgyak között",
"pub.makeOffer": "Tedd meg az ajánlatot",
"pub.makeOfferDesc": "Javasold az összegedet. A szuperadmin értékelni fogja.",
"pub.mapNearYou": "Tárgyak & partnerek a közelben",
"pub.mapWord": "Térkép",
"pub.messageSentToast": "Üzenet elküldve — csapatunk hamarosan válaszol.",
"pub.messageWord": "Üzenet",
"pub.momoInitiated": "Mobil pénzátutalás kezdeményezve",
"pub.monthsWord": "hónap",
"pub.nameConsentRequired": "Név és hozzájárulás szükséges.",
"pub.newDeadline": "Új határidő",
"pub.noActionRequired": "Nincs teendő.",
"pub.noAmountCharged": "Nem kértek összeget.",
"pub.noItemMatch": "Jelenleg nincs elérhető tárgy, ami megfelelne a keresésednek.",
"pub.noMatchingItem": "Nincs megfelelő tárgy",
"pub.noPaymentSession": "Nincs fizetési session.",
"pub.noPhoto": "Nincs fénykép",
"pub.noPointsYet": "Még nincs mutatható pont.",
"pub.noSecondPayment": "A tárgyhoz nem szükséges második fizetés.",
"pub.notHereYet": "Még nem itt? Értesülj róla, amint megérkezik.",
"pub.notifyDone": "Megjegyezve! E-mailben értesítünk, amint egy megfelelő tárgy érkezik.",
"pub.offerSubmitted": "Az ajánlatod be lett nyújtva.",
"pub.oops": "Hoppá",
"pub.orAlertEmail": "Vagy értesülj e-mailben, amint egy megfelelő tárgy érkezik:",
"pub.ownerContacts": "Tulajdonos elérhetőségei",
"pub.ownerContactsUnlocked": "Tulajdonos elérhetőségei feloldva",
"pub.partnerContact": "Partner kapcsolat",
"pub.payLinkUnavailable": "Fizetési link nem elérhető — lépj kapcsolatba a partnerrel.",
"pub.paymentCancelled": "A fizetést törölték",
"pub.paymentConfirmed": "Fizetés megerősítve 🎉",
"pub.paymentConfirmedDesc": "Egy e-mailt fog kapni a tétel helyreállításához szükséges részletekkel.",
"pub.paymentNotConfirmed": "A fizetés nem lett megerősítve",
"pub.paymentNotConfirmedDesc": "A fizetés nem ellenőrizhető. Kérjük, próbálja újra, vagy lépjen kapcsolatba a partnerrel.",
"pub.paymentProcessing": "A kifizetés feldolgozása folyamatban. Frissítsen egy pillanat múlva.",
"pub.photoAdded": "✓ Fénykép hozzáadva",
"pub.photoRequired": "Szükség van a tétel fényképére.",
"pub.previewAlt": "előnézet",
"pub.publish": "Közzététel",
"pub.publishingWord": "Közzététel…",
"pub.qty": "Menny.",
"pub.quoteDeclined": "Ajánlat elutasítva.",
"pub.quoteNotFound": "Ajánlat nem található vagy lejárt.",
"pub.reasonLabel": "Indok",
"pub.recoveryAlreadyPaid": "A helyreállítási díjat már kifizették",
"pub.referralCode": "Ajánlási kód:",
"pub.relationshipPlaceholder": "Fiú, házastárs, közjegyző…",
"pub.renewYourContract": "Újítsa meg a szerződését",
"pub.renewalFailed": "A megújítás nem sikerült. Próbálja meg később.",
"pub.renewing": "Megújítás…",
"pub.replySoon": "Csapatunk a lehető leghamarabb válaszolni fog.",
"pub.requestGone": "Ez a kérés már nem létezik.",
"pub.requestHandled": "A kérés már kezelve van",
"pub.requestNotFound": "Kérés nem található vagy lejárt.",
"pub.requestUnavailable": "Kérés nem elérhető",
"pub.required": "(kötelező)",
"pub.retroClosing": "Együtt a világot egy kicsit kevésbé elveszetté tesszük.",
"pub.retroClosing2": "Együtt a világot egy kicsit kevésbé elveszetté tesszük.",
"pub.retroScroll": "Egy év a fontos dolgok helyreállításáról. Görgessen lefelé ↓",
"pub.revokeAnytime": "Bármikor visszavonhatja, ha felkeres minket",
"pub.scene": "Jelenet",
"pub.sendImpossible": "Nem lehet elküldeni",
"pub.sendMessage": "Üzenet küldése",
"pub.sending": "Küldés…",
"pub.sharePreview": "Előnézet megosztása",
"pub.shareYourAd": "Hirdetésed megosztása",
"pub.signedSuccess": "Sikeresen aláírva!",
"pub.signerFullName": "Aláíró teljes neve",
"pub.spreadNetwork": "Osztja meg a körülötted lévőkkel, hogy növelje esélyeidet.",
"pub.spreadOwner": "Ossza meg, hogy segítsen a tulajdonosnak helyreállítani a dolgait.",
"pub.statusLabel": "Állapot:",
"pub.subject": "Tárgy",
"pub.thanksSent": "Köszönjük, az üzenete elküldve.",
"pub.thisYear": "Idén",
"pub.validate": "Érvényesítés",
"pub.verifyingPayment": "Fizetés ellenőrzése…",
"pub.verifyingYourPayment": "Az Ön kifizetésének ellenőrzése…",
"pub.viewAd": "Hirdetés megtekintése →",
"pub.viewPartner": "Partner megtekintése →",
"pub.yourAdPreview": "Hirdetésed előnézete",
"pub.yourEmail": "Az Ön e-mail címe",
"pub.yourEmailRecommended": "Az Ön e-mail címe (ajánlott)",
"pub.yourEmailShort": "Az Ön e-mail címe",
"pub.yourName": "Az Ön neve",
"pub.yourRelationship": "Ön kapcsolata a személlyel",
"qv.acceptAndSign": "Elfogadom és aláírom az ajánlatomat",
"qv.certifyAuthorized": "Tanúsítom, hogy jogosult vagyok aláírni, és elfogadom a {what} (kötőerővel bíró érték) feltételeit.",
"qv.clear": "Törlés",
"qv.client": "Ügyfél",
"qv.conditions": "Feltételek",
"qv.confirmDecline": "Megerősíti ennek a idézetnek a visszautasítását?",
"qv.countersignedFindo": "Aláírt: Findloop · {name} {date}-án",
"qv.decline": "Visszautasítás",
"qv.description": "Leírás",
"qv.downloadPdf": "PDF letöltése",
"qv.handwrittenSignature": "Kézi aláírás",
"qv.inclTax": "Áfával együtt",
"qv.invalidAmount": "Érvénytelen összeg.",
"qv.invoice": "Számla",
"qv.invoicePaid": "Számla kifizetve",
"qv.issuer": "Kibocsátó",
"qv.messageOptional": "Üzenet (opcionális)",
"qv.negotiatedAmount": "Tárgyalt összeg",
"qv.payInvoiceOnline": "Számla kifizetése online",
"qv.quote": "Ajánlat",
"qv.quoteValidDays": "Ajánlat érvényes {n} napig.",
"qv.sendMyOffer": "Ajánlatom elküldése",
"qv.signContract": "Szerződés aláírása",
"qv.signNow": "Aláírás most",
"qv.signatureAlt": "Aláírás",
"qv.signedByOn": "✔ Aláírta {name} {date}-án",
"qv.stContractSigned": "A szerződés aláírva. Köszönjük!",
"qv.stCounterAccepted": "Ajánlatát elfogadták! Kérjük, írd alá a szerződést alább.",
"qv.stCounterRefused": "Ajánlatodat nem tudták elfogadni.",
"qv.stCountered": "Ajánlatodat benyújtottuk. Várjuk a Findloop válaszát.",
"qv.stDeclined": "Ezt az ajánlatot visszautasította.",
"qv.stSigned": "Ajánlat elfogadva és aláírva. Köszönjük!",
"qv.totalHt": "Összesen áfa nélkül",
"qv.totalTtc": "Összesen áfával együtt",
"qv.unitHt": "Egység áfa nélkül",
"qv.vat": "ÁFA",
"qv.yourProposedAmount": "Az Ön által javasolt összeg ({cur})",
"rate.chooseNote": "Kérjük, válasszon egy értékelést.",
"rate.commentPh": "Egy megjegyzés (opcionális)…",
"rate.home": "Vissza a kezdőlapra",
"rate.submit": "Értékelés elküldése",
"rate.submitting": "Küldés…",
"rate.subtitle": "Hogy ment az Ön tárgyának visszaszerzése?",
"rate.successText": "Visszajelzése segít más felhasználóknak.",
"rate.successTitle": "Köszönjük az értékelését!",
"rate.title": "Értékelje a tapasztalatát",
"reg.add": "Elem rögzítése",
"reg.allBrands": "Minden márka",
"reg.allColors": "Minden szín",
"reg.allLocations": "Minden helyszín",
"reg.detailDesc": "Részletek és intézkedések erről a megtalált tárgyról.",
"reg.dispAuction": "Licitalás",
"reg.dispAuthorities": "Hatóságnak átadva",
"reg.dispDestroyed": "Megsemmisítve",
"reg.dispDonate": "Jótékonysági adomány",
"reg.dispositionHint": "Rögzítse az elemet, ahogyan elhagyja a tárolót. Kategória alapján számítva a statisztikákba.",
"reg.emptyCta": "Elem rögzítése",
"reg.emptyDesc": "Kezdje az első megtalált elemének rögzítésével.",
"reg.emptyTitle": "Nincsenek megtalált elemek",
"reg.establishmentFallback": "az intézmény",
"reg.lblAuctioned": "aukcióra bocsátva",
"reg.lblAuctionedShort": "aukción",
"reg.lblAuthorities": "hatóságnak átadva",
"reg.lblDestroyed": "megmésítve",
"reg.lblDonated": "adományozva egy jótékonysági szervezetnek",
"reg.legalCount": "{n} tétel(ek): jogi megőrzési időszak elérve",
"reg.legalHint": "A tételeket árverésre bocsáthatja, adományozhatja egy jótékonysági szervezetnek, vagy bejelentheti a hatóságoknak.",
"reg.legalLimitCountry": "Határidő: {date} · alkalmazott ország: {country}",
"reg.legalOver": "Határidő lejárt: {date} · {country}",
"reg.legalReached": "Jogi időszak elérve",
"reg.legalReachedFull": "Jogi megőrzési időszak elérve",
"reg.limitShort": "határidő",
"reg.location": "Helyszín",
"reg.markRestituted": "Jelöld meg visszaadottként",
"reg.markedAs": "Tétel megjelölve: {label}",
"reg.moveHistory": "Mozgás története",
"reg.overBy": "{n} nappal túllépve",
"reg.physicalLocation": "Fizikai helyszín",
"reg.popupBlocked": "Engedje meg a felugró ablakokat a címkék nyomtatásához.",
"reg.popupBlockedOne": "Engedje meg a felugró ablakot a címke nyomtatásához.",
"reg.printLabel": "Nyomtassa ki a címkét",
"reg.printN": "Nyomtassa ki a(z) {n} címkét",
"reg.qrCodeItem": "Tétel QR kód",
"reg.qrLabelTitle": "QR címke",
"reg.qrLabelsTitle": "QR címkék",
"reg.qrNotFound": "Nincs tétel a QR kódhoz.",
"reg.qrScanHint": "Szkennelje be, hogy közvetlenül megnyissa ezt a rekordot és megtalálja a helyszínt.",
"reg.recoveryFee": "Visszaszerzési díj (€)",
"reg.searchPh": "Keresés leírás alapján…",
"reg.selectQr": "Válassza ki a QR címkék nyomtatásához",
"reg.selectedN": "{n} kiválasztva",
"reg.shipPricePh": "Szállítási díj (€)",
"reg.shippingPossible": "Szállítás elérhető",
"reg.storagePh": "pl. A3 polc, 12-es zár",
"reg.tAuction": "Árverés a findo-n",
"reg.tAuthorities": "Jelentse a hatóságoknak",
"reg.tDonate": "Adományozza egy jótékonysági szervezetnek",
"reg.toastFee": "Díj frissítve",
"reg.toastLocation": "Helyszín mentve",
"reg.toastRestituted": "Tétel megjelölve: visszaadva",
"reg.toastShipping": "Szállítási opció frissítve",
"reg.toastTransferred": "Tétel átadva: “{name}”",
"reg.unclaimedDisposition": "Igénytelen tétel - végleges rendelkezés",
"res.codeValidated": "Kód érvényesítve",
"res.empty": "Még nem rögzítettek visszaadást.",
"res.error": "Hiba {status}",
"res.proofPdf": "PDF bizonyíték",
"res.signed": "Aláírt",
"res.stRestituted": "Személyesen átadva",
"res.stShipped": "Szállítással visszaküldve",
"res.subtitle": "Az összes befejezett átadás, letölthető aláírt bizonyítékkal.",
"res.title": "Visszaadás története",
"rev.b2b": "B2B partnerek",
"rev.b2c": "Vásárlók",
"rev.based": "{n} értékelés alapján",
"rev.eyebrow": "Vélemények",
"rev.restitutedBy": "Visszaadta: {org}",
"rev.storiesEyebrow": "Boldog befejezések",
"rev.storiesSubtitle": "Valós történetek olyan ügyfelektől, akik visszakapták a dolgaikat a Findloop segítségével.",
"rev.storiesTitle": "Megtalálták a dolgaikat!",
"rev.subtitle": "Partnerek és vásárlók megosztják tapasztalataikat.",
"rev.title": "Bíznak a findloop-ban",
"rev.verified": "Ellenőrzött",
"rp.already": "Már jelentette ezt a listát.",
"rp.comment": "Részletek (opcionális)",
"rp.duplicate": "Másolat",
"rp.fraud": "Csalás",
"rp.inappropriate": "Nem megfelelő tartalom",
"rp.offensive": "Offenzív tartalom",
"rp.other": "Egyéb",
"rp.reason": "Ok",
"rp.report": "Jelentés",
"rp.send": "Jelentés elküldése",
"rp.sent": "Jelentés elküldve. Köszönjük a hozzájárulását.",
"rp.spam": "Spam / hirdetés",
"rp.title": "Jelentsd ezt a hirdetést",
"rp.wrongCategory": "Helytelen kategória",
"rt.annualGoal": "Éves cél",
"rt.championCity": "Bajnok város",
"rt.cityRate": "{rate}% visszatérési arány",
"rt.goalProgress": "{rate}% teljesült a {target}% célból",
"rt.reached": "Elérve 🎉",
"rt.restitutionRate": "Visszatérési arány",
"rt.shareRecap": "Oszd meg az összefoglalómat",
"rt.thanks": "Köszönjük Findloop {year} 💛",
"rt.yourRecap": "A te {year} összefoglalód",
"rw.active": "Aktív",
"rw.add": "Hozzáad",
"rw.camUnavailable": "A kamera nem elérhető. Írd be a kódot manuálisan alább.",
"rw.codeValidated": "Kód érvényesítve",
"rw.codesTitle": "Kódok, amelyeket a finderek váltottak be",
"rw.confirmDelete": "Töröljem a „{title}”-t?",
"rw.deleted": "Törölve",
"rw.edit": "Szerkeszt",
"rw.editReward": "A jutalom szerkesztése",
"rw.empty": "Még nincs jutalom.",
"rw.expired": "Lejárt",
"rw.expiresOn": "Lejár: {date}",
"rw.fActive": "Aktív (látható a findereknek)",
"rw.fCost": "Költség (pontok)",
"rw.fDesc": "Leírás",
"rw.fStock": "Készlet (üres = korlátlan)",
"rw.fTitle": "Cím",
"rw.fValidity": "Kupon érvényessége (napok a beváltás után)",
"rw.inactive": "Inaktív",
"rw.newReward": "Új jutalom",
"rw.noExchange": "Még nincs beváltás.",
"rw.pageSubtitle": "Szkenneljük be a finderek által bemutatott kuponokat, hogy érvényesíthessük jutalmaikat.",
"rw.redeemedN": "Beváltva: {n}×",
"rw.saved": "Jutalom mentve",
"rw.scanVoucher": "Kupon beolvasása",
"rw.staffScanOnly": "Csak beolvasás",
"rw.statActive": "Bemutatásra",
"rw.statExpired": "Lejárt",
"rw.statRedeemed": "Kuponok beváltva",
"rw.statUsed": "Érvényesítve",
"rw.stock": "Készlet",
"rw.subtitle": "Ajánlj nem pénzbeli juttatásokat (kuponok, frissítések…), amelyeket a finderek beváltanak a Finder Score pontjaikért.",
"rw.title": "Jutalmak a findereknek",
"rw.used": "Használt",
"rw.validate": "Érvényesít",
"rw.validateCode": "A kód érvényesítése",
"rw.validity": "Érvényesség: {n} nap",
"shell.f1d": "Automatikusan összeköti az elveszett és talált tárgyakat.",
"shell.f1t": "Okos AI párosítás",
"shell.f2d": "Kövesd a visszatérítési arányt és a bevételt valós időben.",
"shell.f2t": "Irányítópult & bevétel",
"shell.f3d": "Ügyfeleid 30 másodperc alatt jelentik.",
"shell.f3t": "Partner QR kód",
"shell.title": "A megtalált tárgyakat elégedett vásárlókká alakítsd.",
"ship.addr1": "Cím",
"ship.addr2": "Cím 2. sora (opcionális)",
"ship.badge": "Szállítás",
"ship.city": "Város",
"ship.country": "Ország",
"ship.needPaid": "Fizessd ki a visszaszállítási díjat először a szállítás kéréséhez.",
"ship.notShippable": "Ez a tétel nem szállítható.",
"ship.notfound": "Jelentés nem található.",
"ship.postal": "Irányítószám",
"ship.price": "Szállítási díj",
"ship.submit": "Szállítás kérés",
"ship.submitting": "Küldés…",
"ship.subtitle": "Add meg a szállítási címedet.",
"ship.successText": "A partner felkészíti a csomagodat. Értesítést kapsz, amikor feladják.",
"ship.successTitle": "Szállítási kérés elküldve!",
"ship.title": "Kérd el a tétel szállítását",
"ship.weight": "Becsült súly (kg)",
"shp.carrier": "Futár",
"shp.download": "PDF letöltése",
"shp.generating": "Generálás…",
"shp.label": "Címke generálása",
"shp.none": "Nincs kérés alatt lévő szállítás.",
"shp.setTracking": "Nyomkövetés mentése",
"shp.status": "Állapot",
"shp.to": "Címzett",
"shp.tracking": "Nyomkövetési szám",
"shp.trackingSaved": "Nyomkövetés mentve",
"side.account": "Saját fiókom",
"side.declarations": "Jelentések",
"side.deposit": "Tétel bejelentése",
"side.establishments": "Létesítmények",
"side.invoices": "Számlák",
"side.logout": "Kijelentkezés",
"side.matchHistory": "AI Történet",
"side.partner": "Partner",
"side.refresh": "Frissítés",
"side.registry": "Nyilvántartás",
"side.restitutions": "Visszatérések",
"side.reviews": "Vélemények",
"side.rewards": "Jutalmak & Kuponok",
"side.settings": "Beállítások",
"side.shipments": "Szállítmányok",
"side.stats": "Statisztikák",
"side.storage": "Tárhely & QR",
"side.team": "Csapat",
"side.viewSite": "Nyilvános oldal megtekintése",
"st.auctioned": "Aukció keretében eladva",
"st.claimed": "Igényelt",
"st.closed": "Lezárva",
"st.delivered": "Kézbesítve",
"st.destroyed": "Megsemmisítve",
"st.donated": "Adományozva (jótékonyság)",
"st.handed_to_authorities": "Átadva a hatóságoknak",
"st.in_storage": "Raktáron",
"st.matched": "Találat találva",
"st.open": "Nyitva",
"st.paid": "Fizetve",
"st.pending": "Függőben",
"st.resolved": "Megoldva",
"st.restituted": "Visszaadva",
"st.second_chance": "Második esély",
"st.shipped": "Küldve",
"st.shipping_requested": "Szállítás kérése",
"st.submitted": "Ben 제출",
"st.verified": "Ellenőrizve",
"stat.items": "Regisztrált tételek",
"stat.partners": "Partnerek",
"stat.restituted": "Visszaadott tételek",
"status.auctioned": "Licitezték",
"status.destroyed": "Megsemmisítve",
"status.donated": "Adományozva (jótékonyság)",
"status.handed_to_authorities": "Hatóságnak átadva",
"status.in_storage": "Raktáron",
"status.matched": "Találat",
"status.open": "Nyitva",
"status.paid": "Fizetve",
"status.pending": "Függőben",
"status.restituted": "Visszaadva",
"status.shipped": "Küldve",
"status.shipping_requested": "Szállítás kérése",
"status.submitted": "Ben 제출",
"step1.tag": "Létesítmény",
"step1.text": "Másodpercek alatt a létesítmény rögzíti a megtalált tárgyat egy fényképpel, kategóriával és leírással. Minden központosítva van egy világos, biztonságos nyilvántartásban.",
"step1.title": "A partner regisztrálja a tárgyat",
"step2.tag": "Ügyfél",
"step2.text": "A partner QR-kódján keresztül az ügyfél 30 másodperc alatt leírja a elveszett tárgyat. Nincs szükség alkalmazás telepítésére — minden a böngészőben történik.",
"step2.title": "Az ügyfél bejelenti a veszteséget",
"step3.tag": "Intelligencia",
"step3.text": "Okos párosítógépünk összehasonlítja a leírásokat, és a legvalószínűbb találatokat javasolja, készen a megerősítésre.",
"step3.title": "AI összekapcsolja a veszteséget és a megtalált tárgyat",
"step4.tag": "Visszaszerzés",
"step4.text": "A visszaszerzési díj biztonságos kifizetése után az ügyfél átveszi a tárgyat a helyszínen — vagy nyomon követett szállítással kapja meg.",
"step4.title": "Az ügyfél visszakapja a tárgyát",
"stg.allLabels": "Minden QR címke",
"stg.camHint": "Használjon kézi bevitelt lent.",
"stg.camStarting": "A kamera indítása…",
"stg.camUnavailable": "A kamera nem elérhető.",
"stg.clear": "Törlés",
"stg.clearAll": "Összes törlése",
"stg.codeUnreadable": "Olvashatatlan kód.",
"stg.emptyDesc": "A tárolt tételek itt fognak megjelenni, helyszínek szerint csoportosítva.",
"stg.emptyTitle": "Nincs tárgy a tárolóban",
"stg.exportAudit": "Audit CSV exportálása",
"stg.exportDone": "CSV export letöltve",
"stg.exportImpossible": "Exportálás jelenleg nem elérhető.",
"stg.itemFound": "Tárgy megtalálva ✅",
"stg.kLocations": "Használt helyszínek",
"stg.kObjects": "Tárolt tételek",
"stg.kToClear": "Törlendő helyszínek",
"stg.locFreed": "Helyszín törölve",
"stg.locsFreed": "{n} helyszín törölve",
"stg.manualLabel": "Vagy írja be a tárgy kódját / azonosítóját",
"stg.manualPh": "Illessze be a QR azonosítóját vagy URL-jét",
"stg.noItemMatch": "Nincs olyan tárgy, ami megfelelne ennek a QR / kódnak.",
"stg.noLocation": "Nincs helyszín",
"stg.objectsAxis": "Tételek",
"stg.objectsN": "{n} tétel",
"stg.occAvg": "átlag {n} tétel/helyszín",
"stg.occHint": "A narancssárga helyszínek meghaladják az átlagot (potenciálisan túlterhelt).",
"stg.occupancy": "Helyszín kihasználtság",
"stg.openPage": "Oldal megnyitása",
"stg.posterPdf": "PDF poszter (A4)",
"stg.printAll": "Összes nyomtatása",
"stg.printGroupTitle": "Címkék nyomtatása ehhez a polchoz",
"stg.qrAlt": "Önkiszolgáló QR",
"stg.qrDownload": "QR letöltése",
"stg.qrHint": "Ezt a QR-t jelenítse meg az ügyfélnél: az ügyfelek beolvassák, hogy ellenőrizzék, elérhető-e a tételük.",
"stg.qrTitle": "Ügyféligény önkiszolgáló QR",
"stg.scanDesc": "Olvassa be egy tétel címkéjét, hogy azonnal megnyissa a nyilvántartását.",
"stg.scanQr": "QR beolvasása",
"stg.scanTitle": "QR kód beolvasása",
"stg.search": "Keresés",
"stg.shelf": "{loc} polc",
"stg.shelfPlan": "Polc terv",
"stg.staleHint": "Tisztítsa meg ezeket a helyszíneket, hogy az aktuális készletnaplót naprakészen tartsa.",
"stg.staleTitle": "{n} tétel hagyta el a raktárat, de még mindig megmaradt egy helyszín",
"stg.subtitle": "Polc terv, QR beolvasó és fizikai készlet nyilvántartása.",
"stg.title": "Raktár & QR",
"stt.acceptRate": "Elfogadási arány",
"stt.accepted": "Elfogadva",
"stt.activity30": "Tevékenység (utolsó 30 nap)",
"stt.ai6mo": "Utolsó 6 hónap · elfogadva = automatikusan párosított + megerősített.",
"stt.aiEmpty": "Ezen időszak alatt még nincs AI párhuzam.",
"stt.aiTitle": "AI párhuzamok — elfogadva vs elutasítva",
"stt.auctionShort": "Aukció",
"stt.auctionedSold": "Aukciós (eladva)",
"stt.authShort": "Hatóságok",
"stt.authorities": "Hatóságoknak átadva",
"stt.avgRating": "Átlagos értékelés",
"stt.awaitingRestitution": "visszaszolgáltatásra váró tételek",
"stt.boostClicks": "Kattintások az Ön könyvtárában ezen a héten a boostnak köszönhetően",
"stt.boostInactive": "Boost inaktív — aktiválja, hogy láthatóságot nyerjen",
"stt.certifiedPremium": "Premium minősített",
"stt.declarations": "Kinyilatkoztatások",
"stt.destroyed": "Megsemmisítve",
"stt.dispoEmpty": "Még egyetlen igénytelen tétel sem hagyta el a raktárat.",
"stt.donatedAssoc": "Adományozva (jótékonyság)",
"stt.donatedShort": "Adományozott",
"stt.gateCta": "Tudja meg a terveket",
"stt.gateDesc": "Frissítse a Starter verzióra, hogy feloldja alapstatisztikáit, vagy a Business verzióra a fejlett statisztikákhoz és üzletenkénti elemzéshez.",
"stt.gateTitle": "Statisztikák, amelyek fenntartottak a fizetős tervek számára",
"stt.inStorage": "Raktáron",
"stt.kItems": "Regisztrált tételek",
"stt.kRate": "Visszatevési arány",
"stt.kRestituted": "Visszaadott tételek",
"stt.kRevenue": "Bevétel (hónap)",
"stt.noDeclYet": "Még nincs kinyilatkoztatás.",
"stt.recapDownloaded": "Összefoglaló letöltve - készen áll a megosztásra!",
"stt.recapError": "Nem lehet létrehozni az összefoglalót",
"stt.recapText": "A mi Findloop {year} összefoglalónk: visszaadott tételek és ügyfélelégedettség 🎉",
"stt.recapTitle": "Findloop {year} összefoglaló",
"stt.rejected": "Elutasítva",
"stt.restitutions": "Visszatérítések",
"stt.shareRecap": "Ossza meg az én {year} összefoglalómat",
"stt.topCategories": "Legtöbb bevallott kategória",
"stt.unclaimedDesc": "A kategóriák szerinti ártalmatlanított, jótékonysági célra felajánlott és aukción értékesített tételek mennyisége.",
"stt.unclaimedTitle": "Következő tárgyak - tárolás elhagyása",
"stt.vsLastWeek": "a múlt héthez képest",
"sub.cancel": "Előfizetésem lemondása",
"sub.cancelAbort": "Lemondás",
"sub.cancelConfirm1": "Biztosan le akarod mondani? A hozzáférésed aktív marad egészen",
"sub.cancelConfirm2": "Nincs visszatérítés.",
"sub.cancelConfirmBtn": "Lemondás megerősítése",
"sub.cancelTitle": "Előfizetésed lemondása",
"sub.cancelledToast": "Lemondás rögzítve.",
"sub.cguAnd": "és a",
"sub.cguDesc": "Kérjük, erősítsd meg a hozzájárulásodat a fizetés előtt.",
"sub.cguLink": "Felhasználási feltételek",
"sub.cguPay": "Fizetés folytatása",
"sub.cguPre": "Elolvastam és elfogadom a",
"sub.cguRequired": "El kell fogadnod a Felhasználási feltételeket és az Adatvédelmi irányelveket a folytatáshoz.",
"sub.cguSuffix": "a findloop-tól.",
"sub.cguTitle": "Az előfizetés véglegesítése",
"sub.expiresOn": "Előfizetésed lejárata",
"sub.noProrata": "Nincs arányos visszatérítés.",
"sub.privacyLink": "Adatvédelmi irányelvek",
"sub.renewsOn": "Előfizetésed megújul",
"sub.resume": "Újra előfizetek",
"sub.resumedToast": "Újra előfizetés megerősítve.",
"tier.free": "Ingyenes verzió",
"tier.large": "Vállalati",
"tier.medium": "Üzleti",
"tier.small": "Kezdő",
"tm.add": "Hozzáadás",
"tm.adminOpt": "Admin (teljes nézet)",
"tm.chooseEst": "Válassz egy létesítményt",
"tm.chooseEstPh": "Válassz egy létesítményt",
"tm.copyFail": "Másolás nem sikerült",
"tm.copyLink": "Link másolása",
"tm.copyOk": "Meghívó link másolva",
"tm.emailHint": "Meghívó e-mailt küldünk a jelszó létrehozásához.",
"tm.expiresOn": "lejár {date}-kor",
"tm.forEmail": " {email}-nek",
"tm.forbidden": "A csapathasználat fenntartva van a fiók tulajdonosa számára.",
"tm.inviteCreated": "Meghívó létrehozva",
"tm.inviteDesc": "A meghívó e-mail lehetővé teszi a csapattagnak, hogy létrehozza a jelszavát.",
"tm.invitePending": "Függőben lévő meghívó",
"tm.inviteResent": "Meghívó újraküldve",
"tm.inviteSent": "Meghívó elküldve e-mailben",
"tm.inviteTitle": "Tag meghívása",
"tm.invitedOn": "Meghívva: {date}",
"tm.linkExpired": "A link lejárt",
"tm.memberRemoved": "Tag eltávolítva",
"tm.name": "Név",
"tm.noMembers": "Még nincs csapattag.",
"tm.resendTitle": "Meghívó újraküldése",
"tm.role": "Szerep",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Tulajdonos",
"tm.roleStaff": "Személyzet",
"tm.roleUpdated": "Szerep frissítve",
"tm.sendInvite": "Meghívó küldése",
"tm.sending": "Küldés…",
"tm.staffOpt": "Személyzet (csak a saját létesítményét látja)",
"trk.at": "At",
"trk.badge": "Nyomkövetés",
"trk.carrier": "Fuvarozó",
"trk.codeValidated": "A kódot a partner hitelesítette",
"trk.dlProof": "Töltse le a kézbesítési igazolásomat (PDF)",
"trk.emailLabel": "Email (opcionális — a részletei megtekintéséhez)",
"trk.enterEmailCode": "Adja meg az említett e-mailt a kárigény kódjának megjelenítéséhez.",
"trk.idLabel": "Jelentés száma",
"trk.lostEmail": "Már nincs hozzáférésem az e-mailhez",
"trk.phonePh": "Az Ön telefonszáma",
"trk.photoBefore": "Az árucikk fotója a szállítás előtt",
"trk.recoverBtn": "Készítményem visszaállítása",
"trk.recoverHint": "Kérje a kárigény kódját SMS-ben a regisztrált számára.",
"trk.searching": "Keresés…",
"trk.secureRest": "Biztonságos kézbesítés",
"trk.send": "Küldés",
"trk.shipPending": "A szállítmány előkészítése — a nyomkövetési szám itt fog megjelenni, amint elküldik.",
"trk.shipTitle": "Szállítmány nyomkövetés",
"trk.showQr": "Mutassa meg ezt a QR-t a partnernek a kézbesítés érvényesítéséhez",
"trk.sigSaved": "Aláírás mentve",
"trk.signFirst": "Kérjük, írja alá a megerősítés előtt.",
"trk.signProof": "Írja alá a kézbesítési igazolását",
"trk.signSubmit": "Erősítse meg az aláírásomat és generálja a PDF-et",
"trk.submit": "Nyomkövetés",
"trk.subtitle": "Adja meg a jelentés számát a nyomon követéshez.",
"trk.title": "Jelentésem nyomkövetése",
"trk.trackShipment": "Csomag nyomkövetése",
"trk.trackingNo": "Nyomkövetési szám",
"trk.yourCode": "Az Ön kárigény kódja (a partnernek)",
"a.firstName": "Keresztnév",
"ac.emailCrossMatch": "B2C keresztellenőrzések",
"ac.emailCrossMatchDesc": "E-mail, amikor egy nyilvános elveszett tárgy hirdetés megegyezik az Ön helyszínén elhelyezett tárggyal",
"ac.emailCrossReject": "Nyilvános egyezések elutasítása",
"ac.emailCrossRejectDesc": "E-mailt kap, amikor egy vásárló jelzi, hogy egy javasolt nyilvános egyezés nem az ő tárgya.",
"ac.emailLoginNotif": "Bejelentkezési értesítés",
"ac.emailLoginNotifDesc": "E-mailt kap, amikor valaki bejelentkezik a fiókjába.",
"ad.closeNoCancel": "Nem, távolítsa el a hirdetést",
"ad.closeQuestion": "Vissza lett a tárgy neked adva?",
"ad.closeQuestionDesc": "Tudassa velünk, hogy visszanyerte-e a tárgyát, vagy csak el akarja távolítani ezt a hirdetést.",
"ad.closeYesRestituted": "Igen, a tárgy vissza lett adva",
"ad.closedRestituted": "Tárgy visszaadva — hirdetés lezárva 🎉",
"an.lostLoginDesc": "Fiók szükséges az elveszett tárgy bejelentéséhez és nyomon követéséhez.",
"an.lostLoginRequired": "Jelentkezzen be az elveszett tárgy bejelentéséhez",
"an.qfAll": "Minden",
"an.qfBoosted": "Fokozott",
"an.qfPhoto": "Képpel",
"an.qfRecent": "Ezen a héten",
"an.qfResolved": "Megoldott",
"an.restitutionInProgress": "Tárgy visszaadás alatt",
"dec.descPhLong": "Írja le a tárgyat: márka, szín, jellegzetes jegyek… (Minél több részletet ad meg, annál nagyobb az esélye a tárgy visszanyerésére)",
"dec.loadError": "Jelenleg nem lehet betölteni a partnert. Ellenőrizze a kapcsolatát és próbálja újra.",
"dec.retry": "Újrapróbálkozás",
"dec.shippingMode": "Szállítás",
"dep.photo2": "2. tárgy fénykép",
"dep.photo2Hint": "Opcionális — egy másik szög javítja a vizuális egyezés pontosságát.",
"dl.accountSuspended": "Fiók felfüggesztve egy nem kifizetett számla miatt. Rendezze, hogy helyreállítsa a hozzáférését.",
"dl.regularize": "Rendezze most →",
"dl.suspensionCountdown": "{num} nem kifizetett számla — a fiókja felfüggesztésre kerül {days} nap(nap) múlva. Rendezze, hogy elkerülje ezt.",
"ft.cancelConfirm": "Meg szeretné szüntetni a bejelentését? A tárgy tulajdonosát értesítjük.",
"ft.cancelDone": "Bejelentés megszüntetve.",
"ft.cancelLocked": "A törlés már nem lehetséges, miután a tulajdonos kifizette.",
"ft.cancelReport": "Bejelentésem megszüntetése",
"ft.claimCodeHelp": "Adja át ezt a kódot a találónak átadáskor, hogy megerősítse, hogy megkapta a tárgyát.",
"ft.claimCodeTitle": "Az Ön visszaadási kódja",
"ft.claimDone": "Tárgy visszaadva. Köszönjük, hogy a findloop-t használta!",
"ft.claimUnlockHint": "Oldja fel a találó elérhetőségi adatait",
"ft.claimUnlockHintSub": "Lépjen a \"Tárgyak, amiket érkelek\" menüpontra a fiókjában, hogy kifizethesse a díjat és megkaphassa az elérhetőségi adatokat.",
"ft.finderCodeShownHelp": "A tulajdonos kifizette és kiválasztott önt. Másolja ezt a kódot alább, hogy megerősítse a visszaadást — nincs szükség az e-mail ellenőrzésére.",
"ft.finderCodeShownTitle": "A tulajdonos érvényesítő kódja",
"ft.finderContactsTitle": "A Finder elérhetőségei",
"ft.foundCodeHelp": "Mutasd meg ezt a kódot a tulajdonosnak az átadásnál, hogy megerősítsd, hogy az előkerült tárgyat visszaadták.",
"ft.inProgressOther": "Tárgy visszaadása",
"ft.inProgressOtherHelp": "A tulajdonos másik findert választott erre a tárgyra. Nincs további teendőd.",
"ft.restitutionCodeHelp": "Ez a kód megerősíti a tárgy átadását. Az alábbiakban már előre ki van töltve; érvényesítsd, majd zárd le az ügyet.",
"ft.restitutionCodeTitle": "A te restitúción kódod",
"hc.14Digits": "14 számjegy",
"hc.15DaysBeforeAnItem": "15 nappal a tárgy jogi határideje előtt.",
"hc.7DaysBeforeAnItem": "7 nappal a tárgy jogi határideje előtt.",
"hc.8CharactersMinimum": "Minimum 8 karakter.",
"hc.aClaimToValidate": "Egy követelés érvényesítése",
"hc.aFindoAssistanceSessionIs": "Jelenleg aktív Findloop ügyfélszolgálati session van a fiókodban.",
"hc.aNewMatchHasBeen": "Új egyezés található",
"hc.aUser": "Egy felhasználó",
"hc.aUserClaimsToBe": "Egy felhasználó azt állítja, hogy ő a tulajdonos. Ellenőrizd a válaszaikat, mielőtt engedélyezed a visszaadást.",
"hc.aboutFindo": "A findloop-ról",
"hc.accountActivatedPleaseLogIn": "Fiók aktiválva, kérlek, jelentkezz be.",
"hc.accountActivation": "Fiók aktiválás",
"hc.accountCreated": "Fiók létrehozva!",
"hc.accountDeactivatedAReactivationEmail": "Fiók deaktiválva. Egy újraaktiváló emailt (30 napig érvényes) küldtünk neked.",
"hc.accountReactivation": "Fiók újraaktiválás",
"hc.activateMyAccount": "Aktiváld a fiókamat",
"hc.activateMyAdminAccount": "Aktiváld az admin fiókamat",
"hc.activating": "Aktiválás…",
"hc.activeMatchCancelReason": "Aktív egyezés. Az ügyfél lemondási oka: \"{reason}\". A tárgy még várja a követelést.",
"hc.activeMatchWithAPublic": "Aktív egyezés egy nyilvános (ügyfél) hirdetéssel. Várakozás a tulajdonos követelésére.",
"hc.addAPhoto": "Kép hozzáadása",
"hc.addAndConfigureYourEstablishments": "Add hozzá és konfiguráld az intézmények adataidat az \"Intézmények\" menüben: elérhetőségek, kategória és a tárgyak fizikális tárolása.",
"hc.addOnGoogle": "Hozzáadás a Google-hoz",
"hc.address": "Cím",
"hc.addressSaved": "Cím mentve",
"hc.addressStreet": "Cím — Utca",
"hc.adjustThePhoto": "A kép igazítása",
"hc.adminFullView": "Admin (teljes nézet)",
"hc.administratorOnly": "Csak adminisztrátor",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "AI vizuális összehasonlítás",
"hc.all": "Összes",
"hc.amount": "Összeg",
"hc.anOrganization": "Egy szervezet",
"hc.analyzing": "Elemzés…",
"hc.andRecoveryIs": "és a visszaállítás",
"hc.andTheDeclarationWillBe": "és a nyilatkozat le lesz zárva (történeti archívumba kerül). Ez a művelet végleges.",
"hc.annual20": "Éves -20%",
"hc.annualBilling20": "Éves számlázás (−20%)",
"hc.annualTarget": "Éves cél",
"hc.anyCommentsOptional": "Bármilyen megjegyzés? (opcionális)",
"hc.approveTheClaim": "A követelés jóváhagyása",
"hc.archiveCancelledConfirm": "Archiválja a(z) {n} \"Ügyfél által törölve\" listát? Ezek eltávolításra kerülnek a nyilvántartásból.",
"hc.asSoonAs": "Amint",
"hc.askTheOwnerToDisplay": "Kérje meg a tulajdonost, hogy mutassa meg a kód QR-ját (nyomkövető oldal).",
"hc.askThemAtTheCounter": "Kérje őket a pultnál, hogy erősítsék meg a személyazonosságot — soha nem nyilvánosan látható.",
"hc.assistance": "Támogatás",
"hc.assistanceSessionRevoked": "A támogatási sesszió visszavonva.",
"hc.atLeast6Characters": "Legalább 6 karakter",
"hc.automaticallyPreSelected": "automatikusan előre kiválasztva",
"hc.automaticallyWhenShipping": "automatikusan a szállítás során.",
"hc.awaitingClaim": "Várakozás a követelésre",
"hc.awaitingPayment": "Várakozás a kifizetésre",
"hc.b2cCustomer": "B2C ügyfél",
"hc.back": "Vissza",
"hc.backToHome": "Vissza a kezdőlapra",
"hc.backToMyAccount": "Vissza a fiókomhoz",
"hc.backToPayment": "Vissza a fizetéshez",
"hc.beforeAfterComparisonSlider": "Előtte/utána összehasonlító csúszka",
"hc.billingInformation": "Számlázási információ",
"hc.billingInformationSaved": "Számlázási információ mentve ✓",
"hc.brand": "Márka",
"hc.bronze": "Bronz",
"hc.calculatingTheShippingRate": "A szállítási díj kiszámítása…",
"hc.cameraUnavailableEnterTheCode": "A kamera nem elérhető. Kérjük, írja be a kódot kézzel.",
"hc.cancel": "Törlés",
"hc.cancelMyDeclaration": "Nyilatkozatom törlése",
"hc.cancelSavedFmt": "Törlés mentve: \"{reason}\". Még mindig igényelheti.",
"hc.cancelTheDeposit": "A betét törlése",
"hc.cancelThisMatch": "Ez a mérkőzés törlése",
"hc.cancellationReason": "Törlési ok",
"hc.cancelled": "Törölve",
"hc.cancelledByTheCustomer": "Ügyfél által törölve",
"hc.cannotOpenPayment": "A kifizetés nem nyitható meg. Kérjük, próbálja újra.",
"hc.careers": "Karrier",
"hc.carrier": "Szállító",
"hc.carrierAvailabilityCannotBeChecked": "A szállító elérhetősége nem ellenőrizhető, amíg a Sendcloud feladó nincs konfigurálva.",
"hc.carrierConfirmedCharged": "Szállító megerősítve – {price} € levonva az ügyféltől",
"hc.carrierOther": "Szállító (más)",
"hc.carrierSelection": "Szállító kiválasztása",
"hc.caseClosedThankYou": "Az ügy lezárva. Köszönjük!",
"hc.category": "Kategória",
"hc.changeMethod": "Módszer megváltoztatása",
"hc.characteristic": "Jellemző",
"hc.chargedToCustomer": "levonva az ügyféltől.",
"hc.checkOrEditYourDetails": "Ellenőrizze vagy módosítsa a részleteit a biztonságos fizetés előtt.",
"hc.checkStatisticsToTrackDeposited": "Ellenőrizze a \"Statisztikát\" a letett tételek, a visszaküldési arány és az egyes helyek teljesítményének nyomon követéséhez.",
"hc.checkTheDetailsBeforeContacting": "Ellenőrizze a részleteket a keresővel való kapcsolatfelvétel előtt.",
"hc.checkTheDetailsBelowBefore": "Ellenőrizze az alábbi részleteket, mielőtt megkezdené a visszaküldési kérelmét.",
"hc.checkTheNewItem": "Ellenőrizze az új tételt",
"hc.checkThePhotosAndCharacteristics": "Ellenőrizze az alábbi fényképeket és jellemzőket, mielőtt folytatná a visszaszerzést.",
"hc.chooseACountry": "Válasszon egy országot",
"hc.chooseANewPassword": "Válasszon egy új jelszót",
"hc.chooseAReason": "Válasszon egy okot",
"hc.chooseTheLegalRetentionAlerts": "Válassza ki a jogi megőrzési figyelmeztetéseket, amelyeket e-mailben kap",
"hc.chooseYourPasswordToAccess": "Válassza ki a jelszavát a rendszeradminisztrációs konzol eléréséhez.",
"hc.city": "Város",
"hc.claimApproved": "Követelés jóváhagyva",
"hc.claimApproved2": "Követelés jóváhagyva.",
"hc.claimCodeExpired": "A követelési kód lejárt",
"hc.claimCodeVerified": "A követelési kód ellenőrizve",
"hc.claimNotFound": "A követelés nem található",
"hc.claimNotValidated": "A követelés nem érvényesítve",
"hc.claimRejected": "A követelés elutasítva",
"hc.claimRejected2": "A követelés elutasítva.",
"hc.claimValidated": "A követelés érvényesítve",
"hc.claimValidatedByThePartner": "A követelés érvényesítve a partner által",
"hc.claimant": "Követelő",
"hc.claimsToBeTheOwner": "azt állítja, hogy ő a tétel tulajdonosa, és válaszolt a verifikációs kérdésekre. Csak akkor hagyja jóvá, ha a válaszok egyeznek.",
"hc.claimsToValidate": "Érvényesítendő követelések",
"hc.clear": "Törlés",
"hc.clickToZoom": "Kattintson a zoomoláshoz",
"hc.close": "Bezárás",
"hc.close2": "Bezárás",
"hc.closeTheDeclaration": "Zárja le a nyilatkozatot",
"hc.closeTheDeclaration2": "Zárja le a nyilatkozatot?",
"hc.codeAlreadyVerified": "A kód már ellenőrizve",
"hc.codeCopied": "A kód másolva",
"hc.collapse": "Összecsuk",
"hc.color": "Szín",
"hc.company": "Cég",
"hc.companyName": "Cég neve",
"hc.comparePhotos": "Képek összehasonlítása",
"hc.compareThemWithTheOwner": "Hasonlítsa össze a tulajdonos válaszaival - soha nem nyilvánosan látható.",
"hc.condition": "Állapot",
"hc.confirmAndPay": "Megerősítés és fizetés",
"hc.confirmCancellation": "Megerősíti a lemondást",
"hc.confirmCrop": "Megerősíti a vágást",
"hc.confirmDeletion": "Megerősíti a törlést",
"hc.confirmPassword": "Jelszó megerősítése",
"hc.confirmThatThisIsYour": "Megerősítse, hogy ez az öné. A megtalálótól személyazonossági ellenőrzést kérünk a kapcsolatfelvétel előtt.",
"hc.confirmTheCarrier": "Megerősíti a fuvarozót",
"hc.confirmThePassword": "Jelszó megerősítése",
"hc.confirmYourShippingAddressTo": "Erősítse meg a szállítási címét a folytatáshoz.",
"hc.confirmYourSubscription": "Megerősíti az előfizetését",
"hc.confirmed": "Megerősítve ✓",
"hc.contactFindoToGetYour": "Vegye fel a kapcsolatot a Findoval, hogy megkapja a Feladóazonosítóját.",
"hc.contactUs": "Kapcsolatfelvétel",
"hc.continueTheReturn": "Folytassa a visszaküldést",
"hc.continueToPayment": "Folytatás a fizetéshez",
"hc.copy": "Másolás",
"hc.correctMyDetails": "javítsa ki az adataimat",
"hc.correctThisEntry": "Javítani szeretné ezt a bejegyzést?",
"hc.country": "Ország",
"hc.countryAddress": "Ország (cím)",
"hc.countryIsoCodeEG": "Ország (ISO kód, pl. FR)",
"hc.cover": "borító",
"hc.createTheShipment": "A szállítmány létrehozása",
"hc.cropThePhoto": "Vágja le a fényképet",
"hc.customer": "Vásárló",
"hc.customerClaimCodeToCheck": "Vásárlói igénykód - ellenőrzés a felvétel során:",
"hc.customerReasonFmt": "Vásárló oka: \"{reason}\".",
"hc.customerReminderDelay": "Vásárlói emlékeztető késleltetés",
"hc.customerWhosePublicListingMatches": "Vásárló, akinek nyilvános hirdetése megegyezik ezzel a tétellel - csak Önnek látható.",
"hc.d15": "D-15",
"hc.dangerZone": "Veszélyzóna",
"hc.date": "Dátum",
"hc.dateNewest": "Dátum (legújabb)",
"hc.dateOldest": "Dátum (legelején)",
"hc.daysToYearEnd": "{n} nap az év végéig",
"hc.deadlineAlert": "Határidő figyelmeztetés",
"hc.declarationClosed": "Nyilatkozat lezárva ✓",
"hc.declarationNotFound": "Nyilatkozat nem található.",
"hc.declarationNotFound2": "Nyilatkozat nem található",
"hc.declarationTracking": "Nyilatkozat nyomon követése",
"hc.defaultCarrier": "Alapértelmezett szolgáltató",
"hc.defaultCarrierPreselected": "Alapértelmezett szolgáltató előre kiválasztva — megváltoztatható erre a szállításra. Aktuális díj (Sendcloud + {m}% haszon).",
"hc.defaultCarrierRemoved": "Alapértelmezett szolgáltató eltávolítva",
"hc.delayHours": "Késleltetés (órák)",
"hc.deleteMyAccount": "Fiókom törlése",
"hc.deleting": "Törlés…",
"hc.deletingDeactivatesYourAccountLogin": "A törlés deaktiválja a fiókját: a bejelentkezés blokkolva van, és az adatok 30 napig megmaradnak. E-mailt fog kapni egy újraaktiváló linkkel, amely 30 napig érvényes.",
"hc.delivered": "Kézbesítve",
"hc.depositAnItem": "Tétel letétkezelése",
"hc.depositCancelledItemPutBack": "Letét törölve — tétel visszatéve a raktárba.",
"hc.depositCancelledItemRemovedFrom": "Letét törölve — tétel eltávolítva a nyilvántartásból.",
"hc.depositedOn": "Letétbe helyezve:",
"hc.describeTheItemBrandColor": "Jellemezze a tételt: márka, szín, megkülönböztető jelölések… (Minél részletesebb információt ad, annál jobb esélyei vannak a tétel megtalálására)",
"hc.dimensionsCm": "Méretek (cm)",
"hc.disablingAnEmail": "E-mail letiltása",
"hc.doesNotHide": "nem rejt el",
"hc.download": "Letöltés",
"hc.downloadThePdf": "PDF letöltése",
"hc.draftRestoredPickUpYour": "Vázlat visszaállítva — vegye fel a nyilatkozatát ott, ahol abbahagyta.",
"hc.dragToReposition": "Húzza az újrapozicionáláshoz",
"hc.eGColisPriv": "Pl. Colis Privé",
"hc.eachItemGetsAQr": "Minden tétel QR címkét kap. Szkennelje be a \"Készlet & QR\" menüpontból, hogy azonnal megtaláljon egy tételt.",
"hc.eachSiteManagesItsOwn": "Minden hely saját banki ügyeit kezeli. Menjen a",
"hc.edit": "Szerkesztés",
"hc.emailNotificationPreferences": "E-mail értesítési preferenciák",
"hc.emailPreferencesUpdated": "E-mail preferenciák frissítve",
"hc.enableOrDisableRecoveryFees": "Helyezze üzembe vagy tiltsa le a visszaszerzési díjakat",
"hc.enlargePhoto": "Kép nagyítása",
"hc.enterTheCustomerSCode": "Adja meg a vásárló kódját",
"hc.estShipRate": "Becsült szállítási díj (Sendcloud + {m}% haszon):",
"hc.establishment": "Létrehozás",
"hc.establishment2": "Létrehozás:",
"hc.establishmentInItsSendcloudAccount": "létrehozás a Sendcloud fiókjában, és megadja a feladó azonosítót",
"hc.establishmentSettings": "Létrehozás beállításai",
"hc.exCode": "pl. ABCD2345",
"hc.exId": "pl. 3f2a…",
"hc.exit": "Kilépés",
"hc.explainWhyThisItemIs": "Magyarázd el, miért nem a tiéd ez a tétel…",
"hc.externalPaymentLinks": "Külső fizetési linkek",
"hc.failed": "Sikertelen",
"hc.feesEnabled": "Díjak engedélyezve",
"hc.field": ") mező.",
"hc.finderAcceptedCloseTheCase": "Finder elfogadta — zárd le az ügyet, miután a tételt személyesen átadták.",
"hc.findoCityRanking": "Findloop — Városi rangsor",
"hc.findoForEstablishments": "Findloop létrehozások számára",
"hc.findoPresentationVideo": "Findloop bemutató videó",
"hc.findoRegistersTheAddressOf": "Findloop regisztrálja a címet a(z)",
"hc.findoReviewShare": "Findloop {year} értékelés: {n} tétel visszaküldve, {rate}% visszaküldési arány 🎉",
"hc.firstVerifyTheClaimCode": "Először ellenőrizd a fenti kárigény kódot",
"hc.forEveryNewShipmentFrom": "minden új küldeményhez",
"hc.free": "ingyenes",
"hc.freeRecovery0": "Ingyenes visszaszerzés (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Ingyenes visszaszerzés Afrikában – Bevezető ajánlat",
"hc.freeRecoveryFeesDisabled0": "Ingyenes visszaszerzés: díjak letiltva (0 €)",
"hc.fromTeamInviteYourColleagues": "\"Csapat\"-ból, hívd meg kollégáidat e-mailben és rendelj nekik létrehozást. Minden tag csak a saját területét látja.",
"hc.fullName": "Teljes név",
"hc.fullPhoto": "Teljes fotó",
"hc.gallery": "Galéria",
"hc.giveTheReasonForCancelling": "Add meg a lemondás okát. A partner értesítést kap.",
"hc.goToLogin": "Lépj a bejelentkezéshez",
"hc.goToMyAccount": "Lépj a fiókomhoz",
"hc.gold": "Arany",
"hc.googleLoginFailed": "A Google bejelentkezés sikertelen",
"hc.hasConfirmedYourPaymentYou": "megerősítette a fizetésed, automatikusan átirányítanak",
"hc.helpCenter": "Súgó központ",
"hc.helpUsImproveWhyAre": "Segíts nekünk fejlődni: miért távozol? A fiókod deaktiválva lesz, és 30 napig újraaktiválható.",
"hc.hidePassword": "Jelszó elrejtése",
"hc.high": "Magas",
"hc.historyOfYourMonthlySubscriptions": "A havi előfizetéseid története és azok fizetési állapota.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Hogyan állíthatom be a számjegy Sender ID-t?",
"hc.iDonTUseIt": "Nem használom eléggé",
"hc.iFoundItElsewhere": "Máshol találtam",
"hc.iNoLongerNeedMy": "Már nincs szükségem az áruimra",
"hc.identityVerification": "Személyazonosítás",
"hc.idleLogoutIn": "Inaktivitás miatt {n} másodperc múlva kijelentkezik.",
"hc.ifProvidedTheVolumetricWeight": "Ha megadták, a köbméter súlyt használják.",
"hc.ifThePartnerHasNot": "Ha a partner nem erősítette meg a külső kifizetést ezen időtartam után, a Findloop automatikusan emlékezteti a partnert annak érvényesítésére.",
"hc.impersonationEnded": "Az álruha véget ért.",
"hc.impersonationMode": "Álruha mód",
"hc.impersonationSessionExpired": "Az álruha session lejárt.",
"hc.inTheField": ", a területen",
"hc.inTransit": "Folyamatban",
"hc.inclVat": "áfával együtt",
"hc.intraEuVatNumberOptional": "Belföldi EU áfa szám opcionális, SIRET nem szükséges (Franciaországon kívül).",
"hc.invalidInvitationLink": "Érvénytelen meghívó link.",
"hc.invalidInvitationLink2": "Érvénytelen meghívó link",
"hc.invalidInviteLink": "Érvénytelen vagy lejárt meghívó link.",
"hc.invalidNumberEnterAnInternational": "Érvénytelen szám. Kérjük, adjon meg egy nemzetközi számot, pl. +36 30 123 45 67.",
"hc.invalidOrExpiredLink": "Érvénytelen vagy lejárt link.",
"hc.invalidOrExpiredReactivationLink": "Érvénytelen vagy lejárt aktiváló link",
"hc.invalidSendcloudId": "Érvénytelen Sendcloud azonosító",
"hc.inviteSubtitle": "{org} meghív téged, hogy csatlakozz a Findloop csapatához. Válaszd ki a jelszavadat a fiókod aktiválásához.",
"hc.isAvailableOnSendcloudFor": "elérhető a Sendcloud-on minden útvonaladra (belföldi + nemzetközi).",
"hc.isNotEnabledOnYour": "nem engedélyezett a Sendcloud fiókodban bizonyos célállomásokra. A címkék azokhoz egy másik elérhető fuvarozóval készülnek.",
"hc.isThisReallyYourItem": "Ez tényleg a te árud?",
"hc.isThisYourItem": "Ez a te árud?",
"hc.item": "Áru",
"hc.itemAlreadyConfirmed": "Az áru már megerősítve",
"hc.itemDetails": "Áru részletei",
"hc.itemFoundAt": "Áru található itt:",
"hc.itemFoundAtAPartner": "Áru található egy partnernél",
"hc.itemMarkedAsReturned": "Az áru visszaként megjelölve ✓",
"hc.itemPhotoRequiredBeforeShipping": "Árufotó (szükséges a szállítás előtt)",
"hc.itemPhotoSaved": "Árufotó mentve",
"hc.itemPreview": "Áru előnézet",
"hc.itemPutBackInStorage": "Áru visszahelyezve a raktárba.",
"hc.itemWeight": "Áru súlya:",
"hc.itemsReturned": "áruk visszaküldve",
"hc.itemsReturnedThisYear": "áruk visszaküldve idén",
"hc.itemsWhoseLegalDeadlineIs": "Terméke, amelynek jogi határideje 15 nap múlva van, vagy korábban (határidőn túli is). A találatok továbbra is láthatók.",
"hc.kbisNumber": "Kbis szám",
"hc.keysForgottenOnABench": "Padon felejtett kulcsok",
"hc.labelBeingGenerated": "Címke készítése folyamatban",
"hc.leaveTheFieldsEmptyTo": "Hagyja üresen a mezőket a díjmentes helyreállítás érdekében.",
"hc.legalNotice": "Jogi értesítés",
"hc.limitReachedUpgradeToA": "Limit elérve — frissítsen egy magasabb csomagra",
"hc.linkCopiedShareOn": "Hivatkozás másolva — ossza meg itt: {label}",
"hc.linkUnavailable": "Hivatkozás nem elérhető",
"hc.linkedTo": "Kapcsolódik",
"hc.listingHiddenByModeration": "Hirdetés rejtve van a moderáció által.",
"hc.loading": "Betöltés…",
"hc.locateMe": "Helyezz el",
"hc.logIn": "Bejelentkezés",
"hc.logInToGetBack": "Bejelentkezés a saját területedhez és az előfizetés kezelése érdekében.",
"hc.loginFailed": "Bejelentkezés sikertelen",
"hc.lostFoundPlatform": "Tárgyak elvesztése és megtalálása platform.",
"hc.lostIn": "elveszett itt: ",
"hc.lowRate": "Alacsony díj",
"hc.mainReason": "Fő indok",
"hc.mainStreet": "Fő utca",
"hc.makeSureThisIsThe": "Győződjön meg róla, hogy ez az az elem, amit elvesztett, mielőtt feloldaná a megtaláló elérhetőségeit.",
"hc.manageCookies": "Sütik kezelése",
"hc.manageMyTeam": "Csapatom kezelése",
"hc.manageYourTeam": "Csapat kezelése",
"hc.markAsReturned": "Megjelölés visszaként",
"hc.matchNoClaimInTime": "A találat határidőn belül nem kapott igényt.",
"hc.matchNotFound": "Találat nem található",
"hc.medium": "Közepes",
"hc.milestoneFmt": "{m} visszaküldött termék határérték elérve! Úton {next} felé.",
"hc.missingFeatures": "Hiányzó funkciók",
"hc.monthly": "Havi",
"hc.monthlyBilling": "Havi számlázás",
"hc.moveThePhotoToFit": "Mozgassa a fényképet, hogy beleférjen a körbe.",
"hc.myAccount": "Saját fiókom",
"hc.myInvoices": "Saját számláim",
"hc.myMonthlyInvoices": "Havi számláim",
"hc.nArchived": "{n} hirdetés archiválva.",
"hc.newCodeGeneratedAndSent": "Új kód generálva és elküldve az ügyfélnek e-mailben és SMS-ben",
"hc.newCodeGeneratedAndSent2": "Új kód generálva és elküldve a tulajdonosnak",
"hc.newPassword": "Új jelszó",
"hc.next": "Következő",
"hc.nextPhoto": "Következő fotó",
"hc.no": "Nem",
"hc.noAnswerProvided": "Nincs megadva válasz.",
"hc.noArchivedDeclarations": "Nincs archivált nyilatkozat",
"hc.noCountryFound": "Nincs ország megtalálva",
"hc.noDeclarations": "Nincs nyilatkozat",
"hc.noFeesAreChargedTo": "Nincs díj az ügyféltől.",
"hc.noInvoiceYet": "Még nincs számla.",
"hc.noInvoiceYetYourInvoices": "Még nincs számla. A számláid automatikusan itt jelennek meg minden egyes kifizetés után.",
"hc.noMatchIsAvailableFor": "Jelenleg nincs elérhető találat. Azonnal értesítünk, amint egy tétel megfelel a nyilatkozatodnak.",
"hc.noShipmentMatchesYourSearch": "Nincs szállítmány, amely megfelelne a keresésednek.",
"hc.noShipmentsYet": "Még nincs szállítmány.",
"hc.noShipmentsYet2": "Még nincs szállítmány",
"hc.none": "nincs",
"hc.noneChooseForEachShipment": "Nincsen (válaszd ki minden szállítmányhoz)",
"hc.notMine": "Ez nem az enyém",
"hc.of": "ból/ből",
"hc.only": "Csak",
"hc.onlyEachSiteManagesIts": "csak. Minden webhely saját banki működését kezeli: ezek a linkek nem befolyásolják a többi intézményt.",
"hc.onlyTheOwnerOrAn": "Csak a tulajdonos vagy egy adminisztrátor tudja konfigurálni az intézmény fizetési linkjeit.",
"hc.openDepositInTheMenu": "Nyisd meg a \"Betét\" menüpontot, írd le a tételt és készíts egy fotót. Azonnal tárolva lesz és kész a visszaszolgáltatásra.",
"hc.openSettings": "Beállítások megnyitása →",
"hc.openTheDeclarationToManage": "Nyisd meg a nyilatkozatot a szállítmány kezeléséhez",
"hc.optional": "— nem kötelező",
"hc.optional2": "(nem kötelező)",
"hc.optional3": "nem kötelező",
"hc.originalListingPhotoUsed": "Eredeti hirdetési fénykép használva",
"hc.other": "Más",
"hc.other2": "Más…",
"hc.ourProducts": "Termékeink",
"hc.overallRateTrendLast6": "Átlagos ártrend (utolsó 6 hónap)",
"hc.ownerSClaimCode": "Tulajdonos igénykódja",
"hc.ownershipConfirmed": "Tulajdonjog megerősítve",
"hc.paid": "Kifizetve",
"hc.paidOn": "Kifizetve:",
"hc.paidViaPartner": "Fizetve (partneren keresztül)",
"hc.parcelBeingPrepared": "Csomag előkészítése",
"hc.parcelDelivered": "Csomag kézbesítve",
"hc.parcelShipped": "Csomag úton",
"hc.parisGareDeLyon": "Párizs, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Partnerjegyzék",
"hc.passedOnToTheCustomer": "— továbbítva az ügyfélnek a fizetési linken.",
"hc.password": "Jelszó",
"hc.passwordResetPleaseLogIn": "Jelszó visszaállítása, kérjük, jelentkezzen be.",
"hc.passwordUpdated": "Jelszó frissítve.",
"hc.passwordsDoNotMatch": "A jelszavak nem egyeznek.",
"hc.pasteThisSenderIdIn": "Illessze be ezt a Feladó azonosítót a Findloop → Beállításokba",
"hc.payForTheShipmentOf": "Fizessen az Ön árujának szállításáért a Findloop segítségével, biztonságos fizetéssel.",
"hc.payTheRecoveryFees": "Fizesse meg a helyreállítási díjakat",
"hc.payTheShippingFees": "Fizesse meg a szállítási díjakat",
"hc.payment": "Fizetés",
"hc.paymentAlreadyConfirmedByThe": "A fizetés már megerősítve a partner által",
"hc.paymentLinksAreNowConfigured": "A fizetési linkek most már be vannak állítva intézményenként",
"hc.paymentNotCompletedYourAccount": "A fizetés nem fejeződött be, az Ön fiókja még nem jött létre — kérjük, próbálja újra.",
"hc.paymentReceived": "Fizetés megérkezett",
"hc.paymentSuccessful": "Fizetés sikeres!",
"hc.pdfInvoice": "PDF számla",
"hc.pending": "Függőben",
"hc.period": "Időszak",
"hc.phoneNumber": "Telefonszám",
"hc.phoneOptional": "Telefon (nem kötelező)",
"hc.planAt": "terv itt",
"hc.planLimitFmt": "A(z) \"{plan}\" terv korlátozva van {max} intézményre. {n} helyszín kezeléséhez ajánljuk a",
"hc.platformReturnTarget": "Platform visszatérítési cél",
"hc.pleaseCompleteYourShippingAddress": "Kérjük, töltse ki a szállítási címét.",
"hc.pleaseProvideAPhoneNumber": "Kérjük, adjon meg egy telefonszámot: ez kötelező a fuvarozó számára a szállításhoz.",
"hc.pleaseProvideAReason": "Kérjük, adjon meg egy okot.",
"hc.pleaseSetYourOwnPassword": "kérjük, állítson be saját jelszót a folytatáshoz.",
"hc.pointsToGoal": "{n} további pont a közös célunk eléréséhez.",
"hc.posterPreview": "Plakát előnézet",
"hc.potentialMatchBeingVerified": "Potenciális egyezés ellenőrzés alatt",
"hc.potentialOwner": "Potenciális tulajdonos",
"hc.preFilledAutomaticallyYouCan": "Automatikusan kitöltve — helyettesítheti egy fényképpel a csomagról.",
"hc.pressKit": "Sajtócsomag",
"hc.previewMode": "Előnézeti mód:",
"hc.previewOfThePrintReady": "Előnézet a nyomtatásra kész A4-es poszterről e létesítmény számára.",
"hc.previous": "Előző",
"hc.previousPhoto": "Előző fénykép",
"hc.primary": "elsődleges",
"hc.printThePoster": "Nyomtasd ki a posztert",
"hc.privacy": "Adatvédelem",
"hc.privacyPolicy": "Adatvédelmi irányelvek",
"hc.processedCasesWillAppearHere": "A feldolgozott esetek itt fognak megjelenni.",
"hc.proofOfReturnPdf": "Visszaküldés igazolása (PDF)",
"hc.protectedByRecaptcha": "reCAPTCHA védi",
"hc.publicMatch": "Nyilvános mérkőzés",
"hc.putBackInStorage": "Visszakerül a tárolásba",
"hc.pwdResetByTeam": "A jelszavadat a csapatunk állította vissza. Biztonságod érdekében,",
"hc.questionsToAskTheOwner": "Kérdések a tulajdonoshoz",
"hc.rateChargedToTheCustomer": "Ügyfélnek felszámított díj:",
"hc.rateOfTarget": "{rate}% elérve a {target}% célnak",
"hc.reached": "elérve",
"hc.reactivating": "Újraaktiválás…",
"hc.reasonSavedYouCanStill": "Ok eltárolva. Még mindig igényelheted az tételt.",
"hc.recentMatchesFirst": "Legutóbbi mérkőzések először",
"hc.recognizedThePhotoYouSent": "felismerte a általad küldött fényképet és ezekkel a jellemzőkkel írta le. Csak akkor erősítsd meg, ha egyeznek az általad birtokolt tárggyal.",
"hc.recommended": "Ajánlott",
"hc.recoveryFees": "Visszaszerzési díjak",
"hc.recoveryFeesArePaidDirectly": "A visszaszerzési díjak közvetlenül a partnerlétesítménynek vannak fizetve. A Findloop nem kap díjat az ügyfelektől.",
"hc.recoveryFeesEnabled": "Visszaszerzési díjak engedélyezve",
"hc.recoveryOfferedByTheEstablishment": "Visszaszerzés a létesítmény által — a Findloop nem számít fel díjat.",
"hc.recoveryPaymentLink": "Visszaszerzési kifizetési link",
"hc.recoveryPaymentLinkSavedFor": "Visszaszerzési kifizetési link eltárolva e létesítmény számára",
"hc.redirecting": "Átirányítás…",
"hc.redirectingToPayment": "Átirányítás a kifizetéshez…",
"hc.redirectingToTheRecoveryOf": "Átirányítás a tárgyad visszaszerzésére…",
"hc.regenerateAndResendToThe": "Újragenerálás és újraküldés a tulajdonosnak",
"hc.regenerateTheCode": "A kód újragenerálása",
"hc.registerAFoundItem": "Talált tétel regisztrálása",
"hc.rejectTheClaim": "A követelés elutasítása",
"hc.reminderDelaySaved": "Emlékeztető késleltetése elmentve",
"hc.reopenThePaymentLink": "A kifizetési link újra megnyitása",
"hc.repeatThePassword": "A jelszó ismétlése",
"hc.reportAProblem": "Hiba bejelentése",
"hc.reportDismissedYourListingRemains": "A bejelentés elutasítva. Az ön hirdetése nyilvános marad.",
"hc.requiredUsedToCalculateThe": "Szükséges: a Sendcloud szállítási díj kiszámításához. Szállítás 30 kg felett nem elérhető.",
"hc.reset": "Visszaállítás",
"hc.resume": "Folytatás",
"hc.resumeRegistration": "Regisztráció folytatása",
"hc.retro": "Évértékelés",
"hc.returnSecurity": "Visszatérési garancia",
"hc.returnToTheOwner": "Visszatér a tulajdonoshoz",
"hc.returned": "visszatérés",
"hc.reviewTheItemDetails": "A tétel részleteinek átnézése",
"hc.revokeAccess": "Hozzáférés visszavonása",
"hc.role": "Szerep:",
"hc.save": "Mentés",
"hc.save2": "mentés",
"hc.saveAndContinue": "Mentés és folytatás",
"hc.saving": "Mentés…",
"hc.scanTheClaimCode": "Olvassa be a reklamációs kódot",
"hc.scanTheOwnerSQr": "Olvassa be a tulajdonos QR-kódját",
"hc.scrollThroughLanguages": "Böngésszen a nyelvek között",
"hc.searchByCustomerItemOr": "Keresés vevő, tétel vagy nyomon követési szám alapján…",
"hc.searchForACountry": "Keresés egy országra…",
"hc.secureFindoVerification": "Biztonságos Findloop ellenőrzés",
"hc.seeRetro": "Nézze meg az évértékelést",
"hc.selectedCarrier": "Kiválasztott fuvarozó:",
"hc.selectedPlan": "Kiválasztott terv",
"hc.send": "Küldés",
"hc.sendcloudSenderIdSaved": "Sendcloud feladó ID mentve",
"hc.sendcloudSenderIdSenderId": "Sendcloud feladó ID (sender_id)",
"hc.sending": "Küldés…",
"hc.sessionExpired": "A munkamenet lejárt",
"hc.setUpYourEstablishments": "Állítsa be a létesítményeit",
"hc.settings": "Beállítások",
"hc.settingsSubtitle": "Külső fizetések és emlékeztetők, létesítményenként beállítva.",
"hc.shareFoundText": "Találtam egy tárgyat – segíts nekem megtalálni a tulajdonosát a findo-n",
"hc.shareLostText": "Elvesztettem egy tárgyat – segíts nekem megtalálni a findo-n",
"hc.sharePreview": "Megosztás előnézet",
"hc.shareTheRanking": "A rangsor megosztása",
"hc.shareYourQrCodeTo": "Ossza meg a QR-kódját, hogy nyilatkozatokat kapjon.",
"hc.shipRateAutoWeight": "A szállítási díjat automatikusan a Sendcloud számítja ki (súly {w}) a szállítás idején.",
"hc.shipRateForWeight": "Szállítási díj (Sendcloud + {m}% haszon) a(z) {w} számára:",
"hc.shipments": "Küldemények",
"hc.shipmentsSubtitle": "A létesítmény összes küldeményének konszolidált nézete, minden esetben. Kattintson egy sorra a küldemény kezeléséhez a nyilatkozatában.",
"hc.shipping": "Szállítás",
"hc.shippingAddress": "Szállítási cím",
"hc.shippingFeesAreHandledAutomatically": "A szállítási díjakat automatikusan kezeli a Findloop (Sendcloud) — nincs hova belépni.",
"hc.shippingFeesHaveAlreadyBeen": "A szállítási díjak már kifizetésre kerültek: a fuvarozót már nem lehet megváltoztatni.",
"hc.shippingNotAvailableForItems": "A szállítás nem elérhető 30 kg feletti tételek esetén. Az ügyfélnek személyesen kell átvennie az árut.",
"hc.shippingPaid": "Szállítás kifizetve ✓",
"hc.showOnlyItemsMatchingA": "Csak a nyilvános (ügyfél) listázásnak megfelelő tételek megjelenítése",
"hc.showPassword": "Jelszó megjelenítése",
"hc.signInTheBoxAbove": "Jelentkezzen be a fenti mezőben",
"hc.signatureSaved": "Aláírás mentve",
"hc.signedInWithGoogle": "Bejelentkezett Google-lal",
"hc.signupFailed": "A regisztráció sikertelen",
"hc.silver": "Ezüst",
"hc.simulatedRatesInPreProduction": "(szimulált árak előgyártás alatt)",
"hc.siretAndVatNumberRequired": "SIRET és áfa szám szükséges (Franciaország).",
"hc.skip": "Átugrás",
"hc.smsSentIfAccount": "Ha létezik fiók ezzel a számmal, SMS-t küldtünk Önnek.",
"hc.sortItemsWithAPublic": "Rendezés: nyilvános egyezést tartalmazó tételek (legutóbbiak) előre",
"hc.specifyWhetherYouRecoveredYour": "Határozza meg, hogy visszaszerezte az árut, vagy egyszerűen csak el szeretné távolítani ezt a hirdetést.",
"hc.specifyYourReason": "Adja meg okát",
"hc.specifyYourReason2": "Adja meg okát…",
"hc.staff": "Személyzet",
"hc.status": "Állapot",
"hc.staySignedIn": "Maradjon bejelentkezve",
"hc.step": "Lépés",
"hc.stillThere": "Még mindig ott van?",
"hc.stopScrolling": "Görgetés leállítása",
"hc.storeFindWithQr": "Tárolás & keresés QR-kóddal",
"hc.streetName": "Utcaneve",
"hc.streetNo": "Házszám",
"hc.switchTo": "Váltás erre",
"hc.switchToDarkMode": "Váltás sötét módra",
"hc.switchToLightMode": "Váltás világos módra",
"hc.takeAPhoto": "Készítsen egy fényképet",
"hc.takeChangeThePhoto": "Készítsen / cserélje le a fényképet",
"hc.takenFromYourDeclaration": "átvéve az Ön nyilatkozatából",
"hc.target": "Cél",
"hc.targetReached": "Cél elérve",
"hc.targetReachedThankYouTo": "Cél elérve — köszönet a teljes Findloop közösségnek!",
"hc.tellUsMore": "Mondj többet…",
"hc.tellUsWhyYouCancel": "Mondd el, miért mondod le. Ez segít a partnernek feldolgozni a kérésed.",
"hc.tellUsWhyYourListing": "Mondd el, miért. A listázásod aktív marad, és még mindig igényelheted az tárgyadat.",
"hc.termsAndConditions": "Felhasználási feltételek",
"hc.termsAndPolicies": "Feltételek és szabályzatok",
"hc.thankYouForYourFeedback": "Köszönjük a visszajelzésed",
"hc.theBannerDisplayedInThe": "a banner, amely a nyilvántartásban van megjelenítve.",
"hc.theClaimantHasBeenInformed": "A kérelmezőt tájékoztatták. A tárgy továbbra is elérhető a nyilvános listában.",
"hc.theClaimantHasBeenNotified": "A kérelmezőt értesítették, és most folytathatja a visszautalást.",
"hc.theCustomerPaysTheFees": "A vevő fizeti a díjakat az üzlethelyiségnek.",
"hc.theDayTheLegalRetention": "A nap, amikor a jogi visszatartási időszak véget ér.",
"hc.theEstablishmentConsideredThatThis": "Az üzlethelyiség úgy ítélte meg, hogy ez a tárgy nem a tiéd.",
"hc.theEstablishmentIsReviewingYour": "Az üzlethelyiség felülvizsgálja a válaszaidat. Értesítve leszel, amint a kérelmedet érvényesítik, akkor a visszaállítási díjat ki tudod fizetni.",
"hc.theFeesAreTooHigh": "A díjak túl magasak",
"hc.theFinderConsideredThatThis": "A megtaláló úgy ítélte meg, hogy ez a tárgy nem a tiéd.",
"hc.theFinderIsReviewingYour": "A megtaláló felülvizsgálja a kérelmedet. Értesítve leszel, amint érvényesítik.",
"hc.theItem": "A tárgy",
"hc.theItemWillBeRemoved": "A tárgy eltávolításra kerül a nyilvántartásból (nincs folyamatban lévő igény).",
"hc.theItemWillBeSet": "A tárgy „raktáron” visszaállítva lesz, és a kapcsolódó igény törölve lesz.",
"hc.theKbisNumberAndVat": "A Kbis szám és az ÁFA szám szükséges Franciaország számára.",
"hc.theLabelIsGeneratedAutomatically": "A címke automatikusan generálódik, amint az ügyfél kifizette a szállítási díjakat. Itt letölthető lesz.",
"hc.theLinkMayHaveExpired": "A link lejárhatott (30 napig érvényes). Ha szükséges, lépj kapcsolatba a Findloop ügyfélszolgálattal.",
"hc.theOwnerDescribesTheirItem": "A tulajdonos leírja a tárgyát",
"hc.theOwnerReceivedItBy": "A tulajdonos e-mailben (vagy SMS-ben) kapta meg. Add meg vagy olvasd be, mielőtt átadnád.",
"hc.thePartnerConsideredThatThis": "A partner úgy ítélte meg, hogy ez a tárgy nem a tiéd. A tárgy továbbra is elérhető.",
"hc.thePartnerIsReviewingYour": "A partner felülvizsgálja a válaszaidat. Értesítve leszel, amint a kérelmedet érvényesítik.",
"hc.theShipmentIsCreatedAutomatically": "A szállítmány automatikusan létrejön, amint az ügyfél megerősítette a címét és kifizette a visszaállítási díjat. A címke ezután automatikusan generálódik a szállítási díj kifizetése után, és itt letölthető lesz.",
"hc.theShippingRateWillBe": "A szállítási díjat automatikusan kiszámolják a Sendcloud által a szállítás időpontjában (nyilvántartott súly).",
"hc.thisCarrierWillBe": "Ez a fuvarozó lesz",
"hc.thisEstablishment": "ez az üzlethelyiség",
"hc.thisFieldIsRequiredFor": "Ez a mező szükséges az automatikus címkelétrehozáshoz.",
"hc.thisIsMyItem": "Ez az én tárgyam",
"hc.thisIsMyItemContinue": "Ez az én tárgyam — folytatás",
"hc.thisIsMyItemStart": "Ez az én tárgyam — kezdd el a visszaküldést",
"hc.thisIsNotMyItem": "Ez nem az én tárgyam",
"hc.thisMatchIsNoLonger": "Ez a találat már nem elérhető, vagy már feldolgozásra került.",
"hc.thisRateWillBeCharged": "Ez a díj a vevőre lesz terhelve. A magas díj elriaszthatja a visszaállítást.",
"hc.thisStepIsRequiredFor": "Ez a lépés szükséges a szállítási címkék generálásához.",
"hc.thisValidationLinkIsInvalid": "Ez az érvényesítési link érvénytelen vagy lejárt.",
"hc.toCheckBeforeMarkingThe": "Ellenőrizze, mielőtt visszaként jelölné az elemet.",
"hc.toConfigureTheLinksAnd": "a linkek és az emlékeztető késleltetés beállításához minden létesítményhez.",
"hc.toReachOurFirstMilestone": "hogy elérjük az első mérföldkövünket, a 100 visszaküldést.",
"hc.toTheCustomer": "a vásárlónak.",
"hc.toTheShippingFeePayment": "a szállítási díj kifizetéséhez.",
"hc.toYourRecoveryTracking": "az Ön visszaszerzésének nyomon követéséhez.",
"hc.tooExpensiveBudget": "Túl drága / költségvetés",
"hc.topCitiesForReturns": "Legjobb városok a visszaküldésekhez",
"hc.trackMyRecovery": "Kövessem a visszaszerzésemet",
"hc.trackTheShipmentAndDownload": "Kövesse a szállítást és töltse le a címkét (automatikusan generálva) anélkül, hogy elhagyná a Felsorolások fület.",
"hc.trackYourStatistics": "Kövesse nyomon a statisztikáit",
"hc.tracking": "Nyomkövetés",
"hc.unableToOpenTheShipping": "Nem lehet megnyitni a szállítási díj kifizetését. Kérjük, próbálja újra.",
"hc.unableToRetrieveTheInvoice": "Nem lehet lekérni a számlát.",
"hc.unclaimed": "Nem igényelt",
"hc.unclaimedCustomerReason": "Nem igényelt tétel. Vásárló indoka: \"{reason}\".",
"hc.unclaimedItem": "Nem igényelt tétel",
"hc.unclaimedItemNoClaimWithin": "Nem igényelt tétel — nincs igény a határidőn belül.",
"hc.unclaimedItems": "Nem igényelt tételek",
"hc.unclaimedItemsMatchLeftWithout": "Nem igényelt tételek: egyezés maradt igény nélkül a határidőn belül. Visszateheti őket a tárolásba.",
"hc.unlockTheFinderSContact": "Oldja fel a megtaláló kapcsolattartási adatait a kézbesítés megszervezéséhez.",
"hc.upcoming": "Közelgő",
"hc.updateFailed": "Frissítés sikertelen.",
"hc.usedForInvoices": "A Findloop számláinak kiállításához használva.",
"hc.vatNumber": "ÁFA-szám",
"hc.verificationPending": "Az érvényesítés függőben",
"hc.verificationSentToTheFinder": "Az érvényesítés elküldve a megtalálónak. Értesítjük a döntéséről.",
"hc.verificationSentToThePartner": "Az érvényesítés elküldve a partnernek. Értesítjük a döntéséről.",
"hc.verify": "Ellenőrzés",
"hc.verifyingInvite": "A meghívó link ellenőrzése…",
"hc.verifyingTheLink": "A link ellenőrzése…",
"hc.viewInRegistry": "Megtekintés a nyilvántartásban",
"hc.viewItem": "Elem megtekintése",
"hc.viewItemRecover": "Elem megtekintése és visszaszerzése",
"hc.visibleToTheOwnerAutomatically": "Látható a tulajdonosnak · automatikusan törölve 60 nap után.",
"hc.waitingForPartnerConfirmation": "Partnere megerősítésére várva",
"hc.waitingForThePartnerS": "A partner megerősítésére várva",
"hc.weHaveInformedTheEstablishment": "Értesítettük a létesítményt, hogy ez az elem nem az Öné, és újraindítottuk az elemzést. Értesíteni fogjuk, amint új egyezés van.",
"hc.weHaveInformedThePartner": "Értesítettük a partnert, hogy ez az elem nem az Öné. A hirdetése aktív marad a jövőbeli egyezésekhez.",
"hc.weRanTheAnalysisAgain": "Újra elvégeztük az elemzést, és találtunk egy másik tételt, ami a tiéd lehet. Kérlek, nézd meg újra.",
"hc.weight": "Súly",
"hc.weightNotProvidedTheShipping": "Súly nem került megadásra: a szállítási díjat a szállítás időpontjában számítjuk ki.",
"hc.weightUnit": "Súlyegység",
"hc.welcome": "Üdvözöljük!",
"hc.welcomeToFindo": "Üdvözöljük a findloop-nál",
"hc.whenACustomerComesTo": "Amikor egy ügyfél jön, hogy átvegye a holmiját, nyissa meg a nyilatkozatát és érvényesítse a visszakérést. Ennyi az egész!",
"hc.whenDisabledFeesDropTo": ". Ha le van tiltva, a díjak csökkennek",
"hc.whyIsThisNotYour": "Miért nem a te terméked?",
"hc.willBeMarkedAs": "meg lesz jelölve mint",
"hc.wrongColor": "Rossz szín",
"hc.wrongModel": "Rossz modell",
"hc.yesCancel": "Igen, törlés",
"hc.yesContactTheFinder": "Igen, lépj kapcsolatba a megtalálóval",
"hc.youAreHere": "Itt vagy",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Most már elindíthatod a visszakérést.",
"hc.youCanStillChangeIt": ". Még mindig megváltoztathatod esetről esetre.",
"hc.youHaveAlreadyConfirmedThat": "Már megerősítetted, hogy ez a te terméked.",
"hc.youWillBeRedirectedTo": "Ön át lesz irányítva a biztonságos Stripe fizetéshez.",
"hc.yourAccountHasBeenReactivated": "A fiókod újraaktiválva lett.",
"hc.yourAccountIsActiveYou": "A fiókod aktív, most már kezelheted az intézményeidet.",
"hc.yourEstablishment": "A te intézményed",
"hc.yourFeedbackHelpsUsImprove": "A visszajelzésed segít nekünk javítani a találatainkat.",
"hc.yourFeedbackHelpsUsRestart": "A visszajelzésed segít nekünk újraindítani az elemzést, és javítani a találatainkat.",
"hc.yourFirstSteps": "Első lépéseid",
"hc.yourFirstStepsAdmin": "Első lépéseid (admin)",
"hc.yourItemHasBeenHanded": "A termékedet személyesen adta át a partner – zárd le az ügyet, amint az átadás megerősítést nyert.",
"hc.yourItemHasBeenShipped": "A termékedet a partner már feladta – zárd le az ügyet, amint a kézbesítés megerősítést nyert.",
"hc.yourPaymentHasBeenRecorded": "A kifizetésed rögzítve lett.",
"hc.yourShipmentIsBeingPrepared": "A csomagod előkészítése folyamatban van. A csomagodat 3-5 munkanapon belül megkapod.",
"hc.yourShippingFeesHaveAlready": "A szállítási díjaid már kifizetésre kerültek. Szállítás kifizetve ✓",
"hc.yourShippingFeesHaveBeen": "A szállítási díjaid kifizetésre kerültek. A csomagod előkészítése folyamatban van.",
"hc.yourVerificationQuestionsDeposit": "A hitelesítési kérdéseid (letét)",
"hero.einvoiceBadge": "2027-es normának megfelelő e-számlázás",
"home.recentAdsAll": "Összes hirdetés megtekintése",
"home.recentAdsEyebrow": "Jelenleg",
"home.recentAdsSubtitle": "A közösség által jelentett elveszett és megtalált tárgyak.",
"home.recentAdsTitle": "Legújabb hirdetések",
"home.reunions": "Legutóbbi újraegyesítések",
"home.videoEyebrow": "Nézd",
"home.videoSubtitle": "Hogyan találkozunk a tulajdonosokkal, könnyedén.",
"home.videoTitle": "Fedezd fel a findloop-t 2 perc alatt",
"home.watchYoutube": "Nézd a YouTube-on",
"impact.already": "Már",
"impact.citiesWord": "város/városok",
"impact.eachPoint": "Minden pont egy város, ahol a Findloop segít a megtalált tárgyak visszaszerzésében.",
"impact.emptyMap": "A térkép feltöltődik, ahogy a visszaadások megtörténnek.",
"impact.eyebrow": "Hatásunk",
"impact.inCities": "át",
"impact.restitutedTo": "tárgyak visszaadva a tulajdonosuknak",
"impact.title": "Visszaadott tárgyak, mindenhol körülötted",
"inv2.download": "Letöltés",
"inv2.view": "Megtekintés",
"map.objectsOnMapPlural": "tárgyak a térképen",
"map.objectsOnMapSingular": "tárgy a térképen",
"mc.claimConfirmDesc": "Ellenőrizd a megtalált tárgyat a megtaláló által, mielőtt fizetnél a kapcsolati adataiért.",
"mc.claimConfirmNo": "Ez nem az én tárgyam",
"mc.claimConfirmTitle": "Ez tényleg a te tárgyad?",
"mc.claimConfirmYes": "Igen, az enyém — fizetek",
"mc.claimFinderContacts": "A megtaláló kapcsolati adatai",
"mc.claimNotMineDone": "Köszönjük — a megtaláló értesítve lett, és a kérésed eltávolításra került a hirdetésből.",
"mc.claimUnlockDesc": "Fizess a Findloop kezelési díjért, hogy megkapd a személy kapcsolati adatait, aki megtalálta a tárgyadat.",
"mc.claimUnlockTitle": "Nyisd ki a megtaláló kapcsolati adatait",
"mc.hideCountryOffers": "Rejtse el az ajánlatokat az országomban",
"mc.myClaims": "A tárgyak, amiket igénylek",
"mc.myClaimsSub": "Mások által megtalált tárgyak, amelyeket igényelsz. Nyisd ki a megtaláló kapcsolati adatait, hogy megszervezd az átadást.",
"mc.notifAdCancelled": "Hirdetés törölve",
"mc.notifCancelAd": "Hirdetésem törlése",
"mc.offersInCountry": "Ajánlatok az országomban",
"mc.offersInCountryDesc": "Minden aktív jutalom a partnerektől az országodban, városonként.",
"mc.redArchived": "Archíválva",
"mc.rewardsCountryNone": "Még nincs ajánlat az országodban.",
"mc.rewardsForYou": "Jutalmak neked",
"mc.rewardsForYouDesc": "A helyszínen, ahol a tárgyat leadtad, a partner(ek) ajánlásával.",
"mc.rewardsMineNone": "Még nincs jutalom a leadási partnereidtől.",
"mc.showCountryOffers": "Ajánlatok megtekintése az országomban",
"mc2.cancelDecl": "Nyilatkozatom törlése",
"mc2.cancelDeclDone": "Nyilatkozat törölve.",
"pricing.physInvDesc": "Amikor egy tárgy visszaadásra kerül, a helye automatikusan felszabadul és elérhető egy új tárgynak.",
"pricing.physInvTitle": "Fizikai készlet nyomon követése",
"pricing.physModalTitle": "Fizikai termékek kezelése",
"pricing.physQrDesc": "Minden egyes termékhez egyedi QR-kódot generálunk, amely összekapcsolja az összes információt vele.",
"pricing.physQrTitle": "Dedikált QR címke",
"pricing.physShelfDesc": "Minden regisztrált termékhez fizikai helyet rendelhetünk az intézményen belül.",
"pricing.physShelfTitle": "Polcterv",
"pricing.physicalMgmt": "Fizikai termékkezelés (polcok, QR, készlet)",
"pub.addSecondPhoto": "2. fénykép hozzáadása (opcionális)",
"pub.photo2Added": "✓ 2. fénykép hozzáadva",
"reg.dispositionJournal": "Elhelyezési napló",
"reg.dispositionNoteAuthHint": "ℹ️ Jegyzet szükséges az „Átadás hatóságnak” esetében (jelentés száma, osztály…).",
"reg.dispositionNotePh": "Jegyzet (opcionális): kedvezményezett jótékonysági szervezet, hatósági hivatkozás, vevő neve…",
"reg.dispositionNoteRequired": "A hatóságoknak történő átadáshoz hivatalos hivatkozás szükséges.",
"reg.legalPrealert": "Jogi határidő {days} nap(nál) belül",
"reg.legalPrealertOptions": "Lehetőségek a határidőnél: árverés, adomány jótékonysági szervezetnek, átadás a hatóságoknak.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Teljes vélemény",
"rev.readMore": "Továbbiak",
"rw.activeCodes": "Aktív kuponok",
"rw.archived": "Archivált",
"rw.archivedTitle": "Beváltott kuponok (archivált)",
"rw.hideArchived": "Beváltott kuponok elrejtése",
"rw.noArchived": "Nincs archivált kupon.",
"rw.showArchived": "Beváltott kuponok megjelenítése",
"shp.labelAuto": "A címke automatikusan generálódik, amint a vásárló kifizette a szállítási díjat. Itt letölthető.",
"st.cancelled_by_customer": "Törölve",
"stt.dispoPdfBtn": "PDF exportálása",
"stt.dispoPdfError": "PDF exportálás nem sikerült.",
"stt.dispoPdfExporting": "Exportálás…",
"trk.matchVerifying": "Potenciális egyezés ellenőrzése",
"pcat.stadium_arena": "Stadion / Aréna",
"pcat.supermarket": "Szupermarket",
"pcat.taxi_vtc": "Taxi / Fuvarmegosztó",
"pcat.tourism_office": "Turista információs iroda",
"pcat.train_bus_station": "Vasúti / Buszpályaudvar",
"pcat.travel_agency": "Utazási iroda",
"hc.and": "és",
"hc.demoObj0": "egy pénztárca",
"hc.demoObj1": "egy sporttáska",
"hc.demoObj2": "egy telefon",
"hc.demoObj3": "egy szemüveg",
"hc.demoObj4": "egy kulcscsomó",
"hc.demoObj5": "egy sál",
"hc.demoObj6": "egy laptop",
"hc.demoObj7": "egy vizes palack",
"hc.demoWhen0": "2 órája",
"hc.demoWhen1": "5 órája",
"hc.demoWhen2": "tegnap",
"hc.demoWhen3": "3 órája",
"hc.demoWhen4": "ma reggel",
"hc.demoWhen5": "1 napja",
"hc.feedDemo": "{obj} vissza lett küldve {city} {when}.",
"hc.feedReal": "Egy tétel ({cat}) vissza lett küldve {city}-ben.",
"hc.saveBtn": "Mentés",
"hc.saveLink": "Link mentése",
"hc.terms": "Felhasználási feltételek",
"hc.view": "Megtekintés",
"pcat.airline": "Légitársaság",
"pcat.airport": "Repülőtér",
"pcat.amusement_park": "Vidámpark",
"pcat.bank": "Bank",
"pcat.bar_cafe": "Bár / Kávézó",
"pcat.beauty_salon": "Haj / Szépségszalon",
"pcat.cinema": "Mozi",
"pcat.concert_theater": "Koncertterem / Színház",
"pcat.coworking": "Közösségi iroda",
"pcat.gym_fitness": "Edzőterem / Fitnesz",
"pcat.hospital_clinic": "Kórház / Klinika",
"pcat.library": "Könyvtár",
"pcat.mall": "Bevásárlóközpont",
"pcat.museum": "Múzeum",
"pcat.pharmacy": "Gyógyszertár",
"pcat.private_company": "Magáncég",
"pcat.public_transport": "Tömegközlekedés",
"pcat.school_university": "Iskola / Egyetem",
"pcat.sports_center": "Sportközpont",
"an.found": "Megtalálva",
"an.lost": "Elveszett",
"hc.shareReview": "Oszd meg az értékelést",
"hc.citiesAboveTarget": "{n} város a célérték felett",
"hc.cityAboveTarget": "{n} város a célérték felett",
"hc.j15EarlyReminder": "D-15 korai emlékeztető",
"hc.j7EarlyReminder": "D-7 korai emlékeztető",
"hc.annualTotal": "Éves összeg",
"hc.billedOnceYear": "Évente egyszer terhelve, minden évben megújítva.",
"hc.monthlyPrice": "Havi ár",
"hc.perMonth": "/ hónap",
"hc.perYear": "/ év",
"hc.billedEachMonth": "Automatikusan terhelve minden hónapban.",
"nav.business": "Üzleti",
"nav.individual": "Egyéni",
"hc.circumstancesFound": "A megtalálás körülményei",
"hc.circumstancesFoundPh": "Pl. a földön találva a metróbejárat közelében",
"hc.circumstancesLost": "A veszteség körülményei",
"hc.circumstancesLostPh": "Pl. egy padon hagyva a buszra várva",
"hc.conditionPh": "Pl. jó, karcos…",
"hc.firstName": "Keresztnév",
"hc.lastName": "Családi név",
"hc.quantity": "Tárgyak száma",
"fa.approve": "Jóváhagyás",
"fa.approveConfirm": "Jóváhagyja ezt a nyilatkozatot? A teljes kapcsolattartási adatait (név, email, telefon) megosztjuk a keresővel.",
"fa.approved": "Nyilatkozat jóváhagyva — kapcsolattartási adatok megosztva",
"fa.approvedFinder": "A tulajdonos jóváhagyta a nyilatkozatát",
"fa.approvedFinderText": "Lépjen kapcsolatba velük a visszaszolgáltatás megszervezéséhez.",
"fa.boostSub": "A hirdetése a választott időtartamig a legjobb helyen marad.",
"fa.boostTitle": "Hirdetésem kiemelése (opcionális)",
"fa.colFinder": "Kereső nyilatkozata",
"fa.colYours": "Az Ön nyilatkozata",
"fa.compareHint": "Has compare a kereső nyilatkozatát a sajátjával a döntés előtt.",
"fa.contribNone": "Nincs hozzájárulás",
"fa.contribPaid": "Hozzájárulás megérkezett — köszönjük!",
"fa.contribPending": "Hozzájárulás vár a kifizetésre",
"fa.contribSub": "Támogassa a findloop-t, hogy még több emberhez eljuthasson a megkerült tárgy. Választhatja a €0-t.",
"fa.contribSuccessMsg": "A nyilatkozatát elküldtük a tulajdonosnak.",
"fa.contribSuccessTitle": "Köszönjük a hozzájárulását",
"fa.contribTitle": "Önkéntes hozzájárulás",
"fa.days3": "3 nap",
"fa.days30": "30 nap",
"fa.days7": "7 nap",
"fa.declSub": "Írja le a megtalált tárgyat. A tulajdonos összehasonlítja a nyilatkozatát a sajátjával.",
"fa.declTitle": "Ezt a tárgyat találtam",
"fa.expiresOn": "Lejár",
"fa.fBrand": "Márka",
"fa.fCircumstances": "Körülmények",
"fa.fCity": "Város",
"fa.fColor": "Szín",
"fa.fCondition": "Állapot",
"fa.fDate": "Dátum",
"fa.fMessage": "Kereső üzenete",
"fa.fPlace": "Hely",
"fa.fQuantity": "Mennyiség",
"fa.finderContact": "Kereső kapcsolattartási adatai",
"fa.finishPay": "Fizetés befejezése",
"fa.foundDate": "Megtalálás dátuma",
"fa.foundPlace": "Megtalálás helye",
"fa.hours24": "24 óra",
"fa.ht": "nettó áfát nem tartalmaz",
"fa.months3": "3 hónap",
"fa.noBoost": "Nincs kiemelés",
"fa.ownerContact": "A tulajdonos elérhetőségi adatai",
"fa.payPublish": "Fizetés és közzététel",
"fa.pendingPayText": "A hirdetése azonnal élni fog, amint a kifizetést megerősítik.",
"fa.pendingPayTitle": "Fizetés folyamatban",
"fa.planSub": "A hirdetése azonnal élni fog, amint a kifizetést megerősítik.",
"fa.planTitle": "Hirdetés időtartama",
"fa.pubSuccessMsg": "A hirdetése él. Értesítést kap, amint egy kereső jelentkezik.",
"fa.pubSuccessTitle": "Hirdetés közzétéve",
"fa.publicNote": "Csak a leírás, város, ország és fényképek láthatók nyilvánosan.",
"fa.redirectStripe": "Átirányítás a biztonságos fizetéshez…",
"fa.reject": "Elutasít",
"fa.rejectConfirm": "Elutasítja ezt a nyilatkozatot? A hirdetése online marad.",
"fa.rejected": "A nyilatkozat elutasítva",
"fa.rejectedFinder": "Nem az, amire kerestek",
"fa.rejectedFinderText": "A tulajdonos azt mondja, hogy ez az elem nem az övé. Köszönjük a segítséget!",
"fa.responsesTitle": "Keresői nyilatkozatok",
"fa.sent": "A nyilatkozat elküldve a tulajdonosnak.",
"fa.submitDecl": "Küldje el a nyilatkozatomat",
"fa.submitDeclPay": "Küldés és hozzájárulás {amount}",
"fa.total": "Fizetendő összeg",
"fa.ttc": "áfával együtt",
"fa.waitClaimText": "A kereső áttekinti a kérését. Értesítjük a döntésükről.",
"fa.waitFinderText": "Értesítjük, amint egy kereső benyújt egy nyilatkozatot.",
"fa.waitFinderTitle": "A hirdetése él",
"fa.waitOwnerText": "A tulajdonos összehasonlítja a nyilatkozatát a sajátjával. Értesítjük a döntésükről.",
"fa.waitOwnerTitle": "A tulajdonos döntésére várva",
"st.pending_payment": "Fizetés folyamatban",
"fa.africaFree": "Ingyenes hirdetés Afrikában — Findloop bevezető ajánlat, élvezd!",
"fa.africaPublished": "Hirdetés ingyenesen közzétéve — Afrika bevezető ajánlat!",
"fa.approveClaimConfirm": "Jóváhagyod ezt a követelést? Ezután a tulajdonos feloldhatja az elérhetőségeidet.",
"fa.checkInfo": "Ellenőrizd az adataidat elküldés előtt: ezeket a megtalálóéival fogják összehasonlítani.",
"fa.claimApprovedShort": "A megtaláló jóváhagyta a követelésedet",
"fa.claimRejectedShort": "A megtaláló elutasította a követelést",
"fa.claimRejectedText": "A megtaláló úgy véli, hogy ez az elem nem a tiéd.",
"fa.claimSub": "Írd le az elemedet és adj hozzá 2 fotót. A megtaláló összehasonlítja őket a saját hirdetésével.",
"fa.claimTitle": "Ez az én elemem",
"fa.claimUnlockText": "Oldd fel a megtaláló elérhetőségeit a visszaszállítás megszervezéséhez.",
"fa.claimUnlockedShort": "Elérhetőségek feloldva — kövesd az útvonalat",
"fa.claimsTitle": "Tulajdonosi követelések",
"fa.colOwner": "Tulajdonos nyilatkozata",
"fa.colYourAd": "A te hirdetésed",
"fa.expired": "Hirdetés lejárt",
"fa.free": "Ingyenes",
"fa.lostDate": "Elvesztés dátuma",
"fa.lostPlace": "Elvesztés helye",
"fa.noReceipt": "Nincs elérhető nyugta ehhez a hirdetéshez.",
"fa.planSubFree": "Válaszd ki a tartamot: a hirdetésed azonnal él, nincs szükség fizetésre.",
"fa.prefillPrevious": "Használj fel adatokat az előző hirdetésemről ebben a kategóriában",
"fa.receipt": "PDF nyugta",
"fa.renewBtn": "Megújítás",
"fa.renewDiscountBanner": "50% kedvezmény: újítsd meg a hirdetésed lejárta előtt!",
"fa.renewDiscountHint": "50% kedvezmény, mert a lejárat előtt újítod meg.",
"fa.renewEarly": "Megújítás (−50%)",
"fa.renewTitle": "Hirdetésem megújítása",
"fa.renewed": "Hirdetés megújítva",
"fa.sendClaim": "Követelés elküldése",
"fa.twoPhotos": "2 fotó a tervedről",
"fa.twoPhotosError": "Adj hozzá 2 fotót a tervedről.",
"fa.twoPhotosHint": "Személyes fotók, amelyek bizonyítják, hogy az elem a tiéd (a tárggyal, számlával, dobozzal…).",
"fa.unlockBtn": "Elérhetőségek feloldása",
"fa.unlockFree": "Feloldás ingyenesen — bevezető ajánlat",
"fa.waitClaimantText": "Értesítünk, amint egy tulajdonos követeli ezt az elemet.",
"fa.waitFinderDecision": "Várakozás a megtaláló döntésére",
"fa.waitUnlockText": "Értesítünk, amint az elérhetőségek kicserélődnek.",
"fa.waitUnlockTitle": "Várakozás a tulajdonos feloldására",
"fa.cancel": "Mégse",
"fa.categoryRequired": "Válassz egy kategóriát a talált elemhez.",
"fa.confirmTitle": "Erősítsd meg a döntésedet",
"fa.goBack": "Vissza",
"dr.continue": "Folytasd a nyilatkozatot",
"dr.delete": "Törlés véglegesen",
"dr.deleteConfirm": "Véglegesen törlöd ezt a vázlatot? Ezt nem lehet visszavonni.",
"dr.deleted": "Vázlat törölve",
"dr.expiresIn": "Vázlat {h} óráig megőrizve",
"dr.title": "Van egy befejezetlen nyilatkozatod",
"form.step": "Lépés",
"form.next": "Tovább",
"form.back": "Vissza",
"form.stepDetails": "Az Ön jelentése",
"form.stepPublish": "Időtartam, támogatás és fizetés",
"form.stepThanks": "Köszönjük & hozzájárulás",
"fthx.badge": "A jelentés majdnem kész",
"fthx.title": "Köszönjük, különbséget teszel!",
"fthx.text": "Köszönhetően neked, valaki hamarosan visszakaphat valamit, ami számít neki. Az olyan kedvességek, mint a tiéd, tartják életben a Findloop-ot.",
"fthx.impact1": "1 jelentett tétel",
"fthx.impact2": "1 új lehetőség a találkozásra",
"fthx.tipTitle": "Egy kis támogatás a Findloop számára?",
"fthx.tipText": "A hozzájárulásod segít, hogy a szolgáltatás elérhető maradjon, és egyre több tárgyat reunáljunk azok tulajdonosaival.",
"fthx.optional": "100% önkéntes — hozzájárulás nélkül is közzéteheted.",
"fthx.thanksTip": "Köszönjük szépen a nagylelkűségedet!",
"fthx.suggest": "Javasolt összegek",
"fthx.none": "Nincs tipp",
"pay.pendingTitle": "A kifizetés nincs befejezve",
"pay.pendingText": "Az adataid mentve vannak. Folytasd a kifizetést ott, ahol abbahagytad.",
"pay.resume": "Kifizetés folytatása",
"pay.expiredTitle": "A kifizetési session lejárt",
"pay.expiredText": "A biztonságod érdekében a kifizetési session lejárt. Az adataid mentve vannak: indítsd újra a kifizetést egy kattintással.",
"pay.relaunch": "Kifizetés újraindítása",
"sub.received": "Elküldve!",
"sub.publishing": "Befejezzük…",
"sub.toPayment": "Átirányítás a biztonságos kifizetésre…",
"fa.claimSubV2": "Írd le a megtalált tárgyat. Az a személy, aki rátalált, össze fogja hasonlítani a nyilatkozatodat a hirdetésével.",
"fa.photosOptional": "A tárgy fényképei (opcionális)",
"fa.compareOwnerHint": "Hasonlítsd össze ezt az információt a megtalált tárggyal, majd jelezd, hogy ugyanaz a tárgy-e.",
"fa.itsThisItem": "Igen, ez a tárgy",
"fa.notThisItem": "Nem, ez nem a tárgy",
"fa.confirmIsItem": "Megerősíted, hogy ez a tárgy? A te és a tulajdonos elérhetőségei meg lesznek jelenítve a megfelelő fiókokban.",
"fa.confirmNotItem": "Megerősíted, hogy ez nem a tárgy? A jelentésed lezárásra kerül.",
"fa.youConfirmed": "Megerősítetted, hogy ez a tulajdonos tárgya",
"fa.youDeclined": "Jelezted, hogy ez nem a tárgy",
"fa.youDeclinedText": "Köszönjük a segítségedet! A tulajdonos értesítve lett.",
"fa.waitFinderDecisionOwner": "Várakozás a megtaláló döntésére",
"fa.finderConfirmed": "Megerősítve",
"fa.notYourItem": "Ez nem volt a te tárgyad",
"fa.reportedOn": "Jelentve: ",
"fa.ownerWaitHint": "Egy megtaláló jelenleg ellenőrzi az információkat, kérjük várj.",
"fa.claimSentFinder": "A kérelmet elküldtük annak a személynek, aki megtalálta a tárgyat.",
"fa.compareClaimHint": "Hasonlítsa össze a tulajdonos nyilatkozatát a hirdetésével, mielőtt döntene.",
"fa.closeFollowup": "Zárja be ezt a követést",
"fa.closeFollowupConfirm": "Biztosan be szeretné zárni ezt a követést? A tulajdonos listájának bezárása után mindkét fél e-mail címe és telefonszáma véglegesen törlésre kerül.",
"fa.safetyTitle": "Biztonsági tippek a tárgy átadás előtt",
"fa.safety1": "Kérje meg a tulajdonost, hogy adjon részletes leírást a tárgy rejtett jellemzőiről: egy konkrét karcolás, a táska pontos tartalma, a háttérkép, a sorozatszám…",
"fa.safety2": "Ha lehetséges, kérjen vizuális bizonyítékot (a tárgyról készült fényképet) vagy vásárlási igazolást.",
"fa.safety3": "Adja át a tárgyat nyilvános helyen vagy egy Findloop partnernél, és ellenőrizze a tulajdonos azonosítóját.",
"fa.safetyOk": "Készen állok, folytatom",
"fa.ownerClosedNote": "A tulajdonos bezárta a listáját.",
"fa.finderClosedNote": "A kereső bezárta a követését.",
"fa.followupClosed": "Követés lezárva",
"fa.followupClosedText": "Te lezártad ezt a követést. Köszönjük a segítséged!",
"fa.photoReviewTitle": "Egy finder küldött egy fotót. Úgy néz ki, mint a te tárgyad?",
"fa.photoLooksLike": "Igen, úgy néz ki, mint a tárgyam",
"fa.photoNotMine": "Nem, ez nem az én tárgyam",
"fa.photoNotMineConfirm": "A nyomon követés mindkét fél részéről lezárásra kerül, és a hirdetésed nyitva marad egy új finder számára.",
"fa.photoLooksLikeDone": "Köszönjük! A finder most összehasonlítja a nyilatkozatodat.",
"fa.photoNotMineDone": "Jelentés elutasítva. A hirdetésed nyitva marad.",
"fa.ownerPhotoHint": "Csak a finder fotója látható számodra. Mondd el, hogy hasonlít-e a tárgyadra.",
"fa.ownerReviewingPhoto": "A tulajdonos átnézi a fotódat",
"fa.ownerReviewingPhotoText": "Értesítést kapsz, amint válaszolnak. Ekkor össze tudod hasonlítani a nyilatkozatukat.",
"fa.ownerRejectedPhoto": "Ez nem a tulajdonos tárgya",
"fa.ownerRejectedPhotoText": "A tulajdonos azt mondja, hogy a fotód nem egyezik meg a tárgyukkal. A nyomon követés lezárva. Köszönjük a segítségedet!",
"fa.contribute": "Járulj hozzá",
"fa.phoneMissing": "Nincs megadva",
"fa.ownerSafety1": "Javasoljuk, hogy a kézbesítést nyilvános helyen vagy egy Findloop partner irodájában végezze. Ha a távolság nagy, javasolja a postai küldést.",
"fa.ownerSafety2": "A kézbesítéskor ellenőrizze a találó azonosítóját.",
"pub.changePhoto": "Fénykép módosítása",
"ph.secured": "A fénykép védett",
"ph.securing": "A fénykép védelme folyamatban…",
"fa.ownerSafety3": "Ha a találó fényképén a Findloop vízjel szerepel, ne fogadja el a találkozót. A fényképnek az eredeti, a találó által készített, vízjel nélküli képnek kell lennie."
},
"sk": {
"a.back": "Späť",
"a.category": "Kategória",
"a.categoryPlaceholder": "Vyberte kategóriu",
"a.city": "Mesto",
"a.confirmPassword": "Potvrdiť heslo",
"a.country": "Krajina",
"a.createAccount": "Vytvoriť účet",
"a.createBtn": "Vytvoriť môj účet",
"a.creating": "Vytváranie…",
"a.email": "Email",
"a.emailPro": "Firemný email",
"a.forgot": "Zabudli ste?",
"a.forgotSent": "Ak účet existuje, obnovovací odkaz bol práve zaslaný.",
"a.forgotSub": "Získajte obnovenie odkazu na email.",
"a.forgotTitle": "Zabudnuté heslo",
"a.googleContinue": "Pokračovať s Google",
"a.googleSignup": "Prihlásiť sa cez Google",
"a.haveAccount": "Už partner?",
"a.legalHint": "Povinné pre francúzske e-faktúry (Factur-X) francúzskych prevádzok.",
"a.legalRequiredFR": "SIRET a intrakomunitárne IČ DPH sú povinné pre Francúzsko.",
"a.loggingIn": "Prihlasovanie…",
"a.login": "Prihlásiť sa",
"a.loginSub": "Získajte prístup k svojmu správcovskému priestoru.",
"a.loginTitle": "Prihlásenie partnera",
"a.min6": "Minimálne 6 znakov",
"a.newPassword": "Nové heslo",
"a.noAccount": "Ešte nie ste partner?",
"a.or": "ALEBO",
"a.org": "Názov prevádzky",
"a.password": "Heslo",
"a.passwordMismatch": "Heslá sa nezhodujú.",
"a.referral": "Referral kód (voliteľné)",
"a.registerSub": "Vytvorte si svoj priestor za 1 minútu — zadarmo na začiatok.",
"a.registerTitle": "Staňte sa partnerom",
"a.rememberMe": "Pamätať si ma",
"a.reset": "Obnoviť",
"a.resetSub": "Vyberte nové heslo pre váš účet.",
"a.resetTitle": "Nové heslo",
"a.sendLink": "Poslať odkaz",
"a.sending": "Posielanie…",
"a.signin": "Prihlásiť sa",
"a.siret": "SIRET",
"a.vat": "Intrakomunitárne IČ DPH č.",
"ac.africa": "Afrika",
"ac.boostActive": "Zvýrazniť aktívne —",
"ac.boostSub": "Objavte sa na vrchu partnera adresára s odznakom „Zvýraznené“.",
"ac.boostTitle": "Zvýšte svoju ponuku v adresári",
"ac.categoryHint": "Na zaradenie vašej prevádzky do adresára findloop.",
"ac.choose": "Vybrať",
"ac.cityHint": "Pre presné umiestnenie na verejnej mape.",
"ac.cityLabel": "Mesto prevádzky",
"ac.cityPh": "Paríž",
"ac.contact": "Kontaktné údaje",
"ac.converted": "Konvertované",
"ac.copyDeclLink": "Skopírovať odkaz na deklaráciu",
"ac.copyLink": "Skopírovať odkaz",
"ac.currentPlan": "Aktuálny plán",
"ac.emailDesc": "Vyberte emaily, ktoré chcete dostávať. Oznámenia vo vašej pracovnej oblasti zostávajú vždy aktívne.",
"ac.emailMatch": "Zodpovedá",
"ac.emailMatchDesc": "Email, keď sa položka zhoduje s deklaráciou",
"ac.emailNewDecl": "Nové vyhlásenia o stratách",
"ac.emailNewDeclDesc": "Email, hneď ako zákazník nahlási stratu vo vašich priestoroch",
"ac.emailShip": "Žiadosti o expedíciu",
"ac.emailShipDesc": "Email, keď zákazník požaduje expedíciu položky",
"ac.emailTitle": "Nastavenia emailov",
"ac.expireSoon": "Vaša reklama čoskoro vyprší —",
"ac.exportCsv": "Export (CSV)",
"ac.exportHint": "Exportujte svoje overené externé platby pre vaše účtovníctvo.",
"ac.free": "Zdarma",
"ac.freeMonths": "Bezplatné mesiace",
"ac.hours": "hodiny",
"ac.howItWorks": "Ako to funguje?",
"ac.invited": "Pozvané",
"ac.legalFR": "Povinné pre elektronické faktúrovanie (Factur-X) platné od septembra 2026.",
"ac.legalMissing": "⚠️ Chýba SIRET a DPH v rámci EÚ — doplňte ich, aby ste zostali v súlade s elektronickým faktúrovaním.",
"ac.legalOther": "Odporúčané pre vaše faktúry.",
"ac.legalPartnerQr": "QR kód",
"ac.legalTitle": "Právne identifikátory (fakturácia)",
"ac.logoTitle": "Logo zariadenia",
"ac.modeCurrent": "Aktuálny režim:",
"ac.modeExternal": "Externý (manuálne overenie)",
"ac.modeInternal": "Interný Findloop (automatický)",
"ac.noSubReceipt": "Zatiaľ žiadna platba za predplatné.",
"ac.none": "Žiadne",
"ac.onYourListing": "na vašom zozname",
"ac.pay1": "Zadajte svoje platobné odkazy nižšie, aby ste presmerovali svojich zákazníkov na váš vlastný systém inkasa.",
"ac.pay2": "Overenie sa stáva manuálnym: potvrdzujete prijatie platby na karte „Vyhlásenia“.",
"ac.pay3": "Odkaz „Poplatok za expedíciu“ je konsolidovaná platba (obnova + expedícia).",
"ac.pay4": "Nechajte polia prázdne, aby ste použili internú platbu Findloop (Stripe) s automatickým overením.",
"ac.paySub": "Vyberte poplatky cez svoj vlastný platobný systém.",
"ac.payTitle": "Externé platby",
"ac.permissive": "Povolené",
"ac.phone": "Telefón",
"ac.posterA4": "Plagát A4 (PDF)",
"ac.qMessage": "Správa (voliteľné)",
"ac.qName": "Meno",
"ac.qOrg": "Organizácia",
"ac.qSites": "Počet zariadení (odhad)",
"ac.qrHint": "Vaši zákazníci naskenujú tento kód, aby nahlásili stratenú položku.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Váš partner QR kód",
"ac.quoteDesc": "Letiská, železničné siete, medzinárodné reťazce · ",
"ac.quoteEurope": "Európa / Svet",
"ac.quoteSent": "Žiadosť o ponuku bola odoslaná. Náš tím sa vám čoskoro ozve.",
"ac.quoteTitle": "Požiadajte o ponuku — Podnik",
"ac.recoveryLink": "Odkaz „Poplatok za obnovu“",
"ac.refSub": "Každý odporučený partner, ktorý sa prihlási, vám dá 1 bezplatný mesiac.",
"ac.refTitle": "Odporúčajte, získajte bezplatný mesiac",
"ac.reminderDelay": "Meškanie pripomienky overenia",
"ac.reminderHint": "Dostanete emailovú pripomienku, ak externá platba zostane neoverená po uplynutí tejto lehoty (predvolené: 48h).",
"ac.renewDesc1": "Už vám to zarobilo",
"ac.renewDesc2": "Obnovte sa, aby ste zostali na vrchole adresára a nestratili túto viditeľnosť.",
"ac.renewNow": "Obnovte teraz",
"ac.requestQuote": "Požiadajte o ponuku",
"ac.saveLegal": "Uložte identifikátory",
"ac.saveLinks": "Uložte odkazy",
"ac.sendRequest": "Odošlite moju žiadosť",
"ac.sending": "Odosielanie…",
"ac.shippingLink": "Odkaz „Poplatok za expedíciu“ (konsolidované)",
"ac.shippingLinkHint": "Tento odkaz pokrýva obnovu aj expedíciu.",
"ac.strict": "Prísny",
"ac.subReceipt": "Potvrdenie o predplatnom (PDF)",
"ac.subReceiptsSub": "Stiahnite PDF potvrdenie za každú platbu predplatného.",
"ac.subReceiptsTitle": "Potvrdenia o predplatnom",
"ac.tCategory": "Kategória uložená",
"ac.tCity": "Mesto uložené — mapa bola aktualizovaná",
"ac.tCityNeeded": "Zadajte mesto",
"ac.tCopied": "Skopírované!",
"ac.tCover": "Fotka na obálku bola aktualizovaná",
"ac.tEmailPrefs": "Nastavenia e-mailu boli aktualizované",
"ac.tErr": "Chyba",
"ac.tExportImpossible": "Export zlyhal",
"ac.tLegal": "Právne identifikátory uložené",
"ac.tLegalNeeded": "SIRET a DPH potrebné pre Francúzsko",
"ac.tLogo": "Logo aktualizované",
"ac.tLogoRemoved": "Logo odstránené",
"ac.tPayLinks": "Platobné odkazy uložené",
"ac.tPhone": "Telefón uložený",
"ac.tSensitivity": "Citlivosť uložená",
"ac.tVatInvalid": "Neplatné číslo DPH",
"ac.tVatValid": "Platná DPH",
"ac.tabBoost": "Viditeľnosť",
"ac.tabPayments": "Platby",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Plagát",
"ac.tabReferral": "Referral",
"ac.tabSub": "Predplatné",
"ac.thisWeek": "Tento týždeň",
"ac.thisWeekOf": " ({n} tento týždeň)",
"ac.thresholdDesc": "Hranica dôvery, od ktorej AI automaticky validuje zhodu fotografie a informuje zákazníka. Vyššie = menej automatických zhody, ale spoľahlivejšie.",
"ac.thresholdTitle": "Citlivosť vizuálnej zhody AI",
"ac.trend": "Trend",
"ac.upload": "Nahrať",
"ac.vatValidFmt": "Platná DPH{name} ({via})",
"ac.vatVerified": "Overená intra-EÚ DPH",
"ac.verifyVat": "Overiť DPH (VIES)",
"ac.verifying": "Overujem…",
"ac.views": "zobrazení",
"ac.viewsTotal": "Získané zobrazenia (celkom)",
"ac.winbackBtn": "Pokračovať s -20%",
"ac.winbackDesc1": "Získali ste",
"ac.winbackDesc2": "Špeciálna ponuka: -20% aplikované automaticky, ak obnovíte do 24h.",
"ac.winbackTitle": "Vaša obľúbená položka práve vypršala — pokračujte s -20%!",
"ad.boost": "Posilniť",
"ad.close": "Zavrieť",
"ad.closeConfirm": "Zavrieť tento zoznam?",
"ad.closed": "Zoznam zatvorený",
"ad.edit": "Upraviť",
"ad.editTitle": "Upraviť zoznam",
"ad.saved": "Zoznam aktualizovaný",
"an.allCountries": "Všetky krajiny",
"an.badge": "Stratené položky",
"an.boostLater": "Neskôr",
"an.boostNow": "Posilniť teraz",
"an.boostPrompt": "Posilnite svoj zoznam, aby ste ho umiestnili na vrchol a rýchlejšie ho našli.",
"an.boosted": "Posilnené",
"an.contact": "Našiel som túto položku",
"an.contactTitle": "Nahláste, že ste našli túto položku",
"an.copyFailed": "Nepodarilo sa skopírovať odkaz",
"an.copyLink": "Skopírovať odkaz",
"an.country": "Krajina",
"an.date": "Dátum straty",
"an.finderEmail": "Tvoj email",
"an.finderName": "Tvoje meno",
"an.finderPhone": "Tvoje telefónne číslo",
"an.geoBanner": "Zobrazuješ inzeráty v",
"an.geoBannerWorld": "Zobrazuješ inzeráty celosvetovo",
"an.geoChange": "zmeniť krajinu",
"an.goAccount": "Prejdi do môjho účtu",
"an.linkCopied": "Odkaz skopírovaný!",
"an.loginRequired": "Prihlás sa na nahlásenie tohto predmetu a sledovanie jeho vrátenia.",
"an.loginToBoost": "Prihlás sa na zvýraznenie tohto inzerátu",
"an.lostAt": "Stratené na",
"an.message": "Správa (voliteľné)",
"an.none": "Ešte žiadny inzerát.",
"an.photo": "Fotografia (voliteľné)",
"an.post": "Pridať inzerát",
"an.postSubtitle": "Opíš svoj stratený predmet — komunita a naši partneri ti pomôžu ho nájsť.",
"an.postTitle": "Nahlás všeobecný stratený predmet",
"an.publish": "Zverejni inzerát",
"an.published": "Inzerát zverejnený!",
"an.publishing": "Zverejňovanie…",
"an.remaining": "zostáva",
"an.requestInProgress": "Žiadosť prebieha",
"an.resolved": "Predmet už bol nájdený",
"an.reward": "Odmena",
"an.searchPh": "Hľadaj inzerát…",
"an.send": "Odoslať",
"an.sent": "Správa odoslaná vlastníkovi!",
"an.shareConsent": "Súhlasím, že moje kontaktné údaje (meno, email, telefón) môžu byť zdieľané s vlastníkom predmetu.",
"an.shareConsentError": "Prosím zaškrtni políčko, aby si zdieľal svoje kontaktné údaje.",
"an.sortRecent": "Najnovšie",
"an.sortRelevance": "Relevancia",
"an.subtitle": "Prehliadaj predmety nahlásené ako stratené komunitou. Našiel si niektorý z nich?",
"an.title": "Inzeráty stratených predmetov",
"anf.badge": "Nájdené predmety",
"anf.claim": "Toto je moje",
"anf.claimSent": "Správa odoslaná nálezcovi!",
"anf.claimTitle": "Nahlás, že toto je tvoj predmet",
"anf.consent": "Súhlasím, že vlastník môže vidieť moje kontaktné údaje, aby si mohol získať späť svoj predmet.",
"anf.foundAt": "Nájdené na",
"anf.foundDate": "Dátum nájdenia",
"anf.loginCta": "Prihlás sa / vytvor účet",
"anf.loginDesc": "Účet nálezcu je potrebný na zverejnenie inzerátu a získanie bodov Finder Hero.",
"anf.loginRequired": "Prihlás sa na pridanie nájdeného predmetu",
"anf.photo": "Fotografia predmetu",
"anf.pointsEarned": "Ďakujeme! Práve si získal bodu Finder Hero.",
"anf.pointsPending": "Tvoje body budú pripísané do 24 hodín po overení.",
"anf.post": "Pridať nájdený predmet",
"anf.postSubtitle": "Opíš predmet, ktorý si našiel — pomôž jeho vlastníkov, aby si ho získal späť.",
"anf.postTitle": "Nahlás nájdený predmet",
"anf.publishFound": "Zverejni inzerát nájdeného predmetu",
"anf.published": "Inzerát o nájdených predmetoch zverejnený",
"anf.publishedAs": "Zverejnené ako",
"anf.shareConsent": "Súhlasím, že moje kontaktné údaje (meno, email, telefón) môžu byť zdieľané s osobou, ktorá predmet našla.",
"anf.subtitle": "Prehliadaj predmety nájdené a nahlásené komunitou. Spoznávaš svoj?",
"anf.title": "Inzeráty nájdených predmetov",
"bo.active": "Zvýraznenie aktívne",
"bo.africaPrice": "Aplikovaná zvýhodnená cena pre africkú zónu",
"bo.pay": "Platiť & zvýrazniť",
"bo.remaining": "Zostáva čas",
"bo.renew": "Obnoviť posilnenie",
"bo.since": "od posilnenia",
"bo.subtitle": "Umiestnite svoj inzerát na vrchol zoznamu s viditeľným odznakom.",
"bo.title": "Posilniť inzerát",
"c.all": "Všetko",
"c.cancel": "Zrušiť",
"c.close": "Zavrieť",
"c.confirm": "Potvrdiť",
"c.confirmed": "Potvrdené",
"c.download": "Stiahnuť",
"c.loading": "Načítava sa…",
"c.reset": "Obnoviť",
"c.reviews": "recenzie",
"c.save": "Uložiť",
"c.transfer": "Preniesť",
"cat.Animal": "Domáce zviera / Príslušenstvo pre domáce zvieratá",
"cat.AppareilPhoto": "Fotoaparát",
"cat.Argent": "Peniaze / Hotovosť",
"cat.Autres": "Iné",
"cat.Bijoux": "Šperky",
"cat.CarteBancaire": "Banková karta",
"cat.CarteIdentite": "Občiansky preukaz / Pas",
"cat.Casquette": "Čiapka / Klobúk",
"cat.Ceinture": "Opasok",
"cat.Chargeur": "Nabíjačka / Kábel",
"cat.Chaussures": "Topánky",
"cat.CleVoiture": "Kľúč od auta",
"cat.Cles": "Kľúče",
"cat.Console": "Herná konzola",
"cat.Documents": "Dokumenty / Papiera",
"cat.Echarpe": "Šál",
"cat.Ecouteurs": "Slúchadlá",
"cat.Electronique": "Elektronika (ostatné)",
"cat.Enceinte": "Reproduktor",
"cat.Gants": "Rukavice",
"cat.Gourde": "Fľaša / Termoska",
"cat.Instrument": "Hudobný nástroj",
"cat.Jouet": "Hračka / Plyšový",
"cat.Jumelles": "Ďalekohľad",
"cat.Lampe": "Lampa / Baterka",
"cat.Liseuse": "Elektronická čítačka",
"cat.Livre": "Kniha / Zápisník",
"cat.Lunettes": "Okuliare",
"cat.Manteau": "Kabát / Bunda",
"cat.Maquillage": "Kosmetická taška",
"cat.Medical": "Lekárske vybavenie",
"cat.Medicaments": "Liek",
"cat.Montre": "Hodinky / Smart hodinky",
"cat.Ordinateur": "Prenosný počítač",
"cat.Parapluie": "Dáždnnik",
"cat.Portefeuille": "Peňaženka",
"cat.Poussette": "Kočík / Detské príslušenstvo",
"cat.Sac": "Taška / Kabelka",
"cat.SacADos": "Batoh",
"cat.Souris": "Myš / Klávesnica",
"cat.Sport": "Športové vybavenie",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefón / Smartfón",
"cat.Trottinette": "Kolobežka",
"cat.Trousse": "Puzdro",
"cat.USB": "USB kľúč / Pevný disk",
"cat.Valise": "Kufor / Batožina",
"cat.Velo": "Bicykel",
"cat.Vetements": "Odevy",
"cat.placeholder": "Vyberte kategóriu",
"cd.d": "d",
"cd.expired": "Expirujúce",
"cd.h": "h",
"cd.m": "min",
"ck.accept": "Prijať",
"ck.acceptAll": "Prijať všetko",
"ck.customize": "Prispôsobiť",
"ck.learn": "Zistiť viac",
"ck.manage": "Spravovať cookies",
"ck.measurement": "Meranie publika",
"ck.measurementDesc": "Anonymné štatistiky na zlepšenie služby.",
"ck.msg": "Používame cookies na zachovanie funkčnosti stránky a meranie publika.",
"ck.necessary": "Nezbytné",
"ck.necessaryDesc": "Základné pre fungovanie stránky. Vždy zapnuté.",
"ck.refuse": "Odmietnuť",
"ck.save": "Uložiť moje voľby",
"ck.saved": "Nastavenia uložené",
"ck.title": "Vaše preferencie cookies",
"cm.found": "NÁJDENÉ",
"cm.lost": "STRATENÉ",
"cmp.adv": "Pokročilé",
"cmp.ai": "AI párovanie",
"cmp.autobill": "Automatické fakturovanie",
"cmp.basic": "Základné",
"cmp.community": "Komunita",
"cmp.consol": "Konsolidované fakturovanie",
"cmp.custom": "Vlastné",
"cmp.dedicated": "Vyhradené",
"cmp.deploy": "Vyhradené nasadenie & SLA",
"cmp.estIncl": "Zavedenia zahrnuté",
"cmp.estSec": "Extra zavedenie",
"cmp.items": "Položky / mesiac",
"cmp.main": "1 hlavná",
"cmp.max20": "Max 20",
"cmp.members": "Pozvánky pre členov",
"cmp.onQuote": "Vlastná cenová ponuka",
"cmp.priority": "Priorita",
"cmp.starterEst": "1 zahrnuté + neobmedzené extra",
"cmp.stats": "Štatistiky",
"cmp.statsAdv": "Pokročilé",
"cmp.statsBasic": "Základné",
"cmp.support": "Podpora",
"cmp.unlimited": "Neobmedzené",
"cmp.upTo3": "Až 3",
"consent.required": "Musíte súhlasiť so zdieľaním vašich kontaktných údajov, aby ste mohli pokračovať.",
"consent.share": "Súhlasím, že nálezca mojej položky môže vidieť moje kontaktné údaje (meno, e-mail, telefón), aby ma mohol kontaktovať kvôli jej vráteniu.",
"cover.add": "Pridať",
"cover.change": "Zmeniť",
"cover.helper": "Zobrazené ako banner na vašej stránke správy a v adresári.",
"cover.none": "Žiadna obálková fotografia",
"cover.remove": "Odstrániť",
"cover.title": "Obálková fotografia",
"crop.desc": "Upravte orezanie na pomer banneru (3:1). Ťahajte a zoomujte.",
"crop.saving": "Ukladám…",
"crop.title": "Orezanie fotografie na titulku",
"cta.button": "Vytvoriť účet pre partnera",
"cta.subtitle": "Pridajte sa k zariadeniam, ktoré vracajú predmety rýchlejšie s findloop.",
"cta.title": "Pripravený znížiť množstvo stratených predmetov?",
"db.account.s": "Spravujte svoje zariadenie, predplatné a QR kód.",
"db.account.t": "Môj účet",
"db.declarations.s": "Zákazníci, ktorí nahlásili stratený predmet cez váš QR kód.",
"db.declarations.t": "Nahlásenia straty",
"db.deposit.s": "Pridajte fotografiu, kategóriu a popis.",
"db.deposit.t": "Nahlásiť nájdený predmet",
"db.registry.s": "Všetky nájdené predmety zaznamenané vo vašom zariadení.",
"db.registry.t": "Registrácia predmetov",
"db.reviews.s": "Odpovedzte verejne na recenzie vašich zákazníkov.",
"db.reviews.t": "Recenzie zákazníkov",
"db.shipments.s": "Vytvorte štítky a sledujte balíky na odoslanie.",
"db.shipments.t": "Zásielky",
"db.stats.s": "Vaše kľúčové ukazovatele výkonnosti.",
"db.stats.t": "Štatistiky",
"db.team.s": "Pozvite svojich kolegov na správu predmetov.",
"db.team.t": "Tím",
"dc.partnerDesc": "Stratili ste predmet v partnerskom zariadení (hotel, stanica, hala…)? Vyberte ho pre priamy návrat.",
"dc.partnerList": "Vyberte zo zoznamu",
"dc.partnerMap": "Vyberte na mape",
"dc.partnerTitle": "Nahlásenie na partnera",
"dc.publicCta": "Zverejniť verejnú reklamu",
"dc.publicDesc": "Vaša reklama bude viditeľná pre celú komunitu findloop. Ideálne, ak neviete, kde ste predmet stratili.",
"dc.publicTitle": "Verejné nahlásenie",
"dc.subtitle": "Vyberte spôsob, ako nahlásiť váš stratený predmet.",
"dc.title": "Čo by ste chceli robiť?",
"dec.addrPending": "Adresa čakajúca od zákazníka",
"dec.analyzing": "Analyzujem…",
"dec.badge": "Nahlásenie straty",
"dec.category": "Kategória predmetu",
"dec.clientDescription": "Popis od zákazníka",
"dec.clientPhoto": "Fotografia poskytnutá zákazníkom",
"dec.clientPhotoShort": "Fotografia zákazníka",
"dec.comparePhotos": "Porovnať fotografie",
"dec.contactTitle": "Vaše kontaktné údaje",
"dec.date": "Dátum straty",
"dec.declaredItemPhoto": "Fotografia nahláseného predmetu",
"dec.descPh": "Popíšte predmet: značka, farba, charakteristické znaky…",
"dec.description": "Popis",
"dec.email": "Email",
"dec.emptyDesc": "Zdieľajte svoj QR kód, aby ste prijímali nahlásenia.",
"dec.emptyTitle": "Žiadne nahlásenia",
"dec.enlarge": "Zväčšiť",
"dec.extBanner": "{n} externých platob(í) na potvrdenie - potvrďte prijatie nižšie, aby ste odomkli odovzdanie alebo odoslanie.",
"dec.foundItemAlt": "Nájdený predmet",
"dec.foundItemRegistry": "Nájdený predmet (registrácia)",
"dec.home": "Späť na domovskú stránku",
"dec.labelClient": "Zákazník",
"dec.labelRegistry": "Registrácia",
"dec.matchFound": "Zhodu už identifikovali!",
"dec.name": "Celé meno",
"dec.noMatchYet": "Zatiaľ žiadna zhoda.",
"dec.noPhoto": "Žiadna fotografia",
"dec.notfound": "Partner nenájdený.",
"dec.pRecup": "obnova",
"dec.pRecupP": "(obnova)",
"dec.pRecupShip": "(obnova + odoslanie)",
"dec.payConfirmed": "Platba {x} potvrdená",
"dec.payPending": "Externá platba {x} čaká",
"dec.phone": "Telefón",
"dec.pickup": "Osobné vyzdvihnutie",
"dec.place": "Miesto straty",
"dec.placePh": "napr. pri bare, miestnosť 204…",
"dec.recoverBtn": "Obnoviť moju položku",
"dec.reject": "Odmietnuť",
"dec.rerun": "Zopakovať analýzu",
"dec.similarity": "Podobnosť {n}%",
"dec.submit": "Odoslať moju správu",
"dec.submitting": "Posielam…",
"dec.successText": "Hľadáme vašu položku medzi tými, ktoré sú uložené na",
"dec.successTitle": "Správa odoslaná!",
"dec.suggestedMatches": "Navrhované zhody",
"dec.toColon": " do:",
"dec.toShip": "Na odoslanie",
"dec.toastExtPay": "Platba potvrdená — zákazník bude informovaný.",
"dec.toastMatch": "Zhodnotenie potvrdené",
"dec.toastReject": "Návrh odmietnutý",
"dec.toastRerun": "Analýza reštartovaná",
"dec.toastVisualN": "{n} vizuálne zhod(y)",
"dec.toastVisualNone": "Žiadna vizuálna zhoda",
"dec.trackBtn": "Sledovať moju správu",
"dec.viewBeforeAfter": "Prehľad pred/po (prekrývanie)",
"dec.viewSideBySide": "Bočný pohľad",
"dec.visualCompare": "AI vizuálne porovnanie",
"dec.visualIdle": "Spustite porovnanie, aby AI vizuálne porovnala fotografiu zákazníka s nájdenými položkami.",
"dec.visualRunning": "AI porovnáva fotografiu zákazníka s položkami vo vašej registrácii…",
"dec.zoomPhoto": "Zväčšiť fotografiu",
"dep.addAnyway": "Pridať aj tak",
"dep.addError": "Chyba pri pridávaní",
"dep.addItem": "Pridať položku",
"dep.added": "Položka pridaná do registrácie!",
"dep.adding": "Pridávam…",
"dep.aiError": "AI analýza momentálne nie je k dispozícii.",
"dep.aiFilled": "Formulár predvyplnený AI ✨",
"dep.aiUnavailable": "AI nedostupná — vyplňte formulár ručne.",
"dep.analyzing": "Analyzujem…",
"dep.analyzingPhoto": "Analyzujem fotografiu…",
"dep.brand": "Značka",
"dep.brandPlaceholder": "napr. Apple",
"dep.category": "Kategória",
"dep.checkingDup": "Kontrolujem duplikáty…",
"dep.color": "Farba",
"dep.colorPlaceholder": "napr. čierna",
"dep.condition": "Stav",
"dep.conditionPlaceholder": "napr. dobrý stav",
"dep.depositorNote": "Poznámka vkladateľa",
"dep.depositorNoteHint": "Prevádzkové detaily napísané ručne. AI nikdy prepíše túto poznámku.",
"dep.depositorNotePlaceholder": "napr. obsah vrecka, značka ako je hlásená, detaily poskytnuté osobou…",
"dep.descPlaceholder": "napr. čierny iPhone 15 s priehľadným puzdrom, nájdený pri bare…",
"dep.description": "Popis",
"dep.dupHint": "Uistite sa, že nepridávate duplikát. Môžete pokračovať, ak je položka skutočne iná.",
"dep.dupTitle": "Podobná položka(y) už registrované",
"dep.dupWarn": "Podobná položka detekovaná — skontrolujte, potom kliknite znovu na potvrdenie.",
"dep.estHint": "Položka bude pridaná do registrácie tohto zariadenia.",
"dep.establishment": "Zariadenie",
"dep.fee": "Poplatok za obnovu (€) — voliteľné",
"dep.feePlaceholder": "Nechajte prázdne pre predvolenú cenu kategórie",
"dep.fillAI": "Vyplniť AI",
"dep.optional": "(nepovinné)",
"dep.photo": "Fotografia položky",
"dep.principal": "hlavné",
"dep.reqError": "Kategória a popis sú povinné.",
"dep.savedItem": "Registrovaná položka",
"dep.similarity": "Podobnosť",
"dep.storage": "Fyzická lokalita",
"dep.storageHint": "Kde je položka fyzicky uložená. QR kód bude vygenerovaný na jej nájdenie.",
"dep.storagePlaceholder": "napr. Polica A3, Skrinka 12, Trezor na recepcii",
"dl.aClient": "zákazník",
"dl.alertsBlocked": "Prehliadač blokuje upozornenia",
"dl.alertsBlockedHint": "Na opätovné povolenie: kliknite na ikonu 🔒 (alebo ⓘ) na ľavej strane adresy stránky, potom povoľte Upozornenia a obnovte stránku.",
"dl.amountDue": "Čiastka na zaplatenie: {amount} {currency}.",
"dl.enableAlerts": "Povoliť upozornenia",
"dl.extPending": "Platby na overenie",
"dl.freemiumNear": "Približujete sa k freemium limitu ({used}/{max} položiek tento mesiac). Prejdite na Starter pre neobmedzené položky.",
"dl.freemiumReached": "Dosiahnutý freemium limit ({used}/{max} položiek tento mesiac). Prejdite na Starter na registráciu neobmedzených položiek.",
"dl.invoiceOverdue": "Faktúra {num} nezaplatená — prístup obmedzený.",
"dl.matchNotifTitle": "Findloop — Nová AI zhoda 🔔",
"dl.matchToast": "Nová AI zhoda — {name}",
"dl.matchToastDesc": "Položka zodpovedá deklarácii.",
"dl.notifEmpty": "Zatiaľ žiadne upozornenia.",
"dl.notifEnabled": "Upozornenia prehliadača povolené",
"dl.notifTitle": "Upozornenia",
"dl.payInvoice": "Zaplatiť moju faktúru →",
"dl.rewardsPending": "Poukážky na predloženie",
"dl.upgradeStarter": "Prejsť na Starter →",
"est.all": "Všetky zariadenia ({n})",
"est.label": "Zariadenie",
"est.primary": "hlavné",
"est.secondary": "sekundárne",
"est2.add": "Pridať zariadenie",
"est2.addressLabel": "Adresa",
"est2.addressPh": "Ulica 12 République",
"est2.autoInvoice": "Podrobná faktúra sa automaticky vygeneruje 1. dňa každého mesiaca.",
"est2.baseSub": "Základné predplatné",
"est2.billing": "Fakturácia",
"est2.boostActivated": "Zvýšenie aktivované pre {name}",
"est2.boostBillingNote": "Fakturované za aktuálnu sadzbu a skupinovo na vašej súhrnnej mesačnej faktúre.",
"est2.boostCta": "Zvýšiť",
"est2.boostDesc": "Zlepšiť viditeľnosť tohto zariadenia v adresári a na mape.",
"est2.boostDuration": "{h}h zvýšenej viditeľnosti",
"est2.boostExtend": "Predĺžiť",
"est2.boostTitle": "Zvýšiť {name}",
"est2.boosted": "Zvýšené",
"est2.chartDesc": "Podiel vrátených položiek z celkového počtu registrovaných, miesto za miestom.",
"est2.chartTitle": "Miera vrátenia podľa zariadenia",
"est2.chartTooltip": "Vrátenie",
"est2.cityLabel": "Mesto",
"est2.cityPh": "Lyon",
"est2.contactHint": "Tieto údaje sú zobrazené zákazníkovi pre toto zariadenie (ak chýbajú, použijú sa údaje účtu).",
"est2.countryLabel": "Krajina",
"est2.coverLabel": "Obrázok na pozadí",
"est2.create": "Vytvoriť",
"est2.created": "Zariadenie vytvorené",
"est2.delete": "Zmazať",
"est2.deleteDesc": "Tento krok je trvalý. Zariadenie môžete zmazať iba v prípade, že neobsahuje žiadne položky.",
"est2.deleteTitle": "Zmazať “{name}”?",
"est2.deleted": "Zariadenie zmazané",
"est2.dialogDesc": "Zadajte názov a adresu tejto lokality.",
"est2.edit": "Upraviť",
"est2.editEst": "Upraviť zariadenie",
"est2.emailLabel": "Kontaktný e-mail",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " zariadenie/ia",
"est2.extraNoteBase": "{n} ďalšie zariadenie/ia fakturované",
"est2.extraPrice": " za {price} €/mesiac.",
"est2.extraQuote": " na základe cenovej ponuky.",
"est2.imgChange": "Vyberte obrázok",
"est2.imgDone": "Hotovo",
"est2.imgRemove": "Odstrániť",
"est2.imgRemoved": "Obrázok odstránený",
"est2.imgSaved": "Obrázok uložený",
"est2.imgUploading": "Nahráva sa…",
"est2.includedPlan": "Zahrnuté vo vašom pláne: {n}.",
"est2.kDeclarations": "Vyhlásenia",
"est2.kInStorage": "Na sklade",
"est2.kItemsTotal": "Položky (celkom)",
"est2.kRestituted": "Vrátené",
"est2.limitReached": "Dosiahnutý limit",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Vyhl.",
"est2.mItems": "Položky",
"est2.mRestituted": "Vrátené",
"est2.mStorage": "Na sklade",
"est2.monthlyTotal": "Celková suma za mesiac",
"est2.nameLabel": "Meno *",
"est2.namePh": "napr. Belmont Hotel — Lyon Annex",
"est2.newEst": "Nové zariadenie",
"est2.onQuote": "Na základe cenovej ponuky",
"est2.phoneLabel": "Telefón",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plán",
"est2.planLimited": "Váš plán „{tier}“ je obmedzený na {max} zariadenie/ia.",
"est2.primary": "Hlavné",
"est2.qr": "QR kód",
"est2.qrDesc": "Zobrazte tento QR kód v tomto zariadení. Zákazníci hlásiací stratu budú prepojení na túto lokalitu.",
"est2.qrTitle": "QR kód — {name}",
"est2.saving": "Ukladá sa…",
"est2.seeInvoices": "Zobraziť moje mesačné faktúry",
"est2.seePlans": "Zobraziť plány",
"est2.subtitle": "Spravujte všetky svoje lokality pod jedným účtom — konsolidovaný pohľad, položky, QR kód a fakturácia.",
"est2.suspended": "Pozastavené",
"est2.tierFree": "1 zariadenie",
"est2.tierLarge": "neobmedzené zariadenia",
"est2.tierMedium": "5 zariadení zahrnutých",
"est2.tierSmall": "3 zariadenia zahrnuté",
"est2.title": "Zariadenia",
"est2.unlimitedPlan": "Váš plán umožňuje neobmedzený počet zariadení.",
"est2.unlimitedSuffix": " · neobmedzené",
"est2.updated": "Zariadenie aktualizované",
"est2.upgradeHint": "Prejdite na vyšší plán, aby ste pridali viac lokalít a centralizovali všetku svoju činnosť.",
"est2.visuals": "Logo a fotografie",
"est2.visualsDesc": "Prispôsobte logo a obalovú fotografiu tohto zariadenia. Objavia sa na jeho verejnej stránke a vo formulári vyhlásenia.",
"est2.visualsTitle": "Vizualizácie — {name}",
"est2.workOn": "Pracujte na tomto zariadení",
"est2.working": "Pracujete na „{name}“",
"ev.created": "Správa vytvorená",
"ev.matched": "Identifikovaná zodpovedajúca položka",
"ev.paid": "Poplatok za obnovu zaplatený",
"ev.pickup": "Osobný odber",
"ev.shipped": "Zasielka odoslaná",
"ev.shipping_paid": "Poplatok za dopravu zaplatený",
"ev.shipping_requested": "Doprava požadovaná",
"feat1.d": "KPI, miera vrátenia podľa kategórie, príjmy a trendy za 30 dní.",
"feat1.t": "Nástenka & analytika",
"feat2.d": "Štítky, sledovanie nosičov a automatické sledovacie e-maily.",
"feat2.t": "Modul dopravy",
"feat3.d": "Zákazníci vás nájdu podľa mesta a kategórie, s certifikovanými recenziami.",
"feat3.t": "Verejný adresár & recenzie",
"fp.backToRanking": "Späť na rebríček",
"fp.badge": "Odznak",
"fp.hero": "Finder hrdina",
"fp.notFound": "Profil nenájdený alebo súkromný.",
"fp.scoreTotal": "Celkové body",
"fp.scoreYear": "Body v",
"fp.share": "Zdieľať tento profil",
"fp.shareText": "Pozrite si finder profil používateľa {name} na Findloop!",
"fp.tagline": "Čestný finder, ktorý robí svet lepším miestom.",
"ft.backAccount": "Späť na Môj účet",
"ft.closeBtn": "Zavrieť prípad",
"ft.closeConfirm": "Potvrdiť, že položka bola vrátená? Inzerát bude uzavretý.",
"ft.closeLockedHint": "Najskôr overte kód vlastníka, aby ste odblokovali uzatvorenie.",
"ft.closed": "Prípad uzavretý — položka vrátená!",
"ft.codeLabel": "Zadajte validačný kód, ktorý ste dostali od vlastníka",
"ft.codeNeeded": "Zadajte validačný kód, prosím.",
"ft.codeOk": "Kód overený — môžete uzavrieť prípad.",
"ft.codePlaceholder": "napr. 4821",
"ft.codeVerified": "Overený",
"ft.doneMsg": "Položka vrátená. Ďakujeme, že ste pomohli vrátiť ju jej vlastníkovi!",
"ft.stepInProgress": "Vrátenie prebieha",
"ft.stepPublished": "Inzerát publikovaný",
"ft.stepReturned": "Položka vrátená",
"ft.subtitle": "Nasledujte kroky, kým sa nájdená položka nevráti.",
"ft.title": "Sledovanie vrátenia",
"ft.verifyBtn": "Overiť kód",
"hero.badge": "Odporúčané",
"hero.ctaFound": "Našiel som položku",
"hero.ctaLost": "Stratil som položku",
"hero.ctaPartner": "Staňte sa partnerom",
"hero.subtitle": "Findloop pomáha zariadeniam spravovať nájdené položky — a umožňuje ich zákazníkom hlásiť straty a následne si obnoviť svoje veci, na mieste alebo zaslaním.",
"hero.title": "Každá stratená položka nájde svojho vlastníka.",
"home.champBecome": "Staňte sa finderom",
"home.champCta": "Pozrite si rebríček",
"home.champSubtitle": "Každá vrátená položka získa body. Pridajte sa do rebríčka a získajte odmeny.",
"home.champTitle": "Naši najlepší finderi",
"how.eyebrow": "Ako to funguje",
"how.title": "Od odovzdania po vrátenie, bez námahy.",
"inv.all": "Všetko",
"inv.allYears": "Všetky roky",
"inv.count": "Faktúry",
"inv.due": "splatné",
"inv.empty": "Zatiaľ žiadne faktúry.",
"inv.exportCsv": "Exportovať CSV",
"inv.invoicePdf": "Faktúra PDF",
"inv.issued": "Vydané",
"inv.noMatch": "Žiadna faktúra pre tento filter.",
"inv.paid": "Zaplatené (€)",
"inv.paidOn": "zaplatené dňa",
"inv.pay": "Platiť",
"inv.receipt": "Doklad",
"inv.reminders": "Pripomienky",
"inv.remindersDesc": "Pripomienky e-mailom a SMS poslané k tejto faktúre.",
"inv.remindersEmpty": "Žiadna pripomienka nebola odoslaná.",
"inv.rmDue": "Pripomienka k dátumu splatnosti",
"inv.rmManual": "Manuálna pripomienka",
"inv.rmSms": "SMS pripomienka D+30",
"inv.rmStage": "Pripomienka",
"inv.statusPaid": "Zaplatené",
"inv.statusUnpaid": "Nezaplatené",
"inv.subtitle": "Zobrazte a stiahnite si svoje faktúry a doklady.",
"inv.title": "Moje faktúry",
"inv.unpaid": "Nezaplatené (€)",
"inv2.contractTitle": "Moja Findloop zmluva",
"inv2.detailByEst": "Detail podľa zariadenia",
"inv2.dueLabel": "Splatné:",
"inv2.dueSuffix": " · splatné {date}",
"inv2.error": "Chyba {status}",
"inv2.estCountIssued": "{n} zariadení · vydané {date}",
"inv2.estimate": "Odhad (nezaúčtované) · {n} zariadení",
"inv2.expired": " · expirované",
"inv2.exportCsv": "Exportovať CSV",
"inv2.exportDone": "CSV export stiahnutý",
"inv2.included": "Zahrnuté",
"inv2.monthlyTitle": "Mesačné faktúrovanie (predplatné)",
"inv2.months": "+{n} mesiacov",
"inv2.paid": "Zaplatené",
"inv2.pay": "Platiť",
"inv2.previewTitle": "Náhľad vašej nasledujúcej faktúry —",
"inv2.renew": "Obnoviť moju zmluvu",
"inv2.renewalsTitle": "História obnovy ({n})",
"inv2.renewedUntil": "Zmluva obnovena do {date}",
"inv2.serviceTitle": "Faktúry za služby (údaje a ponuky)",
"inv2.soon": "Čoskoro expiruje",
"inv2.toPay": "Na zaplatenie",
"inv2.totalHtTva": "Celkom bez DPH · DPH",
"inv2.totalTtc": "Celkom vrátane DPH",
"iu.addPhoto": "Pridať fotku",
"iu.change": "Zmeniť",
"lang.label": "Jazyk",
"lb.allCountries": "Všetky krajiny",
"lb.badge": "Ročný rebríček",
"lb.champion": "🏆 Majster roka",
"lb.cityPh": "Filtrovať podľa mesta…",
"lb.empty": "Pre tieto filtre zatiaľ nie je žiadne umiestnenie.",
"lb.pts": "body",
"lb.resetNote": "Rebríček aktuálneho roku — resetuje sa každý 1. január.",
"lb.returned": "vrátené",
"lb.share": "Zdieľať rebríček",
"lb.shareText": "Pozrite si najlepších nálezcov v rebríčku na Findloop!",
"lb.subtitle": "Každé vrátenie prináša body. Rebríček sa resetuje každý 1. január.",
"lb.tabFinders": "Nálezcovia",
"lb.tabPartners": "Zariadenia",
"lb.title": "Najlepší nálezcovia",
"lost.b2bDesc": "Stratili ste to v hoteli, prepravnom uzle alebo partnerskom zariadení? Nájdite zariadenie a nahláste svoju stratu.",
"lost.b2bTitle": "Nahlásiť partnerovi",
"lost.b2cDesc": "Uverejnite inzerát viditeľný pre všetkých, ponúknite odmenu a zvýšte jeho dosah, aby ste maximalizovali svoje šance.",
"lost.b2cTitle": "Uverejniť verejný inzerát",
"lost.desc": "Vyberte, ako by ste chceli pokračovať.",
"lost.title": "Stratil si predmet?",
"map.allCategories": "Všetky kategórie",
"map.clear": "Resetovať",
"map.exitFullscreen": "Zavrieť",
"map.filterCity": "Mesto alebo krajina…",
"map.fullscreen": "Celá obrazovka",
"map.heatmap": "Teplotná mapa",
"map.high": "Vysoké",
"map.impactMonth": "predmety vrátené tento mesiac",
"map.impactTotal": "vrátené celkom",
"map.legend": "Farebné body od červenej (nízka) po zelenú (vysoká) na základe miery vrátenia; veľkosť na základe počtu predmetov.",
"map.locating": "Hľadanie… pridaj adresu k svojim prevádzkam, aby si ich videl na mape.",
"map.low": "Nízke",
"map.mAll": "Všetko",
"map.mFound": "Nájdené",
"map.mLost": "Stratené",
"map.medium": "Stredné",
"map.noItemRegistered": "Žiadny predmet registrovaný",
"map.noItems": "Žiadny predmet",
"map.period30": "Posledných 30 dní",
"map.period7": "Posledných 7 dní",
"map.period90": "Posledných 90 dní",
"map.periodAll": "Počas celého času",
"map.returnedSuffix": "vrátené · {a}/{t} predmetov",
"map.stats": "Štatistiky mesta",
"map.statsTop": "Top 5 miest (stratené predmety)",
"map.statsTrend": "6-mesačný trend",
"map.title": "Mapa tvojich prevádzok",
"map.topPlaces": "Populárne miesta",
"mc.adClosed": "Zoznam uzavretý",
"mc.addPhoto": "Pridať fotografiu",
"mc.adsNone": "Žiadny inzerát o stratenom predmete.",
"mc.archiveHide": "Skryť históriu",
"mc.archiveNone": "Žiadny vyriešený prípad zatiaľ.",
"mc.archiveShow": "Zobraziť históriu",
"mc.archiveSub": "Vyriešené a vrátené prípady.",
"mc.archiveTitle": "História",
"mc.at": "Na",
"mc.backToLogin": "Späť na prihlásenie",
"mc.boostContacts": "Kontakty (zvýšiť)",
"mc.boostViews": "Zobrazenia (zvýšiť)",
"mc.cancel": "Zrušiť",
"mc.certificate": "Certifikát",
"mc.changePhoto": "Zmeniť fotografiu",
"mc.city": "Mesto",
"mc.closeAd": "Zavrieť",
"mc.closeAdConfirm": "Zavrieť tento inzerát? Už nebude viditeľný a uvoľní miesto.",
"mc.confirmPassword": "Potvrdiť heslo",
"mc.confirmRestitution": "Potvrdiť vrátenie",
"mc.connect": "Pripojiť",
"mc.contacts": "Kontakty",
"mc.country": "Krajina",
"mc.declareFound": "Nahlásiť nájdený predmet",
"mc.declareFoundSub": "Pridať predmet, ktorý si našiel",
"mc.declareLost": "Nahlásiť stratu",
"mc.declareLostSub": "Pridať inzerát o stratenom predmete",
"mc.deleteAccount": "Vymazať môj účet",
"mc.deleteConfirm": "Áno, vymazať môj účet",
"mc.deleteConfirmBody": "Tvoj účet bude trvalo vymazaný a tvoje osobné údaje anonymizované. Túto akciu nie je možné vziať späť.",
"mc.deleteConfirmTitle": "Vymazať tvoj účet?",
"mc.deleteDesc": "Trvalo vymaže váš účet a anonymizuje vaše osobné údaje. Túto akciu nie je možné zvrátiť.",
"mc.deleted": "Váš účet bol vymazaný.",
"mc.deleting": "Vymazávanie…",
"mc.email": "Email",
"mc.expiresOn": "Expiruje dňa",
"mc.exportData": "Stiahnuť moje údaje (GDPR)",
"mc.exportDone": "Vaše údaje boli stiahnuté.",
"mc.exporting": "Pripravujem…",
"mc.finderAccepted": "Akceptované",
"mc.finderProfile": "Profil nájdenia (voliteľné)",
"mc.finderProfileDesc": "Získajte body vrátením predmetov a objavte sa na verejnom rebríčku.",
"mc.forYourAd": "Pre vašu ponuku",
"mc.forgotLink": "Zabudli ste heslo?",
"mc.forgotSend": "Odoslať odkaz",
"mc.forgotSent": "Ak účet existuje pre tento email, odkaz na obnovenie bol práve odoslaný.",
"mc.forgotTitle": "Zabudli ste heslo",
"mc.foundAdsNone": "Žiadne inzeráty nájdených predmetov neboli publikované.",
"mc.foundAt": "Nájdené na",
"mc.foundNone": "Žiadny nájdený predmet nebol nahlásený.",
"mc.hAd": "Stratený inzerát",
"mc.hDeclaration": "Vyhlásenie",
"mc.hFinderContact": "Nahlásený predmet",
"mc.hFound": "Vrátený predmet",
"mc.hFoundAd": "Inzerát o nájdení",
"mc.histEarned": "Predmet vrátený",
"mc.historyTitle": "Moja história bodov",
"mc.loginBtn": "Prihlásiť sa",
"mc.loginTitle": "Prihlásenie zákazníka",
"mc.logout": "Odhlásiť sa",
"mc.lostAt": "Stratené na",
"mc.matchPartner": "Pri partnerovi",
"mc.matchPublic": "Nájdený predmet",
"mc.matches": "Zápasy",
"mc.matchesSub": "Nájdené predmety môžu zodpovedať vašim inzerátom o stratených predmetoch.",
"mc.myAds": "Moje inzeráty o stratených predmetoch",
"mc.myDeclarations": "Moje nahlásenia",
"mc.myFinds": "Predmety, ktoré som našiel",
"mc.myFindsNone": "Ešte ste nenahlásili žiadny nájdený predmet.",
"mc.myFindsSub": "Predmety, ktoré ste nahlásili ako nájdené v inzerátoch o stratených predmetoch.",
"mc.myFound": "Nahlásené nájdené predmety",
"mc.myFoundAds": "Moje inzeráty o nájdených predmetoch",
"mc.myRewards": "Moje poukážky",
"mc.name": "Celé meno",
"mc.newPassword": "Nové heslo",
"mc.none": "Žiadne nahlásenie zatiaľ.",
"mc.notEnough": "Nedostatočné body",
"mc.notifEmpty": "Žiadne notifikácie zatiaľ.",
"mc.notifOpen": "Zobraziť",
"mc.notifTitle": "Notifikácie",
"mc.notifTrack": "Sledovať",
"mc.notifViewAd": "Zobraziť inzerát",
"mc.optInDesc": "Voliteľná účasť. Súhlasíte s verejným zobrazením predmetov vybraných nižšie. Zmeniteľné kedykoľvek.",
"mc.optInTitle": "Objaviť sa na verejnom rebríčku",
"mc.password": "Heslo",
"mc.passwordMismatch": "Heslá sa nezhodujú.",
"mc.phone": "Telefón",
"mc.photoUpdated": "Profilová fotka bola aktualizovaná",
"mc.pointsAwaiting": "Body čakajúce",
"mc.pointsBalance": "Body na utratenie",
"mc.pointsOk": "Body pripísané",
"mc.presentHint": "Ukáž tento QR partnerovi: oskenuje ho, aby si potvrdil svoju odmenu.",
"mc.presentInStore": "Zobraziť v obchode",
"mc.presentTitle": "Zobraziť tento poukaz",
"mc.privacy": "Ochrana súkromia & dáta",
"mc.privacyDesc": "Stiahni kópiu všetkých osobných údajov, ktoré má Findloop o tebe (GDPR, čl. 15 & 20).",
"mc.profileSaved": "Profil aktualizovaný.",
"mc.profileSettings": "Verejný profil & leaderboard",
"mc.pseudo": "Meno alebo prezývka",
"mc.redExpired": "Expirácie",
"mc.redReady": "Ukázať partnerovi",
"mc.redUsed": "Použité",
"mc.redeem": "Uplatniť",
"mc.registerBtn": "Vytvoriť môj účet",
"mc.registerTitle": "Vytvoriť účet zákazníka",
"mc.rememberMe": "Pamätať si ma",
"mc.remove": "Odstrániť",
"mc.resetDone": "Heslo bolo aktualizované. Teraz sa môžeš prihlásiť.",
"mc.resetExpired": "Tento odkaz na resetovanie je neplatný alebo vypršal. Požiadaj o nový nižšie.",
"mc.resetSave": "Resetovať moje heslo",
"mc.resetTitle": "Nové heslo",
"mc.restitutionConfirmed": "Vrátenie potvrdené.",
"mc.reward": "Odmena",
"mc.rewardRedeemed": "Odmena odomknutá! Kód:",
"mc.rewardsDesc": "Použi svoje body na výhody, ktoré ponúkajú naši partneri. Zostatok:",
"mc.rewardsNone": "Zatiaľ žiadna odmena nie je k dispozícii.",
"mc.rewardsTitle": "Utratiť moje body",
"mc.scoreAwarded": "Skvelá práca! +1 k tvojmu Finder Score 🎉",
"mc.scoreEarned": "Získaný bod",
"mc.scorePts": "b.",
"mc.scoreThisYear": "Tento rok",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Zobraziť leaderboard",
"mc.share": "Zdieľať",
"mc.statsTitle": "Štatistiky",
"mc.subtitle": "Sleduj všetky svoje správy na jednom mieste.",
"mc.title": "Môj účet",
"mc.toLogin": "Už registrovaný?",
"mc.toRegister": "Ešte nemáš účet?",
"mc.track": "Sledovať",
"mc.views": "Zobrazenia",
"mc.visCity": "Mesto",
"mc.visCountry": "Krajina",
"mc.visLabel": "Položky viditeľné na leaderboarde:",
"mc.visName": "Meno / prezývka",
"mc.visPhoto": "Profilová fotka",
"mc.welcome": "Ahoj",
"mc2.acceptFinder": "Akceptuj tohto nálezcu",
"mc2.accountActivity": "Aktivita účtu",
"mc2.adsActive": "{n}/5 aktívnych inzerátov",
"mc2.autoDelete": "Automatické odstránenie naplánované na",
"mc2.badgeBronze": "Bronzový",
"mc2.badgeGold": "Zlatý",
"mc2.badgeSilver": "Strieborný",
"mc2.boostEarnedAlready": "Už ti to vynieslo",
"mc2.boostEarnedWin": "Získal si",
"mc2.boostExpiredWin": "Tvoja akcelerácia práve vypršala — obnov za -20%!",
"mc2.boostExpiresIn": "Tvoja akcelerácia vyprší za",
"mc2.boostWinDetail2": ". -20% sa automaticky uplatní, ak obnovíš do 24h.",
"mc2.claimCode": "Kód pre uplatnenie:",
"mc2.codeSentFinder": "Kód odoslaný nálezcovi e-mailom",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Stiahnuť moju faktúru",
"mc2.error": "Chyba {status}",
"mc2.finderAccepted": "Finder prijatý — kód odoslaný emailom",
"mc2.finderContacts": "Kontaktné údaje finder(a)",
"mc2.followFindo": "Sledujte Findloop",
"mc2.imgInvalid": "Neplatný obrázok",
"mc2.inactivityNote": " — v prípade {n} mesiacov nečinnosti (GDPR).",
"mc2.lastActivity": "Posledná aktivita:",
"mc2.lostEmailTitle": "Viac nemám prístup k svojmu emailu",
"mc2.noPhotoPreset": "Ešte nemáte fotku? Vyberte si predvolený avatar:",
"mc2.paidViaPartner": "Zaplatené (cez partnera)",
"mc2.payRecovery": "Zaplatiť poplatok za obnovenie",
"mc2.paySettle": "Uhradiť moju platbu",
"mc2.payShipping": "Zaplatiť poplatok za dopravu",
"mc2.payUnavailable": "Platba nedostupná",
"mc2.peopleFound": "{n} osoba(y) si myslia, že našli váš predmet",
"mc2.phoneNumber": "Telefónne číslo",
"mc2.reactivateAccount": "Znovu aktivovať môj účet",
"mc2.reactivated": "Účet znovu aktivovaný",
"mc2.reactivatedThanks": "Účet znovu aktivovaný — ďakujeme za vašu vernosť!",
"mc2.recoverSmsBtn": "Získať môj kód SMS",
"mc2.recoverSmsDesc": "Prihláste sa na prijatie kódu cez SMS na číslo registrované vo vašom účte.",
"mc2.recoverSmsFallback": "Ak účet existuje s týmto číslom, SMS bola odoslaná.",
"mc2.renewStayTop": ". Obnovte, aby ste zostali na vrchole a získali váš predmet späť.",
"mc2.resume20": "Pokračovať -20%",
"mc2.unlockContacts": "Odkryť kontaktné údaje",
"mc2.unlockDesc": "Zaplaťte poplatok za spracovanie Findloop, aby ste odhalili ich kontaktné údaje a dohodli odovzdanie.",
"mc2.viewsWord": "zhliadnutí",
"mc2.live": "Naživo",
"mh.allCategories": "Všetky kategórie",
"mh.allPeriod": "Celý čas",
"mh.autoMatch": "Automatické AI priradenie",
"mh.blocked": "Zablokované (rozpor)",
"mh.blockedReason": "Zápas zablokovaný: hlavné kľúčové slová predmetu a vyhlásenie si navzájom odporujú.",
"mh.days30": "Posledných 30 dní",
"mh.days7": "Posledných 7 dní",
"mh.days90": "Posledných 90 dní",
"mh.emptyDesc": "AI zápasy sa tu objavia, keď prídu vyhlásenia.",
"mh.emptyTitle": "Žiadne udalosti",
"mh.exportCsv": "Exportovať CSV",
"mh.exportDone": "CSV export stiahnutý",
"mh.exportImpossible": "Export sa nepodaril",
"mh.fBlocked": "Zablokované",
"mh.fConfirmed": "Potvrdené",
"mh.fRejected": "Odmietnuté",
"mh.objectLabel": "Predmet:",
"mh.refresh": "Obnoviť",
"mh.rejected": "Odmietnuté",
"mh.srcManual": "Ručný",
"mh.srcText": "Text",
"mh.srcVisual": "Vizual (foto)",
"mh.subtitle": "Záznam zápasov navrhnutých AI — automaticky priradené, potvrdené a odmietnuté.",
"mh.title": "AI História",
"nav.ads": "Stratené predmety",
"nav.dashboard": "Môj priestor",
"nav.found": "Nájdené predmety",
"nav.how": "Ako to funguje",
"nav.login": "Prihlásiť sa",
"nav.map": "Mapa",
"nav.more": "Viac",
"nav.partners": "Partneri",
"nav.pricing": "Cenník",
"nav.ranking": "Rebríček",
"nav.register": "Staňte sa partnerom",
"nav.track": "Sledovať hlásenie",
"nf.desc": "Stránka, ktorú hľadáte, neexistuje alebo bola presunutá.",
"nf.home": "Späť domov",
"nf.title": "Stránka nenájdená",
"par.allCities": "Všetky mestá",
"par.allCountries": "Všetky krajiny",
"par.badge": "Adresár",
"par.certified": "Certifikovaný",
"par.certifiedBadge": "Certifikovaný",
"par.cityPh": "Mesto",
"par.declare": "Nahlásiť",
"par.none": "Žiadny partner nenájdený.",
"par.partnerBadge": "Partner",
"par.searchPh": "Hľadať zariadenie…",
"par.subtitle": "Nájdite zariadenie, kde ste stratili svoj predmet, a nahláste svoju stratu.",
"par.title": "Naši partneri",
"pay.addr1": "Adresa",
"pay.addr2": "Adresa riadok 2 (voliteľné)",
"pay.addrIncomplete": "Vyplňte prosím svoju doručovaciu adresu.",
"pay.badge": "Obnova",
"pay.card": "Platiť kartou",
"pay.city": "Mesto",
"pay.country": "Krajina",
"pay.eurNote": "Sumy sú uvedené v eurách (€).",
"pay.fee": "Poplatok za obnovu",
"pay.free": "zadarmo",
"pay.howRecover": "Ako by ste si chceli získať svoj predmet späť?",
"pay.momo": "Platiť cez Mobilné peniaze",
"pay.momoConfirm": "Potvrdiť platbu",
"pay.noMatch": "Pre toto hlásenie zatiaľ nebol potvrdený žiadny zhodný predmet.",
"pay.notfound": "Hlásenie nenájdené.",
"pay.phonePh": "Telefónne číslo",
"pay.pickup": "Osobne vyzdvihnúť",
"pay.pickupDesc": "Na",
"pay.postal": "PSČ",
"pay.secure": "Bezpečná platba",
"pay.serviceFee": "Findloop poplatok za službu",
"pay.ship": "Poslať mi",
"pay.shipAfter": "— ponúkané po platbe.",
"pay.shipDesc": "Doručenie na moju adresu",
"pay.shipNote": "Doprava dostupná",
"pay.shipping": "Poplatok za dopravu",
"pay.subtitleWith": "Zaplaťte poplatok za obnovu na",
"pay.title": "Obnoviť môj predmet",
"pay.total": "Celkom",
"pcat.city_hall": "Mestské úrady",
"pcat.hotel": "Hotely",
"pcat.other": "Iné",
"pcat.park": "Parks",
"pcat.prefecture": "Prefektúry",
"pcat.restaurant": "Reštaurácie",
"pcat.uncategorized": "Nezaradené",
"pd.about": "O nás",
"pd.back": "Všetci partneri",
"pd.certified": "Certifikovaný partner",
"pd.declare": "Nahlásiť stratu tu",
"pd.itemsReturned": "vrátené položky",
"pd.itemsTotal": "registrované položky",
"pd.map": "Poloha",
"pd.noItems": "Nenašli sa žiadne položky.",
"pd.noReviews": "Žiadne recenzie zatiaľ.",
"pd.notFound": "Partner nebol nájdený.",
"pd.recentItems": "Nedávno nájdené položky",
"pd.reply": "Odpoveď od prevádzky",
"pd.reviews": "Recenzie zákazníkov",
"pd.verified": "Overená recenzia",
"pd.verifiedEstablishment": "overená prevádzka Findloop",
"pg.next": "Ďalšie",
"pg.prev": "Predchádzajúce",
"pg.showing": "{from}–{to} z {total}",
"pk.bodyCopy": "Text",
"pk.bodyText": "Hlavný text",
"pk.brandColors": "Farby značky",
"pk.colorRed": "Červená",
"pk.colorWhite": "Biela",
"pk.darkBg": "Tmavé pozadie",
"pk.download": "Stiahnuť",
"pk.downloadZip": "Stiahnuť celý balík (ZIP)",
"pk.headings": "Nadpisy",
"pk.heroDesc": "Oficiálne logá, bannery na sociálne siete, farby a typografia. Vyberte jazyk a variant sloganu, potom si stiahnite vizuál alebo celý balík.",
"pk.lightBg": "Svetlé pozadie (tlač)",
"pk.logoWordmark": "Logo / slovná značka",
"pk.logosVisuals": "Logá a vizuály",
"pk.mapCollect": "Mapa / odberné body",
"pk.plain": "Jednoduché",
"pk.pressKit": "Tlačový balík",
"pk.taglineLang": "Jazyk sloganu",
"pk.typography": "Typografia",
"pk.variant": "Variant",
"pr.shipBtn": "Nechajte položku poslať",
"pr2.adBoostMsg": "Skvelá voľba! Násobíte svoje šance na rýchle získanie vašej položky.",
"pr2.boostActivated": "Zvýšenie aktívne!",
"pr2.canRecoverNow": "Teraz môžete získať svoju položku späť.",
"pr2.continue": "Pokračovať",
"pr2.downloadReceiptPdf": "Stiahnuť potvrdenie (PDF)",
"pr2.goToSpaceNow": "Prejsť do môjho účtu teraz",
"pr2.partnerBoostMsg": "Skvelá voľba! Byť viac viditeľný znamená prilákať nových zákazníkov do vašej prevádzky.",
"pr2.paymentSuccess": "Platba úspešná!",
"pr2.redirectingSpace": "Presmerovávanie na váš účet…",
"pr2.subActivated": "Platba úspešná! Vaša predplatné je aktívne, teraz môžete spravovať vaše prevádzky.",
"prev.allSites": "Všetky prevádzky",
"prev.editReply": "Upraviť odpoveď",
"prev.none": "Žiadna recenzia zatiaľ.",
"prev.published": "Odpoveď publikovaná",
"prev.reply": "Odpoveď",
"prev.replyPh": "Napíšte zdvorilú odpoveď…",
"prev.send": "Publikovať odpoveď",
"prev.sending": "Publikovanie…",
"prev.yourReply": "Vaša odpoveď",
"pricing.annual": "Ročne",
"pricing.annualBadge": "-20% ponuka",
"pricing.choose": "Vybrať",
"pricing.compareFeature": "Funkcia",
"pricing.compareTitle": "Porovnať plány",
"pricing.eyebrow": "Cenník",
"pricing.month": "/mesiac",
"pricing.monthly": "Mesačne",
"pricing.perYear": "/rok",
"pricing.popular": "Populárne",
"pricing.quoteMsg": "Vaše požiadavky (nepovinné)",
"pricing.quoteOrg": "Organizácia",
"pricing.quoteSend": "Odoslať požiadavku",
"pricing.quoteSent": "Požiadavka odoslaná! Čoskoro sa Vám ozveme.",
"pricing.quoteSites": "Počet stránok / terminálov",
"pricing.quoteTitle": "Požiadanie o cenovú ponuku",
"pricing.requestQuote": "Požiadanie o cenovú ponuku",
"pricing.saveLabel": "Ušetríte",
"pricing.savePerYear": "/rok za každý ďalší objekt",
"pricing.start": "Začať",
"pricing.subtitle": "Začnite zadarmo, rozširujte sa, ako rastiete.",
"pricing.title": "Plán pre každú organizáciu",
"promo.badge": "Partnerský program",
"promo.cta": "Zistiť viac",
"promo.text": "Každý partner, ktorého odporučíte a ktorý sa zaregistruje, vám prinesie jeden mesiac zadarmo. Bez obmedzenia.",
"promo.title": "Odporučte partnera, získajte mesiac zdarma.",
"pub.accessGranted": "Prístup povolený",
"pub.accessLimited2h": "Prístup obmedzený na 2 hodiny",
"pub.accountEmailConcerned": "Email účtu, ktorého sa to týka",
"pub.adAppearPublic": "Takto sa vaša reklama bude zobrazovať verejne.",
"pub.adPreviewBtn": "Náhľad reklamy",
"pub.alertMeOnArrival": "Upozorniť ma na príchod",
"pub.allActionsLogged": "Všetky akcie sú zaznamenané",
"pub.allCategories": "Všetky kategórie",
"pub.authorizeAccess": "Povoliť prístup",
"pub.authorizeSupportQ": "Povoliť prístup k podpore?",
"pub.available": "Dostupné",
"pub.backHome": "Späť na domovskú stránku",
"pub.boostAdCta": "Zvýrazniť moju reklamu",
"pub.boostAdTitle": "Zvýraznite svoju reklamu",
"pub.boostCarouselSub": "Presuňte sa na vrchol stránky v karuseli „Zvýraznené“ a znásobte zobrazenia, aby ste rýchlejšie získali svoj predmet späť.",
"pub.boostEstablishment": "Zvýraznite svoju prevádzku",
"pub.boostEstablishmentDesc": "Zobrazte sa na vrchole adresára s odznakom „Zvýraznené“ a prilákajte viac správ.",
"pub.boostFicheCta": "Zvýrazniť môj záznam",
"pub.brandReady": "Značka Findloop, pripravená na použitie",
"pub.cantFindItem": "Nemôžete nájsť svoj predmet?",
"pub.cantProcessImage": "Nemožno spracovať tento obrázok",
"pub.claimQr": "Prevezmite QR kód",
"pub.clickToZoom": "Kliknite pre priblíženie",
"pub.codeAlreadyValidated": "Kód overený – kontakty odomknuté.",
"pub.codeExample": "napr. ABCD2345",
"pub.confirmRenewal": "Potvrdiť obnovenie",
"pub.contactIntro": "Otázka, žiadosť? Napíšte nám, čoskoro sa vám ozveme.",
"pub.contactTypeDeceased": "Vymazanie účtu (mŕtva osoba)",
"pub.contactTypeGeneral": "Všeobecná otázka",
"pub.contactTypeSupport": "Podpora / technický problém",
"pub.contactUs": "Kontaktujte nás",
"pub.continueWithoutEmail": "Pokračovať bez zanechania môjho emailu",
"pub.contractLabel": "Zmluva",
"pub.contractNotFound": "Zmluva nenájdená alebo už vypršala.",
"pub.contractRenewed": "Zmluva obnovená!",
"pub.contractRenewedFor": "Vaša zmluva je obnovená na {n} mesiacov.",
"pub.copyFailed": "Kopírovanie zlyhalo",
"pub.createPartnerAccount": "Vytvoriť môj partnerský účet",
"pub.currentDeadline": "Aktuálny termín",
"pub.deceasedInfo": "Ako príbuzný alebo dedič môžete požiadať o vymazanie účtu Findloop zosnulej osoby. Vašu žiadosť spracujeme v súlade s GDPR (podporné dokumenty môžu byť požadované).",
"pub.declareMyLoss": "Nahlásiť moju stratu",
"pub.describeItemPlaceholder": "Popíšte svoju položku (napr. čierny dáždnik, kľúče…)",
"pub.downloadImage": "Stiahnite obrázok",
"pub.drawSignature": "Prosím, nakreslite svoj podpis.",
"pub.drawSignatureHint": "Nakreslite svoj podpis myšou alebo prstom.",
"pub.duration": "Trvanie",
"pub.eSignature": "Elektronický podpis",
"pub.eSignatureDesc": "Zadajte svoje meno na podpis. Dátum sa zaznamenáva automaticky.",
"pub.edit": "Upraviť",
"pub.editorialTitles": "Redakčné názvy",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "Zadajte kód, ktorý ste dostali na email, aby ste odomkli kontaktné údaje vlastníka.",
"pub.errorWord": "Chyba",
"pub.foundSelfService": "Nájdené položky · Samoobsluha",
"pub.haveOwnerCode": "Dostal som kód od vlastníka",
"pub.home": "Domov",
"pub.immediateRenewal": "Ihneď obnovenie, bez novej ponuky.",
"pub.impAdminReq1": "Administrátor",
"pub.impAdminReq2": "žiadosti o povolenie dočasne prístup k vášmu účtu",
"pub.impAdminReq3": "aby vám mohol pomôcť.",
"pub.impGrantedDesc": "Podporný tím bude mať prístup k vášmu účtu maximálne na 2 hodiny. Každá akcia bude zaznamenaná. Túto stránku môžete zavrieť.",
"pub.invitedOnFindo": "Ste pozvaní do Findloop",
"pub.isThisYourItem": "Je to vaša položka?",
"pub.itemsAvailableCount": "{n} položka(y) momentálne dostupná(e)",
"pub.itemsFoundOwner": "zverené položky našli svojho vlastníka",
"pub.itemsReturnedOwners": "položky vrátené ich vlastníkom",
"pub.itsMine": "Je to moje",
"pub.joinFindoDesc": "Pripojte sa k Findloop a jednoducho spravujte svoje nájdené položky.",
"pub.joinInvitesYou": " Vás pozýva pripojiť sa k findloop. Vytvorte si partnerský účet, aby ste mohli spravovať svoje nájdené položky.",
"pub.linkCopied": "Odkaz skopírovaný!",
"pub.loadingContract": "Načítavam zmluvu…",
"pub.lsClaimDesc": "Nahláste svoju stratu na jej obnovu. Zanechajte svoj email a pošleme vám pripomienku, ak vaše hlásenie nebude dokončené.",
"pub.lsHeroDesc": "Sami si skontrolujte, či bola vaša stratená položka nájdená a ponechaná tu. Našli ste to? Nahláste to, aby ste ju obnovili.",
"pub.lsSearchTitle": "Hľadajte nájdené položky",
"pub.makeOffer": "Urobte ponuku",
"pub.makeOfferDesc": "Navrhnite svoju sumu. Superadministrátor ju prehodnotí.",
"pub.mapNearYou": "Položky a partneri vo vašej blízkosti",
"pub.mapWord": "Mapa",
"pub.messageSentToast": "Správa odoslaná — náš tím vám čoskoro odpovie.",
"pub.messageWord": "Správa",
"pub.momoInitiated": "Platba Mobil Money iniciovaná",
"pub.monthsWord": "mesiace",
"pub.nameConsentRequired": "Meno a súhlas sú potrebné.",
"pub.newDeadline": "Nový termín",
"pub.noActionRequired": "Nie je potrebná žiadna akcia.",
"pub.noAmountCharged": "Nebola účtovaná žiadna suma.",
"pub.noItemMatch": "Momentálne nie sú k dispozícii žiadne položky zodpovedajúce vášmu hľadaniu.",
"pub.noMatchingItem": "Žiadna zodpovedajúca položka",
"pub.noPaymentSession": "Žiadna platobná relácia.",
"pub.noPhoto": "Žiadny obrázok",
"pub.noPointsYet": "Zatiaľ nie sú žiadne body na zobrazenie.",
"pub.noSecondPayment": "Pre túto položku nie je potrebná žiadna druhá platba.",
"pub.notHereYet": "Ešte tu nie je? Dajte nám vedieť, hneď ako príde.",
"pub.notifyDone": "Poznámka! Oznámime vám emailom, hneď ako príde zodpovedajúca položka.",
"pub.offerSubmitted": "Vaša ponuka bola odoslaná.",
"pub.oops": "Ups",
"pub.orAlertEmail": "Alebo dostávajte upozornenia emailom, hneď ako príde zodpovedajúca položka:",
"pub.ownerContacts": "Kontaktné údaje vlastníka",
"pub.ownerContactsUnlocked": "Kontaktné údaje vlastníka odomknuté",
"pub.partnerContact": "Kontaktné údaje partnera",
"pub.payLinkUnavailable": "Platobný odkaz nie je dostupný — kontaktujte partnera.",
"pub.paymentCancelled": "Platba bola zrušená",
"pub.paymentConfirmed": "Platba potvrdená 🎉",
"pub.paymentConfirmedDesc": "Dostanete e-mail s podrobnosťami na obnovenie vašej položky.",
"pub.paymentNotConfirmed": "Platba nebola potvrdená",
"pub.paymentNotConfirmedDesc": "Platbu sa nepodarilo overiť. Skúste to znova alebo kontaktujte partnera.",
"pub.paymentProcessing": "Platba sa spracováva. Obnovte to za chvíľu.",
"pub.photoAdded": "✓ Fotka pridaná",
"pub.photoRequired": "Je potrebná fotka položky.",
"pub.previewAlt": "náhľad",
"pub.publish": "Publikovať",
"pub.publishingWord": "Publikuje sa…",
"pub.qty": "Množstvo",
"pub.quoteDeclined": "Ponuka bola odmietnutá.",
"pub.quoteNotFound": "Ponuka nenájdená alebo vypršaná.",
"pub.reasonLabel": "Dôvod",
"pub.recoveryAlreadyPaid": "Poplatok za obnovenie už bol zaplatený",
"pub.referralCode": "Referenčný kód:",
"pub.relationshipPlaceholder": "Syn, manžel, notár…",
"pub.renewYourContract": "Obnovte svoju zmluvu",
"pub.renewalFailed": "Obnova sa nepodarila. Skúste to neskôr.",
"pub.renewing": "Obnovuje sa…",
"pub.replySoon": "Náš tím odpovie čo najskôr.",
"pub.requestGone": "Táto žiadosť už neexistuje.",
"pub.requestHandled": "Žiadosť už bola vybavená",
"pub.requestNotFound": "Žiadosť nenájdená alebo vypršaná.",
"pub.requestUnavailable": "Žiadosť nie je k dispozícii",
"pub.required": "(povinné)",
"pub.retroClosing": "Spoločne robíme svet o niečo menej strateným.",
"pub.retroClosing2": "Spoločne robíme svet o niečo menej strateným.",
"pub.retroScroll": "Rok obnovovania toho, čo je dôležité. Posuňte nadol ↓",
"pub.revokeAnytime": "Môžete to odvolať kedykoľvek kontaktovaním nás",
"pub.scene": "Scéna",
"pub.sendImpossible": "Nie je možné odoslať",
"pub.sendMessage": "Odoslať správu",
"pub.sending": "Odosielanie…",
"pub.sharePreview": "Zdieľať náhľad",
"pub.shareYourAd": "Zdieľať vašu reklamu",
"pub.signedSuccess": "Úspešne podpísané!",
"pub.signerFullName": "Celé meno podpisujúceho",
"pub.spreadNetwork": "Zdieľajte to so svojimi okolími, aby ste zvýšili svoje šance.",
"pub.spreadOwner": "Zdieľajte to, aby ste pomohli majiteľovi obnoviť ich veci.",
"pub.statusLabel": "Stav:",
"pub.subject": "Predmet",
"pub.thanksSent": "Ďakujeme, vaša správa bola odoslaná.",
"pub.thisYear": "Tento rok",
"pub.validate": "Overiť",
"pub.verifyingPayment": "Overovanie platby…",
"pub.verifyingYourPayment": "Overovanie vašej platby…",
"pub.viewAd": "Zobraziť reklamu →",
"pub.viewPartner": "Zobraziť partnera →",
"pub.yourAdPreview": "Náhľad vašej reklamy",
"pub.yourEmail": "Váš e-mail",
"pub.yourEmailRecommended": "Váš e-mail (odporúčané)",
"pub.yourEmailShort": "Váš e-mail",
"pub.yourName": "Vaše meno",
"pub.yourRelationship": "Váš vzťah k osobe",
"qv.acceptAndSign": "Akceptovať a podpísať moju ponuku",
"qv.certifyAuthorized": "Potvrdzujem, že som oprávnený podpísať a akceptujem podmienky tejto {what} (záväzná hodnota).",
"qv.clear": "Vymazať",
"qv.client": "Klient",
"qv.conditions": "Podmienky",
"qv.confirmDecline": "Potvrdiť odmietnutie tohto návrhu?",
"qv.countersignedFindo": "Oslovené firmou Findloop · {name} dňa {date}",
"qv.decline": "Odmietnuť",
"qv.description": "Popis",
"qv.downloadPdf": "Stiahnuť PDF",
"qv.handwrittenSignature": "Ručný podpis",
"qv.inclTax": "Vrátane DPH",
"qv.invalidAmount": "Neplatná suma.",
"qv.invoice": "Faktúra",
"qv.invoicePaid": "Faktúra zaplatená",
"qv.issuer": "Vydavateľ",
"qv.messageOptional": "Správa (voliteľné)",
"qv.negotiatedAmount": "Jednaná suma",
"qv.payInvoiceOnline": "Zaplatiť faktúru online",
"qv.quote": "Návrh",
"qv.quoteValidDays": "Návrh platný {n} dní.",
"qv.sendMyOffer": "Odoslať moju ponuku",
"qv.signContract": "Podpísať moju zmluvu",
"qv.signNow": "Podpísať teraz",
"qv.signatureAlt": "Podpis",
"qv.signedByOn": "✔ Podpísané {name} dňa {date}",
"qv.stContractSigned": "Zmluva podpísaná. Ďakujeme!",
"qv.stCounterAccepted": "Vaša ponuka bola prijatá! Podpíšte svoju zmluvu nižšie.",
"qv.stCounterRefused": "Vaša ponuka nemohla byť prijatá.",
"qv.stCountered": "Vaša ponuka bola odoslaná. Čaká sa na odpoveď od findloop.",
"qv.stDeclined": "Tento návrh ste odmietli.",
"qv.stSigned": "Návrh prijatý a podpísaný. Ďakujeme!",
"qv.totalHt": "Celkom bez DPH",
"qv.totalTtc": "Celkom vrátane DPH",
"qv.unitHt": "Jednotková cena bez DPH",
"qv.vat": "DPH",
"qv.yourProposedAmount": "Vaša navrhnutá suma ({cur})",
"rate.chooseNote": "Prosím, vyberte hodnotenie.",
"rate.commentPh": "Komentár (voliteľné)…",
"rate.home": "Späť na domov",
"rate.submit": "Odoslať moju recenziu",
"rate.submitting": "Odosielanie…",
"rate.subtitle": "Ako prebehlo vrátenie vášho predmetu?",
"rate.successText": "Vaša spätná väzba pomáha ostatným užívateľom.",
"rate.successTitle": "Ďakujeme za vašu recenziu!",
"rate.title": "Hodnotenie vašich skúseností",
"reg.add": "Zaznamenať predmet",
"reg.allBrands": "Všetky značky",
"reg.allColors": "Všetky farby",
"reg.allLocations": "Všetky lokality",
"reg.detailDesc": "Podrobnosti a akcie pre tento nájdený predmet.",
"reg.dispAuction": "Aukcia",
"reg.dispAuthorities": "Odovzdané úradom",
"reg.dispDestroyed": "Zničené",
"reg.dispDonate": "Charitatívna darcovská činnosť",
"reg.dispositionHint": "Zaznamenať predmet odchádzajúci zo skladu. Započítané do štatistiky podľa kategórie.",
"reg.emptyCta": "Zaznamenať predmet",
"reg.emptyDesc": "Začnite zaznamenaním vášho prvého nájdeného predmetu.",
"reg.emptyTitle": "Žiadne predmety nenájdené",
"reg.establishmentFallback": "podnik",
"reg.lblAuctioned": "uvoľnené na aukciu",
"reg.lblAuctionedShort": "aukcia",
"reg.lblAuthorities": "odovzdané úradom",
"reg.lblDestroyed": "zničené",
"reg.lblDonated": "darované na charitu",
"reg.legalCount": "{n} položka(y): dosiahnuté právne uchovávanie",
"reg.legalHint": "Môžete ich ponúknuť na aukcii, darovať na charitu alebo nahlásiť odovzdanie orgánom.",
"reg.legalLimitCountry": "Termín: {date} · aplikovaná krajina: {country}",
"reg.legalOver": "Termín uplynul: {date} · {country}",
"reg.legalReached": "Právny okres dosiahnutý",
"reg.legalReachedFull": "Dosiahutý právny uchovávací čas",
"reg.limitShort": "termín",
"reg.location": "Poloha",
"reg.markRestituted": "Označiť ako vrátené",
"reg.markedAs": "Položka označená ako {label}",
"reg.moveHistory": "História pohybu",
"reg.overBy": "meškanie o {n}d",
"reg.physicalLocation": "Fyzická poloha",
"reg.popupBlocked": "Povoľte vyskakovacie okná na tlač štítkov.",
"reg.popupBlockedOne": "Povoľte vyskakovacie okná na tlač štítku.",
"reg.printLabel": "Tlačiť štítok",
"reg.printN": "Tlačiť {n} štítok(y)",
"reg.qrCodeItem": "QR kód položky",
"reg.qrLabelTitle": "QR štítok",
"reg.qrLabelsTitle": "QR štítky",
"reg.qrNotFound": "Pre tento QR kód nebola nájdená žiadna položka.",
"reg.qrScanHint": "Naskenujte ho na priamy prístup k tomuto záznamu a nájdite polohu.",
"reg.recoveryFee": "Poplatok za obnovu (€)",
"reg.searchPh": "Hľadanie podľa popisu…",
"reg.selectQr": "Vybrať na tlač QR štítkov",
"reg.selectedN": "{n} vybrané",
"reg.shipPricePh": "Cena za doručenie (€)",
"reg.shippingPossible": "Doručenie dostupné",
"reg.storagePh": "napr. Polica A3, Skrinka 12",
"reg.tAuction": "Aukcia na Findloop",
"reg.tAuthorities": "Nahlásiť odovzdanie orgánom",
"reg.tDonate": "Darovať na charitu",
"reg.toastFee": "Poplatok aktualizovaný",
"reg.toastLocation": "Poloha uložená",
"reg.toastRestituted": "Položka označená ako vrátená",
"reg.toastShipping": "Možnosť doručenia aktualizovaná",
"reg.toastTransferred": "Položka presunutá na „{name}“",
"reg.unclaimedDisposition": "Neprebraná položka — konečné rozlíšenie",
"res.codeValidated": "Kód overený",
"res.empty": "Zatiaľ nie sú zaznamenané žiadne vrátenia.",
"res.error": "Chyba {status}",
"res.proofPdf": "PDF dôkaz",
"res.signed": "Podpísané",
"res.stRestituted": "Odovzdané osobne",
"res.stShipped": "Vrátené odoslaním",
"res.subtitle": "Všetky dokončené odovzdania s ich stiahnuteľným podpísaným dôkazom.",
"res.title": "História vrátenia",
"rev.b2b": "B2B partneri",
"rev.b2c": "Zákazníci",
"rev.based": "na základe {n} recenzií",
"rev.eyebrow": "Svedectvá",
"rev.restitutedBy": "Vrátené {org}",
"rev.storiesEyebrow": "Šťastné konce",
"rev.storiesSubtitle": "Skutočné príbehy od zákazníkov, ktorí si obnovili svoje veci s findloop.",
"rev.storiesTitle": "Našli svoje veci!",
"rev.subtitle": "Partneri a zákazníci zdieľajú svoje skúsenosti.",
"rev.title": "Dôverujú Findloop",
"rev.verified": "Overené",
"rp.already": "Túto ponuku ste už nahlásili.",
"rp.comment": "Podrobnosti (voliteľné)",
"rp.duplicate": "Duplikát",
"rp.fraud": "Podvod / podvod",
"rp.inappropriate": "Nevhodný obsah",
"rp.offensive": "Ofenzívny obsah",
"rp.other": "Iné",
"rp.reason": "Dôvod",
"rp.report": "Nahlásiť",
"rp.send": "Odoslať hlásenie",
"rp.sent": "Hlásenie odoslané. Ďakujeme za váš prínos.",
"rp.spam": "Spam / reklama",
"rp.title": "Nahlásiť tento inzerát",
"rp.wrongCategory": "Nesprávna kategória",
"rt.annualGoal": "Ročný cieľ",
"rt.championCity": "Majstrovské mesto",
"rt.cityRate": "{rate}% miera návratnosti",
"rt.goalProgress": "{rate}% dosiahnuté z {target}% cieľa",
"rt.reached": "Dosiahnuté 🎉",
"rt.restitutionRate": "Miera návratnosti",
"rt.shareRecap": "Zdieľať moje zhrnutie",
"rt.thanks": "Ďakujem Findloop {year} 💛",
"rt.yourRecap": "Vaše zhrnutie {year}",
"rw.active": "Aktívne",
"rw.add": "Pridať",
"rw.camUnavailable": "Kamera nie je k dispozícii. Zadajte kód ručne nižšie.",
"rw.codeValidated": "Kód overený",
"rw.codesTitle": "Kódy uplatnené findermi",
"rw.confirmDelete": "Vymazať „{title}“?",
"rw.deleted": "Vymazané",
"rw.edit": "Upraviť",
"rw.editReward": "Upraviť odmenu",
"rw.empty": "Ešte žiadna odmena.",
"rw.expired": "Expirujúce",
"rw.expiresOn": "Expiruje {date}",
"rw.fActive": "Aktívne (viditeľné pre findery)",
"rw.fCost": "Náklady (body)",
"rw.fDesc": "Popis",
"rw.fStock": "Zásoby (prázdne = neobmedzené)",
"rw.fTitle": "Názov",
"rw.fValidity": "Platnosť poukazu (dni po uplatnení)",
"rw.inactive": "Neaktívne",
"rw.newReward": "Nová odmena",
"rw.noExchange": "Ešte žiadne uplatnenie.",
"rw.pageSubtitle": "Naskenujte poukázky presented by finders na overenie ich odmien.",
"rw.redeemedN": "Uplatnené: {n}×",
"rw.saved": "Odmena uložená",
"rw.scanVoucher": "Naskenujte poukaz",
"rw.staffScanOnly": "Naskenujte iba",
"rw.statActive": "Na prezentáciu",
"rw.statExpired": "Expirované",
"rw.statRedeemed": "Poukážky uplatnené",
"rw.statUsed": "Overené",
"rw.stock": "Zásoby",
"rw.subtitle": "Ponúknite nepeňažné výhody (poukážky, upgrady…) ktoré finderi uplatňujú za svoje body Finder Score.",
"rw.title": "Odmeny pre finders",
"rw.used": "Použité",
"rw.validate": "Overiť",
"rw.validateCode": "Overiť kód",
"rw.validity": "Platnosť: {n} d",
"shell.f1d": "Automaticky prepojiť stratené a nájdené predmety.",
"shell.f1t": "Inteligentné AI priradenie",
"shell.f2d": "Sledujte návratnosť a príjmy v reálnom čase.",
"shell.f2t": "Ná controler & príjmy",
"shell.f3d": "Vaši zákazníci hlásia za 30 sekúnd.",
"shell.f3t": "QR kód partnera",
"shell.title": "Premeňte stratené veci na spokojných zákazníkov.",
"ship.addr1": "Adresa",
"ship.addr2": "Riadok adresy 2 (voliteľné)",
"ship.badge": "Doprava",
"ship.city": "Mesto",
"ship.country": "Krajina",
"ship.needPaid": "Najprv zaplaťte poplatok za vrátenie, aby ste požiadali o dopravu.",
"ship.notShippable": "Táto položka nie je k dispozícii na dopravu.",
"ship.notfound": "Správa nenájdená.",
"ship.postal": "PSČ",
"ship.price": "Poplatok za dopravu",
"ship.submit": "Požiadať o dopravu",
"ship.submitting": "Posielam…",
"ship.subtitle": "Zadajte svoju dodaciu adresu.",
"ship.successText": "Partner pripraví vašu zásielku. O naložení vás budeme informovať.",
"ship.successTitle": "Požiadavka na dopravu odoslaná!",
"ship.title": "Nechajte si zaslať položku",
"ship.weight": "Odhadovaná hmotnosť (kg)",
"shp.carrier": "Dopravca",
"shp.download": "Stiahnuť PDF",
"shp.generating": "Generujem…",
"shp.label": "Vygenerovať štítok",
"shp.none": "Žiadna zásielka nebola požadovaná.",
"shp.setTracking": "Uložiť sledovanie",
"shp.status": "Stav",
"shp.to": "Príjemca",
"shp.tracking": "Číslo sledovania",
"shp.trackingSaved": "Sledovanie uložené",
"side.account": "Môj účet",
"side.declarations": "Správy",
"side.deposit": "Zaregistrovať položku",
"side.establishments": "Establišmenty",
"side.invoices": "Faktúry",
"side.logout": "Odhlásiť sa",
"side.matchHistory": "AI História",
"side.partner": "Partner",
"side.refresh": "Obnoviť",
"side.registry": "Registrácia",
"side.restitutions": "Návraty",
"side.reviews": "Recenzie",
"side.rewards": "Odmeny & Vouchery",
"side.settings": "Nastavenia",
"side.shipments": "Zásielky",
"side.stats": "Štatistiky",
"side.storage": "Úložisko & QR",
"side.team": "Tím",
"side.viewSite": "Zobraziť verejnú stránku",
"st.auctioned": "Predané na aukcii",
"st.claimed": "Prehlásené",
"st.closed": "Zatvorené",
"st.delivered": "Dodanó",
"st.destroyed": "Zničené",
"st.donated": "Darované (charita)",
"st.handed_to_authorities": "Odovzdané úradom",
"st.in_storage": "V úložisku",
"st.matched": "Nájdený zápas",
"st.open": "Otvorené",
"st.paid": "Zaplatené",
"st.pending": "Na čakacej listine",
"st.resolved": "Riešené",
"st.restituted": "Vrátené",
"st.second_chance": "Druhá šanca",
"st.shipped": "Zaslané",
"st.shipping_requested": "Žiadosť o odoslanie",
"st.submitted": "Odoslané",
"st.verified": "Overené",
"stat.items": "Registrované položky",
"stat.partners": "Partnermi",
"stat.restituted": "Vrátené položky",
"status.auctioned": "Dražené",
"status.destroyed": "Zničené",
"status.donated": "Darované (charita)",
"status.handed_to_authorities": "Odovzdané orgánom",
"status.in_storage": "Na sklade",
"status.matched": "Zápas",
"status.open": "Otvorené",
"status.paid": "Zaplatené",
"status.pending": "Na čakacej listine",
"status.restituted": "Vrátené",
"status.shipped": "Zaslané",
"status.shipping_requested": "Žiadosť o odoslanie",
"status.submitted": "Odoslané",
"step1.tag": "Prevádzka",
"step1.text": "Za sekundy prevádzka zaregistruje nájdenú položku s fotkou, kategóriou a popisom. Všetko je centralizované v jasnom, bezpečnom registri.",
"step1.title": "Partner zaregistruje položku",
"step2.tag": "Zákazník",
"step2.text": "Prostredníctvom QR kódu partnera váš zákazník opisuje stratenú položku za 30 sekúnd. Žiadna aplikácia na inštaláciu — všetko prebieha v prehliadači.",
"step2.title": "Zákazník hlási stratu",
"step3.tag": "Inteligencia",
"step3.text": "Náš inteligentný systém porovnáva popisy a navrhuje najpravdepodobnejšie zhodné položky, pripravené na potvrdenie.",
"step3.title": "AI spája stratu a nájdenú položku",
"step4.tag": "Obnova",
"step4.text": "Po bezpečnej platbe poplatku za obnovu si zákazník vyzdvihne položku na mieste — alebo ju dostane sledovaným spôsobom.",
"step4.title": "Zákazník získa späť svoju položku",
"stg.allLabels": "Všetky QR štítky",
"stg.camHint": "Použite manuálny vstup nižšie.",
"stg.camStarting": "Spúšťam kameru…",
"stg.camUnavailable": "Kamera nie je k dispozícii.",
"stg.clear": "Vymazať",
"stg.clearAll": "Vymazať všetko",
"stg.codeUnreadable": "Nečitateľný kód.",
"stg.emptyDesc": "Uložené položky sa objavia tu, zoskupené podľa umiestnenia.",
"stg.emptyTitle": "Žiadna položka na sklade",
"stg.exportAudit": "Exportovať audit CSV",
"stg.exportDone": "CSV export stiahnuté",
"stg.exportImpossible": "Export momentálne nie je k dispozícii.",
"stg.itemFound": "Položka nájdená ✅",
"stg.kLocations": "Použité umiestnenia",
"stg.kObjects": "Uložené položky",
"stg.kToClear": "Umiestnenia na vymazanie",
"stg.locFreed": "Umiestnenie uvoľnené",
"stg.locsFreed": "{n} umiestnení uvoľnených",
"stg.manualLabel": "Alebo zadajte kód / ID položky",
"stg.manualPh": "Vložte ID alebo URL QR",
"stg.noItemMatch": "Žiadna položka nezodpovedá tomuto QR / kódu.",
"stg.noLocation": "Žiadna lokalita",
"stg.objectsAxis": "Položky",
"stg.objectsN": "{n} položka(y)",
"stg.occAvg": "priemer {n} položiek/lokáciu",
"stg.occHint": "Lokalizácie v amber presahujú priemer (potenciálne preťažené).",
"stg.occupancy": "Obsadenosť lokácie",
"stg.openPage": "Otvor stránku",
"stg.posterPdf": "PDF plagát (A4)",
"stg.printAll": "Tlačiť všetko",
"stg.printGroupTitle": "Tlačiť štítky pre túto poličku",
"stg.qrAlt": "Samoobslužný QR",
"stg.qrDownload": "Stiahnuť QR",
"stg.qrHint": "Zobrazte tento QR na pult: vaši zákazníci ho naskenujú, aby skontrolovali, či je ich položka dostupná.",
"stg.qrTitle": "Samoobslužný QR pre zákazníka",
"stg.scanDesc": "Naskenujte štítok položky, aby ste okamžite otvorili jej záznam.",
"stg.scanQr": "Naskenujte QR",
"stg.scanTitle": "Naskenujte QR kód",
"stg.search": "Hľadať",
"stg.shelf": "Polička {loc}",
"stg.shelfPlan": "Plán poličky",
"stg.staleHint": "Vyčistite tieto lokácie, aby ste udržali fyzické zásoby aktuálne.",
"stg.staleTitle": "{n} položka(y) opustili sklad, ale stále majú lokalitu",
"stg.subtitle": "Plán poličky, QR skener a sledovanie fyzických zásob.",
"stg.title": "Skladovanie & QR",
"stt.acceptRate": "Miera prijatia",
"stt.accepted": "Prijaté",
"stt.activity30": "Aktivita (posledných 30 dní)",
"stt.ai6mo": "Posledných 6 mesiacov · prijaté = automaticky priradené + potvrdené.",
"stt.aiEmpty": "Za toto obdobie zatiaľ žiadne AI priradenia.",
"stt.aiTitle": "AI priradenia — prijaté vs zamietnuté",
"stt.auctionShort": "Aukcia",
"stt.auctionedSold": "Aukcia (predané)",
"stt.authShort": "Úrady",
"stt.authorities": "Odovzdané úradom",
"stt.avgRating": "Priemerné hodnotenie",
"stt.awaitingRestitution": "položky čakajúce na vrátenie",
"stt.boostClicks": "Kliky vo vašom adresári tento týždeň vďaka boostu",
"stt.boostInactive": "Boost neaktívny — aktivujte ho na zvýšenie viditeľnosti",
"stt.certifiedPremium": "Certifikované prémiové",
"stt.declarations": "Vyhlásenia",
"stt.destroyed": "Zničené",
"stt.dispoEmpty": "Zatial žiadna neprebraná položka neopustila sklad.",
"stt.donatedAssoc": "Darované (charita)",
"stt.donatedShort": "Darované",
"stt.gateCta": "Objavte plány",
"stt.gateDesc": "Prejdite na Starter, aby ste odomkli svoje základné štatistiky, alebo na Business pre pokročilé štatistiky a analýzu podľa prevádzok.",
"stt.gateTitle": "Štatistiky rezervované pre platené plány",
"stt.inStorage": "V sklade",
"stt.kItems": "Zaregistrované položky",
"stt.kRate": "Miera vrátenia",
"stt.kRestituted": "Vrátené položky",
"stt.kRevenue": "Príjem (mesiac)",
"stt.noDeclYet": "Zatiaľ žiadne vyhlásenia.",
"stt.recapDownloaded": "Vyhodnotenie stiahnuté — pripravené na zdieľanie!",
"stt.recapError": "Nemožno vygenerovať vyhodnotenie",
"stt.recapText": "Naše Findloop {year} vyhodnotenie: vrátené položky a spokojnosť zákazníkov 🎉",
"stt.recapTitle": "Findloop {year} vyhodnotenie",
"stt.rejected": "Zamietnuté",
"stt.restitutions": "Vrátenia",
"stt.shareRecap": "Zdieľať moje vyhodnotenie za {year}",
"stt.topCategories": "Najviac deklarované kategórie",
"stt.unclaimedDesc": "Objem položiek, ktoré boli zničené, darované charitám a vydražené, podľa kategórie.",
"stt.unclaimedTitle": "Neuplatnené položky — opúšťajú sklad",
"stt.vsLastWeek": "vs minulý týždeň",
"sub.cancel": "Zrušiť moju predplatbu",
"sub.cancelAbort": "Zrušiť",
"sub.cancelConfirm1": "Ste si istý, že chcete zrušiť? Váš prístup zostáva aktívny až do",
"sub.cancelConfirm2": "Žiadna náhrada nebude vyplatená.",
"sub.cancelConfirmBtn": "Potvrdiť zrušenie",
"sub.cancelTitle": "Zrušiť vaše predplatné",
"sub.cancelledToast": "Zrušenie zaznamenané.",
"sub.cguAnd": "a",
"sub.cguDesc": "Pred platbou prosím potvrďte svoj súhlas.",
"sub.cguLink": "Podmienky používania",
"sub.cguPay": "Pokračovať k platbe",
"sub.cguPre": "Prečítal/a som a súhlasím s",
"sub.cguRequired": "Musíte akceptovať Podmienky používania a Zásady ochrany osobných údajov, aby ste mohli pokračovať.",
"sub.cguSuffix": "spoločnosti findloop.",
"sub.cguTitle": "Dokončite svoje predplatné",
"sub.expiresOn": "Vaše predplatné vyprší dňa",
"sub.noProrata": "Žiadna pro-rata náhrada.",
"sub.privacyLink": "Zásady ochrany osobných údajov",
"sub.renewsOn": "Vaše predplatné sa obnoví dňa",
"sub.resume": "Znovu sa prihlásiť",
"sub.resumedToast": "Potvrdené obnovenie predplatného.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Business",
"tier.small": "Začiatočník",
"tm.add": "Pridať",
"tm.adminOpt": "Admin (úplný pohľad)",
"tm.chooseEst": "Vyberte zariadenie",
"tm.chooseEstPh": "Vyberte zariadenie",
"tm.copyFail": "Kopírovanie zlyhalo",
"tm.copyLink": "Kopírovať odkaz",
"tm.copyOk": "Odkaz na pozvanie skopírovaný",
"tm.emailHint": "Pozývací email bude odoslaný na vytvorenie hesla.",
"tm.expiresOn": "vyprší dňa {date}",
"tm.forEmail": " pre {email}",
"tm.forbidden": "Správa tímu je vyhradená pre držiteľa účtu.",
"tm.inviteCreated": "Pozvanie vytvorené",
"tm.inviteDesc": "Pozývací email umožní členovi tímu vytvoriť si svoje heslo.",
"tm.invitePending": "Čakajúce pozvanie",
"tm.inviteResent": "Pozvanie znovu odoslané",
"tm.inviteSent": "Pozvanie odoslané emailom",
"tm.inviteTitle": "Pozvať člena",
"tm.invitedOn": "Pozvaný dňa {date}",
"tm.linkExpired": "Odkaz vypršal",
"tm.memberRemoved": "Člen odstránený",
"tm.name": "Meno",
"tm.noMembers": "Zatiaľ žiadny člen tímu.",
"tm.resendTitle": "Znova odoslať pozvanie",
"tm.role": "Úloha",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Majiteľ",
"tm.roleStaff": "Zamestnanec",
"tm.roleUpdated": "Úloha aktualizovaná",
"tm.sendInvite": "Odoslať pozvanie",
"tm.sending": "Odosielam…",
"tm.staffOpt": "Zamestnanec (vidí iba svoje zariadenie)",
"trk.at": "V",
"trk.badge": "Sledovanie",
"trk.carrier": "Dopravca",
"trk.codeValidated": "Kód overený partnerom",
"trk.dlProof": "Stiahnuť môj doklad o prevzatí (PDF)",
"trk.emailLabel": "Email (voliteľné — na zobrazenie vašich údajov)",
"trk.enterEmailCode": "Zadajte svoj email vyššie na zobrazenie vášho kódu nároku.",
"trk.idLabel": "Číslo hlásenia",
"trk.lostEmail": "Už nemám prístup k svojmu emailu",
"trk.phonePh": "Číslo vášho telefónu",
"trk.photoBefore": "Fotografia položky pred odoslaním",
"trk.recoverBtn": "Obnoviť moju položku",
"trk.recoverHint": "Získajte svoj kód nároku cez SMS na vaše registrované číslo.",
"trk.searching": "Hľadám…",
"trk.secureRest": "Bezpečné vydanie",
"trk.send": "Odoslať",
"trk.shipPending": "Odoslanie sa pripravuje — sledovacie číslo sa tu objaví po odoslaní.",
"trk.shipTitle": "Sledovanie zásielky",
"trk.showQr": "Ukážte tento QR partnerovi na overenie prevzatia",
"trk.sigSaved": "Podpis uložený",
"trk.signFirst": "Prosím, podpíšte sa pred potvrdením.",
"trk.signProof": "Podpíšte svoj doklad o prevzatí",
"trk.signSubmit": "Potvrďte môj podpis a vygenerujte PDF",
"trk.submit": "Sledovať",
"trk.subtitle": "Zadajte číslo svojho hlásenia na sledovanie pokroku.",
"trk.title": "Sledovať moje hlásenie",
"trk.trackShipment": "Sledovať balík",
"trk.trackingNo": "Sledovacie číslo",
"trk.yourCode": "Váš kód nároku (na poskytnutie partnerovi)",
"a.firstName": "Meno",
"ac.emailCrossMatch": "B2C zhodovanie",
"ac.emailCrossMatchDesc": "Email, keď verejný inzerát na stratený predmet zodpovedá predmetu odovzdanému vo vašich priestoroch",
"ac.emailCrossReject": "Zamietnutia verejného zhodovania",
"ac.emailCrossRejectDesc": "Získajte email, keď zákazník naznačí, že navrhnuté verejné zhodovanie nie je jeho predmet.",
"ac.emailLoginNotif": "Notifikácia pri prihlásení",
"ac.emailLoginNotifDesc": "Získajte email zakaždým, keď sa niekto prihlási do vášho účtu.",
"ad.closeNoCancel": "Nie, odstrániť inzerát",
"ad.closeQuestion": "Bol predmet vrátený vám?",
"ad.closeQuestionDesc": "Dajte nám vedieť, či ste predmet získali späť, alebo ak len chcete odstrániť tento inzerát.",
"ad.closeYesRestituted": "Áno, predmet bol vrátený",
"ad.closedRestituted": "Predmet vrátený — inzerát uzatvorený 🎉",
"an.lostLoginDesc": "Na nahlásenie strateného predmetu a sledovanie jeho návratu je potrebný účet.",
"an.lostLoginRequired": "Prihláste sa na nahlásenie strateného predmetu",
"an.qfAll": "Všetky",
"an.qfBoosted": "Zvýraznené",
"an.qfPhoto": "S fotografiou",
"an.qfRecent": "Tento týždeň",
"an.qfResolved": "Riešené",
"an.restitutionInProgress": "Predmet sa vracia",
"dec.descPhLong": "Popíšte predmet: značka, farba, charakteristické znaky… (Čím viac podrobností poskytnete, tým vyššie sú vaše šance na získanie predmetu)",
"dec.loadError": "Nemožno načítať partnera práve teraz. Skontrolujte svoje pripojenie a skúste to znova.",
"dec.retry": "Skúsiť znova",
"dec.shippingMode": "Doprava",
"dep.photo2": "Druhá fotografia predmetu",
"dep.photo2Hint": "Voliteľné — ďalší uhol zlepšuje presnosť vizuálneho zhodovania.",
"dl.accountSuspended": "Účet pozastavený pre nezaplatenú faktúru. Uhraďte ju, aby ste obnovili prístup.",
"dl.regularize": "Uhraďte teraz →",
"dl.suspensionCountdown": "Faktúra {num} nezaplatená — váš účet bude pozastavený za {days} deň/dni. Uhraďte ju, aby ste sa tomu vyhli.",
"ft.cancelConfirm": "Zrušiť vašu správu? Majiteľ predmetu bude informovaný.",
"ft.cancelDone": "Správa bola zrušená.",
"ft.cancelLocked": "Zrušenie už nie je možné po zaplatení majiteľa.",
"ft.cancelReport": "Zrušiť moju správu",
"ft.claimCodeHelp": "Dajte tento kód nálezcovi pri odovzdaní na potvrdenie, že ste predmet prevzali.",
"ft.claimCodeTitle": "Váš kód na vrátenie",
"ft.claimDone": "Predmet vrátený. Ďakujeme, že používate Findloop!",
"ft.claimUnlockHint": "Odomknite kontaktné údaje nálezcu",
"ft.claimUnlockHintSub": "Prejdite do \"Predmety, ktoré si nárokujem\" vo svojom účte, aby ste zaplatili poplatok a získali kontaktné údaje.",
"ft.finderCodeShownHelp": "Majiteľ zaplatil a vybral vás. Skopírujte tento kód nižšie na potvrdenie návratu — nie je potrebné kontrolovať váš email.",
"ft.finderCodeShownTitle": "Kód overenia majiteľa",
"ft.finderContactsTitle": "Kontaktné údaje nálezcu",
"ft.foundCodeHelp": "Ukážte tento kód majiteľovi pri odovzdaní, aby ste potvrdili, že položka bola vrátená.",
"ft.inProgressOther": "Položka sa vracia",
"ft.inProgressOtherHelp": "Majiteľ vybral iného nálezcu pre túto položku. Na vašej strane nie sú potrebné žiadne ďalšie kroky.",
"ft.restitutionCodeHelp": "Tento kód potvrdzuje odovzdanie položky. Je už predvyplnený nižšie; overte ho a potom uzavrite prípad.",
"ft.restitutionCodeTitle": "Váš restitúčný kód",
"hc.14Digits": "14 číslic",
"hc.15DaysBeforeAnItem": "15 dní pred zákonným termínom položky.",
"hc.7DaysBeforeAnItem": "7 dní pred zákonným termínom položky.",
"hc.8CharactersMinimum": "Minimálne 8 znakov.",
"hc.aClaimToValidate": "Nárok na overenie",
"hc.aFindoAssistanceSessionIs": "Momentálne prebieha asistenčná relácia Findloop vo vašom účte.",
"hc.aNewMatchHasBeen": "Bola nájdená nová zhoda",
"hc.aUser": "Používateľ",
"hc.aUserClaimsToBe": "Používateľ tvrdí, že je majiteľom. Skontrolujte ich odpovede pred autorizáciou vrátenia.",
"hc.aboutFindo": "O Findloop",
"hc.accountActivatedPleaseLogIn": "Účet aktivovaný, prosím, prihláste sa.",
"hc.accountActivation": "Aktivácia účtu",
"hc.accountCreated": "Účet bol vytvorený!",
"hc.accountDeactivatedAReactivationEmail": "Účet deaktivovaný. E-mail na reaktiváciu (platný 30 dní) bol odoslaný na váš e-mail.",
"hc.accountReactivation": "Reaktivácia účtu",
"hc.activateMyAccount": "Aktivovať môj účet",
"hc.activateMyAdminAccount": "Aktivovať môj administrátorský účet",
"hc.activating": "Aktivujem…",
"hc.activeMatchCancelReason": "Aktívna zhoda. Dôvod zrušenia zákazníka: \"{reason}\". Položka stále čaká na nárok.",
"hc.activeMatchWithAPublic": "Aktívna zhoda s verejným (zákazníckym) záznamom. Čaká sa na nárok majiteľa.",
"hc.addAPhoto": "Pridať fotografiu",
"hc.addAndConfigureYourEstablishments": "Pridajte a nakonfigurujte svoje zariadenia v \"Zariadeniach\": kontaktné údaje, kategória a fyzické uskladnenie položiek.",
"hc.addOnGoogle": "Pridať na Google",
"hc.address": "Adresa",
"hc.addressSaved": "Adresa uložená",
"hc.addressStreet": "Adresa — Ulica",
"hc.adjustThePhoto": "Upraviť fotografiu",
"hc.adminFullView": "Administrátor (úplný pohľad)",
"hc.administratorOnly": "Iba pre administrátorov",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "AI vizuálne porovnanie",
"hc.all": "Všetko",
"hc.amount": "Suma",
"hc.anOrganization": "Organizácia",
"hc.analyzing": "Analyzovanie…",
"hc.andRecoveryIs": "a obnova je",
"hc.andTheDeclarationWillBe": "a vyhlásenie bude uzatvorené (presunuté do histórie). Táto akcia je konečná.",
"hc.annual20": "Ročne -20%",
"hc.annualBilling20": "Ročné faktúrovanie (−20%)",
"hc.annualTarget": "Ročný cieľ",
"hc.anyCommentsOptional": "Nejaké komentáre? (voliteľné)",
"hc.approveTheClaim": "Schváliť nárok",
"hc.archiveCancelledConfirm": "Archivovať {n} zoznam(y) \"Zrušené zákazníkom\"? Budú odstránené z registra.",
"hc.asSoonAs": "Hneď ako",
"hc.askTheOwnerToDisplay": "Požiadajte vlastníka, aby zobrazil QR kód svojho kódu (stránka sledovania).",
"hc.askThemAtTheCounter": "Požiadajte ich na pultíku o potvrdenie identity — nikdy verejne neviditeľné.",
"hc.assistance": "Podpora",
"hc.assistanceSessionRevoked": "Relácia podpory zrušená.",
"hc.atLeast6Characters": "Minimalne 6 znakov",
"hc.automaticallyPreSelected": "automatically pre-selected",
"hc.automaticallyWhenShipping": "automatically when shipping.",
"hc.awaitingClaim": "Čaká na nárok",
"hc.awaitingPayment": "Čaká na platbu",
"hc.b2cCustomer": "B2C zákazník",
"hc.back": "Späť",
"hc.backToHome": "Späť na domov",
"hc.backToMyAccount": "Späť na môj účet",
"hc.backToPayment": "Späť na platbu",
"hc.beforeAfterComparisonSlider": "Porovnávací posúvač pred/po",
"hc.billingInformation": "Fakturačné informácie",
"hc.billingInformationSaved": "Fakturačné informácie uložené ✓",
"hc.brand": "Značka",
"hc.bronze": "Bronz",
"hc.calculatingTheShippingRate": "Vypočítavanie nákladov na dopravu…",
"hc.cameraUnavailableEnterTheCode": "Kamera nedostupná. Zadajte kód ručne.",
"hc.cancel": "Zrušiť",
"hc.cancelMyDeclaration": "Zrušiť moju deklaráciu",
"hc.cancelSavedFmt": "Zrušenie uložené: \"{reason}\". Môžete ešte nárokovať.",
"hc.cancelTheDeposit": "Zrušiť depozit",
"hc.cancelThisMatch": "Zrušiť tento zápas",
"hc.cancellationReason": "Dôvod zrušenia",
"hc.cancelled": "Zrušené",
"hc.cancelledByTheCustomer": "Zrušené zákazníkom",
"hc.cannotOpenPayment": "Nie je možné otvoriť platbu. Skúste to znova.",
"hc.careers": "Kariéra",
"hc.carrier": "Doprava",
"hc.carrierAvailabilityCannotBeChecked": "Dostupnosť dopravcu nemožno skontrolovať, kým nie je nastavený váš odosielateľ Sendcloud.",
"hc.carrierConfirmedCharged": "Doprava potvrdená — zákazníkovi bol účtovaný {price} €",
"hc.carrierOther": "Doprava (iné)",
"hc.carrierSelection": "Výber dopravcu",
"hc.caseClosedThankYou": "Prípad uzavretý. Ďakujeme!",
"hc.category": "Kategória",
"hc.changeMethod": "Zmeniť metódu",
"hc.characteristic": "Charakteristika",
"hc.chargedToCustomer": "účtované zákazníkovi.",
"hc.checkOrEditYourDetails": "Skontrolujte alebo upravte svoje údaje pred zabezpečenou platbou.",
"hc.checkStatisticsToTrackDeposited": "Skontrolujte \"Štatistiky\" na sledovanie vložených položiek, miery vracania a výkonu každého zariadenia.",
"hc.checkTheDetailsBeforeContacting": "Skontrolujte podrobnosti pred kontaktovaním nálezcu.",
"hc.checkTheDetailsBelowBefore": "Skontrolujte údaje nižšie pred začatím žiadosti o vrátenie.",
"hc.checkTheNewItem": "Skontrolujte novú položku",
"hc.checkThePhotosAndCharacteristics": "Skontrolujte fotografie a charakteristiky nižšie pred pokračovaním s obnovením.",
"hc.chooseACountry": "Vyberte krajinu",
"hc.chooseANewPassword": "Vyberte nové heslo",
"hc.chooseAReason": "Vyberte dôvod",
"hc.chooseTheLegalRetentionAlerts": "Vyberte právne upozornenia o uchovávaní, ktoré budete dostávať e-mailom pre",
"hc.chooseYourPasswordToAccess": "Vyberte si svoje heslo na prístup do administratívneho rozhrania.",
"hc.city": "Mesto",
"hc.claimApproved": "Žiadosť schválená",
"hc.claimApproved2": "Žiadosť schválená.",
"hc.claimCodeExpired": "Kód žiadosti vypršaný",
"hc.claimCodeVerified": "Kód žiadosti overený",
"hc.claimNotFound": "Žiadosť nenájdená",
"hc.claimNotValidated": "Žiadosť neoverená",
"hc.claimRejected": "Žiadosť zamietnutá",
"hc.claimRejected2": "Žiadosť zamietnutá.",
"hc.claimValidated": "Žiadosť overená",
"hc.claimValidatedByThePartner": "Žiadosť overená partnerom",
"hc.claimant": "Žiadateľ",
"hc.claimsToBeTheOwner": "tvrdí, že je vlastníkom tejto položky a odpovedal na overovacie otázky. Schválte len ak odpovede sú správne.",
"hc.claimsToValidate": "Žiadosti na overenie",
"hc.clear": "Vymazať",
"hc.clickToZoom": "Kliknite na priblíženie",
"hc.close": "Zatvoriť",
"hc.close2": "Zatvoriť",
"hc.closeTheDeclaration": "Zavrieť vyhlásenie",
"hc.closeTheDeclaration2": "Zavrieť vyhlásenie?",
"hc.codeAlreadyVerified": "Kód už bol overený",
"hc.codeCopied": "Kód skopírovaný",
"hc.collapse": "Zbaliť",
"hc.color": "Farba",
"hc.company": "Spoločnosť",
"hc.companyName": "Názov spoločnosti",
"hc.comparePhotos": "Porovnať fotografie",
"hc.compareThemWithTheOwner": "Porovnať s odpoveďami vlastníka — nikdy verejne viditeľné.",
"hc.condition": "Stav",
"hc.confirmAndPay": "Potvrdiť a zaplatiť",
"hc.confirmCancellation": "Potvrdiť zrušenie",
"hc.confirmCrop": "Potvrdiť orezať",
"hc.confirmDeletion": "Potvrdiť odstránenie",
"hc.confirmPassword": "Potvrdiť heslo",
"hc.confirmThatThisIsYour": "Potvrdiť, že toto je váš predmet. Kontrola identity bude požadovaná od nálezcu pred akýmkoľvek kontaktom.",
"hc.confirmTheCarrier": "Potvrdiť prepravcu",
"hc.confirmThePassword": "Potvrdiť heslo",
"hc.confirmYourShippingAddressTo": "Potvrdiť vašu doručovaciu adresu, aby ste mohli pokračovať v platbe.",
"hc.confirmYourSubscription": "Potvrdiť vašu predplatnú",
"hc.confirmed": "Potvrdené ✓",
"hc.contactFindoToGetYour": "Kontaktujte Findloop, aby ste získali svoje ID odosielateľa.",
"hc.contactUs": "Kontaktujte nás",
"hc.continueTheReturn": "Pokračovať v vrátení",
"hc.continueToPayment": "Pokračovať k platbe",
"hc.copy": "Kopírovať",
"hc.correctMyDetails": "opraviť moje údaje",
"hc.correctThisEntry": "Opraviť tento záznam?",
"hc.country": "Krajina",
"hc.countryAddress": "Krajina (adresa)",
"hc.countryIsoCodeEG": "Krajina (ISO kód, napr. FR)",
"hc.cover": "obal",
"hc.createTheShipment": "Vytvoriť zásielku",
"hc.cropThePhoto": "Orezať fotografiu",
"hc.customer": "Zákazník",
"hc.customerClaimCodeToCheck": "Kód reklamácie zákazníka — na kontrolu pri prevzatí:",
"hc.customerReasonFmt": "Dôvod zákazníka: \"{reason}\".",
"hc.customerReminderDelay": "Odznieť zákazníka oneskorenie",
"hc.customerWhosePublicListingMatches": "Zákazník, ktorého verejný záznam zodpovedá tomuto predmetu — viditeľné iba vám.",
"hc.d15": "D-15",
"hc.dangerZone": "Nebezpečná zóna",
"hc.date": "Dátum",
"hc.dateNewest": "Dátum (najnovší)",
"hc.dateOldest": "Dátum (najstarší)",
"hc.daysToYearEnd": "{n} dní do konca roka",
"hc.deadlineAlert": "Upozornenie na termín",
"hc.declarationClosed": "Vyhlásenie uzavreté ✓",
"hc.declarationNotFound": "Vyhlásenie nenájdené.",
"hc.declarationNotFound2": "Vyhlásenie nenájdené",
"hc.declarationTracking": "Sledovanie vyhlásenia",
"hc.defaultCarrier": "Predvolený dopravca",
"hc.defaultCarrierPreselected": "Predvolený dopravca prednastavený — môže byť zmenený pre túto zásielku. Skutočná sadzba (Sendcloud + {m}% marža).",
"hc.defaultCarrierRemoved": "Predvolený dopravca odstránený",
"hc.delayHours": "Meškanie (hodiny)",
"hc.deleteMyAccount": "Zmazať môj účet",
"hc.deleting": "Zmazávanie…",
"hc.deletingDeactivatesYourAccountLogin": "Zmazávanie deaktivuje váš účet: prihlásenie je zablokované a údaje sa uchovávajú 30 dní. Dostanete e-mail s aktivačným odkazom platným 30 dní.",
"hc.delivered": "Doručené",
"hc.depositAnItem": "Uložiť položku",
"hc.depositCancelledItemPutBack": "Uloženie zrušené — položka vrátená do skladu.",
"hc.depositCancelledItemRemovedFrom": "Uloženie zrušené — položka odstránená z registru.",
"hc.depositedOn": "Uložené dňa",
"hc.describeTheItemBrandColor": "Popíšte položku: značka, farba, rozlišovacie znaky… (Čím viac podrobností poskytnete, tým lepšie sú vaše šance na nájdenie položky)",
"hc.dimensionsCm": "Rozmery (cm)",
"hc.disablingAnEmail": "Deaktivácia e-mailu",
"hc.doesNotHide": "nezakrýva",
"hc.download": "Stiahnuť",
"hc.downloadThePdf": "Stiahnuť PDF",
"hc.draftRestoredPickUpYour": "Návrh obnovený — vyzdvihnite svoje vyhlásenie tam, kde ste prestali.",
"hc.dragToReposition": "Potiahnite na zmenu polohy",
"hc.eGColisPriv": "Napr. Colis Privé",
"hc.eachItemGetsAQr": "Každá položka dostane QR štítok. Naskenujte ho z \"Skladu & QR\", aby ste okamžite našli položku.",
"hc.eachSiteManagesItsOwn": "Každá stránka spravuje svoje vlastné bankovanie. Prejdite na",
"hc.edit": "Upraviť",
"hc.emailNotificationPreferences": "Predvoľby e-mailových oznámení",
"hc.emailPreferencesUpdated": "Predvoľby e-mailu aktualizované",
"hc.enableOrDisableRecoveryFees": "Povoliť alebo zakázať poplatky za spätné získanie pre",
"hc.enlargePhoto": "Zväčšiť foto",
"hc.enterTheCustomerSCode": "Zadajte kód zákazníka",
"hc.estShipRate": "Odhadovaná cena za dopravu (Sendcloud + {m}% marža):",
"hc.establishment": "Zriadenie",
"hc.establishment2": "Zriadenie:",
"hc.establishmentInItsSendcloudAccount": "zriadenie vo vašom účte Sendcloud a poskytne vám ID odosielateľa",
"hc.establishmentSettings": "Nastavenia zriadenia",
"hc.exCode": "napr. ABCD2345",
"hc.exId": "napr. 3f2a…",
"hc.exit": "Odhlásiť",
"hc.explainWhyThisItemIs": "Vysvetlite, prečo táto položka nie je vaša…",
"hc.externalPaymentLinks": "Externé platobné odkazy",
"hc.failed": "Zlyhalo",
"hc.feesEnabled": "Poplatky povolené",
"hc.field": ") pole.",
"hc.finderAcceptedCloseTheCase": "Nájdené akceptované — uzavrite prípad, keď bola položka odovzdaná osobne.",
"hc.findoCityRanking": "Findloop — Mesto poradie",
"hc.findoForEstablishments": "Findloop pre zriadenia",
"hc.findoPresentationVideo": "Findloop prezentačné video",
"hc.findoRegistersTheAddressOf": "Findloop registruje adresu vášho",
"hc.findoReviewShare": "Findloop {year} recenzia: {n} vrátených položiek, {rate}% miera vrátenia 🎉",
"hc.firstVerifyTheClaimCode": "Najprv overte vyššie uvedený kód nároku",
"hc.forEveryNewShipmentFrom": "za každú novú zásielku z",
"hc.free": "bezplatné",
"hc.freeRecovery0": "Bezplatná obnova (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Bezplatná obnova naprieč Afrikou – Úvodná ponuka",
"hc.freeRecoveryFeesDisabled0": "Bezplatná obnova: poplatky sú deaktivované (0 €)",
"hc.fromTeamInviteYourColleagues": "Z \"Tímu\" pozvite svojich kolegov e-mailom a priraďte im zriadenie. Každý člen vidí iba svoj vlastný rozsah.",
"hc.fullName": "Celé meno",
"hc.fullPhoto": "Celá fotografia",
"hc.gallery": "Galéria",
"hc.giveTheReasonForCancelling": "Uveďte dôvod zrušenia. Partner bude informovaný.",
"hc.goToLogin": "Prejdite na prihlásenie",
"hc.goToMyAccount": "Prejdite na môj účet",
"hc.gold": "Zlaté",
"hc.googleLoginFailed": "Prihlásenie cez Google zlyhalo",
"hc.hasConfirmedYourPaymentYou": "potvrdil vašu platbu, automaticky budete presmerovaní",
"hc.helpCenter": "Centrum pomoci",
"hc.helpUsImproveWhyAre": "Pomôžte nám zlepšiť: prečo odchádzate? Váš účet bude deaktivovaný a môže byť reaktivovaný na 30 dní.",
"hc.hidePassword": "Skryť heslo",
"hc.high": "Vysoké",
"hc.historyOfYourMonthlySubscriptions": "História vašich mesačných predplatných a ich stav platby.",
"hc.itemsReturnedThisYear": "predmety vrátené tento rok",
"hc.itemsWhoseLegalDeadlineIs": "Predmety, ktorých zákonný termín je 15 dní alebo menej (splatné vrátane). Zápasy zostanú viditeľné.",
"hc.kbisNumber": "Číslo Kbis",
"hc.keysForgottenOnABench": "Kľúče zabudnuté na lavici",
"hc.labelBeingGenerated": "Štítok sa generuje",
"hc.leaveTheFieldsEmptyTo": "Nechajte polia prázdne, aby ste ponúkli bezplatné vyzdvihnutie.",
"hc.legalNotice": "Právne oznámenie",
"hc.limitReachedUpgradeToA": "Limit dosiahnutý — prejdite na vyšší plán",
"hc.linkCopiedShareOn": "Odkaz skopírovaný — zdieľajte ho na {label}",
"hc.linkUnavailable": "Odkaz nie je k dispozícii",
"hc.linkedTo": "Prepojené na",
"hc.listingHiddenByModeration": "Zoznam skrytý moderáciou.",
"hc.loading": "Načítava sa…",
"hc.locateMe": "Nájdite ma",
"hc.logIn": "Prihlásiť sa",
"hc.logInToGetBack": "Prihláste sa, aby ste sa dostali späť do svojho priestoru a spravovali svoje predplatné.",
"hc.loginFailed": "Prihlásenie zlyhalo",
"hc.lostFoundPlatform": "Platforma stratených a nájdených.",
"hc.lostIn": "stratené v",
"hc.lowRate": "Nízka sadzba",
"hc.mainReason": "Hlavný dôvod",
"hc.mainStreet": "Hlavná ulica",
"hc.makeSureThisIsThe": "Uistite sa, že toto je predmet, ktorý ste stratili, pred odomknutím kontaktu nálezcu.",
"hc.manageCookies": "Spravovať cookies",
"hc.manageMyTeam": "Spravovať svoj tím",
"hc.manageYourTeam": "Spravovať váš tím",
"hc.markAsReturned": "Označiť ako vrátené",
"hc.matchNoClaimInTime": "Na zápas nebol podaný žiadny nárok v lehote.",
"hc.matchNotFound": "Zápas nenájdený",
"hc.medium": "Stredné",
"hc.milestoneFmt": "{m} vrátených predmetov dosiahnutý míľnik! Na ceste k {next}.",
"hc.missingFeatures": "Chýbajúce funkcie",
"hc.monthly": "Mesačne",
"hc.monthlyBilling": "Mesačné fakturovanie",
"hc.moveThePhotoToFit": "Presuňte fotografiu, aby sa zmestila do kruhu.",
"hc.myAccount": "Môj účet",
"hc.myInvoices": "Moje faktúry",
"hc.myMonthlyInvoices": "Moje mesačné faktúry",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Ako nastaviť svoj numerický odosielateľský ID?",
"hc.iDonTUseIt": "Dostatočne to nepoužívam",
"hc.iFoundItElsewhere": "Našiel/a som to inde",
"hc.iNoLongerNeedMy": "Už nepotrebujem svoju položku",
"hc.identityVerification": "Overenie identity",
"hc.idleLogoutIn": "Budeš odhlásený/á za {n} s z dôvodu nečinnosti.",
"hc.ifProvidedTheVolumetricWeight": "Ak je poskytnuté, použije sa objemová hmotnosť.",
"hc.ifThePartnerHasNot": "Ak partner nepotvrdil prijatie externého platby po tomto zdržaní, Findloop automaticky pripomína partnerovi, aby to validoval.",
"hc.impersonationEnded": "Impersonácia skončila.",
"hc.impersonationMode": "Režim impersonácie",
"hc.impersonationSessionExpired": "Relácia impersonácie vypršala.",
"hc.inTheField": ", v teréne",
"hc.inTransit": "V preprave",
"hc.inclVat": "vrátane DPH",
"hc.intraEuVatNumberOptional": "Intra-EÚ VAT číslo voliteľné, SIRET nie je potrebné (mimo Francúzska).",
"hc.invalidInvitationLink": "Neplatný pozvánkový odkaz.",
"hc.invalidInvitationLink2": "Neplatný pozvánkový odkaz",
"hc.invalidInviteLink": "Neplatný alebo vypršaný pozvánkový odkaz.",
"hc.invalidNumberEnterAnInternational": "Neplatné číslo. Zadaj medzinárodné číslo, napr. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Neplatný alebo vypršaný odkaz.",
"hc.invalidOrExpiredReactivationLink": "Neplatný alebo vypršaný reaktivačný odkaz",
"hc.invalidSendcloudId": "Neplatné Sendcloud ID",
"hc.inviteSubtitle": "{org} ťa pozýva pridať sa k ich Findloop tímu. Vyber si svoje heslo na aktiváciu účtu.",
"hc.isAvailableOnSendcloudFor": "je dostupné na Sendcloud pre všetky tvoje trasy (domáce + medzinárodné).",
"hc.isNotEnabledOnYour": "nie je povolené na tvojom Sendcloud účte pre niektoré destinácie. Štítky pre tie budú generované s iným dostupným prepravcom.",
"hc.isThisReallyYourItem": "Je to naozaj tvoja položka?",
"hc.isThisYourItem": "Je to tvoja položka?",
"hc.item": "Položka",
"hc.itemAlreadyConfirmed": "Položka už bola potvrdená",
"hc.itemDetails": "Podrobnosti o položke",
"hc.itemFoundAt": "Položka nájdená na",
"hc.itemFoundAtAPartner": "Položka nájdená u partnera",
"hc.itemMarkedAsReturned": "Položka označená ako vrátená ✓",
"hc.itemPhotoRequiredBeforeShipping": "Fotografia položky (požaduje sa pred odoslaním)",
"hc.itemPhotoSaved": "Fotografia položky uložená",
"hc.itemPreview": "Náhľad položky",
"hc.itemPutBackInStorage": "Položka bola vrátená do skladu.",
"hc.itemWeight": "Hmotnosť položky:",
"hc.itemsReturned": "položka/y vrátené",
"hc.nArchived": "{n} inzerovanie(ia) archivované.",
"hc.newCodeGeneratedAndSent": "Nový kód bol vygenerovaný a zaslaný zákazníkovi e-mailom a SMS.",
"hc.newCodeGeneratedAndSent2": "Nový kód bol vygenerovaný a zaslaný vlastníkovi.",
"hc.newPassword": "Nové heslo",
"hc.next": "Ďalší",
"hc.nextPhoto": "Ďalšia fotka",
"hc.no": "Nie",
"hc.noAnswerProvided": "Nebola poskytnutá odpoveď.",
"hc.noArchivedDeclarations": "Žiadne archivované vyhlásenia",
"hc.noCountryFound": "Žiadna krajina nenájdená",
"hc.noDeclarations": "Žiadne vyhlásenia",
"hc.noFeesAreChargedTo": "Žiadne poplatky nie sú účtované zákazníkovi.",
"hc.noInvoiceYet": "Ešte žiadna faktúra.",
"hc.noInvoiceYetYourInvoices": "Ešte žiadna faktúra. Vaše faktúry sa tu automaticky objavia po každej platbe.",
"hc.noMatchIsAvailableFor": "Momentálne nie sú k dispozícii žiadne zodpovedajúce položky. Dáme vám vedieť, hneď ako sa niečo zhoduje s vaším vyhlásením.",
"hc.noShipmentMatchesYourSearch": "Žiadna zásielka nezodpovedá vašemu vyhľadávaniu.",
"hc.noShipmentsYet": "Ešte žiadne zásielky.",
"hc.noShipmentsYet2": "Ešte žiadne zásielky",
"hc.none": "žiadne",
"hc.noneChooseForEachShipment": "Žiadne (vyberte pre každú zásielku)",
"hc.notMine": "To nie je moje",
"hc.of": "z",
"hc.only": "Iba",
"hc.onlyEachSiteManagesIts": "iba. Každý web spravuje svoje vlastné bankovníctvo: tieto odkazy neovplyvňujú žiadnu inú inštitúciu.",
"hc.onlyTheOwnerOrAn": "Iba vlastník alebo administrátor môže nakonfigurovať platobné odkazy inštitúcie.",
"hc.openDepositInTheMenu": "Otvorte \"Vklad\" v menu, popíšte položku a odfoťte ju. Je okamžite uložená a pripravená na vrátenie.",
"hc.openSettings": "Otvoriť Nastavenia →",
"hc.openTheDeclarationToManage": "Otvorte vyhlásenie na správu zásielky",
"hc.optional": "— voliteľné",
"hc.optional2": "(voliteľné)",
"hc.optional3": "voliteľné",
"hc.originalListingPhotoUsed": "Použitá originálna fotka inzerátu",
"hc.other": "Iné",
"hc.other2": "Iné…",
"hc.ourProducts": "Naše produkty",
"hc.overallRateTrendLast6": "Celkový trend cien (posledné 6 mesiacov)",
"hc.ownerSClaimCode": "Kód nároku vlastníka",
"hc.ownershipConfirmed": "Vlastníctvo potvrdené",
"hc.paid": "Zaplatené",
"hc.paidOn": "Zaplatené dňa",
"hc.paidViaPartner": "Zaplatené (cez partnera)",
"hc.parcelBeingPrepared": "Balík je v príprave",
"hc.parcelDelivered": "Balík doručený",
"hc.parcelShipped": "Balík odoslaný",
"hc.parisGareDeLyon": "Paríž, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Adresár partnerov",
"hc.passedOnToTheCustomer": "— poslané zákazníkovi sponzorský odkaz na platbu.",
"hc.password": "Heslo",
"hc.passwordResetPleaseLogIn": "Obnovenie hesla, prosím prihláste sa.",
"hc.passwordUpdated": "Heslo aktualizované.",
"hc.passwordsDoNotMatch": "Heslá sa nezhodujú.",
"hc.pasteThisSenderIdIn": "Vložte toto ID odosielateľa do Findloop → Nastavenia",
"hc.payForTheShipmentOf": "Zaplaťte za odoslanie vášho predmetu cez Findloop s bezpečnou platbou.",
"hc.payTheRecoveryFees": "Zaplaťte poplatky za zber",
"hc.payTheShippingFees": "Zaplaťte poštovné",
"hc.payment": "Platba",
"hc.paymentAlreadyConfirmedByThe": "Platba už potvrdená partnerom",
"hc.paymentLinksAreNowConfigured": "Platobné odkazy sú teraz nastavené podľa zariadenia",
"hc.paymentNotCompletedYourAccount": "Platba nebola dokončená, váš účet nebol vytvorený — prosím skúste to znova.",
"hc.paymentReceived": "Platba prijatá",
"hc.paymentSuccessful": "Platba úspešná!",
"hc.pdfInvoice": "PDF faktúra",
"hc.pending": "Na schválenie",
"hc.period": "Obdobie",
"hc.phoneNumber": "Číslo telefónu",
"hc.phoneOptional": "Telefón (voliteľné)",
"hc.planAt": "plán na",
"hc.planLimitFmt": "Váš plán \"{plan}\" je obmedzený na {max} zariadení. Pre správu {n} miest odporúčame",
"hc.platformReturnTarget": "Cieľ vrátenia platformy",
"hc.pleaseCompleteYourShippingAddress": "Prosím doplňte svoju adresu pre doručenie.",
"hc.pleaseProvideAPhoneNumber": "Prosím poskytnite číslo telefónu: je to požiadavka dopravcu pre odoslanie.",
"hc.pleaseProvideAReason": "Prosím, poskytnite dôvod.",
"hc.pleaseSetYourOwnPassword": "prosím nastavte si vlastné heslo pred pokračovaním.",
"hc.pointsToGoal": "{n} bodov na dosiahnutie našich spoločných cieľov.",
"hc.posterPreview": "Náhľad plagátu",
"hc.potentialMatchBeingVerified": "Potenciálna zhoda sa overuje",
"hc.potentialOwner": "Potenciálny vlastník",
"hc.preFilledAutomaticallyYouCan": "Predvyplnené automaticky — môžete to nahradiť fotkou balíka.",
"hc.pressKit": "Tlačová súprava",
"hc.previewMode": "Režim náhľadu:",
"hc.previewOfThePrintReady": "Náhľad pripraveného A4 plagátu pre túto prevádzku.",
"hc.previous": "Predchádzajúci",
"hc.previousPhoto": "Predchádzajúca fotografia",
"hc.primary": "primárny",
"hc.printThePoster": "Tlačiť plagát",
"hc.privacy": "Ochrana osobných údajov",
"hc.privacyPolicy": "Zásady ochrany osobných údajov",
"hc.processedCasesWillAppearHere": "Spracované prípady sa tu zobrazia.",
"hc.proofOfReturnPdf": "Potvrdenie o vrátení (PDF)",
"hc.protectedByRecaptcha": "Chránené reCAPTCHA",
"hc.publicMatch": "Verejné zhodovanie",
"hc.putBackInStorage": "Vrátiť naspäť do skladu",
"hc.pwdResetByTeam": "Vaše heslo bolo resetované naším tímom. Pre vašu bezpečnosť,",
"hc.questionsToAskTheOwner": "Otázky, ktoré sa môžete opýtať majiteľa",
"hc.rateChargedToTheCustomer": "Sadza účtovaná zákazníkovi:",
"hc.rateOfTarget": "{rate}% dosiahnuté z {target}% cieľa",
"hc.reached": "dosiahnuté",
"hc.reactivating": "Reaktivácia…",
"hc.reasonSavedYouCanStill": "Dôvod uložený. Môžete si stále nárokovať svoju položku.",
"hc.recentMatchesFirst": "Najnovšie zhodovania najprv",
"hc.recognizedThePhotoYouSent": "rozpoznal fotografiu, ktorú ste poslali a popísal tieto charakteristiky. Potvrďte len v prípade, že sa zhodujú s položkou vo vašej držbe.",
"hc.recommended": "Odporúčané",
"hc.recoveryFees": "Poplatky za obnovu",
"hc.recoveryFeesArePaidDirectly": "Poplatky za obnovu sa platia priamo prevádzke. Findloop neprijíma platby od zákazníkov.",
"hc.recoveryFeesEnabled": "Poplatky za obnovu sú povolené",
"hc.recoveryOfferedByTheEstablishment": "Obnova ponúkaná prevádzkou — Findloop neúčtuje žiadne poplatky.",
"hc.recoveryPaymentLink": "Odkaz na platbu za obnovu",
"hc.recoveryPaymentLinkSavedFor": "Odkaz na platbu za obnovu uložený pre túto prevádzku",
"hc.redirecting": "Prebieha presmerovanie…",
"hc.redirectingToPayment": "Prebieha presmerovanie na platbu…",
"hc.redirectingToTheRecoveryOf": "Prebieha presmerovanie na obnovu vašej položky…",
"hc.regenerateAndResendToThe": "Regenerovať a znovu odoslať majiteľovi",
"hc.regenerateTheCode": "Regenerovať kód",
"hc.registerAFoundItem": "Zaregistrovať nájdenú položku",
"hc.rejectTheClaim": "Odmietnuť nárok",
"hc.reminderDelaySaved": " oneskorenie pripomienky uložené",
"hc.reopenThePaymentLink": "Znovu otvoriť odkaz na platbu",
"hc.repeatThePassword": "Opakujte heslo",
"hc.reportAProblem": "Nahlásiť problém",
"hc.reportDismissedYourListingRemains": "Nahlásenie zamietnuté. Vaša ponuka zostáva verejná.",
"hc.requiredUsedToCalculateThe": "Povinné: používa sa na výpočet ceny za prepravu Sendcloud. Preprava nie je k dispozícii nad 30 kg.",
"hc.reset": "Obnoviť",
"hc.resume": "Pokračovať",
"hc.resumeRegistration": "Pokračovať v registrácii",
"hc.retro": "Rok v prehľade",
"hc.returnSecurity": "Bezpečnosť vrátenia",
"hc.returnToTheOwner": "Vrátiť majiteľovi",
"hc.returned": "vrátené",
"hc.reviewTheItemDetails": "Prehľadajte podrobnosti o položke",
"hc.revokeAccess": "Zrušiť prístup",
"hc.role": "Úloha:",
"hc.save": "Uložiť",
"hc.save2": "uložiť",
"hc.saveAndContinue": "Uložiť a pokračovať",
"hc.saving": "Ukladá sa…",
"hc.scanTheClaimCode": "Naskenujte kód reklamácie",
"hc.scanTheOwnerSQr": "Naskenujte QR kód majiteľa",
"hc.scrollThroughLanguages": "Prechádzajte jazykmi",
"hc.searchByCustomerItemOr": "Hľadanie podľa zákazníka, položky alebo sledovacieho čísla…",
"hc.searchForACountry": "Hľadanie krajiny…",
"hc.secureFindoVerification": "Bezpečná verifikácia Findloop",
"hc.seeRetro": "Pozrite si rok v prehľade",
"hc.selectedCarrier": "Vybraný dopravca:",
"hc.selectedPlan": "Vybraný plán",
"hc.send": "Odoslať",
"hc.sendcloudSenderIdSaved": "ID odosielateľa Sendcloud uložené",
"hc.sendcloudSenderIdSenderId": "ID odosielateľa Sendcloud (sender_id)",
"hc.sending": "Odosielam…",
"hc.sessionExpired": "Časová relácia vypršala",
"hc.setUpYourEstablishments": "Nastavte si svoje prevádzky",
"hc.settings": "Nastavenia",
"hc.settingsSubtitle": "Externé platby a pripomienky, nastavené podľa prevádzok.",
"hc.shareFoundText": "Našiel som predmet — pomôžte mi nájsť jeho majiteľa na Findloop",
"hc.shareLostText": "Stratil som predmet — pomôžte mi ho nájsť na Findloop",
"hc.sharePreview": "Zdieľať náhľad",
"hc.shareTheRanking": "Zdieľať hodnotenie",
"hc.shareYourQrCodeTo": "Zdieľajte svoj QR kód, aby ste dostali vyhlásenia.",
"hc.shipRateAutoWeight": "Cena za prepravu sa automaticky vypočíta cez Sendcloud (váha {w}) v čase odoslania.",
"hc.shipRateForWeight": "Cenník za dopravu (Sendcloud + {m}% marža) pre {w}:",
"hc.shipments": "Zásielky",
"hc.shipmentsSubtitle": "Zlúčený prehľad všetkých zásielok zariadenia vo všetkých prípadoch. Kliknite na riadok, aby ste spravovali zásielku v jej deklarácii.",
"hc.shipping": "Doprava",
"hc.shippingAddress": "Adresa doručenia",
"hc.shippingFeesAreHandledAutomatically": "Poplatky za dopravu sú spracovávané automaticky spoločnosťou Findloop (Sendcloud) — nie je potrebné zadať žiadny odkaz.",
"hc.shippingFeesHaveAlreadyBeen": "Poplatky za dopravu už boli zaplatené: prepravcu už nie je možné zmeniť.",
"hc.shippingNotAvailableForItems": "Doprava nie je k dispozícii pre položky nad 30 kg. Zákazník si bude musieť položku vyzdvihnúť osobne.",
"hc.shippingPaid": "Doprava zaplatená ✓",
"hc.showOnlyItemsMatchingA": "Zobraziť iba položky zodpovedajúce verejnému (zákazníckemu) zoznamu",
"hc.showPassword": "Zobraziť heslo",
"hc.signInTheBoxAbove": "Prihláste sa v boxe vyššie",
"hc.signatureSaved": "Podpis uložený",
"hc.signedInWithGoogle": "Prihlásený cez Google",
"hc.signupFailed": "Registrácia zlyhala",
"hc.silver": "Striebro",
"hc.simulatedRatesInPreProduction": "(simulované sadzby v predprodukcii)",
"hc.siretAndVatNumberRequired": "Vyžaduje sa SIRET a VAT číslo (Francúzsko).",
"hc.skip": "Preskočiť",
"hc.smsSentIfAccount": "Ak existuje účet s týmto číslom, bolo vám zaslané SMS.",
"hc.sortItemsWithAPublic": "Zoradiť: položky s verejnou zhodou (najnovšie) najprv",
"hc.specifyWhetherYouRecoveredYour": "Uveďte, či ste získali svoju položku alebo len chcete odstrániť tento zoznam.",
"hc.specifyYourReason": "Uveďte svoj dôvod",
"hc.specifyYourReason2": "Uveďte svoj dôvod…",
"hc.staff": "Zamestnanci",
"hc.status": "Stav",
"hc.staySignedIn": "Zostaňte prihlásený",
"hc.step": "Krok",
"hc.stillThere": "Ešte tam?",
"hc.stopScrolling": "Zastaviť posúvanie",
"hc.storeFindWithQr": "Uložte & nájdite pomocou QR",
"hc.streetName": "Názov ulice",
"hc.streetNo": "Číslo ulice",
"hc.switchTo": "Prepnúť na",
"hc.switchToDarkMode": "Prepnúť do tmavého režimu",
"hc.switchToLightMode": "Prepnúť do svetlého režimu",
"hc.takeAPhoto": "Urobte fotografiu",
"hc.takeChangeThePhoto": "Urobte / zmeňte fotografiu",
"hc.takenFromYourDeclaration": "prevzaté z vašej deklarácie",
"hc.target": "Cieľ",
"hc.targetReached": "Cieľ dosiahnutý",
"hc.targetReachedThankYouTo": "Cieľ dosiahnutý — ďakujeme celej komunite Findloop!",
"hc.tellUsMore": "Povedz nám viac…",
"hc.tellUsWhyYouCancel": "Povedz nám, prečo rušíš. Pomôže to partnerovi spracovať tvoju žiadosť.",
"hc.tellUsWhyYourListing": "Povedz nám prečo. Tvoja ponuka zostáva aktívna a môžeš si stále nárokovať svoju položku.",
"hc.termsAndConditions": "Podmienky a ustanovenia",
"hc.termsAndPolicies": "Podmienky a politiky",
"hc.thankYouForYourFeedback": "Ďakujeme za tvoju spätnú väzbu",
"hc.theBannerDisplayedInThe": "banner zobrazený v registri.",
"hc.theClaimantHasBeenInformed": "Žiadateľ bol informovaný. Položka zostáva dostupná v verejnej ponuke.",
"hc.theClaimantHasBeenNotified": "Žiadateľ bol informovaný a môže pokračovať s vrátením.",
"hc.theCustomerPaysTheFees": "Zákazník platí poplatky podniku.",
"hc.theDayTheLegalRetention": "Deň, keď uplynie právny zadržovací termín.",
"hc.theEstablishmentConsideredThatThis": "Podnik považoval, že táto položka nie je tvoja.",
"hc.theEstablishmentIsReviewingYour": "Podnik skúma tvoje odpovede. Budeš informovaný, akonáhle bude tvoja žiadosť overená, potom môžeš zaplatiť poplatky za vrátenie.",
"hc.theFeesAreTooHigh": "Poplatky sú príliš vysoké",
"hc.theFinderConsideredThatThis": "Nálezca považoval, že táto položka nie je tvoja.",
"hc.theFinderIsReviewingYour": "Nálezca prehodnocuje tvoju žiadosť. Budeš informovaný, akonáhle bude overená.",
"hc.theItem": "Položka",
"hc.theItemWillBeRemoved": "Položka bude odstránená z registra (žiadna žiadosť prebieha).",
"hc.theItemWillBeSet": "Položka bude opätovne nastavená na \"skladom\" a súvisiaca žiadosť zrušená.",
"hc.theKbisNumberAndVat": "Číslo Kbis a IČ DPH sú povinné pre Francúzsko.",
"hc.theLabelIsGeneratedAutomatically": "Štítok sa generuje automaticky hneď, ako zákazník zaplatí poplatky za prepravu. Bude sa dať stiahnuť tu.",
"hc.theLinkMayHaveExpired": "Odkaz mohol vypršať (platný 30 dní). Kontaktuj podporu Findloop, ak je to potrebné.",
"hc.theOwnerDescribesTheirItem": "Majiteľ opisuje svoju položku",
"hc.theOwnerReceivedItBy": "Majiteľ ju dostal emailom (alebo SMS). Zadaj alebo oskenuj pred odovzdaním.",
"hc.thePartnerConsideredThatThis": "Partner považoval, že táto položka nie je tvoja. Položka zostáva dostupná.",
"hc.thePartnerIsReviewingYour": "Partner skúma tvoje odpovede. Budeš informovaný, akonáhle bude tvoja žiadosť overená.",
"hc.theShipmentIsCreatedAutomatically": "Preprava sa vytvára automaticky, keď zákazník potvrdí svoju adresu a zaplatí poplatky za vrátenie. Štítok bude potom generovaný automaticky po zaplatení za prepravu a môže sa stiahnuť tu.",
"hc.theShippingRateWillBe": "Poplatok za prepravu bude automaticky vypočítaný cez Sendcloud v čase odoslania (zaznamenaná hmotnosť).",
"hc.thisCarrierWillBe": "Tento prepravca bude",
"hc.thisEstablishment": "tento podnik",
"hc.thisFieldIsRequiredFor": "Toto pole je povinné pre automatické generovanie štítka.",
"hc.thisIsMyItem": "Toto je moja položka",
"hc.thisIsMyItemContinue": "Toto je moja položka — pokračuj",
"hc.thisIsMyItemStart": "Toto je moja položka — začni vrátenie",
"hc.thisIsNotMyItem": "Toto nie je moja položka",
"hc.thisMatchIsNoLonger": "Tento zápas už nie je dostupný alebo bol už spracovaný.",
"hc.thisRateWillBeCharged": "Tento poplatok bude účtovaný zákazníkovi. Vysoký poplatok môže odradiť od vrátenia.",
"hc.thisStepIsRequiredFor": "Tento krok je potrebný pre generovanie štítkov na zasielanie",
"hc.thisValidationLinkIsInvalid": "Tento validačný odkaz je neplatný alebo vypršal.",
"hc.toCheckBeforeMarkingThe": "Skontrolujte pred označením položky ako vrátenej.",
"hc.toConfigureTheLinksAnd": "na nastavenie odkazov a oneskorenia pripomienky pre každé zariadenie.",
"hc.toReachOurFirstMilestone": "na dosiahnutie našej prvej méty 100 vrátaní.",
"hc.toTheCustomer": "k zákazníkovi.",
"hc.toTheShippingFeePayment": "k platbe za poštovné.",
"hc.toYourRecoveryTracking": "k sledovaniu vašej obnovy.",
"hc.tooExpensiveBudget": "Príliš drahé / rozpočet",
"hc.topCitiesForReturns": "Najlepšie mestá na vrátenie",
"hc.trackMyRecovery": "Sledujte moju obnovu",
"hc.trackTheShipmentAndDownload": "Sledujte zásielku a stiahnite si štítok (vytvorený automaticky) bez opustenia záložky Vyhlásenia.",
"hc.trackYourStatistics": "Sledujte svoje štatistiky",
"hc.tracking": "Sledovanie",
"hc.unableToOpenTheShipping": "Nemožno otvoriť platbu za poštovné. Prosím, skúste to znova.",
"hc.unableToRetrieveTheInvoice": "Nemožno získať faktúru.",
"hc.unclaimed": "Neprihlásené",
"hc.unclaimedCustomerReason": "Neprihlásená položka. Dôvod zákazníka: \"{reason}\".",
"hc.unclaimedItem": "Neprihlásená položka",
"hc.unclaimedItemNoClaimWithin": "Neprihlásená položka — žiadna reklamácia v stanovenom termíne.",
"hc.unclaimedItems": "Neprihlásené položky",
"hc.unclaimedItemsMatchLeftWithout": "Neprihlásené položky: zhodná položka bez reklamácie v stanovenom termíne. Môžete ich vrátiť do úložiska.",
"hc.unlockTheFinderSContact": "Odomknite kontaktné údaje nálezcu, aby ste dohodli odovzdanie.",
"hc.upcoming": "Nadchádzajúce",
"hc.updateFailed": "Aktualizácia zlyhala.",
"hc.usedForInvoices": "Používané na vystavenie vašich faktúr findloop.",
"hc.vatNumber": "IČ DPH",
"hc.verificationPending": "Čakanie na overenie",
"hc.verificationSentToTheFinder": "Overenie odoslané nálezcovi. Budete informovaní o ich rozhodnutí.",
"hc.verificationSentToThePartner": "Overenie odoslané partnerovi. Budete informovaní o ich rozhodnutí.",
"hc.verify": "Overiť",
"hc.verifyingInvite": "Overujem odkaz na pozvanie…",
"hc.verifyingTheLink": "Overujem odkaz…",
"hc.viewInRegistry": "Zobraziť v registri",
"hc.viewItem": "Zobraziť položku",
"hc.viewItemRecover": "Zobraziť položku & obnoviť",
"hc.visibleToTheOwnerAutomatically": "Viditeľné pre vlastníka · automaticky vymazané po 60 dňoch.",
"hc.waitingForPartnerConfirmation": "Čakanie na potvrdenie partnera",
"hc.waitingForThePartnerS": "Čakanie na potvrdenie partnera",
"hc.weHaveInformedTheEstablishment": "Informovali sme zariadenie, že táto položka nie je vaša a znovu spustili analýzu. Budete informovaní, hneď ako sa nájde nová zhodná položka.",
"hc.weHaveInformedThePartner": "Informovali sme partnera, že táto položka nie je vaša. Vaša ponuka zostáva aktívna pre budúce zhodné položky.",
"hc.weRanTheAnalysisAgain": "Analýzu sme zopakovali a identifikovali ďalšiu položku, ktorá by mohla byť vaša. Skontrolujte ju znova.",
"hc.weight": "Hmotnosť",
"hc.weightNotProvidedTheShipping": "Hmotnosť nebola poskytnutá: cena za dopravu bude vypočítaná v čase odoslania.",
"hc.weightUnit": "Jednotka hmotnosti",
"hc.welcome": "Vitajte!",
"hc.welcomeToFindo": "Vitajte vo Findloop",
"hc.whenACustomerComesTo": "Keď zákazník príde vyzdvihnúť svoje veci, otvorte jeho deklaráciu a potvrďte vrátenie. To je všetko!",
"hc.whenDisabledFeesDropTo": ". Keď je deaktivované, poplatky klesnú na",
"hc.whyIsThisNotYour": "Prečo toto nie je vaša položka?",
"hc.willBeMarkedAs": "bude označená ako",
"hc.wrongColor": "Nesprávna farba",
"hc.wrongModel": "Nesprávny model",
"hc.yesCancel": "Áno, zrušiť",
"hc.yesContactTheFinder": "Áno, kontaktovať nálezcu",
"hc.youAreHere": "Ste tu",
"hc.youBusinessCom": "vy@firma.com",
"hc.youCanNowStartThe": "Môžete teraz začať vrátenie.",
"hc.youCanStillChangeIt": ". Môžete to stále zmeniť individuálne.",
"hc.youHaveAlreadyConfirmedThat": "Už ste potvrdili, že toto je vaša položka.",
"hc.youWillBeRedirectedTo": "Budete presmerovaní na zabezpečenú platbu Stripe.",
"hc.yourAccountHasBeenReactivated": "Váš účet bol znovu aktívny.",
"hc.yourAccountIsActiveYou": "Váš účet je aktívny, teraz môžete spravovať svoje zariadenia.",
"hc.yourEstablishment": "Vaše zariadenie",
"hc.yourFeedbackHelpsUsImprove": "Vaša spätná väzba nám pomáha zlepšovať naše zhodnotenia.",
"hc.yourFeedbackHelpsUsRestart": "Vaša spätná väzba nám pomáha reštartovať analýzu a zlepšiť naše zhodnotenia.",
"hc.yourFirstSteps": "Vaše prvé kroky",
"hc.yourFirstStepsAdmin": "Vaše prvé kroky (administrátor)",
"hc.yourItemHasBeenHanded": "Vaša položka bola odovzdaná osobne partnerom — uzavrite prípad, akonáhle je odovzdanie potvrdené.",
"hc.yourItemHasBeenShipped": "Vaša položka bola odoslaná partnerom — uzavrite prípad, akonáhle je doručenie potvrdené.",
"hc.yourPaymentHasBeenRecorded": "Vaša platba bola zaznamenaná.",
"hc.yourShipmentIsBeingPrepared": "Vaša zásielka sa pripravuje. Váš balík dostanete do 3 až 5 pracovných dní.",
"hc.yourShippingFeesHaveAlready": "Vaše poplatky za dopravu už boli zaplatené. Doprava zaplatená ✓",
"hc.yourShippingFeesHaveBeen": "Vaše poplatky za dopravu boli zaplatené. Váš balík sa pripravuje.",
"hc.yourVerificationQuestionsDeposit": "Vaše overovacie otázky (záloha)",
"hero.einvoiceBadge": "E-fakturácia v súlade s normou 2027",
"home.recentAdsAll": "Zobraziť všetky inzeráty",
"home.recentAdsEyebrow": "Práve teraz",
"home.recentAdsSubtitle": "Nájdite a stratili predmety hlásené komunitou.",
"home.recentAdsTitle": "Najnovšie inzeráty",
"home.reunions": "Nedávne znovuzjednotenia",
"home.videoEyebrow": "Pozrite si",
"home.videoSubtitle": "Ako bez námahy zjednocujeme stratené veci s ich majiteľmi.",
"home.videoTitle": "Objavte Findloop za 2 minúty",
"home.watchYoutube": "Pozrite si na YouTube",
"impact.already": "Už",
"impact.citiesWord": "mesto/mestá",
"impact.eachPoint": "Každý bod je mesto, kde Findloop pomáha obnoviť stratené predmety.",
"impact.emptyMap": "Mapa sa zaplní, keď dôjde k vráteniu.",
"impact.eyebrow": "Náš dopad",
"impact.inCities": "po celom",
"impact.restitutedTo": "predmety vrátené ich majiteľom",
"impact.title": "Predmety vrátené, všade okolo vás",
"inv2.download": "Stiahnuť",
"inv2.view": "Zobraziť",
"map.objectsOnMapPlural": "predmety na mape",
"map.objectsOnMapSingular": "predmet na mape",
"mc.claimConfirmDesc": "Skontrolujte predmet nájdený nálezcom pred zaplatením za odblokovanie ich kontaktov.",
"mc.claimConfirmNo": "Toto nie je môj predmet",
"mc.claimConfirmTitle": "Je to naozaj váš predmet?",
"mc.claimConfirmYes": "Áno, je môj — zaplatím",
"mc.claimFinderContacts": "Kontaktné údaje nálezcu",
"mc.claimNotMineDone": "Ďakujem — nálezca bol informovaný a vaša žiadosť bola odstránená z inzerátu.",
"mc.claimUnlockDesc": "Zaplaťte poplatok za správu Findloop, aby ste získali kontaktné údaje osoby, ktorá našla váš predmet.",
"mc.claimUnlockTitle": "Odomknite kontaktné údaje nálezcu",
"mc.hideCountryOffers": "Skryť ponuky v mojej krajine",
"mc.myClaims": "Predmety, o ktoré sa hlásim",
"mc.myClaimsSub": "Predmety nájdené inými, o ktoré sa hlásite. Odomknite kontaktné údaje nálezcu, aby ste dohodli odovzdanie.",
"mc.notifAdCancelled": "Inzerát zrušený",
"mc.notifCancelAd": "Zrušiť môj inzerát",
"mc.offersInCountry": "Ponuky v mojej krajine",
"mc.offersInCountryDesc": "Všetky aktívne odmeny od partnerov vo vašej krajine, podľa mesta.",
"mc.redArchived": "Archívne",
"mc.rewardsCountryNone": "V vašej krajine zatiaľ žiadna ponuka nie je.",
"mc.rewardsForYou": "Odmeny pre vás",
"mc.rewardsForYouDesc": "Ponúkané partnerom/partnerami, od ktorých ste odovzdali predmet.",
"mc.rewardsMineNone": "Zatiaľ žiadna odmena od vašich odovzdávacích partnerov.",
"mc.showCountryOffers": "Zobraziť ponuky v mojej krajine",
"mc2.cancelDecl": "Zrušiť moje vyhlásenie",
"mc2.cancelDeclDone": "Vyhlásenie zrušené.",
"pricing.physInvDesc": "Keď je predmet vrátený, jeho poloha je automaticky uvoľnená a k dispozícii pre nový predmet.",
"pricing.physInvTitle": "Sledovanie fyzických zásob",
"pricing.physModalTitle": "Správa fyzických položiek",
"pricing.physQrDesc": "Pre každú položku je generovaný jedinečný QR kód, ktorý odkazuje na všetky jej informácie.",
"pricing.physQrTitle": "Vyhradený QR štítok",
"pricing.physShelfDesc": "Každá registrovaná položka môže byť priradená k fyzickej lokalite v zariadení.",
"pricing.physShelfTitle": "Plán políc",
"pricing.physicalMgmt": "Správa fyzických položiek (police, QR, inventár)",
"pub.addSecondPhoto": "Pridať 2. foto (voliteľné)",
"pub.photo2Added": "✓ 2. foto pridané",
"reg.dispositionJournal": "Žurnál dispozícií",
"reg.dispositionNoteAuthHint": "ℹ️ Poznámka je potrebná pre 'Odovzdané orgánom' (číslo hlásenia, oddelenie…)",
"reg.dispositionNotePh": "Poznámka (voliteľné): charita prijímateľa, referenčné číslo orgánov, meno kupujúceho…",
"reg.dispositionNoteRequired": "Úradná referencia je potrebná na odovzdanie orgánom.",
"reg.legalPrealert": "Právny termín za {days} deň/dni",
"reg.legalPrealertOptions": "Možnosti pri termíne: aukčný predaj, darovanie charite, odovzdanie orgánom.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Úplná recenzia",
"rev.readMore": "Čítať viac",
"rw.activeCodes": "Aktívne poukazy",
"rw.archived": "Archivované",
"rw.archivedTitle": "Uplatnené poukazy (archivované)",
"rw.hideArchived": "Skryť uplatnené poukazy",
"rw.noArchived": "Žiadny archivovaný poukaz.",
"rw.showArchived": "Zobraziť uplatnené poukazy",
"shp.labelAuto": "Štítok je generovaný automaticky hneď po zaplatení poštovného. Tu bude na stiahnutie.",
"st.cancelled_by_customer": "Zrušené",
"stt.dispoPdfBtn": "Exportovať PDF",
"stt.dispoPdfError": "Export PDF zlyhal.",
"stt.dispoPdfExporting": "Exportovanie…",
"trk.matchVerifying": "Overuje sa potenciálna zhoda",
"pcat.stadium_arena": "Štadión / Aréna",
"pcat.supermarket": "Supermarket",
"pcat.taxi_vtc": "Taxi / Zdieľaná jazda",
"pcat.tourism_office": "Turistická kancelária",
"pcat.train_bus_station": "Železničná / Autobusová stanica",
"pcat.travel_agency": "Cestovná kancelária",
"hc.and": "a",
"hc.demoObj0": "peňaženka",
"hc.demoObj1": "športová taška",
"hc.demoObj2": "telefón",
"hc.demoObj3": "pár okuliarov",
"hc.demoObj4": "súbor kľúčov",
"hc.demoObj5": "šál",
"hc.demoObj6": "laptop",
"hc.demoObj7": "fľaša na vodu",
"hc.demoWhen0": "pred 2 hodinami",
"hc.demoWhen1": "pred 5 hodinami",
"hc.demoWhen2": "včera",
"hc.demoWhen3": "pred 3 hodinami",
"hc.demoWhen4": "dnes ráno",
"hc.demoWhen5": "pred 1 dňom",
"hc.feedDemo": "{obj} bol vrátený v {city} {when}.",
"hc.feedReal": "Položka ({cat}) bola vrátená v {city}.",
"hc.saveBtn": "Uložiť",
"hc.saveLink": "Uložiť odkaz",
"hc.terms": "Podmienky",
"hc.view": "Zobraziť",
"pcat.airline": "Letecká spoločnosť",
"pcat.airport": "Letisko",
"pcat.amusement_park": "Zábavný park",
"pcat.bank": "Banka",
"pcat.bar_cafe": "Bar / Kaviareň",
"pcat.beauty_salon": "Kadernícky / Kozmetický salón",
"pcat.cinema": "Kino",
"pcat.concert_theater": "Koncertná sála / Divadlo",
"pcat.coworking": "Coworkingové priestory",
"pcat.gym_fitness": "Telocvičňa / Fitness",
"pcat.hospital_clinic": "Nemocnica / Klinika",
"pcat.library": "Knižnica",
"pcat.mall": "Nákupné centrum",
"pcat.museum": "Múzeum",
"pcat.pharmacy": "Lekáreň",
"pcat.private_company": "Súkromná spoločnosť",
"pcat.public_transport": "Verejná doprava",
"pcat.school_university": "Škola / Univerzita",
"pcat.sports_center": "Športové centrum",
"an.found": "Nájdené",
"an.lost": "Stratené",
"hc.shareReview": "Zdieľať recenziu",
"hc.citiesAboveTarget": "{n} miest nad svojím cieľom",
"hc.cityAboveTarget": "{n} mesto nad jeho cieľom",
"hc.j15EarlyReminder": "D-15 predbežná pripomienka",
"hc.j7EarlyReminder": "D-7 predbežná pripomienka",
"hc.annualTotal": "Ročný celkový",
"hc.billedOnceYear": "Účtované raz za 12 mesiacov, obnovené každý rok.",
"hc.monthlyPrice": "Mesačná cena",
"hc.perMonth": "/ mesiac",
"hc.perYear": "/ rok",
"hc.billedEachMonth": "Nabíjané automaticky každý mesiac.",
"nav.business": "Podnikanie",
"nav.individual": "Jednotlivec",
"hc.circumstancesFound": "Okolnosti nálezu",
"hc.circumstancesFoundPh": "Např. nájdené na zemi pri vstupe do metra",
"hc.circumstancesLost": "Okolnosti straty",
"hc.circumstancesLostPh": "Např. zabudnuté na lavičke pri čakaní na autobus",
"hc.conditionPh": "Např. dobré, poškriabané...",
"hc.firstName": "Meno",
"hc.lastName": "Priezvisko",
"hc.quantity": "Počet predmetov",
"fa.approve": "Schváliť",
"fa.approveConfirm": "Schváliť tento údaj? Vaše úplné kontaktné údaje (meno, e-mail, telefón) budú vymenené s nálezcom.",
"fa.approved": "Údaj schválený — kontaktné údaje vymenené",
"fa.approvedFinder": "Majiteľ schválil váš údaj",
"fa.approvedFinderText": "Kontaktujte ich, aby ste dohodli vrátenie.",
"fa.boostSub": "Vaša ponuka zostane na vrchu počas zvolenej doby.",
"fa.boostTitle": "Zvýšiť moju ponuku (voliteľné)",
"fa.colFinder": "Údaj nálezcu",
"fa.colYours": "Váš údaj",
"fa.compareHint": "Porovnajte údaj nálezcu so svojím pred rozhodnutím.",
"fa.contribNone": "Žiadny príspevok",
"fa.contribPaid": "Príspevok prijatý — ďakujeme!",
"fa.contribPending": "Príspevok čaká na platbu",
"fa.contribSub": "Podporte Findloop, aby pomohlo viac ľuďom získať ich veci späť. Môžete zvoliť €0.",
"fa.contribSuccessMsg": "Váš údaj bol odoslaný majiteľovi.",
"fa.contribSuccessTitle": "Ďakujeme za váš príspevok",
"fa.contribTitle": "Dobrovoľný príspevok",
"fa.days3": "3 dni",
"fa.days30": "30 dní",
"fa.days7": "7 dní",
"fa.declSub": "Popíšte predmet, ktorý ste našli. Majiteľ porovná váš údaj so svojím.",
"fa.declTitle": "Našiel(a) som tento predmet",
"fa.expiresOn": "Platnosť končí",
"fa.fBrand": "Značka",
"fa.fCircumstances": "Okolnosti",
"fa.fCity": "Mesto",
"fa.fColor": "Farba",
"fa.fCondition": "Stav",
"fa.fDate": "Dátum",
"fa.fMessage": "Správa nálezcu",
"fa.fPlace": "Miesto",
"fa.fQuantity": "Množstvo",
"fa.finderContact": "Kontaktné údaje nálezcu",
"fa.finishPay": "Dokončiť platbu",
"fa.foundDate": "Dátum nájdenia",
"fa.foundPlace": "Miesto nájdenia",
"fa.hours24": "24 hodín",
"fa.ht": "bez DPH",
"fa.months3": "3 mesiace",
"fa.noBoost": "Žiadne zvýšenie",
"fa.ownerContact": "Kontaktné údaje vlastníka",
"fa.payPublish": "Zaplatiť a zverejniť",
"fa.pendingPayText": "Vaša ponuka bude aktívna, hneď ako bude platba potvrdená.",
"fa.pendingPayTitle": "Platba prebieha",
"fa.planSub": "Vaša ponuka bude aktívna, akonáhle bude platba potvrdená.",
"fa.planTitle": "Doba trvania ponuky",
"fa.pubSuccessMsg": "Vaša ponuka je aktívna. Budete informovaní hneď, ako sa nájde hľadač.",
"fa.pubSuccessTitle": "Ponuka zverejnená",
"fa.publicNote": "Verzia len s popisom, mestom, krajinou a fotkami je zverejnená verejne.",
"fa.redirectStripe": "Presmerovávame na bezpečnú platbu…",
"fa.reject": "Zamietnuť",
"fa.rejectConfirm": "Zamietnuť toto vyhlásenie? Vaša ponuka zostáva online.",
"fa.rejected": "Vyhlásenie zamietnuté",
"fa.rejectedFinder": "Nebolo to to, čo hľadali",
"fa.rejectedFinderText": "Vlastník hovorí, že tento predmet nie je jeho. Ďakujeme za vašu pomoc!",
"fa.responsesTitle": "Vyhlásenia hľadačov",
"fa.sent": "Vyhlásenie odoslané vlastníkovi.",
"fa.submitDecl": "Odoslať moje vyhlásenie",
"fa.submitDeclPay": "Odoslať a prispieť {amount}",
"fa.total": "Celková suma na zaplatenie",
"fa.ttc": "vrátane DPH",
"fa.waitClaimText": "Hľadač preskúmava vašu žiadosť. Budete informovaní o ich rozhodnutí.",
"fa.waitFinderText": "Dáme vám vedieť, hneď ako hľadač odošle vyhlásenie.",
"fa.waitFinderTitle": "Vaša ponuka je aktívna",
"fa.waitOwnerText": "Vlastník porovnáva vaše vyhlásenie so svojím. Budete informovaní o ich rozhodnutí.",
"fa.waitOwnerTitle": "Čaká sa na rozhodnutie vlastníka",
"st.pending_payment": "Platba prebieha",
"fa.africaFree": "Bezplatné zaradenie v Afrike — ponuka pri spustení Findloop, užívajte si to!",
"fa.africaPublished": "Zaradenie publikované zadarmo — ponuka pri spustení Afriky!",
"fa.approveClaimConfirm": "Schváliť tento nárok? Majiteľ potom bude môcť odomknúť vaše kontaktné údaje.",
"fa.checkInfo": "Skontrolujte svoje údaje pred odoslaním: budú porovnané s nálezcom.",
"fa.claimApprovedShort": "Nálezca schválil váš nárok",
"fa.claimRejectedShort": "Nárok zamietnutý nálezcom",
"fa.claimRejectedText": "Nálezca verí, že tento predmet nie je váš.",
"fa.claimSub": "Opíšte svoj predmet a pridajte 2 fotografie. Nálezca ich porovná so svojím zaradením.",
"fa.claimTitle": "Toto je môj predmet",
"fa.claimUnlockText": "Odomknite kontaktné údaje nálezcu, aby ste dohodli vrátenie.",
"fa.claimUnlockedShort": "Kontaktné údaje odomknuté — pozri sledovanie",
"fa.claimsTitle": "Nároky majiteľov",
"fa.colOwner": "Vyhlásenie majiteľa",
"fa.colYourAd": "Vaše zaradenie",
"fa.expired": "Zaradenie vypršalo",
"fa.free": "Zadarmo",
"fa.lostDate": "Dátum straty",
"fa.lostPlace": "Miesto straty",
"fa.noReceipt": "Pre toto zaradenie nie je k dispozícii žiadny doklad.",
"fa.planSubFree": "Vyberte trvanie: vaše zaradenie bude aktívne okamžite, platba nie je potrebná.",
"fa.prefillPrevious": "Znova použiť údaje z môjho predchádzajúceho zaradenia v tejto kategórii",
"fa.receipt": "PDF doklad",
"fa.renewBtn": "Obnoviť",
"fa.renewDiscountBanner": "50% zľava: obnovte pred vypršaním vášho zaradenia!",
"fa.renewDiscountHint": "50% zľava bola uplatnená, pretože obnovujete pred vypršaním.",
"fa.renewEarly": "Obnoviť (−50%)",
"fa.renewTitle": "Obnoviť moje zaradenie",
"fa.renewed": "Zaradenie obnovené",
"fa.sendClaim": "Odoslať môj nárok",
"fa.twoPhotos": "2 fotografie vášho predmetu",
"fa.twoPhotosError": "Pridajte 2 fotografie vášho predmetu.",
"fa.twoPhotosHint": "Osobné fotografie dokazujúce, že predmet je váš (s predmetom, faktúrou, krabicou…).",
"fa.unlockBtn": "Odomknúť kontaktné údaje",
"fa.unlockFree": "Odomknúť zadarmo — ponuka pri spustení",
"fa.waitClaimantText": "Dáme vám vedieť, hneď ako majiteľ nárokuje tento predmet.",
"fa.waitFinderDecision": "Čakanie na rozhodnutie nálezcu",
"fa.waitUnlockText": "Budete informovaní, hneď ako budú kontaktné údaje vymenené.",
"fa.waitUnlockTitle": "Čakanie na odomknutie od majiteľa",
"fa.cancel": "Zrušiť",
"fa.categoryRequired": "Vyberte kategóriu pre nájdenú položku.",
"fa.confirmTitle": "Potvrďte svoje rozhodnutie",
"fa.goBack": "Späť",
"dr.continue": "Pokračovať v mojej deklarácii",
"dr.delete": "Trvalo odstrániť",
"dr.deleteConfirm": "Trvalo odstrániť tento návrh? Toto nemožno vrátiť späť.",
"dr.deleted": "Návrh odstránený",
"dr.expiresIn": "Návrh sa uchováva ešte {h} hodín",
"dr.title": "Máte nedokončenú deklaráciu",
"form.step": "Krok",
"form.next": "Pokračovať",
"form.back": "Späť",
"form.stepDetails": "Váš report",
"form.stepPublish": "Doba trvania, podpora a platba",
"form.stepThanks": "Ďakujeme a príspevok",
"fthx.badge": "Report takmer dokončený",
"fthx.title": "Ďakujeme, robíte rozdiel!",
"fthx.text": "Vďaka vám sa niekto môže čoskoro vrátiť k niečomu, na čom mu záleží. Aktivity láskyplnosti ako tá vaša sú presne to, čo drží Findloop pri živote.",
"fthx.impact1": "1 položka nahlásená",
"fthx.impact2": "1 ďalšia šanca na zjednotenie",
"fthx.tipTitle": "Malé povzbudenie pre Findloop?",
"fthx.tipText": "Váš príspevok nám pomáha udržiavať službu prístupnú a znovu spojiť čoraz viac vecí s ich majiteľmi.",
"fthx.optional": "100% voľiteľné — môžete zverejniť aj bez príspevku.",
"fthx.thanksTip": "Ďakujeme veľmi pekne za vašu veľkorysosť!",
"fthx.suggest": "Odporúčané sumy",
"fthx.none": "Žiadny tip",
"pay.pendingTitle": "Platba nie je dokončená",
"pay.pendingText": "Vaše údaje sú uložené. Pokračujte v platbe tam, kde ste skončili.",
"pay.resume": "Pokračovať v platbe",
"pay.expiredTitle": "Platobná relácia vypršala",
"pay.expiredText": "Pre vaše zabezpečenie vypršala platobná relácia. Vaše údaje sú uložené: reštartujte platbu jedným kliknutím.",
"pay.relaunch": "Reštartovať platbu",
"sub.received": "Odoslané!",
"sub.publishing": "Dokončujeme…",
"sub.toPayment": "Presmerovávame na zabezpečenú platbu…",
"fa.claimSubV2": "Opíšte svoju stratenú vec. Osoba, ktorá ju našla, porovná vašu deklaráciu s ich zoznamom.",
"fa.photosOptional": "Fotografie vašej veci (voliteľné)",
"fa.compareOwnerHint": "Porovnajte tieto informácie s predmetom, ktorý ste našli, a potom povedzte, či je to ten istý predmet.",
"fa.itsThisItem": "Áno, toto je predmet",
"fa.notThisItem": "Nie, toto nie je predmet",
"fa.confirmIsItem": "Potvrdíte, že toto je predmet? Vaše kontaktné údaje a údaje majiteľa budú zobrazené vo vašich účtoch.",
"fa.confirmNotItem": "Potvrdíte, že toto nie je predmet? Váš report bude uzavretý.",
"fa.youConfirmed": "Potvrdili ste, že toto je predmet majiteľa",
"fa.youDeclined": "Uvedomili ste si, že toto nebol predmet",
"fa.youDeclinedText": "Ďakujeme za vašu pomoc! Majiteľ bol informovaný.",
"fa.waitFinderDecisionOwner": "Čakáme na rozhodnutie nálezcu",
"fa.finderConfirmed": "Potvrdené",
"fa.notYourItem": "Toto nebol váš predmet",
"fa.reportedOn": "Nahlásené dňa",
"fa.ownerWaitHint": "Nálezca momentálne kontroluje informácie, prosím počkajte.",
"fa.claimSentFinder": "Žiadosť bola odoslaná osobe, ktorá našla predmet.",
"fa.compareClaimHint": "Porovnajte vyhlásenie vlastníka s vaším zoznamom pred rozhodnutím.",
"fa.closeFollowup": "Zavrieť túto následnú záležitosť",
"fa.closeFollowupConfirm": "Zavrieť túto následnú záležitosť? E-maily a telefónne čísla oboch strán budú natrvalo vymazané, hneď ako majiteľ zavrie svoj záznam.",
"fa.safetyTitle": "Tipy na bezpečnosť pred odovzdaním",
"fa.safety1": "Požiadajte majiteľa o podrobný popis skrytých vlastností predmetu: konkrétna škrabance, presný obsah tašky, tapeta, sériové číslo…",
"fa.safety2": "Ak je to možné, požiadajte o vizuálny dôkaz (fotografia predmetu) alebo doklad o kúpe.",
"fa.safety3": "Odovzdajte predmet na verejnom mieste alebo u partnera Findloop a skontrolujte identifikáciu majiteľa.",
"fa.safetyOk": "Rozumiem, pokračovať",
"fa.ownerClosedNote": "Majiteľ uzavrel svoj záznam.",
"fa.finderClosedNote": "Nájdená osoba uzavrela svoju následnú záležitosť.",
"fa.followupClosed": "Sledovanie uzavreté",
"fa.followupClosedText": "Uzavreli ste toto sledovanie. Ďakujeme za vašu pomoc!",
"fa.photoReviewTitle": "Finder poslal fotografiu. Vyzerá to ako vaša položka?",
"fa.photoLooksLike": "Áno, vyzerá to ako moja položka",
"fa.photoNotMine": "Nie, toto nie je moja položka",
"fa.photoNotMineConfirm": "Požiadavka sa uzavrie z oboch strán a váš inzerát zostane otvorený pre nového findera.",
"fa.photoLooksLikeDone": "Ďakujeme! Finder teraz porovná vašu deklaráciu.",
"fa.photoNotMineDone": "Hlášenie bolo zamietnuté. Váš inzerát zostáva otvorený.",
"fa.ownerPhotoHint": "Iba finderova fotografia je vám zobrazená. Povedzte nám, či to vyzerá ako vaša položka.",
"fa.ownerReviewingPhoto": "Majiteľ posudzuje vašu fotografiu",
"fa.ownerReviewingPhotoText": "Budete informovaní, hneď ako odpovedia. Potom budete môcť porovnať ich deklaráciu.",
"fa.ownerRejectedPhoto": "Toto nie je položka majiteľa",
"fa.ownerRejectedPhotoText": "Majiteľ hovorí, že vaša fotografia nezodpovedá ich položke. Požiadavka je uzavretá. Ďakujeme za vašu pomoc!",
"fa.contribute": "Prispieť",
"fa.phoneMissing": "Nebol poskytnutý",
"fa.ownerSafety1": "Uprednostnite odovzdanie na verejnom mieste alebo u partnera Findloop. Ak je vzdialenosť veľká, navrhnite poslať to poštou.",
"fa.ownerSafety2": "Pri odovzdávaní skontrolujte identifikáciu nálezcu.",
"pub.changePhoto": "Zmeniť foto",
"ph.secured": "Fotka zabezpečená",
"ph.securing": "Zabezpečujem fotku…",
"fa.ownerSafety3": "Ak fotka nálezcu obsahuje vodotlač Findloop, neakceptujte stretnutie. Fotka musí byť pôvodný obrázok, ktorý nafotil nálezca, bez vodotlače."
},
"bg": {
"a.back": "Назад",
"a.category": "Категория",
"a.categoryPlaceholder": "Изберете категория",
"a.city": "Град",
"a.confirmPassword": "Потвърдете паролата",
"a.country": "Държава",
"a.createAccount": "Създайте акаунт",
"a.createBtn": "Създайте моя акаунт",
"a.creating": "Създаване…",
"a.email": "Имейл",
"a.emailPro": "Бизнес имейл",
"a.forgot": "Забравихте?",
"a.forgotSent": "Ако акаунтът съществува, линк за нулиране току-що беше изпратен.",
"a.forgotSub": "Получете линк за нулиране по имейл.",
"a.forgotTitle": "Забравена парола",
"a.googleContinue": "Продължи с Google",
"a.googleSignup": "Регистрация с Google",
"a.haveAccount": "Вече сте партньор?",
"a.legalHint": "Изисква се за френско електронно фактуриране (Factur-X) на френски учреждения.",
"a.legalRequiredFR": "SIRET и вътрешен ДДС номер в ЕС са задължителни за Франция.",
"a.loggingIn": "Влизане…",
"a.login": "Вход",
"a.loginSub": "Достъп до вашето управленско пространство.",
"a.loginTitle": "Вход за партньори",
"a.min6": "Минимум 6 знака",
"a.newPassword": "Нова парола",
"a.noAccount": "Още не сте партньор?",
"a.or": "ИЛИ",
"a.org": "Име на учреждение",
"a.password": "Парола",
"a.passwordMismatch": "Паролите не съвпадат.",
"a.referral": "Код за насочване (по желание)",
"a.registerSub": "Създайте своето пространство за 1 минута — безплатно за начало.",
"a.registerTitle": "Стани партньор",
"a.rememberMe": "Запомни ме",
"a.reset": "Нулиране",
"a.resetSub": "Изберете нова парола за вашия акаунт.",
"a.resetTitle": "Нова парола",
"a.sendLink": "Изпрати линка",
"a.sending": "Изпращане…",
"a.signin": "Вход",
"a.siret": "SIRET",
"a.vat": "Вътрешен ДДС номер в ЕС",
"ac.africa": "Африка",
"ac.boostActive": "Активен акцент —",
"ac.boostSub": "Появявайте се на върха на директорията за партньори с „Усилен“ значка.",
"ac.boostTitle": "Усиляйте вашето обявление в директорията",
"ac.categoryHint": "Да класифицирате вашето учреждение в директорията на findloop.",
"ac.choose": "Изберете",
"ac.cityHint": "За прецизно позициониране на публичната карта.",
"ac.cityLabel": "Град на учреждението",
"ac.cityPh": "Париж",
"ac.contact": "Контактни данни",
"ac.converted": "Конвертирано",
"ac.copyDeclLink": "Копирайте линка за декларация",
"ac.copyLink": "Копирайте линка",
"ac.currentPlan": "Настоящ план",
"ac.emailDesc": "Изберете имейлите, които искате да получите. Уведомленията в вашето работно пространство винаги са активни.",
"ac.emailMatch": "Съвпадения",
"ac.emailMatchDesc": "Имейл, когато елемент съвпадне с декларация",
"ac.emailNewDecl": "Нови декларации за загуба",
"ac.emailNewDeclDesc": "Имейл веднага щом клиент съобщи за загуба при вас",
"ac.emailShip": "Запитвания за доставка",
"ac.emailShipDesc": "Имейл, когато клиент поиска доставка на продукт",
"ac.emailTitle": "Настройки на имейл",
"ac.expireSoon": "Вашият акцент изтича скоро —",
"ac.exportCsv": "Експорт (CSV)",
"ac.exportHint": "Експортирайте своите валидирани външни плащания за вашето счетоводство.",
"ac.free": "Безплатно",
"ac.freeMonths": "Безплатни месеци",
"ac.hours": "часа",
"ac.howItWorks": "Как работи?",
"ac.invited": "Поканен",
"ac.legalFR": "Изисква се за електронно фактуриране (Factur-X), приложимо от септември 2026 г.",
"ac.legalMissing": "⚠️ Липсва SIRET и ДДС от ЕС — попълнете ги, за да останете в съответствие с електронното фактуриране.",
"ac.legalOther": "Препоръчително за вашите фактури.",
"ac.legalPartnerQr": "QR код",
"ac.legalTitle": "Правни идентификатори (фактуриране)",
"ac.logoTitle": "Лого на establecimiento",
"ac.modeCurrent": "Текущ режим:",
"ac.modeExternal": "Външен (ръчна валидизация)",
"ac.modeInternal": "Вътрешен Findloop (автоматичен)",
"ac.noSubReceipt": "Все още няма платено плащане за абонамент.",
"ac.none": "Няма",
"ac.onYourListing": "във вашия списък",
"ac.pay1": "Въведете вашите връзки за плащане по-долу, за да пренасочите клиентите си към вашата собствена система за събиране.",
"ac.pay2": "Валидизацията става ръчна: вие потвърждавате получаването на плащането от таба „Декларации“.",
"ac.pay3": "Връзката „Такса за доставка“ е консолидирано плащане (възстановяване + доставка).",
"ac.pay4": "Оставете полетата празни, за да използвате вътрешното плащане на Findloop (Stripe) с автоматична валидизация.",
"ac.paySub": "Събирайте такси чрез вашата собствена система за плащане.",
"ac.payTitle": "Външни плащания",
"ac.permissive": "Либерален",
"ac.phone": "Телефон",
"ac.posterA4": "А4 плакат (PDF)",
"ac.qMessage": "Съобщение (по желание)",
"ac.qName": "Име",
"ac.qOrg": "Организация",
"ac.qSites": "Брой заведения (оценка)",
"ac.qrHint": "Вашите клиенти сканират този код, за да съобщят за загубен предмет.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Вашият партньорски QR код",
"ac.quoteDesc": "Летища, железопътни мрежи, международни вериги · ",
"ac.quoteEurope": "Европа / Свят",
"ac.quoteSent": "Запитването за оферта е изпратено. Нашият екип ще се свърже с вас скоро.",
"ac.quoteTitle": "Заявка за оферта — Предприятие",
"ac.recoveryLink": "Връзка „Такса за възстановяване“",
"ac.refSub": "Всеки препоръчан партньор, който се абонира, ви дава 1 безплатен месец.",
"ac.refTitle": "Препоръчайте, спечелете безплатен месец",
"ac.reminderDelay": "Закъснение на напомняне за валидизация",
"ac.reminderHint": "Ще получите имейл напомняне, ако външно плащане остане невалидирано след това закъснение (по подразбиране: 48ч).",
"ac.renewDesc1": "Той вече ви е донесъл",
"ac.renewDesc2": "Подновете, за да останете в горната част на директорията и да не загубите тази видимост.",
"ac.renewNow": "Подновете сега",
"ac.requestQuote": "Заявка за оферта",
"ac.saveLegal": "Запазете идентификаторите",
"ac.saveLinks": "Запазете връзките",
"ac.sendRequest": "Изпратете моята заявка",
"ac.sending": "Изпращане…",
"ac.shippingLink": "Връзка „Такса за доставка“ (консолидирана)",
"ac.shippingLinkHint": "Тази връзка покрива както възстановяването, така и доставката.",
"ac.strict": "Стриктно",
"ac.subReceipt": "Квитанция за абонамент (PDF)",
"ac.subReceiptsSub": "Изтеглете PDF квитанцията за всяко плащане на абонамент.",
"ac.subReceiptsTitle": "Квитанции за абонамент",
"ac.tCategory": "Категорията е запазена",
"ac.tCity": "Градът е запазен — картата е актуализирана",
"ac.tCityNeeded": "Въведете град",
"ac.tCopied": "Копирано!",
"ac.tCover": "Снимката на корицата е актуализирана",
"ac.tEmailPrefs": "Настройки за имейл са актуализирани",
"ac.tErr": "Грешка",
"ac.tExportImpossible": "Експортирането неуспешно",
"ac.tLegal": "Правни идентификатори запазени",
"ac.tLegalNeeded": "SIRET и ДДС се изискват за Франция",
"ac.tLogo": "Логото е актуализирано",
"ac.tLogoRemoved": "Логото е премахнато",
"ac.tPayLinks": "Линковете за плащане са запазени",
"ac.tPhone": "Телефонът е запазен",
"ac.tSensitivity": "Чувствителността е запазена",
"ac.tVatInvalid": "Невалидно ДДС номер",
"ac.tVatValid": "Валидно ДДС",
"ac.tabBoost": "Видимост",
"ac.tabPayments": "Плащания",
"ac.tabProfile": "Профил",
"ac.tabQr": "QR & Плакат",
"ac.tabReferral": "Препоръка",
"ac.tabSub": "Абонамент",
"ac.thisWeek": "Тази седмица",
"ac.thisWeekOf": " ({n} тази седмица)",
"ac.thresholdDesc": "Праговата стойност на доверие, от която ИИ автоматично потвърдява съвпадение на снимка и уведомява клиента. По-висока = по-малко автоматични съвпадения, но по-надеждно.",
"ac.thresholdTitle": "Чувствителност на визуално съвпадение на ИИ",
"ac.trend": "Тенденция",
"ac.upload": "Качи",
"ac.vatValidFmt": "Валидно ДДС{name} ({via})",
"ac.vatVerified": "Проверено ДДС в рамките на ЕС",
"ac.verifyVat": "Проверете ДДС (VIES)",
"ac.verifying": "Проверява се…",
"ac.views": "прегледи",
"ac.viewsTotal": "Общо спечелени прегледи",
"ac.winbackBtn": "Върнете се с -20%",
"ac.winbackDesc1": "Спечелихте",
"ac.winbackDesc2": "Специална оферта: -20% приложени автоматично, ако подновите в рамките на 24ч.",
"ac.winbackTitle": "Вашият акцент току-що изтече — възобновете с -20%!",
"ad.boost": "Увеличи",
"ad.close": "Затвори",
"ad.closeConfirm": "Да затворя ли тази обява?",
"ad.closed": "Обявата е затворена",
"ad.edit": "Редактирай",
"ad.editTitle": "Редактиране на обявата",
"ad.saved": "Обявата е актуализирана",
"an.allCountries": "Всички страни",
"an.badge": "Загубени предмети",
"an.boostLater": "По-късно",
"an.boostNow": "Увеличи сега",
"an.boostPrompt": "Увеличете обявата си, за да я поставите на върха и да бъдете намерени по-бързо.",
"an.boosted": "Увеличена",
"an.contact": "Намерих този предмет",
"an.contactTitle": "Докладвайте, че сте намерили този предмет",
"an.copyFailed": "Не можа да копира линка",
"an.copyLink": "Копирайте линка",
"an.country": "Държава",
"an.date": "Дата на изгубване",
"an.finderEmail": "Вашият имейл",
"an.finderName": "Вашето име",
"an.finderPhone": "Вашият телефон",
"an.geoBanner": "Преглеждате обяви в",
"an.geoBannerWorld": "Преглеждате обяви по целия свят",
"an.geoChange": "промяна на страната",
"an.goAccount": "Отидете в профила си",
"an.linkCopied": "Линкът е копиран!",
"an.loginRequired": "Влезте, за да докладвате този артикул и да проследите връщането.",
"an.loginToBoost": "Влезте, за да усилите тази обява",
"an.lostAt": "Изгубен на",
"an.message": "Съобщение (по желание)",
"an.none": "Още няма обяви.",
"an.photo": "Снимка (по желание)",
"an.post": "Публикувайте обява",
"an.postSubtitle": "Опишете изгубения си артикул — общността и нашите партньори ще ви помогнат да го намерите.",
"an.postTitle": "Докладвайте изгубен артикул",
"an.publish": "Публикувайте обявата",
"an.published": "Обявата е публикувана!",
"an.publishing": "Публикува се…",
"an.remaining": "останал",
"an.requestInProgress": "Заявка в процес",
"an.resolved": "Артикулът вече е възстановен",
"an.reward": "Награда",
"an.searchPh": "Търсене на обява…",
"an.send": "Изпрати",
"an.sent": "Съобщението е изпратено до собственика!",
"an.shareConsent": "Съгласен съм мойте контактни данни (име, имейл, телефон) да бъдат споделени със собственика на артикула.",
"an.shareConsentError": "Моля, отметнете полето, за да споделите контактните си данни.",
"an.sortRecent": "Най-скоро",
"an.sortRelevance": "Релевантност",
"an.subtitle": "Прегледайте артикули, докладвани като изгубени от общността. Намерихте ли един от тях?",
"an.title": "Обяви за изгубени артикули",
"anf.badge": "Намерани артикули",
"anf.claim": "Това е моето",
"anf.claimSent": "Съобщението е изпратено до намиращия!",
"anf.claimTitle": "Докладвайте, че това е вашият артикул",
"anf.consent": "Съгласен съм, че собственикът може да види моите контактни данни, за да възстанови артикула си.",
"anf.foundAt": "Намерено на",
"anf.foundDate": "Дата на намиране",
"anf.loginCta": "Влезте / създайте акаунт",
"anf.loginDesc": "Акаунт на намиращ е необходим, за да публикувате обява и да спечелите точки Finder Hero.",
"anf.loginRequired": "Влезте, за да публикувате намерен артикул",
"anf.photo": "Снимка на артикула",
"anf.pointsEarned": "Благодарим ви! Точно спечелихте точки Finder Hero.",
"anf.pointsPending": "Вашите точки ще бъдат начислени в рамките на 24 часа, след проверка.",
"anf.post": "Публикувайте намерен артикул",
"anf.postSubtitle": "Опишете артикула, който намерихте — помогнете на собственика да го получи обратно.",
"anf.postTitle": "Докладвайте намерен артикул",
"anf.publishFound": "Публикувайте обява за намерен артикул",
"anf.published": "Обявата за намерен артикул е публикувана",
"anf.publishedAs": "Публикувано като",
"anf.shareConsent": "Съгласен съм мойте контактни данни (име, имейл, телефон) да бъдат споделени с човека, който е намерил артикула.",
"anf.subtitle": "Прегледайте артикули, намерени и докладвани от общността. Разпознавате ли вашия?",
"anf.title": "Обяви за намерени артикули",
"bo.active": "Усилването е активно",
"bo.africaPrice": "Приложена е предпочитателна цена за зона Африка",
"bo.pay": "Платете и усилете",
"bo.remaining": "Оставащо време",
"bo.renew": "Поднови увеличението",
"bo.since": "от увеличението",
"bo.subtitle": "Поставете вашето обявление в горната част на списъка с видим значка.",
"bo.title": "Увеличаване на обявата",
"c.all": "Всички",
"c.cancel": "Отмени",
"c.close": "Затвори",
"c.confirm": "Потвърди",
"c.confirmed": "Потвърдено",
"c.download": "Изтегляне",
"c.loading": "Зареждане…",
"c.reset": "Нулиране",
"c.reviews": "ревюта",
"c.save": "Запази",
"c.transfer": "Прехвърли",
"cat.Animal": "Домашен любимец / Аксесоари за домашни любимци",
"cat.AppareilPhoto": "Камера",
"cat.Argent": "Пари / Брой",
"cat.Autres": "Други",
"cat.Bijoux": "Бижута",
"cat.CarteBancaire": "Банкова карта",
"cat.CarteIdentite": "Лична карта / Паспорт",
"cat.Casquette": "Шапка / Кеп",
"cat.Ceinture": "Колан",
"cat.Chargeur": "Зарядно / Кабел",
"cat.Chaussures": "Обувки",
"cat.CleVoiture": "Ключ за кола",
"cat.Cles": "Ключове",
"cat.Console": "Игрова конзола",
"cat.Documents": "Документи / Хартия",
"cat.Echarpe": "Шал",
"cat.Ecouteurs": "Слушалки",
"cat.Electronique": "Електроника (друго)",
"cat.Enceinte": "Звукосистема",
"cat.Gants": "Ръкавици",
"cat.Gourde": "Бутилка за вода / Термо",
"cat.Instrument": "Музикален инструмент",
"cat.Jouet": "Играчка / Плюшено",
"cat.Jumelles": "Бинокъл",
"cat.Lampe": "Лампа / Фенер",
"cat.Liseuse": "Четец",
"cat.Livre": "Книга / Тетрадка",
"cat.Lunettes": "Очила",
"cat.Manteau": "Яке / Палто",
"cat.Maquillage": "Чанта за грим",
"cat.Medical": "Медицинско оборудване",
"cat.Medicaments": "Медикаменти",
"cat.Montre": "Часовник / Смарт часовник",
"cat.Ordinateur": "Лаптоп",
"cat.Parapluie": "Чадър",
"cat.Portefeuille": "Портфейл / Чанта",
"cat.Poussette": "Бебешка количка / Аксесоари за бебе",
"cat.Sac": "Чанта / Класическа чанта",
"cat.SacADos": "Раница",
"cat.Souris": "Мишка / Клавиатура",
"cat.Sport": "Спортно оборудване",
"cat.Tablette": "Таблет",
"cat.Telephone": "Телефон / Смартфон",
"cat.Trottinette": "Тротинетка",
"cat.Trousse": "Чанта / Кейс",
"cat.USB": "USB флашка / Внешен диск",
"cat.Valise": "Чанта / Багаж",
"cat.Velo": "Велосипед",
"cat.Vetements": "Дрехи",
"cat.placeholder": "Изберете категория",
"cd.d": "д",
"cd.expired": "Изтекъл",
"cd.h": "ч",
"cd.m": "мин",
"ck.accept": "Приемам",
"ck.acceptAll": "Приемам всичко",
"ck.customize": "Персонализирайте",
"ck.learn": "Научете повече",
"ck.manage": "Управление на бисквитките",
"ck.measurement": "Измерване на аудиторията",
"ck.measurementDesc": "Анонимни статистики за подобряване на услугата.",
"ck.msg": "Използваме бисквитки, за да поддържаме сайта и да измерваме аудиторията.",
"ck.necessary": "Необходими",
"ck.necessaryDesc": "Съществени за функционирането на сайта. Винаги активни.",
"ck.refuse": "Отказвам",
"ck.save": "Запазете моите избори",
"ck.saved": "Настройките запазени",
"ck.title": "Вашите предпочитания за бисквитки",
"cm.found": "НАМЕРЕНО",
"cm.lost": "ЗАГУБЕНО",
"cmp.adv": "Разширени",
"cmp.ai": "AI съвпадение",
"cmp.autobill": "Автоматично фактуриране",
"cmp.basic": "Основен",
"cmp.community": "Общество",
"cmp.consol": "Консолидирано фактуриране",
"cmp.custom": "Персонализиран",
"cmp.dedicated": "Посветен",
"cmp.deploy": "Посветено внедряване и SLA",
"cmp.estIncl": "Включени заведения",
"cmp.estSec": "Допълнително заведение",
"cmp.items": "Артикули / месец",
"cmp.main": "1 основен",
"cmp.max20": "20 макс",
"cmp.members": "Покани за членство",
"cmp.onQuote": "Персонализирана оферта",
"cmp.priority": "Приоритет",
"cmp.starterEst": "1 включено + неограничен допълнителен",
"cmp.stats": "Статистика",
"cmp.statsAdv": "Разширена",
"cmp.statsBasic": "Основна",
"cmp.support": "Подкрепа",
"cmp.unlimited": "Неограничен",
"cmp.upTo3": "До 3",
"consent.required": "Трябва да се съгласите да споделите вашите контактни данни, за да продължите.",
"consent.share": "Съгласен съм, че намерилият моя артикул може да види моите контактни данни (име, имейл, телефон), за да се свърже с мен за връщането му.",
"cover.add": "Добави",
"cover.change": "Смяна",
"cover.helper": "Показан като банер на страница с отчета и в директорията.",
"cover.none": "Без снимка на корицата",
"cover.remove": "Премахни",
"cover.title": "Снимка на корицата",
"crop.desc": "Коригирайте рамката до съотношението на банера (3:1). Плъзнете и увеличете.",
"crop.saving": "Запазване…",
"crop.title": "Орежете снимката за корица",
"cta.button": "Създайте моя партньорски акаунт",
"cta.subtitle": "Присъединете се към заведенията, които връщат предмети по-бързо с findloop.",
"cta.title": "Готови ли сте да намалите изгубените предмети?",
"db.account.s": "Управлявайте вашето заведение, абонамент и QR код.",
"db.account.t": "Моят акаунт",
"db.declarations.s": "Клиенти, които са съобщили за изгубен предмет чрез вашия QR код.",
"db.declarations.t": "Доклади за загуба",
"db.deposit.s": "Добавете снимка, категория и описание.",
"db.deposit.t": "Записване на намерен предмет",
"db.registry.s": "Всички намерени предмети, регистрирани във вашето заведение.",
"db.registry.t": "Регистър на предмети",
"db.reviews.s": "Отговаряйте публично на рецензиите на вашите клиенти.",
"db.reviews.t": "Рецензии от клиенти",
"db.shipments.s": "Генерирайте етикети и проследявайте пратки за изпращане.",
"db.shipments.t": "Пратки",
"db.stats.s": "Вашите ключови показатели за представяне.",
"db.stats.t": "Статистика",
"db.team.s": "Поканете колегите си да управляват предмети.",
"db.team.t": "Екип",
"dc.partnerDesc": "Изгубили ли сте предмет в заведение партньор (хотел, гара, зала…)? Изберете го за директно връщане.",
"dc.partnerList": "Изберете от списъка",
"dc.partnerMap": "Изберете на картата",
"dc.partnerTitle": "Декларация в заведение партньор",
"dc.publicCta": "Публикувайте публична обява",
"dc.publicDesc": "Вашата обява ще бъде видима за цялата общност на findloop. Идеално, ако не знаете къде сте изгубили предмета.",
"dc.publicTitle": "Публична декларация",
"dc.subtitle": "Изберете как да докладвате за изгубения си предмет.",
"dc.title": "Какво искате да направите?",
"dec.addrPending": "Адрес в очакване от клиента",
"dec.analyzing": "Анализиране…",
"dec.badge": "Доклад за загуба",
"dec.category": "Категория предмет",
"dec.clientDescription": "Описание от клиента",
"dec.clientPhoto": "Снимка предоставена от клиента",
"dec.clientPhotoShort": "Снимка на клиента",
"dec.comparePhotos": "Сравнете снимките",
"dec.contactTitle": "Вашите контактни данни",
"dec.date": "Дата на загуба",
"dec.declaredItemPhoto": "Снимка на декларирания предмет",
"dec.descPh": "Опишете предмета: марка, цвят, отличителни знаци…",
"dec.description": "Описание",
"dec.email": "Имейл",
"dec.emptyDesc": "Споделете вашия QR код, за да получавате декларации.",
"dec.emptyTitle": "Няма декларации",
"dec.enlarge": "Увеличи",
"dec.extBanner": "{n} външни плащания за потвърждение — потвърдете получаването по-долу, за да отключите предаването или изпращането.",
"dec.foundItemAlt": "Намерен предмет",
"dec.foundItemRegistry": "Намерен предмет (регистър)",
"dec.home": "Назад на началната страница",
"dec.labelClient": "Клиент",
"dec.labelRegistry": "Регистър",
"dec.matchFound": "Съвпадение вече е установено!",
"dec.name": "Пълно име",
"dec.noMatchYet": "Няма съвпадение още.",
"dec.noPhoto": "Няма снимка",
"dec.notfound": "Партньорът не е намерен.",
"dec.pRecup": "възстановяване",
"dec.pRecupP": "(възстановяване)",
"dec.pRecupShip": "(възстановяване + изпращане)",
"dec.payConfirmed": "Плащането {x} потвърдено",
"dec.payPending": "Външно плащане {x} в очакване",
"dec.phone": "Телефон",
"dec.pickup": "Лично получаване",
"dec.place": "Място на изгубване",
"dec.placePh": "напр. на бара, стая 204…",
"dec.recoverBtn": "Възстанови моя артикул",
"dec.reject": "Отхвърли",
"dec.rerun": "Повтори анализа",
"dec.similarity": "Сходство {n}%",
"dec.submit": "Изпрати моя отчет",
"dec.submitting": "Изпращане…",
"dec.successText": "Търсим вашия артикул сред тези, които се намират в",
"dec.successTitle": "Отчетът е изпратен!",
"dec.suggestedMatches": "Предложени съвпадения",
"dec.toColon": " до:",
"dec.toShip": "За изпращане",
"dec.toastExtPay": "Плащането е потвърдено — клиентът ще бъде уведомен.",
"dec.toastMatch": "Съвпадение потвърдено",
"dec.toastReject": "Предложението отхвърлено",
"dec.toastRerun": "Анализът е рестартиран",
"dec.toastVisualN": "{n} визуално съвпадение(я)",
"dec.toastVisualNone": "Няма визуално съвпадение",
"dec.trackBtn": "Проследи моя отчет",
"dec.viewBeforeAfter": "Поглед преди/след (наложен слой)",
"dec.viewSideBySide": "Поглед един до друг",
"dec.visualCompare": "AI визуално сравнение",
"dec.visualIdle": "Изпълнете сравнението, за да може AI визуално да съпостави направената от клиента снимка с намерени артикули.",
"dec.visualRunning": "AI сравнява снимката на клиента с артикулите във вашия регистър…",
"dec.zoomPhoto": "Увеличете снимката",
"dep.addAnyway": "Добави все пак",
"dep.addError": "Грешка при добавянето",
"dep.addItem": "Добави артикул",
"dep.added": "Артикулът е добавен в регистъра!",
"dep.adding": "Добавяне…",
"dep.aiError": "AI анализът не е наличен в момента.",
"dep.aiFilled": "Формулярът е попълнен от AI ✨",
"dep.aiUnavailable": "AI недостъпен — попълнете формуляра ръчно.",
"dep.analyzing": "Анализиране…",
"dep.analyzingPhoto": "Анализиране на снимка…",
"dep.brand": "Марка",
"dep.brandPlaceholder": "напр. Apple",
"dep.category": "Категория",
"dep.checkingDup": "Проверка за дубликати…",
"dep.color": "Цвят",
"dep.colorPlaceholder": "напр. черен",
"dep.condition": "Състояние",
"dep.conditionPlaceholder": "напр. добро състояние",
"dep.depositorNote": "Бележка на внасящия",
"dep.depositorNoteHint": "Оперативни детайли, написани на ръка. AI никога не презаписва тази бележка.",
"dep.depositorNotePlaceholder": "напр. съдържание на чанта, марка, както е съобщена, детайли от лицето…",
"dep.descPlaceholder": "напр. черен iPhone 15 с прозрачен калъф, намерен на бара…",
"dep.description": "Описание",
"dep.dupHint": "Убедете се, че не добавяте дубликат. Можете да продължите, ако артикулът е наистина различен.",
"dep.dupTitle": "Подобен артикул(и) вече регистрирани",
"dep.dupWarn": "Обнаружен е подобен артикул — прегледайте, след това щракнете отново, за да потвърдите.",
"dep.estHint": "Артикулът ще бъде добавен в регистъра на това заведение.",
"dep.establishment": "Заведение",
"dep.fee": "Такса за възстановяване (€) — по избор",
"dep.feePlaceholder": "Оставете празно за цената по подразбиране на категорията",
"dep.fillAI": "Попълване с AI",
"dep.optional": "(по избор)",
"dep.photo": "Снимка на артикула",
"dep.principal": "основен",
"dep.reqError": "Категорията и описанието са задължителни.",
"dep.savedItem": "Регистриран артикул",
"dep.similarity": "Сходство",
"dep.storage": "Физическо местоположение",
"dep.storageHint": "Къде е физическият артикул. QR код ще бъде генериран, за да го намерите.",
"dep.storagePlaceholder": "напр. Рафтове A3, Склад 12, Сейф на рецепцията",
"dl.aClient": "клиент",
"dl.alertsBlocked": "Браузърските известия са блокирани",
"dl.alertsBlockedHint": "За да ги активирате отново: щракнете върху иконата 🔒 (или ⓘ) отляво на адреса на сайта, след което разрешете известията и презаредете страницата.",
"dl.amountDue": "Дължима сума: {amount} {currency}.",
"dl.enableAlerts": "Активирайте известията",
"dl.extPending": "Плащания за валидиране",
"dl.freemiumNear": "Наближавате лимита на Freemium ({used}/{max} артикула този месец). Преминете на Starter за неограничени артикули.",
"dl.freemiumReached": "Достигнат лимит на Freemium ({used}/{max} артикула този месец). Преминете на Starter, за да регистрирате неограничени артикули.",
"dl.invoiceOverdue": "Фактура {num} неплатена — достъпът е ограничен.",
"dl.matchNotifTitle": "Findloop — Ново AI съвпадение 🔔",
"dl.matchToast": "Ново AI съвпадение — {name}",
"dl.matchToastDesc": "Артикул съответства на декларация.",
"dl.notifEmpty": "Все още няма известия.",
"dl.notifEnabled": "Браузърските известия са активирани",
"dl.notifTitle": "Известия",
"dl.payInvoice": "Платете фактурата ми →",
"dl.rewardsPending": "Ваучери за представяне",
"dl.upgradeStarter": "Преминете на Starter →",
"est.all": "Всички заведения ({n})",
"est.label": "Заведение",
"est.primary": "основен",
"est.secondary": "вторичен",
"est2.add": "Добавете заведение",
"est2.addressLabel": "Адрес",
"est2.addressPh": "ул. Република 12",
"est2.autoInvoice": "Подробна фактура се генерира автоматично на 1-во число на всеки месец.",
"est2.baseSub": "Основен абонамент",
"est2.billing": "Фактуриране",
"est2.boostActivated": "Увеличение активирано за {name}",
"est2.boostBillingNote": "Фактурирано по текущата тарифа и групирано на вашата обединена месечна фактура.",
"est2.boostCta": "Увеличете",
"est2.boostDesc": "Подобрете видимостта на това заведение в директорията и на картата.",
"est2.boostDuration": "{h}ч увеличена видимост",
"est2.boostExtend": "Удължи",
"est2.boostTitle": "Увеличете {name}",
"est2.boosted": "Увеличено",
"est2.chartDesc": "Дял на върнатите артикули от общо регистрираните, сайт по сайт.",
"est2.chartTitle": "Процент на връщане по заведение",
"est2.chartTooltip": "Връщане",
"est2.cityLabel": "Град",
"est2.cityPh": "Лион",
"est2.contactHint": "Тези данни се показват на клиента за това заведение (пада назад към акаунта, ако е празно).",
"est2.countryLabel": "Държава",
"est2.coverLabel": "Снимка на корицата",
"est2.create": "Създайте",
"est2.created": "Заведение създадено",
"est2.delete": "Изтрий",
"est2.deleteDesc": "Тази акция е постоянна. Можете да изтриете заведение само ако не съдържа артикули.",
"est2.deleteTitle": "Изтриване на “{name}”?",
"est2.deleted": "Заведение изтрито",
"est2.dialogDesc": "Въведете името и адреса на този сайт.",
"est2.edit": "Редактиране",
"est2.editEst": "Редактиране на заведение",
"est2.emailLabel": "Имейл за контакт",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " заведение(я)",
"est2.extraNoteBase": "{n} допълнително заведение(я) таксувани",
"est2.extraPrice": " на цена {price} €/месец.",
"est2.extraQuote": " по запитване.",
"est2.imgChange": "Изберете изображение",
"est2.imgDone": "Готово",
"est2.imgRemove": "Премахни",
"est2.imgRemoved": "Изображението е премахнато",
"est2.imgSaved": "Изображението е запазено",
"est2.imgUploading": "Качване…",
"est2.includedPlan": "Включено в плана ви: {n}.",
"est2.kDeclarations": "Декларации",
"est2.kInStorage": "На склад",
"est2.kItemsTotal": "Артикули (общо)",
"est2.kRestituted": "Върнати",
"est2.limitReached": "Достигнат лимит",
"est2.logoLabel": "Лого",
"est2.mDeclar": "Декл.",
"est2.mItems": "Артикули",
"est2.mRestituted": "Върнати",
"est2.mStorage": "На склад",
"est2.monthlyTotal": "Месечен общ",
"est2.nameLabel": "Име *",
"est2.namePh": "напр. Belmont Hotel — Lyon Annex",
"est2.newEst": "Ново заведение",
"est2.onQuote": "По запитване",
"est2.phoneLabel": "Телефон",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "План",
"est2.planLimited": "Вашият план „{tier}“ е ограничен до {max} заведение(я).",
"est2.primary": "Основно",
"est2.qr": "QR код",
"est2.qrDesc": "Покажете този QR код в това заведение. Клиентите, които докладват за загуба, ще бъдат свързани с този сайт.",
"est2.qrTitle": "QR код — {name}",
"est2.saving": "Запазване…",
"est2.seeInvoices": "Виж моите месечни фактури",
"est2.seePlans": "Виж плановете",
"est2.subtitle": "Управлявайте всичките си сайтове под един акаунт — консолидирана гледка, артикули, QR код и фактуриране.",
"est2.suspended": "Спряно",
"est2.tierFree": "1 заведение",
"est2.tierLarge": "неограничени заведения",
"est2.tierMedium": "5 заведения включени",
"est2.tierSmall": "3 заведения включени",
"est2.title": "Заведения",
"est2.unlimitedPlan": "Вашият план позволява неограничен брой заведения.",
"est2.unlimitedSuffix": " · неограничено",
"est2.updated": "Заведение обновено",
"est2.upgradeHint": "Актуализирайте до по-висок план, за да добавите повече сайтове и централизирате всичката си активност.",
"est2.visuals": "Лого и снимка",
"est2.visualsDesc": "Персонализирайте логото и корицата на това заведение. Те се показват на публичната му страница и формата за декларация.",
"est2.visualsTitle": "Визуализации — {name}",
"est2.workOn": "Работете по това заведение",
"est2.working": "Работите по „{name}“",
"ev.created": "Докладът е създаден",
"ev.matched": "Идентифициран съвпадащ артикул",
"ev.paid": "Такса за възстановяване платена",
"ev.pickup": "Лично взимане",
"ev.shipped": "Пратката изпратена",
"ev.shipping_paid": "Такса за доставка платена",
"ev.shipping_requested": "Заявена доставка",
"feat1.d": "KPI, процент на върнати стоки по категории, приходи и тенденции за 30 дни.",
"feat1.t": "Табло и анализи",
"feat2.d": "Етикети, проследяване на куриери и автоматични имейли за проследяване.",
"feat2.t": "Модул за доставка",
"feat3.d": "Клиентите ви намират по град и категория, с сертифицирани отзиви.",
"feat3.t": "Обществена директория и отзиви",
"fp.backToRanking": "Обратно към класацията",
"fp.badge": "Знак",
"fp.hero": "Герой на Finder",
"fp.notFound": "Профилът не е намерен или е частен.",
"fp.scoreTotal": "Общо точки",
"fp.scoreYear": "Точки за",
"fp.share": "Споделете този профил",
"fp.shareText": "Разгледайте профила на находчика {name} във Findloop!",
"fp.tagline": "Честен находчик, който прави света по-добро място.",
"ft.backAccount": "Обратно към Моя профил",
"ft.closeBtn": "Затворете случая",
"ft.closeConfirm": "Потвърдете ли, че продуктът е върнат? Обявата ще бъде затворена.",
"ft.closeLockedHint": "Първо валидирайте кода на собственика, за да отключите затварянето.",
"ft.closed": "Случаят е затворен — продуктът е върнат!",
"ft.codeLabel": "Въведете кода за валидация, получен от собственика",
"ft.codeNeeded": "Моля, въведете кода за валидация.",
"ft.codeOk": "Кодът е валидиран — можете да затворите случая.",
"ft.codePlaceholder": "напр. 4821",
"ft.codeVerified": "Валидиран",
"ft.doneMsg": "Продуктът е върнат. Благодарим ви, че помогнахте да бъде върнат на собственика си!",
"ft.stepInProgress": "Възстановяване в процес",
"ft.stepPublished": "Обявата е публикувана",
"ft.stepReturned": "Продуктът е върнат",
"ft.subtitle": "Следвайте стъпките, докато намереният продукт не бъде върнат.",
"ft.title": "Проследяване на връщането",
"ft.verifyBtn": "Валидирайте кода",
"hero.badge": "Представен",
"hero.ctaFound": "Намерих продукт",
"hero.ctaLost": "Загубих продукт",
"hero.ctaPartner": "Станете партньор",
"hero.subtitle": "Findloop помага на заведенията да управляват намерените продукти — и позволява на техните клиенти да докладват за загуба и след това да възстановят своите вещи, на място или чрез доставка.",
"hero.title": "Всеки загубен предмет намира своя собственик.",
"home.champBecome": "Станете находчик",
"home.champCta": "Вижте класацията",
"home.champSubtitle": "Всеки върнат продукт получава точки. Присъединете се към класацията и спечелете награди.",
"home.champTitle": "Нашите топ находчици",
"how.eyebrow": "Как работи",
"how.title": "От предаване до връщане, без усилие.",
"inv.all": "Всички",
"inv.allYears": "Всички години",
"inv.count": "Фактури",
"inv.due": "с дължими",
"inv.empty": "Няма фактури засега.",
"inv.exportCsv": "Експортиране в CSV",
"inv.invoicePdf": "Фактура PDF",
"inv.issued": "Издадена",
"inv.noMatch": "Няма фактура за този филтър.",
"inv.paid": "Платена (€)",
"inv.paidOn": "платено на",
"inv.pay": "Плати",
"inv.receipt": "Фактура",
"inv.reminders": "Напомняния",
"inv.remindersDesc": "Изпратени електронни и SMS напомняния за тази фактура.",
"inv.remindersEmpty": "Не е изпратено напомняне.",
"inv.rmDue": "Напомняне за краен срок",
"inv.rmManual": "Ръчно напомняне",
"inv.rmSms": "SMS напомняне D+30",
"inv.rmStage": "Напомняне",
"inv.statusPaid": "Платено",
"inv.statusUnpaid": "Неплатено",
"inv.subtitle": "Прегледайте и изтеглете вашите фактури и разписки.",
"inv.title": "Моите фактури",
"inv.unpaid": "Неплатено (€)",
"inv2.contractTitle": "Моят Findloop договор",
"inv2.detailByEst": "Подробности по заведение",
"inv2.dueLabel": "Срок:",
"inv2.dueSuffix": " · до {date}",
"inv2.error": "Грешка {status}",
"inv2.estCountIssued": "{n} заведение(я) · издадено на {date}",
"inv2.estimate": "Оценка (не таксувана) · {n} заведение(я)",
"inv2.expired": " · изтекъл",
"inv2.exportCsv": "Експортиране на CSV",
"inv2.exportDone": "CSV експортирането изтеглено",
"inv2.included": "Включено",
"inv2.monthlyTitle": "Месечно фактуриране (абонамент)",
"inv2.months": "+{n} месеца",
"inv2.paid": "Платено",
"inv2.pay": "Плати",
"inv2.previewTitle": "Преглед на следващата ви фактура —",
"inv2.renew": "Поднови моя договор",
"inv2.renewalsTitle": "История на подновяванията ({n})",
"inv2.renewedUntil": "Договорът е подновен до {date}",
"inv2.serviceTitle": "Фактури за услуги (възстановявания и оферти)",
"inv2.soon": "Срокът изтича скоро",
"inv2.toPay": "За плащане",
"inv2.totalHtTva": "Общо без ДДС · ДДС",
"inv2.totalTtc": "Общо с ДДС",
"iu.addPhoto": "Добави снимка",
"iu.change": "Промени",
"lang.label": "Език",
"lb.allCountries": "Всички държави",
"lb.badge": "Годишна класация",
"lb.champion": "🏆 Шампион на годината",
"lb.cityPh": "Филтрирай по град…",
"lb.empty": "Все още няма класация за тези филтри.",
"lb.pts": "точки",
"lb.resetNote": "Класация за текущата година — нулира се на 1 януари.",
"lb.returned": "върнато",
"lb.share": "Сподели класацията",
"lb.shareText": "Вижте класацията на най-добрите намиращи на Findloop!",
"lb.subtitle": "Всяко върнато нещо носи точки. Класацията се нулира на 1 януари.",
"lb.tabFinders": "Намиращи",
"lb.tabPartners": "Заведения",
"lb.title": "Най-добри намиращи",
"lost.b2bDesc": "Загубили сте го в хотел, транспортен хъб или партньорско място? Намерете заведението и докладвайте загубата си.",
"lost.b2bTitle": "Докладвайте на партньор",
"lost.b2cDesc": "Публикувайте обява, видима за всички, предложете награда и я популяризирайте, за да увеличите шансовете си.",
"lost.b2cTitle": "Публикувайте публична обява",
"lost.desc": "Изберете как искате да продължите.",
"lost.title": "Заг丢ен ли?",
"map.allCategories": "Всички категории",
"map.clear": "Нулиране",
"map.exitFullscreen": "Изход",
"map.filterCity": "Град или държава…",
"map.fullscreen": "На цял екран",
"map.heatmap": "Топлинна карта",
"map.high": "Висока",
"map.impactMonth": "върнати артикули този месец",
"map.impactTotal": "върнати общо",
"map.legend": "Оцветени точки от червено (ниско) до зелено (високо) в зависимост от процента на връщане; размерът е на база брой артикули.",
"map.locating": "Локализиране… добавете адрес на вашите заведения, за да ги видите на картата.",
"map.low": "Ниска",
"map.mAll": "Всички",
"map.mFound": "Намерени",
"map.mLost": "Заг丢ени",
"map.medium": "Средна",
"map.noItemRegistered": "Няма регистриран артикул",
"map.noItems": "Няма артикул",
"map.period30": "Последни 30 дни",
"map.period7": "Последни 7 дни",
"map.period90": "Последни 90 дни",
"map.periodAll": "През цялото време",
"map.returnedSuffix": "върнати · {a}/{t} артикула",
"map.stats": "Статистика на града",
"map.statsTop": "Топ 5 места (заг丢ени артикули)",
"map.statsTrend": "6-месечен тренд",
"map.title": "Карта на вашите заведения",
"map.topPlaces": "Популярни места",
"mc.adClosed": "Обявата е затворена",
"mc.addPhoto": "Добавете снимка",
"mc.adsNone": "Няма обява за заг丢ен артикул.",
"mc.archiveHide": "Скрий историята",
"mc.archiveNone": "Все още няма решен случай.",
"mc.archiveShow": "Покажи историята",
"mc.archiveSub": "Решени и върнати случаи.",
"mc.archiveTitle": "История",
"mc.at": "В",
"mc.backToLogin": "Назад към входа",
"mc.boostContacts": "Контакти (усилване)",
"mc.boostViews": "Прегледи (усилване)",
"mc.cancel": "Отказ",
"mc.certificate": "Сертификат",
"mc.changePhoto": "Сменете снимка",
"mc.city": "Град",
"mc.closeAd": "Затвори",
"mc.closeAdConfirm": "Затваря ли тази обява? Ще спре да бъде видима и ще освободи слот.",
"mc.confirmPassword": "Потвърдете паролата",
"mc.confirmRestitution": "Потвърдете връщането",
"mc.connect": "Свържете се",
"mc.contacts": "Контакти",
"mc.country": "Държава",
"mc.declareFound": "Докладвайте намерен артикул",
"mc.declareFoundSub": "Публикувайте артикул, който сте намерили",
"mc.declareLost": "Докладвайте заг丢ване",
"mc.declareLostSub": "Публикувайте обява за заг丢ен артикул",
"mc.deleteAccount": "Изтрийте моята сметка",
"mc.deleteConfirm": "Да, изтрийте моята сметка",
"mc.deleteConfirmBody": "Вашата сметка ще бъде постоянно изтрита, а личните ви данни анонимизирани. Това действие не може да бъде отменено.",
"mc.deleteConfirmTitle": "Изтриване на вашата сметка?",
"mc.deleteDesc": "Постоянно изтрива вашия акаунт и анонимизира вашите лични данни. Тази операция не може да бъде отменена.",
"mc.deleted": "Вашият акаунт е изтрит.",
"mc.deleting": "Изтриване…",
"mc.email": "Имейл",
"mc.expiresOn": "Изтича на",
"mc.exportData": "Свалете моите данни (GDPR)",
"mc.exportDone": "Вашите данни са свалени.",
"mc.exporting": "Подготовка…",
"mc.finderAccepted": "Прието",
"mc.finderProfile": "Профил на търсач (по желание)",
"mc.finderProfileDesc": "Спечелете точки, като върнете предмети и се появите в публичната таблица с резултати.",
"mc.forYourAd": "За вашата обява",
"mc.forgotLink": "Забравена парола?",
"mc.forgotSend": "Изпратете линка",
"mc.forgotSent": "Ако акаунт съществува за този имейл, линк за нулиране току-що беше изпратен.",
"mc.forgotTitle": "Забравена парола",
"mc.foundAdsNone": "Няма публикувани обяви за намерени предмети.",
"mc.foundAt": "Намерено в",
"mc.foundNone": "Не е съобщено за намерен предмет.",
"mc.hAd": "Загубена обява",
"mc.hDeclaration": "Декларация",
"mc.hFinderContact": "Съобщен предмет",
"mc.hFound": "Върнат предмет",
"mc.hFoundAd": "Обява за намерен предмет",
"mc.histEarned": "Върнат предмет",
"mc.historyTitle": "История на моите точки",
"mc.loginBtn": "Влезте",
"mc.loginTitle": "Вход за клиенти",
"mc.logout": "Излезте",
"mc.lostAt": "Загубено в",
"mc.matchPartner": "При партньор",
"mc.matchPublic": "Намерени предмет",
"mc.matches": "Съвпадения",
"mc.matchesSub": "Намерени предмети може да съвпадат с вашите обяви за загубени предмети.",
"mc.myAds": "Моите обяви за загубени предмети",
"mc.myDeclarations": "Моите репорти",
"mc.myFinds": "Предмети, които намерих",
"mc.myFindsNone": "Все още не сте съобщили за намерен предмет.",
"mc.myFindsSub": "Предмети, които сте съобщили за намерени в обяви за загубени предмети.",
"mc.myFound": "Докладвани намерени предмети",
"mc.myFoundAds": "Моите обяви за намерени предмети",
"mc.myRewards": "Моите ваучери",
"mc.name": "Пълно име",
"mc.newPassword": "Нова парола",
"mc.none": "Няма репорт досега.",
"mc.notEnough": "Недостатъчно точки",
"mc.notifEmpty": "Все още няма известия.",
"mc.notifOpen": "Преглед",
"mc.notifTitle": "Известия",
"mc.notifTrack": "Проследяване",
"mc.notifViewAd": "Преглед на обява",
"mc.optInDesc": "Участването е по желание. Вие се съгласявате да се показват публично избраните предмети по-долу. Може да бъде променено по всяко време.",
"mc.optInTitle": "Появяване в публичната таблица с резултати",
"mc.password": "Парола",
"mc.passwordMismatch": "Паролите не съвпадат.",
"mc.phone": "Телефон",
"mc.photoUpdated": "Снимката на профила е обновена",
"mc.pointsAwaiting": "Точки в очакване",
"mc.pointsBalance": "Точки за харчене",
"mc.pointsOk": "Точки кредитирани",
"mc.presentHint": "Покажете този QR код на партньора: те го сканират, за да валидират вашата награда.",
"mc.presentInStore": "Покажете в магазина",
"mc.presentTitle": "Покажете този ваучер",
"mc.privacy": "Поверителност и данни",
"mc.privacyDesc": "Изтеглете копие на всички лични данни, които Findloop държи за вас (GDPR, чл. 15 и 20).",
"mc.profileSaved": "Профилът е актуализиран.",
"mc.profileSettings": "Публичен профил и класация",
"mc.pseudo": "Име или прякор",
"mc.redExpired": "Изтекъл",
"mc.redReady": "Покажете на партньора",
"mc.redUsed": "Използван",
"mc.redeem": "Осребряване",
"mc.registerBtn": "Създайте акаунта си",
"mc.registerTitle": "Създайте клиентски акаунт",
"mc.rememberMe": "Запомни ме",
"mc.remove": "Премахнете",
"mc.resetDone": "Паролата е актуализирана. Сега можете да влезете.",
"mc.resetExpired": "Тази връзка за нулиране е невалидна или е изтекла. Искате ли нова по-долу.",
"mc.resetSave": "Нулирайте паролата си",
"mc.resetTitle": "Нова парола",
"mc.restitutionConfirmed": "Връщането е потвърдено.",
"mc.reward": "Награда",
"mc.rewardRedeemed": "Наградата е отключена! Код:",
"mc.rewardsDesc": "Използвайте точките си за привилегии, предлагани от нашите партньори. Баланс:",
"mc.rewardsNone": "Все още няма налична награда.",
"mc.rewardsTitle": "Изразходвайте моите точки",
"mc.scoreAwarded": "Браво! +1 към вашия Finder Score 🎉",
"mc.scoreEarned": "Завоювана точка",
"mc.scorePts": "точки",
"mc.scoreThisYear": "Тази година",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Вижте класацията",
"mc.share": "Споделете",
"mc.statsTitle": "Статистика",
"mc.subtitle": "Следете всички ваши отчети на едно място.",
"mc.title": "Моят акаунт",
"mc.toLogin": "Вече сте регистрирани?",
"mc.toRegister": "Все още нямате акаунт?",
"mc.track": "Проследяване",
"mc.views": "Прегледи",
"mc.visCity": "Град",
"mc.visCountry": "Държава",
"mc.visLabel": "Елементи, видими в класацията:",
"mc.visName": "Име / прякор",
"mc.visPhoto": "Профилна снимка",
"mc.welcome": "Здравейте",
"mc2.acceptFinder": "Приемете този finder",
"mc2.accountActivity": "Активност на акаунта",
"mc2.adsActive": "{n}/5 активни обяви",
"mc2.autoDelete": "Автоматично изтриване, планирано за",
"mc2.badgeBronze": "Бронзов",
"mc2.badgeGold": "Златен",
"mc2.badgeSilver": "Сребърен",
"mc2.boostEarnedAlready": "Вече ви е спечелил",
"mc2.boostEarnedWin": "Той ви спечели",
"mc2.boostExpiredWin": "Вашият бууст току-що изтече — възобновете с -20%!",
"mc2.boostExpiresIn": "Вашият бууст изтича след",
"mc2.boostWinDetail2": ". -20% прилагани автоматично, ако подновите в рамките на 24ч.",
"mc2.claimCode": "Код за искане:",
"mc2.codeSentFinder": "Кодът е изпратен до finder по имейл",
"mc2.daysShort": "{n} д",
"mc2.downloadReceipt": "Изтегли моята разписка",
"mc2.error": "Грешка {status}",
"mc2.finderAccepted": "Finder одобрен — код изпратен по имейл",
"mc2.finderContacts": "Данни за контакт на Finder(и)",
"mc2.followFindo": "Следвай Findloop",
"mc2.imgInvalid": "Невалидно изображение",
"mc2.inactivityNote": " — в случай на {n} месеца без активност (GDPR).",
"mc2.lastActivity": "Последна активност:",
"mc2.lostEmailTitle": "Вече нямам достъп до моя имейл",
"mc2.noPhotoPreset": "Все още нямаш снимка? Избери стандартен аватар:",
"mc2.paidViaPartner": "Платено (чрез партньор)",
"mc2.payRecovery": "Плати таксата за възстановяване",
"mc2.paySettle": "Разплати моята плащане",
"mc2.payShipping": "Плати таксата за доставка",
"mc2.payUnavailable": "Плащането е недостъпно",
"mc2.peopleFound": "{n} човек(и) мислят, че са намерили твоя артикул",
"mc2.phoneNumber": "Телефонен номер",
"mc2.reactivateAccount": "Активирай отново моя акаунт",
"mc2.reactivated": "Акаунтът е активиран отново",
"mc2.reactivatedThanks": "Акаунтът е активиран отново — благодаря за лоялността!",
"mc2.recoverSmsBtn": "Получавам кода си по SMS",
"mc2.recoverSmsDesc": "Получете кода си за искане по SMS на номера, регистриран в акаунта ви.",
"mc2.recoverSmsFallback": "Ако акаунт съществува с този номер, SMS е изпратен.",
"mc2.renewStayTop": ". Поднови, за да останеш на върха и да възстановиш артикула си.",
"mc2.resume20": "Възстанови -20%",
"mc2.unlockContacts": "Отключи данни за контакт",
"mc2.unlockDesc": "Плати таксата за обработка на Findloop, за да разкриеш данните им за контакт и да организираш предаването.",
"mc2.viewsWord": "прегледи",
"mc2.live": "На живо",
"mh.allCategories": "Всички категории",
"mh.allPeriod": "През цялото време",
"mh.autoMatch": "Автоматично съвпадение с AI",
"mh.blocked": "Блокиран (противоречие)",
"mh.blockedReason": "Съвпадението е блокирано: основните ключови думи на артикула и декларацията си противоречат.",
"mh.days30": "Последни 30 дни",
"mh.days7": "Последни 7 дни",
"mh.days90": "Последни 90 дни",
"mh.emptyDesc": "Съвпаденията с AI ще се появят тук, когато декларациите постъпват.",
"mh.emptyTitle": "Няма събития",
"mh.exportCsv": "Експорт на CSV",
"mh.exportDone": "CSV експортът е изтеглен",
"mh.exportImpossible": "Експортът не успя",
"mh.fBlocked": "Блокиран",
"mh.fConfirmed": "Потвърден",
"mh.fRejected": "Отхвърлен",
"mh.objectLabel": "Артикул:",
"mh.refresh": "Освежи",
"mh.rejected": "Отхвърлен",
"mh.srcManual": "Ръчен",
"mh.srcText": "Текст",
"mh.srcVisual": "Визуален (снимка)",
"mh.subtitle": "Лог на съвпадения, предложени от AI — автоматично съвпаднали, потвърдени и отхвърлени.",
"mh.title": "История на AI",
"nav.ads": "Намерени артикули",
"nav.dashboard": "М空",
"nav.found": "Намерените артикули",
"nav.how": "Как работи",
"nav.login": "Вход",
"nav.map": "Карта",
"nav.more": "Още",
"nav.partners": "Партньори",
"nav.pricing": "Цени",
"nav.ranking": "Класация",
"nav.register": "Стани партньор",
"nav.track": "Проследи декларация",
"nf.desc": "Страницата, която търсите, не съществува или е преместена.",
"nf.home": "Назад към началото",
"nf.title": "Страницата не е намерена",
"par.allCities": "Всички градове",
"par.allCountries": "Всички държави",
"par.badge": "Директория",
"par.certified": "Сертифициран",
"par.certifiedBadge": "Сертифициран",
"par.cityPh": "Град",
"par.declare": "Декларирай",
"par.none": "Не е намерен партньор.",
"par.partnerBadge": "Партньор",
"par.searchPh": "Търсете заведение…",
"par.subtitle": "Намерете заведението, в което загубихте вашия артикул и докладвайте загубата си.",
"par.title": "Нашите партньори",
"pay.addr1": "Адрес",
"pay.addr2": "Ред 2 на адреса (по желание)",
"pay.addrIncomplete": "Моля, попълнете адреса за доставка.",
"pay.badge": "Възстановяване",
"pay.card": "Плащане с карта",
"pay.city": "Град",
"pay.country": "Държава",
"pay.eurNote": "Сумите са посочени в евро (€).",
"pay.fee": "Такса за възстановяване",
"pay.free": "безплатно",
"pay.howRecover": "Как искате да получите обратно вашия артикул?",
"pay.momo": "Плащане с Mobile Money",
"pay.momoConfirm": "Потвърдете плащането",
"pay.noMatch": "Все още няма потвърдено съвпадение за този доклад.",
"pay.notfound": "Докладът не е намерен.",
"pay.phonePh": "Телефонен номер",
"pay.pickup": "Вземете лично",
"pay.pickupDesc": "В",
"pay.postal": "Пощенски код",
"pay.secure": "Сигурно плащане",
"pay.serviceFee": "такса за услуга на Findloop",
"pay.ship": "Изпратете ми го",
"pay.shipAfter": "— предлагано след плащане.",
"pay.shipDesc": "Доставка до моя адрес",
"pay.shipNote": "Доставката е налична",
"pay.shipping": "Такса за доставка",
"pay.subtitleWith": "Платете таксата за възстановяване на",
"pay.title": "Възстановяване на моя артикул",
"pay.total": "Общо",
"pcat.city_hall": "Общински управления",
"pcat.hotel": "Гостиници",
"pcat.other": "Други",
"pcat.park": "Паркoве",
"pcat.prefecture": "Префектури",
"pcat.restaurant": "Ресторанти",
"pcat.uncategorized": "Несортирани",
"pd.about": "За нас",
"pd.back": "Всички партньори",
"pd.certified": "Сертифициран партньор",
"pd.declare": "Декларирайте загуба тук",
"pd.itemsReturned": "върнати артикули",
"pd.itemsTotal": "регистрирани артикули",
"pd.map": "Местоположение",
"pd.noItems": "Няма намерени артикули наскоро.",
"pd.noReviews": "Все още няма отзиви.",
"pd.notFound": "Партньорът не е намерен.",
"pd.recentItems": "Наскоро намерени артикули",
"pd.reply": "Отговор от заведение",
"pd.reviews": "Отзиви на клиенти",
"pd.verified": "Потвърден отзив",
"pd.verifiedEstablishment": "потвърдено заведение Findloop",
"pg.next": "Напред",
"pg.prev": "Назад",
"pg.showing": "{from}–{to} от {total}",
"pk.bodyCopy": "Основен текст",
"pk.bodyText": "Текст на тялото",
"pk.brandColors": "Цветове на марката",
"pk.colorRed": "Червен",
"pk.colorWhite": "Бял",
"pk.darkBg": "Тъмен фон",
"pk.download": "Изтегли",
"pk.downloadZip": "Изтегли целия комплект (ZIP)",
"pk.headings": "Заглавия",
"pk.heroDesc": "Официални логотипи, банери в социалните мрежи, цветове и типография. Изберете езика и варианта на слогана, след това изтеглете визуализацията или целия комплект.",
"pk.lightBg": "Светъл фон (предпечат)",
"pk.logoWordmark": "Логотип / надпис",
"pk.logosVisuals": "Логотипи и визуали",
"pk.mapCollect": "Карта / точки за събиране",
"pk.plain": "Обикновен",
"pk.pressKit": "Прес комплект",
"pk.taglineLang": "Език на слогана",
"pk.typography": "Типография",
"pk.variant": "Вариант",
"pr.shipBtn": "Изпратете артикула",
"pr2.adBoostMsg": "Страхотен избор! Увеличавате шансовете си бързо да възстановите артикула си.",
"pr2.boostActivated": "Увеличението е активирано!",
"pr2.canRecoverNow": "Сега можете да възстановите артикула си.",
"pr2.continue": "Продължи",
"pr2.downloadReceiptPdf": "Изтеглете разписката (PDF)",
"pr2.goToSpaceNow": "Отидете в моя акаунт сега",
"pr2.partnerBoostMsg": "Страхотен избор! По-видимостта означава привличане на нови клиенти в заведението ви.",
"pr2.paymentSuccess": "Плащането е успешно!",
"pr2.redirectingSpace": "Пренасочване към вашия акаунт…",
"pr2.subActivated": "Плащането е успешно! Вашата абонаментна услуга е активна, сега можете да управлявате заведенията си.",
"prev.allSites": "Всички заведения",
"prev.editReply": "Редактирайте отговора",
"prev.none": "Все още няма отзив.",
"prev.published": "Отговорът е публикуван",
"prev.reply": "Отговор",
"prev.replyPh": "Напишете учтив отговор…",
"prev.send": "Публикувайте отговора",
"prev.sending": "Публикувам…",
"prev.yourReply": "Вашият отговор",
"pricing.annual": "Годишен",
"pricing.annualBadge": "-20% оферта",
"pricing.choose": "Избор",
"pricing.compareFeature": "Функция",
"pricing.compareTitle": "Сравнете плановете",
"pricing.eyebrow": "Ценообразуване",
"pricing.month": "/мс",
"pricing.monthly": "Месечно",
"pricing.perYear": "/г",
"pricing.popular": "Популярен",
"pricing.quoteMsg": "Вашите нужди (по избор)",
"pricing.quoteOrg": "Организация",
"pricing.quoteSend": "Изпрати запитване",
"pricing.quoteSent": "Запитването е изпратено! Ще се свържем с вас скоро.",
"pricing.quoteSites": "Брой сайтове / терминали",
"pricing.quoteTitle": "Искане на оферта",
"pricing.requestQuote": "Искане на оферта",
"pricing.saveLabel": "Спестявате",
"pricing.savePerYear": "/г за всяко допълнително заведение",
"pricing.start": "Започнете",
"pricing.subtitle": "Започнете безплатно, растете с времето.",
"pricing.title": "План за всяка организация",
"promo.badge": "Партньорска програма",
"promo.cta": "Научете повече",
"promo.text": "Всеки партньор, когото насочите и който се абонира, ви дава един безплатен месец. Без лимит.",
"promo.title": "Препоръчайте партньор, получите безплатен месец.",
"pub.accessGranted": "Достъпът е разрешен",
"pub.accessLimited2h": "Достъпът е ограничен до 2 часа",
"pub.accountEmailConcerned": "Имейл на съответния акаунт",
"pub.adAppearPublic": "Така ще изглежда вашата реклама публично.",
"pub.adPreviewBtn": "Преглед на рекламата",
"pub.alertMeOnArrival": "Известете ме при пристигане",
"pub.allActionsLogged": "Всички действия са регистрирани",
"pub.allCategories": "Всички категории",
"pub.authorizeAccess": "Разрешете достъп",
"pub.authorizeSupportQ": "Да разрешим ли достъп до поддръжка?",
"pub.available": "Наличен",
"pub.backHome": "Назад към началото",
"pub.boostAdCta": "Увеличи рекламата ми",
"pub.boostAdTitle": "Увеличете рекламата си",
"pub.boostCarouselSub": "Преместете се на върха на страницата в карусела „Увеличени“ и умножете изгледите, за да възстановите по-бързо продукта си.",
"pub.boostEstablishment": "Увеличете заведението си",
"pub.boostEstablishmentDesc": "Появявайте се на върха на директорията с значка „Увеличен“ и привличайте повече доклади.",
"pub.boostFicheCta": "Увеличи списъка ми",
"pub.brandReady": "Брандът Findloop е готов за употреба",
"pub.cantFindItem": "Не можете да намерите продукта си?",
"pub.cantProcessImage": "Не можем да обработим това изображение",
"pub.claimQr": "Придобий QR код",
"pub.clickToZoom": "Кликнете, за да увеличите",
"pub.codeAlreadyValidated": "Кодът е валидиран — контактите са отключени.",
"pub.codeExample": "напр. ABCD2345",
"pub.confirmRenewal": "Потвърдете подновяването",
"pub.contactIntro": "Въпрос, запитване? Пишете ни, ще се свържем с вас скоро.",
"pub.contactTypeDeceased": "Изтриване на акаунт (покойник)",
"pub.contactTypeGeneral": "Общ въпрос",
"pub.contactTypeSupport": "Поддръжка / технически проблем",
"pub.contactUs": "Свържете се с нас",
"pub.continueWithoutEmail": "Продължете без да оставяте имейл",
"pub.contractLabel": "Договор",
"pub.contractNotFound": "Договорът не е намерен или вече е изтекъл.",
"pub.contractRenewed": "Договорът е подновен!",
"pub.contractRenewedFor": "Вашият договор е подновен за {n} месеца.",
"pub.copyFailed": "Копирането не успя",
"pub.createPartnerAccount": "Създайте партньорския си акаунт",
"pub.currentDeadline": "Текущ срок",
"pub.deceasedInfo": "Като роднина или наследник, можете да поискате изтриване на акаунта на починал човек от findloop. Ще обработим вашето запитване в съответствие с GDPR (може да се поискат подкрепящи документи).",
"pub.declareMyLoss": "Докладвайте за моя загуба",
"pub.describeItemPlaceholder": "Опишете вашия артикул (напр. черен чадър, ключове…)",
"pub.downloadImage": "Изтеглете изображението",
"pub.drawSignature": "Моля, нарисувайте подписа си.",
"pub.drawSignatureHint": "Нарисувайте подписа си с мишката или пръста.",
"pub.duration": "Продължителност",
"pub.eSignature": "Електронен подпис",
"pub.eSignatureDesc": "Въведете името си, за да подпишете. Датата се записва автоматично.",
"pub.edit": "Редактиране",
"pub.editorialTitles": "Редакционни заглавия",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "Въведете кода, получен по имейл, за да отключите данните за контакт на собственика.",
"pub.errorWord": "Грешка",
"pub.foundSelfService": "Намерени артикули · Самообслужване",
"pub.haveOwnerCode": "Получих код от собственика",
"pub.home": "Начало",
"pub.immediateRenewal": "Незабавна подмяна, без нова оферта.",
"pub.impAdminReq1": "Администратор",
"pub.impAdminReq2": "изисква разрешение за временно достъпване на акаунта ви",
"pub.impAdminReq3": "за да ви помогне.",
"pub.impGrantedDesc": "Екипът по поддръжката ще може да получи достъп до акаунта ви за максимум 2 часа. Всяко действие ще бъде записано. Можете да затворите тази страница.",
"pub.invitedOnFindo": "Вие сте поканени да се присъедините към Findloop",
"pub.isThisYourItem": "Това ли е вашият артикул?",
"pub.itemsAvailableCount": "{n} артикул(а) в момента налични",
"pub.itemsFoundOwner": "на доверени артикули, намерили собственика си",
"pub.itemsReturnedOwners": "артикули, върнати на собствениците си",
"pub.itsMine": "Той е мой",
"pub.joinFindoDesc": "Присъединете се към Findloop и управлявайте лесно намерените си артикули.",
"pub.joinInvitesYou": "ви кани да се присъедините към findloop. Създайте партньорски акаунт, за да управлявате намерените си артикули.",
"pub.linkCopied": "Връзката е копирана!",
"pub.loadingContract": "Зареждане на договора…",
"pub.lsClaimDesc": "Съобщете за загубата си, за да я възстановите. Оставете имейл адрес и ще ви изпратим напомняне, ако отчета ви не е завършен.",
"pub.lsHeroDesc": "Проверете сами дали вашият изгубен предмет е намерен и оставен тук. Намерихте ли го? Съобщете, за да го възстановите.",
"pub.lsSearchTitle": "Търсене на намерени артикули",
"pub.makeOffer": "Направете оферта",
"pub.makeOfferDesc": "Предложете вашата сума. Суперадминистраторът ще я прегледа.",
"pub.mapNearYou": "Артикули и партньори наблизо",
"pub.mapWord": "Карта",
"pub.messageSentToast": "Съобщението е изпратено — нашият екип ще отговори скоро.",
"pub.messageWord": "Съобщение",
"pub.momoInitiated": "Иницирано плащане с мобилни пари",
"pub.monthsWord": "месеца",
"pub.nameConsentRequired": "Изисква се име и съгласие.",
"pub.newDeadline": "Нова крайна дата",
"pub.noActionRequired": "Не се изисква действие.",
"pub.noAmountCharged": "Не е начислена сума.",
"pub.noItemMatch": "В момента няма наличен артикул, който да отговаря на вашето търсене.",
"pub.noMatchingItem": "Няма съвпадащ артикул",
"pub.noPaymentSession": "Няма сесия за плащане.",
"pub.noPhoto": "Няма снимка",
"pub.noPointsYet": "Няма точки за показване още.",
"pub.noSecondPayment": "Не е необходимо второ плащане за този артикул.",
"pub.notHereYet": "Още не е тук? Ще получите известие веднага щом пристигне.",
"pub.notifyDone": "Запомнено! Ще ви уведомим по имейл, веднага щом пристигне съвпадащ артикул.",
"pub.offerSubmitted": "Вашата оферта е изпратена.",
"pub.oops": "Оу",
"pub.orAlertEmail": "Или получавайте уведомление по имейл веднага щом пристигне съвпадащ артикул:",
"pub.ownerContacts": "Данни за контакт на собственика",
"pub.ownerContactsUnlocked": "Данни за контакт на собственика отключени",
"pub.partnerContact": "Контакт с партньор",
"pub.payLinkUnavailable": "Връзката за плащане не е налична — свържете се с партньора.",
"pub.paymentCancelled": "Плащането е отменено",
"pub.paymentConfirmed": "Плащането е потвърдено 🎉",
"pub.paymentConfirmedDesc": "Ще получите имейл с подробности за възстановяване на артикула.",
"pub.paymentNotConfirmed": "Плащането не е потвърдено",
"pub.paymentNotConfirmedDesc": "Плащането не може да бъде потвърдено. Опитайте отново или се свържете с партньора.",
"pub.paymentProcessing": "Плащането се обработва. Обновете след малко.",
"pub.photoAdded": "✓ Снимка добавена",
"pub.photoRequired": "Изисква се снимка на артикула.",
"pub.previewAlt": "превью",
"pub.publish": "Публикувай",
"pub.publishingWord": "Публикуване…",
"pub.qty": "Брой",
"pub.quoteDeclined": "Офертата е отказана.",
"pub.quoteNotFound": "Офертата не е намерена или е изтекла.",
"pub.reasonLabel": "Причина",
"pub.recoveryAlreadyPaid": "Таксата за възстановяване вече е платена",
"pub.referralCode": "Код за препоръка:",
"pub.relationshipPlaceholder": "Син, съпруг, нотариус…",
"pub.renewYourContract": "Подновете договора си",
"pub.renewalFailed": "Неуспешно подновяване. Опитайте отново по-късно.",
"pub.renewing": "Подновяване…",
"pub.replySoon": "Нашият екип ще отговори възможно най-скоро.",
"pub.requestGone": "Тази заявка вече не съществува.",
"pub.requestHandled": "Запитването вече е обработено",
"pub.requestNotFound": "Запитването не е намерено или е изтекло.",
"pub.requestUnavailable": "Запитването е недостъпно",
"pub.required": "(изисква се)",
"pub.retroClosing": "Заедно правим света малко по-малко изгубен.",
"pub.retroClosing2": "Заедно правим света малко по-малко изгубен.",
"pub.retroScroll": "Година на възстановяване на важното. Превъртете надолу ↓",
"pub.revokeAnytime": "Можете да оттеглите всеки момент, като се свържете с нас",
"pub.scene": "Сцена",
"pub.sendImpossible": "Не може да бъде изпратено",
"pub.sendMessage": "Изпратете съобщението",
"pub.sending": "Изпращане…",
"pub.sharePreview": "Споделете превю",
"pub.shareYourAd": "Споделете обявата си",
"pub.signedSuccess": "Успешно подписано!",
"pub.signerFullName": "Пълно име на подписващия",
"pub.spreadNetwork": "Споделете го с хората около вас за повече шансове.",
"pub.spreadOwner": "Споделете, за да помогнете на собственика да възстанови вещите си.",
"pub.statusLabel": "Статус:",
"pub.subject": "Тема",
"pub.thanksSent": "Благодарим Ви, вашето съобщение е изпратено.",
"pub.thisYear": "Тази година",
"pub.validate": "Потвърдете",
"pub.verifyingPayment": "Потвърдете плащането…",
"pub.verifyingYourPayment": "Потвърдете вашето плащане…",
"pub.viewAd": "Вижте обявата →",
"pub.viewPartner": "Вижте партньора →",
"pub.yourAdPreview": "Превю на обявата ви",
"pub.yourEmail": "Вашият имейл",
"pub.yourEmailRecommended": "Вашият имейл (препоръчително)",
"pub.yourEmailShort": "Вашият имейл",
"pub.yourName": "Вашето име",
"pub.yourRelationship": "Вашето отношение към лицето",
"qv.acceptAndSign": "Приемам и подписвам офертата си",
"qv.certifyAuthorized": "С удостоверявам, че съм упълномощен да подпиша и приемам условията на този {what} (обвързваща стойност).",
"qv.clear": "Изчисти",
"qv.client": "Клиент",
"qv.conditions": "Условия",
"qv.confirmDecline": "Потвърдете отказа на тази оферта?",
"qv.countersignedFindo": "Овключено от Findloop · {name} на {date}",
"qv.decline": "Отказ",
"qv.description": "Описание",
"qv.downloadPdf": "Изтеглете PDF",
"qv.handwrittenSignature": "Ръчен подпис",
"qv.inclTax": "С вкл. данък",
"qv.invalidAmount": "Невалидна сума.",
"qv.invoice": "Фактура",
"qv.invoicePaid": "Фактурата е платена",
"qv.issuer": "Издател",
"qv.messageOptional": "Съобщение (по избор)",
"qv.negotiatedAmount": "Договорена сума",
"qv.payInvoiceOnline": "Платете фактурата онлайн",
"qv.quote": "Оферта",
"qv.quoteValidDays": "Офертата е валидна за {n} дни.",
"qv.sendMyOffer": "Изпратете моята оферта",
"qv.signContract": "Подпишете моя договор",
"qv.signNow": "Подпишете сега",
"qv.signatureAlt": "Подпис",
"qv.signedByOn": "✔ Подписано от {name} на {date}",
"qv.stContractSigned": "Договорът е подписан. Благодаря ви!",
"qv.stCounterAccepted": "Вашата оферта е приета! Подпишете договора си по-долу.",
"qv.stCounterRefused": "Вашата оферта не можа да бъде приета.",
"qv.stCountered": "Вашата оферта е изпратена. Очаква се отговор от findloop.",
"qv.stDeclined": "Вие отказахте тази оферта.",
"qv.stSigned": "Офертата е приета и подписана. Благодаря ви!",
"qv.totalHt": "Общо без данък",
"qv.totalTtc": "Общо с данък",
"qv.unitHt": "Единична без данък",
"qv.vat": "ДДС",
"qv.yourProposedAmount": "Вашата предложена сума ({cur})",
"rate.chooseNote": "Моля, изберете оценка.",
"rate.commentPh": "Коментар (по избор)…",
"rate.home": "Назад към начало",
"rate.submit": "Изпратете моя отзив",
"rate.submitting": "Изпращам…",
"rate.subtitle": "Как мина възстановяването на вашия предмет?",
"rate.successText": "Вашето мнение помага на другите потребители.",
"rate.successTitle": "Благодаря за отзива!",
"rate.title": "Оценете своя опит",
"reg.add": "Запишете предмет",
"reg.allBrands": "Всички марки",
"reg.allColors": "Всички цветове",
"reg.allLocations": "Всички места",
"reg.detailDesc": "Детайли и действия за този намерен предмет.",
"reg.dispAuction": "Аукцион",
"reg.dispAuthorities": "Предаден на властите",
"reg.dispDestroyed": "Унищожен",
"reg.dispDonate": "Дарение за благотворителност",
"reg.dispositionHint": "Записвайте предмета при напускане на склад. Брои се в статистиката по категория.",
"reg.emptyCta": "Запишете предмет",
"reg.emptyDesc": "Започнете, като запишете първия си намерен предмет.",
"reg.emptyTitle": "Няма намерени предмети",
"reg.establishmentFallback": "заведение",
"reg.lblAuctioned": "изброен на аукцион",
"reg.lblAuctionedShort": "пуснат на аукцион",
"reg.lblAuthorities": "предаден на властите",
"reg.lblDestroyed": "унищожен",
"reg.lblDonated": "дарено на благотворителност",
"reg.legalCount": "{n} артикул(а): срокът на задържане е изтекъл",
"reg.legalHint": "Можете да ги предложите на търг, да ги дарите на благотворителност или да съобщите за тях на властите.",
"reg.legalLimitCountry": "Краен срок: {date} · приложена страна: {country}",
"reg.legalOver": "Срокът е изтекъл: {date} · {country}",
"reg.legalReached": "Срокът е достигнат",
"reg.legalReachedFull": "Срокът на задържане е достигнат",
"reg.limitShort": "краен срок",
"reg.location": "Местоположение",
"reg.markRestituted": "Маркирай като върнат",
"reg.markedAs": "Артикулът е маркиран като {label}",
"reg.moveHistory": "История на движението",
"reg.overBy": "изтекъл с {n}д",
"reg.physicalLocation": "Физическо местоположение",
"reg.popupBlocked": "Позволете изскачащи прозорци, за да отпечатате етикетите.",
"reg.popupBlockedOne": "Позволете изскачащи прозорци, за да отпечатате етикета.",
"reg.printLabel": "Отпечатайте етикета",
"reg.printN": "Отпечатайте {n} етикета",
"reg.qrCodeItem": "QR код на артикула",
"reg.qrLabelTitle": "QR етикет",
"reg.qrLabelsTitle": "QR етикети",
"reg.qrNotFound": "Не е намерен артикул за този QR код.",
"reg.qrScanHint": "Сканирайте, за да отворите този запис директно и да намерите местоположението.",
"reg.recoveryFee": "Такса за възстановяване (€)",
"reg.searchPh": "Търсене по описание…",
"reg.selectQr": "Изберете, за да отпечатате QR етикети",
"reg.selectedN": "{n} избрани",
"reg.shipPricePh": "Цена за доставка (€)",
"reg.shippingPossible": "Доставката е възможна",
"reg.storagePh": "например. Рафтове A3, Шкафче 12",
"reg.tAuction": "Търг на Findloop",
"reg.tAuthorities": "Съобщи за предаването на властите",
"reg.tDonate": "Дарете на благотворителност",
"reg.toastFee": "Таксата е актуализирана",
"reg.toastLocation": "Местоположението е запазено",
"reg.toastRestituted": "Артикулът е маркиран като върнат",
"reg.toastShipping": "Опцията за доставка е актуализирана",
"reg.toastTransferred": "Артикулът е прехвърлен на “{name}”",
"reg.unclaimedDisposition": "Неоткрит артикул — окончателна разпоредба",
"res.codeValidated": "Кодът е валидиран",
"res.empty": "Все още няма записана възстановяване.",
"res.error": "Грешка {status}",
"res.proofPdf": "PDF доказателство",
"res.signed": "Подписано",
"res.stRestituted": "Предадено лично",
"res.stShipped": "Върнато чрез доставка",
"res.subtitle": "Всички завършени предавания, с изтегляемо подпечатано доказателство.",
"res.title": "История на възстановяването",
"rev.b2b": "B2B партньори",
"rev.b2c": "Клиенти",
"rev.based": "основано на {n} отзиви",
"rev.eyebrow": "Отзиви",
"rev.restitutedBy": "Върнато от {org}",
"rev.storiesEyebrow": "Щастливи завършеци",
"rev.storiesSubtitle": "Истински истории от клиенти, които възвърнаха своите вещи с findloop.",
"rev.storiesTitle": "Те намериха своите вещи!",
"rev.subtitle": "Партньори и клиенти споделят своя опит.",
"rev.title": "Те се доверяват на Findloop",
"rev.verified": "Потвърдено",
"rp.already": "Вече сте съобщили за този списък.",
"rp.comment": "Детайли (по желание)",
"rp.duplicate": "Дубликат",
"rp.fraud": "Схема / измама",
"rp.inappropriate": "Неподходящо съдържание",
"rp.offensive": "Оскърбително съдържание",
"rp.other": "Друго",
"rp.reason": "Причина",
"rp.report": "Докладвай",
"rp.send": "Изпрати доклад",
"rp.sent": "Докладът е изпратен. Благодаря за приноса!",
"rp.spam": "Спам / реклама",
"rp.title": "Докладвай за тази обява",
"rp.wrongCategory": "Грешна категория",
"rt.annualGoal": "Годишна цел",
"rt.championCity": "Шампионски град",
"rt.cityRate": "{rate}% възвръщаемост",
"rt.goalProgress": "{rate}% постигнато от целта {target}%",
"rt.reached": "Постигнато 🎉",
"rt.restitutionRate": "Норма на възвръщаемост",
"rt.shareRecap": "Сподели обобщението ми",
"rt.thanks": "Благодаря ти, Findloop {year} 💛",
"rt.yourRecap": "Вашето обобщение за {year}",
"rw.active": "Активен",
"rw.add": "Добави",
"rw.camUnavailable": "Камерата не е налична. Въведи кода ръчно по-долу.",
"rw.codeValidated": "Кодът е валидиран",
"rw.codesTitle": "Кодовете, използвани от откривателите",
"rw.confirmDelete": "Изтриване на “{title}”?",
"rw.deleted": "Изтрито",
"rw.edit": "Редактиране",
"rw.editReward": "Редактиране на наградата",
"rw.empty": "Все още няма награда.",
"rw.expired": "Изтекло",
"rw.expiresOn": "Изтича на {date}",
"rw.fActive": "Активен (видим за откривателите)",
"rw.fCost": "Цена (точки)",
"rw.fDesc": "Описание",
"rw.fStock": "Налично (празно = неограничено)",
"rw.fTitle": "Заглавие",
"rw.fValidity": "Валидност на ваучера (дни след обмена)",
"rw.inactive": "Неактивен",
"rw.newReward": "Нова награда",
"rw.noExchange": "Все още няма обмен.",
"rw.pageSubtitle": "Сканирайте ваучерите, представени от откривателите, за да валидирате техните награди.",
"rw.redeemedN": "Изменени: {n}×",
"rw.saved": "Наградата е запазена",
"rw.scanVoucher": "Сканирай ваучер",
"rw.staffScanOnly": "Само сканиране",
"rw.statActive": "Да се представи",
"rw.statExpired": "Изтекло",
"rw.statRedeemed": "Ваучерите са обменени",
"rw.statUsed": "Валидирано",
"rw.stock": "Налично",
"rw.subtitle": "Предложете немонетарни привилегии (ваучери, надстройки…) които откривателите обменят за своите точки на Finder Score.",
"rw.title": "Награди за откриватели",
"rw.used": "Използвано",
"rw.validate": "Валидирайте",
"rw.validateCode": "Валидирайте кода",
"rw.validity": "Валидност: {n} д",
"shell.f1d": "Автоматично свързване на изгубени и намерени вещи.",
"shell.f1t": "Умен AI мачинг",
"shell.f2d": "Проследявайте процента на връщане и приходите в реално време.",
"shell.f2t": "Табло за управление и приходи",
"shell.f3d": "Вашите клиенти докладват за 30 секунди.",
"shell.f3t": "QR код на партньора",
"shell.title": "Превърнете изгубените вещи в доволни клиенти.",
"ship.addr1": "Адрес",
"ship.addr2": "Ред на адреса 2 (по желание)",
"ship.badge": "Доставка",
"ship.city": "Град",
"ship.country": "Държава",
"ship.needPaid": "Платете таксата за възстановяване първо, за да поискате доставка.",
"ship.notShippable": "Тази вещ не е налична за доставка.",
"ship.notfound": "Докладът не е намерен.",
"ship.postal": "Пощенски код",
"ship.price": "Такса за доставка",
"ship.submit": "Искайте доставка",
"ship.submitting": "Изпращам…",
"ship.subtitle": "Въведете адреса за доставка.",
"ship.successText": "Партньорът ще подготви вашия пакет. Ще бъдете уведомен, след като бъде изпратен.",
"ship.successTitle": "Искането за доставка е изпратено!",
"ship.title": "Имайте своя предмет изпратен",
"ship.weight": "Предполагаемо тегло (кг)",
"shp.carrier": "Куриер",
"shp.download": "Свалете PDF",
"shp.generating": "Генерирам…",
"shp.label": "Генериране на етикет",
"shp.none": "Не е поискана доставка.",
"shp.setTracking": "Запазете проследяване",
"shp.status": "Статус",
"shp.to": "Получател",
"shp.tracking": "Номер за проследяване",
"shp.trackingSaved": "Проследяването е запазено",
"side.account": "Моят акаунт",
"side.declarations": "Доклади",
"side.deposit": "Запишете вещ",
"side.establishments": "Заведения",
"side.invoices": "Фактури",
"side.logout": "Изход",
"side.matchHistory": "AI История",
"side.partner": "Партньор",
"side.refresh": "Освежи",
"side.registry": "Регистър",
"side.restitutions": "Възстановявания",
"side.reviews": "Отзиви",
"side.rewards": "Награди и ваучери",
"side.settings": "Настройки",
"side.shipments": "Пратки",
"side.stats": "Статистика",
"side.storage": "Склад и QR",
"side.team": "Екип",
"side.viewSite": "Преглед на публичния сайт",
"st.auctioned": "Продадено на аукцион",
"st.claimed": "Изисквано",
"st.closed": "Затворено",
"st.delivered": "Доставено",
"st.destroyed": "Унищожено",
"st.donated": "Дарено (благотворителност)",
"st.handed_to_authorities": "Предадено на органите",
"st.in_storage": "В склад",
"st.matched": "Намерен мач",
"st.open": "Отворено",
"st.paid": "Платено",
"st.pending": "В очакване",
"st.resolved": "Решено",
"st.restituted": "Върнато",
"st.second_chance": "Втора възможност",
"st.shipped": "Изпратено",
"st.shipping_requested": "Изпращането е поискано",
"st.submitted": "Подадено",
"st.verified": "Потвърдено",
"stat.items": "Регистрирани артикули",
"stat.partners": "Партньори",
"stat.restituted": "Върнати артикули",
"status.auctioned": "Продавано на търг",
"status.destroyed": "Унищожено",
"status.donated": "Дарено (на благотворителност)",
"status.handed_to_authorities": "Предадено на властите",
"status.in_storage": "В склад",
"status.matched": "Мач",
"status.open": "Отворено",
"status.paid": "Платено",
"status.pending": "В очакване",
"status.restituted": "Върнато",
"status.shipped": "Изпратено",
"status.shipping_requested": "Изпращането е поискано",
"status.submitted": "Подадено",
"step1.tag": "Установяване",
"step1.text": "За секунди, заведението регистрира намерения артикул с фото, категория и описание. Всичко е централизирано в ясен, сигурен регистър.",
"step1.title": "Партньорът регистрира артикула",
"step2.tag": "Клиент",
"step2.text": "Чрез QR кода на партньора, вашият клиент описва изгубения артикул за 30 секунди. Няма нужда да инсталирате приложение — всичко става в браузъра.",
"step2.title": "Клиентът докладва загубата",
"step3.tag": "Интелигентност",
"step3.text": "Нашият интелигентен мачинг енджин сравнява описанията и предлага най-вероятните мачове, готови за потвърждение.",
"step3.title": "AI свързва загубения и намерения артикул",
"step4.tag": "Възстановяване",
"step4.text": "След сигурно плащане на таксата за възстановяване, клиентът взима артикула на място — или го получава чрез проследено изпращане.",
"step4.title": "Клиентът получава артикула си",
"stg.allLabels": "Всички QR етикети",
"stg.camHint": "Използвайте ръчно въвеждане по-долу.",
"stg.camStarting": "Стартиране на камерата…",
"stg.camUnavailable": "Камерата не е налична.",
"stg.clear": "Изчисти",
"stg.clearAll": "Изчисти всичко",
"stg.codeUnreadable": "Неразбираем код.",
"stg.emptyDesc": "Съхранените артикули ще се появят тук, групирани по местоположение.",
"stg.emptyTitle": "Няма артикул в склада",
"stg.exportAudit": "Експорт на одит CSV",
"stg.exportDone": "CSV експортът е изтеглен",
"stg.exportImpossible": "Експортът не е наличен в момента.",
"stg.itemFound": "Намерен артикул ✅",
"stg.kLocations": "Използвани местоположения",
"stg.kObjects": "Съхранени артикули",
"stg.kToClear": "Местоположения за изчистване",
"stg.locFreed": "Местоположение изчистено",
"stg.locsFreed": "{n} местоположения(я) изчистени",
"stg.manualLabel": "Или въведете кода / ID на артикула",
"stg.manualPh": "Поставете ID или URL на QR",
"stg.noItemMatch": "Няма артикул, който съвпада с този QR / код.",
"stg.noLocation": "Няма местоположение",
"stg.objectsAxis": "Артикули",
"stg.objectsN": "{n} артикул(а)",
"stg.occAvg": "средно {n} артикула/местоположение",
"stg.occHint": "Местоположенията в оранжево надвишават средното (възможно претоварване).",
"stg.occupancy": "Запълняемост на местоположението",
"stg.openPage": "Отворете страницата",
"stg.posterPdf": "Плакат PDF (A4)",
"stg.printAll": "Разпечатайте всичко",
"stg.printGroupTitle": "Разпечатайте етикети за тази рафта",
"stg.qrAlt": "QR самостоятелно обслужване",
"stg.qrDownload": "Изтеглете QR",
"stg.qrHint": "Покажете този QR на гишето: клиентите ви го сканират, за да проверят дали артикулът им е наличен.",
"stg.qrTitle": "QR за самостоятелно обслужване на клиенти",
"stg.scanDesc": "Сканирайте етикета на артикула, за да отворите записа му незабавно.",
"stg.scanQr": "Сканирайте QR",
"stg.scanTitle": "Сканирайте QR код",
"stg.search": "Търсене",
"stg.shelf": "Рафтове {loc}",
"stg.shelfPlan": "План на рафта",
"stg.staleHint": "Изчистете тези местоположения, за да поддържате физическия си инвентар актуален.",
"stg.staleTitle": "{n} артикул(а) са напуснали склада, но все още заемат местоположение",
"stg.subtitle": "План на рафта, QR скенер и проследяване на физическия инвентар.",
"stg.title": "Склад и QR",
"stt.acceptRate": "Процент на приемане",
"stt.accepted": "Прието",
"stt.activity30": "Активност (последни 30 дни)",
"stt.ai6mo": "Последни 6 месеца · прието = автоматично съвпадение + потвърдено.",
"stt.aiEmpty": "Все още няма AI съвпадения за този период.",
"stt.aiTitle": "AI съвпадения — прието срещу отхвърлено",
"stt.auctionShort": "Аукцион",
"stt.auctionedSold": "Аукционирано (продадено)",
"stt.authShort": "Власти",
"stt.authorities": "Передадено на властите",
"stt.avgRating": "Средна оценка",
"stt.awaitingRestitution": "артикули в очакване на връщане",
"stt.boostClicks": "Кликвания в директорията ви тази седмица благодарение на усилването",
"stt.boostInactive": "Усилването е неактивно — активирайте го, за да спечелите видимост",
"stt.certifiedPremium": "Премиум сертифициран",
"stt.declarations": "Декларации",
"stt.destroyed": "Унищожен",
"stt.dispoEmpty": "Все още няма неопределен артикул, който да е напуснал склада.",
"stt.donatedAssoc": "Дарен (благотворителност)",
"stt.donatedShort": "Дарен",
"stt.gateCta": "Разгледайте плановете",
"stt.gateDesc": "Актуализирайте до Starter, за да отключите основната си статистика, или до Business за разширена статистика и анализ на всяко заведение.",
"stt.gateTitle": "Статистика, резервирана за платени планове",
"stt.inStorage": "В склада",
"stt.kItems": "Регистрирани артикули",
"stt.kRate": "Процент на връщане",
"stt.kRestituted": "Върнати артикули",
"stt.kRevenue": "Приходи (месец)",
"stt.noDeclYet": "Все още няма декларации.",
"stt.recapDownloaded": "Резюме изтеглено — готово за споделяне!",
"stt.recapError": "Не може да се генерира резюмето",
"stt.recapText": "Нашето Findloop {year} резюме: върнати артикули и удовлетвореност на клиентите 🎉",
"stt.recapTitle": "Findloop {year} резюме",
"stt.rejected": "Отхвърлено",
"stt.restitutions": "Връщания",
"stt.shareRecap": "Споделете моето {year} резюме",
"stt.topCategories": "Най-често заявените категории",
"stt.unclaimedDesc": "Обем на унищожените артикули, дарени на благотворителни организации и продадени на търгове, по категории.",
"stt.unclaimedTitle": "Незаявени артикули — напускане на съхранение",
"stt.vsLastWeek": "срещу миналата седмица",
"sub.cancel": "Отмени абонамента ми",
"sub.cancelAbort": "Отмени",
"sub.cancelConfirm1": "Сигурни ли сте, че искате да отмените? Вашият достъп остава активен до",
"sub.cancelConfirm2": "Няма да бъде извършено възстановяване.",
"sub.cancelConfirmBtn": "Потвърдете отмяната",
"sub.cancelTitle": "Отмяна на абонамента ви",
"sub.cancelledToast": "Отмяната е регистрирана.",
"sub.cguAnd": "и",
"sub.cguDesc": "Моля, потвърдете споразумението си преди плащане.",
"sub.cguLink": "Условия за ползване",
"sub.cguPay": "Продължи към плащане",
"sub.cguPre": "Прочел съм и приемам",
"sub.cguRequired": "Трябва да приемете Условията за ползване и Политиката за конфиденциалност, за да продължите.",
"sub.cguSuffix": "на Findloop.",
"sub.cguTitle": "Финализирайте абонамента си",
"sub.expiresOn": "Вашият абонамент изтича на",
"sub.noProrata": "Няма възстановяване на пропорционална база.",
"sub.privacyLink": "Политика за конфиденциалност",
"sub.renewsOn": "Вашият абонамент се подновява на",
"sub.resume": "Поднови абонамента",
"sub.resumedToast": "Подновяването е потвърдено.",
"tier.free": "Фриймум",
"tier.large": "Ентерпрайз",
"tier.medium": "Бизнес",
"tier.small": "Стартов",
"tm.add": "Добави",
"tm.adminOpt": "Админ (пълен преглед)",
"tm.chooseEst": "Изберете заведение",
"tm.chooseEstPh": "Изберете заведение",
"tm.copyFail": "Копирането неуспешно",
"tm.copyLink": "Копирайте линка",
"tm.copyOk": "Линк за покана копиран",
"tm.emailHint": "Имейл с покана ще бъде изпратен, за да създадете парола.",
"tm.expiresOn": "изтича на {date}",
"tm.forEmail": " за {email}",
"tm.forbidden": "Управлението на екипа е запазено за собственика на акаунта.",
"tm.inviteCreated": "Поканата е създадена",
"tm.inviteDesc": "Имейл с покана позволява на члена на екипа да създаде своята парола.",
"tm.invitePending": "Изчакваща покана",
"tm.inviteResent": "Поканата е изпратена отново",
"tm.inviteSent": "Поканата е изпратена по имейл",
"tm.inviteTitle": "Поканете член",
"tm.invitedOn": "Поканен на {date}",
"tm.linkExpired": "Линкът е изтекъл",
"tm.memberRemoved": "Членът е премахнат",
"tm.name": "Име",
"tm.noMembers": "Още няма членове на екипа.",
"tm.resendTitle": "Изпрати поканата отново",
"tm.role": "Роля",
"tm.roleAdmin": "Админ",
"tm.roleOwner": "Собственик",
"tm.roleStaff": "Персонал",
"tm.roleUpdated": "Ролята е актуализирана",
"tm.sendInvite": "Изпратете поканата",
"tm.sending": "Изпраща се…",
"tm.staffOpt": "Персонал (вижда само своето заведение)",
"trk.at": "В",
"trk.badge": "Проследяване",
"trk.carrier": "Превозвач",
"trk.codeValidated": "Кодът е валидиран от партньора",
"trk.dlProof": "Изтеглете моето удостоверение за предаване (PDF)",
"trk.emailLabel": "Имейл (по избор — за да видите данните си)",
"trk.enterEmailCode": "Въведете имейла си по-горе, за да видите кода за претенция.",
"trk.idLabel": "Номер на доклада",
"trk.lostEmail": "Вече нямам достъп до имейла си",
"trk.phonePh": "Вашият телефонен номер",
"trk.photoBefore": "Снимка на артикула преди изпращане",
"trk.recoverBtn": "Възстановете артикула ми",
"trk.recoverHint": "Получете кода за претенция чрез SMS на регистрирания номер.",
"trk.searching": "Търсене…",
"trk.secureRest": "Сигурно предаване",
"trk.send": "Изпрати",
"trk.shipPending": "Пратката се подготвя — номерът за проследяване ще се появи тук след изпращане.",
"trk.shipTitle": "Проследяване на пратката",
"trk.showQr": "Покажете този QR на партньора, за да валидирате предаването",
"trk.sigSaved": "Подписът е запазен",
"trk.signFirst": "Моля, подпишете преди потвърждаването.",
"trk.signProof": "Подпишете вашето удостоверение за предаване",
"trk.signSubmit": "Потвърдете подписа си и генерирайте PDF",
"trk.submit": "Проследяване",
"trk.subtitle": "Въведете номера на доклада си, за да проследите напредъка.",
"trk.title": "Проследете моя доклад",
"trk.trackShipment": "Проследяване на пратка",
"trk.trackingNo": "Номер за проследяване",
"trk.yourCode": "Вашият код за претенция (за даване на партньора)",
"a.firstName": "Име",
"ac.emailCrossMatch": "B2C съвпадения",
"ac.emailCrossMatchDesc": "Имейл, когато публичната обява за изгубен предмет съвпада с предмет, депозиран при вас",
"ac.emailCrossReject": "Откази на публични съвпадения",
"ac.emailCrossRejectDesc": "Получавайте имейл, когато клиент посочи, че предложеното публично съвпадение не е техен предмет.",
"ac.emailLoginNotif": "Уведомление за вход",
"ac.emailLoginNotifDesc": "Получавайте имейл всеки път, когато някой влезе в акаунта ви.",
"ad.closeNoCancel": "Не, премахнете обявата",
"ad.closeQuestion": "Върнат ли е предметът?",
"ad.closeQuestionDesc": "Уведомете ни дали сте получили предмета си обратно, или просто искате да премахнете тази обява.",
"ad.closeYesRestituted": "Да, предметът беше върнат",
"ad.closedRestituted": "Предметът е върнат — обявата е затворена 🎉",
"an.lostLoginDesc": "Изисква се акаунт за докладване на изгубен предмет и проследяване на връщането му.",
"an.lostLoginRequired": "Влезте, за да докладвате изгубен предмет",
"an.qfAll": "Всички",
"an.qfBoosted": "Ускорени",
"an.qfPhoto": "Снимка",
"an.qfRecent": "Тази седмица",
"an.qfResolved": "Разрешени",
"an.restitutionInProgress": "Предметът се връща",
"dec.descPhLong": "Опишете предмета: марка, цвят, отличителни знаци… (Колкото повече детайли дадете, толкова по-високи са шансовете ви да възстановите предмета)",
"dec.loadError": "Невъзможно е да се зареди партньорът в момента. Проверете връзката си и опитайте отново.",
"dec.retry": "Опитайте отново",
"dec.shippingMode": "Доставка",
"dep.photo2": "Снимка на втория предмет",
"dep.photo2Hint": "По избор — друг ъгъл подобрява точността на визуалното съвпадение.",
"dl.accountSuspended": "Акаунтът еSuspended за неплатена фактура. Уредете го, за да възстановите достъпа си.",
"dl.regularize": "Суредете сега →",
"dl.suspensionCountdown": "Фактура {num} неплатена — вашият акаунт ще бъдеSuspended след {days} ден(дни). Уредете го, за да избегнете това.",
"ft.cancelConfirm": "Да отменя доклада си? Собственикът на предмета ще бъде уведомлен.",
"ft.cancelDone": "Докладът е отменен.",
"ft.cancelLocked": "Отмяната вече не е възможна след като собственикът е платил.",
"ft.cancelReport": "Отмена на доклада ми",
"ft.claimCodeHelp": "Дайте този код на намерителя при предаването, за да потвърдите, че сте получили предмета си.",
"ft.claimCodeTitle": "Вашият код за възстановяване",
"ft.claimDone": "Предметът е върнат. Благодаря, че използвате Findloop!",
"ft.claimUnlockHint": "Разблокирайте детайлите за контакт на намерителя",
"ft.claimUnlockHintSub": "Отидете на \"Предмети, които заявявам\" в акаунта си, за да платите таксата и да получите детайлите за контакт.",
"ft.finderCodeShownHelp": "Собственикът е платил и ви е избрал. Копирайте този код по-долу, за да потвърдите връщането — не е нужно да проверявате имейла си.",
"ft.finderCodeShownTitle": "Код за верификация от собственика",
"hc.analyzing": "Анализиране…",
"hc.andRecoveryIs": "и възстановяването е",
"hc.andTheDeclarationWillBe": "и декларацията ще бъде затворена (преместена в историята). Това действие е окончателно.",
"hc.annual20": "Годишен -20%",
"hc.annualBilling20": "Годишно таксуване (−20%)",
"hc.annualTarget": "Годишна цел",
"hc.anyCommentsOptional": "Имате ли коментари? (по желание)",
"hc.approveTheClaim": "Одобрете искането",
"hc.archiveCancelledConfirm": "Да архивирам {n} обяви \"Отменено от клиента\"? Те ще бъдат премахнати от регистъра.",
"hc.asSoonAs": "Възможно най-скоро",
"hc.askTheOwnerToDisplay": "Помолете собственика да покаже QR кода на своята страница за проследяване.",
"hc.askThemAtTheCounter": "Помолете ги на бюрото да потвърдят самоличността — никога не бъдете публично видими.",
"hc.assistance": "Поддръжка",
"hc.assistanceSessionRevoked": "Сесията по поддръжка е отменена.",
"hc.atLeast6Characters": "Най-малко 6 знака",
"hc.automaticallyPreSelected": "автоматично предварително избрано",
"hc.automaticallyWhenShipping": "автоматично при обработка.",
"hc.awaitingClaim": "Очаква се искане",
"hc.awaitingPayment": "Очаква се плащане",
"hc.b2cCustomer": "B2C клиент",
"hc.back": "Назад",
"hc.backToHome": "Назад в началото",
"hc.backToMyAccount": "Назад в моя акаунт",
"hc.backToPayment": "Назад към плащането",
"hc.beforeAfterComparisonSlider": "Слайдер за сравнение преди/след",
"hc.billingInformation": "Информация за фактуриране",
"hc.billingInformationSaved": "Информацията за фактуриране е запазена ✓",
"hc.brand": "Марка",
"hc.bronze": "Бронз",
"hc.calculatingTheShippingRate": "Изчисляване на цената за доставка…",
"hc.cameraUnavailableEnterTheCode": "Камерата не е достъпна. Въведете кода ръчно.",
"hc.cancel": "Отмяна",
"hc.cancelMyDeclaration": "Отмяна на моята декларация",
"hc.cancelSavedFmt": "Отмяната е запазена: \"{reason}\". Все още можете да направите искане.",
"hc.cancelTheDeposit": "Отмяна на депозита",
"hc.cancelThisMatch": "Отмяна на този мач",
"hc.cancellationReason": "Причина за отмяна",
"hc.cancelled": "Отменено",
"hc.cancelledByTheCustomer": "Отменено от клиента",
"hc.cannotOpenPayment": "Неуспешно отваряне на плащането. Моля, опитайте отново.",
"hc.careers": "Кариери",
"hc.carrier": "Товарен оператор",
"hc.carrierAvailabilityCannotBeChecked": "Наличността на товарния оператор не може да бъде проверена, докато вашият изпращач Sendcloud не е конфигуриран.",
"hc.carrierConfirmedCharged": "Товарният оператор е потвърдил — {price} € таксувани на клиента",
"hc.carrierOther": "Товарен оператор (друг)",
"hc.carrierSelection": "Избор на товарен оператор",
"hc.caseClosedThankYou": "Случаят е затворен. Благодаря!",
"hc.category": "Категория",
"hc.changeMethod": "Смяна на метода",
"hc.characteristic": "Характеристика",
"hc.chargedToCustomer": "таксувано на клиента.",
"hc.checkOrEditYourDetails": "Проверете или редактирайте данните си преди сигурното плащане.",
"hc.checkStatisticsToTrackDeposited": "Проверете \"Статистика\", за да проследите депозитите, процента на връщане и представянето на всяко заведение.",
"hc.checkTheDetailsBeforeContacting": "Проверете детайлите, преди да се свържете с намиращия.",
"hc.checkTheDetailsBelowBefore": "Проверете детайлите по-долу, преди да започнете вашето искане за връщане.",
"hc.checkTheNewItem": "Проверете новия артикул",
"hc.checkThePhotosAndCharacteristics": "Проверете снимките и характеристиките по-долу, преди да продължите с възстановяването.",
"hc.chooseACountry": "Изберете страна",
"hc.chooseANewPassword": "Изберете нова парола",
"hc.chooseAReason": "Изберете причина",
"hc.chooseTheLegalRetentionAlerts": "Изберете законовите уведомления за задържане, получавани по имейл за",
"hc.chooseYourPasswordToAccess": "Изберете паролата си за достъп до консолата на администрацията.",
"hc.city": "Град",
"hc.claimApproved": "Искът е одобрен",
"hc.claimApproved2": "Искът е одобрен.",
"hc.claimCodeExpired": "Кодът за иск е изтекъл",
"hc.claimCodeVerified": "Кодът за иск е проверен",
"hc.claimNotFound": "Искът не е намерен",
"hc.claimNotValidated": "Искът не е валидиран",
"hc.claimRejected": "Искът е отхвърлен",
"hc.claimRejected2": "Искът е отхвърлен.",
"hc.claimValidated": "Искът е валидиран",
"hc.claimValidatedByThePartner": "Искът е валидиран от партньора",
"hc.claimant": "Заявител",
"hc.claimsToBeTheOwner": "твърди, че е собственик на този артикул и е отговорил на въпросите за проверка. Одобрете само ако отговорите съвпадат.",
"hc.claimsToValidate": "Искания за валидиране",
"hc.clear": "Изчисти",
"hc.clickToZoom": "Кликнете, за да увеличите",
"hc.close": "Затвори",
"hc.close2": "Затвори",
"ft.finderContactsTitle": "Данни за контакт с Finder",
"ft.foundCodeHelp": "Покажете този код на собственика при предаването, за да потвърдите, че предметът е върнат.",
"ft.inProgressOther": "Предмет в процес на връщане",
"ft.inProgressOtherHelp": "Собственикът е избрал друг находчик за този предмет. Няма нужда от допълнителни действия от ваша страна.",
"ft.restitutionCodeHelp": "Този код потвърджава предаването на предмета. Вече е попълнен по-долу; валидирайте го и след това затворете случая.",
"ft.restitutionCodeTitle": "Вашият код за възстановяване",
"hc.14Digits": "14 цифри",
"hc.15DaysBeforeAnItem": "15 дни преди законния срок на предмета.",
"hc.7DaysBeforeAnItem": "7 дни преди законния срок на предмета.",
"hc.8CharactersMinimum": "Минимум 8 символа.",
"hc.aClaimToValidate": "Искане за валидиране",
"hc.aFindoAssistanceSessionIs": "Сесия за помощ от Findloop в момента е активна на вашия акаунт.",
"hc.aNewMatchHasBeen": "Ново съвпадение е намерено",
"hc.aUser": "Потребител",
"hc.aUserClaimsToBe": "Потребител твърди, че е собственик. Проверете техните отговори преди да одобрите връщането.",
"hc.aboutFindo": "За Findloop",
"hc.accountActivatedPleaseLogIn": "Акаунтът е активиран, моля влезте.",
"hc.accountActivation": "Активиране на акаунт",
"hc.accountCreated": "Акаунтът е създаден!",
"hc.accountDeactivatedAReactivationEmail": "Акаунтът е деактивиран. Имейл за реактивиране (валиден за 30 дни) е изпратен до вас.",
"hc.accountReactivation": "Реактивиране на акаунт",
"hc.activateMyAccount": "Активирайте моя акаунт",
"hc.activateMyAdminAccount": "Активирайте моя администраторски акаунт",
"hc.activating": "Активиране…",
"hc.activeMatchCancelReason": "Активно съвпадение. Причина за отказ от клиента: \"{reason}\". Предметът все още очаква искане.",
"hc.activeMatchWithAPublic": "Активно съвпадение с публично (клиентско) обявление. Изчаква се искането на собственика.",
"hc.addAPhoto": "Добавете снимка",
"hc.addAndConfigureYourEstablishments": "Добавете и конфигурирайте вашите заведения в \"Заведения\": данни за контакт, категория и физическо съхранение на предмети.",
"hc.addOnGoogle": "Добавете в Google",
"hc.address": "Адрес",
"hc.addressSaved": "Адресът е запазен",
"hc.addressStreet": "Адрес — Улица",
"hc.adjustThePhoto": "Регулирайте снимката",
"hc.adminFullView": "Администратор (пълен изглед)",
"hc.administratorOnly": "Само за администратори",
"hc.africa": "Африка",
"hc.aiVisualComparison": "AI визуално сравнение",
"hc.all": "Всички",
"hc.amount": "Сума",
"hc.anOrganization": "Организация",
"hc.closeTheDeclaration": "Затвори декларацията",
"hc.closeTheDeclaration2": "Затвори декларацията?",
"hc.codeAlreadyVerified": "Кодът вече е потвърден",
"hc.codeCopied": "Кодът е копиран",
"hc.collapse": "Сгъни",
"hc.color": "Цвят",
"hc.company": "Компания",
"hc.companyName": "Име на компания",
"hc.comparePhotos": "Сравни снимки",
"hc.compareThemWithTheOwner": "Сравнете ги с отговорите на собственика — никога не е публично видимо.",
"hc.condition": "Състояние",
"hc.confirmAndPay": "Потвърдете и платете",
"hc.confirmCancellation": "Потвърдете анулирането",
"hc.confirmCrop": "Потвърдете изрязването",
"hc.confirmDeletion": "Потвърдете изтриването",
"hc.confirmPassword": "Потвърдете паролата",
"hc.confirmThatThisIsYour": "Потвърдете, че това е вашият артикул. Проверка на идентичността ще бъде поискана от откривателя преди контакт.",
"hc.confirmTheCarrier": "Потвърдете превозвача",
"hc.confirmThePassword": "Потвърдете паролата",
"hc.confirmYourShippingAddressTo": "Потвърдете адреса за доставка, за да продължите с плащането.",
"hc.confirmYourSubscription": "Потвърдете абонамента си",
"hc.confirmed": "Потвърдено ✓",
"hc.contactFindoToGetYour": "Свържете се с Findloop, за да получите вашия идентификатор на подателя.",
"hc.contactUs": "Свържете се с нас",
"hc.continueTheReturn": "Продължете с връщането",
"hc.continueToPayment": "Продължете към плащането",
"hc.copy": "Копирай",
"hc.correctMyDetails": "коригирайте моите данни",
"hc.correctThisEntry": "Коригирайте ли това запис?",
"hc.country": "Държава",
"hc.countryAddress": "Държава (адрес)",
"hc.countryIsoCodeEG": "Държава (ISO код, напр. FR)",
"hc.cover": "покритие",
"hc.createTheShipment": "Създаване на пратката",
"hc.cropThePhoto": "Изрежете снимката",
"hc.customer": "Клиент",
"hc.customerClaimCodeToCheck": "Клиентски код за иск — за проверка при вземане:",
"hc.customerReasonFmt": "Причина на клиента: \"{reason}\".",
"hc.customerReminderDelay": "Закъснение за напомняне на клиента",
"hc.customerWhosePublicListingMatches": "Клиент, чийто публичен списък съвпада с този артикул — видимо само за вас.",
"hc.d15": "D-15",
"hc.dangerZone": "Опасна зона",
"hc.date": "Дата",
"hc.dateNewest": "Дата (най-нови)",
"hc.dateOldest": "Дата (най-стари)",
"hc.daysToYearEnd": "{n} дни до края на годината",
"hc.deadlineAlert": "Предупреждение за краен срок",
"hc.declarationClosed": "Декларацията е затворена ✓",
"hc.declarationNotFound": "Декларацията не е намерена.",
"hc.declarationNotFound2": "Декларацията не е намерена",
"hc.declarationTracking": "Проследяване на декларация",
"hc.defaultCarrier": "Основен превозвач",
"hc.defaultCarrierPreselected": "Основният превозвач е предварително избран — може да бъде променен за тази пратка. Актуална ставка (Sendcloud + {m}% надбавка).",
"hc.defaultCarrierRemoved": "Основният превозвач е премахнат",
"hc.delayHours": "Закъснение (часове)",
"hc.deleteMyAccount": "Изтрий акаунта ми",
"hc.deleting": "Изтриване…",
"hc.deletingDeactivatesYourAccountLogin": "Изтриването деактивира вашия акаунт: входът е блокиран и данните се съхраняват за 30 дни. Ще получите имейл с линк за реактивация, валиден за 30 дни.",
"hc.delivered": "Доставено",
"hc.depositAnItem": "Депозит на артикул",
"hc.depositCancelledItemPutBack": "Депозитът е отменен — артикулът е върнат в наличност.",
"hc.depositCancelledItemRemovedFrom": "Депозитът е отменен — артикулът е премахнат от регистъра.",
"hc.depositedOn": "Депозиран на",
"hc.describeTheItemBrandColor": "Опишете артикула: марка, цвят, характерни знаци… (Колкото повече подробности предоставите, толкова по-добри са шансовете ви да намерите артикула си)",
"hc.dimensionsCm": "Размери (см)",
"hc.disablingAnEmail": "Деактивиране на имейл",
"hc.doesNotHide": "не крие",
"hc.download": "Изтегли",
"hc.downloadThePdf": "Изтегли PDF",
"hc.draftRestoredPickUpYour": "Чернова възстановена — вземете декларацията си от мястото, на което я оставихте.",
"hc.dragToReposition": "Плъзнете за да промените позицията",
"hc.eGColisPriv": "Пример: Colis Privé",
"hc.eachItemGetsAQr": "Всеки артикул получава QR етикет. Сканирайте го от \"Склад & QR\", за да локализирате артикул за секунди.",
"hc.eachSiteManagesItsOwn": "Всеки сайт управлява собствените си банкови операции. Отидете на",
"hc.edit": "Редактиране",
"hc.emailNotificationPreferences": "Предпочитания за имейл известия",
"hc.emailPreferencesUpdated": "Предпочитанията за имейл са актуализирани",
"hc.enableOrDisableRecoveryFees": "Активирайте или деактивирайте таксите за възстановяване за",
"hc.enlargePhoto": "Увеличете снимката",
"hc.enterTheCustomerSCode": "Въведете кода на клиента",
"hc.estShipRate": "Оценена цена на доставка (Sendcloud + {m}% надбавка):",
"hc.establishment": "Заведение",
"hc.establishment2": "Заведение:",
"hc.establishmentInItsSendcloudAccount": "заведение в акаунта си в Sendcloud и ви дава ID на подателя",
"hc.establishmentSettings": "Настройки на заведението",
"hc.exCode": "напр. ABCD2345",
"hc.exId": "напр. 3f2a…",
"hc.exit": "Изход",
"hc.explainWhyThisItemIs": "Обяснете защо този предмет не е ваш…",
"hc.externalPaymentLinks": "Външни платежни връзки",
"hc.failed": "Неуспешно",
"hc.feesEnabled": "Таксите са активирани",
"hc.field": ") поле.",
"hc.finderAcceptedCloseTheCase": "Finder приет — затворете случая след като предметът е предаден лично.",
"hc.findoCityRanking": "Findloop — Ранг на градовете",
"hc.findoForEstablishments": "Findloop за заведения",
"hc.findoPresentationVideo": "видео за представяне на Findloop",
"hc.findoRegistersTheAddressOf": "Findloop регистрира адреса на вашето",
"hc.findoReviewShare": "Findloop {year} ревю: {n} върнати предмета, {rate}% процент на връщане 🎉",
"hc.firstVerifyTheClaimCode": "Първо потвърдете кода за иск",
"hc.forEveryNewShipmentFrom": "за всяка нова пратка от",
"hc.free": "безплатно",
"hc.freeRecovery0": "Безплатно възстановяване (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Безплатно възстановяване в цяла Африка – Начална оферта",
"hc.freeRecoveryFeesDisabled0": "Безплатно възстановяване: таксите са деактивирани (0 €)",
"hc.fromTeamInviteYourColleagues": "От \"Отбор\", поканете колегите си по имейл и им присвойте заведение. Всеки член вижда само своя обхват.",
"hc.fullName": "Пълно име",
"hc.fullPhoto": "Пълен снимка",
"hc.gallery": "Галерия",
"hc.giveTheReasonForCancelling": "Дайте причина за анулиране. Партньорът ще бъде уведомлен.",
"hc.goToLogin": "Отидете на вход",
"hc.goToMyAccount": "Отидете на моя акаунт",
"hc.gold": "Златен",
"hc.googleLoginFailed": "Неуспешно влизане с Google",
"hc.hasConfirmedYourPaymentYou": "е потвърдил вашето плащане, ще бъдете автоматично пренасочени",
"hc.helpCenter": "Център за помощ",
"hc.helpUsImproveWhyAre": "Помогнете ни да подобрим: защо си тръгвате? Вашият акаунт ще бъде деактивиран и може да бъде повторно активиран за 30 дни.",
"hc.hidePassword": "Скрий паролата",
"hc.high": "Висок",
"hc.historyOfYourMonthlySubscriptions": "История на вашите месечни абонаменти и тяхното статус на плащане.",
"hc.hotelBelmont": "Хотел Белмонт",
"hc.howConfigureSenderId": "Как да настроя моя числов Sender ID?",
"hc.iDonTUseIt": "Не го използвам достатъчно",
"hc.iFoundItElsewhere": "Намерих го на друго място",
"hc.iNoLongerNeedMy": "Вече не ми трябва моята вещ",
"hc.identityVerification": "Потвърждение на идентичността",
"hc.idleLogoutIn": "Ще бъдете излогнати след {n} секунди поради неактивност.",
"hc.ifProvidedTheVolumetricWeight": "Ако е предоставено, обемното тегло се използва.",
"hc.ifThePartnerHasNot": "Ако партньорът не е потвърдил получаването на външното плащане след тази забавена, Findloop автоматично напомня на партньора да го валидира.",
"hc.impersonationEnded": "Имитиране приключи.",
"hc.impersonationMode": "Режим на имитиране",
"hc.impersonationSessionExpired": "Сесията по имитиране изтече.",
"hc.inTheField": ", на терен",
"hc.inTransit": "В транзит",
"hc.inclVat": "вкл. ДДС",
"hc.intraEuVatNumberOptional": "Вътре-ЕС ДДС номер по избор, не се изисква SIRET (извън Франция).",
"hc.invalidInvitationLink": "Невалиден линк за покана.",
"hc.invalidInvitationLink2": "Невалиден линк за покана",
"hc.invalidInviteLink": "Невалиден или изтекъл линк за покана.",
"hc.invalidNumberEnterAnInternational": "Невалиден номер. Въведете международен номер, например +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Невалиден или изтекъл линк.",
"hc.invalidOrExpiredReactivationLink": "Невалиден или изтекъл линк за реактивация",
"hc.invalidSendcloudId": "Невалиден Sendcloud ID",
"hc.inviteSubtitle": "{org} ви кани да се присъедините към техния екип на findloop. Изберете паролата си, за да активирате акаунта си.",
"hc.isAvailableOnSendcloudFor": "е наличен на Sendcloud за всички ваши маршрути (вътрешен + международен).",
"hc.isNotEnabledOnYour": "не е активиран на вашия Sendcloud акаунт за някои дестинации. Етикети за тях ще бъдат генерирани с друг наличен превозвач.",
"hc.isThisReallyYourItem": "Това ли наистина е вашата вещ?",
"hc.isThisYourItem": "Това ли е вашата вещ?",
"hc.item": "Вещ",
"hc.itemAlreadyConfirmed": "Вещта вече е потвърдена",
"hc.itemDetails": "Детайли за вещта",
"hc.itemFoundAt": "Вещта е намерена на",
"hc.itemFoundAtAPartner": "Вещта е намерена при партньор",
"hc.itemMarkedAsReturned": "Вещта е обозначена като върната ✓",
"hc.itemPhotoRequiredBeforeShipping": "Снимка на вещта (изисква се преди изпращане)",
"hc.itemPhotoSaved": "Снимката на вещта е запазена",
"hc.itemPreview": "Предварителен преглед на вещта",
"hc.itemPutBackInStorage": "Вещта е върната в склада.",
"hc.itemWeight": "Тегло на вещта:",
"hc.itemsReturned": "вещи(и) върнати",
"hc.itemsReturnedThisYear": "върнати артикули тази година",
"hc.itemsWhoseLegalDeadlineIs": "Артикули, чийто правен срок е 15 дни или по-малко (включително просрочени). Съответствията остават видими.",
"hc.kbisNumber": "Номер Kbis",
"hc.keysForgottenOnABench": "Ключове забравени на пейка",
"hc.labelBeingGenerated": "Етикет се генерира",
"hc.leaveTheFieldsEmptyTo": "Оставете полетата празни, за да предложите възстановяване безплатно.",
"hc.legalNotice": "Правно известие",
"hc.limitReachedUpgradeToA": "Достигнат лимит — надстройте до по-висок план",
"hc.linkCopiedShareOn": "Линкът е копиран — споделете го в {label}",
"hc.linkUnavailable": "Линкът не е наличен",
"hc.linkedTo": "Свързано с",
"hc.listingHiddenByModeration": "Обявата е скрита от модерация.",
"hc.loading": "Зареждане…",
"hc.locateMe": "Намери ме",
"hc.logIn": "Вход",
"hc.logInToGetBack": "Влезте, за да се върнете в пространството си и да управлявате абонамента си.",
"hc.loginFailed": "Влизането не успя",
"hc.lostFoundPlatform": "Платформа за загубени и намерени вещи.",
"hc.lostIn": "загубен в",
"hc.lowRate": "Ниска тарифа",
"hc.mainReason": "Основна причина",
"hc.mainStreet": "Главна улица",
"hc.makeSureThisIsThe": "Уверете се, че това е артикулът, който загубихте, преди да отключите данните за контакт на намиращия.",
"hc.manageCookies": "Управление на бисквитки",
"hc.manageMyTeam": "Управление на моя екип",
"hc.manageYourTeam": "Управление на вашия екип",
"hc.markAsReturned": "Маркирайте като върнат",
"hc.matchNoClaimInTime": "Съответствието не е получило искане в срок.",
"hc.matchNotFound": "Съответствие не е намерено",
"hc.medium": "Среден",
"hc.milestoneFmt": "{m} върнати артикули — достигнат важен етап! На път към {next}.",
"hc.missingFeatures": "Липсващи функции",
"hc.monthly": "Месечно",
"hc.monthlyBilling": "Месечна фактура",
"hc.moveThePhotoToFit": "Преместете снимката, за да я поставите в кръга.",
"hc.myAccount": "Моят акаунт",
"hc.myInvoices": "Моите фактури",
"hc.myMonthlyInvoices": "Моите месечни фактури",
"hc.nArchived": "{n} обяви архивирани.",
"hc.newCodeGeneratedAndSent": "Нов код генериран и изпратен на клиента по имейл и SMS",
"hc.newCodeGeneratedAndSent2": "Нов код генериран и изпратен на собственика",
"hc.newPassword": "Нова парола",
"hc.next": "Следващ",
"hc.nextPhoto": "Следваща снимка",
"hc.no": "Не",
"hc.noAnswerProvided": "Не е предоставен отговор.",
"hc.noArchivedDeclarations": "Няма архивирани декларации",
"hc.noCountryFound": "Няма намерена държава",
"hc.noDeclarations": "Няма декларации",
"hc.noFeesAreChargedTo": "Не се начисляват такси на клиента.",
"hc.noInvoiceYet": "Все още няма фактура.",
"hc.noInvoiceYetYourInvoices": "Все още няма фактура. Вашите фактури ще се появят тук автоматично след всяко плащане.",
"hc.noMatchIsAvailableFor": "Не е налично съвпадение за сега. Ще ви уведомим веднага щом се появи съвпадение с вашата декларация.",
"hc.noShipmentMatchesYourSearch": "Няма пратки, които да отговарят на вашето търсене.",
"hc.noShipmentsYet": "Все още няма пратки.",
"hc.noShipmentsYet2": "Все още няма пратки",
"hc.none": "няма",
"hc.noneChooseForEachShipment": "Няма (изберете за всяка пратка)",
"hc.notMine": "Не е моя",
"hc.of": "на",
"hc.only": "Само",
"hc.onlyEachSiteManagesIts": "само. Всеки сайт управлява собствената си банка: тези линкове не влияят на другите заведения.",
"hc.onlyTheOwnerOrAn": "Само собственикът или администратор може да конфигурира платежните линкове на заведението.",
"hc.openDepositInTheMenu": "Отворете \"Депозит\" в менюто, опишете артикула и направете снимка. Тя веднага се съхранява и е готова за връщане.",
"hc.openSettings": "Отворете Настройки →",
"hc.openTheDeclarationToManage": "Отворете декларацията, за да управлявате пратката",
"hc.optional": "— по избор",
"hc.optional2": "(по избор)",
"hc.optional3": "по избор",
"hc.originalListingPhotoUsed": "Използвана оригинална снимка на обявата",
"hc.other": "Друг",
"hc.other2": "Други…",
"hc.ourProducts": "Нашите продукти",
"hc.overallRateTrendLast6": "Обща тенденция на цените (последни 6 месеца)",
"hc.ownerSClaimCode": "Код за иск на собственика",
"hc.ownershipConfirmed": "Собствеността е потвърдена",
"hc.paid": "Платено",
"hc.paidOn": "Платено на",
"hc.paidViaPartner": "Платено (чрез партньор)",
"hc.parcelBeingPrepared": "Пакетът се подготвя",
"hc.parcelDelivered": "Пакетът е доставен",
"hc.parcelShipped": "Пакетът е изпратен",
"hc.parisGareDeLyon": "Париж, Гар дьо Лион…",
"hc.partner": "Партньор",
"hc.partner2": "партньор",
"hc.partnerDirectory": "Директория на партньори",
"hc.passedOnToTheCustomer": "— изпратен на клиента линк за плащане.",
"hc.password": "Парола",
"hc.passwordResetPleaseLogIn": "Нулиране на парола, моля влезте.",
"hc.passwordUpdated": "Паролата е обновена.",
"hc.passwordsDoNotMatch": "Паролите не съвпадат.",
"hc.pasteThisSenderIdIn": "Поставете този идентификатор на подател в Findloop → Настройки",
"hc.payForTheShipmentOf": "Платете за изпращането на вашия артикул чрез Findloop с безопасно плащане.",
"hc.payTheRecoveryFees": "Платете таксите за възстановяване",
"hc.payTheShippingFees": "Платете таксите за доставка",
"hc.payment": "Плащане",
"hc.paymentAlreadyConfirmedByThe": "Плащането вече е потвърдено от партньора",
"hc.paymentLinksAreNowConfigured": "Линковете за плащане сега са конфигурирани по заведение",
"hc.paymentNotCompletedYourAccount": "Плащането не е завършено, вашият акаунт не е създаден — моля, опитайте отново.",
"hc.paymentReceived": "Плащането е получено",
"hc.paymentSuccessful": "Плащането е успешно!",
"hc.pdfInvoice": "PDF фактура",
"hc.pending": "В очакване",
"hc.period": "Период",
"hc.phoneNumber": "Телефонен номер",
"hc.phoneOptional": "Телефон (по избор)",
"hc.planAt": "план на",
"hc.planLimitFmt": "Вашият план \"{plan}\" е ограничен до {max} заведения. За управление на {n} сайта, препоръчваме",
"hc.platformReturnTarget": "Цел за връщане на платформата",
"hc.pleaseCompleteYourShippingAddress": "Моля, попълнете адреса за доставка.",
"hc.pleaseProvideAPhoneNumber": "Моля, предоставете телефонен номер: той е необходим от куриера за доставка.",
"hc.pleaseProvideAReason": "Моля, предоставете причина.",
"hc.pleaseSetYourOwnPassword": "моля, задайте своя парола преди да продължите.",
"hc.pointsToGoal": "{n} точки, за да достигнем нашата обща цел.",
"hc.posterPreview": "Преглед на постера",
"hc.potentialMatchBeingVerified": "Потенциално съвпадение се проверява",
"hc.potentialOwner": "Потенциален собственик",
"hc.preFilledAutomaticallyYouCan": "Попълнено автоматично — можете да го замените с изображение на пакета.",
"hc.pressKit": "Прес-кит",
"hc.previewMode": "Режим на преглед:",
"hc.previewOfThePrintReady": "Преглед на готовия за печат A4 плакат за това заведение.",
"hc.previous": "Предишен",
"hc.previousPhoto": "Предишна снимка",
"hc.primary": "основен",
"hc.printThePoster": "Отпечатай плаката",
"hc.privacy": "Поверителност",
"hc.privacyPolicy": "Политика за поверителност",
"hc.processedCasesWillAppearHere": "Обработените случаи ще се появят тук.",
"hc.proofOfReturnPdf": "Доказателство за връщане (PDF)",
"hc.protectedByRecaptcha": "Защитено от reCAPTCHA",
"hc.publicMatch": "Публично съвпадение",
"hc.putBackInStorage": "Върни обратно в склад",
"hc.pwdResetByTeam": "Вашата парола беше нулирана от нашия екип. За ваша безопасност,",
"hc.questionsToAskTheOwner": "Въпроси за задаване на собственика",
"hc.rateChargedToTheCustomer": "Такса, начислена на клиента:",
"hc.rateOfTarget": "{rate}% постигнато от целта {target}%",
"hc.reached": "постигнато",
"hc.reactivating": "Реактивиране…",
"hc.reasonSavedYouCanStill": "Причината е запазена. Все още можете да поискате своя предмет.",
"hc.recentMatchesFirst": "Първо последните съвпадения",
"hc.recognizedThePhotoYouSent": "разпозна снимката, която изпратихте, и описа тези характеристики. Потвърдете само ако съвпадат с предмета, който притежавате.",
"hc.recommended": "Препоръчано",
"hc.recoveryFees": "Такси за възстановяване",
"hc.recoveryFeesArePaidDirectly": "Таксите за възстановяване се плащат директно на партньорското заведение. Findloop не получава плащания от клиенти.",
"hc.recoveryFeesEnabled": "Таксите за възстановяване са активирани",
"hc.recoveryOfferedByTheEstablishment": "Възстановяването, предлагано от заведението — Findloop не начислява такси.",
"hc.recoveryPaymentLink": "Линк за плащане за възстановяване",
"hc.recoveryPaymentLinkSavedFor": "Линк за плащане за възстановяване, запазен за това заведение",
"hc.redirecting": "Пренасочване…",
"hc.redirectingToPayment": "Пренасочване към плащане…",
"hc.redirectingToTheRecoveryOf": "Пренасочване към възстановяването на вашия предмет…",
"hc.regenerateAndResendToThe": "Регенерирайте и изпратете отново на собственика",
"hc.regenerateTheCode": "Регенерирайте кода",
"hc.registerAFoundItem": "Регистрирайте намерен предмет",
"hc.rejectTheClaim": "Отхвърлете искането",
"hc.reminderDelaySaved": "Закъснението за напомняне е запазено",
"hc.reopenThePaymentLink": "Преотвори линка за плащане",
"hc.repeatThePassword": "Повторете паролата",
"hc.reportAProblem": "Докладвайте за проблем",
"hc.reportDismissedYourListingRemains": "Докладът е отхвърлен. Вашата обява остава публична.",
"hc.requiredUsedToCalculateThe": "Задължително: използва се за изчисляване на тарифата за доставка на Sendcloud. Доставката не е налична над 30 кг.",
"hc.reset": "Нулиране",
"hc.resume": "Възобновяване",
"hc.resumeRegistration": "Възобновяване на регистрацията",
"hc.retro": "Година в преглед",
"hc.returnSecurity": "Връщане на сигурността",
"hc.returnToTheOwner": "Връщане на собственика",
"hc.returned": "върнато",
"hc.reviewTheItemDetails": "Прегледайте детайлите на артикула",
"hc.revokeAccess": "Отнемете достъпа",
"hc.role": "Роля:",
"hc.save": "Запазване",
"hc.save2": "запазване",
"hc.saveAndContinue": "Запазете и продължете",
"hc.saving": "Запазване…",
"hc.scanTheClaimCode": "Сканирайте кода за иск",
"hc.scanTheOwnerSQr": "Сканирайте QR на собственика",
"hc.scrollThroughLanguages": "Превъртете през езиците",
"hc.searchByCustomerItemOr": "Търсене по клиент, артикул или номер за проследяване…",
"hc.searchForACountry": "Търсене на държава…",
"hc.secureFindoVerification": "Сигурна проверка на Findloop",
"hc.seeRetro": "Вижте годината в преглед",
"hc.selectedCarrier": "Избран куриер:",
"hc.selectedPlan": "Избран план",
"hc.send": "Изпрати",
"hc.sendcloudSenderIdSaved": "ID на подател на Sendcloud запазен",
"hc.sendcloudSenderIdSenderId": "ID на подател на Sendcloud (sender_id)",
"hc.sending": "Изпращане…",
"hc.sessionExpired": "Сесията изтече",
"hc.setUpYourEstablishments": "Настройте вашите заведения",
"hc.settings": "Настройки",
"hc.settingsSubtitle": "Външни плащания и напомняния, конфигурирани на база заведение.",
"hc.shareFoundText": "Намерих артикул – помогнете ми да намеря неговия собственик в Findloop",
"hc.shareLostText": "Загубих артикул – помогнете ми да го намеря в Findloop",
"hc.sharePreview": "Споделете предварителен преглед",
"hc.shareTheRanking": "Споделете класирането",
"hc.shareYourQrCodeTo": "Споделете QR кода си, за да получавате декларации.",
"hc.shipRateAutoWeight": "Таксата за доставка се изчислява автоматично чрез Sendcloud (тегло {w}) в момента на доставка.",
"hc.shipRateForWeight": "Тариф за доставка (Sendcloud + {m}% наценка) за {w}:",
"hc.shipments": "Пратки",
"hc.shipmentsSubtitle": "Консолидирана гледка на всички пратки на заведението, по всички случаи. Кликнете върху реда, за да управлявате пратката в нейната декларация.",
"hc.shipping": "Доставка",
"hc.shippingAddress": "Адрес за доставка",
"hc.shippingFeesAreHandledAutomatically": "Таксите за доставка се обработват автоматично от Findloop (Sendcloud) — няма връзка за въвеждане.",
"hc.shippingFeesHaveAlreadyBeen": "Таксите за доставка вече са платени: превозвачът вече не може да бъде променен.",
"hc.shippingNotAvailableForItems": "Доставка не е налична за артикули над 30 кг. Клиентът ще трябва да вземе артикула лично.",
"hc.shippingPaid": "Доставката платена ✓",
"hc.showOnlyItemsMatchingA": "Покажи само артикули, съвпадащи с публична (клиентска) обява",
"hc.showPassword": "Покажи паролата",
"hc.signInTheBoxAbove": "Влезте в полето по-горе",
"hc.signatureSaved": "Подписът е запазен",
"hc.signedInWithGoogle": "Влезли с Google",
"hc.signupFailed": "Регистрацията не успя",
"hc.silver": "Сребро",
"hc.simulatedRatesInPreProduction": "(симулирани тарифи в предпроизводство)",
"hc.siretAndVatNumberRequired": "Изисква се SIRET и ДДДС номер (Франция).",
"hc.skip": "Пропусни",
"hc.smsSentIfAccount": "Ако съществува акаунт с този номер, на вас е изпратено SMS.",
"hc.sortItemsWithAPublic": "Сортиране: артикули с публично съвпадение (най-нови) първо",
"hc.specifyWhetherYouRecoveredYour": "Уточнете дали сте възстановили артикулът или просто искате да премахнете тази обява.",
"hc.specifyYourReason": "Уточнете причината си",
"hc.specifyYourReason2": "Уточнете причината си…",
"hc.staff": "Персонал",
"hc.status": "Статус",
"hc.staySignedIn": "Останете влезли",
"hc.step": "Стъпка",
"hc.stillThere": "Все още тук?",
"hc.stopScrolling": "Спри да превърташ",
"hc.storeFindWithQr": "Съхранявайте и намирайте с QR",
"hc.streetName": "Име на улица",
"hc.streetNo": "Номер на улица",
"hc.switchTo": "Превключи към",
"hc.switchToDarkMode": "Превключи към тъмен режим",
"hc.switchToLightMode": "Превключи към светъл режим",
"hc.takeAPhoto": "Направи снимка",
"hc.takeChangeThePhoto": "Направи / смени снимката",
"hc.takenFromYourDeclaration": "вземете от вашата декларация",
"hc.target": "Цел",
"hc.targetReached": "Целта е постигната",
"hc.targetReachedThankYouTo": "Целта е постигната — благодаря на цялата общност на Findloop!",
"hc.tellUsMore": "Кажете ни повече…",
"hc.tellUsWhyYouCancel": "Кажете ни защо отменяте. Това помага на партньора да обработи вашето искане.",
"hc.tellUsWhyYourListing": "Кажете ни защо. Вашата обява остава активна и можете все още да си я поискате.",
"hc.termsAndConditions": "Условия и положения",
"hc.termsAndPolicies": "Условия и политики",
"hc.thankYouForYourFeedback": "Благодарим ви за обратната връзка",
"hc.theBannerDisplayedInThe": "банерът, показан в регистъра.",
"hc.theClaimantHasBeenInformed": "Искателят е информиран. Артикулът остава наличен в публичната обява.",
"hc.theClaimantHasBeenNotified": "Искателят е уведомен и сега може да продължи с връщането.",
"hc.theCustomerPaysTheFees": "Клиентът плаща таксите на заведението.",
"hc.theDayTheLegalRetention": "Денят, в който е достигнат законният срок на задържане.",
"hc.theEstablishmentConsideredThatThis": "Заведението счита, че този артикул не е ваш.",
"hc.theEstablishmentIsReviewingYour": "Заведението преглежда отговорите ви. Ще бъдете уведомени веднага след потвърждаването на искането ви, след това можете да платите таксите за възстановяване.",
"hc.theFeesAreTooHigh": "Таксите са твърде високи",
"hc.theFinderConsideredThatThis": "Намерачът счита, че този артикул не е ваш.",
"hc.theFinderIsReviewingYour": "Намерачът преглежда вашето искане. Ще бъдете уведомени веднага след като бъде потвърдено.",
"hc.theItem": "Артикулът",
"hc.theItemWillBeRemoved": "Артикулът ще бъде премахнат от регистъра (не е в процес на искане).",
"hc.theItemWillBeSet": "Артикулът ще бъде върнат в \"наличност\" и свързаното искане отменено.",
"hc.theKbisNumberAndVat": "Kbis номерът и ДДС номерът са задължителни за Франция.",
"hc.theLabelIsGeneratedAutomatically": "Етикетът се генерира автоматично веднага след като клиентът е платил таксите за доставка. Той ще може да бъде изтеглен тук.",
"hc.theLinkMayHaveExpired": "Връзката може да е изтекла (валидна за 30 дни). Свържете се с поддръжката на Findloop, ако е необходимо.",
"hc.theOwnerDescribesTheirItem": "Собственикът описва своя артикул",
"hc.theOwnerReceivedItBy": "Собственикът го е получил по имейл (или SMS). Въведете или сканирайте преди предаване.",
"hc.thePartnerConsideredThatThis": "Партньорът счита, че този артикул не е ваш. Артикулът остава наличен.",
"hc.thePartnerIsReviewingYour": "Партньорът преглежда вашите отговори. Ще бъдете уведомени веднага след потвърждаването на искането ви.",
"hc.theShipmentIsCreatedAutomatically": "Доставката се създава автоматично, след като клиентът потвърди своя адрес и плати таксите за възстановяване. След това етикетът ще бъде генериран автоматично след плащането на доставката и може да бъде изтеглен тук.",
"hc.theShippingRateWillBe": "Таксата за доставка ще бъде изчислена автоматично чрез Sendcloud в момента на изпращане (записано тегло).",
"hc.thisCarrierWillBe": "Този превозвач ще бъде",
"hc.thisEstablishment": "това заведение",
"hc.thisFieldIsRequiredFor": "Тази полета е задължителна за автоматично генериране на етикет.",
"hc.thisIsMyItem": "Това е моята стока",
"hc.thisIsMyItemContinue": "Това е моята стока — продължете",
"hc.thisIsMyItemStart": "Това е моята стока — започнете връщането",
"hc.thisIsNotMyItem": "Това не е моята стока",
"hc.thisMatchIsNoLonger": "Това съвпадение вече не е налично или вече е обработено.",
"hc.thisRateWillBeCharged": "Тази ставка ще бъде начислена на клиента. Високата такса може да възпре възстановяването.",
"hc.thisStepIsRequiredFor": "Тази стъпка е необходима, за да бъдат генерирани етикетите за доставка",
"hc.thisValidationLinkIsInvalid": "Тази връзка за валидация е невалидна или е изтекла.",
"hc.toCheckBeforeMarkingThe": "Да проверите преди да маркирате артикула като върнат.",
"hc.toConfigureTheLinksAnd": "да конфигурирате връзките и забавянето на напомнянето за всяко заведение.",
"hc.toReachOurFirstMilestone": "да достигнем нашия първи етап от 100 връщания.",
"hc.toTheCustomer": "към клиента.",
"hc.toTheShippingFeePayment": "към плащането на таксата за доставка.",
"hc.toYourRecoveryTracking": "към проследяването на вашето възстановяване.",
"hc.tooExpensiveBudget": "Твърде скъпо / бюджет",
"hc.topCitiesForReturns": "Най-добри градове за връщания",
"hc.trackMyRecovery": "Проследи моето възстановяване",
"hc.trackTheShipmentAndDownload": "Проследете пратката и изтеглете етикета (генериран автоматично) без да напускате таба Декларации.",
"hc.trackYourStatistics": "Проследете статистиките си",
"hc.tracking": "Проследяване",
"hc.unableToOpenTheShipping": "Не може да се отвори плащането на таксата за доставка. Моля, опитайте отново.",
"hc.unableToRetrieveTheInvoice": "Не може да се извлече фактурата.",
"hc.unclaimed": "Ненает",
"hc.unclaimedCustomerReason": "Ненает предмет. Причина на клиента: \"{reason}\".",
"hc.unclaimedItem": "Ненает предмет",
"hc.unclaimedItemNoClaimWithin": "Ненает предмет — без искане в рамките на срока.",
"hc.unclaimedItems": "Ненаети предмети",
"hc.unclaimedItemsMatchLeftWithout": "Ненаети предмети: съответствие оставено без искане в рамките на срока. Можете да ги върнете обратно в хранилището.",
"hc.unlockTheFinderSContact": "Отключете контактните данни на намиращия, за да организирате предаването.",
"hc.upcoming": "Предстоящи",
"hc.updateFailed": "Актуализацията не успя.",
"hc.usedForInvoices": "Използва се за издаване на вашите фактури от findloop.",
"hc.vatNumber": "ДДС номер",
"hc.verificationPending": "Верификация в процес",
"hc.verificationSentToTheFinder": "Верификацията е изпратена на намиращия. Ще бъдете уведомени за тяхното решение.",
"hc.verificationSentToThePartner": "Верификацията е изпратена на партньора. Ще бъдете уведомени за тяхното решение.",
"hc.verify": "Потвърдете",
"hc.verifyingInvite": "Потвърдете връзката на поканата…",
"hc.verifyingTheLink": "Потвърдете връзката…",
"hc.viewInRegistry": "Преглед в регистъра",
"hc.viewItem": "Преглед на предмета",
"hc.viewItemRecover": "Преглед на предмета и възстановяване",
"hc.visibleToTheOwnerAutomatically": "Видим за собственика · автоматично изтрит след 60 дни.",
"hc.waitingForPartnerConfirmation": "Изчакване на потвърждение от партньора",
"hc.waitingForThePartnerS": "Изчакване на потвърждението на партньора",
"hc.weHaveInformedTheEstablishment": "Уведомили сме заведението, че този предмет не е ваш и сме рестартирали анализа. Ще бъдете уведомени, веднага щом бъде намерено ново съответствие.",
"hc.weHaveInformedThePartner": "Уведомили сме партньора, че този предмет не е ваш. Вашето обявление остава активно за бъдещи съвпадения.",
"hc.weRanTheAnalysisAgain": "Повторихме анализа и идентифицирахме още един артикул, който може да е ваш. Моля, проверете отново.",
"hc.weight": "Тегло",
"hc.weightNotProvidedTheShipping": "Теглото не е предоставено: цената за доставка ще бъде изчислена в момента на изпращането.",
"hc.weightUnit": "Единица за тегло",
"hc.welcome": "Добре дошли!",
"hc.welcomeToFindo": "Добре дошли в Findloop",
"hc.whenACustomerComesTo": "Когато клиент дойде да вземе своите вещи, отворете тяхната декларация и валидирайте връщането. Това е всичко!",
"hc.whenDisabledFeesDropTo": ". Когато е деактивирано, таксите спадат до",
"hc.whyIsThisNotYour": "Защо това не е вашият артикул?",
"hc.willBeMarkedAs": "ще бъде обозначен като",
"hc.wrongColor": "Грешен цвят",
"hc.wrongModel": "Грешен модел",
"hc.yesCancel": "Да, отменям",
"hc.yesContactTheFinder": "Да, свържете се с откривателя",
"hc.youAreHere": "Вие сте тук",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Сега можете да стартирате връщането.",
"hc.youCanStillChangeIt": ". Все още можете да го промените поотделно.",
"hc.youHaveAlreadyConfirmedThat": "Вие вече потвърдихте, че това е вашият артикул.",
"hc.youWillBeRedirectedTo": "Ще бъдете пренасочени към сигурното плащане с Stripe.",
"hc.yourAccountHasBeenReactivated": "Вашият акаунт е активиран отново.",
"hc.yourAccountIsActiveYou": "Вашият акаунт е активен, сега можете да управлявате вашите заведения.",
"hc.yourEstablishment": "Вашето заведение",
"hc.yourFeedbackHelpsUsImprove": "Вашата обратна връзка ни помага да подобрим нашите съвпадения.",
"hc.yourFeedbackHelpsUsRestart": "Вашата обратна връзка ни помага да рестартираме анализа и да подобрим нашите съвпадения.",
"hc.yourFirstSteps": "Вашите първи стъпки",
"hc.yourFirstStepsAdmin": "Вашите първи стъпки (администратор)",
"hc.yourItemHasBeenHanded": "Вашият артикул е предаден лично от партньора — затворете случая, след като предаването е потвърдено.",
"hc.yourItemHasBeenShipped": "Вашият артикул е изпратен от партньора — затворете случая, след като доставката е потвърдена.",
"hc.yourPaymentHasBeenRecorded": "Вашето плащане е записано.",
"hc.yourShipmentIsBeingPrepared": "Вашето изпращане се подготвя. Ще получите пакета си в рамките на 3 до 5 работни дни.",
"hc.yourShippingFeesHaveAlready": "Вашите такси за доставка вече са платени. Доставката е платена ✓",
"hc.yourShippingFeesHaveBeen": "Вашите такси за доставка са платени. Вашият пакет се подготвя.",
"hc.yourVerificationQuestionsDeposit": "Вашите въпроси за верификация (депозит)",
"hero.einvoiceBadge": "E-фактуриране, съобразено с 2027 г.",
"home.recentAdsAll": "Вижте всички обяви",
"home.recentAdsEyebrow": "В момента",
"home.recentAdsSubtitle": "Загубени и намерени вещи, отразени от общността.",
"home.recentAdsTitle": "Последни обяви",
"home.reunions": "Наскоро събрания",
"home.videoEyebrow": "Гледай",
"home.videoTitle": "Открий Findloop за 2 минути",
"home.watchYoutube": "Гледай в YouTube",
"impact.already": "Вече",
"impact.citiesWord": "град/градове",
"impact.eachPoint": "Всяка точка е град, в който Findloop помага за възстановяване на загубени предмети.",
"impact.emptyMap": "Картата се запълва, когато се случват възстановявания.",
"impact.eyebrow": "Нашето въздействие",
"impact.inCities": "в",
"impact.restitutedTo": "предмети, върнати на техните притежатели",
"impact.title": "Предмети, върнати на всякъде около вас",
"inv2.download": "Изтегли",
"inv2.view": "Прегледай",
"map.objectsOnMapPlural": "предмети на картата",
"map.objectsOnMapSingular": "предмет на картата",
"mc.claimConfirmDesc": "Провери предмета, открит от откривателя, преди да платиш за отключване на неговите контактни данни.",
"mc.claimConfirmNo": "Това не е моят предмет",
"mc.claimConfirmTitle": "Дали това наистина е твоят предмет?",
"mc.claimConfirmYes": "Да, мой е — плати",
"mc.claimFinderContacts": "Контактни данни на откривателя",
"mc.claimNotMineDone": "Благодаря — откривателят е уведомлен и твоето искане беше премахнато от рекламата.",
"mc.claimUnlockDesc": "Плати управленската такса на Findloop, за да получиш контактните данни на лицето, което е намерило твоят предмет.",
"mc.claimUnlockTitle": "Отключи контактните данни на откривателя",
"mc.hideCountryOffers": "Скрий предложенията в моята страна",
"mc.myClaims": "Предмети, които претендирам",
"mc.myClaimsSub": "Предмети, намерени от други, които претендираш. Отключи контактните данни на откривателя, за да организираш предаването.",
"mc.notifAdCancelled": "Рекламата отменена",
"mc.notifCancelAd": "Отмени моята реклама",
"mc.offersInCountry": "Предложения в моята страна",
"mc.offersInCountryDesc": "Всички активни награди от партньори в твоята страна, по град.",
"mc.redArchived": "Архивирано",
"mc.rewardsCountryNone": "Няма предложения в твоята страна все още.",
"mc.rewardsForYou": "Награди за теб",
"mc.rewardsForYouDesc": "Предложени от партньора(ите), където си оставил предмет.",
"mc.rewardsMineNone": "Няма награда от твоите партньори за оставяне все още.",
"mc.showCountryOffers": "Виж предложенията в моята страна",
"mc2.cancelDecl": "Отмени моята декларация",
"mc2.cancelDeclDone": "Декларацията отменена.",
"pricing.physInvDesc": "Когато предмет бъде върнат, неговото местоположение автоматично се освобождава и е налично за нов предмет.",
"pricing.physInvTitle": "Проследяване на физически инвентар",
"pricing.physModalTitle": "Управление на физически артикули",
"pricing.physQrDesc": "Генерира се уникален QR код за всеки артикул, който свързва с цялата му информация.",
"pricing.physQrTitle": "Специален QR етикет",
"pricing.physShelfDesc": "Всеки регистриран артикул може да бъде назначен на физическо място в заведението.",
"pricing.physShelfTitle": "План на рафтовете",
"pricing.physicalMgmt": "Управление на физически артикули (рафтове, QR, инвентар)",
"pub.addSecondPhoto": "Добавете 2-ра снимка (по избор)",
"pub.photo2Added": "✓ 2-ра снимка добавена",
"reg.dispositionJournal": "Журнал на разпорежданията",
"reg.dispositionNoteAuthHint": "ℹ️ Необходима е бележка за „Предадено на органите“ (номер на доклад, отдел…).",
"reg.dispositionNotePh": "Бележка (по избор): бенефициер, реф. на органите, име на купувача…",
"reg.dispositionNoteRequired": "Необходима е официална справка за предаване на органите.",
"reg.legalPrealert": "Правен срок в {days} ден(дни)",
"reg.legalPrealertOptions": "Опции на крайния срок: търг, дарение на благотворителна организация, предаване на органите.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Пълен преглед",
"rev.readMore": "Прочетете повече",
"rw.activeCodes": "Активни ваучери",
"rw.archived": "Архивирани",
"rw.archivedTitle": "Използвани ваучери (архивирани)",
"rw.hideArchived": "Скрийте използваните ваучери",
"rw.noArchived": "Няма архивиран ваучер.",
"rw.showArchived": "Покажи използваните ваучери",
"shp.labelAuto": "Етикетът се генерира автоматично, веднага щом клиентът е платил таксите за доставка. Той ще може да бъде свален оттук.",
"st.cancelled_by_customer": "Отменено",
"stt.dispoPdfBtn": "Експортиране на PDF",
"stt.dispoPdfError": "Неуспешен импорт на PDF.",
"stt.dispoPdfExporting": "Експортиране…",
"trk.matchVerifying": "Потенциално съвпадение се проверява",
"pcat.stadium_arena": "Стадион / Арена",
"pcat.supermarket": "Супермаркет",
"pcat.taxi_vtc": "Такси / Платформа за споделени пътувания",
"pcat.tourism_office": "Туристическо бюро",
"pcat.train_bus_station": "Железопътна / автобусна станция",
"pcat.travel_agency": "Туристическа агенция",
"hc.and": "и",
"hc.demoObj0": "портфейл",
"hc.demoObj1": "спортна чанта",
"hc.demoObj2": "телефон",
"hc.demoObj3": "чифт очила",
"hc.demoObj4": "ключодържател",
"hc.demoObj5": "шал",
"hc.demoObj6": "лаптоп",
"hc.demoObj7": "бутилка с вода",
"hc.demoWhen0": "преди 2 часа",
"hc.demoWhen1": "преди 5 часа",
"hc.demoWhen2": "вчера",
"hc.demoWhen3": "преди 3 часа",
"hc.demoWhen4": "тази сутрин",
"hc.demoWhen5": "преди 1 ден",
"hc.feedDemo": "{obj} беше върнат в {city} {when}.",
"hc.feedReal": "Артикул ({cat}) беше върнат в {city}.",
"hc.saveBtn": "Запази",
"hc.saveLink": "Запази връзка",
"hc.terms": "Условия",
"hc.view": "Преглед",
"pcat.airline": "Авиокомпания",
"pcat.airport": "Летище",
"pcat.amusement_park": "Парк за развлечения",
"pcat.bank": "Банка",
"pcat.bar_cafe": "Бар / Кафе",
"pcat.beauty_salon": "Фризьорски / Козметичен салон",
"pcat.cinema": "Кино",
"pcat.concert_theater": "Концертна зала / Театър",
"pcat.coworking": "Коворкинг пространство",
"pcat.gym_fitness": "Фитнес",
"pcat.hospital_clinic": "Болница / Клиника",
"pcat.library": "Библиотека",
"pcat.mall": "Търговски център",
"pcat.museum": "Музей",
"pcat.pharmacy": "Аптека",
"pcat.private_company": "Частна компания",
"pcat.public_transport": "Обществен транспорт",
"pcat.school_university": "Училище / Университет",
"pcat.sports_center": "Спортен център",
"an.found": "Намерено",
"an.lost": "Загубено",
"hc.shareReview": "Споделете отзива",
"home.videoSubtitle": "Как лесно събираме загубени предмети с техните собственици.",
"hc.citiesAboveTarget": "{n} града над целта",
"hc.cityAboveTarget": "{n} град над целта",
"hc.j15EarlyReminder": "Реминдер D-15",
"hc.j7EarlyReminder": "Реминдер D-7",
"hc.annualTotal": "Годишна сума",
"hc.billedOnceYear": "Таксуване веднъж за 12 месеца, подновява се всяка година.",
"hc.monthlyPrice": "Месечна цена",
"hc.perMonth": "/ месец",
"hc.perYear": "/ година",
"hc.billedEachMonth": "Таксувано автоматично всеки месец.",
"nav.business": "Бизнес",
"nav.individual": "Индивидуален",
"hc.circumstancesFound": "Обстоятелства на намереното",
"hc.circumstancesFoundPh": "Напр. намерено на земята близо до входа на метрото",
"hc.circumstancesLost": "Обстоятелства на изгубеното",
"hc.circumstancesLostPh": "Напр. оставено на пейка, докато чакам автобуса",
"hc.conditionPh": "Напр. добро, надраскано…",
"hc.firstName": "Собствено име",
"hc.lastName": "Фамилно име",
"hc.quantity": "Брой на предметите",
"fa.ownerContact": "Данни за контакт с собственика",
"fa.payPublish": "Плати и публикувай",
"fa.pendingPayText": "Вашата обява ще бъде активна, след като плащането бъде потвърдено.",
"fa.pendingPayTitle": "Плащането е в процес на обработка",
"fa.planSub": "Вашата обява става активна, щом плащането бъде потвърдено.",
"fa.planTitle": "Продължителност на обявата",
"fa.pubSuccessMsg": "Вашата обява е активна. Ще бъдете уведомени, щом някой намери.",
"fa.pubSuccessTitle": "Обявата е публикувана",
"fa.publicNote": "Само описанието, градът, страната и снимките са показани публично.",
"fa.redirectStripe": "Пренасочване към сигурно плащане…",
"fa.reject": "Отхвърли",
"fa.rejectConfirm": "Да отхвърля ли тази декларация? Вашата обява остава онлайн.",
"fa.rejected": "Декларацията е отхвърлена",
"fa.rejectedFinder": "Не е това, което търсеха",
"fa.rejectedFinderText": "Собственикът казва, че този предмет не е техен. Благодарим ви за помощта!",
"fa.responsesTitle": "Декларации на намерилите",
"fa.sent": "Декларацията е изпратена на собственика.",
"fa.submitDecl": "Изпрати моята декларация",
"fa.submitDeclPay": "Изпрати и допринеси {amount}",
"fa.total": "Обща сума за плащане",
"fa.ttc": "вкл. ДДС",
"fa.waitClaimText": "Намерилят преглежда вашата молба. Ще бъдете уведомени за тяхното решение.",
"fa.waitFinderText": "Ние ще ви уведомим веднага щом намерилят изпрати декларация.",
"fa.waitFinderTitle": "Вашата обява е активна",
"fa.waitOwnerText": "Собственикът сравнява вашата декларация с тяхната. Ще бъдете уведомени за тяхното решение.",
"fa.waitOwnerTitle": "Чакаме решението на собственика",
"st.pending_payment": "Плащането е в процес на обработка",
"fa.approve": "Одобри",
"fa.approveConfirm": "Одобрявате ли тази декларация? Вашите пълни контактни данни (имя, имейл, телефон) ще бъдат обменяни с намиращия.",
"fa.approved": "Декларацията е одобрена — контактните данни са обменени",
"fa.approvedFinder": "Собственикът одобри вашата декларация",
"fa.approvedFinderText": "Свържете се с тях, за да организирате връщането.",
"fa.boostSub": "Вашата обява остава на върха за избраната продължителност.",
"fa.boostTitle": "Увеличете видимостта на обявата си (по избор)",
"fa.colFinder": "Декларация на намиращия",
"fa.colYours": "Вашата декларация",
"fa.compareHint": "Сравнете декларацията на намиращия с вашата, преди да вземете решение.",
"fa.contribNone": "Няма принос",
"fa.contribPaid": "Приносът е получен — благодаря!",
"fa.contribPending": "Приносът чака плащане",
"fa.contribSub": "Подкрепете Findloop, за да помогнете на повече хора да получат вещите си обратно. Можете да изберете €0.",
"fa.contribSuccessMsg": "Вашата декларация е изпратена на собственика.",
"fa.contribSuccessTitle": "Благодаря ви за приноса",
"fa.contribTitle": "Доброволен принос",
"fa.days3": "3 дни",
"fa.days30": "30 дни",
"fa.days7": "7 дни",
"fa.declSub": "Опишете намерения предмет. Собственикът ще сравни вашата декларация с тяхната.",
"fa.declTitle": "Намерих този предмет",
"fa.expiresOn": "Изтича на",
"fa.fBrand": "Марка",
"fa.fCircumstances": "Обстоятелства",
"fa.fCity": "Град",
"fa.fColor": "Цвят",
"fa.fCondition": "Състояние",
"fa.fDate": "Дата",
"fa.fMessage": "Съобщение на намиращия",
"fa.fPlace": "Място",
"fa.fQuantity": "Количество",
"fa.finderContact": "Контактни данни на намиращия",
"fa.finishPay": "Завършване на плащането",
"fa.foundDate": "Дата на намиране",
"fa.foundPlace": "Място на намиране",
"fa.hours24": "24 часа",
"fa.ht": "без ДДС",
"fa.months3": "3 месеца",
"fa.noBoost": "Без увеличаване на видимостта",
"fa.africaFree": "Безплатно обявление в Африка — оферта при стартиране на Findloop, насладете се!",
"fa.africaPublished": "Обявлението публикувано безплатно — оферта при стартиране на Африка!",
"fa.approveClaimConfirm": "Да одобрите ли това искане? След това собственикът ще може да отключи вашите данни за контакт.",
"fa.checkInfo": "Проверете вашите данни преди изпращане: те ще бъдат сравнени с тези на намерителя.",
"fa.claimApprovedShort": "Намерителят одобри вашето искане",
"fa.claimRejectedShort": "Искането е отказано от намерителя",
"fa.claimRejectedText": "Намерителят смята, че този предмет не е ваш.",
"fa.claimSub": "Опишете вашия предмет и добавете 2 снимки. Намерителят ще ги сравни с тяхното обявление.",
"fa.claimTitle": "Това е моят предмет",
"fa.claimUnlockText": "Отключете данните за контакт на намерителя, за да организирате връщането.",
"fa.claimUnlockedShort": "Данните за контакт отключени — вижте проследяването",
"fa.claimsTitle": "Искания на собственици",
"fa.colOwner": "Декларация на собственика",
"fa.colYourAd": "Вашето обявление",
"fa.expired": "Обявлението е изтекло",
"fa.free": "Безплатно",
"fa.lostDate": "Дата на загуба",
"fa.lostPlace": "Място на загуба",
"fa.noReceipt": "Няма налична разписка за това обявление.",
"fa.planSubFree": "Изберете продължителността: вашето обявление ще бъде активно незабавно, без нужда от плащане.",
"fa.prefillPrevious": "Използвайте отново данните от предишното ми обявление в тази категория",
"fa.receipt": "PDF разписка",
"fa.renewBtn": "Поднови",
"fa.renewDiscountBanner": "50% отстъпка: подновете преди изтичането на вашето обявление!",
"fa.renewDiscountHint": "50% отстъпка е приложена, защото подновявате преди изтичането.",
"fa.renewEarly": "Поднови (−50%)",
"fa.renewTitle": "Поднови моето обявление",
"fa.renewed": "Обявлението е подновено",
"fa.sendClaim": "Изпрати моето искане",
"fa.twoPhotos": "2 снимки на вашия предмет",
"fa.twoPhotosError": "Добавете 2 снимки на вашия предмет.",
"fa.twoPhotosHint": "Лични снимки, доказващи, че предметът е ваш (с предмета, фактура, кутия…).",
"fa.unlockBtn": "Отключете данни за контакт",
"fa.unlockFree": "Отключете безплатно — оферта при стартиране",
"fa.waitClaimantText": "Ще ви уведомим, щом собственикът заяви този предмет.",
"fa.waitFinderDecision": "Чакаме решението на намерителя",
"fa.waitUnlockText": "Ще бъдете уведомени, щом данните за контакт бъдат разменени.",
"fa.waitUnlockTitle": "Чакаме собственика да отключи",
"fa.cancel": "Отменяне",
"fa.categoryRequired": "Изберете категория за намерения елемент.",
"fa.confirmTitle": "Потвърдете решението си",
"fa.goBack": "Отиди обратно",
"dr.continue": "Продължи моята декларация",
"dr.delete": "Изтрий трайно",
"dr.deleteConfirm": "Наистина ли искате да изтриете този проект? Това не може да бъде отменено.",
"dr.deleted": "Проектът е изтрит",
"dr.expiresIn": "Проектът ще бъде запазен за още {h} часа",
"dr.title": "Имам незавършена декларация",
"form.step": "Стъпка",
"form.next": "Продължи",
"form.back": "Назад",
"form.stepDetails": "Вашият доклад",
"form.stepPublish": "Време, удължаване и плащане",
"form.stepThanks": "Благодарим ви и вашето участие",
"fthx.badge": "Докладът почти е готов",
"fthx.title": "Благодарим ви, правите разлика!",
"fthx.text": "Благодарение на вас, скоро някой може да получи обратно нещо, което му е ценно. Такива актове на доброта като вашите са точно това, което държи Findloop жив.",
"fthx.impact1": "1 отчетен артикул",
"fthx.impact2": "1 допълнителен шанс за среща",
"fthx.tipTitle": "Малко вдъхновение за Findloop?",
"fthx.tipText": "Вашият принос ни помага да поддържаме услугата достъпна и да събираем все повече предмети с техните собственици.",
"fthx.optional": "100% опционално — можете да публикувате без да допринасяте.",
"fthx.thanksTip": "Благодарим ви много за щедростта!",
"fthx.suggest": "Предложени суми",
"fthx.none": "Без предложение",
"pay.pendingTitle": "Плащането не е завършено",
"pay.pendingText": "Вашите данни са запазени. Продължете плащането от мястото, на което спряхте.",
"pay.resume": "Продължи плащането",
"pay.expiredTitle": "Сесията за плащане е изтекла",
"pay.expiredText": "За ваша сигурност, сесията за плащане изтече. Вашите данни са запазени: рестартирайте плащането с едно кликване.",
"pay.relaunch": "Рестартирайте плащането",
"sub.received": "Изпратено!",
"sub.publishing": "Завършваме…",
"sub.toPayment": "Пренасочваме към сигурно плащане…",
"fa.claimSubV2": "Опишете изгубения си предмет. Човекът, който го е намерил, ще сравни вашата декларация с неговото обявление.",
"fa.photosOptional": "Снимки на вашия предмет (по избор)",
"fa.compareOwnerHint": "Сравнете тази информация с предмета, който сте намерили, и след това кажете дали е същият предмет.",
"fa.itsThisItem": "Да, това е предметът",
"fa.notThisItem": "Не, това не е предметът",
"fa.confirmIsItem": "Потвърдете, че това е предметът? Вашите контактни данни и на собственика ще бъдат показани в съответните ви профили.",
"fa.confirmNotItem": "Потвърдете, че това не е предметът? Вашият доклад ще бъде затворен.",
"fa.youConfirmed": "Потвърдихте, че това е предметът на собственика",
"fa.youDeclined": "Вие указахте, че това не е предметът",
"fa.youDeclinedText": "Благодарим за помощта! Собственикът е информиран.",
"fa.waitFinderDecisionOwner": "Изчакване на решението на намиращия",
"fa.finderConfirmed": "Потвърдено",
"fa.notYourItem": "Това не беше вашият предмет",
"fa.reportedOn": "Докладвано на",
"fa.ownerWaitHint": "Намиращият в момента проверява информацията, моля изчакайте.",
"fa.claimSentFinder": "Искането е изпратено на лицето, което е намерило предмета.",
"fa.compareClaimHint": "Сравнете декларацията на собственика с вашата обява, преди да вземете решение.",
"fa.closeFollowup": "Затвори това последващо действие",
"fa.closeFollowupConfirm": "Наистина ли искате да затворите това последващо действие? Имейлите и телефонните номера на двете страни ще бъдат постоянно изтрити, след като и собственикът затвори своята обява.",
"fa.safetyTitle": "Съвети за безопасност преди предаването",
"fa.safety1": "Попитайте собственика за подробен опис на скритите характеристики на артикула: конкретна драскотина, точното съдържание на чанта, тапет, серийния номер…",
"fa.safety2": "Ако е възможно, поискайте визуално доказателство (снимка на артикула) или доказателство за покупка.",
"fa.safety3": "Предайте артикула на публично място или при партньор на Findloop, и проверете личната карта на собственика.",
"fa.safetyOk": "Разбрах, продължавай",
"fa.ownerClosedNote": "Собственикът е закрил своята обява.",
"fa.finderClosedNote": "Намерачът е закрил своето последващо действие.",
"fa.followupClosed": "Проследяване затворено",
"fa.followupClosedText": "Вие затворихте това проследяване. Благодаря за помощта!",
"fa.photoReviewTitle": "Търсачът изпрати снимка. Изглежда ли като вашия предмет?",
"fa.photoLooksLike": "Да, изглежда като моя предмет",
"fa.photoNotMine": "Не, това не е моят предмет",
"fa.photoNotMineConfirm": "Последващото действие ще бъде затворено и обявата ви ще остане отворена за нов търсач.",
"fa.photoLooksLikeDone": "Благодаря! Търсачът сега ще сравни вашата декларация.",
"fa.photoNotMineDone": "Докладът е отхвърлен. Вашата обява остава отворена.",
"fa.ownerPhotoHint": "Само снимката на търсача е показана на вас. Кажете ни дали изглежда като вашия предмет.",
"fa.ownerReviewingPhoto": "Собственикът преглежда вашата снимка",
"fa.ownerReviewingPhotoText": "Ще бъдете уведомени веднага щом получат отговор. Тогава ще можете да сравните тяхната декларация.",
"fa.ownerRejectedPhoto": "Това не е предметът на собственика",
"fa.ownerRejectedPhotoText": "Собственикът казва, че вашата снимка не съвпада с техния предмет. Последващото действие е затворено. Благодаря за помощта!",
"fa.contribute": "Принос",
"fa.phoneMissing": "Не е предоставен",
"fa.ownerSafety1": "Предпочитайте предаване на публично място или при партньор на Findloop. Ако разстоянието е голямо, предложете да го изпратят по пощата вместо.",
"fa.ownerSafety2": "При предаването проверете документа за самоличност на находчика.",
"pub.changePhoto": "Смяна на снимка",
"ph.secured": "Снимката е защитена",
"ph.securing": "Защита на снимката…",
"fa.ownerSafety3": "Ако снимката на находчика носи воден знак Findloop, не приемайте срещата. Снимката трябва да бъде оригинален образ, направен от находчика, без воден знак."
},
"hr": {
"a.back": "Nazad",
"a.category": "Kategorija",
"a.categoryPlaceholder": "Odaberite kategoriju",
"a.city": "Grad",
"a.confirmPassword": "Potvrdi lozinku",
"a.country": "Država",
"a.createAccount": "Kreiraj račun",
"a.createBtn": "Kreiraj moj račun",
"a.creating": "Kreiranje…",
"a.email": "Email",
"a.emailPro": "Poslovni email",
"a.forgot": "Zaboravili ste?",
"a.forgotSent": "Ako račun postoji, poveznica za resetiranje je upravo poslana.",
"a.forgotSub": "Dobijte poveznicu za resetiranje putem emaila.",
"a.forgotTitle": "Zaboravljena lozinka",
"a.googleContinue": "Nastavi s Google-om",
"a.googleSignup": "Prijavite se s Google-om",
"a.haveAccount": "Već ste partner?",
"a.legalHint": "Obavezno za francusko e-fakturiranje (Factur-X) francuskih ustanova.",
"a.legalRequiredFR": "SIRET i intra-EU PDV broj su obavezni za Francusku.",
"a.loggingIn": "Prijavljivanje…",
"a.login": "Prijavite se",
"a.loginSub": "Pristupite svom upravljačkom prostoru.",
"a.loginTitle": "Prijava partnera",
"a.min6": "Minimalno 6 znakova",
"a.newPassword": "Nova lozinka",
"a.noAccount": "Još niste partner?",
"a.or": "ILI",
"a.org": "Naziv ustanove",
"a.password": "Lozinka",
"a.passwordMismatch": "Lozinke se ne podudaraju.",
"a.referral": "Referentni kod (opcionalno)",
"a.registerSub": "Kreirajte svoj prostor u 1 minuti — besplatno za početi.",
"a.registerTitle": "Postanite partner",
"a.rememberMe": "Zapamti me",
"a.reset": "Resetiraj",
"a.resetSub": "Odaberite novu lozinku za svoj račun.",
"a.resetTitle": "Nova lozinka",
"a.sendLink": "Pošaljite poveznicu",
"a.sending": "Slanje…",
"a.signin": "Prijavite se",
"a.siret": "SIRET",
"a.vat": "Intra-EU PDV br.",
"ac.africa": "Afrika",
"ac.boostActive": "Istakni aktivno —",
"ac.boostSub": "Pojavite se na vrhu imenika partnera s oznakom “Potaknuto”.",
"ac.boostTitle": "Povećajte svoju listu u imeniku",
"ac.categoryHint": "Za klasifikaciju vaše ustanove u Findloop imeniku.",
"ac.choose": "Odaberite",
"ac.cityHint": "Za precizno pozicioniranje na javnoj karti.",
"ac.cityLabel": "Grad ustanove",
"ac.cityPh": "Pariz",
"ac.contact": "Kontakt podaci",
"ac.converted": "Pretvoreno",
"ac.copyDeclLink": "Kopirajte poveznicu za deklaraciju",
"ac.copyLink": "Kopirajte poveznicu",
"ac.currentPlan": "Trenutni plan",
"ac.emailDesc": "Odaberite emailove koje želite primati. Obavijesti u vašem radnom prostoru uvijek ostaju aktivne.",
"ac.emailMatch": "Podudara se",
"ac.emailMatchDesc": "Email kada se stavka podudara s deklaracijom",
"ac.emailNewDecl": "Nove prijave gubitaka",
"ac.emailNewDeclDesc": "Email čim kupac prijavi gubitak na vašem mjestu",
"ac.emailShip": "Zahtjevi za dostavu",
"ac.emailShipDesc": "Email kada kupac zatraži dostavu artikla",
"ac.emailTitle": "Postavke emaila",
"ac.expireSoon": "Vaš istaknuti unos uskoro ističe —",
"ac.exportCsv": "Izvoz (CSV)",
"ac.exportHint": "Izvezite svoje validated vanjske uplate za svoje knjigovodstvo.",
"ac.free": "Besplatno",
"ac.freeMonths": "Besplatni mjeseci",
"ac.hours": "sati",
"ac.howItWorks": "Kako to funkcionira?",
"ac.invited": "Pozvan",
"ac.legalFR": "Obavezno za elektroničko fakturiranje (Factur-X) primjenjuje se od rujna 2026.",
"ac.legalMissing": "⚠️ SIRET i unutarnje EU PDV nedostaju — popunite ih kako biste ostali u skladu s elektroničkim fakturiranjem.",
"ac.legalOther": "Preporučeno za vaše račune.",
"ac.legalPartnerQr": "QR kod",
"ac.legalTitle": "Pravni identifikatori (fakturiranje)",
"ac.logoTitle": "Logo poslovanja",
"ac.modeCurrent": "Trenutni način:",
"ac.modeExternal": "Eksterni (ručna provjera)",
"ac.modeInternal": "Interni Findloop (automatski)",
"ac.noSubReceipt": "Još nema plaćene pretplate.",
"ac.none": "Nema",
"ac.onYourListing": "na vašoj listi",
"ac.pay1": "Unesite svoje linkove za uplatu u nastavku kako biste preusmjerili svoje kupce na svoj vlastiti sustav naplate.",
"ac.pay2": "Provjera postaje ručna: potvrđujete primitak uplate s “Izjave” kartice.",
"ac.pay3": "Link “Trošak dostave” je konsolidirana uplata (povrat + dostava).",
"ac.pay4": "Ostavite polja prazna da biste koristili findloop-ov unutarnji sustav uplate (Stripe) s automatskom provjerom.",
"ac.paySub": "Prikupite naknade putem vlastitog sustava plaćanja.",
"ac.payTitle": "Eksterni plaćanja",
"ac.permissive": "Tolerantan",
"ac.phone": "Telefon",
"ac.posterA4": "A4 plakat (PDF)",
"ac.qMessage": "Poruka (opcionalno)",
"ac.qName": "Ime",
"ac.qOrg": "Organizacija",
"ac.qSites": "Broj poslovnica (procijenjeno)",
"ac.qrHint": "Vaši kupci skeniraju ovaj kod kako bi prijavili izgubljeni predmet.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Vaš QR kod partnera",
"ac.quoteDesc": "Aerodromi, željezničke mreže, međunarodni lanci · ",
"ac.quoteEurope": "Europa / Svijet",
"ac.quoteSent": "Zahtjev za ponudu poslan. Naš tim će vam se ubrzo javiti.",
"ac.quoteTitle": "Zatražite ponudu — Poduzeće",
"ac.recoveryLink": "Link “Naknada za povrat”",
"ac.refSub": "Svaki referirani partner koji se pretplati daje vam 1 besplatan mjesec.",
"ac.refTitle": "Preporučite, zaradite besplatan mjesec",
"ac.reminderDelay": "Odgođeno podsjećanje na provjeru",
"ac.reminderHint": "Dobit ćete email podsjetnik ako vanjska uplata ostane neprovjerena izvan ovog odgode (zadano: 48h).",
"ac.renewDesc1": "Već vam je donio",
"ac.renewDesc2": "Obnovite kako biste ostali na vrhu direktorija i ne biste izgubili ovu vidljivost.",
"ac.renewNow": "Obnovite sada",
"ac.requestQuote": "Zatražite ponudu",
"ac.saveLegal": "Spremite identifikatore",
"ac.saveLinks": "Spremite linkove",
"ac.sendRequest": "Pošaljite moj zahtjev",
"ac.sending": "Šalje se…",
"ac.shippingLink": "Link “Trošak dostave” (konsolidirano)",
"ac.shippingLinkHint": "Ovaj link pokriva i povrat i dostavu.",
"ac.strict": "Strogo",
"ac.subReceipt": "Račun za pretplatu (PDF)",
"ac.subReceiptsSub": "Preuzmite PDF račun za svaku uplatu pretplate.",
"ac.subReceiptsTitle": "Računi za pretplatu",
"ac.tCategory": "Kategorija spremljena",
"ac.tCity": "Grad spremljen — mapa ažurirana",
"ac.tCityNeeded": "Unesite grad",
"ac.tCopied": "Kopirano!",
"ac.tCover": "Fotografija naslovnice ažurirana",
"ac.tEmailPrefs": "Postavke e-pošte ažurirane",
"ac.tErr": "Greška",
"ac.tExportImpossible": "Izvoz neuspješan",
"ac.tLegal": "Pravni identifikatori spremljeni",
"ac.tLegalNeeded": "SIRET i PDV potrebni za Francusku",
"ac.tLogo": "Logo ažuriran",
"ac.tLogoRemoved": "Logo uklonjen",
"ac.tPayLinks": "Linkovi za plaćanje spremljeni",
"ac.tPhone": "Telefon spremljen",
"ac.tSensitivity": "Osjetljivost spremljena",
"ac.tVatInvalid": "Neispravan PDV",
"ac.tVatValid": "Ispravan PDV",
"ac.tabBoost": "Vidljivost",
"ac.tabPayments": "Plaćanja",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Poster",
"ac.tabReferral": "Preporuka",
"ac.tabSub": "Pretplata",
"ac.thisWeek": "Ovaj tjedan",
"ac.thisWeekOf": " ({n} ovaj tjedan)",
"ac.thresholdDesc": "Prag povjerenja nakon kojeg AI automatski potvrđuje podudaranje fotografije i obavještava kupca. Više = manje automatskih podudaranja, ali pouzdanije.",
"ac.thresholdTitle": "Osjetljivost vizualnog podudaranja AI-a",
"ac.trend": "Trend",
"ac.upload": "Otpremi",
"ac.vatValidFmt": "Ispravan PDV{name} ({via})",
"ac.vatVerified": "Unutarnji EU PDV verificiran",
"ac.verifyVat": "Verificiraj PDV (VIES)",
"ac.verifying": "Verificira se…",
"ac.views": "pregledi",
"ac.viewsTotal": "Ostvareni pregledi (ukupno)",
"ac.winbackBtn": "Nastavi uz -20%",
"ac.winbackDesc1": "Zaradao si",
"ac.winbackDesc2": "Posebna ponuda: -20% primijenjeno automatski ako obnoviš unutar 24h.",
"ac.winbackTitle": "Tvoj istaknuti predmet je upravo istekao — nastavi s -20%!",
"ad.boost": "Povećaj",
"ad.close": "Zatvori",
"ad.closeConfirm": "Zatvoriti ovu ponudu?",
"ad.closed": "Ponuda zatvorena",
"ad.edit": "Uredi",
"ad.editTitle": "Uredi ponudu",
"ad.saved": "Ponuda ažurirana",
"an.allCountries": "Sve zemlje",
"an.badge": "Izgubljeni predmeti",
"an.boostLater": "Kasnije",
"an.boostNow": "Povećaj sada",
"an.boostPrompt": "Povećaj svoju ponudu kako bi je stavio na vrh i brže je pronašli.",
"an.boosted": "Povećano",
"an.contact": "Pronašao sam ovaj predmet",
"an.contactTitle": "Prijavite da ste pronašli ovaj predmet",
"an.copyFailed": "Nije moguće kopirati link",
"an.copyLink": "Kopiraj link",
"an.country": "Država",
"an.date": "Datum gubitka",
"an.finderEmail": "Vaš email",
"an.finderName": "Vaše ime",
"an.finderPhone": "Vaš telefon",
"an.geoBanner": "Gledate oglase u",
"an.geoBannerWorld": "Gledate oglase širom svijeta",
"an.geoChange": "promijeni državu",
"an.goAccount": "Idi na moj račun",
"an.linkCopied": "Link je kopiran!",
"an.loginRequired": "Prijavite se za prijavu ovog predmeta i praćenje povrata.",
"an.loginToBoost": "Prijavite se za povećanje ovog oglasa",
"an.lostAt": "Izgubljeno u",
"an.message": "Poruka (opcionalno)",
"an.none": "Još nema oglasa.",
"an.photo": "Fotografija (opcionalno)",
"an.post": "Objavi oglas",
"an.postSubtitle": "Opišite svoj izgubljeni predmet — zajednica i naši partneri će vam pomoći da ga pronađete.",
"an.postTitle": "Prijavi izgubljeni predmet",
"an.publish": "Objavi oglas",
"an.published": "Oglas objavljen!",
"an.publishing": "Objavljujem…",
"an.remaining": "ostalo",
"an.requestInProgress": "Zahtjev u obradi",
"an.resolved": "Predmet je već pronađen",
"an.reward": "Nagrada",
"an.searchPh": "Pretraži oglas…",
"an.send": "Pošalji",
"an.sent": "Poruka poslana vlasniku!",
"an.shareConsent": "Slažem se da se moji kontakt podaci (ime, email, telefon) mogu podijeliti s vlasnikom predmeta.",
"an.shareConsentError": "Molimo označite okvir da podijelite svoje kontakt podatke.",
"an.sortRecent": "Najnoviji",
"an.sortRelevance": "Relevance",
"an.subtitle": "Pretražujte predmete koje je prijavila zajednica. Jeste li pronašli neki od njih?",
"an.title": "Oglasi izgubljenih predmeta",
"anf.badge": "Pronađeni predmeti",
"anf.claim": "Ovo je moje",
"anf.claimSent": "Poruka poslana pronaliocu!",
"anf.claimTitle": "Prijavite da je ovo vaš predmet",
"anf.consent": "Slažem se da vlasnik može vidjeti moje kontakt podatke kako bi povratio svoj predmet.",
"anf.foundAt": "Pronađeno u",
"anf.foundDate": "Datum pronađen",
"anf.loginCta": "Prijavite se / izradite račun",
"anf.loginDesc": "Račun pronašlioca je potreban za objavu oglasa i osvajanje Finder Hero bodova.",
"anf.loginRequired": "Prijavite se da objavite pronađeni predmet",
"anf.photo": "Fotografija predmeta",
"anf.pointsEarned": "Hvala! Upravo ste osvojili Finder Hero bodove.",
"anf.pointsPending": "Vaši bodovi bit će pripisani unutar 24h, nakon verifikacije.",
"anf.post": "Objavi pronađeni predmet",
"anf.postSubtitle": "Opišite predmet koji ste pronašli — pomozite njegovom vlasniku da ga povrati.",
"anf.postTitle": "Prijavi pronađeni predmet",
"anf.publishFound": "Objavi oglas za pronađeni predmet",
"anf.published": "Oglas za pronađeni predmet objavljen",
"anf.publishedAs": "Objavljeno kao",
"anf.shareConsent": "Slažem se da se moji kontakt podaci (ime, email, telefon) mogu podijeliti s osobom koja je pronašla predmet.",
"anf.subtitle": "Pretražujte predmete koje je pronašla i prijavila zajednica. Prepoznajete li svoj?",
"anf.title": "Oglasi pronađenih predmeta",
"bo.active": "Povećanje aktivno",
"bo.africaPrice": "Primijenjena preferencijalna cijena za afričku zonu",
"bo.pay": "Plati i povećaj",
"bo.remaining": "Preostalo vrijeme",
"bo.renew": "Obnovi boost",
"bo.since": "od boosta",
"bo.subtitle": "Postavite svoj oglas na vrh sa vidljivom oznakom.",
"bo.title": "Povećaj oglas",
"c.all": "Sve",
"c.cancel": "Otkaži",
"c.close": "Zatvori",
"c.confirm": "Potvrdi",
"c.confirmed": "Potvrđeno",
"c.download": "Preuzmi",
"c.loading": "Učitavanje…",
"c.reset": "Ponovno postavi",
"c.reviews": "recenzije",
"c.save": "Spremi",
"c.transfer": "Prenesi",
"cat.Animal": "Kućni ljubimac / Pribor za ljubimce",
"cat.AppareilPhoto": "Fotoaparat",
"cat.Argent": "Novac / Gotovina",
"cat.Autres": "Ostalo",
"cat.Bijoux": "Nakit",
"cat.CarteBancaire": "Bankovna kartica",
"cat.CarteIdentite": "Osobna iskaznica / Putovnica",
"cat.Casquette": "Kapa",
"cat.Ceinture": "Pojas",
"cat.Chargeur": "Punjač / Kabl",
"cat.Chaussures": "Cipele",
"cat.CleVoiture": "Ključ od automobila",
"cat.Cles": "Ključevi",
"cat.Console": "Igraća konzola",
"cat.Documents": "Dokumenti / Papiri",
"cat.Echarpe": "Šal",
"cat.Ecouteurs": "Slusalice",
"cat.Electronique": "Elektronika (ostalo)",
"cat.Enceinte": "Zvučnik",
"cat.Gants": "Rukavice",
"cat.Gourde": "Boca za vodu / Termos",
"cat.Instrument": "Muzički instrument",
"cat.Jouet": "Igračka / Mekani igrač",
"cat.Jumelles": "Teleskop",
"cat.Lampe": "Lampa / Vatra",
"cat.Liseuse": "E-čitač",
"cat.Livre": "Knjiga / Bilješka",
"cat.Lunettes": "Naočale",
"cat.Manteau": "Kaput / Jakna",
"cat.Maquillage": "Torba za šminku",
"cat.Medical": "Medicinska oprema",
"cat.Medicaments": "Lijekovi",
"cat.Montre": "Sat / Pametni sat",
"cat.Ordinateur": "Laptop",
"cat.Parapluie": "Kišobran",
"cat.Portefeuille": "Novčanik / Torbica",
"cat.Poussette": "Kolica / Pribor za bebu",
"cat.Sac": "Torbica / Ručna torba",
"cat.SacADos": "Ruksak",
"cat.Souris": "Miš / Tipkovnica",
"cat.Sport": "Sportska oprema",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefon / Pametni telefon",
"cat.Trottinette": "Trotinet",
"cat.Trousse": "Torba / Etui",
"cat.USB": "USB stick / Vanjski disk",
"cat.Valise": "Kufar / Prtljaga",
"cat.Velo": "Bicikl",
"cat.Vetements": "Odjeća",
"cat.placeholder": "Odaberite kategoriju",
"cd.d": "d",
"cd.expired": "Isteklo",
"cd.h": "h",
"cd.m": "min",
"ck.accept": "Prihvati",
"ck.acceptAll": "Prihvati sve",
"ck.customize": "Prilagodi",
"ck.learn": "Saznaj više",
"ck.manage": "Upravljanje kolačićima",
"ck.measurement": "Mjerenje publike",
"ck.measurementDesc": "Anonimna statistika za poboljšanje usluge.",
"ck.msg": "Koristimo kolačiće za održavanje rada stranice i mjerenje publike.",
"ck.necessary": "Nužno",
"ck.necessaryDesc": "Bitno za rad stranice. Uvijek uključeno.",
"ck.refuse": "Odbij",
"ck.save": "Spremi moje odabire",
"ck.saved": "Postavke spremljene",
"ck.title": "Vaše postavke kolačića",
"cm.found": "PRONAĐENO",
"cm.lost": "IZGUBLJENO",
"cmp.adv": "Napredno",
"cmp.ai": "AI usklađivanje",
"cmp.autobill": "Automatsko fakturiranje",
"cmp.basic": "Osnovno",
"cmp.community": "Zajednica",
"cmp.consol": "Konsolidirano fakturiranje",
"cmp.custom": "Prilagođeno",
"cmp.dedicated": "Posvećeno",
"cmp.deploy": "Posvećeno implementacija & SLA",
"cmp.estIncl": "Uključena poduzeća",
"cmp.estSec": "Dodatno poduzeće",
"cmp.items": "Predmeti / mjesečno",
"cmp.main": "1 glavni",
"cmp.max20": "20 max",
"cmp.members": "Pozivnice članovima",
"cmp.onQuote": "Prilagođena ponuda",
"cmp.priority": "Prioritet",
"cmp.starterEst": "1 uključeno + neograničeno dodatno",
"cmp.stats": "Statistika",
"cmp.statsAdv": "Napredno",
"cmp.statsBasic": "Osnovno",
"cmp.support": "Podrška",
"cmp.unlimited": "Neograničeno",
"cmp.upTo3": "Do 3",
"consent.required": "Morate se složiti da podijelite svoje kontakt podatke kako biste nastavili.",
"consent.share": "Slažem se da pronalazač mog predmeta može vidjeti moje kontakt podatke (ime, e-pošta, telefon) kako bi me kontaktirao za povrat.",
"cover.add": "Dodaj",
"cover.change": "Promijeni",
"cover.helper": "Prikazano kao banner na vašoj stranici izvještaja i u imeniku.",
"cover.none": "Nema fotografije naslovnice",
"cover.remove": "Ukloni",
"cover.title": "Fotografija naslovnice",
"crop.desc": "Prilagodite okvir omjeru bannera (3:1). Povucite i zumirajte.",
"crop.saving": "Spremam…",
"crop.title": "Izreži naslovnu fotografiju",
"cta.button": "Izradi moj partnerski račun",
"cta.subtitle": "Pridruži se ustanovama koje brže vraćaju predmete s findloop-om.",
"cta.title": "Spreman za smanjenje izgubljenih predmeta?",
"db.account.s": "Upravljajte svojom ustanovom, pretplatom i QR kodom.",
"db.account.t": "Moj račun",
"db.declarations.s": "Kupci koji su prijavili izgubljeni predmet putem vašeg QR koda.",
"db.declarations.t": "Prijave gubitka",
"db.deposit.s": "Dodajte fotografiju, kategoriju i opis.",
"db.deposit.t": "Zabilježite pronađeni predmet",
"db.registry.s": "Svi pronađeni predmeti zabilježeni u vašoj ustanovi.",
"db.registry.t": "Registar predmeta",
"db.reviews.s": "Javno odgovorite na recenzije svojih kupaca.",
"db.reviews.t": "Recenzije kupaca",
"db.shipments.s": "Generirajte oznake i pratite pakete za slanje.",
"db.shipments.t": "Pošiljke",
"db.stats.s": "Vaši ključni pokazatelji uspješnosti.",
"db.stats.t": "Statistika",
"db.team.s": "Pozovite svoje kolege da upravljaju predmetima.",
"db.team.t": "Tim",
"dc.partnerDesc": "Izgubili ste predmet na partnerskoj lokaciji (hotel, stanica, dvorana…)? Odaberite ga za izravni povrat.",
"dc.partnerList": "Odaberite s popisa",
"dc.partnerMap": "Odaberite na karti",
"dc.partnerTitle": "Prijava na partneru",
"dc.publicCta": "Objavite javni oglas",
"dc.publicDesc": "Vaš oglas će biti vidljiv cijeloj Findloop zajednici. Idealno ako ne znate gdje ste izgubili predmet.",
"dc.publicTitle": "Javna prijava",
"dc.subtitle": "Odaberite kako prijaviti svoj izgubljeni predmet.",
"dc.title": "Što biste htjeli učiniti?",
"dec.addrPending": "Adresa na čekanju od kupca",
"dec.analyzing": "Analiziranje…",
"dec.badge": "Prijava gubitka",
"dec.category": "Kategorija predmeta",
"dec.clientDescription": "Opis kupca",
"dec.clientPhoto": "Fotografija koju je dao kupac",
"dec.clientPhotoShort": "Kupčeva fotografija",
"dec.comparePhotos": "Uporedite fotografije",
"dec.contactTitle": "Vaši kontakt podaci",
"dec.date": "Datum gubitka",
"dec.declaredItemPhoto": "Fotografija prijavljenog predmeta",
"dec.descPh": "Opisujte predmet: marka, boja, posebne oznake…",
"dec.description": "Opis",
"dec.email": "Email",
"dec.emptyDesc": "Podijelite svoj QR kod kako biste primili prijave.",
"dec.emptyTitle": "Nema prijava",
"dec.enlarge": "Povećaj",
"dec.extBanner": "{n} vanjska uplata(e) za potvrdu - potvrdite primitak u nastavku kako biste otključali preuzimanje ili slanje.",
"dec.foundItemAlt": "Pronađeni predmet",
"dec.foundItemRegistry": "Pronađeni predmet (registar)",
"dec.home": "Povratak na početnu",
"dec.labelClient": "Kupac",
"dec.labelRegistry": "Registar",
"dec.matchFound": "Podudaranje je već identificirano!",
"dec.name": "Puno ime",
"dec.noMatchYet": "Još nema podudaranja.",
"dec.noPhoto": "Nema fotografije",
"dec.notfound": "Partner nije pronađen.",
"dec.pRecup": "oporavak",
"dec.pRecupP": "(oporavak)",
"dec.pRecupShip": "(oporavak + slanje)",
"dec.payConfirmed": "Plaćanje {x} potvrđeno",
"dec.payPending": "Vanjsko plaćanje {x} na čekanju",
"dec.phone": "Telefon",
"dec.pickup": "Osobno preuzimanje",
"dec.place": "Mjesto gubitka",
"dec.placePh": "npr. kod šanka, soba 204…",
"dec.recoverBtn": "Povrati svoju stavku",
"dec.reject": "Odbaci",
"dec.rerun": "Ponovno pokreni analizu",
"dec.similarity": "Sličnost {n}%",
"dec.submit": "Pošalji moj izvještaj",
"dec.submitting": "Šaljem…",
"dec.successText": "Tražimo vašu stavku među onima koje imamo na",
"dec.successTitle": "Izvještaj poslan!",
"dec.suggestedMatches": "Preporučeni podudarnosti",
"dec.toColon": " do:",
"dec.toShip": "Za slanje",
"dec.toastExtPay": "Plaćanje potvrđeno — kupac će biti obaviješten.",
"dec.toastMatch": "Podudaranje potvrđeno",
"dec.toastReject": "Preporuka odbijena",
"dec.toastRerun": "Analiza ponovo pokrenuta",
"dec.toastVisualN": "{n} vizualno podudaranje",
"dec.toastVisualNone": "Nema vizualnog podudaranja",
"dec.trackBtn": "Prati moj izvještaj",
"dec.viewBeforeAfter": "Prikaz prije/poslije (preklapanje)",
"dec.viewSideBySide": "Paralelni prikaz",
"dec.visualCompare": "AI vizualna usporedba",
"dec.visualIdle": "Pokrenite usporedbu kako bi AI vizualno usporedio fotografiju kupca sa pronađenim stavkama.",
"dec.visualRunning": "AI uspoređuje fotografiju kupca sa stavkama u vašem registru…",
"dec.zoomPhoto": "Povećaj fotografiju",
"dep.addAnyway": "Dodaj unatoč tome",
"dep.addError": "Greška prilikom dodavanja",
"dep.addItem": "Dodaj stavku",
"dep.added": "Stavka dodana u registar!",
"dep.adding": "Dodajem…",
"dep.aiError": "AI analiza trenutno nije dostupna.",
"dep.aiFilled": "Obrazac unaprijed ispunjen od strane AI ✨",
"dep.aiUnavailable": "AI nije dostupan — ispunite obrazac ručno.",
"dep.analyzing": "Analiziram…",
"dep.analyzingPhoto": "Analiziram fotografiju…",
"dep.brand": "Marka",
"dep.brandPlaceholder": "npr. Apple",
"dep.category": "Kategorija",
"dep.checkingDup": "Provjeravam duplikate…",
"dep.color": "Boja",
"dep.colorPlaceholder": "npr. crna",
"dep.condition": "Stanje",
"dep.conditionPlaceholder": "npr. dobro stanje",
"dep.depositorNote": "Napomena depozitora",
"dep.depositorNoteHint": "Operativni detalji napisani ručno. AI nikada ne prepisuje ovu napomenu.",
"dep.depositorNotePlaceholder": "npr. sadržaj torbice, marka kako je prijavljeno, detalji koje je dao osoba…",
"dep.descPlaceholder": "npr. crni iPhone 15 s prozirnim kućištem, pronađen kod šanka…",
"dep.description": "Opis",
"dep.dupHint": "Pobrinite se da ne dodajete duplikat. Možete nastaviti ako je stavka stvarno drugačija.",
"dep.dupTitle": "Slične stavke već registrirane",
"dep.dupWarn": "Otkriven sličan predmet — pregledajte, a zatim kliknite ponovo za potvrdu.",
"dep.estHint": "Stavka će biti dodana u registar ove ustanove.",
"dep.establishment": "Ustanova",
"dep.fee": "Naknada za povrat (€) — opcionalno",
"dep.feePlaceholder": "Ostavite prazno za zadanu cijenu kategorije",
"dep.fillAI": "Ispuni s AI",
"dep.optional": "(opcionalno)",
"dep.photo": "Fotografija predmeta",
"dep.principal": "primarni",
"dep.reqError": "Kategorija i opis su obavezni.",
"dep.savedItem": "Registrirani predmet",
"dep.similarity": "Sličnost",
"dep.storage": "Fizička lokacija",
"dep.storageHint": "Gdje je predmet fizički pohranjen. QR kod će biti generiran za pronalaženje.",
"dep.storagePlaceholder": "npr. Polica A3, Ormar 12, Reception sef",
"dl.aClient": "kupac",
"dl.alertsBlocked": "Blokirani preglednički obavijesti",
"dl.alertsBlockedHint": "Da biste ih ponovo omogućili: kliknite na 🔒 (ili ⓘ) ikonu lijevo od adrese web stranice, zatim dopustite Obavijesti i ponovno učitajte stranicu.",
"dl.amountDue": "Iznos dugovanja: {amount} {currency}.",
"dl.enableAlerts": "Omogući obavijesti",
"dl.extPending": "Plaćanja na odobrenje",
"dl.freemiumNear": "Približavate se Freemium granici ({used}/{max} predmeta ovog mjeseca). Nadogradite na Starter za neograničene predmete.",
"dl.freemiumReached": "Freemium granica postignuta ({used}/{max} predmeta ovog mjeseca). Nadogradite na Starter da registrirate neograničene predmete.",
"dl.invoiceOverdue": "Račun {num} neplaćen — pristup je ograničen.",
"dl.matchNotifTitle": "Findloop — Nova AI podudarnost 🔔",
"dl.matchToast": "Nova AI podudarnost — {name}",
"dl.matchToastDesc": "Jedan predmet odgovara izjavi.",
"dl.notifEmpty": "Još nema obavijesti.",
"dl.notifEnabled": "Pregledničke obavijesti omogućene",
"dl.notifTitle": "Obavijesti",
"dl.payInvoice": "Plati moj račun →",
"dl.rewardsPending": "Kuponi za predstavljanje",
"dl.upgradeStarter": "Nadogradi na Starter →",
"est.all": "Sva poduzeća ({n})",
"est.label": "Poduzeće",
"est.primary": "primarni",
"est.secondary": "sekundarni",
"est2.add": "Dodaj poduzeće",
"est2.addressLabel": "Adresa",
"est2.addressPh": "Ulica Republike 12",
"est2.autoInvoice": "Detaljni račun se automatski generira prvog dana svakog mjeseca.",
"est2.baseSub": "Osnovna pretplata",
"est2.billing": "Računanje",
"est2.boostActivated": "Povećanje aktivirano za {name}",
"est2.boostBillingNote": "Naplaćeno po trenutnoj cijeni i grupirano na vašem konsolidiranom mjesečnom računu.",
"est2.boostCta": "Povećaj",
"est2.boostDesc": "Povećajte vidljivost ovog poduzeća u imeniku i na karti.",
"est2.boostDuration": "{h}h povećane vidljivosti",
"est2.boostExtend": "Produži",
"est2.boostTitle": "Povećaj {name}",
"est2.boosted": "Povećano",
"est2.chartDesc": "Postotak vraćenih predmeta od ukupno registriranih, po lokacijama.",
"est2.chartTitle": "Stopa vraćanja po poduzeću",
"est2.chartTooltip": "Vraćanje",
"est2.cityLabel": "Grad",
"est2.cityPh": "Lyon",
"est2.contactHint": "Ovi podaci se prikazuju kupcu za ovo poduzeće (vraća se na račun ako je prazan).",
"est2.countryLabel": "Država",
"est2.coverLabel": "Naslovna fotografija",
"est2.create": "Kreiraj",
"est2.created": "Poduzeće kreirano",
"est2.delete": "Izbriši",
"est2.deleteDesc": "Ova akcija je trajna. Možete izbrisati poduzeće samo ako ne sadrži predmete.",
"est2.deleteTitle": "Izbriši “{name}”?",
"est2.deleted": "Poduzeće obrisano",
"est2.dialogDesc": "Unesite naziv i adresu ovog objekta.",
"est2.edit": "Uredi",
"est2.editEst": "Uredi objekt",
"est2.emailLabel": "Kontakt e-mail",
"est2.emailPh": "kontakt@site.com",
"est2.estSuffix": " objekt(a)",
"est2.extraNoteBase": "{n} dodatni objekt(a) naplaćeni",
"est2.extraPrice": " po {price} €/mj.",
"est2.extraQuote": " na ponudi.",
"est2.imgChange": "Odaberite sliku",
"est2.imgDone": "Gotovo",
"est2.imgRemove": "Ukloni",
"est2.imgRemoved": "Slika uklonjena",
"est2.imgSaved": "Slika spremljena",
"est2.imgUploading": "Učitavanje…",
"est2.includedPlan": "Uključeno u vaš plan: {n}.",
"est2.kDeclarations": "Izjave",
"est2.kInStorage": "U skladištu",
"est2.kItemsTotal": "Predmeti (ukupno)",
"est2.kRestituted": "Vraćeno",
"est2.limitReached": "Dosegnut limit",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Izj.",
"est2.mItems": "Predmeti",
"est2.mRestituted": "Vraćeno",
"est2.mStorage": "U skladištu",
"est2.monthlyTotal": "Mjesečni ukupno",
"est2.nameLabel": "Naziv *",
"est2.namePh": "npr. Belmont Hotel — Lyon Annex",
"est2.newEst": "Novi objekt",
"est2.onQuote": "Na ponudi",
"est2.phoneLabel": "Telefon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plan",
"est2.planLimited": "Vaš “{tier}” plan je ograničen na {max} objekata.",
"est2.primary": "Primarni",
"est2.qr": "QR kod",
"est2.qrDesc": "Prikažite ovaj QR kod u ovom objektu. Kupci koji prijave gubitak bit će povezani s ovom stranicom.",
"est2.qrTitle": "QR kod — {name}",
"est2.saving": "Spremanje…",
"est2.seeInvoices": "Pogledajte moje mjesečne račune",
"est2.seePlans": "Pogledajte planove",
"est2.subtitle": "Upravite svim svojim mjestima iz jednog računa — objedinjeni prikaz, predmeti, QR kod i naplata.",
"est2.suspended": "Suspendirano",
"est2.tierFree": "1 objekt",
"est2.tierLarge": "neograničeni objekti",
"est2.tierMedium": "5 uključeno objekata",
"est2.tierSmall": "3 uključena objekta",
"est2.title": "Objekti",
"est2.unlimitedPlan": "Vaš plan dopušta neograničeni broj objekata.",
"est2.unlimitedSuffix": " · neograničeno",
"est2.updated": "Objekt ažuriran",
"est2.upgradeHint": "Ažurirajte na viši plan kako biste dodali više mjesta i centralizirali sve svoje aktivnosti.",
"est2.visuals": "Logo i fotografija",
"est2.visualsDesc": "Prilagodite logo i naslovnu fotografiju ovog objekta. Pojavljuju se na njegovoj javnoj stranici i obrascu izjave.",
"est2.visualsTitle": "Vizuali — {name}",
"est2.workOn": "Radite na ovom objektu",
"est2.working": "Radite na “{name}”",
"ev.created": "Izvještaj kreiran",
"ev.matched": "Identificirani odgovarajući predmet",
"ev.paid": "Naknada za povrat plaćena",
"ev.pickup": "Preuzimanje na lokaciji",
"ev.shipped": "Paketa poslan",
"ev.shipping_paid": "Naknada za dostavu plaćena",
"ev.shipping_requested": "Zahtev za dostavu",
"feat1.d": "KPIs, stopa povrata po kategoriji, prihodi i trendovi u posljednjih 30 dana.",
"feat1.t": "Nadzorna ploča & analitika",
"feat2.d": "Naljepnice, praćenje prijevoznika i automatski e-mailovi za praćenje.",
"feat2.t": "Modul za dostavu",
"feat3.d": "Kupci vas nalaze prema gradu i kategoriji, s provjerenim recenzijama.",
"feat3.t": "Javni direktorij & recenzije",
"fp.backToRanking": "Povratak na ljestvicu",
"fp.badge": "Pečat",
"fp.hero": "Finder Hero",
"fp.notFound": "Profil nije pronađen ili je privatni.",
"fp.scoreTotal": "Ukupni bodovi",
"fp.scoreYear": "Bodovi u",
"fp.share": "Podijeli ovaj profil",
"fp.shareText": "Provjerite {name}'s finder profil na Findloop!",
"fp.tagline": "Iskreni pronalazač čini svijet boljim mjestom.",
"ft.backAccount": "Povratak na Moj račun",
"ft.closeBtn": "Zatvori slučaj",
"ft.closeConfirm": "Potvrdite da je stavka vraćena? Oglas će biti zatvoren.",
"ft.closeLockedHint": "Prvo potvrdite vlasnikov kod za otključavanje zatvaranja.",
"ft.closed": "Slučaj zatvoren — stavka vraćena!",
"ft.codeLabel": "Unesite kod za potvrdu koji ste dobili od vlasnika",
"ft.codeNeeded": "Molimo unesite kod za potvrdu.",
"ft.codeOk": "Kod potvrđen — možete zatvoriti slučaj.",
"ft.codePlaceholder": "npr. 4821",
"ft.codeVerified": "Potvrđeno",
"ft.doneMsg": "Stavka vraćena. Hvala što ste pomogli da se vrati vlasniku!",
"ft.stepInProgress": "Povrat u tijeku",
"ft.stepPublished": "Oglas objavljen",
"ft.stepReturned": "Stavka vraćena",
"ft.subtitle": "Pratite korake dok se pronađena stavka ne vrati.",
"ft.title": "Praćenje povrata",
"ft.verifyBtn": "Potvrdi kod",
"hero.badge": "Istaknuto",
"hero.ctaFound": "Pronašao sam stavku",
"hero.ctaLost": "Izgubio sam stavku",
"hero.ctaPartner": "Postanite partner",
"hero.subtitle": "Findloop pomaže ustanovama u upravljanju pronađenim stavkama — i omogućuje njihovim kupcima da prijave gubitak i vrate svoje stvari, na lokaciji ili slanjem.",
"hero.title": "Svaka izgubljena stavka pronalazi svog vlasnika.",
"home.champBecome": "Postanite pronalazač",
"home.champCta": "Pogledajte ljestvicu",
"home.champSubtitle": "Svaka vraćena stavka donosi bodove. Pridružite se ljestvici i osvojite nagrade.",
"home.champTitle": "Naši vrhunski pronalazači",
"how.eyebrow": "Kako to funkcionira",
"how.title": "Od predaje do povrata, bez napora.",
"inv.all": "Sve",
"inv.allYears": "Sve godine",
"inv.count": "Računi",
"inv.due": "dospjelo",
"inv.empty": "Još nema računa.",
"inv.exportCsv": "Izvezi CSV",
"inv.invoicePdf": "PDF računa",
"inv.issued": "Izdano",
"inv.noMatch": "Nema računa za ovaj filtar.",
"inv.paid": "Plaćeno (€)",
"inv.paidOn": "plaćeno na",
"inv.pay": "Plati",
"inv.receipt": "Račun",
"inv.reminders": "Podsjetnici",
"inv.remindersDesc": "Podsjetnici putem e-pošte i SMS-a poslani za ovaj račun.",
"inv.remindersEmpty": "Nema poslanih podsjetnika.",
"inv.rmDue": "Podsjetnik na datum dospijeća",
"inv.rmManual": "Ručno podsjećanje",
"inv.rmSms": "SMS podsjetnik D+30",
"inv.rmStage": "Podsjetnik",
"inv.statusPaid": "Plaćeno",
"inv.statusUnpaid": "Neplaćeno",
"inv.subtitle": "Pregledajte i preuzmite svoje račune i potvrde.",
"inv.title": "Moji računi",
"inv.unpaid": "Neplaćeno (€)",
"inv2.contractTitle": "Moj Findloop ugovor",
"inv2.detailByEst": "Detalji po ustanovi",
"inv2.dueLabel": "Dospijeće:",
"inv2.dueSuffix": " · dospjelo {date}",
"inv2.error": "Greška {status}",
"inv2.estCountIssued": "{n} ustanova · izdano {date}",
"inv2.estimate": "Ponuda (nije naplaćena) · {n} ustanova",
"inv2.expired": " · istekao",
"inv2.exportCsv": "Izvezi CSV",
"inv2.exportDone": "CSV izvoz preuzet",
"inv2.included": "Uključeno",
"inv2.monthlyTitle": "Mjesečno naplaćivanje (pretplata)",
"inv2.months": "+{n} mjeseci",
"inv2.paid": "Plaćeno",
"inv2.pay": "Plati",
"inv2.previewTitle": "Pregled vašeg sljedećeg računa —",
"inv2.renew": "Obnovi moj ugovor",
"inv2.renewalsTitle": "Povijest obnove ({n})",
"inv2.renewedUntil": "Ugovor obnovljen do {date}",
"inv2.serviceTitle": "Računi za usluge (naplata i ponude)",
"inv2.soon": "Istiće uskoro",
"inv2.toPay": "Za platiti",
"inv2.totalHtTva": "Ukupno bez PDV-a · PDV",
"inv2.totalTtc": "Ukupno s PDV-om",
"iu.addPhoto": "Dodaj fotografiju",
"iu.change": "Promijeni",
"lang.label": "Jezik",
"lb.allCountries": "Sve zemlje",
"lb.badge": "Godišnja ljestvica",
"lb.champion": "🏆 Šampion godine",
"lb.cityPh": "Filtriraj po gradu…",
"lb.empty": "Nema rangiranja za ove filtre.",
"lb.pts": "bodova",
"lb.resetNote": "Ljesta trenutne godine — resetira se svakog 1. siječnja.",
"lb.returned": "vraćeno",
"lb.share": "Dijeli ljestvicu",
"lb.shareText": "Pogledajte najbolju ljestvicu pronalazača na findu!",
"lb.subtitle": "Svaki povrat donosi bodove. Ljestvica se resetira svakog 1. siječnja.",
"lb.tabFinders": "Pronalazači",
"lb.tabPartners": "Ustanove",
"lb.title": "Najbolji pronađivači",
"lost.b2bDesc": "Izgubili ste ga u hotelu, prometnom čvorištu ili partnerskom objektu? Pronađite ustanovu i prijavite svoju izgubljenu stvar.",
"lost.b2bTitle": "Prijavite partneru",
"lost.b2cDesc": "Objavite oglas vidljiv svima, ponudite nagradu i promovirajte ga kako biste povećali svoje šanse.",
"lost.b2cTitle": "Objavite javni oglas",
"lost.desc": "Odaberite kako želite nastaviti.",
"lost.title": "Izgubili ste predmet?",
"map.allCategories": "Sve kategorije",
"map.clear": "Ponovno postavi",
"map.exitFullscreen": "Izlaz",
"map.filterCity": "Grad ili država…",
"map.fullscreen": "Cjeloviti zaslon",
"map.heatmap": "Toplinska mapa",
"map.high": "Visoko",
"map.impactMonth": "predmeti vraćeni ovog mjeseca",
"map.impactTotal": "ukupno vraćeno",
"map.legend": "Obojene točke od crvene (nisko) do zelene (visoko) temeljem stope vraćanja; veličina prema broju predmeta.",
"map.locating": "Lokacija… dodajte adresu svojim ustanovama da biste ih vidjeli na karti.",
"map.low": "Nisko",
"map.mAll": "Sve",
"map.mFound": "Pronađeno",
"map.mLost": "Izgubljeno",
"map.medium": "Srednje",
"map.noItemRegistered": "Nema registrovanih predmeta",
"map.noItems": "Nema predmeta",
"map.period30": "Posljednjih 30 dana",
"map.period7": "Posljednjih 7 dana",
"map.period90": "Posljednjih 90 dana",
"map.periodAll": "Sve vrijeme",
"map.returnedSuffix": "vraćeno · {a}/{t} predmeta",
"map.stats": "Statistika grada",
"map.statsTop": "Top 5 mjesta (izgubljeni predmeti)",
"map.statsTrend": "Trend u posljednjih 6 mjeseci",
"map.title": "Karta vaših ustanova",
"map.topPlaces": "Popularna mjesta",
"mc.adClosed": "Oglas zatvoren",
"mc.addPhoto": "Dodaj fotografiju",
"mc.adsNone": "Nema oglasa za izgubljene predmete.",
"mc.archiveHide": "Sakrij povijest",
"mc.archiveNone": "Nema riješenih slučajeva još.",
"mc.archiveShow": "Prikaži povijest",
"mc.archiveSub": "Riješeni i vraćeni slučajevi.",
"mc.archiveTitle": "Povijest",
"mc.at": "Na",
"mc.backToLogin": "Povratak na prijavu",
"mc.boostContacts": "Kontakti (pojačaj)",
"mc.boostViews": "Prikazi (pojačaj)",
"mc.cancel": "Otkaži",
"mc.certificate": "Certifikat",
"mc.changePhoto": "Promijeni fotografiju",
"mc.city": "Grad",
"mc.closeAd": "Zatvori",
"mc.closeAdConfirm": "Zatvoriti ovaj oglas? Neće više biti vidljiv i oslobodit će slot.",
"mc.confirmPassword": "Potvrdi lozinku",
"mc.confirmRestitution": "Potvrdi vraćanje",
"mc.connect": "Poveži",
"mc.contacts": "Kontakti",
"mc.country": "Država",
"mc.declareFound": "Prijavite pronađeni predmet",
"mc.declareFoundSub": "Objavite predmet koji ste pronašli",
"mc.declareLost": "Prijavite gubitak",
"mc.declareLostSub": "Objavite oglas za izgubljeni predmet",
"mc.deleteAccount": "Izbriši svoj račun",
"mc.deleteConfirm": "Da, izbriši moj račun",
"mc.deleteConfirmBody": "Vaš račun će biti trajno izbrisan i vaši osobni podaci će biti anonimni. Ova radnja se ne može poništiti.",
"mc.deleteConfirmTitle": "Izbrisati svoj račun?",
"mc.deleteDesc": "Trajno briše vaš račun i anonimizira vaše osobne podatke. Ova akcija se ne može poništiti.",
"mc.deleted": "Vaš račun je obrisan.",
"mc.deleting": "Brišem…",
"mc.email": "Email",
"mc.expiresOn": "Ističe",
"mc.exportData": "Preuzmi moje podatke (GDPR)",
"mc.exportDone": "Vaši podaci su preuzeti.",
"mc.exporting": "Priprema…",
"mc.finderAccepted": "Prihvaćeno",
"mc.finderProfile": "Finder profil (opcionalno)",
"mc.finderProfileDesc": "Zaradite bodove vraćanjem predmeta i pojavite se na javnoj ljestvici.",
"mc.forYourAd": "Za vašu ponudu",
"mc.forgotLink": "Zaboravili ste lozinku?",
"mc.forgotSend": "Pošaljite link",
"mc.forgotSent": "Ako račun postoji za ovu email adresu, link za ponovno postavljanje je upravo poslan.",
"mc.forgotTitle": "Zaboravljena lozinka",
"mc.foundAdsNone": "Nema objavljenih oglasa za pronađene predmete.",
"mc.foundAt": "Pronađeno na",
"mc.foundNone": "Nema prijavljenih pronađenih predmeta.",
"mc.hAd": "Oglas za izgubljeni predmet",
"mc.hDeclaration": "Izjava",
"mc.hFinderContact": "Prijavljen predmet",
"mc.hFound": "Vraćeni predmet",
"mc.hFoundAd": "Oglas za pronađeni predmet",
"mc.histEarned": "Predmet vraćen",
"mc.historyTitle": "Povijest mojih bodova",
"mc.loginBtn": "Prijavite se",
"mc.loginTitle": "Prijava korisnika",
"mc.logout": "Odjavite se",
"mc.lostAt": "Izgubljeno na",
"mc.matchPartner": "Kod partnera",
"mc.matchPublic": "Pronađeni predmet",
"mc.matches": "Podudaranja",
"mc.matchesSub": "Pronađeni predmeti mogu se podudarati s vašim oglasima za izgubljene predmete.",
"mc.myAds": "Moji oglasi za izgubljene predmete",
"mc.myDeclarations": "Moje prijave",
"mc.myFinds": "Predmeti koje sam pronašao",
"mc.myFindsNone": "Još niste prijavili pronalazak nijednog predmeta.",
"mc.myFindsSub": "Predmeti koje ste prijavili da ste pronašli u oglasima za izgubljene predmete.",
"mc.myFound": "Prijavljeni pronađeni predmeti",
"mc.myFoundAds": "Moji oglasi za pronađene predmete",
"mc.myRewards": "Moji vaučeri",
"mc.name": "Puno ime",
"mc.newPassword": "Nova lozinka",
"mc.none": "Još nema prijave.",
"mc.notEnough": "Nedovoljno bodova",
"mc.notifEmpty": "Još nema obavijesti.",
"mc.notifOpen": "Pogledajte",
"mc.notifTitle": "Obavijesti",
"mc.notifTrack": "Praćenje",
"mc.notifViewAd": "Pogledajte oglas",
"mc.optInDesc": "Opcionalno sudjelovanje. Pristajete na objavu predmeta odabranih u nastavku. Moguće promijeniti u bilo kojem trenutku.",
"mc.optInTitle": "Pojavite se na javnoj ljestvici",
"mc.password": "Lozinka",
"mc.passwordMismatch": "Lozinke se ne podudaraju.",
"mc.phone": "Telefon",
"mc.photoUpdated": "Profilna slika ažurirana",
"mc.pointsAwaiting": "Bodovi na čekanju",
"mc.pointsBalance": "Bodovi za potrošiti",
"mc.pointsOk": "Bodovi dodijeljeni",
"mc.presentHint": "Pokažite ovaj QR partneru: oni ga skeniraju kako bi potvrdili vašu nagradu.",
"mc.presentInStore": "Pokaži u trgovini",
"mc.presentTitle": "Pokaži ovaj vaučer",
"mc.privacy": "Privatnost i podaci",
"mc.privacyDesc": "Preuzmite kopiju svih osobnih podataka koje Findloop posjeduje o vama (GDPR, članak 15. i 20.).",
"mc.profileSaved": "Profil ažuriran.",
"mc.profileSettings": "Javni profil i ljestvica",
"mc.pseudo": "Ime ili nadimak",
"mc.redExpired": "Isteklo",
"mc.redReady": "Pokaži partneru",
"mc.redUsed": "Iskorišteno",
"mc.redeem": "Iskoristi",
"mc.registerBtn": "Napravite moj račun",
"mc.registerTitle": "Napravite korisnički račun",
"mc.rememberMe": "Zapamti me",
"mc.remove": "Ukloni",
"mc.resetDone": "Lozinka ažurirana. Sada se možete prijaviti.",
"mc.resetExpired": "Ova poveznica za resetiranje je nevažeća ili je istekao rok. Zatražite novu ispod.",
"mc.resetSave": "Resetiraj moju lozinku",
"mc.resetTitle": "Nova lozinka",
"mc.restitutionConfirmed": "Povrat potvrđen.",
"mc.reward": "Nagrada",
"mc.rewardRedeemed": "Nagrada otključana! Kod:",
"mc.rewardsDesc": "Iskoristite svoje bodove za pogodnosti koje nude naši partneri. Stanje:",
"mc.rewardsNone": "Nema dostupne nagrade još.",
"mc.rewardsTitle": "Potroši moje bodove",
"mc.scoreAwarded": "Odlično! +1 vašem Finder Score 🎉",
"mc.scoreEarned": "Bod zarađen",
"mc.scorePts": "bodova",
"mc.scoreThisYear": "Ove godine",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Pogledajte ljestvicu",
"mc.share": "Podijeli",
"mc.statsTitle": "Statistika",
"mc.subtitle": "Pratite sve vaše izvještaje na jednom mjestu.",
"mc.title": "Moj račun",
"mc.toLogin": "Već ste registrirani?",
"mc.toRegister": "Još nemate račun?",
"mc.track": "Pratite",
"mc.views": "Prikazi",
"mc.visCity": "Grad",
"mc.visCountry": "Država",
"mc.visLabel": " stavke vidljive na ljestvici:",
"mc.visName": "Ime / nadimak",
"mc.visPhoto": "Profilna slika",
"mc.welcome": "Zdravo",
"mc2.acceptFinder": "Prihvatite ovog findera",
"mc2.accountActivity": "Aktivnost računa",
"mc2.adsActive": "{n}/5 aktivnih oglasa",
"mc2.autoDelete": "Automatsko brisanje zakazano za",
"mc2.badgeBronze": "Brončano",
"mc2.badgeGold": "Zlatno",
"mc2.badgeSilver": "Srebrno",
"mc2.boostEarnedAlready": "Već vam je donio",
"mc2.boostEarnedWin": "Dalo vam je",
"mc2.boostExpiredWin": "Vaš boost je upravo istekao — obnovite sa -20%!",
"mc2.boostExpiresIn": "Vaš boost istječe za",
"mc2.boostWinDetail2": ". -20% se automatski primjenjuje ako obnovite unutar 24h.",
"mc2.claimCode": "Kod za preuzimanje:",
"mc2.codeSentFinder": "Kod poslan finderu putem e-pošte",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Preuzmi moj račun",
"mc2.error": "Pogreška {status}",
"mc2.finderAccepted": "Finder prihvaćen — kod poslan putem e-pošte",
"mc2.finderContacts": "Detalji kontakta findera",
"mc2.followFindo": "Prati Findloop",
"mc2.imgInvalid": "Nevažeća slika",
"mc2.inactivityNote": " — u slučaju {n} mjeseci neaktivnosti (GDPR).",
"mc2.lastActivity": "Zadnja aktivnost:",
"mc2.lostEmailTitle": "Više nemam pristup svojoj e-pošti",
"mc2.noPhotoPreset": "Još nema fotografije? Odaberi zadani avatar:",
"mc2.paidViaPartner": "Plaćeno (putem partnera)",
"mc2.payRecovery": "Plati trošak oporavka",
"mc2.paySettle": "Izmirim svoju uplatu",
"mc2.payShipping": "Plati trošak dostave",
"mc2.payUnavailable": "Plaćanje nije dostupno",
"mc2.peopleFound": "{n} osoba(e) misle da su pronašli vašu stavku",
"mc2.phoneNumber": "Broj telefona",
"mc2.reactivateAccount": "Ponovno aktiviraj svoj račun",
"mc2.reactivated": "Račun ponovno aktiviran",
"mc2.reactivatedThanks": "Račun ponovno aktiviran — hvala na vašoj vjernosti!",
"mc2.recoverSmsBtn": "Dohvati svoj kod putem SMS-a",
"mc2.recoverSmsDesc": "Primite svoj kod zahtjeva putem SMS-a na broj registriran na vašem računu.",
"mc2.recoverSmsFallback": "Ako račun postoji s ovim brojem, SMS je poslan.",
"mc2.renewStayTop": ". Obnovite kako biste ostali na vrhu i povratili svoju stavku.",
"mc2.resume20": "Nastavi -20%",
"mc2.unlockContacts": "Otključaj podatke o kontaktu",
"mc2.unlockDesc": "Platite trošak obrade findloop-a da otkrijete njihove podatke o kontaktu i dogovorite predaju.",
"mc2.viewsWord": "pogleda",
"mc2.live": "Uživo",
"mh.allCategories": "Sve kategorije",
"mh.allPeriod": "Sve vrijeme",
"mh.autoMatch": "Automatska AI podudarnost",
"mh.blocked": "Blokirano (protuslov)",
"mh.blockedReason": "Podudaranje blokirano: glavne ključne riječi stavke i izjava proturječe jedna drugoj.",
"mh.days30": "Zadnjih 30 dana",
"mh.days7": "Zadnjih 7 dana",
"mh.days90": "Zadnjih 90 dana",
"mh.emptyDesc": "AI podudaranja će se ovdje pojaviti kako se izjave primaju.",
"mh.emptyTitle": "Nema događaja",
"mh.exportCsv": "Izvezi CSV",
"mh.exportDone": "CSV izvoz preuzet",
"mh.exportImpossible": "Izvoz nije uspio",
"mh.fBlocked": "Blokirano",
"mh.fConfirmed": "Potvrđeno",
"mh.fRejected": "Odbijeno",
"mh.objectLabel": "Stavka:",
"mh.refresh": "Osvježi",
"mh.rejected": "Odbijeno",
"mh.srcManual": "Ručno",
"mh.srcText": "Tekst",
"mh.srcVisual": "Vizualno (slika)",
"mh.subtitle": "Zapis o podudaranjima predloženim od strane AI — automatski podudarni, potvrđeni i odbijeni.",
"mh.title": "AI Povijest",
"nav.ads": "Izgubljene stavke",
"nav.dashboard": "Moj prostor",
"nav.found": "Pronađene stavke",
"nav.how": "Kako to funkcionira",
"nav.login": "Prijavi se",
"nav.map": "Karta",
"nav.more": "Više",
"nav.partners": "Partneri",
"nav.pricing": "Cijene",
"nav.ranking": "Utrka",
"nav.register": "Postanite partner",
"nav.track": "Pratite prijavu",
"nf.desc": "Stranica koju tražite ne postoji ili je premještena.",
"nf.home": "Povratak na početnu",
"nf.title": "Stranica nije pronađena",
"par.allCities": "Sve grads",
"par.allCountries": "Sve zemlje",
"par.badge": "Imenik",
"par.certified": "Certificirani",
"par.certifiedBadge": "Certificirani",
"par.cityPh": "Grad",
"par.declare": "Prijavi",
"par.none": "Nema pronađenih partnera.",
"par.partnerBadge": "Partner",
"par.searchPh": "Pretraži ustanovu…",
"par.subtitle": "Pronađite ustanovu gdje ste izgubili svoj predmet i prijavite gubitak.",
"par.title": "Naši partneri",
"pay.addr1": "Adresa",
"pay.addr2": "Adresa (opcionalno)",
"pay.addrIncomplete": "Molimo ispunite svoju adresu za isporuku.",
"pay.badge": "Povrat",
"pay.card": "Plaćanje karticom",
"pay.city": "Grad",
"pay.country": "Zemlja",
"pay.eurNote": "Iznosi su prikazani u eurima (€).",
"pay.fee": "Naknada za povrat",
"pay.free": "besplatno",
"pay.howRecover": "Kako želite dobiti svoj predmet natrag?",
"pay.momo": "Plaćanje mobilnim novcem",
"pay.momoConfirm": "Potvrdite uplatu",
"pay.noMatch": "Za ovu prijavu još nije potvrđen niti jedan odgovarajući predmet.",
"pay.notfound": "Prijava nije pronađena.",
"pay.phonePh": "Broj telefona",
"pay.pickup": "Preuzmi osobno",
"pay.pickupDesc": "Na",
"pay.postal": "Poštanski broj",
"pay.secure": "Sigurna uplata",
"pay.serviceFee": "Findloop naknada za uslugu",
"pay.ship": "Pošaljite mi",
"pay.shipAfter": "— ponuđeno nakon plaćanja.",
"pay.shipDesc": "Dostava na moju adresu",
"pay.shipNote": "Dostava dostupna",
"pay.shipping": "Naknada za dostavu",
"pay.subtitleWith": "Platite naknadu za povrat na",
"pay.title": "Povrat mog predmeta",
"pay.total": "Ukupno",
"pcat.city_hall": "Gradske uprave",
"pcat.hotel": "Hoteli",
"pcat.other": "Ostalo",
"pcat.park": "Parkovi",
"pcat.prefecture": "Prefekture",
"pcat.restaurant": "Restorani",
"pcat.uncategorized": "Nekategorizirano",
"pd.about": "O",
"pd.back": "Svi partneri",
"pd.certified": "Certificirani partner",
"pd.declare": "Prijavite gubitak ovdje",
"pd.itemsReturned": "vraćeni artikli",
"pd.itemsTotal": "registrirani artikli",
"pd.map": "Lokacija",
"pd.noItems": "Nema nedavno pronađenih artikala.",
"pd.noReviews": "Još nema recenzija.",
"pd.notFound": "Partner nije pronađen.",
"pd.recentItems": "Nedavno pronađeni artikli",
"pd.reply": "Odgovor iz objekta",
"pd.reviews": "Recenzije kupaca",
"pd.verified": "Potvrđena recenzija",
"pd.verifiedEstablishment": "Findloop verificirani objekt",
"pg.next": "Sljedeće",
"pg.prev": "Prethodno",
"pg.showing": "{from}–{to} od {total}",
"pk.bodyCopy": "Tekst",
"pk.bodyText": "Tijelo teksta",
"pk.brandColors": "Boje branda",
"pk.colorRed": "Crvena",
"pk.colorWhite": "Bijela",
"pk.darkBg": "Tamna pozadina",
"pk.download": "Preuzmi",
"pk.downloadZip": "Preuzmi cijeli paket (ZIP)",
"pk.headings": "Naslovi",
"pk.heroDesc": "Službeni logotipi, bannere za društvene mreže, boje i tipografiju. Odaberite jezik i varijantu slogana, zatim preuzmite vizual ili cijeli paket.",
"pk.lightBg": "Svijetla pozadina (tiskano)",
"pk.logoWordmark": "Logotip / oznaka",
"pk.logosVisuals": "Logotipi i vizuali",
"pk.mapCollect": "Karta / punktovi za prikupljanje",
"pk.plain": "Jednostavno",
"pk.pressKit": "Press kit",
"pk.taglineLang": "Jezik slogana",
"pk.typography": "Tipografija",
"pk.variant": "Varijanta",
"pr.shipBtn": "Dostavite artikl",
"pr2.adBoostMsg": "Odličan izbor! Množite svoje šanse za brzo vraćanje artikla.",
"pr2.boostActivated": "Povećanje aktivirano!",
"pr2.canRecoverNow": "Sada možete povratiti svoj artikl.",
"pr2.continue": "Nastavi",
"pr2.downloadReceiptPdf": "Preuzmi račun (PDF)",
"pr2.goToSpaceNow": "Idite na moj račun sada",
"pr2.partnerBoostMsg": "Odličan izbor! Veća vidljivost znači privlačenje novih kupaca u vaš objekt.",
"pr2.paymentSuccess": "Plaćanje uspješno!",
"pr2.redirectingSpace": "Preusmjeravanje na vaš račun…",
"pr2.subActivated": "Plaćanje uspješno! Vaša pretplata je aktivna, sada možete upravljati svojim objektima.",
"prev.allSites": "Svi objekti",
"prev.editReply": "Uredi odgovor",
"prev.none": "Još nema recenzija.",
"prev.published": "Odgovor objavljen",
"prev.reply": "Odgovor",
"prev.replyPh": "Napišite ljubazan odgovor…",
"prev.send": "Objavi odgovor",
"prev.sending": "Objavljivanje…",
"prev.yourReply": "Vaš odgovor",
"pricing.annual": "Godišnje",
"pricing.annualBadge": "-20% ponuda",
"pricing.choose": "Odaberite",
"pricing.compareFeature": "Karakteristika",
"pricing.compareTitle": "Usporedi planove",
"pricing.eyebrow": "Cijene",
"pricing.month": "/mj",
"pricing.monthly": "Mjesečno",
"pricing.perYear": "/god",
"pricing.popular": "Popularno",
"pricing.quoteMsg": "Vaše potrebe (opcionalno)",
"pricing.quoteOrg": "Organizacija",
"pricing.quoteSend": "Pošaljite zahtjev",
"pricing.quoteSent": "Zahtjev poslan! Javit ćemo vam se uskoro.",
"pricing.quoteSites": "Broj stranica / terminala",
"pricing.quoteTitle": "Zahtjev za ponudu",
"pricing.requestQuote": "Zahtjev za ponudu",
"pricing.saveLabel": "Uštedite",
"pricing.savePerYear": "/god po dodatnom ustanovljenju",
"pricing.start": "Počnite",
"pricing.subtitle": "Počnite besplatno, rastite kako rastete.",
"pricing.title": "Plan za svaku organizaciju",
"promo.badge": "Partnerski program",
"promo.cta": "Saznaj više",
"promo.text": "Svaki partner kojeg preporučite i koji se pretplaćuje daje vam jedan besplatan mjesec. Bez ograničenja.",
"promo.title": "Preporučite partnera, dobijte besplatan mjesec.",
"pub.accessGranted": "Pristup odobren",
"pub.accessLimited2h": "Pristup ograničen na 2 sata",
"pub.accountEmailConcerned": "Email naloga koji se tiče",
"pub.adAppearPublic": "Ovako će se vaša reklama javno prikazivati.",
"pub.adPreviewBtn": "Pregled reklame",
"pub.alertMeOnArrival": "Obavijestite me po dolasku",
"pub.allActionsLogged": "Sve radnje su zabilježene",
"pub.allCategories": "Sve kategorije",
"pub.authorizeAccess": "Odobrite pristup",
"pub.authorizeSupportQ": "Odobravam pristup podršci?",
"pub.available": "Dostupno",
"pub.backHome": "Povratak na početnu",
"pub.boostAdCta": "Povećajte svoju reklamu",
"pub.boostAdTitle": "Povećajte svoju reklamu",
"pub.boostCarouselSub": "Premjestite se na vrh stranice u „Povećanom” karuselu i povećajte pregleda kako biste brže povratili svoj predmet.",
"pub.boostEstablishment": "Povećajte svoju ustanovu",
"pub.boostEstablishmentDesc": "Prikazujte se na vrhu direktorija s oznakom „Povećano” i privucite više izvještaja.",
"pub.boostFicheCta": "Povećajte moj popis",
"pub.brandReady": "Marka Findloop, spremna za upotrebu",
"pub.cantFindItem": "Ne možete pronaći svoj predmet?",
"pub.cantProcessImage": "Ne može se obraditi ova slika",
"pub.claimQr": "Zatražite QR kod",
"pub.clickToZoom": "Kliknite za zumiranje",
"pub.codeAlreadyValidated": "Kod je verificiran — kontakti otključani.",
"pub.codeExample": "npr. ABCD2345",
"pub.confirmRenewal": "Potvrdite obnovu",
"pub.contactIntro": "Imate pitanje, zahtjev? Pišite nam, javit ćemo vam se uskoro.",
"pub.contactTypeDeceased": "Brisanje računa (preminula osoba)",
"pub.contactTypeGeneral": "Opće pitanje",
"pub.contactTypeSupport": "Podrška / tehnički problem",
"pub.contactUs": "Kontaktirajte nas",
"pub.continueWithoutEmail": "Nastavite bez ostavljanja mog emaila",
"pub.contractLabel": "Ugovor",
"pub.contractNotFound": "Ugovor nije pronađen ili je već istekao.",
"pub.contractRenewed": "Ugovor obnovljen!",
"pub.contractRenewedFor": "Vaš ugovor je obnovljen na {n} mjeseci.",
"pub.copyFailed": "Kopiranje nije uspjelo",
"pub.createPartnerAccount": "Kreirajte svoj partnerski račun",
"pub.currentDeadline": "Trenutni rok",
"pub.deceasedInfo": "Kao rođak ili nasljednik, možete zatražiti brisanje računa Findloop preminule osobe. Obradit ćemo vaš zahtjev u skladu s GDPR-om (može se zatražiti dostava potpornih dokumenata).",
"pub.declareMyLoss": "Prijavite svoj gubitak",
"pub.describeItemPlaceholder": "Opišite svoju stavku (npr. crni kišobran, ključevi…)",
"pub.downloadImage": "Preuzmi sliku",
"pub.drawSignature": "Nacrtajte svoj potpis.",
"pub.drawSignatureHint": "Nacrtajte svoj potpis mišem ili prstom.",
"pub.duration": "Trajanje",
"pub.eSignature": "Elektronički potpis",
"pub.eSignatureDesc": "Unesite svoje ime za potpis. Datum se automatski bilježi.",
"pub.edit": "Uredi",
"pub.editorialTitles": "Urednički naslovi",
"pub.emailPlaceholder": "vi@primjer.com",
"pub.enterCodeUnlockOwner": "Unesite kod primljen putem e-pošte za otključavanje podataka o kontaktu vlasnika.",
"pub.errorWord": "Greška",
"pub.foundSelfService": "Pronađeni predmeti · Samoposluga",
"pub.haveOwnerCode": "Primio/la sam kod od vlasnika",
"pub.home": "Početna",
"pub.immediateRenewal": "Odmah obnavljanje, bez nove ponude.",
"pub.impAdminReq1": "Administrator",
"pub.impAdminReq2": "traži dopuštenje za privremeni pristup vašem računu",
"pub.impAdminReq3": "da bi vam pomogao.",
"pub.impGrantedDesc": "Tim podrške moći će pristupiti vašem računu najviše 2 sata. Svaka radnja će biti zabilježena. Možete zatvoriti ovu stranicu.",
"pub.invitedOnFindo": "Pozvani ste na Findloop",
"pub.isThisYourItem": "Je li ovo vaša stavka?",
"pub.itemsAvailableCount": "{n} stavka(e) trenutno dostupna(e)",
"pub.itemsFoundOwner": "povjerenih stvari pronašle su vlasnika",
"pub.itemsReturnedOwners": "stavke vraćene njihovim vlasnicima",
"pub.itsMine": "Moje je",
"pub.joinFindoDesc": "Pridružite se findu i jednostavno upravljajte svojim pronađenim stavkama.",
"pub.joinInvitesYou": "vas poziva da se pridružite findu. Kreirajte svoj partnerski račun za upravljanje pronađenim stavkama.",
"pub.linkCopied": "Veza kopirana!",
"pub.loadingContract": "Učitavanje ugovora…",
"pub.lsClaimDesc": "Prijavite svoj gubitak da ga povratite. Ostavite svoju e-poštu i poslat ćemo vam podsjetnik ako vaša prijava nije završena.",
"pub.lsHeroDesc": "Provjerite sami je li vaša izgubljena stavka pronađena i ostavljena ovdje. Pronašli ste je? Prijavite to kako biste je povratili.",
"pub.lsSearchTitle": "Pretraži pronađene stavke",
"pub.makeOffer": "Napravite ponudu",
"pub.makeOfferDesc": "Predložite svoj iznos. Superadministrator će ga pregledati.",
"pub.mapNearYou": "Predmeti i partneri u vašoj blizini",
"pub.mapWord": "Karta",
"pub.messageSentToast": "Poruka poslana — naš tim će uskoro odgovoriti.",
"pub.messageWord": "Poruka",
"pub.momoInitiated": "Pokrenuta uplata putem mobilnog novca",
"pub.monthsWord": "mjesece",
"pub.nameConsentRequired": "Ime i pristanak su obavezni.",
"pub.newDeadline": "Novi rok",
"pub.noActionRequired": "Nema potrebnih radnji.",
"pub.noAmountCharged": "Nema naplaćene svote.",
"pub.noItemMatch": "Trenutno nema dostupne stavke koja odgovara vašoj pretrazi.",
"pub.noMatchingItem": "Nema odgovarajuće stavke",
"pub.noPaymentSession": "Nema sesije plaćanja.",
"pub.noPhoto": "Nema slike",
"pub.noPointsYet": "Još nema bodova za prikaz.",
"pub.noSecondPayment": "Za ovu stavku nije potrebna druga uplata.",
"pub.notHereYet": "Još nije ovdje? Obavijestite se čim stigne.",
"pub.notifyDone": "Zabilježeno! Obavijestit ćemo vas putem e-pošte čim stigne odgovarajuća stavka.",
"pub.offerSubmitted": "Vaša ponuda je poslana.",
"pub.oops": "Ups",
"pub.orAlertEmail": "Ili se obavijestite putem e-pošte čim stigne odgovarajuća stavka:",
"pub.ownerContacts": "Podaci o kontaktu vlasnika",
"pub.ownerContactsUnlocked": "Podaci o kontaktu vlasnika otključani",
"pub.partnerContact": "Kontakt partnera",
"pub.payLinkUnavailable": "Veza za uplatu nije dostupna — kontaktirajte partnera.",
"pub.paymentCancelled": "Plaćanje otkazano",
"pub.paymentConfirmed": "Plaćanje potvrđeno 🎉",
"pub.paymentConfirmedDesc": "Primiti ćete e-mail s detaljima za oporavak vašeg predmeta.",
"pub.paymentNotConfirmed": "Plaćanje nije potvrđeno",
"pub.paymentNotConfirmedDesc": "Plaćanje nije moglo biti verificirano. Pokušajte ponovo ili kontaktirajte partnera.",
"pub.paymentProcessing": "Plaćanje se obrađuje. Osvježite za trenutak.",
"pub.photoAdded": "✓ Fotografija dodana",
"pub.photoRequired": "Potrebna je fotografija predmeta.",
"pub.previewAlt": "pregled",
"pub.publish": "Objavi",
"pub.publishingWord": "Objavljujem…",
"pub.qty": "Količina",
"pub.quoteDeclined": "Ponuda odbijena.",
"pub.quoteNotFound": "Ponuda nije pronađena ili je istekao rok.",
"pub.reasonLabel": "Razlog",
"pub.recoveryAlreadyPaid": "Naknada za oporavak već plaćena",
"pub.referralCode": "Kod za preporuku:",
"pub.relationshipPlaceholder": "Sin, suprug, javni bilježnik…",
"pub.renewYourContract": "Obnovite svoj ugovor",
"pub.renewalFailed": "Obnova nije uspjela. Pokušajte ponovo kasnije.",
"pub.renewing": "Obnavljam…",
"pub.replySoon": "Naš tim će odgovoriti što je prije moguće.",
"pub.requestGone": "Ova molba više ne postoji.",
"pub.requestHandled": "Molba već obrađena",
"pub.requestNotFound": "Molba nije pronađena ili je istekao rok.",
"pub.requestUnavailable": "Molba nije dostupna",
"pub.required": "(obavezno)",
"pub.retroClosing": "Zajedno, čini svijet malo manje izgubljenim.",
"pub.retroClosing2": "Zajedno, čini svijet malo manje izgubljenim.",
"pub.retroScroll": "Godina oporavka onoga što je važno. Pomaknite se dolje ↓",
"pub.revokeAnytime": "Možete opozvati u bilo kojem trenutku kontaktirajući nas",
"pub.scene": "Scena",
"pub.sendImpossible": "Nemoguće poslati",
"pub.sendMessage": "Pošaljite poruku",
"pub.sending": "Šaljem…",
"pub.sharePreview": "Dijeli pregled",
"pub.shareYourAd": "Dijelite svoju reklamu",
"pub.signedSuccess": "Uspješno potpisano!",
"pub.signerFullName": "Puno ime potpisnika",
"pub.spreadNetwork": "Podijelite s onima oko sebe kako biste povećali svoje šanse.",
"pub.spreadOwner": "Podijelite kako biste pomogli vlasniku da povrati svoje stvari.",
"pub.statusLabel": "Status:",
"pub.subject": "Predmet",
"pub.thanksSent": "Hvala, vaša poruka je poslana.",
"pub.thisYear": "Ove godine",
"pub.validate": "Potvrdi",
"pub.verifyingPayment": "Verificiranje plaćanja…",
"pub.verifyingYourPayment": "Verificiranje vašeg plaćanja…",
"pub.viewAd": "Pogledajte oglas →",
"pub.viewPartner": "Pogledajte partnera →",
"pub.yourAdPreview": "Pregled vašeg oglasa",
"pub.yourEmail": "Vaša e-mail adresa",
"pub.yourEmailRecommended": "Vaša e-mail adresa (preporučeno)",
"pub.yourEmailShort": "Vaša e-mail adresa",
"pub.yourName": "Vaše ime",
"pub.yourRelationship": "Vaš odnos s osobom",
"qv.acceptAndSign": "Prihvatite i potpišite svoju ponudu",
"qv.certifyAuthorized": "Potvrđujem da sam ovlašten za potpisivanje i prihvaćam uvjete ovog {what} (obvezujuća vrijednost).",
"qv.clear": "Obriši",
"qv.client": "Klijent",
"qv.conditions": "Uvjeti",
"qv.confirmDecline": "Potvrditi odbijanje ove ponude?",
"qv.countersignedFindo": "Potpisano od strane Findloop · {name} na {date}",
"qv.decline": "Odbij",
"qv.description": "Opis",
"qv.downloadPdf": "Preuzmi PDF",
"qv.handwrittenSignature": "Ručni potpis",
"qv.inclTax": "Uključ. PDV",
"qv.invalidAmount": "Neispravan iznos.",
"qv.invoice": "Račun",
"qv.invoicePaid": "Račun plaćen",
"qv.issuer": "Izdavač",
"qv.messageOptional": "Poruka (opcionalno)",
"qv.negotiatedAmount": "Pregovaran iznos",
"qv.payInvoiceOnline": "Plati račun online",
"qv.quote": "Ponuda",
"qv.quoteValidDays": "Ponuda važi {n} dana.",
"qv.sendMyOffer": "Pošalji moju ponudu",
"qv.signContract": "Potpiši moj ugovor",
"qv.signNow": "Potpiši sada",
"qv.signatureAlt": "Potpis",
"qv.signedByOn": "✔ Potpisano od {name} na {date}",
"qv.stContractSigned": "Ugovor potpisan. Hvala!",
"qv.stCounterAccepted": "Vaša ponuda je prihvaćena! Potpišite svoj ugovor niže.",
"qv.stCounterRefused": "Vaša ponuda nije mogla biti prihvaćena.",
"qv.stCountered": "Vaša ponuda je poslana. Čekamo odgovor finda.",
"qv.stDeclined": "Odbili ste ovu ponudu.",
"qv.stSigned": "Ponuda prihvaćena i potpisana. Hvala!",
"qv.totalHt": "Ukupno bez PDV-a",
"qv.totalTtc": "Ukupno s PDV-om",
"qv.unitHt": "Jedinica bez PDV-a",
"qv.vat": "PDV",
"qv.yourProposedAmount": "Vaš predloženi iznos ({cur})",
"rate.chooseNote": "Molimo vas odaberite ocjenu.",
"rate.commentPh": "Komentar (opcionalno)…",
"rate.home": "Natrag na početnu",
"rate.submit": "Pošalji moju recenziju",
"rate.submitting": "Šaljem…",
"rate.subtitle": "Kako je prošlo vraćanje vašeg predmeta?",
"rate.successText": "Vaša povratna informacija pomaže drugim korisnicima.",
"rate.successTitle": "Hvala na vašoj recenziji!",
"rate.title": "Ocijenite svoje iskustvo",
"reg.add": "Zabilježite predmet",
"reg.allBrands": "Sve marke",
"reg.allColors": "Sve boje",
"reg.allLocations": "Sve lokacije",
"reg.detailDesc": "Detalji i akcije za ovaj pronađeni predmet.",
"reg.dispAuction": "Aukcija",
"reg.dispAuthorities": "Predano vlastima",
"reg.dispDestroyed": "Uništeno",
"reg.dispDonate": "Donacija u dobrotvorne svrhe",
"reg.dispositionHint": "Zabilježite predmet koji napušta skladište. Broji se u statistikama prema kategoriji.",
"reg.emptyCta": "Zabilježite predmet",
"reg.emptyDesc": "Započnite tako da zabilježite svoj prvi pronađeni predmet.",
"reg.emptyTitle": "Nema pronađenih predmeta",
"reg.establishmentFallback": "ustanova",
"reg.lblAuctioned": "naveden na aukciji",
"reg.lblAuctionedShort": "aukcioniran",
"reg.lblAuthorities": "predano vlastima",
"reg.lblDestroyed": "uništeno",
"reg.lblDonated": "donirano u dobrotvorne svrhe",
"reg.legalCount": "{n} stavka(e): dosegnut pravni rok čuvanja",
"reg.legalHint": "Možete ih staviti na aukciju, donirati dobrotvornoj organizaciji ili prijaviti predaju vlastima.",
"reg.legalLimitCountry": "Rok: {date} · primjenjena država: {country}",
"reg.legalOver": "Rok je prošao: {date} · {country}",
"reg.legalReached": "Pravni rok dosegnut",
"reg.legalReachedFull": "Dosegnut pravni rok čuvanja",
"reg.limitShort": "rok",
"reg.location": "Lokacija",
"reg.markRestituted": "Označi kao vraćeno",
"reg.markedAs": "Stavka označena kao {label}",
"reg.moveHistory": "Povijest kretanja",
"reg.overBy": "prešao za {n}d",
"reg.physicalLocation": "Fizička lokacija",
"reg.popupBlocked": "Dopustite iskačuće prozore za ispis oznaka.",
"reg.popupBlockedOne": "Dopustite iskačuće prozore za ispis oznake.",
"reg.printLabel": "Ispiši oznaku",
"reg.printN": "Ispiši {n} oznaku(e)",
"reg.qrCodeItem": "QR kod stavke",
"reg.qrLabelTitle": "QR oznaka",
"reg.qrLabelsTitle": "QR oznake",
"reg.qrNotFound": "Nema stavke za ovaj QR kod.",
"reg.qrScanHint": "Skenirajte za izravni pristup ovom zapisu i pronalazak lokacije.",
"reg.recoveryFee": "Naknada za oporavak (€)",
"reg.searchPh": "Pretraži prema opisu…",
"reg.selectQr": "Odaberite za ispis QR oznaka",
"reg.selectedN": "{n} odabrano",
"reg.shipPricePh": "Cijena dostave (€)",
"reg.shippingPossible": "Dostava dostupna",
"reg.storagePh": "npr. Polica A3, Ormar 12",
"reg.tAuction": "Aukcija na Findloop",
"reg.tAuthorities": "Prijava predaje vlastima",
"reg.tDonate": "Doniraj u dobrotvorne svrhe",
"reg.toastFee": "Naknada ažurirana",
"reg.toastLocation": "Lokacija spremljena",
"reg.toastRestituted": "Stavka označena kao vraćena",
"reg.toastShipping": "Opcija dostave ažurirana",
"reg.toastTransferred": "Stavka prenesena na “{name}”",
"reg.unclaimedDisposition": "Neodobrena stavka — konačna disposicija",
"res.codeValidated": "Kod je potvrđen",
"res.empty": "Još nema zabilježenih vraćanja.",
"res.error": "Greška {status}",
"res.proofPdf": "PDF dokaz",
"res.signed": "Potpisano",
"res.stRestituted": "Predano osobno",
"res.stShipped": "Vraćeno putem dostave",
"res.subtitle": "Sve završene predaje, s njihovim preuzimljivim potpisanim dokazima.",
"res.title": "Povijest vraćanja",
"rev.b2b": "B2B partneri",
"rev.b2c": "Kupci",
"rev.based": "na temelju {n} recenzija",
"rev.eyebrow": "Svjedočanstva",
"rev.restitutedBy": "Vratio {org}",
"rev.storiesEyebrow": "Sretni završeci",
"rev.storiesSubtitle": "Prave priče kupaca koji su povratili svoje stvari uz pomoć findloop.",
"rev.storiesTitle": "Pronašli su svoje stvari!",
"rev.subtitle": "Partneri i kupci dijele svoja iskustva.",
"rev.title": "Vjeruju Findloop",
"rev.verified": "Potvrđeno",
"rp.already": "Već ste prijavili ovu ponudu.",
"rp.comment": "Detalji (opcionalno)",
"rp.duplicate": "Duplikat",
"rp.fraud": "Prevara / laž",
"rp.inappropriate": "Neprikladan sadržaj",
"rp.offensive": "Uvredljiv sadržaj",
"rp.other": "Drugo",
"rp.reason": "Razlog",
"rp.report": "Prijavi",
"rp.send": "Pošalji prijavu",
"rp.sent": "Prijava poslana. Hvala na doprinosu.",
"rp.spam": "Spam / oglašavanje",
"rp.title": "Prijavi ovu ponudu",
"rp.wrongCategory": "Pogrešna kategorija",
"rt.annualGoal": "Godšnji cilj",
"rt.championCity": "Grad pobjednik",
"rt.cityRate": "{rate}% stopa povrata",
"rt.goalProgress": "{rate}% postignuto od {target}% cilja",
"rt.reached": "Postignuto 🎉",
"rt.restitutionRate": "Stopa povrata",
"rt.shareRecap": "Dijeli moj pregled",
"rt.thanks": "Hvala ti Findloop {year} 💛",
"rt.yourRecap": "Tvoj pregled za {year}",
"rw.active": "Aktivno",
"rw.add": "Dodaj",
"rw.camUnavailable": "Kamera nedostupna. Unesite kod ručno u nastavku.",
"rw.codeValidated": "Kod verificiran",
"rw.codesTitle": "Kodovi koje su iskoristili tražitelji",
"rw.confirmDelete": "Izbriši “{title}”?",
"rw.deleted": "Izbrisano",
"rw.edit": "Uredi",
"rw.editReward": "Uredi nagradu",
"rw.empty": "Još nema nagrade.",
"rw.expired": "Isteklo",
"rw.expiresOn": "Ima rok do {date}",
"rw.fActive": "Aktivno (vidljivo tražiteljima)",
"rw.fCost": "Trošak (bodovi)",
"rw.fDesc": "Opis",
"rw.fStock": "Zaliha (prazno = neograničeno)",
"rw.fTitle": "Naslov",
"rw.fValidity": "Važenje vaučera (dani nakon isplate)",
"rw.inactive": "Neaktivno",
"rw.newReward": "Nova nagrada",
"rw.noExchange": "Još nema isplate.",
"rw.pageSubtitle": "Skenirajte vaučere koje su predstavili tražitelji da biste potvrdili njihove nagrade.",
"rw.redeemedN": "Isplaćeno: {n}×",
"rw.saved": "Nagrada spremljena",
"rw.scanVoucher": "Skeniraj vaučer",
"rw.staffScanOnly": "Skeniraj samo",
"rw.statActive": "Za prikaz",
"rw.statExpired": "Isteklo",
"rw.statRedeemed": "Vaučeri isplaćeni",
"rw.statUsed": "Verificirano",
"rw.stock": "Zaliha",
"rw.subtitle": "Ponudite nemonetarne pogodnosti (vaučere, nadogradnje…) koje tražitelji unovčavaju za svoje Finder Score bodove.",
"rw.title": "Nagrade za tražitelje",
"rw.used": "Korišteno",
"rw.validate": "Verificiraj",
"rw.validateCode": "Verificiraj kod",
"rw.validity": "Važenje: {n} d",
"shell.f1d": "Automatski povežite izgubljene i pronađene predmete.",
"shell.f1t": "Pametno AI usklađivanje",
"shell.f2d": "Pratite stopu povrata i prihode u stvarnom vremenu.",
"shell.f2t": "Dashboard & prihodi",
"shell.f3d": "Vaši kupci prijavljuju u 30 sekundi.",
"shell.f3t": "Partner QR kod",
"shell.title": "Pretvorite izgubljene predmete u zadovoljne kupce.",
"ship.addr1": "Adresa",
"ship.addr2": "Linija adrese 2 (opcionalno)",
"ship.badge": "Isporuka",
"ship.city": "Grad",
"ship.country": "Država",
"ship.needPaid": "Prvo platite naknadu za povrat kako biste zatražili isporuku.",
"ship.notShippable": "Ovaj predmet nije dostupan za isporuku.",
"ship.notfound": "Izvještaj nije pronađen.",
"ship.postal": "Poštanski broj",
"ship.price": "Naknada za isporuku",
"ship.submit": "Zatraži isporuku",
"ship.submitting": "Slanje…",
"ship.subtitle": "Unesite svoju adresu za dostavu.",
"ship.successText": "Partner će pripremiti vašu pošiljku. Bit ćete obaviješteni kada bude poslana.",
"ship.successTitle": "Zahtjev za isporuku poslan!",
"ship.title": "Naručite isporuku svog predmeta",
"ship.weight": "Procijenjena težina (kg)",
"shp.carrier": "Dostavljač",
"shp.download": "Preuzmi PDF",
"shp.generating": "Generiram…",
"shp.label": "Generiraj oznaku",
"shp.none": "Nema zatraženih isporuka.",
"shp.setTracking": "Spremi praćenje",
"shp.status": "Status",
"shp.to": "Primatelj",
"shp.tracking": "Broj za praćenje",
"shp.trackingSaved": "Praćenje spremljeno",
"side.account": "Moj račun",
"side.declarations": "Izvještaji",
"side.deposit": "Prijavi predmet",
"side.establishments": "Ustanove",
"side.invoices": "Računi",
"side.logout": "Odjavi se",
"side.matchHistory": "AI Povijest",
"side.partner": "Partner",
"side.refresh": "Osvježi",
"side.registry": "Registar",
"side.restitutions": "Povrat",
"side.reviews": "Recenzije",
"side.rewards": "Nagrade & Vaučeri",
"side.settings": "Postavke",
"side.shipments": "Pošiljke",
"side.stats": "Statistika",
"side.storage": "Skladište & QR",
"side.team": "Tim",
"side.viewSite": "Pogledajte javnu stranicu",
"st.auctioned": "Prodano na aukciji",
"st.claimed": "Zatraženo",
"st.closed": "Zatvoreno",
"st.delivered": "Isporučeno",
"st.destroyed": "Uništeno",
"st.donated": "Donirano (humanitarno)",
"st.handed_to_authorities": "Predano vlastima",
"st.in_storage": "U skladištu",
"st.matched": "Podudaranje pronađeno",
"st.open": "Otvoreno",
"st.paid": "Plaćeno",
"st.pending": "Na čekanju",
"st.resolved": "Riješeno",
"st.restituted": "Vraćeno",
"st.second_chance": "Druga prilika",
"st.shipped": "Poslano",
"st.shipping_requested": "Zatražena dostava",
"st.submitted": "Poslano",
"st.verified": "Potvrđeno",
"stat.items": "Registrirani predmeti",
"stat.partners": "Partneri",
"stat.restituted": "Vraćeni predmeti",
"status.auctioned": "Pruženo na aukciji",
"status.destroyed": "Uništeno",
"status.donated": "Donirano (dobrotvorno)",
"status.handed_to_authorities": "Predano vlastima",
"status.in_storage": "U skladištu",
"status.matched": "Podudaranje",
"status.open": "Otvoreno",
"status.paid": "Plaćeno",
"status.pending": "Na čekanju",
"status.restituted": "Vraćeno",
"status.shipped": "Poslano",
"status.shipping_requested": "Zatražena dostava",
"status.submitted": "Poslano",
"step1.tag": "Ustanova",
"step1.text": "U nekoliko sekundi, ustanova bilježi pronađeni predmet s fotografijom, kategorijom i opisom. Sve je centralizirano u jasnom, sigurnom registru.",
"step1.title": "Partner registrira predmet",
"step2.tag": "Kupac",
"step2.text": "Putem partnerovog QR koda, vaš kupac opisuje izgubljeni predmet u 30 sekundi. Nema potrebe za instalacijom aplikacije — sve se odvija u pregledniku.",
"step2.title": "Kupac prijavljuje gubitak",
"step3.tag": "Inteligencija",
"step3.text": "Naš pametni sustav uspoređuje opise i predlaže najvjerojatnija podudaranja, spremna za potvrdu.",
"step3.title": "AI povezuje izgubljeni i pronađeni predmet",
"step4.tag": "Povrat",
"step4.text": "Nakon sigurnog plaćanja naknade za povrat, kupac preuzima predmet na licu mjesta — ili ga prima putem praćene dostave.",
"step4.title": "Kupac dobiva svoj predmet natrag",
"stg.allLabels": "Sve QR oznake",
"stg.camHint": "Koristite ručni unos u nastavku.",
"stg.camStarting": "Pokreće kameru…",
"stg.camUnavailable": "Kamera nije dostupna.",
"stg.clear": "Obriši",
"stg.clearAll": "Obriši sve",
"stg.codeUnreadable": "Nečitljiv kod.",
"stg.emptyDesc": "Pohranjeni predmeti će se ovdje pojaviti, grupirani prema lokaciji.",
"stg.emptyTitle": "Nema predmeta u skladištu",
"stg.exportAudit": "Izvezi revizijski CSV",
"stg.exportDone": "CSV izvoz preuzet",
"stg.exportImpossible": "Izvoz trenutno nije dostupan.",
"stg.itemFound": "Predmet pronađen ✅",
"stg.kLocations": "Korištene lokacije",
"stg.kObjects": "Pohranjeni predmeti",
"stg.kToClear": "Lokacije za brisanje",
"stg.locFreed": "Lokacija očišćena",
"stg.locsFreed": "{n} lokacija(e) očišćena(e)",
"stg.manualLabel": "Ili unesite kod / ID predmeta",
"stg.manualPh": "Zalijepite ID ili URL QR-a",
"stg.noItemMatch": "Nema predmeta koji odgovara ovom QR-u / kodu.",
"stg.noLocation": "Nema lokacije",
"stg.objectsAxis": "Stavke",
"stg.objectsN": "{n} stavka(e)",
"stg.occAvg": "prosječno {n} stavki/lokaciju",
"stg.occHint": "Lokacije u narančastoj boji prelaze prosjek (moguće preopterećene).",
"stg.occupancy": "Zauzetost lokacije",
"stg.openPage": "Otvori stranicu",
"stg.posterPdf": "PDF plakat (A4)",
"stg.printAll": "Ispis svih",
"stg.printGroupTitle": "Ispiši oznake za ovu policu",
"stg.qrAlt": "QR samoposluživanje",
"stg.qrDownload": "Preuzmi QR",
"stg.qrHint": "Prikažite ovaj QR na pultu: vaši kupci ga skeniraju kako bi provjerili je li njihova stavka dostupna.",
"stg.qrTitle": "QR za samoposluživanje kupaca",
"stg.scanDesc": "Skenirajte oznaku stavke da biste odmah otvorili njen zapis.",
"stg.scanQr": "Skenirajte QR",
"stg.scanTitle": "Skenirajte QR kod",
"stg.search": "Pretraži",
"stg.shelf": "Polica {loc}",
"stg.shelfPlan": "Plan police",
"stg.staleHint": "Obrišite ove lokacije kako biste održali fizičku inventuru ažurnom.",
"stg.staleTitle": "{n} stavka(e) su napustile skladište, ali i dalje imaju lokaciju",
"stg.subtitle": "Plan police, QR skener i praćenje fizičke inventure.",
"stg.title": "Skladište & QR",
"stt.acceptRate": "Stopa prihvaćanja",
"stt.accepted": "Prihvaćeno",
"stt.activity30": "Aktivnost (posljednjih 30 dana)",
"stt.ai6mo": "Posljednjih 6 mjeseci · prihvaćeno = automatski podudareno + potvrđeno.",
"stt.aiEmpty": "Još nema AI podudaranja u ovom razdoblju.",
"stt.aiTitle": "AI podudaranja — prihvaćena vs odbijena",
"stt.auctionShort": "Aukcija",
"stt.auctionedSold": "Aukcionirano (prodano)",
"stt.authShort": "Ovlasti",
"stt.authorities": "Predano vlastima",
"stt.avgRating": "Prosječna ocjena",
"stt.awaitingRestitution": "stavke čekaju vraćanje",
"stt.boostClicks": "Klikovi na vaš direktorij ovog tjedna zahvaljujući pojačanju",
"stt.boostInactive": "Pojačanje neaktivno — omogućite ga za vidljivost",
"stt.certifiedPremium": "Premium certificirano",
"stt.declarations": "Deklaracije",
"stt.destroyed": "Uništeno",
"stt.dispoEmpty": "Još nema nepreuzetih stavki koje su napustile skladište.",
"stt.donatedAssoc": "Donirano (dobrotvorno)",
"stt.donatedShort": "Donirano",
"stt.gateCta": "Otkrijte planove",
"stt.gateDesc": "Nadogradite na Starter da biste otključali vašu osnovnu statistiku, ili na Business za naprednu statistiku i analizu po objektima.",
"stt.gateTitle": "Statistika rezervirana za plaćene planove",
"stt.inStorage": "U skladištu",
"stt.kItems": "Registrirane stavke",
"stt.kRate": "Stopa povrata",
"stt.kRestituted": "Vraćene stavke",
"stt.kRevenue": "Prihod (mjesec)",
"stt.noDeclYet": "Još nema deklaracija.",
"stt.recapDownloaded": "Sažetak preuzet — spreman za dijeljenje!",
"stt.recapError": "Nije moguće generirati sažetak",
"stt.recapText": "Naš Findloop sažetak {year}: vraćene stavke i zadovoljstvo kupaca 🎉",
"stt.recapTitle": "Findloop sažetak {year}",
"stt.rejected": "Odbijeno",
"stt.restitutions": "Povrati",
"stt.shareRecap": "Dijeli moj sažetak {year}",
"stt.topCategories": "Najčešće deklarirane kategorije",
"stt.unclaimedDesc": "Volumen predmeta koji su uništeni, donirani dobrotvornim organizacijama i prodani na aukcijama, po kategorijama.",
"stt.unclaimedTitle": "Nepretrži predmeti — napuštanje skladišta",
"stt.vsLastWeek": "u odnosu na prošli tjedan",
"sub.cancel": "Otkaži moju pretplatu",
"sub.cancelAbort": "Otkaži",
"sub.cancelConfirm1": "Jeste li sigurni da želite otkazati? Vaš pristup ostaje aktivan do",
"sub.cancelConfirm2": "Neće biti vraćen novac.",
"sub.cancelConfirmBtn": "Potvrdi otkazivanje",
"sub.cancelTitle": "Otkaži svoju pretplatu",
"sub.cancelledToast": "Otkazivanje zabilježeno.",
"sub.cguAnd": "i",
"sub.cguDesc": "Molimo potvrdite svoju suglasnost prije plaćanja.",
"sub.cguLink": "Uvjeti korištenja",
"sub.cguPay": "Nastavi s plaćanjem",
"sub.cguPre": "Pročitao/la sam i prihvaćam",
"sub.cguRequired": "Morate prihvatiti Uvjete korištenja i Politiku privatnosti da biste nastavili.",
"sub.cguSuffix": "findloop.",
"sub.cguTitle": "Dovršite svoju pretplatu",
"sub.expiresOn": "Vaša pretplata ističe",
"sub.noProrata": "Nema povrata pro-rata.",
"sub.privacyLink": "Politika privatnosti",
"sub.renewsOn": "Vaša pretplata se obnavlja",
"sub.resume": "Ponovno se pretplatite",
"sub.resumedToast": "Ponovna pretplata potvrđena.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Poslovna",
"tier.small": "Početna",
"tm.add": "Dodaj",
"tm.adminOpt": "Administrator (potpuni pregled)",
"tm.chooseEst": "Odaberite ustanovu",
"tm.chooseEstPh": "Odaberite ustanovu",
"tm.copyFail": "Kopiranje nije uspjelo",
"tm.copyLink": "Kopirajte vezu",
"tm.copyOk": "Veza s pozivnicom kopirana",
"tm.emailHint": "Pozivno e-mail će biti poslan za kreiranje lozinke.",
"tm.expiresOn": "isteče {date}",
"tm.forEmail": " za {email}",
"tm.forbidden": "Upravljanje timom je rezervirano za vlasnika računa.",
"tm.inviteCreated": "Pozivnica stvorena",
"tm.inviteDesc": "Pozivno e-mail omogućuje članu tima da kreira svoju lozinku.",
"tm.invitePending": "Pozivnica na čekanju",
"tm.inviteResent": "Pozivnica ponovno poslana",
"tm.inviteSent": "Pozivnica poslana e-mailom",
"tm.inviteTitle": "Pozovite člana",
"tm.invitedOn": "Pozvan {date}",
"tm.linkExpired": "Veza je istekla",
"tm.memberRemoved": "Član uklonjen",
"tm.name": "Ime",
"tm.noMembers": "Još nema članova tima.",
"tm.resendTitle": "Ponovno pošalji pozivnicu",
"tm.role": "Uloga",
"tm.roleAdmin": "Administrator",
"tm.roleOwner": "Vlasnik",
"tm.roleStaff": "Osoblje",
"tm.roleUpdated": "Uloga ažurirana",
"tm.sendInvite": "Pošalji pozivnicu",
"tm.sending": "Šaljem…",
"tm.staffOpt": "Osoblje (vidi samo svoju ustanovu)",
"trk.at": "Na",
"trk.badge": "Praćenje",
"trk.carrier": "Nositelj",
"trk.codeValidated": "Kod potvrđen od strane partnera",
"trk.dlProof": "Preuzmite moj dokaz o predaji (PDF)",
"trk.emailLabel": "Email (opcionalno — za prikaz vaših podataka)",
"trk.enterEmailCode": "Unesite svoj email iznad za prikaz vašeg koda zahtjeva.",
"trk.idLabel": "Broj izvještaja",
"trk.lostEmail": "Više nemam pristup svom emailu",
"trk.phonePh": "Vaš broj telefona",
"trk.photoBefore": "Fotografija predmeta prije slanja",
"trk.recoverBtn": "Opobavi moj predmet",
"trk.recoverHint": "Dobijte svoj kod zahtjeva putem SMS-a na vaš registrirani broj.",
"trk.searching": "Pretraživanje…",
"trk.secureRest": "Sigurna predaja",
"trk.send": "Pošalji",
"trk.shipPending": "Pošiljka se priprema — broj za praćenje će se ovdje prikazati kada bude poslana.",
"trk.shipTitle": "Praćenje pošiljke",
"trk.showQr": "Pokažite ovaj QR partneru za potvrdu predaje",
"trk.sigSaved": "Potpis spremljen",
"trk.signFirst": "Molimo potpišite prije potvrde.",
"trk.signProof": "Potpišite svoj dokaz o predaji",
"trk.signSubmit": "Potvrdite svoj potpis i generirajte PDF",
"trk.submit": "Pratite",
"trk.subtitle": "Unesite broj izvještaja za praćenje napretka.",
"trk.title": "Pratite moj izvještaj",
"trk.trackShipment": "Pratite paket",
"trk.trackingNo": "Broj za praćenje",
"trk.yourCode": "Vaš kod zahtjeva (za davanje partneru)",
"hc.weRanTheAnalysisAgain": "Ponovno smo proveli analizu i identificirali još jednu stavku koja bi mogla biti vaša. Molimo provjerite ponovno.",
"hc.weight": "Težina",
"hc.weightNotProvidedTheShipping": "Težina nije navedena: trošak dostave bit će izračunat u trenutku slanja.",
"hc.weightUnit": "Jedinica težine",
"hc.welcome": "Dobrodošli!",
"hc.welcomeToFindo": "Dobrodošli u Findloop",
"hc.whenACustomerComesTo": "Kada kupac dođe po svoje stvari, otvorite njihovu izjavu i potvrdite povrat. To je to!",
"hc.whenDisabledFeesDropTo": ". Kada je onemogućeno, naknade padaju na",
"hc.whyIsThisNotYour": "Zašto ovo nije vaša stavka?",
"hc.willBeMarkedAs": "bit će označeno kao",
"hc.wrongColor": "Kriva boja",
"hc.wrongModel": "Krivi model",
"hc.yesCancel": "Da, otkaži",
"hc.yesContactTheFinder": "Da, kontaktiraj pronalazača",
"hc.youAreHere": "Vi ste ovdje",
"hc.youBusinessCom": "vi@tvrtka.com",
"hc.youCanNowStartThe": "Sada možete započeti povrat.",
"hc.youCanStillChangeIt": ". I dalje ga možete mijenjati slučaj po slučaj.",
"hc.youHaveAlreadyConfirmedThat": "Već ste potvrdili da je ovo vaša stavka.",
"hc.youWillBeRedirectedTo": "Bit ćete preusmjereni na sigurnu Stripe uplatu.",
"hc.yourAccountHasBeenReactivated": "Vaš račun je ponovno aktiviran.",
"hc.yourAccountIsActiveYou": "Vaš račun je aktivan, sada možete upravljati svojim poslovnicama.",
"hc.yourEstablishment": "Vaša poslovnica",
"hc.yourFeedbackHelpsUsImprove": "Vaša povratna informacija pomaže nam poboljšati naše pretraživanje.",
"hc.yourFeedbackHelpsUsRestart": "Vaša povratna informacija pomaže nam ponovo pokrenuti analizu i poboljšati naše pretraživanje.",
"hc.yourFirstSteps": "Vaši prvi koraci",
"hc.yourFirstStepsAdmin": "Vaši prvi koraci (admin)",
"hc.yourItemHasBeenHanded": "Vaša stavka je osobno predana od strane partnera — zatvorite slučaj kada je predaja potvrđena.",
"hc.yourItemHasBeenShipped": "Vaša stavka je poslana od strane partnera — zatvorite slučaj kada je dostava potvrđena.",
"hc.yourPaymentHasBeenRecorded": "Vaša uplata je zabilježena.",
"hc.yourShipmentIsBeingPrepared": "Vaša pošiljka se priprema. U svom paketu ćete primiti unutar 3 do 5 radnih dana.",
"hc.yourShippingFeesHaveAlready": "Vaši troškovi dostave već su plaćeni. Dostava plaćena ✓",
"hc.yourShippingFeesHaveBeen": "Vaši troškovi dostave su plaćeni. Vaš paket se priprema.",
"hc.yourVerificationQuestionsDeposit": "Vaša pitanja za verifikaciju (depozit)",
"hero.einvoiceBadge": "e-račun usklađen s 2027.",
"home.recentAdsAll": "Pogledajte sve oglase",
"home.recentAdsEyebrow": "Trenutno",
"home.recentAdsSubtitle": "Prijavljene izgubljene i pronađene stvari od strane zajednice.",
"home.recentAdsTitle": "Najnoviji oglasi",
"home.reunions": "Nedavne reunije",
"home.videoEyebrow": "Gledajte",
"home.videoSubtitle": "Kako lako ponovno povezuje izgubljene predmete s njihovim vlasnicima.",
"home.videoTitle": "Otkrijte Findloop u 2 minute",
"home.watchYoutube": "Gledajte na YouTubeu",
"impact.already": "Već",
"impact.citiesWord": "grad/gradovi",
"impact.eachPoint": "Svaka točka je grad gdje Findloop pomaže u vraćanju izgubljenih predmeta.",
"impact.emptyMap": "Karta se popunjava kako se vraćaju predmeti.",
"impact.eyebrow": "Naš utjecaj",
"impact.inCities": "u",
"impact.restitutedTo": "predmeti vraćeni njihovim vlasnicima",
"impact.title": "Predmeti vraćeni, svugdje oko vas",
"inv2.download": "Preuzmi",
"inv2.view": "Pogledaj",
"map.objectsOnMapPlural": "predmeti na karti",
"map.objectsOnMapSingular": "predmet na karti",
"mc.claimConfirmDesc": "Provjerite predmet koji je pronašao pronalazač prije nego što platite kako biste otključali njihove kontakt podatke.",
"mc.claimConfirmNo": "Ovo nije moj predmet",
"mc.claimConfirmTitle": "Je li ovo doista vaš predmet?",
"mc.claimConfirmYes": "Da, moj je — platite",
"mc.claimFinderContacts": "Kontakt podaci pronalazača",
"mc.claimNotMineDone": "Hvala — pronalazač je obaviješten i vaš zahtjev je uklonjen iz oglasa.",
"mc.claimUnlockDesc": "Platite naknadu za upravljanje findloop-om kako biste dobili kontakt podatke osobe koja je pronašla vaš predmet.",
"mc.claimUnlockTitle": "Otključajte kontakt podatke pronalazača",
"mc.hideCountryOffers": "Sakrij ponude u mojoj zemlji",
"mc.myClaims": "Predmeti koje tražim",
"mc.myClaimsSub": "Predmeti koje su pronašli drugi, a koje tražite. Otključajte kontakt podatke pronalazača kako biste dogovorili predaju.",
"mc.notifAdCancelled": "Oglas otkazan",
"mc.notifCancelAd": "Otkaži moj oglas",
"mc.offersInCountry": "Ponude u mojoj zemlji",
"mc.offersInCountryDesc": "Sve aktivne nagrade od partnera u vašoj zemlji, po gradu.",
"mc.redArchived": "Arhivirano",
"mc.rewardsCountryNone": "Još nema ponuda u vašoj zemlji.",
"mc.rewardsForYou": "Nagrade za vas",
"mc.rewardsForYouDesc": "Ponude od partner(a) gdje ste ostavili predmet.",
"mc.rewardsMineNone": "Još nema nagrada od vaših partnera za ostavljanje.",
"mc.showCountryOffers": "Pogledajte ponude u mojoj zemlji",
"mc2.cancelDecl": "Otkaži moju deklaraciju",
"mc2.cancelDeclDone": "Deklaracija otkazana.",
"pricing.physInvDesc": "Kada se predmet vrati, njegova lokacija se automatski oslobađa i dostupna je za novi predmet.",
"pricing.physInvTitle": "Praćenje fizičke inventure",
"pricing.physModalTitle": "Upravljanje fizičkim artiklima",
"pricing.physQrDesc": "Jedinstveni QR kod generira se za svaki artikl i povezuje sve njegove informacije.",
"pricing.physQrTitle": "Posvećena QR oznaka",
"pricing.physShelfDesc": "Svakom registriranom artiklu može se dodijeliti fizička lokacija unutar objekta.",
"pricing.physShelfTitle": "Plan polica",
"pricing.physicalMgmt": "Upravljanje fizičkim artiklima (police, QR, inventura)",
"pub.addSecondPhoto": "Dodajte 2. fotografiju (opcionalno)",
"pub.photo2Added": "✓ 2. fotografija dodana",
"reg.dispositionJournal": "Dnevnik raspodjele",
"reg.dispositionNoteAuthHint": "ℹ️ Napomena je obavezna za “Predano vlastima” (broj izvješća, odjel…).",
"reg.dispositionNotePh": "Napomena (opcionalno): dobrotvorna organizacija, referenca vlasti, ime kupca…",
"reg.dispositionNoteRequired": "Službena referenca je potrebna za predaju vlastima.",
"reg.legalPrealert": "Pravni rok za {days} dan(a)",
"reg.legalPrealertOptions": "Opcije na roka: aukcija, donacija dobrotvornoj organizaciji, predaja vlastima.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Potpuna recenzija",
"rev.readMore": "Pročitajte više",
"rw.activeCodes": "Aktivni kuponi",
"rw.archived": "Arhivirano",
"rw.archivedTitle": "Iskorišteni kuponi (arhivirano)",
"rw.hideArchived": "Sakrijte iskorištene kupone",
"rw.noArchived": "Nema arhiviranog kupona.",
"rw.showArchived": "Prikažite iskorištene kupone",
"shp.labelAuto": "Oznaka se automatski generira čim kupac plati troškove dostave. Bit će dostupna za preuzimanje ovdje.",
"st.cancelled_by_customer": "Otkazano",
"stt.dispoPdfBtn": "Izvezi PDF",
"stt.dispoPdfError": "Izvoz PDF-a nije uspio.",
"stt.dispoPdfExporting": "Izvoz…",
"trk.matchVerifying": "Potencijalna podudarnost se provjerava",
"a.firstName": "Ime",
"ac.emailCrossMatch": "B2C preklapanja",
"ac.emailCrossMatchDesc": "Email kada je javna reklama za izgubljeni predmet u skladu s predmetom koji je predan na vašem mjestu",
"ac.emailCrossReject": "Odbijanja javnih preklapanja",
"ac.emailCrossRejectDesc": "Primite email kada kupac naznači da predloženo javno preklapanje nije njihov predmet.",
"ac.emailLoginNotif": "Obavijest o prijavi",
"ac.emailLoginNotifDesc": "Primite email svaki put kada se netko prijavi na vaš račun.",
"ad.closeNoCancel": "Ne, ukloni oglas",
"ad.closeQuestion": "Je li predmet vraćen vama?",
"ad.closeQuestionDesc": "Obavijestite nas jeste li povratili svoj predmet ili jednostavno želite ukloniti ovaj oglas.",
"ad.closeYesRestituted": "Da, predmet je vraćen",
"ad.closedRestituted": "Predmet vraćen — oglas zatvoren 🎉",
"an.lostLoginDesc": "Račun je potreban za prijavu izgubljenog predmeta i praćenje njegovog povrata.",
"an.lostLoginRequired": "Prijavite se za prijavu izgubljenog predmeta",
"an.qfAll": "Sve",
"an.qfBoosted": "Povećano",
"an.qfPhoto": "S fotografijom",
"an.qfRecent": "Ovoj tjednu",
"an.qfResolved": "Riješeno",
"an.restitutionInProgress": "Predmet se vraća",
"dec.descPhLong": "Opisujte predmet: marka, boja, karakteristične oznake… (Što više detalja date, veće su šanse da povratite svoj predmet)",
"dec.loadError": "Nije moguće učitati partnera trenutno. Provjerite svoju vezu i pokušajte ponovo.",
"dec.retry": "Pokušajte ponovno",
"dec.shippingMode": "Šaljemo",
"dep.photo2": "Fotografija 2. predmeta",
"dep.photo2Hint": "Neobavezno — drugi kut poboljšava točnost vizualnog preklapanja.",
"dl.accountSuspended": "Račun suspendiran zbog neplaćene fakture. Podmirite ga kako biste obnovili svoj pristup.",
"dl.regularize": "Podmirite sada →",
"dl.suspensionCountdown": "Faktura {num} nije plaćena — vaš račun će biti suspendiran za {days} dan(a). Podmirite kako biste to izbjegli.",
"ft.cancelConfirm": "Otkažite svoju prijavu? Vlasnik predmeta bit će obaviješten.",
"ft.cancelDone": "Prijava otkazana.",
"ft.cancelLocked": "Otkazivanje više nije moguće nakon što je vlasnik platio.",
"ft.cancelReport": "Otkazujem svoj izvještaj",
"ft.claimCodeHelp": "Dajte ovaj kod pronalazniku prilikom predaje kako biste potvrdili da ste primili svoj predmet.",
"ft.claimCodeTitle": "Vaš kod za povrat",
"ft.claimDone": "Predmet vraćen. Hvala što koristite Findloop!",
"ft.claimUnlockHint": "Otključajte kontaktne podatke pronalaznika",
"ft.claimUnlockHintSub": "Idite na \"Predmeti koje preuzimam\" u svom računu kako biste platili naknadu i dobili kontaktne podatke.",
"ft.finderCodeShownHelp": "Vlasnik je platio i odabrao vas. Kopirajte ovaj kod ispod kako biste potvrdili povrat — nema potrebe za provjeravanjem emaila.",
"ft.finderCodeShownTitle": "Kod za validaciju vlasnika",
"ft.finderContactsTitle": "Finderovi kontakt detalji",
"ft.foundCodeHelp": "Pokažite ovaj kod vlasniku prilikom predaje kako biste potvrdili da je predmet vraćen.",
"ft.inProgressOther": "Predmet se vraća",
"ft.inProgressOtherHelp": "Vlasnik je odabrao drugog findera za ovaj predmet. Nema potrebe za daljnjim postupcima s vaše strane.",
"ft.restitutionCodeHelp": "Ovaj kod potvrđuje predaju predmeta. Već je unaprijed popunjen dolje; potvrdite ga, a zatim zatvorite slučaj.",
"ft.restitutionCodeTitle": "Vaš kod za restituciju",
"hc.14Digits": "14 znamenki",
"hc.15DaysBeforeAnItem": "15 dana prije zakonskog roka predmeta.",
"hc.7DaysBeforeAnItem": "7 dana prije zakonskog roka predmeta.",
"hc.8CharactersMinimum": "Minimalno 8 znakova.",
"hc.aClaimToValidate": "Potraživanje za validaciju",
"hc.aFindoAssistanceSessionIs": "Findloop asistentska sesija trenutno je aktivna na vašem računu.",
"hc.aNewMatchHasBeen": "Pronađena je nova podudarnost",
"hc.aUser": "Korisnik",
"hc.aUserClaimsToBe": "Korisnik tvrdi da je vlasnik. Provjerite njihove odgovore prije nego što odobrite povratak.",
"hc.aboutFindo": "O findu",
"hc.accountActivatedPleaseLogIn": "Račun aktiviran, molimo prijavite se.",
"hc.accountActivation": "Aktivacija računa",
"hc.accountCreated": "Račun je stvoren!",
"hc.accountDeactivatedAReactivationEmail": "Račun deaktiviran. E-mail za ponovnu aktivaciju (važeći 30 dana) je poslan vama.",
"hc.accountReactivation": "Ponovna aktivacija računa",
"hc.activateMyAccount": "Aktiviraj moj račun",
"hc.activateMyAdminAccount": "Aktiviraj moj administratorski račun",
"hc.activating": "Aktiviram…",
"hc.activeMatchCancelReason": "Aktivna podudarnost. Razlog otkazivanja korisnika: \"{reason}\". Predmet još čeka na potraživanje.",
"hc.activeMatchWithAPublic": "Aktivna podudarnost s javnom (korisničkom) listom. Čeka se na potraživanje vlasnika.",
"hc.addAPhoto": "Dodaj fotografiju",
"hc.addAndConfigureYourEstablishments": "Dodajte i konfigurirajte svoje ustanove u \"Ustanove\": kontakt podaci, kategorija i fizičko skladište predmeta.",
"hc.addOnGoogle": "Dodaj na Google",
"hc.address": "Adresa",
"hc.addressSaved": "Adresa spremljena",
"hc.addressStreet": "Adresa — Ulica",
"hc.adjustThePhoto": "Prilagodite fotografiju",
"hc.adminFullView": "Administrator (puni prikaz)",
"hc.administratorOnly": "Samo za administratore",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "AI vizualna usporedba",
"hc.all": "Sve",
"hc.amount": "Iznos",
"hc.anOrganization": "Organizacija",
"hc.analyzing": "Analiziram…",
"hc.andRecoveryIs": "i oporavak je",
"hc.andTheDeclarationWillBe": "i izjava će biti zatvorena (premještena u povijest). Ova akcija je konačna.",
"hc.annual20": "Godišnje -20%",
"hc.annualBilling20": "Godišnje naplaćivanje (−20%)",
"hc.annualTarget": "Godišnji cilj",
"hc.anyCommentsOptional": "Ima li komentara? (opcionalno)",
"hc.approveTheClaim": "Odobri zahtjev",
"hc.archiveCancelledConfirm": "Arhivirati {n} oglas(a) \"Otkaže kupac\"? Bit će uklonjeni iz registra.",
"hc.asSoonAs": "Šim prije",
"hc.askTheOwnerToDisplay": "Zamoli vlasnika da prikaže QR svog koda (stranica za praćenje).",
"hc.askThemAtTheCounter": "Pitaj ih na pultu da potvrde identitet — nikad javno vidljivo.",
"hc.assistance": "Podrška",
"hc.assistanceSessionRevoked": "Sesija podrške opozvana.",
"hc.atLeast6Characters": "Najmanje 6 znakova",
"hc.automaticallyPreSelected": "automatski unaprijed odabrano",
"hc.automaticallyWhenShipping": "automatski prilikom slanja.",
"hc.awaitingClaim": "Na čekanju zahtjev",
"hc.awaitingPayment": "Na čekanju uplata",
"hc.b2cCustomer": "B2C kupac",
"hc.back": "Nazad",
"hc.backToHome": "Povratak na početnu",
"hc.backToMyAccount": "Povratak na moj račun",
"hc.backToPayment": "Povratak na uplatu",
"hc.beforeAfterComparisonSlider": "Klizač usporedbe prije/poslije",
"hc.billingInformation": "Informacije o naplati",
"hc.billingInformationSaved": "Informacije o naplati spremljene ✓",
"hc.brand": "Marka",
"hc.bronze": "Brončano",
"hc.calculatingTheShippingRate": "Izračunavam cijenu dostave…",
"hc.cameraUnavailableEnterTheCode": "Kamera nije dostupna. Unesite kod ručno.",
"hc.cancel": "Otkaži",
"hc.cancelMyDeclaration": "Otkazati moju izjavu",
"hc.cancelSavedFmt": "Otkazivanje spremljeno: \"{reason}\". Možete još uvijek zatražiti.",
"hc.cancelTheDeposit": "Otkaži depozit",
"hc.cancelThisMatch": "Otkaži ovaj susret",
"hc.cancellationReason": "Razlog otkazivanja",
"hc.cancelled": "Otkazano",
"hc.cancelledByTheCustomer": "Otkazano od strane kupca",
"hc.cannotOpenPayment": "Nije moguće otvoriti uplatu. Pokušajte ponovo.",
"hc.careers": "Karijere",
"hc.carrier": "Prijevoznik",
"hc.carrierAvailabilityCannotBeChecked": "Dostupnost prijevoznika ne može se provjeriti dok vaša Sendcloud adresa pošiljatelja nije postavljena.",
"hc.carrierConfirmedCharged": "Prijevoznik potvrđen — {price} € naplaćeno kupcu",
"hc.carrierOther": "Prijevoznik (ostalo)",
"hc.carrierSelection": "Odabir prijevoznika",
"hc.caseClosedThankYou": "Slučaj zatvoren. Hvala!",
"hc.category": "Kategorija",
"hc.changeMethod": "Promijeni metodu",
"hc.characteristic": "Karakteristika",
"hc.chargedToCustomer": "naplaćeno kupcu.",
"hc.checkOrEditYourDetails": "Provjerite ili uredite svoje detalje prije sigurnog plaćanja.",
"hc.checkStatisticsToTrackDeposited": "Provjerite \"Statistiku\" za praćenje deponiranih stavki, stopu povrata i performanse svake ustanove.",
"hc.checkTheDetailsBeforeContacting": "Provjerite detalje prije kontakta s pronalaznikom.",
"hc.checkTheDetailsBelowBefore": "Provjerite detalje u nastavku prije nego što započnete svoj zahtjev za povrat.",
"hc.checkTheNewItem": "Provjerite novu stavku",
"hc.checkThePhotosAndCharacteristics": "Provjerite fotografije i karakteristike u nastavku prije nego što nastavite s povratom.",
"hc.chooseACountry": "Odaberite državu",
"hc.chooseANewPassword": "Odaberite novu lozinku",
"hc.chooseAReason": "Odaberite razlog",
"hc.chooseTheLegalRetentionAlerts": "Odaberite pravna obavijest o zadržavanju primljene e-poštom za",
"hc.chooseYourPasswordToAccess": "Odaberite svoju lozinku za pristup administratorskoj konzoli.",
"hc.city": "Grad",
"hc.claimApproved": "Zahtjev odobren",
"hc.claimApproved2": "Zahtjev odobren.",
"hc.claimCodeExpired": "Kod zahtjeva istekao",
"hc.claimCodeVerified": "Kod zahtjeva verificiran",
"hc.claimNotFound": "Zahtjev nije pronađen",
"hc.claimNotValidated": "Zahtjev nije potvrđen",
"hc.claimRejected": "Zahtjev odbijen",
"hc.claimRejected2": "Zahtjev odbijen.",
"hc.claimValidated": "Zahtjev potvrđen",
"hc.claimValidatedByThePartner": "Zahtjev potvrđen od strane partnera",
"hc.claimant": "Podnositelj zahtjeva",
"hc.claimsToBeTheOwner": "tvrdi da je vlasnik ove stavke i odgovorio na pitanja za provjeru. Odobrite samo ako se odgovori podudaraju.",
"hc.claimsToValidate": "Zahtjevi za potvrdu",
"hc.clear": "Obriši",
"hc.clickToZoom": "Kliknite za uvećanje",
"hc.close": "Zatvori",
"hc.close2": "Zatvori",
"hc.closeTheDeclaration": "Zatvori izjavu",
"hc.closeTheDeclaration2": "Zatvoriti izjavu?",
"hc.codeAlreadyVerified": "Kod već verificiran",
"hc.codeCopied": "Kod je kopiran",
"hc.collapse": "Smanji",
"hc.color": "Boja",
"hc.company": "Tvrtka",
"hc.companyName": "Naziv tvrtke",
"hc.comparePhotos": "Usporedi fotografije",
"hc.compareThemWithTheOwner": "Usporedite ih s odgovorima vlasnika - nikada javno vidljivi.",
"hc.condition": "Stanje",
"hc.confirmAndPay": "Potvrdi i plati",
"hc.confirmCancellation": "Potvrdi otkazivanje",
"hc.confirmCrop": "Potvrdi izrez",
"hc.confirmDeletion": "Potvrdi brisanje",
"hc.confirmPassword": "Potvrdi lozinku",
"hc.confirmThatThisIsYour": "Potvrdi da je ovo tvoj predmet. Provjera identiteta će biti zatražena od pronalazača prije bilo kakvog kontakta.",
"hc.confirmTheCarrier": "Potvrdi prijevoznika",
"hc.confirmThePassword": "Potvrdi lozinku",
"hc.confirmYourShippingAddressTo": "Potvrdi svoju adresu za dostavu kako bi nastavio s plaćanjem.",
"hc.confirmYourSubscription": "Potvrdi svoju pretplatu",
"hc.confirmed": "Potvrđeno ✓",
"hc.contactFindoToGetYour": "Kontaktiraj Findloop za svoj ID pošiljatelja.",
"hc.contactUs": "Kontaktirajte nas",
"hc.continueTheReturn": "Nastavi s povratom",
"hc.continueToPayment": "Nastavi na plaćanje",
"hc.copy": "Kopiraj",
"hc.correctMyDetails": "ispravi moje podatke",
"hc.correctThisEntry": "Ispraviti ovaj unos?",
"hc.country": "Država",
"hc.countryAddress": "Država (adresa)",
"hc.countryIsoCodeEG": "Država (ISO kod, npr. FR)",
"hc.cover": "korica",
"hc.createTheShipment": "Kreiraj pošiljku",
"hc.cropThePhoto": "Izreži fotografiju",
"hc.customer": "Kupac",
"hc.customerClaimCodeToCheck": "Kod potraživanja kupca - za provjeru prilikom preuzimanja:",
"hc.customerReasonFmt": "Kupčev razlog: \"{reason}\".",
"hc.customerReminderDelay": "Kašnjenje podsjetnika kupca",
"hc.customerWhosePublicListingMatches": "Kupac čija javna ponuda odgovara ovom predmetu - vidljivo samo vama.",
"hc.d15": "D-15",
"hc.dangerZone": "Opasna zona",
"hc.date": "Datum",
"hc.dateNewest": "Datum (najnovije)",
"hc.dateOldest": "Datum (najstarije)",
"hc.daysToYearEnd": "{n} dana do kraja godine",
"hc.deadlineAlert": "Upozorenje na rok",
"hc.declarationClosed": "Deklaracija zatvorena ✓",
"hc.declarationNotFound": "Deklaracija nije pronađena.",
"hc.declarationNotFound2": "Deklaracija nije pronađena",
"hc.declarationTracking": "Praćenje deklaracije",
"hc.defaultCarrier": "Zadani prijevoznik",
"hc.defaultCarrierPreselected": "Zadani prijevoznik unaprijed odabran — može se promijeniti za ovu pošiljku. Stvarna cijena (Sendcloud + {m}% marža).",
"hc.defaultCarrierRemoved": "Zadani prijevoznik uklonjen",
"hc.delayHours": "Kašnjenje (sati)",
"hc.deleteMyAccount": "Izbriši moj račun",
"hc.deleting": "Brišem…",
"hc.deletingDeactivatesYourAccountLogin": "Brisanjem se deaktivira vaš račun: prijava je blokirana, a podaci se čuvaju 30 dana. Primat ćete e-mail s vezom za ponovnu aktivaciju koja vrijedi 30 dana.",
"hc.delivered": "Isporučeno",
"hc.depositAnItem": "Depozit stavke",
"hc.depositCancelledItemPutBack": "Depozit otkazan — stavka vraćena u skladište.",
"hc.depositCancelledItemRemovedFrom": "Depozit otkazan — stavka uklonjena iz registra.",
"hc.depositedOn": "Depozitiran na",
"hc.describeTheItemBrandColor": "Opišite stavku: marka, boja, prepoznatljivi znakovi… (Što više detalja pružite, veće su šanse da pronađete svoju stavku)",
"hc.dimensionsCm": "Dimenzije (cm)",
"hc.disablingAnEmail": "Onemogućavanje e-maila",
"hc.doesNotHide": "ne skriva",
"hc.download": "Preuzmi",
"hc.downloadThePdf": "Preuzmi PDF",
"hc.draftRestoredPickUpYour": "Nacrt vraćen — preuzmite svoju deklaraciju odakle ste stali.",
"hc.dragToReposition": "Povucite za premještanje",
"hc.eGColisPriv": "Npr. Colis Privé",
"hc.eachItemGetsAQr": "Svaka stavka dobiva QR oznaku. Skenirajte je iz \"Skladište & QR\" kako biste odmah locirali stavku.",
"hc.eachSiteManagesItsOwn": "Svaka stranica upravlja vlastitom bankom. Idite na",
"hc.edit": "Uredi",
"hc.emailNotificationPreferences": "Preferencije obavijesti e-poštom",
"hc.emailPreferencesUpdated": "Preferencije e-pošte ažurirane",
"hc.enableOrDisableRecoveryFees": "Omogućite ili onemogućite naknade za oporavak za",
"hc.enlargePhoto": "Povećajte fotografiju",
"hc.enterTheCustomerSCode": "Unesite kod kupca",
"hc.estShipRate": "Procijenjena cijena dostave (Sendcloud + {m}% marža):",
"hc.establishment": "Ustanova",
"hc.establishment2": "Ustanova:",
"hc.establishmentInItsSendcloudAccount": "ustanova u svom Sendcloud računu i daje vam ID pošiljatelja",
"hc.establishmentSettings": "Postavke ustanove",
"hc.exCode": "npr. ABCD2345",
"hc.exId": "npr. 3f2a…",
"hc.exit": "Izlaz",
"hc.explainWhyThisItemIs": "Objasnite zašto ovaj predmet nije vaš…",
"hc.externalPaymentLinks": "Vanjske platne poveznice",
"hc.failed": "Neuspjeh",
"hc.feesEnabled": "Naknade omogućene",
"hc.field": ") polje.",
"hc.finderAcceptedCloseTheCase": "Finder prihvaćen — zatvorite slučaj nakon što je predmet predan osobno.",
"hc.findoCityRanking": "Findloop — Rangiranje gradova",
"hc.findoForEstablishments": "Findloop za ustanove",
"hc.findoPresentationVideo": "Findloop prezentacijski video",
"hc.findoRegistersTheAddressOf": "Findloop registrira adresu vašeg",
"hc.findoReviewShare": "Findloop {year} pregled: {n} predmeta vraćeno, {rate}% stopa povrata 🎉",
"hc.firstVerifyTheClaimCode": "Prvo potvrdite kod za potraživanje iznad",
"hc.forEveryNewShipmentFrom": "za svaki novi paket iz",
"hc.free": "besplatno",
"hc.freeRecovery0": "Besplatni povrat (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Besplatni povrat diljem Afrike – Promo ponuda",
"hc.freeRecoveryFeesDisabled0": "Besplatni povrat: naknade onemogućene (0 €)",
"hc.fromTeamInviteYourColleagues": "Iz \"Tima\", pozovite svoje kolege putem e-pošte i dodijelite im ustanovu. Svaki član vidi samo svoj opseg.",
"hc.fullName": "Puno ime",
"hc.fullPhoto": "Cjelovita fotografija",
"hc.gallery": "Galerija",
"hc.giveTheReasonForCancelling": "Dajte razlog za otkazivanje. Partner će biti obaviješten.",
"hc.goToLogin": "Idite na prijavu",
"hc.goToMyAccount": "Idite na moj račun",
"hc.gold": "Zlatno",
"hc.googleLoginFailed": "Prijava putem Googlea nije uspjela",
"hc.hasConfirmedYourPaymentYou": "je potvrdio vašu uplatu, bit ćete automatski preusmjereni",
"hc.helpCenter": "Centar za pomoć",
"hc.helpUsImproveWhyAre": "Pomozite nam da poboljšamo: zašto odlazite? Vaš račun će biti deaktiviran i može se ponovo aktivirati u roku od 30 dana.",
"hc.hidePassword": "Sakrij lozinku",
"hc.high": "Visoko",
"hc.historyOfYourMonthlySubscriptions": "Povijest vaših mjesečnih pretplata i njihovog statusa plaćanja.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Kako postaviti svoj numerički Sender ID?",
"hc.iDonTUseIt": "Ne koristim ga dovoljno",
"hc.iFoundItElsewhere": "Našao/la sam to negdje drugo",
"hc.iNoLongerNeedMy": "Više mi nije potrebna moja stavka",
"hc.identityVerification": "Verifikacija identiteta",
"hc.idleLogoutIn": "Bit ćete odjavljeni za {n} sekundi zbog neaktivnosti.",
"hc.ifProvidedTheVolumetricWeight": "Ako je pruženo, koristi se volumetrijska težina.",
"hc.ifThePartnerHasNot": "Ako partner nije potvrdio primitak vanjske uplate nakon ovog vremena, Findloop automatski podsjeća partnera da je potvrdi.",
"hc.impersonationEnded": "Završena je lažna identifikacija.",
"hc.impersonationMode": "Način lažne identifikacije",
"hc.impersonationSessionExpired": "Sesija lažne identifikacije je istekao.",
"hc.inTheField": ", u terenu",
"hc.inTransit": "U tranzitu",
"hc.inclVat": "uključ. PDV",
"hc.intraEuVatNumberOptional": "Intra-EU PDV broj neobavezan, bez SIRET-a (izvan Francuske).",
"hc.invalidInvitationLink": "Nevažeća poveznica za poziv.",
"hc.invalidInvitationLink2": "Nevažeća poveznica za poziv",
"hc.invalidInviteLink": "Nevažeća ili istekla poveznica za poziv.",
"hc.invalidNumberEnterAnInternational": "Nevažeći broj. Unesite međunarodni broj, npr. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Nevažeća ili istekla poveznica.",
"hc.invalidOrExpiredReactivationLink": "Nevažeća ili istekla poveznica za reaktivaciju",
"hc.invalidSendcloudId": "Nevažeći Sendcloud ID",
"hc.inviteSubtitle": "{org} vas poziva da se pridružite svom Findloop timu. Odaberite svoju lozinku za aktivaciju svog računa.",
"hc.isAvailableOnSendcloudFor": "je dostupan na Sendcloudu za sve vaše rute (unutarnje + međunarodne).",
"hc.isNotEnabledOnYour": "nije omogućen na vašem Sendcloud računu za neka odredišta. Označene će se generirati s drugim dostupnim prijevoznikom.",
"hc.isThisReallyYourItem": "Je li ovo stvarno vaša stavka?",
"hc.isThisYourItem": "Je li ovo vaša stavka?",
"hc.item": "Stavka",
"hc.itemAlreadyConfirmed": "Stavka već potvrđena",
"hc.itemDetails": "Detalji stavke",
"hc.itemFoundAt": "Stavka pronađena na",
"hc.itemFoundAtAPartner": "Stavka pronađena kod partnera",
"hc.itemMarkedAsReturned": "Stavka označena kao vraćena ✓",
"hc.itemPhotoRequiredBeforeShipping": "Fotografija stavke (obavezno prije slanja)",
"hc.itemPhotoSaved": "Fotografija stavke spremljena",
"hc.itemPreview": "Pregled stavke",
"hc.itemPutBackInStorage": "Stavka vraćena u skladište.",
"hc.itemWeight": "Težina stavke:",
"hc.itemsReturned": "stavka(e) vraćena(e)",
"hc.itemsReturnedThisYear": "artikli vraćeni ove godine",
"hc.itemsWhoseLegalDeadlineIs": "Artikli čiji je zakonski rok udaljen 15 dana ili manje (uključujući dospjela). Podudaranja ostaju vidljiva.",
"hc.kbisNumber": "Kbis broj",
"hc.keysForgottenOnABench": "Ključevi zaboravljeni na klupi",
"hc.labelBeingGenerated": "Označka se generira",
"hc.leaveTheFieldsEmptyTo": "Ostavite polja prazna kako biste ponudili oporavak besplatno.",
"hc.legalNotice": "Pravni obavijest",
"hc.limitReachedUpgradeToA": "Postignut limit — nadogradite na viši plan",
"hc.linkCopiedShareOn": "Veza kopirana — podijelite je na {label}",
"hc.linkUnavailable": "Veza nije dostupna",
"hc.linkedTo": "Povezano s",
"hc.listingHiddenByModeration": "Oglas skriven moderacijom.",
"hc.loading": "Učitavanje…",
"hc.locateMe": "Lociraj me",
"hc.logIn": "Prijavite se",
"hc.logInToGetBack": "Prijavite se kako biste se vratili u svoj prostor i upravljali svojim pretplatama.",
"hc.loginFailed": "Prijava nije uspjela",
"hc.lostFoundPlatform": "Platforma za izgubljeno i pronađeno.",
"hc.lostIn": "izgubljeno u",
"hc.lowRate": "Niska stopa",
"hc.mainReason": "Glavni razlog",
"hc.mainStreet": "Glavna ulica",
"hc.makeSureThisIsThe": "Provjerite je li to predmet koji ste izgubili prije nego što otključate kontaktne podatke pronalazača.",
"hc.manageCookies": "Upr управљање kolačićima",
"hc.manageMyTeam": "Upravljajte svojim timom",
"hc.manageYourTeam": "Upravljajte svojim timom",
"hc.markAsReturned": "Označi kao vraćeno",
"hc.matchNoClaimInTime": "Podudaranje nije imalo pritužbu unutar roka.",
"hc.matchNotFound": "Podudaranje nije pronađeno",
"hc.medium": "Srednji",
"hc.milestoneFmt": "{m} vraćenih artikala dostignuto! Na putu prema {next}.",
"hc.missingFeatures": "Nedostajuće karakteristike",
"hc.monthly": "Mjesečno",
"hc.monthlyBilling": "Mjesečno fakturiranje",
"hc.moveThePhotoToFit": "Pomaknite fotografiju da biste je uklopili u krug.",
"hc.myAccount": "Moj račun",
"hc.myInvoices": "Moje fakture",
"hc.myMonthlyInvoices": "Moje mjesečne fakture",
"hc.nArchived": "{n} oglas(a) arhivirano.",
"hc.newCodeGeneratedAndSent": "Novi kod je generiran i poslan kupcu e-poštom i SMS-om",
"hc.newCodeGeneratedAndSent2": "Novi kod je generiran i poslan vlasniku",
"hc.newPassword": "Nova lozinka",
"hc.next": "Sljedeće",
"hc.nextPhoto": "Sljedeća fotografija",
"hc.no": "Ne",
"hc.noAnswerProvided": "Nema pruženog odgovora.",
"hc.noArchivedDeclarations": "Nema arhiviranih deklaracija",
"hc.noCountryFound": "Nema pronađene države",
"hc.noDeclarations": "Nema deklaracija",
"hc.noFeesAreChargedTo": "Nema naknada za kupca.",
"hc.noInvoiceYet": "Još nema računa.",
"hc.noInvoiceYetYourInvoices": "Još nema računa. Vaši računi će se ovdje automatski prikazati nakon svake uplate.",
"hc.noMatchIsAvailableFor": "Trenutno nema dostupnog podudaranja. Jav ćemo vam čim se predmet podudara s vašom deklaracijom.",
"hc.noShipmentMatchesYourSearch": "Nema isporuka koje odgovaraju vašoj pretrazi.",
"hc.noShipmentsYet": "Još nema isporuka.",
"hc.noShipmentsYet2": "Još nema isporuka",
"hc.none": "nema",
"hc.noneChooseForEachShipment": "Nema (odaberite za svaku isporuku)",
"hc.notMine": "Nije moje",
"hc.of": "od",
"hc.only": "Samo",
"hc.onlyEachSiteManagesIts": "samo. Svaka stranica upravlja svojim vlastitim bankarstvom: ove poveznice ne utječu na nijednu drugu ustanovu.",
"hc.onlyTheOwnerOrAn": "Samo vlasnik ili administrator može konfigurirati poveznice za plaćanje ustanove.",
"hc.openDepositInTheMenu": "Otvorite \"Depozit\" u izborniku, opisujte predmet i slikajte. Odmah se pohranjuje i spremno je za vraćanje.",
"hc.openSettings": "Otvorite Postavke →",
"hc.openTheDeclarationToManage": "Otvorite deklaraciju za upravljanje isporukom",
"hc.optional": "— opcionalno",
"hc.optional2": "(opcionalno)",
"hc.optional3": "opcionalno",
"hc.originalListingPhotoUsed": "Korištena izvorna fotografija oglasa",
"hc.other": "Drugo",
"hc.other2": "Drugo...",
"hc.ourProducts": "Naši proizvodi",
"hc.overallRateTrendLast6": "Trend ukupne stope (posljednjih 6 mjeseci)",
"hc.ownerSClaimCode": "Kod zahtjeva vlasnika",
"hc.ownershipConfirmed": "Vlasništvo potvrđeno",
"hc.paid": "Plaćeno",
"hc.paidOn": "Plaćeno dana",
"hc.paidViaPartner": "Plaćeno (putem partnera)",
"hc.parcelBeingPrepared": "Paketu se priprema",
"hc.parcelDelivered": "Paketu isporučen",
"hc.parcelShipped": "Paketu otpremljen",
"hc.parisGareDeLyon": "Pariz, Gare de Lyon…",
"hc.partner": "Partner",
"hc.partner2": "partner",
"hc.partnerDirectory": "Direktorij partnera",
"hc.passedOnToTheCustomer": "— proslijeđeno kupcu putem linka za plaćanje.",
"hc.password": "Lozinka",
"hc.passwordResetPleaseLogIn": "Poništavanje lozinke, molimo prijavite se.",
"hc.passwordUpdated": "Lozinka ažurirana.",
"hc.passwordsDoNotMatch": "Lozinke se ne podudaraju.",
"hc.pasteThisSenderIdIn": "Zalijepite ovu Sender ID u Findloop → Postavke",
"hc.payForTheShipmentOf": "Platite otpremu vašeg predmeta putem Findloop s sigurnim plaćanjem.",
"hc.payTheRecoveryFees": "Platite naknade za oporavak",
"hc.payTheShippingFees": "Platite troškove dostave",
"hc.payment": "Plaćanje",
"hc.paymentAlreadyConfirmedByThe": "Plaćanje već potvrđeno od strane partnera",
"hc.paymentLinksAreNowConfigured": "Linkovi za plaćanje su sada konfigurirani po ustanovama",
"hc.paymentNotCompletedYourAccount": "Plaćanje nije dovršeno, vaš račun nije kreiran — pokušajte ponovo.",
"hc.paymentReceived": "Plaćanje primljeno",
"hc.paymentSuccessful": "Plaćanje uspješno!",
"hc.pdfInvoice": "PDF račun",
"hc.pending": "Na čekanju",
"hc.period": "Razdoblje",
"hc.phoneNumber": "Broj telefona",
"hc.phoneOptional": "Telefon (opcionalno)",
"hc.planAt": "plan na",
"hc.planLimitFmt": "Vaš \"{plan}\" plan je ograničen na {max} ustanova. Za upravljanje {n} lokacijama preporučujemo",
"hc.platformReturnTarget": "Cilj povrata platforme",
"hc.pleaseCompleteYourShippingAddress": "Molimo dovršite svoju adresu za dostavu.",
"hc.pleaseProvideAPhoneNumber": "Molimo navedite broj telefona: potreban je od strane prijevoznika za dostavu.",
"hc.pleaseProvideAReason": "Molimo navedite razlog.",
"hc.pleaseSetYourOwnPassword": "molimo postavite svoju lozinku prije nastavka.",
"hc.pointsToGoal": "{n} dodatnih bodova do našeg zajedničkog cilja.",
"hc.posterPreview": "Pregled plakata",
"hc.potentialMatchBeingVerified": "Potencijalni podudaranje se provjerava",
"hc.potentialOwner": "Potencijalni vlasnik",
"hc.preFilledAutomaticallyYouCan": "Automatski unaprijed ispunjeno — možete ga zamijeniti fotografijom paketa.",
"hc.pressKit": "Press kit",
"hc.previewMode": "Način pregleda:",
"hc.previewOfThePrintReady": "Pregled A4 plakata spremnog za ispis za ovu ustanovu.",
"hc.previous": "Prethodno",
"hc.previousPhoto": "Prethodna fotografija",
"hc.primary": "primarno",
"hc.printThePoster": "Ispisi plakat",
"hc.privacy": "Privatnost",
"hc.privacyPolicy": "Pravilnik o privatnosti",
"hc.processedCasesWillAppearHere": "Obrađeni slučajevi će se pojaviti ovdje.",
"hc.proofOfReturnPdf": "Dokaz o vraćanju (PDF)",
"hc.protectedByRecaptcha": "Zaštićeno reCAPTCHA-om",
"hc.publicMatch": "Javna utakmica",
"hc.putBackInStorage": "Vrati nazad u skladište",
"hc.pwdResetByTeam": "Vaša lozinka je resetirana od strane našeg tima. Radi vaše sigurnosti,",
"hc.questionsToAskTheOwner": "Pitanja za postaviti vlasniku",
"hc.rateChargedToTheCustomer": "Naknada naplaćena kupcu:",
"hc.rateOfTarget": "{rate}% ostvareno od {target}% cilja",
"hc.reached": "postignuto",
"hc.reactivating": "Reaktivacija…",
"hc.reasonSavedYouCanStill": "Razlog je spremljen. Još uvijek možete zatražiti svoj predmet.",
"hc.recentMatchesFirst": "Nedavne utakmice prvo",
"hc.recognizedThePhotoYouSent": "prepoznali smo fotografiju koju ste poslali i opisali ove karakteristike. Potvrdite samo ako se podudaraju s predmetom u vašem posjedu.",
"hc.recommended": "Preporučeno",
"hc.recoveryFees": "Naknade za oporavak",
"hc.recoveryFeesArePaidDirectly": "Naknade za oporavak plaćaju se izravno partnerskoj ustanovi. Findloop ne prima uplatu od kupaca.",
"hc.recoveryFeesEnabled": "Naknade za oporavak omogućene",
"hc.recoveryOfferedByTheEstablishment": "Oporavak ponuđen od strane ustanove — Findloop ne naplaćuje naknade.",
"hc.recoveryPaymentLink": "Link za uplatu oporavka",
"hc.recoveryPaymentLinkSavedFor": "Link za uplatu oporavka spremljen za ovu ustanovu",
"hc.redirecting": "Preusmjeravanje…",
"hc.redirectingToPayment": "Preusmjeravanje na uplatu…",
"hc.redirectingToTheRecoveryOf": "Preusmjeravanje na oporavak vašeg predmeta…",
"hc.regenerateAndResendToThe": "Ponovno generirajte i pošaljite vlasniku",
"hc.regenerateTheCode": "Ponovno generirajte kod",
"hc.registerAFoundItem": "Registrirajte pronađeni predmet",
"hc.rejectTheClaim": "Odbijte zahtjev",
"hc.reminderDelaySaved": "Kašnjenje podsjetnika spremljeno",
"hc.reopenThePaymentLink": "Ponovno otvorite link za uplatu",
"hc.repeatThePassword": "Ponovno unesite lozinku",
"hc.reportAProblem": "Prijavite problem",
"hc.reportDismissedYourListingRemains": "Prijava odbijena. Vaš oglas ostaje javan.",
"hc.requiredUsedToCalculateThe": "Obavezno: koristi se za izračunavanje cijene dostave Sendcloud. Dostava nije dostupna iznad 30 kg.",
"hc.reset": "Poništi",
"hc.resume": "Nastavi",
"hc.resumeRegistration": "Nastavi registraciju",
"hc.retro": "Godina u pregledu",
"hc.returnSecurity": "Sigurnosni povrat",
"hc.returnToTheOwner": "Vratite vlasniku",
"hc.returned": "vratili",
"hc.reviewTheItemDetails": "Pregledajte detalje stavke",
"hc.revokeAccess": "Poništi pristup",
"hc.role": "Uloga:",
"hc.save": "Spremi",
"hc.save2": "spremi",
"hc.saveAndContinue": "Spremi i nastavi",
"hc.saving": "Spremam…",
"hc.scanTheClaimCode": "Skenirajte kod za zahtjev",
"hc.scanTheOwnerSQr": "Skenirajte QR vlasnika",
"hc.scrollThroughLanguages": "Pomaknite se kroz jezike",
"hc.searchByCustomerItemOr": "Pretraži po kupcu, stavci ili broju za praćenje…",
"hc.searchForACountry": "Pretraži za zemlju…",
"hc.secureFindoVerification": "Sigurna Findloop verifikacija",
"hc.seeRetro": "Pogledajte godinu u pregledu",
"hc.selectedCarrier": "Odabrani prijevoznik:",
"hc.selectedPlan": "Odabrani plan",
"hc.send": "Pošalji",
"hc.sendcloudSenderIdSaved": "ID pošiljatelja Sendcloud spremljen",
"hc.sendcloudSenderIdSenderId": "ID pošiljatelja Sendcloud (sender_id)",
"hc.sending": "Šaljem…",
"hc.sessionExpired": "Sesija je istekla",
"hc.setUpYourEstablishments": "Postavite svoje ustanove",
"hc.settings": "Postavke",
"hc.settingsSubtitle": "Vanjska plaćanja i podsjetnici, konfigurirani po ustanovama.",
"hc.shareFoundText": "Pronašao/la sam predmet — pomozite mi pronaći njegovog vlasnika na Findloop",
"hc.shareLostText": "Izgubio/la sam predmet — pomozite mi pronaći ga na Findloop",
"hc.sharePreview": "Dijeli pregled",
"hc.shareTheRanking": "Dijeli rang",
"hc.shareYourQrCodeTo": "Podijelite svoj QR kod kako biste primili deklaracije.",
"hc.shipRateAutoWeight": "Cijena dostave se automatski izračunava putem Sendcloud (težina {w}) u trenutku slanja.",
"hc.shipRateForWeight": "Cijena dostave (Sendcloud + {m}% marža) za {w}:",
"hc.shipments": "Pošiljke",
"hc.shipmentsSubtitle": "Konsolidirani pregled svih pošiljki ustanove, u svim slučajevima. Kliknite na redak za upravljanje pošiljkom u njenoj deklaraciji.",
"hc.shipping": "Dostava",
"hc.shippingAddress": "Adresa dostave",
"hc.shippingFeesAreHandledAutomatically": "Troškovi dostave se automatski obrađuju od strane Findloop (Sendcloud) — nema veze za unos.",
"hc.shippingFeesHaveAlreadyBeen": "Troškovi dostave su već plaćeni: prevoznika više nije moguće mijenjati.",
"hc.shippingNotAvailableForItems": "Dostava nije dostupna za stavke preko 30 kg. Kupac će morati osobno preuzeti predmet.",
"hc.shippingPaid": "Dostava plaćena ✓",
"hc.showOnlyItemsMatchingA": "Prikažite samo stavke koje odgovaraju javnoj (kupac) listi",
"hc.showPassword": "Prikaži lozinku",
"hc.signInTheBoxAbove": "Prijavite se u kutiji iznad",
"hc.signatureSaved": "Potpis spremljen",
"hc.signedInWithGoogle": "Prijavljeno s Googleom",
"hc.signupFailed": "Registracija nije uspjela",
"hc.silver": "Srebrna",
"hc.simulatedRatesInPreProduction": "(simulirane cijene u predprodukciji)",
"hc.siretAndVatNumberRequired": "SIRET i PDV broj su obavezni (Francuska).",
"hc.skip": "Preskoči",
"hc.smsSentIfAccount": "Ako postoji račun s ovim brojem, SMS je poslan na vašu adresu.",
"hc.sortItemsWithAPublic": "Sortiraj: stavke s javnim podudaranjem (najnovije) prvo",
"hc.specifyWhetherYouRecoveredYour": "Odredite jeste li preuzeli svoju stavku ili jednostavno želite ukloniti ovu listu.",
"hc.specifyYourReason": "Odredite svoj razlog",
"hc.specifyYourReason2": "Odredite svoj razlog…",
"hc.staff": "Osoblje",
"hc.status": "Status",
"hc.staySignedIn": "Ostani prijavljen",
"hc.step": "Korak",
"hc.stillThere": "Još si tu?",
"hc.stopScrolling": "Prestanite skrolati",
"hc.storeFindWithQr": "Spremite i pronađite s QR-om",
"hc.streetName": "Ime ulice",
"hc.streetNo": "Broj ulice",
"hc.switchTo": "Prebaci na",
"hc.switchToDarkMode": "Prebaci na tamni način",
"hc.switchToLightMode": "Prebaci na svijetli način",
"hc.takeAPhoto": "Snimi fotografiju",
"hc.takeChangeThePhoto": "Snimi / promijeni fotografiju",
"hc.takenFromYourDeclaration": "uzeto iz vaše deklaracije",
"hc.target": "Cilj",
"hc.targetReached": "Cilj postignut",
"hc.targetReachedThankYouTo": "Cilj postignut — hvala cijeloj Findloop zajednici!",
"hc.tellUsMore": "Recite nam više…",
"hc.tellUsWhyYouCancel": "Recite nam zašto otkazujete. To pomaže partneru u obradi vašeg zahtjeva.",
"hc.tellUsWhyYourListing": "Recite nam zašto. Vaš unos ostaje aktivan i još uvijek možete preuzeti svoj predmet.",
"hc.termsAndConditions": "Uvjeti i odredbe",
"hc.termsAndPolicies": "Uvjeti i politike",
"hc.thankYouForYourFeedback": "Hvala na vašem mišljenju",
"hc.theBannerDisplayedInThe": "baner prikazan u registru.",
"hc.theClaimantHasBeenInformed": "Podnositelj zahtjeva je obaviješten. Predmet ostaje dostupan u javnoj ponudi.",
"hc.theClaimantHasBeenNotified": "Podnositelj zahtjeva je obaviješten i sada može nastaviti s povratom.",
"hc.theCustomerPaysTheFees": "Kupac plaća naknade mjestu.",
"hc.theDayTheLegalRetention": "Dan kada je dostignut zakonski rok zadržavanja.",
"hc.theEstablishmentConsideredThatThis": "Mjesto je smatralo da ovaj predmet nije vaš.",
"hc.theEstablishmentIsReviewingYour": "Mjesto pregledava vaše odgovore. Bit ćete obaviješteni čim vaš zahtjev bude potvrđen, tada možete platiti naknade za povrat.",
"hc.theFeesAreTooHigh": "Naknade su previsoke",
"hc.theFinderConsideredThatThis": "Pronalazač je smatrao da ovaj predmet nije vaš.",
"hc.theFinderIsReviewingYour": "Pronalazač pregledava vaš zahtjev. Bit ćete obaviješteni čim bude potvrđen.",
"hc.theItem": "Predmet",
"hc.theItemWillBeRemoved": "Predmet će biti uklonjen iz registra (nema aktivnog zahtjeva).",
"hc.theItemWillBeSet": "Predmet će biti vraćen u stanje \"na skladištu\" i povezani zahtjev će biti otkazan.",
"hc.theKbisNumberAndVat": "Kbis broj i PDV broj su obavezni za Francusku.",
"hc.theLabelIsGeneratedAutomatically": "Naljepnica se automatski generira čim kupac plati troškove dostave. Bit će dostupna za preuzimanje ovdje.",
"hc.theLinkMayHaveExpired": "Veza je možda istekla (valjana 30 dana). Kontaktirajte Findloop podršku ako je potrebno.",
"hc.theOwnerDescribesTheirItem": "Vlasnik opisuje svoj predmet",
"hc.theOwnerReceivedItBy": "Vlasnik je primio putem e-pošte (ili SMS-a). Unesite ili skenirajte prije predaje.",
"hc.thePartnerConsideredThatThis": "Partner je smatrao da ovaj predmet nije vaš. Predmet ostaje dostupan.",
"hc.thePartnerIsReviewingYour": "Partner pregledava vaše odgovore. Bit ćete obaviješteni čim vaš zahtjev bude potvrđen.",
"hc.theShipmentIsCreatedAutomatically": "Pošiljka se automatski stvara kada kupac potvrdi svoju adresu i plati naknade za povrat. Naljepnica će tada biti automatski generirana nakon plaćanja dostave i može se preuzeti ovdje.",
"hc.theShippingRateWillBe": "Cijena dostave će se automatski izračunati putem Sendcloud-a u trenutku dostave (zabilježena težina).",
"hc.thisCarrierWillBe": "Ovaj prijevoznik će biti",
"hc.thisEstablishment": "ova ustanova",
"hc.thisFieldIsRequiredFor": "Ovo polje je obavezno za automatsku generaciju naljepnica.",
"hc.thisIsMyItem": "Ovo je moj predmet",
"hc.thisIsMyItemContinue": "Ovo je moj predmet — nastavite",
"hc.thisIsMyItemStart": "Ovo je moj predmet — započnite povrat",
"hc.thisIsNotMyItem": "Ovo nije moj predmet",
"hc.thisMatchIsNoLonger": "Ovo podudaranje više nije dostupno ili je već obrađeno.",
"hc.thisRateWillBeCharged": "Ova tarifa će biti naplaćena kupcu. Visoka tarifa može obeshrabriti povrat.",
"hc.thisStepIsRequiredFor": "Ovaj korak je potreban za generiranje naljepnica za dostavu.",
"hc.thisValidationLinkIsInvalid": "Ova poveznica za verifikaciju je neispravna ili je istekao rok.",
"hc.toCheckBeforeMarkingThe": "Provjerite prije nego označite predmet kao vraćen.",
"hc.toConfigureTheLinksAnd": "da konfigurirate poveznice i odgodu podsjetnika za svaku ustanovu.",
"hc.toReachOurFirstMilestone": "da postignemo našu prvu prekretnicu od 100 povrata.",
"hc.toTheCustomer": "kupcu.",
"hc.toTheShippingFeePayment": "plaćanju troškova dostave.",
"hc.toYourRecoveryTracking": "vašem praćenju povrata.",
"hc.tooExpensiveBudget": "Previše skupo / proračun",
"hc.topCitiesForReturns": "Najbolji gradovi za povrate",
"hc.trackMyRecovery": "Prati moj povrat",
"hc.trackTheShipmentAndDownload": "Pratite pošiljku i preuzmite oznaku (automatski generiranu) bez napuštanja kartice Izjave.",
"hc.trackYourStatistics": "Pratite svoje statistike",
"hc.tracking": "Praćenje",
"hc.unableToOpenTheShipping": "Nije moguće otvoriti plaćanje troškova dostave. Pokušajte ponovo.",
"hc.unableToRetrieveTheInvoice": "Nije moguće preuzeti račun.",
"hc.unclaimed": "Nepretrženo",
"hc.unclaimedCustomerReason": "Nepretržen predmet. Razlog kupca: \"{reason}\".",
"hc.unclaimedItem": "Nepretrženi predmet",
"hc.unclaimedItemNoClaimWithin": "Nepretrženi predmet — nema zahtjeva unutar roka.",
"hc.unclaimedItems": "Nepretrženi predmeti",
"hc.unclaimedItemsMatchLeftWithout": "Nepretrženi predmeti: ostao par bez zahtjeva unutar roka. Možete ih vratiti na skladištenje.",
"hc.unlockTheFinderSContact": "Otključajte kontakte pronalazača za dogovor o predaji.",
"hc.upcoming": "Nadolazeće",
"hc.updateFailed": "Ažuriranje nije uspjelo.",
"hc.usedForInvoices": "Koristi se za izdavanje vaših Findloop računa.",
"hc.vatNumber": "OIB",
"hc.verificationPending": "Verifikacija na čekanju",
"hc.verificationSentToTheFinder": "Verifikacija poslana pronalazaču. Bit ćete obaviješteni o njihovoj odluci.",
"hc.verificationSentToThePartner": "Verifikacija poslana partneru. Bit ćete obaviješteni o njihovoj odluci.",
"hc.verify": "Verificiraj",
"hc.verifyingInvite": "Verificiranje poveznice za poziv…",
"hc.verifyingTheLink": "Verificiranje poveznice…",
"hc.viewInRegistry": "Pogledaj u registru",
"hc.viewItem": "Pogledaj predmet",
"hc.viewItemRecover": "Pogledaj predmet & povrati",
"hc.visibleToTheOwnerAutomatically": "Vidljivo vlasniku · automatski izbrisano nakon 60 dana.",
"hc.waitingForPartnerConfirmation": "Čekanje na potvrdu partnera",
"hc.waitingForThePartnerS": "Čekanje na potvrdu partnera",
"hc.weHaveInformedTheEstablishment": "Obavijestili smo ustanovu da ovaj predmet nije vaš i ponovno pokrenuli analizu. Bit ćete obaviješteni čim se pronađe nova podudarnost.",
"hc.weHaveInformedThePartner": "Obavijestili smo partnera da ovaj predmet nije vaš. Vaša ponuda ostaje aktivna za buduće podudarnosti.",
"pcat.stadium_arena": "Stadion / Arena",
"pcat.supermarket": "Supermarket",
"pcat.taxi_vtc": "Taksijada / Druženje vozača",
"pcat.tourism_office": "Turistički ured",
"pcat.train_bus_station": "Željeznički / autobusni kolodvor",
"pcat.travel_agency": "Putnička agencija",
"hc.and": "i",
"hc.demoObj0": "novčanik",
"hc.demoObj1": "sportska torba",
"hc.demoObj2": "telefon",
"hc.demoObj3": "par naočala",
"hc.demoObj4": "set ključeva",
"hc.demoObj5": "šal",
"hc.demoObj6": "laptop",
"hc.demoObj7": "boca za vodu",
"hc.demoWhen0": "prije 2 sata",
"hc.demoWhen1": "prije 5 sati",
"hc.demoWhen2": "jučer",
"hc.demoWhen3": "prije 3 sata",
"hc.demoWhen4": "ovoga jutra",
"hc.demoWhen5": "prije 1 dana",
"hc.feedDemo": "{obj} je vraćen u {city} {when}.",
"hc.feedReal": "Stavka ({cat}) je vraćena u {city}.",
"hc.saveBtn": "Spremi",
"hc.saveLink": "Spremi link",
"hc.terms": "Uvjeti",
"hc.view": "Pogledaj",
"pcat.airline": "Zračna linija",
"pcat.airport": "Zračna luka",
"pcat.amusement_park": "Lunapark",
"pcat.bank": "Banka",
"pcat.bar_cafe": "Bar / Kafić",
"pcat.beauty_salon": "Frizerski / Kozmetički salon",
"pcat.cinema": "Kino",
"pcat.concert_theater": "Koncertna dvorana / Kazalište",
"pcat.coworking": "Coworking prostor",
"pcat.gym_fitness": "Teretana / Fitness",
"pcat.hospital_clinic": "Bolnica / Klinika",
"pcat.library": "Knjižnica",
"pcat.mall": "Trgovački centar",
"pcat.museum": "Muzej",
"pcat.pharmacy": "Ljekarna",
"pcat.private_company": "Privatna tvrtka",
"pcat.public_transport": "Javni prijevoz",
"pcat.school_university": "Škola / Sveučilište",
"pcat.sports_center": "Sportski centar",
"an.found": "Pronađeno",
"an.lost": "Izgubljeno",
"hc.shareReview": "Podijeli recenziju",
"hc.citiesAboveTarget": "{n} gradova iznad svog cilja",
"hc.cityAboveTarget": "{n} grad iznad svog cilja",
"hc.j15EarlyReminder": "D-15 rano podsjećanje",
"hc.j7EarlyReminder": "D-7 rano podsjećanje",
"hc.annualTotal": "Godišnji ukupno",
"hc.billedOnceYear": "Naplaćuje se jednom za 12 mjeseci, obnavlja se svake godine.",
"hc.monthlyPrice": "Mjesečna cijena",
"hc.perMonth": "/ mjesečno",
"hc.perYear": "/ godišnje",
"hc.billedEachMonth": "Naplaćuje se automatski svaki mjesec.",
"nav.business": "Posao",
"nav.individual": "Individualno",
"hc.circumstancesFound": "Okolnosti pronalaska",
"hc.circumstancesFoundPh": "Npr. pronađeno na tlu blizu ulaza u metro",
"hc.circumstancesLost": "Okolnosti gubitka",
"hc.circumstancesLostPh": "Npr. ostavljeno na klupi dok se čekao autobus",
"hc.conditionPh": "Npr. dobro, ogrebano…",
"hc.firstName": "Ime",
"hc.lastName": " Prezime",
"hc.quantity": "Broj predmeta",
"fa.approve": "Odobri",
"fa.approveConfirm": "Odobriti ovu izjavu? Vaši puni kontakt podaci (ime, e-mail, telefon) bit će razmijenjeni s pronalazačem.",
"fa.approved": "Izjava odobrena — kontakt podaci razmijenjeni",
"fa.approvedFinder": "Vlasnik je odobrio vašu izjavu",
"fa.approvedFinderText": "Kontaktirajte ih da dogovorite povratak.",
"fa.boostSub": "Vaš oglas ostaje na vrhu odabranog trajanja.",
"fa.boostTitle": "Povećaj moj oglas (opcionalno)",
"fa.colFinder": "Izjava pronalazača",
"fa.colYours": "Vaša izjava",
"fa.compareHint": "Uporedite izjavu pronalazača s vašom prije nego što odlučite.",
"fa.contribNone": "Bez doprinosa",
"fa.contribPaid": "Doprinos primljen — hvala!",
"fa.contribPending": "Doprinos čeka na plaćanje",
"fa.contribSub": "Podržite Findloop kako biste pomogli više ljudi da povrate svoje stvari. Možete odabrati €0.",
"fa.contribSuccessMsg": "Vaša izjava je poslana vlasniku.",
"fa.contribSuccessTitle": "Hvala na vašem doprinosu",
"fa.contribTitle": "Dobrovoljni doprinos",
"fa.days3": "3 dana",
"fa.days30": "30 dana",
"fa.days7": "7 dana",
"fa.declSub": "Opišite predmet koji ste pronašli. Vlasnik će usporediti vašu izjavu s njihovom.",
"fa.declTitle": "Pronašao sam ovaj predmet",
"fa.expiresOn": "Ističe",
"fa.fBrand": "Brend",
"fa.fCircumstances": "Okolnosti",
"fa.fCity": "Grad",
"fa.fColor": "Boja",
"fa.fCondition": "Stanje",
"fa.fDate": "Datum",
"fa.fMessage": "Poruka pronalazača",
"fa.fPlace": "Mjesto",
"fa.fQuantity": "Količina",
"fa.finderContact": "Kontakt podaci pronalazača",
"fa.finishPay": "Završi uplatu",
"fa.foundDate": "Datum pronalaska",
"fa.foundPlace": "Mjesto pronalaska",
"fa.hours24": "24 sata",
"fa.ht": "bez PDV-a",
"fa.months3": "3 mjeseca",
"fa.noBoost": "Nema povećanja",
"fa.ownerContact": "Kontaktni podaci vlasnika",
"fa.payPublish": "Plati i objavi",
"fa.pendingPayText": "Vaš unos će biti objavljen čim uplata bude potvrđena.",
"fa.pendingPayTitle": "Uplata na čekanju",
"fa.planSub": "Vaš unos ide uživo čim uplata bude potvrđena.",
"fa.planTitle": "Trajanje unosa",
"fa.pubSuccessMsg": "Vaš unos je objavljen. Bit ćete obaviješteni čim se neko javi.",
"fa.pubSuccessTitle": "Unos objavljen",
"fa.publicNote": "Samo su opis, grad, država i fotografije javno prikazani.",
"fa.redirectStripe": "Preusmjeravanje na sigurnu uplatu…",
"fa.reject": "Odbiti",
"fa.rejectConfirm": "Odbiti ovu izjavu? Vaš unos ostaje online.",
"fa.rejected": "Izjava odbijena",
"fa.rejectedFinder": "Nije to predmet koji su tražili",
"fa.rejectedFinderText": "Vlasnik kaže da ovaj predmet nije njihov. Hvala na pomoći!",
"fa.responsesTitle": "Izjave pronalazača",
"fa.sent": "Izjava poslana vlasniku.",
"fa.submitDecl": "Pošaljite moju izjavu",
"fa.submitDeclPay": "Pošaljite i doprinosite {amount}",
"fa.total": "Ukupno za platiti",
"fa.ttc": "uklj. PDV",
"fa.waitClaimText": "Praxatelj razmatra vaš zahtjev. Bit ćete obaviješteni o njihovoj odluci.",
"fa.waitFinderText": "Obavijestit ćemo vas čim se pronalazač javi s izjavom.",
"fa.waitFinderTitle": "Vaš unos je uživo",
"fa.waitOwnerText": "Vlasnik uspoređuje vašu izjavu s njihovom. Bit ćete obaviješteni o njihovoj odluci.",
"fa.waitOwnerTitle": "Čekanje na odluku vlasnika",
"st.pending_payment": "Uplata na čekanju",
"fa.africaFree": "Besplatno oglašavanje u Africi — ponuda prilikom lansiranja findloop-a, uživajte!",
"fa.africaPublished": "Oglašavanje objavljeno besplatno — ponuda prilikom lansiranja Afrike!",
"fa.approveClaimConfirm": "Odobrete li ovu tvrdnju? Tada će vlasnik moći otključati vaše kontakt informacije.",
"fa.checkInfo": "Provjerite svoje podatke prije slanja: usporedit će se s podacima pronalazitelja.",
"fa.claimApprovedShort": "Pronalazitelj je odobrio vašu tvrdnju",
"fa.claimRejectedShort": "Tvrdnja je odbijena od strane pronalazitelja",
"fa.claimRejectedText": "Pronalazitelj smatra da ovaj predmet nije vaš.",
"fa.claimSub": "Opišite svoj predmet i dodajte 2 fotografije. Pronalazitelj će ih usporediti sa svojim oglasom.",
"fa.claimTitle": "Ovo je moj predmet",
"fa.claimUnlockText": "Otključajte kontakt informacije pronalazitelja kako biste dogovorili povratak.",
"fa.claimUnlockedShort": "Kontakt informacije otključane — vidite praćenje",
"fa.claimsTitle": "Tvrdnje vlasnika",
"fa.colOwner": "Izjava vlasnika",
"fa.colYourAd": "Vaše oglašavanje",
"fa.expired": "Oglašavanje je istekao",
"fa.free": "Besplatno",
"fa.lostDate": "Datum gubitka",
"fa.lostPlace": "Mjesto gubitka",
"fa.noReceipt": "Nema dostupnog računa za ovo oglašavanje.",
"fa.planSubFree": "Odaberite trajanje: vaše oglašavanje ide uživo odmah, bez potrebe za plaćanjem.",
"fa.prefillPrevious": "Ponovno upotrijebite podatke mog prethodnog oglasa u ovoj kategoriji",
"fa.receipt": "PDF račun",
"fa.renewBtn": "Obnovi",
"fa.renewDiscountBanner": "50% popusta: obnovite prije nego što vaše oglašavanje istekne!",
"fa.renewDiscountHint": "50% popusta primijenjeno jer obnavljate prije isteka.",
"fa.renewEarly": "Obnovi (−50%)",
"fa.renewTitle": "Obnovi moje oglašavanje",
"fa.renewed": "Oglašavanje obnovljeno",
"fa.sendClaim": "Pošaljite moju tvrdnju",
"fa.twoPhotos": "2 fotografije vašeg predmeta",
"fa.twoPhotosError": "Dodajte 2 fotografije vašeg predmeta.",
"fa.twoPhotosHint": "Osobne fotografije koje dokazuju da je predmet vaš (s predmetom, računun, kutijom…).",
"fa.unlockBtn": "Otključajte kontakt informacije",
"fa.unlockFree": "Otključajte besplatno — ponuda prilikom lansiranja",
"fa.waitClaimantText": "Obavijestit ćemo vas čim vlasnik zatraži ovaj predmet.",
"fa.waitFinderDecision": "Čekanje na odluku pronalazitelja",
"fa.waitUnlockText": "Bit ćete obaviješteni čim se razmijene kontakt informacije.",
"fa.waitUnlockTitle": "Čekanje na vlasnika da otključa",
"fa.cancel": "Otkaži",
"fa.categoryRequired": "Odaberite kategoriju za pronađeni predmet.",
"fa.confirmTitle": "Potvrdite svoju odluku",
"fa.goBack": "Vrati se",
"dr.continue": "Nastavi svoju deklaraciju",
"dr.delete": "Trajno izbriši",
"dr.deleteConfirm": "Trajno izbrisati ovu skicu? Ovo se ne može poništiti.",
"dr.deleted": "Skica izbrisana",
"dr.expiresIn": "Skica će se čuvati još {h} sati",
"dr.title": "Imate nedovršenu deklaraciju",
"form.step": "Korak",
"form.next": "Nastavi",
"form.back": "Natrag",
"form.stepDetails": "Vaš izvještaj",
"form.stepPublish": "Trajanje, poticaj i plaćanje",
"form.stepThanks": "Hvala i doprinos",
"fthx.badge": "Izvještaj skoro gotov",
"fthx.title": "Hvala ti, činiš razliku!",
"fthx.text": "Zahvaljujući tebi, netko bi uskoro mogao dobiti natrag nešto što mu mnogo znači. Dela ljubaznosti poput tvoje upravo su ono što održava Findloop na životu.",
"fthx.impact1": "1 prijavljena stavka",
"fthx.impact2": "1 nova šansa za ponovni susret",
"fthx.tipTitle": "Mali poticaj za Findloop?",
"fthx.tipText": "Vaš doprinos pomaže nam održati uslugu dostupnom i povezati još više predmeta s njihovim vlasnicima.",
"fthx.optional": "100% opcionalno — možete objaviti bez doprinosa.",
"fthx.thanksTip": "Hvala ti puno na tvojoj velikodušnosti!",
"fthx.suggest": "Preporučeni iznosi",
"fthx.none": "Nema napojnice",
"pay.pendingTitle": "Plaćanje nije dovršeno",
"pay.pendingText": "Vaši podaci su spremljeni. Nastavite s plaćanjem točno tamo gdje ste stali.",
"pay.resume": "Nastavite s plaćanjem",
"pay.expiredTitle": "Sesija plaćanja je istekla",
"pay.expiredText": "Za vašu sigurnost, sesija plaćanja je istekla. Vaši podaci su spremljeni: ponovo pokrenite plaćanje jednim klikom.",
"pay.relaunch": "Ponovno pokreni plaćanje",
"sub.received": "Poslano!",
"sub.publishing": "Završavamo…",
"sub.toPayment": "Preusmjeravanje na sigurno plaćanje…",
"fa.claimSubV2": "Opišite svoju izgubljenu stvar. Osoba koja ju je pronašla usporedit će vašu izjavu s njihovim popisom.",
"fa.photosOptional": "Fotografije vaše stavke (opcionalno)",
"fa.compareOwnerHint": "Usporedite ove informacije s predmetom koji ste pronašli, a zatim recite je li to isti predmet.",
"fa.itsThisItem": "Da, ovo je taj predmet",
"fa.notThisItem": "Ne, ovo nije taj predmet",
"fa.confirmIsItem": "Potvrđujete li da je ovo predmet? Vaši kontakt podaci i podaci vlasnika bit će prikazani u vašim računima.",
"fa.confirmNotItem": "Potvrđujete li da ovo nije predmet? Vaš izvještaj će biti zatvoren.",
"fa.youConfirmed": "Potvrdili ste da je ovo predmet vlasnika",
"fa.youDeclined": "Naznačili ste da ovo nije predmet",
"fa.youDeclinedText": "Hvala na pomoći! Vlasnik je obaviješten.",
"fa.waitFinderDecisionOwner": "Čekamo odluku pronađenika",
"fa.finderConfirmed": "Potvrđeno",
"fa.notYourItem": "Ovo nije bila vaša stavka",
"fa.reportedOn": "Prijavljeno dana",
"fa.ownerWaitHint": "Pronađenik trenutno provjerava informacije, molimo pričekajte.",
"fa.claimSentFinder": "Potraživanje poslano osobi koja je pronašla predmet.",
"fa.compareClaimHint": "Usporedite izjavu vlasnika s vašim oglasom prije donošenja odluke.",
"fa.closeFollowup": "Zatvori ovu pratnju",
"fa.closeFollowupConfirm": "Zatvoriti ovu pratnju? E-mailovi i telefonski brojevi obje strane bit će trajno izbrisani kada vlasnik također zatvori svoju ponudu.",
"fa.safetyTitle": "Savjeti za sigurnost prije predaje",
"fa.safety1": "Zatražite od vlasnika detaljan opis skrivenih značajki predmeta: određena ogrebotina, točan sadržaj torbe, tapeta, serijski broj…",
"fa.safety2": "Ako je moguće, zatražite vizualni dokaz (fotografiju predmeta) ili dokaz o kupnji.",
"fa.safety3": "Predajte predmet na javnom mjestu ili kod Findloop partnera, i provjerite vlasnikov ID.",
"fa.safetyOk": "Razumijem, nastavite",
"fa.ownerClosedNote": "Vlasnik je zatvorio svoju ponudu.",
"fa.finderClosedNote": "Pronalaznik je zatvorio svoju pratnju.",
"fa.followupClosed": "Praćenje zatvoreno",
"fa.followupClosedText": "Zatvorili ste ovo praćenje. Hvala na pomoći!",
"fa.photoReviewTitle": "Finder je poslao fotografiju. Izgleda li kao vaš predmet?",
"fa.photoLooksLike": "Da, izgleda kao moj predmet",
"fa.photoNotMine": "Ne, ovo nije moj predmet",
"fa.photoNotMineConfirm": "Nastavak će biti zatvoren s obje strane i vaša lista će ostati otvorena za novog findera.",
"fa.photoLooksLikeDone": "Hvala! Finder će sada usporediti vašu izjavu.",
"fa.photoNotMineDone": "Prijava odbijena. Vaša lista ostaje otvorena.",
"fa.ownerPhotoHint": "Samo fotografija findera se prikazuje vama. Recite nam izgleda li kao vaš predmet.",
"fa.ownerReviewingPhoto": "Vlasnik pregledava vašu fotografiju",
"fa.ownerReviewingPhotoText": "Bit ćete obaviješteni čim odgovore. Tada ćete moći usporediti njihovu izjavu.",
"fa.ownerRejectedPhoto": "Ovo nije predmet vlasnika",
"fa.ownerRejectedPhotoText": "Vlasnik kaže da vaša fotografija ne odgovara njihovom predmetu. Nastavak je zatvoren. Hvala na vašoj pomoći!",
"fa.contribute": "Doprinosite",
"fa.phoneMissing": "Nije navedeno",
"fa.ownerSafety1": "Preferirajte predaju na javnom mjestu ili kod Findloop partnera. Ako je udaljenost velika, predložite slanje poštom umjesto toga.",
"fa.ownerSafety2": "Prilikom predaje, provjerite osobnu iskaznicu pronalazača.",
"pub.changePhoto": "Promijeni fotografiju",
"ph.secured": "Fotografija osigurana",
"ph.securing": "Osiguravanje fotografije…",
"fa.ownerSafety3": "Ako fotografija koja je pronađena nosi Findloop vodeni žig, ne prihvaćajte sastanak. Fotografija mora biti originalna slika koju je snimio pronalazač, bez vodenog žiga."
},
"ca": {
"a.back": "Enrere",
"a.category": "Categoria",
"a.categoryPlaceholder": "Escolliu una categoria",
"a.city": "Ciutat",
"a.confirmPassword": "Confirma la contrasenya",
"a.country": "País",
"a.createAccount": "Crea un compte",
"a.createBtn": "Crea el meu compte",
"a.creating": "Creant…",
"a.email": "Correu electrònic",
"a.emailPro": "Correu electrònic professional",
"a.forgot": "Has oblidat?",
"a.forgotSent": "Si existeix un compte, s'ha enviat un enllaç de restauració.",
"a.forgotSub": "Obté un enllaç de restauració per correu electrònic.",
"a.forgotTitle": "He oblidat la contrasenya",
"a.googleContinue": "Continuar amb Google",
"a.googleSignup": "Inscriu-te amb Google",
"a.haveAccount": "Ja ets un soci?",
"a.legalHint": "Requerit per a la facturació electrònica francesa (Factur-X) dels establiments francesos.",
"a.legalRequiredFR": "El número SIRET i el número d'IVA intracomunitari són obligatoris per a França.",
"a.loggingIn": "Iniciant sessió…",
"a.login": "Iniciar sessió",
"a.loginSub": "Accedeix al teu espai de gestió.",
"a.loginTitle": "Inici de sessió de soci",
"a.min6": "Mínim 6 caràcters",
"a.newPassword": "Nova contrasenya",
"a.noAccount": "Encara no ets un soci?",
"a.or": "O",
"a.org": "Nom de l'establiment",
"a.password": "Contrasenya",
"a.passwordMismatch": "Les contrasenyes no coincideixen.",
"a.referral": "Codi de recomanació (opcional)",
"a.registerSub": "Crea el teu espai en 1 minut — gratuït per començar.",
"a.registerTitle": "Converteix-te en soci",
"a.rememberMe": "Recorda'm",
"a.reset": "Restablir",
"a.resetSub": "Escolliu una nova contrasenya per al vostre compte.",
"a.resetTitle": "Nova contrasenya",
"a.sendLink": "Enviar l'enllaç",
"a.sending": "Enviant…",
"a.signin": "Iniciar sessió",
"a.siret": "SIRET",
"a.vat": "Número d'IVA intracomunitari.",
"ac.africa": "Àfrica",
"ac.boostActive": "Destacar actiu —",
"ac.boostSub": "Apareix a la part superior del directori de socis amb un distintiu de “Destacat”.",
"ac.boostTitle": "Impulsa la teva llista al directori",
"ac.categoryHint": "Per classificar el vostre establiment al directori findloop.",
"ac.choose": "Escollir",
"ac.cityHint": "Per a una posicionament precís al mapa públic.",
"ac.cityLabel": "Ciutat de l'establiment",
"ac.cityPh": "París",
"ac.contact": "Detalls de contacte",
"ac.converted": "Convertit",
"ac.copyDeclLink": "Copia l'enllaç de declaració",
"ac.copyLink": "Copia l'enllaç",
"ac.currentPlan": "Pla actual",
"ac.emailDesc": "Escolliu els correus electrònics que voleu rebre. Les notificacions al vostre espai de treball sempre es mantenen actives.",
"ac.emailMatch": "Coincideix",
"ac.emailMatchDesc": "Un correu electrònic quan un element coincideix amb una declaració",
"ac.emailNewDecl": "Noves declaracions de pèrdues",
"ac.emailNewDeclDesc": "Un correu electrònic tan aviat com un client reporti una pèrdua al teu establiment",
"ac.emailShip": "Sol·licituds d'enviament",
"ac.emailShipDesc": "Un correu electrònic quan un client sol·liciti l'enviament d'un article",
"ac.emailTitle": "Preferències de correu electrònic",
"ac.expireSoon": "El teu destacat expira aviat —",
"ac.exportCsv": "Exportar (CSV)",
"ac.exportHint": "Exporta els teus pagaments externs validats per a la teva comptabilitat.",
"ac.free": "Gratuït",
"ac.freeMonths": "Mesos gratuïts",
"ac.hours": "hores",
"ac.howItWorks": "Com funciona?",
"ac.invited": "Convidat",
"ac.legalFR": "Requerit per a la facturació electrònica (Factur-X) aplicable a partir de setembre de 2026.",
"ac.legalMissing": "⚠️ SIRET i VAT intracomunitari mancants — completa'ls per mantenir-te conforme amb la facturació electrònica.",
"ac.legalOther": "Recomanat per a les teves factures.",
"ac.legalPartnerQr": "Codi QR",
"ac.legalTitle": "Identificadors legals (facturació)",
"ac.logoTitle": "Logotip de l'establiment",
"ac.modeCurrent": "Mode actual:",
"ac.modeExternal": "Externa (validació manual)",
"ac.modeInternal": "Intern Findloop (automàtic)",
"ac.noSubReceipt": "Encara no hi ha cap pagament de subscripció pagada.",
"ac.none": "Cap",
"ac.onYourListing": "a la teva llista",
"ac.pay1": "Introdueix els teus enllaços de pagament a continuació per redirigir els teus clients al teu propi sistema de cobrament.",
"ac.pay2": "La validació es torna manual: confirmes la recepció del pagament des de la pestanya “Declaracions”.",
"ac.pay3": "L'enllaç “Taxa d'enviament” és un pagament consolidat (recuperació + enviament).",
"ac.pay4": "Deixa els camps buits per utilitzar el pagament intern de Findloop (Stripe) amb validació automàtica.",
"ac.paySub": "Recull tarifes a través del teu propi sistema de pagament.",
"ac.payTitle": "Pagaments externs",
"ac.permissive": "Permissiu",
"ac.phone": "Telèfon",
"ac.posterA4": "Cartell A4 (PDF)",
"ac.qMessage": "Missatge (opcional)",
"ac.qName": "Nom",
"ac.qOrg": "Organització",
"ac.qSites": "Nombre d'establiments (estimat)",
"ac.qrHint": "Els teus clients escanegen aquest codi per reportar un article perdut.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "El teu codi QR de soci",
"ac.quoteDesc": "Aeroports, xarxes ferroviàries, cadenes internacionals · ",
"ac.quoteEurope": "Europa / Món",
"ac.quoteSent": "Sol·licitud de pressupost enviada. El nostre equip es posarà en contacte amb tu aviat.",
"ac.quoteTitle": "Sol·licita un pressupost — Empresa",
"ac.recoveryLink": "enllaç “Taxa de recuperació”",
"ac.refSub": "Cada soci referit que subscriu et dona 1 mes gratuït.",
"ac.refTitle": "Referir, guanyar un mes gratuït",
"ac.reminderDelay": "Dret de recordatori de validació",
"ac.reminderHint": "Rebràs un correu electrònic de recordatori si un pagament extern roman no validat més enllà d'aquest retard (per defecte: 48h).",
"ac.renewDesc1": "Ja t'ha guanyat",
"ac.renewDesc2": "Renova per mantenir-te al capdavant del directori i no perdre aquesta visibilitat.",
"ac.renewNow": "Renova ara",
"ac.requestQuote": "Sol·licita un pressupost",
"ac.saveLegal": "Desa els identificadors",
"ac.saveLinks": "Desa els enllaços",
"ac.sendRequest": "Envia la meva sol·licitud",
"ac.sending": "Enviant…",
"ac.shippingLink": "enllaç “Taxa d'enviament” (consolidat)",
"ac.shippingLinkHint": "Aquest enllaç cobreix tant la recuperació com l'enviament.",
"ac.strict": "Estricte",
"ac.subReceipt": "Rebut de subscripció (PDF)",
"ac.subReceiptsSub": "Descarrega el rebut en PDF per cada pagament de subscripció.",
"ac.subReceiptsTitle": "Rebuts de subscripció",
"ac.tCategory": "Categoria desada",
"ac.tCity": "Ciutat desada — mapa actualitzat",
"ac.tCityNeeded": "Introdueix una ciutat",
"ac.tCopied": "Copiat!",
"ac.tCover": "Fotografia de portada actualitzada",
"ac.tEmailPrefs": "Preferències de correu electrònic actualitzades",
"ac.tErr": "Error",
"ac.tExportImpossible": "Exportació fallida",
"ac.tLegal": "Identificadors legals desats",
"ac.tLegalNeeded": "SIRET i IVA requerits per França",
"ac.tLogo": "Logotip actualitzat",
"ac.tLogoRemoved": "Logotip eliminat",
"ac.tPayLinks": "Enllaços de pagament desats",
"ac.tPhone": "Telèfon desat",
"ac.tSensitivity": "Sensibilitat desada",
"ac.tVatInvalid": "Número d'IVA no vàlid",
"ac.tVatValid": "IVA vàlid",
"ac.tabBoost": "Visibilitat",
"ac.tabPayments": "Pagaments",
"ac.tabProfile": "Perfil",
"ac.tabQr": "QR i Pòster",
"ac.tabReferral": "Referència",
"ac.tabSub": "Subscripció",
"ac.thisWeek": "Aquesta setmana",
"ac.thisWeekOf": " ({n} aquesta setmana)",
"ac.thresholdDesc": "Llimite de confiança a partir del qual la IA valida automàticament una coincidència de foto i notifica al client. Més alt = fewer auto-coincidències però més fiables.",
"ac.thresholdTitle": "Sensibilitat de coincidència visual de la IA",
"ac.trend": "Tendència",
"ac.upload": "Pujar",
"ac.vatValidFmt": "IVA vàlid{name} ({via})",
"ac.vatVerified": "IVA intracomunitari verificat",
"ac.verifyVat": "Verifica l'IVA (VIES)",
"ac.verifying": "Verificant…",
"ac.views": "visualitzacions",
"ac.viewsTotal": "Visualitzacions guanyades (total)",
"ac.winbackBtn": "Reprendre amb -20%",
"ac.winbackDesc1": "T'ha pogut guanyar",
"ac.winbackDesc2": "Oferta especial: -20% aplicades automàticament si renoves dins de 24h.",
"ac.winbackTitle": "El teu moment destacat acaba de caducar — resumeix amb -20%!",
"ad.boost": "Impulsar",
"ad.close": "Tancar",
"ad.closeConfirm": "Tancar aquesta llista?",
"ad.closed": "Llista tancada",
"ad.edit": "Editar",
"ad.editTitle": "Editar llista",
"ad.saved": "Llista actualitzada",
"an.allCountries": "Tots els països",
"an.badge": "Articles perduts",
"an.boostLater": "Més tard",
"an.boostNow": "Impulsa ara",
"an.boostPrompt": "Impulsa la teva llista per col·locar-la a dalt i ser trobat més ràpidament.",
"an.boosted": "Impulsat",
"an.contact": "He trobat aquest article",
"an.contactTitle": "Reporta que has trobat aquest article",
"an.copyFailed": "No s'ha pogut copiar l'enllaç",
"an.copyLink": "Copia l'enllaç",
"an.country": "País",
"an.date": "Data perduda",
"an.finderEmail": "El teu correu electrònic",
"an.finderName": "El teu nom",
"an.finderPhone": "El teu telèfon",
"an.geoBanner": "Estàs veient anuncis a",
"an.geoBannerWorld": "Estàs veient anuncis a tot el món",
"an.geoChange": "canvia el país",
"an.goAccount": "Vés al meu compte",
"an.linkCopied": "Enllaç copiat!",
"an.loginRequired": "Inicia sessió per informar d’aquest article i seguir la devolució.",
"an.loginToBoost": "Inicia sessió per impulsar aquest anunci",
"an.lostAt": "Perdut a",
"an.message": "Missatge (opcional)",
"an.none": "Encara no hi ha anuncis.",
"an.photo": "Foto (opcional)",
"an.post": "Publica un anunci",
"an.postSubtitle": "Descriu el teu article perdut: la comunitat i els nostres socis t'ajuden a trobar-lo.",
"an.postTitle": "Informar d'un article perdut",
"an.publish": "Publicar anunci",
"an.published": "Anunci publicat!",
"an.publishing": "Publicant…",
"an.remaining": "quedat",
"an.requestInProgress": "Sol·licitud en curs",
"an.resolved": "Article ja recuperat",
"an.reward": "Recompensa",
"an.searchPh": "Cerca un anunci…",
"an.send": "Enviar",
"an.sent": "Missatge enviat al propietari!",
"an.shareConsent": "Accepto que les meves dades de contacte (nom, correu electrònic, telèfon) es puguin compartir amb el propietari de l'article.",
"an.shareConsentError": "Si us plau, marca la casella per compartir les teves dades de contacte.",
"an.sortRecent": "Més recent",
"an.sortRelevance": "Relevància",
"an.subtitle": "Explora articles reportats com a perduts per la comunitat. Has trobat un d'ells?",
"an.title": "Anuncis d'articles perduts",
"anf.badge": "Articles trobats",
"anf.claim": "Això és meu",
"anf.claimSent": "Missatge enviat al qui ha trobat l'article!",
"anf.claimTitle": "Informar que aquest és el teu article",
"anf.consent": "Accepto que el propietari pugui veure les meves dades de contacte per recuperar el seu article.",
"anf.foundAt": "Trobat a",
"anf.foundDate": "Data trobada",
"anf.loginCta": "Iniciar sessió / crear un compte",
"anf.loginDesc": "Es requereix un compte de trobador per publicar un anunci i guanyar punts de Finder Hero.",
"anf.loginRequired": "Inicia sessió per publicar un article trobat",
"anf.photo": "Foto de l'article",
"anf.pointsEarned": "Gràcies! Acabes de guanyar punts de Finder Hero.",
"anf.pointsPending": "Els teus punts s'acreditaran en menys de 24h, després de la verificació.",
"anf.post": "Publica un article trobat",
"anf.postSubtitle": "Descriu l'article que has trobat: ajuda al seu propietari a recuperar-lo.",
"anf.postTitle": "Informar d'un article trobat",
"anf.publishFound": "Publicar anunci trobat",
"anf.published": "Anunci d'article trobat publicat",
"anf.publishedAs": "Publicat com a",
"anf.shareConsent": "Accepto que les meves dades de contacte (nom, correu electrònic, telèfon) es puguin compartir amb la persona que ha trobat l'article.",
"anf.subtitle": "Explora articles trobats i reportats per la comunitat. Reconèixes el teu?",
"anf.title": "Anuncis d'articles trobats",
"bo.active": "Impuls actiu",
"bo.africaPrice": "Preu preferencial de la zona d'Àfrica aplicat",
"bo.pay": "Pagar i impulsar",
"bo.remaining": "Temps restant",
"bo.renew": "Renovar bretxa",
"bo.since": "des de la bretxa",
"bo.subtitle": "Col·loca el teu anunci a la part superior de la llista amb una inscripció visible.",
"bo.title": "Augmentar anunci",
"c.all": "Tots",
"c.cancel": "Cancel·la",
"c.close": "Tanca",
"c.confirm": "Confirma",
"c.confirmed": "Confirmat",
"c.download": "Descarrega",
"c.loading": "Carregant…",
"c.reset": "Reestableix",
"c.reviews": "crítiques",
"c.save": "Desa",
"c.transfer": "Transferir",
"cat.Animal": "Mascota / Accessori per a mascotes",
"cat.AppareilPhoto": "Càmara",
"cat.Argent": "Dinero / Efectiu",
"cat.Autres": "Altres",
"cat.Bijoux": "Joies",
"cat.CarteBancaire": "Targeta bancària",
"cat.CarteIdentite": "Document d'identitat / Passaport",
"cat.Casquette": "Gorro",
"cat.Ceinture": "Cinturó",
"cat.Chargeur": "Carregador / Cable",
"cat.Chaussures": "Sabates",
"cat.CleVoiture": "Clau del cotxe",
"cat.Cles": "Claus",
"cat.Console": "Consola de jocs",
"cat.Documents": "Documents",
"cat.Echarpe": "Bufanda",
"cat.Ecouteurs": "Auriculars",
"cat.Electronique": "Electrònica (altres)",
"cat.Enceinte": "Altaveu",
"cat.Gants": "Guants",
"cat.Gourde": "Ampolla d'aigua / Termos",
"cat.Instrument": "Instrument musical",
"cat.Jouet": "Joguina / Plush",
"cat.Jumelles": "Binocles",
"cat.Lampe": "Llum / Llanterna",
"cat.Liseuse": "Lecteur electrònic",
"cat.Livre": "Llibre / Quadern",
"cat.Lunettes": "Ulleres",
"cat.Manteau": "Abric / Jaqueta",
"cat.Maquillage": "Bossa de maquillatge",
"cat.Medical": "Equipament mèdic",
"cat.Medicaments": "Medicaments",
"cat.Montre": "Rellotge / Smartwatch",
"cat.Ordinateur": "Portàtil",
"cat.Parapluie": "Paraigües",
"cat.Portefeuille": "Cartera / Bossa",
"cat.Poussette": "Cotxet / Accessori de nen",
"cat.Sac": "Bossa / Bossa de mà",
"cat.SacADos": "Mochila",
"cat.Souris": "Ratolí / Teclat",
"cat.Sport": "Equipament esportiu",
"cat.Tablette": "Tauleta",
"cat.Telephone": "Telèfon / Smartphone",
"cat.Trottinette": "Patinet",
"cat.Trousse": "Bossa / Estoig",
"cat.USB": "Pen drive / Disc dur",
"cat.Valise": "Maleta / Equipatge",
"cat.Velo": "Bicicleta",
"cat.Vetements": "Roba",
"cat.placeholder": "Escolliu una categoria",
"cd.d": "d",
"cd.expired": "Caducat",
"cd.h": "h",
"cd.m": "min",
"ck.accept": "Acceptar",
"ck.acceptAll": "Acceptar tot",
"ck.customize": "Personalitzar",
"ck.learn": "Més informació",
"ck.manage": "Gestionar cookies",
"ck.measurement": "Mesura d'audiència",
"ck.measurementDesc": "Estadístiques anònimes per millorar el servei.",
"ck.msg": "Fem servir cookies per mantenir el lloc web en funcionament i mesurar l'audiència.",
"ck.necessary": "Necessàries",
"ck.necessaryDesc": "Essencials perquè el lloc web funcioni. Sempre activades.",
"ck.refuse": "Rebutjar",
"ck.save": "Desa les meves opcions",
"ck.saved": "Preferències desades",
"ck.title": "Les teves preferències de cookies",
"cm.found": "TROBAT",
"cm.lost": "PERDUT",
"cmp.adv": "Avançat",
"cmp.ai": "Coincidència AI",
"cmp.autobill": "Facturació automàtica",
"cmp.basic": "Bàsic",
"cmp.community": "Comunitat",
"cmp.consol": "Facturació consolidada",
"cmp.custom": "Personalitzat",
"cmp.dedicated": "Dedicat",
"cmp.deploy": "Desplegament dedicat & SLA",
"cmp.estIncl": "Establiments inclosos",
"cmp.estSec": "Establiment addicional",
"cmp.items": "Articles / mes",
"cmp.main": "1 principal",
"cmp.max20": "20 màx",
"cmp.members": "Invitacions a membres",
"cmp.onQuote": "Cotització personalitzada",
"cmp.priority": "Prioritat",
"cmp.starterEst": "1 inclòs + il·limitats addicionals",
"cmp.stats": "Estadístiques",
"cmp.statsAdv": "Avançades",
"cmp.statsBasic": "Bàsiques",
"cmp.support": "Suport",
"cmp.unlimited": "Il·limitat",
"cmp.upTo3": "Fins a 3",
"consent.required": "Heu d'acceptar compartir els vostres detalls de contacte per continuar.",
"consent.share": "Accepto que el trobador del meu article pugui veure els meus detalls de contacte (nom, correu electrònic, telèfon) per contactar-me per la seva devolució.",
"cover.add": "Afegir",
"cover.change": "Canviar",
"cover.helper": "Mostrat com un banner a la vostra pàgina de report i al directori.",
"cover.none": "Sense foto de portada",
"cover.remove": "Eliminar",
"cover.title": "Foto de portada",
"crop.desc": "Ajusteu el marc al ratio del banner (3:1). Arrossegueu i feu zoom.",
"crop.saving": "Desant…",
"crop.title": "Retalla la foto de portada",
"cta.button": "Crea el meu compte de soci",
"cta.subtitle": "Uneix-te als establiments que retornen articles més ràpidament amb findloop.",
"cta.title": "Preparat per reduir articles perduts?",
"db.account.s": "Gestiona el teu establiment, subscripció i codi QR.",
"db.account.t": "El meu compte",
"db.declarations.s": "Clients que han reportat un article perdut a través del teu codi QR.",
"db.declarations.t": "Informes de pèrdua",
"db.deposit.s": "Afegeix una foto, una categoria i una descripció.",
"db.deposit.t": "Registra un article trobat",
"db.registry.s": "Tots els articles trobats registrats al teu establiment.",
"db.registry.t": "Registre d'articles",
"db.reviews.s": "Respon públicament a les valoracions dels teus clients.",
"db.reviews.t": "Valoracions dels clients",
"db.shipments.s": "Genera etiquetes i fa un seguiment dels paquets a enviar.",
"db.shipments.t": "Enviaments",
"db.stats.s": "Els teus indicadors clau de rendiment.",
"db.stats.t": "Estadístiques",
"db.team.s": "Convida els teus companys a gestionar articles.",
"db.team.t": "Equip",
"dc.partnerDesc": "Has perdut el teu article en un local associat (hotel, estació, sala…)? Selecciona'l per a un retorn directe.",
"dc.partnerList": "Tria de la llista",
"dc.partnerMap": "Tria al mapa",
"dc.partnerTitle": "Declaració en un soci",
"dc.publicCta": "Publica un anunci públic",
"dc.publicDesc": "El teu anunci serà visible per a tota la comunitat findloop. Ideal si no saps on has perdut l'article.",
"dc.publicTitle": "Declaració pública",
"dc.subtitle": "Tria com vols reportar el teu article perdut.",
"dc.title": "Què t'agradaria fer?",
"dec.addrPending": "Adreça pendent del client",
"dec.analyzing": "Analitzant…",
"dec.badge": "Informe de pèrdua",
"dec.category": "Categoria de l'article",
"dec.clientDescription": "Descripció del client",
"dec.clientPhoto": "Foto proporcionada pel client",
"dec.clientPhotoShort": "Foto del client",
"dec.comparePhotos": "Comparar fotos",
"dec.contactTitle": "Les teves dades de contacte",
"dec.date": "Data de pèrdua",
"dec.declaredItemPhoto": "Foto de l'article declarat",
"dec.descPh": "Descriu l'article: marca, color, marques distintives…",
"dec.description": "Descripció",
"dec.email": "Correu electrònic",
"dec.emptyDesc": "Comparteix el teu codi QR per rebre declaracions.",
"dec.emptyTitle": "Sense declaracions",
"dec.enlarge": "Amplia",
"dec.extBanner": "{n} pagament(s) extern(s) a validar — confirma la recepció a continuació per desbloquejar el traspàs o l'enviament.",
"dec.foundItemAlt": "Article trobat",
"dec.foundItemRegistry": "Article trobat (registre)",
"dec.home": "Torna a l'inici",
"dec.labelClient": "Client",
"dec.labelRegistry": "Registre",
"dec.matchFound": "Ja s'ha identificat una coincidència!",
"dec.name": "Nom complet",
"dec.noMatchYet": "Sense coincidència encara.",
"dec.noPhoto": "Sense foto",
"dec.notfound": "Soci no trobat.",
"dec.pRecup": "recuperació",
"dec.pRecupP": "(recuperació)",
"dec.pRecupShip": "(recuperació + enviament)",
"dec.payConfirmed": "Pagament {x} confirmat",
"dec.payPending": "Pagament extern {x} pendent",
"dec.phone": "Telèfon",
"dec.pickup": "Recollida en persona",
"dec.place": "Lloc de pèrdua",
"dec.placePh": "p. ex. al bar, habitació 204…",
"dec.recoverBtn": "Recupera el meu article",
"dec.reject": "Rebutjar",
"dec.rerun": "Tornar a executar l'anàlisi",
"dec.similarity": "Similitud {n}%",
"dec.submit": "Envia el meu informe",
"dec.submitting": "Enviant…",
"dec.successText": "Estem cercant el teu article entre els que es troben a",
"dec.successTitle": "Informe enviat!",
"dec.suggestedMatches": "Coincidències suggerides",
"dec.toColon": " a:",
"dec.toShip": "Per enviar",
"dec.toastExtPay": "Pagament confirmat — el client serà notificat.",
"dec.toastMatch": "Coincidència confirmada",
"dec.toastReject": "Suggeriment rebutjat",
"dec.toastRerun": "Anàlisi reiniciada",
"dec.toastVisualN": "{n} coincidència visual(s)",
"dec.toastVisualNone": "Sense coincidència visual",
"dec.trackBtn": "Rastreja el meu informe",
"dec.viewBeforeAfter": "Vista abans/després (superposició)",
"dec.viewSideBySide": "Vista comparativa",
"dec.visualCompare": "Comparació visual AI",
"dec.visualIdle": "Executa la comparació perquè la IA compari visualment la foto del client amb els articles trobats.",
"dec.visualRunning": "La IA està comparant la foto del client amb articles al teu registre…",
"dec.zoomPhoto": "Augmentar la foto",
"dep.addAnyway": "Afegeix de totes maneres",
"dep.addError": "Error mentre s'afegia",
"dep.addItem": "Afegeix article",
"dep.added": "Article afegit al registre!",
"dep.adding": "Afegint…",
"dep.aiError": "Anàlisi AI no disponible ara mateix.",
"dep.aiFilled": "Formulari pre omplert per la IA ✨",
"dep.aiUnavailable": "IA no disponible — omple el formulari manualment.",
"dep.analyzing": "Analitzant…",
"dep.analyzingPhoto": "Analitzant foto…",
"dep.brand": "Marca",
"dep.brandPlaceholder": "p. ex. Apple",
"dep.category": "Categoria",
"dep.checkingDup": "Comprovant duplicats…",
"dep.color": "Color",
"dep.colorPlaceholder": "p. ex. negre",
"dep.condition": "Condició",
"dep.conditionPlaceholder": "p. ex. bona condició",
"dep.depositorNote": "Nota del dipositari",
"dep.depositorNoteHint": "Detalls operatius escrits a mà. La IA mai sobreescriu aquesta nota.",
"dep.depositorNotePlaceholder": "p. ex. contingut d'una bossa, marca tal com es reporta, detalls donats per la persona…",
"dep.descPlaceholder": "p. ex. iPhone 15 negre amb una funda transparent, trobat al bar…",
"dep.description": "Descripció",
"dep.dupHint": "Assegura't que no estiguis afegint un duplicat. Pots continuar si l'article és genuïnament diferent.",
"dep.dupTitle": "Article(s) similar(s) ja registrats",
"dep.dupWarn": "S'ha detectat un article similar — revisa, després torna a fer clic per confirmar.",
"dep.estHint": "L'article s'afegirà al registre d'aquest establiment.",
"dep.establishment": "Establiment",
"dep.fee": "Fiança de recuperació (€) — opcional",
"dep.feePlaceholder": "Deixa buit per al preu per defecte de la categoria",
"dep.fillAI": "Omplir amb IA",
"dep.optional": "(opcional)",
"dep.photo": "Foto de l'element",
"dep.principal": "primari",
"dep.reqError": "La categoria i la descripció són obligatòries.",
"dep.savedItem": "Element registrat",
"dep.similarity": "Similitud",
"dep.storage": "Ubicació física",
"dep.storageHint": "On es guarda físicament l'element. Es generarà un codi QR per trobar-lo.",
"dep.storagePlaceholder": "p. ex. Estant A3, Taquilla 12, caixa de recepció",
"dl.aClient": "un client",
"dl.alertsBlocked": "Alertes del navegador bloquejades",
"dl.alertsBlockedHint": "Per tornar-les a activar: fes clic a la icona 🔒 (o ⓘ) a l'esquerra de l'adreça del lloc, després permet les notificacions i torna a carregar la pàgina.",
"dl.amountDue": "Import degut: {amount} {currency}.",
"dl.enableAlerts": "Habilitar alertes",
"dl.extPending": "Pagaments per validar",
"dl.freemiumNear": "T'estàs apropant al límit Freemium ({used}/{max} elements aquest mes). Actualitza a Starter per a elements il·limitats.",
"dl.freemiumReached": "Límit Freemium assolit ({used}/{max} elements aquest mes). Actualitza a Starter per registrar elements il·limitats.",
"dl.invoiceOverdue": "Factura {num} impagada — accés restringit.",
"dl.matchNotifTitle": "Findloop — Nova coincidència d'IA 🔔",
"dl.matchToast": "Nova coincidència d'IA — {name}",
"dl.matchToastDesc": "Un element coincideix amb una declaració.",
"dl.notifEmpty": "Encara no hi ha notificacions.",
"dl.notifEnabled": "Alertes del navegador habilitades",
"dl.notifTitle": "Notificacions",
"dl.payInvoice": "Paga la meva factura →",
"dl.rewardsPending": "Vouchers per presentar",
"dl.upgradeStarter": "Actualitza a Starter →",
"est.all": "Tots els establiments ({n})",
"est.label": "Establiment",
"est.primary": "primari",
"est.secondary": "secundari",
"est2.add": "Afegir un establiment",
"est2.addressLabel": "Adreça",
"est2.addressPh": "12 Rue de la République",
"est2.autoInvoice": "Una factura detallada es genera automàticament el dia 1 de cada mes.",
"est2.baseSub": "Subscripció base",
"est2.billing": "Facturació",
"est2.boostActivated": "Impuls activat per {name}",
"est2.boostBillingNote": "Facturat al preu actual i agrupat a la teva factura mensual consolidada.",
"est2.boostCta": "Impulsar",
"est2.boostDesc": "Millora la visibilitat d'aquest establiment al directori i al mapa.",
"est2.boostDuration": "{h}h de visibilitat impulsada",
"est2.boostExtend": "Extendre",
"est2.boostTitle": "Impulsar {name}",
"est2.boosted": "Impulsat",
"est2.chartDesc": "Part d'element retornats sobre el total registrat, lloc per lloc.",
"est2.chartTitle": "Taxa de retorn per establiment",
"est2.chartTooltip": "Retorn",
"est2.cityLabel": "Ciutat",
"est2.cityPh": "Lió",
"est2.contactHint": "Aquests detalls es mostren al client per aquest establiment (retrocedeix al compte si està buit).",
"est2.countryLabel": "País",
"est2.coverLabel": "Foto de portada",
"est2.create": "Crear",
"est2.created": "Establiment creat",
"est2.delete": "Eliminar",
"est2.deleteDesc": "Aquesta acció és permanent. Només pots eliminar un establiment si no conté elements.",
"est2.deleteTitle": "Eliminar “{name}”?",
"est2.deleted": "Establiment eliminat",
"est2.dialogDesc": "Introdueix el nom i l'adreça d'aquest lloc.",
"est2.edit": "Editar",
"est2.editEst": "Editar establiment",
"est2.emailLabel": "Correu electrònic de contacte",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " establiment(s)",
"est2.extraNoteBase": "{n} establiment(s) addicionals facturats",
"est2.extraPrice": " a {price} €/mes.",
"est2.extraQuote": " a pressupost.",
"est2.imgChange": "Tria una imatge",
"est2.imgDone": "Fet",
"est2.imgRemove": "Eliminar",
"est2.imgRemoved": "Imatge eliminada",
"est2.imgSaved": "Imatge desada",
"est2.imgUploading": "Pujant…",
"est2.includedPlan": "Inclòs en el teu pla: {n}.",
"est2.kDeclarations": "Declaracions",
"est2.kInStorage": "En magatzem",
"est2.kItemsTotal": "Articles (total)",
"est2.kRestituted": "Tornats",
"est2.limitReached": "Límit assolit",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Decl.",
"est2.mItems": "Articles",
"est2.mRestituted": "Tornats",
"est2.mStorage": "En magatzem",
"est2.monthlyTotal": "Total mensual",
"est2.nameLabel": "Nom *",
"est2.namePh": "per exemple. Belmont Hotel — Annex de Lió",
"est2.newEst": "Nou establiment",
"est2.onQuote": "A pressupost",
"est2.phoneLabel": "Telèfon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Pla",
"est2.planLimited": "El teu pla “{tier}” està limitat a {max} establiment(s).",
"est2.primary": "Primari",
"est2.qr": "Codi QR",
"est2.qrDesc": "Mostra aquest codi QR en aquest establiment. Els clients que reportin una pèrdua estaran vinculats amb aquest lloc.",
"est2.qrTitle": "Codi QR — {name}",
"est2.saving": "Estalviant…",
"est2.seeInvoices": "Veure les meves factures mensuals",
"est2.seePlans": "Veure els plans",
"est2.subtitle": "Gestiona tots els teus llocs sota un compte — vista consolidada, articles, codi QR i facturació.",
"est2.suspended": "Suspès",
"est2.tierFree": "1 establiment",
"est2.tierLarge": "establiments il·limitats",
"est2.tierMedium": "5 establiments inclosos",
"est2.tierSmall": "3 establiments inclosos",
"est2.title": "Establiments",
"est2.unlimitedPlan": "El teu pla permet un nombre il·limitat d'establiments.",
"est2.unlimitedSuffix": " · il·limitat",
"est2.updated": "Establiment actualitzat",
"est2.upgradeHint": "Actualitza a un pla més alt per afegir més llocs i centralitzar tota la teva activitat.",
"est2.visuals": "Logo i foto",
"est2.visualsDesc": "Personalitza el logo i la foto de portada d'aquest establiment. Apareixen a la seva pàgina pública i formulari de declaració.",
"est2.visualsTitle": "Visuals — {name}",
"est2.workOn": "Treballa en aquest establiment",
"est2.working": "Estàs treballant en “{name}”",
"ev.created": "Informe creat",
"ev.matched": "Article coincident identificat",
"ev.paid": "Quota de recuperació pagada",
"ev.pickup": "Recollida al lloc",
"ev.shipped": "Paquet enviat",
"ev.shipping_paid": "Quota d'enviament pagada",
"ev.shipping_requested": "Enviament sol·licitat",
"feat1.d": "KPIs, taxa de retorn per categoria, ingressos i tendències de 30 dies.",
"feat1.t": "Tauler de control i anàlisi",
"feat2.d": "Etiquetes, seguiment de transportistes i correus electrònics de seguiment automàtic.",
"feat2.t": "Mòdul d'enviament",
"feat3.d": "Els clients et troben per ciutat i categoria, amb ressenyes certificades.",
"feat3.t": "Directori públic i ressenyes",
"fp.backToRanking": "Torna al rànquing",
"fp.badge": "Insígnia",
"fp.hero": "Heroi Finder",
"fp.notFound": "Perfil no trobat o privat.",
"fp.scoreTotal": "Punts totals",
"fp.scoreYear": "Punts en",
"fp.share": "Comparteix aquest perfil",
"fp.shareText": "Mira el perfil de finder de {name} a Findloop!",
"fp.tagline": "Un finder sincer que fa del món un lloc millor.",
"ft.backAccount": "Torna al meu compte",
"ft.closeBtn": "Tanca el cas",
"ft.closeConfirm": "Confirmar que l'objecte ha estat retornat? L'anunci es tancarà.",
"ft.closeLockedHint": "Valida primer el codi de l'propietari per desbloquejar el tancament.",
"ft.closed": "Cas tancat — objecte retornat!",
"ft.codeLabel": "Introduce el codi de validació rebut de l'propietari",
"ft.codeNeeded": "Si us plau, introdueix el codi de validació.",
"ft.codeOk": "Codi validat — pots tancar el cas.",
"ft.codePlaceholder": "p. ex. 4821",
"ft.codeVerified": "Validat",
"ft.doneMsg": "Objecte retornat. Gràcies per ajudar a retornar-lo al seu propietari!",
"ft.stepInProgress": "Retorn en curs",
"ft.stepPublished": "Anunci publicat",
"ft.stepReturned": "Objecte retornat",
"ft.subtitle": "Segueix els passos fins que l'objecte trobat sigui retornat.",
"ft.title": "Seguiment de retorn",
"ft.verifyBtn": "Valida el codi",
"hero.badge": "Destacat",
"hero.ctaFound": "He trobat un objecte",
"hero.ctaLost": "He perdut un objecte",
"hero.ctaPartner": "Converteix-te en un soci",
"hero.subtitle": "Findloop ajuda els establiments a gestionar els objectes trobats — i permet als seus clients informar d'una pèrdua i recuperar els seus objectes, al lloc o per enviament.",
"hero.title": "Cada objecte perdut troba el seu propietari.",
"home.champBecome": "Converteix-te en un finder",
"home.champCta": "Veure rànquing",
"home.champSubtitle": "Cada objecte retornat guanya punts. Uneix-te al rànquing i guanya recompenses.",
"home.champTitle": "Els nostres millors finders",
"how.eyebrow": "Com funciona",
"how.title": "Des de la devolució fins al retorn, sense esforç.",
"inv.all": "Tots",
"inv.allYears": "Tots els anys",
"inv.count": "Factures",
"inv.due": "vençut",
"inv.empty": "Encara no hi ha factures.",
"inv.exportCsv": "Exportar CSV",
"inv.invoicePdf": "Factura PDF",
"inv.issued": "Emesa",
"inv.noMatch": "Sense factura per aquest filtre.",
"inv.paid": "Pagada (€)",
"inv.paidOn": "pagada el",
"inv.pay": "Pagar",
"inv.receipt": "Justificant",
"inv.reminders": "Rappels",
"inv.remindersDesc": "Rappels per correu electrònic i SMS enviats per aquesta factura.",
"inv.remindersEmpty": "No s'ha enviat cap recordatori.",
"inv.rmDue": "Recordatori de data de venciment",
"inv.rmManual": "Recordatori manual",
"inv.rmSms": "Recordatori SMS D+30",
"inv.rmStage": "Recordatori",
"inv.statusPaid": "Pagat",
"inv.statusUnpaid": "Impagat",
"inv.subtitle": "Vegeu i descarregueu les vostres factures i justificants.",
"inv.title": "Les meves factures",
"inv.unpaid": "Impagat (€)",
"inv2.contractTitle": "El meu contracte Findloop",
"inv2.detailByEst": "Detall per establiment",
"inv2.dueLabel": "Venciment:",
"inv2.dueSuffix": " · venciment {date}",
"inv2.error": "Error {status}",
"inv2.estCountIssued": "{n} establiment(s) · emès el {date}",
"inv2.estimate": "Pressupost (no cobrat) · {n} establiment(s)",
"inv2.expired": " · caducat",
"inv2.exportCsv": "Exportar CSV",
"inv2.exportDone": "CSV exportat descarregat",
"inv2.included": "Inclòs",
"inv2.monthlyTitle": "Facturació mensual (subscripció)",
"inv2.months": "+{n} mesos",
"inv2.paid": "Pagat",
"inv2.pay": "Pagar",
"inv2.previewTitle": "Vista prèvia de la vostra propera factura —",
"inv2.renew": "Renovar el meu contracte",
"inv2.renewalsTitle": "Historial de renovacions ({n})",
"inv2.renewedUntil": "Contracte renovat fins al {date}",
"inv2.serviceTitle": "Factures de servei (recuperacions i pressupostos)",
"inv2.soon": "Caduca aviat",
"inv2.toPay": "A pagar",
"inv2.totalHtTva": "Total excl. impostos · IVA",
"inv2.totalTtc": "Total incl. impostos",
"iu.addPhoto": "Afegir una foto",
"iu.change": "Canviar",
"lang.label": "Idioma",
"lb.allCountries": "Tots els països",
"lb.badge": "Classificació anual",
"lb.champion": "🏆 Campió de l'any",
"lb.cityPh": "Filtrar per ciutat…",
"lb.empty": "Sense classificació per a aquests filtres encara.",
"lb.pts": "punts",
"lb.resetNote": "Classificació de l'any en curs — restableix cada 1 de gener.",
"lb.returned": "retornat",
"lb.share": "Compartir classificació",
"lb.shareText": "Mira la classificació dels millors finders a Findloop!",
"lb.subtitle": "Cada retorn guanya punts. La classificació es restableix cada 1 de gener.",
"lb.tabFinders": "Finders",
"lb.tabPartners": "Establiments",
"lb.title": "Millors finders",
"lost.b2bDesc": "Ho has perdut en un hotel, centre de transport o lloc associat? Troba l'establiment i informa sobre la teva pèrdua.",
"lost.b2bTitle": "Informar a un sòcia",
"lost.b2cDesc": "Publica un anunci visible per a tothom, ofereix una recompensa i impulsa'l per maximitzar les teves possibilitats.",
"lost.b2cTitle": "Publicar un anunci públic",
"lost.desc": "Trieu com us agradaria procedir.",
"lost.title": "Has perdut un objecte?",
"map.allCategories": "Totes les categories",
"map.clear": "Restableix",
"map.exitFullscreen": "Sortir",
"map.filterCity": "Ciutat o país…",
"map.fullscreen": "Pantalla completa",
"map.heatmap": "Mapa de calor",
"map.high": "Alt",
"map.impactMonth": "objectes retornats aquest mes",
"map.impactTotal": "retornats en total",
"map.legend": "Punts de colors de vermell (baix) a verd (alt) en funció de la taxa de retorn; mida en funció del nombre d'objectes.",
"map.locating": "Localitzant… afegeix una adreça als teus establiments per veure'ls al mapa.",
"map.low": "Baix",
"map.mAll": "Tots",
"map.mFound": "Trobats",
"map.mLost": "G बेरber",
"map.medium": "Mitjà",
"map.noItemRegistered": "No s'ha registrat cap objecte",
"map.noItems": "Sense objecte",
"map.period30": "Últims 30 dies",
"map.period7": "Últims 7 dies",
"map.period90": "Últims 90 dies",
"map.periodAll": "Tot el temps",
"map.returnedSuffix": "retornats · {a}/{t} objectes",
"map.stats": "Estadístiques de la ciutat",
"map.statsTop": "Top 5 llocs (objectes perduts)",
"map.statsTrend": "Tendència de 6 mesos",
"map.title": "Mapa dels teus establiments",
"map.topPlaces": "Llocs populars",
"mc.adClosed": "Anunci tancat",
"mc.addPhoto": "Afegir una foto",
"mc.adsNone": "Sense anunci d'objecte perdut.",
"mc.archiveHide": "Amaga la història",
"mc.archiveNone": "Encara no hi ha cap cas resolt.",
"mc.archiveShow": "Mostra la història",
"mc.archiveSub": "Casos resolts i retornats.",
"mc.archiveTitle": "Història",
"mc.at": "A",
"mc.backToLogin": "Torna a la connexió",
"mc.boostContacts": "Contactes (impuls)",
"mc.boostViews": "Visites (impuls)",
"mc.cancel": "Cancel·la",
"mc.certificate": "Certificat",
"mc.changePhoto": "Canvia la foto",
"mc.city": "Ciutat",
"mc.closeAd": "Tanca",
"mc.closeAdConfirm": "Tancar aquest anunci? Ja no serà visible i es dessubirà una plaça.",
"mc.confirmPassword": "Confirma la contrasenya",
"mc.confirmRestitution": "Confirma el retorn",
"mc.connect": "Connecta",
"mc.contacts": "Contactes",
"mc.country": "País",
"mc.declareFound": "Reportar un objecte trobat",
"mc.declareFoundSub": "Publica un objecte que has trobat",
"mc.declareLost": "Reportar una pèrdua",
"mc.declareLostSub": "Publica un anunci d'objecte perdut",
"mc.deleteAccount": "Esborra el meu compte",
"mc.deleteConfirm": "Sí, esborra el meu compte",
"mc.deleteConfirmBody": "El teu compte serà eliminat de manera permanent i les teves dades personals s'anonimitzaran. Aquesta acció no es pot desfer.",
"mc.deleteConfirmTitle": "Esborrar el teu compte?",
"mc.deleteDesc": "Elimina permanentment el teu compte i anonimitza les teves dades personals. Aquesta acció no es pot desfer.",
"mc.deleted": "El teu compte ha estat eliminat.",
"mc.deleting": "Eliminant…",
"mc.email": "Correu electrònic",
"mc.expiresOn": "Caduca el",
"mc.exportData": "Descarregar les meves dades (GDPR)",
"mc.exportDone": "Les teves dades s'han descarregat.",
"mc.exporting": "Preparant…",
"mc.finderAccepted": "Acceptat",
"mc.finderProfile": "Perfil del trobar (opcional)",
"mc.finderProfileDesc": "Guanya punts tornant articles i apareix al rànquing públic.",
"mc.forYourAd": "Per la teva publicació",
"mc.forgotLink": "Has oblidat la contrasenya?",
"mc.forgotSend": "Enviar l'enllaç",
"mc.forgotSent": "Si existeix un compte per aquest correu electrònic, s'ha enviat un enllaç de restabliment.",
"mc.forgotTitle": "Has oblidat la contrasenya",
"mc.foundAdsNone": "No s'ha publicat cap llistat d'articles trobats.",
"mc.foundAt": "Trobat a",
"mc.foundNone": "No s'ha reportat cap article trobat.",
"mc.hAd": "Anunci perdut",
"mc.hDeclaration": "Declaració",
"mc.hFinderContact": "Article reportat",
"mc.hFound": "Article retornat",
"mc.hFoundAd": "Anunci trobat",
"mc.histEarned": "Article retornat",
"mc.historyTitle": "El meu historial de punts",
"mc.loginBtn": "Inicia sessió",
"mc.loginTitle": "Inici de sessió del client",
"mc.logout": "Tanca sessió",
"mc.lostAt": "Perdut a",
"mc.matchPartner": "A un soci",
"mc.matchPublic": "Article trobat",
"mc.matches": "Coincidències",
"mc.matchesSub": "Els articles trobats poden coincidir amb les teves publicacions d'articles perduts.",
"mc.myAds": "Els meus anuncis d'articles perduts",
"mc.myDeclarations": "Els meus informes",
"mc.myFinds": "Articles que he trobat",
"mc.myFindsNone": "Encara no has reportat haver trobat cap article.",
"mc.myFindsSub": "Articles que has reportat haver trobat en anuncis d'articles perduts.",
"mc.myFound": "Articles trobats reportats",
"mc.myFoundAds": "Les meves publicacions d'articles trobats",
"mc.myRewards": "Els meus vals",
"mc.name": "Nom complet",
"mc.newPassword": "Nova contrasenya",
"mc.none": "Encara no hi ha informes.",
"mc.notEnough": "Pocs punts",
"mc.notifEmpty": "Encara no hi ha notificacions.",
"mc.notifOpen": "Veure",
"mc.notifTitle": "Notificacions",
"mc.notifTrack": "Rastrejar",
"mc.notifViewAd": "Veure anunci",
"mc.optInDesc": "Participació opcional. Consentes a mostrar públicament els articles seleccionats a continuació. Canviable en qualsevol moment.",
"mc.optInTitle": "Aparèixer al rànquing públic",
"mc.password": "Contrasenya",
"mc.passwordMismatch": "Les contrasenyes no coincideixen.",
"mc.phone": "Telèfon",
"mc.photoUpdated": "Foto de perfil actualitzada",
"mc.pointsAwaiting": "Punts pendents",
"mc.pointsBalance": "Punts per gastar",
"mc.pointsOk": "Punts acreditats",
"mc.presentHint": "Mostra aquest QR al soci: ells el scanegen per validar la teva recompensa.",
"mc.presentInStore": "Mostra a la botiga",
"mc.presentTitle": "Mostra aquest val",
"mc.privacy": "Privacitat i dades",
"mc.privacyDesc": "Descarrega una còpia de totes les dades personals que Findloop té sobre tu (GDPR, art. 15 i 20).",
"mc.profileSaved": "Perfil actualitzat.",
"mc.profileSettings": "Perfil públic i classificació",
"mc.pseudo": "Nom o sobrenom",
"mc.redExpired": "Caducat",
"mc.redReady": "Mostra al soci",
"mc.redUsed": "Utilitzat",
"mc.redeem": "Canvia",
"mc.registerBtn": "Crea el meu compte",
"mc.registerTitle": "Crea un compte de client",
"mc.rememberMe": "Recorda'm",
"mc.remove": "Elimina",
"mc.resetDone": "Contrasenya actualitzada. Ara pots iniciar sessió.",
"mc.resetExpired": "Aquest enllaç de restabliment no és vàlid o ha caducat. Sol·licita'n un de nou a continuació.",
"mc.resetSave": "Restablir la meva contrasenya",
"mc.resetTitle": "Nova contrasenya",
"mc.restitutionConfirmed": "Retorn confirmat.",
"mc.reward": "Recompensa",
"mc.rewardRedeemed": "Recompensa desbloquejada! Codi:",
"mc.rewardsDesc": "Utilitza els teus punts per avantatges oferts pels nostres socis. Balanç:",
"mc.rewardsNone": "Encara no hi ha cap recompensa disponible.",
"mc.rewardsTitle": "Gasta els meus punts",
"mc.scoreAwarded": "Ben fet! +1 al teu Finder Score 🎉",
"mc.scoreEarned": "Punt guanyat",
"mc.scorePts": "punts",
"mc.scoreThisYear": "Aquest any",
"mc.scoreTitle": "Finder Score",
"mc.seeRanking": "Veure classificació",
"mc.share": "Comparteix",
"mc.statsTitle": "Estadístiques",
"mc.subtitle": "Fes el seguiment de tots els teus informes en un sol lloc.",
"mc.title": "El meu compte",
"mc.toLogin": "Ja registrat?",
"mc.toRegister": "Encara no tens compte?",
"mc.track": "Rastrejar",
"mc.views": "Visualitzacions",
"mc.visCity": "Ciutat",
"mc.visCountry": "País",
"mc.visLabel": "Elements visibles a la classificació:",
"mc.visName": "Nom / sobrenom",
"mc.visPhoto": "Foto de perfil",
"mc.welcome": "Hola",
"mc2.acceptFinder": "Accepta aquest finder",
"mc2.accountActivity": "Activitat del compte",
"mc2.adsActive": "{n}/5 anuncis actius",
"mc2.autoDelete": "Eliminació automàtica programada per a",
"mc2.badgeBronze": "Bronze",
"mc2.badgeGold": "Or",
"mc2.badgeSilver": "Silver",
"mc2.boostEarnedAlready": "Ja t'ha guanyat",
"mc2.boostEarnedWin": "T'ha guanyat",
"mc2.boostExpiredWin": "El teu boost acaba de caducar — torna a activar-lo amb un -20%!",
"mc2.boostExpiresIn": "El teu boost caduca en",
"mc2.boostWinDetail2": ". -20% aplicat automàticament si el renoves en 24h.",
"mc2.claimCode": "Codi de reclamació:",
"mc2.codeSentFinder": "Codi enviat al finder per correu electrònic",
"mc2.daysShort": "{n} d",
"mc2.downloadReceipt": "Descarregar el meu rebut",
"mc2.error": "Error {status}",
"mc2.finderAccepted": "Finder acceptat — codi enviat per correu electrònic",
"mc2.finderContacts": "Detalls de contacte del Finder",
"mc2.followFindo": "Segueix Findloop",
"mc2.imgInvalid": "Imatge no vàlida",
"mc2.inactivityNote": " — en cas d'inactivitat de {n} mesos (GDPR).",
"mc2.lastActivity": "Última activitat:",
"mc2.lostEmailTitle": "Ja no tinc accés al meu correu electrònic",
"mc2.noPhotoPreset": "Encara no tens foto? Tria un avatar per defecte:",
"mc2.paidViaPartner": "Pagat (a través de partner)",
"mc2.payRecovery": "Paga la taxa de recuperació",
"mc2.paySettle": "Regular el meu pagament",
"mc2.payShipping": "Paga la taxa d'enviament",
"mc2.payUnavailable": "Pagament no disponible",
"mc2.peopleFound": "{n} persona/es creuen que han trobat el teu article",
"mc2.phoneNumber": "Número de telèfon",
"mc2.reactivateAccount": "Reactiva el meu compte",
"mc2.reactivated": "Compte reactivat",
"mc2.reactivatedThanks": "Compte reactivat — gràcies per la teva fidelitat!",
"mc2.recoverSmsBtn": "Obtenen el meu codi per SMS",
"mc2.recoverSmsDesc": "Rep el teu codi de reclamació per SMS al número registrat al teu compte.",
"mc2.recoverSmsFallback": "Si existeix un compte amb aquest número, s'ha enviat un SMS.",
"mc2.renewStayTop": ". Renova per mantenir-te a la part superior i recuperar el teu article.",
"mc2.resume20": "Reanudar -20%",
"mc2.unlockContacts": "Desbloquejar detalls de contacte",
"mc2.unlockDesc": "Paga la taxa de gestió de Findloop per revelar els seus detalls de contacte i organitzar la entrega.",
"mc2.viewsWord": "veus",
"mc2.live": "En directe",
"mh.allCategories": "Totes les categories",
"mh.allPeriod": "Tot el temps",
"mh.autoMatch": "Coincidència AI automàtica",
"mh.blocked": "Bloquejat (contradictori)",
"mh.blockedReason": "Coincidència bloquejada: les paraules clau principals de l'article i la declaració es Contradicten.",
"mh.days30": "Últims 30 dies",
"mh.days7": "Últims 7 dies",
"mh.days90": "Últims 90 dies",
"mh.emptyDesc": "Les coincidències AI apareixeran aquí a mesura que arribin les declaracions.",
"mh.emptyTitle": "Sense esdeveniments",
"mh.exportCsv": "Exportar CSV",
"mh.exportDone": "Exportació CSV descarregada",
"mh.exportImpossible": "Exportació fallida",
"mh.fBlocked": "Bloquejat",
"mh.fConfirmed": "Confirmat",
"mh.fRejected": "Rebutjat",
"mh.objectLabel": "Article:",
"mh.refresh": "Actualitzar",
"mh.rejected": "Rebutjat",
"mh.srcManual": "Manual",
"mh.srcText": "Text",
"mh.srcVisual": "Visual (foto)",
"mh.subtitle": "Registre de coincidències proposades per AI — coincidència automàtica, confirmades i rebutjades.",
"mh.title": "Historial AI",
"nav.ads": "Articles perduts",
"nav.dashboard": "El meu espai",
"nav.found": "Articles trobats",
"nav.how": "Com funciona",
"nav.login": "Iniciar sessió",
"nav.map": "Mapa",
"nav.more": "Més",
"nav.partners": "Socis",
"nav.pricing": "Preus",
"nav.ranking": "Taula de classificació",
"nav.register": "Converteix-te en soci",
"nav.track": "Segueix una declaració",
"nf.desc": "La pàgina que estàs buscant no existeix o ha estat traslladada.",
"nf.home": "Torna a la pàgina principal",
"nf.title": "Pàgina no trobada",
"par.allCities": "Totes les ciutats",
"par.allCountries": "Tots els països",
"par.badge": "Directori",
"par.certified": "Certificat",
"par.certifiedBadge": "Certificat",
"par.cityPh": "Ciutat",
"par.declare": "Declarar",
"par.none": "No s'ha trobat cap soci.",
"par.partnerBadge": "Soci",
"par.searchPh": "Cerca un establiment…",
"par.subtitle": "Troba l'establiment on vas perdre el teu article i declara la teva pèrdua.",
"par.title": "Els nostres socis",
"pay.addr1": "Adreça",
"pay.addr2": "Línia d'adreça 2 (opcional)",
"pay.addrIncomplete": "Si us plau, omple la teva adreça de lliurament.",
"pay.badge": "Recuperació",
"pay.card": "Paga amb targeta",
"pay.city": "Ciutat",
"pay.country": "País",
"pay.eurNote": "Quantitats mostrades en euros (€).",
"pay.fee": "Quota de recuperació",
"pay.free": "gratuït",
"pay.howRecover": "Com t'agradaria recuperar el teu article?",
"pay.momo": "Paga amb Mobile Money",
"pay.momoConfirm": "Confirmar el pagament",
"pay.noMatch": "No s'ha confirmat cap article que coincideixi amb aquesta declaració encara.",
"pay.notfound": "Declaració no trobada.",
"pay.phonePh": "Número de telèfon",
"pay.pickup": "Recollir en persona",
"pay.pickupDesc": "A",
"pay.postal": "Codi postal",
"pay.secure": "Pagament segur",
"pay.serviceFee": "quota de servei Findloop",
"pay.ship": "Envia-ho a mi",
"pay.shipAfter": "— ofereix després del pagament.",
"pay.shipDesc": "Lliurament a la meva adreça",
"pay.shipNote": "Enviament disponible",
"pay.shipping": "Quota d'enviament",
"pay.subtitleWith": "Paga la quota de recuperació a",
"pay.title": "Recuperar el meu article",
"pay.total": "Total",
"pcat.city_hall": "Ajuntaments",
"pcat.hotel": "Hotels",
"pcat.other": "Altres",
"pcat.park": "Parcs",
"pcat.prefecture": "Prefectures",
"pcat.restaurant": "Restaurants",
"pcat.uncategorized": "Sense classificar",
"pd.about": "Sobre",
"pd.back": "Tots els socis",
"pd.certified": "Soci certificat",
"pd.declare": "Declarar una pèrdua aquí",
"pd.itemsReturned": "elements retornats",
"pd.itemsTotal": "elements registrats",
"pd.map": "Ubicació",
"pd.noItems": "No s'han trobat elements recentment.",
"pd.noReviews": "Encara no hi ha ressenyes.",
"pd.notFound": "Soci no trobat.",
"pd.recentItems": "Elements trobats recentment",
"pd.reply": "Resposta de l'establiment",
"pd.reviews": "Ressenyes dels clients",
"pd.verified": "Ressenya verificada",
"pd.verifiedEstablishment": "establiment verificat per Findloop",
"pg.next": "Següent",
"pg.prev": "Anterior",
"pg.showing": "{from}–{to} de {total}",
"pk.bodyCopy": "Text del cos",
"pk.bodyText": "Text del cos",
"pk.brandColors": "Colors de la marca",
"pk.colorRed": "Vermell",
"pk.colorWhite": "Blanc",
"pk.darkBg": "Fons fosc",
"pk.download": "Descarregar",
"pk.downloadZip": "Descarrega tot el kit (ZIP)",
"pk.headings": "Titols",
"pk.heroDesc": "Logos oficials, pancartes de xarxes socials, colors i tipografia. Trieu l'idioma i variant del lema, després descarregueu el visual o el kit complet.",
"pk.lightBg": "Fons clar (impressió)",
"pk.logoWordmark": "Logo / marca verbal",
"pk.logosVisuals": "Logos i visuals",
"pk.mapCollect": "Mapa / punts de recollida",
"pk.plain": "Pla",
"pk.pressKit": "Kit de premsa",
"pk.taglineLang": "Idioma del lema",
"pk.typography": "Tipografia",
"pk.variant": "Variant",
"pr.shipBtn": "Fer enviar l'element",
"pr2.adBoostMsg": "Gran elecció! Multipliques les teves possibilitats de recuperar ràpidament el teu element.",
"pr2.boostActivated": "Boost activat!",
"pr2.canRecoverNow": "Ara pots recuperar el teu element.",
"pr2.continue": "Continuar",
"pr2.downloadReceiptPdf": "Descarregar el rebut (PDF)",
"pr2.goToSpaceNow": "Ves al meu compte ara",
"pr2.partnerBoostMsg": "Gran elecció! Ser més visible significa atraure nous clients al teu establiment.",
"pr2.paymentSuccess": "Pagament realitzat amb èxit!",
"pr2.redirectingSpace": "Redirigint al teu compte…",
"pr2.subActivated": "Pagament realitzat amb èxit! La teva subscripció està activa, ara pots gestionar els teus establiments.",
"prev.allSites": "Tots els establiments",
"prev.editReply": "Edita la resposta",
"prev.none": "Encara no hi ha ressenya.",
"prev.published": "Resposta publicada",
"prev.reply": "Resposta",
"prev.replyPh": "Escriu una resposta cortès…",
"prev.send": "Publicar resposta",
"prev.sending": "Publicant…",
"prev.yourReply": "La teva resposta",
"pricing.annual": "Anual",
"pricing.annualBadge": "-20% oferta",
"pricing.choose": "Escollir",
"pricing.compareFeature": "Funcionalitat",
"pricing.compareTitle": "Comparar plans",
"pricing.eyebrow": "Preus",
"pricing.month": "/mes",
"pricing.monthly": "Mensual",
"pricing.perYear": "/any",
"pricing.popular": "Popular",
"pricing.quoteMsg": "Les teves necessitats (opcional)",
"pricing.quoteOrg": "Organització",
"pricing.quoteSend": "Enviar sol·licitud",
"pricing.quoteSent": "Sol·licitud enviada! Ens posarem en contacte amb tu aviat.",
"pricing.quoteSites": "Nombre de llocs / terminals",
"pricing.quoteTitle": "Sol·licita un pressupost",
"pricing.requestQuote": "Sol·licita un pressupost",
"pricing.saveLabel": "Estalvies",
"pricing.savePerYear": "/any per establiment extra",
"pricing.start": "Començar",
"pricing.subtitle": "Comença gratis, escala a mesura que creixes.",
"pricing.title": "Un pla per a cada organització",
"promo.badge": "Programa de socis",
"promo.cta": "Obtén més informació",
"promo.text": "Cada soci que refereixes que es subscriu et dona un mes gratis. Sense límits.",
"promo.title": "Refereix un soci, aconsegueix un mes gratis.",
"pub.accessGranted": "Accés concedit",
"pub.accessLimited2h": "Accés limitat a 2 hores",
"pub.accountEmailConcerned": "Correu electrònic del compte afectat",
"pub.adAppearPublic": "Així és com apareixerà el teu anunci públicament.",
"pub.adPreviewBtn": "Previsualització d'anunci",
"pub.alertMeOnArrival": "Avisa'm a l'arribada",
"pub.allActionsLogged": "Totes les accions estan registrades",
"pub.allCategories": " totes les categories",
"pub.authorizeAccess": "Autoritzar accés",
"pub.authorizeSupportQ": "Autoritzar accés al suport?",
"pub.available": "Disponible",
"pub.backHome": "Torna a l'inici",
"pub.boostAdCta": "Impulsa el meu anunci",
"pub.boostAdTitle": "Impulsa el teu anunci",
"pub.boostCarouselSub": "Mou-te a la part superior de la pàgina en el carrusel “Impulsat” i multiplica les visualitzacions per recuperar el teu article més ràpidament.",
"pub.boostEstablishment": "Impulsa el teu establiment",
"pub.boostEstablishmentDesc": "Apareix a la part superior del directori amb un distintiu “Impulsat” i atraig més informes.",
"pub.boostFicheCta": "Impulsa la meva llista",
"pub.brandReady": "La marca Findloop, llesta per usar",
"pub.cantFindItem": "No pots trobar el teu article?",
"pub.cantProcessImage": "No s'ha pogut processar aquesta imatge",
"pub.claimQr": "Reclama el codi QR",
"pub.clickToZoom": "Fes clic per fer zoom",
"pub.codeAlreadyValidated": "Codi validat — contactes desbloquejats.",
"pub.codeExample": "p. ex. ABCD2345",
"pub.confirmRenewal": "Confirma la renovació",
"pub.contactIntro": "Una pregunta, una sol·licitud? Escriu-nos, ens posarem en contacte amb tu aviat.",
"pub.contactTypeDeceased": "Eliminació del compte (persona difunta)",
"pub.contactTypeGeneral": "Pregunta general",
"pub.contactTypeSupport": "Suport / problema tècnic",
"pub.contactUs": "Contacta'ns",
"pub.continueWithoutEmail": "Continuar sense deixar el meu correu electrònic",
"pub.contractLabel": "Contracte",
"pub.contractNotFound": "Contracte no trobat o ja expirat.",
"pub.contractRenewed": "Contracte renovat!",
"pub.contractRenewedFor": "El teu contracte s'ha renovat per {n} mesos.",
"pub.copyFailed": "Copia fallida",
"pub.createPartnerAccount": "Crea el meu compte de soci",
"pub.currentDeadline": "Data límit actual",
"pub.deceasedInfo": "Com a familiar o hereu, pots sol·licitar l'eliminació del compte Findloop d'una persona difunta. Processarem la teva sol·licitud en conformitat amb el GDPR (es poden sol·licitar documents de suport).",
"pub.declareMyLoss": "Informar de la meva pèrdua",
"pub.describeItemPlaceholder": "Descriu el teu article (per exemple, paraigua negre, claus…)",
"pub.downloadImage": "Descarrega la imatge",
"pub.drawSignature": "Si us plau, dibuixa la teva firma.",
"pub.drawSignatureHint": "Dibuixa la teva firma amb el ratolí o el dit.",
"pub.duration": "Durada",
"pub.eSignature": "Signatura electrònica",
"pub.eSignatureDesc": "Introdueix el teu nom per signar. La data es registrarà automàticament.",
"pub.edit": "Editar",
"pub.editorialTitles": "Títols editorials",
"pub.emailPlaceholder": "tu@example.com",
"pub.enterCodeUnlockOwner": "Introdueix el codi rebut per correu electrònic per desbloquejar els detalls de contacte del propietari.",
"pub.errorWord": "Error",
"pub.foundSelfService": "Articles trobats · Autoservei",
"pub.haveOwnerCode": "He rebut un codi del propietari",
"pub.home": "Inici",
"pub.immediateRenewal": "Renovació immediata, sense nova cotització.",
"pub.impAdminReq1": "Administrador",
"pub.impAdminReq2": "sol·licita permís per accedir temporalment al teu compte",
"pub.impAdminReq3": "per ajudar-te.",
"pub.impGrantedDesc": "L'equip de suport podrà accedir al teu compte durant un màxim de 2 hores. Cada acció serà registrada. Pots tancar aquesta pàgina.",
"pub.invitedOnFindo": "Estàs convidat a Findloop",
"pub.isThisYourItem": "És aquest el teu article?",
"pub.itemsAvailableCount": "{n} article(s) actualment disponibles",
"pub.itemsFoundOwner": "d'articles confiats que han trobat el seu propietari",
"pub.itemsReturnedOwners": "articles retornats als seus propietaris",
"pub.itsMine": "És meu",
"pub.joinFindoDesc": "Uneix-te a Findloop i gestiona els teus articles trobats amb facilitat.",
"pub.joinInvitesYou": "et convida a unir-te a findloop. Crea el teu compte de soci per gestionar els teus articles trobats.",
"pub.linkCopied": "Enllaç copiat!",
"pub.loadingContract": "Carregant el contracte…",
"pub.lsClaimDesc": "Reporta la teva pèrdua per recuperar-la. Deixa el teu correu electrònic i t'enviarem un recordatori si el teu informe no està completat.",
"pub.lsHeroDesc": "Comprova pel teu compte si el teu article perdut ha estat trobat i deixat aquí. L'has trobat? Reporta-ho per recuperar-ho.",
"pub.lsSearchTitle": "Cerca articles trobats",
"pub.makeOffer": "Fes una oferta",
"pub.makeOfferDesc": "Proposa la teva quantitat. El superadministrador la revisarà.",
"pub.mapNearYou": "Articles i socis a prop teu",
"pub.mapWord": "Mapa",
"pub.messageSentToast": "Missatge enviat — el nostre equip et respondrà aviat.",
"pub.messageWord": "Missatge",
"pub.momoInitiated": "Pagament de Mobile Money iniciat",
"pub.monthsWord": "mesos",
"pub.nameConsentRequired": "Nom i consentiment necessaris.",
"pub.newDeadline": "Nou termini",
"pub.noActionRequired": "No és necessària ninguna acció.",
"pub.noAmountCharged": "No s'ha cobrat cap quantitat.",
"pub.noItemMatch": "Actualment no hi ha cap article disponible que coincideixi amb la teva cerca.",
"pub.noMatchingItem": "No hi ha cap article coincident",
"pub.noPaymentSession": "No hi ha cap sessió de pagament.",
"pub.noPhoto": "Sense foto",
"pub.noPointsYet": "Sense punts per mostrar encara.",
"pub.noSecondPayment": "No es requereix un segon pagament per aquest article.",
"pub.notHereYet": "Encara no aquí? Rebràs una notificació tan aviat com arribi.",
"pub.notifyDone": "Anotat! T'informarem per correu electrònic tan aviat com arribi un article coincident.",
"pub.offerSubmitted": "La teva oferta ha estat enviada.",
"pub.oops": "Ups",
"pub.orAlertEmail": "O rep una alerta per correu electrònic tan aviat com arribi un article coincident:",
"pub.ownerContacts": "Detalls de contacte del propietari",
"pub.ownerContactsUnlocked": "Detalls de contacte del propietari desbloquejats",
"pub.partnerContact": "Contacte del soci",
"pub.payLinkUnavailable": "Enllaç de pagament no disponible — contacta amb el soci.",
"pub.paymentCancelled": "Pagament cancel·lat",
"pub.paymentConfirmed": "Pagament confirmat 🎉",
"pub.paymentConfirmedDesc": "Rebràs un correu electrònic amb els detalls per recuperar el teu article.",
"pub.paymentNotConfirmed": "Pagament no confirmat",
"pub.paymentNotConfirmedDesc": "El pagament no s'ha pogut verificar. Torna-ho a provar o contacta amb el soci.",
"pub.paymentProcessing": "El pagament s'està processant. Actualitza en un moment.",
"pub.photoAdded": "✓ Photo afegida",
"pub.photoRequired": "Es requereix una foto de l'article.",
"pub.previewAlt": "previsualització",
"pub.publish": "Publicar",
"pub.publishingWord": "Publicant…",
"pub.qty": "Quantitat",
"pub.quoteDeclined": "Pressupost rebutjat.",
"pub.quoteNotFound": "Pressupost no trobat o caducat.",
"pub.reasonLabel": "Raó",
"pub.recoveryAlreadyPaid": "La quota de recuperació ja està pagada",
"pub.referralCode": "Codi de referència:",
"pub.relationshipPlaceholder": "Fill, cònjuge, notari…",
"pub.renewYourContract": "Renova el teu contracte",
"pub.renewalFailed": "La renovació ha fallat. Torna-ho a provar més tard.",
"pub.renewing": "Renovant…",
"pub.replySoon": "El nostre equip respondrà tan aviat com sigui possible.",
"pub.requestGone": "Aquesta sol·licitud ja no existeix.",
"pub.requestHandled": "Sol·licitud ja gestionada",
"pub.requestNotFound": "Sol·licitud no trobada o caducada.",
"pub.requestUnavailable": "Sol·licitud no disponible",
"pub.required": "(requerit)",
"pub.retroClosing": "Junts, fem que el món sigui una mica menys perdut.",
"pub.retroClosing2": "Junts, fem que el món sigui una mica menys perdut.",
"pub.retroScroll": "Un any recuperant el que importa. Desplaça't avall ↓",
"pub.revokeAnytime": "Pots revocar en qualsevol moment contactant amb nosaltres",
"pub.scene": "Escena",
"pub.sendImpossible": "Impossible d'enviar",
"pub.sendMessage": "Envia el missatge",
"pub.sending": "Enviant…",
"pub.sharePreview": "Comparteix la previsualització",
"pub.shareYourAd": "Comparteix el teu anunci",
"pub.signedSuccess": "Signat amb èxit!",
"pub.signerFullName": "Nom complet del signant",
"pub.spreadNetwork": "Comparteix-ho amb els que t'envolten per millorar les teves possibilitats.",
"pub.spreadOwner": "Comparteix-ho per ajudar al propietari a recuperar les seves pertinences.",
"pub.statusLabel": "Estat:",
"pub.subject": "Assumpte",
"pub.thanksSent": "Gràcies, el teu missatge s'ha enviat.",
"pub.thisYear": "Aquest any",
"pub.validate": "Validar",
"pub.verifyingPayment": "Verificant pagament…",
"pub.verifyingYourPayment": "Verificant el teu pagament…",
"pub.viewAd": "Veure l'anunci →",
"pub.viewPartner": "Veure el soci →",
"pub.yourAdPreview": "Previsualització del teu anunci",
"pub.yourEmail": "El teu correu electrònic",
"pub.yourEmailRecommended": "El teu correu electrònic (recomanat)",
"pub.yourEmailShort": "El teu correu electrònic",
"pub.yourName": "El teu nom",
"pub.yourRelationship": "La teva relació amb la persona",
"qv.acceptAndSign": "Acceptar i signar el meu pressupost",
"qv.certifyAuthorized": "Certifico que estic autoritzat per signar i accepto els termes d'aquest {what} (valor vinculant).",
"qv.clear": "Esborrar",
"qv.client": "Client",
"qv.conditions": "Termes",
"qv.confirmDecline": "Confirma el rebuig d'aquest pressupost?",
"qv.countersignedFindo": "Contra-signat per Findloop · {name} el {date}",
"qv.decline": "Rebutjar",
"qv.description": "Descripció",
"qv.downloadPdf": "Descarregar el PDF",
"qv.handwrittenSignature": "Signatura manuscrita",
"qv.inclTax": "Incl. IVA",
"qv.invalidAmount": "Quantitat no vàlida.",
"qv.invoice": "Factura",
"qv.invoicePaid": "Factura pagada",
"qv.issuer": "Emissor",
"qv.messageOptional": "Missatge (opcional)",
"qv.negotiatedAmount": "Quantitat negotiada",
"qv.payInvoiceOnline": "Paga la factura en línia",
"qv.quote": "Pressupost",
"qv.quoteValidDays": "Pressupost vàlid durant {n} dies.",
"qv.sendMyOffer": "Envia la meva oferta",
"qv.signContract": "Signa el meu contracte",
"qv.signNow": "Signa ara",
"qv.signatureAlt": "Signatura",
"qv.signedByOn": "✔ Signat per {name} el {date}",
"qv.stContractSigned": "Contracte signat. Gràcies!",
"qv.stCounterAccepted": "La teva oferta ha estat acceptada! Signa el teu contracte a continuació.",
"qv.stCounterRefused": "La teva oferta no ha pogut ser acceptada.",
"qv.stCountered": "La teva oferta ha estat presentada. Esperant la resposta de findloop.",
"qv.stDeclined": "Has rebutjat aquest pressupost.",
"qv.stSigned": "Pressupost acceptat i signat. Gràcies!",
"qv.totalHt": "Total excl. IVA",
"qv.totalTtc": "Total incl. IVA",
"qv.unitHt": "Unitat excl. IVA",
"qv.vat": "IVA",
"qv.yourProposedAmount": "La teva quantitat proposada ({cur})",
"rate.chooseNote": "Si us plau, tria una valoració.",
"rate.commentPh": "Un comentari (opcional)…",
"rate.home": "Torna a l'inici",
"rate.submit": "Enviar la meva ressenya",
"rate.submitting": "Enviant…",
"rate.subtitle": "Com ha anat la recuperació del teu article?",
"rate.successText": "El teu comentari ajuda altres usuaris.",
"rate.successTitle": "Gràcies per la teva opinió!",
"rate.title": "Valora la teva experiència",
"reg.add": "Registra un article",
"reg.allBrands": "Totes les marques",
"reg.allColors": "Tots els colors",
"reg.allLocations": "Totes les ubicacions",
"reg.detailDesc": "Detalls i accions per aquest article trobat.",
"reg.dispAuction": "Subhasta",
"reg.dispAuthorities": "Entregat a les autoritats",
"reg.dispDestroyed": "Destruit",
"reg.dispDonate": "Donació a la caritat",
"reg.dispositionHint": "Registra l'article que deixa el magatzem. Comptat en estadístiques per categoria.",
"reg.emptyCta": "Registra un article",
"reg.emptyDesc": "Comença registrant el teu primer article trobat.",
"reg.emptyTitle": "No s'han trobat articles",
"reg.establishmentFallback": "l'establiment",
"reg.lblAuctioned": "llistat a subhasta",
"reg.lblAuctionedShort": "subhastat",
"reg.lblAuthorities": "entregat a les autoritats",
"reg.lblDestroyed": "destruit",
"reg.lblDonated": "donat a una organització benèfica",
"reg.legalCount": "{n} article(s): període de retenció legal assolit",
"reg.legalHint": "Podeu llistar-los a subhasta, donar-los a una organització benèfica o informar-ne a les autoritats.",
"reg.legalLimitCountry": "Termini: {date} · país aplicat: {country}",
"reg.legalOver": "Termini passat: {date} · {country}",
"reg.legalReached": "Període legal assolit",
"reg.legalReachedFull": "Període de retenció legal assolit",
"reg.limitShort": "termini",
"reg.location": "Ubicació",
"reg.markRestituted": "Marcar com a retornat",
"reg.markedAs": "Article marcat com a {label}",
"reg.moveHistory": "Història de moviments",
"reg.overBy": "més de {n}d",
"reg.physicalLocation": "Ubicació física",
"reg.popupBlocked": "Permet els pop-ups per imprimir les etiquetes.",
"reg.popupBlockedOne": "Permet els pop-ups per imprimir l'etiqueta.",
"reg.printLabel": "Imprimir l'etiqueta",
"reg.printN": "Imprimir {n} etiqueta(s)",
"reg.qrCodeItem": "Codi QR de l'article",
"reg.qrLabelTitle": "Etiqueta QR",
"reg.qrLabelsTitle": "Etiquetes QR",
"reg.qrNotFound": "No s'ha trobat cap article per aquest codi QR.",
"reg.qrScanHint": "Escaneja-ho per obrir aquest registre directament i trobar la ubicació.",
"reg.recoveryFee": "Taxa de recuperació (€)",
"reg.searchPh": "Cerca per descripció…",
"reg.selectQr": "Selecciona per imprimir etiquetes QR",
"reg.selectedN": "{n} seleccionat",
"reg.shipPricePh": "Preu d'enviament (€)",
"reg.shippingPossible": "Enviament disponible",
"reg.storagePh": "per exemple, prestatgeria A3, caset 12",
"reg.tAuction": "Subhasta a Findloop",
"reg.tAuthorities": "Informar de la entrega a les autoritats",
"reg.tDonate": "Donar a una organització benèfica",
"reg.toastFee": "Taxa actualitzada",
"reg.toastLocation": "Ubicació desada",
"reg.toastRestituted": "Article marcat com a retornat",
"reg.toastShipping": "Opció d'enviament actualitzada",
"reg.toastTransferred": "Article transferit a “{name}”",
"reg.unclaimedDisposition": "Article sense reclamar — disposició final",
"res.codeValidated": "Codi validat",
"res.empty": "Encara no s'ha registrat cap restitució.",
"res.error": "Error {status}",
"res.proofPdf": "Prova PDF",
"res.signed": "Signat",
"res.stRestituted": "Entregat en persona",
"res.stShipped": "Retornat per enviament",
"res.subtitle": "Totes les entregues completes, amb la seva prova signada descarregable.",
"res.title": "Història de restitucions",
"rev.b2b": "Socis B2B",
"rev.b2c": "Clients",
"rev.based": "basat en {n} ressenyes",
"rev.eyebrow": "Testimonis",
"rev.restitutedBy": "Retornat per {org}",
"rev.storiesEyebrow": "Finals feliços",
"rev.storiesSubtitle": "Històries reals de clients que han recuperat les seves pertinences amb findloop.",
"rev.storiesTitle": "Han trobat les seves pertinences!",
"rev.subtitle": "Els socis i clients comparteixen la seva experiència.",
"rev.title": "Ells confien en Findloop",
"rev.verified": "Verificat",
"rp.already": "Ja has reportat aquesta llista.",
"rp.comment": "Detalls (opcional)",
"rp.duplicate": "Duplicat",
"rp.fraud": "Estafa / frau",
"rp.inappropriate": "Contingut inapropiat",
"rp.offensive": "Contingut ofensiu",
"rp.other": "Altres",
"rp.reason": "Raó",
"rp.report": "Informe",
"rp.send": "Enviar informe",
"rp.sent": "Informe enviat. Gràcies per la teva contribució.",
"rp.spam": "Spam / publicitat",
"rp.title": "Informe aquesta llista",
"rp.wrongCategory": "Categoria incorrecta",
"rt.annualGoal": "Objectiu anual",
"rt.championCity": "Ciutat campiona",
"rt.cityRate": "{rate}% taxa de retorn",
"rt.goalProgress": "{rate}% assolit d'un objectiu de {target}%",
"rt.reached": "Assolit 🎉",
"rt.restitutionRate": "Taxa de retorn",
"rt.shareRecap": "Comparteix el meu resum",
"rt.thanks": "Gràcies Findloop {year} 💛",
"rt.yourRecap": "El teu resum de {year}",
"rw.active": "Actiu",
"rw.add": "Afegir",
"rw.camUnavailable": "Càmera no disponible. Introduïu el codi manualment a continuació.",
"rw.codeValidated": "Codi validat",
"rw.codesTitle": "Codis rescatats pels finders",
"rw.confirmDelete": "Esborrar “{title}”?",
"rw.deleted": "Esborrat",
"rw.edit": "Editar",
"rw.editReward": "Editar la recompensa",
"rw.empty": "Encara no hi ha recompensa.",
"rw.expired": "Caducat",
"rw.expiresOn": "Caduca el {date}",
"rw.fActive": "Actiu (visible per als finders)",
"rw.fCost": "Cost (punts)",
"rw.fDesc": "Descripció",
"rw.fStock": "Estoc (buida = il·limitada)",
"rw.fTitle": "Títol",
"rw.fValidity": "Validesa del val (dies després del rescat)",
"rw.inactive": "Inactiu",
"rw.newReward": "Nova recompensa",
"rw.noExchange": "Encara no hi ha canvis.",
"rw.pageSubtitle": "Escaneja els vals presentats pels finders per validar les seves recompenses.",
"rw.redeemedN": "Rescatat: {n}×",
"rw.saved": "Recompensa desada",
"rw.scanVoucher": "Escaneja un val",
"rw.staffScanOnly": "Escaneja només",
"rw.statActive": "A presentar",
"rw.statExpired": "Caducat",
"rw.statRedeemed": "Vals rescatats",
"rw.statUsed": "Validat",
"rw.stock": "Estoc",
"rw.subtitle": "Ofereix avantatges no monetaris (vals, actualitzacions…) que els finders rescaten per als seus punts Finder Score.",
"rw.title": "Recompenses per a finders",
"rw.used": "Usat",
"rw.validate": "Validar",
"rw.validateCode": "Valida el codi",
"rw.validity": "Validesa: {n} d",
"shell.f1d": "Enllaça automàticament articles perduts i trobats.",
"shell.f1t": "Coincidència d'IA intel·ligent",
"shell.f2d": "Realitza un seguiment de la taxa de devolució i dels ingressos en temps real.",
"shell.f2t": "Tauler de control i ingressos",
"shell.f3d": "Els teus clients informen en 30 segons.",
"shell.f3t": "Codi QR de soci",
"shell.title": "Converteix articles perduts en clients satisfets.",
"ship.addr1": "Adreça",
"ship.addr2": "Línia d'adreça 2 (opcional)",
"ship.badge": "Enviament",
"ship.city": "Ciutat",
"ship.country": "País",
"ship.needPaid": "Primer paga la tarifa de recuperació per sol·licitar l'enviament.",
"ship.notShippable": "Aquest article no està disponible per a l'enviament.",
"ship.notfound": "Informe no trobat.",
"ship.postal": "Codi postal",
"ship.price": "Tarifa d'enviament",
"ship.submit": "Sol·licita l'enviament",
"ship.submitting": "Enviant…",
"ship.subtitle": "Introdueix la teva adreça de lliurament.",
"ship.successText": "El soci prepararà el teu paquet. Seràs notificat un cop enviat.",
"ship.successTitle": "Sol·licitud d'enviament enviada!",
"ship.title": "Fes que el teu article sigui enviat",
"ship.weight": "Pes estimat (kg)",
"shp.carrier": "Transportista",
"shp.download": "Descarregar PDF",
"shp.generating": "Generant…",
"shp.label": "Generar etiqueta",
"shp.none": "No s'ha sol·licitat cap enviament.",
"shp.setTracking": "Desar seguiment",
"shp.status": "Estat",
"shp.to": "Destinatari",
"shp.tracking": "Núm. de seguiment",
"shp.trackingSaved": "Seguiment desat",
"side.account": "El meu compte",
"side.declarations": "Informes",
"side.deposit": "Registrar un article",
"side.establishments": "Establiments",
"side.invoices": "Factures",
"side.logout": "Tancar sessió",
"side.matchHistory": "Historial d'IA",
"side.partner": "Soci",
"side.refresh": "Actualitzar",
"side.registry": "Registre",
"side.restitutions": "Devolucions",
"side.reviews": "Respostes",
"side.rewards": "Recompenses i Vouchers",
"side.settings": "Configuracions",
"side.shipments": "Enviaments",
"side.stats": "Estadístiques",
"side.storage": "Emmagatzematge i QR",
"side.team": "Equip",
"side.viewSite": "Veure el lloc públic",
"st.auctioned": "Venut en subhasta",
"st.claimed": "Reclamant",
"st.closed": "Tancat",
"st.delivered": "Lliurat",
"st.destroyed": "Destruït",
"st.donated": "Donat (caritat)",
"st.handed_to_authorities": "Entregat a les autoritats",
"st.in_storage": "En emmagatzematge",
"st.matched": "S'ha trobat una coincidència",
"st.open": "Obert",
"st.paid": "Pagat",
"st.pending": "Pendent",
"st.resolved": "Resolut",
"st.restituted": "Retornat",
"st.second_chance": "Segona oportunitat",
"st.shipped": "Enviat",
"st.shipping_requested": "Enviament sol·licitat",
"st.submitted": "Enviat",
"st.verified": "Verificat",
"stat.items": "Elements registrats",
"stat.partners": "Socis",
"stat.restituted": "Elements retornats",
"status.auctioned": "En subhasta",
"status.destroyed": "Destruit",
"status.donated": "Donat (obra benèfica)",
"status.handed_to_authorities": "Entregat a les autoritats",
"status.in_storage": "En emmagatzematge",
"status.matched": "Coincidència",
"status.open": "Obert",
"status.paid": "Pagat",
"status.pending": "Pendent",
"status.restituted": "Retornat",
"status.shipped": "Enviat",
"status.shipping_requested": "Enviament sol·licitat",
"status.submitted": "Enviat",
"step1.tag": "Establiment",
"step1.text": "En segons, l'establiment registra l'objecte trobat amb una foto, categoria i descripció. Tot està centralitzat en un registre clar i segur.",
"step1.title": "El soci registra l'element",
"step2.tag": "Client",
"step2.text": "A través del codi QR del soci, el teu client descriu l'objecte perdut en 30 segons. No cal instal·lar cap app — tot passa al navegador.",
"step2.title": "El client comunica la pèrdua",
"step3.tag": "Intel·ligència",
"step3.text": "El nostre motor de coincidències intel·ligent compara descripcions i suggereix les coincidències més probables, llestes per confirmar.",
"step3.title": "La IA vincula la pèrdua i l'objecte trobat",
"step4.tag": "Recuperació",
"step4.text": "Després d'un pagament segur de la tarifa de recuperació, el client recull l'element al lloc — o el rep per enviament rastrejat.",
"step4.title": "El client rep el seu element de nou",
"stg.allLabels": "Totes les etiquetes QR",
"stg.camHint": "Utilitzeu l'entrada manual a continuació.",
"stg.camStarting": "Iniciant la càmera…",
"stg.camUnavailable": "Càmera no disponible.",
"stg.clear": "Esborrar",
"stg.clearAll": "Esborrar tot",
"stg.codeUnreadable": "Codi il·legible.",
"stg.emptyDesc": "Els elements emmagatzemats apareixeran aquí, agrupats per ubicació.",
"stg.emptyTitle": "No hi ha cap element emmagatzemat",
"stg.exportAudit": "Exportar auditoria CSV",
"stg.exportDone": "Exportació CSV descarregada",
"stg.exportImpossible": "Exportació no disponible en aquest moment.",
"stg.itemFound": "Element trobat ✅",
"stg.kLocations": "Ubicacions utilitzades",
"stg.kObjects": "Elements emmagatzemats",
"stg.kToClear": "Ubicacions a esborrar",
"stg.locFreed": "Ubicació esborrada",
"stg.locsFreed": "{n} ubicació(ons) esborrades",
"stg.manualLabel": "O introduceix el codi / ID de l'element",
"stg.manualPh": "Enganxa l'ID o URL del QR",
"stg.noItemMatch": "No hi ha cap element que coincideixi amb aquest QR / codi.",
"stg.noLocation": "Sense ubicació",
"stg.objectsAxis": "Articles",
"stg.objectsN": "{n} article(s)",
"stg.occAvg": "avg {n} articles/ubicació",
"stg.occHint": "Les ubicacions en àmbar superen la mitjana (potencialment sobrecarregades).",
"stg.occupancy": "Ocupació de la ubicació",
"stg.openPage": "Obrir la pàgina",
"stg.posterPdf": "Pòster PDF (A4)",
"stg.printAll": "Imprimir tot",
"stg.printGroupTitle": "Imprimir etiquetes per aquesta lleixa",
"stg.qrAlt": "QR d'autoservei",
"stg.qrDownload": "Descarregar el QR",
"stg.qrHint": "Mostra aquest QR al taulell: els teus clients el scanegen per comprovar si el seu article està disponible.",
"stg.qrTitle": "QR d'autoservei per a clients",
"stg.scanDesc": "Escaneja l'etiqueta d'un article per obrir el seu registre de manera instantània.",
"stg.scanQr": "Escaneja un QR",
"stg.scanTitle": "Escaneja un codi QR",
"stg.search": "Cercar",
"stg.shelf": "Lleixa {loc}",
"stg.shelfPlan": "Pla de la lleixa",
"stg.staleHint": "Neteja aquestes ubicacions per mantenir el teu inventari físic actualitzat.",
"stg.staleTitle": "{n} article(s) han sortit de l'emmagatzematge però encara mantenen una ubicació",
"stg.subtitle": "Pla de la lleixa, escàner de QR i seguiment d'inventari físic.",
"stg.title": "Emmagatzematge & QR",
"stt.acceptRate": "Taxa d'acceptació",
"stt.accepted": "Acceptat",
"stt.activity30": "Activitat (últims 30 dies)",
"stt.ai6mo": "Últims 6 mesos · acceptat = coincidents automàtics + confirmats.",
"stt.aiEmpty": "Encara no hi ha coincidències d'IA durant aquest període.",
"stt.aiTitle": "Coincidències d'IA — acceptades vs rebutjades",
"stt.auctionShort": "Subhasta",
"stt.auctionedSold": "Subhastat (venut)",
"stt.authShort": "Autoritats",
"stt.authorities": "Entregat a les autoritats",
"stt.avgRating": "Valoració mitjana",
"stt.awaitingRestitution": "articles a l'espera de retorn",
"stt.boostClicks": "Cliquets al teu directori aquesta setmana gràcies al boost",
"stt.boostInactive": "Boost inactiu — habilita'l per guanyar visibilitat",
"stt.certifiedPremium": "Premium certificat",
"stt.declarations": "Declaracions",
"stt.destroyed": "Destruït",
"stt.dispoEmpty": "Encara no ha sortit cap article no reclamats de l'emmagatzematge.",
"stt.donatedAssoc": "Donat (entitat benèfica)",
"stt.donatedShort": "Donat",
"stt.gateCta": "Descobreix els plans",
"stt.gateDesc": "Melora a Starter per desbloquejar les teves estadístiques bàsiques, o a Business per a estadístiques avançades i anàlisis per establiment.",
"stt.gateTitle": "Estadístiques reservades per a plans de pagament",
"stt.inStorage": "A l'emmagatzematge",
"stt.kItems": "Articles registrats",
"stt.kRate": "Taxa de retorn",
"stt.kRestituted": "Articles retornats",
"stt.kRevenue": "Ingressos (mes)",
"stt.noDeclYet": "Sense declaracions encara.",
"stt.recapDownloaded": "Resum descarregat — llest per compartir!",
"stt.recapError": "No s'ha pogut generar el resum",
"stt.recapText": "El nostre resum Findloop {year}: articles retornats i satisfacció del client 🎉",
"stt.recapTitle": "resum Findloop {year}",
"stt.rejected": "Rebutjat",
"stt.restitutions": "Retorns",
"stt.shareRecap": "Comparteix el meu resum de {year}",
"stt.topCategories": "Categories més declarades",
"stt.unclaimedDesc": "Volum d'articles destruïts, donats a organitzacions benèfiques i venuts en subhasta, per categoria.",
"stt.unclaimedTitle": "Articles no reclamats — deixant l'emmagatzematge",
"stt.vsLastWeek": "vs la setmana passada",
"sub.cancel": "Cancel·la la meva subscripció",
"sub.cancelAbort": "Cancel·la",
"sub.cancelConfirm1": "Estàs segur que vols cancel·lar? El teu accés es mantindrà actiu fins al",
"sub.cancelConfirm2": "No es farà cap reemborsament.",
"sub.cancelConfirmBtn": "Confirma la cancel·lació",
"sub.cancelTitle": "Cancel·la la teva subscripció",
"sub.cancelledToast": "Cancel·lació enregistrada.",
"sub.cguAnd": "i el",
"sub.cguDesc": "Si us plau, confirma la teva acceptació abans del pagament.",
"sub.cguLink": "Termes d'Ús",
"sub.cguPay": "Continuar amb el pagament",
"sub.cguPre": "He llegit i accepto els",
"sub.cguRequired": "Has d'acceptar els Termes d'Ús i la Política de Privacitat per continuar.",
"sub.cguSuffix": "de findloop.",
"sub.cguTitle": "Finalitza la teva subscripció",
"sub.expiresOn": "La teva subscripció caduca el",
"sub.noProrata": "Sense reemborsament prorratejat.",
"sub.privacyLink": "Política de Privacitat",
"sub.renewsOn": "La teva subscripció es renova el",
"sub.resume": "Torna a subscriure't",
"sub.resumedToast": "Re-subscripció confirmada.",
"tier.free": "Freemium",
"tier.large": "Enterprise",
"tier.medium": "Negoci",
"tier.small": "Iniciant",
"tm.add": "Afegir",
"tm.adminOpt": "Admin (vista completa)",
"tm.chooseEst": "Tria un establiment",
"tm.chooseEstPh": "Tria un establiment",
"tm.copyFail": "Còpia fallida",
"tm.copyLink": "Copia el enllaç",
"tm.copyOk": "Enllaç d'invitació copiat",
"tm.emailHint": "S'enviarà un correu electrònic d'invitació per crear la contrasenya.",
"tm.expiresOn": "caduca el {date}",
"tm.forEmail": " per {email}",
"tm.forbidden": "La gestió d'equip està reservada per al propietari del compte.",
"tm.inviteCreated": "Invitació creada",
"tm.inviteDesc": "Un correu electrònic d'invitació permet al company crear la seva contrasenya.",
"tm.invitePending": "Invitació pendent",
"tm.inviteResent": "Invitació reenviada",
"tm.inviteSent": "Invitació enviada per correu electrònic",
"tm.inviteTitle": "Convida un membre",
"tm.invitedOn": "Convidat el {date}",
"tm.linkExpired": "Enllaç caducat",
"tm.memberRemoved": "Membre eliminat",
"tm.name": "Nom",
"tm.noMembers": "Encara no hi ha cap company.",
"tm.resendTitle": "Reenviar la invitació",
"tm.role": "Rol",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Propietari",
"tm.roleStaff": "Personal",
"tm.roleUpdated": "Rol actualitzat",
"tm.sendInvite": "Envia la invitació",
"tm.sending": "Enviant…",
"tm.staffOpt": "Personal (veu només el seu establiment)",
"trk.at": "A",
"trk.badge": "Seguiment",
"trk.carrier": "Transportista",
"trk.codeValidated": "Codi validat pel soci",
"trk.dlProof": "Descarrega la meva prova de lliurament (PDF)",
"trk.emailLabel": "Correu electrònic (opcional — per veure els teus detalls)",
"trk.enterEmailCode": "Introdueix el teu correu electrònic a dalt per mostrar el teu codi de reclamació.",
"trk.idLabel": "Número de informe",
"trk.lostEmail": "Ja no tinc accés al meu correu electrònic",
"trk.phonePh": "El teu número de telèfon",
"trk.photoBefore": "Foto de l'article abans d'enviar",
"trk.recoverBtn": "Recupera el meu article",
"trk.recoverHint": "Obteniu el vostre codi de reclamació per SMS al vostre número registrat.",
"trk.searching": "Cercant…",
"trk.secureRest": "Lliurament segur",
"trk.send": "Enviar",
"trk.shipPending": "Enviament en preparació — el número de seguiment apareixerà aquí un cop enviat.",
"trk.shipTitle": "Seguiment d'enviament",
"trk.showQr": "Mostra aquest codi QR al soci per validar el lliurament",
"trk.sigSaved": "Signatura desada",
"trk.signFirst": "Si us plau, signa abans de confirmar.",
"trk.signProof": "Signa la teva prova de lliurament",
"trk.signSubmit": "Confirma la meva signatura i genera el PDF",
"trk.submit": "Fer seguiment",
"trk.subtitle": "Introdueix el teu número d'informe per fer un seguiment del progrés.",
"trk.title": "Fes seguiment del meu informe",
"trk.trackShipment": "Fer seguiment del paquet",
"trk.trackingNo": "Número de seguiment",
"trk.yourCode": "El teu codi de reclamació (per donar al soci)",
"a.firstName": "Nom",
"ac.emailCrossMatch": "Coincidències B2C",
"ac.emailCrossMatchDesc": "Un correu electrònic quan un anunci públic de llistat perdut coincideixi amb un article dipositat a les teves instal·lacions",
"ac.emailCrossReject": "Rebuigs de coincidències públiques",
"ac.emailCrossRejectDesc": "Rep un correu electrònic quan un client indica que una coincidència pública suggerida no és el seu article.",
"ac.emailLoginNotif": "Notificació d'inici de sessió",
"ac.emailLoginNotifDesc": "Rep un correu electrònic cada vegada que algú iniciï sessió al teu compte.",
"ad.closeNoCancel": "No, suprimeix l'anunci",
"ad.closeQuestion": "L'article et va ser retornat?",
"ad.closeQuestionDesc": "Fes-nos saber si has recuperat el teu article, o si simplement vols eliminar aquest anunci.",
"ad.closeYesRestituted": "Sí, l'article va ser retornat",
"ad.closedRestituted": "Article retornat — anunci tancat 🎉",
"an.lostLoginDesc": "Es necessita un compte per informar d'un article perdut i fer seguiment del seu retorn.",
"an.lostLoginRequired": "Inicia sessió per informar d'un article perdut",
"an.qfAll": "Tots",
"an.qfBoosted": "Impulsats",
"an.qfPhoto": "Amb foto",
"an.qfRecent": "Aquesta setmana",
"an.qfResolved": "Resolts",
"an.restitutionInProgress": "Article en procés de retorn",
"dec.descPhLong": "Descriu l'article: marca, color, marques distintives… (Quants més detalls donis, més altes seran les teves possibilitats de recuperar l'article)",
"dec.loadError": "No es pot carregar el soci ara mateix. Comprova la teva connexió i torna-ho a intentar.",
"dec.retry": "Reintentar",
"dec.shippingMode": "Enviament",
"dep.photo2": "2a foto de l'article",
"dep.photo2Hint": "Opcional — un altre angle millora l'accuraciat visual de la coincidència.",
"dl.accountSuspended": "Compte suspès per una factura no pagada. Salda-la per restaurar el teu accés.",
"dl.regularize": "Salda ara →",
"dl.suspensionCountdown": "Factura {num} no pagada — el teu compte es suspèn en {days} dia(s). Salda-ho per evitar-ho.",
"ft.cancelConfirm": "Cancel·lar el teu informe? L'owner de l'article serà informat.",
"ft.cancelDone": "Informe cancel·lat.",
"ft.cancelLocked": "La cancel·lació ja no és possible després que l'owner hagi pagat.",
"ft.cancelReport": "Cancel·lar el meu informe",
"ft.claimCodeHelp": "Dona aquest codi al trobat en la devolució per confirmar que has rebut el teu article.",
"ft.claimCodeTitle": "El teu codi de restitució",
"ft.claimDone": "Article retornat. Gràcies per utilitzar Findloop!",
"ft.claimUnlockHint": "Desbloqueja els detalls de contacte del trobat",
"ft.claimUnlockHintSub": "Vés a \"Articles que estic reclamant\" al teu compte per pagar la taxa i obtenir els detalls de contacte.",
"ft.finderCodeShownHelp": "L'owner ha pagat i t'ha seleccionat. Copia aquest codi a continuació per confirmar el retorn — no cal que comprovis el teu correu electrònic.",
"ft.finderCodeShownTitle": "Codi de validació de l'owner",
"ft.finderContactsTitle": "Detalls de contacte del Finder",
"ft.foundCodeHelp": "Mostra aquest codi al propietari durant la devolució per confirmar que l'objecte ha estat retornat.",
"ft.inProgressOther": "Objecte en retorn",
"ft.inProgressOtherHelp": "El propietari ha seleccionat un altre finder per aquest objecte. No es necessita cap acció per la teva banda.",
"ft.restitutionCodeHelp": "Aquest codi confirma la devolució de l'objecte. Ja està prefabricat a sota; valida'l i després tanca el cas.",
"ft.restitutionCodeTitle": "El teu codi de devolució",
"hc.14Digits": "14 dígits",
"hc.15DaysBeforeAnItem": "15 dies abans del termini legal de l'objecte.",
"hc.7DaysBeforeAnItem": "7 dies abans del termini legal de l'objecte.",
"hc.8CharactersMinimum": "Mínim 8 caràcters.",
"hc.aClaimToValidate": "Una reclamació per validar",
"hc.aFindoAssistanceSessionIs": "Una sessió d'assistència de Findloop està actualment activa al teu compte.",
"hc.aNewMatchHasBeen": "S'ha trobat un nou match",
"hc.aUser": "Un usuari",
"hc.aUserClaimsToBe": "Un usuari afirma ser el propietari. Comprova les seves respostes abans d'autoritzar la devolució.",
"hc.aboutFindo": "Sobre Findloop",
"hc.accountActivatedPleaseLogIn": "Compte activat, si us plau, inicia sessió.",
"hc.accountActivation": "Activació del compte",
"hc.accountCreated": "Compte creat!",
"hc.accountDeactivatedAReactivationEmail": "Compte desactivat. S'ha enviat un correu electrònic de reactivació (vàlid durant 30 dies) a tu.",
"hc.accountReactivation": "Reactivació del compte",
"hc.activateMyAccount": "Activa el meu compte",
"hc.activateMyAdminAccount": "Activa el meu compte d'administrador",
"hc.activating": "Activant…",
"hc.activeMatchCancelReason": "Match actiu. Motiu de cancel·lació del client: \"{reason}\". L'objecte encara espera una reclamació.",
"hc.activeMatchWithAPublic": "Match actiu amb una llista pública (client). Esperant la reclamació del propietari.",
"hc.addAPhoto": "Afegir una foto",
"hc.addAndConfigureYourEstablishments": "Afegiu i configureu els vostres establiments a \"Establiments\": detalls de contacte, categoria i emmagatzematge físic dels objectes.",
"hc.addOnGoogle": "Afegir a Google",
"hc.address": "Adreça",
"hc.addressSaved": "Adreça desada",
"hc.addressStreet": "Adreça — Carrer",
"hc.adjustThePhoto": "Ajustar la foto",
"hc.adminFullView": "Administrador (vista completa)",
"hc.administratorOnly": "Només administrador",
"hc.africa": "Àfrica",
"hc.aiVisualComparison": "Comparació visual AI",
"hc.all": "Tots",
"hc.amount": "Quantitat",
"hc.anOrganization": "Una organització",
"hc.analyzing": "Analitzant…",
"hc.andRecoveryIs": "i la recuperació és",
"hc.andTheDeclarationWillBe": "i la declaració es tancarà (passada a la història). Aquesta acció és definitiva.",
"hc.annual20": "Anual -20%",
"hc.annualBilling20": "Facturació anual (−20%)",
"hc.annualTarget": "Objectiu anual",
"hc.anyCommentsOptional": "Tens comentaris? (opcional)",
"hc.approveTheClaim": "Aprovar la sol·licitud",
"hc.archiveCancelledConfirm": "Arxivar {n} registre(s) \"Cancel·lat pel client\"? Seran eliminats del registre.",
"hc.asSoonAs": "Tan aviat com",
"hc.askTheOwnerToDisplay": "Demana al propietari que mostri el codi QR (pàgina de seguiment).",
"hc.askThemAtTheCounter": "Pregunta'ls al taulell per confirmar la identitat — mai visible públicament.",
"hc.assistance": "Suport",
"hc.assistanceSessionRevoked": "Sessió d'assistència revocada.",
"hc.atLeast6Characters": "Almenys 6 caràcters",
"hc.automaticallyPreSelected": "automàticament preseleccionat",
"hc.automaticallyWhenShipping": "automàticament quan s'enviï.",
"hc.awaitingClaim": "Esperant la sol·licitud",
"hc.awaitingPayment": "Esperant el pagament",
"hc.b2cCustomer": "Client B2C",
"hc.back": "Enrere",
"hc.backToHome": "Tornar a l'inici",
"hc.backToMyAccount": "Tornar al meu compte",
"hc.backToPayment": "Tornar al pagament",
"hc.beforeAfterComparisonSlider": "Control desplaçador de comparació abans/després",
"hc.billingInformation": "Informació de facturació",
"hc.billingInformationSaved": "Informació de facturació desada ✓",
"hc.brand": "Marca",
"hc.bronze": "Bronze",
"hc.calculatingTheShippingRate": "Calculant la tarifa d'enviament…",
"hc.cameraUnavailableEnterTheCode": "Càmera no disponible. Introdueix el codi manualment.",
"hc.cancel": "Cancel·lar",
"hc.cancelMyDeclaration": "Cancel·lar la meva declaració",
"hc.cancelSavedFmt": "Cancel·lació desada: \"{reason}\". Encara pots reclamar.",
"hc.cancelTheDeposit": "Cancel·lar el dipòsit",
"hc.cancelThisMatch": "Cancel·lar aquest partit",
"hc.cancellationReason": "Motiu de cancel·lació",
"hc.cancelled": "Cancel·lat",
"hc.cancelledByTheCustomer": "Cancel·lat pel client",
"hc.cannotOpenPayment": "No es pot obrir el pagament. Si us plau, torna a provar.",
"hc.careers": "Carreres",
"hc.carrier": "Transportista",
"hc.carrierAvailabilityCannotBeChecked": "No es pot comprovar la disponibilitat del transportista fins que no estigui configurat el teu remitent de Sendcloud.",
"hc.carrierConfirmedCharged": "Transportista confirmat — {price} € carregats al client",
"hc.carrierOther": "Transportista (altres)",
"hc.carrierSelection": "Selecció de transportista",
"hc.caseClosedThankYou": "Cas tancat. Gràcies!",
"hc.category": "Categoria",
"hc.changeMethod": "Canviar mètode",
"hc.characteristic": "Característica",
"hc.chargedToCustomer": "carregat al client.",
"hc.checkOrEditYourDetails": "Comprova o edita els teus detalls abans del pagament segur.",
"hc.checkStatisticsToTrackDeposited": "Comprova \"Estadístiques\" per fer un seguiment dels articles dipositats, la taxa de devolució i el rendiment de cada establiment.",
"hc.checkTheDetailsBeforeContacting": "Comprova els detalls abans de contactar amb el localitzador.",
"hc.checkTheDetailsBelowBefore": "Comprova els detalls següents abans d'iniciar la teva sol·licitud de devolució.",
"hc.checkTheNewItem": "Comprova el nou article",
"hc.checkThePhotosAndCharacteristics": "Comprova les fotos i característiques que es mostren a continuació abans de continuar amb la recuperació.",
"hc.chooseACountry": "Tria un país",
"hc.chooseANewPassword": "Tria una nova contrasenya",
"hc.chooseAReason": "Tria un motiu",
"hc.chooseTheLegalRetentionAlerts": "Tria les alertes de retenció legal rebudes per correu electrònic per",
"hc.chooseYourPasswordToAccess": "Tria la teva contrasenya per accedir a la consola d'administració.",
"hc.city": "Ciutat",
"hc.claimApproved": "Reclamació aprovada",
"hc.claimApproved2": "Reclamació aprovada.",
"hc.claimCodeExpired": "Codi de reclamació caducat",
"hc.claimCodeVerified": "Codi de reclamació verificat",
"hc.claimNotFound": "Reclamació no trobada",
"hc.claimNotValidated": "Reclamació no validada",
"hc.claimRejected": "Reclamació rebutjada",
"hc.claimRejected2": "Reclamació rebutjada.",
"hc.claimValidated": "Reclamació validada",
"hc.claimValidatedByThePartner": "Reclamació validada pel partner",
"hc.claimant": "Reclamant",
"hc.claimsToBeTheOwner": "declara ser el propietari d'aquest article i ha respost les preguntes de verificació. Només aprova si les respostes coincideixen.",
"hc.claimsToValidate": "Reclamacions per validar",
"hc.clear": "Netejar",
"hc.clickToZoom": "Fes clic per fer zoom",
"hc.close": "Tancar",
"hc.close2": "Tancar",
"hc.closeTheDeclaration": "Tancar la declaració",
"hc.closeTheDeclaration2": "Tancar la declaració?",
"hc.codeAlreadyVerified": "Codi ja verificat",
"hc.codeCopied": "Codi copiat",
"hc.collapse": "Col·lapsar",
"hc.color": "Color",
"hc.company": "Companyia",
"hc.companyName": "Nom de la companyia",
"hc.comparePhotos": "Comparar fotos",
"hc.compareThemWithTheOwner": "Compara'ls amb les respostes del propietari — mai visibles públicament.",
"hc.condition": "Condició",
"hc.confirmAndPay": "Confirmar i pagar",
"hc.confirmCancellation": "Confirmar la cancel·lació",
"hc.confirmCrop": "Confirmar retallat",
"hc.confirmDeletion": "Confirmar eliminació",
"hc.confirmPassword": "Confirmar contrasenya",
"hc.confirmThatThisIsYour": "Confirmeu que aquest és el vostre article. Es sol·licitarà una verificació d'identitat al trobat abans de qualsevol contacte.",
"hc.confirmTheCarrier": "Confirmar el transportista",
"hc.confirmThePassword": "Confirmar la contrasenya",
"hc.confirmYourShippingAddressTo": "Confirmeu la vostra adreça d'enviament per continuar amb el pagament.",
"hc.confirmYourSubscription": "Confirmar la vostra subscripció",
"hc.confirmed": "Confirmat ✓",
"hc.contactFindoToGetYour": "Contacta amb Findloop per obtenir el teu ID d'expedidor.",
"hc.contactUs": "Contacta'ns",
"hc.continueTheReturn": "Continuar la devolució",
"hc.continueToPayment": "Continuar amb el pagament",
"hc.copy": "Copiar",
"hc.correctMyDetails": "corregir els meus detalls",
"hc.correctThisEntry": "Corregir aquesta entrada?",
"hc.country": "País",
"hc.countryAddress": "País (adreça)",
"hc.countryIsoCodeEG": "País (codi ISO, p. ex. FR)",
"hc.cover": "coberta",
"hc.createTheShipment": "Crear l'enviament",
"hc.cropThePhoto": "Retallar la foto",
"hc.customer": "Client",
"hc.customerClaimCodeToCheck": "Codi de reclamació del client — per verificar a la recollida:",
"hc.customerReasonFmt": "Motiu del client: \"{reason}\".",
"hc.customerReminderDelay": "Retard d'avís del client",
"hc.customerWhosePublicListingMatches": "Client la llista pública del qual coincideix amb aquest article — visible només per a tu.",
"hc.d15": "D-15",
"hc.dangerZone": "Zona de perill",
"hc.date": "Data",
"hc.dateNewest": "Data (més nova)",
"hc.dateOldest": "Data (més antiga)",
"hc.daysToYearEnd": "{n} dies fins a l'acabament de l'any",
"hc.deadlineAlert": "Advertència de termini",
"hc.declarationClosed": "Declaració tancada ✓",
"hc.declarationNotFound": "Declaració no trobada.",
"hc.declarationNotFound2": "Declaració no trobada",
"hc.declarationTracking": "Seguiment de la declaració",
"hc.defaultCarrier": "Transportista per defecte",
"hc.defaultCarrierPreselected": "Transportista per defecte preseleccionat — es pot canviar per aquest enviament. Tarifa actual (Sendcloud + {m}% marge).",
"hc.defaultCarrierRemoved": "Transportista per defecte eliminat",
"hc.delayHours": "Retard (hores)",
"hc.deleteMyAccount": "Esborrar el meu compte",
"hc.deleting": "Esborrant…",
"hc.deletingDeactivatesYourAccountLogin": "Esborrar desactiva el teu compte: l'accés està bloquejat i les dades es conserven durant 30 dies. Rebràs un correu electrònic amb un enllaç de reactivació vàlid durant 30 dies.",
"hc.delivered": "Entregat",
"hc.depositAnItem": "Dipositvar un article",
"hc.depositCancelledItemPutBack": "Dipòsit cancel·lat — article tornat a estoc.",
"hc.depositCancelledItemRemovedFrom": "Dipòsit cancel·lat — article eliminat del registre.",
"hc.depositedOn": "Dipositada el",
"hc.describeTheItemBrandColor": "Descripció de l'article: marca, color, marques distintives… (Quants més detalls donis, millor seran les teves possibilitats de trobar l'article)",
"hc.dimensionsCm": "Dimensions (cm)",
"hc.disablingAnEmail": "Desactivant un correu electrònic",
"hc.doesNotHide": "no s'amaga",
"hc.download": "Descarregar",
"hc.downloadThePdf": "Descarregar el PDF",
"hc.draftRestoredPickUpYour": "Esborrany restaurat — recull la teva declaració on la vas deixar.",
"hc.dragToReposition": "Arrossega per reposicionar",
"hc.eGColisPriv": "Ex: Colis Privé",
"hc.eachItemGetsAQr": "Cada article rep una etiqueta QR. Escaneja-ho des de \"Magatzem & QR\" per localitzar un article a l'instant.",
"hc.eachSiteManagesItsOwn": "Cada lloc gestiona el seu propi banking. Vés a",
"hc.edit": "Editar",
"hc.emailNotificationPreferences": "Preferències de notificació per correu electrònic",
"hc.emailPreferencesUpdated": "Preferències de correu electrònic actualitzades",
"hc.enableOrDisableRecoveryFees": "Activa o desactiva les tarifes de recuperació per",
"hc.enlargePhoto": "Augmentar foto",
"hc.enterTheCustomerSCode": "Introdueix el codi del client",
"hc.estShipRate": "Tarifa d'enviament estimada (Sendcloud + {m}% de marge):",
"hc.establishment": "Establiment",
"hc.establishment2": "Establiment:",
"hc.establishmentInItsSendcloudAccount": "establiment a la seva compte de Sendcloud i li proporciona l'ID de l'expedidor",
"hc.establishmentSettings": "Configuració de l'establiment",
"hc.exCode": "p. ex. ABCD2345",
"hc.exId": "p. ex. 3f2a…",
"hc.exit": "Sortir",
"hc.explainWhyThisItemIs": "Expliqueu per què aquest article no és seu…",
"hc.externalPaymentLinks": "Enllaços de pagament externs",
"hc.failed": "Fallit",
"hc.feesEnabled": "Comissions activades",
"hc.field": ") camp.",
"hc.finderAcceptedCloseTheCase": "Finder acceptat — tanca el cas un cop l'article s'ha lliurat en persona.",
"hc.findoCityRanking": "Findloop — Classificació de ciutats",
"hc.findoForEstablishments": "Findloop per establiments",
"hc.findoPresentationVideo": "vídeo de presentació de Findloop",
"hc.findoRegistersTheAddressOf": "Findloop registra l'adreça del vostre",
"hc.findoReviewShare": "resum de Findloop {year}: {n} articles retornats, {rate}% de taxa de retorn 🎉",
"hc.firstVerifyTheClaimCode": "Primer verifiqueu el codi de reclamació anterior",
"hc.forEveryNewShipmentFrom": "per cada nou enviament de",
"hc.free": "gratuït",
"hc.freeRecovery0": "Recuperació gratuïta (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Recuperació gratuïta a través d'Àfrica – Oferta de llançament",
"hc.freeRecoveryFeesDisabled0": "Recuperació gratuïta: comissions desactivades (0 €)",
"hc.fromTeamInviteYourColleagues": "Des de \"Equip\", invita els teus companys per correu electrònic i assigna'ls un establiment. Cada membre només veu el seu propi àmbit.",
"hc.fullName": "Nom complet",
"hc.fullPhoto": "Foto completa",
"hc.gallery": "Galeria",
"hc.giveTheReasonForCancelling": "Dona la raó per cancel·lar. El partner serà informat.",
"hc.goToLogin": "Ves a iniciar sessió",
"hc.goToMyAccount": "Ves al meu compte",
"hc.gold": "Or",
"hc.googleLoginFailed": "Error en l'inici de sessió amb Google",
"hc.hasConfirmedYourPaymentYou": "ha confirmat el teu pagament, seràs redirigit automàticament",
"hc.helpCenter": "Centre d'ajuda",
"hc.helpUsImproveWhyAre": "Ajuda'ns a millorar: per què te'n vas? El teu compte serà desactivat i es podrà reactivar durant 30 dies.",
"hc.hidePassword": "Amaga la contrasenya",
"hc.high": "Alt",
"hc.historyOfYourMonthlySubscriptions": "Historial de les teves subscripcions mensuals i el seu estat de pagament.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Com puc configurar el meu ID de remitent numèric?",
"hc.iDonTUseIt": "No ho faig servir prou",
"hc.iFoundItElsewhere": "Ho he trobat en un altre lloc",
"hc.iNoLongerNeedMy": "Ja no necessito el meu article",
"hc.identityVerification": "Verificació d'identitat",
"hc.idleLogoutIn": "Seràs tancat la sessió en {n} s a causa de la inactivitat.",
"hc.ifProvidedTheVolumetricWeight": "Si s'ha proporcionat, es fa servir el pes volumètric.",
"hc.ifThePartnerHasNot": "Si el soci no ha confirmat la recepció del pagament extern després d'aquest retard, Findloop recorda automàticament al soci que ho validi.",
"hc.impersonationEnded": "Finalització de la impersonació.",
"hc.impersonationMode": "Mode d'impressió",
"hc.impersonationSessionExpired": "Sessió d'impressió caducada.",
"hc.inTheField": ", al camp",
"hc.inTransit": "En trànsit",
"hc.inclVat": "incl. IVA",
"hc.intraEuVatNumberOptional": "Número d'IVA intra-UE opcional, sense SIRET requerit (fora de França).",
"hc.invalidInvitationLink": "Enllaç d'invitació no vàlid.",
"hc.invalidInvitationLink2": "Enllaç d'invitació no vàlid",
"hc.invalidInviteLink": "Enllaç d'invitació no vàlid o caducat.",
"hc.invalidNumberEnterAnInternational": "Número no vàlid. Introduïu un número internacional, p. ex. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Enllaç no vàlid o caducat.",
"hc.invalidOrExpiredReactivationLink": "Enllaç de reactivació no vàlid o caducat",
"hc.invalidSendcloudId": "ID de Sendcloud no vàlid",
"hc.inviteSubtitle": "{org} t'invita a unir-te al seu equip de findloop. Tria la teva contrasenya per activar el teu compte.",
"hc.isAvailableOnSendcloudFor": "està disponible a Sendcloud per a totes les teves rutes (nacionals + internacionals).",
"hc.isNotEnabledOnYour": "no està habilitat al teu compte de Sendcloud per a algunes destinacions. Les etiquetes per aquestes es generaran amb un altre transportista disponible.",
"hc.isThisReallyYourItem": "És aquest realment el teu article?",
"hc.isThisYourItem": "És aquest el teu article?",
"hc.item": "Article",
"hc.itemAlreadyConfirmed": "Article ja confirmat",
"hc.itemDetails": "Detalls de l'article",
"hc.itemFoundAt": "Article trobat a",
"hc.itemFoundAtAPartner": "Article trobat a un soci",
"hc.itemMarkedAsReturned": "Article marcat com a retornat ✓",
"hc.itemPhotoRequiredBeforeShipping": "Foto de l'article (requerida abans de l'enviament)",
"hc.itemPhotoSaved": "Foto de l'article guardada",
"hc.itemPreview": "Previsualització de l'article",
"hc.itemPutBackInStorage": "Article guardat novament.",
"hc.itemWeight": "Pes de l'article:",
"hc.itemsReturned": "article(s) retornat(s)",
"hc.itemsReturnedThisYear": "articles retornats aquest any",
"hc.itemsWhoseLegalDeadlineIs": "Articles el termini legal dels quals és a 15 dies o menys (incloent venciments). Les coincidències segueixen sent visibles.",
"hc.kbisNumber": "Número Kbis",
"hc.keysForgottenOnABench": " claus oblidats en un banc",
"hc.labelBeingGenerated": "Etiquetatge en procés",
"hc.leaveTheFieldsEmptyTo": "Deixa els camps buits per oferir recuperació gratuïta.",
"hc.legalNotice": "Avís legal",
"hc.limitReachedUpgradeToA": "Límit assolit — millora a un pla superior",
"hc.linkCopiedShareOn": "Enllaç copiat — comparteix-ho a {label}",
"hc.linkUnavailable": "Enllaç no disponible",
"hc.linkedTo": "Enllaçat a",
"hc.listingHiddenByModeration": "Anunci amagat per moderació.",
"hc.loading": "Carregant…",
"hc.locateMe": "Localitza'm",
"hc.logIn": "Iniciar sessió",
"hc.logInToGetBack": "Inicia sessió per tornar a l’espai i gestionar la teva subscripció.",
"hc.loginFailed": "Inici de sessió fallit",
"hc.lostFoundPlatform": "Plataforma de pèrdues i troballes.",
"hc.lostIn": "perduts en",
"hc.lowRate": "Baixa tarifa",
"hc.mainReason": "Raó principal",
"hc.mainStreet": "Carrer principal",
"hc.makeSureThisIsThe": "Assegura't que aquest és l'article que vas perdre abans de desbloquejar els detalls de contacte del trobador.",
"hc.manageCookies": "Gestionar galetes",
"hc.manageMyTeam": "Gestionar el meu equip",
"hc.manageYourTeam": "Gestionar el teu equip",
"hc.markAsReturned": "Marcar com a retornat",
"hc.matchNoClaimInTime": "La coincidència no va rebre cap reclamació dins del termini.",
"hc.matchNotFound": "Coincidència no trobada",
"hc.medium": "Mitjà",
"hc.milestoneFmt": "{m} objectes retornats, fita assolida! De camí a {next}.",
"hc.missingFeatures": "Funcions mancants",
"hc.monthly": "Mensual",
"hc.monthlyBilling": "Facturació mensual",
"hc.moveThePhotoToFit": "Mou la foto per ajustar-la al cercle.",
"hc.myAccount": "El meu compte",
"hc.myInvoices": "Les meves factures",
"hc.myMonthlyInvoices": "Les meves factures mensuals",
"hc.nArchived": "{n} llistat(s) arxivats.",
"hc.newCodeGeneratedAndSent": "Nou codi generat i enviat al client per correu electrònic i SMS",
"hc.newCodeGeneratedAndSent2": "Nou codi generat i enviat al propietari",
"hc.newPassword": "Nova contrasenya",
"hc.next": "Següent",
"hc.nextPhoto": "Següent foto",
"hc.no": "No",
"hc.noAnswerProvided": "No s'ha proporcionat resposta.",
"hc.noArchivedDeclarations": "No hi ha declaracions arxivades",
"hc.noCountryFound": "No s'ha trobat cap país",
"hc.noDeclarations": "No hi ha declaracions",
"hc.noFeesAreChargedTo": "No s'apliquen taxes al client.",
"hc.noInvoiceYet": "Encara no hi ha factura.",
"hc.noInvoiceYetYourInvoices": "Encara no hi ha factura. Les teves factures apareixeran aquí automàticament després de cada pagament.",
"hc.noMatchIsAvailableFor": "No hi ha coincidències disponibles per ara. T'avisarem tan aviat com un article coincideixi amb la teva declaració.",
"hc.noShipmentMatchesYourSearch": "No hi ha enviaments que coincideixin amb la teva cerca.",
"hc.noShipmentsYet": "Encara no hi ha enviaments.",
"hc.noShipmentsYet2": "Encara no hi ha enviaments",
"hc.none": "cap",
"hc.noneChooseForEachShipment": "Cap (triar per a cada enviament)",
"hc.notMine": "No és meu",
"hc.of": "de",
"hc.only": "Només",
"hc.onlyEachSiteManagesIts": "només. Cada lloc gestiona el seu propi banc: aquests enllaços no afecten cap altre establiment.",
"hc.onlyTheOwnerOrAn": "Només el propietari o un administrador pot configurar els enllaços de pagament de l'establiment.",
"hc.openDepositInTheMenu": "Obre \"Dipòsit\" al menú, descriu l'article i fes una foto. Es desa immediatament i està llest per ser tornat.",
"hc.openSettings": "Obrir Configuració →",
"hc.openTheDeclarationToManage": "Obrir la declaració per gestionar l'enviament",
"hc.optional": "— opcional",
"hc.optional2": "(opcional)",
"hc.optional3": "opcional",
"hc.originalListingPhotoUsed": "Foto original del llistat utilitzada",
"hc.other": "Altres",
"hc.other2": "Altres…",
"hc.ourProducts": "Els nostres productes",
"hc.overallRateTrendLast6": "Tendència general de les tarifes (últims 6 mesos)",
"hc.ownerSClaimCode": "Codi de reclamació del propietari",
"hc.ownershipConfirmed": "Propietat confirmada",
"hc.paid": "Pagat",
"hc.paidOn": "Pagat el",
"hc.paidViaPartner": "Pagat (a través del soci)",
"hc.parcelBeingPrepared": "Paquet en preparació",
"hc.parcelDelivered": "Paquet entregat",
"hc.parcelShipped": "Paquet enviat",
"hc.parisGareDeLyon": "París, Gare de Lyon…",
"hc.partner": "Soci",
"hc.partner2": "soci",
"hc.partnerDirectory": "Directori de socis",
"hc.passedOnToTheCustomer": "— enviat al client l'enllaç de pagament.",
"hc.password": "Contrasenya",
"hc.passwordResetPleaseLogIn": "Restabliment de contrasenya, si us plau, inicia sessió.",
"hc.passwordUpdated": "Contrasenya actualitzada.",
"hc.passwordsDoNotMatch": "Les contrasenyes no coincideixen.",
"hc.pasteThisSenderIdIn": "Enganxa aquest ID de remitent a Findloop → Configuració",
"hc.payForTheShipmentOf": "Paga per l'enviament del teu article a través de Findloop amb un pagament segur.",
"hc.payTheRecoveryFees": "Paga les taxes de recuperació",
"hc.payTheShippingFees": "Paga les taxes d'enviament",
"hc.payment": "Pagament",
"hc.paymentAlreadyConfirmedByThe": "Pagament ja confirmat pel soci",
"hc.paymentLinksAreNowConfigured": "Els enllaços de pagament ja estan configurats per establiment",
"hc.paymentNotCompletedYourAccount": "Pagament no completat, el teu compte no s'ha creat — si us plau, torna-ho a provar.",
"hc.paymentReceived": "Pagament rebut",
"hc.paymentSuccessful": "Pagament exitos!",
"hc.pdfInvoice": "Factura PDF",
"hc.pending": "Pendent",
"hc.period": "Període",
"hc.phoneNumber": "Número de telèfon",
"hc.phoneOptional": "Telèfon (opcional)",
"hc.planAt": "pla a",
"hc.planLimitFmt": "El teu pla \"{plan}\" està limitat a {max} establiment. Per gestionar {n} llocs, et recomanem el",
"hc.platformReturnTarget": "Objectiu de retorn de la plataforma",
"hc.pleaseCompleteYourShippingAddress": "Si us plau, completa la teva adreça d'enviament.",
"hc.pleaseProvideAPhoneNumber": "Si us plau, proporciona un número de telèfon: és necessari per al transportista per a l'enviament.",
"hc.pleaseProvideAReason": "Si us plau, proporciona un motiu.",
"hc.pleaseSetYourOwnPassword": "si us plau, estableix la teva pròpia contrasenya abans de continuar.",
"hc.pointsToGoal": "{n} punts més per arribar al nostre objectiu compartit.",
"hc.posterPreview": "Previsió de pòster",
"hc.potentialMatchBeingVerified": "Possible coincidència sent verificada",
"hc.potentialOwner": "Possiblement propietari",
"hc.preFilledAutomaticallyYouCan": "Omplert automàticament — pots substituir-lo per una foto del paquet.",
"hc.pressKit": "Kit de premsa",
"hc.previewMode": "Mode de vista prèvia:",
"hc.previewOfThePrintReady": "Vista prèvia del cartell A4 llest per imprimir per a aquest establiment.",
"hc.previous": "Anterior",
"hc.previousPhoto": "Foto anterior",
"hc.primary": "primari",
"hc.printThePoster": "Imprimir el cartell",
"hc.privacy": "Privadesa",
"hc.privacyPolicy": "Política de privadesa",
"hc.processedCasesWillAppearHere": "Els casos processats apareixeran aquí.",
"hc.proofOfReturnPdf": "Prova de retorn (PDF)",
"hc.protectedByRecaptcha": "Protegit per reCAPTCHA",
"hc.publicMatch": "Coincidència pública",
"hc.putBackInStorage": "Tornar a emmagatzemar",
"hc.pwdResetByTeam": "La teva contrasenya ha estat restablerta pel nostre equip. Per la teva seguretat,",
"hc.questionsToAskTheOwner": "Preguntes per fer al propietari",
"hc.rateChargedToTheCustomer": "Tarifa cobrada al client:",
"hc.rateOfTarget": "{rate}% aconseguit d'un objectiu del {target}%",
"hc.reached": "assolit",
"hc.reactivating": "Reactivant…",
"hc.reasonSavedYouCanStill": "Raó guardada. Encara pots reclamar el teu article.",
"hc.recentMatchesFirst": "Ànteriors coincidències primer",
"hc.recognizedThePhotoYouSent": "ha reconegut la foto que vas enviar i ha descrit aquestes característiques. Només confirma si coincideixen amb l'article que tens en possessió.",
"hc.recommended": "Recomanant",
"hc.recoveryFees": "Taxes de recuperació",
"hc.recoveryFeesArePaidDirectly": "Les taxes de recuperació es paguen directament a l'establiment soci. Findloop no rep cap pagament dels clients.",
"hc.recoveryFeesEnabled": "Taxes de recuperació habilitades",
"hc.recoveryOfferedByTheEstablishment": "Recuperació ofereix l'establiment — Findloop no cobra taxes.",
"hc.recoveryPaymentLink": "Enllaç de pagament per a la recuperació",
"hc.recoveryPaymentLinkSavedFor": "Enllaç de pagament per a la recuperació guardat per a aquest establiment",
"hc.redirecting": "Redirigint…",
"hc.redirectingToPayment": "Redirigint al pagament…",
"hc.redirectingToTheRecoveryOf": "Redirigint a la recuperació del teu article…",
"hc.regenerateAndResendToThe": "Regenerar i reenviar al propietari",
"hc.regenerateTheCode": "Regenerar el codi",
"hc.registerAFoundItem": "Registrar un article trobat",
"hc.rejectTheClaim": "Rebutjar la reclamació",
"hc.reminderDelaySaved": "Retard de recordatori guardat",
"hc.reopenThePaymentLink": "Torna a obrir l'enllaç de pagament",
"hc.repeatThePassword": "Repetir la contrasenya",
"hc.reportAProblem": "Informar d'un problema",
"hc.reportDismissedYourListingRemains": "Informe rebutjat. La teva llista roman pública.",
"hc.requiredUsedToCalculateThe": "Requerit: utilitzat per calcular la tarifa d'enviament de Sendcloud. Enviament no disponible per sobre de 30 kg.",
"hc.reset": "Restablir",
"hc.resume": "Reprendrà",
"hc.resumeRegistration": "Reprendre el registre",
"hc.retro": "Any en revisió",
"hc.returnSecurity": "Seguretat de devolució",
"hc.returnToTheOwner": "Retorn al propietari",
"hc.returned": "retornat",
"hc.reviewTheItemDetails": "Revisar els detalls de l'ítem",
"hc.revokeAccess": "Revocar accés",
"hc.role": "Rol:",
"hc.save": "Desar",
"hc.save2": "desar",
"hc.saveAndContinue": "Desar i continuar",
"hc.saving": "Desant…",
"hc.scanTheClaimCode": "Escanejar el codi de reclamació",
"hc.scanTheOwnerSQr": "Escanejar el codi QR del propietari",
"hc.scrollThroughLanguages": "Desplaçar-se per idiomes",
"hc.searchByCustomerItemOr": "Cerca per client, ítem o número de seguiment…",
"hc.searchForACountry": "Cerca un país…",
"hc.secureFindoVerification": "Verificació segura de Findloop",
"hc.seeRetro": "Veure l'any en revisió",
"hc.selectedCarrier": "Transportista seleccionat:",
"hc.selectedPlan": "Pla seleccionat",
"hc.send": "Enviar",
"hc.sendcloudSenderIdSaved": "ID de remitent de Sendcloud desat",
"hc.sendcloudSenderIdSenderId": "ID de remitent de Sendcloud (sender_id)",
"hc.sending": "Enviant…",
"hc.sessionExpired": "Sessió expirada",
"hc.setUpYourEstablishments": "Configura els teus establiments",
"hc.settings": "Configuracions",
"hc.settingsSubtitle": "Pagaments i recordatoris externs, configurats per establiment.",
"hc.shareFoundText": "He trobat un ítem — ajuda'm a trobar el seu propietari a Findloop",
"hc.shareLostText": "He perdut un ítem — ajuda'm a trobar-lo a Findloop",
"hc.sharePreview": "Compartir vista prèvia",
"hc.shareTheRanking": "Compartir el rànquing",
"hc.shareYourQrCodeTo": "Comparteix el teu codi QR per rebre declaracions.",
"hc.shipRateAutoWeight": "La tarifa d'enviament s'calcula automàticament a través de Sendcloud (pes {w}) en el moment de l'enviament.",
"hc.shipRateForWeight": "Tarifa d'enviament (Sendcloud + {m}% de marge) per {w}:",
"hc.shipments": "Enviaments",
"hc.shipmentsSubtitle": "Visió consolidada de tots els enviaments de l'establiment, en tots els casos. Feu clic en una fila per gestionar l'enviament en la seva declaració.",
"hc.shipping": "Enviament",
"hc.shippingAddress": "Adreça d'enviament",
"hc.shippingFeesAreHandledAutomatically": "Les tarifes d'enviament es gestionen automàticament per Findloop (Sendcloud) — sense enllaç per entrar.",
"hc.shippingFeesHaveAlreadyBeen": "Les tarifes d'enviament ja han estat pagades: el transportista ja no pot ser canviat.",
"hc.shippingNotAvailableForItems": "Enviament no disponible per a articles de més de 30 kg. El client haurà de recollir l'article en persona.",
"hc.shippingPaid": "Enviament pagat ✓",
"hc.showOnlyItemsMatchingA": "Mostrar només articles que coincideixin amb una llista pública (client)",
"hc.showPassword": "Mostrar contrasenya",
"hc.signInTheBoxAbove": "Inicieu sessió a la caixa superior",
"hc.signatureSaved": "Signatura guardada",
"hc.signedInWithGoogle": "Iniciat sessió amb Google",
"hc.signupFailed": "Error en el registre",
"hc.silver": " plata",
"hc.simulatedRatesInPreProduction": "(tarifes simulades en pre-producció)",
"hc.siretAndVatNumberRequired": "SIRET i número de VAT requerits (França).",
"hc.skip": "Ometre",
"hc.smsSentIfAccount": "Si existeix un compte amb aquest número, se t'ha enviat un SMS.",
"hc.sortItemsWithAPublic": "Ordenar: articles amb una coincidència pública (més recent) primer",
"hc.specifyWhetherYouRecoveredYour": "Especifica si has recuperat el teu article o si simplement vols eliminar aquesta llista.",
"hc.specifyYourReason": "Especifica el teu motiu",
"hc.specifyYourReason2": "Especifica el teu motiu…",
"hc.staff": "Personal",
"hc.status": "Estat",
"hc.staySignedIn": "Roman en sessió",
"hc.step": "Pas",
"hc.stillThere": "Encara hi ets?",
"hc.stopScrolling": "Atura la desplaçament",
"hc.storeFindWithQr": "Emmagatzemar i trobar amb QR",
"hc.streetName": "Nom del carrer",
"hc.streetNo": "Num. del carrer",
"hc.switchTo": "Canviar a",
"hc.switchToDarkMode": "Canviar a mode fosc",
"hc.switchToLightMode": "Canviar a mode clar",
"hc.takeAPhoto": "Fes una foto",
"hc.takeChangeThePhoto": "Fes / canvia la foto",
"hc.takenFromYourDeclaration": "treta de la teva declaració",
"hc.target": "Objectiu",
"hc.targetReached": "Objectiu aconseguit",
"hc.targetReachedThankYouTo": "Objectiu aconseguit — gràcies a tota la comunitat Findloop!",
"hc.tellUsMore": "Digue'ns més…",
"hc.tellUsWhyYouCancel": "Digue'ns per què cancel·les. Això ajuda el soci a processar la teva sol·licitud.",
"hc.tellUsWhyYourListing": "Digue'ns per què. La teva llista roman activa i encara pots reclamar el teu article.",
"hc.termsAndConditions": "Termes i condicions",
"hc.termsAndPolicies": "Termes i polítiques",
"hc.thankYouForYourFeedback": "Gràcies pel teu comentari",
"hc.theBannerDisplayedInThe": "el banner mostrat al registre.",
"hc.theClaimantHasBeenInformed": "El reclamant ha estat informat. L'article roman disponible a la llista pública.",
"hc.theClaimantHasBeenNotified": "El reclamant ha estat notificat i ara pot procedir amb la devolució.",
"hc.theCustomerPaysTheFees": "El client paga les comissions a l'establiment.",
"hc.theDayTheLegalRetention": "El dia en què es completa el període de retenció legal.",
"hc.theEstablishmentConsideredThatThis": "L'establiment ha considerat que aquest article no és teu.",
"hc.theEstablishmentIsReviewingYour": "L'establiment està revisant les teves respostes. Seràs notificat tan aviat com la teva reclamació sigui validada, llavors podràs pagar les comissions de recuperació.",
"hc.theFeesAreTooHigh": "Les comissions són massa altes",
"hc.theFinderConsideredThatThis": "El cercador ha considerat que aquest article no és teu.",
"hc.theFinderIsReviewingYour": "El cercador està revisant la teva reclamació. Seràs notificat tan aviat com sigui validada.",
"hc.theItem": "L'article",
"hc.theItemWillBeRemoved": "L'article serà eliminat del registre (sense reclamació en curs).",
"hc.theItemWillBeSet": "L'article es posarà de nou com \"en estoc\" i la reclamació relacionada es cancel·larà.",
"hc.theKbisNumberAndVat": "El número Kbis i el número de VAT són necessaris per a França.",
"hc.theLabelIsGeneratedAutomatically": "L'etiqueta es genera automàticament tan bon punt el client ha pagat les comissions d'enviament. Es podrà descarregar aquí.",
"hc.theLinkMayHaveExpired": "El enllaç pot haver caducat (vàlid durant 30 dies). Contacta amb el suport de Findloop si cal.",
"hc.theOwnerDescribesTheirItem": "L' propietari descriu el seu article",
"hc.theOwnerReceivedItBy": "L' propietari ho ha rebut per correu electrònic (o SMS). Introdueix-ho o escaneja-ho abans de la entrega.",
"hc.thePartnerConsideredThatThis": "El soci ha considerat que aquest article no és teu. L'article Roman disponible.",
"hc.thePartnerIsReviewingYour": "El soci està revisant les teves respostes. Seràs notificat tan aviat com la teva reclamació sigui validada.",
"hc.theShipmentIsCreatedAutomatically": "L'enviament es crea automàticament tan bon punt el client ha confirmat la seva adreça i ha pagat les comissions de recuperació. L'etiqueta es generarà automàticament després del pagament d'enviament, i es podrà descarregar aquí.",
"hc.theShippingRateWillBe": "La tarifa d'enviament es calcularà automàticament a través de Sendcloud en el moment de l'enviament (pes enregistrat).",
"hc.thisCarrierWillBe": "Aquest transportista serà",
"hc.thisEstablishment": "aquest establiment",
"hc.thisFieldIsRequiredFor": "Aquest camp és necessari per a la generació automàtica d'etiquetes.",
"hc.thisIsMyItem": "Aquest és el meu article",
"hc.thisIsMyItemContinue": "Aquest és el meu article — continua",
"hc.thisIsMyItemStart": "Aquest és el meu article — inicia la devolució",
"hc.thisIsNotMyItem": "Aquest no és el meu article",
"hc.thisMatchIsNoLonger": "Aquesta coincidència ja no està disponible o ja ha estat processada.",
"hc.thisRateWillBeCharged": "Aquesta tarifa serà cobrada al client. Una tarifa alta pot desanimar la recuperació.",
"hc.thisStepIsRequiredFor": "Aquesta etapa és necessària perquè es generin les etiquetes d'enviament.",
"hc.thisValidationLinkIsInvalid": "Aquest enllaç de validació és invàlid o ha caducat.",
"hc.toCheckBeforeMarkingThe": "Per comprovar abans de marcar l'element com a retornat.",
"hc.toConfigureTheLinksAnd": "per configurar els enllaços i el retard de recordatori per a cada establiment.",
"hc.toReachOurFirstMilestone": "per aconseguir el nostre primer objectiu de 100 retorns.",
"hc.toTheCustomer": "al client.",
"hc.toTheShippingFeePayment": "al pagament de la tarifa d'enviament.",
"hc.toYourRecoveryTracking": "al teu seguiment de recuperació.",
"hc.tooExpensiveBudget": "Masses cars / pressupost",
"hc.topCitiesForReturns": "Principals ciutats per a retorns",
"hc.trackMyRecovery": "Seguir la meva recuperació",
"hc.trackTheShipmentAndDownload": "Segueix l'enviament i descarrega l'etiqueta (generada automàticament) sense deixar la pestanya de Declaracions.",
"hc.trackYourStatistics": "Segueix les teves estadístiques",
"hc.tracking": "Seguiment",
"hc.unableToOpenTheShipping": "No es pot obrir el pagament de la tarifa d'enviament. Si us plau, torna a provar-ho.",
"hc.unableToRetrieveTheInvoice": "No es pot recuperar la factura.",
"hc.unclaimed": "Sense reclamar",
"hc.unclaimedCustomerReason": "Element sense reclamar. Motiu del client: \"{reason}\".",
"hc.unclaimedItem": "Element sense reclamar",
"hc.unclaimedItemNoClaimWithin": "Element sense reclamar — sense reclamació dins del termini.",
"hc.unclaimedItems": "Elements sense reclamar",
"hc.unclaimedItemsMatchLeftWithout": "Elements sense reclamar: coincidències deixades sense reclamació dins del termini. Pots tornar-los a emmagatzemar.",
"hc.unlockTheFinderSContact": "Desbloqueja els detalls de contacte del trobador per organitzar la transferència.",
"hc.upcoming": "Properament",
"hc.updateFailed": "Actualització fallida.",
"hc.usedForInvoices": "Utilitzat per emetre les teves factures findloop.",
"hc.vatNumber": "Número d'IVA",
"hc.verificationPending": "Verificació pendent",
"hc.verificationSentToTheFinder": "Verificació enviada al trobador. Seràs notificat de la seva decisió.",
"hc.verificationSentToThePartner": "Verificació enviada al soci. Seràs notificat de la seva decisió.",
"hc.verify": "Verifica",
"hc.verifyingInvite": "Verificant l'enllaç d'invitació…",
"hc.verifyingTheLink": "Verificant l'enllaç…",
"hc.viewInRegistry": "Veure al registre",
"hc.viewItem": "Veure element",
"hc.viewItemRecover": "Veure element i recuperar",
"hc.visibleToTheOwnerAutomatically": "Visible per al propietari · eliminat automàticament després de 60 dies.",
"hc.waitingForPartnerConfirmation": "Esperant la confirmació del soci",
"hc.waitingForThePartnerS": "Esperant la confirmació del soci",
"hc.weHaveInformedTheEstablishment": "Hem informat l'establiment que aquest article no és teu i hem reiniciat l'anàlisi. Seràs notificat tan aviat com es trobi una nova coincidència.",
"hc.weHaveInformedThePartner": "Hem informat el soci que aquest article no és teu. El teu anunci roman actiu per a futures coincidències.",
"hc.weRanTheAnalysisAgain": "Hem tornat a fer l'anàlisi i hem identificat un altre article que podria ser teu. Si us plau, comprova-ho de nou.",
"hc.weight": "Pes",
"hc.weightNotProvidedTheShipping": "Pes no proporcionat: la tarifa d'enviament es calcularà al moment de l'enviament.",
"hc.weightUnit": "Unitat de pes",
"hc.welcome": "Benvingut!",
"hc.welcomeToFindo": "Benvingut a Findloop",
"hc.whenACustomerComesTo": "Quan un client ve a recollir les seves pertinences, obre la seva declaració i valida el retorn. Això és tot!",
"hc.whenDisabledFeesDropTo": ". Quan estigui desactivat, les comissions baixen a",
"hc.whyIsThisNotYour": "Per què aquest article no és teu?",
"hc.willBeMarkedAs": "serà marcat com",
"hc.wrongColor": "Color incorrecte",
"hc.wrongModel": "Model incorrecte",
"hc.yesCancel": "Sí, cancel·la",
"hc.yesContactTheFinder": "Sí, contacta amb el trobador",
"hc.youAreHere": "Ets aquí",
"hc.youBusinessCom": "tu@negoci.com",
"hc.youCanNowStartThe": "Ara pots començar el retorn.",
"hc.youCanStillChangeIt": ". Encara pots canviar-ho cas per cas.",
"hc.youHaveAlreadyConfirmedThat": "Ja has confirmat que aquest és el teu article.",
"hc.youWillBeRedirectedTo": "Seràs redirigit al pagament segur de Stripe.",
"hc.yourAccountHasBeenReactivated": "El teu compte ha estat reactivat.",
"hc.yourAccountIsActiveYou": "El teu compte està actiu, ara pots gestionar els teus establiments.",
"hc.yourEstablishment": "El teu establiment",
"hc.yourFeedbackHelpsUsImprove": "La teva valoració ens ajuda a millorar les nostres coincidències.",
"hc.yourFeedbackHelpsUsRestart": "La teva valoració ens ajuda a reiniciar l'anàlisi i millorar les nostres coincidències.",
"hc.yourFirstSteps": "Els teus primers passos",
"hc.yourFirstStepsAdmin": "Els teus primers passos (administrador)",
"hc.yourItemHasBeenHanded": "El teu article ha estat lliurat personalment pel soci — tanca el cas un cop el lliurament estigui confirmat.",
"hc.yourItemHasBeenShipped": "El teu article ha estat enviat pel soci — tanca el cas un cop la entrega estigui confirmada.",
"hc.yourPaymentHasBeenRecorded": "El teu pagament ha estat registrat.",
"hc.yourShipmentIsBeingPrepared": "El teu enviament s'està preparant. Rebràs el teu paquet en un termini de 3 a 5 dies laborals.",
"hc.yourShippingFeesHaveAlready": "Les teves tarifes d'enviament ja han estat pagades. Enviament pagat ✓",
"hc.yourShippingFeesHaveBeen": "Les teves tarifes d'enviament han estat pagades. El teu paquet s'està preparant.",
"hc.yourVerificationQuestionsDeposit": "Les teves preguntes de verificació (dipòsit)",
"hero.einvoiceBadge": "facturació electrònica conforme a 2027",
"home.recentAdsAll": "Veure totes les llistes",
"home.recentAdsEyebrow": "Ara mateix",
"home.recentAdsSubtitle": "Articles perduts i trobats reportats per la comunitat.",
"home.recentAdsTitle": "Últimes llistes",
"home.reunions": "Reunions recents",
"home.videoEyebrow": "Veure",
"home.videoSubtitle": "Com reunim articles perduts amb els seus propietaris, sense esforç.",
"home.videoTitle": "Descobreix Findloop en 2 minuts",
"home.watchYoutube": "Veure a YouTube",
"impact.already": "Ja",
"impact.citiesWord": "ciutat/ciutats",
"impact.eachPoint": "Cada punt és una ciutat on Findloop ajuda a recuperar articles perduts.",
"impact.emptyMap": "El mapa es va omplint a mesura que es fan restitucions.",
"impact.eyebrow": "El nostre impacte",
"impact.inCities": "a través de",
"impact.restitutedTo": "articles retornats als seus propietaris",
"impact.title": "Articles retornats, arreu a prop teu",
"inv2.download": "Descarregar",
"inv2.view": "Veure",
"map.objectsOnMapPlural": "articles al mapa",
"map.objectsOnMapSingular": "article al mapa",
"mc.claimConfirmDesc": "Comprova l'article trobat pel trobador abans de pagar per desbloquejar les seves dades de contacte.",
"mc.claimConfirmNo": "Això no és el meu article",
"mc.claimConfirmTitle": "És realment el teu article?",
"mc.claimConfirmYes": "Sí, és meu — paga",
"mc.claimFinderContacts": "Dades de contacte del trobador",
"mc.claimNotMineDone": "Gràcies — el trobador ha estat notificat i la teva sol·licitud s'ha eliminat de l'anunci.",
"mc.claimUnlockDesc": "Paga la taxa de gestió de Findloop per obtenir les dades de contacte de la persona que va trobar el teu article.",
"mc.claimUnlockTitle": "Desbloqueja les dades de contacte del trobador",
"mc.hideCountryOffers": "Amagar ofertes al meu país",
"mc.myClaims": "Articles que estic reclamant",
"mc.myClaimsSub": "Articles trobats per altres que estàs reclamant. Desbloqueja les dades de contacte del trobador per organitzar la entrega.",
"mc.notifAdCancelled": "Anunci cancel·lat",
"mc.notifCancelAd": "Cancel·la el meu anunci",
"mc.offersInCountry": "Ofertes al meu país",
"mc.offersInCountryDesc": "Totes les recompenses actives dels socis al teu país, per ciutat.",
"mc.redArchived": "Arxivat",
"mc.rewardsCountryNone": "Encara no hi ha ofertes al teu país.",
"mc.rewardsForYou": "Recompenses per a tu",
"mc.rewardsForYouDesc": "Ofert per al(s) soci(s) on vas deixar un article.",
"mc.rewardsMineNone": "Encara no hi ha recompensa dels teus socis de drop-off.",
"mc.showCountryOffers": "Veure ofertes al meu país",
"mc2.cancelDecl": "Cancel·la la meva declaració",
"mc2.cancelDeclDone": "Declaració cancel·lada.",
"pricing.physInvDesc": "Quan un article és retornat, la seva ubicació es llibera automàticament i està disponible per a un nou article.",
"pricing.physInvTitle": "Seguiment d'inventari físic",
"pricing.physModalTitle": "Gestió d'articles físics",
"pricing.physQrDesc": "Es genera un codi QR únic per article que enllaça tota la seva informació.",
"pricing.physQrTitle": "Etiqueta QR dedicada",
"pricing.physShelfDesc": "Cada article registrat pot ser assignat a una ubicació física dins de l'establiment.",
"pricing.physShelfTitle": "Pla de prestatge",
"pricing.physicalMgmt": "Gestió d'articles físics (prestatges, QR, inventari)",
"pub.addSecondPhoto": "Afegir una 2a foto (opcional)",
"pub.photo2Added": "✓ 2a foto afegida",
"reg.dispositionJournal": "Diari de disposició",
"reg.dispositionNoteAuthHint": "ℹ️ Es requereix una nota per a “Entregat a les autoritats” (número de report, departament…).",
"reg.dispositionNotePh": "Nota (opcional): organització beneficiària, referència autoritats, nom del comprador…",
"reg.dispositionNoteRequired": "Es requereix una referència oficial per fer la entrega a les autoritats.",
"reg.legalPrealert": "Termini legal en {days} dia(s)",
"reg.legalPrealertOptions": "Opcions al termini: venda en subhasta, donació a una organització benèfica, entrega a les autoritats.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Revisió completa",
"rev.readMore": "Llegir més",
"rw.activeCodes": "Vouchers actius",
"rw.archived": "Arxivat",
"rw.archivedTitle": "Vouchers bescanviats (arxivats)",
"rw.hideArchived": "Amagar vouchers bescanviats",
"rw.noArchived": "No hi ha cap voucher arxivat.",
"rw.showArchived": "Mostrar vouchers bescanviats",
"shp.labelAuto": "L'etiqueta es genera automàticament tan aviat com el client ha pagat les despeses d'enviament. Es podrà descarregar aquí.",
"st.cancelled_by_customer": "Cancel·lat",
"stt.dispoPdfBtn": "Exportar PDF",
"stt.dispoPdfError": "Error en l'exportació del PDF.",
"stt.dispoPdfExporting": "Exportant…",
"trk.matchVerifying": "Possible coincidència en verificació",
"pcat.stadium_arena": "Estadi / Arena",
"pcat.supermarket": "Supermercat",
"pcat.taxi_vtc": "Taxi / VTC",
"pcat.tourism_office": "Oficina de turisme",
"pcat.train_bus_station": "Estació de tren / autobús",
"pcat.travel_agency": "Agència de viatges",
"hc.and": "i",
"hc.demoObj0": "una cartera",
"hc.demoObj1": "una bossa esportiva",
"hc.demoObj2": "un telèfon",
"hc.demoObj3": "un parell d'ulleres",
"hc.demoObj4": "un grapat de claus",
"hc.demoObj5": "una bufanda",
"hc.demoObj6": "un portàtil",
"hc.demoObj7": "una botella d'aigua",
"hc.demoWhen0": "fa 2 hores",
"hc.demoWhen1": "fa 5 hores",
"hc.demoWhen2": "ahir",
"hc.demoWhen3": "fa 3 hores",
"hc.demoWhen4": "aquesta matinada",
"hc.demoWhen5": "fa 1 dia",
"hc.feedDemo": "{obj} va ser retornat a {city} {when}.",
"hc.feedReal": "Un article ({cat}) va ser retornat a {city}.",
"hc.saveBtn": "Desa",
"hc.saveLink": "Desa enllaç",
"hc.terms": "Termes",
"hc.view": "Veure",
"pcat.airline": "Aerolínia",
"pcat.airport": "Aeroport",
"pcat.amusement_park": "Parc d'atraccions",
"pcat.bank": "Banc",
"pcat.bar_cafe": "Bar / Café",
"pcat.beauty_salon": "Perruqueria / Saló de bellesa",
"pcat.cinema": "Cinema",
"pcat.concert_theater": "Sala de concerts / Teatre",
"pcat.coworking": "Espai de coworking",
"pcat.gym_fitness": "Gimnàs / Fitness",
"pcat.hospital_clinic": "Hospital / Clínica",
"pcat.library": "Biblioteca",
"pcat.mall": "Centre comercial",
"pcat.museum": "Museu",
"pcat.pharmacy": "Farmàcia",
"pcat.private_company": "Companyia privada",
"pcat.public_transport": "Transport públic",
"pcat.school_university": "Escola / Universitat",
"pcat.sports_center": "Centre esportiu",
"an.found": "Trobat",
"an.lost": "Perdut",
"hc.shareReview": "Comparteix la ressenya",
"hc.citiesAboveTarget": "{n} ciutats per sobre del seu objectiu",
"hc.cityAboveTarget": "{n} ciutat per sobre del seu objectiu",
"hc.j15EarlyReminder": "Recordatori anticipat D-15",
"hc.j7EarlyReminder": "Recordatori anticipat D-7",
"hc.annualTotal": "Total anual",
"hc.billedOnceYear": "Cobrat una vegada per 12 mesos, renovat cada any.",
"hc.monthlyPrice": "Preu mensual",
"hc.perMonth": "/ mes",
"hc.perYear": "/ any",
"hc.billedEachMonth": "Cobrat automàticament cada mes.",
"nav.business": "Negoci",
"nav.individual": "Individual",
"hc.circumstancesFound": "Circumstàncies del troball",
"hc.circumstancesFoundPh": "Per exemple, trobat a terra a prop de l'entrada del metro",
"hc.circumstancesLost": "Circumstàncies de la pèrdua",
"hc.circumstancesLostPh": "Per exemple, deixat en un banc mentre esperaves el autobús",
"hc.conditionPh": "Per exemple, bo, ratllat…",
"hc.firstName": "Nom",
"hc.lastName": "Cognom",
"hc.quantity": "Número d'articles",
"fa.approve": "Aprovar",
"fa.approveConfirm": "Aprovar aquesta declaració? Es canviaran les teves dades de contacte completes (nom, correu electrònic, telèfon) amb el trobador.",
"fa.approved": "Declaració aprovada — dades de contacte canviades",
"fa.approvedFinder": "El propietari ha aprovat la teva declaració",
"fa.approvedFinderText": "Contacta'ls per organitzar el retorn.",
"fa.boostSub": "La teva llista es manté a la part superior durant la durada escollida.",
"fa.boostTitle": "Millorar la meva llista (opcions)",
"fa.colFinder": "Declaració del trobador",
"fa.colYours": "La teva declaració",
"fa.compareHint": "Compara la declaració del trobador amb la teva abans de decidir.",
"fa.contribNone": "Sense contribució",
"fa.contribPaid": "Contribució rebuda — gràcies!",
"fa.contribPending": "Contribució en espera de pagament",
"fa.contribSub": "Suporta Findloop per ajudar més gent a recuperar les seves pertinences. Pots escollir €0.",
"fa.contribSuccessMsg": "La teva declaració ha estat enviada al propietari.",
"fa.contribSuccessTitle": "Gràcies per la teva contribució",
"fa.contribTitle": "Contribució voluntària",
"fa.days3": "3 dies",
"fa.days30": "30 dies",
"fa.days7": "7 dies",
"fa.declSub": "Descriu l'objecte que has trobat. El propietari compararà la teva declaració amb la seva.",
"fa.declTitle": "He trobat aquest objecte",
"fa.expiresOn": "Caduca el",
"fa.fBrand": "Marca",
"fa.fCircumstances": "Circumstàncies",
"fa.fCity": "Ciutat",
"fa.fColor": "Color",
"fa.fCondition": "Condició",
"fa.fDate": "Data",
"fa.fMessage": "Missatge del trobador",
"fa.fPlace": "Lloc",
"fa.fQuantity": "Quantitat",
"fa.finderContact": "Dades de contacte del trobador",
"fa.finishPay": "Completa el pagament",
"fa.foundDate": "Data trobada",
"fa.foundPlace": "Lloc trobat",
"fa.hours24": "24 hores",
"fa.ht": "excl. IVA",
"fa.months3": "3 mesos",
"fa.noBoost": "Sense millora",
"fa.ownerContact": "Detalls de contacte del propietari",
"fa.payPublish": "Paga i publica",
"fa.pendingPayText": "La teva oferta es posarà en marxa tan aviat com es confirmi el pagament.",
"fa.pendingPayTitle": "Pagament pendent",
"fa.planSub": "La teva oferta es posarà en marxa tan aviat com es confirmi el pagament.",
"fa.planTitle": "Durada de l'oferta",
"fa.pubSuccessMsg": "La teva oferta està activa. Se't notificaran tan aviat com un cercador es presenti.",
"fa.pubSuccessTitle": "Oferta publicada",
"fa.publicNote": "Només es mostren públicament la descripció, la ciutat, el país i les fotos.",
"fa.redirectStripe": "Redirectant a un pagament segur…",
"fa.reject": "Rebutjar",
"fa.rejectConfirm": "Rebutjar aquesta declaració? La teva oferta es manté en línia.",
"fa.rejected": "Declaració rebutjada",
"fa.rejectedFinder": "No era l'objecte que buscaven",
"fa.rejectedFinderText": "El propietari diu que aquest article no és seu. Gràcies per la teva ajuda!",
"fa.responsesTitle": "Declaracions dels cercadors",
"fa.sent": "Declaració enviada al propietari.",
"fa.submitDecl": "Envia la meva declaració",
"fa.submitDeclPay": "Enviar i contribuir {amount}",
"fa.total": "Total a pagar",
"fa.ttc": "incl. IVA",
"fa.waitClaimText": "El cercador està revisant la teva sol·licitud. Se't notificarà sobre la seva decisió.",
"fa.waitFinderText": "Et farem saber tan aviat com un cercador enviï una declaració.",
"fa.waitFinderTitle": "La teva oferta està activa",
"fa.waitOwnerText": "El propietari està comparant la teva declaració amb la seva. Se't notificarà sobre la seva decisió.",
"fa.waitOwnerTitle": "Esperant la decisió del propietari",
"st.pending_payment": "Pagament pendent",
"fa.africaFree": "Llistat gratuït a Àfrica — oferta de llançament de Findloop, gaudeix-ho!",
"fa.africaPublished": "Llistat publicat gratuïtament — oferta de llançament a Àfrica!",
"fa.approveClaimConfirm": "Aprovar aquesta reclamació? L' propietari podrà desbloquejar les teves dades de contacte.",
"fa.checkInfo": "Comprova les teves dades abans d'enviar: es compararan amb les del trobador.",
"fa.claimApprovedShort": "El trobador ha aprovat la teva reclamació",
"fa.claimRejectedShort": "Reclamació rebutjada pel trobador",
"fa.claimRejectedText": "El trobador creu que aquest article no és teu.",
"fa.claimSub": "Descriu el teu article i afegeix 2 fotos. El trobador les compararà amb la seva llista.",
"fa.claimTitle": "Aquest és el meu article",
"fa.claimUnlockText": "Desbloqueja les dades de contacte del trobador per organitzar la devolució.",
"fa.claimUnlockedShort": "Dades de contacte desbloquejades — veure seguiment",
"fa.claimsTitle": "Reclamacions de propietari",
"fa.colOwner": "Declaració del propietari",
"fa.colYourAd": "El teu llistat",
"fa.expired": "Llistat caducat",
"fa.free": "Gratuït",
"fa.lostDate": "Data de pèrdua",
"fa.lostPlace": "Lloc de pèrdua",
"fa.noReceipt": "No hi ha rebut disponible per a aquest llistat.",
"fa.planSubFree": "Tria la durada: el teu llistat es publica immediatament, sense necessitat de pagament.",
"fa.prefillPrevious": "Reutilitza les dades del meu llistat anterior en aquesta categoria",
"fa.receipt": "Rebut en PDF",
"fa.renewBtn": "Renovar",
"fa.renewDiscountBanner": "50% de descompte: renova abans que el teu llistat caduqui!",
"fa.renewDiscountHint": "50% de descompte aplicat perquè renoves abans de la caducitat.",
"fa.renewEarly": "Renovar (−50%)",
"fa.renewTitle": "Renovar el meu llistat",
"fa.renewed": "Llistat renovat",
"fa.sendClaim": "Envia la meva reclamació",
"fa.twoPhotos": "2 fotos del teu article",
"fa.twoPhotosError": "Afegeix 2 fotos del teu article.",
"fa.twoPhotosHint": "Fotos personals provant que l'article és teu (amb l'article, factura, caixa…).",
"fa.unlockBtn": "Desbloquejar dades de contacte",
"fa.unlockFree": "Desbloqueja gratuïtament — oferta de llançament",
"fa.waitClaimantText": "Et informarem tan aviat com un propietari reclami aquest article.",
"fa.waitFinderDecision": "Esperant la decisió del trobador",
"fa.waitUnlockText": "Se't notificarà tan aviat com es canviïn les dades de contacte.",
"fa.waitUnlockTitle": "Esperant que el propietari desbloquegi",
"fa.cancel": "Cancelar",
"fa.categoryRequired": "Trieu una categoria per l'element trobat.",
"fa.confirmTitle": "Confirmeu la vostra decisió",
"fa.goBack": "Torna enrere",
"dr.continue": "Continua la meva declaració",
"dr.delete": "Suprimeix permanentment",
"dr.deleteConfirm": "Suprimeixes aquest esborrany permanentment? Això no es pot desfer.",
"dr.deleted": "Esborrany suprimit",
"dr.expiresIn": "Esborrany mantingut durant {h} hores més",
"dr.title": "Tens una declaració pendent",
"form.step": "Pas",
"form.next": "Continuar",
"form.back": "Enrere",
"form.stepDetails": "El teu informe",
"form.stepPublish": "Durada, impuls i pagament",
"form.stepThanks": "Gràcies i contribució",
"fthx.badge": "Informe gairebé complet",
"fthx.title": "Gràcies, estàs fent la diferència!",
"fthx.text": "Gràcies a tu, algú podria recuperar pròximament alguna cosa que li importa. Actes de bondat com el teu són exactament el que manté Findloop viu.",
"fthx.impact1": "1 article informat",
"fthx.impact2": "1 oportunitat més de reunió",
"fthx.tipTitle": "Una petita ajuda per a Findloop?",
"fthx.tipText": "La teva contribució ens ajuda a mantenir el servei accessible i a reunir cada vegada més articles amb els seus propietaris.",
"fthx.optional": "100% opcional — pots publicar sense contribuir.",
"fthx.thanksTip": "Moltes gràcies per la teva generositat!",
"fthx.suggest": "Quantitats suggerides",
"fthx.none": "Sense propina",
"pay.pendingTitle": "Pagament no completat",
"pay.pendingText": "Les teves dades s'han desat. Recull el pagament just on ho vas deixar.",
"pay.resume": "Reanudar el pagament",
"pay.expiredTitle": "Sessió de pagament expirada",
"pay.expiredText": "Per la teva seguretat, la sessió de pagament ha expirat. Les teves dades s'han desat: reinicia el pagament amb un clic.",
"pay.relaunch": "Reiniciar el pagament",
"sub.received": "Enviat!",
"sub.publishing": "Estem acabant…",
"sub.toPayment": "Redireccionant a pagament segur…",
"fa.claimSubV2": "Descripció de l'objecte perdut. La persona que l'ha trobat compararà la teva declaració amb el seu llistat.",
"fa.photosOptional": "Fotos del teu article (opcional)",
"fa.compareOwnerHint": "Compara aquesta informació amb l'objecte que has trobat i digues si és el mateix article.",
"fa.itsThisItem": "Sí, aquest és l'article",
"fa.notThisItem": "No, aquest no és l'article",
"fa.confirmIsItem": "Confirmes que aquest és l'article? Les teves dades de contacte i les de l'owner es mostraran a les teves respectives comptes.",
"fa.confirmNotItem": "Confirmes que aquest no és l'article? El teu informe es tancarà.",
"fa.youConfirmed": "Has confirmat que aquest és l'article de l'owner",
"fa.youDeclined": "Has indicat que aquest no era l'article",
"fa.youDeclinedText": "Gràcies per la teva ajuda! L'owner ha estat informat.",
"fa.waitFinderDecisionOwner": "Esperant la decisió de qui ha trobat l'objecte",
"fa.finderConfirmed": "Confirmat",
"fa.notYourItem": "Això no era el teu article",
"fa.reportedOn": "Informada el",
"fa.ownerWaitHint": "Un qui ha trobat l'objecte està comprobant la informació, si us plau espera.",
"fa.claimSentFinder": "Reclamació enviada a la persona que ha trobat l'objecte.",
"fa.compareClaimHint": "Compara la declaració del propietari amb la teva llista abans de decidir.",
"fa.closeFollowup": "Tancar aquest seguiment",
"fa.closeFollowupConfirm": "Tancar aquest seguiment? Els correus electrònics i números de telèfon de les dues parts s'esborraran de manera permanent un cop l' owner també hagi tancat el seu llistat.",
"fa.safetyTitle": "Consells de seguretat abans de la transacció",
"fa.safety1": "Pregunta a l'owner per una descripció detallada de les característiques ocultes de l'objecte: un ratll, el contingut exacte d'una bossa, el paper de paret, el número de sèrie…",
"fa.safety2": "Si és possible, demana una prova visual (una foto de l'objecte) o una prova de compra.",
"fa.safety3": "Fes la transacció en un lloc públic o en un soci de Findloop, i comprova la identificació de l'owner.",
"fa.safetyOk": "Entès, continua",
"fa.ownerClosedNote": "L'owner ha tancat el seu llistat.",
"fa.finderClosedNote": "El cercador ha tancat el seu seguiment.",
"fa.followupClosed": "Seguiment tancat",
"fa.followupClosedText": "Has tancat aquest seguiment. Gràcies per la teva ajuda!",
"fa.photoReviewTitle": "Un cercador ha enviat una foto. Sembla el teu article?",
"fa.photoLooksLike": "Sí, sembla el meu article",
"fa.photoNotMine": "No, aquest no és el meu article",
"fa.photoNotMineConfirm": "El seguiment es tancarà per ambdues parts i la teva llista es mantindrà oberta per a un nou cercador.",
"fa.photoLooksLikeDone": "Gràcies! El cercador compararà ara la teva declaració.",
"fa.photoNotMineDone": "Report rebutjat. La teva llista es manté oberta.",
"fa.ownerPhotoHint": "Només es mostra la foto del cercador. Diga'ns si sembla el teu article.",
"fa.ownerReviewingPhoto": "El propietari està revisant la teva foto",
"fa.ownerReviewingPhotoText": "Seràs notificat tan aviat com responguin. Aleshores podràs comparar la seva declaració.",
"fa.ownerRejectedPhoto": "Aquest no és l'article del propietari",
"fa.ownerRejectedPhotoText": "El propietari diu que la teva foto no coincideix amb el seu article. El seguiment està tancat. Gràcies per la teva ajuda!",
"fa.contribute": "Contribueix",
"fa.phoneMissing": "No proporcionat",
"fa.ownerSafety1": "Prefereix una entrega en un lloc públic o en un soci de Findloop. Si la distància és llarga, suggereix enviar-ho per correu en canvi.",
"fa.ownerSafety2": "A l'entrega, comprova la identificació del trobador.",
"pub.changePhoto": "Canvia la foto",
"ph.secured": "Foto assegurada",
"ph.securing": "Assegurant la foto…",
"fa.ownerSafety3": "Si la foto del trobador porta la marca d'aigua de Findloop, no acceptis la reunió. La foto ha de ser una imatge original presa pel trobador, sense marca d'aigua."
},
"ja": {
"ac.africa": "アフリカ",
"ac.boostActive": "アクティブを強調表示 —",
"ac.boostSub": "「ブースト」バッジ付きでパートナーディレクトリのトップに表示されます。",
"ac.boostTitle": "ディレクトリでリスティングをブーストする",
"ac.categoryHint": "findloopディレクトリでの施設分類のため。",
"ac.choose": "選択",
"ac.cityHint": "公開マップ上での正確な位置付けのため。",
"ac.cityLabel": "施設の都市",
"ac.cityPh": "パリ",
"ac.contact": "連絡先詳細",
"ac.converted": "変換済み",
"ac.copyDeclLink": "宣言リンクをコピー",
"ac.copyLink": "リンクをコピー",
"ac.currentPlan": "現在のプラン",
"ac.emailDesc": "受け取りたいメールを選択してください。ワークスペースの通知は常にアクティブです。",
"ac.emailMatch": "一致",
"ac.emailMatchDesc": "アイテムが宣言に一致した時のメール",
"ac.emailNewDecl": "新しい損失声明",
"ac.emailNewDeclDesc": "顧客があなたの場所で損失を報告した時にすぐにメールが届きます",
"ac.emailShip": "配送リクエスト",
"ac.emailShipDesc": "顧客がアイテムの配送をリクエストした時のメール",
"ac.emailTitle": "メール設定",
"ac.expireSoon": "あなたのハイライトはまもなく期限切れになります —",
"ac.exportCsv": "エクスポート (CSV)",
"ac.exportHint": "会計用に承認された外部支払いをエクスポートします。",
"ac.free": "無料",
"ac.freeMonths": "無料期間",
"ac.hours": "時間",
"ac.howItWorks": "どのように機能しますか？",
"ac.invited": "招待済み",
"ac.legalFR": "2026年9月から適用される電子請求書用に必要です (Factur-X)。",
"ac.legalMissing": "⚠️ SIRETとEU内VATが不足しています — 電子請求書に準拠するためにそれらを完了してください。",
"ac.legalOther": "請求書に推奨されます。",
"ac.legalPartnerQr": "QRコード",
"ac.legalTitle": "法的識別子（請求）",
"ac.logoTitle": "施設のロゴ",
"ac.modeCurrent": "現在のモード:",
"ac.modeExternal": "外部（手動検証）",
"ac.modeInternal": "内部Findloop（自動）",
"ac.noSubReceipt": "まだ有料サブスクリプションの支払いはありません。",
"ac.none": "なし",
"ac.onYourListing": "リスティング上で",
"ac.pay1": "顧客を自分の決済システムにリダイレクトするために、下に決済リンクを入力してください。",
"ac.pay2": "確認が手動になります: 「宣言」タブからの支払い受領を確認します。",
"ac.pay3": "「配送手数料」リンクは、統合された支払いです（回収 + 配送）。",
"ac.pay4": "Findloopの内部決済（Stripe）を自動検証で使用するには、フィールドを空のままにしてください。",
"ac.paySub": "自分の支払いシステムを介して手数料を収集します。",
"ac.payTitle": "外部支払い",
"ac.permissive": "許可",
"ac.phone": "電話",
"ac.posterA4": "A4ポスター (PDF)",
"ac.qMessage": "メッセージ（オプション）",
"ac.qName": "名前",
"ac.qOrg": "組織",
"ac.qSites": "施設数（推定）",
"ac.qrHint": "顧客がこのコードをスキャンして紛失物を報告します。",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "あなたのパートナーQRコード",
"ac.quoteDesc": "空港、鉄道網、国際チェーン · ",
"ac.quoteEurope": "ヨーロッパ / 世界",
"ac.quoteSent": "見積もりリクエストが送信されました。チームがすぐにご連絡いたします。",
"ac.quoteTitle": "見積もりをリクエスト — エンタープライズ",
"ac.recoveryLink": "「回収手数料」リンク",
"ac.refSub": "紹介したパートナーが登録すると、1ヶ月無料になります。",
"ac.refTitle": "紹介して、1ヶ月無料を獲得",
"ac.reminderDelay": "検証リマインダーの遅延",
"ac.reminderHint": "外部支払いがこの遅延を超えて未検証のままの場合、メールリマインダーが届きます（デフォルト：約48時間）。",
"ac.renewDesc1": "すでにあなたに利益をもたらしています",
"ac.renewDesc2": "ディレクトリのトップに留まり、この可視性を失わないために更新してください。",
"ac.renewNow": "今すぐ更新",
"ac.requestQuote": "見積もりをリクエスト",
"ac.saveLegal": "識別子を保存",
"ac.saveLinks": "リンクを保存",
"ac.sendRequest": "リクエストを送信",
"ac.sending": "送信中…",
"ac.shippingLink": "「配送手数料」リンク（統合済）",
"ac.shippingLinkHint": "このリンクは回収と配送の両方をカバーしています。",
"ac.strict": "厳格",
"ac.subReceipt": "サブスクリプション領収書（PDF）",
"ac.subReceiptsSub": "各サブスクリプション支払いのPDF領収書をダウンロードしてください。",
"ac.subReceiptsTitle": "サブスクリプション領収書",
"ac.tCategory": "カテゴリーが保存されました",
"ac.tCity": "都市が保存されました - 地図が更新されました",
"ac.tCityNeeded": "都市を入力してください",
"ac.tCopied": "コピーしました！",
"ac.tCover": "カバー写真が更新されました",
"ac.tEmailPrefs": "メール設定が更新されました",
"ac.tErr": "エラー",
"ac.tExportImpossible": "エクスポートに失敗しました",
"ac.tLegal": "法的識別子が保存されました",
"ac.tLegalNeeded": "フランスに必要なSIRETとVAT",
"ac.tLogo": "ロゴが更新されました",
"ac.tLogoRemoved": "ロゴが削除されました",
"ac.tPayLinks": "支払いリンクが保存されました",
"ac.tPhone": "電話が保存されました",
"ac.tSensitivity": "感度が保存されました",
"ac.tVatInvalid": "無効なVAT番号",
"ac.tVatValid": "有効なVAT",
"ac.tabBoost": "可視性",
"ac.tabPayments": "支払い",
"ac.tabProfile": "プロフィール",
"ac.tabQr": "QR & ポスター",
"ac.tabReferral": "リファerral",
"ac.tabSub": "サブスクリプション",
"ac.thisWeek": "今週",
"ac.thisWeekOf": " （今週 {n}）",
"ac.thresholdDesc": "AIが自動的に写真の一致を検証し、顧客に通知する信頼度のしきい値。高いほど自動一致は少なくなりますが、より信頼性が増します。",
"ac.thresholdTitle": "AI視覚的一致感度",
"ac.trend": "トレンド",
"ac.upload": "アップロード",
"ac.vatValidFmt": "有効なVAT{name} ({via})",
"ac.vatVerified": "EU内のVATが確認されました",
"ac.verifyVat": "VATを確認する（VIES）",
"ac.verifying": "確認中…",
"ac.views": "ビュー",
"ac.viewsTotal": "獲得したビュー（合計）",
"ac.winbackBtn": "-20%で再開",
"ac.winbackDesc1": "あなたに利益をもたらしました",
"ac.winbackDesc2": "特別オファー：24時間以内に更新すると自動的に-20%が適用されます。",
"ac.winbackTitle": "あなたのハイライトが期限切れになりました — -20%で再開！",
"an.allCountries": "すべての国",
"an.country": "国",
"an.geoBanner": "あなたは以下のリストを表示しています",
"an.geoBannerWorld": "あなたは世界中のリストを表示しています",
"an.geoChange": "国を変更する",
"an.loginRequired": "このアイテムを報告し、返品を追跡するにはログインしてください。",
"an.requestInProgress": "リクエスト処理中",
"an.resolved": "アイテムはすでに回収されています",
"an.sortRecent": "最も最近",
"an.sortRelevance": "関連性",
"bo.africaPrice": "アフリカ地域の優遇価格が適用されました",
"c.all": "すべて",
"c.close": "閉じる",
"c.confirm": "確認",
"c.confirmed": "確認済み",
"c.download": "ダウンロード",
"c.reset": "リセット",
"c.transfer": "転送",
"cat.Animal": "ペット / ペットアクセサリー",
"cat.AppareilPhoto": "カメラ",
"cat.Argent": "お金 / 現金",
"cat.Autres": "その他",
"cat.Bijoux": "ジュエリー",
"cat.CarteBancaire": "銀行カード",
"cat.CarteIdentite": "IDカード / パスポート",
"cat.Casquette": "キャップ / 帽子",
"cat.Ceinture": "ベルト",
"cat.Chargeur": "充電器 / ケーブル",
"cat.Chaussures": "靴",
"cat.CleVoiture": "車の鍵",
"cat.Cles": "鍵",
"cat.Console": "ゲーム機",
"cat.Documents": "書類 / ペーパー",
"cat.Echarpe": "スカーフ",
"cat.Ecouteurs": "イヤフォン / ヘッドフォン",
"cat.Electronique": "電子機器（その他）",
"cat.Enceinte": "スピーカー",
"cat.Gants": "手袋",
"cat.Gourde": "水筒 / フラスク",
"cat.Instrument": "楽器",
"cat.Jouet": "おもちゃ / プラッシュ",
"cat.Jumelles": "双眼鏡",
"cat.Lampe": "ランプ / 懐中電灯",
"cat.Liseuse": "電子書籍リーダー",
"cat.Livre": "本 / ノート",
"cat.Lunettes": "眼鏡",
"cat.Manteau": "コート / ジャケット",
"cat.Maquillage": "メイクアップバッグ",
"cat.Medical": "医療機器",
"cat.Medicaments": "薬",
"cat.Montre": "腕時計 / スマートウォッチ",
"cat.Ordinateur": "ノートパソコン",
"cat.Parapluie": "傘",
"cat.Portefeuille": "財布 / ハンドバッグ",
"cat.Poussette": "ベビーカー / ベビーアクセサリー",
"cat.Sac": "バッグ / ハンドバッグ",
"cat.SacADos": "バックパック",
"cat.Souris": "マウス / キーボード",
"cat.Sport": "スポーツ用品",
"cat.Tablette": "タブレット",
"cat.Telephone": "電話 / スマートフォン",
"cat.Trottinette": "スクーター",
"cat.Trousse": "ポーチ / ケース",
"cat.USB": "USBメモリ / ハードドライブ",
"cat.Valise": "スーツケース / 荷物",
"cat.Velo": "自転車",
"cat.Vetements": "服",
"cm.found": "見つかりました",
"cm.lost": "紛失しました",
"cmp.starterEst": "1つ含まれています + 無制限の追加",
"consent.required": "続行するには連絡先情報の共有に同意する必要があります。",
"consent.share": "私のアイテムの発見者が私の連絡先情報（名前、メール、電話）を見られることに同意します。連絡のために返却に向けて。",
"dc.partnerDesc": "パートナー施設（ホテル、駅、ホールなど）でアイテムを紛失しましたか？ 直接返却のために選択してください。",
"dc.partnerList": "リストから選択",
"dc.partnerMap": "地図から選択",
"dc.partnerTitle": "パートナーでの申告",
"dc.publicCta": "公開広告を投稿",
"dc.publicDesc": "あなたの広告はfindloopコミュニティ全体に表示されます。アイテムを失った場所がわからない場合に最適です。",
"dc.publicTitle": "公開申告",
"dc.subtitle": "紛失したアイテムを報告する方法を選択してください。",
"dc.title": "何をしたいですか？",
"dec.addrPending": "顧客からの住所保留中",
"dec.analyzing": "分析中…",
"dec.clientDescription": "顧客の説明",
"dec.clientPhoto": "顧客提供の写真",
"dec.clientPhotoShort": "顧客の写真",
"dec.comparePhotos": "写真を比較",
"dec.declaredItemPhoto": "申告されたアイテムの写真",
"dec.emptyDesc": "QRコードを共有して申告を受け取ります。",
"dec.emptyTitle": "申告はありません",
"dec.enlarge": "拡大する",
"dec.extBanner": "{n} の外部支払いを確認する必要があります — 引渡しまたは発送を解除するには、以下の受領を確認してください。",
"dec.foundItemAlt": "見つかったアイテム",
"dec.foundItemRegistry": "見つかったアイテム（登録）",
"dec.labelClient": "顧客",
"dec.labelRegistry": "登録",
"dec.noMatchYet": "まだマッチしていません。",
"dec.noPhoto": "写真はありません",
"dec.pRecup": "回収",
"dec.pRecupP": "(回収)",
"dec.pRecupShip": "(回収 + 発送)",
"dec.payConfirmed": "支払い {x} 確認済み",
"dec.payPending": "外部支払い {x} 保留中",
"dec.pickup": "対面での受け取り",
"dec.reject": "拒否",
"dec.rerun": "分析を再実行",
"dec.similarity": "類似度 {n}%",
"dec.suggestedMatches": "提案されたマッチ",
"dec.toColon": " へ:",
"dec.toShip": "発送先",
"dec.toastExtPay": "支払いが確認されました — 顧客に通知されます。",
"dec.toastMatch": "マッチが確認されました",
"dec.toastReject": "提案が拒否されました",
"dec.toastRerun": "分析が再開されました",
"dec.toastVisualN": "{n} の視覚マッチ",
"dec.toastVisualNone": "視覚マッチはありません",
"dec.viewBeforeAfter": "前後の表示（オーバーレイ）",
"dec.viewSideBySide": "並べて表示",
"dec.visualCompare": "AI視覚比較",
"dec.visualIdle": "比較を実行し、AIが顧客の写真と見つかったアイテムを視覚的にマッチさせます。",
"dec.visualRunning": "AIが顧客の写真をあなたのレジストリのアイテムと比較しています…",
"dec.zoomPhoto": "写真を拡大",
"dep.addAnyway": "無理に追加",
"dep.addError": "追加中にエラーが発生しました",
"dep.addItem": "アイテムを追加",
"dep.added": "アイテムがレジストリに追加されました！",
"dep.adding": "追加中…",
"dep.aiError": "現在AI分析が利用できません。",
"dep.aiFilled": "AIによってフォームが事前入力されました ✨",
"dep.aiUnavailable": "AIが利用できません — フォームを手動で入力してください。",
"dep.analyzing": "分析中…",
"dep.analyzingPhoto": "写真を分析中…",
"dep.brand": "ブランド",
"dep.brandPlaceholder": "例: Apple",
"dep.category": "カテゴリー",
"dep.checkingDup": "重複をチェック中…",
"dep.color": "色",
"dep.colorPlaceholder": "例: 黒",
"dep.condition": "状態",
"dep.conditionPlaceholder": "例: 良好な状態",
"dep.depositorNote": "預託者のメモ",
"dep.depositorNoteHint": "手書きで入力された運用詳細。AIはこのメモを上書きしません。",
"dep.depositorNotePlaceholder": "例: ポーチの内容、報告されたブランド、提供された詳細…",
"dep.descPlaceholder": "例: バーで発見されたクリアケース付きの黒いiPhone 15…",
"dep.description": "説明",
"dep.dupHint": "重複していないことを確認してください。本当に異なるアイテムの場合は続行できます。",
"dep.dupTitle": "類似のアイテムがすでに登録されています",
"dep.dupWarn": "類似のアイテムが検出されました — 確認して、再度クリックして確定してください。",
"dep.estHint": "アイテムはこの施設のレジストリに追加されます。",
"dep.establishment": "施設",
"dep.fee": "回収手数料 (€) — 任意",
"dep.feePlaceholder": "カテゴリーのデフォルト価格を使用するには空白のままにしてください",
"dep.fillAI": "AIで入力",
"dep.optional": "(任意)",
"dep.photo": "アイテム写真",
"dep.principal": "主要",
"dep.reqError": "カテゴリーと説明は必須です。",
"dep.savedItem": "登録されたアイテム",
"dep.similarity": "類似性",
"dep.storage": "物理的な場所",
"dep.storageHint": "アイテムが物理的に保存されている場所。QRコードが生成されて見つけることができます。",
"dep.storagePlaceholder": "例: シェルフA3、ロッカー12、受付の金庫",
"dl.aClient": "顧客",
"dl.alertsBlocked": "ブラウザのアラートがブロックされています",
"dl.alertsBlockedHint": "再度有効にするには: サイトアドレスの左にある🔒（またはⓘ）アイコンをクリックし、通知を許可してページを再読み込みしてください。",
"dl.amountDue": "未払い金額: {amount} {currency}.",
"dl.enableAlerts": "アラートを有効にする",
"dl.extPending": "検証済みの支払い",
"dl.freemiumNear": "あなたはフリーミアム制限に近づいています（今月 {used}/{max} アイテム）。無制限のアイテム用にStarterにアップグレードしてください。",
"dl.freemiumReached": "フリーミアム制限に達しました（今月 {used}/{max} アイテム）。無制限のアイテム登録のためにStarterにアップグレードしてください。",
"dl.invoiceOverdue": "未払いの請求書 {num} — アクセスが制限されています。",
"dl.matchNotifTitle": "Findloop — 新しいAIマッチ 🔔",
"dl.matchToast": "新しいAIマッチ — {name}",
"dl.matchToastDesc": "アイテムが宣言と一致します。",
"dl.notifEmpty": "通知はまだありません。",
"dl.notifEnabled": "ブラウザのアラートが有効です",
"dl.notifTitle": "通知",
"dl.payInvoice": "請求書を支払う →",
"dl.rewardsPending": "提示するバウチャー",
"dl.upgradeStarter": "Starterにアップグレード →",
"est.all": "すべての施設 ({n})",
"est.label": "施設",
"est.primary": "主要",
"est.secondary": "副次的",
"est2.add": "施設を追加",
"est2.addressLabel": "住所",
"est2.addressPh": "12 République Street",
"est2.autoInvoice": "詳細な請求書は毎月1日に自動で生成されます。",
"est2.baseSub": "基本サブスクリプション",
"est2.billing": "請求",
"est2.boostActivated": "{name}のブーストが有効になりました",
"est2.boostBillingNote": "現在の料金で請求され、月次の統合請求書にまとめられます。",
"est2.boostCta": "ブースト",
"est2.boostDesc": "この施設のディレクトリおよびマップ上の可視性を向上させます。",
"est2.boostDuration": "{h}時間のブースト可視性",
"est2.boostExtend": "延長",
"est2.boostTitle": "{name}をブースト",
"est2.boosted": "ブースト済み",
"est2.chartDesc": "登録された合計に対する返品アイテムの割合、サイト別。",
"est2.chartTitle": "施設別返品率",
"est2.chartTooltip": "返品",
"est2.cityLabel": "市",
"est2.cityPh": "リヨン",
"est2.contactHint": "これらの詳細はこの施設の顧客に表示されます（空白の場合はアカウントに戻ります）。",
"est2.countryLabel": "国",
"est2.coverLabel": "カバーフォト",
"est2.create": "作成",
"est2.created": "施設が作成されました",
"est2.delete": "削除",
"est2.deleteDesc": "この操作は永久的です。アイテムがない場合のみ施設を削除できます。",
"est2.deleteTitle": "「{name}」を削除しますか？",
"est2.deleted": "施設が削除されました",
"est2.dialogDesc": "このサイトの名前と住所を入力してください。",
"est2.edit": "編集",
"est2.editEst": "施設を編集",
"est2.emailLabel": "連絡先メール",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " 施設",
"est2.extraNoteBase": "{n}の追加施設が請求されます",
"est2.extraPrice": " {price} €/月で。",
"est2.extraQuote": "見積もりにて。",
"est2.imgChange": "画像を選択",
"est2.imgDone": "完了",
"est2.imgRemove": "削除",
"est2.imgRemoved": "画像が削除されました",
"est2.imgSaved": "画像が保存されました",
"est2.imgUploading": "アップロード中…",
"est2.includedPlan": "プランに含まれています: {n}。",
"est2.kDeclarations": "申告",
"est2.kInStorage": "保管中",
"est2.kItemsTotal": "アイテム（合計）",
"est2.kRestituted": "返品済み",
"est2.limitReached": "制限に達しました",
"est2.logoLabel": "ロゴ",
"est2.mDeclar": "申告",
"est2.mItems": "アイテム",
"est2.mRestituted": "返品済み",
"est2.mStorage": "保管中",
"est2.monthlyTotal": "月次合計",
"est2.nameLabel": "名前 *",
"est2.namePh": "例: ベルモントホテル — リヨンアネックス",
"est2.newEst": "新しい施設",
"est2.onQuote": "見積もり中",
"est2.phoneLabel": "電話",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "プラン",
"est2.planLimited": "あなたの「{tier}」プランは {max} 施設に制限されています。",
"est2.primary": "プライマリ",
"est2.qr": "QRコード",
"est2.qrDesc": "このQRコードをこの施設で表示します。紛失を報告するお客様はこのサイトにリンクされます。",
"est2.qrTitle": "QRコード — {name}",
"est2.saving": "保存中…",
"est2.seeInvoices": "月次請求書を確認",
"est2.seePlans": "プランを確認",
"est2.subtitle": "1つのアカウントで全てのサイトを管理 — 集約されたビュー、アイテム、QRコード、請求書。",
"est2.suspended": "一時停止中",
"est2.tierFree": "1施設",
"est2.tierLarge": "無制限の施設",
"est2.tierMedium": "5施設が含まれています",
"est2.tierSmall": "3施設が含まれています",
"est2.title": "施設",
"est2.unlimitedPlan": "あなたのプランは無制限の施設数を許可します。",
"est2.unlimitedSuffix": " · 無制限",
"est2.updated": "施設が更新されました",
"est2.upgradeHint": "より高いプランにアップグレードして、さらに多くのサイトを追加し、全ての活動を集中管理してください。",
"est2.visuals": "ロゴと写真",
"est2.visualsDesc": "この施設のロゴとカバーフォトをカスタマイズします。これらは公開ページと申請書に表示されます。",
"est2.visualsTitle": "ビジュアル — {name}",
"est2.workOn": "この施設に取り組む",
"est2.working": "あなたは「{name}」に取り組んでいます",
"ft.backAccount": "マイアカウントに戻る",
"ft.closeBtn": "ケースを閉じる",
"ft.closeConfirm": "アイテムが返却されたことを確認しますか？広告が閉じられます。",
"ft.closeLockedHint": "まず所有者のコードを確認して閉じるのを解除してください。",
"ft.closed": "ケースが閉じました — アイテムが返却されました！",
"ft.codeLabel": "所有者から受け取った確認コードを入力",
"ft.codeNeeded": "確認コードを入力してください。",
"ft.codeOk": "コードが確認されました — ケースを閉じることができます。",
"ft.codePlaceholder": "例: 4821",
"ft.codeVerified": "確認済み",
"ft.doneMsg": "アイテムが返却されました。所有者への返却に協力していただきありがとうございます！",
"ft.stepInProgress": "返却中",
"ft.stepPublished": "広告が公開されました",
"ft.stepReturned": "アイテムが返却されました",
"ft.subtitle": "見つかったアイテムが返却されるまで手順に従ってください。",
"ft.title": "返却追跡",
"ft.verifyBtn": "コードを確認",
"inv2.contractTitle": "私のfindloop契約",
"inv2.detailByEst": "施設別の詳細",
"inv2.dueLabel": "期限:",
"inv2.dueSuffix": " · 期限 {date}",
"inv2.error": "エラー {status}",
"inv2.estCountIssued": "{n} 施設 · 発行日 {date}",
"inv2.estimate": "見積もり（未請求） · {n} 施設",
"inv2.expired": " · 期限切れ",
"inv2.exportCsv": "CSVをエクスポート",
"inv2.exportDone": "CSVエクスポートがダウンロードされました",
"inv2.included": "含まれています",
"inv2.monthlyTitle": "月次請求（サブスクリプション）",
"inv2.months": "+{n} ヶ月",
"inv2.paid": "支払い済み",
"inv2.pay": "支払う",
"inv2.previewTitle": "次の請求書のプレビュー —",
"inv2.renew": "契約を更新する",
"inv2.renewalsTitle": "契約更新履歴 ({n})",
"inv2.renewedUntil": "契約は {date} まで更新されました",
"inv2.serviceTitle": "サービス請求書（回収と見積もり）",
"inv2.soon": "期限が近い",
"inv2.toPay": "支払うべき金額",
"inv2.totalHtTva": "合計（税抜）· VAT",
"inv2.totalTtc": "合計（税込）",
"iu.addPhoto": "写真を追加",
"iu.change": "変更",
"map.high": "高",
"map.legend": "リターン率に基づく赤（低）から緑（高）への色付きドット; サイズはアイテム数に基づく。",
"map.locating": "位置情報を取得中… マップに表示するために、あなたの施設に住所を追加してください。",
"map.low": "低",
"map.medium": "中",
"map.noItemRegistered": "登録されたアイテムはありません",
"map.noItems": "アイテムなし",
"map.returnedSuffix": "返却された · {a}/{t} アイテム",
"map.title": "あなたの施設の地図",
"mc.archiveHide": "履歴を隠す",
"mc.archiveNone": "まだ解決されたケースはありません。",
"mc.archiveShow": "履歴を表示",
"mc.archiveSub": "解決され、返却されたケース。",
"mc.archiveTitle": "履歴",
"mc.certificate": "証明書",
"mc.finderAccepted": "受け入れられました",
"mc.hAd": "失われた広告",
"mc.hDeclaration": "宣言",
"mc.hFinderContact": "報告されたアイテム",
"mc.hFound": "返却されたアイテム",
"mc.hFoundAd": "見つかった広告",
"mc.myFinds": "私が見つけたアイテム",
"mc.myFindsNone": "まだアイテムの発見を報告していません。",
"mc.myFindsSub": "失くしたアイテム広告で発見を報告したアイテム。",
"mc.notifOpen": "表示",
"mc.notifTrack": "追跡",
"mc.notifViewAd": "広告を表示",
"mc.presentHint": "このQRをパートナーに見せてください：彼らはそれをスキャンしてあなたの報酬を確認します。",
"mc.presentInStore": "店舗で見せる",
"mc.presentTitle": "このバウチャーを見せる",
"mc2.acceptFinder": "この発見者を受け入れる",
"mc2.accountActivity": "アカウントの活動",
"mc2.adsActive": "{n}/5 件のアクティブな広告",
"mc2.autoDelete": "自動削除が予定されています",
"mc2.badgeBronze": "ブロンズ",
"mc2.badgeGold": "ゴールド",
"mc2.badgeSilver": "シルバー",
"mc2.boostEarnedAlready": "すでにあなたに得られています",
"mc2.boostEarnedWin": "あなたに得られました",
"mc2.boostExpiredWin": "あなたのブーストがちょうど期限切れです — -20% で再開！",
"mc2.boostExpiresIn": "あなたのブーストはあと",
"mc2.boostWinDetail2": "。 -20% は24時間以内に更新すると自動的に適用されます。",
"mc2.claimCode": "クレームコード:",
"mc2.codeSentFinder": "発見者にメールで送信されたコード",
"mc2.daysShort": "{n} 日",
"mc2.downloadReceipt": "領収書をダウンロード",
"mc2.error": "エラー {status}",
"mc2.finderAccepted": "ファインダー受理 — コードがメールで送信されました",
"mc2.finderContacts": "ファインダーの連絡先情報",
"mc2.followFindo": "findloopをフォローする",
"mc2.imgInvalid": "無効な画像",
"mc2.inactivityNote": " — {n}か月間の非活動の場合（GDPR）。",
"mc2.lastActivity": "最終活動:",
"mc2.lostEmailTitle": "メールにアクセスできなくなりました",
"mc2.noPhotoPreset": "まだ写真がありませんか？ デフォルトのアバターを選択:",
"mc2.paidViaPartner": "支払い完了（パートナー経由）",
"mc2.payRecovery": "回復手数料を支払う",
"mc2.paySettle": "支払いを完了する",
"mc2.payShipping": "送料を支払う",
"mc2.payUnavailable": "支払い不可",
"mc2.peopleFound": "{n}人があなたのアイテムを見つけたと思っています",
"mc2.phoneNumber": "電話番号",
"mc2.reactivateAccount": "アカウントを再活性化する",
"mc2.reactivated": "アカウントが再活性化されました",
"mc2.reactivatedThanks": "アカウントが再活性化されました — ご愛顧ありがとうございます！",
"mc2.recoverSmsBtn": "SMSでコードを取得する",
"mc2.recoverSmsDesc": "アカウントに登録されている番号にSMSで請求コードを受け取ります。",
"mc2.recoverSmsFallback": "この番号でアカウントが存在する場合は、SMSが送信されました。",
"mc2.renewStayTop": ". 頂点に留まり、アイテムを回復するには更新してください。",
"mc2.resume20": "再開 -20%",
"mc2.unlockContacts": "連絡先情報を表示",
"mc2.unlockDesc": "findloopの手数料を支払うことで、連絡先情報を表示し、引き渡しを手配できます。",
"mc2.viewsWord": "ビュー",
"mc2.live": "ライブ",
"mh.allCategories": "すべてのカテゴリ",
"mh.allPeriod": "すべての時間",
"mh.autoMatch": "自動AIマッチ",
"mh.blocked": "ブロックされています（矛盾）",
"mh.blockedReason": "マッチがブロックされました: アイテムの主要キーワードと宣言が矛盾しています。",
"mh.days30": "過去30日",
"mh.days7": "過去7日",
"mh.days90": "過去90日",
"mh.emptyDesc": "AIによるマッチは、宣言が入るとここに表示されます。",
"mh.emptyTitle": "イベントはありません",
"mh.exportCsv": "CSVをエクスポート",
"mh.exportDone": "CSVのエクスポートがダウンロードされました",
"mh.exportImpossible": "エクスポートに失敗しました",
"mh.fBlocked": "ブロック済み",
"mh.fConfirmed": "確認済み",
"mh.fRejected": "拒否済み",
"mh.objectLabel": "アイテム:",
"mh.refresh": "リフレッシュ",
"mh.rejected": "拒否されました",
"mh.srcManual": "手動",
"mh.srcText": "テキスト",
"mh.srcVisual": "視覚（写真）",
"mh.subtitle": "AIによって提案されたマッチのログ — 自動マッチ、確認、拒否。",
"mh.title": "AI履歴",
"nf.desc": "お探しのページは存在しないか、移動されました。",
"nf.home": "ホームに戻る",
"nf.title": "ページが見つかりません",
"par.allCities": "すべての都市",
"par.cityPh": "都市",
"pay.eurNote": "金額はユーロ（€）で表示されています。",
"pg.next": "次",
"pg.prev": "前",
"pg.showing": "{from}–{to} の {total}",
"pk.bodyCopy": "ボディコピー",
"pk.bodyText": "本文テキスト",
"pk.brandColors": "ブランドカラー",
"pk.colorRed": "赤",
"pk.colorWhite": "白",
"pk.darkBg": "ダーク背景",
"pk.download": "ダウンロード",
"pk.downloadZip": "全てのキットをダウンロード (ZIP)",
"pk.headings": "見出し",
"pk.heroDesc": "公式ロゴ、SNSバナー、色とタイポグラフィ。タグラインの言語とバリアントを選択し、ビジュアルまたはフルキットをダウンロードします。",
"pk.lightBg": "ライト背景 (印刷用)",
"pk.logoWordmark": "ロゴ / ワードマーク",
"pk.logosVisuals": "ロゴとビジュアル",
"pk.mapCollect": "地図 / 収集ポイント",
"pk.plain": "プレーン",
"pk.pressKit": "プレスキット",
"pk.taglineLang": "タグライン言語",
"pk.typography": "タイポグラフィ",
"pk.variant": "バリアント",
"pr2.adBoostMsg": "素晴らしい選択です！アイテムを迅速に回収できる機会が倍増します。",
"pr2.boostActivated": "ブーストが有効化されました！",
"pr2.canRecoverNow": "今すぐアイテムを回収できます。",
"pr2.continue": "続ける",
"pr2.downloadReceiptPdf": "領収書をダウンロード (PDF)",
"pr2.goToSpaceNow": "今すぐマイアカウントへ",
"pr2.partnerBoostMsg": "素晴らしい選択です！より目立つことで新しい顧客を引き寄せます。",
"pr2.paymentSuccess": "支払い成功！",
"pr2.redirectingSpace": "アカウントにリダイレクト中…",
"pr2.subActivated": "支払い成功！サブスクリプションが有効です。現在、店舗を管理できます。",
"prev.allSites": "すべての店舗",
"pricing.annual": "年間",
"pricing.annualBadge": "-20%のオファー",
"pricing.monthly": "月額",
"pricing.perYear": "/年",
"pricing.saveLabel": "節約額",
"pricing.savePerYear": "/年あたり追加店舗",
"pub.accessGranted": "アクセスが許可されました",
"pub.accessLimited2h": "アクセスは2時間に制限されています",
"pub.accountEmailConcerned": "対象のアカウントのメール",
"pub.adAppearPublic": "これがあなたの広告の公に表示される方法です。",
"pub.adPreviewBtn": "広告プレビュー",
"pub.alertMeOnArrival": "到着時に通知",
"pub.allActionsLogged": "すべてのアクションが記録されています",
"pub.allCategories": "すべてのカテゴリ",
"pub.authorizeAccess": "アクセスを許可",
"pub.authorizeSupportQ": "サポートアクセスを許可しますか？",
"pub.available": "利用可能",
"pub.backHome": "ホームに戻る",
"pub.boostAdCta": "広告をブースト",
"pub.boostAdTitle": "広告をブーストする",
"pub.boostCarouselSub": "「ブーストされた」カルーセルでページのトップに移動し、視聴回数を倍増させてアイテムをより早く回収します。",
"pub.boostEstablishment": "店舗をブースト",
"pub.boostEstablishmentDesc": "「ブーストされた」バッジでディレクトリのトップに表示され、より多くのレポートを引き寄せます。",
"pub.boostFicheCta": "リスティングをブースト",
"pub.brandReady": "使用する準備が整ったfindloopブランド",
"pub.cantFindItem": "アイテムが見つかりませんか？",
"pub.cantProcessImage": "この画像を処理できません",
"pub.claimQr": "QRコードを取得",
"pub.clickToZoom": "クリックしてズーム",
"pub.codeAlreadyValidated": "コードが検証されました — 連絡先が解除されました。",
"pub.codeExample": "例：ABCD2345",
"pub.confirmRenewal": "更新を確認",
"pub.contactIntro": "質問やリクエストはありますか？ご連絡いただければ、すぐにお返事いたします。",
"pub.contactTypeDeceased": "アカウント削除（故人）",
"pub.contactTypeGeneral": "一般的な質問",
"pub.contactTypeSupport": "サポート / 技術的な問題",
"pub.contactUs": "お問い合わせ",
"pub.continueWithoutEmail": "メールアドレスを残さずに続ける",
"pub.contractLabel": "契約",
"pub.contractNotFound": "契約が見つからないか、すでに期限切れです。",
"pub.contractRenewed": "契約が更新されました！",
"pub.contractRenewedFor": "契約は {n} ヶ月間更新されました。",
"pub.copyFailed": "コピーに失敗しました",
"pub.createPartnerAccount": "パートナーアカウントを作成",
"pub.currentDeadline": "現在の期限",
"pub.deceasedInfo": "親族または相続人として、故人のfindloopアカウントの削除をリクエストできます。GDPRに従いリクエストを処理します（必要に応じて書類を求めることがあります）。",
"pub.declareMyLoss": "紛失を報告",
"pub.describeItemPlaceholder": "アイテムを説明してください（例：黒い傘、鍵…）",
"pub.downloadImage": "画像をダウンロード",
"pub.drawSignature": "署名を描いてください。",
"pub.drawSignatureHint": "マウスまたは指で署名を描いてください。",
"pub.duration": "期間",
"pub.eSignature": "電子署名",
"pub.eSignatureDesc": "署名するために名前を入力してください。日付は自動的に記録されます。",
"pub.edit": "編集",
"pub.editorialTitles": "編集タイトル",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "オーナーの連絡先詳細を解除するために、メールで受け取ったコードを入力してください。",
"pub.errorWord": "エラー",
"pub.foundSelfService": "見つかったアイテム · セルフサービス",
"pub.haveOwnerCode": "オーナーからコードを受け取りました",
"pub.home": "ホーム",
"pub.immediateRenewal": "新しい見積もりなしでの即時更新。",
"pub.impAdminReq1": "管理者",
"pub.impAdminReq2": "があなたのアカウントに一時的にアクセスする許可をリクエストしています",
"pub.impAdminReq3": "支援するためです。",
"pub.impGrantedDesc": "サポートチームは最大2時間あなたのアカウントにアクセスできます。すべての操作は記録されます。このページを閉じることができます。",
"pub.invitedOnFindo": "findloopに招待されています",
"pub.isThisYourItem": "これはあなたのアイテムですか？",
"pub.itemsAvailableCount": "現在 {n} 点のアイテムが利用可能",
"pub.itemsFoundOwner": "委託されたアイテムの所有者が見つかりました",
"pub.itemsReturnedOwners": "アイテムが所有者に返却されました",
"pub.itsMine": "私のものです",
"pub.joinFindoDesc": "findloopに参加して、見つけたアイテムを簡単に管理しましょう。",
"pub.joinInvitesYou": "はfindloopへの参加を招待します。見つけたアイテムを管理するためにパートナーアカウントを作成してください。",
"pub.linkCopied": "リンクがコピーされました！",
"pub.loadingContract": "契約を読み込み中…",
"pub.lsClaimDesc": "紛失を報告して回収しましょう。メールアドレスを残しておけば、報告が未完了の場合にリマインダーをお送りします。",
"pub.lsHeroDesc": "自分で失くしたアイテムが見つかり、ここに置いてあるか確認してください。見つけましたか？報告して回収してください。",
"pub.lsSearchTitle": "見つかったアイテムを検索",
"pub.makeOffer": "オファーを出す",
"pub.makeOfferDesc": "金額を提案してください。スーパー管理者が確認します。",
"pub.mapNearYou": "近くのアイテム & パートナー",
"pub.mapWord": "地図",
"pub.messageSentToast": "メッセージが送信されました — 当社のチームがすぐに返信します。",
"pub.messageWord": "メッセージ",
"pub.momoInitiated": "モバイルマネーの支払いが開始されました",
"pub.monthsWord": "ヶ月",
"pub.nameConsentRequired": "名前と同意が必要です。",
"pub.newDeadline": "新しい期限",
"pub.noActionRequired": "アクションは不要です。",
"pub.noAmountCharged": "料金は請求されませんでした。",
"pub.noItemMatch": "現在、検索条件に一致するアイテムはありません。",
"pub.noMatchingItem": "一致するアイテムはありません",
"pub.noPaymentSession": "支払いセッションはありません。",
"pub.noPhoto": "写真はありません",
"pub.noPointsYet": "表示するポイントはまだありません。",
"pub.noSecondPayment": "このアイテムには2回目の支払いは必要ありません。",
"pub.notHereYet": "まだ来ていませんか？到着次第通知します。",
"pub.notifyDone": "記録しました！一致するアイテムが到着次第、メールでお知らせします。",
"pub.offerSubmitted": "あなたのオファーが送信されました。",
"pub.oops": "おっと",
"pub.orAlertEmail": "または、一致するアイテムが到着次第、メールで通知を受け取る：",
"pub.ownerContacts": "オーナーの連絡先詳細",
"pub.ownerContactsUnlocked": "オーナーの連絡先詳細がアンロックされました",
"pub.partnerContact": "パートナー連絡先",
"pub.payLinkUnavailable": "支払いリンクは利用できません — パートナーに連絡してください。",
"pub.paymentCancelled": "支払いがキャンセルされました",
"pub.paymentConfirmed": "支払いが確認されました 🎉",
"pub.paymentConfirmedDesc": "アイテムを回収するための詳細が記載されたメールを受け取ります。",
"pub.paymentNotConfirmed": "支払いが確認されていません",
"pub.paymentNotConfirmedDesc": "支払いを確認できませんでした。再試行するか、パートナーに連絡してください。",
"pub.paymentProcessing": "支払い処理中です。少々お待ちください。",
"pub.photoAdded": "✓ 写真が追加されました",
"pub.photoRequired": "アイテムの写真が必要です。",
"pub.previewAlt": "プレビュー",
"pub.publish": "公開",
"pub.publishingWord": "公開中…",
"pub.qty": "数量",
"pub.quoteDeclined": "見積もりが却下されました。",
"pub.quoteNotFound": "見積もりが見つかりませんでしたまたは期限切れです。",
"pub.reasonLabel": "理由",
"pub.recoveryAlreadyPaid": "回収手数料は既に支払われています",
"pub.referralCode": "紹介コード：",
"pub.relationshipPlaceholder": "息子、配偶者、公証人…",
"pub.renewYourContract": "契約を更新する",
"pub.renewalFailed": "更新に失敗しました。後でもう一度お試しください。",
"pub.renewing": "更新中…",
"pub.replySoon": "私たちのチームはできるだけ早く返信します。",
"pub.requestGone": "このリクエストは存在しません。",
"pub.requestHandled": "リクエストはすでに処理されています",
"pub.requestNotFound": "リクエストが見つかりませんでしたまたは期限切れです。",
"pub.requestUnavailable": "リクエストは利用できません",
"pub.required": "(必須)",
"pub.retroClosing": "私たちが一緒に、世界を少しだけ迷子にならないようにします。",
"pub.retroClosing2": "私たちが一緒に、世界を少しだけ迷子にならないようにします。",
"pub.retroScroll": "大切なものを取り戻す1年。下にスクロール ↓",
"pub.revokeAnytime": "いつでも私たちに連絡して解除できます",
"pub.scene": "シーン",
"pub.sendImpossible": "送信できません",
"pub.sendMessage": "メッセージを送信",
"pub.sending": "送信中…",
"pub.sharePreview": "プレビューを共有",
"pub.shareYourAd": "広告を共有",
"pub.signedSuccess": "正常に署名されました！",
"pub.signerFullName": "署名者のフルネーム",
"pub.spreadNetwork": "周りの人に共有して、チャンスを広げましょう。",
"pub.spreadOwner": "オーナーが所有物を回収できるように共有してください。",
"pub.statusLabel": "ステータス：",
"pub.subject": "件名",
"pub.thanksSent": "ありがとうございます。メッセージが送信されました。",
"pub.thisYear": "今年",
"pub.validate": "検証",
"pub.verifyingPayment": "支払いを検証しています…",
"pub.verifyingYourPayment": "あなたの支払いを検証しています…",
"pub.viewAd": "広告を見る →",
"pub.viewPartner": "パートナーを見る →",
"pub.yourAdPreview": "広告のプレビュー",
"pub.yourEmail": "あなたのメールアドレス",
"pub.yourEmailRecommended": "あなたのメールアドレス（推奨）",
"pub.yourEmailShort": "メールアドレス",
"pub.yourName": "あなたの名前",
"pub.yourRelationship": "その人との関係",
"qv.acceptAndSign": "見積もりを承認して署名する",
"qv.certifyAuthorized": "私は署名する権限があり、この{what}（拘束力のある金額）の条件を受け入れることを証明します。",
"qv.clear": "クリア",
"qv.client": "クライアント",
"qv.conditions": "条件",
"qv.confirmDecline": "この見積もりの拒否を確認しますか？",
"qv.countersignedFindo": "findloopによって反署されました · {name} {date}に",
"qv.decline": "拒否",
"qv.description": "説明",
"qv.downloadPdf": "PDFをダウンロード",
"qv.handwrittenSignature": "手書きの署名",
"qv.inclTax": "税込み",
"qv.invalidAmount": "無効な金額です。",
"qv.invoice": "請求書",
"qv.invoicePaid": "請求書が支払われました",
"qv.issuer": "発行者",
"qv.messageOptional": "メッセージ（任意）",
"qv.negotiatedAmount": "交渉された金額",
"qv.payInvoiceOnline": "オンラインで請求書を支払う",
"qv.quote": "見積もり",
"qv.quoteValidDays": "見積もりは{n}日間有効です。",
"qv.sendMyOffer": "私のオファーを送信",
"qv.signContract": "契約に署名",
"qv.signNow": "今すぐ署名",
"qv.signatureAlt": "署名",
"qv.signedByOn": "✔ {name}によって{date}に署名されました",
"qv.stContractSigned": "契約が署名されました。ありがとうございます！",
"qv.stCounterAccepted": "あなたのオファーが受け入れられました！以下で契約に署名してください。",
"qv.stCounterRefused": "あなたのオファーは受け入れられませんでした。",
"qv.stCountered": "あなたのオファーが提出されました。findloopの返答を待っています。",
"qv.stDeclined": "この見積もりを拒否しました。",
"qv.stSigned": "見積もりが受け入れられ、署名されました。ありがとうございます！",
"qv.totalHt": "合計（税抜）",
"qv.totalTtc": "合計（税込）",
"qv.unitHt": "単位（税抜）",
"qv.vat": "消費税",
"qv.yourProposedAmount": "あなたの提案した金額（{cur}）",
"reg.add": "アイテムを登録",
"reg.allBrands": "すべてのブランド",
"reg.allColors": "すべての色",
"reg.allLocations": "すべての場所",
"reg.detailDesc": "見つかったアイテムの詳細とアクション。",
"reg.dispAuction": "オークション",
"reg.dispAuthorities": "当局に引き渡し",
"reg.dispDestroyed": "破壊されました",
"reg.dispDonate": "チャリティ寄付",
"reg.dispositionHint": "アイテムが保管を離れることを記録します。カテゴリ別に統計にカウントされます。",
"reg.emptyCta": "アイテムを登録",
"reg.emptyDesc": "最初の見つけたアイテムをログに記録しましょう。",
"reg.emptyTitle": "見つかったアイテムはありません",
"reg.establishmentFallback": "その施設",
"reg.lblAuctioned": "オークションに出品",
"reg.lblAuctionedShort": "オークション",
"reg.lblAuthorities": "当局に引き渡し",
"reg.lblDestroyed": "破棄",
"reg.lblDonated": "慈善団体に寄付",
"reg.legalCount": "{n} アイテム(s): 法的保持期間到達",
"reg.legalHint": "オークションに出品するか、慈善団体に寄付するか、当局に引き渡したことを報告できます。",
"reg.legalLimitCountry": "締切: {date} · 適用国: {country}",
"reg.legalOver": "締切が過ぎました: {date} · {country}",
"reg.legalReached": "法的期間到達",
"reg.legalReachedFull": "法的保持期間到達",
"reg.limitShort": "締切",
"reg.location": "場所",
"reg.markRestituted": "返却済みとマーク",
"reg.markedAs": "アイテムは {label} としてマークされました",
"reg.moveHistory": "移動履歴",
"reg.overBy": "{n}日超過",
"reg.physicalLocation": "物理的な場所",
"reg.popupBlocked": "ラベルを印刷するためにポップアップを許可してください。",
"reg.popupBlockedOne": "ラベルを印刷するためにポップアップを許可してください。",
"reg.printLabel": "ラベルを印刷",
"reg.printN": "{n} ラベルを印刷",
"reg.qrCodeItem": "アイテム QR コード",
"reg.qrLabelTitle": "QR ラベル",
"reg.qrLabelsTitle": "QR ラベル",
"reg.qrNotFound": "このQRコードに対応するアイテムは見つかりませんでした。",
"reg.qrScanHint": "スキャンしてこの記録を直接開き、場所を見つけてください。",
"reg.recoveryFee": "回収手数料 (€)",
"reg.searchPh": "説明で検索…",
"reg.selectQr": "QR ラベルを印刷するために選択",
"reg.selectedN": "{n} 選択済み",
"reg.shipPricePh": "送料 (€)",
"reg.shippingPossible": "配送可能",
"reg.storagePh": "例: シェルフ A3、ロッカー 12",
"reg.tAuction": "findloopのオークション",
"reg.tAuthorities": "当局への引き渡しを報告",
"reg.tDonate": "慈善団体に寄付",
"reg.toastFee": "手数料が更新されました",
"reg.toastLocation": "場所が保存されました",
"reg.toastRestituted": "アイテムが返却済みとマークされました",
"reg.toastShipping": "配送オプションが更新されました",
"reg.toastTransferred": "アイテムが「{name}」に転送されました",
"reg.unclaimedDisposition": "未請求アイテム — 最終処分",
"res.codeValidated": "コードが検証されました",
"res.empty": "まだ返還が記録されていません。",
"res.error": "エラー {status}",
"res.proofPdf": "PDF証明書",
"res.signed": "署名済み",
"res.stRestituted": "対面で引き渡し",
"res.stShipped": "配送で返却",
"res.subtitle": "ダウンロード可能な署名済み証明書付きの全ての完了した引き渡し。",
"res.title": "返還履歴",
"rev.restitutedBy": "{org} によって返却されました",
"rev.storiesEyebrow": "ハッピーエンド",
"rev.storiesSubtitle": "findloopで所持品を取り戻した顧客の実際の物語。",
"rev.storiesTitle": "彼らは所持品を見つけました！",
"rp.already": "このリストを既に報告しています。",
"rp.duplicate": "重複",
"rp.inappropriate": "不適切なコンテンツ",
"rp.wrongCategory": "間違ったカテゴリー",
"rt.annualGoal": "年間目標",
"rt.championCity": "チャンピオンシティ",
"rt.cityRate": "{rate}% のリターン率",
"rt.goalProgress": "{rate}% 達成の {target}% 目標",
"rt.reached": "達成 🎉",
"rt.restitutionRate": "リターン率",
"rt.shareRecap": "私の要約を共有",
"rt.thanks": "ありがとう Findloop {year} 💛",
"rt.yourRecap": "あなたの {year} 要約",
"rw.active": "アクティブ",
"rw.add": "追加",
"rw.camUnavailable": "カメラが使用できません。以下にコードを手動で入力してください。",
"rw.codeValidated": "コードが確認されました",
"rw.codesTitle": "ファインダーによって引き換えられたコード",
"rw.confirmDelete": "「{title}」を削除しますか？",
"rw.deleted": "削除されました",
"rw.edit": "編集",
"rw.editReward": "報酬を編集",
"rw.empty": "まだ報酬はありません。",
"rw.expired": "期限切れ",
"rw.expiresOn": "{date} に期限切れ",
"rw.fActive": "アクティブ（ファインダーに可視）",
"rw.fCost": "コスト（ポイント）",
"rw.fDesc": "説明",
"rw.fStock": "ストック（空 = 無制限）",
"rw.fTitle": "タイトル",
"rw.fValidity": "バウチャー有効期限（リデンプション後の日数）",
"rw.inactive": "非アクティブ",
"rw.newReward": "新しい報酬",
"rw.noExchange": "まだ引き換えはありません。",
"rw.pageSubtitle": "ファインダーが提示したバウチャーをスキャンして報酬を確認してください。",
"rw.redeemedN": "引き換え済み: {n}×",
"rw.saved": "報酬が保存されました",
"rw.scanVoucher": "バウチャーをスキャン",
"rw.staffScanOnly": "スキャンのみ",
"rw.statActive": "提示するため",
"rw.statExpired": "期限切れ",
"rw.statRedeemed": "引き換えられたバウチャー",
"rw.statUsed": "確認済み",
"rw.stock": "ストック",
"rw.subtitle": "ファインダーがFinder Scoreポイントと引き換える非金銭的特典（バウチャー、アップグレード…）を提供します。",
"rw.title": "ファインダー向けの報酬",
"rw.used": "使用済み",
"rw.validate": "確認",
"rw.validateCode": "コードを確認",
"rw.validity": "有効期限: {n} 日",
"side.establishments": "施設",
"side.restitutions": "リターン",
"side.rewards": "報酬 & バウチャー",
"side.settings": "設定",
"side.storage": "ストレージ & QR",
"status.auctioned": "オークション出品",
"status.destroyed": "破壊されました",
"status.donated": "寄付されました（慈善）",
"status.handed_to_authorities": "当局に引き渡されました",
"status.in_storage": "保管中",
"status.matched": "マッチしました",
"status.open": "オープン",
"status.paid": "支払い済み",
"status.pending": "保留中",
"status.restituted": "返品",
"status.shipped": "発送済み",
"status.shipping_requested": "発送をリクエスト済み",
"status.submitted": "提出済み",
"stg.allLabels": "すべてのQRラベル",
"stg.camHint": "下記に手動入力を使用してください。",
"stg.camStarting": "カメラを起動中…",
"stg.camUnavailable": "カメラが使用できません。",
"stg.clear": "クリア",
"stg.clearAll": "すべてクリア",
"stg.codeUnreadable": "コードが読み取れません。",
"stg.emptyDesc": "保存されたアイテムはここに表示され、場所ごとにグループ化されます。",
"stg.emptyTitle": "ストレージにアイテムがありません",
"stg.exportAudit": "監査CSVをエクスポート",
"stg.exportDone": "CSVエクスポートがダウンロードされました",
"stg.exportImpossible": "現在、エクスポートは利用できません。",
"stg.itemFound": "アイテムが見つかりました ✅",
"stg.kLocations": "使用された場所",
"stg.kObjects": "保存されたアイテム",
"stg.kToClear": "クリアする場所",
"stg.locFreed": "場所がクリアされました",
"stg.locsFreed": "{n} の場所がクリアされました",
"stg.manualLabel": "またはアイテムのコード / IDを入力してください",
"stg.manualPh": "QRのIDまたはURLを貼り付け",
"stg.noItemMatch": "このQR / コードに一致するアイテムがありません。",
"stg.noLocation": "場所がありません",
"stg.objectsAxis": "アイテム",
"stg.objectsN": "{n} アイテム",
"stg.occAvg": "平均 {n} アイテム/場所",
"stg.occHint": "オレンジの場所は平均を超えています（過負荷の可能性あり）。",
"stg.occupancy": "場所の占有率",
"stg.openPage": "ページを開く",
"stg.posterPdf": "PDFポスター (A4)",
"stg.printAll": "すべて印刷",
"stg.printGroupTitle": "この棚のラベルを印刷",
"stg.qrAlt": "セルフサービスQR",
"stg.qrDownload": "QRをダウンロード",
"stg.qrHint": "このQRをカウンターに表示してください：お客様はそれをスキャンしてアイテムの可用性を確認します。",
"stg.qrTitle": "顧客セルフサービスQR",
"stg.scanDesc": "アイテムのラベルをスキャンして、その記録をすぐに開きます。",
"stg.scanQr": "QRをスキャン",
"stg.scanTitle": "QRコードをスキャン",
"stg.search": "検索",
"stg.shelf": "棚 {loc}",
"stg.shelfPlan": "棚の計画",
"stg.staleHint": "これらの場所をクリアして、物理的な在庫を最新の状態に保ってください。",
"stg.staleTitle": "{n} アイテムがストレージを離れましたが、まだ場所を保持しています",
"stg.subtitle": "棚の計画、QRスキャナー、および物理的な在庫追跡。",
"stg.title": "ストレージ & QR",
"stt.acceptRate": "受け入れ率",
"stt.accepted": "受け入れ済み",
"stt.activity30": "アクティビティ（過去30日間）",
"stt.ai6mo": "過去6ヶ月 · 受け入れ済み = 自動マッチ + 確認済み。",
"stt.aiEmpty": "この期間中にAIマッチはありません。",
"stt.aiTitle": "AIマッチ — 受け入れ済みと拒否",
"stt.auctionShort": "オークション",
"stt.auctionedSold": "オークションされた（販売済み）",
"stt.authShort": "権限",
"stt.authorities": "権限に引き渡されました",
"stt.avgRating": "平均評価",
"stt.awaitingRestitution": "返却を待っているアイテム",
"stt.boostClicks": "今週のディレクトリへのクリック数（ブースト効果）",
"stt.boostInactive": "ブーストは無効です — 可視性を得るために有効にしてください",
"stt.certifiedPremium": "プレミアム認証済み",
"stt.declarations": "申告",
"stt.destroyed": "破棄済み",
"stt.dispoEmpty": "保管庫から出た未請求アイテムはありません。",
"stt.donatedAssoc": "寄付済み（慈善）",
"stt.donatedShort": "寄付済み",
"stt.gateCta": "プランを確認する",
"stt.gateDesc": "スタータープランにアップグレードして基本統計を解除するか、ビジネスプランで高度な統計と店舗別分析を利用してください。",
"stt.gateTitle": "有料プラン専用の統計",
"stt.inStorage": "保管中",
"stt.kItems": "登録済みアイテム",
"stt.kRate": "返却率",
"stt.kRestituted": "返却されたアイテム",
"stt.kRevenue": "収益（今月）",
"stt.noDeclYet": "まだ申告はありません。",
"stt.recapDownloaded": "レポートがダウンロードされました — 共有準備完了！",
"stt.recapError": "レポートの生成に失敗しました",
"stt.recapText": "私たちのfindloop {year} レポート：返却されたアイテムと顧客満足度 🎉",
"stt.recapTitle": "Findloop {year} レポート",
"stt.rejected": "拒否されました",
"stt.restitutions": "返却",
"stt.shareRecap": "私の{year}レポートを共有",
"stt.topCategories": "最も申告されたカテゴリ",
"stt.unclaimedDesc": "カテゴリ別の破棄アイテム、慈善団体への寄付、およびオークションのボリューム。",
"stt.unclaimedTitle": "未請求アイテム — 保管から出ます",
"stt.vsLastWeek": "対先週",
"sub.cancel": "サブスクリプションをキャンセル",
"sub.cancelAbort": "キャンセル",
"sub.cancelConfirm1": "本当にキャンセルしてもよろしいですか？ あなたのアクセスは、まで有効です",
"sub.cancelConfirm2": "返金は行われません。",
"sub.cancelConfirmBtn": "キャンセルを確認",
"sub.cancelTitle": "サブスクリプションをキャンセル",
"sub.cancelledToast": "キャンセルが記録されました。",
"sub.cguAnd": "および",
"sub.cguDesc": "お支払い前に同意を確認してください。",
"sub.cguLink": "利用規約",
"sub.cguPay": "お支払いを続ける",
"sub.cguPre": "私は利用規約を読み、同意します",
"sub.cguRequired": "続行するには利用規約とプライバシーポリシーを受け入れる必要があります。",
"sub.cguSuffix": "Findloopの。",
"sub.cguTitle": "サブスクリプションを最終確定",
"sub.expiresOn": "サブスクリプションは、に期限切れになります",
"sub.noProrata": "プロラタ返金はありません。",
"sub.privacyLink": "プライバシーポリシー",
"sub.renewsOn": "サブスクリプションは、に更新されます",
"sub.resume": "再購読",
"sub.resumedToast": "再購読が確認されました。",
"tier.free": "フリーミアム",
"tier.large": "エンタープライズ",
"tier.medium": "ビジネス",
"tier.small": "スターター",
"tm.add": "追加",
"tm.adminOpt": "管理者（全表示）",
"tm.chooseEst": "店舗を選択",
"tm.chooseEstPh": "施設を選択",
"tm.copyFail": "コピーに失敗しました",
"tm.copyLink": "リンクをコピー",
"tm.copyOk": "招待リンクがコピーされました",
"tm.emailHint": "パスワードを作成するための招待メールが送信されます。",
"tm.expiresOn": "期限は {date} です",
"tm.forEmail": " {email} 用",
"tm.forbidden": "チーム管理はアカウント所有者のみに制限されています。",
"tm.inviteCreated": "招待が作成されました",
"tm.inviteDesc": "招待メールにより、チームメンバーはパスワードを作成できます。",
"tm.invitePending": "保留中の招待",
"tm.inviteResent": "招待が再送信されました",
"tm.inviteSent": "招待がメールで送信されました",
"tm.inviteTitle": "メンバーを招待",
"tm.invitedOn": "{date} に招待されました",
"tm.linkExpired": "リンクが期限切れです",
"tm.memberRemoved": "メンバーが削除されました",
"tm.name": "名前",
"tm.noMembers": "まだチームメンバーはいません。",
"tm.resendTitle": "招待状を再送信",
"tm.role": "役割",
"tm.roleAdmin": "管理者",
"tm.roleOwner": "オーナー",
"tm.roleStaff": "スタッフ",
"tm.roleUpdated": "役割が更新されました",
"tm.sendInvite": "招待を送信",
"tm.sending": "送信中…",
"tm.staffOpt": "スタッフ（自分の施設のみ閲覧）",
"trk.carrier": "運送業者",
"trk.shipPending": "出荷準備中 — 送信されたら追跡番号がここに表示されます。",
"trk.shipTitle": "出荷追跡",
"trk.trackShipment": "荷物を追跡",
"trk.trackingNo": "追跡番号",
"a.firstName": "名",
"ac.emailCrossMatch": "B2C クロスマッチ",
"ac.emailCrossMatchDesc": "公共の紛失物広告があなたの施設に預けられたアイテムと一致した際にメールが届きます",
"ac.emailCrossReject": "公共マッチ拒否",
"ac.emailCrossRejectDesc": "顧客が提案された公共マッチが自分のアイテムではないと示した場合にメールを受け取ります。",
"ac.emailLoginNotif": "ログイン通知",
"ac.emailLoginNotifDesc": "誰かがあなたのアカウントにログインするたびにメールを受け取ります。",
"ad.closeNoCancel": "いいえ、リストを削除",
"ad.closeQuestion": "アイテムは返却されましたか？",
"ad.closeQuestionDesc": "アイテムが回復されたか、単にこのリストを削除したいかをお知らせください。",
"ad.closeYesRestituted": "はい、アイテムは返却されました",
"ad.closedRestituted": "アイテムが返却されました — リストは閉じられました 🎉",
"an.lostLoginDesc": "紛失物を報告し、その返却を追跡するにはアカウントが必要です。",
"an.lostLoginRequired": "紛失物を報告するためにログイン",
"an.qfAll": "すべて",
"an.qfBoosted": "ブーストされた",
"an.qfPhoto": "写真あり",
"an.qfRecent": "今週",
"an.qfResolved": "解決済み",
"an.restitutionInProgress": "アイテムが返却中",
"dec.descPhLong": "アイテムの説明：ブランド、色、特徴的な印…（詳細を多く提供するほど、アイテムを回収できる可能性が高くなります）",
"dec.loadError": "現在、パートナーを読み込めません。接続を確認して再試行してください。",
"dec.retry": "再試行",
"dec.shippingMode": "配送",
"dep.photo2": "2番目のアイテム写真",
"dep.photo2Hint": "オプション — 別の角度は視覚的なマッチング精度を向上させます。",
"dl.accountSuspended": "未払いの請求書によりアカウントが一時停止されました。アクセスを復元するには清算してください。",
"dl.regularize": "今すぐ清算 →",
"dl.suspensionCountdown": "請求書 {num} が未払いです — あなたのアカウントは {days} 日以内に一時停止されます。これを避けるために清算してください。",
"ft.cancelConfirm": "レポートをキャンセルしますか？アイテムの所有者に通知されます。",
"ft.cancelDone": "レポートがキャンセルされました。",
"ft.cancelLocked": "所有者が支払った後はキャンセルは不可能です。",
"ft.cancelReport": "私のレポートをキャンセル",
"ft.claimCodeHelp": "このコードを引き渡し時に発見者に渡して、アイテムを受け取ったことを確認してください。",
"ft.claimCodeTitle": "あなたの返却コード",
"ft.claimDone": "アイテムが返却されました。findloopを利用していただきありがとうございます！",
"ft.claimUnlockHint": "発見者の連絡先情報を解除",
"ft.claimUnlockHintSub": "アカウントの「請求中のアイテム」に移動して、手数料を支払い連絡先情報を取得してください。",
"ft.finderCodeShownHelp": "所有者が支払いを完了し、あなたを選択しました。このコードを下にコピーして返却を確認してください — メールを確認する必要はありません。",
"ft.finderCodeShownTitle": "所有者の検証コード",
"ft.finderContactsTitle": "ファインダーの連絡先情報",
"ft.foundCodeHelp": "このコードを所有者に示して、アイテムが返却されたことを確認してください。",
"ft.inProgressOther": "返却されるアイテム",
"ft.inProgressOtherHelp": "所有者がこのアイテムの別のファインダーを選択しました。あなたの側でのさらなるアクションは必要ありません。",
"ft.restitutionCodeHelp": "このコードはアイテムの引き渡しを確認します。下に既に入力されていますので、確認してからケースを閉じてください。",
"ft.restitutionCodeTitle": "あなたの補償コード",
"hc.14Digits": "14桁",
"hc.15DaysBeforeAnItem": "アイテムの法的期限の15日前。",
"hc.7DaysBeforeAnItem": "アイテムの法的期限の7日前。",
"hc.8CharactersMinimum": "最低8文字。",
"hc.aClaimToValidate": "確認する請求",
"hc.aFindoAssistanceSessionIs": "現在、あなたのアカウントでファインダーの支援セッションがアクティブです。",
"hc.aNewMatchHasBeen": "新しいマッチが見つかりました",
"hc.aUser": "ユーザー",
"hc.aUserClaimsToBe": "ユーザーが所有者を名乗っています。返却を承認する前に彼らの回答を確認してください。",
"hc.aboutFindo": "ファインダーについて",
"hc.accountActivatedPleaseLogIn": "アカウントが有効化されました。ログインしてください。",
"hc.accountActivation": "アカウントの有効化",
"hc.accountCreated": "アカウントが作成されました！",
"hc.accountDeactivatedAReactivationEmail": "アカウントが無効化されました。再有効化メール（30日間有効）が送信されました。",
"hc.accountReactivation": "アカウントの再有効化",
"hc.activateMyAccount": "アカウントを有効化する",
"hc.activateMyAdminAccount": "管理アカウントを有効化する",
"hc.activating": "有効化中…",
"hc.activeMatchCancelReason": "アクティブなマッチ。顧客のキャンセル理由: \"{reason}\"。アイテムはまだ請求を待っています。",
"hc.activeMatchWithAPublic": "公開リスト（顧客）のあるアクティブなマッチ。所有者の請求を待っています。",
"hc.addAPhoto": "写真を追加",
"hc.addAndConfigureYourEstablishments": "\"施設\"にあなたの施設を追加して設定してください: 連絡先情報、カテゴリ、およびアイテムの物理的保管。",
"hc.addOnGoogle": "Googleに追加",
"hc.address": "住所",
"hc.addressSaved": "住所が保存されました",
"hc.addressStreet": "住所 — 通り",
"hc.adjustThePhoto": "写真を調整",
"hc.adminFullView": "管理者（フルビュー）",
"hc.administratorOnly": "管理者のみ",
"hc.africa": "アフリカ",
"hc.aiVisualComparison": "AIビジュアル比較",
"hc.all": "すべて",
"hc.amount": "金額",
"hc.anOrganization": "組織",
"hc.analyzing": "分析中…",
"hc.andRecoveryIs": "および回復は",
"hc.andTheDeclarationWillBe": "および申告は閉じられます（履歴に移動）。このアクションは最終です。",
"hc.annual20": "年間 -20%",
"hc.annualBilling20": "年会費（−20%）",
"hc.annualTarget": "年間目標",
"hc.anyCommentsOptional": "コメントはありますか？（任意）",
"hc.approveTheClaim": "請求を承認",
"hc.archiveCancelledConfirm": "{n} 件のリスト「顧客によってキャンセル」をアーカイブしますか？レジストリから削除されます。",
"hc.asSoonAs": "できるだけ早く",
"hc.askTheOwnerToDisplay": "オーナーにコードのQR（追跡ページ）を表示するよう依頼します。",
"hc.askThemAtTheCounter": "カウンターで本人確認を依頼してください — 公に表示されることはありません。",
"hc.assistance": "サポート",
"hc.assistanceSessionRevoked": "サポートセッションが取り消されました。",
"hc.atLeast6Characters": "6文字以上",
"hc.automaticallyPreSelected": "自動的に事前選択されました",
"hc.automaticallyWhenShipping": "発送時に自動的に。",
"hc.awaitingClaim": "請求を待機中",
"hc.awaitingPayment": "支払いを待機中",
"hc.b2cCustomer": "B2C顧客",
"hc.back": "戻る",
"hc.backToHome": "ホームに戻る",
"hc.backToMyAccount": "マイアカウントに戻る",
"hc.backToPayment": "支払いに戻る",
"hc.beforeAfterComparisonSlider": "ビフォー/アフター比較スライダー",
"hc.billingInformation": "請求情報",
"hc.billingInformationSaved": "請求情報が保存されました ✓",
"hc.brand": "ブランド",
"hc.bronze": "ブロンズ",
"hc.calculatingTheShippingRate": "送料を計算中…",
"hc.cameraUnavailableEnterTheCode": "カメラが使用できません。コードを手動で入力してください。",
"hc.cancel": "キャンセル",
"hc.cancelMyDeclaration": "私の申告をキャンセル",
"hc.cancelSavedFmt": "キャンセルが保存されました：「{reason}」。まだ請求できます。",
"hc.cancelTheDeposit": "預金をキャンセル",
"hc.cancelThisMatch": "このマッチをキャンセル",
"hc.cancellationReason": "キャンセル理由",
"hc.cancelled": "キャンセルされました",
"hc.cancelledByTheCustomer": "顧客によってキャンセルされました",
"hc.cannotOpenPayment": "支払いを開けません。もう一度お試しください。",
"hc.careers": "キャリア",
"hc.carrier": "キャリア",
"hc.carrierAvailabilityCannotBeChecked": "キャリアの可用性は、Sendcloudの送信者が設定されるまで確認できません。",
"hc.carrierConfirmedCharged": "キャリアが確認しました — {price} € が顧客に課金されました",
"hc.carrierOther": "キャリア (その他)",
"hc.carrierSelection": "キャリアの選択",
"hc.caseClosedThankYou": "ケースが閉じました。ありがとうございます！",
"hc.category": "カテゴリ",
"hc.changeMethod": "方法を変更",
"hc.characteristic": "特徴",
"hc.chargedToCustomer": "顧客に課金されます。",
"hc.checkOrEditYourDetails": "安全な支払いの前に、詳細を確認または編集してください。",
"hc.checkStatisticsToTrackDeposited": "「統計」を確認して、預けられたアイテム、返品率、および各施設のパフォーマンスを追跡してください。",
"hc.checkTheDetailsBeforeContacting": "ファインダーに連絡する前に、詳細を確認してください。",
"hc.checkTheDetailsBelowBefore": "返品リクエストを開始する前に、以下の詳細を確認してください。",
"hc.checkTheNewItem": "新しいアイテムを確認",
"hc.checkThePhotosAndCharacteristics": "回収を進める前に、以下の写真と特徴を確認してください。",
"hc.chooseACountry": "国を選択",
"hc.chooseANewPassword": "新しいパスワードを選択",
"hc.chooseAReason": "理由を選択",
"hc.chooseTheLegalRetentionAlerts": "以下についてメールで受け取る法的保持アラートを選択",
"hc.chooseYourPasswordToAccess": "管理コンソールにアクセスするためのパスワードを選択してください。",
"hc.city": "市",
"hc.claimApproved": "請求が承認されました",
"hc.claimApproved2": "請求が承認されました。",
"hc.claimCodeExpired": "請求コードが期限切れ",
"hc.claimCodeVerified": "請求コードが確認されました",
"hc.claimNotFound": "請求が見つかりません",
"hc.claimNotValidated": "請求が検証されていません",
"hc.claimRejected": "請求が拒否されました",
"hc.claimRejected2": "請求が拒否されました。",
"hc.claimValidated": "請求が検証されました",
"hc.claimValidatedByThePartner": "請求がパートナーによって検証されました",
"hc.claimant": "請求者",
"hc.claimsToBeTheOwner": "このアイテムの所有者を主張し、確認質問に回答しました。答えが一致する場合のみ承認してください。",
"hc.claimsToValidate": "検証する請求",
"hc.clear": "クリア",
"hc.clickToZoom": "クリックしてズーム",
"hc.close": "閉じる",
"hc.close2": "閉じる",
"hc.closeTheDeclaration": "宣言を閉じる",
"hc.closeTheDeclaration2": "宣言を閉じますか？",
"hc.codeAlreadyVerified": "コードは既に確認済み",
"hc.codeCopied": "コードがコピーされました",
"hc.collapse": "折りたたむ",
"hc.color": "色",
"hc.company": "会社",
"hc.companyName": "会社名",
"hc.comparePhotos": "写真を比較する",
"hc.compareThemWithTheOwner": "所有者の回答と比較してください — 公開されません。",
"hc.condition": "状態",
"hc.confirmAndPay": "確認して支払う",
"hc.confirmCancellation": "キャンセルを確認する",
"hc.confirmCrop": "トリミングを確認する",
"hc.confirmDeletion": "削除を確認する",
"hc.confirmPassword": "パスワードを確認する",
"hc.confirmThatThisIsYour": "これがあなたのアイテムであることを確認してください。連絡を取る前に、発見者に本人確認が求められます。",
"hc.confirmTheCarrier": "運送業者を確認する",
"hc.confirmThePassword": "パスワードを確認する",
"hc.confirmYourShippingAddressTo": "支払いを続けるために、あなたの配送先住所を確認してください。",
"hc.confirmYourSubscription": "購読を確認する",
"hc.confirmed": "確認済み ✓",
"hc.contactFindoToGetYour": "Sender IDを取得するにはFindloopに連絡してください。",
"hc.contactUs": "お問い合わせ",
"hc.continueTheReturn": "返品を続ける",
"hc.continueToPayment": "支払いに進む",
"hc.copy": "コピー",
"hc.correctMyDetails": "私の詳細を修正する",
"hc.correctThisEntry": "このエントリーを修正しますか？",
"hc.country": "国",
"hc.countryAddress": "国（住所）",
"hc.countryIsoCodeEG": "国（ISOコード、例：FR）",
"hc.cover": "カバー",
"hc.createTheShipment": "発送を作成する",
"hc.cropThePhoto": "写真をトリミングする",
"hc.customer": "顧客",
"hc.customerClaimCodeToCheck": "顧客請求コード — 受け取り時に確認：",
"hc.customerReasonFmt": "顧客の理由: \"{reason}\"。",
"hc.customerReminderDelay": "顧客リマインダーの遅延",
"hc.customerWhosePublicListingMatches": "このアイテムに一致する公開リストを持つ顧客 — あなたにのみ表示されます。",
"hc.d15": "D-15",
"hc.dangerZone": "危険ゾーン",
"hc.date": "日付",
"hc.dateNewest": "日付（最新）",
"hc.dateOldest": "日付（最古）",
"hc.daysToYearEnd": "年末まであと{n}日",
"hc.deadlineAlert": "締切アラート",
"hc.declarationClosed": "申告完了 ✓",
"hc.declarationNotFound": "申告が見つかりません。",
"hc.declarationNotFound2": "申告が見つかりません",
"hc.declarationTracking": "申告追跡",
"hc.defaultCarrier": "デフォルト配送業者",
"hc.defaultCarrierPreselected": "デフォルト配送業者が事前選択されています — この配送のために変更可能です。実際の料金（Sendcloud + {m}% マージン）。",
"hc.defaultCarrierRemoved": "デフォルト配送業者が削除されました",
"hc.delayHours": "遅延（時間）",
"hc.deleteMyAccount": "アカウントを削除",
"hc.deleting": "削除中…",
"hc.deletingDeactivatesYourAccountLogin": "削除するとアカウントが無効化されます：ログインがブロックされ、データは30日間保持されます。30日間有効な再活性化リンクが記載されたメールが届きます。",
"hc.delivered": "配達完了",
"hc.depositAnItem": "アイテムを預ける",
"hc.depositCancelledItemPutBack": "預け入れキャンセル — アイテムは在庫に戻りました。",
"hc.depositCancelledItemRemovedFrom": "預け入れキャンセル — アイテムは名簿から削除されました。",
"hc.depositedOn": "預け入れ日",
"hc.describeTheItemBrandColor": "アイテムを説明してください：ブランド、色、特徴的なマーク…（詳細を多く提供するほど、アイテムを見つける可能性が高くなります）",
"hc.dimensionsCm": "寸法（cm）",
"hc.disablingAnEmail": "メールを無効化中",
"hc.doesNotHide": "隠れません",
"hc.download": "ダウンロード",
"hc.downloadThePdf": "PDFをダウンロード",
"hc.draftRestoredPickUpYour": "ドラフトが復元されました — 前回の申告を続行してください。",
"hc.dragToReposition": "ドラッグして移動",
"hc.eGColisPriv": "例：Colis Privé",
"hc.eachItemGetsAQr": "各アイテムにはQRラベルが付与されます。「ストレージ & QR」からスキャンして、アイテムを瞬時に見つけてください。",
"hc.eachSiteManagesItsOwn": "各サイトが独自の銀行を管理します。行くには",
"hc.edit": "編集",
"hc.emailNotificationPreferences": "メール通知の設定",
"hc.emailPreferencesUpdated": "メール設定が更新されました",
"hc.enableOrDisableRecoveryFees": "回収手数料を有効または無効にする",
"hc.enlargePhoto": "写真を拡大",
"hc.enterTheCustomerSCode": "顧客のコードを入力してください",
"hc.estShipRate": "予想配送料（Sendcloud + {m}% マージン）：",
"hc.establishment": "設立",
"hc.establishment2": "設立：",
"hc.establishmentInItsSendcloudAccount": "Sendcloudアカウントにおける設立と送信者IDを提供します",
"hc.establishmentSettings": "設立設定",
"hc.exCode": "例：ABCD2345",
"hc.exId": "例：3f2a…",
"hc.exit": "終了",
"hc.explainWhyThisItemIs": "このアイテムがあなたのものでない理由を説明してください…",
"hc.externalPaymentLinks": "外部支払いリンク",
"hc.failed": "失敗",
"hc.feesEnabled": "手数料有効",
"hc.field": ") フィールド。",
"hc.finderAcceptedCloseTheCase": "ファインダーが受理 - アイテムが対面で引き渡されたらケースを終了します。",
"hc.findoCityRanking": "Findloop — 都市ランキング",
"hc.findoForEstablishments": "設立向けのfindloop",
"hc.findoPresentationVideo": "findloopプレゼンテーション動画",
"hc.findoRegistersTheAddressOf": "Findloopがあなたのの住所を登録します",
"hc.findoReviewShare": "Findloop {year} レビュー：{n} アイテム返却、{rate}% 返却率 🎉",
"hc.firstVerifyTheClaimCode": "まず、上記の請求コードを確認してください",
"hc.forEveryNewShipmentFrom": "からの新しい発送ごとに",
"hc.free": "無料",
"hc.freeRecovery0": "無料回収（0 €）",
"hc.freeRecoveryAcrossAfricaLaunch": "アフリカ全域での無料回収 – 発売オファー",
"hc.freeRecoveryFeesDisabled0": "無料回収：手数料無効（0 €）",
"hc.fromTeamInviteYourColleagues": "\"チーム\" から、同僚をメールで招待して設立を割り当ててください。各メンバーは自分の範囲のみを確認できます。",
"hc.fullName": "フルネーム",
"hc.fullPhoto": "全体の写真",
"hc.gallery": "ギャラリー",
"hc.giveTheReasonForCancelling": "キャンセルの理由を教えてください。パートナーに通知されます。",
"hc.goToLogin": "ログインへ進む",
"hc.goToMyAccount": "マイアカウントへ進む",
"hc.gold": "ゴールド",
"hc.googleLoginFailed": "Googleサインインに失敗しました",
"hc.hasConfirmedYourPaymentYou": "があなたの支払いを確認しました。自動的にリダイレクトされます",
"hc.helpCenter": "ヘルプセンター",
"hc.helpUsImproveWhyAre": "改善のためにお手伝いください：なぜ去っていますか？ あなたのアカウントは無効化され、30日間再活性化可能です。",
"hc.hidePassword": "パスワードを隠す",
"hc.high": "高",
"hc.historyOfYourMonthlySubscriptions": "あなたの月額サブスクリプションの履歴とその支払い状況。",
"hc.hotelBelmont": "ホテルベルモント",
"hc.howConfigureSenderId": "数値の送信者IDをどう設定しますか？",
"hc.iDonTUseIt": "あまり使っていません",
"hc.iFoundItElsewhere": "他で見つけました",
"hc.iNoLongerNeedMy": "もうアイテムは必要ありません",
"hc.identityVerification": "本人確認",
"hc.idleLogoutIn": "非アクティブのため、{n}秒後にログアウトされます。",
"hc.ifProvidedTheVolumetricWeight": "提供された場合、体積重量が使用されます。",
"hc.ifThePartnerHasNot": "パートナーがこの遅延後に外部支払いの受領を確認していない場合、Findloopは自動的にパートナーに検証をリマインドします。",
"hc.impersonationEnded": "なりすましが終了しました。",
"hc.impersonationMode": "なりすましモード",
"hc.impersonationSessionExpired": "なりすましセッションの期限が切れました。",
"hc.inTheField": "、現場で",
"hc.inTransit": "輸送中",
"hc.inclVat": "VAT込み",
"hc.intraEuVatNumberOptional": "EU内VAT番号は任意、SIRETは不要です（フランス以外）。",
"hc.invalidInvitationLink": "無効な招待リンクです。",
"hc.invalidInvitationLink2": "無効な招待リンク",
"hc.invalidInviteLink": "無効または期限切れの招待リンクです。",
"hc.invalidNumberEnterAnInternational": "無効な番号です。国際番号を入力してください。例：+33 6 12 34 56 78。",
"hc.invalidOrExpiredLink": "無効または期限切れのリンクです。",
"hc.invalidOrExpiredReactivationLink": "無効または期限切れの再活性化リンク",
"hc.invalidSendcloudId": "無効なSendcloud ID",
"hc.inviteSubtitle": "{org}があなたをfindloopチームに招待しています。アカウントを有効にするためにパスワードを選んでください。",
"hc.isAvailableOnSendcloudFor": "すべてのルート（国内 + 国際）でSendcloudで利用可能です。",
"hc.isNotEnabledOnYour": "いくつかの目的地では、あなたのSendcloudアカウントで有効になっていません。それらのラベルは別の利用可能なキャリアで生成されます。",
"hc.isThisReallyYourItem": "これは本当にあなたのアイテムですか？",
"hc.isThisYourItem": "これはあなたのアイテムですか？",
"hc.item": "アイテム",
"hc.itemAlreadyConfirmed": "アイテムはすでに確認されています",
"hc.itemDetails": "アイテムの詳細",
"hc.itemFoundAt": "アイテムはここで見つかりました",
"hc.itemFoundAtAPartner": "アイテムはパートナーで見つかりました",
"hc.itemMarkedAsReturned": "アイテムは返却済みとしてマークされました✓",
"hc.itemPhotoRequiredBeforeShipping": "アイテムの写真（出荷前に必須）",
"hc.itemPhotoSaved": "アイテムの写真が保存されました",
"hc.itemPreview": "アイテムのプレビュー",
"hc.itemPutBackInStorage": "アイテムは収納に戻されました。",
"hc.itemWeight": "アイテムの重量:",
"hc.itemsReturned": "アイテム(s)が返却されました",
"hc.itemsReturnedThisYear": "今年返却されたアイテム",
"hc.itemsWhoseLegalDeadlineIs": "法的期限が15日以内のアイテム（延滞も含む）。マッチは表示されたままです。",
"hc.kbisNumber": "Kbis番号",
"hc.keysForgottenOnABench": "ベンチに忘れた鍵",
"hc.labelBeingGenerated": "ラベルを生成中",
"hc.leaveTheFieldsEmptyTo": "フィールドを空にすると、無料で回収を提供できます。",
"hc.legalNotice": "法的通知",
"hc.limitReachedUpgradeToA": "制限に達しました — より高いプランにアップグレードしてください",
"hc.linkCopiedShareOn": "リンクがコピーされました — {label} で共有してください",
"hc.linkUnavailable": "リンクは利用できません",
"hc.linkedTo": "リンクされています",
"hc.listingHiddenByModeration": "掲載はモデレーションによって非表示です。",
"hc.loading": "読み込み中…",
"hc.locateMe": "私を探す",
"hc.logIn": "ログイン",
"hc.logInToGetBack": "ログインして、スペースに戻り、サブスクリプションを管理してください。",
"hc.loginFailed": "ログインに失敗しました",
"hc.lostFoundPlatform": "紛失物および発見物プラットフォーム。",
"hc.lostIn": "紛失場所",
"hc.lowRate": "低料金",
"hc.mainReason": "主な理由",
"hc.mainStreet": "メインストリート",
"hc.makeSureThisIsThe": "発見者の連絡先詳細を解除する前に、これが失くしたアイテムであることを確認してください。",
"hc.manageCookies": "クッキーを管理",
"hc.manageMyTeam": "私のチームを管理",
"hc.manageYourTeam": "あなたのチームを管理",
"hc.markAsReturned": "返却済みとしてマーク",
"hc.matchNoClaimInTime": "マッチは期限内に請求がありませんでした。",
"hc.matchNotFound": "マッチが見つかりません",
"hc.medium": "中程度",
"hc.milestoneFmt": "{m} 件の返却アイテムのマイルストーンに達しました！次は {next} へ進みます。",
"hc.missingFeatures": "機能が不足しています",
"hc.monthly": "月額",
"hc.monthlyBilling": "月額請求",
"hc.moveThePhotoToFit": "写真を移動して円の中に収めてください。",
"hc.myAccount": "マイアカウント",
"hc.myInvoices": "マイ請求書",
"hc.myMonthlyInvoices": "マイ月額請求書",
"hc.nArchived": "{n} 件のリスティングがアーカイブされました。",
"hc.newCodeGeneratedAndSent": "新しいコードが生成され、お客様にメールとSMSで送信されました",
"hc.newCodeGeneratedAndSent2": "新しいコードが生成され、オーナーに送信されました",
"hc.newPassword": "新しいパスワード",
"hc.next": "次へ",
"hc.nextPhoto": "次の写真",
"hc.no": "いいえ",
"hc.noAnswerProvided": "回答が提供されていません。",
"hc.noArchivedDeclarations": "アーカイブされた申告はありません",
"hc.noCountryFound": "国が見つかりません",
"hc.noDeclarations": "申告はありません",
"hc.noFeesAreChargedTo": "お客様には料金は請求されません。",
"hc.noInvoiceYet": "まだ請求書はありません。",
"hc.noInvoiceYetYourInvoices": "まだ請求書はありません。お客様の請求書は、各支払い後に自動的にここに表示されます。",
"hc.noMatchIsAvailableFor": "現在利用可能な一致はありません。お客様の申告に一致するアイテムが見つかり次第お知らせします。",
"hc.noShipmentMatchesYourSearch": "お客様の検索に一致する出荷はありません。",
"hc.noShipmentsYet": "まだ出荷はありません。",
"hc.noShipmentsYet2": "まだ出荷はありません",
"hc.none": "なし",
"hc.noneChooseForEachShipment": "なし（各出荷について選択）",
"hc.notMine": "私のではありません",
"hc.of": "の",
"hc.only": "のみ",
"hc.onlyEachSiteManagesIts": "のみ。各サイトはそれぞれの銀行を管理します：これらのリンクは他の施設には影響しません。",
"hc.onlyTheOwnerOrAn": "オーナーまたは管理者のみが施設の支払いリンクを設定できます。",
"hc.openDepositInTheMenu": "メニューの「預金」を開き、アイテムを説明し、写真を撮影してください。すぐに保存され、返却の準備が整います。",
"hc.openSettings": "設定を開く →",
"hc.openTheDeclarationToManage": "出荷を管理するための申告を開く",
"hc.optional": "— オプション",
"hc.optional2": "(オプション)",
"hc.optional3": "オプション",
"hc.originalListingPhotoUsed": "元のリスティング写真が使用されました",
"hc.other": "その他",
"hc.other2": "その他…",
"hc.ourProducts": "私たちの製品",
"hc.overallRateTrendLast6": "全体的な料金傾向（過去6ヶ月）",
"hc.ownerSClaimCode": "オーナーのクレームコード",
"hc.ownershipConfirmed": "所有権が確認されました",
"hc.paid": "支払い済み",
"hc.paidOn": "支払い日",
"hc.paidViaPartner": "パートナー経由で支払われました",
"hc.parcelBeingPrepared": "荷物を準備中",
"hc.parcelDelivered": "荷物が配達されました",
"hc.parcelShipped": "荷物が発送されました",
"hc.parisGareDeLyon": "パリ、リヨン駅…",
"hc.partner": "パートナー",
"hc.partner2": "パートナー",
"hc.partnerDirectory": "パートナーのディレクトリ",
"hc.passedOnToTheCustomer": "— お客様の支払いリンクに転送されました。",
"hc.password": "パスワード",
"hc.passwordResetPleaseLogIn": "パスワードをリセットしました。ログインしてください。",
"hc.passwordUpdated": "パスワードが更新されました。",
"hc.passwordsDoNotMatch": "パスワードが一致しません。",
"hc.pasteThisSenderIdIn": "この送信者IDをFindloop → 設定に貼り付けてください",
"hc.payForTheShipmentOf": "findloopを通じてアイテムの配送代金を安全に支払ってください。",
"hc.payTheRecoveryFees": "回収手数料を支払う",
"hc.payTheShippingFees": "送料を支払う",
"hc.payment": "支払い",
"hc.paymentAlreadyConfirmedByThe": "支払いはパートナーによってすでに確認されています",
"hc.paymentLinksAreNowConfigured": "支払いリンクは各店舗ごとに設定されました",
"hc.paymentNotCompletedYourAccount": "支払いが完了していません。アカウントは作成されていません — もう一度お試しください。",
"hc.paymentReceived": "支払いを受け取りました",
"hc.paymentSuccessful": "支払い完了！",
"hc.pdfInvoice": "PDF請求書",
"hc.pending": "保留中",
"hc.period": "期間",
"hc.phoneNumber": "電話番号",
"hc.phoneOptional": "電話（オプション）",
"hc.planAt": "プランで",
"hc.planLimitFmt": "あなたの「{plan}」プランは最大{max}の店舗に制限されています。{n}のサイトを管理するには、",
"hc.platformReturnTarget": "プラットフォームの返却ターゲット",
"hc.pleaseCompleteYourShippingAddress": "お届け先住所を完成させてください。",
"hc.pleaseProvideAPhoneNumber": "電話番号を提供してください：配送のためにキャリアが必要としています。",
"hc.pleaseProvideAReason": "理由を提供してください。",
"hc.pleaseSetYourOwnPassword": "続行する前に、自分のパスワードを設定してください。",
"hc.pointsToGoal": "{n}ポイントで私たちの共有目標に到達します。",
"hc.posterPreview": "ポスターのプレビュー",
"hc.potentialMatchBeingVerified": "潜在的な一致を確認中",
"hc.potentialOwner": "潜在的な所有者",
"hc.preFilledAutomaticallyYouCan": "自動的に入力されました — 荷物の写真に置き換えることができます。",
"hc.pressKit": "プレスキット",
"hc.previewMode": "プレビュー モード:",
"hc.previewOfThePrintReady": "この施設の印刷可能なA4ポスターのプレビュー。",
"hc.previous": "前",
"hc.previousPhoto": "前の写真",
"hc.primary": "主な",
"hc.printThePoster": "ポスターを印刷",
"hc.privacy": "プライバシー",
"hc.privacyPolicy": "プライバシーポリシー",
"hc.processedCasesWillAppearHere": "処理されたケースはここに表示されます。",
"hc.proofOfReturnPdf": "返却証明書 (PDF)",
"hc.protectedByRecaptcha": "reCAPTCHAによって保護されています",
"hc.publicMatch": "公共の一致",
"hc.putBackInStorage": "保管に戻す",
"hc.pwdResetByTeam": "あなたのパスワードは当社のチームによってリセットされました。あなたの安全のために、",
"hc.questionsToAskTheOwner": "オーナーに尋ねる質問",
"hc.rateChargedToTheCustomer": "顧客に請求される料金:",
"hc.rateOfTarget": "{rate}%は{target}%の目標に対して達成されました",
"hc.reached": "達成",
"hc.reactivating": "再アクティブ化中…",
"hc.reasonSavedYouCanStill": "理由が保存されました。アイテムをまだ請求できます。",
"hc.recentMatchesFirst": "最近の一致を優先",
"hc.recognizedThePhotoYouSent": "あなたが送信した写真を認識し、これらの特性を説明しました。一致する場合のみ確認してください。",
"hc.recommended": "推奨",
"hc.recoveryFees": "回収手数料",
"hc.recoveryFeesArePaidDirectly": "回収手数料はパートナー施設に直接支払われます。findloopは顧客からの支払いを受け取っていません。",
"hc.recoveryFeesEnabled": "回収手数料が有効",
"hc.recoveryOfferedByTheEstablishment": "施設が提供する回収 — findloopは手数料を請求しません。",
"hc.recoveryPaymentLink": "回収支払いリンク",
"hc.recoveryPaymentLinkSavedFor": "この施設のために保存された回収支払いリンク",
"hc.redirecting": "リダイレクト中…",
"hc.redirectingToPayment": "支払いへリダイレクト中…",
"hc.redirectingToTheRecoveryOf": "アイテムの回収にリダイレクト中…",
"hc.regenerateAndResendToThe": "再生成してオーナーに再送",
"hc.regenerateTheCode": "コードを再生成",
"hc.registerAFoundItem": "見つけたアイテムを登録",
"hc.rejectTheClaim": "請求を拒否",
"hc.reminderDelaySaved": "リマインダーの遅延が保存されました",
"hc.reopenThePaymentLink": "支払いリンクを再開",
"hc.repeatThePassword": "パスワードを再入力",
"hc.reportAProblem": "問題を報告する",
"hc.reportDismissedYourListingRemains": "報告は却下されました。あなたのリスティングは公開のままです。",
"hc.requiredUsedToCalculateThe": "必須：Sendcloudの送料を計算するために使用されます。30kgを超えると送料は利用できません。",
"hc.reset": "リセット",
"hc.resume": "再開",
"hc.resumeRegistration": "登録を再開",
"hc.retro": "今年の振り返り",
"hc.returnSecurity": "返送のセキュリティ",
"hc.returnToTheOwner": "所有者に返す",
"hc.returned": "返却済み",
"hc.reviewTheItemDetails": "アイテムの詳細を確認",
"hc.revokeAccess": "アクセスを取り消す",
"hc.role": "役割：",
"hc.save": "保存",
"hc.save2": "保存",
"hc.saveAndContinue": "保存して続行",
"hc.saving": "保存中…",
"hc.scanTheClaimCode": "請求コードをスキャン",
"hc.scanTheOwnerSQr": "所有者のQRをスキャン",
"hc.scrollThroughLanguages": "言語をスクロール",
"hc.searchByCustomerItemOr": "顧客、アイテム、または追跡番号で検索…",
"hc.searchForACountry": "国を検索…",
"hc.secureFindoVerification": "安全なfindloopの確認",
"hc.seeRetro": "今年の振り返りを見る",
"hc.selectedCarrier": "選択されたキャリア：",
"hc.selectedPlan": "選択したプラン",
"hc.send": "送信",
"hc.sendcloudSenderIdSaved": "Sendcloud送信者IDが保存されました",
"hc.sendcloudSenderIdSenderId": "Sendcloud送信者ID（sender_id）",
"hc.sending": "送信中…",
"hc.sessionExpired": "セッションが期限切れです",
"hc.setUpYourEstablishments": "あなたの施設を設定",
"hc.settings": "設定",
"hc.settingsSubtitle": "外部支払いとリマインダー、施設ごとに構成されています。",
"hc.shareFoundText": "アイテムを見つけました — findloopでその所有者を見つける手助けをしてください",
"hc.shareLostText": "アイテムを失いました — findloopで見つける手助けをしてください",
"hc.sharePreview": "プレビューを共有",
"hc.shareTheRanking": "ランキングを共有",
"hc.shareYourQrCodeTo": "申告を受け取るためにQRコードを共有",
"hc.shipRateAutoWeight": "送料は、発送時にSendcloudを介して自動的に計算されます（重量 {w}）。",
"hc.shipRateForWeight": "配送料金 (Sendcloud + {m}% マージン) は {w}:",
"hc.shipments": "出荷",
"hc.shipmentsSubtitle": "すべてのケースにおける店舗の出荷の統合ビューです。行をクリックして、申告内で出荷を管理します。",
"hc.shipping": "配送",
"hc.shippingAddress": "配送先住所",
"hc.shippingFeesAreHandledAutomatically": "配送料金は Findloop (Sendcloud) によって自動的に処理されます — 入力するリンクはありません。",
"hc.shippingFeesHaveAlreadyBeen": "配送料金はすでに支払われています: 運送業者は変更できません。",
"hc.shippingNotAvailableForItems": "30 kg を超えるアイテムの配送は利用できません。お客様が直接アイテムを受け取る必要があります。",
"hc.shippingPaid": "配送費用は支払い済み ✓",
"hc.showOnlyItemsMatchingA": "公開（顧客）リストに一致するアイテムのみ表示",
"hc.showPassword": "パスワードを表示",
"hc.signInTheBoxAbove": "上のボックスにサインイン",
"hc.signatureSaved": "署名が保存されました",
"hc.signedInWithGoogle": "Googleでサインイン済み",
"hc.signupFailed": "サインアップに失敗しました",
"hc.silver": "シルバー",
"hc.simulatedRatesInPreProduction": "(プリプロダクションでのシミュレーション料金)",
"hc.siretAndVatNumberRequired": "SIRET および VAT 番号が必要です（フランス）。",
"hc.skip": "スキップ",
"hc.smsSentIfAccount": "この番号のアカウントが存在する場合、SMSをお送りしました。",
"hc.sortItemsWithAPublic": "ソート: 公開マッチのアイテム (最近のもの) を最初に表示",
"hc.specifyWhetherYouRecoveredYour": "アイテムを回収したか、単にこのリストを削除したいかを指定してください。",
"hc.specifyYourReason": "理由を指定してください",
"hc.specifyYourReason2": "理由を指定してください…",
"hc.staff": "スタッフ",
"hc.status": "ステータス",
"hc.staySignedIn": "サインインを維持",
"hc.step": "ステップ",
"hc.stillThere": "まだいますか？",
"hc.stopScrolling": "スクロールを停止",
"hc.storeFindWithQr": "QRで保存 & 検索",
"hc.streetName": "通りの名前",
"hc.streetNo": "通り番号",
"hc.switchTo": "切り替え",
"hc.switchToDarkMode": "ダークモードに切り替え",
"hc.switchToLightMode": "ライトモードに切り替え",
"hc.takeAPhoto": "写真を撮る",
"hc.takeChangeThePhoto": "写真を撮る / 変更する",
"hc.takenFromYourDeclaration": "あなたの申告から取得",
"hc.target": "ターゲット",
"hc.targetReached": "目標達成",
"hc.targetReachedThankYouTo": "目標達成 — findloopコミュニティ全体に感謝します！",
"hc.tellUsMore": "もっと教えてください…",
"hc.tellUsWhyYouCancel": "キャンセル理由を教えてください。これはパートナーがリクエストを処理するのに役立ちます。",
"hc.tellUsWhyYourListing": "理由を教えてください。あなたのリスティングはアクティブなままで、アイテムを引き続き請求できます。",
"hc.termsAndConditions": "利用規約",
"hc.termsAndPolicies": "利用規約とポリシー",
"hc.thankYouForYourFeedback": "フィードバックありがとうございます",
"hc.theBannerDisplayedInThe": "登録簿に表示されたバナー。",
"hc.theClaimantHasBeenInformed": "請求者に通知されました。アイテムは公共リストに引き続き利用可能です。",
"hc.theClaimantHasBeenNotified": "請求者に通知され、返却手続きに進むことができます。",
"hc.theCustomerPaysTheFees": "顧客が店舗に手数料を支払います。",
"hc.theDayTheLegalRetention": "法的保留期間に達した日。",
"hc.theEstablishmentConsideredThatThis": "店舗はこのアイテムはあなたのものではないと判断しました。",
"hc.theEstablishmentIsReviewingYour": "店舗はあなたの回答を確認しています。請求が承認され次第通知され、回収手数料を支払うことができます。",
"hc.theFeesAreTooHigh": "手数料が高すぎます",
"hc.theFinderConsideredThatThis": "発見者はこのアイテムはあなたのものではないと判断しました。",
"hc.theFinderIsReviewingYour": "発見者はあなたの請求を確認しています。承認され次第通知されます。",
"hc.theItem": "アイテム",
"hc.theItemWillBeRemoved": "アイテムは登録簿から削除されます（請求中ではありません）。",
"hc.theItemWillBeSet": "アイテムは「在庫あり」に戻され、関連する請求はキャンセルされます。",
"hc.theKbisNumberAndVat": "フランスではKbis番号とVAT番号が必要です。",
"hc.theLabelIsGeneratedAutomatically": "ラベルは顧客が送料を支払った後に自動的に生成されます。ここからダウンロードできます。",
"hc.theLinkMayHaveExpired": "リンクが期限切れかもしれません（30日間有効）。必要に応じてfindloopサポートにお問い合わせください。",
"hc.theOwnerDescribesTheirItem": "所有者がアイテムを説明します",
"hc.theOwnerReceivedItBy": "所有者はメール（またはSMS）で受け取りました。引き渡し前に入力またはスキャンしてください。",
"hc.thePartnerConsideredThatThis": "パートナーはこのアイテムはあなたのものではないと判断しました。アイテムは引き続き利用可能です。",
"hc.thePartnerIsReviewingYour": "パートナーはあなたの回答を確認しています。請求が承認され次第通知されます。",
"hc.theShipmentIsCreatedAutomatically": "発送は顧客が住所を確認し、回収手数料を支払った時点で自動的に作成されます。その後、送料の支払いが行われた後にラベルが自動生成され、ここからダウンロードできます。",
"hc.theShippingRateWillBe": "送料は発送時にSendcloudを通じて自動的に計算されます（記録された重量）。",
"hc.thisCarrierWillBe": "このキャリアは",
"hc.thisEstablishment": "この店舗",
"hc.thisFieldIsRequiredFor": "このフィールドは自動ラベル生成に必要です。",
"hc.thisIsMyItem": "これは私のアイテムです",
"hc.thisIsMyItemContinue": "これは私のアイテムです — 続ける",
"hc.thisIsMyItemStart": "これは私のアイテムです — 返却を開始する",
"hc.thisIsNotMyItem": "これは私のアイテムではありません",
"hc.thisMatchIsNoLonger": "このマッチはもはや利用できないか、すでに処理されています。",
"hc.thisRateWillBeCharged": "この料金は顧客に請求されます。高い料金は回収を妨げる可能性があります。",
"hc.thisStepIsRequiredFor": "このステップは発送ラベルの生成に必要です。",
"hc.thisValidationLinkIsInvalid": "この検証リンクは無効か、期限が切れています。",
"hc.toCheckBeforeMarkingThe": "アイテムを返却済みとしてマークする前に確認してください。",
"hc.toConfigureTheLinksAnd": "各施設のリンクとリマインダー遅延を設定するために。",
"hc.toReachOurFirstMilestone": "100件の返却という最初のマイルストーンに到達するために。",
"hc.toTheCustomer": "顧客へ。",
"hc.toTheShippingFeePayment": "送料の支払いへ。",
"hc.toYourRecoveryTracking": "回収追跡へ。",
"hc.tooExpensiveBudget": "高すぎる / 予算",
"hc.topCitiesForReturns": "返却のための主要都市",
"hc.trackMyRecovery": "回収を追跡する",
"hc.trackTheShipmentAndDownload": "発送を追跡し、ラベルをダウンロード（自動生成）して、宣言タブを離れずに行います。",
"hc.trackYourStatistics": "統計を追跡する",
"hc.tracking": "追跡",
"hc.unableToOpenTheShipping": "送料の支払いを開くことができません。再試行してください。",
"hc.unableToRetrieveTheInvoice": "請求書を取得できませんでした。",
"hc.unclaimed": "未請求",
"hc.unclaimedCustomerReason": "未請求アイテム。顧客の理由: \"{reason}\"。",
"hc.unclaimedItem": "未請求アイテム",
"hc.unclaimedItemNoClaimWithin": "未請求アイテム — 期限内に請求なし。",
"hc.unclaimedItems": "未請求アイテム",
"hc.unclaimedItemsMatchLeftWithout": "未請求アイテム: 期限内に請求なしで残されたマッチ。保管に戻すことができます。",
"hc.unlockTheFinderSContact": "発見者の連絡先を解除して、引き渡しを調整します。",
"hc.upcoming": "今後の予定",
"hc.updateFailed": "更新に失敗しました。",
"hc.usedForInvoices": "あなたのfindloop請求書を発行するために使用されます。",
"hc.vatNumber": "VAT番号",
"hc.verificationPending": "確認待ち",
"hc.verificationSentToTheFinder": "確認を発見者に送信しました。彼らの決定が通知されます。",
"hc.verificationSentToThePartner": "確認をパートナーに送信しました。彼らの決定が通知されます。",
"hc.verify": "確認する",
"hc.verifyingInvite": "招待リンクを確認中…",
"hc.verifyingTheLink": "リンクを確認中…",
"hc.viewInRegistry": "レジストリで表示",
"hc.viewItem": "アイテムを表示",
"hc.viewItemRecover": "アイテムを表示 & 回収",
"hc.visibleToTheOwnerAutomatically": "所有者に見える · 60日後に自動削除。",
"hc.waitingForPartnerConfirmation": "パートナーの確認を待っています",
"hc.waitingForThePartnerS": "パートナーの確認を待っています",
"hc.weHaveInformedTheEstablishment": "このアイテムがあなたのものでないことを施設に通知し、分析を再開しました。新しいマッチが見つかり次第、通知されます。",
"hc.weHaveInformedThePartner": "このアイテムがあなたのものでないことをパートナーに通知しました。あなたのリストは今後のマッチのためにアクティブなままです。",
"hc.weRanTheAnalysisAgain": "再度分析を行い、あなたのものかもしれないアイテムをもう一つ見つけました。再度ご確認ください。",
"hc.weight": "重量",
"hc.weightNotProvidedTheShipping": "重量が提供されていません：配送時に運賃が計算されます。",
"hc.weightUnit": "重量単位",
"hc.welcome": "ようこそ！",
"hc.welcomeToFindo": "findloopへようこそ",
"hc.whenACustomerComesTo": "顧客が持ち物を取りに来たら、申告を開き、返却を確認してください。それで完了です！",
"hc.whenDisabledFeesDropTo": "無効にすると、手数料は",
"hc.whyIsThisNotYour": "なぜこれはあなたのアイテムではないのですか？",
"hc.willBeMarkedAs": "としてマークされます",
"hc.wrongColor": "間違った色",
"hc.wrongModel": "間違ったモデル",
"hc.yesCancel": "はい、キャンセル",
"hc.yesContactTheFinder": "はい、発見者に連絡",
"hc.youAreHere": "あなたはここにいます",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "返却を開始できます。",
"hc.youCanStillChangeIt": "ケースごとにまだ変更できます。",
"hc.youHaveAlreadyConfirmedThat": "これはあなたのアイテムであることをすでに確認しています。",
"hc.youWillBeRedirectedTo": "安全なStripe決済にリダイレクトされます。",
"hc.yourAccountHasBeenReactivated": "あなたのアカウントは再活性化されました。",
"hc.yourAccountIsActiveYou": "あなたのアカウントはアクティブです。これで施設を管理できます。",
"hc.yourEstablishment": "あなたの施設",
"hc.yourFeedbackHelpsUsImprove": "あなたのフィードバックは私たちのマッチを改善するのに役立ちます。",
"hc.yourFeedbackHelpsUsRestart": "あなたのフィードバックは分析を再開し、マッチを改善するのに役立ちます。",
"hc.yourFirstSteps": "あなたの最初のステップ",
"hc.yourFirstStepsAdmin": "あなたの最初のステップ（管理者）",
"hc.yourItemHasBeenHanded": "あなたのアイテムはパートナーによって直接手渡されました — 引き渡しが確認されたらケースを閉じてください。",
"hc.yourItemHasBeenShipped": "あなたのアイテムはパートナーによって発送されました — 配達が確認されたらケースを閉じてください。",
"hc.yourPaymentHasBeenRecorded": "あなたの支払いが記録されました。",
"hc.yourShipmentIsBeingPrepared": "あなたの発送が準備中です。3～5営業日以内に荷物を受け取ります。",
"hc.yourShippingFeesHaveAlready": "あなたの発送手数料はすでに支払われています。発送済み ✓",
"hc.yourShippingFeesHaveBeen": "あなたの発送手数料は支払われました。あなたの荷物が準備中です。",
"hc.yourVerificationQuestionsDeposit": "あなたの確認質問（デポジット）",
"hero.einvoiceBadge": "2027準拠の電子請求書",
"home.recentAdsAll": "すべてのリストを見る",
"home.recentAdsEyebrow": "現在",
"home.recentAdsSubtitle": "コミュニティによって報告された紛失物と発見物。",
"home.recentAdsTitle": "最新のリスト",
"home.reunions": "最近の再会",
"home.videoEyebrow": "見る",
"home.videoSubtitle": "どのように失われたアイテムを所有者に簡単に返すか。",
"home.videoTitle": "2分でfindloopを発見する",
"home.watchYoutube": "YouTubeで見る",
"impact.already": "すでに",
"impact.citiesWord": "都市/都市",
"impact.eachPoint": "各点はfindloopが失われたアイテムを回収する都市です。",
"impact.emptyMap": "返還が行われるごとに地図が埋まります。",
"impact.eyebrow": "私たちの影響",
"impact.inCities": "を通じて",
"impact.restitutedTo": "所有者に返されたアイテム",
"impact.title": "返還されたアイテム、あなたの近くに",
"inv2.download": "ダウンロード",
"inv2.view": "見る",
"map.objectsOnMapPlural": "地図上のアイテム",
"map.objectsOnMapSingular": "地図上のアイテム",
"mc.claimConfirmDesc": "支払いを行う前に、見つけた人が見つけたアイテムを確認してください。",
"mc.claimConfirmNo": "これは私のアイテムではありません",
"mc.claimConfirmTitle": "これは本当にあなたのアイテムですか？",
"mc.claimConfirmYes": "はい、私のものです — 支払います",
"mc.claimFinderContacts": "見つけた人の連絡先詳細",
"mc.claimNotMineDone": "ありがとうございます — 見つけた人に通知され、あなたのリクエストは広告から削除されました。",
"mc.claimUnlockDesc": "あなたのアイテムを見つけた人の連絡先詳細を取得するためにfindloop管理料金を支払ってください。",
"mc.claimUnlockTitle": "見つけた人の連絡先詳細を解除する",
"mc.hideCountryOffers": "私の国のオファーを非表示にする",
"mc.myClaims": "私が請求しているアイテム",
"mc.myClaimsSub": "他の人が見つけたアイテムを請求しています。連絡先詳細を解除して手渡しを手配してください。",
"mc.notifAdCancelled": "広告がキャンセルされました",
"mc.notifCancelAd": "私の広告をキャンセルする",
"mc.offersInCountry": "私の国のオファー",
"mc.offersInCountryDesc": "あなたの国のパートナーからのすべてのアクティブな報酬、都市別。",
"mc.redArchived": "アーカイブ済み",
"mc.rewardsCountryNone": "あなたの国にはまだオファーがありません。",
"mc.rewardsForYou": "あなたのための報酬",
"mc.rewardsForYouDesc": "あなたがアイテムを持ち込んだパートナーによって提供されています。",
"mc.rewardsMineNone": "あなたの持ち込みパートナーからの報酬はまだありません。",
"mc.showCountryOffers": "私の国のオファーを見る",
"mc2.cancelDecl": "私の申告をキャンセルする",
"mc2.cancelDeclDone": "申告がキャンセルされました。",
"pricing.physInvDesc": "アイテムが返却されると、その場所は自動的に解放され、新しいアイテムのために利用可能になります。",
"pricing.physInvTitle": "物理在庫管理",
"pricing.physModalTitle": "物理アイテム管理",
"pricing.physQrDesc": "各アイテムに一意のQRコードが生成され、その情報にリンクします。",
"pricing.physQrTitle": "専用QRラベル",
"pricing.physShelfDesc": "登録されたすべてのアイテムは、施設内の物理的な場所に割り当てることができます。",
"pricing.physShelfTitle": "棚計画",
"pricing.physicalMgmt": "物理アイテム管理（棚、QR、在庫）",
"pub.addSecondPhoto": "2枚目の写真を追加（オプション）",
"pub.photo2Added": "✓ 2枚目の写真が追加されました",
"reg.dispositionJournal": "処分ジャーナル",
"reg.dispositionNoteAuthHint": "ℹ️ 「当局に引き渡す」にはメモが必要です（報告番号、部署など）。",
"reg.dispositionNotePh": "メモ（オプション）：受取慈善団体、当局の参照、購入者名…",
"reg.dispositionNoteRequired": "当局に引き渡すには公式な参照が必要です。",
"reg.legalPrealert": "{days}日以内の法的期限",
"reg.legalPrealertOptions": "期限のオプション：オークション販売、慈善団体への寄付、当局への引き渡し。",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "フルレビュー",
"rev.readMore": "続きを読む",
"rw.activeCodes": "アクティブバウチャー",
"rw.archived": "アーカイブ済み",
"rw.archivedTitle": "引き換えられたバウチャー（アーカイブ済み）",
"rw.hideArchived": "引き換えられたバウチャーを非表示",
"rw.noArchived": "アーカイブ済みのバウチャーはありません。",
"rw.showArchived": "引き換えられたバウチャーを表示",
"shp.labelAuto": "顧客が送料を支払った時点でラベルが自動的に生成されます。ここからダウンロードできます。",
"st.cancelled_by_customer": "キャンセルされました",
"stt.dispoPdfBtn": "PDFをエクスポート",
"stt.dispoPdfError": "PDFのエクスポートに失敗しました。",
"stt.dispoPdfExporting": "エクスポート中…",
"trk.matchVerifying": "潜在的な一致を確認中",
"pcat.stadium_arena": "スタジアム / アリーナ",
"pcat.supermarket": "スーパーマーケット",
"pcat.taxi_vtc": "タクシー / ライドヘイリング",
"pcat.tourism_office": "観光案内所",
"pcat.train_bus_station": "鉄道 / バスの駅",
"pcat.travel_agency": "旅行代理店",
"hc.and": "と",
"hc.demoObj0": "財布",
"hc.demoObj1": "スポーツバッグ",
"hc.demoObj2": "電話",
"hc.demoObj3": "眼鏡",
"hc.demoObj4": "鍵の束",
"hc.demoObj5": "スカーフ",
"hc.demoObj6": "ノートパソコン",
"hc.demoObj7": "水筒",
"hc.demoWhen0": "2時間前",
"hc.demoWhen1": "5時間前",
"hc.demoWhen2": "昨日",
"hc.demoWhen3": "3時間前",
"hc.demoWhen4": "今朝",
"hc.demoWhen5": "1日前",
"hc.feedDemo": "{obj}が{city}で{when}に返却されました。",
"hc.feedReal": "アイテム（{cat}）が{city}で返却されました。",
"hc.saveBtn": "保存",
"hc.saveLink": "リンクを保存",
"hc.terms": "利用規約",
"hc.view": "表示",
"pcat.airline": "航空会社",
"pcat.airport": "空港",
"pcat.amusement_park": "遊園地",
"pcat.bank": "銀行",
"pcat.bar_cafe": "バー / カフェ",
"pcat.beauty_salon": "美容院",
"pcat.cinema": "映画館",
"pcat.concert_theater": "コンサートホール / 劇場",
"pcat.coworking": "コワーキングスペース",
"pcat.gym_fitness": "ジム / フィットネス",
"pcat.hospital_clinic": "病院 / クリニック",
"pcat.library": "図書館",
"pcat.mall": "ショッピングモール",
"pcat.museum": "博物館",
"pcat.pharmacy": "薬局",
"pcat.private_company": "民間企業",
"pcat.public_transport": "公共交通機関",
"pcat.school_university": "学校 / 大学",
"pcat.sports_center": "スポーツセンター",
"an.found": "見つかりました",
"an.lost": "失われました",
"hc.shareReview": "レビューを共有する",
"hc.citiesAboveTarget": "{n} の都市が目標を超えています",
"hc.cityAboveTarget": "{n} の都市が目標を超えています",
"hc.j15EarlyReminder": "D-15 の早期リマインダー",
"hc.j7EarlyReminder": "D-7 の早期リマインダー",
"hc.annualTotal": "年間合計",
"hc.billedOnceYear": "12ヶ月分を一度に請求し、毎年更新されます。",
"hc.monthlyPrice": "月額料金",
"hc.perMonth": "/ 月",
"hc.perYear": "/ 年",
"hc.billedEachMonth": "毎月自動的に請求されます。",
"nav.business": "ビジネス",
"nav.individual": "個人",
"hc.circumstancesFound": "発見の状況",
"hc.circumstancesFoundPh": "例：地下鉄の入り口近くに落ちていた",
"hc.circumstancesLost": "紛失の状況",
"hc.circumstancesLostPh": "例：バスを待っている間にベンチに置き忘れた",
"hc.conditionPh": "例：良い、傷がある…",
"hc.firstName": "名",
"hc.lastName": "姓",
"hc.quantity": "アイテムの数",
"fa.ownerContact": "オーナーの連絡先詳細",
"fa.payPublish": "支払いと公開",
"fa.pendingPayText": "支払いが確認され次第、あなたのリスティングが公開されます。",
"fa.pendingPayTitle": "支払い保留中",
"fa.planSub": "支払いが確認され次第、あなたのリスティングが公開されます。",
"fa.planTitle": "リスティングの期間",
"fa.pubSuccessMsg": "あなたのリスティングが公開されました。ファインダーが現れ次第、お知らせします。",
"fa.pubSuccessTitle": "リスティングが公開されました",
"fa.publicNote": "公開されるのは、説明、都市、国、写真のみです。",
"fa.redirectStripe": "安全な支払いにリダイレクト中…",
"fa.reject": "拒否",
"fa.rejectConfirm": "この声明を拒否しますか？あなたのリスティングはオンラインのままです。",
"fa.rejected": "声明が拒否されました",
"fa.rejectedFinder": "彼らが探していたアイテムではありませんでした",
"fa.rejectedFinderText": "オーナーはこのアイテムは自分のものでないと言っています。お手伝いありがとうございます！",
"fa.responsesTitle": "ファインダーの声明",
"fa.sent": "声明がオーナーに送信されました。",
"fa.submitDecl": "私の声明を送信",
"fa.submitDeclPay": "{amount}を送信して寄付",
"fa.total": "支払い合計",
"fa.ttc": "税込み",
"fa.waitClaimText": "ファインダーがあなたのリクエストをレビューしています。彼らの決定についてお知らせします。",
"fa.waitFinderText": "ファインダーが声明を提出次第、お知らせします。",
"fa.waitFinderTitle": "あなたのリスティングが公開されています",
"fa.waitOwnerText": "オーナーがあなたの声明と彼らの声明を比較しています。彼らの決定についてお知らせします。",
"fa.waitOwnerTitle": "オーナーの決定を待っています",
"st.pending_payment": "支払い保留中",
"fa.approve": "承認",
"fa.approveConfirm": "この宣言を承認しますか？あなたの連絡先情報（名前、メール、電話）がファインダーと交換されます。",
"fa.approved": "宣言が承認されました — 連絡先情報が交換されました",
"fa.approvedFinder": "所有者があなたの宣言を承認しました",
"fa.approvedFinderText": "返却の手配をするために連絡してください。",
"fa.boostSub": "あなたのリスティングが選択した期間、トップに表示されます。",
"fa.boostTitle": "リスティングをブーストする（オプション）",
"fa.colFinder": "ファインダーの宣言",
"fa.colYours": "あなたの宣言",
"fa.compareHint": "決定前にファインダーの宣言とあなたの宣言を比較してください。",
"fa.contribNone": "寄付なし",
"fa.contribPaid": "寄付を受け取りました — ありがとうございます！",
"fa.contribPending": "寄付が支払いを待っています",
"fa.contribSub": "findloopをサポートし、より多くの人が自分の持ち物を取り戻せるようにします。€0を選択できます。",
"fa.contribSuccessMsg": "あなたの宣言が所有者に送信されました。",
"fa.contribSuccessTitle": "寄付ありがとうございます",
"fa.contribTitle": "任意の寄付",
"fa.days3": "3日",
"fa.days30": "30日",
"fa.days7": "7日",
"fa.declSub": "見つけたアイテムを説明してください。所有者はあなたの宣言と自分の宣言を比較します。",
"fa.declTitle": "このアイテムを見つけました",
"fa.expiresOn": "有効期限",
"fa.fBrand": "ブランド",
"fa.fCircumstances": "状況",
"fa.fCity": "都市",
"fa.fColor": "色",
"fa.fCondition": "状態",
"fa.fDate": "日付",
"fa.fMessage": "ファインダーのメッセージ",
"fa.fPlace": "場所",
"fa.fQuantity": "数量",
"fa.finderContact": "ファインダーの連絡先情報",
"fa.finishPay": "支払いを完了する",
"fa.foundDate": "見つけた日付",
"fa.foundPlace": "見つけた場所",
"fa.hours24": "24時間",
"fa.ht": "税抜",
"fa.months3": "3か月",
"fa.noBoost": "ブーストなし",
"fa.africaFree": "アフリカでの無料掲載 — Findloopのローンチオファーをお楽しみください！",
"fa.africaPublished": "無料で掲載されました — アフリカのローンチオファー！",
"fa.approveClaimConfirm": "このクレームを承認しますか？所有者はあなたの連絡先情報を解除できるようになります。",
"fa.checkInfo": "送信前にあなたの詳細を確認してください：探し手の情報と比較されます。",
"fa.claimApprovedShort": "探し手があなたのクレームを承認しました",
"fa.claimRejectedShort": "探し手によってクレームが拒否されました",
"fa.claimRejectedText": "探し手はこのアイテムがあなたのものでないと考えています。",
"fa.claimSub": "アイテムを説明し、2枚の写真を追加してください。探し手はそれらを彼らのリストと比較します。",
"fa.claimTitle": "これは私のアイテムです",
"fa.claimUnlockText": "探し手の連絡先情報を解除して、返却の手配をします。",
"fa.claimUnlockedShort": "連絡先情報が解除されました — 追跡を確認",
"fa.claimsTitle": "所有者のクレーム",
"fa.colOwner": "所有者の申告",
"fa.colYourAd": "あなたの掲載",
"fa.expired": "掲載期限切れ",
"fa.free": "無料",
"fa.lostDate": "紛失日",
"fa.lostPlace": "紛失場所",
"fa.noReceipt": "この掲載に利用可能な領収書はありません。",
"fa.planSubFree": "期間を選択してください：あなたの掲載はすぐにライブになり、支払いは不要です。",
"fa.prefillPrevious": "このカテゴリの前回の掲載の詳細を再利用する",
"fa.receipt": "PDF領収書",
"fa.renewBtn": "更新",
"fa.renewDiscountBanner": "50%オフ：掲載期限が切れる前に更新してください！",
"fa.renewDiscountHint": "期限前に更新したため、50%オフが適用されました。",
"fa.renewEarly": "更新 (−50%)",
"fa.renewTitle": "私の掲載を更新",
"fa.renewed": "掲載が更新されました",
"fa.sendClaim": "クレームを送信",
"fa.twoPhotos": "アイテムの写真2枚",
"fa.twoPhotosError": "アイテムの写真を2枚追加してください。",
"fa.twoPhotosHint": "アイテムがあなたのものであることを証明する個人の写真（アイテム、請求書、箱などと一緒に）。",
"fa.unlockBtn": "連絡先情報を解除",
"fa.unlockFree": "無料で解除 — ローンチオファー",
"fa.waitClaimantText": "所有者がこのアイテムをクレームした際、お知らせします。",
"fa.waitFinderDecision": "探し手の決定を待っています",
"fa.waitUnlockText": "連絡先情報が交換され次第通知されます。",
"fa.waitUnlockTitle": "所有者の解除を待っています",
"fa.cancel": "キャンセル",
"fa.categoryRequired": "見つかったアイテムのカテゴリを選択してください。",
"fa.confirmTitle": "決定を確認",
"fa.goBack": "戻る",
"dr.continue": "宣言を続ける",
"dr.delete": "完全に削除",
"dr.deleteConfirm": "このドラフトを完全に削除しますか？元には戻せません。",
"dr.deleted": "ドラフトが削除されました",
"dr.expiresIn": "ドラフトはあと{h}時間保管されます",
"dr.title": "未完了の宣言があります",
"form.step": "ステップ",
"form.next": "続ける",
"form.back": "戻る",
"form.stepDetails": "あなたの報告",
"form.stepPublish": "期間、ブースト＆支払い",
"form.stepThanks": "ありがとう＆ご寄付",
"fthx.badge": "報告はほぼ完了です",
"fthx.title": "ありがとう、あなたは違いを生み出しています！",
"fthx.text": "あなたのおかげで、誰かが大切なものを取り戻すチャンスができるかもしれません。あなたのような親切な行動こそがFindloopを支えています。",
"fthx.impact1": "1件の報告",
"fthx.impact2": "再会のチャンスが1回増えました",
"fthx.tipTitle": "Findloopを少しサポートしますか？",
"fthx.tipText": "あなたのご寄付は私たちがサービスを維持し、ますます多くのアイテムを所有者に届けるのを助けます。",
"fthx.optional": "100%任意 — ご寄付なくても投稿できます。",
"fthx.thanksTip": "ご寛大に感謝いたします！",
"fthx.suggest": "推奨金額",
"fthx.none": "チップなし",
"pay.pendingTitle": "支払いが完了していません",
"pay.pendingText": "詳細は保存されました。お支払いを途中から再開してください。",
"pay.resume": "支払いを再開",
"pay.expiredTitle": "支払いセッションが期限切れです",
"pay.expiredText": "安全のため、支払いセッションが期限切れになりました。あなたの詳細は保存されています: ワンクリックで支払いを再開します。",
"pay.relaunch": "支払いを再起動",
"sub.received": "送信しました！",
"sub.publishing": "最終調整中です…",
"sub.toPayment": "安全な支払いにリダイレクトしています…",
"fa.claimSubV2": "失くしたアイテムについて説明してください。見つけた人は、あなたの申告内容を彼らのリストと照らし合わせます。",
"fa.photosOptional": "アイテムの写真（任意）",
"fa.compareOwnerHint": "この情報を見つけたアイテムと比較し、同じアイテムかどうかをお知らせください。",
"fa.itsThisItem": "はい、これがそのアイテムです",
"fa.notThisItem": "いいえ、これはそのアイテムではありません",
"fa.confirmIsItem": "これがそのアイテムであることを確認しますか？あなたの連絡先情報と所有者の情報はそれぞれのアカウントに表示されます。",
"fa.confirmNotItem": "これがそのアイテムではないことを確認しますか？あなたの報告は閉じられます。",
"fa.youConfirmed": "あなたはこれが所有者のアイテムであると確認しました",
"fa.youDeclined": "あなたはこれがそのアイテムではないと表示しました",
"fa.youDeclinedText": "ご協力ありがとうございます！所有者に通知されました。",
"fa.waitFinderDecisionOwner": "見つけた人の決定を待っています",
"fa.finderConfirmed": "確認済み",
"fa.notYourItem": "これはあなたのアイテムではありません",
"fa.reportedOn": "報告日",
"fa.ownerWaitHint": "現在、見つけた人が情報を確認しています。お待ちください。",
"fa.claimSentFinder": "アイテムを見つけた人に請求が送信されました。",
"fa.compareClaimHint": "決定する前に、所有者の申告とあなたのリストを比較してください。",
"fa.closeFollowup": "このフォローアップを終了します",
"fa.closeFollowupConfirm": "このフォローアップを終了しますか？オーナーがリスティングを終了すると、両方のメールアドレスと電話番号は永遠に削除されます。",
"fa.safetyTitle": "引き渡し前の安全対策",
"fa.safety1": "オーナーにアイテムの隠れた特徴について詳しく説明してもらいましょう：特定の傷、バッグの正確な内容物、壁紙、シリアルナンバーなど。",
"fa.safety2": "可能であれば、視覚的証拠（アイテムの写真）や購入証明を求めましょう。",
"fa.safety3": "公共の場またはFindloopのパートナーでアイテムを引き渡し、オーナーの身分証明書を確認しましょう。",
"fa.safetyOk": "了解です、続けます",
"fa.ownerClosedNote": "オーナーがリスティングを終了しました。",
"fa.finderClosedNote": "ファインダーがフォローアップを終了しました。",
"fa.followupClosed": "フォローアップが完了しました",
"fa.followupClosedText": "このフォローアップを完了しました。ご協力ありがとうございます！",
"fa.photoReviewTitle": "フィンダーが写真を送信しました。あなたのアイテムのように見えますか？",
"fa.photoLooksLike": "はい、私のアイテムのように見えます。",
"fa.photoNotMine": "いいえ、これは私のアイテムではありません。",
"fa.photoNotMineConfirm": "フォローアップは両者で閉じられ、あなたのリスティングは新しいフィンダーのためにオープンのままとなります。",
"fa.photoLooksLikeDone": "ありがとうございます！ フィンダーはあなたの申告を比較します。",
"fa.photoNotMineDone": "報告は却下されました。あなたのリスティングはオープンのままです。",
"fa.ownerPhotoHint": "フィンダーの写真のみがあなたに表示されます。あなたのアイテムのように見えるか教えてください。",
"fa.ownerReviewingPhoto": "オーナーがあなたの写真をレビュー中です。",
"fa.ownerReviewingPhotoText": "彼らが回答し次第、通知されます。その後、彼らの申告を比較できるようになります。",
"fa.ownerRejectedPhoto": "これはオーナーのアイテムではありません。",
"fa.ownerRejectedPhotoText": "オーナーはあなたの写真が彼らのアイテムと一致しないと言っています。フォローアップは閉じられました。ご協力ありがとうございました！",
"fa.contribute": "貢献する",
"fa.phoneMissing": "提供されていません",
"fa.ownerSafety1": "公共の場所かFindloopのパートナーでの手渡しをおすすめします。距離が長い場合は、郵送を提案してください。",
"fa.ownerSafety2": "手渡しの際には、発見者のIDを確認してください。",
"pub.changePhoto": "写真を変更する",
"ph.secured": "写真が保護されました",
"ph.securing": "写真を保護しています…",
"fa.ownerSafety3": "もし発見者の写真にFindloopのウォーターマークがある場合は、ミーティングを受け入れないでください。その写真は、発見者が撮影したオリジナルの画像でなければなりません。"
},
"ko": {
"ac.africa": "아프리카",
"ac.boostActive": "활성화 강조 —",
"ac.boostSub": "파트너 디렉토리 상단에 “강조됨” 배지로 나타납니다.",
"ac.boostTitle": "디렉토리에서 목록을 강조하세요",
"ac.categoryHint": "Findloop 디렉토리에 귀하의 시설을 분류하기 위해.",
"ac.choose": "선택하세요",
"ac.cityHint": "공식 지도에서 정확한 위치를 위해.",
"ac.cityLabel": "시설 도시",
"ac.cityPh": "파리",
"ac.contact": "연락처 정보",
"ac.converted": "변환됨",
"ac.copyDeclLink": "신고 링크 복사",
"ac.copyLink": "링크 복사",
"ac.currentPlan": "현재 플랜",
"ac.emailDesc": "수신할 이메일을 선택하세요. 작업 공간의 알림은 항상 활성 상태로 유지됩니다.",
"ac.emailMatch": "일치함",
"ac.emailMatchDesc": "항목이 신고와 일치할 때 이메일",
"ac.emailNewDecl": "새로운 분실 신고",
"ac.emailNewDeclDesc": "고객이 귀하의 장소에서 분실 신고를 할 때 바로 이메일",
"ac.emailShip": "배송 요청",
"ac.emailShipDesc": "고객이 항목의 배송을 요청할 때 이메일",
"ac.emailTitle": "이메일 기본 설정",
"ac.expireSoon": "귀하의 강조 표시가 곧 만료됩니다 —",
"ac.exportCsv": "내보내기 (CSV)",
"ac.exportHint": "회계를 위해 검증된 외부 결제를 내보내세요.",
"ac.free": "무료",
"ac.freeMonths": "무료 월",
"ac.hours": "시간",
"ac.howItWorks": "어떻게 작동하나요?",
"ac.invited": "초대됨",
"ac.legalFR": "2026년 9월부터 적용되는 전자 송장 발행을 위해 필요합니다 (Factur-X).",
"ac.legalMissing": "⚠️ SIRET 및 EU 내 VAT 누락 — 전자 송장 발행을 준수하려면 이를 완성하세요.",
"ac.legalOther": "귀하의 송장에 추천됩니다.",
"ac.legalPartnerQr": "QR 코드",
"ac.legalTitle": "법적 식별자 (청구)",
"ac.logoTitle": "시설 로고",
"ac.modeCurrent": "현재 모드:",
"ac.modeExternal": "외부 (수동 검증)",
"ac.modeInternal": "내부 Findloop (자동)",
"ac.noSubReceipt": "아직 유료 구독 결제 없음.",
"ac.none": "없음",
"ac.onYourListing": "귀하의 목록에",
"ac.pay1": "고객을 귀하의 결제 시스템으로 리디렉션하기 위해 아래에 결제 링크를 입력하세요.",
"ac.pay2": "검증이 수동으로 전환됩니다: “신고” 탭에서 결제 수신을 확인하세요.",
"ac.pay3": "“배송비” 링크는 통합 결제입니다 (회수 + 배송).",
"ac.pay4": "Findloop의 내부 결제(Stripe)를 자동 검증으로 사용하려면 필드를 비워두세요.",
"ac.paySub": "귀하의 결제 시스템을 통해 수수료를 수집하세요.",
"ac.payTitle": "외부 결제",
"ac.permissive": "허용됨",
"ac.phone": "전화",
"ac.posterA4": "A4 포스터 (PDF)",
"ac.qMessage": "메시지 (선택 사항)",
"ac.qName": "이름",
"ac.qOrg": "조직",
"ac.qSites": "시설 수 (추정)",
"ac.qrHint": "고객이 분실물을 신고하기 위해 이 코드를 스캔합니다.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "귀하의 파트너 QR 코드",
"ac.quoteDesc": "공항, 철도망, 국제 체인 · ",
"ac.quoteEurope": "유럽 / 세계",
"ac.quoteSent": "견적 요청을 보냈습니다. 우리 팀이 곧 연락드릴 것입니다.",
"ac.quoteTitle": "견적 요청하기 — 기업",
"ac.recoveryLink": "“회복 수수료” 링크",
"ac.refSub": "추천한 파트너가 구독할 때마다 1개월 무료를 드립니다.",
"ac.refTitle": "추천하고 무료 월을 얻으세요",
"ac.reminderDelay": "검증 알림 지연",
"ac.reminderHint": "이 지연(기본: 48시간)을 초과하여 외부 결제가 검증되지 않으면 이메일 알림을 받습니다.",
"ac.renewDesc1": "이미 획득한 금액",
"ac.renewDesc2": "디렉토리의 상단에 유지하고 이 가시성을 잃지 않으려면 갱신하세요.",
"ac.renewNow": "지금 갱신하기",
"ac.requestQuote": "견적 요청하기",
"ac.saveLegal": "식별자 저장",
"ac.saveLinks": "링크 저장",
"ac.sendRequest": "내 요청 보내기",
"ac.sending": "보내는 중…",
"ac.shippingLink": "“배송 수수료” 링크(통합)",
"ac.shippingLinkHint": "이 링크는 회복 및 배송을 모두 포함합니다.",
"ac.strict": "엄격함",
"ac.subReceipt": "구독 영수증 (PDF)",
"ac.subReceiptsSub": "각 구독 결제에 대한 PDF 영수증을 다운로드하세요.",
"ac.subReceiptsTitle": "구독 영수증",
"ac.tCategory": "카테고리 저장됨",
"ac.tCity": "도시 저장됨 — 지도 업데이트됨",
"ac.tCityNeeded": "도시를 입력하세요",
"ac.tCopied": "복사완료!",
"ac.tCover": "커버 사진 업데이트됨",
"ac.tEmailPrefs": "이메일 기본 설정 업데이트됨",
"ac.tErr": "오류",
"ac.tExportImpossible": "내보내기 실패",
"ac.tLegal": "법적 식별자 저장됨",
"ac.tLegalNeeded": "프랑스를 위한 SIRET 및 VAT 필요",
"ac.tLogo": "로고 업데이트됨",
"ac.tLogoRemoved": "로고 제거됨",
"ac.tPayLinks": "결제 링크 저장됨",
"ac.tPhone": "전화 저장됨",
"ac.tSensitivity": "민감도 저장됨",
"ac.tVatInvalid": "유효하지 않은 VAT 번호",
"ac.tVatValid": "유효한 VAT",
"ac.tabBoost": "가시성",
"ac.tabPayments": "결제",
"ac.tabProfile": "프로필",
"ac.tabQr": "QR & 포스터",
"ac.tabReferral": "추천",
"ac.tabSub": "구독",
"ac.thisWeek": "이번 주",
"ac.thisWeekOf": " ({n} 이번 주)",
"ac.thresholdDesc": "AI가 사진 일치를 자동으로 검증하고 고객에게 알림을 주는 신뢰 임계값. 높을수록 자동 일치가 적고 더 신뢰할 수 있습니다.",
"ac.thresholdTitle": "AI 시각 매칭 민감도",
"ac.trend": "트렌드",
"ac.upload": "업로드",
"ac.vatValidFmt": "유효한 VAT{name} ({via})",
"ac.vatVerified": "EU 내 VAT 검증됨",
"ac.verifyVat": "VAT 검증하기 (VIES)",
"ac.verifying": "검증 중…",
"ac.views": "조회수",
"ac.viewsTotal": "획득한 조회수 (총)",
"ac.winbackBtn": "-20%로 재개하기",
"ac.winbackDesc1": "당신이 얻은 금액",
"ac.winbackDesc2": "특별 제안: 24시간 이내에 갱신하면 -20%가 자동으로 적용됩니다.",
"ac.winbackTitle": "귀하의 하이라이트가 막 만료되었습니다 — -20%로 재개하세요!",
"an.allCountries": "모든 국가",
"an.country": "국가",
"an.geoBanner": "다음의 리스트를 보고 있습니다",
"an.geoBannerWorld": "전 세계의 리스트를 보고 있습니다",
"an.geoChange": "국가 변경",
"an.loginRequired": "이 항목을 신고하고 반품을 따르려면 로그인하십시오.",
"an.requestInProgress": "요청 진행 중",
"an.resolved": "항목이 이미 회복되었습니다",
"an.sortRecent": "가장 최근",
"an.sortRelevance": "관련성",
"bo.africaPrice": "아프리카 지역 우대 가격 적용됨",
"c.all": "모두",
"c.close": "닫기",
"c.confirm": "확인",
"c.confirmed": "확인됨",
"c.download": "다운로드",
"c.reset": "재설정",
"c.transfer": "전송",
"cat.Animal": "애완동물 / 애완동물 액세서리",
"cat.AppareilPhoto": "카메라",
"cat.Argent": "돈 / 현금",
"cat.Autres": "기타",
"cat.Bijoux": "보석",
"cat.CarteBancaire": "은행 카드",
"cat.CarteIdentite": "신분증 / 여권",
"cat.Casquette": "모자 / 캡",
"cat.Ceinture": "벨트",
"cat.Chargeur": "충전기 / 케이블",
"cat.Chaussures": "신발",
"cat.CleVoiture": "차 열쇠",
"cat.Cles": "열쇠",
"cat.Console": "게임 콘솔",
"cat.Documents": "문서 / 서류",
"cat.Echarpe": "스카프",
"cat.Ecouteurs": "이어폰 / 헤드폰",
"cat.Electronique": "전자기기 (기타)",
"cat.Enceinte": "스피커",
"cat.Gants": "장갑",
"cat.Gourde": "물병 / 플라스크",
"cat.Instrument": "악기",
"cat.Jouet": "장난감 / 인형",
"cat.Jumelles": "쌍안경",
"cat.Lampe": "램프 / 손전등",
"cat.Liseuse": "전자책 리더",
"cat.Livre": "책 / 노트",
"cat.Lunettes": "안경",
"cat.Manteau": "코트 / 재킷",
"cat.Maquillage": "화장품 가방",
"cat.Medical": "의료 기기",
"cat.Medicaments": "약물",
"cat.Montre": "시계 / 스마트워치",
"cat.Ordinateur": "노트북",
"cat.Parapluie": "우산",
"cat.Portefeuille": "지갑 / 지갑",
"cat.Poussette": "유모차 / 아기 액세서리",
"cat.Sac": "가방 / 핸드백",
"cat.SacADos": "배낭",
"cat.Souris": "마우스 / 키보드",
"cat.Sport": "스포츠 장비",
"cat.Tablette": "태블릿",
"cat.Telephone": "전화 / 스마트폰",
"cat.Trottinette": "스쿠터",
"cat.Trousse": "파우치 / 케이스",
"cat.USB": "USB 드라이브 / 하드 드라이브",
"cat.Valise": "수하물 / 여행가방",
"cat.Velo": "자전거",
"cat.Vetements": "의류",
"cm.found": "발견됨",
"cm.lost": "분실됨",
"cmp.starterEst": "포함 1개 + 무제한 추가",
"consent.required": "계속하려면 연락처를 공유하는 것에 동의해야 합니다.",
"consent.share": "제 물건을 찾는 사람이 제 연락처(이름, 이메일, 전화번호)를 볼 수 있도록 동의합니다.",
"dc.partnerDesc": "파트너 장소(호텔, 역, 홀…)에서 물건을 잃어버렸나요? 직접 반납을 위해 선택하세요.",
"dc.partnerList": "목록에서 선택",
"dc.partnerMap": "지도에서 선택",
"dc.partnerTitle": "파트너에 대한 신고",
"dc.publicCta": "공식 광고 게시",
"dc.publicDesc": "귀하의 광고는 전체 Findloop 커뮤니티에 표시됩니다. 물건을 잃어버린 장소를 모를 때 이상적입니다.",
"dc.publicTitle": "공식 신고",
"dc.subtitle": "분실물 신고 방법을 선택하세요.",
"dc.title": "무엇을 하시겠습니까?",
"dec.addrPending": "고객으로부터 주소 대기 중",
"dec.analyzing": "분석 중…",
"dec.clientDescription": "고객 설명",
"dec.clientPhoto": "고객이 제공한 사진",
"dec.clientPhotoShort": "고객 사진",
"dec.comparePhotos": "사진 비교",
"dec.declaredItemPhoto": "신고된 물건의 사진",
"dec.emptyDesc": "QR 코드를 공유하여 신고를 받으세요.",
"dec.emptyTitle": "신고 없음",
"dec.enlarge": "확대",
"dec.extBanner": "{n} 외부 결제(들)를 확인해야 합니다 — 아래에서 수령 확인 후 인계 또는 배송을 해제하세요.",
"dec.foundItemAlt": "발견된 물건",
"dec.foundItemRegistry": "발견된 물건 (등록)",
"dec.labelClient": "고객",
"dec.labelRegistry": "등록",
"dec.noMatchYet": "아직 일치하는 항목 없음.",
"dec.noPhoto": "사진 없음",
"dec.pRecup": "회수",
"dec.pRecupP": "(회수)",
"dec.pRecupShip": "(회수 + 배송)",
"dec.payConfirmed": "결제 {x} 확인됨",
"dec.payPending": "외부 결제 {x} 대기 중",
"dec.pickup": "직접 수령",
"dec.reject": "거부",
"dec.rerun": "분석 다시 실행",
"dec.similarity": "유사도 {n}%",
"dec.suggestedMatches": "제안된 일치 항목",
"dec.toColon": " 로:",
"dec.toShip": "배송할 것",
"dec.toastExtPay": "결제 확인됨 — 고객에게 알림이 전송됩니다.",
"dec.toastMatch": "일치 확인됨",
"dec.toastReject": "제안 거부됨",
"dec.toastRerun": "분석 재시작됨",
"dec.toastVisualN": "{n} 시각적 일치(들)",
"dec.toastVisualNone": "시각적 일치 없음",
"dec.viewBeforeAfter": "전후 보기 (오버레이)",
"dec.viewSideBySide": "나란히 보기",
"dec.visualCompare": "AI 시각 비교",
"dec.visualIdle": "비교를 실행하여 AI가 고객의 사진을 발견된 물건과 시각적으로 일치시킵니다.",
"dec.visualRunning": "AI가 고객의 사진을 귀하의 등록 정보에 있는 항목과 비교하고 있습니다…",
"dec.zoomPhoto": "사진 확대",
"dep.addAnyway": "어쨌든 추가",
"dep.addError": "추가 중 오류 발생",
"dep.addItem": "항목 추가",
"dep.added": "항목이 등록 정보에 추가되었습니다!",
"dep.adding": "추가하는 중…",
"dep.aiError": "현재 AI 분석이 불가능합니다.",
"dep.aiFilled": "AI로 자동 입력된 양식 ✨",
"dep.aiUnavailable": "AI를 사용할 수 없습니다 — 양식을 수동으로 작성하십시오.",
"dep.analyzing": "분석 중…",
"dep.analyzingPhoto": "사진 분석 중…",
"dep.brand": "브랜드",
"dep.brandPlaceholder": "예: Apple",
"dep.category": "카테고리",
"dep.checkingDup": "중복 확인 중…",
"dep.color": "색상",
"dep.colorPlaceholder": "예: 검은색",
"dep.condition": "상태",
"dep.conditionPlaceholder": "예: 좋은 상태",
"dep.depositorNote": "예치자 노트",
"dep.depositorNoteHint": "손으로 입력한 운영 세부정보. AI는 이 노트를 덮어쓰지 않습니다.",
"dep.depositorNotePlaceholder": "예: 파우치 내용물, 보고된 브랜드, 제공된 세부정보…",
"dep.descPlaceholder": "예: 바에서 발견된 투명 케이스의 검은색 아이폰 15…",
"dep.description": "설명",
"dep.dupHint": "중복 항목을 추가하지 않도록 하세요. 항목이 진정으로 다르다면 계속 진행할 수 있습니다.",
"dep.dupTitle": "유사 항목이 이미 등록되었습니다",
"dep.dupWarn": "유사한 항목이 감지되었습니다 — 검토 후 다시 클릭하여 확인하십시오.",
"dep.estHint": "이 항목은 이 기관의 등록 정보에 추가됩니다.",
"dep.establishment": "기관",
"dep.fee": "회수 수수료 (€) — 선택 사항",
"dep.feePlaceholder": "카테고리 기본 가격을 위해 비워 두세요",
"dep.fillAI": "AI로 채우기",
"dep.optional": "(선택 사항)",
"dep.photo": "항목 사진",
"dep.principal": "주요",
"dep.reqError": "카테고리와 설명이 필요합니다.",
"dep.savedItem": "등록된 항목",
"dep.similarity": "유사성",
"dep.storage": "물리적 위치",
"dep.storageHint": "항목이 물리적으로 저장된 곳입니다. 찾기 위한 QR 코드가 생성됩니다.",
"dep.storagePlaceholder": "예: 선반 A3, 사물함 12, 접수 금고",
"dl.aClient": "고객",
"dl.alertsBlocked": "브라우저 알림 차단됨",
"dl.alertsBlockedHint": "다시 활성화하려면: 사이트 주소 왼쪽의 🔒 (또는 ⓘ) 아이콘을 클릭한 후 알림을 허용하고 페이지를 새로 고치십시오.",
"dl.amountDue": "결제해야 할 금액: {amount} {currency}.",
"dl.enableAlerts": "알림 활성화",
"dl.extPending": "검증할 결제",
"dl.freemiumNear": "프리미엄 한도에 가까워지고 있습니다 ({used}/{max} 항목 이달). 무제한 항목을 위해 스타터로 업그레이드하세요.",
"dl.freemiumReached": "프리미엄 한도 초과됨 ({used}/{max} 항목 이달). 무제한 항목을 등록하려면 스타터로 업그레이드하세요.",
"dl.invoiceOverdue": "청구서 {num} 미납 — 접근 제한됨.",
"dl.matchNotifTitle": "Findloop — 새로운 AI 일치 🔔",
"dl.matchToast": "새로운 AI 일치 — {name}",
"dl.matchToastDesc": "항목이 선언과 일치합니다.",
"dl.notifEmpty": "아직 알림이 없습니다.",
"dl.notifEnabled": "브라우저 알림 활성화됨",
"dl.notifTitle": "알림",
"dl.payInvoice": "청구서 결제 →",
"dl.rewardsPending": "제시할 쿠폰",
"dl.upgradeStarter": "스타터로 업그레이드 →",
"est.all": "모든 업소 ({n})",
"est.label": "업소",
"est.primary": "주요",
"est.secondary": "부가",
"est2.add": "업소 추가",
"est2.addressLabel": "주소",
"est2.addressPh": "12 République Street",
"est2.autoInvoice": "매월 1일에 상세한 청구서가 자동으로 생성됩니다.",
"est2.baseSub": "기본 구독",
"est2.billing": "청구",
"est2.boostActivated": "{name}에 대한 부스트 활성화",
"est2.boostBillingNote": "현재 요금으로 청구되며 통합 월 청구서에 그룹화됩니다.",
"est2.boostCta": "부스트",
"est2.boostDesc": "디렉터리와 지도에서 이 업소의 가시성을 향상시킵니다.",
"est2.boostDuration": "{h}시간의 부스팅 가시성",
"est2.boostExtend": "연장",
"est2.boostTitle": "{name} 부스트",
"est2.boosted": "부스트됨",
"est2.chartDesc": "사이트별로 등록된 총 항목 중 반환된 항목의 비율.",
"est2.chartTitle": "업소별 반품율",
"est2.chartTooltip": "반품",
"est2.cityLabel": "도시",
"est2.cityPh": "리옹",
"est2.contactHint": "이 세부정보는 이 업소의 고객에게 표시됩니다(비어 있을 경우 계정으로 대체됨).",
"est2.countryLabel": "국가",
"est2.coverLabel": "커버 사진",
"est2.create": "생성",
"est2.created": "업소 생성됨",
"est2.delete": "삭제",
"est2.deleteDesc": "이 작업은 영구적입니다. 항목이 없는 경우에만 업소를 삭제할 수 있습니다.",
"est2.deleteTitle": "“{name}” 삭제?",
"est2.deleted": "업소 삭제됨",
"est2.dialogDesc": "이 사이트의 이름과 주소를 입력하세요.",
"est2.edit": "편집",
"est2.editEst": "업소 편집",
"est2.emailLabel": "연락 이메일",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " 업소",
"est2.extraNoteBase": "{n}개의 추가 업소 청구",
"est2.extraPrice": " {price} €/월.",
"est2.extraQuote": " 견적서에서.",
"est2.imgChange": "이미지 선택",
"est2.imgDone": "완료",
"est2.imgRemove": "제거",
"est2.imgRemoved": "이미지 제거됨",
"est2.imgSaved": "이미지 저장됨",
"est2.imgUploading": "업로드 중…",
"est2.includedPlan": "계획에 포함됨: {n}.",
"est2.kDeclarations": "신고",
"est2.kInStorage": "보관 중",
"est2.kItemsTotal": "항목 (총합)",
"est2.kRestituted": "반환됨",
"est2.limitReached": "제한 도달",
"est2.logoLabel": "로고",
"est2.mDeclar": "신고",
"est2.mItems": "항목",
"est2.mRestituted": "반환됨",
"est2.mStorage": "보관 중",
"est2.monthlyTotal": "월간 총합",
"est2.nameLabel": "이름 *",
"est2.namePh": "예: 벨몬트 호텔 — 리옹 부가관",
"est2.newEst": "새로운 시설",
"est2.onQuote": "견적 중",
"est2.phoneLabel": "전화",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "플랜",
"est2.planLimited": "당신의 “{tier}” 플랜은 {max} 시설로 제한됩니다.",
"est2.primary": "기본",
"est2.qr": "QR 코드",
"est2.qrDesc": "이 QR 코드를 해당 시설에 표시합니다. 분실 신고를 한 고객은 이 사이트로 연결됩니다.",
"est2.qrTitle": "QR 코드 — {name}",
"est2.saving": "저장 중…",
"est2.seeInvoices": "내 월별 청구서 보기",
"est2.seePlans": "플랜 보기",
"est2.subtitle": "하나의 계정으로 모든 사이트를 관리하세요 — 통합된 보기, 항목, QR 코드 및 청구.",
"est2.suspended": "중단됨",
"est2.tierFree": "1 시설",
"est2.tierLarge": "무제한 시설",
"est2.tierMedium": "포함된 5 시설",
"est2.tierSmall": "포함된 3 시설",
"est2.title": "시설",
"est2.unlimitedPlan": "당신의 플랜은 무제한 시설을 허용합니다.",
"est2.unlimitedSuffix": " · 무제한",
"est2.updated": "시설 업데이트됨",
"est2.upgradeHint": "더 높은 플랜으로 업그레이드하여 더 많은 사이트를 추가하고 모든 활동을 중앙 집중화하세요.",
"est2.visuals": "로고 및 사진",
"est2.visualsDesc": "이 시설의 로고와 커버 사진을 사용자 정의하세요. 이들은 공개 페이지와 선언서에 나타납니다.",
"est2.visualsTitle": "비주얼 — {name}",
"est2.workOn": "이 시설 작업하기",
"est2.working": "당신은 “{name}”에서 작업 중입니다.",
"ft.backAccount": "내 계정으로 돌아가기",
"ft.closeBtn": "사례 닫기",
"ft.closeConfirm": "물품이 반환되었습니까? 광고가 닫힙니다.",
"ft.closeLockedHint": "닫기를 해제하려면 먼저 소유자의 코드를 확인하세요.",
"ft.closed": "사례가 닫혔습니다 — 물품이 반환되었습니다!",
"ft.codeLabel": "소유자로부터 받은 확인 코드를 입력하세요",
"ft.codeNeeded": "확인 코드를 입력하세요.",
"ft.codeOk": "코드가 확인되었습니다 — 사례를 닫을 수 있습니다.",
"ft.codePlaceholder": "예: 4821",
"ft.codeVerified": "확인됨",
"ft.doneMsg": "물품이 반환되었습니다. 소유자에게 다시 전달해 주셔서 감사합니다!",
"ft.stepInProgress": "반환 진행 중",
"ft.stepPublished": "광고 게시됨",
"ft.stepReturned": "물품 반환됨",
"ft.subtitle": "찾은 물품이 반환될 때까지 단계를 따르세요.",
"ft.title": "반환 추적",
"ft.verifyBtn": "코드 확인",
"inv2.contractTitle": "내 Findloop 계약",
"inv2.detailByEst": "시설별 세부 정보",
"inv2.dueLabel": "기한:",
"inv2.dueSuffix": " · {date} 기한",
"inv2.error": "오류 {status}",
"inv2.estCountIssued": "{n} 시설 · {date}에 발행됨",
"inv2.estimate": "견적 (청구되지 않음) · {n} 시설",
"inv2.expired": " · 만료됨",
"inv2.exportCsv": "CSV 내보내기",
"inv2.exportDone": "CSV 내보내기 다운로드 완료",
"inv2.included": "포함됨",
"inv2.monthlyTitle": "월별 청구 (구독)",
"inv2.months": "+{n} 개월",
"inv2.paid": "지급됨",
"inv2.pay": "지급하기",
"inv2.previewTitle": "다음 청구서 미리보기 —",
"inv2.renew": "계약 갱신하기",
"inv2.renewalsTitle": "갱신 이력 ({n})",
"inv2.renewedUntil": "계약 갱신됨: {date}까지",
"inv2.serviceTitle": "서비스 청구서 (회수 및 견적)",
"inv2.soon": "곧 만료됨",
"inv2.toPay": "지급할 금액",
"inv2.totalHtTva": "세금 제외 총액 · VAT",
"inv2.totalTtc": "세금 포함 총액",
"iu.addPhoto": "사진 추가",
"iu.change": "변경",
"map.high": "높음",
"map.legend": "반환률에 따라 빨간색(낮음)에서 녹색(높음)까지 색상 점; 아이템 수에 따라 크기 조정.",
"map.locating": "위치 찾는 중… 주소를 추가하여 지도에 표시하세요.",
"map.low": "낮음",
"map.medium": "중간",
"map.noItemRegistered": "등록된 아이템 없음",
"map.noItems": "아이템 없음",
"map.returnedSuffix": "반환됨 · {a}/{t} 아이템",
"map.title": "내 시설의 지도",
"mc.archiveHide": "기록 숨기기",
"mc.archiveNone": "아직 해결된 사례가 없습니다.",
"mc.archiveShow": "기록 보기",
"mc.archiveSub": "해결되고 반환된 사례입니다.",
"mc.archiveTitle": "기록",
"mc.certificate": "증명서",
"mc.finderAccepted": "수락됨",
"mc.hAd": "잃어버린 광고",
"mc.hDeclaration": "신고",
"mc.hFinderContact": "신고된 아이템",
"mc.hFound": "반환된 아이템",
"mc.hFoundAd": "발견된 광고",
"mc.myFinds": "내가 발견한 아이템",
"mc.myFindsNone": "아직 발견한 아이템을 신고하지 않았습니다.",
"mc.myFindsSub": "잃어버린 아이템 광고에서 발견을 신고한 아이템입니다.",
"mc.notifOpen": "보기",
"mc.notifTrack": "추적",
"mc.notifViewAd": "광고 보기",
"mc.presentHint": "이 QR코드를 파트너에게 보여주세요: 그들이 스캔하여 보상을 확인합니다.",
"mc.presentInStore": "매장에서 보여주기",
"mc.presentTitle": "이 바우처 보여주기",
"mc2.acceptFinder": "이 찾는 사람 수락하기",
"mc2.accountActivity": "계정 활동",
"mc2.adsActive": "{n}/5 활성 광고",
"mc2.autoDelete": "자동 삭제 예약됨",
"mc2.badgeBronze": "브론즈",
"mc2.badgeGold": "골드",
"mc2.badgeSilver": "실버",
"mc2.boostEarnedAlready": "이미 획득하셨습니다",
"mc2.boostEarnedWin": "획득하셨습니다",
"mc2.boostExpiredWin": "귀하의 보너스가 방금 만료되었습니다 — -20%로 재개하세요!",
"mc2.boostExpiresIn": "귀하의 보너스가 만료됨",
"mc2.boostWinDetail2": ". 24시간 이내에 갱신하면 자동으로 -20% 적용됩니다.",
"mc2.claimCode": "청구 코드:",
"mc2.codeSentFinder": "찾는 사람에게 이메일로 전송된 코드",
"mc2.daysShort": "{n}일",
"mc2.downloadReceipt": "영수증 다운로드",
"mc2.error": "오류 {status}",
"mc2.finderAccepted": "파인더 승인됨 — 코드가 이메일로 전송되었습니다",
"mc2.finderContacts": "파인더 연락처 정보",
"mc2.followFindo": "Findloop 팔로우하기",
"mc2.imgInvalid": "유효하지 않은 이미지",
"mc2.inactivityNote": " — 비활동 {n}개월 시 (GDPR).",
"mc2.lastActivity": "마지막 활동:",
"mc2.lostEmailTitle": "이메일에 더 이상 접근할 수 없습니다",
"mc2.noPhotoPreset": "아직 사진이 없나요? 기본 아바타를 선택하세요:",
"mc2.paidViaPartner": "결제 완료 (파트너를 통해)",
"mc2.payRecovery": "복구 수수료를 지불하세요",
"mc2.paySettle": "내 결제를 정산하세요",
"mc2.payShipping": "배송료를 지불하세요",
"mc2.payUnavailable": "결제 불가능",
"mc2.peopleFound": "{n}명(이) 귀하의 물건을 찾은 것 같습니다",
"mc2.phoneNumber": "전화번호",
"mc2.reactivateAccount": "내 계정을 재활성화하기",
"mc2.reactivated": "계정 재활성화됨",
"mc2.reactivatedThanks": "계정이 재활성화되었습니다 — 당신의 충성도에 감사드립니다!",
"mc2.recoverSmsBtn": "SMS로 코드 받기",
"mc2.recoverSmsDesc": "계정에 등록된 번호로 SMS로 청구 코드를 받으세요.",
"mc2.recoverSmsFallback": "이 번호로 계정이 존재하는 경우, SMS가 전송되었습니다.",
"mc2.renewStayTop": ". 최상위를 유지하고 귀하의 물건을 복구하기 위해 갱신하세요.",
"mc2.resume20": "재개 -20%",
"mc2.unlockContacts": "연락처 정보 잠금 해제",
"mc2.unlockDesc": "파인도 처리 수수료를 지불하여 연락처 정보를 공개하고 인수인계를 설정하세요.",
"mc2.viewsWord": "조회수",
"mc2.live": "실시간",
"mh.allCategories": "모든 카테고리",
"mh.allPeriod": "전체 기간",
"mh.autoMatch": "자동 AI 매칭",
"mh.blocked": "차단됨 (모순)",
"mh.blockedReason": "매치 차단됨: 아이템의 주요 키워드와 선언이 서로 모순됩니다.",
"mh.days30": "지난 30일",
"mh.days7": "지난 7일",
"mh.days90": "지난 90일",
"mh.emptyDesc": "AI 매치는 선언이 들어오면 여기 나타납니다.",
"mh.emptyTitle": "이벤트 없음",
"mh.exportCsv": "CSV 내보내기",
"mh.exportDone": "CSV 내보내기 완료됨",
"mh.exportImpossible": "내보내기 실패",
"mh.fBlocked": "차단됨",
"mh.fConfirmed": "확인됨",
"mh.fRejected": "거부됨",
"mh.objectLabel": "아이템:",
"mh.refresh": "새로 고침",
"mh.rejected": "거부됨",
"mh.srcManual": "수동",
"mh.srcText": "텍스트",
"mh.srcVisual": "비주얼 (사진)",
"mh.subtitle": "AI가 제안한 매치 기록 — 자동 매칭, 확인 및 거부됨.",
"mh.title": "AI 기록",
"nf.desc": "찾고 있는 페이지가 존재하지 않거나 이동되었습니다.",
"nf.home": "홈으로 돌아가기",
"nf.title": "페이지를 찾을 수 없습니다",
"par.allCities": "모든 도시",
"par.cityPh": "도시",
"pay.eurNote": "금액은 유로(€)로 표시됩니다.",
"pg.next": "다음",
"pg.prev": "이전",
"pg.showing": "{from}–{to} 중 {total}",
"pk.bodyCopy": "본문 복사",
"pk.bodyText": "본문 텍스트",
"pk.brandColors": "브랜드 색상",
"pk.colorRed": "빨강",
"pk.colorWhite": "흰색",
"pk.darkBg": "어두운 배경",
"pk.download": "다운로드",
"pk.downloadZip": "전체 키트 다운로드 (ZIP)",
"pk.headings": "제목",
"pk.heroDesc": "<b>공식 로고</b>, <b>소셜 미디어 배너</b>, 색상 및 타이포그래피. 태그라인 언어와 변형을 선택한 후, 비주얼 또는 전체 키트를 다운로드하세요.",
"pk.lightBg": "밝은 배경 (인쇄)",
"pk.logoWordmark": "로고 / 워드마크",
"pk.logosVisuals": "로고 및 비주얼",
"pk.mapCollect": "지도 / 수집 지점",
"pk.plain": "일반",
"pk.pressKit": "언론 키트",
"pk.taglineLang": "태그라인 언어",
"pk.typography": "타이포그래피",
"pk.variant": "변형",
"pr2.adBoostMsg": "훌륭한 선택입니다! 아이템을 빠르게 회수할 확률이 높아집니다.",
"pr2.boostActivated": "부스트 활성화됨!",
"pr2.canRecoverNow": "이제 아이템을 회수할 수 있습니다.",
"pr2.continue": "계속",
"pr2.downloadReceiptPdf": "영수증 다운로드 (PDF)",
"pr2.goToSpaceNow": "지금 내 계정으로 가기",
"pr2.partnerBoostMsg": "훌륭한 선택입니다! 더 많이 보이는 것은 고객을 끌어들이는 것을 의미합니다.",
"pr2.paymentSuccess": "결제 성공!",
"pr2.redirectingSpace": "계정으로 리디렉션 중…",
"pr2.subActivated": "결제 성공! 구독이 활성화되었습니다. 이제 시설을 관리할 수 있습니다.",
"prev.allSites": "모든 시설",
"pricing.annual": "연간",
"pricing.annualBadge": "-20% 혜택",
"pricing.monthly": "월간",
"pricing.perYear": "/년",
"pricing.saveLabel": "절약하신 금액",
"pricing.savePerYear": "/년당 추가 시설",
"pub.accessGranted": "접근 허용됨",
"pub.accessLimited2h": "2시간으로 제한된 접근",
"pub.accountEmailConcerned": "관련 계정의 이메일",
"pub.adAppearPublic": "광고가 공개적으로 어떻게 표시될지입니다.",
"pub.adPreviewBtn": "광고 미리보기",
"pub.alertMeOnArrival": "도착 시 알림",
"pub.allActionsLogged": "모든 작업이 기록됨",
"pub.allCategories": "모든 카테고리",
"pub.authorizeAccess": "접근 허용",
"pub.authorizeSupportQ": "지원 접근 허용?",
"pub.available": "사용 가능",
"pub.backHome": "홈으로 돌아가기",
"pub.boostAdCta": "내 광고 부스트",
"pub.boostAdTitle": "내 광고를 부스트하세요",
"pub.boostCarouselSub": "부스트된 캐러셀의 상단으로 이동하여 조회수를 늘리고 아이템을 더 빨리 회수하세요.",
"pub.boostEstablishment": "내 시설 부스트",
"pub.boostEstablishmentDesc": "부스트된 배지와 함께 디렉토리 상단에 나타나고 더 많은 신고를 유도하세요.",
"pub.boostFicheCta": "내 목록 부스트",
"pub.brandReady": "사용 준비 완료된 Findloop 브랜드",
"pub.cantFindItem": "아이템을 찾을 수 없나요?",
"pub.cantProcessImage": "이 이미지를 처리할 수 없습니다.",
"pub.claimQr": "QR 코드 주장",
"pub.clickToZoom": "클릭하여 확대",
"pub.codeAlreadyValidated": "코드가 확인되었습니다 — 연락처가 잠금 해제되었습니다.",
"pub.codeExample": "예: ABCD2345",
"pub.confirmRenewal": "갱신 확인",
"pub.contactIntro": "질문이나 요청이 있으신가요? 저희에게 연락해 주시면 곧 답변 드리겠습니다.",
"pub.contactTypeDeceased": "계정 삭제 (고인)",
"pub.contactTypeGeneral": "일반 질문",
"pub.contactTypeSupport": "지원 / 기술 문제",
"pub.contactUs": "연락하기",
"pub.continueWithoutEmail": "이메일을 남기지 않고 계속하기",
"pub.contractLabel": "계약",
"pub.contractNotFound": "계약을 찾을 수 없거나 이미 만료되었습니다.",
"pub.contractRenewed": "계약이 갱신되었습니다!",
"pub.contractRenewedFor": "귀하의 계약은 {n}개월 동안 갱신되었습니다.",
"pub.copyFailed": "복사 실패",
"pub.createPartnerAccount": "내 파트너 계정 만들기",
"pub.currentDeadline": "현재 마감일",
"pub.deceasedInfo": "친척 또는 상속인으로서 고인의 Findloop 계정 삭제를 요청할 수 있습니다. GDPR에 따라 요청을 처리하며, 필요한 경우 지원 서류를 요청할 수 있습니다.",
"pub.declareMyLoss": "내 손실 신고하기",
"pub.describeItemPlaceholder": "물품을 설명하세요 (예: 검은 우산, 열쇠…)",
"pub.downloadImage": "이미지 다운로드",
"pub.drawSignature": "서명을 그려주세요.",
"pub.drawSignatureHint": "마우스나 손가락으로 서명을 그리세요.",
"pub.duration": "기간",
"pub.eSignature": "전자 서명",
"pub.eSignatureDesc": "서명할 이름을 입력하세요. 날짜는 자동으로 기록됩니다.",
"pub.edit": "편집",
"pub.editorialTitles": "편집 제목",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "소유자의 연락처 정보를 잠금 해제하기 위해 이메일로 받은 코드를 입력하세요.",
"pub.errorWord": "오류",
"pub.foundSelfService": "발견된 항목 · 셀프 서비스",
"pub.haveOwnerCode": "소유자로부터 코드를 받았습니다",
"pub.home": "홈",
"pub.immediateRenewal": "새 견적 없이 즉시 갱신합니다.",
"pub.impAdminReq1": "관리자",
"pub.impAdminReq2": "귀하의 계정에 일시적으로 접근할 권한을 요청합니다",
"pub.impAdminReq3": "도움을 드리기 위해서입니다.",
"pub.impGrantedDesc": "지원팀은 귀하의 계정에 최대 2시간 동안 접근할 수 있습니다. 모든 작업은 기록됩니다. 이 페이지를 닫을 수 있습니다.",
"pub.invitedOnFindo": "findloop에 초대되었습니다",
"pub.isThisYourItem": "이것이 귀하의 물품인가요?",
"pub.itemsAvailableCount": "{n}개 항목이 현재 이용 가능합니다",
"pub.itemsFoundOwner": "위탁된 물품의 주인을 찾았습니다",
"pub.itemsReturnedOwners": "주인에게 반환된 물품",
"pub.itsMine": "내 것입니다",
"pub.joinFindoDesc": "findloop에 가입하고 귀하의 발견한 물품을 쉽게 관리하세요.",
"pub.joinInvitesYou": "귀하를 findloop에 초대합니다. 발견한 물품을 관리하기 위해 파트너 계정을 만드세요.",
"pub.linkCopied": "링크가 복사되었습니다!",
"pub.loadingContract": "계약 로딩 중…",
"pub.lsClaimDesc": "손실 신고를 통해 회수하세요. 이메일을 남기시면 신고가 완료되지 않았을 경우 알림을 보내드립니다.",
"pub.lsHeroDesc": "자신의 물품이 발견되어 여기 남겨졌는지 확인하세요. 발견하셨나요? 회수하려면 신고하세요.",
"pub.lsSearchTitle": "발견된 물품 검색",
"pub.makeOffer": "제안하기",
"pub.makeOfferDesc": "금액을 제안하세요. 슈퍼 관리자 검토 후 진행합니다.",
"pub.mapNearYou": "주변의 물품 및 파트너",
"pub.mapWord": "지도",
"pub.messageSentToast": "메시지를 보냈습니다 — 저희 팀이 곧 답변 드리겠습니다.",
"pub.messageWord": "메시지",
"pub.momoInitiated": "모바일 머니 결제 시작됨",
"pub.monthsWord": "개월",
"pub.nameConsentRequired": "이름과 동의가 필요합니다.",
"pub.newDeadline": "새 마감일",
"pub.noActionRequired": "조치가 필요하지 않습니다.",
"pub.noAmountCharged": "청구된 금액이 없습니다.",
"pub.noItemMatch": "현재 검색 결과와 일치하는 항목이 없습니다.",
"pub.noMatchingItem": "일치하는 항목 없음",
"pub.noPaymentSession": "결제 세션이 없습니다.",
"pub.noPhoto": "사진이 없습니다.",
"pub.noPointsYet": "표시할 포인트가 없습니다.",
"pub.noSecondPayment": "이 항목에 대한 두 번째 결제가 필요하지 않습니다.",
"pub.notHereYet": "아직 도착하지 않았나요? 도착하는 대로 알림을 받으세요.",
"pub.notifyDone": "알림받을게요! 일치하는 항목이 도착하는 대로 이메일로 알려드리겠습니다.",
"pub.offerSubmitted": "제안이 제출되었습니다.",
"pub.oops": "오ops",
"pub.orAlertEmail": "또는 일치하는 항목이 도착하는 대로 이메일로 알림을 받으세요:",
"pub.ownerContacts": "소유자 연락처",
"pub.ownerContactsUnlocked": "소유자 연락처가 해제되었습니다.",
"pub.partnerContact": "파트너 연락처",
"pub.payLinkUnavailable": "결제 링크를 사용할 수 없습니다 — 파트너에 문의하세요.",
"pub.paymentCancelled": "결제가 취소되었습니다.",
"pub.paymentConfirmed": "결제가 확인되었습니다 🎉",
"pub.paymentConfirmedDesc": "귀하의 항목을 복구하는 데 필요한 세부 정보를 담은 이메일을 받게 됩니다.",
"pub.paymentNotConfirmed": "결제가 확인되지 않았습니다.",
"pub.paymentNotConfirmedDesc": "결제를 확인할 수 없습니다. 다시 시도하거나 파트너에 문의하세요.",
"pub.paymentProcessing": "결제가 처리되고 있습니다. 잠시 후 새로 고침하세요.",
"pub.photoAdded": "✓ 사진이 추가되었습니다.",
"pub.photoRequired": "항목의 사진이 필요합니다.",
"pub.previewAlt": "미리보기",
"pub.publish": "발행",
"pub.publishingWord": "발행 중…",
"pub.qty": "수량",
"pub.quoteDeclined": "견적이 거부되었습니다.",
"pub.quoteNotFound": "견적을 찾을 수 없거나 만료되었습니다.",
"pub.reasonLabel": "사유",
"pub.recoveryAlreadyPaid": "회수 수수료가 이미 지불되었습니다.",
"pub.referralCode": "추천 코드:",
"pub.relationshipPlaceholder": "아들, 배우자, 공증인…",
"pub.renewYourContract": "계약 갱신하기",
"pub.renewalFailed": "갱신에 실패했습니다. 나중에 다시 시도하세요.",
"pub.renewing": "갱신 중…",
"pub.replySoon": "우리 팀이 가능한 한 빨리 답변 드리겠습니다.",
"pub.requestGone": "이 요청은 더 이상 존재하지 않습니다.",
"pub.requestHandled": "요청이 이미 처리되었습니다.",
"pub.requestNotFound": "요청을 찾을 수 없거나 만료되었습니다.",
"pub.requestUnavailable": "요청을 사용할 수 없습니다.",
"pub.required": "(필수)",
"pub.retroClosing": "함께, 우리는 세상을 조금 덜 잃게 만듭니다.",
"pub.retroClosing2": "함께, 우리는 세상을 조금 덜 잃게 만듭니다.",
"pub.retroScroll": "중요한 것을 회수한 한 해. 아래로 스크롤하세요 ↓",
"pub.revokeAnytime": "언제든지 저희에게 연락하여 철회할 수 있습니다.",
"pub.scene": "장면",
"pub.sendImpossible": "전송할 수 없습니다.",
"pub.sendMessage": "메시지 전송",
"pub.sending": "전송 중…",
"pub.sharePreview": "미리보기 공유",
"pub.shareYourAd": "광고 공유",
"pub.signedSuccess": "성공적으로 서명했습니다!",
"pub.signerFullName": "서명자의 전체 이름",
"pub.spreadNetwork": "주변 사람들과 공유하여 기회를 높이세요.",
"pub.spreadOwner": "소유자가 소지품을 회수할 수 있도록 공유하세요.",
"pub.statusLabel": "상태:",
"pub.subject": "주제",
"pub.thanksSent": "감사합니다, 귀하의 메시지가 전송되었습니다.",
"pub.thisYear": "올해",
"pub.validate": "검증",
"pub.verifyingPayment": "결제 검증 중…",
"pub.verifyingYourPayment": "귀하의 결제 검증 중…",
"pub.viewAd": "광고 보기 →",
"pub.viewPartner": "파트너 보기 →",
"pub.yourAdPreview": "귀하의 광고 미리보기",
"pub.yourEmail": "귀하의 이메일",
"pub.yourEmailRecommended": "귀하의 이메일 (추천)",
"pub.yourEmailShort": "귀하의 이메일",
"pub.yourName": "귀하의 이름",
"pub.yourRelationship": "대상과의 관계",
"qv.acceptAndSign": "내 견적을 수락하고 서명하기",
"qv.certifyAuthorized": "서명할 권한이 있음을 인증하며, 이 {what} (구속력 있는 가치)의 조건을 수락합니다.",
"qv.clear": "초기화",
"qv.client": "클라이언트",
"qv.conditions": "조건",
"qv.confirmDecline": "이 견적의 거부를 확인하시겠습니까?",
"qv.countersignedFindo": "findloop에 의해 공동 서명됨 · {name} {date}에",
"qv.decline": "거부",
"qv.description": "설명",
"qv.downloadPdf": "PDF 다운로드",
"qv.handwrittenSignature": "손으로 쓴 서명",
"qv.inclTax": "세금 포함",
"qv.invalidAmount": "유효하지 않은 금액입니다.",
"qv.invoice": "청구서",
"qv.invoicePaid": "청구서가 지불되었습니다",
"qv.issuer": "발행자",
"qv.messageOptional": "메시지 (선택 사항)",
"qv.negotiatedAmount": "협상된 금액",
"qv.payInvoiceOnline": "온라인으로 청구서 지불하기",
"qv.quote": "견적",
"qv.quoteValidDays": "견적은 {n}일 동안 유효합니다.",
"qv.sendMyOffer": "내 제안 보내기",
"qv.signContract": "내 계약에 서명하기",
"qv.signNow": "지금 서명하기",
"qv.signatureAlt": "서명",
"qv.signedByOn": "✔ {name} {date}에 서명됨",
"qv.stContractSigned": "계약이 서명되었습니다. 감사합니다!",
"qv.stCounterAccepted": "귀하의 제안이 수락되었습니다! 아래 계약에 서명하세요.",
"qv.stCounterRefused": "귀하의 제안이 수락되지 않았습니다.",
"qv.stCountered": "귀하의 제안이 제출되었습니다. findloop의 응답을 기다리고 있습니다.",
"qv.stDeclined": "귀하는 이 견적을 거부하였습니다.",
"qv.stSigned": "견적이 수락되고 서명되었습니다. 감사합니다!",
"qv.totalHt": "총액 (세금 제외)",
"qv.totalTtc": "총액 (세금 포함)",
"qv.unitHt": "단가 (세금 제외)",
"qv.vat": "부가가치세",
"qv.yourProposedAmount": "귀하의 제안 금액 ({cur})",
"reg.add": "항목 추가",
"reg.allBrands": "모든 브랜드",
"reg.allColors": "모든 색상",
"reg.allLocations": "모든 위치",
"reg.detailDesc": "이 발견된 항목에 대한 세부정보 및 작업.",
"reg.dispAuction": "경매",
"reg.dispAuthorities": "당국에 전달됨",
"reg.dispDestroyed": "파괴됨",
"reg.dispDonate": "자선 기부",
"reg.dispositionHint": "저장소에서 항목을 기록합니다. 카테고리별로 통계에 포함됩니다.",
"reg.emptyCta": "항목 추가",
"reg.emptyDesc": "첫 번째 발견 항목을 기록하는 것으로 시작하세요.",
"reg.emptyTitle": "찾은 항목이 없습니다",
"reg.establishmentFallback": "기관",
"reg.lblAuctioned": "경매에 등록됨",
"reg.lblAuctionedShort": "경매",
"reg.lblAuthorities": "당국에 인계됨",
"reg.lblDestroyed": "파기됨",
"reg.lblDonated": "자선단체에 기부됨",
"reg.legalCount": "{n} 항목: 법적 보존 기간 도달",
"reg.legalHint": "경매에 등록하거나, 자선단체에 기부하거나, 당국에 인계했다고 신고할 수 있습니다.",
"reg.legalLimitCountry": "마감일: {date} · 적용 국가: {country}",
"reg.legalOver": "마감일 초과: {date} · {country}",
"reg.legalReached": "법적 기간 도달",
"reg.legalReachedFull": "법적 보존 기간 도달",
"reg.limitShort": "마감일",
"reg.location": "위치",
"reg.markRestituted": "반환으로 표시",
"reg.markedAs": "항목이 {label}로 표시됨",
"reg.moveHistory": "이동 기록",
"reg.overBy": "{n}일 초과",
"reg.physicalLocation": "실제 위치",
"reg.popupBlocked": "레이블 인쇄를 위해 팝업을 허용하세요.",
"reg.popupBlockedOne": "레이블 인쇄를 위해 팝업을 허용하세요.",
"reg.printLabel": "라벨 인쇄",
"reg.printN": "{n} 개 라벨 인쇄",
"reg.qrCodeItem": "항목 QR 코드",
"reg.qrLabelTitle": "QR 라벨",
"reg.qrLabelsTitle": "QR 라벨들",
"reg.qrNotFound": "이 QR 코드로 찾은 항목이 없습니다.",
"reg.qrScanHint": "스캔하여 이 기록을 직접 열고 위치를 찾으세요.",
"reg.recoveryFee": "회수 수수료 (€)",
"reg.searchPh": "설명으로 검색…",
"reg.selectQr": "QR 라벨 인쇄 선택",
"reg.selectedN": "{n} 선택됨",
"reg.shipPricePh": "배송 가격 (€)",
"reg.shippingPossible": "배송 가능",
"reg.storagePh": "예: 선반 A3, 사물함 12",
"reg.tAuction": "findloop의 경매",
"reg.tAuthorities": "당국에 인계 신고",
"reg.tDonate": "자선단체에 기부",
"reg.toastFee": "요금이 업데이트되었습니다",
"reg.toastLocation": "위치가 저장되었습니다",
"reg.toastRestituted": "항목이 반환으로 표시되었습니다",
"reg.toastShipping": "배송 옵션이 업데이트되었습니다",
"reg.toastTransferred": "항목이 “{name}”에게 전송되었습니다",
"reg.unclaimedDisposition": "청구되지 않은 항목 — 최종 처리",
"res.codeValidated": "코드가 검증되었습니다",
"res.empty": "아직 반환 기록이 없습니다.",
"res.error": "오류 {status}",
"res.proofPdf": "PDF 증명서",
"res.signed": "서명됨",
"res.stRestituted": "직접 인계됨",
"res.stShipped": "배송으로 반환됨",
"res.subtitle": "다운로드 가능한 서명 증명이 포함된 모든 완료된 인계.",
"res.title": "반환 역사",
"rev.restitutedBy": "{org}에 의해 반환됨",
"rev.storiesEyebrow": "행복한 결말들",
"rev.storiesSubtitle": "findloop를 통해 소중한 물건을 되찾은 고객들의 실제 이야기입니다.",
"rev.storiesTitle": "그들은 소중한 물건을 찾았습니다!",
"rp.already": "이미 이 목록을 신고하셨습니다.",
"rp.duplicate": "중복",
"rp.inappropriate": "부적절한 콘텐츠",
"rp.wrongCategory": "잘못된 카테고리",
"rt.annualGoal": "연간 목표",
"rt.championCity": "챔피언 도시",
"rt.cityRate": "{rate}% 반환율",
"rt.goalProgress": "{rate}% 달성, {target}% 목표",
"rt.reached": "도달했습니다 🎉",
"rt.restitutionRate": "반환율",
"rt.shareRecap": "내 요약 공유",
"rt.thanks": "감사합니다 Findloop {year} 💛",
"rt.yourRecap": "당신의 {year} 요약",
"rw.active": "활성",
"rw.add": "추가",
"rw.camUnavailable": "카메라를 사용할 수 없습니다. 아래에 코드를 수동으로 입력하세요.",
"rw.codeValidated": "코드가 검증됨",
"rw.codesTitle": "리더가 교환한 코드",
"rw.confirmDelete": "“{title}” 삭제?",
"rw.deleted": "삭제됨",
"rw.edit": "편집",
"rw.editReward": "보상 편집",
"rw.empty": "아직 보상이 없습니다.",
"rw.expired": "만료됨",
"rw.expiresOn": "만료일: {date}",
"rw.fActive": "활성 (리더에게 보임)",
"rw.fCost": "비용 (포인트)",
"rw.fDesc": "설명",
"rw.fStock": "재고 (빈칸 = 무제한)",
"rw.fTitle": "제목",
"rw.fValidity": "바우처 유효성 (교환 후 일수)",
"rw.inactive": "비활성",
"rw.newReward": "새 보상",
"rw.noExchange": "아직 교환하지 않음.",
"rw.pageSubtitle": "리더가 제시한 바우처를 스캔하여 보상을 검증하세요.",
"rw.redeemedN": "교환됨: {n}×",
"rw.saved": "보상 저장됨",
"rw.scanVoucher": "바우처 스캔",
"rw.staffScanOnly": "스캔 전용",
"rw.statActive": "제공 중",
"rw.statExpired": "만료됨",
"rw.statRedeemed": "교환된 바우처",
"rw.statUsed": "검증됨",
"rw.stock": "재고",
"rw.subtitle": "리더가 Finder Score 포인트와 교환할 수 있는 비금전적 혜택(바우처, 업그레이드 등)을 제공합니다.",
"rw.title": "리더를 위한 보상",
"rw.used": "사용됨",
"rw.validate": "검증",
"rw.validateCode": "코드 검증",
"rw.validity": "유효성: {n} 일",
"side.establishments": "시설",
"side.restitutions": "반환",
"side.rewards": "보상 및 바우처",
"side.settings": "설정",
"side.storage": "저장소 및 QR",
"status.auctioned": "경매됨",
"status.destroyed": "파기됨",
"status.donated": "기부됨 (자선)",
"status.handed_to_authorities": "당국에 전달됨",
"status.in_storage": "저장 중",
"status.matched": "일치함",
"status.open": "열림",
"status.paid": "지급됨",
"status.pending": "대기 중",
"status.restituted": "반환됨",
"status.shipped": "배송됨",
"status.shipping_requested": "배송 요청됨",
"status.submitted": "제출됨",
"stg.allLabels": "모든 QR 라벨",
"stg.camHint": "아래 수동 입력을 사용하세요.",
"stg.camStarting": "카메라 시작 중…",
"stg.camUnavailable": "카메라를 사용할 수 없습니다.",
"stg.clear": "지우기",
"stg.clearAll": "모두 지우기",
"stg.codeUnreadable": "읽을 수 없는 코드입니다.",
"stg.emptyDesc": "저장된 항목이 여기에 위치별로 그룹화되어 나타납니다.",
"stg.emptyTitle": "저장소에 항목이 없습니다",
"stg.exportAudit": "감사 CSV 내보내기",
"stg.exportDone": "CSV 내보내기 완료",
"stg.exportImpossible": "현재 내보내기를 사용할 수 없습니다.",
"stg.itemFound": "항목을 찾았습니다 ✅",
"stg.kLocations": "사용된 위치",
"stg.kObjects": "저장된 항목",
"stg.kToClear": "지울 위치",
"stg.locFreed": "위치가 지워졌습니다",
"stg.locsFreed": "{n} 위치가 지워졌습니다",
"stg.manualLabel": "또는 항목의 코드 / ID를 입력하세요",
"stg.manualPh": "QR의 ID 또는 URL을 붙여넣으세요",
"stg.noItemMatch": "이 QR / 코드에 해당하는 항목이 없습니다.",
"stg.noLocation": "위치 없음",
"stg.objectsAxis": "항목",
"stg.objectsN": "{n} 항목",
"stg.occAvg": "위치당 평균 {n} 항목",
"stg.occHint": "호황 지역은 평균을 초과합니다(과밀 가능성 있음).",
"stg.occupancy": "위치 점유율",
"stg.openPage": "페이지 열기",
"stg.posterPdf": "PDF 포스터 (A4)",
"stg.printAll": "모두 인쇄하기",
"stg.printGroupTitle": "이 선반의 라벨 인쇄",
"stg.qrAlt": "셀프 서비스 QR",
"stg.qrDownload": "QR 다운로드",
"stg.qrHint": "이 QR을 카운터에 표시하세요: 고객이 스캔하여 해당 항목이 사용 가능한지 확인합니다.",
"stg.qrTitle": "고객 셀프 서비스 QR",
"stg.scanDesc": "항목의 라벨을 스캔하여 즉시 기록을 엽니다.",
"stg.scanQr": "QR 스캔",
"stg.scanTitle": "QR 코드 스캔",
"stg.search": "검색",
"stg.shelf": "선반 {loc}",
"stg.shelfPlan": "선반 계획",
"stg.staleHint": "이 위치를 지워 실제 재고를 최신 상태로 유지하세요.",
"stg.staleTitle": "{n} 항목이 저장소를 떠났지만 여전히 위치를 유지하고 있습니다",
"stg.subtitle": "선반 계획, QR 스캐너 및 물리적 재고 추적.",
"stg.title": "저장소 & QR",
"stt.acceptRate": "수용률",
"stt.accepted": "수용됨",
"stt.activity30": "활동 (최근 30일)",
"stt.ai6mo": "최근 6개월 · 수용됨 = 자동 일치 + 확인됨.",
"stt.aiEmpty": "이 기간 동안 AI 일치 항목이 없습니다.",
"stt.aiTitle": "AI 일치 — 수용됨 vs 거부됨",
"stt.auctionShort": "경매",
"stt.auctionedSold": "경매 (판매됨)",
"stt.authShort": "기관",
"stt.authorities": "기관에 전달됨",
"stt.avgRating": "평균 평점",
"stt.awaitingRestitution": "반환 대기 중인 항목",
"stt.boostClicks": "이번 주 부스트 덕분에 디렉토리에 클릭 수",
"stt.boostInactive": "부스트 비활성화 — 가시성을 위해 활성화하세요",
"stt.certifiedPremium": "프리미엄 인증",
"stt.declarations": "신고",
"stt.destroyed": "파기됨",
"stt.dispoEmpty": "청구되지 않은 항목이 아직 저장소를 떠나지 않았습니다.",
"stt.donatedAssoc": "기부됨 (자선)",
"stt.donatedShort": "기부됨",
"stt.gateCta": "계획 알아보기",
"stt.gateDesc": "기본 통계를 잠금 해제하려면 스타터로 업그레이드하거나, 고급 통계 및 개별 분석을 위해 비즈니스로 업그레이드하세요.",
"stt.gateTitle": "유료 플랜 전용 통계",
"stt.inStorage": "저장소에 있음",
"stt.kItems": "등록된 항목",
"stt.kRate": "반환 비율",
"stt.kRestituted": "반환된 항목",
"stt.kRevenue": "수익 (월)",
"stt.noDeclYet": "아직 신고가 없습니다.",
"stt.recapDownloaded": "요약 다운로드 완료 — 공유 준비 완료!",
"stt.recapError": "요약을 생성할 수 없습니다.",
"stt.recapText": "우리 Findloop {year} 요약: 반환된 항목과 고객 만족도 🎉",
"stt.recapTitle": "Findloop {year} 요약",
"stt.rejected": "거부됨",
"stt.restitutions": "반환",
"stt.shareRecap": "내 {year} 요약 공유",
"stt.topCategories": "가장 많이 신고된 카테고리",
"stt.unclaimedDesc": "카테고리별 파기, 기부 및 경매된 항목의 양.",
"stt.unclaimedTitle": "청구되지 않은 항목 — 저장소를 떠남",
"stt.vsLastWeek": "지난주 대비",
"sub.cancel": "구독 취소",
"sub.cancelAbort": "취소",
"sub.cancelConfirm2": "환불은 이루어지지 않습니다.",
"sub.cancelConfirmBtn": "취소 확인",
"sub.cancelTitle": "구독 취소",
"sub.cancelledToast": "취소가 기록되었습니다.",
"sub.cguAnd": "및",
"sub.cguDesc": "결제 전에 동의를 확인해 주세요.",
"sub.cguLink": "이용 약관",
"sub.cguPay": "결제로 계속하기",
"sub.cguPre": "이용 약관을 읽고 동의합니다.",
"sub.cguRequired": "계속하려면 이용 약관 및 개인정보 처리방침에 동의해야 합니다.",
"sub.cguSuffix": "of findloop.",
"sub.cguTitle": "구독 완료",
"sub.expiresOn": "구독이 만료되는 날짜",
"sub.noProrata": "비례 환불 없음.",
"sub.privacyLink": "개인정보 처리방침",
"sub.renewsOn": "구독 갱신일",
"sub.resume": "재구독",
"sub.resumedToast": "재구독이 확인되었습니다.",
"tier.free": "프리미엄",
"tier.large": "기업",
"tier.medium": "비즈니스",
"tier.small": "스타터",
"tm.add": "추가",
"tm.adminOpt": "관리자 (전체 보기)",
"tm.chooseEst": "업체 선택",
"tm.chooseEstPh": "업체 선택",
"tm.copyFail": "복사 실패",
"tm.copyLink": "링크 복사",
"tm.copyOk": "초대 링크가 복사되었습니다",
"tm.emailHint": "비밀번호 생성을 위한 초대 이메일이 발송됩니다.",
"tm.expiresOn": "{date}에 만료",
"tm.forEmail": " {email}에 대해",
"tm.forbidden": "팀 관리는 계정 소유자에게만 허용됩니다.",
"tm.inviteCreated": "초대 생성됨",
"tm.inviteDesc": "초대 이메일을 통해 팀원이 비밀번호를 생성할 수 있습니다.",
"tm.invitePending": "대기 중인 초대",
"tm.inviteResent": "초대 재전송됨",
"tm.inviteSent": "초대가 이메일로 전송됨",
"tm.inviteTitle": "팀원 초대",
"tm.invitedOn": "{date}에 초대됨",
"tm.linkExpired": "링크가 만료되었습니다",
"tm.memberRemoved": "팀원이 제거되었습니다",
"tm.name": "이름",
"tm.noMembers": "아직 팀원이 없습니다.",
"tm.resendTitle": "초대 재전송",
"tm.role": "역할",
"tm.roleAdmin": "관리자",
"tm.roleOwner": "소유자",
"tm.roleStaff": "직원",
"tm.roleUpdated": "역할 업데이트됨",
"tm.sendInvite": "초대 보내기",
"tm.sending": "전송 중…",
"tm.staffOpt": "직원 (자신의 업체만 볼 수 있음)",
"trk.carrier": "운송업체",
"trk.shipPending": "배송 준비 중 — 발송되면 여기서 추적 번호가 나타납니다.",
"trk.shipTitle": "배송 추적",
"trk.trackShipment": "소포 추적",
"trk.trackingNo": "추적 번호",
"hc.paidViaPartner": "파트너를 통한 결제",
"hc.parcelBeingPrepared": "소포 준비 중",
"hc.parcelDelivered": "소포 배송 완료",
"hc.parcelShipped": "소포 발송됨",
"hc.parisGareDeLyon": "파리, 리옹역…",
"hc.partner": "파트너",
"hc.partner2": "파트너",
"hc.partnerDirectory": "파트너 디렉토리",
"hc.passedOnToTheCustomer": "— 고객에게 결제 링크가 전달되었습니다.",
"hc.password": "비밀번호",
"hc.passwordResetPleaseLogIn": "비밀번호 재설정, 로그인 해주세요.",
"hc.passwordUpdated": "비밀번호가 업데이트되었습니다.",
"hc.passwordsDoNotMatch": "비밀번호가 일치하지 않습니다.",
"hc.pasteThisSenderIdIn": "이 발신자 ID를 Findloop → 설정에 붙여넣으세요.",
"hc.payForTheShipmentOf": "findloop를 통해 안전하게 물품 배송비를 결제하세요.",
"hc.payTheRecoveryFees": "회수 수수료를 결제하세요",
"hc.payTheShippingFees": "배송비를 결제하세요",
"hc.payment": "결제",
"hc.paymentAlreadyConfirmedByThe": "결제가 이미 파트너에 의해 확인되었습니다",
"hc.paymentLinksAreNowConfigured": "결제 링크가 이제 각 업체별로 구성되었습니다",
"hc.paymentNotCompletedYourAccount": "결제가 완료되지 않았습니다. 계정이 생성되지 않았습니다 — 다시 시도해주세요.",
"hc.paymentReceived": "결제를 받았습니다",
"hc.paymentSuccessful": "결제가 성공적으로 완료되었습니다!",
"hc.pdfInvoice": "PDF 송장",
"hc.pending": "대기 중",
"hc.period": "기간",
"hc.phoneNumber": "전화번호",
"hc.phoneOptional": "전화 (선택 사항)",
"hc.planAt": "플랜:",
"hc.planLimitFmt": "당신의 \"{plan}\" 플랜은 {max} 업체로 제한됩니다. {n} 사이트를 관리하려면",
"hc.platformReturnTarget": "플랫폼 반환 목표",
"hc.pleaseCompleteYourShippingAddress": "배송 주소를 완전하게 입력해주세요.",
"hc.pleaseProvideAPhoneNumber": "전화번호를 제공해주세요: 배송을 위해 운송업체에 필요합니다.",
"hc.pleaseProvideAReason": "이유를 제공해주세요.",
"hc.pleaseSetYourOwnPassword": "계속하기 전에 본인의 비밀번호를 설정해주세요.",
"hc.pointsToGoal": "{n}점 더 획득하여 우리의 공동 목표에 도달하세요.",
"hc.posterPreview": "포스터 미리보기",
"hc.potentialMatchBeingVerified": "잠재적 매치 확인 중",
"hc.potentialOwner": "잠재적 소유자",
"hc.preFilledAutomaticallyYouCan": "자동으로 미리 채워졌습니다 — 소포의 사진으로 교체할 수 있습니다.",
"hc.pressKit": "보도 자료",
"hc.previewMode": "미리보기 모드:",
"hc.previewOfThePrintReady": "이 시설의 인쇄 준비가 완료된 A4 포스터 미리보기입니다.",
"hc.previous": "이전",
"hc.previousPhoto": "이전 사진",
"hc.primary": "주요",
"hc.printThePoster": "포스터 인쇄",
"hc.privacy": "개인정보 보호",
"hc.privacyPolicy": "개인정보 보호정책",
"hc.processedCasesWillAppearHere": "처리된 사례가 여기에 나타납니다.",
"hc.proofOfReturnPdf": "반환 증명 (PDF)",
"hc.protectedByRecaptcha": "reCAPTCHA로 보호됨",
"hc.publicMatch": "공개 매칭",
"hc.putBackInStorage": "저장소에 다시 넣기",
"hc.pwdResetByTeam": "귀하의 비밀번호가 저희 팀에 의해 재설정되었습니다. 귀하의 안전을 위해,",
"hc.questionsToAskTheOwner": "소유자에게 물어볼 질문",
"hc.rateChargedToTheCustomer": "고객에게 부과되는 요금:",
"hc.rateOfTarget": "{rate}%가 {target}% 목표에 도달했습니다",
"hc.reached": "도달했습니다",
"hc.reactivating": "다시 활성화 중…",
"hc.reasonSavedYouCanStill": "사유가 저장되었습니다. 여전히 귀하의 아이템을 청구할 수 있습니다.",
"hc.recentMatchesFirst": "최근 매칭 우선",
"hc.recognizedThePhotoYouSent": "보낸 사진을 인식하였으며, 이러한 특징을 설명했습니다. 귀하가 소지한 아이템과 일치하는 경우에만 확인하십시오.",
"hc.recommended": "추천",
"hc.recoveryFees": "회수 수수료",
"hc.recoveryFeesArePaidDirectly": "회수 수수료는 파트너 시설에 직접 지급됩니다. findloop는 고객으로부터 어떠한 수수료도 받지 않습니다.",
"hc.recoveryFeesEnabled": "회수 수수료 사용 가능",
"hc.recoveryOfferedByTheEstablishment": "시설에서 제공하는 회수 — findloop는 수수료를 부과하지 않습니다.",
"hc.recoveryPaymentLink": "회수 결제 링크",
"hc.recoveryPaymentLinkSavedFor": "이 시설의 회수 결제 링크가 저장되었습니다",
"hc.redirecting": "리다이렉트 중…",
"hc.redirectingToPayment": "결제로 리다이렉트 중…",
"hc.redirectingToTheRecoveryOf": "귀하의 아이템 회수를 위해 리다이렉트 중…",
"hc.regenerateAndResendToThe": "생성하여 소유자에게 재전송",
"hc.regenerateTheCode": "코드 재생성",
"hc.registerAFoundItem": "찾은 아이템 등록",
"hc.rejectTheClaim": "청구 거부",
"hc.reminderDelaySaved": "리마인더 지연이 저장되었습니다",
"hc.reopenThePaymentLink": "결제 링크 다시 열기",
"hc.repeatThePassword": "비밀번호 반복",
"hc.reportAProblem": "문제 신고",
"hc.reportDismissedYourListingRemains": "신고가 기각되었습니다. 귀하의 목록은 공개 상태로 유지됩니다.",
"hc.requiredUsedToCalculateThe": "필수: Sendcloud 운송료 계산에 사용됩니다. 30kg 초과 시 배송이 불가능합니다.",
"hc.reset": "초기화",
"hc.resume": "재개",
"hc.resumeRegistration": "등록 재개",
"hc.retro": "올해의 회고",
"hc.returnSecurity": "반품 보안",
"hc.returnToTheOwner": "소유자에게 반환",
"hc.returned": "반환됨",
"hc.reviewTheItemDetails": "상품 세부정보 검토",
"hc.revokeAccess": "액세스 철회",
"hc.role": "역할:",
"hc.save": "저장",
"hc.save2": "저장",
"hc.saveAndContinue": "저장 후 계속",
"hc.saving": "저장 중…",
"hc.scanTheClaimCode": "청구 코드 스캔",
"hc.scanTheOwnerSQr": "소유자의 QR 코드 스캔",
"hc.scrollThroughLanguages": "언어 스크롤",
"hc.searchByCustomerItemOr": "고객, 아이템 또는 추적 번호로 검색…",
"hc.searchForACountry": "국가 검색…",
"hc.secureFindoVerification": "안전한 Findloop 인증",
"hc.seeRetro": "올해의 회고 보기",
"hc.selectedCarrier": "선택된 운송업체:",
"hc.selectedPlan": "선택된 계획",
"hc.send": "보내기",
"hc.sendcloudSenderIdSaved": "Sendcloud 발신자 ID가 저장되었습니다.",
"hc.sendcloudSenderIdSenderId": "Sendcloud 발신자 ID (sender_id)",
"hc.sending": "전송 중…",
"hc.sessionExpired": "세션 만료",
"hc.setUpYourEstablishments": "시설 설정",
"hc.settings": "설정",
"hc.settingsSubtitle": "외부 결제 및 알림, 시설별로 구성됨.",
"hc.shareFoundText": "아이템을 찾았습니다 — findloop에서 소유자를 찾는데 도움을 주세요",
"hc.shareLostText": "아이템을 잃어버렸습니다 — findloop에서 찾는 데 도움을 주세요",
"hc.sharePreview": "공유 미리보기",
"hc.shareTheRanking": "순위 공유",
"hc.shareYourQrCodeTo": "신고를 받기 위해 QR 코드를 공유하세요.",
"hc.shipRateAutoWeight": "배송 요금은 배송 시 Sendcloud를 통해 자동으로 계산됩니다 (무게 {w}).",
"hc.shipRateForWeight": "배송 요금 (Sendcloud + {m}% 마진) {w}에 대한:",
"hc.shipments": "배송",
"hc.shipmentsSubtitle": "모든 경우에 대한 모든 배송의 통합 보기. 행을 클릭하여 배송을 관리하세요.",
"hc.shipping": "배송",
"hc.shippingAddress": "배송지",
"hc.shippingFeesAreHandledAutomatically": "배송 요금은 Findloop (Sendcloud)에서 자동으로 처리됩니다 — 입력할 링크 없음.",
"hc.shippingFeesHaveAlreadyBeen": "배송 요금이 이미 지불되었습니다: 운송업체를 더 이상 변경할 수 없습니다.",
"hc.shippingNotAvailableForItems": "30kg 이상 품목에 대한 배송 불가능. 고객이 직접 아이템을 수령해야 합니다.",
"hc.shippingPaid": "배송비 지불 ✓",
"hc.showOnlyItemsMatchingA": "공개(고객) 목록과 일치하는 항목만 표시",
"hc.showPassword": "비밀번호 표시",
"hc.signInTheBoxAbove": "위 상자에 로그인",
"hc.signatureSaved": "서명 저장됨",
"hc.signedInWithGoogle": "Google로 로그인했습니다",
"hc.signupFailed": "가입 실패",
"hc.silver": "은",
"hc.simulatedRatesInPreProduction": "(사전 제작의 시뮬레이션된 요금)",
"hc.siretAndVatNumberRequired": "SIRET 및 VAT 번호 필요 (프랑스).",
"hc.skip": "건너뛰기",
"hc.smsSentIfAccount": "이 번호로 계정이 존재하면 SMS가 전송되었습니다.",
"hc.sortItemsWithAPublic": "정렬: 공개 일치 항목 (가장 최근) 우선",
"hc.specifyWhetherYouRecoveredYour": "아이템을 회수했는지 또는 이 목록을 제거하려는지 지정하세요.",
"hc.specifyYourReason": "이유를 지정하세요",
"hc.specifyYourReason2": "이유를 지정하세요…",
"hc.staff": "직원",
"hc.status": "상태",
"hc.staySignedIn": "계속 로그인 유지",
"hc.step": "단계",
"hc.stillThere": "아직 계신가요?",
"hc.stopScrolling": "스크롤 멈추기",
"hc.storeFindWithQr": "QR로 저장 및 찾기",
"hc.streetName": "도로명",
"hc.streetNo": "도로 번호",
"hc.switchTo": "전환하기",
"hc.switchToDarkMode": "어두운 모드로 전환",
"hc.switchToLightMode": "밝은 모드로 전환",
"hc.takeAPhoto": "사진 촬영",
"hc.takeChangeThePhoto": "사진 촬영 / 변경",
"hc.takenFromYourDeclaration": "신고서에서 가져온",
"hc.target": "대상",
"hc.targetReached": "목표 도달",
"hc.targetReachedThankYouTo": "목표 도달 — Findloop 커뮤니티 전체에 감사드립니다!",
"hc.tellUsMore": "더 말씀해 주세요…",
"hc.tellUsWhyYouCancel": "취소 사유를 알려주세요. 이는 파트너가 요청을 처리하는 데 도움이 됩니다.",
"hc.tellUsWhyYourListing": "사유를 알려주세요. 귀하의 목록은 활성 상태로 남아 있으며 아이템을 여전히 청구할 수 있습니다.",
"hc.termsAndConditions": "약관",
"hc.termsAndPolicies": "약관 및 정책",
"hc.thankYouForYourFeedback": "피드백 감사합니다",
"hc.theBannerDisplayedInThe": "등록부에 표시된 배너입니다.",
"hc.theClaimantHasBeenInformed": "청구인이 통보되었습니다. 해당 아이템은 공개 목록에서 계속 제공됩니다.",
"hc.theClaimantHasBeenNotified": "청구인이 통지되었으며 이제 반환 절차를 진행할 수 있습니다.",
"hc.theCustomerPaysTheFees": "고객이 시설에 수수료를 지불합니다.",
"hc.theDayTheLegalRetention": "법적 보유 기간이 만료되는 날입니다.",
"hc.theEstablishmentConsideredThatThis": "해당 시설에서 이 아이템이 귀하의 것이 아니라고 간주하였습니다.",
"hc.theEstablishmentIsReviewingYour": "해당 시설에서 귀하의 답변을 검토하고 있습니다. 청구가 검증되면 즉시 통지되고, 회수 수수료를 지불할 수 있습니다.",
"hc.theFeesAreTooHigh": "수수료가 너무 높습니다",
"hc.theFinderConsideredThatThis": "찾는이가 이 아이템이 귀하의 것이 아니라고 간주하였습니다.",
"hc.theFinderIsReviewingYour": "찾는이가 귀하의 청구를 검토하고 있습니다. 검증되면 즉시 통지됩니다.",
"hc.theItem": "아이템",
"hc.theItemWillBeRemoved": "아이템이 등록부에서 제거됩니다 (진행 중인 청구 없음).",
"hc.theItemWillBeSet": "아이템이 \"재고 있음\"으로 복원되며 관련 청구가 취소됩니다.",
"hc.theKbisNumberAndVat": "프랑스를 위한 Kbis 번호와 VAT 번호가 필요합니다.",
"hc.theLabelIsGeneratedAutomatically": "배송 수수료를 고객이 지불하면 레이블이 자동으로 생성됩니다. 여기에서 다운로드할 수 있습니다.",
"hc.theLinkMayHaveExpired": "링크가 만료되었을 수 있습니다 (30일 유효). 필요시 Findloop 지원에 문의하세요.",
"hc.theOwnerDescribesTheirItem": "소유자가 자신의 아이템을 설명합니다.",
"hc.theOwnerReceivedItBy": "소유자가 이메일(또는 SMS)로 수령하였습니다. 인수 전에 입력하거나 스캔하세요.",
"hc.thePartnerConsideredThatThis": "파트너에서 이 아이템이 귀하의 것이 아니라고 간주하였습니다. 해당 아이템은 계속 제공됩니다.",
"hc.thePartnerIsReviewingYour": "파트너에서 귀하의 답변을 검토하고 있습니다. 청구가 검증되면 즉시 통지됩니다.",
"hc.theShipmentIsCreatedAutomatically": "고객이 주소를 확인하고 회수 수수료를 지불하면 배송이 자동으로 생성됩니다. 이후 배송 결제가 완료되면 레이블이 자동으로 생성되며, 여기에서 다운로드할 수 있습니다.",
"hc.theShippingRateWillBe": "배송 요금은 배송 시 Sendcloud를 통해 자동으로 계산됩니다 (기록된 무게).",
"hc.thisCarrierWillBe": "이 운송업체는",
"hc.thisEstablishment": "이 시설",
"hc.thisFieldIsRequiredFor": "이 필드는 자동 레이블 생성을 위해 필요합니다.",
"hc.thisIsMyItem": "이것은 내 아이템입니다",
"hc.thisIsMyItemContinue": "이것은 내 아이템입니다 — 계속하기",
"hc.thisIsMyItemStart": "이것은 내 아이템입니다 — 반환 시작하기",
"hc.thisIsNotMyItem": "이것은 내 아이템이 아닙니다",
"hc.thisMatchIsNoLonger": "이 매치는 더 이상 유효하지 않거나 이미 처리되었습니다.",
"hc.thisRateWillBeCharged": "이 요금이 고객에게 청구됩니다. 높은 요금은 회수를 어렵게 할 수 있습니다.",
"hc.thisStepIsRequiredFor": "이 단계는 배송 레이블 생성을 위해 필요합니다.",
"hc.thisValidationLinkIsInvalid": "이 검증 링크는 유효하지 않거나 만료되었습니다.",
"hc.toCheckBeforeMarkingThe": "상품을 반품으로 표시하기 전에 확인하십시오.",
"hc.toConfigureTheLinksAnd": "각 업체에 대한 링크 및 알림 지연을 구성합니다.",
"hc.toReachOurFirstMilestone": "첫 번째 100회 반품 이정표에 도달합니다.",
"hc.toTheCustomer": "고객에게.",
"hc.toTheShippingFeePayment": "배송비 결제로.",
"hc.toYourRecoveryTracking": "회수 추적으로.",
"hc.tooExpensiveBudget": "너무 비쌉니다 / 예산",
"hc.topCitiesForReturns": "반품이 많은 도시",
"hc.trackMyRecovery": "내 회수 추적",
"hc.trackTheShipmentAndDownload": "배송을 추적하고 <b>라벨</b>을 다운로드하세요(자동 생성됨).",
"hc.trackYourStatistics": "내 통계 추적",
"hc.tracking": "추적",
"hc.unableToOpenTheShipping": "배송비 결제를 열 수 없습니다. 다시 시도해주세요.",
"hc.unableToRetrieveTheInvoice": "송장을 가져올 수 없습니다.",
"hc.unclaimed": "청구되지 않음",
"hc.unclaimedCustomerReason": "청구되지 않은 품목. 고객의 사유: \"{reason}\".",
"hc.unclaimedItem": "청구되지 않은 품목",
"hc.unclaimedItemNoClaimWithin": "청구되지 않은 품목 — 기한 내 청구 없음.",
"hc.unclaimedItems": "청구되지 않은 품목",
"hc.unclaimedItemsMatchLeftWithout": "청구되지 않은 품목: 기한 내 청구 없이 남은 매치. 다시 보관할 수 있습니다.",
"hc.unlockTheFinderSContact": "발견자의 연락처를 잠금 해제하여 인수인계를 조정합니다.",
"hc.upcoming": "다가오는",
"hc.updateFailed": "업데이트 실패.",
"hc.usedForInvoices": "당신의 Findloop 송장을 발급하는 데 사용됩니다.",
"hc.vatNumber": "부가세 번호",
"hc.verificationPending": "인증 대기 중",
"hc.verificationSentToTheFinder": "발견자에게 인증이 전송되었습니다. 그들의 결정에 대해 알림을 받게 됩니다.",
"hc.verificationSentToThePartner": "파트너에게 인증이 전송되었습니다. 그들의 결정에 대해 알림을 받게 됩니다.",
"hc.verify": "확인",
"hc.verifyingInvite": "초대 링크 확인 중…",
"hc.verifyingTheLink": "링크 확인 중…",
"hc.viewInRegistry": "등록에서 보기",
"hc.viewItem": "품목 보기",
"hc.viewItemRecover": "품목 보기 & 회수",
"hc.visibleToTheOwnerAutomatically": "소유자에게 표시 · 60일 후 자동 삭제됩니다.",
"hc.waitingForPartnerConfirmation": "파트너 확인 대기 중",
"hc.waitingForThePartnerS": "파트너의 확인을 기다리는 중",
"hc.weHaveInformedTheEstablishment": "이 품목이 당신의 것이 아님을 업체에 알리고 분석을 재시작했습니다. 새 매치가 발견되는 즉시 통보받게 됩니다.",
"hc.weHaveInformedThePartner": "이 품목이 당신의 것이 아님을 파트너에 알렸습니다. 당신의 목록은 미래의 매치를 위해 활성 상태로 유지됩니다.",
"hc.weRanTheAnalysisAgain": "우리는 분석을 다시 수행하였고 귀하의 항목일 수 있는 다른 항목을 확인했습니다. 다시 확인해주세요.",
"hc.weight": "무게",
"hc.weightNotProvidedTheShipping": "무게가 제공되지 않음: 배송 시 요금이 계산됩니다.",
"hc.weightUnit": "무게 단위",
"hc.welcome": "환영합니다!",
"hc.welcomeToFindo": "findloop에 오신 것을 환영합니다",
"hc.whenACustomerComesTo": "고객이 물건을 찾으러 오면, 선언서를 열고 반환을 검증하세요. 그게 전부입니다!",
"hc.whenDisabledFeesDropTo": ". 비활성화 시 요금이 다음으로 떨어집니다",
"hc.whyIsThisNotYour": "왜 이 항목이 귀하의 것이 아닙니까?",
"hc.willBeMarkedAs": "다음으로 표시됩니다",
"hc.wrongColor": "잘못된 색상",
"hc.wrongModel": "잘못된 모델",
"hc.yesCancel": "네, 취소",
"hc.yesContactTheFinder": "네, 찾는 사람에게 연락",
"hc.youAreHere": "여기에 있습니다",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "이제 반환을 시작할 수 있습니다.",
"hc.youCanStillChangeIt": ". 여전히 경우에 따라 변경할 수 있습니다.",
"hc.youHaveAlreadyConfirmedThat": "이것이 귀하의 항목임을 이미 확인하셨습니다.",
"hc.youWillBeRedirectedTo": "안전한 Stripe 결제로 리디렉션됩니다.",
"hc.yourAccountHasBeenReactivated": "귀하의 계정이 다시 활성화되었습니다.",
"hc.yourAccountIsActiveYou": "귀하의 계정이 활성화되었습니다. 이제 귀하의 시설을 관리할 수 있습니다.",
"hc.yourEstablishment": "귀하의 시설",
"hc.yourFeedbackHelpsUsImprove": "귀하의 피드백이 우리의 매치를 개선하는 데 도움이 됩니다.",
"hc.yourFeedbackHelpsUsRestart": "귀하의 피드백이 분석을 재시작하고 매치를 개선하는 데 도움이 됩니다.",
"hc.yourFirstSteps": "귀하의 첫 단계",
"hc.yourFirstStepsAdmin": "귀하의 첫 단계 (관리자)",
"hc.yourItemHasBeenHanded": "귀하의 항목이 파트너에 의해 직접 전달되었습니다 — 인수 확인 후 사례를 종료하세요.",
"hc.yourItemHasBeenShipped": "귀하의 항목이 파트너에 의해 배송되었습니다 — 배달 확인 후 사례를 종료하세요.",
"hc.yourPaymentHasBeenRecorded": "귀하의 결제가 기록되었습니다.",
"hc.yourShipmentIsBeingPrepared": "귀하의 배송이 준비되고 있습니다. 3일에서 5일 이내에 소포를 받게 됩니다.",
"hc.yourShippingFeesHaveAlready": "귀하의 배송 요금이 이미 지불되었습니다. 배송 완료 ✓",
"hc.yourShippingFeesHaveBeen": "귀하의 배송 요금이 지불되었습니다. 귀하의 소포가 준비 중입니다.",
"hc.yourVerificationQuestionsDeposit": "귀하의 확인 질문 (예치금)",
"hero.einvoiceBadge": "2027 준수 e-청구서",
"home.recentAdsAll": "모든 목록 보기",
"home.recentAdsEyebrow": "현재",
"home.recentAdsSubtitle": "커뮤니티에서 보고된 분실물.",
"home.recentAdsTitle": "최신 목록",
"home.reunions": "최근 재회",
"home.videoEyebrow": "보기",
"home.videoSubtitle": "우리가 어떻게 잃어버린 물건을 소유자에게 쉽게 되찾는지.",
"home.videoTitle": "2분 안에 findloop를 발견하세요",
"home.watchYoutube": "YouTube에서 보기",
"impact.already": "이미",
"impact.citiesWord": "도시/도시들",
"impact.eachPoint": "각 점은 findloop가 잃어버린 물건을 복구하는 도시입니다.",
"impact.emptyMap": "상환이 발생할 때 지도가 채워집니다.",
"impact.eyebrow": "우리의 영향",
"impact.inCities": "전역에 걸쳐",
"impact.restitutedTo": "소유자에게 반환된 물건들",
"impact.title": "어디에서든 반환된 물건들",
"inv2.download": "다운로드",
"inv2.view": "보기",
"map.objectsOnMapPlural": "지도에 있는 물건들",
"map.objectsOnMapSingular": "지도에 있는 물건",
"mc.claimConfirmDesc": "지급하기 전에 찾은 사람이 발견한 물건을 확인하세요.",
"mc.claimConfirmNo": "이것은 내 물건이 아닙니다",
"mc.claimConfirmTitle": "이것이 정말 당신의 물건인가요?",
"mc.claimConfirmYes": "네, 제 것입니다 — 지급합니다",
"mc.claimFinderContacts": "찾은 사람의 연락처",
"mc.claimNotMineDone": "감사합니다 — 찾은 사람이 통지되었고 귀하의 요청이 광고에서 제거되었습니다.",
"mc.claimUnlockDesc": "귀하의 물건을 찾은 사람의 연락처를 얻기 위해 Findloop 관리 수수료를 지불하세요.",
"mc.claimUnlockTitle": "찾은 사람의 연락처를 잠금 해제하세요",
"mc.hideCountryOffers": "내 나라의 제안 숨기기",
"mc.myClaims": "내가 청구하는 물건",
"mc.myClaimsSub": "다른 사람이 찾은 물건을 청구하고 있습니다. 찾은 사람의 연락처를 잠금 해제하여 인수인계를 정리하세요.",
"mc.notifAdCancelled": "광고가 취소되었습니다",
"mc.notifCancelAd": "내 광고 취소",
"mc.offersInCountry": "내 나라의 제안",
"mc.offersInCountryDesc": "도시별로 귀하의 나라의 파트너들로부터 모든 활성 보상.",
"mc.redArchived": "아카이브됨",
"mc.rewardsCountryNone": "아직 귀하의 나라에 제안이 없습니다.",
"mc.rewardsForYou": "귀하를 위한 보상",
"mc.rewardsForYouDesc": "물건을 맡긴 파트너(s)에서 제공됩니다.",
"mc.rewardsMineNone": "아직 귀하의 물건 맡긴 파트너로부터 보상이 없습니다.",
"mc.showCountryOffers": "내 나라의 제안 보기",
"mc2.cancelDecl": "내 신고 취소",
"mc2.cancelDeclDone": "신고가 취소되었습니다.",
"pricing.physInvDesc": "물건이 반환되면 그 위치가 자동으로 해제되고 새로운 물건을 위해 사용 가능합니다.",
"pricing.physInvTitle": "물리적 재고 추적",
"pricing.physModalTitle": "물리적 아이템 관리",
"pricing.physQrDesc": "각 아이템에 대해 고유한 QR 코드가 생성되며, 모든 정보에 연결됩니다.",
"pricing.physQrTitle": "전용 QR 라벨",
"pricing.physShelfDesc": "등록된 모든 아이템은 시설 내 특정 위치에 배정될 수 있습니다.",
"pricing.physShelfTitle": "선반 계획",
"pricing.physicalMgmt": "물리적 아이템 관리 (선반, QR, 재고)",
"pub.addSecondPhoto": "2번째 사진 추가 (선택 사항)",
"pub.photo2Added": "✓ 2번째 사진 추가됨",
"reg.dispositionJournal": "처분 저널",
"reg.dispositionNoteAuthHint": "ℹ️ \"당국에 전달됨\"에 대한 메모가 필요합니다 (보고서 번호, 부서…).",
"reg.dispositionNotePh": "메모 (선택 사항): 수령자 자선단체, 당국 참조, 구매자 이름…",
"reg.dispositionNoteRequired": "당국에 넘기기 위해 공식 참조가 필요합니다.",
"reg.legalPrealert": "{days}일(들) 내에 법적 마감",
"reg.legalPrealertOptions": "마감 시 옵션: 경매 판매, 자선단체에 기부, 당국에 인도.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "전체 리뷰",
"rev.readMore": "더 읽기",
"rw.activeCodes": "활성 바우처",
"rw.archived": "보관됨",
"rw.archivedTitle": "사용된 바우처 (보관됨)",
"rw.hideArchived": "사용된 바우처 숨기기",
"rw.noArchived": "보관된 바우처가 없습니다.",
"rw.showArchived": "사용된 바우처 보기",
"shp.labelAuto": "고객이 배송료를 지불하면 라벨이 자동으로 생성됩니다. 여기에서 다운로드할 수 있습니다.",
"st.cancelled_by_customer": "취소됨",
"stt.dispoPdfBtn": "PDF 내보내기",
"stt.dispoPdfError": "PDF 내보내기 실패.",
"stt.dispoPdfExporting": "내보내는 중…",
"trk.matchVerifying": "잠재적 일치 확인 중",
"a.firstName": "이름",
"ac.emailCrossMatch": "B2C 교차 일치",
"ac.emailCrossMatchDesc": "<b>공식 분실물 광고</b>와 귀하의 장소에 보관된 항목이 일치할 때 이메일",
"ac.emailCrossReject": "공식 일치 거부",
"ac.emailCrossRejectDesc": "고객이 제안된 공식 일치가 자신의 항목이 아님을 나타낼 때 이메일을 받습니다.",
"ac.emailLoginNotif": "로그인 알림",
"ac.emailLoginNotifDesc": "누군가 귀하의 계정에 로그인할 때마다 이메일을 받습니다.",
"ad.closeNoCancel": "아니요, 목록 제거",
"ad.closeQuestion": "항목이 반환되었나요?",
"ad.closeQuestionDesc": "귀하의 항목을 회수했는지, 아니면 단순히 이 목록을 제거하고 싶은지 알려주세요.",
"ad.closeYesRestituted": "네, 항목이 반환되었습니다",
"ad.closedRestituted": "항목이 반환되었습니다 — 목록이 닫혔습니다 🎉",
"an.lostLoginDesc": "분실물 보고 및 반환을 위해 계정이 필요합니다.",
"an.lostLoginRequired": "분실물을 보고하려면 로그인하세요",
"an.qfAll": "모두",
"an.qfBoosted": "부스트된",
"an.qfPhoto": "사진 포함",
"an.qfRecent": "이번 주",
"an.qfResolved": "해결됨",
"an.restitutionInProgress": "항목 반환 중",
"dec.descPhLong": "항목 설명: 브랜드, 색상, 특징적인 표시… (자세히 제공할수록 항목 회수 가능성이 높아집니다)",
"dec.loadError": "현재 파트너를 로드할 수 없습니다. 연결을 확인하고 다시 시도하세요.",
"dec.retry": "다시 시도",
"dec.shippingMode": "배송",
"dep.photo2": "2번째 항목 사진",
"dep.photo2Hint": "선택 사항 — 다른 각도는 시각적 일치 정확성을 향상시킵니다.",
"dl.accountSuspended": "미지급 청구서로 인해 계정이 중지되었습니다. 이를 정산하여 접근을 복원하세요.",
"dl.regularize": "지금 정산 →",
"dl.suspensionCountdown": "청구서 {num} 미납 — 귀하의 계정은 {days}일 후에 중지됩니다. 이를 피하려면 정산하세요.",
"ft.cancelConfirm": "신고를 취소하시겠습니까? 항목 소유자에게 알려집니다.",
"ft.cancelDone": "신고가 취소되었습니다.",
"ft.cancelLocked": "소유자가 지불한 후에는 더 이상 취소할 수 없습니다.",
"ft.cancelReport": "내 신고 취소",
"ft.claimCodeHelp": "항목을 수령했음을 확인하기 위해 인수 시 발견자에게 이 코드를 제공합니다.",
"ft.claimCodeTitle": "귀하의 반환 코드",
"ft.claimDone": "항목이 반환되었습니다. findloop를 사용해 주셔서 감사합니다!",
"ft.claimUnlockHint": "발견자의 연락처 정보를 잠금 해제하세요",
"ft.claimUnlockHintSub": "수수료를 지불하고 연락처 정보를 얻기 위해 귀하의 계정에서 \"내가 주장하는 항목\"으로 이동하세요.",
"ft.finderCodeShownHelp": "소유자가 지불하고 귀하를 선택했습니다. 반환을 확인하기 위해 아래 코드를 복사하세요 — 이메일을 확인할 필요가 없습니다.",
"ft.finderCodeShownTitle": "소유자 확인 코드",
"ft.finderContactsTitle": "발견자 연락처 정보",
"ft.foundCodeHelp": "물품 반환을 확인하기 위해 이 코드를 소유자에게 보여주세요.",
"ft.inProgressOther": "반환 중인 물품",
"ft.inProgressOtherHelp": "소유자가 이 물품에 대해 다른 발견자를 선택했습니다. 귀하 쪽에서 추가 작업은 필요하지 않습니다.",
"ft.restitutionCodeHelp": "이 코드는 물품 인수 확인을 합니다. 아래에 미리 입력되어 있으니, 확인한 후 사건을 종료하세요.",
"ft.restitutionCodeTitle": "귀하의 환불 코드",
"hc.14Digits": "14자리",
"hc.15DaysBeforeAnItem": "물품의 법적 기한 15일 전입니다.",
"hc.7DaysBeforeAnItem": "물품의 법적 기한 7일 전입니다.",
"hc.8CharactersMinimum": "최소 8자 이상입니다.",
"hc.aClaimToValidate": "확인해야 할 청구",
"hc.aFindoAssistanceSessionIs": "현재 귀하의 계정에서 Findloop 지원 세션이 활성화되어 있습니다.",
"hc.aNewMatchHasBeen": "새로운 매치가 발견되었습니다",
"hc.aUser": "사용자",
"hc.aUserClaimsToBe": "사용자가 소유자라고 주장합니다. 반환을 승인하기 전에 그들의 답변을 확인하세요.",
"hc.aboutFindo": "Findloop 소개",
"hc.accountActivatedPleaseLogIn": "계정이 활성화되었습니다. 로그인해주세요.",
"hc.accountActivation": "계정 활성화",
"hc.accountCreated": "계정이 생성되었습니다!",
"hc.accountDeactivatedAReactivationEmail": "계정이 비활성화되었습니다. 재활성화 이메일(30일 유효)이 발송되었습니다.",
"hc.accountReactivation": "계정 재활성화",
"hc.activateMyAccount": "내 계정 활성화",
"hc.activateMyAdminAccount": "내 관리자 계정 활성화",
"hc.activating": "활성화 중…",
"hc.activeMatchCancelReason": "활성 매치. 고객의 취소 사유: \"{reason}\". 물품은 여전히 청구를 기다리고 있습니다.",
"hc.activeMatchWithAPublic": "공식(고객) 목록과의 활성 매치. 소유자의 청구를 기다리고 있습니다.",
"hc.addAPhoto": "사진 추가",
"hc.addAndConfigureYourEstablishments": "\"시설\"에 귀하의 시설을 추가 및 구성하세요: 연락처 정보, 카테고리 및 물품의 물리적 보관.",
"hc.addOnGoogle": "Google에 추가",
"hc.address": "주소",
"hc.addressSaved": "주소가 저장되었습니다",
"hc.addressStreet": "주소 — 거리",
"hc.adjustThePhoto": "사진 조정",
"hc.adminFullView": "관리자 (전체 보기)",
"hc.administratorOnly": "관리자 전용",
"hc.africa": "아프리카",
"hc.aiVisualComparison": "AI 시각 비교",
"hc.all": "모두",
"hc.amount": "금액",
"hc.anOrganization": "조직",
"hc.analyzing": "분석 중…",
"hc.andRecoveryIs": "및 복구는",
"hc.andTheDeclarationWillBe": "및 선언은 종료됩니다 (기록으로 이동). 이 작업은 최종적입니다.",
"hc.annual20": "연간 -20%",
"hc.annualBilling20": "연간 청구 (−20%)",
"hc.annualTarget": "연간 목표",
"hc.anyCommentsOptional": "댓글이 있습니까? (선택 사항)",
"hc.approveTheClaim": "청구 승인",
"hc.archiveCancelledConfirm": "{n} 목록을 \"고객에 의해 취소됨\"으로 아카이브 하시겠습니까? 레지스트리에서 제거됩니다.",
"hc.asSoonAs": "가능한 한 빨리",
"hc.askTheOwnerToDisplay": "소유자에게 코드의 QR(추적 페이지)을 표시하도록 요청하세요.",
"hc.askThemAtTheCounter": "카운터에서 그들에게 신원을 확인하도록 요청하세요 — 공개적으로 보이지 않습니다.",
"hc.assistance": "지원",
"hc.assistanceSessionRevoked": "지원 세션이 취소되었습니다.",
"hc.atLeast6Characters": "최소 6자",
"hc.automaticallyPreSelected": "자동으로 미리 선택됨",
"hc.automaticallyWhenShipping": "배송 시 자동으로.",
"hc.awaitingClaim": "청구 대기 중",
"hc.awaitingPayment": "결제 대기 중",
"hc.b2cCustomer": "B2C 고객",
"hc.back": "뒤로",
"hc.backToHome": "홈으로 돌아가기",
"hc.backToMyAccount": "내 계정으로 돌아가기",
"hc.backToPayment": "결제로 돌아가기",
"hc.beforeAfterComparisonSlider": "전후 비교 슬라이더",
"hc.billingInformation": "청구 정보",
"hc.billingInformationSaved": "청구 정보 저장 ✓",
"hc.brand": "브랜드",
"hc.bronze": "브론즈",
"hc.calculatingTheShippingRate": "배송 요금 계산 중…",
"hc.cameraUnavailableEnterTheCode": "카메라 이용할 수 없음. 코드를 수동으로 입력하세요.",
"hc.cancel": "취소",
"hc.cancelMyDeclaration": "내 선언 취소",
"hc.cancelSavedFmt": "취소 저장됨: \"{reason}\". 여전히 청구할 수 있습니다.",
"hc.cancelTheDeposit": "보증금 취소",
"hc.cancelThisMatch": "이 매치 취소",
"hc.cancellationReason": "취소 사유",
"hc.cancelled": "취소됨",
"hc.cancelledByTheCustomer": "고객에 의해 취소됨",
"hc.cannotOpenPayment": "결제를 열 수 없습니다. 다시 시도하세요.",
"hc.careers": "커리어",
"hc.carrier": "운송업체",
"hc.carrierAvailabilityCannotBeChecked": "발송자 Sendcloud가 설정되기 전에는 운송업체의 가용성을 확인할 수 없습니다.",
"hc.carrierConfirmedCharged": "운송업체 확인됨 — 고객에게 {price} €가 청구되었습니다",
"hc.carrierOther": "운송업체(기타)",
"hc.carrierSelection": "운송업체 선택",
"hc.caseClosedThankYou": "사례가 닫혔습니다. 감사합니다!",
"hc.category": "카테고리",
"hc.changeMethod": "방법 변경",
"hc.characteristic": "특성",
"hc.chargedToCustomer": "고객에게 청구됨.",
"hc.checkOrEditYourDetails": "안전한 결제 전에 세부 정보를 확인하거나 수정하세요.",
"hc.checkStatisticsToTrackDeposited": "\"통계\"를 확인하여 입금된 항목, 반품 비율 및 각 시설의 실적을 추적하세요.",
"hc.checkTheDetailsBeforeContacting": "찾는 사람에게 연락하기 전에 세부 정보를 확인하세요.",
"hc.checkTheDetailsBelowBefore": "반품 요청을 시작하기 전에 아래 세부 정보를 확인하세요.",
"hc.checkTheNewItem": "새 항목 확인",
"hc.checkThePhotosAndCharacteristics": "회수를 진행하기 전에 아래의 사진과 특성을 확인하세요.",
"hc.chooseACountry": "국가 선택",
"hc.chooseANewPassword": "새 비밀번호 선택",
"hc.chooseAReason": "이유 선택",
"hc.chooseTheLegalRetentionAlerts": "다음에 대한 이메일로 수신할 법적 보관 알림 선택",
"hc.chooseYourPasswordToAccess": "관리 콘솔에 접근할 비밀번호를 선택하세요.",
"hc.city": "도시",
"hc.claimApproved": "청구 승인됨",
"hc.claimApproved2": "청구가 승인되었습니다.",
"hc.claimCodeExpired": "청구 코드 만료됨",
"hc.claimCodeVerified": "청구 코드가 검증되었습니다.",
"hc.claimNotFound": "청구를 찾을 수 없음",
"hc.claimNotValidated": "청구가 유효하지 않음",
"hc.claimRejected": "청구 거부됨",
"hc.claimRejected2": "청구가 거부되었습니다.",
"hc.claimValidated": "청구가 확인되었습니다",
"hc.claimValidatedByThePartner": "파트너에 의해 청구가 확인되었습니다",
"hc.claimant": "청구인",
"hc.claimsToBeTheOwner": "이 항목의 소유자라고 주장하며 확인 질문에 응답했습니다. 답변이 일치하는 경우에만 승인하세요.",
"hc.claimsToValidate": "검증할 청구",
"hc.clear": "지우기",
"hc.clickToZoom": "클릭하여 확대",
"hc.close": "닫기",
"hc.close2": "닫기",
"hc.closeTheDeclaration": "신고서 닫기",
"hc.closeTheDeclaration2": "신고서를 닫겠습니까?",
"hc.codeAlreadyVerified": "코드가 이미 확인됨",
"hc.codeCopied": "코드가 복사됨",
"hc.collapse": "축소",
"hc.color": "색상",
"hc.company": "회사",
"hc.companyName": "회사 이름",
"hc.comparePhotos": "사진 비교",
"hc.compareThemWithTheOwner": "소유자의 답변과 비교하세요 — 공개적으로 표시되지 않음.",
"hc.condition": "상태",
"hc.confirmAndPay": "확인 후 결제",
"hc.confirmCancellation": "취소 확인",
"hc.confirmCrop": "자르기 확인",
"hc.confirmDeletion": "삭제 확인",
"hc.confirmPassword": "비밀번호 확인",
"hc.confirmThatThisIsYour": "이 항목이 귀하의 것임을 확인하십시오. 연락을 하기 전에 발신자에게 신원 확인이 요청됩니다.",
"hc.confirmTheCarrier": "운송업체 확인",
"hc.confirmThePassword": "비밀번호 확인",
"hc.confirmYourShippingAddressTo": "결제를 계속하려면 배송 주소를 확인하십시오.",
"hc.confirmYourSubscription": "구독 확인",
"hc.confirmed": "확인됨 ✓",
"hc.contactFindoToGetYour": "발신자 ID를 받으려면 Findloop에 문의하십시오.",
"hc.contactUs": "문의하기",
"hc.continueTheReturn": "반품 계속하기",
"hc.continueToPayment": "결제로 계속하기",
"hc.copy": "복사",
"hc.correctMyDetails": "내 정보 수정",
"hc.correctThisEntry": "이 항목을 수정하시겠습니까?",
"hc.country": "국가",
"hc.countryAddress": "국가 (주소)",
"hc.countryIsoCodeEG": "국가 (ISO 코드, 예: FR)",
"hc.cover": "덮개",
"hc.createTheShipment": "배송물 생성",
"hc.cropThePhoto": "사진 자르기",
"hc.customer": "고객",
"hc.customerClaimCodeToCheck": "고객 청구 코드 — 픽업 확인:",
"hc.customerReasonFmt": "고객의 사유: \"{reason}\".",
"hc.customerReminderDelay": "고객 알림 지연",
"hc.customerWhosePublicListingMatches": "공개 목록이 이 항목과 일치하는 고객 — 귀하에게만 표시됨.",
"hc.d15": "D-15",
"hc.dangerZone": "위험 지역",
"hc.date": "날짜",
"hc.dateNewest": "날짜 (최신)",
"hc.dateOldest": "날짜 (최초)",
"hc.daysToYearEnd": "{n}일 남았습니다.",
"hc.deadlineAlert": "마감 알림",
"hc.declarationClosed": "신고 마감 ✓",
"hc.declarationNotFound": "신고를 찾을 수 없습니다.",
"hc.declarationNotFound2": "신고를 찾을 수 없습니다",
"hc.declarationTracking": "신고 추적",
"hc.defaultCarrier": "기본 운송업체",
"hc.defaultCarrierPreselected": "기본 운송업체 미리 선택됨 — 이 배송에 대해 변경할 수 있습니다. 실제 요금 (Sendcloud + {m}% 마진).",
"hc.defaultCarrierRemoved": "기본 운송업체가 제거되었습니다",
"hc.delayHours": "지연 (시간)",
"hc.deleteMyAccount": "내 계정 삭제",
"hc.deleting": "삭제 중…",
"hc.deletingDeactivatesYourAccountLogin": "삭제 시 계정이 비활성화됩니다: 로그인이 차단되고 데이터는 30일 동안 보관됩니다. 30일간 유효한 재활성화 링크가 포함된 이메일을 받게 됩니다.",
"hc.delivered": "배송 완료",
"hc.depositAnItem": "항목을 보관하세요",
"hc.depositCancelledItemPutBack": "보관이 취소되었습니다 — 항목이 재고에 되돌려졌습니다.",
"hc.depositCancelledItemRemovedFrom": "보관이 취소되었습니다 — 항목이 목록에서 제거되었습니다.",
"hc.depositedOn": "보관 날짜",
"hc.describeTheItemBrandColor": "항목 설명: 브랜드, 색상, 식별 마크… (더 많은 세부 정보를 제공할수록 항목을 찾을 확률이 높아집니다)",
"hc.dimensionsCm": "치수 (cm)",
"hc.disablingAnEmail": "이메일 비활성화 중",
"hc.doesNotHide": "숨기지 않음",
"hc.download": "다운로드",
"hc.downloadThePdf": "PDF 다운로드",
"hc.draftRestoredPickUpYour": "초안 복원됨 — 신고를 중단한 지점에서 계속하세요.",
"hc.dragToReposition": "재배치하려면 드래그하세요",
"hc.eGColisPriv": "예: Colis Privé",
"hc.eachItemGetsAQr": "각 항목은 QR 라벨이 붙습니다. \"보관 및 QR\"에서 스캔하여 항목을 즉시 찾으세요.",
"hc.eachSiteManagesItsOwn": "각 사이트는 고유한 은행 관리를 합니다. 가세요",
"hc.edit": "편집",
"hc.emailNotificationPreferences": "이메일 알림 설정",
"hc.emailPreferencesUpdated": "이메일 설정이 업데이트되었습니다",
"hc.enableOrDisableRecoveryFees": "회수 수수료 활성화 또는 비활성화",
"hc.enlargePhoto": "사진 확대",
"hc.enterTheCustomerSCode": "고객 코드를 입력하세요",
"hc.estShipRate": "예상 배송비 (Sendcloud + {m}% 마진):",
"hc.establishment": "설립",
"hc.establishment2": "설립:",
"hc.establishmentInItsSendcloudAccount": "Sendcloud 계정의 설립 및 발신자 ID를 제공합니다.",
"hc.establishmentSettings": "설립 설정",
"hc.exCode": "예: ABCD2345",
"hc.exId": "예: 3f2a…",
"hc.exit": "종료",
"hc.explainWhyThisItemIs": "이 항목이 귀하의 것이 아닌 이유를 설명하세요…",
"hc.externalPaymentLinks": "외부 결제 링크",
"hc.failed": "실패",
"hc.feesEnabled": "수수료 활성화됨",
"hc.field": ") 필드.",
"hc.finderAcceptedCloseTheCase": "파인더 수락 — 항목이 직접 전달되면 사건을 종료하세요.",
"hc.findoCityRanking": "Findloop — 도시 순위",
"hc.findoForEstablishments": "설립을 위한 Findloop",
"hc.findoPresentationVideo": "Findloop 소개 영상",
"hc.findoRegistersTheAddressOf": "Findloop는 귀하의 주소를 등록합니다.",
"hc.findoReviewShare": "Findloop {year} 리뷰: {n} 항목 반환, {rate}% 반품율 🎉",
"hc.firstVerifyTheClaimCode": "먼저 위의 청구 코드를 확인하세요",
"hc.forEveryNewShipmentFrom": "에서의 새로운 배송마다",
"hc.free": "무료",
"hc.freeRecovery0": "무료 복구 (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "아프리카 전역 무료 복구 – 출시 행사",
"hc.freeRecoveryFeesDisabled0": "무료 복구: 수수료 비활성화 (0 €)",
"hc.fromTeamInviteYourColleagues": "\"팀\"에서 동료를 이메일로 초대하고 그들에게 설립을 할당하세요. 각 구성원은 자신의 범위만 볼 수 있습니다.",
"hc.fullName": "전체 이름",
"hc.fullPhoto": "전체 사진",
"hc.gallery": "갤러리",
"hc.giveTheReasonForCancelling": "취소 이유를 제공하세요. 파트너에게 통지됩니다.",
"hc.goToLogin": "로그인으로 이동",
"hc.goToMyAccount": "내 계정으로 이동",
"hc.gold": "금",
"hc.googleLoginFailed": "구글 로그인 실패",
"hc.hasConfirmedYourPaymentYou": "이 귀하의 결제를 확인했습니다. 자동으로 리디렉션됩니다.",
"hc.helpCenter": "도움 센터",
"hc.helpUsImproveWhyAre": "우리를 개선하는 데 도움주세요: 왜 떠나고 있나요? 귀하의 계정은 비활성화되며 30일 동안 재활성화할 수 있습니다.",
"hc.hidePassword": "비밀번호 숨기기",
"hc.high": "높음",
"hc.historyOfYourMonthlySubscriptions": "귀하의 월간 구독 내역 및 결제 상태.",
"hc.hotelBelmont": "호텔 벨몬트",
"hc.howConfigureSenderId": "숫자 발신자 ID를 어떻게 설정하나요?",
"hc.iDonTUseIt": "잘 사용하지 않아요",
"hc.iFoundItElsewhere": "다른 곳에서 찾았어요",
"hc.iNoLongerNeedMy": "더 이상 필요하지 않아요",
"hc.identityVerification": "신원 확인",
"hc.idleLogoutIn": "비활동으로 인해 {n}초 후에 로그아웃됩니다.",
"hc.ifProvidedTheVolumetricWeight": "제공된 경우, 부피 무게가 사용됩니다.",
"hc.ifThePartnerHasNot": "파트너가 이 지연 후 외부 결제 수령을 확인하지 않으면, findloop가 자동으로 파트너에게 확인을 요청합니다.",
"hc.impersonationEnded": "재현이 종료되었습니다.",
"hc.impersonationMode": "재현 모드",
"hc.impersonationSessionExpired": "재현 세션이 만료되었습니다.",
"hc.inTheField": ", 현장에서",
"hc.inTransit": "운송 중",
"hc.inclVat": "부가세 포함",
"hc.intraEuVatNumberOptional": "EU 내 VAT 번호 선택적, 프랑스 외에서는 SIRET 필요 없음.",
"hc.invalidInvitationLink": "유효하지 않은 초대 링크입니다.",
"hc.invalidInvitationLink2": "유효하지 않은 초대 링크",
"hc.invalidInviteLink": "유효하지 않거나 만료된 초대 링크입니다.",
"hc.invalidNumberEnterAnInternational": "유효하지 않은 번호입니다. 국제 번호를 입력하세요, 예: +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "유효하지 않거나 만료된 링크입니다.",
"hc.invalidOrExpiredReactivationLink": "유효하지 않거나 만료된 재활성화 링크",
"hc.invalidSendcloudId": "유효하지 않은 Sendcloud ID",
"hc.inviteSubtitle": "{org}가 당신을 그들의 Findloop 팀에 초대합니다. 계정을 활성화하기 위해 비밀번호를 선택하세요.",
"hc.isAvailableOnSendcloudFor": "이것은 모든 경로(국내 + 국제)에서 Sendcloud에서 사용할 수 있습니다.",
"hc.isNotEnabledOnYour": "일부 목적지에서 귀하의 Sendcloud 계정에 대해 활성화되지 않았습니다. 해당 목적지의 라벨은 다른 사용 가능한 운송업체로 생성됩니다.",
"hc.isThisReallyYourItem": "정말 당신의 물건인가요?",
"hc.isThisYourItem": "이것이 당신의 물건인가요?",
"hc.item": "물품",
"hc.itemAlreadyConfirmed": "물품이 이미 확인되었습니다",
"hc.itemDetails": "물품 세부정보",
"hc.itemFoundAt": "물품이 발견된 장소",
"hc.itemFoundAtAPartner": "파트너에서 발견된 물품",
"hc.itemMarkedAsReturned": "물품이 반품된 것으로 표시되었습니다 ✓",
"hc.itemPhotoRequiredBeforeShipping": "물품 사진(배송 전에 필요)",
"hc.itemPhotoSaved": "물품 사진이 저장되었습니다",
"hc.itemPreview": "물품 미리보기",
"hc.itemPutBackInStorage": "물품이 보관되로 되돌아갔습니다.",
"hc.itemWeight": "물품 무게:",
"hc.itemsReturned": "반품된 물품",
"hc.itemsReturnedThisYear": "올해 반납된 물품",
"hc.itemsWhoseLegalDeadlineIs": "법적 기한이 15일 이내인 물품(연체 포함). 매치는 계속 표시됩니다.",
"hc.kbisNumber": "Kbis 번호",
"hc.keysForgottenOnABench": "벤치에 두고 온 열쇠",
"hc.labelBeingGenerated": "라벨 생성 중",
"hc.leaveTheFieldsEmptyTo": "필드를 비워두면 무료 회수를 제공합니다.",
"hc.legalNotice": "법적 고지",
"hc.limitReachedUpgradeToA": "한도 초과 — 더 높은 요금제로 업그레이드하세요",
"hc.linkCopiedShareOn": "링크가 복사됨 — {label}에 공유하세요",
"hc.linkUnavailable": "링크를 사용할 수 없음",
"hc.linkedTo": "연결됨",
"hc.listingHiddenByModeration": "리스트가 중재로 숨겨졌습니다.",
"hc.loading": "로딩 중…",
"hc.locateMe": "내 위치 찾기",
"hc.logIn": "로그인",
"hc.logInToGetBack": "로그인하여 내 공간으로 돌아가고 구독을 관리하세요.",
"hc.loginFailed": "로그인 실패",
"hc.lostFoundPlatform": "분실물 플랫폼.",
"hc.lostIn": "분실된 장소",
"hc.lowRate": "저렴한 요금",
"hc.mainReason": "주요 이유",
"hc.mainStreet": "메인 스트리트",
"hc.makeSureThisIsThe": "발견자의 연락처 정보를 잠금 해제하기 전에 잃어버린 물품인지 확인하세요.",
"hc.manageCookies": "쿠키 관리",
"hc.manageMyTeam": "내 팀 관리",
"hc.manageYourTeam": "팀 관리",
"hc.markAsReturned": "반납으로 표시",
"hc.matchNoClaimInTime": "기한 내에 청구가 없는 매치입니다.",
"hc.matchNotFound": "매치를 찾을 수 없습니다.",
"hc.medium": "중간",
"hc.milestoneFmt": "{m}개의 반납된 물품 이정표 도달! {next}로 가는 중.",
"hc.missingFeatures": "누락된 기능",
"hc.monthly": "매달",
"hc.monthlyBilling": "월별 청구",
"hc.moveThePhotoToFit": "사진을 원 안에 맞게 이동하세요.",
"hc.myAccount": "내 계정",
"hc.myInvoices": "내 청구서",
"hc.myMonthlyInvoices": "내 월별 청구서",
"hc.nArchived": "{n} 항목이 보관되었습니다.",
"hc.newCodeGeneratedAndSent": "고객에게 새 코드가 이메일 및 SMS로 전송되었습니다.",
"hc.newCodeGeneratedAndSent2": "소유자에게 새 코드가 전송되었습니다.",
"hc.newPassword": "새 비밀번호",
"hc.next": "다음",
"hc.nextPhoto": "다음 사진",
"hc.no": "아니요",
"hc.noAnswerProvided": "답변이 제공되지 않았습니다.",
"hc.noArchivedDeclarations": "보관된 선언이 없습니다.",
"hc.noCountryFound": "국가를 찾을 수 없습니다.",
"hc.noDeclarations": "선언이 없습니다.",
"hc.noFeesAreChargedTo": "고객에게 수수료가 부과되지 않습니다.",
"hc.noInvoiceYet": "아직 청구서가 없습니다.",
"hc.noInvoiceYetYourInvoices": "아직 청구서가 없습니다. 결제 후 귀하의 청구서가 자동으로 여기에 나타납니다.",
"hc.noMatchIsAvailableFor": "현재 일치하는 항목이 없습니다. 선언과 일치하는 항목이 생기면 알려드리겠습니다.",
"hc.noShipmentMatchesYourSearch": "검색과 일치하는 배송이 없습니다.",
"hc.noShipmentsYet": "아직 배송이 없습니다.",
"hc.noShipmentsYet2": "아직 배송이 없습니다.",
"hc.none": "없음",
"hc.noneChooseForEachShipment": "없음 (각 배송에 대해 선택)",
"hc.notMine": "내 것이 아닙니다.",
"hc.of": "의",
"hc.only": "오직",
"hc.onlyEachSiteManagesIts": "오직. 각 사이트는 자체 은행 업무를 관리하며, 이러한 링크는 다른 시설에 영향을 미치지 않습니다.",
"hc.onlyTheOwnerOrAn": "오직 소유자 또는 관리자만 해당 시설의 결제 링크를 구성할 수 있습니다.",
"hc.openDepositInTheMenu": "메뉴에서 \"입금\"을 열고, 항목을 설명하고 사진을 촬영하십시오. 즉시 저장되어 반환 준비가 완료됩니다.",
"hc.openSettings": "설정 열기 →",
"hc.openTheDeclarationToManage": "배송을 관리하기 위해 선언을 열기",
"hc.optional": "— 선택 사항",
"hc.optional2": "(선택 사항)",
"hc.optional3": "선택 사항",
"hc.originalListingPhotoUsed": "원본 목록 사진 사용",
"hc.other": "기타",
"hc.other2": "기타…",
"hc.ourProducts": "우리 제품",
"hc.overallRateTrendLast6": "전반적인 요금 추세 (지난 6개월)",
"hc.ownerSClaimCode": "소유자의 청구 코드",
"hc.ownershipConfirmed": "소유권 확인됨",
"hc.paid": "지불 완료",
"hc.paidOn": "지불 날짜",
"pcat.stadium_arena": "경기장 / 아레나",
"pcat.supermarket": "슈퍼마켓",
"pcat.taxi_vtc": "택시 / 라이드 헤일링",
"pcat.tourism_office": "관광 안내소",
"pcat.train_bus_station": "기차 / 버스 정류장",
"pcat.travel_agency": "여행사",
"hc.and": "그리고",
"hc.demoObj0": "지갑",
"hc.demoObj1": "스포츠 가방",
"hc.demoObj2": "전화기",
"hc.demoObj3": "안경 한 쌍",
"hc.demoObj4": "키 세트",
"hc.demoObj5": "스카프",
"hc.demoObj6": "노트북",
"hc.demoObj7": "물병",
"hc.demoWhen0": "2시간 전",
"hc.demoWhen1": "5시간 전",
"hc.demoWhen2": "어제",
"hc.demoWhen3": "3시간 전",
"hc.demoWhen4": "오늘 아침",
"hc.demoWhen5": "1일 전",
"hc.feedDemo": "{obj}가 {city}에서 {when} 반환되었습니다.",
"hc.feedReal": "항목 ({cat})이 {city}에서 반환되었습니다.",
"hc.saveBtn": "저장",
"hc.saveLink": "링크 저장",
"hc.terms": "약관",
"hc.view": "보기",
"pcat.airline": "항공사",
"pcat.airport": "공항",
"pcat.amusement_park": "놀이공원",
"pcat.bank": "은행",
"pcat.bar_cafe": "바 / 카페",
"pcat.beauty_salon": "미용실",
"pcat.cinema": "영화관",
"pcat.concert_theater": "콘서트홀 / 극장",
"pcat.coworking": "코워킹 스페이스",
"pcat.gym_fitness": "헬스장 / 피트니스",
"pcat.hospital_clinic": "병원 / 클리닉",
"pcat.library": "도서관",
"pcat.mall": "쇼핑몰",
"pcat.museum": "박물관",
"pcat.pharmacy": "약국",
"pcat.private_company": "사기업",
"pcat.public_transport": "대중교통",
"pcat.school_university": "학교 / 대학교",
"pcat.sports_center": "스포츠 센터",
"sub.cancelConfirm1": "정말 취소하시겠습니까? 귀하의 접근은 {days}까지 활성 상태로 유지됩니다.",
"an.found": "발견됨",
"an.lost": "분실됨",
"hc.shareReview": "리뷰 공유하기",
"hc.citiesAboveTarget": "{n}개 도시가 목표를 초과함",
"hc.cityAboveTarget": "{n}개 도시가 목표를 초과함",
"hc.j15EarlyReminder": "D-15 조기 알림",
"hc.j7EarlyReminder": "D-7 조기 알림",
"hc.annualTotal": "연간 총액",
"hc.billedOnceYear": "12개월에 대해 한 번 청구되며, 매년 자동 갱신됩니다.",
"hc.monthlyPrice": "월 요금",
"hc.perMonth": "/ 월",
"hc.perYear": "/ 년",
"hc.billedEachMonth": "매달 자동으로 청구됩니다.",
"nav.business": "비즈니스",
"nav.individual": "개인",
"hc.circumstancesFound": "발견된 상황",
"hc.circumstancesFoundPh": "예: 지하철 입구 근처 바닥에서 발견",
"hc.circumstancesLost": "분실된 상황",
"hc.circumstancesLostPh": "예: 버스를 기다리다가 벤치에 두고 간",
"hc.conditionPh": "예: 양호, 긁힌…",
"hc.firstName": "이름",
"hc.lastName": "성",
"hc.quantity": "아이템 수",
"fa.approve": "승인",
"fa.approveConfirm": "이 선언을 승인하시겠습니까? 귀하의 전체 연락처 정보(이름, 이메일, 전화번호)가 찾는 사람과 교환됩니다.",
"fa.approved": "선언 승인됨 — 연락처 정보가 교환되었습니다.",
"fa.approvedFinder": "소유자가 귀하의 선언을 승인했습니다.",
"fa.approvedFinderText": "반환을 조율하기 위해 그들과 연락하십시오.",
"fa.boostSub": "귀하의 목록이 선택한 기간 동안 상단에 유지됩니다.",
"fa.boostTitle": "내 목록 부스트하기 (선택 사항)",
"fa.colFinder": "찾는 사람의 선언",
"fa.colYours": "귀하의 선언",
"fa.compareHint": "결정하기 전에 찾는 사람의 선언과 귀하의 것을 비교하세요.",
"fa.contribNone": "기여 없음",
"fa.contribPaid": "기여가 접수되었습니다 — 감사합니다!",
"fa.contribPending": "기여가 지불을 기다리고 있습니다.",
"fa.contribSub": "findloop를 지원하여 더 많은 사람들이 소지품을 되찾을 수 있도록 돕습니다. €0을 선택할 수 있습니다.",
"fa.contribSuccessMsg": "귀하의 선언이 소유자에게 전송되었습니다.",
"fa.contribSuccessTitle": "기여에 감사드립니다",
"fa.contribTitle": "자발적 기여",
"fa.days3": "3일",
"fa.days30": "30일",
"fa.days7": "7일",
"fa.declSub": "발견한 아이템을 설명하세요. 소유자는 귀하의 선언을 그들의 것과 비교할 것입니다.",
"fa.declTitle": "이 아이템을 발견했습니다.",
"fa.expiresOn": "만료일",
"fa.fBrand": "브랜드",
"fa.fCircumstances": "상황",
"fa.fCity": "도시",
"fa.fColor": "색상",
"fa.fCondition": "상태",
"fa.fDate": "날짜",
"fa.fMessage": "찾는 사람의 메시지",
"fa.fPlace": "장소",
"fa.fQuantity": "수량",
"fa.finderContact": "찾는 사람의 연락처 정보",
"fa.finishPay": "지불 완료",
"fa.foundDate": "발견 날짜",
"fa.foundPlace": "발견 장소",
"fa.hours24": "24시간",
"fa.ht": "세금 별도",
"fa.months3": "3개월",
"fa.noBoost": "부스트 없음",
"fa.ownerContact": "소유자의 연락처 정보",
"fa.payPublish": "결제하고 게시하기",
"fa.pendingPayText": "결제가 확인되면 귀하의 목록이 즉시 활성화됩니다.",
"fa.pendingPayTitle": "결제 대기 중",
"fa.planSub": "결제가 확인되면 귀하의 목록이 즉시 활성화됩니다.",
"fa.planTitle": "목록 기간",
"fa.pubSuccessMsg": "귀하의 목록이 활성화되었습니다. 헌터가 나타나면 즉시 알려드립니다.",
"fa.pubSuccessTitle": "목록이 게시됨",
"fa.publicNote": "설명, 도시, 국가 및 사진만 공개됩니다.",
"fa.redirectStripe": "안전한 결제로 리디렉션 중…",
"fa.reject": "거절",
"fa.rejectConfirm": "이 선언을 거절하시겠습니까? 귀하의 목록은 온라인에 유지됩니다.",
"fa.rejected": "선언이 거부됨",
"fa.rejectedFinder": "그들이 찾고 있던 항목이 아니었습니다",
"fa.rejectedFinderText": "소유자가 이 항목이 자신의 것이 아니라고 말했습니다. 도움을 주셔서 감사합니다!",
"fa.responsesTitle": "헌터 선언",
"fa.sent": "소유자에게 선언이 전송되었습니다.",
"fa.submitDecl": "내 선언 전송",
"fa.submitDeclPay": "{amount}를 보내고 기여하기",
"fa.total": "총 결제액",
"fa.ttc": "부가세 포함",
"fa.waitClaimText": "헌터가 귀하의 요청을 검토 중입니다. 결정이 나면 알려드립니다.",
"fa.waitFinderText": "헌터가 선언을 제출하는 즉시 알려드리겠습니다.",
"fa.waitFinderTitle": "귀하의 목록이 활성화되었습니다",
"fa.waitOwnerText": "소유자가 귀하의 선언과 자신의 선언을 비교 중입니다. 결정이 나면 알려드립니다.",
"fa.waitOwnerTitle": "소유자의 결정을 기다리는 중",
"st.pending_payment": "결제 대기 중",
"fa.africaFree": "아프리카 무료 등록 — Findloop 런칭 오퍼, 즐기세요!",
"fa.africaPublished": "무료 등록 완료 — 아프리카 런칭 오퍼!",
"fa.approveClaimConfirm": "이 청구를 승인하시겠습니까? 그러면 소유자가 귀하의 연락처를 열 수 있게 됩니다.",
"fa.checkInfo": "전송하기 전에 귀하의 정보를 확인하세요: 찾는 사람의 정보와 비교됩니다.",
"fa.claimApprovedShort": "찾는 사람이 귀하의 청구를 승인했습니다",
"fa.claimRejectedShort": "찾는 사람이 청구를 거부했습니다",
"fa.claimRejectedText": "찾는 사람이 이 물건이 귀하의 것이 아니라고 믿습니다.",
"fa.claimSub": "아이템을 설명하고 2장의 사진을 추가하세요. 찾는 사람이 그것을 자신의 등록 정보와 비교합니다.",
"fa.claimTitle": "이것은 내 아이템입니다",
"fa.claimUnlockText": "물품 반품을 위해 찾는 사람의 연락처를 열어주세요.",
"fa.claimUnlockedShort": "연락처 정보가 열림 — 추적 보기",
"fa.claimsTitle": "소유자 청구",
"fa.colOwner": "소유자 선언",
"fa.colYourAd": "귀하의 등록",
"fa.expired": "등록이 만료되었습니다",
"fa.free": "무료",
"fa.lostDate": "분실 날짜",
"fa.lostPlace": "분실 장소",
"fa.noReceipt": "이 등록에 대한 영수증이 없습니다.",
"fa.planSubFree": "기간을 선택하세요: 귀하의 등록이 즉시 활성화되며, 결제가 필요 없습니다.",
"fa.prefillPrevious": "이 카테고리의 이전 등록 정보를 재사용합니다",
"fa.receipt": "PDF 영수증",
"fa.renewBtn": "갱신",
"fa.renewDiscountBanner": "50% 할인: 등록 만료 전에 갱신하세요!",
"fa.renewDiscountHint": "만료 전에 갱신했기 때문에 50% 할인 적용되었습니다.",
"fa.renewEarly": "조기 갱신 (−50%)",
"fa.renewTitle": "내 등록 갱신",
"fa.renewed": "등록이 갱신되었습니다",
"fa.sendClaim": "내 청구 보내기",
"fa.twoPhotos": "귀하의 아이템 2장 사진",
"fa.twoPhotosError": "귀하의 아이템 사진 2장을 추가하세요.",
"fa.twoPhotosHint": "물건이 귀하의 것임을 증명하는 개인 사진 (물품과 함께, 영수증, 상자…).",
"fa.unlockBtn": "연락처 정보 열기",
"fa.unlockFree": "무료로 열기 — 런칭 오퍼",
"fa.waitClaimantText": "소유자가 이 아이템을 청구하면 즉시 알려드리겠습니다.",
"fa.waitFinderDecision": "찾는 사람의 결정을 기다리는 중",
"fa.waitUnlockText": "연락처 정보가 교환되면 즉시 알림을 받게 됩니다.",
"fa.waitUnlockTitle": "소유자가 열기를 기다리는 중",
"fa.cancel": "취소",
"fa.categoryRequired": "찾은 항목에 대한 카테고리를 선택하세요.",
"fa.confirmTitle": "결정을 확인하세요",
"fa.goBack": "뒤로 가기",
"dr.continue": "신고서를 계속 작성하기",
"dr.delete": "영구 삭제",
"dr.deleteConfirm": "<b>이 초안을 영구 삭제</b>하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
"dr.deleted": "초안이 삭제되었습니다",
"dr.expiresIn": "{h}시간 더 초안이 유지됩니다",
"dr.title": "완료되지 않은 신고서가 있습니다",
"form.step": "단계",
"form.next": "계속",
"form.back": "뒤로",
"form.stepDetails": "귀하의 보고서",
"form.stepPublish": "기간, 기부 및 결제",
"fthx.badge": "보고서 거의 완료",
"fthx.title": "감사합니다, 당신의 도움이 됩니다!",
"fthx.text": "당신 덕분에 누군가가 곧 소중한 것을 되찾을 수 있습니다. 당신과 같은 친절한 행동이 Findloop를 지속 가능하게 만들어 줍니다.",
"fthx.impact1": "1건 신고됨",
"fthx.impact2": "재회의 기회 1회 더",
"fthx.tipTitle": "Findloop을 위한 작은 도움?",
"fthx.tipText": "당신의 기여는 서비스의 접근성을 유지하고 더 많은 아이템을 주인과 다시 연결하는 데 도움이 됩니다.",
"fthx.optional": "100% 선택 사항 — 기여 없이도 게시할 수 있습니다.",
"fthx.thanksTip": "당신의 관대함에 진심으로 감사드립니다!",
"fthx.suggest": "추천 금액",
"fthx.none": "기부 없음",
"form.stepThanks": "감사합니다 & 기여",
"pay.pendingTitle": "결제가 완료되지 않았습니다",
"pay.pendingText": "귀하의 정보가 저장되었습니다. 중단한 지점에서 결제를 계속 진행하세요.",
"pay.resume": "결제 계속",
"pay.expiredTitle": "결제 세션 시간이 만료되었습니다",
"pay.expiredText": "보안을 위해 결제 세션이 만료되었습니다. 귀하의 정보가 저장되었습니다: 한 번의 클릭으로 결제를 다시 시작하세요.",
"pay.relaunch": "결제 재시작",
"sub.received": "전송 완료!",
"sub.publishing": "마무리 중입니다…",
"sub.toPayment": "안전한 결제로 리다이렉션 중입니다…",
"fa.claimSubV2": "분실물에 대해 설명해주세요. 그것을 찾은 사람이 귀하의 신고와 그들의 목록을 비교할 것입니다.",
"fa.photosOptional": "물품 사진 (선택사항)",
"fa.compareOwnerHint": "이 정보를 찾은 물품과 비교한 후, 동일한 물품인지 알려주세요.",
"fa.itsThisItem": "네, 이것이 그 물품입니다",
"fa.notThisItem": "아니요, 이것은 그 물품이 아닙니다",
"fa.confirmIsItem": "이것이 물품이라는 것을 확인하시겠습니까? 귀하의 연락처 정보와 소유자의 정보가 각 계정에 표시됩니다.",
"fa.confirmNotItem": "이것이 물품이 아님을 확인하시겠습니까? 귀하의 신고가 종료됩니다.",
"fa.youConfirmed": "귀하가 이 물품이 소유자의 것임을 확인했습니다",
"fa.youDeclined": "귀하가 이것이 물품이 아님을 표시했습니다",
"fa.youDeclinedText": "도움 주셔서 감사합니다! 소유자에게 알림이 전달되었습니다.",
"fa.waitFinderDecisionOwner": "찾는 사람의 결정을 기다리고 있습니다",
"fa.finderConfirmed": "확인됨",
"fa.notYourItem": "이것은 귀하의 물품이 아닙니다",
"fa.reportedOn": "보고된 날짜",
"fa.ownerWaitHint": "현재 발견자가 정보를 확인하고 있으니, 잠시 기다려주세요.",
"fa.claimSentFinder": "아이템을 찾은 사람에게 청구가 전송되었습니다.",
"fa.compareClaimHint": "결정을 내리기 전에 소유자의 신고와 귀하의 목록을 비교하세요.",
"fa.closeFollowup": "이 추적을 닫기",
"fa.closeFollowupConfirm": "이 추적을 정말로 닫으시겠습니까? 소유자가 리스팅을 종료하면 양 당사자의 이메일과 전화번호는 영구적으로 삭제됩니다.",
"fa.safetyTitle": "인수 전 안전 팁",
"fa.safety1": "소유자에게 물품의 숨겨진 특징에 대한 자세한 설명을 요청하세요: 특정 흠집, 가방의 정확한 내용물, 벽지, 일련번호…",
"fa.safety2": "가능하다면 시각적 증거(물품의 사진)나 구매 증명을 요청하세요.",
"fa.safety3": "공공 장소나 Findloop 파트너에서 물품을 전달하고, 소유자의 신분증을 확인하세요.",
"fa.safetyOk": "알겠습니다, 계속하기",
"fa.ownerClosedNote": "소유자가 리스팅을 종료했습니다.",
"fa.finderClosedNote": "발견자가 추적을 종료했습니다.",
"fa.followupClosed": "후속 조치 종료",
"fa.followupClosedText": "이 후속 조치를 종료하셨습니다. 도움 주셔서 감사합니다!",
"fa.photoReviewTitle": "찾는 사람이 사진을 보냈습니다. 당신의 아이템처럼 보이나요?",
"fa.photoLooksLike": "네, 제 아이템처럼 보여요",
"fa.photoNotMine": "아니요, 이것은 제 아이템이 아니에요",
"fa.photoNotMineConfirm": "후속 조치는 양쪽에서 종료되며, 당신의 목록은 새로운 찾는 이를 위해 열려 있습니다.",
"fa.photoLooksLikeDone": "감사합니다! 찾는 사람이 당신의 선언을 비교할 것입니다.",
"fa.photoNotMineDone": "신고가 기각되었습니다. 당신의 목록은 열려 있습니다.",
"fa.ownerPhotoHint": "찾는 사람의 사진만 당신에게 보여집니다. 당신의 아이템처럼 보이는지 알려주세요.",
"fa.ownerReviewingPhoto": "소유자가 당신의 사진을 검토하고 있습니다",
"fa.ownerReviewingPhotoText": "그들이 답변하는 즉시 알림을 받을 것입니다. 그때 당신은 그들의 선언을 비교할 수 있습니다.",
"fa.ownerRejectedPhoto": "이것은 소유자의 아이템이 아닙니다",
"fa.ownerRejectedPhotoText": "소유자가 당신의 사진이 그들의 아이템과 일치하지 않는다고 말했습니다. 후속 조치는 종료되었습니다. 도움에 감사드립니다!",
"fa.contribute": "기여하기",
"fa.phoneMissing": "제공되지 않음",
"fa.ownerSafety1": "공공 장소나 Findloop 파트너에게 전달하는 것을 선호합니다. 거리가 먼 경우, 우편으로 보내는 것을 제안하세요.",
"fa.ownerSafety2": "전달 시, 찾는 사람의 신분증을 확인하세요.",
"pub.changePhoto": "사진 변경",
"ph.secured": "사진이 보호되었습니다",
"ph.securing": "사진 보호 중…",
"fa.ownerSafety3": "발견자의 사진에 Findloop 워터마크가 포함되어 있으면 만남을 수락하지 마세요. 사진은 발견자가 찍은 원본 이미지여야 하며, 워터마크가 없어야 합니다."
},
"tr": {
"ac.africa": "Afrika",
"ac.boostActive": "Aktif öne çıkma —",
"ac.boostSub": "“Öne Çıkan” rozeti ile ortaklar dizininde en üstte görün.",
"ac.boostTitle": "Dizindeki kaydınızı öne çıkarın",
"ac.categoryHint": "Kuruluşunuzu Findloop dizininde sınıflandırmak için.",
"ac.choose": "Seç",
"ac.cityHint": "Halka açık haritada kesin konumlandırma için.",
"ac.cityLabel": "Kuruluşun şehri",
"ac.cityPh": "Paris",
"ac.contact": "İletişim bilgileri",
"ac.converted": "Dönüştürüldü",
"ac.copyDeclLink": "Beyan bağlantısını kopyala",
"ac.copyLink": "Bağlantıyı kopyala",
"ac.currentPlan": "Mevcut plan",
"ac.emailDesc": "Almak istediğiniz e-postaları seçin. Çalışma alanınızdaki bildirimler her zaman etkin kalır.",
"ac.emailMatch": "Eşleşmeler",
"ac.emailMatchDesc": "Bir öğe bir beyanla eşleştiğinde bir e-posta",
"ac.emailNewDecl": "Yeni kayıp beyanları",
"ac.emailNewDeclDesc": "Bir müşteri kaybı bildirdiğinde hemen bir e-posta",
"ac.emailShip": "Gönderim talepleri",
"ac.emailShipDesc": "Bir müşteri bir öğenin gönderimini talep ettiğinde bir e-posta",
"ac.emailTitle": "E-posta tercihleri",
"ac.expireSoon": "Öne çıkarma süreniz yakında doluyor —",
"ac.exportCsv": "Dışa Aktar (CSV)",
"ac.exportHint": "Muhasebeniz için onaylanan dış ödemelerinizi dışa aktarın.",
"ac.free": "Ücretsiz",
"ac.freeMonths": "Ücretsiz aylar",
"ac.hours": "saat",
"ac.howItWorks": "Bu nasıl çalışır?",
"ac.invited": "Davet edildi",
"ac.legalFR": "E-faturalama için gerekli (Factur-X), Eylül 2026'dan itibaren geçerli.",
"ac.legalMissing": "⚠️ SIRET ve AB içi KDV eksik — e-faturalama ile uyumlu kalmak için tamamlayın.",
"ac.legalOther": "Faturalarınız için önerilir.",
"ac.legalPartnerQr": "QR kodu",
"ac.legalTitle": "Hukuki tanımlar (faturalama)",
"ac.logoTitle": "Kuruluş logosu",
"ac.modeCurrent": "Mevcut mod:",
"ac.modeExternal": "Dış (manuel onay)",
"ac.modeInternal": "İç Findloop (otomatik)",
"ac.noSubReceipt": "Henüz ödenmiş bir abonelik ödemesi yok.",
"ac.none": "Yok",
"ac.onYourListing": "kaydınızda",
"ac.pay1": "Aşağıya ödeme bağlantılarınızı girin, müşterilerinizi kendi tahsilat sisteminize yönlendirin.",
"ac.pay2": "Onaylama manuel hale geliyor: “Beyanlar” sekmesinden ödeme alımını onaylıyorsunuz.",
"ac.pay3": "“Gönderim ücreti” bağlantısı birleştirilmiş bir ödemedir (kurtarma + gönderim).",
"ac.pay4": "Otomatik onayla Findloop'nun iç ödeme sistemini (Stripe) kullanmak için alanları boş bırakın.",
"ac.paySub": "Kendi ödeme sisteminiz aracılığıyla ücret alın.",
"ac.payTitle": "Dış ödemeler",
"ac.permissive": "İzin veren",
"ac.phone": "Telefon",
"ac.posterA4": "A4 afiş (PDF)",
"ac.qMessage": "Mesaj (isteğe bağlı)",
"ac.qName": "Ad",
"ac.qOrg": "Organizasyon",
"ac.qSites": "Kuruluş sayısı (tahmini)",
"ac.qrHint": "Müşterileriniz kaybolan bir öğeyi bildirmek için bu kodu tarar.",
"ac.qrPng": "QR (PNG)",
"ac.qrTitle": "Ortak QR kodunuz",
"ac.quoteDesc": "Havalimanları, demiryolu ağları, uluslararası zincirler · ",
"ac.quoteEurope": "Avrupa / Dünya",
"ac.quoteSent": "Teklif talebi gönderildi. Ekibimiz kısa süre içinde sizinle iletişime geçecek.",
"ac.quoteTitle": "Teklif talep et — Kurumsal",
"ac.recoveryLink": "“Kurtarma ücreti” bağlantısı",
"ac.refSub": "Her yönlendirdiğiniz ortak, size 1 ücretsiz ay kazandırır.",
"ac.refTitle": "Yönlendir, ücretsiz bir ay kazan",
"ac.reminderDelay": "Doğrulama hatırlatma gecikmesi",
"ac.reminderHint": "Bu gecikmeden (varsayılan: 48 saat) sonra harici bir ödeme doğrulanmazsa bir e-posta hatırlatıcısı alacaksınız.",
"ac.renewDesc1": "Size şimdiden kazandırdı",
"ac.renewDesc2": "Rehberin en üstünde kalmak ve bu görünürlüğü kaybetmemek için yenileyin.",
"ac.renewNow": "Şimdi yenileyin",
"ac.requestQuote": "Teklif iste",
"ac.saveLegal": "Tanımlayıcıları kaydet",
"ac.saveLinks": "Bağlantıları kaydet",
"ac.sendRequest": "Talebimi gönder",
"ac.sending": "Gönderiliyor…",
"ac.shippingLink": "“Gönderim ücreti” bağlantısı (birleştirilmiş)",
"ac.shippingLinkHint": "Bu bağlantı hem kurtarma hem de gönderimi kapsar.",
"ac.strict": "Sıkı",
"ac.subReceipt": "Abonelik makbuzu (PDF)",
"ac.subReceiptsSub": "Her abonelik ödemesi için PDF makbuzunu indirin.",
"ac.subReceiptsTitle": "Abonelik makbuzları",
"ac.tCategory": "Kategori kaydedildi",
"ac.tCity": "Şehir kaydedildi — harita güncellendi",
"ac.tCityNeeded": "Bir şehir girin",
"ac.tCopied": "Kopyalandı!",
"ac.tCover": "Kapak fotoğrafı güncellendi",
"ac.tEmailPrefs": "E-posta tercihleri güncellendi",
"ac.tErr": "Hata",
"ac.tExportImpossible": "Dışa aktarım başarısız",
"ac.tLegal": "Hukuki tanımlayıcılar kaydedildi",
"ac.tLegalNeeded": "Fransa için SIRET ve KDV gerekiyor",
"ac.tLogo": "Logo güncellendi",
"ac.tLogoRemoved": "Logo kaldırıldı",
"ac.tPayLinks": "Ödeme bağlantıları kaydedildi",
"ac.tPhone": "Telefon kaydedildi",
"ac.tSensitivity": "Hassasiyet kaydedildi",
"ac.tVatInvalid": "Geçersiz KDV numarası",
"ac.tVatValid": "Geçerli KDV",
"ac.tabBoost": "Görünürlük",
"ac.tabPayments": "Ödemeler",
"ac.tabProfile": "Profil",
"ac.tabQr": "QR & Poster",
"ac.tabReferral": "Yönlendirme",
"ac.tabSub": "Abonelik",
"ac.thisWeek": "Bu hafta",
"ac.thisWeekOf": " ({n} bu hafta)",
"ac.thresholdDesc": "AI'nin otomatik olarak bir fotoğraf eşleşmesini doğruladığı ve müşteriyi bilgilendirdiği güven eşiği. Daha yüksek = daha az otomatik eşleşme ama daha güvenilir.",
"ac.thresholdTitle": "AI görsel eşleşme hassasiyeti",
"ac.trend": "Eğilim",
"ac.upload": "Yükle",
"ac.vatValidFmt": "Geçerli KDV{name} ({via})",
"ac.vatVerified": "AB içi KDV doğrulandı",
"ac.verifyVat": "KDV'yi doğrula (VIES)",
"ac.verifying": "Doğrulanıyor…",
"ac.views": "görüntüleme",
"ac.viewsTotal": "Kazanan görüntülemeler (toplam)",
"ac.winbackBtn": "-20% ile devam et",
"ac.winbackDesc1": "Size kazandırdı",
"ac.winbackDesc2": "Özel teklif: 24 saat içinde yenilerseniz otomatik olarak -20% uygulanır.",
"ac.winbackTitle": "Vurgunuz az önce sona erdi — -20% ile devam edin!",
"an.allCountries": "Tüm ülkeler",
"an.country": "Ülke",
"an.geoBanner": "İlanları görüntülediğiniz yer",
"an.geoBannerWorld": "Dünya genelinde ilanları görüntülüyorsunuz",
"an.geoChange": "ülkeyi değiştir",
"an.loginRequired": "Bu öğeyi bildirmek ve iade sürecini takip etmek için giriş yapın.",
"an.requestInProgress": "İstek işleniyor",
"an.resolved": "Öğe zaten geri alındı",
"an.sortRecent": "En yeni",
"an.sortRelevance": "İlgili",
"bo.africaPrice": "Afrika bölgesi için tercihli fiyat uygulandı",
"c.all": "Hepsi",
"c.close": "Kapat",
"c.confirm": "Onayla",
"c.confirmed": "Onaylandı",
"c.download": "İndir",
"c.reset": "Sıfırla",
"c.transfer": "Transfer et",
"cat.Animal": "Evcil hayvan / Evcil hayvan aksesuarı",
"cat.AppareilPhoto": "Kamera",
"cat.Argent": "Para / Nakit",
"cat.Autres": "Diğer",
"cat.Bijoux": "Takı",
"cat.CarteBancaire": "Banka kartı",
"cat.CarteIdentite": "Kimlik kartı / Pasaport",
"cat.Casquette": "Şapka",
"cat.Ceinture": "Kemer",
"cat.Chargeur": "Şarj cihazı / Kablo",
"cat.Chaussures": "Ayakkabılar",
"cat.CleVoiture": "Araba anahtarı",
"cat.Cles": "Anahtarlar",
"cat.Console": "Oyun konsolu",
"cat.Documents": "Belgeler / Kağıtlar",
"cat.Echarpe": "Şal",
"cat.Ecouteurs": "Kulaklık / Kafaüstü",
"cat.Electronique": "Elektronik (diğer)",
"cat.Enceinte": "Hoparlör",
"cat.Gants": "Eldiven",
"cat.Gourde": "Su şişesi / Termos",
"cat.Instrument": "Müzik aleti",
"cat.Jouet": "Oyuncak / Peluş",
"cat.Jumelles": "Dürbün",
"cat.Lampe": "Lamba / Fener",
"cat.Liseuse": "E-kitap okuyucu",
"cat.Livre": "Kitap / Defter",
"cat.Lunettes": "Gözlük",
"cat.Manteau": "Kaban / Ceket",
"cat.Maquillage": "Makyaj çantası",
"cat.Medical": "Tıbbi ekipman",
"cat.Medicaments": "İlaç",
"cat.Montre": "Saat / Akıllı saat",
"cat.Ordinateur": "Dizüstü bilgisayar",
"cat.Parapluie": "Şemsiye",
"cat.Portefeuille": "Cüzdan / Çanta",
"cat.Poussette": "Bebek arabası / Bebek aksesuarı",
"cat.Sac": "Çanta / El çantası",
"cat.SacADos": "Sırt çantası",
"cat.Souris": "Fare / Klavye",
"cat.Sport": "Spor ekipmanı",
"cat.Tablette": "Tablet",
"cat.Telephone": "Telefon / Akıllı telefon",
"cat.Trottinette": "Süreksiz",
"cat.Trousse": "Torba / Kılıf",
"cat.USB": "USB bellek / Harici sürücü",
"cat.Valise": "Valiz / Bagaj",
"cat.Velo": "Bisiklet",
"cat.Vetements": "Giysi",
"cm.found": "BULUNDU",
"cm.lost": "KAYBOLDU",
"cmp.starterEst": "1 dahil + sınırsız ek",
"consent.required": "Devam etmek için iletişim bilgilerinizi paylaşmayı kabul etmelisiniz.",
"consent.share": "Eşyamın bulucusunun bana ulaşabilmesi için iletişim bilgilerimi (isim, e-posta, telefon) görebilmesini kabul ediyorum.",
"dc.partnerDesc": "Eşyanızı bir ortak mekanda (otel, istasyon, salon…) kaybettiniz mi? Doğrudan geri dönüş için seçin.",
"dc.partnerList": "Listeden seçin",
"dc.partnerMap": "Haritada seçin",
"dc.partnerTitle": "Ortakta bildirim",
"dc.publicCta": "Genel bir ilan ver",
"dc.publicDesc": "İlanınız tüm Findloop topluluğu tarafından görülebilir. Eşyayı nerede kaybettiğinizi bilmiyorsanız ideal.",
"dc.publicTitle": "Genel bildirim",
"dc.subtitle": "Kaybolan eşyanızı bildirmek için nasıl bir yol izlemek istersiniz?",
"dc.title": "Ne yapmak istersiniz?",
"dec.addrPending": "Müşteriden adres bekleniyor",
"dec.analyzing": "Analiz ediliyor…",
"dec.clientDescription": "Müşteri açıklaması",
"dec.clientPhoto": "Müşteri tarafından sağlanan fotoğraf",
"dec.clientPhotoShort": "Müşterinin fotoğrafı",
"dec.comparePhotos": "Fotoğrafları karşılaştır",
"dec.declaredItemPhoto": "Bildirilen eşyanın fotoğrafı",
"dec.emptyDesc": "Bildirimleri almak için QR kodunuzu paylaşın.",
"dec.emptyTitle": "Hiçbir bildirim yok",
"dec.enlarge": "Büyüt",
"dec.extBanner": "{n} harici ödeme onaylamak için — teslim alma veya gönderim için aşağıdaki alımı onaylayın.",
"dec.foundItemAlt": "Bulunan eşya",
"dec.foundItemRegistry": "Bulunan eşya (kayıt)",
"dec.labelClient": "Müşteri",
"dec.labelRegistry": "Kayıt",
"dec.noMatchYet": "Henüz eşleşme yok.",
"dec.noPhoto": "Fotoğraf yok",
"dec.pRecup": "geri kazanım",
"dec.pRecupP": "(geri kazanım)",
"dec.pRecupShip": "(geri kazanım + gönderim)",
"dec.payConfirmed": "Ödeme {x} onaylandı",
"dec.payPending": "Harici ödeme {x} beklemede",
"dec.pickup": "Yüz yüze teslim alma",
"dec.reject": "Reddet",
"dec.rerun": "Analizi yeniden çalıştır",
"dec.similarity": "Benzerlik {n}%",
"dec.suggestedMatches": "Önerilen eşleşmeler",
"dec.toColon": " olan:",
"dec.toShip": "Gönderilecek",
"dec.toastExtPay": "Ödeme onaylandı — müşteri bilgilendirilecektir.",
"dec.toastMatch": "Eşleşme onaylandı",
"dec.toastReject": "Öneri reddedildi",
"dec.toastRerun": "Analiz yeniden başlatıldı",
"dec.toastVisualN": "{n} görsel eşleşme",
"dec.toastVisualNone": "Görsel eşleşme yok",
"dec.viewBeforeAfter": "Önce/sonra görünümü (kaplama)",
"dec.viewSideBySide": "Yan yana görünüm",
"dec.visualCompare": "Yapay zeka görsel karşılaştırması",
"dec.visualIdle": "Yapay zekanın müşterinin fotoğrafını bulunan eşyalarla görsel olarak eşleştirmesi için karşılaştırmayı çalıştırın.",
"dec.visualRunning": "Yapay zeka, müşterinin fotoğrafını kaydınızdaki öğelerle karşılaştırıyor…",
"dec.zoomPhoto": "Fotoğrafı büyüt",
"dep.addAnyway": "Yine de ekle",
"dep.addError": "Ekleme sırasında hata",
"dep.addItem": "Öğe ekle",
"dep.added": "Öğe kayda eklendi!",
"dep.adding": "Ekleniyor…",
"dep.aiError": "Yapay zeka analizi şu anda mevcut değil.",
"dep.aiFilled": "Form, yapay zeka tarafından önceden dolduruldu ✨",
"dep.aiUnavailable": "Yapay zeka kullanım dışı — formu manuel olarak doldurun.",
"dep.analyzing": "Analiz ediliyor…",
"dep.analyzingPhoto": "Fotoğraf analiz ediliyor…",
"dep.brand": "Marka",
"dep.brandPlaceholder": "ör. Apple",
"dep.category": "Kategori",
"dep.checkingDup": "Çiftleri kontrol ediliyor…",
"dep.color": "Renk",
"dep.colorPlaceholder": "ör. siyah",
"dep.condition": "Durum",
"dep.conditionPlaceholder": "ör. iyi durumda",
"dep.depositorNote": "Depozitör notu",
"dep.depositorNoteHint": "Operasyonel detaylar elle yazılmıştır. Yapay zeka bu notu asla değiştirmez.",
"dep.depositorNotePlaceholder": "ör. bir poşetin içeriği, bildirilen markası, kişi tarafından verilen detaylar…",
"dep.descPlaceholder": "ör. barın içinde bulunan şeffaf kılıflı siyah iPhone 15…",
"dep.description": "Açıklama",
"dep.dupHint": "Çift bir öğe eklemediğinizden emin olun. Gerçekten farklıysa devam edebilirsiniz.",
"dep.dupTitle": "Benzer öğe(ler) zaten kaydedildi",
"dep.dupWarn": "Benzer öğe tespit edildi — gözden geçirin ve onaylamak için tekrar tıklayın.",
"dep.estHint": "Öğe, bu işletmenin kaydına eklenecek.",
"dep.establishment": "İşletme",
"dep.fee": "Kurtarma ücreti (€) — isteğe bağlı",
"dep.feePlaceholder": "Kategori varsayılan fiyatı için boş bırakın",
"dep.fillAI": "Yapay zeka ile doldur",
"dep.optional": "(isteğe bağlı)",
"dep.photo": "Öğe fotoğrafı",
"dep.principal": "birincil",
"dep.reqError": "Kategori ve açıklama gereklidir.",
"dep.savedItem": "Kaydedilen öğe",
"dep.similarity": "Benzerlik",
"dep.storage": "Fiziksel konum",
"dep.storageHint": "Öğenin fiziksel olarak saklandığı yer. Bulmak için bir QR kodu oluşturulacak.",
"dep.storagePlaceholder": "ör. Raf A3, Kilitli Dolap 12, Resepsiyon kasası",
"dl.aClient": "bir müşteri",
"dl.alertsBlocked": "Tarayıcı uyarıları engellendi",
"dl.alertsBlockedHint": "Tekrar etkinleştirmek için: site adresinin solundaki 🔒 (veya ⓘ) simgesine tıklayın, ardından Bildirimleri izin verin ve sayfayı yenileyin.",
"dl.amountDue": "Ödenecek tutar: {amount} {currency}.",
"dl.enableAlerts": "Uyarıları etkinleştir",
"dl.extPending": "Onaylanacak ödemeler",
"dl.freemiumNear": "Freemium limitine yaklaşıyorsunuz ({used}/{max} öğe bu ay). Sınırsız öğe için Starter'a yükseltin.",
"dl.freemiumReached": "Freemium limiti aşıldı ({used}/{max} öğe bu ay). Sınırsız öğe kaydetmek için Starter'a yükseltin.",
"dl.invoiceOverdue": "Fatura {num} ödenmemiş - erişim kısıtlı.",
"dl.matchNotifTitle": "Findloop — Yeni AI eşleşmesi 🔔",
"dl.matchToast": "Yeni AI eşleşmesi — {name}",
"dl.matchToastDesc": "Bir öğe bir beyanla eşleşiyor.",
"dl.notifEmpty": "Henüz bildirim yok.",
"dl.notifEnabled": "Tarayıcı uyarıları etkinleştirildi",
"dl.notifTitle": "Bildirimler",
"dl.payInvoice": "Faturamı öde →",
"dl.rewardsPending": "Taksitler sunulacak",
"dl.upgradeStarter": "Starter'a yükselt →",
"est.all": "Tüm kuruluşlar ({n})",
"est.label": "Kuruluş",
"est.primary": "birincil",
"est.secondary": "ikincil",
"est2.add": "Bir kuruluş ekleyin",
"est2.addressLabel": "Adres",
"est2.addressPh": "12 République Caddesi",
"est2.autoInvoice": "Her ayın 1'inde ayrıntılı bir fatura otomatik olarak oluşturulur.",
"est2.baseSub": "Temel abonelik",
"est2.billing": "Faturalama",
"est2.boostActivated": "{name} için artırma etkinleştirildi",
"est2.boostBillingNote": "Mevcut tarifeye göre faturalandırılır ve toplu aylık faturanızda gruplandırılır.",
"est2.boostCta": "Artır",
"est2.boostDesc": "Bu kuruluşun dizindeki ve haritadaki görünürlüğünü artırın.",
"est2.boostDuration": "{h} saat artırılmış görünürlük",
"est2.boostExtend": "Uzat",
"est2.boostTitle": "{name} artır",
"est2.boosted": "Artırıldı",
"est2.chartDesc": "Yerel kaydedilen toplamdan dönen ürünlerin oranı, site bazında.",
"est2.chartTitle": "Kuruluşa göre iade oranı",
"est2.chartTooltip": "İade",
"est2.cityLabel": "Şehir",
"est2.cityPh": "Lyon",
"est2.contactHint": "Bu bilgiler, bu kuruluş için müşteriye gösterilir (boşsa hesap bilgilerine geri döner).",
"est2.countryLabel": "Ülke",
"est2.coverLabel": "Kapak fotoğrafı",
"est2.create": "Oluştur",
"est2.created": "Kuruluş oluşturuldu",
"est2.delete": "Sil",
"est2.deleteDesc": "Bu eylem kalıcıdır. Bir kuruluşu yalnızca içinde öğe yoksa silebilirsiniz.",
"est2.deleteTitle": "“{name}” silinsin mi?",
"est2.deleted": "Kuruluş silindi",
"est2.dialogDesc": "Bu alanın adını ve adresini girin.",
"est2.edit": "Düzenle",
"est2.editEst": "Kuruluşu düzenle",
"est2.emailLabel": "İletişim e-postası",
"est2.emailPh": "contact@site.com",
"est2.estSuffix": " kuruluş(lar)",
"est2.extraNoteBase": "{n} ek kuruluş faturalandırıldı",
"est2.extraPrice": " {price} €/ay.",
"est2.extraQuote": " teklife göre.",
"est2.imgChange": "Bir resim seçin",
"est2.imgDone": "Tamam",
"est2.imgRemove": "Kaldır",
"est2.imgRemoved": "Resim kaldırıldı",
"est2.imgSaved": "Resim kaydedildi",
"est2.imgUploading": "Yükleniyor…",
"est2.includedPlan": "Planınıza dahil: {n}.",
"est2.kDeclarations": "Beyanlar",
"est2.kInStorage": "Depoda",
"est2.kItemsTotal": "Öğeler (toplam)",
"est2.kRestituted": "İade edilen",
"est2.limitReached": "Sınıra ulaşıldı",
"est2.logoLabel": "Logo",
"est2.mDeclar": "Beyan.",
"est2.mItems": "Öğeler",
"est2.mRestituted": "İade edilen",
"est2.mStorage": "Depoda",
"est2.monthlyTotal": "Aylık toplam",
"est2.nameLabel": "İsim *",
"est2.namePh": "örn. Belmont Oteli — Lyon Ek Binası",
"est2.newEst": "Yeni kuruluş",
"est2.onQuote": "Teklifte",
"est2.phoneLabel": "Telefon",
"est2.phonePh": "+33 1 23 45 67 89",
"est2.plan": "Plan",
"est2.planLimited": "Sizin “{tier}” planınız {max} kuruluşla sınırlıdır.",
"est2.primary": "Ana",
"est2.qr": "QR kodu",
"est2.qrDesc": "Bu QR kodunu bu kuruluşta gösterin. Kayıp bildiren müşteriler bu siteye yönlendirilecektir.",
"est2.qrTitle": "QR kodu — {name}",
"est2.saving": "Kaydediliyor…",
"est2.seeInvoices": "Aylık faturalarımla gör",
"est2.seePlans": "Planları gör",
"est2.subtitle": "Tüm sitelerinizi tek bir hesap altında yönetin — konsolide görünüm, öğeler, QR kodu ve faturalama.",
"est2.suspended": "Askıya alındı",
"est2.tierFree": "1 kuruluş",
"est2.tierLarge": "sınırsız kuruluş",
"est2.tierMedium": "5 kuruluş dahil",
"est2.tierSmall": "3 kuruluş dahil",
"est2.title": "Kuruluşlar",
"est2.unlimitedPlan": "Planınız, sınırsız sayıda kuruluş eklenmesine izin verir.",
"est2.unlimitedSuffix": " · sınırsız",
"est2.updated": "Kuruluş güncellendi",
"est2.upgradeHint": "Daha fazla site eklemek ve tüm aktivitenizi merkezileştirmek için daha yüksek bir plana yükseltin.",
"est2.visuals": "Logo & fotoğraf",
"est2.visualsDesc": "Bu kuruluşun logosunu ve kapak fotosunu özelleştirin. Bunlar genel sayfasında ve beyan formunda görünür.",
"est2.visualsTitle": "Görseller — {name}",
"est2.workOn": "Bu kuruluşta çalış",
"est2.working": "“{name}” üzerinde çalışıyorsunuz",
"ft.backAccount": "Hesabıma geri dön",
"ft.closeBtn": "Olayı kapat",
"ft.closeConfirm": "Öğenin geri gönderildiğini onaylıyor musunuz? İlan kapatılacak.",
"ft.closeLockedHint": "Kapatmayı açmak için öncelikle sahibin kodunu doğrulayın.",
"ft.closed": "Olay kapandı — öğe geri gönderildi!",
"ft.codeLabel": "Sahibinden alınan doğrulama kodunu girin",
"ft.codeNeeded": "Lütfen doğrulama kodunu girin.",
"ft.codeOk": "Kod doğrulandı — olayı kapatabilirsiniz.",
"ft.codePlaceholder": "örn. 4821",
"ft.codeVerified": "Doğrulandı",
"ft.doneMsg": "Öğe geri gönderildi. Onu sahibine geri göndermeye yardımcı olduğunuz için teşekkürler!",
"ft.stepInProgress": "Geri göndermesi devam ediyor",
"ft.stepPublished": "İlan yayımlandı",
"ft.stepReturned": "Öğe geri gönderildi",
"ft.subtitle": "Bulunan öğe geri gönderilene kadar adımları takip edin.",
"ft.title": "Geri izleme",
"ft.verifyBtn": "Kodu doğrula",
"inv2.contractTitle": "Benim Findloop sözleşmem",
"inv2.detailByEst": "Kuruluşa göre detay",
"inv2.dueLabel": "Son tarih:",
"inv2.dueSuffix": " · son tarih {date}",
"inv2.error": "Hata {status}",
"inv2.estCountIssued": "{n} kuruluş · {date}'de verildi",
"inv2.estimate": "Tahmin (ücret alınmadı) · {n} kuruluş",
"inv2.expired": " · süresi dolmuş",
"inv2.exportCsv": "CSV Dışa Aktar",
"inv2.exportDone": "CSV dışa aktarma indirildi",
"inv2.included": "Dahil",
"inv2.monthlyTitle": "Aylık faturalama (abonelik)",
"inv2.months": "+{n} ay",
"inv2.paid": "Ödendi",
"inv2.pay": "Öde",
"inv2.previewTitle": "Sonraki faturanızın önizlemesi —",
"inv2.renew": "Sözleşmemi yenile",
"inv2.renewalsTitle": "Yenileme geçmişi ({n})",
"inv2.renewedUntil": "Sözleşme {date} tarihine kadar yenilendi",
"inv2.serviceTitle": "Hizmet faturaları (geri ödemeler & tekliflerin)",
"inv2.soon": "Yakında sona eriyor",
"inv2.toPay": "Ödenecek",
"inv2.totalHtTva": "Toplam vergi hariç · KDV",
"inv2.totalTtc": "Toplam vergi dahil",
"iu.addPhoto": "Bir fotoğraf ekle",
"iu.change": "Değiştir",
"map.high": "Yüksek",
"map.legend": "Dönüş oranına göre kırmızı (düşük) ile yeşil (yüksek) arasındaki renkli noktalar; boyut, öğe sayısına göre ayarlanmıştır.",
"map.locating": "Konumlanıyor… Haritada görmek için işletmelerinize bir adres ekleyin.",
"map.low": "Düşük",
"map.medium": "Orta",
"map.noItemRegistered": "Kayıtlı öğe yok",
"map.noItems": "Öğe yok",
"map.returnedSuffix": "iade edildi · {a}/{t} öğe",
"map.title": "İşletmelerinizin haritası",
"mc.archiveHide": "Geçmişi gizle",
"mc.archiveNone": "Henüz çözülmüş bir durum yok.",
"mc.archiveShow": "Geçmişi göster",
"mc.archiveSub": "Çözümlenmiş ve iade edilmiş vakalar.",
"mc.archiveTitle": "Geçmiş",
"mc.certificate": "Sertifika",
"mc.finderAccepted": "Kabul edildi",
"mc.hAd": "Kayıp ilanı",
"mc.hDeclaration": "Beyan",
"mc.hFinderContact": "Bildirilmiş öğe",
"mc.hFound": "İade edilen öğe",
"mc.hFoundAd": "Bulunan ilan",
"mc.myFinds": "Bulduğum eşyalar",
"mc.myFindsNone": "Henüz herhangi bir öğe bulduğunuzu bildirmediniz.",
"mc.myFindsSub": "Kayıp eşya ilanlarında bulduğunuzu bildirdiğiniz öğeler.",
"mc.notifOpen": "Görüntüle",
"mc.notifTrack": "Takip et",
"mc.notifViewAd": "İlanı görüntüle",
"mc.presentHint": "Bu QR'yi ortağa gösterin: ödülünüzü doğrulamak için tararlar.",
"mc.presentInStore": "Mağazada göster",
"mc.presentTitle": "Bu kuponu göster",
"mc2.acceptFinder": "Bu bulucuyu kabul et",
"mc2.accountActivity": "Hesap etkinliği",
"mc2.adsActive": "{n}/5 aktif ilan",
"mc2.badgeBronze": "Bronz",
"mc2.badgeGold": "Altın",
"mc2.badgeSilver": "Gümüş",
"mc2.boostEarnedAlready": "Sizde zaten kazandırdı",
"mc2.boostEarnedWin": "Sizde kazandırdı",
"mc2.boostExpiredWin": "Destek süreniz sona erdi — %20 indirimle devam edin!",
"mc2.boostWinDetail2": ". 24 saat içinde yenilerseniz otomatik olarak -%20 uygulanır.",
"mc2.claimCode": "Talep kodu:",
"mc2.codeSentFinder": "Kod bulucuya e-posta ile gönderildi",
"mc2.daysShort": "{n} g",
"mc2.downloadReceipt": "Faturamı indir",
"mc2.error": "Hata {status}",
"mc2.finderAccepted": "Finder kabul edildi — kod e-posta ile gönderildi",
"mc2.finderContacts": "Finder'ın iletişim bilgileri",
"mc2.followFindo": "Findloop'yu takip et",
"mc2.imgInvalid": "Geçersiz resim",
"mc2.inactivityNote": " — {n} aylık pasiflik durumunda (GDPR).",
"mc2.lastActivity": "Son etkinlik:",
"mc2.lostEmailTitle": "Artık e-posta adresime erişimim yok",
"mc2.noPhotoPreset": "Henüz fotoğraf yok mu? Varsayılan avatarı seçin:",
"mc2.paidViaPartner": "Ödendi (ortağa üzerinden)",
"mc2.payRecovery": "Geri kazanım ücretini öde",
"mc2.paySettle": "Ödememi tamamla",
"mc2.payShipping": "Kargo ücretini öde",
"mc2.payUnavailable": "Ödeme yapılamıyor",
"mc2.peopleFound": "{n} kişi öğenizi bulduğunu düşünüyor",
"mc2.phoneNumber": "Telefon numarası",
"mc2.reactivateAccount": "Hesabımı tekrar etkinleştir",
"mc2.reactivated": "Hesap yeniden etkinleştirildi",
"mc2.reactivatedThanks": "Hesap yeniden etkinleştirildi — sadakatiniz için teşekkürler!",
"mc2.recoverSmsBtn": "Kodumu SMS ile al",
"mc2.recoverSmsDesc": "Talep kodunuzu, hesabınıza kayıtlı numaraya SMS olarak alın.",
"mc2.recoverSmsFallback": "Bu numara ile bir hesap varsa, bir SMS gönderildi.",
"mc2.renewStayTop": ". Yenileyerek önde kalın ve öğenizi geri kazanin.",
"mc2.resume20": "Devam Et -%20",
"mc2.unlockContacts": "İletişim bilgilerini aç",
"mc2.unlockDesc": "İletişim bilgilerini açmak ve elden teslimat düzenlemek için Findloop işlem ücretini ödeyin.",
"mc2.viewsWord": "görüntüleme",
"mc2.live": "Canlı",
"mh.allCategories": "Tüm kategoriler",
"mh.allPeriod": "Tüm zamanlar",
"mh.autoMatch": "Otomatik AI eşleşmesi",
"mh.blocked": "Engellendi (çelişki)",
"mh.blockedReason": "Eşleşme engellendi: öğenin ana anahtar kelimeleri ve beyan birbiriyle çelişiyor.",
"mh.days30": "Son 30 gün",
"mh.days7": "Son 7 gün",
"mh.days90": "Son 90 gün",
"mh.emptyDesc": "Beyanlar geldikçe AI eşleşmeleri burada görünecek.",
"mh.emptyTitle": "Hiçbir olay yok",
"mh.exportCsv": "CSV Dışa Aktar",
"mh.exportDone": "CSV dışa aktarımı indirildi",
"mh.exportImpossible": "Dışa aktarma başarısız oldu",
"mh.fBlocked": "Engellendi",
"mh.fConfirmed": "Onaylandı",
"mh.fRejected": "Reddedildi",
"mh.objectLabel": "Öğe:",
"mh.refresh": "Yenile",
"mh.rejected": "Reddedildi",
"mh.srcManual": "Manuel",
"mh.srcText": "Metin",
"mh.srcVisual": "Görsel (fotoğraf)",
"mh.subtitle": "AI tarafından önerilen eşleşmelerin geçmişi — otomatik eşleşme, onaylı ve reddedilmiş.",
"mh.title": "AI Geçmişi",
"nf.desc": "Aradığınız sayfa mevcut değil veya taşındı.",
"nf.home": "Anasayfaya dön",
"nf.title": "Sayfa bulunamadı",
"par.allCities": "Tüm şehirler",
"par.cityPh": "Şehir",
"pay.eurNote": "Görüntülenen tutarlar euro (€) cinsindendir.",
"pg.next": "Sonraki",
"pg.prev": "Önceki",
"pg.showing": "{from}–{to} arasında {total}",
"pk.bodyCopy": "Ana metin",
"pk.bodyText": "Gövde metni",
"pk.brandColors": "Marka renkleri",
"pk.colorRed": "Kırmızı",
"pk.colorWhite": "Beyaz",
"pk.darkBg": "Koyu arka plan",
"pk.download": "İndir",
"pk.downloadZip": "Tüm kiti indir (ZIP)",
"pk.headings": "Başlıklar",
"pk.heroDesc": "Resmi logolar, sosyal medya afişleri, renkler ve tipografi. Slogan dilini ve varyantını seçin, ardından görseli veya tam kiti indirin.",
"pk.lightBg": "Aydınlık arka plan (baskı)",
"pk.logoWordmark": "Logo / yazı tipi",
"pk.logosVisuals": "Logolar & görseller",
"pk.mapCollect": "Harita / toplama noktaları",
"pk.plain": "Düz",
"pk.pressKit": "Basın kiti",
"pk.taglineLang": "Slogan dili",
"pk.typography": "Tipografi",
"pk.variant": "Varyant",
"pr2.adBoostMsg": "Harika seçim! Eşyanızı hızlıca geri alma şansınızı artırıyorsunuz.",
"pr2.boostActivated": "Güçlendirme aktif edildi!",
"pr2.canRecoverNow": "Artık eşyanızı geri alabilirsiniz.",
"pr2.continue": "Devam et",
"pr2.downloadReceiptPdf": "Fişi indir (PDF)",
"pr2.goToSpaceNow": "Hesabıma git",
"pr2.partnerBoostMsg": "Harika seçim! Daha görünür olmak, işletmenize yeni müşteriler çekmek demektir.",
"pr2.paymentSuccess": "Ödeme başarılı!",
"pr2.redirectingSpace": "Hesabınıza yönlendiriliyorsunuz…",
"pr2.subActivated": "Ödeme başarılı! Aboneliğiniz aktif, artık işletmelerinizi yönetebilirsiniz.",
"prev.allSites": "Tüm işletmeler",
"pricing.annual": "Yıllık",
"pricing.annualBadge": "-%20 teklif",
"pricing.monthly": "Aylık",
"pricing.perYear": "/yıl",
"pricing.saveLabel": "Tasarruf ettiniz",
"pricing.savePerYear": "/yıl her ek işletme için",
"pub.accessGranted": "Erişim verildi",
"pub.accessLimited2h": "Erişim 2 saatle sınırlı",
"pub.accountEmailConcerned": "İlgili hesabın e-posta adresi",
"pub.adAppearPublic": "Reklamınızın kamusal görünümü.",
"pub.adPreviewBtn": "Reklam önizlemesi",
"pub.alertMeOnArrival": "Vardığımda bana bildir",
"pub.allActionsLogged": "Tüm işlemler kaydedildi",
"pub.allCategories": "Tüm kategoriler",
"pub.authorizeAccess": "Erişimi yetkilendir",
"pub.authorizeSupportQ": "Destek erişimini yetkilendir?: ",
"pub.available": "Mevcut",
"pub.backHome": "Ana sayfaya dön",
"pub.boostAdCta": "Reklamımı güçlendir",
"pub.boostAdTitle": "Reklamınızı güçlendirin",
"pub.boostCarouselSub": "“Güçlendirilmiş” döngüsünde sayfanın üstüne çıkın ve eşyalarınızı daha hızlı geri almak için görüntülemeleri artırın.",
"pub.boostEstablishment": "İşletmenizi güçlendirin",
"pub.boostEstablishmentDesc": "Bir “Güçlendirilmiş” rozeti ile dizinin en üstünde görünün ve daha fazla rapor çekin.",
"pub.boostFicheCta": "İlanımı güçlendir",
"pub.brandReady": "Findloop markası, kullanıma hazır",
"pub.cantFindItem": "Eşyanızı bulamıyor musunuz?",
"pub.cantProcessImage": "Bu resmi işleyemiyorum",
"pub.claimQr": "QR kodunu talep et",
"pub.clickToZoom": "Zoom yapmak için tıklayın",
"pub.codeAlreadyValidated": "Kod doğrulandı — iletişimler açıldı.",
"pub.codeExample": "örn. ABCD2345",
"pub.confirmRenewal": "Yenilemeyi onayla",
"pub.contactIntro": "Bir soru, bir talep mi? Bizimle yazışın, size kısa süre içinde döneceğiz.",
"pub.contactTypeDeceased": "Hesap silme (vefat eden kişi)",
"pub.contactTypeGeneral": "Genel soru",
"pub.contactTypeSupport": "Destek / teknik sorun",
"pub.contactUs": "Bize ulaşın",
"pub.continueWithoutEmail": "E-posta bırakmadan devam et",
"pub.contractLabel": "Sözleşme",
"pub.contractNotFound": "Sözleşme bulunamadı veya süresi dolmuş.",
"pub.contractRenewed": "Sözleşme yenilendi!",
"pub.contractRenewedFor": "Sözleşmeniz {n} ay süreyle yenilendi.",
"pub.copyFailed": "Kopyalama başarısız oldu",
"pub.createPartnerAccount": "Ortak hesabımı oluştur",
"pub.currentDeadline": "Geçerli son tarih",
"pub.deceasedInfo": "Bir yakın ya da mirasçı olarak, vefat eden kişinin Findloop hesabının silinmesini talep edebilirsiniz. Talebinizi GDPR'a uygun olarak işleyeceğiz (destekleyici belgeler istenebilir).",
"pub.declareMyLoss": "Kayıp bildirimim",
"pub.describeItemPlaceholder": "Eşyanızı tanımlayın (örneğin, siyah şemsiye, anahtarlar…)",
"pub.downloadImage": "Görseli indir",
"pub.drawSignature": "Lütfen imzanızı çizin.",
"pub.drawSignatureHint": "İmzanızı fare veya parmakla çizin.",
"pub.duration": "Süre",
"pub.eSignature": "Elektronik imza",
"pub.eSignatureDesc": "İmza atmak için adınızı girin. Tarih otomatik olarak kaydedilecektir.",
"pub.edit": "Düzenle",
"pub.editorialTitles": "Editoryal başlıklar",
"pub.emailPlaceholder": "you@example.com",
"pub.enterCodeUnlockOwner": "Sahibin iletişim detaylarını açmak için e-posta ile alınan kodu girin.",
"pub.errorWord": "Hata",
"pub.foundSelfService": "Bulunan eşyalar · Kendi kendine hizmet",
"pub.haveOwnerCode": "Sahipten bir kod aldım",
"pub.home": "Ana sayfa",
"pub.immediateRenewal": "Yeni bir teklif olmadan acil yenileme.",
"pub.impAdminReq1": "Yönetici",
"pub.impAdminReq2": "geçici olarak hesabınıza erişim izni talep ediyor",
"pub.impAdminReq3": "size yardımcı olmak için.",
"pub.impGrantedDesc": "Destek ekibi, hesabınıza en fazla 2 saat erişebilecektir. Her işlem kaydedilecektir. Bu sayfayı kapatabilirsiniz.",
"pub.invitedOnFindo": "Findloop'ya davet edildiniz",
"pub.isThisYourItem": "Bu sizin eşyanız mı?",
"pub.itemsAvailableCount": "{n} eşya şu anda mevcut",
"pub.itemsFoundOwner": "emanet eşyaların sahibi bulundu",
"pub.itemsReturnedOwners": "eşya sahiplerine geri iade edildi",
"pub.itsMine": "Bu benim",
"pub.joinFindoDesc": "Findloop'ya katılın ve bulunan eşyalarınızı kolayca yönetin.",
"pub.joinInvitesYou": "sizi Findloop'ya katılmaya davet ediyor. Bulunan eşyalarınızı yönetmek için ortak hesabınızı oluşturun.",
"pub.linkCopied": "Bağlantı kopyalandı!",
"pub.loadingContract": "Sözleşme yükleniyor…",
"pub.lsClaimDesc": "Kaybınızı bildirerek geri almayı talep edin. E-posta bırakın, raporunuz tamamlanmazsa size hatırlatacağız.",
"pub.lsHeroDesc": "Kayıp eşyanızın bulunup bulunmadığını kendiniz kontrol edin. Bulduysanız? Bildirin ve geri alın.",
"pub.lsSearchTitle": "Bulunan eşyaları ara",
"pub.makeOffer": "Teklif ver",
"pub.makeOfferDesc": "Miktarınızı önerin. Süper admin bunu inceleyecektir.",
"pub.mapNearYou": "Yakınınızdaki eşyalar & ortaklar",
"pub.mapWord": "Harita",
"pub.messageSentToast": "Mesaj gönderildi — ekibimiz kısa süre içinde yanıt verecek.",
"pub.messageWord": "Mesaj",
"pub.momoInitiated": "Mobil Para ödeme başlatıldı",
"pub.monthsWord": "ay",
"pub.nameConsentRequired": "İsim ve onay gereklidir.",
"pub.newDeadline": "Yeni son tarih",
"pub.noActionRequired": "Hiçbir işlem gerekmiyor.",
"pub.noAmountCharged": "Hiç ücret alınmadı.",
"pub.noItemMatch": "Şu anda aramanıza uygun bir ürün bulunmamaktadır.",
"pub.noMatchingItem": "Eşleşen ürün yok",
"pub.noPaymentSession": "Ödeme oturumu yok.",
"pub.noPhoto": "Fotoğraf yok",
"pub.noPointsYet": "Henüz gösterilecek puan yok.",
"pub.noSecondPayment": "Bu ürün için ikinci bir ödeme gerekmez.",
"pub.notHereYet": "Henüz burada değil mi? Geldiğinde sizi haberdar edelim.",
"pub.notifyDone": "Not edildi! Eşleşen bir ürün geldiğinde size e-posta ile bildireceğiz.",
"pub.offerSubmitted": "Teklifiniz gönderildi.",
"pub.oops": "Oops",
"pub.orAlertEmail": "Veya eşleşen bir ürün geldiğinde size e-posta ile bildirim almak için:",
"pub.ownerContacts": "Sahibin iletişim bilgileri",
"pub.ownerContactsUnlocked": "Sahibin iletişim bilgileri açıldı",
"pub.partnerContact": "Ortak iletişimi",
"pub.payLinkUnavailable": "Ödeme bağlantısı yok - ortakla iletişime geçin.",
"pub.paymentCancelled": "Ödeme iptal edildi",
"pub.paymentConfirmed": "Ödeme onaylandı 🎉",
"pub.paymentConfirmedDesc": "Eşyanızı geri almak için detayların bulunduğu bir e-posta alacaksınız.",
"pub.paymentNotConfirmed": "Ödeme onaylanmadı",
"pub.paymentNotConfirmedDesc": "Ödeme doğrulanamadı. Lütfen tekrar deneyin veya ortakla iletişime geçin.",
"pub.paymentProcessing": "Ödeme işleniyor. Birazdan yenileyin.",
"pub.photoAdded": "✓ Fotoğraf eklendi",
"pub.photoRequired": "Ürünün fotoğrafı gereklidir.",
"pub.previewAlt": "ön izleme",
"pub.publish": "Yayınla",
"pub.publishingWord": "Yayınlanıyor…",
"pub.qty": "Adet",
"pub.quoteDeclined": "Teklif reddedildi.",
"pub.quoteNotFound": "Teklif bulunamadı veya süresi dolmuş.",
"pub.reasonLabel": "Sebep",
"pub.recoveryAlreadyPaid": "Geri alma ücreti zaten ödendi",
"pub.referralCode": "Referans kodu:",
"pub.relationshipPlaceholder": "Oğul, eş, noter…",
"pub.renewYourContract": "Sözleşmenizi yenileyin",
"pub.renewalFailed": "Yenileme başarısız oldu. Lütfen daha sonra tekrar deneyin.",
"pub.renewing": "Yenileniyor…",
"pub.replySoon": "Ekibimiz en kısa sürede yanıt verecek.",
"pub.requestGone": "Bu istek artık mevcut değil.",
"pub.requestHandled": "İstek zaten işlenmiştir",
"pub.requestNotFound": "İstek bulunamadı veya süresi dolmuş.",
"pub.requestUnavailable": "İstek mevcut değil",
"pub.required": "(gerekli)",
"pub.retroClosing": "Birlikte, dünyayı biraz daha az kaybolmuş hale getiriyoruz.",
"pub.retroClosing2": "Birlikte, dünyayı biraz daha az kaybolmuş hale getiriyoruz.",
"pub.retroScroll": "Önemli olanı geri kazanmanın bir yılı. Aşağı kaydırın ↓",
"pub.revokeAnytime": "İstediğiniz zaman bizimle iletişime geçerek iptal edebilirsiniz",
"pub.scene": "Sahne",
"pub.sendImpossible": "Gönderilemiyor",
"pub.sendMessage": "Mesajı gönder",
"pub.sending": "Gönderiliyor…",
"pub.sharePreview": "Ön izlemeyi paylaş",
"pub.shareYourAd": "İlanınızı paylaşın",
"pub.signedSuccess": "Başarıyla imzalandı!",
"pub.signerFullName": "İmzalayanın tam adı",
"pub.spreadNetwork": "Şanslarınızı artırmak için çevrenizle paylaşın.",
"pub.spreadOwner": "Sahibin eşyalarını geri almasına yardımcı olmak için paylaşın.",
"pub.statusLabel": "Durum:",
"pub.subject": "Konu",
"pub.thanksSent": "Teşekkürler, mesajınız gönderildi.",
"pub.thisYear": "Bu yıl",
"pub.validate": "Doğrula",
"pub.verifyingPayment": "Ödeme doğrulanıyor...",
"pub.verifyingYourPayment": "Ödemeniz doğrulanıyor...",
"pub.viewAd": "İlanı görüntüle →",
"pub.viewPartner": "Ortakı görüntüle →",
"pub.yourAdPreview": "İlanınızın önizlemesi",
"pub.yourEmail": "E-posta adresiniz",
"pub.yourEmailRecommended": "E-posta adresiniz (tavsiye edilen)",
"pub.yourEmailShort": "E-posta",
"pub.yourName": "Adınız",
"pub.yourRelationship": "Kişiyle olan ilişkiniz",
"qv.acceptAndSign": "Teklifimi kabul et ve imzala",
"qv.certifyAuthorized": "İmza atmak için yetkili olduğumu ve bu {what} (bağlayıcı değer) şartlarını kabul ettiğimi onaylıyorum.",
"qv.clear": "Temizle",
"qv.client": "Müşteri",
"qv.conditions": "Şartlar",
"qv.confirmDecline": "Bu teklifin reddedilmesini onaylıyor musunuz?",
"qv.countersignedFindo": "Findloop tarafından karşı imzalanmıştır · {name} tarihinde {date}",
"qv.decline": "Reddet",
"qv.description": "Açıklama",
"qv.downloadPdf": "PDF’i indir",
"qv.handwrittenSignature": "Elliyle yazılmış imza",
"qv.inclTax": "KDV dahil",
"qv.invalidAmount": "Geçersiz tutar.",
"qv.invoice": "Fatura",
"qv.invoicePaid": "Fatura ödendi",
"qv.issuer": "Düzenleyen",
"qv.messageOptional": "Mesaj (isteğe bağlı)",
"qv.negotiatedAmount": "Pazarlık edilen tutar",
"qv.payInvoiceOnline": "Faturanızı çevrimiçi ödeyin",
"qv.quote": "Teklif",
"qv.quoteValidDays": "Teklif {n} gün geçerlidir.",
"qv.sendMyOffer": "Teklifimi gönder",
"qv.signContract": "Sözleşmemi imzala",
"qv.signNow": "Şimdi imzala",
"qv.signatureAlt": "İmza",
"qv.signedByOn": "✔ {name} tarafından {date} tarihinde imzalandı",
"qv.stContractSigned": "Sözleşme imzalandı. Teşekkür ederiz!",
"qv.stCounterAccepted": "Teklifiniz kabul edildi! Aşağıda sözleşmenizi imzalayın.",
"qv.stCounterRefused": "Teklifiniz kabul edilemedi.",
"qv.stCountered": "Teklifiniz iletildi. Findloop'nun yanıtını bekliyoruz.",
"qv.stDeclined": "Bu teklifi reddettiniz.",
"qv.stSigned": "Teklif kabul edildi ve imzalandı. Teşekkür ederiz!",
"qv.totalHt": "Toplam KDV hariç",
"qv.totalTtc": "Toplam KDV dahil",
"qv.unitHt": "Birim KDV hariç",
"qv.vat": "KDV",
"qv.yourProposedAmount": "Önerdiğiniz tutar ({cur})",
"reg.add": "Bir öğe kaydet",
"reg.allBrands": "Tüm markalar",
"reg.allColors": "Tüm renkler",
"reg.allLocations": "Tüm konumlar",
"reg.detailDesc": "Bulunan öğe için detaylar ve işlemler.",
"reg.dispAuction": "Açık artırma",
"reg.dispAuthorities": "Yetkililere devredildi",
"reg.dispDestroyed": "İmha edildi",
"reg.dispDonate": "Yardım kurumu bağışı",
"reg.dispositionHint": "Öğeyi depodan çıkışını kaydedin. Kategoriye göre istatistiklerde sayılır.",
"reg.emptyCta": "Bir öğe kaydet",
"reg.emptyDesc": "İlk bulduğunuz eşyayı kaydederek başlayın.",
"reg.emptyTitle": "Bulunan eşya yok",
"reg.establishmentFallback": "kuruluş",
"reg.lblAuctioned": "açık artırmaya listeledi",
"reg.lblAuctionedShort": "açık artırma",
"reg.lblAuthorities": "yetkililere teslim edildi",
"reg.lblDestroyed": "imha edildi",
"reg.lblDonated": "hayır kurumuna bağışlandı",
"reg.legalCount": "{n} eşya(lar): yasal saklama süresi doldu",
"reg.legalHint": "Onları açık artırmaya listeleyebilir, hayır kurumuna bağışlayabilir veya yetkililere teslim ettiklerini bildirebilirsiniz.",
"reg.legalLimitCountry": "Son tarih: {date} · uygulanan ülke: {country}",
"reg.legalOver": "Son tarih geçti: {date} · {country}",
"reg.legalReached": "Yasal süre dolduruldu",
"reg.legalReachedFull": "Yasal saklama süresi doldu",
"reg.limitShort": "son tarih",
"reg.location": "Konum",
"reg.markRestituted": "İade edildi olarak işaretle",
"reg.markedAs": "Eşya {label} olarak işaretlendi",
"reg.moveHistory": "Hareket geçmişi",
"reg.overBy": "{n} gün ötedir",
"reg.physicalLocation": "Fiziksel konum",
"reg.popupBlocked": "Etiketleri yazdırmak için pop-up'lara izin verin.",
"reg.popupBlockedOne": "Etiketi yazdırmak için pop-up'a izin verin.",
"reg.printLabel": "Etiketi yazdır",
"reg.printN": "{n} etiket(leri) yazdır",
"reg.qrCodeItem": "Eşya QR kodu",
"reg.qrLabelTitle": "QR etiketi",
"reg.qrLabelsTitle": "QR etiketleri",
"reg.qrNotFound": "Bu QR kodu için eşya bulunamadı.",
"reg.qrScanHint": "Bunu tarayın, kaydı doğrudan açın ve konumu bulun.",
"reg.recoveryFee": "Kurtarma ücreti (€)",
"reg.searchPh": "Açıklamaya göre ara…",
"reg.selectQr": "QR etiketlerini yazdırmak için seçin",
"reg.selectedN": "{n} seçildi",
"reg.shipPricePh": "Gönderim ücreti (€)",
"reg.shippingPossible": "Gönderim mevcut",
"reg.storagePh": "Örneğin: Raf A3, Locker 12",
"reg.tAuction": "Findloop üzerinde açık artırma",
"reg.tAuthorities": "Yetkililere teslim bildirin",
"reg.tDonate": "Hayır kurumuna bağışla",
"reg.toastFee": "Ücret güncellendi",
"reg.toastLocation": "Konum kaydedildi",
"reg.toastRestituted": "Eşya iade edildi olarak işaretlendi",
"reg.toastShipping": "Gönderim seçeneği güncellendi",
"reg.toastTransferred": "Eşya “{name}”'a aktarıldı",
"reg.unclaimedDisposition": "Talep edilmemiş eşya — nihai tasfiye",
"res.codeValidated": "Kod doğrulandı",
"res.empty": "Henüz iade kaydı yok.",
"res.error": "Hata {status}",
"res.proofPdf": "PDF kanıtı",
"res.signed": "İmzalı",
"res.stRestituted": "Şahsen teslim edildi",
"res.stShipped": "Gönderim ile geri gönderildi",
"res.subtitle": "İndirilebilir imzalı kanıtlarıyla tamamlanmış tüm teslimatlar.",
"res.title": "İade geçmişi",
"rev.restitutedBy": "{org} tarafından iade edildi",
"rev.storiesEyebrow": "Mutlu sonlar",
"rev.storiesSubtitle": "Findloop ile eşyalarını geri kazanan müşterilerin gerçek hikayeleri.",
"rev.storiesTitle": "Eşyalarını buldular!",
"rp.already": "Bu listeyi zaten bildirdiniz.",
"rp.duplicate": "Çoğalt",
"rp.inappropriate": "Uygunsuz içerik",
"rp.wrongCategory": "Yanlış kategori",
"rt.annualGoal": "Yıllık hedef",
"rt.championCity": "Şampiyon şehir",
"rt.cityRate": "{rate}% dönüş oranı",
"rt.goalProgress": "{rate}% tamamlandı, {target}% hedef",
"rt.reached": "Ulaşıldı 🎉",
"rt.restitutionRate": "Dönüş oranı",
"rt.shareRecap": "Özeti paylaş",
"rt.thanks": "Teşekkür ederim Findloop {year} 💛",
"rt.yourRecap": "Senin {year} özetin",
"rw.active": "Aktif",
"rw.add": "Ekle",
"rw.camUnavailable": "Kamera kullanılamıyor. Aşağıdaki kodu manuel olarak girin.",
"rw.codeValidated": "Kod doğrulandı",
"rw.codesTitle": "finders tarafından kullanılan kodlar",
"rw.confirmDelete": "“{title}” silinsin mi?",
"rw.deleted": "Silindi",
"rw.edit": "Düzenle",
"rw.editReward": "Ödülü düzenle",
"rw.empty": "Henüz ödül yok.",
"rw.expired": "Süresi doldu",
"rw.expiresOn": "{date} tarihinde sona erer",
"rw.fActive": "Aktif (finders için görünür)",
"rw.fCost": "Maliyet (puan)",
"rw.fDesc": "Açıklama",
"rw.fStock": "Stok (boş = sınırsız)",
"rw.fTitle": "Başlık",
"rw.fValidity": "Kupon geçerlilik süresi (kullanımdan sonraki gün sayısı)",
"rw.inactive": "Pasif",
"rw.newReward": "Yeni ödül",
"rw.noExchange": "Henüz arındırma yok.",
"rw.pageSubtitle": "Ödüllerini doğrulamak için finders tarafından sunulan kuponları tara.",
"rw.redeemedN": "Kullanıldı: {n}×",
"rw.saved": "Ödül kaydedildi",
"rw.scanVoucher": "Bir kupon tara",
"rw.staffScanOnly": "Sadece tara",
"rw.statActive": "Sunulacak",
"rw.statExpired": "Süresi dolmuş",
"rw.statRedeemed": "Kuponlar kullanıldı",
"rw.statUsed": "Doğrulandı",
"rw.stock": "Stok",
"rw.subtitle": "Finders’ın kazanım puanları için kullandığı parasal olmayan avantajlar sunun (kuponlar, yükseltmeler…) ",
"rw.title": "Finders için ödüller",
"rw.used": "Kullanıldı",
"rw.validate": "Doğrula",
"rw.validateCode": "Kodu doğrula",
"rw.validity": "Geçerlilik: {n} g",
"side.establishments": "Kuruluşlar",
"side.restitutions": "İadeler",
"side.rewards": "Ödüller & Kuponlar",
"side.settings": "Ayarlar",
"side.storage": "Depolama & QR",
"status.auctioned": "Açık artırmaya çıkarıldı",
"status.destroyed": "İmha edildi",
"status.donated": "Bağışlandı (hayır kurumu)",
"status.handed_to_authorities": "Yetkililere teslim edildi",
"status.in_storage": "Depoda",
"status.matched": "Eşleşti",
"status.open": "Açık",
"status.paid": "Ödendi",
"status.pending": "Beklemede",
"status.restituted": "İade Edildi",
"status.shipped": "Gönderildi",
"status.shipping_requested": "Gönderim talep edildi",
"status.submitted": "Gönderildi",
"stg.allLabels": "Tüm QR etiketleri",
"stg.camHint": "Aşağıda manuel girişi kullanın.",
"stg.camStarting": "Kamerayı başlatıyor…",
"stg.camUnavailable": "Kamera kullanılamıyor.",
"stg.clear": "Temizle",
"stg.clearAll": "Hepsini temizle",
"stg.codeUnreadable": "Okunamayan kod.",
"stg.emptyDesc": "Saklanan eşyalar burada, konumlarına göre gruplandırılmış olarak görünecektir.",
"stg.emptyTitle": "Depoda hiç eşya yok",
"stg.exportAudit": "Denetim CSV'sini dışa aktar",
"stg.exportDone": "CSV dışa aktarımı indirildi",
"stg.exportImpossible": "Şu anda dışa aktarma mümkün değil.",
"stg.itemFound": "Eşya bulundu ✅",
"stg.kLocations": "Kullanılan konumlar",
"stg.kObjects": "Saklanan eşyalar",
"stg.kToClear": "Temizlenecek konumlar",
"stg.locFreed": "Konum temizlendi",
"stg.locsFreed": "{n} konum(lar) temizlendi",
"stg.manualLabel": "Ya da eşyanın kodunu / kimliğini girin",
"stg.manualPh": "QR'nin kimliğini veya URL'sini yapıştırın",
"stg.noItemMatch": "Bu QR / kod ile eşleşen hiçbir eşya yok.",
"stg.noLocation": "Hiçbir konum yok",
"stg.objectsAxis": "Eşyalar",
"stg.objectsN": "{n} eşya",
"stg.occAvg": "ortalama {n} eşya/kona",
"stg.occHint": "Açık sarı konumlar ortalamayı aşıyor (potansiyel olarak aşırı yüklenmiş).",
"stg.occupancy": "Konum doluluğu",
"stg.openPage": "Sayfayı aç",
"stg.posterPdf": "PDF afiş (A4)",
"stg.printAll": "Hepsini yazdır",
"stg.printGroupTitle": "Bu raf için etiketleri yazdır",
"stg.qrAlt": "Kendi kendine hizmet QR",
"stg.qrDownload": "QR'yi indir",
"stg.qrHint": "Bu QR'yi kasada gösterin: müşterileriniz, eşyanın mevcut olup olmadığını kontrol etmek için bunu tarar.",
"stg.qrTitle": "Müşteri kendi kendine hizmet QR",
"stg.scanDesc": "Bir eşyanın etiketini tarayarak kaydını anında açın.",
"stg.scanQr": "Bir QR tara",
"stg.scanTitle": "Bir QR kodunu tara",
"stg.search": "Ara",
"stg.shelf": "Raf {loc}",
"stg.shelfPlan": "Raf planı",
"stg.staleHint": " Fiziksel envanterinizi güncel tutmak için bu konumları temizleyin.",
"stg.staleTitle": "{n} eşya depodan çıktı ama hâlâ bir konumda tutuluyor",
"stg.subtitle": "Raf planı, QR tarayıcı ve fiziksel envanter takibi.",
"stg.title": "Depolama & QR",
"stt.acceptRate": "Kabul oranı",
"stt.accepted": "Kabul edildi",
"stt.activity30": "Aktivite (son 30 gün)",
"stt.ai6mo": "Son 6 ay · kabul edilen = otomatik eşleşen + onaylı.",
"stt.aiEmpty": "Bu süre zarfında hiçbir AI eşleşmesi yok.",
"stt.aiTitle": "AI eşleşmeleri — kabul edilen vs reddedilen",
"stt.auctionShort": "Müzayede",
"stt.auctionedSold": "Müzayedeye çıkarıldı (satıldı)",
"stt.authShort": "Yetkililer",
"stt.authorities": "Yetkililere teslim edildi",
"stt.avgRating": "Ortalama puan",
"stt.boostClicks": "Bu hafta künyenize yapılan tıklamalar sayesinde",
"stt.boostInactive": "Boost pasif — görünürlük kazanmak için etkinleştirin",
"stt.certifiedPremium": "Premium onaylı",
"stt.declarations": "Beyanlar",
"stt.destroyed": "İmha edildi",
"stt.dispoEmpty": "Henüz depodan çıkmamış hiç bir talep edilmemiş ürün yok.",
"stt.donatedAssoc": "Bağışlandı (hayır kurumu)",
"stt.donatedShort": "Bağışlandı",
"stt.gateCta": "Planları keşfedin",
"stt.gateDesc": "Temel istatistiklerinizi açmak için Starter'a yükseltin veya gelişmiş istatistikler ve her işletme için analiz için Business'a geçin.",
"stt.gateTitle": "Ücretli planlara özel istatistikler",
"stt.inStorage": "Depoda",
"stt.kItems": "Kaydedilen ürünler",
"stt.kRate": "İade oranı",
"stt.kRestituted": "İade edilen ürünler",
"stt.kRevenue": "Gelir (ay)",
"stt.noDeclYet": "Henüz beyan yok.",
"stt.recapDownloaded": "Özet indirildi — paylaşmaya hazır!",
"stt.recapError": "Özet oluşturulamadı",
"stt.recapText": "Findloop {year} özeti: iade edilen ürünler ve müşteri memnuniyeti 🎉",
"stt.recapTitle": "Findloop {year} özeti",
"stt.rejected": "Reddedildi",
"stt.restitutions": "İadeler",
"stt.shareRecap": "{year} özeti paylaş",
"stt.topCategories": "En çok beyan edilen kategoriler",
"stt.unclaimedDesc": "İmha edilen, hayır kurumlarına bağışlanan ve açık artırmaya çıkarılan ürünlerin hacmi, kategoriye göre.",
"stt.unclaimedTitle": "Talep edilmemiş ürünler — depodan çıkıyor",
"stt.vsLastWeek": "geçen hafta ile",
"sub.cancel": "Aboneliğimi iptal et",
"sub.cancelAbort": "İptal",
"sub.cancelConfirm2": "Hiçbir geri ödeme yapılmayacaktır.",
"sub.cancelConfirmBtn": "İptali onayla",
"sub.cancelTitle": "Aboneliğinizi iptal edin",
"sub.cancelledToast": "İptal kaydedildi.",
"sub.cguAnd": "ve",
"sub.cguDesc": "Lütfen ödeme öncesinde kabul ettiğinizi onaylayın.",
"sub.cguLink": "Kullanım Şartları",
"sub.cguPay": "Ödeme için devam et",
"sub.cguPre": "Okudum ve kabul ediyorum",
"sub.cguRequired": "Devam etmek için Kullanım Şartları ve Gizlilik Politikasını kabul etmelisiniz.",
"sub.cguSuffix": "Findloop'nun.",
"sub.cguTitle": "Aboneliğinizi tamamlayın",
"sub.expiresOn": "Aboneliğinizin bitiş tarihi",
"sub.noProrata": "Pro-rata geri ödeme yok.",
"sub.privacyLink": "Gizlilik Politikası",
"sub.renewsOn": "Aboneliğinizin yenileneceği tarih",
"sub.resume": "Yeniden abone ol",
"sub.resumedToast": "Yeniden abone olduğu onaylandı.",
"tier.free": "Ücretsiz",
"tier.large": "Kurumsal",
"tier.medium": "İş",
"tier.small": "Başlangıç",
"tm.add": "Ekle",
"tm.adminOpt": "Yönetici (tam görünüm)",
"tm.chooseEst": "Bir işletme seçin",
"tm.chooseEstPh": "Bir kuruluş seçin",
"tm.copyFail": "Kopyalama başarısız",
"tm.copyLink": "Bağlantıyı kopyala",
"tm.copyOk": "Davet bağlantısı kopyalandı",
"tm.emailHint": "Şifre oluşturmak için bir davet e-postası gönderilecek.",
"tm.expiresOn": "{date} tarihinde sona erer",
"tm.forEmail": " için {email}",
"tm.forbidden": "Takım yönetimi hesap sahibine özeldir.",
"tm.inviteCreated": "Davet oluşturuldu",
"tm.inviteDesc": "Bir davet e-postası, takım arkadaşının şifresini oluşturmasına olanak tanır.",
"tm.invitePending": "Bekleyen davet",
"tm.inviteResent": "Davet yeniden gönderildi",
"tm.inviteSent": "Davet e-posta ile gönderildi",
"tm.inviteTitle": "Bir üye davet et",
"tm.invitedOn": "{date} tarihinde davet edildi",
"tm.linkExpired": "Bağlantı süresi dolmuş",
"tm.memberRemoved": "Üye çıkarıldı",
"tm.name": "İsim",
"tm.noMembers": "Henüz takım arkadaşı yok.",
"tm.resendTitle": "Davetiyeyi yeniden gönder",
"tm.role": "Rol",
"tm.roleAdmin": "Admin",
"tm.roleOwner": "Sahip",
"tm.roleStaff": "Personel",
"tm.roleUpdated": "Rol güncellendi",
"tm.sendInvite": "Davet gönder",
"tm.sending": "Gönderiliyor…",
"tm.staffOpt": "Personel (sadece kendi kuruluşunu görür)",
"trk.carrier": "Taşıyıcı",
"trk.shipPending": "Gönderim hazırlanıyor — gönderildiğinde takip numarası buraya görünecek.",
"trk.shipTitle": "Gönderim takibi",
"trk.trackShipment": "Paket takibi",
"trk.trackingNo": "Takip numarası",
"a.firstName": "Ad",
"ac.emailCrossMatch": "B2C karşılaştırmaları",
"ac.emailCrossMatchDesc": "Bir kamu kayıp eşya ilanı, sizin tesislerinize bırakılan bir eşya ile eşleştiğinde bir e-posta alın",
"ac.emailCrossReject": "Kamu eşleşme reddetmeleri",
"ac.emailCrossRejectDesc": "Önerilen bir kamu eşleşmesinin kendilerine ait olmadığını belirtirse bir e-posta alın.",
"ac.emailLoginNotif": "Giriş bildirimi",
"ac.emailLoginNotifDesc": "Hesabınıza her giriş yapıldığında bir e-posta alın.",
"ad.closeNoCancel": "Hayır, ilanı kaldır",
"ad.closeQuestion": "Eşya size iade edildi mi?",
"ad.closeQuestionDesc": "Eşyayı geri alıp almadığınızı veya bu ilanı kaldırmak isteyip istemediğinizi bize bildirin.",
"ad.closeYesRestituted": "Evet, eşya iade edildi",
"ad.closedRestituted": "Eşya iade edildi — ilan kapatıldı 🎉",
"an.lostLoginDesc": "Kayıp bir eşya bildirmek ve geri dönüşünü takip etmek için bir hesap gereklidir.",
"an.lostLoginRequired": "Kayıp bir eşyayı bildirmek için giriş yapın",
"an.qfAll": "Hepsi",
"an.qfBoosted": "Öne çıkan",
"an.qfPhoto": "Fotoğraflı",
"an.qfRecent": "Bu hafta",
"an.qfResolved": "Çözüldü",
"an.restitutionInProgress": "Eşya iade ediliyor",
"dec.descPhLong": "Eşyayı tanımlayın: marka, renk, belirgin işaretler… (Verdiğiniz detaylar, eşyayı geri alma şansınızı artırır)",
"dec.loadError": "Şu anda partner yüklenemiyor. Bağlantınızı kontrol edin ve tekrar deneyin.",
"dec.retry": "Yeniden dene",
"dec.shippingMode": "Gönderim",
"dep.photo2": "2. eşya fotoğrafı",
"dep.photo2Hint": "Opsiyonel — başka bir açı, görsel eşleşme doğruluğunu artırır.",
"dl.accountSuspended": "Ödenmemiş fatura nedeniyle hesap askıya alındı. Erişiminizi geri kazanmak için ödeyin.",
"dl.regularize": "Şimdi öde →",
"dl.suspensionCountdown": "Fatura {num} ödenmedi — hesabınız {days} gün içinde askıya alınacak. Bunu önlemek için ödeyin.",
"ft.cancelConfirm": "Raporunuzu iptal etmek istiyor musunuz? Eşya sahibine bilgi verilecektir.",
"ft.cancelDone": "Rapor iptal edildi.",
"ft.cancelLocked": "Sahip ödediğinde iptal artık mümkün değil.",
"ft.cancelReport": "Raporumu iptal et",
"ft.claimCodeHelp": "Eşyanızı aldığınızı doğrulamak için bu kodu bulana verin.",
"ft.claimCodeTitle": "Geri alma kodunuz",
"ft.claimDone": "Eşya iade edildi. Findloop'yu kullandığınız için teşekkürler!",
"ft.claimUnlockHint": "Bulucunun iletişim bilgilerini açın",
"ft.claimUnlockHintSub": "Ücretinizi ödemek ve iletişim bilgilerini almak için hesabınızdaki \"İddaa ettiğim eşyalar\" bölümüne gidin.",
"ft.finderCodeShownHelp": "Sahip ödedi ve sizi seçti. İade işlemini onaylamak için aşağıdaki kodu kopyalayın — e-postanızı kontrol etmenize gerek yok.",
"ft.finderCodeShownTitle": "Sahibin doğrulama kodu",
"ft.finderContactsTitle": "Finder'ın iletişim bilgileri",
"ft.foundCodeHelp": "Bu kodu teslim sırasında sahibi gösterin, eşyaların geri döndüğünü onaylayın.",
"ft.inProgressOther": "Geri iade edilen eşya",
"ft.inProgressOtherHelp": "Sahip bu eşya için başka bir bulucu seçti. Sizin tarafınızdan başka bir işlem yapılmasına gerek yok.",
"ft.restitutionCodeHelp": "Bu kod, eşya teslimini onaylar. Aşağıda zaten doldurulmuş; doğrulayın ve dosyayı kapatın.",
"ft.restitutionCodeTitle": "İade kodunuz",
"hc.14Digits": "14 haneli",
"hc.15DaysBeforeAnItem": "Bir eşyanın yasal süresinden 15 gün önce.",
"hc.7DaysBeforeAnItem": "Bir eşyanın yasal süresinden 7 gün önce.",
"hc.8CharactersMinimum": "Minimum 8 karakter.",
"hc.aClaimToValidate": "Onaylanacak bir talep",
"hc.aFindoAssistanceSessionIs": "Hesabınızda şu anda bir Findloop destek oturumu aktif.",
"hc.aNewMatchHasBeen": "Yeni bir eşleşme bulundu",
"hc.aUser": "Bir kullanıcı",
"hc.aUserClaimsToBe": "Bir kullanıcı sahibi olduğunu iddia ediyor. İade yetkilendirmeden önce cevaplarını kontrol edin.",
"hc.aboutFindo": "Findloop hakkında",
"hc.accountActivatedPleaseLogIn": "Hesap etkinleştirildi, lütfen giriş yapın.",
"hc.accountActivation": "Hesap etkinleştirme",
"hc.accountCreated": "Hesap oluşturuldu!",
"hc.accountDeactivatedAReactivationEmail": "Hesap devre dışı. Size reaktivasyon e-postası (30 gün geçerli) gönderildi.",
"hc.accountReactivation": "Hesap reaktivasyonu",
"hc.activateMyAccount": "Hesabımı etkinleştir",
"hc.activateMyAdminAccount": "Yönetici hesabımı etkinleştir",
"hc.activating": "Etkinleştiriliyor…",
"hc.activeMatchCancelReason": "Aktif eşleşme. Müşterinin iptal nedeni: \"{reason}\". Eşya hala bir talep bekliyor.",
"hc.activeMatchWithAPublic": "Bir halka açık (müşteri) listesi ile aktif eşleşme. Sahipten talep bekleniyor.",
"hc.addAPhoto": "Bir fotoğraf ekle",
"hc.addAndConfigureYourEstablishments": "\"Kuruluşlar\" bölümüne kuruluşlarınızı ekleyin ve yapılandırın: iletişim bilgileri, kategori ve eşyaların fiziksel saklanması.",
"hc.addOnGoogle": "Google'da ekle",
"hc.address": "Adres",
"hc.addressSaved": "Adres kaydedildi",
"hc.addressStreet": "Adres — Cadde",
"hc.adjustThePhoto": "Fotoğrafı ayarlayın",
"hc.adminFullView": "Yönetici (tam görünüm)",
"hc.administratorOnly": "Sadece yönetici",
"hc.africa": "Afrika",
"hc.aiVisualComparison": "Yapay zeka görsel karşılaştırma",
"hc.all": "Tüm",
"hc.amount": "Tutar",
"hc.anOrganization": "Bir kuruluş",
"hc.analyzing": "Analiz ediliyor…",
"hc.andRecoveryIs": "ve geri dönüş",
"hc.andTheDeclarationWillBe": "ve beyan kapatılacak (geçmişe taşındı). Bu işlem sonlandırılmıştır.",
"hc.annual20": "Yıllık -%20",
"hc.annualBilling20": "Yıllık faturalama (−%20)",
"hc.annualTarget": "Yıllık hedef",
"hc.anyCommentsOptional": "Herhangi bir yorum? (isteğe bağlı)",
"hc.approveTheClaim": "Talebi onayla",
"hc.archiveCancelledConfirm": "{n} listeyi \"Müşteri tarafından iptal edildi\" olarak arşivlemek istiyor musunuz? Kayıttan silinecekler.",
"hc.asSoonAs": "En kısa zamanda",
"hc.askTheOwnerToDisplay": "Kullanıcının kodunun QR'sini (takip sayfası) göstermesini isteyin.",
"hc.askThemAtTheCounter": "Onlardan kimliklerini doğrulamalarını isteyin — asla kamuya açık değildir.",
"hc.assistance": "Destek",
"hc.assistanceSessionRevoked": "Destek oturumu iptal edildi.",
"hc.atLeast6Characters": "En az 6 karakter",
"hc.automaticallyPreSelected": "otomatik olarak önceden seçildi",
"hc.automaticallyWhenShipping": "otomatik olarak gönderim sırasında.",
"hc.awaitingClaim": "Talep bekleniyor",
"hc.awaitingPayment": "Ödeme bekleniyor",
"hc.b2cCustomer": "B2C müşteri",
"hc.back": "Geri",
"hc.backToHome": "Ana sayfaya dön",
"hc.backToMyAccount": "Hesabıma geri dön",
"hc.backToPayment": "Ödemeye geri dön",
"hc.beforeAfterComparisonSlider": "Önce/sonra karşılaştırma kaydırıcı",
"hc.billingInformation": "Fatura bilgileri",
"hc.billingInformationSaved": "Fatura bilgileri kaydedildi ✓",
"hc.brand": "Marka",
"hc.bronze": "Bronz",
"hc.calculatingTheShippingRate": "Gönderim ücretini hesaplıyor…",
"hc.cameraUnavailableEnterTheCode": "Kamera kullanılamıyor. Kodu manuel olarak girin.",
"hc.cancel": "İptal et",
"hc.cancelMyDeclaration": "Beyanımı iptal et",
"hc.cancelSavedFmt": "İptal kaydedildi: \"{reason}\". Hala talep edebilirsiniz.",
"hc.cancelTheDeposit": "Depozitoyu iptal et",
"hc.cancelThisMatch": "Bu eşleşmeyi iptal et",
"hc.cancellationReason": "İptal nedeni",
"hc.cancelled": "İptal edildi",
"hc.cancelledByTheCustomer": "Müşteri tarafından iptal edildi",
"hc.cannotOpenPayment": "Ödeme açılamıyor. Lütfen tekrar deneyin.",
"hc.careers": "Kariyerler",
"hc.carrier": "Taşıyıcı",
"hc.carrierAvailabilityCannotBeChecked": "Taşıyıcı durumu, Sendcloud göndericiniz yapılandırılıncaya kadar kontrol edilemez.",
"hc.carrierConfirmedCharged": "Taşıyıcı onaylandı — müşteri <b>{price} €</b> ücretlendirildi",
"hc.carrierOther": "Taşıyıcı (diğer)",
"hc.carrierSelection": "Taşıyıcı seçimi",
"hc.caseClosedThankYou": "Kasa kapandı. Teşekkür ederiz!",
"hc.category": "Kategori",
"hc.changeMethod": "Yöntemi değiştir",
"hc.characteristic": "Özellik",
"hc.chargedToCustomer": "müşteriye ücreti.",
"hc.checkOrEditYourDetails": "Güvenli ödeme öncesinde bilgilerinizi kontrol edin veya düzenleyin.",
"hc.checkStatisticsToTrackDeposited": "\"İstatistikler\" bölümünü kontrol ederek yatırılan nesneleri, iade oranını ve her işletmenin performansını takip edin.",
"hc.checkTheDetailsBeforeContacting": "İletişim kurmadan önce detayları kontrol edin.",
"hc.checkTheDetailsBelowBefore": "İade talebine başlamadan önce aşağıdaki detayları kontrol edin.",
"hc.checkTheNewItem": "Yeni öğeyi kontrol et",
"hc.checkThePhotosAndCharacteristics": "Devam etmeden önce aşağıdaki fotoğrafları ve özellikleri kontrol edin.",
"hc.chooseACountry": "Bir ülke seç",
"hc.chooseANewPassword": "Yeni bir şifre seç",
"hc.chooseAReason": "Bir neden seç",
"hc.chooseTheLegalRetentionAlerts": "E-posta ile alınan yasal saklama uyarılarını seçin",
"hc.chooseYourPasswordToAccess": "Yönetim paneline erişmek için şifrenizi seçin.",
"hc.city": "Şehir",
"hc.claimApproved": "Talep onaylandı",
"hc.claimApproved2": "Talep onaylandı.",
"hc.claimCodeExpired": "Talep kodu geçersiz",
"hc.claimCodeVerified": "Talep kodu doğrulandı",
"hc.claimNotFound": "Talep bulunamadı",
"hc.claimNotValidated": "Talep doğrulanmadı",
"hc.claimRejected": "Talep reddedildi",
"hc.claimRejected2": "Talep reddedildi.",
"hc.claimValidated": "Talep doğrulandı",
"hc.claimValidatedByThePartner": "Talep partner tarafından doğrulandı",
"hc.claimant": "Başvuran",
"hc.claimsToBeTheOwner": "bu öğenin sahibi olduğunu iddia ediyor ve doğrulama sorularını yanıtladı. Yanıtların eşleştiğinden emin olun.",
"hc.claimsToValidate": "Doğrulanması gereken talepler",
"hc.clear": "Temizle",
"hc.clickToZoom": "Büyütmek için tıklayın",
"hc.close": "Kapat",
"hc.close2": "Kapat",
"hc.closeTheDeclaration": "Beyanı kapat",
"hc.closeTheDeclaration2": "Beyanı kapat?",
"hc.codeAlreadyVerified": "Kod zaten onaylandı",
"hc.codeCopied": "Kod kopyalandı",
"hc.collapse": "Daralt",
"hc.color": "Renk",
"hc.company": "Şirket",
"hc.companyName": "Şirket adı",
"hc.comparePhotos": "Fotoğrafları karşılaştır",
"hc.compareThemWithTheOwner": "Onları sahibinin cevaplarıyla karşılaştır — asla halka açık değil.",
"hc.condition": "Durum",
"hc.confirmAndPay": "Onayla ve öde",
"hc.confirmCancellation": "İptali onayla",
"hc.confirmCrop": "Kesimi onayla",
"hc.confirmDeletion": "Silme işlemini onayla",
"hc.confirmPassword": "Şifreyi onayla",
"hc.confirmThatThisIsYour": "Bu öğenin sizin olduğunu onaylayın. İletişimden önce bulucudan kimlik kontrolü talep edilecektir.",
"hc.confirmTheCarrier": "Taşıyıcıyı onayla",
"hc.confirmThePassword": "Şifreyi onayla",
"hc.confirmYourShippingAddressTo": "Ödemeye devam etmek için teslimat adresinizi onaylayın.",
"hc.confirmYourSubscription": "Aboneliğinizi onaylayın",
"hc.confirmed": "Onaylandı ✓",
"hc.contactFindoToGetYour": "Gönderen ID'nizi almak için Findloop ile iletişime geçin.",
"hc.contactUs": "Bizimle iletişime geçin",
"hc.continueTheReturn": "İade işlemini devam ettir",
"hc.continueToPayment": "Ödemeye devam et",
"hc.copy": "Kopyala",
"hc.correctMyDetails": "detaylarımı düzelt",
"hc.correctThisEntry": "Bu girişi düzeltmek ister misin?",
"hc.country": "Ülke",
"hc.countryAddress": "Ülke (adres)",
"hc.countryIsoCodeEG": "Ülke (ISO kodu, örn. FR)",
"hc.cover": "kapak",
"hc.createTheShipment": "Gönderimi oluştur",
"hc.cropThePhoto": "Fotoğrafı kes",
"hc.customer": "Müşteri",
"hc.customerClaimCodeToCheck": "Müşteri talep kodu — teslimatta kontrol etmek için:",
"hc.customerReasonFmt": "Müşterinin nedeni: \"{reason}\".",
"hc.customerReminderDelay": "Müşteri hatırlatma gecikmesi",
"hc.customerWhosePublicListingMatches": "Bu öğeye uyan halka açık listeye sahip müşteri — yalnızca size görünür.",
"hc.d15": "D-15",
"hc.dangerZone": "Tehlikeli bölge",
"hc.date": "Tarih",
"hc.dateNewest": "Tarih (en yeni)",
"hc.dateOldest": "Tarih (en eski)",
"hc.daysToYearEnd": "{n} gün yıl sonuna kadar",
"hc.deadlineAlert": "Son tarih uyarısı",
"hc.declarationClosed": "Beyan kapandı ✓",
"hc.declarationNotFound": "Beyan bulunamadı.",
"hc.declarationNotFound2": "Beyan bulunamadı",
"hc.declarationTracking": "Beyan takibi",
"hc.defaultCarrier": "Varsayılan taşıyıcı",
"hc.defaultCarrierPreselected": "Varsayılan taşıyıcı önceden seçildi — bu gönderi için değiştirilebilir. Gerçek ücret (Sendcloud + {m}% kâr).",
"hc.defaultCarrierRemoved": "Varsayılan taşıyıcı kaldırıldı",
"hc.delayHours": "Gecikme (saat)",
"hc.deleteMyAccount": "Hesabımı sil",
"hc.deleting": "Siliniyor…",
"hc.deletingDeactivatesYourAccountLogin": "Silme işlemi, hesabınızı devre dışı bırakır: giriş engellenir ve veriler 30 gün süreyle saklanır. 30 gün geçerli bir reaktivasyon bağlantısı içeren bir e-posta alacaksınız.",
"hc.delivered": "Teslim edildi",
"hc.depositAnItem": "Bir ürün depozite et",
"hc.depositCancelledItemPutBack": "Depozito iptal edildi — ürün stoğa geri alındı.",
"hc.depositCancelledItemRemovedFrom": "Depozito iptal edildi — ürün kayıttan çıkarıldı.",
"hc.depositedOn": "Şu tarihte depozito edildi",
"hc.describeTheItemBrandColor": "Ürünü tanımlayın: marka, renk, belirleyici işaretler… (Verdiğiniz detaylar ne kadar çok olursa, ürününüzü bulma şansınız o kadar artar)",
"hc.dimensionsCm": "Boyutlar (cm)",
"hc.disablingAnEmail": "Bir e-postayı devre dışı bırakma",
"hc.doesNotHide": "gizlemez",
"hc.download": "İndir",
"hc.downloadThePdf": "PDF'yi indir",
"hc.draftRestoredPickUpYour": "Taslak geri yüklendi — beyanınızı kaldığınız yerden alın.",
"hc.dragToReposition": "Yeniden konumlandırmak için sürükleyin",
"hc.eGColisPriv": "Örn. Colis Privé",
"hc.eachItemGetsAQr": "Her ürün bir QR etiketi alır. Anında bir ürünü bulmak için \"Depo & QR\" bölümünden taratın.",
"hc.eachSiteManagesItsOwn": "Her site kendi finansmanını yönetir. Git",
"hc.edit": "Düzenle",
"hc.emailNotificationPreferences": "E-posta bildirim tercihleri",
"hc.emailPreferencesUpdated": "E-posta tercihleri güncellendi",
"hc.enableOrDisableRecoveryFees": "Geri alma ücretlerini etkinleştir veya devre dışı bırak",
"hc.enlargePhoto": "Fotoğrafı büyüt",
"hc.enterTheCustomerSCode": "Müşterinin kodunu girin",
"hc.estShipRate": "Tahmini gönderim ücreti (Sendcloud + {m}% marj):",
"hc.establishment": "Kuruluş",
"hc.establishment2": "Kuruluş:",
"hc.establishmentInItsSendcloudAccount": "Sendcloud hesabınızdaki kuruluş ve size gönderici ID'sini verir",
"hc.establishmentSettings": "Kuruluş ayarları",
"hc.exCode": "örn. ABCD2345",
"hc.exId": "örn. 3f2a…",
"hc.exit": "Çıkış",
"hc.explainWhyThisItemIs": "Bu eşyayı neden sizin değil olduğunu açıklayın…",
"hc.externalPaymentLinks": "Dış ödeme bağlantıları",
"hc.failed": "Başarısız",
"hc.feesEnabled": "Ücretler etkin",
"hc.field": ") alanı.",
"hc.finderAcceptedCloseTheCase": "Finder kabul etti — eşya teslim edildikten sonra dosyayı kapatın.",
"hc.findoCityRanking": "Findloop — Şehir sıralaması",
"hc.findoForEstablishments": "Findloop kuruluşlar için",
"hc.findoPresentationVideo": "Findloop sunum videosu",
"hc.findoRegistersTheAddressOf": "Findloop, sizin için adresi kaydeder",
"hc.findoReviewShare": "Findloop {year} inceleme: {n} eşya iade edildi, {rate}% iade oranı 🎉",
"hc.firstVerifyTheClaimCode": "Öncelikle yukarıdaki talep kodunu doğrulayın",
"hc.forEveryNewShipmentFrom": "her yeni gönderi için",
"hc.free": "ücretsiz",
"hc.freeRecovery0": "Ücretsiz kurtarma (0 €)",
"hc.freeRecoveryAcrossAfricaLaunch": "Afrika genelinde ücretsiz kurtarma – Lansman teklifi",
"hc.freeRecoveryFeesDisabled0": "Ücretsiz kurtarma: ücretler devre dışı (0 €)",
"hc.fromTeamInviteYourColleagues": "\"Takım\" kısmından, meslektaşlarınızı e-posta ile davet edin ve onlara bir kuruluş atayın. Her üye yalnızca kendi kapsamını görür.",
"hc.fullName": "Tam ad",
"hc.fullPhoto": "Tam fotoğraf",
"hc.gallery": "Galerisi",
"hc.giveTheReasonForCancelling": "İptal nedenini belirtin. Ortak bilgilendirilecektir.",
"hc.goToLogin": "Giriş yapmaya git",
"hc.goToMyAccount": "Hesabıma git",
"hc.gold": "Altın",
"hc.googleLoginFailed": "Google ile giriş başarısız oldu",
"hc.hasConfirmedYourPaymentYou": "ödemeyi onayladı, otomatik olarak yönlendirileceksiniz",
"hc.helpCenter": "Yardım merkezi",
"hc.helpUsImproveWhyAre": "Bize gelişmemizde yardımcı olun: neden ayrılıyorsunuz? Hesabınız devre dışı bırakılacak ve 30 gün içinde yeniden etkinleştirilebilir.",
"hc.hidePassword": "Şifreyi gizle",
"hc.high": "Yüksek",
"hc.historyOfYourMonthlySubscriptions": "Aylık aboneliklerinizin geçmişi ve ödeme durumu.",
"hc.hotelBelmont": "Hotel Belmont",
"hc.howConfigureSenderId": "Numeric Gönderici Kimliğimi nasıl ayarlarım?",
"hc.iDonTUseIt": "Bunu yeterince kullanmıyorum",
"hc.iFoundItElsewhere": "Bunu başka bir yerde buldum",
"hc.iNoLongerNeedMy": "Artık eşyama ihtiyacım yok",
"hc.identityVerification": "Kimlik doğrulama",
"hc.idleLogoutIn": "Etkisizlik nedeniyle {n} s içinde oturumunuz kapatılacak.",
"hc.ifProvidedTheVolumetricWeight": "Verilmişse, hacimsel ağırlık kullanılır.",
"hc.ifThePartnerHasNot": "Ortak bu süre zarfında dış ödemeyi aldığını onaylamazsa, Findloop otomatik olarak ortağı doğrulaması için hatırlatır.",
"hc.impersonationEnded": "Taklit sona erdi.",
"hc.impersonationMode": "Taklit modu",
"hc.impersonationSessionExpired": "Taklit oturumu süresi doldu.",
"hc.inTheField": ", sahada",
"hc.inTransit": "Taşınmada",
"hc.inclVat": "KDV dahil",
"hc.intraEuVatNumberOptional": "AB içi KDV numarası isteğe bağlı, SIRET gerekmemektedir (Fransa dışı).",
"hc.invalidInvitationLink": "Geçersiz davet linki.",
"hc.invalidInvitationLink2": "Geçersiz davet linki",
"hc.invalidInviteLink": "Geçersiz veya süresi dolmuş davet linki.",
"hc.invalidNumberEnterAnInternational": "Geçersiz numara. Uluslararası bir numara girin, örn. +33 6 12 34 56 78.",
"hc.invalidOrExpiredLink": "Geçersiz veya süresi dolmuş link.",
"hc.invalidOrExpiredReactivationLink": "Geçersiz veya süresi dolmuş yeniden etkinleştirme linki",
"hc.invalidSendcloudId": "Geçersiz Sendcloud ID",
"hc.inviteSubtitle": "{org} sizi Findloop ekibine katılmaya davet ediyor. Hesabınızı aktifleştirmek için şifrenizi seçin.",
"hc.isAvailableOnSendcloudFor": "tüm rotalarınızda (yurt içi + uluslararası) Sendcloud'da mevcuttur.",
"hc.isNotEnabledOnYour": "bazı destinasyonlar için Sendcloud hesabınızda etkin değil. Bu etiketler, başka bir mevcut taşıyıcı ile oluşturulacaktır.",
"hc.isThisReallyYourItem": "Bu gerçekten eşyam mı?",
"hc.isThisYourItem": "Bu eşyam mı?",
"hc.item": "Ürün",
"hc.itemAlreadyConfirmed": "Ürün zaten onaylandı",
"hc.itemDetails": "Ürün detayları",
"hc.itemFoundAt": "Ürün şu yerde bulundu",
"hc.itemFoundAtAPartner": "Ürün bir partnerde bulundu",
"hc.itemMarkedAsReturned": "Ürün iade olarak işaretlendi ✓",
"hc.itemPhotoRequiredBeforeShipping": "Ürün fotoğrafı (göndermeden önce gereklidir)",
"hc.itemPhotoSaved": "Ürün fotoğrafı kaydedildi",
"hc.itemPreview": "Ürün önizlemesi",
"hc.itemPutBackInStorage": "Ürün depoya geri konuldu.",
"hc.itemWeight": "Ürün ağırlığı:",
"hc.itemsReturned": "üretim(i) iade edildi",
"hc.itemsReturnedThisYear": "bu yıl iade edilen eşyalar",
"hc.itemsWhoseLegalDeadlineIs": "Yasal son tarihi 15 gün veya daha az (gecikmeli dahil) olan eşyalar. Eşleşmeler görünür kalır.",
"hc.kbisNumber": "Kbis numarası",
"hc.keysForgottenOnABench": "Bir bankta unutulan anahtarlar",
"hc.labelBeingGenerated": "Etiket oluşturuluyor",
"hc.leaveTheFieldsEmptyTo": "Ücretsiz kurtarma sunmak için alanları boş bırakın.",
"hc.legalNotice": "Hukuki bildirim",
"hc.limitReachedUpgradeToA": "Limit aşıldı — daha yüksek bir plana geçin",
"hc.linkCopiedShareOn": "Bağlantı kopyalandı — bunu {label} üzerinde paylaşın",
"hc.linkUnavailable": "Bağlantı mevcut değil",
"hc.linkedTo": "Bağlı olduğu",
"hc.listingHiddenByModeration": "İlan moderasyon nedeniyle gizlendi.",
"hc.loading": "Yükleniyor…",
"hc.locateMe": "Beni bul",
"hc.logIn": "Giriş yap",
"hc.logInToGetBack": "Aboneliğinizi yönetmek ve alanınıza geri dönmek için giriş yapın.",
"hc.loginFailed": "Giriş başarısız",
"hc.lostFoundPlatform": "Kayıp & bulunmuş platform.",
"hc.lostIn": "kayboldu",
"hc.lowRate": "Düşük oran",
"hc.mainReason": "Ana sebep",
"hc.mainStreet": "Ana Cadde",
"hc.makeSureThisIsThe": "Bulucunun iletişim bilgilerini açmadan önce kaybettiğiniz eşyanın bu olduğundan emin olun.",
"hc.manageCookies": "Çerezleri yönet",
"hc.manageMyTeam": "Takımımı yönet",
"hc.manageYourTeam": "Ekibinizi yönetin",
"hc.markAsReturned": "Iade edildi olarak işaretle",
"hc.matchNoClaimInTime": "Eşleşme, son tarih içinde herhangi bir talep almadı.",
"hc.matchNotFound": "Eşleşme bulunamadı",
"hc.medium": "Orta",
"hc.milestoneFmt": "{m} iade edilen eşya kilometre taşına ulaşıldı! {next} yolunda.",
"hc.missingFeatures": "Eksik özellikler",
"hc.monthly": "Aylık",
"hc.monthlyBilling": "Aylık faturalama",
"hc.moveThePhotoToFit": "Fotoğrafı daireye sığacak şekilde hareket ettirin.",
"hc.myAccount": "Hesabım",
"hc.myInvoices": "Faturalarım",
"hc.myMonthlyInvoices": "Aylık faturalarım",
"hc.nArchived": "{n} liste arşivlendi.",
"hc.newCodeGeneratedAndSent": "Yeni kod oluşturuldu ve müşteriye e-posta ve SMS ile gönderildi",
"hc.newCodeGeneratedAndSent2": "Yeni kod oluşturuldu ve sahibine gönderildi",
"hc.newPassword": "Yeni şifre",
"hc.next": "Sonraki",
"hc.nextPhoto": "Sonraki fotoğraf",
"hc.no": "Hayır",
"hc.noAnswerProvided": "Cevap verilmedi.",
"hc.noArchivedDeclarations": "Hiç arşivlenmiş beyan yok",
"hc.noCountryFound": "Hiçbir ülke bulunamadı",
"hc.noDeclarations": "Hiç beyan yok",
"hc.noFeesAreChargedTo": "Müşteriden herhangi bir ücret alınmamaktadır.",
"hc.noInvoiceYet": "Henüz fatura yok.",
"hc.noInvoiceYetYourInvoices": "Henüz fatura yok. Faturalarınız her ödeme sonrası burada otomatik olarak görünecektir.",
"hc.noMatchIsAvailableFor": "Şu anda eşleşen bir kayıt yok. Beyanınıza uygun bir öğe bulunduğunda sizi bilgilendireceğiz.",
"hc.noShipmentMatchesYourSearch": "Aramanıza uygun bir sevkiyat yok.",
"hc.noShipmentsYet": "Henüz sevkiyat yok.",
"hc.noShipmentsYet2": "Henüz sevkiyat yok",
"hc.none": "hiçbiri",
"hc.noneChooseForEachShipment": "Hiçbiri (her sevkiyat için seçin)",
"hc.notMine": "Bu benim değil",
"hc.of": "ın",
"hc.only": "Sadece",
"hc.onlyEachSiteManagesIts": "sadece. Her site kendi bankacılığını yönetir: bu bağlantılar diğer işletmeleri etkilemez.",
"hc.onlyTheOwnerOrAn": "Yalnızca sahibi veya bir yönetici tesisin ödeme bağlantılarını yapılandırabilir.",
"hc.openDepositInTheMenu": "Menüde \"Deposit\" seçeneğini açın, öğeyi tanımlayın ve bir fotoğraf çekin. Hemen depolanır ve iade edilmeye hazırdır.",
"hc.openSettings": "Ayarları Aç →",
"hc.openTheDeclarationToManage": "Sevkiyatı yönetmek için beyanı aç",
"hc.optional": "— isteğe bağlı",
"hc.optional2": "(isteğe bağlı)",
"hc.optional3": "isteğe bağlı",
"hc.originalListingPhotoUsed": "Orijinal liste fotoğrafı kullanıldı",
"hc.other": "Diğer",
"hc.other2": "Diğer…",
"hc.ourProducts": "Ürünlerimiz",
"hc.overallRateTrendLast6": "Genel oran trendi (son 6 ay)",
"hc.ownerSClaimCode": "Sahip talep kodu",
"hc.ownershipConfirmed": "Mülkiyet onaylandı",
"hc.paid": "Ödendi",
"hc.paidOn": "Ödenme tarihi",
"hc.paidViaPartner": "Ödeme (ortağımız aracılığıyla)",
"hc.parcelBeingPrepared": "Paket hazırlanıyor",
"hc.parcelDelivered": "Paket teslim edildi",
"hc.parcelShipped": "Paket gönderildi",
"hc.parisGareDeLyon": "Paris, Gare de Lyon…",
"hc.partner": "Ortak",
"hc.partner2": "ortağ",
"hc.partnerDirectory": "Ortak dizini",
"hc.passedOnToTheCustomer": "— müşteri ödeme linkine aktarıldı.",
"hc.password": "Şifre",
"hc.passwordResetPleaseLogIn": "Şifre sıfırlama, lütfen giriş yapın.",
"hc.passwordUpdated": "Şifre güncellendi.",
"hc.passwordsDoNotMatch": "Şifreler eşleşmiyor.",
"hc.pasteThisSenderIdIn": "Bu Gönderen ID'sini Findloop → Ayarlar'a yapıştırın",
"hc.payForTheShipmentOf": "Eşyanızın gönderimi için Findloop üzerinden güvenli bir ödeme yapın.",
"hc.payTheRecoveryFees": "İade ücretlerini ödeyin",
"hc.payTheShippingFees": "Gönderim ücretlerini ödeyin",
"hc.payment": "Ödeme",
"hc.paymentAlreadyConfirmedByThe": "Ödeme zaten ortak tarafından onaylandı",
"hc.paymentLinksAreNowConfigured": "Ödeme bağlantıları artık kuruldu",
"hc.paymentNotCompletedYourAccount": "Ödeme tamamlanmadı, hesabınız oluşturulmadı — lütfen tekrar deneyin.",
"hc.paymentReceived": "Ödeme alındı",
"hc.paymentSuccessful": "Ödeme başarılı!",
"hc.pdfInvoice": "PDF fatura",
"hc.pending": "Beklemede",
"hc.period": "Dönem",
"hc.phoneNumber": "Telefon numarası",
"hc.phoneOptional": "Telefon (isteğe bağlı)",
"hc.planAt": "şu planda",
"hc.planLimitFmt": "\"{plan}\" planınız {max} kuruluşla sınırlıdır. {n} alanı yönetmek için,",
"hc.platformReturnTarget": "Platform geri dönüş hedefi",
"hc.pleaseCompleteYourShippingAddress": "Lütfen teslimat adresinizi tamamlayın.",
"hc.pleaseProvideAPhoneNumber": "Lütfen bir telefon numarası sağlayın: taşıyıcı için gereklidir.",
"hc.pleaseProvideAReason": "Lütfen bir neden belirtin.",
"hc.pleaseSetYourOwnPassword": "lütfen devam etmeden önce kendi şifrenizi belirleyin.",
"hc.pointsToGoal": "{n} puan daha ortak hedefimize ulaşmak için.",
"hc.posterPreview": "Afiş önizlemesi",
"hc.potentialMatchBeingVerified": "Olası eşleşme doğrulanıyor",
"hc.potentialOwner": "Olası sahibi",
"hc.preFilledAutomaticallyYouCan": "Otomatik olarak dolduruldu — paketin fotoğrafıyla değiştirebilirsiniz.",
"hc.pressKit": "Basın kiti",
"hc.previewMode": "Önizleme modu:",
"hc.previewOfThePrintReady": "Bu işletme için baskıya uygun A4 afişin önizlemesi.",
"hc.previous": "Önceki",
"hc.previousPhoto": "Önceki fotoğraf",
"hc.primary": "birincil",
"hc.printThePoster": "Afişi yazdır",
"hc.privacy": "Gizlilik",
"hc.privacyPolicy": "Gizlilik politikası",
"hc.processedCasesWillAppearHere": "İşlenmiş dosyalar burada görünecek.",
"hc.proofOfReturnPdf": "İade belgesi (PDF)",
"hc.protectedByRecaptcha": "reCAPTCHA ile korunuyor",
"hc.publicMatch": "Herkese açık eşleşme",
"hc.putBackInStorage": "Depoya geri koy",
"hc.pwdResetByTeam": "Şifreniz ekibimiz tarafından sıfırlandı. Güvenliğiniz için,",
"hc.questionsToAskTheOwner": "Sahibe sorulacak sorular",
"hc.rateChargedToTheCustomer": "Müşteriye uygulanan ücret:",
"hc.rateOfTarget": "{rate}% hedefin {target}%’si ulaşıldı",
"hc.reached": "ulaşıldı",
"hc.reactivating": "Yeniden etkinleştiriliyor…",
"hc.reasonSavedYouCanStill": "Sebep kaydedildi. Eşyanızı hala talep edebilirsiniz.",
"hc.recentMatchesFirst": "Önce en son eşleşmeler",
"hc.recognizedThePhotoYouSent": "gönderdiğiniz fotoğrafı tanıdı ve bu özellikleri tanımladı. Sadece, bu özelliklerin elinizdeki eşya ile eşleştiğini onaylayın.",
"hc.recommended": "Önerilen",
"hc.recoveryFees": "Geri alma ücretleri",
"hc.recoveryFeesArePaidDirectly": "Geri alma ücretleri, doğrudan partner işletmeye ödenir. Findloop, müşterilerden herhangi bir ödeme almaz.",
"hc.recoveryFeesEnabled": "Geri alma ücretleri etkinleştirildi",
"hc.recoveryOfferedByTheEstablishment": "İşletme tarafından sağlanan geri alma — Findloop herhangi bir ücret talep etmez.",
"hc.recoveryPaymentLink": "Geri alma ödeme bağlantısı",
"hc.recoveryPaymentLinkSavedFor": "Bu işletme için geri alma ödeme bağlantısı kaydedildi",
"hc.redirecting": "Yönlendiriliyor…",
"hc.redirectingToPayment": "Ödemeye yönlendiriliyor…",
"hc.redirectingToTheRecoveryOf": "Eşyanızın geri alınmasına yönlendiriliyor…",
"hc.regenerateAndResendToThe": "Yeniden oluştur ve sahibine gönder",
"hc.regenerateTheCode": "Kodu yeniden oluşturarak oluştur",
"hc.registerAFoundItem": "Bulunan bir eşyayı kaydet",
"hc.rejectTheClaim": "Talebi reddet",
"hc.reminderDelaySaved": "Hatırlatma süresi kaydedildi",
"hc.reopenThePaymentLink": "Ödeme bağlantısını yeniden aç",
"hc.repeatThePassword": "Şifreyi tekrar et",
"hc.reportAProblem": "Bir sorun bildirin",
"hc.reportDismissedYourListingRemains": "Rapor reddedildi. İlanınız herkese açık kalmaya devam ediyor.",
"hc.requiredUsedToCalculateThe": "Gerekli: Sendcloud gönderim tarifesini hesaplamak için kullanılır. 30 kg üzerinde gönderim mümkün değildir.",
"hc.reset": "Sıfırla",
"hc.resume": "Devam et",
"hc.resumeRegistration": "Kaydı devam ettir",
"hc.retro": "Yılın özeti",
"hc.returnSecurity": "İade güvenliği",
"hc.returnToTheOwner": "Sahibine iade et",
"hc.returned": "iade edildi",
"hc.reviewTheItemDetails": "Ürün detaylarını gözden geçirin",
"hc.revokeAccess": "Erişimi iptal et",
"hc.role": "Rol:",
"hc.save": "Kaydet",
"hc.save2": "kaydet",
"hc.saveAndContinue": "Kaydet ve devam et",
"hc.saving": "Kaydediliyor…",
"hc.scanTheClaimCode": "Talep kodunu tara",
"hc.scanTheOwnerSQr": "Sahibin QR kodunu tara",
"hc.scrollThroughLanguages": "Diller arasında kaydır",
"hc.searchByCustomerItemOr": "Müşteri, ürün veya takip numarasına göre ara…",
"hc.searchForACountry": "Bir ülke ara…",
"hc.secureFindoVerification": "Güvenli Findloop doğrulaması",
"hc.seeRetro": "Yılı gözden geçir",
"hc.selectedCarrier": "Seçilen taşıyıcı:",
"hc.selectedPlan": "Seçilen plan",
"hc.send": "Gönder",
"hc.sendcloudSenderIdSaved": "Sendcloud gönderici ID'si kaydedildi",
"hc.sendcloudSenderIdSenderId": "Sendcloud gönderici ID'si (sender_id)",
"hc.sending": "Gönderiliyor…",
"hc.sessionExpired": "Oturum süresi doldu",
"hc.setUpYourEstablishments": "İşletmelerinizi kurun",
"hc.settings": "Ayarlar",
"hc.settingsSubtitle": "Dış ödemeler ve hatırlatmalar, işletmelere göre yapılandırılmıştır.",
"hc.shareFoundText": "Bir ürün buldum — Findloop'da sahibini bulmama yardım et",
"hc.shareLostText": "Bir ürün kaybettim — Findloop'da onu bulmama yardım et",
"hc.sharePreview": "Paylaşım önizlemesi",
"hc.shareTheRanking": "Sıralamayı paylaş",
"hc.shareYourQrCodeTo": "Açıklamalar almak için QR kodunuzu paylaşın.",
"hc.shipRateAutoWeight": "Gönderim ücreti, Sendcloud üzerinden otomatik olarak (ağırlık {w}) gönderim anında hesaplanır.",
"hc.shipRateForWeight": "{w} için gönderim ücreti (Sendcloud + {m}% kar):",
"hc.shipments": "Gönderimler",
"hc.shipmentsSubtitle": "Tüm durumlar üzerinden işletmenin tüm gönderimlerinin konsolide görüntüsü. Gönderimi yönetmek için bir satıra tıklayın.",
"hc.shipping": "Gönderim",
"hc.shippingAddress": "Gönderim adresi",
"hc.shippingFeesAreHandledAutomatically": "Gönderim ücretleri Findloop (Sendcloud) tarafından otomatik olarak işlenir – girilecek bir bağlantı yok.",
"hc.shippingFeesHaveAlreadyBeen": "Gönderim ücretleri zaten ödendi: taşıyıcı artık değiştirilemez.",
"hc.shippingNotAvailableForItems": "30 kg'dan fazla ürünler için gönderim mevcut değildir. Müşteri ürününü şahsen almalıdır.",
"hc.shippingPaid": "Gönderim ödendi ✓",
"hc.showOnlyItemsMatchingA": "Sadece bir genel (müşteri) liste ile eşleşen ürünleri göster",
"hc.showPassword": "Şifreyi göster",
"hc.signInTheBoxAbove": "Yukarıdaki kutudan oturum açın",
"hc.signatureSaved": "İmza kaydedildi",
"hc.signedInWithGoogle": "Google ile oturum açıldı",
"hc.signupFailed": "Kayıt işlemi başarısız oldu",
"hc.silver": "Gümüş",
"hc.simulatedRatesInPreProduction": "(ön üretimde simüle edilmiş tarifeler)",
"hc.siretAndVatNumberRequired": "SIRET ve KDV numarası gereklidir (Fransa).",
"hc.skip": "Atla",
"hc.smsSentIfAccount": "Bu numara ile bir hesap varsa, size bir SMS gönderilmiştir.",
"hc.sortItemsWithAPublic": "Sırala: genel eşleşme (en son) olan ürünler önce",
"hc.specifyWhetherYouRecoveredYour": "Ürününüzü geri alıp almadığınızı veya bu listeyi çıkarmak isteyip istemediğinizi belirtin.",
"hc.specifyYourReason": "Sebebinizi belirtin",
"hc.specifyYourReason2": "Sebebinizi belirtin…",
"hc.staff": "Personel",
"hc.status": "Durum",
"hc.staySignedIn": "Oturumu açık tut",
"hc.step": "Adım",
"hc.stillThere": "Hala orada mı?",
"hc.stopScrolling": "Kaydırmayı durdur",
"hc.storeFindWithQr": "QR ile sakla & bul",
"hc.streetName": "Sokak adı",
"hc.streetNo": "Sokak no.",
"hc.switchTo": "Geçiş yap",
"hc.switchToDarkMode": "Karanlık moda geç",
"hc.switchToLightMode": "Aydınlık moda geç",
"hc.takeAPhoto": "Fotoğraf çek",
"hc.takeChangeThePhoto": "Fotoğrafı çek / değiştir",
"hc.takenFromYourDeclaration": "beyanınızdan alındı",
"hc.target": "Hedef",
"hc.targetReached": "Hedefe ulaşıldı",
"hc.targetReachedThankYouTo": "Hedefe ulaşıldı — tüm Findloop topluluğuna teşekkürler!",
"hc.tellUsMore": "Bize daha fazlasını söyle…",
"hc.tellUsWhyYouCancel": "Neden iptal ettiğinizi bildirin. Bu, partnerin isteğinizi işlemesine yardımcı olur.",
"hc.tellUsWhyYourListing": "Nedenini belirtin. İlanınız aktif kalacak ve eşyanızı talep edebilirsiniz.",
"hc.termsAndConditions": "Şartlar ve koşullar",
"hc.termsAndPolicies": "Şartlar ve politikalar",
"hc.thankYouForYourFeedback": "Geri bildiriminiz için teşekkürler",
"hc.theBannerDisplayedInThe": "kayıt defterinde görüntülenen afiş.",
"hc.theClaimantHasBeenInformed": "Talep sahibi bilgilendirildi. Eşya, kamusal listede mevcut kalacaktır.",
"hc.theClaimantHasBeenNotified": "Talep sahibine bildirildi ve şimdi iade işlemini başlatabilir.",
"hc.theCustomerPaysTheFees": "Müşteri, kuruluma ücretleri öder.",
"hc.theDayTheLegalRetention": "Yasal saklama süresinin dolduğu gün.",
"hc.theEstablishmentConsideredThatThis": "Kuruluş, bu eşyanın size ait olmadığını düşündü.",
"hc.theEstablishmentIsReviewingYour": "Kuruluş yanıtlarınızı inceliyor. Talebiniz onaylandığında size bildirilecektir, ardından kurtarma ücretlerini ödeyebilirsiniz.",
"hc.theFeesAreTooHigh": "Ücretler çok yüksek",
"hc.theFinderConsideredThatThis": "Bulucu, bu eşyanın size ait olmadığını düşündü.",
"hc.theFinderIsReviewingYour": "Bulucu talebinizi inceliyor. Onaylandığında size bildirilecektir.",
"hc.theItem": "Eşya",
"hc.theItemWillBeRemoved": "Eşya kayıt defterinden kaldırılacaktır (devam eden bir talep yok).",
"hc.theItemWillBeSet": "Eşya \"stokta\" olarak ayarlanacak ve ilgili talep iptal edilecektir.",
"hc.theKbisNumberAndVat": "Fransa için Kbis numarası ve KDV numarası gereklidir.",
"hc.theLabelIsGeneratedAutomatically": "Etiket, müşteri nakliye ücretini ödedikten sonra otomatik olarak oluşturulur. Buradan indirilebilir.",
"hc.theLinkMayHaveExpired": "Bağlantı süresi dolmuş olabilir (30 gün geçerli). Gerekirse Findloop destek ile iletişime geçin.",
"hc.theOwnerDescribesTheirItem": "Sahip, eşyasını tanımlıyor",
"hc.theOwnerReceivedItBy": "Sahip, eşyayı e-posta (veya SMS) ile aldı. Teslimattan önce girin veya tarayın.",
"hc.thePartnerConsideredThatThis": "Partner, bu eşyanın size ait olmadığını düşündü. Eşya mevcut durumda kalacaktır.",
"hc.thePartnerIsReviewingYour": "Partner yanıtlarınızı inceliyor. Talebiniz onaylandığında size bildirilecektir.",
"hc.theShipmentIsCreatedAutomatically": "Gönderim, müşteri adresini onayladıktan ve kurtarma ücretlerini ödedikten sonra otomatik olarak oluşturulur. Daha sonra, nakliye ödemesi yapıldıktan sonra etiket otomatik olarak oluşturulacak ve buradan indirilebilir.",
"hc.theShippingRateWillBe": "Nakliye ücreti, nakliye sırasında Sendcloud üzerinden otomatik olarak hesaplanacaktır (kayıtlı ağırlık).",
"hc.thisCarrierWillBe": "Bu taşıyıcı olacak",
"hc.thisEstablishment": "bu kuruluş",
"hc.thisFieldIsRequiredFor": "Bu alan otomatik etiket oluşturma için gereklidir.",
"hc.thisIsMyItem": "Bu benim eşyam",
"hc.thisIsMyItemContinue": "Bu benim eşyam — devam et",
"hc.thisIsMyItemStart": "Bu benim eşyam — iade işlemini başlat",
"hc.thisIsNotMyItem": "Bu benim eşyam değil",
"hc.thisMatchIsNoLonger": "Bu eşleşme artık mevcut değil veya işlenmiştir.",
"hc.thisRateWillBeCharged": "Bu ücret müşteriden tahsil edilecektir. Yüksek bir ücret kurtarmayı caydırabilir.",
"hc.thisStepIsRequiredFor": "Bu adım, nakliye etiketlerinin oluşturulması için gereklidir.",
"hc.thisValidationLinkIsInvalid": "Bu doğrulama bağlantısı geçersiz veya süresi dolmuş.",
"hc.toCheckBeforeMarkingThe": "Öğeyi iade edilmiş olarak işaretlemeden önce kontrol etmek için.",
"hc.toConfigureTheLinksAnd": "her kuruluş için bağlantıları ve hatırlatıcı gecikmeyi yapılandırmak için.",
"hc.toReachOurFirstMilestone": "100 iade ile ilk kilometre taşımıza ulaşmak için.",
"hc.toTheCustomer": "müşteriye.",
"hc.toTheShippingFeePayment": "nakliye ücreti ödemesine.",
"hc.toYourRecoveryTracking": "kurtarma takibinize.",
"hc.tooExpensiveBudget": "Çok pahalı / bütçe",
"hc.topCitiesForReturns": "İadeler için en iyi şehirler",
"hc.trackMyRecovery": "Kurtarmamı takip et",
"hc.trackTheShipmentAndDownload": "Gönderimi takip et ve Etiket'i (otomatik olarak oluşturulur) Deklarasyonlar sekmesini terk etmeden indir.",
"hc.trackYourStatistics": "İstatistiklerinizi takip et",
"hc.tracking": "Takip",
"hc.unableToOpenTheShipping": "Nakliye ücreti ödemesini açamıyoruz. Lütfen tekrar deneyin.",
"hc.unableToRetrieveTheInvoice": "Faturayı almamız mümkün olmadı.",
"hc.unclaimed": "Talep edilmemiş",
"hc.unclaimedCustomerReason": "Talep edilmemiş öğe. Müşterinin nedeni: \"{reason}\".",
"hc.unclaimedItem": "Talep edilmemiş öğe",
"hc.unclaimedItemNoClaimWithin": "Talep edilmemiş öğe — son tarih içerisinde talep yok.",
"hc.unclaimedItems": "Talep edilmemiş öğeler",
"hc.unclaimedItemsMatchLeftWithout": "Talep edilmemiş öğeler: son tarih içinde talep olmaksızın kalan eşleşme. Bunları tekrar depoya koyabilirsiniz.",
"hc.unlockTheFinderSContact": "Teslimat düzenlemek için bulucunun iletişim bilgilerini açın.",
"hc.upcoming": "Yaklaşan",
"hc.updateFailed": "Güncelleme başarısız.",
"hc.usedForInvoices": "Findloop faturalarınızı düzenlemek için kullanılır.",
"hc.vatNumber": "KDV numarası",
"hc.verificationPending": "Doğrulama bekleniyor",
"hc.verificationSentToTheFinder": "Doğrulama bulucuya gönderildi. Kararları hakkında bilgilendirileceksiniz.",
"hc.verificationSentToThePartner": "Doğrulama ortağa gönderildi. Kararları hakkında bilgilendirileceksiniz.",
"hc.verify": "Doğrula",
"hc.verifyingInvite": "Davet bağlantısını doğruluyor…",
"hc.verifyingTheLink": "Bağlantıyı doğruluyor…",
"hc.viewInRegistry": "Kayıtta görüntüle",
"hc.viewItem": "Öğeyi görüntüle",
"hc.viewItemRecover": "Öğeyi görüntüle & kurtar",
"hc.visibleToTheOwnerAutomatically": "Sahibine görünür · 60 gün sonra otomatik olarak silinir.",
"hc.waitingForPartnerConfirmation": "Ortak onayını bekliyor",
"hc.waitingForThePartnerS": "Ortak onayını bekliyor",
"hc.weHaveInformedTheEstablishment": "Bu öğenin sizin olmadığını kuruluşa bildirdik ve analizi yeniden başlattık. Yeni bir eşleşme bulunduğunda bilgilendirileceksiniz.",
"hc.weHaveInformedThePartner": "Bu öğenin sizin olmadığını ortakla bildirdik. İlanınız gelecekteki eşleşmeler için aktif kalmaya devam ediyor.",
"hc.weRanTheAnalysisAgain": "Analizi tekrar yaptık ve sizin olabilecek başka bir öğe belirledik. Lütfen tekrar kontrol edin.",
"hc.weight": "Ağırlık",
"hc.weightNotProvidedTheShipping": "Ağırlık sağlanmadı: kargo ücreti, gönderim anında hesaplanacaktır.",
"hc.weightUnit": "Ağırlık birimi",
"hc.welcome": "Hoş geldiniz!",
"hc.welcomeToFindo": "Findloop'ya hoş geldiniz",
"hc.whenACustomerComesTo": "Bir müşteri eşyalarını almaya geldiğinde, beyanlarını açın ve iadeyi doğrulayın. Hepsi bu kadar!",
"hc.whenDisabledFeesDropTo": ". Engellendiğinde, ücretler düşer",
"hc.whyIsThisNotYour": "Bu neden sizin öğeniz değil?",
"hc.willBeMarkedAs": "şu şekilde işaretlenecek",
"hc.wrongColor": "Yanlış renk",
"hc.wrongModel": "Yanlış model",
"hc.yesCancel": "Evet, iptal et",
"hc.yesContactTheFinder": "Evet, bulucu ile iletişim kur",
"hc.youAreHere": "Buradasınız",
"hc.youBusinessCom": "you@business.com",
"hc.youCanNowStartThe": "Artık iadeyi başlatabilirsiniz.",
"hc.youCanStillChangeIt": ". Duruma göre hala değiştirebilirsiniz.",
"hc.youHaveAlreadyConfirmedThat": "Bu öğenin sizin olduğunu zaten onayladınız.",
"hc.youWillBeRedirectedTo": "Güvenli Stripe ödeme sayfasına yönlendirileceksiniz.",
"hc.yourAccountHasBeenReactivated": "Hesabınız yeniden etkinleştirildi.",
"hc.yourAccountIsActiveYou": "Hesabınız aktif, artık işletmelerinizi yönetebilirsiniz.",
"hc.yourEstablishment": "İşletmeniz",
"hc.yourFeedbackHelpsUsImprove": "Geri bildiriminiz, eşleştirmelerimizi geliştirmemize yardımcı oluyor.",
"hc.yourFeedbackHelpsUsRestart": "Geri bildiriminiz, analizi yeniden başlatmamıza ve eşleştirmelerimizi geliştirmemize yardımcı oluyor.",
"hc.yourFirstSteps": "İlk adımlarınız",
"hc.yourFirstStepsAdmin": "İlk adımlarınız (yönetici)",
"hc.yourItemHasBeenHanded": "Öğeniz, partner tarafından şahsen teslim edildi — teslimat onaylandığında dosyayı kapatın.",
"hc.yourItemHasBeenShipped": "Öğeniz, partner tarafından gönderildi — teslimat onaylandığında dosyayı kapatın.",
"hc.yourPaymentHasBeenRecorded": "Ödemeniz kaydedildi.",
"hc.yourShipmentIsBeingPrepared": "Gönderiminiz hazırlanıyor. Paketinizi 3 ila 5 iş günü içinde alacaksınız.",
"hc.yourShippingFeesHaveAlready": "Kargo ücretleriniz zaten ödendi. Kargo ödendi ✓",
"hc.yourShippingFeesHaveBeen": "Kargo ücretleriniz ödendi. Paketiniz hazırlanıyor.",
"hc.yourVerificationQuestionsDeposit": "Doğrulama sorularınız (depozito)",
"hero.einvoiceBadge": "2027 uyumlu e-fatura",
"home.recentAdsAll": "Tüm ilanları görün",
"home.recentAdsEyebrow": "Şu anda",
"home.recentAdsSubtitle": "Toplum tarafından bildirilen kaybolan eşyalar.",
"home.recentAdsTitle": "Son ilanlar",
"home.reunions": "Son buluşmalar",
"home.videoEyebrow": "İzle",
"home.videoSubtitle": "Kaybolan eşyaları sahipleriyle zahmetsizce nasıl buluşturduğumuzu keşfedin.",
"home.videoTitle": "Findloop'yu 2 dakikada keşfedin",
"home.watchYoutube": "YouTube'da izle",
"impact.already": "Zaten",
"impact.citiesWord": "şehir/şehirler",
"impact.eachPoint": "Her nokta, Findloop'nun kaybolan eşyaların geri alınmasına yardımcı olduğu bir şehri temsil eder.",
"impact.emptyMap": "Eşyalar geri verildikçe harita doluyor.",
"impact.eyebrow": "Etkimiz",
"impact.inCities": "boyunca",
"impact.restitutedTo": "sahiplerine geri verilen eşyalar",
"impact.title": "Her yerde yakınınızda geri verilen eşyalar",
"inv2.download": "İndir",
"inv2.view": "Görüntüle",
"map.objectsOnMapPlural": "haritadaki eşyalar",
"map.objectsOnMapSingular": "haritadaki eşya",
"mc.claimConfirmDesc": "İletişim bilgilerini almak için bulucunun bulduğu eşyayı kontrol edin.",
"mc.claimConfirmNo": "Bu benim eşyam değil",
"mc.claimConfirmTitle": "Bu gerçekten sizin eşyanız mı?",
"mc.claimConfirmYes": "Evet, benim — öde",
"mc.claimFinderContacts": "Bulucunun iletişim bilgileri",
"mc.claimNotMineDone": "Teşekkürler — bulucu bilgilendirildi ve talebiniz reklamdan kaldırıldı.",
"mc.claimUnlockDesc": "Eşyanızı bulan kişinin iletişim bilgilerini almak için Findloop yönetim ücretini ödeyin.",
"mc.claimUnlockTitle": "Bulucunun iletişim bilgilerini aç",
"mc.hideCountryOffers": "Ülkemdeki teklifleri gizle",
"mc.myClaims": "Talep ettiğim eşyalar",
"mc.myClaimsSub": "Diğerlerinin bulduğu ve sizlerin talep ettiği eşyalar. Eşya teslimini düzenlemek için bulucunun iletişim bilgilerini açın.",
"mc.notifAdCancelled": "Reklam iptal edildi",
"mc.notifCancelAd": "Reklamımı iptal et",
"mc.offersInCountry": "Ülkemdeki teklifler",
"mc.offersInCountryDesc": "Şehrinize göre, ülkenizdeki ortaklardan tüm aktif ödüller.",
"mc.redArchived": "Arşivlendi",
"mc.rewardsCountryNone": "Ülkenizde henüz bir teklif yok.",
"mc.rewardsForYou": "Sizler için ödüller",
"mc.rewardsForYouDesc": "Eşyayı bıraktığınız ortak(lar) tarafından sunulmuştur.",
"mc.rewardsMineNone": "Henüz bırakma ortaklarınızdan bir ödül yok.",
"mc.showCountryOffers": "Ülkemdeki teklifleri gör",
"mc2.cancelDecl": "Beyanımı iptal et",
"mc2.cancelDeclDone": "Beyan iptal edildi.",
"pricing.physInvDesc": "Bir eşya geri verildiğinde, yeri otomatik olarak serbest kalır ve yeni bir eşyaya uygun hale gelir.",
"pricing.physInvTitle": "Fiziksel envanter takibi",
"pricing.physModalTitle": "Fiziksel eşya yönetimi",
"pricing.physQrDesc": "Her bir ürün için benzersiz bir QR kodu oluşturulur ve tüm bilgilerine bağlantı sağlar.",
"pricing.physQrTitle": "Özel QR etiketi",
"pricing.physShelfDesc": "Her kayıtlı ürün, işletme içinde fiziksel bir konuma atanabilir.",
"pricing.physShelfTitle": "Raf planı",
"pricing.physicalMgmt": "Fiziksel eşya yönetimi (raf, QR, envanter)",
"pub.addSecondPhoto": "2. fotoğraf ekle (isteğe bağlı)",
"pub.photo2Added": "✓ 2. fotoğraf eklendi",
"reg.dispositionJournal": "Devir günlüğü",
"reg.dispositionNoteAuthHint": "ℹ️ \"Yetkililere teslim edildi\" için bir not gereklidir (rapor numarası, departman…).",
"reg.dispositionNotePh": "Not (isteğe bağlı): alıcı vakfı, yetkili referansı, alıcı adı…",
"reg.dispositionNoteRequired": "Yetkililere teslim için resmi bir referans gereklidir.",
"reg.legalPrealert": "{days} gün içinde yasal son tarih",
"reg.legalPrealertOptions": "Son tarih seçenekleri: açık artırma, bir vakfa bağış, yetkililere teslim.",
"reg.legalPrealertShort": "D-{days}",
"rev.fullReview": "Tam inceleme",
"rev.readMore": "Daha fazla oku",
"rw.activeCodes": "Aktif kuponlar",
"rw.archived": "Arşivlenmiş",
"rw.archivedTitle": "Kullanılan kuponlar (arşivlenmiş)",
"rw.hideArchived": "Kullanılan kuponları gizle",
"rw.noArchived": "Arşivlenmiş kupon yok.",
"rw.showArchived": "Kullanılan kuponları göster",
"shp.labelAuto": "Etiket, müşteri nakliye ücretlerini ödediği anda otomatik olarak oluşturulur. Buradan indirilebilir.",
"st.cancelled_by_customer": "İptal edildi",
"stt.dispoPdfBtn": "PDF dışa aktar",
"stt.dispoPdfError": "PDF dışa aktarma başarısız oldu.",
"stt.dispoPdfExporting": "Dışa aktarılıyor…",
"trk.matchVerifying": "Olası eşleşme doğrulanıyor",
"pcat.stadium_arena": "Stadyum / Arena",
"pcat.supermarket": "Süpermarket",
"pcat.taxi_vtc": "Taksi / Araç çağırma",
"pcat.tourism_office": "Turist Bürosu",
"pcat.train_bus_station": "Tren / otobüs istasyonu",
"pcat.travel_agency": "Seyahat Acentesi",
"hc.and": "ve",
"hc.demoObj0": "bir cüzdan",
"hc.demoObj1": "bir spor çantası",
"hc.demoObj2": "bir telefon",
"hc.demoObj3": "bir gözlük",
"hc.demoObj4": "bir anahtar seti",
"hc.demoObj5": "bir atkı",
"hc.demoObj6": "bir dizüstü bilgisayar",
"hc.demoObj7": "bir su şişesi",
"hc.demoWhen0": "2 saat önce",
"hc.demoWhen1": "5 saat önce",
"hc.demoWhen2": "dün",
"hc.demoWhen3": "3 saat önce",
"hc.demoWhen4": "bu sabah",
"hc.demoWhen5": "1 gün önce",
"hc.feedDemo": "{obj} {city} {when} döndürüldü.",
"hc.feedReal": "{cat} adlı bir ürün {city} şehrinde döndürüldü.",
"hc.saveBtn": "Kaydet",
"hc.saveLink": "Bağlantıyı kaydet",
"hc.terms": "Şartlar",
"hc.view": "Görüntüle",
"pcat.airline": "Havayolu",
"pcat.airport": "Havalimanı",
"pcat.amusement_park": "Eğlence parkı",
"pcat.bank": "Banka",
"pcat.bar_cafe": "Bar / Kafe",
"pcat.beauty_salon": "Kuaför / Güzellik salonu",
"pcat.cinema": "Sinema",
"pcat.concert_theater": "Konser salonu / Tiyatro",
"pcat.coworking": "Ortak çalışma alanı",
"pcat.gym_fitness": "Spor salonu / Fitness",
"pcat.hospital_clinic": "Hastane / Klinik",
"pcat.library": "Kütüphane",
"pcat.mall": "Alışveriş merkezi",
"pcat.museum": "Müze",
"pcat.pharmacy": "Eczane",
"pcat.private_company": "Özel şirket",
"pcat.public_transport": "Toplu taşıma",
"pcat.school_university": "Okul / Üniversite",
"pcat.sports_center": "Spor merkezi",
"mc2.autoDelete": "Otomatik silme planlandı",
"mc2.boostExpiresIn": "Boost'unuzun süresi doluyor",
"stt.awaitingRestitution": "iade bekleyen ürünler",
"sub.cancelConfirm1": "İptal etmek istediğinize emin misiniz? Erişiminiz aktif kalmaya devam edecek",
"an.found": "Bulundu",
"an.lost": "Kaybedildi",
"hc.shareReview": "Yorumu paylaş",
"hc.citiesAboveTarget": "{n} hedefin üstünde şehirler",
"hc.cityAboveTarget": "{n} hedefin üstünde şehir",
"hc.j15EarlyReminder": "D-15 erken hatırlatma",
"hc.j7EarlyReminder": "D-7 erken hatırlatma",
"hc.annualTotal": "Yıllık toplam",
"hc.billedOnceYear": "12 ay için bir kerelik tahsilat, her yıl yenilenir.",
"hc.monthlyPrice": "Aylık fiyat",
"hc.perMonth": "/ ay",
"hc.perYear": "/ yıl",
"hc.billedEachMonth": "Her ay otomatik olarak ücretlendirilir.",
"nav.business": "İş",
"nav.individual": "Bireysel",
"hc.circumstancesFound": "Bulunduğu koşullar",
"hc.circumstancesFoundPh": "Örnek: metro girişinin yanındaki yerde bulundu",
"hc.circumstancesLost": "Kaybolma koşulları",
"hc.circumstancesLostPh": "Örnek: otobüs beklerken bir bankta bırakıldı",
"hc.conditionPh": "Örnek: iyi, çizik... ",
"hc.firstName": "İsim",
"hc.lastName": "Soyisim",
"hc.quantity": "Eşya sayısı",
"fa.approve": "Onayla",
"fa.approveConfirm": "Bu bildirimi onaylamak istiyor musunuz? İletişim bilgileriniz (isim, e-posta, telefon) bulunurla paylaşılacaktır.",
"fa.approved": "Bildiriminiz onaylandı — iletişim bilgileri paylaşıldı",
"fa.approvedFinder": "Sahibi bildiriminizi onayladı",
"fa.approvedFinderText": "İade düzenlemek için onlarla iletişime geçin.",
"fa.boostSub": "İlanınız seçilen süre boyunca en üstte kalır.",
"fa.boostTitle": "İlanımı yükselt (isteğe bağlı)",
"fa.colFinder": "Bulunun bildirimi",
"fa.colYours": "Sizin bildiriminiz",
"fa.compareHint": "Karar vermeden önce bulununun bildirimini sizinle karşılaştırın.",
"fa.contribNone": "Hiçbir katkı",
"fa.contribPaid": "Katkı alındı — teşekkürler!",
"fa.contribPending": "Katkı ödemesi bekleniyor",
"fa.contribSub": "Daha fazla kişinin eşyalarını geri almasına yardımcı olmak için Findloop'yu destekleyin. €0 seçebilirsiniz.",
"fa.contribSuccessMsg": "Bildiriminiz sahibine gönderildi.",
"fa.contribSuccessTitle": "Katkınız için teşekkürler",
"fa.contribTitle": "Gönüllü katkı",
"fa.days3": "3 gün",
"fa.days30": "30 gün",
"fa.days7": "7 gün",
"fa.declSub": "Bulduğunuz eşyayı tanımlayın. Sahibi sizin bildiriminizle kendi bildiriminizi karşılaştıracaktır.",
"fa.declTitle": "Bu eşyayı buldum",
"fa.expiresOn": "Son tarihi",
"fa.fBrand": "Marka",
"fa.fCircumstances": "Durumlar",
"fa.fCity": "Şehir",
"fa.fColor": "Renk",
"fa.fCondition": "Durum",
"fa.fDate": "Tarih",
"fa.fMessage": "Bulununun mesajı",
"fa.fPlace": "Yer",
"fa.fQuantity": "Miktar",
"fa.finderContact": "Bulununun iletişim bilgileri",
"fa.finishPay": "Ödemeyi tamamla",
"fa.foundDate": "Bulunduğu tarih",
"fa.foundPlace": "Bulunduğu yer",
"fa.hours24": "24 saat",
"fa.ht": "KDV hariç",
"fa.months3": "3 ay",
"fa.noBoost": "Yükseltme yok",
"fa.ownerContact": "Sahibin iletişim bilgileri",
"fa.payPublish": "Öde ve yayınla",
"fa.pendingPayText": "Ödemeniz onaylandıktan sonra ilanınız yayına girecek.",
"fa.pendingPayTitle": "Ödeme bekleniyor",
"fa.planSub": "Ödemeniz onaylandıktan sonra ilanınız yayına girecek.",
"fa.planTitle": "İlan süresi",
"fa.pubSuccessMsg": "İlanınız yayında. Bir bulucu öne çıktığında size bildireceğiz.",
"fa.pubSuccessTitle": "İlan yayınlandı",
"fa.publicNote": "Sadece açıklama, şehir, ülke ve fotoğraflar kamuya açık olarak gösterilmektedir.",
"fa.redirectStripe": "Güvenli ödemeye yönlendiriliyor…",
"fa.reject": "Reddet",
"fa.rejectConfirm": "Bu beyanı reddediyor musunuz? İlanınız çevrimdışı kalacak.",
"fa.rejected": "Beyan reddedildi",
"fa.rejectedFinder": "Aradıkları ürün bu değildi",
"fa.rejectedFinderText": "Sahibi bu ürünün kendine ait olmadığını söylüyor. Yardımınız için teşekkürler!",
"fa.responsesTitle": "Bulucu beyanları",
"fa.sent": "Beyan sahibine gönderildi.",
"fa.submitDecl": "Beyanımı gönder",
"fa.submitDeclPay": "Gönder ve katkıda bulun {amount}",
"fa.total": "Ödenecek toplam",
"fa.ttc": "KDV dahil",
"fa.waitClaimText": "Bulucu talebinizi inceliyor. Kararları hakkında bilgilendirileceksiniz.",
"fa.waitFinderText": "Bir bulucu bir beyan gönderdiğinde sizi bilgilendireceğiz.",
"fa.waitFinderTitle": "İlanınız yayında",
"fa.waitOwnerText": "Sahibi, beyanınızı kendi beyanıyla karşılaştırıyor. Kararları hakkında bilgilendirileceksiniz.",
"fa.waitOwnerTitle": "Sahibin kararını bekliyoruz",
"st.pending_payment": "Ödeme bekleniyor",
"fa.africaFree": "Afrika'da ücretsiz listeleme — Findloop lansman teklifi, tadını çıkarın!",
"fa.africaPublished": "Ücretsiz yayınlanan listeleme — Afrika lansman teklifi!",
"fa.approveClaimConfirm": "Bu iddiayı onaylayacak mısınız? Sahibi, ardından iletişim bilgilerinizi açabilecektir.",
"fa.checkInfo": "Göndermeden önce bilgilerinizi kontrol edin: bunlar bulucunun bilgileriyle karşılaştırılacaktır.",
"fa.claimApprovedShort": "Bulucu, iddianızı onayladı",
"fa.claimRejectedShort": "İddia bulucu tarafından reddedildi",
"fa.claimRejectedText": "Bulucu, bu nesnenin sizinki olmadığına inanıyor.",
"fa.claimSub": "Ürününüzü tanımlayın ve 2 fotoğraf ekleyin. Bulucu bunları kendi listesiyla karşılaştıracaktır.",
"fa.claimTitle": "Bu benim eşyam",
"fa.claimUnlockText": "Dönüşüm ayarlamak için bulucunun iletişim bilgilerini açın.",
"fa.claimUnlockedShort": "İletişim bilgileri açıldı — takibi görün",
"fa.claimsTitle": "Sahip iddiaları",
"fa.colOwner": "Sahip beyanı",
"fa.colYourAd": "Listeleme",
"fa.expired": "Listeleme süresi doldu",
"fa.free": "Ücretsiz",
"fa.lostDate": "Kaybolma tarihi",
"fa.lostPlace": "Kaybolma yeri",
"fa.noReceipt": "Bu listeleme için fatura mevcut değil.",
"fa.planSubFree": "Süresini seçin: listelemeniz hemen yayına girecek, ödeme gerekmez.",
"fa.prefillPrevious": "Bu kategorideki önceki listelememin bilgilerini tekrar kullan",
"fa.receipt": "PDF faturası",
"fa.renewBtn": "Yenile",
"fa.renewDiscountBanner": "50% indirim: listelemeniz süresi dolmadan yenileyin!",
"fa.renewDiscountHint": "50% indirim, süresi dolmadan yenilediğiniz için uygulanmıştır.",
"fa.renewEarly": "Yenile (−50%)",
"fa.renewTitle": "Listelemi yenile",
"fa.renewed": "Listeleme yenilendi",
"fa.sendClaim": "İddiaımı gönder",
"fa.twoPhotos": "Eşyanızın 2 fotoğrafı",
"fa.twoPhotosError": "Eşyalarınızın 2 fotoğrafını ekleyin.",
"fa.twoPhotosHint": "Eşyanın size ait olduğunu kanıtlayan kişisel fotoğraflar (eşya ile, fatura, kutu…).",
"fa.unlockBtn": "İletişim bilgilerini aç",
"fa.unlockFree": "Ücretsiz aç — lansman teklifi",
"fa.waitClaimantText": "Bir sahibi bu eşya için iddia oluşturduğunda sizi bilgilendireceğiz.",
"fa.waitFinderDecision": "Bulucunun kararını bekliyoruz",
"fa.waitUnlockText": "İletişim bilgileri değiştirildiğinde size bildirim yapılacak.",
"fa.waitUnlockTitle": "Sahibin açılmasını bekliyoruz",
"fa.cancel": "İptal",
"fa.categoryRequired": "Bulunan öğe için bir kategori seçin.",
"fa.confirmTitle": "Kararınızı onaylayın",
"fa.goBack": "Geri dön",
"dr.continue": "Beyanımı devam ettir",
"dr.delete": "Kalıcı olarak sil",
"dr.deleteConfirm": "Bu taslağı kalıcı olarak silinsin mi? Bu işlem geri alınamaz.",
"dr.deleted": "Taslak silindi",
"dr.expiresIn": "{h} saat daha taslak saklandı",
"dr.title": "Tamamlanmamış bir beyanınız var",
"form.step": "Adım",
"form.next": "Devam et",
"form.back": "Geri",
"form.stepDetails": "Raporunuz",
"form.stepPublish": "Süre, artırma & ödeme",
"form.stepThanks": "Teşekkür ederiz & katkınız",
"fthx.badge": "Rapor neredeyse tamam",
"fthx.title": "Teşekkür ederiz, bir fark yaratıyorsunuz!",
"fthx.text": "Sizin sayenizde, biri yakında kendisi için önemli bir şeye kavuşabilir. Sizin gibi iyilikler, Findloop'un ayakta kalmasını sağlayan şeylerdir.",
"fthx.impact1": "1 madde rapor edildi",
"fthx.impact2": "1 reunification şansı daha",
"fthx.tipTitle": "Findloop için küçük bir destek?",
"fthx.tipText": "Katkınız, hizmeti erişilebilir tutmamıza ve daha fazla eşyayı sahipleriyle buluşturmamıza yardımcı oluyor.",
"fthx.optional": "%100 isteğe bağlı — katkıda bulunmadan yayınlayabilirsiniz.",
"fthx.thanksTip": "Cömertliğiniz için çok teşekkür ederiz!",
"fthx.suggest": "Önerilen miktarlar",
"fthx.none": "Hiçbir bahşiş yok",
"pay.pendingTitle": "Ödeme tamamlanmadı",
"pay.pendingText": "Detaylarınız kaydedildi. Ödemeye bıraktığınız yerden devam edin.",
"pay.resume": "Ödemeye devam et",
"pay.expiredTitle": "Ödeme oturumu süresi doldu",
"pay.expiredText": "Güvenliğiniz için ödeme oturumu süresi doldu. Detaylarınız kaydedildi: Ödemeyi bir tıklama ile yeniden başlatın.",
"pay.relaunch": "Ödemeyi yeniden başlat",
"sub.received": "Gönderildi!",
"sub.publishing": "Tamamlamak üzereyiz…",
"sub.toPayment": "Güvenli ödeme sayfasına yönlendiriliyor…",
"fa.claimSubV2": "Kayıp eşyanızı tanımlayın. Bulan kişi, beyanınızı kendi kaydıyla karşılaştıracaktır.",
"fa.photosOptional": "Eşyanızın fotoğrafları (isteğe bağlı)",
"fa.compareOwnerHint": "Bu bilgiyi bulduğunuz eşya ile karşılaştırın, ardından bunun aynı eşyası olup olmadığını belirtin.",
"fa.itsThisItem": "Evet, bu eşya",
"fa.notThisItem": "Hayır, bu eşya değil",
"fa.confirmIsItem": "Bu eşyanın olduğuna dair onay veriyor musunuz? İletişim bilgileriniz ve sahibin bilgileri kendi hesaplarınızda gösterilecektir.",
"fa.confirmNotItem": "Bu eşya olmadığını onaylıyor musunuz? Raporunuz kapatılacaktır.",
"fa.youConfirmed": "Bu eşyanın sahibine ait olduğunu onayladınız",
"fa.youDeclined": "Bu eşya olmadığını belirttiniz",
"fa.youDeclinedText": "Yardımınız için teşekkürler! Sahibi bilgilendirildi.",
"fa.waitFinderDecisionOwner": "Bulan kişinin kararını bekliyoruz",
"fa.finderConfirmed": "Onaylandı",
"fa.notYourItem": "Bu sizin eşyanız değildi",
"fa.reportedOn": "Rapor edildi",
"fa.ownerWaitHint": "Bulucu şu anda bilgiyi kontrol ediyor, lütfen bekleyin.",
"fa.claimSentFinder": "Eşya bulan kişiye talep gönderildi.",
"fa.compareClaimHint": "Karar vermeden önce sahibin beyanını listelemenizle karşılaştırın.",
"fa.closeFollowup": "Bu takibi kapat",
"fa.closeFollowupConfirm": "Bu takibi kapatmak istiyor musunuz? Hem sahibin hem de bulucunun e-posta ve telefon numaraları kalıcı olarak silinecektir.",
"fa.safetyTitle": "Teslimat öncesi güvenlik ipuçları",
"fa.safety1": "Sahipten, eşyanın gizli özellikleri hakkında ayrıntılı bir açıklama isteyin: belirli bir çizik, bir çantanın tam içeriği, duvar kağıdı, seri numarası...",
"fa.safety2": "Mümkünse, görsel kanıt (eşyanın fotoğrafı) veya satın alma belgesi isteyin.",
"fa.safety3": "Eşyayı kamusal bir yerde veya bir Findloop ortağında teslim edin ve sahibin kimliğini kontrol edin.",
"fa.safetyOk": "Tamam, devam et",
"fa.ownerClosedNote": "Sahip, listelerini kapattı.",
"fa.finderClosedNote": "Bulucu, takibini kapattı.",
"fa.followupClosed": "Takip kapandı",
"fa.followupClosedText": "Bu takip işlemine son verdiniz. Yardımınız için teşekkürler!",
"fa.photoReviewTitle": "Bir bulucu bir fotoğraf gönderdi. Bu, sizin eşyaya benziyor mu?",
"fa.photoLooksLike": "Evet, bu benim eşyama benziyor",
"fa.photoNotMine": "Hayır, bu benim eşyam değil",
"fa.photoNotMineConfirm": "Takip her iki tarafta da kapatılacak ve ilanınız yeni bir bulucu için açık kalacaktır.",
"fa.photoLooksLikeDone": "Teşekkürler! Bulucu artık beyanınızı karşılaştıracak.",
"fa.photoNotMineDone": "Rapor reddedildi. İlanınız açık kalmaya devam ediyor.",
"fa.ownerPhotoHint": "Sadece bulucunun fotoğrafı size gösteriliyor. Bunun sizin eşyanıza benziyor mu, bize söyleyin.",
"fa.ownerReviewingPhoto": "Sahip, fotoğrafınızı inceliyor",
"fa.ownerReviewingPhotoText": "Cevap verir vermez bildirileceksiniz. Sonrasında beyanlarını karşılaştırabileceksiniz.",
"fa.ownerRejectedPhoto": "Bu, sahibin eşyası değil",
"fa.ownerRejectedPhotoText": "Sahip, fotoğrafınızın onların eşyasıyla uyuşmadığını söylüyor. Takip kapandı. Yardımınız için teşekkürler!",
"fa.contribute": "Katkıda bulunun",
"fa.phoneMissing": "Sağlanmadı",
"fa.ownerSafety1": "Bir teslimatın halka açık bir yerde ya da Findloop ortaklarından birinde yapılmasını tercih edin. Mesafe uzunsa, bunun yerine posta ile göndermeyi önerin.",
"fa.ownerSafety2": "Teslimatta, bulucunun kimliğini kontrol edin.",
"pub.changePhoto": "Fotoğrafı değiştir",
"ph.secured": "Fotoğraf güvence altına alındı",
"ph.securing": "Fotoğraf güvence altına alınıyor…",
"fa.ownerSafety3": "Bulucunun fotoğrafı Findloop filigranını taşıyorsa buluşmayı kabul etmeyin. Fotoğraf, bulucu tarafından çekilmiş, filigransız orijinal bir görüntü olmalıdır."
}
};
